
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lxKym", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $faf0ca8cf8906591$export$6503ec6e8aabbaf; }, function (v) { return $faf0ca8cf8906591$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $faf0ca8cf8906591$export$f7ad0328861e2f03; }, function (v) { return $faf0ca8cf8906591$export$f7ad0328861e2f03 = v; });
var $faf0ca8cf8906591$export$6503ec6e8aabbaf;
var $faf0ca8cf8906591$export$f7ad0328861e2f03;
"use strict";
var $faf0ca8cf8906591$var$mapping = new Map();
function $faf0ca8cf8906591$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$faf0ca8cf8906591$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $faf0ca8cf8906591$var$resolve(id) {
    var resolved = $faf0ca8cf8906591$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$faf0ca8cf8906591$export$6503ec6e8aabbaf = $faf0ca8cf8906591$var$register;
$faf0ca8cf8906591$export$f7ad0328861e2f03 = $faf0ca8cf8906591$var$resolve;

});

parcelRegister("cgi2g", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $8ed4f81d80955406$export$bdfd709ae4826697; }, function (v) { return $8ed4f81d80955406$export$bdfd709ae4826697 = v; });
var $8ed4f81d80955406$export$bdfd709ae4826697;
var $8ed4f81d80955406$export$c9e73fbda7da57b6;
var $8ed4f81d80955406$export$5a759dc7a1cfb72a;
"use strict";
var $8ed4f81d80955406$var$bundleURL = {};
function $8ed4f81d80955406$var$getBundleURLCached(id) {
    var value = $8ed4f81d80955406$var$bundleURL[id];
    if (!value) {
        value = $8ed4f81d80955406$var$getBundleURL();
        $8ed4f81d80955406$var$bundleURL[id] = value;
    }
    return value;
}
function $8ed4f81d80955406$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $8ed4f81d80955406$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $8ed4f81d80955406$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $8ed4f81d80955406$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$8ed4f81d80955406$export$bdfd709ae4826697 = $8ed4f81d80955406$var$getBundleURLCached;
$8ed4f81d80955406$export$c9e73fbda7da57b6 = $8ed4f81d80955406$var$getBaseURL;
$8ed4f81d80955406$export$5a759dc7a1cfb72a = $8ed4f81d80955406$var$getOrigin;

});

parcelRegister("4ZSso", function(module, exports) {
'use strict';

module.exports = (parcelRequire("kFYcr"));

});
parcelRegister("kFYcr", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $f0d6555fbf1b2760$export$ffb0004e005737fa; }, function (v) { return $f0d6555fbf1b2760$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $f0d6555fbf1b2760$export$34b9dba7ce09269b; }, function (v) { return $f0d6555fbf1b2760$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $f0d6555fbf1b2760$export$25062201e9e25d76; }, function (v) { return $f0d6555fbf1b2760$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f0d6555fbf1b2760$export$ffb0004e005737fa;
var $f0d6555fbf1b2760$export$34b9dba7ce09269b;
var $f0d6555fbf1b2760$export$25062201e9e25d76;
'use strict';

var $91i6m = parcelRequire("91i6m");
var $f0d6555fbf1b2760$var$k = Symbol.for("react.element"), $f0d6555fbf1b2760$var$l = Symbol.for("react.fragment"), $f0d6555fbf1b2760$var$m = Object.prototype.hasOwnProperty, $f0d6555fbf1b2760$var$n = $91i6m.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $f0d6555fbf1b2760$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $f0d6555fbf1b2760$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$f0d6555fbf1b2760$var$m.call(a, b) && !$f0d6555fbf1b2760$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $f0d6555fbf1b2760$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $f0d6555fbf1b2760$var$n.current
    };
}
$f0d6555fbf1b2760$export$ffb0004e005737fa = $f0d6555fbf1b2760$var$l;
$f0d6555fbf1b2760$export$34b9dba7ce09269b = $f0d6555fbf1b2760$var$q;
$f0d6555fbf1b2760$export$25062201e9e25d76 = $f0d6555fbf1b2760$var$q;

});
parcelRegister("91i6m", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5FrtN"));

});
parcelRegister("5FrtN", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $420618ef9b6ae686$export$dca3b0875bd9a954; }, function (v) { return $420618ef9b6ae686$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $420618ef9b6ae686$export$16fa2f45be04daa8; }, function (v) { return $420618ef9b6ae686$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $420618ef9b6ae686$export$ffb0004e005737fa; }, function (v) { return $420618ef9b6ae686$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $420618ef9b6ae686$export$e2c29f18771995cb; }, function (v) { return $420618ef9b6ae686$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $420618ef9b6ae686$export$221d75b3f55bb0bd; }, function (v) { return $420618ef9b6ae686$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $420618ef9b6ae686$export$5f8d39834fd61797; }, function (v) { return $420618ef9b6ae686$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $420618ef9b6ae686$export$74bf444e3cd11ea5; }, function (v) { return $420618ef9b6ae686$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $420618ef9b6ae686$export$ae55be85d98224ed; }, function (v) { return $420618ef9b6ae686$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $420618ef9b6ae686$export$3ba232387fd5d6dd; }, function (v) { return $420618ef9b6ae686$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $420618ef9b6ae686$export$e530037191fcd5d7; }, function (v) { return $420618ef9b6ae686$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $420618ef9b6ae686$export$fd42f52fd3ae1109; }, function (v) { return $420618ef9b6ae686$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $420618ef9b6ae686$export$c8a8987d4410bf2d; }, function (v) { return $420618ef9b6ae686$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $420618ef9b6ae686$export$d38cd72104c1f0e9; }, function (v) { return $420618ef9b6ae686$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $420618ef9b6ae686$export$7d1e3a5e95ceca43; }, function (v) { return $420618ef9b6ae686$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $420618ef9b6ae686$export$257a8862b851cb5b; }, function (v) { return $420618ef9b6ae686$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $420618ef9b6ae686$export$a8257692ac88316c; }, function (v) { return $420618ef9b6ae686$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $420618ef9b6ae686$export$488013bae63b21da; }, function (v) { return $420618ef9b6ae686$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $420618ef9b6ae686$export$7c73462e0d25e514; }, function (v) { return $420618ef9b6ae686$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $420618ef9b6ae686$export$7568632d0d33d16d; }, function (v) { return $420618ef9b6ae686$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $420618ef9b6ae686$export$88948ce120ea2619; }, function (v) { return $420618ef9b6ae686$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $420618ef9b6ae686$export$35808ee640e87ca7; }, function (v) { return $420618ef9b6ae686$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $420618ef9b6ae686$export$fae74005e78b1a27; }, function (v) { return $420618ef9b6ae686$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $420618ef9b6ae686$export$dc8fbce3eb94dc1e; }, function (v) { return $420618ef9b6ae686$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $420618ef9b6ae686$export$6a7bc4e911dc01cf; }, function (v) { return $420618ef9b6ae686$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $420618ef9b6ae686$export$6d9c69b0de29b591; }, function (v) { return $420618ef9b6ae686$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $420618ef9b6ae686$export$f680877a34711e37; }, function (v) { return $420618ef9b6ae686$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $420618ef9b6ae686$export$d5a552a76deda3c2; }, function (v) { return $420618ef9b6ae686$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $420618ef9b6ae686$export$aaabe4eda9ed9969; }, function (v) { return $420618ef9b6ae686$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $420618ef9b6ae686$export$e5c5a5f917a5871c; }, function (v) { return $420618ef9b6ae686$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $420618ef9b6ae686$export$1538c33de8887b59; }, function (v) { return $420618ef9b6ae686$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $420618ef9b6ae686$export$13e3392192263954; }, function (v) { return $420618ef9b6ae686$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $420618ef9b6ae686$export$b8f5890fc79d6aca; }, function (v) { return $420618ef9b6ae686$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $420618ef9b6ae686$export$60241385465d0a34; }, function (v) { return $420618ef9b6ae686$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $420618ef9b6ae686$export$306c0aa65ff9ec16; }, function (v) { return $420618ef9b6ae686$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $420618ef9b6ae686$export$7b286972b8d8ccbf; }, function (v) { return $420618ef9b6ae686$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $420618ef9b6ae686$export$83d89fbfd8236492; }, function (v) { return $420618ef9b6ae686$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $420618ef9b6ae686$export$dca3b0875bd9a954;
var $420618ef9b6ae686$export$16fa2f45be04daa8;
var $420618ef9b6ae686$export$ffb0004e005737fa;
var $420618ef9b6ae686$export$e2c29f18771995cb;
var $420618ef9b6ae686$export$221d75b3f55bb0bd;
var $420618ef9b6ae686$export$5f8d39834fd61797;
var $420618ef9b6ae686$export$74bf444e3cd11ea5;
var $420618ef9b6ae686$export$ae55be85d98224ed;
var $420618ef9b6ae686$export$3ba232387fd5d6dd;
var $420618ef9b6ae686$export$e530037191fcd5d7;
var $420618ef9b6ae686$export$fd42f52fd3ae1109;
var $420618ef9b6ae686$export$c8a8987d4410bf2d;
var $420618ef9b6ae686$export$d38cd72104c1f0e9;
var $420618ef9b6ae686$export$7d1e3a5e95ceca43;
var $420618ef9b6ae686$export$257a8862b851cb5b;
var $420618ef9b6ae686$export$a8257692ac88316c;
var $420618ef9b6ae686$export$488013bae63b21da;
var $420618ef9b6ae686$export$7c73462e0d25e514;
var $420618ef9b6ae686$export$7568632d0d33d16d;
var $420618ef9b6ae686$export$88948ce120ea2619;
var $420618ef9b6ae686$export$35808ee640e87ca7;
var $420618ef9b6ae686$export$fae74005e78b1a27;
var $420618ef9b6ae686$export$dc8fbce3eb94dc1e;
var $420618ef9b6ae686$export$6a7bc4e911dc01cf;
var $420618ef9b6ae686$export$6d9c69b0de29b591;
var $420618ef9b6ae686$export$f680877a34711e37;
var $420618ef9b6ae686$export$d5a552a76deda3c2;
var $420618ef9b6ae686$export$aaabe4eda9ed9969;
var $420618ef9b6ae686$export$e5c5a5f917a5871c;
var $420618ef9b6ae686$export$1538c33de8887b59;
var $420618ef9b6ae686$export$13e3392192263954;
var $420618ef9b6ae686$export$b8f5890fc79d6aca;
var $420618ef9b6ae686$export$60241385465d0a34;
var $420618ef9b6ae686$export$306c0aa65ff9ec16;
var $420618ef9b6ae686$export$7b286972b8d8ccbf;
var $420618ef9b6ae686$export$83d89fbfd8236492;
'use strict';
var $420618ef9b6ae686$var$l = Symbol.for("react.element"), $420618ef9b6ae686$var$n = Symbol.for("react.portal"), $420618ef9b6ae686$var$p = Symbol.for("react.fragment"), $420618ef9b6ae686$var$q = Symbol.for("react.strict_mode"), $420618ef9b6ae686$var$r = Symbol.for("react.profiler"), $420618ef9b6ae686$var$t = Symbol.for("react.provider"), $420618ef9b6ae686$var$u = Symbol.for("react.context"), $420618ef9b6ae686$var$v = Symbol.for("react.forward_ref"), $420618ef9b6ae686$var$w = Symbol.for("react.suspense"), $420618ef9b6ae686$var$x = Symbol.for("react.memo"), $420618ef9b6ae686$var$y = Symbol.for("react.lazy"), $420618ef9b6ae686$var$z = Symbol.iterator;
function $420618ef9b6ae686$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $420618ef9b6ae686$var$z && a[$420618ef9b6ae686$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $420618ef9b6ae686$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $420618ef9b6ae686$var$C = Object.assign, $420618ef9b6ae686$var$D = {};
function $420618ef9b6ae686$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $420618ef9b6ae686$var$D;
    this.updater = e || $420618ef9b6ae686$var$B;
}
$420618ef9b6ae686$var$E.prototype.isReactComponent = {};
$420618ef9b6ae686$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$420618ef9b6ae686$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $420618ef9b6ae686$var$F() {}
$420618ef9b6ae686$var$F.prototype = $420618ef9b6ae686$var$E.prototype;
function $420618ef9b6ae686$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $420618ef9b6ae686$var$D;
    this.updater = e || $420618ef9b6ae686$var$B;
}
var $420618ef9b6ae686$var$H = $420618ef9b6ae686$var$G.prototype = new $420618ef9b6ae686$var$F;
$420618ef9b6ae686$var$H.constructor = $420618ef9b6ae686$var$G;
$420618ef9b6ae686$var$C($420618ef9b6ae686$var$H, $420618ef9b6ae686$var$E.prototype);
$420618ef9b6ae686$var$H.isPureReactComponent = !0;
var $420618ef9b6ae686$var$I = Array.isArray, $420618ef9b6ae686$var$J = Object.prototype.hasOwnProperty, $420618ef9b6ae686$var$K = {
    current: null
}, $420618ef9b6ae686$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $420618ef9b6ae686$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$420618ef9b6ae686$var$J.call(b, d) && !$420618ef9b6ae686$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $420618ef9b6ae686$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $420618ef9b6ae686$var$K.current
    };
}
function $420618ef9b6ae686$var$N(a, b) {
    return {
        $$typeof: $420618ef9b6ae686$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $420618ef9b6ae686$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $420618ef9b6ae686$var$l;
}
function $420618ef9b6ae686$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $420618ef9b6ae686$var$P = /\/+/g;
function $420618ef9b6ae686$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $420618ef9b6ae686$var$escape("" + a.key) : b.toString(36);
}
function $420618ef9b6ae686$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $420618ef9b6ae686$var$l:
                case $420618ef9b6ae686$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $420618ef9b6ae686$var$Q(h, 0) : d, $420618ef9b6ae686$var$I(c) ? (e = "", null != a && (e = a.replace($420618ef9b6ae686$var$P, "$&/") + "/"), $420618ef9b6ae686$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($420618ef9b6ae686$var$O(c) && (c = $420618ef9b6ae686$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($420618ef9b6ae686$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($420618ef9b6ae686$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $420618ef9b6ae686$var$Q(k, g);
        h += $420618ef9b6ae686$var$R(k, b, e, f, c);
    }
    else if (f = $420618ef9b6ae686$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $420618ef9b6ae686$var$Q(k, g++), h += $420618ef9b6ae686$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $420618ef9b6ae686$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $420618ef9b6ae686$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $420618ef9b6ae686$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $420618ef9b6ae686$var$U = {
    current: null
}, $420618ef9b6ae686$var$V = {
    transition: null
}, $420618ef9b6ae686$var$W = {
    ReactCurrentDispatcher: $420618ef9b6ae686$var$U,
    ReactCurrentBatchConfig: $420618ef9b6ae686$var$V,
    ReactCurrentOwner: $420618ef9b6ae686$var$K
};
function $420618ef9b6ae686$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$420618ef9b6ae686$export$dca3b0875bd9a954 = {
    map: $420618ef9b6ae686$var$S,
    forEach: function(a, b, e) {
        $420618ef9b6ae686$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $420618ef9b6ae686$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $420618ef9b6ae686$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$420618ef9b6ae686$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$420618ef9b6ae686$export$16fa2f45be04daa8 = $420618ef9b6ae686$var$E;
$420618ef9b6ae686$export$ffb0004e005737fa = $420618ef9b6ae686$var$p;
$420618ef9b6ae686$export$e2c29f18771995cb = $420618ef9b6ae686$var$r;
$420618ef9b6ae686$export$221d75b3f55bb0bd = $420618ef9b6ae686$var$G;
$420618ef9b6ae686$export$5f8d39834fd61797 = $420618ef9b6ae686$var$q;
$420618ef9b6ae686$export$74bf444e3cd11ea5 = $420618ef9b6ae686$var$w;
$420618ef9b6ae686$export$ae55be85d98224ed = $420618ef9b6ae686$var$W;
$420618ef9b6ae686$export$3ba232387fd5d6dd = $420618ef9b6ae686$var$X;
$420618ef9b6ae686$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $420618ef9b6ae686$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $420618ef9b6ae686$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$420618ef9b6ae686$var$J.call(b, f) && !$420618ef9b6ae686$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $420618ef9b6ae686$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$420618ef9b6ae686$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $420618ef9b6ae686$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $420618ef9b6ae686$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$420618ef9b6ae686$export$c8a8987d4410bf2d = $420618ef9b6ae686$var$M;
$420618ef9b6ae686$export$d38cd72104c1f0e9 = function(a) {
    var b = $420618ef9b6ae686$var$M.bind(null, a);
    b.type = a;
    return b;
};
$420618ef9b6ae686$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$420618ef9b6ae686$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $420618ef9b6ae686$var$v,
        render: a
    };
};
$420618ef9b6ae686$export$a8257692ac88316c = $420618ef9b6ae686$var$O;
$420618ef9b6ae686$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $420618ef9b6ae686$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $420618ef9b6ae686$var$T
    };
};
$420618ef9b6ae686$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $420618ef9b6ae686$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$420618ef9b6ae686$export$7568632d0d33d16d = function(a) {
    var b = $420618ef9b6ae686$var$V.transition;
    $420618ef9b6ae686$var$V.transition = {};
    try {
        a();
    } finally{
        $420618ef9b6ae686$var$V.transition = b;
    }
};
$420618ef9b6ae686$export$88948ce120ea2619 = $420618ef9b6ae686$var$X;
$420618ef9b6ae686$export$35808ee640e87ca7 = function(a, b) {
    return $420618ef9b6ae686$var$U.current.useCallback(a, b);
};
$420618ef9b6ae686$export$fae74005e78b1a27 = function(a) {
    return $420618ef9b6ae686$var$U.current.useContext(a);
};
$420618ef9b6ae686$export$dc8fbce3eb94dc1e = function() {};
$420618ef9b6ae686$export$6a7bc4e911dc01cf = function(a) {
    return $420618ef9b6ae686$var$U.current.useDeferredValue(a);
};
$420618ef9b6ae686$export$6d9c69b0de29b591 = function(a, b) {
    return $420618ef9b6ae686$var$U.current.useEffect(a, b);
};
$420618ef9b6ae686$export$f680877a34711e37 = function() {
    return $420618ef9b6ae686$var$U.current.useId();
};
$420618ef9b6ae686$export$d5a552a76deda3c2 = function(a, b, e) {
    return $420618ef9b6ae686$var$U.current.useImperativeHandle(a, b, e);
};
$420618ef9b6ae686$export$aaabe4eda9ed9969 = function(a, b) {
    return $420618ef9b6ae686$var$U.current.useInsertionEffect(a, b);
};
$420618ef9b6ae686$export$e5c5a5f917a5871c = function(a, b) {
    return $420618ef9b6ae686$var$U.current.useLayoutEffect(a, b);
};
$420618ef9b6ae686$export$1538c33de8887b59 = function(a, b) {
    return $420618ef9b6ae686$var$U.current.useMemo(a, b);
};
$420618ef9b6ae686$export$13e3392192263954 = function(a, b, e) {
    return $420618ef9b6ae686$var$U.current.useReducer(a, b, e);
};
$420618ef9b6ae686$export$b8f5890fc79d6aca = function(a) {
    return $420618ef9b6ae686$var$U.current.useRef(a);
};
$420618ef9b6ae686$export$60241385465d0a34 = function(a) {
    return $420618ef9b6ae686$var$U.current.useState(a);
};
$420618ef9b6ae686$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $420618ef9b6ae686$var$U.current.useSyncExternalStore(a, b, e);
};
$420618ef9b6ae686$export$7b286972b8d8ccbf = function() {
    return $420618ef9b6ae686$var$U.current.useTransition();
};
$420618ef9b6ae686$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("eAqbf", function(module, exports) {
'use strict';
function $02bd8f6cebd4b212$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($02bd8f6cebd4b212$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$02bd8f6cebd4b212$var$checkDCE();

module.exports = (parcelRequire("jFsi6"));

});
parcelRegister("jFsi6", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $e517caada390a624$export$ae55be85d98224ed; }, function (v) { return $e517caada390a624$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $e517caada390a624$export$d39a5bbd09211389; }, function (v) { return $e517caada390a624$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $e517caada390a624$export$882461b6382ed46c; }, function (v) { return $e517caada390a624$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $e517caada390a624$export$466bfc07425424d5; }, function (v) { return $e517caada390a624$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $e517caada390a624$export$cd75ccfd720a3cd4; }, function (v) { return $e517caada390a624$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $e517caada390a624$export$fa8d919ba61d84db; }, function (v) { return $e517caada390a624$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $e517caada390a624$export$757ceba2d55c277e; }, function (v) { return $e517caada390a624$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $e517caada390a624$export$b3890eb0ae9dca99; }, function (v) { return $e517caada390a624$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $e517caada390a624$export$502457920280e6be; }, function (v) { return $e517caada390a624$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $e517caada390a624$export$c78a37762a8d58e1; }, function (v) { return $e517caada390a624$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $e517caada390a624$export$dc54d992c10e8a18; }, function (v) { return $e517caada390a624$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $e517caada390a624$export$83d89fbfd8236492; }, function (v) { return $e517caada390a624$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $e517caada390a624$export$ae55be85d98224ed;
var $e517caada390a624$export$d39a5bbd09211389;
var $e517caada390a624$export$882461b6382ed46c;
var $e517caada390a624$export$466bfc07425424d5;
var $e517caada390a624$export$cd75ccfd720a3cd4;
var $e517caada390a624$export$fa8d919ba61d84db;
var $e517caada390a624$export$757ceba2d55c277e;
var $e517caada390a624$export$b3890eb0ae9dca99;
var $e517caada390a624$export$502457920280e6be;
var $e517caada390a624$export$c78a37762a8d58e1;
var $e517caada390a624$export$dc54d992c10e8a18;
var $e517caada390a624$export$83d89fbfd8236492;
'use strict';

var $91i6m = parcelRequire("91i6m");

var $lLS11 = parcelRequire("lLS11");
function $e517caada390a624$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $e517caada390a624$var$da = new Set, $e517caada390a624$var$ea = {};
function $e517caada390a624$var$fa(a, b) {
    $e517caada390a624$var$ha(a, b);
    $e517caada390a624$var$ha(a + "Capture", b);
}
function $e517caada390a624$var$ha(a, b) {
    $e517caada390a624$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$e517caada390a624$var$da.add(b[a]);
}
var $e517caada390a624$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $e517caada390a624$var$ja = Object.prototype.hasOwnProperty, $e517caada390a624$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $e517caada390a624$var$la = {}, $e517caada390a624$var$ma = {};
function $e517caada390a624$var$oa(a) {
    if ($e517caada390a624$var$ja.call($e517caada390a624$var$ma, a)) return !0;
    if ($e517caada390a624$var$ja.call($e517caada390a624$var$la, a)) return !1;
    if ($e517caada390a624$var$ka.test(a)) return $e517caada390a624$var$ma[a] = !0;
    $e517caada390a624$var$la[a] = !0;
    return !1;
}
function $e517caada390a624$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $e517caada390a624$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $e517caada390a624$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $e517caada390a624$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $e517caada390a624$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $e517caada390a624$var$z[a] = new $e517caada390a624$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $e517caada390a624$var$z[b] = new $e517caada390a624$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $e517caada390a624$var$z[a] = new $e517caada390a624$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $e517caada390a624$var$z[a] = new $e517caada390a624$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $e517caada390a624$var$z[a] = new $e517caada390a624$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $e517caada390a624$var$z[a] = new $e517caada390a624$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $e517caada390a624$var$z[a] = new $e517caada390a624$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $e517caada390a624$var$z[a] = new $e517caada390a624$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $e517caada390a624$var$z[a] = new $e517caada390a624$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $e517caada390a624$var$ra = /[\-:]([a-z])/g;
function $e517caada390a624$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($e517caada390a624$var$ra, $e517caada390a624$var$sa);
    $e517caada390a624$var$z[b] = new $e517caada390a624$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($e517caada390a624$var$ra, $e517caada390a624$var$sa);
    $e517caada390a624$var$z[b] = new $e517caada390a624$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($e517caada390a624$var$ra, $e517caada390a624$var$sa);
    $e517caada390a624$var$z[b] = new $e517caada390a624$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $e517caada390a624$var$z[a] = new $e517caada390a624$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$e517caada390a624$var$z.xlinkHref = new $e517caada390a624$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $e517caada390a624$var$z[a] = new $e517caada390a624$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $e517caada390a624$var$ta(a, b, c, d) {
    var e = $e517caada390a624$var$z.hasOwnProperty(b) ? $e517caada390a624$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $e517caada390a624$var$qa(b, c, e, d) && (c = null), d || null === e ? $e517caada390a624$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $e517caada390a624$var$ua = $91i6m.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $e517caada390a624$var$va = Symbol.for("react.element"), $e517caada390a624$var$wa = Symbol.for("react.portal"), $e517caada390a624$var$ya = Symbol.for("react.fragment"), $e517caada390a624$var$za = Symbol.for("react.strict_mode"), $e517caada390a624$var$Aa = Symbol.for("react.profiler"), $e517caada390a624$var$Ba = Symbol.for("react.provider"), $e517caada390a624$var$Ca = Symbol.for("react.context"), $e517caada390a624$var$Da = Symbol.for("react.forward_ref"), $e517caada390a624$var$Ea = Symbol.for("react.suspense"), $e517caada390a624$var$Fa = Symbol.for("react.suspense_list"), $e517caada390a624$var$Ga = Symbol.for("react.memo"), $e517caada390a624$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $e517caada390a624$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $e517caada390a624$var$Ja = Symbol.iterator;
function $e517caada390a624$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $e517caada390a624$var$Ja && a[$e517caada390a624$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e517caada390a624$var$A = Object.assign, $e517caada390a624$var$La;
function $e517caada390a624$var$Ma(a) {
    if (void 0 === $e517caada390a624$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $e517caada390a624$var$La = b && b[1] || "";
    }
    return "\n" + $e517caada390a624$var$La + a;
}
var $e517caada390a624$var$Na = !1;
function $e517caada390a624$var$Oa(a, b) {
    if (!a || $e517caada390a624$var$Na) return "";
    $e517caada390a624$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $e517caada390a624$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $e517caada390a624$var$Ma(a) : "";
}
function $e517caada390a624$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $e517caada390a624$var$Ma(a.type);
        case 16:
            return $e517caada390a624$var$Ma("Lazy");
        case 13:
            return $e517caada390a624$var$Ma("Suspense");
        case 19:
            return $e517caada390a624$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $e517caada390a624$var$Oa(a.type, !1), a;
        case 11:
            return a = $e517caada390a624$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $e517caada390a624$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $e517caada390a624$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $e517caada390a624$var$ya:
            return "Fragment";
        case $e517caada390a624$var$wa:
            return "Portal";
        case $e517caada390a624$var$Aa:
            return "Profiler";
        case $e517caada390a624$var$za:
            return "StrictMode";
        case $e517caada390a624$var$Ea:
            return "Suspense";
        case $e517caada390a624$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $e517caada390a624$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $e517caada390a624$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $e517caada390a624$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $e517caada390a624$var$Ga:
            return b = a.displayName || null, null !== b ? b : $e517caada390a624$var$Qa(a.type) || "Memo";
        case $e517caada390a624$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $e517caada390a624$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $e517caada390a624$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $e517caada390a624$var$Qa(b);
        case 8:
            return b === $e517caada390a624$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $e517caada390a624$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $e517caada390a624$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $e517caada390a624$var$Ua(a) {
    var b = $e517caada390a624$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $e517caada390a624$var$Va(a) {
    a._valueTracker || (a._valueTracker = $e517caada390a624$var$Ua(a));
}
function $e517caada390a624$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $e517caada390a624$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $e517caada390a624$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $e517caada390a624$var$Ya(a, b) {
    var c = b.checked;
    return $e517caada390a624$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $e517caada390a624$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $e517caada390a624$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $e517caada390a624$var$ab(a, b) {
    b = b.checked;
    null != b && $e517caada390a624$var$ta(a, "checked", b, !1);
}
function $e517caada390a624$var$bb(a, b) {
    $e517caada390a624$var$ab(a, b);
    var c = $e517caada390a624$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $e517caada390a624$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $e517caada390a624$var$cb(a, b.type, $e517caada390a624$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $e517caada390a624$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $e517caada390a624$var$cb(a, b, c) {
    if ("number" !== b || $e517caada390a624$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $e517caada390a624$var$eb = Array.isArray;
function $e517caada390a624$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $e517caada390a624$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $e517caada390a624$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($e517caada390a624$var$p(91));
    return $e517caada390a624$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $e517caada390a624$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($e517caada390a624$var$p(92));
            if ($e517caada390a624$var$eb(c)) {
                if (1 < c.length) throw Error($e517caada390a624$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $e517caada390a624$var$Sa(c)
    };
}
function $e517caada390a624$var$ib(a, b) {
    var c = $e517caada390a624$var$Sa(b.value), d = $e517caada390a624$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $e517caada390a624$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $e517caada390a624$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $e517caada390a624$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $e517caada390a624$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $e517caada390a624$var$mb, $e517caada390a624$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $e517caada390a624$var$mb = $e517caada390a624$var$mb || document.createElement("div");
        $e517caada390a624$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $e517caada390a624$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $e517caada390a624$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $e517caada390a624$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $e517caada390a624$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($e517caada390a624$var$pb).forEach(function(a) {
    $e517caada390a624$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $e517caada390a624$var$pb[b] = $e517caada390a624$var$pb[a];
    });
});
function $e517caada390a624$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $e517caada390a624$var$pb.hasOwnProperty(a) && $e517caada390a624$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $e517caada390a624$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $e517caada390a624$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $e517caada390a624$var$tb = $e517caada390a624$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $e517caada390a624$var$ub(a, b) {
    if (b) {
        if ($e517caada390a624$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($e517caada390a624$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($e517caada390a624$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($e517caada390a624$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($e517caada390a624$var$p(62));
    }
}
function $e517caada390a624$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $e517caada390a624$var$wb = null;
function $e517caada390a624$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $e517caada390a624$var$yb = null, $e517caada390a624$var$zb = null, $e517caada390a624$var$Ab = null;
function $e517caada390a624$var$Bb(a) {
    if (a = $e517caada390a624$var$Cb(a)) {
        if ("function" !== typeof $e517caada390a624$var$yb) throw Error($e517caada390a624$var$p(280));
        var b = a.stateNode;
        b && (b = $e517caada390a624$var$Db(b), $e517caada390a624$var$yb(a.stateNode, a.type, b));
    }
}
function $e517caada390a624$var$Eb(a) {
    $e517caada390a624$var$zb ? $e517caada390a624$var$Ab ? $e517caada390a624$var$Ab.push(a) : $e517caada390a624$var$Ab = [
        a
    ] : $e517caada390a624$var$zb = a;
}
function $e517caada390a624$var$Fb() {
    if ($e517caada390a624$var$zb) {
        var a = $e517caada390a624$var$zb, b = $e517caada390a624$var$Ab;
        $e517caada390a624$var$Ab = $e517caada390a624$var$zb = null;
        $e517caada390a624$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$e517caada390a624$var$Bb(b[a]);
    }
}
function $e517caada390a624$var$Gb(a, b) {
    return a(b);
}
function $e517caada390a624$var$Hb() {}
var $e517caada390a624$var$Ib = !1;
function $e517caada390a624$var$Jb(a, b, c) {
    if ($e517caada390a624$var$Ib) return a(b, c);
    $e517caada390a624$var$Ib = !0;
    try {
        return $e517caada390a624$var$Gb(a, b, c);
    } finally{
        if ($e517caada390a624$var$Ib = !1, null !== $e517caada390a624$var$zb || null !== $e517caada390a624$var$Ab) $e517caada390a624$var$Hb(), $e517caada390a624$var$Fb();
    }
}
function $e517caada390a624$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $e517caada390a624$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($e517caada390a624$var$p(231, b, typeof c));
    return c;
}
var $e517caada390a624$var$Lb = !1;
if ($e517caada390a624$var$ia) try {
    var $e517caada390a624$var$Mb = {};
    Object.defineProperty($e517caada390a624$var$Mb, "passive", {
        get: function() {
            $e517caada390a624$var$Lb = !0;
        }
    });
    window.addEventListener("test", $e517caada390a624$var$Mb, $e517caada390a624$var$Mb);
    window.removeEventListener("test", $e517caada390a624$var$Mb, $e517caada390a624$var$Mb);
} catch (a) {
    $e517caada390a624$var$Lb = !1;
}
function $e517caada390a624$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $e517caada390a624$var$Ob = !1, $e517caada390a624$var$Pb = null, $e517caada390a624$var$Qb = !1, $e517caada390a624$var$Rb = null, $e517caada390a624$var$Sb = {
    onError: function(a) {
        $e517caada390a624$var$Ob = !0;
        $e517caada390a624$var$Pb = a;
    }
};
function $e517caada390a624$var$Tb(a, b, c, d, e, f, g, h, k) {
    $e517caada390a624$var$Ob = !1;
    $e517caada390a624$var$Pb = null;
    $e517caada390a624$var$Nb.apply($e517caada390a624$var$Sb, arguments);
}
function $e517caada390a624$var$Ub(a, b, c, d, e, f, g, h, k) {
    $e517caada390a624$var$Tb.apply(this, arguments);
    if ($e517caada390a624$var$Ob) {
        if ($e517caada390a624$var$Ob) {
            var l = $e517caada390a624$var$Pb;
            $e517caada390a624$var$Ob = !1;
            $e517caada390a624$var$Pb = null;
        } else throw Error($e517caada390a624$var$p(198));
        $e517caada390a624$var$Qb || ($e517caada390a624$var$Qb = !0, $e517caada390a624$var$Rb = l);
    }
}
function $e517caada390a624$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $e517caada390a624$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $e517caada390a624$var$Xb(a) {
    if ($e517caada390a624$var$Vb(a) !== a) throw Error($e517caada390a624$var$p(188));
}
function $e517caada390a624$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $e517caada390a624$var$Vb(a);
        if (null === b) throw Error($e517caada390a624$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $e517caada390a624$var$Xb(e), a;
                if (f === d) return $e517caada390a624$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($e517caada390a624$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($e517caada390a624$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($e517caada390a624$var$p(190));
    }
    if (3 !== c.tag) throw Error($e517caada390a624$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $e517caada390a624$var$Zb(a) {
    a = $e517caada390a624$var$Yb(a);
    return null !== a ? $e517caada390a624$var$$b(a) : null;
}
function $e517caada390a624$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $e517caada390a624$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $e517caada390a624$var$ac = $lLS11.unstable_scheduleCallback, $e517caada390a624$var$bc = $lLS11.unstable_cancelCallback, $e517caada390a624$var$cc = $lLS11.unstable_shouldYield, $e517caada390a624$var$dc = $lLS11.unstable_requestPaint, $e517caada390a624$var$B = $lLS11.unstable_now, $e517caada390a624$var$ec = $lLS11.unstable_getCurrentPriorityLevel, $e517caada390a624$var$fc = $lLS11.unstable_ImmediatePriority, $e517caada390a624$var$gc = $lLS11.unstable_UserBlockingPriority, $e517caada390a624$var$hc = $lLS11.unstable_NormalPriority, $e517caada390a624$var$ic = $lLS11.unstable_LowPriority, $e517caada390a624$var$jc = $lLS11.unstable_IdlePriority, $e517caada390a624$var$kc = null, $e517caada390a624$var$lc = null;
function $e517caada390a624$var$mc(a) {
    if ($e517caada390a624$var$lc && "function" === typeof $e517caada390a624$var$lc.onCommitFiberRoot) try {
        $e517caada390a624$var$lc.onCommitFiberRoot($e517caada390a624$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $e517caada390a624$var$oc = Math.clz32 ? Math.clz32 : $e517caada390a624$var$nc, $e517caada390a624$var$pc = Math.log, $e517caada390a624$var$qc = Math.LN2;
function $e517caada390a624$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($e517caada390a624$var$pc(a) / $e517caada390a624$var$qc | 0) | 0;
}
var $e517caada390a624$var$rc = 64, $e517caada390a624$var$sc = 4194304;
function $e517caada390a624$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $e517caada390a624$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $e517caada390a624$var$tc(h) : (f &= g, 0 !== f && (d = $e517caada390a624$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $e517caada390a624$var$tc(g) : 0 !== f && (d = $e517caada390a624$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $e517caada390a624$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $e517caada390a624$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $e517caada390a624$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $e517caada390a624$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $e517caada390a624$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $e517caada390a624$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $e517caada390a624$var$yc() {
    var a = $e517caada390a624$var$rc;
    $e517caada390a624$var$rc <<= 1;
    0 === ($e517caada390a624$var$rc & 4194240) && ($e517caada390a624$var$rc = 64);
    return a;
}
function $e517caada390a624$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $e517caada390a624$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $e517caada390a624$var$oc(b);
    a[b] = c;
}
function $e517caada390a624$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $e517caada390a624$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $e517caada390a624$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $e517caada390a624$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $e517caada390a624$var$C = 0;
function $e517caada390a624$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $e517caada390a624$var$Ec, $e517caada390a624$var$Fc, $e517caada390a624$var$Gc, $e517caada390a624$var$Hc, $e517caada390a624$var$Ic, $e517caada390a624$var$Jc = !1, $e517caada390a624$var$Kc = [], $e517caada390a624$var$Lc = null, $e517caada390a624$var$Mc = null, $e517caada390a624$var$Nc = null, $e517caada390a624$var$Oc = new Map, $e517caada390a624$var$Pc = new Map, $e517caada390a624$var$Qc = [], $e517caada390a624$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $e517caada390a624$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $e517caada390a624$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $e517caada390a624$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $e517caada390a624$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $e517caada390a624$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $e517caada390a624$var$Pc.delete(b.pointerId);
    }
}
function $e517caada390a624$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $e517caada390a624$var$Cb(b), null !== b && $e517caada390a624$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $e517caada390a624$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $e517caada390a624$var$Lc = $e517caada390a624$var$Tc($e517caada390a624$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $e517caada390a624$var$Mc = $e517caada390a624$var$Tc($e517caada390a624$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $e517caada390a624$var$Nc = $e517caada390a624$var$Tc($e517caada390a624$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $e517caada390a624$var$Oc.set(f, $e517caada390a624$var$Tc($e517caada390a624$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $e517caada390a624$var$Pc.set(f, $e517caada390a624$var$Tc($e517caada390a624$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $e517caada390a624$var$Vc(a) {
    var b = $e517caada390a624$var$Wc(a.target);
    if (null !== b) {
        var c = $e517caada390a624$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $e517caada390a624$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $e517caada390a624$var$Ic(a.priority, function() {
                        $e517caada390a624$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $e517caada390a624$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $e517caada390a624$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $e517caada390a624$var$wb = d;
            c.target.dispatchEvent(d);
            $e517caada390a624$var$wb = null;
        } else return b = $e517caada390a624$var$Cb(c), null !== b && $e517caada390a624$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $e517caada390a624$var$Zc(a, b, c) {
    $e517caada390a624$var$Xc(a) && c.delete(b);
}
function $e517caada390a624$var$$c() {
    $e517caada390a624$var$Jc = !1;
    null !== $e517caada390a624$var$Lc && $e517caada390a624$var$Xc($e517caada390a624$var$Lc) && ($e517caada390a624$var$Lc = null);
    null !== $e517caada390a624$var$Mc && $e517caada390a624$var$Xc($e517caada390a624$var$Mc) && ($e517caada390a624$var$Mc = null);
    null !== $e517caada390a624$var$Nc && $e517caada390a624$var$Xc($e517caada390a624$var$Nc) && ($e517caada390a624$var$Nc = null);
    $e517caada390a624$var$Oc.forEach($e517caada390a624$var$Zc);
    $e517caada390a624$var$Pc.forEach($e517caada390a624$var$Zc);
}
function $e517caada390a624$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $e517caada390a624$var$Jc || ($e517caada390a624$var$Jc = !0, $lLS11.unstable_scheduleCallback($lLS11.unstable_NormalPriority, $e517caada390a624$var$$c)));
}
function $e517caada390a624$var$bd(a) {
    function b(b) {
        return $e517caada390a624$var$ad(b, a);
    }
    if (0 < $e517caada390a624$var$Kc.length) {
        $e517caada390a624$var$ad($e517caada390a624$var$Kc[0], a);
        for(var c = 1; c < $e517caada390a624$var$Kc.length; c++){
            var d = $e517caada390a624$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $e517caada390a624$var$Lc && $e517caada390a624$var$ad($e517caada390a624$var$Lc, a);
    null !== $e517caada390a624$var$Mc && $e517caada390a624$var$ad($e517caada390a624$var$Mc, a);
    null !== $e517caada390a624$var$Nc && $e517caada390a624$var$ad($e517caada390a624$var$Nc, a);
    $e517caada390a624$var$Oc.forEach(b);
    $e517caada390a624$var$Pc.forEach(b);
    for(c = 0; c < $e517caada390a624$var$Qc.length; c++)d = $e517caada390a624$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $e517caada390a624$var$Qc.length && (c = $e517caada390a624$var$Qc[0], null === c.blockedOn);)$e517caada390a624$var$Vc(c), null === c.blockedOn && $e517caada390a624$var$Qc.shift();
}
var $e517caada390a624$var$cd = $e517caada390a624$var$ua.ReactCurrentBatchConfig, $e517caada390a624$var$dd = !0;
function $e517caada390a624$var$ed(a, b, c, d) {
    var e = $e517caada390a624$var$C, f = $e517caada390a624$var$cd.transition;
    $e517caada390a624$var$cd.transition = null;
    try {
        $e517caada390a624$var$C = 1, $e517caada390a624$var$fd(a, b, c, d);
    } finally{
        $e517caada390a624$var$C = e, $e517caada390a624$var$cd.transition = f;
    }
}
function $e517caada390a624$var$gd(a, b, c, d) {
    var e = $e517caada390a624$var$C, f = $e517caada390a624$var$cd.transition;
    $e517caada390a624$var$cd.transition = null;
    try {
        $e517caada390a624$var$C = 4, $e517caada390a624$var$fd(a, b, c, d);
    } finally{
        $e517caada390a624$var$C = e, $e517caada390a624$var$cd.transition = f;
    }
}
function $e517caada390a624$var$fd(a, b, c, d) {
    if ($e517caada390a624$var$dd) {
        var e = $e517caada390a624$var$Yc(a, b, c, d);
        if (null === e) $e517caada390a624$var$hd(a, b, d, $e517caada390a624$var$id, c), $e517caada390a624$var$Sc(a, d);
        else if ($e517caada390a624$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($e517caada390a624$var$Sc(a, d), b & 4 && -1 < $e517caada390a624$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $e517caada390a624$var$Cb(e);
                null !== f && $e517caada390a624$var$Ec(f);
                f = $e517caada390a624$var$Yc(a, b, c, d);
                null === f && $e517caada390a624$var$hd(a, b, d, $e517caada390a624$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $e517caada390a624$var$hd(a, b, d, null, c);
    }
}
var $e517caada390a624$var$id = null;
function $e517caada390a624$var$Yc(a, b, c, d) {
    $e517caada390a624$var$id = null;
    a = $e517caada390a624$var$xb(d);
    a = $e517caada390a624$var$Wc(a);
    if (null !== a) {
        if (b = $e517caada390a624$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $e517caada390a624$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $e517caada390a624$var$id = a;
    return null;
}
function $e517caada390a624$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($e517caada390a624$var$ec()){
                case $e517caada390a624$var$fc:
                    return 1;
                case $e517caada390a624$var$gc:
                    return 4;
                case $e517caada390a624$var$hc:
                case $e517caada390a624$var$ic:
                    return 16;
                case $e517caada390a624$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $e517caada390a624$var$kd = null, $e517caada390a624$var$ld = null, $e517caada390a624$var$md = null;
function $e517caada390a624$var$nd() {
    if ($e517caada390a624$var$md) return $e517caada390a624$var$md;
    var a, b = $e517caada390a624$var$ld, c = b.length, d, e = "value" in $e517caada390a624$var$kd ? $e517caada390a624$var$kd.value : $e517caada390a624$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $e517caada390a624$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $e517caada390a624$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $e517caada390a624$var$pd() {
    return !0;
}
function $e517caada390a624$var$qd() {
    return !1;
}
function $e517caada390a624$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $e517caada390a624$var$pd : $e517caada390a624$var$qd;
        this.isPropagationStopped = $e517caada390a624$var$qd;
        return this;
    }
    $e517caada390a624$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $e517caada390a624$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $e517caada390a624$var$pd);
        },
        persist: function() {},
        isPersistent: $e517caada390a624$var$pd
    });
    return b;
}
var $e517caada390a624$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $e517caada390a624$var$td = $e517caada390a624$var$rd($e517caada390a624$var$sd), $e517caada390a624$var$ud = $e517caada390a624$var$A({}, $e517caada390a624$var$sd, {
    view: 0,
    detail: 0
}), $e517caada390a624$var$vd = $e517caada390a624$var$rd($e517caada390a624$var$ud), $e517caada390a624$var$wd, $e517caada390a624$var$xd, $e517caada390a624$var$yd, $e517caada390a624$var$Ad = $e517caada390a624$var$A({}, $e517caada390a624$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $e517caada390a624$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $e517caada390a624$var$yd && ($e517caada390a624$var$yd && "mousemove" === a.type ? ($e517caada390a624$var$wd = a.screenX - $e517caada390a624$var$yd.screenX, $e517caada390a624$var$xd = a.screenY - $e517caada390a624$var$yd.screenY) : $e517caada390a624$var$xd = $e517caada390a624$var$wd = 0, $e517caada390a624$var$yd = a);
        return $e517caada390a624$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $e517caada390a624$var$xd;
    }
}), $e517caada390a624$var$Bd = $e517caada390a624$var$rd($e517caada390a624$var$Ad), $e517caada390a624$var$Cd = $e517caada390a624$var$A({}, $e517caada390a624$var$Ad, {
    dataTransfer: 0
}), $e517caada390a624$var$Dd = $e517caada390a624$var$rd($e517caada390a624$var$Cd), $e517caada390a624$var$Ed = $e517caada390a624$var$A({}, $e517caada390a624$var$ud, {
    relatedTarget: 0
}), $e517caada390a624$var$Fd = $e517caada390a624$var$rd($e517caada390a624$var$Ed), $e517caada390a624$var$Gd = $e517caada390a624$var$A({}, $e517caada390a624$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e517caada390a624$var$Hd = $e517caada390a624$var$rd($e517caada390a624$var$Gd), $e517caada390a624$var$Id = $e517caada390a624$var$A({}, $e517caada390a624$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $e517caada390a624$var$Jd = $e517caada390a624$var$rd($e517caada390a624$var$Id), $e517caada390a624$var$Kd = $e517caada390a624$var$A({}, $e517caada390a624$var$sd, {
    data: 0
}), $e517caada390a624$var$Ld = $e517caada390a624$var$rd($e517caada390a624$var$Kd), $e517caada390a624$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $e517caada390a624$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $e517caada390a624$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $e517caada390a624$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $e517caada390a624$var$Od[a]) ? !!b[a] : !1;
}
function $e517caada390a624$var$zd() {
    return $e517caada390a624$var$Pd;
}
var $e517caada390a624$var$Qd = $e517caada390a624$var$A({}, $e517caada390a624$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $e517caada390a624$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $e517caada390a624$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $e517caada390a624$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $e517caada390a624$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $e517caada390a624$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $e517caada390a624$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $e517caada390a624$var$Rd = $e517caada390a624$var$rd($e517caada390a624$var$Qd), $e517caada390a624$var$Sd = $e517caada390a624$var$A({}, $e517caada390a624$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $e517caada390a624$var$Td = $e517caada390a624$var$rd($e517caada390a624$var$Sd), $e517caada390a624$var$Ud = $e517caada390a624$var$A({}, $e517caada390a624$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $e517caada390a624$var$zd
}), $e517caada390a624$var$Vd = $e517caada390a624$var$rd($e517caada390a624$var$Ud), $e517caada390a624$var$Wd = $e517caada390a624$var$A({}, $e517caada390a624$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e517caada390a624$var$Xd = $e517caada390a624$var$rd($e517caada390a624$var$Wd), $e517caada390a624$var$Yd = $e517caada390a624$var$A({}, $e517caada390a624$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $e517caada390a624$var$Zd = $e517caada390a624$var$rd($e517caada390a624$var$Yd), $e517caada390a624$var$$d = [
    9,
    13,
    27,
    32
], $e517caada390a624$var$ae = $e517caada390a624$var$ia && "CompositionEvent" in window, $e517caada390a624$var$be = null;
$e517caada390a624$var$ia && "documentMode" in document && ($e517caada390a624$var$be = document.documentMode);
var $e517caada390a624$var$ce = $e517caada390a624$var$ia && "TextEvent" in window && !$e517caada390a624$var$be, $e517caada390a624$var$de = $e517caada390a624$var$ia && (!$e517caada390a624$var$ae || $e517caada390a624$var$be && 8 < $e517caada390a624$var$be && 11 >= $e517caada390a624$var$be), $e517caada390a624$var$ee = String.fromCharCode(32), $e517caada390a624$var$fe = !1;
function $e517caada390a624$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $e517caada390a624$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $e517caada390a624$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $e517caada390a624$var$ie = !1;
function $e517caada390a624$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $e517caada390a624$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $e517caada390a624$var$fe = !0;
            return $e517caada390a624$var$ee;
        case "textInput":
            return a = b.data, a === $e517caada390a624$var$ee && $e517caada390a624$var$fe ? null : a;
        default:
            return null;
    }
}
function $e517caada390a624$var$ke(a, b) {
    if ($e517caada390a624$var$ie) return "compositionend" === a || !$e517caada390a624$var$ae && $e517caada390a624$var$ge(a, b) ? (a = $e517caada390a624$var$nd(), $e517caada390a624$var$md = $e517caada390a624$var$ld = $e517caada390a624$var$kd = null, $e517caada390a624$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $e517caada390a624$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $e517caada390a624$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $e517caada390a624$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$e517caada390a624$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $e517caada390a624$var$ne(a, b, c, d) {
    $e517caada390a624$var$Eb(d);
    b = $e517caada390a624$var$oe(b, "onChange");
    0 < b.length && (c = new $e517caada390a624$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $e517caada390a624$var$pe = null, $e517caada390a624$var$qe = null;
function $e517caada390a624$var$re(a) {
    $e517caada390a624$var$se(a, 0);
}
function $e517caada390a624$var$te(a) {
    var b = $e517caada390a624$var$ue(a);
    if ($e517caada390a624$var$Wa(b)) return a;
}
function $e517caada390a624$var$ve(a, b) {
    if ("change" === a) return b;
}
var $e517caada390a624$var$we = !1;
if ($e517caada390a624$var$ia) {
    var $e517caada390a624$var$xe;
    if ($e517caada390a624$var$ia) {
        var $e517caada390a624$var$ye = "oninput" in document;
        if (!$e517caada390a624$var$ye) {
            var $e517caada390a624$var$ze = document.createElement("div");
            $e517caada390a624$var$ze.setAttribute("oninput", "return;");
            $e517caada390a624$var$ye = "function" === typeof $e517caada390a624$var$ze.oninput;
        }
        $e517caada390a624$var$xe = $e517caada390a624$var$ye;
    } else $e517caada390a624$var$xe = !1;
    $e517caada390a624$var$we = $e517caada390a624$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $e517caada390a624$var$Ae() {
    $e517caada390a624$var$pe && ($e517caada390a624$var$pe.detachEvent("onpropertychange", $e517caada390a624$var$Be), $e517caada390a624$var$qe = $e517caada390a624$var$pe = null);
}
function $e517caada390a624$var$Be(a) {
    if ("value" === a.propertyName && $e517caada390a624$var$te($e517caada390a624$var$qe)) {
        var b = [];
        $e517caada390a624$var$ne(b, $e517caada390a624$var$qe, a, $e517caada390a624$var$xb(a));
        $e517caada390a624$var$Jb($e517caada390a624$var$re, b);
    }
}
function $e517caada390a624$var$Ce(a, b, c) {
    "focusin" === a ? ($e517caada390a624$var$Ae(), $e517caada390a624$var$pe = b, $e517caada390a624$var$qe = c, $e517caada390a624$var$pe.attachEvent("onpropertychange", $e517caada390a624$var$Be)) : "focusout" === a && $e517caada390a624$var$Ae();
}
function $e517caada390a624$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $e517caada390a624$var$te($e517caada390a624$var$qe);
}
function $e517caada390a624$var$Ee(a, b) {
    if ("click" === a) return $e517caada390a624$var$te(b);
}
function $e517caada390a624$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $e517caada390a624$var$te(b);
}
function $e517caada390a624$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e517caada390a624$var$He = "function" === typeof Object.is ? Object.is : $e517caada390a624$var$Ge;
function $e517caada390a624$var$Ie(a, b) {
    if ($e517caada390a624$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$e517caada390a624$var$ja.call(b, e) || !$e517caada390a624$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $e517caada390a624$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $e517caada390a624$var$Ke(a, b) {
    var c = $e517caada390a624$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $e517caada390a624$var$Je(c);
    }
}
function $e517caada390a624$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $e517caada390a624$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $e517caada390a624$var$Me() {
    for(var a = window, b = $e517caada390a624$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $e517caada390a624$var$Xa(a.document);
    }
    return b;
}
function $e517caada390a624$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $e517caada390a624$var$Oe(a) {
    var b = $e517caada390a624$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $e517caada390a624$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $e517caada390a624$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $e517caada390a624$var$Ke(c, f);
                var g = $e517caada390a624$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $e517caada390a624$var$Pe = $e517caada390a624$var$ia && "documentMode" in document && 11 >= document.documentMode, $e517caada390a624$var$Qe = null, $e517caada390a624$var$Re = null, $e517caada390a624$var$Se = null, $e517caada390a624$var$Te = !1;
function $e517caada390a624$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $e517caada390a624$var$Te || null == $e517caada390a624$var$Qe || $e517caada390a624$var$Qe !== $e517caada390a624$var$Xa(d) || (d = $e517caada390a624$var$Qe, "selectionStart" in d && $e517caada390a624$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $e517caada390a624$var$Se && $e517caada390a624$var$Ie($e517caada390a624$var$Se, d) || ($e517caada390a624$var$Se = d, d = $e517caada390a624$var$oe($e517caada390a624$var$Re, "onSelect"), 0 < d.length && (b = new $e517caada390a624$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $e517caada390a624$var$Qe)));
}
function $e517caada390a624$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $e517caada390a624$var$We = {
    animationend: $e517caada390a624$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $e517caada390a624$var$Ve("Animation", "AnimationIteration"),
    animationstart: $e517caada390a624$var$Ve("Animation", "AnimationStart"),
    transitionend: $e517caada390a624$var$Ve("Transition", "TransitionEnd")
}, $e517caada390a624$var$Xe = {}, $e517caada390a624$var$Ye = {};
$e517caada390a624$var$ia && ($e517caada390a624$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $e517caada390a624$var$We.animationend.animation, delete $e517caada390a624$var$We.animationiteration.animation, delete $e517caada390a624$var$We.animationstart.animation), "TransitionEvent" in window || delete $e517caada390a624$var$We.transitionend.transition);
function $e517caada390a624$var$Ze(a) {
    if ($e517caada390a624$var$Xe[a]) return $e517caada390a624$var$Xe[a];
    if (!$e517caada390a624$var$We[a]) return a;
    var b = $e517caada390a624$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $e517caada390a624$var$Ye) return $e517caada390a624$var$Xe[a] = b[c];
    return a;
}
var $e517caada390a624$var$$e = $e517caada390a624$var$Ze("animationend"), $e517caada390a624$var$af = $e517caada390a624$var$Ze("animationiteration"), $e517caada390a624$var$bf = $e517caada390a624$var$Ze("animationstart"), $e517caada390a624$var$cf = $e517caada390a624$var$Ze("transitionend"), $e517caada390a624$var$df = new Map, $e517caada390a624$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $e517caada390a624$var$ff(a, b) {
    $e517caada390a624$var$df.set(a, b);
    $e517caada390a624$var$fa(b, [
        a
    ]);
}
for(var $e517caada390a624$var$gf = 0; $e517caada390a624$var$gf < $e517caada390a624$var$ef.length; $e517caada390a624$var$gf++){
    var $e517caada390a624$var$hf = $e517caada390a624$var$ef[$e517caada390a624$var$gf], $e517caada390a624$var$jf = $e517caada390a624$var$hf.toLowerCase(), $e517caada390a624$var$kf = $e517caada390a624$var$hf[0].toUpperCase() + $e517caada390a624$var$hf.slice(1);
    $e517caada390a624$var$ff($e517caada390a624$var$jf, "on" + $e517caada390a624$var$kf);
}
$e517caada390a624$var$ff($e517caada390a624$var$$e, "onAnimationEnd");
$e517caada390a624$var$ff($e517caada390a624$var$af, "onAnimationIteration");
$e517caada390a624$var$ff($e517caada390a624$var$bf, "onAnimationStart");
$e517caada390a624$var$ff("dblclick", "onDoubleClick");
$e517caada390a624$var$ff("focusin", "onFocus");
$e517caada390a624$var$ff("focusout", "onBlur");
$e517caada390a624$var$ff($e517caada390a624$var$cf, "onTransitionEnd");
$e517caada390a624$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$e517caada390a624$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$e517caada390a624$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$e517caada390a624$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$e517caada390a624$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$e517caada390a624$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$e517caada390a624$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$e517caada390a624$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$e517caada390a624$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$e517caada390a624$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $e517caada390a624$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $e517caada390a624$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($e517caada390a624$var$lf));
function $e517caada390a624$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $e517caada390a624$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $e517caada390a624$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e517caada390a624$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e517caada390a624$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($e517caada390a624$var$Qb) throw a = $e517caada390a624$var$Rb, $e517caada390a624$var$Qb = !1, $e517caada390a624$var$Rb = null, a;
}
function $e517caada390a624$var$D(a, b) {
    var c = b[$e517caada390a624$var$of];
    void 0 === c && (c = b[$e517caada390a624$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($e517caada390a624$var$pf(b, a, 2, !1), c.add(d));
}
function $e517caada390a624$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $e517caada390a624$var$pf(c, a, d, b);
}
var $e517caada390a624$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $e517caada390a624$var$sf(a) {
    if (!a[$e517caada390a624$var$rf]) {
        a[$e517caada390a624$var$rf] = !0;
        $e517caada390a624$var$da.forEach(function(b) {
            "selectionchange" !== b && ($e517caada390a624$var$mf.has(b) || $e517caada390a624$var$qf(b, !1, a), $e517caada390a624$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$e517caada390a624$var$rf] || (b[$e517caada390a624$var$rf] = !0, $e517caada390a624$var$qf("selectionchange", !1, b));
    }
}
function $e517caada390a624$var$pf(a, b, c, d) {
    switch($e517caada390a624$var$jd(b)){
        case 1:
            var e = $e517caada390a624$var$ed;
            break;
        case 4:
            e = $e517caada390a624$var$gd;
            break;
        default:
            e = $e517caada390a624$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$e517caada390a624$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $e517caada390a624$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $e517caada390a624$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $e517caada390a624$var$Jb(function() {
        var d = f, e = $e517caada390a624$var$xb(c), g = [];
        a: {
            var h = $e517caada390a624$var$df.get(a);
            if (void 0 !== h) {
                var k = $e517caada390a624$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $e517caada390a624$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $e517caada390a624$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $e517caada390a624$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $e517caada390a624$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $e517caada390a624$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $e517caada390a624$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $e517caada390a624$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $e517caada390a624$var$Vd;
                        break;
                    case $e517caada390a624$var$$e:
                    case $e517caada390a624$var$af:
                    case $e517caada390a624$var$bf:
                        k = $e517caada390a624$var$Hd;
                        break;
                    case $e517caada390a624$var$cf:
                        k = $e517caada390a624$var$Xd;
                        break;
                    case "scroll":
                        k = $e517caada390a624$var$vd;
                        break;
                    case "wheel":
                        k = $e517caada390a624$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $e517caada390a624$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $e517caada390a624$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $e517caada390a624$var$Kb(w, x), null != F && t.push($e517caada390a624$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $e517caada390a624$var$wb && (n = c.relatedTarget || c.fromElement) && ($e517caada390a624$var$Wc(n) || n[$e517caada390a624$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $e517caada390a624$var$Wc(n) : null, null !== n && (J = $e517caada390a624$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $e517caada390a624$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $e517caada390a624$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $e517caada390a624$var$ue(k);
                        u = null == n ? h : $e517caada390a624$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $e517caada390a624$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $e517caada390a624$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $e517caada390a624$var$vf(F))u++;
                            for(; 0 < w - u;)t = $e517caada390a624$var$vf(t), w--;
                            for(; 0 < u - w;)x = $e517caada390a624$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $e517caada390a624$var$vf(t);
                                x = $e517caada390a624$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $e517caada390a624$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $e517caada390a624$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $e517caada390a624$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $e517caada390a624$var$ve;
                else if ($e517caada390a624$var$me(h)) {
                    if ($e517caada390a624$var$we) na = $e517caada390a624$var$Fe;
                    else {
                        na = $e517caada390a624$var$De;
                        var xa = $e517caada390a624$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $e517caada390a624$var$Ee);
                if (na && (na = na(a, d))) {
                    $e517caada390a624$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $e517caada390a624$var$cb(h, "number", h.value);
            }
            xa = d ? $e517caada390a624$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($e517caada390a624$var$me(xa) || "true" === xa.contentEditable) $e517caada390a624$var$Qe = xa, $e517caada390a624$var$Re = d, $e517caada390a624$var$Se = null;
                    break;
                case "focusout":
                    $e517caada390a624$var$Se = $e517caada390a624$var$Re = $e517caada390a624$var$Qe = null;
                    break;
                case "mousedown":
                    $e517caada390a624$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $e517caada390a624$var$Te = !1;
                    $e517caada390a624$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($e517caada390a624$var$Pe) break;
                case "keydown":
                case "keyup":
                    $e517caada390a624$var$Ue(g, c, e);
            }
            var $a;
            if ($e517caada390a624$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $e517caada390a624$var$ie ? $e517caada390a624$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($e517caada390a624$var$de && "ko" !== c.locale && ($e517caada390a624$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $e517caada390a624$var$ie && ($a = $e517caada390a624$var$nd()) : ($e517caada390a624$var$kd = e, $e517caada390a624$var$ld = "value" in $e517caada390a624$var$kd ? $e517caada390a624$var$kd.value : $e517caada390a624$var$kd.textContent, $e517caada390a624$var$ie = !0)), xa = $e517caada390a624$var$oe(d, ba), 0 < xa.length && (ba = new $e517caada390a624$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $e517caada390a624$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $e517caada390a624$var$ce ? $e517caada390a624$var$je(a, c) : $e517caada390a624$var$ke(a, c)) d = $e517caada390a624$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $e517caada390a624$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $e517caada390a624$var$se(g, b);
    });
}
function $e517caada390a624$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $e517caada390a624$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $e517caada390a624$var$Kb(a, c), null != f && d.unshift($e517caada390a624$var$tf(a, f, e)), f = $e517caada390a624$var$Kb(a, b), null != f && d.push($e517caada390a624$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $e517caada390a624$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $e517caada390a624$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $e517caada390a624$var$Kb(c, f), null != k && g.unshift($e517caada390a624$var$tf(c, k, h))) : e || (k = $e517caada390a624$var$Kb(c, f), null != k && g.push($e517caada390a624$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $e517caada390a624$var$xf = /\r\n?/g, $e517caada390a624$var$yf = /\u0000|\uFFFD/g;
function $e517caada390a624$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($e517caada390a624$var$xf, "\n").replace($e517caada390a624$var$yf, "");
}
function $e517caada390a624$var$Af(a, b, c) {
    b = $e517caada390a624$var$zf(b);
    if ($e517caada390a624$var$zf(a) !== b && c) throw Error($e517caada390a624$var$p(425));
}
function $e517caada390a624$var$Bf() {}
var $e517caada390a624$var$Cf = null, $e517caada390a624$var$Df = null;
function $e517caada390a624$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $e517caada390a624$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $e517caada390a624$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $e517caada390a624$var$Hf = "function" === typeof Promise ? Promise : void 0, $e517caada390a624$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $e517caada390a624$var$Hf ? function(a) {
    return $e517caada390a624$var$Hf.resolve(null).then(a).catch($e517caada390a624$var$If);
} : $e517caada390a624$var$Ff;
function $e517caada390a624$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $e517caada390a624$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $e517caada390a624$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $e517caada390a624$var$bd(b);
}
function $e517caada390a624$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $e517caada390a624$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $e517caada390a624$var$Nf = Math.random().toString(36).slice(2), $e517caada390a624$var$Of = "__reactFiber$" + $e517caada390a624$var$Nf, $e517caada390a624$var$Pf = "__reactProps$" + $e517caada390a624$var$Nf, $e517caada390a624$var$uf = "__reactContainer$" + $e517caada390a624$var$Nf, $e517caada390a624$var$of = "__reactEvents$" + $e517caada390a624$var$Nf, $e517caada390a624$var$Qf = "__reactListeners$" + $e517caada390a624$var$Nf, $e517caada390a624$var$Rf = "__reactHandles$" + $e517caada390a624$var$Nf;
function $e517caada390a624$var$Wc(a) {
    var b = a[$e517caada390a624$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$e517caada390a624$var$uf] || c[$e517caada390a624$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $e517caada390a624$var$Mf(a); null !== a;){
                if (c = a[$e517caada390a624$var$Of]) return c;
                a = $e517caada390a624$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $e517caada390a624$var$Cb(a) {
    a = a[$e517caada390a624$var$Of] || a[$e517caada390a624$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $e517caada390a624$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($e517caada390a624$var$p(33));
}
function $e517caada390a624$var$Db(a) {
    return a[$e517caada390a624$var$Pf] || null;
}
var $e517caada390a624$var$Sf = [], $e517caada390a624$var$Tf = -1;
function $e517caada390a624$var$Uf(a) {
    return {
        current: a
    };
}
function $e517caada390a624$var$E(a) {
    0 > $e517caada390a624$var$Tf || (a.current = $e517caada390a624$var$Sf[$e517caada390a624$var$Tf], $e517caada390a624$var$Sf[$e517caada390a624$var$Tf] = null, $e517caada390a624$var$Tf--);
}
function $e517caada390a624$var$G(a, b) {
    $e517caada390a624$var$Tf++;
    $e517caada390a624$var$Sf[$e517caada390a624$var$Tf] = a.current;
    a.current = b;
}
var $e517caada390a624$var$Vf = {}, $e517caada390a624$var$H = $e517caada390a624$var$Uf($e517caada390a624$var$Vf), $e517caada390a624$var$Wf = $e517caada390a624$var$Uf(!1), $e517caada390a624$var$Xf = $e517caada390a624$var$Vf;
function $e517caada390a624$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $e517caada390a624$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $e517caada390a624$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $e517caada390a624$var$$f() {
    $e517caada390a624$var$E($e517caada390a624$var$Wf);
    $e517caada390a624$var$E($e517caada390a624$var$H);
}
function $e517caada390a624$var$ag(a, b, c) {
    if ($e517caada390a624$var$H.current !== $e517caada390a624$var$Vf) throw Error($e517caada390a624$var$p(168));
    $e517caada390a624$var$G($e517caada390a624$var$H, b);
    $e517caada390a624$var$G($e517caada390a624$var$Wf, c);
}
function $e517caada390a624$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($e517caada390a624$var$p(108, $e517caada390a624$var$Ra(a) || "Unknown", e));
    return $e517caada390a624$var$A({}, c, d);
}
function $e517caada390a624$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $e517caada390a624$var$Vf;
    $e517caada390a624$var$Xf = $e517caada390a624$var$H.current;
    $e517caada390a624$var$G($e517caada390a624$var$H, a);
    $e517caada390a624$var$G($e517caada390a624$var$Wf, $e517caada390a624$var$Wf.current);
    return !0;
}
function $e517caada390a624$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($e517caada390a624$var$p(169));
    c ? (a = $e517caada390a624$var$bg(a, b, $e517caada390a624$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $e517caada390a624$var$E($e517caada390a624$var$Wf), $e517caada390a624$var$E($e517caada390a624$var$H), $e517caada390a624$var$G($e517caada390a624$var$H, a)) : $e517caada390a624$var$E($e517caada390a624$var$Wf);
    $e517caada390a624$var$G($e517caada390a624$var$Wf, c);
}
var $e517caada390a624$var$eg = null, $e517caada390a624$var$fg = !1, $e517caada390a624$var$gg = !1;
function $e517caada390a624$var$hg(a) {
    null === $e517caada390a624$var$eg ? $e517caada390a624$var$eg = [
        a
    ] : $e517caada390a624$var$eg.push(a);
}
function $e517caada390a624$var$ig(a) {
    $e517caada390a624$var$fg = !0;
    $e517caada390a624$var$hg(a);
}
function $e517caada390a624$var$jg() {
    if (!$e517caada390a624$var$gg && null !== $e517caada390a624$var$eg) {
        $e517caada390a624$var$gg = !0;
        var a = 0, b = $e517caada390a624$var$C;
        try {
            var c = $e517caada390a624$var$eg;
            for($e517caada390a624$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $e517caada390a624$var$eg = null;
            $e517caada390a624$var$fg = !1;
        } catch (e) {
            throw null !== $e517caada390a624$var$eg && ($e517caada390a624$var$eg = $e517caada390a624$var$eg.slice(a + 1)), $e517caada390a624$var$ac($e517caada390a624$var$fc, $e517caada390a624$var$jg), e;
        } finally{
            $e517caada390a624$var$C = b, $e517caada390a624$var$gg = !1;
        }
    }
    return null;
}
var $e517caada390a624$var$kg = [], $e517caada390a624$var$lg = 0, $e517caada390a624$var$mg = null, $e517caada390a624$var$ng = 0, $e517caada390a624$var$og = [], $e517caada390a624$var$pg = 0, $e517caada390a624$var$qg = null, $e517caada390a624$var$rg = 1, $e517caada390a624$var$sg = "";
function $e517caada390a624$var$tg(a, b) {
    $e517caada390a624$var$kg[$e517caada390a624$var$lg++] = $e517caada390a624$var$ng;
    $e517caada390a624$var$kg[$e517caada390a624$var$lg++] = $e517caada390a624$var$mg;
    $e517caada390a624$var$mg = a;
    $e517caada390a624$var$ng = b;
}
function $e517caada390a624$var$ug(a, b, c) {
    $e517caada390a624$var$og[$e517caada390a624$var$pg++] = $e517caada390a624$var$rg;
    $e517caada390a624$var$og[$e517caada390a624$var$pg++] = $e517caada390a624$var$sg;
    $e517caada390a624$var$og[$e517caada390a624$var$pg++] = $e517caada390a624$var$qg;
    $e517caada390a624$var$qg = a;
    var d = $e517caada390a624$var$rg;
    a = $e517caada390a624$var$sg;
    var e = 32 - $e517caada390a624$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $e517caada390a624$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $e517caada390a624$var$rg = 1 << 32 - $e517caada390a624$var$oc(b) + e | c << e | d;
        $e517caada390a624$var$sg = f + a;
    } else $e517caada390a624$var$rg = 1 << f | c << e | d, $e517caada390a624$var$sg = a;
}
function $e517caada390a624$var$vg(a) {
    null !== a.return && ($e517caada390a624$var$tg(a, 1), $e517caada390a624$var$ug(a, 1, 0));
}
function $e517caada390a624$var$wg(a) {
    for(; a === $e517caada390a624$var$mg;)$e517caada390a624$var$mg = $e517caada390a624$var$kg[--$e517caada390a624$var$lg], $e517caada390a624$var$kg[$e517caada390a624$var$lg] = null, $e517caada390a624$var$ng = $e517caada390a624$var$kg[--$e517caada390a624$var$lg], $e517caada390a624$var$kg[$e517caada390a624$var$lg] = null;
    for(; a === $e517caada390a624$var$qg;)$e517caada390a624$var$qg = $e517caada390a624$var$og[--$e517caada390a624$var$pg], $e517caada390a624$var$og[$e517caada390a624$var$pg] = null, $e517caada390a624$var$sg = $e517caada390a624$var$og[--$e517caada390a624$var$pg], $e517caada390a624$var$og[$e517caada390a624$var$pg] = null, $e517caada390a624$var$rg = $e517caada390a624$var$og[--$e517caada390a624$var$pg], $e517caada390a624$var$og[$e517caada390a624$var$pg] = null;
}
var $e517caada390a624$var$xg = null, $e517caada390a624$var$yg = null, $e517caada390a624$var$I = !1, $e517caada390a624$var$zg = null;
function $e517caada390a624$var$Ag(a, b) {
    var c = $e517caada390a624$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $e517caada390a624$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $e517caada390a624$var$xg = a, $e517caada390a624$var$yg = $e517caada390a624$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $e517caada390a624$var$xg = a, $e517caada390a624$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $e517caada390a624$var$qg ? {
                id: $e517caada390a624$var$rg,
                overflow: $e517caada390a624$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $e517caada390a624$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $e517caada390a624$var$xg = a, $e517caada390a624$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $e517caada390a624$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $e517caada390a624$var$Eg(a) {
    if ($e517caada390a624$var$I) {
        var b = $e517caada390a624$var$yg;
        if (b) {
            var c = b;
            if (!$e517caada390a624$var$Cg(a, b)) {
                if ($e517caada390a624$var$Dg(a)) throw Error($e517caada390a624$var$p(418));
                b = $e517caada390a624$var$Lf(c.nextSibling);
                var d = $e517caada390a624$var$xg;
                b && $e517caada390a624$var$Cg(a, b) ? $e517caada390a624$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $e517caada390a624$var$I = !1, $e517caada390a624$var$xg = a);
            }
        } else {
            if ($e517caada390a624$var$Dg(a)) throw Error($e517caada390a624$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $e517caada390a624$var$I = !1;
            $e517caada390a624$var$xg = a;
        }
    }
}
function $e517caada390a624$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $e517caada390a624$var$xg = a;
}
function $e517caada390a624$var$Gg(a) {
    if (a !== $e517caada390a624$var$xg) return !1;
    if (!$e517caada390a624$var$I) return $e517caada390a624$var$Fg(a), $e517caada390a624$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$e517caada390a624$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $e517caada390a624$var$yg)) {
        if ($e517caada390a624$var$Dg(a)) throw $e517caada390a624$var$Hg(), Error($e517caada390a624$var$p(418));
        for(; b;)$e517caada390a624$var$Ag(a, b), b = $e517caada390a624$var$Lf(b.nextSibling);
    }
    $e517caada390a624$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($e517caada390a624$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $e517caada390a624$var$yg = $e517caada390a624$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $e517caada390a624$var$yg = null;
        }
    } else $e517caada390a624$var$yg = $e517caada390a624$var$xg ? $e517caada390a624$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $e517caada390a624$var$Hg() {
    for(var a = $e517caada390a624$var$yg; a;)a = $e517caada390a624$var$Lf(a.nextSibling);
}
function $e517caada390a624$var$Ig() {
    $e517caada390a624$var$yg = $e517caada390a624$var$xg = null;
    $e517caada390a624$var$I = !1;
}
function $e517caada390a624$var$Jg(a) {
    null === $e517caada390a624$var$zg ? $e517caada390a624$var$zg = [
        a
    ] : $e517caada390a624$var$zg.push(a);
}
var $e517caada390a624$var$Kg = $e517caada390a624$var$ua.ReactCurrentBatchConfig;
function $e517caada390a624$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($e517caada390a624$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($e517caada390a624$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($e517caada390a624$var$p(284));
        if (!c._owner) throw Error($e517caada390a624$var$p(290, a));
    }
    return a;
}
function $e517caada390a624$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($e517caada390a624$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $e517caada390a624$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $e517caada390a624$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $e517caada390a624$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $e517caada390a624$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $e517caada390a624$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $e517caada390a624$var$Ha && $e517caada390a624$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $e517caada390a624$var$Lg(a, b, c), d.return = a, d;
        d = $e517caada390a624$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $e517caada390a624$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $e517caada390a624$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $e517caada390a624$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $e517caada390a624$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $e517caada390a624$var$va:
                    return c = $e517caada390a624$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $e517caada390a624$var$Lg(a, null, b), c.return = a, c;
                case $e517caada390a624$var$wa:
                    return b = $e517caada390a624$var$Sg(b, a.mode, c), b.return = a, b;
                case $e517caada390a624$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($e517caada390a624$var$eb(b) || $e517caada390a624$var$Ka(b)) return b = $e517caada390a624$var$Tg(b, a.mode, c, null), b.return = a, b;
            $e517caada390a624$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $e517caada390a624$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $e517caada390a624$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $e517caada390a624$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($e517caada390a624$var$eb(c) || $e517caada390a624$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $e517caada390a624$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $e517caada390a624$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $e517caada390a624$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $e517caada390a624$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($e517caada390a624$var$eb(d) || $e517caada390a624$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $e517caada390a624$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $e517caada390a624$var$I && $e517caada390a624$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $e517caada390a624$var$I && $e517caada390a624$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $e517caada390a624$var$I && $e517caada390a624$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $e517caada390a624$var$Ka(h);
        if ("function" !== typeof l) throw Error($e517caada390a624$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($e517caada390a624$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $e517caada390a624$var$I && $e517caada390a624$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $e517caada390a624$var$I && $e517caada390a624$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $e517caada390a624$var$I && $e517caada390a624$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $e517caada390a624$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $e517caada390a624$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $e517caada390a624$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $e517caada390a624$var$Ha && $e517caada390a624$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $e517caada390a624$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $e517caada390a624$var$ya ? (d = $e517caada390a624$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $e517caada390a624$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $e517caada390a624$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $e517caada390a624$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $e517caada390a624$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $e517caada390a624$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($e517caada390a624$var$eb(f)) return n(a, d, f, h);
            if ($e517caada390a624$var$Ka(f)) return t(a, d, f, h);
            $e517caada390a624$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $e517caada390a624$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $e517caada390a624$var$Ug = $e517caada390a624$var$Og(!0), $e517caada390a624$var$Vg = $e517caada390a624$var$Og(!1), $e517caada390a624$var$Wg = $e517caada390a624$var$Uf(null), $e517caada390a624$var$Xg = null, $e517caada390a624$var$Yg = null, $e517caada390a624$var$Zg = null;
function $e517caada390a624$var$$g() {
    $e517caada390a624$var$Zg = $e517caada390a624$var$Yg = $e517caada390a624$var$Xg = null;
}
function $e517caada390a624$var$ah(a) {
    var b = $e517caada390a624$var$Wg.current;
    $e517caada390a624$var$E($e517caada390a624$var$Wg);
    a._currentValue = b;
}
function $e517caada390a624$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $e517caada390a624$var$ch(a, b) {
    $e517caada390a624$var$Xg = a;
    $e517caada390a624$var$Zg = $e517caada390a624$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($e517caada390a624$var$dh = !0), a.firstContext = null);
}
function $e517caada390a624$var$eh(a) {
    var b = a._currentValue;
    if ($e517caada390a624$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $e517caada390a624$var$Yg) {
            if (null === $e517caada390a624$var$Xg) throw Error($e517caada390a624$var$p(308));
            $e517caada390a624$var$Yg = a;
            $e517caada390a624$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $e517caada390a624$var$Yg = $e517caada390a624$var$Yg.next = a;
    }
    return b;
}
var $e517caada390a624$var$fh = null;
function $e517caada390a624$var$gh(a) {
    null === $e517caada390a624$var$fh ? $e517caada390a624$var$fh = [
        a
    ] : $e517caada390a624$var$fh.push(a);
}
function $e517caada390a624$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $e517caada390a624$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $e517caada390a624$var$ih(a, d);
}
function $e517caada390a624$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $e517caada390a624$var$jh = !1;
function $e517caada390a624$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $e517caada390a624$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $e517caada390a624$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $e517caada390a624$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($e517caada390a624$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $e517caada390a624$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $e517caada390a624$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $e517caada390a624$var$ih(a, c);
}
function $e517caada390a624$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e517caada390a624$var$Cc(a, c);
    }
}
function $e517caada390a624$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $e517caada390a624$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $e517caada390a624$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $e517caada390a624$var$A({}, q, r);
                            break a;
                        case 2:
                            $e517caada390a624$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $e517caada390a624$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $e517caada390a624$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($e517caada390a624$var$p(191, e));
            e.call(d);
        }
    }
}
var $e517caada390a624$var$th = {}, $e517caada390a624$var$uh = $e517caada390a624$var$Uf($e517caada390a624$var$th), $e517caada390a624$var$vh = $e517caada390a624$var$Uf($e517caada390a624$var$th), $e517caada390a624$var$wh = $e517caada390a624$var$Uf($e517caada390a624$var$th);
function $e517caada390a624$var$xh(a) {
    if (a === $e517caada390a624$var$th) throw Error($e517caada390a624$var$p(174));
    return a;
}
function $e517caada390a624$var$yh(a, b) {
    $e517caada390a624$var$G($e517caada390a624$var$wh, b);
    $e517caada390a624$var$G($e517caada390a624$var$vh, a);
    $e517caada390a624$var$G($e517caada390a624$var$uh, $e517caada390a624$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $e517caada390a624$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $e517caada390a624$var$lb(b, a);
    }
    $e517caada390a624$var$E($e517caada390a624$var$uh);
    $e517caada390a624$var$G($e517caada390a624$var$uh, b);
}
function $e517caada390a624$var$zh() {
    $e517caada390a624$var$E($e517caada390a624$var$uh);
    $e517caada390a624$var$E($e517caada390a624$var$vh);
    $e517caada390a624$var$E($e517caada390a624$var$wh);
}
function $e517caada390a624$var$Ah(a) {
    $e517caada390a624$var$xh($e517caada390a624$var$wh.current);
    var b = $e517caada390a624$var$xh($e517caada390a624$var$uh.current);
    var c = $e517caada390a624$var$lb(b, a.type);
    b !== c && ($e517caada390a624$var$G($e517caada390a624$var$vh, a), $e517caada390a624$var$G($e517caada390a624$var$uh, c));
}
function $e517caada390a624$var$Bh(a) {
    $e517caada390a624$var$vh.current === a && ($e517caada390a624$var$E($e517caada390a624$var$uh), $e517caada390a624$var$E($e517caada390a624$var$vh));
}
var $e517caada390a624$var$L = $e517caada390a624$var$Uf(0);
function $e517caada390a624$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $e517caada390a624$var$Dh = [];
function $e517caada390a624$var$Eh() {
    for(var a = 0; a < $e517caada390a624$var$Dh.length; a++)$e517caada390a624$var$Dh[a]._workInProgressVersionPrimary = null;
    $e517caada390a624$var$Dh.length = 0;
}
var $e517caada390a624$var$Fh = $e517caada390a624$var$ua.ReactCurrentDispatcher, $e517caada390a624$var$Gh = $e517caada390a624$var$ua.ReactCurrentBatchConfig, $e517caada390a624$var$Hh = 0, $e517caada390a624$var$M = null, $e517caada390a624$var$N = null, $e517caada390a624$var$O = null, $e517caada390a624$var$Ih = !1, $e517caada390a624$var$Jh = !1, $e517caada390a624$var$Kh = 0, $e517caada390a624$var$Lh = 0;
function $e517caada390a624$var$P() {
    throw Error($e517caada390a624$var$p(321));
}
function $e517caada390a624$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e517caada390a624$var$He(a[c], b[c])) return !1;
    return !0;
}
function $e517caada390a624$var$Nh(a, b, c, d, e, f) {
    $e517caada390a624$var$Hh = f;
    $e517caada390a624$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $e517caada390a624$var$Fh.current = null === a || null === a.memoizedState ? $e517caada390a624$var$Oh : $e517caada390a624$var$Ph;
    a = c(d, e);
    if ($e517caada390a624$var$Jh) {
        f = 0;
        do {
            $e517caada390a624$var$Jh = !1;
            $e517caada390a624$var$Kh = 0;
            if (25 <= f) throw Error($e517caada390a624$var$p(301));
            f += 1;
            $e517caada390a624$var$O = $e517caada390a624$var$N = null;
            b.updateQueue = null;
            $e517caada390a624$var$Fh.current = $e517caada390a624$var$Qh;
            a = c(d, e);
        }while ($e517caada390a624$var$Jh);
    }
    $e517caada390a624$var$Fh.current = $e517caada390a624$var$Rh;
    b = null !== $e517caada390a624$var$N && null !== $e517caada390a624$var$N.next;
    $e517caada390a624$var$Hh = 0;
    $e517caada390a624$var$O = $e517caada390a624$var$N = $e517caada390a624$var$M = null;
    $e517caada390a624$var$Ih = !1;
    if (b) throw Error($e517caada390a624$var$p(300));
    return a;
}
function $e517caada390a624$var$Sh() {
    var a = 0 !== $e517caada390a624$var$Kh;
    $e517caada390a624$var$Kh = 0;
    return a;
}
function $e517caada390a624$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $e517caada390a624$var$O ? $e517caada390a624$var$M.memoizedState = $e517caada390a624$var$O = a : $e517caada390a624$var$O = $e517caada390a624$var$O.next = a;
    return $e517caada390a624$var$O;
}
function $e517caada390a624$var$Uh() {
    if (null === $e517caada390a624$var$N) {
        var a = $e517caada390a624$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $e517caada390a624$var$N.next;
    var b = null === $e517caada390a624$var$O ? $e517caada390a624$var$M.memoizedState : $e517caada390a624$var$O.next;
    if (null !== b) $e517caada390a624$var$O = b, $e517caada390a624$var$N = a;
    else {
        if (null === a) throw Error($e517caada390a624$var$p(310));
        $e517caada390a624$var$N = a;
        a = {
            memoizedState: $e517caada390a624$var$N.memoizedState,
            baseState: $e517caada390a624$var$N.baseState,
            baseQueue: $e517caada390a624$var$N.baseQueue,
            queue: $e517caada390a624$var$N.queue,
            next: null
        };
        null === $e517caada390a624$var$O ? $e517caada390a624$var$M.memoizedState = $e517caada390a624$var$O = a : $e517caada390a624$var$O = $e517caada390a624$var$O.next = a;
    }
    return $e517caada390a624$var$O;
}
function $e517caada390a624$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $e517caada390a624$var$Wh(a) {
    var b = $e517caada390a624$var$Uh(), c = b.queue;
    if (null === c) throw Error($e517caada390a624$var$p(311));
    c.lastRenderedReducer = a;
    var d = $e517caada390a624$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($e517caada390a624$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $e517caada390a624$var$M.lanes |= m;
                $e517caada390a624$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $e517caada390a624$var$He(d, b.memoizedState) || ($e517caada390a624$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $e517caada390a624$var$M.lanes |= f, $e517caada390a624$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $e517caada390a624$var$Xh(a) {
    var b = $e517caada390a624$var$Uh(), c = b.queue;
    if (null === c) throw Error($e517caada390a624$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e517caada390a624$var$He(f, b.memoizedState) || ($e517caada390a624$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $e517caada390a624$var$Yh() {}
function $e517caada390a624$var$Zh(a, b) {
    var c = $e517caada390a624$var$M, d = $e517caada390a624$var$Uh(), e = b(), f = !$e517caada390a624$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $e517caada390a624$var$dh = !0);
    d = d.queue;
    $e517caada390a624$var$$h($e517caada390a624$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $e517caada390a624$var$O && $e517caada390a624$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $e517caada390a624$var$bi(9, $e517caada390a624$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $e517caada390a624$var$Q) throw Error($e517caada390a624$var$p(349));
        0 !== ($e517caada390a624$var$Hh & 30) || $e517caada390a624$var$di(c, b, e);
    }
    return e;
}
function $e517caada390a624$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $e517caada390a624$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e517caada390a624$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $e517caada390a624$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $e517caada390a624$var$ei(b) && $e517caada390a624$var$fi(a);
}
function $e517caada390a624$var$ai(a, b, c) {
    return c(function() {
        $e517caada390a624$var$ei(b) && $e517caada390a624$var$fi(a);
    });
}
function $e517caada390a624$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$e517caada390a624$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $e517caada390a624$var$fi(a) {
    var b = $e517caada390a624$var$ih(a, 1);
    null !== b && $e517caada390a624$var$gi(b, a, 1, -1);
}
function $e517caada390a624$var$hi(a) {
    var b = $e517caada390a624$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $e517caada390a624$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $e517caada390a624$var$ii.bind(null, $e517caada390a624$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $e517caada390a624$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $e517caada390a624$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e517caada390a624$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $e517caada390a624$var$ji() {
    return $e517caada390a624$var$Uh().memoizedState;
}
function $e517caada390a624$var$ki(a, b, c, d) {
    var e = $e517caada390a624$var$Th();
    $e517caada390a624$var$M.flags |= a;
    e.memoizedState = $e517caada390a624$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $e517caada390a624$var$li(a, b, c, d) {
    var e = $e517caada390a624$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $e517caada390a624$var$N) {
        var g = $e517caada390a624$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $e517caada390a624$var$Mh(d, g.deps)) {
            e.memoizedState = $e517caada390a624$var$bi(b, c, f, d);
            return;
        }
    }
    $e517caada390a624$var$M.flags |= a;
    e.memoizedState = $e517caada390a624$var$bi(1 | b, c, f, d);
}
function $e517caada390a624$var$mi(a, b) {
    return $e517caada390a624$var$ki(8390656, 8, a, b);
}
function $e517caada390a624$var$$h(a, b) {
    return $e517caada390a624$var$li(2048, 8, a, b);
}
function $e517caada390a624$var$ni(a, b) {
    return $e517caada390a624$var$li(4, 2, a, b);
}
function $e517caada390a624$var$oi(a, b) {
    return $e517caada390a624$var$li(4, 4, a, b);
}
function $e517caada390a624$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $e517caada390a624$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $e517caada390a624$var$li(4, 4, $e517caada390a624$var$pi.bind(null, b, a), c);
}
function $e517caada390a624$var$ri() {}
function $e517caada390a624$var$si(a, b) {
    var c = $e517caada390a624$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e517caada390a624$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e517caada390a624$var$ti(a, b) {
    var c = $e517caada390a624$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e517caada390a624$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e517caada390a624$var$ui(a, b, c) {
    if (0 === ($e517caada390a624$var$Hh & 21)) return a.baseState && (a.baseState = !1, $e517caada390a624$var$dh = !0), a.memoizedState = c;
    $e517caada390a624$var$He(c, b) || (c = $e517caada390a624$var$yc(), $e517caada390a624$var$M.lanes |= c, $e517caada390a624$var$rh |= c, a.baseState = !0);
    return b;
}
function $e517caada390a624$var$vi(a, b) {
    var c = $e517caada390a624$var$C;
    $e517caada390a624$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $e517caada390a624$var$Gh.transition;
    $e517caada390a624$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $e517caada390a624$var$C = c, $e517caada390a624$var$Gh.transition = d;
    }
}
function $e517caada390a624$var$wi() {
    return $e517caada390a624$var$Uh().memoizedState;
}
function $e517caada390a624$var$xi(a, b, c) {
    var d = $e517caada390a624$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e517caada390a624$var$zi(a)) $e517caada390a624$var$Ai(b, c);
    else if (c = $e517caada390a624$var$hh(a, b, c, d), null !== c) {
        var e = $e517caada390a624$var$R();
        $e517caada390a624$var$gi(c, a, d, e);
        $e517caada390a624$var$Bi(c, b, d);
    }
}
function $e517caada390a624$var$ii(a, b, c) {
    var d = $e517caada390a624$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e517caada390a624$var$zi(a)) $e517caada390a624$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($e517caada390a624$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $e517caada390a624$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $e517caada390a624$var$hh(a, b, e, d);
        null !== c && (e = $e517caada390a624$var$R(), $e517caada390a624$var$gi(c, a, d, e), $e517caada390a624$var$Bi(c, b, d));
    }
}
function $e517caada390a624$var$zi(a) {
    var b = a.alternate;
    return a === $e517caada390a624$var$M || null !== b && b === $e517caada390a624$var$M;
}
function $e517caada390a624$var$Ai(a, b) {
    $e517caada390a624$var$Jh = $e517caada390a624$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $e517caada390a624$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e517caada390a624$var$Cc(a, c);
    }
}
var $e517caada390a624$var$Rh = {
    readContext: $e517caada390a624$var$eh,
    useCallback: $e517caada390a624$var$P,
    useContext: $e517caada390a624$var$P,
    useEffect: $e517caada390a624$var$P,
    useImperativeHandle: $e517caada390a624$var$P,
    useInsertionEffect: $e517caada390a624$var$P,
    useLayoutEffect: $e517caada390a624$var$P,
    useMemo: $e517caada390a624$var$P,
    useReducer: $e517caada390a624$var$P,
    useRef: $e517caada390a624$var$P,
    useState: $e517caada390a624$var$P,
    useDebugValue: $e517caada390a624$var$P,
    useDeferredValue: $e517caada390a624$var$P,
    useTransition: $e517caada390a624$var$P,
    useMutableSource: $e517caada390a624$var$P,
    useSyncExternalStore: $e517caada390a624$var$P,
    useId: $e517caada390a624$var$P,
    unstable_isNewReconciler: !1
}, $e517caada390a624$var$Oh = {
    readContext: $e517caada390a624$var$eh,
    useCallback: function(a, b) {
        $e517caada390a624$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $e517caada390a624$var$eh,
    useEffect: $e517caada390a624$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $e517caada390a624$var$ki(4194308, 4, $e517caada390a624$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $e517caada390a624$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $e517caada390a624$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $e517caada390a624$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $e517caada390a624$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $e517caada390a624$var$xi.bind(null, $e517caada390a624$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $e517caada390a624$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $e517caada390a624$var$hi,
    useDebugValue: $e517caada390a624$var$ri,
    useDeferredValue: function(a) {
        return $e517caada390a624$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $e517caada390a624$var$hi(!1), b = a[0];
        a = $e517caada390a624$var$vi.bind(null, a[1]);
        $e517caada390a624$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $e517caada390a624$var$M, e = $e517caada390a624$var$Th();
        if ($e517caada390a624$var$I) {
            if (void 0 === c) throw Error($e517caada390a624$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $e517caada390a624$var$Q) throw Error($e517caada390a624$var$p(349));
            0 !== ($e517caada390a624$var$Hh & 30) || $e517caada390a624$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $e517caada390a624$var$mi($e517caada390a624$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $e517caada390a624$var$bi(9, $e517caada390a624$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $e517caada390a624$var$Th(), b = $e517caada390a624$var$Q.identifierPrefix;
        if ($e517caada390a624$var$I) {
            var c = $e517caada390a624$var$sg;
            var d = $e517caada390a624$var$rg;
            c = (d & ~(1 << 32 - $e517caada390a624$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $e517caada390a624$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $e517caada390a624$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $e517caada390a624$var$Ph = {
    readContext: $e517caada390a624$var$eh,
    useCallback: $e517caada390a624$var$si,
    useContext: $e517caada390a624$var$eh,
    useEffect: $e517caada390a624$var$$h,
    useImperativeHandle: $e517caada390a624$var$qi,
    useInsertionEffect: $e517caada390a624$var$ni,
    useLayoutEffect: $e517caada390a624$var$oi,
    useMemo: $e517caada390a624$var$ti,
    useReducer: $e517caada390a624$var$Wh,
    useRef: $e517caada390a624$var$ji,
    useState: function() {
        return $e517caada390a624$var$Wh($e517caada390a624$var$Vh);
    },
    useDebugValue: $e517caada390a624$var$ri,
    useDeferredValue: function(a) {
        var b = $e517caada390a624$var$Uh();
        return $e517caada390a624$var$ui(b, $e517caada390a624$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $e517caada390a624$var$Wh($e517caada390a624$var$Vh)[0], b = $e517caada390a624$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e517caada390a624$var$Yh,
    useSyncExternalStore: $e517caada390a624$var$Zh,
    useId: $e517caada390a624$var$wi,
    unstable_isNewReconciler: !1
}, $e517caada390a624$var$Qh = {
    readContext: $e517caada390a624$var$eh,
    useCallback: $e517caada390a624$var$si,
    useContext: $e517caada390a624$var$eh,
    useEffect: $e517caada390a624$var$$h,
    useImperativeHandle: $e517caada390a624$var$qi,
    useInsertionEffect: $e517caada390a624$var$ni,
    useLayoutEffect: $e517caada390a624$var$oi,
    useMemo: $e517caada390a624$var$ti,
    useReducer: $e517caada390a624$var$Xh,
    useRef: $e517caada390a624$var$ji,
    useState: function() {
        return $e517caada390a624$var$Xh($e517caada390a624$var$Vh);
    },
    useDebugValue: $e517caada390a624$var$ri,
    useDeferredValue: function(a) {
        var b = $e517caada390a624$var$Uh();
        return null === $e517caada390a624$var$N ? b.memoizedState = a : $e517caada390a624$var$ui(b, $e517caada390a624$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $e517caada390a624$var$Xh($e517caada390a624$var$Vh)[0], b = $e517caada390a624$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e517caada390a624$var$Yh,
    useSyncExternalStore: $e517caada390a624$var$Zh,
    useId: $e517caada390a624$var$wi,
    unstable_isNewReconciler: !1
};
function $e517caada390a624$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $e517caada390a624$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $e517caada390a624$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $e517caada390a624$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $e517caada390a624$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $e517caada390a624$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e517caada390a624$var$R(), e = $e517caada390a624$var$yi(a), f = $e517caada390a624$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e517caada390a624$var$nh(a, f, e);
        null !== b && ($e517caada390a624$var$gi(b, a, e, d), $e517caada390a624$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e517caada390a624$var$R(), e = $e517caada390a624$var$yi(a), f = $e517caada390a624$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e517caada390a624$var$nh(a, f, e);
        null !== b && ($e517caada390a624$var$gi(b, a, e, d), $e517caada390a624$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $e517caada390a624$var$R(), d = $e517caada390a624$var$yi(a), e = $e517caada390a624$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $e517caada390a624$var$nh(a, e, d);
        null !== b && ($e517caada390a624$var$gi(b, a, d, c), $e517caada390a624$var$oh(b, a, d));
    }
};
function $e517caada390a624$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$e517caada390a624$var$Ie(c, d) || !$e517caada390a624$var$Ie(e, f) : !0;
}
function $e517caada390a624$var$Gi(a, b, c) {
    var d = !1, e = $e517caada390a624$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $e517caada390a624$var$eh(f) : (e = $e517caada390a624$var$Zf(b) ? $e517caada390a624$var$Xf : $e517caada390a624$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $e517caada390a624$var$Yf(a, e) : $e517caada390a624$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $e517caada390a624$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $e517caada390a624$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $e517caada390a624$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $e517caada390a624$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $e517caada390a624$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $e517caada390a624$var$eh(f) : (f = $e517caada390a624$var$Zf(b) ? $e517caada390a624$var$Xf : $e517caada390a624$var$H.current, e.context = $e517caada390a624$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($e517caada390a624$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $e517caada390a624$var$Ei.enqueueReplaceState(e, e.state, null), $e517caada390a624$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $e517caada390a624$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $e517caada390a624$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $e517caada390a624$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $e517caada390a624$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $e517caada390a624$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $e517caada390a624$var$Ni(a, b, c) {
    c = $e517caada390a624$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $e517caada390a624$var$Oi || ($e517caada390a624$var$Oi = !0, $e517caada390a624$var$Pi = d);
        $e517caada390a624$var$Li(a, b);
    };
    return c;
}
function $e517caada390a624$var$Qi(a, b, c) {
    c = $e517caada390a624$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $e517caada390a624$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $e517caada390a624$var$Li(a, b);
        "function" !== typeof d && (null === $e517caada390a624$var$Ri ? $e517caada390a624$var$Ri = new Set([
            this
        ]) : $e517caada390a624$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $e517caada390a624$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $e517caada390a624$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $e517caada390a624$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $e517caada390a624$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $e517caada390a624$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $e517caada390a624$var$mh(-1, 1), b.tag = 2, $e517caada390a624$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $e517caada390a624$var$Wi = $e517caada390a624$var$ua.ReactCurrentOwner, $e517caada390a624$var$dh = !1;
function $e517caada390a624$var$Xi(a, b, c, d) {
    b.child = null === a ? $e517caada390a624$var$Vg(b, null, c, d) : $e517caada390a624$var$Ug(b, a.child, c, d);
}
function $e517caada390a624$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $e517caada390a624$var$ch(b, e);
    d = $e517caada390a624$var$Nh(a, b, c, d, f, e);
    c = $e517caada390a624$var$Sh();
    if (null !== a && !$e517caada390a624$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e517caada390a624$var$Zi(a, b, e);
    $e517caada390a624$var$I && c && $e517caada390a624$var$vg(b);
    b.flags |= 1;
    $e517caada390a624$var$Xi(a, b, d, e);
    return b.child;
}
function $e517caada390a624$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$e517caada390a624$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $e517caada390a624$var$bj(a, b, f, d, e);
        a = $e517caada390a624$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $e517caada390a624$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $e517caada390a624$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $e517caada390a624$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $e517caada390a624$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($e517caada390a624$var$Ie(f, d) && a.ref === b.ref) {
            if ($e517caada390a624$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($e517caada390a624$var$dh = !0);
            else return b.lanes = a.lanes, $e517caada390a624$var$Zi(a, b, e);
        }
    }
    return $e517caada390a624$var$cj(a, b, c, d, e);
}
function $e517caada390a624$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $e517caada390a624$var$G($e517caada390a624$var$ej, $e517caada390a624$var$fj), $e517caada390a624$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $e517caada390a624$var$G($e517caada390a624$var$ej, $e517caada390a624$var$fj), $e517caada390a624$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $e517caada390a624$var$G($e517caada390a624$var$ej, $e517caada390a624$var$fj);
            $e517caada390a624$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $e517caada390a624$var$G($e517caada390a624$var$ej, $e517caada390a624$var$fj), $e517caada390a624$var$fj |= d;
    $e517caada390a624$var$Xi(a, b, e, c);
    return b.child;
}
function $e517caada390a624$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $e517caada390a624$var$cj(a, b, c, d, e) {
    var f = $e517caada390a624$var$Zf(c) ? $e517caada390a624$var$Xf : $e517caada390a624$var$H.current;
    f = $e517caada390a624$var$Yf(b, f);
    $e517caada390a624$var$ch(b, e);
    c = $e517caada390a624$var$Nh(a, b, c, d, f, e);
    d = $e517caada390a624$var$Sh();
    if (null !== a && !$e517caada390a624$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e517caada390a624$var$Zi(a, b, e);
    $e517caada390a624$var$I && d && $e517caada390a624$var$vg(b);
    b.flags |= 1;
    $e517caada390a624$var$Xi(a, b, c, e);
    return b.child;
}
function $e517caada390a624$var$hj(a, b, c, d, e) {
    if ($e517caada390a624$var$Zf(c)) {
        var f = !0;
        $e517caada390a624$var$cg(b);
    } else f = !1;
    $e517caada390a624$var$ch(b, e);
    if (null === b.stateNode) $e517caada390a624$var$ij(a, b), $e517caada390a624$var$Gi(b, c, d), $e517caada390a624$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $e517caada390a624$var$eh(l) : (l = $e517caada390a624$var$Zf(c) ? $e517caada390a624$var$Xf : $e517caada390a624$var$H.current, l = $e517caada390a624$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $e517caada390a624$var$Hi(b, g, d, l);
        $e517caada390a624$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $e517caada390a624$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $e517caada390a624$var$Wf.current || $e517caada390a624$var$jh ? ("function" === typeof m && ($e517caada390a624$var$Di(b, c, m, d), k = b.memoizedState), (h = $e517caada390a624$var$jh || $e517caada390a624$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $e517caada390a624$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $e517caada390a624$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $e517caada390a624$var$eh(k) : (k = $e517caada390a624$var$Zf(c) ? $e517caada390a624$var$Xf : $e517caada390a624$var$H.current, k = $e517caada390a624$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $e517caada390a624$var$Hi(b, g, d, k);
        $e517caada390a624$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $e517caada390a624$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $e517caada390a624$var$Wf.current || $e517caada390a624$var$jh ? ("function" === typeof y && ($e517caada390a624$var$Di(b, c, y, d), n = b.memoizedState), (l = $e517caada390a624$var$jh || $e517caada390a624$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $e517caada390a624$var$jj(a, b, c, d, f, e);
}
function $e517caada390a624$var$jj(a, b, c, d, e, f) {
    $e517caada390a624$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $e517caada390a624$var$dg(b, c, !1), $e517caada390a624$var$Zi(a, b, f);
    d = b.stateNode;
    $e517caada390a624$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $e517caada390a624$var$Ug(b, a.child, null, f), b.child = $e517caada390a624$var$Ug(b, null, h, f)) : $e517caada390a624$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $e517caada390a624$var$dg(b, c, !0);
    return b.child;
}
function $e517caada390a624$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $e517caada390a624$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $e517caada390a624$var$ag(a, b.context, !1);
    $e517caada390a624$var$yh(a, b.containerInfo);
}
function $e517caada390a624$var$lj(a, b, c, d, e) {
    $e517caada390a624$var$Ig();
    $e517caada390a624$var$Jg(e);
    b.flags |= 256;
    $e517caada390a624$var$Xi(a, b, c, d);
    return b.child;
}
var $e517caada390a624$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $e517caada390a624$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $e517caada390a624$var$oj(a, b, c) {
    var d = b.pendingProps, e = $e517caada390a624$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $e517caada390a624$var$G($e517caada390a624$var$L, e & 1);
    if (null === a) {
        $e517caada390a624$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $e517caada390a624$var$pj(g, d, 0, null), a = $e517caada390a624$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $e517caada390a624$var$nj(c), b.memoizedState = $e517caada390a624$var$mj, a) : $e517caada390a624$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $e517caada390a624$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $e517caada390a624$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $e517caada390a624$var$Pg(h, f) : (f = $e517caada390a624$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $e517caada390a624$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $e517caada390a624$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $e517caada390a624$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $e517caada390a624$var$qj(a, b) {
    b = $e517caada390a624$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $e517caada390a624$var$sj(a, b, c, d) {
    null !== d && $e517caada390a624$var$Jg(d);
    $e517caada390a624$var$Ug(b, a.child, null, c);
    a = $e517caada390a624$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $e517caada390a624$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $e517caada390a624$var$Ki(Error($e517caada390a624$var$p(422))), $e517caada390a624$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $e517caada390a624$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $e517caada390a624$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $e517caada390a624$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $e517caada390a624$var$nj(g);
        b.memoizedState = $e517caada390a624$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $e517caada390a624$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($e517caada390a624$var$p(419));
        d = $e517caada390a624$var$Ki(f, d, void 0);
        return $e517caada390a624$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($e517caada390a624$var$dh || h) {
        d = $e517caada390a624$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $e517caada390a624$var$ih(a, e), $e517caada390a624$var$gi(d, a, e, -1));
        }
        $e517caada390a624$var$tj();
        d = $e517caada390a624$var$Ki(Error($e517caada390a624$var$p(421)));
        return $e517caada390a624$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $e517caada390a624$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $e517caada390a624$var$yg = $e517caada390a624$var$Lf(e.nextSibling);
    $e517caada390a624$var$xg = b;
    $e517caada390a624$var$I = !0;
    $e517caada390a624$var$zg = null;
    null !== a && ($e517caada390a624$var$og[$e517caada390a624$var$pg++] = $e517caada390a624$var$rg, $e517caada390a624$var$og[$e517caada390a624$var$pg++] = $e517caada390a624$var$sg, $e517caada390a624$var$og[$e517caada390a624$var$pg++] = $e517caada390a624$var$qg, $e517caada390a624$var$rg = a.id, $e517caada390a624$var$sg = a.overflow, $e517caada390a624$var$qg = b);
    b = $e517caada390a624$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $e517caada390a624$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $e517caada390a624$var$bh(a.return, b, c);
}
function $e517caada390a624$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $e517caada390a624$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $e517caada390a624$var$Xi(a, b, d.children, c);
    d = $e517caada390a624$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $e517caada390a624$var$vj(a, c, b);
            else if (19 === a.tag) $e517caada390a624$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $e517caada390a624$var$G($e517caada390a624$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $e517caada390a624$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $e517caada390a624$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $e517caada390a624$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $e517caada390a624$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $e517caada390a624$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $e517caada390a624$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $e517caada390a624$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $e517caada390a624$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($e517caada390a624$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $e517caada390a624$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $e517caada390a624$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $e517caada390a624$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $e517caada390a624$var$kj(b);
            $e517caada390a624$var$Ig();
            break;
        case 5:
            $e517caada390a624$var$Ah(b);
            break;
        case 1:
            $e517caada390a624$var$Zf(b.type) && $e517caada390a624$var$cg(b);
            break;
        case 4:
            $e517caada390a624$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $e517caada390a624$var$G($e517caada390a624$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $e517caada390a624$var$G($e517caada390a624$var$L, $e517caada390a624$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $e517caada390a624$var$oj(a, b, c);
                $e517caada390a624$var$G($e517caada390a624$var$L, $e517caada390a624$var$L.current & 1);
                a = $e517caada390a624$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $e517caada390a624$var$G($e517caada390a624$var$L, $e517caada390a624$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $e517caada390a624$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $e517caada390a624$var$G($e517caada390a624$var$L, $e517caada390a624$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $e517caada390a624$var$dj(a, b, c);
    }
    return $e517caada390a624$var$Zi(a, b, c);
}
var $e517caada390a624$var$zj, $e517caada390a624$var$Aj, $e517caada390a624$var$Bj, $e517caada390a624$var$Cj;
$e517caada390a624$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$e517caada390a624$var$Aj = function() {};
$e517caada390a624$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $e517caada390a624$var$xh($e517caada390a624$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $e517caada390a624$var$Ya(a, e);
                d = $e517caada390a624$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $e517caada390a624$var$A({}, e, {
                    value: void 0
                });
                d = $e517caada390a624$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $e517caada390a624$var$gb(a, e);
                d = $e517caada390a624$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $e517caada390a624$var$Bf);
        }
        $e517caada390a624$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($e517caada390a624$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($e517caada390a624$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $e517caada390a624$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$e517caada390a624$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $e517caada390a624$var$Dj(a, b) {
    if (!$e517caada390a624$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $e517caada390a624$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $e517caada390a624$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $e517caada390a624$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $e517caada390a624$var$S(b), null;
        case 1:
            return $e517caada390a624$var$Zf(b.type) && $e517caada390a624$var$$f(), $e517caada390a624$var$S(b), null;
        case 3:
            d = b.stateNode;
            $e517caada390a624$var$zh();
            $e517caada390a624$var$E($e517caada390a624$var$Wf);
            $e517caada390a624$var$E($e517caada390a624$var$H);
            $e517caada390a624$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $e517caada390a624$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $e517caada390a624$var$zg && ($e517caada390a624$var$Fj($e517caada390a624$var$zg), $e517caada390a624$var$zg = null));
            $e517caada390a624$var$Aj(a, b);
            $e517caada390a624$var$S(b);
            return null;
        case 5:
            $e517caada390a624$var$Bh(b);
            var e = $e517caada390a624$var$xh($e517caada390a624$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $e517caada390a624$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($e517caada390a624$var$p(166));
                    $e517caada390a624$var$S(b);
                    return null;
                }
                a = $e517caada390a624$var$xh($e517caada390a624$var$uh.current);
                if ($e517caada390a624$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$e517caada390a624$var$Of] = b;
                    d[$e517caada390a624$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $e517caada390a624$var$D("cancel", d);
                            $e517caada390a624$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $e517caada390a624$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $e517caada390a624$var$lf.length; e++)$e517caada390a624$var$D($e517caada390a624$var$lf[e], d);
                            break;
                        case "source":
                            $e517caada390a624$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $e517caada390a624$var$D("error", d);
                            $e517caada390a624$var$D("load", d);
                            break;
                        case "details":
                            $e517caada390a624$var$D("toggle", d);
                            break;
                        case "input":
                            $e517caada390a624$var$Za(d, f);
                            $e517caada390a624$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $e517caada390a624$var$D("invalid", d);
                            break;
                        case "textarea":
                            $e517caada390a624$var$hb(d, f), $e517caada390a624$var$D("invalid", d);
                    }
                    $e517caada390a624$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $e517caada390a624$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $e517caada390a624$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $e517caada390a624$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $e517caada390a624$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $e517caada390a624$var$Va(d);
                            $e517caada390a624$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $e517caada390a624$var$Va(d);
                            $e517caada390a624$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $e517caada390a624$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $e517caada390a624$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$e517caada390a624$var$Of] = b;
                    a[$e517caada390a624$var$Pf] = d;
                    $e517caada390a624$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $e517caada390a624$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $e517caada390a624$var$D("cancel", a);
                                $e517caada390a624$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $e517caada390a624$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $e517caada390a624$var$lf.length; e++)$e517caada390a624$var$D($e517caada390a624$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $e517caada390a624$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $e517caada390a624$var$D("error", a);
                                $e517caada390a624$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $e517caada390a624$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $e517caada390a624$var$Za(a, d);
                                e = $e517caada390a624$var$Ya(a, d);
                                $e517caada390a624$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $e517caada390a624$var$A({}, d, {
                                    value: void 0
                                });
                                $e517caada390a624$var$D("invalid", a);
                                break;
                            case "textarea":
                                $e517caada390a624$var$hb(a, d);
                                e = $e517caada390a624$var$gb(a, d);
                                $e517caada390a624$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $e517caada390a624$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $e517caada390a624$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $e517caada390a624$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $e517caada390a624$var$ob(a, k) : "number" === typeof k && $e517caada390a624$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($e517caada390a624$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $e517caada390a624$var$D("scroll", a) : null != k && $e517caada390a624$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $e517caada390a624$var$Va(a);
                                $e517caada390a624$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $e517caada390a624$var$Va(a);
                                $e517caada390a624$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $e517caada390a624$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $e517caada390a624$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $e517caada390a624$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $e517caada390a624$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $e517caada390a624$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $e517caada390a624$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($e517caada390a624$var$p(166));
                c = $e517caada390a624$var$xh($e517caada390a624$var$wh.current);
                $e517caada390a624$var$xh($e517caada390a624$var$uh.current);
                if ($e517caada390a624$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$e517caada390a624$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $e517caada390a624$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $e517caada390a624$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $e517caada390a624$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$e517caada390a624$var$Of] = b, b.stateNode = d;
            }
            $e517caada390a624$var$S(b);
            return null;
        case 13:
            $e517caada390a624$var$E($e517caada390a624$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($e517caada390a624$var$I && null !== $e517caada390a624$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $e517caada390a624$var$Hg(), $e517caada390a624$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $e517caada390a624$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($e517caada390a624$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($e517caada390a624$var$p(317));
                        f[$e517caada390a624$var$Of] = b;
                    } else $e517caada390a624$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $e517caada390a624$var$S(b);
                    f = !1;
                } else null !== $e517caada390a624$var$zg && ($e517caada390a624$var$Fj($e517caada390a624$var$zg), $e517caada390a624$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($e517caada390a624$var$L.current & 1) ? 0 === $e517caada390a624$var$T && ($e517caada390a624$var$T = 3) : $e517caada390a624$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $e517caada390a624$var$S(b);
            return null;
        case 4:
            return $e517caada390a624$var$zh(), $e517caada390a624$var$Aj(a, b), null === a && $e517caada390a624$var$sf(b.stateNode.containerInfo), $e517caada390a624$var$S(b), null;
        case 10:
            return $e517caada390a624$var$ah(b.type._context), $e517caada390a624$var$S(b), null;
        case 17:
            return $e517caada390a624$var$Zf(b.type) && $e517caada390a624$var$$f(), $e517caada390a624$var$S(b), null;
        case 19:
            $e517caada390a624$var$E($e517caada390a624$var$L);
            f = b.memoizedState;
            if (null === f) return $e517caada390a624$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $e517caada390a624$var$Dj(f, !1);
                else {
                    if (0 !== $e517caada390a624$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $e517caada390a624$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $e517caada390a624$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $e517caada390a624$var$G($e517caada390a624$var$L, $e517caada390a624$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $e517caada390a624$var$B() > $e517caada390a624$var$Gj && (b.flags |= 128, d = !0, $e517caada390a624$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $e517caada390a624$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $e517caada390a624$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$e517caada390a624$var$I) return $e517caada390a624$var$S(b), null;
                    } else 2 * $e517caada390a624$var$B() - f.renderingStartTime > $e517caada390a624$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $e517caada390a624$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $e517caada390a624$var$B(), b.sibling = null, c = $e517caada390a624$var$L.current, $e517caada390a624$var$G($e517caada390a624$var$L, d ? c & 1 | 2 : c & 1), b;
            $e517caada390a624$var$S(b);
            return null;
        case 22:
        case 23:
            return $e517caada390a624$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($e517caada390a624$var$fj & 1073741824) && ($e517caada390a624$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $e517caada390a624$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($e517caada390a624$var$p(156, b.tag));
}
function $e517caada390a624$var$Ij(a, b) {
    $e517caada390a624$var$wg(b);
    switch(b.tag){
        case 1:
            return $e517caada390a624$var$Zf(b.type) && $e517caada390a624$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $e517caada390a624$var$zh(), $e517caada390a624$var$E($e517caada390a624$var$Wf), $e517caada390a624$var$E($e517caada390a624$var$H), $e517caada390a624$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $e517caada390a624$var$Bh(b), null;
        case 13:
            $e517caada390a624$var$E($e517caada390a624$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($e517caada390a624$var$p(340));
                $e517caada390a624$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $e517caada390a624$var$E($e517caada390a624$var$L), null;
        case 4:
            return $e517caada390a624$var$zh(), null;
        case 10:
            return $e517caada390a624$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $e517caada390a624$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $e517caada390a624$var$Jj = !1, $e517caada390a624$var$U = !1, $e517caada390a624$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $e517caada390a624$var$V = null;
function $e517caada390a624$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $e517caada390a624$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $e517caada390a624$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $e517caada390a624$var$W(a, b, d);
    }
}
var $e517caada390a624$var$Nj = !1;
function $e517caada390a624$var$Oj(a, b) {
    $e517caada390a624$var$Cf = $e517caada390a624$var$dd;
    a = $e517caada390a624$var$Me();
    if ($e517caada390a624$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $e517caada390a624$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $e517caada390a624$var$dd = !1;
    for($e517caada390a624$var$V = b; null !== $e517caada390a624$var$V;)if (b = $e517caada390a624$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $e517caada390a624$var$V = a;
    else for(; null !== $e517caada390a624$var$V;){
        b = $e517caada390a624$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $e517caada390a624$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($e517caada390a624$var$p(163));
            }
        } catch (F) {
            $e517caada390a624$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $e517caada390a624$var$V = a;
            break;
        }
        $e517caada390a624$var$V = b.return;
    }
    n = $e517caada390a624$var$Nj;
    $e517caada390a624$var$Nj = !1;
    return n;
}
function $e517caada390a624$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $e517caada390a624$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $e517caada390a624$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $e517caada390a624$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $e517caada390a624$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $e517caada390a624$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$e517caada390a624$var$Of], delete b[$e517caada390a624$var$Pf], delete b[$e517caada390a624$var$of], delete b[$e517caada390a624$var$Qf], delete b[$e517caada390a624$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $e517caada390a624$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $e517caada390a624$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $e517caada390a624$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $e517caada390a624$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $e517caada390a624$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($e517caada390a624$var$Vj(a, b, c), a = a.sibling; null !== a;)$e517caada390a624$var$Vj(a, b, c), a = a.sibling;
}
function $e517caada390a624$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($e517caada390a624$var$Wj(a, b, c), a = a.sibling; null !== a;)$e517caada390a624$var$Wj(a, b, c), a = a.sibling;
}
var $e517caada390a624$var$X = null, $e517caada390a624$var$Xj = !1;
function $e517caada390a624$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$e517caada390a624$var$Zj(a, b, c), c = c.sibling;
}
function $e517caada390a624$var$Zj(a, b, c) {
    if ($e517caada390a624$var$lc && "function" === typeof $e517caada390a624$var$lc.onCommitFiberUnmount) try {
        $e517caada390a624$var$lc.onCommitFiberUnmount($e517caada390a624$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $e517caada390a624$var$U || $e517caada390a624$var$Lj(c, b);
        case 6:
            var d = $e517caada390a624$var$X, e = $e517caada390a624$var$Xj;
            $e517caada390a624$var$X = null;
            $e517caada390a624$var$Yj(a, b, c);
            $e517caada390a624$var$X = d;
            $e517caada390a624$var$Xj = e;
            null !== $e517caada390a624$var$X && ($e517caada390a624$var$Xj ? (a = $e517caada390a624$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $e517caada390a624$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $e517caada390a624$var$X && ($e517caada390a624$var$Xj ? (a = $e517caada390a624$var$X, c = c.stateNode, 8 === a.nodeType ? $e517caada390a624$var$Kf(a.parentNode, c) : 1 === a.nodeType && $e517caada390a624$var$Kf(a, c), $e517caada390a624$var$bd(a)) : $e517caada390a624$var$Kf($e517caada390a624$var$X, c.stateNode));
            break;
        case 4:
            d = $e517caada390a624$var$X;
            e = $e517caada390a624$var$Xj;
            $e517caada390a624$var$X = c.stateNode.containerInfo;
            $e517caada390a624$var$Xj = !0;
            $e517caada390a624$var$Yj(a, b, c);
            $e517caada390a624$var$X = d;
            $e517caada390a624$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$e517caada390a624$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $e517caada390a624$var$Mj(c, b, g) : 0 !== (f & 4) && $e517caada390a624$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $e517caada390a624$var$Yj(a, b, c);
            break;
        case 1:
            if (!$e517caada390a624$var$U && ($e517caada390a624$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $e517caada390a624$var$W(c, b, h);
            }
            $e517caada390a624$var$Yj(a, b, c);
            break;
        case 21:
            $e517caada390a624$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($e517caada390a624$var$U = (d = $e517caada390a624$var$U) || null !== c.memoizedState, $e517caada390a624$var$Yj(a, b, c), $e517caada390a624$var$U = d) : $e517caada390a624$var$Yj(a, b, c);
            break;
        default:
            $e517caada390a624$var$Yj(a, b, c);
    }
}
function $e517caada390a624$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $e517caada390a624$var$Kj);
        b.forEach(function(b) {
            var d = $e517caada390a624$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $e517caada390a624$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $e517caada390a624$var$X = h.stateNode;
                        $e517caada390a624$var$Xj = !1;
                        break a;
                    case 3:
                        $e517caada390a624$var$X = h.stateNode.containerInfo;
                        $e517caada390a624$var$Xj = !0;
                        break a;
                    case 4:
                        $e517caada390a624$var$X = h.stateNode.containerInfo;
                        $e517caada390a624$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $e517caada390a624$var$X) throw Error($e517caada390a624$var$p(160));
            $e517caada390a624$var$Zj(f, g, e);
            $e517caada390a624$var$X = null;
            $e517caada390a624$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $e517caada390a624$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$e517caada390a624$var$dk(b, a), b = b.sibling;
}
function $e517caada390a624$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $e517caada390a624$var$ck(b, a);
            $e517caada390a624$var$ek(a);
            if (d & 4) {
                try {
                    $e517caada390a624$var$Pj(3, a, a.return), $e517caada390a624$var$Qj(3, a);
                } catch (t) {
                    $e517caada390a624$var$W(a, a.return, t);
                }
                try {
                    $e517caada390a624$var$Pj(5, a, a.return);
                } catch (t) {
                    $e517caada390a624$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $e517caada390a624$var$ck(b, a);
            $e517caada390a624$var$ek(a);
            d & 512 && null !== c && $e517caada390a624$var$Lj(c, c.return);
            break;
        case 5:
            $e517caada390a624$var$ck(b, a);
            $e517caada390a624$var$ek(a);
            d & 512 && null !== c && $e517caada390a624$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $e517caada390a624$var$ob(e, "");
                } catch (t) {
                    $e517caada390a624$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $e517caada390a624$var$ab(e, f);
                    $e517caada390a624$var$vb(h, g);
                    var l = $e517caada390a624$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $e517caada390a624$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $e517caada390a624$var$nb(e, q) : "children" === m ? $e517caada390a624$var$ob(e, q) : $e517caada390a624$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $e517caada390a624$var$bb(e, f);
                            break;
                        case "textarea":
                            $e517caada390a624$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $e517caada390a624$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $e517caada390a624$var$fb(e, !!f.multiple, f.defaultValue, !0) : $e517caada390a624$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$e517caada390a624$var$Pf] = f;
                } catch (t) {
                    $e517caada390a624$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $e517caada390a624$var$ck(b, a);
            $e517caada390a624$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($e517caada390a624$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $e517caada390a624$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $e517caada390a624$var$ck(b, a);
            $e517caada390a624$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $e517caada390a624$var$bd(b.containerInfo);
            } catch (t) {
                $e517caada390a624$var$W(a, a.return, t);
            }
            break;
        case 4:
            $e517caada390a624$var$ck(b, a);
            $e517caada390a624$var$ek(a);
            break;
        case 13:
            $e517caada390a624$var$ck(b, a);
            $e517caada390a624$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($e517caada390a624$var$fk = $e517caada390a624$var$B()));
            d & 4 && $e517caada390a624$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($e517caada390a624$var$U = (l = $e517caada390a624$var$U) || m, $e517caada390a624$var$ck(b, a), $e517caada390a624$var$U = l) : $e517caada390a624$var$ck(b, a);
            $e517caada390a624$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($e517caada390a624$var$V = a, m = a.child; null !== m;){
                    for(q = $e517caada390a624$var$V = m; null !== $e517caada390a624$var$V;){
                        r = $e517caada390a624$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $e517caada390a624$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $e517caada390a624$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $e517caada390a624$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $e517caada390a624$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $e517caada390a624$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $e517caada390a624$var$V = y) : $e517caada390a624$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $e517caada390a624$var$rb("display", g));
                            } catch (t) {
                                $e517caada390a624$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $e517caada390a624$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $e517caada390a624$var$ck(b, a);
            $e517caada390a624$var$ek(a);
            d & 4 && $e517caada390a624$var$ak(a);
            break;
        case 21:
            break;
        default:
            $e517caada390a624$var$ck(b, a), $e517caada390a624$var$ek(a);
    }
}
function $e517caada390a624$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($e517caada390a624$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($e517caada390a624$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($e517caada390a624$var$ob(e, ""), d.flags &= -33);
                    var f = $e517caada390a624$var$Uj(a);
                    $e517caada390a624$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $e517caada390a624$var$Uj(a);
                    $e517caada390a624$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($e517caada390a624$var$p(161));
            }
        } catch (k) {
            $e517caada390a624$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $e517caada390a624$var$hk(a, b, c) {
    $e517caada390a624$var$V = a;
    $e517caada390a624$var$ik(a, b, c);
}
function $e517caada390a624$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $e517caada390a624$var$V;){
        var e = $e517caada390a624$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $e517caada390a624$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $e517caada390a624$var$U;
                h = $e517caada390a624$var$Jj;
                var l = $e517caada390a624$var$U;
                $e517caada390a624$var$Jj = g;
                if (($e517caada390a624$var$U = k) && !l) for($e517caada390a624$var$V = e; null !== $e517caada390a624$var$V;)g = $e517caada390a624$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $e517caada390a624$var$jk(e) : null !== k ? (k.return = g, $e517caada390a624$var$V = k) : $e517caada390a624$var$jk(e);
                for(; null !== f;)$e517caada390a624$var$V = f, $e517caada390a624$var$ik(f, b, c), f = f.sibling;
                $e517caada390a624$var$V = e;
                $e517caada390a624$var$Jj = h;
                $e517caada390a624$var$U = l;
            }
            $e517caada390a624$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $e517caada390a624$var$V = f) : $e517caada390a624$var$kk(a, b, c);
    }
}
function $e517caada390a624$var$kk(a) {
    for(; null !== $e517caada390a624$var$V;){
        var b = $e517caada390a624$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $e517caada390a624$var$U || $e517caada390a624$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$e517caada390a624$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $e517caada390a624$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $e517caada390a624$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $e517caada390a624$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $e517caada390a624$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($e517caada390a624$var$p(163));
                }
                $e517caada390a624$var$U || b.flags & 512 && $e517caada390a624$var$Rj(b);
            } catch (r) {
                $e517caada390a624$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $e517caada390a624$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e517caada390a624$var$V = c;
            break;
        }
        $e517caada390a624$var$V = b.return;
    }
}
function $e517caada390a624$var$gk(a) {
    for(; null !== $e517caada390a624$var$V;){
        var b = $e517caada390a624$var$V;
        if (b === a) {
            $e517caada390a624$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e517caada390a624$var$V = c;
            break;
        }
        $e517caada390a624$var$V = b.return;
    }
}
function $e517caada390a624$var$jk(a) {
    for(; null !== $e517caada390a624$var$V;){
        var b = $e517caada390a624$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $e517caada390a624$var$Qj(4, b);
                    } catch (k) {
                        $e517caada390a624$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $e517caada390a624$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $e517caada390a624$var$Rj(b);
                    } catch (k) {
                        $e517caada390a624$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $e517caada390a624$var$Rj(b);
                    } catch (k) {
                        $e517caada390a624$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $e517caada390a624$var$W(b, b.return, k);
        }
        if (b === a) {
            $e517caada390a624$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $e517caada390a624$var$V = h;
            break;
        }
        $e517caada390a624$var$V = b.return;
    }
}
var $e517caada390a624$var$lk = Math.ceil, $e517caada390a624$var$mk = $e517caada390a624$var$ua.ReactCurrentDispatcher, $e517caada390a624$var$nk = $e517caada390a624$var$ua.ReactCurrentOwner, $e517caada390a624$var$ok = $e517caada390a624$var$ua.ReactCurrentBatchConfig, $e517caada390a624$var$K = 0, $e517caada390a624$var$Q = null, $e517caada390a624$var$Y = null, $e517caada390a624$var$Z = 0, $e517caada390a624$var$fj = 0, $e517caada390a624$var$ej = $e517caada390a624$var$Uf(0), $e517caada390a624$var$T = 0, $e517caada390a624$var$pk = null, $e517caada390a624$var$rh = 0, $e517caada390a624$var$qk = 0, $e517caada390a624$var$rk = 0, $e517caada390a624$var$sk = null, $e517caada390a624$var$tk = null, $e517caada390a624$var$fk = 0, $e517caada390a624$var$Gj = Infinity, $e517caada390a624$var$uk = null, $e517caada390a624$var$Oi = !1, $e517caada390a624$var$Pi = null, $e517caada390a624$var$Ri = null, $e517caada390a624$var$vk = !1, $e517caada390a624$var$wk = null, $e517caada390a624$var$xk = 0, $e517caada390a624$var$yk = 0, $e517caada390a624$var$zk = null, $e517caada390a624$var$Ak = -1, $e517caada390a624$var$Bk = 0;
function $e517caada390a624$var$R() {
    return 0 !== ($e517caada390a624$var$K & 6) ? $e517caada390a624$var$B() : -1 !== $e517caada390a624$var$Ak ? $e517caada390a624$var$Ak : $e517caada390a624$var$Ak = $e517caada390a624$var$B();
}
function $e517caada390a624$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($e517caada390a624$var$K & 2) && 0 !== $e517caada390a624$var$Z) return $e517caada390a624$var$Z & -$e517caada390a624$var$Z;
    if (null !== $e517caada390a624$var$Kg.transition) return 0 === $e517caada390a624$var$Bk && ($e517caada390a624$var$Bk = $e517caada390a624$var$yc()), $e517caada390a624$var$Bk;
    a = $e517caada390a624$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $e517caada390a624$var$jd(a.type);
    return a;
}
function $e517caada390a624$var$gi(a, b, c, d) {
    if (50 < $e517caada390a624$var$yk) throw $e517caada390a624$var$yk = 0, $e517caada390a624$var$zk = null, Error($e517caada390a624$var$p(185));
    $e517caada390a624$var$Ac(a, c, d);
    if (0 === ($e517caada390a624$var$K & 2) || a !== $e517caada390a624$var$Q) a === $e517caada390a624$var$Q && (0 === ($e517caada390a624$var$K & 2) && ($e517caada390a624$var$qk |= c), 4 === $e517caada390a624$var$T && $e517caada390a624$var$Ck(a, $e517caada390a624$var$Z)), $e517caada390a624$var$Dk(a, d), 1 === c && 0 === $e517caada390a624$var$K && 0 === (b.mode & 1) && ($e517caada390a624$var$Gj = $e517caada390a624$var$B() + 500, $e517caada390a624$var$fg && $e517caada390a624$var$jg());
}
function $e517caada390a624$var$Dk(a, b) {
    var c = a.callbackNode;
    $e517caada390a624$var$wc(a, b);
    var d = $e517caada390a624$var$uc(a, a === $e517caada390a624$var$Q ? $e517caada390a624$var$Z : 0);
    if (0 === d) null !== c && $e517caada390a624$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $e517caada390a624$var$bc(c);
        if (1 === b) 0 === a.tag ? $e517caada390a624$var$ig($e517caada390a624$var$Ek.bind(null, a)) : $e517caada390a624$var$hg($e517caada390a624$var$Ek.bind(null, a)), $e517caada390a624$var$Jf(function() {
            0 === ($e517caada390a624$var$K & 6) && $e517caada390a624$var$jg();
        }), c = null;
        else {
            switch($e517caada390a624$var$Dc(d)){
                case 1:
                    c = $e517caada390a624$var$fc;
                    break;
                case 4:
                    c = $e517caada390a624$var$gc;
                    break;
                case 16:
                    c = $e517caada390a624$var$hc;
                    break;
                case 536870912:
                    c = $e517caada390a624$var$jc;
                    break;
                default:
                    c = $e517caada390a624$var$hc;
            }
            c = $e517caada390a624$var$Fk(c, $e517caada390a624$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $e517caada390a624$var$Gk(a, b) {
    $e517caada390a624$var$Ak = -1;
    $e517caada390a624$var$Bk = 0;
    if (0 !== ($e517caada390a624$var$K & 6)) throw Error($e517caada390a624$var$p(327));
    var c = a.callbackNode;
    if ($e517caada390a624$var$Hk() && a.callbackNode !== c) return null;
    var d = $e517caada390a624$var$uc(a, a === $e517caada390a624$var$Q ? $e517caada390a624$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $e517caada390a624$var$Ik(a, d);
    else {
        b = d;
        var e = $e517caada390a624$var$K;
        $e517caada390a624$var$K |= 2;
        var f = $e517caada390a624$var$Jk();
        if ($e517caada390a624$var$Q !== a || $e517caada390a624$var$Z !== b) $e517caada390a624$var$uk = null, $e517caada390a624$var$Gj = $e517caada390a624$var$B() + 500, $e517caada390a624$var$Kk(a, b);
        for(;;)try {
            $e517caada390a624$var$Lk();
            break;
        } catch (h) {
            $e517caada390a624$var$Mk(a, h);
        }
        $e517caada390a624$var$$g();
        $e517caada390a624$var$mk.current = f;
        $e517caada390a624$var$K = e;
        null !== $e517caada390a624$var$Y ? b = 0 : ($e517caada390a624$var$Q = null, $e517caada390a624$var$Z = 0, b = $e517caada390a624$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $e517caada390a624$var$xc(a), 0 !== e && (d = e, b = $e517caada390a624$var$Nk(a, e)));
        if (1 === b) throw c = $e517caada390a624$var$pk, $e517caada390a624$var$Kk(a, 0), $e517caada390a624$var$Ck(a, d), $e517caada390a624$var$Dk(a, $e517caada390a624$var$B()), c;
        if (6 === b) $e517caada390a624$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$e517caada390a624$var$Ok(e) && (b = $e517caada390a624$var$Ik(a, d), 2 === b && (f = $e517caada390a624$var$xc(a), 0 !== f && (d = f, b = $e517caada390a624$var$Nk(a, f))), 1 === b)) throw c = $e517caada390a624$var$pk, $e517caada390a624$var$Kk(a, 0), $e517caada390a624$var$Ck(a, d), $e517caada390a624$var$Dk(a, $e517caada390a624$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($e517caada390a624$var$p(345));
                case 2:
                    $e517caada390a624$var$Pk(a, $e517caada390a624$var$tk, $e517caada390a624$var$uk);
                    break;
                case 3:
                    $e517caada390a624$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $e517caada390a624$var$fk + 500 - $e517caada390a624$var$B(), 10 < b)) {
                        if (0 !== $e517caada390a624$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $e517caada390a624$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $e517caada390a624$var$Ff($e517caada390a624$var$Pk.bind(null, a, $e517caada390a624$var$tk, $e517caada390a624$var$uk), b);
                        break;
                    }
                    $e517caada390a624$var$Pk(a, $e517caada390a624$var$tk, $e517caada390a624$var$uk);
                    break;
                case 4:
                    $e517caada390a624$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $e517caada390a624$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $e517caada390a624$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $e517caada390a624$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $e517caada390a624$var$Ff($e517caada390a624$var$Pk.bind(null, a, $e517caada390a624$var$tk, $e517caada390a624$var$uk), d);
                        break;
                    }
                    $e517caada390a624$var$Pk(a, $e517caada390a624$var$tk, $e517caada390a624$var$uk);
                    break;
                case 5:
                    $e517caada390a624$var$Pk(a, $e517caada390a624$var$tk, $e517caada390a624$var$uk);
                    break;
                default:
                    throw Error($e517caada390a624$var$p(329));
            }
        }
    }
    $e517caada390a624$var$Dk(a, $e517caada390a624$var$B());
    return a.callbackNode === c ? $e517caada390a624$var$Gk.bind(null, a) : null;
}
function $e517caada390a624$var$Nk(a, b) {
    var c = $e517caada390a624$var$sk;
    a.current.memoizedState.isDehydrated && ($e517caada390a624$var$Kk(a, b).flags |= 256);
    a = $e517caada390a624$var$Ik(a, b);
    2 !== a && (b = $e517caada390a624$var$tk, $e517caada390a624$var$tk = c, null !== b && $e517caada390a624$var$Fj(b));
    return a;
}
function $e517caada390a624$var$Fj(a) {
    null === $e517caada390a624$var$tk ? $e517caada390a624$var$tk = a : $e517caada390a624$var$tk.push.apply($e517caada390a624$var$tk, a);
}
function $e517caada390a624$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$e517caada390a624$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $e517caada390a624$var$Ck(a, b) {
    b &= ~$e517caada390a624$var$rk;
    b &= ~$e517caada390a624$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $e517caada390a624$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $e517caada390a624$var$Ek(a) {
    if (0 !== ($e517caada390a624$var$K & 6)) throw Error($e517caada390a624$var$p(327));
    $e517caada390a624$var$Hk();
    var b = $e517caada390a624$var$uc(a, 0);
    if (0 === (b & 1)) return $e517caada390a624$var$Dk(a, $e517caada390a624$var$B()), null;
    var c = $e517caada390a624$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $e517caada390a624$var$xc(a);
        0 !== d && (b = d, c = $e517caada390a624$var$Nk(a, d));
    }
    if (1 === c) throw c = $e517caada390a624$var$pk, $e517caada390a624$var$Kk(a, 0), $e517caada390a624$var$Ck(a, b), $e517caada390a624$var$Dk(a, $e517caada390a624$var$B()), c;
    if (6 === c) throw Error($e517caada390a624$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $e517caada390a624$var$Pk(a, $e517caada390a624$var$tk, $e517caada390a624$var$uk);
    $e517caada390a624$var$Dk(a, $e517caada390a624$var$B());
    return null;
}
function $e517caada390a624$var$Qk(a, b) {
    var c = $e517caada390a624$var$K;
    $e517caada390a624$var$K |= 1;
    try {
        return a(b);
    } finally{
        $e517caada390a624$var$K = c, 0 === $e517caada390a624$var$K && ($e517caada390a624$var$Gj = $e517caada390a624$var$B() + 500, $e517caada390a624$var$fg && $e517caada390a624$var$jg());
    }
}
function $e517caada390a624$var$Rk(a) {
    null !== $e517caada390a624$var$wk && 0 === $e517caada390a624$var$wk.tag && 0 === ($e517caada390a624$var$K & 6) && $e517caada390a624$var$Hk();
    var b = $e517caada390a624$var$K;
    $e517caada390a624$var$K |= 1;
    var c = $e517caada390a624$var$ok.transition, d = $e517caada390a624$var$C;
    try {
        if ($e517caada390a624$var$ok.transition = null, $e517caada390a624$var$C = 1, a) return a();
    } finally{
        $e517caada390a624$var$C = d, $e517caada390a624$var$ok.transition = c, $e517caada390a624$var$K = b, 0 === ($e517caada390a624$var$K & 6) && $e517caada390a624$var$jg();
    }
}
function $e517caada390a624$var$Hj() {
    $e517caada390a624$var$fj = $e517caada390a624$var$ej.current;
    $e517caada390a624$var$E($e517caada390a624$var$ej);
}
function $e517caada390a624$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $e517caada390a624$var$Gf(c));
    if (null !== $e517caada390a624$var$Y) for(c = $e517caada390a624$var$Y.return; null !== c;){
        var d = c;
        $e517caada390a624$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $e517caada390a624$var$$f();
                break;
            case 3:
                $e517caada390a624$var$zh();
                $e517caada390a624$var$E($e517caada390a624$var$Wf);
                $e517caada390a624$var$E($e517caada390a624$var$H);
                $e517caada390a624$var$Eh();
                break;
            case 5:
                $e517caada390a624$var$Bh(d);
                break;
            case 4:
                $e517caada390a624$var$zh();
                break;
            case 13:
                $e517caada390a624$var$E($e517caada390a624$var$L);
                break;
            case 19:
                $e517caada390a624$var$E($e517caada390a624$var$L);
                break;
            case 10:
                $e517caada390a624$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $e517caada390a624$var$Hj();
        }
        c = c.return;
    }
    $e517caada390a624$var$Q = a;
    $e517caada390a624$var$Y = a = $e517caada390a624$var$Pg(a.current, null);
    $e517caada390a624$var$Z = $e517caada390a624$var$fj = b;
    $e517caada390a624$var$T = 0;
    $e517caada390a624$var$pk = null;
    $e517caada390a624$var$rk = $e517caada390a624$var$qk = $e517caada390a624$var$rh = 0;
    $e517caada390a624$var$tk = $e517caada390a624$var$sk = null;
    if (null !== $e517caada390a624$var$fh) {
        for(b = 0; b < $e517caada390a624$var$fh.length; b++)if (c = $e517caada390a624$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $e517caada390a624$var$fh = null;
    }
    return a;
}
function $e517caada390a624$var$Mk(a, b) {
    do {
        var c = $e517caada390a624$var$Y;
        try {
            $e517caada390a624$var$$g();
            $e517caada390a624$var$Fh.current = $e517caada390a624$var$Rh;
            if ($e517caada390a624$var$Ih) {
                for(var d = $e517caada390a624$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $e517caada390a624$var$Ih = !1;
            }
            $e517caada390a624$var$Hh = 0;
            $e517caada390a624$var$O = $e517caada390a624$var$N = $e517caada390a624$var$M = null;
            $e517caada390a624$var$Jh = !1;
            $e517caada390a624$var$Kh = 0;
            $e517caada390a624$var$nk.current = null;
            if (null === c || null === c.return) {
                $e517caada390a624$var$T = 1;
                $e517caada390a624$var$pk = b;
                $e517caada390a624$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $e517caada390a624$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $e517caada390a624$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $e517caada390a624$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $e517caada390a624$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $e517caada390a624$var$Si(f, l, b);
                            $e517caada390a624$var$tj();
                            break a;
                        }
                        k = Error($e517caada390a624$var$p(426));
                    }
                } else if ($e517caada390a624$var$I && h.mode & 1) {
                    var J = $e517caada390a624$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $e517caada390a624$var$Vi(J, g, h, f, b);
                        $e517caada390a624$var$Jg($e517caada390a624$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $e517caada390a624$var$Ji(k, h);
                4 !== $e517caada390a624$var$T && ($e517caada390a624$var$T = 2);
                null === $e517caada390a624$var$sk ? $e517caada390a624$var$sk = [
                    f
                ] : $e517caada390a624$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $e517caada390a624$var$Ni(f, k, b);
                            $e517caada390a624$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $e517caada390a624$var$Ri || !$e517caada390a624$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $e517caada390a624$var$Qi(f, h, b);
                                $e517caada390a624$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $e517caada390a624$var$Sk(c);
        } catch (na) {
            b = na;
            $e517caada390a624$var$Y === c && null !== c && ($e517caada390a624$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $e517caada390a624$var$Jk() {
    var a = $e517caada390a624$var$mk.current;
    $e517caada390a624$var$mk.current = $e517caada390a624$var$Rh;
    return null === a ? $e517caada390a624$var$Rh : a;
}
function $e517caada390a624$var$tj() {
    if (0 === $e517caada390a624$var$T || 3 === $e517caada390a624$var$T || 2 === $e517caada390a624$var$T) $e517caada390a624$var$T = 4;
    null === $e517caada390a624$var$Q || 0 === ($e517caada390a624$var$rh & 268435455) && 0 === ($e517caada390a624$var$qk & 268435455) || $e517caada390a624$var$Ck($e517caada390a624$var$Q, $e517caada390a624$var$Z);
}
function $e517caada390a624$var$Ik(a, b) {
    var c = $e517caada390a624$var$K;
    $e517caada390a624$var$K |= 2;
    var d = $e517caada390a624$var$Jk();
    if ($e517caada390a624$var$Q !== a || $e517caada390a624$var$Z !== b) $e517caada390a624$var$uk = null, $e517caada390a624$var$Kk(a, b);
    for(;;)try {
        $e517caada390a624$var$Tk();
        break;
    } catch (e) {
        $e517caada390a624$var$Mk(a, e);
    }
    $e517caada390a624$var$$g();
    $e517caada390a624$var$K = c;
    $e517caada390a624$var$mk.current = d;
    if (null !== $e517caada390a624$var$Y) throw Error($e517caada390a624$var$p(261));
    $e517caada390a624$var$Q = null;
    $e517caada390a624$var$Z = 0;
    return $e517caada390a624$var$T;
}
function $e517caada390a624$var$Tk() {
    for(; null !== $e517caada390a624$var$Y;)$e517caada390a624$var$Uk($e517caada390a624$var$Y);
}
function $e517caada390a624$var$Lk() {
    for(; null !== $e517caada390a624$var$Y && !$e517caada390a624$var$cc();)$e517caada390a624$var$Uk($e517caada390a624$var$Y);
}
function $e517caada390a624$var$Uk(a) {
    var b = $e517caada390a624$var$Vk(a.alternate, a, $e517caada390a624$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $e517caada390a624$var$Sk(a) : $e517caada390a624$var$Y = b;
    $e517caada390a624$var$nk.current = null;
}
function $e517caada390a624$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $e517caada390a624$var$Ej(c, b, $e517caada390a624$var$fj), null !== c) {
                $e517caada390a624$var$Y = c;
                return;
            }
        } else {
            c = $e517caada390a624$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $e517caada390a624$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $e517caada390a624$var$T = 6;
                $e517caada390a624$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $e517caada390a624$var$Y = b;
            return;
        }
        $e517caada390a624$var$Y = b = a;
    }while (null !== b);
    0 === $e517caada390a624$var$T && ($e517caada390a624$var$T = 5);
}
function $e517caada390a624$var$Pk(a, b, c) {
    var d = $e517caada390a624$var$C, e = $e517caada390a624$var$ok.transition;
    try {
        $e517caada390a624$var$ok.transition = null, $e517caada390a624$var$C = 1, $e517caada390a624$var$Wk(a, b, c, d);
    } finally{
        $e517caada390a624$var$ok.transition = e, $e517caada390a624$var$C = d;
    }
    return null;
}
function $e517caada390a624$var$Wk(a, b, c, d) {
    do $e517caada390a624$var$Hk();
    while (null !== $e517caada390a624$var$wk);
    if (0 !== ($e517caada390a624$var$K & 6)) throw Error($e517caada390a624$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($e517caada390a624$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $e517caada390a624$var$Bc(a, f);
    a === $e517caada390a624$var$Q && ($e517caada390a624$var$Y = $e517caada390a624$var$Q = null, $e517caada390a624$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $e517caada390a624$var$vk || ($e517caada390a624$var$vk = !0, $e517caada390a624$var$Fk($e517caada390a624$var$hc, function() {
        $e517caada390a624$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $e517caada390a624$var$ok.transition;
        $e517caada390a624$var$ok.transition = null;
        var g = $e517caada390a624$var$C;
        $e517caada390a624$var$C = 1;
        var h = $e517caada390a624$var$K;
        $e517caada390a624$var$K |= 4;
        $e517caada390a624$var$nk.current = null;
        $e517caada390a624$var$Oj(a, c);
        $e517caada390a624$var$dk(c, a);
        $e517caada390a624$var$Oe($e517caada390a624$var$Df);
        $e517caada390a624$var$dd = !!$e517caada390a624$var$Cf;
        $e517caada390a624$var$Df = $e517caada390a624$var$Cf = null;
        a.current = c;
        $e517caada390a624$var$hk(c, a, e);
        $e517caada390a624$var$dc();
        $e517caada390a624$var$K = h;
        $e517caada390a624$var$C = g;
        $e517caada390a624$var$ok.transition = f;
    } else a.current = c;
    $e517caada390a624$var$vk && ($e517caada390a624$var$vk = !1, $e517caada390a624$var$wk = a, $e517caada390a624$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($e517caada390a624$var$Ri = null);
    $e517caada390a624$var$mc(c.stateNode, d);
    $e517caada390a624$var$Dk(a, $e517caada390a624$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($e517caada390a624$var$Oi) throw $e517caada390a624$var$Oi = !1, a = $e517caada390a624$var$Pi, $e517caada390a624$var$Pi = null, a;
    0 !== ($e517caada390a624$var$xk & 1) && 0 !== a.tag && $e517caada390a624$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $e517caada390a624$var$zk ? $e517caada390a624$var$yk++ : ($e517caada390a624$var$yk = 0, $e517caada390a624$var$zk = a) : $e517caada390a624$var$yk = 0;
    $e517caada390a624$var$jg();
    return null;
}
function $e517caada390a624$var$Hk() {
    if (null !== $e517caada390a624$var$wk) {
        var a = $e517caada390a624$var$Dc($e517caada390a624$var$xk), b = $e517caada390a624$var$ok.transition, c = $e517caada390a624$var$C;
        try {
            $e517caada390a624$var$ok.transition = null;
            $e517caada390a624$var$C = 16 > a ? 16 : a;
            if (null === $e517caada390a624$var$wk) var d = !1;
            else {
                a = $e517caada390a624$var$wk;
                $e517caada390a624$var$wk = null;
                $e517caada390a624$var$xk = 0;
                if (0 !== ($e517caada390a624$var$K & 6)) throw Error($e517caada390a624$var$p(331));
                var e = $e517caada390a624$var$K;
                $e517caada390a624$var$K |= 4;
                for($e517caada390a624$var$V = a.current; null !== $e517caada390a624$var$V;){
                    var f = $e517caada390a624$var$V, g = f.child;
                    if (0 !== ($e517caada390a624$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($e517caada390a624$var$V = l; null !== $e517caada390a624$var$V;){
                                    var m = $e517caada390a624$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $e517caada390a624$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $e517caada390a624$var$V = q;
                                    else for(; null !== $e517caada390a624$var$V;){
                                        m = $e517caada390a624$var$V;
                                        var r = m.sibling, y = m.return;
                                        $e517caada390a624$var$Sj(m);
                                        if (m === l) {
                                            $e517caada390a624$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $e517caada390a624$var$V = r;
                                            break;
                                        }
                                        $e517caada390a624$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $e517caada390a624$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $e517caada390a624$var$V = g;
                    else b: for(; null !== $e517caada390a624$var$V;){
                        f = $e517caada390a624$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $e517caada390a624$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $e517caada390a624$var$V = x;
                            break b;
                        }
                        $e517caada390a624$var$V = f.return;
                    }
                }
                var w = a.current;
                for($e517caada390a624$var$V = w; null !== $e517caada390a624$var$V;){
                    g = $e517caada390a624$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $e517caada390a624$var$V = u;
                    else b: for(g = w; null !== $e517caada390a624$var$V;){
                        h = $e517caada390a624$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $e517caada390a624$var$Qj(9, h);
                            }
                        } catch (na) {
                            $e517caada390a624$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $e517caada390a624$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $e517caada390a624$var$V = F;
                            break b;
                        }
                        $e517caada390a624$var$V = h.return;
                    }
                }
                $e517caada390a624$var$K = e;
                $e517caada390a624$var$jg();
                if ($e517caada390a624$var$lc && "function" === typeof $e517caada390a624$var$lc.onPostCommitFiberRoot) try {
                    $e517caada390a624$var$lc.onPostCommitFiberRoot($e517caada390a624$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $e517caada390a624$var$C = c, $e517caada390a624$var$ok.transition = b;
        }
    }
    return !1;
}
function $e517caada390a624$var$Xk(a, b, c) {
    b = $e517caada390a624$var$Ji(c, b);
    b = $e517caada390a624$var$Ni(a, b, 1);
    a = $e517caada390a624$var$nh(a, b, 1);
    b = $e517caada390a624$var$R();
    null !== a && ($e517caada390a624$var$Ac(a, 1, b), $e517caada390a624$var$Dk(a, b));
}
function $e517caada390a624$var$W(a, b, c) {
    if (3 === a.tag) $e517caada390a624$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $e517caada390a624$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $e517caada390a624$var$Ri || !$e517caada390a624$var$Ri.has(d))) {
                a = $e517caada390a624$var$Ji(c, a);
                a = $e517caada390a624$var$Qi(b, a, 1);
                b = $e517caada390a624$var$nh(b, a, 1);
                a = $e517caada390a624$var$R();
                null !== b && ($e517caada390a624$var$Ac(b, 1, a), $e517caada390a624$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $e517caada390a624$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $e517caada390a624$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $e517caada390a624$var$Q === a && ($e517caada390a624$var$Z & c) === c && (4 === $e517caada390a624$var$T || 3 === $e517caada390a624$var$T && ($e517caada390a624$var$Z & 130023424) === $e517caada390a624$var$Z && 500 > $e517caada390a624$var$B() - $e517caada390a624$var$fk ? $e517caada390a624$var$Kk(a, 0) : $e517caada390a624$var$rk |= c);
    $e517caada390a624$var$Dk(a, b);
}
function $e517caada390a624$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $e517caada390a624$var$sc, $e517caada390a624$var$sc <<= 1, 0 === ($e517caada390a624$var$sc & 130023424) && ($e517caada390a624$var$sc = 4194304)));
    var c = $e517caada390a624$var$R();
    a = $e517caada390a624$var$ih(a, b);
    null !== a && ($e517caada390a624$var$Ac(a, b, c), $e517caada390a624$var$Dk(a, c));
}
function $e517caada390a624$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $e517caada390a624$var$Yk(a, c);
}
function $e517caada390a624$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($e517caada390a624$var$p(314));
    }
    null !== d && d.delete(b);
    $e517caada390a624$var$Yk(a, c);
}
var $e517caada390a624$var$Vk;
$e517caada390a624$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $e517caada390a624$var$Wf.current) $e517caada390a624$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $e517caada390a624$var$dh = !1, $e517caada390a624$var$yj(a, b, c);
            $e517caada390a624$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $e517caada390a624$var$dh = !1, $e517caada390a624$var$I && 0 !== (b.flags & 1048576) && $e517caada390a624$var$ug(b, $e517caada390a624$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $e517caada390a624$var$ij(a, b);
            a = b.pendingProps;
            var e = $e517caada390a624$var$Yf(b, $e517caada390a624$var$H.current);
            $e517caada390a624$var$ch(b, c);
            e = $e517caada390a624$var$Nh(null, b, d, a, e, c);
            var f = $e517caada390a624$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $e517caada390a624$var$Zf(d) ? (f = !0, $e517caada390a624$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $e517caada390a624$var$kh(b), e.updater = $e517caada390a624$var$Ei, b.stateNode = e, e._reactInternals = b, $e517caada390a624$var$Ii(b, d, a, c), b = $e517caada390a624$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $e517caada390a624$var$I && f && $e517caada390a624$var$vg(b), $e517caada390a624$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $e517caada390a624$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $e517caada390a624$var$Zk(d);
                a = $e517caada390a624$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $e517caada390a624$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $e517caada390a624$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $e517caada390a624$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $e517caada390a624$var$$i(null, b, d, $e517caada390a624$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($e517caada390a624$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e517caada390a624$var$Ci(d, e), $e517caada390a624$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e517caada390a624$var$Ci(d, e), $e517caada390a624$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $e517caada390a624$var$kj(b);
                if (null === a) throw Error($e517caada390a624$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $e517caada390a624$var$lh(a, b);
                $e517caada390a624$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $e517caada390a624$var$Ji(Error($e517caada390a624$var$p(423)), b);
                        b = $e517caada390a624$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $e517caada390a624$var$Ji(Error($e517caada390a624$var$p(424)), b);
                        b = $e517caada390a624$var$lj(a, b, d, c, e);
                        break a;
                    } else for($e517caada390a624$var$yg = $e517caada390a624$var$Lf(b.stateNode.containerInfo.firstChild), $e517caada390a624$var$xg = b, $e517caada390a624$var$I = !0, $e517caada390a624$var$zg = null, c = $e517caada390a624$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $e517caada390a624$var$Ig();
                    if (d === e) {
                        b = $e517caada390a624$var$Zi(a, b, c);
                        break a;
                    }
                    $e517caada390a624$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $e517caada390a624$var$Ah(b), null === a && $e517caada390a624$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $e517caada390a624$var$Ef(d, e) ? g = null : null !== f && $e517caada390a624$var$Ef(d, f) && (b.flags |= 32), $e517caada390a624$var$gj(a, b), $e517caada390a624$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $e517caada390a624$var$Eg(b), null;
        case 13:
            return $e517caada390a624$var$oj(a, b, c);
        case 4:
            return $e517caada390a624$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $e517caada390a624$var$Ug(b, null, d, c) : $e517caada390a624$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e517caada390a624$var$Ci(d, e), $e517caada390a624$var$Yi(a, b, d, e, c);
        case 7:
            return $e517caada390a624$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $e517caada390a624$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $e517caada390a624$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $e517caada390a624$var$G($e517caada390a624$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($e517caada390a624$var$He(f.value, g)) {
                        if (f.children === e.children && !$e517caada390a624$var$Wf.current) {
                            b = $e517caada390a624$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $e517caada390a624$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $e517caada390a624$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($e517caada390a624$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $e517caada390a624$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $e517caada390a624$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $e517caada390a624$var$ch(b, c), e = $e517caada390a624$var$eh(e), d = d(e), b.flags |= 1, $e517caada390a624$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $e517caada390a624$var$Ci(d, b.pendingProps), e = $e517caada390a624$var$Ci(d.type, e), $e517caada390a624$var$$i(a, b, d, e, c);
        case 15:
            return $e517caada390a624$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e517caada390a624$var$Ci(d, e), $e517caada390a624$var$ij(a, b), b.tag = 1, $e517caada390a624$var$Zf(d) ? (a = !0, $e517caada390a624$var$cg(b)) : a = !1, $e517caada390a624$var$ch(b, c), $e517caada390a624$var$Gi(b, d, e), $e517caada390a624$var$Ii(b, d, e, c), $e517caada390a624$var$jj(null, b, d, !0, a, c);
        case 19:
            return $e517caada390a624$var$xj(a, b, c);
        case 22:
            return $e517caada390a624$var$dj(a, b, c);
    }
    throw Error($e517caada390a624$var$p(156, b.tag));
};
function $e517caada390a624$var$Fk(a, b) {
    return $e517caada390a624$var$ac(a, b);
}
function $e517caada390a624$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $e517caada390a624$var$Bg(a, b, c, d) {
    return new $e517caada390a624$var$$k(a, b, c, d);
}
function $e517caada390a624$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $e517caada390a624$var$Zk(a) {
    if ("function" === typeof a) return $e517caada390a624$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $e517caada390a624$var$Da) return 11;
        if (a === $e517caada390a624$var$Ga) return 14;
    }
    return 2;
}
function $e517caada390a624$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $e517caada390a624$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $e517caada390a624$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $e517caada390a624$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $e517caada390a624$var$ya:
            return $e517caada390a624$var$Tg(c.children, e, f, b);
        case $e517caada390a624$var$za:
            g = 8;
            e |= 8;
            break;
        case $e517caada390a624$var$Aa:
            return a = $e517caada390a624$var$Bg(12, c, b, e | 2), a.elementType = $e517caada390a624$var$Aa, a.lanes = f, a;
        case $e517caada390a624$var$Ea:
            return a = $e517caada390a624$var$Bg(13, c, b, e), a.elementType = $e517caada390a624$var$Ea, a.lanes = f, a;
        case $e517caada390a624$var$Fa:
            return a = $e517caada390a624$var$Bg(19, c, b, e), a.elementType = $e517caada390a624$var$Fa, a.lanes = f, a;
        case $e517caada390a624$var$Ia:
            return $e517caada390a624$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $e517caada390a624$var$Ba:
                    g = 10;
                    break a;
                case $e517caada390a624$var$Ca:
                    g = 9;
                    break a;
                case $e517caada390a624$var$Da:
                    g = 11;
                    break a;
                case $e517caada390a624$var$Ga:
                    g = 14;
                    break a;
                case $e517caada390a624$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($e517caada390a624$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $e517caada390a624$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $e517caada390a624$var$Tg(a, b, c, d) {
    a = $e517caada390a624$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $e517caada390a624$var$pj(a, b, c, d) {
    a = $e517caada390a624$var$Bg(22, a, d, b);
    a.elementType = $e517caada390a624$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $e517caada390a624$var$Qg(a, b, c) {
    a = $e517caada390a624$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $e517caada390a624$var$Sg(a, b, c) {
    b = $e517caada390a624$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $e517caada390a624$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $e517caada390a624$var$zc(0);
    this.expirationTimes = $e517caada390a624$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $e517caada390a624$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $e517caada390a624$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $e517caada390a624$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $e517caada390a624$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $e517caada390a624$var$kh(f);
    return a;
}
function $e517caada390a624$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $e517caada390a624$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $e517caada390a624$var$dl(a) {
    if (!a) return $e517caada390a624$var$Vf;
    a = a._reactInternals;
    a: {
        if ($e517caada390a624$var$Vb(a) !== a || 1 !== a.tag) throw Error($e517caada390a624$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($e517caada390a624$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($e517caada390a624$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($e517caada390a624$var$Zf(c)) return $e517caada390a624$var$bg(a, c, b);
    }
    return b;
}
function $e517caada390a624$var$el(a, b, c, d, e, f, g, h, k) {
    a = $e517caada390a624$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $e517caada390a624$var$dl(null);
    c = a.current;
    d = $e517caada390a624$var$R();
    e = $e517caada390a624$var$yi(c);
    f = $e517caada390a624$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $e517caada390a624$var$nh(c, f, e);
    a.current.lanes = e;
    $e517caada390a624$var$Ac(a, e, d);
    $e517caada390a624$var$Dk(a, d);
    return a;
}
function $e517caada390a624$var$fl(a, b, c, d) {
    var e = b.current, f = $e517caada390a624$var$R(), g = $e517caada390a624$var$yi(e);
    c = $e517caada390a624$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $e517caada390a624$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $e517caada390a624$var$nh(e, b, g);
    null !== a && ($e517caada390a624$var$gi(a, e, g, f), $e517caada390a624$var$oh(a, e, g));
    return g;
}
function $e517caada390a624$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $e517caada390a624$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $e517caada390a624$var$il(a, b) {
    $e517caada390a624$var$hl(a, b);
    (a = a.alternate) && $e517caada390a624$var$hl(a, b);
}
function $e517caada390a624$var$jl() {
    return null;
}
var $e517caada390a624$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $e517caada390a624$var$ll(a) {
    this._internalRoot = a;
}
$e517caada390a624$var$ml.prototype.render = $e517caada390a624$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($e517caada390a624$var$p(409));
    $e517caada390a624$var$fl(a, b, null, null);
};
$e517caada390a624$var$ml.prototype.unmount = $e517caada390a624$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $e517caada390a624$var$Rk(function() {
            $e517caada390a624$var$fl(null, a, null, null);
        });
        b[$e517caada390a624$var$uf] = null;
    }
};
function $e517caada390a624$var$ml(a) {
    this._internalRoot = a;
}
$e517caada390a624$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $e517caada390a624$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $e517caada390a624$var$Qc.length && 0 !== b && b < $e517caada390a624$var$Qc[c].priority; c++);
        $e517caada390a624$var$Qc.splice(c, 0, a);
        0 === c && $e517caada390a624$var$Vc(a);
    }
};
function $e517caada390a624$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $e517caada390a624$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $e517caada390a624$var$pl() {}
function $e517caada390a624$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $e517caada390a624$var$gl(g);
                f.call(a);
            };
        }
        var g = $e517caada390a624$var$el(b, d, a, 0, null, !1, !1, "", $e517caada390a624$var$pl);
        a._reactRootContainer = g;
        a[$e517caada390a624$var$uf] = g.current;
        $e517caada390a624$var$sf(8 === a.nodeType ? a.parentNode : a);
        $e517caada390a624$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $e517caada390a624$var$gl(k);
            h.call(a);
        };
    }
    var k = $e517caada390a624$var$bl(a, 0, !1, null, null, !1, !1, "", $e517caada390a624$var$pl);
    a._reactRootContainer = k;
    a[$e517caada390a624$var$uf] = k.current;
    $e517caada390a624$var$sf(8 === a.nodeType ? a.parentNode : a);
    $e517caada390a624$var$Rk(function() {
        $e517caada390a624$var$fl(b, k, c, d);
    });
    return k;
}
function $e517caada390a624$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $e517caada390a624$var$gl(g);
                h.call(a);
            };
        }
        $e517caada390a624$var$fl(b, g, a, e);
    } else g = $e517caada390a624$var$ql(c, b, a, e, d);
    return $e517caada390a624$var$gl(g);
}
$e517caada390a624$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $e517caada390a624$var$tc(b.pendingLanes);
                0 !== c && ($e517caada390a624$var$Cc(b, c | 1), $e517caada390a624$var$Dk(b, $e517caada390a624$var$B()), 0 === ($e517caada390a624$var$K & 6) && ($e517caada390a624$var$Gj = $e517caada390a624$var$B() + 500, $e517caada390a624$var$jg()));
            }
            break;
        case 13:
            $e517caada390a624$var$Rk(function() {
                var b = $e517caada390a624$var$ih(a, 1);
                if (null !== b) {
                    var c = $e517caada390a624$var$R();
                    $e517caada390a624$var$gi(b, a, 1, c);
                }
            }), $e517caada390a624$var$il(a, 1);
    }
};
$e517caada390a624$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $e517caada390a624$var$ih(a, 134217728);
        if (null !== b) {
            var c = $e517caada390a624$var$R();
            $e517caada390a624$var$gi(b, a, 134217728, c);
        }
        $e517caada390a624$var$il(a, 134217728);
    }
};
$e517caada390a624$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $e517caada390a624$var$yi(a), c = $e517caada390a624$var$ih(a, b);
        if (null !== c) {
            var d = $e517caada390a624$var$R();
            $e517caada390a624$var$gi(c, a, b, d);
        }
        $e517caada390a624$var$il(a, b);
    }
};
$e517caada390a624$var$Hc = function() {
    return $e517caada390a624$var$C;
};
$e517caada390a624$var$Ic = function(a, b) {
    var c = $e517caada390a624$var$C;
    try {
        return $e517caada390a624$var$C = a, b();
    } finally{
        $e517caada390a624$var$C = c;
    }
};
$e517caada390a624$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $e517caada390a624$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $e517caada390a624$var$Db(d);
                        if (!e) throw Error($e517caada390a624$var$p(90));
                        $e517caada390a624$var$Wa(d);
                        $e517caada390a624$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $e517caada390a624$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $e517caada390a624$var$fb(a, !!c.multiple, b, !1);
    }
};
$e517caada390a624$var$Gb = $e517caada390a624$var$Qk;
$e517caada390a624$var$Hb = $e517caada390a624$var$Rk;
var $e517caada390a624$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $e517caada390a624$var$Cb,
        $e517caada390a624$var$ue,
        $e517caada390a624$var$Db,
        $e517caada390a624$var$Eb,
        $e517caada390a624$var$Fb,
        $e517caada390a624$var$Qk
    ]
}, $e517caada390a624$var$tl = {
    findFiberByHostInstance: $e517caada390a624$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $e517caada390a624$var$ul = {
    bundleType: $e517caada390a624$var$tl.bundleType,
    version: $e517caada390a624$var$tl.version,
    rendererPackageName: $e517caada390a624$var$tl.rendererPackageName,
    rendererConfig: $e517caada390a624$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $e517caada390a624$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $e517caada390a624$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $e517caada390a624$var$tl.findFiberByHostInstance || $e517caada390a624$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $e517caada390a624$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$e517caada390a624$var$vl.isDisabled && $e517caada390a624$var$vl.supportsFiber) try {
        $e517caada390a624$var$kc = $e517caada390a624$var$vl.inject($e517caada390a624$var$ul), $e517caada390a624$var$lc = $e517caada390a624$var$vl;
    } catch (a) {}
}
$e517caada390a624$export$ae55be85d98224ed = $e517caada390a624$var$sl;
$e517caada390a624$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$e517caada390a624$var$nl(b)) throw Error($e517caada390a624$var$p(200));
    return $e517caada390a624$var$cl(a, b, null, c);
};
$e517caada390a624$export$882461b6382ed46c = function(a, b) {
    if (!$e517caada390a624$var$nl(a)) throw Error($e517caada390a624$var$p(299));
    var c = !1, d = "", e = $e517caada390a624$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $e517caada390a624$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$e517caada390a624$var$uf] = b.current;
    $e517caada390a624$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $e517caada390a624$var$ll(b);
};
$e517caada390a624$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($e517caada390a624$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($e517caada390a624$var$p(268, a));
    }
    a = $e517caada390a624$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$e517caada390a624$export$cd75ccfd720a3cd4 = function(a) {
    return $e517caada390a624$var$Rk(a);
};
$e517caada390a624$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$e517caada390a624$var$ol(b)) throw Error($e517caada390a624$var$p(200));
    return $e517caada390a624$var$rl(null, a, b, !0, c);
};
$e517caada390a624$export$757ceba2d55c277e = function(a, b, c) {
    if (!$e517caada390a624$var$nl(a)) throw Error($e517caada390a624$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $e517caada390a624$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $e517caada390a624$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$e517caada390a624$var$uf] = b.current;
    $e517caada390a624$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $e517caada390a624$var$ml(b);
};
$e517caada390a624$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$e517caada390a624$var$ol(b)) throw Error($e517caada390a624$var$p(200));
    return $e517caada390a624$var$rl(null, a, b, !1, c);
};
$e517caada390a624$export$502457920280e6be = function(a) {
    if (!$e517caada390a624$var$ol(a)) throw Error($e517caada390a624$var$p(40));
    return a._reactRootContainer ? ($e517caada390a624$var$Rk(function() {
        $e517caada390a624$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$e517caada390a624$var$uf] = null;
        });
    }), !0) : !1;
};
$e517caada390a624$export$c78a37762a8d58e1 = $e517caada390a624$var$Qk;
$e517caada390a624$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$e517caada390a624$var$ol(c)) throw Error($e517caada390a624$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($e517caada390a624$var$p(38));
    return $e517caada390a624$var$rl(a, b, c, !1, d);
};
$e517caada390a624$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("lLS11", function(module, exports) {
'use strict';

module.exports = (parcelRequire("6TWB7"));

});
parcelRegister("6TWB7", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $5065556f91dbbfb3$export$c4744153514ff05d; }, function (v) { return $5065556f91dbbfb3$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $5065556f91dbbfb3$export$3e506c1ccc9cc1a7; }, function (v) { return $5065556f91dbbfb3$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $5065556f91dbbfb3$export$e26fe2ed2fa76875; }, function (v) { return $5065556f91dbbfb3$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $5065556f91dbbfb3$export$502329bbf4b505b1; }, function (v) { return $5065556f91dbbfb3$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $5065556f91dbbfb3$export$6e3807111c4874c4; }, function (v) { return $5065556f91dbbfb3$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $5065556f91dbbfb3$export$c27134553091fb3a; }, function (v) { return $5065556f91dbbfb3$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $5065556f91dbbfb3$export$33ee1acdc04fd2a2; }, function (v) { return $5065556f91dbbfb3$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $5065556f91dbbfb3$export$b00a404bbd5edef2; }, function (v) { return $5065556f91dbbfb3$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $5065556f91dbbfb3$export$8352ce38b91d0c62; }, function (v) { return $5065556f91dbbfb3$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $5065556f91dbbfb3$export$d66a1c1c77bd778b; }, function (v) { return $5065556f91dbbfb3$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $5065556f91dbbfb3$export$d3dfb8e4810cb555; }, function (v) { return $5065556f91dbbfb3$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $5065556f91dbbfb3$export$839f9183b0465a69; }, function (v) { return $5065556f91dbbfb3$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $5065556f91dbbfb3$export$72fdf0e06517287b; }, function (v) { return $5065556f91dbbfb3$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $5065556f91dbbfb3$export$4b844e58a3e414b4; }, function (v) { return $5065556f91dbbfb3$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $5065556f91dbbfb3$export$816d2913ae6b83b1; }, function (v) { return $5065556f91dbbfb3$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $5065556f91dbbfb3$export$61bcfe829111a1d0; }, function (v) { return $5065556f91dbbfb3$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $5065556f91dbbfb3$export$7ee8c9beb337bc3f; }, function (v) { return $5065556f91dbbfb3$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $5065556f91dbbfb3$export$b5836b71941fa3ed; }, function (v) { return $5065556f91dbbfb3$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $5065556f91dbbfb3$export$cf845f2c119da08a; }, function (v) { return $5065556f91dbbfb3$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5065556f91dbbfb3$export$c4744153514ff05d;
var $5065556f91dbbfb3$export$3e506c1ccc9cc1a7;
var $5065556f91dbbfb3$export$e26fe2ed2fa76875;
var $5065556f91dbbfb3$export$502329bbf4b505b1;
var $5065556f91dbbfb3$export$6e3807111c4874c4;
var $5065556f91dbbfb3$export$c27134553091fb3a;
var $5065556f91dbbfb3$export$33ee1acdc04fd2a2;
var $5065556f91dbbfb3$export$b00a404bbd5edef2;
var $5065556f91dbbfb3$export$8352ce38b91d0c62;
var $5065556f91dbbfb3$export$d66a1c1c77bd778b;
var $5065556f91dbbfb3$export$d3dfb8e4810cb555;
var $5065556f91dbbfb3$export$839f9183b0465a69;
var $5065556f91dbbfb3$export$72fdf0e06517287b;
var $5065556f91dbbfb3$export$4b844e58a3e414b4;
var $5065556f91dbbfb3$export$816d2913ae6b83b1;
var $5065556f91dbbfb3$export$61bcfe829111a1d0;
var $5065556f91dbbfb3$export$7ee8c9beb337bc3f;
var $5065556f91dbbfb3$export$b5836b71941fa3ed;
var $5065556f91dbbfb3$export$cf845f2c119da08a;
'use strict';
function $5065556f91dbbfb3$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $5065556f91dbbfb3$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $5065556f91dbbfb3$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $5065556f91dbbfb3$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $5065556f91dbbfb3$var$g(C, c)) n < e && 0 > $5065556f91dbbfb3$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $5065556f91dbbfb3$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $5065556f91dbbfb3$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $5065556f91dbbfb3$var$l = performance;
    $5065556f91dbbfb3$export$c4744153514ff05d = function() {
        return $5065556f91dbbfb3$var$l.now();
    };
} else {
    var $5065556f91dbbfb3$var$p = Date, $5065556f91dbbfb3$var$q = $5065556f91dbbfb3$var$p.now();
    $5065556f91dbbfb3$export$c4744153514ff05d = function() {
        return $5065556f91dbbfb3$var$p.now() - $5065556f91dbbfb3$var$q;
    };
}
var $5065556f91dbbfb3$var$r = [], $5065556f91dbbfb3$var$t = [], $5065556f91dbbfb3$var$u = 1, $5065556f91dbbfb3$var$v = null, $5065556f91dbbfb3$var$y = 3, $5065556f91dbbfb3$var$z = !1, $5065556f91dbbfb3$var$A = !1, $5065556f91dbbfb3$var$B = !1, $5065556f91dbbfb3$var$D = "function" === typeof setTimeout ? setTimeout : null, $5065556f91dbbfb3$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $5065556f91dbbfb3$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $5065556f91dbbfb3$var$G(a) {
    for(var b = $5065556f91dbbfb3$var$h($5065556f91dbbfb3$var$t); null !== b;){
        if (null === b.callback) $5065556f91dbbfb3$var$k($5065556f91dbbfb3$var$t);
        else if (b.startTime <= a) $5065556f91dbbfb3$var$k($5065556f91dbbfb3$var$t), b.sortIndex = b.expirationTime, $5065556f91dbbfb3$var$f($5065556f91dbbfb3$var$r, b);
        else break;
        b = $5065556f91dbbfb3$var$h($5065556f91dbbfb3$var$t);
    }
}
function $5065556f91dbbfb3$var$H(a) {
    $5065556f91dbbfb3$var$B = !1;
    $5065556f91dbbfb3$var$G(a);
    if (!$5065556f91dbbfb3$var$A) {
        if (null !== $5065556f91dbbfb3$var$h($5065556f91dbbfb3$var$r)) $5065556f91dbbfb3$var$A = !0, $5065556f91dbbfb3$var$I($5065556f91dbbfb3$var$J);
        else {
            var b = $5065556f91dbbfb3$var$h($5065556f91dbbfb3$var$t);
            null !== b && $5065556f91dbbfb3$var$K($5065556f91dbbfb3$var$H, b.startTime - a);
        }
    }
}
function $5065556f91dbbfb3$var$J(a, b) {
    $5065556f91dbbfb3$var$A = !1;
    $5065556f91dbbfb3$var$B && ($5065556f91dbbfb3$var$B = !1, $5065556f91dbbfb3$var$E($5065556f91dbbfb3$var$L), $5065556f91dbbfb3$var$L = -1);
    $5065556f91dbbfb3$var$z = !0;
    var c = $5065556f91dbbfb3$var$y;
    try {
        $5065556f91dbbfb3$var$G(b);
        for($5065556f91dbbfb3$var$v = $5065556f91dbbfb3$var$h($5065556f91dbbfb3$var$r); null !== $5065556f91dbbfb3$var$v && (!($5065556f91dbbfb3$var$v.expirationTime > b) || a && !$5065556f91dbbfb3$var$M());){
            var d = $5065556f91dbbfb3$var$v.callback;
            if ("function" === typeof d) {
                $5065556f91dbbfb3$var$v.callback = null;
                $5065556f91dbbfb3$var$y = $5065556f91dbbfb3$var$v.priorityLevel;
                var e = d($5065556f91dbbfb3$var$v.expirationTime <= b);
                b = $5065556f91dbbfb3$export$c4744153514ff05d();
                "function" === typeof e ? $5065556f91dbbfb3$var$v.callback = e : $5065556f91dbbfb3$var$v === $5065556f91dbbfb3$var$h($5065556f91dbbfb3$var$r) && $5065556f91dbbfb3$var$k($5065556f91dbbfb3$var$r);
                $5065556f91dbbfb3$var$G(b);
            } else $5065556f91dbbfb3$var$k($5065556f91dbbfb3$var$r);
            $5065556f91dbbfb3$var$v = $5065556f91dbbfb3$var$h($5065556f91dbbfb3$var$r);
        }
        if (null !== $5065556f91dbbfb3$var$v) var w = !0;
        else {
            var m = $5065556f91dbbfb3$var$h($5065556f91dbbfb3$var$t);
            null !== m && $5065556f91dbbfb3$var$K($5065556f91dbbfb3$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $5065556f91dbbfb3$var$v = null, $5065556f91dbbfb3$var$y = c, $5065556f91dbbfb3$var$z = !1;
    }
}
var $5065556f91dbbfb3$var$N = !1, $5065556f91dbbfb3$var$O = null, $5065556f91dbbfb3$var$L = -1, $5065556f91dbbfb3$var$P = 5, $5065556f91dbbfb3$var$Q = -1;
function $5065556f91dbbfb3$var$M() {
    return $5065556f91dbbfb3$export$c4744153514ff05d() - $5065556f91dbbfb3$var$Q < $5065556f91dbbfb3$var$P ? !1 : !0;
}
function $5065556f91dbbfb3$var$R() {
    if (null !== $5065556f91dbbfb3$var$O) {
        var a = $5065556f91dbbfb3$export$c4744153514ff05d();
        $5065556f91dbbfb3$var$Q = a;
        var b = !0;
        try {
            b = $5065556f91dbbfb3$var$O(!0, a);
        } finally{
            b ? $5065556f91dbbfb3$var$S() : ($5065556f91dbbfb3$var$N = !1, $5065556f91dbbfb3$var$O = null);
        }
    } else $5065556f91dbbfb3$var$N = !1;
}
var $5065556f91dbbfb3$var$S;
if ("function" === typeof $5065556f91dbbfb3$var$F) $5065556f91dbbfb3$var$S = function() {
    $5065556f91dbbfb3$var$F($5065556f91dbbfb3$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $5065556f91dbbfb3$var$T = new MessageChannel, $5065556f91dbbfb3$var$U = $5065556f91dbbfb3$var$T.port2;
    $5065556f91dbbfb3$var$T.port1.onmessage = $5065556f91dbbfb3$var$R;
    $5065556f91dbbfb3$var$S = function() {
        $5065556f91dbbfb3$var$U.postMessage(null);
    };
} else $5065556f91dbbfb3$var$S = function() {
    $5065556f91dbbfb3$var$D($5065556f91dbbfb3$var$R, 0);
};
function $5065556f91dbbfb3$var$I(a) {
    $5065556f91dbbfb3$var$O = a;
    $5065556f91dbbfb3$var$N || ($5065556f91dbbfb3$var$N = !0, $5065556f91dbbfb3$var$S());
}
function $5065556f91dbbfb3$var$K(a, b) {
    $5065556f91dbbfb3$var$L = $5065556f91dbbfb3$var$D(function() {
        a($5065556f91dbbfb3$export$c4744153514ff05d());
    }, b);
}
$5065556f91dbbfb3$export$3e506c1ccc9cc1a7 = 5;
$5065556f91dbbfb3$export$e26fe2ed2fa76875 = 1;
$5065556f91dbbfb3$export$502329bbf4b505b1 = 4;
$5065556f91dbbfb3$export$6e3807111c4874c4 = 3;
$5065556f91dbbfb3$export$c27134553091fb3a = null;
$5065556f91dbbfb3$export$33ee1acdc04fd2a2 = 2;
$5065556f91dbbfb3$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$5065556f91dbbfb3$export$8352ce38b91d0c62 = function() {
    $5065556f91dbbfb3$var$A || $5065556f91dbbfb3$var$z || ($5065556f91dbbfb3$var$A = !0, $5065556f91dbbfb3$var$I($5065556f91dbbfb3$var$J));
};
$5065556f91dbbfb3$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $5065556f91dbbfb3$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$5065556f91dbbfb3$export$d3dfb8e4810cb555 = function() {
    return $5065556f91dbbfb3$var$y;
};
$5065556f91dbbfb3$export$839f9183b0465a69 = function() {
    return $5065556f91dbbfb3$var$h($5065556f91dbbfb3$var$r);
};
$5065556f91dbbfb3$export$72fdf0e06517287b = function(a) {
    switch($5065556f91dbbfb3$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $5065556f91dbbfb3$var$y;
    }
    var c = $5065556f91dbbfb3$var$y;
    $5065556f91dbbfb3$var$y = b;
    try {
        return a();
    } finally{
        $5065556f91dbbfb3$var$y = c;
    }
};
$5065556f91dbbfb3$export$4b844e58a3e414b4 = function() {};
$5065556f91dbbfb3$export$816d2913ae6b83b1 = function() {};
$5065556f91dbbfb3$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $5065556f91dbbfb3$var$y;
    $5065556f91dbbfb3$var$y = a;
    try {
        return b();
    } finally{
        $5065556f91dbbfb3$var$y = c;
    }
};
$5065556f91dbbfb3$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $5065556f91dbbfb3$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $5065556f91dbbfb3$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $5065556f91dbbfb3$var$f($5065556f91dbbfb3$var$t, a), null === $5065556f91dbbfb3$var$h($5065556f91dbbfb3$var$r) && a === $5065556f91dbbfb3$var$h($5065556f91dbbfb3$var$t) && ($5065556f91dbbfb3$var$B ? ($5065556f91dbbfb3$var$E($5065556f91dbbfb3$var$L), $5065556f91dbbfb3$var$L = -1) : $5065556f91dbbfb3$var$B = !0, $5065556f91dbbfb3$var$K($5065556f91dbbfb3$var$H, c - d))) : (a.sortIndex = e, $5065556f91dbbfb3$var$f($5065556f91dbbfb3$var$r, a), $5065556f91dbbfb3$var$A || $5065556f91dbbfb3$var$z || ($5065556f91dbbfb3$var$A = !0, $5065556f91dbbfb3$var$I($5065556f91dbbfb3$var$J)));
    return a;
};
$5065556f91dbbfb3$export$b5836b71941fa3ed = $5065556f91dbbfb3$var$M;
$5065556f91dbbfb3$export$cf845f2c119da08a = function(a) {
    var b = $5065556f91dbbfb3$var$y;
    return function() {
        var c = $5065556f91dbbfb3$var$y;
        $5065556f91dbbfb3$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $5065556f91dbbfb3$var$y = c;
        }
    };
};

});




parcelRegister("bpS0w", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $84fbec42301fef15$export$306c0aa65ff9ec16; }, function (v) { return $84fbec42301fef15$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $84fbec42301fef15$export$306c0aa65ff9ec16;
'use strict';

var $91i6m = parcelRequire("91i6m");
function $84fbec42301fef15$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $84fbec42301fef15$var$k = "function" === typeof Object.is ? Object.is : $84fbec42301fef15$var$h, $84fbec42301fef15$var$l = $91i6m.useState, $84fbec42301fef15$var$m = $91i6m.useEffect, $84fbec42301fef15$var$n = $91i6m.useLayoutEffect, $84fbec42301fef15$var$p = $91i6m.useDebugValue;
function $84fbec42301fef15$var$q(a, b) {
    var d = b(), f = $84fbec42301fef15$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $84fbec42301fef15$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $84fbec42301fef15$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $84fbec42301fef15$var$m(function() {
        $84fbec42301fef15$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $84fbec42301fef15$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $84fbec42301fef15$var$p(d);
    return d;
}
function $84fbec42301fef15$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$84fbec42301fef15$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $84fbec42301fef15$var$t(a, b) {
    return b();
}
var $84fbec42301fef15$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $84fbec42301fef15$var$t : $84fbec42301fef15$var$q;
$84fbec42301fef15$export$306c0aa65ff9ec16 = void 0 !== $91i6m.useSyncExternalStore ? $91i6m.useSyncExternalStore : $84fbec42301fef15$var$u;

});

parcelRegister("kl10d", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $ece68bdc9f56f20d$export$bf730a2d8bf68b42; }, function (v) { return $ece68bdc9f56f20d$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ece68bdc9f56f20d$export$bf730a2d8bf68b42;
'use strict';

var $91i6m = parcelRequire("91i6m");

var $1jUfn = parcelRequire("1jUfn");
function $ece68bdc9f56f20d$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $ece68bdc9f56f20d$var$q = "function" === typeof Object.is ? Object.is : $ece68bdc9f56f20d$var$p, $ece68bdc9f56f20d$var$r = $1jUfn.useSyncExternalStore, $ece68bdc9f56f20d$var$t = $91i6m.useRef, $ece68bdc9f56f20d$var$u = $91i6m.useEffect, $ece68bdc9f56f20d$var$v = $91i6m.useMemo, $ece68bdc9f56f20d$var$w = $91i6m.useDebugValue;
$ece68bdc9f56f20d$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $ece68bdc9f56f20d$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $ece68bdc9f56f20d$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($ece68bdc9f56f20d$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $ece68bdc9f56f20d$var$r(a, c[0], c[1]);
    $ece68bdc9f56f20d$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $ece68bdc9f56f20d$var$w(d);
    return d;
};

});
parcelRegister("1jUfn", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bpS0w"));

});


parcelRegister("kOzMk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2743b0169b92d51$export$2e2bcd8739ae039; });
function $f2743b0169b92d51$export$2e2bcd8739ae039() {
    return $f2743b0169b92d51$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f2743b0169b92d51$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("dDDP6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9eddceede2601ce2$export$2e2bcd8739ae039; });
function $9eddceede2601ce2$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("85ppU", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $5e3281a57d9eaa46$export$2b8d127b894957b9; }, function (v) { return $5e3281a57d9eaa46$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $5e3281a57d9eaa46$export$cea3a54a6425200c; }, function (v) { return $5e3281a57d9eaa46$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $5e3281a57d9eaa46$export$a7c73072b1a182ae; }, function (v) { return $5e3281a57d9eaa46$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $5e3281a57d9eaa46$export$9f27bc3417b4524d; }, function (v) { return $5e3281a57d9eaa46$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $5e3281a57d9eaa46$export$db77ccec0bb4ccac; }, function (v) { return $5e3281a57d9eaa46$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $5e3281a57d9eaa46$export$8392c0c9d3dcbd35; }, function (v) { return $5e3281a57d9eaa46$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $5e3281a57d9eaa46$export$ffb0004e005737fa; }, function (v) { return $5e3281a57d9eaa46$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $5e3281a57d9eaa46$export$b624eff549462981; }, function (v) { return $5e3281a57d9eaa46$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $5e3281a57d9eaa46$export$7897aa7841a5380c; }, function (v) { return $5e3281a57d9eaa46$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $5e3281a57d9eaa46$export$602eac185826482c; }, function (v) { return $5e3281a57d9eaa46$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $5e3281a57d9eaa46$export$e2c29f18771995cb; }, function (v) { return $5e3281a57d9eaa46$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $5e3281a57d9eaa46$export$5f8d39834fd61797; }, function (v) { return $5e3281a57d9eaa46$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $5e3281a57d9eaa46$export$74bf444e3cd11ea5; }, function (v) { return $5e3281a57d9eaa46$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $5e3281a57d9eaa46$export$92387174baf9b227; }, function (v) { return $5e3281a57d9eaa46$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $5e3281a57d9eaa46$export$ec112efeb987d9c6; }, function (v) { return $5e3281a57d9eaa46$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $5e3281a57d9eaa46$export$b706b080d889d2c9; }, function (v) { return $5e3281a57d9eaa46$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $5e3281a57d9eaa46$export$5be5a87408f70ddc; }, function (v) { return $5e3281a57d9eaa46$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $5e3281a57d9eaa46$export$45a5e7f76e0caa8d; }, function (v) { return $5e3281a57d9eaa46$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $5e3281a57d9eaa46$export$455c2e768291efa6; }, function (v) { return $5e3281a57d9eaa46$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $5e3281a57d9eaa46$export$9522e17588c12572; }, function (v) { return $5e3281a57d9eaa46$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $5e3281a57d9eaa46$export$2110ac352bb060b9; }, function (v) { return $5e3281a57d9eaa46$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $5e3281a57d9eaa46$export$56885ab8b9c456ab; }, function (v) { return $5e3281a57d9eaa46$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $5e3281a57d9eaa46$export$d927fcb6adf8f9de; }, function (v) { return $5e3281a57d9eaa46$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $5e3281a57d9eaa46$export$b82d16f27459e05a; }, function (v) { return $5e3281a57d9eaa46$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $5e3281a57d9eaa46$export$522c17b4f5e123e8; }, function (v) { return $5e3281a57d9eaa46$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $5e3281a57d9eaa46$export$1aabd8a0274ecfd6; }, function (v) { return $5e3281a57d9eaa46$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $5e3281a57d9eaa46$export$9b621391a187a31a; }, function (v) { return $5e3281a57d9eaa46$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $5e3281a57d9eaa46$export$f5bbd400c2f4426f; }, function (v) { return $5e3281a57d9eaa46$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5e3281a57d9eaa46$export$2b8d127b894957b9;
var $5e3281a57d9eaa46$export$cea3a54a6425200c;
var $5e3281a57d9eaa46$export$a7c73072b1a182ae;
var $5e3281a57d9eaa46$export$9f27bc3417b4524d;
var $5e3281a57d9eaa46$export$db77ccec0bb4ccac;
var $5e3281a57d9eaa46$export$8392c0c9d3dcbd35;
var $5e3281a57d9eaa46$export$ffb0004e005737fa;
var $5e3281a57d9eaa46$export$b624eff549462981;
var $5e3281a57d9eaa46$export$7897aa7841a5380c;
var $5e3281a57d9eaa46$export$602eac185826482c;
var $5e3281a57d9eaa46$export$e2c29f18771995cb;
var $5e3281a57d9eaa46$export$5f8d39834fd61797;
var $5e3281a57d9eaa46$export$74bf444e3cd11ea5;
var $5e3281a57d9eaa46$export$92387174baf9b227;
var $5e3281a57d9eaa46$export$ec112efeb987d9c6;
var $5e3281a57d9eaa46$export$b706b080d889d2c9;
var $5e3281a57d9eaa46$export$5be5a87408f70ddc;
var $5e3281a57d9eaa46$export$45a5e7f76e0caa8d;
var $5e3281a57d9eaa46$export$455c2e768291efa6;
var $5e3281a57d9eaa46$export$9522e17588c12572;
var $5e3281a57d9eaa46$export$2110ac352bb060b9;
var $5e3281a57d9eaa46$export$56885ab8b9c456ab;
var $5e3281a57d9eaa46$export$d927fcb6adf8f9de;
var $5e3281a57d9eaa46$export$b82d16f27459e05a;
var $5e3281a57d9eaa46$export$522c17b4f5e123e8;
var $5e3281a57d9eaa46$export$1aabd8a0274ecfd6;
var $5e3281a57d9eaa46$export$9b621391a187a31a;
var $5e3281a57d9eaa46$export$f5bbd400c2f4426f;
'use strict';
var $5e3281a57d9eaa46$var$b = "function" === typeof Symbol && Symbol.for, $5e3281a57d9eaa46$var$c = $5e3281a57d9eaa46$var$b ? Symbol.for("react.element") : 60103, $5e3281a57d9eaa46$var$d = $5e3281a57d9eaa46$var$b ? Symbol.for("react.portal") : 60106, $5e3281a57d9eaa46$var$e = $5e3281a57d9eaa46$var$b ? Symbol.for("react.fragment") : 60107, $5e3281a57d9eaa46$var$f = $5e3281a57d9eaa46$var$b ? Symbol.for("react.strict_mode") : 60108, $5e3281a57d9eaa46$var$g = $5e3281a57d9eaa46$var$b ? Symbol.for("react.profiler") : 60114, $5e3281a57d9eaa46$var$h = $5e3281a57d9eaa46$var$b ? Symbol.for("react.provider") : 60109, $5e3281a57d9eaa46$var$k = $5e3281a57d9eaa46$var$b ? Symbol.for("react.context") : 60110, $5e3281a57d9eaa46$var$l = $5e3281a57d9eaa46$var$b ? Symbol.for("react.async_mode") : 60111, $5e3281a57d9eaa46$var$m = $5e3281a57d9eaa46$var$b ? Symbol.for("react.concurrent_mode") : 60111, $5e3281a57d9eaa46$var$n = $5e3281a57d9eaa46$var$b ? Symbol.for("react.forward_ref") : 60112, $5e3281a57d9eaa46$var$p = $5e3281a57d9eaa46$var$b ? Symbol.for("react.suspense") : 60113, $5e3281a57d9eaa46$var$q = $5e3281a57d9eaa46$var$b ? Symbol.for("react.suspense_list") : 60120, $5e3281a57d9eaa46$var$r = $5e3281a57d9eaa46$var$b ? Symbol.for("react.memo") : 60115, $5e3281a57d9eaa46$var$t = $5e3281a57d9eaa46$var$b ? Symbol.for("react.lazy") : 60116, $5e3281a57d9eaa46$var$v = $5e3281a57d9eaa46$var$b ? Symbol.for("react.block") : 60121, $5e3281a57d9eaa46$var$w = $5e3281a57d9eaa46$var$b ? Symbol.for("react.fundamental") : 60117, $5e3281a57d9eaa46$var$x = $5e3281a57d9eaa46$var$b ? Symbol.for("react.responder") : 60118, $5e3281a57d9eaa46$var$y = $5e3281a57d9eaa46$var$b ? Symbol.for("react.scope") : 60119;
function $5e3281a57d9eaa46$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $5e3281a57d9eaa46$var$c:
                switch(a = a.type, a){
                    case $5e3281a57d9eaa46$var$l:
                    case $5e3281a57d9eaa46$var$m:
                    case $5e3281a57d9eaa46$var$e:
                    case $5e3281a57d9eaa46$var$g:
                    case $5e3281a57d9eaa46$var$f:
                    case $5e3281a57d9eaa46$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $5e3281a57d9eaa46$var$k:
                            case $5e3281a57d9eaa46$var$n:
                            case $5e3281a57d9eaa46$var$t:
                            case $5e3281a57d9eaa46$var$r:
                            case $5e3281a57d9eaa46$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $5e3281a57d9eaa46$var$d:
                return u;
        }
    }
}
function $5e3281a57d9eaa46$var$A(a) {
    return $5e3281a57d9eaa46$var$z(a) === $5e3281a57d9eaa46$var$m;
}
$5e3281a57d9eaa46$export$2b8d127b894957b9 = $5e3281a57d9eaa46$var$l;
$5e3281a57d9eaa46$export$cea3a54a6425200c = $5e3281a57d9eaa46$var$m;
$5e3281a57d9eaa46$export$a7c73072b1a182ae = $5e3281a57d9eaa46$var$k;
$5e3281a57d9eaa46$export$9f27bc3417b4524d = $5e3281a57d9eaa46$var$h;
$5e3281a57d9eaa46$export$db77ccec0bb4ccac = $5e3281a57d9eaa46$var$c;
$5e3281a57d9eaa46$export$8392c0c9d3dcbd35 = $5e3281a57d9eaa46$var$n;
$5e3281a57d9eaa46$export$ffb0004e005737fa = $5e3281a57d9eaa46$var$e;
$5e3281a57d9eaa46$export$b624eff549462981 = $5e3281a57d9eaa46$var$t;
$5e3281a57d9eaa46$export$7897aa7841a5380c = $5e3281a57d9eaa46$var$r;
$5e3281a57d9eaa46$export$602eac185826482c = $5e3281a57d9eaa46$var$d;
$5e3281a57d9eaa46$export$e2c29f18771995cb = $5e3281a57d9eaa46$var$g;
$5e3281a57d9eaa46$export$5f8d39834fd61797 = $5e3281a57d9eaa46$var$f;
$5e3281a57d9eaa46$export$74bf444e3cd11ea5 = $5e3281a57d9eaa46$var$p;
$5e3281a57d9eaa46$export$92387174baf9b227 = function(a) {
    return $5e3281a57d9eaa46$var$A(a) || $5e3281a57d9eaa46$var$z(a) === $5e3281a57d9eaa46$var$l;
};
$5e3281a57d9eaa46$export$ec112efeb987d9c6 = $5e3281a57d9eaa46$var$A;
$5e3281a57d9eaa46$export$b706b080d889d2c9 = function(a) {
    return $5e3281a57d9eaa46$var$z(a) === $5e3281a57d9eaa46$var$k;
};
$5e3281a57d9eaa46$export$5be5a87408f70ddc = function(a) {
    return $5e3281a57d9eaa46$var$z(a) === $5e3281a57d9eaa46$var$h;
};
$5e3281a57d9eaa46$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $5e3281a57d9eaa46$var$c;
};
$5e3281a57d9eaa46$export$455c2e768291efa6 = function(a) {
    return $5e3281a57d9eaa46$var$z(a) === $5e3281a57d9eaa46$var$n;
};
$5e3281a57d9eaa46$export$9522e17588c12572 = function(a) {
    return $5e3281a57d9eaa46$var$z(a) === $5e3281a57d9eaa46$var$e;
};
$5e3281a57d9eaa46$export$2110ac352bb060b9 = function(a) {
    return $5e3281a57d9eaa46$var$z(a) === $5e3281a57d9eaa46$var$t;
};
$5e3281a57d9eaa46$export$56885ab8b9c456ab = function(a) {
    return $5e3281a57d9eaa46$var$z(a) === $5e3281a57d9eaa46$var$r;
};
$5e3281a57d9eaa46$export$d927fcb6adf8f9de = function(a) {
    return $5e3281a57d9eaa46$var$z(a) === $5e3281a57d9eaa46$var$d;
};
$5e3281a57d9eaa46$export$b82d16f27459e05a = function(a) {
    return $5e3281a57d9eaa46$var$z(a) === $5e3281a57d9eaa46$var$g;
};
$5e3281a57d9eaa46$export$522c17b4f5e123e8 = function(a) {
    return $5e3281a57d9eaa46$var$z(a) === $5e3281a57d9eaa46$var$f;
};
$5e3281a57d9eaa46$export$1aabd8a0274ecfd6 = function(a) {
    return $5e3281a57d9eaa46$var$z(a) === $5e3281a57d9eaa46$var$p;
};
$5e3281a57d9eaa46$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $5e3281a57d9eaa46$var$e || a === $5e3281a57d9eaa46$var$m || a === $5e3281a57d9eaa46$var$g || a === $5e3281a57d9eaa46$var$f || a === $5e3281a57d9eaa46$var$p || a === $5e3281a57d9eaa46$var$q || "object" === typeof a && null !== a && (a.$$typeof === $5e3281a57d9eaa46$var$t || a.$$typeof === $5e3281a57d9eaa46$var$r || a.$$typeof === $5e3281a57d9eaa46$var$h || a.$$typeof === $5e3281a57d9eaa46$var$k || a.$$typeof === $5e3281a57d9eaa46$var$n || a.$$typeof === $5e3281a57d9eaa46$var$w || a.$$typeof === $5e3281a57d9eaa46$var$x || a.$$typeof === $5e3281a57d9eaa46$var$y || a.$$typeof === $5e3281a57d9eaa46$var$v);
};
$5e3281a57d9eaa46$export$f5bbd400c2f4426f = $5e3281a57d9eaa46$var$z;

});

parcelRegister("fEdd6", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $b644d6bd123c301b$export$a7c73072b1a182ae; }, function (v) { return $b644d6bd123c301b$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $b644d6bd123c301b$export$9f27bc3417b4524d; }, function (v) { return $b644d6bd123c301b$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $b644d6bd123c301b$export$db77ccec0bb4ccac; }, function (v) { return $b644d6bd123c301b$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $b644d6bd123c301b$export$8392c0c9d3dcbd35; }, function (v) { return $b644d6bd123c301b$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b644d6bd123c301b$export$ffb0004e005737fa; }, function (v) { return $b644d6bd123c301b$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $b644d6bd123c301b$export$b624eff549462981; }, function (v) { return $b644d6bd123c301b$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $b644d6bd123c301b$export$7897aa7841a5380c; }, function (v) { return $b644d6bd123c301b$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $b644d6bd123c301b$export$602eac185826482c; }, function (v) { return $b644d6bd123c301b$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $b644d6bd123c301b$export$e2c29f18771995cb; }, function (v) { return $b644d6bd123c301b$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b644d6bd123c301b$export$5f8d39834fd61797; }, function (v) { return $b644d6bd123c301b$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b644d6bd123c301b$export$74bf444e3cd11ea5; }, function (v) { return $b644d6bd123c301b$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $b644d6bd123c301b$export$998bcd577473dd93; }, function (v) { return $b644d6bd123c301b$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $b644d6bd123c301b$export$92387174baf9b227; }, function (v) { return $b644d6bd123c301b$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $b644d6bd123c301b$export$ec112efeb987d9c6; }, function (v) { return $b644d6bd123c301b$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $b644d6bd123c301b$export$b706b080d889d2c9; }, function (v) { return $b644d6bd123c301b$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $b644d6bd123c301b$export$5be5a87408f70ddc; }, function (v) { return $b644d6bd123c301b$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $b644d6bd123c301b$export$45a5e7f76e0caa8d; }, function (v) { return $b644d6bd123c301b$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $b644d6bd123c301b$export$455c2e768291efa6; }, function (v) { return $b644d6bd123c301b$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $b644d6bd123c301b$export$9522e17588c12572; }, function (v) { return $b644d6bd123c301b$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $b644d6bd123c301b$export$2110ac352bb060b9; }, function (v) { return $b644d6bd123c301b$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $b644d6bd123c301b$export$56885ab8b9c456ab; }, function (v) { return $b644d6bd123c301b$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $b644d6bd123c301b$export$d927fcb6adf8f9de; }, function (v) { return $b644d6bd123c301b$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $b644d6bd123c301b$export$b82d16f27459e05a; }, function (v) { return $b644d6bd123c301b$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $b644d6bd123c301b$export$522c17b4f5e123e8; }, function (v) { return $b644d6bd123c301b$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $b644d6bd123c301b$export$1aabd8a0274ecfd6; }, function (v) { return $b644d6bd123c301b$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $b644d6bd123c301b$export$3d6c20d97e46b957; }, function (v) { return $b644d6bd123c301b$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $b644d6bd123c301b$export$9b621391a187a31a; }, function (v) { return $b644d6bd123c301b$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $b644d6bd123c301b$export$f5bbd400c2f4426f; }, function (v) { return $b644d6bd123c301b$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b644d6bd123c301b$export$a7c73072b1a182ae;
var $b644d6bd123c301b$export$9f27bc3417b4524d;
var $b644d6bd123c301b$export$db77ccec0bb4ccac;
var $b644d6bd123c301b$export$8392c0c9d3dcbd35;
var $b644d6bd123c301b$export$ffb0004e005737fa;
var $b644d6bd123c301b$export$b624eff549462981;
var $b644d6bd123c301b$export$7897aa7841a5380c;
var $b644d6bd123c301b$export$602eac185826482c;
var $b644d6bd123c301b$export$e2c29f18771995cb;
var $b644d6bd123c301b$export$5f8d39834fd61797;
var $b644d6bd123c301b$export$74bf444e3cd11ea5;
var $b644d6bd123c301b$export$998bcd577473dd93;
var $b644d6bd123c301b$export$92387174baf9b227;
var $b644d6bd123c301b$export$ec112efeb987d9c6;
var $b644d6bd123c301b$export$b706b080d889d2c9;
var $b644d6bd123c301b$export$5be5a87408f70ddc;
var $b644d6bd123c301b$export$45a5e7f76e0caa8d;
var $b644d6bd123c301b$export$455c2e768291efa6;
var $b644d6bd123c301b$export$9522e17588c12572;
var $b644d6bd123c301b$export$2110ac352bb060b9;
var $b644d6bd123c301b$export$56885ab8b9c456ab;
var $b644d6bd123c301b$export$d927fcb6adf8f9de;
var $b644d6bd123c301b$export$b82d16f27459e05a;
var $b644d6bd123c301b$export$522c17b4f5e123e8;
var $b644d6bd123c301b$export$1aabd8a0274ecfd6;
var $b644d6bd123c301b$export$3d6c20d97e46b957;
var $b644d6bd123c301b$export$9b621391a187a31a;
var $b644d6bd123c301b$export$f5bbd400c2f4426f;
'use strict';
var $b644d6bd123c301b$var$b = Symbol.for("react.element"), $b644d6bd123c301b$var$c = Symbol.for("react.portal"), $b644d6bd123c301b$var$d = Symbol.for("react.fragment"), $b644d6bd123c301b$var$e = Symbol.for("react.strict_mode"), $b644d6bd123c301b$var$f = Symbol.for("react.profiler"), $b644d6bd123c301b$var$g = Symbol.for("react.provider"), $b644d6bd123c301b$var$h = Symbol.for("react.context"), $b644d6bd123c301b$var$k = Symbol.for("react.server_context"), $b644d6bd123c301b$var$l = Symbol.for("react.forward_ref"), $b644d6bd123c301b$var$m = Symbol.for("react.suspense"), $b644d6bd123c301b$var$n = Symbol.for("react.suspense_list"), $b644d6bd123c301b$var$p = Symbol.for("react.memo"), $b644d6bd123c301b$var$q = Symbol.for("react.lazy"), $b644d6bd123c301b$var$t = Symbol.for("react.offscreen"), $b644d6bd123c301b$var$u;
$b644d6bd123c301b$var$u = Symbol.for("react.module.reference");
function $b644d6bd123c301b$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $b644d6bd123c301b$var$b:
                switch(a = a.type, a){
                    case $b644d6bd123c301b$var$d:
                    case $b644d6bd123c301b$var$f:
                    case $b644d6bd123c301b$var$e:
                    case $b644d6bd123c301b$var$m:
                    case $b644d6bd123c301b$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $b644d6bd123c301b$var$k:
                            case $b644d6bd123c301b$var$h:
                            case $b644d6bd123c301b$var$l:
                            case $b644d6bd123c301b$var$q:
                            case $b644d6bd123c301b$var$p:
                            case $b644d6bd123c301b$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $b644d6bd123c301b$var$c:
                return r;
        }
    }
}
$b644d6bd123c301b$export$a7c73072b1a182ae = $b644d6bd123c301b$var$h;
$b644d6bd123c301b$export$9f27bc3417b4524d = $b644d6bd123c301b$var$g;
$b644d6bd123c301b$export$db77ccec0bb4ccac = $b644d6bd123c301b$var$b;
$b644d6bd123c301b$export$8392c0c9d3dcbd35 = $b644d6bd123c301b$var$l;
$b644d6bd123c301b$export$ffb0004e005737fa = $b644d6bd123c301b$var$d;
$b644d6bd123c301b$export$b624eff549462981 = $b644d6bd123c301b$var$q;
$b644d6bd123c301b$export$7897aa7841a5380c = $b644d6bd123c301b$var$p;
$b644d6bd123c301b$export$602eac185826482c = $b644d6bd123c301b$var$c;
$b644d6bd123c301b$export$e2c29f18771995cb = $b644d6bd123c301b$var$f;
$b644d6bd123c301b$export$5f8d39834fd61797 = $b644d6bd123c301b$var$e;
$b644d6bd123c301b$export$74bf444e3cd11ea5 = $b644d6bd123c301b$var$m;
$b644d6bd123c301b$export$998bcd577473dd93 = $b644d6bd123c301b$var$n;
$b644d6bd123c301b$export$92387174baf9b227 = function() {
    return !1;
};
$b644d6bd123c301b$export$ec112efeb987d9c6 = function() {
    return !1;
};
$b644d6bd123c301b$export$b706b080d889d2c9 = function(a) {
    return $b644d6bd123c301b$var$v(a) === $b644d6bd123c301b$var$h;
};
$b644d6bd123c301b$export$5be5a87408f70ddc = function(a) {
    return $b644d6bd123c301b$var$v(a) === $b644d6bd123c301b$var$g;
};
$b644d6bd123c301b$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b644d6bd123c301b$var$b;
};
$b644d6bd123c301b$export$455c2e768291efa6 = function(a) {
    return $b644d6bd123c301b$var$v(a) === $b644d6bd123c301b$var$l;
};
$b644d6bd123c301b$export$9522e17588c12572 = function(a) {
    return $b644d6bd123c301b$var$v(a) === $b644d6bd123c301b$var$d;
};
$b644d6bd123c301b$export$2110ac352bb060b9 = function(a) {
    return $b644d6bd123c301b$var$v(a) === $b644d6bd123c301b$var$q;
};
$b644d6bd123c301b$export$56885ab8b9c456ab = function(a) {
    return $b644d6bd123c301b$var$v(a) === $b644d6bd123c301b$var$p;
};
$b644d6bd123c301b$export$d927fcb6adf8f9de = function(a) {
    return $b644d6bd123c301b$var$v(a) === $b644d6bd123c301b$var$c;
};
$b644d6bd123c301b$export$b82d16f27459e05a = function(a) {
    return $b644d6bd123c301b$var$v(a) === $b644d6bd123c301b$var$f;
};
$b644d6bd123c301b$export$522c17b4f5e123e8 = function(a) {
    return $b644d6bd123c301b$var$v(a) === $b644d6bd123c301b$var$e;
};
$b644d6bd123c301b$export$1aabd8a0274ecfd6 = function(a) {
    return $b644d6bd123c301b$var$v(a) === $b644d6bd123c301b$var$m;
};
$b644d6bd123c301b$export$3d6c20d97e46b957 = function(a) {
    return $b644d6bd123c301b$var$v(a) === $b644d6bd123c301b$var$n;
};
$b644d6bd123c301b$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $b644d6bd123c301b$var$d || a === $b644d6bd123c301b$var$f || a === $b644d6bd123c301b$var$e || a === $b644d6bd123c301b$var$m || a === $b644d6bd123c301b$var$n || a === $b644d6bd123c301b$var$t || "object" === typeof a && null !== a && (a.$$typeof === $b644d6bd123c301b$var$q || a.$$typeof === $b644d6bd123c301b$var$p || a.$$typeof === $b644d6bd123c301b$var$g || a.$$typeof === $b644d6bd123c301b$var$h || a.$$typeof === $b644d6bd123c301b$var$l || a.$$typeof === $b644d6bd123c301b$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$b644d6bd123c301b$export$f5bbd400c2f4426f = $b644d6bd123c301b$var$v;

});

parcelRegister("9OWP7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $726669acbf759775$export$2e2bcd8739ae039; });
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $9gzWK = parcelRequire("9gzWK");

var $91i6m = parcelRequire("91i6m");

var $3xY3R = parcelRequire("3xY3R");

var $irwSp = parcelRequire("irwSp");

var $6Kt8S = parcelRequire("6Kt8S");
/**
 * Returns the appropriate circle stroke color.
 */ function $726669acbf759775$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $irwSp.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $irwSp.N0), ")");
}
var $726669acbf759775$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $726669acbf759775$var$loadIn = null;
var $726669acbf759775$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $726669acbf759775$var$useLayoutEffect = typeof window === 'undefined' ? (0, $91i6m.useEffect) : (0, $91i6m.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $726669acbf759775$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $6Kt8S.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $726669acbf759775$var$getStrokeColor(appearance);
    var context = (0, $91i6m.useContext)((0, $3xY3R.default));
    $726669acbf759775$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $9gzWK.default)([
            $726669acbf759775$var$styles.wrapperStyles,
            $726669acbf759775$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $9gzWK.default)([
            $726669acbf759775$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $9gzWK.default)([
            $726669acbf759775$var$styles.circleStyles
        ])
    })));
}));
var $726669acbf759775$export$2e2bcd8739ae039 = $726669acbf759775$var$Spinner;

});
parcelRegister("9gzWK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6bf17decfbb57655$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $6bf17decfbb57655$var$ATOMIC_GROUP_LENGTH = 5;
function $6bf17decfbb57655$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $6bf17decfbb57655$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("3xY3R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29530b1aa6a739cf$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");
var $29530b1aa6a739cf$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $91i6m.createContext)(null);

});

parcelRegister("irwSp", function(module, exports) {

$parcel$export(module.exports, "N0", function () { return $d6d4403b34ab578b$export$29a4f05edc054374; });
$parcel$export(module.exports, "N500", function () { return $d6d4403b34ab578b$export$c39c0fe0f26207ae; });
// Reds
var $d6d4403b34ab578b$export$4b84fd0e2c617bd = '#FFEBE6';
var $d6d4403b34ab578b$export$b34b069eff244586 = '#FFBDAD';
var $d6d4403b34ab578b$export$be802dd0d8b57f35 = '#FF8F73';
var $d6d4403b34ab578b$export$60847d42f9da92a6 = '#FF7452';
var $d6d4403b34ab578b$export$4a7404f376229999 = '#FF5630';
var $d6d4403b34ab578b$export$2010d0fb4295b346 = '#DE350B';
var $d6d4403b34ab578b$export$2837b5a1a71d5c02 = '#BF2600';
var $d6d4403b34ab578b$export$8d9596b529bbb9cf = '#FFFAE6';
var $d6d4403b34ab578b$export$41060a744ab0b7ae = '#FFF0B3';
var $d6d4403b34ab578b$export$1cc05bbbf340e559 = '#FFE380';
var $d6d4403b34ab578b$export$5aae31392d72caaa = '#FFC400';
var $d6d4403b34ab578b$export$c6930421db9fa514 = '#FFAB00';
var $d6d4403b34ab578b$export$59619663aa6500fb = '#FF991F';
var $d6d4403b34ab578b$export$874739ea9e379ab6 = '#FF8B00';
var $d6d4403b34ab578b$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $d6d4403b34ab578b$export$69a3bf21b9686c2b = '#ABF5D1';
var $d6d4403b34ab578b$export$afbce1382ec95f73 = '#79F2C0';
var $d6d4403b34ab578b$export$747d86715d4175de = '#57D9A3';
var $d6d4403b34ab578b$export$940e1f69e873f202 = '#36B37E';
var $d6d4403b34ab578b$export$a49394138f7b8e85 = '#00875A';
var $d6d4403b34ab578b$export$6fa04827ac68a4fb = '#006644';
var $d6d4403b34ab578b$export$226de0355ed012f8 = '#DEEBFF';
var $d6d4403b34ab578b$export$8c13c2ee36917869 = '#B3D4FF';
var $d6d4403b34ab578b$export$ecfc1dff386a3e7a = '#4C9AFF';
var $d6d4403b34ab578b$export$215b7063051591f1 = '#2684FF';
var $d6d4403b34ab578b$export$e62e8919cca44969 = '#0065FF';
var $d6d4403b34ab578b$export$b3de0ae08da2ce64 = '#0052CC';
var $d6d4403b34ab578b$export$a6ee3d71bc067634 = '#0747A6';
var $d6d4403b34ab578b$export$67f15409e87642a1 = '#669DF1';
var $d6d4403b34ab578b$export$f0539dbc42dbb067 = '#8FB8F6';
var $d6d4403b34ab578b$export$363e4475840015bb = '#EAE6FF';
var $d6d4403b34ab578b$export$4b0a4417ed59760f = '#C0B6F2';
var $d6d4403b34ab578b$export$6011520a64d9a187 = '#998DD9';
var $d6d4403b34ab578b$export$a7175d4e9206bc80 = '#8777D9';
var $d6d4403b34ab578b$export$b48405b95304b5a1 = '#6554C0';
var $d6d4403b34ab578b$export$c71e4279dd54a18d = '#5243AA';
var $d6d4403b34ab578b$export$147899de772240ec = '#403294';
var $d6d4403b34ab578b$export$2cf711fe14c66f06 = '#E6FCFF';
var $d6d4403b34ab578b$export$7a8f4d33f6f9772c = '#B3F5FF';
var $d6d4403b34ab578b$export$776c9c497ef08533 = '#79E2F2';
var $d6d4403b34ab578b$export$69cb3ca10c1e330e = '#00C7E6';
var $d6d4403b34ab578b$export$9dc1ef0f3f48059b = '#00B8D9';
var $d6d4403b34ab578b$export$7c835c78b6fcdef8 = '#00A3BF';
var $d6d4403b34ab578b$export$6036577f95c3877e = '#008DA6';
var $d6d4403b34ab578b$export$29a4f05edc054374 = '#FFFFFF';
var $d6d4403b34ab578b$export$e655ef011c4aa1a2 = '#FAFBFC';
var $d6d4403b34ab578b$export$9fdfb749e33cdf97 = '#F4F5F7';
var $d6d4403b34ab578b$export$3e51e8f1440314ba = '#EBECF0';
var $d6d4403b34ab578b$export$1ce2d1575d444ceb = '#DFE1E6';
var $d6d4403b34ab578b$export$8754fc7e6d8b3000 = '#C1C7D0';
var $d6d4403b34ab578b$export$c2e91cbeada39b8b = '#B3BAC5';
var $d6d4403b34ab578b$export$5f71e19f3a7ad9de = '#A5ADBA';
var $d6d4403b34ab578b$export$eaa8c8a70ac22806 = '#97A0AF';
var $d6d4403b34ab578b$export$7c87d337fb91a97d = '#8993A4';
var $d6d4403b34ab578b$export$d6447c357493214f = '#7A869A';
var $d6d4403b34ab578b$export$f563ee71e9ee74cd = '#6B778C';
var $d6d4403b34ab578b$export$e2ef2124cf4024b1 = '#5E6C84';
var $d6d4403b34ab578b$export$eece5f492e429f08 = '#505F79';
var $d6d4403b34ab578b$export$c39c0fe0f26207ae = '#42526E';
var $d6d4403b34ab578b$export$7090862dc3038a9f = '#344563';
var $d6d4403b34ab578b$export$ad0bacf983b7ddaa = '#253858';
var $d6d4403b34ab578b$export$7d61b15e0da132af = '#172B4D';
var $d6d4403b34ab578b$export$fbda843f0a27fe96 = '#091E42';
var $d6d4403b34ab578b$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $d6d4403b34ab578b$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $d6d4403b34ab578b$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $d6d4403b34ab578b$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $d6d4403b34ab578b$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $d6d4403b34ab578b$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $d6d4403b34ab578b$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $d6d4403b34ab578b$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $d6d4403b34ab578b$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $d6d4403b34ab578b$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $d6d4403b34ab578b$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $d6d4403b34ab578b$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $d6d4403b34ab578b$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $d6d4403b34ab578b$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $d6d4403b34ab578b$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $d6d4403b34ab578b$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $d6d4403b34ab578b$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $d6d4403b34ab578b$export$2f6319cf7d736c2a = '#E6EDFA';
var $d6d4403b34ab578b$export$95126bc8884d6634 = '#DCE5F5';
var $d6d4403b34ab578b$export$8338d8c35d44ff1 = '#CED9EB';
var $d6d4403b34ab578b$export$5368d76ae4fbbda7 = '#B8C7E0';
var $d6d4403b34ab578b$export$9f0a771d16ec8d36 = '#ABBBD6';
var $d6d4403b34ab578b$export$abcf8c38338b4aa5 = '#9FB0CC';
var $d6d4403b34ab578b$export$97e81faa16a182c7 = '#8C9CB8';
var $d6d4403b34ab578b$export$bfe21c59123ecf33 = '#7988A3';
var $d6d4403b34ab578b$export$ee82aa2ea6a1558 = '#67758F';
var $d6d4403b34ab578b$export$682927c6ed76be02 = '#56637A';
var $d6d4403b34ab578b$export$91fd9994c5be9757 = '#455166';
var $d6d4403b34ab578b$export$d281fbfe3cff2df6 = '#3B475C';
var $d6d4403b34ab578b$export$3902c91d8b98a753 = '#313D52';
var $d6d4403b34ab578b$export$8e8133c1ba5845b5 = '#283447';
var $d6d4403b34ab578b$export$33ff357f6620b39 = '#202B3D';
var $d6d4403b34ab578b$export$633847cf062b69e0 = '#1B2638';
var $d6d4403b34ab578b$export$9776a6e503bdbf76 = '#121A29';
var $d6d4403b34ab578b$export$6c813d5160dff5db = '#0E1624';
var $d6d4403b34ab578b$export$3d4f271a500072a = '#0D1424';
var $d6d4403b34ab578b$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $d6d4403b34ab578b$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $d6d4403b34ab578b$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $d6d4403b34ab578b$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $d6d4403b34ab578b$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $d6d4403b34ab578b$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $d6d4403b34ab578b$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $d6d4403b34ab578b$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $d6d4403b34ab578b$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $d6d4403b34ab578b$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $d6d4403b34ab578b$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $d6d4403b34ab578b$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $d6d4403b34ab578b$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $d6d4403b34ab578b$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $d6d4403b34ab578b$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $d6d4403b34ab578b$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $d6d4403b34ab578b$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $d6d4403b34ab578b$export$d2adc5dedf09fced = '#292A2E';
var $d6d4403b34ab578b$export$f51762073d2bb381 = '#94C748';
var $d6d4403b34ab578b$export$95e26d54def96891 = '#B3DF72';

});

parcelRegister("6Kt8S", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $4e9da4f57c356bd5$export$4e9f1640bbe7a1a8; });
var $4e9da4f57c356bd5$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});


parcelRegister("gFEh4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e693d825f42a773c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "BaseErrorPage", function () { return $e693d825f42a773c$export$7ef2fc65256b3bd8; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $9jjaN = parcelRequire("9jjaN");

var $iTSCG = parcelRequire("iTSCG");

var $kyMDl = parcelRequire("kyMDl");

var $1V2cH = parcelRequire("1V2cH");
let $e693d825f42a773c$var$_ = (t)=>t, $e693d825f42a773c$var$t;
function $e693d825f42a773c$export$2e2bcd8739ae039({ title: title, children: children }) {
    const anonymousId = (0, $1V2cH.useAnalyticsAnonymousId)();
    return /*#__PURE__*/ (0, $4ZSso.jsx)($e693d825f42a773c$export$7ef2fc65256b3bd8, {
        title: title,
        anonymousId: anonymousId,
        children: children
    });
}
function $e693d825f42a773c$export$7ef2fc65256b3bd8({ title: title, anonymousId: anonymousId, children: children }) {
    return /*#__PURE__*/ (0, $4ZSso.jsxs)($e693d825f42a773c$var$ErrorContainer, {
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $iTSCG.AtlassianLogo), {
                size: "large",
                label: "Atlassian",
                appearance: "brand"
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($kyMDl))),
                    height: "150",
                    alt: "",
                    className: "error-image"
                })
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)("h2", {
                className: "error-title",
                children: title
            }),
            !!children && /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
                className: "error-content",
                children: children
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)("small", {
                className: "error-diagnostic-details",
                children: /*#__PURE__*/ (0, $4ZSso.jsx)("code", {
                    children: anonymousId || "\u2014"
                })
            })
        ]
    });
}
const $e693d825f42a773c$var$ErrorContainer = (0, $9jjaN.default).div($e693d825f42a773c$var$t || ($e693d825f42a773c$var$t = $e693d825f42a773c$var$_`
  margin-right: auto;
  margin-left: auto;
  max-width: 900px;
  padding: 100px 10px 0px 10px;
  text-align: center;

  .error-image {
    padding: 24px 0px;
  }

  .error-title {
    padding-top: 0px;
  }

  .error-content {
    padding-top: 16px;
  }

  .error-action {
    padding-top: 24px;
  }

  .error-diagnostic-details {
    display: block;
    padding-top: 24px;
  }
`));

});
parcelRegister("9jjaN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c74c2c78d65d158$export$2e2bcd8739ae039; });

var $2OIoE = parcelRequire("2OIoE");
parcelRequire("cIDQN");

parcelRequire("iehG3");
parcelRequire("hplAq");
parcelRequire("dyCnM");
parcelRequire("91i6m");
parcelRequire("lty7x");
var $6c74c2c78d65d158$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $6c74c2c78d65d158$export$2e2bcd8739ae039 = (0, $2OIoE.default).bind(null);
$6c74c2c78d65d158$var$tags.forEach(function(tagName) {
    $6c74c2c78d65d158$export$2e2bcd8739ae039[tagName] = $6c74c2c78d65d158$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("2OIoE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20d2b08aaa718469$export$2e2bcd8739ae039; });

var $kOzMk = parcelRequire("kOzMk");
parcelRequire("boAHD");
var $9GfGB = parcelRequire("9GfGB");

var $iehG3 = parcelRequire("iehG3");

var $hplAq = parcelRequire("hplAq");

var $dyCnM = parcelRequire("dyCnM");

var $91i6m = parcelRequire("91i6m");

var $lty7x = parcelRequire("lty7x");
var $20d2b08aaa718469$var$isBrowser = typeof document !== 'undefined';
var $20d2b08aaa718469$var$isDevelopment = false;
var $20d2b08aaa718469$var$testOmitPropsOnStringTag = (0, $lty7x.default);
var $20d2b08aaa718469$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $20d2b08aaa718469$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $20d2b08aaa718469$var$testOmitPropsOnStringTag : $20d2b08aaa718469$var$testOmitPropsOnComponent;
};
var $20d2b08aaa718469$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $20d2b08aaa718469$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $dyCnM.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $hplAq.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $dyCnM.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$20d2b08aaa718469$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $91i6m.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $20d2b08aaa718469$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $20d2b08aaa718469$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $20d2b08aaa718469$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $9GfGB.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $91i6m.useContext((0, $9GfGB.T));
            }
            if (typeof props.className === 'string') className = (0, $dyCnM.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $iehG3.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $20d2b08aaa718469$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $91i6m.createElement($91i6m.Fragment, null, /*#__PURE__*/ $91i6m.createElement($20d2b08aaa718469$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $91i6m.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $20d2b08aaa718469$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $kOzMk.default)({}, options, nextOptions, {
                shouldForwardProp: $20d2b08aaa718469$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("boAHD", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $84be680419ac8caa$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $84be680419ac8caa$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $84be680419ac8caa$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ClassNames", function () { return $84be680419ac8caa$export$9b9c0f9d9f3552b8; });
$parcel$export(module.exports, "jsx", function () { return $84be680419ac8caa$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("9GfGB")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("9GfGB")).w; });

var $9GfGB = parcelRequire("9GfGB");

var $91i6m = parcelRequire("91i6m");

var $dyCnM = parcelRequire("dyCnM");

var $hplAq = parcelRequire("hplAq");

var $iehG3 = parcelRequire("iehG3");
parcelRequire("af0bm");
parcelRequire("cIDQN");
parcelRequire("83oEa");

parcelRequire("kTpRR");
var $84be680419ac8caa$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $9GfGB.h).call(props, 'css')) return $91i6m.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $9GfGB.E);
    createElementArgArray[1] = (0, $9GfGB.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $91i6m.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($84be680419ac8caa$export$c8a8987d4410bf2d || ($84be680419ac8caa$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $84be680419ac8caa$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $9GfGB.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $iehG3.serializeStyles)([
        styles
    ], undefined, $91i6m.useContext((0, $9GfGB.T)));
    if (!(0, $9GfGB.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $91i6m.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $91i6m.useRef();
    (0, $hplAq.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $hplAq.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $dyCnM.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $84be680419ac8caa$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $iehG3.serializeStyles)(args);
}
function $84be680419ac8caa$export$d25ddfdf17c3ad3e() {
    var insertable = $84be680419ac8caa$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $84be680419ac8caa$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $84be680419ac8caa$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $dyCnM.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $84be680419ac8caa$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $hplAq.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $dyCnM.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $9GfGB.i) && res !== undefined) rules += res;
        }
        if (!(0, $9GfGB.i)) return rules;
    });
    if (!(0, $9GfGB.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $91i6m.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $84be680419ac8caa$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $9GfGB.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $9GfGB.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $iehG3.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $dyCnM.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $9GfGB.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $84be680419ac8caa$var$merge(cache.registered, css, $84be680419ac8caa$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $91i6m.useContext((0, $9GfGB.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $91i6m.createElement($91i6m.Fragment, null, /*#__PURE__*/ $91i6m.createElement($84be680419ac8caa$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("9GfGB", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $70c434381ac7ef6b$export$407448d2b89b1813; });
$parcel$export(module.exports, "i", function () { return $70c434381ac7ef6b$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "w", function () { return $70c434381ac7ef6b$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $70c434381ac7ef6b$export$971d5caa766a69d7; });
$parcel$export(module.exports, "h", function () { return $70c434381ac7ef6b$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "c", function () { return $70c434381ac7ef6b$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $70c434381ac7ef6b$export$a9c23c6ac3fc3eca; });

var $91i6m = parcelRequire("91i6m");

var $af0bm = parcelRequire("af0bm");

var $kOzMk = parcelRequire("kOzMk");

var $83oEa = parcelRequire("83oEa");

var $9Z6k8 = parcelRequire("9Z6k8");

var $dyCnM = parcelRequire("dyCnM");

var $iehG3 = parcelRequire("iehG3");

var $hplAq = parcelRequire("hplAq");
var $70c434381ac7ef6b$export$407448d2b89b1813 = false;
var $70c434381ac7ef6b$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $70c434381ac7ef6b$var$EmotionCacheContext = /* #__PURE__ */ $91i6m.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $af0bm.default)({
    key: 'css'
}) : null);
var $70c434381ac7ef6b$export$e7094788287c5e9b = $70c434381ac7ef6b$var$EmotionCacheContext.Provider;
var $70c434381ac7ef6b$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $91i6m.useContext)($70c434381ac7ef6b$var$EmotionCacheContext);
};
var $70c434381ac7ef6b$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $91i6m.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $91i6m.useContext)($70c434381ac7ef6b$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$70c434381ac7ef6b$export$23f2a1d2818174ef) $70c434381ac7ef6b$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $91i6m.useContext)($70c434381ac7ef6b$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $af0bm.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $91i6m.createElement($70c434381ac7ef6b$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $70c434381ac7ef6b$export$971d5caa766a69d7 = /* #__PURE__ */ $91i6m.createContext({});
var $70c434381ac7ef6b$export$3b14a55fb2447963 = function useTheme() {
    return $91i6m.useContext($70c434381ac7ef6b$export$971d5caa766a69d7);
};
var $70c434381ac7ef6b$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $kOzMk.default)({}, outerTheme, theme);
};
var $70c434381ac7ef6b$var$createCacheWithTheme = /* #__PURE__ */ (0, $83oEa.default)(function(outerTheme) {
    return (0, $83oEa.default)(function(theme) {
        return $70c434381ac7ef6b$var$getTheme(outerTheme, theme);
    });
});
var $70c434381ac7ef6b$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $91i6m.useContext($70c434381ac7ef6b$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $70c434381ac7ef6b$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $91i6m.createElement($70c434381ac7ef6b$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $70c434381ac7ef6b$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $91i6m.forwardRef(function render(props, ref) {
        var theme = $91i6m.useContext($70c434381ac7ef6b$export$971d5caa766a69d7);
        return /*#__PURE__*/ $91i6m.createElement(Component, (0, $kOzMk.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $9Z6k8.default)(WithTheme, Component);
}
var $70c434381ac7ef6b$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $70c434381ac7ef6b$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $70c434381ac7ef6b$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($70c434381ac7ef6b$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$70c434381ac7ef6b$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $70c434381ac7ef6b$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $dyCnM.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $hplAq.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $dyCnM.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$70c434381ac7ef6b$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $91i6m.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $70c434381ac7ef6b$var$Emotion = /* #__PURE__ */ $70c434381ac7ef6b$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$70c434381ac7ef6b$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $dyCnM.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $iehG3.serializeStyles)(registeredStyles, undefined, $91i6m.useContext($70c434381ac7ef6b$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($70c434381ac7ef6b$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $70c434381ac7ef6b$var$typePropName && !$70c434381ac7ef6b$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $91i6m.createElement($91i6m.Fragment, null, /*#__PURE__*/ $91i6m.createElement($70c434381ac7ef6b$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $91i6m.createElement(WrappedComponent, newProps));
});
var $70c434381ac7ef6b$export$a9c23c6ac3fc3eca = $70c434381ac7ef6b$var$Emotion;

});
parcelRegister("af0bm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $774b7247727e7633$export$2e2bcd8739ae039; });

var $g2rMT = parcelRequire("g2rMT");

var $9bmCV = parcelRequire("9bmCV");

var $83oEa = parcelRequire("83oEa");

var $lAymj = parcelRequire("lAymj");
var $774b7247727e7633$var$isBrowser = typeof document !== 'undefined';
var $774b7247727e7633$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $9bmCV.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $9bmCV.token)(character)) break;
        (0, $9bmCV.next)();
    }
    return (0, $9bmCV.slice)(begin, (0, $9bmCV.position));
};
var $774b7247727e7633$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $9bmCV.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $9bmCV.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $774b7247727e7633$var$identifierWithPointTracking((0, $9bmCV.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $9bmCV.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $9bmCV.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $9bmCV.from)(character);
    }
    while (character = (0, $9bmCV.next)());
    return parsed;
};
var $774b7247727e7633$var$getRules = function getRules(value, points) {
    return (0, $9bmCV.dealloc)($774b7247727e7633$var$toRules((0, $9bmCV.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $774b7247727e7633$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $774b7247727e7633$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$774b7247727e7633$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $774b7247727e7633$var$fixedElements.set(element, true);
    var points = [];
    var rules = $774b7247727e7633$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $774b7247727e7633$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $774b7247727e7633$var$prefix(value, length) {
    switch((0, $9bmCV.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $9bmCV.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $9bmCV.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $9bmCV.WEBKIT) + value + (0, $9bmCV.MOZ) + value + (0, $9bmCV.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $9bmCV.WEBKIT) + value + (0, $9bmCV.MS) + value + value;
        // order
        case 6165:
            return (0, $9bmCV.WEBKIT) + value + (0, $9bmCV.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $9bmCV.WEBKIT) + value + (0, $9bmCV.replace)(value, /(\w+).+(:[^]+)/, (0, $9bmCV.WEBKIT) + 'box-$1$2' + (0, $9bmCV.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $9bmCV.WEBKIT) + value + (0, $9bmCV.MS) + 'flex-item-' + (0, $9bmCV.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $9bmCV.WEBKIT) + value + (0, $9bmCV.MS) + 'flex-line-pack' + (0, $9bmCV.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $9bmCV.WEBKIT) + value + (0, $9bmCV.MS) + (0, $9bmCV.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $9bmCV.WEBKIT) + value + (0, $9bmCV.MS) + (0, $9bmCV.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $9bmCV.WEBKIT) + 'box-' + (0, $9bmCV.replace)(value, '-grow', '') + (0, $9bmCV.WEBKIT) + value + (0, $9bmCV.MS) + (0, $9bmCV.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $9bmCV.WEBKIT) + (0, $9bmCV.replace)(value, /([^-])(transform)/g, '$1' + (0, $9bmCV.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $9bmCV.replace)((0, $9bmCV.replace)((0, $9bmCV.replace)(value, /(zoom-|grab)/, (0, $9bmCV.WEBKIT) + '$1'), /(image-set)/, (0, $9bmCV.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $9bmCV.replace)(value, /(image-set\([^]*)/, (0, $9bmCV.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $9bmCV.replace)((0, $9bmCV.replace)(value, /(.+:)(flex-)?(.*)/, (0, $9bmCV.WEBKIT) + 'box-pack:$3' + (0, $9bmCV.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $9bmCV.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $9bmCV.replace)(value, /(.+)-inline(.+)/, (0, $9bmCV.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $9bmCV.strlen)(value) - 1 - length > 6) switch((0, $9bmCV.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $9bmCV.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $9bmCV.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $9bmCV.WEBKIT) + '$2-$3' + '$1' + (0, $9bmCV.MOZ) + ((0, $9bmCV.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $9bmCV.indexof)(value, 'stretch') ? $774b7247727e7633$var$prefix((0, $9bmCV.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $9bmCV.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $9bmCV.charat)(value, (0, $9bmCV.strlen)(value) - 3 - (~(0, $9bmCV.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $9bmCV.replace)(value, ':', ':' + (0, $9bmCV.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $9bmCV.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $9bmCV.WEBKIT) + ((0, $9bmCV.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $9bmCV.WEBKIT) + '$2$3' + '$1' + (0, $9bmCV.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $9bmCV.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $9bmCV.WEBKIT) + value + (0, $9bmCV.MS) + (0, $9bmCV.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $9bmCV.WEBKIT) + value + (0, $9bmCV.MS) + (0, $9bmCV.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $9bmCV.WEBKIT) + value + (0, $9bmCV.MS) + (0, $9bmCV.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $9bmCV.WEBKIT) + value + (0, $9bmCV.MS) + value + value;
    }
    return value;
}
var $774b7247727e7633$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $9bmCV.DECLARATION:
                element["return"] = $774b7247727e7633$var$prefix(element.value, element.length);
                break;
            case 0, $9bmCV.KEYFRAMES:
                return (0, $9bmCV.serialize)([
                    (0, $9bmCV.copy)(element, {
                        value: (0, $9bmCV.replace)(element.value, '@', '@' + (0, $9bmCV.WEBKIT))
                    })
                ], callback);
            case 0, $9bmCV.RULESET:
                if (element.length) return (0, $9bmCV.combine)(element.props, function(value) {
                    switch((0, $9bmCV.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $9bmCV.serialize)([
                                (0, $9bmCV.copy)(element, {
                                    props: [
                                        (0, $9bmCV.replace)(value, /:(read-\w+)/, ':' + (0, $9bmCV.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $9bmCV.serialize)([
                                (0, $9bmCV.copy)(element, {
                                    props: [
                                        (0, $9bmCV.replace)(value, /:(plac\w+)/, ':' + (0, $9bmCV.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $9bmCV.copy)(element, {
                                    props: [
                                        (0, $9bmCV.replace)(value, /:(plac\w+)/, ':' + (0, $9bmCV.MOZ) + '$1')
                                    ]
                                }),
                                (0, $9bmCV.copy)(element, {
                                    props: [
                                        (0, $9bmCV.replace)(value, /:(plac\w+)/, (0, $9bmCV.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $774b7247727e7633$var$getServerStylisCache = $774b7247727e7633$var$isBrowser ? undefined : (0, $83oEa.default)(function() {
    return (0, $lAymj.default)(function() {
        return {};
    });
});
var $774b7247727e7633$var$defaultStylisPlugins = [
    $774b7247727e7633$var$prefixer
];
var $774b7247727e7633$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($774b7247727e7633$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $774b7247727e7633$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($774b7247727e7633$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $774b7247727e7633$var$compat,
        $774b7247727e7633$var$removeLabel
    ];
    if (!$774b7247727e7633$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $9bmCV.stringify),
            (0, $9bmCV.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $9bmCV.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $9bmCV.serialize)((0, $9bmCV.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $9bmCV.stringify)
        ];
        var _serializer = (0, $9bmCV.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $9bmCV.serialize)((0, $9bmCV.compile)(styles), _serializer);
        };
        var serverStylisCache = $774b7247727e7633$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $g2rMT.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("g2rMT", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $bad2634cc45aca2a$export$9d753cd7ae895cce; });
var $bad2634cc45aca2a$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $bad2634cc45aca2a$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $bad2634cc45aca2a$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $bad2634cc45aca2a$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$bad2634cc45aca2a$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($bad2634cc45aca2a$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $bad2634cc45aca2a$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("9bmCV", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $49275300514f15b0$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $49275300514f15b0$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $49275300514f15b0$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $49275300514f15b0$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $49275300514f15b0$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $49275300514f15b0$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $49275300514f15b0$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $49275300514f15b0$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $49275300514f15b0$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $49275300514f15b0$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $49275300514f15b0$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $49275300514f15b0$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $49275300514f15b0$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $49275300514f15b0$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $49275300514f15b0$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $49275300514f15b0$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $49275300514f15b0$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $49275300514f15b0$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $49275300514f15b0$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $49275300514f15b0$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $49275300514f15b0$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $49275300514f15b0$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $49275300514f15b0$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $49275300514f15b0$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $49275300514f15b0$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $49275300514f15b0$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $49275300514f15b0$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $49275300514f15b0$export$38bcb760f1d4871c; });
var $49275300514f15b0$export$71ad59f2e432cfe8 = "-ms-";
var $49275300514f15b0$export$2c0f367103c8d01c = "-moz-";
var $49275300514f15b0$export$39dfd62a25e0fe93 = "-webkit-";
var $49275300514f15b0$export$a29989082612d0d9 = "comm";
var $49275300514f15b0$export$aa3a2e812ca8570d = "rule";
var $49275300514f15b0$export$527d108ccf083c2b = "decl";
var $49275300514f15b0$export$d3d35020fa5b54f0 = "@page";
var $49275300514f15b0$export$500415a86c544f73 = "@media";
var $49275300514f15b0$export$a763edbf796b780a = "@import";
var $49275300514f15b0$export$2790aeb8b4e5c826 = "@charset";
var $49275300514f15b0$export$1cc683e23b84b133 = "@viewport";
var $49275300514f15b0$export$9447a5efea57e862 = "@supports";
var $49275300514f15b0$export$ef011b4e114b1fba = "@document";
var $49275300514f15b0$export$6aad947bda0f3f46 = "@namespace";
var $49275300514f15b0$export$b44a8529a35fcb60 = "@keyframes";
var $49275300514f15b0$export$2c16de31893252e6 = "@font-face";
var $49275300514f15b0$export$3d846dd52e150c6f = "@counter-style";
var $49275300514f15b0$export$22314bfbb57653fe = "@font-feature-values";
var $49275300514f15b0$export$d773506282b3cfe6 = "@layer";
var $49275300514f15b0$export$2335f513bbd82c6d = Math.abs;
var $49275300514f15b0$export$6788812c4e6611e6 = String.fromCharCode;
var $49275300514f15b0$export$e6e34fd1f2686227 = Object.assign;
function $49275300514f15b0$export$d6af199866bfb566(e, r) {
    return $49275300514f15b0$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $49275300514f15b0$export$a9db5e087081082d(e, 0)) << 2 ^ $49275300514f15b0$export$a9db5e087081082d(e, 1)) << 2 ^ $49275300514f15b0$export$a9db5e087081082d(e, 2)) << 2 ^ $49275300514f15b0$export$a9db5e087081082d(e, 3) : 0;
}
function $49275300514f15b0$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $49275300514f15b0$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $49275300514f15b0$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $49275300514f15b0$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $49275300514f15b0$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $49275300514f15b0$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $49275300514f15b0$export$36776f635604f274(e) {
    return e.length;
}
function $49275300514f15b0$export$f9084667e487ed46(e) {
    return e.length;
}
function $49275300514f15b0$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $49275300514f15b0$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $49275300514f15b0$export$53f1d5ea8de3d7c = 1;
var $49275300514f15b0$export$4e0c71f277ca26b3 = 1;
var $49275300514f15b0$export$f24224f1c91d8156 = 0;
var $49275300514f15b0$export$5880b8b5730aff45 = 0;
var $49275300514f15b0$export$c0306caf338ac095 = 0;
var $49275300514f15b0$export$30a86d91af8ff6e6 = "";
function $49275300514f15b0$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $49275300514f15b0$export$53f1d5ea8de3d7c,
        column: $49275300514f15b0$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $49275300514f15b0$export$784d13d8ee351f07(e, r) {
    return $49275300514f15b0$export$e6e34fd1f2686227($49275300514f15b0$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $49275300514f15b0$export$eba6f6f03b0a92e7() {
    return $49275300514f15b0$export$c0306caf338ac095;
}
function $49275300514f15b0$export$232faf9add678146() {
    $49275300514f15b0$export$c0306caf338ac095 = $49275300514f15b0$export$5880b8b5730aff45 > 0 ? $49275300514f15b0$export$a9db5e087081082d($49275300514f15b0$export$30a86d91af8ff6e6, --$49275300514f15b0$export$5880b8b5730aff45) : 0;
    if ($49275300514f15b0$export$4e0c71f277ca26b3--, $49275300514f15b0$export$c0306caf338ac095 === 10) $49275300514f15b0$export$4e0c71f277ca26b3 = 1, $49275300514f15b0$export$53f1d5ea8de3d7c--;
    return $49275300514f15b0$export$c0306caf338ac095;
}
function $49275300514f15b0$export$48cfd1e771a65c4f() {
    $49275300514f15b0$export$c0306caf338ac095 = $49275300514f15b0$export$5880b8b5730aff45 < $49275300514f15b0$export$f24224f1c91d8156 ? $49275300514f15b0$export$a9db5e087081082d($49275300514f15b0$export$30a86d91af8ff6e6, $49275300514f15b0$export$5880b8b5730aff45++) : 0;
    if ($49275300514f15b0$export$4e0c71f277ca26b3++, $49275300514f15b0$export$c0306caf338ac095 === 10) $49275300514f15b0$export$4e0c71f277ca26b3 = 1, $49275300514f15b0$export$53f1d5ea8de3d7c++;
    return $49275300514f15b0$export$c0306caf338ac095;
}
function $49275300514f15b0$export$4d3fb11e950abb9e() {
    return $49275300514f15b0$export$a9db5e087081082d($49275300514f15b0$export$30a86d91af8ff6e6, $49275300514f15b0$export$5880b8b5730aff45);
}
function $49275300514f15b0$export$e88cb2efb12ae807() {
    return $49275300514f15b0$export$5880b8b5730aff45;
}
function $49275300514f15b0$export$58adb3bec8346d0f(e, r) {
    return $49275300514f15b0$export$2f35ab04d2335697($49275300514f15b0$export$30a86d91af8ff6e6, e, r);
}
function $49275300514f15b0$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $49275300514f15b0$export$2de70f21292aac9e(e) {
    return $49275300514f15b0$export$53f1d5ea8de3d7c = $49275300514f15b0$export$4e0c71f277ca26b3 = 1, $49275300514f15b0$export$f24224f1c91d8156 = $49275300514f15b0$export$36776f635604f274($49275300514f15b0$export$30a86d91af8ff6e6 = e), $49275300514f15b0$export$5880b8b5730aff45 = 0, [];
}
function $49275300514f15b0$export$45918ac1574455b1(e) {
    return $49275300514f15b0$export$30a86d91af8ff6e6 = "", e;
}
function $49275300514f15b0$export$410ac95b9ec204b8(e) {
    return $49275300514f15b0$export$87c2784dc9fc4ab($49275300514f15b0$export$58adb3bec8346d0f($49275300514f15b0$export$5880b8b5730aff45 - 1, $49275300514f15b0$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $49275300514f15b0$export$660b2ee2d4fb4eff(e) {
    return $49275300514f15b0$export$45918ac1574455b1($49275300514f15b0$export$5f8c09e3ae6f64e1($49275300514f15b0$export$2de70f21292aac9e(e)));
}
function $49275300514f15b0$export$7af1228ff777d175(e) {
    while($49275300514f15b0$export$c0306caf338ac095 = $49275300514f15b0$export$4d3fb11e950abb9e())if ($49275300514f15b0$export$c0306caf338ac095 < 33) $49275300514f15b0$export$48cfd1e771a65c4f();
    else break;
    return $49275300514f15b0$export$9e1725a4cfeada27(e) > 2 || $49275300514f15b0$export$9e1725a4cfeada27($49275300514f15b0$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $49275300514f15b0$export$5f8c09e3ae6f64e1(e) {
    while($49275300514f15b0$export$48cfd1e771a65c4f())switch($49275300514f15b0$export$9e1725a4cfeada27($49275300514f15b0$export$c0306caf338ac095)){
        case 0:
            $49275300514f15b0$export$10d8903dec122b9d($49275300514f15b0$export$c2ab62c7bf24634($49275300514f15b0$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $49275300514f15b0$export$10d8903dec122b9d($49275300514f15b0$export$410ac95b9ec204b8($49275300514f15b0$export$c0306caf338ac095), e);
            break;
        default:
            $49275300514f15b0$export$10d8903dec122b9d($49275300514f15b0$export$6788812c4e6611e6($49275300514f15b0$export$c0306caf338ac095), e);
    }
    return e;
}
function $49275300514f15b0$export$955ba06d119e085e(e, r) {
    while(--r && $49275300514f15b0$export$48cfd1e771a65c4f())if ($49275300514f15b0$export$c0306caf338ac095 < 48 || $49275300514f15b0$export$c0306caf338ac095 > 102 || $49275300514f15b0$export$c0306caf338ac095 > 57 && $49275300514f15b0$export$c0306caf338ac095 < 65 || $49275300514f15b0$export$c0306caf338ac095 > 70 && $49275300514f15b0$export$c0306caf338ac095 < 97) break;
    return $49275300514f15b0$export$58adb3bec8346d0f(e, $49275300514f15b0$export$e88cb2efb12ae807() + (r < 6 && $49275300514f15b0$export$4d3fb11e950abb9e() == 32 && $49275300514f15b0$export$48cfd1e771a65c4f() == 32));
}
function $49275300514f15b0$export$c889f2fcc19dbf12(e) {
    while($49275300514f15b0$export$48cfd1e771a65c4f())switch($49275300514f15b0$export$c0306caf338ac095){
        case e:
            return $49275300514f15b0$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $49275300514f15b0$export$c889f2fcc19dbf12($49275300514f15b0$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $49275300514f15b0$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $49275300514f15b0$export$48cfd1e771a65c4f();
            break;
    }
    return $49275300514f15b0$export$5880b8b5730aff45;
}
function $49275300514f15b0$export$4254d4e2b3745c4c(e, r) {
    while($49275300514f15b0$export$48cfd1e771a65c4f())if (e + $49275300514f15b0$export$c0306caf338ac095 === 57) break;
    else if (e + $49275300514f15b0$export$c0306caf338ac095 === 84 && $49275300514f15b0$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $49275300514f15b0$export$58adb3bec8346d0f(r, $49275300514f15b0$export$5880b8b5730aff45 - 1) + "*" + $49275300514f15b0$export$6788812c4e6611e6(e === 47 ? e : $49275300514f15b0$export$48cfd1e771a65c4f());
}
function $49275300514f15b0$export$c2ab62c7bf24634(e) {
    while(!$49275300514f15b0$export$9e1725a4cfeada27($49275300514f15b0$export$4d3fb11e950abb9e()))$49275300514f15b0$export$48cfd1e771a65c4f();
    return $49275300514f15b0$export$58adb3bec8346d0f(e, $49275300514f15b0$export$5880b8b5730aff45);
}
function $49275300514f15b0$export$ef7acd7185315e22(e) {
    return $49275300514f15b0$export$45918ac1574455b1($49275300514f15b0$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $49275300514f15b0$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $49275300514f15b0$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $49275300514f15b0$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $49275300514f15b0$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($49275300514f15b0$export$f8e21b1e77979a08(j += $49275300514f15b0$export$77ad94ebf1c2b9ed($49275300514f15b0$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $49275300514f15b0$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $49275300514f15b0$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $49275300514f15b0$export$955ba06d119e085e($49275300514f15b0$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($49275300514f15b0$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $49275300514f15b0$export$10d8903dec122b9d($49275300514f15b0$export$4a34f930e789283c($49275300514f15b0$export$4254d4e2b3745c4c($49275300514f15b0$export$48cfd1e771a65c4f(), $49275300514f15b0$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $49275300514f15b0$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $49275300514f15b0$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $49275300514f15b0$export$36776f635604f274(j) - l) $49275300514f15b0$export$10d8903dec122b9d(p > 32 ? $49275300514f15b0$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $49275300514f15b0$export$f8483753829ec8f3($49275300514f15b0$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $49275300514f15b0$export$10d8903dec122b9d(y = $49275300514f15b0$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $49275300514f15b0$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $49275300514f15b0$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $49275300514f15b0$export$98e6a39c04603d36(e, y, y, n && $49275300514f15b0$export$10d8903dec122b9d($49275300514f15b0$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $49275300514f15b0$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $49275300514f15b0$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $49275300514f15b0$export$232faf9add678146() == 125) continue;
            }
            switch(j += $49275300514f15b0$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($49275300514f15b0$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($49275300514f15b0$export$4d3fb11e950abb9e() === 45) j += $49275300514f15b0$export$410ac95b9ec204b8($49275300514f15b0$export$48cfd1e771a65c4f());
                    v = $49275300514f15b0$export$4d3fb11e950abb9e(), o = l = $49275300514f15b0$export$36776f635604f274(g = j += $49275300514f15b0$export$c2ab62c7bf24634($49275300514f15b0$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $49275300514f15b0$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $49275300514f15b0$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $49275300514f15b0$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $49275300514f15b0$export$2f35ab04d2335697(e, v + 1, v = $49275300514f15b0$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $49275300514f15b0$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $49275300514f15b0$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $49275300514f15b0$export$35059013cd4a06db(e, r, a, s === 0 ? $49275300514f15b0$export$aa3a2e812ca8570d : i, f, o, l);
}
function $49275300514f15b0$export$4a34f930e789283c(e, r, a) {
    return $49275300514f15b0$export$35059013cd4a06db(e, r, a, $49275300514f15b0$export$a29989082612d0d9, $49275300514f15b0$export$6788812c4e6611e6($49275300514f15b0$export$eba6f6f03b0a92e7()), $49275300514f15b0$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $49275300514f15b0$export$f8483753829ec8f3(e, r, a, n) {
    return $49275300514f15b0$export$35059013cd4a06db(e, r, a, $49275300514f15b0$export$527d108ccf083c2b, $49275300514f15b0$export$2f35ab04d2335697(e, 0, n), $49275300514f15b0$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $49275300514f15b0$export$82e9f45cca5ba907(n, c, s) {
    switch($49275300514f15b0$export$d6af199866bfb566(n, c)){
        case 5103:
            return $49275300514f15b0$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $49275300514f15b0$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $49275300514f15b0$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $49275300514f15b0$export$39dfd62a25e0fe93 + n + $49275300514f15b0$export$2c0f367103c8d01c + n + $49275300514f15b0$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($49275300514f15b0$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $49275300514f15b0$export$39dfd62a25e0fe93 + n + $49275300514f15b0$export$71ad59f2e432cfe8 + $49275300514f15b0$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $49275300514f15b0$export$39dfd62a25e0fe93 + n + $49275300514f15b0$export$71ad59f2e432cfe8 + $49275300514f15b0$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $49275300514f15b0$export$39dfd62a25e0fe93 + n + $49275300514f15b0$export$71ad59f2e432cfe8 + $49275300514f15b0$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $49275300514f15b0$export$39dfd62a25e0fe93 + n + $49275300514f15b0$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $49275300514f15b0$export$39dfd62a25e0fe93 + n + $49275300514f15b0$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $49275300514f15b0$export$39dfd62a25e0fe93 + n + $49275300514f15b0$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $49275300514f15b0$export$39dfd62a25e0fe93 + "box-$1$2" + $49275300514f15b0$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $49275300514f15b0$export$39dfd62a25e0fe93 + n + $49275300514f15b0$export$71ad59f2e432cfe8 + "flex-item-" + $49275300514f15b0$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$49275300514f15b0$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $49275300514f15b0$export$71ad59f2e432cfe8 + "grid-row-" + $49275300514f15b0$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $49275300514f15b0$export$39dfd62a25e0fe93 + n + $49275300514f15b0$export$71ad59f2e432cfe8 + "flex-line-pack" + $49275300514f15b0$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $49275300514f15b0$export$39dfd62a25e0fe93 + n + $49275300514f15b0$export$71ad59f2e432cfe8 + $49275300514f15b0$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $49275300514f15b0$export$39dfd62a25e0fe93 + n + $49275300514f15b0$export$71ad59f2e432cfe8 + $49275300514f15b0$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $49275300514f15b0$export$39dfd62a25e0fe93 + "box-" + $49275300514f15b0$export$77ad94ebf1c2b9ed(n, "-grow", "") + $49275300514f15b0$export$39dfd62a25e0fe93 + n + $49275300514f15b0$export$71ad59f2e432cfe8 + $49275300514f15b0$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $49275300514f15b0$export$39dfd62a25e0fe93 + $49275300514f15b0$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $49275300514f15b0$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $49275300514f15b0$export$77ad94ebf1c2b9ed($49275300514f15b0$export$77ad94ebf1c2b9ed($49275300514f15b0$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $49275300514f15b0$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $49275300514f15b0$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $49275300514f15b0$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $49275300514f15b0$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $49275300514f15b0$export$77ad94ebf1c2b9ed($49275300514f15b0$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $49275300514f15b0$export$39dfd62a25e0fe93 + "box-pack:$3" + $49275300514f15b0$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $49275300514f15b0$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$49275300514f15b0$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $49275300514f15b0$export$71ad59f2e432cfe8 + "grid-column-align" + $49275300514f15b0$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $49275300514f15b0$export$71ad59f2e432cfe8 + $49275300514f15b0$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $49275300514f15b0$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$49275300514f15b0$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $49275300514f15b0$export$71ad59f2e432cfe8 + $49275300514f15b0$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $49275300514f15b0$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$49275300514f15b0$export$f8e21b1e77979a08(s, "span") ? $49275300514f15b0$export$4659b591c19bdf3d(s, /\d+/) : +$49275300514f15b0$export$4659b591c19bdf3d(s, /\d+/) - +$49275300514f15b0$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $49275300514f15b0$export$71ad59f2e432cfe8 + $49275300514f15b0$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $49275300514f15b0$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $49275300514f15b0$export$71ad59f2e432cfe8 + $49275300514f15b0$export$77ad94ebf1c2b9ed($49275300514f15b0$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $49275300514f15b0$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $49275300514f15b0$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($49275300514f15b0$export$36776f635604f274(n) - 1 - c > 6) switch($49275300514f15b0$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($49275300514f15b0$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $49275300514f15b0$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $49275300514f15b0$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $49275300514f15b0$export$2c0f367103c8d01c + ($49275300514f15b0$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$49275300514f15b0$export$f8e21b1e77979a08(n, "stretch") ? $49275300514f15b0$export$82e9f45cca5ba907($49275300514f15b0$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $49275300514f15b0$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $49275300514f15b0$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $49275300514f15b0$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($49275300514f15b0$export$a9db5e087081082d(n, c + 6) === 121) return $49275300514f15b0$export$77ad94ebf1c2b9ed(n, ":", ":" + $49275300514f15b0$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($49275300514f15b0$export$a9db5e087081082d(n, $49275300514f15b0$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $49275300514f15b0$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $49275300514f15b0$export$39dfd62a25e0fe93 + ($49275300514f15b0$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $49275300514f15b0$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $49275300514f15b0$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $49275300514f15b0$export$77ad94ebf1c2b9ed(n, ":", ":" + $49275300514f15b0$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $49275300514f15b0$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $49275300514f15b0$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $49275300514f15b0$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $49275300514f15b0$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $49275300514f15b0$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $49275300514f15b0$export$a763edbf796b780a:
        case $49275300514f15b0$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $49275300514f15b0$export$a29989082612d0d9:
            return "";
        case $49275300514f15b0$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $49275300514f15b0$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $49275300514f15b0$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $49275300514f15b0$export$36776f635604f274(a = $49275300514f15b0$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $49275300514f15b0$export$5a7767152ae0305f(e) {
    var r = $49275300514f15b0$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $49275300514f15b0$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $49275300514f15b0$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $49275300514f15b0$export$527d108ccf083c2b:
                n.return = $49275300514f15b0$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $49275300514f15b0$export$b44a8529a35fcb60:
                return $49275300514f15b0$export$dfdc1655ccc5b9cb([
                    $49275300514f15b0$export$784d13d8ee351f07(n, {
                        value: $49275300514f15b0$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $49275300514f15b0$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $49275300514f15b0$export$aa3a2e812ca8570d:
                if (n.length) return $49275300514f15b0$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($49275300514f15b0$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $49275300514f15b0$export$dfdc1655ccc5b9cb([
                                $49275300514f15b0$export$784d13d8ee351f07(n, {
                                    props: [
                                        $49275300514f15b0$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $49275300514f15b0$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $49275300514f15b0$export$dfdc1655ccc5b9cb([
                                $49275300514f15b0$export$784d13d8ee351f07(n, {
                                    props: [
                                        $49275300514f15b0$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $49275300514f15b0$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $49275300514f15b0$export$784d13d8ee351f07(n, {
                                    props: [
                                        $49275300514f15b0$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $49275300514f15b0$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $49275300514f15b0$export$784d13d8ee351f07(n, {
                                    props: [
                                        $49275300514f15b0$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $49275300514f15b0$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $49275300514f15b0$export$76a88f7de6507443(e) {
    switch(e.type){
        case $49275300514f15b0$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $49275300514f15b0$export$1be1fc439b849fdf($49275300514f15b0$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($49275300514f15b0$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $49275300514f15b0$export$2f35ab04d2335697(r, 1, $49275300514f15b0$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $49275300514f15b0$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $49275300514f15b0$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $49275300514f15b0$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("83oEa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5dd1b8e0c4118d13$export$2e2bcd8739ae039; });
var $5dd1b8e0c4118d13$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("lAymj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb779cb85ecaca82$export$2e2bcd8739ae039; });
function $fb779cb85ecaca82$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("9Z6k8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $744eb750c61db2f3$export$2e2bcd8739ae039; });

var $kTpRR = parcelRequire("kTpRR");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $744eb750c61db2f3$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($kTpRR)))(targetComponent, sourceComponent);
};

});
parcelRegister("kTpRR", function(module, exports) {
'use strict';

var $92D93 = parcelRequire("92D93");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $f35d02826975f8df$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $f35d02826975f8df$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $f35d02826975f8df$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $f35d02826975f8df$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $f35d02826975f8df$var$TYPE_STATICS = {};
$f35d02826975f8df$var$TYPE_STATICS[$92D93.ForwardRef] = $f35d02826975f8df$var$FORWARD_REF_STATICS;
$f35d02826975f8df$var$TYPE_STATICS[$92D93.Memo] = $f35d02826975f8df$var$MEMO_STATICS;
function $f35d02826975f8df$var$getStatics(component) {
    // React v16.11 and below
    if ($92D93.isMemo(component)) return $f35d02826975f8df$var$MEMO_STATICS;
     // React v16.12 and above
    return $f35d02826975f8df$var$TYPE_STATICS[component['$$typeof']] || $f35d02826975f8df$var$REACT_STATICS;
}
var $f35d02826975f8df$var$defineProperty = Object.defineProperty;
var $f35d02826975f8df$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $f35d02826975f8df$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $f35d02826975f8df$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $f35d02826975f8df$var$getPrototypeOf = Object.getPrototypeOf;
var $f35d02826975f8df$var$objectPrototype = Object.prototype;
function $f35d02826975f8df$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($f35d02826975f8df$var$objectPrototype) {
            var inheritedComponent = $f35d02826975f8df$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $f35d02826975f8df$var$objectPrototype) $f35d02826975f8df$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $f35d02826975f8df$var$getOwnPropertyNames(sourceComponent);
        if ($f35d02826975f8df$var$getOwnPropertySymbols) keys = keys.concat($f35d02826975f8df$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $f35d02826975f8df$var$getStatics(targetComponent);
        var sourceStatics = $f35d02826975f8df$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$f35d02826975f8df$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $f35d02826975f8df$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $f35d02826975f8df$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $f35d02826975f8df$var$hoistNonReactStatics;

});
parcelRegister("92D93", function(module, exports) {
'use strict';

module.exports = (parcelRequire("85ppU"));

});



parcelRegister("dyCnM", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $028c1170caa0ea17$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $028c1170caa0ea17$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $028c1170caa0ea17$export$6f077d94b33a01aa; });
var $028c1170caa0ea17$var$isBrowser = typeof document !== 'undefined';
function $028c1170caa0ea17$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $028c1170caa0ea17$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $028c1170caa0ea17$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $028c1170caa0ea17$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $028c1170caa0ea17$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$028c1170caa0ea17$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$028c1170caa0ea17$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("iehG3", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $d4573f1f6fcf1ee3$export$6321afa313b251b5; });

var $jjgIr = parcelRequire("jjgIr");

var $5GbVW = parcelRequire("5GbVW");

var $lAymj = parcelRequire("lAymj");
var $d4573f1f6fcf1ee3$var$isDevelopment = false;
var $d4573f1f6fcf1ee3$var$hyphenateRegex = /[A-Z]|^ms/g;
var $d4573f1f6fcf1ee3$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $d4573f1f6fcf1ee3$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $d4573f1f6fcf1ee3$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $d4573f1f6fcf1ee3$var$processStyleName = /* #__PURE__ */ (0, $lAymj.default)(function(styleName) {
    return $d4573f1f6fcf1ee3$var$isCustomProperty(styleName) ? styleName : styleName.replace($d4573f1f6fcf1ee3$var$hyphenateRegex, '-$&').toLowerCase();
});
var $d4573f1f6fcf1ee3$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($d4573f1f6fcf1ee3$var$animationRegex, function(match, p1, p2) {
                $d4573f1f6fcf1ee3$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $d4573f1f6fcf1ee3$var$cursor
                };
                return p1;
            });
    }
    if ((0, $5GbVW.default)[key] !== 1 && !$d4573f1f6fcf1ee3$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $d4573f1f6fcf1ee3$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $d4573f1f6fcf1ee3$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $d4573f1f6fcf1ee3$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $d4573f1f6fcf1ee3$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $d4573f1f6fcf1ee3$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $d4573f1f6fcf1ee3$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $d4573f1f6fcf1ee3$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $d4573f1f6fcf1ee3$var$cursor;
                var result = interpolation(mergedProps);
                $d4573f1f6fcf1ee3$var$cursor = previousCursor;
                return $d4573f1f6fcf1ee3$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $d4573f1f6fcf1ee3$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $d4573f1f6fcf1ee3$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($d4573f1f6fcf1ee3$var$isProcessableValue(asString)) string += $d4573f1f6fcf1ee3$var$processStyleName(key) + ":" + $d4573f1f6fcf1ee3$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $d4573f1f6fcf1ee3$var$isDevelopment) throw new Error($d4573f1f6fcf1ee3$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($d4573f1f6fcf1ee3$var$isProcessableValue(value[_i])) string += $d4573f1f6fcf1ee3$var$processStyleName(key) + ":" + $d4573f1f6fcf1ee3$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $d4573f1f6fcf1ee3$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $d4573f1f6fcf1ee3$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $d4573f1f6fcf1ee3$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $d4573f1f6fcf1ee3$var$cursor;
function $d4573f1f6fcf1ee3$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $d4573f1f6fcf1ee3$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $d4573f1f6fcf1ee3$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $d4573f1f6fcf1ee3$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $d4573f1f6fcf1ee3$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $d4573f1f6fcf1ee3$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $jjgIr.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $d4573f1f6fcf1ee3$var$cursor
    };
}

});
parcelRegister("jjgIr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0ecc20e89dc5db1$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $e0ecc20e89dc5db1$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("5GbVW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $422a21bd8dab7552$export$2e2bcd8739ae039; });
var $422a21bd8dab7552$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("hplAq", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $cac5841ea65ee17c$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $cac5841ea65ee17c$export$811a713a7276cb9d; });

var $91i6m = parcelRequire("91i6m");
var $cac5841ea65ee17c$var$isBrowser = typeof document !== 'undefined';
var $cac5841ea65ee17c$var$syncFallback = function syncFallback(create) {
    return create();
};
var $cac5841ea65ee17c$var$useInsertionEffect = $91i6m.useInsertionEffect ? $91i6m.useInsertionEffect : false;
var $cac5841ea65ee17c$export$db21c7ffa21794e7 = !$cac5841ea65ee17c$var$isBrowser ? $cac5841ea65ee17c$var$syncFallback : $cac5841ea65ee17c$var$useInsertionEffect || $cac5841ea65ee17c$var$syncFallback;
var $cac5841ea65ee17c$export$811a713a7276cb9d = $cac5841ea65ee17c$var$useInsertionEffect || $91i6m.useLayoutEffect;

});


parcelRegister("cIDQN", function(module, exports) {
function $942881900b330c39$var$_extends() {
    return module.exports = $942881900b330c39$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $942881900b330c39$var$_extends.apply(null, arguments);
}
module.exports = $942881900b330c39$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("lty7x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa26c611e33610de$export$2e2bcd8739ae039; });

var $lAymj = parcelRequire("lAymj");
// eslint-disable-next-line no-undef
var $fa26c611e33610de$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $fa26c611e33610de$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $lAymj.default)(function(prop) {
    return $fa26c611e33610de$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("iTSCG", function(module, exports) {

$parcel$export(module.exports, "AtlassianLogo", function () { return $dc27bc03e52063c7$export$765cacec8b0843f3; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $dc27bc03e52063c7$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 198 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\">\n      <path fill=".concat(colors.iconColor, " d=\"M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"/>\n      <path fill=").concat(colors.atlassianLogoTextColor, " d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.265 0 1.061-.708 1.698-2.973 1.698-2.619 0-5.733-.92-7.785-2.123v4.813c1.627.778 3.751 1.698 7.785 1.698 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.298-2.902-.637-3.61-1.274-3.61-2.194 0-1.133 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.698v-4.6c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.17h4.318V9.979l1.769 4.035 6.087 11.324h5.379V5.166h-4.247v13.022l-1.628-3.821-4.883-9.201zm-27.319 0h-4.671v20.17h4.671zm-10.05 14.154c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.708 6.795 1.699v-4.6c-1.557-.78-3.893-1.346-6.653-1.346-5.238 0-7.927 2.265-7.927 5.946 0 2.972 1.344 5.308 6.794 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.618 0-5.733-.92-7.785-2.123v4.812c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.166v20.17h9.625l1.486-4.387h-6.44V5.166zm-19.039 0v4.317h5.167v15.854h4.741V9.483h5.592V5.166zm-6.866 0h-6.157L32 25.336h5.379l.99-3.396c1.204.353 2.478.566 3.752.566s2.548-.213 3.751-.567l.991 3.398h5.379c-.07 0-7.078-20.171-7.078-20.171M42.05 18.259c-.92 0-1.77-.141-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354zM97.326 5.166H91.17l-7.078 20.17h5.38l.99-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.114 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.093h-6.157l-7.007 20.17h5.379l.991-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.043 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354\"/>\n    </svg>");
};
var $dc27bc03e52063c7$export$765cacec8b0843f3 = function AtlassianLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        label: label,
        svg: $dc27bc03e52063c7$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});
parcelRegister("jfDBc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e03e2291ac7b86ab$export$2e2bcd8739ae039; });

var $5YM7L = parcelRequire("5YM7L");

var $91i6m = parcelRequire("91i6m");

var $4sggA = parcelRequire("4sggA");

var $7rIXr = parcelRequire("7rIXr");
/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ var $e03e2291ac7b86ab$var$useThemeObserver = function useThemeObserver() {
    var _useState = (0, $91i6m.useState)((0, $4sggA.default)()), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $91i6m.useEffect)(function() {
        var observer = new (0, $7rIXr.default)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $e03e2291ac7b86ab$export$2e2bcd8739ae039 = $e03e2291ac7b86ab$var$useThemeObserver;

});
parcelRegister("5YM7L", function(module, exports) {

var $cS2Jc = parcelRequire("cS2Jc");

var $4lFbj = parcelRequire("4lFbj");

var $d9Fbm = parcelRequire("d9Fbm");

var $hymCx = parcelRequire("hymCx");
function $45a7e2d6d07dbb8b$var$_slicedToArray(r, e) {
    return $cS2Jc(r) || $4lFbj(r, e) || $d9Fbm(r, e) || $hymCx();
}
module.exports = $45a7e2d6d07dbb8b$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("cS2Jc", function(module, exports) {
function $95eca4e2b6b30937$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $95eca4e2b6b30937$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("4lFbj", function(module, exports) {
function $32a9116013e42497$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $32a9116013e42497$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("d9Fbm", function(module, exports) {

var $7CcOI = parcelRequire("7CcOI");
function $993c0f94786bc394$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $7CcOI(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $7CcOI(r, a) : void 0;
    }
}
module.exports = $993c0f94786bc394$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("7CcOI", function(module, exports) {
function $58b60636e201d03e$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $58b60636e201d03e$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("hymCx", function(module, exports) {
function $cc7728a30d0f86a1$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $cc7728a30d0f86a1$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("4sggA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33e6652089333bd4$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");

var $2S8bR = parcelRequire("2S8bR");

var $3cRMM = parcelRequire("3cRMM");

var $2HO6u = parcelRequire("2HO6u");
function $33e6652089333bd4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $33e6652089333bd4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $33e6652089333bd4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $33e6652089333bd4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $33e6652089333bd4$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $3cRMM.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $33e6652089333bd4$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $2S8bR.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $2S8bR.THEME_DATA_ATTRIBUTE)) || '';
    return $33e6652089333bd4$var$_objectSpread($33e6652089333bd4$var$_objectSpread({}, (0, $2HO6u.themeStringToObject)(theme)), $33e6652089333bd4$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $33e6652089333bd4$export$2e2bcd8739ae039 = $33e6652089333bd4$var$getGlobalTheme;

});
parcelRegister("dsN6L", function(module, exports) {

var $lPlZF = parcelRequire("lPlZF");
function $9cd3fbc2070a5357$var$_defineProperty(e, r, t) {
    return (r = $lPlZF(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $9cd3fbc2070a5357$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("lPlZF", function(module, exports) {

var $61RDg = parcelRequire("61RDg");
var $fe3f6bda4044d25c$var$_typeof = $61RDg.default;

var $1O0MN = parcelRequire("1O0MN");
function $fe3f6bda4044d25c$var$toPropertyKey(t) {
    var i = $1O0MN(t, "string");
    return "symbol" == $fe3f6bda4044d25c$var$_typeof(i) ? i : i + "";
}
module.exports = $fe3f6bda4044d25c$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("61RDg", function(module, exports) {
function $463c705588f32109$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $463c705588f32109$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $463c705588f32109$var$_typeof(o);
}
module.exports = $463c705588f32109$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1O0MN", function(module, exports) {

var $61RDg = parcelRequire("61RDg");
var $150b120749d82366$var$_typeof = $61RDg.default;
function $150b120749d82366$var$toPrimitive(t, r) {
    if ("object" != $150b120749d82366$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $150b120749d82366$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $150b120749d82366$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("2S8bR", function(module, exports) {

$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $2176fa5179e9d4bc$export$4ef52930e33717cd; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $2176fa5179e9d4bc$export$a00eac3f8684bcd0; });
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", function () { return $2176fa5179e9d4bc$export$2112803007239c61; });
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", function () { return $2176fa5179e9d4bc$export$352e418ed5b6193a; });
$parcel$export(module.exports, "TOKEN_NOT_FOUND_CSS_VAR", function () { return $2176fa5179e9d4bc$export$dddac1532e822863; });
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $2176fa5179e9d4bc$export$9d7b58831ae93caa; });
var $2176fa5179e9d4bc$export$4ef52930e33717cd = 'data-theme';
var $2176fa5179e9d4bc$export$a00eac3f8684bcd0 = 'data-color-mode';
var $2176fa5179e9d4bc$export$2112803007239c61 = 'data-contrast-mode';
var $2176fa5179e9d4bc$export$352e418ed5b6193a = 'data-custom-theme';
var $2176fa5179e9d4bc$export$6f0c6fb8c80fcc92 = 'ds';
var $2176fa5179e9d4bc$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $2176fa5179e9d4bc$export$dddac1532e822863 = "--".concat($2176fa5179e9d4bc$export$6f0c6fb8c80fcc92, "-token-not-found");
var $2176fa5179e9d4bc$export$9d7b58831ae93caa = "--".concat($2176fa5179e9d4bc$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("3cRMM", function(module, exports) {

$parcel$export(module.exports, "themeColorModes", function () { return $255c36d7e950591e$export$83993de8eb66733; });
$parcel$export(module.exports, "themeIds", function () { return $255c36d7e950591e$export$7d43e72a58e3283f; });
$parcel$export(module.exports, "themeStateDefaults", function () { return $255c36d7e950591e$export$9aedcfa7336a207; });
$parcel$export(module.exports, "default", function () { return $255c36d7e950591e$export$2e2bcd8739ae039; });

var $f1k1y = parcelRequire("f1k1y");
var $255c36d7e950591e$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
/**
 * Contrast preferences: The system contrast preference
 */ var $255c36d7e950591e$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
var $255c36d7e950591e$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'light-brand-refresh',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'dark-brand-refresh',
    'legacy-light',
    'legacy-dark',
    'spacing',
    'shape',
    'shape-rounder',
    'shape-roundest',
    'typography',
    'typography-adg3',
    'typography-modernized',
    'typography-refreshed'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $255c36d7e950591e$var$themeOverrideIds = [];
var $255c36d7e950591e$export$92ba366331403db2 = [].concat($255c36d7e950591e$export$7d43e72a58e3283f, $255c36d7e950591e$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $255c36d7e950591e$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-legacy-light': {
        id: 'legacy-light',
        displayName: 'Light Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-legacy-dark': {
        id: 'legacy-dark',
        displayName: 'Dark Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-typography-adg3': {
        id: 'typography-adg3',
        displayName: 'ADG3 Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-shape-rounder': {
        id: 'shape-rounder',
        displayName: 'Shape (Rounder)',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-shape-roundest': {
        id: 'shape-roundest',
        displayName: 'Shape (Roundest)',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-typography-modernized': {
        id: 'typography-modernized',
        displayName: 'Atlassian Typography (Modernized)',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-typography-refreshed': {
        id: 'typography-refreshed',
        displayName: 'Atlassian Typography (Refreshed)',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-light-brand-refresh': {
        id: 'light-brand-refresh',
        displayName: 'Light theme (Brand refresh)',
        palette: 'brandRefreshPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-dark-brand-refresh': {
        id: 'dark-brand-refresh',
        displayName: 'Dark theme (Brand refresh)',
        palette: 'brandRefreshPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    }
};
var $255c36d7e950591e$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: undefined,
    spacing: 'spacing',
    typography: function typography() {
        if ((0, $f1k1y.fg)('platform-disable-default-typography')) return undefined;
        return 'typography';
    },
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $255c36d7e950591e$export$2e2bcd8739ae039 = $255c36d7e950591e$var$themeConfig;

});
parcelRegister("f1k1y", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $aef67b6046402932$export$b40ec24ac8275656; });

var $644tJ = parcelRequire("644tJ");
function $aef67b6046402932$export$ba05d765b8392e5e(flagResolver) {
    (0, $644tJ.setBooleanResolver)(flagResolver);
}
function $aef67b6046402932$export$470e5c2be1411c89(name) {
    return (0, $644tJ.resolveBooleanFlag)(name);
}
function $aef67b6046402932$export$b40ec24ac8275656(name) {
    return (0, $644tJ.resolveBooleanFlag)(name);
}

});
parcelRegister("644tJ", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $46a6971f10699772$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $46a6971f10699772$export$6333b6aff9fc6275; });

var $kRYwT = parcelRequire("kRYwT");

var $3fC94 = parcelRequire("3fC94");

var $e08gr = parcelRequire("e08gr");
var $46a6971f10699772$var$pkgName = '@atlaskit/platform-feature-flags';
var $46a6971f10699772$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $46a6971f10699772$var$hasProcessEnv = typeof $e08gr !== 'undefined' && typeof $e08gr.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $46a6971f10699772$var$ENV_ENABLE_PLATFORM_FF = $46a6971f10699772$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $46a6971f10699772$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $46a6971f10699772$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $46a6971f10699772$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $46a6971f10699772$var$ENV_ENABLE_PLATFORM_FF || $46a6971f10699772$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $46a6971f10699772$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $46a6971f10699772$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$46a6971f10699772$var$globalVar[$46a6971f10699772$export$7e41b1b2bdee3f98] = $46a6971f10699772$var$globalVar[$46a6971f10699772$export$7e41b1b2bdee3f98] || $46a6971f10699772$var$DEFAULT_PFF_GLOBAL;
function $46a6971f10699772$export$f2b591175b3e424c(resolver) {
    $46a6971f10699772$var$globalVar[$46a6971f10699772$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $46a6971f10699772$export$6333b6aff9fc6275(flagKey) {
    if ($46a6971f10699772$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $3fC94.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $46a6971f10699772$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $46a6971f10699772$var$globalVar[$46a6971f10699772$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $46a6971f10699772$var$globalVar[$46a6971f10699772$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $kRYwT.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $46a6971f10699772$var$globalVar[$46a6971f10699772$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("kRYwT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f317b5c3751c7f9d$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "CLIENT_VERSION", function () { return (parcelRequire("i7Qvh")).CLIENT_VERSION; });

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $dsN6L = parcelRequire("dsN6L");

var $jqOUM = parcelRequire("jqOUM");

var $i7Qvh = parcelRequire("i7Qvh");



var $c0Ow7 = parcelRequire("c0Ow7");
var $f317b5c3751c7f9d$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $f317b5c3751c7f9d$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$f317b5c3751c7f9d$var$_FeatureGates = $f317b5c3751c7f9d$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($f317b5c3751c7f9d$var$FeatureGates, "client", new (0, $jqOUM.Client)());
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($f317b5c3751c7f9d$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($f317b5c3751c7f9d$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($f317b5c3751c7f9d$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$f317b5c3751c7f9d$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $f317b5c3751c7f9d$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $f317b5c3751c7f9d$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($f317b5c3751c7f9d$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$f317b5c3751c7f9d$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $f317b5c3751c7f9d$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $f317b5c3751c7f9d$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($f317b5c3751c7f9d$var$FeatureGates, "initializeCalled", $f317b5c3751c7f9d$var$_FeatureGates.client.initializeCalled.bind($f317b5c3751c7f9d$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($f317b5c3751c7f9d$var$FeatureGates, "initializeCompleted", $f317b5c3751c7f9d$var$_FeatureGates.client.initializeCompleted.bind($f317b5c3751c7f9d$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($f317b5c3751c7f9d$var$FeatureGates, "initialize", $f317b5c3751c7f9d$var$_FeatureGates.client.initialize.bind($f317b5c3751c7f9d$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($f317b5c3751c7f9d$var$FeatureGates, "initializeWithProvider", $f317b5c3751c7f9d$var$_FeatureGates.client.initializeWithProvider.bind($f317b5c3751c7f9d$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($f317b5c3751c7f9d$var$FeatureGates, "initializeFromValues", $f317b5c3751c7f9d$var$_FeatureGates.client.initializeFromValues.bind($f317b5c3751c7f9d$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($f317b5c3751c7f9d$var$FeatureGates, "manuallyLogGateExposure", $f317b5c3751c7f9d$var$_FeatureGates.client.manuallyLogGateExposure.bind($f317b5c3751c7f9d$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($f317b5c3751c7f9d$var$FeatureGates, "getExperiment", $f317b5c3751c7f9d$var$_FeatureGates.client.getExperiment.bind($f317b5c3751c7f9d$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($f317b5c3751c7f9d$var$FeatureGates, "manuallyLogExperimentExposure", $f317b5c3751c7f9d$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($f317b5c3751c7f9d$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($f317b5c3751c7f9d$var$FeatureGates, "manuallyLogLayerExposure", $f317b5c3751c7f9d$var$_FeatureGates.client.manuallyLogLayerExposure.bind($f317b5c3751c7f9d$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($f317b5c3751c7f9d$var$FeatureGates, "shutdownStatsig", $f317b5c3751c7f9d$var$_FeatureGates.client.shutdownStatsig.bind($f317b5c3751c7f9d$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($f317b5c3751c7f9d$var$FeatureGates, "overrideGate", $f317b5c3751c7f9d$var$_FeatureGates.client.overrideGate.bind($f317b5c3751c7f9d$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($f317b5c3751c7f9d$var$FeatureGates, "clearGateOverride", $f317b5c3751c7f9d$var$_FeatureGates.client.clearGateOverride.bind($f317b5c3751c7f9d$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($f317b5c3751c7f9d$var$FeatureGates, "overrideConfig", $f317b5c3751c7f9d$var$_FeatureGates.client.overrideConfig.bind($f317b5c3751c7f9d$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($f317b5c3751c7f9d$var$FeatureGates, "clearConfigOverride", $f317b5c3751c7f9d$var$_FeatureGates.client.clearConfigOverride.bind($f317b5c3751c7f9d$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($f317b5c3751c7f9d$var$FeatureGates, "setOverrides", $f317b5c3751c7f9d$var$_FeatureGates.client.setOverrides.bind($f317b5c3751c7f9d$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($f317b5c3751c7f9d$var$FeatureGates, "getOverrides", $f317b5c3751c7f9d$var$_FeatureGates.client.getOverrides.bind($f317b5c3751c7f9d$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($f317b5c3751c7f9d$var$FeatureGates, "clearAllOverrides", $f317b5c3751c7f9d$var$_FeatureGates.client.clearAllOverrides.bind($f317b5c3751c7f9d$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($f317b5c3751c7f9d$var$FeatureGates, "isCurrentUser", $f317b5c3751c7f9d$var$_FeatureGates.client.isCurrentUser.bind($f317b5c3751c7f9d$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($f317b5c3751c7f9d$var$FeatureGates, "onGateUpdated", $f317b5c3751c7f9d$var$_FeatureGates.client.onGateUpdated.bind($f317b5c3751c7f9d$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($f317b5c3751c7f9d$var$FeatureGates, "onExperimentValueUpdated", $f317b5c3751c7f9d$var$_FeatureGates.client.onExperimentValueUpdated.bind($f317b5c3751c7f9d$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($f317b5c3751c7f9d$var$FeatureGates, "onAnyUpdated", $f317b5c3751c7f9d$var$_FeatureGates.client.onAnyUpdated.bind($f317b5c3751c7f9d$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($f317b5c3751c7f9d$var$FeatureGates, "updateUser", $f317b5c3751c7f9d$var$_FeatureGates.client.updateUser.bind($f317b5c3751c7f9d$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($f317b5c3751c7f9d$var$FeatureGates, "updateUserWithProvider", $f317b5c3751c7f9d$var$_FeatureGates.client.updateUserWithProvider.bind($f317b5c3751c7f9d$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($f317b5c3751c7f9d$var$FeatureGates, "updateUserWithValues", $f317b5c3751c7f9d$var$_FeatureGates.client.updateUserWithValues.bind($f317b5c3751c7f9d$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($f317b5c3751c7f9d$var$FeatureGates, "getPackageVersion", $f317b5c3751c7f9d$var$_FeatureGates.client.getPackageVersion.bind($f317b5c3751c7f9d$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($f317b5c3751c7f9d$var$FeatureGates, "getLayer", $f317b5c3751c7f9d$var$_FeatureGates.client.getLayer.bind($f317b5c3751c7f9d$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($f317b5c3751c7f9d$var$FeatureGates, "getLayerValue", $f317b5c3751c7f9d$var$_FeatureGates.client.getLayerValue.bind($f317b5c3751c7f9d$var$_FeatureGates.client));
var $f317b5c3751c7f9d$var$boundFGJS = $f317b5c3751c7f9d$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $f317b5c3751c7f9d$var$FeatureGates;
    else {
        var $f317b5c3751c7f9d$var$_boundFGJS, $f317b5c3751c7f9d$var$_boundFGJS$getPackage;
        $f317b5c3751c7f9d$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $f317b5c3751c7f9d$var$boundVersion = (($f317b5c3751c7f9d$var$_boundFGJS = $f317b5c3751c7f9d$var$boundFGJS) === null || $f317b5c3751c7f9d$var$_boundFGJS === void 0 || ($f317b5c3751c7f9d$var$_boundFGJS$getPackage = $f317b5c3751c7f9d$var$_boundFGJS.getPackageVersion) === null || $f317b5c3751c7f9d$var$_boundFGJS$getPackage === void 0 ? void 0 : $f317b5c3751c7f9d$var$_boundFGJS$getPackage.call($f317b5c3751c7f9d$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($f317b5c3751c7f9d$var$boundVersion !== (0, $i7Qvh.CLIENT_VERSION)) {
            var $f317b5c3751c7f9d$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($f317b5c3751c7f9d$var$boundVersion, " when module version ").concat((0, $i7Qvh.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($f317b5c3751c7f9d$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $f317b5c3751c7f9d$export$2e2bcd8739ae039 = $f317b5c3751c7f9d$var$boundFGJS;

});
parcelRegister("3lbuJ", function(module, exports) {
function $26ec3fd729209353$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $26ec3fd729209353$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("iTPYb", function(module, exports) {

var $lPlZF = parcelRequire("lPlZF");
function $dc25ad235fd04aa5$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $lPlZF(o.key), o);
    }
}
function $dc25ad235fd04aa5$var$_createClass(e, r, t) {
    return r && $dc25ad235fd04aa5$var$_defineProperties(e.prototype, r), t && $dc25ad235fd04aa5$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $dc25ad235fd04aa5$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jqOUM", function(module, exports) {

$parcel$export(module.exports, "Client", function () { return $e257f0a0baee932a$export$1f2bb630327ac4b6; });

var $ai2Md = parcelRequire("ai2Md");

var $5YM7L = parcelRequire("5YM7L");

var $2R76C = parcelRequire("2R76C");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $dsN6L = parcelRequire("dsN6L");

var $eWMMH = parcelRequire("eWMMH");

var $65IDm = parcelRequire("65IDm");

var $5h5gj = parcelRequire("5h5gj");

var $5nkgG = parcelRequire("5nkgG");

var $etNe6 = parcelRequire("etNe6");

var $4LQfc = parcelRequire("4LQfc");

var $bYy5Y = parcelRequire("bYy5Y");

var $iOJep = parcelRequire("iOJep");

var $dgvCq = parcelRequire("dgvCq");

var $c0Ow7 = parcelRequire("c0Ow7");

var $i3XRq = parcelRequire("i3XRq");

var $i7Qvh = parcelRequire("i7Qvh");
var $e257f0a0baee932a$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $e257f0a0baee932a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e257f0a0baee932a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e257f0a0baee932a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e257f0a0baee932a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e257f0a0baee932a$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $e257f0a0baee932a$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $e257f0a0baee932a$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $dgvCq.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "subscriptions", new (0, $5h5gj.default)());
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "dataAdapter", new (0, $iOJep.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $dgvCq.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $i3XRq.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $i3XRq.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $i3XRq.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $i3XRq.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $i7Qvh.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $e257f0a0baee932a$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $i7Qvh.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $c0Ow7.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $i3XRq.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $i3XRq.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $i3XRq.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $bYy5Y.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $5nkgG.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $5nkgG.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $4LQfc.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $i3XRq.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $i3XRq.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee7(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                fromValuesClientOptions = $e257f0a0baee932a$var$_objectSpread({}, clientOptions);
                                _context7.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $bYy5Y.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $bYy5Y.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context7.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context7.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context7.next = 20;
                                break;
                            case 13:
                                _context7.prev = 13;
                                _context7.t0 = _context7["catch"](1);
                                if (_context7.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context7.t0 === null || _context7.t0 === void 0 ? void 0 : _context7.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context7.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context7.t0;
                            case 20:
                                return _context7.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee8(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $e257f0a0baee932a$var$_objectSpread($e257f0a0baee932a$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context8.prev = 1;
                                _context8.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context8.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context8.next = 22;
                                break;
                            case 15:
                                _context8.prev = 15;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context8.t0;
                            case 22:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee9(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args9 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                initializeValues = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $i3XRq.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $e257f0a0baee932a$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $e257f0a0baee932a$var$_objectSpread($e257f0a0baee932a$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $e257f0a0baee932a$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $c0Ow7.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(newClientOptions, $e257f0a0baee932a$var$_excluded);
                                this.user = (0, $i3XRq.toStatsigUser)(identifiers, customAttributes);
                                statsigOptions = $e257f0a0baee932a$var$_objectSpread($e257f0a0baee932a$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $65IDm.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $65IDm.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context9.prev = 12;
                                this.statsigClient = new (0, $65IDm.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context9.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context9.next = 29;
                                break;
                            case 19:
                                _context9.prev = 19;
                                _context9.t0 = _context9["catch"](12);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $65IDm.StatsigClient)($e257f0a0baee932a$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context9.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context9.t0;
                            case 29:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee1(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee1$(_context1) {
                        while(true)switch(_context1.prev = _context1.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context1.next = 3;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context1.next = 5;
                                    break;
                                }
                                return _context1.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context1.prev = 6;
                                _context1.next = 9;
                                return this.initPromise;
                            case 9:
                                _context1.next = 13;
                                break;
                            case 11:
                                _context1.prev = 11;
                                _context1.t0 = _context1["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee0() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee0$(_context0) {
                                        while(true)switch(_context0.prev = _context0.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context0.next = 4;
                                                    break;
                                                }
                                                _context0.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context0.stop();
                                        }
                                    }, _callee0);
                                })));
                                return _context1.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context1.stop();
                        }
                    }, _callee1, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee10(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context10.prev = 1;
                                _context10.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context10.sent;
                                user = (0, $i3XRq.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                _context10.next = 13;
                                break;
                            case 8:
                                _context10.prev = 8;
                                _context10.t0 = _context10["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context10.t0 instanceof Error ? _context10.t0.message : JSON.stringify(_context10.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context10.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context10.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context10.next = 21;
                                    break;
                                }
                                _context10.next = 21;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 21:
                                _context10.next = 27;
                                break;
                            case 23:
                                _context10.prev = 23;
                                _context10.t1 = _context10["catch"](15);
                                success = false;
                                errorMessage = String(_context10.t1);
                            case 27:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context10.next = 34;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context10.next = 35;
                                break;
                            case 34:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 35:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            23
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $i7Qvh.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $etNe6.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $etNe6.Layer).fromLayer((0, $65IDm._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("ai2Md", function(module, exports) {

var $218Qy = parcelRequire("218Qy");
function $77ddbd36f5e1549c$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $218Qy(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $77ddbd36f5e1549c$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("218Qy", function(module, exports) {
function $1782898b3f81be5b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $1782898b3f81be5b$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("2R76C", function(module, exports) {
function $21460b0dd94da407$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $21460b0dd94da407$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $21460b0dd94da407$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $21460b0dd94da407$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $21460b0dd94da407$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("eWMMH", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $ae1c530c936f4933$var$runtime = (parcelRequire("iB8a0"))();
module.exports = $ae1c530c936f4933$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $ae1c530c936f4933$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $ae1c530c936f4933$var$runtime;
    else Function("r", "regeneratorRuntime = r")($ae1c530c936f4933$var$runtime);
}

});
parcelRegister("iB8a0", function(module, exports) {

var $h4HKL = parcelRequire("h4HKL");

var $fK55E = parcelRequire("fK55E");

var $g9b1A = parcelRequire("g9b1A");

var $9rfbF = parcelRequire("9rfbF");

var $2Jd6W = parcelRequire("2Jd6W");

var $dYt8r = parcelRequire("dYt8r");

var $aev3B = parcelRequire("aev3B");
function $d8a20329968b5ece$var$_regeneratorRuntime() {
    "use strict";
    var r = $fK55E(), e = r.m($d8a20329968b5ece$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $aev3B(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $d8a20329968b5ece$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $h4HKL(r, e);
            },
            AsyncIterator: $2Jd6W,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $9rfbF : $g9b1A)(a(r), e, t, o, u);
            },
            keys: $dYt8r,
            values: $aev3B
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $d8a20329968b5ece$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("h4HKL", function(module, exports) {
function $c6e4bfde10fe93ac$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $c6e4bfde10fe93ac$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fK55E", function(module, exports) {

var $jZmFE = parcelRequire("jZmFE");
function $b75f19af2c999544$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $jZmFE(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($jZmFE(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $jZmFE(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $jZmFE(u, "constructor", GeneratorFunctionPrototype), $jZmFE(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $jZmFE(GeneratorFunctionPrototype, o, "GeneratorFunction"), $jZmFE(u), $jZmFE(u, o, "Generator"), $jZmFE(u, n, function() {
        return this;
    }), $jZmFE(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $b75f19af2c999544$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $b75f19af2c999544$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jZmFE", function(module, exports) {
function $e8d54cc061184849$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $e8d54cc061184849$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        if (r) i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n;
        else {
            var o = function o(r, n) {
                $e8d54cc061184849$var$_regeneratorDefine(e, r, function(e) {
                    return this._invoke(r, n, e);
                });
            };
            o("next", 0), o("throw", 1), o("return", 2);
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $e8d54cc061184849$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $e8d54cc061184849$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("g9b1A", function(module, exports) {

var $9rfbF = parcelRequire("9rfbF");
function $bc1609e025ff1592$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $9rfbF(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $bc1609e025ff1592$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9rfbF", function(module, exports) {

var $fK55E = parcelRequire("fK55E");

var $2Jd6W = parcelRequire("2Jd6W");
function $6df26a862ba5aa61$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $2Jd6W($fK55E().w(r, e, t, o), n || Promise);
}
module.exports = $6df26a862ba5aa61$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2Jd6W", function(module, exports) {

var $h4HKL = parcelRequire("h4HKL");

var $jZmFE = parcelRequire("jZmFE");
function $1fc9f44dbf7487fa$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $h4HKL ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($jZmFE($1fc9f44dbf7487fa$var$AsyncIterator.prototype), $jZmFE($1fc9f44dbf7487fa$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $jZmFE(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $1fc9f44dbf7487fa$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("dYt8r", function(module, exports) {
function $a2c77a9c5c0b804e$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $a2c77a9c5c0b804e$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("aev3B", function(module, exports) {

var $61RDg = parcelRequire("61RDg");
var $77334d7947739289$var$_typeof = $61RDg.default;
function $77334d7947739289$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($77334d7947739289$var$_typeof(e) + " is not iterable");
}
module.exports = $77334d7947739289$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("65IDm", function(module, exports) {
"use strict";
var $46f5d515d44a65a9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $46f5d515d44a65a9$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $46f5d515d44a65a9$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;


var $5XiwI = parcelRequire("5XiwI");
module.exports.StatsigClient = $5XiwI.default;

$46f5d515d44a65a9$var$__exportStar((parcelRequire("ku4nR")), module.exports);
const $46f5d515d44a65a9$var$__STATSIG__ = Object.assign((0, (parcelRequire("ku4nR"))._getStatsigGlobal)(), {
    StatsigClient: $5XiwI.default
});
module.exports.default = $46f5d515d44a65a9$var$__STATSIG__;

});
parcelRegister("ku4nR", function(module, exports) {
"use strict";
var $ee9a02867b3455f5$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ee9a02867b3455f5$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ee9a02867b3455f5$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("4eHof")).Diagnostics;
    }
});

var $iZxCm = parcelRequire("iZxCm");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $iZxCm.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("kp0SQ")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("e49tN")).Storage;
    }
});

$ee9a02867b3455f5$var$__exportStar((parcelRequire("lptyf")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("fV2Nk")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("hL4Fz")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("lBhsv")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("4eHof")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("25vFD")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("8MU8V")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("fApYm")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("3YWWK")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("aSqZn")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("aFstg")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("kp0SQ")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("grJ5h")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("cVXgQ")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("60Pni")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("4Lrnq")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("4jypg")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("fyllS")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("1PZH9")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("3Wwnx")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("8wFhx")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("4ISnd")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("lDOHr")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("1qgQ6")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("hqFB2")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("1Tyyb")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("28sXv")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("9i5vR")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("6E7aU")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("h63QG")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("58Rur")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("5H0FU")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("e49tN")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("feMSz")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("dfkhs")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("i0tcK")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("4620b")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("2B8R6")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("9peM0")), module.exports);

$ee9a02867b3455f5$var$__exportStar((parcelRequire("4loRs")), module.exports);
Object.assign((0, (parcelRequire("lptyf"))._getStatsigGlobal)(), {
    Log: (parcelRequire("kp0SQ")).Log,
    SDK_VERSION: (parcelRequire("28sXv")).SDK_VERSION
});

});
parcelRegister("lptyf", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $f962db0e053171a8$var$_a, $f962db0e053171a8$var$_b, $f962db0e053171a8$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $kp0SQ = parcelRequire("kp0SQ");
const $f962db0e053171a8$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== 'undefined' ? __STATSIG__ : $f962db0e053171a8$var$statsigGlobal;
    } catch (e) {
        return $f962db0e053171a8$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $f962db0e053171a8$var$_getStatsigGlobal;
const $f962db0e053171a8$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $f962db0e053171a8$var$_getStatsigGlobalFlag;
const $f962db0e053171a8$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $kp0SQ.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $f962db0e053171a8$var$_getInstance;
const $f962db0e053171a8$var$GLOBAL_KEY = '__STATSIG__';
const $f962db0e053171a8$var$_window = typeof window !== 'undefined' ? window : {};
const $f962db0e053171a8$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $f962db0e053171a8$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $f962db0e053171a8$var$statsigGlobal = ($f962db0e053171a8$var$_c = ($f962db0e053171a8$var$_b = ($f962db0e053171a8$var$_a = $f962db0e053171a8$var$_window[$f962db0e053171a8$var$GLOBAL_KEY]) !== null && $f962db0e053171a8$var$_a !== void 0 ? $f962db0e053171a8$var$_a : $f962db0e053171a8$var$_global[$f962db0e053171a8$var$GLOBAL_KEY]) !== null && $f962db0e053171a8$var$_b !== void 0 ? $f962db0e053171a8$var$_b : $f962db0e053171a8$var$_globalThis[$f962db0e053171a8$var$GLOBAL_KEY]) !== null && $f962db0e053171a8$var$_c !== void 0 ? $f962db0e053171a8$var$_c : {
    instance: module.exports._getInstance
};
$f962db0e053171a8$var$_window[$f962db0e053171a8$var$GLOBAL_KEY] = $f962db0e053171a8$var$statsigGlobal;
$f962db0e053171a8$var$_global[$f962db0e053171a8$var$GLOBAL_KEY] = $f962db0e053171a8$var$statsigGlobal;
$f962db0e053171a8$var$_globalThis[$f962db0e053171a8$var$GLOBAL_KEY] = $f962db0e053171a8$var$statsigGlobal;

});
parcelRegister("kp0SQ", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $eda6d3e9593e7929$var$DEBUG = ' DEBUG ';
const $eda6d3e9593e7929$var$_INFO = '  INFO ';
const $eda6d3e9593e7929$var$_WARN = '  WARN ';
const $eda6d3e9593e7929$var$ERROR = ' ERROR ';
function $eda6d3e9593e7929$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $eda6d3e9593e7929$var$Log {
    static info(...args) {
        if ($eda6d3e9593e7929$var$Log.level >= module.exports.LogLevel.Info) console.info($eda6d3e9593e7929$var$_INFO, ...$eda6d3e9593e7929$var$addTag(args));
    }
    static debug(...args) {
        if ($eda6d3e9593e7929$var$Log.level >= module.exports.LogLevel.Debug) console.debug($eda6d3e9593e7929$var$DEBUG, ...$eda6d3e9593e7929$var$addTag(args));
    }
    static warn(...args) {
        if ($eda6d3e9593e7929$var$Log.level >= module.exports.LogLevel.Warn) console.warn($eda6d3e9593e7929$var$_WARN, ...$eda6d3e9593e7929$var$addTag(args));
    }
    static error(...args) {
        if ($eda6d3e9593e7929$var$Log.level >= module.exports.LogLevel.Error) console.error($eda6d3e9593e7929$var$ERROR, ...$eda6d3e9593e7929$var$addTag(args));
    }
}
module.exports.Log = $eda6d3e9593e7929$var$Log;
$eda6d3e9593e7929$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("4eHof", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $315a209feea95068$var$MARKER_MAP = new Map();
const $315a209feea95068$var$ACT_START = 'start';
const $315a209feea95068$var$ACT_END = 'end';
const $315a209feea95068$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $315a209feea95068$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $315a209feea95068$var$_addMarker(sdkKey, $315a209feea95068$var$_createMarker({}, $315a209feea95068$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $315a209feea95068$var$_addMarker(sdkKey, $315a209feea95068$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $315a209feea95068$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $315a209feea95068$var$_addMarker(sdkKey, $315a209feea95068$var$_createMarker(data, $315a209feea95068$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $315a209feea95068$var$_addMarker(sdkKey, $315a209feea95068$var$_createMarker(data, $315a209feea95068$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $315a209feea95068$var$_addMarker(sdkKey, $315a209feea95068$var$_createMarker({}, $315a209feea95068$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $315a209feea95068$var$_addMarker(sdkKey, $315a209feea95068$var$_createMarker(data, $315a209feea95068$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $315a209feea95068$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $315a209feea95068$var$_safeGetField(e, 'code'),
            name: $315a209feea95068$var$_safeGetField(e, 'name'),
            message: $315a209feea95068$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $315a209feea95068$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $315a209feea95068$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $315a209feea95068$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $315a209feea95068$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $315a209feea95068$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $315a209feea95068$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $315a209feea95068$var$MARKER_MAP.set(sdkKey, markers);
}
function $315a209feea95068$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("iZxCm", function(module, exports) {
"use strict";
var $dd380041ba980c49$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $fV2Nk = parcelRequire("fV2Nk");

var $aSqZn = parcelRequire("aSqZn");

var $kp0SQ = parcelRequire("kp0SQ");

var $cVXgQ = parcelRequire("cVXgQ");

var $fyllS = parcelRequire("fyllS");

var $1Tyyb = parcelRequire("1Tyyb");

var $9i5vR = parcelRequire("9i5vR");

var $e49tN = parcelRequire("e49tN");

var $i0tcK = parcelRequire("i0tcK");

var $2B8R6 = parcelRequire("2B8R6");
const $dd380041ba980c49$var$DEFAULT_QUEUE_SIZE = 100;
const $dd380041ba980c49$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $dd380041ba980c49$var$MAX_DEDUPER_KEYS = 1000;
const $dd380041ba980c49$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $dd380041ba980c49$var$MAX_FAILED_LOGS = 500;
const $dd380041ba980c49$var$QUICK_FLUSH_WINDOW_MS = 200;
const $dd380041ba980c49$var$EVENT_LOGGER_MAP = {};
const $dd380041ba980c49$var$RetryFailedLogsTrigger = {
    Startup: 'startup',
    GainedFocus: 'gained_focus'
};
class $dd380041ba980c49$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $dd380041ba980c49$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $dd380041ba980c49$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs($dd380041ba980c49$var$RetryFailedLogsTrigger.GainedFocus);
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(loggingEnabled) {
        this._loggingEnabled = loggingEnabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $dd380041ba980c49$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $fyllS._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always') return;
        $dd380041ba980c49$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $2B8R6._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $dd380041ba980c49$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') $dd380041ba980c49$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs($dd380041ba980c49$var$RetryFailedLogsTrigger.Startup);
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $dd380041ba980c49$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $dd380041ba980c49$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $dd380041ba980c49$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $dd380041ba980c49$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$dd380041ba980c49$var$EventLogger._safeFlushAndForget(this._sdkKey), $dd380041ba980c49$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always' && (0, $fyllS._isServerEnv)()) return false;
        if (!(0, $1Tyyb._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $fV2Nk._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $dd380041ba980c49$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $dd380041ba980c49$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        return $dd380041ba980c49$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (this._loggingEnabled === 'disabled') {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $2B8R6._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: events
                });
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: 'logs_flushed',
                        events: events
                    });
                    return true;
                } else {
                    $kp0SQ.Log.warn('Failed to flush events.');
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $kp0SQ.Log.warn('Failed to flush events.');
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        return $dd380041ba980c49$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return {
            success: this._network.beacon(this._getRequestData(events))
        };
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$cVXgQ.NetworkParam.EventCount]: String(events.length)
            },
            credentials: 'same-origin'
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > $dd380041ba980c49$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            (0, $e49tN._setObjectInStorage)(storageKey, events);
        } catch (_a) {
            $kp0SQ.Log.warn('Unable to save failed logs to storage');
        }
    }
    _retryFailedLogs(trigger) {
        const storageKey = this._getStorageKey();
        (()=>$dd380041ba980c49$var$__awaiter(this, void 0, void 0, function*() {
                if (!$e49tN.Storage.isReady()) yield $e49tN.Storage.isReadyResolver();
                const events = (0, $e49tN._getObjectFromStorage)(storageKey);
                if (!events) return;
                if (trigger === $dd380041ba980c49$var$RetryFailedLogsTrigger.Startup) $e49tN.Storage.removeItem(storageKey);
                const isSuccess = yield this._sendEvents(events);
                if (isSuccess && trigger === $dd380041ba980c49$var$RetryFailedLogsTrigger.GainedFocus) $e49tN.Storage.removeItem(storageKey);
            }))().catch(()=>{
            $kp0SQ.Log.warn('Failed to flush stored logs');
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $aSqZn._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $kp0SQ.Log.debug('Enqueued Event:', final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $fyllS._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $dd380041ba980c49$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $dd380041ba980c49$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $dd380041ba980c49$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a, _b;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $9i5vR.LoggingEnabledOption.disabled : $9i5vR.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $kp0SQ.Log.warn('Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.');
        this._maxQueueSize = (_b = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $dd380041ba980c49$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $i0tcK.UrlConfiguration($cVXgQ.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
}
module.exports.EventLogger = $dd380041ba980c49$var$EventLogger;

});
parcelRegister("fV2Nk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $aSqZn = parcelRequire("aSqZn");
function $b96e58dd4ad5226d$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $aSqZn._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $b96e58dd4ad5226d$var$_getUserStorageKey;
function $b96e58dd4ad5226d$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $b96e58dd4ad5226d$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $aSqZn._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $b96e58dd4ad5226d$var$_getStorageKey;

});
parcelRegister("aSqZn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $dfkhs = parcelRequire("dfkhs");
const $7eb3e1fd173821d5$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $7eb3e1fd173821d5$var$_DJB2;
const $7eb3e1fd173821d5$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $7eb3e1fd173821d5$var$_DJB2Object;
const $7eb3e1fd173821d5$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $dfkhs._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $7eb3e1fd173821d5$var$_getSortedObject;

});
parcelRegister("dfkhs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $9a4c685eadc3cae6$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $9a4c685eadc3cae6$var$_typeOf;
function $9a4c685eadc3cae6$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : x === null ? 'null' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $9a4c685eadc3cae6$var$_isTypeMatch;

});



parcelRegister("cVXgQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("fyllS", function(module, exports) {

var $e08gr = parcelRequire("e08gr");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $b52a980a09baaf09$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $b52a980a09baaf09$var$_getWindowSafe;
const $b52a980a09baaf09$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $b52a980a09baaf09$var$_getDocumentSafe;
const $b52a980a09baaf09$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $e08gr !== 'undefined' && $e08gr.versions != null && $e08gr.versions.node != null;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $b52a980a09baaf09$var$_isServerEnv;
const $b52a980a09baaf09$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $b52a980a09baaf09$var$_addWindowEventListenerSafe;
const $b52a980a09baaf09$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $b52a980a09baaf09$var$_addDocumentEventListenerSafe;
const $b52a980a09baaf09$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $b52a980a09baaf09$var$_getCurrentPageUrlSafe;
const $b52a980a09baaf09$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return 'beforeunload';
    const eventType = 'onpagehide' in win ? 'pagehide' : 'beforeunload';
    return eventType;
};
module.exports._getUnloadEvent = $b52a980a09baaf09$var$_getUnloadEvent;

});
parcelRegister("e08gr", function(module, exports) {
// shim for using process in browser
var $a31779e305fa5364$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $a31779e305fa5364$var$cachedSetTimeout;
var $a31779e305fa5364$var$cachedClearTimeout;
function $a31779e305fa5364$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $a31779e305fa5364$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $a31779e305fa5364$var$cachedSetTimeout = setTimeout;
        else $a31779e305fa5364$var$cachedSetTimeout = $a31779e305fa5364$var$defaultSetTimout;
    } catch (e) {
        $a31779e305fa5364$var$cachedSetTimeout = $a31779e305fa5364$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $a31779e305fa5364$var$cachedClearTimeout = clearTimeout;
        else $a31779e305fa5364$var$cachedClearTimeout = $a31779e305fa5364$var$defaultClearTimeout;
    } catch (e) {
        $a31779e305fa5364$var$cachedClearTimeout = $a31779e305fa5364$var$defaultClearTimeout;
    }
})();
function $a31779e305fa5364$var$runTimeout(fun) {
    if ($a31779e305fa5364$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($a31779e305fa5364$var$cachedSetTimeout === $a31779e305fa5364$var$defaultSetTimout || !$a31779e305fa5364$var$cachedSetTimeout) && setTimeout) {
        $a31779e305fa5364$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $a31779e305fa5364$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $a31779e305fa5364$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $a31779e305fa5364$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $a31779e305fa5364$var$runClearTimeout(marker) {
    if ($a31779e305fa5364$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($a31779e305fa5364$var$cachedClearTimeout === $a31779e305fa5364$var$defaultClearTimeout || !$a31779e305fa5364$var$cachedClearTimeout) && clearTimeout) {
        $a31779e305fa5364$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $a31779e305fa5364$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $a31779e305fa5364$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $a31779e305fa5364$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $a31779e305fa5364$var$queue = [];
var $a31779e305fa5364$var$draining = false;
var $a31779e305fa5364$var$currentQueue;
var $a31779e305fa5364$var$queueIndex = -1;
function $a31779e305fa5364$var$cleanUpNextTick() {
    if (!$a31779e305fa5364$var$draining || !$a31779e305fa5364$var$currentQueue) return;
    $a31779e305fa5364$var$draining = false;
    if ($a31779e305fa5364$var$currentQueue.length) $a31779e305fa5364$var$queue = $a31779e305fa5364$var$currentQueue.concat($a31779e305fa5364$var$queue);
    else $a31779e305fa5364$var$queueIndex = -1;
    if ($a31779e305fa5364$var$queue.length) $a31779e305fa5364$var$drainQueue();
}
function $a31779e305fa5364$var$drainQueue() {
    if ($a31779e305fa5364$var$draining) return;
    var timeout = $a31779e305fa5364$var$runTimeout($a31779e305fa5364$var$cleanUpNextTick);
    $a31779e305fa5364$var$draining = true;
    var len = $a31779e305fa5364$var$queue.length;
    while(len){
        $a31779e305fa5364$var$currentQueue = $a31779e305fa5364$var$queue;
        $a31779e305fa5364$var$queue = [];
        while(++$a31779e305fa5364$var$queueIndex < len)if ($a31779e305fa5364$var$currentQueue) $a31779e305fa5364$var$currentQueue[$a31779e305fa5364$var$queueIndex].run();
        $a31779e305fa5364$var$queueIndex = -1;
        len = $a31779e305fa5364$var$queue.length;
    }
    $a31779e305fa5364$var$currentQueue = null;
    $a31779e305fa5364$var$draining = false;
    $a31779e305fa5364$var$runClearTimeout(timeout);
}
$a31779e305fa5364$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $a31779e305fa5364$var$queue.push(new $a31779e305fa5364$var$Item(fun, args));
    if ($a31779e305fa5364$var$queue.length === 1 && !$a31779e305fa5364$var$draining) $a31779e305fa5364$var$runTimeout($a31779e305fa5364$var$drainQueue);
};
// v8 likes predictible objects
function $a31779e305fa5364$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$a31779e305fa5364$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$a31779e305fa5364$var$process.title = 'browser';
$a31779e305fa5364$var$process.browser = true;
$a31779e305fa5364$var$process.env = {};
$a31779e305fa5364$var$process.argv = [];
$a31779e305fa5364$var$process.version = ''; // empty string to avoid regexp issues
$a31779e305fa5364$var$process.versions = {};
function $a31779e305fa5364$var$noop() {}
$a31779e305fa5364$var$process.on = $a31779e305fa5364$var$noop;
$a31779e305fa5364$var$process.addListener = $a31779e305fa5364$var$noop;
$a31779e305fa5364$var$process.once = $a31779e305fa5364$var$noop;
$a31779e305fa5364$var$process.off = $a31779e305fa5364$var$noop;
$a31779e305fa5364$var$process.removeListener = $a31779e305fa5364$var$noop;
$a31779e305fa5364$var$process.removeAllListeners = $a31779e305fa5364$var$noop;
$a31779e305fa5364$var$process.emit = $a31779e305fa5364$var$noop;
$a31779e305fa5364$var$process.prependListener = $a31779e305fa5364$var$noop;
$a31779e305fa5364$var$process.prependOnceListener = $a31779e305fa5364$var$noop;
$a31779e305fa5364$var$process.listeners = function(name) {
    return [];
};
$a31779e305fa5364$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$a31779e305fa5364$var$process.cwd = function() {
    return '/';
};
$a31779e305fa5364$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$a31779e305fa5364$var$process.umask = function() {
    return 0;
};

});


parcelRegister("1Tyyb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $1615ba7ed5001700$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $1615ba7ed5001700$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $1615ba7ed5001700$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $1615ba7ed5001700$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $1615ba7ed5001700$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $1615ba7ed5001700$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $1615ba7ed5001700$var$GATE_EXPOSURE_NAME || eventName === $1615ba7ed5001700$var$CONFIG_EXPOSURE_NAME || eventName === $1615ba7ed5001700$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $1615ba7ed5001700$var$_isExposureEvent;
const $1615ba7ed5001700$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $1615ba7ed5001700$var$_createExposure($1615ba7ed5001700$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $1615ba7ed5001700$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $1615ba7ed5001700$var$_createGateExposure;
function $1615ba7ed5001700$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === 'string') return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $1615ba7ed5001700$var$_mapExposures;
const $1615ba7ed5001700$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $1615ba7ed5001700$var$_createExposure($1615ba7ed5001700$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $1615ba7ed5001700$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $1615ba7ed5001700$var$_createConfigExposure;
const $1615ba7ed5001700$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $1615ba7ed5001700$var$_createExposure($1615ba7ed5001700$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $1615ba7ed5001700$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $1615ba7ed5001700$var$_createLayerParameterExposure;
const $1615ba7ed5001700$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("9i5vR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: 'd',
    /** Compress request bodies unless a network proxy is configured */ Enabled: 'e',
    /** Always compress request bodies, even when a proxy is configured */ Forced: 'f'
};
module.exports.LoggingEnabledOption = {
    disabled: 'disabled',
    browserOnly: 'browser-only',
    always: 'always'
};

});

parcelRegister("e49tN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $kp0SQ = parcelRequire("kp0SQ");

var $fyllS = parcelRequire("fyllS");
const $a3d8cae0c4348d5a$var$inMemoryStore = {};
const $a3d8cae0c4348d5a$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$a3d8cae0c4348d5a$var$inMemoryStore[key] ? $a3d8cae0c4348d5a$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $a3d8cae0c4348d5a$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $a3d8cae0c4348d5a$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($a3d8cae0c4348d5a$var$inMemoryStore)
};
let $a3d8cae0c4348d5a$var$_localStorageProvider = null;
try {
    const win = (0, $fyllS._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $a3d8cae0c4348d5a$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $kp0SQ.Log.warn('Failed to setup localStorageProvider.');
}
let $a3d8cae0c4348d5a$var$_main = $a3d8cae0c4348d5a$var$_localStorageProvider !== null && $a3d8cae0c4348d5a$var$_localStorageProvider !== void 0 ? $a3d8cae0c4348d5a$var$_localStorageProvider : $a3d8cae0c4348d5a$var$_inMemoryProvider;
let $a3d8cae0c4348d5a$var$_current = $a3d8cae0c4348d5a$var$_main;
function $a3d8cae0c4348d5a$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($a3d8cae0c4348d5a$var$_inMemoryProvider);
            return null;
        }
        if (error instanceof Error && error.name === 'QuotaExceededError') {
            const allKeys = module.exports.Storage.getAllKeys();
            const statsigKeys = allKeys.filter((key)=>key.startsWith('statsig.'));
            error.message = `${error.message}. Statsig Keys: ${statsigKeys.length}`;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$a3d8cae0c4348d5a$var$_current.isReady(),
    isReadyResolver: ()=>$a3d8cae0c4348d5a$var$_current.isReadyResolver(),
    getProviderName: ()=>$a3d8cae0c4348d5a$var$_current.getProviderName(),
    getItem: (key)=>$a3d8cae0c4348d5a$var$_inMemoryBreaker(()=>$a3d8cae0c4348d5a$var$_current.getItem(key)),
    setItem: (key, value)=>$a3d8cae0c4348d5a$var$_inMemoryBreaker(()=>$a3d8cae0c4348d5a$var$_current.setItem(key, value)),
    removeItem: (key)=>$a3d8cae0c4348d5a$var$_current.removeItem(key),
    getAllKeys: ()=>$a3d8cae0c4348d5a$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $a3d8cae0c4348d5a$var$_main = newProvider;
        $a3d8cae0c4348d5a$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $a3d8cae0c4348d5a$var$_current = $a3d8cae0c4348d5a$var$_inMemoryProvider;
        else $a3d8cae0c4348d5a$var$_current = $a3d8cae0c4348d5a$var$_main;
    }
};
function $a3d8cae0c4348d5a$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    return JSON.parse(value !== null && value !== void 0 ? value : 'null');
}
module.exports._getObjectFromStorage = $a3d8cae0c4348d5a$var$_getObjectFromStorage;
function $a3d8cae0c4348d5a$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $a3d8cae0c4348d5a$var$_setObjectInStorage;

});

parcelRegister("i0tcK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $aSqZn = parcelRequire("aSqZn");

var $cVXgQ = parcelRequire("cVXgQ");
const $d1bee188a8839fa7$var$ENDPOINT_DNS_KEY_MAP = {
    [$cVXgQ.Endpoint._initialize]: 'i',
    [$cVXgQ.Endpoint._rgstr]: 'e',
    [$cVXgQ.Endpoint._download_config_specs]: 'd'
};
class $d1bee188a8839fa7$var$UrlConfiguration {
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(',');
        return (0, $aSqZn._DJB2)(this.customUrl + fallbacks);
    }
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $d1bee188a8839fa7$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $cVXgQ.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
}
module.exports.UrlConfiguration = $d1bee188a8839fa7$var$UrlConfiguration;

});

parcelRegister("2B8R6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $fyllS = parcelRequire("fyllS");
const $1e45e7fa04ba38a0$var$FOREGROUND = 'foreground';
const $1e45e7fa04ba38a0$var$BACKGROUND = 'background';
const $1e45e7fa04ba38a0$var$LISTENERS = [];
let $1e45e7fa04ba38a0$var$current = $1e45e7fa04ba38a0$var$FOREGROUND;
let $1e45e7fa04ba38a0$var$isUnloading = false;
const $1e45e7fa04ba38a0$var$_isCurrentlyVisible = ()=>{
    return $1e45e7fa04ba38a0$var$current === $1e45e7fa04ba38a0$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $1e45e7fa04ba38a0$var$_isCurrentlyVisible;
const $1e45e7fa04ba38a0$var$_isUnloading = ()=>$1e45e7fa04ba38a0$var$isUnloading;
module.exports._isUnloading = $1e45e7fa04ba38a0$var$_isUnloading;
const $1e45e7fa04ba38a0$var$_subscribeToVisiblityChanged = (listener)=>{
    $1e45e7fa04ba38a0$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $1e45e7fa04ba38a0$var$_subscribeToVisiblityChanged;
const $1e45e7fa04ba38a0$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $1e45e7fa04ba38a0$var$current) return;
    $1e45e7fa04ba38a0$var$current = visibility;
    $1e45e7fa04ba38a0$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $1e45e7fa04ba38a0$var$_notifyVisibilityChanged;
(0, $fyllS._addWindowEventListenerSafe)('focus', ()=>{
    $1e45e7fa04ba38a0$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($1e45e7fa04ba38a0$var$FOREGROUND);
});
(0, $fyllS._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($1e45e7fa04ba38a0$var$BACKGROUND));
(0, $fyllS._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $1e45e7fa04ba38a0$var$FOREGROUND : $1e45e7fa04ba38a0$var$BACKGROUND);
});
(0, $fyllS._addWindowEventListenerSafe)((0, $fyllS._getUnloadEvent)(), ()=>{
    $1e45e7fa04ba38a0$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($1e45e7fa04ba38a0$var$BACKGROUND);
});

});


parcelRegister("28sXv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.24.1';
let $18e2cabdc062ce89$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$18e2cabdc062ce89$var$metadata,
    add: (additions)=>{
        $18e2cabdc062ce89$var$metadata = Object.assign(Object.assign({}, $18e2cabdc062ce89$var$metadata), additions);
    }
};

});

parcelRegister("hL4Fz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lBhsv", function(module, exports) {
"use strict";
var $fb9a989b7026003d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $kp0SQ = parcelRequire("kp0SQ");

var $4ISnd = parcelRequire("4ISnd");

var $5H0FU = parcelRequire("5H0FU");

var $e49tN = parcelRequire("e49tN");

var $feMSz = parcelRequire("feMSz");
const $fb9a989b7026003d$var$CACHE_LIMIT = 10;
class $fb9a989b7026003d$var$DataAdapterCore {
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $5H0FU._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $5H0FU._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $fb9a989b7026003d$var$_makeDataAdapterResult('Bootstrap', data, null, normalized));
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === $4ISnd.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return $fb9a989b7026003d$var$__awaiter(this, void 0, void 0, function*() {
            if (!$e49tN.Storage.isReady()) yield $e49tN.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $kp0SQ.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $fb9a989b7026003d$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $5H0FU._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }));
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $fb9a989b7026003d$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $kp0SQ.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $feMSz._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $4ISnd.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $fb9a989b7026003d$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $fb9a989b7026003d$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $kp0SQ.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $e49tN.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($e49tN.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $feMSz._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        $e49tN.Storage.setItem(cacheKey, JSON.stringify(result));
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $e49tN._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictable = $fb9a989b7026003d$var$_getEvictableKey(lastModifiedTimeMap, $fb9a989b7026003d$var$CACHE_LIMIT);
        if (evictable) {
            delete lastModifiedTimeMap[evictable];
            $e49tN.Storage.removeItem(evictable);
        }
        (0, $e49tN._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $fb9a989b7026003d$var$InMemoryCache();
    }
}
module.exports.DataAdapterCore = $fb9a989b7026003d$var$DataAdapterCore;
function $fb9a989b7026003d$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $5H0FU._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $fb9a989b7026003d$var$_makeDataAdapterResult;
class $fb9a989b7026003d$var$InMemoryCache {
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $kp0SQ.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value) {
        const oldest = $fb9a989b7026003d$var$_getEvictableKey(this._data, $fb9a989b7026003d$var$CACHE_LIMIT - 1);
        if (oldest) delete this._data[oldest];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
    constructor(){
        this._data = {};
    }
}
function $fb9a989b7026003d$var$_getEvictableKey(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return null;
    return keys.reduce((prevKey, currKey)=>{
        const prev = data[prevKey];
        const current = data[currKey];
        if (typeof prev === 'object' && typeof current === 'object') return current.receivedAt < prev.receivedAt ? currKey : prevKey;
        return current < prev ? currKey : prevKey;
    });
}

});
parcelRegister("4ISnd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StableID = void 0;

var $fV2Nk = parcelRequire("fV2Nk");

var $kp0SQ = parcelRequire("kp0SQ");

var $fyllS = parcelRequire("fyllS");

var $e49tN = parcelRequire("e49tN");

var $4620b = parcelRequire("4620b");
const $370572ea7fd9df17$var$PROMISE_MAP = {};
const $370572ea7fd9df17$var$COOKIE_ENABLED_MAP = {};
const $370572ea7fd9df17$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($370572ea7fd9df17$var$DISABLED_MAP[sdkKey]) return null;
        if ($370572ea7fd9df17$var$PROMISE_MAP[sdkKey] != null) return $370572ea7fd9df17$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $370572ea7fd9df17$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $370572ea7fd9df17$var$PROMISE_MAP[sdkKey] = stableID;
            $370572ea7fd9df17$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $370572ea7fd9df17$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $4620b.getUUID)();
        $370572ea7fd9df17$var$_persistToStorage(stableID, sdkKey);
        $370572ea7fd9df17$var$_persistToCookie(stableID, sdkKey);
        $370572ea7fd9df17$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $370572ea7fd9df17$var$PROMISE_MAP[sdkKey] = override;
        $370572ea7fd9df17$var$_persistToStorage(override, sdkKey);
        $370572ea7fd9df17$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $370572ea7fd9df17$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $370572ea7fd9df17$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $370572ea7fd9df17$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $fV2Nk._getStorageKey)(sdkKey)}`;
}
function $370572ea7fd9df17$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $370572ea7fd9df17$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $e49tN._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $kp0SQ.Log.warn('Failed to save StableID to storage');
    }
}
function $370572ea7fd9df17$var$_loadFromStorage(sdkKey) {
    const storageKey = $370572ea7fd9df17$var$_getStableIDStorageKey(sdkKey);
    return (0, $e49tN._getObjectFromStorage)(storageKey);
}
function $370572ea7fd9df17$var$_loadFromCookie(sdkKey) {
    if (!$370572ea7fd9df17$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $fyllS._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split('=');
        if (key === $370572ea7fd9df17$var$_getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $370572ea7fd9df17$var$_persistToCookie(stableID, sdkKey) {
    if (!$370572ea7fd9df17$var$COOKIE_ENABLED_MAP[sdkKey] || !document) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$370572ea7fd9df17$var$_getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $370572ea7fd9df17$var$_getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $fV2Nk._getStorageKey)(sdkKey)}`;
}

});
parcelRegister("4620b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $2fb9468027fd5b59$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $2fb9468027fd5b59$var$getUUID;

});


parcelRegister("5H0FU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $aSqZn = parcelRequire("aSqZn");

var $kp0SQ = parcelRequire("kp0SQ");
function $42517dedbfb42e86$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $kp0SQ.Log.error('Failed to JSON.stringify user');
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $42517dedbfb42e86$var$_normalizeUser;
function $42517dedbfb42e86$var$_getFullUserHash(user) {
    return user ? (0, $aSqZn._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $42517dedbfb42e86$var$_getFullUserHash;

});

parcelRegister("feMSz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $kp0SQ = parcelRequire("kp0SQ");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $b17e1437be4eb593$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $kp0SQ.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $b17e1437be4eb593$var$_typedJsonParse;

});


parcelRegister("25vFD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8MU8V", function(module, exports) {
"use strict";
var $665e5b424a040bc2$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $kp0SQ = parcelRequire("kp0SQ");

var $1PZH9 = parcelRequire("1PZH9");

var $28sXv = parcelRequire("28sXv");
module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $665e5b424a040bc2$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $665e5b424a040bc2$var$ErrorBoundary {
    wrap(instance, namePrefix) {
        try {
            const obj = instance;
            $665e5b424a040bc2$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(namePrefix ? `${namePrefix}:${name}` : name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $665e5b424a040bc2$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $kp0SQ.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$665e5b424a040bc2$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($665e5b424a040bc2$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $665e5b424a040bc2$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $1PZH9.SDKType._get(this._sdkKey);
                    const statsigMetadata = $28sXv.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $665e5b424a040bc2$var$_getDescription(unwrapped);
                    const body = Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $665e5b424a040bc2$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    }));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
}
module.exports.ErrorBoundary = $665e5b424a040bc2$var$ErrorBoundary;
function $665e5b424a040bc2$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $665e5b424a040bc2$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $665e5b424a040bc2$var$UNKNOWN_ERROR;
    }
}
function $665e5b424a040bc2$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $665e5b424a040bc2$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.entries(options).forEach(([option, value])=>{
        const valueType = typeof value;
        switch(valueType){
            case 'number':
            case 'bigint':
            case 'boolean':
                loggingCopy[String(option)] = value;
                break;
            case 'string':
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = 'set';
                break;
            case 'object':
                if (option === 'environment') loggingCopy['environment'] = value;
                else if (option === 'networkConfig') loggingCopy['networkConfig'] = value;
                else loggingCopy[String(option)] = value != null ? 'set' : 'unset';
                break;
            default:
        }
    });
    return loggingCopy;
}

});
parcelRegister("1PZH9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $156a692eeb3c05c2$var$SDK_CLIENT = {};
let $156a692eeb3c05c2$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $156a692eeb3c05c2$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($156a692eeb3c05c2$var$suffix !== null && $156a692eeb3c05c2$var$suffix !== void 0 ? $156a692eeb3c05c2$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $156a692eeb3c05c2$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$156a692eeb3c05c2$var$suffix || $156a692eeb3c05c2$var$suffix === '-react') $156a692eeb3c05c2$var$suffix = '-' + binding;
    }
};

});


parcelRegister("fApYm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3YWWK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("aFstg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("grJ5h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _configList: 'cl',
    _layer: 'l',
    _paramStore: 'p'
};
const $bf9223bf496497dd$var$EXIST_KEYS = new Set([]);
const $bf9223bf496497dd$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $bf9223bf496497dd$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($bf9223bf496497dd$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($bf9223bf496497dd$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $bf9223bf496497dd$var$createMemoKey;

});

parcelRegister("60Pni", function(module, exports) {
"use strict";
var $460a981dae3afdf7$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $lptyf = parcelRequire("lptyf");

var $lptyf = parcelRequire("lptyf");

var $4eHof = parcelRequire("4eHof");

var $kp0SQ = parcelRequire("kp0SQ");

var $cVXgQ = parcelRequire("cVXgQ");

var $l4azz = parcelRequire("l4azz");

var $4loRs = parcelRequire("4loRs");

var $1PZH9 = parcelRequire("1PZH9");

var $fyllS = parcelRequire("fyllS");

var $3Wwnx = parcelRequire("3Wwnx");

var $4ISnd = parcelRequire("4ISnd");

var $1qgQ6 = parcelRequire("1qgQ6");

var $28sXv = parcelRequire("28sXv");

var $9i5vR = parcelRequire("9i5vR");

var $2B8R6 = parcelRequire("2B8R6");
const $460a981dae3afdf7$var$DEFAULT_TIMEOUT_MS = 10000;
const $460a981dae3afdf7$var$BACKOFF_BASE_MS = 500;
const $460a981dae3afdf7$var$BACKOFF_MAX_MS = 30000;
const $460a981dae3afdf7$var$RATE_LIMIT_WINDOW_MS = 1000;
const $460a981dae3afdf7$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $460a981dae3afdf7$var$LEAK_RATE = $460a981dae3afdf7$var$RATE_LIMIT_MAX_REQ_COUNT / $460a981dae3afdf7$var$RATE_LIMIT_WINDOW_MS;
const $460a981dae3afdf7$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $460a981dae3afdf7$var$NetworkCore {
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        if (!$460a981dae3afdf7$var$_ensureValidSdkKey(args)) return false;
        const argsInternal = this._getInternalRequestArgs('POST', args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        return nav.sendBeacon.bind(nav)(url, argsInternal.body);
    }
    post(args) {
        return $460a981dae3afdf7$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        return $460a981dae3afdf7$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!$460a981dae3afdf7$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $kp0SQ.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            const abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
            const timeoutHandle = setTimeout(()=>{
                abortController === null || abortController === void 0 || abortController.abort(`Timeout of ${this._timeout}ms expired.`);
            }, this._timeout);
            const populatedUrl = this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $2B8R6._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal,
                    priority: args.priority,
                    keepalive: keepalive
                };
                $460a981dae3afdf7$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                response = yield func(populatedUrl, config);
                clearTimeout(timeoutHandle);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $460a981dae3afdf7$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $460a981dae3afdf7$var$_getErrorMessage(abortController, error);
                const timedOut = $460a981dae3afdf7$var$_didTimeout(abortController);
                $460a981dae3afdf7$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$460a981dae3afdf7$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $1qgQ6.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $kp0SQ.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $460a981dae3afdf7$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $9i5vR.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $9i5vR.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $460a981dae3afdf7$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $460a981dae3afdf7$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $cVXgQ.Endpoint._initialize || args.urlConfig.endpoint === $cVXgQ.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$cVXgQ.NetworkParam.SdkKey]: args.sdkKey,
            [$cVXgQ.NetworkParam.SdkType]: $1PZH9.SDKType._get(args.sdkKey),
            [$cVXgQ.NetworkParam.SdkVersion]: $28sXv.SDK_VERSION,
            [$cVXgQ.NetworkParam.Time]: String(Date.now()),
            [$cVXgQ.NetworkParam.SessionID]: $3Wwnx.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
        return `${url}${query ? `?${query}` : ''}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $fyllS._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== 'string' || (0, $lptyf._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split('').reverse().join('');
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$cVXgQ.NetworkParam.StatsigEncoded]: '1'
            });
        } catch (e) {
            $kp0SQ.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return $460a981dae3afdf7$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== 'string' || !$460a981dae3afdf7$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream('gzip');
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($kp0SQ.Log.error);
                writer.close().catch($kp0SQ.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$cVXgQ.NetworkParam.IsGzipped]: '1'
                });
            } catch (e) {
                $kp0SQ.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ('data' in args) $460a981dae3afdf7$var$_populateRequestBody(result, args.data);
        return result;
    }
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $460a981dae3afdf7$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $l4azz.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
}
module.exports.NetworkCore = $460a981dae3afdf7$var$NetworkCore;
const $460a981dae3afdf7$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $kp0SQ.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
const $460a981dae3afdf7$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $4ISnd.StableID.get(sdkKey);
    const sessionID = $3Wwnx.SessionID.get(sdkKey);
    const sdkType = $1PZH9.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $28sXv.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $460a981dae3afdf7$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $lptyf._getStatsigGlobalFlag)('no-compress') != null || typeof CompressionStream === 'undefined' || typeof TextEncoder === 'undefined') return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $4loRs.SDKFlags.get(args.sdkKey, 'enable_log_event_compression') === true;
    switch(options.logEventCompressionMode){
        case $9i5vR.LogEventCompressionMode.Disabled:
            return false;
        case $9i5vR.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $9i5vR.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $460a981dae3afdf7$var$_getErrorMessage(controller, error) {
    if ((controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === 'string') return controller.signal.reason;
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $460a981dae3afdf7$var$_didTimeout(controller) {
    const timeout = (controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === 'string' && controller.signal.reason.includes('Timeout');
    return timeout || false;
}
function $460a981dae3afdf7$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $cVXgQ.Endpoint._initialize) return;
    $4eHof.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $460a981dae3afdf7$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $cVXgQ.Endpoint._initialize) return;
    $4eHof.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $4eHof.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $460a981dae3afdf7$var$_exponentialBackoff(attempt) {
    return $460a981dae3afdf7$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($460a981dae3afdf7$var$BACKOFF_BASE_MS * (attempt * attempt), $460a981dae3afdf7$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("l4azz", function(module, exports) {
"use strict";
var $f5622c32a8bc3f40$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $hsy3n = parcelRequire("hsy3n");

var $aSqZn = parcelRequire("aSqZn");

var $kp0SQ = parcelRequire("kp0SQ");

var $e49tN = parcelRequire("e49tN");
const $f5622c32a8bc3f40$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $f5622c32a8bc3f40$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $f5622c32a8bc3f40$var$NetworkFallbackResolver {
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $f5622c32a8bc3f40$var$DEFAULT_TTL_MS;
        $f5622c32a8bc3f40$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $f5622c32a8bc3f40$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $f5622c32a8bc3f40$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return $f5622c32a8bc3f40$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!$f5622c32a8bc3f40$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $f5622c32a8bc3f40$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $f5622c32a8bc3f40$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return $f5622c32a8bc3f40$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $f5622c32a8bc3f40$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $hsy3n._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $f5622c32a8bc3f40$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
}
module.exports.NetworkFallbackResolver = $f5622c32a8bc3f40$var$NetworkFallbackResolver;
function $f5622c32a8bc3f40$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $f5622c32a8bc3f40$var$_isDomainFailure;
function $f5622c32a8bc3f40$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $aSqZn._DJB2)(sdkKey)}`;
}
function $f5622c32a8bc3f40$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $f5622c32a8bc3f40$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $e49tN.Storage.removeItem(hashKey);
        return;
    }
    $e49tN.Storage.setItem(hashKey, JSON.stringify(info));
}
function $f5622c32a8bc3f40$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $f5622c32a8bc3f40$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $e49tN.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $kp0SQ.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $f5622c32a8bc3f40$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("hsy3n", function(module, exports) {
"use strict";
var $cb5f777db37d29e0$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $cb5f777db37d29e0$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $cb5f777db37d29e0$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $cb5f777db37d29e0$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $cb5f777db37d29e0$var$MAX_START_LOOKUP = 200;
function $cb5f777db37d29e0$var$_fetchTxtRecords(networkFunc) {
    return $cb5f777db37d29e0$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($cb5f777db37d29e0$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $cb5f777db37d29e0$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $cb5f777db37d29e0$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $cb5f777db37d29e0$var$_fetchTxtRecords;
function $cb5f777db37d29e0$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $cb5f777db37d29e0$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $cb5f777db37d29e0$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});


parcelRegister("4loRs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $329c68840ad7d778$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $329c68840ad7d778$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $329c68840ad7d778$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("3Wwnx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $lptyf = parcelRequire("lptyf");

var $fV2Nk = parcelRequire("fV2Nk");

var $kp0SQ = parcelRequire("kp0SQ");

var $e49tN = parcelRequire("e49tN");

var $4620b = parcelRequire("4620b");
const $2defe795b9169e75$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $2defe795b9169e75$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $2defe795b9169e75$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($2defe795b9169e75$var$PROMISE_MAP[sdkKey] == null) $2defe795b9169e75$var$PROMISE_MAP[sdkKey] = $2defe795b9169e75$var$_loadSession(sdkKey);
        const session = $2defe795b9169e75$var$PROMISE_MAP[sdkKey];
        return $2defe795b9169e75$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $2defe795b9169e75$var$PROMISE_MAP[sdkKey] = $2defe795b9169e75$var$_overrideSessionId(override, sdkKey);
    }
};
function $2defe795b9169e75$var$_loadSession(sdkKey) {
    let data = $2defe795b9169e75$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $4620b.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $2defe795b9169e75$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $2defe795b9169e75$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    const sdkKey = session.sdkKey;
    if ($2defe795b9169e75$var$_isIdle(data) || $2defe795b9169e75$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $4620b.getUUID)();
        data.startTime = now;
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }
    data.lastUpdate = now;
    $2defe795b9169e75$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    session.idleTimeoutID = $2defe795b9169e75$var$_createSessionTimeout(sdkKey, $2defe795b9169e75$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $2defe795b9169e75$var$_createSessionTimeout(sdkKey, $2defe795b9169e75$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $2defe795b9169e75$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        var _a;
        const client = (_a = (0, $lptyf._getStatsigGlobal)()) === null || _a === void 0 ? void 0 : _a.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }, duration);
}
function $2defe795b9169e75$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $2defe795b9169e75$var$MAX_SESSION_IDLE_TIME;
}
function $2defe795b9169e75$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $2defe795b9169e75$var$MAX_SESSION_AGE;
}
function $2defe795b9169e75$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $fV2Nk._getStorageKey)(sdkKey)}`;
}
function $2defe795b9169e75$var$_persistToStorage(session, sdkKey) {
    const storageKey = $2defe795b9169e75$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $e49tN._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $kp0SQ.Log.warn('Failed to save SessionID');
    }
}
function $2defe795b9169e75$var$_loadFromStorage(sdkKey) {
    const storageKey = $2defe795b9169e75$var$_getSessionIDStorageKey(sdkKey);
    return (0, $e49tN._getObjectFromStorage)(storageKey);
}

});

parcelRegister("1qgQ6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});


parcelRegister("4Lrnq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("4jypg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8wFhx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fastApproxSizeOf = void 0;
const $6351559578fe385c$var$CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const $6351559578fe385c$var$APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const $6351559578fe385c$var$_fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === 'object' && value !== null) size += (0, module.exports._fastApproxSizeOf)(value, max) + $6351559578fe385c$var$CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + $6351559578fe385c$var$APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
module.exports._fastApproxSizeOf = $6351559578fe385c$var$_fastApproxSizeOf;

});

parcelRegister("lDOHr", function(module, exports) {
"use strict";
var $fc149167ca5c996b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $lptyf = parcelRequire("lptyf");

var $lptyf = parcelRequire("lptyf");

var $8MU8V = parcelRequire("8MU8V");

var $iZxCm = parcelRequire("iZxCm");

var $kp0SQ = parcelRequire("kp0SQ");

var $grJ5h = parcelRequire("grJ5h");

var $fyllS = parcelRequire("fyllS");

var $3Wwnx = parcelRequire("3Wwnx");

var $4ISnd = parcelRequire("4ISnd");

var $9i5vR = parcelRequire("9i5vR");

var $e49tN = parcelRequire("e49tN");
const $fc149167ca5c996b$var$MAX_MEMO_CACHE_SIZE = 3000;
class $fc149167ca5c996b$var$StatsigClientBase {
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? 'disabled' : 'browser-only');
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $e49tN.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $4ISnd.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($9i5vR.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $fc149167ca5c996b$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $kp0SQ.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $grJ5h.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $fc149167ca5c996b$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($kp0SQ.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $e49tN.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $3Wwnx.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $e49tN.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $4ISnd.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $4ISnd.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $iZxCm.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $8MU8V.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $e49tN.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError('OA::loadFromStorage', e));
        this._primeReadyRipcord();
        $fc149167ca5c996b$var$_assignGlobalInstance(sdkKey, this);
    }
}
module.exports.StatsigClientBase = $fc149167ca5c996b$var$StatsigClientBase;
function $fc149167ca5c996b$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $fyllS._isServerEnv)()) return;
    const statsigGlobal = (0, $lptyf._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $kp0SQ.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("hqFB2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("6E7aU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("h63QG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $kp0SQ = parcelRequire("kp0SQ");

var $dfkhs = parcelRequire("dfkhs");
function $c725fb7c1c408e94$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : '',
        __evaluation: evaluation,
        value: value
    };
}
function $c725fb7c1c408e94$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $c725fb7c1c408e94$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $c725fb7c1c408e94$var$_makeFeatureGate;
function $c725fb7c1c408e94$var$_makeDynamicConfig(name, details, evaluation) {
    var _a;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $c725fb7c1c408e94$var$_makeEvaluation(name, details, evaluation, value)), {
        get: $c725fb7c1c408e94$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $c725fb7c1c408e94$var$_makeDynamicConfig;
function $c725fb7c1c408e94$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $c725fb7c1c408e94$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $c725fb7c1c408e94$var$_makeExperiment;
function $c725fb7c1c408e94$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $c725fb7c1c408e94$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $c725fb7c1c408e94$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $c725fb7c1c408e94$var$_makeLayer;
function $c725fb7c1c408e94$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $c725fb7c1c408e94$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $c725fb7c1c408e94$var$_mergeOverride;
function $c725fb7c1c408e94$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $dfkhs._isTypeMatch)(found, fallback)) {
            $kp0SQ.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $c725fb7c1c408e94$var$_makeTypedGet;

});

parcelRegister("58Rur", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9peM0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $6d91e8892a474517$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $6d91e8892a474517$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});


parcelRegister("5XiwI", function(module, exports) {
"use strict";
var $4560d576f4af9562$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $ku4nR = parcelRequire("ku4nR");

var $fPdx0 = parcelRequire("fPdx0");

var $do1Xy = parcelRequire("do1Xy");

var $7q31K = parcelRequire("7q31K");

var $4HR6h = parcelRequire("4HR6h");
class $4560d576f4af9562$var$StatsigClient extends $ku4nR.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *  If no instance exists for the given SDK key, a new StatsigClient instance will be created and returned.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient} Returns the StatsigClient instance associated with the given SDK key, creating a new one if needed.
     */ static instance(sdkKey) {
        const instance = (0, $ku4nR._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $4560d576f4af9562$var$StatsigClient) return instance;
        $ku4nR.Log.warn((0, $ku4nR._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
        return new $4560d576f4af9562$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== 'Uninitialized') return (0, $ku4nR.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            'MultipleInitializations',
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $4560d576f4af9562$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        const startTime = performance.now();
        try {
            return this._updateUserSyncImpl(user, options, startTime);
        } catch (e) {
            const err = e instanceof Error ? e : new Error(String(e));
            return this._createErrorUpdateDetails(err, startTime);
        }
    }
    _updateUserSyncImpl(user, options, startTime) {
        var _a;
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push('NoCachedValues');
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, $ku4nR.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $ku4nR.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $4560d576f4af9562$var$__awaiter(this, void 0, void 0, function*() {
            const startTime = performance.now();
            try {
                return yield this._updateUserAsyncImpl(user, options);
            } catch (e) {
                const err = e instanceof Error ? e : new Error(String(e));
                return this._createErrorUpdateDetails(err, startTime);
            }
        });
    }
    _updateUserAsyncImpl(user, options) {
        return $4560d576f4af9562$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $ku4nR.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus('Loading', result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $ku4nR.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $ku4nR.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $ku4nR.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($ku4nR.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: 'initialization_failure'
                });
            }
            $ku4nR.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $ku4nR.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $ku4nR.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: JSON.parse(JSON.stringify(this._user)),
            errorBoundary: this._errorBoundary,
            session: $ku4nR.StatsigSession.get(this._sdkKey),
            stableID: $ku4nR.StableID.get(this._sdkKey),
            sdkInstanceID: this._sdkInstanceID
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === 'string' ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this.$emt({
            name: 'log_event_called',
            event: event
        });
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    /**
     * Updates the user with analytics only metadata. This will override any existing analytics only metadata.
     *
     * @param {Record<string, string | number | boolean>} metadata - The metadata to add to the user.
     */ updateUserWithAnalyticsOnlyMetadata(metadata) {
        this._user = this._configureUser(Object.assign(Object.assign({}, this._user), {
            analyticsOnlyMetadata: metadata
        }), this._options);
    }
    _primeReadyRipcord() {
        this.$on('error', ()=>{
            this.loadingStatus === 'Loading' && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $4560d576f4af9562$var$__awaiter(this, void 0, void 0, function*() {
            if (!$ku4nR.Storage.isReady()) yield $ku4nR.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _createErrorUpdateDetails(error, startTime) {
        var _a;
        return (0, $ku4nR.createUpdateDetails)(false, this._store.getSource(), performance.now() - startTime, error, null, [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus('Ready', values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: 'low'
        }).catch((err)=>{
            $ku4nR.Log.error('An error occurred after update.', err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a;
        const user = (0, $ku4nR._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) $ku4nR.StableID.setOverride(stableIdOverride, this._sdkKey);
        // Only attach first touch metadata if it's not empty
        if (Object.keys(this._possibleFirstTouchMetadata).length > 0) user.analyticsOnlyMetadata = Object.assign(Object.assign({}, user.analyticsOnlyMetadata), this._possibleFirstTouchMetadata);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $ku4nR._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $ku4nR._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'gate_evaluation',
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $ku4nR._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $ku4nR._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'dynamic_config_evaluation',
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $ku4nR._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $ku4nR._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $ku4nR._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'experiment_evaluation',
            experiment: result
        });
        return result;
    }
    _getConfigListImpl() {
        return this._store.getConfigList();
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $ku4nR._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $ku4nR._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $ku4nR._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: 'layer_evaluation',
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $7q31K._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $7q31K._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $ku4nR.SDKType._setClientType(sdkKey, 'javascript-client');
        const network = new $do1Xy.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $4HR6h.StatsigEvaluationsDataAdapter(), network, options);
        this._possibleFirstTouchMetadata = {};
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($ku4nR.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($ku4nR.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($ku4nR.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the list of all Dynamic Configs and Experiments for the current user.
         *
         * @returns {string[]} The list of all Dynamic Config and Experiment names for the current user. Note - these will be hashed unless you've disabled hashing.
         * This is intended to be used for debugging.
         */ this.getConfigList = this._memoize($ku4nR.MemoPrefix._configList, this._getConfigListImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($ku4nR.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($ku4nR.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $fPdx0.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        this._sdkInstanceID = (0, $ku4nR.getUUID)();
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
}
module.exports.default = $4560d576f4af9562$var$StatsigClient;

});
parcelRegister("fPdx0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $ku4nR = parcelRequire("ku4nR");
class $b8561d7a19fe4e0c$var$EvaluationStore {
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings.clear();
    }
    finalize() {
        if (this._values) return;
        this._source = 'NoValues';
    }
    getValues() {
        return this._rawValues ? (0, $ku4nR._typedJsonParse)(this._rawValues, 'has_updates', 'EvaluationStoreValues') : null;
    }
    setValues(result, user) {
        var _a;
        if (!result) return false;
        const values = (0, $ku4nR._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        this._values = values;
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $ku4nR.SDKFlags.setFlags(this._sdkKey, (_a = values.sdk_flags) !== null && _a !== void 0 ? _a : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.feature_gates, name);
    }
    getConfig(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.dynamic_configs, name);
    }
    getConfigList() {
        var _a;
        if (!((_a = this._values) === null || _a === void 0 ? void 0 : _a.dynamic_configs)) return [];
        return Object.values(this._values.dynamic_configs).map((config)=>config.name);
    }
    getLayer(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.layer_configs, name);
    }
    getParamStore(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.param_stores, name);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.exposures;
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== 'Bootstrap') return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(lookup, name) {
        let result = null;
        if (lookup) result = lookup[name] ? lookup[name] : lookup[(0, $ku4nR._DJB2)(name)];
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b;
        const stableID = $ku4nR.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add('StableIDMismatch');
            return;
        }
        if ('user' in values) {
            const bootstrapUser = values['user'];
            const userForComparison = Object.assign(Object.assign({}, user), {
                analyticsOnlyMetadata: undefined,
                privateAttributes: undefined
            });
            if ((0, $ku4nR._getFullUserHash)(userForComparison) !== (0, $ku4nR._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
        }
    }
    getCurrentSourceDetails() {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== 'Uninitialized' && reason !== 'NoValues') {
            const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
}
module.exports.default = $b8561d7a19fe4e0c$var$EvaluationStore;

});

parcelRegister("do1Xy", function(module, exports) {
"use strict";
var $9bef0960fe423f26$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $ku4nR = parcelRequire("ku4nR");

var $5aLFC = parcelRequire("5aLFC");
class $9bef0960fe423f26$var$StatsigNetwork extends $ku4nR.NetworkCore {
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        return $9bef0960fe423f26$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f;
            const cache = current ? (0, $ku4nR._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : 'djb2',
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : 'djb2');
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: 'derived_fields' in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        return $9bef0960fe423f26$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $5aLFC._resolveDeltasResponse)(cache, response.body);
            if (typeof result === 'string') return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $ku4nR.UrlConfiguration($ku4nR.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
}
module.exports.default = $9bef0960fe423f26$var$StatsigNetwork;

});
parcelRegister("5aLFC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $ku4nR = parcelRequire("ku4nR");
const $3c42dd44ea7f7e8d$var$MAX_DELTAS_SORT_DEPTH = 2;
function $3c42dd44ea7f7e8d$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $ku4nR._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $3c42dd44ea7f7e8d$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $3c42dd44ea7f7e8d$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $ku4nR._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $3c42dd44ea7f7e8d$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $3c42dd44ea7f7e8d$var$_resolveDeltasResponse;
function $3c42dd44ea7f7e8d$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $3c42dd44ea7f7e8d$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $3c42dd44ea7f7e8d$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $3c42dd44ea7f7e8d$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $3c42dd44ea7f7e8d$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $3c42dd44ea7f7e8d$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("7q31K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $ku4nR = parcelRequire("ku4nR");
const $566d4f3e3402053b$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $566d4f3e3402053b$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $566d4f3e3402053b$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $ku4nR._isTypeMatch)(value, fallback);
}
function $566d4f3e3402053b$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $566d4f3e3402053b$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $566d4f3e3402053b$var$_shouldLogExposure(options) ? undefined : $566d4f3e3402053b$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $566d4f3e3402053b$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $566d4f3e3402053b$var$_shouldLogExposure(options) ? undefined : $566d4f3e3402053b$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($566d4f3e3402053b$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $566d4f3e3402053b$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $566d4f3e3402053b$var$_shouldLogExposure(options) ? undefined : $566d4f3e3402053b$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($566d4f3e3402053b$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $566d4f3e3402053b$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $566d4f3e3402053b$var$_shouldLogExposure(options) ? undefined : $566d4f3e3402053b$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($566d4f3e3402053b$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $566d4f3e3402053b$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $ku4nR._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return $566d4f3e3402053b$var$_getMappedStaticValue(param, options);
            case 'gate':
                return $566d4f3e3402053b$var$_getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return $566d4f3e3402053b$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return $566d4f3e3402053b$var$_getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return $566d4f3e3402053b$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $566d4f3e3402053b$var$_makeParamStoreGetter;

});

parcelRegister("4HR6h", function(module, exports) {
"use strict";
var $36d45e360b3a06bb$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $ku4nR = parcelRequire("ku4nR");

var $do1Xy = parcelRequire("do1Xy");
class $36d45e360b3a06bb$var$StatsigEvaluationsDataAdapter extends $ku4nR.DataAdapterCore {
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $do1Xy.default) this._network = network;
        else this._network = new $do1Xy.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $ku4nR._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $ku4nR._typedJsonParse)(data, 'has_updates', 'data');
        if (values && 'user' in values) super.setData(data, values.user);
        else $ku4nR.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        return $36d45e360b3a06bb$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $ku4nR._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$ku4nR.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $ku4nR._getFullUserHash)(user);
    }
    constructor(){
        super('EvaluationsDataAdapter', 'evaluations');
        this._network = null;
        this._options = null;
    }
}
module.exports.StatsigEvaluationsDataAdapter = $36d45e360b3a06bb$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("5h5gj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d729f3720c42384$export$2e2bcd8739ae039; });

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $dsN6L = parcelRequire("dsN6L");

var $8iqaj = parcelRequire("8iqaj");
function $3d729f3720c42384$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3d729f3720c42384$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3d729f3720c42384$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3d729f3720c42384$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3d729f3720c42384$export$a66cbd9b2289cd78 = '@all-features';
var $3d729f3720c42384$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($8iqaj)))();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $3d729f3720c42384$var$_objectSpread($3d729f3720c42384$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $3d729f3720c42384$var$_objectSpread($3d729f3720c42384$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $3d729f3720c42384$var$_objectSpread($3d729f3720c42384$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $3d729f3720c42384$var$_objectSpread($3d729f3720c42384$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($3d729f3720c42384$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($3d729f3720c42384$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($3d729f3720c42384$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $3d729f3720c42384$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});
parcelRegister("8iqaj", function(module, exports) {
'use strict';
var $60a44d0ec585a7ec$var$has = Object.prototype.hasOwnProperty, $60a44d0ec585a7ec$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $60a44d0ec585a7ec$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $60a44d0ec585a7ec$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $60a44d0ec585a7ec$var$Events().__proto__) $60a44d0ec585a7ec$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $60a44d0ec585a7ec$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $60a44d0ec585a7ec$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $60a44d0ec585a7ec$var$EE(fn, context || emitter, once), evt = $60a44d0ec585a7ec$var$prefix ? $60a44d0ec585a7ec$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $60a44d0ec585a7ec$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $60a44d0ec585a7ec$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $60a44d0ec585a7ec$var$EventEmitter() {
    this._events = new $60a44d0ec585a7ec$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $60a44d0ec585a7ec$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($60a44d0ec585a7ec$var$has.call(events, name)) names.push($60a44d0ec585a7ec$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $60a44d0ec585a7ec$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $60a44d0ec585a7ec$var$prefix ? $60a44d0ec585a7ec$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $60a44d0ec585a7ec$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $60a44d0ec585a7ec$var$prefix ? $60a44d0ec585a7ec$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $60a44d0ec585a7ec$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $60a44d0ec585a7ec$var$prefix ? $60a44d0ec585a7ec$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $60a44d0ec585a7ec$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $60a44d0ec585a7ec$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $60a44d0ec585a7ec$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $60a44d0ec585a7ec$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $60a44d0ec585a7ec$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $60a44d0ec585a7ec$var$prefix ? $60a44d0ec585a7ec$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $60a44d0ec585a7ec$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $60a44d0ec585a7ec$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $60a44d0ec585a7ec$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $60a44d0ec585a7ec$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $60a44d0ec585a7ec$var$prefix ? $60a44d0ec585a7ec$var$prefix + event : event;
        if (this._events[evt]) $60a44d0ec585a7ec$var$clearEvent(this, evt);
    } else {
        this._events = new $60a44d0ec585a7ec$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$60a44d0ec585a7ec$var$EventEmitter.prototype.off = $60a44d0ec585a7ec$var$EventEmitter.prototype.removeListener;
$60a44d0ec585a7ec$var$EventEmitter.prototype.addListener = $60a44d0ec585a7ec$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$60a44d0ec585a7ec$var$EventEmitter.prefixed = $60a44d0ec585a7ec$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$60a44d0ec585a7ec$var$EventEmitter.EventEmitter = $60a44d0ec585a7ec$var$EventEmitter;
module.exports = $60a44d0ec585a7ec$var$EventEmitter;

});


parcelRegister("5nkgG", function(module, exports) {

$parcel$export(module.exports, "DynamicConfig", function () { return $3e9ed28c2708a8a6$export$6dc24881a3d96325; });

var $61RDg = parcelRequire("61RDg");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $i3XRq = parcelRequire("i3XRq");
var $3e9ed28c2708a8a6$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $i3XRq.migrateEvaluationDetails)(experiment.details), (0, $i3XRq.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("i3XRq", function(module, exports) {

$parcel$export(module.exports, "getOptionsWithDefaults", function () { return $d266f0e22477b0f0$export$d119b37e5f788b43; });
$parcel$export(module.exports, "shallowEquals", function () { return $d266f0e22477b0f0$export$fa1c2bbf4100b8bc; });
$parcel$export(module.exports, "toStatsigUser", function () { return $d266f0e22477b0f0$export$3dad1db244472f32; });
$parcel$export(module.exports, "migrateInitializationOptions", function () { return $d266f0e22477b0f0$export$202946b690d26d22; });
$parcel$export(module.exports, "migrateEvaluationDetails", function () { return $d266f0e22477b0f0$export$18ad168d3dbac899; });
$parcel$export(module.exports, "migrateSecondaryExposures", function () { return $d266f0e22477b0f0$export$55fd683752d01e67; });

var $ai2Md = parcelRequire("ai2Md");

var $5YM7L = parcelRequire("5YM7L");

var $dsN6L = parcelRequire("dsN6L");

var $8RqYg = parcelRequire("8RqYg");

var $4LQfc = parcelRequire("4LQfc");

var $c0Ow7 = parcelRequire("c0Ow7");
var $d266f0e22477b0f0$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $d266f0e22477b0f0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d266f0e22477b0f0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d266f0e22477b0f0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d266f0e22477b0f0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d266f0e22477b0f0$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $d266f0e22477b0f0$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $8RqYg.isFedRamp)() ? (0, $c0Ow7.PerimeterType).FEDRAMP_MODERATE : (0, $c0Ow7.PerimeterType).COMMERCIAL
    }, options);
};
var $d266f0e22477b0f0$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $d266f0e22477b0f0$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    var user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $d266f0e22477b0f0$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(options, $d266f0e22477b0f0$var$_excluded);
    return $d266f0e22477b0f0$var$_objectSpread($d266f0e22477b0f0$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $d266f0e22477b0f0$var$evaluationReasonMappings = Object.entries((0, $4LQfc.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $d266f0e22477b0f0$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $d266f0e22477b0f0$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $4LQfc.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $d266f0e22477b0f0$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("8RqYg", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", function () { return $673831dcbde11cfb$export$64d6499adf9b2e51; });

var $bQBcH = parcelRequire("bQBcH");
function $673831dcbde11cfb$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $bQBcH.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("bQBcH", function(module, exports) {

$parcel$export(module.exports, "FEDRAMP_MODERATE", function () { return $8a0168eb439c6992$export$ce553301d55c2fd8; });
var $8a0168eb439c6992$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $8a0168eb439c6992$export$f005e2e9f707cb5f = 'commercial';
var $8a0168eb439c6992$export$bd6b5a7802d76127 = 'fedramp-fedex';
var $8a0168eb439c6992$export$a739cd5aac835909 = 'stg';
var $8a0168eb439c6992$export$42dd0cdd351a4a9 = 'prod';
var $8a0168eb439c6992$export$404582bc18fe4d9e = 'dev';

});


parcelRegister("4LQfc", function(module, exports) {

$parcel$export(module.exports, "EvaluationReason", function () { return $379413cb273fd9cf$export$c62558b199e46828; });
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $379413cb273fd9cf$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("c0Ow7", function(module, exports) {

$parcel$export(module.exports, "FeatureGateEnvironment", function () { return $8becabbb643a777b$export$479e7351a733299; });
$parcel$export(module.exports, "PerimeterType", function () { return $8becabbb643a777b$export$c42b7bbc5e7ba555; });
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $8becabbb643a777b$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $8becabbb643a777b$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $8becabbb643a777b$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("etNe6", function(module, exports) {

$parcel$export(module.exports, "Layer", function () { return $a8a9f57e257cf432$export$936d0764594b6eb3; });

var $61RDg = parcelRequire("61RDg");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $i3XRq = parcelRequire("i3XRq");
var $a8a9f57e257cf432$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $i3XRq.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $i3XRq.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $i3XRq.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("bYy5Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b7fbee99a5150d6$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");

var $2R76C = parcelRequire("2R76C");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $eWMMH = parcelRequire("eWMMH");

var $c0Ow7 = parcelRequire("c0Ow7");

var $i7Qvh = parcelRequire("i7Qvh");

var $3uAZK = parcelRequire("3uAZK");
function $8b7fbee99a5150d6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8b7fbee99a5150d6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8b7fbee99a5150d6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8b7fbee99a5150d6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8b7fbee99a5150d6$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $8b7fbee99a5150d6$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $8b7fbee99a5150d6$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $8b7fbee99a5150d6$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $8b7fbee99a5150d6$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $8b7fbee99a5150d6$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $8b7fbee99a5150d6$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $8b7fbee99a5150d6$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $8b7fbee99a5150d6$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $8b7fbee99a5150d6$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $8b7fbee99a5150d6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error('Failed to retrieve client sdk key');
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error('Failed to retrieve experiment values');
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $3uAZK.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $3uAZK.ResponseError)('Unexpected 204 response');
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $8b7fbee99a5150d6$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $c0Ow7.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $c0Ow7.FeatureGateEnvironment).Production:
                        return $8b7fbee99a5150d6$export$18c93900db9358a4;
                    case (0, $c0Ow7.FeatureGateEnvironment).Staging:
                        return $8b7fbee99a5150d6$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $c0Ow7.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $c0Ow7.FeatureGateEnvironment).Development:
                        return $8b7fbee99a5150d6$export$f058dbf75c3bc647;
                    case (0, $c0Ow7.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $8b7fbee99a5150d6$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $8b7fbee99a5150d6$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $8b7fbee99a5150d6$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $8b7fbee99a5150d6$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $i7Qvh.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $8b7fbee99a5150d6$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($8b7fbee99a5150d6$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($8b7fbee99a5150d6$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("i7Qvh", function(module, exports) {

$parcel$export(module.exports, "CLIENT_VERSION", function () { return $d3219b8833698ce2$export$a59f8d67326bd1cb; });
/// <reference types="node" />
var $d3219b8833698ce2$export$a59f8d67326bd1cb = "5.5.4";

});

parcelRegister("3uAZK", function(module, exports) {

$parcel$export(module.exports, "ResponseError", function () { return $28b0dedf30016726$export$286baf652d0b1206; });

var $iTPYb = parcelRequire("iTPYb");

var $3lbuJ = parcelRequire("3lbuJ");

var $gGOBY = parcelRequire("gGOBY");

var $lVDuE = parcelRequire("lVDuE");

var $kSyoi = parcelRequire("kSyoi");

var $8PVNu = parcelRequire("8PVNu");
function $28b0dedf30016726$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($gGOBY)))(t, $28b0dedf30016726$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(t).constructor) : o.apply(t, e));
}
function $28b0dedf30016726$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($28b0dedf30016726$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $28b0dedf30016726$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, ResponseError);
        return $28b0dedf30016726$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($kSyoi)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PVNu)))(Error));

});
parcelRegister("gGOBY", function(module, exports) {

var $61RDg = parcelRequire("61RDg");
var $c267d3f5f2b29dff$var$_typeof = $61RDg.default;

var $jhawX = parcelRequire("jhawX");
function $c267d3f5f2b29dff$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $c267d3f5f2b29dff$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $jhawX(t);
}
module.exports = $c267d3f5f2b29dff$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jhawX", function(module, exports) {
function $e087c605e4fdcf23$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $e087c605e4fdcf23$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("lVDuE", function(module, exports) {
function $ff6d8e6c4f25cf58$var$_getPrototypeOf(t) {
    return module.exports = $ff6d8e6c4f25cf58$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $ff6d8e6c4f25cf58$var$_getPrototypeOf(t);
}
module.exports = $ff6d8e6c4f25cf58$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kSyoi", function(module, exports) {

var $hO0eY = parcelRequire("hO0eY");
function $f333871edaaa322a$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $hO0eY(t, e);
}
module.exports = $f333871edaaa322a$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hO0eY", function(module, exports) {
function $cf674aeb1a10c450$var$_setPrototypeOf(t, e) {
    return module.exports = $cf674aeb1a10c450$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $cf674aeb1a10c450$var$_setPrototypeOf(t, e);
}
module.exports = $cf674aeb1a10c450$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("8PVNu", function(module, exports) {

var $lVDuE = parcelRequire("lVDuE");

var $hO0eY = parcelRequire("hO0eY");

var $gzoFx = parcelRequire("gzoFx");

var $gisaB = parcelRequire("gisaB");
function $66efeb7d71b11a1c$var$_wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return module.exports = $66efeb7d71b11a1c$var$_wrapNativeSuper = function _wrapNativeSuper(t) {
        if (null === t || !$gzoFx(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return $gisaB(t, arguments, $lVDuE(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), $hO0eY(Wrapper, t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $66efeb7d71b11a1c$var$_wrapNativeSuper(t);
}
module.exports = $66efeb7d71b11a1c$var$_wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("gzoFx", function(module, exports) {
function $c1030cfd7b15b5b0$var$_isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
module.exports = $c1030cfd7b15b5b0$var$_isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("gisaB", function(module, exports) {

var $0NZZj = parcelRequire("0NZZj");

var $hO0eY = parcelRequire("hO0eY");
function $bdd42dc085cb89be$var$_construct(t, e, r) {
    if ($0NZZj()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && $hO0eY(p, r.prototype), p;
}
module.exports = $bdd42dc085cb89be$var$_construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("0NZZj", function(module, exports) {
function $0026c8ec5a94eed5$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $0026c8ec5a94eed5$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $0026c8ec5a94eed5$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("iOJep", function(module, exports) {

$parcel$export(module.exports, "NoFetchDataAdapter", function () { return $db2ffb8426f0ede3$export$55fffef3474104af; });

var $2R76C = parcelRequire("2R76C");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $gGOBY = parcelRequire("gGOBY");

var $lVDuE = parcelRequire("lVDuE");

var $dX0BB = parcelRequire("dX0BB");

var $kSyoi = parcelRequire("kSyoi");

var $dsN6L = parcelRequire("dsN6L");

var $eWMMH = parcelRequire("eWMMH");

var $65IDm = parcelRequire("65IDm");
function $db2ffb8426f0ede3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $db2ffb8426f0ede3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $db2ffb8426f0ede3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $db2ffb8426f0ede3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $db2ffb8426f0ede3$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($gGOBY)))(t, $db2ffb8426f0ede3$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(t).constructor) : o.apply(t, e));
}
function $db2ffb8426f0ede3$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($db2ffb8426f0ede3$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $db2ffb8426f0ede3$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dX0BB)))((0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $db2ffb8426f0ede3$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, NoFetchDataAdapter);
        _this = $db2ffb8426f0ede3$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($kSyoi)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $65IDm.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $db2ffb8426f0ede3$var$_objectSpread($db2ffb8426f0ede3$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $65IDm._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $db2ffb8426f0ede3$var$_objectSpread($db2ffb8426f0ede3$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $65IDm._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $65IDm._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $65IDm.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $db2ffb8426f0ede3$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $db2ffb8426f0ede3$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $65IDm.DataAdapterCore));

});
parcelRegister("dX0BB", function(module, exports) {

var $biNOM = parcelRequire("biNOM");
function $a28141504e457849$var$_get() {
    return module.exports = $a28141504e457849$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $biNOM(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $a28141504e457849$var$_get.apply(null, arguments);
}
module.exports = $a28141504e457849$var$_get, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("biNOM", function(module, exports) {

var $lVDuE = parcelRequire("lVDuE");
function $83a804fe1e84608f$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $lVDuE(t)););
    return t;
}
module.exports = $83a804fe1e84608f$var$_superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("dgvCq", function(module, exports) {

$parcel$export(module.exports, "LOCAL_STORAGE_KEY", function () { return $9a854bc9df65235b$export$d8474cff104280f3; });
$parcel$export(module.exports, "PersistentOverrideAdapter", function () { return $9a854bc9df65235b$export$bcb28fbac1def494; });

var $dsN6L = parcelRequire("dsN6L");

var $5YM7L = parcelRequire("5YM7L");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $ku4nR = parcelRequire("ku4nR");
function $9a854bc9df65235b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9a854bc9df65235b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9a854bc9df65235b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9a854bc9df65235b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9a854bc9df65235b$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $9a854bc9df65235b$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $9a854bc9df65235b$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $9a854bc9df65235b$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $9a854bc9df65235b$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $9a854bc9df65235b$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $9a854bc9df65235b$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $9a854bc9df65235b$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $9a854bc9df65235b$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $9a854bc9df65235b$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $9a854bc9df65235b$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $9a854bc9df65235b$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, PersistentOverrideAdapter);
        this._overrides = $9a854bc9df65235b$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $9a854bc9df65235b$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $9a854bc9df65235b$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $9a854bc9df65235b$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($9a854bc9df65235b$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($9a854bc9df65235b$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $9a854bc9df65235b$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $ku4nR._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $9a854bc9df65235b$var$_objectSpread($9a854bc9df65235b$var$_objectSpread({}, $9a854bc9df65235b$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($9a854bc9df65235b$var$djb2MapKey((0, $ku4nR._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($9a854bc9df65235b$var$djb2MapKey((0, $ku4nR._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($9a854bc9df65235b$var$djb2MapKey((0, $ku4nR._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($9a854bc9df65235b$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $9a854bc9df65235b$var$_objectSpread($9a854bc9df65235b$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $9a854bc9df65235b$var$_objectSpread($9a854bc9df65235b$var$_objectSpread({}, current.details), {}, {
                        reason: $9a854bc9df65235b$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($9a854bc9df65235b$var$djb2MapKey((0, $ku4nR._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($9a854bc9df65235b$var$djb2MapKey((0, $ku4nR._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($9a854bc9df65235b$var$djb2MapKey((0, $ku4nR._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($9a854bc9df65235b$var$djb2MapKey((0, $ku4nR._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($9a854bc9df65235b$var$djb2MapKey((0, $ku4nR._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($9a854bc9df65235b$var$djb2MapKey((0, $ku4nR._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $9a854bc9df65235b$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($9a854bc9df65235b$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $9a854bc9df65235b$var$_objectSpread($9a854bc9df65235b$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $ku4nR._makeTypedGet)(current.name, overridden),
                    details: $9a854bc9df65235b$var$_objectSpread($9a854bc9df65235b$var$_objectSpread({}, current.details), {}, {
                        reason: $9a854bc9df65235b$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($9a854bc9df65235b$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $9a854bc9df65235b$var$_objectSpread($9a854bc9df65235b$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $ku4nR._makeTypedGet)(current.name, overridden),
                    details: $9a854bc9df65235b$var$_objectSpread($9a854bc9df65235b$var$_objectSpread({}, current.details), {}, {
                        reason: $9a854bc9df65235b$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("3fC94", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $25e05caaf3636a1c$export$1c9f709888824e05; });
var $25e05caaf3636a1c$var$_process, $25e05caaf3636a1c$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $25e05caaf3636a1c$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($25e05caaf3636a1c$var$_process = globalThis.process) === null || $25e05caaf3636a1c$var$_process === void 0 || ($25e05caaf3636a1c$var$_process = $25e05caaf3636a1c$var$_process.env) === null || $25e05caaf3636a1c$var$_process === void 0 ? void 0 : $25e05caaf3636a1c$var$_process.JEST_WORKER_ID) !== undefined;
var $25e05caaf3636a1c$var$DEBUG_MODE = !$25e05caaf3636a1c$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($25e05caaf3636a1c$var$_process2 = globalThis.process) === null || $25e05caaf3636a1c$var$_process2 === void 0 || ($25e05caaf3636a1c$var$_process2 = $25e05caaf3636a1c$var$_process2.env) === null || $25e05caaf3636a1c$var$_process2 === void 0 ? void 0 : $25e05caaf3636a1c$var$_process2.NODE_ENV) !== 'production';
var $25e05caaf3636a1c$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$25e05caaf3636a1c$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});




parcelRegister("2HO6u", function(module, exports) {

$parcel$export(module.exports, "themeStringToObject", function () { return $1f86767afe376484$export$f19b488f7c0547ee; });
$parcel$export(module.exports, "themeObjectToString", function () { return $1f86767afe376484$export$62c37ab81302621a; });

var $61RDg = parcelRequire("61RDg");

var $5YM7L = parcelRequire("5YM7L");

var $3cRMM = parcelRequire("3cRMM");
var $1f86767afe376484$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape'
];
var $1f86767afe376484$var$customThemeOptions = 'UNSAFE_themeOptions';
var $1f86767afe376484$var$isThemeKind = function isThemeKind(themeKind) {
    return $1f86767afe376484$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $1f86767afe376484$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $3cRMM.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $1f86767afe376484$var$isColorMode = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
var $1f86767afe376484$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && $1f86767afe376484$var$isColorMode(id)) themeObject[kind] = id;
        if ($1f86767afe376484$var$isThemeKind(kind) && $1f86767afe376484$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $1f86767afe376484$var$customThemeOptions) try {
            themeObject[$1f86767afe376484$var$customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
var $1f86767afe376484$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $1f86767afe376484$var$isColorMode(id) || // custom theme state
        kind === $1f86767afe376484$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(id) === 'object' || // other theme states
        $1f86767afe376484$var$isThemeKind(kind) && typeof id === 'string' && $1f86767afe376484$var$isThemeIds(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};

});


parcelRegister("7rIXr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56bdeda9fd3b2300$export$2e2bcd8739ae039; });

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $dsN6L = parcelRequire("dsN6L");

var $2S8bR = parcelRequire("2S8bR");

var $4sggA = parcelRequire("4sggA");
/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $56bdeda9fd3b2300$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $4sggA.default)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $2S8bR.THEME_DATA_ATTRIBUTE),
                            (0, $2S8bR.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($56bdeda9fd3b2300$export$2e2bcd8739ae039, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($56bdeda9fd3b2300$export$2e2bcd8739ae039, "callbacks", new Set());

});


parcelRegister("anGZX", function(module, exports) {

$parcel$export(module.exports, "defaultLogoParams", function () { return $78ed67f239cf5962$export$438460117ae6b7ee; });
/**
 * These are the default parameters for LogoProps if the user does not specify values.
 */ var $78ed67f239cf5962$export$438460117ae6b7ee = {
    iconColor: 'inherit',
    label: '',
    size: 'medium',
    textColor: 'currentColor'
};
var $78ed67f239cf5962$export$793fba32aed8942a = {
    iconGradientStart: 'inherit',
    iconGradientStop: 'inherit'
}; /**
 * The props for the <Wrapper /> that takes the svg and turns it into a component.
 */ 

});

parcelRegister("1hGv8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ef858d13cffa91d$export$2e2bcd8739ae039; });
/* wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $dsN6L = parcelRequire("dsN6L");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");
var $0ef858d13cffa91d$var$_excluded = [
    "label",
    "svg",
    "size",
    "appearance",
    "iconColor",
    "textColor",
    "testId"
];
var $0ef858d13cffa91d$var$CSS_VAR_COLOR = '--logo-color';
var $0ef858d13cffa91d$var$CSS_VAR_FILL = '--logo-fill';
var $0ef858d13cffa91d$var$styles = {
    root: "_1e0c1o8l _kqswh2mm _syaz1vry _lswu1xf6 _vwz4kb7n _uiztglyw _o5724jg8 _zbji1osq _3se11kw7",
    stop: "_vc881r31",
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ var $0ef858d13cffa91d$var$Wrapper = function Wrapper(_ref) {
    var label = _ref.label, svg = _ref.svg, size = _ref.size, appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor, userDefinedTestId = _ref.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $0ef858d13cffa91d$var$_excluded);
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    var shouldApplyStopColor = appearance === undefined;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    return /*#__PURE__*/ $91i6m.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        "data-testid": testId,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, $0ef858d13cffa91d$var$CSS_VAR_COLOR, iconColor), $0ef858d13cffa91d$var$CSS_VAR_FILL, textColor),
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        }
    }, rest, {
        className: (0, $9gzWK.default)([
            $0ef858d13cffa91d$var$styles.root,
            shouldApplyStopColor && $0ef858d13cffa91d$var$styles.stop,
            size && $0ef858d13cffa91d$var$styles[size]
        ])
    }));
};
var $0ef858d13cffa91d$export$2e2bcd8739ae039 = $0ef858d13cffa91d$var$Wrapper;

});

parcelRegister("7NTQQ", function(module, exports) {

$parcel$export(module.exports, "getColorsFromAppearanceOldLogos", function () { return $5ae86ee5e1367a5d$export$362a25f017e2bc8a; });
$parcel$export(module.exports, "getColorsFromAppearance", function () { return $5ae86ee5e1367a5d$export$bbacc3980e0f3029; });
$parcel$export(module.exports, "getColorsForLoom", function () { return $5ae86ee5e1367a5d$export$7818df200941dbbf; });

var $crpYx = parcelRequire("crpYx");
var $5ae86ee5e1367a5d$export$362a25f017e2bc8a = function getColorsFromAppearanceOldLogos(appearance, colorMode) {
    var iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case 'brand':
            iconGradientStart = (0, $crpYx.B400);
            iconGradientStop = (0, $crpYx.B200);
            iconColor = (0, $crpYx.B200);
            textColor = "var(--ds-text, ".concat((0, $crpYx.N800), ")");
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = (0, $crpYx.B400);
            break;
        case 'neutral':
            iconGradientStart = (0, $crpYx.N600);
            iconGradientStop = (0, $crpYx.N100);
            iconColor = (0, $crpYx.N100);
            textColor = (0, $crpYx.N400);
            atlassianLogoTextColor = (0, $crpYx.N400);
            break;
        case 'inverse':
            iconGradientStart = '#FFFFFF66';
            iconGradientStop = '#FFFFFF';
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    if (colorMode === 'dark' && appearance === 'inverse') {
        iconGradientStart = '#161A1D66';
        iconGradientStop = '#161A1D';
        iconColor = '#161A1D';
        textColor = '#161A1D';
        atlassianLogoTextColor = '#161A1D';
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $5ae86ee5e1367a5d$export$bbacc3980e0f3029 = function getColorsFromAppearance(appearance, colorMode) {
    var iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#357DE8';
            textColor = '#E2E3E4';
            atlassianLogoTextColor = '#357DE8';
            break;
        case 'neutral':
            iconColor = '#96999E';
            textColor = '#BFC1C4';
            atlassianLogoTextColor = '#96999E';
            break;
        case 'inverse':
            iconColor = '#101214';
            textColor = '#101214';
            atlassianLogoTextColor = '#101214';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#1868DB';
            textColor = '#101214';
            atlassianLogoTextColor = '#1868DB';
            break;
        case 'neutral':
            iconColor = '#6C6F77';
            textColor = '#3B3D42';
            atlassianLogoTextColor = '#6C6F77';
            break;
        case 'inverse':
            iconColor = (0, $crpYx.N0);
            textColor = (0, $crpYx.N0);
            atlassianLogoTextColor = (0, $crpYx.N0);
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $5ae86ee5e1367a5d$export$7818df200941dbbf = function getColorsForLoom(appearance, colorMode) {
    var iconColor = $5ae86ee5e1367a5d$export$bbacc3980e0f3029(appearance, colorMode).iconColor;
    var textColor = $5ae86ee5e1367a5d$export$bbacc3980e0f3029(appearance, colorMode).textColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#EFF0FF';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#252434';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};

});
parcelRegister("crpYx", function(module, exports) {

$parcel$export(module.exports, "B200", function () { return $90ec27d3c4d98c58$export$215b7063051591f1; });
$parcel$export(module.exports, "B400", function () { return $90ec27d3c4d98c58$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "N0", function () { return $90ec27d3c4d98c58$export$29a4f05edc054374; });
$parcel$export(module.exports, "N100", function () { return $90ec27d3c4d98c58$export$d6447c357493214f; });
$parcel$export(module.exports, "N400", function () { return $90ec27d3c4d98c58$export$eece5f492e429f08; });
$parcel$export(module.exports, "N600", function () { return $90ec27d3c4d98c58$export$7090862dc3038a9f; });
$parcel$export(module.exports, "N800", function () { return $90ec27d3c4d98c58$export$7d61b15e0da132af; });
// Reds
var $90ec27d3c4d98c58$export$4b84fd0e2c617bd = '#FFEBE6';
var $90ec27d3c4d98c58$export$b34b069eff244586 = '#FFBDAD';
var $90ec27d3c4d98c58$export$be802dd0d8b57f35 = '#FF8F73';
var $90ec27d3c4d98c58$export$60847d42f9da92a6 = '#FF7452';
var $90ec27d3c4d98c58$export$4a7404f376229999 = '#FF5630';
var $90ec27d3c4d98c58$export$2010d0fb4295b346 = '#DE350B';
var $90ec27d3c4d98c58$export$2837b5a1a71d5c02 = '#BF2600';
var $90ec27d3c4d98c58$export$8d9596b529bbb9cf = '#FFFAE6';
var $90ec27d3c4d98c58$export$41060a744ab0b7ae = '#FFF0B3';
var $90ec27d3c4d98c58$export$1cc05bbbf340e559 = '#FFE380';
var $90ec27d3c4d98c58$export$5aae31392d72caaa = '#FFC400';
var $90ec27d3c4d98c58$export$c6930421db9fa514 = '#FFAB00';
var $90ec27d3c4d98c58$export$59619663aa6500fb = '#FF991F';
var $90ec27d3c4d98c58$export$874739ea9e379ab6 = '#FF8B00';
var $90ec27d3c4d98c58$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $90ec27d3c4d98c58$export$69a3bf21b9686c2b = '#ABF5D1';
var $90ec27d3c4d98c58$export$afbce1382ec95f73 = '#79F2C0';
var $90ec27d3c4d98c58$export$747d86715d4175de = '#57D9A3';
var $90ec27d3c4d98c58$export$940e1f69e873f202 = '#36B37E';
var $90ec27d3c4d98c58$export$a49394138f7b8e85 = '#00875A';
var $90ec27d3c4d98c58$export$6fa04827ac68a4fb = '#006644';
var $90ec27d3c4d98c58$export$226de0355ed012f8 = '#DEEBFF';
var $90ec27d3c4d98c58$export$8c13c2ee36917869 = '#B3D4FF';
var $90ec27d3c4d98c58$export$ecfc1dff386a3e7a = '#4C9AFF';
var $90ec27d3c4d98c58$export$215b7063051591f1 = '#2684FF';
var $90ec27d3c4d98c58$export$e62e8919cca44969 = '#0065FF';
var $90ec27d3c4d98c58$export$b3de0ae08da2ce64 = '#0052CC';
var $90ec27d3c4d98c58$export$a6ee3d71bc067634 = '#0747A6';
var $90ec27d3c4d98c58$export$67f15409e87642a1 = '#669DF1';
var $90ec27d3c4d98c58$export$f0539dbc42dbb067 = '#8FB8F6';
var $90ec27d3c4d98c58$export$363e4475840015bb = '#EAE6FF';
var $90ec27d3c4d98c58$export$4b0a4417ed59760f = '#C0B6F2';
var $90ec27d3c4d98c58$export$6011520a64d9a187 = '#998DD9';
var $90ec27d3c4d98c58$export$a7175d4e9206bc80 = '#8777D9';
var $90ec27d3c4d98c58$export$b48405b95304b5a1 = '#6554C0';
var $90ec27d3c4d98c58$export$c71e4279dd54a18d = '#5243AA';
var $90ec27d3c4d98c58$export$147899de772240ec = '#403294';
var $90ec27d3c4d98c58$export$2cf711fe14c66f06 = '#E6FCFF';
var $90ec27d3c4d98c58$export$7a8f4d33f6f9772c = '#B3F5FF';
var $90ec27d3c4d98c58$export$776c9c497ef08533 = '#79E2F2';
var $90ec27d3c4d98c58$export$69cb3ca10c1e330e = '#00C7E6';
var $90ec27d3c4d98c58$export$9dc1ef0f3f48059b = '#00B8D9';
var $90ec27d3c4d98c58$export$7c835c78b6fcdef8 = '#00A3BF';
var $90ec27d3c4d98c58$export$6036577f95c3877e = '#008DA6';
var $90ec27d3c4d98c58$export$29a4f05edc054374 = '#FFFFFF';
var $90ec27d3c4d98c58$export$e655ef011c4aa1a2 = '#FAFBFC';
var $90ec27d3c4d98c58$export$9fdfb749e33cdf97 = '#F4F5F7';
var $90ec27d3c4d98c58$export$3e51e8f1440314ba = '#EBECF0';
var $90ec27d3c4d98c58$export$1ce2d1575d444ceb = '#DFE1E6';
var $90ec27d3c4d98c58$export$8754fc7e6d8b3000 = '#C1C7D0';
var $90ec27d3c4d98c58$export$c2e91cbeada39b8b = '#B3BAC5';
var $90ec27d3c4d98c58$export$5f71e19f3a7ad9de = '#A5ADBA';
var $90ec27d3c4d98c58$export$eaa8c8a70ac22806 = '#97A0AF';
var $90ec27d3c4d98c58$export$7c87d337fb91a97d = '#8993A4';
var $90ec27d3c4d98c58$export$d6447c357493214f = '#7A869A';
var $90ec27d3c4d98c58$export$f563ee71e9ee74cd = '#6B778C';
var $90ec27d3c4d98c58$export$e2ef2124cf4024b1 = '#5E6C84';
var $90ec27d3c4d98c58$export$eece5f492e429f08 = '#505F79';
var $90ec27d3c4d98c58$export$c39c0fe0f26207ae = '#42526E';
var $90ec27d3c4d98c58$export$7090862dc3038a9f = '#344563';
var $90ec27d3c4d98c58$export$ad0bacf983b7ddaa = '#253858';
var $90ec27d3c4d98c58$export$7d61b15e0da132af = '#172B4D';
var $90ec27d3c4d98c58$export$fbda843f0a27fe96 = '#091E42';
var $90ec27d3c4d98c58$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $90ec27d3c4d98c58$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $90ec27d3c4d98c58$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $90ec27d3c4d98c58$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $90ec27d3c4d98c58$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $90ec27d3c4d98c58$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $90ec27d3c4d98c58$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $90ec27d3c4d98c58$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $90ec27d3c4d98c58$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $90ec27d3c4d98c58$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $90ec27d3c4d98c58$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $90ec27d3c4d98c58$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $90ec27d3c4d98c58$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $90ec27d3c4d98c58$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $90ec27d3c4d98c58$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $90ec27d3c4d98c58$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $90ec27d3c4d98c58$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $90ec27d3c4d98c58$export$2f6319cf7d736c2a = '#E6EDFA';
var $90ec27d3c4d98c58$export$95126bc8884d6634 = '#DCE5F5';
var $90ec27d3c4d98c58$export$8338d8c35d44ff1 = '#CED9EB';
var $90ec27d3c4d98c58$export$5368d76ae4fbbda7 = '#B8C7E0';
var $90ec27d3c4d98c58$export$9f0a771d16ec8d36 = '#ABBBD6';
var $90ec27d3c4d98c58$export$abcf8c38338b4aa5 = '#9FB0CC';
var $90ec27d3c4d98c58$export$97e81faa16a182c7 = '#8C9CB8';
var $90ec27d3c4d98c58$export$bfe21c59123ecf33 = '#7988A3';
var $90ec27d3c4d98c58$export$ee82aa2ea6a1558 = '#67758F';
var $90ec27d3c4d98c58$export$682927c6ed76be02 = '#56637A';
var $90ec27d3c4d98c58$export$91fd9994c5be9757 = '#455166';
var $90ec27d3c4d98c58$export$d281fbfe3cff2df6 = '#3B475C';
var $90ec27d3c4d98c58$export$3902c91d8b98a753 = '#313D52';
var $90ec27d3c4d98c58$export$8e8133c1ba5845b5 = '#283447';
var $90ec27d3c4d98c58$export$33ff357f6620b39 = '#202B3D';
var $90ec27d3c4d98c58$export$633847cf062b69e0 = '#1B2638';
var $90ec27d3c4d98c58$export$9776a6e503bdbf76 = '#121A29';
var $90ec27d3c4d98c58$export$6c813d5160dff5db = '#0E1624';
var $90ec27d3c4d98c58$export$3d4f271a500072a = '#0D1424';
var $90ec27d3c4d98c58$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $90ec27d3c4d98c58$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $90ec27d3c4d98c58$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $90ec27d3c4d98c58$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $90ec27d3c4d98c58$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $90ec27d3c4d98c58$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $90ec27d3c4d98c58$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $90ec27d3c4d98c58$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $90ec27d3c4d98c58$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $90ec27d3c4d98c58$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $90ec27d3c4d98c58$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $90ec27d3c4d98c58$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $90ec27d3c4d98c58$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $90ec27d3c4d98c58$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $90ec27d3c4d98c58$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $90ec27d3c4d98c58$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $90ec27d3c4d98c58$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $90ec27d3c4d98c58$export$d2adc5dedf09fced = '#292A2E';
var $90ec27d3c4d98c58$export$f51762073d2bb381 = '#94C748';
var $90ec27d3c4d98c58$export$95e26d54def96891 = '#B3DF72';

});



parcelRegister("kyMDl", function(module, exports) {

module.exports = (parcelRequire("cgi2g")).getBundleURL('9rAa3') + "Error.b0f67bec.svg";

});

parcelRegister("1V2cH", function(module, exports) {

$parcel$export(module.exports, "appendReferer", function () { return $3a66668f31be527d$export$b75bb5b493e221ea; });
$parcel$export(module.exports, "appendReasonViewingScreen", function () { return $3a66668f31be527d$export$b68d90d94a86fe33; });
$parcel$export(module.exports, "AnalyticsClientImpl", function () { return $3a66668f31be527d$export$17499c710c4e1d; });
$parcel$export(module.exports, "AnalyticsClientContext", function () { return $3a66668f31be527d$export$70089efe93d43959; });
$parcel$export(module.exports, "useAnalyticsClient", function () { return $3a66668f31be527d$export$923054f18cb06572; });
$parcel$export(module.exports, "useAnalyticsAnonymousId", function () { return $3a66668f31be527d$export$e126afa8615733f3; });
$parcel$export(module.exports, "useTrackingEvent", function () { return $3a66668f31be527d$export$1397d31414038d5e; });
$parcel$export(module.exports, "usePageViewedEvent", function () { return $3a66668f31be527d$export$a07d7c1ce880cd05; });
$parcel$export(module.exports, "useButtonClickedEvent", function () { return $3a66668f31be527d$export$4fb7f377b48b9cbc; });
$parcel$export(module.exports, "useLinkClickedEvent", function () { return $3a66668f31be527d$export$65af8b3e3ac7d8ee; });
$parcel$export(module.exports, "useFormSubmittedEvent", function () { return $3a66668f31be527d$export$69c70ee0cb243a51; });
$parcel$export(module.exports, "useOperationalEvent", function () { return $3a66668f31be527d$export$87ff6dcd457142b0; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $bqdjD = parcelRequire("bqdjD");

var $49Pnv = parcelRequire("49Pnv");

var $imbUG = parcelRequire("imbUG");
var $9UvCO = parcelRequire("9UvCO");

var $5lFna = parcelRequire("5lFna");

var $91i6m = parcelRequire("91i6m");

var $7eeh4 = parcelRequire("7eeh4");

var $dHOko = parcelRequire("dHOko");

var $fYxRW = parcelRequire("fYxRW");

var $cDwV0 = parcelRequire("cDwV0");
parcelRequire("h8k8x");
var $7eWkL = parcelRequire("7eWkL");

var $6cMFi = parcelRequire("6cMFi");
const $3a66668f31be527d$var$tags = [
    'identity'
];
function $3a66668f31be527d$var$getEnv() {
    switch(0, $bqdjD.currentEnv){
        case 'local':
            return (0, $9UvCO.envType).LOCAL;
        case 'dev':
            return (0, $9UvCO.envType).DEV;
        case 'stg':
        case 'stg-fedm':
        case 'stg-ic':
            return (0, $9UvCO.envType).STAGING;
        case 'prod':
        case 'prod-fedm':
        case 'prod-ic':
            return (0, $9UvCO.envType).PROD;
        default:
            return (0, $9UvCO.envType).DEV;
    }
}
function $3a66668f31be527d$export$b75bb5b493e221ea(eventAttributes) {
    try {
        const referer = new URL(document.referrer);
        referer.search = ''; // lets minimise possibility of tokens in referer by cleaning up query params
        return (0, $b2I6k._)((0, $1Fos3._)({}, eventAttributes), {
            referer: referer.toString()
        });
    } catch (e) {
        return eventAttributes;
    }
}
function $3a66668f31be527d$export$b68d90d94a86fe33(eventAttributes, userFlow) {
    if (userFlow) return (0, $b2I6k._)((0, $1Fos3._)({}, eventAttributes), {
        reasonViewingScreen: userFlow
    });
    return eventAttributes;
}
function $3a66668f31be527d$var$determinePlatform(microbranding) {
    if ((0, $7eeh4.isMobileOidc)(microbranding.oidcContext) || microbranding.isEmbedded) return (0, $9UvCO.platformType).MOBILE_WEB;
    return (0, $9UvCO.platformType).WEB;
}
let $3a66668f31be527d$var$analyticsClient;
function $3a66668f31be527d$export$77ce8f76f8d1e1d1({ microbranding: microbranding, locality: locality, tenantCloudId: tenantCloudId, userId: userId }) {
    const platform = $3a66668f31be527d$var$determinePlatform(microbranding);
    const locale = locality || 'en';
    const env = $3a66668f31be527d$var$getEnv();
    const apiHost = [
        'prod',
        'staging'
    ].includes((0, $bqdjD.currentEnvType)) ? window.location.host + '/gateway/api/gasv3/api/v1' : undefined;
    if (!$3a66668f31be527d$var$analyticsClient) $3a66668f31be527d$var$analyticsClient = new (0, $imbUG.default)({
        env: env,
        product: 'identity',
        origin: (0, $9UvCO.originType).WEB,
        platform: platform,
        locale: locale,
        perimeter: (0, $bqdjD.currentPerimeter)
    }, {
        apiHost: apiHost
    });
    if (userId) $3a66668f31be527d$var$analyticsClient.setUserInfo((0, $9UvCO.userType).ATLASSIAN_ACCOUNT, userId);
    if (tenantCloudId) $3a66668f31be527d$var$analyticsClient.setTenantInfo((0, $9UvCO.tenantType).CLOUD_ID, tenantCloudId);
    else $3a66668f31be527d$var$analyticsClient.setTenantInfo((0, $9UvCO.tenantType).NONE);
    return $3a66668f31be527d$var$analyticsClient;
}
class $3a66668f31be527d$export$17499c710c4e1d {
    formSubmittedEvent(page, formId, attributes) {
        return this.uiEvent({
            page: page,
            action: 'submitted',
            subject: 'form',
            subjectId: formId,
            attributes: attributes
        });
    }
    buttonClickedEvent(page, buttonId, attributes) {
        return this.uiEvent({
            page: page,
            action: 'clicked',
            subject: 'button',
            subjectId: buttonId,
            attributes: attributes
        });
    }
    linkClickedEvent(page, linkId, attributes) {
        return this.uiEvent({
            page: page,
            action: 'clicked',
            subject: 'link',
            subjectId: linkId,
            attributes: attributes
        });
    }
    checkboxChangedEvent(page, checkboxId, attributes) {
        return this.uiEvent({
            page: page,
            action: 'changed',
            subject: 'checkbox',
            subjectId: checkboxId,
            attributes: attributes
        });
    }
    trackingEvent(event) {
        const attributes = this.enrichAttributes(event.attributes);
        (0, $49Pnv.addBreadcrumb)({
            category: 'tracking',
            message: `UI ${event.action} tracking event occured at ${event.subject} ${event.subjectId} on page ${event.page}`,
            data: (0, $1Fos3._)({
                // this has to be a flat structure
                source: event.page,
                actionSubject: event.subject,
                action: event.action,
                actionSubjectId: event.subjectId
            }, attributes)
        });
        try {
            this.client.sendTrackEvent({
                source: event.page,
                actionSubject: event.subject,
                action: event.action,
                actionSubjectId: event.subjectId,
                attributes: attributes,
                tags: $3a66668f31be527d$var$tags
            });
        } catch (error) {
            (0, $49Pnv.captureException)(error, {
                event: event
            });
        }
    }
    operationalEvent(event, callback) {
        const attributes = this.enrichAttributes(event.attributes);
        (0, $49Pnv.addBreadcrumb)({
            category: 'operational',
            message: `${event.action} operational event occured at ${event.subject} ${event.subjectId} on page ${event.page}`,
            data: (0, $1Fos3._)({
                // this has to be a flat structure
                source: event.page,
                actionSubject: event.subject,
                action: event.action,
                actionSubjectId: event.subjectId
            }, attributes)
        });
        try {
            this.client.sendOperationalEvent({
                source: event.page,
                actionSubject: event.subject,
                action: event.action,
                actionSubjectId: event.subjectId,
                attributes: attributes,
                tags: $3a66668f31be527d$var$tags
            }, callback);
        } catch (error) {
            (0, $49Pnv.captureException)(error, {
                event: event
            });
            if (callback) callback(error);
        }
    }
    async pageViewedEvent(page, eventAttributes) {
        const attributes = this.enrichAttributes(eventAttributes);
        (0, $49Pnv.addBreadcrumb)({
            category: 'pageViewed',
            message: 'Page viewed event of page id ' + page,
            data: (0, $1Fos3._)({
                source: page
            }, attributes)
        });
        try {
            const metric = (0, $7eWkL.getPageLoadMetric)(page);
            if (metric.getData().state !== 'finished') metric.stop();
        } catch (error) {
            (0, $49Pnv.captureException)(error, {
                page: page
            });
        }
        try {
            await this.client.sendScreenEvent({
                name: page,
                attributes: attributes
            });
        } catch (error) {
            (0, $49Pnv.captureException)(error, {
                page: page
            });
        }
    }
    errorShownEvent(page, subjectId, eventAttributes) {
        return this.uiEvent({
            page: page,
            action: 'shown',
            subject: 'error',
            subjectId: subjectId,
            attributes: eventAttributes
        });
    }
    uiEvent(event) {
        const attributes = this.enrichAttributes(event.attributes);
        (0, $49Pnv.addBreadcrumb)({
            category: 'ui',
            message: `UI ${event.action} event occured at ${event.subject} ${event.subjectId} on page ${event.page}`,
            data: (0, $1Fos3._)({
                // this has to be a flat structure
                source: event.page,
                actionSubject: event.subject,
                action: event.action,
                actionSubjectId: event.subjectId
            }, attributes)
        });
        return new Promise((resolve)=>{
            try {
                this.client.sendUIEvent({
                    source: event.page,
                    actionSubject: event.subject,
                    action: event.action,
                    actionSubjectId: event.subjectId,
                    attributes: attributes,
                    tags: $3a66668f31be527d$var$tags
                }, ()=>resolve());
            } catch (error) {
                (0, $49Pnv.captureException)(error, {
                    event: event
                });
                // error is already captured, no point in putting the burden upon consumers by rejecting since they likely want to proceed
                resolve();
            }
        });
    }
    stopApdexEvent(apdexEvent) {
        try {
            this.client.stopApdexEvent(apdexEvent);
        } catch (error) {
            (0, $49Pnv.captureException)(error, {
                event: apdexEvent
            });
        }
    }
    stopInitialLoadApdexEvent(task) {
        this.stopApdexEvent({
            task: task,
            type: 'initialLoad',
            additionalAttributes: {
                properties: {
                    firstPaint: (0, $cDwV0.getFirstPaint)(),
                    firstContentfulPaint: (0, $cDwV0.getFirstContentfulPaint)()
                }
            }
        });
    }
    getInstance() {
        return this.client;
    }
    getAnonymousId() {
        return this.client.getAnonymousId();
    }
    setFfsId(ffsId) {
        this.ffsId = ffsId;
    }
    enrichAttributes(eventAttributes) {
        const originTracingProperties = (0, $dHOko.default)(window.location.href, {
            mapAttribute: (value)=>typeof value === 'string' ? (0, $5lFna.dangerouslyCreateSafeString)(value) : value
        });
        const queryParams = new URLSearchParams(window.location.search);
        const flowTraceId = queryParams.get('flowTraceId');
        const applicationData = (0, $fYxRW.lookupApplication)(this.cobranding);
        const application = applicationData ? applicationData.application : 'unknown';
        const applicationAnalyticAttributes = {
            firstProductAccessed: application,
            experience: applicationData === null || applicationData === void 0 ? void 0 : applicationData.experience
        };
        return (0, $b2I6k._)((0, $1Fos3._)((0, $b2I6k._)((0, $1Fos3._)({}, applicationAnalyticAttributes, originTracingProperties, flowTraceId && {
            flowTraceId: flowTraceId
        }), {
            isMobileApp: this.microbranding.isMobileApp
        }), eventAttributes), {
            ffsId: this.ffsId,
            isInPopup: Boolean(window.opener && window.opener !== window),
            isServedByBifrost: (0, $6cMFi.default)()
        });
    }
    constructor(args){
        const { microbranding: microbranding, cobranding: cobranding, locale: locale, tenantCloudId: tenantCloudId, userId: userId, client: client = $3a66668f31be527d$export$77ce8f76f8d1e1d1({
            microbranding: microbranding,
            locality: locale,
            tenantCloudId: tenantCloudId,
            userId: userId
        }) } = args;
        try {
            (0, $49Pnv.setLocale)(locale);
            this.microbranding = microbranding;
            this.cobranding = cobranding;
            this.client = client;
        } catch (error) {
            (0, $49Pnv.captureException)(error);
        }
    }
}
const $3a66668f31be527d$export$70089efe93d43959 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createContext(null);
const $3a66668f31be527d$export$923054f18cb06572 = ()=>{
    const context = (0, $91i6m.useContext)($3a66668f31be527d$export$70089efe93d43959);
    if (!context) throw new Error('useAnalyticsClient used outside of AnalyticsProvider.');
    return context;
};
const $3a66668f31be527d$export$e126afa8615733f3 = ()=>{
    const analyticsClient = $3a66668f31be527d$export$923054f18cb06572();
    return analyticsClient.getAnonymousId();
};
const $3a66668f31be527d$export$1397d31414038d5e = (event)=>{
    const analyticsClient = $3a66668f31be527d$export$923054f18cb06572();
    (0, $91i6m.useEffect)(()=>{
        analyticsClient.trackingEvent(event);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
};
const $3a66668f31be527d$export$a07d7c1ce880cd05 = (page, eventAttributes)=>{
    const analyticsClient = $3a66668f31be527d$export$923054f18cb06572();
    (0, $91i6m.useEffect)(()=>{
        analyticsClient.pageViewedEvent(page, eventAttributes);
    }, [
        page
    ]); // eslint-disable-line react-hooks/exhaustive-deps
};
const $3a66668f31be527d$export$4fb7f377b48b9cbc = (page, buttonId, attributes)=>{
    const analyticsClient = $3a66668f31be527d$export$923054f18cb06572();
    return (0, $91i6m.useCallback)(()=>{
        analyticsClient.buttonClickedEvent(page, buttonId, attributes);
    }, [
        analyticsClient,
        page,
        buttonId,
        attributes
    ]);
};
const $3a66668f31be527d$export$65af8b3e3ac7d8ee = (page, linkId, attributes)=>{
    const analyticsClient = $3a66668f31be527d$export$923054f18cb06572();
    return (0, $91i6m.useCallback)(()=>{
        analyticsClient.linkClickedEvent(page, linkId, attributes);
    }, [
        analyticsClient,
        page,
        linkId,
        attributes
    ]);
};
const $3a66668f31be527d$export$69c70ee0cb243a51 = (page, formId, attributes)=>{
    const analyticsClient = $3a66668f31be527d$export$923054f18cb06572();
    return (0, $91i6m.useCallback)(()=>{
        analyticsClient.formSubmittedEvent(page, formId, attributes);
    }, [
        analyticsClient,
        page,
        formId,
        attributes
    ]);
};
const $3a66668f31be527d$export$87ff6dcd457142b0 = (operationalEvent, callback)=>{
    const analyticsClient = $3a66668f31be527d$export$923054f18cb06572();
    (0, $91i6m.useEffect)(()=>{
        analyticsClient.operationalEvent(operationalEvent, callback);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
};

});
parcelRegister("1Fos3", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $136c965950901ddd$export$71511d61b312f219; });

var $dHPIr = parcelRequire("dHPIr");
function $136c965950901ddd$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $dHPIr._)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("dHPIr", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9fa7682c38e471bb$export$71511d61b312f219; });
function $9fa7682c38e471bb$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("b2I6k", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $80a217269df00cf8$export$71511d61b312f219; });
function $80a217269df00cf8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $80a217269df00cf8$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $80a217269df00cf8$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("bqdjD", function(module, exports) {

$parcel$export(module.exports, "currentEnv", function () { return $5bb64522e5610275$export$d1418d82198b4abb; });
$parcel$export(module.exports, "getCurrentEnv", function () { return $5bb64522e5610275$export$449f077783cda297; });
$parcel$export(module.exports, "currentEnvType", function () { return $5bb64522e5610275$export$fc28d431ec5ff0ef; });
$parcel$export(module.exports, "idacOrigin", function () { return $5bb64522e5610275$export$7fd1ab530687106; });
$parcel$export(module.exports, "currentCloudType", function () { return $5bb64522e5610275$export$965b3f41be601b7a; });
$parcel$export(module.exports, "currentPerimeter", function () { return $5bb64522e5610275$export$84a0517db04c70cb; });
$parcel$export(module.exports, "getCurrentCloudType", function () { return $5bb64522e5610275$export$35199af7a1ed7e54; });
$parcel$export(module.exports, "isFedM", function () { return $5bb64522e5610275$export$9db7980b9f442a4c; });
$parcel$export(module.exports, "isIsolatedCloud", function () { return $5bb64522e5610275$export$9186ccba8effc5de; });
$parcel$export(module.exports, "getConfig", function () { return $5bb64522e5610275$export$44487a86467333c3; });
function $5bb64522e5610275$var$inferEnvFromHostname(hostname) {
    if (hostname === 'localhost') return 'local';
    if (hostname.endsWith('.dev.internal.atlassian.com') || hostname.endsWith('.dev.atlassian.com')) return 'dev';
    if (hostname.endsWith('.stg.internal.atlassian.com') || hostname.endsWith('.stg.atlassian.com')) return 'stg';
    if (hostname.endsWith('.stg.atlassian-us-gov-mod.com')) return 'stg-fedm';
    if (hostname.endsWith('.oasis-stg.com')) return 'stg-ic';
    if (hostname.endsWith('.atlassian-us-gov-mod.com')) return 'prod-fedm';
    if (hostname.endsWith('.atlassian.com')) return 'prod';
    if (hostname.endsWith('.atlassian-isolated.net')) return 'prod-ic';
    return 'unknown';
}
const $5bb64522e5610275$export$d1418d82198b4abb = $5bb64522e5610275$var$inferEnvFromHostname(window.location.hostname);
const $5bb64522e5610275$export$449f077783cda297 = ()=>$5bb64522e5610275$var$inferEnvFromHostname(window.location.hostname);
const $5bb64522e5610275$var$envTypes = {
    local: 'dev',
    dev: 'dev',
    stg: 'staging',
    'stg-fedm': 'staging',
    'stg-ic': 'staging',
    prod: 'prod',
    'prod-fedm': 'prod',
    'prod-ic': 'prod',
    unknown: 'unknown'
};
const $5bb64522e5610275$export$fc28d431ec5ff0ef = $5bb64522e5610275$var$envTypes[$5bb64522e5610275$export$d1418d82198b4abb];
const $5bb64522e5610275$var$idacOrigins = {
    // The local proxy is created within Parcel on the frontend local step, and requests are proxied to staging
    // Using `window.location.protocol` means that we don't need to make a change here if we run using HTTPS or HTTP.
    local: `${window.location.protocol}//localhost:3000`,
    dev: 'https://id.dev.internal.atlassian.com',
    stg: 'https://id.stg.internal.atlassian.com',
    'stg-fedm': 'https://id.stg.atlassian-us-gov-mod.com',
    'stg-ic': window.location.origin,
    prod: 'https://id.atlassian.com',
    'prod-fedm': 'https://id.atlassian-us-gov-mod.com',
    'prod-ic': window.location.origin,
    unknown: 'https://id.atlassian.com'
};
const $5bb64522e5610275$export$7fd1ab530687106 = $5bb64522e5610275$var$idacOrigins[$5bb64522e5610275$export$d1418d82198b4abb];
const $5bb64522e5610275$var$atlassianCloudType = {
    local: 'commercial',
    dev: 'commercial',
    stg: 'commercial',
    'stg-fedm': 'fedramp-moderate',
    'stg-ic': 'isolated-cloud',
    prod: 'commercial',
    'prod-fedm': 'fedramp-moderate',
    'prod-ic': 'isolated-cloud',
    unknown: 'commercial'
};
const $5bb64522e5610275$var$perimeter = {
    local: 'commercial',
    dev: 'commercial',
    stg: 'commercial',
    'stg-fedm': 'fedramp-moderate',
    'stg-ic': 'commercial',
    prod: 'commercial',
    'prod-fedm': 'fedramp-moderate',
    'prod-ic': 'commercial',
    unknown: 'commercial'
};
const $5bb64522e5610275$var$config = {
    dev: {
        recaptcha: {
            smsEnrollmentRecaptchaEnterpriseInvisibleKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
            smsEnrollmentRecaptchaEnterpriseNewKey: '6Ld_RrgpAAAAAC6NtADmI_b9uTwxyDieSQbL0A4O'
        }
    },
    staging: {
        recaptcha: {
            smsEnrollmentRecaptchaEnterpriseInvisibleKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
            smsEnrollmentRecaptchaEnterpriseNewKey: '6Ld_RrgpAAAAAC6NtADmI_b9uTwxyDieSQbL0A4O'
        }
    },
    prod: {
        recaptcha: {
            smsEnrollmentRecaptchaEnterpriseInvisibleKey: '6LeLRz0kAAAAAPIWGnreLcE0BJaZ17REyxkFhM0E',
            smsEnrollmentRecaptchaEnterpriseNewKey: '6LcjUrgpAAAAANvg2hgPsYsHNO9F21kQVCQwUPoF'
        }
    },
    unknown: {
        recaptcha: {
            smsEnrollmentRecaptchaEnterpriseInvisibleKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
            smsEnrollmentRecaptchaEnterpriseNewKey: '6Ld_RrgpAAAAAC6NtADmI_b9uTwxyDieSQbL0A4O'
        }
    }
};
const $5bb64522e5610275$export$965b3f41be601b7a = $5bb64522e5610275$var$atlassianCloudType[$5bb64522e5610275$export$d1418d82198b4abb];
const $5bb64522e5610275$export$84a0517db04c70cb = $5bb64522e5610275$var$perimeter[$5bb64522e5610275$export$d1418d82198b4abb];
const $5bb64522e5610275$export$35199af7a1ed7e54 = ()=>$5bb64522e5610275$var$atlassianCloudType[$5bb64522e5610275$export$d1418d82198b4abb];
const $5bb64522e5610275$export$9db7980b9f442a4c = ()=>$5bb64522e5610275$export$35199af7a1ed7e54() === 'fedramp-moderate';
const $5bb64522e5610275$export$9186ccba8effc5de = ()=>$5bb64522e5610275$export$35199af7a1ed7e54() === 'isolated-cloud';
const $5bb64522e5610275$export$44487a86467333c3 = ()=>$5bb64522e5610275$var$config[$5bb64522e5610275$export$fc28d431ec5ff0ef];

});

parcelRegister("49Pnv", function(module, exports) {

$parcel$export(module.exports, "initClient", function () { return $5ca0c57b411d9bc5$export$c4b69426a5efa3b7; });
$parcel$export(module.exports, "setUserId", function () { return $5ca0c57b411d9bc5$export$7f5abdb7f5093137; });
$parcel$export(module.exports, "addBreadcrumb", function () { return $5ca0c57b411d9bc5$export$efda9a273d7a036d; });
$parcel$export(module.exports, "setLocale", function () { return $5ca0c57b411d9bc5$export$c8aadf3621e41efb; });
$parcel$export(module.exports, "captureTaggedException", function () { return $5ca0c57b411d9bc5$export$2e97319d952475e; });
$parcel$export(module.exports, "captureTaggedReactException", function () { return $5ca0c57b411d9bc5$export$8d72b01fb282cc43; });
$parcel$export(module.exports, "captureException", function () { return $5ca0c57b411d9bc5$export$f5282963edea4a68; });
$parcel$export(module.exports, "captureRecaptchaException", function () { return $5ca0c57b411d9bc5$export$ddf087afa206091f; });
$parcel$export(module.exports, "captureCobrandingException", function () { return $5ca0c57b411d9bc5$export$5ec83ab111bbcd41; });
$parcel$export(module.exports, "captureMalformedError", function () { return $5ca0c57b411d9bc5$export$b6c309bc746f6dbf; });
$parcel$export(module.exports, "captureCobrandingError", function () { return $5ca0c57b411d9bc5$export$2fb60ea2fe20385b; });
$parcel$export(module.exports, "captureMessage", function () { return $5ca0c57b411d9bc5$export$45654777c133ae80; });
$parcel$export(module.exports, "captureErrorMessage", function () { return $5ca0c57b411d9bc5$export$53b98cb085651af4; });
$parcel$export(module.exports, "captureRecaptchaMessage", function () { return $5ca0c57b411d9bc5$export$8a94d1afc2068093; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $49xsF = parcelRequire("49xsF");
var $2BjBt = parcelRequire("2BjBt");
var $lKCxp = parcelRequire("lKCxp");
var $8Y2kN = parcelRequire("8Y2kN");
var $d5d01 = parcelRequire("d5d01");
var $57re5 = parcelRequire("57re5");

var $bqdjD = parcelRequire("bqdjD");

var $7eeh4 = parcelRequire("7eeh4");

var $8PxQr = parcelRequire("8PxQr");
// Only turn on debug for non production and non test runs (i.e. Jest);
const $5ca0c57b411d9bc5$var$debug = (0, $bqdjD.currentEnv) !== 'prod' && true;
// https://hello.atlassian.net/wiki/spaces/OBSERVABILITY/pages/3370131692/Sentry+FedRAMP+-+Getting+Started#Sentry-DSN-in-FedRAMP
const $5ca0c57b411d9bc5$var$fedMSentryDSN = 'https://1c864dd6ac671ce6296e7cc6710a21a0@sentry.atlassian-us-gov-mod.com/22';
const $5ca0c57b411d9bc5$var$commercialSentryDSN = 'https://1271fcf5ddad45a1846153219eb726bd@o55978.ingest.sentry.io/4504172801622016';
$57re5.init({
    dsn: (0, $bqdjD.isFedM)() ? $5ca0c57b411d9bc5$var$fedMSentryDSN : $5ca0c57b411d9bc5$var$commercialSentryDSN,
    debug: $5ca0c57b411d9bc5$var$debug,
    environment: (0, $bqdjD.currentEnv),
    release: "6860-73ae597408a9ea5278438d83f10f0f7cbd964b22",
    enabled: (0, $bqdjD.currentEnv) !== 'local',
    sampleRate: 0.1,
    beforeSend (event) {
        var _event_request;
        // Remove URL queryparams, they can contain PII
        if ((_event_request = event.request) === null || _event_request === void 0 ? void 0 : _event_request.url) {
            event.request.url = event.request.url.split('?')[0];
            delete event.request.query_string;
        }
        // Ensure we have at least some best-guess tags for which capability might be affected
        const inferredCapabilities = (0, $8PxQr.inferCapabilitiesFromPathname)(window.location.pathname);
        const capabilityTags = $5ca0c57b411d9bc5$var$capabilitiesToTags(inferredCapabilities);
        const existingTags = event.tags || {};
        event.tags = (0, $1Fos3._)({}, capabilityTags, existingTags);
        return event;
    },
    beforeBreadcrumb (breadcrumb) {
        // Don't send breadcrumbs that may contain PII
        if ([
            'navigation',
            'fetch',
            'xhr'
        ].includes(breadcrumb.category || '')) return null;
        return breadcrumb;
    },
    denyUrls: [
        /^chrome:\/\//,
        /^chrome-extension:\/\//,
        /accounts\.google\.com/,
        /recaptcha.net/
    ],
    ignoreErrors: [
        /^null/,
        /^undefined/,
        /Loading chunk.\d+.failed/,
        /^[^.]+\w+ is not defined/,
        'Load Failed',
        'NetworkError',
        'Failed to fetch',
        'SecurityError',
        'Object Not Found Matching Id',
        'Non-Error promise rejection captured with value:',
        'ResizeObserver loop limit exceeded'
    ],
    integrations: [
        // extracts all non-native attributes from the error object and attaches them to the event as extra data
        $8Y2kN.extraErrorDataIntegration()
    ]
});
function $5ca0c57b411d9bc5$export$c4b69426a5efa3b7(microbranding) {
    $d5d01.getCurrentScope().setExtra('isEmbedded', microbranding.isEmbedded);
    $d5d01.getCurrentScope().setExtra('isMobileOidc', (0, $7eeh4.isMobileOidc)(microbranding.oidcContext));
}
function $5ca0c57b411d9bc5$export$7f5abdb7f5093137(userId) {
    $d5d01.getCurrentScope().setUser({
        id: userId
    });
}
function $5ca0c57b411d9bc5$export$efda9a273d7a036d(breadcrumb) {
    if (!breadcrumb.level) breadcrumb.level = 'info';
    $49xsF.addBreadcrumb(breadcrumb);
}
function $5ca0c57b411d9bc5$export$c8aadf3621e41efb(locale) {
    if (locale) $d5d01.getCurrentScope().setTag('locale', locale);
}
function $5ca0c57b411d9bc5$export$2e97319d952475e(ex, options) {
    const { capabilities: capabilities, tags: tags = {}, extraProperties: extraProperties = {} } = options;
    $d5d01.withScope((scope)=>{
        const capabilityTags = $5ca0c57b411d9bc5$var$capabilitiesToTags(capabilities);
        scope.setTags((0, $1Fos3._)({}, tags, capabilityTags));
        scope.setExtras(extraProperties);
        $2BjBt.captureException(ex);
    });
}
function $5ca0c57b411d9bc5$export$8d72b01fb282cc43(ex, errorInfo, options) {
    const { capabilities: capabilities, tags: tags = {}, extraProperties: extraProperties = {} } = options;
    $d5d01.withScope((scope)=>{
        const capabilityTags = $5ca0c57b411d9bc5$var$capabilitiesToTags(capabilities);
        const otherTags = (0, $b2I6k._)((0, $1Fos3._)({}, tags), {
            // These errors always affect rendering. Meaning that, if left unhandled, they would
            // crash the app. We always want to include this tag to designate them as such.
            errorKind: 'rendering'
        });
        scope.setTags((0, $1Fos3._)({}, otherTags, capabilityTags));
        scope.setExtras(extraProperties);
        $lKCxp.captureReactException(ex, errorInfo);
    });
}
function $5ca0c57b411d9bc5$export$f5282963edea4a68(ex, payload = {}, tags) {
    if (payload) $d5d01.withScope((scope)=>{
        Object.entries(payload).forEach(([key, value])=>{
            scope.setExtra(key, value);
        });
        if (tags) $2BjBt.setTags(tags);
        $2BjBt.captureException(ex);
    });
    else $2BjBt.captureException(ex);
}
const $5ca0c57b411d9bc5$export$ddf087afa206091f = (ex, payload = {}, tag)=>{
    $5ca0c57b411d9bc5$export$f5282963edea4a68(ex, payload, {
        recaptcha: tag
    });
};
const $5ca0c57b411d9bc5$export$5ec83ab111bbcd41 = (ex, payload = {}, tag)=>{
    $5ca0c57b411d9bc5$export$f5282963edea4a68(ex, payload, {
        coBranding: tag
    });
};
const $5ca0c57b411d9bc5$export$b6c309bc746f6dbf = (ex, payload = {}, tag)=>{
    $5ca0c57b411d9bc5$export$f5282963edea4a68(ex, payload, {
        malformedError: tag
    });
};
const $5ca0c57b411d9bc5$export$2fb60ea2fe20385b = (msg, payload = {}, tag)=>{
    $5ca0c57b411d9bc5$export$45654777c133ae80(msg, payload, 'error', {
        coBranding: tag
    });
};
function $5ca0c57b411d9bc5$export$53b98cb085651af4(msg, payload = {}) {
    $5ca0c57b411d9bc5$export$45654777c133ae80(msg, payload, 'error');
}
const $5ca0c57b411d9bc5$export$8a94d1afc2068093 = (msg, payload = {}, tag)=>{
    $5ca0c57b411d9bc5$export$45654777c133ae80(msg, payload, 'error', {
        recaptcha: tag
    });
};
function $5ca0c57b411d9bc5$export$45654777c133ae80(msg, payload, severity, tags) {
    if (payload) $d5d01.withScope((scope)=>{
        Object.entries(payload).forEach(([key, value])=>{
            scope.setExtra(key, value);
        });
        if (tags) $2BjBt.setTags(tags);
        $2BjBt.captureMessage(msg, severity);
    });
    else $2BjBt.captureMessage(msg, severity);
}
/**
 * Sentry only allows primitives for tag values.
 *
 * Since an error may be related to more than one capability group/subgroup/name, we need the
 * option to assign multiple different capability tags.
 *
 * For example, an error during check-username could impact both password+username login as well
 * as SSO login - both cases will need to be represented with their own tag.
 *
 * i.e. we can't include an array of affected capabilities under a single tag, so we include
 * them all individually as both the key and the value, like:
 *
 * { 'capability-group:login': 'capability-group:login' };
 */ const $5ca0c57b411d9bc5$var$capabilitiesToTags = (capabilities)=>capabilities.reduce((acc, current)=>{
        return (0, $b2I6k._)((0, $1Fos3._)({}, acc), {
            [current]: current
        });
    }, {});

});
parcelRegister("49xsF", function(module, exports) {

$parcel$export(module.exports, "addBreadcrumb", function () { return $3061f568c44fbd99$export$efda9a273d7a036d; });

var $1Fos3 = parcelRequire("1Fos3");

var $d5d01 = parcelRequire("d5d01");

var $zusVr = parcelRequire("zusVr");

var $hPkId = parcelRequire("hPkId");
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $3061f568c44fbd99$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $3061f568c44fbd99$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $d5d01.getClient)();
    const isolationScope = (0, $d5d01.getIsolationScope)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $3061f568c44fbd99$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $hPkId.dateTimestampInSeconds)();
    const mergedBreadcrumb = (0, $1Fos3._)({
        timestamp: timestamp
    }, breadcrumb);
    const finalBreadcrumb = beforeBreadcrumb ? (0, $zusVr.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}

});
parcelRegister("d5d01", function(module, exports) {

$parcel$export(module.exports, "getCurrentScope", function () { return $9865d3608e6bfc97$export$c7be4b0125a10cba; });
$parcel$export(module.exports, "getIsolationScope", function () { return $9865d3608e6bfc97$export$68f3af03034c9e90; });
$parcel$export(module.exports, "getGlobalScope", function () { return $9865d3608e6bfc97$export$aa55d5ab8e05984f; });
$parcel$export(module.exports, "withScope", function () { return $9865d3608e6bfc97$export$ec58d9285c204497; });
$parcel$export(module.exports, "withIsolationScope", function () { return $9865d3608e6bfc97$export$9a4fed82c350c2bd; });
$parcel$export(module.exports, "getClient", function () { return $9865d3608e6bfc97$export$6bb76d6eba7e258c; });
$parcel$export(module.exports, "getTraceContextFromScope", function () { return $9865d3608e6bfc97$export$1e83db7ee4876dc4; });

var $iL1GP = parcelRequire("iL1GP");

var $9cBYA = parcelRequire("9cBYA");

var $448dK = parcelRequire("448dK");

var $i6XPv = parcelRequire("i6XPv");
/**
 * Get the currently active scope.
 */ function $9865d3608e6bfc97$export$c7be4b0125a10cba() {
    const carrier = (0, $9cBYA.getMainCarrier)();
    const acs = (0, $iL1GP.getAsyncContextStrategy)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $9865d3608e6bfc97$export$68f3af03034c9e90() {
    const carrier = (0, $9cBYA.getMainCarrier)();
    const acs = (0, $iL1GP.getAsyncContextStrategy)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $9865d3608e6bfc97$export$aa55d5ab8e05984f() {
    return (0, $9cBYA.getGlobalSingleton)('globalScope', ()=>new (0, $448dK.Scope)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $9865d3608e6bfc97$export$ec58d9285c204497(...rest) {
    const carrier = (0, $9cBYA.getMainCarrier)();
    const acs = (0, $iL1GP.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $9865d3608e6bfc97$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $9cBYA.getMainCarrier)();
    const acs = (0, $iL1GP.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $9865d3608e6bfc97$export$6bb76d6eba7e258c() {
    return $9865d3608e6bfc97$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $9865d3608e6bfc97$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $i6XPv.generateSpanId)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}

});
parcelRegister("iL1GP", function(module, exports) {

$parcel$export(module.exports, "getAsyncContextStrategy", function () { return $da7ded5bf7bfa115$export$f639b0c2752203be; });

var $9cBYA = parcelRequire("9cBYA");

var $1QryJ = parcelRequire("1QryJ");
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $da7ded5bf7bfa115$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $9cBYA.getMainCarrier)();
    const sentry = (0, $9cBYA.getSentryCarrier)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $da7ded5bf7bfa115$export$f639b0c2752203be(carrier) {
    const sentry = (0, $9cBYA.getSentryCarrier)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $1QryJ.getStackAsyncContextStrategy)();
}

});
parcelRegister("9cBYA", function(module, exports) {

$parcel$export(module.exports, "getMainCarrier", function () { return $6b32b1550f1fa00d$export$19eade501500c6c1; });
$parcel$export(module.exports, "getSentryCarrier", function () { return $6b32b1550f1fa00d$export$c8bfa33e4e8ae492; });
$parcel$export(module.exports, "getGlobalSingleton", function () { return $6b32b1550f1fa00d$export$7e223ec222791509; });

var $j5O51 = parcelRequire("j5O51");

var $6ZThC = parcelRequire("6ZThC");
/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $6b32b1550f1fa00d$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $6b32b1550f1fa00d$export$c8bfa33e4e8ae492((0, $6ZThC.GLOBAL_OBJ));
    return 0, $6ZThC.GLOBAL_OBJ;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $6b32b1550f1fa00d$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $j5O51.SDK_VERSION);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $j5O51.SDK_VERSION] = __SENTRY__[0, $j5O51.SDK_VERSION] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $6b32b1550f1fa00d$export$7e223ec222791509(name, creator, obj = (0, $6ZThC.GLOBAL_OBJ)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $j5O51.SDK_VERSION] = __SENTRY__[0, $j5O51.SDK_VERSION] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}

});
parcelRegister("j5O51", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", function () { return $de6554cd360e34a0$export$31499a9cd224b78c; });
// This is a magic string replaced by rollup
const $de6554cd360e34a0$export$31499a9cd224b78c = "9.39.0";

});

parcelRegister("6ZThC", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", function () { return $518352ae6cd80232$export$f1a6cdb1459e81d1; });
/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $518352ae6cd80232$export$f1a6cdb1459e81d1 = globalThis;

});


parcelRegister("1QryJ", function(module, exports) {

$parcel$export(module.exports, "getStackAsyncContextStrategy", function () { return $15800678ceb5e09a$export$329d4d4d54e42710; });

var $adkiu = parcelRequire("adkiu");

var $448dK = parcelRequire("448dK");

var $brfue = parcelRequire("brfue");

var $9cBYA = parcelRequire("9cBYA");
/**
 * This is an object that holds a stack of scopes.
 */ class $15800678ceb5e09a$export$d36ec451f120cfba {
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $brfue.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $448dK.Scope)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $448dK.Scope)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $15800678ceb5e09a$var$getAsyncContextStack() {
    const registry = (0, $9cBYA.getMainCarrier)();
    const sentry = (0, $9cBYA.getSentryCarrier)(registry);
    return sentry.stack = sentry.stack || new $15800678ceb5e09a$export$d36ec451f120cfba((0, $adkiu.getDefaultCurrentScope)(), (0, $adkiu.getDefaultIsolationScope)());
}
function $15800678ceb5e09a$var$withScope(callback) {
    return $15800678ceb5e09a$var$getAsyncContextStack().withScope(callback);
}
function $15800678ceb5e09a$var$withSetScope(scope, callback) {
    const stack = $15800678ceb5e09a$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $15800678ceb5e09a$var$withIsolationScope(callback) {
    return $15800678ceb5e09a$var$getAsyncContextStack().withScope(()=>{
        return callback($15800678ceb5e09a$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $15800678ceb5e09a$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $15800678ceb5e09a$var$withIsolationScope,
        withScope: $15800678ceb5e09a$var$withScope,
        withSetScope: $15800678ceb5e09a$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $15800678ceb5e09a$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$15800678ceb5e09a$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$15800678ceb5e09a$var$getAsyncContextStack().getIsolationScope()
    };
}

});
parcelRegister("adkiu", function(module, exports) {

$parcel$export(module.exports, "getDefaultCurrentScope", function () { return $76fadcdf61cd7cfa$export$6f1b9191db9c4d5; });
$parcel$export(module.exports, "getDefaultIsolationScope", function () { return $76fadcdf61cd7cfa$export$de9862929b76bf57; });

var $9cBYA = parcelRequire("9cBYA");

var $448dK = parcelRequire("448dK");
/** Get the default current scope. */ function $76fadcdf61cd7cfa$export$6f1b9191db9c4d5() {
    return (0, $9cBYA.getGlobalSingleton)('defaultCurrentScope', ()=>new (0, $448dK.Scope)());
}
/** Get the default isolation scope. */ function $76fadcdf61cd7cfa$export$de9862929b76bf57() {
    return (0, $9cBYA.getGlobalSingleton)('defaultIsolationScope', ()=>new (0, $448dK.Scope)());
}

});
parcelRegister("448dK", function(module, exports) {

$parcel$export(module.exports, "Scope", function () { return $2f5de9a1801ed244$export$775b6bb06e53a214; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $euQAQ = parcelRequire("euQAQ");

var $81R8A = parcelRequire("81R8A");

var $brfue = parcelRequire("brfue");

var $zusVr = parcelRequire("zusVr");

var $lrI6i = parcelRequire("lrI6i");

var $38AjJ = parcelRequire("38AjJ");

var $i6XPv = parcelRequire("i6XPv");

var $l4Dzd = parcelRequire("l4Dzd");

var $38VNK = parcelRequire("38VNK");

var $hPkId = parcelRequire("hPkId");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $2f5de9a1801ed244$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ class $2f5de9a1801ed244$export$775b6bb06e53a214 {
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $2f5de9a1801ed244$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = (0, $1Fos3._)({}, this._tags);
        newScope._extra = (0, $1Fos3._)({}, this._extra);
        newScope._contexts = (0, $1Fos3._)({}, this._contexts);
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = (0, $1Fos3._)({}, this._sdkProcessingMetadata);
        newScope._propagationContext = (0, $1Fos3._)({}, this._propagationContext);
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $l4Dzd._setSpanForScope)(newScope, (0, $l4Dzd._getSpanForScope)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $81R8A.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = (0, $1Fos3._)({}, this._tags, tags);
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        this._tags = (0, $b2I6k._)((0, $1Fos3._)({}, this._tags), {
            [key]: value
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = (0, $1Fos3._)({}, this._extra, extras);
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = (0, $b2I6k._)((0, $1Fos3._)({}, this._extra), {
            [key]: extra
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $2f5de9a1801ed244$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $brfue.isPlainObject)(scopeToMerge) ? captureContext : undefined;
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = (0, $1Fos3._)({}, this._tags, tags);
        this._extra = (0, $1Fos3._)({}, this._extra, extra);
        this._contexts = (0, $1Fos3._)({}, this._contexts, contexts);
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._session = undefined;
        (0, $l4Dzd._setSpanForScope)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $i6XPv.generateTraceId)(),
            sampleRand: Math.random()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $2f5de9a1801ed244$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = (0, $b2I6k._)((0, $1Fos3._)({
            timestamp: (0, $hPkId.dateTimestampInSeconds)()
        }, breadcrumb), {
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $38VNK.truncate)(breadcrumb.message, 2048) : breadcrumb.message
        });
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            var _this__client;
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            (_this__client = this._client) === null || _this__client === void 0 ? void 0 : _this__client.recordDroppedEvent('buffer_overflow', 'log_item');
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $l4Dzd._getSpanForScope)(this)
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $lrI6i.merge)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = (hint === null || hint === void 0 ? void 0 : hint.event_id) || (0, $38AjJ.uuid4)();
        if (!this._client) {
            (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, (0, $b2I6k._)((0, $1Fos3._)({
            originalException: exception,
            syntheticException: syntheticException
        }, hint), {
            event_id: eventId
        }), this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = (hint === null || hint === void 0 ? void 0 : hint.event_id) || (0, $38AjJ.uuid4)();
        if (!this._client) {
            (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, (0, $b2I6k._)((0, $1Fos3._)({
            originalException: message,
            syntheticException: syntheticException
        }, hint), {
            event_id: eventId
        }), this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = (hint === null || hint === void 0 ? void 0 : hint.event_id) || (0, $38AjJ.uuid4)();
        if (!this._client) {
            (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, (0, $b2I6k._)((0, $1Fos3._)({}, hint), {
            event_id: eventId
        }), this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $i6XPv.generateTraceId)(),
            sampleRand: Math.random()
        };
    }
}

});
parcelRegister("euQAQ", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $a8dca9f578d5ec49$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $a8dca9f578d5ec49$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("81R8A", function(module, exports) {

$parcel$export(module.exports, "makeSession", function () { return $5d87a2bba76781ed$export$14a186326edbb264; });
$parcel$export(module.exports, "updateSession", function () { return $5d87a2bba76781ed$export$531818e825e774db; });
$parcel$export(module.exports, "closeSession", function () { return $5d87a2bba76781ed$export$56521d9ba90f62ee; });

var $38AjJ = parcelRequire("38AjJ");

var $hPkId = parcelRequire("hPkId");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $5d87a2bba76781ed$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $hPkId.timestampInSeconds)();
    const session = {
        sid: (0, $38AjJ.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$5d87a2bba76781ed$var$sessionToJSON(session)
    };
    if (context) $5d87a2bba76781ed$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $5d87a2bba76781ed$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $hPkId.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $38AjJ.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $5d87a2bba76781ed$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $5d87a2bba76781ed$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $5d87a2bba76781ed$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}

});
parcelRegister("38AjJ", function(module, exports) {

$parcel$export(module.exports, "uuid4", function () { return $248e4a4d61038515$export$19f53698e68b2496; });
$parcel$export(module.exports, "getEventDescription", function () { return $248e4a4d61038515$export$4157119e2b157127; });
$parcel$export(module.exports, "addExceptionTypeValue", function () { return $248e4a4d61038515$export$f26508487bf83ee7; });
$parcel$export(module.exports, "addExceptionMechanism", function () { return $248e4a4d61038515$export$c69a9a0313b03bb1; });
$parcel$export(module.exports, "checkOrSetAlreadyCaught", function () { return $248e4a4d61038515$export$6de4ffac6a2f1098; });

var $1Fos3 = parcelRequire("1Fos3");

var $aVCF4 = parcelRequire("aVCF4");

var $38VNK = parcelRequire("38VNK");

var $6ZThC = parcelRequire("6ZThC");
function $248e4a4d61038515$var$getCrypto() {
    const gbl = (0, $6ZThC.GLOBAL_OBJ);
    return gbl.crypto || gbl.msCrypto;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function $248e4a4d61038515$export$19f53698e68b2496(crypto = $248e4a4d61038515$var$getCrypto()) {
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto === null || crypto === void 0 ? void 0 : crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto === null || crypto === void 0 ? void 0 : crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $248e4a4d61038515$var$getFirstException(event) {
    var _event_exception_values, _event_exception;
    return (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $248e4a4d61038515$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $248e4a4d61038515$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $248e4a4d61038515$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $248e4a4d61038515$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $248e4a4d61038515$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $1Fos3._)({}, defaultMechanism, currentMechanism, newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = (0, $1Fos3._)({}, currentMechanism === null || currentMechanism === void 0 ? void 0 : currentMechanism.data, newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $248e4a4d61038515$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $248e4a4d61038515$var$_parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $248e4a4d61038515$export$d364f2020ab30578(input) {
    const match = input.match($248e4a4d61038515$var$SEMVER_REGEXP) || [];
    const major = $248e4a4d61038515$var$_parseInt(match[1]);
    const minor = $248e4a4d61038515$var$_parseInt(match[2]);
    const patch = $248e4a4d61038515$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $248e4a4d61038515$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $38VNK.snipLine)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $38VNK.snipLine)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $38VNK.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $248e4a4d61038515$export$6de4ffac6a2f1098(exception) {
    if ($248e4a4d61038515$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $aVCF4.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $248e4a4d61038515$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch (e) {} // eslint-disable-line no-empty
}

});
parcelRegister("aVCF4", function(module, exports) {

$parcel$export(module.exports, "fill", function () { return $7f4d3797e59bdbc4$export$9563e054e6f787fb; });
$parcel$export(module.exports, "markFunctionWrapped", function () { return $7f4d3797e59bdbc4$export$5c1499e2e5d010ae; });
$parcel$export(module.exports, "addNonEnumerableProperty", function () { return $7f4d3797e59bdbc4$export$e73679ffaf56810e; });
$parcel$export(module.exports, "getOriginalFunction", function () { return $7f4d3797e59bdbc4$export$e6cc1e135e2092e5; });
$parcel$export(module.exports, "convertToPlainObject", function () { return $7f4d3797e59bdbc4$export$62ff257738bf57f5; });
$parcel$export(module.exports, "extractExceptionKeysForMessage", function () { return $7f4d3797e59bdbc4$export$b0244d5063c0b61b; });

var $1Fos3 = parcelRequire("1Fos3");

var $euQAQ = parcelRequire("euQAQ");

var $eqzQm = parcelRequire("eqzQm");

var $brfue = parcelRequire("brfue");

var $zusVr = parcelRequire("zusVr");

var $38VNK = parcelRequire("38VNK");
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $7f4d3797e59bdbc4$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    const original = source[name];
    if (typeof original !== 'function') return;
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $7f4d3797e59bdbc4$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch (e) {
        (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $7f4d3797e59bdbc4$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $7f4d3797e59bdbc4$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $7f4d3797e59bdbc4$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $7f4d3797e59bdbc4$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $7f4d3797e59bdbc4$export$62ff257738bf57f5(value) {
    if ((0, $brfue.isError)(value)) return (0, $1Fos3._)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $7f4d3797e59bdbc4$var$getOwnProperties(value));
    else if ((0, $brfue.isEvent)(value)) {
        const newObj = (0, $1Fos3._)({
            type: value.type,
            target: $7f4d3797e59bdbc4$var$serializeEventTarget(value.target),
            currentTarget: $7f4d3797e59bdbc4$var$serializeEventTarget(value.currentTarget)
        }, $7f4d3797e59bdbc4$var$getOwnProperties(value));
        if (typeof CustomEvent !== 'undefined' && (0, $brfue.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $7f4d3797e59bdbc4$var$serializeEventTarget(target) {
    try {
        return (0, $brfue.isElement)(target) ? (0, $eqzQm.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $7f4d3797e59bdbc4$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $7f4d3797e59bdbc4$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($7f4d3797e59bdbc4$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return '[object has no keys]';
    if (firstKey.length >= maxLength) return (0, $38VNK.truncate)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $38VNK.truncate)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function $7f4d3797e59bdbc4$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $7f4d3797e59bdbc4$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $7f4d3797e59bdbc4$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || typeof inputValue !== 'object') return inputValue;
    // Check memo map first for all object types
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($7f4d3797e59bdbc4$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($7f4d3797e59bdbc4$var$isPojo(inputValue)) {
        const returnValue = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== undefined) returnValue[key] = $7f4d3797e59bdbc4$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    // For other object types, return as is
    return inputValue;
}
function $7f4d3797e59bdbc4$var$isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    const constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $7f4d3797e59bdbc4$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $brfue.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("eqzQm", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", function () { return $a80f4c2792c1392a$export$5647df6b7814ac86; });
$parcel$export(module.exports, "getLocationHref", function () { return $a80f4c2792c1392a$export$1cfafeee2987818b; });
$parcel$export(module.exports, "getComponentName", function () { return $a80f4c2792c1392a$export$26727cfcc4d7e0fc; });

var $brfue = parcelRequire("brfue");

var $6ZThC = parcelRequire("6ZThC");
const $a80f4c2792c1392a$var$WINDOW = (0, $6ZThC.GLOBAL_OBJ);
const $a80f4c2792c1392a$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $a80f4c2792c1392a$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $a80f4c2792c1392a$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $a80f4c2792c1392a$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $a80f4c2792c1392a$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!(elem === null || elem === void 0 ? void 0 : elem.tagName)) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($a80f4c2792c1392a$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = (keyAttrs === null || keyAttrs === void 0 ? void 0 : keyAttrs.length) ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs === null || keyAttrPairs === void 0 ? void 0 : keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $brfue.isString)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $a80f4c2792c1392a$export$1cfafeee2987818b() {
    try {
        return $a80f4c2792c1392a$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $a80f4c2792c1392a$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$a80f4c2792c1392a$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}

});
parcelRegister("brfue", function(module, exports) {

$parcel$export(module.exports, "isError", function () { return $853e3aa771478995$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isInstanceOf", function () { return $853e3aa771478995$export$49034edbe6b62415; });
$parcel$export(module.exports, "isErrorEvent", function () { return $853e3aa771478995$export$9f9636d330b71954; });
$parcel$export(module.exports, "isDOMError", function () { return $853e3aa771478995$export$ef9e2056653f0c8e; });
$parcel$export(module.exports, "isDOMException", function () { return $853e3aa771478995$export$12e869b2a583f783; });
$parcel$export(module.exports, "isString", function () { return $853e3aa771478995$export$844ec244b1367d54; });
$parcel$export(module.exports, "isParameterizedString", function () { return $853e3aa771478995$export$dbcbffa59149b824; });
$parcel$export(module.exports, "isPrimitive", function () { return $853e3aa771478995$export$c3825b437cbdea5c; });
$parcel$export(module.exports, "isPlainObject", function () { return $853e3aa771478995$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isEvent", function () { return $853e3aa771478995$export$9671ea99bd126ace; });
$parcel$export(module.exports, "isElement", function () { return $853e3aa771478995$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isRegExp", function () { return $853e3aa771478995$export$49841c62b9eff15; });
$parcel$export(module.exports, "isThenable", function () { return $853e3aa771478995$export$f5b060c2914b97c8; });
$parcel$export(module.exports, "isSyntheticEvent", function () { return $853e3aa771478995$export$bc2894c7158efbac; });
$parcel$export(module.exports, "isVueViewModel", function () { return $853e3aa771478995$export$7916fad0ebc23f48; });
$parcel$export(module.exports, "isRequest", function () { return $853e3aa771478995$export$6d3d1f317d7cda57; });
// eslint-disable-next-line @typescript-eslint/unbound-method
const $853e3aa771478995$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $853e3aa771478995$export$e6127cc7fe7395c3(wat) {
    switch($853e3aa771478995$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return $853e3aa771478995$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $853e3aa771478995$var$isBuiltin(wat, className) {
    return $853e3aa771478995$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $853e3aa771478995$export$9f9636d330b71954(wat) {
    return $853e3aa771478995$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $853e3aa771478995$export$ef9e2056653f0c8e(wat) {
    return $853e3aa771478995$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $853e3aa771478995$export$12e869b2a583f783(wat) {
    return $853e3aa771478995$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $853e3aa771478995$export$844ec244b1367d54(wat) {
    return $853e3aa771478995$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $853e3aa771478995$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $853e3aa771478995$export$c3825b437cbdea5c(wat) {
    return wat === null || $853e3aa771478995$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $853e3aa771478995$export$53b83ca8eaab0383(wat) {
    return $853e3aa771478995$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $853e3aa771478995$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $853e3aa771478995$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $853e3aa771478995$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $853e3aa771478995$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $853e3aa771478995$export$49841c62b9eff15(wat) {
    return $853e3aa771478995$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $853e3aa771478995$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean((wat === null || wat === void 0 ? void 0 : wat.then) && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $853e3aa771478995$export$bc2894c7158efbac(wat) {
    return $853e3aa771478995$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $853e3aa771478995$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $853e3aa771478995$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function $853e3aa771478995$export$6d3d1f317d7cda57(request) {
    return typeof Request !== 'undefined' && $853e3aa771478995$export$49034edbe6b62415(request, Request);
}

});


parcelRegister("zusVr", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", function () { return $06aae6d229f9baf1$export$2a2b1d2252a69ecb; });
$parcel$export(module.exports, "originalConsoleMethods", function () { return $06aae6d229f9baf1$export$77c4ce905194557b; });
$parcel$export(module.exports, "consoleSandbox", function () { return $06aae6d229f9baf1$export$cda52e2a8927a2ca; });
$parcel$export(module.exports, "logger", function () { return $06aae6d229f9baf1$export$af88d00dbe7f521; });
$parcel$export(module.exports, "debug", function () { return $06aae6d229f9baf1$export$1c9f709888824e05; });

var $9cBYA = parcelRequire("9cBYA");

var $euQAQ = parcelRequire("euQAQ");

var $6ZThC = parcelRequire("6ZThC");
/** A Sentry Logger instance. */ const $06aae6d229f9baf1$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** Prefix for logging strings */ const $06aae6d229f9baf1$var$PREFIX = 'Sentry Logger ';
/** This may be mutated by the console instrumentation. */ const $06aae6d229f9baf1$export$77c4ce905194557b = {};
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $06aae6d229f9baf1$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $6ZThC.GLOBAL_OBJ))) return callback();
    const console = (0, $6ZThC.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($06aae6d229f9baf1$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $06aae6d229f9baf1$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $06aae6d229f9baf1$var$enable() {
    $06aae6d229f9baf1$var$_getLoggerSettings().enabled = true;
}
function $06aae6d229f9baf1$var$disable() {
    $06aae6d229f9baf1$var$_getLoggerSettings().enabled = false;
}
function $06aae6d229f9baf1$var$isEnabled() {
    return $06aae6d229f9baf1$var$_getLoggerSettings().enabled;
}
function $06aae6d229f9baf1$var$log(...args) {
    $06aae6d229f9baf1$var$_maybeLog('log', ...args);
}
function $06aae6d229f9baf1$var$info(...args) {
    $06aae6d229f9baf1$var$_maybeLog('info', ...args);
}
function $06aae6d229f9baf1$var$warn(...args) {
    $06aae6d229f9baf1$var$_maybeLog('warn', ...args);
}
function $06aae6d229f9baf1$var$error(...args) {
    $06aae6d229f9baf1$var$_maybeLog('error', ...args);
}
function $06aae6d229f9baf1$var$_debug(...args) {
    $06aae6d229f9baf1$var$_maybeLog('debug', ...args);
}
function $06aae6d229f9baf1$var$assert(...args) {
    $06aae6d229f9baf1$var$_maybeLog('assert', ...args);
}
function $06aae6d229f9baf1$var$trace(...args) {
    $06aae6d229f9baf1$var$_maybeLog('trace', ...args);
}
function $06aae6d229f9baf1$var$_maybeLog(level, ...args) {
    if (!(0, $euQAQ.DEBUG_BUILD)) return;
    if ($06aae6d229f9baf1$var$isEnabled()) $06aae6d229f9baf1$export$cda52e2a8927a2ca(()=>{
        (0, $6ZThC.GLOBAL_OBJ).console[level](`${$06aae6d229f9baf1$var$PREFIX}[${level}]:`, ...args);
    });
}
function $06aae6d229f9baf1$var$_getLoggerSettings() {
    if (!(0, $euQAQ.DEBUG_BUILD)) return {
        enabled: false
    };
    return (0, $9cBYA.getGlobalSingleton)('loggerSettings', ()=>({
            enabled: false
        }));
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */ const $06aae6d229f9baf1$export$af88d00dbe7f521 = {
    enable: /** Enable logging. */ $06aae6d229f9baf1$var$enable,
    disable: /** Disable logging. */ $06aae6d229f9baf1$var$disable,
    isEnabled: /** Check if logging is enabled. */ $06aae6d229f9baf1$var$isEnabled,
    log: /** Log a message. */ $06aae6d229f9baf1$var$log,
    info: /** Log level info */ $06aae6d229f9baf1$var$info,
    warn: /** Log a warning. */ $06aae6d229f9baf1$var$warn,
    error: /** Log an error. */ $06aae6d229f9baf1$var$error,
    /** Log a debug message. */ debug: $06aae6d229f9baf1$var$_debug,
    assert: /** Log an assertion. */ $06aae6d229f9baf1$var$assert,
    trace: /** Log a trace. */ $06aae6d229f9baf1$var$trace
};
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 */ const $06aae6d229f9baf1$export$1c9f709888824e05 = {
    enable: /** Enable logging. */ $06aae6d229f9baf1$var$enable,
    disable: /** Disable logging. */ $06aae6d229f9baf1$var$disable,
    isEnabled: /** Check if logging is enabled. */ $06aae6d229f9baf1$var$isEnabled,
    log: /** Log a message. */ $06aae6d229f9baf1$var$log,
    warn: /** Log a warning. */ $06aae6d229f9baf1$var$warn,
    error: /** Log an error. */ $06aae6d229f9baf1$var$error
};

});

parcelRegister("38VNK", function(module, exports) {

$parcel$export(module.exports, "truncate", function () { return $249ef49d88d37e47$export$6a506b36fdea397d; });
$parcel$export(module.exports, "snipLine", function () { return $249ef49d88d37e47$export$4215662d762d6f9d; });
$parcel$export(module.exports, "safeJoin", function () { return $249ef49d88d37e47$export$465e9d514283d4fd; });
$parcel$export(module.exports, "stringMatchesSomePattern", function () { return $249ef49d88d37e47$export$a7a5ec66062ea5d; });

var $brfue = parcelRequire("brfue");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $249ef49d88d37e47$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $249ef49d88d37e47$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $249ef49d88d37e47$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $brfue.isVueViewModel)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $249ef49d88d37e47$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $brfue.isString)(value)) return false;
    if ((0, $brfue.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $brfue.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $249ef49d88d37e47$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$249ef49d88d37e47$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});



parcelRegister("hPkId", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", function () { return $cfa74417ee467e16$export$7740643b9eeaf0c4; });
$parcel$export(module.exports, "timestampInSeconds", function () { return $cfa74417ee467e16$export$ee52dced521e3e18; });

var $6ZThC = parcelRequire("6ZThC");
const $cfa74417ee467e16$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function $cfa74417ee467e16$export$7740643b9eeaf0c4() {
    return Date.now() / $cfa74417ee467e16$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $cfa74417ee467e16$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $6ZThC.GLOBAL_OBJ);
    // Some browser and environments don't have a performance or timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    if (!(performance === null || performance === void 0 ? void 0 : performance.now) || !performance.timeOrigin) return $cfa74417ee467e16$export$7740643b9eeaf0c4;
    const timeOrigin = performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $cfa74417ee467e16$var$ONE_SECOND_IN_MS;
    };
}
let $cfa74417ee467e16$var$_cachedTimestampInSeconds;
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ function $cfa74417ee467e16$export$ee52dced521e3e18() {
    // We store this in a closure so that we don't have to create a new function every time this is called.
    const func = $cfa74417ee467e16$var$_cachedTimestampInSeconds !== null && $cfa74417ee467e16$var$_cachedTimestampInSeconds !== void 0 ? $cfa74417ee467e16$var$_cachedTimestampInSeconds : $cfa74417ee467e16$var$_cachedTimestampInSeconds = $cfa74417ee467e16$var$createUnixTimestampInSecondsFunc();
    return func();
}
/**
 * Cached result of getBrowserTimeOrigin.
 */ let $cfa74417ee467e16$var$cachedTimeOrigin;
/**
 * Gets the time origin and the mode used to determine it.
 */ function $cfa74417ee467e16$var$getBrowserTimeOrigin() {
    var _performance_timing;
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $6ZThC.GLOBAL_OBJ);
    if (!(performance === null || performance === void 0 ? void 0 : performance.now)) return [
        undefined,
        'none'
    ];
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = (_performance_timing = performance.timing) === null || _performance_timing === void 0 ? void 0 : _performance_timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) return [
            performance.timeOrigin,
            'timeOrigin'
        ];
        else return [
            navigationStart,
            'navigationStart'
        ];
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    return [
        dateNow,
        'dateNow'
    ];
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function $cfa74417ee467e16$export$baf075a948ffc0bf() {
    if (!$cfa74417ee467e16$var$cachedTimeOrigin) $cfa74417ee467e16$var$cachedTimeOrigin = $cfa74417ee467e16$var$getBrowserTimeOrigin();
    return $cfa74417ee467e16$var$cachedTimeOrigin[0];
}

});


parcelRegister("lrI6i", function(module, exports) {

$parcel$export(module.exports, "merge", function () { return $f9ce5405b7443350$export$4950aa0f605343fb; });
/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ 
var $1Fos3 = parcelRequire("1Fos3");
function $f9ce5405b7443350$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== 'object' || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = (0, $1Fos3._)({}, initialObj);
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $f9ce5405b7443350$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}

});

parcelRegister("i6XPv", function(module, exports) {

$parcel$export(module.exports, "generateTraceId", function () { return $d2f7327c3a45b7ec$export$dc6d7ea554bcce10; });
$parcel$export(module.exports, "generateSpanId", function () { return $d2f7327c3a45b7ec$export$295213bc4d0c54ad; });

var $38AjJ = parcelRequire("38AjJ");
/**
 * Generate a random, valid trace ID.
 */ function $d2f7327c3a45b7ec$export$dc6d7ea554bcce10() {
    return (0, $38AjJ.uuid4)();
}
/**
 * Generate a random, valid span ID.
 */ function $d2f7327c3a45b7ec$export$295213bc4d0c54ad() {
    return (0, $38AjJ.uuid4)().substring(16);
}

});

parcelRegister("l4Dzd", function(module, exports) {

$parcel$export(module.exports, "_setSpanForScope", function () { return $f578a9e10f15c8a4$export$3f25fa50c18e20ca; });
$parcel$export(module.exports, "_getSpanForScope", function () { return $f578a9e10f15c8a4$export$91f063ebb8eff307; });

var $aVCF4 = parcelRequire("aVCF4");
const $f578a9e10f15c8a4$var$SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $f578a9e10f15c8a4$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $aVCF4.addNonEnumerableProperty)(scope, $f578a9e10f15c8a4$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$f578a9e10f15c8a4$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $f578a9e10f15c8a4$export$91f063ebb8eff307(scope) {
    return scope[$f578a9e10f15c8a4$var$SCOPE_SPAN_FIELD];
}

});







parcelRegister("2BjBt", function(module, exports) {

$parcel$export(module.exports, "captureException", function () { return $1e4e3e4de965851e$export$f5282963edea4a68; });
$parcel$export(module.exports, "captureMessage", function () { return $1e4e3e4de965851e$export$45654777c133ae80; });
$parcel$export(module.exports, "captureEvent", function () { return $1e4e3e4de965851e$export$1462b974fdcf6ba2; });
$parcel$export(module.exports, "setContext", function () { return $1e4e3e4de965851e$export$2f04de43fe27971a; });
$parcel$export(module.exports, "setTags", function () { return $1e4e3e4de965851e$export$74a8fb34822092e6; });
$parcel$export(module.exports, "startSession", function () { return $1e4e3e4de965851e$export$c0d84948cecf78d8; });
$parcel$export(module.exports, "captureSession", function () { return $1e4e3e4de965851e$export$667e7b4d445d566b; });

var $1Fos3 = parcelRequire("1Fos3");

var $d5d01 = parcelRequire("d5d01");

var $euQAQ = parcelRequire("euQAQ");

var $81R8A = parcelRequire("81R8A");

var $brfue = parcelRequire("brfue");

var $zusVr = parcelRequire("zusVr");

var $38AjJ = parcelRequire("38AjJ");

var $9NNss = parcelRequire("9NNss");

var $hPkId = parcelRequire("hPkId");

var $6ZThC = parcelRequire("6ZThC");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $1e4e3e4de965851e$export$f5282963edea4a68(exception, hint) {
    return (0, $d5d01.getCurrentScope)().captureException(exception, (0, $9NNss.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $1e4e3e4de965851e$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return (0, $d5d01.getCurrentScope)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $1e4e3e4de965851e$export$1462b974fdcf6ba2(event, hint) {
    return (0, $d5d01.getCurrentScope)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $1e4e3e4de965851e$export$2f04de43fe27971a(name, context) {
    (0, $d5d01.getIsolationScope)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $1e4e3e4de965851e$export$bb4922da0dd51b92(extras) {
    (0, $d5d01.getIsolationScope)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $1e4e3e4de965851e$export$8e8e7789d42ed61d(key, extra) {
    (0, $d5d01.getIsolationScope)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $1e4e3e4de965851e$export$74a8fb34822092e6(tags) {
    (0, $d5d01.getIsolationScope)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $1e4e3e4de965851e$export$a37d07ee78eb4569(key, value) {
    (0, $d5d01.getIsolationScope)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $1e4e3e4de965851e$export$8b6bb3dd62a01be2(user) {
    (0, $d5d01.getIsolationScope)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $1e4e3e4de965851e$export$5d4e9fd7fac8e617() {
    return (0, $d5d01.getIsolationScope)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $1e4e3e4de965851e$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $d5d01.getCurrentScope)();
    const client = (0, $d5d01.getClient)();
    if (!client) (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $38AjJ.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param callback Callback to be monitored
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $1e4e3e4de965851e$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $1e4e3e4de965851e$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $hPkId.timestampInSeconds)();
    function finishCheckIn(status) {
        $1e4e3e4de965851e$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $hPkId.timestampInSeconds)() - now
        });
    }
    return (0, $d5d01.withIsolationScope)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn('error');
            throw e;
        }
        if ((0, $brfue.isThenable)(maybePromiseResult)) return maybePromiseResult.then((r)=>{
            finishCheckIn('ok');
            return r;
        }, (e)=>{
            finishCheckIn('error');
            throw e;
        });
        finishCheckIn('ok');
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $1e4e3e4de965851e$export$4909b86c8034bf73(timeout) {
    const client = (0, $d5d01.getClient)();
    if (client) return client.flush(timeout);
    (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $1e4e3e4de965851e$export$8360e631d277ea4d(timeout) {
    const client = (0, $d5d01.getClient)();
    if (client) return client.close(timeout);
    (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $1e4e3e4de965851e$export$3f95c6f800b78024() {
    return !!(0, $d5d01.getClient)();
}
/** If the SDK is initialized & enabled. */ function $1e4e3e4de965851e$export$3b029eb57ac4d562() {
    const client = (0, $d5d01.getClient)();
    return (client === null || client === void 0 ? void 0 : client.getOptions().enabled) !== false && !!(client === null || client === void 0 ? void 0 : client.getTransport());
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $1e4e3e4de965851e$export$9aac0b9f77928fbf(callback) {
    (0, $d5d01.getIsolationScope)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $1e4e3e4de965851e$export$c0d84948cecf78d8(context) {
    const isolationScope = (0, $d5d01.getIsolationScope)();
    const currentScope = (0, $d5d01.getCurrentScope)();
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $6ZThC.GLOBAL_OBJ).navigator || {};
    const session = (0, $81R8A.makeSession)((0, $1Fos3._)({
        user: currentScope.getUser() || isolationScope.getUser()
    }, userAgent && {
        userAgent: userAgent
    }, context));
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if ((currentSession === null || currentSession === void 0 ? void 0 : currentSession.status) === 'ok') (0, $81R8A.updateSession)(currentSession, {
        status: 'exited'
    });
    $1e4e3e4de965851e$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $1e4e3e4de965851e$export$17a5be43989a0bc1() {
    const isolationScope = (0, $d5d01.getIsolationScope)();
    const currentScope = (0, $d5d01.getCurrentScope)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $81R8A.closeSession)(session);
    $1e4e3e4de965851e$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $1e4e3e4de965851e$var$_sendSessionUpdate() {
    const isolationScope = (0, $d5d01.getIsolationScope)();
    const client = (0, $d5d01.getClient)();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $1e4e3e4de965851e$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $1e4e3e4de965851e$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $1e4e3e4de965851e$var$_sendSessionUpdate();
}

});
parcelRegister("9NNss", function(module, exports) {

$parcel$export(module.exports, "prepareEvent", function () { return $722f0e000a507321$export$2d67fb380bd11267; });
$parcel$export(module.exports, "parseEventHintOrCaptureContext", function () { return $722f0e000a507321$export$76b5f966996d1653; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $5gR0A = parcelRequire("5gR0A");

var $d5d01 = parcelRequire("d5d01");

var $726a8 = parcelRequire("726a8");

var $448dK = parcelRequire("448dK");

var $3mkPr = parcelRequire("3mkPr");

var $aLhPi = parcelRequire("aLhPi");

var $38AjJ = parcelRequire("38AjJ");

var $kmom1 = parcelRequire("kmom1");

var $38VNK = parcelRequire("38VNK");

var $hPkId = parcelRequire("hPkId");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $722f0e000a507321$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = (0, $b2I6k._)((0, $1Fos3._)({}, event), {
        event_id: event.event_id || hint.event_id || (0, $38AjJ.uuid4)(),
        timestamp: event.timestamp || (0, $hPkId.dateTimestampInSeconds)()
    });
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $722f0e000a507321$export$d7e04067a6fbc882(prepared, options);
    $722f0e000a507321$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit('applyFrameMetadata', event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $722f0e000a507321$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $722f0e000a507321$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $38AjJ.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $d5d01.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $3mkPr.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $3mkPr.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $3mkPr.applyScopeDataToEvent)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $726a8.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $722f0e000a507321$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $722f0e000a507321$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $722f0e000a507321$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, $5gR0A.DEFAULT_ENVIRONMENT);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request === null || request === void 0 ? void 0 : request.url) request.url = (0, $38VNK.truncate)(request.url, maxValueLength);
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $722f0e000a507321$export$63042efc86f043e7(event, stackParser) {
    var _event_exception_values, _event_exception;
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, $aLhPi.getFilenameToDebugIdMap)(stackParser);
    (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.forEach((exception)=>{
        var _exception_stacktrace_frames, _exception_stacktrace;
        (_exception_stacktrace = exception.stacktrace) === null || _exception_stacktrace === void 0 ? void 0 : (_exception_stacktrace_frames = _exception_stacktrace.frames) === null || _exception_stacktrace_frames === void 0 ? void 0 : _exception_stacktrace_frames.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $722f0e000a507321$export$1be657ba8ef44ff0(event) {
    var _event_exception_values, _event_exception;
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.forEach((exception)=>{
        var _exception_stacktrace_frames, _exception_stacktrace;
        (_exception_stacktrace = exception.stacktrace) === null || _exception_stacktrace === void 0 ? void 0 : (_exception_stacktrace_frames = _exception_stacktrace.frames) === null || _exception_stacktrace_frames === void 0 ? void 0 : _exception_stacktrace_frames.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $722f0e000a507321$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $722f0e000a507321$var$normalizeEvent(event, depth, maxBreadth) {
    var _event_contexts, _event_contexts1;
    if (!event) return null;
    const normalized = (0, $1Fos3._)({}, event, event.breadcrumbs && {
        breadcrumbs: event.breadcrumbs.map((b)=>(0, $1Fos3._)({}, b, b.data && {
                data: (0, $kmom1.normalize)(b.data, depth, maxBreadth)
            }))
    }, event.user && {
        user: (0, $kmom1.normalize)(event.user, depth, maxBreadth)
    }, event.contexts && {
        contexts: (0, $kmom1.normalize)(event.contexts, depth, maxBreadth)
    }, event.extra && {
        extra: (0, $kmom1.normalize)(event.extra, depth, maxBreadth)
    });
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (((_event_contexts = event.contexts) === null || _event_contexts === void 0 ? void 0 : _event_contexts.trace) && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $kmom1.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return (0, $1Fos3._)({}, span, span.data && {
            data: (0, $kmom1.normalize)(span.data, depth, maxBreadth)
        });
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (((_event_contexts1 = event.contexts) === null || _event_contexts1 === void 0 ? void 0 : _event_contexts1.flags) && normalized.contexts) normalized.contexts.flags = (0, $kmom1.normalize)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $722f0e000a507321$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $448dK.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $722f0e000a507321$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($722f0e000a507321$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($722f0e000a507321$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $722f0e000a507321$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $448dK.Scope) || typeof hint === 'function';
}
const $722f0e000a507321$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'propagationContext'
];
function $722f0e000a507321$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$722f0e000a507321$var$captureContextKeys.includes(key));
}

});
parcelRegister("5gR0A", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", function () { return $3d6790bbcb54e0cf$export$849dbeeeda01ae98; });
const $3d6790bbcb54e0cf$export$849dbeeeda01ae98 = 'production';

});

parcelRegister("726a8", function(module, exports) {

$parcel$export(module.exports, "notifyEventProcessors", function () { return $51ed800f9a535a8a$export$bf2a096c3e883e79; });

var $1Fos3 = parcelRequire("1Fos3");

var $euQAQ = parcelRequire("euQAQ");

var $brfue = parcelRequire("brfue");

var $zusVr = parcelRequire("zusVr");

var $f3a5J = parcelRequire("f3a5J");
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $51ed800f9a535a8a$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $f3a5J.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor((0, $1Fos3._)({}, event), hint);
            (0, $euQAQ.DEBUG_BUILD) && processor.id && result === null && (0, $zusVr.debug).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $brfue.isThenable)(result)) result.then((final)=>$51ed800f9a535a8a$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $51ed800f9a535a8a$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("f3a5J", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", function () { return $af4ef6ca4d915731$export$1fda8aa4d135f8aa; });
$parcel$export(module.exports, "SyncPromise", function () { return $af4ef6ca4d915731$export$6f292d4960313241; });
$parcel$export(module.exports, "rejectedSyncPromise", function () { return $af4ef6ca4d915731$export$78e43115b553f358; });

var $brfue = parcelRequire("brfue");
/* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ const $af4ef6ca4d915731$var$STATE_PENDING = 0;
const $af4ef6ca4d915731$var$STATE_RESOLVED = 1;
const $af4ef6ca4d915731$var$STATE_REJECTED = 2;
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $af4ef6ca4d915731$export$1fda8aa4d135f8aa(value) {
    return new $af4ef6ca4d915731$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $af4ef6ca4d915731$export$78e43115b553f358(reason) {
    return new $af4ef6ca4d915731$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $af4ef6ca4d915731$export$6f292d4960313241 {
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $af4ef6ca4d915731$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $af4ef6ca4d915731$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $af4ef6ca4d915731$var$STATE_PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $af4ef6ca4d915731$var$STATE_RESOLVED) handler[1](this._value);
            if (this._state === $af4ef6ca4d915731$var$STATE_REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $af4ef6ca4d915731$var$STATE_PENDING) return;
            if ((0, $brfue.isThenable)(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($af4ef6ca4d915731$var$STATE_RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($af4ef6ca4d915731$var$STATE_REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
    constructor(executor){
        this._state = $af4ef6ca4d915731$var$STATE_PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
}

});


parcelRegister("3mkPr", function(module, exports) {

$parcel$export(module.exports, "applyScopeDataToEvent", function () { return $2723954ddce7fa71$export$43988bc651a80216; });
$parcel$export(module.exports, "mergeScopeData", function () { return $2723954ddce7fa71$export$25ac7e259a513db4; });

var $1Fos3 = parcelRequire("1Fos3");

var $eNSK5 = parcelRequire("eNSK5");

var $lrI6i = parcelRequire("lrI6i");

var $lN5CN = parcelRequire("lN5CN");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $2723954ddce7fa71$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $2723954ddce7fa71$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $2723954ddce7fa71$var$applySpanToEvent(event, span);
    $2723954ddce7fa71$var$applyFingerprintToEvent(event, fingerprint);
    $2723954ddce7fa71$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $2723954ddce7fa71$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $2723954ddce7fa71$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $2723954ddce7fa71$export$b1a120a2871faa46(data, 'extra', extra);
    $2723954ddce7fa71$export$b1a120a2871faa46(data, 'tags', tags);
    $2723954ddce7fa71$export$b1a120a2871faa46(data, 'user', user);
    $2723954ddce7fa71$export$b1a120a2871faa46(data, 'contexts', contexts);
    data.sdkProcessingMetadata = (0, $lrI6i.merge)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = (0, $1Fos3._)({}, data.propagationContext, propagationContext);
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $2723954ddce7fa71$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $lrI6i.merge)(data[prop], mergeVal, 1);
}
function $2723954ddce7fa71$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = (0, $1Fos3._)({}, extra, event.extra);
    if (Object.keys(tags).length) event.tags = (0, $1Fos3._)({}, tags, event.tags);
    if (Object.keys(user).length) event.user = (0, $1Fos3._)({}, user, event.user);
    if (Object.keys(contexts).length) event.contexts = (0, $1Fos3._)({}, contexts, event.contexts);
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== 'transaction') event.transaction = transactionName;
}
function $2723954ddce7fa71$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $2723954ddce7fa71$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = (0, $1Fos3._)({}, event.sdkProcessingMetadata, sdkProcessingMetadata);
}
function $2723954ddce7fa71$var$applySpanToEvent(event, span) {
    event.contexts = (0, $1Fos3._)({
        trace: (0, $lN5CN.spanToTraceContext)(span)
    }, event.contexts);
    event.sdkProcessingMetadata = (0, $1Fos3._)({
        dynamicSamplingContext: (0, $eNSK5.getDynamicSamplingContextFromSpan)(span)
    }, event.sdkProcessingMetadata);
    const rootSpan = (0, $lN5CN.getRootSpan)(span);
    const transactionName = (0, $lN5CN.spanToJSON)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === 'transaction') event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $2723954ddce7fa71$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (!event.fingerprint.length) delete event.fingerprint;
}

});
parcelRegister("eNSK5", function(module, exports) {

$parcel$export(module.exports, "getDynamicSamplingContextFromScope", function () { return $ac701af8dff70d1c$export$89ef1736f08c6b2b; });
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", function () { return $ac701af8dff70d1c$export$a117f995597e25df; });

var $5gR0A = parcelRequire("5gR0A");

var $d5d01 = parcelRequire("d5d01");

var $cdgd4 = parcelRequire("cdgd4");

var $7HVDN = parcelRequire("7HVDN");

var $hABGa = parcelRequire("hABGa");

var $5Q9Ww = parcelRequire("5Q9Ww");

var $aVCF4 = parcelRequire("aVCF4");

var $lN5CN = parcelRequire("lN5CN");

var $78eGt = parcelRequire("78eGt");
/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $ac701af8dff70d1c$var$FROZEN_DSC_FIELD = '_frozenDsc';
/**
 * Freeze the given DSC on the given span.
 */ function $ac701af8dff70d1c$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $aVCF4.addNonEnumerableProperty)(spanWithMaybeDsc, $ac701af8dff70d1c$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $ac701af8dff70d1c$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key, host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = (0, $hABGa.extractOrgIdFromDsnHost)(host);
    // Instead of conditionally adding non-undefined values, we add them and then remove them if needed
    // otherwise, the order of baggage entries changes, which "breaks" a bunch of tests etc.
    const dsc = {
        environment: options.environment || (0, $5gR0A.DEFAULT_ENVIRONMENT),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: org_id
    };
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $ac701af8dff70d1c$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $ac701af8dff70d1c$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $ac701af8dff70d1c$export$a117f995597e25df(span) {
    const client = (0, $d5d01.getClient)();
    if (!client) return {};
    const rootSpan = (0, $lN5CN.getRootSpan)(span);
    const rootSpanJson = (0, $lN5CN.spanToJSON)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    var _traceState_get, _ref;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    const rootSpanSampleRate = (_ref = (_traceState_get = traceState === null || traceState === void 0 ? void 0 : traceState.get('sentry.sample_rate')) !== null && _traceState_get !== void 0 ? _traceState_get : rootSpanAttributes[0, $cdgd4.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]) !== null && _ref !== void 0 ? _ref : rootSpanAttributes[0, $cdgd4.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === 'number' || typeof rootSpanSampleRate === 'string') dsc.sample_rate = `${rootSpanSampleRate}`;
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$ac701af8dff70d1c$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceStateDsc = traceState === null || traceState === void 0 ? void 0 : traceState.get('sentry.dsc');
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $7HVDN.baggageHeaderToDynamicSamplingContext)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    const dsc = $ac701af8dff70d1c$export$366bad00d6815eed(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = rootSpanAttributes[0, $cdgd4.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = rootSpanJson.description;
    if (source !== 'url' && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $5Q9Ww.hasSpansEnabled)()) {
        var // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        _getCapturedScopesOnSpan_scope;
        dsc.sampled = String((0, $lN5CN.spanIsSampled)(rootSpan));
        var // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        _traceState_get1;
        dsc.sample_rand = (_traceState_get1 = traceState === null || traceState === void 0 ? void 0 : traceState.get('sentry.sample_rand')) !== null && _traceState_get1 !== void 0 ? _traceState_get1 : (_getCapturedScopesOnSpan_scope = (0, $78eGt.getCapturedScopesOnSpan)(rootSpan).scope) === null || _getCapturedScopesOnSpan_scope === void 0 ? void 0 : _getCapturedScopesOnSpan_scope.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit('createDsc', dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $ac701af8dff70d1c$export$95cf936fdacaff7b(span) {
    const dsc = $ac701af8dff70d1c$export$a117f995597e25df(span);
    return (0, $7HVDN.dynamicSamplingContextToSentryBaggageHeader)(dsc);
}

});
parcelRegister("cdgd4", function(module, exports) {

$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", function () { return $8e4345e0dcb1f7e3$export$d7a7d984b0791405; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", function () { return $8e4345e0dcb1f7e3$export$ccfe0a40627cc34b; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE", function () { return $8e4345e0dcb1f7e3$export$889fb736668e1ecc; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", function () { return $8e4345e0dcb1f7e3$export$1a413bd9a88fdb09; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", function () { return $8e4345e0dcb1f7e3$export$cca8dd30f57f805e; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME", function () { return $8e4345e0dcb1f7e3$export$165ce9a229f6f050; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", function () { return $8e4345e0dcb1f7e3$export$1efec95406bbe327; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME", function () { return $8e4345e0dcb1f7e3$export$fea48ba9f4550879; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD", function () { return $8e4345e0dcb1f7e3$export$be7a251980e7e946; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_URL_FULL", function () { return $8e4345e0dcb1f7e3$export$25dfd73e0e32c6e1; });
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $8e4345e0dcb1f7e3$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ const $8e4345e0dcb1f7e3$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Attribute holding the sample rate of the previous trace.
 * This is used to sample consistently across subsequent traces in the browser SDK.
 *
 * Note: Only defined on root spans, if opted into consistent sampling
 */ const $8e4345e0dcb1f7e3$export$889fb736668e1ecc = 'sentry.previous_trace_sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $8e4345e0dcb1f7e3$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $8e4345e0dcb1f7e3$export$cca8dd30f57f805e = 'sentry.origin';
/** The reason why an idle span finished. */ const $8e4345e0dcb1f7e3$export$ba73f34502b7a3b3 = 'sentry.idle_span_finish_reason';
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $8e4345e0dcb1f7e3$export$f5f95cff026507b5 = 'sentry.measurement_unit';
/** The value of a measurement, which may be stored as a TimedEvent. */ const $8e4345e0dcb1f7e3$export$69cd5c610c7bb96a = 'sentry.measurement_value';
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $8e4345e0dcb1f7e3$export$165ce9a229f6f050 = 'sentry.custom_span_name';
/**
 * The id of the profile that this span occurred in.
 */ const $8e4345e0dcb1f7e3$export$1efec95406bbe327 = 'sentry.profile_id';
const $8e4345e0dcb1f7e3$export$fea48ba9f4550879 = 'sentry.exclusive_time';
const $8e4345e0dcb1f7e3$export$b016f89ac1066ec = 'cache.hit';
const $8e4345e0dcb1f7e3$export$3110e4c3f4386399 = 'cache.key';
const $8e4345e0dcb1f7e3$export$86be76deee227ff2 = 'cache.item_size';
/** TODO: Remove these once we update to latest semantic conventions */ const $8e4345e0dcb1f7e3$export$be7a251980e7e946 = 'http.request.method';
const $8e4345e0dcb1f7e3$export$25dfd73e0e32c6e1 = 'url.full';
/**
 * A span link attribute to mark the link as a special span link.
 *
 * Known values:
 * - `previous_trace`: The span links to the frontend root span of the previous trace.
 * - `next_trace`: The span links to the frontend root span of the next trace. (Not set by the SDK)
 *
 * Other values may be set as appropriate.
 * @see https://develop.sentry.dev/sdk/telemetry/traces/span-links/#link-types
 */ const $8e4345e0dcb1f7e3$export$ff77b5fd5b2d627b = 'sentry.link.type';

});

parcelRegister("7HVDN", function(module, exports) {

$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", function () { return $59c942cfa6d52ef6$export$5b96ee2c8421f107; });
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", function () { return $59c942cfa6d52ef6$export$56766feef403f365; });

var $euQAQ = parcelRequire("euQAQ");

var $brfue = parcelRequire("brfue");

var $zusVr = parcelRequire("zusVr");
const $59c942cfa6d52ef6$export$6e69537d67fa20f = 'sentry-';
const $59c942cfa6d52ef6$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $59c942cfa6d52ef6$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $59c942cfa6d52ef6$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $59c942cfa6d52ef6$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($59c942cfa6d52ef6$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($59c942cfa6d52ef6$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $59c942cfa6d52ef6$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$59c942cfa6d52ef6$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $59c942cfa6d52ef6$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $59c942cfa6d52ef6$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $brfue.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $59c942cfa6d52ef6$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $59c942cfa6d52ef6$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $59c942cfa6d52ef6$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch (e) {
                // We ignore errors here, e.g. if the value cannot be URL decoded.
                // This will then be skipped in the next step
                return;
            }
        })).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $59c942cfa6d52ef6$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $59c942cfa6d52ef6$export$bdd844ddb2def819) {
            (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}

});

parcelRegister("hABGa", function(module, exports) {

$parcel$export(module.exports, "dsnToString", function () { return $cce306c139d27b7d$export$44d472fbb931a776; });
$parcel$export(module.exports, "extractOrgIdFromDsnHost", function () { return $cce306c139d27b7d$export$5914f4e7748c29c9; });
$parcel$export(module.exports, "makeDsn", function () { return $cce306c139d27b7d$export$128827c3562ec0cb; });

var $euQAQ = parcelRequire("euQAQ");

var $zusVr = parcelRequire("zusVr");
/** Regular expression used to extract org ID from a DSN host. */ const $cce306c139d27b7d$var$ORG_ID_REGEX = /^o(\d+)\./;
/** Regular expression used to parse a Dsn. */ const $cce306c139d27b7d$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $cce306c139d27b7d$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $cce306c139d27b7d$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $cce306c139d27b7d$export$b892860177f70a30(str) {
    const match = $cce306c139d27b7d$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $zusVr.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host = '', port = '', lastPath = ''] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $cce306c139d27b7d$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $cce306c139d27b7d$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $cce306c139d27b7d$var$validateDsn(dsn) {
    if (!(0, $euQAQ.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $zusVr.debug).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $zusVr.debug).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$cce306c139d27b7d$var$isValidProtocol(protocol)) {
        (0, $zusVr.debug).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $zusVr.debug).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Extract the org ID from a DSN host.
 *
 * @param host The host from a DSN
 * @returns The org ID if found, undefined otherwise
 */ function $cce306c139d27b7d$export$5914f4e7748c29c9(host) {
    const match = host.match($cce306c139d27b7d$var$ORG_ID_REGEX);
    return match === null || match === void 0 ? void 0 : match[1];
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $cce306c139d27b7d$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $cce306c139d27b7d$export$b892860177f70a30(from) : $cce306c139d27b7d$var$dsnFromComponents(from);
    if (!components || !$cce306c139d27b7d$var$validateDsn(components)) return undefined;
    return components;
}

});

parcelRegister("5Q9Ww", function(module, exports) {

$parcel$export(module.exports, "hasSpansEnabled", function () { return $4409858c2d4f1685$export$1f70765132c3c225; });

var $d5d01 = parcelRequire("d5d01");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function $4409858c2d4f1685$export$1f70765132c3c225(maybeOptions) {
    var _getClient;
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || ((_getClient = (0, $d5d01.getClient)()) === null || _getClient === void 0 ? void 0 : _getClient.getOptions());
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}
/**
 * @see JSDoc of `hasSpansEnabled`
 * @deprecated Use `hasSpansEnabled` instead, which is a more accurately named version of this function.
 * This function will be removed in the next major version of the SDK.
 */ // TODO(v10): Remove this export
const $4409858c2d4f1685$export$5008da00b1b6dee6 = $4409858c2d4f1685$export$1f70765132c3c225;

});

parcelRegister("lN5CN", function(module, exports) {

$parcel$export(module.exports, "spanToJSON", function () { return $fdd2898eb24e47a0$export$92d8c23565496537; });
$parcel$export(module.exports, "spanToTraceContext", function () { return $fdd2898eb24e47a0$export$46c6fbd1d265ebf0; });
$parcel$export(module.exports, "spanIsSampled", function () { return $fdd2898eb24e47a0$export$5caecac1caaf3a71; });
$parcel$export(module.exports, "getRootSpan", function () { return $fdd2898eb24e47a0$export$c4c6a79b1260ca1b; });
$parcel$export(module.exports, "getActiveSpan", function () { return $fdd2898eb24e47a0$export$1be426a8e585c83e; });
$parcel$export(module.exports, "showSpanDropWarning", function () { return $fdd2898eb24e47a0$export$d11691ff45a3e535; });

var $1Fos3 = parcelRequire("1Fos3");

var $6NU0v = parcelRequire("6NU0v");

var $iL1GP = parcelRequire("iL1GP");

var $9cBYA = parcelRequire("9cBYA");

var $d5d01 = parcelRequire("d5d01");

var $cdgd4 = parcelRequire("cdgd4");

var $l7AZk = parcelRequire("l7AZk");

var $78eGt = parcelRequire("78eGt");

var $zusVr = parcelRequire("zusVr");

var $aVCF4 = parcelRequire("aVCF4");

var $i6XPv = parcelRequire("i6XPv");

var $hPkId = parcelRequire("hPkId");

var $aBpcX = parcelRequire("aBpcX");

var $l4Dzd = parcelRequire("l4Dzd");
// These are aligned with OpenTelemetry trace flags
const $fdd2898eb24e47a0$export$208d5b368507fb8b = 0x0;
const $fdd2898eb24e47a0$export$eb571cd9b5d98de8 = 0x1;
let $fdd2898eb24e47a0$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $fdd2898eb24e47a0$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $fdd2898eb24e47a0$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $fdd2898eb24e47a0$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $fdd2898eb24e47a0$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $78eGt.getCapturedScopesOnSpan)(span).scope;
    const span_id = isRemote ? (scope === null || scope === void 0 ? void 0 : scope.getPropagationContext().propagationSpanId) || (0, $i6XPv.generateSpanId)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $fdd2898eb24e47a0$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $fdd2898eb24e47a0$export$5caecac1caaf3a71(span);
    return (0, $aBpcX.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $fdd2898eb24e47a0$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map((_param)=>{
        var { context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags }, attributes: attributes } = _param, restContext = (0, $6NU0v._)(_param.context, [
            "spanId",
            "traceId",
            "traceFlags"
        ]);
        return (0, $1Fos3._)({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $fdd2898eb24e47a0$export$eb571cd9b5d98de8,
            attributes: attributes
        }, restContext);
    });
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $fdd2898eb24e47a0$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $fdd2898eb24e47a0$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $fdd2898eb24e47a0$var$ensureTimestampInSeconds(input.getTime());
    return (0, $hPkId.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $fdd2898eb24e47a0$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $fdd2898eb24e47a0$export$92d8c23565496537(span) {
    if ($fdd2898eb24e47a0$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($fdd2898eb24e47a0$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        var _span_parentSpanContext;
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        // In preparation for the next major of OpenTelemetry, we want to support
        // looking up the parent span id according to the new API
        // In OTel v1, the parent span id is accessed as `parentSpanId`
        // In OTel v2, the parent span id is accessed as `spanId` on the `parentSpanContext`
        const parentSpanId = 'parentSpanId' in span ? span.parentSpanId : 'parentSpanContext' in span ? (_span_parentSpanContext = span.parentSpanContext) === null || _span_parentSpanContext === void 0 ? void 0 : _span_parentSpanContext.spanId : undefined;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: parentSpanId,
            start_timestamp: $fdd2898eb24e47a0$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $fdd2898eb24e47a0$export$3f7581298f56c6d7(endTime) || undefined,
            status: $fdd2898eb24e47a0$export$e238a77ea3a8cd66(status),
            op: attributes[0, $cdgd4.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            origin: attributes[0, $cdgd4.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            links: $fdd2898eb24e47a0$export$cb3e3a12e0eec16c(links)
        };
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $fdd2898eb24e47a0$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $fdd2898eb24e47a0$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $fdd2898eb24e47a0$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $fdd2898eb24e47a0$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $fdd2898eb24e47a0$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $l7AZk.SPAN_STATUS_UNSET)) return undefined;
    if (status.code === (0, $l7AZk.SPAN_STATUS_OK)) return 'ok';
    return status.message || 'unknown_error';
}
const $fdd2898eb24e47a0$var$CHILD_SPANS_FIELD = '_sentryChildSpans';
const $fdd2898eb24e47a0$var$ROOT_SPAN_FIELD = '_sentryRootSpan';
/**
 * Adds an opaque child span reference to a span.
 */ function $fdd2898eb24e47a0$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$fdd2898eb24e47a0$var$ROOT_SPAN_FIELD] || span;
    (0, $aVCF4.addNonEnumerableProperty)(childSpan, $fdd2898eb24e47a0$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$fdd2898eb24e47a0$var$CHILD_SPANS_FIELD]) span[$fdd2898eb24e47a0$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $aVCF4.addNonEnumerableProperty)(span, $fdd2898eb24e47a0$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $fdd2898eb24e47a0$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$fdd2898eb24e47a0$var$CHILD_SPANS_FIELD]) span[$fdd2898eb24e47a0$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $fdd2898eb24e47a0$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($fdd2898eb24e47a0$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$fdd2898eb24e47a0$var$CHILD_SPANS_FIELD] ? Array.from(span[$fdd2898eb24e47a0$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $fdd2898eb24e47a0$export$c4c6a79b1260ca1b(span) {
    return span[$fdd2898eb24e47a0$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $fdd2898eb24e47a0$export$1be426a8e585c83e() {
    const carrier = (0, $9cBYA.getMainCarrier)();
    const acs = (0, $iL1GP.getAsyncContextStrategy)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $l4Dzd._getSpanForScope)((0, $d5d01.getCurrentScope)());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function $fdd2898eb24e47a0$export$d11691ff45a3e535() {
    if (!$fdd2898eb24e47a0$var$hasShownSpanDropWarning) {
        (0, $zusVr.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly.');
        });
        $fdd2898eb24e47a0$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $fdd2898eb24e47a0$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $cdgd4.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'custom',
        [(0, $cdgd4.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME)]: name
    });
}

});
parcelRegister("6NU0v", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4f42c385e3061c37$export$71511d61b312f219; });

var $c3DRc = parcelRequire("c3DRc");
function $4f42c385e3061c37$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = (0, $c3DRc._)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("c3DRc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8c74aea71aea5adc$export$71511d61b312f219; });
function $8c74aea71aea5adc$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("l7AZk", function(module, exports) {

$parcel$export(module.exports, "SPAN_STATUS_UNSET", function () { return $f606f17dda1f2447$export$136e25984ba4a383; });
$parcel$export(module.exports, "SPAN_STATUS_OK", function () { return $f606f17dda1f2447$export$58f7963109c806fc; });
const $f606f17dda1f2447$export$136e25984ba4a383 = 0;
const $f606f17dda1f2447$export$58f7963109c806fc = 1;
const $f606f17dda1f2447$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $f606f17dda1f2447$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $f606f17dda1f2447$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $f606f17dda1f2447$export$f966a0446ece71e,
                message: 'unauthenticated'
            };
        case 403:
            return {
                code: $f606f17dda1f2447$export$f966a0446ece71e,
                message: 'permission_denied'
            };
        case 404:
            return {
                code: $f606f17dda1f2447$export$f966a0446ece71e,
                message: 'not_found'
            };
        case 409:
            return {
                code: $f606f17dda1f2447$export$f966a0446ece71e,
                message: 'already_exists'
            };
        case 413:
            return {
                code: $f606f17dda1f2447$export$f966a0446ece71e,
                message: 'failed_precondition'
            };
        case 429:
            return {
                code: $f606f17dda1f2447$export$f966a0446ece71e,
                message: 'resource_exhausted'
            };
        case 499:
            return {
                code: $f606f17dda1f2447$export$f966a0446ece71e,
                message: 'cancelled'
            };
        default:
            return {
                code: $f606f17dda1f2447$export$f966a0446ece71e,
                message: 'invalid_argument'
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $f606f17dda1f2447$export$f966a0446ece71e,
                message: 'unimplemented'
            };
        case 503:
            return {
                code: $f606f17dda1f2447$export$f966a0446ece71e,
                message: 'unavailable'
            };
        case 504:
            return {
                code: $f606f17dda1f2447$export$f966a0446ece71e,
                message: 'deadline_exceeded'
            };
        default:
            return {
                code: $f606f17dda1f2447$export$f966a0446ece71e,
                message: 'internal_error'
            };
    }
    return {
        code: $f606f17dda1f2447$export$f966a0446ece71e,
        message: 'unknown_error'
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $f606f17dda1f2447$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute('http.response.status_code', httpStatus);
    const spanStatus = $f606f17dda1f2447$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== 'unknown_error') span.setStatus(spanStatus);
}

});

parcelRegister("78eGt", function(module, exports) {

$parcel$export(module.exports, "getCapturedScopesOnSpan", function () { return $5314abae6234660c$export$c08fbc656a245d03; });

var $aVCF4 = parcelRequire("aVCF4");
const $5314abae6234660c$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $5314abae6234660c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $5314abae6234660c$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $aVCF4.addNonEnumerableProperty)(span, $5314abae6234660c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $aVCF4.addNonEnumerableProperty)(span, $5314abae6234660c$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $5314abae6234660c$export$c08fbc656a245d03(span) {
    return {
        scope: span[$5314abae6234660c$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$5314abae6234660c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}

});

parcelRegister("aBpcX", function(module, exports) {

$parcel$export(module.exports, "generateSentryTraceHeader", function () { return $7b80e9df25389de6$export$f35d907436da45cf; });

var $7HVDN = parcelRequire("7HVDN");

var $1TvTJ = parcelRequire("1TvTJ");

var $i6XPv = parcelRequire("i6XPv");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $7b80e9df25389de6$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $7b80e9df25389de6$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($7b80e9df25389de6$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $7b80e9df25389de6$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $7b80e9df25389de6$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $7HVDN.baggageHeaderToDynamicSamplingContext)(baggage);
    if (!(traceparentData === null || traceparentData === void 0 ? void 0 : traceparentData.traceId)) return {
        traceId: (0, $i6XPv.generateTraceId)(),
        sampleRand: Math.random()
    };
    const sampleRand = $7b80e9df25389de6$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $7b80e9df25389de6$export$f35d907436da45cf(traceId = (0, $i6XPv.generateTraceId)(), spanId = (0, $i6XPv.generateSpanId)(), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function $7b80e9df25389de6$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    const parsedSampleRand = (0, $1TvTJ.parseSampleRate)(dsc === null || dsc === void 0 ? void 0 : dsc.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    const parsedSampleRate = (0, $1TvTJ.parseSampleRate)(dsc === null || dsc === void 0 ? void 0 : dsc.sample_rate);
    if (parsedSampleRate && (traceparentData === null || traceparentData === void 0 ? void 0 : traceparentData.parentSampled) !== undefined) return traceparentData.parentSampled ? Math.random() * parsedSampleRate : parsedSampleRate + Math.random() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return Math.random();
}

});
parcelRegister("1TvTJ", function(module, exports) {

$parcel$export(module.exports, "parseSampleRate", function () { return $1613abc7a055d0cd$export$a5bd2d81656d9546; });
/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $1613abc7a055d0cd$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === 'boolean') return Number(sampleRate);
    const rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}

});





parcelRegister("aLhPi", function(module, exports) {

$parcel$export(module.exports, "getFilenameToDebugIdMap", function () { return $7d5c1f18644a155e$export$e069fee9c632ed00; });

var $6ZThC = parcelRequire("6ZThC");
let $7d5c1f18644a155e$var$parsedStackResults;
let $7d5c1f18644a155e$var$lastKeysCount;
let $7d5c1f18644a155e$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 */ function $7d5c1f18644a155e$export$e069fee9c632ed00(stackParser) {
    const debugIdMap = (0, $6ZThC.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return {};
    const debugIdKeys = Object.keys(debugIdMap);
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($7d5c1f18644a155e$var$cachedFilenameDebugIds && debugIdKeys.length === $7d5c1f18644a155e$var$lastKeysCount) return $7d5c1f18644a155e$var$cachedFilenameDebugIds;
    $7d5c1f18644a155e$var$lastKeysCount = debugIdKeys.length;
    // Build a map of filename -> debug_id.
    $7d5c1f18644a155e$var$cachedFilenameDebugIds = debugIdKeys.reduce((acc, stackKey)=>{
        if (!$7d5c1f18644a155e$var$parsedStackResults) $7d5c1f18644a155e$var$parsedStackResults = {};
        const result = $7d5c1f18644a155e$var$parsedStackResults[stackKey];
        if (result) acc[result[0]] = result[1];
        else {
            const parsedStack = stackParser(stackKey);
            for(let i = parsedStack.length - 1; i >= 0; i--){
                const stackFrame = parsedStack[i];
                const filename = stackFrame === null || stackFrame === void 0 ? void 0 : stackFrame.filename;
                const debugId = debugIdMap[stackKey];
                if (filename && debugId) {
                    acc[filename] = debugId;
                    $7d5c1f18644a155e$var$parsedStackResults[stackKey] = [
                        filename,
                        debugId
                    ];
                    break;
                }
            }
        }
        return acc;
    }, {});
    return $7d5c1f18644a155e$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $7d5c1f18644a155e$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $7d5c1f18644a155e$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: 'sourcemap',
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}

});

parcelRegister("kmom1", function(module, exports) {

$parcel$export(module.exports, "normalize", function () { return $ed28c0f5e92ceaea$export$a3295358bff77e; });
$parcel$export(module.exports, "normalizeToSize", function () { return $ed28c0f5e92ceaea$export$23fbbb20bed71033; });

var $brfue = parcelRequire("brfue");

var $aVCF4 = parcelRequire("aVCF4");

var $cvueN = parcelRequire("cvueN");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ed28c0f5e92ceaea$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $ed28c0f5e92ceaea$var$visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $ed28c0f5e92ceaea$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $ed28c0f5e92ceaea$export$a3295358bff77e(object, depth);
    if ($ed28c0f5e92ceaea$var$jsonSize(normalized) > maxSize) return $ed28c0f5e92ceaea$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $ed28c0f5e92ceaea$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $ed28c0f5e92ceaea$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'boolean',
        'string'
    ].includes(typeof value) || typeof value === 'number' && Number.isFinite(value)) return value;
    const stringified = $ed28c0f5e92ceaea$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $ed28c0f5e92ceaea$var$visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $aVCF4.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $ed28c0f5e92ceaea$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $ed28c0f5e92ceaea$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $brfue.isVueViewModel)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $brfue.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === 'function') return `[Function: ${(0, $cvueN.getFunctionName)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $ed28c0f5e92ceaea$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $ed28c0f5e92ceaea$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === void 0 ? void 0 : prototype.constructor) ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $ed28c0f5e92ceaea$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ed28c0f5e92ceaea$var$jsonSize(value) {
    return $ed28c0f5e92ceaea$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $ed28c0f5e92ceaea$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}
/**
 * Helper to decycle json objects
 */ function $ed28c0f5e92ceaea$var$memoBuilder() {
    const inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}

});
parcelRegister("cvueN", function(module, exports) {

$parcel$export(module.exports, "UNKNOWN_FUNCTION", function () { return $91afd5e0650ea886$export$27c7e15d453fc0ac; });
$parcel$export(module.exports, "createStackParser", function () { return $91afd5e0650ea886$export$a5739666fb2d03d4; });
$parcel$export(module.exports, "stackParserFromStackParserOptions", function () { return $91afd5e0650ea886$export$1d5cf88b347146d4; });
$parcel$export(module.exports, "getFunctionName", function () { return $91afd5e0650ea886$export$aad197c7121a6651; });
$parcel$export(module.exports, "getFramesFromEvent", function () { return $91afd5e0650ea886$export$91d8ca51bd9f6a47; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");
const $91afd5e0650ea886$var$STACKTRACE_FRAME_LIMIT = 50;
const $91afd5e0650ea886$export$27c7e15d453fc0ac = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
const $91afd5e0650ea886$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $91afd5e0650ea886$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $91afd5e0650ea886$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $91afd5e0650ea886$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($91afd5e0650ea886$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $91afd5e0650ea886$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $91afd5e0650ea886$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $91afd5e0650ea886$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $91afd5e0650ea886$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $91afd5e0650ea886$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($91afd5e0650ea886$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($91afd5e0650ea886$var$STRIP_FRAME_REGEXP.test($91afd5e0650ea886$var$getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($91afd5e0650ea886$var$STRIP_FRAME_REGEXP.test($91afd5e0650ea886$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, $91afd5e0650ea886$var$STACKTRACE_FRAME_LIMIT).map((frame)=>(0, $b2I6k._)((0, $1Fos3._)({}, frame), {
            filename: frame.filename || $91afd5e0650ea886$var$getLastStackFrame(localStack).filename,
            function: frame.function || $91afd5e0650ea886$export$27c7e15d453fc0ac
        }));
}
function $91afd5e0650ea886$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $91afd5e0650ea886$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $91afd5e0650ea886$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $91afd5e0650ea886$var$defaultFunctionName;
        return fn.name || $91afd5e0650ea886$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $91afd5e0650ea886$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $91afd5e0650ea886$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}

});




parcelRegister("lKCxp", function(module, exports) {

$parcel$export(module.exports, "captureReactException", function () { return $fd5bc9b0564da048$export$270be4195468cda9; });

var $2BjBt = parcelRequire("2BjBt");
var $d5d01 = parcelRequire("d5d01");

var $brfue = parcelRequire("brfue");

var $91i6m = parcelRequire("91i6m");
/**
 * See if React major version is 17+ by parsing version string.
 */ function $fd5bc9b0564da048$export$a87138b73900f5b(reactVersion) {
    const reactMajor = reactVersion.match(/^([^.]+)/);
    return reactMajor !== null && parseInt(reactMajor[0]) >= 17;
}
/**
 * Recurse through `error.cause` chain to set cause on an error.
 */ function $fd5bc9b0564da048$export$bc95048bc211a673(error, cause) {
    const seenErrors = new WeakSet();
    function recurse(error, cause) {
        // If we've already seen the error, there is a recursive loop somewhere in the error's
        // cause chain. Let's just bail out then to prevent a stack overflow.
        if (seenErrors.has(error)) return;
        if (error.cause) {
            seenErrors.add(error);
            return recurse(error.cause, cause);
        }
        error.cause = cause;
    }
    recurse(error, cause);
}
/**
 * Captures an error that was thrown by a React ErrorBoundary or React root.
 *
 * @param error The error to capture.
 * @param errorInfo The errorInfo provided by React.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $fd5bc9b0564da048$export$270be4195468cda9(// eslint-disable-next-line @typescript-eslint/no-explicit-any
error, { componentStack: componentStack }, hint) {
    // If on React version >= 17, create stack trace from componentStack param and links
    // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
    // Linking errors requires the `LinkedErrors` integration be enabled.
    // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
    //
    // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
    // with non-error objects. This is why we need to check if the error is an error-like object.
    // See: https://github.com/getsentry/sentry-javascript/issues/6167
    if ($fd5bc9b0564da048$export$a87138b73900f5b((0, $91i6m.version)) && (0, $brfue.isError)(error) && componentStack) {
        const errorBoundaryError = new Error(error.message);
        errorBoundaryError.name = `React ErrorBoundary ${error.name}`;
        errorBoundaryError.stack = componentStack;
        // Using the `LinkedErrors` integration to link the errors together.
        $fd5bc9b0564da048$export$bc95048bc211a673(error, errorBoundaryError);
    }
    return (0, $d5d01.withScope)((scope)=>{
        scope.setContext('react', {
            componentStack: componentStack
        });
        return (0, $2BjBt.captureException)(error, hint);
    });
}
/**
 * Creates an error handler that can be used with the `onCaughtError`, `onUncaughtError`,
 * and `onRecoverableError` options in `createRoot` and `hydrateRoot` React DOM methods.
 *
 * @param callback An optional callback that will be called after the error is captured.
 * Use this to add custom handling for errors.
 *
 * @example
 *
 * ```JavaScript
 * const root = createRoot(container, {
 *  onCaughtError: Sentry.reactErrorHandler(),
 *  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
 *    console.warn('Caught error', error, errorInfo.componentStack);
 *  });
 * });
 * ```
 */ function $fd5bc9b0564da048$export$1e6f045b27b3cfb1(// eslint-disable-next-line @typescript-eslint/no-explicit-any
callback) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (error, errorInfo)=>{
        const eventId = $fd5bc9b0564da048$export$270be4195468cda9(error, errorInfo);
        if (callback) callback(error, errorInfo, eventId);
    };
}

});

parcelRegister("8Y2kN", function(module, exports) {

$parcel$export(module.exports, "extraErrorDataIntegration", function () { return $6875bce23cb6427f$export$6e0872131894301d; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $euQAQ = parcelRequire("euQAQ");

var $Fmb4Q = parcelRequire("Fmb4Q");

var $brfue = parcelRequire("brfue");

var $zusVr = parcelRequire("zusVr");

var $kmom1 = parcelRequire("kmom1");

var $aVCF4 = parcelRequire("aVCF4");

var $38VNK = parcelRequire("38VNK");
const $6875bce23cb6427f$var$INTEGRATION_NAME = 'ExtraErrorData';
/**
 * Extract additional data for from original exceptions.
 */ const $6875bce23cb6427f$var$_extraErrorDataIntegration = (options = {})=>{
    const { depth: depth = 3, captureErrorCause: captureErrorCause = true } = options;
    return {
        name: $6875bce23cb6427f$var$INTEGRATION_NAME,
        processEvent (event, hint, client) {
            const { maxValueLength: maxValueLength = 250 } = client.getOptions();
            return $6875bce23cb6427f$var$_enhanceEventWithErrorData(event, hint, depth, captureErrorCause, maxValueLength);
        }
    };
};
const $6875bce23cb6427f$export$6e0872131894301d = (0, $Fmb4Q.defineIntegration)($6875bce23cb6427f$var$_extraErrorDataIntegration);
function $6875bce23cb6427f$var$_enhanceEventWithErrorData(event, hint = {}, depth, captureErrorCause, maxValueLength) {
    if (!hint.originalException || !(0, $brfue.isError)(hint.originalException)) return event;
    const exceptionName = hint.originalException.name || hint.originalException.constructor.name;
    const errorData = $6875bce23cb6427f$var$_extractErrorData(hint.originalException, captureErrorCause, maxValueLength);
    if (errorData) {
        const contexts = (0, $1Fos3._)({}, event.contexts);
        const normalizedErrorData = (0, $kmom1.normalize)(errorData, depth);
        if ((0, $brfue.isPlainObject)(normalizedErrorData)) {
            // We mark the error data as "already normalized" here, because we don't want other normalization procedures to
            // potentially truncate the data we just already normalized, with a certain depth setting.
            (0, $aVCF4.addNonEnumerableProperty)(normalizedErrorData, '__sentry_skip_normalization__', true);
            contexts[exceptionName] = normalizedErrorData;
        }
        return (0, $b2I6k._)((0, $1Fos3._)({}, event), {
            contexts: contexts
        });
    }
    return event;
}
/**
 * Extract extra information from the Error object
 */ function $6875bce23cb6427f$var$_extractErrorData(error, captureErrorCause, maxValueLength) {
    // We are trying to enhance already existing event, so no harm done if it won't succeed
    try {
        const nativeKeys = [
            'name',
            'message',
            'stack',
            'line',
            'column',
            'fileName',
            'lineNumber',
            'columnNumber',
            'toJSON'
        ];
        const extraErrorInfo = {};
        // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
        for (const key of Object.keys(error)){
            if (nativeKeys.indexOf(key) !== -1) continue;
            const value = error[key];
            extraErrorInfo[key] = (0, $brfue.isError)(value) || typeof value === 'string' ? (0, $38VNK.truncate)(`${value}`, maxValueLength) : value;
        }
        // Error.cause is a standard property that is non enumerable, we therefore need to access it separately.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/cause
        if (captureErrorCause && error.cause !== undefined) extraErrorInfo.cause = (0, $brfue.isError)(error.cause) ? error.cause.toString() : error.cause;
        // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
        if (typeof error.toJSON === 'function') {
            const serializedError = error.toJSON();
            for (const key of Object.keys(serializedError)){
                const value = serializedError[key];
                extraErrorInfo[key] = (0, $brfue.isError)(value) ? value.toString() : value;
            }
        }
        return extraErrorInfo;
    } catch (oO) {
        (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).error('Unable to extract extra data from the Error object:', oO);
    }
    return null;
}

});
parcelRegister("Fmb4Q", function(module, exports) {

$parcel$export(module.exports, "getIntegrationsToSetup", function () { return $07c50878deb63d3f$export$68bc4c01ab8ae766; });
$parcel$export(module.exports, "setupIntegrations", function () { return $07c50878deb63d3f$export$51abed9797baa598; });
$parcel$export(module.exports, "setupIntegration", function () { return $07c50878deb63d3f$export$e7390a03b70a6f2f; });
$parcel$export(module.exports, "afterSetupIntegrations", function () { return $07c50878deb63d3f$export$35abcfd71227c6ca; });
$parcel$export(module.exports, "defineIntegration", function () { return $07c50878deb63d3f$export$2323046b9414659f; });

var $d5d01 = parcelRequire("d5d01");

var $euQAQ = parcelRequire("euQAQ");

var $zusVr = parcelRequire("zusVr");
const $07c50878deb63d3f$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $07c50878deb63d3f$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $07c50878deb63d3f$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $07c50878deb63d3f$var$filterDuplicates(integrations);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $07c50878deb63d3f$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $07c50878deb63d3f$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $07c50878deb63d3f$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration === null || integration === void 0 ? void 0 : integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $07c50878deb63d3f$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($07c50878deb63d3f$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === 'function') {
        integration.setupOnce();
        $07c50878deb63d3f$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $07c50878deb63d3f$export$2d8f5188773bcddd(integration) {
    const client = (0, $d5d01.getClient)();
    if (!client) {
        (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $07c50878deb63d3f$export$2323046b9414659f(fn) {
    return fn;
}

});


parcelRegister("57re5", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $3ba2b9c76e839011$export$2cd8252107eb640b; });

var $1Fos3 = parcelRequire("1Fos3");

var $3txZF = parcelRequire("3txZF");
var $2BjBt = parcelRequire("2BjBt");

var $69Azg = parcelRequire("69Azg");

var $91i6m = parcelRequire("91i6m");
/**
 * Inits the React SDK
 */ function $3ba2b9c76e839011$export$2cd8252107eb640b(options) {
    const opts = (0, $1Fos3._)({}, options);
    (0, $69Azg.applySdkMetadata)(opts, 'react');
    (0, $2BjBt.setContext)('react', {
        version: $91i6m.version
    });
    return (0, $3txZF.init)(opts);
}

});
parcelRegister("3txZF", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $287e72f35cd83240$export$2cd8252107eb640b; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $1UsVJ = parcelRequire("1UsVJ");
var $h3TkC = parcelRequire("h3TkC");
var $Fmb4Q = parcelRequire("Fmb4Q");
var $lOB8a = parcelRequire("lOB8a");
var $42Mn4 = parcelRequire("42Mn4");
var $cvueN = parcelRequire("cvueN");

var $bkj8h = parcelRequire("bkj8h");

var $cd6Zb = parcelRequire("cd6Zb");

var $dvw5H = parcelRequire("dvw5H");

var $jZlaw = parcelRequire("jZlaw");

var $hnhnG = parcelRequire("hnhnG");

var $da9Cp = parcelRequire("da9Cp");

var $5c0ex = parcelRequire("5c0ex");

var $cxcJ7 = parcelRequire("cxcJ7");

var $g3ZnX = parcelRequire("g3ZnX");

var $gDDQ6 = parcelRequire("gDDQ6");
/** Get the default integrations for the browser SDK. */ function $287e72f35cd83240$export$5783b2920b1d62b9(_options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ return [
        // TODO(v10): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line deprecation/deprecation
        (0, $lOB8a.inboundFiltersIntegration)(),
        (0, $h3TkC.functionToStringIntegration)(),
        (0, $dvw5H.browserApiErrorsIntegration)(),
        (0, $cd6Zb.breadcrumbsIntegration)(),
        (0, $hnhnG.globalHandlersIntegration)(),
        (0, $5c0ex.linkedErrorsIntegration)(),
        (0, $1UsVJ.dedupeIntegration)(),
        (0, $da9Cp.httpContextIntegration)(),
        (0, $jZlaw.browserSessionIntegration)()
    ];
}
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $287e72f35cd83240$export$2cd8252107eb640b(options = {}) {
    const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, $gDDQ6.checkAndWarnIfIsEmbeddedBrowserExtension)();
    const clientOptions = (0, $b2I6k._)((0, $1Fos3._)({}, options), {
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, $cvueN.stackParserFromStackParserOptions)(options.stackParser || (0, $cxcJ7.defaultStackParser)),
        integrations: (0, $Fmb4Q.getIntegrationsToSetup)({
            integrations: options.integrations,
            defaultIntegrations: options.defaultIntegrations == null ? $287e72f35cd83240$export$5783b2920b1d62b9() : options.defaultIntegrations
        }),
        transport: options.transport || (0, $g3ZnX.makeFetchTransport)
    });
    return (0, $42Mn4.initAndBind)((0, $bkj8h.BrowserClient), clientOptions);
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $287e72f35cd83240$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $287e72f35cd83240$export$4e4d8b287d028b6b(callback) {
    callback();
}

});
parcelRegister("1UsVJ", function(module, exports) {

$parcel$export(module.exports, "dedupeIntegration", function () { return $16417655db63282b$export$6d39aa44cd0c7567; });

var $euQAQ = parcelRequire("euQAQ");

var $Fmb4Q = parcelRequire("Fmb4Q");

var $zusVr = parcelRequire("zusVr");

var $cvueN = parcelRequire("cvueN");
const $16417655db63282b$var$INTEGRATION_NAME = 'Dedupe';
const $16417655db63282b$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $16417655db63282b$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($16417655db63282b$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $16417655db63282b$export$6d39aa44cd0c7567 = (0, $Fmb4Q.defineIntegration)($16417655db63282b$var$_dedupeIntegration);
/** only exported for tests. */ function $16417655db63282b$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($16417655db63282b$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($16417655db63282b$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $16417655db63282b$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$16417655db63282b$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$16417655db63282b$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $16417655db63282b$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $16417655db63282b$var$_getExceptionFromEvent(previousEvent);
    const currentException = $16417655db63282b$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$16417655db63282b$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$16417655db63282b$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $16417655db63282b$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $cvueN.getFramesFromEvent)(currentEvent);
    let previousFrames = (0, $cvueN.getFramesFromEvent)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $16417655db63282b$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $16417655db63282b$var$_getExceptionFromEvent(event) {
    var _event_exception;
    return ((_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : _event_exception.values) && event.exception.values[0];
}

});

parcelRegister("h3TkC", function(module, exports) {

$parcel$export(module.exports, "functionToStringIntegration", function () { return $c6bda32da53d5bb3$export$7918117e9202e4fb; });

var $d5d01 = parcelRequire("d5d01");

var $Fmb4Q = parcelRequire("Fmb4Q");

var $aVCF4 = parcelRequire("aVCF4");
let $c6bda32da53d5bb3$var$originalFunctionToString;
const $c6bda32da53d5bb3$var$INTEGRATION_NAME = 'FunctionToString';
const $c6bda32da53d5bb3$var$SETUP_CLIENTS = new WeakMap();
const $c6bda32da53d5bb3$var$_functionToStringIntegration = ()=>{
    return {
        name: $c6bda32da53d5bb3$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $c6bda32da53d5bb3$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $aVCF4.getOriginalFunction)(this);
                    const context = $c6bda32da53d5bb3$var$SETUP_CLIENTS.has((0, $d5d01.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return $c6bda32da53d5bb3$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $c6bda32da53d5bb3$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $c6bda32da53d5bb3$export$7918117e9202e4fb = (0, $Fmb4Q.defineIntegration)($c6bda32da53d5bb3$var$_functionToStringIntegration);

});

parcelRegister("lOB8a", function(module, exports) {

$parcel$export(module.exports, "inboundFiltersIntegration", function () { return $fe1b11e2b563eb7d$export$cb3c5c2ceb9818ba; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $euQAQ = parcelRequire("euQAQ");

var $Fmb4Q = parcelRequire("Fmb4Q");

var $6LSad = parcelRequire("6LSad");

var $zusVr = parcelRequire("zusVr");

var $38AjJ = parcelRequire("38AjJ");

var $38VNK = parcelRequire("38VNK");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $fe1b11e2b563eb7d$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    /^Can't find variable: gmo$/,
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    'can\'t redefine non-configurable property "solana"',
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    "Can't find variable: _AutofillCallbackHandler",
    /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/,
    /^Java exception was raised during method invocation$/
];
/** Options for the EventFilters integration */ const $fe1b11e2b563eb7d$var$INTEGRATION_NAME = 'EventFilters';
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 */ const $fe1b11e2b563eb7d$export$9a84f518c163c552 = (0, $Fmb4Q.defineIntegration)((options = {})=>{
    let mergedOptions;
    return {
        name: $fe1b11e2b563eb7d$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $fe1b11e2b563eb7d$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $fe1b11e2b563eb7d$var$_mergeOptions(options, clientOptions);
            }
            return $fe1b11e2b563eb7d$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 *
 * @deprecated this integration was renamed and will be removed in a future major version.
 * Use `eventFiltersIntegration` instead.
 */ const $fe1b11e2b563eb7d$export$cb3c5c2ceb9818ba = (0, $Fmb4Q.defineIntegration)((options = {})=>{
    return (0, $b2I6k._)((0, $1Fos3._)({}, $fe1b11e2b563eb7d$export$9a84f518c163c552(options)), {
        name: 'InboundFilters'
    });
});
function $fe1b11e2b563eb7d$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $fe1b11e2b563eb7d$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $fe1b11e2b563eb7d$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        // Filter errors
        if ($fe1b11e2b563eb7d$var$_isIgnoredError(event, options.ignoreErrors)) {
            (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $38AjJ.getEventDescription)(event)}`);
            return true;
        }
        if ($fe1b11e2b563eb7d$var$_isUselessError(event)) {
            (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $38AjJ.getEventDescription)(event)}`);
            return true;
        }
        if ($fe1b11e2b563eb7d$var$_isDeniedUrl(event, options.denyUrls)) {
            (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $38AjJ.getEventDescription)(event)}.\nUrl: ${$fe1b11e2b563eb7d$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$fe1b11e2b563eb7d$var$_isAllowedUrl(event, options.allowUrls)) {
            (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $38AjJ.getEventDescription)(event)}.\nUrl: ${$fe1b11e2b563eb7d$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === 'transaction') // Filter transactions
    {
        if ($fe1b11e2b563eb7d$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $38AjJ.getEventDescription)(event)}`);
            return true;
        }
    }
    return false;
}
function $fe1b11e2b563eb7d$var$_isIgnoredError(event, ignoreErrors) {
    if (!(ignoreErrors === null || ignoreErrors === void 0 ? void 0 : ignoreErrors.length)) return false;
    return (0, $6LSad.getPossibleEventMessages)(event).some((message)=>(0, $38VNK.stringMatchesSomePattern)(message, ignoreErrors));
}
function $fe1b11e2b563eb7d$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!(ignoreTransactions === null || ignoreTransactions === void 0 ? void 0 : ignoreTransactions.length)) return false;
    const name = event.transaction;
    return name ? (0, $38VNK.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $fe1b11e2b563eb7d$var$_isDeniedUrl(event, denyUrls) {
    if (!(denyUrls === null || denyUrls === void 0 ? void 0 : denyUrls.length)) return false;
    const url = $fe1b11e2b563eb7d$var$_getEventFilterUrl(event);
    return !url ? false : (0, $38VNK.stringMatchesSomePattern)(url, denyUrls);
}
function $fe1b11e2b563eb7d$var$_isAllowedUrl(event, allowUrls) {
    if (!(allowUrls === null || allowUrls === void 0 ? void 0 : allowUrls.length)) return true;
    const url = $fe1b11e2b563eb7d$var$_getEventFilterUrl(event);
    return !url ? true : (0, $38VNK.stringMatchesSomePattern)(url, allowUrls);
}
function $fe1b11e2b563eb7d$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $fe1b11e2b563eb7d$var$_getEventFilterUrl(event) {
    try {
        var _event_exception, _rootException_stacktrace;
        var _event_exception_values;
        // If there are linked exceptions or exception aggregates we only want to match against the top frame of the "root" (the main exception)
        // The root always comes last in linked exceptions
        const rootException = [
            ...(_event_exception_values = (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : _event_exception.values) !== null && _event_exception_values !== void 0 ? _event_exception_values : []
        ].reverse().find((value)=>{
            var _value_mechanism, _value_stacktrace_frames, _value_stacktrace;
            return ((_value_mechanism = value.mechanism) === null || _value_mechanism === void 0 ? void 0 : _value_mechanism.parent_id) === undefined && ((_value_stacktrace = value.stacktrace) === null || _value_stacktrace === void 0 ? void 0 : (_value_stacktrace_frames = _value_stacktrace.frames) === null || _value_stacktrace_frames === void 0 ? void 0 : _value_stacktrace_frames.length);
        });
        const frames = rootException === null || rootException === void 0 ? void 0 : (_rootException_stacktrace = rootException.stacktrace) === null || _rootException_stacktrace === void 0 ? void 0 : _rootException_stacktrace.frames;
        return frames ? $fe1b11e2b563eb7d$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).error(`Cannot extract url for event ${(0, $38AjJ.getEventDescription)(event)}`);
        return null;
    }
}
function $fe1b11e2b563eb7d$var$_isUselessError(event) {
    var _event_exception_values, _event_exception;
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!((_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.length)) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== 'Error' || value.value));
}

});
parcelRegister("6LSad", function(module, exports) {

$parcel$export(module.exports, "getPossibleEventMessages", function () { return $4ee125a3f6f6783c$export$d55a97c329cacfcc; });
/**
 * Get a list of possible event messages from a Sentry event.
 */ function $4ee125a3f6f6783c$export$d55a97c329cacfcc(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        // @ts-expect-error Try catching to save bundle size
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException === null || lastException === void 0 ? void 0 : lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch (e) {
    // ignore errors here
    }
    return possibleMessages;
}

});


parcelRegister("42Mn4", function(module, exports) {

$parcel$export(module.exports, "initAndBind", function () { return $2f1cded59fbff9d8$export$5333c3f1c58d9bc1; });

var $d5d01 = parcelRequire("d5d01");

var $euQAQ = parcelRequire("euQAQ");

var $zusVr = parcelRequire("zusVr");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $2f1cded59fbff9d8$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $euQAQ.DEBUG_BUILD) (0, $zusVr.debug).enable();
        else // use `console.warn` rather than `debug.warn` since by non-debug bundles have all `debug.x` statements stripped
        (0, $zusVr.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $d5d01.getCurrentScope)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $2f1cded59fbff9d8$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $2f1cded59fbff9d8$export$ecb76f41d43c0e43(client) {
    (0, $d5d01.getCurrentScope)().setClient(client);
}

});

parcelRegister("bkj8h", function(module, exports) {

$parcel$export(module.exports, "BrowserClient", function () { return $83f0674ada00dcb3$export$1df9218a526d318d; });

var $1Fos3 = parcelRequire("1Fos3");

var $81MSo = parcelRequire("81MSo");
var $8hqrR = parcelRequire("8hqrR");
var $69Azg = parcelRequire("69Azg");
var $ijU2C = parcelRequire("ijU2C");
var $jMfG5 = parcelRequire("jMfG5");

var $jiEIw = parcelRequire("jiEIw");

var $hFw8s = parcelRequire("hFw8s");
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ const $83f0674ada00dcb3$var$DEFAULT_FLUSH_INTERVAL = 5000;
/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $83f0674ada00dcb3$export$1df9218a526d318d extends (0, $ijU2C.Client) {
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $jiEIw.eventFromException)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = 'info', hint) {
        return (0, $jiEIw.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = $83f0674ada00dcb3$export$4e107b20a7f977(options);
        const sdkSource = (0, $hFw8s.WINDOW).SENTRY_SDK_SOURCE || (0, $jMfG5.getSDKSource)();
        (0, $69Azg.applySdkMetadata)(opts, 'browser', [
            'browser'
        ], sdkSource);
        super(opts);
        const { sendDefaultPii: sendDefaultPii, sendClientReports: sendClientReports, _experiments: _experiments } = this._options;
        const enableLogs = _experiments === null || _experiments === void 0 ? void 0 : _experiments.enableLogs;
        if ((0, $hFw8s.WINDOW).document && (sendClientReports || enableLogs)) (0, $hFw8s.WINDOW).document.addEventListener('visibilitychange', ()=>{
            if ((0, $hFw8s.WINDOW).document.visibilityState === 'hidden') {
                if (sendClientReports) this._flushOutcomes();
                if (enableLogs) (0, $81MSo._INTERNAL_flushLogsBuffer)(this);
            }
        });
        if (enableLogs) {
            this.on('flush', ()=>{
                (0, $81MSo._INTERNAL_flushLogsBuffer)(this);
            });
            this.on('afterCaptureLog', ()=>{
                if (this._logFlushIdleTimeout) clearTimeout(this._logFlushIdleTimeout);
                this._logFlushIdleTimeout = setTimeout(()=>{
                    (0, $81MSo._INTERNAL_flushLogsBuffer)(this);
                }, $83f0674ada00dcb3$var$DEFAULT_FLUSH_INTERVAL);
            });
        }
        if (sendDefaultPii) {
            this.on('postprocessEvent', (0, $8hqrR.addAutoIpAddressToUser));
            this.on('beforeSendSession', (0, $8hqrR.addAutoIpAddressToSession));
        }
    }
}
/** Exported only for tests. */ function $83f0674ada00dcb3$export$4e107b20a7f977(optionsArg) {
    var _WINDOW_SENTRY_RELEASE;
    return (0, $1Fos3._)({
        release: typeof __SENTRY_RELEASE__ === 'string' // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (_WINDOW_SENTRY_RELEASE = (0, $hFw8s.WINDOW).SENTRY_RELEASE) === null || _WINDOW_SENTRY_RELEASE === void 0 ? void 0 : _WINDOW_SENTRY_RELEASE.id,
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true
    }, optionsArg);
}

});
parcelRegister("81MSo", function(module, exports) {

$parcel$export(module.exports, "_INTERNAL_flushLogsBuffer", function () { return $5d84548b97f08e99$export$f8ed83d3b6a0b504; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $9cBYA = parcelRequire("9cBYA");

var $ijU2C = parcelRequire("ijU2C");

var $d5d01 = parcelRequire("d5d01");

var $euQAQ = parcelRequire("euQAQ");

var $3mkPr = parcelRequire("3mkPr");

var $brfue = parcelRequire("brfue");

var $zusVr = parcelRequire("zusVr");

var $l4Dzd = parcelRequire("l4Dzd");

var $hPkId = parcelRequire("hPkId");

var $15ptf = parcelRequire("15ptf");

var $ipbPZ = parcelRequire("ipbPZ");
const $5d84548b97f08e99$var$MAX_LOG_BUFFER_SIZE = 100;
/**
 * Converts a log attribute to a serialized log attribute.
 *
 * @param key - The key of the log attribute.
 * @param value - The value of the log attribute.
 * @returns The serialized log attribute.
 */ function $5d84548b97f08e99$export$84cb46f4adfc5d14(value) {
    switch(typeof value){
        case 'number':
            if (Number.isInteger(value)) return {
                value: value,
                type: 'integer'
            };
            return {
                value: value,
                type: 'double'
            };
        case 'boolean':
            return {
                value: value,
                type: 'boolean'
            };
        case 'string':
            return {
                value: value,
                type: 'string'
            };
        default:
            {
                let stringValue = '';
                try {
                    var _JSON_stringify;
                    stringValue = (_JSON_stringify = JSON.stringify(value)) !== null && _JSON_stringify !== void 0 ? _JSON_stringify : '';
                } catch (e) {
                // Do nothing
                }
                return {
                    value: stringValue,
                    type: 'string'
                };
            }
    }
}
/**
 * Sets a log attribute if the value exists and the attribute key is not already present.
 *
 * @param logAttributes - The log attributes object to modify.
 * @param key - The attribute key to set.
 * @param value - The value to set (only sets if truthy and key not present).
 * @param setEvenIfPresent - Whether to set the attribute if it is present. Defaults to true.
 */ function $5d84548b97f08e99$var$setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
/**
 * Captures a serialized log event and adds it to the log buffer for the given client.
 *
 * @param client - A client. Uses the current client if not provided.
 * @param serializedLog - The serialized log event to capture.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $5d84548b97f08e99$export$743ba6f7ec19225f(client, serializedLog) {
    const bufferMap = $5d84548b97f08e99$var$_getBufferMap();
    const logBuffer = $5d84548b97f08e99$export$5365c9902fb9e770(client);
    if (logBuffer === undefined) bufferMap.set(client, [
        serializedLog
    ]);
    else {
        bufferMap.set(client, [
            ...logBuffer,
            serializedLog
        ]);
        if (logBuffer.length >= $5d84548b97f08e99$var$MAX_LOG_BUFFER_SIZE) $5d84548b97f08e99$export$f8ed83d3b6a0b504(client, logBuffer);
    }
}
/**
 * Captures a log event and sends it to Sentry.
 *
 * @param log - The log event to capture.
 * @param scope - A scope. Uses the current scope if not provided.
 * @param client - A client. Uses the current client if not provided.
 * @param captureSerializedLog - A function to capture the serialized log.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $5d84548b97f08e99$export$3ab3d16b9eebd986(beforeLog, client = (0, $d5d01.getClient)(), currentScope = (0, $d5d01.getCurrentScope)(), captureSerializedLog = $5d84548b97f08e99$export$743ba6f7ec19225f) {
    var _client_getSdkMetadata;
    if (!client) {
        (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).warn('No client available to capture log.');
        return;
    }
    const { _experiments: _experiments, release: release, environment: environment } = client.getOptions();
    const { enableLogs: enableLogs = false, beforeSendLog: beforeSendLog } = _experiments !== null && _experiments !== void 0 ? _experiments : {};
    if (!enableLogs) {
        (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).warn('logging option not enabled, log will not be captured.');
        return;
    }
    const [, traceContext] = (0, $ijU2C._getTraceInfoFromScope)(client, currentScope);
    const processedLogAttributes = (0, $1Fos3._)({}, beforeLog.attributes);
    const { user: { id: id, email: email, username: username } } = $5d84548b97f08e99$var$getMergedScopeData(currentScope);
    $5d84548b97f08e99$var$setLogAttribute(processedLogAttributes, 'user.id', id, false);
    $5d84548b97f08e99$var$setLogAttribute(processedLogAttributes, 'user.email', email, false);
    $5d84548b97f08e99$var$setLogAttribute(processedLogAttributes, 'user.name', username, false);
    $5d84548b97f08e99$var$setLogAttribute(processedLogAttributes, 'sentry.release', release);
    $5d84548b97f08e99$var$setLogAttribute(processedLogAttributes, 'sentry.environment', environment);
    var _client_getSdkMetadata_sdk;
    const { name: name, version: version } = (_client_getSdkMetadata_sdk = (_client_getSdkMetadata = client.getSdkMetadata()) === null || _client_getSdkMetadata === void 0 ? void 0 : _client_getSdkMetadata.sdk) !== null && _client_getSdkMetadata_sdk !== void 0 ? _client_getSdkMetadata_sdk : {};
    $5d84548b97f08e99$var$setLogAttribute(processedLogAttributes, 'sentry.sdk.name', name);
    $5d84548b97f08e99$var$setLogAttribute(processedLogAttributes, 'sentry.sdk.version', version);
    const beforeLogMessage = beforeLog.message;
    if ((0, $brfue.isParameterizedString)(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        processedLogAttributes['sentry.message.template'] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = (0, $l4Dzd._getSpanForScope)(currentScope);
    // Add the parent span ID to the log attributes for trace context
    $5d84548b97f08e99$var$setLogAttribute(processedLogAttributes, 'sentry.trace.parent_span_id', span === null || span === void 0 ? void 0 : span.spanContext().spanId);
    const processedLog = (0, $b2I6k._)((0, $1Fos3._)({}, beforeLog), {
        attributes: processedLogAttributes
    });
    client.emit('beforeCaptureLog', processedLog);
    // We need to wrap this in `consoleSandbox` to avoid recursive calls to `beforeSendLog`
    const log = beforeSendLog ? (0, $zusVr.consoleSandbox)(()=>beforeSendLog(processedLog)) : processedLog;
    if (!log) {
        client.recordDroppedEvent('before_send', 'log_item', 1);
        (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).warn('beforeSendLog returned null, log will not be captured.');
        return;
    }
    const { level: level, message: message, attributes: attributes = {}, severityNumber: severityNumber } = log;
    const serializedLog = {
        timestamp: (0, $hPkId.timestampInSeconds)(),
        level: level,
        body: message,
        trace_id: traceContext === null || traceContext === void 0 ? void 0 : traceContext.trace_id,
        severity_number: severityNumber !== null && severityNumber !== void 0 ? severityNumber : (0, $15ptf.SEVERITY_TEXT_TO_SEVERITY_NUMBER)[level],
        attributes: Object.keys(attributes).reduce((acc, key)=>{
            acc[key] = $5d84548b97f08e99$export$84cb46f4adfc5d14(attributes[key]);
            return acc;
        }, {})
    };
    captureSerializedLog(client, serializedLog);
    client.emit('afterCaptureLog', log);
}
/**
 * Flushes the logs buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeLogBuffer - A log buffer. Uses the log buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $5d84548b97f08e99$export$f8ed83d3b6a0b504(client, maybeLogBuffer) {
    var _ref;
    const logBuffer = (_ref = maybeLogBuffer !== null && maybeLogBuffer !== void 0 ? maybeLogBuffer : $5d84548b97f08e99$export$5365c9902fb9e770(client)) !== null && _ref !== void 0 ? _ref : [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $ipbPZ.createLogEnvelope)(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn());
    // Clear the log buffer after envelopes have been constructed.
    $5d84548b97f08e99$var$_getBufferMap().set(client, []);
    client.emit('flushLogs');
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}
/**
 * Returns the log buffer for a given client.
 *
 * Exported for testing purposes.
 *
 * @param client - The client to get the log buffer for.
 * @returns The log buffer for the given client.
 */ function $5d84548b97f08e99$export$5365c9902fb9e770(client) {
    return $5d84548b97f08e99$var$_getBufferMap().get(client);
}
/**
 * Get the scope data for the current scope after merging with the
 * global scope and isolation scope.
 *
 * @param currentScope - The current scope.
 * @returns The scope data.
 */ function $5d84548b97f08e99$var$getMergedScopeData(currentScope) {
    const scopeData = (0, $d5d01.getGlobalScope)().getScopeData();
    (0, $3mkPr.mergeScopeData)(scopeData, (0, $d5d01.getIsolationScope)().getScopeData());
    (0, $3mkPr.mergeScopeData)(scopeData, currentScope.getScopeData());
    return scopeData;
}
function $5d84548b97f08e99$var$_getBufferMap() {
    // The reference to the Client <> LogBuffer map is stored on the carrier to ensure it's always the same
    return (0, $9cBYA.getGlobalSingleton)('clientToLogBufferMap', ()=>new WeakMap());
}

});
parcelRegister("ijU2C", function(module, exports) {

$parcel$export(module.exports, "Client", function () { return $d56578f9537391b5$export$1f2bb630327ac4b6; });
$parcel$export(module.exports, "_getTraceInfoFromScope", function () { return $d56578f9537391b5$export$fb7d833b3fdedf5f; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $fJ442 = parcelRequire("fJ442");

var $5gR0A = parcelRequire("5gR0A");

var $d5d01 = parcelRequire("d5d01");

var $euQAQ = parcelRequire("euQAQ");

var $lK8rM = parcelRequire("lK8rM");

var $Fmb4Q = parcelRequire("Fmb4Q");

var $81R8A = parcelRequire("81R8A");

var $eNSK5 = parcelRequire("eNSK5");

var $hOUjO = parcelRequire("hOUjO");

var $hABGa = parcelRequire("hABGa");

var $e0SvR = parcelRequire("e0SvR");

var $6LSad = parcelRequire("6LSad");

var $brfue = parcelRequire("brfue");

var $zusVr = parcelRequire("zusVr");

var $lrI6i = parcelRequire("lrI6i");

var $38AjJ = parcelRequire("38AjJ");

var $1TvTJ = parcelRequire("1TvTJ");

var $9NNss = parcelRequire("9NNss");

var $lN5CN = parcelRequire("lN5CN");

var $f3a5J = parcelRequire("f3a5J");

var $liI4o = parcelRequire("liI4o");
/* eslint-disable max-lines */ const $d56578f9537391b5$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $d56578f9537391b5$var$MISSING_RELEASE_FOR_SESSION_ERROR = 'Discarded session because of missing or non-string release';
const $d56578f9537391b5$var$INTERNAL_ERROR_SYMBOL = Symbol.for('SentryInternalError');
const $d56578f9537391b5$var$DO_NOT_SEND_EVENT_SYMBOL = Symbol.for('SentryDoNotSendEventError');
function $d56578f9537391b5$var$_makeInternalError(message) {
    return {
        message: message,
        [$d56578f9537391b5$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $d56578f9537391b5$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$d56578f9537391b5$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $d56578f9537391b5$var$_isInternalError(error) {
    return !!error && typeof error === 'object' && $d56578f9537391b5$var$INTERNAL_ERROR_SYMBOL in error;
}
function $d56578f9537391b5$var$_isDoNotSendEventError(error) {
    return !!error && typeof error === 'object' && $d56578f9537391b5$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link Client._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends Client<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $d56578f9537391b5$export$1f2bb630327ac4b6 {
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = (0, $38AjJ.uuid4)();
        // ensure we haven't captured this very object before
        if ((0, $38AjJ.checkOrSetAlreadyCaught)(exception)) {
            (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).log($d56578f9537391b5$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = (0, $1Fos3._)({
            event_id: eventId
        }, hint);
        this._process(this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = (0, $1Fos3._)({
            event_id: (0, $38AjJ.uuid4)()
        }, hint);
        const eventMessage = (0, $brfue.isParameterizedString)(message) ? message : String(message);
        const promisedEvent = (0, $brfue.isPrimitive)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $38AjJ.uuid4)();
        // ensure we haven't captured this very object before
        if ((hint === null || hint === void 0 ? void 0 : hint.originalException) && (0, $38AjJ.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).log($d56578f9537391b5$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = (0, $1Fos3._)({
            event_id: eventId
        }, hint);
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session) {
        this.sendSession(session);
        // After sending, we set init false to indicate it's not the first occurrence
        (0, $81R8A.updateSession)(session, {
            init: false
        });
    }
    /**
   * Create a cron monitor check in and send it to Sentry. This method is not available on all clients.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   * @param scope An optional scope containing event metadata.
   * @returns A string representing the id of the check in.
   */ /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            this.emit('flush');
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $f3a5J.resolvedSyncPromise)(true);
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            this.emit('close');
            return result;
        });
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith('Spotlight'))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $Fmb4Q.setupIntegration)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $Fmb4Q.afterSetupIntegrations)(this, [
            integration
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $lK8rM.createEventEnvelope)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $e0SvR.addItemToEnvelope)(env, (0, $e0SvR.createAttachmentEnvelopeItem)(attachment));
        const promise = this.sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        // Backfill release and environment on session
        const { release: clientReleaseOption, environment: clientEnvironmentOption = (0, $5gR0A.DEFAULT_ENVIRONMENT) } = this._options;
        if ('aggregates' in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).warn($d56578f9537391b5$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).warn($d56578f9537391b5$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit('beforeSendSession', session);
        const env = (0, $lK8rM.createSessionEnvelope)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /* eslint-disable @typescript-eslint/unified-signatures */ /**
   * Register a callback for whenever a span is started.
   * Receives the span as argument.
   * @returns {() => void} A function that, when executed, removes the registered callback.
   */ /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hooks = this._hooks[hook] = this._hooks[hook] || [];
        // @ts-expect-error We assume the types are correct
        hooks.push(callback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            // @ts-expect-error We assume the types are correct
            const cbIndex = hooks.indexOf(callback);
            if (cbIndex > -1) hooks.splice(cbIndex, 1);
        };
    }
    /** Fire a hook whenever a span starts. */ /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).error('Error while sending envelope:', reason);
            return reason;
        });
        (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).error('Transport disabled');
        return (0, $f3a5J.resolvedSyncPromise)({});
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $Fmb4Q.setupIntegrations)(this, integrations);
        (0, $Fmb4Q.afterSetupIntegrations)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        var _event_exception;
        let crashed = event.level === 'fatal';
        let errored = false;
        const exceptions = (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : _event_exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if ((mechanism === null || mechanism === void 0 ? void 0 : mechanism.handled) === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $81R8A.updateSession)(session, (0, $b2I6k._)((0, $1Fos3._)({}, crashed && {
                status: 'crashed'
            }), {
                errors: session.errors || Number(errored || crashed)
            }));
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $f3a5J.SyncPromise)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && (integrations === null || integrations === void 0 ? void 0 : integrations.length)) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $9NNss.prepareEvent)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit('postprocessEvent', evt, hint);
            evt.contexts = (0, $1Fos3._)({
                trace: (0, $d5d01.getTraceContextFromScope)(currentScope)
            }, evt.contexts);
            const dynamicSamplingContext = (0, $eNSK5.getDynamicSamplingContextFromScope)(this, currentScope);
            evt.sdkProcessingMetadata = (0, $1Fos3._)({
                dynamicSamplingContext: dynamicSamplingContext
            }, evt.sdkProcessingMetadata);
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = (0, $d5d01.getCurrentScope)(), isolationScope = (0, $d5d01.getIsolationScope)()) {
        if ((0, $euQAQ.DEBUG_BUILD) && $d56578f9537391b5$var$isErrorEvent(event)) (0, $zusVr.debug).log(`Captured error event \`${(0, $6LSad.getPossibleEventMessages)(event)[0] || '<unknown>'}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $euQAQ.DEBUG_BUILD) {
                if ($d56578f9537391b5$var$_isDoNotSendEventError(reason)) (0, $zusVr.debug).log(reason.message);
                else if ($d56578f9537391b5$var$_isInternalError(reason)) (0, $zusVr.debug).warn(reason.message);
                else (0, $zusVr.debug).warn(reason);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $d56578f9537391b5$var$isTransactionEvent(event);
        const isError = $d56578f9537391b5$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === 'undefined' ? undefined : (0, $1TvTJ.parseSampleRate)(sampleRate);
        if (isError && typeof parsedSampleRate === 'number' && Math.random() > parsedSampleRate) {
            this.recordDroppedEvent('sample_rate', 'error');
            return (0, $f3a5J.rejectedSyncPromise)($d56578f9537391b5$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory);
                throw $d56578f9537391b5$var$_makeDoNotSendEventError('An event processor returned `null`, will not send event.');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $d56578f9537391b5$var$processBeforeSend(this, options, prepared, hint);
            return $d56578f9537391b5$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw $d56578f9537391b5$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                var _processedEvent_sdkProcessingMetadata;
                const spanCountBefore = ((_processedEvent_sdkProcessingMetadata = processedEvent.sdkProcessingMetadata) === null || _processedEvent_sdkProcessingMetadata === void 0 ? void 0 : _processedEvent_sdkProcessingMetadata.spanCountBeforeProcessing) || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = (0, $b2I6k._)((0, $1Fos3._)({}, transactionInfo), {
                    source: source
                });
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($d56578f9537391b5$var$_isDoNotSendEventError(reason) || $d56578f9537391b5$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $d56578f9537391b5$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).log('Flushing outcomes...');
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).log('Sending outcomes:', outcomes);
        const envelope = (0, $hOUjO.createClientReportEnvelope)(outcomes, this._options.tunnel && (0, $hABGa.dsnToString)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $hABGa.makeDsn)(options.dsn);
        else (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $fJ442.getEnvelopeEndpointWithUrlEncodedAuth)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport((0, $b2I6k._)((0, $1Fos3._)({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this)
            }, options.transportOptions), {
                url: url
            }));
        }
    }
}
/**
 * @deprecated Use `Client` instead. This alias may be removed in a future major version.
 */ // TODO(v10): Remove
/**
 * @deprecated Use `Client` instead. This alias may be removed in a future major version.
 */ // TODO(v10): Remove
const $d56578f9537391b5$export$4f22f74eddb7716a = $d56578f9537391b5$export$1f2bb630327ac4b6;
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $d56578f9537391b5$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $brfue.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $brfue.isPlainObject)(event) && event !== null) throw $d56578f9537391b5$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $d56578f9537391b5$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $brfue.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw $d56578f9537391b5$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $d56578f9537391b5$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan } = options;
    let processedEvent = event;
    if ($d56578f9537391b5$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($d56578f9537391b5$var$isTransactionEvent(processedEvent)) {
        if (beforeSendSpan) {
            // process root span
            const processedRootSpanJson = beforeSendSpan((0, $liI4o.convertTransactionEventToSpanJson)(processedEvent));
            if (!processedRootSpanJson) (0, $lN5CN.showSpanDropWarning)();
            else // update event with processed root span values
            processedEvent = (0, $lrI6i.merge)(event, (0, $liI4o.convertSpanJsonToTransactionEvent)(processedRootSpanJson));
            // process child spans
            if (processedEvent.spans) {
                const processedSpans = [];
                for (const span of processedEvent.spans){
                    const processedSpan = beforeSendSpan(span);
                    if (!processedSpan) {
                        (0, $lN5CN.showSpanDropWarning)();
                        processedSpans.push(span);
                    } else processedSpans.push(processedSpan);
                }
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = (0, $b2I6k._)((0, $1Fos3._)({}, event.sdkProcessingMetadata), {
                    spanCountBeforeProcessing: spanCountBefore
                });
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $d56578f9537391b5$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $d56578f9537391b5$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/** Extract trace information from scope */ function $d56578f9537391b5$export$fb7d833b3fdedf5f(client, scope) {
    if (!scope) return [
        undefined,
        undefined
    ];
    return (0, $d5d01.withScope)(scope, ()=>{
        const span = (0, $lN5CN.getActiveSpan)();
        const traceContext = span ? (0, $lN5CN.spanToTraceContext)(span) : (0, $d5d01.getTraceContextFromScope)(scope);
        const dynamicSamplingContext = span ? (0, $eNSK5.getDynamicSamplingContextFromSpan)(span) : (0, $eNSK5.getDynamicSamplingContextFromScope)(client, scope);
        return [
            dynamicSamplingContext,
            traceContext
        ];
    });
}

});
parcelRegister("fJ442", function(module, exports) {

$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", function () { return $b72e360e3bb2b30e$export$9964600bfe84e6a3; });

var $hABGa = parcelRequire("hABGa");
const $b72e360e3bb2b30e$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $b72e360e3bb2b30e$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $b72e360e3bb2b30e$var$_getIngestEndpoint(dsn) {
    return `${$b72e360e3bb2b30e$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $b72e360e3bb2b30e$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $b72e360e3bb2b30e$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $b72e360e3bb2b30e$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$b72e360e3bb2b30e$var$_getIngestEndpoint(dsn)}?${$b72e360e3bb2b30e$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $b72e360e3bb2b30e$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $hABGa.makeDsn)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$b72e360e3bb2b30e$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $hABGa.dsnToString)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}

});

parcelRegister("lK8rM", function(module, exports) {

$parcel$export(module.exports, "createSessionEnvelope", function () { return $fd44723db9d71319$export$124b03c077baa2f3; });
$parcel$export(module.exports, "createEventEnvelope", function () { return $fd44723db9d71319$export$c31057337a18010f; });

var $1Fos3 = parcelRequire("1Fos3");

var $eNSK5 = parcelRequire("eNSK5");

var $hABGa = parcelRequire("hABGa");

var $e0SvR = parcelRequire("e0SvR");

var $lN5CN = parcelRequire("lN5CN");
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $fd44723db9d71319$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $fd44723db9d71319$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $e0SvR.getSdkMetadataForEnvelopeHeader)(metadata);
    const envelopeHeaders = (0, $1Fos3._)({
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }, !!tunnel && dsn && {
        dsn: (0, $hABGa.dsnToString)(dsn)
    });
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $e0SvR.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $fd44723db9d71319$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $e0SvR.getSdkMetadataForEnvelopeHeader)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $fd44723db9d71319$var$enhanceEventWithSdkInfo(event, metadata === null || metadata === void 0 ? void 0 : metadata.sdk);
    const envelopeHeaders = (0, $e0SvR.createEventEnvelopeHeaders)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $e0SvR.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $fd44723db9d71319$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $eNSK5.getDynamicSamplingContextFromSpan)(spans[0]);
    const dsn = client === null || client === void 0 ? void 0 : client.getDsn();
    const tunnel = client === null || client === void 0 ? void 0 : client.getOptions().tunnel;
    const headers = (0, $1Fos3._)({
        sent_at: new Date().toISOString()
    }, dscHasRequiredProps(dsc) && {
        trace: dsc
    }, !!tunnel && dsn && {
        dsn: (0, $hABGa.dsnToString)(dsn)
    });
    const beforeSendSpan = client === null || client === void 0 ? void 0 : client.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $lN5CN.spanToJSON)(span);
        const processedSpan = beforeSendSpan(spanJson);
        if (!processedSpan) {
            (0, $lN5CN.showSpanDropWarning)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $lN5CN.spanToJSON);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $e0SvR.createSpanEnvelopeItem)(spanJson));
    }
    return (0, $e0SvR.createEnvelope)(headers, items);
}

});
parcelRegister("e0SvR", function(module, exports) {

$parcel$export(module.exports, "createEnvelope", function () { return $a33b59e850b33688$export$f93f7f385160c44e; });
$parcel$export(module.exports, "addItemToEnvelope", function () { return $a33b59e850b33688$export$d650323442802f6f; });
$parcel$export(module.exports, "forEachEnvelopeItem", function () { return $a33b59e850b33688$export$c56c55acf0136fd3; });
$parcel$export(module.exports, "serializeEnvelope", function () { return $a33b59e850b33688$export$32f9b428425aac85; });
$parcel$export(module.exports, "createSpanEnvelopeItem", function () { return $a33b59e850b33688$export$655cf139bc8b8afd; });
$parcel$export(module.exports, "createAttachmentEnvelopeItem", function () { return $a33b59e850b33688$export$d8fc80952cc31fa4; });
$parcel$export(module.exports, "envelopeItemTypeToDataCategory", function () { return $a33b59e850b33688$export$b11169581eeaf237; });
$parcel$export(module.exports, "getSdkMetadataForEnvelopeHeader", function () { return $a33b59e850b33688$export$d369f3b2758f6743; });
$parcel$export(module.exports, "createEventEnvelopeHeaders", function () { return $a33b59e850b33688$export$92b6093782fe661b; });

var $1Fos3 = parcelRequire("1Fos3");

var $9cBYA = parcelRequire("9cBYA");

var $hABGa = parcelRequire("hABGa");

var $kmom1 = parcelRequire("kmom1");

var $6ZThC = parcelRequire("6ZThC");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $a33b59e850b33688$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $a33b59e850b33688$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $a33b59e850b33688$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $a33b59e850b33688$export$604a45d95a155e2b(envelope, types) {
    return $a33b59e850b33688$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $a33b59e850b33688$var$encodeUTF8(input) {
    const carrier = (0, $9cBYA.getSentryCarrier)((0, $6ZThC.GLOBAL_OBJ));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $a33b59e850b33688$var$decodeUTF8(input) {
    const carrier = (0, $9cBYA.getSentryCarrier)((0, $6ZThC.GLOBAL_OBJ));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $a33b59e850b33688$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $a33b59e850b33688$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === 'string' ? $a33b59e850b33688$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $kmom1.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $a33b59e850b33688$var$concatBuffers(parts);
}
function $a33b59e850b33688$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $a33b59e850b33688$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === 'string' ? $a33b59e850b33688$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($a33b59e850b33688$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $a33b59e850b33688$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $a33b59e850b33688$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === 'string' ? $a33b59e850b33688$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $a33b59e850b33688$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    profile_chunk: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    raw_security: 'security',
    log: 'log_item'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $a33b59e850b33688$export$b11169581eeaf237(type) {
    return $a33b59e850b33688$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $a33b59e850b33688$export$d369f3b2758f6743(metadataOrEvent) {
    if (!(metadataOrEvent === null || metadataOrEvent === void 0 ? void 0 : metadataOrEvent.sdk)) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $a33b59e850b33688$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    var _event_sdkProcessingMetadata;
    const dynamicSamplingContext = (_event_sdkProcessingMetadata = event.sdkProcessingMetadata) === null || _event_sdkProcessingMetadata === void 0 ? void 0 : _event_sdkProcessingMetadata.dynamicSamplingContext;
    return (0, $1Fos3._)({
        event_id: event.event_id,
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }, !!tunnel && dsn && {
        dsn: (0, $hABGa.dsnToString)(dsn)
    }, dynamicSamplingContext && {
        trace: dynamicSamplingContext
    });
}

});


parcelRegister("hOUjO", function(module, exports) {

$parcel$export(module.exports, "createClientReportEnvelope", function () { return $cf92cae417ba115b$export$f3b9ed77c03eeb00; });

var $e0SvR = parcelRequire("e0SvR");

var $hPkId = parcelRequire("hPkId");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $cf92cae417ba115b$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $hPkId.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $e0SvR.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("liI4o", function(module, exports) {

$parcel$export(module.exports, "convertTransactionEventToSpanJson", function () { return $f81d76c5418f15fc$export$d9c6b2464b0a687e; });
$parcel$export(module.exports, "convertSpanJsonToTransactionEvent", function () { return $f81d76c5418f15fc$export$f2d8fce5ae150e92; });

var $1Fos3 = parcelRequire("1Fos3");

var $cdgd4 = parcelRequire("cdgd4");
/**
 * Converts a transaction event to a span JSON object.
 */ function $f81d76c5418f15fc$export$d9c6b2464b0a687e(event) {
    var _event_contexts;
    var _event_contexts_trace;
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = (_event_contexts_trace = (_event_contexts = event.contexts) === null || _event_contexts === void 0 ? void 0 : _event_contexts.trace) !== null && _event_contexts_trace !== void 0 ? _event_contexts_trace : {};
    var _event_start_timestamp;
    return {
        data: data !== null && data !== void 0 ? data : {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id !== null && span_id !== void 0 ? span_id : '',
        start_timestamp: (_event_start_timestamp = event.start_timestamp) !== null && _event_start_timestamp !== void 0 ? _event_start_timestamp : 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id !== null && trace_id !== void 0 ? trace_id : '',
        origin: origin,
        profile_id: data === null || data === void 0 ? void 0 : data[0, $cdgd4.SEMANTIC_ATTRIBUTE_PROFILE_ID],
        exclusive_time: data === null || data === void 0 ? void 0 : data[0, $cdgd4.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
        measurements: event.measurements,
        is_segment: true
    };
}
/**
 * Converts a span JSON object to a transaction event.
 */ function $f81d76c5418f15fc$export$f2d8fce5ae150e92(span) {
    return {
        type: 'transaction',
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: (0, $1Fos3._)({}, span.data, span.profile_id && {
                    [(0, $cdgd4.SEMANTIC_ATTRIBUTE_PROFILE_ID)]: span.profile_id
                }, span.exclusive_time && {
                    [(0, $cdgd4.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME)]: span.exclusive_time
                })
            }
        },
        measurements: span.measurements
    };
}

});


parcelRegister("15ptf", function(module, exports) {

$parcel$export(module.exports, "SEVERITY_TEXT_TO_SEVERITY_NUMBER", function () { return $0caa0408f14d8e49$export$4fb50c0840d636d1; });
/**
 * Maps a log severity level to a log severity number.
 *
 * @see LogSeverityLevel
 */ const $0caa0408f14d8e49$export$4fb50c0840d636d1 = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};

});

parcelRegister("ipbPZ", function(module, exports) {

$parcel$export(module.exports, "createLogEnvelope", function () { return $d663be804f8f8cf7$export$cdcd668e6516443f; });

var $hABGa = parcelRequire("hABGa");

var $e0SvR = parcelRequire("e0SvR");
/**
 * Creates a log container envelope item for a list of logs.
 *
 * @param items - The logs to include in the envelope.
 * @returns The created log container envelope item.
 */ function $d663be804f8f8cf7$export$efdf3b13edb1118e(items) {
    return [
        {
            type: 'log',
            item_count: items.length,
            content_type: 'application/vnd.sentry.items.log+json'
        },
        {
            items: items
        }
    ];
}
/**
 * Creates an envelope for a list of logs.
 *
 * Logs from multiple traces can be included in the same envelope.
 *
 * @param logs - The logs to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @returns The created envelope.
 */ function $d663be804f8f8cf7$export$cdcd668e6516443f(logs, metadata, tunnel, dsn) {
    const headers = {};
    if (metadata === null || metadata === void 0 ? void 0 : metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $hABGa.dsnToString)(dsn);
    return (0, $e0SvR.createEnvelope)(headers, [
        $d663be804f8f8cf7$export$efdf3b13edb1118e(logs)
    ]);
}

});


parcelRegister("8hqrR", function(module, exports) {

$parcel$export(module.exports, "addAutoIpAddressToUser", function () { return $60746d583012287e$export$3e12ad68afa434ac; });
$parcel$export(module.exports, "addAutoIpAddressToSession", function () { return $60746d583012287e$export$e8e2d07ba63e2b6c; });
// By default, we want to infer the IP address, unless this is explicitly set to `null`
// We do this after all other processing is done
// If `ip_address` is explicitly set to `null` or a value, we leave it as is
/**
 * @internal
 */ 
var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");
function $60746d583012287e$export$3e12ad68afa434ac(objWithMaybeUser) {
    var _objWithMaybeUser_user;
    if (((_objWithMaybeUser_user = objWithMaybeUser.user) === null || _objWithMaybeUser_user === void 0 ? void 0 : _objWithMaybeUser_user.ip_address) === undefined) objWithMaybeUser.user = (0, $b2I6k._)((0, $1Fos3._)({}, objWithMaybeUser.user), {
        ip_address: '{{auto}}'
    });
}
/**
 * @internal
 */ function $60746d583012287e$export$e8e2d07ba63e2b6c(session) {
    var _session_attrs;
    if ('aggregates' in session) {
        if (((_session_attrs = session.attrs) === null || _session_attrs === void 0 ? void 0 : _session_attrs['ip_address']) === undefined) session.attrs = (0, $b2I6k._)((0, $1Fos3._)({}, session.attrs), {
            ip_address: '{{auto}}'
        });
    } else if (session.ipAddress === undefined) session.ipAddress = '{{auto}}';
}

});

parcelRegister("69Azg", function(module, exports) {

$parcel$export(module.exports, "applySdkMetadata", function () { return $47aff2ec8fdb2bba$export$b9f95b027256052c; });

var $j5O51 = parcelRequire("j5O51");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $47aff2ec8fdb2bba$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $j5O51.SDK_VERSION)
            })),
        version: (0, $j5O51.SDK_VERSION)
    };
    options._metadata = metadata;
}

});

parcelRegister("jMfG5", function(module, exports) {

$parcel$export(module.exports, "getSDKSource", function () { return $e65ea94ce9cabf03$export$8ad33f488b1ab046; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `debug` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $e65ea94ce9cabf03$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $e65ea94ce9cabf03$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return 'npm';
}

});

parcelRegister("jiEIw", function(module, exports) {

$parcel$export(module.exports, "exceptionFromError", function () { return $e0cf4855ee200dc2$export$a6c2d27607295951; });
$parcel$export(module.exports, "eventFromException", function () { return $e0cf4855ee200dc2$export$ea3ec7e569b823fc; });
$parcel$export(module.exports, "eventFromUnknownInput", function () { return $e0cf4855ee200dc2$export$9dd56ed1ef0c3420; });
$parcel$export(module.exports, "eventFromMessage", function () { return $e0cf4855ee200dc2$export$5425b53185d13d6c; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $38AjJ = parcelRequire("38AjJ");
var $aVCF4 = parcelRequire("aVCF4");
var $d5d01 = parcelRequire("d5d01");
var $brfue = parcelRequire("brfue");
var $kmom1 = parcelRequire("kmom1");
var $f3a5J = parcelRequire("f3a5J");
/**
 * This function creates an exception from a JavaScript Error
 */ function $e0cf4855ee200dc2$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $e0cf4855ee200dc2$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $e0cf4855ee200dc2$export$2e9ae379995d99e3(ex),
        value: $e0cf4855ee200dc2$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $e0cf4855ee200dc2$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $d5d01.getClient)();
    const normalizeDepth = client === null || client === void 0 ? void 0 : client.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $e0cf4855ee200dc2$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $kmom1.normalizeToSize)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $e0cf4855ee200dc2$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $brfue.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $e0cf4855ee200dc2$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $e0cf4855ee200dc2$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $e0cf4855ee200dc2$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $e0cf4855ee200dc2$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $e0cf4855ee200dc2$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const skipLines = $e0cf4855ee200dc2$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $e0cf4855ee200dc2$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $e0cf4855ee200dc2$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $e0cf4855ee200dc2$var$getSkipFirstStackStringLines(ex) {
    if (ex && $e0cf4855ee200dc2$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $e0cf4855ee200dc2$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === 'number') return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $e0cf4855ee200dc2$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    if (typeof WebAssembly !== 'undefined' && typeof WebAssembly.Exception !== 'undefined') // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $e0cf4855ee200dc2$export$2e9ae379995d99e3(ex) {
    const name = ex === null || ex === void 0 ? void 0 : ex.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $e0cf4855ee200dc2$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : 'WebAssembly.Exception';
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $e0cf4855ee200dc2$export$86005d1b62804363(ex) {
    const message = ex === null || ex === void 0 ? void 0 : ex.message;
    if ($e0cf4855ee200dc2$var$isWebAssemblyException(ex)) {
        // For Node 18, Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return 'wasm exception';
    }
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $e0cf4855ee200dc2$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = (hint === null || hint === void 0 ? void 0 : hint.syntheticException) || undefined;
    const event = $e0cf4855ee200dc2$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $38AjJ.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint === null || hint === void 0 ? void 0 : hint.event_id) event.event_id = hint.event_id;
    return (0, $f3a5J.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $e0cf4855ee200dc2$export$5425b53185d13d6c(stackParser, message, level = 'info', hint, attachStacktrace) {
    const syntheticException = (hint === null || hint === void 0 ? void 0 : hint.syntheticException) || undefined;
    const event = $e0cf4855ee200dc2$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint === null || hint === void 0 ? void 0 : hint.event_id) event.event_id = hint.event_id;
    return (0, $f3a5J.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $e0cf4855ee200dc2$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $brfue.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $e0cf4855ee200dc2$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $brfue.isDOMError)(exception) || (0, $brfue.isDOMException)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $e0cf4855ee200dc2$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $brfue.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $e0cf4855ee200dc2$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $38AjJ.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = (0, $b2I6k._)((0, $1Fos3._)({}, event.tags), {
            'DOMException.code': `${domException.code}`
        });
        return event;
    }
    if ((0, $brfue.isError)(exception)) // we have a real Error object, do nothing
    return $e0cf4855ee200dc2$var$eventFromError(stackParser, exception);
    if ((0, $brfue.isPlainObject)(exception) || (0, $brfue.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $e0cf4855ee200dc2$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $38AjJ.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $e0cf4855ee200dc2$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $38AjJ.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $38AjJ.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $e0cf4855ee200dc2$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $e0cf4855ee200dc2$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $38AjJ.addExceptionMechanism)(event, {
            synthetic: true
        });
    }
    if ((0, $brfue.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $e0cf4855ee200dc2$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $aVCF4.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $brfue.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $brfue.isEvent)(exception)) {
        const className = $e0cf4855ee200dc2$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $e0cf4855ee200dc2$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $e0cf4855ee200dc2$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}

});

parcelRegister("hFw8s", function(module, exports) {

$parcel$export(module.exports, "WINDOW", function () { return $cdcf316b11a0666c$export$56d8a8a25bd48b81; });
$parcel$export(module.exports, "shouldIgnoreOnError", function () { return $cdcf316b11a0666c$export$b79738ab10c590b2; });
$parcel$export(module.exports, "wrap", function () { return $cdcf316b11a0666c$export$4997ffc0176396a6; });
$parcel$export(module.exports, "getHttpRequestData", function () { return $cdcf316b11a0666c$export$a3c4a8453e8936f0; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $38AjJ = parcelRequire("38AjJ");
var $aVCF4 = parcelRequire("aVCF4");
var $2BjBt = parcelRequire("2BjBt");
var $eqzQm = parcelRequire("eqzQm");
var $6ZThC = parcelRequire("6ZThC");
var $d5d01 = parcelRequire("d5d01");
const $cdcf316b11a0666c$export$56d8a8a25bd48b81 = (0, $6ZThC.GLOBAL_OBJ);
let $cdcf316b11a0666c$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $cdcf316b11a0666c$export$b79738ab10c590b2() {
    return $cdcf316b11a0666c$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $cdcf316b11a0666c$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $cdcf316b11a0666c$var$ignoreOnError++;
    setTimeout(()=>{
        $cdcf316b11a0666c$var$ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $cdcf316b11a0666c$export$4997ffc0176396a6(fn, options = {}) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === 'function';
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $aVCF4.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function(...args) {
        try {
            // Also wrap arguments that are themselves functions
            const wrappedArguments = args.map((arg)=>$cdcf316b11a0666c$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $cdcf316b11a0666c$export$1265a142ff5ba165();
            (0, $d5d01.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $38AjJ.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $38AjJ.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = (0, $b2I6k._)((0, $1Fos3._)({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                (0, $2BjBt.captureException)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (e) {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $aVCF4.markFunctionWrapped)(sentryWrapped, fn);
    (0, $aVCF4.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    } catch (e) {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}
/**
 * Get HTTP request data from the current page.
 */ function $cdcf316b11a0666c$export$a3c4a8453e8936f0() {
    // grab as much info as exists and add it to the event
    const url = (0, $eqzQm.getLocationHref)();
    const { referrer: referrer } = $cdcf316b11a0666c$export$56d8a8a25bd48b81.document || {};
    const { userAgent: userAgent } = $cdcf316b11a0666c$export$56d8a8a25bd48b81.navigator || {};
    const headers = (0, $1Fos3._)({}, referrer && {
        Referer: referrer
    }, userAgent && {
        'User-Agent': userAgent
    });
    const request = {
        url: url,
        headers: headers
    };
    return request;
}

});


parcelRegister("cd6Zb", function(module, exports) {

$parcel$export(module.exports, "breadcrumbsIntegration", function () { return $8e3c1e29159a2b15$export$c079d904b326663a; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $49xsF = parcelRequire("49xsF");
var $7ORaH = parcelRequire("7ORaH");
var $ivYh7 = parcelRequire("ivYh7");
var $Fmb4Q = parcelRequire("Fmb4Q");
var $1l081 = parcelRequire("1l081");
var $d5d01 = parcelRequire("d5d01");
var $eqzQm = parcelRequire("eqzQm");
var $38AjJ = parcelRequire("38AjJ");
var $zusVr = parcelRequire("zusVr");
var $ioL28 = parcelRequire("ioL28");
var $38VNK = parcelRequire("38VNK");
var $fMscJ = parcelRequire("fMscJ");

var $a4Xi1 = parcelRequire("a4Xi1");
var $8tNX9 = parcelRequire("8tNX9");
var $3Cb1o = parcelRequire("3Cb1o");

var $ePNNA = parcelRequire("ePNNA");

var $hFw8s = parcelRequire("hFw8s");
/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $8e3c1e29159a2b15$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $8e3c1e29159a2b15$var$INTEGRATION_NAME = 'Breadcrumbs';
const $8e3c1e29159a2b15$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = (0, $1Fos3._)({
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true
    }, options);
    return {
        name: $8e3c1e29159a2b15$var$INTEGRATION_NAME,
        setup (client) {
            // TODO(v10): Remove this functionality and use `consoleIntegration` from @sentry/core instead.
            if (_options.console) (0, $7ORaH.addConsoleInstrumentationHandler)($8e3c1e29159a2b15$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $a4Xi1.addClickKeypressInstrumentationHandler)($8e3c1e29159a2b15$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $3Cb1o.addXhrInstrumentationHandler)($8e3c1e29159a2b15$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $ivYh7.addFetchInstrumentationHandler)($8e3c1e29159a2b15$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $8tNX9.addHistoryInstrumentationHandler)($8e3c1e29159a2b15$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on('beforeSendEvent', $8e3c1e29159a2b15$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $8e3c1e29159a2b15$export$c079d904b326663a = (0, $Fmb4Q.defineIntegration)($8e3c1e29159a2b15$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $8e3c1e29159a2b15$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $d5d01.getClient)() !== client) return;
        (0, $49xsF.addBreadcrumb)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $38AjJ.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $8e3c1e29159a2b15$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $d5d01.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $8e3c1e29159a2b15$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $ePNNA.DEBUG_BUILD) && (0, $zusVr.logger).warn(`\`dom.maxStringLength\` cannot exceed ${$8e3c1e29159a2b15$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$8e3c1e29159a2b15$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $8e3c1e29159a2b15$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $8e3c1e29159a2b15$var$_isEvent(event) ? event.target : event;
            target = (0, $eqzQm.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $eqzQm.getComponentName)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $49xsF.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $8e3c1e29159a2b15$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $d5d01.getClient)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $fMscJ.severityLevelFromString)(handlerData.level),
            message: (0, $38VNK.safeJoin)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $38VNK.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $49xsF.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $8e3c1e29159a2b15$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $d5d01.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $3Cb1o.SENTRY_XHR_DATA_KEY];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: 'xhr',
            data: data,
            type: 'http',
            level: (0, $1l081.getBreadcrumbLogLevelFromHttpStatusCode)(status_code)
        };
        client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
        (0, $49xsF.addBreadcrumb)(breadcrumb, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $8e3c1e29159a2b15$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $d5d01.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        handlerData.fetchData.method, handlerData.fetchData.url;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $49xsF.addBreadcrumb)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = (0, $b2I6k._)((0, $1Fos3._)({}, handlerData.fetchData), {
                status_code: response === null || response === void 0 ? void 0 : response.status
            });
            handlerData.fetchData.request_body_size;
            handlerData.fetchData.response_body_size;
            response === null || response === void 0 ? void 0 : response.status;
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                type: 'http',
                level: (0, $1l081.getBreadcrumbLogLevelFromHttpStatusCode)(data.status_code)
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $49xsF.addBreadcrumb)(breadcrumb, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $8e3c1e29159a2b15$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $d5d01.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $ioL28.parseUrl)((0, $hFw8s.WINDOW).location.href);
        let parsedFrom = from ? (0, $ioL28.parseUrl)(from) : undefined;
        const parsedTo = (0, $ioL28.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!(parsedFrom === null || parsedFrom === void 0 ? void 0 : parsedFrom.path)) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $49xsF.addBreadcrumb)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $8e3c1e29159a2b15$var$_isEvent(event) {
    return !!event && !!event.target;
}

});
parcelRegister("7ORaH", function(module, exports) {

$parcel$export(module.exports, "addConsoleInstrumentationHandler", function () { return $5b1672b01907e907$export$1d6e0d073f9e6723; });

var $zusVr = parcelRequire("zusVr");

var $aVCF4 = parcelRequire("aVCF4");

var $6ZThC = parcelRequire("6ZThC");

var $9wMZt = parcelRequire("9wMZt");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $5b1672b01907e907$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $9wMZt.addHandler)(type, handler);
    (0, $9wMZt.maybeInstrument)(type, $5b1672b01907e907$var$instrumentConsole);
}
function $5b1672b01907e907$var$instrumentConsole() {
    if (!('console' in (0, $6ZThC.GLOBAL_OBJ))) return;
    (0, $zusVr.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $6ZThC.GLOBAL_OBJ).console)) return;
        (0, $aVCF4.fill)((0, $6ZThC.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $zusVr.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $9wMZt.triggerHandlers)('console', handlerData);
                const log = (0, $zusVr.originalConsoleMethods)[level];
                log === null || log === void 0 ? void 0 : log.apply((0, $6ZThC.GLOBAL_OBJ).console, args);
            };
        });
    });
}

});
parcelRegister("9wMZt", function(module, exports) {

$parcel$export(module.exports, "addHandler", function () { return $6efd1abc2cc0b348$export$a4e09611e30da72e; });
$parcel$export(module.exports, "maybeInstrument", function () { return $6efd1abc2cc0b348$export$e18d6c5462c01368; });
$parcel$export(module.exports, "triggerHandlers", function () { return $6efd1abc2cc0b348$export$b18c893e424d3127; });

var $euQAQ = parcelRequire("euQAQ");

var $zusVr = parcelRequire("zusVr");

var $cvueN = parcelRequire("cvueN");
// We keep the handlers globally
const $6efd1abc2cc0b348$var$handlers = {};
const $6efd1abc2cc0b348$var$instrumented = {};
/** Add a handler function. */ function $6efd1abc2cc0b348$export$a4e09611e30da72e(type, handler) {
    $6efd1abc2cc0b348$var$handlers[type] = $6efd1abc2cc0b348$var$handlers[type] || [];
    $6efd1abc2cc0b348$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $6efd1abc2cc0b348$export$b17eab759a1cb5fe() {
    Object.keys($6efd1abc2cc0b348$var$handlers).forEach((key)=>{
        $6efd1abc2cc0b348$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $6efd1abc2cc0b348$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$6efd1abc2cc0b348$var$instrumented[type]) {
        $6efd1abc2cc0b348$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $6efd1abc2cc0b348$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $6efd1abc2cc0b348$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $cvueN.getFunctionName)(handler)}\nError:`, e);
    }
}

});


parcelRegister("ivYh7", function(module, exports) {

$parcel$export(module.exports, "addFetchInstrumentationHandler", function () { return $d7a9e0a217c1b087$export$f75d3c772c923df0; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $brfue = parcelRequire("brfue");

var $aVCF4 = parcelRequire("aVCF4");

var $erx9x = parcelRequire("erx9x");

var $hPkId = parcelRequire("hPkId");

var $6ZThC = parcelRequire("6ZThC");

var $9wMZt = parcelRequire("9wMZt");
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $d7a9e0a217c1b087$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = 'fetch';
    (0, $9wMZt.addHandler)(type, handler);
    (0, $9wMZt.maybeInstrument)(type, ()=>$d7a9e0a217c1b087$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $d7a9e0a217c1b087$export$1a79663eb318fe6a(handler) {
    const type = 'fetch-body-resolved';
    (0, $9wMZt.addHandler)(type, handler);
    (0, $9wMZt.maybeInstrument)(type, ()=>$d7a9e0a217c1b087$var$instrumentFetch($d7a9e0a217c1b087$var$streamHandler));
}
function $d7a9e0a217c1b087$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $erx9x.supportsNativeFetch)()) return;
    (0, $aVCF4.fill)((0, $6ZThC.GLOBAL_OBJ), 'fetch', function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method: method, url: url } = $d7a9e0a217c1b087$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $hPkId.timestampInSeconds)() * 1000,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $d7a9e0a217c1b087$var$getHeadersFromFetchArgs(args)
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $9wMZt.triggerHandlers)('fetch', (0, $1Fos3._)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $6ZThC.GLOBAL_OBJ), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $9wMZt.triggerHandlers)('fetch', (0, $b2I6k._)((0, $1Fos3._)({}, handlerData), {
                    endTimestamp: (0, $hPkId.timestampInSeconds)() * 1000,
                    response: response
                }));
                return response;
            }, (error)=>{
                (0, $9wMZt.triggerHandlers)('fetch', (0, $b2I6k._)((0, $1Fos3._)({}, handlerData), {
                    endTimestamp: (0, $hPkId.timestampInSeconds)() * 1000,
                    error: error
                }));
                if ((0, $brfue.isError)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    (0, $aVCF4.addNonEnumerableProperty)(error, 'framesToPop', 1);
                }
                // We enhance the not-so-helpful "Failed to fetch" error messages with the host
                // Possible messages we handle here:
                // * "Failed to fetch" (chromium)
                // * "Load failed" (webkit)
                // * "NetworkError when attempting to fetch resource." (firefox)
                if (error instanceof TypeError && (error.message === 'Failed to fetch' || error.message === 'Load failed' || error.message === 'NetworkError when attempting to fetch resource.')) try {
                    const url = new URL(handlerData.fetchData.url);
                    error.message = `${error.message} (${url.host})`;
                } catch (e) {
                // ignore it if errors happen here
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $d7a9e0a217c1b087$var$resolveResponse(res, onFinishedResolving) {
    if (res === null || res === void 0 ? void 0 : res.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch (error) {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $d7a9e0a217c1b087$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch (e) {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $d7a9e0a217c1b087$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $9wMZt.triggerHandlers)('fetch-body-resolved', {
            endTimestamp: (0, $hPkId.timestampInSeconds)() * 1000,
            response: response
        });
    });
}
function $d7a9e0a217c1b087$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $d7a9e0a217c1b087$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($d7a9e0a217c1b087$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $d7a9e0a217c1b087$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $d7a9e0a217c1b087$var$getUrlFromResource(url),
            method: $d7a9e0a217c1b087$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $d7a9e0a217c1b087$var$getUrlFromResource(arg),
        method: $d7a9e0a217c1b087$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}
function $d7a9e0a217c1b087$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === 'object' && optionsArgument !== null && 'headers' in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, $brfue.isRequest)(requestArgument)) return new Headers(requestArgument.headers);
    } catch (e) {
    // noop
    }
    return;
}

});
parcelRegister("erx9x", function(module, exports) {

$parcel$export(module.exports, "supportsHistory", function () { return $a83d4dc5e6f4c0f0$export$67fc34576016d6ec; });
$parcel$export(module.exports, "isNativeFunction", function () { return $a83d4dc5e6f4c0f0$export$d5f608b368e73f38; });
$parcel$export(module.exports, "supportsNativeFetch", function () { return $a83d4dc5e6f4c0f0$export$c82d238e23c40b21; });

var $euQAQ = parcelRequire("euQAQ");

var $zusVr = parcelRequire("zusVr");

var $6ZThC = parcelRequire("6ZThC");
const $a83d4dc5e6f4c0f0$var$WINDOW = (0, $6ZThC.GLOBAL_OBJ);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $a83d4dc5e6f4c0f0$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $a83d4dc5e6f4c0f0$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $a83d4dc5e6f4c0f0$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $a83d4dc5e6f4c0f0$export$67fc34576016d6ec() {
    return 'history' in $a83d4dc5e6f4c0f0$var$WINDOW && !!$a83d4dc5e6f4c0f0$var$WINDOW.history;
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ const $a83d4dc5e6f4c0f0$export$edf3cb81fd7d2a3e = $a83d4dc5e6f4c0f0$var$_isFetchSupported;
function $a83d4dc5e6f4c0f0$var$_isFetchSupported() {
    if (!('fetch' in $a83d4dc5e6f4c0f0$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $a83d4dc5e6f4c0f0$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $a83d4dc5e6f4c0f0$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$a83d4dc5e6f4c0f0$var$_isFetchSupported()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($a83d4dc5e6f4c0f0$export$d5f608b368e73f38($a83d4dc5e6f4c0f0$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $a83d4dc5e6f4c0f0$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        var _sandbox_contentWindow;
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if ((_sandbox_contentWindow = sandbox.contentWindow) === null || _sandbox_contentWindow === void 0 ? void 0 : _sandbox_contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $a83d4dc5e6f4c0f0$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $a83d4dc5e6f4c0f0$export$531055a6c684a70a() {
    return 'ReportingObserver' in $a83d4dc5e6f4c0f0$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ function $a83d4dc5e6f4c0f0$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$a83d4dc5e6f4c0f0$var$_isFetchSupported()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}

});


parcelRegister("1l081", function(module, exports) {

$parcel$export(module.exports, "getBreadcrumbLogLevelFromHttpStatusCode", function () { return $0f97da1f560e42fa$export$b8cfcc4175694bcc; });
/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $0f97da1f560e42fa$export$b8cfcc4175694bcc(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return 'warning';
    else if (statusCode >= 500) return 'error';
    else return undefined;
}

});

parcelRegister("ioL28", function(module, exports) {

$parcel$export(module.exports, "parseUrl", function () { return $d64ef3bb4a9e9003$export$7a5253c0f62e0150; });

var $cdgd4 = parcelRequire("cdgd4");
// Curious about `thismessage:/`? See: https://www.rfc-editor.org/rfc/rfc2557.html
//  > When the methods above do not yield an absolute URI, a base URL
//  > of "thismessage:/" MUST be employed. This base URL has been
//  > defined for the sole purpose of resolving relative references
//  > within a multipart/related structure when no other base URI is
//  > specified.
//
// We need to provide a base URL to `parseStringToURLObject` because the fetch API gives us a
// relative URL sometimes.
//
// This is the only case where we need to provide a base URL to `parseStringToURLObject`
// because the relative URL is not valid on its own.
const $d64ef3bb4a9e9003$var$DEFAULT_BASE_URL = 'thismessage:/';
/**
 * Checks if the URL object is relative
 *
 * @param url - The URL object to check
 * @returns True if the URL object is relative, false otherwise
 */ function $d64ef3bb4a9e9003$export$e258e13805402ba7(url) {
    return 'isRelative' in url;
}
/**
 * Parses string to a URL object
 *
 * @param url - The URL to parse
 * @returns The parsed URL object or undefined if the URL is invalid
 */ function $d64ef3bb4a9e9003$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.indexOf('://') <= 0 && url.indexOf('//') !== 0;
    const base = urlBase !== null && urlBase !== void 0 ? urlBase : isRelative ? $d64ef3bb4a9e9003$var$DEFAULT_BASE_URL : undefined;
    try {
        // Use `canParse` to short-circuit the URL constructor if it's not a valid URL
        // This is faster than trying to construct the URL and catching the error
        // Node 20+, Chrome 120+, Firefox 115+, Safari 17+
        if ('canParse' in URL && !URL.canParse(url, base)) return undefined;
        const fullUrlObject = new URL(url, base);
        if (isRelative) // Because we used a fake base URL, we need to return a relative URL object.
        // We cannot return anything about the origin, host, etc. because it will refer to the fake base URL.
        return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch (e) {
    // empty body
    }
    return undefined;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $d64ef3bb4a9e9003$export$5339fcdc8e2a427c(url) {
    if ($d64ef3bb4a9e9003$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = '';
    newUrl.hash = '';
    if ([
        '80',
        '443'
    ].includes(newUrl.port)) newUrl.port = '';
    if (newUrl.password) newUrl.password = '%filtered%';
    if (newUrl.username) newUrl.username = '%filtered%';
    return newUrl.toString();
}
function $d64ef3bb4a9e9003$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    var _request_method;
    var _request_method_toUpperCase;
    const method = (_request_method_toUpperCase = request === null || request === void 0 ? void 0 : (_request_method = request.method) === null || _request_method === void 0 ? void 0 : _request_method.toUpperCase()) !== null && _request_method_toUpperCase !== void 0 ? _request_method_toUpperCase : 'GET';
    const route = routeName ? routeName : urlObject ? kind === 'client' ? $d64ef3bb4a9e9003$export$5339fcdc8e2a427c(urlObject) : urlObject.pathname : '/';
    return `${method} ${route}`;
}
/**
 * Takes a parsed URL object and returns a set of attributes for the span
 * that represents the HTTP request for that url. This is used for both server
 * and client http spans.
 *
 * Follows https://opentelemetry.io/docs/specs/semconv/http/.
 *
 * @param urlObject - see {@link parseStringToURLObject}
 * @param kind - The type of HTTP operation (server or client)
 * @param spanOrigin - The origin of the span
 * @param request - The request object, see {@link PartialRequest}
 * @param routeName - The name of the route, must be low cardinality
 * @returns The span name and attributes for the HTTP operation
 */ function $d64ef3bb4a9e9003$export$c37a41544f3c180c(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [(0, $cdgd4.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanOrigin,
        [(0, $cdgd4.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'url'
    };
    if (routeName) {
        // This is based on https://opentelemetry.io/docs/specs/semconv/http/http-spans/#name
        attributes[kind === 'server' ? 'http.route' : 'url.template'] = routeName;
        attributes[0, $cdgd4.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = 'route';
    }
    if (request === null || request === void 0 ? void 0 : request.method) attributes[0, $cdgd4.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes['url.query'] = urlObject.search;
        if (urlObject.hash) attributes['url.fragment'] = urlObject.hash;
        if (urlObject.pathname) {
            attributes['url.path'] = urlObject.pathname;
            if (urlObject.pathname === '/') attributes[0, $cdgd4.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = 'route';
        }
        if (!$d64ef3bb4a9e9003$export$e258e13805402ba7(urlObject)) {
            attributes[0, $cdgd4.SEMANTIC_ATTRIBUTE_URL_FULL] = urlObject.href;
            if (urlObject.port) attributes['url.port'] = urlObject.port;
            if (urlObject.protocol) attributes['url.scheme'] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === 'server' ? 'server.address' : 'url.domain'] = urlObject.hostname;
        }
    }
    return [
        $d64ef3bb4a9e9003$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $d64ef3bb4a9e9003$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $d64ef3bb4a9e9003$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $d64ef3bb4a9e9003$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = (host === null || host === void 0 ? void 0 : host.replace(/^.*@/, '[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, '').replace(/(:443)$/, '')) || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}

});

parcelRegister("fMscJ", function(module, exports) {

$parcel$export(module.exports, "severityLevelFromString", function () { return $b7d1377f8a5a9da7$export$d771ef054122c30a; });
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $b7d1377f8a5a9da7$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : [
        'fatal',
        'error',
        'warning',
        'log',
        'info',
        'debug'
    ].includes(level) ? level : 'log';
}

});

parcelRegister("a4Xi1", function(module, exports) {

$parcel$export(module.exports, "addClickKeypressInstrumentationHandler", function () { return $756844d1f71a1daf$export$5aeffd3db2cf9df7; });

var $9wMZt = parcelRequire("9wMZt");
var $aVCF4 = parcelRequire("aVCF4");
var $38AjJ = parcelRequire("38AjJ");

var $8MyHQ = parcelRequire("8MyHQ");
const $756844d1f71a1daf$var$DEBOUNCE_DURATION = 1000;
let $756844d1f71a1daf$var$debounceTimerID;
let $756844d1f71a1daf$var$lastCapturedEventType;
let $756844d1f71a1daf$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $756844d1f71a1daf$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $9wMZt.addHandler)(type, handler);
    (0, $9wMZt.maybeInstrument)(type, $756844d1f71a1daf$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $756844d1f71a1daf$export$3014bbf0af0e1d4a() {
    if (!(0, $8MyHQ.WINDOW).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $9wMZt.triggerHandlers).bind(null, 'dom');
    const globalDOMEventHandler = $756844d1f71a1daf$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $8MyHQ.WINDOW).document.addEventListener('click', globalDOMEventHandler, false);
    (0, $8MyHQ.WINDOW).document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        var _globalObject_target, _proto_hasOwnProperty;
        const globalObject = (0, $8MyHQ.WINDOW);
        const proto = (_globalObject_target = globalObject[target]) === null || _globalObject_target === void 0 ? void 0 : _globalObject_target.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!(proto === null || proto === void 0 ? void 0 : (_proto_hasOwnProperty = proto.hasOwnProperty) === null || _proto_hasOwnProperty === void 0 ? void 0 : _proto_hasOwnProperty.call(proto, 'addEventListener'))) return;
        (0, $aVCF4.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $756844d1f71a1daf$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $aVCF4.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $756844d1f71a1daf$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $756844d1f71a1daf$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $756844d1f71a1daf$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $756844d1f71a1daf$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!(target === null || target === void 0 ? void 0 : target.tagName)) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $756844d1f71a1daf$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $756844d1f71a1daf$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($756844d1f71a1daf$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $aVCF4.addNonEnumerableProperty)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $aVCF4.addNonEnumerableProperty)(target, '_sentryId', (0, $38AjJ.uuid4)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$756844d1f71a1daf$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $756844d1f71a1daf$var$lastCapturedEventType = event.type;
            $756844d1f71a1daf$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($756844d1f71a1daf$var$debounceTimerID);
        $756844d1f71a1daf$var$debounceTimerID = (0, $8MyHQ.WINDOW).setTimeout(()=>{
            $756844d1f71a1daf$var$lastCapturedEventTargetId = undefined;
            $756844d1f71a1daf$var$lastCapturedEventType = undefined;
        }, $756844d1f71a1daf$var$DEBOUNCE_DURATION);
    };
}
function $756844d1f71a1daf$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}

});
parcelRegister("8MyHQ", function(module, exports) {

$parcel$export(module.exports, "WINDOW", function () { return $664dba5ad617a65f$export$56d8a8a25bd48b81; });

var $6ZThC = parcelRequire("6ZThC");
const $664dba5ad617a65f$export$56d8a8a25bd48b81 = (0, $6ZThC.GLOBAL_OBJ);

});


parcelRegister("8tNX9", function(module, exports) {

$parcel$export(module.exports, "addHistoryInstrumentationHandler", function () { return $62c7c7cb2b3f8fed$export$3f18c56c58114e75; });

var $9wMZt = parcelRequire("9wMZt");
var $aVCF4 = parcelRequire("aVCF4");
var $erx9x = parcelRequire("erx9x");

var $8MyHQ = parcelRequire("8MyHQ");
let $62c7c7cb2b3f8fed$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $62c7c7cb2b3f8fed$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $9wMZt.addHandler)(type, handler);
    (0, $9wMZt.maybeInstrument)(type, $62c7c7cb2b3f8fed$export$d9b613a6254a184e);
}
/**
 * Exported just for testing
 */ function $62c7c7cb2b3f8fed$export$d9b613a6254a184e() {
    // The `popstate` event may also be triggered on `pushState`, but it may not always reliably be emitted by the browser
    // Which is why we also monkey-patch methods below, in addition to this
    (0, $8MyHQ.WINDOW).addEventListener('popstate', ()=>{
        const to = (0, $8MyHQ.WINDOW).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $62c7c7cb2b3f8fed$var$lastHref;
        $62c7c7cb2b3f8fed$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $9wMZt.triggerHandlers)('history', handlerData);
    });
    // Just guard against this not being available, in weird environments
    if (!(0, $erx9x.supportsHistory)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                const from = $62c7c7cb2b3f8fed$var$lastHref;
                // Ensure the URL is absolute
                // this can be either a path, then it is relative to the current origin
                // or a full URL of the current origin - other origins are not allowed
                // See: https://developer.mozilla.org/en-US/docs/Web/API/History/pushState#url
                // coerce to string (this is what pushState does)
                const to = $62c7c7cb2b3f8fed$var$getAbsoluteUrl(String(url));
                // keep track of the current URL state, as we always receive only the updated state
                $62c7c7cb2b3f8fed$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $9wMZt.triggerHandlers)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $aVCF4.fill)((0, $8MyHQ.WINDOW).history, 'pushState', historyReplacementFunction);
    (0, $aVCF4.fill)((0, $8MyHQ.WINDOW).history, 'replaceState', historyReplacementFunction);
}
function $62c7c7cb2b3f8fed$var$getAbsoluteUrl(urlOrPath) {
    try {
        const url = new URL(urlOrPath, (0, $8MyHQ.WINDOW).location.origin);
        return url.toString();
    } catch (e) {
        // fallback, just do nothing
        return urlOrPath;
    }
}

});

parcelRegister("3Cb1o", function(module, exports) {

$parcel$export(module.exports, "SENTRY_XHR_DATA_KEY", function () { return $2a1d785dd6248d92$export$55b6bb1e45c6cf59; });
$parcel$export(module.exports, "addXhrInstrumentationHandler", function () { return $2a1d785dd6248d92$export$26ace48dd54c9aea; });

var $9wMZt = parcelRequire("9wMZt");
var $brfue = parcelRequire("brfue");
var $hPkId = parcelRequire("hPkId");

var $8MyHQ = parcelRequire("8MyHQ");
const $2a1d785dd6248d92$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $2a1d785dd6248d92$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $9wMZt.addHandler)(type, handler);
    (0, $9wMZt.maybeInstrument)(type, $2a1d785dd6248d92$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $2a1d785dd6248d92$export$c67d533bf77cbf54() {
    if (!(0, $8MyHQ.WINDOW).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            const virtualError = new Error();
            const startTimestamp = (0, $hPkId.timestampInSeconds)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $brfue.isString)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $2a1d785dd6248d92$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$2a1d785dd6248d92$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$2a1d785dd6248d92$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $hPkId.timestampInSeconds)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $9wMZt.triggerHandlers)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === 'function') xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$2a1d785dd6248d92$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $brfue.isString)(header) && (0, $brfue.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$2a1d785dd6248d92$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $hPkId.timestampInSeconds)() * 1000,
                xhr: sendThisArg
            };
            (0, $9wMZt.triggerHandlers)('xhr', handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
/**
 * Parses the URL argument of a XHR method to a string.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/open#url
 * url: A string or any other object with a stringifier — including a URL object — that provides the URL of the resource to send the request to.
 *
 * @param url - The URL argument of an XHR method
 * @returns The parsed URL string or undefined if the URL is invalid
 */ function $2a1d785dd6248d92$var$parseXhrUrlArg(url) {
    if ((0, $brfue.isString)(url)) return url;
    try {
        // If the passed in argument is not a string, it should have a `toString` method as a stringifier.
        // If that fails, we just return undefined (like in IE11 where URL is not available)
        return url.toString();
    } catch (e) {} // eslint-disable-line no-empty
    return undefined;
}

});

parcelRegister("ePNNA", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $accc752275e3129d$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $accc752275e3129d$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});


parcelRegister("dvw5H", function(module, exports) {

$parcel$export(module.exports, "browserApiErrorsIntegration", function () { return $9d571032823fb0ee$export$59bfe9f1c76150e; });

var $1Fos3 = parcelRequire("1Fos3");

var $Fmb4Q = parcelRequire("Fmb4Q");
var $aVCF4 = parcelRequire("aVCF4");
var $cvueN = parcelRequire("cvueN");

var $hFw8s = parcelRequire("hFw8s");
const $9d571032823fb0ee$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $9d571032823fb0ee$var$INTEGRATION_NAME = 'BrowserApiErrors';
const $9d571032823fb0ee$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = (0, $1Fos3._)({
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false
    }, options);
    return {
        name: $9d571032823fb0ee$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $aVCF4.fill)((0, $hFw8s.WINDOW), 'setTimeout', $9d571032823fb0ee$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $aVCF4.fill)((0, $hFw8s.WINDOW), 'setInterval', $9d571032823fb0ee$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $aVCF4.fill)((0, $hFw8s.WINDOW), 'requestAnimationFrame', $9d571032823fb0ee$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $hFw8s.WINDOW)) (0, $aVCF4.fill)(XMLHttpRequest.prototype, 'send', $9d571032823fb0ee$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $9d571032823fb0ee$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach((target)=>$9d571032823fb0ee$var$_wrapEventTarget(target, _options));
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $9d571032823fb0ee$export$59bfe9f1c76150e = (0, $Fmb4Q.defineIntegration)($9d571032823fb0ee$var$_browserApiErrorsIntegration);
function $9d571032823fb0ee$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $hFw8s.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $cvueN.getFunctionName)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
function $9d571032823fb0ee$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $hFw8s.wrap)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $cvueN.getFunctionName)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $9d571032823fb0ee$var$_wrapXHR(originalSend) {
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') (0, $aVCF4.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $cvueN.getFunctionName)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $aVCF4.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $cvueN.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $hFw8s.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $9d571032823fb0ee$var$_wrapEventTarget(target, integrationOptions) {
    var _globalObject_target, _proto_hasOwnProperty;
    const globalObject = (0, $hFw8s.WINDOW);
    const proto = (_globalObject_target = globalObject[target]) === null || _globalObject_target === void 0 ? void 0 : _globalObject_target.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!(proto === null || proto === void 0 ? void 0 : (_proto_hasOwnProperty = proto.hasOwnProperty) === null || _proto_hasOwnProperty === void 0 ? void 0 : _proto_hasOwnProperty.call(proto, 'addEventListener'))) return;
    (0, $aVCF4.fill)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if ($9d571032823fb0ee$var$isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $hFw8s.wrap)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $cvueN.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch (e) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            if (integrationOptions.unregisterOriginalCallbacks) $9d571032823fb0ee$var$unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, $hFw8s.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $cvueN.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $aVCF4.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $9d571032823fb0ee$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === 'function';
}
function $9d571032823fb0ee$var$unregisterOriginalCallback(target, eventName, fn) {
    if (target && typeof target === 'object' && 'removeEventListener' in target && typeof target.removeEventListener === 'function') target.removeEventListener(eventName, fn);
}

});

parcelRegister("jZlaw", function(module, exports) {

$parcel$export(module.exports, "browserSessionIntegration", function () { return $e8d4227aefe7cbd4$export$1baa7880e357371c; });

var $2BjBt = parcelRequire("2BjBt");
var $Fmb4Q = parcelRequire("Fmb4Q");
var $zusVr = parcelRequire("zusVr");

var $8tNX9 = parcelRequire("8tNX9");

var $ePNNA = parcelRequire("ePNNA");

var $hFw8s = parcelRequire("hFw8s");
/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ const $e8d4227aefe7cbd4$export$1baa7880e357371c = (0, $Fmb4Q.defineIntegration)(()=>{
    return {
        name: 'BrowserSession',
        setupOnce () {
            if (typeof (0, $hFw8s.WINDOW).document === 'undefined') {
                (0, $ePNNA.DEBUG_BUILD) && (0, $zusVr.logger).warn('Using the `browserSessionIntegration` in non-browser environments is not supported.');
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, $2BjBt.startSession)({
                ignoreDuration: true
            });
            (0, $2BjBt.captureSession)();
            // We want to create a session for every navigation as well
            (0, $8tNX9.addHistoryInstrumentationHandler)(({ from: from, to: to })=>{
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== undefined && from !== to) {
                    (0, $2BjBt.startSession)({
                        ignoreDuration: true
                    });
                    (0, $2BjBt.captureSession)();
                }
            });
        }
    };
});

});

parcelRegister("hnhnG", function(module, exports) {

$parcel$export(module.exports, "globalHandlersIntegration", function () { return $ca621127ae3ee8cb$export$66acc70e8cf2b71a; });

var $1Fos3 = parcelRequire("1Fos3");

var $kAayL = parcelRequire("kAayL");
var $kM909 = parcelRequire("kM909");
var $2BjBt = parcelRequire("2BjBt");
var $Fmb4Q = parcelRequire("Fmb4Q");
var $d5d01 = parcelRequire("d5d01");
var $eqzQm = parcelRequire("eqzQm");
var $brfue = parcelRequire("brfue");
var $zusVr = parcelRequire("zusVr");
var $cvueN = parcelRequire("cvueN");

var $ePNNA = parcelRequire("ePNNA");

var $jiEIw = parcelRequire("jiEIw");

var $hFw8s = parcelRequire("hFw8s");
const $ca621127ae3ee8cb$var$INTEGRATION_NAME = 'GlobalHandlers';
const $ca621127ae3ee8cb$var$_globalHandlersIntegration = (options = {})=>{
    const _options = (0, $1Fos3._)({
        onerror: true,
        onunhandledrejection: true
    }, options);
    return {
        name: $ca621127ae3ee8cb$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $ca621127ae3ee8cb$var$_installGlobalOnErrorHandler(client);
                $ca621127ae3ee8cb$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $ca621127ae3ee8cb$var$_installGlobalOnUnhandledRejectionHandler(client);
                $ca621127ae3ee8cb$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $ca621127ae3ee8cb$export$66acc70e8cf2b71a = (0, $Fmb4Q.defineIntegration)($ca621127ae3ee8cb$var$_globalHandlersIntegration);
function $ca621127ae3ee8cb$var$_installGlobalOnErrorHandler(client) {
    (0, $kAayL.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $ca621127ae3ee8cb$var$getOptions();
        if ((0, $d5d01.getClient)() !== client || (0, $hFw8s.shouldIgnoreOnError)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $ca621127ae3ee8cb$var$_enhanceEventWithInitialFrame((0, $jiEIw.eventFromUnknownInput)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $2BjBt.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $ca621127ae3ee8cb$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $kM909.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $ca621127ae3ee8cb$var$getOptions();
        if ((0, $d5d01.getClient)() !== client || (0, $hFw8s.shouldIgnoreOnError)()) return;
        const error = $ca621127ae3ee8cb$var$_getUnhandledRejectionError(e);
        const event = (0, $brfue.isPrimitive)(error) ? $ca621127ae3ee8cb$var$_eventFromRejectionWithPrimitive(error) : (0, $jiEIw.eventFromUnknownInput)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $2BjBt.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $ca621127ae3ee8cb$var$_getUnhandledRejectionError(error) {
    if ((0, $brfue.isPrimitive)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ('detail' in error && 'reason' in error.detail) return error.detail.reason;
    } catch (e) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $ca621127ae3ee8cb$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $ca621127ae3ee8cb$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = column;
    const lineno = line;
    const filename = (0, $brfue.isString)(url) && url.length > 0 ? url : (0, $eqzQm.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $cvueN.UNKNOWN_FUNCTION),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $ca621127ae3ee8cb$var$globalHandlerLog(type) {
    (0, $ePNNA.DEBUG_BUILD) && (0, $zusVr.logger).log(`Global Handler attached: ${type}`);
}
function $ca621127ae3ee8cb$var$getOptions() {
    const client = (0, $d5d01.getClient)();
    const options = (client === null || client === void 0 ? void 0 : client.getOptions()) || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}

});
parcelRegister("kAayL", function(module, exports) {

$parcel$export(module.exports, "addGlobalErrorInstrumentationHandler", function () { return $efbf5c61fcb398dc$export$55b5c3ba2194f0c6; });

var $6ZThC = parcelRequire("6ZThC");

var $9wMZt = parcelRequire("9wMZt");
let $efbf5c61fcb398dc$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $efbf5c61fcb398dc$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $9wMZt.addHandler)(type, handler);
    (0, $9wMZt.maybeInstrument)(type, $efbf5c61fcb398dc$var$instrumentError);
}
function $efbf5c61fcb398dc$var$instrumentError() {
    $efbf5c61fcb398dc$var$_oldOnErrorHandler = (0, $6ZThC.GLOBAL_OBJ).onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    (0, $6ZThC.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $9wMZt.triggerHandlers)('error', handlerData);
        if ($efbf5c61fcb398dc$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $efbf5c61fcb398dc$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $6ZThC.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}

});

parcelRegister("kM909", function(module, exports) {

$parcel$export(module.exports, "addGlobalUnhandledRejectionInstrumentationHandler", function () { return $f1ff45dbf031eb3f$export$8bf4fc6858821a4e; });

var $6ZThC = parcelRequire("6ZThC");

var $9wMZt = parcelRequire("9wMZt");
let $f1ff45dbf031eb3f$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $f1ff45dbf031eb3f$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $9wMZt.addHandler)(type, handler);
    (0, $9wMZt.maybeInstrument)(type, $f1ff45dbf031eb3f$var$instrumentUnhandledRejection);
}
function $f1ff45dbf031eb3f$var$instrumentUnhandledRejection() {
    $f1ff45dbf031eb3f$var$_oldOnUnhandledRejectionHandler = (0, $6ZThC.GLOBAL_OBJ).onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    (0, $6ZThC.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $9wMZt.triggerHandlers)('unhandledrejection', handlerData);
        if ($f1ff45dbf031eb3f$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $f1ff45dbf031eb3f$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $6ZThC.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

});


parcelRegister("da9Cp", function(module, exports) {

$parcel$export(module.exports, "httpContextIntegration", function () { return $9953ab90ad157c4a$export$1378794447170364; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $Fmb4Q = parcelRequire("Fmb4Q");

var $hFw8s = parcelRequire("hFw8s");
/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $9953ab90ad157c4a$export$1378794447170364 = (0, $Fmb4Q.defineIntegration)(()=>{
    return {
        name: 'HttpContext',
        preprocessEvent (event) {
            var _event_request;
            // if none of the information we want exists, don't bother
            if (!(0, $hFw8s.WINDOW).navigator && !(0, $hFw8s.WINDOW).location && !(0, $hFw8s.WINDOW).document) return;
            const reqData = (0, $hFw8s.getHttpRequestData)();
            const headers = (0, $1Fos3._)({}, reqData.headers, (_event_request = event.request) === null || _event_request === void 0 ? void 0 : _event_request.headers);
            event.request = (0, $b2I6k._)((0, $1Fos3._)({}, reqData, event.request), {
                headers: headers
            });
        }
    };
});

});

parcelRegister("5c0ex", function(module, exports) {

$parcel$export(module.exports, "linkedErrorsIntegration", function () { return $3c7e411fe93761bc$export$ebabb00eb7f3a395; });

var $4GitZ = parcelRequire("4GitZ");
var $Fmb4Q = parcelRequire("Fmb4Q");

var $jiEIw = parcelRequire("jiEIw");
const $3c7e411fe93761bc$var$DEFAULT_KEY = 'cause';
const $3c7e411fe93761bc$var$DEFAULT_LIMIT = 5;
const $3c7e411fe93761bc$var$INTEGRATION_NAME = 'LinkedErrors';
const $3c7e411fe93761bc$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $3c7e411fe93761bc$var$DEFAULT_LIMIT;
    const key = options.key || $3c7e411fe93761bc$var$DEFAULT_KEY;
    return {
        name: $3c7e411fe93761bc$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $4GitZ.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $jiEIw.exceptionFromError), options.stackParser, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $3c7e411fe93761bc$export$ebabb00eb7f3a395 = (0, $Fmb4Q.defineIntegration)($3c7e411fe93761bc$var$_linkedErrorsIntegration);

});
parcelRegister("4GitZ", function(module, exports) {

$parcel$export(module.exports, "applyAggregateErrorsToEvent", function () { return $36896bf81e23cbb7$export$b91c38ed7d8ae9b2; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $brfue = parcelRequire("brfue");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $36896bf81e23cbb7$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    var _event_exception;
    if (!((_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : _event_exception.values) || !hint || !(0, $brfue.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $36896bf81e23cbb7$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $36896bf81e23cbb7$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $brfue.isInstanceOf)(error[key], Error)) {
        $36896bf81e23cbb7$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $36896bf81e23cbb7$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $36896bf81e23cbb7$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $brfue.isInstanceOf)(childError, Error)) {
            $36896bf81e23cbb7$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $36896bf81e23cbb7$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $36896bf81e23cbb7$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $36896bf81e23cbb7$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = (0, $b2I6k._)((0, $1Fos3._)({}, exception.mechanism, exception.type === 'AggregateError' && {
        is_exception_group: true
    }), {
        exception_id: exceptionId
    });
}
function $36896bf81e23cbb7$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = (0, $b2I6k._)((0, $1Fos3._)({}, exception.mechanism), {
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    });
}

});


parcelRegister("cxcJ7", function(module, exports) {

$parcel$export(module.exports, "defaultStackParser", function () { return $9202705a9fc53d64$export$2b2b997d81bf3907; });

var $cvueN = parcelRequire("cvueN");
const $9202705a9fc53d64$var$OPERA10_PRIORITY = 10;
const $9202705a9fc53d64$var$OPERA11_PRIORITY = 20;
const $9202705a9fc53d64$var$CHROME_PRIORITY = 30;
const $9202705a9fc53d64$var$WINJS_PRIORITY = 40;
const $9202705a9fc53d64$var$GECKO_PRIORITY = 50;
function $9202705a9fc53d64$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === '<anonymous>' ? (0, $cvueN.UNKNOWN_FUNCTION) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $9202705a9fc53d64$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $9202705a9fc53d64$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $9202705a9fc53d64$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $9202705a9fc53d64$var$chromeStackParserFn = (line)=>{
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $9202705a9fc53d64$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $9202705a9fc53d64$var$createFrame(filename, (0, $cvueN.UNKNOWN_FUNCTION), +line, +col);
    }
    const parts = $9202705a9fc53d64$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $9202705a9fc53d64$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $9202705a9fc53d64$var$extractSafariExtensionDetails(parts[1] || (0, $cvueN.UNKNOWN_FUNCTION), parts[2]);
        return $9202705a9fc53d64$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $9202705a9fc53d64$export$263a749fff749872 = [
    $9202705a9fc53d64$var$CHROME_PRIORITY,
    $9202705a9fc53d64$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $9202705a9fc53d64$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $9202705a9fc53d64$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $9202705a9fc53d64$var$gecko = (line)=>{
    const parts = $9202705a9fc53d64$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $9202705a9fc53d64$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $cvueN.UNKNOWN_FUNCTION);
        [func, filename] = $9202705a9fc53d64$var$extractSafariExtensionDetails(func, filename);
        return $9202705a9fc53d64$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $9202705a9fc53d64$export$cdba47a5dd2804d = [
    $9202705a9fc53d64$var$GECKO_PRIORITY,
    $9202705a9fc53d64$var$gecko
];
const $9202705a9fc53d64$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $9202705a9fc53d64$var$winjs = (line)=>{
    const parts = $9202705a9fc53d64$var$winjsRegex.exec(line);
    return parts ? $9202705a9fc53d64$var$createFrame(parts[2], parts[1] || (0, $cvueN.UNKNOWN_FUNCTION), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $9202705a9fc53d64$export$179460296da408e8 = [
    $9202705a9fc53d64$var$WINJS_PRIORITY,
    $9202705a9fc53d64$var$winjs
];
const $9202705a9fc53d64$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $9202705a9fc53d64$var$opera10 = (line)=>{
    const parts = $9202705a9fc53d64$var$opera10Regex.exec(line);
    return parts ? $9202705a9fc53d64$var$createFrame(parts[2], parts[3] || (0, $cvueN.UNKNOWN_FUNCTION), +parts[1]) : undefined;
};
const $9202705a9fc53d64$export$f892b52c880ffc7a = [
    $9202705a9fc53d64$var$OPERA10_PRIORITY,
    $9202705a9fc53d64$var$opera10
];
const $9202705a9fc53d64$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $9202705a9fc53d64$var$opera11 = (line)=>{
    const parts = $9202705a9fc53d64$var$opera11Regex.exec(line);
    return parts ? $9202705a9fc53d64$var$createFrame(parts[5], parts[3] || parts[4] || (0, $cvueN.UNKNOWN_FUNCTION), +parts[1], +parts[2]) : undefined;
};
const $9202705a9fc53d64$export$af11af13f09fb0dc = [
    $9202705a9fc53d64$var$OPERA11_PRIORITY,
    $9202705a9fc53d64$var$opera11
];
const $9202705a9fc53d64$export$7197c0fe6554c079 = [
    $9202705a9fc53d64$export$263a749fff749872,
    $9202705a9fc53d64$export$cdba47a5dd2804d
];
const $9202705a9fc53d64$export$2b2b997d81bf3907 = (0, $cvueN.createStackParser)(...$9202705a9fc53d64$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $9202705a9fc53d64$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : (0, $cvueN.UNKNOWN_FUNCTION),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};

});

parcelRegister("g3ZnX", function(module, exports) {

$parcel$export(module.exports, "makeFetchTransport", function () { return $bb1c8b0609bc1021$export$b2311068c46d7cc8; });

var $1Fos3 = parcelRequire("1Fos3");

var $3DuUJ = parcelRequire("3DuUJ");
var $f3a5J = parcelRequire("f3a5J");

var $fLqvX = parcelRequire("fLqvX");
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $bb1c8b0609bc1021$export$b2311068c46d7cc8(options, nativeFetch = (0, $fLqvX.getNativeImplementation)('fetch')) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = (0, $1Fos3._)({
            body: request.body,
            method: 'POST',
            referrerPolicy: 'strict-origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15
        }, options.fetchOptions);
        if (!nativeFetch) {
            (0, $fLqvX.clearCachedImplementation)('fetch');
            return (0, $f3a5J.rejectedSyncPromise)('No fetch implementation available');
        }
        try {
            // Note: We do not need to suppress tracing here, becasue we are using the native fetch, instead of our wrapped one.
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $fLqvX.clearCachedImplementation)('fetch');
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $f3a5J.rejectedSyncPromise)(e);
        }
    }
    return (0, $3DuUJ.createTransport)(options, makeRequest);
}

});
parcelRegister("3DuUJ", function(module, exports) {

$parcel$export(module.exports, "createTransport", function () { return $2a5cfe7bb7b87236$export$d09f50d9ab7f7b69; });

var $euQAQ = parcelRequire("euQAQ");

var $e0SvR = parcelRequire("e0SvR");

var $zusVr = parcelRequire("zusVr");

var $lgymU = parcelRequire("lgymU");

var $2OkBO = parcelRequire("2OkBO");

var $f3a5J = parcelRequire("f3a5J");
const $2a5cfe7bb7b87236$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $2a5cfe7bb7b87236$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $lgymU.makePromiseBuffer)(options.bufferSize || $2a5cfe7bb7b87236$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $e0SvR.forEachEnvelopeItem)(envelope, (item, type)=>{
            const dataCategory = (0, $e0SvR.envelopeItemTypeToDataCategory)(type);
            if ((0, $2OkBO.isRateLimited)(rateLimits, dataCategory)) options.recordDroppedEvent('ratelimit_backoff', dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $f3a5J.resolvedSyncPromise)({});
        const filteredEnvelope = (0, $e0SvR.createEnvelope)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $e0SvR.forEachEnvelopeItem)(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, (0, $e0SvR.envelopeItemTypeToDataCategory)(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $e0SvR.serializeEnvelope)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $2OkBO.updateRateLimits)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).error('Encountered error running transport request:', error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === (0, $lgymU.SENTRY_BUFFER_FULL_ERROR)) {
                (0, $euQAQ.DEBUG_BUILD) && (0, $zusVr.debug).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $f3a5J.resolvedSyncPromise)({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}

});
parcelRegister("lgymU", function(module, exports) {

$parcel$export(module.exports, "SENTRY_BUFFER_FULL_ERROR", function () { return $f7b5c07aefc93c04$export$c8667f1887a128dc; });
$parcel$export(module.exports, "makePromiseBuffer", function () { return $f7b5c07aefc93c04$export$85a4f67f852183e6; });

var $f3a5J = parcelRequire("f3a5J");
const $f7b5c07aefc93c04$export$c8667f1887a128dc = Symbol.for('SentryBufferFullError');
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $f7b5c07aefc93c04$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0] || Promise.resolve(undefined);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $f3a5J.rejectedSyncPromise)($f7b5c07aefc93c04$export$c8667f1887a128dc);
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $f3a5J.SyncPromise)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $f3a5J.resolvedSyncPromise)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});

parcelRegister("2OkBO", function(module, exports) {

$parcel$export(module.exports, "isRateLimited", function () { return $20c03cc828807388$export$6c91fec22056810a; });
$parcel$export(module.exports, "updateRateLimits", function () { return $20c03cc828807388$export$699aff705e0d49d4; });
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend

var $1Fos3 = parcelRequire("1Fos3");
const $20c03cc828807388$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $20c03cc828807388$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $20c03cc828807388$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $20c03cc828807388$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $20c03cc828807388$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $20c03cc828807388$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $20c03cc828807388$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = (0, $1Fos3._)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers === null || headers === void 0 ? void 0 : headers['x-sentry-rate-limits'];
    const retryAfterHeader = headers === null || headers === void 0 ? void 0 : headers['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $20c03cc828807388$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}

});


parcelRegister("fLqvX", function(module, exports) {

$parcel$export(module.exports, "getNativeImplementation", function () { return $b79fd0001439611f$export$e464f4a514ac28a8; });
$parcel$export(module.exports, "clearCachedImplementation", function () { return $b79fd0001439611f$export$8aa36702e8c8978; });

var $erx9x = parcelRequire("erx9x");
var $zusVr = parcelRequire("zusVr");

var $k3aic = parcelRequire("k3aic");

var $8MyHQ = parcelRequire("8MyHQ");
/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $b79fd0001439611f$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $b79fd0001439611f$export$e464f4a514ac28a8(name) {
    const cached = $b79fd0001439611f$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $8MyHQ.WINDOW)[name];
    // Fast path to avoid DOM I/O
    if ((0, $erx9x.isNativeFunction)(impl)) return $b79fd0001439611f$var$cachedImplementations[name] = impl.bind((0, $8MyHQ.WINDOW));
    const document = (0, $8MyHQ.WINDOW).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow === null || contentWindow === void 0 ? void 0 : contentWindow[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $k3aic.DEBUG_BUILD) && (0, $zusVr.logger).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $b79fd0001439611f$var$cachedImplementations[name] = impl.bind((0, $8MyHQ.WINDOW));
}
/** Clear a cached implementation. */ function $b79fd0001439611f$export$8aa36702e8c8978(name) {
    $b79fd0001439611f$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $b79fd0001439611f$export$e7aa7bc5c1b3cfb3(...rest) {
    return $b79fd0001439611f$export$e464f4a514ac28a8('fetch')(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $b79fd0001439611f$export$831dc9f2ab0a617b(...rest) {
    return $b79fd0001439611f$export$e464f4a514ac28a8('setTimeout')(...rest);
}

});
parcelRegister("k3aic", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $e98c125a4118a691$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $e98c125a4118a691$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});



parcelRegister("gDDQ6", function(module, exports) {

$parcel$export(module.exports, "checkAndWarnIfIsEmbeddedBrowserExtension", function () { return $c1cf311deb6a8b83$export$dc236a86065879fc; });

var $zusVr = parcelRequire("zusVr");
var $eqzQm = parcelRequire("eqzQm");

var $ePNNA = parcelRequire("ePNNA");

var $hFw8s = parcelRequire("hFw8s");
/**
 * Returns true if the SDK is running in an embedded browser extension.
 * Stand-alone browser extensions (which do not share the same data as the main browser page) are fine.
 */ function $c1cf311deb6a8b83$export$dc236a86065879fc() {
    if ($c1cf311deb6a8b83$var$_isEmbeddedBrowserExtension()) {
        if (0, $ePNNA.DEBUG_BUILD) (0, $zusVr.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error('[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/');
        });
        return true;
    }
    return false;
}
function $c1cf311deb6a8b83$var$_isEmbeddedBrowserExtension() {
    var _extensionObject_runtime;
    if (typeof (0, $hFw8s.WINDOW).window === 'undefined') // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const _window = (0, $hFw8s.WINDOW);
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    if (_window.nw) return false;
    const extensionObject = _window['chrome'] || _window['browser'];
    if (!(extensionObject === null || extensionObject === void 0 ? void 0 : (_extensionObject_runtime = extensionObject.runtime) === null || _extensionObject_runtime === void 0 ? void 0 : _extensionObject_runtime.id)) return false;
    const href = (0, $eqzQm.getLocationHref)();
    const extensionProtocols = [
        'chrome-extension',
        'moz-extension',
        'ms-browser-extension',
        'safari-web-extension'
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = (0, $hFw8s.WINDOW) === (0, $hFw8s.WINDOW).top && extensionProtocols.some((protocol)=>href.startsWith(`${protocol}://`));
    return !isDedicatedExtensionPage;
}

});



parcelRegister("7eeh4", function(module, exports) {

$parcel$export(module.exports, "isOidcDisplayMode", function () { return $42e642160d19cdc6$export$62d34b9f4d1e3978; });
$parcel$export(module.exports, "isMobileOidc", function () { return $42e642160d19cdc6$export$eb7f7bf9cc131875; });
function $42e642160d19cdc6$export$62d34b9f4d1e3978(context, ...display) {
    if (!context || !context.display) return false;
    return display.includes(context.display);
}
function $42e642160d19cdc6$export$eb7f7bf9cc131875(context) {
    // currently we assume that any oidc with proper display param is a mobile oidc
    return !!context && !!context.display;
}

});

parcelRegister("8PxQr", function(module, exports) {

$parcel$export(module.exports, "inferCapabilitiesFromPathname", function () { return $2c2ae3e2e5dd4086$export$6c4138d23bab6961; });
const $2c2ae3e2e5dd4086$export$6c4138d23bab6961 = (pathname)=>{
    if (pathname.includes('login')) return [
        'capability-group--login'
    ];
    if (pathname.includes('signup')) return [
        'capability-group--signup'
    ];
    if (pathname.includes('logout')) return [
        'capability-group--logout'
    ];
    return [
        'unknown'
    ];
};

});


parcelRegister("imbUG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5d385c8d22d627a$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");

var $kbWO6 = parcelRequire("kbWO6");

var $9UvCO = parcelRequire("9UvCO");

var $c3rzm = parcelRequire("c3rzm");

var $3IiMP = parcelRequire("3IiMP");

var $6DY4F = parcelRequire("6DY4F");

var $lFnO2 = parcelRequire("lFnO2");

var $kHwWf = parcelRequire("kHwWf");

var $hJSVJ = parcelRequire("hJSVJ");

var $kFQH5 = parcelRequire("kFQH5");

var $bOqPW = parcelRequire("bOqPW");

var $6Mvxe = parcelRequire("6Mvxe");

var $dOulP = parcelRequire("dOulP");

var $4meW7 = parcelRequire("4meW7");

var $6yYN7 = parcelRequire("6yYN7");

var $hIO3P = parcelRequire("hIO3P");

var $is91y = parcelRequire("is91y");

var $c5fHl = parcelRequire("c5fHl");

var $6TSJ2 = parcelRequire("6TSJ2");

var $3bvlA = parcelRequire("3bvlA");

var $d24k1 = parcelRequire("d24k1");
function $d5d385c8d22d627a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d5d385c8d22d627a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d5d385c8d22d627a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d5d385c8d22d627a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $d5d385c8d22d627a$export$5df9262e102d0c32 = '/gateway/api/gasv3/api/v1';
const $d5d385c8d22d627a$var$LAST_SCREEN_EVENT_STORAGE_KEY = 'last.screen.event';
class $d5d385c8d22d627a$export$48361b6ed38f1b0 {
    static callback(response) {
        const statusCode = response.getStatusCode();
        if (statusCode >= 200 && statusCode <= 299) {
            if (response.getEventResponseList().length === 0) // eslint-disable-next-line no-console
            console.debug('Event(s) submitted to GASv3');
            else response.getEventResponseList().forEach((eventResponse)=>{
                // eslint-disable-next-line no-console
                console.warn('Validation report for event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        } else if (statusCode === 400 || statusCode === 404) {
            // eslint-disable-next-line no-console
            console.warn('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.getEventResponseList().forEach((eventResponse)=>{
                // eslint-disable-next-line no-console
                console.warn('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        } else {
            // eslint-disable-next-line no-console
            console.info('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.eventResponseList.forEach((eventResponse)=>{
                // eslint-disable-next-line no-console
                console.debug('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        }
    }
}
class $d5d385c8d22d627a$export$2e2bcd8739ae039 {
    setEventValidationMode(eventValidationMode) {
        this._context.context.validationMode = eventValidationMode;
    }
    constructor(productInfo, settings = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_useStargate", (useStargate)=>{
            if (useStargate == null) return true;
            return useStargate;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_endsWith", (str, suffix)=>str.indexOf(suffix, str.length - suffix.length) !== -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_changeInternalUserId", (userId, anonymousId)=>{
            this.eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== this.eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            this.eventProcessor.getUser().setAnonymousId(anonymousId);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_createSubproductGetter", (subproduct)=>(0, $3IiMP.default)(subproduct, 'Cannot get subproduct from the callback. Proceeding without it.'));
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_createEmbeddedProductGetter", (embeddedProduct)=>(0, $3IiMP.default)(embeddedProduct, 'Cannot get embeddedProduct from the callback. Proceeding without it.'));
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_getLastScreenEvent", ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($d5d385c8d22d627a$var$LAST_SCREEN_EVENT_STORAGE_KEY) || '');
            } catch (err) {
                this._safeSessionStorage.removeItem($d5d385c8d22d627a$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_setLastScreenEvent", (event)=>{
            this._safeSessionStorage.setItem($d5d385c8d22d627a$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_shouldEventBeDelayed", (event)=>{
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf('measurement') === -1) return false;
            const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return this.eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_fireEvent", (identifier, builtEvent, context, callback)=>{
            switch(builtEvent.eventType){
                case (0, $9UvCO.eventType).UI:
                case (0, $9UvCO.eventType).OPERATIONAL:
                case (0, $9UvCO.eventType).TRACK:
                    return this.eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, $9UvCO.eventType).SCREEN:
                    return this.eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, $9UvCO.eventType).IDENTIFY:
                    return this.eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_fireDelayedEvent", (identifier, builtEvent, context, userInfo)=>{
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [
                    ...builtEvent.tags || [],
                    'sentWithDelay'
                ];
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_delayEvent", (identifier, builtEvent, context, userInfo, callback)=>{
            this.eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_processEvent", (identifier, builtEvent, context, callback)=>{
            this._testingCache.saveEvent(builtEvent);
            if (this._shouldEventBeDelayed(builtEvent)) {
                this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                return Promise.resolve();
            } else return this._fireEvent(identifier, builtEvent, context, callback);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "setEmbeddedProduct", (embeddedProduct)=>{
            this._productInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
            this.resetUIViewedTimers();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "clearEmbeddedProduct", ()=>{
            this._productInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "setSubproduct", (subproduct)=>{
            this._productInfo.subproduct = this._createSubproductGetter(subproduct);
            this.resetUIViewedTimers();
        });
        /**
      * Calling this function in the intialisation of the client in product
      * captures specified 'origin tracing' URL params and fires a single origin landed event
      * <p>
      * This function expects a mapping between the keys for any URL parameters
      *  that should be captured and removed for origin tracing
      * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
      * Each handler function should return an object with two items
      * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
      * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
      *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
      * </p>
      * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
      * e.g. from a share or email
      *
      * An example calling this function using an external decoding library, with taskSessionId specified to persist
      * analyticsWebClient.setOriginTracingHandlers({
           atlOrigin: encodedOrigin => {
               const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
               return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
           },
       });
      *
      * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
      * @this {AnalyticsWebClient}
      */ (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "setOriginTracingHandlers", (originParamHandlerMapping)=>{
            const capturedOriginTraces = this.originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (typeof capturedOriginTraces[x].taskSessionId !== 'undefined') this.task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            const originAttributes = {};
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
            });
            if (Object.keys(capturedOriginTraces).length > 0) return this.sendOperationalEvent({
                action: 'landed',
                actionSubject: 'origin',
                source: 'webClient',
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{});
            return Promise.resolve();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "setTenantInfo", (tenantIdType, tenantId)=>{
            if (!tenantIdType) throw new Error('Missing tenantIdType');
            if (tenantIdType !== (0, $9UvCO.tenantType).NONE && !tenantId) throw new Error('Missing tenantId');
            if (!(0, $9UvCO.isType)((0, $9UvCO.tenantType), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $9UvCO.objectValues)((0, $9UvCO.tenantType))}]`);
            this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "clearTenantInfo", ()=>{
            this._tenantInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "setOrgInfo", (orgId)=>{
            if (!orgId) throw new Error('Missing orgId');
            this._orgInfo = {
                orgId: orgId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "clearOrgInfo", ()=>{
            this._orgInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "setWorkspaceInfo", (workspaceId)=>{
            if (!workspaceId) throw new Error('Missing workspaceId');
            this._workspaceInfo = {
                workspaceId: workspaceId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "clearWorkspaceInfo", ()=>{
            this._workspaceInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "setUserInfo", (userIdType, userId)=>{
            (0, $kHwWf.validateIdentifyEvent)(userIdType, userId);
            this._changeInternalUserId(userId);
            this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: this.eventProcessor.getUser().getAnonymousId()
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "clearUserInfo", ()=>{
            this._changeInternalUserId(undefined);
            this._userInfo = {
                anonymousId: this.eventProcessor.getUser().getAnonymousId()
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "setAlias", (aliasKeyType, alias)=>{
            if (!aliasKeyType) throw new Error('Missing aliasType');
            if (!(0, $9UvCO.isType)((0, $9UvCO.aliasType), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, $9UvCO.objectValues)((0, $9UvCO.aliasType))}]`);
            this._aliases[aliasKeyType] = alias;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "clearAlias", ()=>{
            this._aliases = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "setGroup", (groupsKeyType, group)=>{
            if (!groupsKeyType) throw new Error('Missing groupType');
            if (!(0, $9UvCO.isType)((0, $9UvCO.groupType), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, $9UvCO.objectValues)((0, $9UvCO.groupType))}]`);
            this._groups[groupsKeyType] = group;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "clearGroup", ()=>{
            this._groups = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "getAnonymousId", ()=>this._userInfo.anonymousId);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "setUIViewedAttributes", (uiViewedAttributes)=>{
            if (!uiViewedAttributes) throw new Error('Missing uiViewedAttributes');
            if (typeof uiViewedAttributes !== 'object' || Array.isArray(uiViewedAttributes)) throw new Error('Invalid uiViewedAttributes type, should be a non array object');
            this._uiViewedAttributes = $d5d385c8d22d627a$var$_objectSpread({}, uiViewedAttributes);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "getUIViewedAttributes", ()=>{
            return this._uiViewedAttributes;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "clearUIViewedAttributes", ()=>{
            this._uiViewedAttributes = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "sendIdentifyEvent", (userIdType, userId, callback)=>{
            this.setUserInfo(userIdType, userId);
            const builtEvent = {
                userIdType: userIdType,
                eventType: (0, $9UvCO.eventType).IDENTIFY
            };
            return this._processEvent(userId, builtEvent, this._context, callback);
        });
        /**
     * @deprecated
     * please use {@link sendScreenEvent instead)
     */ (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "sendPageEvent", (name, callback)=>{
            return this.sendScreenEvent(name, callback);
        });
        /**
     * send screen event
     * @param event The event / For retrocompatibility event name is still supported here.
     * @param callback
     * @param attributes. Deprecated, will get ignored if using an event object as first param.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "sendScreenEvent", (event, callback, attributes)=>{
            let screenName;
            let screenAttributes;
            let screenContainers;
            let screenTags;
            if (typeof event === 'object') {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, $kHwWf.validateScreenEvent)(screenName);
            (0, $kHwWf.validateContainers)(screenContainers);
            const builtEvent = (0, $6DY4F.buildScreenEvent)(this._productInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, event, screenContainers, this._aliases, this._groups);
            const builtEventWithName = $d5d385c8d22d627a$var$_objectSpread({
                name: screenName
            }, builtEvent);
            this._setLastScreenEvent(builtEventWithName);
            return this._processEvent(screenName, builtEventWithName, this._context, (0, $3bvlA.default)(callback, builtEventWithName));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "sendTrackEvent", (event, callback)=>{
            (0, $kHwWf.validateTrackEvent)(event);
            const builtEvent = (0, $6DY4F.buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $9UvCO.eventType).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $6DY4F.buildActionName)(event), builtEvent, this._context, (0, $3bvlA.default)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "sendUIEvent", (event, callback)=>{
            (0, $kHwWf.validateUIEvent)(event);
            const builtEvent = (0, $6DY4F.buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $9UvCO.eventType).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $6DY4F.buildActionName)(event), builtEvent, this._context, (0, $3bvlA.default)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "sendOperationalEvent", (event, callback)=>{
            (0, $kHwWf.validateOperationalEvent)(event);
            const builtEvent = (0, $6DY4F.buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $9UvCO.eventType).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $6DY4F.buildActionName)(event), builtEvent, this._context, (0, $3bvlA.default)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "startUIViewedEvent", (callback)=>{
            this.stopUIViewedEvent();
            this._uiViewedEvent = new (0, $c5fHl.default)(this._productInfo, ()=>({
                    embeddedProduct: this._productInfo.embeddedProduct(),
                    subproduct: this._productInfo.subproduct(),
                    tenantIdType: this._tenantInfo.tenantIdType,
                    tenantId: this._tenantInfo.tenantId,
                    userId: this._userInfo.userId,
                    lastScreenEvent: this._getLastScreenEvent(),
                    attributes: this._uiViewedAttributes
                }), (event)=>this.sendUIEvent(event, callback));
            this._uiViewedEvent.start();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "stopUIViewedEvent", ()=>{
            if (this._uiViewedEvent) {
                this._uiViewedEvent.stop();
                this._uiViewedEvent = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "resetUIViewedTimers", ()=>{
            if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "startApdexEvent", (apdexEvent)=>{
            this._apdexEvent.start(apdexEvent);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "getApdexStart", (apdexEvent)=>this._apdexEvent.getStart(apdexEvent));
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "stopApdexEvent", (apdexEvent, callback)=>{
            this._apdexEvent.stop(apdexEvent, callback);
        });
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "startLowPriorityEventDelay", (timeout, callback)=>{
            this.eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "stopLowPriorityEventDelay", ()=>{
            this.eventDelayQueue.stopLowPriorityEventDelay();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "onEvent", (_analyticsId, analyticsData)=>{
            if (!analyticsData) throw new Error('Missing analyticsData');
            if (!analyticsData.eventType) throw new Error('Missing analyticsData.eventType');
            if (analyticsData.eventType === (0, $9UvCO.eventType).TRACK) return this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, $9UvCO.eventType).UI) return this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, $9UvCO.eventType).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, $9UvCO.eventType).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, $9UvCO.eventType).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $9UvCO.objectValues)((0, $9UvCO.eventType))}]`);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "setResponseCallback", (responseCallback)=>{
            this.eventProcessor.setResponseCallback(responseCallback);
        });
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.env) throw new Error('Missing productInfo.env');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!(0, $9UvCO.isType)((0, $9UvCO.envType), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $9UvCO.objectValues)((0, $9UvCO.envType))}]`);
        if (productInfo.perimeter && !(0, $9UvCO.isType)((0, $9UvCO.perimeterType), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be an perimeterType: [${(0, $9UvCO.objectValues)((0, $9UvCO.perimeterType))}]`);
        if (!productInfo.origin) productInfo.origin = (0, $9UvCO.originType).WEB;
        else if (!(0, $9UvCO.isType)((0, $9UvCO.originType), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $9UvCO.objectValues)((0, $9UvCO.originType))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $9UvCO.originType).WEB ? (0, $9UvCO.platformType).WEB : (0, $9UvCO.platformType).DESKTOP;
        else (0, $kHwWf.validatePlatform)(productInfo);
        this.logger = settings.logger || console;
        this._productInfo = $d5d385c8d22d627a$var$_objectSpread($d5d385c8d22d627a$var$_objectSpread({}, productInfo), {}, {
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        });
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        this._context = (0, $6DY4F.buildContext)(this._productInfo);
        this._safeSessionStorage = new (0, $4meW7.default)();
        const _useStargate = this._useStargate(settings.useStargate);
        const apiHost = settings.apiHost || (0, $6Mvxe.selectHost)({
            useStargate: _useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            envOverride: productInfo.envOverride
        });
        const apiHostProtocol = settings.apiHostProtocol || 'https';
        const minRetryDelay = settings.minRetryDelay || 1000;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, $d24k1.XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
        const disableCookiePersistence = settings.disableCookiePersistence || false;
        this.eventProcessor = new (0, $hJSVJ.default)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this.logger,
            disableCookiePersistence: disableCookiePersistence,
            responseCallback: $d5d385c8d22d627a$export$48361b6ed38f1b0.callback
        });
        this._userInfo = {
            anonymousId: this.eventProcessor.getUser().getAnonymousId(settings === null || settings === void 0 ? void 0 : settings.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, $bOqPW.default)();
        this._tabTracking = new (0, $6yYN7.default)();
        this._sessionTracking = new (0, $dOulP.default)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this.task = new (0, $hIO3P.default)();
        this.originTracing = new (0, $kFQH5.default)();
        // Init Apdex
        this._apdexEvent = new (0, $c3rzm.default)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === 'function' ? settings.historyReplaceFn : (0, $6TSJ2.defaultHistoryReplaceFn);
        this.eventDelayQueue = new (0, $lFnO2.default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $is91y.default)();
        this._pageLoadId = (0, (/*@__PURE__*/$parcel$interopDefault($kbWO6)))();
        this._workspaceInfo = {};
        this._aliases = {};
        this._groups = {};
    }
}

});
parcelRegister("kbWO6", function(module, exports) {

var $dlG1y = parcelRequire("dlG1y");

var $VgMe7 = parcelRequire("VgMe7");
function $eb3273998e7646a7$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $dlG1y)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $VgMe7(rnds);
}
module.exports = $eb3273998e7646a7$var$v4;

});
parcelRegister("dlG1y", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $9b7dd5a887b2d837$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($9b7dd5a887b2d837$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $9b7dd5a887b2d837$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $9b7dd5a887b2d837$var$getRandomValues($9b7dd5a887b2d837$var$rnds8);
        return $9b7dd5a887b2d837$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $9b7dd5a887b2d837$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $9b7dd5a887b2d837$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $9b7dd5a887b2d837$var$rnds;
    };
}

});

parcelRegister("VgMe7", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $0ac25684c2cb96a2$var$byteToHex = [];
for(var $0ac25684c2cb96a2$var$i = 0; $0ac25684c2cb96a2$var$i < 256; ++$0ac25684c2cb96a2$var$i)$0ac25684c2cb96a2$var$byteToHex[$0ac25684c2cb96a2$var$i] = ($0ac25684c2cb96a2$var$i + 0x100).toString(16).substr(1);
function $0ac25684c2cb96a2$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $0ac25684c2cb96a2$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = $0ac25684c2cb96a2$var$bytesToUuid;

});


parcelRegister("9UvCO", function(module, exports) {

$parcel$export(module.exports, "envType", function () { return $7371e0143151dc23$export$56ac8ebc9870b1b9; });
$parcel$export(module.exports, "eventType", function () { return $7371e0143151dc23$export$4c045e605d532c98; });
$parcel$export(module.exports, "platformType", function () { return $7371e0143151dc23$export$6b4f396210e539f3; });
$parcel$export(module.exports, "originType", function () { return $7371e0143151dc23$export$f73e9fcd368bb695; });
$parcel$export(module.exports, "tenantType", function () { return $7371e0143151dc23$export$496f06ac2a964da2; });
$parcel$export(module.exports, "userType", function () { return $7371e0143151dc23$export$1827adfd178b4870; });
$parcel$export(module.exports, "apdexType", function () { return $7371e0143151dc23$export$99b37380a464d794; });
$parcel$export(module.exports, "desktopPlatforms", function () { return $7371e0143151dc23$export$809831be6c4c6227; });
$parcel$export(module.exports, "webPlatforms", function () { return $7371e0143151dc23$export$19c579398ad213e7; });
$parcel$export(module.exports, "originTracingType", function () { return $7371e0143151dc23$export$62a500c02dc63ee; });
$parcel$export(module.exports, "objectValues", function () { return $7371e0143151dc23$export$ad1854f4a08c15f8; });
$parcel$export(module.exports, "isType", function () { return $7371e0143151dc23$export$26b9f946b448f23e; });
$parcel$export(module.exports, "perimeterType", function () { return $7371e0143151dc23$export$bdd41749d2096e4b; });
$parcel$export(module.exports, "aliasType", function () { return $7371e0143151dc23$export$a8c99e46b781d936; });
$parcel$export(module.exports, "groupType", function () { return $7371e0143151dc23$export$e73680b18d9b7c6e; });
// These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
let $7371e0143151dc23$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
let $7371e0143151dc23$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
let $7371e0143151dc23$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
let $7371e0143151dc23$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
let $7371e0143151dc23$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["LOOM_ORG_ID"] = "loomOrgId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["JA_WORKSPACE_ID"] = "jiraAlignWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
let $7371e0143151dc23$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
let $7371e0143151dc23$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const $7371e0143151dc23$export$809831be6c4c6227 = Object.freeze([
    $7371e0143151dc23$export$6b4f396210e539f3.DESKTOP,
    $7371e0143151dc23$export$6b4f396210e539f3.MAC,
    $7371e0143151dc23$export$6b4f396210e539f3.LINUX,
    $7371e0143151dc23$export$6b4f396210e539f3.WINDOWS
]);
const $7371e0143151dc23$export$19c579398ad213e7 = Object.freeze([
    $7371e0143151dc23$export$6b4f396210e539f3.WEB,
    $7371e0143151dc23$export$6b4f396210e539f3.MOBILE_WEB
]);
let $7371e0143151dc23$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
function $7371e0143151dc23$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}
function $7371e0143151dc23$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}
let $7371e0143151dc23$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
let $7371e0143151dc23$export$a8c99e46b781d936 = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
let $7371e0143151dc23$export$e73680b18d9b7c6e = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
let $7371e0143151dc23$export$12b75c708da5a04b = /*#__PURE__*/ function(envOverrides) {
    return envOverrides;
}({});

});

parcelRegister("c3rzm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c6b268d815f78a9$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");

var $9UvCO = parcelRequire("9UvCO");

var $bOqPW = parcelRequire("bOqPW");

var $kHEhd = parcelRequire("kHEhd");
function $8c6b268d815f78a9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8c6b268d815f78a9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8c6b268d815f78a9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8c6b268d815f78a9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $8c6b268d815f78a9$export$2e2bcd8739ae039 {
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent($8c6b268d815f78a9$var$_objectSpread($8c6b268d815f78a9$var$_objectSpread($8c6b268d815f78a9$var$_objectSpread({}, event), apdexFields), visibilityFields), callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
        }
    }
    constructor(onEvent, pageVisibility){
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_getEventKey", ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_getEventTimingByName", (name)=>{
            const eventTimings = this._performance.getEntriesByName(name);
            const eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_getApdexFields", (event)=>{
            const apdexTimings = this._getApdexTimings(event);
            const apdexScore = this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return $8c6b268d815f78a9$var$_objectSpread($8c6b268d815f78a9$var$_objectSpread({}, apdexTimings), {}, {
                apdex: apdexScore
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_getApdexTimings", (event)=>{
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            const startTime = event.startTime || this._getStartTime(event, eventStartName);
            const stopTime = event.stopTime || this._getStopTime();
            // We do some clean up of the marks and started events
            this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_getStartTime", (event, eventName)=>{
            let startTime;
            const timeOrigin = this._performance.getTimeOrigin();
            if (event.type === (0, $9UvCO.apdexType).INITIAL_LOAD) startTime = timeOrigin;
            else {
                const eventTiming = this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_getStopTime", ()=>this._performance.getTimeOrigin() + this._performance.now());
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_cleanApdexState", (eventKey)=>{
            this._performance.clearMarks(`${eventKey}-start`);
            this._performance.clearMarks(`${eventKey}-stop`);
            this._startedEvents.delete(eventKey);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_getVisibilityFields", (event)=>{
            let isActiveTab;
            /**
       * For initialLoad type:
       * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
       *
       * For transition type:
       * 1. active status is tracked in active events map (_isActiveEvents)
       *
       * For any type, if startTime or stopTime is specified:
       * 1. If currently active (!_isHidden)
       */ if (event.type === (0, $9UvCO.apdexType).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
            else if (event.type === (0, $9UvCO.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                isActiveTab = this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_calculateApdex", ({ duration: duration, threshold: threshold = this._threshold })=>{
            let apdex;
            const satisfiedThreshold = threshold;
            const tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_validateStartEvent", (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex start event');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_validateStopEvent", (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $9UvCO.isType)((0, $9UvCO.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== 'number') throw new Error('Invalid "threshold" in Apdex stop event');
            /*
       * For a transition, if the startTime was not specified,
       * the start event should have been present.
       */ if (!event.startTime && event.type === (0, $9UvCO.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
            }
            if (event.startTime && !(typeof event.startTime === 'number' && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== 'number') throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_shouldSendEvent", (event)=>{
            if (!event) return false;
            if (typeof event.apdex !== 'number') return false;
            return true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_sendEvent", (event, callback)=>{
            if (this._shouldSendEvent(event)) this._onEvent({
                source: 'ui',
                action: 'readyForUser',
                actionSubject: 'ui',
                attributes: $8c6b268d815f78a9$var$_objectSpread($8c6b268d815f78a9$var$_objectSpread({}, event.additionalAttributes), {}, {
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                })
            }, callback);
        });
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        if (!(pageVisibility instanceof (0, $bOqPW.default))) throw new Error('Invalid pageVisibility, must be PageVisibility class');
        this._startedEvents = new Map();
        this._performance = new (0, $kHEhd.default)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback('apdexEvent', (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
}

});
parcelRegister("bOqPW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89992e7609d07bc8$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");
class $89992e7609d07bc8$export$2e2bcd8739ae039 {
    addCallback(name, fn) {
        if (typeof name !== 'string') throw new Error('Invalid name, must be string');
        if (typeof fn !== 'function') throw new Error('Invalid callback, must be function');
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_bindEventListeners", ()=>{
            document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_handleVisibilityChange", ()=>{
            const isHidden = document[this._hidden];
            this._isHidden = isHidden;
            this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
        });
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== 'undefined') {
            if (typeof document.hidden !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = 'hidden';
                this._visibilityChange = 'visibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                this._isHidden = document.msHidden;
                this._hidden = 'msHidden';
                this._visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                this._isHidden = document.webkitHidden;
                this._hidden = 'webkitHidden';
                this._visibilityChange = 'webkitvisibilitychange';
            }
            if (typeof document.addEventListener !== 'undefined' && this._hidden !== undefined) this._bindEventListeners();
        }
    }
}

});

parcelRegister("kHEhd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f12710e7ba89b977$export$2e2bcd8739ae039; });
class $f12710e7ba89b977$export$2e2bcd8739ae039 {
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
    constructor(){
        this._performance = window.performance;
    }
}

});


parcelRegister("3IiMP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b440dc9c73cfd45$export$2e2bcd8739ae039; });
/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const $2b440dc9c73cfd45$var$isFunction = (possibleFn)=>typeof possibleFn === 'function';
var $2b440dc9c73cfd45$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
    return ()=>{
        if ($2b440dc9c73cfd45$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};

});

parcelRegister("6DY4F", function(module, exports) {

$parcel$export(module.exports, "buildActionFields", function () { return $4d64fc18a4a38087$export$655ecf7241feac42; });
$parcel$export(module.exports, "buildScreenEvent", function () { return $4d64fc18a4a38087$export$c7d9a5f56acc4b19; });
$parcel$export(module.exports, "buildActionName", function () { return $4d64fc18a4a38087$export$9c5623a792efc9b0; });
$parcel$export(module.exports, "buildContext", function () { return $4d64fc18a4a38087$export$3a7fe28f9bf4f3d9; });
$parcel$export(module.exports, "buildActionEvent", function () { return $4d64fc18a4a38087$export$7bf451af4a8e3dd9; });

var $dsN6L = parcelRequire("dsN6L");

var $9UvCO = parcelRequire("9UvCO");

var $6g3Rz = parcelRequire("6g3Rz");
function $4d64fc18a4a38087$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4d64fc18a4a38087$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4d64fc18a4a38087$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4d64fc18a4a38087$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $4d64fc18a4a38087$var$libraryVersion = "4.27.1";
function $4d64fc18a4a38087$var$buildTenantFields(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}
function $4d64fc18a4a38087$var$buildUserFields(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}
function $4d64fc18a4a38087$var$buildOrgFields(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}
function $4d64fc18a4a38087$var$buildWorkspaceFields(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}
function $4d64fc18a4a38087$var$buildAliases(aliases) {
    if ($4d64fc18a4a38087$var$isNotEmptyObject(aliases)) return {
        aliases: aliases
    };
    return undefined;
}
function $4d64fc18a4a38087$var$buildGroups(groups) {
    if ($4d64fc18a4a38087$var$isNotEmptyObject(groups)) return {
        groups: groups
    };
    return undefined;
}
function $4d64fc18a4a38087$var$buildEventOverrides(event) {
    if (event.anonymousId) return {
        anonymousId: event.anonymousId
    };
    return {};
}
function $4d64fc18a4a38087$var$getProductField(field, override) {
    return override === undefined ? field : override;
}
function $4d64fc18a4a38087$var$buildProductFields(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = $4d64fc18a4a38087$var$getProductField(productInfo.env, overrides.env);
    const product = $4d64fc18a4a38087$var$getProductField(productInfo.product, overrides.product);
    const subproduct = $4d64fc18a4a38087$var$getProductField(productInfo.subproduct(), overrides.subproduct);
    const version = $4d64fc18a4a38087$var$getProductField(productInfo.version, overrides.version);
    const origin = $4d64fc18a4a38087$var$getProductField(productInfo.origin, overrides.origin);
    const platform = $4d64fc18a4a38087$var$getProductField(productInfo.platform, overrides.platform);
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $4d64fc18a4a38087$var$isNotEmptyObject(obj) {
    return (0, $6g3Rz.isPlainObject)(obj) && Object.keys(obj).length > 0;
}
function $4d64fc18a4a38087$var$buildAttributesWithName(name, attrObject) {
    return $4d64fc18a4a38087$var$isNotEmptyObject(attrObject) ? {
        [name]: attrObject
    } : undefined;
}
function $4d64fc18a4a38087$var$buildAttributes(attributes) {
    return $4d64fc18a4a38087$var$buildAttributesWithName('attributes', attributes);
}
function $4d64fc18a4a38087$export$3f5115a568819c1a(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}
function $4d64fc18a4a38087$export$f045f238d77c002a(containers) {
    if ($4d64fc18a4a38087$var$isNotEmptyObject(containers)) {
        const validContainers = $4d64fc18a4a38087$export$3f5115a568819c1a(containers);
        return $4d64fc18a4a38087$var$buildAttributesWithName('containers', validContainers);
    }
    return undefined;
}
function $4d64fc18a4a38087$export$655ecf7241feac42(event, actionEventType) {
    return $4d64fc18a4a38087$var$_objectSpread({
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType
    }, $4d64fc18a4a38087$export$f045f238d77c002a(event.containers));
}
function $4d64fc18a4a38087$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return $4d64fc18a4a38087$var$buildAttributesWithName('nonPrivacySafeAttributes', nonPrivacySafeAttributes);
}
function $4d64fc18a4a38087$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, event, containers, aliases, groups) {
    const productFields = $4d64fc18a4a38087$var$buildProductFields(productInfo);
    const tenantFields = $4d64fc18a4a38087$var$buildTenantFields(tenantInfo);
    const userFields = $4d64fc18a4a38087$var$buildUserFields(userInfo);
    const orgFields = $4d64fc18a4a38087$var$buildOrgFields(orgInfo);
    const workspaceFields = $4d64fc18a4a38087$var$buildWorkspaceFields(workspaceInfo);
    const overrides = {
        title: '',
        path: '',
        url: '',
        referrer: '',
        search: '',
        eventType: (0, $9UvCO.eventType).SCREEN
    };
    return $4d64fc18a4a38087$var$_objectSpread($4d64fc18a4a38087$var$_objectSpread($4d64fc18a4a38087$var$_objectSpread($4d64fc18a4a38087$var$_objectSpread($4d64fc18a4a38087$var$_objectSpread($4d64fc18a4a38087$var$_objectSpread($4d64fc18a4a38087$var$_objectSpread($4d64fc18a4a38087$var$_objectSpread($4d64fc18a4a38087$var$_objectSpread($4d64fc18a4a38087$var$_objectSpread($4d64fc18a4a38087$var$_objectSpread($4d64fc18a4a38087$var$_objectSpread({}, productFields), tenantFields), userFields), orgFields), overrides), $4d64fc18a4a38087$var$buildAttributes(attributes)), $4d64fc18a4a38087$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes)), $4d64fc18a4a38087$export$f045f238d77c002a(containers)), $4d64fc18a4a38087$var$buildEventOverrides(event)), {}, {
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId
    }, workspaceFields), $4d64fc18a4a38087$var$buildAliases(aliases)), $4d64fc18a4a38087$var$buildGroups(groups));
}
function $4d64fc18a4a38087$export$9c5623a792efc9b0(event) {
    return `${event.actionSubject} ${event.action}`;
}
let $4d64fc18a4a38087$export$fbd92247fb4d6159 = /*#__PURE__*/ function(validationMode) {
    validationMode["QUIET"] = "quiet";
    validationMode["STANDARD"] = "standard";
    validationMode["COMPLETE"] = "complete";
    return validationMode;
}({});
function $4d64fc18a4a38087$var$getDefaultValidationMode(productInfo) {
    const environment = productInfo.env;
    if (environment === undefined) return $4d64fc18a4a38087$export$fbd92247fb4d6159.QUIET;
    if (environment.includes('prod')) return $4d64fc18a4a38087$export$fbd92247fb4d6159.QUIET;
    return $4d64fc18a4a38087$export$fbd92247fb4d6159.COMPLETE;
}
function $4d64fc18a4a38087$export$3a7fe28f9bf4f3d9(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: 'analytics.js',
                version: $4d64fc18a4a38087$var$libraryVersion
            },
            validationMode: $4d64fc18a4a38087$var$getDefaultValidationMode(productInfo)
        }
    };
}
function $4d64fc18a4a38087$export$e3d99b4bfec06f6e(event) {
    const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $4d64fc18a4a38087$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, aliases, groups) {
    const productFields = $4d64fc18a4a38087$var$buildProductFields(productInfo, $4d64fc18a4a38087$export$e3d99b4bfec06f6e(event));
    const tenantFields = $4d64fc18a4a38087$var$buildTenantFields(tenantInfo);
    const orgFields = $4d64fc18a4a38087$var$buildOrgFields(orgInfo);
    const workspaceFields = $4d64fc18a4a38087$var$buildWorkspaceFields(workspaceInfo);
    const userFields = $4d64fc18a4a38087$var$buildUserFields(userInfo);
    const actionFields = $4d64fc18a4a38087$export$655ecf7241feac42(event, actionEventType);
    return $4d64fc18a4a38087$var$_objectSpread($4d64fc18a4a38087$var$_objectSpread($4d64fc18a4a38087$var$_objectSpread($4d64fc18a4a38087$var$_objectSpread($4d64fc18a4a38087$var$_objectSpread($4d64fc18a4a38087$var$_objectSpread($4d64fc18a4a38087$var$_objectSpread($4d64fc18a4a38087$var$_objectSpread($4d64fc18a4a38087$var$_objectSpread({}, productFields), tenantFields), orgFields), userFields), actionFields), $4d64fc18a4a38087$var$buildEventOverrides(event)), {}, {
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId
    }, workspaceFields), $4d64fc18a4a38087$var$buildAliases(aliases)), $4d64fc18a4a38087$var$buildGroups(groups));
}

});
parcelRegister("6g3Rz", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $48e73bcd88fffe7d$export$53b83ca8eaab0383; });
// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $48e73bcd88fffe7d$var$isObject(val) {
    return val !== null && typeof val === 'object' && Array.isArray(val) === false;
}
function $48e73bcd88fffe7d$var$isObjectObject(o) {
    return $48e73bcd88fffe7d$var$isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}
function $48e73bcd88fffe7d$export$53b83ca8eaab0383(o) {
    if ($48e73bcd88fffe7d$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== 'function') return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if ($48e73bcd88fffe7d$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!('isPrototypeOf' in prot)) return false;
    // Most likely a plain Object
    return true;
}

});


parcelRegister("lFnO2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc5fe4b11f6b1077$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");

var $1vi8i = parcelRequire("1vi8i");

var $iS99f = parcelRequire("iS99f");

var $ltGvk = parcelRequire("ltGvk");
class $fc5fe4b11f6b1077$export$2e2bcd8739ae039 {
    constructor(fireDelayedEvent, compressors){
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "push", (identifier, builtEvent, context, userInfo)=>{
            this.delayQueue.push(identifier, builtEvent, context, userInfo);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "startLowPriorityEventDelay", (timeout = (0, $1vi8i.DEFAULT_DELAY_TIMEOUT), callback)=>{
            if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
            if (this.delayTimeout) clearTimeout(this.delayTimeout);
            const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $1vi8i.MAX_DELAY_TIMEOUT)) : (0, $1vi8i.MAX_DELAY_TIMEOUT);
            this.delayCallback = callback;
            this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $ltGvk.StopLowPriorityEventDelayReason).TIMEOUT), delayTimeoutPeriod);
            // If the queue is still flushing from a previous delay period, then we should cancel that flush
            // to stop it from negatively impacting the performance of the new critical section
            this.delayQueue.cancelFlush();
            this.isDelaying = true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "stopLowPriorityEventDelay", (reason = (0, $ltGvk.StopLowPriorityEventDelayReason).MANUAL)=>{
            var _this$delayCallback;
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = undefined;
            }
            this.delayQueue.startFlush();
            this.isDelaying = false;
            (_this$delayCallback = this.delayCallback) === null || _this$delayCallback === void 0 || _this$delayCallback.call(this, reason);
            this.delayCallback = undefined;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "isDelayingLowPriorityEvents", ()=>this.isDelaying);
        this.isDelaying = false;
        this.delayQueue = new (0, $iS99f.default)(fireDelayedEvent, compressors);
    }
}

});
parcelRegister("1vi8i", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_DELAY_TIMEOUT", function () { return $1186c07b765f3c46$export$cf090d5281b5ae06; });
$parcel$export(module.exports, "MAX_DELAY_TIMEOUT", function () { return $1186c07b765f3c46$export$8575e30be0feb909; });
const $1186c07b765f3c46$export$cf090d5281b5ae06 = 10000;
const $1186c07b765f3c46$export$8575e30be0feb909 = 30000;

});

parcelRegister("iS99f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbd45dcafb6d36b6$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");

var $6DY4F = parcelRequire("6DY4F");

var $cFYwb = parcelRequire("cFYwb");

var $i3lf6 = parcelRequire("i3lf6");
// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const $dbd45dcafb6d36b6$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const $dbd45dcafb6d36b6$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
class $dbd45dcafb6d36b6$export$2e2bcd8739ae039 {
    constructor(processFn, compressionRules){
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "push", (identifier, builtEvent, context, userInfo)=>{
            this.eventArgs.push({
                identifier: identifier,
                builtEvent: builtEvent,
                context: context,
                userInfo: userInfo
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "size", ()=>this.eventArgs.length);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "startFlush", ()=>{
            try {
                this.eventArgs = this.compressEventArgs(this.eventArgs);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn('Failed to perform compression on the delayed analytics events. ' + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
            }
            this.flushNextBatch();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "cancelFlush", ()=>{
            if (this.flushBatchTimeout) {
                clearTimeout(this.flushBatchTimeout);
                this.flushBatchTimeout = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "flushNextBatch", ()=>{
            const batch = this.eventArgs.splice(0, $dbd45dcafb6d36b6$var$FLUSH_BATCH_SIZE);
            batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
            if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $dbd45dcafb6d36b6$var$FLUSH_BATCH_BACKOFF_PERIOD);
            else this.flushBatchTimeout = null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "compressEventArgs", (eventArgs)=>{
            const [compressibleEventArgs, incompressibleEventArgs] = (0, $cFYwb.partition)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
            // Events can only be compressed together if they share the same context and user info, since these are top-level
            // fields that need to exist on the fired event and can only be set to a single value.
            // We can achieve this by grouping our events by context prior to passing them to the compressor.
            const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                const matchingGroup = groups.find((group)=>(0, $cFYwb.equals)(group.userInfo, args.userInfo) && (0, $cFYwb.equals)(group.context, args.context));
                if (matchingGroup) matchingGroup.eventArgs.push(args);
                else groups.push({
                    userInfo: args.userInfo,
                    context: args.context,
                    eventArgs: [
                        args
                    ]
                });
                return groups;
            }, []);
            // Run the compressor on each group
            const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                try {
                    const events = group.eventArgs.map((args)=>args.builtEvent);
                    const compressedEvents = this.compressor.compress(events);
                    const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                            identifier: (0, $6DY4F.buildActionName)(compressedEvent),
                            builtEvent: compressedEvent,
                            userInfo: group.userInfo,
                            context: group.context
                        }));
                    return acc.concat(compressedEventArgs);
                } catch (e) {
                    // If anything goes wrong while compressing this group, then just fall back on the
                    // uncompressed events instead. The event compressor already handles errors with invalid
                    // generator functions or results, but this is an extra layer of defense to prevent data
                    // loss in the event of an unexpected error.
                    // eslint-disable-next-line no-console
                    console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                    return group.eventArgs;
                }
            }, []);
            incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
            return allCompressedEventArgs;
        });
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, $i3lf6.default)(compressionRules);
    }
}

});
parcelRegister("cFYwb", function(module, exports) {

$parcel$export(module.exports, "mapKeys", function () { return $93a84206859d77c8$export$781522908e4e76a1; });
$parcel$export(module.exports, "pick", function () { return $93a84206859d77c8$export$357523c63a2253b9; });
$parcel$export(module.exports, "omitBy", function () { return $93a84206859d77c8$export$d7a617dda645b4e3; });
$parcel$export(module.exports, "pickBy", function () { return $93a84206859d77c8$export$b460b275d6c6aa0; });
$parcel$export(module.exports, "omit", function () { return $93a84206859d77c8$export$30a06c8d3562193f; });
$parcel$export(module.exports, "equals", function () { return $93a84206859d77c8$export$e9bab7fafb253603; });
$parcel$export(module.exports, "partition", function () { return $93a84206859d77c8$export$b29f828819edca8d; });
/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
const $93a84206859d77c8$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const $93a84206859d77c8$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const $93a84206859d77c8$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const $93a84206859d77c8$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const $93a84206859d77c8$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const $93a84206859d77c8$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== 'object' && typeof b !== 'object') return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>$93a84206859d77c8$export$e9bab7fafb253603(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const $93a84206859d77c8$export$b29f828819edca8d = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);

});

parcelRegister("i3lf6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d248fc225ddbcb9b$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");

var $6DY4F = parcelRequire("6DY4F");

var $cFYwb = parcelRequire("cFYwb");

var $arMz1 = parcelRequire("arMz1");
function $d248fc225ddbcb9b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d248fc225ddbcb9b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d248fc225ddbcb9b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d248fc225ddbcb9b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $d248fc225ddbcb9b$export$2e2bcd8739ae039 {
    constructor(compressionRules = []){
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "canCompress", (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event)));
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "compress", (events)=>{
            const groups = this.createGroups(events);
            return groups.reduce((allCompressedEvents, group)=>{
                const groupCompressedEvents = this.compressGroup(group);
                return allCompressedEvents.concat(groupCompressedEvents);
            }, []);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "createGroups", (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
            // rather than passed in by the caller (eg. product, org. and tenant info)
            events.reduce((groups, event)=>{
                const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                let contextFields;
                if (matchingCompressor) {
                    const actionFields = (0, $6DY4F.buildActionFields)(event, event.eventType);
                    contextFields = (0, $cFYwb.omit)(event, Object.keys(actionFields));
                }
                const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $cFYwb.equals)(contextFields, group.contextFields));
                if (matchingGroup) matchingGroup.events.push(event);
                else groups.push({
                    contextFields: contextFields,
                    compressor: matchingCompressor,
                    events: [
                        event
                    ]
                });
                return groups;
            }, []));
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "compressGroup", (group)=>{
            // If this group doesn't have any compressor, then the event args are already in their final format
            if (!group.compressor) return group.events;
            try {
                // Run the compressor on the group to generate some new events.
                // The compression function is only expected to return the action fields for each
                // event that it generates, since all other fields are generated by the client.
                const compressedEventActionFields = group.compressor.compress(group.events);
                // Add the context fields to each of the resulting events to inflate them into a full action event
                return compressedEventActionFields.map((actionFields)=>$d248fc225ddbcb9b$var$_objectSpread($d248fc225ddbcb9b$var$_objectSpread({}, actionFields), group.contextFields));
            } catch (e) {
                // If we fail to compress the events, then just fall back the uncompressed events
                // so that no data is lost. This can happen if the compression function throws an error
                // or returns some invalid event payloads.
                // eslint-disable-next-line no-console
                console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.events.length} uncompressed events instead`);
                return group.events;
            }
        });
        if (!Array.isArray(compressionRules)) throw new Error('Event compressors must be constructed with an array of CompressionRules');
        if (!compressionRules.every((rule)=>rule instanceof (0, $arMz1.CompressionRule))) throw new Error('Event compressors can only be constructed with instances of CompressionRule');
        this.compressionRules = compressionRules;
    }
}

});
parcelRegister("arMz1", function(module, exports) {

$parcel$export(module.exports, "CompressionRule", function () { return $79b218c88ab62f47$export$89b3253ddfd2e6e8; });

var $dsN6L = parcelRequire("dsN6L");

var $kHwWf = parcelRequire("kHwWf");

var $cFYwb = parcelRequire("cFYwb");
class $79b218c88ab62f47$export$89b3253ddfd2e6e8 {
    /**
   * @callback EventPredicate
   * @param {object} event An analytics event
   * @returns {boolean} A flag indicating whether or not the event matches the conditions
   */ /**
   * @callback CompressionFunction
   * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
   * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
   */ /**
   * This constructor defines a new rule for compressing analytics events.
   * @param {EventPredicate} predicate
   * @param {CompressionFunction} compressFn
   */ constructor(predicate, compressFn){
        /**
     * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
     * @param event
     * @returns {boolean}
     */ (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "canCompress", (event)=>{
            try {
                return event && (0, $kHwWf.isActionEventType)(event.eventType) && this.predicate(event);
            } catch (e) {
                return false;
            }
        });
        /**
     * This function compresses as many events in the given collection as possible.<p>
     * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
     * appended to the end of the resulting array.
     *
     * @param events A collection of analytic events to compress
     * @returns {Array.<Object>} The action fields for the resulting compressed events
     */ (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "compress", (events)=>{
            const [compatibleEvents, incompatibleEvents] = (0, $cFYwb.partition)(events, (event)=>this.canCompress(event));
            const compressedEvents = this.compressFn(compatibleEvents);
            if (!compressedEvents) throw new Error('No events were returned from the compression function');
            compressedEvents.forEach((event)=>{
                (0, $kHwWf.validateActionEventType)(event.eventType);
                (0, $kHwWf.validateActionEvent)(event);
            });
            return compressedEvents.concat(incompatibleEvents);
        });
        if (typeof predicate !== 'function') throw new Error('Invalid predicate, must be a function that accepts an event and returns a boolean');
        if (typeof compressFn !== 'function') throw new Error('Invalid compressFn, must be a function that both accepts and returns an array of events');
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
}

});
parcelRegister("kHwWf", function(module, exports) {

$parcel$export(module.exports, "validateContainers", function () { return $f1215fad2a9b4b8b$export$e63ea5d8477971d3; });
$parcel$export(module.exports, "isActionEventType", function () { return $f1215fad2a9b4b8b$export$d19cebda16f7579a; });
$parcel$export(module.exports, "validateActionEventType", function () { return $f1215fad2a9b4b8b$export$4a8d7476662aebcc; });
$parcel$export(module.exports, "validateActionEvent", function () { return $f1215fad2a9b4b8b$export$e0c121325c66ed4c; });
$parcel$export(module.exports, "validateScreenEvent", function () { return $f1215fad2a9b4b8b$export$dc993432a592dc27; });
$parcel$export(module.exports, "validateTrackEvent", function () { return $f1215fad2a9b4b8b$export$8c014fd74b0c8b99; });
$parcel$export(module.exports, "validateUIEvent", function () { return $f1215fad2a9b4b8b$export$e5bac0930c812e90; });
$parcel$export(module.exports, "validateOperationalEvent", function () { return $f1215fad2a9b4b8b$export$1e561554275607ef; });
$parcel$export(module.exports, "validateIdentifyEvent", function () { return $f1215fad2a9b4b8b$export$c16a4e16aa4026c0; });
$parcel$export(module.exports, "validatePlatform", function () { return $f1215fad2a9b4b8b$export$801b46c35394d316; });

var $9UvCO = parcelRequire("9UvCO");

var $6g3Rz = parcelRequire("6g3Rz");
const $f1215fad2a9b4b8b$var$actionEventTypes = Object.freeze([
    (0, $9UvCO.eventType).OPERATIONAL,
    (0, $9UvCO.eventType).TRACK,
    (0, $9UvCO.eventType).UI
]);
function $f1215fad2a9b4b8b$export$df8ff30e3c960006(container) {
    if (!(0, $6g3Rz.isPlainObject)(container)) throw new Error('properties.containers must be an Object');
    if (!('id' in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== 'string') throw new Error('properties.containers.id must be of type String');
    if ('type' in container && typeof container.type !== 'string') throw new Error('properties.containers.type must be of type String');
}
function $f1215fad2a9b4b8b$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error('properties.containers must be an Object');
    Object.values(containers).forEach((container)=>$f1215fad2a9b4b8b$export$df8ff30e3c960006(container));
}
function $f1215fad2a9b4b8b$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $9UvCO.eventType).OPERATIONAL:
        case (0, $9UvCO.eventType).TRACK:
        case (0, $9UvCO.eventType).UI:
            return true;
        default:
            return false;
    }
}
function $f1215fad2a9b4b8b$export$4a8d7476662aebcc(type) {
    if (!$f1215fad2a9b4b8b$export$d19cebda16f7579a(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$f1215fad2a9b4b8b$var$actionEventTypes}]`);
    return true;
}
function $f1215fad2a9b4b8b$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
    if (!event.action) throw new Error('Missing event.action');
    $f1215fad2a9b4b8b$export$e63ea5d8477971d3(event.containers);
}
function $f1215fad2a9b4b8b$export$dc993432a592dc27(name) {
    if (!name) throw new Error('Missing name');
}
function $f1215fad2a9b4b8b$export$8c014fd74b0c8b99(event) {
    $f1215fad2a9b4b8b$export$e0c121325c66ed4c(event);
}
function $f1215fad2a9b4b8b$export$39d6334da9a44984(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
}
function $f1215fad2a9b4b8b$export$e5bac0930c812e90(event) {
    $f1215fad2a9b4b8b$export$e0c121325c66ed4c(event);
}
function $f1215fad2a9b4b8b$export$1e561554275607ef(event) {
    $f1215fad2a9b4b8b$export$e0c121325c66ed4c(event);
}
function $f1215fad2a9b4b8b$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error('Missing userIdType');
    if (!userId) throw new Error('Missing userId');
    if (!(0, $9UvCO.isType)((0, $9UvCO.userType), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $9UvCO.objectValues)((0, $9UvCO.userType))}]`);
}
function $f1215fad2a9b4b8b$export$801b46c35394d316(productInfo) {
    if (!(0, $9UvCO.isType)((0, $9UvCO.platformType), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $9UvCO.objectValues)((0, $9UvCO.platformType))}]`);
    if (productInfo.origin === (0, $9UvCO.originType).DESKTOP && !(0, $9UvCO.isType)((0, $9UvCO.desktopPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + 'must be one of [mac, linux, windows]');
    if (productInfo.origin === (0, $9UvCO.originType).WEB && !(0, $9UvCO.isType)((0, $9UvCO.webPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}

});




parcelRegister("ltGvk", function(module, exports) {

$parcel$export(module.exports, "StopLowPriorityEventDelayReason", function () { return $fa2d46dd53d4d740$export$fa6e3729c21cb8f; });
let $fa2d46dd53d4d740$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});

});


parcelRegister("hJSVJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cea13f9cb075660f$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");

var $kbWO6 = parcelRequire("kbWO6");

var $7nEJf = parcelRequire("7nEJf");

var $2Z4H0 = parcelRequire("2Z4H0");

var $e8HTB = parcelRequire("e8HTB");

var $cFFHy = parcelRequire("cFFHy");

var $5HoMf = parcelRequire("5HoMf");

var $heliR = parcelRequire("heliR");

var $hfae9 = parcelRequire("hfae9");

var $6Xo9M = parcelRequire("6Xo9M");

var $eZyQr = parcelRequire("eZyQr");
function $cea13f9cb075660f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cea13f9cb075660f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cea13f9cb075660f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cea13f9cb075660f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $cea13f9cb075660f$var$AnalyticsAPIResponse {
    isSuccess() {
        return this.success;
    }
    getValidationErrors() {
        return this.validationErrors;
    }
    getMessage() {
        return this.message;
    }
    getCode() {
        return this.code;
    }
    getValidationReports() {
        return this.validationReports;
    }
    constructor(success, validationErrors, message, code, validationReports){
        this.success = success;
        this.validationErrors = validationErrors;
        this.message = message;
        this.code = code;
        this.validationReports = validationReports;
    }
}
class $cea13f9cb075660f$var$Message {
    constructor(error){
        this.error = error;
    }
}
class $cea13f9cb075660f$var$EventValidationReport {
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    constructor(messageId, results){
        this.messageId = messageId;
        this.results = results;
    }
}
class $cea13f9cb075660f$export$133650fcdde1b226 {
    isSuccess() {
        return this.success;
    }
    getStatusCode() {
        return this.statusCode;
    }
    getMessage() {
        return this.message;
    }
    getEventResponseList() {
        return this.eventResponseList;
    }
    constructor(success, statusCode, message, eventResponseList){
        this.success = success;
        this.statusCode = statusCode;
        this.message = message;
        this.eventResponseList = eventResponseList;
    }
}
class $cea13f9cb075660f$var$EventResponse {
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    getSegmentEvent() {
        return this.segmentEvent;
    }
    constructor(messageId, results, segmentEvent){
        this.messageId = messageId;
        this.results = results;
        this.segmentEvent = segmentEvent;
    }
}
class $cea13f9cb075660f$var$EventValidationResult {
    getType() {
        return this.type;
    }
    getSeverity() {
        return this.severity;
    }
    getPropertyPath() {
        return this.propertyPath;
    }
    getMessage() {
        return this.message;
    }
    constructor(type, severity, propertyPath, message){
        this.type = type;
        this.severity = severity;
        this.propertyPath = propertyPath;
        this.message = message;
    }
}
class $cea13f9cb075660f$export$2e2bcd8739ae039 {
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $hfae9.SegmentEventTypes).TRACK, builtEvent);
        const eventWithoutMessageId = $cea13f9cb075660f$var$_objectSpread($cea13f9cb075660f$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $hfae9.SegmentEventTypes).TRACK,
            properties: (0, $eZyQr.prepareEventProperties)(builtEvent),
            event: eventName
        });
        const event = $cea13f9cb075660f$var$_objectSpread($cea13f9cb075660f$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $hfae9.SegmentEventTypes).PAGE, builtEvent);
        const eventWithoutMessageId = $cea13f9cb075660f$var$_objectSpread($cea13f9cb075660f$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $hfae9.SegmentEventTypes).PAGE,
            properties: (0, $eZyQr.prepareEventProperties)(builtEvent),
            name: eventName
        });
        const event = $cea13f9cb075660f$var$_objectSpread($cea13f9cb075660f$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $hfae9.SegmentEventTypes).IDENTIFY, builtEvent);
        const eventWithoutMessageId = $cea13f9cb075660f$var$_objectSpread($cea13f9cb075660f$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $hfae9.SegmentEventTypes).IDENTIFY,
            traits: (0, $eZyQr.prepareEventProperties)(builtEvent)
        });
        const event = $cea13f9cb075660f$var$_objectSpread($cea13f9cb075660f$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, $eZyQr.prepareEventProperties)(context);
        const segmentContext = (0, $eZyQr.buildContext)(clonedContext);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type: type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${(0, (/*@__PURE__*/$parcel$interopDefault($kbWO6)))()}`;
    }
    packageEvent(event) {
        const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
        return {
            headers: {
                'Content-Type': 'text/plain'
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, $e8HTB.attachXidToMultipleEvents)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
    setResponseCallback(responseCallback) {
        this.responseCallback = responseCallback;
    }
    constructor(options){
        var _this$options;
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "sendEvents", async (items, callback)=>{
            const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
            const metricsPayload = this.metrics.getMetricsPayload();
            const metadata = $cea13f9cb075660f$var$_objectSpread($cea13f9cb075660f$var$_objectSpread({}, metricsPayload), {}, {
                httpRetryCount: httpRetryCount
            });
            for(let key in metadata)// @ts-ignore Some keys maybe a string, but these will never equal 0
            if (metadata[key] === 0) // @ts-ignore Save space in requests by removing metrics with no impact
            delete metadata[key];
            const eventsWithXID = await this.attachXIDs(items);
            // Calculating sentAt after the XID generation as this may take some time.
            const sentAt = new Date().toISOString();
            const unpackagedEvents = eventsWithXID.map((item)=>{
                item.msg.sentAt = sentAt;
                return item.msg;
            });
            const batchBody = {
                batch: unpackagedEvents,
                sentAt: sentAt,
                metadata: metadata
            };
            const localResponseCallback = this.responseCallback;
            try {
                const response = await (0, $heliR.sendEvents)({
                    url: this.gasv3BatchUrl,
                    batch: batchBody,
                    timeout: this.options.requestTimeout
                });
                this.metrics.subtractFromMetrics(metricsPayload);
                callback(null, response);
                if (localResponseCallback !== null && response !== null) {
                    const analyticsAPIResponse = await response.clone().json();
                    const analyticsResponse = $cea13f9cb075660f$var$BatchInterceptor.toAnalyticsResponse(items, null, analyticsAPIResponse);
                    localResponseCallback(analyticsResponse);
                }
            } catch (error) {
                callback(error, null);
                if (localResponseCallback !== null && error !== null) {
                    const analyticsResponse = $cea13f9cb075660f$var$BatchInterceptor.toAnalyticsResponse(items, error, null);
                    localResponseCallback(analyticsResponse);
                }
            }
        });
        this.options = $cea13f9cb075660f$var$_objectSpread($cea13f9cb075660f$var$_objectSpread({}, options), {}, {
            requestTimeout: options.requestTimeout || (0, $cFFHy.DEFAULT_REQUEST_TIMEOUT),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false
        });
        this.user = new (0, $6Xo9M.default)((_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, $2Z4H0.default)();
        this.responseCallback = options.responseCallback;
        this.resilienceQueue = (0, $7nEJf.default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.resilienceQueue.start(this.sendEvents);
    }
}
class $cea13f9cb075660f$var$BatchInterceptor {
    static toAnalyticsResponse(items, error, analyticsAPIResponse) {
        const eventResponseList = [];
        if (analyticsAPIResponse !== null) {
            const [statusCode, success] = [
                analyticsAPIResponse.code,
                analyticsAPIResponse.success
            ];
            if (statusCode >= 200 && statusCode <= 299) {
                var _analyticsAPIResponse;
                (_analyticsAPIResponse = analyticsAPIResponse.validationReports) === null || _analyticsAPIResponse === void 0 || _analyticsAPIResponse.forEach((report)=>{
                    const matchedEvent = items.find((item)=>item.msg.messageId === report.messageId);
                    if (matchedEvent) eventResponseList.push(new $cea13f9cb075660f$var$EventResponse(matchedEvent.msg.messageId, report.results, matchedEvent.msg));
                });
                return new $cea13f9cb075660f$export$133650fcdde1b226(success, statusCode, (0, $5HoMf.HTTP_STATUS_CODE_MAP).get(statusCode), eventResponseList);
            } else if (statusCode >= 400 && statusCode <= 499) {
                var _analyticsAPIResponse2;
                // not exluding "HTTP 429 Too Many Requests error" as it is thrown as an error and handled below
                const errorMessage = ((_analyticsAPIResponse2 = analyticsAPIResponse.message) === null || _analyticsAPIResponse2 === void 0 ? void 0 : _analyticsAPIResponse2.error) !== null ? analyticsAPIResponse.message.error : (0, $5HoMf.HTTP_STATUS_CODE_MAP).has(statusCode) ? (0, $5HoMf.HTTP_STATUS_CODE_MAP).get(statusCode) : (0, $5HoMf.HTTP_STATUS_CODE_MAP).get(-1);
                items.forEach((item)=>{
                    eventResponseList.push(new $cea13f9cb075660f$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $cea13f9cb075660f$export$133650fcdde1b226(success, statusCode, errorMessage, eventResponseList);
            }
        } else if (error !== null && error.message !== null) {
            const match = error.message.match($cea13f9cb075660f$var$BatchInterceptor.http_error_regex);
            if (match) {
                items.forEach((item)=>{
                    eventResponseList.push(new $cea13f9cb075660f$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $cea13f9cb075660f$export$133650fcdde1b226(false, Number(match[1]), match[2], eventResponseList);
            }
        }
        items.forEach((item)=>{
            eventResponseList.push(new $cea13f9cb075660f$var$EventResponse(item.msg.messageId, [], item.msg));
        });
        return new $cea13f9cb075660f$export$133650fcdde1b226(false, -1, (0, $5HoMf.HTTP_STATUS_CODE_MAP).get(-1), eventResponseList);
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($cea13f9cb075660f$var$BatchInterceptor, "http_error_regex", /HTTP Error\s([0-9]{3})\s\((.+)\)/);

});
parcelRegister("7nEJf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55fa464c66f070dc$export$2e2bcd8739ae039; });

var $6nJeC = parcelRequire("6nJeC");

var $55fa464c66f070dc$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
    return new (0, $6nJeC.default)(retryQueuePrefix, product, options || {}, logger);
};

});
parcelRegister("6nJeC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a57fabbc9a1a811$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");

var $anYf2 = parcelRequire("anYf2");
var $iKhHX = parcelRequire("iKhHX");

var $h2nc6 = parcelRequire("h2nc6");
var $kCKPK = parcelRequire("kCKPK");
var $gLGA8 = parcelRequire("gLGA8");

var $2Z4H0 = parcelRequire("2Z4H0");

var $grZKu = parcelRequire("grZKu");

var $kso36 = parcelRequire("kso36");
var $le7KR = parcelRequire("le7KR");

var $3wcTi = parcelRequire("3wcTi");
function $4a57fabbc9a1a811$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4a57fabbc9a1a811$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4a57fabbc9a1a811$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4a57fabbc9a1a811$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $4a57fabbc9a1a811$var$ONE_MINUTE = 60000;
const $4a57fabbc9a1a811$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $4a57fabbc9a1a811$var$ONE_MINUTE,
    minRetryDelay: $4a57fabbc9a1a811$var$ONE_MINUTE,
    maxRetryDelay: $4a57fabbc9a1a811$var$ONE_MINUTE
};
const $4a57fabbc9a1a811$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // TODO figure out this number. For indexeddb we are sharing the queue with all tabs
    maxItems: 1000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class $4a57fabbc9a1a811$export$2e2bcd8739ae039 {
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $gLGA8.GuardPolicy).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, $3wcTi.NetworkStatusEnum).OFFLINE) {
            done((0, $le7KR.DoneState).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, $h2nc6.CallbackProcessingErrorName)) {
                done((0, $le7KR.DoneState).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, $anYf2.default)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, $iKhHX.default)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $gLGA8.GuardPolicy).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: 'successful'
            };
            else return {
                status: 'partial',
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, $le7KR.DoneState).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback: batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error('batchFlushCallback has not been set. Call PullBatchableQueue#start first.');
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, $le7KR.DoneState).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, $le7KR.DoneState).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || $4a57fabbc9a1a811$export$d219df4fe04c04a7.backoffFactor,
            backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : $4a57fabbc9a1a811$export$d219df4fe04c04a7.backoffJitterPercentage,
            batchFlushSize: (options === null || options === void 0 ? void 0 : options.batchFlushSize) || $4a57fabbc9a1a811$export$d219df4fe04c04a7.batchFlushSize,
            flushBeforeUnload: (options === null || options === void 0 ? void 0 : options.flushBeforeUnload) || $4a57fabbc9a1a811$export$d219df4fe04c04a7.flushBeforeUnload,
            flushWaitMs: (options === null || options === void 0 ? void 0 : options.flushWaitMs) || $4a57fabbc9a1a811$export$d219df4fe04c04a7.flushWaitMs,
            maxItems: (options === null || options === void 0 ? void 0 : options.maxItems) || $4a57fabbc9a1a811$export$d219df4fe04c04a7.maxItems,
            maxAttempts: (options === null || options === void 0 ? void 0 : options.maxAttempts) || $4a57fabbc9a1a811$export$d219df4fe04c04a7.maxAttempts,
            maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || $4a57fabbc9a1a811$export$d219df4fe04c04a7.maxRetryDelay,
            minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || $4a57fabbc9a1a811$export$d219df4fe04c04a7.minRetryDelay
        };
    }
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $kCKPK.default)(product, {
            logger: logger,
            maxAttempts: options === null || options === void 0 ? void 0 : options.maxAttempts,
            maxEventLimit: options === null || options === void 0 ? void 0 : options.maxItems
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $kso36.default)($4a57fabbc9a1a811$var$_objectSpread($4a57fabbc9a1a811$var$_objectSpread({}, this.options), {}, {
            waitInterval: options !== null && options !== void 0 && options.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }), this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $kso36.default)($4a57fabbc9a1a811$var$_objectSpread($4a57fabbc9a1a811$var$_objectSpread({}, $4a57fabbc9a1a811$var$LONG_POLLING_OPTIONS), {}, {
            waitInterval: $4a57fabbc9a1a811$var$LONG_POLLING_OPTIONS.flushWaitMs
        }), this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $2Z4H0.default)();
        this.networkStatus = new (0, $grZKu.default)((status)=>{
            if (status === (0, $3wcTi.NetworkStatusEnum).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
}

});
parcelRegister("anYf2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78fac80f05bbe9e6$export$2e2bcd8739ae039; });

var $g1nK9 = parcelRequire("g1nK9");

var $3RTB0 = parcelRequire("3RTB0");
// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const $78fac80f05bbe9e6$var$validSuffixs = Object.values((0, $g1nK9.LocalStorageKeySuffix));
var $78fac80f05bbe9e6$export$2e2bcd8739ae039 = (prefix)=>{
    if (typeof prefix !== 'string' || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split('.')).filter((splitKeys)=>splitKeys.length === 3 && $78fac80f05bbe9e6$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $g1nK9.LocalStorageKeySuffix).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $3RTB0.createLocalStorageKeys)(prefix, id);
            localStorage.removeItem(inProgress);
            localStorage.removeItem(queue);
            localStorage.removeItem(reclaimStart);
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};

});
parcelRegister("g1nK9", function(module, exports) {

$parcel$export(module.exports, "LocalStorageKeySuffix", function () { return $ba9f284c0eb57cf1$export$ecfa71cbc9b28241; });
$parcel$export(module.exports, "Timers", function () { return $ba9f284c0eb57cf1$export$8bb2c1fb2b1765a9; });
let $ba9f284c0eb57cf1$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
let $ba9f284c0eb57cf1$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});

});

parcelRegister("3RTB0", function(module, exports) {

$parcel$export(module.exports, "createLocalStorageKeys", function () { return $2d11727ffa6a0249$export$8433d54f767cbec5; });

var $g1nK9 = parcelRequire("g1nK9");
const $2d11727ffa6a0249$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
        [(0, $g1nK9.LocalStorageKeySuffix).ACK]: `${queuePrefix}.${queueId}.${(0, $g1nK9.LocalStorageKeySuffix).ACK}`,
        [(0, $g1nK9.LocalStorageKeySuffix).QUEUE]: `${queuePrefix}.${queueId}.${(0, $g1nK9.LocalStorageKeySuffix).QUEUE}`,
        [(0, $g1nK9.LocalStorageKeySuffix).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $g1nK9.LocalStorageKeySuffix).IN_PROGRESS}`,
        [(0, $g1nK9.LocalStorageKeySuffix).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $g1nK9.LocalStorageKeySuffix).RECLAIM_START}`,
        [(0, $g1nK9.LocalStorageKeySuffix).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $g1nK9.LocalStorageKeySuffix).RECLAIM_END}`
    });

});


parcelRegister("iKhHX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da5a4254a029cdd6$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");

var $kbWO6 = parcelRequire("kbWO6");

var $g1nK9 = parcelRequire("g1nK9");

var $3RTB0 = parcelRequire("3RTB0");
function $da5a4254a029cdd6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $da5a4254a029cdd6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $da5a4254a029cdd6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $da5a4254a029cdd6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Code we need to mimic:
// https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L262-L357
// Note we do not want to run this library due to the performance, duplication and memory leak issues.
const $da5a4254a029cdd6$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const $da5a4254a029cdd6$var$findOtherQueues = (queuePrefix)=>{
    try {
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split('.')).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $g1nK9.LocalStorageKeySuffix).ACK) try {
                const ackTimestamp = localStorage.getItem(split.join('.'));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $g1nK9.Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch (error) {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch (_error) {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const $da5a4254a029cdd6$var$tryReclaim = async (options, callback)=>{
    const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
    const start = Date.now();
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    localStorage.setItem(ack, start.toString());
    await $da5a4254a029cdd6$var$promisedSetTimeout((0, $g1nK9.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $g1nK9.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimStart.');
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await $da5a4254a029cdd6$var$promisedSetTimeout((0, $g1nK9.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $g1nK9.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimEnd.');
    return $da5a4254a029cdd6$var$reclaim(options, callback);
};
const $da5a4254a029cdd6$var$reclaim = async (options, callback)=>{
    const { queue: queue, inProgress: inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || '[]');
    const eventsInProgress = JSON.parse(localStorage.getItem(inProgress) || '{}');
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = $da5a4254a029cdd6$var$_objectSpread($da5a4254a029cdd6$var$_objectSpread({}, item), {}, {
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        });
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === 'successful') $da5a4254a029cdd6$var$clearLocalStorageKeys(options.storageKeys);
        else if (result.status === 'partial') {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            localStorage.removeItem(inProgress);
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else $da5a4254a029cdd6$var$clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const $da5a4254a029cdd6$var$clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    localStorage.removeItem(keys.queue);
    localStorage.removeItem(keys.inProgress);
    localStorage.removeItem(keys.reclaimEnd);
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    localStorage.removeItem(keys.ack);
};
var $da5a4254a029cdd6$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== 'string' || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = (0, (/*@__PURE__*/$parcel$interopDefault($kbWO6)))();
    const queuesToReclaim = $da5a4254a029cdd6$var$findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>$da5a4254a029cdd6$var$tryReclaim({
            queuePrefix: queuePrefix,
            reclaimProcessId: reclaimProcessId,
            storageKeys: (0, $3RTB0.createLocalStorageKeys)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === 'rejected');
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === 'fulfilled').map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};

});

parcelRegister("h2nc6", function(module, exports) {

$parcel$export(module.exports, "CallbackProcessingErrorName", function () { return $c6749d7a624cfa6e$export$a409c8de90e11e14; });
$parcel$export(module.exports, "default", function () { return $c6749d7a624cfa6e$export$2e2bcd8739ae039; });
const $c6749d7a624cfa6e$export$a409c8de90e11e14 = 'CallbackProcessingError';
class $c6749d7a624cfa6e$export$2e2bcd8739ae039 extends Error {
    constructor(error){
        const messageFromError = error && typeof error === 'object' && 'toString' in error && typeof error.toString === 'function' && error.toString();
        const messageFromString = typeof error === 'string' && error;
        const message = messageFromError || messageFromString || 'Argument passed to CallbackProcessingError was not an Error or string.';
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $c6749d7a624cfa6e$export$2e2bcd8739ae039.prototype);
        this.name = $c6749d7a624cfa6e$export$a409c8de90e11e14;
    }
}

});

parcelRegister("kCKPK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f03baf6f2f5f5a92$export$2e2bcd8739ae039; });

var $60Epp = parcelRequire("60Epp");

var $gLGA8 = parcelRequire("gLGA8");

var $h2nc6 = parcelRequire("h2nc6");
var $f03baf6f2f5f5a92$export$2e2bcd8739ae039 = (0, $60Epp.default);

});
parcelRegister("60Epp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4602168780306be1$export$2e2bcd8739ae039; });

var $gLGA8 = parcelRequire("gLGA8");

var $3gd5a = parcelRequire("3gd5a");
var $1KJT2 = parcelRequire("1KJT2");

var $jnWV5 = parcelRequire("jnWV5");

var $8Yx3b = parcelRequire("8Yx3b");

var $eIOk8 = parcelRequire("eIOk8");
class $4602168780306be1$export$2e2bcd8739ae039 {
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, $jnWV5.default)(namespace, options);
        } catch (error) {
            if (!(error instanceof (0, $3gd5a.default))) {
                var _options$logger;
                (_options$logger = options.logger) === null || _options$logger === void 0 || _options$logger.warn('Attempted to create IndexedDbResilience but failed. Using memory instead.');
            }
        }
        return new (0, $8Yx3b.default)(this.namespace, options);
    }
    addItem(item, options, policy = (0, $gLGA8.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, $gLGA8.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, $1KJT2.shouldIgnoreResilienceDbError)(error)) throw error;
            else if (this.resilience.storeType() === (0, $gLGA8.StoreType).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, $8Yx3b.default)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $gLGA8.GuardPolicy).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn('Unexpected error from ResilienceDb, switching to MemoryDb');
        // Dont need to catch. We are just getting events if we can
        }
    }
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.options = (0, $eIOk8.createOptionsWithDefaults)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== 'string') throw new Error('Invalid namespace provided');
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
}

});
parcelRegister("gLGA8", function(module, exports) {

$parcel$export(module.exports, "NAMESPACE_AND_TIME_ADDED_INDEX", function () { return $c35210f95b3c2f63$export$d21fbb25eb37b5bf; });
$parcel$export(module.exports, "RESILIENCE_DB_NAME", function () { return $c35210f95b3c2f63$export$8cad224051643259; });
$parcel$export(module.exports, "RESILIENCE_STORE_NAME", function () { return $c35210f95b3c2f63$export$3d8420be07b276ab; });
$parcel$export(module.exports, "TIME_TO_PROCESS_AFTER_INDEX", function () { return $c35210f95b3c2f63$export$a512a65455fce2a6; });
$parcel$export(module.exports, "TIME_ADDED_INDEX", function () { return $c35210f95b3c2f63$export$89d9c1ff8ac91862; });
$parcel$export(module.exports, "RETRY_INDEX", function () { return $c35210f95b3c2f63$export$a37d385bcd713809; });
$parcel$export(module.exports, "INDEXEDDB_TIMEOUT", function () { return $c35210f95b3c2f63$export$6d8635fed0e4b14d; });
$parcel$export(module.exports, "StoreType", function () { return $c35210f95b3c2f63$export$39337ab5872e9457; });
$parcel$export(module.exports, "GuardPolicy", function () { return $c35210f95b3c2f63$export$7710d69e6f450f20; });
const $c35210f95b3c2f63$export$d21fbb25eb37b5bf = 'namespace-timeAdded';
const $c35210f95b3c2f63$export$8cad224051643259 = 'analytics-web-client';
const $c35210f95b3c2f63$export$3d8420be07b276ab = 'analytics-resilience';
const $c35210f95b3c2f63$export$a512a65455fce2a6 = 'timeToBeProcessedAfter';
const $c35210f95b3c2f63$export$89d9c1ff8ac91862 = 'timeAdded';
const $c35210f95b3c2f63$export$a37d385bcd713809 = 'retryAttempts';
const $c35210f95b3c2f63$export$6d8635fed0e4b14d = 15000;
let $c35210f95b3c2f63$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
let $c35210f95b3c2f63$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    GuardPolicy["IGNORE"] = "ignore";
    GuardPolicy["ABANDON"] = "abandon";
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});

});

parcelRegister("3gd5a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25fd03946a701a0e$export$2e2bcd8739ae039; });
const $25fd03946a701a0e$export$fc14cf6dcea0f8ed = 'NoIndexedDbError';
class $25fd03946a701a0e$export$2e2bcd8739ae039 extends Error {
    constructor(){
        super('window.indexeddb is undefined.');
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $25fd03946a701a0e$export$2e2bcd8739ae039.prototype);
        this.name = $25fd03946a701a0e$export$fc14cf6dcea0f8ed;
    }
}

});

parcelRegister("1KJT2", function(module, exports) {

$parcel$export(module.exports, "shouldIgnoreResilienceDbError", function () { return $146dae7592842387$export$74101021e0969375; });

var $l5Q88 = parcelRequire("l5Q88");

var $h2nc6 = parcelRequire("h2nc6");

var $8P17o = parcelRequire("8P17o");
const $146dae7592842387$export$74101021e0969375 = (error)=>{
    if (error && typeof error === 'object' && 'name' in error) {
        const errorWithName = error;
        return typeof errorWithName.name === 'string' && (errorWithName.name === (0, $l5Q88.AbandonWriteErrorName) || errorWithName.name === (0, $h2nc6.CallbackProcessingErrorName) || errorWithName.name === (0, $8P17o.InvalidPolicyErrorName));
    }
    return false;
};

});
parcelRegister("l5Q88", function(module, exports) {

$parcel$export(module.exports, "AbandonWriteErrorName", function () { return $f5b28090e2ea9c87$export$ba95206613c96b28; });
$parcel$export(module.exports, "default", function () { return $f5b28090e2ea9c87$export$2e2bcd8739ae039; });
const $f5b28090e2ea9c87$export$ba95206613c96b28 = 'AbandonWriteError';
class $f5b28090e2ea9c87$export$2e2bcd8739ae039 extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $f5b28090e2ea9c87$export$2e2bcd8739ae039.prototype);
        this.name = $f5b28090e2ea9c87$export$ba95206613c96b28;
    }
}

});

parcelRegister("8P17o", function(module, exports) {

$parcel$export(module.exports, "InvalidPolicyErrorName", function () { return $01a85263fc9f7960$export$7e7aee9a953465ec; });
$parcel$export(module.exports, "default", function () { return $01a85263fc9f7960$export$2e2bcd8739ae039; });
const $01a85263fc9f7960$export$7e7aee9a953465ec = 'InvalidPolicyError';
class $01a85263fc9f7960$export$2e2bcd8739ae039 extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = $01a85263fc9f7960$export$7e7aee9a953465ec;
    }
}

});


parcelRegister("jnWV5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1cdde904c307aac$export$2e2bcd8739ae039; });

var $ai2Md = parcelRequire("ai2Md");

var $dsN6L = parcelRequire("dsN6L");

var $gLGA8 = parcelRequire("gLGA8");

var $g22sj = parcelRequire("g22sj");

var $h2nc6 = parcelRequire("h2nc6");
var $8P17o = parcelRequire("8P17o");
var $3gd5a = parcelRequire("3gd5a");
var $1KJT2 = parcelRequire("1KJT2");

var $eZpRU = parcelRequire("eZpRU");

var $eIOk8 = parcelRequire("eIOk8");
const $e1cdde904c307aac$var$_excluded = [
    "item"
], $e1cdde904c307aac$var$_excluded2 = [
    "items"
];
function $e1cdde904c307aac$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e1cdde904c307aac$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e1cdde904c307aac$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e1cdde904c307aac$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $e1cdde904c307aac$export$2e2bcd8739ae039 {
    storeType() {
        return (0, $gLGA8.StoreType).INDEXEDDB;
    }
    constructor(_namespace, _options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "startDB", async ()=>{
            return new Promise(async (resolve, reject)=>{
                if (typeof window !== 'undefined') {
                    const dbTimeout = window.setTimeout(()=>{
                        this.logger.warn('IndexedDB timed out.');
                        reject(new (0, $3gd5a.default)());
                    }, (0, $gLGA8.INDEXEDDB_TIMEOUT));
                    /*
           * The database version number can never change.
           * An upgrade transaction is limited to only one connection to the database.
           * Once this is done, we cannot open any connections with older versions of the schema.
           * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
           *
           * Due to the nature of how AWC is used (multiple tabs that are very long lived),
           * we will not be able to run version upgrades via indexeddb.
           *
           * This does not mean we cant change what is stored in the tables,
           * this limitation just prevents us from:
           *   - Creating new ObjectStores in this database connection, and
           *   - Creating new indexes on our ObjectStores
           *
           * Any upgrades we wish to run in the future will have to create a new database,
           * and migrate all the data from older databases.
           *
           * This also means any migrations we make will have to be supported until we have evidence
           * that no events are coming from old versions of the database.
           * This may take a long time.
           */ const request = window.indexedDB.open((0, $gLGA8.RESILIENCE_DB_NAME), 1);
                    request.onupgradeneeded = (event)=>{
                        if (event.oldVersion !== 0) throw new Error('We cannot upgrade the database. Do not do this.');
                        const db = request.result;
                        const store = db.createObjectStore((0, $gLGA8.RESILIENCE_STORE_NAME), {
                            keyPath: 'id'
                        });
                        store.createIndex((0, $gLGA8.TIME_TO_PROCESS_AFTER_INDEX), (0, $gLGA8.TIME_TO_PROCESS_AFTER_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $gLGA8.RETRY_INDEX), (0, $gLGA8.RETRY_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $gLGA8.TIME_ADDED_INDEX), (0, $gLGA8.TIME_ADDED_INDEX), {
                            unique: false
                        });
                        // Compound key index of product - timeAdded.
                        store.createIndex((0, $gLGA8.NAMESPACE_AND_TIME_ADDED_INDEX), [
                            'namespace',
                            'timeAdded'
                        ], {
                            unique: false
                        });
                    };
                    request.onerror = function() {
                        reject(new (0, $3gd5a.default)());
                    };
                    try {
                        await (0, $eIOk8.requestToPromise)(request);
                        return resolve(request.result);
                    } catch (error) {
                        this.logger.warn('IndexedDB failed to initialise.', error);
                        reject(new (0, $3gd5a.default)());
                    } finally{
                        window.clearTimeout(dbTimeout);
                    }
                } else {
                    this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                    reject(new (0, $3gd5a.default)());
                }
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "addItem", async (item, options = {}, policy = (0, $gLGA8.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const value = (0, $eIOk8.convertToItemWrapper)(item, namespace, options);
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            if (policy === (0, $gLGA8.GuardPolicy).IGNORE) throw new (0, $8P17o.default)(policy, 'IndexedDbConnector#addItem');
            try {
                if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== 'string') throw new Error('Namespace not specified');
                // Making space for 1 event, if required.
                const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                    value
                ], policy);
                if (bulkAddResult.items.length === 1) return {
                    item: bulkAddResult.items[0],
                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                };
                // Should never happen as the Policy and EventCountGuard should cause another pathway
                throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
            } catch (error) {
                if ((0, $1KJT2.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "bulkAddItem", async (itemOptions, policy = (0, $gLGA8.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const items = itemOptions.map((_ref)=>{
                let { item: item } = _ref, options = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $e1cdde904c307aac$var$_excluded);
                return (0, $eIOk8.convertToItemWrapper)(item, namespace, options);
            });
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
            } catch (error) {
                if ((0, $1KJT2.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "getItems", async (count = (0, $g22sj.GET_ITEM_COUNT))=>{
            const fixedCount = count > 0 ? count : (0, $g22sj.GET_ITEM_COUNT);
            const { logger: logger } = this;
            const maxAttempts = this.options.maxAttempts;
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            const timeIndex = objectStore.index((0, $gLGA8.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.openCursor(upperBoundOpenKeyRange);
            const getResult = await new Promise(async (resolve, reject)=>{
                const items = [];
                let numberOfDeletedItems = 0;
                request.onerror = (error)=>{
                    logger.error('Failed to open cursor:', error);
                    reject('Failed to open cursor');
                };
                // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (cursor) {
                        // Prevent mutation of the value we are returning
                        const value = $e1cdde904c307aac$var$_objectSpread({}, cursor.value);
                        items.push(value);
                        // Mutations seem to be required for testing indexeddb library
                        const updatedValue = cursor.value;
                        updatedValue.retryAttempts += 1;
                        updatedValue.timeToBeProcessedAfter = Date.now() + (0, $g22sj.VISIBILITY_TIMEOUT);
                        if (updatedValue.retryAttempts >= maxAttempts) {
                            ++numberOfDeletedItems;
                            const request = cursor.delete();
                            (0, $eIOk8.monitorErrorsOnRequest)(request, logger);
                        } else {
                            const request = cursor.update(updatedValue);
                            (0, $eIOk8.monitorErrorsOnRequest)(request, logger);
                        }
                        if (items.length < fixedCount) cursor.continue();
                        else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    } else resolve({
                        items: items,
                        numberOfDeletedItems: numberOfDeletedItems
                    });
                };
            });
            await (0, $eIOk8.commitTransaction)(transaction, this.logger);
            return getResult;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "deleteItems", async (itemIds)=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                await (0, $eIOk8.commitTransaction)(transaction, this.logger);
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "getItemCount", async ()=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readonly');
            const timeIndex = objectStore.index((0, $gLGA8.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.count(upperBoundOpenKeyRange);
            const event = await (0, $eIOk8.requestToPromise)(request);
            await (0, $eIOk8.commitTransaction)(transaction, this.logger);
            return event.target.result;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "processItems", async (processFn, count = (0, $g22sj.GET_ITEM_COUNT))=>{
            const _await$this$getItems = await this.getItems(count), { items: items } = _await$this$getItems, partialResult = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_await$this$getItems, $e1cdde904c307aac$var$_excluded2);
            try {
                const result = await processFn(items, partialResult);
                const itemIds = items.map((item)=>item.id);
                // We should not await this delete as a rejected promise would get caught by the catch statement
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                throw new (0, $h2nc6.default)(error);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "deleteItem", async (objectStore, id)=>{
            const { logger: logger } = this;
            try {
                await (0, $eIOk8.requestToPromise)(objectStore.delete(id));
            } catch (error) {
                logger.error('Failed to delete item:', id, error);
                throw error;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "getObjectStoreAndTransaction", async (mode)=>{
            const transaction = (await this.db).transaction((0, $gLGA8.RESILIENCE_STORE_NAME), mode);
            const objectStore = transaction.objectStore((0, $gLGA8.RESILIENCE_STORE_NAME));
            return {
                transaction: transaction,
                objectStore: objectStore
            };
        });
        this.options = (0, $eIOk8.createOptionsWithDefaults)(_options);
        this.namespace = _namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $3gd5a.default)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
     *
     * This class will enforce the number of analytics events we can store in our IndexedDB object store
     * if asked before adding items to the object store.
     */ this.globalEventLimitGuard = new (0, $eZpRU.default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
}

});
parcelRegister("g22sj", function(module, exports) {

$parcel$export(module.exports, "GET_ITEM_COUNT", function () { return $babebcdef2d42a74$export$b6df3d334cec060f; });
$parcel$export(module.exports, "VISIBILITY_TIMEOUT", function () { return $babebcdef2d42a74$export$14ef152a03a4b6ee; });
$parcel$export(module.exports, "MAX_ATTEMPTS", function () { return $babebcdef2d42a74$export$da9ab7b2fd5998e8; });
$parcel$export(module.exports, "EVENT_COUNT_LIMIT", function () { return $babebcdef2d42a74$export$1188664dfff364c8; });
const $babebcdef2d42a74$export$b6df3d334cec060f = 7;
const $babebcdef2d42a74$export$14ef152a03a4b6ee = 60000;
const $babebcdef2d42a74$export$da9ab7b2fd5998e8 = 10;
const $babebcdef2d42a74$export$1188664dfff364c8 = 5000;

});

parcelRegister("eZpRU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae9ad429c7040907$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");

var $gLGA8 = parcelRequire("gLGA8");

var $l5Q88 = parcelRequire("l5Q88");

var $eIOk8 = parcelRequire("eIOk8");
class $ae9ad429c7040907$export$2e2bcd8739ae039 {
    /**
   * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
   *
   * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ async insertItems(objectStore, items, policy = (0, $gLGA8.GuardPolicy).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, $gLGA8.GuardPolicy).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $gLGA8.GuardPolicy).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $gLGA8.GuardPolicy).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, $eIOk8.requestToPromise)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, $eIOk8.commitTransaction)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, $l5Q88.default)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
   * This query returns the count of items held in AWC IndexedDB object store per product.
   */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, $gLGA8.NAMESPACE_AND_TIME_ADDED_INDEX));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, $eIOk8.requestToPromise)(request);
        return event.target.result;
    }
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        /**
     * This query fetches the oldest events currently stored in AWC IndexedDb object store
     * and deletes them sequentially
     */ (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "deleteOldestNEvents", async (objectStore, count)=>{
            var _target;
            const productTimeAddedIndex = objectStore.index((0, $gLGA8.NAMESPACE_AND_TIME_ADDED_INDEX));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
            const event = await (0, $eIOk8.requestToPromise)(getAllRequest);
            const result = event === null || event === void 0 || (_target = event.target) === null || _target === void 0 ? void 0 : _target.result;
            // Adding extra safety
            if (result && Array.isArray(result) && result.length > 0) try {
                const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
}

});
parcelRegister("eIOk8", function(module, exports) {

$parcel$export(module.exports, "convertToItemWrapper", function () { return $ab7c3603cfe9fd55$export$aec476f33d77be11; });
$parcel$export(module.exports, "createOptionsWithDefaults", function () { return $ab7c3603cfe9fd55$export$ddc6718318090f71; });
$parcel$export(module.exports, "requestToPromise", function () { return $ab7c3603cfe9fd55$export$85ceed0783e42041; });
$parcel$export(module.exports, "commitTransaction", function () { return $ab7c3603cfe9fd55$export$feab8418f018df89; });
$parcel$export(module.exports, "monitorErrorsOnRequest", function () { return $ab7c3603cfe9fd55$export$342d941b6f724995; });

var $kbWO6 = parcelRequire("kbWO6");

var $g22sj = parcelRequire("g22sj");
const $ab7c3603cfe9fd55$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
        item: item,
        id: id || (0, (/*@__PURE__*/$parcel$interopDefault($kbWO6)))(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    });
const $ab7c3603cfe9fd55$export$ddc6718318090f71 = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $g22sj.MAX_ATTEMPTS),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $g22sj.EVENT_COUNT_LIMIT)
    });
const $ab7c3603cfe9fd55$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};
const $ab7c3603cfe9fd55$export$2a5213bce1720b42 = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};
const $ab7c3603cfe9fd55$export$feab8418f018df89 = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === 'function') transaction.commit();
    } catch (error) {
        logger.error('Failed to force commit transaction:', error);
        throw error;
    }
    return $ab7c3603cfe9fd55$export$2a5213bce1720b42(transaction);
};
const $ab7c3603cfe9fd55$export$342d941b6f724995 = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn('Error thrown from request:', event);
    };
};

});



parcelRegister("8Yx3b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $688d9069f488b078$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");

var $ai2Md = parcelRequire("ai2Md");

var $gLGA8 = parcelRequire("gLGA8");

var $g22sj = parcelRequire("g22sj");

var $h2nc6 = parcelRequire("h2nc6");
var $8P17o = parcelRequire("8P17o");

var $1hqhd = parcelRequire("1hqhd");

var $eIOk8 = parcelRequire("eIOk8");
const $688d9069f488b078$var$_excluded = [
    "item"
], $688d9069f488b078$var$_excluded2 = [
    "items"
];
function $688d9069f488b078$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $688d9069f488b078$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $688d9069f488b078$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $688d9069f488b078$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $688d9069f488b078$export$2e2bcd8739ae039 {
    /**
   * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
   * to removes oldest events when limit is reached.
   */ async addItem(item, options = {}, policy = (0, $gLGA8.GuardPolicy).ABANDON) {
        if (policy === (0, $gLGA8.GuardPolicy).IGNORE) throw new (0, $8P17o.default)(policy, 'IndexedDbConnector#addItem');
        const storedValue = (0, $eIOk8.convertToItemWrapper)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, $gLGA8.GuardPolicy).ABANDON) {
        const items = itemOptions.map((_ref)=>{
            let { item: item } = _ref, addOptions = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $688d9069f488b078$var$_excluded);
            return (0, $eIOk8.convertToItemWrapper)(item, this.namespace, addOptions);
        });
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
   * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
   */ bulkAddItemWrapperType(items, policy = (0, $gLGA8.GuardPolicy).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, $g22sj.GET_ITEM_COUNT)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, $g22sj.GET_ITEM_COUNT)) {
        const fixedCount = count > 0 ? count : (0, $g22sj.GET_ITEM_COUNT);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push($688d9069f488b078$var$_objectSpread({}, wrappedItem));
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, $g22sj.VISIBILITY_TIMEOUT);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const _this$synchronousGetI = this.synchronousGetItems(count), { items: items } = _this$synchronousGetI, partialGetResult = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_this$synchronousGetI, $688d9069f488b078$var$_excluded2);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, $h2nc6.default)(error);
        }
    }
    storeType() {
        return (0, $gLGA8.StoreType).MEMORY;
    }
    /**
   * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
   * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
   * memoryStore much faster.
   *
   * @param itemsToAdd
   */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
   * This function checks the number of events currently in AWC MemoryDb and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $eIOk8.createOptionsWithDefaults)(options);
        /**
     * This class will enforce the number of analytics events we can store in our MemoryDb
     */ this.globalEventLimitGuard = new (0, $1hqhd.default)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
}

});
parcelRegister("1hqhd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0eebc2f76bac97cd$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");

var $gLGA8 = parcelRequire("gLGA8");

var $l5Q88 = parcelRequire("l5Q88");
class $0eebc2f76bac97cd$export$2e2bcd8739ae039 {
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $l5Q88.default)((0, $gLGA8.StoreType).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
    constructor(eventLimit, memoryItemHandlers){
        /**
     * Unlike IndexedDb, we cannot take advantage of any index. So we are,
     * treating the memory store as a sorted set when adding items.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "insertItemsToMemoryStore", (itemsToAdd, policy)=>{
            switch(policy){
                case (0, $gLGA8.GuardPolicy).ABANDON:
                    return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $gLGA8.GuardPolicy).EVICT:
                    return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $gLGA8.GuardPolicy).IGNORE:
                    return this.handleAddAsManyAsPossible(itemsToAdd);
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.memoryItemHandlers = memoryItemHandlers;
    }
}

});




parcelRegister("2Z4H0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22c4eb1f64d6737b$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");

var $3wcTi = parcelRequire("3wcTi");
class $22c4eb1f64d6737b$export$4b62ee5120ab50a8 {
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
    constructor(){
        // Number of events discarded due to exceeding retry limits.
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "itemsDiscardedByRetry", 0);
        // Number of events created by the product in current tab.
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "eventCount", 0);
        // Number of events discarded due to reaching queue max size.
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "itemsDiscardedByOverflow", 0);
        // Will be used in the future when we get more resilience mechanisms
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "resilienceMechanism", (0, $3wcTi.ResilienceMechanism).INDEXEDDB);
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "localstorageNumberOfQueuesPurged", 0);
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "localstorageNumberOfFullReclaims", 0);
        // Queue was found but not all events were able to be put into resilienceDb.
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "localstorageNumberOfPartialReclaims", 0);
        // Reclaim failed for a queue and reclaim was abandonded.
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "localstorageNumberOfFailedReclaims", 0);
    }
}
let $22c4eb1f64d6737b$var$cachedMetricsClient = null;
var $22c4eb1f64d6737b$export$2e2bcd8739ae039 = ()=>{
    if (!$22c4eb1f64d6737b$var$cachedMetricsClient) $22c4eb1f64d6737b$var$cachedMetricsClient = new $22c4eb1f64d6737b$export$4b62ee5120ab50a8();
    return $22c4eb1f64d6737b$var$cachedMetricsClient;
};

});
parcelRegister("3wcTi", function(module, exports) {

$parcel$export(module.exports, "ResilienceMechanism", function () { return $28fe5c20252f4346$export$c75161629e3ec34e; });
$parcel$export(module.exports, "NetworkStatusEnum", function () { return $28fe5c20252f4346$export$ee138fa712d11b84; });
let $28fe5c20252f4346$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
let $28fe5c20252f4346$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});

});


parcelRegister("grZKu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf9f10fa2f8fd3af$export$2e2bcd8739ae039; });

var $3wcTi = parcelRequire("3wcTi");
class $bf9f10fa2f8fd3af$export$2e2bcd8739ae039 {
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, $3wcTi.NetworkStatusEnum).ONLINE;
        return (0, $3wcTi.NetworkStatusEnum).OFFLINE;
    }
    constructor(networkChangeCallback){
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>networkChangeCallback((0, $3wcTi.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>networkChangeCallback((0, $3wcTi.NetworkStatusEnum).ONLINE));
        }
    }
}

});

parcelRegister("kso36", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee4913ccd193c06d$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");

var $fE21v = parcelRequire("fE21v");

var $le7KR = parcelRequire("le7KR");
const $ee4913ccd193c06d$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
let $ee4913ccd193c06d$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class $ee4913ccd193c06d$export$2e2bcd8739ae039 {
    constructor(retryOptions, callback){
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "schedule", ({ immediate: immediate } = {
            immediate: false
        })=>{
            if (typeof window === 'undefined') return;
            if (this.operationInFlight) {
                if (immediate) this.queuedSchedule = $ee4913ccd193c06d$export$8bb92baee001fc60.IMMEDIATE;
                else if (this.queuedSchedule !== $ee4913ccd193c06d$export$8bb92baee001fc60.IMMEDIATE) this.queuedSchedule = $ee4913ccd193c06d$export$8bb92baee001fc60.WAIT;
            // Only run immediately if we have no failures
            } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                this.clearTimeout();
                this.run();
            // Backoff
            } else if (this.failureCount > 0 && this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
            else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.options.waitInterval);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "stop", ()=>{
            this.clearTimeout();
            this.queuedSchedule = $ee4913ccd193c06d$export$8bb92baee001fc60.NONE;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "getFailureCount", ()=>this.failureCount);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "getCallbackStatus", ()=>{
            return this.callbackTimer.getCallbackStatus();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "clearTimeout", ()=>{
            if (typeof window !== 'undefined' && this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "run", ()=>{
            this.operationInFlight = true;
            this.clearTimeout();
            try {
                this.callbackTimer.executeCallbackWithTimeout(// callback to execute
                this.callback, // when callback completes, call this function
                this.done, // on timeout, do this instead
                ()=>this.done((0, $le7KR.DoneState).ERROR));
            } catch (err) {
                this.done(err);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "done", (state)=>{
            this.operationInFlight = false;
            if (state === (0, $le7KR.DoneState).ERROR || this.callbackTimer.getCallbackStatus() === (0, $fE21v.CallbackStatus).TIMED_OUT) {
                this.failureCount++;
                this.clearTimeout();
            } else if (state === (0, $le7KR.DoneState).SUCCESS) this.failureCount = 0;
            this.processQueuedSchedule();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "processQueuedSchedule", ()=>{
            if (this.queuedSchedule !== $ee4913ccd193c06d$export$8bb92baee001fc60.NONE) {
                const immediate = this.queuedSchedule === $ee4913ccd193c06d$export$8bb92baee001fc60.IMMEDIATE;
                this.queuedSchedule = $ee4913ccd193c06d$export$8bb92baee001fc60.NONE;
                this.schedule({
                    immediate: immediate
                });
            } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
            // For example, when this.callback(this._done) was not called within
            // this.callbackTimeoutPeriod
            this.schedule();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "calculateBackoff", ()=>{
            const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage } = this.options;
            let ms = minRetryDelay * backoffFactor ** this.failureCount;
            if (backoffJitterPercentage) {
                const rand = Math.random();
                const deviation = Math.floor(rand * backoffJitterPercentage * ms);
                if (Math.floor(rand * 10) < 5) ms -= deviation;
                else ms += deviation;
            }
            return Number(Math.min(ms, maxRetryDelay).toPrecision(1));
        });
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || $ee4913ccd193c06d$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || $ee4913ccd193c06d$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || $ee4913ccd193c06d$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || $ee4913ccd193c06d$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $ee4913ccd193c06d$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $ee4913ccd193c06d$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = $ee4913ccd193c06d$export$8bb92baee001fc60.NONE;
        this.callbackTimer = new (0, $fE21v.CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
    }
}

});
parcelRegister("fE21v", function(module, exports) {

$parcel$export(module.exports, "CallbackStatus", function () { return $b63c2939c844ddac$export$ef3353088fca369c; });
$parcel$export(module.exports, "CallbackWithTimeout", function () { return $b63c2939c844ddac$export$590a718599f8f8b3; });

var $dsN6L = parcelRequire("dsN6L");
let $b63c2939c844ddac$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
let $b63c2939c844ddac$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class $b63c2939c844ddac$export$590a718599f8f8b3 {
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case $b63c2939c844ddac$export$ef3353088fca369c.IDLE:
            case $b63c2939c844ddac$export$ef3353088fca369c.TIMED_OUT:
            case $b63c2939c844ddac$export$ef3353088fca369c.COMPLETED:
                if (event === $b63c2939c844ddac$export$def7d978353eaa0.EXECUTE) this.callbackStatus = $b63c2939c844ddac$export$ef3353088fca369c.RUNNING;
                break;
            case $b63c2939c844ddac$export$ef3353088fca369c.RUNNING:
                switch(event){
                    case $b63c2939c844ddac$export$def7d978353eaa0.COMPLETE:
                        this.callbackStatus = $b63c2939c844ddac$export$ef3353088fca369c.COMPLETED;
                        break;
                    case $b63c2939c844ddac$export$def7d978353eaa0.TIMEOUT:
                        this.callbackStatus = $b63c2939c844ddac$export$ef3353088fca369c.TIMED_OUT;
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        if (typeof window === 'undefined') return;
        this.transitionCallbackStatus(this.callbackStatus, $b63c2939c844ddac$export$def7d978353eaa0.EXECUTE);
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, $b63c2939c844ddac$export$def7d978353eaa0.TIMEOUT);
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== $b63c2939c844ddac$export$ef3353088fca369c.TIMED_OUT) {
                this.transitionCallbackStatus(this.callbackStatus, $b63c2939c844ddac$export$def7d978353eaa0.COMPLETE);
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (typeof window !== 'undefined' && this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
    constructor(timeoutPeriod){
        // Milliseconds to wait
        // Tracks the settimeout; so that we can clear the timeout
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "timeoutHandle", undefined);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "callbackStatus", $b63c2939c844ddac$export$ef3353088fca369c.IDLE);
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error('CallbackWithTimeout requires timeout period higher than 0');
    }
}

});

parcelRegister("le7KR", function(module, exports) {

$parcel$export(module.exports, "DoneState", function () { return $f740ebb8823df1e3$export$f93c40fda808dd0c; });
// Clients can optionally provide the callbackTimeoutPeriod parameter
let $f740ebb8823df1e3$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});

});




parcelRegister("e8HTB", function(module, exports) {

$parcel$export(module.exports, "attachXidToMultipleEvents", function () { return $a4b3dcd4953929d0$export$c21270cab66ab290; });

var $dsN6L = parcelRequire("dsN6L");

var $hfae9 = parcelRequire("hfae9");
function $a4b3dcd4953929d0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a4b3dcd4953929d0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a4b3dcd4953929d0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a4b3dcd4953929d0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a4b3dcd4953929d0$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $hfae9.SegmentEventTypes).PAGE || item.msg.type === (0, $hfae9.SegmentEventTypes).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = $a4b3dcd4953929d0$var$_objectSpread($a4b3dcd4953929d0$var$_objectSpread({}, item.msg.properties), {}, {
            xid: xid
        });
    } else if (item.msg.traits && item.msg.type === (0, $hfae9.SegmentEventTypes).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = $a4b3dcd4953929d0$var$_objectSpread($a4b3dcd4953929d0$var$_objectSpread({}, item.msg.traits), {}, {
            xid: xid
        });
    }
    return item;
}
async function $a4b3dcd4953929d0$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>$a4b3dcd4953929d0$export$c9c3aaf655d6f275(item, xidCallback));
    } catch (error) {
        return items;
    }
}

});
parcelRegister("hfae9", function(module, exports) {

$parcel$export(module.exports, "SegmentEventTypes", function () { return $c8dbc54f46029771$export$ddf929981dc6feb3; });
// Segment event types copied from our backend
// https://bitbucket.org/atlassian/analytics-service/src/master/api/src/main/java/com/atlassian/dataservices/analytics/service/api/segment/
let $c8dbc54f46029771$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
let $c8dbc54f46029771$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
let $c8dbc54f46029771$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});

});


parcelRegister("cFFHy", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_REQUEST_TIMEOUT", function () { return $9399a967ea47d9f9$export$9175ce0e1c95daf2; });
const $9399a967ea47d9f9$export$9175ce0e1c95daf2 = 10000; // 10 seconds

});

parcelRegister("5HoMf", function(module, exports) {

$parcel$export(module.exports, "HTTP_STATUS_CODE_MAP", function () { return $42643025d7773016$export$ba118f9de1e5ac63; });
const $42643025d7773016$export$ba118f9de1e5ac63 = new Map([
    [
        200,
        'OK'
    ],
    [
        400,
        'Bad Request'
    ],
    [
        401,
        'Unauthorized'
    ],
    [
        402,
        'Payment Required'
    ],
    [
        403,
        'Forbidden'
    ],
    [
        404,
        'Not Found'
    ],
    [
        405,
        'Method Not Allowed'
    ],
    [
        406,
        'Not Acceptable'
    ],
    [
        407,
        'Proxy Authentication Required'
    ],
    [
        408,
        'Request Timeout'
    ],
    [
        409,
        'Conflict'
    ],
    [
        410,
        'Gone'
    ],
    [
        411,
        'Length Required'
    ],
    [
        412,
        'Precondition Failed'
    ],
    [
        413,
        'Payload Too Large'
    ],
    [
        414,
        'URI Too Long'
    ],
    [
        415,
        'Unsupported Media Type'
    ],
    [
        416,
        'Requested range not satisfiable'
    ],
    [
        417,
        'Expectation Failed'
    ],
    [
        418,
        "I'm a teapot"
    ],
    [
        422,
        'Unprocessable Entity'
    ],
    [
        423,
        'Locked'
    ],
    [
        424,
        'Failed Dependency'
    ],
    [
        425,
        'Too Early'
    ],
    [
        426,
        'Upgrade Required'
    ],
    [
        428,
        'Precondition Required'
    ],
    [
        429,
        'Too Many Requests'
    ],
    [
        431,
        'Request Header Fields Too Large'
    ],
    [
        451,
        'Unavailable For Legal Reasons'
    ],
    [
        500,
        'Internal Server Error'
    ],
    [
        501,
        'Not Implemented'
    ],
    [
        502,
        'Bad Gateway'
    ],
    [
        503,
        'Service Unavailable'
    ],
    [
        504,
        'Gateway Timeout'
    ],
    [
        505,
        'HTTP Version not supported'
    ],
    [
        506,
        'Variant Also Negotiates'
    ],
    [
        507,
        'Insufficient Storage'
    ],
    [
        508,
        'Loop Detected'
    ],
    [
        509,
        'Bandwidth Limit Exceeded'
    ],
    [
        510,
        'Not Extended'
    ],
    [
        511,
        'Network Authentication Required'
    ],
    [
        -1,
        'Unknown Status'
    ]
]);

});

parcelRegister("heliR", function(module, exports) {

$parcel$export(module.exports, "sendEvents", function () { return $c8b444da663abb6b$export$8e8f0180c1b41fad; });

var $dsN6L = parcelRequire("dsN6L");

var $79CCE = parcelRequire("79CCE");
function $c8b444da663abb6b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c8b444da663abb6b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c8b444da663abb6b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c8b444da663abb6b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $c8b444da663abb6b$export$8e8f0180c1b41fad = async (options)=>{
    var _createOrGetAbortCont;
    const signal = (_createOrGetAbortCont = $c8b444da663abb6b$var$createOrGetAbortController(options)) === null || _createOrGetAbortCont === void 0 ? void 0 : _createOrGetAbortCont.signal;
    const corsOptions = $c8b444da663abb6b$var$getCorsForUrl(options.url);
    const response = await fetch(options.url, $c8b444da663abb6b$var$_objectSpread({
        method: 'POST',
        // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
        headers: {
            'Content-Type': 'text/plain'
        },
        body: JSON.stringify(options.batch),
        signal: signal
    }, corsOptions));
    if (response.status === 429 || response.status >= 500 && response.status < 600) throw new Error(`HTTP Error ${response.status} (${response.statusText})`);
    return response;
};
const $c8b444da663abb6b$var$createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $c8b444da663abb6b$var$getCorsForUrl = (0, $79CCE.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});
parcelRegister("79CCE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53575547ddf1854d$export$2e2bcd8739ae039; });
var $53575547ddf1854d$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $53575547ddf1854d$var$isEqual(first, second) {
    if (first === second) return true;
    if ($53575547ddf1854d$var$safeIsNaN(first) && $53575547ddf1854d$var$safeIsNaN(second)) return true;
    return false;
}
function $53575547ddf1854d$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$53575547ddf1854d$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $53575547ddf1854d$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $53575547ddf1854d$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});


parcelRegister("6Xo9M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $510afdc848b1f94b$export$2e2bcd8739ae039; });

var $3mZkL = parcelRequire("3mZkL");

var $kbWO6 = parcelRequire("kbWO6");

var $jFgnw = parcelRequire("jFgnw");
var $28vxJ = parcelRequire("28vxJ");

var $k02jW = parcelRequire("k02jW");
// Cookie is stale, if anonymousId was generated 7 days ago.
const $510afdc848b1f94b$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const $510afdc848b1f94b$var$SAFE = 'SAFE';
const $510afdc848b1f94b$var$UNSAFE = 'UNSAFE';
const $510afdc848b1f94b$var$NOT_FOUND = 'NOT_FOUND';
const $510afdc848b1f94b$var$COOKIE = 'COOKIE';
const $510afdc848b1f94b$var$LOCAL_STORAGE = 'LOCAL_STORAGE';
class $510afdc848b1f94b$export$2e2bcd8739ae039 {
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId(customAnonymousIdGenerator) {
        /**
     * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
     * If not set in localStorage, check cookies. Also set localStorage for future attempts.
     * If not in cookies, generate a new one. Set both cookie and localStorage keys.
     */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set((0, $jFgnw.AWCCookiesKeys).AJS_ANONYMOUS_ID, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem((0, $jFgnw.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === $510afdc848b1f94b$var$LOCAL_STORAGE ? this.store.getItem((0, $jFgnw.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $jFgnw.AWCCookiesKeys).AJS_ANONYMOUS_ID);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: $510afdc848b1f94b$var$UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === 'string') return {
                    type: $510afdc848b1f94b$var$SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch (err) {
                /*
         * Segments new Analytics-next client will store strings as strings without stringifing.
         * The legacy Segment client and AWC always stringify and parse cookies and values.
         * If the new Segment analytics-client stores a cookie and local storage value first, it will
         * breaking old clients.
         *
         * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
         *
         * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
         */ return unsafeValue;
            }
        }
        return {
            type: $510afdc848b1f94b$var$NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage($510afdc848b1f94b$var$LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, $3mZkL.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $510afdc848b1f94b$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case $510afdc848b1f94b$var$SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case $510afdc848b1f94b$var$UNSAFE:
                return localStorageValue.anonymousId;
            case $510afdc848b1f94b$var$NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage($510afdc848b1f94b$var$COOKIE);
        switch(cookieValue.type){
            case $510afdc848b1f94b$var$SAFE:
            case $510afdc848b1f94b$var$UNSAFE:
                this.store.setItem((0, $jFgnw.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case $510afdc848b1f94b$var$NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId(customAnonymousIdGenerator = (0, (/*@__PURE__*/$parcel$interopDefault($kbWO6)))) {
        const newAnonId = customAnonymousIdGenerator();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
    constructor(disableCookiePersistence){
        this.store = new (0, $k02jW.default)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $28vxJ.default)(disableCookiePersistence);
    }
}

});
parcelRegister("3mZkL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $274300d491857a00$export$2e2bcd8739ae039; });

var $lTwVa = parcelRequire("lTwVa");

var $iYQiW = parcelRequire("iYQiW");

var $gLg3c = parcelRequire("gLg3c");
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $274300d491857a00$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $274300d491857a00$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $gLg3c.default)(2, arguments);
    var dateLeft = (0, $lTwVa.default)(dirtyDateLeft);
    var dateRight = (0, $lTwVa.default)(dirtyDateRight);
    var sign = $274300d491857a00$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $iYQiW.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($274300d491857a00$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("lTwVa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff084570d413ae9f$export$2e2bcd8739ae039; });

var $4y9O5 = parcelRequire("4y9O5");

var $gLg3c = parcelRequire("gLg3c");
function $ff084570d413ae9f$export$2e2bcd8739ae039(argument) {
    (0, $gLg3c.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $4y9O5.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("4y9O5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3501f1d28bb3b897$export$2e2bcd8739ae039; });
function $3501f1d28bb3b897$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $3501f1d28bb3b897$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3501f1d28bb3b897$export$2e2bcd8739ae039(o);
}

});

parcelRegister("gLg3c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c33d7c6f7984ceac$export$2e2bcd8739ae039; });
function $c33d7c6f7984ceac$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});


parcelRegister("iYQiW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd16672961e285ac$export$2e2bcd8739ae039; });

var $9P7SM = parcelRequire("9P7SM");

var $jDoiO = parcelRequire("jDoiO");

var $gLg3c = parcelRequire("gLg3c");
var $dd16672961e285ac$var$MILLISECONDS_IN_DAY = 86400000;
function $dd16672961e285ac$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $gLg3c.default)(2, arguments);
    var startOfDayLeft = (0, $jDoiO.default)(dirtyDateLeft);
    var startOfDayRight = (0, $jDoiO.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $9P7SM.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $9P7SM.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $dd16672961e285ac$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("9P7SM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $726efdc76781732d$export$2e2bcd8739ae039; });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $726efdc76781732d$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("jDoiO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4b482d09696d4c4$export$2e2bcd8739ae039; });

var $lTwVa = parcelRequire("lTwVa");

var $gLg3c = parcelRequire("gLg3c");
function $e4b482d09696d4c4$export$2e2bcd8739ae039(dirtyDate) {
    (0, $gLg3c.default)(1, arguments);
    var date = (0, $lTwVa.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});



parcelRegister("jFgnw", function(module, exports) {

$parcel$export(module.exports, "AWCCookiesKeys", function () { return $e50e8d0fb282c3a6$export$202d555a5dbfd90c; });
$parcel$export(module.exports, "AllAnalyticsCookies", function () { return $e50e8d0fb282c3a6$export$d4cb17942ea57c95; });
let $e50e8d0fb282c3a6$export$202d555a5dbfd90c = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
class $e50e8d0fb282c3a6$var$CookieSchema {
    getAttributes() {
        return this.options;
    }
    getKey() {
        return this.key;
    }
    constructor(key, options){
        this.key = key;
        this.options = options;
    }
}
const $e50e8d0fb282c3a6$var$isSecure = ()=>{
    try {
        return window && window.location && window.location.protocol === 'https:';
    } catch (err) {
        return false;
    }
};
const $e50e8d0fb282c3a6$export$d4cb17942ea57c95 = {
    [$e50e8d0fb282c3a6$export$202d555a5dbfd90c.AWC_TLD_TEST]: new $e50e8d0fb282c3a6$var$CookieSchema('__awc_tld_test__', {
        expires: 365,
        secure: $e50e8d0fb282c3a6$var$isSecure(),
        path: '/'
    }),
    [$e50e8d0fb282c3a6$export$202d555a5dbfd90c.AWC_ANALYTICS_DEBUG]: new $e50e8d0fb282c3a6$var$CookieSchema('atlassian_analytics_debug', {
        expires: 365,
        secure: $e50e8d0fb282c3a6$var$isSecure(),
        path: '/'
    }),
    [$e50e8d0fb282c3a6$export$202d555a5dbfd90c.AJS_ANONYMOUS_ID]: new $e50e8d0fb282c3a6$var$CookieSchema('ajs_anonymous_id', {
        expires: 365,
        secure: $e50e8d0fb282c3a6$var$isSecure(),
        path: '/'
    })
};

});

parcelRegister("28vxJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18e4cbe984172f1c$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");

var $1VX1s = parcelRequire("1VX1s");

var $jFgnw = parcelRequire("jFgnw");

var $7aKVU = parcelRequire("7aKVU");

var $gmxpV = parcelRequire("gmxpV");
function $18e4cbe984172f1c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $18e4cbe984172f1c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $18e4cbe984172f1c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $18e4cbe984172f1c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $18e4cbe984172f1c$export$2e2bcd8739ae039 {
    set(name, value, options) {
        // no-op
        if (!(0, $jFgnw.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not set.`);
            return;
        }
        return this.cookieLike.set((0, $jFgnw.AllAnalyticsCookies)[name].getKey(), value, $18e4cbe984172f1c$var$_objectSpread($18e4cbe984172f1c$var$_objectSpread({}, (0, $jFgnw.AllAnalyticsCookies)[name].getAttributes()), {}, {
            // Function is memoized so we only calculate this once per page load
            domain: (0, $gmxpV.getTld)()
        }, options));
    }
    get(name) {
        if (!(0, $jFgnw.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not fetched.`);
            return;
        }
        return this.cookieLike.get((0, $jFgnw.AllAnalyticsCookies)[name].getKey());
    }
    remove(name, options) {
        if (!(0, $jFgnw.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not removed.`);
            return;
        }
        this.cookieLike.remove((0, $jFgnw.AllAnalyticsCookies)[name].getKey(), $18e4cbe984172f1c$var$_objectSpread({}, options));
    }
    constructor(disableCookiePersistence){
        this.cookieLike = (0, $gmxpV.canUseCookie)(disableCookiePersistence) ? (0, (/*@__PURE__*/$parcel$interopDefault($1VX1s))) : new (0, $7aKVU.default)();
    }
}

});
parcelRegister("1VX1s", function(module, exports) {
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === 'function' && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    module.exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = extend({
                path: '/'
            }, api.defaults, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = key + '=' + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === 'undefined') return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var cookie = parts.slice(1).join('=');
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, '', extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});

});

parcelRegister("7aKVU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $538ddf7f920f5414$export$2e2bcd8739ae039; });

var $k02jW = parcelRequire("k02jW");
class $538ddf7f920f5414$export$2e2bcd8739ae039 {
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
    constructor(){
        this.safeStorage = new (0, $k02jW.default)({
            useStoragePrefix: false
        });
    }
}

});
parcelRegister("k02jW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8f59b94519a4ceb$export$2e2bcd8739ae039; });

var $bUIaX = parcelRequire("bUIaX");

var $7stv4 = parcelRequire("7stv4");
class $e8f59b94519a4ceb$export$2e2bcd8739ae039 extends (0, $7stv4.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.localStorage || (0, $bUIaX.default);
        } catch (err) {
            storageToUse = (0, $bUIaX.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("bUIaX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ac73108ca97d29f$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");
class $8ac73108ca97d29f$export$90e3e001bcac59c7 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_data", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "length", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "setItem", (key, value)=>{
            this._data[key] = value;
            this.length = Object.keys(this._data).length;
            return value;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "getItem", (key)=>{
            if (key in this._data) return this._data[key];
            return null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "removeItem", (key)=>{
            if (key in this._data) delete this._data[key];
            this.length = Object.keys(this._data).length;
            return null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "clear", ()=>{
            this._data = {};
            this.length = 0;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "key", (index)=>Object.keys(this._data)[index]);
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$8ac73108ca97d29f$export$2e2bcd8739ae039 = new $8ac73108ca97d29f$export$90e3e001bcac59c7();

});

parcelRegister("7stv4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56e20805f41837fc$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");

var $9UvCO = parcelRequire("9UvCO");

var $bUIaX = parcelRequire("bUIaX");
const $56e20805f41837fc$export$41c06fdd37b7e9a5 = 'awc';
const $56e20805f41837fc$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
function $56e20805f41837fc$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
function $56e20805f41837fc$export$6325979d1c67607f(e) {
    let quotaExceeded = false;
    if (e.code) switch(e.code){
        case 22:
            quotaExceeded = true;
            break;
        case 1014:
            // Firefox
            if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') quotaExceeded = true;
            break;
        default:
            break;
    }
    else if (e.number === -2147024882) // Internet Explorer 8
    quotaExceeded = true;
    return quotaExceeded;
}
class $56e20805f41837fc$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "getStore", ()=>this._store);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "getItem", (key)=>this._store.getItem(this.createKey(key)));
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "removeItem", (key)=>this._store.removeItem(this.createKey(key)));
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "setItem", (key, value)=>{
            try {
                this._store.setItem(this.createKey(key), value);
            } catch (err) {
                if ($56e20805f41837fc$export$6325979d1c67607f(err)) {
                    this.swapToInMemory();
                    this._store.setItem(this.createKey(key), value);
                }
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "swapToInMemory", ()=>{
            if (this._store === (0, $bUIaX.default) || typeof window === 'undefined') return;
            const keys = Object.keys(this._store || {});
            let inMemoryStorage;
            if ($56e20805f41837fc$export$48c17662a6902497(window[$56e20805f41837fc$export$770aa8bc07b3de03])) inMemoryStorage = window[$56e20805f41837fc$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $bUIaX.default);
                if (!window[$56e20805f41837fc$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                window[$56e20805f41837fc$export$770aa8bc07b3de03] = (0, $bUIaX.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this._store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this._store = inMemoryStorage;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "clear", ()=>this._store.clear());
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "key", (index)=>this._store.key(index));
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "getPrefix", ()=>this._prefix);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "createKey", (key)=>{
            if (this._prefix) return `${this.getPrefix()}.${key}`;
            return key;
        });
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($56e20805f41837fc$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $9UvCO.envType).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join('-');
        if ($56e20805f41837fc$export$48c17662a6902497(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
}

});



parcelRegister("gmxpV", function(module, exports) {

$parcel$export(module.exports, "canUseCookie", function () { return $be989f571a344656$export$a9330601ee8f4d95; });
$parcel$export(module.exports, "getTld", function () { return $be989f571a344656$export$de6821eed3d5f32d; });

var $1VX1s = parcelRequire("1VX1s");

var $79CCE = parcelRequire("79CCE");

var $jFgnw = parcelRequire("jFgnw");
const $be989f571a344656$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
    if (disableCookiePersistence) return false;
    return !(location.protocol === 'file:' || location.protocol === 'chrome-extension:');
};
const $be989f571a344656$export$eb80e1beaa8dacf8 = (0, $jFgnw.AllAnalyticsCookies).AWC_TLD_TEST.getKey();
const $be989f571a344656$export$19164982d36535d8 = 'tld_test';
const $be989f571a344656$export$de6821eed3d5f32d = (0, $79CCE.default)(()=>{
    if (typeof location === 'undefined') return '';
    const { hostname: hostname } = location;
    const splitHostname = hostname.split('.');
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join('.')}`;
        (0, (/*@__PURE__*/$parcel$interopDefault($1VX1s))).set($be989f571a344656$export$eb80e1beaa8dacf8, $be989f571a344656$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($1VX1s))).get($be989f571a344656$export$eb80e1beaa8dacf8) === $be989f571a344656$export$19164982d36535d8) {
            (0, (/*@__PURE__*/$parcel$interopDefault($1VX1s))).remove($be989f571a344656$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});

});



parcelRegister("eZyQr", function(module, exports) {

$parcel$export(module.exports, "buildContext", function () { return $aea1caa1ff9efdfd$export$3a7fe28f9bf4f3d9; });
$parcel$export(module.exports, "prepareEventProperties", function () { return $aea1caa1ff9efdfd$export$44d22e5fb02cc68e; });

var $dsN6L = parcelRequire("dsN6L");

var $1dehJ = parcelRequire("1dehJ");
function $aea1caa1ff9efdfd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $aea1caa1ff9efdfd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $aea1caa1ff9efdfd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $aea1caa1ff9efdfd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $aea1caa1ff9efdfd$export$3a7fe28f9bf4f3d9 = (context)=>{
    return $aea1caa1ff9efdfd$var$_objectSpread($aea1caa1ff9efdfd$var$_objectSpread({}, context.context), {}, {
        userAgent: navigator.userAgent
    });
};
const $aea1caa1ff9efdfd$export$44d22e5fb02cc68e = (properties)=>{
    const propertiesWithoutUndefined = $aea1caa1ff9efdfd$export$2250ccecd1e040fd(properties);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1dehJ)))(propertiesWithoutUndefined);
};
const $aea1caa1ff9efdfd$export$2250ccecd1e040fd = (obj)=>{
    if (obj === null || typeof obj !== 'object') return obj;
    const clone = {};
    Object.keys(obj).forEach((key)=>{
        const value = $aea1caa1ff9efdfd$var$getValueOfObject(obj, key);
        if (value !== undefined) {
            if (Array.isArray(value)) clone[key] = value.map((i)=>$aea1caa1ff9efdfd$export$2250ccecd1e040fd(i));
            else if (typeof value === 'object' && value !== null) clone[key] = $aea1caa1ff9efdfd$export$2250ccecd1e040fd(value);
            else clone[key] = value;
        }
    });
    return clone;
};
// Using ts-ignore everywhere urked me
const $aea1caa1ff9efdfd$var$getValueOfObject = (obj, key)=>{
    // @ts-ignore This is an object
    return obj[key];
};

});
parcelRegister("1dehJ", function(module, exports) {
'use strict';

var $2YUFU = parcelRequire("2YUFU");
/**
 * Expose `traverse`.
 */ module.exports = $0e221608db071b0b$var$traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $0e221608db071b0b$var$traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && typeof input === 'object') return $0e221608db071b0b$var$traverseObject(input, strict);
    else if (Array.isArray(input)) return $0e221608db071b0b$var$traverseArray(input, strict);
    else if ($2YUFU.is(input, strict)) return $2YUFU.parse(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $0e221608db071b0b$var$traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = $0e221608db071b0b$var$traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function $0e221608db071b0b$var$traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = $0e221608db071b0b$var$traverse(value, strict);
    });
    return arr;
}

});
parcelRegister("2YUFU", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $22bd25d4c9e9aee3$export$98e6a39c04603d36; }, function (v) { return $22bd25d4c9e9aee3$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "is", function () { return $22bd25d4c9e9aee3$export$226b3eccf92c9ed9; }, function (v) { return $22bd25d4c9e9aee3$export$226b3eccf92c9ed9 = v; });
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ var $22bd25d4c9e9aee3$export$98e6a39c04603d36;
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ var $22bd25d4c9e9aee3$export$226b3eccf92c9ed9;
'use strict';
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var $22bd25d4c9e9aee3$var$matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
$22bd25d4c9e9aee3$export$98e6a39c04603d36 = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = $22bd25d4c9e9aee3$var$matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + '00').substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === ' ') offset = new Date().getTimezoneOffset();
    else if (arr[9] !== 'Z' && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === '+') offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
$22bd25d4c9e9aee3$export$226b3eccf92c9ed9 = function(string, strict) {
    if (typeof string !== 'string') return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return $22bd25d4c9e9aee3$var$matcher.test(string);
};

});




parcelRegister("kFQH5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0d082e6a1fe5ef4$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");

var $9UvCO = parcelRequire("9UvCO");

var $6TSJ2 = parcelRequire("6TSJ2");
class $f0d082e6a1fe5ef4$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "handleOriginParameters", (originParamHandlerMapping, historyReplaceFn)=>{
            // Collect all the parameter labels to be handled
            const originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error('Empty parameter mapping provided');
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $9UvCO.originTracingType)).indexOf(x) < 0);
            if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
            const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
            // Capture and remove params from URL
            const capturedURLParams = (0, $6TSJ2.default)(isCaptureParam, historyReplaceFn);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            const applyHandlerFunction = (key)=>{
                const x = originParamHandlerMapping[key](capturedURLParams[key]);
                return {
                    [key]: x
                };
            };
            const extractedOriginID = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
            return extractedOriginID;
        });
        this._originStore = {};
    }
}

});
parcelRegister("6TSJ2", function(module, exports) {

$parcel$export(module.exports, "defaultHistoryReplaceFn", function () { return $50625470e313fdcd$export$600dd5bf1b049f11; });
$parcel$export(module.exports, "default", function () { return $50625470e313fdcd$export$2e2bcd8739ae039; });

var $gSf9T = parcelRequire("gSf9T");

var $cFYwb = parcelRequire("cFYwb");
const $50625470e313fdcd$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, '', newUrl);
const $50625470e313fdcd$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = $50625470e313fdcd$export$600dd5bf1b049f11)=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== '' ? originalUrl.replace(fragmentHash, '') : originalUrl;
    const { url: url, query: query } = (0, $gSf9T.parseUrl)(removedFragmentURL);
    const captureParams = (0, $cFYwb.pickBy)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, $cFYwb.omitBy)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, $gSf9T.stringify)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
var $50625470e313fdcd$export$2e2bcd8739ae039 = $50625470e313fdcd$var$urlParamExtractor;

});
parcelRegister("gSf9T", function(module, exports) {

$parcel$export(module.exports, "extract", function () { return $c48d72ae90fc54af$export$f9380c9a627682d3; }, function (v) { return $c48d72ae90fc54af$export$f9380c9a627682d3 = v; });
$parcel$export(module.exports, "parse", function () { return $c48d72ae90fc54af$export$98e6a39c04603d36; }, function (v) { return $c48d72ae90fc54af$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $c48d72ae90fc54af$export$fac44ee5b035f737; }, function (v) { return $c48d72ae90fc54af$export$fac44ee5b035f737 = v; });
$parcel$export(module.exports, "parseUrl", function () { return $c48d72ae90fc54af$export$7a5253c0f62e0150; }, function (v) { return $c48d72ae90fc54af$export$7a5253c0f62e0150 = v; });
$parcel$export(module.exports, "stringifyUrl", function () { return $c48d72ae90fc54af$export$a8c1621ea79325d3; }, function (v) { return $c48d72ae90fc54af$export$a8c1621ea79325d3 = v; });
$parcel$export(module.exports, "pick", function () { return $c48d72ae90fc54af$export$357523c63a2253b9; }, function (v) { return $c48d72ae90fc54af$export$357523c63a2253b9 = v; });
var $c48d72ae90fc54af$export$f9380c9a627682d3;
var $c48d72ae90fc54af$export$98e6a39c04603d36;
var $c48d72ae90fc54af$export$fac44ee5b035f737;
var $c48d72ae90fc54af$export$7a5253c0f62e0150;
var $c48d72ae90fc54af$export$a8c1621ea79325d3;
var $c48d72ae90fc54af$export$357523c63a2253b9;
var $c48d72ae90fc54af$export$44c361b8ec72ef7f;
'use strict';

var $fsLZj = parcelRequire("fsLZj");

var $gDzas = parcelRequire("gDzas");

var $1RfQo = parcelRequire("1RfQo");

var $hLK2l = parcelRequire("hLK2l");
const $c48d72ae90fc54af$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $c48d72ae90fc54af$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $c48d72ae90fc54af$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $c48d72ae90fc54af$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $c48d72ae90fc54af$var$encode(key, options),
                            '[',
                            $c48d72ae90fc54af$var$encode(index, options),
                            ']=',
                            $c48d72ae90fc54af$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $c48d72ae90fc54af$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $c48d72ae90fc54af$var$encode(key, options),
                            '[]=',
                            $c48d72ae90fc54af$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $c48d72ae90fc54af$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $c48d72ae90fc54af$var$encode(key, options),
                            ':list=',
                            $c48d72ae90fc54af$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $c48d72ae90fc54af$var$encode(key, options),
                                keyValueSep,
                                $c48d72ae90fc54af$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $c48d72ae90fc54af$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $c48d72ae90fc54af$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $c48d72ae90fc54af$var$encode(key, options),
                            '=',
                            $c48d72ae90fc54af$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $c48d72ae90fc54af$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $c48d72ae90fc54af$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $c48d72ae90fc54af$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$c48d72ae90fc54af$var$decode(item, options)) : value === null ? value : $c48d72ae90fc54af$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $c48d72ae90fc54af$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$c48d72ae90fc54af$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $c48d72ae90fc54af$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $c48d72ae90fc54af$var$encode(value, options) {
    if (options.encode) return options.strict ? $fsLZj(value) : encodeURIComponent(value);
    return value;
}
function $c48d72ae90fc54af$var$decode(value, options) {
    if (options.decode) return $gDzas(value);
    return value;
}
function $c48d72ae90fc54af$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $c48d72ae90fc54af$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $c48d72ae90fc54af$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $c48d72ae90fc54af$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $c48d72ae90fc54af$var$extract(input) {
    input = $c48d72ae90fc54af$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $c48d72ae90fc54af$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $c48d72ae90fc54af$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $c48d72ae90fc54af$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $c48d72ae90fc54af$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $1RfQo(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $c48d72ae90fc54af$var$decode(value, options);
        formatter($c48d72ae90fc54af$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $c48d72ae90fc54af$var$parseValue(value[k], options);
        else ret[key] = $c48d72ae90fc54af$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $c48d72ae90fc54af$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$c48d72ae90fc54af$export$f9380c9a627682d3 = $c48d72ae90fc54af$var$extract;
$c48d72ae90fc54af$export$98e6a39c04603d36 = $c48d72ae90fc54af$var$parse;
$c48d72ae90fc54af$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $c48d72ae90fc54af$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $c48d72ae90fc54af$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $c48d72ae90fc54af$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $c48d72ae90fc54af$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $c48d72ae90fc54af$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $c48d72ae90fc54af$var$encode(key, options) + '=' + $c48d72ae90fc54af$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$c48d72ae90fc54af$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $1RfQo(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $c48d72ae90fc54af$var$parse($c48d72ae90fc54af$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $c48d72ae90fc54af$var$decode(hash, options)
    } : {});
};
$c48d72ae90fc54af$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$c48d72ae90fc54af$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $c48d72ae90fc54af$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $c48d72ae90fc54af$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $c48d72ae90fc54af$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $c48d72ae90fc54af$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $c48d72ae90fc54af$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$c48d72ae90fc54af$var$encodeFragmentIdentifier] ? $c48d72ae90fc54af$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$c48d72ae90fc54af$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$c48d72ae90fc54af$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $c48d72ae90fc54af$export$7a5253c0f62e0150(input, options);
    return $c48d72ae90fc54af$export$a8c1621ea79325d3({
        url: url,
        query: $hLK2l(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$c48d72ae90fc54af$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $c48d72ae90fc54af$export$357523c63a2253b9(input, exclusionFilter, options);
};

});
parcelRegister("fsLZj", function(module, exports) {
'use strict';
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("gDzas", function(module, exports) {
'use strict';
var $c1cb9169ff1ca292$var$token = '%[a-f0-9]{2}';
var $c1cb9169ff1ca292$var$singleMatcher = new RegExp('(' + $c1cb9169ff1ca292$var$token + ')|([^%]+?)', 'gi');
var $c1cb9169ff1ca292$var$multiMatcher = new RegExp('(' + $c1cb9169ff1ca292$var$token + ')+', 'gi');
function $c1cb9169ff1ca292$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $c1cb9169ff1ca292$var$decodeComponents(left), $c1cb9169ff1ca292$var$decodeComponents(right));
}
function $c1cb9169ff1ca292$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($c1cb9169ff1ca292$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $c1cb9169ff1ca292$var$decodeComponents(tokens, i).join('');
            tokens = input.match($c1cb9169ff1ca292$var$singleMatcher) || [];
        }
        return input;
    }
}
function $c1cb9169ff1ca292$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    var match = $c1cb9169ff1ca292$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $c1cb9169ff1ca292$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $c1cb9169ff1ca292$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
    try {
        encodedURI = encodedURI.replace(/\+/g, ' ');
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $c1cb9169ff1ca292$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("1RfQo", function(module, exports) {
'use strict';
module.exports = (string, separator)=>{
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (separator === '') return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("hLK2l", function(module, exports) {
'use strict';
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});




parcelRegister("6Mvxe", function(module, exports) {

$parcel$export(module.exports, "selectHost", function () { return $01463041eb5b7db9$export$18c0b81944902eae; });

var $9UvCO = parcelRequire("9UvCO");
const $01463041eb5b7db9$var$PROD_HOST = 'as.atlassian.com/api/v1';
const $01463041eb5b7db9$var$STARGATE_PROD_HOST = 'api-private.atlassian.com/gasv3/api/v1';
const $01463041eb5b7db9$var$STAGING_HOST = 'as.staging.atl-paas.net/api/v1';
const $01463041eb5b7db9$var$STARGATE_STAGING_HOST = 'api-private.stg.atlassian.com/gasv3/api/v1';
const $01463041eb5b7db9$var$FEDRAMP_STAGING_HOST = 'as.staging.atl-paas-us-gov-mod.net/api/v1';
const $01463041eb5b7db9$var$FEDRAMP_PROD_HOST = 'as.atlassian-us-gov-mod.com/api/v1';
const $01463041eb5b7db9$var$STARGATE_FEDRAMP_STAGING_HOST = 'api.stg.atlassian-us-gov-mod.com/gasv3/api/v1';
const $01463041eb5b7db9$var$STARGATE_FEDRAMP_PROD_HOST = 'api.atlassian-us-gov-mod.com/gasv3/api/v1';
const $01463041eb5b7db9$var$STARGATE_PROXY_PATH = '/gateway/api/gasv3/api/v1';
const $01463041eb5b7db9$var$handleFedRampStagingDirect = ()=>{
    return $01463041eb5b7db9$var$FEDRAMP_STAGING_HOST;
};
const $01463041eb5b7db9$var$handleFedRampStagingStargate = ()=>{
    return $01463041eb5b7db9$var$STARGATE_FEDRAMP_STAGING_HOST;
};
const $01463041eb5b7db9$var$handleFedRampModerate = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, envOverride: envOverride })=>{
    if (env === (0, $9UvCO.envType).LOCAL || env === (0, $9UvCO.envType).DEV) throw Error('No LOCAL or DEV environments for FedRAMP.');
    if (env === (0, $9UvCO.envType).PROD && envOverride) throw Error('Cannot override to FedRAMP Sandbox for Prod.');
    if (!useStargate) return env === (0, $9UvCO.envType).PROD ? $01463041eb5b7db9$var$FEDRAMP_PROD_HOST : $01463041eb5b7db9$var$handleFedRampStagingDirect();
    if (useLegacyUrl) return env === (0, $9UvCO.envType).PROD ? $01463041eb5b7db9$var$STARGATE_FEDRAMP_PROD_HOST : $01463041eb5b7db9$var$handleFedRampStagingStargate();
    /**
   * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
   * For more details, see:
   *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
   *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
   */ return window.location.host + $01463041eb5b7db9$var$STARGATE_PROXY_PATH;
};
const $01463041eb5b7db9$var$handleCommercial = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl })=>{
    if (!useStargate) return env === (0, $9UvCO.envType).PROD ? $01463041eb5b7db9$var$PROD_HOST : $01463041eb5b7db9$var$STAGING_HOST;
    if (useLegacyUrl) return env === (0, $9UvCO.envType).PROD ? $01463041eb5b7db9$var$STARGATE_PROD_HOST : $01463041eb5b7db9$var$STARGATE_STAGING_HOST;
    /**
   * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
   * For more details, see:
   *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
   *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
   */ return window.location.host + $01463041eb5b7db9$var$STARGATE_PROXY_PATH;
};
function $01463041eb5b7db9$export$18c0b81944902eae({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter, envOverride: envOverride }) {
    if (perimeter === (0, $9UvCO.perimeterType).FEDRAMP_MODERATE) return $01463041eb5b7db9$var$handleFedRampModerate({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl,
        envOverride: envOverride
    });
    return $01463041eb5b7db9$var$handleCommercial({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl
    });
}

});

parcelRegister("dOulP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0e77cfa53b6a41b$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");

var $k02jW = parcelRequire("k02jW");
const $a0e77cfa53b6a41b$var$SESSION_ID_STORAGE_KEY = 'session.id';
const $a0e77cfa53b6a41b$var$SESSION_EXPIRY_STORAGE_KEY = 'session.expiry';
const $a0e77cfa53b6a41b$var$ONLY_NUMBERS_REGEX = /^\d+$/;
const $a0e77cfa53b6a41b$export$285f6bddd927a06d = 1800000; // 30 minutes
const $a0e77cfa53b6a41b$export$a92e915d70316eb2 = 5000; // 5 seconds
const $a0e77cfa53b6a41b$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $a0e77cfa53b6a41b$export$5702a91a6f42969f = ()=>{};
class $a0e77cfa53b6a41b$export$2e2bcd8739ae039 {
    getCurrentSessionId() {
        const sessionId = this._safeLocalStorage.getItem($a0e77cfa53b6a41b$var$SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem($a0e77cfa53b6a41b$var$SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        if (!sessionId || sessionExpiry <= Date.now() || Number.isNaN(sessionExpiry)) return this._generateNewSessionId();
        // Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (!$a0e77cfa53b6a41b$var$ONLY_NUMBERS_REGEX.test(sessionId)) return this._generateNewSessionId();
        return sessionId;
    }
    constructor(options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_generateNewSessionId", ()=>{
            const newSessionId = Date.now().toString();
            this._safeLocalStorage.setItem($a0e77cfa53b6a41b$var$SESSION_ID_STORAGE_KEY, newSessionId);
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            this._onNewSessionStarted && this._onNewSessionStarted();
            return newSessionId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_updateSessionExpiry", ()=>{
            const expiry = Date.now() + this._sessionExpiryTime;
            this._safeLocalStorage.setItem($a0e77cfa53b6a41b$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_debouncedUpdateSessionExpiry", (currentExpiry)=>{
            const { _updateSessionExpiry: _updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) return _updateSessionExpiry();
            else {
                if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this._sessionExpiryDebounceTimer = setTimeout(()=>{
                    _updateSessionExpiry();
                }, this._sessionExpiryDebounce);
            }
        });
        this._sessionExpiryTime = options.sessionExpiryTime || $a0e77cfa53b6a41b$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $a0e77cfa53b6a41b$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $a0e77cfa53b6a41b$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : $a0e77cfa53b6a41b$export$5702a91a6f42969f;
        this._safeLocalStorage = new (0, $k02jW.default)();
    }
}

});

parcelRegister("4meW7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32c4cd915c357e51$export$2e2bcd8739ae039; });

var $bUIaX = parcelRequire("bUIaX");

var $7stv4 = parcelRequire("7stv4");
class $32c4cd915c357e51$export$2e2bcd8739ae039 extends (0, $7stv4.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.sessionStorage || (0, $bUIaX.default);
        } catch (err) {
            storageToUse = (0, $bUIaX.default);
        }
        super(storageToUse, options);
    }
}

});

parcelRegister("6yYN7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c7512e7d5520613$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");

var $kbWO6 = parcelRequire("kbWO6");

var $4meW7 = parcelRequire("4meW7");
const $4c7512e7d5520613$var$STORAGE_KEY = 'tab.id';
class $4c7512e7d5520613$export$2e2bcd8739ae039 {
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem($4c7512e7d5520613$var$STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_generateNewTabId", ()=>{
            const newTabId = (0, (/*@__PURE__*/$parcel$interopDefault($kbWO6)))();
            this._safeSessionStorage.setItem($4c7512e7d5520613$var$STORAGE_KEY, newTabId);
            return newTabId;
        });
        this._safeSessionStorage = new (0, $4meW7.default)();
    }
}

});

parcelRegister("hIO3P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce6d60c10d7dc719$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");

var $gSf9T = parcelRequire("gSf9T");

var $kbWO6 = parcelRequire("kbWO6");

var $9UvCO = parcelRequire("9UvCO");

var $cFYwb = parcelRequire("cFYwb");

var $4meW7 = parcelRequire("4meW7");

var $6TSJ2 = parcelRequire("6TSJ2");
function $ce6d60c10d7dc719$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ce6d60c10d7dc719$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ce6d60c10d7dc719$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ce6d60c10d7dc719$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $ce6d60c10d7dc719$var$STORAGE_KEY = 'taskSessions';
const $ce6d60c10d7dc719$var$INIT_KEY = 'taskSessionsInit';
const $ce6d60c10d7dc719$var$AWC_PARAM_PREFIX = 'awc.';
const $ce6d60c10d7dc719$var$TASK_SESSION_RELOAD_TIME = 3000;
class $ce6d60c10d7dc719$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_taskSessionsNotRecentlyInitialised", (currentTimestamp)=>this._safeSessionStorage.getItem($ce6d60c10d7dc719$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($ce6d60c10d7dc719$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($ce6d60c10d7dc719$var$INIT_KEY) || '0', 10) < currentTimestamp - $ce6d60c10d7dc719$var$TASK_SESSION_RELOAD_TIME);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_removeTaskSessionPrefix", (_, taskSessionName)=>taskSessionName.split($ce6d60c10d7dc719$var$AWC_PARAM_PREFIX)[1]);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_isTaskSessionQueryParam", (_, taskSessionName)=>taskSessionName.startsWith($ce6d60c10d7dc719$var$AWC_PARAM_PREFIX));
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "getAllTaskSessions", ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($ce6d60c10d7dc719$var$STORAGE_KEY) || '');
            } catch (e) {
                return {};
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_writeToSessionStorage", (taskSessions)=>{
            try {
                this._safeSessionStorage.setItem($ce6d60c10d7dc719$var$STORAGE_KEY, JSON.stringify(taskSessions));
            // eslint-disable-next-line no-empty
            } catch (e) {}
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_appendTaskSessions", (newTaskSessions)=>{
            const currentState = this.getAllTaskSessions();
            const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
            this._writeToSessionStorage(newState);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_safelyRemoveKey", (currentState, taskSessionName)=>{
            if (currentState === null) return {};
            delete currentState[taskSessionName];
            return currentState;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "createTaskSession", (taskSessionName)=>{
            const taskSessionId = (0, (/*@__PURE__*/$parcel$interopDefault($kbWO6)))();
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
            return taskSessionId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "createTaskSessionWithProvidedId", (taskSessionName, taskSessionId)=>{
            if (typeof taskSessionId !== 'string') throw new TypeError('invalid taskSessionId, must be string');
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "completeTaskSession", (taskSessionName)=>{
            const currentState = this.getAllTaskSessions();
            const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
            this._writeToSessionStorage(updatedState);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "formatTaskSessionQueryString", ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
            const { url: url, query: query } = (0, $gSf9T.parseUrl)(uri);
            const currentState = this.getAllTaskSessions();
            // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
            const filteredTaskSessions = includedTaskSessions ? (0, $cFYwb.pick)(currentState, includedTaskSessions) : (0, $cFYwb.omit)(currentState, Object.values((0, $9UvCO.originTracingType)));
            if (Object.keys(filteredTaskSessions).length === 0) return uri;
            const queryWithTaskSessions = $ce6d60c10d7dc719$var$_objectSpread($ce6d60c10d7dc719$var$_objectSpread({}, (0, $cFYwb.mapKeys)(filteredTaskSessions, (_, taskSessionName)=>$ce6d60c10d7dc719$var$AWC_PARAM_PREFIX + taskSessionName)), query);
            return `${url}?${(0, $gSf9T.stringify)(queryWithTaskSessions)}`;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "stripQueryParameters", ()=>{
            const extractedTaskSessions = (0, $cFYwb.mapKeys)((0, $6TSJ2.default)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
            this._appendTaskSessions(extractedTaskSessions);
        });
        const _currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, $4meW7.default)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(_currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem($ce6d60c10d7dc719$var$INIT_KEY, _currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}

});

parcelRegister("is91y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6f1d784c76446b8$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");

var $1VX1s = parcelRequire("1VX1s");

var $jFgnw = parcelRequire("jFgnw");
const $d6f1d784c76446b8$var$MAX_CACHE_SIZE = 100;
const $d6f1d784c76446b8$var$COOKIE_NAME = (0, $jFgnw.AllAnalyticsCookies).AWC_ANALYTICS_DEBUG.getKey();
const $d6f1d784c76446b8$var$DEBUG_TAG = 'synthetic';
const $d6f1d784c76446b8$var$getDebugCookie = ()=>{
    try {
        return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($1VX1s))).get($d6f1d784c76446b8$var$COOKIE_NAME) || 'false');
    } catch (error) {
        (0, (/*@__PURE__*/$parcel$interopDefault($1VX1s))).remove($d6f1d784c76446b8$var$COOKIE_NAME);
    }
    return false;
};
class $d6f1d784c76446b8$var$TestingCache {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_bind", ()=>{
            if (typeof window === 'undefined' || window.testAnalytics) return;
            window.testAnalytics = {
                eventCache: [],
                events: ()=>window.testAnalytics.eventCache,
                clear: ()=>{
                    window.testAnalytics.eventCache = [];
                    try {
                        localStorage.removeItem('awc.ui.viewed.last.sent');
                        localStorage.removeItem('awc-staging.ui.viewed.last.sent');
                        localStorage.removeItem('awc-dev.ui.viewed.last.sent');
                        localStorage.removeItem('awc-local.ui.viewed.last.sent');
                    } catch (_error) {
                    // Ignore errors from localStorage.
                    }
                }
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_cache", (event)=>{
            if (typeof window === 'undefined') return;
            if (window.testAnalytics.eventCache.length >= $d6f1d784c76446b8$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
            window.testAnalytics.eventCache.push(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_shouldCacheEvent", ()=>this._isDebugCookieEnabled);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "saveEvent", (event)=>{
            if (event && this._shouldCacheEvent()) {
                if (!window.testAnalytics) this._bind();
                if (event.tags instanceof Array) event.tags.push($d6f1d784c76446b8$var$DEBUG_TAG);
                else event.tags = [
                    $d6f1d784c76446b8$var$DEBUG_TAG
                ];
                this._cache(event);
            }
        });
        this._isDebugCookieEnabled = $d6f1d784c76446b8$var$getDebugCookie();
        if (this._isDebugCookieEnabled) this._bind();
    }
}
var $d6f1d784c76446b8$export$2e2bcd8739ae039 = $d6f1d784c76446b8$var$TestingCache;

});

parcelRegister("c5fHl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8cc220f9b8d81fdf$export$2e2bcd8739ae039; });

var $ai2Md = parcelRequire("ai2Md");

var $dsN6L = parcelRequire("dsN6L");

var $9UvCO = parcelRequire("9UvCO");

var $k02jW = parcelRequire("k02jW");
const $8cc220f9b8d81fdf$var$_excluded = [
    "embeddedProduct"
];
function $8cc220f9b8d81fdf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8cc220f9b8d81fdf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8cc220f9b8d81fdf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8cc220f9b8d81fdf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $8cc220f9b8d81fdf$var$DEFAULT_DELAY = 2000; // 2 seconds
const $8cc220f9b8d81fdf$var$DEFAULT_THROTTLE = 3600000; // 1 hour
const $8cc220f9b8d81fdf$var$DEFAULT_STORAGE_KEY = 'ui.viewed.last.sent';
class $8cc220f9b8d81fdf$export$2e2bcd8739ae039 {
    constructor(productInfo, getContext, onEvent, settings = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "start", ()=>{
            this._startInterval();
            this._bindEventListeners();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "stop", ()=>{
            this._stopInterval();
            this._unbindEventListeners();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "resetTimers", ()=>{
            if (this._intervalId) {
                this.stop();
                this.start();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_bindEventListeners", ()=>{
            if (typeof window !== 'undefined') {
                window.addEventListener('focus', this._focusListener);
                window.addEventListener('blur', this._blurListener);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_unbindEventListeners", ()=>{
            if (typeof window !== 'undefined') {
                window.removeEventListener('focus', this._focusListener);
                window.removeEventListener('blur', this._blurListener);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_startInterval", ()=>{
            clearInterval(this._intervalId);
            this._intervalId = setInterval(this._handleInterval, this._delay);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_stopInterval", ()=>{
            if (this._intervalId) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_getProductKey", (product, subproduct)=>{
            let productKey = product;
            if (subproduct) productKey += `-${subproduct}`;
            return productKey;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_getLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData() || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            const p = t[productKey] || null;
            return p;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_parseLocalStorageData", ()=>{
            const data = this._safeLocalStorage.getItem(this._storageKey);
            try {
                return JSON.parse(data || '');
            } catch (error) {
                this._safeLocalStorage.removeItem(this._storageKey);
                return null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_setLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData() || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            t[productKey] = Date.now();
            u[tenantId] = t;
            json[userId] = u;
            this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_shouldSendEvent", (productKey, tenantIdType, tenantId, userId)=>{
            if (!document.hasFocus()) return false;
            if (tenantIdType !== (0, $9UvCO.tenantType).NONE && !tenantId || !userId) return false;
            const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
            return sinceLastSent > this._throttle;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_handleInterval", ()=>{
            const _this$_getContext = this._getContext(), { embeddedProduct: embeddedProduct } = _this$_getContext, context = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_this$_getContext, $8cc220f9b8d81fdf$var$_excluded);
            this._sendEvent(this._product, context);
            if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_sendEvent", (product, context, isEmbeddedProduct = false)=>{
            const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
            const productKey = this._getProductKey(product, subproduct);
            if (this._shouldSendEvent(productKey, tenantIdType, tenantId, userId)) {
                this._setLastSentTimestamp(productKey, tenantId, userId);
                const event = this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes);
                this._onEvent(event);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_createEvent", (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes)=>{
            const event = {
                product: product,
                source: 'ui',
                action: 'viewed',
                actionSubject: 'ui',
                attributes: extraAttributes
            };
            if (isEmbeddedProduct) {
                // Clear the subproduct and version as they don't relate to the embedded product
                event.subproduct = null;
                event.version = null;
                event.attributes = $8cc220f9b8d81fdf$var$_objectSpread($8cc220f9b8d81fdf$var$_objectSpread({}, event.attributes), {}, {
                    embeddedInEnv: this._productInfo.env,
                    embeddedInProduct: this._productInfo.product,
                    embeddedInSubproduct: subproduct,
                    embeddedInVersion: this._productInfo.version,
                    embeddedInOrigin: this._productInfo.origin,
                    embeddedInPlatform: this._productInfo.platform
                });
            }
            if (lastScreenEvent) event.attributes = $8cc220f9b8d81fdf$var$_objectSpread($8cc220f9b8d81fdf$var$_objectSpread({}, event.attributes), {}, {
                lastScreenEvent: {
                    name: lastScreenEvent.name,
                    attributes: lastScreenEvent.attributes
                }
            });
            return event;
        });
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!getContext) throw new Error('Missing getContext callback');
        if (typeof getContext !== 'function') throw new Error('Invalid getContext, must be function');
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || $8cc220f9b8d81fdf$var$DEFAULT_DELAY;
        this._throttle = settings.throttle || $8cc220f9b8d81fdf$var$DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || $8cc220f9b8d81fdf$var$DEFAULT_STORAGE_KEY;
        this._safeLocalStorage = new (0, $k02jW.default)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
}

});

parcelRegister("3bvlA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $251ab7187d48ccfe$export$2e2bcd8739ae039; });
function $251ab7187d48ccfe$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== 'function') return null;
    return ()=>{
        callback(event);
    };
}

});

parcelRegister("d24k1", function(module, exports) {

$parcel$export(module.exports, "XIDPromise", function () { return $97ced0804a38e1ba$export$fbe53bbbe682bcdd; });

var $fZooc = parcelRequire("fZooc");
const $97ced0804a38e1ba$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === 'function') {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, $fZooc.createTimeoutXid)()), (0, $fZooc.XID_TIMEOUT));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, $fZooc.createUnknownXid)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};

});
parcelRegister("fZooc", function(module, exports) {

$parcel$export(module.exports, "XID_TIMEOUT", function () { return $ba3f78b543363dbb$export$545bcbd53afabfa3; });
$parcel$export(module.exports, "createTimeoutXid", function () { return $ba3f78b543363dbb$export$af4087e36d63846; });
$parcel$export(module.exports, "createUnknownXid", function () { return $ba3f78b543363dbb$export$fa341d0c750d705b; });

var $jlumM = parcelRequire("jlumM");
const $ba3f78b543363dbb$export$545bcbd53afabfa3 = 5000;
const $ba3f78b543363dbb$export$af4087e36d63846 = ()=>[
        {
            type: (0, $jlumM.XIDItemType).XC,
            state: 'TIMEOUT'
        },
        {
            type: (0, $jlumM.XIDItemType).UID,
            state: 'TIMEOUT'
        }
    ];
const $ba3f78b543363dbb$export$fa341d0c750d705b = ()=>[
        {
            type: (0, $jlumM.XIDItemType).XC,
            state: 'UNKNOWN'
        },
        {
            type: (0, $jlumM.XIDItemType).UID,
            state: 'UNKNOWN'
        }
    ];

});
parcelRegister("jlumM", function(module, exports) {

$parcel$export(module.exports, "XIDItemType", function () { return $e157889c1d23b343$export$92ca0438bcb0d396; });
let $e157889c1d23b343$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
let $e157889c1d23b343$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});

});




parcelRegister("5lFna", function(module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
    var a, i;
    module.exports = factory();
})(module.exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // identity function for calling harmony imports with the correct context
        /******/ __webpack_require__.i = function(value) {
            return value;
        };
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 7);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var GAS_BULK_URL = exports.GAS_BULK_URL = 'https://mgas.prod.public.atl-paas.net/v1/events';
            var CLOUD_ANALYTICS_URL = exports.CLOUD_ANALYTICS_URL = '/rest/analytics/1.0/publish/bulk';
            var CONFLUENCE_URL_PREFIX = exports.CONFLUENCE_URL_PREFIX = '/wiki';
            var BATCH_INTERVAL_MS = exports.BATCH_INTERVAL_MS = 5000;
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var SafeString = exports.SafeString = function SafeString(value) {
                var _this = this;
                _classCallCheck(this, SafeString);
                this.value = value;
                this.valueOf = this.toString = this.toJSON = function() {
                    return _this.value;
                };
            };
            /**
 * Use this when you explicitly need to collect user entered data. Such as NPS survey responses.
 * @param value
 */ var dangerouslyCreateSafeString = exports.dangerouslyCreateSafeString = function dangerouslyCreateSafeString(value) {
                return new SafeString(value);
            };
            var isSafeString = exports.isSafeString = function isSafeString(value) {
                return value instanceof SafeString;
            };
            /**
 * Provide a list of acceptable values to ensure we do not unintentionally capture user data
 * @param {Array} allowedStrings - Static string values representing allowed words for this property
 * @returns {SafeString}
 */ var markAsSafe = exports.markAsSafe = function markAsSafe() {
                for(var _len = arguments.length, allowedStrings = Array(_len), _key = 0; _key < _len; _key++)allowedStrings[_key] = arguments[_key];
                return function(value) {
                    return allowedStrings.includes(value) ? Object.freeze(new SafeString(value)) : value;
                };
            };
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.BaseAnalytics = undefined;
            var _extends = Object.assign || function(target) {
                for(var i = 1; i < arguments.length; i++){
                    var source = arguments[i];
                    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
                }
                return target;
            };
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _default = __webpack_require__(0);
            var _Beacon = __webpack_require__(8);
            var _PrivacySafeString = __webpack_require__(1);
            var _AnalyticsLogger = __webpack_require__(9);
            var _AnalyticsLogger2 = _interopRequireDefault(_AnalyticsLogger);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var isNumberOrNumericString = function isNumberOrNumericString(value) {
                return !isNaN(value);
            };
            var isNull = function isNull(value) {
                return value === null;
            };
            var isBoolean = function isBoolean(value) {
                return value === true || value === false;
            };
            /**
 * Is of a type that will not reveal any PII
 * OR
 * is explicitly marked as being safe of PII
 * @param value
 */ var isPrivacySafe = function isPrivacySafe(value) {
                return isNull(value) || isBoolean(value) || isNumberOrNumericString(value) || (0, _PrivacySafeString.isSafeString)(value);
            };
            /**
 * Extend this to include "whitelisted" keys where the values will be deemed safe
 * @param key
 */ var isPrivacySafeAttributeKey = function isPrivacySafeAttributeKey(key) {
                return key === 'spaceKey';
            };
            /*eslint no-unused-vars: ["error", { "argsIgnorePattern": "name|properties|events" }]*/ /**
 * Abstract analytics client implementation
 */ var BaseAnalytics = exports.BaseAnalytics = function() {
                function BaseAnalytics() {
                    var _this = this;
                    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    _classCallCheck(this, BaseAnalytics);
                    this.eventPrefix = options.eventPrefix || '';
                    this.devMode = options.devMode;
                    this.batch_interval_ms = options.batchIntervalMs || _default.BATCH_INTERVAL_MS;
                    this.options = options;
                    this._requestQueue = [];
                    if (typeof window !== "undefined" && window.addEventListener) window.addEventListener("unload", function() {
                        _this.handlePageUnload();
                    });
                }
                _createClass(BaseAnalytics, [
                    {
                        key: 'url',
                        value: function url() {
                            throw new Error('override url()');
                        }
                    },
                    {
                        key: 'createRequest',
                        value: function createRequest(name) {
                            var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            throw new Error('You must override createRequest().');
                        }
                    },
                    {
                        key: 'trigger',
                        value: function trigger(name) {
                            var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
                                immediate: false
                            };
                            if (!name) throw new Error("Name must be provided when sending an event.");
                            var eventName = '' + (this.eventPrefix ? this.eventPrefix + "." : "") + name;
                            var request = this.createRequest(eventName, this.sanitizeAnalyticsData(properties));
                            if (this.devMode) _AnalyticsLogger2.default.log(JSON.stringify(request, null, 2));
                            if (options.immediate) this.sendEventsToRemote([
                                request
                            ]);
                            else {
                                this.pushToQueue(request);
                                this.startInterval();
                            }
                        }
                    },
                    {
                        key: 'setQueue',
                        value: function setQueue(newQueue) {
                            this._requestQueue = newQueue;
                        }
                    },
                    {
                        key: 'getQueue',
                        value: function getQueue() {
                            return this._requestQueue;
                        }
                    },
                    {
                        key: 'pushToQueue',
                        value: function pushToQueue(request) {
                            this.getQueue().push(request);
                        }
                    },
                    {
                        key: 'processQueue',
                        value: function processQueue() {
                            var events = this.getQueue().splice(0);
                            if (events.length > 0) this.sendEventsToRemote(events);
                        }
                    },
                    {
                        key: 'handlePageUnload',
                        value: function handlePageUnload() {
                            this.processQueue();
                            this.stopInterval();
                        }
                    },
                    {
                        key: 'startInterval',
                        value: function startInterval() {
                            var _this2 = this;
                            if (typeof this._intervalId === "number") return;
                            this._intervalId = setInterval(function() {
                                return _this2.processQueue();
                            }, this.batch_interval_ms);
                        }
                    },
                    {
                        key: 'stopInterval',
                        value: function stopInterval() {
                            if (typeof this._intervalId === "number") {
                                clearInterval(this._intervalId);
                                this._intervalId = null;
                            }
                        }
                    },
                    {
                        key: 'emptyQueue',
                        value: function emptyQueue() {
                            this._requestQueue = [];
                        }
                    },
                    {
                        key: 'sendEventsToRemote',
                        value: function sendEventsToRemote(events) {
                            var payload = this.constructor.createPayload(events);
                            if (this.devMode) {
                                _AnalyticsLogger2.default.log('sending ' + events.length + ' events.');
                                return;
                            }
                            var successfullyQueued = false;
                            if (_Beacon.Beacon.isSupported()) successfullyQueued = _Beacon.Beacon.sendAsJson(this.url(), payload);
                            if (!successfullyQueued) this.doPost(payload);
                        }
                    },
                    {
                        key: 'doPost',
                        value: function doPost(postBody) {
                            var xhr = void 0;
                            if (typeof window !== "undefined" && window.XMLHttpRequest) // IE7+, Firefox, Chrome, Opera, Safari
                            xhr = new window.XMLHttpRequest();
                            else return;
                            xhr.open("POST", this.url(), true);
                            if (typeof xhr.setRequestHeader !== 'undefined') {
                                xhr.setRequestHeader("Content-Type", "application/json");
                                xhr.setRequestHeader("Accept", "application/json, text/javascript, */*;");
                            }
                            var decoratedPostBody = this.decorateEventsWithType(postBody);
                            xhr.send(JSON.stringify(decoratedPostBody));
                        }
                    },
                    {
                        key: 'decorateEventsWithType',
                        value: function decorateEventsWithType(postBody) {
                            return postBody.map(function(event) {
                                event.properties = event.properties || {};
                                event.properties._type = "xhr";
                                return event;
                            });
                        }
                    },
                    {
                        key: 'sanitizeAnalyticsData',
                        value: function sanitizeAnalyticsData(data) {
                            var _this3 = this;
                            if (isNull(data) || typeof data === 'undefined') return data;
                            if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== 'object') return {};
                            // return the data with privacy unsafe data filtered out
                            return Object.keys(data).reduce(function(filteredData, key) {
                                var value = data[key];
                                if (isPrivacySafeAttributeKey(key) || isPrivacySafe(value)) filteredData[key] = value;
                                else if (_this3.devMode) _AnalyticsLogger2.default.warn('Stripping out potentially privacy-unsafe analytics attribute: \'' + key + '\' -> \'' + value + '\'');
                                return filteredData;
                            }, {});
                        }
                    },
                    {
                        key: 'updateOptions',
                        value: function updateOptions(newOptions) {
                            this.options = _extends({}, this.options, newOptions);
                        }
                    }
                ], [
                    {
                        key: 'createPayload',
                        value: function createPayload(events) {
                            throw new Error('You must override createPayload().');
                        }
                    }
                ]);
                return BaseAnalytics;
            }();
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.CloudAnalytics = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _BaseAnalytics2 = __webpack_require__(2);
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self, call) {
                if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            /**
 * Common code for cloud, shared by JiraAnalytics and ConfluenceAnalytics
 */ var CloudAnalytics = exports.CloudAnalytics = function(_BaseAnalytics) {
                _inherits(CloudAnalytics, _BaseAnalytics);
                function CloudAnalytics() {
                    _classCallCheck(this, CloudAnalytics);
                    return _possibleConstructorReturn(this, (CloudAnalytics.__proto__ || Object.getPrototypeOf(CloudAnalytics)).apply(this, arguments));
                }
                _createClass(CloudAnalytics, [
                    {
                        key: 'createRequest',
                        value: function createRequest(name) {
                            var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            return {
                                name: name,
                                properties: properties,
                                serverTime: Date.now()
                            };
                        }
                    }
                ], [
                    {
                        key: 'createPayload',
                        value: function createPayload(events) {
                            return this.adjustEventTimings(events);
                        }
                    },
                    {
                        key: 'adjustEventTimings',
                        value: function adjustEventTimings(events) {
                            var now = Date.now();
                            return events.map(function(event) {
                                return {
                                    name: event.name,
                                    properties: event.properties,
                                    timeDelta: event.serverTime - now
                                };
                            });
                        }
                    }
                ]);
                return CloudAnalytics;
            }(_BaseAnalytics2.BaseAnalytics);
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.ConfluenceAnalytics = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _default = __webpack_require__(0);
            var _CloudAnalytics2 = __webpack_require__(3);
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self, call) {
                if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            /**
 * Analytics client for Confluence
 * Defaults to /wiki
 */ var ConfluenceAnalytics = exports.ConfluenceAnalytics = function(_CloudAnalytics) {
                _inherits(ConfluenceAnalytics, _CloudAnalytics);
                function ConfluenceAnalytics() {
                    _classCallCheck(this, ConfluenceAnalytics);
                    return _possibleConstructorReturn(this, (ConfluenceAnalytics.__proto__ || Object.getPrototypeOf(ConfluenceAnalytics)).apply(this, arguments));
                }
                _createClass(ConfluenceAnalytics, [
                    {
                        key: 'url',
                        /**
     * Override if context path changes
     * @param baseUrl
     * @returns {string}
     */ value: function url() {
                            var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.hostname + _default.CONFLUENCE_URL_PREFIX;
                            return baseUrl + _default.CLOUD_ANALYTICS_URL;
                        }
                    }
                ]);
                return ConfluenceAnalytics;
            }(_CloudAnalytics2.CloudAnalytics);
        /***/ },
        /* 5 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.GasAnalytics = undefined;
            var _extends = Object.assign || function(target) {
                for(var i = 1; i < arguments.length; i++){
                    var source = arguments[i];
                    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
                }
                return target;
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _default = __webpack_require__(0);
            var _BaseAnalytics2 = __webpack_require__(2);
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self, call) {
                if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            /**
 * Analytics client for the GAS API ({@link https://extranet.atlassian.com/display/MOD/Public+Analytics+aka+GAS})
 */ var GasAnalytics = exports.GasAnalytics = function(_BaseAnalytics) {
                _inherits(GasAnalytics, _BaseAnalytics);
                /**
    * @constructor
    * @param {object} options - Required: server, product, user.
    */ function GasAnalytics(options) {
                    _classCallCheck(this, GasAnalytics);
                    var _this = _possibleConstructorReturn(this, (GasAnalytics.__proto__ || Object.getPrototypeOf(GasAnalytics)).call(this, options));
                    if (!options.server) throw new Error("You must specify a GAS server value.");
                    if (!options.product) throw new Error("You must specify a GAS product value.");
                    if (!options.user && !options.user_id) throw new Error("You must specify a GAS user or user_id value.");
                    return _this;
                }
                _createClass(GasAnalytics, [
                    {
                        key: "url",
                        value: function url() {
                            return _default.GAS_BULK_URL;
                        }
                    },
                    {
                        key: "createRequest",
                        value: function createRequest(name) {
                            var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            return {
                                name: name,
                                server: this.options.server,
                                product: this.options.product,
                                user: this.options.user,
                                serverTime: Date.now(),
                                cloud_id: this.options.cloud_id || null,
                                user_id: this.options.user_id || null,
                                user_id_type: this.options.user_id_type || null,
                                properties: properties
                            };
                        }
                    },
                    {
                        key: "decorateEventsWithType",
                        value: function decorateEventsWithType(postBody) {
                            if (!postBody.events) return;
                            postBody.events = postBody.events.map(function(event) {
                                event.properties = event.properties || {};
                                event.properties._type = "xhr";
                                return event;
                            });
                            return postBody;
                        }
                    },
                    {
                        key: "updateOptions",
                        value: function updateOptions(newOptions) {
                            this.options = _extends({}, this.options, newOptions);
                            this.setQueue(this.getQueue().map(function(queuedEvent) {
                                return _extends({}, queuedEvent, newOptions);
                            }));
                        }
                    }
                ], [
                    {
                        key: "createPayload",
                        value: function createPayload(events) {
                            return {
                                events: events
                            };
                        }
                    }
                ]);
                return GasAnalytics;
            }(_BaseAnalytics2.BaseAnalytics);
        /***/ },
        /* 6 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.JiraAnalytics = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _default = __webpack_require__(0);
            var _CloudAnalytics2 = __webpack_require__(3);
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self, call) {
                if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            /**
 * Analytics client for JIRA
 */ var JiraAnalytics = exports.JiraAnalytics = function(_CloudAnalytics) {
                _inherits(JiraAnalytics, _CloudAnalytics);
                function JiraAnalytics() {
                    _classCallCheck(this, JiraAnalytics);
                    return _possibleConstructorReturn(this, (JiraAnalytics.__proto__ || Object.getPrototypeOf(JiraAnalytics)).apply(this, arguments));
                }
                _createClass(JiraAnalytics, [
                    {
                        key: 'url',
                        /**
     * Override if context path changes
     * @param baseUrl
     * @returns {string}
     */ value: function url() {
                            var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.hostname;
                            return baseUrl + _default.CLOUD_ANALYTICS_URL;
                        }
                    }
                ]);
                return JiraAnalytics;
            }(_CloudAnalytics2.CloudAnalytics);
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.dangerouslyCreateSafeString = exports.isSafeString = exports.markAsSafe = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _GasAnalytics = __webpack_require__(5);
            var _JiraAnalytics = __webpack_require__(6);
            var _ConfluenceAnalytics = __webpack_require__(4);
            var _PrivacySafeString = __webpack_require__(1);
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /**
 * Get singleton Analytics Client that is appropriate for your product or app.
 */ var AnalyticsClientFactory = function() {
                function AnalyticsClientFactory() {
                    _classCallCheck(this, AnalyticsClientFactory);
                }
                _createClass(AnalyticsClientFactory, [
                    {
                        key: 'getGasClient',
                        /**
     * Get a Gas Analytics Client.
     * @param {object} options - {
     *  server: "String - required",
     *  product: "String - required",
     *  user: "String - required",
     *  eventPrefix: "String - optional - default: ''",
     *  devMode: "Boolean - optional - default: false",
     *  batchIntervalMs: "Integer - optional - default: 5000"
     * }
     * @returns {GasAnalytics}
     */ value: function getGasClient(options) {
                            if (this._gasClient) return this._gasClient;
                            return this._gasClient = new _GasAnalytics.GasAnalytics(options);
                        }
                    },
                    {
                        key: 'getJiraClient',
                        value: function getJiraClient(options) {
                            if (this._jiraClient) return this._jiraClient;
                            return this._jiraClient = new _JiraAnalytics.JiraAnalytics(options);
                        }
                    },
                    {
                        key: 'getConfluenceClient',
                        value: function getConfluenceClient(options) {
                            if (this._confluenceClient) return this._confluenceClient;
                            return this._confluenceClient = new _ConfluenceAnalytics.ConfluenceAnalytics(options);
                        }
                    }
                ]);
                return AnalyticsClientFactory;
            }();
            exports.default = new AnalyticsClientFactory();
            /**
 * Provide a list of acceptable values to ensure we do not unintentionally capture user data
 * @param {...String} allowedStrings - Static string values representing allowed words for this property
 * @returns {SafeString} - a function that will check if the value (argument) is in the list of allowedStrings
 */ var markAsSafe = exports.markAsSafe = _PrivacySafeString.markAsSafe;
            var isSafeString = exports.isSafeString = _PrivacySafeString.isSafeString;
            var dangerouslyCreateSafeString = exports.dangerouslyCreateSafeString = _PrivacySafeString.dangerouslyCreateSafeString;
        /***/ },
        /* 8 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var _isSupported = null;
            /**
 * Light wrapper around navigator.sendBeacon()
 */ var Beacon = exports.Beacon = function() {
                function Beacon() {
                    _classCallCheck(this, Beacon);
                }
                _createClass(Beacon, null, [
                    {
                        key: 'sendAsJson',
                        /**
         * Send the specified object as JSON using Beacon API.
         *
         * See:
         * - https://developer.mozilla.org/en-US/docs/Web/API/Beacon_API
         * - https://w3c.github.io/beacon/#dom-navigator-sendbeacon
         *
         * Returns a boolean to indicate that the data was successfully queued.
         *
         * If we've exceeded our quota for sendBeacon on this page, this method
         * will return false.
         *
         * See: https://www.w3.org/TR/beacon/#sec-sendBeacon-method
         *
         * @param url
         * @param object
         * @returns {boolean}
         */ value: function sendAsJson(url, object) {
                            var blob = new Blob([
                                JSON.stringify(object)
                            ], {
                                type: 'text/plain'
                            });
                            return navigator.sendBeacon(url, blob);
                        }
                    },
                    {
                        key: 'isSupported',
                        value: function isSupported() {
                            if (typeof _isSupported !== 'boolean') _isSupported = this.isSendBeaconSupported() && this.isBlobSupported();
                            return _isSupported;
                        }
                    },
                    {
                        key: 'isSendBeaconSupported',
                        value: function isSendBeaconSupported() {
                            // Modified from: https://github.com/Modernizr/Modernizr/blob/master/feature-detects/network/beacon.js
                            return 'sendBeacon' in navigator && typeof navigator.sendBeacon === 'function';
                        }
                    },
                    {
                        key: 'isBlobSupported',
                        value: function isBlobSupported() {
                            // Source: https://github.com/Modernizr/Modernizr/blob/master/feature-detects/blob.js
                            try {
                                return new Blob(), true;
                            } catch (e) {
                                return false;
                            }
                        }
                    }
                ]);
                return Beacon;
            }();
        /***/ },
        /* 9 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            /**
 * Prettifier with a standard prefix for all log messages
 */ /*eslint no-console: 0*/ exports.default = {
                log: function log(message) {
                    console.log("%cAnalytics: " + message, "color: #0052CC; font-size: small");
                },
                warn: function warn(message) {
                    console.warn("%cAnalytics: " + message, "color: #DE350B; font-size: small");
                },
                error: function error(message) {
                    // This might not work in some browsers... but ignore this for now.
                    console.error("%cAnalytics: " + message, "color: #FF5630; font-size: small");
                }
            };
        /***/ }
    ]);
});

});

parcelRegister("dHOko", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8bd89103835628f9$export$2e2bcd8739ae039; });

var $dBq8m = parcelRequire("dBq8m");

var $11BZU = parcelRequire("11BZU");
const $8bd89103835628f9$var$cache = new Map();
var $8bd89103835628f9$export$2e2bcd8739ae039 = (url, options)=>{
    if (!$8bd89103835628f9$var$cache.has(url)) $8bd89103835628f9$var$cache.set(url, $8bd89103835628f9$var$getOriginTracingAttributesFromUrl(url, options));
    return $8bd89103835628f9$var$cache.get(url);
};
function $8bd89103835628f9$var$getOriginTracingAttributesFromUrl(url, options) {
    let mapAttribute = (v)=>v;
    if (options && options.mapAttribute) mapAttribute = options.mapAttribute;
    let origin = (0, $11BZU.default).createEmpty();
    try {
        const urlOrigin = (0, $11BZU.default).fromUrl(url);
        const continueUrl = $8bd89103835628f9$var$getQueryParam(url, 'continue');
        const continueOrigin = (0, $11BZU.default).fromUrl(continueUrl);
        // @ts-ignore Argument of type 'string | string[]' is not assignable to parameter of type 'string'.
        const destUrl = $8bd89103835628f9$var$getQueryParam(continueUrl, 'dest-url');
        const destOrigin = (0, $11BZU.default).fromUrl(destUrl);
        // @ts-ignore Argument of type 'string | string[]' is not assignable to parameter of type 'string'.
        const nestedContinueUrl = $8bd89103835628f9$var$getQueryParam(continueUrl, 'continue');
        const nestedContinueOrigin = (0, $11BZU.default).fromUrl(nestedContinueUrl);
        origin = !urlOrigin.isEmpty() && urlOrigin || !continueOrigin.isEmpty() && continueOrigin || !destOrigin.isEmpty() && destOrigin || !nestedContinueOrigin.isEmpty() && nestedContinueOrigin || (0, $11BZU.default).createEmpty();
    } catch (e) {
    //will fail only on malformed urls, we don't care about that
    }
    return origin.toAnalyticsAttributes({
        transformValue: mapAttribute
    });
}
function $8bd89103835628f9$var$getQueryParam(url, paramName) {
    if (!url) return undefined;
    // Base is only needed for URL() to resolve relative paths. It could be arbitrary.
    const BASE = 'http://atlassian.com/';
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(new URL(url, BASE).search);
    return query[paramName] || undefined;
}

});
parcelRegister("dBq8m", function(module, exports) {

$parcel$export(module.exports, "extract", function () { return $9e7300b5647a56a4$export$f9380c9a627682d3; }, function (v) { return $9e7300b5647a56a4$export$f9380c9a627682d3 = v; });
$parcel$export(module.exports, "parse", function () { return $9e7300b5647a56a4$export$98e6a39c04603d36; }, function (v) { return $9e7300b5647a56a4$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $9e7300b5647a56a4$export$fac44ee5b035f737; }, function (v) { return $9e7300b5647a56a4$export$fac44ee5b035f737 = v; });
$parcel$export(module.exports, "parseUrl", function () { return $9e7300b5647a56a4$export$7a5253c0f62e0150; }, function (v) { return $9e7300b5647a56a4$export$7a5253c0f62e0150 = v; });
var $9e7300b5647a56a4$export$f9380c9a627682d3;
var $9e7300b5647a56a4$export$98e6a39c04603d36;
var $9e7300b5647a56a4$export$fac44ee5b035f737;
var $9e7300b5647a56a4$export$7a5253c0f62e0150;
'use strict';

var $i7F95 = parcelRequire("i7F95");

var $gmXIm = parcelRequire("gmXIm");

var $gDzas = parcelRequire("gDzas");
function $9e7300b5647a56a4$var$encoderForArrayFormat(opts) {
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, index) {
                return value === null ? [
                    $9e7300b5647a56a4$var$encode(key, opts),
                    '[',
                    index,
                    ']'
                ].join('') : [
                    $9e7300b5647a56a4$var$encode(key, opts),
                    '[',
                    $9e7300b5647a56a4$var$encode(index, opts),
                    ']=',
                    $9e7300b5647a56a4$var$encode(value, opts)
                ].join('');
            };
        case 'bracket':
            return function(key, value) {
                return value === null ? $9e7300b5647a56a4$var$encode(key, opts) : [
                    $9e7300b5647a56a4$var$encode(key, opts),
                    '[]=',
                    $9e7300b5647a56a4$var$encode(value, opts)
                ].join('');
            };
        default:
            return function(key, value) {
                return value === null ? $9e7300b5647a56a4$var$encode(key, opts) : [
                    $9e7300b5647a56a4$var$encode(key, opts),
                    '=',
                    $9e7300b5647a56a4$var$encode(value, opts)
                ].join('');
            };
    }
}
function $9e7300b5647a56a4$var$parserForArrayFormat(opts) {
    var result;
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, accumulator) {
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return function(key, value, accumulator) {
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                } else if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        default:
            return function(key, value, accumulator) {
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $9e7300b5647a56a4$var$encode(value, opts) {
    if (opts.encode) return opts.strict ? $i7F95(value) : encodeURIComponent(value);
    return value;
}
function $9e7300b5647a56a4$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    else if (typeof input === 'object') return $9e7300b5647a56a4$var$keysSorter(Object.keys(input)).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(key) {
        return input[key];
    });
    return input;
}
function $9e7300b5647a56a4$var$extract(str) {
    var queryStart = str.indexOf('?');
    if (queryStart === -1) return '';
    return str.slice(queryStart + 1);
}
function $9e7300b5647a56a4$var$parse(str, opts) {
    opts = $gmXIm({
        arrayFormat: 'none'
    }, opts);
    var formatter = $9e7300b5647a56a4$var$parserForArrayFormat(opts);
    // Create an object with no prototype
    // https://github.com/sindresorhus/query-string/issues/47
    var ret = Object.create(null);
    if (typeof str !== 'string') return ret;
    str = str.trim().replace(/^[?#&]/, '');
    if (!str) return ret;
    str.split('&').forEach(function(param) {
        var parts = param.replace(/\+/g, ' ').split('=');
        // Firefox (pre 40) decodes `%3D` to `=`
        // https://github.com/sindresorhus/query-string/pull/37
        var key = parts.shift();
        var val = parts.length > 0 ? parts.join('=') : undefined;
        // missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        val = val === undefined ? null : $gDzas(val);
        formatter($gDzas(key), val, ret);
    });
    return Object.keys(ret).sort().reduce(function(result, key) {
        var val = ret[key];
        if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) // Sort object keys, not values
        result[key] = $9e7300b5647a56a4$var$keysSorter(val);
        else result[key] = val;
        return result;
    }, Object.create(null));
}
$9e7300b5647a56a4$export$f9380c9a627682d3 = $9e7300b5647a56a4$var$extract;
$9e7300b5647a56a4$export$98e6a39c04603d36 = $9e7300b5647a56a4$var$parse;
$9e7300b5647a56a4$export$fac44ee5b035f737 = function(obj, opts) {
    var defaults = {
        encode: true,
        strict: true,
        arrayFormat: 'none'
    };
    opts = $gmXIm(defaults, opts);
    if (opts.sort === false) opts.sort = function() {};
    var formatter = $9e7300b5647a56a4$var$encoderForArrayFormat(opts);
    return obj ? Object.keys(obj).sort(opts.sort).map(function(key) {
        var val = obj[key];
        if (val === undefined) return '';
        if (val === null) return $9e7300b5647a56a4$var$encode(key, opts);
        if (Array.isArray(val)) {
            var result = [];
            val.slice().forEach(function(val2) {
                if (val2 === undefined) return;
                result.push(formatter(key, val2, result.length));
            });
            return result.join('&');
        }
        return $9e7300b5647a56a4$var$encode(key, opts) + '=' + $9e7300b5647a56a4$var$encode(val, opts);
    }).filter(function(x) {
        return x.length > 0;
    }).join('&') : '';
};
$9e7300b5647a56a4$export$7a5253c0f62e0150 = function(str, opts) {
    return {
        url: str.split('?')[0] || '',
        query: $9e7300b5647a56a4$var$parse($9e7300b5647a56a4$var$extract(str), opts)
    };
};

});
parcelRegister("i7F95", function(module, exports) {
'use strict';
module.exports = function(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
};

});

parcelRegister("gmXIm", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $bead0575dc90e2ee$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $bead0575dc90e2ee$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $bead0575dc90e2ee$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $bead0575dc90e2ee$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $bead0575dc90e2ee$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $bead0575dc90e2ee$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $bead0575dc90e2ee$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($bead0575dc90e2ee$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($bead0575dc90e2ee$var$getOwnPropertySymbols) {
            symbols = $bead0575dc90e2ee$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($bead0575dc90e2ee$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});


parcelRegister("11BZU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bf35bfa93a18327$export$2e2bcd8739ae039; });

var $kSyoi = parcelRequire("kSyoi");

var $gGOBY = parcelRequire("gGOBY");

var $lVDuE = parcelRequire("lVDuE");

var $dsN6L = parcelRequire("dsN6L");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $kbWO6 = parcelRequire("kbWO6");

var $4KgYp = parcelRequire("4KgYp");

var $6Vq2n = parcelRequire("6Vq2n");
function $0bf35bfa93a18327$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $0bf35bfa93a18327$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($gGOBY)))(this, result);
    };
}
function $0bf35bfa93a18327$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0bf35bfa93a18327$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $0bf35bfa93a18327$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0bf35bfa93a18327$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0bf35bfa93a18327$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0bf35bfa93a18327$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0bf35bfa93a18327$var$packageVersion = "6.1.5";
var $0bf35bfa93a18327$var$originParamName = 'atlOrigin';
var $0bf35bfa93a18327$var$originVersioningAttributes = {
    originLibrary: "origin-tracing.js@".concat($0bf35bfa93a18327$var$packageVersion)
};
var $0bf35bfa93a18327$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function OriginTracer(_ref) {
        var _ref$id = _ref.id, id = _ref$id === void 0 ? OriginTracer.generateId() : _ref$id, product = _ref.product, _ref$dangerouslySkipV = _ref.dangerouslySkipValidation, dangerouslySkipValidation = _ref$dangerouslySkipV === void 0 ? false : _ref$dangerouslySkipV;
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, OriginTracer);
        this.id = id;
        this.product = product;
        if (!dangerouslySkipValidation) this.validate();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(OriginTracer, [
        {
            key: "encode",
            value: function encode() {
                return (0, $4KgYp.encode)({
                    id: this.id,
                    product: this.product
                });
            }
        },
        {
            key: "addToUrl",
            value: function addToUrl(url) {
                var _this = this;
                return $0bf35bfa93a18327$var$replaceQuery(url, function(originalQueryString) {
                    var params = new ((0, $6Vq2n.getEnv)()).URLSearchParams(originalQueryString);
                    params.set($0bf35bfa93a18327$var$originParamName, _this.encode());
                    return params.toString();
                });
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return false;
            }
        },
        {
            key: "isMalformed",
            value: function isMalformed() {
                return !this.isEmpty() && !this.isValid();
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                return true;
            }
        },
        {
            key: "toAnalyticsAttributes",
            value: function toAnalyticsAttributes() {
                var _objectSpread2;
                var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$transformValue = _ref2.transformValue, transformValue = _ref2$transformValue === void 0 ? function(v) {
                    return v === null ? undefined : v;
                } : _ref2$transformValue, _ref2$hasGeneratedId = _ref2.hasGeneratedId, hasGeneratedId = _ref2$hasGeneratedId === void 0 ? false : _ref2$hasGeneratedId;
                // `originIdGenerated` should be used in analytic events that generated this originId.
                // Subsequent events should use `originId`.
                // No two events should have the same value of originIdGenerated.
                var originIdProp = hasGeneratedId ? 'originIdGenerated' : 'originId';
                return $0bf35bfa93a18327$var$_objectSpread((_objectSpread2 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_objectSpread2, originIdProp, transformValue(this.id)), (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_objectSpread2, "originProduct", transformValue(this.product)), _objectSpread2), $0bf35bfa93a18327$var$originVersioningAttributes);
            }
        },
        {
            key: "validate",
            value: function validate() {
                if (!OriginTracer.isValidId(this.id)) throw new TypeError('Invalid Origin id');
                if (!OriginTracer.isValidProduct(this.product)) throw new TypeError('Missing/invalid Origin product');
            }
        }
    ], [
        {
            key: "isValidId",
            value: function isValidId(value) {
                return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,36}$/.test(value);
            }
        },
        {
            key: "isValidProduct",
            value: function isValidProduct(value) {
                return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,20}$/.test(value);
            }
        },
        {
            key: "generateId",
            value: function generateId() {
                var id = (0, (/*@__PURE__*/$parcel$interopDefault($kbWO6)))();
                // Dash positions are fixed so they don't add to uniqueness.
                // Remove them to save space in the encoded form.
                return id.replace(/-/g, '');
            }
        },
        {
            key: "createEmpty",
            value: function createEmpty() {
                return new $0bf35bfa93a18327$var$EmptyOriginTracer();
            }
        },
        {
            key: "createMalformed",
            value: function createMalformed() {
                return new $0bf35bfa93a18327$var$MalformedOriginTracer();
            }
        },
        {
            key: "fromUrl",
            value: function fromUrl(url) {
                var params = new ((0, $6Vq2n.getEnv)()).URLSearchParams();
                $0bf35bfa93a18327$var$replaceQuery(url, function(queryString) {
                    params = new ((0, $6Vq2n.getEnv)()).URLSearchParams(queryString);
                });
                return OriginTracer.fromEncoded(params.get($0bf35bfa93a18327$var$originParamName));
            }
        },
        {
            key: "fromEncoded",
            value: function fromEncoded(encoded) {
                if (!encoded) return OriginTracer.createEmpty();
                try {
                    return OriginTracer.decode(encoded);
                } catch (e) {
                    return OriginTracer.createMalformed();
                }
            }
        },
        {
            key: "removeFromUrl",
            value: function removeFromUrl(url) {
                return $0bf35bfa93a18327$var$replaceQuery(url, function(queryString) {
                    var params = new ((0, $6Vq2n.getEnv)()).URLSearchParams(queryString);
                    params.delete($0bf35bfa93a18327$var$originParamName);
                    return params.toString();
                });
            }
        },
        {
            key: "decode",
            value: function decode(encodedOrigin) {
                var originData = (0, $4KgYp.decode)(encodedOrigin);
                return new OriginTracer(originData);
            }
        }
    ]);
    return OriginTracer;
}();
var $0bf35bfa93a18327$var$EmptyOriginTracer = /*#__PURE__*/ function(_OriginTracer) {
    (0, (/*@__PURE__*/$parcel$interopDefault($kSyoi)))(EmptyOriginTracer, _OriginTracer);
    var _super = $0bf35bfa93a18327$var$_createSuper(EmptyOriginTracer);
    function EmptyOriginTracer() {
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, EmptyOriginTracer);
        return _super.call(this, {
            id: null,
            product: null,
            dangerouslySkipValidation: true
        });
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(EmptyOriginTracer, [
        {
            key: "isValid",
            value: function isValid() {
                return false;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return true;
            }
        },
        {
            key: "toAnalyticsAttributes",
            value: function toAnalyticsAttributes() {
                return $0bf35bfa93a18327$var$_objectSpread({}, $0bf35bfa93a18327$var$originVersioningAttributes);
            }
        }
    ]);
    return EmptyOriginTracer;
}($0bf35bfa93a18327$export$2e2bcd8739ae039);
var $0bf35bfa93a18327$var$MalformedOriginTracer = /*#__PURE__*/ function(_OriginTracer2) {
    (0, (/*@__PURE__*/$parcel$interopDefault($kSyoi)))(MalformedOriginTracer, _OriginTracer2);
    var _super2 = $0bf35bfa93a18327$var$_createSuper(MalformedOriginTracer);
    function MalformedOriginTracer() {
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, MalformedOriginTracer);
        return _super2.call(this, {
            id: null,
            product: null,
            dangerouslySkipValidation: true
        });
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(MalformedOriginTracer, [
        {
            key: "isValid",
            value: function isValid() {
                return false;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return false;
            }
        },
        {
            key: "toAnalyticsAttributes",
            value: function toAnalyticsAttributes() {
                return $0bf35bfa93a18327$var$_objectSpread({
                    originMalformed: true
                }, $0bf35bfa93a18327$var$originVersioningAttributes);
            }
        }
    ]);
    return MalformedOriginTracer;
}($0bf35bfa93a18327$export$2e2bcd8739ae039);
function $0bf35bfa93a18327$var$replaceQuery(url, replacer) {
    var urlWithQueryStringRegex = /(^[^?#]*)(?:\?)?([^#]*?)(#.*|$)$/;
    // If we get passed window.location, we don't want to call window.location.replace()
    var urlString = String(url);
    return urlString.replace(urlWithQueryStringRegex, function(_wholeMatch, beforeQuery, queryString, afterQuery) {
        var newQueryString = replacer(queryString);
        if (newQueryString) newQueryString = "?".concat(newQueryString);
        return "".concat(beforeQuery).concat(newQueryString).concat(afterQuery);
    });
}

});
parcelRegister("4KgYp", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $37489fd7bbdf7ebd$export$c564cdbbe6da493; });
$parcel$export(module.exports, "decode", function () { return $37489fd7bbdf7ebd$export$2f872c0f2117be69; });

var $fT3Pc = parcelRequire("fT3Pc");

var $6Vq2n = parcelRequire("6Vq2n");
var $37489fd7bbdf7ebd$var$productShorthands = {
    confluence: 'c',
    jira: 'j',
    stride: 's',
    bitbucket: 'b',
    trello: 't'
};
function $37489fd7bbdf7ebd$export$c564cdbbe6da493(originData) {
    var json = JSON.stringify($37489fd7bbdf7ebd$export$4bc4b533a565aabe(originData));
    var base64 = (0, $6Vq2n.getEnv)().btoa(json);
    return (0, $fT3Pc.base64ToBase64Url)(base64);
}
function $37489fd7bbdf7ebd$export$2f872c0f2117be69(encodedOriginString) {
    var base64 = (0, $fT3Pc.base64UrlToBase64)(encodedOriginString);
    var json = (0, $6Vq2n.getEnv)().atob(base64);
    return $37489fd7bbdf7ebd$export$46d5cda6b884b7ab(JSON.parse(json));
}
function $37489fd7bbdf7ebd$export$4bc4b533a565aabe(_ref) {
    var id = _ref.id, product = _ref.product;
    return {
        i: id,
        p: product && product in $37489fd7bbdf7ebd$var$productShorthands ? $37489fd7bbdf7ebd$var$productShorthands[product] : product
    };
}
function $37489fd7bbdf7ebd$export$46d5cda6b884b7ab(originJSONObject) {
    var originData = {};
    if (originJSONObject.i) originData.id = originJSONObject.i;
    if (originJSONObject.p) originData.product = $37489fd7bbdf7ebd$var$expandProductShorthand(originJSONObject.p);
    return originData;
}
function $37489fd7bbdf7ebd$var$expandProductShorthand(maybeShorthand) {
    var products = Object.keys($37489fd7bbdf7ebd$var$productShorthands);
    for(var i = 0; i < products.length; i++){
        var product = products[i];
        var shorthand = $37489fd7bbdf7ebd$var$productShorthands[product];
        if (maybeShorthand === shorthand) return product;
    }
    return maybeShorthand;
}

});
parcelRegister("fT3Pc", function(module, exports) {

$parcel$export(module.exports, "base64ToBase64Url", function () { return $b90ef593dd8cb187$export$3b91e21dac1023c6; });
$parcel$export(module.exports, "base64UrlToBase64", function () { return $b90ef593dd8cb187$export$47c5265a25535d02; });
/**
 * This file converts between Base64 and Base 64 Encoding with URL and Filename Safe Alphabet,
 * the latter of which has URL-safe characters only (drops =, + and /).
 *
 * Why not use a library? The popular libs use Buffer to be able to
 * encode any data to base64. We don't need this capability, and it causes
 * Webpack to include 30KB of a Buffer polyfill.
 * Webpack's/UglifyJS's Tree Shaking seems to be unable to drop it.
 *
 * See: RFC 4648 section 5 (https://tools.ietf.org/html/rfc4648#section-5)
 */ function $b90ef593dd8cb187$export$3b91e21dac1023c6(base64) {
    if (base64 == null) return '';
    return String(base64).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
function $b90ef593dd8cb187$export$47c5265a25535d02(base64url) {
    if (base64url == null) return '';
    var base64 = String(base64url).replace(/-/g, '+').replace(/_/g, '/');
    var padLength = (4 - base64url.length % 4) % 4;
    var pad = '==='.slice(0, padLength);
    return base64 + pad;
}

});

parcelRegister("6Vq2n", function(module, exports) {

$parcel$export(module.exports, "getEnv", function () { return $014d19dc7a0aecfb$export$4bd44a2aa29d3d6e; });

var $lh5ok = parcelRequire("lh5ok");

var $014d19dc7a0aecfb$export$d3cd91e0fdbfdbc0 = function getEnvGlobals() {
    return {
        atob: // atob/btoa need to be bound because they throw an illegal invocation error when called as a method (obj.atob())
        typeof atob === 'function' && atob.bind(undefined) || typeof (0, $lh5ok.Buffer) !== 'undefined' && function(encoded) {
            return (0, $lh5ok.Buffer).from(encoded, 'base64').toString();
        },
        btoa: typeof btoa === 'function' && btoa.bind(undefined) || typeof (0, $lh5ok.Buffer) !== 'undefined' && function(str) {
            return (0, $lh5ok.Buffer).from(str).toString('base64');
        },
        URLSearchParams: typeof URLSearchParams === 'function' && URLSearchParams || (0, (parcelRequire("2RdYA")).URLSearchParams)
    };
};
var $014d19dc7a0aecfb$var$env;
var $014d19dc7a0aecfb$export$4bd44a2aa29d3d6e = function getEnv() {
    return $014d19dc7a0aecfb$var$env || ($014d19dc7a0aecfb$var$env = $014d19dc7a0aecfb$var$validateEnv($014d19dc7a0aecfb$export$d3cd91e0fdbfdbc0()));
};
var $014d19dc7a0aecfb$var$validateEnv = function validateEnv(env) {
    if (!(env.atob && env.btoa && env.URLSearchParams)) throw new TypeError("Origin-Tracing: missing environment APIs. Required: btoa(), atob(), URLSearchParams() (or in Node: Buffer, require('url').URLSearchParams).");
    return env;
};

});
parcelRegister("lh5ok", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $f7cf5e2556f21b58$export$a143d493d941bafc; }, function (v) { return $f7cf5e2556f21b58$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $f7cf5e2556f21b58$export$f99ded8fe4b79145; }, function (v) { return $f7cf5e2556f21b58$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $f7cf5e2556f21b58$export$a143d493d941bafc;
var $f7cf5e2556f21b58$export$e4cf37d7f6fb9e0a;
var $f7cf5e2556f21b58$export$f99ded8fe4b79145;
var $f7cf5e2556f21b58$export$599f31c3813fae4d;
'use strict';

var $8KxEN = parcelRequire("8KxEN");

var $aWooH = parcelRequire("aWooH");
const $f7cf5e2556f21b58$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$f7cf5e2556f21b58$export$a143d493d941bafc = $f7cf5e2556f21b58$var$Buffer;
$f7cf5e2556f21b58$export$e4cf37d7f6fb9e0a = $f7cf5e2556f21b58$var$SlowBuffer;
$f7cf5e2556f21b58$export$f99ded8fe4b79145 = 50;
const $f7cf5e2556f21b58$var$K_MAX_LENGTH = 0x7fffffff;
$f7cf5e2556f21b58$export$599f31c3813fae4d = $f7cf5e2556f21b58$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $f7cf5e2556f21b58$var$Buffer.TYPED_ARRAY_SUPPORT = $f7cf5e2556f21b58$var$typedArraySupport();
if (!$f7cf5e2556f21b58$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $f7cf5e2556f21b58$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($f7cf5e2556f21b58$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$f7cf5e2556f21b58$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($f7cf5e2556f21b58$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$f7cf5e2556f21b58$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $f7cf5e2556f21b58$var$createBuffer(length) {
    if (length > $f7cf5e2556f21b58$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $f7cf5e2556f21b58$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $f7cf5e2556f21b58$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $f7cf5e2556f21b58$var$allocUnsafe(arg);
    }
    return $f7cf5e2556f21b58$var$from(arg, encodingOrOffset, length);
}
$f7cf5e2556f21b58$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $f7cf5e2556f21b58$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $f7cf5e2556f21b58$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $f7cf5e2556f21b58$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($f7cf5e2556f21b58$var$isInstance(value, ArrayBuffer) || value && $f7cf5e2556f21b58$var$isInstance(value.buffer, ArrayBuffer)) return $f7cf5e2556f21b58$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($f7cf5e2556f21b58$var$isInstance(value, SharedArrayBuffer) || value && $f7cf5e2556f21b58$var$isInstance(value.buffer, SharedArrayBuffer))) return $f7cf5e2556f21b58$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $f7cf5e2556f21b58$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $f7cf5e2556f21b58$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $f7cf5e2556f21b58$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $f7cf5e2556f21b58$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $f7cf5e2556f21b58$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($f7cf5e2556f21b58$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($f7cf5e2556f21b58$var$Buffer, Uint8Array);
function $f7cf5e2556f21b58$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $f7cf5e2556f21b58$var$alloc(size, fill, encoding) {
    $f7cf5e2556f21b58$var$assertSize(size);
    if (size <= 0) return $f7cf5e2556f21b58$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $f7cf5e2556f21b58$var$createBuffer(size).fill(fill, encoding) : $f7cf5e2556f21b58$var$createBuffer(size).fill(fill);
    return $f7cf5e2556f21b58$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $f7cf5e2556f21b58$var$Buffer.alloc = function(size, fill, encoding) {
    return $f7cf5e2556f21b58$var$alloc(size, fill, encoding);
};
function $f7cf5e2556f21b58$var$allocUnsafe(size) {
    $f7cf5e2556f21b58$var$assertSize(size);
    return $f7cf5e2556f21b58$var$createBuffer(size < 0 ? 0 : $f7cf5e2556f21b58$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $f7cf5e2556f21b58$var$Buffer.allocUnsafe = function(size) {
    return $f7cf5e2556f21b58$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $f7cf5e2556f21b58$var$Buffer.allocUnsafeSlow = function(size) {
    return $f7cf5e2556f21b58$var$allocUnsafe(size);
};
function $f7cf5e2556f21b58$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$f7cf5e2556f21b58$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $f7cf5e2556f21b58$var$byteLength(string, encoding) | 0;
    let buf = $f7cf5e2556f21b58$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $f7cf5e2556f21b58$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $f7cf5e2556f21b58$var$checked(array.length) | 0;
    const buf = $f7cf5e2556f21b58$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $f7cf5e2556f21b58$var$fromArrayView(arrayView) {
    if ($f7cf5e2556f21b58$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $f7cf5e2556f21b58$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $f7cf5e2556f21b58$var$fromArrayLike(arrayView);
}
function $f7cf5e2556f21b58$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $f7cf5e2556f21b58$var$Buffer.prototype);
    return buf;
}
function $f7cf5e2556f21b58$var$fromObject(obj) {
    if ($f7cf5e2556f21b58$var$Buffer.isBuffer(obj)) {
        const len = $f7cf5e2556f21b58$var$checked(obj.length) | 0;
        const buf = $f7cf5e2556f21b58$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $f7cf5e2556f21b58$var$numberIsNaN(obj.length)) return $f7cf5e2556f21b58$var$createBuffer(0);
        return $f7cf5e2556f21b58$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $f7cf5e2556f21b58$var$fromArrayLike(obj.data);
}
function $f7cf5e2556f21b58$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $f7cf5e2556f21b58$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $f7cf5e2556f21b58$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $f7cf5e2556f21b58$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $f7cf5e2556f21b58$var$Buffer.alloc(+length);
}
$f7cf5e2556f21b58$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $f7cf5e2556f21b58$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$f7cf5e2556f21b58$var$Buffer.compare = function compare(a, b) {
    if ($f7cf5e2556f21b58$var$isInstance(a, Uint8Array)) a = $f7cf5e2556f21b58$var$Buffer.from(a, a.offset, a.byteLength);
    if ($f7cf5e2556f21b58$var$isInstance(b, Uint8Array)) b = $f7cf5e2556f21b58$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$f7cf5e2556f21b58$var$Buffer.isBuffer(a) || !$f7cf5e2556f21b58$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$f7cf5e2556f21b58$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$f7cf5e2556f21b58$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $f7cf5e2556f21b58$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $f7cf5e2556f21b58$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($f7cf5e2556f21b58$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$f7cf5e2556f21b58$var$Buffer.isBuffer(buf)) buf = $f7cf5e2556f21b58$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$f7cf5e2556f21b58$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $f7cf5e2556f21b58$var$byteLength(string, encoding) {
    if ($f7cf5e2556f21b58$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $f7cf5e2556f21b58$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $f7cf5e2556f21b58$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $f7cf5e2556f21b58$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $f7cf5e2556f21b58$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$f7cf5e2556f21b58$var$Buffer.byteLength = $f7cf5e2556f21b58$var$byteLength;
function $f7cf5e2556f21b58$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $f7cf5e2556f21b58$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $f7cf5e2556f21b58$var$utf8Slice(this, start, end);
        case 'ascii':
            return $f7cf5e2556f21b58$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $f7cf5e2556f21b58$var$latin1Slice(this, start, end);
        case 'base64':
            return $f7cf5e2556f21b58$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $f7cf5e2556f21b58$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$f7cf5e2556f21b58$var$Buffer.prototype._isBuffer = true;
function $f7cf5e2556f21b58$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$f7cf5e2556f21b58$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$f7cf5e2556f21b58$var$swap(this, i, i + 1);
    return this;
};
$f7cf5e2556f21b58$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $f7cf5e2556f21b58$var$swap(this, i, i + 3);
        $f7cf5e2556f21b58$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$f7cf5e2556f21b58$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $f7cf5e2556f21b58$var$swap(this, i, i + 7);
        $f7cf5e2556f21b58$var$swap(this, i + 1, i + 6);
        $f7cf5e2556f21b58$var$swap(this, i + 2, i + 5);
        $f7cf5e2556f21b58$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$f7cf5e2556f21b58$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $f7cf5e2556f21b58$var$utf8Slice(this, 0, length);
    return $f7cf5e2556f21b58$var$slowToString.apply(this, arguments);
};
$f7cf5e2556f21b58$var$Buffer.prototype.toLocaleString = $f7cf5e2556f21b58$var$Buffer.prototype.toString;
$f7cf5e2556f21b58$var$Buffer.prototype.equals = function equals(b) {
    if (!$f7cf5e2556f21b58$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $f7cf5e2556f21b58$var$Buffer.compare(this, b) === 0;
};
$f7cf5e2556f21b58$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $f7cf5e2556f21b58$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($f7cf5e2556f21b58$var$customInspectSymbol) $f7cf5e2556f21b58$var$Buffer.prototype[$f7cf5e2556f21b58$var$customInspectSymbol] = $f7cf5e2556f21b58$var$Buffer.prototype.inspect;
$f7cf5e2556f21b58$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($f7cf5e2556f21b58$var$isInstance(target, Uint8Array)) target = $f7cf5e2556f21b58$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$f7cf5e2556f21b58$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $f7cf5e2556f21b58$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($f7cf5e2556f21b58$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $f7cf5e2556f21b58$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($f7cf5e2556f21b58$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $f7cf5e2556f21b58$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $f7cf5e2556f21b58$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $f7cf5e2556f21b58$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$f7cf5e2556f21b58$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$f7cf5e2556f21b58$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $f7cf5e2556f21b58$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$f7cf5e2556f21b58$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $f7cf5e2556f21b58$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $f7cf5e2556f21b58$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($f7cf5e2556f21b58$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $f7cf5e2556f21b58$var$utf8Write(buf, string, offset, length) {
    return $f7cf5e2556f21b58$var$blitBuffer($f7cf5e2556f21b58$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $f7cf5e2556f21b58$var$asciiWrite(buf, string, offset, length) {
    return $f7cf5e2556f21b58$var$blitBuffer($f7cf5e2556f21b58$var$asciiToBytes(string), buf, offset, length);
}
function $f7cf5e2556f21b58$var$base64Write(buf, string, offset, length) {
    return $f7cf5e2556f21b58$var$blitBuffer($f7cf5e2556f21b58$var$base64ToBytes(string), buf, offset, length);
}
function $f7cf5e2556f21b58$var$ucs2Write(buf, string, offset, length) {
    return $f7cf5e2556f21b58$var$blitBuffer($f7cf5e2556f21b58$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$f7cf5e2556f21b58$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $f7cf5e2556f21b58$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $f7cf5e2556f21b58$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $f7cf5e2556f21b58$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $f7cf5e2556f21b58$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $f7cf5e2556f21b58$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$f7cf5e2556f21b58$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $f7cf5e2556f21b58$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $8KxEN.fromByteArray(buf);
    else return $8KxEN.fromByteArray(buf.slice(start, end));
}
function $f7cf5e2556f21b58$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $f7cf5e2556f21b58$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $f7cf5e2556f21b58$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $f7cf5e2556f21b58$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $f7cf5e2556f21b58$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $f7cf5e2556f21b58$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $f7cf5e2556f21b58$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $f7cf5e2556f21b58$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $f7cf5e2556f21b58$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $f7cf5e2556f21b58$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $f7cf5e2556f21b58$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$f7cf5e2556f21b58$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $f7cf5e2556f21b58$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $f7cf5e2556f21b58$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$f7cf5e2556f21b58$var$Buffer.prototype.readUintLE = $f7cf5e2556f21b58$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f7cf5e2556f21b58$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$f7cf5e2556f21b58$var$Buffer.prototype.readUintBE = $f7cf5e2556f21b58$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f7cf5e2556f21b58$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$f7cf5e2556f21b58$var$Buffer.prototype.readUint8 = $f7cf5e2556f21b58$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f7cf5e2556f21b58$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$f7cf5e2556f21b58$var$Buffer.prototype.readUint16LE = $f7cf5e2556f21b58$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f7cf5e2556f21b58$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$f7cf5e2556f21b58$var$Buffer.prototype.readUint16BE = $f7cf5e2556f21b58$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f7cf5e2556f21b58$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$f7cf5e2556f21b58$var$Buffer.prototype.readUint32LE = $f7cf5e2556f21b58$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f7cf5e2556f21b58$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$f7cf5e2556f21b58$var$Buffer.prototype.readUint32BE = $f7cf5e2556f21b58$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f7cf5e2556f21b58$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$f7cf5e2556f21b58$var$Buffer.prototype.readBigUInt64LE = $f7cf5e2556f21b58$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $f7cf5e2556f21b58$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f7cf5e2556f21b58$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$f7cf5e2556f21b58$var$Buffer.prototype.readBigUInt64BE = $f7cf5e2556f21b58$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $f7cf5e2556f21b58$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f7cf5e2556f21b58$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$f7cf5e2556f21b58$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f7cf5e2556f21b58$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$f7cf5e2556f21b58$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f7cf5e2556f21b58$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$f7cf5e2556f21b58$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f7cf5e2556f21b58$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$f7cf5e2556f21b58$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f7cf5e2556f21b58$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$f7cf5e2556f21b58$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f7cf5e2556f21b58$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$f7cf5e2556f21b58$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f7cf5e2556f21b58$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$f7cf5e2556f21b58$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f7cf5e2556f21b58$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$f7cf5e2556f21b58$var$Buffer.prototype.readBigInt64LE = $f7cf5e2556f21b58$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $f7cf5e2556f21b58$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f7cf5e2556f21b58$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$f7cf5e2556f21b58$var$Buffer.prototype.readBigInt64BE = $f7cf5e2556f21b58$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $f7cf5e2556f21b58$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f7cf5e2556f21b58$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$f7cf5e2556f21b58$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f7cf5e2556f21b58$var$checkOffset(offset, 4, this.length);
    return $aWooH.read(this, offset, true, 23, 4);
};
$f7cf5e2556f21b58$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f7cf5e2556f21b58$var$checkOffset(offset, 4, this.length);
    return $aWooH.read(this, offset, false, 23, 4);
};
$f7cf5e2556f21b58$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f7cf5e2556f21b58$var$checkOffset(offset, 8, this.length);
    return $aWooH.read(this, offset, true, 52, 8);
};
$f7cf5e2556f21b58$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f7cf5e2556f21b58$var$checkOffset(offset, 8, this.length);
    return $aWooH.read(this, offset, false, 52, 8);
};
function $f7cf5e2556f21b58$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$f7cf5e2556f21b58$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$f7cf5e2556f21b58$var$Buffer.prototype.writeUintLE = $f7cf5e2556f21b58$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $f7cf5e2556f21b58$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$f7cf5e2556f21b58$var$Buffer.prototype.writeUintBE = $f7cf5e2556f21b58$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $f7cf5e2556f21b58$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$f7cf5e2556f21b58$var$Buffer.prototype.writeUint8 = $f7cf5e2556f21b58$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f7cf5e2556f21b58$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$f7cf5e2556f21b58$var$Buffer.prototype.writeUint16LE = $f7cf5e2556f21b58$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f7cf5e2556f21b58$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$f7cf5e2556f21b58$var$Buffer.prototype.writeUint16BE = $f7cf5e2556f21b58$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f7cf5e2556f21b58$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$f7cf5e2556f21b58$var$Buffer.prototype.writeUint32LE = $f7cf5e2556f21b58$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f7cf5e2556f21b58$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$f7cf5e2556f21b58$var$Buffer.prototype.writeUint32BE = $f7cf5e2556f21b58$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f7cf5e2556f21b58$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $f7cf5e2556f21b58$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $f7cf5e2556f21b58$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $f7cf5e2556f21b58$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $f7cf5e2556f21b58$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$f7cf5e2556f21b58$var$Buffer.prototype.writeBigUInt64LE = $f7cf5e2556f21b58$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $f7cf5e2556f21b58$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$f7cf5e2556f21b58$var$Buffer.prototype.writeBigUInt64BE = $f7cf5e2556f21b58$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $f7cf5e2556f21b58$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$f7cf5e2556f21b58$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $f7cf5e2556f21b58$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$f7cf5e2556f21b58$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $f7cf5e2556f21b58$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$f7cf5e2556f21b58$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f7cf5e2556f21b58$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$f7cf5e2556f21b58$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f7cf5e2556f21b58$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$f7cf5e2556f21b58$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f7cf5e2556f21b58$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$f7cf5e2556f21b58$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f7cf5e2556f21b58$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$f7cf5e2556f21b58$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f7cf5e2556f21b58$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$f7cf5e2556f21b58$var$Buffer.prototype.writeBigInt64LE = $f7cf5e2556f21b58$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $f7cf5e2556f21b58$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$f7cf5e2556f21b58$var$Buffer.prototype.writeBigInt64BE = $f7cf5e2556f21b58$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $f7cf5e2556f21b58$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $f7cf5e2556f21b58$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $f7cf5e2556f21b58$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f7cf5e2556f21b58$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $aWooH.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$f7cf5e2556f21b58$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $f7cf5e2556f21b58$var$writeFloat(this, value, offset, true, noAssert);
};
$f7cf5e2556f21b58$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $f7cf5e2556f21b58$var$writeFloat(this, value, offset, false, noAssert);
};
function $f7cf5e2556f21b58$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f7cf5e2556f21b58$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $aWooH.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$f7cf5e2556f21b58$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $f7cf5e2556f21b58$var$writeDouble(this, value, offset, true, noAssert);
};
$f7cf5e2556f21b58$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $f7cf5e2556f21b58$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$f7cf5e2556f21b58$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$f7cf5e2556f21b58$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$f7cf5e2556f21b58$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$f7cf5e2556f21b58$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $f7cf5e2556f21b58$var$Buffer.isBuffer(val) ? val : $f7cf5e2556f21b58$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $f7cf5e2556f21b58$var$errors = {};
function $f7cf5e2556f21b58$var$E(sym, getMessage, Base) {
    $f7cf5e2556f21b58$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$f7cf5e2556f21b58$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$f7cf5e2556f21b58$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$f7cf5e2556f21b58$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $f7cf5e2556f21b58$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $f7cf5e2556f21b58$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $f7cf5e2556f21b58$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $f7cf5e2556f21b58$var$checkBounds(buf, offset, byteLength) {
    $f7cf5e2556f21b58$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $f7cf5e2556f21b58$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $f7cf5e2556f21b58$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $f7cf5e2556f21b58$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $f7cf5e2556f21b58$var$checkBounds(buf, offset, byteLength);
}
function $f7cf5e2556f21b58$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $f7cf5e2556f21b58$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $f7cf5e2556f21b58$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $f7cf5e2556f21b58$var$validateNumber(value, type);
        throw new $f7cf5e2556f21b58$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $f7cf5e2556f21b58$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $f7cf5e2556f21b58$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $f7cf5e2556f21b58$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $f7cf5e2556f21b58$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($f7cf5e2556f21b58$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $f7cf5e2556f21b58$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $f7cf5e2556f21b58$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $f7cf5e2556f21b58$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $f7cf5e2556f21b58$var$base64ToBytes(str) {
    return $8KxEN.toByteArray($f7cf5e2556f21b58$var$base64clean(str));
}
function $f7cf5e2556f21b58$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $f7cf5e2556f21b58$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $f7cf5e2556f21b58$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $f7cf5e2556f21b58$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $f7cf5e2556f21b58$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $f7cf5e2556f21b58$var$BufferBigIntNotDefined : fn;
}
function $f7cf5e2556f21b58$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("8KxEN", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $65ecba2a1c4f61b0$export$d622b2ad8d90c771; }, function (v) { return $65ecba2a1c4f61b0$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $65ecba2a1c4f61b0$export$6100ba28696e12de; }, function (v) { return $65ecba2a1c4f61b0$export$6100ba28696e12de = v; });
var $65ecba2a1c4f61b0$export$a48f0734ac7c2329;
var $65ecba2a1c4f61b0$export$d622b2ad8d90c771;
var $65ecba2a1c4f61b0$export$6100ba28696e12de;
'use strict';
$65ecba2a1c4f61b0$export$a48f0734ac7c2329 = $65ecba2a1c4f61b0$var$byteLength;
$65ecba2a1c4f61b0$export$d622b2ad8d90c771 = $65ecba2a1c4f61b0$var$toByteArray;
$65ecba2a1c4f61b0$export$6100ba28696e12de = $65ecba2a1c4f61b0$var$fromByteArray;
var $65ecba2a1c4f61b0$var$lookup = [];
var $65ecba2a1c4f61b0$var$revLookup = [];
var $65ecba2a1c4f61b0$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $65ecba2a1c4f61b0$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $65ecba2a1c4f61b0$var$i = 0, $65ecba2a1c4f61b0$var$len = $65ecba2a1c4f61b0$var$code.length; $65ecba2a1c4f61b0$var$i < $65ecba2a1c4f61b0$var$len; ++$65ecba2a1c4f61b0$var$i){
    $65ecba2a1c4f61b0$var$lookup[$65ecba2a1c4f61b0$var$i] = $65ecba2a1c4f61b0$var$code[$65ecba2a1c4f61b0$var$i];
    $65ecba2a1c4f61b0$var$revLookup[$65ecba2a1c4f61b0$var$code.charCodeAt($65ecba2a1c4f61b0$var$i)] = $65ecba2a1c4f61b0$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$65ecba2a1c4f61b0$var$revLookup['-'.charCodeAt(0)] = 62;
$65ecba2a1c4f61b0$var$revLookup['_'.charCodeAt(0)] = 63;
function $65ecba2a1c4f61b0$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $65ecba2a1c4f61b0$var$byteLength(b64) {
    var lens = $65ecba2a1c4f61b0$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $65ecba2a1c4f61b0$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $65ecba2a1c4f61b0$var$toByteArray(b64) {
    var tmp;
    var lens = $65ecba2a1c4f61b0$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $65ecba2a1c4f61b0$var$Arr($65ecba2a1c4f61b0$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $65ecba2a1c4f61b0$var$revLookup[b64.charCodeAt(i)] << 18 | $65ecba2a1c4f61b0$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $65ecba2a1c4f61b0$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $65ecba2a1c4f61b0$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $65ecba2a1c4f61b0$var$revLookup[b64.charCodeAt(i)] << 2 | $65ecba2a1c4f61b0$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $65ecba2a1c4f61b0$var$revLookup[b64.charCodeAt(i)] << 10 | $65ecba2a1c4f61b0$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $65ecba2a1c4f61b0$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $65ecba2a1c4f61b0$var$tripletToBase64(num) {
    return $65ecba2a1c4f61b0$var$lookup[num >> 18 & 0x3F] + $65ecba2a1c4f61b0$var$lookup[num >> 12 & 0x3F] + $65ecba2a1c4f61b0$var$lookup[num >> 6 & 0x3F] + $65ecba2a1c4f61b0$var$lookup[num & 0x3F];
}
function $65ecba2a1c4f61b0$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($65ecba2a1c4f61b0$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $65ecba2a1c4f61b0$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($65ecba2a1c4f61b0$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($65ecba2a1c4f61b0$var$lookup[tmp >> 2] + $65ecba2a1c4f61b0$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($65ecba2a1c4f61b0$var$lookup[tmp >> 10] + $65ecba2a1c4f61b0$var$lookup[tmp >> 4 & 0x3F] + $65ecba2a1c4f61b0$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("aWooH", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $7f723ef475ec5163$export$aafa59e2e03f2942; }, function (v) { return $7f723ef475ec5163$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $7f723ef475ec5163$export$68d8715fc104d294; }, function (v) { return $7f723ef475ec5163$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7f723ef475ec5163$export$aafa59e2e03f2942;
var $7f723ef475ec5163$export$68d8715fc104d294;
$7f723ef475ec5163$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7f723ef475ec5163$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("2RdYA", function(module, exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ 'use strict';

var $8b36G = parcelRequire("8b36G");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    '\''
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat(autoEscape), hostEndingChars = [
    '/',
    '?',
    '#'
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};

var $jhoPC = parcelRequire("jhoPC");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === 'object' && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== 'string') throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf('?'), splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#', uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, '/');
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $jhoPC.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = '';
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf('@', hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || '';
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = '/' + notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = '';
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = $8b36G.toASCII(this.hostname);
        var p = this.port ? ':' + this.port : '';
        var h = this.hostname || '';
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== '/') rest = '/' + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $jhoPC.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = '';
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '/';
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || '';
        var s = this.search || '';
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === 'string') obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || '';
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ':');
        auth += '@';
    }
    var protocol = this.protocol || '', pathname = this.pathname || '', hash = this.hash || '', host = false, query = '';
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
        if (this.port) host += ':' + this.port;
    }
    if (this.query && typeof this.query === 'object' && Object.keys(this.query).length) query = $jhoPC.stringify(this.query, {
        arrayFormat: 'repeat',
        addQueryPrefix: false
    });
    var search = this.search || query && '?' + query || '';
    if (protocol && protocol.substr(-1) !== ':') protocol += ':';
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = '//' + (host || '');
        if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
    } else if (!host) host = '';
    if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
    if (search && search.charAt(0) !== '?') search = '?' + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace('#', '%23');
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === 'string') {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === '') {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== 'protocol') result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = '/';
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || '').split('/');
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = '';
            if (!relative.hostname) relative.hostname = '';
            if (relPath[0] !== '') relPath.unshift('');
            if (relPath.length < 2) relPath.unshift('');
            result.pathname = relPath.join('/');
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || '';
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || '';
            var s = result.search || '';
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/', isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/', mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split('/') || [], relPath = relative.pathname && relative.pathname.split('/') || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = '';
        result.port = null;
        if (result.host) {
            if (srcPath[0] === '') srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = '';
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === '') relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === '' ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = '/' + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === '.') srcPath.splice(i, 1);
        else if (last === '..') {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift('..');
    if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) srcPath.unshift('');
    if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') srcPath.push('');
    var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift('');
    if (srcPath.length > 0) result.pathname = srcPath.join('/');
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

});
parcelRegister("8b36G", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = '-', /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        'overflow': 'Overflow: input needs wider integers to process',
        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
        'invalid-input': 'Invalid input'
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split('@');
        var result = '';
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + '@';
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, '\x2E');
        var labels = string.split('.');
        var encoded = map(labels, fn).join('.');
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = '';
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join('');
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error('not-basic');
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error('invalid-input');
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error('overflow');
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error('overflow');
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error('overflow');
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error('overflow');
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error('overflow');
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join('');
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ 'version': '1.4.1',
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ 'ucs2': {
            'decode': ucs2decode,
            'encode': ucs2encode
        },
        'decode': decode,
        'encode': encode,
        'toASCII': toASCII,
        'toUnicode': toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define('punycode', function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("jhoPC", function(module, exports) {
'use strict';

var $16JRU = parcelRequire("16JRU");

var $khw7U = parcelRequire("khw7U");

var $aaHyO = parcelRequire("aaHyO");
module.exports = {
    formats: $aaHyO,
    parse: $khw7U,
    stringify: $16JRU
};

});
parcelRegister("16JRU", function(module, exports) {
'use strict';

var $e8FAK = parcelRequire("e8FAK");

var $iOqfi = parcelRequire("iOqfi");

var $aaHyO = parcelRequire("aaHyO");
var $0ce9ee80b6a575ac$var$has = Object.prototype.hasOwnProperty;
var $0ce9ee80b6a575ac$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $0ce9ee80b6a575ac$var$isArray = Array.isArray;
var $0ce9ee80b6a575ac$var$push = Array.prototype.push;
var $0ce9ee80b6a575ac$var$pushToArray = function(arr, valueOrArray) {
    $0ce9ee80b6a575ac$var$push.apply(arr, $0ce9ee80b6a575ac$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $0ce9ee80b6a575ac$var$toISO = Date.prototype.toISOString;
var $0ce9ee80b6a575ac$var$defaultFormat = $aaHyO.default;
var $0ce9ee80b6a575ac$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: $iOqfi.encode,
    encodeValuesOnly: false,
    filter: void 0,
    format: $0ce9ee80b6a575ac$var$defaultFormat,
    formatter: $aaHyO.formatters[$0ce9ee80b6a575ac$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $0ce9ee80b6a575ac$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $0ce9ee80b6a575ac$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $0ce9ee80b6a575ac$var$sentinel = {};
var $0ce9ee80b6a575ac$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($0ce9ee80b6a575ac$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($0ce9ee80b6a575ac$var$sentinel) === 'undefined') step = 0;
    }
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $0ce9ee80b6a575ac$var$isArray(obj)) obj = $iOqfi.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $0ce9ee80b6a575ac$var$defaults.encoder, charset, 'key', format) : prefix;
        obj = '';
    }
    if ($0ce9ee80b6a575ac$var$isNonNullishPrimitive(obj) || $iOqfi.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $0ce9ee80b6a575ac$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $0ce9ee80b6a575ac$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $0ce9ee80b6a575ac$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $iOqfi.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(',') || null : void 0
            }
        ];
    } else if ($0ce9ee80b6a575ac$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);
    var adjustedPrefix = commaRoundTrip && $0ce9ee80b6a575ac$var$isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
    if (allowEmptyArrays && $0ce9ee80b6a575ac$var$isArray(obj) && obj.length === 0) return adjustedPrefix + '[]';
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = $0ce9ee80b6a575ac$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $e8FAK();
        valueSideChannel.set($0ce9ee80b6a575ac$var$sentinel, sideChannel);
        $0ce9ee80b6a575ac$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && $0ce9ee80b6a575ac$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $0ce9ee80b6a575ac$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $0ce9ee80b6a575ac$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $0ce9ee80b6a575ac$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $aaHyO.default;
    if (typeof opts.format !== 'undefined') {
        if (!$0ce9ee80b6a575ac$var$has.call($aaHyO.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $aaHyO.formatters[format];
    var filter = $0ce9ee80b6a575ac$var$defaults.filter;
    if (typeof opts.filter === 'function' || $0ce9ee80b6a575ac$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $0ce9ee80b6a575ac$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ('indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = $0ce9ee80b6a575ac$var$defaults.arrayFormat;
    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : $0ce9ee80b6a575ac$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $0ce9ee80b6a575ac$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $0ce9ee80b6a575ac$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $0ce9ee80b6a575ac$var$defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? $0ce9ee80b6a575ac$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $0ce9ee80b6a575ac$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : $0ce9ee80b6a575ac$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $0ce9ee80b6a575ac$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $0ce9ee80b6a575ac$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $0ce9ee80b6a575ac$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $0ce9ee80b6a575ac$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $0ce9ee80b6a575ac$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $0ce9ee80b6a575ac$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($0ce9ee80b6a575ac$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var generateArrayPrefix = $0ce9ee80b6a575ac$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $e8FAK();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        var value = obj[key];
        if (options.skipNulls && value === null) continue;
        $0ce9ee80b6a575ac$var$pushToArray(keys, $0ce9ee80b6a575ac$var$stringify(value, key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B&';
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93&';
    }
    return joined.length > 0 ? prefix + joined : '';
};

});
parcelRegister("e8FAK", function(module, exports) {
'use strict';

var $aSCZz = parcelRequire("aSCZz");

var $3xDnv = parcelRequire("3xDnv");

var $7rAIU = parcelRequire("7rAIU");

var $hersr = parcelRequire("hersr");

var $9rr7R = parcelRequire("9rr7R");
var $a4b213450956b97c$var$makeChannel = $9rr7R || $hersr || $7rAIU;
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $aSCZz('Side channel does not contain ' + $3xDnv(key));
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $a4b213450956b97c$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

});
parcelRegister("aSCZz", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("3xDnv", function(module, exports) {
var $2942ffd3360a348e$var$hasMap = typeof Map === 'function' && Map.prototype;
var $2942ffd3360a348e$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $2942ffd3360a348e$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $2942ffd3360a348e$var$mapSize = $2942ffd3360a348e$var$hasMap && $2942ffd3360a348e$var$mapSizeDescriptor && typeof $2942ffd3360a348e$var$mapSizeDescriptor.get === 'function' ? $2942ffd3360a348e$var$mapSizeDescriptor.get : null;
var $2942ffd3360a348e$var$mapForEach = $2942ffd3360a348e$var$hasMap && Map.prototype.forEach;
var $2942ffd3360a348e$var$hasSet = typeof Set === 'function' && Set.prototype;
var $2942ffd3360a348e$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $2942ffd3360a348e$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $2942ffd3360a348e$var$setSize = $2942ffd3360a348e$var$hasSet && $2942ffd3360a348e$var$setSizeDescriptor && typeof $2942ffd3360a348e$var$setSizeDescriptor.get === 'function' ? $2942ffd3360a348e$var$setSizeDescriptor.get : null;
var $2942ffd3360a348e$var$setForEach = $2942ffd3360a348e$var$hasSet && Set.prototype.forEach;
var $2942ffd3360a348e$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $2942ffd3360a348e$var$weakMapHas = $2942ffd3360a348e$var$hasWeakMap ? WeakMap.prototype.has : null;
var $2942ffd3360a348e$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $2942ffd3360a348e$var$weakSetHas = $2942ffd3360a348e$var$hasWeakSet ? WeakSet.prototype.has : null;
var $2942ffd3360a348e$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $2942ffd3360a348e$var$weakRefDeref = $2942ffd3360a348e$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $2942ffd3360a348e$var$booleanValueOf = Boolean.prototype.valueOf;
var $2942ffd3360a348e$var$objectToString = Object.prototype.toString;
var $2942ffd3360a348e$var$functionToString = Function.prototype.toString;
var $2942ffd3360a348e$var$$match = String.prototype.match;
var $2942ffd3360a348e$var$$slice = String.prototype.slice;
var $2942ffd3360a348e$var$$replace = String.prototype.replace;
var $2942ffd3360a348e$var$$toUpperCase = String.prototype.toUpperCase;
var $2942ffd3360a348e$var$$toLowerCase = String.prototype.toLowerCase;
var $2942ffd3360a348e$var$$test = RegExp.prototype.test;
var $2942ffd3360a348e$var$$concat = Array.prototype.concat;
var $2942ffd3360a348e$var$$join = Array.prototype.join;
var $2942ffd3360a348e$var$$arrSlice = Array.prototype.slice;
var $2942ffd3360a348e$var$$floor = Math.floor;
var $2942ffd3360a348e$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $2942ffd3360a348e$var$gOPS = Object.getOwnPropertySymbols;
var $2942ffd3360a348e$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $2942ffd3360a348e$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $2942ffd3360a348e$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $2942ffd3360a348e$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $2942ffd3360a348e$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $2942ffd3360a348e$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $2942ffd3360a348e$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $2942ffd3360a348e$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$2942ffd3360a348e$var$$floor(-num) : $2942ffd3360a348e$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $2942ffd3360a348e$var$$slice.call(str, intStr.length + 1);
            return $2942ffd3360a348e$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $2942ffd3360a348e$var$$replace.call($2942ffd3360a348e$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $2942ffd3360a348e$var$$replace.call(str, sepRegex, '$&_');
}

var $cmMDL = parcelRequire("cmMDL");
var $2942ffd3360a348e$var$inspectCustom = $cmMDL.custom;
var $2942ffd3360a348e$var$inspectSymbol = $2942ffd3360a348e$var$isSymbol($2942ffd3360a348e$var$inspectCustom) ? $2942ffd3360a348e$var$inspectCustom : null;
var $2942ffd3360a348e$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $2942ffd3360a348e$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($2942ffd3360a348e$var$has(opts, 'quoteStyle') && !$2942ffd3360a348e$var$has($2942ffd3360a348e$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($2942ffd3360a348e$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $2942ffd3360a348e$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($2942ffd3360a348e$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($2942ffd3360a348e$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $2942ffd3360a348e$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $2942ffd3360a348e$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $2942ffd3360a348e$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $2942ffd3360a348e$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $2942ffd3360a348e$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($2942ffd3360a348e$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $2942ffd3360a348e$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($2942ffd3360a348e$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$2942ffd3360a348e$var$isRegExp(obj)) {
        var name = $2942ffd3360a348e$var$nameOf(obj);
        var keys = $2942ffd3360a348e$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $2942ffd3360a348e$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($2942ffd3360a348e$var$isSymbol(obj)) {
        var symString = $2942ffd3360a348e$var$hasShammedSymbols ? $2942ffd3360a348e$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $2942ffd3360a348e$var$symToString.call(obj);
        return typeof obj === 'object' && !$2942ffd3360a348e$var$hasShammedSymbols ? $2942ffd3360a348e$var$markBoxed(symString) : symString;
    }
    if ($2942ffd3360a348e$var$isElement(obj)) {
        var s = '<' + $2942ffd3360a348e$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $2942ffd3360a348e$var$wrapQuotes($2942ffd3360a348e$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $2942ffd3360a348e$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($2942ffd3360a348e$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $2942ffd3360a348e$var$arrObjKeys(obj, inspect);
        if (indent && !$2942ffd3360a348e$var$singleLineValues(xs)) return '[' + $2942ffd3360a348e$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $2942ffd3360a348e$var$$join.call(xs, ', ') + ' ]';
    }
    if ($2942ffd3360a348e$var$isError(obj)) {
        var parts = $2942ffd3360a348e$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$2942ffd3360a348e$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $2942ffd3360a348e$var$$join.call($2942ffd3360a348e$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $2942ffd3360a348e$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($2942ffd3360a348e$var$inspectSymbol && typeof obj[$2942ffd3360a348e$var$inspectSymbol] === 'function' && $cmMDL) return $cmMDL(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($2942ffd3360a348e$var$isMap(obj)) {
        var mapParts = [];
        if ($2942ffd3360a348e$var$mapForEach) $2942ffd3360a348e$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $2942ffd3360a348e$var$collectionOf('Map', $2942ffd3360a348e$var$mapSize.call(obj), mapParts, indent);
    }
    if ($2942ffd3360a348e$var$isSet(obj)) {
        var setParts = [];
        if ($2942ffd3360a348e$var$setForEach) $2942ffd3360a348e$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $2942ffd3360a348e$var$collectionOf('Set', $2942ffd3360a348e$var$setSize.call(obj), setParts, indent);
    }
    if ($2942ffd3360a348e$var$isWeakMap(obj)) return $2942ffd3360a348e$var$weakCollectionOf('WeakMap');
    if ($2942ffd3360a348e$var$isWeakSet(obj)) return $2942ffd3360a348e$var$weakCollectionOf('WeakSet');
    if ($2942ffd3360a348e$var$isWeakRef(obj)) return $2942ffd3360a348e$var$weakCollectionOf('WeakRef');
    if ($2942ffd3360a348e$var$isNumber(obj)) return $2942ffd3360a348e$var$markBoxed(inspect(Number(obj)));
    if ($2942ffd3360a348e$var$isBigInt(obj)) return $2942ffd3360a348e$var$markBoxed(inspect($2942ffd3360a348e$var$bigIntValueOf.call(obj)));
    if ($2942ffd3360a348e$var$isBoolean(obj)) return $2942ffd3360a348e$var$markBoxed($2942ffd3360a348e$var$booleanValueOf.call(obj));
    if ($2942ffd3360a348e$var$isString(obj)) return $2942ffd3360a348e$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$2942ffd3360a348e$var$isDate(obj) && !$2942ffd3360a348e$var$isRegExp(obj)) {
        var ys = $2942ffd3360a348e$var$arrObjKeys(obj, inspect);
        var isPlainObject = $2942ffd3360a348e$var$gPO ? $2942ffd3360a348e$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $2942ffd3360a348e$var$toStringTag && Object(obj) === obj && $2942ffd3360a348e$var$toStringTag in obj ? $2942ffd3360a348e$var$$slice.call($2942ffd3360a348e$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $2942ffd3360a348e$var$$join.call($2942ffd3360a348e$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $2942ffd3360a348e$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $2942ffd3360a348e$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $2942ffd3360a348e$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $2942ffd3360a348e$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $2942ffd3360a348e$var$quote(s) {
    return $2942ffd3360a348e$var$$replace.call(String(s), /"/g, '&quot;');
}
function $2942ffd3360a348e$var$canTrustToString(obj) {
    return !$2942ffd3360a348e$var$toStringTag || !(typeof obj === 'object' && ($2942ffd3360a348e$var$toStringTag in obj || typeof obj[$2942ffd3360a348e$var$toStringTag] !== 'undefined'));
}
function $2942ffd3360a348e$var$isArray(obj) {
    return $2942ffd3360a348e$var$toStr(obj) === '[object Array]' && $2942ffd3360a348e$var$canTrustToString(obj);
}
function $2942ffd3360a348e$var$isDate(obj) {
    return $2942ffd3360a348e$var$toStr(obj) === '[object Date]' && $2942ffd3360a348e$var$canTrustToString(obj);
}
function $2942ffd3360a348e$var$isRegExp(obj) {
    return $2942ffd3360a348e$var$toStr(obj) === '[object RegExp]' && $2942ffd3360a348e$var$canTrustToString(obj);
}
function $2942ffd3360a348e$var$isError(obj) {
    return $2942ffd3360a348e$var$toStr(obj) === '[object Error]' && $2942ffd3360a348e$var$canTrustToString(obj);
}
function $2942ffd3360a348e$var$isString(obj) {
    return $2942ffd3360a348e$var$toStr(obj) === '[object String]' && $2942ffd3360a348e$var$canTrustToString(obj);
}
function $2942ffd3360a348e$var$isNumber(obj) {
    return $2942ffd3360a348e$var$toStr(obj) === '[object Number]' && $2942ffd3360a348e$var$canTrustToString(obj);
}
function $2942ffd3360a348e$var$isBoolean(obj) {
    return $2942ffd3360a348e$var$toStr(obj) === '[object Boolean]' && $2942ffd3360a348e$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $2942ffd3360a348e$var$isSymbol(obj) {
    if ($2942ffd3360a348e$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$2942ffd3360a348e$var$symToString) return false;
    try {
        $2942ffd3360a348e$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $2942ffd3360a348e$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$2942ffd3360a348e$var$bigIntValueOf) return false;
    try {
        $2942ffd3360a348e$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $2942ffd3360a348e$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $2942ffd3360a348e$var$has(obj, key) {
    return $2942ffd3360a348e$var$hasOwn.call(obj, key);
}
function $2942ffd3360a348e$var$toStr(obj) {
    return $2942ffd3360a348e$var$objectToString.call(obj);
}
function $2942ffd3360a348e$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $2942ffd3360a348e$var$$match.call($2942ffd3360a348e$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $2942ffd3360a348e$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $2942ffd3360a348e$var$isMap(x) {
    if (!$2942ffd3360a348e$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $2942ffd3360a348e$var$mapSize.call(x);
        try {
            $2942ffd3360a348e$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $2942ffd3360a348e$var$isWeakMap(x) {
    if (!$2942ffd3360a348e$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $2942ffd3360a348e$var$weakMapHas.call(x, $2942ffd3360a348e$var$weakMapHas);
        try {
            $2942ffd3360a348e$var$weakSetHas.call(x, $2942ffd3360a348e$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $2942ffd3360a348e$var$isWeakRef(x) {
    if (!$2942ffd3360a348e$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $2942ffd3360a348e$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $2942ffd3360a348e$var$isSet(x) {
    if (!$2942ffd3360a348e$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $2942ffd3360a348e$var$setSize.call(x);
        try {
            $2942ffd3360a348e$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $2942ffd3360a348e$var$isWeakSet(x) {
    if (!$2942ffd3360a348e$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $2942ffd3360a348e$var$weakSetHas.call(x, $2942ffd3360a348e$var$weakSetHas);
        try {
            $2942ffd3360a348e$var$weakMapHas.call(x, $2942ffd3360a348e$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $2942ffd3360a348e$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $2942ffd3360a348e$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $2942ffd3360a348e$var$inspectString($2942ffd3360a348e$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $2942ffd3360a348e$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $2942ffd3360a348e$var$$replace.call($2942ffd3360a348e$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $2942ffd3360a348e$var$lowbyte);
    return $2942ffd3360a348e$var$wrapQuotes(s, 'single', opts);
}
function $2942ffd3360a348e$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $2942ffd3360a348e$var$$toUpperCase.call(n.toString(16));
}
function $2942ffd3360a348e$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $2942ffd3360a348e$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $2942ffd3360a348e$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $2942ffd3360a348e$var$indentedJoin(entries, indent) : $2942ffd3360a348e$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $2942ffd3360a348e$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($2942ffd3360a348e$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $2942ffd3360a348e$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $2942ffd3360a348e$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $2942ffd3360a348e$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $2942ffd3360a348e$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $2942ffd3360a348e$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $2942ffd3360a348e$var$arrObjKeys(obj, inspect) {
    var isArr = $2942ffd3360a348e$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $2942ffd3360a348e$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $2942ffd3360a348e$var$gOPS === 'function' ? $2942ffd3360a348e$var$gOPS(obj) : [];
    var symMap;
    if ($2942ffd3360a348e$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$2942ffd3360a348e$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($2942ffd3360a348e$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($2942ffd3360a348e$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $2942ffd3360a348e$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($2942ffd3360a348e$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("cmMDL", function(module, exports) {
"use strict";

});


parcelRegister("7rAIU", function(module, exports) {
'use strict';

var $3xDnv = parcelRequire("3xDnv");

var $aSCZz = parcelRequire("aSCZz");
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $56b78a8852f6d71c$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $56b78a8852f6d71c$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $56b78a8852f6d71c$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $56b78a8852f6d71c$var$listSet = function(objects, key, value) {
    var node = $56b78a8852f6d71c$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $56b78a8852f6d71c$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$56b78a8852f6d71c$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $56b78a8852f6d71c$var$listDelete = function(objects, key) {
    if (objects) return $56b78a8852f6d71c$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ module.exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $aSCZz('Side channel does not contain ' + $3xDnv(key));
        },
        'delete': function(key) {
            var root = $o && $o.next;
            var deletedNode = $56b78a8852f6d71c$var$listDelete($o, key);
            if (deletedNode && root && root === deletedNode) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $56b78a8852f6d71c$var$listGet($o, key);
        },
        has: function(key) {
            return $56b78a8852f6d71c$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $56b78a8852f6d71c$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

});

parcelRegister("hersr", function(module, exports) {
'use strict';

var $80Cl4 = parcelRequire("80Cl4");

var $4EpNf = parcelRequire("4EpNf");

var $3xDnv = parcelRequire("3xDnv");

var $aSCZz = parcelRequire("aSCZz");
var $c8b90b078cc325fa$var$$Map = $80Cl4('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $c8b90b078cc325fa$var$$mapGet = $4EpNf('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $c8b90b078cc325fa$var$$mapSet = $4EpNf('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $c8b90b078cc325fa$var$$mapHas = $4EpNf('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $c8b90b078cc325fa$var$$mapDelete = $4EpNf('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $c8b90b078cc325fa$var$$mapSize = $4EpNf('Map.prototype.size', true);
/** @type {import('.')} */ module.exports = !!$c8b90b078cc325fa$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $aSCZz('Side channel does not contain ' + $3xDnv(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $c8b90b078cc325fa$var$$mapDelete($m, key);
                if ($c8b90b078cc325fa$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $c8b90b078cc325fa$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $c8b90b078cc325fa$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $c8b90b078cc325fa$var$$Map();
            $c8b90b078cc325fa$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};

});
parcelRegister("80Cl4", function(module, exports) {
'use strict';
var $5d4c101bdac3ea44$var$undefined1;

var $54r9h = parcelRequire("54r9h");

var $1bvjx = parcelRequire("1bvjx");

var $11xNG = parcelRequire("11xNG");

var $jpjmZ = parcelRequire("jpjmZ");

var $8o5Da = parcelRequire("8o5Da");

var $dhvGr = parcelRequire("dhvGr");

var $aSCZz = parcelRequire("aSCZz");

var $fAtY2 = parcelRequire("fAtY2");

var $2F43o = parcelRequire("2F43o");

var $7Ze0b = parcelRequire("7Ze0b");

var $gqwxx = parcelRequire("gqwxx");

var $8Wt19 = parcelRequire("8Wt19");

var $lCIWp = parcelRequire("lCIWp");

var $2GB0m = parcelRequire("2GB0m");

var $3oCL5 = parcelRequire("3oCL5");
var $5d4c101bdac3ea44$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $5d4c101bdac3ea44$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $5d4c101bdac3ea44$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $4C48f = parcelRequire("4C48f");

var $5gGLy = parcelRequire("5gGLy");
var $5d4c101bdac3ea44$var$throwTypeError = function() {
    throw new $aSCZz();
};
var $5d4c101bdac3ea44$var$ThrowTypeError = $4C48f ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $5d4c101bdac3ea44$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $4C48f(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $5d4c101bdac3ea44$var$throwTypeError;
        }
    }
}() : $5d4c101bdac3ea44$var$throwTypeError;

var $5d4c101bdac3ea44$var$hasSymbols = (parcelRequire("h9e2j"))();

var $ca87s = parcelRequire("ca87s");

var $iyQEc = parcelRequire("iyQEc");

var $jTjDE = parcelRequire("jTjDE");

var $3rCWF = parcelRequire("3rCWF");

var $8M2hX = parcelRequire("8M2hX");
var $5d4c101bdac3ea44$var$needsEval = {};
var $5d4c101bdac3ea44$var$TypedArray = typeof Uint8Array === 'undefined' || !$ca87s ? undefined : $ca87s(Uint8Array);
var $5d4c101bdac3ea44$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $5d4c101bdac3ea44$var$hasSymbols && $ca87s ? $ca87s([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $5d4c101bdac3ea44$var$needsEval,
    '%AsyncGenerator%': $5d4c101bdac3ea44$var$needsEval,
    '%AsyncGeneratorFunction%': $5d4c101bdac3ea44$var$needsEval,
    '%AsyncIteratorPrototype%': $5d4c101bdac3ea44$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $1bvjx,
    '%eval%': eval,
    '%EvalError%': $11xNG,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $5d4c101bdac3ea44$var$$Function,
    '%GeneratorFunction%': $5d4c101bdac3ea44$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $5d4c101bdac3ea44$var$hasSymbols && $ca87s ? $ca87s($ca87s([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$5d4c101bdac3ea44$var$hasSymbols || !$ca87s ? undefined : $ca87s(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $54r9h,
    '%Object.getOwnPropertyDescriptor%': $4C48f,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $jpjmZ,
    '%ReferenceError%': $8o5Da,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$5d4c101bdac3ea44$var$hasSymbols || !$ca87s ? undefined : $ca87s(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $5d4c101bdac3ea44$var$hasSymbols && $ca87s ? $ca87s(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $5d4c101bdac3ea44$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $dhvGr,
    '%ThrowTypeError%': $5d4c101bdac3ea44$var$ThrowTypeError,
    '%TypedArray%': $5d4c101bdac3ea44$var$TypedArray,
    '%TypeError%': $aSCZz,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $fAtY2,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $8M2hX,
    '%Function.prototype.apply%': $3rCWF,
    '%Object.defineProperty%': $5gGLy,
    '%Object.getPrototypeOf%': $iyQEc,
    '%Math.abs%': $2F43o,
    '%Math.floor%': $7Ze0b,
    '%Math.max%': $gqwxx,
    '%Math.min%': $8Wt19,
    '%Math.pow%': $lCIWp,
    '%Math.round%': $2GB0m,
    '%Math.sign%': $3oCL5,
    '%Reflect.getPrototypeOf%': $jTjDE
};
if ($ca87s) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $5d4c101bdac3ea44$var$errorProto = $ca87s($ca87s(e));
    $5d4c101bdac3ea44$var$INTRINSICS['%Error.prototype%'] = $5d4c101bdac3ea44$var$errorProto;
}
var $5d4c101bdac3ea44$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $5d4c101bdac3ea44$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $5d4c101bdac3ea44$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $5d4c101bdac3ea44$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $ca87s) value = $ca87s(gen.prototype);
    }
    $5d4c101bdac3ea44$var$INTRINSICS[name] = value;
    return value;
};
var $5d4c101bdac3ea44$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $kttiA = parcelRequire("kttiA");

var $3XZ7K = parcelRequire("3XZ7K");
var $5d4c101bdac3ea44$var$$concat = $kttiA.call($8M2hX, Array.prototype.concat);
var $5d4c101bdac3ea44$var$$spliceApply = $kttiA.call($3rCWF, Array.prototype.splice);
var $5d4c101bdac3ea44$var$$replace = $kttiA.call($8M2hX, String.prototype.replace);
var $5d4c101bdac3ea44$var$$strSlice = $kttiA.call($8M2hX, String.prototype.slice);
var $5d4c101bdac3ea44$var$$exec = $kttiA.call($8M2hX, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $5d4c101bdac3ea44$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $5d4c101bdac3ea44$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $5d4c101bdac3ea44$var$stringToPath = function stringToPath(string) {
    var first = $5d4c101bdac3ea44$var$$strSlice(string, 0, 1);
    var last = $5d4c101bdac3ea44$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $dhvGr('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $dhvGr('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $5d4c101bdac3ea44$var$$replace(string, $5d4c101bdac3ea44$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $5d4c101bdac3ea44$var$$replace(subString, $5d4c101bdac3ea44$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $5d4c101bdac3ea44$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($3XZ7K($5d4c101bdac3ea44$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $5d4c101bdac3ea44$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($3XZ7K($5d4c101bdac3ea44$var$INTRINSICS, intrinsicName)) {
        var value = $5d4c101bdac3ea44$var$INTRINSICS[intrinsicName];
        if (value === $5d4c101bdac3ea44$var$needsEval) value = $5d4c101bdac3ea44$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $aSCZz('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $dhvGr('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $aSCZz('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $aSCZz('"allowMissing" argument must be a boolean');
    if ($5d4c101bdac3ea44$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $dhvGr('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $5d4c101bdac3ea44$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $5d4c101bdac3ea44$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $5d4c101bdac3ea44$var$$spliceApply(parts, $5d4c101bdac3ea44$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $5d4c101bdac3ea44$var$$strSlice(part, 0, 1);
        var last = $5d4c101bdac3ea44$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $dhvGr('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($3XZ7K($5d4c101bdac3ea44$var$INTRINSICS, intrinsicRealName)) value = $5d4c101bdac3ea44$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $aSCZz('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($4C48f && i + 1 >= parts.length) {
                var desc = $4C48f(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $3XZ7K(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $5d4c101bdac3ea44$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("54r9h", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("1bvjx", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("11xNG", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("jpjmZ", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("8o5Da", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("dhvGr", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("fAtY2", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("2F43o", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("7Ze0b", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("gqwxx", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("8Wt19", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("lCIWp", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("2GB0m", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("3oCL5", function(module, exports) {
'use strict';

var $jXn8G = parcelRequire("jXn8G");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($jXn8G(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("jXn8G", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("4C48f", function(module, exports) {
'use strict';

var $hZV0L = parcelRequire("hZV0L");
var $35bdea8c5316a385$require$$gOPD = $hZV0L;
if ($35bdea8c5316a385$require$$gOPD) try {
    $35bdea8c5316a385$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $35bdea8c5316a385$require$$gOPD = null;
}
module.exports = $35bdea8c5316a385$require$$gOPD;

});
parcelRegister("hZV0L", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("5gGLy", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $3d5f9ec93da3a27a$var$$defineProperty = Object.defineProperty || false;
if ($3d5f9ec93da3a27a$var$$defineProperty) try {
    $3d5f9ec93da3a27a$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $3d5f9ec93da3a27a$var$$defineProperty = false;
}
module.exports = $3d5f9ec93da3a27a$var$$defineProperty;

});

parcelRegister("h9e2j", function(module, exports) {
'use strict';
var $c7be2a421c30e8b4$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $cOLP3 = parcelRequire("cOLP3");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $c7be2a421c30e8b4$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $c7be2a421c30e8b4$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $cOLP3();
};

});
parcelRegister("cOLP3", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("ca87s", function(module, exports) {
'use strict';

var $jTjDE = parcelRequire("jTjDE");

var $iyQEc = parcelRequire("iyQEc");

var $7BQj2 = parcelRequire("7BQj2");
/** @type {import('.')} */ module.exports = $jTjDE ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $jTjDE(O);
} : $iyQEc ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $iyQEc(O);
} : $7BQj2 ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $7BQj2(O);
} : null;

});
parcelRegister("jTjDE", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("iyQEc", function(module, exports) {
'use strict';

var $54r9h = parcelRequire("54r9h");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $54r9h.getPrototypeOf || null;

});

parcelRegister("7BQj2", function(module, exports) {
'use strict';

var $9F17b = parcelRequire("9F17b");

var $4C48f = parcelRequire("4C48f");
var $58a490045f435fd8$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $58a490045f435fd8$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $58a490045f435fd8$var$desc = !!$58a490045f435fd8$var$hasProtoAccessor && $4C48f && $4C48f(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $58a490045f435fd8$var$$Object = Object;
var $58a490045f435fd8$var$$getPrototypeOf = $58a490045f435fd8$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $58a490045f435fd8$var$desc && typeof $58a490045f435fd8$var$desc.get === 'function' ? $9F17b([
    $58a490045f435fd8$var$desc.get
]) : typeof $58a490045f435fd8$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $58a490045f435fd8$var$$getPrototypeOf(value == null ? value : $58a490045f435fd8$var$$Object(value));
} : false;

});
parcelRegister("9F17b", function(module, exports) {
'use strict';

var $kttiA = parcelRequire("kttiA");

var $aSCZz = parcelRequire("aSCZz");

var $8M2hX = parcelRequire("8M2hX");

var $k0DYl = parcelRequire("k0DYl");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $aSCZz('a function is required');
    return $k0DYl($kttiA, $8M2hX, args);
};

});
parcelRegister("kttiA", function(module, exports) {
'use strict';

var $kFr7N = parcelRequire("kFr7N");
module.exports = Function.prototype.bind || $kFr7N;

});
parcelRegister("kFr7N", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $f0bcad671ace8592$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $f0bcad671ace8592$var$toStr = Object.prototype.toString;
var $f0bcad671ace8592$var$max = Math.max;
var $f0bcad671ace8592$var$funcType = '[object Function]';
var $f0bcad671ace8592$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $f0bcad671ace8592$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $f0bcad671ace8592$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $f0bcad671ace8592$var$toStr.apply(target) !== $f0bcad671ace8592$var$funcType) throw new TypeError($f0bcad671ace8592$var$ERROR_MESSAGE + target);
    var args = $f0bcad671ace8592$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $f0bcad671ace8592$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $f0bcad671ace8592$var$concatty(args, arguments));
    };
    var boundLength = $f0bcad671ace8592$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $f0bcad671ace8592$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("8M2hX", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("k0DYl", function(module, exports) {
'use strict';

var $kttiA = parcelRequire("kttiA");

var $3rCWF = parcelRequire("3rCWF");

var $8M2hX = parcelRequire("8M2hX");

var $k48dx = parcelRequire("k48dx");
/** @type {import('./actualApply')} */ module.exports = $k48dx || $kttiA.call($8M2hX, $3rCWF);

});
parcelRegister("3rCWF", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("k48dx", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("3XZ7K", function(module, exports) {
'use strict';
var $2e364bbc37e7d501$var$call = Function.prototype.call;
var $2e364bbc37e7d501$var$$hasOwn = Object.prototype.hasOwnProperty;

var $kttiA = parcelRequire("kttiA");
/** @type {import('.')} */ module.exports = $kttiA.call($2e364bbc37e7d501$var$call, $2e364bbc37e7d501$var$$hasOwn);

});


parcelRegister("4EpNf", function(module, exports) {
'use strict';

var $80Cl4 = parcelRequire("80Cl4");

var $9F17b = parcelRequire("9F17b");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $362ee7e43aa567ef$var$$indexOf = $9F17b([
    $80Cl4('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $80Cl4(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $362ee7e43aa567ef$var$$indexOf(name, '.prototype.') > -1) return $9F17b(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});


parcelRegister("9rr7R", function(module, exports) {
'use strict';

var $80Cl4 = parcelRequire("80Cl4");

var $4EpNf = parcelRequire("4EpNf");

var $3xDnv = parcelRequire("3xDnv");

var $hersr = parcelRequire("hersr");

var $aSCZz = parcelRequire("aSCZz");
var $6dfbad4e0c9d9570$var$$WeakMap = $80Cl4('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $6dfbad4e0c9d9570$var$$weakMapGet = $4EpNf('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $6dfbad4e0c9d9570$var$$weakMapSet = $4EpNf('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $6dfbad4e0c9d9570$var$$weakMapHas = $4EpNf('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $6dfbad4e0c9d9570$var$$weakMapDelete = $4EpNf('WeakMap.prototype.delete', true);
/** @type {import('.')} */ module.exports = $6dfbad4e0c9d9570$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $aSCZz('Side channel does not contain ' + $3xDnv(key));
        },
        'delete': function(key) {
            if ($6dfbad4e0c9d9570$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $6dfbad4e0c9d9570$var$$weakMapDelete($wm, key);
            } else if ($hersr) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($6dfbad4e0c9d9570$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $6dfbad4e0c9d9570$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($6dfbad4e0c9d9570$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $6dfbad4e0c9d9570$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($6dfbad4e0c9d9570$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $6dfbad4e0c9d9570$var$$WeakMap();
                $6dfbad4e0c9d9570$var$$weakMapSet($wm, key, value);
            } else if ($hersr) {
                if (!$m) $m = $hersr();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $hersr;

});


parcelRegister("iOqfi", function(module, exports) {
'use strict';

var $aaHyO = parcelRequire("aaHyO");
var $db21415d2ea4cb2a$var$has = Object.prototype.hasOwnProperty;
var $db21415d2ea4cb2a$var$isArray = Array.isArray;
var $db21415d2ea4cb2a$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    return array;
}();
var $db21415d2ea4cb2a$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($db21415d2ea4cb2a$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $db21415d2ea4cb2a$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? {
        __proto__: null
    } : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $db21415d2ea4cb2a$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object' && typeof source !== 'function') {
        if ($db21415d2ea4cb2a$var$isArray(target)) target.push(source);
        else if (target && typeof target === 'object') {
            if (options && (options.plainObjects || options.allowPrototypes) || !$db21415d2ea4cb2a$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($db21415d2ea4cb2a$var$isArray(target) && !$db21415d2ea4cb2a$var$isArray(source)) mergeTarget = $db21415d2ea4cb2a$var$arrayToObject(target, options);
    if ($db21415d2ea4cb2a$var$isArray(target) && $db21415d2ea4cb2a$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($db21415d2ea4cb2a$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($db21415d2ea4cb2a$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $db21415d2ea4cb2a$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $db21415d2ea4cb2a$var$decode = function(str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $db21415d2ea4cb2a$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $db21415d2ea4cb2a$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var j = 0; j < string.length; j += $db21415d2ea4cb2a$var$limit){
        var segment = string.length >= $db21415d2ea4cb2a$var$limit ? string.slice(j, j + $db21415d2ea4cb2a$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $aaHyO.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $db21415d2ea4cb2a$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $db21415d2ea4cb2a$var$hexTable[0xC0 | c >> 6] + $db21415d2ea4cb2a$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $db21415d2ea4cb2a$var$hexTable[0xE0 | c >> 12] + $db21415d2ea4cb2a$var$hexTable[0x80 | c >> 6 & 0x3F] + $db21415d2ea4cb2a$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $db21415d2ea4cb2a$var$hexTable[0xF0 | c >> 18] + $db21415d2ea4cb2a$var$hexTable[0x80 | c >> 12 & 0x3F] + $db21415d2ea4cb2a$var$hexTable[0x80 | c >> 6 & 0x3F] + $db21415d2ea4cb2a$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join('');
    }
    return out;
};
var $db21415d2ea4cb2a$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $db21415d2ea4cb2a$var$compactQueue(queue);
    return value;
};
var $db21415d2ea4cb2a$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $db21415d2ea4cb2a$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $db21415d2ea4cb2a$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $db21415d2ea4cb2a$var$maybeMap = function maybeMap(val, fn) {
    if ($db21415d2ea4cb2a$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $db21415d2ea4cb2a$var$arrayToObject,
    assign: $db21415d2ea4cb2a$var$assign,
    combine: $db21415d2ea4cb2a$var$combine,
    compact: $db21415d2ea4cb2a$var$compact,
    decode: $db21415d2ea4cb2a$var$decode,
    encode: $db21415d2ea4cb2a$var$encode,
    isBuffer: $db21415d2ea4cb2a$var$isBuffer,
    isRegExp: $db21415d2ea4cb2a$var$isRegExp,
    maybeMap: $db21415d2ea4cb2a$var$maybeMap,
    merge: $db21415d2ea4cb2a$var$merge
};

});
parcelRegister("aaHyO", function(module, exports) {
'use strict';
var $767ca0c367fea9c7$var$replace = String.prototype.replace;
var $767ca0c367fea9c7$var$percentTwenties = /%20/g;
var $767ca0c367fea9c7$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
module.exports = {
    'default': $767ca0c367fea9c7$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $767ca0c367fea9c7$var$replace.call(value, $767ca0c367fea9c7$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $767ca0c367fea9c7$var$Format.RFC1738,
    RFC3986: $767ca0c367fea9c7$var$Format.RFC3986
};

});



parcelRegister("khw7U", function(module, exports) {
'use strict';

var $iOqfi = parcelRequire("iOqfi");
var $ec3e50d68b4fc799$var$has = Object.prototype.hasOwnProperty;
var $ec3e50d68b4fc799$var$isArray = Array.isArray;
var $ec3e50d68b4fc799$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $iOqfi.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};
var $ec3e50d68b4fc799$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $ec3e50d68b4fc799$var$parseArrayValue = function(val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) return val.split(',');
    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $ec3e50d68b4fc799$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $ec3e50d68b4fc799$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $ec3e50d68b4fc799$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded ? limit + 1 : limit);
    if (options.throwOnLimitExceeded && parts.length > limit) throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $ec3e50d68b4fc799$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $ec3e50d68b4fc799$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, $ec3e50d68b4fc799$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $ec3e50d68b4fc799$var$defaults.decoder, charset, 'key');
            val = $iOqfi.maybeMap($ec3e50d68b4fc799$var$parseArrayValue(part.slice(pos + 1), options, $ec3e50d68b4fc799$var$isArray(obj[key]) ? obj[key].length : 0), function(encodedVal) {
                return options.decoder(encodedVal, $ec3e50d68b4fc799$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $ec3e50d68b4fc799$var$interpretNumericEntities(String(val));
        if (part.indexOf('[]=') > -1) val = $ec3e50d68b4fc799$var$isArray(val) ? [
            val
        ] : val;
        var existing = $ec3e50d68b4fc799$var$has.call(obj, key);
        if (existing && options.duplicates === 'combine') obj[key] = $iOqfi.combine(obj[key], val);
        else if (!existing || options.duplicates === 'last') obj[key] = val;
    }
    return obj;
};
var $ec3e50d68b4fc799$var$parseObject = function(chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }
    var leaf = valuesParsed ? val : $ec3e50d68b4fc799$var$parseArrayValue(val, options, currentArrayLength);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : $iOqfi.combine([], leaf);
        else {
            obj = options.plainObjects ? {
                __proto__: null
            } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $ec3e50d68b4fc799$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $ec3e50d68b4fc799$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $ec3e50d68b4fc799$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, check strictDepth option for throw, else just add whatever is left
    if (segment) {
        if (options.strictDepth === true) throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        keys.push('[' + key.slice(segment.index) + ']');
    }
    return $ec3e50d68b4fc799$var$parseObject(keys, val, options, valuesParsed);
};
var $ec3e50d68b4fc799$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $ec3e50d68b4fc799$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    var charset = typeof opts.charset === 'undefined' ? $ec3e50d68b4fc799$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === 'undefined' ? $ec3e50d68b4fc799$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') throw new TypeError('The duplicates option must be either combine, first, or last');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : $ec3e50d68b4fc799$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $ec3e50d68b4fc799$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $ec3e50d68b4fc799$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $ec3e50d68b4fc799$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $ec3e50d68b4fc799$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $ec3e50d68b4fc799$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $ec3e50d68b4fc799$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : $ec3e50d68b4fc799$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $ec3e50d68b4fc799$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $iOqfi.isRegExp(opts.delimiter) ? opts.delimiter : $ec3e50d68b4fc799$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $ec3e50d68b4fc799$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $ec3e50d68b4fc799$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $ec3e50d68b4fc799$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $ec3e50d68b4fc799$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : $ec3e50d68b4fc799$var$defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $ec3e50d68b4fc799$var$defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};
module.exports = function(str, opts) {
    var options = $ec3e50d68b4fc799$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? {
        __proto__: null
    } : {};
    var tempObj = typeof str === 'string' ? $ec3e50d68b4fc799$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? {
        __proto__: null
    } : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $ec3e50d68b4fc799$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $iOqfi.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $iOqfi.compact(obj);
};

});







parcelRegister("fYxRW", function(module, exports) {

$parcel$export(module.exports, "applications", function () { return $ece8e831ff66d30a$export$e7ad650a602a37dc; });
$parcel$export(module.exports, "applicationSelector", function () { return $ece8e831ff66d30a$export$5b2ad1bf581a1d7b; });
$parcel$export(module.exports, "lookupApplication", function () { return $ece8e831ff66d30a$export$105c92f8798550c7; });
$parcel$export(module.exports, "cobrandingURLParams", function () { return $ece8e831ff66d30a$export$5a5f77d52a5485dc; });
$parcel$export(module.exports, "getMicrobrandingFromUrl", function () { return $ece8e831ff66d30a$export$dace4fb1afc7ad6b; });
$parcel$export(module.exports, "isTrelloDesktop", function () { return $ece8e831ff66d30a$export$5824ecd2b22a2ece; });
$parcel$export(module.exports, "replaceQueryParam", function () { return $ece8e831ff66d30a$export$70c3f4404feb54c5; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $dBq8m = parcelRequire("dBq8m");
parcelRequire("5jYTP");
var $4b5th = parcelRequire("4b5th");
const $ece8e831ff66d30a$export$e7ad650a602a37dc = {
    admin: {
        name: 'Adminhub',
        useInLoginPrompt: false
    },
    access: {
        name: 'Adminhub',
        useInLoginPrompt: false
    },
    ace: {
        name: 'Atlassian Community Events',
        useInLoginPrompt: false
    },
    atlas: {
        name: 'Atlas',
        useInLoginPrompt: true
    },
    bitbucket: {
        name: 'Bitbucket',
        useInLoginPrompt: true
    },
    community: {
        name: 'Community',
        useInLoginPrompt: true
    },
    cac: {
        name: 'Documentation',
        useInLoginPrompt: true
    },
    dac: {
        name: 'Developer Portal',
        useInLoginPrompt: true
    },
    experts: {
        name: 'Partner Program',
        useInLoginPrompt: true
    },
    'itap-uat-backend': {
        name: 'itap-uat-backend',
        useInLoginPrompt: false
    },
    jac: {
        name: 'Atlassian Bug Reporting & Feature Requests'
    },
    mpac: {
        name: 'Marketplace',
        useInLoginPrompt: true
    },
    profile: {
        name: 'Atlassian'
    },
    prt: {
        name: 'Primary Refresh Token Test'
    },
    'manage-profile': {
        name: 'Atlassian account',
        useInLoginPrompt: false
    },
    sac: {
        name: 'Support',
        useInLoginPrompt: true
    },
    teamcentral: {
        name: 'Team Central',
        useInLoginPrompt: false
    },
    trello: {
        name: 'Trello',
        useInLoginPrompt: true
    },
    mac: {
        name: 'My Atlassian',
        useInLoginPrompt: true
    },
    jira: {
        name: 'Jira',
        useInLoginPrompt: true
    },
    loom: {
        name: 'Loom',
        useInLoginPrompt: true
    },
    'jira-align': {
        name: 'Jira Align',
        useInLoginPrompt: true
    },
    confluence: {
        name: 'Confluence',
        useInLoginPrompt: true
    },
    ondemand: {
        name: 'Atlassian Cloud',
        useInLoginPrompt: false
    },
    opsgenie: {
        name: 'Opsgenie',
        useInLoginPrompt: true
    },
    rovo: {
        name: 'Rovo',
        useInLoginPrompt: false
    },
    start: {
        name: 'Start',
        useInLoginPrompt: false
    },
    megamanzero: {
        name: 'MegamanZero',
        useInLoginPrompt: false
    },
    pollinator: {
        // for functional testing
        name: 'Pollinator',
        useInLoginPrompt: false
    },
    wac: {
        name: 'Atlassian',
        useInLoginPrompt: false
    },
    compass: {
        name: 'Compass',
        useInLoginPrompt: true
    },
    sourcetree: {
        name: 'Sourcetree',
        useInLoginPrompt: false
    },
    statuspage: {
        name: 'Statuspage'
    },
    uac: {
        name: 'UAC',
        useInLoginPrompt: false
    },
    support: {
        name: 'Support',
        useInLoginPrompt: true
    }
};
const $ece8e831ff66d30a$export$5b2ad1bf581a1d7b = (0, $4b5th.createSelector)((state)=>state.cobranding, (cobranding)=>$ece8e831ff66d30a$export$105c92f8798550c7(cobranding));
function $ece8e831ff66d30a$export$105c92f8798550c7(cobranding) {
    const applicationFromContinue = $ece8e831ff66d30a$var$applicationFromContinueUrl();
    const { application: applicationFromQueryParameter, experience: experienceFromQueryParameter } = $ece8e831ff66d30a$var$applicationFromApplicationQueryParameter();
    const application = cobranding.derivedApplication || applicationFromContinue || applicationFromQueryParameter;
    const experience = cobranding.experience || experienceFromQueryParameter;
    if (application) {
        const appData = $ece8e831ff66d30a$export$e7ad650a602a37dc[application];
        if (appData) return (0, $1Fos3._)({
            application: application,
            experience: experience
        }, appData);
    }
    return null;
}
const $ece8e831ff66d30a$export$5a5f77d52a5485dc = (location, productHint)=>{
    const params = $dBq8m.parse(location.search);
    const allParams = productHint !== undefined && productHint !== null ? (0, $b2I6k._)((0, $1Fos3._)({}, params), {
        productHint: productHint
    }) : (0, $1Fos3._)({}, params);
    const filteredCobrandingParams = Object.keys(allParams).filter((key)=>[
            'continue',
            'application',
            'display',
            'productHint'
        ].includes(key)).reduce((o, key)=>{
        o[key] = allParams[key];
        return o;
    }, {});
    const cobrandingURLParams = filteredCobrandingParams && Object.keys(filteredCobrandingParams).length ? (0, $1Fos3._)({}, filteredCobrandingParams) : '';
    return cobrandingURLParams;
};
function $ece8e831ff66d30a$export$dace4fb1afc7ad6b(location) {
    const params = $dBq8m.parse(location.search);
    return Object.keys(params).filter((key)=>[
            'application',
            'continue',
            'tenant'
        ].includes(key)).reduce((o, key)=>{
        o[key] = params[key];
        return o;
    }, {});
}
const $ece8e831ff66d30a$export$ae5bd94b7585e9d5 = [
    '/admin',
    '/login',
    '/logout',
    '/impersonate',
    '/home',
    '/people',
    '/trusted-admin',
    '/forge-apps'
];
/**
 * Determine the cobranding application from the `?continue=...` URL param as a last resort.
 *
 * **This code should _only_ be relied upon for situations where passing an `?application=...`
 * param or product hint is not possible**, such as within Slack's direct initiate flow. In OIDC
 * flows applications should pass a product hint, and in all other flows applications should pass
 * an `?application=...` param to id.a.c.
 */ function $ece8e831ff66d30a$var$applicationFromContinueUrl() {
    const params = $dBq8m.parse(window.location.search);
    const continueParam = params.continue;
    if (!continueParam) return null;
    try {
        const continueUrl = new URL(continueParam, window.location.origin);
        const { hostname: hostname, pathname: pathname, searchParams: searchParams } = continueUrl;
        if ([
            'bitbucket.org',
            'integration.bb-inf.net'
        ].includes(hostname)) return 'bitbucket';
        else if ([
            '.opsgenie.com',
            '.opsgeni.us'
        ].some((domain)=>hostname.endsWith(domain))) return 'opsgenie';
        else if ([
            'manage.statuspage.io',
            'manage.statuspagestaging.com'
        ].includes(hostname)) return 'statuspage';
        else if ([
            'trello.com',
            'trellis.coffee'
        ].includes(hostname)) return 'trello';
        else if ([
            'atlassian.com',
            'www.atlassian.com',
            'wac.stg.internal.atlassian.com'
        ].includes(hostname)) return 'wac';
        else if ([
            'team.atlassian.com',
            'team.stg.atlassian.com'
        ].includes(hostname)) return 'atlas';
        else if ([
            '.atlassian.net',
            'atlassian-fex.net',
            '.jira-dev.com'
        ].some((domain)=>hostname.endsWith(domain))) {
            const unwrappedContinueUrl = pathname === '/login' && searchParams.get('dest-url') ? new URL(searchParams.get('dest-url'), continueUrl) : continueUrl;
            const { pathname: unwrappedPathname } = unwrappedContinueUrl;
            if (unwrappedPathname === '/wiki' || unwrappedPathname.startsWith('/wiki/')) return 'confluence';
            else if (unwrappedPathname === '/compass' || unwrappedPathname.startsWith('/compass/')) return 'compass';
            else if (// Root could be Jira or Conflience
            unwrappedPathname !== '/' && !$ece8e831ff66d30a$export$ae5bd94b7585e9d5.some((prefix)=>unwrappedPathname === prefix || unwrappedPathname.startsWith(`${prefix}/`))) return 'jira';
        }
    } catch (error) {
    // Malformed URL, ignore
    }
    return null;
}
function $ece8e831ff66d30a$var$applicationFromApplicationQueryParameter() {
    try {
        var _get;
        const [application, experience] = ((_get = new URLSearchParams(window.location.search).get('application')) === null || _get === void 0 ? void 0 : _get.split('--')) || [];
        if (application && $ece8e831ff66d30a$var$isValidApplication(application)) return {
            application: application,
            experience: experience
        };
    } catch (error) {
    // Malformed query parameter, ignore
    }
    return {
        application: null,
        experience: null
    };
}
function $ece8e831ff66d30a$export$5824ecd2b22a2ece() {
    const userAgent = window.navigator.userAgent;
    return userAgent.includes('TrelloDesktop');
}
const $ece8e831ff66d30a$export$e248db7c9a3cd59 = (app)=>app && $ece8e831ff66d30a$export$e7ad650a602a37dc[app] ? $ece8e831ff66d30a$export$e7ad650a602a37dc[app].name : 'Atlassian';
const $ece8e831ff66d30a$var$isValidApplication = (application)=>Object.keys($ece8e831ff66d30a$export$e7ad650a602a37dc).includes(application);
function $ece8e831ff66d30a$export$70c3f4404feb54c5(paramName, paramValue) {
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set(paramName, paramValue);
    const queryString = queryParams.toString();
    return queryString ? `?${queryString}` : '';
}

});
parcelRegister("5jYTP", function(module, exports) {

$parcel$export(module.exports, "configureStore", function () { return $3dfdf7787ece802f$export$7d8a5b498da695ac; });
$parcel$export(module.exports, "createSelector", function () { return (parcelRequire("4b5th")).createSelector; });

var $7RbkC = parcelRequire("7RbkC");

var $5tPtc = parcelRequire("5tPtc");

var $4b5th = parcelRequire("4b5th");

var $2z5V7 = parcelRequire("2z5V7");

var $e08gr = parcelRequire("e08gr");
var $3dfdf7787ece802f$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $3dfdf7787ece802f$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $3dfdf7787ece802f$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $3dfdf7787ece802f$var$__defProp = Object.defineProperty;
var $3dfdf7787ece802f$var$__defProps = Object.defineProperties;
var $3dfdf7787ece802f$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $3dfdf7787ece802f$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $3dfdf7787ece802f$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $3dfdf7787ece802f$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $3dfdf7787ece802f$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $3dfdf7787ece802f$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $3dfdf7787ece802f$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($3dfdf7787ece802f$var$__hasOwnProp.call(b, prop)) $3dfdf7787ece802f$var$__defNormalProp(a, prop, b[prop]);
    if ($3dfdf7787ece802f$var$__getOwnPropSymbols) for(var _i = 0, _c = $3dfdf7787ece802f$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($3dfdf7787ece802f$var$__propIsEnum.call(b, prop)) $3dfdf7787ece802f$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $3dfdf7787ece802f$var$__spreadProps = function(a, b) {
    return $3dfdf7787ece802f$var$__defProps(a, $3dfdf7787ece802f$var$__getOwnPropDescs(b));
};
var $3dfdf7787ece802f$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $3dfdf7787ece802f$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $4b5th.createSelector).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $3dfdf7787ece802f$var$__spreadArray([
            (0, $7RbkC.isDraft)(value) ? (0, $7RbkC.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $3dfdf7787ece802f$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $5tPtc.compose;
    return (0, $5tPtc.compose).apply(null, arguments);
};
var $3dfdf7787ece802f$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $3dfdf7787ece802f$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/tsHelpers.ts
var $3dfdf7787ece802f$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $3dfdf7787ece802f$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $3dfdf7787ece802f$var$__spreadValues($3dfdf7787ece802f$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $3dfdf7787ece802f$export$b956e38827fca970(action) {
    return $3dfdf7787ece802f$export$53b83ca8eaab0383(action) && "type" in action;
}
function $3dfdf7787ece802f$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && $3dfdf7787ece802f$var$hasMatchFunction(action);
}
function $3dfdf7787ece802f$export$ebd532f9034651f3(action) {
    return $3dfdf7787ece802f$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($3dfdf7787ece802f$var$isValidKey);
}
function $3dfdf7787ece802f$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $3dfdf7787ece802f$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/actionCreatorInvariantMiddleware.ts
function $3dfdf7787ece802f$var$getMessage(type) {
    var splitType = type ? ("" + type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return "Detected an action creator with type \"" + (type || "unknown") + "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(" + actionName + "())` instead of `dispatch(" + actionName + ")`. This is necessary even if the action has no payload.";
}
function $3dfdf7787ece802f$export$6a1fcb4ceef578f(options) {
    if (options === void 0) options = {};
    var _c, isActionCreator2;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $3dfdf7787ece802f$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $3dfdf7787ece802f$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $3dfdf7787ece802f$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $3dfdf7787ece802f$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $3dfdf7787ece802f$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $3dfdf7787ece802f$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $3dfdf7787ece802f$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $3dfdf7787ece802f$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $3dfdf7787ece802f$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $3dfdf7787ece802f$var$freezeDraftable(val) {
    return (0, $7RbkC.isDraftable)(val) ? (0, $7RbkC.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $3dfdf7787ece802f$var$isProduction = true;
var $3dfdf7787ece802f$var$prefix = "Invariant failed";
function $3dfdf7787ece802f$var$invariant(condition, message) {
    if (condition) return;
    if ($3dfdf7787ece802f$var$isProduction) throw new Error($3dfdf7787ece802f$var$prefix);
    throw new Error($3dfdf7787ece802f$var$prefix + ": " + (message || ""));
}
function $3dfdf7787ece802f$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $3dfdf7787ece802f$var$getSerialize(serializer, decycler), indent);
}
function $3dfdf7787ece802f$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $3dfdf7787ece802f$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $3dfdf7787ece802f$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $3dfdf7787ece802f$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $3dfdf7787ece802f$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $3dfdf7787ece802f$var$trackProperties(isImmutable, ignorePaths, obj, path, checkedObjects) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    if (checkedObjects === void 0) checkedObjects = new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $3dfdf7787ece802f$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $3dfdf7787ece802f$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $3dfdf7787ece802f$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $3dfdf7787ece802f$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $3dfdf7787ece802f$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $3dfdf7787ece802f$export$53b83ca8eaab0383(val);
}
function $3dfdf7787ece802f$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $3dfdf7787ece802f$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $3dfdf7787ece802f$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $3dfdf7787ece802f$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $3dfdf7787ece802f$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$3dfdf7787ece802f$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $3dfdf7787ece802f$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $3dfdf7787ece802f$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $3dfdf7787ece802f$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $3dfdf7787ece802f$export$36c1185aeee5b0a6(options);
    };
}
function $3dfdf7787ece802f$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e, _f = options.actionCreatorCheck, actionCreatorCheck = _f === void 0 ? true : _f;
    var middlewareArray = new $3dfdf7787ece802f$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($3dfdf7787ece802f$var$isBoolean(thunk)) middlewareArray.push((0, $2z5V7.default));
        else middlewareArray.push((0, $2z5V7.default).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions, actionCreatorOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $3dfdf7787ece802f$var$IS_PRODUCTION = true;
function $3dfdf7787ece802f$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $3dfdf7787ece802f$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($3dfdf7787ece802f$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $5tPtc.combineReducers)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$3dfdf7787ece802f$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$3dfdf7787ece802f$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $5tPtc.applyMiddleware).apply(void 0, finalMiddleware);
    var finalCompose = (0, $5tPtc.compose);
    if (devTools) finalCompose = $3dfdf7787ece802f$var$composeWithDevTools($3dfdf7787ece802f$var$__spreadValues({
        trace: !$3dfdf7787ece802f$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $3dfdf7787ece802f$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $3dfdf7787ece802f$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $5tPtc.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $3dfdf7787ece802f$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error("`builder.addCase` cannot be called with an empty action type");
            if (type in actionsMap) throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $3dfdf7787ece802f$var$isStateFunction(x) {
    return typeof x === "function";
}
var $3dfdf7787ece802f$var$hasWarnedAboutObjectNotation = false;
function $3dfdf7787ece802f$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $3dfdf7787ece802f$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($3dfdf7787ece802f$var$isStateFunction(initialState)) getInitialState = function() {
        return $3dfdf7787ece802f$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $3dfdf7787ece802f$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $3dfdf7787ece802f$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $7RbkC.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $7RbkC.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $7RbkC.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $3dfdf7787ece802f$var$hasWarnedAboutObjectNotation2 = false;
function $3dfdf7787ece802f$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $3dfdf7787ece802f$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    typeof $e08gr;
    var initialState = typeof options.initialState == "function" ? options.initialState : $3dfdf7787ece802f$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $3dfdf7787ece802f$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $3dfdf7787ece802f$export$309c7a02b0b0bc62(type, prepareCallback) : $3dfdf7787ece802f$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $3dfdf7787ece802f$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $3dfdf7787ece802f$var$__spreadValues($3dfdf7787ece802f$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $3dfdf7787ece802f$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $3dfdf7787ece802f$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $3dfdf7787ece802f$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($3dfdf7787ece802f$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $3dfdf7787ece802f$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $3dfdf7787ece802f$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $3dfdf7787ece802f$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $3dfdf7787ece802f$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $3dfdf7787ece802f$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $3dfdf7787ece802f$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $3dfdf7787ece802f$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $3dfdf7787ece802f$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $3dfdf7787ece802f$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $3dfdf7787ece802f$var$createSingleArgumentStateOperator(mutator) {
    var operator = $3dfdf7787ece802f$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $3dfdf7787ece802f$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $3dfdf7787ece802f$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $7RbkC.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $7RbkC.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $3dfdf7787ece802f$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $3dfdf7787ece802f$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $3dfdf7787ece802f$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $3dfdf7787ece802f$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $3dfdf7787ece802f$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $3dfdf7787ece802f$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $3dfdf7787ece802f$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $3dfdf7787ece802f$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $3dfdf7787ece802f$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $3dfdf7787ece802f$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $3dfdf7787ece802f$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $3dfdf7787ece802f$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $3dfdf7787ece802f$var$__spreadValues($3dfdf7787ece802f$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $3dfdf7787ece802f$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $3dfdf7787ece802f$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $3dfdf7787ece802f$var$createStateOperator(addOneMutably),
        addMany: $3dfdf7787ece802f$var$createStateOperator(addManyMutably),
        setOne: $3dfdf7787ece802f$var$createStateOperator(setOneMutably),
        setMany: $3dfdf7787ece802f$var$createStateOperator(setManyMutably),
        setAll: $3dfdf7787ece802f$var$createStateOperator(setAllMutably),
        updateOne: $3dfdf7787ece802f$var$createStateOperator(updateOneMutably),
        updateMany: $3dfdf7787ece802f$var$createStateOperator(updateManyMutably),
        upsertOne: $3dfdf7787ece802f$var$createStateOperator(upsertOneMutably),
        upsertMany: $3dfdf7787ece802f$var$createStateOperator(upsertManyMutably),
        removeOne: $3dfdf7787ece802f$var$createStateOperator(removeOneMutably),
        removeMany: $3dfdf7787ece802f$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $3dfdf7787ece802f$var$createSortedStateAdapter(selectId, sort) {
    var _c = $3dfdf7787ece802f$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $3dfdf7787ece802f$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($3dfdf7787ece802f$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $3dfdf7787ece802f$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $3dfdf7787ece802f$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $3dfdf7787ece802f$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $3dfdf7787ece802f$var$createStateOperator(addOneMutably),
        updateOne: $3dfdf7787ece802f$var$createStateOperator(updateOneMutably),
        upsertOne: $3dfdf7787ece802f$var$createStateOperator(upsertOneMutably),
        setOne: $3dfdf7787ece802f$var$createStateOperator(setOneMutably),
        setMany: $3dfdf7787ece802f$var$createStateOperator(setManyMutably),
        setAll: $3dfdf7787ece802f$var$createStateOperator(setAllMutably),
        addMany: $3dfdf7787ece802f$var$createStateOperator(addManyMutably),
        updateMany: $3dfdf7787ece802f$var$createStateOperator(updateManyMutably),
        upsertMany: $3dfdf7787ece802f$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $3dfdf7787ece802f$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $3dfdf7787ece802f$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $3dfdf7787ece802f$var$createInitialStateFactory();
    var selectorsFactory = $3dfdf7787ece802f$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $3dfdf7787ece802f$var$createSortedStateAdapter(selectId, sortComparer) : $3dfdf7787ece802f$var$createUnsortedStateAdapter(selectId);
    return $3dfdf7787ece802f$var$__spreadValues($3dfdf7787ece802f$var$__spreadValues($3dfdf7787ece802f$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $3dfdf7787ece802f$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $3dfdf7787ece802f$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $3dfdf7787ece802f$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $3dfdf7787ece802f$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $3dfdf7787ece802f$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $3dfdf7787ece802f$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $3dfdf7787ece802f$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $3dfdf7787ece802f$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $3dfdf7787ece802f$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $3dfdf7787ece802f$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $3dfdf7787ece802f$var$__spreadProps($3dfdf7787ece802f$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $3dfdf7787ece802f$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $3dfdf7787ece802f$var$__spreadProps($3dfdf7787ece802f$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $3dfdf7787ece802f$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $3dfdf7787ece802f$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $3dfdf7787ece802f$var$__spreadProps($3dfdf7787ece802f$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $3dfdf7787ece802f$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $3dfdf7787ece802f$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $3dfdf7787ece802f$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$3dfdf7787ece802f$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $3dfdf7787ece802f$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $3dfdf7787ece802f$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $3dfdf7787ece802f$var$RejectWithValue) throw result;
                                                if (result instanceof $3dfdf7787ece802f$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $3dfdf7787ece802f$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($3dfdf7787ece802f$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $3dfdf7787ece802f$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $3dfdf7787ece802f$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/matchers.ts
var $3dfdf7787ece802f$var$matches = function(matcher, action) {
    if ($3dfdf7787ece802f$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $3dfdf7787ece802f$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $3dfdf7787ece802f$var$matches(matcher, action);
        });
    };
}
function $3dfdf7787ece802f$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $3dfdf7787ece802f$var$matches(matcher, action);
        });
    };
}
function $3dfdf7787ece802f$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $3dfdf7787ece802f$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $3dfdf7787ece802f$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $3dfdf7787ece802f$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$3dfdf7787ece802f$var$isAsyncThunkArray(asyncThunks)) return $3dfdf7787ece802f$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $3dfdf7787ece802f$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $3dfdf7787ece802f$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $3dfdf7787ece802f$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$3dfdf7787ece802f$var$isAsyncThunkArray(asyncThunks)) return $3dfdf7787ece802f$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $3dfdf7787ece802f$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $3dfdf7787ece802f$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $3dfdf7787ece802f$export$9dd1fb32974da385($3dfdf7787ece802f$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$3dfdf7787ece802f$var$isAsyncThunkArray(asyncThunks)) return $3dfdf7787ece802f$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $3dfdf7787ece802f$export$9dd1fb32974da385($3dfdf7787ece802f$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $3dfdf7787ece802f$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $3dfdf7787ece802f$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$3dfdf7787ece802f$var$isAsyncThunkArray(asyncThunks)) return $3dfdf7787ece802f$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $3dfdf7787ece802f$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $3dfdf7787ece802f$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $3dfdf7787ece802f$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$3dfdf7787ece802f$var$isAsyncThunkArray(asyncThunks)) return $3dfdf7787ece802f$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $3dfdf7787ece802f$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $3dfdf7787ece802f$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $3dfdf7787ece802f$var$noop = function() {};
var $3dfdf7787ece802f$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $3dfdf7787ece802f$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $3dfdf7787ece802f$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $3dfdf7787ece802f$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $3dfdf7787ece802f$var$task = "task";
var $3dfdf7787ece802f$var$listener = "listener";
var $3dfdf7787ece802f$var$completed = "completed";
var $3dfdf7787ece802f$var$cancelled = "cancelled";
var $3dfdf7787ece802f$var$taskCancelled = "task-" + $3dfdf7787ece802f$var$cancelled;
var $3dfdf7787ece802f$var$taskCompleted = "task-" + $3dfdf7787ece802f$var$completed;
var $3dfdf7787ece802f$var$listenerCancelled = $3dfdf7787ece802f$var$listener + "-" + $3dfdf7787ece802f$var$cancelled;
var $3dfdf7787ece802f$var$listenerCompleted = $3dfdf7787ece802f$var$listener + "-" + $3dfdf7787ece802f$var$completed;
var $3dfdf7787ece802f$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $3dfdf7787ece802f$var$task + " " + $3dfdf7787ece802f$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $3dfdf7787ece802f$var$validateActive = function(signal) {
    if (signal.aborted) throw new $3dfdf7787ece802f$export$cb1bdac908fed7f(signal.reason);
};
function $3dfdf7787ece802f$var$raceWithSignal(signal, promise2) {
    var cleanup = $3dfdf7787ece802f$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $3dfdf7787ece802f$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $3dfdf7787ece802f$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $3dfdf7787ece802f$var$noop;
    });
}
var $3dfdf7787ece802f$var$runTask = function(task2, cleanUp) {
    return $3dfdf7787ece802f$var$__async(void 0, null, function() {
        var value, error_1;
        return $3dfdf7787ece802f$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $3dfdf7787ece802f$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $3dfdf7787ece802f$var$createPause = function(signal) {
    return function(promise2) {
        return $3dfdf7787ece802f$var$catchRejection($3dfdf7787ece802f$var$raceWithSignal(signal, promise2).then(function(output) {
            $3dfdf7787ece802f$var$validateActive(signal);
            return output;
        }));
    };
};
var $3dfdf7787ece802f$var$createDelay = function(signal) {
    var pause = $3dfdf7787ece802f$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $3dfdf7787ece802f$var$assign = Object.assign;
var $3dfdf7787ece802f$var$INTERNAL_NIL_TOKEN = {};
var $3dfdf7787ece802f$var$alm = "listenerMiddleware";
var $3dfdf7787ece802f$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $3dfdf7787ece802f$var$addAbortSignalListener(parentAbortSignal, function() {
            return $3dfdf7787ece802f$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $3dfdf7787ece802f$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $3dfdf7787ece802f$var$runTask(function() {
            return $3dfdf7787ece802f$var$__async(void 0, null, function() {
                var result2;
                return $3dfdf7787ece802f$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $3dfdf7787ece802f$var$validateActive(parentAbortSignal);
                            $3dfdf7787ece802f$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $3dfdf7787ece802f$var$createPause(childAbortController.signal),
                                    delay: $3dfdf7787ece802f$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $3dfdf7787ece802f$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $3dfdf7787ece802f$var$abortControllerWithReason(childAbortController, $3dfdf7787ece802f$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result);
        return {
            result: $3dfdf7787ece802f$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $3dfdf7787ece802f$var$abortControllerWithReason(childAbortController, $3dfdf7787ece802f$var$taskCancelled);
            }
        };
    };
};
var $3dfdf7787ece802f$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $3dfdf7787ece802f$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $3dfdf7787ece802f$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $3dfdf7787ece802f$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $3dfdf7787ece802f$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $3dfdf7787ece802f$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $3dfdf7787ece802f$var$catchRejection(take(predicate, timeout));
    };
};
var $3dfdf7787ece802f$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $3dfdf7787ece802f$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $3dfdf7787ece802f$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $3dfdf7787ece802f$var$createListenerEntry = function(options) {
    var _c = $3dfdf7787ece802f$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $3dfdf7787ece802f$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $3dfdf7787ece802f$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $3dfdf7787ece802f$var$abortControllerWithReason(controller, $3dfdf7787ece802f$var$listenerCancelled);
    });
};
var $3dfdf7787ece802f$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($3dfdf7787ece802f$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $3dfdf7787ece802f$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $3dfdf7787ece802f$export$f03a6b845d3fb58b = $3dfdf7787ece802f$export$309c7a02b0b0bc62($3dfdf7787ece802f$var$alm + "/add");
var $3dfdf7787ece802f$export$b1b8022855fb2b71 = $3dfdf7787ece802f$export$309c7a02b0b0bc62($3dfdf7787ece802f$var$alm + "/removeAll");
var $3dfdf7787ece802f$export$b03e9483f936dccb = $3dfdf7787ece802f$export$309c7a02b0b0bc62($3dfdf7787ece802f$var$alm + "/remove");
var $3dfdf7787ece802f$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $3dfdf7787ece802f$var$__spreadArray([
        $3dfdf7787ece802f$var$alm + "/error"
    ], args));
};
function $3dfdf7787ece802f$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $3dfdf7787ece802f$var$defaultErrorHandler : _c;
    $3dfdf7787ece802f$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $3dfdf7787ece802f$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $3dfdf7787ece802f$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $3dfdf7787ece802f$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $3dfdf7787ece802f$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $3dfdf7787ece802f$var$__async(_this, null, function() {
            var internalTaskController, take, autoJoinPromises, listenerError_1;
            return $3dfdf7787ece802f$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $3dfdf7787ece802f$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $3dfdf7787ece802f$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $3dfdf7787ece802f$var$createDelay(internalTaskController.signal),
                                pause: $3dfdf7787ece802f$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $3dfdf7787ece802f$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $3dfdf7787ece802f$var$abortControllerWithReason(controller, $3dfdf7787ece802f$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $3dfdf7787ece802f$export$cb1bdac908fed7f)) $3dfdf7787ece802f$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            Promise.allSettled(autoJoinPromises)
                        ];
                    case 5:
                        _c.sent();
                        $3dfdf7787ece802f$var$abortControllerWithReason(internalTaskController, $3dfdf7787ece802f$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $3dfdf7787ece802f$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!$3dfdf7787ece802f$export$b956e38827fca970(action)) return next(action);
                if ($3dfdf7787ece802f$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($3dfdf7787ece802f$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($3dfdf7787ece802f$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $3dfdf7787ece802f$var$INTERNAL_NIL_TOKEN) throw new Error($3dfdf7787ece802f$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $3dfdf7787ece802f$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $3dfdf7787ece802f$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $3dfdf7787ece802f$export$8fb31c0f05df007b = "RTK_autoBatch";
var $3dfdf7787ece802f$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$3dfdf7787ece802f$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $3dfdf7787ece802f$var$promise;
var $3dfdf7787ece802f$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($3dfdf7787ece802f$var$promise || ($3dfdf7787ece802f$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $3dfdf7787ece802f$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $3dfdf7787ece802f$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $3dfdf7787ece802f$var$createQueueWithTimer(10);
var $3dfdf7787ece802f$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $3dfdf7787ece802f$var$queueMicrotaskShim : options.type === "raf" ? $3dfdf7787ece802f$var$rAF : options.type === "callback" ? options.queueNotification : $3dfdf7787ece802f$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$3dfdf7787ece802f$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $7RbkC.enableES5)();

});
parcelRegister("7RbkC", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return r; });
$parcel$export(module.exports, "isDraftable", function () { return t; });
$parcel$export(module.exports, "immerable", function () { return L; });
$parcel$export(module.exports, "original", function () { return e; });
$parcel$export(module.exports, "freeze", function () { return d; });
$parcel$export(module.exports, "nothing", function () { return H; });
$parcel$export(module.exports, "current", function () { return R; });
$parcel$export(module.exports, "enableES5", function () { return F; });
$parcel$export(module.exports, "enablePatches", function () { return T; });
$parcel$export(module.exports, "enableMapSet", function () { return C; });
$parcel$export(module.exports, "enableAllPlugins", function () { return J; });
$parcel$export(module.exports, "castDraft", function () { return K; });
$parcel$export(module.exports, "castImmutable", function () { return $; });
$parcel$export(module.exports, "Immer", function () { return un; });
$parcel$export(module.exports, "produce", function () { return fn; });
$parcel$export(module.exports, "produceWithPatches", function () { return cn; });
$parcel$export(module.exports, "setAutoFreeze", function () { return sn; });
$parcel$export(module.exports, "setUseProxies", function () { return vn; });
$parcel$export(module.exports, "applyPatches", function () { return pn; });
$parcel$export(module.exports, "createDraft", function () { return ln; });
$parcel$export(module.exports, "finishDraft", function () { return dn; });
$parcel$export(module.exports, "default", function () { return $5b8645e046a3bf0b$export$2e2bcd8739ae039; });
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(_n) {
                            void 0 !== o[_n] || u(o, _n) || (f[_n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $5b8645e046a3bf0b$export$2e2bcd8739ae039 = fn;

});

parcelRegister("5tPtc", function(module, exports) {

$parcel$export(module.exports, "createStore", function () { return $3fd7960da487a1c7$export$f51a9068ac82ea43; });
$parcel$export(module.exports, "combineReducers", function () { return $3fd7960da487a1c7$export$66e4520cdb265d18; });
$parcel$export(module.exports, "compose", function () { return $3fd7960da487a1c7$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "applyMiddleware", function () { return $3fd7960da487a1c7$export$9ff26e0402cc7b7; });

var $93f5N = parcelRequire("93f5N");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $3fd7960da487a1c7$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $3fd7960da487a1c7$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $3fd7960da487a1c7$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $3fd7960da487a1c7$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $3fd7960da487a1c7$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $3fd7960da487a1c7$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $3fd7960da487a1c7$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $3fd7960da487a1c7$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $3fd7960da487a1c7$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($3fd7960da487a1c7$var$isDate(val)) return 'date';
    if ($3fd7960da487a1c7$var$isError(val)) return 'error';
    var constructorName = $3fd7960da487a1c7$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $3fd7960da487a1c7$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $3fd7960da487a1c7$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $3fd7960da487a1c7$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $3fd7960da487a1c7$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $3fd7960da487a1c7$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($3fd7960da487a1c7$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($3fd7960da487a1c7$var$formatProdErrorMessage(1));
        return enhancer($3fd7960da487a1c7$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($3fd7960da487a1c7$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($3fd7960da487a1c7$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($3fd7960da487a1c7$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($3fd7960da487a1c7$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($3fd7960da487a1c7$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$3fd7960da487a1c7$var$isPlainObject(action)) throw new Error($3fd7960da487a1c7$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($3fd7960da487a1c7$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($3fd7960da487a1c7$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($3fd7960da487a1c7$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $3fd7960da487a1c7$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($3fd7960da487a1c7$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$3fd7960da487a1c7$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $3fd7960da487a1c7$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$3fd7960da487a1c7$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $3fd7960da487a1c7$export$8928921ea2d3b126 = $3fd7960da487a1c7$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $3fd7960da487a1c7$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $3fd7960da487a1c7$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $3fd7960da487a1c7$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$3fd7960da487a1c7$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $3fd7960da487a1c7$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $3fd7960da487a1c7$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $3fd7960da487a1c7$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $3fd7960da487a1c7$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($3fd7960da487a1c7$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $3fd7960da487a1c7$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($3fd7960da487a1c7$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $3fd7960da487a1c7$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $3fd7960da487a1c7$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($3fd7960da487a1c7$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $3fd7960da487a1c7$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $3fd7960da487a1c7$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $3fd7960da487a1c7$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($3fd7960da487a1c7$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $3fd7960da487a1c7$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $3fd7960da487a1c7$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $3fd7960da487a1c7$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($3fd7960da487a1c7$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $3fd7960da487a1c7$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $93f5N.default)((0, $93f5N.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("93f5N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $697019e951a72aa2$export$2e2bcd8739ae039; });

var $bSych = parcelRequire("bSych");
function $697019e951a72aa2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $697019e951a72aa2$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $697019e951a72aa2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $bSych.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $697019e951a72aa2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("bSych", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a5f43aa994d3f07$export$2e2bcd8739ae039; });

var $kSKhj = parcelRequire("kSKhj");
function $8a5f43aa994d3f07$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $kSKhj.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("kSKhj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f33cbfb1a0a6671a$export$2e2bcd8739ae039; });

var $4y9O5 = parcelRequire("4y9O5");

var $2HtuZ = parcelRequire("2HtuZ");
function $f33cbfb1a0a6671a$export$2e2bcd8739ae039(t) {
    var i = (0, $2HtuZ.default)(t, "string");
    return "symbol" == (0, $4y9O5.default)(i) ? i : i + "";
}

});
parcelRegister("2HtuZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f767acc7dcda1c0$export$2e2bcd8739ae039; });

var $4y9O5 = parcelRequire("4y9O5");
function $1f767acc7dcda1c0$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $4y9O5.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $4y9O5.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});





parcelRegister("4b5th", function(module, exports) {

$parcel$export(module.exports, "createSelector", function () { return $30ac6ef58d149628$export$595d22ed68ca2841; });

var $cKB7z = parcelRequire("cKB7z");
function $30ac6ef58d149628$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
        }).join(', ');
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $30ac6ef58d149628$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === 'object') {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== 'function') throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $30ac6ef58d149628$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $30ac6ef58d149628$export$595d22ed68ca2841 = /* #__PURE__ */ $30ac6ef58d149628$export$5943f4447f6ef248((0, $cKB7z.defaultMemoize));
var $30ac6ef58d149628$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $30ac6ef58d149628$export$595d22ed68ca2841;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};

});
parcelRegister("cKB7z", function(module, exports) {

$parcel$export(module.exports, "defaultMemoize", function () { return $9486935e8bfcc735$export$281bff7f05488aa2; });
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $9486935e8bfcc735$var$NOT_FOUND = 'NOT_FOUND';
function $9486935e8bfcc735$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $9486935e8bfcc735$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $9486935e8bfcc735$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $9486935e8bfcc735$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $9486935e8bfcc735$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $9486935e8bfcc735$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $9486935e8bfcc735$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $9486935e8bfcc735$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $9486935e8bfcc735$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $9486935e8bfcc735$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $9486935e8bfcc735$var$createSingletonCache(comparator) : $9486935e8bfcc735$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $9486935e8bfcc735$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}

});


parcelRegister("2z5V7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1de3714e624d14ca$export$2e2bcd8739ae039; });
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $1de3714e624d14ca$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === 'function') // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $1de3714e624d14ca$var$thunk = $1de3714e624d14ca$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$1de3714e624d14ca$var$thunk.withExtraArgument = $1de3714e624d14ca$var$createThunkMiddleware;
var $1de3714e624d14ca$export$2e2bcd8739ae039 = $1de3714e624d14ca$var$thunk;

});



parcelRegister("cDwV0", function(module, exports) {

$parcel$export(module.exports, "getFirstPaint", function () { return $575105f1c52007e0$export$819e7a0b13f5961; });
$parcel$export(module.exports, "getFirstContentfulPaint", function () { return $575105f1c52007e0$export$3086fa1a9fb7f683; });
const $575105f1c52007e0$var$perf = typeof window !== 'undefined' ? window.performance : null;
function $575105f1c52007e0$export$819e7a0b13f5961() {
    try {
        if (!$575105f1c52007e0$var$perf) return null;
        const fp = $575105f1c52007e0$var$perf.getEntriesByType('paint').find(({ name: name })=>name === 'first-paint');
        return fp ? Math.round(fp.startTime) : null;
    } catch (err) {
        return null;
    }
}
function $575105f1c52007e0$export$3086fa1a9fb7f683() {
    try {
        if (!$575105f1c52007e0$var$perf) return null;
        const fcp = $575105f1c52007e0$var$perf.getEntriesByType('paint').find(({ name: name })=>name === 'first-contentful-paint');
        return fcp ? Math.round(fcp.startTime) : null;
    } catch (err) {
        return null;
    }
}

});

parcelRegister("h8k8x", function(module, exports) {
$parcel$export(module.exports, "BrowserMetricsBoundary", function () { return (parcelRequire("cAPqq")).BrowserMetricsBoundary; });
$parcel$export(module.exports, "startBrowserMetrics", function () { return (parcelRequire("jQauR")).startBrowserMetrics; });
$parcel$export(module.exports, "getPageLoadMetric", function () { return (parcelRequire("7eWkL")).getPageLoadMetric; });
parcelRequire("cAPqq");
parcelRequire("jQauR");
parcelRequire("7eWkL");

});
parcelRegister("cAPqq", function(module, exports) {

$parcel$export(module.exports, "BrowserMetricsBoundary", function () { return $1873c8ccf89b0335$export$e338054fa926c14d; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $3TJbe = parcelRequire("3TJbe");
parcelRequire("6d87w");
var $l2v8Y = parcelRequire("l2v8Y");
const $1873c8ccf89b0335$export$e338054fa926c14d = ({ children: children })=>{
    const prevPathname = (0, $91i6m.useRef)();
    const { pathname: pathname } = (0, $l2v8Y.useLocation)();
    /*
   * Here we only want to capture transition page loads (i.e. clientside route changes).
   *
   * Initial page loads (with a full trip to the server) are already recorded separately,
   * by calling startPageLoad before the react app is bootstrapped.
   *
   * And if startPageLoad were called again here, that initial page load will be overridden
   * and incorrectly recorded as a transition.
   */ (0, $91i6m.useLayoutEffect)(()=>{
        if (!pathname) return;
        if (!prevPathname.current) {
            prevPathname.current = pathname;
            return;
        }
        // `isInitial: false` is the default, but made explicit here for clarity
        (0, $3TJbe.browserMetrics).startPageLoad({
            isInitial: false
        });
    }, [
        pathname,
        prevPathname
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4ZSso.Fragment), {
        children: children
    });
};

});
parcelRegister("3TJbe", function(module, exports) {

$parcel$export(module.exports, "browserMetrics", function () { return $2d698dfa6689627d$export$c08e7affcf78b064; });

var $dsN6L = parcelRequire("dsN6L");

var $kvMag = parcelRequire("kvMag");

var $7SFmd = parcelRequire("7SFmd");

var $45L5U = parcelRequire("45L5U");

var $jpUMu = parcelRequire("jpUMu");

var $9AAEF = parcelRequire("9AAEF");

var $h8Adp = parcelRequire("h8Adp");

var $eYIeC = parcelRequire("eYIeC");

var $5JEHx = parcelRequire("5JEHx");
function $2d698dfa6689627d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2d698dfa6689627d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2d698dfa6689627d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2d698dfa6689627d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2d698dfa6689627d$var$makeBrowserMetrics = function makeBrowserMetrics() {
    var bm = {
        init: function init(config) {
            var _config$events$BMEven, _config$ssr;
            (0, $jpUMu.visibilityChangeObserver).start();
            if ((_config$events$BMEven = config.events[(0, $5JEHx.BMEventsType).WEB_VITALS]) !== null && _config$events$BMEven !== void 0 && _config$events$BMEven.enabled) (0, $9AAEF.webVitalsObserver).start();
            if (config.debug) {
                (0, $7SFmd.logger).enable();
                (0, $eYIeC.submitter).setDebug(true);
                (0, $45L5U.pageLoadMetaMetric).setDebug(true);
            }
            (0, $eYIeC.submitter).configure(config);
            if ((_config$ssr = config.ssr) !== null && _config$ssr !== void 0 && _config$ssr.getDoneMark) (0, $kvMag.SSRGetDoneMark).setGetDoneMark(config.ssr.getDoneMark);
        },
        setRoute: function setRoute(newRoute) {
            (0, $h8Adp.Route).setRoute(newRoute);
        },
        startPageLoad: function startPageLoad(params) {
            (0, $45L5U.pageLoadMetaMetric).startPageLoad($2d698dfa6689627d$var$_objectSpread({
                isInitial: false,
                cancelStarted: true
            }, params));
        },
        getPageLoadMetric: function getPageLoadMetric() {
            return 0, $45L5U.pageLoadMetaMetric;
        },
        experimental__addPageLoadTimingFromPerformanceMarks: function experimental__addPageLoadTimingFromPerformanceMarks(name, startMark, stopMark) {
            var initialOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
            if (initialOnly && !(0, $45L5U.pageLoadMetaMetric).isInitialLoad()) return;
            var start = performance.getEntriesByName(startMark);
            var stop = performance.getEntriesByName(stopMark);
            if (start.length > 0 && stop.length > 0) {
                if ((0, $45L5U.pageLoadMetaMetric).isDebugMode()) try {
                    performance.measure(name, startMark, stopMark);
                } catch (e) {}
                var pageLoadData = (0, $45L5U.pageLoadMetaMetric).getData();
                if (pageLoadData.start !== null) {
                    var _startMark = start[start.length - 1];
                    var timing = {
                        startTime: Math.round(_startMark.startTime - pageLoadData.start),
                        duration: Math.round(stop[stop.length - 1].startTime - _startMark.startTime)
                    };
                    (0, $45L5U.pageLoadMetaMetric).experimental__addExplicitTiming(name, timing);
                }
            }
        }
    };
    return bm;
};
var $2d698dfa6689627d$export$c08e7affcf78b064 = $2d698dfa6689627d$var$makeBrowserMetrics();

});
parcelRegister("kvMag", function(module, exports) {

$parcel$export(module.exports, "SSRGetDoneMark", function () { return $eeec1062cf5bf77f$export$9e87a201397ac0a9; });
var $eeec1062cf5bf77f$export$9e87a201397ac0a9 = {
    getDoneMark: function() {
        return null;
    },
    setGetDoneMark: function setGetDoneMark(fn) {
        $eeec1062cf5bf77f$export$9e87a201397ac0a9.getDoneMark = fn;
    }
};

});

parcelRegister("7SFmd", function(module, exports) {

$parcel$export(module.exports, "logger", function () { return $5bcda844ca0a72e8$export$af88d00dbe7f521; });
var $5bcda844ca0a72e8$export$af88d00dbe7f521 = {
    enabled: false,
    enable: function enable() {
        this.enabled = true;
    },
    log: function log() {
        if (this.enabled) {
            var _console;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            // eslint-disable-next-line no-console
            (_console = console).log.apply(_console, [
                'BM log: '
            ].concat(args));
        }
    },
    logCond: function logCond(condition) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        if (this.enabled && condition && args.length > 1) this.log.apply(this, args);
    }
};

});

parcelRegister("45L5U", function(module, exports) {

$parcel$export(module.exports, "pageLoadMetaMetric", function () { return $2fac29007820420a$export$24b7a1a311eb05dc; });

var $ai2Md = parcelRequire("ai2Md");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $gGOBY = parcelRequire("gGOBY");

var $lVDuE = parcelRequire("lVDuE");

var $dX0BB = parcelRequire("dX0BB");

var $kSyoi = parcelRequire("kSyoi");

var $dsN6L = parcelRequire("dsN6L");

var $5JEHx = parcelRequire("5JEHx");

var $2Dr5Z = parcelRequire("2Dr5Z");

var $cpGHF = parcelRequire("cpGHF");
var $2fac29007820420a$var$_excluded = [
    "cancelStarted"
];
function $2fac29007820420a$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($gGOBY)))(t, $2fac29007820420a$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(t).constructor) : o.apply(t, e));
}
function $2fac29007820420a$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($2fac29007820420a$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $2fac29007820420a$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dX0BB)))((0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $2fac29007820420a$export$9609608c00ea5077 = /*#__PURE__*/ function(_BasePageLoadMetric) {
    function PageLoadMetaMetric() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, PageLoadMetaMetric);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $2fac29007820420a$var$_callSuper(this, PageLoadMetaMetric, [].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "activePageLoadMetric", null);
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($kSyoi)))(PageLoadMetaMetric, _BasePageLoadMetric);
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(PageLoadMetaMetric, [
        {
            key: "startPageLoad",
            value: function startPageLoad() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                    isInitial: false,
                    cancelStarted: false
                };
                var cancelStarted = _ref.cancelStarted, startPageLoadParams = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $2fac29007820420a$var$_excluded);
                if (cancelStarted || this.state !== (0, $2Dr5Z.MetricState).STARTED) $2fac29007820420a$var$_superPropGet(PageLoadMetaMetric, "startPageLoad", this, 3)([
                    startPageLoadParams
                ]);
            }
        },
        {
            key: "setActive",
            value: function setActive(metric) {
                this.activePageLoadMetric = metric;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(debug) {
                this.config.debug = debug;
            }
        },
        {
            key: "isDebugMode",
            value: function isDebugMode() {
                return this.config.debug;
            }
        },
        {
            key: "isInitialLoad",
            value: function isInitialLoad() {
                return this.isInitial;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.activePageLoadMetric && this.activePageLoadMetric.cancel();
                $2fac29007820420a$var$_superPropGet(PageLoadMetaMetric, "clear", this, 3)([]);
            }
        },
        {
            key: "include",
            value: function include(metric) {
                if (!this.config.include) this.config.include = [
                    metric
                ];
                else this.config.include.push(metric);
            }
        },
        {
            key: "experimental__addExplicitTiming",
            value: function experimental__addExplicitTiming(name, timing) {
                if (this.explicitTimings === null) this.explicitTimings = {};
                this.explicitTimings[name] = timing;
            }
        }
    ]);
}((0, $cpGHF.BasePageLoadMetric));
var $2fac29007820420a$export$24b7a1a311eb05dc = new $2fac29007820420a$export$9609608c00ea5077({
    type: (0, $5JEHx.BMEventsType).PAGE_LOAD,
    key: 'page_load_meta_metric'
});

});
parcelRegister("5JEHx", function(module, exports) {

$parcel$export(module.exports, "BMEventsType", function () { return $42d0ba1f3dfc1638$export$9c73e297d4be9159; });
$parcel$export(module.exports, "StorableBMEventsType", function () { return $42d0ba1f3dfc1638$export$9b7037ec30489597; });
$parcel$export(module.exports, "BMPageLoadMetrics", function () { return $42d0ba1f3dfc1638$export$74c1fb0997d51e2a; });
$parcel$export(module.exports, "BMPageSegmentLoadMetrics", function () { return $42d0ba1f3dfc1638$export$88195ac8200d03a6; });
$parcel$export(module.exports, "BMInteractionMetrics", function () { return $42d0ba1f3dfc1638$export$6e28252a002afdb2; });
$parcel$export(module.exports, "PageSegmentPageLoadMetricsOptions", function () { return $42d0ba1f3dfc1638$export$474154836bfd8dd9; });
$parcel$export(module.exports, "PageVisibleFields", function () { return $42d0ba1f3dfc1638$export$e89802082dab5633; });
$parcel$export(module.exports, "PageVisibleValueOrigin", function () { return $42d0ba1f3dfc1638$export$983b017156c2aee2; });
$parcel$export(module.exports, "isDetailedPageLoadSlo", function () { return $42d0ba1f3dfc1638$export$5866f95702a15142; });
$parcel$export(module.exports, "isDetailedPageSegmentLoadSlo", function () { return $42d0ba1f3dfc1638$export$f087a59bd717e49d; });
$parcel$export(module.exports, "isInteractionMetricsSlo", function () { return $42d0ba1f3dfc1638$export$b10c1d9a7db7765b; });
$parcel$export(module.exports, "IncludeSSRFeatureFlagsConfig", function () { return $42d0ba1f3dfc1638$export$60c0193054fc3040; });

var $2Dr5Z = parcelRequire("2Dr5Z");
var $42d0ba1f3dfc1638$export$9c73e297d4be9159 = /*#__PURE__*/ function(BMEventsType) {
    BMEventsType["PAGE_LOAD"] = "PAGE_LOAD";
    BMEventsType["PAGE_SEGMENT_LOAD"] = "PAGE_SEGMENT_LOAD";
    BMEventsType["INLINE_RESULT"] = "INLINE_RESULT";
    BMEventsType["CUSTOM"] = "CUSTOM";
    BMEventsType["WEB_VITALS"] = "WEB_VITALS";
    return BMEventsType;
}({});
var $42d0ba1f3dfc1638$export$9b7037ec30489597 = /*#__PURE__*/ function(StorableBMEventsType) {
    StorableBMEventsType["PAGE_LOAD"] = "page-load";
    StorableBMEventsType["PAGE_SEGMENT_LOAD"] = "page-segment-load";
    StorableBMEventsType["INLINE_RESULT"] = "inline-result";
    StorableBMEventsType["CUSTOM"] = "custom";
    StorableBMEventsType["WEB_VITALS"] = "web-vitals";
    return StorableBMEventsType;
}({});
var $42d0ba1f3dfc1638$export$74c1fb0997d51e2a = /*#__PURE__*/ function(BMPageLoadMetrics) {
    BMPageLoadMetrics["fmp"] = "fmp";
    BMPageLoadMetrics["tti"] = "tti";
    return BMPageLoadMetrics;
}({});
var $42d0ba1f3dfc1638$export$88195ac8200d03a6 = /*#__PURE__*/ function(BMPageSegmentLoadMetrics) {
    BMPageSegmentLoadMetrics["fmp"] = "fmp";
    BMPageSegmentLoadMetrics["tti"] = "tti";
    return BMPageSegmentLoadMetrics;
}({});
var $42d0ba1f3dfc1638$export$6e28252a002afdb2 = /*#__PURE__*/ function(BMInteractionMetrics) {
    BMInteractionMetrics["response"] = "response";
    BMInteractionMetrics["result"] = "result";
    return BMInteractionMetrics;
}({});
var $42d0ba1f3dfc1638$export$474154836bfd8dd9 = /*#__PURE__*/ function(PageSegmentPageLoadMetricsOptions) {
    PageSegmentPageLoadMetricsOptions["OFF"] = "OFF";
    PageSegmentPageLoadMetricsOptions["IF_PRESENT"] = "IF_PRESENT";
    PageSegmentPageLoadMetricsOptions["WAIT_UNTIL_PRESENT"] = "WAIT_UNTIL_PRESENT";
    return PageSegmentPageLoadMetricsOptions;
}({});
var $42d0ba1f3dfc1638$export$e89802082dab5633 = /*#__PURE__*/ function(PageVisibleFields) {
    PageVisibleFields["pageVisibleState"] = "page-visible-state";
    PageVisibleFields["pageVisibleValue"] = "page-visible-value";
    return PageVisibleFields;
}({});
var $42d0ba1f3dfc1638$export$983b017156c2aee2 = /*#__PURE__*/ function(PageVisibleValueOrigin) {
    PageVisibleValueOrigin["documentHidden"] = "document-hidden";
    PageVisibleValueOrigin["pageVisibleState"] = "page-visible-state";
    return PageVisibleValueOrigin;
}({});
var $42d0ba1f3dfc1638$export$5866f95702a15142 = function isDetailedPageLoadSlo(data) {
    return Boolean(data.initial);
};
var $42d0ba1f3dfc1638$export$f087a59bd717e49d = function isDetailedPageSegmentLoadSlo(data) {
    return Boolean(data.initial);
};
var $42d0ba1f3dfc1638$export$153c4c72fa5eeece = function isPageLoadMetricsSlo(data) {
    var obj = data;
    return Boolean(obj.fmp !== undefined || obj.tti !== undefined);
};
var $42d0ba1f3dfc1638$export$b10c1d9a7db7765b = function isInteractionMetricsSlo(data) {
    var obj = data;
    return Boolean(obj.result !== undefined || obj.response !== undefined);
};
var $42d0ba1f3dfc1638$export$60c0193054fc3040 = /*#__PURE__*/ function(IncludeSSRFeatureFlagsConfig) {
    IncludeSSRFeatureFlagsConfig["NEVER"] = "never";
    IncludeSSRFeatureFlagsConfig["WHEN_FMP"] = "when-fmp";
    IncludeSSRFeatureFlagsConfig["WHEN_AVAILABLE"] = "when-available";
    return IncludeSSRFeatureFlagsConfig;
}({});

});
parcelRegister("2Dr5Z", function(module, exports) {

$parcel$export(module.exports, "MetricState", function () { return $1eb43de881f3c303$export$1e458f18c0c7bfe3; });
$parcel$export(module.exports, "PageVisibleState", function () { return $1eb43de881f3c303$export$a12c67b37a306b13; });
$parcel$export(module.exports, "BaseMetric", function () { return $1eb43de881f3c303$export$2bce4ffdd840e878; });

var $iqLBO = parcelRequire("iqLBO");

var $5YM7L = parcelRequire("5YM7L");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $dsN6L = parcelRequire("dsN6L");

var $9semw = parcelRequire("9semw");

var $7SFmd = parcelRequire("7SFmd");

var $jpUMu = parcelRequire("jpUMu");

var $6C6bd = parcelRequire("6C6bd");
function $1eb43de881f3c303$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1eb43de881f3c303$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1eb43de881f3c303$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1eb43de881f3c303$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1eb43de881f3c303$export$1e458f18c0c7bfe3 = /*#__PURE__*/ function(MetricState) {
    MetricState["NOT_STARTED"] = "not-started";
    MetricState["STARTED"] = "started";
    MetricState["FINISHED"] = "finished";
    MetricState["CANCELLED"] = "cancelled";
    return MetricState;
}({});
var $1eb43de881f3c303$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["MIXED"] = "mixed";
    PageVisibleState["HIDDEN"] = "hidden";
    return PageVisibleState;
}({});
function $1eb43de881f3c303$var$getPageVisibleState() {
    return typeof document !== 'undefined' && document.visibilityState === 'visible' ? $1eb43de881f3c303$export$a12c67b37a306b13.VISIBLE : $1eb43de881f3c303$export$a12c67b37a306b13.HIDDEN;
}
var $1eb43de881f3c303$export$2bce4ffdd840e878 = /*#__PURE__*/ function() {
    function BaseMetric(config) {
        var _this = this, _this$config$timings;
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, BaseMetric);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "state", $1eb43de881f3c303$export$1e458f18c0c7bfe3.NOT_STARTED);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "startTime", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "stopTime", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "marks", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "onStopCallbacks", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "custom", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "submetrics", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "route", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "untilOnStopCallback", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "pageVisibleState", $1eb43de881f3c303$var$getPageVisibleState());
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "setPageVisibleStateToMixed", function() {
            _this.pageVisibleState = $1eb43de881f3c303$export$a12c67b37a306b13.MIXED;
        });
        this.config = config;
        this.key = config.key.replace(/ /gi, '-');
        this.type = config.type;
        (_this$config$timings = this.config.timings) === null || _this$config$timings === void 0 || _this$config$timings.forEach(function(entry) {
            if ((0, $9semw.restrictedTimingKeys).includes(entry.key)) {
                // eslint-disable-next-line no-console
                console.warn("Entry ".concat(entry.key, " is restricted and has been renamed to custom__").concat(entry.key));
                entry.key = "custom__".concat(entry.key);
            }
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(BaseMetric, [
        {
            key: "untilMetrics",
            get: function get() {
                var until = this.config.until;
                if (!until) return [];
                else if (Array.isArray(until)) return this.getConfiguredUntilMetricArray(until);
                return this.getConfiguredUntilMetricArray([
                    until
                ]);
            }
        },
        {
            key: "start",
            value: function start() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$startTime = _ref.startTime, startTime = _ref$startTime === void 0 ? window.performance.now() : _ref$startTime;
                this.clear();
                (0, $7SFmd.logger).logCond(!!this.config.debug, this.key, startTime);
                this.state = $1eb43de881f3c303$export$1e458f18c0c7bfe3.STARTED;
                this.startTime = startTime;
                this.pageVisibleState = $1eb43de881f3c303$var$getPageVisibleState();
                (0, $jpUMu.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
                this.watchUntil();
            }
        },
        {
            key: "stop",
            value: function stop() {
                var stopArguments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var _stopArguments$stopTi = stopArguments.stopTime, stopTime = _stopArguments$stopTi === void 0 ? window.performance.now() : _stopArguments$stopTi;
                if (this.state !== $1eb43de881f3c303$export$1e458f18c0c7bfe3.STARTED || this.startTime === null) {
                    (0, $7SFmd.logger).log("metric ".concat(this.config.key, " has been stopped while not being started before; current state: ").concat(this.state));
                    return false;
                }
                if (stopTime < this.startTime) {
                    (0, $7SFmd.logger).log("metric ".concat(this.config.key, " has been stopped with stopTime lower than startTime; startTime: ").concat(this.startTime, "; stopTime: ").concat(stopTime));
                    return false;
                }
                this.stopTime = stopTime;
                this.state = $1eb43de881f3c303$export$1e458f18c0c7bfe3.FINISHED;
                this.handleStop(stopArguments);
                (0, $jpUMu.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
                return true;
            }
        },
        {
            key: "handleStop",
            value: function handleStop(stopArguments) {
                var _this2 = this;
                var _stopArguments$custom = stopArguments.customData, customData = _stopArguments$custom === void 0 ? null : _stopArguments$custom;
                if (customData) this.custom = $1eb43de881f3c303$var$_objectSpread($1eb43de881f3c303$var$_objectSpread({}, this.custom), customData);
                this.config.include && this.config.include.forEach(function(metric) {
                    var included = metric.getData();
                    if (included.state === $1eb43de881f3c303$export$1e458f18c0c7bfe3.FINISHED && included.start !== null && included.start >= (_this2.startTime || 0)) _this2.addSubMetric(metric.getData());
                });
                this.onStopCallbacks.forEach(function(_ref2) {
                    var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_ref2, 1), success = _ref3[0];
                    success(stopArguments);
                });
                this.onStopCallbacks = [];
                (0, $7SFmd.logger).logCond(!!this.config.debug, this.key, this.config.debug && this.getData());
            }
        },
        {
            key: "mark",
            value: function mark(_mark) {
                var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance.now();
                this.marks[_mark] = timestamp;
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                if (this.state !== $1eb43de881f3c303$export$1e458f18c0c7bfe3.STARTED) return;
                this.state = $1eb43de881f3c303$export$1e458f18c0c7bfe3.CANCELLED;
                this.cancelUntil();
                this.onStopCallbacks.forEach(function(_ref4) {
                    var _ref5 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_ref4, 2), cancel = _ref5[1];
                    cancel();
                });
                this.onStopCallbacks = [];
                (0, $jpUMu.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
            }
        },
        {
            key: "merge",
            value: function merge(mergeData) {
                this.state = mergeData.state;
                this.pageVisibleState = mergeData.pageVisibleState;
                this.startTime = mergeData.start;
                this.stopTime = mergeData.stop;
                this.marks = $1eb43de881f3c303$var$_objectSpread($1eb43de881f3c303$var$_objectSpread({}, this.marks), mergeData.marks);
                this.submetrics = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(this.submetrics), (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(mergeData.submetrics));
                this.onStopCallbacks = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(this.onStopCallbacks), (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(mergeData.onStopCallbacks));
            }
        },
        {
            key: "onStop",
            value: function onStop(success, cancel) {
                this.onStopCallbacks.push([
                    success,
                    cancel
                ]);
            }
        },
        {
            key: "removeOnStopCallback",
            value: function removeOnStopCallback(success) {
                var index = this.onStopCallbacks.findIndex(function(_ref6) {
                    var _ref7 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_ref6, 1), successCallback = _ref7[0];
                    return success === successCallback;
                });
                if (index > -1) this.onStopCallbacks.splice(index, 1);
            }
        },
        {
            key: "getData",
            value: function getData() {
                return {
                    key: this.key,
                    state: this.state,
                    start: this.startTime,
                    stop: this.stopTime,
                    //todo ranges
                    // ranges: this.makeRanges()
                    marks: this.marks,
                    // todo make copy
                    custom: this.custom,
                    submetrics: this.submetrics,
                    config: this.config,
                    route: this.route,
                    pageVisibleState: this.pageVisibleState,
                    type: this.config.type
                };
            }
        },
        {
            key: "getDataToMerge",
            value: function getDataToMerge() {
                return $1eb43de881f3c303$var$_objectSpread($1eb43de881f3c303$var$_objectSpread({}, this.getData()), {}, {
                    onStopCallbacks: this.onStopCallbacks
                });
            }
        },
        {
            key: "addSubMetric",
            value: function addSubMetric(data) {
                this.submetrics.push(data);
            }
        },
        {
            key: "getConfiguredUntilMetric",
            value: function getConfiguredUntilMetric(metricOrConfig) {
                return metricOrConfig instanceof BaseMetric ? (0, $6C6bd.UntilExperience).fromMetric(metricOrConfig) : (0, $6C6bd.UntilExperience).fromConfig(metricOrConfig);
            }
        },
        {
            key: "getConfiguredUntilMetricArray",
            value: function getConfiguredUntilMetricArray(metricArray) {
                var _this3 = this;
                if (!metricArray.length) return [];
                return metricArray.map(function(metric) {
                    return _this3.getConfiguredUntilMetric(metric);
                });
            }
        },
        {
            key: "isUntilFinished",
            value: function isUntilFinished() {
                return this.untilMetrics.every(function(metric) {
                    return metric.experience.getData().state === $1eb43de881f3c303$export$1e458f18c0c7bfe3.FINISHED;
                });
            }
        },
        {
            key: "handleAllUntilFinished",
            value: function handleAllUntilFinished() {
                // Order by ascending stop time
                var sorted = (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(this.untilMetrics).sort(function(m1, m2) {
                    return m1.getDependencyStopTime() - m2.getDependencyStopTime();
                });
                // Find the latest page segment to become fully interactive
                var latestFullyInteractiveSegment = (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(this.untilMetrics).reduce(function(currentLatestSegment, metric) {
                    var _currentLatestSegment, _metric$getFullyInter;
                    var currentLatestStopTime = (_currentLatestSegment = currentLatestSegment === null || currentLatestSegment === void 0 ? void 0 : currentLatestSegment.getFullyInteractiveStopTime()) !== null && _currentLatestSegment !== void 0 ? _currentLatestSegment : 0;
                    var metricStopTime = (_metric$getFullyInter = metric.getFullyInteractiveStopTime()) !== null && _metric$getFullyInter !== void 0 ? _metric$getFullyInter : 0;
                    return metricStopTime > currentLatestStopTime ? metric : currentLatestSegment;
                }, undefined);
                // Accumulate the custom data from each metric, later metrics take priority
                var accumulatedCustomData = {};
                sorted.forEach(function(metric) {
                    Object.assign(accumulatedCustomData, metric.experience.getData().custom);
                });
                var latestSegment = sorted[sorted.length - 1];
                var latestFullyInteractiveStopTime = latestFullyInteractiveSegment === null || latestFullyInteractiveSegment === void 0 ? void 0 : latestFullyInteractiveSegment.getFullyInteractiveStopTime();
                this.stop({
                    stopTime: latestSegment.getDependencyStopTime(),
                    customData: $1eb43de881f3c303$var$_objectSpread($1eb43de881f3c303$var$_objectSpread({}, accumulatedCustomData), {}, {
                        segment: latestSegment.getKey(),
                        segmentOverrided: latestSegment.getIsSegmentLoadOverrided()
                    }, latestFullyInteractiveStopTime ? {
                        latestFullyInteractiveSegment: latestFullyInteractiveSegment === null || latestFullyInteractiveSegment === void 0 ? void 0 : latestFullyInteractiveSegment.getKey(),
                        latestFullyInteractiveStopTime: latestFullyInteractiveStopTime
                    } : {})
                });
            }
        },
        {
            key: "watchUntil",
            value: function watchUntil() {
                var _this4 = this;
                if (!this.untilMetrics.length) return;
                if (this.isUntilFinished()) {
                    // Already finished, handle it immediately
                    this.handleAllUntilFinished();
                    return;
                }
                // If not currently finished, register stop callbacks to re-check
                this.untilOnStopCallback = function() {
                    if (_this4.isUntilFinished()) _this4.handleAllUntilFinished();
                };
                this.untilMetrics.forEach(function(metric) {
                    if (metric.experience.getData().state !== $1eb43de881f3c303$export$1e458f18c0c7bfe3.FINISHED) metric.experience.onStop(_this4.untilOnStopCallback, function() {
                        return _this4.cancel();
                    });
                });
            }
        },
        {
            key: "cancelUntil",
            value: function cancelUntil() {
                var _this5 = this;
                this.untilMetrics.forEach(function(metric) {
                    if (metric.experience.getData().state !== $1eb43de881f3c303$export$1e458f18c0c7bfe3.CANCELLED && _this5.untilOnStopCallback) metric.experience.removeOnStopCallback(_this5.untilOnStopCallback);
                });
            }
        },
        {
            key: "clear",
            value: function clear() {
                // todo before clearing - handle cancelling existing onStop / unsubscribe submetrics
                this.cancelUntil();
                this.state = $1eb43de881f3c303$export$1e458f18c0c7bfe3.NOT_STARTED;
                this.startTime = null;
                this.stopTime = null;
                this.marks = {};
                this.custom = null;
                this.submetrics = [];
                this.route = null;
                this.pageVisibleState = $1eb43de881f3c303$var$getPageVisibleState();
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($1eb43de881f3c303$export$2bce4ffdd840e878, "FMP", 'fmp');

});
parcelRegister("iqLBO", function(module, exports) {

var $aWj15 = parcelRequire("aWj15");

var $azAQW = parcelRequire("azAQW");

var $d9Fbm = parcelRequire("d9Fbm");

var $d0pPA = parcelRequire("d0pPA");
function $d6af95d1f4dbf598$var$_toConsumableArray(r) {
    return $aWj15(r) || $azAQW(r) || $d9Fbm(r) || $d0pPA();
}
module.exports = $d6af95d1f4dbf598$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("aWj15", function(module, exports) {

var $7CcOI = parcelRequire("7CcOI");
function $7f6e126ed7c1ac41$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $7CcOI(r);
}
module.exports = $7f6e126ed7c1ac41$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("azAQW", function(module, exports) {
function $7b29c27aa7a4146b$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $7b29c27aa7a4146b$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("d0pPA", function(module, exports) {
function $977f4ff650e29a44$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $977f4ff650e29a44$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("9semw", function(module, exports) {

$parcel$export(module.exports, "restrictedTimingKeys", function () { return $6e21de9c5abc6f76$export$1d17377365286b00; });
$parcel$export(module.exports, "clsWaitTimeMs", function () { return $6e21de9c5abc6f76$export$df21d285cfcda81e; });
var $6e21de9c5abc6f76$export$1d17377365286b00 = [
    'ssr'
];
var $6e21de9c5abc6f76$export$df21d285cfcda81e = 7500;

});

parcelRegister("jpUMu", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", function () { return $e22c65a6e3dd583f$export$13e680397ec8f3eb; });

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $dsN6L = parcelRequire("dsN6L");
var $e22c65a6e3dd583f$var$VisibilityChangeObserver = /*#__PURE__*/ function() {
    function VisibilityChangeObserver() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, VisibilityChangeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "observers", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "broadcast", function() {
            _this.observers.forEach(function(fn) {
                return fn();
            });
            _this.observers = [];
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(VisibilityChangeObserver, [
        {
            key: "start",
            value: function start() {
                document.addEventListener('visibilitychange', this.broadcast);
                /**
       * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
       * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
       * so for that case, you need to also include code to listen for the pagehide event.
       */ window.addEventListener('pagehide', this.broadcast);
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                this.observers.push(callback);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(callback) {
                this.observers = this.observers.filter(function(fn) {
                    return fn !== callback;
                });
            }
        }
    ]);
}();
var $e22c65a6e3dd583f$export$13e680397ec8f3eb = new $e22c65a6e3dd583f$var$VisibilityChangeObserver();

});

parcelRegister("6C6bd", function(module, exports) {

$parcel$export(module.exports, "UntilExperience", function () { return $4d0b15e26aa18202$export$3fcc0936ee2cc852; });

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $dsN6L = parcelRequire("dsN6L");
var $4d0b15e26aa18202$export$3fcc0936ee2cc852 = /*#__PURE__*/ function() {
    function UntilExperience(experience, useFmpAsUntilStopTime) {
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, UntilExperience);
        this.experience = experience;
        this.useFmpAsUntilStopTime = useFmpAsUntilStopTime;
    }
    /**
   * If FMP mark is present, return that
   * otherwise return the eventual load
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(UntilExperience, [
        {
            key: "getFmp",
            value: function getFmp() {
                var _marks$UntilExperienc;
                var _this$experience$getD = this.experience.getData(), marks = _this$experience$getD.marks, stop = _this$experience$getD.stop;
                return (_marks$UntilExperienc = marks[UntilExperience.FMP]) !== null && _marks$UntilExperienc !== void 0 ? _marks$UntilExperienc : stop;
            }
        },
        {
            key: "getDependencyStopTime",
            value: function getDependencyStopTime() {
                if (this.useFmpAsUntilStopTime) return this.getFmp();
                return this.experience.getData().stop;
            }
        },
        {
            key: "getFullyInteractiveStopTime",
            value: function getFullyInteractiveStopTime() {
                return this.experience.getData().stop;
            }
        },
        {
            key: "getIsSegmentLoadOverrided",
            value: function getIsSegmentLoadOverrided() {
                if (this.useFmpAsUntilStopTime) {
                    var _this$experience$getD2 = this.experience.getData(), marks = _this$experience$getD2.marks;
                    return marks[UntilExperience.FMP] ? true : false;
                }
                return false;
            }
        },
        {
            key: "getKey",
            value: function getKey() {
                return this.experience.getData().key;
            }
        }
    ], [
        {
            key: "fromConfig",
            value: function fromConfig(config) {
                return new UntilExperience(config.experience, config.useFmpAsUntilStopTime);
            }
        },
        {
            key: "fromMetric",
            value: function fromMetric(metric) {
                return new UntilExperience(metric);
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($4d0b15e26aa18202$export$3fcc0936ee2cc852, "FMP", 'fmp');

});



parcelRegister("cpGHF", function(module, exports) {

$parcel$export(module.exports, "BasePageLoadMetric", function () { return $9098f1cf3c92ea3f$export$fd1447b187f590fe; });

var $iqLBO = parcelRequire("iqLBO");

var $lwsBr = parcelRequire("lwsBr");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $gGOBY = parcelRequire("gGOBY");

var $lVDuE = parcelRequire("lVDuE");

var $dX0BB = parcelRequire("dX0BB");

var $kSyoi = parcelRequire("kSyoi");

var $dsN6L = parcelRequire("dsN6L");

var $7SFmd = parcelRequire("7SFmd");

var $2Dr5Z = parcelRequire("2Dr5Z");
function $9098f1cf3c92ea3f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9098f1cf3c92ea3f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9098f1cf3c92ea3f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9098f1cf3c92ea3f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9098f1cf3c92ea3f$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($gGOBY)))(t, $9098f1cf3c92ea3f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(t).constructor) : o.apply(t, e));
}
function $9098f1cf3c92ea3f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($9098f1cf3c92ea3f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $9098f1cf3c92ea3f$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dX0BB)))((0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $9098f1cf3c92ea3f$export$fd1447b187f590fe = /*#__PURE__*/ function(_BaseMetric) {
    function BasePageLoadMetric(args) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, BasePageLoadMetric);
        _this = $9098f1cf3c92ea3f$var$_callSuper(this, BasePageLoadMetric, [
            args
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "isInitial", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "explicitTimings", null);
        _this.config = args;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($kSyoi)))(BasePageLoadMetric, _BaseMetric);
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(BasePageLoadMetric, [
        {
            key: "start",
            value: function start() {
                (0, (/*@__PURE__*/$parcel$interopDefault($lwsBr)))(arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {});
                // please use startPageLoad
                return;
            }
        },
        {
            key: "startPageLoad",
            value: function startPageLoad() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                    isInitial: false
                };
                // todo this should update meta page load metric
                this.isInitial = params.isInitial;
                if (params.isInitial) $9098f1cf3c92ea3f$var$_superPropGet(BasePageLoadMetric, "start", this, 3)([
                    {
                        startTime: 0
                    }
                ]);
                else $9098f1cf3c92ea3f$var$_superPropGet(BasePageLoadMetric, "start", this, 3)([
                    params
                ]);
                (0, $7SFmd.logger).logCond(!!this.config.debug, this.key, this.startTime);
            }
        },
        {
            key: "stopPageLoad",
            value: function stopPageLoad(pageLoadMetaMetricData) {
                var stopArguments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    stopTime: window.performance.now()
                };
                if (pageLoadMetaMetricData.state !== (0, $2Dr5Z.MetricState).STARTED || pageLoadMetaMetricData.start === null || stopArguments.stopTime === undefined) {
                    (0, $7SFmd.logger).log("meta metric has been stopped while not being started before; current state: ".concat(this.state));
                    return false;
                }
                if (stopArguments.stopTime < pageLoadMetaMetricData.start) {
                    (0, $7SFmd.logger).log("metric ".concat(this.config.key, " has been stopped with stopTime lower than startTime; startTime: ").concat(pageLoadMetaMetricData.start, "; stopTime: ").concat(stopArguments.stopTime));
                    return false;
                }
                this.merge(pageLoadMetaMetricData);
                this.stopTime = stopArguments.stopTime;
                this.state = (0, $2Dr5Z.MetricState).FINISHED;
                this.handleStop(stopArguments);
                return true;
            }
        },
        {
            key: "handleStop",
            value: function handleStop(stopArguments) {
                var until = this.config.until;
                var fmpWasMarked = BasePageLoadMetric.FMP in this.marks;
                if (!fmpWasMarked && until) {
                    // Extract the maximum FMP value from the until metrics
                    var untilArr = Array.isArray(until) ? this.getConfiguredUntilMetricArray(until) : this.getConfiguredUntilMetricArray([
                        until
                    ]);
                    var untilFmpMarks = untilArr.map(function(metric) {
                        return metric.getFmp();
                    });
                    if (untilFmpMarks.every(Number.isFinite)) this.markFMP(Math.max.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(untilFmpMarks)));
                }
                $9098f1cf3c92ea3f$var$_superPropGet(BasePageLoadMetric, "handleStop", this, 3)([
                    stopArguments
                ]);
            }
        },
        {
            key: "mark",
            value: function mark(_mark) {
                var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance.now();
                if (_mark === BasePageLoadMetric.FMP) return;
                $9098f1cf3c92ea3f$var$_superPropGet(BasePageLoadMetric, "mark", this, 3)([
                    _mark,
                    timestamp
                ]);
            }
        },
        {
            key: "merge",
            value: function merge(mergeData) {
                $9098f1cf3c92ea3f$var$_superPropGet(BasePageLoadMetric, "merge", this, 3)([
                    mergeData
                ]);
                this.isInitial = mergeData.isInitial;
                this.explicitTimings = this.explicitTimings || mergeData.explicitTimings ? $9098f1cf3c92ea3f$var$_objectSpread($9098f1cf3c92ea3f$var$_objectSpread({}, mergeData.explicitTimings), this.explicitTimings) : null;
            }
        },
        {
            key: "markFMP",
            value: function markFMP(timestamp) {
                $9098f1cf3c92ea3f$var$_superPropGet(BasePageLoadMetric, "mark", this, 3)([
                    BasePageLoadMetric.FMP,
                    timestamp
                ]);
            }
        },
        {
            key: "getPageLoadData",
            value: function getPageLoadData() {
                return {
                    isInitial: this.isInitial,
                    explicitTimings: this.explicitTimings
                };
            }
        },
        {
            key: "getData",
            value: function getData() {
                return $9098f1cf3c92ea3f$var$_objectSpread($9098f1cf3c92ea3f$var$_objectSpread({}, $9098f1cf3c92ea3f$var$_superPropGet(BasePageLoadMetric, "getData", this, 3)([])), this.getPageLoadData());
            }
        },
        {
            key: "getDataToMerge",
            value: function getDataToMerge() {
                return $9098f1cf3c92ea3f$var$_objectSpread($9098f1cf3c92ea3f$var$_objectSpread({}, $9098f1cf3c92ea3f$var$_superPropGet(BasePageLoadMetric, "getDataToMerge", this, 3)([])), this.getPageLoadData());
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.explicitTimings = null;
                $9098f1cf3c92ea3f$var$_superPropGet(BasePageLoadMetric, "clear", this, 3)([]);
            }
        }
    ]);
}((0, $2Dr5Z.BaseMetric));
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($9098f1cf3c92ea3f$export$fd1447b187f590fe, "FMP", 'fmp');

});
parcelRegister("lwsBr", function(module, exports) {
function $fab2c60ef39d628a$var$_objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
module.exports = $fab2c60ef39d628a$var$_objectDestructuringEmpty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("9AAEF", function(module, exports) {

$parcel$export(module.exports, "webVitalsObserver", function () { return $6fb3e8bae7fcb13b$export$253d38dccbb37615; });

var $2R76C = parcelRequire("2R76C");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $dsN6L = parcelRequire("dsN6L");

var $eWMMH = parcelRequire("eWMMH");


var $6fb3e8bae7fcb13b$var$WebVitalsObserver = /*#__PURE__*/ function() {
    function WebVitalsObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, WebVitalsObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "data", {
            'metric:ttci': null,
            'metric:ttfb': null,
            'metric:fid': null,
            'metric:fcp': null,
            'metric:lcp': null,
            'metric:cls': null
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(WebVitalsObserver, [
        {
            key: "start",
            value: function start() {
                this.ttciDetermined = this.registerTTCI();
                this.webVitalsDetermined = this.registerWebVitals();
            }
        },
        {
            key: "registerWebVitals",
            value: function() {
                var _registerWebVitals = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee() {
                    var _this = this;
                    var _yield$import, getCLS, getFCP, getFID, getLCP, getTTFB;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return (parcelRequire("cteCe"));
                            case 3:
                                _yield$import = _context.sent;
                                getCLS = _yield$import.getCLS;
                                getFCP = _yield$import.getFCP;
                                getFID = _yield$import.getFID;
                                getLCP = _yield$import.getLCP;
                                getTTFB = _yield$import.getTTFB;
                                _context.next = 11;
                                return Promise.all([
                                    getTTFB,
                                    getFID,
                                    getFCP,
                                    getLCP,
                                    getCLS
                                ].map(function(fx) {
                                    return new Promise(function(resolve) {
                                        fx(function(_ref) {
                                            var name = _ref.name, value = _ref.value;
                                            // round FCP, FID, LCP, TTFB to nearest integer.
                                            // CLS is rounded to two decimal places.
                                            var metricName = name.toLowerCase();
                                            var metricValue = metricName === 'cls' ? parseFloat(value.toFixed(2)) : Math.round(value);
                                            _this.data["metric:".concat(metricName)] = metricValue;
                                            resolve();
                                        });
                                    });
                                }));
                            case 11:
                                _context.next = 15;
                                break;
                            case 13:
                                _context.prev = 13;
                                _context.t0 = _context["catch"](0);
                            case 15:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, null, [
                        [
                            0,
                            13
                        ]
                    ]);
                }));
                function registerWebVitals() {
                    return _registerWebVitals.apply(this, arguments);
                }
                return registerWebVitals;
            }()
        },
        {
            key: "registerTTCI",
            value: function() {
                var _registerTTCI = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee2() {
                    var _this2 = this;
                    var ttiPolyfill;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.prev = 0;
                                _context2.next = 3;
                                return (parcelRequire("lpHd1"));
                            case 3:
                                ttiPolyfill = _context2.sent;
                                _context2.next = 6;
                                return ttiPolyfill.getFirstConsistentlyInteractive().then(function(value) {
                                    // according to the docs:
                                    // If no TTI value can be found, or if the browser doesn't support all the APIs required to detect TTI,
                                    // the promise resolves to null.
                                    _this2.data['metric:ttci'] = typeof value === 'number' ? Math.round(value) : value;
                                    return true;
                                });
                            case 6:
                                _context2.next = 10;
                                break;
                            case 8:
                                _context2.prev = 8;
                                _context2.t0 = _context2["catch"](0);
                            case 10:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, null, [
                        [
                            0,
                            8
                        ]
                    ]);
                }));
                function registerTTCI() {
                    return _registerTTCI.apply(this, arguments);
                }
                return registerTTCI;
            }()
        }
    ]);
}();
var $6fb3e8bae7fcb13b$export$253d38dccbb37615 = new $6fb3e8bae7fcb13b$var$WebVitalsObserver();

});
parcelRegister("cteCe", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("lyb5Y")).then(()=>parcelRequire('2L7l6'));

});
parcelRegister("ij0b0", function(module, exports) {
"use strict";

var $dPL7j = parcelRequire("dPL7j");
module.exports = $dPL7j(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Add a global function to handle when the script loads.
        var globalName = "i".concat(('' + Math.random()).slice(2));
        $parcel$global[globalName] = function(m) {
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        var cleanup = function() {
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        var script = document.createElement('script');
        script.async = true;
        script.type = 'module';
        script.charset = 'utf-8';
        script.textContent = "import * as m from '".concat(bundle, "'; ").concat(globalName, "(m);");
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});
parcelRegister("dPL7j", function(module, exports) {
"use strict";
var $a124963c3f7d4950$var$cachedBundles = {};
var $a124963c3f7d4950$var$cachedPreloads = {};
var $a124963c3f7d4950$var$cachedPrefetches = {};
function $a124963c3f7d4950$var$getCache(type) {
    switch(type){
        case 'preload':
            return $a124963c3f7d4950$var$cachedPreloads;
        case 'prefetch':
            return $a124963c3f7d4950$var$cachedPrefetches;
        default:
            return $a124963c3f7d4950$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $a124963c3f7d4950$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("lpHd1", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("f2uOF")).then(()=>parcelRequire('9uERg'));

});


parcelRegister("h8Adp", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $c79f469fe07bdff3$export$e7b0ac011bb776c6; });
var $c79f469fe07bdff3$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute: function setRoute(newRoute) {
        this.route = newRoute;
    },
    getRoute: function getRoute() {
        return this.route;
    }
};

});

parcelRegister("eYIeC", function(module, exports) {

$parcel$export(module.exports, "submitter", function () { return $ae78fb62c5b5614b$export$c21a25872e3f5a2b; });

var $2R76C = parcelRequire("2R76C");

var $eWMMH = parcelRequire("eWMMH");

var $1mFjE = parcelRequire("1mFjE");

var $5JEHx = parcelRequire("5JEHx");

var $c0VuO = parcelRequire("c0VuO");

var $2O5uS = parcelRequire("2O5uS");
var $ae78fb62c5b5614b$export$c21a25872e3f5a2b = {
    debug: false,
    config: {
        gasv3: undefined,
        configChunk: null,
        useVisibleState: false,
        histogram: {},
        enableReactUFOTracker: false
    },
    configure: function configure(config) {
        this.config.gasv3 = config.endpoints.eventPipelineClient;
        this.config.enableReactUFOTracker = config.enableReactUFOTracker;
        this.config.configChunk = (0, $2O5uS.makeShareableGlobalConfig)(config);
        if (config.events.all && config.events.all.sfxEvents) this.config.useVisibleState = config.events.all.sfxEvents.activeTab === (0, $5JEHx.PageVisibleFields).pageVisibleState;
    },
    setDebug: function setDebug(debug) {
        this.debug = debug;
    },
    queue: function queue(data) {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee() {
            var chunk, payload, client, attributes;
            return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        if (_this.config.enableReactUFOTracker) (0, $1mFjE.addBrowserMetricEvent)(data);
                        if (_this.config.configChunk) {
                            _context.next = 4;
                            break;
                        }
                        // eslint-disable-next-line no-console
                        _this.debug && console.warn('Submitter is not configured');
                        return _context.abrupt("return", null);
                    case 4:
                        _context.next = 6;
                        return _this.config.configChunk;
                    case 6:
                        chunk = _context.sent;
                        _context.next = 9;
                        return (0, $c0VuO.eventDataProcessor)(chunk[data.config.type], data);
                    case 9:
                        payload = _context.sent;
                        if (!(payload === null)) {
                            _context.next = 12;
                            break;
                        }
                        return _context.abrupt("return");
                    case 12:
                        if (!(_this.config.gasv3 !== undefined)) {
                            _context.next = 18;
                            break;
                        }
                        _context.next = 15;
                        return _this.config.gasv3;
                    case 15:
                        client = _context.sent;
                        attributes = {
                            task: payload['event:key'],
                            properties: payload
                        };
                        client && client.sendOperationalEvent({
                            actionSubject: 'performance',
                            attributes: attributes,
                            source: 'performance',
                            action: 'measured'
                        });
                    case 18:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }))();
    }
};

});
parcelRegister("1mFjE", function(module, exports) {

$parcel$export(module.exports, "addBrowserMetricEvent", function () { return $0fe7e506e20c7bdd$export$4a759336b50e86e3; });

var $2R76C = parcelRequire("2R76C");

var $5YM7L = parcelRequire("5YM7L");

var $dsN6L = parcelRequire("dsN6L");

var $iqLBO = parcelRequire("iqLBO");

var $eWMMH = parcelRequire("eWMMH");

var $8giud = parcelRequire("8giud");

var $k9NOh = parcelRequire("k9NOh");

var $h6MYR = parcelRequire("h6MYR");

var $kQsKx = parcelRequire("kQsKx");

var $gxkd1 = parcelRequire("gxkd1");

var $9TLEj = parcelRequire("9TLEj");

var $6jqx3 = parcelRequire("6jqx3");

var $5Dj3P = parcelRequire("5Dj3P");

var $2xQTd = parcelRequire("2xQTd");

var $82q7C = parcelRequire("82q7C");

var $ifECG = parcelRequire("ifECG");
function $0fe7e506e20c7bdd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0fe7e506e20c7bdd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0fe7e506e20c7bdd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0fe7e506e20c7bdd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0fe7e506e20c7bdd$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $0fe7e506e20c7bdd$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $0fe7e506e20c7bdd$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $0fe7e506e20c7bdd$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $0fe7e506e20c7bdd$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $0fe7e506e20c7bdd$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $0fe7e506e20c7bdd$var$PreviousInteractionLog = {
    name: undefined,
    isAborted: undefined
};
var $0fe7e506e20c7bdd$export$d8f52e8f804021e8 = new (0, $ifECG.default)();
var $0fe7e506e20c7bdd$var$interactionQueue = [];
var $0fe7e506e20c7bdd$var$segmentCache = new Map();
var $0fe7e506e20c7bdd$var$CLEANUP_TIMEOUT = 60000;
var $0fe7e506e20c7bdd$var$CLEANUP_TIMEOUT_AFTER_APDEX = 15000;
var $0fe7e506e20c7bdd$var$segmentObservers = [];
var $0fe7e506e20c7bdd$export$2b3954d2e8509985 = (0, $5Dj3P.withProfiling)(function getActiveInteraction() {
    var interactionId = (0, $6jqx3.getInteractionId)();
    if (!interactionId.current) return;
    return (0, $82q7C.interactions).get(interactionId.current);
});
var $0fe7e506e20c7bdd$var$isPerformanceTracingEnabled = (0, $5Dj3P.withProfiling)(function isPerformanceTracingEnabled() {
    var _getConfig;
    return ((_getConfig = (0, $h6MYR.getConfig)()) === null || _getConfig === void 0 ? void 0 : _getConfig.enableAdditionalPerformanceMarks) || window.__REACT_UFO_ENABLE_PERF_TRACING || false;
});
var $0fe7e506e20c7bdd$var$labelStackToString = (0, $5Dj3P.withProfiling)(function labelStackToString(labelStack, name) {
    var _stack$map;
    var stack = (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(labelStack !== null && labelStack !== void 0 ? labelStack : []);
    if (name) stack.push({
        name: name
    });
    return (_stack$map = stack.map(function(l) {
        return l.name;
    })) === null || _stack$map === void 0 ? void 0 : _stack$map.join('/');
});
var $0fe7e506e20c7bdd$var$labelStackToIdString = (0, $5Dj3P.withProfiling)(function labelStackToIdString(labelStack) {
    var _labelStack$map;
    return labelStack === null || labelStack === void 0 || (_labelStack$map = labelStack.map(function(l) {
        return 'segmentId' in l ? "".concat(l.name, ":").concat(l.segmentId) : "".concat(l.name);
    })) === null || _labelStack$map === void 0 ? void 0 : _labelStack$map.join('/');
});
var $0fe7e506e20c7bdd$var$addSegmentObserver = (0, $5Dj3P.withProfiling)(function addSegmentObserver(observer) {
    $0fe7e506e20c7bdd$var$segmentObservers.push(observer);
    var _iterator = $0fe7e506e20c7bdd$var$_createForOfIteratorHelper($0fe7e506e20c7bdd$var$segmentCache.values()), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var segmentInfo = _step.value;
            observer.onAdd(segmentInfo);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
});
var $0fe7e506e20c7bdd$var$removeSegmentObserver = (0, $5Dj3P.withProfiling)(function removeSegmentObserver(observer) {
    var index = $0fe7e506e20c7bdd$var$segmentObservers.findIndex(function(obs) {
        return obs === observer;
    });
    if (index !== -1) $0fe7e506e20c7bdd$var$segmentObservers.splice(index, 1);
});
var $0fe7e506e20c7bdd$export$cd7f480d6b8286c3 = (0, $5Dj3P.withProfiling)(function remove(interactionId) {
    (0, $82q7C.interactions).delete(interactionId);
});
var $0fe7e506e20c7bdd$export$f6f1cf5bedf83c71 = (0, $5Dj3P.withProfiling)(function updatePageLoadInteractionName(ufoName) {
    var routeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ufoName;
    var interaction = $0fe7e506e20c7bdd$export$2b3954d2e8509985();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
});
var $0fe7e506e20c7bdd$export$12f2b6cb85d59904 = (0, $5Dj3P.withProfiling)(function addMetadata(interactionId, data) {
    var interaction = (0, $82q7C.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach(function(key) {
        interaction.metaData[key] = data[key];
    });
});
var $0fe7e506e20c7bdd$export$e4380431c2bdabee = (0, $5Dj3P.withProfiling)(function addCustomData(interactionId, labelStack, data) {
    var interaction = (0, $82q7C.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach(function(i) {
        interaction.customData.push({
            labelStack: labelStack,
            data: (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, i, data[i])
        });
    });
});
var $0fe7e506e20c7bdd$export$27cacb7d7f3fe20a = (0, $5Dj3P.withProfiling)(function addCustomTiming(interactionId, labelStack, data) {
    var interaction = (0, $82q7C.interactions).get(interactionId);
    if (interaction != null) {
        interaction.customTimings.push({
            labelStack: labelStack,
            data: data
        });
        if ($0fe7e506e20c7bdd$var$isPerformanceTracingEnabled()) for(var _i = 0, _Object$entries = Object.entries(data); _i < _Object$entries.length; _i++){
            var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], timingData = _Object$entries$_i[1];
            var startTime = timingData.startTime, endTime = timingData.endTime;
            try {
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat($0fe7e506e20c7bdd$var$labelStackToString(labelStack, key), " [custom_timing]"), {
                    start: startTime,
                    end: endTime
                });
            } catch (e) {
            // do nothing
            }
        }
    }
});
var $0fe7e506e20c7bdd$export$728e28c22a0fba4 = (0, $5Dj3P.withProfiling)(function addMark(interactionId, type, name, labelStack) {
    var time = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : performance.now();
    var interaction = (0, $82q7C.interactions).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
    if ($0fe7e506e20c7bdd$var$isPerformanceTracingEnabled()) performance.mark("\uD83D\uDEF8 ".concat($0fe7e506e20c7bdd$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
        startTime: time
    });
});
var $0fe7e506e20c7bdd$export$c4b23cc624bd2fb = (0, $5Dj3P.withProfiling)(function addMarkToAll(type, name, labelStack) {
    var time = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : performance.now();
    (0, $82q7C.interactions).forEach(function(interaction) {
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
    if ($0fe7e506e20c7bdd$var$isPerformanceTracingEnabled()) performance.mark("\uD83D\uDEF8 ".concat($0fe7e506e20c7bdd$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
        startTime: time
    });
});
var $0fe7e506e20c7bdd$export$2c1d6e17cfa9bbc7 = (0, $5Dj3P.withProfiling)(function addSpan(interactionId, type, name, labelStack, start) {
    var end = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : performance.now();
    var size = arguments.length > 6 ? arguments[6] : undefined;
    var interaction = (0, $82q7C.interactions).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        if ($0fe7e506e20c7bdd$var$isPerformanceTracingEnabled()) try {
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat($0fe7e506e20c7bdd$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
                start: start,
                end: end
            });
        } catch (e) {
        // do nothing
        }
    }
});
var $0fe7e506e20c7bdd$export$943a8b2b5d6b1809 = (0, $5Dj3P.withProfiling)(function addSpanToAll(type, name, labelStack, start) {
    var end = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : performance.now();
    var size = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    (0, $82q7C.interactions).forEach(function(interaction) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    if ($0fe7e506e20c7bdd$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 ".concat($0fe7e506e20c7bdd$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
            start: start,
            end: end
        });
    } catch (e) {
    // do nothing
    }
});
var $0fe7e506e20c7bdd$export$9e04fe1a58571ec = (0, $5Dj3P.withProfiling)(function addPreload(moduleId, timestamp) {
    $0fe7e506e20c7bdd$export$c4b23cc624bd2fb('bundle_preload', moduleId, null, timestamp);
});
var $0fe7e506e20c7bdd$export$6f228d1fdc911d7 = (0, $5Dj3P.withProfiling)(function addLoad(identifier, start, end) {
    $0fe7e506e20c7bdd$export$943a8b2b5d6b1809('bundle_load', identifier, null, start, end - start);
});
var $0fe7e506e20c7bdd$var$moduleLoadingRequests = {};
var $0fe7e506e20c7bdd$export$f5a8f10de74904da = (0, $5Dj3P.withProfiling)(function extractModuleName(input) {
    var result = input !== null && input !== void 0 ? input : '';
    result = result.replace(/^\.\/src\/packages\//, '');
    result = result.replace(/^\.\/node_modules\//, '');
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, '');
    return result;
});
var $0fe7e506e20c7bdd$var$addHoldCriterion = (0, $5Dj3P.withProfiling)(function addHoldCriterion(id, labelStack, name, startTime) {
    var _window$__CRITERION__;
    if (!((_window$__CRITERION__ = window.__CRITERION__) !== null && _window$__CRITERION__ !== void 0 && _window$__CRITERION__.addUFOHold)) return;
    window.__CRITERION__.addUFOHold(id, $0fe7e506e20c7bdd$var$labelStackToString(labelStack), name, startTime);
});
var $0fe7e506e20c7bdd$var$removeHoldCriterion = (0, $5Dj3P.withProfiling)(function removeHoldCriterion(id) {
    var _window$__CRITERION__2;
    if (!((_window$__CRITERION__2 = window.__CRITERION__) !== null && _window$__CRITERION__2 !== void 0 && _window$__CRITERION__2.removeUFOHold)) return;
    window.__CRITERION__.removeUFOHold(id);
});
var $0fe7e506e20c7bdd$export$7606887303596f82 = (0, $5Dj3P.withProfiling)(function addHold(interactionId, labelStack, name, experimental) {
    var interaction = (0, $82q7C.interactions).get(interactionId);
    var id = (0, $8giud.v4)();
    if (interaction != null) {
        var _getConfig2;
        var start = performance.now();
        var holdActive = {
            labelStack: labelStack,
            name: name,
            start: start
        };
        if ((_getConfig2 = (0, $h6MYR.getConfig)()) !== null && _getConfig2 !== void 0 && (_getConfig2 = _getConfig2.experimentalInteractionMetrics) !== null && _getConfig2 !== void 0 && _getConfig2.enabled && experimental) interaction.holdExpActive.set(id, $0fe7e506e20c7bdd$var$_objectSpread($0fe7e506e20c7bdd$var$_objectSpread({}, holdActive), {}, {
            start: start
        }));
        if (!experimental) interaction.holdActive.set(id, $0fe7e506e20c7bdd$var$_objectSpread($0fe7e506e20c7bdd$var$_objectSpread({}, holdActive), {}, {
            start: start
        }));
        $0fe7e506e20c7bdd$var$addHoldCriterion(id, labelStack, name, start);
        return function() {
            var end = performance.now();
            if ($0fe7e506e20c7bdd$var$isPerformanceTracingEnabled()) try {
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat($0fe7e506e20c7bdd$var$labelStackToString(labelStack, name), " [hold]"), {
                    start: start,
                    end: end
                });
            } catch (e) {
            // do nothing
            }
            $0fe7e506e20c7bdd$var$removeHoldCriterion(id);
            var currentInteraction = (0, $82q7C.interactions).get(interactionId);
            var currentHold = interaction.holdActive.get(id);
            var expHold = interaction.holdExpActive.get(id);
            if (currentInteraction != null) {
                if (currentHold != null) {
                    currentInteraction.holdInfo.push($0fe7e506e20c7bdd$var$_objectSpread($0fe7e506e20c7bdd$var$_objectSpread({}, currentHold), {}, {
                        end: end
                    }));
                    interaction.holdActive.delete(id);
                }
                if (expHold != null) {
                    currentInteraction.holdExpInfo.push($0fe7e506e20c7bdd$var$_objectSpread($0fe7e506e20c7bdd$var$_objectSpread({}, expHold), {}, {
                        end: end
                    }));
                    interaction.holdExpActive.delete(id);
                }
            }
        };
    }
    return function() {};
});
var $0fe7e506e20c7bdd$export$10582acd678c213 = (0, $5Dj3P.withProfiling)(function addHoldByID(interactionId, labelStack, name, id, ignoreOnSubmit) {
    var interaction = (0, $82q7C.interactions).get(interactionId);
    if (interaction != null) {
        var start = performance.now();
        interaction.holdActive.set(id, {
            labelStack: labelStack,
            name: name,
            start: start,
            ignoreOnSubmit: ignoreOnSubmit
        });
        $0fe7e506e20c7bdd$var$addHoldCriterion(id, labelStack, name, start);
    }
    return function() {};
});
var $0fe7e506e20c7bdd$export$4983dfbbb996f7ae = (0, $5Dj3P.withProfiling)(function removeHoldByID(interactionId, id) {
    var interaction = (0, $82q7C.interactions).get(interactionId);
    if (interaction != null) {
        var end = performance.now();
        var currentInteraction = (0, $82q7C.interactions).get(interactionId);
        var currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            currentInteraction.holdInfo.push($0fe7e506e20c7bdd$var$_objectSpread($0fe7e506e20c7bdd$var$_objectSpread({}, currentHold), {}, {
                end: end
            }));
            interaction.holdActive.delete(id);
            $0fe7e506e20c7bdd$var$removeHoldCriterion(id);
        }
    }
});
var $0fe7e506e20c7bdd$export$2df109852219d16e = (0, $5Dj3P.withProfiling)(function getCurrentInteractionType(interactionId) {
    var interaction = (0, $82q7C.interactions).get(interactionId);
    if (interaction) return interaction.type;
    return null;
});
var $0fe7e506e20c7bdd$export$9591b52b33ccc510 = {
    onPreload: (0, $5Dj3P.withProfiling)(function onPreload(moduleId, _priority) {
        $0fe7e506e20c7bdd$export$9e04fe1a58571ec($0fe7e506e20c7bdd$export$f5a8f10de74904da(moduleId), performance.now());
    }),
    onLoadStart: (0, $5Dj3P.withProfiling)(function onLoadStart(info) {
        var timeoutId = setTimeout(function() {
            delete $0fe7e506e20c7bdd$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        var request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $0fe7e506e20c7bdd$var$moduleLoadingRequests[info.identifier] = request;
    }),
    onLoadComplete: (0, $5Dj3P.withProfiling)(function onLoadComplete(info) {
        var request = $0fe7e506e20c7bdd$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $0fe7e506e20c7bdd$var$moduleLoadingRequests[info.identifier];
            $0fe7e506e20c7bdd$export$6f228d1fdc911d7($0fe7e506e20c7bdd$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    }),
    placeholderFallBackMounted: (0, $5Dj3P.withProfiling)(function placeholderFallBackMounted(id, moduleId) {
        var interactionId = (0, $6jqx3.getInteractionId)();
        var currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $0fe7e506e20c7bdd$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    }),
    placeholderFallBackUnmounted: (0, $5Dj3P.withProfiling)(function placeholderFallBackUnmounted(id) {
        var interactionId = (0, $6jqx3.getInteractionId)();
        var currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $0fe7e506e20c7bdd$export$4983dfbbb996f7ae(currentInteractionId, id);
    })
};
var $0fe7e506e20c7bdd$export$239c33984d9b1367 = (0, $5Dj3P.withProfiling)(function addError(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError) {
    var interaction = (0, $82q7C.interactions).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError
    });
});
var $0fe7e506e20c7bdd$export$7379c15afd3840fa = (0, $5Dj3P.withProfiling)(function addErrorToAll(name, labelStack, errorType, errorMessage, errorStack) {
    (0, $82q7C.interactions).forEach(function(interaction) {
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack
        });
    });
});
var $0fe7e506e20c7bdd$export$53d6f611de951a13 = (0, $5Dj3P.withProfiling)(function addProfilerTimings(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    var _getConfig3;
    if ($0fe7e506e20c7bdd$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 ".concat($0fe7e506e20c7bdd$var$labelStackToString(labelStack), " [react-profiler] ").concat(type), {
            start: startTime,
            duration: actualDuration
        });
    } catch (e) {
    // do nothing
    }
    var interaction = (0, $82q7C.interactions).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
    else if ((_getConfig3 = (0, $h6MYR.getConfig)()) !== null && _getConfig3 !== void 0 && (_getConfig3 = _getConfig3.postInteractionLog) !== null && _getConfig3 !== void 0 && _getConfig3.enabled) $0fe7e506e20c7bdd$export$d8f52e8f804021e8.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
});
var $0fe7e506e20c7bdd$var$pushToQueue = (0, $5Dj3P.withProfiling)(function pushToQueue(id, data) {
    $0fe7e506e20c7bdd$var$interactionQueue.push({
        id: id,
        data: data
    });
});
var $0fe7e506e20c7bdd$var$handleInteraction = $0fe7e506e20c7bdd$var$pushToQueue;
var $0fe7e506e20c7bdd$var$callCleanUpCallbacks = (0, $5Dj3P.withProfiling)(function callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach(function(cleanUpCallback) {
        cleanUpCallback();
    });
});
var $0fe7e506e20c7bdd$var$finishInteraction = (0, $5Dj3P.withProfiling)(function finishInteraction(id, data) {
    var _getConfig4, _getConfig5;
    var endTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    data.end = endTime;
    try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 [".concat(data.type, "] ").concat(data.ufoName, " [ttai]"), {
            start: data.start,
            end: data.end
        });
    } catch (e) {
    // do nothing
    }
    if (data.featureFlags) data.featureFlags.during = Object.fromEntries((0, $9TLEj.currentFeatureFlagsAccessed));
    (0, $gxkd1.clearActiveTrace)();
    $0fe7e506e20c7bdd$var$callCleanUpCallbacks(data);
    if ((_getConfig4 = (0, $h6MYR.getConfig)()) !== null && _getConfig4 !== void 0 && (_getConfig4 = _getConfig4.vc) !== null && _getConfig4 !== void 0 && _getConfig4.stopVCAtInteractionFinish) data.vc = (0, $2xQTd.getVCObserver)().getVCRawData();
    if (!((_getConfig5 = (0, $h6MYR.getConfig)()) !== null && _getConfig5 !== void 0 && (_getConfig5 = _getConfig5.experimentalInteractionMetrics) !== null && _getConfig5 !== void 0 && _getConfig5.enabled)) $0fe7e506e20c7bdd$export$cd7f480d6b8286c3(id);
    $0fe7e506e20c7bdd$var$PreviousInteractionLog.name = data.ufoName || 'unknown';
    $0fe7e506e20c7bdd$var$PreviousInteractionLog.isAborted = data.abortReason != null;
    if (data.ufoName) $0fe7e506e20c7bdd$var$handleInteraction(id, data);
    if ($0fe7e506e20c7bdd$var$isPerformanceTracingEnabled()) {
        var profilerTimingMap = new Map();
        data.reactProfilerTimings.forEach(function(profilerTiming) {
            var labelStackId = $0fe7e506e20c7bdd$var$labelStackToIdString(profilerTiming.labelStack);
            if (labelStackId) {
                var _profilerTimingMap$ge, _timing$start, _timing$end;
                var timing = (_profilerTimingMap$ge = profilerTimingMap.get(labelStackId)) !== null && _profilerTimingMap$ge !== void 0 ? _profilerTimingMap$ge : {
                    labelStack: profilerTiming.labelStack
                };
                timing.start = profilerTiming.startTime < ((_timing$start = timing.start) !== null && _timing$start !== void 0 ? _timing$start : Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                timing.end = profilerTiming.commitTime > ((_timing$end = timing.end) !== null && _timing$end !== void 0 ? _timing$end : Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                profilerTimingMap.set(labelStackId, timing);
            }
        });
        try {
            // for Firefox 102 and older
            var _iterator2 = $0fe7e506e20c7bdd$var$_createForOfIteratorHelper(profilerTimingMap.entries()), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _step2$value = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_step2.value, 2), _step2$value$ = _step2$value[1], labelStack = _step2$value$.labelStack, start = _step2$value$.start, end = _step2$value$.end;
                    performance.measure("\uD83D\uDEF8 ".concat($0fe7e506e20c7bdd$var$labelStackToString(labelStack), " [segment_ttai]"), {
                        start: start,
                        end: end
                    });
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        } catch (e) {
        // do nothing
        }
    }
    try {
        // dispatch a global window event to notify the measure is completed
        window.dispatchEvent(new CustomEvent('UFO_FINISH_INTERACTION', {
            detail: data
        }));
    } catch (error) {
    // do nothing
    }
});
var $0fe7e506e20c7bdd$export$9e614a29a1ac213e = (0, $5Dj3P.withProfiling)(function sinkInteractionHandler(sinkFn) {
    if ($0fe7e506e20c7bdd$var$handleInteraction === $0fe7e506e20c7bdd$var$pushToQueue) {
        $0fe7e506e20c7bdd$var$handleInteraction = sinkFn;
        $0fe7e506e20c7bdd$var$interactionQueue.forEach(function(interaction) {
            sinkFn(interaction.id, interaction.data);
        });
        $0fe7e506e20c7bdd$var$interactionQueue.length = 0;
    }
});
var $0fe7e506e20c7bdd$export$8a1ba7bef607358a = (0, $5Dj3P.withProfiling)(function sinkPostInteractionLogHandler(sinkFn) {
    $0fe7e506e20c7bdd$export$d8f52e8f804021e8.sinkHandler(sinkFn);
});
// a flag to prevent multiple submitting
var $0fe7e506e20c7bdd$var$activeSubmitted = false;
var $0fe7e506e20c7bdd$export$673be905888f8839 = (0, $5Dj3P.withProfiling)(function tryComplete(interactionId, endTime) {
    var interaction = (0, $82q7C.interactions).get(interactionId);
    if (interaction != null) {
        var noMoreActiveHolds = interaction.holdActive.size === 0;
        var noMoreExpHolds = interaction.holdExpActive.size === 0;
        var postInteraction = /*#__PURE__*/ function() {
            var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee() {
                var _getConfig6, _getConfig8;
                var _getConfig7, experimentalVC90, experimentalTTAI, _yield$getExperimenta, start, end;
                return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (!((_getConfig6 = (0, $h6MYR.getConfig)()) !== null && _getConfig6 !== void 0 && (_getConfig6 = _getConfig6.postInteractionLog) !== null && _getConfig6 !== void 0 && _getConfig6.enabled)) {
                                _context.next = 17;
                                break;
                            }
                            if (!((_getConfig7 = (0, $h6MYR.getConfig)()) !== null && _getConfig7 !== void 0 && (_getConfig7 = _getConfig7.experimentalInteractionMetrics) !== null && _getConfig7 !== void 0 && _getConfig7.enabled)) {
                                _context.next = 16;
                                break;
                            }
                            _context.next = 4;
                            return (0, $kQsKx.getExperimentalVCMetrics)(interaction);
                        case 4:
                            _context.t1 = _yield$getExperimenta = _context.sent;
                            _context.t0 = _context.t1 === null;
                            if (_context.t0) {
                                _context.next = 8;
                                break;
                            }
                            _context.t0 = _yield$getExperimenta === void 0;
                        case 8:
                            if (!_context.t0) {
                                _context.next = 12;
                                break;
                            }
                            _context.t2 = void 0;
                            _context.next = 13;
                            break;
                        case 12:
                            _context.t2 = _yield$getExperimenta['metric:experimental:vc90'];
                        case 13:
                            experimentalVC90 = _context.t2;
                            start = interaction.start, end = interaction.end;
                            experimentalTTAI = !interaction.abortReason ? Math.round(end - start) : undefined;
                        case 16:
                            $0fe7e506e20c7bdd$export$d8f52e8f804021e8.onInteractionComplete($0fe7e506e20c7bdd$var$_objectSpread($0fe7e506e20c7bdd$var$_objectSpread({}, interaction), {}, {
                                experimentalTTAI: experimentalTTAI,
                                experimentalVC90: experimentalVC90
                            }));
                        case 17:
                            if ((_getConfig8 = (0, $h6MYR.getConfig)()) !== null && _getConfig8 !== void 0 && (_getConfig8 = _getConfig8.experimentalInteractionMetrics) !== null && _getConfig8 !== void 0 && _getConfig8.enabled) $0fe7e506e20c7bdd$export$cd7f480d6b8286c3(interactionId);
                            $0fe7e506e20c7bdd$var$activeSubmitted = false;
                        case 19:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function postInteraction() {
                return _ref.apply(this, arguments);
            };
        }();
        if (noMoreActiveHolds) {
            if (!$0fe7e506e20c7bdd$var$activeSubmitted) {
                $0fe7e506e20c7bdd$var$finishInteraction(interactionId, interaction, endTime);
                $0fe7e506e20c7bdd$var$activeSubmitted = true;
            }
            if (noMoreExpHolds) {
                var _getConfig9;
                if ((_getConfig9 = (0, $h6MYR.getConfig)()) !== null && _getConfig9 !== void 0 && (_getConfig9 = _getConfig9.experimentalInteractionMetrics) !== null && _getConfig9 !== void 0 && _getConfig9.enabled) (0, $kQsKx.onExperimentalInteractionComplete)(interactionId, interaction, endTime);
                postInteraction();
            }
        }
    }
});
var $0fe7e506e20c7bdd$var$callCancelCallbacks = (0, $5Dj3P.withProfiling)(function callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach(function(cancelCallback) {
        cancelCallback();
    });
});
var $0fe7e506e20c7bdd$export$5def58af4fd46132 = (0, $5Dj3P.withProfiling)(function abort(interactionId, abortReason) {
    var interaction = (0, $82q7C.interactions).get(interactionId);
    if (interaction != null) {
        var _getConfig10;
        $0fe7e506e20c7bdd$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $0fe7e506e20c7bdd$var$finishInteraction(interactionId, interaction);
        if ((_getConfig10 = (0, $h6MYR.getConfig)()) !== null && _getConfig10 !== void 0 && (_getConfig10 = _getConfig10.experimentalInteractionMetrics) !== null && _getConfig10 !== void 0 && _getConfig10.enabled) {
            (0, $kQsKx.onExperimentalInteractionComplete)(interactionId, interaction);
            $0fe7e506e20c7bdd$export$cd7f480d6b8286c3(interactionId);
        }
    }
});
var $0fe7e506e20c7bdd$export$c4a545284f55edf2 = (0, $5Dj3P.withProfiling)(function abortByNewInteraction(interactionId, interactionName) {
    var interaction = (0, $82q7C.interactions).get(interactionId);
    if (interaction != null) {
        var _getConfig11;
        $0fe7e506e20c7bdd$var$callCancelCallbacks(interaction);
        interaction.abortReason = 'new_interaction';
        interaction.abortedByInteractionName = interactionName;
        $0fe7e506e20c7bdd$var$finishInteraction(interactionId, interaction);
        if ((_getConfig11 = (0, $h6MYR.getConfig)()) !== null && _getConfig11 !== void 0 && (_getConfig11 = _getConfig11.experimentalInteractionMetrics) !== null && _getConfig11 !== void 0 && _getConfig11.enabled) {
            (0, $kQsKx.onExperimentalInteractionComplete)(interactionId, interaction);
            $0fe7e506e20c7bdd$export$cd7f480d6b8286c3(interactionId);
        }
    }
});
var $0fe7e506e20c7bdd$export$614a7af2affc5dff = (0, $5Dj3P.withProfiling)(function abortAll(abortReason, abortedByInteractionName) {
    (0, $82q7C.interactions).forEach(function(interaction, interactionId) {
        var _getConfig12;
        var noMoreHolds = interaction.holdActive.size === 0;
        if (!noMoreHolds) {
            $0fe7e506e20c7bdd$var$callCancelCallbacks(interaction);
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) interaction.abortedByInteractionName = abortedByInteractionName;
        }
        $0fe7e506e20c7bdd$var$finishInteraction(interactionId, interaction);
        if ((_getConfig12 = (0, $h6MYR.getConfig)()) !== null && _getConfig12 !== void 0 && (_getConfig12 = _getConfig12.experimentalInteractionMetrics) !== null && _getConfig12 !== void 0 && _getConfig12.enabled) {
            (0, $kQsKx.onExperimentalInteractionComplete)(interactionId, interaction);
            $0fe7e506e20c7bdd$export$cd7f480d6b8286c3(interactionId);
        }
    });
});
var $0fe7e506e20c7bdd$export$7b9261a96cfe427b = (0, $5Dj3P.withProfiling)(function addOnCancelCallback(id, cancelCallback) {
    var interaction = (0, $82q7C.interactions).get(id);
    interaction === null || interaction === void 0 || interaction.cancelCallbacks.push(cancelCallback);
});
var $0fe7e506e20c7bdd$export$1a1ed1e1fdb2006b = (0, $5Dj3P.withProfiling)(function addNewInteraction(interactionId, ufoName, type, startTime, rate, labelStack, routeName) {
    var _getConfig13;
    var trace = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
    if ((_getConfig13 = (0, $h6MYR.getConfig)()) !== null && _getConfig13 !== void 0 && (_getConfig13 = _getConfig13.postInteractionLog) !== null && _getConfig13 !== void 0 && _getConfig13.enabled) $0fe7e506e20c7bdd$export$d8f52e8f804021e8.reset();
    var previousTime = startTime;
    var timeoutTime = $0fe7e506e20c7bdd$var$CLEANUP_TIMEOUT;
    var timerID = setTimeout(function() {
        $0fe7e506e20c7bdd$export$5def58af4fd46132(interactionId, 'timeout');
    }, $0fe7e506e20c7bdd$var$CLEANUP_TIMEOUT);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        var currentTime = performance.now();
        var timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        var newTimerID = setTimeout(function() {
            $0fe7e506e20c7bdd$export$5def58af4fd46132(interactionId, 'timeout');
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    var addFeatureFlagsToInteraction = (0, $k9NOh.default)((0, $h6MYR.getCapabilityRate)('feature_flag_access'));
    var metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        type: type,
        previousInteractionName: $0fe7e506e20c7bdd$var$PreviousInteractionLog.name,
        isPreviousInteractionAborted: $0fe7e506e20c7bdd$var$PreviousInteractionLog.isAborted === true,
        marks: [],
        customData: [],
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdExpInfo: [],
        holdActive: new Map(),
        holdExpActive: new Map(),
        // measure when we execute this code
        // from this, we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName !== null && routeName !== void 0 ? routeName : ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: Object.fromEntries((0, $9TLEj.allFeatureFlagsAccessed)),
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace
    };
    if (addFeatureFlagsToInteraction) (0, $9TLEj.currentFeatureFlagsAccessed).clear();
    (0, $82q7C.interactions).set(interactionId, metrics);
    var segmentObserver = {
        onAdd: function onAdd(segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove: function onRemove() {}
    };
    $0fe7e506e20c7bdd$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(function() {
        $0fe7e506e20c7bdd$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(function() {
        clearTimeout(metrics.timerID);
    });
    var awaitBM3TTIList = (0, $h6MYR.getAwaitBM3TTIList)();
    if (awaitBM3TTIList.includes(ufoName)) $0fe7e506e20c7bdd$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
    if (type === 'transition') {
        var _getConfig14;
        (0, $2xQTd.getVCObserver)().start({
            startTime: startTime
        });
        $0fe7e506e20c7bdd$export$d8f52e8f804021e8.startVCObserver({
            startTime: startTime
        });
        if ((_getConfig14 = (0, $h6MYR.getConfig)()) !== null && _getConfig14 !== void 0 && (_getConfig14 = _getConfig14.experimentalInteractionMetrics) !== null && _getConfig14 !== void 0 && _getConfig14.enabled) (0, $kQsKx.experimentalVC).start({
            startTime: startTime
        });
    }
});
var $0fe7e506e20c7bdd$export$4a759336b50e86e3 = (0, $5Dj3P.withProfiling)(function addBrowserMetricEvent(event) {
    var interaction = $0fe7e506e20c7bdd$export$2b3954d2e8509985();
    if (interaction) {
        var _event$config;
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === 'page_load' || interaction.type === 'transition') && ((_event$config = event.config) === null || _event$config === void 0 ? void 0 : _event$config.type) === 'PAGE_LOAD') {
            interaction.changeTimeout($0fe7e506e20c7bdd$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $0fe7e506e20c7bdd$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
        }
    }
});
var $0fe7e506e20c7bdd$export$ad216cc25852d44b = (0, $5Dj3P.withProfiling)(function addApdexToAll(apdex) {
    (0, $82q7C.interactions).forEach(function(interaction, key) {
        interaction.apdex.push(apdex);
        try {
            var _apdex$startTime;
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat(apdex.key, " [bm3_tti]"), {
                start: (_apdex$startTime = apdex.startTime) !== null && _apdex$startTime !== void 0 ? _apdex$startTime : interaction.start,
                end: apdex.stopTime
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') {
            interaction.changeTimeout($0fe7e506e20c7bdd$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $0fe7e506e20c7bdd$export$4983dfbbb996f7ae(key, interaction.ufoName);
        }
    });
});
var $0fe7e506e20c7bdd$export$35220fd6cdd1b731 = (0, $5Dj3P.withProfiling)(function addApdex(interactionId, apdexInfo) {
    var interaction = (0, $82q7C.interactions).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            var _apdexInfo$startTime;
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat(apdexInfo.key, " [bm3_tti]"), {
                start: (_apdexInfo$startTime = apdexInfo.startTime) !== null && _apdexInfo$startTime !== void 0 ? _apdexInfo$startTime : interaction.start,
                end: apdexInfo.stopTime
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') {
            interaction.changeTimeout($0fe7e506e20c7bdd$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $0fe7e506e20c7bdd$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
        }
    }
});
var $0fe7e506e20c7bdd$export$57d55b4569823d8f = (0, $5Dj3P.withProfiling)(function addRequestInfo(interactionId, labelStack, requestInfo) {
    var interaction = (0, $82q7C.interactions).get(interactionId);
    if (interaction != null) interaction.requestInfo.push($0fe7e506e20c7bdd$var$_objectSpread({
        labelStack: labelStack
    }, requestInfo));
});
var $0fe7e506e20c7bdd$var$isSegmentLabel = (0, $5Dj3P.withProfiling)(function isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
});
var $0fe7e506e20c7bdd$var$getSegmentCacheKey = (0, $5Dj3P.withProfiling)(function getSegmentCacheKey(labelStack) {
    return labelStack.map(function(l) {
        if ($0fe7e506e20c7bdd$var$isSegmentLabel(l)) return "".concat(l.name, "_").concat(l.segmentId);
        return l.name;
    }).join('|');
});
var $0fe7e506e20c7bdd$export$1c43f9ac826b6462 = (0, $5Dj3P.withProfiling)(function addSegment(labelStack) {
    var key = $0fe7e506e20c7bdd$var$getSegmentCacheKey(labelStack);
    var existingSegment = $0fe7e506e20c7bdd$var$segmentCache.get(key);
    if (!existingSegment) {
        var segmentInfo = {
            labelStack: labelStack
        };
        $0fe7e506e20c7bdd$var$segmentCache.set(key, segmentInfo);
        $0fe7e506e20c7bdd$var$segmentObservers.forEach(function(observer) {
            observer.onAdd(segmentInfo);
        });
    }
});
var $0fe7e506e20c7bdd$export$d0365e48b58231c3 = (0, $5Dj3P.withProfiling)(function removeSegment(labelStack) {
    var key = $0fe7e506e20c7bdd$var$getSegmentCacheKey(labelStack);
    var segmentInfo = $0fe7e506e20c7bdd$var$segmentCache.get(key);
    if (segmentInfo) {
        $0fe7e506e20c7bdd$var$segmentCache.delete(JSON.stringify(labelStack));
        $0fe7e506e20c7bdd$var$segmentObservers.forEach(function(observer) {
            observer.onRemove(segmentInfo);
        });
    }
});
var $0fe7e506e20c7bdd$export$bbf14d79614d9818 = (0, $5Dj3P.withProfiling)(function addRedirect(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    var interaction = (0, $82q7C.interactions).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        if ($0fe7e506e20c7bdd$var$isPerformanceTracingEnabled()) {
            var prevRedirect = interaction.redirects.at(-2);
            try {
                var _prevRedirect$time;
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat(nextUfoName, " [redirect]"), {
                    start: (_prevRedirect$time = prevRedirect === null || prevRedirect === void 0 ? void 0 : prevRedirect.time) !== null && _prevRedirect$time !== void 0 ? _prevRedirect$time : interaction.start,
                    end: time
                });
            } catch (e) {
            // do nothing
            }
        }
    }
});
var $0fe7e506e20c7bdd$export$6ce04c7ca6810a7e = [];
var $0fe7e506e20c7bdd$var$defaultLabelStack = [
    {
        name: 'custom'
    }
];
var $0fe7e506e20c7bdd$export$5342dcad19138a1c = (0, $5Dj3P.withProfiling)(function addCustomSpans(name, start) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    var size = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var labelStack = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : $0fe7e506e20c7bdd$var$defaultLabelStack;
    var customSpan = {
        type: 'custom',
        name: name,
        start: start,
        end: end,
        labelStack: labelStack,
        size: size
    };
    $0fe7e506e20c7bdd$export$6ce04c7ca6810a7e.push(customSpan);
});

});
parcelRegister("8giud", function(module, exports) {

var $alSV4 = parcelRequire("alSV4");

var $kbWO6 = parcelRequire("kbWO6");
var $603e28612b77fbc5$var$uuid = $kbWO6;
$603e28612b77fbc5$var$uuid.v1 = $alSV4;
$603e28612b77fbc5$var$uuid.v4 = $kbWO6;
module.exports = $603e28612b77fbc5$var$uuid;

});
parcelRegister("alSV4", function(module, exports) {

var $dlG1y = parcelRequire("dlG1y");

var $VgMe7 = parcelRequire("VgMe7");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $7896776536f3cc2b$var$_nodeId;
var $7896776536f3cc2b$var$_clockseq;
// Previous uuid creation time
var $7896776536f3cc2b$var$_lastMSecs = 0;
var $7896776536f3cc2b$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $7896776536f3cc2b$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $7896776536f3cc2b$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $7896776536f3cc2b$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $dlG1y();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $7896776536f3cc2b$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $7896776536f3cc2b$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $7896776536f3cc2b$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $7896776536f3cc2b$var$_lastMSecs + (nsecs - $7896776536f3cc2b$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $7896776536f3cc2b$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $7896776536f3cc2b$var$_lastMSecs = msecs;
    $7896776536f3cc2b$var$_lastNSecs = nsecs;
    $7896776536f3cc2b$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $VgMe7(b);
}
module.exports = $7896776536f3cc2b$var$v1;

});


parcelRegister("k9NOh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eacb491de1a05b45$export$2e2bcd8739ae039; });

var $5Dj3P = parcelRequire("5Dj3P");
/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ var $eacb491de1a05b45$var$coinflip = (0, $5Dj3P.withProfiling)(function coinflip(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
});
var $eacb491de1a05b45$export$2e2bcd8739ae039 = $eacb491de1a05b45$var$coinflip;

});
parcelRegister("5Dj3P", function(module, exports) {

$parcel$export(module.exports, "withProfiling", function () { return $419f6151ed9b21d9$export$5fee8d7b32c0d54f; });
$parcel$export(module.exports, "markProfilingStart", function () { return $419f6151ed9b21d9$export$32aa818f3c5feabe; });
$parcel$export(module.exports, "markProfilingEnd", function () { return $419f6151ed9b21d9$export$293bccc5603149b4; });

var $dsN6L = parcelRequire("dsN6L");

var $2R76C = parcelRequire("2R76C");

var $eWMMH = parcelRequire("eWMMH");

var $f1k1y = parcelRequire("f1k1y");
function $419f6151ed9b21d9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $419f6151ed9b21d9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $419f6151ed9b21d9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $419f6151ed9b21d9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $419f6151ed9b21d9$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $419f6151ed9b21d9$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $419f6151ed9b21d9$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $419f6151ed9b21d9$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $419f6151ed9b21d9$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $419f6151ed9b21d9$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
globalThis.__ufo_self_measurements = globalThis.__ufo_self_measurements || {
    __internalState: {
        functionStack: []
    },
    runtime: {
        total: 0,
        async: 0,
        error: 0,
        byFunction: {},
        custom: {}
    }
};
function $419f6151ed9b21d9$export$a4a352ce60895de1() {
    globalThis.__ufo_self_measurements = {
        __internalState: {
            functionStack: []
        },
        runtime: {
            total: 0,
            async: 0,
            error: 0,
            byFunction: {},
            custom: {}
        }
    };
}
function $419f6151ed9b21d9$var$trackFunctionTimingStart(fnName) {
    var _globalThis$__ufo_sel;
    if (!(globalThis !== null && globalThis !== void 0 && globalThis.__ufo_self_measurements)) $419f6151ed9b21d9$export$a4a352ce60895de1();
    globalThis === null || globalThis === void 0 || (_globalThis$__ufo_sel = globalThis.__ufo_self_measurements) === null || _globalThis$__ufo_sel === void 0 || (_globalThis$__ufo_sel = _globalThis$__ufo_sel.__internalState) === null || _globalThis$__ufo_sel === void 0 || (_globalThis$__ufo_sel = _globalThis$__ufo_sel.functionStack) === null || _globalThis$__ufo_sel === void 0 || _globalThis$__ufo_sel.push(fnName);
}
function $419f6151ed9b21d9$var$trackFunctionTimingEnd() {
    var _globalThis$__ufo_sel2;
    if (!(globalThis !== null && globalThis !== void 0 && globalThis.__ufo_self_measurements)) $419f6151ed9b21d9$export$a4a352ce60895de1();
    globalThis === null || globalThis === void 0 || (_globalThis$__ufo_sel2 = globalThis.__ufo_self_measurements) === null || _globalThis$__ufo_sel2 === void 0 || (_globalThis$__ufo_sel2 = _globalThis$__ufo_sel2.__internalState) === null || _globalThis$__ufo_sel2 === void 0 || (_globalThis$__ufo_sel2 = _globalThis$__ufo_sel2.functionStack) === null || _globalThis$__ufo_sel2 === void 0 || _globalThis$__ufo_sel2.pop();
}
function $419f6151ed9b21d9$var$shouldRecordProfilerMeasurement() {
    var _globalThis$__ufo_sel3;
    if (!(globalThis !== null && globalThis !== void 0 && globalThis.__ufo_self_measurements)) $419f6151ed9b21d9$export$a4a352ce60895de1();
    return (globalThis === null || globalThis === void 0 || (_globalThis$__ufo_sel3 = globalThis.__ufo_self_measurements) === null || _globalThis$__ufo_sel3 === void 0 || (_globalThis$__ufo_sel3 = _globalThis$__ufo_sel3.__internalState) === null || _globalThis$__ufo_sel3 === void 0 || (_globalThis$__ufo_sel3 = _globalThis$__ufo_sel3.functionStack) === null || _globalThis$__ufo_sel3 === void 0 ? void 0 : _globalThis$__ufo_sel3.length) === 0;
}
function $419f6151ed9b21d9$var$recordProfilerMeasurement(functionName, duration, isAsync, isError) {
    var tags = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    // discard measurements that are not significant
    if (duration <= 0) return;
    if (!(globalThis !== null && globalThis !== void 0 && globalThis.__ufo_self_measurements)) $419f6151ed9b21d9$export$a4a352ce60895de1();
    globalThis.__ufo_self_measurements.runtime.total += duration;
    if (isAsync) globalThis.__ufo_self_measurements.runtime.async += duration;
    if (isError) globalThis.__ufo_self_measurements.runtime.error += duration;
    if (functionName in globalThis.__ufo_self_measurements.runtime.byFunction) globalThis.__ufo_self_measurements.runtime.byFunction[functionName] += duration;
    else globalThis.__ufo_self_measurements.runtime.byFunction[functionName] = duration;
    var _iterator = $419f6151ed9b21d9$var$_createForOfIteratorHelper(tags), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var tag = _step.value;
            if (tag in globalThis.__ufo_self_measurements.runtime.custom) globalThis.__ufo_self_measurements.runtime.custom[tag] += duration;
            else globalThis.__ufo_self_measurements.runtime.custom[tag] = duration;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
}
function $419f6151ed9b21d9$var$isPromise(value) {
    return value && typeof value.then === 'function';
}
function $419f6151ed9b21d9$export$5fee8d7b32c0d54f(fn) {
    var tags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    try {
        if (!(0, $f1k1y.fg)('platform_ufo_self_timings')) return fn; // this is a NOOP wrapper if feature gate is disabled
    } catch (_unused) {
        return fn;
    }
    if (!(globalThis !== null && globalThis !== void 0 && globalThis.performance)) return fn;
    if (fn.constructor.name === 'AsyncFunction') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee() {
        var _fn$name;
        var startTime, result, endTime, _endTime, _args = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    startTime = performance.now();
                    $419f6151ed9b21d9$var$trackFunctionTimingStart((_fn$name = fn.name) !== null && _fn$name !== void 0 ? _fn$name : 'anonymous');
                    _context.prev = 2;
                    _context.next = 5;
                    return fn.apply(void 0, _args);
                case 5:
                    result = _context.sent;
                    endTime = performance.now();
                    $419f6151ed9b21d9$var$trackFunctionTimingEnd();
                    if ($419f6151ed9b21d9$var$shouldRecordProfilerMeasurement()) $419f6151ed9b21d9$var$recordProfilerMeasurement(fn.name, endTime - startTime, true, false, tags);
                    return _context.abrupt("return", result);
                case 12:
                    _context.prev = 12;
                    _context.t0 = _context["catch"](2);
                    _endTime = performance.now();
                    $419f6151ed9b21d9$var$trackFunctionTimingEnd();
                    if ($419f6151ed9b21d9$var$shouldRecordProfilerMeasurement()) $419f6151ed9b21d9$var$recordProfilerMeasurement(fn.name, _endTime - startTime, true, true, tags);
                    throw _context.t0;
                case 18:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                2,
                12
            ]
        ]);
    }));
    return function() {
        var _fn$name2;
        var startTime = performance.now();
        $419f6151ed9b21d9$var$trackFunctionTimingStart((_fn$name2 = fn.name) !== null && _fn$name2 !== void 0 ? _fn$name2 : 'anonymous');
        try {
            var result = fn.apply(void 0, arguments);
            if ($419f6151ed9b21d9$var$isPromise(result)) result.then(function(value) {
                var endTime = performance.now();
                $419f6151ed9b21d9$var$trackFunctionTimingEnd();
                if ($419f6151ed9b21d9$var$shouldRecordProfilerMeasurement()) $419f6151ed9b21d9$var$recordProfilerMeasurement(fn.name, endTime - startTime, true, false, tags);
                return value;
            }).catch(function(value) {
                var endTime = performance.now();
                $419f6151ed9b21d9$var$trackFunctionTimingEnd();
                if ($419f6151ed9b21d9$var$shouldRecordProfilerMeasurement()) $419f6151ed9b21d9$var$recordProfilerMeasurement(fn.name, endTime - startTime, true, true, tags);
                return value;
            });
            else {
                var endTime = performance.now();
                $419f6151ed9b21d9$var$trackFunctionTimingEnd();
                if ($419f6151ed9b21d9$var$shouldRecordProfilerMeasurement()) $419f6151ed9b21d9$var$recordProfilerMeasurement(fn.name, endTime - startTime, false, false, tags);
            }
            return result;
        } catch (error) {
            var _endTime2 = performance.now();
            $419f6151ed9b21d9$var$trackFunctionTimingEnd();
            if ($419f6151ed9b21d9$var$shouldRecordProfilerMeasurement()) $419f6151ed9b21d9$var$recordProfilerMeasurement(fn.name, _endTime2 - startTime, false, true, tags);
            throw error;
        }
    };
}
function $419f6151ed9b21d9$export$32aa818f3c5feabe(name) {
    if (!(globalThis !== null && globalThis !== void 0 && globalThis.performance)) return {
        name: name,
        startTime: -1
    };
    $419f6151ed9b21d9$var$trackFunctionTimingStart(name);
    return {
        name: name,
        startTime: performance.now()
    };
}
function $419f6151ed9b21d9$export$293bccc5603149b4(_ref2) {
    var name = _ref2.name, startTime = _ref2.startTime;
    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, isAsync = _ref3.isAsync, isError = _ref3.isError, tags = _ref3.tags;
    if (!(globalThis !== null && globalThis !== void 0 && globalThis.performance)) return;
    $419f6151ed9b21d9$var$trackFunctionTimingEnd();
    if (!(0, $f1k1y.fg)('platform_ufo_self_timings')) return;
    var endTime = performance.now();
    $419f6151ed9b21d9$var$recordProfilerMeasurement(name, endTime - startTime, isAsync, isError, tags);
}
function $419f6151ed9b21d9$export$d3e2c82243dab73a() {
    return $419f6151ed9b21d9$var$_objectSpread({}, globalThis === null || globalThis === void 0 ? void 0 : globalThis.__ufo_self_measurements.runtime);
}
function $419f6151ed9b21d9$export$898d7c11d63bc2e5() {
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.__ufo_self_measurements.runtime.total) === 'number') return Math.round(globalThis === null || globalThis === void 0 ? void 0 : globalThis.__ufo_self_measurements.runtime.total);
    return null;
}
function $419f6151ed9b21d9$export$a7794d55eaa6800e() {
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.__ufo_self_measurements.runtime.async) === 'number') return Math.round(globalThis === null || globalThis === void 0 ? void 0 : globalThis.__ufo_self_measurements.runtime.async);
    return null;
}
function $419f6151ed9b21d9$export$c321c81126f91d1c(functionName) {
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.__ufo_self_measurements.runtime.byFunction[functionName]) === 'number') return Math.round(globalThis === null || globalThis === void 0 ? void 0 : globalThis.__ufo_self_measurements.runtime.byFunction[functionName]);
    return null;
}
function $419f6151ed9b21d9$export$5e3aaf097aba6e53(tag) {
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.__ufo_self_measurements.runtime.custom[tag]) === 'number') return Math.round(globalThis === null || globalThis === void 0 ? void 0 : globalThis.__ufo_self_measurements.runtime.custom[tag]);
    return null;
}

});


parcelRegister("h6MYR", function(module, exports) {

$parcel$export(module.exports, "getConfig", function () { return $c748fdba4a6dc4f6$export$44487a86467333c3; });
$parcel$export(module.exports, "getCapabilityRate", function () { return $c748fdba4a6dc4f6$export$29b9ffb14861a1d; });
$parcel$export(module.exports, "getAwaitBM3TTIList", function () { return $c748fdba4a6dc4f6$export$2d311b3fd18dcab1; });
$parcel$export(module.exports, "shouldHandleEditorLnv", function () { return $c748fdba4a6dc4f6$export$808cd22f6b703d66; });

var $5Dj3P = parcelRequire("5Dj3P");
var $c748fdba4a6dc4f6$var$config;
var $c748fdba4a6dc4f6$export$10d6139a8fb42158 = (0, $5Dj3P.withProfiling)(function setUFOConfig(newConfig) {
    $c748fdba4a6dc4f6$var$config = newConfig;
});
var $c748fdba4a6dc4f6$export$44487a86467333c3 = (0, $5Dj3P.withProfiling)(function getConfig() {
    return $c748fdba4a6dc4f6$var$config;
});
var $c748fdba4a6dc4f6$export$9466a8f085fa7d4e = (0, $5Dj3P.withProfiling)(function getInteractionRate(name, interactionKind) {
    try {
        if (!$c748fdba4a6dc4f6$var$config) return 0;
        var _config = $c748fdba4a6dc4f6$var$config, killswitch = _config.killswitch, rates = _config.rates, rules = _config.rules, kind = _config.kind, autoGeneratedRate = _config.autoGeneratedRate;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(var i = 0; i < rules.length; i++){
            var rule = rules[i];
            var test = rule.test, rate = rule.rate;
            if (test != null && rate != null) {
                var regexp = new RegExp(test, 'ig');
                if (regexp.test(name)) return rate;
            }
        }
        var isAutogenerated = name === null || name === void 0 ? void 0 : name.startsWith('auto-generated');
        if (isAutogenerated) {
            var _rate = autoGeneratedRate;
            if (_rate != null) return _rate;
        }
        if (kind != null) {
            var _rate2 = kind[interactionKind];
            if (_rate2 != null) return _rate2;
        }
        return 0;
    } catch (e) {
        // Fallback
        return 0;
    }
});
var $c748fdba4a6dc4f6$export$563f73272328c0d = (0, $5Dj3P.withProfiling)(function getExperimentalInteractionRate(name, interactionType) {
    try {
        if (!$c748fdba4a6dc4f6$var$config) return 0;
        var _config2 = $c748fdba4a6dc4f6$var$config, experimentalInteractionMetrics = _config2.experimentalInteractionMetrics;
        if (!(experimentalInteractionMetrics !== null && experimentalInteractionMetrics !== void 0 && experimentalInteractionMetrics.enabled)) return 0;
        if (experimentalInteractionMetrics.rates && typeof experimentalInteractionMetrics.rates[name] === 'number') return experimentalInteractionMetrics.rates[name];
        if (experimentalInteractionMetrics.kind && typeof experimentalInteractionMetrics.kind[interactionType] === 'number') return experimentalInteractionMetrics.kind[interactionType];
        return 0;
    } catch (e) {
        return 0;
    }
});
var $c748fdba4a6dc4f6$export$1d459f020c06ae34 = (0, $5Dj3P.withProfiling)(function getPostInteractionRate(name, interactionType) {
    try {
        if (!$c748fdba4a6dc4f6$var$config) return 0;
        var _config3 = $c748fdba4a6dc4f6$var$config, postInteractionLog = _config3.postInteractionLog;
        if (!(postInteractionLog !== null && postInteractionLog !== void 0 && postInteractionLog.enabled)) return 0;
        if (postInteractionLog.rates && typeof postInteractionLog.rates[name] === 'number') return postInteractionLog.rates[name];
        if (postInteractionLog.kind && typeof postInteractionLog.kind[interactionType] === 'number') return postInteractionLog.kind[interactionType];
        return 0;
    } catch (e) {
        return 0;
    }
});
var $c748fdba4a6dc4f6$export$29b9ffb14861a1d = (0, $5Dj3P.withProfiling)(function getCapabilityRate(capability) {
    try {
        if (!$c748fdba4a6dc4f6$var$config) return 0;
        var _config4 = $c748fdba4a6dc4f6$var$config, capabilityRate = _config4.capability;
        if (capabilityRate != null) {
            var rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch (_unused) {
        return 0;
    }
});
var $c748fdba4a6dc4f6$var$validTypingMethods = [
    'timeout',
    'timeoutNoAlloc',
    'mutationObserver'
];
var $c748fdba4a6dc4f6$export$7e32aae12bf9b50f = (0, $5Dj3P.withProfiling)(function getTypingPerformanceTracingMethod() {
    var defaultMethod = 'timeout';
    try {
        if (!$c748fdba4a6dc4f6$var$config) return defaultMethod;
        var _config5 = $c748fdba4a6dc4f6$var$config, typingMethod = _config5.typingMethod;
        if (typingMethod != null && $c748fdba4a6dc4f6$var$validTypingMethods.find(function(m) {
            return m === typingMethod;
        })) return typingMethod;
        else return defaultMethod;
    } catch (e) {
        return defaultMethod;
    }
});
var $c748fdba4a6dc4f6$export$2d311b3fd18dcab1 = (0, $5Dj3P.withProfiling)(function getAwaitBM3TTIList() {
    try {
        if (!$c748fdba4a6dc4f6$var$config) return [];
        var _config6 = $c748fdba4a6dc4f6$var$config, awaitBM3TTI = _config6.awaitBM3TTI;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch (e) {
        return [];
    }
});
var $c748fdba4a6dc4f6$export$e2ea675800536898 = (0, $5Dj3P.withProfiling)(function getRemovePageSegmentsUFOPrefixes() {
    try {
        if (!$c748fdba4a6dc4f6$var$config) return false;
        var _config7 = $c748fdba4a6dc4f6$var$config, removePageSegmentsUFOPrefixes = _config7.removePageSegmentsUFOPrefixes;
        if (removePageSegmentsUFOPrefixes != null) return removePageSegmentsUFOPrefixes;
        else return false;
    } catch (e) {
        return false;
    }
});
var $c748fdba4a6dc4f6$export$525ba53ca98e9db = (0, $5Dj3P.withProfiling)(function getRemoveInteractionsUFOPrefixes() {
    try {
        if (!$c748fdba4a6dc4f6$var$config) return false;
        var _config8 = $c748fdba4a6dc4f6$var$config, removeInteractionsUFOPrefixes = _config8.removeInteractionsUFOPrefixes;
        if (removeInteractionsUFOPrefixes != null) return removeInteractionsUFOPrefixes;
        else return false;
    } catch (e) {
        return false;
    }
});
var $c748fdba4a6dc4f6$export$4f4649ef27b6f5d6 = (0, $5Dj3P.withProfiling)(function getUfoNameOverrides() {
    try {
        if (!$c748fdba4a6dc4f6$var$config) return undefined;
        var _config9 = $c748fdba4a6dc4f6$var$config, ufoNameOverrides = _config9.ufoNameOverrides;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch (e) {
        return undefined;
    }
});
var $c748fdba4a6dc4f6$export$3c170167645a0eff = (0, $5Dj3P.withProfiling)(function getDoNotAbortActivePressInteraction() {
    try {
        if (!$c748fdba4a6dc4f6$var$config) return undefined;
        var _config10 = $c748fdba4a6dc4f6$var$config, doNotAbortActivePressInteraction = _config10.doNotAbortActivePressInteraction;
        return doNotAbortActivePressInteraction;
    } catch (e) {
        return undefined;
    }
});
var $c748fdba4a6dc4f6$export$d6dc9444bd15f70f = (0, $5Dj3P.withProfiling)(function getDoNotAbortActivePressInteractionOnTransition() {
    try {
        if (!$c748fdba4a6dc4f6$var$config) return undefined;
        var _config11 = $c748fdba4a6dc4f6$var$config, doNotAbortActivePressInteractionOnTransition = _config11.doNotAbortActivePressInteractionOnTransition;
        return doNotAbortActivePressInteractionOnTransition;
    } catch (e) {
        return undefined;
    }
});
var $c748fdba4a6dc4f6$export$808cd22f6b703d66 = (0, $5Dj3P.withProfiling)(function shouldHandleEditorLnv() {
    try {
        var _config$enableEditorL, _config12;
        return (_config$enableEditorL = (_config12 = $c748fdba4a6dc4f6$var$config) === null || _config12 === void 0 ? void 0 : _config12.enableEditorLnvHandler) !== null && _config$enableEditorL !== void 0 ? _config$enableEditorL : false;
    } catch (e) {
        return false;
    }
});

});

parcelRegister("kQsKx", function(module, exports) {

$parcel$export(module.exports, "onExperimentalInteractionComplete", function () { return $f2cef70c2076a439$export$1aed449484dedf63; });
$parcel$export(module.exports, "experimentalVC", function () { return $f2cef70c2076a439$export$81b28dca2587ec47; });
$parcel$export(module.exports, "getExperimentalVCMetrics", function () { return $f2cef70c2076a439$export$d17d2b5c5e8d732e; });

var $2R76C = parcelRequire("2R76C");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $dsN6L = parcelRequire("dsN6L");

var $eWMMH = parcelRequire("eWMMH");

var $hvnV0 = parcelRequire("hvnV0");

var $5Dj3P = parcelRequire("5Dj3P");

var $7F3ZZ = parcelRequire("7F3ZZ");
function $f2cef70c2076a439$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f2cef70c2076a439$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f2cef70c2076a439$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f2cef70c2076a439$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f2cef70c2076a439$var$interactionBuffer = [];
var $f2cef70c2076a439$var$bufferInteractionData = (0, $5Dj3P.withProfiling)(function bufferInteractionData(interactionId, data) {
    $f2cef70c2076a439$var$interactionBuffer.push({
        interactionId: interactionId,
        data: data
    });
});
var $f2cef70c2076a439$var$clearInteractionBuffer = (0, $5Dj3P.withProfiling)(function clearInteractionBuffer() {
    $f2cef70c2076a439$var$interactionBuffer.length = 0;
});
var $f2cef70c2076a439$var$appendInteractionData = (0, $5Dj3P.withProfiling)(function appendInteractionData(interactionId, data) {
    $f2cef70c2076a439$var$bufferInteractionData(interactionId, data);
});
var $f2cef70c2076a439$export$c8a9e17ae62a073d = (0, $5Dj3P.withProfiling)(function installInteractionSink(handler) {
    for(var _i = 0, _interactionBuffer = $f2cef70c2076a439$var$interactionBuffer; _i < _interactionBuffer.length; _i++){
        var _interactionBuffer$_i = _interactionBuffer[_i], _interactionId = _interactionBuffer$_i.interactionId, data = _interactionBuffer$_i.data;
        handler(_interactionId, data);
    }
    $f2cef70c2076a439$var$clearInteractionBuffer();
    $f2cef70c2076a439$var$bufferInteractionData = (0, $5Dj3P.withProfiling)(handler);
});
var $f2cef70c2076a439$export$7aa99c40634ac65f = (0, $5Dj3P.withProfiling)(function sinkExperimentalHandler(sinkFn) {
    $f2cef70c2076a439$export$c8a9e17ae62a073d(sinkFn);
});
var $f2cef70c2076a439$export$1aed449484dedf63 = (0, $5Dj3P.withProfiling)(function onExperimentalInteractionComplete(interactionId, data) {
    var endTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    if (data.ufoName) {
        data.end = endTime;
        $f2cef70c2076a439$var$appendInteractionData(interactionId, data);
        $f2cef70c2076a439$var$clearInteractionBuffer();
    }
});
var $f2cef70c2076a439$export$f9a59f57e0282541 = /*#__PURE__*/ function() {
    function ExperimentalVCMetrics() {
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, ExperimentalVCMetrics);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "vcObserver", null);
        this.initialize = (0, $5Dj3P.withProfiling)(this.initialize.bind(this));
        this.start = (0, $5Dj3P.withProfiling)(this.start.bind(this));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(ExperimentalVCMetrics, [
        {
            key: "initialize",
            value: function initialize(options) {
                if (this.vcObserver === null) this.vcObserver = new (0, $7F3ZZ.VCObserver)($f2cef70c2076a439$var$_objectSpread($f2cef70c2076a439$var$_objectSpread({}, options), {}, {
                    isPostInteraction: true
                }));
                return this;
            }
        },
        {
            key: "start",
            value: function start(_ref) {
                var _this$vcObserver;
                var startTime = _ref.startTime;
                (_this$vcObserver = this.vcObserver) === null || _this$vcObserver === void 0 || _this$vcObserver.start({
                    startTime: startTime
                });
            }
        }
    ]);
}();
var $f2cef70c2076a439$export$81b28dca2587ec47 = new $f2cef70c2076a439$export$f9a59f57e0282541();
var $f2cef70c2076a439$export$d17d2b5c5e8d732e = (0, $5Dj3P.withProfiling)(/*#__PURE__*/ function() {
    var _getExperimentalVCMetrics = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee(interaction) {
        var _interaction$apdex, prefix, result, VC, pageVisibilityUpToTTAI;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!$f2cef70c2076a439$export$81b28dca2587ec47.vcObserver) {
                        _context.next = 12;
                        break;
                    }
                    prefix = 'ufo-experimental';
                    _context.next = 4;
                    return $f2cef70c2076a439$export$81b28dca2587ec47.vcObserver.getVCResult({
                        start: interaction.start,
                        stop: interaction.end,
                        tti: (_interaction$apdex = interaction.apdex) === null || _interaction$apdex === void 0 || (_interaction$apdex = _interaction$apdex[0]) === null || _interaction$apdex === void 0 ? void 0 : _interaction$apdex.stopTime,
                        isEventAborted: !!interaction.abortReason,
                        prefix: prefix,
                        vc: interaction.vc
                    });
                case 4:
                    result = _context.sent;
                    VC = result === null || result === void 0 ? void 0 : result['metrics:vc'];
                    if (!(!VC || !(result !== null && result !== void 0 && result["".concat(prefix, ":vc:clean")]))) {
                        _context.next = 8;
                        break;
                    }
                    return _context.abrupt("return", result);
                case 8:
                    pageVisibilityUpToTTAI = (0, $hvnV0.getPageVisibilityState)(interaction.start, interaction.end);
                    if (!(interaction.abortReason || pageVisibilityUpToTTAI !== 'visible')) {
                        _context.next = 11;
                        break;
                    }
                    return _context.abrupt("return", result);
                case 11:
                    return _context.abrupt("return", $f2cef70c2076a439$var$_objectSpread($f2cef70c2076a439$var$_objectSpread({}, result), {}, {
                        'metric:experimental:vc90': VC['90']
                    }));
                case 12:
                    return _context.abrupt("return", null);
                case 13:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    function getExperimentalVCMetrics(_x) {
        return _getExperimentalVCMetrics.apply(this, arguments);
    }
    return getExperimentalVCMetrics;
}());

});
parcelRegister("hvnV0", function(module, exports) {

$parcel$export(module.exports, "getPageVisibilityState", function () { return $cbe7e2a57dd72383$export$768b2008623433e1; });

var $aA6j8 = parcelRequire("aA6j8");
var $cbe7e2a57dd72383$var$timings = [];
var $cbe7e2a57dd72383$var$wasHiddenFlag;
var $cbe7e2a57dd72383$var$setupFlag = false;
function $cbe7e2a57dd72383$var$isPageHidden() {
    if ('visibilityState' in document) return document.visibilityState === 'hidden';
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
var $cbe7e2a57dd72383$var$SIZE = 50;
var $cbe7e2a57dd72383$var$insertIndex = 0;
function $cbe7e2a57dd72383$var$pushHidden(isPageHiddenFlag, time) {
    $cbe7e2a57dd72383$var$timings[$cbe7e2a57dd72383$var$insertIndex] = {
        time: time !== null && time !== void 0 ? time : performance.now(),
        hidden: isPageHiddenFlag
    };
    $cbe7e2a57dd72383$var$insertIndex = ($cbe7e2a57dd72383$var$insertIndex + 1) % $cbe7e2a57dd72383$var$SIZE;
    $cbe7e2a57dd72383$var$wasHiddenFlag = isPageHiddenFlag;
}
function $cbe7e2a57dd72383$var$handleChange() {
    var isPageHiddenFlag = $cbe7e2a57dd72383$var$isPageHidden();
    if (isPageHiddenFlag) {
        if (!$cbe7e2a57dd72383$var$wasHiddenFlag) $cbe7e2a57dd72383$var$pushHidden(isPageHiddenFlag);
        $cbe7e2a57dd72383$var$wasHiddenFlag = true;
    } else {
        if ($cbe7e2a57dd72383$var$wasHiddenFlag) $cbe7e2a57dd72383$var$pushHidden(isPageHiddenFlag);
        $cbe7e2a57dd72383$var$wasHiddenFlag = false;
    }
}
function $cbe7e2a57dd72383$var$setup() {
    (0, $aA6j8.bind)(window, {
        type: 'pageshow',
        listener: $cbe7e2a57dd72383$var$handleChange
    });
    (0, $aA6j8.bind)(window, {
        type: 'pagehide',
        listener: $cbe7e2a57dd72383$var$handleChange
    });
    (0, $aA6j8.bind)(document, {
        type: 'visibilitychange',
        listener: $cbe7e2a57dd72383$var$handleChange
    });
}
function $cbe7e2a57dd72383$export$554cefe0f0373da4() {
    if (!$cbe7e2a57dd72383$var$setupFlag) {
        var isPageHiddenFlag = $cbe7e2a57dd72383$var$isPageHidden();
        $cbe7e2a57dd72383$var$pushHidden(isPageHiddenFlag, 0);
        $cbe7e2a57dd72383$var$setup();
        $cbe7e2a57dd72383$var$setupFlag = true;
    }
}
function $cbe7e2a57dd72383$export$768b2008623433e1(start, end) {
    // Desirable default value is visible
    if ($cbe7e2a57dd72383$var$timings.length === 0) return 'visible';
    var currentSize = $cbe7e2a57dd72383$var$timings.length;
    var hiddenState = 'mixed';
    var startIdx = $cbe7e2a57dd72383$var$insertIndex;
    var endIdx = $cbe7e2a57dd72383$var$insertIndex;
    // currentSize is capped at SIZE.
    for(var i = 0; i < currentSize; i++){
        var tmpIdx = ($cbe7e2a57dd72383$var$insertIndex + i) % currentSize;
        if ($cbe7e2a57dd72383$var$timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if ($cbe7e2a57dd72383$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    if (endIdx - startIdx === 0) {
        if ($cbe7e2a57dd72383$var$timings[startIdx].hidden) hiddenState = 'hidden';
        else hiddenState = 'visible';
    }
    return hiddenState;
}

});
parcelRegister("aA6j8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $c4dN1 = parcelRequire("c4dN1");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $c4dN1.bind;
    }
});

var $yMk9o = parcelRequire("yMk9o");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $yMk9o.bindAll;
    }
});

});
parcelRegister("c4dN1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $8c908e1ac86f9e6e$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $8c908e1ac86f9e6e$var$bind;

});

parcelRegister("yMk9o", function(module, exports) {
"use strict";
var $0688a93b51899264$var$__assign = module.exports && module.exports.__assign || function() {
    $0688a93b51899264$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0688a93b51899264$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $c4dN1 = parcelRequire("c4dN1");
function $0688a93b51899264$var$toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function $0688a93b51899264$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $0688a93b51899264$var$__assign($0688a93b51899264$var$__assign({}, original), {
        options: $0688a93b51899264$var$__assign($0688a93b51899264$var$__assign({}, $0688a93b51899264$var$toOptions(sharedOptions)), $0688a93b51899264$var$toOptions(original.options))
    });
    return binding;
}
function $0688a93b51899264$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $0688a93b51899264$var$getBinding(original, sharedOptions);
        return (0, $c4dN1.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $0688a93b51899264$var$bindAll;

});



parcelRegister("7F3ZZ", function(module, exports) {

$parcel$export(module.exports, "VCObserver", function () { return $593f76d3bf0d2070$export$1f70d263701b1d01; });

var $iqLBO = parcelRequire("iqLBO");

var $2R76C = parcelRequire("2R76C");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $dsN6L = parcelRequire("dsN6L");

var $ai2Md = parcelRequire("ai2Md");

var $5YM7L = parcelRequire("5YM7L");

var $eWMMH = parcelRequire("eWMMH");

var $f1k1y = parcelRequire("f1k1y");

var $5Dj3P = parcelRequire("5Dj3P");

var $7kZto = parcelRequire("7kZto");

var $dI1SJ = parcelRequire("dI1SJ");

var $5jOXh = parcelRequire("5jOXh");

var $hOsrT = parcelRequire("hOsrT");

var $iLSkI = parcelRequire("iLSkI");

var $xbeRb = parcelRequire("xbeRb");
var $593f76d3bf0d2070$var$_VCObserver;
var $593f76d3bf0d2070$var$_excluded = [
    "__debug__element"
];
function $593f76d3bf0d2070$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $593f76d3bf0d2070$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $593f76d3bf0d2070$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $593f76d3bf0d2070$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $593f76d3bf0d2070$var$abortReason = {
    scroll: 'scroll',
    keypress: 'keypress',
    resize: 'resize',
    error: 'error'
};
var $593f76d3bf0d2070$var$UNUSED_SECTOR = 0;
var $593f76d3bf0d2070$var$filterComponentsLog = (0, $5Dj3P.withProfiling)(function filterComponentsLog(log) {
    return Object.fromEntries(Object.entries(log).map(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_ref, 2), timestamp = _ref2[0], entries = _ref2[1];
        return [
            Number(timestamp),
            entries.map(function(entry) {
                var __debug__element = entry.__debug__element, rest = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(entry, $593f76d3bf0d2070$var$_excluded);
                return rest;
            })
        ];
    }));
}, [
    'vc'
]);
var $593f76d3bf0d2070$export$1f70d263701b1d01 = /*#__PURE__*/ function() {
    function VCObserver(options) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, VCObserver);
        /* abort logic */ (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "abortReason", {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "outOfBoundaryInfo", '');
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "viewport", {
            w: 0,
            h: 0
        });
        /* heatmap */ (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "arraySize", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "multiHeatmap", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "componentsLog", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "vcRatios", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "active", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "totalTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "startTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_startMeasureTimestamp", -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "ssr", {
            reactRendered: -1
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "unbind", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "getAbortReasonInfo", function() {
            if (_this.abortReason.reason === null) return null;
            var info = _this.abortReason.info !== '' ? " ".concat(_this.abortReason.info) : '';
            return "".concat(_this.abortReason.reason).concat(info);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "getVCRawData", function() {
            _this.measureStart();
            if (!_this.active) {
                _this.measureStop();
                return null;
            }
            _this.stop();
            var abortReasonInfo = _this.getAbortReasonInfo();
            _this.measureStop();
            return {
                abortReasonInfo: abortReasonInfo,
                abortReason: $593f76d3bf0d2070$var$_objectSpread({}, _this.abortReason),
                heatmap: _this.heatmap,
                heatmapNext: _this.heatmapNext,
                multiHeatmap: _this.multiHeatmap,
                outOfBoundaryInfo: _this.outOfBoundaryInfo,
                totalTime: Math.round(_this.totalTime + _this.observers.getTotalTime()),
                componentsLog: $593f76d3bf0d2070$var$_objectSpread({}, _this.componentsLog),
                viewport: $593f76d3bf0d2070$var$_objectSpread({}, _this.viewport),
                oldDomUpdatesEnabled: _this.oldDomUpdatesEnabled,
                devToolsEnabled: _this.devToolsEnabled,
                ratios: _this.vcRatios
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "getVCResult", /*#__PURE__*/ function() {
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee(_ref3) {
                var start, stop, tti, prefix, ssr, vc, isEventAborted, startTime, fullPrefix, rawData, abortReason, abortReasonInfo, heatmap, heatmapNext, outOfBoundaryInfo, totalTime, componentsLog, viewport, devToolsEnabled, ratios, multiHeatmap, isTTVCv1Disabled, ttvcV1Result, VC, VCBox, VCEntries, totalPainted, _componentsLog, vcNext, outOfBoundary, stopTime, ttvcV1DevToolInfo, ttvcV2DevToolInfo, isVCClean, revisionsData, isCalcSpeedIndexEnabled, speedIndex;
                return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            start = _ref3.start, stop = _ref3.stop, tti = _ref3.tti, prefix = _ref3.prefix, ssr = _ref3.ssr, vc = _ref3.vc, isEventAborted = _ref3.isEventAborted;
                            startTime = performance.now(); // add local measurement
                            fullPrefix = prefix !== undefined && prefix !== '' ? "".concat(prefix, ":") : '';
                            rawData = vc !== undefined ? vc : _this.getVCRawData();
                            if (!(rawData === null)) {
                                _context.next = 6;
                                break;
                            }
                            return _context.abrupt("return", {});
                        case 6:
                            abortReason = rawData.abortReason, abortReasonInfo = rawData.abortReasonInfo, heatmap = rawData.heatmap, heatmapNext = rawData.heatmapNext, outOfBoundaryInfo = rawData.outOfBoundaryInfo, totalTime = rawData.totalTime, componentsLog = rawData.componentsLog, viewport = rawData.viewport, devToolsEnabled = rawData.devToolsEnabled, ratios = rawData.ratios, multiHeatmap = rawData.multiHeatmap;
                            if (!(abortReasonInfo !== null && abortReason.blocking)) {
                                _context.next = 10;
                                break;
                            }
                            // exposing data to devtools
                            try {
                                if (devToolsEnabled && !_this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                            } catch (e) {}
                            return _context.abrupt("return", (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, "".concat(fullPrefix, "vc:state"), false), "".concat(fullPrefix, "vc:abort:reason"), abortReasonInfo), "".concat(fullPrefix, "vc:abort:timestamp"), abortReason.timestamp));
                        case 10:
                            isTTVCv1Disabled = (0, $f1k1y.fg)('platform_ufo_disable_ttvc_v1');
                            ttvcV1Result = isTTVCv1Disabled ? {
                                VC: {},
                                VCBox: {},
                                VCEntries: {
                                    abs: [],
                                    rel: [],
                                    speedIndex: -1
                                },
                                totalPainted: -1
                            } : VCObserver.calculateVC({
                                heatmap: heatmap,
                                ssr: ssr,
                                componentsLog: $593f76d3bf0d2070$var$_objectSpread({}, componentsLog),
                                viewport: viewport
                            });
                            VC = ttvcV1Result.VC, VCBox = ttvcV1Result.VCBox, VCEntries = ttvcV1Result.VCEntries, totalPainted = ttvcV1Result.totalPainted;
                            _componentsLog = {};
                            Object.entries(_this.componentsLog).forEach(function(_ref6) {
                                var _ref7 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_ref6, 2), _timestamp = _ref7[0], value = _ref7[1];
                                var timestamp = Number(_timestamp);
                                if (stop > timestamp) _componentsLog[timestamp] = value;
                            });
                            vcNext = VCObserver.calculateVC({
                                heatmap: heatmapNext,
                                ssr: ssr,
                                componentsLog: _componentsLog,
                                viewport: viewport
                            });
                            try {
                                if (!_this.isPostInteraction) VCObserver.VCParts.forEach(function(key) {
                                    if (isTTVCv1Disabled) {
                                        var duration = vcNext.VC[key];
                                        if (duration !== null && duration !== undefined) {
                                            performance.measure("VC".concat(key), {
                                                start: start,
                                                duration: duration
                                            });
                                            performance.measure("VC_Next".concat(key), {
                                                start: start,
                                                duration: duration
                                            });
                                        }
                                    } else {
                                        var ttvcV1duration = VC[key];
                                        if (ttvcV1duration !== null && ttvcV1duration !== undefined) performance.measure("VC".concat(key), {
                                            start: start,
                                            duration: ttvcV1duration
                                        });
                                        var ttvcV2duration = vcNext.VC[key];
                                        if (ttvcV2duration !== null && ttvcV2duration !== undefined) performance.measure("VC_Next".concat(key), {
                                            start: start,
                                            duration: ttvcV2duration
                                        });
                                    }
                                });
                            } catch (e) {
                            /* empty */ }
                            outOfBoundary = outOfBoundaryInfo ? (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, "".concat(fullPrefix, "vc:oob"), outOfBoundaryInfo) : {}; //const oldDomUpdates = oldDomUpdatesEnabled ? { [`${fullPrefix}vc:old:dom`]: vcNext.VCBox } : {};
                            stopTime = performance.now(); // exposing data to devtools
                            try {
                                if (!_this.isPostInteraction && devToolsEnabled) {
                                    ttvcV1DevToolInfo = isTTVCv1Disabled ? undefined : {
                                        entries: VCEntries.rel,
                                        log: componentsLog,
                                        metrics: {
                                            '75': VC['75'],
                                            '80': VC['80'],
                                            '85': VC['85'],
                                            '90': VC['90'],
                                            '95': VC['95'],
                                            '98': VC['98'],
                                            '99': VC['99'],
                                            tti: tti,
                                            ttai: stop - start
                                        },
                                        start: start,
                                        stop: stop,
                                        heatmap: heatmap,
                                        ratios: ratios
                                    };
                                    ttvcV2DevToolInfo = {
                                        entries: vcNext.VCEntries.rel,
                                        log: componentsLog,
                                        metrics: {
                                            '75': vcNext.VC['75'],
                                            '80': vcNext.VC['80'],
                                            '85': vcNext.VC['85'],
                                            '90': vcNext.VC['90'],
                                            '95': vcNext.VC['95'],
                                            '98': vcNext.VC['98'],
                                            '99': vcNext.VC['99'],
                                            tti: tti,
                                            ttai: stop - start
                                        },
                                        start: start,
                                        stop: stop,
                                        heatmap: heatmapNext,
                                        ratios: ratios
                                    };
                                    if (isTTVCv1Disabled) {
                                        window.__vc = ttvcV2DevToolInfo;
                                        window.__vcNext = ttvcV2DevToolInfo;
                                    } else {
                                        window.__vc = ttvcV1DevToolInfo;
                                        window.__vcNext = ttvcV2DevToolInfo;
                                    }
                                    // Emitting a custom event to make it available in the Chrome extension
                                    window.dispatchEvent(new CustomEvent('vcReady', {
                                        detail: {
                                            log: $593f76d3bf0d2070$var$filterComponentsLog(componentsLog),
                                            entries: isTTVCv1Disabled ? vcNext.VCEntries.rel : VCEntries.rel
                                        }
                                    }));
                                }
                            } catch (e) {
                            /*  do nothing */ }
                            isVCClean = !abortReasonInfo;
                            revisionsData = (0, $dI1SJ.getVCRevisionsData)({
                                fullPrefix: fullPrefix,
                                interaction: {
                                    start: start,
                                    end: stop
                                },
                                isVCClean: isVCClean,
                                multiHeatmap: multiHeatmap,
                                ssr: ssr,
                                calculatedVC: {
                                    VC: VC,
                                    VCBox: VCBox
                                },
                                calculatedVCNext: {
                                    VC: vcNext.VC,
                                    VCBox: vcNext.VCBox
                                },
                                isEventAborted: isEventAborted
                            }); // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                            isCalcSpeedIndexEnabled = (0, $f1k1y.fg)('ufo-calc-speed-index');
                            speedIndex = (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, "ufo:speedIndex", isTTVCv1Disabled ? vcNext.VCEntries.speedIndex : VCEntries.speedIndex), "ufo:next:speedIndex", vcNext.VCEntries.speedIndex);
                            if (!isTTVCv1Disabled) {
                                _context.next = 26;
                                break;
                            }
                            return _context.abrupt("return", $593f76d3bf0d2070$var$_objectSpread($593f76d3bf0d2070$var$_objectSpread($593f76d3bf0d2070$var$_objectSpread((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, "".concat(fullPrefix, "vc:size"), viewport), "".concat(fullPrefix, "vc:time"), Math.round(totalTime + (stopTime - startTime))), "".concat(fullPrefix, "vc:ratios"), ratios), outOfBoundary), {}, (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, "".concat(fullPrefix, "vc:ignored"), _this.getIgnoredElements(componentsLog)), revisionsData), isCalcSpeedIndexEnabled ? speedIndex : {}));
                        case 26:
                            return _context.abrupt("return", $593f76d3bf0d2070$var$_objectSpread($593f76d3bf0d2070$var$_objectSpread($593f76d3bf0d2070$var$_objectSpread((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({
                                'metrics:vc': VC
                            }, "".concat(fullPrefix, "vc:state"), true), "".concat(fullPrefix, "vc:clean"), isVCClean), "".concat(fullPrefix, "vc:dom"), VCBox), "".concat(fullPrefix, "vc:updates"), (0, $f1k1y.fg)('platform_ufo_vc_observer_new') ? undefined : VCEntries.rel.slice(0, 50)), "".concat(fullPrefix, "vc:size"), viewport), "".concat(fullPrefix, "vc:time"), Math.round(totalTime + (stopTime - startTime))), "".concat(fullPrefix, "vc:total"), totalPainted), "".concat(fullPrefix, "vc:ratios"), ratios), outOfBoundary), {}, (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, "".concat(fullPrefix, "vc:next"), vcNext.VC), "".concat(fullPrefix, "vc:next:updates"), (0, $f1k1y.fg)('platform_ufo_vc_observer_new') ? undefined : vcNext.VCEntries.rel.slice(0, 50)), "".concat(fullPrefix, "vc:next:dom"), vcNext.VCBox), "".concat(fullPrefix, "vc:ignored"), _this.getIgnoredElements(componentsLog)), revisionsData), isCalcSpeedIndexEnabled ? speedIndex : {}));
                        case 27:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function(_x) {
                return _ref4.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "handleUpdate", function(rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue) {
            _this.measureStart();
            _this.legacyHandleUpdate(rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue);
            if (!(0, $f1k1y.fg)('platform_ufo_vc_observer_new')) _this.onViewportChangeDetected({
                timestamp: rawTime,
                intersectionRect: intersectionRect,
                targetName: targetName,
                element: element,
                type: type,
                ignoreReason: ignoreReason,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
            _this.measureStop();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "legacyHandleUpdate", function(rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue) {
            if (_this.abortReason.reason === null || _this.abortReason.blocking === false) {
                var time = Math.round(rawTime - _this.startTime);
                var mappedValues = _this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                _this.vcRatios[targetName] = _this.getElementRatio(mappedValues);
                if (!ignoreReason) _this.applyChangesToHeatMap(mappedValues, time, _this.heatmapNext);
                var isTTVCv1Disabled = (0, $f1k1y.fg)('platform_ufo_disable_ttvc_v1');
                if (!isTTVCv1Disabled && (!ignoreReason || ignoreReason === 'not-visible') && type !== 'attr') _this.applyChangesToHeatMap(mappedValues, time, _this.heatmap);
                if (!_this.componentsLog[time]) _this.componentsLog[time] = [];
                _this.componentsLog[time].push({
                    __debug__element: _this.devToolsEnabled ? new WeakRef(element) : null,
                    type: type,
                    intersectionRect: intersectionRect,
                    targetName: targetName,
                    ignoreReason: ignoreReason,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                });
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "onViewportChangeDetected", function(_ref9) {
            var element = _ref9.element, type = _ref9.type, ignoreReason = _ref9.ignoreReason, timestamp = _ref9.timestamp, targetName = _ref9.targetName, intersectionRect = _ref9.intersectionRect, attributeName = _ref9.attributeName, oldValue = _ref9.oldValue, newValue = _ref9.newValue;
            if (_this.multiHeatmap === null) return;
            // @todo add abort reason handling
            var time = Math.round(timestamp - _this.startTime);
            var revisions = (0, $xbeRb.getRevisions)();
            var revisionsClassification = revisions.map(function(revision) {
                return revision.classifier.classifyUpdate({
                    element: element,
                    type: type,
                    ignoreReason: ignoreReason
                });
            }, []);
            _this.multiHeatmap.handleUpdate({
                time: time,
                targetName: targetName,
                intersectionRect: intersectionRect,
                type: type,
                element: element,
                classification: revisionsClassification,
                onError: function onError(error) {
                    _this.setAbortReason($593f76d3bf0d2070$var$abortReason.error, error.time, error.error);
                },
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "mapPixelsToHeatmap", function(left, top, width, height) {
            var _this$viewport = _this.viewport, w = _this$viewport.w, h = _this$viewport.h;
            var l = Math.floor(left / w * _this.arraySize);
            var t = Math.floor(top / h * _this.arraySize);
            var r = Math.ceil((left + width) / w * _this.arraySize);
            var b = Math.ceil((top + height) / h * _this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (_this.outOfBoundaryInfo === '') {
                var outOfBoundaryInfo = '';
                if (r > _this.arraySize) outOfBoundaryInfo += " r ".concat(r, " ! ").concat(left, " ").concat(width);
                if (b > _this.arraySize) outOfBoundaryInfo += " r ".concat(r, " ! ").concat(top, " ").concat(height);
                _this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            var result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(_this.arraySize, r),
                b: Math.min(_this.arraySize, b)
            };
            return result;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "getElementRatio", function(mappedValues) {
            var r = mappedValues.r, l = mappedValues.l, b = mappedValues.b, t = mappedValues.t;
            return (r - l) * (b - t) / (_this.arraySize * _this.arraySize);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "abortReasonCallback", function(key, time) {
            switch(key){
                case 'wheel':
                    _this.setAbortReason($593f76d3bf0d2070$var$abortReason.scroll, time);
                    break;
                case 'keydown':
                    _this.setAbortReason($593f76d3bf0d2070$var$abortReason.keypress, time);
                    break;
                case 'resize':
                    _this.setAbortReason($593f76d3bf0d2070$var$abortReason.resize, time);
                    break;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "attachAbortListeners", function() {
            var _window;
            _this.detachAbortListeners();
            var unbinds = (0, $7kZto.attachAbortListeners)(window, _this.viewport, _this.abortReasonCallback);
            if ((_window = window) !== null && _window !== void 0 && _window.__SSR_ABORT_LISTENERS__) {
                var _window2;
                Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(function(_ref10) {
                    var _ref11 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_ref10, 2), key = _ref11[0], time = _ref11[1];
                    if (time) _this.abortReasonCallback(key, time);
                });
                unbinds = unbinds.concat(window.__SSR_ABORT_LISTENERS__.unbinds);
                (_window2 = window) === null || _window2 === void 0 || delete _window2.__SSR_ABORT_LISTENERS__;
            }
            _this.unbind = unbinds;
        });
        var operationTimer = (0, $5Dj3P.markProfilingStart)('VCObserver constructor');
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        this.observers = new (0, $iLSkI.Observers)({
            selectorConfig: options.selectorConfig || {
                id: false,
                testId: false,
                role: false,
                className: true,
                dataVC: true
            }
        });
        this.heatmap = (0, $f1k1y.fg)('platform_ufo_disable_ttvc_v1') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.multiHeatmap = new (0, $hOsrT.MultiRevisionHeatmap)({
            viewport: this.viewport,
            revisions: (0, $xbeRb.getRevisions)(),
            devToolsEnabled: this.devToolsEnabled
        });
        this.isPostInteraction = options.isPostInteraction || false;
        this.start = (0, $5Dj3P.withProfiling)(this.start.bind(this), [
            'vc'
        ]);
        this.stop = (0, $5Dj3P.withProfiling)(this.stop.bind(this), [
            'vc'
        ]);
        this.getAbortReasonInfo = (0, $5Dj3P.withProfiling)(this.getAbortReasonInfo.bind(this), [
            'vc'
        ]); // TODO: confirm correct value of `this`
        this.getVCRawData = (0, $5Dj3P.withProfiling)(this.getVCRawData.bind(this), [
            'vc'
        ]); // TODO: confirm correct value of `this`
        this.getIgnoredElements = (0, $5Dj3P.withProfiling)(this.getIgnoredElements.bind(this), [
            'vc'
        ]);
        this.getVCResult = (0, $5Dj3P.withProfiling)(this.getVCResult.bind(this), [
            'vc'
        ]);
        this.setSSRElement = (0, $5Dj3P.withProfiling)(this.setSSRElement.bind(this), [
            'vc'
        ]);
        this.setReactRootRenderStart = (0, $5Dj3P.withProfiling)(this.setReactRootRenderStart.bind(this), [
            'vc'
        ]);
        this.setReactRootRenderStop = (0, $5Dj3P.withProfiling)(this.setReactRootRenderStop.bind(this), [
            'vc'
        ]);
        this.handleUpdate = (0, $5Dj3P.withProfiling)(this.handleUpdate.bind(this), [
            'vc'
        ]); // TODO: confirm correct value of `this`
        this.legacyHandleUpdate = (0, $5Dj3P.withProfiling)(this.legacyHandleUpdate.bind(this), [
            'vc'
        ]); // TODO: confirm correct value of `this`
        this.onViewportChangeDetected = (0, $5Dj3P.withProfiling)(this.onViewportChangeDetected.bind(this), [
            'vc'
        ]); // TODO: confirm correct value of `this`
        this.setAbortReason = (0, $5Dj3P.withProfiling)(this.setAbortReason.bind(this), [
            'vc'
        ]);
        this.resetState = (0, $5Dj3P.withProfiling)(this.resetState.bind(this), [
            'vc'
        ]);
        this.setViewportSize = (0, $5Dj3P.withProfiling)(this.setViewportSize.bind(this), [
            'vc'
        ]);
        this.mapPixelsToHeatmap = (0, $5Dj3P.withProfiling)(this.mapPixelsToHeatmap.bind(this), [
            'vc'
        ]); // TODO: confirm correct value of `this`
        this.getElementRatio = (0, $5Dj3P.withProfiling)(this.getElementRatio.bind(this), [
            'vc'
        ]); // TODO: confirm correct value of `this`
        this.applyChangesToHeatMap = (0, $5Dj3P.withProfiling)(this.applyChangesToHeatMap.bind(this), [
            'vc'
        ]);
        this.abortReasonCallback = (0, $5Dj3P.withProfiling)(this.abortReasonCallback.bind(this), [
            'vc'
        ]); // TODO: confirm correct value of `this`
        this.attachAbortListeners = (0, $5Dj3P.withProfiling)(this.attachAbortListeners.bind(this), [
            'vc'
        ]); // TODO: confirm correct value of `this`
        this.detachAbortListeners = (0, $5Dj3P.withProfiling)(this.detachAbortListeners.bind(this), [
            'vc'
        ]);
        this.measureStart = (0, $5Dj3P.withProfiling)(this.measureStart.bind(this), [
            'vc'
        ]);
        this.measureStop = (0, $5Dj3P.withProfiling)(this.measureStop.bind(this), [
            'vc'
        ]);
        (0, $5Dj3P.markProfilingEnd)(operationTimer, {
            tags: [
                'vc'
            ]
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(VCObserver, [
        {
            key: "start",
            value: function start(_ref12) {
                var startTime = _ref12.startTime;
                this.active = true;
                if (this.observers.isBrowserSupported()) {
                    this.setViewportSize();
                    this.resetState();
                    this.startTime = startTime;
                    this.attachAbortListeners();
                    this.observers.subscribeResults(this.handleUpdate);
                    this.observers.observe();
                } else this.setAbortReason('not-supported', startTime);
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.observers.disconnect();
                this.detachAbortListeners();
            }
        },
        {
            key: "getIgnoredElements",
            value: function getIgnoredElements(componentsLog) {
                return Object.values(componentsLog).flat().filter(function(_ref13) {
                    var ignoreReason = _ref13.ignoreReason;
                    return Boolean(ignoreReason);
                }).map(function(_ref14) {
                    var targetName = _ref14.targetName, ignoreReason = _ref14.ignoreReason;
                    return {
                        targetName: targetName,
                        ignoreReason: ignoreReason
                    };
                });
            }
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(element) {
                this.observers.setReactRootElement(element);
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.observers.setReactRootRenderStart(startTime);
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.observers.setReactRootRenderStop(stopTime);
            }
        },
        {
            key: "setAbortReason",
            value: function setAbortReason(abort, timestamp) {
                var info = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
                if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                    this.abortReason.reason = abort;
                    this.abortReason.info = info;
                    this.abortReason.timestamp = timestamp;
                    this.abortReason.blocking = abort !== $593f76d3bf0d2070$var$abortReason.scroll;
                    if (this.abortReason.blocking) this.detachAbortListeners();
                }
            }
        },
        {
            key: "resetState",
            value: function resetState() {
                this.abortReason = {
                    reason: null,
                    info: '',
                    timestamp: -1,
                    blocking: false
                };
                this.detachAbortListeners();
                this.heatmap = (0, $f1k1y.fg)('platform_ufo_disable_ttvc_v1') ? [] : this.getCleanHeatmap();
                this.heatmapNext = this.getCleanHeatmap();
                this.multiHeatmap = new (0, $hOsrT.MultiRevisionHeatmap)({
                    viewport: this.viewport,
                    revisions: (0, $xbeRb.getRevisions)(),
                    devToolsEnabled: this.devToolsEnabled
                });
                this.totalTime = 0;
                this.componentsLog = {};
                this.vcRatios = {};
            }
        },
        {
            key: "getCleanHeatmap",
            value: function getCleanHeatmap() {
                var _this2 = this;
                return Array(this.arraySize).fill('').map(function() {
                    return Array(_this2.arraySize).fill($593f76d3bf0d2070$var$UNUSED_SECTOR);
                });
            }
        },
        {
            key: "setViewportSize",
            value: function setViewportSize() {
                this.viewport.w = (0, $5jOXh.getViewportWidth)();
                this.viewport.h = (0, $5jOXh.getViewportHeight)();
            }
        },
        {
            key: "applyChangesToHeatMap",
            value: function applyChangesToHeatMap(a, time, heatmap) {
                var l = a.l, t = a.t, r = a.r, b = a.b;
                var localHeatmap = heatmap;
                for(var row = t; row < b; row++){
                    for(var col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                        try {
                            this.setAbortReason($593f76d3bf0d2070$var$abortReason.error, time, "index - ".concat(row));
                        } catch (e) {
                            this.setAbortReason($593f76d3bf0d2070$var$abortReason.error, time, 'row error');
                        }
                        return;
                    } else localHeatmap[row][col] = time;
                }
            }
        },
        {
            key: "detachAbortListeners",
            value: function detachAbortListeners() {
                this.unbind.forEach(function(fn) {
                    return fn();
                });
                this.unbind = [];
            }
        },
        {
            key: "measureStart",
            value: function measureStart() {
                this._startMeasureTimestamp = performance.now();
            }
        },
        {
            key: "measureStop",
            value: function measureStop() {
                if (this._startMeasureTimestamp === -1) return;
                this.totalTime += performance.now() - this._startMeasureTimestamp;
                this._startMeasureTimestamp = -1;
            }
        }
    ]);
}();
$593f76d3bf0d2070$var$_VCObserver = $593f76d3bf0d2070$export$1f70d263701b1d01;
/** config * */ (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($593f76d3bf0d2070$export$1f70d263701b1d01, "VCParts", [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
]);
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($593f76d3bf0d2070$export$1f70d263701b1d01, "calculateVC", (0, $5Dj3P.withProfiling)(function calculateVC(_ref15) {
    var heatmap = _ref15.heatmap, _ref15$ssr = _ref15.ssr, ssr = _ref15$ssr === void 0 ? $593f76d3bf0d2070$var$UNUSED_SECTOR : _ref15$ssr, componentsLog = _ref15.componentsLog, viewport = _ref15.viewport;
    var lastUpdate = {};
    var totalPainted = 0;
    if (ssr !== $593f76d3bf0d2070$var$UNUSED_SECTOR) {
        var _window$document;
        var element = {
            __debug__element: new WeakRef((_window$document = window.document) === null || _window$document === void 0 ? void 0 : _window$document.body),
            intersectionRect: {
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                x: 0,
                y: 0,
                width: viewport.w,
                height: viewport.h,
                toJSON: function toJSON() {
                    return {};
                }
            },
            targetName: 'SSR'
        };
        if (!componentsLog[ssr]) componentsLog[ssr] = [];
        componentsLog[ssr].push(element);
    }
    heatmap.forEach(function(line) {
        line.forEach(function(entry) {
            var rounded = Math.floor(entry === $593f76d3bf0d2070$var$UNUSED_SECTOR && ssr !== $593f76d3bf0d2070$var$UNUSED_SECTOR ? ssr : entry);
            totalPainted += rounded !== $593f76d3bf0d2070$var$UNUSED_SECTOR ? 1 : 0;
            if (rounded !== $593f76d3bf0d2070$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
        });
    });
    var entries = Object.entries(lastUpdate).map(function(a) {
        return [
            parseInt(a[0], 10),
            a[1]
        ];
    }).sort(function(a, b) {
        return a[0] > b[0] ? 1 : -1;
    });
    var VC = $593f76d3bf0d2070$var$_VCObserver.makeVCReturnObj();
    var VCBox = $593f76d3bf0d2070$var$_VCObserver.makeVCReturnObj();
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    var isCalcSpeedIndexEnabled = (0, $f1k1y.fg)('ufo-calc-speed-index');
    entries.reduce(function() {
        var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var v = arguments.length > 1 ? arguments[1] : undefined;
        var currRatio = v[1] / totalPainted;
        var VCRatio = currRatio + acc;
        var preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
        var preciseAccRatio = Math.round(acc * 100);
        VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
        var time = v[0];
        $593f76d3bf0d2070$var$_VCObserver.VCParts.forEach(function(key) {
            var value = parseInt(key, 10);
            if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                var _componentsLog$time;
                VC[key] = time;
                VCBox[key] = (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(new Set((_componentsLog$time = componentsLog[time]) === null || _componentsLog$time === void 0 ? void 0 : _componentsLog$time.filter(function(v) {
                    return !v.ignoreReason;
                }).map(function(v) {
                    return v.targetName;
                })));
            }
        });
        return VCRatio;
    }, 0);
    var VCEntries = entries.reduce(function(acc, _ref16, i) {
        var _acc$abs, _componentsLog$timest, _acc$rel$vc, _acc$rel;
        var _ref17 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_ref16, 2), timestamp = _ref17[0], entryPainted = _ref17[1];
        var currentlyPainted = entryPainted + (((_acc$abs = acc.abs[i - 1]) === null || _acc$abs === void 0 ? void 0 : _acc$abs[1]) || 0);
        var currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
        var logEntry = (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(new Set((_componentsLog$timest = componentsLog[timestamp]) === null || _componentsLog$timest === void 0 ? void 0 : _componentsLog$timest.filter(function(v) {
            return !v.ignoreReason;
        }).map(function(v) {
            return v.targetName;
        })));
        var ratioDelta = (currentlyPaintedRatio - ((_acc$rel$vc = (_acc$rel = acc.rel[i - 1]) === null || _acc$rel === void 0 ? void 0 : _acc$rel.vc) !== null && _acc$rel$vc !== void 0 ? _acc$rel$vc : 0)) / 100;
        if (isCalcSpeedIndexEnabled) {
            var speedIndex = timestamp * ratioDelta;
            acc.speedIndex += speedIndex;
        }
        acc.abs.push([
            timestamp,
            currentlyPainted
        ]);
        acc.rel.push({
            time: timestamp,
            vc: currentlyPaintedRatio,
            elements: logEntry
        });
        return acc;
    }, {
        abs: [],
        rel: [],
        speedIndex: 0
    });
    VCEntries.speedIndex = Math.round(VCEntries.speedIndex);
    return {
        VC: VC,
        VCBox: VCBox,
        VCEntries: VCEntries,
        totalPainted: totalPainted
    };
}, [
    'vc'
]));
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($593f76d3bf0d2070$export$1f70d263701b1d01, "makeVCReturnObj", (0, $5Dj3P.withProfiling)(function makeVCReturnObj() {
    var vc = {};
    $593f76d3bf0d2070$var$_VCObserver.VCParts.forEach(function(v) {
        vc[v] = null;
    });
    return vc;
}, [
    'vc'
]));

});
parcelRegister("7kZto", function(module, exports) {

$parcel$export(module.exports, "attachAbortListeners", function () { return $557a15e937a90413$export$9010aa71841a6887; });

var $aA6j8 = parcelRequire("aA6j8");

var $7CwM6 = parcelRequire("7CwM6");

var $5Dj3P = parcelRequire("5Dj3P");

var $5jOXh = parcelRequire("5jOXh");
var $557a15e937a90413$export$9010aa71841a6887 = (0, $5Dj3P.withProfiling)(function attachAbortListeners(window, initialViewPort, callback) {
    var unbindWheel = (0, $aA6j8.bind)(window, {
        type: (0, $7CwM6.AbortEvent).wheel,
        listener: function listener(e) {
            callback((0, $7CwM6.AbortEvent).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    var unbindKeydown = (0, $aA6j8.bind)(window, {
        type: (0, $7CwM6.AbortEvent).keydown,
        listener: function listener(e) {
            callback((0, $7CwM6.AbortEvent).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    var unbindResize = (0, $aA6j8.bind)(window, {
        type: (0, $7CwM6.AbortEvent).resize,
        listener: function listener(e) {
            if ((0, $5jOXh.getViewportWidth)() !== initialViewPort.w || (0, $5jOXh.getViewportHeight)() !== initialViewPort.h) {
                callback((0, $7CwM6.AbortEvent).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
}, [
    'vc'
]);

});
parcelRegister("7CwM6", function(module, exports) {

$parcel$export(module.exports, "AbortEvent", function () { return $58c5816416165bd5$export$199edc0307b5587f; });
var $58c5816416165bd5$export$199edc0307b5587f = {
    wheel: 'wheel',
    keydown: 'keydown',
    resize: 'resize'
};

});

parcelRegister("5jOXh", function(module, exports) {

$parcel$export(module.exports, "getViewportWidth", function () { return $3df640bca57a6c0a$export$a497a1dcb4408212; });
$parcel$export(module.exports, "getViewportHeight", function () { return $3df640bca57a6c0a$export$4f01c15d21ef9cc6; });

var $5Dj3P = parcelRequire("5Dj3P");
var $3df640bca57a6c0a$export$a497a1dcb4408212 = (0, $5Dj3P.withProfiling)(function getViewportWidth() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (e) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}, [
    'vc'
]);
var $3df640bca57a6c0a$export$4f01c15d21ef9cc6 = (0, $5Dj3P.withProfiling)(function getViewportHeight() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (e) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}, [
    'vc'
]);

});


parcelRegister("dI1SJ", function(module, exports) {

$parcel$export(module.exports, "getVCRevisionsData", function () { return $9fb0d81f49b563ee$export$5c86a34c9becd6d0; });

var $dsN6L = parcelRequire("dsN6L");

var $f1k1y = parcelRequire("f1k1y");

var $hvnV0 = parcelRequire("hvnV0");

var $5Dj3P = parcelRequire("5Dj3P");

var $xbeRb = parcelRequire("xbeRb");
var $9fb0d81f49b563ee$var$VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];
var $9fb0d81f49b563ee$var$READONLY_EMPTY_ARRAY = Array.from({
    length: 0
});
// Helper function to create vcDetails object to avoid code duplication
var $9fb0d81f49b563ee$var$createVCDetails = (0, $5Dj3P.withProfiling)(function createVCDetails(calculatedVC, shouldHaveVCmetric) {
    if (!shouldHaveVCmetric || !calculatedVC || !calculatedVC.VC || !calculatedVC.VCBox) return {};
    var details = {};
    var VC = calculatedVC.VC, VCBox = calculatedVC.VCBox; // Destructure once to avoid repeated property access
    for(var _i = 0, _VCParts = $9fb0d81f49b563ee$var$VCParts; _i < _VCParts.length; _i++){
        var key = _VCParts[_i];
        details[key] = {
            t: VC[key],
            e: VCBox[key] || $9fb0d81f49b563ee$var$READONLY_EMPTY_ARRAY
        };
    }
    return details;
}, [
    'vc'
]);
var $9fb0d81f49b563ee$export$5c86a34c9becd6d0 = (0, $5Dj3P.withProfiling)(function getVCRevisionsData(_ref) {
    var fullPrefix = _ref.fullPrefix, interaction = _ref.interaction, isVCClean = _ref.isVCClean, isEventAborted = _ref.isEventAborted, multiHeatmap = _ref.multiHeatmap, ssr = _ref.ssr, calculatedVC = _ref.calculatedVC, calculatedVCNext = _ref.calculatedVCNext;
    if (!(0, $f1k1y.fg)('platform_ufo_vc_observer_new')) {
        if (!multiHeatmap) return null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, "".concat(fullPrefix, "vc:rev"), multiHeatmap === null || multiHeatmap === void 0 ? void 0 : multiHeatmap.getPayloadShapedData({
            VCParts: $9fb0d81f49b563ee$var$VCParts.map(function(v) {
                return parseInt(v);
            }),
            VCCalculationMethods: (0, $xbeRb.getRevisions)().map(function(_ref2) {
                var classifier = _ref2.classifier;
                return classifier.VCCalculationMethod;
            }),
            filterComponentsLog: (0, $xbeRb.getRevisions)().map(function(_ref3) {
                var classifier = _ref3.classifier;
                return classifier.filterComponentsLog;
            }),
            isEventAborted: isEventAborted,
            interactionStart: interaction.start,
            ttai: interaction.end,
            ssr: ssr,
            clean: isVCClean
        }));
    }
    // Calculate these conditions once
    var pageVisibilityUpToTTAI = (0, $hvnV0.getPageVisibilityState)(interaction.start, interaction.end);
    var isVisiblePageVisibleUpToTTAI = pageVisibilityUpToTTAI === 'visible';
    var shouldHaveVCmetric = isVCClean && !isEventAborted && isVisiblePageVisibleUpToTTAI;
    // Create the V2 revision object which is always needed
    var ttvcV2Revision = {
        revision: 'fy25.02',
        clean: isVCClean,
        'metric:vc90': shouldHaveVCmetric ? calculatedVCNext.VC['90'] : null,
        vcDetails: $9fb0d81f49b563ee$var$createVCDetails(calculatedVCNext, shouldHaveVCmetric)
    };
    if ((0, $f1k1y.fg)('platform_ufo_disable_ttvc_v1')) return (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, "".concat(fullPrefix, "vc:rev"), [
        ttvcV2Revision
    ]);
    // Only create ttvcV1Revision when we're actually going to use it
    var ttvcV1Revision = {
        revision: 'fy25.01',
        clean: isVCClean,
        'metric:vc90': shouldHaveVCmetric ? calculatedVC.VC['90'] : null,
        vcDetails: $9fb0d81f49b563ee$var$createVCDetails(calculatedVC, shouldHaveVCmetric)
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, "".concat(fullPrefix, "vc:rev"), [
        ttvcV1Revision,
        ttvcV2Revision
    ]);
}, [
    'vc'
]);

});
parcelRegister("xbeRb", function(module, exports) {

$parcel$export(module.exports, "getRevisions", function () { return $063bccf07c4973ac$export$3a6bcaa2795a58f8; });

var $f1k1y = parcelRequire("f1k1y");

var $5Dj3P = parcelRequire("5Dj3P");

var $hOtaV = parcelRequire("hOtaV");

var $gL75Q = parcelRequire("gL75Q");
var $063bccf07c4973ac$export$3a6bcaa2795a58f8 = (0, $5Dj3P.withProfiling)(function getRevisions() {
    if ((0, $f1k1y.fg)('platform_ufo_disable_ttvc_v1')) return [
        {
            name: 'fy25.02',
            classifier: (0, $gL75Q.revFY25_02Classifier)
        }
    ];
    return [
        {
            name: 'fy25.01',
            classifier: (0, $hOtaV.revFY25_01Classifier)
        },
        {
            name: 'fy25.02',
            classifier: (0, $gL75Q.revFY25_02Classifier)
        }
    ];
}, [
    'vc'
]);

});
parcelRegister("hOtaV", function(module, exports) {

$parcel$export(module.exports, "FY25_01Classifier", function () { return $cf7dbcc6030aa4db$export$1287fed0f253eee5; });
$parcel$export(module.exports, "revFY25_01Classifier", function () { return $cf7dbcc6030aa4db$export$d822caadc9ee5453; });

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $gGOBY = parcelRequire("gGOBY");

var $lVDuE = parcelRequire("lVDuE");

var $kSyoi = parcelRequire("kSyoi");

var $dsN6L = parcelRequire("dsN6L");

var $5Dj3P = parcelRequire("5Dj3P");

var $fq6hO = parcelRequire("fq6hO");
function $cf7dbcc6030aa4db$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($gGOBY)))(t, $cf7dbcc6030aa4db$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(t).constructor) : o.apply(t, e));
}
function $cf7dbcc6030aa4db$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($cf7dbcc6030aa4db$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $cf7dbcc6030aa4db$var$legacyIgnoreReasons = [
    'image',
    'ssr-hydration',
    'editor-lazy-node-view',
    'editor-container-mutation'
];
var $cf7dbcc6030aa4db$export$1287fed0f253eee5 = /*#__PURE__*/ function(_ViewportUpdateClassi) {
    function FY25_01Classifier() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, FY25_01Classifier);
        _this = $cf7dbcc6030aa4db$var$_callSuper(this, FY25_01Classifier);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "revision", 'fy25.01');
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "types", [
            'html',
            'text'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "filters", [
            {
                name: 'default-ignore-reasons',
                filter: function filter(_ref) {
                    var type = _ref.type, ignoreReason = _ref.ignoreReason;
                    return !ignoreReason || !$cf7dbcc6030aa4db$var$legacyIgnoreReasons.includes(ignoreReason);
                }
            }
        ]);
        _this.mergeConfig();
        _this.VCCalculationMethod = (0, $5Dj3P.withProfiling)(_this.VCCalculationMethod.bind(_this), [
            'vc'
        ]);
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($kSyoi)))(FY25_01Classifier, _ViewportUpdateClassi);
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(FY25_01Classifier, [
        {
            key: "VCCalculationMethod",
            value: function VCCalculationMethod(_ref2) {
                var VCParts = _ref2.VCParts, entries = _ref2.entries, totalPainted = _ref2.totalPainted, componentsLog = _ref2.componentsLog;
                var VC = {};
                var VCBox = {};
                entries.reduce(function() {
                    var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    var v = arguments.length > 1 ? arguments[1] : undefined;
                    var VCRatio = v[1] / totalPainted + acc;
                    var time = v[0];
                    // @todo apply fix to include small changes into accumulator
                    var preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
                    var preciseAccRatio = Math.round(acc * 100);
                    VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
                    VCParts.forEach(function(value) {
                        if ((VC[value] === null || VC[value] === undefined) && VCRatio >= value / 100) {
                            var _componentsLog$time;
                            VC[value] = time;
                            VCBox[value] = new Set();
                            (_componentsLog$time = componentsLog[time]) === null || _componentsLog$time === void 0 || _componentsLog$time.forEach(function(v) {
                                var _VCBox$value;
                                return (_VCBox$value = VCBox[value]) === null || _VCBox$value === void 0 ? void 0 : _VCBox$value.add(v.targetName);
                            });
                        }
                    });
                    return VCRatio;
                }, 0);
                return {
                    VC: VC,
                    VCBox: VCBox
                };
            }
        }
    ]);
}((0, $fq6hO.ViewportUpdateClassifier));
var $cf7dbcc6030aa4db$export$d822caadc9ee5453 = new $cf7dbcc6030aa4db$export$1287fed0f253eee5();

});
parcelRegister("fq6hO", function(module, exports) {

$parcel$export(module.exports, "ViewportUpdateClassifier", function () { return $b39e2908520f5b85$export$66a5f74f04eab7df; });

var $iqLBO = parcelRequire("iqLBO");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $dsN6L = parcelRequire("dsN6L");
var $b39e2908520f5b85$export$66a5f74f04eab7df = /*#__PURE__*/ function() {
    function ViewportUpdateClassifier() {
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, ViewportUpdateClassifier);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "types", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "filters", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "removedFilters", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "__combinedTypes", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "__combinedFilters", []);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(ViewportUpdateClassifier, [
        {
            key: "VCCalculationMethod",
            value: function VCCalculationMethod(_) {
                return {
                    VC: {},
                    VCBox: {}
                };
            }
        },
        {
            key: "filterComponentsLog",
            value: function filterComponentsLog(_ref) {
                var componentsLog = _ref.componentsLog;
                return componentsLog;
            }
        },
        {
            key: "mergeConfig",
            value: function mergeConfig() {
                var _this = this;
                this.__combinedTypes = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(this.types), (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))((this === null || this === void 0 ? void 0 : this.__combinedTypes) || []));
                var previousFilters = this.removedFilters.length === 0 ? this.__combinedFilters : this.__combinedFilters.filter(function(filter) {
                    return !_this.removedFilters.includes(filter.name);
                });
                this.__combinedFilters = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(this.filters), (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(previousFilters));
            }
        },
        {
            key: "classifyUpdate",
            value: function classifyUpdate(_ref2) {
                var element = _ref2.element, type = _ref2.type, tags = _ref2.tags, ignoreReason = _ref2.ignoreReason;
                if (!this.__combinedTypes.includes(type)) return false;
                return this.__combinedFilters.every(function(_ref3) {
                    var filter = _ref3.filter, name = _ref3.name;
                    return filter({
                        type: type,
                        tags: tags,
                        ignoreReason: ignoreReason
                    });
                });
            }
        }
    ]);
}();

});


parcelRegister("gL75Q", function(module, exports) {

$parcel$export(module.exports, "revFY25_02Classifier", function () { return $c33689aff09083ab$export$624b2c3760a5ab41; });

var $5YM7L = parcelRequire("5YM7L");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $gGOBY = parcelRequire("gGOBY");

var $lVDuE = parcelRequire("lVDuE");

var $kSyoi = parcelRequire("kSyoi");

var $dsN6L = parcelRequire("dsN6L");

var $5Dj3P = parcelRequire("5Dj3P");

var $hOtaV = parcelRequire("hOtaV");
function $c33689aff09083ab$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($gGOBY)))(t, $c33689aff09083ab$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(t).constructor) : o.apply(t, e));
}
function $c33689aff09083ab$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c33689aff09083ab$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $c33689aff09083ab$export$d8e8ccb82df07b7c = /*#__PURE__*/ function(_FY25_01Classifier) {
    function FY25_02Classifier() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, FY25_02Classifier);
        _this = $c33689aff09083ab$var$_callSuper(this, FY25_02Classifier);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "revision", 'fy25.02');
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "types", [
            'attr'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "filters", [
            {
                name: 'not-visible',
                filter: function filter(_ref) {
                    var type = _ref.type, ignoreReason = _ref.ignoreReason;
                    return !(ignoreReason !== null && ignoreReason !== void 0 && ignoreReason.includes('not-visible')) && ignoreReason !== 'non-visual-style';
                }
            }
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "removedFilters", []);
        _this.mergeConfig();
        _this.filterComponentsLog = (0, $5Dj3P.withProfiling)(_this.filterComponentsLog.bind(_this), [
            'vc'
        ]);
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($kSyoi)))(FY25_02Classifier, _FY25_01Classifier);
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(FY25_02Classifier, [
        {
            key: "filterComponentsLog",
            value: // @todo remove it once fixed as described: https://product-fabric.atlassian.net/browse/AFO-3443
            function filterComponentsLog(_ref2) {
                var componentsLog = _ref2.componentsLog, ttai = _ref2.ttai;
                var _componentsLog = {};
                Object.entries(componentsLog).forEach(function(_ref3) {
                    var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_ref3, 2), _timestamp = _ref4[0], value = _ref4[1];
                    var timestamp = Number(_timestamp);
                    if (Math.ceil(ttai) >= timestamp) _componentsLog[timestamp] = value;
                });
                return _componentsLog;
            }
        }
    ]);
}((0, $hOtaV.FY25_01Classifier));
var $c33689aff09083ab$export$624b2c3760a5ab41 = new $c33689aff09083ab$export$d8e8ccb82df07b7c();

});



parcelRegister("hOsrT", function(module, exports) {

$parcel$export(module.exports, "MultiRevisionHeatmap", function () { return $cf7d2c8e09191a2c$export$40923620784ea2c1; });

var $5YM7L = parcelRequire("5YM7L");

var $lwsBr = parcelRequire("lwsBr");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $dsN6L = parcelRequire("dsN6L");

var $hvnV0 = parcelRequire("hvnV0");

var $5Dj3P = parcelRequire("5Dj3P");
var $cf7d2c8e09191a2c$var$UNUSED_SECTOR = 0;
var $cf7d2c8e09191a2c$export$40923620784ea2c1 = /*#__PURE__*/ function() {
    function MultiRevisionHeatmap(_ref) {
        var _this = this;
        var viewport = _ref.viewport, revisions = _ref.revisions, arraySize = _ref.arraySize, devToolsEnabled = _ref.devToolsEnabled;
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, MultiRevisionHeatmap);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "arraySize", {
            w: 200,
            h: 200
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "mapPixelsToHeatmap", function(left, top, width, height) {
            var _this$viewport = _this.viewport, w = _this$viewport.w, h = _this$viewport.h;
            var l = Math.floor(left / w * _this.arraySize.w);
            var t = Math.floor(top / h * _this.arraySize.h);
            var r = Math.ceil((left + width) / w * _this.arraySize.w);
            var b = Math.ceil((top + height) / h * _this.arraySize.h);
            // correct values to min - 0, max - arraySize
            var result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(_this.arraySize.w, r),
                b: Math.min(_this.arraySize.h, b)
            };
            return result;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "getElementRatio", function(mappedValues) {
            var r = mappedValues.r, l = mappedValues.l, b = mappedValues.b, t = mappedValues.t;
            return (r - l) * (b - t) / (_this.arraySize.w * _this.arraySize.h);
        });
        var operationTimer = (0, $5Dj3P.markProfilingStart)('MultiRevisionHeatmap constructor');
        this.viewport = viewport;
        this.revisions = revisions;
        if (arraySize) this.arraySize = arraySize;
        this.heatmaps = new Array(revisions.length);
        this.componentsLogs = new Array(revisions.length);
        this.vcRatios = new Array(revisions.length);
        this.devToolsEnabled = devToolsEnabled || false;
        revisions.forEach(function(_ref2, i) {
            (0, (/*@__PURE__*/$parcel$interopDefault($lwsBr)))(_ref2);
            _this.heatmaps[i] = _this.getCleanHeatmap();
            _this.componentsLogs[i] = {};
            _this.vcRatios[i] = {};
        });
        this.handleUpdate = (0, $5Dj3P.withProfiling)(this.handleUpdate.bind(this), [
            'vc'
        ]);
        this.getData = (0, $5Dj3P.withProfiling)(this.getData.bind(this), [
            'vc'
        ]);
        this.getPayloadShapedData = (0, $5Dj3P.withProfiling)(this.getPayloadShapedData.bind(this), [
            'vc'
        ]);
        this.processData = (0, $5Dj3P.withProfiling)(this.processData.bind(this), [
            'vc'
        ]);
        this.mapPixelsToHeatmap = (0, $5Dj3P.withProfiling)(this.mapPixelsToHeatmap.bind(this), [
            'vc'
        ]);
        this.getElementRatio = (0, $5Dj3P.withProfiling)(this.getElementRatio.bind(this), [
            'vc'
        ]);
        this.applyChangesToHeatMap = (0, $5Dj3P.withProfiling)(this.applyChangesToHeatMap.bind(this), [
            'vc'
        ]);
        this.getIndex = (0, $5Dj3P.withProfiling)(this.getIndex.bind(this), [
            'vc'
        ]);
        this.getCleanHeatmap = (0, $5Dj3P.withProfiling)(this.getCleanHeatmap.bind(this), [
            'vc'
        ]);
        (0, $5Dj3P.markProfilingEnd)(operationTimer);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(MultiRevisionHeatmap, [
        {
            key: "handleUpdate",
            value: function handleUpdate(_ref3) {
                var _this2 = this;
                var time = _ref3.time, type = _ref3.type, classification = _ref3.classification, intersectionRect = _ref3.intersectionRect, element = _ref3.element, targetName = _ref3.targetName, ignoreReason = _ref3.ignoreReason, onError = _ref3.onError, attributeName = _ref3.attributeName, oldValue = _ref3.oldValue, newValue = _ref3.newValue;
                var mappedValues = this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                var result = this.applyChangesToHeatMap(mappedValues, time, classification);
                if (result !== true) onError(result);
                var componentRatio = this.getElementRatio(mappedValues);
                this.revisions.forEach(function(_, i) {
                    if (classification[i]) _this2.vcRatios[i][targetName] = componentRatio;
                    if (!_this2.componentsLogs[i][time]) _this2.componentsLogs[i][time] = [];
                    _this2.componentsLogs[i][time].push({
                        __debug__element: _this2.devToolsEnabled ? new WeakRef(element) : null,
                        intersectionRect: intersectionRect,
                        targetName: targetName,
                        ignoreReason: ignoreReason,
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    });
                });
            }
        },
        {
            key: "getData",
            value: function getData() {
                return {
                    heatmaps: this.heatmaps
                };
            }
        },
        {
            key: "getPayloadShapedData",
            value: function getPayloadShapedData(args) {
                var pageVisibilityUpToTTAI = (0, $hvnV0.getPageVisibilityState)(args.interactionStart, args.ttai);
                var result = this.processData(args);
                var payload = this.revisions.map(function(rev, i) {
                    var _vcDetails$;
                    var vcDetails = {};
                    args.VCParts.forEach(function(VCPart) {
                        vcDetails[VCPart] = {
                            t: result[i].VC[VCPart] || 0,
                            e: Array.from(result[i].VCBox[VCPart] || [])
                        };
                    });
                    return {
                        revision: rev.name,
                        vcDetails: vcDetails,
                        clean: args.clean,
                        'metric:vc90': args.clean && !args.isEventAborted && pageVisibilityUpToTTAI === 'visible' ? vcDetails === null || vcDetails === void 0 || (_vcDetails$ = vcDetails['90']) === null || _vcDetails$ === void 0 ? void 0 : _vcDetails$.t : null
                    };
                });
                return payload;
            }
        },
        {
            key: "processData",
            value: function processData(_ref4) {
                var _this3 = this;
                var VCParts = _ref4.VCParts, VCCalculationMethods = _ref4.VCCalculationMethods, filterComponentsLog = _ref4.filterComponentsLog, ttai = _ref4.ttai, _ref4$ssr = _ref4.ssr, ssr = _ref4$ssr === void 0 ? $cf7d2c8e09191a2c$var$UNUSED_SECTOR : _ref4$ssr;
                return this.heatmaps.map(function(heatmap, i) {
                    var lastUpdate = {};
                    var totalPainted = 0;
                    var componentsLog = _this3.componentsLogs[i];
                    if (ssr !== $cf7d2c8e09191a2c$var$UNUSED_SECTOR) {
                        var _window$document;
                        var element = {
                            __debug__element: new WeakRef((_window$document = window.document) === null || _window$document === void 0 ? void 0 : _window$document.body),
                            intersectionRect: {
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                x: 0,
                                y: 0,
                                width: _this3.viewport.w,
                                height: _this3.viewport.h,
                                toJSON: function toJSON() {
                                    return {};
                                }
                            },
                            targetName: 'SSR'
                        };
                        if (!componentsLog[ssr]) componentsLog[ssr] = [];
                        componentsLog[ssr].push(element);
                    }
                    for(var _i = 0; _i < heatmap.length; _i++){
                        var rounded = Math.floor(heatmap[_i] === $cf7d2c8e09191a2c$var$UNUSED_SECTOR && ssr !== $cf7d2c8e09191a2c$var$UNUSED_SECTOR ? ssr : heatmap[_i]);
                        totalPainted += rounded !== $cf7d2c8e09191a2c$var$UNUSED_SECTOR ? 1 : 0;
                        if (rounded !== $cf7d2c8e09191a2c$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
                    }
                    var entries = Object.entries(lastUpdate).map(function(a) {
                        return [
                            parseInt(a[0], 10),
                            a[1]
                        ];
                    }).sort(function(a, b) {
                        return a[0] > b[0] ? 1 : -1;
                    });
                    // @todo remove it once fixed as described: https://product-fabric.atlassian.net/browse/AFO-3443
                    componentsLog = filterComponentsLog[i]({
                        componentsLog: componentsLog,
                        ttai: ttai
                    });
                    var _VCCalculationMethods = VCCalculationMethods[i]({
                        VCParts: VCParts,
                        componentsLog: componentsLog,
                        entries: entries,
                        totalPainted: totalPainted
                    }), VC = _VCCalculationMethods.VC, VCBox = _VCCalculationMethods.VCBox;
                    var VCEntries = entries.reduce(function(acc, _ref5, i) {
                        var _acc$abs, _componentsLog$timest;
                        var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_ref5, 2), timestamp = _ref6[0], entryPainted = _ref6[1];
                        var currentlyPainted = entryPainted + (((_acc$abs = acc.abs[i - 1]) === null || _acc$abs === void 0 ? void 0 : _acc$abs[1]) || 0);
                        var currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
                        var logEntry = (_componentsLog$timest = componentsLog[timestamp]) === null || _componentsLog$timest === void 0 ? void 0 : _componentsLog$timest.map(function(v) {
                            return v.targetName;
                        });
                        acc.abs.push([
                            timestamp,
                            currentlyPainted
                        ]);
                        acc.rel.push({
                            time: timestamp,
                            vc: currentlyPaintedRatio,
                            elements: logEntry
                        });
                        return acc;
                    }, {
                        abs: [],
                        rel: []
                    });
                    return {
                        VC: VC,
                        VCBox: VCBox,
                        VCEntries: VCEntries,
                        totalPainted: totalPainted
                    };
                });
            }
        },
        {
            key: "applyChangesToHeatMap",
            value: function applyChangesToHeatMap(a, time, classification) {
                var l = a.l, t = a.t, r = a.r, b = a.b;
                var size = classification.length;
                for(var row = t; row < b; row++){
                    if (this.heatmaps[0][row] === undefined) try {
                        return {
                            error: "index - ".concat(row),
                            time: time
                        };
                    } catch (e) {
                        return {
                            error: 'row error',
                            time: time
                        };
                    }
                    else {
                        for(var heatmapIndex = 0; heatmapIndex < size; heatmapIndex++)if (classification[heatmapIndex]) this.heatmaps[heatmapIndex].fill(time, this.getIndex(l, row), this.getIndex(r, row));
                    }
                }
                return true;
            }
        },
        {
            key: "getIndex",
            value: function getIndex(x, y) {
                return x + this.arraySize.w * y;
            }
        },
        {
            key: "getCleanHeatmap",
            value: function getCleanHeatmap() {
                return new Int32Array(this.arraySize.w * this.arraySize.h);
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($cf7d2c8e09191a2c$export$40923620784ea2c1, "makeVCReturnObj", (0, $5Dj3P.withProfiling)(function makeVCReturnObj(VCParts) {
    var vc = {};
    VCParts.forEach(function(v) {
        vc[v] = null;
    });
    return vc;
}, [
    'vc'
]));

});

parcelRegister("iLSkI", function(module, exports) {

$parcel$export(module.exports, "Observers", function () { return $daa6c3352b6cb7d5$export$b65d046240060e78; });

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $dsN6L = parcelRequire("dsN6L");

var $f1k1y = parcelRequire("f1k1y");

var $h6MYR = parcelRequire("h6MYR");

var $5Dj3P = parcelRequire("5Dj3P");

var $U9jzZ = parcelRequire("U9jzZ");

var $julQm = parcelRequire("julQm");

var $6cg1G = parcelRequire("6cg1G");

var $lWu86 = parcelRequire("lWu86");
function $daa6c3352b6cb7d5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $daa6c3352b6cb7d5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $daa6c3352b6cb7d5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $daa6c3352b6cb7d5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $daa6c3352b6cb7d5$var$state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
var $daa6c3352b6cb7d5$var$isElementVisible = (0, $5Dj3P.withProfiling)(function isElementVisible(target) {
    if (!target || typeof target.checkVisibility !== 'function') return true;
    var isVisible = target.checkVisibility({
        contentVisibilityAuto: true,
        opacityProperty: true,
        visibilityProperty: true
    });
    return isVisible;
}, [
    'vc'
]);
var $daa6c3352b6cb7d5$var$isInsideEditorContainer = (0, $5Dj3P.withProfiling)(function isInsideEditorContainer(target) {
    if (!target || typeof target.closest !== 'function') return false;
    return Boolean(target.closest('.ProseMirror'));
}, [
    'vc'
]);
var $daa6c3352b6cb7d5$export$b65d046240060e78 = /*#__PURE__*/ function() {
    function Observers(opts) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, Observers);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "observedMutations", new WeakMap());
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "elementsInView", new Set());
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "callbacks", new Set());
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "totalTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_startMeasureTimestamp", -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "ssr", {
            state: $daa6c3352b6cb7d5$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "selectorConfig", {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "subscribeResults", function(cb) {
            _this.callbacks.add(cb);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "observeElement", function(node, mutation, type, ignoreReason, attributeName) {
            var _this$intersectionObs;
            var oldValue = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
            var newValue = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
            (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.observe(node);
            if ((0, $f1k1y.fg)('platform_ufo_log_attr_mutation_values')) _this.observedMutations.set(node, {
                mutation: mutation,
                ignoreReason: ignoreReason,
                type: type,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
            else _this.observedMutations.set(node, {
                mutation: mutation,
                ignoreReason: ignoreReason,
                type: type
            });
        });
        var operationTimer = (0, $5Dj3P.markProfilingStart)('Observers constructor');
        this.selectorConfig = $daa6c3352b6cb7d5$var$_objectSpread($daa6c3352b6cb7d5$var$_objectSpread({}, this.selectorConfig), opts.selectorConfig);
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        this.ssrPlaceholderHandler = new (0, $lWu86.SSRPlaceholderHandlers)();
        this.editorLnvHandler = new (0, $julQm.EditorLnvHandler)();
        this.isBrowserSupported = (0, $5Dj3P.withProfiling)(this.isBrowserSupported.bind(this), [
            'vc'
        ]);
        this.observe = (0, $5Dj3P.withProfiling)(this.observe.bind(this), [
            'vc'
        ]);
        this.disconnect = (0, $5Dj3P.withProfiling)(this.disconnect.bind(this), [
            'vc'
        ]);
        this.subscribeResults = (0, $5Dj3P.withProfiling)(this.subscribeResults.bind(this), [
            'vc'
        ]);
        this.getTotalTime = (0, $5Dj3P.withProfiling)(this.getTotalTime.bind(this), [
            'vc'
        ]);
        this.setReactRootElement = (0, $5Dj3P.withProfiling)(this.setReactRootElement.bind(this), [
            'vc'
        ]);
        this.setReactRootRenderStart = (0, $5Dj3P.withProfiling)(this.setReactRootRenderStart.bind(this), [
            'vc'
        ]);
        this.setReactRootRenderStop = (0, $5Dj3P.withProfiling)(this.setReactRootRenderStop.bind(this), [
            'vc'
        ]);
        this.observeElement = (0, $5Dj3P.withProfiling)(this.observeElement.bind(this), [
            'vc'
        ]);
        this.getMutationObserver = (0, $5Dj3P.withProfiling)(this.getMutationObserver.bind(this), [
            'vc'
        ]);
        this.getElementName = (0, $5Dj3P.withProfiling)(this.getElementName.bind(this), [
            'vc'
        ]);
        this.getIntersectionObserver = (0, $5Dj3P.withProfiling)(this.getIntersectionObserver.bind(this), [
            'vc'
        ]);
        this.measureStart = (0, $5Dj3P.withProfiling)(this.measureStart.bind(this), [
            'vc'
        ]);
        this.measureStop = (0, $5Dj3P.withProfiling)(this.measureStop.bind(this), [
            'vc'
        ]);
        (0, $5Dj3P.markProfilingEnd)(operationTimer, {
            tags: [
                'vc'
            ]
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(Observers, [
        {
            key: "isBrowserSupported",
            value: function isBrowserSupported() {
                return typeof window.IntersectionObserver === 'function' && typeof window.MutationObserver === 'function';
            }
        },
        {
            key: "observe",
            value: function observe() {
                var _this$mutationObserve;
                this.totalTime = 0;
                this.ssr = {
                    state: $daa6c3352b6cb7d5$var$state.normal,
                    reactRootElement: null,
                    renderStart: -1,
                    renderStop: -1
                };
                (_this$mutationObserve = this.mutationObserver) === null || _this$mutationObserve === void 0 || _this$mutationObserve.observe(document.body, {
                    attributeFilter: [
                        'hidden',
                        'style',
                        'src',
                        'class'
                    ],
                    attributeOldValue: true,
                    attributes: true,
                    childList: true,
                    subtree: true
                });
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                var _this$mutationObserve2, _this$intersectionObs2;
                (_this$mutationObserve2 = this.mutationObserver) === null || _this$mutationObserve2 === void 0 || _this$mutationObserve2.disconnect();
                (_this$intersectionObs2 = this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.disconnect();
                this.observedMutations = new WeakMap();
                this.elementsInView = new Set();
                this.callbacks = new Set();
                this.ssr.reactRootElement = null;
                this.ssrPlaceholderHandler.clear();
                this.editorLnvHandler.clear();
            }
        },
        {
            key: "getTotalTime",
            value: function getTotalTime() {
                return this.totalTime;
            }
        },
        {
            key: "setReactRootElement",
            value: function setReactRootElement(element) {
                this.ssr.reactRootElement = element;
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStart = startTime;
                this.ssr.state = $daa6c3352b6cb7d5$var$state.waitingForFirstRender;
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStop = stopTime;
            }
        },
        {
            key: "getMutationObserver",
            value: function getMutationObserver() {
                var _this2 = this;
                if (!this.isBrowserSupported()) return null;
                var shouldHandleEditorLnvLocal = (0, $h6MYR.shouldHandleEditorLnv)();
                return new MutationObserver(function(mutations) {
                    var operationTimer = (0, $5Dj3P.markProfilingStart)('mutationObserverCallback');
                    _this2.measureStart();
                    mutations.forEach(function(mutation) {
                        // patching element if timestamp not automatically added
                        // eslint-disable-next-line no-param-reassign
                        mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                        var ignoreReason = '';
                        if (_this2.ssr.state === $daa6c3352b6cb7d5$var$state.waitingForFirstRender && mutation.timestamp > _this2.ssr.renderStart && mutation.target === _this2.ssr.reactRootElement) {
                            _this2.ssr.state = $daa6c3352b6cb7d5$var$state.ignoring;
                            if (_this2.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                            _this2.ssr.renderStop = mutation.timestamp + 500;
                            ignoreReason = 'ssr-hydration';
                        }
                        if (_this2.ssr.state === $daa6c3352b6cb7d5$var$state.ignoring && mutation.timestamp > _this2.ssr.renderStart && mutation.target === _this2.ssr.reactRootElement) {
                            if (mutation.timestamp <= _this2.ssr.renderStop) ignoreReason = 'ssr-hydration';
                            else _this2.ssr.state = $daa6c3352b6cb7d5$var$state.normal;
                        }
                        if (mutation.type === 'childList') {
                            mutation.addedNodes.forEach(function(node) {
                                if ((0, $U9jzZ.isContainedWithinMediaWrapper)(node)) ignoreReason = 'image';
                                if (node instanceof HTMLElement) {
                                    if (_this2.ssrPlaceholderHandler.isPlaceholder(node) || _this2.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                        _this2.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then(function(result) {
                                            if (result === false) _this2.observeElement(node, mutation, 'html', ignoreReason);
                                        });
                                        return;
                                    }
                                    if (_this2.ssrPlaceholderHandler.isPlaceholderReplacement(node) || _this2.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                        _this2.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then(function(result) {
                                            if (result === false) _this2.observeElement(node, mutation, 'html', ignoreReason);
                                        });
                                        return;
                                    }
                                    if (shouldHandleEditorLnvLocal) {
                                        if (_this2.editorLnvHandler.shouldHandleAddedNode(node)) {
                                            _this2.editorLnvHandler.handleAddedNode(node).then(function(_ref) {
                                                var shouldIgnore = _ref.shouldIgnore;
                                                _this2.observeElement(node, mutation, 'html', shouldIgnore ? 'editor-lazy-node-view' : ignoreReason);
                                            });
                                            return;
                                        }
                                    }
                                    _this2.observeElement(node, mutation, 'html', ignoreReason);
                                }
                                if (node instanceof Text && node.parentElement != null) _this2.observeElement(node.parentElement, mutation, 'text', ignoreReason);
                            });
                            mutation.removedNodes.forEach(function(node) {
                                if (node instanceof Element) {
                                    var _this2$intersectionOb;
                                    _this2.elementsInView.delete(node);
                                    (_this2$intersectionOb = _this2.intersectionObserver) === null || _this2$intersectionOb === void 0 || _this2$intersectionOb.unobserve(node);
                                }
                            });
                        } else if (mutation.type === 'attributes') {
                            if (mutation.target instanceof HTMLElement) {
                                var attributeName = mutation.attributeName;
                                if ((0, $f1k1y.fg)('platform_ufo_vc_ignore_same_value_mutation')) {
                                    var _mutation$oldValue;
                                    /*
                	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
                	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
                	Conceptually there is after all a mutation: there is an old value replaced with a new one,
                	and whether or not they are the same doesn't really matter.
                	And Custom elements should work the same way as MutationObserver."
                	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
                */ var oldValue = (_mutation$oldValue = mutation.oldValue) !== null && _mutation$oldValue !== void 0 ? _mutation$oldValue : undefined;
                                    var newValue = attributeName ? mutation.target.getAttribute(attributeName) : undefined;
                                    if (oldValue !== newValue) {
                                        if ((0, $6cg1G.default)(mutation)) ignoreReason = 'non-visual-style';
                                        if ((0, $f1k1y.fg)('platform_ufo_vc_fix_ignore_image_mutation')) {
                                            if ((0, $U9jzZ.isContainedWithinMediaWrapper)(mutation.target)) ignoreReason = 'image';
                                        }
                                        _this2.observeElement(mutation.target, mutation, 'attr', ignoreReason, attributeName, oldValue, newValue);
                                    }
                                } else {
                                    if ((0, $6cg1G.default)(mutation)) ignoreReason = 'non-visual-style';
                                    if ((0, $f1k1y.fg)('platform_ufo_vc_fix_ignore_image_mutation')) {
                                        if ((0, $U9jzZ.isContainedWithinMediaWrapper)(mutation.target)) ignoreReason = 'image';
                                    }
                                    _this2.observeElement(mutation.target, mutation, 'attr', ignoreReason, attributeName);
                                }
                            }
                        }
                    });
                    (0, $5Dj3P.markProfilingEnd)(operationTimer, {
                        tags: [
                            'vc'
                        ]
                    });
                });
            }
        },
        {
            key: "getElementName",
            value: function getElementName(element) {
                try {
                    var tagName = element.localName;
                    var dataVCAttr = element.getAttribute('data-vc');
                    var dataVC = this.selectorConfig.dataVC && dataVCAttr ? "[data-vc=\"".concat(dataVCAttr, "\"]") : '';
                    var id = this.selectorConfig.id && element.id ? "#".concat(element.id) : '';
                    var testId = this.selectorConfig.testId ? element.getAttribute('data-testid') || element.getAttribute('data-test-id') : '';
                    testId = testId ? "[testid=".concat(testId, "]") : '';
                    var role = this.selectorConfig.role ? element.getAttribute('role') : '';
                    role = role ? "[role=".concat(role, "]") : '';
                    var classList = this.selectorConfig.className ? Array.from(element.classList).join('.') : '';
                    classList = classList === '' ? '' : ".".concat(classList);
                    var attrs = dataVC ? dataVC : [
                        id,
                        testId,
                        role
                    ].join('');
                    var idString = '';
                    if (attrs === '' && classList === '') {
                        var parent = element.parentElement ? this.getElementName(element.parentElement) : 'unknown';
                        idString = "".concat(parent, " > ").concat(tagName);
                    } else idString = [
                        tagName,
                        attrs || classList
                    ].join('');
                    return idString;
                } catch (e) {
                    return 'error';
                }
            }
        },
        {
            key: "getIntersectionObserver",
            value: function getIntersectionObserver() {
                var _this3 = this;
                if (!this.isBrowserSupported()) return null;
                return new IntersectionObserver(function(entries) {
                    var operationTimer = (0, $5Dj3P.markProfilingStart)('intersectionObserverCallback');
                    _this3.measureStart();
                    entries.forEach(function(_ref2) {
                        var isIntersecting = _ref2.isIntersecting, ir = _ref2.intersectionRect, target = _ref2.target;
                        var data = _this3.observedMutations.get(target);
                        _this3.observedMutations.delete(target);
                        if (isIntersecting && ir.width > 0 && ir.height > 0) {
                            if (!(target instanceof HTMLElement)) return;
                            if (!(data !== null && data !== void 0 && data.mutation)) // ignore intersection report without recent mutation
                            return;
                            if (!$daa6c3352b6cb7d5$var$isElementVisible(target)) data.ignoreReason = 'not-visible';
                            if ((0, $f1k1y.fg)('platform_editor_ed-25937_ignore_mutations_for_ttvc')) {
                                if ($daa6c3352b6cb7d5$var$isInsideEditorContainer(target)) data.ignoreReason = 'editor-container-mutation';
                            }
                            _this3.callbacks.forEach(function(callback) {
                                var elementName;
                                try {
                                    elementName = _this3.getElementName(target);
                                } catch (e) {
                                    elementName = 'error';
                                }
                                callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason, data.attributeName, data.oldValue, data.newValue);
                            });
                            _this3.elementsInView.add(target);
                        } else _this3.elementsInView.delete(target);
                    });
                    _this3.measureStop();
                    (0, $5Dj3P.markProfilingEnd)(operationTimer, {
                        tags: [
                            'vc'
                        ]
                    });
                });
            }
        },
        {
            key: "measureStart",
            value: function measureStart() {
                this._startMeasureTimestamp = performance.now();
            }
        },
        {
            key: "measureStop",
            value: function measureStop() {
                if (this._startMeasureTimestamp === -1) return;
                this.totalTime += performance.now() - this._startMeasureTimestamp;
                this._startMeasureTimestamp = -1;
            }
        }
    ]);
}();

});
parcelRegister("U9jzZ", function(module, exports) {

$parcel$export(module.exports, "isContainedWithinMediaWrapper", function () { return $0a8c74cd774907cd$export$f61fbc3b9c4a9019; });

var $5Dj3P = parcelRequire("5Dj3P");

var $kFCx2 = parcelRequire("kFCx2");
var $0a8c74cd774907cd$export$f61fbc3b9c4a9019 = (0, $5Dj3P.withProfiling)(function isContainedWithinMediaWrapper(node) {
    while(node){
        if (node instanceof Element && node.hasAttribute((0, $kFCx2.MEDIA_WRAPPER_TAG))) return true;
        node = node.parentNode;
    }
    return false;
});

});
parcelRegister("kFCx2", function(module, exports) {

$parcel$export(module.exports, "MEDIA_WRAPPER_TAG", function () { return $f0c5869aaf5b42f7$export$7674290405cc25b0; });

var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");
var $f0c5869aaf5b42f7$export$7674290405cc25b0 = 'data-media-vc-wrapper';
var $f0c5869aaf5b42f7$export$7028e9efe569888c = (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, $f0c5869aaf5b42f7$export$7674290405cc25b0, true);
function $f0c5869aaf5b42f7$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("div", $f0c5869aaf5b42f7$export$7028e9efe569888c, children);
}

});


parcelRegister("julQm", function(module, exports) {

$parcel$export(module.exports, "EditorLnvHandler", function () { return $e301c3512f15f6c4$export$569bcb41b9a84ec8; });

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $dsN6L = parcelRequire("dsN6L");

var $5Dj3P = parcelRequire("5Dj3P");
var $e301c3512f15f6c4$var$placeholderDataKey = 'editorLnvPlaceholder'; // data-editor-lnv-placeholder
var $e301c3512f15f6c4$var$replaceDataKey = 'editorLnvPlaceholderReplace'; // data-editor-lnv-placeholder-replace
var $e301c3512f15f6c4$export$569bcb41b9a84ec8 = /*#__PURE__*/ function() {
    function EditorLnvHandler() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, EditorLnvHandler);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "placeholders", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "getSizeCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "isAddedPlaceholderMatchingSizeCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "isAddedReplaceMatchingSizeCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "intersectionObserverCallback", function(_ref) {
            var _target$dataset, _target$dataset2;
            var target = _ref.target, boundingClientRect = _ref.boundingClientRect;
            _this.intersectionObserver.unobserve(target);
            if (!(target instanceof HTMLElement)) return;
            var placeholderId = (_target$dataset = target.dataset) === null || _target$dataset === void 0 ? void 0 : _target$dataset[$e301c3512f15f6c4$var$placeholderDataKey];
            if (placeholderId && _this.getSizeCallbacks.has(placeholderId)) {
                var _resolve = _this.getSizeCallbacks.get(placeholderId);
                _this.getSizeCallbacks.delete(placeholderId);
                if (!_resolve) return;
                _resolve({
                    x: boundingClientRect.x,
                    y: boundingClientRect.y,
                    width: boundingClientRect.width,
                    height: boundingClientRect.height
                });
                return;
            }
            if (placeholderId && _this.isAddedPlaceholderMatchingSizeCallbacks.has(placeholderId)) {
                var _resolve2 = _this.isAddedPlaceholderMatchingSizeCallbacks.get(placeholderId);
                _this.isAddedPlaceholderMatchingSizeCallbacks.delete(placeholderId);
                if (!_resolve2) return;
                var placeholder = _this.placeholders.get(placeholderId);
                if (!placeholder) {
                    _resolve2(false);
                    return;
                }
                _resolve2(_this.areRectsSameSize(placeholder, boundingClientRect));
                return;
            }
            var replaceId = (_target$dataset2 = target.dataset) === null || _target$dataset2 === void 0 ? void 0 : _target$dataset2[$e301c3512f15f6c4$var$replaceDataKey];
            if (replaceId && _this.isAddedReplaceMatchingSizeCallbacks.has(replaceId)) {
                var _resolve3 = _this.isAddedReplaceMatchingSizeCallbacks.get(replaceId);
                _this.isAddedReplaceMatchingSizeCallbacks.delete(replaceId);
                if (!_resolve3) return;
                var _placeholder = _this.placeholders.get(replaceId);
                if (!_placeholder) {
                    _resolve3(false);
                    return;
                }
                _this.placeholders.delete(replaceId);
                _resolve3(_this.areRectsSameSize(_placeholder, boundingClientRect));
                return;
            }
        });
        var operationTimer = (0, $5Dj3P.markProfilingStart)('EditorLnvHandler constructor');
        this.intersectionObserver = new IntersectionObserver(function(entries) {
            return entries.filter(function(entry) {
                return entry.intersectionRatio > 0;
            }).forEach(_this.intersectionObserverCallback);
        });
        this.shouldHandleAddedNode = (0, $5Dj3P.withProfiling)(this.shouldHandleAddedNode.bind(this), [
            'vc'
        ]);
        this.handleAddedNode = (0, $5Dj3P.withProfiling)(this.handleAddedNode.bind(this), [
            'vc'
        ]);
        this.clear = (0, $5Dj3P.withProfiling)(this.clear.bind(this), [
            'vc'
        ]);
        this.handleAddedPlaceholderNode = (0, $5Dj3P.withProfiling)(this.handleAddedPlaceholderNode.bind(this), [
            'vc'
        ]);
        this.handleAddedReplaceNode = (0, $5Dj3P.withProfiling)(this.handleAddedReplaceNode.bind(this), [
            'vc'
        ]);
        this.isExistingPlaceholder = (0, $5Dj3P.withProfiling)(this.isExistingPlaceholder.bind(this), [
            'vc'
        ]);
        this.registerPlaceholder = (0, $5Dj3P.withProfiling)(this.registerPlaceholder.bind(this), [
            'vc'
        ]);
        this.getSize = (0, $5Dj3P.withProfiling)(this.getSize.bind(this), [
            'vc'
        ]);
        this.isAddedPlaceholderMatchingSize = (0, $5Dj3P.withProfiling)(this.isAddedPlaceholderMatchingSize.bind(this), [
            'vc'
        ]);
        this.isAddedReplaceMatchingSize = (0, $5Dj3P.withProfiling)(this.isAddedReplaceMatchingSize.bind(this), [
            'vc'
        ]);
        this.areRectsSameSize = (0, $5Dj3P.withProfiling)(this.areRectsSameSize.bind(this), [
            'vc'
        ]);
        this.intersectionObserverCallback = (0, $5Dj3P.withProfiling)(this.intersectionObserverCallback.bind(this), [
            'vc'
        ]);
        (0, $5Dj3P.markProfilingEnd)(operationTimer, {
            tags: [
                'vc'
            ]
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(EditorLnvHandler, [
        {
            key: "shouldHandleAddedNode",
            value: function shouldHandleAddedNode(el) {
                var _el$dataset, _el$dataset2;
                return ((_el$dataset = el.dataset) === null || _el$dataset === void 0 ? void 0 : _el$dataset[$e301c3512f15f6c4$var$placeholderDataKey]) || ((_el$dataset2 = el.dataset) === null || _el$dataset2 === void 0 ? void 0 : _el$dataset2[$e301c3512f15f6c4$var$replaceDataKey]);
            }
        },
        {
            key: "handleAddedNode",
            value: function handleAddedNode(el) {
                var _el$dataset3, _el$dataset4;
                // If it placeholder does not already exist, add it to the map
                var placeholderId = (_el$dataset3 = el.dataset) === null || _el$dataset3 === void 0 ? void 0 : _el$dataset3[$e301c3512f15f6c4$var$placeholderDataKey];
                if (placeholderId) return this.handleAddedPlaceholderNode(el, placeholderId);
                var replaceId = (_el$dataset4 = el.dataset) === null || _el$dataset4 === void 0 ? void 0 : _el$dataset4[$e301c3512f15f6c4$var$replaceDataKey];
                if (replaceId) return this.handleAddedReplaceNode(el, replaceId);
                return Promise.resolve({
                    shouldIgnore: false
                });
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.placeholders.clear();
                this.intersectionObserver.disconnect();
            }
        },
        {
            key: "handleAddedPlaceholderNode",
            value: function handleAddedPlaceholderNode(el, placeholderId) {
                if (this.isExistingPlaceholder(placeholderId)) return this.isAddedPlaceholderMatchingSize(el, placeholderId).then(function(isMatching) {
                    return {
                        shouldIgnore: isMatching
                    };
                });
                return this.registerPlaceholder(el, placeholderId).then(function() {
                    return {
                        shouldIgnore: false
                    };
                });
            }
        },
        {
            key: "handleAddedReplaceNode",
            value: function handleAddedReplaceNode(el, placeholderId) {
                if (this.isExistingPlaceholder(placeholderId)) return this.isAddedReplaceMatchingSize(el, placeholderId).then(function(isMatching) {
                    return {
                        shouldIgnore: isMatching
                    };
                });
                return Promise.resolve({
                    shouldIgnore: false
                });
            }
        },
        {
            key: "isExistingPlaceholder",
            value: function isExistingPlaceholder(placeholderId) {
                return this.placeholders.has(placeholderId);
            }
        },
        {
            key: "registerPlaceholder",
            value: function registerPlaceholder(el, placeholderId) {
                var _this2 = this;
                return this.getSize(el, placeholderId).then(function(size) {
                    _this2.placeholders.set(placeholderId, size);
                });
            }
        },
        {
            key: "getSize",
            value: function getSize(el, placeholderId) {
                var _this3 = this;
                return new Promise(function(resolve) {
                    _this3.getSizeCallbacks.set(placeholderId, resolve);
                    _this3.intersectionObserver.observe(el);
                });
            }
        },
        {
            key: "isAddedPlaceholderMatchingSize",
            value: function isAddedPlaceholderMatchingSize(el, placeholderId) {
                var _this4 = this;
                return new Promise(function(resolve) {
                    _this4.isAddedPlaceholderMatchingSizeCallbacks.set(placeholderId, resolve);
                    _this4.intersectionObserver.observe(el);
                });
            }
        },
        {
            key: "isAddedReplaceMatchingSize",
            value: function isAddedReplaceMatchingSize(el, placeholderId) {
                var _this5 = this;
                return new Promise(function(resolve) {
                    _this5.isAddedReplaceMatchingSizeCallbacks.set(placeholderId, resolve);
                    _this5.intersectionObserver.observe(el);
                });
            }
        },
        {
            key: "areRectsSameSize",
            value: function areRectsSameSize(a, b) {
                return Math.abs(a.width - b.width) < 1 && Math.abs(a.height - b.height) < 1;
            }
        }
    ]);
}();

});

parcelRegister("6cg1G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48304b856e470a81$export$2e2bcd8739ae039; });

var $5Dj3P = parcelRequire("5Dj3P");
/**
 * Checks if a mutation record represents a non-visual style change
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a non-visual style mutation
 *
 * A mutation is considered non-visual if:
 * - The target has data-	vc-nvs="true" attribute
 * - The changed attribute is either 'class' or 'style'
 */ var $48304b856e470a81$var$isNonVisualStyleMutation = (0, $5Dj3P.withProfiling)(function isNonVisualStyleMutation(_ref) {
    var target = _ref.target, attributeName = _ref.attributeName;
    if (!(target instanceof Element)) return false;
    if (attributeName !== 'class' && attributeName !== 'style') return false;
    if (target.getAttribute('data-vc-nvs') !== 'true') return false;
    return true;
}, [
    'vc'
]);
var $48304b856e470a81$export$2e2bcd8739ae039 = $48304b856e470a81$var$isNonVisualStyleMutation;

});

parcelRegister("lWu86", function(module, exports) {

$parcel$export(module.exports, "SSRPlaceholderHandlers", function () { return $ff9662e426e514c1$export$c0102f1a1198d10f; });

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $dsN6L = parcelRequire("dsN6L");

var $5Dj3P = parcelRequire("5Dj3P");
var $ff9662e426e514c1$var$ANCESTOR_LOOKUP_LIMIT = 10;
var $ff9662e426e514c1$export$c0102f1a1198d10f = /*#__PURE__*/ function() {
    function SSRPlaceholderHandlers() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, SSRPlaceholderHandlers);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "staticPlaceholders", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "callbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "getSizeCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "reactValidateCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "EQUALITY_THRESHOLD", 1);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "intersectionObserverCallback", function(_ref) {
            var _this$intersectionObs;
            var target = _ref.target, boundingClientRect = _ref.boundingClientRect;
            (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.unobserve(target);
            if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
            return;
            var staticKey = target.dataset.ssrPlaceholder || '';
            if (staticKey) {
                if (_this.staticPlaceholders.has(staticKey) && _this.callbacks.has(staticKey)) {
                    // validation
                    var _resolve = _this.callbacks.get(staticKey);
                    if (!_resolve) return;
                    var rect = _this.staticPlaceholders.get(staticKey);
                    var hasSameSizePosition = _this.hasSameSizePosition(rect, boundingClientRect);
                    if (hasSameSizePosition || _this.isDummyRect(rect)) _resolve(hasSameSizePosition);
                    else requestAnimationFrame(function() {
                        var targetRect = target.getBoundingClientRect();
                        var hasSameSizePosition = _this.hasSameSizePosition(rect, targetRect);
                        _resolve(hasSameSizePosition);
                    });
                    _this.callbacks.delete(staticKey);
                }
            } else {
                var key = target.dataset.ssrPlaceholderReplace || '';
                var _resolve2 = _this.reactValidateCallbacks.get(key);
                if (!_resolve2) return;
                var _rect = _this.staticPlaceholders.get(key);
                var _hasSameSizePosition = _this.hasSameSizePosition(_rect, boundingClientRect);
                if (_hasSameSizePosition || _this.isDummyRect(_rect)) _resolve2(_hasSameSizePosition);
                else requestAnimationFrame(function() {
                    var targetRect = target.getBoundingClientRect();
                    var hasSameSizePosition = _this.hasSameSizePosition(_rect, targetRect);
                    _resolve2(hasSameSizePosition);
                });
                _this.staticPlaceholders.delete(staticKey);
                _this.reactValidateCallbacks.delete(staticKey);
            }
        });
        var operationTimer = (0, $5Dj3P.markProfilingStart)('SSRPlaceholderHandlers constructor');
        if (typeof IntersectionObserver === 'function') // Only instantiate the IntersectionObserver if it's supported
        this.intersectionObserver = new IntersectionObserver(function(entries) {
            return entries.filter(function(entry) {
                return entry.intersectionRatio > 0;
            }).forEach(_this.intersectionObserverCallback);
        });
        if (window.document) try {
            var existingElements = document.querySelectorAll('[data-ssr-placeholder]');
            existingElements.forEach(function(el) {
                var _el$dataset;
                if (el instanceof HTMLElement && el !== null && el !== void 0 && (_el$dataset = el.dataset) !== null && _el$dataset !== void 0 && _el$dataset.ssrPlaceholder) {
                    var _window$__SSR_PLACEHO, _this$intersectionObs2;
                    var width = -1;
                    var height = -1;
                    var x = -1;
                    var y = -1;
                    var boundingClientRect = (_window$__SSR_PLACEHO = window.__SSR_PLACEHOLDERS_DIMENSIONS__) === null || _window$__SSR_PLACEHO === void 0 ? void 0 : _window$__SSR_PLACEHO[el.dataset.ssrPlaceholder];
                    if (boundingClientRect) {
                        width = boundingClientRect.width;
                        height = boundingClientRect.height;
                        x = boundingClientRect.x;
                        y = boundingClientRect.y;
                    }
                    _this.staticPlaceholders.set(el.dataset.ssrPlaceholder, {
                        width: width,
                        height: height,
                        x: x,
                        y: y
                    });
                    (_this$intersectionObs2 = _this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.observe(el);
                }
            });
        } catch (e) {} finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
        this.clear = (0, $5Dj3P.withProfiling)(this.clear.bind(this), [
            'vc'
        ]);
        this.isPlaceholder = (0, $5Dj3P.withProfiling)(this.isPlaceholder.bind(this), [
            'vc'
        ]);
        this.isPlaceholderReplacement = (0, $5Dj3P.withProfiling)(this.isPlaceholderReplacement.bind(this), [
            'vc'
        ]);
        this.isPlaceholderIgnored = (0, $5Dj3P.withProfiling)(this.isPlaceholderIgnored.bind(this), [
            'vc'
        ]);
        this.findNearestPlaceholderContainerIfIgnored = (0, $5Dj3P.withProfiling)(this.findNearestPlaceholderContainerIfIgnored.bind(this), [
            'vc'
        ]);
        this.checkIfExistedAndSizeMatching = (0, $5Dj3P.withProfiling)(this.checkIfExistedAndSizeMatching.bind(this), [
            'vc'
        ]);
        this.getSize = (0, $5Dj3P.withProfiling)(this.getSize.bind(this), [
            'vc'
        ]);
        this.validateReactComponentMatchToPlaceholder = (0, $5Dj3P.withProfiling)(this.validateReactComponentMatchToPlaceholder.bind(this), [
            'vc'
        ]);
        this.hasSameSizePosition = (0, $5Dj3P.withProfiling)(this.hasSameSizePosition.bind(this), [
            'vc'
        ]);
        this.isDummyRect = (0, $5Dj3P.withProfiling)(this.isDummyRect.bind(this), [
            'vc'
        ]);
        this.intersectionObserverCallback = (0, $5Dj3P.withProfiling)(this.intersectionObserverCallback.bind(this), [
            'vc'
        ]);
        (0, $5Dj3P.markProfilingEnd)(operationTimer, {
            tags: [
                'vc'
            ]
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(SSRPlaceholderHandlers, [
        {
            key: "clear",
            value: function clear() {
                this.staticPlaceholders = new Map();
                this.callbacks = new Map();
                this.getSizeCallbacks = new Map();
                this.reactValidateCallbacks = new Map();
            }
        },
        {
            key: "isPlaceholder",
            value: function isPlaceholder(element) {
                return Boolean(element.dataset.ssrPlaceholder);
            }
        },
        {
            key: "isPlaceholderReplacement",
            value: function isPlaceholderReplacement(element) {
                return Boolean(element.dataset.ssrPlaceholderReplace);
            }
        },
        {
            key: "isPlaceholderIgnored",
            value: function isPlaceholderIgnored(element) {
                // data-ssr-placeholder-ignored doesn't have a value.
                return 'ssrPlaceholderIgnored' in element.dataset;
            }
        },
        {
            key: "findNearestPlaceholderContainerIfIgnored",
            value: function findNearestPlaceholderContainerIfIgnored(element) {
                if (!this.isPlaceholderIgnored(element)) return element;
                var ancestor = element.parentElement;
                var i = 0;
                while(ancestor && i < $ff9662e426e514c1$var$ANCESTOR_LOOKUP_LIMIT){
                    if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
                    ancestor = ancestor.parentElement;
                    i++;
                }
                return element;
            }
        },
        {
            key: "checkIfExistedAndSizeMatching",
            value: function checkIfExistedAndSizeMatching(el) {
                var _this2 = this;
                el = this.findNearestPlaceholderContainerIfIgnored(el);
                var id = el.dataset.ssrPlaceholder || '';
                return new Promise(function(resolve) {
                    if (!_this2.staticPlaceholders.has(id)) {
                        resolve(false);
                        return;
                    } else {
                        var _this2$intersectionOb;
                        _this2.callbacks.set(id, resolve);
                        (_this2$intersectionOb = _this2.intersectionObserver) === null || _this2$intersectionOb === void 0 || _this2$intersectionOb.observe(el);
                    }
                });
            }
        },
        {
            key: "getSize",
            value: function getSize(el) {
                var _this3 = this;
                return new Promise(function(resolve) {
                    var _this3$intersectionOb;
                    _this3.getSizeCallbacks.set(el.dataset.ssrPlaceholder || '', resolve);
                    (_this3$intersectionOb = _this3.intersectionObserver) === null || _this3$intersectionOb === void 0 || _this3$intersectionOb.observe(el);
                });
            }
        },
        {
            key: "validateReactComponentMatchToPlaceholder",
            value: function validateReactComponentMatchToPlaceholder(el) {
                var _this4 = this;
                el = this.findNearestPlaceholderContainerIfIgnored(el);
                var id = el.dataset.ssrPlaceholderReplace || '';
                return new Promise(function(resolve) {
                    if (!_this4.staticPlaceholders.has(id)) {
                        resolve(false);
                        return;
                    } else {
                        var _this4$intersectionOb;
                        _this4.reactValidateCallbacks.set(id, resolve);
                        (_this4$intersectionOb = _this4.intersectionObserver) === null || _this4$intersectionOb === void 0 || _this4$intersectionOb.observe(el);
                    }
                });
            }
        },
        {
            key: "hasSameSizePosition",
            value: function hasSameSizePosition(rect, boundingClientRect) {
                return rect && Math.abs(rect.x - boundingClientRect.x) < this.EQUALITY_THRESHOLD && Math.abs(rect.y - boundingClientRect.y) < this.EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < this.EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < this.EQUALITY_THRESHOLD || false;
            }
        },
        {
            key: "isDummyRect",
            value: function isDummyRect(rect) {
                return rect && rect.width < 0 && rect.height < 0 || false;
            }
        }
    ]);
}();

});




parcelRegister("gxkd1", function(module, exports) {

$parcel$export(module.exports, "clearActiveTrace", function () { return $c09f677b4c8fd26a$export$17ab21d7be720b; });

var $5Dj3P = parcelRequire("5Dj3P");

var $lsrhB = parcelRequire("lsrhB");
var $c09f677b4c8fd26a$var$state = {
    context: null
};
var $c09f677b4c8fd26a$export$295213bc4d0c54ad = (0, $5Dj3P.withProfiling)(function generateSpanId() {
    return Array.from(new Array(16), function() {
        return Math.floor(Math.random() * 16).toString(16);
    }).join('');
});
var $c09f677b4c8fd26a$export$f2e521e495a88544 = (0, $5Dj3P.withProfiling)(function setInteractionActiveTrace(interactionId, experienceType) {
    $c09f677b4c8fd26a$export$a1002be327997103(interactionId.replace(/-/g, ''), $c09f677b4c8fd26a$export$295213bc4d0c54ad(), experienceType);
});
var $c09f677b4c8fd26a$export$a1002be327997103 = (0, $5Dj3P.withProfiling)(function setActiveTrace(traceId, spanId, type) {
    $c09f677b4c8fd26a$var$state.context = {
        traceId: traceId,
        spanId: spanId,
        type: type
    };
});
var $c09f677b4c8fd26a$export$b6ac780db3a3cc77 = (0, $5Dj3P.withProfiling)(function getActiveTrace() {
    return $c09f677b4c8fd26a$var$state.context || undefined;
});
var $c09f677b4c8fd26a$export$17ab21d7be720b = (0, $5Dj3P.withProfiling)(function clearActiveTrace() {
    $c09f677b4c8fd26a$var$state.context = null;
});
var $c09f677b4c8fd26a$export$6e17cce6446848f9 = (0, $5Dj3P.withProfiling)(function getActiveTraceHttpRequestHeaders(_url) {
    if ($c09f677b4c8fd26a$var$state.context === null) return null;
    var _state$context = $c09f677b4c8fd26a$var$state.context, traceId = _state$context.traceId, spanId = _state$context.spanId;
    return (0, $lsrhB.makeTraceHttpRequestHeaders)(traceId, spanId);
});
var $c09f677b4c8fd26a$export$a1e7396778592551 = (0, $5Dj3P.withProfiling)(function getActiveTraceAsQueryParams(_url) {
    var traceHeaders = $c09f677b4c8fd26a$export$6e17cce6446848f9(_url);
    return traceHeaders ? new URLSearchParams(traceHeaders).toString().toLowerCase() : null;
});

});
parcelRegister("lsrhB", function(module, exports) {

$parcel$export(module.exports, "makeTraceHttpRequestHeaders", function () { return $f9f1604f58029e18$export$1115c5277eb10d5e; });

var $5Dj3P = parcelRequire("5Dj3P");
var $f9f1604f58029e18$export$1115c5277eb10d5e = (0, $5Dj3P.withProfiling)(function makeTraceHttpRequestHeaders(traceId, spanId) {
    return {
        'X-B3-TraceId': traceId,
        'X-B3-SpanId': spanId
    };
});

});


parcelRegister("9TLEj", function(module, exports) {

$parcel$export(module.exports, "allFeatureFlagsAccessed", function () { return $734e36399b178de1$export$5b78c989c8db2561; });
$parcel$export(module.exports, "currentFeatureFlagsAccessed", function () { return $734e36399b178de1$export$2a5c8df26bb89760; });

var $5Dj3P = parcelRequire("5Dj3P");

var $3vasC = parcelRequire("3vasC");
var $734e36399b178de1$export$5b78c989c8db2561 = new Map();
var $734e36399b178de1$export$2a5c8df26bb89760 = new Map();
var $734e36399b178de1$export$47fade9662f71000 = (0, $5Dj3P.withProfiling)(function addFeatureFlagAccessed(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    var value = (0, $3vasC.redactValue)(featureFlagValue);
    $734e36399b178de1$export$5b78c989c8db2561.set(featureFlagName, value);
    $734e36399b178de1$export$2a5c8df26bb89760.set(featureFlagName, value);
});

});
parcelRegister("3vasC", function(module, exports) {

$parcel$export(module.exports, "redactValue", function () { return $28cc61983f2908df$export$fcc03ee4c944962f; });

var $61RDg = parcelRequire("61RDg");

var $5Dj3P = parcelRequire("5Dj3P");

var $4J0vZ = parcelRequire("4J0vZ");
var $28cc61983f2908df$var$startsAsObject = (0, $5Dj3P.withProfiling)(function startsAsObject(value) {
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
});
var $28cc61983f2908df$var$isObject = (0, $5Dj3P.withProfiling)(function isObject(value) {
    return value && (0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(value) === 'object' && value.constructor === Object;
});
var $28cc61983f2908df$var$isString = (0, $5Dj3P.withProfiling)(function isString(input) {
    var result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
});
var $28cc61983f2908df$export$7b4abba432e57989 = (0, $5Dj3P.withProfiling)(function shouldRedactValue(value) {
    return $28cc61983f2908df$var$isString(value) && $28cc61983f2908df$var$startsAsObject(value) || $28cc61983f2908df$var$isObject(value);
});
var $28cc61983f2908df$export$fcc03ee4c944962f = (0, $5Dj3P.withProfiling)(function redactValue(featureFlagValue) {
    return $28cc61983f2908df$export$7b4abba432e57989(featureFlagValue) ? (0, $4J0vZ.NON_BOOLEAN_VALUE) : featureFlagValue;
});

});
parcelRegister("4J0vZ", function(module, exports) {

$parcel$export(module.exports, "NON_BOOLEAN_VALUE", function () { return $370bc3ac11b90b8f$export$42f4885608027d0c; });
var $370bc3ac11b90b8f$export$42f4885608027d0c = 'non_boolean';

});



parcelRegister("6jqx3", function(module, exports) {

$parcel$export(module.exports, "getInteractionId", function () { return $4989192226ab6cff$export$37bca3107733ac1e; });

var $91i6m = parcelRequire("91i6m");
var $4989192226ab6cff$export$3109542b68df9ba1 = {
    current: null
};
var // We use a context to allow modals to have their own lifecycle
$4989192226ab6cff$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $91i6m.createContext)($4989192226ab6cff$export$3109542b68df9ba1);
var $4989192226ab6cff$export$37bca3107733ac1e = function getInteractionId() {
    return $4989192226ab6cff$export$3109542b68df9ba1;
};
var $4989192226ab6cff$export$9f6000531b78127e = function useInteractionId() {
    return $4989192226ab6cff$export$3109542b68df9ba1;
};

});

parcelRegister("2xQTd", function(module, exports) {

$parcel$export(module.exports, "getVCObserver", function () { return $1da7b09d448c6e47$export$b3bc47985717b49e; });

var $iqLBO = parcelRequire("iqLBO");

var $dsN6L = parcelRequire("dsN6L");

var $2R76C = parcelRequire("2R76C");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $eWMMH = parcelRequire("eWMMH");

var $f1k1y = parcelRequire("f1k1y");

var $h6MYR = parcelRequire("h6MYR");

var $5Dj3P = parcelRequire("5Dj3P");

var $4gbvc = parcelRequire("4gbvc");

var $7F3ZZ = parcelRequire("7F3ZZ");

var $dcJMa = parcelRequire("dcJMa");

var $e08gr = parcelRequire("e08gr");
var $1da7b09d448c6e47$var$_process;
function $1da7b09d448c6e47$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1da7b09d448c6e47$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1da7b09d448c6e47$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1da7b09d448c6e47$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1da7b09d448c6e47$var$VCObserverWrapper = /*#__PURE__*/ function() {
    function VCObserverWrapper() {
        var _getConfig;
        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, VCObserverWrapper);
        var operationTimer = (0, $5Dj3P.markProfilingStart)('VCObserverWrapper constructor');
        this.newVCObserver = null;
        var isNewVCObserverEnabled = (0, $f1k1y.fg)('platform_ufo_vc_observer_new') || ((_getConfig = (0, $h6MYR.getConfig)()) === null || _getConfig === void 0 || (_getConfig = _getConfig.vc) === null || _getConfig === void 0 ? void 0 : _getConfig.enableVCObserverNew);
        if (isNewVCObserverEnabled) this.newVCObserver = new (0, $dcJMa.default)({
            selectorConfig: opts.selectorConfig
        });
        this.oldVCObserver = new (0, $7F3ZZ.VCObserver)(opts);
        this.start = (0, $5Dj3P.withProfiling)(this.start.bind(this), [
            'vc'
        ]);
        this.stop = (0, $5Dj3P.withProfiling)(this.stop.bind(this), [
            'vc'
        ]);
        this.getVCRawData = (0, $5Dj3P.withProfiling)(this.getVCRawData.bind(this), [
            'vc'
        ]);
        this.getVCResult = (0, $5Dj3P.withProfiling)(this.getVCResult.bind(this), [
            'vc'
        ]);
        this.setSSRElement = (0, $5Dj3P.withProfiling)(this.setSSRElement.bind(this), [
            'vc'
        ]);
        this.setReactRootRenderStart = (0, $5Dj3P.withProfiling)(this.setReactRootRenderStart.bind(this), [
            'vc'
        ]);
        this.setReactRootRenderStop = (0, $5Dj3P.withProfiling)(this.setReactRootRenderStop.bind(this), [
            'vc'
        ]);
        (0, $5Dj3P.markProfilingEnd)(operationTimer, {
            tags: [
                'vc'
            ]
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(VCObserverWrapper, [
        {
            key: "start",
            value: function start(startArg) {
                var _this$oldVCObserver, _this$newVCObserver;
                (_this$oldVCObserver = this.oldVCObserver) === null || _this$oldVCObserver === void 0 || _this$oldVCObserver.start(startArg);
                (_this$newVCObserver = this.newVCObserver) === null || _this$newVCObserver === void 0 || _this$newVCObserver.start({
                    startTime: startArg.startTime
                });
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$oldVCObserver2, _this$newVCObserver2;
                (_this$oldVCObserver2 = this.oldVCObserver) === null || _this$oldVCObserver2 === void 0 || _this$oldVCObserver2.stop();
                (_this$newVCObserver2 = this.newVCObserver) === null || _this$newVCObserver2 === void 0 || _this$newVCObserver2.stop();
            }
        },
        {
            key: "getVCRawData",
            value: function getVCRawData() {
                var _this$oldVCObserver$g, _this$oldVCObserver3;
                return (_this$oldVCObserver$g = (_this$oldVCObserver3 = this.oldVCObserver) === null || _this$oldVCObserver3 === void 0 ? void 0 : _this$oldVCObserver3.getVCRawData()) !== null && _this$oldVCObserver$g !== void 0 ? _this$oldVCObserver$g : null;
            }
        },
        {
            key: "getVCResult",
            value: function() {
                var _getVCResult = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee(param) {
                    var _this$oldVCObserver4, _this$newVCObserver3, _ref;
                    var oldResult, newResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.next = 2;
                                return (_this$oldVCObserver4 = this.oldVCObserver) === null || _this$oldVCObserver4 === void 0 ? void 0 : _this$oldVCObserver4.getVCResult(param);
                            case 2:
                                oldResult = _context.sent;
                                _context.next = 5;
                                return (_this$newVCObserver3 = this.newVCObserver) === null || _this$newVCObserver3 === void 0 ? void 0 : _this$newVCObserver3.getVCResult({
                                    start: param.start,
                                    stop: (0, $f1k1y.fg)('platform_ufo_vc_ttai_on_paint') ? param.stop : performance.now()
                                });
                            case 5:
                                newResult = _context.sent;
                                if (!(oldResult && !newResult)) {
                                    _context.next = 8;
                                    break;
                                }
                                return _context.abrupt("return", oldResult);
                            case 8:
                                return _context.abrupt("return", $1da7b09d448c6e47$var$_objectSpread($1da7b09d448c6e47$var$_objectSpread({}, oldResult !== null && oldResult !== void 0 ? oldResult : {}), {}, {
                                    'ufo:vc:rev': [].concat((0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))((_ref = oldResult === null || oldResult === void 0 ? void 0 : oldResult['ufo:vc:rev']) !== null && _ref !== void 0 ? _ref : []), (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(newResult !== null && newResult !== void 0 ? newResult : []))
                                }));
                            case 9:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getVCResult(_x) {
                    return _getVCResult.apply(this, arguments);
                }
                return getVCResult;
            }()
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(element) {
                var _this$oldVCObserver5;
                (_this$oldVCObserver5 = this.oldVCObserver) === null || _this$oldVCObserver5 === void 0 || _this$oldVCObserver5.setSSRElement(element);
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart(startTime) {
                var _this$oldVCObserver6;
                (_this$oldVCObserver6 = this.oldVCObserver) === null || _this$oldVCObserver6 === void 0 || _this$oldVCObserver6.setReactRootRenderStart(startTime || performance.now());
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop(stopTime) {
                var _this$oldVCObserver7;
                (_this$oldVCObserver7 = this.oldVCObserver) === null || _this$oldVCObserver7 === void 0 || _this$oldVCObserver7.setReactRootRenderStop(stopTime || performance.now());
            }
        }
    ]);
}(); // Some products set this variable to indicate it is running in SSR
var $1da7b09d448c6e47$var$isServer = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.__SERVER__);
// Other products set this other variable to indicate it is running in SSR
var $1da7b09d448c6e47$var$isReactSSR = typeof $e08gr !== 'undefined' && Boolean((($1da7b09d448c6e47$var$_process = $e08gr) === null || $1da7b09d448c6e47$var$_process === void 0 || ($1da7b09d448c6e47$var$_process = $1da7b09d448c6e47$var$_process.env) === null || $1da7b09d448c6e47$var$_process === void 0 ? void 0 : $1da7b09d448c6e47$var$_process.REACT_SSR) || false);
var $1da7b09d448c6e47$export$68d57b133e88584d = (0, $5Dj3P.withProfiling)(function isEnvironmentSupported() {
    // SSR environment aren't supported
    if ($1da7b09d448c6e47$var$isReactSSR || $1da7b09d448c6e47$var$isServer) return false;
    // Legacy browsers that doesn't support WeakRef
    // aren't valid
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.WeakRef) !== 'function') return false;
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.MutationObserver) !== 'function' || typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.IntersectionObserver) !== 'function' || typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.PerformanceObserver) !== 'function') return false;
    return true;
}, [
    'vc'
]);
var $1da7b09d448c6e47$export$b3bc47985717b49e = (0, $5Dj3P.withProfiling)(function getVCObserver() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!globalThis.__vcObserver) {
        var shouldMockVCObserver = !$1da7b09d448c6e47$export$68d57b133e88584d();
        globalThis.__vcObserver = shouldMockVCObserver ? new (0, $4gbvc.VCObserverNOOP)() : new $1da7b09d448c6e47$var$VCObserverWrapper(opts);
    }
    return globalThis.__vcObserver;
}, [
    'vc'
]);

});
parcelRegister("4gbvc", function(module, exports) {

$parcel$export(module.exports, "VCObserverNOOP", function () { return $31a1942c4e0df210$export$24d07287b49da906; });

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");
var $31a1942c4e0df210$export$24d07287b49da906 = /*#__PURE__*/ function() {
    function VCObserverNOOP() {
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, VCObserverNOOP);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(VCObserverNOOP, [
        {
            key: "start",
            value: function start(startArg) {}
        },
        {
            key: "stop",
            value: function stop() {}
        },
        {
            key: "getVCRawData",
            value: function getVCRawData() {
                return null;
            }
        },
        {
            key: "getVCResult",
            value: function getVCResult(param) {
                return Promise.resolve({
                    'ufo:vc:noop': true
                });
            }
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(element) {}
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart(startTime) {}
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop(stopTime) {}
        }
    ]);
}();

});

parcelRegister("dcJMa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99cfe7784c6ae648$export$2e2bcd8739ae039; });

var $2R76C = parcelRequire("2R76C");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $dsN6L = parcelRequire("dsN6L");

var $eWMMH = parcelRequire("eWMMH");

var $5Dj3P = parcelRequire("5Dj3P");

var $e92NH = parcelRequire("e92NH");

var $dOyhl = parcelRequire("dOyhl");

var $8PG43 = parcelRequire("8PG43");

var $veLXE = parcelRequire("veLXE");

var $7JXRi = parcelRequire("7JXRi");
var $99cfe7784c6ae648$var$DEFAULT_SELECTOR_CONFIG = {
    id: false,
    testId: true,
    role: false,
    className: false,
    dataVC: true
};
var $99cfe7784c6ae648$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function VCObserverNew(config) {
        var _config$selectorConfi, _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, VCObserverNew);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "viewportObserver", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "windowEventObserver", null);
        var operationTimer = (0, $5Dj3P.markProfilingStart)('VCObserverNew constructor');
        this.entriesTimeline = new (0, $e92NH.default)();
        this.selectorConfig = (_config$selectorConfi = config.selectorConfig) !== null && _config$selectorConfi !== void 0 ? _config$selectorConfi : $99cfe7784c6ae648$var$DEFAULT_SELECTOR_CONFIG;
        this.viewportObserver = new (0, $veLXE.default)({
            onChange: function onChange(onChangeArg) {
                var time = onChangeArg.time, type = onChangeArg.type, elementRef = onChangeArg.elementRef, visible = onChangeArg.visible, rect = onChangeArg.rect, previousRect = onChangeArg.previousRect, mutationData = onChangeArg.mutationData;
                var elementName = 'unknown';
                var element = elementRef.deref();
                if (element) elementName = _this.getElementName(element);
                _this.entriesTimeline.push({
                    time: time,
                    type: type,
                    data: {
                        elementName: elementName,
                        rect: rect,
                        previousRect: previousRect,
                        visible: visible,
                        attributeName: mutationData === null || mutationData === void 0 ? void 0 : mutationData.attributeName
                    }
                });
            }
        });
        this.windowEventObserver = new (0, $7JXRi.default)({
            onEvent: function onEvent(_ref) {
                var time = _ref.time, type = _ref.type;
                _this.entriesTimeline.push({
                    time: time,
                    type: 'window:event',
                    data: {
                        eventType: type
                    }
                });
            }
        });
        this.start = (0, $5Dj3P.withProfiling)(this.start.bind(this), [
            'vc'
        ]);
        this.stop = (0, $5Dj3P.withProfiling)(this.stop.bind(this), [
            'vc'
        ]);
        this.getVCResult = (0, $5Dj3P.withProfiling)(this.getVCResult.bind(this), [
            'vc'
        ]);
        this.getElementName = (0, $5Dj3P.withProfiling)(this.getElementName.bind(this), [
            'vc'
        ]);
        (0, $5Dj3P.markProfilingEnd)(operationTimer, {
            tags: [
                'vc'
            ]
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(VCObserverNew, [
        {
            key: "start",
            value: function start(_ref2) {
                var _this$viewportObserve, _this$windowEventObse;
                var startTime = _ref2.startTime;
                (_this$viewportObserve = this.viewportObserver) === null || _this$viewportObserve === void 0 || _this$viewportObserve.start();
                (_this$windowEventObse = this.windowEventObserver) === null || _this$windowEventObse === void 0 || _this$windowEventObse.start();
                this.entriesTimeline.clear();
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$viewportObserve2, _this$windowEventObse2;
                (_this$viewportObserve2 = this.viewportObserver) === null || _this$viewportObserve2 === void 0 || _this$viewportObserve2.stop();
                (_this$windowEventObse2 = this.windowEventObserver) === null || _this$windowEventObse2 === void 0 || _this$windowEventObse2.stop();
            }
        },
        {
            key: "getVCResult",
            value: function() {
                var _getVCResult = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee(param) {
                    var start, stop, results, calculator_fy25_03, orderedEntries, fy25_03;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                start = param.start, stop = param.stop;
                                results = [];
                                calculator_fy25_03 = new (0, $8PG43.default)();
                                orderedEntries = this.entriesTimeline.getOrderedEntries({
                                    start: start,
                                    stop: stop
                                });
                                _context.next = 6;
                                return calculator_fy25_03.calculate({
                                    orderedEntries: orderedEntries,
                                    startTime: start,
                                    stopTime: stop
                                });
                            case 6:
                                fy25_03 = _context.sent;
                                if (fy25_03) results.push(fy25_03);
                                return _context.abrupt("return", results);
                            case 9:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getVCResult(_x) {
                    return _getVCResult.apply(this, arguments);
                }
                return getVCResult;
            }()
        },
        {
            key: "getElementName",
            value: function getElementName(element) {
                return (0, $dOyhl.default)(this.selectorConfig, element);
            }
        }
    ]);
}();

});
parcelRegister("e92NH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4c41417851a2e1e$export$2e2bcd8739ae039; });

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $dsN6L = parcelRequire("dsN6L");

var $5Dj3P = parcelRequire("5Dj3P");
var $a4c41417851a2e1e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function EntriesTimeline() {
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, EntriesTimeline);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "unorderedEntries", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "sortedEntriesCache", new Map());
        var operationTimer = (0, $5Dj3P.markProfilingStart)('EntriesTimeline constructor');
        this.unorderedEntries = [];
        this.push = (0, $5Dj3P.withProfiling)(this.push.bind(this), [
            'vc'
        ]);
        this.getCacheKey = (0, $5Dj3P.withProfiling)(this.getCacheKey.bind(this), [
            'vc'
        ]);
        this.getOrderedEntries = (0, $5Dj3P.withProfiling)(this.getOrderedEntries.bind(this), [
            'vc'
        ]);
        this.clear = (0, $5Dj3P.withProfiling)(this.clear.bind(this), [
            'vc'
        ]);
        (0, $5Dj3P.markProfilingEnd)(operationTimer, {
            tags: [
                'vc'
            ]
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(EntriesTimeline, [
        {
            key: "push",
            value: function push(entry) {
                this.unorderedEntries.push(entry);
                this.sortedEntriesCache.clear();
            }
        },
        {
            key: "getCacheKey",
            value: function getCacheKey(start, stop) {
                return "".concat(start !== null && start !== void 0 ? start : 'null', "_").concat(stop !== null && stop !== void 0 ? stop : 'null');
            }
        },
        {
            key: "getOrderedEntries",
            value: function getOrderedEntries(_ref) {
                var _this$sortedEntriesCa;
                var start = _ref.start, stop = _ref.stop;
                var cacheKey = this.getCacheKey(start, stop);
                var cachedSortedEntries = (_this$sortedEntriesCa = this.sortedEntriesCache.get(cacheKey)) === null || _this$sortedEntriesCa === void 0 ? void 0 : _this$sortedEntriesCa.deref();
                if (cachedSortedEntries) return cachedSortedEntries;
                var filteredEntries = this.unorderedEntries.filter(function(e) {
                    return e.time >= (start !== null && start !== void 0 ? start : 0) && e.time <= (stop !== null && stop !== void 0 ? stop : performance.now());
                });
                var sortedEntries = filteredEntries.sort(function(a, b) {
                    return a.time - b.time;
                });
                this.sortedEntriesCache.set(cacheKey, new WeakRef(sortedEntries));
                return sortedEntries;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.unorderedEntries = [];
                this.sortedEntriesCache.clear();
            }
        }
    ]);
}();

});

parcelRegister("dOyhl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0ea88ebbcc31778$export$2e2bcd8739ae039; });

var $5Dj3P = parcelRequire("5Dj3P");
var $a0ea88ebbcc31778$var$nameCache = new WeakMap();
var $a0ea88ebbcc31778$var$getElementName = (0, $5Dj3P.withProfiling)(function getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) return 'error';
    var cachedName = $a0ea88ebbcc31778$var$nameCache.get(element);
    if (cachedName) return cachedName;
    // Get the tag name of the element.
    var tagName = element.localName;
    var encodeValue = function encodeValue(s) {
        if (typeof encodeURIComponent !== 'function') return '';
        try {
            return encodeURIComponent(s);
        } catch (e) {
            return 'malformed_value';
        }
    };
    // Helper function to construct attribute selectors.
    var getAttributeSelector = function getAttributeSelector(attributeName) {
        var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        if (element && typeof element.getAttribute !== 'function') return '';
        var attrValue = element.getAttribute(attributeName);
        if (!attrValue) return '';
        var encondedAttrValue = encodeValue(attrValue);
        return "".concat(prefix, "[").concat(attributeName, "=\"").concat(encondedAttrValue, "\"]");
    };
    // Construct the data-vc attribute selector if specified in the config.
    var dataVC = selectorConfig.dataVC !== false ? getAttributeSelector('data-vc') : '';
    // Construct the ID selector if specified in the config and the element has an ID.
    var id = selectorConfig.id && element.id ? "#".concat(encodeValue(element.id)) : '';
    // Construct the test ID selector if specified in the config.
    var testId = selectorConfig.testId ? getAttributeSelector('data-testid') || getAttributeSelector('data-test-id') : '';
    // Construct the role selector if specified in the config.
    var role = selectorConfig.role ? getAttributeSelector('role') : '';
    var classNames = Array.from(element.classList).map(encodeValue).join('.');
    // Construct the class list selector if specified in the config.
    var classList = selectorConfig.className && classNames ? ".".concat(classNames) : '';
    // Combine primary attribute selectors (id, testId, role) into a single string.
    var primaryAttributes = [
        id,
        testId,
        role
    ].filter(Boolean).join('');
    // Use dataVC if available, otherwise use the primary attributes.
    var attributes = dataVC || primaryAttributes;
    // If no attributes or class list, recursively get the parent's name.
    if (!attributes && !classList) {
        var parentName = element.parentElement ? getElementName(selectorConfig, element.parentElement) : 'unknown';
        return "".concat(parentName, " > ").concat(tagName);
    }
    // Return the final constructed name: tagName + attributes or classList.
    var name = "".concat(tagName).concat(attributes || classList);
    $a0ea88ebbcc31778$var$nameCache.set(element, name);
    return name;
}, [
    'vc'
]);
var $a0ea88ebbcc31778$export$2e2bcd8739ae039 = $a0ea88ebbcc31778$var$getElementName;

});

parcelRegister("8PG43", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66e3b73eab097fe4$export$2e2bcd8739ae039; });

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $gGOBY = parcelRequire("gGOBY");

var $lVDuE = parcelRequire("lVDuE");

var $kSyoi = parcelRequire("kSyoi");

var $5Dj3P = parcelRequire("5Dj3P");

var $eiBHQ = parcelRequire("eiBHQ");

var $hJ8kW = parcelRequire("hJ8kW");
function $66e3b73eab097fe4$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($gGOBY)))(t, $66e3b73eab097fe4$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(t).constructor) : o.apply(t, e));
}
function $66e3b73eab097fe4$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($66e3b73eab097fe4$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $66e3b73eab097fe4$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
var $66e3b73eab097fe4$var$REVISION_NO = 'fy25.03';
var $66e3b73eab097fe4$var$CONSIDERED_ENTRY_TYPE = [
    'mutation:child-element',
    'mutation:element',
    'mutation:attribute',
    'layout-shift',
    'window:event'
];
var $66e3b73eab097fe4$export$98812f4e79596e2b = [
    'data-drop-target-for-element',
    'draggable'
];
var $66e3b73eab097fe4$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractVCCalculator) {
    function VCCalculator_FY25_03() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, VCCalculator_FY25_03);
        _this = $66e3b73eab097fe4$var$_callSuper(this, VCCalculator_FY25_03, [
            $66e3b73eab097fe4$var$REVISION_NO
        ]);
        _this.isEntryIncluded = (0, $5Dj3P.withProfiling)(_this.isEntryIncluded.bind(_this), [
            'vc'
        ]);
        _this.isVCClean = (0, $5Dj3P.withProfiling)(_this.isVCClean.bind(_this), [
            'vc'
        ]);
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($kSyoi)))(VCCalculator_FY25_03, _AbstractVCCalculator);
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(VCCalculator_FY25_03, [
        {
            key: "isEntryIncluded",
            value: function isEntryIncluded(entry) {
                if (!$66e3b73eab097fe4$var$CONSIDERED_ENTRY_TYPE.includes(entry.type)) return false;
                if (entry.type === 'mutation:attribute') {
                    var entryData = entry.data;
                    var attributeName = entryData.attributeName;
                    if (!attributeName || $66e3b73eab097fe4$export$98812f4e79596e2b.includes(attributeName)) return false;
                    return true;
                }
                if ((0, $hJ8kW.default)(entry.data) && !entry.data.visible) return false;
                return true;
            }
        },
        {
            key: "isVCClean",
            value: function isVCClean(filteredEntries) {
                var hasAbortEvent = filteredEntries.some(function(entry) {
                    if (entry.type === 'window:event') {
                        var data = entry.data;
                        if ($66e3b73eab097fe4$var$ABORTING_WINDOW_EVENT.includes(data.eventType)) return true;
                    }
                    return false;
                });
                return !hasAbortEvent;
            }
        }
    ]);
}((0, $eiBHQ.default));

});
parcelRegister("eiBHQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a68ffec705f13424$export$2e2bcd8739ae039; });

var $2R76C = parcelRequire("2R76C");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $eWMMH = parcelRequire("eWMMH");

var $5Dj3P = parcelRequire("5Dj3P");

var $4k9XK = parcelRequire("4k9XK");

var $kNHoN = parcelRequire("kNHoN");

var $jINBT = parcelRequire("jINBT");
var $a68ffec705f13424$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AbstractVCCalculatorBase(revisionNo) {
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, AbstractVCCalculatorBase);
        this.revisionNo = revisionNo;
        this.calculate = (0, $5Dj3P.withProfiling)(this.calculate.bind(this), [
            'vc'
        ]);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(AbstractVCCalculatorBase, [
        {
            key: "calculate",
            value: function() {
                var _calculate = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee(_ref) {
                    var _this = this, _vcDetails$90$t, _vcDetails$;
                    var startTime, stopTime, orderedEntries, filteredEntries, isVCClean, vcDetails;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                startTime = _ref.startTime, stopTime = _ref.stopTime, orderedEntries = _ref.orderedEntries;
                                filteredEntries = orderedEntries.filter(function(entry) {
                                    return _this.isEntryIncluded(entry);
                                });
                                isVCClean = this.isVCClean(filteredEntries);
                                if (isVCClean) {
                                    _context.next = 5;
                                    break;
                                }
                                return _context.abrupt("return", {
                                    revision: this.revisionNo,
                                    'metric:vc90': null,
                                    clean: false
                                });
                            case 5:
                                _context.next = 7;
                                return (0, $4k9XK.default)({
                                    viewport: {
                                        width: (0, $jINBT.default)(),
                                        height: (0, $kNHoN.default)()
                                    },
                                    startTime: startTime,
                                    stopTime: stopTime,
                                    orderedEntries: filteredEntries,
                                    percentiles: [
                                        25,
                                        50,
                                        75,
                                        80,
                                        85,
                                        90,
                                        95,
                                        98,
                                        99
                                    ]
                                });
                            case 7:
                                vcDetails = _context.sent;
                                return _context.abrupt("return", {
                                    revision: this.revisionNo,
                                    vcDetails: vcDetails !== null && vcDetails !== void 0 ? vcDetails : undefined,
                                    clean: isVCClean,
                                    'metric:vc90': (_vcDetails$90$t = vcDetails === null || vcDetails === void 0 || (_vcDetails$ = vcDetails['90']) === null || _vcDetails$ === void 0 ? void 0 : _vcDetails$.t) !== null && _vcDetails$90$t !== void 0 ? _vcDetails$90$t : null
                                });
                            case 9:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function calculate(_x) {
                    return _calculate.apply(this, arguments);
                }
                return calculate;
            }()
        }
    ]);
}();

});
parcelRegister("4k9XK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3260c2124a894e2e$export$2e2bcd8739ae039; });

var $2R76C = parcelRequire("2R76C");

var $eWMMH = parcelRequire("eWMMH");

var $5Dj3P = parcelRequire("5Dj3P");

var $ZJbix = parcelRequire("ZJbix");

var $kap5K = parcelRequire("kap5K");

var $e0z6A = parcelRequire("e0z6A");
var $3260c2124a894e2e$var$calculateTTVCPercentiles = (0, $5Dj3P.withProfiling)(/*#__PURE__*/ function() {
    var _calculateTTVCPercentiles = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee(arg) {
        var algo, vcDetails, _vcDetails, _vcDetails2;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    algo = 'canvas_heatmap';
                    if (!(algo === 'canvas_heatmap')) {
                        _context.next = 6;
                        break;
                    }
                    _context.next = 4;
                    return (0, $ZJbix.default)(arg);
                case 4:
                    vcDetails = _context.sent;
                    return _context.abrupt("return", vcDetails);
                case 6:
                    if (!(algo === 'rect_sweeping')) {
                        _context.next = 11;
                        break;
                    }
                    _context.next = 9;
                    return (0, $e0z6A.default)(arg);
                case 9:
                    _vcDetails = _context.sent;
                    return _context.abrupt("return", _vcDetails);
                case 11:
                    if (!(algo === 'old_heatmap')) {
                        _context.next = 16;
                        break;
                    }
                    _context.next = 14;
                    return (0, $kap5K.default)(arg);
                case 14:
                    _vcDetails2 = _context.sent;
                    return _context.abrupt("return", _vcDetails2);
                case 16:
                    throw new Error('unexpected Error algo not chosen correctly');
                case 17:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    function calculateTTVCPercentiles(_x) {
        return _calculateTTVCPercentiles.apply(this, arguments);
    }
    return calculateTTVCPercentiles;
}(), [
    'vc'
]);
var $3260c2124a894e2e$export$2e2bcd8739ae039 = $3260c2124a894e2e$var$calculateTTVCPercentiles;

});
parcelRegister("ZJbix", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b98beab885f66b6$export$2e2bcd8739ae039; });

var $5YM7L = parcelRequire("5YM7L");

var $2R76C = parcelRequire("2R76C");

var $eWMMH = parcelRequire("eWMMH");

var $f1k1y = parcelRequire("f1k1y");

var $5Dj3P = parcelRequire("5Dj3P");

var $4xYkV = parcelRequire("4xYkV");
function $0b98beab885f66b6$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $0b98beab885f66b6$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $0b98beab885f66b6$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $0b98beab885f66b6$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $0b98beab885f66b6$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $0b98beab885f66b6$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $0b98beab885f66b6$var$calculateTTVCPercentiles = (0, $5Dj3P.withProfiling)(/*#__PURE__*/ function() {
    var _calculateTTVCPercentiles = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee(_ref) {
        var viewport, orderedEntries, percentiles, startTime, canvas, elementMap, _iterator, _step, entry, rect, elementName, timePixelCounts, canvasDimenstions, totalPixels;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    viewport = _ref.viewport, orderedEntries = _ref.orderedEntries, percentiles = _ref.percentiles, startTime = _ref.startTime;
                    canvas = new (0, $4xYkV.ViewportCanvas)(viewport, (0, $f1k1y.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
                    elementMap = new Map();
                    _iterator = $0b98beab885f66b6$var$_createForOfIteratorHelper(orderedEntries);
                    _context.prev = 4;
                    _iterator.s();
                case 6:
                    if ((_step = _iterator.n()).done) {
                        _context.next = 17;
                        break;
                    }
                    entry = _step.value;
                    if ('rect' in entry.data) {
                        _context.next = 10;
                        break;
                    }
                    return _context.abrupt("continue", 15);
                case 10:
                    rect = entry.data.rect;
                    elementName = entry.data.elementName;
                    canvas.drawRect(rect, entry.time);
                    if (!elementMap.has(entry.time)) elementMap.set(entry.time, new Set());
                    elementMap.get(entry.time).add(elementName);
                case 15:
                    _context.next = 6;
                    break;
                case 17:
                    _context.next = 22;
                    break;
                case 19:
                    _context.prev = 19;
                    _context.t0 = _context["catch"](4);
                    _iterator.e(_context.t0);
                case 22:
                    _context.prev = 22;
                    _iterator.f();
                    return _context.finish(22);
                case 25:
                    _context.next = 27;
                    return canvas.getPixelCounts();
                case 27:
                    timePixelCounts = _context.sent;
                    canvasDimenstions = canvas.getScaledDimensions();
                    totalPixels = canvasDimenstions.width * canvasDimenstions.height;
                    return _context.abrupt("return", $0b98beab885f66b6$export$89c8da9b65eff678(timePixelCounts, elementMap, percentiles, totalPixels, startTime));
                case 31:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                4,
                19,
                22,
                25
            ]
        ]);
    }));
    function calculateTTVCPercentiles(_x) {
        return _calculateTTVCPercentiles.apply(this, arguments);
    }
    return calculateTTVCPercentiles;
}(), [
    'vc'
]);
var $0b98beab885f66b6$export$2e2bcd8739ae039 = $0b98beab885f66b6$var$calculateTTVCPercentiles;
var $0b98beab885f66b6$export$89c8da9b65eff678 = (0, $5Dj3P.withProfiling)(function calculatePercentiles(timePixelCounts, elementMap, unorderedPercentiles, totalPixels, startTime) {
    var results = {};
    var cumulativePixels = 0;
    var percentiles = unorderedPercentiles.sort(function(a, b) {
        return a - b;
    });
    // Sort entries by timestamp for consistent processing
    var sortedEntries = Array.from(timePixelCounts.entries()).sort(function(_ref2, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_ref2, 1), timeA = _ref4[0];
        var _ref5 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_ref3, 1), timeB = _ref5[0];
        return Number(timeA) - Number(timeB);
    });
    var percentileIndex = 0;
    var domElementsBuffer = new Set();
    var _iterator2 = $0b98beab885f66b6$var$_createForOfIteratorHelper(sortedEntries), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var _step2$value = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_step2.value, 2), time = _step2$value[0], pixelCount = _step2$value[1];
            cumulativePixels += pixelCount;
            var percentCovered = cumulativePixels / totalPixels * 100;
            var elementNames = elementMap.get(time) || new Set();
            elementNames.forEach(function(elName) {
                return domElementsBuffer.add(elName);
            });
            var matchesAnyCheckpoints = false;
            while(percentileIndex < percentiles.length && percentCovered >= percentiles[percentileIndex]){
                results["".concat(percentiles[percentileIndex])] = {
                    t: Math.round(Number(time - startTime)),
                    e: Array.from(domElementsBuffer)
                };
                percentileIndex++;
                matchesAnyCheckpoints = true;
            }
            if (matchesAnyCheckpoints) domElementsBuffer.clear();
            if (percentileIndex >= percentiles.length) break;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    var previousResult = {
        t: 0,
        e: []
    };
    for(var i = 0; i < percentiles.length; i++){
        var percentile = percentiles[i];
        if (!(percentile in results)) results["".concat(percentile)] = previousResult;
        previousResult = results["".concat(percentile)];
    }
    return results;
}, [
    'vc'
]);

});
parcelRegister("4xYkV", function(module, exports) {

$parcel$export(module.exports, "ViewportCanvas", function () { return $34f90c142cef59f4$export$3e59ac9de7402fb1; });

var $2R76C = parcelRequire("2R76C");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $eWMMH = parcelRequire("eWMMH");

var $5Dj3P = parcelRequire("5Dj3P");

var $cCtf5 = parcelRequire("cCtf5");
var $34f90c142cef59f4$export$3e59ac9de7402fb1 = /*#__PURE__*/ function() {
    /** The underlying OffscreenCanvas instance */ /** The 2D rendering context of the canvas */ /** Scale factor applied to the canvas (affects final pixel counts) */ /** Maps unique colors to their corresponding timestamps */ /** Counter used to generate unique colors */ /**
   * Creates a new ViewportCanvas instance.
   * @param viewport - The dimensions of the viewport
   * @param scaleFactor - Scale factor to apply to the canvas (default: 0.5)
   * @throws {Error} If canvas context cannot be obtained
   */ function ViewportCanvas(viewport) {
        var scaleFactor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, ViewportCanvas);
        var operationTimer = (0, $5Dj3P.markProfilingStart)('ViewportCanvas constructor');
        this.scaleFactor = scaleFactor;
        this.colorCounter = 1;
        this.colorTimeMap = new Map();
        var safeViewportWidth = Math.max(viewport.width, 1);
        var safeViewportHeight = Math.max(viewport.height, 1);
        // Calculate scaled dimensions
        this.scaledWidth = Math.max(Math.ceil(safeViewportWidth * scaleFactor), 1);
        this.scaledHeight = Math.max(Math.ceil(safeViewportHeight * scaleFactor), 1);
        this.scaleX = this.scaledWidth / safeViewportWidth;
        this.scaleY = this.scaledHeight / safeViewportHeight;
        // Initialize OffscreenCanvas with scaled dimensions
        this.canvas = document.createElement('canvas');
        this.canvas.width = this.scaledWidth;
        this.canvas.height = this.scaledHeight;
        var ctx = this.canvas.getContext('2d', {
            alpha: false,
            // Disable alpha channel for better performance
            willReadFrequently: true,
            // Optimize for frequent pixel reading
            colorSpace: 'srgb' // Use standard RGB color space
        });
        if (!ctx) throw new Error('Could not get canvas context');
        this.ctx = ctx;
        this.ctx.globalCompositeOperation = 'source-over';
        this.clear();
        this.getScaledDimensions = (0, $5Dj3P.withProfiling)(this.getScaledDimensions.bind(this), [
            'vc'
        ]);
        this.clear = (0, $5Dj3P.withProfiling)(this.clear.bind(this), [
            'vc'
        ]);
        this.generateColor = (0, $5Dj3P.withProfiling)(this.generateColor.bind(this), [
            'vc'
        ]);
        this.drawRect = (0, $5Dj3P.withProfiling)(this.drawRect.bind(this), [
            'vc'
        ]);
        this.getPixelCounts = (0, $5Dj3P.withProfiling)(this.getPixelCounts.bind(this), [
            'vc'
        ]);
        (0, $5Dj3P.markProfilingEnd)(operationTimer, {
            tags: [
                'vc'
            ]
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(ViewportCanvas, [
        {
            key: "getScaledDimensions",
            value: function getScaledDimensions() {
                return {
                    width: this.scaledWidth,
                    height: this.scaledHeight
                };
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            }
        },
        {
            key: "generateColor",
            value: function generateColor() {
                // Wrap around at 16,777,215 (0x00FFFFFF) to stay within 24-bit color space
                var rgbColor = this.colorCounter++ % 0x00ffffff;
                return $34f90c142cef59f4$export$54591583ed0b20ce(rgbColor);
            }
        },
        {
            key: "drawRect",
            value: function drawRect(rect, timestamp) {
                var color = this.generateColor();
                this.colorTimeMap.set(color, timestamp);
                this.ctx.fillStyle = color;
                if (this.scaleFactor === 1) return this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
                var scaledX = rect.x * this.scaleX;
                var scaledY = rect.y * this.scaleY;
                var scaledWidth = rect.width * this.scaleX;
                var scaledHeight = rect.height * this.scaleY;
                this.ctx.fillRect(Math.floor(scaledX), Math.ceil(scaledY), Math.max(scaledWidth, 1), Math.max(scaledHeight, 1));
            }
        },
        {
            key: "getPixelCounts",
            value: function() {
                var _getPixelCounts = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee() {
                    var imageData, timestampsAmount, pixelCounts, timePixelCounts, i, count, color, rgbColor, timestamp;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                imageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
                                timestampsAmount = this.colorTimeMap.size;
                                _context.next = 4;
                                return $34f90c142cef59f4$export$fafc9be44839f9c8(imageData, this.scaleFactor, timestampsAmount);
                            case 4:
                                pixelCounts = _context.sent;
                                // Convert color counts to timestamp counts
                                timePixelCounts = new Map();
                                i = 0;
                            case 7:
                                if (!(i < pixelCounts.length)) {
                                    _context.next = 18;
                                    break;
                                }
                                count = pixelCounts[i];
                                if (!(typeof count !== 'number')) {
                                    _context.next = 11;
                                    break;
                                }
                                return _context.abrupt("continue", 15);
                            case 11:
                                color = i + 1;
                                rgbColor = $34f90c142cef59f4$export$54591583ed0b20ce(color);
                                timestamp = this.colorTimeMap.get(rgbColor);
                                if (timestamp !== undefined) timePixelCounts.set(timestamp, (timePixelCounts.get(timestamp) || 0) + count);
                            case 15:
                                i++;
                                _context.next = 7;
                                break;
                            case 18:
                                return _context.abrupt("return", timePixelCounts);
                            case 19:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getPixelCounts() {
                    return _getPixelCounts.apply(this, arguments);
                }
                return getPixelCounts;
            }()
        }
    ]);
}();
var $34f90c142cef59f4$export$54591583ed0b20ce = (0, $5Dj3P.withProfiling)(function getRGBComponents(n) {
    // Ensure the input is within the valid range for a 24-bit color
    if (n < 0 || n > 0xffffff) throw new Error('Input number must be between 0 and 16777215 (inclusive).');
    // Extract blue component (bits 0-7)
    var blue = n & 0xff;
    // Extract green component (bits 8-15)
    var green = n >> 8 & 0xff;
    // Extract red component (bits 16-23)
    var red = n >> 16 & 0xff;
    return "rgb(".concat(red, ", ").concat(green, ", ").concat(blue, ")");
}, [
    'vc'
]);
var $34f90c142cef59f4$export$fafc9be44839f9c8 = (0, $5Dj3P.withProfiling)(/*#__PURE__*/ function() {
    var _calculateDrawnPixelsRaw = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee2(imageData, scaleFactor, arraySize) {
        var data, arr, i, color, colorIndex;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    data = imageData.data;
                    arr = new Uint32Array(arraySize);
                    i = 0;
                case 3:
                    if (!(i < data.length)) {
                        _context2.next = 11;
                        break;
                    }
                    // Check alpha
                    if (data[i + 3] !== 0) {
                        // Combine RGB components into a single 24-bit color value:
                        // (data[i] << 16)   - Shift red component left 16 bits   (bits 16-23)
                        // (data[i + 1] << 8) - Shift green component left 8 bits (bits 8-15)
                        // data[i + 2]       - Blue component stays as is         (bits 0-7)
                        // The | operator combines all bits together
                        color = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
                        colorIndex = color - 1;
                        arr[colorIndex] = (arr[colorIndex] || 0) + 1;
                    }
                    if (!(i % 10000 === 0)) {
                        _context2.next = 8;
                        break;
                    }
                    _context2.next = 8;
                    return (0, $cCtf5.default)();
                case 8:
                    i += 4;
                    _context2.next = 3;
                    break;
                case 11:
                    return _context2.abrupt("return", arr);
                case 12:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    function calculateDrawnPixelsRaw(_x, _x2, _x3) {
        return _calculateDrawnPixelsRaw.apply(this, arguments);
    }
    return calculateDrawnPixelsRaw;
}(), [
    'vc'
]);

});
parcelRegister("cCtf5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92ffb78dd308f6e0$export$2e2bcd8739ae039; });

var $2R76C = parcelRequire("2R76C");

var $eWMMH = parcelRequire("eWMMH");

var $5Dj3P = parcelRequire("5Dj3P");
// See https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
var $92ffb78dd308f6e0$var$taskYield = (0, $5Dj3P.withProfiling)(/*#__PURE__*/ function() {
    var _taskYield = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee() {
        var resolve, p;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!('scheduler' in globalThis && // @ts-ignore
                    'yield' in globalThis.scheduler)) {
                        _context.next = 4;
                        break;
                    }
                    _context.next = 3;
                    return scheduler.yield();
                case 3:
                    return _context.abrupt("return");
                case 4:
                    resolve = function resolve() {};
                    p = new Promise(function(a) {
                        resolve = a;
                    });
                    setTimeout(resolve, 0);
                    _context.next = 9;
                    return p;
                case 9:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    function taskYield() {
        return _taskYield.apply(this, arguments);
    }
    return taskYield;
}(), [
    'vc'
]);
var $92ffb78dd308f6e0$export$2e2bcd8739ae039 = $92ffb78dd308f6e0$var$taskYield;

});



parcelRegister("kap5K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eae83482d32518a3$export$2e2bcd8739ae039; });

var $iqLBO = parcelRequire("iqLBO");

var $dsN6L = parcelRequire("dsN6L");

var $2R76C = parcelRequire("2R76C");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $eWMMH = parcelRequire("eWMMH");

var $5Dj3P = parcelRequire("5Dj3P");

var $hJ8kW = parcelRequire("hJ8kW");

var $cCtf5 = parcelRequire("cCtf5");
function $eae83482d32518a3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $eae83482d32518a3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $eae83482d32518a3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $eae83482d32518a3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $eae83482d32518a3$var$MAX_HEATMAP_SIZE = 1000;
var $eae83482d32518a3$var$createEmptyHeatmapEntry = (0, $5Dj3P.withProfiling)(function createEmptyHeatmapEntry() {
    return {
        head: null,
        previousEntries: []
    };
}, [
    'vc'
]);
var $eae83482d32518a3$var$createEmptyMap = (0, $5Dj3P.withProfiling)(function createEmptyMap(heatmapWidth, heatmapHeight) {
    return Array.from({
        length: heatmapHeight
    }).map(function() {
        return Array.from({
            length: heatmapWidth
        }).map($eae83482d32518a3$var$createEmptyHeatmapEntry);
    });
}, [
    'vc'
]);
var $eae83482d32518a3$var$isRectInside = (0, $5Dj3P.withProfiling)(function isRectInside(a, b) {
    if (!a || !b) return false;
    // Check if all corners of rectangle a are within the bounds of rectangle b
    return a.left >= b.left && a.right <= b.right && a.top >= b.top && a.bottom <= b.bottom;
}, [
    'vc'
]);
var $eae83482d32518a3$var$Heatmap = /*#__PURE__*/ function() {
    /**
   * Heatmap Width
   */ /**
   * Heatmap Height
   */ /**
   * Heatmap Area (width * height)
   */ function Heatmap(_ref) {
        var viewport = _ref.viewport, heatmapSize = _ref.heatmapSize;
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, Heatmap);
        var operationTimer = (0, $5Dj3P.markProfilingStart)('Heatmap constructor');
        // TODO timeOrigin? do we need? for SSR??
        this.viewport = viewport;
        var safeSize = Math.min(heatmapSize, $eae83482d32518a3$var$MAX_HEATMAP_SIZE);
        if (viewport.width === 0 || viewport.height === 0) {
            this.width = safeSize;
            this.height = safeSize;
            this.scaleX = 1;
            this.scaleY = 1;
            this.heatmapAreaSize = 0;
            this.map = $eae83482d32518a3$var$createEmptyMap(safeSize, safeSize);
            return;
        }
        var aspectRatio = viewport.width / viewport.height;
        if (aspectRatio > 1) {
            // Landscape orientation
            this.width = safeSize;
            this.height = Math.round(safeSize / aspectRatio);
        } else {
            // Portrait orientation
            this.width = safeSize;
            this.height = Math.round(safeSize * aspectRatio);
        }
        this.scaleX = this.width / viewport.width;
        this.scaleY = this.height / viewport.height;
        this.heatmapAreaSize = this.width * this.height;
        this.map = $eae83482d32518a3$var$createEmptyMap(this.width, this.height);
        this.getHeatmap = (0, $5Dj3P.withProfiling)(this.getHeatmap.bind(this), [
            'vc'
        ]);
        this.getCell = (0, $5Dj3P.withProfiling)(this.getCell.bind(this), [
            'vc'
        ]);
        this.mapDOMRectToHeatmap = (0, $5Dj3P.withProfiling)(this.mapDOMRectToHeatmap.bind(this), [
            'vc'
        ]);
        this.getRatio = (0, $5Dj3P.withProfiling)(this.getRatio.bind(this), [
            'vc'
        ]);
        this.applyEntriesToHeatmap = (0, $5Dj3P.withProfiling)(this.applyEntriesToHeatmap.bind(this), [
            'vc'
        ]);
        this.getVCPercentMetrics = (0, $5Dj3P.withProfiling)(this.getVCPercentMetrics.bind(this), [
            'vc'
        ]);
        (0, $5Dj3P.markProfilingEnd)(operationTimer, {
            tags: [
                'vc'
            ]
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(Heatmap, [
        {
            key: "getHeatmap",
            value: function getHeatmap() {
                return this.map;
            }
        },
        {
            key: "getCell",
            value: function getCell(row, col) {
                var _this$map$row;
                return (_this$map$row = this.map[row]) === null || _this$map$row === void 0 ? void 0 : _this$map$row[col];
            }
        },
        {
            key: "mapDOMRectToHeatmap",
            value: function mapDOMRectToHeatmap(rect) {
                var scaledX = rect.x * this.scaleX;
                var scaledY = rect.y * this.scaleY;
                var scaledWidth = rect.width * this.scaleX;
                var scaledHeight = rect.height * this.scaleY;
                return {
                    left: Math.floor(scaledX),
                    right: Math.ceil(scaledX + scaledWidth),
                    top: Math.floor(scaledY),
                    bottom: Math.ceil(scaledY + scaledHeight)
                };
            }
        },
        {
            key: "getRatio",
            value: function getRatio(rect) {
                if (this.viewport.width === 0 || this.viewport.height === 0) return 0;
                var right = rect.right, left = rect.left, bottom = rect.bottom, top = rect.top;
                var rectWidth = right - left;
                var rectHeight = bottom - top;
                var rectArea = rectWidth * rectHeight;
                var ratio = rectArea / this.heatmapAreaSize;
                if (ratio > 1) return 1;
                return ratio;
            }
        },
        {
            key: "applyEntriesToHeatmap",
            value: function() {
                var _applyEntriesToHeatmap = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee(entries) {
                    var i, entry, time, type, data, rect, ratio, heatmapEntryData, roundedTop, roundedBottom, roundedLeft, roundedRight, row, col, cell, previousEntry;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                i = 0;
                            case 1:
                                if (!(i < entries.length)) {
                                    _context.next = 37;
                                    break;
                                }
                                entry = entries[i];
                                time = entry.time, type = entry.type, data = entry.data;
                                if (!(0, $hJ8kW.default)(data)) {
                                    _context.next = 31;
                                    break;
                                }
                                rect = this.mapDOMRectToHeatmap(data.rect);
                                ratio = this.getRatio(rect);
                                heatmapEntryData = {
                                    time: time,
                                    elementName: data.elementName,
                                    ratio: ratio !== null && ratio !== void 0 ? ratio : null,
                                    rect: rect,
                                    source: type
                                };
                                roundedTop = Math.floor(rect.top);
                                roundedBottom = Math.min(rect.bottom, this.height);
                                roundedLeft = Math.floor(rect.left);
                                roundedRight = Math.min(rect.right, this.width);
                                row = roundedTop;
                            case 13:
                                if (!(row < roundedBottom)) {
                                    _context.next = 31;
                                    break;
                                }
                                col = roundedLeft;
                            case 15:
                                if (!(col < roundedRight)) {
                                    _context.next = 28;
                                    break;
                                }
                                cell = this.getCell(row, col);
                                if (cell) {
                                    _context.next = 19;
                                    break;
                                }
                                return _context.abrupt("continue", 25);
                            case 19:
                                previousEntry = cell.head; // When elements are added at the same time
                                // we try to keep the inner element changes as the head
                                if (!((previousEntry === null || previousEntry === void 0 ? void 0 : previousEntry.time) === entry.time && $eae83482d32518a3$var$isRectInside(previousEntry.rect, heatmapEntryData.rect))) {
                                    _context.next = 23;
                                    break;
                                }
                                cell.previousEntries.push($eae83482d32518a3$var$_objectSpread($eae83482d32518a3$var$_objectSpread({}, heatmapEntryData), {}, {
                                    source: 'mutation:parent-mounted'
                                }));
                                return _context.abrupt("continue", 25);
                            case 23:
                                cell.head = $eae83482d32518a3$var$_objectSpread($eae83482d32518a3$var$_objectSpread({}, heatmapEntryData), {}, {
                                    source: heatmapEntryData.source || null
                                });
                                if (previousEntry !== null) cell.previousEntries.push(previousEntry);
                            case 25:
                                col++;
                                _context.next = 15;
                                break;
                            case 28:
                                row++;
                                _context.next = 13;
                                break;
                            case 31:
                                if (!(i % 100 === 0)) {
                                    _context.next = 34;
                                    break;
                                }
                                _context.next = 34;
                                return (0, $cCtf5.default)();
                            case 34:
                                i++;
                                _context.next = 1;
                                break;
                            case 37:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function applyEntriesToHeatmap(_x) {
                    return _applyEntriesToHeatmap.apply(this, arguments);
                }
                return applyEntriesToHeatmap;
            }()
        },
        {
            key: "getVCPercentMetrics",
            value: function() {
                var _getVCPercentMetrics = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee2(vcPercentCheckpoint, startTime) {
                    var sortedCheckpoints, flattenHeatmap, totalCells, timestampMap, i, _cellHead$time, _timestampMap$get, cell, cellHead, timestamp, elementName, curr, sortedTimings, totalCellPainted, result, domElementsBuffer, _i, _timestamp, timestampInfo, cellCount, domElements, currVCRatio, currVCPercent, matchesAnyCheckpoints, checkpoint, _domElements;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                sortedCheckpoints = (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(vcPercentCheckpoint).sort(function(a, b) {
                                    return a - b;
                                });
                                flattenHeatmap = this.map.flat();
                                totalCells = flattenHeatmap.length;
                                timestampMap = new Map();
                                i = 0;
                            case 5:
                                if (!(i < flattenHeatmap.length)) {
                                    _context2.next = 20;
                                    break;
                                }
                                cell = flattenHeatmap[i];
                                cellHead = cell.head;
                                timestamp = Math.trunc((_cellHead$time = cellHead === null || cellHead === void 0 ? void 0 : cellHead.time) !== null && _cellHead$time !== void 0 ? _cellHead$time : 0);
                                elementName = cellHead === null || cellHead === void 0 ? void 0 : cellHead.elementName;
                                curr = (_timestampMap$get = timestampMap.get(timestamp)) !== null && _timestampMap$get !== void 0 ? _timestampMap$get : {
                                    cellCount: 0,
                                    domElements: new Set()
                                };
                                curr.cellCount += 1;
                                if (elementName) curr.domElements.add(elementName);
                                timestampMap.set(timestamp, curr);
                                // Every 10000 heatmap entries processed
                                // we give the browser the power
                                // to process any other high priority task
                                if (!(i > 10000 && i % 10000 === 0)) {
                                    _context2.next = 17;
                                    break;
                                }
                                _context2.next = 17;
                                return (0, $cCtf5.default)();
                            case 17:
                                i++;
                                _context2.next = 5;
                                break;
                            case 20:
                                sortedTimings = (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(timestampMap.keys()).sort(function(a, b) {
                                    return a - b;
                                });
                                totalCellPainted = 0;
                                result = {};
                                domElementsBuffer = new Set();
                                _i = 0;
                            case 25:
                                if (!(_i < sortedTimings.length)) {
                                    _context2.next = 52;
                                    break;
                                }
                                _timestamp = sortedTimings[_i];
                                timestampInfo = timestampMap.get(_timestamp);
                                if (timestampInfo) {
                                    _context2.next = 30;
                                    break;
                                }
                                throw new Error('unexpected timestampInfo not found');
                            case 30:
                                cellCount = timestampInfo.cellCount, domElements = timestampInfo.domElements;
                                totalCellPainted += cellCount;
                                currVCRatio = totalCellPainted / totalCells;
                                currVCPercent = Math.round(currVCRatio * 100);
                                domElements.forEach(function(domElement) {
                                    domElementsBuffer.add(domElement);
                                });
                                matchesAnyCheckpoints = false;
                            case 36:
                                if (!(sortedCheckpoints.length > 0 && currVCPercent >= sortedCheckpoints[0])) {
                                    _context2.next = 45;
                                    break;
                                }
                                checkpoint = sortedCheckpoints.shift();
                                _domElements = (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(domElementsBuffer);
                                if (checkpoint) {
                                    _context2.next = 41;
                                    break;
                                }
                                return _context2.abrupt("break", 45);
                            case 41:
                                matchesAnyCheckpoints = true;
                                result[checkpoint.toString()] = {
                                    t: Math.round(_timestamp - startTime),
                                    e: _domElements
                                };
                                _context2.next = 36;
                                break;
                            case 45:
                                if (matchesAnyCheckpoints) domElementsBuffer.clear();
                                if (!(_i % 500 === 0)) {
                                    _context2.next = 49;
                                    break;
                                }
                                _context2.next = 49;
                                return (0, $cCtf5.default)();
                            case 49:
                                _i++;
                                _context2.next = 25;
                                break;
                            case 52:
                                return _context2.abrupt("return", result);
                            case 53:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getVCPercentMetrics(_x2, _x3) {
                    return _getVCPercentMetrics.apply(this, arguments);
                }
                return getVCPercentMetrics;
            }()
        }
    ]);
}();
var $eae83482d32518a3$var$calculateTTVCPercentiles = (0, $5Dj3P.withProfiling)(/*#__PURE__*/ function() {
    var _calculateTTVCPercentiles = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee3(_ref2) {
        var orderedEntries, viewport, percentiles, startTime, heatmap, vcDetails;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    orderedEntries = _ref2.orderedEntries, viewport = _ref2.viewport, percentiles = _ref2.percentiles, startTime = _ref2.startTime;
                    heatmap = new $eae83482d32518a3$var$Heatmap({
                        viewport: viewport,
                        heatmapSize: 200
                    });
                    _context3.next = 4;
                    return heatmap.applyEntriesToHeatmap(orderedEntries);
                case 4:
                    _context3.next = 6;
                    return heatmap.getVCPercentMetrics(percentiles, startTime);
                case 6:
                    vcDetails = _context3.sent;
                    return _context3.abrupt("return", vcDetails);
                case 8:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    function calculateTTVCPercentiles(_x4) {
        return _calculateTTVCPercentiles.apply(this, arguments);
    }
    return calculateTTVCPercentiles;
}(), [
    'vc'
]);
var $eae83482d32518a3$export$2e2bcd8739ae039 = $eae83482d32518a3$var$calculateTTVCPercentiles;

});
parcelRegister("hJ8kW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce7d1b2a49b1f71b$export$2e2bcd8739ae039; });

var $5Dj3P = parcelRequire("5Dj3P");
var $ce7d1b2a49b1f71b$var$isViewportEntryData = (0, $5Dj3P.withProfiling)(function isViewportEntryData(data) {
    if (data) {
        var hasElementName = typeof data.elementName === 'string';
        var hasRect = typeof data.rect !== 'undefined';
        if (hasRect && hasElementName) return true;
    }
    return false;
}, [
    'vc'
]);
var $ce7d1b2a49b1f71b$export$2e2bcd8739ae039 = $ce7d1b2a49b1f71b$var$isViewportEntryData;

});


parcelRegister("e0z6A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a32c4bed4380e259$export$2e2bcd8739ae039; });

var $iqLBO = parcelRequire("iqLBO");

var $2R76C = parcelRequire("2R76C");

var $eWMMH = parcelRequire("eWMMH");

var $5Dj3P = parcelRequire("5Dj3P");

var $hJ8kW = parcelRequire("hJ8kW");

var $cCtf5 = parcelRequire("cCtf5");

var $3SvAV = parcelRequire("3SvAV");
var $a32c4bed4380e259$var$calculateTTVCPercentiles = (0, $5Dj3P.withProfiling)(/*#__PURE__*/ function() {
    var _calculateTTVCPercentiles = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee(_ref) {
        var orderedEntries, viewport, percentiles, startTime, sortedPercentiles, viewportArea, checkpoints, activeRects, removeActiveRect, domElementsBuffer, i, iEntry, iEntryData, rect, elementName, exclusionArea, currentArea, currVCPercent, matchesAnyCheckpoints, _checkpoint, domElements;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    orderedEntries = _ref.orderedEntries, viewport = _ref.viewport, percentiles = _ref.percentiles, startTime = _ref.startTime;
                    sortedPercentiles = (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(percentiles).sort(function(a, b) {
                        return a - b;
                    });
                    viewportArea = viewport.width * viewport.height;
                    checkpoints = {};
                    activeRects = orderedEntries.filter(function(e) {
                        return (0, $hJ8kW.default)(e.data);
                    }).map(function(e) {
                        return e.data.rect;
                    });
                    removeActiveRect = function removeActiveRect(rectToRemove) {
                        var index = activeRects.indexOf(rectToRemove);
                        // Check if the element exists in the array
                        if (index !== -1) // Remove the element at the found index
                        activeRects.splice(index, 1);
                    };
                    domElementsBuffer = new Set();
                    i = 0;
                case 8:
                    if (!(i < orderedEntries.length)) {
                        _context.next = 36;
                        break;
                    }
                    iEntry = orderedEntries[i];
                    iEntryData = iEntry.data;
                    if ((0, $hJ8kW.default)(iEntryData)) {
                        _context.next = 13;
                        break;
                    }
                    return _context.abrupt("continue", 33);
                case 13:
                    rect = iEntryData.rect, elementName = iEntryData.elementName;
                    domElementsBuffer.add(elementName);
                    removeActiveRect(rect);
                    exclusionArea = (0, $3SvAV.default)(activeRects);
                    currentArea = viewportArea - exclusionArea;
                    currVCPercent = Math.round(currentArea / viewportArea * 100);
                    matchesAnyCheckpoints = false;
                case 20:
                    if (!(sortedPercentiles.length > 0 && currVCPercent >= sortedPercentiles[0])) {
                        _context.next = 29;
                        break;
                    }
                    _checkpoint = sortedPercentiles.shift();
                    domElements = (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(domElementsBuffer);
                    if (_checkpoint) {
                        _context.next = 25;
                        break;
                    }
                    return _context.abrupt("break", 29);
                case 25:
                    matchesAnyCheckpoints = true;
                    checkpoints[_checkpoint.toString()] = {
                        t: Math.round(iEntry.time - startTime),
                        e: domElements
                    };
                    _context.next = 20;
                    break;
                case 29:
                    if (matchesAnyCheckpoints) domElementsBuffer.clear();
                    if (!(i % 500 === 0)) {
                        _context.next = 33;
                        break;
                    }
                    _context.next = 33;
                    return (0, $cCtf5.default)();
                case 33:
                    i++;
                    _context.next = 8;
                    break;
                case 36:
                    return _context.abrupt("return", checkpoints);
                case 37:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    function calculateTTVCPercentiles(_x) {
        return _calculateTTVCPercentiles.apply(this, arguments);
    }
    return calculateTTVCPercentiles;
}(), [
    'vc'
]);
var $a32c4bed4380e259$export$2e2bcd8739ae039 = $a32c4bed4380e259$var$calculateTTVCPercentiles;

});
parcelRegister("3SvAV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d2eec4827e97f05$export$2e2bcd8739ae039; });

var $5YM7L = parcelRequire("5YM7L");

var $iqLBO = parcelRequire("iqLBO");

var $5Dj3P = parcelRequire("5Dj3P");
function $2d2eec4827e97f05$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $2d2eec4827e97f05$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $2d2eec4827e97f05$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $2d2eec4827e97f05$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $2d2eec4827e97f05$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $2d2eec4827e97f05$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
/**
 * Calculate the union areas of all rectangles using Sweep Line Algorithm
 *
 * Reference:
 * 	https://en.wikipedia.org/wiki/Sweep_line_algorithm
 *  https://www.hackerearth.com/practice/math/geometry/line-sweep-technique/tutorial/#:~:text=A%20sweep%20line%20is%20an,order%20to%20discretize%20the%20sweep.
 *
 * @param rectangles
 * @returns
 */ var $2d2eec4827e97f05$var$calculateUnionArea = (0, $5Dj3P.withProfiling)(function calculateUnionArea(rectangles) {
    // Step 1: Create sweep line events
    var events = $2d2eec4827e97f05$var$createSweepLineEvents(rectangles);
    // Step 2: Process events to calculate total area
    var activeIntervals = new Map();
    var totalArea = 0;
    var previousX = 0;
    var _iterator = $2d2eec4827e97f05$var$_createForOfIteratorHelper(events), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var event = _step.value;
            // Calculate height at current x-position
            var currentHeight = $2d2eec4827e97f05$var$calculateActiveHeight(activeIntervals);
            // Add area since last x-position
            totalArea += currentHeight * (event.x - previousX);
            // Update x-position
            previousX = event.x;
            // Update active intervals
            $2d2eec4827e97f05$var$updateActiveIntervals(activeIntervals, event);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return totalArea;
}, [
    'vc'
]);
var $2d2eec4827e97f05$export$2e2bcd8739ae039 = $2d2eec4827e97f05$var$calculateUnionArea;
var $2d2eec4827e97f05$var$createSweepLineEvents = (0, $5Dj3P.withProfiling)(function createSweepLineEvents(rectangles) {
    var events = [];
    var _iterator2 = $2d2eec4827e97f05$var$_createForOfIteratorHelper(rectangles), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var rect = _step2.value;
            // Create start and end events for each rectangle
            events.push({
                x: rect.left,
                type: 'start',
                top: rect.top,
                bottom: rect.bottom
            });
            events.push({
                x: rect.right,
                type: 'end',
                top: rect.top,
                bottom: rect.bottom
            });
        }
    // Sort events by x-coordinate (and type as tiebreaker)
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return events.sort(function(a, b) {
        return a.x === b.x ? a.type === 'end' ? 1 : -1 : a.x - b.x;
    });
}, [
    'vc'
]);
var $2d2eec4827e97f05$var$calculateActiveHeight = (0, $5Dj3P.withProfiling)(function calculateActiveHeight(intervals) {
    if (intervals.size === 0) return 0;
    // Get all unique y-coordinates
    var coordinates = [];
    var _iterator3 = $2d2eec4827e97f05$var$_createForOfIteratorHelper(intervals), _step3;
    try {
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
            var _step3$value = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_step3.value, 1), _key = _step3$value[0];
            var _key$split$map3 = _key.split(',').map(Number), _key$split$map4 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_key$split$map3, 2), _start = _key$split$map4[0], _end = _key$split$map4[1];
            coordinates.push(_start, _end);
        }
    // Sort coordinates
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
    var sortedCoords = (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(new Set(coordinates)).sort(function(a, b) {
        return a - b;
    });
    var totalHeight = 0;
    // Check each segment between consecutive coordinates
    for(var i = 0; i < sortedCoords.length; i++){
        var y1 = sortedCoords[i];
        var y2 = sortedCoords[i + 1];
        // Check if this segment is covered by any active interval
        var covered = false;
        var _iterator4 = $2d2eec4827e97f05$var$_createForOfIteratorHelper(intervals), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _step4$value = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_step4.value, 2), key = _step4$value[0], count = _step4$value[1];
                if (count <= 0) continue;
                var _key$split$map = key.split(',').map(Number), _key$split$map2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_key$split$map, 2), start = _key$split$map2[0], end = _key$split$map2[1];
                if (start <= y1 && end >= y2) {
                    covered = true;
                    break;
                }
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
        if (covered) totalHeight += y2 - y1;
    }
    return totalHeight;
}, [
    'vc'
]);
var $2d2eec4827e97f05$var$updateActiveIntervals = (0, $5Dj3P.withProfiling)(function updateActiveIntervals(intervals, event) {
    var key = "".concat(event.top, ",").concat(event.bottom);
    if (event.type === 'start') intervals.set(key, (intervals.get(key) || 0) + 1);
    else {
        var count = intervals.get(key) || 0;
        if (count > 1) intervals.set(key, count - 1);
        else intervals.delete(key);
    }
}, [
    'vc'
]);

});



parcelRegister("kNHoN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f24a0c627902430c$export$2e2bcd8739ae039; });

var $5Dj3P = parcelRequire("5Dj3P");
var $f24a0c627902430c$var$getViewportHeight = (0, $5Dj3P.withProfiling)(function getViewportHeight() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (e) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}, [
    'vc'
]);
var $f24a0c627902430c$export$2e2bcd8739ae039 = $f24a0c627902430c$var$getViewportHeight;

});

parcelRegister("jINBT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5b89beab5ad3732$export$2e2bcd8739ae039; });

var $5Dj3P = parcelRequire("5Dj3P");
var $e5b89beab5ad3732$var$getViewportWidth = (0, $5Dj3P.withProfiling)(function getViewportWidth() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (e) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}, [
    'vc'
]);
var $e5b89beab5ad3732$export$2e2bcd8739ae039 = $e5b89beab5ad3732$var$getViewportWidth;

});



parcelRegister("veLXE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05de5ae3b2b73f3b$export$2e2bcd8739ae039; });

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $5Dj3P = parcelRequire("5Dj3P");

var $U9jzZ = parcelRequire("U9jzZ");

var $6cg1G = parcelRequire("6cg1G");

var $4Ym3d = parcelRequire("4Ym3d");

var $1BLoR = parcelRequire("1BLoR");

var $4Dk1w = parcelRequire("4Dk1w");
function $05de5ae3b2b73f3b$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $05de5ae3b2b73f3b$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $05de5ae3b2b73f3b$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $05de5ae3b2b73f3b$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $05de5ae3b2b73f3b$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $05de5ae3b2b73f3b$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $05de5ae3b2b73f3b$var$isElementVisible = (0, $5Dj3P.withProfiling)(function isElementVisible(element) {
    if (!(element instanceof HTMLElement)) return true;
    try {
        var visible = element.checkVisibility({
            // @ts-expect-error
            visibilityProperty: true,
            contentVisibilityAuto: true,
            opacityProperty: true
        });
        return visible;
    } catch (e) {
        // there is no support for checkVisibility
        return true;
    }
}, [
    'vc'
]);
var $05de5ae3b2b73f3b$var$sameRectSize = (0, $5Dj3P.withProfiling)(function sameRectSize(a, b) {
    if (!a || !b) return false;
    return a.width === b.width && a.height === b.height;
}, [
    'vc'
]);
var $05de5ae3b2b73f3b$var$sameRectDimensions = (0, $5Dj3P.withProfiling)(function sameRectDimensions(a, b) {
    if (!a || !b) return false;
    return a.width === b.width && a.height === b.height && a.x === b.x && a.y === b.y;
}, [
    'vc'
]);
var $05de5ae3b2b73f3b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ViewportObserver(_ref) {
        var _this = this;
        var _onChange = _ref.onChange;
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, ViewportObserver);
        var onChange = (0, $5Dj3P.withProfiling)(_onChange, [
            'vc'
        ]);
        var operationTimer = (0, $5Dj3P.markProfilingStart)('ViewportObserver constructor');
        this.mapVisibleNodeRects = new WeakMap();
        this.intersectionObserver = (0, $4Ym3d.createIntersectionObserver)({
            onEntry: function onEntry(_ref2) {
                var target = _ref2.target, rect = _ref2.rect, time = _ref2.time, type = _ref2.type, mutationData = _ref2.mutationData;
                if (!target) return;
                var visible = $05de5ae3b2b73f3b$var$isElementVisible(target);
                var lastElementRect = _this.mapVisibleNodeRects.get(target);
                _this.mapVisibleNodeRects.set(target, rect);
                onChange({
                    time: time,
                    type: type,
                    elementRef: new WeakRef(target),
                    visible: visible,
                    rect: rect,
                    previousRect: lastElementRect,
                    mutationData: mutationData
                });
            }
        });
        this.mutationObserver = (0, $1BLoR.default)({
            onChildListMutation: function onChildListMutation(_ref3) {
                var _removedNodes$map;
                var addedNodes = _ref3.addedNodes, removedNodes = _ref3.removedNodes;
                var removedNodeRects = (_removedNodes$map = removedNodes === null || removedNodes === void 0 ? void 0 : removedNodes.map(function(n) {
                    return _this.mapVisibleNodeRects.get(n);
                })) !== null && _removedNodes$map !== void 0 ? _removedNodes$map : [];
                addedNodes.forEach(function(addedNode) {
                    var _this$intersectionObs3;
                    // for (const elem of addedNode.querySelectorAll('*')) {
                    // 	this.intersectionObserver?.watchAndTag(elem, 'mutation:child-element');
                    // }
                    var sameDeletedNode = removedNodes.find(function(n) {
                        return n.isEqualNode(addedNode);
                    });
                    if (sameDeletedNode) {
                        var _this$intersectionObs;
                        (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.watchAndTag(addedNode, 'mutation:remount');
                        return;
                    }
                    if ((0, $U9jzZ.isContainedWithinMediaWrapper)(addedNode)) {
                        var _this$intersectionObs2;
                        (_this$intersectionObs2 = _this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.watchAndTag(addedNode, 'mutation:media');
                        return;
                    }
                    (_this$intersectionObs3 = _this.intersectionObserver) === null || _this$intersectionObs3 === void 0 || _this$intersectionObs3.watchAndTag(addedNode, function(_ref4) {
                        var rect = _ref4.rect;
                        var wasDeleted = removedNodeRects.some(function(nr) {
                            return $05de5ae3b2b73f3b$var$sameRectDimensions(nr, rect);
                        });
                        if (wasDeleted) return 'mutation:element-replacement';
                        return 'mutation:element';
                    });
                });
            },
            onAttributeMutation: function onAttributeMutation(_ref5) {
                var _this$intersectionObs4;
                var target = _ref5.target, attributeName = _ref5.attributeName;
                (_this$intersectionObs4 = _this.intersectionObserver) === null || _this$intersectionObs4 === void 0 || _this$intersectionObs4.watchAndTag(target, function(_ref6) {
                    var target = _ref6.target, rect = _ref6.rect;
                    if ((0, $U9jzZ.isContainedWithinMediaWrapper)(target)) return {
                        type: 'mutation:media',
                        mutationData: {
                            attributeName: attributeName
                        }
                    };
                    if ((0, $6cg1G.default)({
                        target: target,
                        attributeName: attributeName,
                        type: 'attributes'
                    })) return {
                        type: 'mutation:attribute:non-visual-style',
                        mutationData: {
                            attributeName: attributeName
                        }
                    };
                    var lastElementRect = _this.mapVisibleNodeRects.get(target);
                    if (lastElementRect && $05de5ae3b2b73f3b$var$sameRectSize(rect, lastElementRect)) return {
                        type: 'mutation:attribute:no-layout-shift',
                        mutationData: {
                            attributeName: attributeName
                        }
                    };
                    return {
                        type: 'mutation:attribute',
                        mutationData: {
                            attributeName: attributeName
                        }
                    };
                });
            }
        });
        this.performanceObserver = (0, $4Dk1w.default)({
            onLayoutShift: function onLayoutShift(_ref7) {
                var time = _ref7.time, changedRects = _ref7.changedRects;
                var _iterator = $05de5ae3b2b73f3b$var$_createForOfIteratorHelper(changedRects), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var changedRect = _step.value;
                        var target = changedRect.node;
                        if (target) onChange({
                            time: time,
                            elementRef: new WeakRef(target),
                            visible: true,
                            rect: changedRect.rect,
                            previousRect: changedRect.previousRect,
                            type: 'layout-shift'
                        });
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        });
        this.start = (0, $5Dj3P.withProfiling)(this.start.bind(this), [
            'vc'
        ]);
        this.stop = (0, $5Dj3P.withProfiling)(this.stop.bind(this), [
            'vc'
        ]);
        (0, $5Dj3P.markProfilingEnd)(operationTimer, {
            tags: [
                'vc'
            ]
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(ViewportObserver, [
        {
            key: "start",
            value: function start() {
                var _this$mutationObserve, _this$performanceObse;
                (_this$mutationObserve = this.mutationObserver) === null || _this$mutationObserve === void 0 || _this$mutationObserve.observe(document.body, {
                    attributeOldValue: true,
                    attributes: true,
                    childList: true,
                    subtree: true
                });
                (_this$performanceObse = this.performanceObserver) === null || _this$performanceObse === void 0 || _this$performanceObse.observe({
                    type: 'layout-shift',
                    buffered: true,
                    // @ts-ignore-error
                    durationThreshold: 30
                });
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$mutationObserve2, _this$intersectionObs5, _this$performanceObse2;
                (_this$mutationObserve2 = this.mutationObserver) === null || _this$mutationObserve2 === void 0 || _this$mutationObserve2.disconnect();
                (_this$intersectionObs5 = this.intersectionObserver) === null || _this$intersectionObs5 === void 0 || _this$intersectionObs5.disconnect();
                (_this$performanceObse2 = this.performanceObserver) === null || _this$performanceObse2 === void 0 || _this$performanceObse2.disconnect();
            }
        }
    ]);
}();

});
parcelRegister("4Ym3d", function(module, exports) {

$parcel$export(module.exports, "createIntersectionObserver", function () { return $39edded92be2fe1a$export$c3799d33e0ae80a5; });

var $5Dj3P = parcelRequire("5Dj3P");
var $39edded92be2fe1a$var$isValidEntry = (0, $5Dj3P.withProfiling)(function isValidEntry(entry) {
    return entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0;
}, [
    'vc'
]);
function $39edded92be2fe1a$export$c3799d33e0ae80a5(args) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    var onEntry = (0, $5Dj3P.withProfiling)(args.onEntry, [
        'vc'
    ]);
    var onObserved = typeof args.onObserved === 'function' ? (0, $5Dj3P.withProfiling)(args.onObserved, [
        'vc'
    ]) : undefined;
    var callbacksPerElement = new WeakMap();
    var intersectionObserverCallback = (0, $5Dj3P.withProfiling)(function intersectionObserverCallback(entries) {
        var validEntries = [];
        var startTime = performance.now();
        entries.forEach(function(entry) {
            if (!(entry.target instanceof HTMLElement) || !$39edded92be2fe1a$var$isValidEntry(entry)) return;
            var mutationTag = null;
            var mutationData = null;
            var tagOrCallback = callbacksPerElement.get(entry.target);
            if (typeof tagOrCallback === 'function') {
                var tagOrCallbackResult = tagOrCallback({
                    target: entry.target,
                    rect: entry.intersectionRect
                });
                if (!tagOrCallbackResult) mutationTag = 'unknown';
                else if (typeof tagOrCallbackResult === 'string') mutationTag = tagOrCallbackResult;
                else {
                    mutationTag = tagOrCallbackResult.type;
                    mutationData = tagOrCallbackResult.mutationData;
                }
            } else if (typeof tagOrCallback === 'string') mutationTag = tagOrCallback;
            onEntry({
                target: entry.target,
                rect: entry.intersectionRect,
                time: entry.time,
                type: mutationTag !== null && mutationTag !== void 0 ? mutationTag : 'unknown',
                mutationData: mutationData
            });
            validEntries.push(new WeakRef(entry.target));
            callbacksPerElement.delete(entry.target);
            observer.unobserve(entry.target);
        });
        onObserved === null || onObserved === void 0 || onObserved({
            time: startTime,
            elements: validEntries
        });
    });
    var observer = new IntersectionObserver(intersectionObserverCallback);
    return {
        disconnect: (0, $5Dj3P.withProfiling)(function disconnect() {
            observer.disconnect();
        }, [
            'vc'
        ]),
        unobserve: (0, $5Dj3P.withProfiling)(function unobserve(target) {
            observer.unobserve(target);
        }, [
            'vc'
        ]),
        watchAndTag: (0, $5Dj3P.withProfiling)(function watchAndTag(target, tagOrCallback) {
            callbacksPerElement.set(target, tagOrCallback);
            observer.observe(target);
        }, [
            'vc'
        ])
    };
}

});

parcelRegister("1BLoR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12be03cb082cab4f$export$2e2bcd8739ae039; });

var $f1k1y = parcelRequire("f1k1y");

var $5Dj3P = parcelRequire("5Dj3P");
function $12be03cb082cab4f$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $12be03cb082cab4f$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $12be03cb082cab4f$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $12be03cb082cab4f$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $12be03cb082cab4f$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $12be03cb082cab4f$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $12be03cb082cab4f$var$createMutationObserver = (0, $5Dj3P.withProfiling)(function createMutationObserver(props) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    var onAttributeMutation = (0, $5Dj3P.withProfiling)(props.onAttributeMutation, [
        'vc'
    ]);
    var onChildListMutation = (0, $5Dj3P.withProfiling)(props.onChildListMutation, [
        'vc'
    ]);
    var onMutationFinished = typeof props.onMutationFinished === 'function' ? (0, $5Dj3P.withProfiling)(props.onMutationFinished, [
        'vc'
    ]) : undefined;
    var mutationObserverCallback = (0, $5Dj3P.withProfiling)(function mutationObserverCallback(mutations) {
        var addedNodes = [];
        var removedNodes = [];
        var targets = [];
        var _iterator = $12be03cb082cab4f$var$_createForOfIteratorHelper(mutations), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var mut = _step.value;
                if (!(mut.target instanceof HTMLElement)) continue;
                if (mut.type === 'attributes') {
                    if ((0, $f1k1y.fg)('platform_ufo_vc_ignore_same_value_mutation')) {
                        var _mut$oldValue;
                        /*
            "MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
            I think it might have been something along the lines that for consistency every setAttribute call should create a record.
            Conceptually there is after all a mutation: there is an old value replaced with a new one,
            and whether or not they are the same doesn't really matter.
            And Custom elements should work the same way as MutationObserver."
            https://github.com/whatwg/dom/issues/520#issuecomment-336574796
            */ var oldValue = (_mut$oldValue = mut.oldValue) !== null && _mut$oldValue !== void 0 ? _mut$oldValue : undefined;
                        var newValue = mut.attributeName ? mut.target.getAttribute(mut.attributeName) : undefined;
                        if (oldValue !== newValue) {
                            var _mut$attributeName;
                            onAttributeMutation({
                                target: mut.target,
                                attributeName: (_mut$attributeName = mut.attributeName) !== null && _mut$attributeName !== void 0 ? _mut$attributeName : 'unknown'
                            });
                        }
                    } else {
                        var _mut$attributeName2;
                        onAttributeMutation({
                            target: mut.target,
                            attributeName: (_mut$attributeName2 = mut.attributeName) !== null && _mut$attributeName2 !== void 0 ? _mut$attributeName2 : 'unknown'
                        });
                    }
                    continue;
                } else if (mut.type === 'childList') {
                    var _mut$addedNodes, _mut$removedNodes;
                    ((_mut$addedNodes = mut.addedNodes) !== null && _mut$addedNodes !== void 0 ? _mut$addedNodes : []).forEach(function(node) {
                        if (node instanceof HTMLElement) addedNodes.push(node);
                    });
                    ((_mut$removedNodes = mut.removedNodes) !== null && _mut$removedNodes !== void 0 ? _mut$removedNodes : []).forEach(function(node) {
                        if (node instanceof HTMLElement) removedNodes.push(node);
                    });
                }
                targets.push(mut.target);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        onChildListMutation({
            addedNodes: addedNodes,
            removedNodes: removedNodes
        });
        onMutationFinished === null || onMutationFinished === void 0 || onMutationFinished({
            targets: targets
        });
    });
    var observer = new MutationObserver(mutationObserverCallback);
    return observer;
}, [
    'vc'
]);
var $12be03cb082cab4f$export$2e2bcd8739ae039 = $12be03cb082cab4f$var$createMutationObserver;

});

parcelRegister("4Dk1w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35fa5639e8249ea7$export$2e2bcd8739ae039; });

var $5Dj3P = parcelRequire("5Dj3P");
function $35fa5639e8249ea7$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $35fa5639e8249ea7$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $35fa5639e8249ea7$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $35fa5639e8249ea7$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $35fa5639e8249ea7$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $35fa5639e8249ea7$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $35fa5639e8249ea7$export$5e3f54cad8cb65e2 = (0, $5Dj3P.withProfiling)(function convertPhysicalToLogicalResolution(rect) {
    if (typeof window.devicePixelRatio !== 'number') return rect;
    if (window.devicePixelRatio === 1) return rect;
    // eslint-disable-next-line compat/compat
    return new DOMRect(rect.x / window.devicePixelRatio, rect.y / window.devicePixelRatio, rect.width / window.devicePixelRatio, rect.height / window.devicePixelRatio);
}, [
    'vc'
]);
var $35fa5639e8249ea7$var$createPerformanceObserver = (0, $5Dj3P.withProfiling)(function createPerformanceObserver(args) {
    if (!window || typeof window.PerformanceObserver !== 'function') return null;
    var onLayoutShift = (0, $5Dj3P.withProfiling)(args.onLayoutShift, [
        'vc'
    ]);
    var performanceObserverCallback = (0, $5Dj3P.withProfiling)(function performanceObserverCallback(entries) {
        var _iterator = $35fa5639e8249ea7$var$_createForOfIteratorHelper(entries.getEntries()), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var entry = _step.value;
                if (entry.entryType === 'layout-shift') {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    var changedRects = entry.sources.reduceRight(function(acc, attr) {
                        acc.push({
                            rect: $35fa5639e8249ea7$export$5e3f54cad8cb65e2(attr.currentRect),
                            previousRect: $35fa5639e8249ea7$export$5e3f54cad8cb65e2(attr.previousRect),
                            node: attr.node
                        });
                        return acc;
                    }, []);
                    onLayoutShift({
                        time: entry.startTime,
                        changedRects: changedRects
                    });
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }, [
        'vc'
    ]);
    var observer = new PerformanceObserver(performanceObserverCallback);
    return observer;
}, [
    'vc'
]);
var $35fa5639e8249ea7$export$2e2bcd8739ae039 = $35fa5639e8249ea7$var$createPerformanceObserver;

});


parcelRegister("7JXRi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a2b2b11ba354702$export$2e2bcd8739ae039; });

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $dsN6L = parcelRequire("dsN6L");

var $aA6j8 = parcelRequire("aA6j8");

var $5Dj3P = parcelRequire("5Dj3P");
var $5a2b2b11ba354702$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function WindowEventObserver(opts) {
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, WindowEventObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "unbindFns", []);
        var operationTimer = (0, $5Dj3P.markProfilingStart)('WindowEventObserver constructor');
        this.onEvent = (0, $5Dj3P.withProfiling)(opts.onEvent, [
            'vc'
        ]);
        this.bindEvent = (0, $5Dj3P.withProfiling)(this.bindEvent.bind(this), [
            'vc'
        ]);
        this.start = (0, $5Dj3P.withProfiling)(this.start.bind(this), [
            'vc'
        ]);
        this.stop = (0, $5Dj3P.withProfiling)(this.stop.bind(this), [
            'vc'
        ]);
        (0, $5Dj3P.markProfilingEnd)(operationTimer);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(WindowEventObserver, [
        {
            key: "bindEvent",
            value: function bindEvent(type) {
                var _this = this;
                var unbindCallback = (0, $aA6j8.bind)(window, {
                    type: type,
                    listener: function listener(event) {
                        if (!event.isTrusted) return;
                        _this.onEvent({
                            time: event.timeStamp,
                            type: type,
                            event: event
                        });
                    },
                    options: {
                        passive: true,
                        once: true
                    }
                });
                this.unbindFns.push(unbindCallback);
            }
        },
        {
            key: "start",
            value: function start() {
                this.bindEvent('wheel');
                this.bindEvent('scroll');
                this.bindEvent('keydown');
                this.bindEvent('resize');
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.unbindFns.forEach(function(cb) {
                    cb();
                });
                this.unbindFns = [];
            }
        }
    ]);
}();

});



parcelRegister("82q7C", function(module, exports) {

$parcel$export(module.exports, "interactions", function () { return $5da2c5e0dd1026db$export$cc97b17ef9aeb088; });
var $5da2c5e0dd1026db$export$cc97b17ef9aeb088 = new Map();

});

parcelRegister("ifECG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4992396da280952$export$2e2bcd8739ae039; });

var $2R76C = parcelRequire("2R76C");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $dsN6L = parcelRequire("dsN6L");

var $eWMMH = parcelRequire("eWMMH");

var $h6MYR = parcelRequire("h6MYR");

var $5Dj3P = parcelRequire("5Dj3P");

var $7F3ZZ = parcelRequire("7F3ZZ");
function $d4992396da280952$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d4992396da280952$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d4992396da280952$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d4992396da280952$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d4992396da280952$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
var $d4992396da280952$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PostInteractionLog() {
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, PostInteractionLog);
        /**
     * Basic info about interaction that has just finished
     */ (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "lastInteractionFinish", null);
        /**
     * Array of observed react render timings
     */ (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "reactProfilerTimings", []);
        /**
     * Store the scheduled sink timeout Id so that it can be cancelled when needed
     */ (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "sinkTimeoutId", null);
        /**
     * independent VC observer, that observes until `custom.post-interaction-logs` event is sent
     */ (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "vcObserver", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "vcObserverSSRConfig", null);
        /**
     * Handler function to process / send the observation data
     */ (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "sinkHandlerFn", function() {});
        this.initializeVCObserver = (0, $5Dj3P.withProfiling)(this.initializeVCObserver.bind(this));
        this.startVCObserver = (0, $5Dj3P.withProfiling)(this.startVCObserver.bind(this));
        this.setVCObserverSSRConfig = (0, $5Dj3P.withProfiling)(this.setVCObserverSSRConfig.bind(this));
        this.setLastInteractionFinishVCResult = (0, $5Dj3P.withProfiling)(this.setLastInteractionFinishVCResult.bind(this));
        this.reset = (0, $5Dj3P.withProfiling)(this.reset.bind(this));
        this.hasData = (0, $5Dj3P.withProfiling)(this.hasData.bind(this));
        this.sendPostInteractionLog = (0, $5Dj3P.withProfiling)(this.sendPostInteractionLog.bind(this));
        this.onInteractionComplete = (0, $5Dj3P.withProfiling)(this.onInteractionComplete.bind(this));
        this.addProfilerTimings = (0, $5Dj3P.withProfiling)(this.addProfilerTimings.bind(this));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(PostInteractionLog, [
        {
            key: "initializeVCObserver",
            value: function initializeVCObserver(options) {
                if (this.vcObserver === null) this.vcObserver = new (0, $7F3ZZ.VCObserver)($d4992396da280952$var$_objectSpread($d4992396da280952$var$_objectSpread({}, options), {}, {
                    isPostInteraction: true
                }));
            }
        },
        {
            key: "startVCObserver",
            value: function startVCObserver(_ref) {
                var _this$vcObserver;
                var startTime = _ref.startTime;
                (_this$vcObserver = this.vcObserver) === null || _this$vcObserver === void 0 || _this$vcObserver.start({
                    startTime: startTime
                });
            }
        },
        {
            key: "setVCObserverSSRConfig",
            value: function setVCObserverSSRConfig(vcObserverSSRConfig) {
                this.vcObserverSSRConfig = vcObserverSSRConfig;
            }
        },
        {
            key: "setLastInteractionFinishVCResult",
            value: function setLastInteractionFinishVCResult(result) {
                this.lastInteractionFinishVCResult = result;
            }
        },
        {
            key: "sinkHandler",
            value: /**
     * Set the fn that would be invoked to process / send the observation data
     */ function sinkHandler(sinkHandlerFn) {
                this.sinkHandlerFn = sinkHandlerFn;
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.lastInteractionFinish = null;
                this.reactProfilerTimings = [];
                if (this.sinkTimeoutId != null) {
                    clearTimeout(this.sinkTimeoutId);
                    this.sinkTimeoutId = null;
                }
                this.setVCObserverSSRConfig(null);
            }
        },
        {
            key: "hasData",
            value: function hasData() {
                var _this$reactProfilerTi;
                return ((_this$reactProfilerTi = this.reactProfilerTimings) === null || _this$reactProfilerTi === void 0 ? void 0 : _this$reactProfilerTi.length) > 0;
            }
        },
        {
            key: "sendPostInteractionLog",
            value: function() {
                var _sendPostInteractionLog = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee() {
                    var _this$vcObserver3, _getConfig2;
                    var _getConfig, _this$vcObserver2, postInteractionFinishVCResult, _this$vcObserver4;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!(!this.hasData() || !this.lastInteractionFinish || !this.sinkHandlerFn)) {
                                    _context.next = 4;
                                    break;
                                }
                                this.reset();
                                if ((_getConfig = (0, $h6MYR.getConfig)()) !== null && _getConfig !== void 0 && (_getConfig = _getConfig.experimentalInteractionMetrics) !== null && _getConfig !== void 0 && _getConfig.enabled) (_this$vcObserver2 = this.vcObserver) === null || _this$vcObserver2 === void 0 || _this$vcObserver2.stop();
                                return _context.abrupt("return");
                            case 4:
                                _context.next = 6;
                                return (_this$vcObserver3 = this.vcObserver) === null || _this$vcObserver3 === void 0 ? void 0 : _this$vcObserver3.getVCResult($d4992396da280952$var$_objectSpread({
                                    start: this.lastInteractionFinish.start,
                                    stop: performance.now(),
                                    tti: -1,
                                    // no need for TTI value here
                                    isEventAborted: !!this.lastInteractionFinish.abortReason,
                                    prefix: 'ufo'
                                }, this.vcObserverSSRConfig));
                            case 6:
                                postInteractionFinishVCResult = _context.sent;
                                if ((_getConfig2 = (0, $h6MYR.getConfig)()) !== null && _getConfig2 !== void 0 && (_getConfig2 = _getConfig2.experimentalInteractionMetrics) !== null && _getConfig2 !== void 0 && _getConfig2.enabled) (_this$vcObserver4 = this.vcObserver) === null || _this$vcObserver4 === void 0 || _this$vcObserver4.stop();
                                this.sinkHandlerFn({
                                    lastInteractionFinish: this.lastInteractionFinish,
                                    reactProfilerTimings: this.reactProfilerTimings,
                                    // NOTE: invoking `getVCResult` at latest possible point in time here (not earlier) to get the most accurate result (from performance.now())
                                    postInteractionFinishVCResult: postInteractionFinishVCResult,
                                    lastInteractionFinishVCResult: this.lastInteractionFinishVCResult
                                });
                                this.reset();
                            case 10:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function sendPostInteractionLog() {
                    return _sendPostInteractionLog.apply(this, arguments);
                }
                return sendPostInteractionLog;
            }()
        },
        {
            key: "onInteractionComplete",
            value: function onInteractionComplete(_ref2) {
                var _getConfig3, _this = this;
                var ufoName = _ref2.ufoName, start = _ref2.start, end = _ref2.end, id = _ref2.id, abortReason = _ref2.abortReason, abortedByInteractionName = _ref2.abortedByInteractionName, routeName = _ref2.routeName, type = _ref2.type, experimentalTTAI = _ref2.experimentalTTAI, experimentalVC90 = _ref2.experimentalVC90;
                this.lastInteractionFinish = {
                    ufoName: ufoName,
                    start: start,
                    end: end,
                    id: id,
                    abortReason: abortReason,
                    abortedByInteractionName: abortedByInteractionName,
                    routeName: routeName,
                    type: type,
                    experimentalTTAI: experimentalTTAI,
                    experimentalVC90: experimentalVC90
                };
                var timeout = ((_getConfig3 = (0, $h6MYR.getConfig)()) === null || _getConfig3 === void 0 ? void 0 : _getConfig3.timeWindowForLateMutationsInMilliseconds) || $d4992396da280952$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
                this.sinkTimeoutId = window.setTimeout(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee2() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return _this.sendPostInteractionLog();
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                })), timeout);
            }
        },
        {
            key: "addProfilerTimings",
            value: function addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
                if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
                    type: type,
                    actualDuration: actualDuration,
                    baseDuration: baseDuration,
                    startTime: startTime,
                    commitTime: commitTime,
                    labelStack: labelStack
                });
            }
        }
    ]);
}();

});


parcelRegister("c0VuO", function(module, exports) {

$parcel$export(module.exports, "eventDataProcessor", function () { return $8bf2159e72fccd1a$export$896b6e121bbaec25; });

var $2R76C = parcelRequire("2R76C");

var $iqLBO = parcelRequire("iqLBO");

var $eWMMH = parcelRequire("eWMMH");

var $9semw = parcelRequire("9semw");

var $7SFmd = parcelRequire("7SFmd");

var $4teBn = parcelRequire("4teBn");

var $cD472 = parcelRequire("cD472");

var $a1r0J = parcelRequire("a1r0J");

var $dmiFr = parcelRequire("dmiFr");

var $57Dw2 = parcelRequire("57Dw2");

var $kW3Vj = parcelRequire("kW3Vj");

var $brkRK = parcelRequire("brkRK");

var $88oP5 = parcelRequire("88oP5");

var $9AiFy = parcelRequire("9AiFy");

var $2HeI3 = parcelRequire("2HeI3");

var $emIai = parcelRequire("emIai");

var $eOAA1 = parcelRequire("eOAA1");

var $aqzxD = parcelRequire("aqzxD");

var $61u4L = parcelRequire("61u4L");

var $77QAL = parcelRequire("77QAL");

var $dKjXy = parcelRequire("dKjXy");

var $kMJQF = parcelRequire("kMJQF");

var $6yir5 = parcelRequire("6yir5");

var $gFwM7 = parcelRequire("gFwM7");

var $7Ioqf = parcelRequire("7Ioqf");

var $9szfy = parcelRequire("9szfy");

var $iWI9m = parcelRequire("iWI9m");

var $9x5Qz = parcelRequire("9x5Qz");

var $d3atg = parcelRequire("d3atg");

var $gVYmn = parcelRequire("gVYmn");

var $fkEXK = parcelRequire("fkEXK");

var $2i4fu = parcelRequire("2i4fu");

var $dp8lK = parcelRequire("dp8lK");

var $esOTl = parcelRequire("esOTl");

var $4RmDf = parcelRequire("4RmDf");

var $kEDhW = parcelRequire("kEDhW");

var $d53P7 = parcelRequire("d53P7");

var $a3BbV = parcelRequire("a3BbV");

var $bDlIo = parcelRequire("bDlIo");

var $5JEHx = parcelRequire("5JEHx");
function $8bf2159e72fccd1a$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $8bf2159e72fccd1a$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $8bf2159e72fccd1a$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $8bf2159e72fccd1a$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $8bf2159e72fccd1a$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $8bf2159e72fccd1a$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $8bf2159e72fccd1a$var$defaultSet = [
    (0, $88oP5.eventKey),
    (0, $aqzxD.eventType),
    (0, $2HeI3.eventProduct),
    (0, $eOAA1.eventRoute),
    (0, $kW3Vj.eventId),
    (0, $9AiFy.eventLocalTime),
    (0, $emIai.eventRegion),
    (0, $cD472.appFramework),
    (0, $a1r0J.appVersion),
    (0, $dmiFr.bmVersion),
    (0, $dp8lK.telemetryBrowser),
    (0, $esOTl.telemetryCpu),
    (0, $4RmDf.telemetryMemory),
    (0, $kEDhW.telemetryNetwork),
    (0, $57Dw2.customData),
    (0, $61u4L.featureFlags),
    (0, $77QAL.hostname),
    (0, $gVYmn.productCustomData),
    (0, $d53P7.appTimings),
    (0, $bDlIo.resourceTimings)
];
var $8bf2159e72fccd1a$var$pageLoadCommon = [].concat($8bf2159e72fccd1a$var$defaultSet, [
    (0, $9x5Qz.pageVisibleState),
    (0, $d3atg.pageVisibleValue),
    (0, $brkRK.eventInitial),
    (0, $7Ioqf.pageLoadMetrics),
    (0, $a3BbV.bundleEvalTimings)
]);
var $8bf2159e72fccd1a$var$initialPageLoadSet = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))($8bf2159e72fccd1a$var$pageLoadCommon), [
    (0, $kMJQF.initialPageLoadMetrics),
    (0, $gFwM7.navigationMetrics),
    (0, $2i4fu.ssrSuccess),
    (0, $fkEXK.ssrFeatureFlags)
]);
var $8bf2159e72fccd1a$var$spaTransitionSet = (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))($8bf2159e72fccd1a$var$pageLoadCommon);
var $8bf2159e72fccd1a$var$pageSegmentLoadSet = [].concat($8bf2159e72fccd1a$var$defaultSet, [
    (0, $9szfy.pageSegmentLoadMetrics),
    (0, $9x5Qz.pageVisibleState),
    (0, $d3atg.pageVisibleValue),
    (0, $brkRK.eventInitial),
    (0, $a3BbV.bundleEvalTimings)
]);
var $8bf2159e72fccd1a$var$interactionSet = [].concat($8bf2159e72fccd1a$var$defaultSet, [
    (0, $9x5Qz.pageVisibleState),
    (0, $d3atg.pageVisibleValue),
    (0, $6yir5.interactionMetrics)
]);
var $8bf2159e72fccd1a$var$customMetricSet = [].concat($8bf2159e72fccd1a$var$defaultSet, [
    (0, $9x5Qz.pageVisibleState),
    (0, $d3atg.pageVisibleValue),
    (0, $dKjXy.customEventMetrics)
]);
// pageVisibleState and pageVisibleValue has been handled within webVitalsMetrics.
var $8bf2159e72fccd1a$var$webVitalsMetricSet = [].concat($8bf2159e72fccd1a$var$defaultSet, [
    (0, $iWI9m.webVitalsMetrics)
]);
// Function that returns a promise which resolves after clsWaitTimeMs + 500ms
// so that clsData is guaranteed to be attached to window
var $8bf2159e72fccd1a$var$waitForCLS = function waitForCLS() {
    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $9semw.clsWaitTimeMs) + 500;
    return new Promise(function(resolve) {
        return setTimeout(resolve, delay);
    });
};
var $8bf2159e72fccd1a$export$896b6e121bbaec25 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee(globalConfig, data) {
        var set, plugins, _iterator, _step, plugin, result, pluginResults, generated;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(data.start === null || data.stop === null)) {
                        _context.next = 3;
                        break;
                    }
                    (0, $7SFmd.logger).log("eventDataProcessor: Metric \"".concat(data.key, "\" start or stop are incorrect; start: ").concat(data.start, "; stop: ").concat(data.stop));
                    return _context.abrupt("return", null);
                case 3:
                    set = [];
                    if (data.config.type === (0, $5JEHx.BMEventsType).PAGE_LOAD && (0, $4teBn.isPageLoadMetricData)(data) && data.isInitial) set = $8bf2159e72fccd1a$var$initialPageLoadSet;
                    if (data.config.type === (0, $5JEHx.BMEventsType).PAGE_LOAD && (0, $4teBn.isPageLoadMetricData)(data) && !data.isInitial) set = $8bf2159e72fccd1a$var$spaTransitionSet;
                    if (data.config.type === (0, $5JEHx.BMEventsType).PAGE_SEGMENT_LOAD && (0, $4teBn.isPageSegmentLoadMetricData)(data)) set = $8bf2159e72fccd1a$var$pageSegmentLoadSet;
                    if (data.config.type === (0, $5JEHx.BMEventsType).INLINE_RESULT) set = $8bf2159e72fccd1a$var$interactionSet;
                    if (data.config.type === (0, $5JEHx.BMEventsType).CUSTOM) set = $8bf2159e72fccd1a$var$customMetricSet;
                    if (!(data.config.type === (0, $5JEHx.BMEventsType).WEB_VITALS)) {
                        _context.next = 13;
                        break;
                    }
                    set = $8bf2159e72fccd1a$var$webVitalsMetricSet;
                    // Wait for CLS to be recorded before proceeding to run plugin and attach CLS data
                    _context.next = 13;
                    return $8bf2159e72fccd1a$var$waitForCLS();
                case 13:
                    //TODO if type is different - do not send at all
                    plugins = [];
                    _iterator = $8bf2159e72fccd1a$var$_createForOfIteratorHelper(set);
                    _context.prev = 15;
                    _iterator.s();
                case 17:
                    if ((_step = _iterator.n()).done) {
                        _context.next = 25;
                        break;
                    }
                    plugin = _step.value;
                    _context.next = 21;
                    return plugin(data.config, data, // some plugins support page load specific data with special check
                    globalConfig);
                case 21:
                    result = _context.sent;
                    if (result) plugins.push(result);
                case 23:
                    _context.next = 17;
                    break;
                case 25:
                    _context.next = 30;
                    break;
                case 27:
                    _context.prev = 27;
                    _context.t0 = _context["catch"](15);
                    _iterator.e(_context.t0);
                case 30:
                    _context.prev = 30;
                    _iterator.f();
                    return _context.finish(30);
                case 33:
                    _context.next = 35;
                    return Promise.all(plugins);
                case 35:
                    pluginResults = _context.sent;
                    generated = {};
                    pluginResults.forEach(function(pluginResult) {
                        if (pluginResult === null) return;
                        Object.keys(pluginResult).forEach(function(key) {
                            var keyResult = pluginResult[key];
                            if (keyResult !== null && keyResult !== undefined) generated[key] = keyResult;
                        });
                    });
                    return _context.abrupt("return", generated);
                case 39:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                15,
                27,
                30,
                33
            ]
        ]);
    }));
    return function eventDataProcessor(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

});
parcelRegister("4teBn", function(module, exports) {

$parcel$export(module.exports, "isPageLoadMetricData", function () { return $341532812aedcac1$export$b0e12e7abb0bff11; });
$parcel$export(module.exports, "isPageSegmentLoadMetricData", function () { return $341532812aedcac1$export$83d0099ee6dbb5b0; });
$parcel$export(module.exports, "isPageLoadConfig", function () { return $341532812aedcac1$export$8672fa27ba8bba88; });
$parcel$export(module.exports, "isPageSegmentLoadConfig", function () { return $341532812aedcac1$export$abe063537ef4987b; });
$parcel$export(module.exports, "isInteractionConfig", function () { return $341532812aedcac1$export$ae68674b6a9353be; });
$parcel$export(module.exports, "isCustomConfig", function () { return $341532812aedcac1$export$b493eb8b2ba87421; });

var $5JEHx = parcelRequire("5JEHx");
var $341532812aedcac1$export$b0e12e7abb0bff11 = function isPageLoadMetricData(data) {
    return data.type === (0, $5JEHx.BMEventsType).PAGE_LOAD;
};
var $341532812aedcac1$export$83d0099ee6dbb5b0 = function isPageSegmentLoadMetricData(data) {
    return data.type === (0, $5JEHx.BMEventsType).PAGE_SEGMENT_LOAD;
};
var $341532812aedcac1$export$8672fa27ba8bba88 = function isPageLoadConfig(data) {
    return data.type === (0, $5JEHx.BMEventsType).PAGE_LOAD;
};
var $341532812aedcac1$export$abe063537ef4987b = function isPageSegmentLoadConfig(data) {
    return data.type === (0, $5JEHx.BMEventsType).PAGE_SEGMENT_LOAD;
};
var $341532812aedcac1$export$ae68674b6a9353be = function isInteractionConfig(data) {
    return data.type === (0, $5JEHx.BMEventsType).INLINE_RESULT;
};
var $341532812aedcac1$export$b493eb8b2ba87421 = function isCustomConfig(data) {
    return data.type === (0, $5JEHx.BMEventsType).CUSTOM;
};

});

parcelRegister("cD472", function(module, exports) {

$parcel$export(module.exports, "appFramework", function () { return $931c5132a53b1739$export$e34e4529b979f74c; });
var $931c5132a53b1739$export$e34e4529b979f74c = function appFramework(_config, _data, globalConfig) {
    if (!globalConfig.app.framework) return null;
    return {
        'app:framework:name': globalConfig.app.framework.name,
        'app:framework:version': globalConfig.app.framework.version
    };
};

});

parcelRegister("a1r0J", function(module, exports) {

$parcel$export(module.exports, "appVersion", function () { return $74bef3252432c20b$export$82ae485178b37419; });
var $74bef3252432c20b$export$82ae485178b37419 = function appVersion(_config, _data, globalConfig) {
    var pluginData = {
        'app:web:version': globalConfig.app.version.web
    };
    if (globalConfig.app.version.ssr) pluginData['app:ssr:version'] = globalConfig.app.version.ssr;
    return pluginData;
};

});

parcelRegister("dmiFr", function(module, exports) {

$parcel$export(module.exports, "bmVersion", function () { return $9b9bcf6160809c35$export$5cafa465fc876895; });
var $9b9bcf6160809c35$export$5cafa465fc876895 = function bmVersion() {
    return {
        'bm:version': 3
    };
};

});

parcelRegister("57Dw2", function(module, exports) {

$parcel$export(module.exports, "customData", function () { return $3bac422fe56e7a90$export$f7e743c7db162193; });

var $5YM7L = parcelRequire("5YM7L");
var $3bac422fe56e7a90$export$f7e743c7db162193 = function customData(_config, data) {
    var custom = {};
    var changed = false;
    if (data.custom) Object.entries(data.custom).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        changed = true;
        custom["custom:".concat(key)] = value;
    });
    return changed ? custom : null;
};

});

parcelRegister("kW3Vj", function(module, exports) {

$parcel$export(module.exports, "eventId", function () { return $f3dc4482bc91640a$export$aed28df7ac07d79a; });
var $f3dc4482bc91640a$export$aed28df7ac07d79a = function eventId(config) {
    return {
        'event:id': config.key
    };
};

});

parcelRegister("brkRK", function(module, exports) {

$parcel$export(module.exports, "eventInitial", function () { return $854266dbb54cf8a7$export$fa8e91d436b3ef8b; });

var $4teBn = parcelRequire("4teBn");
var $854266dbb54cf8a7$export$fa8e91d436b3ef8b = function eventInitial(_config, data) {
    if (!(0, $4teBn.isPageLoadMetricData)(data) && !(0, $4teBn.isPageSegmentLoadMetricData)(data)) return null;
    return {
        'event:initial': data.isInitial
    };
};

});

parcelRegister("88oP5", function(module, exports) {

$parcel$export(module.exports, "eventKey", function () { return $5ec253684efcb1dd$export$10be2d3a558d3f88; });

var $6xJQ4 = parcelRequire("6xJQ4");
var $5ec253684efcb1dd$export$10be2d3a558d3f88 = function eventKey(config, _data, globalConfig) {
    return {
        'event:key': "".concat(globalConfig.product, ".fe.").concat((0, $6xJQ4.mapEventType)(config.type), ".").concat(config.key)
    };
};

});
parcelRegister("6xJQ4", function(module, exports) {

$parcel$export(module.exports, "mapEventType", function () { return $4c3961ca4151e67d$export$b334d07f11140768; });

var $5JEHx = parcelRequire("5JEHx");
var $4c3961ca4151e67d$export$b334d07f11140768 = function mapEventType(type) {
    switch(type){
        case (0, $5JEHx.BMEventsType).CUSTOM:
            return (0, $5JEHx.StorableBMEventsType).CUSTOM;
        case (0, $5JEHx.BMEventsType).INLINE_RESULT:
            return (0, $5JEHx.StorableBMEventsType).INLINE_RESULT;
        case (0, $5JEHx.BMEventsType).PAGE_LOAD:
            return (0, $5JEHx.StorableBMEventsType).PAGE_LOAD;
        case (0, $5JEHx.BMEventsType).PAGE_SEGMENT_LOAD:
            return (0, $5JEHx.StorableBMEventsType).PAGE_SEGMENT_LOAD;
        case (0, $5JEHx.BMEventsType).WEB_VITALS:
            return (0, $5JEHx.StorableBMEventsType).WEB_VITALS;
        default:
            return 'unknown';
    }
};

});


parcelRegister("9AiFy", function(module, exports) {

$parcel$export(module.exports, "eventLocalTime", function () { return $6fa5f5275ca0e02f$export$5219854ae7ec45da; });

var $e6fYJ = parcelRequire("e6fYJ");
var $6fa5f5275ca0e02f$export$5219854ae7ec45da = function eventLocalTime() {
    return {
        'event:localHour': parseInt((0, $e6fYJ.default)(new Date(), 'H'), 10),
        'event:localDayOfWeek': parseInt((0, $e6fYJ.default)(new Date(), 'i'), 10)
    };
};

});
parcelRegister("e6fYJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a43e05403ffe1437$export$2e2bcd8739ae039; });

var $3dTMP = parcelRequire("3dTMP");

var $gie3w = parcelRequire("gie3w");

var $lTwVa = parcelRequire("lTwVa");

var $cY5UF = parcelRequire("cY5UF");

var $6wIdB = parcelRequire("6wIdB");

var $9P7SM = parcelRequire("9P7SM");

var $duCyr = parcelRequire("duCyr");

var $5l2Ur = parcelRequire("5l2Ur");

var $gLg3c = parcelRequire("gLg3c");

var $2z8Q4 = parcelRequire("2z8Q4");

var $f2aWc = parcelRequire("f2aWc");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $a43e05403ffe1437$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $a43e05403ffe1437$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $a43e05403ffe1437$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $a43e05403ffe1437$var$doubleQuoteRegExp = /''/g;
var $a43e05403ffe1437$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $a43e05403ffe1437$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $gLg3c.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $2z8Q4.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $f2aWc.default);
    var firstWeekContainsDate = (0, $5l2Ur.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $5l2Ur.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $lTwVa.default)(dirtyDate);
    if (!(0, $3dTMP.default)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $9P7SM.default)(originalDate);
    var utcDate = (0, $gie3w.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($a43e05403ffe1437$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $6wIdB.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($a43e05403ffe1437$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $a43e05403ffe1437$var$cleanEscapedString(substring);
        var formatter = (0, $cY5UF.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $duCyr.isProtectedWeekYearToken)(substring)) (0, $duCyr.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $duCyr.isProtectedDayOfYearToken)(substring)) (0, $duCyr.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($a43e05403ffe1437$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $a43e05403ffe1437$var$cleanEscapedString(input) {
    var matched = input.match($a43e05403ffe1437$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($a43e05403ffe1437$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("3dTMP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $258ddc114527664b$export$2e2bcd8739ae039; });

var $4B0Lw = parcelRequire("4B0Lw");

var $lTwVa = parcelRequire("lTwVa");

var $gLg3c = parcelRequire("gLg3c");
function $258ddc114527664b$export$2e2bcd8739ae039(dirtyDate) {
    (0, $gLg3c.default)(1, arguments);
    if (!(0, $4B0Lw.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $lTwVa.default)(dirtyDate);
    return !isNaN(Number(date));
}

});
parcelRegister("4B0Lw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $358b3622917d6967$export$2e2bcd8739ae039; });

var $4y9O5 = parcelRequire("4y9O5");

var $gLg3c = parcelRequire("gLg3c");
function $358b3622917d6967$export$2e2bcd8739ae039(value) {
    (0, $gLg3c.default)(1, arguments);
    return value instanceof Date || (0, $4y9O5.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

});


parcelRegister("gie3w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bdc93af4669380ec$export$2e2bcd8739ae039; });

var $6XFIj = parcelRequire("6XFIj");

var $gLg3c = parcelRequire("gLg3c");

var $5l2Ur = parcelRequire("5l2Ur");
function $bdc93af4669380ec$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $gLg3c.default)(2, arguments);
    var amount = (0, $5l2Ur.default)(dirtyAmount);
    return (0, $6XFIj.default)(dirtyDate, -amount);
}

});
parcelRegister("6XFIj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51189c3c65044df8$export$2e2bcd8739ae039; });

var $5l2Ur = parcelRequire("5l2Ur");

var $lTwVa = parcelRequire("lTwVa");

var $gLg3c = parcelRequire("gLg3c");
function $51189c3c65044df8$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $gLg3c.default)(2, arguments);
    var timestamp = (0, $lTwVa.default)(dirtyDate).getTime();
    var amount = (0, $5l2Ur.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});
parcelRegister("5l2Ur", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e312ba59d7b310f$export$2e2bcd8739ae039; });
function $3e312ba59d7b310f$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});



parcelRegister("cY5UF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $970facd2b0828429$export$2e2bcd8739ae039; });

var $3uwXk = parcelRequire("3uwXk");

var $7773H = parcelRequire("7773H");

var $7LyfO = parcelRequire("7LyfO");

var $iexvb = parcelRequire("iexvb");

var $72PpT = parcelRequire("72PpT");

var $4Jola = parcelRequire("4Jola");

var $2zXms = parcelRequire("2zXms");
var $970facd2b0828429$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $970facd2b0828429$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $2zXms.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $72PpT.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $4Jola.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $4Jola.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $7LyfO.default)(date);
        // Padding
        return (0, $4Jola.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $4Jola.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $4Jola.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $4Jola.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $2zXms.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $4Jola.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $iexvb.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $4Jola.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $7773H.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $4Jola.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $2zXms.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $3uwXk.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $4Jola.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $4Jola.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $4Jola.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $4Jola.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $970facd2b0828429$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $970facd2b0828429$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $970facd2b0828429$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $970facd2b0828429$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $970facd2b0828429$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $970facd2b0828429$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $2zXms.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $2zXms.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $4Jola.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $4Jola.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $2zXms.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $2zXms.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $2zXms.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $970facd2b0828429$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $970facd2b0828429$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $970facd2b0828429$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $970facd2b0828429$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $970facd2b0828429$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $970facd2b0828429$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $970facd2b0828429$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $970facd2b0828429$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $970facd2b0828429$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $970facd2b0828429$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $4Jola.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $4Jola.default)(timestamp, token.length);
    }
};
function $970facd2b0828429$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $4Jola.default)(minutes, 2);
}
function $970facd2b0828429$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $4Jola.default)(Math.abs(offset) / 60, 2);
    }
    return $970facd2b0828429$var$formatTimezone(offset, dirtyDelimiter);
}
function $970facd2b0828429$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $4Jola.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $4Jola.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $970facd2b0828429$export$2e2bcd8739ae039 = $970facd2b0828429$var$formatters;

});
parcelRegister("3uwXk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28adbccbe34d5960$export$2e2bcd8739ae039; });

var $lTwVa = parcelRequire("lTwVa");

var $gLg3c = parcelRequire("gLg3c");
var $28adbccbe34d5960$var$MILLISECONDS_IN_DAY = 86400000;
function $28adbccbe34d5960$export$2e2bcd8739ae039(dirtyDate) {
    (0, $gLg3c.default)(1, arguments);
    var date = (0, $lTwVa.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $28adbccbe34d5960$var$MILLISECONDS_IN_DAY) + 1;
}

});

parcelRegister("7773H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52dea98d192ac7df$export$2e2bcd8739ae039; });

var $lTwVa = parcelRequire("lTwVa");

var $1vVdo = parcelRequire("1vVdo");

var $mCOvu = parcelRequire("mCOvu");

var $gLg3c = parcelRequire("gLg3c");
var $52dea98d192ac7df$var$MILLISECONDS_IN_WEEK = 604800000;
function $52dea98d192ac7df$export$2e2bcd8739ae039(dirtyDate) {
    (0, $gLg3c.default)(1, arguments);
    var date = (0, $lTwVa.default)(dirtyDate);
    var diff = (0, $1vVdo.default)(date).getTime() - (0, $mCOvu.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $52dea98d192ac7df$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("1vVdo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11a5116335d2f8f1$export$2e2bcd8739ae039; });

var $lTwVa = parcelRequire("lTwVa");

var $gLg3c = parcelRequire("gLg3c");
function $11a5116335d2f8f1$export$2e2bcd8739ae039(dirtyDate) {
    (0, $gLg3c.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $lTwVa.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("mCOvu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $044029c448d2114f$export$2e2bcd8739ae039; });

var $7LyfO = parcelRequire("7LyfO");

var $1vVdo = parcelRequire("1vVdo");

var $gLg3c = parcelRequire("gLg3c");
function $044029c448d2114f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $gLg3c.default)(1, arguments);
    var year = (0, $7LyfO.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $1vVdo.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("7LyfO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a777e56576ee18e$export$2e2bcd8739ae039; });

var $lTwVa = parcelRequire("lTwVa");

var $gLg3c = parcelRequire("gLg3c");

var $1vVdo = parcelRequire("1vVdo");
function $5a777e56576ee18e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $gLg3c.default)(1, arguments);
    var date = (0, $lTwVa.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $1vVdo.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $1vVdo.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("iexvb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4638596d80aea27$export$2e2bcd8739ae039; });

var $lTwVa = parcelRequire("lTwVa");

var $7TQi3 = parcelRequire("7TQi3");

var $dd1w5 = parcelRequire("dd1w5");

var $gLg3c = parcelRequire("gLg3c");
var $d4638596d80aea27$var$MILLISECONDS_IN_WEEK = 604800000;
function $d4638596d80aea27$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $gLg3c.default)(1, arguments);
    var date = (0, $lTwVa.default)(dirtyDate);
    var diff = (0, $7TQi3.default)(date, options).getTime() - (0, $dd1w5.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $d4638596d80aea27$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("7TQi3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c063b2ec2dd6cf8$export$2e2bcd8739ae039; });

var $lTwVa = parcelRequire("lTwVa");

var $gLg3c = parcelRequire("gLg3c");

var $5l2Ur = parcelRequire("5l2Ur");

var $2z8Q4 = parcelRequire("2z8Q4");
function $5c063b2ec2dd6cf8$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $gLg3c.default)(1, arguments);
    var defaultOptions = (0, $2z8Q4.getDefaultOptions)();
    var weekStartsOn = (0, $5l2Ur.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $lTwVa.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});
parcelRegister("2z8Q4", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $1de5b4e13b6b04c9$export$430a3269e24b912e; });
var $1de5b4e13b6b04c9$var$defaultOptions = {};
function $1de5b4e13b6b04c9$export$430a3269e24b912e() {
    return $1de5b4e13b6b04c9$var$defaultOptions;
}
function $1de5b4e13b6b04c9$export$95365be1b0704abc(newOptions) {
    $1de5b4e13b6b04c9$var$defaultOptions = newOptions;
}

});


parcelRegister("dd1w5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99ddaa639a113ea8$export$2e2bcd8739ae039; });

var $72PpT = parcelRequire("72PpT");

var $gLg3c = parcelRequire("gLg3c");

var $7TQi3 = parcelRequire("7TQi3");

var $5l2Ur = parcelRequire("5l2Ur");

var $2z8Q4 = parcelRequire("2z8Q4");
function $99ddaa639a113ea8$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $gLg3c.default)(1, arguments);
    var defaultOptions = (0, $2z8Q4.getDefaultOptions)();
    var firstWeekContainsDate = (0, $5l2Ur.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $72PpT.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $7TQi3.default)(firstWeek, options);
    return date;
}

});
parcelRegister("72PpT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52109a987e416595$export$2e2bcd8739ae039; });

var $lTwVa = parcelRequire("lTwVa");

var $gLg3c = parcelRequire("gLg3c");

var $7TQi3 = parcelRequire("7TQi3");

var $5l2Ur = parcelRequire("5l2Ur");

var $2z8Q4 = parcelRequire("2z8Q4");
function $52109a987e416595$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $gLg3c.default)(1, arguments);
    var date = (0, $lTwVa.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $2z8Q4.getDefaultOptions)();
    var firstWeekContainsDate = (0, $5l2Ur.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $7TQi3.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $7TQi3.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("4Jola", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $371e3ee8fb37b09f$export$2e2bcd8739ae039; });
function $371e3ee8fb37b09f$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}

});

parcelRegister("2zXms", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e0ce58cfd38498d$export$2e2bcd8739ae039; });

var $4Jola = parcelRequire("4Jola");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $1e0ce58cfd38498d$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $4Jola.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $4Jola.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $4Jola.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $4Jola.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $4Jola.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $4Jola.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $4Jola.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $4Jola.default)(fractionalSeconds, token.length);
    }
};
var $1e0ce58cfd38498d$export$2e2bcd8739ae039 = $1e0ce58cfd38498d$var$formatters;

});


parcelRegister("6wIdB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c08081aa9b2eedf$export$2e2bcd8739ae039; });
var $4c08081aa9b2eedf$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $4c08081aa9b2eedf$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $4c08081aa9b2eedf$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $4c08081aa9b2eedf$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $4c08081aa9b2eedf$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $4c08081aa9b2eedf$var$timeLongFormatter(timePattern, formatLong));
};
var $4c08081aa9b2eedf$var$longFormatters = {
    p: $4c08081aa9b2eedf$var$timeLongFormatter,
    P: $4c08081aa9b2eedf$var$dateTimeLongFormatter
};
var $4c08081aa9b2eedf$export$2e2bcd8739ae039 = $4c08081aa9b2eedf$var$longFormatters;

});

parcelRegister("duCyr", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", function () { return $9d2bfbd3907236bd$export$c6cc36aa33304772; });
$parcel$export(module.exports, "isProtectedWeekYearToken", function () { return $9d2bfbd3907236bd$export$c6b49d6dceb604a1; });
$parcel$export(module.exports, "throwProtectedError", function () { return $9d2bfbd3907236bd$export$8073c1ae88f0e727; });
var $9d2bfbd3907236bd$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $9d2bfbd3907236bd$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $9d2bfbd3907236bd$export$c6cc36aa33304772(token) {
    return $9d2bfbd3907236bd$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $9d2bfbd3907236bd$export$c6b49d6dceb604a1(token) {
    return $9d2bfbd3907236bd$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $9d2bfbd3907236bd$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

});

parcelRegister("f2aWc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af1f86e83888d9f6$export$2e2bcd8739ae039; });

var $OpWxF = parcelRequire("OpWxF");
var $af1f86e83888d9f6$export$2e2bcd8739ae039 = (0, $OpWxF.default);

});
parcelRegister("OpWxF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0978cb693d331833$export$2e2bcd8739ae039; });

var $5Ej0u = parcelRequire("5Ej0u");

var $lMBAz = parcelRequire("lMBAz");

var $IV7tR = parcelRequire("IV7tR");

var $cmHk2 = parcelRequire("cmHk2");

var $dtdUG = parcelRequire("dtdUG");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $0978cb693d331833$var$locale = {
    code: 'en-US',
    formatDistance: (0, $5Ej0u.default),
    formatLong: (0, $lMBAz.default),
    formatRelative: (0, $IV7tR.default),
    localize: (0, $cmHk2.default),
    match: (0, $dtdUG.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $0978cb693d331833$export$2e2bcd8739ae039 = $0978cb693d331833$var$locale;

});
parcelRegister("5Ej0u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41cf6e92b2693bb1$export$2e2bcd8739ae039; });
var $41cf6e92b2693bb1$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $41cf6e92b2693bb1$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $41cf6e92b2693bb1$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $41cf6e92b2693bb1$export$2e2bcd8739ae039 = $41cf6e92b2693bb1$var$formatDistance;

});

parcelRegister("lMBAz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdbb3d05a8fb1a79$export$2e2bcd8739ae039; });

var $bRdou = parcelRequire("bRdou");
var $fdbb3d05a8fb1a79$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $fdbb3d05a8fb1a79$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $fdbb3d05a8fb1a79$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $fdbb3d05a8fb1a79$var$formatLong = {
    date: (0, $bRdou.default)({
        formats: $fdbb3d05a8fb1a79$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $bRdou.default)({
        formats: $fdbb3d05a8fb1a79$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $bRdou.default)({
        formats: $fdbb3d05a8fb1a79$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $fdbb3d05a8fb1a79$export$2e2bcd8739ae039 = $fdbb3d05a8fb1a79$var$formatLong;

});
parcelRegister("bRdou", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a1f08b47f2746d8$export$2e2bcd8739ae039; });
function $8a1f08b47f2746d8$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("IV7tR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08706af310e24e53$export$2e2bcd8739ae039; });
var $08706af310e24e53$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $08706af310e24e53$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $08706af310e24e53$var$formatRelativeLocale[token];
};
var $08706af310e24e53$export$2e2bcd8739ae039 = $08706af310e24e53$var$formatRelative;

});

parcelRegister("cmHk2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90092502311abc01$export$2e2bcd8739ae039; });

var $6GQzM = parcelRequire("6GQzM");
var $90092502311abc01$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $90092502311abc01$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $90092502311abc01$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $90092502311abc01$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $90092502311abc01$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $90092502311abc01$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $90092502311abc01$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $90092502311abc01$var$localize = {
    ordinalNumber: $90092502311abc01$var$ordinalNumber,
    era: (0, $6GQzM.default)({
        values: $90092502311abc01$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $6GQzM.default)({
        values: $90092502311abc01$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $6GQzM.default)({
        values: $90092502311abc01$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $6GQzM.default)({
        values: $90092502311abc01$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $6GQzM.default)({
        values: $90092502311abc01$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $90092502311abc01$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $90092502311abc01$export$2e2bcd8739ae039 = $90092502311abc01$var$localize;

});
parcelRegister("6GQzM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4def72dbffaa10c3$export$2e2bcd8739ae039; });
function $4def72dbffaa10c3$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("dtdUG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ce8c6b22cae3b4d$export$2e2bcd8739ae039; });

var $gu5pt = parcelRequire("gu5pt");

var $4mtOM = parcelRequire("4mtOM");
var $9ce8c6b22cae3b4d$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $9ce8c6b22cae3b4d$var$parseOrdinalNumberPattern = /\d+/i;
var $9ce8c6b22cae3b4d$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $9ce8c6b22cae3b4d$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $9ce8c6b22cae3b4d$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $9ce8c6b22cae3b4d$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $9ce8c6b22cae3b4d$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $9ce8c6b22cae3b4d$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $9ce8c6b22cae3b4d$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $9ce8c6b22cae3b4d$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $9ce8c6b22cae3b4d$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $9ce8c6b22cae3b4d$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $9ce8c6b22cae3b4d$var$match = {
    ordinalNumber: (0, $4mtOM.default)({
        matchPattern: $9ce8c6b22cae3b4d$var$matchOrdinalNumberPattern,
        parsePattern: $9ce8c6b22cae3b4d$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gu5pt.default)({
        matchPatterns: $9ce8c6b22cae3b4d$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9ce8c6b22cae3b4d$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $gu5pt.default)({
        matchPatterns: $9ce8c6b22cae3b4d$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9ce8c6b22cae3b4d$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gu5pt.default)({
        matchPatterns: $9ce8c6b22cae3b4d$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9ce8c6b22cae3b4d$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $gu5pt.default)({
        matchPatterns: $9ce8c6b22cae3b4d$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9ce8c6b22cae3b4d$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $gu5pt.default)({
        matchPatterns: $9ce8c6b22cae3b4d$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $9ce8c6b22cae3b4d$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $9ce8c6b22cae3b4d$export$2e2bcd8739ae039 = $9ce8c6b22cae3b4d$var$match;

});
parcelRegister("gu5pt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c003a4f28d490a6b$export$2e2bcd8739ae039; });
function $c003a4f28d490a6b$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $c003a4f28d490a6b$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $c003a4f28d490a6b$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $c003a4f28d490a6b$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $c003a4f28d490a6b$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("4mtOM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32d058bb12fcb9b2$export$2e2bcd8739ae039; });
function $32d058bb12fcb9b2$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});






parcelRegister("2HeI3", function(module, exports) {

$parcel$export(module.exports, "eventProduct", function () { return $1f6b01ed8f03d993$export$a7df4e8088db8843; });
var $1f6b01ed8f03d993$export$a7df4e8088db8843 = function eventProduct(_config, _data, globalConfig) {
    return {
        'event:product': "".concat(globalConfig.product)
    };
};

});

parcelRegister("emIai", function(module, exports) {

$parcel$export(module.exports, "eventRegion", function () { return $02b2eceb630a72b3$export$d0117b71adcdebc0; });
var $02b2eceb630a72b3$export$d0117b71adcdebc0 = function eventRegion(_config, _data, globalConfig) {
    return {
        'event:region': "".concat(globalConfig.region)
    };
};

});

parcelRegister("eOAA1", function(module, exports) {

$parcel$export(module.exports, "eventRoute", function () { return $ac921c3e44c366d2$export$44d3627af289ca16; });
var $ac921c3e44c366d2$export$44d3627af289ca16 = function eventRoute(_config, data) {
    if (!data.route) return null;
    return {
        'event:route': data.route
    };
};

});

parcelRegister("aqzxD", function(module, exports) {

$parcel$export(module.exports, "eventType", function () { return $7977e6e8710973b9$export$4c045e605d532c98; });

var $6xJQ4 = parcelRequire("6xJQ4");
var $7977e6e8710973b9$export$4c045e605d532c98 = function eventType(config) {
    return {
        'event:type': (0, $6xJQ4.mapEventType)(config.type)
    };
};

});

parcelRegister("61u4L", function(module, exports) {

$parcel$export(module.exports, "featureFlags", function () { return $462a2a881e738809$export$e62953d023125748; });

var $dsN6L = parcelRequire("dsN6L");
function $462a2a881e738809$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $462a2a881e738809$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $462a2a881e738809$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $462a2a881e738809$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $462a2a881e738809$export$e62953d023125748 = function featureFlags(config, _data, globalConfig) {
    var _config$featureFlags;
    var localFeatureFlags = ((_config$featureFlags = config.featureFlags) === null || _config$featureFlags === void 0 ? void 0 : _config$featureFlags.reduce(function(acc, ffName) {
        acc[ffName] = globalConfig.ffClient.getValue(ffName);
        return acc;
    }, {})) || null;
    if ((!globalConfig.featureFlags || Object.keys(globalConfig.featureFlags).length === 0) && (!localFeatureFlags || Object.keys(localFeatureFlags).length === 0)) return null;
    return {
        featureFlags: $462a2a881e738809$var$_objectSpread($462a2a881e738809$var$_objectSpread({}, localFeatureFlags), globalConfig.featureFlags)
    };
};

});

parcelRegister("77QAL", function(module, exports) {

$parcel$export(module.exports, "hostname", function () { return $5301fb88cf65cd0a$export$640106f6dc7d2706; });
var $5301fb88cf65cd0a$export$640106f6dc7d2706 = function hostname(_config, _data, globalConfig) {
    return {
        hostname: globalConfig.hostname
    };
};

});

parcelRegister("dKjXy", function(module, exports) {

$parcel$export(module.exports, "customEventMetrics", function () { return $a01f0dc6966f86bc$export$cab039265c52a2e9; });

var $4teBn = parcelRequire("4teBn");
var $a01f0dc6966f86bc$export$cab039265c52a2e9 = function customEventMetrics(config, data, globalConfig) {
    var _config$slo, _config$histogram;
    if (!(0, $4teBn.isCustomConfig)(config)) return null;
    var payload = {
        'metric:duration': Math.round(data.stop - data.start)
    };
    if (((_config$slo = config.slo) === null || _config$slo === void 0 ? void 0 : _config$slo.threshold) !== undefined) {
        var _config$slo2, _config$slo3;
        payload['metric:duration:slo'] = payload['metric:duration'] <= ((_config$slo2 = config.slo) === null || _config$slo2 === void 0 ? void 0 : _config$slo2.threshold);
        payload['metric:duration:slo:threshold'] = (_config$slo3 = config.slo) === null || _config$slo3 === void 0 ? void 0 : _config$slo3.threshold;
    }
    if ((_config$histogram = config.histogram) !== null && _config$histogram !== void 0 && _config$histogram.duration) payload['metric:duration:histogramBuckets'] = config.histogram.duration;
    else if (globalConfig.histogram) payload['metric:duration:histogramBuckets'] = globalConfig.histogram.duration;
    return payload;
};

});

parcelRegister("kMJQF", function(module, exports) {

$parcel$export(module.exports, "initialPageLoadMetrics", function () { return $f21bdae51621d091$export$cc95aa3f6ea8e5cb; });
var $f21bdae51621d091$export$cc95aa3f6ea8e5cb = function initialPageLoadMetrics() {
    var metrics = {};
    performance.getEntriesByType('paint').forEach(function(entry) {
        if (entry.name === 'first-paint') metrics['metric:fp'] = Math.round(entry.startTime);
        if (entry.name === 'first-contentful-paint') metrics['metric:fcp'] = Math.round(entry.startTime);
    });
    return metrics;
};

});

parcelRegister("6yir5", function(module, exports) {

$parcel$export(module.exports, "interactionMetrics", function () { return $4c54380e7d914f21$export$86db56030b57ba34; });

var $4teBn = parcelRequire("4teBn");

var $5JEHx = parcelRequire("5JEHx");
var $4c54380e7d914f21$export$86db56030b57ba34 = function interactionMetrics(config, data, globalConfig) {
    var _config$histogram;
    if (!(0, $4teBn.isInteractionConfig)(config)) return null;
    var result = {
        'metric:result': Math.round(data.stop - data.start)
    };
    if ((_config$histogram = config.histogram) !== null && _config$histogram !== void 0 && _config$histogram.result) result['metric:result:histogramBuckets'] = config.histogram.result;
    else if (globalConfig.histogram) {
        var histogram = globalConfig.histogram;
        if (histogram.result !== undefined) result['metric:result:histogramBuckets'] = histogram[(0, $5JEHx.BMInteractionMetrics).result];
    }
    if (config.slo && (0, $5JEHx.isInteractionMetricsSlo)(config.slo) && config.slo.result) {
        result['metric:result:slo'] = result['metric:result'] <= config.slo.result.threshold;
        result['metric:result:slo:threshold'] = config.slo.result.threshold;
    }
    if (data.marks['feedback']) {
        var _config$histogram2;
        result['metric:response'] = Math.round((data.marks['feedback'] || data.stop) - data.start);
        if ((_config$histogram2 = config.histogram) !== null && _config$histogram2 !== void 0 && _config$histogram2.response) result['metric:response:histogramBuckets'] = config.histogram[(0, $5JEHx.BMInteractionMetrics).response];
        else if (globalConfig.histogram) {
            var _histogram = globalConfig.histogram;
            if (_histogram.result !== undefined) result['metric:response:histogramBuckets'] = _histogram[(0, $5JEHx.BMInteractionMetrics).response];
        }
        if (config.slo && (0, $5JEHx.isInteractionMetricsSlo)(config.slo) && config.slo.response) {
            result['metric:response:slo'] = result['metric:response'] <= config.slo.response.threshold;
            result['metric:response:slo:threshold'] = config.slo.response.threshold;
        }
    }
    return result;
};

});

parcelRegister("gFwM7", function(module, exports) {

$parcel$export(module.exports, "navigationMetrics", function () { return $c229e626a1aedca6$export$b88d990436be0f8a; });
var $c229e626a1aedca6$export$b88d990436be0f8a = function navigationMetrics() {
    var entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    var navigation = entries[0];
    var metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};

});

parcelRegister("7Ioqf", function(module, exports) {

$parcel$export(module.exports, "pageLoadMetrics", function () { return $59df963ead1bd6f2$export$2878bf482e539059; });

var $4teBn = parcelRequire("4teBn");

var $5JEHx = parcelRequire("5JEHx");
var $59df963ead1bd6f2$var$getThreshold = function getThreshold(isInitial, metric) {
    return (0, $5JEHx.isDetailedPageLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
var $59df963ead1bd6f2$var$getHistogram = function getHistogram(isInitial, metric, histogram) {
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
var $59df963ead1bd6f2$export$2878bf482e539059 = function pageLoadMetrics(config, data, globalConfig) {
    if (!(0, $4teBn.isPageLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page load data for non-page-load config');
    var fmp = data.marks[(0, $5JEHx.BMPageLoadMetrics).fmp] || data.stop;
    var result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $59df963ead1bd6f2$var$getHistogram(data.isInitial, (0, $5JEHx.BMPageLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $59df963ead1bd6f2$var$getHistogram(data.isInitial, (0, $5JEHx.BMPageLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        var histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $59df963ead1bd6f2$var$getHistogram(data.isInitial, (0, $5JEHx.BMPageLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $59df963ead1bd6f2$var$getHistogram(data.isInitial, (0, $5JEHx.BMPageLoadMetrics).tti, histogram);
    }
    if (config.slo && config.slo.fmp) {
        var threshold = $59df963ead1bd6f2$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if (config.slo && config.slo.tti) {
        var _threshold = $59df963ead1bd6f2$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= _threshold;
        result['metric:tti:slo:threshold'] = _threshold;
    }
    return result;
};

});

parcelRegister("9szfy", function(module, exports) {

$parcel$export(module.exports, "pageSegmentLoadMetrics", function () { return $6e32127cff519759$export$ba86cb47f2f22db5; });

var $45L5U = parcelRequire("45L5U");

var $4teBn = parcelRequire("4teBn");

var $5JEHx = parcelRequire("5JEHx");
var $6e32127cff519759$var$getThreshold = function getThreshold(isInitial, metric) {
    return (0, $5JEHx.isDetailedPageSegmentLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
var $6e32127cff519759$var$getHistogram = function getHistogram(isInitial, metric, histogram) {
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
var $6e32127cff519759$export$ba86cb47f2f22db5 = function pageSegmentLoadMetrics(config, data, globalConfig) {
    var _config$slo, _config$slo2;
    if (!(0, $4teBn.isPageSegmentLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page segment load data for non-page-segment-load config');
    var fmp = data.marks[(0, $5JEHx.BMPageSegmentLoadMetrics).fmp] || data.stop;
    var result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $6e32127cff519759$var$getHistogram(data.isInitial, (0, $5JEHx.BMPageSegmentLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $6e32127cff519759$var$getHistogram(data.isInitial, (0, $5JEHx.BMPageSegmentLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        var histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $6e32127cff519759$var$getHistogram(data.isInitial, (0, $5JEHx.BMPageSegmentLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $6e32127cff519759$var$getHistogram(data.isInitial, (0, $5JEHx.BMPageSegmentLoadMetrics).tti, histogram);
    }
    if ((_config$slo = config.slo) !== null && _config$slo !== void 0 && _config$slo.fmp) {
        var threshold = $6e32127cff519759$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if ((_config$slo2 = config.slo) !== null && _config$slo2 !== void 0 && _config$slo2.tti) {
        var _threshold = $6e32127cff519759$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= _threshold;
        result['metric:tti:slo:threshold'] = _threshold;
    }
    if (config.includePageLoadTimings === (0, $5JEHx.PageSegmentPageLoadMetricsOptions).IF_PRESENT || config.includePageLoadTimings === (0, $5JEHx.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT) {
        var pageLoadData = (0, $45L5U.pageLoadMetaMetric).getData();
        var _fmp = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round((pageLoadData.marks[(0, $5JEHx.BMPageLoadMetrics).fmp] || pageLoadData.stop) - pageLoadData.start) : null;
        var tti = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round(pageLoadData.stop - pageLoadData.start) : null;
        result['pageLoad'] = {
            fmp: _fmp,
            tti: tti
        };
    }
    return result;
};

});

parcelRegister("iWI9m", function(module, exports) {

$parcel$export(module.exports, "webVitalsMetrics", function () { return $dcafe40a42d793e3$export$3731db279f590f30; });

var $dsN6L = parcelRequire("dsN6L");

var $2R76C = parcelRequire("2R76C");

var $eWMMH = parcelRequire("eWMMH");

var $2Dr5Z = parcelRequire("2Dr5Z");

var $jpUMu = parcelRequire("jpUMu");

var $9AAEF = parcelRequire("9AAEF");

var $d3atg = parcelRequire("d3atg");
function $dcafe40a42d793e3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dcafe40a42d793e3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dcafe40a42d793e3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dcafe40a42d793e3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $dcafe40a42d793e3$export$3731db279f590f30 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee(config, data, globalConfig) {
        var _globalConfig$webVita, _globalConfig$webVita2, _globalConfig$webVita3;
        var pageVisibleState, setPageVisibleStateToMixed, ttciEnabled, webVitalMetrics;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    pageVisibleState = data.pageVisibleState;
                    setPageVisibleStateToMixed = function setPageVisibleStateToMixed() {
                        pageVisibleState = (0, $2Dr5Z.PageVisibleState).MIXED;
                    };
                    (0, $jpUMu.visibilityChangeObserver).subscribe(setPageVisibleStateToMixed);
                    ttciEnabled = ((_globalConfig$webVita = globalConfig.webVitals) === null || _globalConfig$webVita === void 0 ? void 0 : _globalConfig$webVita.ttciEnabled) !== undefined ? (_globalConfig$webVita2 = globalConfig.webVitals) === null || _globalConfig$webVita2 === void 0 ? void 0 : _globalConfig$webVita2.ttciEnabled : true;
                    _context.next = 6;
                    return $dcafe40a42d793e3$export$193ae490b52081dd(ttciEnabled, ((_globalConfig$webVita3 = globalConfig.webVitals) === null || _globalConfig$webVita3 === void 0 ? void 0 : _globalConfig$webVita3.timeout) || 30000);
                case 6:
                    webVitalMetrics = _context.sent;
                    (0, $jpUMu.visibilityChangeObserver).unsubscribe(setPageVisibleStateToMixed);
                    return _context.abrupt("return", $dcafe40a42d793e3$var$_objectSpread($dcafe40a42d793e3$var$_objectSpread({}, webVitalMetrics), {}, {
                        'pageVisible:state': pageVisibleState
                    }, (0, $d3atg.pageVisibleValue)(config, data, globalConfig)));
                case 9:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function webVitalsMetrics(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();
var $dcafe40a42d793e3$export$193ae490b52081dd = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee2(ttciEnabled, timeout) {
        var timeoutWindow;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return ttciEnabled ? (0, $9AAEF.webVitalsObserver).ttciDetermined : Promise.resolve();
                case 2:
                    // wait up to $timeout ms longer for web-vitals until returning
                    timeoutWindow = new Promise(function(resolve) {
                        return setTimeout(resolve, timeout);
                    });
                    _context2.next = 5;
                    return Promise.race([
                        timeoutWindow,
                        (0, $9AAEF.webVitalsObserver).webVitalsDetermined
                    ]);
                case 5:
                    return _context2.abrupt("return", (0, $9AAEF.webVitalsObserver).data);
                case 6:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function webVitalsMetricCustomTimeout(_x4, _x5) {
        return _ref2.apply(this, arguments);
    };
}();

});
parcelRegister("d3atg", function(module, exports) {

$parcel$export(module.exports, "pageVisibleValue", function () { return $9803ad79e93cea1c$export$177b923114656380; });

var $2Dr5Z = parcelRequire("2Dr5Z");
var $5JEHx = parcelRequire("5JEHx");
var $9803ad79e93cea1c$export$177b923114656380 = function pageVisibleValue(_config, data, globalConfig) {
    var value = globalConfig.pageVisibleValueOrigin === (0, $5JEHx.PageVisibleValueOrigin).documentHidden ? !document.hidden || false : data.pageVisibleState === (0, $2Dr5Z.PageVisibleState).VISIBLE;
    return {
        'pageVisible:value': value
    };
};

});


parcelRegister("9x5Qz", function(module, exports) {

$parcel$export(module.exports, "pageVisibleState", function () { return $6f0bbb340df10e35$export$723b4c298aca63af; });
var $6f0bbb340df10e35$export$723b4c298aca63af = function pageVisibleState(_config, data) {
    return {
        'pageVisible:state': data.pageVisibleState
    };
};

});

parcelRegister("gVYmn", function(module, exports) {

$parcel$export(module.exports, "productCustomData", function () { return $c540ca73dce34b09$export$fa2af6e412815a74; });

var $5YM7L = parcelRequire("5YM7L");

var $2R76C = parcelRequire("2R76C");

var $eWMMH = parcelRequire("eWMMH");
var $c540ca73dce34b09$export$fa2af6e412815a74 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee(_config, data, globalConfig) {
        var result, pluginOutputs;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(!globalConfig.custom && !globalConfig.plugins)) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return", null);
                case 2:
                    result = {};
                    if (globalConfig.custom) Object.entries(globalConfig.custom).forEach(function(_ref2) {
                        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_ref2, 2), key = _ref3[0], value = _ref3[1];
                        result["".concat(globalConfig.product, ":").concat(key)] = value;
                    });
                    if (!globalConfig.plugins) {
                        _context.next = 9;
                        break;
                    }
                    _context.next = 7;
                    return Promise.all(globalConfig.plugins.map(function(plugin) {
                        return plugin({
                            start: data.start,
                            stop: data.stop,
                            key: data.key
                        });
                    }));
                case 7:
                    pluginOutputs = _context.sent;
                    pluginOutputs.forEach(function(pluginOutput) {
                        if (pluginOutput === null) return;
                        Object.entries(pluginOutput).forEach(function(_ref4) {
                            var _ref5 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_ref4, 2), key = _ref5[0], value = _ref5[1];
                            result["".concat(globalConfig.product, ":").concat(key)] = value;
                        });
                    });
                case 9:
                    return _context.abrupt("return", result);
                case 10:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function productCustomData(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();

});

parcelRegister("fkEXK", function(module, exports) {

$parcel$export(module.exports, "ssrFeatureFlags", function () { return $b2987f980d039fdd$export$fdbea518c19dfa8; });

var $2R76C = parcelRequire("2R76C");

var $eWMMH = parcelRequire("eWMMH");

var $5JEHx = parcelRequire("5JEHx");
var $b2987f980d039fdd$var$retrieveFeatureFlags = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee(getFeatureFlags) {
        var featureFlags;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return getFeatureFlags();
                case 3:
                    featureFlags = _context.sent;
                    if (!featureFlags) {
                        _context.next = 6;
                        break;
                    }
                    return _context.abrupt("return", {
                        'ssr:featureFlags': featureFlags
                    });
                case 6:
                    _context.next = 10;
                    break;
                case 8:
                    _context.prev = 8;
                    _context.t0 = _context["catch"](0);
                case 10:
                    return _context.abrupt("return", null);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function retrieveFeatureFlags(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $b2987f980d039fdd$export$fdbea518c19dfa8 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee2(config, _data, globalConfig) {
        var _globalConfig$ssr, _config$ssr, _globalConfig$ssr2, _config$ssr2;
        var includeFeatureFlags;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    if ((_globalConfig$ssr = globalConfig.ssr) !== null && _globalConfig$ssr !== void 0 && _globalConfig$ssr.getFeatureFlags) {
                        _context2.next = 2;
                        break;
                    }
                    return _context2.abrupt("return", null);
                case 2:
                    includeFeatureFlags = ((_config$ssr = config.ssr) === null || _config$ssr === void 0 ? void 0 : _config$ssr.includeFeatureFlags) || ((_globalConfig$ssr2 = globalConfig.ssr) === null || _globalConfig$ssr2 === void 0 ? void 0 : _globalConfig$ssr2.includeFeatureFlags) || (0, $5JEHx.IncludeSSRFeatureFlagsConfig).WHEN_FMP;
                    if (!(includeFeatureFlags === (0, $5JEHx.IncludeSSRFeatureFlagsConfig).WHEN_AVAILABLE || (_config$ssr2 = config.ssr) !== null && _config$ssr2 !== void 0 && _config$ssr2.doneAsFmp && includeFeatureFlags === (0, $5JEHx.IncludeSSRFeatureFlagsConfig).WHEN_FMP)) {
                        _context2.next = 7;
                        break;
                    }
                    _context2.next = 6;
                    return $b2987f980d039fdd$var$retrieveFeatureFlags(globalConfig.ssr.getFeatureFlags);
                case 6:
                    return _context2.abrupt("return", _context2.sent);
                case 7:
                    return _context2.abrupt("return", null);
                case 8:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function ssrFeatureFlags(_x2, _x3, _x4) {
        return _ref2.apply(this, arguments);
    };
}();

});

parcelRegister("2i4fu", function(module, exports) {

$parcel$export(module.exports, "ssrSuccess", function () { return $1ab08ef24c315d90$export$a3dc8251cf55b2e0; });
var $1ab08ef24c315d90$export$a3dc8251cf55b2e0 = function ssrSuccess(config, _data, globalConfig) {
    if (config.ssr && config.ssr.doneAsFmp && globalConfig.ssr && globalConfig.ssr.getDoneMark && globalConfig.ssr.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};

});

parcelRegister("dp8lK", function(module, exports) {

$parcel$export(module.exports, "telemetryBrowser", function () { return $0284b6093f5ebbef$export$386b10ac64a50b1; });

var $d5uZU = parcelRequire("d5uZU");
var $0284b6093f5ebbef$export$386b10ac64a50b1 = function telemetryBrowser() {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($d5uZU))).getParser) return null;
    var browser = (0, (/*@__PURE__*/$parcel$interopDefault($d5uZU))).getParser(window.navigator.userAgent);
    return {
        'telemetry:browser:name': browser.getBrowserName(),
        'telemetry:browser:version': browser.getBrowserVersion()
    };
};

});
parcelRegister("d5uZU", function(module, exports) {
!function(e, r) {
    module.exports = r();
}(module.exports, function() {
    return function(e) {
        var r = {};
        function t(n) {
            if (r[n]) return r[n].exports;
            var i = r[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
        }
        return t.m = e, t.c = r, t.d = function(e, r, n) {
            t.o(e, r) || Object.defineProperty(e, r, {
                enumerable: !0,
                get: n
            });
        }, t.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, t.t = function(e, r) {
            if (1 & r && (e = t(e)), 8 & r) return e;
            if (4 & r && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (t.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & r && "string" != typeof e) for(var i in e)t.d(n, i, (function(r) {
                return e[r];
            }).bind(null, i));
            return n;
        }, t.n = function(e) {
            var r = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return t.d(r, "a", r), r;
        }, t.o = function(e, r) {
            return Object.prototype.hasOwnProperty.call(e, r);
        }, t.p = "", t(t.s = 0);
    }([
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(1)) && n.__esModule ? n : {
                default: n
            };
            /*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */ var o = function() {
                function e() {}
                return e.getParser = function(e, r) {
                    if (void 0 === r && (r = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, r);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(2)) && n.__esModule ? n : {
                default: n
            };
            var o = function() {
                function e(e, r) {
                    if (void 0 === r && (r = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== r && this.parse();
                }
                var r = e.prototype;
                return r.getUA = function() {
                    return this._ua;
                }, r.test = function(e) {
                    return e.test(this._ua);
                }, r.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var r = i.default.find(function(r) {
                        if ("function" == typeof r.test) return r.test(e);
                        if (r.test instanceof Array) return r.test.some(function(r) {
                            return e.test(r);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return r && (this.parsedResult.browser = r.describe(this.getUA())), this.parsedResult.browser;
                }, r.isMobile = function() {
                    return this.test(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i);
                }, r.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, r.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, r.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, r.parse = function() {
                    return this.parseBrowser(), this;
                }, r.getResult = function() {
                    return Object.assign({}, this.parsedResult);
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            function n(e, r) {
                var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (t) return (t = t.call(e)).next.bind(t);
                if (Array.isArray(e) || (t = function(e, r) {
                    if (!e) return;
                    if ("string" == typeof e) return i(e, r);
                    var t = Object.prototype.toString.call(e).slice(8, -1);
                    "Object" === t && e.constructor && (t = e.constructor.name);
                    if ("Map" === t || "Set" === t) return Array.from(e);
                    if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return i(e, r);
                }(e)) || r && e && "number" == typeof e.length) {
                    t && (e = t);
                    var n = 0;
                    return function() {
                        return n >= e.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: e[n++]
                        };
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function i(e, r) {
                (null == r || r > e.length) && (r = e.length);
                for(var t = 0, n = new Array(r); t < r; t++)n[t] = e[t];
                return n;
            }
            r.__esModule = !0, r.default = void 0;
            var o = function(e, r) {
                var t = r.match(e);
                return t && t.length > 0 && t[1] || "";
            }, s = function(e, r) {
                var t = r.match(e);
                return t && t.length > 1 && t[2] || "";
            }, u = /version\/(\d+(\.?_?\d+)+)/i, a = function(e, r) {
                void 0 === e && (e = []);
                for(var t, i = n(e); !(t = i()).done;){
                    var s = t.value, u = o(s, r);
                    if (u) return u;
                }
                return null;
            }, d = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Googlebot",
                            version: a([
                                /googlebot\/(\d+(\.\d+))/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                u,
                                /(?:opera)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                /(?:opr|opios)[\s/](\S+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Samsung Internet for Android",
                            version: a([
                                u,
                                /(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        return {
                            name: "NAVER Whale Browser",
                            version: a([
                                u,
                                /(?:whale)[\s/](\d+(?:\.\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Coast",
                            version: a([
                                u,
                                /(?:coast)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Touch",
                            version: a([
                                /(?:opt)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Internet Explorer",
                            version: a([
                                /(?:msie |rv:)(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: a([
                                /\sedg\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: s(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e)
                        };
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Vivaldi",
                            version: a([
                                /vivaldi\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Tizen",
                            version: a([
                                /(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Firefox",
                            version: a([
                                /(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Electron",
                            version: a([
                                /(?:electron)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chromium",
                            version: a([
                                /(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chrome",
                            version: a([
                                /(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Google Search",
                            version: a([
                                /(?:GSA)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: function(e) {
                        var r = !e.test(/like android/i), t = e.test(/android/i);
                        return r && t;
                    },
                    describe: function(e) {
                        return {
                            name: "Android Browser",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Safari",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var r = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: o(r, e),
                            version: s(r, e)
                        };
                    }
                }
            ];
            r.default = d, e.exports = r.default;
        }
    ]);
});

});


parcelRegister("esOTl", function(module, exports) {

$parcel$export(module.exports, "telemetryCpu", function () { return $a87b2840de904e98$export$9f84cb359ed29139; });
var $a87b2840de904e98$export$9f84cb359ed29139 = function telemetryCpu() {
    if (!navigator.hardwareConcurrency) return null;
    return {
        'telemetry:cpus': navigator.hardwareConcurrency
    };
};

});

parcelRegister("4RmDf", function(module, exports) {

$parcel$export(module.exports, "telemetryMemory", function () { return $389daaef6372ab96$export$496c14d72b257e07; });
var $389daaef6372ab96$export$496c14d72b257e07 = function telemetryMemory() {
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'telemetry:memory': navigator.deviceMemory
    };
};

});

parcelRegister("kEDhW", function(module, exports) {

$parcel$export(module.exports, "telemetryNetwork", function () { return $f09604e8111c19fe$export$88bf7b55f7fc4e8e; });
var $f09604e8111c19fe$export$88bf7b55f7fc4e8e = function telemetryNetwork() {
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:downlink': navigator.connection.downlink
    };
};

});

parcelRegister("d53P7", function(module, exports) {

$parcel$export(module.exports, "appTimings", function () { return $985eb54738f0ba33$export$e952f50a4f2d02da; });

var $dsN6L = parcelRequire("dsN6L");

var $5JEHx = parcelRequire("5JEHx");

var $6ylz5 = parcelRequire("6ylz5");

var $3d2J9 = parcelRequire("3d2J9");
function $985eb54738f0ba33$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $985eb54738f0ba33$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $985eb54738f0ba33$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $985eb54738f0ba33$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $985eb54738f0ba33$export$e952f50a4f2d02da = function appTimings(config, data, globalConfig) {
    var explicitTimings = config.type === (0, $5JEHx.BMEventsType).PAGE_LOAD && data.explicitTimings || null;
    var timings = (0, $6ylz5.customTimings)(config, data);
    var ssr = config.type === (0, $5JEHx.BMEventsType).PAGE_LOAD && data.isInitial ? (0, $3d2J9.ssrTimings)(config, data, globalConfig) : null;
    var timingsApp = (explicitTimings || timings || ssr) && $985eb54738f0ba33$var$_objectSpread($985eb54738f0ba33$var$_objectSpread($985eb54738f0ba33$var$_objectSpread({}, explicitTimings), timings), ssr);
    if (!timingsApp) return null;
    return {
        'timings:app': timingsApp
    };
};

});
parcelRegister("6ylz5", function(module, exports) {

$parcel$export(module.exports, "customTimings", function () { return $4c56a56bc1e610aa$export$6126f85083a72c6e; });

var $jwsmd = parcelRequire("jwsmd");
var $4c56a56bc1e610aa$var$retrieveTimings = function retrieveTimings(config, data) {
    var relativeTo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var prefix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var configTimings = config.timings || [];
    var timings = configTimings.reduce(function(entries, timing) {
        if (timing.startMark && !data.marks[timing.startMark]) return entries;
        if (timing.endMark && !data.marks[timing.endMark]) return entries;
        if (data.start === null || data.stop === null) return null;
        var startTime = Math.round((data.marks[timing.startMark] !== undefined ? data.marks[timing.startMark] : data.start) - data.start + relativeTo);
        var duration = Math.round((data.marks[timing.endMark] !== undefined ? data.marks[timing.endMark] : data.stop) - data.start - startTime + relativeTo);
        entries["".concat(prefix).concat(timing.key)] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
var $4c56a56bc1e610aa$export$6126f85083a72c6e = function customTimings(config, data) {
    if (!config.timings && data.submetrics.length === 0) return null;
    var timings = $4c56a56bc1e610aa$var$retrieveTimings(config, data);
    data.submetrics.forEach(function(submetric) {
        if (submetric.start !== null && submetric.stop !== null) {
            var submetricPrefix = "include:".concat(submetric.config.key);
            timings[submetricPrefix] = {
                startTime: Math.round(submetric.start - data.start),
                duration: Math.round(submetric.stop - submetric.start)
            };
            Object.assign(timings, $4c56a56bc1e610aa$var$retrieveTimings(submetric.config, submetric, submetric.start - data.start, submetricPrefix + (0, $jwsmd.NESTED_METRIC_SEPARATOR)));
        }
    });
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});
parcelRegister("jwsmd", function(module, exports) {

$parcel$export(module.exports, "NESTED_METRIC_SEPARATOR", function () { return $e36700aa14bd604a$export$b98e411ae80c806f; });
var $e36700aa14bd604a$export$b98e411ae80c806f = '/';

});


parcelRegister("3d2J9", function(module, exports) {

$parcel$export(module.exports, "ssrTimings", function () { return $2564b3955538c360$export$130f411261a599c5; });

var $61RDg = parcelRequire("61RDg");

var $jwsmd = parcelRequire("jwsmd");
var $2564b3955538c360$var$filterEntry = function filterEntry(entry) {
    return !(!entry || (0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(entry) !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
var $2564b3955538c360$var$mapEntry = function mapEntry(entry) {
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
var $2564b3955538c360$var$SSR_PREFIX = 'ssr';
var $2564b3955538c360$var$mapKey = function mapKey(key) {
    if (key === 'total') return $2564b3955538c360$var$SSR_PREFIX;
    return "".concat($2564b3955538c360$var$SSR_PREFIX).concat((0, $jwsmd.NESTED_METRIC_SEPARATOR)).concat(key);
};
var $2564b3955538c360$export$130f411261a599c5 = function ssrTimings(_config, _data, globalConfig) {
    if (!globalConfig.ssr || !globalConfig.ssr.getTimings) return null;
    var timings = globalConfig.ssr.getTimings();
    if (!timings) return null;
    var ssrTimings = Object.entries(timings).reduce(function(acc, entry) {
        if ($2564b3955538c360$var$filterEntry(entry[1])) acc[$2564b3955538c360$var$mapKey(entry[0])] = $2564b3955538c360$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});


parcelRegister("a3BbV", function(module, exports) {

$parcel$export(module.exports, "bundleEvalTimings", function () { return $752708a2a117a8b2$export$1a2bb347935fc536; });

var $5YM7L = parcelRequire("5YM7L");
var $752708a2a117a8b2$var$bundleEvalTimingsInternal = function bundleEvalTimingsInternal(_config, data, globalConfig) {
    var _globalConfig$enableB;
    var performance = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window.performance;
    var started = {};
    var timings = {};
    var enableBundleEvalTimings = (_globalConfig$enableB = globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.enableBundleEvalTimings) !== null && _globalConfig$enableB !== void 0 ? _globalConfig$enableB : true;
    performance.getEntriesByType('mark').forEach(function(mark) {
        if (!globalConfig.bundleEvalTimings) return;
        var result = globalConfig.bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result) return;
        var type = result.type, name = result.name;
        if (type === 'start' && data.start !== null && mark.startTime >= data.start) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.start),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (globalConfig.bundleEvalTimings && globalConfig.bundleEvalTimings.additionalTimings && data.start !== null && enableBundleEvalTimings) {
        var result = globalConfig.bundleEvalTimings.additionalTimings(data.start);
        if (result) Object.entries(result).forEach(function(_ref) {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_ref, 2), key = _ref2[0], value = _ref2[1];
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};
var $752708a2a117a8b2$export$1a2bb347935fc536 = function bundleEvalTimings() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return new Promise(function(resolve) {
        setTimeout(function() {
            resolve($752708a2a117a8b2$var$bundleEvalTimingsInternal.apply(void 0, args));
        });
    });
};

});

parcelRegister("bDlIo", function(module, exports) {

$parcel$export(module.exports, "resourceTimings", function () { return $87842e5a4542f740$export$81a7d52441a06b50; });

var $dsN6L = parcelRequire("dsN6L");
function $87842e5a4542f740$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $87842e5a4542f740$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $87842e5a4542f740$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $87842e5a4542f740$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $87842e5a4542f740$var$cacheableTypes = [
    'script',
    'link'
];
var $87842e5a4542f740$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
var $87842e5a4542f740$var$CACHE_NETWORK = 'network';
var $87842e5a4542f740$var$CACHE_MEMORY = 'memory';
var $87842e5a4542f740$var$CACHE_DISK = 'disk';
var $87842e5a4542f740$var$calculateTransferType = function calculateTransferType(type, duration, size) {
    if (!$87842e5a4542f740$var$cacheableTypes.includes(type)) return $87842e5a4542f740$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $87842e5a4542f740$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $87842e5a4542f740$var$CACHE_DISK;
    if (size === undefined) return null;
    return $87842e5a4542f740$var$CACHE_NETWORK;
};
var $87842e5a4542f740$var$hasAccessToResourceSize = function hasAccessToResourceSize(url, type, hasTimingHeaders) {
    return !$87842e5a4542f740$var$cacheableTypes.includes(type) || url.includes('localhost') || url.includes(window.location.hostname) || hasTimingHeaders(url);
};
var $87842e5a4542f740$var$getReportedInitiatorTypes = function getReportedInitiatorTypes(xhrEnabled) {
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
var $87842e5a4542f740$var$withoutHeaders = function withoutHeaders() {
    return false;
};
var $87842e5a4542f740$var$evaluateAccessToResourceTimings = function evaluateAccessToResourceTimings(entry) {
    if (entry.responseStart === 0 && entry.startTime > entry.responseStart) return false;
    return true;
};
var $87842e5a4542f740$var$getEvaluatedTimingHeader = function getEvaluatedTimingHeader(entry) {
    var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var hasTimingHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $87842e5a4542f740$var$withoutHeaders;
    if (!enabled) return null;
    var manualResolution = entry.name.includes('localhost') || entry.name.includes(window.location.hostname) || hasTimingHeaders(entry.name);
    var autoResolution = $87842e5a4542f740$var$evaluateAccessToResourceTimings(entry);
    return {
        m_h: manualResolution,
        a_h: autoResolution
    };
};
var $87842e5a4542f740$var$getSizeObject = function getSizeObject(size) {
    return size !== undefined ? {
        size: size
    } : null;
};
var $87842e5a4542f740$var$getNetworkData = function getNetworkData(item, eventStart) {
    var hasTimingHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $87842e5a4542f740$var$withoutHeaders;
    var name = item.name, duration = item.duration, size = item.transferSize, type = item.initiatorType, responseStart = item.responseStart;
    var ttfb = Math.round(responseStart - eventStart);
    if (!$87842e5a4542f740$var$hasAccessToResourceSize(name, type, hasTimingHeaders)) return {};
    if ($87842e5a4542f740$var$cacheableTypes.includes(type)) {
        var transferType = $87842e5a4542f740$var$calculateTransferType(type, duration, size);
        if (!transferType) return $87842e5a4542f740$var$_objectSpread({
            ttfb: ttfb
        }, $87842e5a4542f740$var$getSizeObject(size));
        if (transferType !== $87842e5a4542f740$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return $87842e5a4542f740$var$_objectSpread({
            ttfb: ttfb,
            transferType: transferType
        }, $87842e5a4542f740$var$getSizeObject(size));
    }
    return $87842e5a4542f740$var$_objectSpread({
        ttfb: ttfb
    }, $87842e5a4542f740$var$getSizeObject(size));
};
var $87842e5a4542f740$export$81a7d52441a06b50 = function resourceTimings(_config, data, globalConfig) {
    var performance = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window.performance;
    if (data.start === null) return null;
    var resources = performance.getEntriesByType('resource').filter(function(entry) {
        return entry.startTime >= data.start;
    });
    if (!resources.length) return null;
    var resourceTiming = {};
    var xhrFilter = globalConfig.resourceTimings.xhrFilter;
    var reportedInitiatorTypes = $87842e5a4542f740$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach(function(item) {
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        var name = item.name, startTime = item.startTime, duration = item.duration, workerStart = item.workerStart, fetchStart = item.fetchStart, type = item.initiatorType;
        if (!name) return;
        if (type === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        var url = $87842e5a4542f740$var$resourceTypes.includes(type) ? globalConfig.resourceTimings.sanitiseEndpoints(name) : globalConfig.resourceTimings.mapResources(name);
        if (resourceTiming[url]) return;
        resourceTiming[url] = $87842e5a4542f740$var$_objectSpread($87842e5a4542f740$var$_objectSpread({
            startTime: Math.round(startTime - data.start),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.start), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.start), 0),
            type: type
        }, $87842e5a4542f740$var$getNetworkData(item, data.start, globalConfig.resourceTimings.hasTimingHeaders)), $87842e5a4542f740$var$getEvaluatedTimingHeader(item, globalConfig.resourceTimings.experimental__reportEvaluatedTimingHeaders, globalConfig.resourceTimings.hasTimingHeaders));
    });
    return {
        'timings:resource': resourceTiming
    };
};

});


parcelRegister("2O5uS", function(module, exports) {

$parcel$export(module.exports, "makeShareableGlobalConfig", function () { return $20b483de064fd20c$export$5b4fb14409a2a825; });

var $2R76C = parcelRequire("2R76C");

var $dsN6L = parcelRequire("dsN6L");

var $iqLBO = parcelRequire("iqLBO");

var $eWMMH = parcelRequire("eWMMH");

var $5JEHx = parcelRequire("5JEHx");
function $20b483de064fd20c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $20b483de064fd20c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $20b483de064fd20c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $20b483de064fd20c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $20b483de064fd20c$var$makeFeatureFlags = function makeFeatureFlags(allFeatureFlags, eventTypeFeatureFlags) {
    var featureFlagsForType = [];
    if (allFeatureFlags) featureFlagsForType.push.apply(featureFlagsForType, (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(allFeatureFlags));
    if (eventTypeFeatureFlags) featureFlagsForType.push.apply(featureFlagsForType, (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(eventTypeFeatureFlags));
    return featureFlagsForType;
};
var $20b483de064fd20c$var$makeGlobalConfigPerType = function makeGlobalConfigPerType(global, ffClient, allEventsConfig, eventConfig) {
    var _ref, _eventConfig$pageVisi;
    var allEventsConfigCustom = allEventsConfig && allEventsConfig.custom;
    var eventConfigCustom = eventConfig && eventConfig.custom;
    var custom = (allEventsConfigCustom || eventConfigCustom) && $20b483de064fd20c$var$_objectSpread($20b483de064fd20c$var$_objectSpread({}, allEventsConfigCustom), eventConfigCustom) || undefined;
    var allEventsConfigPlugins = allEventsConfig && allEventsConfig.plugins;
    var eventConfigPlugins = eventConfig && eventConfig.plugins;
    var plugins = (allEventsConfigPlugins || eventConfigPlugins) && [].concat((0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(allEventsConfigPlugins || []), (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(eventConfigPlugins || [])) || undefined;
    var pageVisibleValueOrigin = (_ref = (_eventConfig$pageVisi = eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.pageVisibleValueOrigin) !== null && _eventConfig$pageVisi !== void 0 ? _eventConfig$pageVisi : allEventsConfig === null || allEventsConfig === void 0 ? void 0 : allEventsConfig.pageVisibleValueOrigin) !== null && _ref !== void 0 ? _ref : (0, $5JEHx.PageVisibleValueOrigin).documentHidden;
    return Object.freeze($20b483de064fd20c$var$_objectSpread($20b483de064fd20c$var$_objectSpread({}, global), {}, {
        featureFlags: Object.freeze($20b483de064fd20c$var$makeFeatureFlags(allEventsConfig && allEventsConfig.featureFlags, eventConfig && eventConfig.featureFlags).reduce(function(acc, value) {
            acc[value] = ffClient.getValue(value);
            return acc;
        }, {})),
        custom: custom,
        plugins: plugins,
        histogram: eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.histogram,
        pageVisibleValueOrigin: pageVisibleValueOrigin,
        enableBundleEvalTimings: eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.enableBundleEvalTimings
    }));
};
var $20b483de064fd20c$export$5b4fb14409a2a825 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee(globalConfig) {
        var _globalConfig$events$, _globalConfig$events$2, _globalConfig$events$3;
        var ffClient, global;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 2;
                    return globalConfig.plugins.featureFlags.client;
                case 2:
                    ffClient = _context.sent;
                    global = {
                        app: globalConfig.info.app,
                        product: globalConfig.info.product,
                        region: globalConfig.info.region,
                        resourceTimings: globalConfig.plugins.resourceTimings,
                        bundleEvalTimings: globalConfig.plugins.bundleEvalTimings,
                        ffClient: ffClient,
                        hostname: globalConfig.info.hostname || window.location.hostname,
                        ssr: globalConfig.ssr,
                        enableReactUFOTracker: globalConfig.enableReactUFOTracker,
                        webVitals: {
                            enabled: (_globalConfig$events$ = globalConfig.events[(0, $5JEHx.BMEventsType).WEB_VITALS]) === null || _globalConfig$events$ === void 0 ? void 0 : _globalConfig$events$.enabled,
                            timeout: (_globalConfig$events$2 = globalConfig.events[(0, $5JEHx.BMEventsType).WEB_VITALS]) === null || _globalConfig$events$2 === void 0 ? void 0 : _globalConfig$events$2.timeout,
                            ttciEnabled: (_globalConfig$events$3 = globalConfig.events[(0, $5JEHx.BMEventsType).WEB_VITALS]) === null || _globalConfig$events$3 === void 0 ? void 0 : _globalConfig$events$3.ttciEnabled
                        }
                    };
                    return _context.abrupt("return", (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, (0, $5JEHx.BMEventsType).PAGE_LOAD, $20b483de064fd20c$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $5JEHx.BMEventsType).PAGE_LOAD])), (0, $5JEHx.BMEventsType).PAGE_SEGMENT_LOAD, $20b483de064fd20c$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $5JEHx.BMEventsType).PAGE_SEGMENT_LOAD])), (0, $5JEHx.BMEventsType).INLINE_RESULT, $20b483de064fd20c$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $5JEHx.BMEventsType).INLINE_RESULT])), (0, $5JEHx.BMEventsType).CUSTOM, $20b483de064fd20c$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $5JEHx.BMEventsType).CUSTOM])), (0, $5JEHx.BMEventsType).WEB_VITALS, $20b483de064fd20c$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $5JEHx.BMEventsType).WEB_VITALS])));
                case 5:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function makeShareableGlobalConfig(_x) {
        return _ref2.apply(this, arguments);
    };
}();

});



parcelRegister("6d87w", function(module, exports) {

$parcel$export(module.exports, "createSearchParams", function () { return $485a417b51e4f6ea$export$a2e4e2dcc7b1f22f; });
$parcel$export(module.exports, "createBrowserRouter", function () { return $485a417b51e4f6ea$export$1f3f55432a00e06d; });
$parcel$export(module.exports, "RouterProvider", function () { return $485a417b51e4f6ea$export$323e4fc2fa4753fb; });
$parcel$export(module.exports, "Link", function () { return $485a417b51e4f6ea$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "useSearchParams", function () { return $485a417b51e4f6ea$export$f1a78c17382fe22a; });
$parcel$export(module.exports, "useLocation", function () { return (parcelRequire("l2v8Y")).useLocation; });
$parcel$export(module.exports, "useNavigate", function () { return (parcelRequire("l2v8Y")).useNavigate; });
/**
 * React Router DOM v6.29.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $91i6m = parcelRequire("91i6m");

var $eAqbf = parcelRequire("eAqbf");

var $exhS2 = parcelRequire("exhS2");parcelRequire("l2v8Y");
var $exhS2 = parcelRequire("exhS2");
var $l2v8Y = parcelRequire("l2v8Y");

var $exhS2 = parcelRequire("exhS2");
function $485a417b51e4f6ea$var$_extends() {
    $485a417b51e4f6ea$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $485a417b51e4f6ea$var$_extends.apply(this, arguments);
}
function $485a417b51e4f6ea$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $485a417b51e4f6ea$var$defaultMethod = "get";
const $485a417b51e4f6ea$var$defaultEncType = "application/x-www-form-urlencoded";
function $485a417b51e4f6ea$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $485a417b51e4f6ea$var$isButtonElement(object) {
    return $485a417b51e4f6ea$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $485a417b51e4f6ea$var$isFormElement(object) {
    return $485a417b51e4f6ea$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $485a417b51e4f6ea$var$isInputElement(object) {
    return $485a417b51e4f6ea$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $485a417b51e4f6ea$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $485a417b51e4f6ea$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$485a417b51e4f6ea$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $485a417b51e4f6ea$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $485a417b51e4f6ea$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $485a417b51e4f6ea$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $485a417b51e4f6ea$var$_formDataSupportsSubmitter = null;
function $485a417b51e4f6ea$var$isFormDataSubmitterSupported() {
    if ($485a417b51e4f6ea$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $485a417b51e4f6ea$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $485a417b51e4f6ea$var$_formDataSupportsSubmitter = true;
    }
    return $485a417b51e4f6ea$var$_formDataSupportsSubmitter;
}
const $485a417b51e4f6ea$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $485a417b51e4f6ea$var$getFormEncType(encType) {
    if (encType != null && !$485a417b51e4f6ea$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $485a417b51e4f6ea$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($485a417b51e4f6ea$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $exhS2.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $485a417b51e4f6ea$var$defaultMethod;
        encType = $485a417b51e4f6ea$var$getFormEncType(target.getAttribute("enctype")) || $485a417b51e4f6ea$var$defaultEncType;
        formData = new FormData(target);
    } else if ($485a417b51e4f6ea$var$isButtonElement(target) || $485a417b51e4f6ea$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $exhS2.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $485a417b51e4f6ea$var$defaultMethod;
        encType = $485a417b51e4f6ea$var$getFormEncType(target.getAttribute("formenctype")) || $485a417b51e4f6ea$var$getFormEncType(form.getAttribute("enctype")) || $485a417b51e4f6ea$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$485a417b51e4f6ea$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($485a417b51e4f6ea$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $485a417b51e4f6ea$var$defaultMethod;
        action = null;
        encType = $485a417b51e4f6ea$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $485a417b51e4f6ea$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $485a417b51e4f6ea$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $485a417b51e4f6ea$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $485a417b51e4f6ea$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $485a417b51e4f6ea$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $485a417b51e4f6ea$export$1f3f55432a00e06d(routes, opts) {
    return (0, $exhS2.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $485a417b51e4f6ea$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $exhS2.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $485a417b51e4f6ea$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $l2v8Y.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $485a417b51e4f6ea$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $exhS2.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $485a417b51e4f6ea$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $exhS2.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $485a417b51e4f6ea$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $l2v8Y.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $485a417b51e4f6ea$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $485a417b51e4f6ea$var$_extends({}, state, {
        errors: $485a417b51e4f6ea$var$deserializeErrors(state.errors)
    });
    return state;
}
function $485a417b51e4f6ea$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $exhS2.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $485a417b51e4f6ea$export$7ad602f0e94e62d1 = /*#__PURE__*/ $91i6m.createContext({
    isTransitioning: false
});
const $485a417b51e4f6ea$export$148fd98d095596d4 = /*#__PURE__*/ $91i6m.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $485a417b51e4f6ea$var$START_TRANSITION = "startTransition";
const $485a417b51e4f6ea$var$startTransitionImpl = $91i6m[$485a417b51e4f6ea$var$START_TRANSITION];
const $485a417b51e4f6ea$var$FLUSH_SYNC = "flushSync";
const $485a417b51e4f6ea$var$flushSyncImpl = $eAqbf[$485a417b51e4f6ea$var$FLUSH_SYNC];
const $485a417b51e4f6ea$var$USE_ID = "useId";
const $485a417b51e4f6ea$var$useIdImpl = $91i6m[$485a417b51e4f6ea$var$USE_ID];
function $485a417b51e4f6ea$var$startTransitionSafe(cb) {
    if ($485a417b51e4f6ea$var$startTransitionImpl) $485a417b51e4f6ea$var$startTransitionImpl(cb);
    else cb();
}
function $485a417b51e4f6ea$var$flushSyncSafe(cb) {
    if ($485a417b51e4f6ea$var$flushSyncImpl) $485a417b51e4f6ea$var$flushSyncImpl(cb);
    else cb();
}
class $485a417b51e4f6ea$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $485a417b51e4f6ea$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $91i6m.useState(router.state);
    let [pendingState, setPendingState] = $91i6m.useState();
    let [vtContext, setVtContext] = $91i6m.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $91i6m.useState();
    let [transition, setTransition] = $91i6m.useState();
    let [interruption, setInterruption] = $91i6m.useState();
    let fetcherData = $91i6m.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $91i6m.useCallback((cb)=>{
        if (v7_startTransition) $485a417b51e4f6ea$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $91i6m.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $485a417b51e4f6ea$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $485a417b51e4f6ea$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $485a417b51e4f6ea$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $485a417b51e4f6ea$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $485a417b51e4f6ea$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $91i6m.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $91i6m.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $485a417b51e4f6ea$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $91i6m.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $91i6m.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $91i6m.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $91i6m.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $91i6m.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $91i6m.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $91i6m.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $91i6m.useEffect(()=>(0, $l2v8Y.UNSAFE_logV6DeprecationWarnings)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $91i6m.createElement($91i6m.Fragment, null, /*#__PURE__*/ $91i6m.createElement((0, $l2v8Y.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $91i6m.createElement((0, $l2v8Y.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $91i6m.createElement($485a417b51e4f6ea$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $91i6m.createElement($485a417b51e4f6ea$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $91i6m.createElement((0, $l2v8Y.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $91i6m.createElement($485a417b51e4f6ea$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $485a417b51e4f6ea$var$MemoizedDataRoutes = /*#__PURE__*/ $91i6m.memo($485a417b51e4f6ea$var$DataRoutes);
function $485a417b51e4f6ea$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $l2v8Y.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $485a417b51e4f6ea$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $91i6m.useRef();
    if (historyRef.current == null) historyRef.current = (0, $exhS2.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $91i6m.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $91i6m.useCallback((newState)=>{
        v7_startTransition && $485a417b51e4f6ea$var$startTransitionImpl ? $485a417b51e4f6ea$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $91i6m.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $91i6m.useEffect(()=>(0, $l2v8Y.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $91i6m.createElement((0, $l2v8Y.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $485a417b51e4f6ea$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $91i6m.useRef();
    if (historyRef.current == null) historyRef.current = (0, $exhS2.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $91i6m.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $91i6m.useCallback((newState)=>{
        v7_startTransition && $485a417b51e4f6ea$var$startTransitionImpl ? $485a417b51e4f6ea$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $91i6m.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $91i6m.useEffect(()=>(0, $l2v8Y.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $91i6m.createElement((0, $l2v8Y.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $485a417b51e4f6ea$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $91i6m.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $91i6m.useCallback((newState)=>{
        v7_startTransition && $485a417b51e4f6ea$var$startTransitionImpl ? $485a417b51e4f6ea$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $91i6m.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $91i6m.useEffect(()=>(0, $l2v8Y.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $91i6m.createElement((0, $l2v8Y.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $485a417b51e4f6ea$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $485a417b51e4f6ea$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $485a417b51e4f6ea$export$a6c7ac8248d6e38a = /*#__PURE__*/ $91i6m.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $485a417b51e4f6ea$var$_objectWithoutPropertiesLoose(_ref7, $485a417b51e4f6ea$var$_excluded);
    let { basename: basename } = $91i6m.useContext((0, $l2v8Y.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $485a417b51e4f6ea$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($485a417b51e4f6ea$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $exhS2.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $l2v8Y.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $485a417b51e4f6ea$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $91i6m.createElement("a", $485a417b51e4f6ea$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $485a417b51e4f6ea$export$b0d92dbee9b5b60d = /*#__PURE__*/ $91i6m.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $485a417b51e4f6ea$var$_objectWithoutPropertiesLoose(_ref8, $485a417b51e4f6ea$var$_excluded2);
    let path = (0, $l2v8Y.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $l2v8Y.useLocation)();
    let routerState = $91i6m.useContext((0, $l2v8Y.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $91i6m.useContext((0, $l2v8Y.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $485a417b51e4f6ea$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $exhS2.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $91i6m.createElement($485a417b51e4f6ea$export$a6c7ac8248d6e38a, $485a417b51e4f6ea$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $485a417b51e4f6ea$export$a7fed597f4b8afd8 = /*#__PURE__*/ $91i6m.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $485a417b51e4f6ea$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $485a417b51e4f6ea$var$_objectWithoutPropertiesLoose(_ref9, $485a417b51e4f6ea$var$_excluded3);
    let submit = $485a417b51e4f6ea$export$47c85c6e3a081d3();
    let formAction = $485a417b51e4f6ea$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $91i6m.createElement("form", $485a417b51e4f6ea$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $485a417b51e4f6ea$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $485a417b51e4f6ea$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $485a417b51e4f6ea$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($485a417b51e4f6ea$var$DataRouterHook || ($485a417b51e4f6ea$var$DataRouterHook = {}));
var $485a417b51e4f6ea$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($485a417b51e4f6ea$var$DataRouterStateHook || ($485a417b51e4f6ea$var$DataRouterStateHook = {}));
// Internal hooks
function $485a417b51e4f6ea$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $485a417b51e4f6ea$var$useDataRouterContext(hookName) {
    let ctx = $91i6m.useContext((0, $l2v8Y.UNSAFE_DataRouterContext));
    !ctx && (0, $exhS2.UNSAFE_invariant)(false);
    return ctx;
}
function $485a417b51e4f6ea$var$useDataRouterState(hookName) {
    let state = $91i6m.useContext((0, $l2v8Y.UNSAFE_DataRouterStateContext));
    !state && (0, $exhS2.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $485a417b51e4f6ea$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $l2v8Y.useNavigate)();
    let location = (0, $l2v8Y.useLocation)();
    let path = (0, $l2v8Y.useResolvedPath)(to, {
        relative: relative
    });
    return $91i6m.useCallback((event)=>{
        if ($485a417b51e4f6ea$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $exhS2.createPath)(location) === (0, $exhS2.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $485a417b51e4f6ea$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $91i6m.useRef($485a417b51e4f6ea$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $91i6m.useRef(false);
    let location = (0, $l2v8Y.useLocation)();
    let searchParams = $91i6m.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $485a417b51e4f6ea$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $l2v8Y.useNavigate)();
    let setSearchParams = $91i6m.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $485a417b51e4f6ea$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $485a417b51e4f6ea$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $485a417b51e4f6ea$var$fetcherId = 0;
let $485a417b51e4f6ea$var$getUniqueFetcherId = ()=>"__" + String(++$485a417b51e4f6ea$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $485a417b51e4f6ea$export$47c85c6e3a081d3() {
    let { router: router } = $485a417b51e4f6ea$var$useDataRouterContext($485a417b51e4f6ea$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $91i6m.useContext((0, $l2v8Y.UNSAFE_NavigationContext));
    let currentRouteId = (0, $l2v8Y.UNSAFE_useRouteId)();
    return $91i6m.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $485a417b51e4f6ea$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $485a417b51e4f6ea$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $485a417b51e4f6ea$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $485a417b51e4f6ea$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $91i6m.useContext((0, $l2v8Y.UNSAFE_NavigationContext));
    let routeContext = $91i6m.useContext((0, $l2v8Y.UNSAFE_RouteContext));
    !routeContext && (0, $exhS2.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $485a417b51e4f6ea$var$_extends({}, (0, $l2v8Y.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $l2v8Y.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $exhS2.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $exhS2.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $485a417b51e4f6ea$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $485a417b51e4f6ea$var$useDataRouterContext($485a417b51e4f6ea$var$DataRouterHook.UseFetcher);
    let state = $485a417b51e4f6ea$var$useDataRouterState($485a417b51e4f6ea$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $91i6m.useContext($485a417b51e4f6ea$export$148fd98d095596d4);
    let route = $91i6m.useContext((0, $l2v8Y.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $exhS2.UNSAFE_invariant)(false);
    !route && (0, $exhS2.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $exhS2.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $485a417b51e4f6ea$var$useIdImpl ? $485a417b51e4f6ea$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $91i6m.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($485a417b51e4f6ea$var$getUniqueFetcherId());
    // Registration/cleanup
    $91i6m.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $91i6m.useCallback((href, opts)=>{
        !routeId && (0, $exhS2.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $485a417b51e4f6ea$export$47c85c6e3a081d3();
    let submit = $91i6m.useCallback((target, opts)=>{
        submitImpl(target, $485a417b51e4f6ea$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $91i6m.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $91i6m.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $91i6m.createElement($485a417b51e4f6ea$export$a7fed597f4b8afd8, $485a417b51e4f6ea$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $exhS2.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $91i6m.useMemo(()=>$485a417b51e4f6ea$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $485a417b51e4f6ea$export$fa996778a3a31087() {
    let state = $485a417b51e4f6ea$var$useDataRouterState($485a417b51e4f6ea$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $485a417b51e4f6ea$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $485a417b51e4f6ea$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $485a417b51e4f6ea$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $485a417b51e4f6ea$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $485a417b51e4f6ea$var$useDataRouterContext($485a417b51e4f6ea$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $485a417b51e4f6ea$var$useDataRouterState($485a417b51e4f6ea$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $91i6m.useContext((0, $l2v8Y.UNSAFE_NavigationContext));
    let location = (0, $l2v8Y.useLocation)();
    let matches = (0, $l2v8Y.useMatches)();
    let navigation = (0, $l2v8Y.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $91i6m.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $485a417b51e4f6ea$var$usePageHide($91i6m.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $485a417b51e4f6ea$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $485a417b51e4f6ea$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($485a417b51e4f6ea$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $91i6m.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $485a417b51e4f6ea$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $485a417b51e4f6ea$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $91i6m.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($485a417b51e4f6ea$var$_extends({}, location, {
                    pathname: (0, $exhS2.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($485a417b51e4f6ea$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $91i6m.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $485a417b51e4f6ea$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $91i6m.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $485a417b51e4f6ea$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $91i6m.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $485a417b51e4f6ea$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $l2v8Y.useBlocker)(when);
    $91i6m.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $91i6m.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $485a417b51e4f6ea$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $91i6m.useContext($485a417b51e4f6ea$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $exhS2.UNSAFE_invariant)(false);
    let { basename: basename } = $485a417b51e4f6ea$var$useDataRouterContext($485a417b51e4f6ea$var$DataRouterHook.useViewTransitionState);
    let path = (0, $l2v8Y.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $exhS2.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $exhS2.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $exhS2.matchPath)(path.pathname, nextPath) != null || (0, $exhS2.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("exhS2", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return $a952027d3933c703$export$e19cd5f9376f8cee; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $a952027d3933c703$export$2b76ad033c6e6d08; });
$parcel$export(module.exports, "createPath", function () { return $a952027d3933c703$export$fe53371bee54353d; });
$parcel$export(module.exports, "parsePath", function () { return $a952027d3933c703$export$8ccf933b0513f8d0; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $a952027d3933c703$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $a952027d3933c703$export$b71fdd3798280242; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return $a952027d3933c703$export$3e9cee6b33872309; });
$parcel$export(module.exports, "matchRoutes", function () { return $a952027d3933c703$export$2708184779ceb39d; });
$parcel$export(module.exports, "stripBasename", function () { return $a952027d3933c703$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "UNSAFE_decodePath", function () { return $a952027d3933c703$export$30d21fd6d7295f52; });
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", function () { return $a952027d3933c703$export$b3fac024fad9e8ff; });
$parcel$export(module.exports, "joinPaths", function () { return $a952027d3933c703$export$86d9a7913e44197e; });
$parcel$export(module.exports, "matchPath", function () { return $a952027d3933c703$export$81336c211d5ff295; });
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", function () { return $a952027d3933c703$export$a5784978eca585fa; });
$parcel$export(module.exports, "resolveTo", function () { return $a952027d3933c703$export$cae722b0cc860f13; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return $a952027d3933c703$export$42a99a7a4bc0e76a; });
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", function () { return $a952027d3933c703$export$6c6580e81da25755; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $a952027d3933c703$export$972111febbeef05b; });
$parcel$export(module.exports, "IDLE_FETCHER", function () { return $a952027d3933c703$export$52eace9c284d3585; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return $a952027d3933c703$export$386d57f03f0b2883; });
$parcel$export(module.exports, "createRouter", function () { return $a952027d3933c703$export$baddd0131ee8c05b; });
/**
 * @remix-run/router v1.22.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $a952027d3933c703$var$_extends() {
    $a952027d3933c703$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a952027d3933c703$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $a952027d3933c703$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($a952027d3933c703$export$e19cd5f9376f8cee || ($a952027d3933c703$export$e19cd5f9376f8cee = {}));
const $a952027d3933c703$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $a952027d3933c703$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $a952027d3933c703$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $a952027d3933c703$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $a952027d3933c703$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $a952027d3933c703$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $a952027d3933c703$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $a952027d3933c703$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $a952027d3933c703$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $a952027d3933c703$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $a952027d3933c703$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $a952027d3933c703$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $a952027d3933c703$export$fe53371bee54353d(to);
    }
    return $a952027d3933c703$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $a952027d3933c703$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $a952027d3933c703$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $a952027d3933c703$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $a952027d3933c703$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $a952027d3933c703$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $a952027d3933c703$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $a952027d3933c703$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $a952027d3933c703$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $a952027d3933c703$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $a952027d3933c703$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $a952027d3933c703$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $a952027d3933c703$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $a952027d3933c703$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $a952027d3933c703$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $a952027d3933c703$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $a952027d3933c703$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $a952027d3933c703$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $a952027d3933c703$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($a952027d3933c703$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $a952027d3933c703$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $a952027d3933c703$export$e19cd5f9376f8cee.Push;
        let location = $a952027d3933c703$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $a952027d3933c703$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $a952027d3933c703$export$e19cd5f9376f8cee.Replace;
        let location = $a952027d3933c703$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $a952027d3933c703$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $a952027d3933c703$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $a952027d3933c703$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($a952027d3933c703$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($a952027d3933c703$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $a952027d3933c703$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($a952027d3933c703$var$ResultType || ($a952027d3933c703$var$ResultType = {}));
const $a952027d3933c703$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $a952027d3933c703$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $a952027d3933c703$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $a952027d3933c703$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $a952027d3933c703$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($a952027d3933c703$var$isIndexRoute(route)) {
            let indexRoute = $a952027d3933c703$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $a952027d3933c703$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $a952027d3933c703$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $a952027d3933c703$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $a952027d3933c703$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $a952027d3933c703$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $a952027d3933c703$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $a952027d3933c703$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $a952027d3933c703$var$flattenRoutes(routes);
    $a952027d3933c703$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $a952027d3933c703$export$30d21fd6d7295f52(pathname);
        matches = $a952027d3933c703$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $a952027d3933c703$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $a952027d3933c703$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $a952027d3933c703$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $a952027d3933c703$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $a952027d3933c703$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $a952027d3933c703$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $a952027d3933c703$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $a952027d3933c703$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $a952027d3933c703$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $a952027d3933c703$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $a952027d3933c703$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $a952027d3933c703$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $a952027d3933c703$var$paramRe = /^:[\w-]+$/;
const $a952027d3933c703$var$dynamicSegmentValue = 3;
const $a952027d3933c703$var$indexRouteValue = 2;
const $a952027d3933c703$var$emptySegmentValue = 1;
const $a952027d3933c703$var$staticSegmentValue = 10;
const $a952027d3933c703$var$splatPenalty = -2;
const $a952027d3933c703$var$isSplat = (s)=>s === "*";
function $a952027d3933c703$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($a952027d3933c703$var$isSplat)) initialScore += $a952027d3933c703$var$splatPenalty;
    if (index) initialScore += $a952027d3933c703$var$indexRouteValue;
    return segments.filter((s)=>!$a952027d3933c703$var$isSplat(s)).reduce((score, segment)=>score + ($a952027d3933c703$var$paramRe.test(segment) ? $a952027d3933c703$var$dynamicSegmentValue : segment === "" ? $a952027d3933c703$var$emptySegmentValue : $a952027d3933c703$var$staticSegmentValue), initialScore);
}
function $a952027d3933c703$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $a952027d3933c703$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $a952027d3933c703$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $a952027d3933c703$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $a952027d3933c703$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $a952027d3933c703$export$a5c6d149b50c1d86($a952027d3933c703$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $a952027d3933c703$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $a952027d3933c703$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $a952027d3933c703$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $a952027d3933c703$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $a952027d3933c703$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $a952027d3933c703$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $a952027d3933c703$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $a952027d3933c703$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $a952027d3933c703$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $a952027d3933c703$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $a952027d3933c703$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $a952027d3933c703$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $a952027d3933c703$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $a952027d3933c703$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $a952027d3933c703$var$normalizeSearch(search),
        hash: $a952027d3933c703$var$normalizeHash(hash)
    };
}
function $a952027d3933c703$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $a952027d3933c703$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $a952027d3933c703$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $a952027d3933c703$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $a952027d3933c703$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $a952027d3933c703$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $a952027d3933c703$export$8ccf933b0513f8d0(toArg);
    else {
        to = $a952027d3933c703$var$_extends({}, toArg);
        $a952027d3933c703$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $a952027d3933c703$var$getInvalidPathError("?", "pathname", "search", to));
        $a952027d3933c703$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $a952027d3933c703$var$getInvalidPathError("#", "pathname", "hash", to));
        $a952027d3933c703$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $a952027d3933c703$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $a952027d3933c703$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $a952027d3933c703$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $a952027d3933c703$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $a952027d3933c703$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $a952027d3933c703$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $a952027d3933c703$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $a952027d3933c703$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $a952027d3933c703$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $a952027d3933c703$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $a952027d3933c703$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $a952027d3933c703$export$4051a07651545597(data, init) {
    return new $a952027d3933c703$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $a952027d3933c703$export$42a99a7a4bc0e76a extends Error {
}
class $a952027d3933c703$export$61d759255b4eec65 {
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $a952027d3933c703$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $a952027d3933c703$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $a952027d3933c703$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $a952027d3933c703$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $a952027d3933c703$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
}
function $a952027d3933c703$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $a952027d3933c703$var$unwrapTrackedPromise(value) {
    if (!$a952027d3933c703$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $a952027d3933c703$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $a952027d3933c703$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $a952027d3933c703$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $a952027d3933c703$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $a952027d3933c703$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $a952027d3933c703$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $a952027d3933c703$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $a952027d3933c703$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $a952027d3933c703$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $a952027d3933c703$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $a952027d3933c703$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $a952027d3933c703$var$validMutationMethods = new Set($a952027d3933c703$var$validMutationMethodsArr);
const $a952027d3933c703$var$validRequestMethodsArr = [
    "get",
    ...$a952027d3933c703$var$validMutationMethodsArr
];
const $a952027d3933c703$var$validRequestMethods = new Set($a952027d3933c703$var$validRequestMethodsArr);
const $a952027d3933c703$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $a952027d3933c703$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $a952027d3933c703$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $a952027d3933c703$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $a952027d3933c703$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $a952027d3933c703$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $a952027d3933c703$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $a952027d3933c703$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $a952027d3933c703$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $a952027d3933c703$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $a952027d3933c703$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $a952027d3933c703$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $a952027d3933c703$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $a952027d3933c703$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $a952027d3933c703$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $a952027d3933c703$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $a952027d3933c703$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$a952027d3933c703$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$a952027d3933c703$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $a952027d3933c703$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $a952027d3933c703$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $a952027d3933c703$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $a952027d3933c703$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $a952027d3933c703$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$a952027d3933c703$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($a952027d3933c703$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $a952027d3933c703$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $a952027d3933c703$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $a952027d3933c703$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $a952027d3933c703$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $a952027d3933c703$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $a952027d3933c703$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $a952027d3933c703$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $a952027d3933c703$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $a952027d3933c703$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($a952027d3933c703$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $a952027d3933c703$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $a952027d3933c703$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $a952027d3933c703$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $a952027d3933c703$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $a952027d3933c703$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $a952027d3933c703$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $a952027d3933c703$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $a952027d3933c703$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $a952027d3933c703$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $a952027d3933c703$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $a952027d3933c703$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $a952027d3933c703$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $a952027d3933c703$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $a952027d3933c703$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $a952027d3933c703$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $a952027d3933c703$var$findNearestBoundary(matches).route.id,
            {
                type: $a952027d3933c703$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $a952027d3933c703$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($a952027d3933c703$var$isErrorResult(result) && $a952027d3933c703$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $a952027d3933c703$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $a952027d3933c703$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $a952027d3933c703$var$_extends({
            matches: updatedMatches || matches
        }, $a952027d3933c703$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $a952027d3933c703$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $a952027d3933c703$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $a952027d3933c703$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $a952027d3933c703$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $a952027d3933c703$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $a952027d3933c703$var$ResultType.error,
            error: $a952027d3933c703$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($a952027d3933c703$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $a952027d3933c703$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($a952027d3933c703$var$isDeferredResult(result)) throw $a952027d3933c703$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($a952027d3933c703$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $a952027d3933c703$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $a952027d3933c703$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $a952027d3933c703$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $a952027d3933c703$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($a952027d3933c703$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $a952027d3933c703$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $a952027d3933c703$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $a952027d3933c703$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $a952027d3933c703$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $a952027d3933c703$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $a952027d3933c703$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $a952027d3933c703$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $a952027d3933c703$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $a952027d3933c703$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $a952027d3933c703$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$a952027d3933c703$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $a952027d3933c703$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $a952027d3933c703$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $a952027d3933c703$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $a952027d3933c703$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $a952027d3933c703$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $a952027d3933c703$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $a952027d3933c703$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $a952027d3933c703$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $a952027d3933c703$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $a952027d3933c703$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $a952027d3933c703$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $a952027d3933c703$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($a952027d3933c703$var$isRedirectResult(actionResult) || $a952027d3933c703$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $a952027d3933c703$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($a952027d3933c703$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $a952027d3933c703$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $a952027d3933c703$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($a952027d3933c703$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($a952027d3933c703$var$isDeferredResult(actionResult)) throw $a952027d3933c703$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $a952027d3933c703$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $a952027d3933c703$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $a952027d3933c703$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $a952027d3933c703$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $a952027d3933c703$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $a952027d3933c703$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $a952027d3933c703$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $a952027d3933c703$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $a952027d3933c703$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $a952027d3933c703$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $a952027d3933c703$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $a952027d3933c703$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $a952027d3933c703$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $a952027d3933c703$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $a952027d3933c703$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $a952027d3933c703$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($a952027d3933c703$var$isDeferredResult(result)) result = await $a952027d3933c703$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $a952027d3933c703$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($a952027d3933c703$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $a952027d3933c703$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($a952027d3933c703$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $a952027d3933c703$export$3e9cee6b33872309(!$a952027d3933c703$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $a952027d3933c703$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $a952027d3933c703$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $a952027d3933c703$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $a952027d3933c703$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($a952027d3933c703$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $a952027d3933c703$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $a952027d3933c703$export$e19cd5f9376f8cee.Replace : $a952027d3933c703$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $a952027d3933c703$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($a952027d3933c703$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $a952027d3933c703$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $a952027d3933c703$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $a952027d3933c703$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $a952027d3933c703$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $a952027d3933c703$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($a952027d3933c703$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $a952027d3933c703$var$ResultType.redirect,
                response: $a952027d3933c703$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $a952027d3933c703$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $a952027d3933c703$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $a952027d3933c703$var$ResultType.error,
                    error: $a952027d3933c703$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $a952027d3933c703$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $a952027d3933c703$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $a952027d3933c703$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $a952027d3933c703$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $a952027d3933c703$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $a952027d3933c703$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $a952027d3933c703$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $a952027d3933c703$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $a952027d3933c703$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $a952027d3933c703$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $a952027d3933c703$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $a952027d3933c703$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $a952027d3933c703$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $a952027d3933c703$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$a952027d3933c703$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $a952027d3933c703$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $a952027d3933c703$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $a952027d3933c703$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $a952027d3933c703$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $a952027d3933c703$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $a952027d3933c703$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $a952027d3933c703$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $a952027d3933c703$export$4d0306f8f6a4585b = Symbol("deferred");
function $a952027d3933c703$export$3336b097a6fbc59a(routes, opts) {
    $a952027d3933c703$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $a952027d3933c703$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $a952027d3933c703$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $a952027d3933c703$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $a952027d3933c703$var$createLocation("", $a952027d3933c703$export$fe53371bee54353d(url), null, "default");
        let matches = $a952027d3933c703$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$a952027d3933c703$var$isValidMethod(method) && method !== "HEAD") {
            let error = $a952027d3933c703$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $a952027d3933c703$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $a952027d3933c703$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $a952027d3933c703$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($a952027d3933c703$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $a952027d3933c703$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $a952027d3933c703$var$createLocation("", $a952027d3933c703$export$fe53371bee54353d(url), null, "default");
        let matches = $a952027d3933c703$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$a952027d3933c703$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $a952027d3933c703$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $a952027d3933c703$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $a952027d3933c703$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $a952027d3933c703$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $a952027d3933c703$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($a952027d3933c703$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$a952027d3933c703$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $a952027d3933c703$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($a952027d3933c703$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $a952027d3933c703$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $a952027d3933c703$var$isResponse(result) ? result : $a952027d3933c703$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($a952027d3933c703$var$isDataStrategyResult(e) && $a952027d3933c703$var$isResponse(e.result)) {
                if (e.type === $a952027d3933c703$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($a952027d3933c703$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $a952027d3933c703$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $a952027d3933c703$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $a952027d3933c703$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($a952027d3933c703$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($a952027d3933c703$var$isDeferredResult(result)) {
            let error = $a952027d3933c703$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $a952027d3933c703$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($a952027d3933c703$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($a952027d3933c703$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $a952027d3933c703$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $a952027d3933c703$var$_extends({}, context, {
                statusCode: $a952027d3933c703$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $a952027d3933c703$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $a952027d3933c703$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $a952027d3933c703$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $a952027d3933c703$var$isErrorResult(pendingActionResult[1]) ? $a952027d3933c703$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $a952027d3933c703$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $a952027d3933c703$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $a952027d3933c703$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $a952027d3933c703$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $a952027d3933c703$var$callDataStrategyImpl(dataStrategy || $a952027d3933c703$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($a952027d3933c703$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $a952027d3933c703$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($a952027d3933c703$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $a952027d3933c703$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $a952027d3933c703$export$fec11da027c70692(routes, context, error) {
    let newContext = $a952027d3933c703$var$_extends({}, context, {
        statusCode: $a952027d3933c703$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $a952027d3933c703$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $a952027d3933c703$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $a952027d3933c703$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $a952027d3933c703$export$cae722b0cc860f13(to ? to : ".", $a952027d3933c703$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $a952027d3933c703$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $a952027d3933c703$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $a952027d3933c703$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $a952027d3933c703$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $a952027d3933c703$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$a952027d3933c703$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$a952027d3933c703$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $a952027d3933c703$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $a952027d3933c703$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $a952027d3933c703$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$a952027d3933c703$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$a952027d3933c703$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $a952027d3933c703$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $a952027d3933c703$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $a952027d3933c703$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $a952027d3933c703$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $a952027d3933c703$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($a952027d3933c703$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $a952027d3933c703$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $a952027d3933c703$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $a952027d3933c703$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $a952027d3933c703$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $a952027d3933c703$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $a952027d3933c703$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $a952027d3933c703$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $a952027d3933c703$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $a952027d3933c703$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $a952027d3933c703$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($a952027d3933c703$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $a952027d3933c703$var$shouldRevalidateLoader(match, $a952027d3933c703$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $a952027d3933c703$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $a952027d3933c703$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $a952027d3933c703$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $a952027d3933c703$var$shouldRevalidateLoader(fetcherMatch, $a952027d3933c703$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $a952027d3933c703$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $a952027d3933c703$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $a952027d3933c703$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $a952027d3933c703$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $a952027d3933c703$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $a952027d3933c703$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$a952027d3933c703$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $a952027d3933c703$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $a952027d3933c703$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$a952027d3933c703$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $a952027d3933c703$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $a952027d3933c703$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $a952027d3933c703$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$a952027d3933c703$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $a952027d3933c703$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $a952027d3933c703$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $a952027d3933c703$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $a952027d3933c703$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $a952027d3933c703$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $a952027d3933c703$var$ResultType.data,
                result: undefined
            });
        };
        return $a952027d3933c703$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $a952027d3933c703$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $a952027d3933c703$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $a952027d3933c703$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $a952027d3933c703$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $a952027d3933c703$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $a952027d3933c703$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $a952027d3933c703$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($a952027d3933c703$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $a952027d3933c703$var$ResultType.error,
                error: e
            };
        }
        if (type === $a952027d3933c703$var$ResultType.error) return {
            type: $a952027d3933c703$var$ResultType.error,
            error: new $a952027d3933c703$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $a952027d3933c703$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $a952027d3933c703$var$ResultType.error) {
        if ($a952027d3933c703$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $a952027d3933c703$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $a952027d3933c703$var$ResultType.error,
                error: new $a952027d3933c703$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $a952027d3933c703$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $a952027d3933c703$var$ResultType.error,
            error: result,
            statusCode: $a952027d3933c703$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($a952027d3933c703$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $a952027d3933c703$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($a952027d3933c703$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $a952027d3933c703$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $a952027d3933c703$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $a952027d3933c703$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $a952027d3933c703$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$a952027d3933c703$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $a952027d3933c703$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $a952027d3933c703$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($a952027d3933c703$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $a952027d3933c703$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $a952027d3933c703$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($a952027d3933c703$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $a952027d3933c703$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $a952027d3933c703$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $a952027d3933c703$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $a952027d3933c703$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $a952027d3933c703$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $a952027d3933c703$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $a952027d3933c703$export$3e9cee6b33872309(!$a952027d3933c703$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($a952027d3933c703$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $a952027d3933c703$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $a952027d3933c703$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($a952027d3933c703$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $a952027d3933c703$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $a952027d3933c703$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $a952027d3933c703$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($a952027d3933c703$var$isErrorResult(result)) {
            let boundaryMatch = $a952027d3933c703$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $a952027d3933c703$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($a952027d3933c703$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $a952027d3933c703$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($a952027d3933c703$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $a952027d3933c703$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $a952027d3933c703$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $a952027d3933c703$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $a952027d3933c703$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $a952027d3933c703$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $a952027d3933c703$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $a952027d3933c703$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $a952027d3933c703$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $a952027d3933c703$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $a952027d3933c703$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $a952027d3933c703$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($a952027d3933c703$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $a952027d3933c703$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $a952027d3933c703$export$8ccf933b0513f8d0(path) : path;
    return $a952027d3933c703$export$fe53371bee54353d($a952027d3933c703$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $a952027d3933c703$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $a952027d3933c703$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $a952027d3933c703$var$ResultType.data || result.type === $a952027d3933c703$var$ResultType.error);
}
function $a952027d3933c703$var$isRedirectDataStrategyResultResult(result) {
    return $a952027d3933c703$var$isResponse(result.result) && $a952027d3933c703$var$redirectStatusCodes.has(result.result.status);
}
function $a952027d3933c703$var$isDeferredResult(result) {
    return result.type === $a952027d3933c703$var$ResultType.deferred;
}
function $a952027d3933c703$var$isErrorResult(result) {
    return result.type === $a952027d3933c703$var$ResultType.error;
}
function $a952027d3933c703$var$isRedirectResult(result) {
    return (result && result.type) === $a952027d3933c703$var$ResultType.redirect;
}
function $a952027d3933c703$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $a952027d3933c703$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $a952027d3933c703$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $a952027d3933c703$var$isRedirectResponse(result) {
    if (!$a952027d3933c703$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $a952027d3933c703$var$isValidMethod(method) {
    return $a952027d3933c703$var$validRequestMethods.has(method.toLowerCase());
}
function $a952027d3933c703$var$isMutationMethod(method) {
    return $a952027d3933c703$var$validMutationMethods.has(method.toLowerCase());
}
async function $a952027d3933c703$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$a952027d3933c703$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($a952027d3933c703$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $a952027d3933c703$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $a952027d3933c703$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($a952027d3933c703$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $a952027d3933c703$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $a952027d3933c703$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $a952027d3933c703$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $a952027d3933c703$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $a952027d3933c703$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $a952027d3933c703$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $a952027d3933c703$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $a952027d3933c703$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $a952027d3933c703$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $a952027d3933c703$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $a952027d3933c703$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $a952027d3933c703$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $a952027d3933c703$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $a952027d3933c703$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $a952027d3933c703$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $a952027d3933c703$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $a952027d3933c703$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $a952027d3933c703$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($a952027d3933c703$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $a952027d3933c703$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($a952027d3933c703$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $a952027d3933c703$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});

parcelRegister("l2v8Y", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", function () { return $f511f15adb21d8aa$export$3add0d5dce533e2e; });
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", function () { return $f511f15adb21d8aa$export$145dfa71566a64dc; });
$parcel$export(module.exports, "UNSAFE_NavigationContext", function () { return $f511f15adb21d8aa$export$26749e8557646306; });
$parcel$export(module.exports, "UNSAFE_RouteContext", function () { return $f511f15adb21d8aa$export$9072aa6dd1f93057; });
$parcel$export(module.exports, "useHref", function () { return $f511f15adb21d8aa$export$b66bb29c5006f12f; });
$parcel$export(module.exports, "useResolvedPath", function () { return $f511f15adb21d8aa$export$e75d2a2d1b3c245b; });
$parcel$export(module.exports, "useLocation", function () { return $f511f15adb21d8aa$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $f511f15adb21d8aa$export$9770f232ac06a008; });
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", function () { return $f511f15adb21d8aa$export$5fcee62552a12fbf; });
$parcel$export(module.exports, "useRouteError", function () { return $f511f15adb21d8aa$export$ed527bf60f6e05f2; });
$parcel$export(module.exports, "UNSAFE_useRouteId", function () { return $f511f15adb21d8aa$export$5fc8298006ad9e58; });
$parcel$export(module.exports, "useNavigation", function () { return $f511f15adb21d8aa$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useMatches", function () { return $f511f15adb21d8aa$export$2378eb7f5ff86053; });
$parcel$export(module.exports, "useLoaderData", function () { return $f511f15adb21d8aa$export$1448a5050d252c4d; });
$parcel$export(module.exports, "useBlocker", function () { return $f511f15adb21d8aa$export$b273b3273281a049; });
$parcel$export(module.exports, "UNSAFE_logV6DeprecationWarnings", function () { return $f511f15adb21d8aa$export$db5148ec97d6af7a; });
$parcel$export(module.exports, "Router", function () { return $f511f15adb21d8aa$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Navigate", function () { return $f511f15adb21d8aa$export$444b3ab0cb9aec40; });
$parcel$export(module.exports, "Outlet", function () { return $f511f15adb21d8aa$export$910ae8079b2c2852; });
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", function () { return $f511f15adb21d8aa$export$52b333d321859367; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return (parcelRequire("exhS2")).isRouteErrorResponse; });
/**
 * React Router v6.29.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $91i6m = parcelRequire("91i6m");

var $exhS2 = parcelRequire("exhS2");
function $f511f15adb21d8aa$var$_extends() {
    $f511f15adb21d8aa$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f511f15adb21d8aa$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $f511f15adb21d8aa$export$3add0d5dce533e2e = /*#__PURE__*/ $91i6m.createContext(null);
const $f511f15adb21d8aa$export$145dfa71566a64dc = /*#__PURE__*/ $91i6m.createContext(null);
const $f511f15adb21d8aa$var$AwaitContext = /*#__PURE__*/ $91i6m.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $f511f15adb21d8aa$export$26749e8557646306 = /*#__PURE__*/ $91i6m.createContext(null);
const $f511f15adb21d8aa$export$c7914228fb69b0f5 = /*#__PURE__*/ $91i6m.createContext(null);
const $f511f15adb21d8aa$export$9072aa6dd1f93057 = /*#__PURE__*/ $91i6m.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $f511f15adb21d8aa$var$RouteErrorContext = /*#__PURE__*/ $91i6m.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $f511f15adb21d8aa$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$f511f15adb21d8aa$export$9c954a9d03d32f4a() && (0, $exhS2.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $91i6m.useContext($f511f15adb21d8aa$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $f511f15adb21d8aa$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $exhS2.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $f511f15adb21d8aa$export$9c954a9d03d32f4a() {
    return $91i6m.useContext($f511f15adb21d8aa$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $f511f15adb21d8aa$export$45d76561a5302f2b() {
    !$f511f15adb21d8aa$export$9c954a9d03d32f4a() && (0, $exhS2.UNSAFE_invariant)(false);
    return $91i6m.useContext($f511f15adb21d8aa$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $f511f15adb21d8aa$export$1b3f31771c5d07c() {
    return $91i6m.useContext($f511f15adb21d8aa$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $f511f15adb21d8aa$export$6c330e8992e8a295(pattern) {
    !$f511f15adb21d8aa$export$9c954a9d03d32f4a() && (0, $exhS2.UNSAFE_invariant)(false);
    let { pathname: pathname } = $f511f15adb21d8aa$export$45d76561a5302f2b();
    return $91i6m.useMemo(()=>(0, $exhS2.matchPath)(pattern, (0, $exhS2.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $f511f15adb21d8aa$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $f511f15adb21d8aa$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $91i6m.useContext($f511f15adb21d8aa$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $91i6m.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $f511f15adb21d8aa$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $91i6m.useContext($f511f15adb21d8aa$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $f511f15adb21d8aa$var$useNavigateStable() : $f511f15adb21d8aa$var$useNavigateUnstable();
}
function $f511f15adb21d8aa$var$useNavigateUnstable() {
    !$f511f15adb21d8aa$export$9c954a9d03d32f4a() && (0, $exhS2.UNSAFE_invariant)(false);
    let dataRouterContext = $91i6m.useContext($f511f15adb21d8aa$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $91i6m.useContext($f511f15adb21d8aa$export$26749e8557646306);
    let { matches: matches } = $91i6m.useContext($f511f15adb21d8aa$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $f511f15adb21d8aa$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $exhS2.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $91i6m.useRef(false);
    $f511f15adb21d8aa$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $91i6m.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $exhS2.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $exhS2.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $f511f15adb21d8aa$var$OutletContext = /*#__PURE__*/ $91i6m.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $f511f15adb21d8aa$export$4138103a3ae699cc() {
    return $91i6m.useContext($f511f15adb21d8aa$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $f511f15adb21d8aa$export$a3be3530d8e40d0b(context) {
    let outlet = $91i6m.useContext($f511f15adb21d8aa$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $91i6m.createElement($f511f15adb21d8aa$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $f511f15adb21d8aa$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $91i6m.useContext($f511f15adb21d8aa$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $f511f15adb21d8aa$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $91i6m.useContext($f511f15adb21d8aa$export$26749e8557646306);
    let { matches: matches } = $91i6m.useContext($f511f15adb21d8aa$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $f511f15adb21d8aa$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $exhS2.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $91i6m.useMemo(()=>(0, $exhS2.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $f511f15adb21d8aa$export$5d3fca4a98652595(routes, locationArg) {
    return $f511f15adb21d8aa$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $f511f15adb21d8aa$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$f511f15adb21d8aa$export$9c954a9d03d32f4a() && (0, $exhS2.UNSAFE_invariant)(false);
    let { navigator: navigator, static: isStatic } = $91i6m.useContext($f511f15adb21d8aa$export$26749e8557646306);
    let { matches: parentMatches } = $91i6m.useContext($f511f15adb21d8aa$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $f511f15adb21d8aa$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $exhS2.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $exhS2.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = !isStatic && dataRouterState && dataRouterState.matches && dataRouterState.matches.length > 0 ? dataRouterState.matches : (0, $exhS2.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $f511f15adb21d8aa$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $exhS2.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $exhS2.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $91i6m.createElement($f511f15adb21d8aa$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $f511f15adb21d8aa$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $exhS2.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $f511f15adb21d8aa$var$DefaultErrorComponent() {
    let error = $f511f15adb21d8aa$export$ed527bf60f6e05f2();
    let message = (0, $exhS2.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $91i6m.createElement($91i6m.Fragment, null, /*#__PURE__*/ $91i6m.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $91i6m.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $91i6m.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $f511f15adb21d8aa$var$defaultErrorElement = /*#__PURE__*/ $91i6m.createElement($f511f15adb21d8aa$var$DefaultErrorComponent, null);
class $f511f15adb21d8aa$var$RenderErrorBoundary extends $91i6m.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $91i6m.createElement($f511f15adb21d8aa$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $91i6m.createElement($f511f15adb21d8aa$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
}
function $f511f15adb21d8aa$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $91i6m.useContext($f511f15adb21d8aa$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $91i6m.createElement($f511f15adb21d8aa$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $f511f15adb21d8aa$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $exhS2.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $f511f15adb21d8aa$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $f511f15adb21d8aa$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $91i6m.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $91i6m.createElement($f511f15adb21d8aa$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $91i6m.createElement($f511f15adb21d8aa$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $f511f15adb21d8aa$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($f511f15adb21d8aa$var$DataRouterHook || {});
var $f511f15adb21d8aa$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($f511f15adb21d8aa$var$DataRouterStateHook || {});
function $f511f15adb21d8aa$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $f511f15adb21d8aa$var$useDataRouterContext(hookName) {
    let ctx = $91i6m.useContext($f511f15adb21d8aa$export$3add0d5dce533e2e);
    !ctx && (0, $exhS2.UNSAFE_invariant)(false);
    return ctx;
}
function $f511f15adb21d8aa$var$useDataRouterState(hookName) {
    let state = $91i6m.useContext($f511f15adb21d8aa$export$145dfa71566a64dc);
    !state && (0, $exhS2.UNSAFE_invariant)(false);
    return state;
}
function $f511f15adb21d8aa$var$useRouteContext(hookName) {
    let route = $91i6m.useContext($f511f15adb21d8aa$export$9072aa6dd1f93057);
    !route && (0, $exhS2.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $f511f15adb21d8aa$var$useCurrentRouteId(hookName) {
    let route = $f511f15adb21d8aa$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $exhS2.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $f511f15adb21d8aa$export$5fc8298006ad9e58() {
    return $f511f15adb21d8aa$var$useCurrentRouteId($f511f15adb21d8aa$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $f511f15adb21d8aa$export$d0fd4b7106de2769() {
    let state = $f511f15adb21d8aa$var$useDataRouterState($f511f15adb21d8aa$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $f511f15adb21d8aa$export$600dc272ed516c15() {
    let dataRouterContext = $f511f15adb21d8aa$var$useDataRouterContext($f511f15adb21d8aa$var$DataRouterHook.UseRevalidator);
    let state = $f511f15adb21d8aa$var$useDataRouterState($f511f15adb21d8aa$var$DataRouterStateHook.UseRevalidator);
    return $91i6m.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $f511f15adb21d8aa$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $f511f15adb21d8aa$var$useDataRouterState($f511f15adb21d8aa$var$DataRouterStateHook.UseMatches);
    return $91i6m.useMemo(()=>matches.map((m)=>(0, $exhS2.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $f511f15adb21d8aa$export$1448a5050d252c4d() {
    let state = $f511f15adb21d8aa$var$useDataRouterState($f511f15adb21d8aa$var$DataRouterStateHook.UseLoaderData);
    let routeId = $f511f15adb21d8aa$var$useCurrentRouteId($f511f15adb21d8aa$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $f511f15adb21d8aa$export$fd5d37484eab868d(routeId) {
    let state = $f511f15adb21d8aa$var$useDataRouterState($f511f15adb21d8aa$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $f511f15adb21d8aa$export$fdc00f3f26066d5e() {
    let state = $f511f15adb21d8aa$var$useDataRouterState($f511f15adb21d8aa$var$DataRouterStateHook.UseActionData);
    let routeId = $f511f15adb21d8aa$var$useCurrentRouteId($f511f15adb21d8aa$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $f511f15adb21d8aa$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $91i6m.useContext($f511f15adb21d8aa$var$RouteErrorContext);
    let state = $f511f15adb21d8aa$var$useDataRouterState($f511f15adb21d8aa$var$DataRouterStateHook.UseRouteError);
    let routeId = $f511f15adb21d8aa$var$useCurrentRouteId($f511f15adb21d8aa$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $f511f15adb21d8aa$export$78a72ddb39bdd145() {
    let value = $91i6m.useContext($f511f15adb21d8aa$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $f511f15adb21d8aa$export$17f53340677d5831() {
    let value = $91i6m.useContext($f511f15adb21d8aa$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $f511f15adb21d8aa$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $f511f15adb21d8aa$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $f511f15adb21d8aa$var$useDataRouterContext($f511f15adb21d8aa$var$DataRouterHook.UseBlocker);
    let state = $f511f15adb21d8aa$var$useDataRouterState($f511f15adb21d8aa$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $91i6m.useState("");
    let blockerFunction = $91i6m.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $f511f15adb21d8aa$var$_extends({}, currentLocation, {
                pathname: (0, $exhS2.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $f511f15adb21d8aa$var$_extends({}, nextLocation, {
                pathname: (0, $exhS2.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $91i6m.useEffect(()=>{
        let key = String(++$f511f15adb21d8aa$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $91i6m.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $exhS2.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $f511f15adb21d8aa$var$useNavigateStable() {
    let { router: router } = $f511f15adb21d8aa$var$useDataRouterContext($f511f15adb21d8aa$var$DataRouterHook.UseNavigateStable);
    let id = $f511f15adb21d8aa$var$useCurrentRouteId($f511f15adb21d8aa$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $91i6m.useRef(false);
    $f511f15adb21d8aa$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $91i6m.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $f511f15adb21d8aa$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $f511f15adb21d8aa$var$alreadyWarned$1 = {};
function $f511f15adb21d8aa$var$warningOnce(key, cond, message) {
    if (!cond && !$f511f15adb21d8aa$var$alreadyWarned$1[key]) $f511f15adb21d8aa$var$alreadyWarned$1[key] = true;
}
const $f511f15adb21d8aa$var$alreadyWarned = {};
function $f511f15adb21d8aa$var$warnOnce(key, message) {}
const $f511f15adb21d8aa$var$logDeprecation = (flag, msg, link)=>$f511f15adb21d8aa$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $f511f15adb21d8aa$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $f511f15adb21d8aa$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $f511f15adb21d8aa$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $f511f15adb21d8aa$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $f511f15adb21d8aa$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $f511f15adb21d8aa$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $f511f15adb21d8aa$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $f511f15adb21d8aa$var$START_TRANSITION = "startTransition";
const $f511f15adb21d8aa$var$startTransitionImpl = $91i6m[$f511f15adb21d8aa$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $f511f15adb21d8aa$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $91i6m.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $91i6m.useCallback((newState)=>{
        if (v7_startTransition && $f511f15adb21d8aa$var$startTransitionImpl) $f511f15adb21d8aa$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $91i6m.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $91i6m.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $91i6m.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $91i6m.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $91i6m.useEffect(()=>$f511f15adb21d8aa$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $91i6m.createElement($91i6m.Fragment, null, /*#__PURE__*/ $91i6m.createElement($f511f15adb21d8aa$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $91i6m.createElement($f511f15adb21d8aa$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $91i6m.createElement($f511f15adb21d8aa$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $91i6m.createElement($f511f15adb21d8aa$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $f511f15adb21d8aa$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $f511f15adb21d8aa$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $f511f15adb21d8aa$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $91i6m.useRef();
    if (historyRef.current == null) historyRef.current = (0, $exhS2.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $91i6m.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $91i6m.useCallback((newState)=>{
        v7_startTransition && $f511f15adb21d8aa$var$startTransitionImpl ? $f511f15adb21d8aa$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $91i6m.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $91i6m.useEffect(()=>$f511f15adb21d8aa$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $91i6m.createElement($f511f15adb21d8aa$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $f511f15adb21d8aa$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$f511f15adb21d8aa$export$9c954a9d03d32f4a() && (0, $exhS2.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $91i6m.useContext($f511f15adb21d8aa$export$26749e8557646306);
    let { matches: matches } = $91i6m.useContext($f511f15adb21d8aa$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $f511f15adb21d8aa$export$45d76561a5302f2b();
    let navigate = $f511f15adb21d8aa$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $exhS2.resolveTo)(to, (0, $exhS2.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $91i6m.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $f511f15adb21d8aa$export$910ae8079b2c2852(props) {
    return $f511f15adb21d8aa$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $f511f15adb21d8aa$export$e7b0ac011bb776c6(_props) {
    (0, $exhS2.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $f511f15adb21d8aa$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $exhS2.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$f511f15adb21d8aa$export$9c954a9d03d32f4a() && (0, $exhS2.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $91i6m.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $f511f15adb21d8aa$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $exhS2.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $91i6m.useMemo(()=>{
        let trailingPathname = (0, $exhS2.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $91i6m.createElement($f511f15adb21d8aa$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $91i6m.createElement($f511f15adb21d8aa$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $f511f15adb21d8aa$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $f511f15adb21d8aa$export$5d3fca4a98652595($f511f15adb21d8aa$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $f511f15adb21d8aa$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $91i6m.createElement($f511f15adb21d8aa$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $91i6m.createElement($f511f15adb21d8aa$var$ResolveAwait, null, children));
}
var $f511f15adb21d8aa$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($f511f15adb21d8aa$var$AwaitRenderStatus || {});
const $f511f15adb21d8aa$var$neverSettledPromise = new Promise(()=>{});
class $f511f15adb21d8aa$var$AwaitErrorBoundary extends $91i6m.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $f511f15adb21d8aa$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $f511f15adb21d8aa$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $f511f15adb21d8aa$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $f511f15adb21d8aa$var$AwaitRenderStatus.error : "_data" in promise ? $f511f15adb21d8aa$var$AwaitRenderStatus.success : $f511f15adb21d8aa$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $f511f15adb21d8aa$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $f511f15adb21d8aa$var$AwaitRenderStatus.error && promise._error instanceof (0, $exhS2.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $f511f15adb21d8aa$var$neverSettledPromise;
        if (status === $f511f15adb21d8aa$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $f511f15adb21d8aa$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $91i6m.createElement($f511f15adb21d8aa$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $f511f15adb21d8aa$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $91i6m.createElement($f511f15adb21d8aa$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $f511f15adb21d8aa$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $f511f15adb21d8aa$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $91i6m.createElement($91i6m.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $f511f15adb21d8aa$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $91i6m.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $91i6m.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $91i6m.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $f511f15adb21d8aa$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $f511f15adb21d8aa$export$e7b0ac011bb776c6) && (0, $exhS2.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $exhS2.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $f511f15adb21d8aa$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $f511f15adb21d8aa$export$daf73786167a7f72(matches) {
    return $f511f15adb21d8aa$var$_renderMatches(matches);
}
function $f511f15adb21d8aa$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $91i6m.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $91i6m.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $91i6m.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $f511f15adb21d8aa$export$f30f7e456d254e83(routes, opts) {
    return (0, $exhS2.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $f511f15adb21d8aa$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $exhS2.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $f511f15adb21d8aa$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

});



parcelRegister("jQauR", function(module, exports) {

$parcel$export(module.exports, "startBrowserMetrics", function () { return $01b6fb92c085b13d$export$7cf313435eb9a801; });

var $3TJbe = parcelRequire("3TJbe");

var $5JEHx = parcelRequire("5JEHx");

var $91i6m = parcelRequire("91i6m");

var $bqdjD = parcelRequire("bqdjD");

var $3f4xr = parcelRequire("3f4xr");
const $01b6fb92c085b13d$export$7cf313435eb9a801 = (analyticsClient)=>{
    var _686073ae597408a9ea5278438d83f10f0f7cbd964b22;
    const info = {
        app: {
            version: {
                web: (_686073ae597408a9ea5278438d83f10f0f7cbd964b22 = "6860-73ae597408a9ea5278438d83f10f0f7cbd964b22") !== null && _686073ae597408a9ea5278438d83f10f0f7cbd964b22 !== void 0 ? _686073ae597408a9ea5278438d83f10f0f7cbd964b22 : 'no-version'
            },
            framework: {
                name: 'react',
                version: $91i6m.version
            }
        },
        product: 'identity',
        // Region is used for "Split by" in Perf Portal.
        region: 'unknown'
    };
    const endpoints = {
        eventPipelineClient: Promise.resolve(analyticsClient.getInstance())
    };
    const events = {
        [(0, $5JEHx.BMEventsType).WEB_VITALS]: {
            enabled: true
        }
    };
    const plugins = {
        featureFlags: {
            client: Promise.resolve({
                getValue: (gate)=>(0, $3f4xr.checkFeatureGate)(gate)
            })
        },
        resourceTimings: {
            /**
       * Browser Metrics track all the network calls and add them automatically to the performance events.
       * To ensure we're not recording any UGC / PII, we need to provide a sanitise method.
       */ sanitiseEndpoints: (url)=>{
                // Remove sensitive PII data (i.e. all URL params)
                return url.split('?')[0];
            },
            /**
       * Takes a URL and removes hashes, cache busting parameters, versioning, and other unique identifiers specific to the build of the app.
       * This is so that URLs that exist as a part of a browser metrics payload will not be deemed unique due to having different hashes.
       *
       * * For example, when `url` is:
       * - `https://aid-frontend.prod.atl-paas.net/atlassian-id/front-end/5.0.449/static/js/login.28848bff.chunk.js`
       * - `https://aid-frontend.prod.atl-paas.net/atlassian-id/front-end/5.0.450/static/js/login.66eb7699.chunk.js`
       *
       * Then both of the above should be cleaned to `login.js`, which will be treated as the same URL for reporting purposes.
       */ mapResources: (url)=>{
                // url = https://aid-frontend.prod.atl-paas.net/.../static/js/login.28848bff.chunk.js
                if (!url.includes('aid-frontend')) // This is an external URL where we can't guarantee the URL structure, therefore cannot do any mapping.
                return url;
                var _url_split_pop;
                // hashedFileName = login.28848bff.chunk.js
                const hashedFileName = (_url_split_pop = url.split('/').pop()) !== null && _url_split_pop !== void 0 ? _url_split_pop : 'unknown';
                const parts = hashedFileName.split('.');
                const ext = parts.length > 1 ? parts.pop() : 'unknown';
                // Returning login.js
                return `${parts[0]}.${ext}`;
            },
            // If url supports TimingAllowOrigin header, then BM calculates cache status of static resources:
            hasTimingHeaders: ()=>false
        }
    };
    (0, $3TJbe.browserMetrics).init({
        info: info,
        endpoints: endpoints,
        plugins: plugins,
        events: events,
        debug: (0, $bqdjD.currentEnvType) !== 'prod'
    });
    (0, $3TJbe.browserMetrics).startPageLoad({
        isInitial: true
    });
};

});
parcelRegister("3f4xr", function(module, exports) {

$parcel$export(module.exports, "checkFeatureGate", function () { return $69026b79b4744072$export$bd360271f9be3afb; });
$parcel$export(module.exports, "checkFeatureGateOnceInitialized", function () { return $69026b79b4744072$export$169cc76505f776d4; });

var $kRYwT = parcelRequire("kRYwT");
parcelRequire("02MUI");
var $eYupi = parcelRequire("eYupi");
const $69026b79b4744072$export$bd360271f9be3afb = (key)=>{
    return (0, $kRYwT.default).checkGate(key);
};
const $69026b79b4744072$export$169cc76505f776d4 = async (key)=>{
    await (0, $eYupi.isFeatureGateProviderReady);
    return (0, $kRYwT.default).checkGate(key);
};

});
parcelRegister("02MUI", function(module, exports) {
$parcel$export(module.exports, "FeatureGateProvider", function () { return (parcelRequire("eYupi")).FeatureGateProvider; });
$parcel$export(module.exports, "isFeatureGateProviderReady", function () { return (parcelRequire("eYupi")).isFeatureGateProviderReady; });
parcelRequire("eYupi");

});
parcelRegister("eYupi", function(module, exports) {

$parcel$export(module.exports, "isFeatureGateProviderReady", function () { return $536e628c15225cf0$export$e64f903d3c37e234; });
$parcel$export(module.exports, "FeatureGateProvider", function () { return $536e628c15225cf0$export$d9e6d91f1f7e3282; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $2aGBJ = parcelRequire("2aGBJ");

var $1KJSO = parcelRequire("1KJSO");

var $497Dz = parcelRequire("497Dz");

var $1V2cH = parcelRequire("1V2cH");

var $9OWP7 = parcelRequire("9OWP7");

var $leG06 = parcelRequire("leG06");

var $2UbF1 = parcelRequire("2UbF1");

var $49Pnv = parcelRequire("49Pnv");

var $cL1dd = parcelRequire("cL1dd");
/**
 * Feature Gates are currently created within React (ticket to move this outside in KIRBY-9193)
 * There are cases where FGs may be needed to used by entities outside of React components
 * The example this was written for is the react-router v6 loader function,
 * which gets called at the top-level on initialization of createBrowserRouter is called.
 */ const $536e628c15225cf0$var$deferredPromise = (0, $cL1dd.default)();
const $536e628c15225cf0$export$e64f903d3c37e234 = $536e628c15225cf0$var$deferredPromise.promise;
const $536e628c15225cf0$export$d9e6d91f1f7e3282 = ({ children: children })=>{
    const [isFeatureGatesClientReady, setIsFeatureGatesClientReady] = (0, $91i6m.useState)(false);
    const [dynamicConfigsClient, setDynamicConfigsCollection] = (0, $91i6m.useState)(undefined);
    const tenantId = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_context;
        return (_state_context = state.context) === null || _state_context === void 0 ? void 0 : _state_context.tenantCloudId;
    });
    const atlassianAccountId = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_context;
        return (_state_context = state.context) === null || _state_context === void 0 ? void 0 : _state_context.userId;
    });
    const ffsId = (0, $1KJSO.getFfsId)();
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const analyticsAnonymousId = (0, $1V2cH.useAnalyticsAnonymousId)();
    const featureGatesIdentifiers = (0, $91i6m.useMemo)(()=>({
            tenantId: tenantId,
            atlassianAccountId: atlassianAccountId,
            randomizationId: ffsId,
            analyticsAnonymousId: analyticsAnonymousId
        }), [
        tenantId,
        atlassianAccountId,
        ffsId,
        analyticsAnonymousId
    ]);
    (0, $91i6m.useEffect)(()=>{
        (0, $2UbF1.initializeDynamicConfigs)(analyticsAnonymousId).then((dynamicConfigs)=>setDynamicConfigsCollection(dynamicConfigs));
    }, [
        analyticsAnonymousId
    ]);
    const onFeatureGatesReady = (0, $91i6m.useCallback)((err)=>{
        setIsFeatureGatesClientReady(true);
        $536e628c15225cf0$var$captureStatsigFeatureGateError(err);
        $536e628c15225cf0$var$deferredPromise.resolve();
    }, []);
    const areClientsReady = isFeatureGatesClientReady && !!dynamicConfigsClient;
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $497Dz.FeatureGatesInit), {
                identifiers: featureGatesIdentifiers,
                onReady: onFeatureGatesReady
            }),
            !areClientsReady && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9OWP7.default), {
                label: formatMessage({
                    id: 'statsig.clients.loading',
                    defaultMessage: 'Loading feature flags...',
                    description: 'Label text for loading spinner when Statsig clients are being initialized'
                })
            }),
            areClientsReady && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $2UbF1.DynamicConfigsContext).Provider, {
                value: dynamicConfigsClient,
                children: children
            })
        ]
    });
};
const $536e628c15225cf0$var$captureStatsigFeatureGateError = (err)=>{
    if (!err) return;
    (0, $49Pnv.captureException)(err, undefined, {
        statsigFeatureGate: 'statsig_feature_gate_client_init'
    });
};

});
parcelRegister("2aGBJ", function(module, exports) {

$parcel$export(module.exports, "RESET_APP_STATE", function () { return $d9da60e9b7106810$export$83323797e38f210e; });
$parcel$export(module.exports, "createAppStore", function () { return $d9da60e9b7106810$export$38e7b01cdeec369; });
$parcel$export(module.exports, "useAppDispatch", function () { return $d9da60e9b7106810$export$f51d452c10d5b956; });
$parcel$export(module.exports, "useAppSelector", function () { return $d9da60e9b7106810$export$a7347740d65f620b; });

var $5tPtc = parcelRequire("5tPtc");
var $5jYTP = parcelRequire("5jYTP");

var $cDM7Q = parcelRequire("cDM7Q");

var $evZqI = parcelRequire("evZqI");
parcelRequire("iCwDt");
var $eOclC = parcelRequire("eOclC");
var $2rfZC = parcelRequire("2rfZC");
const $d9da60e9b7106810$export$83323797e38f210e = 'RESET_APP_STATE';
const $d9da60e9b7106810$var$rootReducer = (state, action)=>{
    const shouldResetAppState = action.type === $d9da60e9b7106810$export$83323797e38f210e;
    const stateToUpdate = shouldResetAppState ? action.data : state;
    return (0, $5tPtc.combineReducers)((0, $cDM7Q.getReducers)())(stateToUpdate, action);
};
const $d9da60e9b7106810$export$38e7b01cdeec369 = (preloadedState = {})=>(0, $5jYTP.configureStore)({
        reducer: $d9da60e9b7106810$var$rootReducer,
        devTools: false,
        preloadedState: preloadedState,
        middleware: (getDefaultMiddleware)=>getDefaultMiddleware().concat((0, $evZqI.idAuthMfaMiddleware))
    });
const $d9da60e9b7106810$export$f51d452c10d5b956 = (0, $eOclC.useDispatch);
const $d9da60e9b7106810$export$a7347740d65f620b = (0, $2rfZC.useSelector);

});
parcelRegister("cDM7Q", function(module, exports) {

$parcel$export(module.exports, "getReducers", function () { return $b5d7db479941bad6$export$cf167d5dfe57ae0e; });

var $4w5di = parcelRequire("4w5di");

var $4VPnC = parcelRequire("4VPnC");

var $i2o6I = parcelRequire("i2o6I");

var $bx5EQ = parcelRequire("bx5EQ");

var $5Bh4Q = parcelRequire("5Bh4Q");

var $kETRA = parcelRequire("kETRA");

var $fbaIQ = parcelRequire("fbaIQ");

var $91k9J = parcelRequire("91k9J");

var $6ol8l = parcelRequire("6ol8l");

var $7lzTb = parcelRequire("7lzTb");

var $97wUm = parcelRequire("97wUm");

var $8bjBd = parcelRequire("8bjBd");

var $5WVUf = parcelRequire("5WVUf");

var $lXPI9 = parcelRequire("lXPI9");

var $eSSZz = parcelRequire("eSSZz");

var $byv62 = parcelRequire("byv62");

var $aZRl3 = parcelRequire("aZRl3");

var $g3uqB = parcelRequire("g3uqB");

var $8Yngm = parcelRequire("8Yngm");

var $5KunI = parcelRequire("5KunI");

var $UKWGN = parcelRequire("UKWGN");

var $jCe7t = parcelRequire("jCe7t");

var $dJcgK = parcelRequire("dJcgK");

var $l4asD = parcelRequire("l4asD");

var $kldA7 = parcelRequire("kldA7");

var $gMqGE = parcelRequire("gMqGE");

var $7me1n = parcelRequire("7me1n");

var $dMSXm = parcelRequire("dMSXm");

var $jtxsP = parcelRequire("jtxsP");

var $50ywh = parcelRequire("50ywh");

var $jq2RY = parcelRequire("jq2RY");

var $joMJe = parcelRequire("joMJe");

var $cSbax = parcelRequire("cSbax");

var $6jKHi = parcelRequire("6jKHi");

var $ScDHm = parcelRequire("ScDHm");

var $1KCn1 = parcelRequire("1KCn1");

var $MAUh6 = parcelRequire("MAUh6");

var $8qpC8 = parcelRequire("8qpC8");
const $b5d7db479941bad6$export$cf167d5dfe57ae0e = ()=>({
        appConfig: $4w5di.default,
        csrfToken: $6ol8l.csrfToken,
        hashedCsrfToken: $6ol8l.hashedCsrfToken,
        globalStateLoading: $8qpC8.default,
        login: $lXPI9.default,
        logout: $eSSZz.default,
        marketingConsent: $byv62.default,
        mfaEnrollment: $aZRl3.default,
        mfaPromote: $g3uqB.default,
        microbranding: $8Yngm.default,
        multiFactor: $UKWGN.default,
        recovery: $dJcgK.default,
        resetPassword: $l4asD.default,
        signup: $7me1n.default,
        signupOnboard: $dMSXm.default,
        user: $joMJe.default,
        flags: $97wUm.default,
        continueAs: $fbaIQ.default,
        selectAccount: $kldA7.default,
        cancelDeletion: $4VPnC.default,
        expiredPassword: $7lzTb.default,
        googleOneTap: $8bjBd.default,
        changePassword: $bx5EQ.default,
        changeEmail: $i2o6I.default,
        createAccount: $91k9J.default,
        welcome: $1KCn1.default,
        context: $kETRA.default,
        migrateConfirmation: $5KunI.default,
        socialLoginRecovery: $jtxsP.default,
        verifyEmail: $cSbax.default,
        verifyEmailSent: $ScDHm.default,
        serverError: $gMqGE.default,
        cobranding: $5Bh4Q.default,
        stepUp: $50ywh.default,
        stepUpSso: $jq2RY.default,
        welcomeSent: $jCe7t.default,
        locale: $5WVUf.default,
        verifyEmailOtp: $6jKHi.default,
        loginConsent: $MAUh6.default
    });

});
parcelRegister("4w5di", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3b32e5f9368c4c4$export$2e2bcd8739ae039; });
const $f3b32e5f9368c4c4$export$49d5fc8cba920a0 = {
    googleAuthClientId: '596149463257-9oquqfivs9on8t8erq23c8qso6vk3cp1.apps.googleusercontent.com',
    isSamlEnabled: true,
    recaptchaEnable: true,
    recaptchaEnterpriseCheckboxKeySite: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
    recaptchaEnterpriseInvisibleKeySite: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
    recaptchaEnterpriseScoreKeySite: '6LcIg3QnAAAAAPmTkAv_ZanJY5dRDUJo-i5hr_aN',
    smsEnrollmentRecaptchaEnabled: true,
    smsEnrollmentRecaptchaEnterpriseInvisibleKeySite: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
    auth0Config: {
        domain: 'auth-domain.dev.atlassian.com',
        clientId: 'RJH00Zs94cwksZuhhkM133mJvmBA0NoQ',
        callbackUrl: 'http://localhost:3000/login/callback',
        deferRules: {
            apple: {
                callbackUrl: 'https://id.dev.internal.atlassian.com/login/apple/callback',
                clientId: 'EtITLqX61hS0sxFzgMEwYYWHosfYHjgY'
            },
            microsoft: {
                callbackUrl: 'https://id.dev.internal.atlassian.com/login/microsoft/callback',
                clientId: '3LDSJPtWZnovKS1gMCnKmp9Hk3iXlVEZ'
            },
            slack: {
                callbackUrl: 'https://id.dev.internal.atlassian.com/login/slack/callback',
                clientId: 'zKYyRODwsh165L0h41wALWAeqVfqDs0i'
            }
        }
    },
    segmentIoKey: '',
    castlePublishableApiKey: ''
};
const $f3b32e5f9368c4c4$var$appConfig = (state = $f3b32e5f9368c4c4$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $f3b32e5f9368c4c4$export$2e2bcd8739ae039 = $f3b32e5f9368c4c4$var$appConfig;

});

parcelRegister("4VPnC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9eb2e5eb409b9f56$export$2e2bcd8739ae039; });
const $9eb2e5eb409b9f56$export$49d5fc8cba920a0 = {
    deleteOn: ''
};
const $9eb2e5eb409b9f56$var$cancelDeletion = (state = $9eb2e5eb409b9f56$export$49d5fc8cba920a0)=>{
    return state;
};
var $9eb2e5eb409b9f56$export$2e2bcd8739ae039 = $9eb2e5eb409b9f56$var$cancelDeletion;

});

parcelRegister("i2o6I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de0ad4e4e4d19f69$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");
const $de0ad4e4e4d19f69$export$49d5fc8cba920a0 = {
    email: '',
    newEmail: '',
    error: null,
    isLoading: false,
    redirectTo: null
};
const $de0ad4e4e4d19f69$var$changeEmail = (state = $de0ad4e4e4d19f69$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'CHANGE_EMAIL_RESET_STATE':
            return $de0ad4e4e4d19f69$export$49d5fc8cba920a0;
        case 'CHANGE_EMAIL_REQUEST':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                error: null,
                isLoading: true
            });
        case 'CHANGE_EMAIL_REQUEST_FAILED':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                error: action.error,
                isLoading: false
            });
        case 'CHANGE_EMAIL_REQUEST_SUCCEEDED':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                redirectTo: action.redirectTo,
                isLoading: false
            });
        case 'CHANGE_EMAIL_STATE_UPDATE':
            return (0, $1Fos3._)({}, state, action.backendState);
        default:
            return state;
    }
};
var $de0ad4e4e4d19f69$export$2e2bcd8739ae039 = $de0ad4e4e4d19f69$var$changeEmail;

});

parcelRegister("bx5EQ", function(module, exports) {

$parcel$export(module.exports, "defaultState", function () { return $41145cbf5c519e54$export$49d5fc8cba920a0; });
$parcel$export(module.exports, "default", function () { return $41145cbf5c519e54$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");
const $41145cbf5c519e54$export$49d5fc8cba920a0 = {
    email: '',
    displayName: '',
    fieldErrors: {},
    isLoading: false
};
const $41145cbf5c519e54$var$changePassword = (state = $41145cbf5c519e54$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'CHANGE_PASSWORD_REQUEST_INITIATE':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                fieldErrors: {},
                isLoading: true,
                error: undefined
            });
        case 'CHANGE_PASSWORD_REQUEST_SUCCESS':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isLoading: false,
                error: undefined
            });
        case 'CHANGE_PASSWORD_REQUEST_FAILED':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isLoading: false,
                error: action.error
            });
        case 'CHANGE_PASSWORD_REQUEST_FIELD_ERRORS':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isLoading: false,
                fieldErrors: action.fieldErrors
            });
        default:
            return state;
    }
};
var $41145cbf5c519e54$export$2e2bcd8739ae039 = $41145cbf5c519e54$var$changePassword;

});

parcelRegister("5Bh4Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ef4bfc9a5a61b65$export$2e2bcd8739ae039; });
const $5ef4bfc9a5a61b65$export$49d5fc8cba920a0 = {};
const $5ef4bfc9a5a61b65$var$cobranding = (state = $5ef4bfc9a5a61b65$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $5ef4bfc9a5a61b65$export$2e2bcd8739ae039 = $5ef4bfc9a5a61b65$var$cobranding;

});

parcelRegister("kETRA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5c85e5816ad3af7$export$2e2bcd8739ae039; });
const $c5c85e5816ad3af7$export$49d5fc8cba920a0 = {
    tenantCloudId: undefined
};
const $c5c85e5816ad3af7$var$appConfig = (state = $c5c85e5816ad3af7$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $c5c85e5816ad3af7$export$2e2bcd8739ae039 = $c5c85e5816ad3af7$var$appConfig;

});

parcelRegister("fbaIQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc771d3fe3fbb78d$export$2e2bcd8739ae039; });
const $fc771d3fe3fbb78d$export$49d5fc8cba920a0 = {
    displayName: '',
    email: '',
    avatarUrl: '',
    continueUrl: ''
};
const $fc771d3fe3fbb78d$var$continueAs = (state = $fc771d3fe3fbb78d$export$49d5fc8cba920a0)=>{
    return state;
};
var $fc771d3fe3fbb78d$export$2e2bcd8739ae039 = $fc771d3fe3fbb78d$var$continueAs;

});

parcelRegister("91k9J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee9820b4e5b35fce$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");
const $ee9820b4e5b35fce$export$49d5fc8cba920a0 = {
    formError: undefined,
    fieldErrors: {},
    redirectTo: null,
    isLoading: false,
    source: undefined,
    loginType: undefined,
    displayName: undefined,
    email: undefined,
    accessToken: undefined,
    idToken: undefined,
    createNeeded: undefined,
    verifyNeeded: undefined,
    confirmationToken: undefined,
    mfaToken: undefined
};
const $ee9820b4e5b35fce$var$createAccount = (state = $ee9820b4e5b35fce$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'CONFIRMATION_RESET':
            return $ee9820b4e5b35fce$export$49d5fc8cba920a0;
        case 'CONFIRMATION_REQUEST':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                fieldErrors: {},
                formError: undefined,
                isLoading: true
            });
        case 'CONFIRMATION_REQUEST_SUCCESS':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                fieldErrors: {},
                isLoading: false,
                redirectTo: action.redirectTo
            });
        case 'CONFIRMATION_RESEND_SUCCESS':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                mfaToken: action.mfaToken
            });
        case 'CONFIRMATION_REQUEST_FAILED':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                formError: action.error,
                isLoading: false
            });
        case 'CONFIRMATION_SHOW_FIELD_ERROR':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                fieldErrors: action.errors,
                isLoading: false
            });
        case 'CONFIRMATION_STATE_UPDATE':
            return (0, $1Fos3._)({}, state, action.backendState);
        default:
            return state;
    }
};
var $ee9820b4e5b35fce$export$2e2bcd8739ae039 = $ee9820b4e5b35fce$var$createAccount;

});

parcelRegister("6ol8l", function(module, exports) {

$parcel$export(module.exports, "csrfToken", function () { return $b26a9a3133647789$export$c077d53e8672d0e9; });
$parcel$export(module.exports, "hashedCsrfToken", function () { return $b26a9a3133647789$export$e9eff156dd8b992; });
const $b26a9a3133647789$export$49d5fc8cba920a0 = '';
const $b26a9a3133647789$export$c077d53e8672d0e9 = (state = $b26a9a3133647789$export$49d5fc8cba920a0, action)=>{
    if (action.type === 'CSRF_TOKEN_UPDATE') return action.csrfToken;
    return state;
};
const $b26a9a3133647789$export$e9eff156dd8b992 = (state = $b26a9a3133647789$export$49d5fc8cba920a0, action)=>{
    if (action.type === 'HASHED_CSRF_TOKEN_UPDATE') return action.hashedCsrfToken;
    return state;
};

});

parcelRegister("7lzTb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1a422ed9324fecb$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");
const $c1a422ed9324fecb$export$49d5fc8cba920a0 = {
    error: null,
    isLoading: false,
    isComplete: false
};
const $c1a422ed9324fecb$var$expiredPassword = (state = $c1a422ed9324fecb$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'EXPIRED_PASSWORD_RESET_REQUEST_INITIATE':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                error: null,
                isLoading: true,
                isComplete: false
            });
        case 'EXPIRED_PASSWORD_RESET_REQUEST_SUCCESS':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                error: null,
                isLoading: false,
                isComplete: true
            });
        case 'EXPIRED_PASSWORD_RESET_REQUEST_FAILED':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                error: action.error,
                isLoading: false,
                isComplete: true
            });
        default:
            return state;
    }
};
var $c1a422ed9324fecb$export$2e2bcd8739ae039 = $c1a422ed9324fecb$var$expiredPassword;

});

parcelRegister("97wUm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e0fd631cf06d802$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");
const $1e0fd631cf06d802$export$49d5fc8cba920a0 = {
    flags: []
};
var $1e0fd631cf06d802$export$2e2bcd8739ae039 = (state = $1e0fd631cf06d802$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'FLAG_ADD':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                flags: [
                    action.flag,
                    ...state.flags
                ]
            });
        case 'FLAG_DISMISS':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                flags: state.flags.slice(1)
            });
        default:
            return state;
    }
};

});

parcelRegister("8bjBd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6502538105ac4cc6$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");
const $6502538105ac4cc6$export$49d5fc8cba920a0 = {
    dismissed: false
};
const $6502538105ac4cc6$var$googleOneTap = (state = $6502538105ac4cc6$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'GOOGLE_ONE_TAP_DISMISS':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                dismissed: true
            });
        default:
            return state;
    }
};
var $6502538105ac4cc6$export$2e2bcd8739ae039 = $6502538105ac4cc6$var$googleOneTap;

});

parcelRegister("5WVUf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6073e7b8cf539b92$export$2e2bcd8739ae039; });
const $6073e7b8cf539b92$export$49d5fc8cba920a0 = 'en';
const $6073e7b8cf539b92$var$locale = (state = $6073e7b8cf539b92$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $6073e7b8cf539b92$export$2e2bcd8739ae039 = $6073e7b8cf539b92$var$locale;

});

parcelRegister("lXPI9", function(module, exports) {

$parcel$export(module.exports, "defaultState", function () { return $30ebf37732a4904c$export$49d5fc8cba920a0; });
$parcel$export(module.exports, "default", function () { return $30ebf37732a4904c$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $gtKO2 = parcelRequire("gtKO2");
const $30ebf37732a4904c$export$49d5fc8cba920a0 = {
    isUsernameChecked: false,
    isV2UsernameChecked: false,
    passwordless: (0, $gtKO2.CheckUserNamePasswordlessType).Disallowed,
    isCaptchaRequired: false,
    isCheckingUsername: false,
    isV2CheckingUsername: false,
    isErrorShown: false,
    fieldErrors: {},
    isLoggingIn: false,
    redirectUrl: '',
    redirectType: null,
    restrictedEmail: false,
    nextAttempt: 1,
    showResetHint: false,
    usernameExists: false,
    isSocialBlocked: false,
    rememberMeEnabled: false,
    rememberedAccounts: [],
    isRememberMeChecked: false,
    rememberedAccountsResponseCodes: [],
    v2Accounts: []
};
const $30ebf37732a4904c$var$login = (state = $30ebf37732a4904c$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'LOGIN_REQUEST_CHECK_USERNAME':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isCheckingUsername: true,
                isErrorShown: false,
                fieldErrors: {},
                identities: undefined
            });
        case 'LOGIN_REQUEST_CHECK_USERNAME_V2':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isV2CheckingUsername: true,
                isErrorShown: false,
                fieldErrors: {},
                v2Accounts: []
            });
        case 'LOGIN_REQUEST_CHECK_USERNAME_V2_SUCCEEDED':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isV2CheckingUsername: false,
                isV2UsernameChecked: true,
                v2Accounts: action.accounts
            });
        case 'LOGIN_REQUEST_CHECK_USERNAME_REDIRECT':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isCheckingUsername: false,
                isErrorShown: false,
                fieldErrors: {},
                isUsernameChecked: false,
                usernameExists: true,
                redirectUrl: action.redirectUrl,
                redirectType: action.redirectType,
                passwordless: (0, $gtKO2.CheckUserNamePasswordlessType).Disallowed,
                isSocialBlocked: false
            });
        case 'LOGIN_REQUEST_CHECK_USERNAME_SIGNUP':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isCheckingUsername: false,
                isErrorShown: false,
                fieldErrors: {},
                isUsernameChecked: true,
                usernameExists: false,
                redirectUrl: '',
                redirectType: null,
                passwordless: (0, $gtKO2.CheckUserNamePasswordlessType).Disallowed,
                isSocialBlocked: false
            });
        case 'LOGIN_REQUEST_CHECK_USERNAME_NO_ACTION':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isCheckingUsername: false,
                isErrorShown: false,
                fieldErrors: {},
                isUsernameChecked: true,
                usernameExists: true,
                redirectUrl: '',
                redirectType: null,
                passwordless: action.passwordless,
                isSocialBlocked: action.social === 'disallowed'
            });
        case 'LOGIN_REQUEST_CHECK_USERNAME_SOCIAL_LOGIN':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isCheckingUsername: false,
                isErrorShown: false,
                fieldErrors: {},
                isUsernameChecked: true,
                usernameExists: true,
                redirectUrl: '',
                redirectType: null,
                passwordless: action.passwordless,
                identities: action.identities,
                isSocialBlocked: false
            });
        case 'LOGIN_REQUEST_CHECK_USERNAME_FAILED':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isErrorShown: false,
                isCheckingUsername: false,
                fieldErrors: {
                    email: action.error
                }
            });
        case 'LOGIN_REQUEST_CHECK_USERNAME_ERROR':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isCheckingUsername: false,
                isErrorShown: true,
                error: action.error
            });
        case 'LOGIN_RESET':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isCaptchaRequired: false,
                isSocialBlocked: false,
                isUsernameChecked: false,
                usernameExists: false,
                isV2UsernameChecked: false,
                isV2CheckingUsername: false,
                isErrorShown: false,
                nextAttempt: 1,
                fieldErrors: {},
                identities: undefined,
                v2Accounts: []
            });
        case 'LOGIN_REQUEST_USERNAME_PASSWORD_LOGIN':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isErrorShown: false,
                isLoggingIn: true,
                fieldErrors: {}
            });
        case 'LOGIN_REQUEST_USERNAME_PASSWORD_LOGIN_FAILED':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isErrorShown: true,
                isLoggingIn: false,
                error: action.error
            });
        case 'LOGIN_REQUEST_USERNAME_PASSWORD_LOGIN_SUCCESS':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isErrorShown: false,
                isLoggingIn: false,
                fieldErrors: {},
                redirectUrl: action.redirectUrl
            });
        case 'LOGIN_REQUEST_PASSWORDLESS_LOGIN':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isErrorShown: false,
                isLoggingIn: true,
                fieldErrors: {}
            });
        case 'LOGIN_REQUEST_PASSWORDLESS_LOGIN_FAILED':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isErrorShown: true,
                isLoggingIn: false,
                error: action.error
            });
        case 'LOGIN_REQUEST_PASSWORDLESS_LOGIN_SUCCESS':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isErrorShown: false,
                isLoggingIn: false,
                fieldErrors: {}
            });
        case 'LOGIN_REDIRECT_USER':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isErrorShown: false,
                isLoggingIn: false,
                fieldErrors: {},
                redirectUrl: action.redirectUrl
            });
        case 'LOGIN_SHOW_LOGIN_FORM_ERRORS':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                fieldErrors: action.errors
            });
        case 'UPDATE_LOGIN_ATTEMPT_DETAILS':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                nextAttempt: action.nextAttempt
            });
        case 'LOGIN_UPDATE_CAPTCHA_REQUIREMENT':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isCaptchaRequired: action.isCaptchaRequired
            });
        case 'LOGIN_SET_STATE':
            var _action_state_login, _action_state_login1, _action_state_login2, _action_state_login3;
            return (0, $1Fos3._)({}, state, ((_action_state_login = action.state.login) === null || _action_state_login === void 0 ? void 0 : _action_state_login.error) && {
                error: action.state.login.error
            }, ((_action_state_login1 = action.state.login) === null || _action_state_login1 === void 0 ? void 0 : _action_state_login1.fieldErrors) && {
                fieldErrors: action.state.login.fieldErrors
            }, ((_action_state_login2 = action.state.login) === null || _action_state_login2 === void 0 ? void 0 : _action_state_login2.recoveryToken) && {
                recoveryToken: (_action_state_login3 = action.state.login) === null || _action_state_login3 === void 0 ? void 0 : _action_state_login3.recoveryToken
            });
        case 'REMOVE_REMEMBERED_ACCOUNT_REQUEST_INITIATE':
            {
                const { accountIds: accountIds } = action.payload;
                return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                    rememberedAccounts: state.rememberedAccounts.filter((account)=>!accountIds.includes(account.accountId))
                });
            }
        case 'REMOVE_REMEMBERED_ACCOUNT_REQUEST_SUCCESS':
        case 'REMOVE_REMEMBERED_ACCOUNT_REQUEST_FAILED':
            // Update the state based on the response from the backend, which updates the UI.
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                rememberedAccountsResponseCodes: [
                    ...state.rememberedAccountsResponseCodes || [],
                    action.payload.response
                ]
            });
        case 'RESET_REMEMBERED_ACCOUNT_RESPONSE_CODES':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                rememberedAccountsResponseCodes: []
            });
        case 'REMEMBER_ME_CHECKBOX_UPDATE':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isRememberMeChecked: action.payload.enabled
            });
        case 'REMEMBER_ME_CHECKBOX_TOGGLE':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isRememberMeChecked: !state.isRememberMeChecked
            });
        case 'RESET_REMEMBER_ME_STATE':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isRememberMeChecked: false,
                isCheckingUsername: false,
                isUsernameChecked: false
            });
        default:
            return state;
    }
};
var $30ebf37732a4904c$export$2e2bcd8739ae039 = $30ebf37732a4904c$var$login;

});
parcelRegister("gtKO2", function(module, exports) {

$parcel$export(module.exports, "CheckUserNameRedirectType", function () { return $a0255ca9ea79d308$export$8ef54b27f2e9d22a; });
$parcel$export(module.exports, "CheckUserNamePasswordlessType", function () { return $a0255ca9ea79d308$export$b660b4f2246928fd; });
$parcel$export(module.exports, "SocialProvider", function () { return $a0255ca9ea79d308$export$9368509e79aec5d3; });
$parcel$export(module.exports, "OidcDisplay", function () { return $a0255ca9ea79d308$export$979d11be6cba8f4d; });
$parcel$export(module.exports, "VerificationType", function () { return $a0255ca9ea79d308$export$ca9df54f128b4fc3; });
$parcel$export(module.exports, "VerifyOrReverifyEmailError", function () { return $a0255ca9ea79d308$export$900620e02700dc8d; });
$parcel$export(module.exports, "WelcomeError", function () { return $a0255ca9ea79d308$export$b3e1628b2fcac0ef; });
$parcel$export(module.exports, "WelcomeSentError", function () { return $a0255ca9ea79d308$export$8681a4e3b8216bf1; });
$parcel$export(module.exports, "RedirectType", function () { return $a0255ca9ea79d308$export$901f7b7cba88b6fd; });
$parcel$export(module.exports, "MfaFlow", function () { return $a0255ca9ea79d308$export$dfa50caeee289030; });
$parcel$export(module.exports, "KnownRecoveryEmailErrorReasons", function () { return $a0255ca9ea79d308$export$617703099de92392; });
var $a0255ca9ea79d308$export$8ef54b27f2e9d22a = /*#__PURE__*/ function(CheckUserNameRedirectType) {
    CheckUserNameRedirectType["Sso"] = "sso";
    CheckUserNameRedirectType["EmailSent"] = "email_sent";
    return CheckUserNameRedirectType;
}({});
var $a0255ca9ea79d308$export$b660b4f2246928fd = /*#__PURE__*/ function(CheckUserNamePasswordlessType) {
    CheckUserNamePasswordlessType["Disallowed"] = "disallowed";
    CheckUserNamePasswordlessType["Allowed"] = "allowed";
    return CheckUserNamePasswordlessType;
}({});
var $a0255ca9ea79d308$export$9368509e79aec5d3 = /*#__PURE__*/ function(SocialProvider) {
    SocialProvider["Google"] = "google";
    SocialProvider["Microsoft"] = "microsoft";
    SocialProvider["Apple"] = "apple";
    SocialProvider["Slack"] = "slack";
    return SocialProvider;
}({});
var $a0255ca9ea79d308$export$979d11be6cba8f4d = /*#__PURE__*/ function(OidcDisplay) {
    OidcDisplay["Login"] = "login";
    OidcDisplay["Signup"] = "signup";
    OidcDisplay["Continue"] = "continue";
    OidcDisplay["LoginWithRedirect"] = "login_with_redirect";
    OidcDisplay["Reverify"] = "reverify";
    OidcDisplay["ManageSessions"] = "manage_sessions";
    return OidcDisplay;
}({});
var $a0255ca9ea79d308$export$ca9df54f128b4fc3 = /*#__PURE__*/ function(VerificationType) {
    VerificationType["Verify"] = "verify";
    VerificationType["VerifyWithSoftSession"] = "verifyWithSoftSession";
    VerificationType["Reverify"] = "reverify";
    return VerificationType;
}({});
var $a0255ca9ea79d308$export$900620e02700dc8d = /*#__PURE__*/ function(VerifyOrReverifyEmailError) {
    VerifyOrReverifyEmailError["ExpiredToken"] = "expired_token_error";
    VerifyOrReverifyEmailError["InvalidToken"] = "invalid_token_error";
    VerifyOrReverifyEmailError["RateLimitExceeded"] = "ratelimit_exceeded_error";
    return VerifyOrReverifyEmailError;
}({});
var $a0255ca9ea79d308$export$b3e1628b2fcac0ef = /*#__PURE__*/ function(WelcomeError) {
    WelcomeError["RateLimitExceeded"] = "rate_limit_exceeded";
    return WelcomeError;
}({});
var $a0255ca9ea79d308$export$8681a4e3b8216bf1 = /*#__PURE__*/ function(WelcomeSentError) {
    WelcomeSentError["ExpiredToken"] = "expired_token";
    WelcomeSentError["InvalidToken"] = "invalid_token";
    return WelcomeSentError;
}({});
var $a0255ca9ea79d308$export$901f7b7cba88b6fd = /*#__PURE__*/ function(RedirectType) {
    RedirectType["ResumeMigration"] = "resume_migration";
    RedirectType["Migration"] = "migration";
    RedirectType["Signup"] = "signup";
    RedirectType["ResumeSignup"] = "resume_signup";
    RedirectType["Invite"] = "invite";
    return RedirectType;
}({});
const $a0255ca9ea79d308$export$af8c96aed1523ade = [
    'internal_server_error',
    'bad_request',
    'not_found',
    'csrf_token_mismatch'
];
function $a0255ca9ea79d308$export$390d5c1cc6047864(error) {
    // Need to typecast because T[].includes(X) -> X always needs to be of type T
    return $a0255ca9ea79d308$export$af8c96aed1523ade.includes(error);
}
var $a0255ca9ea79d308$export$12df27b025e392f8 = /*#__PURE__*/ function(SecurityKeyAuthenticatorAttachment) {
    SecurityKeyAuthenticatorAttachment["Platform"] = "platform";
    SecurityKeyAuthenticatorAttachment["CrossPlatform"] = "cross-platform";
    return SecurityKeyAuthenticatorAttachment;
}({});
var $a0255ca9ea79d308$export$dfa50caeee289030 = /*#__PURE__*/ function(MfaFlow) {
    MfaFlow["Sms"] = "sms";
    MfaFlow["Totp"] = "totp";
    MfaFlow["SecurityKey"] = "security_key";
    return MfaFlow;
}({});
const $a0255ca9ea79d308$export$617703099de92392 = [
    'userNotFound',
    'userIsManaged',
    'alreadyRequested'
];

});


parcelRegister("eSSZz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c33160e23d305fe$export$2e2bcd8739ae039; });
const $8c33160e23d305fe$export$49d5fc8cba920a0 = {
    autoSubmit: false
};
const $8c33160e23d305fe$var$logout = (state = $8c33160e23d305fe$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $8c33160e23d305fe$export$2e2bcd8739ae039 = $8c33160e23d305fe$var$logout;

});

parcelRegister("byv62", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e863e67a8527cff7$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");
const $e863e67a8527cff7$export$49d5fc8cba920a0 = {
    config: undefined
};
const $e863e67a8527cff7$var$marketingConsent = (state = $e863e67a8527cff7$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'UPDATE_MARKETING_CONSENT_CONFIG':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                config: action.config
            });
        default:
            return state;
    }
};
var $e863e67a8527cff7$export$2e2bcd8739ae039 = $e863e67a8527cff7$var$marketingConsent;

});

parcelRegister("aZRl3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d839b3707aef7088$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $gtKO2 = parcelRequire("gtKO2");
const $d839b3707aef7088$export$49d5fc8cba920a0 = {
    invalid: false,
    enrollStarted: false,
    enrollConfirmed: false,
    token: '',
    redirectUrl: null,
    recoveryCode: null,
    transactionToken: null,
    unsupportedCountries: []
};
var $d839b3707aef7088$export$2e2bcd8739ae039 = (state = $d839b3707aef7088$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'START_ENROLL':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                token: action.token,
                mfaFlow: (0, $gtKO2.MfaFlow).Totp
            });
        case 'START_ENROLL_RESPONSE':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                enrollStarted: true,
                transactionToken: action.transactionToken,
                emailAddress: action.emailAddress,
                totpSecret: action.totpSecret,
                recoveryCode: action.recoveryCode,
                totpUri: action.totpUri
            });
        case 'CONFIRM_ENROLL':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                confirmingEnroll: true,
                invalid: false
            });
        case 'CONFIRM_ENROLL_RESPONSE':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                enrollConfirmed: true,
                confirmingEnroll: false,
                redirectUrl: action.redirectUrl
            });
        case 'CONFIRM_ENROLL_ERROR':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                confirmingEnroll: false,
                invalid: true
            });
        case 'START_SMS_ENROLL':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                token: action.token,
                phoneNumber: action.phoneNumber,
                mfaFlow: (0, $gtKO2.MfaFlow).Sms
            });
        case 'START_SMS_ENROLL_RESPONSE':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                transactionToken: action.transactionToken,
                recoveryCode: action.recoveryCode,
                smsEnrollError: null,
                phoneNumber: action.phoneNumber
            });
        case 'START_SMS_ENROLL_ERROR':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                smsEnrollError: action.smsEnrollError,
                transactionToken: null,
                recoveryCode: null
            });
        case 'UPDATE_SMS_ENROLLMENT_UNSUPPORTED_COUNTRIES':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                unsupportedCountries: action.unsupportedCountries
            });
        case 'RESET_SMS_ENROLL_ERROR':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                smsEnrollError: null
            });
        case 'START_SECURITY_KEY_ENROLL':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                token: action.token,
                mfaFlow: (0, $gtKO2.MfaFlow).SecurityKey
            });
        case 'CONFIRM_SECURITY_KEY_ENROLLMENT':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                recoveryCode: action.recoveryCode
            });
        default:
            return state;
    }
};

});

parcelRegister("g3uqB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3109a418cd89340e$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");
const $3109a418cd89340e$export$49d5fc8cba920a0 = {
    redirectTo: null
};
var $3109a418cd89340e$export$2e2bcd8739ae039 = (state = $3109a418cd89340e$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'MFA_PROMOTE_REDIRECT':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                redirectTo: action.redirectTo
            });
        default:
            return state;
    }
};

});

parcelRegister("8Yngm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12b173878cba6a30$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");
const $12b173878cba6a30$export$49d5fc8cba920a0 = {
    oidcContext: undefined,
    isEmbedded: false,
    isAnyMobile: false,
    isMobileApp: false,
    screenSize: 'unknown'
};
const $12b173878cba6a30$var$microbranding = (state = $12b173878cba6a30$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'MICROBRANDING_UPDATE':
            return (0, $1Fos3._)({}, state, action.microbranding);
        case 'SCREEN_SIZE_UPDATED':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                screenSize: action.screenSize
            });
        default:
            return state;
    }
};
var $12b173878cba6a30$export$2e2bcd8739ae039 = $12b173878cba6a30$var$microbranding;

});

parcelRegister("5KunI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89ac482399c5e411$export$2e2bcd8739ae039; });
const $89ac482399c5e411$export$49d5fc8cba920a0 = {
    redirectTo: ''
};
const $89ac482399c5e411$var$migrateConfirmation = (state = $89ac482399c5e411$export$49d5fc8cba920a0)=>{
    return state;
};
var $89ac482399c5e411$export$2e2bcd8739ae039 = $89ac482399c5e411$var$migrateConfirmation;

});

parcelRegister("UKWGN", function(module, exports) {

$parcel$export(module.exports, "defaultState", function () { return $37bbd9ed18ef18a8$export$49d5fc8cba920a0; });
$parcel$export(module.exports, "default", function () { return $37bbd9ed18ef18a8$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");
const $37bbd9ed18ef18a8$export$49d5fc8cba920a0 = {
    email: '',
    fieldErrors: {},
    isLoading: false,
    isManaged: true,
    isRecoveryEmailSent: false
};
var $37bbd9ed18ef18a8$export$2e2bcd8739ae039 = (state = $37bbd9ed18ef18a8$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'MFA_VERIFICATION_VERIFY':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                fieldErrors: {},
                isLoading: true
            });
        case 'MFA_VERIFICATION_RECOVER':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                fieldErrors: {},
                isLoading: true
            });
        case 'MFA_VERIFICATION_RECOVER_RESPONSE':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                recoveryCode: action.recoveryCode
            });
        case 'MFA_VERIFICATION_VERIFY_ERROR':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isLoading: false,
                fieldErrors: {
                    otpCode: {
                        errorCode: action.errorCode,
                        message: action.message
                    }
                }
            });
        case 'MFA_VERIFICATION_RECOVER_ERROR':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isLoading: false,
                fieldErrors: {
                    recoveryCode: {
                        errorCode: action.errorCode,
                        message: action.message
                    }
                }
            });
        case 'RECOVERY_EMAIL_SENT':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isRecoveryEmailSent: true
            });
        case 'RECOVERY_EMAIL_START':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                recoveryEmailError: undefined
            });
        case 'RECOVERY_EMAIL_ERROR':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                recoveryEmailError: action.reason
            });
        case 'USER_MANAGED_STATUS':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isManaged: action.isManaged
            });
        case 'MFA_RESET_OTP_INPUT':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                clearInputTrigger: Date.now(),
                fieldErrors: {}
            });
        default:
            return state;
    }
};

});

parcelRegister("jCe7t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $024f87ecb7a97142$export$2e2bcd8739ae039; });

var $gtKO2 = parcelRequire("gtKO2");
const $024f87ecb7a97142$export$49d5fc8cba920a0 = {
    error: null,
    email: '',
    redirectType: (0, $gtKO2.RedirectType).ResumeMigration,
    showBrowserWarning: false
};
const $024f87ecb7a97142$var$welcomeSent = (state = $024f87ecb7a97142$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $024f87ecb7a97142$export$2e2bcd8739ae039 = $024f87ecb7a97142$var$welcomeSent;

});

parcelRegister("dJcgK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5de9ce9f301f98e6$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");
const $5de9ce9f301f98e6$export$49d5fc8cba920a0 = {
    error: null,
    fieldErrors: {},
    redirectTo: null,
    isLoading: false
};
const $5de9ce9f301f98e6$var$recovery = (state = $5de9ce9f301f98e6$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'TSV_RECOVERY_RESET':
            return $5de9ce9f301f98e6$export$49d5fc8cba920a0;
        case 'TSV_RECOVERY_LOGIN_REQUEST_LINK_REDIRECT':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                fieldErrors: {},
                error: null,
                redirectTo: action.redirectTo,
                isLoading: true
            });
        case 'TSV_RECOVERY_REQUEST_FAILED':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                error: action.error,
                isLoading: false
            });
        case 'TSV_RECOVERY_SHOW_FIELD_ERRORS':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                fieldErrors: action.error,
                isLoading: false
            });
        default:
            return state;
    }
};
var $5de9ce9f301f98e6$export$2e2bcd8739ae039 = $5de9ce9f301f98e6$var$recovery;

});

parcelRegister("l4asD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bba514e8b21b9c67$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");
const $bba514e8b21b9c67$export$49d5fc8cba920a0 = {
    error: undefined,
    fieldErrors: {},
    isLoading: false,
    isSent: false
};
const $bba514e8b21b9c67$var$resetPassword = (state = $bba514e8b21b9c67$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'RESET_PASSWORD_RESET':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                error: undefined,
                isLoading: false,
                isSent: false
            });
        case 'RESET_PASSWORD_REQUEST_LINK':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                error: undefined,
                isLoading: true,
                isSent: false
            });
        case 'RESET_PASSWORD_REQUEST_LINK_SUCCESS':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                error: undefined,
                isLoading: false,
                isSent: true
            });
        case 'RESET_PASSWORD_REQUEST_LINK_REDIRECT':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                error: undefined,
                isLoading: true,
                isSent: false,
                redirectTo: action.redirectTo
            });
        case 'RESET_PASSWORD_ERROR':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                error: action.error,
                isLoading: false,
                isSent: false
            });
        case 'RESET_PASSWORD_REQUEST_LINK_FAILED_WITH_FIELD_ERRORS':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                fieldErrors: action.fieldErrors,
                isLoading: false,
                isSent: false
            });
        default:
            return state;
    }
};
var $bba514e8b21b9c67$export$2e2bcd8739ae039 = $bba514e8b21b9c67$var$resetPassword;

});

parcelRegister("kldA7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d61e09673d8564b$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");
const $8d61e09673d8564b$export$49d5fc8cba920a0 = {
    sessions: null
};
const $8d61e09673d8564b$var$selectAccount = (state = $8d61e09673d8564b$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'SESSION_REQUEST':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isLoading: true
            });
        default:
            return state;
    }
};
var $8d61e09673d8564b$export$2e2bcd8739ae039 = $8d61e09673d8564b$var$selectAccount;

});

parcelRegister("gMqGE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24eeecf9bc858749$export$2e2bcd8739ae039; });
const $24eeecf9bc858749$export$49d5fc8cba920a0 = null;
const $24eeecf9bc858749$var$serverErrorReducer = (state = $24eeecf9bc858749$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'SERVER_ERROR_UPDATE':
            return action.error;
        default:
            return state;
    }
};
var $24eeecf9bc858749$export$2e2bcd8739ae039 = $24eeecf9bc858749$var$serverErrorReducer;

});

parcelRegister("7me1n", function(module, exports) {

$parcel$export(module.exports, "defaultState", function () { return $231452aa2b0597f9$export$49d5fc8cba920a0; });
$parcel$export(module.exports, "default", function () { return $231452aa2b0597f9$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");
const $231452aa2b0597f9$export$49d5fc8cba920a0 = {
    error: null,
    fieldErrors: {},
    isLoading: false,
    redirectTo: null,
    autoSubmit: false
};
const $231452aa2b0597f9$var$signup = (state = $231452aa2b0597f9$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'SIGNUP_RESET':
            return $231452aa2b0597f9$export$49d5fc8cba920a0;
        case 'SIGNUP_REQUEST':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                error: null,
                fieldErrors: {},
                isLoading: true
            });
        case 'SIGNUP_REQUEST_SUCCESS':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isLoading: false,
                fieldErrors: {},
                redirectTo: action.redirectTo
            });
        case 'SIGNUP_REQUEST_FAILED':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                error: action.error,
                isLoading: false
            });
        case 'SIGNUP_SHOW_FIELD_ERRORS':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                fieldErrors: action.errors,
                isLoading: false
            });
        default:
            return state;
    }
};
var $231452aa2b0597f9$export$2e2bcd8739ae039 = $231452aa2b0597f9$var$signup;

});

parcelRegister("dMSXm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $faa4b90bf3d191ce$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");
const $faa4b90bf3d191ce$export$49d5fc8cba920a0 = {
    error: null,
    fieldErrors: {},
    isLoading: false,
    redirectTo: null,
    autoSubmit: false
};
const $faa4b90bf3d191ce$var$signupOnboard = (state = $faa4b90bf3d191ce$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'SIGNUP_ONBOARD_RESET':
            return $faa4b90bf3d191ce$export$49d5fc8cba920a0;
        case 'SIGNUP_ONBOARD_REQUEST':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                error: null,
                fieldErrors: {},
                isLoading: true
            });
        case 'SIGNUP_ONBOARD_REQUEST_SUCCESS':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isLoading: false,
                fieldErrors: {},
                redirectTo: action.redirectTo
            });
        case 'SIGNUP_ONBOARD_REQUEST_FAILED':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                error: action.error,
                isLoading: false
            });
        case 'SIGNUP_ONBOARD_SHOW_FIELD_ERRORS':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                fieldErrors: action.errors,
                isLoading: false
            });
        default:
            return state;
    }
};
var $faa4b90bf3d191ce$export$2e2bcd8739ae039 = $faa4b90bf3d191ce$var$signupOnboard;

});

parcelRegister("jtxsP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6b562f5e3bc3d1f$export$2e2bcd8739ae039; });
const $f6b562f5e3bc3d1f$export$49d5fc8cba920a0 = {};
const $f6b562f5e3bc3d1f$var$socialLoginRecovery = (state = $f6b562f5e3bc3d1f$export$49d5fc8cba920a0)=>state;
var $f6b562f5e3bc3d1f$export$2e2bcd8739ae039 = $f6b562f5e3bc3d1f$var$socialLoginRecovery;

});

parcelRegister("50ywh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4eb427ad190b1e25$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");
const $4eb427ad190b1e25$export$49d5fc8cba920a0 = {
    email: '',
    mfaToken: '',
    orgName: null,
    token: null
};
const $4eb427ad190b1e25$var$stepUp = (state = $4eb427ad190b1e25$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'STEP_UP_RESEND_CODE_SUCCESS':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                mfaToken: action.mfaToken
            });
        case 'STEP_UP_SEND_CODE_SUCCESS':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                mfaToken: action.mfaToken
            });
        case 'STEP_UP_MFA_TOKEN_LOAD_FROM_SESSION_STORAGE':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                mfaToken: action.mfaToken
            });
        default:
            return state;
    }
};
var $4eb427ad190b1e25$export$2e2bcd8739ae039 = $4eb427ad190b1e25$var$stepUp;

});

parcelRegister("jq2RY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $822bd359c5368454$export$2e2bcd8739ae039; });
const $822bd359c5368454$export$49d5fc8cba920a0 = {
    ssoRedirectUrl: undefined,
    idp: {
        trusted: false,
        humanReadableRedirectLocation: undefined
    }
};
const $822bd359c5368454$var$stepUpSso = (state = $822bd359c5368454$export$49d5fc8cba920a0, _action)=>{
    return state;
};
var $822bd359c5368454$export$2e2bcd8739ae039 = $822bd359c5368454$var$stepUpSso;

});

parcelRegister("joMJe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $deb0b8310dd567d9$export$2e2bcd8739ae039; });
const $deb0b8310dd567d9$export$49d5fc8cba920a0 = {
    email: ''
};
const $deb0b8310dd567d9$var$user = (state = $deb0b8310dd567d9$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $deb0b8310dd567d9$export$2e2bcd8739ae039 = $deb0b8310dd567d9$var$user;

});

parcelRegister("cSbax", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $635be1aff5b67b96$export$2e2bcd8739ae039; });

var $gtKO2 = parcelRequire("gtKO2");
const $635be1aff5b67b96$export$49d5fc8cba920a0 = {
    verificationType: (0, $gtKO2.VerificationType).Verify,
    url: '#',
    error: (0, $gtKO2.VerifyOrReverifyEmailError).ExpiredToken
};
const $635be1aff5b67b96$var$verifyEmail = (state = $635be1aff5b67b96$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $635be1aff5b67b96$export$2e2bcd8739ae039 = $635be1aff5b67b96$var$verifyEmail;

});

parcelRegister("6jKHi", function(module, exports) {

$parcel$export(module.exports, "defaultState", function () { return $c810cb1157f5f217$export$49d5fc8cba920a0; });
$parcel$export(module.exports, "default", function () { return $c810cb1157f5f217$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $gtKO2 = parcelRequire("gtKO2");
const $c810cb1157f5f217$export$49d5fc8cba920a0 = {
    email: '',
    isLoading: false,
    redirectType: (0, $gtKO2.RedirectType).Signup
};
const $c810cb1157f5f217$var$verifyEmailOtp = (state = $c810cb1157f5f217$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'VERIFY_EMAIL_OTP_REQUEST':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isLoading: true,
                error: undefined,
                redirectTo: undefined
            });
        case 'VERIFY_EMAIL_OTP_SUCCESS':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                redirectTo: action.redirectTo
            });
        case 'VERIFY_EMAIL_OTP_FAILURE':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isLoading: false,
                error: action.error
            });
        case 'VERIFY_EMAIL_OTP_SET_STATE':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                email: action.state.email
            });
        default:
            return state;
    }
};
var $c810cb1157f5f217$export$2e2bcd8739ae039 = $c810cb1157f5f217$var$verifyEmailOtp;

});

parcelRegister("ScDHm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $723eb268757c8464$export$2e2bcd8739ae039; });

var $gtKO2 = parcelRequire("gtKO2");
const $723eb268757c8464$export$49d5fc8cba920a0 = {
    verificationType: (0, $gtKO2.VerificationType).Verify,
    showBrowserWarning: false
};
const $723eb268757c8464$var$verifyEmailSent = (state = $723eb268757c8464$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $723eb268757c8464$export$2e2bcd8739ae039 = $723eb268757c8464$var$verifyEmailSent;

});

parcelRegister("1KCn1", function(module, exports) {

$parcel$export(module.exports, "defaultState", function () { return $844fd68dffa9deaf$export$49d5fc8cba920a0; });
$parcel$export(module.exports, "default", function () { return $844fd68dffa9deaf$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $gtKO2 = parcelRequire("gtKO2");

var $dU56v = parcelRequire("dU56v");
const $844fd68dffa9deaf$export$49d5fc8cba920a0 = {
    error: null,
    formError: null,
    fieldErrors: {},
    isLoading: false,
    isMobile: (0, $dU56v.detectClient)().atlassianMobileApp,
    redirectTo: null,
    redirectType: (0, $gtKO2.RedirectType).Migration,
    email: '',
    shouldSkipCaptcha: false
};
const $844fd68dffa9deaf$var$welcome = (state = $844fd68dffa9deaf$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'WELCOME_SIGNUP_RESET':
            return $844fd68dffa9deaf$export$49d5fc8cba920a0;
        case 'WELCOME_SIGNUP_REQUEST':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                error: null,
                formError: null,
                fieldErrors: {},
                isLoading: true
            });
        case 'WELCOME_SIGNUP_REQUEST_SUCCESS':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                isLoading: false,
                fieldErrors: {},
                redirectTo: action.redirectTo
            });
        case 'WELCOME_SIGNUP_REQUEST_FAILED':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                error: null,
                formError: action.formError,
                isLoading: false
            });
        case 'WELCOME_SIGNUP_SHOW_FIELD_ERRORS':
            return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                fieldErrors: action.errors,
                isLoading: false
            });
        case 'WELCOME_SIGNUP_SET_STATE':
            return (0, $1Fos3._)((0, $b2I6k._)((0, $1Fos3._)({}, state, action.state.recoveryToken && {
                recoveryToken: action.state.recoveryToken
            }), {
                redirectType: action.state.redirectType,
                shouldSkipCaptcha: action.state.shouldSkipCaptcha,
                email: action.state.email
            }), action.state.displayName && {
                displayName: action.state.displayName
            });
        default:
            return state;
    }
};
var $844fd68dffa9deaf$export$2e2bcd8739ae039 = $844fd68dffa9deaf$var$welcome;

});
parcelRegister("dU56v", function(module, exports) {

$parcel$export(module.exports, "detectClient", function () { return $19a5fc4ec07d0c92$export$dbd7930c526235a3; });
const $19a5fc4ec07d0c92$var$userAgent = navigator.userAgent || navigator.vendor || window.opera;
const $19a5fc4ec07d0c92$export$b7eb5c075a7422f3 = ()=>{
    if (/windows phone/i.test($19a5fc4ec07d0c92$var$userAgent)) return 'windows phone';
    if (/android/i.test($19a5fc4ec07d0c92$var$userAgent)) return 'android';
    if (/iPad|iPhone|iPod/.test($19a5fc4ec07d0c92$var$userAgent) && !window.MSStream) return 'ios';
    return 'unknown';
};
const $19a5fc4ec07d0c92$export$dbd7930c526235a3 = ()=>{
    return {
        platform: $19a5fc4ec07d0c92$export$b7eb5c075a7422f3(),
        atlassianMobileApp: /AtlassianMobileApp/i.test($19a5fc4ec07d0c92$var$userAgent)
    };
};

});


parcelRegister("MAUh6", function(module, exports) {

$parcel$export(module.exports, "defaultState", function () { return $acaf5fd89ebafb30$export$49d5fc8cba920a0; });
$parcel$export(module.exports, "default", function () { return $acaf5fd89ebafb30$export$2e2bcd8739ae039; });
const $acaf5fd89ebafb30$export$49d5fc8cba920a0 = {
    consentType: undefined
};
const $acaf5fd89ebafb30$var$loginConsent = (state = $acaf5fd89ebafb30$export$49d5fc8cba920a0)=>{
    return state;
};
var $acaf5fd89ebafb30$export$2e2bcd8739ae039 = $acaf5fd89ebafb30$var$loginConsent;

});

parcelRegister("8qpC8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1edbf235085c161$export$2e2bcd8739ae039; });
const $b1edbf235085c161$var$globalStateLoading = (state = false, action)=>{
    if (action.type === 'SET_GLOBAL_STATE_LOADING') return action.isLoading;
    return state;
};
var $b1edbf235085c161$export$2e2bcd8739ae039 = $b1edbf235085c161$var$globalStateLoading;

});


parcelRegister("evZqI", function(module, exports) {

$parcel$export(module.exports, "idAuthMfaMiddleware", function () { return $d6a04d985fff3b7f$export$9c3b774af0e8f6c4; });

var $1Fos3 = parcelRequire("1Fos3");

var $6d87w = parcelRequire("6d87w");

var $dBq8m = parcelRequire("dBq8m");

var $2ipGE = parcelRequire("2ipGE");

var $49Pnv = parcelRequire("49Pnv");

var $21Xgy = parcelRequire("21Xgy");

var $klwqV = parcelRequire("klwqV");

var $bqdjD = parcelRequire("bqdjD");

var $lodUs = parcelRequire("lodUs");

var $gCn4g = parcelRequire("gCn4g");

var $fYxRW = parcelRequire("fYxRW");
const $d6a04d985fff3b7f$export$9c3b774af0e8f6c4 = ({ dispatch: dispatch })=>(next)=>(action)=>{
            switch(action.type){
                case 'MFA_VERIFICATION_VERIFY':
                    next(action);
                    // The action that calls fetch (/verify) and redirects
                    return dispatch($d6a04d985fff3b7f$export$5d2dfc489f5d5678(action));
                case 'MFA_VERIFICATION_RESEND_OTP':
                    next(action);
                    // The action that calls fetch to resend OTP code
                    // Transport (i.e. via SMS or Email) is determined by the mfa token.
                    return dispatch($d6a04d985fff3b7f$export$6a7404e2291306ab(action));
                case 'MFA_VERIFICATION_RECOVER':
                    next(action);
                    // The action that verifies recovery code
                    return dispatch($d6a04d985fff3b7f$export$d76d4fe28235a83(action));
                case 'MFA_VERIFICATION_CONFIRMED_RECOVER':
                    next(action);
                    // The action that calls /mfa/authorize and redirects
                    return dispatch($d6a04d985fff3b7f$export$8cfa5c421bdc24ae(action));
                case 'MFA_VERIFICATION_CHANGE_FACTOR':
                    next(action);
                    // The action that calls /mfa/change to switch MFA factors
                    return dispatch($d6a04d985fff3b7f$export$38c17aec706fc109(action));
                default:
                    next(action);
            }
        };
const $d6a04d985fff3b7f$export$6a7404e2291306ab = ({ params: params, analyticsClient: analyticsClient, navigate: navigate, mfaMethod: mfaMethod })=>async (dispatch, getState)=>{
        try {
            const response = await fetch(`/rest/mfa/resend${params}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': getState().csrfToken
                }
            });
            const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(params);
            switch(response.status){
                case 200:
                    const { transactionToken: transactionToken } = await response.json();
                    navigate({
                        search: `?${new URLSearchParams({
                            transactionToken: transactionToken
                        })}`
                    }, {
                        replace: true
                    });
                    if (mfaMethod === 'email-otp') dispatch((0, $21Xgy.addFlag)('success', (0, $klwqV.default).mfEmailResentSuccessTitle, (0, $klwqV.default).mfEmailResentSuccessDesc));
                    else dispatch((0, $21Xgy.addFlag)('success', (0, $klwqV.default).mfRecoverySMSResentSuccessTitle, (0, $klwqV.default).mfRecoverySMSResentSuccessDesc));
                    break;
                case 400:
                    $d6a04d985fff3b7f$var$redirectToLoginErrorOn400IncorrectTokenResponse({
                        analyticsClient: analyticsClient,
                        page: '2svChallengeScreen',
                        subjectId: '2svIncorrectToken',
                        currentQueryParams: queryParams,
                        navigate: navigate
                    });
                    break;
                case 422:
                    analyticsClient.errorShownEvent('2svChallengeScreen', '2svInvalidPhoneNumber');
                    return dispatch((0, $21Xgy.addFlag)('error', (0, $klwqV.default).mfVerifyErrorTitle, (0, $klwqV.default).mfSmsInvalidPhoneNumberDesc));
                case 429:
                    analyticsClient.errorShownEvent('2svChallengeScreen', '2svTooManySms');
                    $d6a04d985fff3b7f$var$handleError(dispatch);
                    break;
                default:
                    const error = await response.text();
                    throw new Error(error || response.statusText);
            }
        } catch (error) {
            analyticsClient.errorShownEvent('2svChallengeScreen', '2svUnknownError');
            $d6a04d985fff3b7f$var$handleError(dispatch);
            (0, $49Pnv.captureException)(error);
        }
    };

const $d6a04d985fff3b7f$export$5d2dfc489f5d5678 = ({ params: params, otpCode: otpCode, analyticsClient: analyticsClient, maybeHardRedirect: maybeHardRedirect })=>async (dispatch, getState)=>{
        try {
            const isCommercial = (0, $bqdjD.getCurrentCloudType)() === 'commercial';
            const token = isCommercial ? await (parcelRequire("jEJQB")).then(async ({ createRequestToken: createRequestToken })=>await createRequestToken()).catch(()=>'') : null;
            const response = await fetch(`/rest/mfa/verify${params}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': getState().csrfToken
                },
                body: JSON.stringify((0, $1Fos3._)({
                    otpCode: otpCode
                }, token && {
                    token: token
                }))
            });
            switch(response.status){
                case 200:
                    {
                        const { transactionToken: transactionToken } = await response.json();
                        const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(params);
                        queryParams.transactionToken = transactionToken;
                        const authorizeResponse = await fetch(`/rest/mfa/authorize?${(0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).stringify(queryParams)}`);
                        if (!authorizeResponse.ok) {
                            const error = await authorizeResponse.text();
                            throw new Error(error || authorizeResponse.statusText);
                        }
                        const { redirectUri: redirectUri } = await authorizeResponse.json();
                        maybeHardRedirect(redirectUri);
                        break;
                    }
                case 400:
                    {
                        const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(params);
                        $d6a04d985fff3b7f$var$redirectToLoginErrorOn400IncorrectTokenResponse({
                            analyticsClient: analyticsClient,
                            page: '2svChallengeScreen',
                            subjectId: '2svIncorrectToken',
                            currentQueryParams: queryParams,
                            navigate: maybeHardRedirect
                        });
                        break;
                    }
                case 403:
                case 429:
                    analyticsClient.errorShownEvent('2svChallengeScreen', '2svIncorrectCode');
                    dispatch((0, $2ipGE.mfaVerifyError)({
                        errorCode: 'invalid_otp',
                        message: 'invalid otp code'
                    }));
                    break;
                default:
                    const error = await response.text();
                    throw new Error(error || response.statusText);
            }
        } catch (error) {
            analyticsClient.errorShownEvent('2svChallengeScreen', '2svUnknownError');
            $d6a04d985fff3b7f$var$handleError(dispatch);
            (0, $49Pnv.captureException)(error);
        }
    };
const $d6a04d985fff3b7f$export$d76d4fe28235a83 = ({ params: params, recoveryCode: recoveryCode, analyticsClient: analyticsClient, navigate: navigate })=>async (dispatch, getState)=>{
        try {
            const response = await fetch(`/rest/mfa/verify/recoverycode${params}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': getState().csrfToken
                },
                body: JSON.stringify({
                    recoveryCode: recoveryCode
                })
            });
            switch(response.status){
                case 200:
                    const { recoveryCode: recoveryCode1, transactionToken: transactionToken } = await response.json();
                    const newParams = {
                        continue: (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(params).continue,
                        transactionToken: transactionToken.toString()
                    };
                    navigate({
                        search: `?${(0, $6d87w.createSearchParams)(newParams)}`
                    }, {
                        replace: true
                    });
                    dispatch((0, $2ipGE.mfaRecoverResponse)({
                        recoveryCode: recoveryCode1
                    }));
                    break;
                case 400:
                    const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(params);
                    $d6a04d985fff3b7f$var$redirectToLoginErrorOn400IncorrectTokenResponse({
                        analyticsClient: analyticsClient,
                        page: '2svRecoveryKeyScreen',
                        subjectId: '2svIncorrectToken',
                        currentQueryParams: queryParams,
                        navigate: navigate
                    });
                    break;
                case 403:
                case 429:
                    analyticsClient.errorShownEvent('2svRecoveryKeyScreen', '2svIncorrectCode');
                    dispatch((0, $2ipGE.mfaRecoverError)({
                        errorCode: 'invalid_recovery_code',
                        message: 'invalid recovery code'
                    }));
                    break;
                default:
                    const error = await response.text();
                    throw new Error(`Unexpected response from POST /rest/mfa/verify/recoverycode: ${error || response.statusText}`);
            }
        } catch (error) {
            analyticsClient.errorShownEvent('2svRecoveryKeyScreen', '2svUnknownError');
            $d6a04d985fff3b7f$var$handleError(dispatch);
            (0, $49Pnv.captureException)(error);
        }
    };
const $d6a04d985fff3b7f$export$8cfa5c421bdc24ae = ({ params: params, analyticsClient: analyticsClient, maybeHardRedirect: maybeHardRedirect })=>async (dispatch)=>{
        try {
            const response = await fetch(`/rest/mfa/authorize${params}`);
            switch(response.status){
                case 200:
                    const { redirectUri: redirectUri } = await response.json();
                    maybeHardRedirect(redirectUri);
                    break;
                case 400:
                case 403:
                    const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(params);
                    $d6a04d985fff3b7f$var$redirectToLoginErrorOn400IncorrectTokenResponse({
                        analyticsClient: analyticsClient,
                        page: '2svSavedNewRecoveryKey',
                        subjectId: '2svIncorrectToken',
                        currentQueryParams: queryParams,
                        navigate: maybeHardRedirect
                    });
                    break;
                default:
                    const error = await response.text();
                    throw new Error(`Unexpected response from GET /rest/mfa/authorize: ${error || response.statusText}`);
            }
        } catch (error) {
            analyticsClient.errorShownEvent('2svSavedNewRecoveryKey', '2svUnknownError');
            $d6a04d985fff3b7f$var$handleError(dispatch);
            (0, $49Pnv.captureException)(error);
        }
    };
const $d6a04d985fff3b7f$var$getSwitchMfaFactorErrorFlagMessages = (reason)=>{
    if (reason) switch(reason){
        case 'invalid_factor_type':
        case 'user_not_enrolled':
            return {
                title: (0, $klwqV.default).mfSwitchFactorInvalidFactorTypeTitle,
                description: (0, $klwqV.default).mfSwitchFactorInvalidFactorTypeDesc
            };
        case 'invalid_transaction_token':
            return {
                title: (0, $klwqV.default).mfSwitchFactorInvalidTokenTitle,
                description: (0, $klwqV.default).mfSwitchFactorInvalidTokenDesc
            };
        case 'expired_transaction_token':
            return {
                title: (0, $klwqV.default).mfSwitchFactorTransactionExpiredTitle,
                description: (0, $klwqV.default).mfSwitchFactorTransactionExpiredDesc
            };
    }
    return {
        title: (0, $klwqV.default).mfSwitchFactorErrorTitle,
        description: (0, $klwqV.default).mfSwitchFactorErrorDesc
    };
};
const $d6a04d985fff3b7f$export$38c17aec706fc109 = ({ params: params, factor: factor, analyticsClient: analyticsClient, navigate: navigate })=>async (dispatch)=>{
        try {
            const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(params);
            const transactionToken = queryParams.transactionToken;
            if (!transactionToken) throw new Error('No transaction token found');
            const response = await fetch(`/rest/mfa/change?transactionToken=${transactionToken}&factor=${factor}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            switch(response.status){
                case 200:
                    {
                        const { token: newTransactionToken } = await response.json();
                        const updatedQueryParamString = (0, $fYxRW.replaceQueryParam)('transactionToken', newTransactionToken);
                        try {
                            const newStateResponse = await fetch(`/rest/login/mfa/state${updatedQueryParamString}`);
                            switch(newStateResponse.status){
                                case 200:
                                    {
                                        // This updates the search query params in the address bar, but does not trigger
                                        // a page reload due to the pathname remains unchanged
                                        // Setting this would ensure the user loads the page with the updated token should
                                        // they refresh (eg. F5) the page
                                        navigate({
                                            search: updatedQueryParamString
                                        });
                                        const newState = await newStateResponse.json();
                                        const transformedState = await (0, $lodUs.buildInitialState)(newState);
                                        dispatch((0, $gCn4g.resetAppState)(transformedState.initialStoreState));
                                        dispatch((0, $2ipGE.resetMfaOtpInput)());
                                        break;
                                    }
                                default:
                                    throw Error(`Unexpected status code when fetching new state after switching MFA factor: ${response.status}`);
                            }
                        } catch (error) {
                            dispatch((0, $21Xgy.addFlag)('error', (0, $klwqV.default).mfSwitchFactorErrorTitle, (0, $klwqV.default).mfSwitchFactorErrorDesc));
                            (0, $49Pnv.captureException)(error);
                        }
                        break;
                    }
                case 400:
                    analyticsClient.errorShownEvent('2svChallengeScreen', '2svSwitchFactorBadRequest');
                    try {
                        var _errorResponse_context;
                        const errorResponse = await response.json();
                        const { title: title, description: description } = $d6a04d985fff3b7f$var$getSwitchMfaFactorErrorFlagMessages(errorResponse === null || errorResponse === void 0 ? void 0 : (_errorResponse_context = errorResponse.context) === null || _errorResponse_context === void 0 ? void 0 : _errorResponse_context.reason);
                        dispatch((0, $21Xgy.addFlag)('error', title, description));
                    } catch (error) {
                        dispatch((0, $21Xgy.addFlag)('error', (0, $klwqV.default).mfSwitchFactorErrorTitle, (0, $klwqV.default).mfSwitchFactorErrorDesc));
                        (0, $49Pnv.captureException)(error);
                    }
                    break;
                case 429:
                    analyticsClient.errorShownEvent('2svChallengeScreen', '2svSwitchFactorTooManyAttempts');
                    dispatch((0, $21Xgy.addFlag)('error', (0, $klwqV.default).mfSwitchFactorTooManyAttemptsTitle, (0, $klwqV.default).mfSwitchFactorTooManyAttemptsDesc));
                    break;
                default:
                    const error = await response.text();
                    throw new Error(error || response.statusText);
            }
        } catch (error) {
            analyticsClient.errorShownEvent('2svChallengeScreen', '2svSwitchFactorUnknownError');
            dispatch((0, $21Xgy.addFlag)('error', (0, $klwqV.default).mfSwitchFactorErrorTitle, (0, $klwqV.default).mfSwitchFactorErrorDesc));
            (0, $49Pnv.captureException)(error);
        }
    };
function $d6a04d985fff3b7f$var$handleError(dispatch) {
    return dispatch((0, $21Xgy.addFlag)('error', (0, $klwqV.default).mfVerifyErrorTitle, (0, $klwqV.default).mfVerifyErrorDesc));
}
function $d6a04d985fff3b7f$var$redirectToLoginErrorOn400IncorrectTokenResponse({ analyticsClient: analyticsClient, page: page, subjectId: subjectId, currentQueryParams: currentQueryParams, navigate: navigate }) {
    analyticsClient.errorShownEvent(page, subjectId);
    delete currentQueryParams.transactionToken;
    delete currentQueryParams.errorCode;
    const currentQueryString = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).stringify(currentQueryParams);
    const extraParamsString = currentQueryString === '' ? '' : `&${currentQueryString}`;
    navigate(`/login?prompt=true&errorCode=login.form.token.expired${extraParamsString}`);
}

});
parcelRegister("2ipGE", function(module, exports) {

$parcel$export(module.exports, "confirmedRecoveryCode", function () { return $4a132263a265f2a7$export$9d6418e9b0c5e37; });
$parcel$export(module.exports, "verifyOtpCode", function () { return $4a132263a265f2a7$export$a5c568dd7addf7ae; });
$parcel$export(module.exports, "resendOtp", function () { return $4a132263a265f2a7$export$fa0ba0eb6a79519c; });
$parcel$export(module.exports, "recoverAccount", function () { return $4a132263a265f2a7$export$5e6ce816cc4182a; });
$parcel$export(module.exports, "mfaRecoverResponse", function () { return $4a132263a265f2a7$export$9034102f3c89e717; });
$parcel$export(module.exports, "mfaVerifyError", function () { return $4a132263a265f2a7$export$2026ab15e46bd57d; });
$parcel$export(module.exports, "mfaRecoverError", function () { return $4a132263a265f2a7$export$3652b92f5dbdf874; });
$parcel$export(module.exports, "switchMfaFactor", function () { return $4a132263a265f2a7$export$3c9096ff6f777303; });
$parcel$export(module.exports, "resetMfaOtpInput", function () { return $4a132263a265f2a7$export$c82f9f96ca3abc9d; });
$parcel$export(module.exports, "sendRecoveryEmail", function () { return $4a132263a265f2a7$export$ad7f1a4d46b544fc; });

var $gtKO2 = parcelRequire("gtKO2");

var $bqdjD = parcelRequire("bqdjD");

var $49Pnv = parcelRequire("49Pnv");
const $4a132263a265f2a7$export$9d6418e9b0c5e37 = (params, analyticsClient, maybeHardRedirect)=>({
        type: 'MFA_VERIFICATION_CONFIRMED_RECOVER',
        params: params,
        analyticsClient: analyticsClient,
        maybeHardRedirect: maybeHardRedirect
    });
const $4a132263a265f2a7$export$a5c568dd7addf7ae = (params, otpCode, analyticsClient, maybeHardRedirect)=>({
        type: 'MFA_VERIFICATION_VERIFY',
        params: params,
        otpCode: otpCode,
        analyticsClient: analyticsClient,
        maybeHardRedirect: maybeHardRedirect
    });
const $4a132263a265f2a7$export$fa0ba0eb6a79519c = (params, analyticsClient, navigate, mfaMethod)=>({
        type: 'MFA_VERIFICATION_RESEND_OTP',
        params: params,
        analyticsClient: analyticsClient,
        navigate: navigate,
        mfaMethod: mfaMethod
    });
const $4a132263a265f2a7$export$5e6ce816cc4182a = (params, recoveryCode, analyticsClient, navigate)=>({
        type: 'MFA_VERIFICATION_RECOVER',
        params: params,
        recoveryCode: recoveryCode,
        analyticsClient: analyticsClient,
        navigate: navigate
    });
const $4a132263a265f2a7$export$9034102f3c89e717 = ({ recoveryCode: recoveryCode })=>({
        type: 'MFA_VERIFICATION_RECOVER_RESPONSE',
        recoveryCode: recoveryCode
    });
const $4a132263a265f2a7$export$2026ab15e46bd57d = ({ errorCode: errorCode, message: message })=>({
        type: 'MFA_VERIFICATION_VERIFY_ERROR',
        errorCode: errorCode,
        message: message
    });
const $4a132263a265f2a7$export$3652b92f5dbdf874 = ({ errorCode: errorCode, message: message })=>({
        type: 'MFA_VERIFICATION_RECOVER_ERROR',
        errorCode: errorCode,
        message: message
    });
const $4a132263a265f2a7$export$b147b2e1028c65fa = ()=>({
        type: 'RECOVERY_EMAIL_SENT'
    });
const $4a132263a265f2a7$export$cc7dfbcab13c5eea = ()=>({
        type: 'RECOVERY_EMAIL_START'
    });
const $4a132263a265f2a7$export$b760122b98e1a9be = (reason)=>({
        type: 'RECOVERY_EMAIL_ERROR',
        reason: reason
    });
const $4a132263a265f2a7$export$3c9096ff6f777303 = (params, factor, analyticsClient, navigate)=>({
        type: 'MFA_VERIFICATION_CHANGE_FACTOR',
        params: params,
        factor: factor,
        analyticsClient: analyticsClient,
        navigate: navigate
    });
const $4a132263a265f2a7$export$c82f9f96ca3abc9d = ()=>({
        type: 'MFA_RESET_OTP_INPUT'
    });
const $4a132263a265f2a7$export$ad7f1a4d46b544fc = (email)=>async (dispatch)=>{
        dispatch($4a132263a265f2a7$export$cc7dfbcab13c5eea());
        try {
            var _body_error;
            const response = await fetch(`${(0, $bqdjD.idacOrigin)}/rest/tsv-recovery/trigger`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: email
                })
            });
            const body = await response.json();
            const errorReason = body === null || body === void 0 ? void 0 : (_body_error = body.error) === null || _body_error === void 0 ? void 0 : _body_error.reason;
            // Note that sing-in-service may return an error reason with a 200 response, in cases where
            // a non-200 response could introduce an account enumeration vulnerability.
            if (response.ok && !errorReason) dispatch($4a132263a265f2a7$export$b147b2e1028c65fa());
            else {
                const narrowedReason = $4a132263a265f2a7$var$narrowErrorReason(errorReason);
                dispatch($4a132263a265f2a7$export$b760122b98e1a9be(narrowedReason));
            }
        } catch (e) {
            (0, $49Pnv.captureException)(e);
            dispatch($4a132263a265f2a7$export$b760122b98e1a9be('unknown'));
        }
    };
const $4a132263a265f2a7$var$isKnownRecoveryEmailErrorReason = (reason)=>(0, $gtKO2.KnownRecoveryEmailErrorReasons).includes(reason);
/** Maps arbitrary string returned by API to a type-safe value compatible with the redux state */ const $4a132263a265f2a7$var$narrowErrorReason = (reason)=>{
    if (reason && $4a132263a265f2a7$var$isKnownRecoveryEmailErrorReason(reason)) return reason;
    return 'unknown';
};

});

parcelRegister("21Xgy", function(module, exports) {

$parcel$export(module.exports, "addFlag", function () { return $bfc9b73834f384b1$export$820a1da46c7a4303; });
$parcel$export(module.exports, "dismissFlag", function () { return $bfc9b73834f384b1$export$900a08a292ad23cd; });

var $8giud = parcelRequire("8giud");
const $bfc9b73834f384b1$export$820a1da46c7a4303 = (type, title, description)=>({
        type: 'FLAG_ADD',
        flag: {
            type: type,
            title: title,
            description: description,
            id: (0, (/*@__PURE__*/$parcel$interopDefault($8giud))).v4()
        }
    });
const $bfc9b73834f384b1$export$900a08a292ad23cd = ()=>({
        type: 'FLAG_DISMISS'
    });

});

parcelRegister("klwqV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3efc09458ebe1d58$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $3efc09458ebe1d58$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    loginHeadTitle: {
        id: 'mf.login.head.title',
        defaultMessage: 'Continue with multi-factor authentication',
        description: ''
    },
    // Flags
    mfRecoveryEmailResentSuccessTitle: {
        id: 'mf.recoveryemailresentsuccess.title',
        defaultMessage: 'Recovery email resent!',
        description: ''
    },
    mfRecoveryEmailResentSuccessDesc: {
        id: 'mf.recoveryemailresentsuccess',
        defaultMessage: 'A recovery email has been resent to you!',
        description: ''
    },
    mfRecoveryEmailResentErrorTitle: {
        id: 'mf.recoveryemailresenterror.title',
        defaultMessage: 'Something went wrong.',
        description: ''
    },
    mfRecoveryEmailResentErrorDesc: {
        id: 'mf.recoveryemailresenterror',
        defaultMessage: "We couldn\u2019t send the recovery email. Please try again later.",
        description: ''
    },
    mfRecoverySMSResentSuccessTitle: {
        id: 'mf.recoverysmsresentsuccess.title',
        defaultMessage: 'SMS resent!',
        description: ''
    },
    mfRecoverySMSResentSuccessDesc: {
        id: 'mf.recoverysmsresentsuccess',
        defaultMessage: 'A SMS has been resent to you!',
        description: ''
    },
    mfEmailResentSuccessTitle: {
        id: 'mf.emailresentsuccess.title',
        defaultMessage: 'Email resent!',
        description: ''
    },
    mfEmailResentSuccessDesc: {
        id: 'mf.emailresentsuccess',
        defaultMessage: 'An Email has been resent to you!',
        description: ''
    },
    mfVerifyErrorTitle: {
        id: 'guardian.error.default.flag.title',
        defaultMessage: "Oops, that didn't work!"
    },
    mfVerifyErrorDesc: {
        id: 'guardian.error.default.flag.description',
        defaultMessage: 'Try that again in a moment.'
    },
    // eg. if Twilio deprecates service in the country
    mfSmsInvalidPhoneNumberDesc: {
        id: 'mf.sms.invalidphonenumber.description',
        defaultMessage: 'Unable to send verification code to the registered phone number. Try again later, or navigate to the recovery code screen and use your recovery code to continue.'
    },
    mfSwitchToSms: {
        id: 'mf.switch-to.sms',
        defaultMessage: 'Use SMS instead',
        description: 'Button text to switch to SMS verification'
    },
    mfSwitchToTotp: {
        id: 'mf.switch-to.authenticator',
        defaultMessage: 'Use authenticator app instead',
        description: 'Button text to switch to authenticator verification'
    },
    mfSwitchToSecurityKey: {
        id: 'mf.switch-to.security.key',
        defaultMessage: 'Use security key instead',
        description: 'Button text to switch to security key verification'
    },
    mfSwitchFactorInvalidFactorTypeTitle: {
        id: 'mf.switch-factor.invalid-factor-type.title',
        defaultMessage: 'Invalid method',
        description: 'Title for invalid factor type error when switching MFA factors'
    },
    mfSwitchFactorInvalidFactorTypeDesc: {
        id: 'mf.switch-factor.invalid-factor-type.description',
        defaultMessage: 'The selected verification method is not supported. Try a different option.',
        description: 'Description for invalid factor type error when switching MFA factors'
    },
    mfSwitchFactorInvalidTokenTitle: {
        id: 'mf.switch-factor.invalid-transaction-token.title',
        defaultMessage: 'Invalid request',
        description: 'Title for invalid transaction token error when switching MFA factors'
    },
    mfSwitchFactorInvalidTokenDesc: {
        id: 'mf.switch-factor.invalid-transaction-token.description',
        defaultMessage: 'Your request cannot be processed.',
        description: 'Description for invalid token error when switching MFA factors'
    },
    mfSwitchFactorTransactionExpiredTitle: {
        id: 'mf.switch-factor.expired_transaction_token.title',
        defaultMessage: 'Request expired',
        description: 'Title for expired transaction error when switching MFA factors'
    },
    mfSwitchFactorTransactionExpiredDesc: {
        id: 'mf.switch-factor.expired-transaction-token.description',
        defaultMessage: 'Your login request has expired',
        description: 'Description for expired transaction when switching MFA factors'
    },
    mfSwitchFactorTooManyAttemptsTitle: {
        id: 'mf.switch-factor.too-many-attempts.title',
        defaultMessage: 'Too many requests',
        description: 'Title for reaching rate limit when switching MFA factors'
    },
    mfSwitchFactorTooManyAttemptsDesc: {
        id: 'mf.switch-factor.too-many-attempts.description',
        defaultMessage: "You've reached your rate limit. Try again in a few minutes.",
        description: 'Description for reaching rate limit when switching MFA factors'
    },
    mfSwitchFactorErrorTitle: {
        id: 'mf.switch-factor.error.title',
        defaultMessage: 'Unable to change method',
        description: 'Title for generic factor switching error'
    },
    mfSwitchFactorErrorDesc: {
        id: 'mf.switch-factor.error.description',
        defaultMessage: 'We encountered an issue while changing your verification method. Try again later.',
        description: 'Description for generic factor switching error'
    },
    // recovery code
    mfSwitchToRecoveryCode: {
        id: 'mf.switch-to.recovery-code',
        defaultMessage: 'Use recovery key instead',
        description: 'Button text to switch to solving MFA challenge with recovery key'
    }
});

});
parcelRegister("j5RJC", function(module, exports) {

$parcel$export(module.exports, "defineMessages", function () { return $de682a91f50cc83e$export$1adfeb024f5185b; });
$parcel$export(module.exports, "defineMessage", function () { return $de682a91f50cc83e$export$747d244ee58120dd; });

var $7x6fP = parcelRequire("7x6fP");


var $leG06 = parcelRequire("leG06");

var $57Ksf = parcelRequire("57Ksf");




var $6T9dz = parcelRequire("6T9dz");


function $de682a91f50cc83e$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $de682a91f50cc83e$export$747d244ee58120dd(msg) {
    return msg;
}
var $de682a91f50cc83e$export$40ae3194919d16b = (0, $7x6fP.createFormattedComponent)('formatDate');
var $de682a91f50cc83e$export$5b390a54f8a846f7 = (0, $7x6fP.createFormattedComponent)('formatTime');
var $de682a91f50cc83e$export$db80edc1e6b2f63d = (0, $7x6fP.createFormattedComponent)('formatNumber');
var $de682a91f50cc83e$export$f52b44e459e6e71d = (0, $7x6fP.createFormattedComponent)('formatList');
var $de682a91f50cc83e$export$c2336ea5aaab92fa = (0, $7x6fP.createFormattedComponent)('formatDisplayName');
var $de682a91f50cc83e$export$7fdc7d2c91ce149b = (0, $7x6fP.createFormattedDateTimePartsComponent)('formatDate');
var $de682a91f50cc83e$export$ec35873761676c2a = (0, $7x6fP.createFormattedDateTimePartsComponent)('formatTime');

});
parcelRegister("7x6fP", function(module, exports) {

$parcel$export(module.exports, "createFormattedDateTimePartsComponent", function () { return $016a5481e2a62d18$export$7448277f6036d2ab; });
$parcel$export(module.exports, "createFormattedComponent", function () { return $016a5481e2a62d18$export$b37e14176d001dec; });

var $2HjL4 = parcelRequire("2HjL4");

var $91i6m = parcelRequire("91i6m");

var $leG06 = parcelRequire("leG06");
var $016a5481e2a62d18$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($016a5481e2a62d18$var$DisplayName || ($016a5481e2a62d18$var$DisplayName = {}));
var $016a5481e2a62d18$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($016a5481e2a62d18$var$DisplayNameParts || ($016a5481e2a62d18$var$DisplayNameParts = {}));
var $016a5481e2a62d18$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $leG06.default)();
    var value = props.value, children = props.children, formatProps = (0, $2HjL4.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$016a5481e2a62d18$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
var $016a5481e2a62d18$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $leG06.default)();
    var value = props.value, children = props.children, formatProps = (0, $2HjL4.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$016a5481e2a62d18$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
function $016a5481e2a62d18$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $leG06.default)();
        var value = props.value, children = props.children, formatProps = (0, $2HjL4.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate' ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $016a5481e2a62d18$var$DisplayNameParts[name];
    return ComponentParts;
}
function $016a5481e2a62d18$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $leG06.default)();
        var value = props.value, children = props.children, formatProps = (0, $2HjL4.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') return children(formattedValue);
        var Text = intl.textComponent || $91i6m.Fragment;
        return $91i6m.createElement(Text, null, formattedValue);
    };
    Component.displayName = $016a5481e2a62d18$var$DisplayName[name];
    return Component;
}

});
parcelRegister("2HjL4", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $1f6eec818d63e151$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $1f6eec818d63e151$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $1f6eec818d63e151$export$3c9a16f847548506; });
$parcel$export(module.exports, "__awaiter", function () { return $1f6eec818d63e151$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $1f6eec818d63e151$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__spreadArray", function () { return $1f6eec818d63e151$export$1216008129fb82ed; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $1f6eec818d63e151$var$extendStatics = function(d, b) {
    $1f6eec818d63e151$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $1f6eec818d63e151$var$extendStatics(d, b);
};
function $1f6eec818d63e151$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $1f6eec818d63e151$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $1f6eec818d63e151$export$18ce0697a983be9b = function() {
    $1f6eec818d63e151$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1f6eec818d63e151$export$18ce0697a983be9b.apply(this, arguments);
};
function $1f6eec818d63e151$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $1f6eec818d63e151$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $1f6eec818d63e151$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $1f6eec818d63e151$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $1f6eec818d63e151$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $1f6eec818d63e151$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $1f6eec818d63e151$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $1f6eec818d63e151$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $1f6eec818d63e151$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $1f6eec818d63e151$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $1f6eec818d63e151$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $1f6eec818d63e151$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $1f6eec818d63e151$export$45d3717a4c69092e(o, m, p);
}
function $1f6eec818d63e151$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $1f6eec818d63e151$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $1f6eec818d63e151$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($1f6eec818d63e151$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $1f6eec818d63e151$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $1f6eec818d63e151$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $1f6eec818d63e151$export$10c90e4f7922046c(v) {
    return this instanceof $1f6eec818d63e151$export$10c90e4f7922046c ? (this.v = v, this) : new $1f6eec818d63e151$export$10c90e4f7922046c(v);
}
function $1f6eec818d63e151$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $1f6eec818d63e151$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $1f6eec818d63e151$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $1f6eec818d63e151$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $1f6eec818d63e151$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $1f6eec818d63e151$export$19a8beecd37a4c45 === "function" ? $1f6eec818d63e151$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $1f6eec818d63e151$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $1f6eec818d63e151$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $1f6eec818d63e151$var$ownKeys = function(o) {
    $1f6eec818d63e151$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $1f6eec818d63e151$var$ownKeys(o);
};
function $1f6eec818d63e151$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $1f6eec818d63e151$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $1f6eec818d63e151$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $1f6eec818d63e151$var$__setModuleDefault(result, mod);
    return result;
}
function $1f6eec818d63e151$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $1f6eec818d63e151$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $1f6eec818d63e151$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $1f6eec818d63e151$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $1f6eec818d63e151$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $1f6eec818d63e151$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $1f6eec818d63e151$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $1f6eec818d63e151$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $1f6eec818d63e151$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $1f6eec818d63e151$export$2e2bcd8739ae039 = {
    __extends: $1f6eec818d63e151$export$a8ba968b8961cb8a,
    __assign: $1f6eec818d63e151$export$18ce0697a983be9b,
    __rest: $1f6eec818d63e151$export$3c9a16f847548506,
    __decorate: $1f6eec818d63e151$export$29e00dfd3077644b,
    __param: $1f6eec818d63e151$export$d5ad3fd78186038f,
    __esDecorate: $1f6eec818d63e151$export$3a84e1ae4e97e9b0,
    __runInitializers: $1f6eec818d63e151$export$d831c04e792af3d,
    __propKey: $1f6eec818d63e151$export$6a2a36740a146cb8,
    __setFunctionName: $1f6eec818d63e151$export$d1a06452d3489bc7,
    __metadata: $1f6eec818d63e151$export$f1db080c865becb9,
    __awaiter: $1f6eec818d63e151$export$1050f835b63b671e,
    __generator: $1f6eec818d63e151$export$67ebef60e6f28a6,
    __createBinding: $1f6eec818d63e151$export$45d3717a4c69092e,
    __exportStar: $1f6eec818d63e151$export$f33643c0debef087,
    __values: $1f6eec818d63e151$export$19a8beecd37a4c45,
    __read: $1f6eec818d63e151$export$8d051b38c9118094,
    __spread: $1f6eec818d63e151$export$afc72e2116322959,
    __spreadArrays: $1f6eec818d63e151$export$6388937ca91ccae8,
    __spreadArray: $1f6eec818d63e151$export$1216008129fb82ed,
    __await: $1f6eec818d63e151$export$10c90e4f7922046c,
    __asyncGenerator: $1f6eec818d63e151$export$e427f37a30a4de9b,
    __asyncDelegator: $1f6eec818d63e151$export$bbd80228419bb833,
    __asyncValues: $1f6eec818d63e151$export$e3b29a3d6162315f,
    __makeTemplateObject: $1f6eec818d63e151$export$4fb47efe1390b86f,
    __importStar: $1f6eec818d63e151$export$c21735bcef00d192,
    __importDefault: $1f6eec818d63e151$export$da59b14a69baef04,
    __classPrivateFieldGet: $1f6eec818d63e151$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $1f6eec818d63e151$export$d40a35129aaff81f,
    __classPrivateFieldIn: $1f6eec818d63e151$export$81fdc39f203e4e04,
    __addDisposableResource: $1f6eec818d63e151$export$88ac25d8e944e405,
    __disposeResources: $1f6eec818d63e151$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $1f6eec818d63e151$export$889dfb5d17574b0b
};

});

parcelRegister("leG06", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f75b7c390b86637f$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $2imbu = parcelRequire("2imbu");

var $dDaRI = parcelRequire("dDaRI");
function $f75b7c390b86637f$export$2e2bcd8739ae039() {
    var intl = $91i6m.useContext((0, $dDaRI.Context));
    (0, $2imbu.invariantIntlContext)(intl);
    return intl;
}

});
parcelRegister("2imbu", function(module, exports) {

$parcel$export(module.exports, "invariantIntlContext", function () { return $1abe788fb1baae64$export$45c4bbf6e55bba1f; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $1abe788fb1baae64$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "assignUniqueKeysToParts", function () { return $1abe788fb1baae64$export$cfec03d26465fa63; });
$parcel$export(module.exports, "shallowEqual", function () { return $1abe788fb1baae64$export$d36bdfa510afb180; });

var $2HjL4 = parcelRequire("2HjL4");

var $91i6m = parcelRequire("91i6m");

var $k5jf7 = parcelRequire("k5jf7");

var $dlKY2 = parcelRequire("dlKY2");
function $1abe788fb1baae64$export$45c4bbf6e55bba1f(intl) {
    (0, $k5jf7.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $1abe788fb1baae64$export$b52f8d6fc0d47415 = (0, $2HjL4.__assign)((0, $2HjL4.__assign)({}, (0, $dlKY2.DEFAULT_INTL_CONFIG)), {
    textComponent: $91i6m.Fragment
});
function $1abe788fb1baae64$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($91i6m.Children.toArray(parts));
    };
}
function $1abe788fb1baae64$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});
parcelRegister("k5jf7", function(module, exports) {

$parcel$export(module.exports, "invariant", function () { return $e9f333805a7ca2a8$export$f5708dca728d7177; });

var $2HjL4 = parcelRequire("2HjL4");

var $goHb9 = parcelRequire("goHb9");
function $e9f333805a7ca2a8$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $e9f333805a7ca2a8$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === 'function') return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join('');
}
function $e9f333805a7ca2a8$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $e9f333805a7ca2a8$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $e9f333805a7ca2a8$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $e9f333805a7ca2a8$export$3fae2929ed23c202(map, pl, field) {
    return $e9f333805a7ca2a8$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $e9f333805a7ca2a8$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $e9f333805a7ca2a8$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === 'literal';
}
function $e9f333805a7ca2a8$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
function $e9f333805a7ca2a8$export$e4e12d57dd938668(target, name, value) {
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: true,
        writable: true,
        value: value
    });
}
var $e9f333805a7ca2a8$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $e9f333805a7ca2a8$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
var $e9f333805a7ca2a8$export$a99e4aaac79eeead = (0, $goHb9.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $2HjL4.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $goHb9.strategies).variadic
});
var $e9f333805a7ca2a8$export$b479a1a2d8754359 = (0, $goHb9.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $2HjL4.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $goHb9.strategies).variadic
});
var $e9f333805a7ca2a8$export$569bb3095db8432e = (0, $goHb9.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $2HjL4.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $goHb9.strategies).variadic
});
var $e9f333805a7ca2a8$export$e124bc7d23dd0e5a = (0, $goHb9.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.Locale).bind.apply(_a, (0, $2HjL4.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $goHb9.strategies).variadic
});
var $e9f333805a7ca2a8$export$a1209f8c6068edc3 = (0, $goHb9.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.ListFormat).bind.apply(_a, (0, $2HjL4.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $goHb9.strategies).variadic
});

});
parcelRegister("goHb9", function(module, exports) {

$parcel$export(module.exports, "memoize", function () { return $bf0061ac0373d8b7$export$fc10aeed3a532e2a; });
$parcel$export(module.exports, "strategies", function () { return $bf0061ac0373d8b7$export$c5491a8691a23b9e; });
//
// Main
//
function $bf0061ac0373d8b7$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $bf0061ac0373d8b7$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $bf0061ac0373d8b7$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $bf0061ac0373d8b7$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $bf0061ac0373d8b7$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $bf0061ac0373d8b7$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $bf0061ac0373d8b7$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $bf0061ac0373d8b7$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $bf0061ac0373d8b7$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $bf0061ac0373d8b7$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $bf0061ac0373d8b7$var$monadic : $bf0061ac0373d8b7$var$variadic;
    return $bf0061ac0373d8b7$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $bf0061ac0373d8b7$var$strategyVariadic(fn, options) {
    return $bf0061ac0373d8b7$var$assemble(fn, this, $bf0061ac0373d8b7$var$variadic, options.cache.create(), options.serializer);
}
function $bf0061ac0373d8b7$var$strategyMonadic(fn, options) {
    return $bf0061ac0373d8b7$var$assemble(fn, this, $bf0061ac0373d8b7$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $bf0061ac0373d8b7$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $bf0061ac0373d8b7$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$bf0061ac0373d8b7$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$bf0061ac0373d8b7$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $bf0061ac0373d8b7$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $bf0061ac0373d8b7$var$ObjectWithoutPrototypeCache();
    }
};
var $bf0061ac0373d8b7$export$c5491a8691a23b9e = {
    variadic: $bf0061ac0373d8b7$var$strategyVariadic,
    monadic: $bf0061ac0373d8b7$var$strategyMonadic
};

});


parcelRegister("dlKY2", function(module, exports) {

$parcel$export(module.exports, "filterProps", function () { return $9b81ab3eb7235222$export$d697c39a2985a4c; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $9b81ab3eb7235222$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "createIntlCache", function () { return $9b81ab3eb7235222$export$51c4f4e973f2dc00; });
$parcel$export(module.exports, "createFormatters", function () { return $9b81ab3eb7235222$export$c3f4cd5551df13fd; });
$parcel$export(module.exports, "getNamedFormat", function () { return $9b81ab3eb7235222$export$4ee1db8ce44a209b; });

var $2HjL4 = parcelRequire("2HjL4");
parcelRequire("eJHlR");
var $5AuEq = parcelRequire("5AuEq");

var $goHb9 = parcelRequire("goHb9");

var $1DT17 = parcelRequire("1DT17");
function $9b81ab3eb7235222$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $9b81ab3eb7235222$var$defaultErrorHandler = function(error) {};
var $9b81ab3eb7235222$var$defaultWarnHandler = function(warning) {};
var $9b81ab3eb7235222$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $9b81ab3eb7235222$var$defaultErrorHandler,
    onWarn: $9b81ab3eb7235222$var$defaultWarnHandler
};
function $9b81ab3eb7235222$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $9b81ab3eb7235222$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $9b81ab3eb7235222$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $9b81ab3eb7235222$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $goHb9.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $2HjL4.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $9b81ab3eb7235222$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $goHb9.strategies).variadic
    });
    var getNumberFormat = (0, $goHb9.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $2HjL4.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $9b81ab3eb7235222$var$createFastMemoizeCache(cache.number),
        strategy: (0, $goHb9.strategies).variadic
    });
    var getPluralRules = (0, $goHb9.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $2HjL4.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $9b81ab3eb7235222$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $goHb9.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $goHb9.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, $5AuEq.IntlMessageFormat)(message, locales, overrideFormats, (0, $2HjL4.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $9b81ab3eb7235222$var$createFastMemoizeCache(cache.message),
            strategy: (0, $goHb9.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $goHb9.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $2HjL4.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $9b81ab3eb7235222$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $goHb9.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $goHb9.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $2HjL4.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $9b81ab3eb7235222$var$createFastMemoizeCache(cache.list),
            strategy: (0, $goHb9.strategies).variadic
        }),
        getDisplayNames: (0, $goHb9.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $2HjL4.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $9b81ab3eb7235222$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $goHb9.strategies).variadic
        })
    };
}
function $9b81ab3eb7235222$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $1DT17.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("eJHlR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "ErrorCode", function () { return (parcelRequire("kC6G7")).ErrorCode; });
$parcel$export(module.exports, "FormatError", function () { return (parcelRequire("kC6G7")).FormatError; });
$parcel$export(module.exports, "isFormatXMLElementFn", function () { return (parcelRequire("4A667")).isFormatXMLElementFn; });

$parcel$export(module.exports, "IntlMessageFormat", function () { return (parcelRequire("5AuEq")).IntlMessageFormat; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $5AuEq = parcelRequire("5AuEq");
parcelRequire("kC6G7");
parcelRequire("4A667");
var $aba6e566fb3a2603$export$2e2bcd8739ae039 = (0, $5AuEq.IntlMessageFormat);

});
parcelRegister("5AuEq", function(module, exports) {

$parcel$export(module.exports, "IntlMessageFormat", function () { return $4118173424daef60$export$d342343268debc40; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $2HjL4 = parcelRequire("2HjL4");

var $goHb9 = parcelRequire("goHb9");

var $f4gUB = parcelRequire("f4gUB");

var $4A667 = parcelRequire("4A667");
// -- MessageFormat --------------------------------------------------------
function $4118173424daef60$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $2HjL4.__assign)((0, $2HjL4.__assign)((0, $2HjL4.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $2HjL4.__assign)((0, $2HjL4.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $4118173424daef60$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $4118173424daef60$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $2HjL4.__assign)({}, defaultConfig));
}
function $4118173424daef60$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $4118173424daef60$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $goHb9.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $2HjL4.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $4118173424daef60$var$createFastMemoizeCache(cache.number),
            strategy: (0, $goHb9.strategies).variadic
        }),
        getDateTimeFormat: (0, $goHb9.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $2HjL4.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $4118173424daef60$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $goHb9.strategies).variadic
        }),
        getPluralRules: (0, $goHb9.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $2HjL4.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $4118173424daef60$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $goHb9.strategies).variadic
        })
    };
}
var $4118173424daef60$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $4A667.PART_TYPE).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $4A667.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $2HjL4.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $2HjL4.__assign)((0, $2HjL4.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $4118173424daef60$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $4118173424daef60$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $f4gUB.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("f4gUB", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", function () { return (parcelRequire("4oe30")).isArgumentElement; });
$parcel$export(module.exports, "isDateElement", function () { return (parcelRequire("4oe30")).isDateElement; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return (parcelRequire("4oe30")).isDateTimeSkeleton; });
$parcel$export(module.exports, "isLiteralElement", function () { return (parcelRequire("4oe30")).isLiteralElement; });
$parcel$export(module.exports, "isNumberElement", function () { return (parcelRequire("4oe30")).isNumberElement; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return (parcelRequire("4oe30")).isNumberSkeleton; });
$parcel$export(module.exports, "isPluralElement", function () { return (parcelRequire("4oe30")).isPluralElement; });
$parcel$export(module.exports, "isPoundElement", function () { return (parcelRequire("4oe30")).isPoundElement; });
$parcel$export(module.exports, "isSelectElement", function () { return (parcelRequire("4oe30")).isSelectElement; });
$parcel$export(module.exports, "isTagElement", function () { return (parcelRequire("4oe30")).isTagElement; });
$parcel$export(module.exports, "isTimeElement", function () { return (parcelRequire("4oe30")).isTimeElement; });
$parcel$export(module.exports, "TYPE", function () { return (parcelRequire("4oe30")).TYPE; });

$parcel$export(module.exports, "parse", function () { return $af84591ecb683e66$export$98e6a39c04603d36; });

var $2HjL4 = parcelRequire("2HjL4");

var $aBvYY = parcelRequire("aBvYY");

var $d6lRE = parcelRequire("d6lRE");

var $4oe30 = parcelRequire("4oe30");
function $af84591ecb683e66$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $4oe30.isSelectElement)(el) || (0, $4oe30.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $af84591ecb683e66$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $4oe30.isNumberElement)(el) && (0, $4oe30.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $4oe30.isDateElement)(el) || (0, $4oe30.isTimeElement)(el)) && (0, $4oe30.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $4oe30.isTagElement)(el)) $af84591ecb683e66$var$pruneLocation(el.children);
    });
}
function $af84591ecb683e66$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $2HjL4.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $d6lRE.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $aBvYY.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $af84591ecb683e66$var$pruneLocation(result.val);
    return result.val;
}
var $af84591ecb683e66$export$d3c1bfa0f7d806e9 = (0, $d6lRE.Parser);

});
parcelRegister("aBvYY", function(module, exports) {

$parcel$export(module.exports, "ErrorKind", function () { return $7b862b2219635152$export$896afd8541959ee5; });
var $7b862b2219635152$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($7b862b2219635152$export$896afd8541959ee5 || ($7b862b2219635152$export$896afd8541959ee5 = {}));

});

parcelRegister("d6lRE", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $989ccbba80b155bc$export$7acfa6ed01010e37; });

var $2HjL4 = parcelRequire("2HjL4");

var $aBvYY = parcelRequire("aBvYY");

var $4oe30 = parcelRequire("4oe30");

var $kmboM = parcelRequire("kmboM");
parcelRequire("eBCkX");
var $4KdNy = parcelRequire("4KdNy");
var $ahG4D = parcelRequire("ahG4D");

var $9VXNF = parcelRequire("9VXNF");
var $989ccbba80b155bc$var$_a;
var $989ccbba80b155bc$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $kmboM.SPACE_SEPARATOR_REGEX).source, "*"));
var $989ccbba80b155bc$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $kmboM.SPACE_SEPARATOR_REGEX).source, "*$"));
function $989ccbba80b155bc$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $989ccbba80b155bc$var$hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var $989ccbba80b155bc$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $989ccbba80b155bc$var$hasNativeFromEntries = !!Object.fromEntries;
var $989ccbba80b155bc$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $989ccbba80b155bc$var$hasTrimStart = !!String.prototype.trimStart;
var $989ccbba80b155bc$var$hasTrimEnd = !!String.prototype.trimEnd;
var $989ccbba80b155bc$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $989ccbba80b155bc$var$isSafeInteger = $989ccbba80b155bc$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $989ccbba80b155bc$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $989ccbba80b155bc$var$re = $989ccbba80b155bc$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $989ccbba80b155bc$var$REGEX_SUPPORTS_U_AND_Y = (($989ccbba80b155bc$var$_a = $989ccbba80b155bc$var$re.exec('a')) === null || $989ccbba80b155bc$var$_a === void 0 ? void 0 : $989ccbba80b155bc$var$_a[0]) === 'a';
} catch (_) {
    $989ccbba80b155bc$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $989ccbba80b155bc$var$startsWith = $989ccbba80b155bc$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $989ccbba80b155bc$var$fromCodePoint = $989ccbba80b155bc$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $989ccbba80b155bc$var$fromEntries = // native
$989ccbba80b155bc$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $989ccbba80b155bc$var$codePointAt = $989ccbba80b155bc$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $989ccbba80b155bc$var$trimStart = $989ccbba80b155bc$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($989ccbba80b155bc$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $989ccbba80b155bc$var$trimEnd = $989ccbba80b155bc$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($989ccbba80b155bc$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $989ccbba80b155bc$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $989ccbba80b155bc$var$matchIdentifierAtIndex;
if ($989ccbba80b155bc$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $989ccbba80b155bc$var$IDENTIFIER_PREFIX_RE_1 = $989ccbba80b155bc$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $989ccbba80b155bc$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $989ccbba80b155bc$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $989ccbba80b155bc$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$989ccbba80b155bc$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $989ccbba80b155bc$var$codePointAt(s, index);
        if (c === undefined || $989ccbba80b155bc$var$_isWhiteSpace(c) || $989ccbba80b155bc$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $989ccbba80b155bc$var$fromCodePoint.apply(void 0, match);
};
var $989ccbba80b155bc$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $4oe30.TYPE).pound,
                    location: $989ccbba80b155bc$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $aBvYY.ErrorKind).UNMATCHED_CLOSING_TAG, $989ccbba80b155bc$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $989ccbba80b155bc$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $4oe30.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $989ccbba80b155bc$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$989ccbba80b155bc$var$_isAlpha(this.char())) return this.error((0, $aBvYY.ErrorKind).INVALID_TAG, $989ccbba80b155bc$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $aBvYY.ErrorKind).UNMATCHED_CLOSING_TAG, $989ccbba80b155bc$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $aBvYY.ErrorKind).INVALID_TAG, $989ccbba80b155bc$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $4oe30.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $989ccbba80b155bc$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $aBvYY.ErrorKind).UNCLOSED_TAG, $989ccbba80b155bc$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $aBvYY.ErrorKind).INVALID_TAG, $989ccbba80b155bc$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $989ccbba80b155bc$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $989ccbba80b155bc$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $4oe30.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$989ccbba80b155bc$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $989ccbba80b155bc$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $989ccbba80b155bc$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $aBvYY.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $989ccbba80b155bc$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $aBvYY.ErrorKind).EMPTY_ARGUMENT, $989ccbba80b155bc$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $aBvYY.ErrorKind).MALFORMED_ARGUMENT, $989ccbba80b155bc$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $aBvYY.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $989ccbba80b155bc$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $4oe30.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $989ccbba80b155bc$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $aBvYY.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $989ccbba80b155bc$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $aBvYY.ErrorKind).MALFORMED_ARGUMENT, $989ccbba80b155bc$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $989ccbba80b155bc$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $989ccbba80b155bc$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $aBvYY.ErrorKind).EXPECT_ARGUMENT_TYPE, $989ccbba80b155bc$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $989ccbba80b155bc$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $aBvYY.ErrorKind).EXPECT_ARGUMENT_STYLE, $989ccbba80b155bc$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $989ccbba80b155bc$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $989ccbba80b155bc$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $989ccbba80b155bc$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $989ccbba80b155bc$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $4oe30.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $aBvYY.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $9VXNF.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $4oe30.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $4KdNy.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $4oe30.TYPE).date : (0, $4oe30.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $4oe30.TYPE).number : argType === 'date' ? (0, $4oe30.TYPE).date : (0, $4oe30.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $aBvYY.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $989ccbba80b155bc$var$createLocation(typeEndPosition_1, (0, $2HjL4.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $aBvYY.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $989ccbba80b155bc$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $aBvYY.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $aBvYY.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $989ccbba80b155bc$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $4oe30.TYPE).select,
                        value: value,
                        options: $989ccbba80b155bc$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $4oe30.TYPE).plural,
                        value: value,
                        options: $989ccbba80b155bc$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $aBvYY.ErrorKind).INVALID_ARGUMENT_TYPE, $989ccbba80b155bc$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $aBvYY.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $989ccbba80b155bc$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $aBvYY.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $989ccbba80b155bc$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $ahG4D.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $aBvYY.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $4oe30.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $ahG4D.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $aBvYY.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $aBvYY.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $989ccbba80b155bc$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $aBvYY.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $aBvYY.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $aBvYY.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $aBvYY.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $989ccbba80b155bc$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $989ccbba80b155bc$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $aBvYY.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $aBvYY.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $989ccbba80b155bc$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $aBvYY.ErrorKind).MISSING_OTHER_CLAUSE, $989ccbba80b155bc$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $989ccbba80b155bc$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$989ccbba80b155bc$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $989ccbba80b155bc$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($989ccbba80b155bc$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $989ccbba80b155bc$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $989ccbba80b155bc$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $989ccbba80b155bc$var$_isAlphaOrSlash(codepoint) {
    return $989ccbba80b155bc$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $989ccbba80b155bc$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $989ccbba80b155bc$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $989ccbba80b155bc$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("4oe30", function(module, exports) {

$parcel$export(module.exports, "TYPE", function () { return $33244cdb90aeaba6$export$b87f371cbc396fcf; });
$parcel$export(module.exports, "SKELETON_TYPE", function () { return $33244cdb90aeaba6$export$906452485466fa53; });
$parcel$export(module.exports, "isLiteralElement", function () { return $33244cdb90aeaba6$export$cfa10c5697238752; });
$parcel$export(module.exports, "isArgumentElement", function () { return $33244cdb90aeaba6$export$4f55724281bdfaf9; });
$parcel$export(module.exports, "isNumberElement", function () { return $33244cdb90aeaba6$export$e11187b219e191e1; });
$parcel$export(module.exports, "isDateElement", function () { return $33244cdb90aeaba6$export$32d811605da75f40; });
$parcel$export(module.exports, "isTimeElement", function () { return $33244cdb90aeaba6$export$34ec46f596b1702f; });
$parcel$export(module.exports, "isSelectElement", function () { return $33244cdb90aeaba6$export$dcfe1c11d168b5a1; });
$parcel$export(module.exports, "isPluralElement", function () { return $33244cdb90aeaba6$export$6c796d116f0a4fbc; });
$parcel$export(module.exports, "isPoundElement", function () { return $33244cdb90aeaba6$export$c0ece297bdd0c082; });
$parcel$export(module.exports, "isTagElement", function () { return $33244cdb90aeaba6$export$5c83de34745812b; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return $33244cdb90aeaba6$export$3f9a19cd4152eda3; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return $33244cdb90aeaba6$export$7680c41f1a55f4cf; });
var $33244cdb90aeaba6$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($33244cdb90aeaba6$export$b87f371cbc396fcf || ($33244cdb90aeaba6$export$b87f371cbc396fcf = {}));
var $33244cdb90aeaba6$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($33244cdb90aeaba6$export$906452485466fa53 || ($33244cdb90aeaba6$export$906452485466fa53 = {}));
function $33244cdb90aeaba6$export$cfa10c5697238752(el) {
    return el.type === $33244cdb90aeaba6$export$b87f371cbc396fcf.literal;
}
function $33244cdb90aeaba6$export$4f55724281bdfaf9(el) {
    return el.type === $33244cdb90aeaba6$export$b87f371cbc396fcf.argument;
}
function $33244cdb90aeaba6$export$e11187b219e191e1(el) {
    return el.type === $33244cdb90aeaba6$export$b87f371cbc396fcf.number;
}
function $33244cdb90aeaba6$export$32d811605da75f40(el) {
    return el.type === $33244cdb90aeaba6$export$b87f371cbc396fcf.date;
}
function $33244cdb90aeaba6$export$34ec46f596b1702f(el) {
    return el.type === $33244cdb90aeaba6$export$b87f371cbc396fcf.time;
}
function $33244cdb90aeaba6$export$dcfe1c11d168b5a1(el) {
    return el.type === $33244cdb90aeaba6$export$b87f371cbc396fcf.select;
}
function $33244cdb90aeaba6$export$6c796d116f0a4fbc(el) {
    return el.type === $33244cdb90aeaba6$export$b87f371cbc396fcf.plural;
}
function $33244cdb90aeaba6$export$c0ece297bdd0c082(el) {
    return el.type === $33244cdb90aeaba6$export$b87f371cbc396fcf.pound;
}
function $33244cdb90aeaba6$export$5c83de34745812b(el) {
    return el.type === $33244cdb90aeaba6$export$b87f371cbc396fcf.tag;
}
function $33244cdb90aeaba6$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $33244cdb90aeaba6$export$906452485466fa53.number);
}
function $33244cdb90aeaba6$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $33244cdb90aeaba6$export$906452485466fa53.dateTime);
}
function $33244cdb90aeaba6$export$f0ac572c1121c662(value) {
    return {
        type: $33244cdb90aeaba6$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $33244cdb90aeaba6$export$425e864b0ba114f1(value, style) {
    return {
        type: $33244cdb90aeaba6$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("kmboM", function(module, exports) {

$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", function () { return $ed1eb44441cc69bb$export$523451f94304dd6c; });
// @generated from regex-gen.ts
var $ed1eb44441cc69bb$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $ed1eb44441cc69bb$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("eBCkX", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return (parcelRequire("4KdNy")).parseDateTimeSkeleton; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return (parcelRequire("ahG4D")).parseNumberSkeleton; });
$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return (parcelRequire("ahG4D")).parseNumberSkeletonFromString; });
parcelRequire("4KdNy");
parcelRequire("ahG4D");

});
parcelRegister("4KdNy", function(module, exports) {

$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return $3746295cdbc0c02c$export$f7b99fb377fe69fa; });
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $3746295cdbc0c02c$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $3746295cdbc0c02c$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($3746295cdbc0c02c$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

});

parcelRegister("ahG4D", function(module, exports) {

$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return $77cc20dce77d12fd$export$71cee2f16fba2480; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return $77cc20dce77d12fd$export$47c6f8480bda3e11; });

var $2HjL4 = parcelRequire("2HjL4");

var $90Hne = parcelRequire("90Hne");
function $77cc20dce77d12fd$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $90Hne.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $77cc20dce77d12fd$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $77cc20dce77d12fd$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $77cc20dce77d12fd$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $77cc20dce77d12fd$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $77cc20dce77d12fd$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $77cc20dce77d12fd$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($77cc20dce77d12fd$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $77cc20dce77d12fd$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $77cc20dce77d12fd$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$77cc20dce77d12fd$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $77cc20dce77d12fd$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $77cc20dce77d12fd$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $77cc20dce77d12fd$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $77cc20dce77d12fd$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $2HjL4.__assign)((0, $2HjL4.__assign)((0, $2HjL4.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $2HjL4.__assign)((0, $2HjL4.__assign)({}, all), $77cc20dce77d12fd$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $2HjL4.__assign)((0, $2HjL4.__assign)((0, $2HjL4.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $2HjL4.__assign)((0, $2HjL4.__assign)({}, all), $77cc20dce77d12fd$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            case 'rounding-mode-floor':
                result.roundingMode = 'floor';
                continue;
            case 'rounding-mode-ceiling':
                result.roundingMode = 'ceil';
                continue;
            case 'rounding-mode-down':
                result.roundingMode = 'trunc';
                continue;
            case 'rounding-mode-up':
                result.roundingMode = 'expand';
                continue;
            case 'rounding-mode-half-even':
                result.roundingMode = 'halfEven';
                continue;
            case 'rounding-mode-half-down':
                result.roundingMode = 'halfTrunc';
                continue;
            case 'rounding-mode-half-up':
                result.roundingMode = 'halfExpand';
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($77cc20dce77d12fd$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($77cc20dce77d12fd$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($77cc20dce77d12fd$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($77cc20dce77d12fd$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $2HjL4.__assign)((0, $2HjL4.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $2HjL4.__assign)((0, $2HjL4.__assign)({}, result), $77cc20dce77d12fd$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($77cc20dce77d12fd$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $2HjL4.__assign)((0, $2HjL4.__assign)({}, result), $77cc20dce77d12fd$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $77cc20dce77d12fd$var$parseSign(token.stem);
        if (signOpts) result = (0, $2HjL4.__assign)((0, $2HjL4.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $77cc20dce77d12fd$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $2HjL4.__assign)((0, $2HjL4.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("90Hne", function(module, exports) {

$parcel$export(module.exports, "WHITE_SPACE_REGEX", function () { return $68f5c23dd30ce70f$export$2b8db14d8bcaece7; });
// @generated from regex-gen.ts
var $68f5c23dd30ce70f$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("9VXNF", function(module, exports) {

$parcel$export(module.exports, "getBestPattern", function () { return $73b7d2f7dc76aeec$export$29c5368be8904d27; });

var $1QrTW = parcelRequire("1QrTW");
function $73b7d2f7dc76aeec$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $73b7d2f7dc76aeec$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $73b7d2f7dc76aeec$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $1QrTW.timeData)[regionTag || ''] || (0, $1QrTW.timeData)[languageTag || ''] || (0, $1QrTW.timeData)["".concat(languageTag, "-001")] || (0, $1QrTW.timeData)['001'];
    return hourCycles[0];
}

});
parcelRegister("1QrTW", function(module, exports) {

$parcel$export(module.exports, "timeData", function () { return $15804a5d8ece5f25$export$a8c9209db4084317; });
// @generated from time-data-gen.ts
// prettier-ignore  
var $15804a5d8ece5f25$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});




parcelRegister("4A667", function(module, exports) {

$parcel$export(module.exports, "PART_TYPE", function () { return $355f4112fb465727$export$49694c2877b44c57; });
$parcel$export(module.exports, "isFormatXMLElementFn", function () { return $355f4112fb465727$export$df0c12a2d414a163; });
$parcel$export(module.exports, "formatToParts", function () { return $355f4112fb465727$export$275d4a3bb5f66fda; });
parcelRequire("f4gUB");
var $4oe30 = parcelRequire("4oe30");

var $kC6G7 = parcelRequire("kC6G7");
var $355f4112fb465727$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($355f4112fb465727$export$49694c2877b44c57 || ($355f4112fb465727$export$49694c2877b44c57 = {}));
function $355f4112fb465727$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $355f4112fb465727$export$49694c2877b44c57.literal || part.type !== $355f4112fb465727$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $355f4112fb465727$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $355f4112fb465727$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $4oe30.isLiteralElement)(els[0])) return [
        {
            type: $355f4112fb465727$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $4oe30.isLiteralElement)(el)) {
            result.push({
                type: $355f4112fb465727$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $4oe30.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $355f4112fb465727$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $kC6G7.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $4oe30.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $355f4112fb465727$export$49694c2877b44c57.literal : $355f4112fb465727$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $4oe30.isDateElement)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $4oe30.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $355f4112fb465727$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $4oe30.isTimeElement)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $4oe30.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $355f4112fb465727$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $4oe30.isNumberElement)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $4oe30.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $355f4112fb465727$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $4oe30.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$355f4112fb465727$export$df0c12a2d414a163(formatFn)) throw new (0, $kC6G7.InvalidValueTypeError)(value_1, 'function', originalMessage);
            var parts = $355f4112fb465727$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $355f4112fb465727$export$49694c2877b44c57.literal : $355f4112fb465727$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $4oe30.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $kC6G7.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $355f4112fb465727$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $4oe30.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $kC6G7.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $kC6G7.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $kC6G7.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $355f4112fb465727$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $355f4112fb465727$var$mergeLiteral(result);
}

});
parcelRegister("kC6G7", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", function () { return $f01c896a81cfa3dd$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "FormatError", function () { return $f01c896a81cfa3dd$export$7369836851cc1329; });
$parcel$export(module.exports, "InvalidValueError", function () { return $f01c896a81cfa3dd$export$565c3afc07dfa382; });
$parcel$export(module.exports, "InvalidValueTypeError", function () { return $f01c896a81cfa3dd$export$cbc0db47c750f7c9; });
$parcel$export(module.exports, "MissingValueError", function () { return $f01c896a81cfa3dd$export$8bfc137e4d23fdf0; });

var $2HjL4 = parcelRequire("2HjL4");
var $f01c896a81cfa3dd$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($f01c896a81cfa3dd$export$d4e71bc0b80dc0fb || ($f01c896a81cfa3dd$export$d4e71bc0b80dc0fb = {}));
var $f01c896a81cfa3dd$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $2HjL4.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $f01c896a81cfa3dd$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $2HjL4.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $f01c896a81cfa3dd$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($f01c896a81cfa3dd$export$7369836851cc1329);
var $f01c896a81cfa3dd$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $2HjL4.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $f01c896a81cfa3dd$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($f01c896a81cfa3dd$export$7369836851cc1329);
var $f01c896a81cfa3dd$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $2HjL4.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $f01c896a81cfa3dd$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($f01c896a81cfa3dd$export$7369836851cc1329);

});




parcelRegister("1DT17", function(module, exports) {

$parcel$export(module.exports, "UnsupportedFormatterError", function () { return $13241c33ea572676$export$549f97e137a05c90; });
$parcel$export(module.exports, "InvalidConfigError", function () { return $13241c33ea572676$export$3ca04dd7fb305893; });
$parcel$export(module.exports, "MissingDataError", function () { return $13241c33ea572676$export$c1eaf877d81384b6; });
$parcel$export(module.exports, "IntlFormatError", function () { return $13241c33ea572676$export$e3b7eee1dbc44895; });
$parcel$export(module.exports, "MessageFormatError", function () { return $13241c33ea572676$export$74a601a3d3f31621; });
$parcel$export(module.exports, "MissingTranslationError", function () { return $13241c33ea572676$export$2ddcb436d0aa3688; });

var $2HjL4 = parcelRequire("2HjL4");
var $13241c33ea572676$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($13241c33ea572676$export$557d6acb76e8a244 || ($13241c33ea572676$export$557d6acb76e8a244 = {}));
var $13241c33ea572676$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $2HjL4.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $13241c33ea572676$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $2HjL4.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $13241c33ea572676$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($13241c33ea572676$export$c016d36112f6ddf8);
var $13241c33ea572676$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $2HjL4.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $13241c33ea572676$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($13241c33ea572676$export$c016d36112f6ddf8);
var $13241c33ea572676$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $2HjL4.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $13241c33ea572676$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($13241c33ea572676$export$c016d36112f6ddf8);
var $13241c33ea572676$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $2HjL4.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $13241c33ea572676$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($13241c33ea572676$export$c016d36112f6ddf8);
var $13241c33ea572676$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $2HjL4.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($13241c33ea572676$export$e3b7eee1dbc44895);
var $13241c33ea572676$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $2HjL4.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $13241c33ea572676$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($13241c33ea572676$export$c016d36112f6ddf8);

});



parcelRegister("dDaRI", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return $9ec7587fde5350d3$export$2881499e37b75b9a; });
$parcel$export(module.exports, "Context", function () { return $9ec7587fde5350d3$export$841858b892ce1f4c; });

var $2HjL4 = parcelRequire("2HjL4");

var $kTpRR = parcelRequire("kTpRR");

var $91i6m = parcelRequire("91i6m");

var $2imbu = parcelRequire("2imbu");
function $9ec7587fde5350d3$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $9ec7587fde5350d3$var$IntlContext = typeof window !== 'undefined' && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $91i6m.createContext(null)) : $91i6m.createContext(null);
var $9ec7587fde5350d3$var$IntlConsumer = $9ec7587fde5350d3$var$IntlContext.Consumer, $9ec7587fde5350d3$var$IntlProvider = $9ec7587fde5350d3$var$IntlContext.Provider;
var $9ec7587fde5350d3$export$2881499e37b75b9a = $9ec7587fde5350d3$var$IntlProvider;
var $9ec7587fde5350d3$export$841858b892ce1f4c = $9ec7587fde5350d3$var$IntlContext;
function $9ec7587fde5350d3$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $91i6m.createElement($9ec7587fde5350d3$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $2imbu.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $91i6m.createElement(WrappedComponent, (0, $2HjL4.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($9ec7587fde5350d3$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($kTpRR)))(// @ts-expect-error
    $91i6m.forwardRef(function(props, ref) {
        return $91i6m.createElement(WithIntl, (0, $2HjL4.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kTpRR)))(WithIntl, WrappedComponent);
}

});



parcelRegister("57Ksf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bb1a4191a7aa036$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $2HjL4 = parcelRequire("2HjL4");

var $dlKY2 = parcelRequire("dlKY2");

var $91i6m = parcelRequire("91i6m");

var $2imbu = parcelRequire("2imbu");

var $dDaRI = parcelRequire("dDaRI");

var $2c9Ww = parcelRequire("2c9Ww");
function $3bb1a4191a7aa036$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
var $3bb1a4191a7aa036$var$IntlProvider = /** @class */ function(_super) {
    (0, $2HjL4.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $dlKY2.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: (0, $2c9Ww.createIntl)($3bb1a4191a7aa036$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $3bb1a4191a7aa036$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $3bb1a4191a7aa036$var$processIntlConfig(props);
        if (!(0, $2imbu.shallowEqual)(prevConfig, config)) return {
            intl: (0, $2c9Ww.createIntl)(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $2imbu.invariantIntlContext)(this.state.intl);
        return $91i6m.createElement((0, $dDaRI.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $2imbu.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($91i6m.PureComponent);
var $3bb1a4191a7aa036$export$2e2bcd8739ae039 = $3bb1a4191a7aa036$var$IntlProvider;

});
parcelRegister("2c9Ww", function(module, exports) {

$parcel$export(module.exports, "createIntl", function () { return $19946a37f85de62f$export$7e4cbedfdd7b4c0d; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $2HjL4 = parcelRequire("2HjL4");

var $12cy7 = parcelRequire("12cy7");
var $8djEE = parcelRequire("8djEE");

var $91i6m = parcelRequire("91i6m");

var $2imbu = parcelRequire("2imbu");

var $4A667 = parcelRequire("4A667");
function $19946a37f85de62f$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $4A667.isFormatXMLElementFn)(v) ? (0, $2imbu.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $19946a37f85de62f$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $19946a37f85de62f$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $8djEE.formatMessage).apply(void 0, (0, $2HjL4.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $91i6m.Children.toArray(chunks);
    return chunks;
};
var $19946a37f85de62f$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $2HjL4.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $19946a37f85de62f$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $12cy7.createIntl)((0, $2HjL4.__assign)((0, $2HjL4.__assign)((0, $2HjL4.__assign)({}, (0, $2imbu.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $2HjL4.__assign)((0, $2HjL4.__assign)({}, coreIntl), {
        formatMessage: $19946a37f85de62f$var$formatMessage.bind(null, resolvedConfig, // @ts-expect-error fix this
        coreIntl.formatters),
        // @ts-expect-error fix this
        $t: $19946a37f85de62f$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};

});
parcelRegister("12cy7", function(module, exports) {

$parcel$export(module.exports, "createIntl", function () { return $0c0fb65de2a25c91$export$7e4cbedfdd7b4c0d; });

var $2HjL4 = parcelRequire("2HjL4");

var $dlKY2 = parcelRequire("dlKY2");

var $1DT17 = parcelRequire("1DT17");

var $aS5xo = parcelRequire("aS5xo");

var $lheb5 = parcelRequire("lheb5");

var $3A7Hb = parcelRequire("3A7Hb");

var $bEfET = parcelRequire("bEfET");

var $8djEE = parcelRequire("8djEE");

var $grOIe = parcelRequire("grOIe");

var $bxuKN = parcelRequire("bxuKN");
function $0c0fb65de2a25c91$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $0c0fb65de2a25c91$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $0c0fb65de2a25c91$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
}
function $0c0fb65de2a25c91$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $dlKY2.createFormatters)(cache);
    var resolvedConfig = (0, $2HjL4.__assign)((0, $2HjL4.__assign)({}, (0, $dlKY2.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $1DT17.InvalidConfigError)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $1DT17.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $1DT17.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    $0c0fb65de2a25c91$var$verifyConfigMessages(resolvedConfig);
    return (0, $2HjL4.__assign)((0, $2HjL4.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $aS5xo.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $aS5xo.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $lheb5.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $3A7Hb.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $3A7Hb.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $3A7Hb.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $3A7Hb.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $3A7Hb.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $bEfET.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        // @ts-expect-error TODO: will get to this later
        formatMessage: (0, $8djEE.formatMessage).bind(null, resolvedConfig, formatters),
        // @ts-expect-error TODO: will get to this later
        $t: (0, $8djEE.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $grOIe.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $grOIe.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $bxuKN.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("aS5xo", function(module, exports) {

$parcel$export(module.exports, "formatNumber", function () { return $7ea33e2f66583e7a$export$f5dd818bff069720; });
$parcel$export(module.exports, "formatNumberToParts", function () { return $7ea33e2f66583e7a$export$6871080848f10b2f; });

var $1DT17 = parcelRequire("1DT17");

var $dlKY2 = parcelRequire("dlKY2");
var $7ea33e2f66583e7a$var$NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
    // ES2023 NumberFormat
    'trailingZeroDisplay',
    'roundingPriority',
    'roundingIncrement',
    'roundingMode'
];
function $7ea33e2f66583e7a$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $dlKY2.getNamedFormat)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $dlKY2.filterProps)(options, $7ea33e2f66583e7a$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $7ea33e2f66583e7a$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $7ea33e2f66583e7a$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $1DT17.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return String(value);
}
function $7ea33e2f66583e7a$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $7ea33e2f66583e7a$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $1DT17.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return [];
}

});

parcelRegister("lheb5", function(module, exports) {

$parcel$export(module.exports, "formatRelativeTime", function () { return $f7d62eef1623788b$export$b4ea3b48dcf921f6; });

var $dlKY2 = parcelRequire("dlKY2");

var $kC6G7 = parcelRequire("kC6G7");

var $1DT17 = parcelRequire("1DT17");
var $f7d62eef1623788b$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $f7d62eef1623788b$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $dlKY2.getNamedFormat)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $dlKY2.filterProps)(options, $f7d62eef1623788b$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $f7d62eef1623788b$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $kC6G7.FormatError)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $kC6G7.ErrorCode).MISSING_INTL_API));
    try {
        return $f7d62eef1623788b$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $1DT17.IntlFormatError)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

});

parcelRegister("3A7Hb", function(module, exports) {

$parcel$export(module.exports, "formatDate", function () { return $29bab40a5e93d46a$export$3ae94a2503e890a1; });
$parcel$export(module.exports, "formatTime", function () { return $29bab40a5e93d46a$export$3203edd9e5edd663; });
$parcel$export(module.exports, "formatDateTimeRange", function () { return $29bab40a5e93d46a$export$a7fc3a91cb2ec376; });
$parcel$export(module.exports, "formatDateToParts", function () { return $29bab40a5e93d46a$export$dc1f059bce486b1; });
$parcel$export(module.exports, "formatTimeToParts", function () { return $29bab40a5e93d46a$export$af6e5d7a5c73edeb; });

var $2HjL4 = parcelRequire("2HjL4");

var $dlKY2 = parcelRequire("dlKY2");

var $1DT17 = parcelRequire("1DT17");
var $29bab40a5e93d46a$var$DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits'
];
function $29bab40a5e93d46a$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $2HjL4.__assign)((0, $2HjL4.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $dlKY2.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $dlKY2.filterProps)(options, $29bab40a5e93d46a$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $2HjL4.__assign)((0, $2HjL4.__assign)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $29bab40a5e93d46a$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $29bab40a5e93d46a$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $1DT17.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return String(date);
}
function $29bab40a5e93d46a$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $29bab40a5e93d46a$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $1DT17.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return String(date);
}
function $29bab40a5e93d46a$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $dlKY2.filterProps)(options, $29bab40a5e93d46a$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $1DT17.IntlFormatError)('Error formatting date time range.', config.locale, e));
    }
    return String(from);
}
function $29bab40a5e93d46a$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $29bab40a5e93d46a$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $1DT17.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return [];
}
function $29bab40a5e93d46a$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $29bab40a5e93d46a$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $1DT17.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return [];
}

});

parcelRegister("bEfET", function(module, exports) {

$parcel$export(module.exports, "formatPlural", function () { return $87af9395681e3e42$export$bbbd05c900f3568d; });

var $dlKY2 = parcelRequire("dlKY2");

var $1DT17 = parcelRequire("1DT17");

var $kC6G7 = parcelRequire("kC6G7");
var $87af9395681e3e42$var$PLURAL_FORMAT_OPTIONS = [
    'type'
];
function $87af9395681e3e42$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $kC6G7.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $kC6G7.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $dlKY2.filterProps)(options, $87af9395681e3e42$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $1DT17.IntlFormatError)('Error formatting plural.', locale, e));
    }
    return 'other';
}

});

parcelRegister("8djEE", function(module, exports) {

$parcel$export(module.exports, "formatMessage", function () { return $5faec8a79bc52d9c$export$25868d1e8e76735f; });

var $2HjL4 = parcelRequire("2HjL4");

var $k5jf7 = parcelRequire("k5jf7");
parcelRequire("eJHlR");
var $5AuEq = parcelRequire("5AuEq");

var $1DT17 = parcelRequire("1DT17");
parcelRequire("f4gUB");
var $4oe30 = parcelRequire("4oe30");
function $5faec8a79bc52d9c$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $2HjL4.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $5faec8a79bc52d9c$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $2HjL4.__assign)((0, $2HjL4.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $2HjL4.__assign)((0, $2HjL4.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $5faec8a79bc52d9c$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $5AuEq.IntlMessageFormat).formats;
    return (0, $2HjL4.__assign)((0, $2HjL4.__assign)((0, $2HjL4.__assign)({}, mfFormats), f1), {
        date: $5faec8a79bc52d9c$var$deepMergeOptions($5faec8a79bc52d9c$var$setTimeZoneInOptions(mfFormats.date, timeZone), $5faec8a79bc52d9c$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $5faec8a79bc52d9c$var$deepMergeOptions($5faec8a79bc52d9c$var$setTimeZoneInOptions(mfFormats.time, timeZone), $5faec8a79bc52d9c$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $5faec8a79bc52d9c$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $k5jf7.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $4oe30.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $2HjL4.__assign)((0, $2HjL4.__assign)({}, defaultRichTextElements), values || {});
    formats = $5faec8a79bc52d9c$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $5faec8a79bc52d9c$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $1DT17.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $1DT17.MessageFormatError)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $2HjL4.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $1DT17.MessageFormatError)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $1DT17.MessageFormatError)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
};

});

parcelRegister("grOIe", function(module, exports) {

$parcel$export(module.exports, "formatList", function () { return $bf96816123756e36$export$e8b8be48b45905bb; });
$parcel$export(module.exports, "formatListToParts", function () { return $bf96816123756e36$export$6f284aad1934db69; });

var $2HjL4 = parcelRequire("2HjL4");

var $dlKY2 = parcelRequire("dlKY2");

var $kC6G7 = parcelRequire("kC6G7");

var $1DT17 = parcelRequire("1DT17");
var $bf96816123756e36$var$LIST_FORMAT_OPTIONS = [
    'type',
    'style'
];
var $bf96816123756e36$var$now = Date.now();
function $bf96816123756e36$var$generateToken(i) {
    return "".concat($bf96816123756e36$var$now, "_").concat(i, "_").concat($bf96816123756e36$var$now);
}
function $bf96816123756e36$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $bf96816123756e36$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
}
function $bf96816123756e36$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $kC6G7.FormatError)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $kC6G7.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $dlKY2.filterProps)(options, $bf96816123756e36$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === 'object') {
                var id = $bf96816123756e36$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $2HjL4.__assign)((0, $2HjL4.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $1DT17.IntlFormatError)('Error formatting list.', locale, e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("bxuKN", function(module, exports) {

$parcel$export(module.exports, "formatDisplayName", function () { return $866aa1d8a8c281fe$export$62fe1a4d9e891fa2; });

var $dlKY2 = parcelRequire("dlKY2");

var $kC6G7 = parcelRequire("kC6G7");

var $1DT17 = parcelRequire("1DT17");
var $866aa1d8a8c281fe$var$DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
    'languageDisplay'
];
function $866aa1d8a8c281fe$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $kC6G7.FormatError)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $kC6G7.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $dlKY2.filterProps)(options, $866aa1d8a8c281fe$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $1DT17.IntlFormatError)('Error formatting display name.', locale, e));
    }
}

});




parcelRegister("6T9dz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $503f079c6cd23a9c$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $2HjL4 = parcelRequire("2HjL4");

var $91i6m = parcelRequire("91i6m");

var $2imbu = parcelRequire("2imbu");

var $leG06 = parcelRequire("leG06");
function $503f079c6cd23a9c$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $2HjL4.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $2HjL4.__rest)(nextProps, [
        "values"
    ]);
    return (0, $2imbu.shallowEqual)(nextValues, values) && (0, $2imbu.shallowEqual)(otherProps, nextOtherProps);
}
function $503f079c6cd23a9c$var$FormattedMessage(props) {
    var intl = (0, $leG06.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $91i6m.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $91i6m.createElement(Component, null, $91i6m.Children.toArray(nodes));
    return $91i6m.createElement($91i6m.Fragment, null, nodes);
}
$503f079c6cd23a9c$var$FormattedMessage.displayName = 'FormattedMessage';
var $503f079c6cd23a9c$var$MemoizedFormattedMessage = $91i6m.memo($503f079c6cd23a9c$var$FormattedMessage, $503f079c6cd23a9c$var$areEqual);
$503f079c6cd23a9c$var$MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
var $503f079c6cd23a9c$export$2e2bcd8739ae039 = $503f079c6cd23a9c$var$MemoizedFormattedMessage;

});



parcelRegister("lodUs", function(module, exports) {

$parcel$export(module.exports, "preloadAppState", function () { return $150b9cee14f1400c$export$b2d23fea71dbec1b; });
$parcel$export(module.exports, "buildMicrobranding", function () { return $150b9cee14f1400c$export$4cd70f9ecbebfa45; });
$parcel$export(module.exports, "buildInitialState", function () { return $150b9cee14f1400c$export$2a115e4c5d766179; });
$parcel$export(module.exports, "createAnalyticsClient", function () { return $150b9cee14f1400c$export$3d970ca206012d6b; });
$parcel$export(module.exports, "startupAnalyticEvent", function () { return $150b9cee14f1400c$export$514076659add65b6; });
$parcel$export(module.exports, "pushGlobals", function () { return $150b9cee14f1400c$export$fac9d5c57cee7357; });
$parcel$export(module.exports, "initCastle", function () { return $150b9cee14f1400c$export$22e481f8c6e85dea; });

var $1Fos3 = parcelRequire("1Fos3");

var $26Riy = parcelRequire("26Riy");

var $lXPI9 = parcelRequire("lXPI9");

var $7eeh4 = parcelRequire("7eeh4");

var $bx5EQ = parcelRequire("bx5EQ");

var $7me1n = parcelRequire("7me1n");

var $1KCn1 = parcelRequire("1KCn1");

var $6jKHi = parcelRequire("6jKHi");

var $1V2cH = parcelRequire("1V2cH");

var $UKWGN = parcelRequire("UKWGN");

var $bqdjD = parcelRequire("bqdjD");

var $49Pnv = parcelRequire("49Pnv");

var $MAUh6 = parcelRequire("MAUh6");
function $150b9cee14f1400c$export$b2d23fea71dbec1b() {
    try {
        const el = document.body;
        return JSON.parse(el && el.getAttribute('data-app-state') || 'null');
    } catch (e) {
        return null;
    }
}
async function $150b9cee14f1400c$var$fetchAppState() {
    try {
        return await Promise.race([
            fetch(`${(0, $bqdjD.idacOrigin)}/frontend/state`, {
                mode: 'cors',
                credentials: 'include'
            }).then((res)=>{
                if (res.status === 200) return res.json();
                else throw new Error(`Failed to fetch app state: ${res.status} ${res.statusText}`);
            }),
            new Promise((_, reject)=>{
                const timeoutMs = 10000;
                setTimeout(()=>reject(new Error(`Fetching app state timed out after ${timeoutMs}ms`)), timeoutMs);
            })
        ]);
    } catch (e) {
        (0, $49Pnv.captureException)(e);
        return null;
    }
}
function $150b9cee14f1400c$export$4cd70f9ecbebfa45(oidcContext) {
    const isEmbedded = /AtlassianMobileApp|HipChat/.test(navigator.userAgent);
    const isMobileApp = isEmbedded || (0, $7eeh4.isMobileOidc)(oidcContext) || false;
    return {
        isEmbedded: isEmbedded,
        isAnyMobile: (0, $26Riy.screenSize)() === 'mobile' || isMobileApp,
        isMobileApp: isMobileApp,
        screenSize: (0, $26Riy.screenSize)(),
        oidcContext: oidcContext
    };
}
async function $150b9cee14f1400c$export$2a115e4c5d766179(preloaded) {
    const microbranding = $150b9cee14f1400c$export$4cd70f9ecbebfa45(preloaded === null || preloaded === void 0 ? void 0 : preloaded.oidcContext);
    if (!preloaded) {
        const fetched = await $150b9cee14f1400c$var$fetchAppState();
        return {
            initialStoreState: {
                csrfToken: fetched === null || fetched === void 0 ? void 0 : fetched.csrfToken,
                user: undefined,
                login: undefined,
                logout: undefined,
                appConfig: fetched === null || fetched === void 0 ? void 0 : fetched.appConfig,
                locale: fetched === null || fetched === void 0 ? void 0 : fetched.locale,
                continueAs: undefined,
                cancelDeletion: undefined,
                selectAccount: undefined,
                microbranding: $150b9cee14f1400c$export$4cd70f9ecbebfa45(fetched === null || fetched === void 0 ? void 0 : fetched.oidcContext),
                createAccount: undefined,
                context: {
                    tenantCloudId: fetched === null || fetched === void 0 ? void 0 : fetched.tenantCloudId,
                    userId: undefined
                },
                migrateConfirmation: undefined,
                welcome: undefined,
                socialLoginRecovery: undefined,
                verifyEmail: undefined,
                verifyEmailSent: undefined,
                changeEmail: undefined,
                changePassword: undefined,
                welcomeSent: undefined,
                serverError: undefined,
                cobranding: fetched === null || fetched === void 0 ? void 0 : fetched.cobranding,
                stepUp: undefined,
                stepUpSso: undefined,
                verifyEmailOtp: undefined,
                loginConsent: undefined
            },
            cspNonce: (fetched === null || fetched === void 0 ? void 0 : fetched.cspNonce) || ''
        };
    }
    const loginState = preloaded.login && (0, $1Fos3._)({}, (0, $lXPI9.defaultState), preloaded.login);
    return {
        initialStoreState: {
            csrfToken: preloaded.csrfToken,
            hashedCsrfToken: preloaded.hashedCsrfToken,
            user: preloaded.user,
            login: loginState,
            logout: preloaded.logout,
            appConfig: preloaded.appConfig,
            locale: preloaded.locale,
            continueAs: preloaded.continueAs,
            cancelDeletion: preloaded.cancelDeletion,
            selectAccount: preloaded.selectAccount,
            microbranding: microbranding,
            createAccount: preloaded.createAccount,
            context: {
                tenantCloudId: preloaded.tenantCloudId,
                userId: preloaded.userId
            },
            migrateConfirmation: preloaded.migrateConfirmation,
            signup: (0, $1Fos3._)({}, (0, $7me1n.defaultState), preloaded.signup),
            welcome: (0, $1Fos3._)({}, (0, $1KCn1.defaultState), preloaded.welcome),
            socialLoginRecovery: preloaded.socialLoginRecovery,
            verifyEmail: preloaded.verifyEmail,
            verifyEmailSent: preloaded.verifyEmailSent,
            changeEmail: preloaded.changeEmail,
            changePassword: (0, $1Fos3._)({}, (0, $bx5EQ.defaultState), preloaded.changePassword),
            welcomeSent: preloaded.welcomeSent,
            serverError: preloaded.error,
            cobranding: preloaded.cobranding,
            multiFactor: (0, $1Fos3._)({}, (0, $UKWGN.defaultState), preloaded.multiFactor),
            stepUp: preloaded.stepUp,
            stepUpSso: preloaded.stepUpSso,
            verifyEmailOtp: (0, $1Fos3._)({}, (0, $6jKHi.defaultState), preloaded.verifyEmailOtp),
            loginConsent: (0, $1Fos3._)({}, (0, $MAUh6.defaultState), preloaded.loginConsent)
        },
        cspNonce: preloaded.cspNonce
    };
}
function $150b9cee14f1400c$export$3d970ca206012d6b(initialState) {
    const { microbranding: microbranding, cobranding: cobranding, context: context } = initialState.initialStoreState;
    const locale = undefined;
    return new (0, $1V2cH.AnalyticsClientImpl)({
        microbranding: microbranding,
        cobranding: cobranding || {},
        locale: locale,
        tenantCloudId: context.tenantCloudId,
        userId: context.userId,
        client: undefined
    });
}
function $150b9cee14f1400c$export$514076659add65b6(analyticsClient) {
    analyticsClient.operationalEvent({
        page: 'unknown',
        action: 'loadPage',
        subject: 'sli'
    });
}
function $150b9cee14f1400c$export$fac9d5c57cee7357(appConfig, cspNonce) {
    window.segmentIoKey = appConfig && appConfig.segmentIoKey;
    window.cspNonce = cspNonce;
}

function $150b9cee14f1400c$export$22e481f8c6e85dea(appConfig) {
    if ((0, $bqdjD.currentCloudType) !== 'commercial') return; // Castle is not enabled for FedRAMP
    if (appConfig.castlePublishableApiKey) (parcelRequire("jEJQB")).then(({ configure: configure })=>{
        configure({
            pk: appConfig.castlePublishableApiKey
        });
    });
}

});
parcelRegister("26Riy", function(module, exports) {

$parcel$export(module.exports, "media", function () { return $71484931e1cb6667$export$987d49ffe1b0900f; });
$parcel$export(module.exports, "screenSizeMatcher", function () { return $71484931e1cb6667$export$417d65d80b205866; });
$parcel$export(module.exports, "screenSize", function () { return $71484931e1cb6667$export$463d066e8ee12fba; });

var $1Fos3 = parcelRequire("1Fos3");

var $boAHD = parcelRequire("boAHD");

var $6e88g = parcelRequire("6e88g");
let $71484931e1cb6667$var$_ = (t)=>t, $71484931e1cb6667$var$t;
const $71484931e1cb6667$var$mobileMaxWidth = `${(0, $6e88g.gridSize)() * 100}px`;
const $71484931e1cb6667$var$mediaQueryCss = (query)=>(...args)=>{
        // @ts-ignore
        const inner = (0, $boAHD.css)(...args);
        return (0, $boAHD.css)($71484931e1cb6667$var$t || ($71484931e1cb6667$var$t = $71484931e1cb6667$var$_`
      @media ${0} {
        ${0}
      }
    `), query, inner);
    };
const $71484931e1cb6667$var$mediaQuery = {
    handheldQuery: `(max-width: ${$71484931e1cb6667$var$mobileMaxWidth})`
};
const $71484931e1cb6667$export$987d49ffe1b0900f = (0, $1Fos3._)({
    handheld: $71484931e1cb6667$var$mediaQueryCss($71484931e1cb6667$var$mediaQuery.handheldQuery)
}, $71484931e1cb6667$var$mediaQuery);
const $71484931e1cb6667$export$417d65d80b205866 = window.matchMedia && window.matchMedia($71484931e1cb6667$export$987d49ffe1b0900f.handheldQuery);
const $71484931e1cb6667$export$463d066e8ee12fba = ()=>$71484931e1cb6667$export$417d65d80b205866 ? $71484931e1cb6667$export$417d65d80b205866.matches ? 'mobile' : 'desktop' : 'unknown';
const $71484931e1cb6667$var$maxWidth = (screenSize)=>{
    switch(screenSize){
        case 'mobile':
            return $71484931e1cb6667$var$mobileMaxWidth;
        default:
            return '100%';
    }
};
const $71484931e1cb6667$export$d7b7311ec04a3e8f = (screenSize, name)=>{
    const viewport = {};
    viewport[screenSize] = {
        name: name ? name : screenSize,
        styles: {
            width: $71484931e1cb6667$var$maxWidth(screenSize),
            height: '100%'
        }
    };
    return viewport;
};

});
parcelRegister("6e88g", function(module, exports) {

$parcel$export(module.exports, "borderRadius", function () { return $488a5bcd21b8518e$export$7a57f79000377ca2; });
$parcel$export(module.exports, "gridSize", function () { return $488a5bcd21b8518e$export$6d8204c2cb2e06b8; });

var $5RmjO = parcelRequire("5RmjO");

var $kLNLK = parcelRequire("kLNLK");
var $488a5bcd21b8518e$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $488a5bcd21b8518e$export$c93026a968943f95 = 'light';
var $488a5bcd21b8518e$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $488a5bcd21b8518e$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $488a5bcd21b8518e$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $488a5bcd21b8518e$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $kLNLK.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $488a5bcd21b8518e$export$6d8204c2cb2e06b8() / 4;
    (0, $5RmjO.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $488a5bcd21b8518e$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $488a5bcd21b8518e$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $488a5bcd21b8518e$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $5RmjO.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $488a5bcd21b8518e$export$ba1d834b86d72a09 = $488a5bcd21b8518e$export$a1b3edb637fb4f35;
var $488a5bcd21b8518e$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $kLNLK.N20A), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $kLNLK.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $kLNLK.N30A), ")")
            }
        }
    };
};

});
parcelRegister("5RmjO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $444336f8319860cc$export$2e2bcd8739ae039; });

var $37EPr = parcelRequire("37EPr");

var $e08gr = parcelRequire("e08gr");
function $444336f8319860cc$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $37EPr.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $444336f8319860cc$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $e08gr;
}

});
parcelRegister("37EPr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2461b245f5853eac$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $2461b245f5853eac$var$printed = {};
function $2461b245f5853eac$export$2e2bcd8739ae039(message) {
    if ($2461b245f5853eac$var$printed[message]) return;
    $2461b245f5853eac$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});


parcelRegister("kLNLK", function(module, exports) {

$parcel$export(module.exports, "R50", function () { return $f1eecd9145f94190$export$4b84fd0e2c617bd; });
$parcel$export(module.exports, "R75", function () { return $f1eecd9145f94190$export$b34b069eff244586; });
$parcel$export(module.exports, "R100", function () { return $f1eecd9145f94190$export$be802dd0d8b57f35; });
$parcel$export(module.exports, "R200", function () { return $f1eecd9145f94190$export$60847d42f9da92a6; });
$parcel$export(module.exports, "R300", function () { return $f1eecd9145f94190$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $f1eecd9145f94190$export$2010d0fb4295b346; });
$parcel$export(module.exports, "R500", function () { return $f1eecd9145f94190$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y50", function () { return $f1eecd9145f94190$export$8d9596b529bbb9cf; });
$parcel$export(module.exports, "Y75", function () { return $f1eecd9145f94190$export$41060a744ab0b7ae; });
$parcel$export(module.exports, "Y100", function () { return $f1eecd9145f94190$export$1cc05bbbf340e559; });
$parcel$export(module.exports, "Y200", function () { return $f1eecd9145f94190$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Y300", function () { return $f1eecd9145f94190$export$c6930421db9fa514; });
$parcel$export(module.exports, "Y400", function () { return $f1eecd9145f94190$export$59619663aa6500fb; });
$parcel$export(module.exports, "Y500", function () { return $f1eecd9145f94190$export$874739ea9e379ab6; });
$parcel$export(module.exports, "G50", function () { return $f1eecd9145f94190$export$8a6341c32b6a3ee6; });
$parcel$export(module.exports, "G75", function () { return $f1eecd9145f94190$export$69a3bf21b9686c2b; });
$parcel$export(module.exports, "G100", function () { return $f1eecd9145f94190$export$afbce1382ec95f73; });
$parcel$export(module.exports, "G200", function () { return $f1eecd9145f94190$export$747d86715d4175de; });
$parcel$export(module.exports, "G300", function () { return $f1eecd9145f94190$export$940e1f69e873f202; });
$parcel$export(module.exports, "G400", function () { return $f1eecd9145f94190$export$a49394138f7b8e85; });
$parcel$export(module.exports, "G500", function () { return $f1eecd9145f94190$export$6fa04827ac68a4fb; });
$parcel$export(module.exports, "B50", function () { return $f1eecd9145f94190$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $f1eecd9145f94190$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $f1eecd9145f94190$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $f1eecd9145f94190$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $f1eecd9145f94190$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $f1eecd9145f94190$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $f1eecd9145f94190$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "B600", function () { return $f1eecd9145f94190$export$67f15409e87642a1; });
$parcel$export(module.exports, "B700", function () { return $f1eecd9145f94190$export$f0539dbc42dbb067; });
$parcel$export(module.exports, "P50", function () { return $f1eecd9145f94190$export$363e4475840015bb; });
$parcel$export(module.exports, "P75", function () { return $f1eecd9145f94190$export$4b0a4417ed59760f; });
$parcel$export(module.exports, "P100", function () { return $f1eecd9145f94190$export$6011520a64d9a187; });
$parcel$export(module.exports, "P200", function () { return $f1eecd9145f94190$export$a7175d4e9206bc80; });
$parcel$export(module.exports, "P300", function () { return $f1eecd9145f94190$export$b48405b95304b5a1; });
$parcel$export(module.exports, "P400", function () { return $f1eecd9145f94190$export$c71e4279dd54a18d; });
$parcel$export(module.exports, "P500", function () { return $f1eecd9145f94190$export$147899de772240ec; });
$parcel$export(module.exports, "T50", function () { return $f1eecd9145f94190$export$2cf711fe14c66f06; });
$parcel$export(module.exports, "T75", function () { return $f1eecd9145f94190$export$7a8f4d33f6f9772c; });
$parcel$export(module.exports, "T100", function () { return $f1eecd9145f94190$export$776c9c497ef08533; });
$parcel$export(module.exports, "T200", function () { return $f1eecd9145f94190$export$69cb3ca10c1e330e; });
$parcel$export(module.exports, "T300", function () { return $f1eecd9145f94190$export$9dc1ef0f3f48059b; });
$parcel$export(module.exports, "T400", function () { return $f1eecd9145f94190$export$7c835c78b6fcdef8; });
$parcel$export(module.exports, "T500", function () { return $f1eecd9145f94190$export$6036577f95c3877e; });
$parcel$export(module.exports, "N0", function () { return $f1eecd9145f94190$export$29a4f05edc054374; });
$parcel$export(module.exports, "N10", function () { return $f1eecd9145f94190$export$e655ef011c4aa1a2; });
$parcel$export(module.exports, "N20", function () { return $f1eecd9145f94190$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $f1eecd9145f94190$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N40", function () { return $f1eecd9145f94190$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N50", function () { return $f1eecd9145f94190$export$8754fc7e6d8b3000; });
$parcel$export(module.exports, "N60", function () { return $f1eecd9145f94190$export$c2e91cbeada39b8b; });
$parcel$export(module.exports, "N70", function () { return $f1eecd9145f94190$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N80", function () { return $f1eecd9145f94190$export$eaa8c8a70ac22806; });
$parcel$export(module.exports, "N90", function () { return $f1eecd9145f94190$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N100", function () { return $f1eecd9145f94190$export$d6447c357493214f; });
$parcel$export(module.exports, "N200", function () { return $f1eecd9145f94190$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N300", function () { return $f1eecd9145f94190$export$e2ef2124cf4024b1; });
$parcel$export(module.exports, "N400", function () { return $f1eecd9145f94190$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $f1eecd9145f94190$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N600", function () { return $f1eecd9145f94190$export$7090862dc3038a9f; });
$parcel$export(module.exports, "N700", function () { return $f1eecd9145f94190$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $f1eecd9145f94190$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N900", function () { return $f1eecd9145f94190$export$fbda843f0a27fe96; });
$parcel$export(module.exports, "N10A", function () { return $f1eecd9145f94190$export$791e57b27ca738ef; });
$parcel$export(module.exports, "N20A", function () { return $f1eecd9145f94190$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $f1eecd9145f94190$export$920c0d5c49070351; });
$parcel$export(module.exports, "N40A", function () { return $f1eecd9145f94190$export$46987b49aab6d1a8; });
$parcel$export(module.exports, "N50A", function () { return $f1eecd9145f94190$export$7d3359664e8bb0e5; });
$parcel$export(module.exports, "N60A", function () { return $f1eecd9145f94190$export$d2d3bedfb276cac0; });
$parcel$export(module.exports, "N70A", function () { return $f1eecd9145f94190$export$6e5e7499ff054f6d; });
$parcel$export(module.exports, "N80A", function () { return $f1eecd9145f94190$export$59264b346c877fa7; });
$parcel$export(module.exports, "N90A", function () { return $f1eecd9145f94190$export$d092757d7c64925c; });
$parcel$export(module.exports, "N100A", function () { return $f1eecd9145f94190$export$486ab785e4bac3c6; });
$parcel$export(module.exports, "N200A", function () { return $f1eecd9145f94190$export$fba592bbc6419fea; });
$parcel$export(module.exports, "N300A", function () { return $f1eecd9145f94190$export$13609db0e6812ab8; });
$parcel$export(module.exports, "N400A", function () { return $f1eecd9145f94190$export$fbae4efaa892d883; });
$parcel$export(module.exports, "N500A", function () { return $f1eecd9145f94190$export$f13946d26f440ce6; });
$parcel$export(module.exports, "N600A", function () { return $f1eecd9145f94190$export$19f58225ac52a306; });
$parcel$export(module.exports, "N700A", function () { return $f1eecd9145f94190$export$6384f09da70e7b62; });
$parcel$export(module.exports, "N800A", function () { return $f1eecd9145f94190$export$d0dccc730683edc2; });
$parcel$export(module.exports, "DN900", function () { return $f1eecd9145f94190$export$2f6319cf7d736c2a; });
$parcel$export(module.exports, "DN800", function () { return $f1eecd9145f94190$export$95126bc8884d6634; });
$parcel$export(module.exports, "DN700", function () { return $f1eecd9145f94190$export$8338d8c35d44ff1; });
$parcel$export(module.exports, "DN600", function () { return $f1eecd9145f94190$export$5368d76ae4fbbda7; });
$parcel$export(module.exports, "DN500", function () { return $f1eecd9145f94190$export$9f0a771d16ec8d36; });
$parcel$export(module.exports, "DN400", function () { return $f1eecd9145f94190$export$abcf8c38338b4aa5; });
$parcel$export(module.exports, "DN300", function () { return $f1eecd9145f94190$export$97e81faa16a182c7; });
$parcel$export(module.exports, "DN200", function () { return $f1eecd9145f94190$export$bfe21c59123ecf33; });
$parcel$export(module.exports, "DN100", function () { return $f1eecd9145f94190$export$ee82aa2ea6a1558; });
$parcel$export(module.exports, "DN90", function () { return $f1eecd9145f94190$export$682927c6ed76be02; });
$parcel$export(module.exports, "DN80", function () { return $f1eecd9145f94190$export$91fd9994c5be9757; });
$parcel$export(module.exports, "DN70", function () { return $f1eecd9145f94190$export$d281fbfe3cff2df6; });
$parcel$export(module.exports, "DN60", function () { return $f1eecd9145f94190$export$3902c91d8b98a753; });
$parcel$export(module.exports, "DN50", function () { return $f1eecd9145f94190$export$8e8133c1ba5845b5; });
$parcel$export(module.exports, "DN40", function () { return $f1eecd9145f94190$export$33ff357f6620b39; });
$parcel$export(module.exports, "DN30", function () { return $f1eecd9145f94190$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN20", function () { return $f1eecd9145f94190$export$9776a6e503bdbf76; });
$parcel$export(module.exports, "DN10", function () { return $f1eecd9145f94190$export$6c813d5160dff5db; });
$parcel$export(module.exports, "DN0", function () { return $f1eecd9145f94190$export$3d4f271a500072a; });
$parcel$export(module.exports, "DN800A", function () { return $f1eecd9145f94190$export$fe151285c22759ec; });
$parcel$export(module.exports, "DN700A", function () { return $f1eecd9145f94190$export$a101c6190d0da34; });
$parcel$export(module.exports, "DN600A", function () { return $f1eecd9145f94190$export$4b16f52932fda51; });
$parcel$export(module.exports, "DN500A", function () { return $f1eecd9145f94190$export$a74bcd7b9845b0d8; });
$parcel$export(module.exports, "DN400A", function () { return $f1eecd9145f94190$export$9209c179316d1751; });
$parcel$export(module.exports, "DN300A", function () { return $f1eecd9145f94190$export$88f55133f636c8dd; });
$parcel$export(module.exports, "DN200A", function () { return $f1eecd9145f94190$export$51126f85d1009512; });
$parcel$export(module.exports, "DN100A", function () { return $f1eecd9145f94190$export$a069b547bd23af78; });
$parcel$export(module.exports, "DN90A", function () { return $f1eecd9145f94190$export$40cce05af3b2600a; });
$parcel$export(module.exports, "DN80A", function () { return $f1eecd9145f94190$export$b78942185925a0d; });
$parcel$export(module.exports, "DN70A", function () { return $f1eecd9145f94190$export$e058fb44b8eaafca; });
$parcel$export(module.exports, "DN60A", function () { return $f1eecd9145f94190$export$92b0b8de26920c18; });
$parcel$export(module.exports, "DN50A", function () { return $f1eecd9145f94190$export$67564f7459d3fc9e; });
$parcel$export(module.exports, "DN40A", function () { return $f1eecd9145f94190$export$77868e1ca884ffa3; });
$parcel$export(module.exports, "DN30A", function () { return $f1eecd9145f94190$export$2afd71d7d3ea2cd5; });
$parcel$export(module.exports, "DN20A", function () { return $f1eecd9145f94190$export$f2a0acaab9972c70; });
$parcel$export(module.exports, "DN10A", function () { return $f1eecd9145f94190$export$9ab70e67d6475361; });
$parcel$export(module.exports, "T30", function () { return $f1eecd9145f94190$export$d2adc5dedf09fced; });
$parcel$export(module.exports, "L50", function () { return $f1eecd9145f94190$export$f51762073d2bb381; });
$parcel$export(module.exports, "L75", function () { return $f1eecd9145f94190$export$95e26d54def96891; });
// Reds
var $f1eecd9145f94190$export$4b84fd0e2c617bd = '#FFEBE6';
var $f1eecd9145f94190$export$b34b069eff244586 = '#FFBDAD';
var $f1eecd9145f94190$export$be802dd0d8b57f35 = '#FF8F73';
var $f1eecd9145f94190$export$60847d42f9da92a6 = '#FF7452';
var $f1eecd9145f94190$export$4a7404f376229999 = '#FF5630';
var $f1eecd9145f94190$export$2010d0fb4295b346 = '#DE350B';
var $f1eecd9145f94190$export$2837b5a1a71d5c02 = '#BF2600';
var $f1eecd9145f94190$export$8d9596b529bbb9cf = '#FFFAE6';
var $f1eecd9145f94190$export$41060a744ab0b7ae = '#FFF0B3';
var $f1eecd9145f94190$export$1cc05bbbf340e559 = '#FFE380';
var $f1eecd9145f94190$export$5aae31392d72caaa = '#FFC400';
var $f1eecd9145f94190$export$c6930421db9fa514 = '#FFAB00';
var $f1eecd9145f94190$export$59619663aa6500fb = '#FF991F';
var $f1eecd9145f94190$export$874739ea9e379ab6 = '#FF8B00';
var $f1eecd9145f94190$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $f1eecd9145f94190$export$69a3bf21b9686c2b = '#ABF5D1';
var $f1eecd9145f94190$export$afbce1382ec95f73 = '#79F2C0';
var $f1eecd9145f94190$export$747d86715d4175de = '#57D9A3';
var $f1eecd9145f94190$export$940e1f69e873f202 = '#36B37E';
var $f1eecd9145f94190$export$a49394138f7b8e85 = '#00875A';
var $f1eecd9145f94190$export$6fa04827ac68a4fb = '#006644';
var $f1eecd9145f94190$export$226de0355ed012f8 = '#DEEBFF';
var $f1eecd9145f94190$export$8c13c2ee36917869 = '#B3D4FF';
var $f1eecd9145f94190$export$ecfc1dff386a3e7a = '#4C9AFF';
var $f1eecd9145f94190$export$215b7063051591f1 = '#2684FF';
var $f1eecd9145f94190$export$e62e8919cca44969 = '#0065FF';
var $f1eecd9145f94190$export$b3de0ae08da2ce64 = '#0052CC';
var $f1eecd9145f94190$export$a6ee3d71bc067634 = '#0747A6';
var $f1eecd9145f94190$export$67f15409e87642a1 = '#669DF1';
var $f1eecd9145f94190$export$f0539dbc42dbb067 = '#8FB8F6';
var $f1eecd9145f94190$export$363e4475840015bb = '#EAE6FF';
var $f1eecd9145f94190$export$4b0a4417ed59760f = '#C0B6F2';
var $f1eecd9145f94190$export$6011520a64d9a187 = '#998DD9';
var $f1eecd9145f94190$export$a7175d4e9206bc80 = '#8777D9';
var $f1eecd9145f94190$export$b48405b95304b5a1 = '#6554C0';
var $f1eecd9145f94190$export$c71e4279dd54a18d = '#5243AA';
var $f1eecd9145f94190$export$147899de772240ec = '#403294';
var $f1eecd9145f94190$export$2cf711fe14c66f06 = '#E6FCFF';
var $f1eecd9145f94190$export$7a8f4d33f6f9772c = '#B3F5FF';
var $f1eecd9145f94190$export$776c9c497ef08533 = '#79E2F2';
var $f1eecd9145f94190$export$69cb3ca10c1e330e = '#00C7E6';
var $f1eecd9145f94190$export$9dc1ef0f3f48059b = '#00B8D9';
var $f1eecd9145f94190$export$7c835c78b6fcdef8 = '#00A3BF';
var $f1eecd9145f94190$export$6036577f95c3877e = '#008DA6';
var $f1eecd9145f94190$export$29a4f05edc054374 = '#FFFFFF';
var $f1eecd9145f94190$export$e655ef011c4aa1a2 = '#FAFBFC';
var $f1eecd9145f94190$export$9fdfb749e33cdf97 = '#F4F5F7';
var $f1eecd9145f94190$export$3e51e8f1440314ba = '#EBECF0';
var $f1eecd9145f94190$export$1ce2d1575d444ceb = '#DFE1E6';
var $f1eecd9145f94190$export$8754fc7e6d8b3000 = '#C1C7D0';
var $f1eecd9145f94190$export$c2e91cbeada39b8b = '#B3BAC5';
var $f1eecd9145f94190$export$5f71e19f3a7ad9de = '#A5ADBA';
var $f1eecd9145f94190$export$eaa8c8a70ac22806 = '#97A0AF';
var $f1eecd9145f94190$export$7c87d337fb91a97d = '#8993A4';
var $f1eecd9145f94190$export$d6447c357493214f = '#7A869A';
var $f1eecd9145f94190$export$f563ee71e9ee74cd = '#6B778C';
var $f1eecd9145f94190$export$e2ef2124cf4024b1 = '#5E6C84';
var $f1eecd9145f94190$export$eece5f492e429f08 = '#505F79';
var $f1eecd9145f94190$export$c39c0fe0f26207ae = '#42526E';
var $f1eecd9145f94190$export$7090862dc3038a9f = '#344563';
var $f1eecd9145f94190$export$ad0bacf983b7ddaa = '#253858';
var $f1eecd9145f94190$export$7d61b15e0da132af = '#172B4D';
var $f1eecd9145f94190$export$fbda843f0a27fe96 = '#091E42';
var $f1eecd9145f94190$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $f1eecd9145f94190$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $f1eecd9145f94190$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $f1eecd9145f94190$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $f1eecd9145f94190$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $f1eecd9145f94190$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $f1eecd9145f94190$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $f1eecd9145f94190$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $f1eecd9145f94190$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $f1eecd9145f94190$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $f1eecd9145f94190$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $f1eecd9145f94190$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $f1eecd9145f94190$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $f1eecd9145f94190$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $f1eecd9145f94190$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $f1eecd9145f94190$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $f1eecd9145f94190$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $f1eecd9145f94190$export$2f6319cf7d736c2a = '#E6EDFA';
var $f1eecd9145f94190$export$95126bc8884d6634 = '#DCE5F5';
var $f1eecd9145f94190$export$8338d8c35d44ff1 = '#CED9EB';
var $f1eecd9145f94190$export$5368d76ae4fbbda7 = '#B8C7E0';
var $f1eecd9145f94190$export$9f0a771d16ec8d36 = '#ABBBD6';
var $f1eecd9145f94190$export$abcf8c38338b4aa5 = '#9FB0CC';
var $f1eecd9145f94190$export$97e81faa16a182c7 = '#8C9CB8';
var $f1eecd9145f94190$export$bfe21c59123ecf33 = '#7988A3';
var $f1eecd9145f94190$export$ee82aa2ea6a1558 = '#67758F';
var $f1eecd9145f94190$export$682927c6ed76be02 = '#56637A';
var $f1eecd9145f94190$export$91fd9994c5be9757 = '#455166';
var $f1eecd9145f94190$export$d281fbfe3cff2df6 = '#3B475C';
var $f1eecd9145f94190$export$3902c91d8b98a753 = '#313D52';
var $f1eecd9145f94190$export$8e8133c1ba5845b5 = '#283447';
var $f1eecd9145f94190$export$33ff357f6620b39 = '#202B3D';
var $f1eecd9145f94190$export$633847cf062b69e0 = '#1B2638';
var $f1eecd9145f94190$export$9776a6e503bdbf76 = '#121A29';
var $f1eecd9145f94190$export$6c813d5160dff5db = '#0E1624';
var $f1eecd9145f94190$export$3d4f271a500072a = '#0D1424';
var $f1eecd9145f94190$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $f1eecd9145f94190$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $f1eecd9145f94190$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $f1eecd9145f94190$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $f1eecd9145f94190$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $f1eecd9145f94190$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $f1eecd9145f94190$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $f1eecd9145f94190$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $f1eecd9145f94190$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $f1eecd9145f94190$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $f1eecd9145f94190$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $f1eecd9145f94190$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $f1eecd9145f94190$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $f1eecd9145f94190$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $f1eecd9145f94190$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $f1eecd9145f94190$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $f1eecd9145f94190$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $f1eecd9145f94190$export$d2adc5dedf09fced = '#292A2E';
var $f1eecd9145f94190$export$f51762073d2bb381 = '#94C748';
var $f1eecd9145f94190$export$95e26d54def96891 = '#B3DF72';

});



parcelRegister("jEJQB", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("hQDxa")).then(()=>parcelRequire('7FBZw'));

});


parcelRegister("gCn4g", function(module, exports) {

$parcel$export(module.exports, "resetAppState", function () { return $8f8ec199d7ae58ec$export$10d871c0f32f1a89; });

var $2aGBJ = parcelRequire("2aGBJ");
const $8f8ec199d7ae58ec$export$10d871c0f32f1a89 = (data)=>({
        type: (0, $2aGBJ.RESET_APP_STATE),
        data: data
    });

});


parcelRegister("iCwDt", function(module, exports) {
$parcel$export(module.exports, "connect", function () { return (parcelRequire("bBJZC")).default; });
$parcel$export(module.exports, "Provider", function () { return (parcelRequire("49swM")).default; });
$parcel$export(module.exports, "useDispatch", function () { return (parcelRequire("eOclC")).useDispatch; });
$parcel$export(module.exports, "useSelector", function () { return (parcelRequire("2rfZC")).useSelector; });
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $1jUfn = parcelRequire("1jUfn");

var $6LUU1 = parcelRequire("6LUU1");
parcelRequire("8BM6A");
var $eAqbf = parcelRequire("eAqbf");

var $b2Qbv = parcelRequire("b2Qbv");

var $2rfZC = parcelRequire("2rfZC");

var $bBJZC = parcelRequire("bBJZC");
parcelRequire("32cI2");
(0, $2rfZC.initializeUseSelector)((0, $6LUU1.useSyncExternalStoreWithSelector));
(0, $bBJZC.initializeConnect)((0, $1jUfn.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $b2Qbv.setBatch)((0, $eAqbf.unstable_batchedUpdates));

});
parcelRegister("6LUU1", function(module, exports) {
'use strict';

module.exports = (parcelRequire("kl10d"));

});

parcelRegister("8BM6A", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", function () { return (parcelRequire("eAqbf")).unstable_batchedUpdates; });

var $eAqbf = parcelRequire("eAqbf");

});

parcelRegister("b2Qbv", function(module, exports) {

$parcel$export(module.exports, "setBatch", function () { return $80a85c6611d19d91$export$4b9874722d0da7bc; });
$parcel$export(module.exports, "getBatch", function () { return $80a85c6611d19d91$export$fc47d4c0ba3bd2c6; });
// Default to a dummy "batch" implementation that just runs the callback
function $80a85c6611d19d91$var$defaultNoopBatch(callback) {
    callback();
}
let $80a85c6611d19d91$var$batch = $80a85c6611d19d91$var$defaultNoopBatch; // Allow injecting another batching function later
const $80a85c6611d19d91$export$4b9874722d0da7bc = (newBatch)=>$80a85c6611d19d91$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $80a85c6611d19d91$export$fc47d4c0ba3bd2c6 = ()=>$80a85c6611d19d91$var$batch;

});

parcelRegister("2rfZC", function(module, exports) {

$parcel$export(module.exports, "initializeUseSelector", function () { return $1c6a823d243bc71a$export$e2e6e3f3f3b782e3; });
$parcel$export(module.exports, "useSelector", function () { return $1c6a823d243bc71a$export$2105062e25df4afe; });

var $91i6m = parcelRequire("91i6m");

var $byiaT = parcelRequire("byiaT");

var $ilA7r = parcelRequire("ilA7r");

var $4uBLd = parcelRequire("4uBLd");
let $1c6a823d243bc71a$var$useSyncExternalStoreWithSelector = (0, $4uBLd.notInitialized);
const $1c6a823d243bc71a$export$e2e6e3f3f3b782e3 = (fn)=>{
    $1c6a823d243bc71a$var$useSyncExternalStoreWithSelector = fn;
};
const $1c6a823d243bc71a$var$refEquality = (a, b)=>a === b;
function $1c6a823d243bc71a$export$2b53f90d2bd1cbfb(context = (0, $ilA7r.ReactReduxContext)) {
    const useReduxContext = context === (0, $ilA7r.ReactReduxContext) ? (0, $byiaT.useReduxContext) : (0, $byiaT.createReduxContextHook)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $1c6a823d243bc71a$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === 'function' ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $91i6m.useRef)(true);
        const wrappedSelector = (0, $91i6m.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $1c6a823d243bc71a$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $91i6m.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $1c6a823d243bc71a$export$2105062e25df4afe = /*#__PURE__*/ $1c6a823d243bc71a$export$2b53f90d2bd1cbfb();

});
parcelRegister("byiaT", function(module, exports) {

$parcel$export(module.exports, "createReduxContextHook", function () { return $8690f7c9055e104f$export$d4d6226d5fc61558; });
$parcel$export(module.exports, "useReduxContext", function () { return $8690f7c9055e104f$export$c1275ca9a6fd3ec5; });

var $91i6m = parcelRequire("91i6m");

var $ilA7r = parcelRequire("ilA7r");
function $8690f7c9055e104f$export$d4d6226d5fc61558(context = (0, $ilA7r.ReactReduxContext)) {
    return function useReduxContext() {
        const contextValue = (0, $91i6m.useContext)(context);
        return contextValue;
    };
}
const $8690f7c9055e104f$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $8690f7c9055e104f$export$d4d6226d5fc61558();

});
parcelRegister("ilA7r", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", function () { return $d5b634a93ade801f$export$cc80c08dc91f1c00; });

var $91i6m = parcelRequire("91i6m");
const $d5b634a93ade801f$var$ContextKey = Symbol.for(`react-redux-context`);
const $d5b634a93ade801f$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $d5b634a93ade801f$var$getContext() {
    var _gT$ContextKey;
    if (!$91i6m.createContext) return {};
    const contextMap = (_gT$ContextKey = $d5b634a93ade801f$var$gT[$d5b634a93ade801f$var$ContextKey]) != null ? _gT$ContextKey : $d5b634a93ade801f$var$gT[$d5b634a93ade801f$var$ContextKey] = new Map();
    let realContext = contextMap.get($91i6m.createContext);
    if (!realContext) {
        realContext = $91i6m.createContext(null);
        contextMap.set($91i6m.createContext, realContext);
    }
    return realContext;
}
const $d5b634a93ade801f$export$cc80c08dc91f1c00 = /*#__PURE__*/ $d5b634a93ade801f$var$getContext();
var $d5b634a93ade801f$export$2e2bcd8739ae039 = $d5b634a93ade801f$export$cc80c08dc91f1c00;

});


parcelRegister("4uBLd", function(module, exports) {

$parcel$export(module.exports, "notInitialized", function () { return $3457413f7eee618d$export$20656a4825650bd0; });
const $3457413f7eee618d$export$20656a4825650bd0 = ()=>{
    throw new Error('uSES not initialized!');
};

});


parcelRegister("bBJZC", function(module, exports) {

$parcel$export(module.exports, "initializeConnect", function () { return $8736d39cb9e28456$export$36d45daa6a4925b8; });
$parcel$export(module.exports, "default", function () { return $8736d39cb9e28456$export$2e2bcd8739ae039; });

var $kOzMk = parcelRequire("kOzMk");

var $dDDP6 = parcelRequire("dDDP6");

var $kTpRR = parcelRequire("kTpRR");

var $91i6m = parcelRequire("91i6m");

var $jy6CJ = parcelRequire("jy6CJ");

var $bjEHm = parcelRequire("bjEHm");

var $4CU8Q = parcelRequire("4CU8Q");

var $c78j9 = parcelRequire("c78j9");

var $fDIbo = parcelRequire("fDIbo");

var $5iTk3 = parcelRequire("5iTk3");

var $eUKCR = parcelRequire("eUKCR");

var $8YwfY = parcelRequire("8YwfY");
parcelRequire("5VRCO");

var $ilA7r = parcelRequire("ilA7r");

var $4uBLd = parcelRequire("4uBLd");
const $8736d39cb9e28456$var$_excluded = [
    "reactReduxForwardedRef"
];
let $8736d39cb9e28456$var$useSyncExternalStore = (0, $4uBLd.notInitialized);
const $8736d39cb9e28456$export$36d45daa6a4925b8 = (fn)=>{
    $8736d39cb9e28456$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $8736d39cb9e28456$var$EMPTY_ARRAY = [
    null,
    0
];
const $8736d39cb9e28456$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $8736d39cb9e28456$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $8736d39cb9e28456$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $eUKCR.useIsomorphicLayoutEffect)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $8736d39cb9e28456$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $8736d39cb9e28456$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $8736d39cb9e28456$var$initStateUpdates = ()=>$8736d39cb9e28456$var$EMPTY_ARRAY;
function $8736d39cb9e28456$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $8736d39cb9e28456$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $8736d39cb9e28456$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $8736d39cb9e28456$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $8YwfY.default), areStatePropsEqual: areStatePropsEqual = (0, $8YwfY.default), areMergedPropsEqual: areMergedPropsEqual = (0, $8YwfY.default), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $ilA7r.ReactReduxContext) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $c78j9.mapStateToPropsFactory)(mapStateToProps);
    const initMapDispatchToProps = (0, $4CU8Q.mapDispatchToPropsFactory)(mapDispatchToProps);
    const initMergeProps = (0, $fDIbo.mergePropsFactory)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $91i6m.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $dDDP6.default)(props, $8736d39cb9e28456$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $91i6m.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $jy6CJ.isContextConsumer)(/*#__PURE__*/ $91i6m.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $91i6m.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $91i6m.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $bjEHm.default)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $91i6m.useMemo(()=>{
                if (!shouldHandleStateChanges) return $8736d39cb9e28456$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $5iTk3.createSubscription)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $91i6m.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $kOzMk.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $91i6m.useRef();
            const lastWrapperProps = $91i6m.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $91i6m.useRef();
            const renderIsScheduled = $91i6m.useRef(false);
            const isProcessingDispatch = $91i6m.useRef(false);
            const isMounted = $91i6m.useRef(false);
            const latestSubscriptionCallbackError = $91i6m.useRef();
            (0, $eUKCR.useIsomorphicLayoutEffect)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $91i6m.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $91i6m.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $8736d39cb9e28456$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $8736d39cb9e28456$var$useIsomorphicLayoutEffectWithArgs($8736d39cb9e28456$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $8736d39cb9e28456$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $eUKCR.useIsomorphicLayoutEffect)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $91i6m.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $91i6m.createElement(WrappedComponent, (0, $kOzMk.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $91i6m.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $91i6m.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $91i6m.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $91i6m.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $91i6m.createElement(Connect, (0, $kOzMk.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($kTpRR)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($kTpRR)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $8736d39cb9e28456$export$2e2bcd8739ae039 = $8736d39cb9e28456$var$connect;

});
parcelRegister("jy6CJ", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fEdd6"));

});

parcelRegister("bjEHm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83d109e3fc990ca3$export$2e2bcd8739ae039; });

var $dDDP6 = parcelRequire("dDDP6");
parcelRequire("c3wOK");
const $83d109e3fc990ca3$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $83d109e3fc990ca3$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $83d109e3fc990ca3$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $dDDP6.default)(_ref, $83d109e3fc990ca3$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $83d109e3fc990ca3$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("c3wOK", function(module, exports) {

var $5VRCO = parcelRequire("5VRCO");
function $8c6f38b963d1bdaa$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $5VRCO.default)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $8c6f38b963d1bdaa$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $8c6f38b963d1bdaa$var$verify(mapStateToProps, 'mapStateToProps');
    $8c6f38b963d1bdaa$var$verify(mapDispatchToProps, 'mapDispatchToProps');
    $8c6f38b963d1bdaa$var$verify(mergeProps, 'mergeProps');
}

});
parcelRegister("5VRCO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $451bdf6a5dffafc2$export$2e2bcd8739ae039; });
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $451bdf6a5dffafc2$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});



parcelRegister("4CU8Q", function(module, exports) {

$parcel$export(module.exports, "mapDispatchToPropsFactory", function () { return $35e64298ded628a2$export$b69a785ceac019a6; });

var $kEeIe = parcelRequire("kEeIe");

var $8La57 = parcelRequire("8La57");

var $eGNNU = parcelRequire("eGNNU");
function $35e64298ded628a2$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $8La57.wrapMapToPropsConstant)((dispatch)=>(0, $kEeIe.default)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $8La57.wrapMapToPropsConstant)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === 'function' ? (0, $8La57.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : (0, $eGNNU.createInvalidArgFactory)(mapDispatchToProps, 'mapDispatchToProps');
}

});
parcelRegister("kEeIe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f082f4a31ba4f82e$export$2e2bcd8739ae039; });
function $f082f4a31ba4f82e$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}

});

parcelRegister("8La57", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", function () { return $660a888463cf9147$export$710f7c60f68acd3e; });
$parcel$export(module.exports, "wrapMapToPropsFunc", function () { return $660a888463cf9147$export$8d46c7f53c8c602f; });
parcelRequire("iEbJZ");
function $660a888463cf9147$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $660a888463cf9147$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $660a888463cf9147$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $660a888463cf9147$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $660a888463cf9147$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("iEbJZ", function(module, exports) {

var $xY9yd = parcelRequire("xY9yd");

var $5VRCO = parcelRequire("5VRCO");
function $d93511e3b4aa75c4$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $xY9yd.default)(value)) (0, $5VRCO.default)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}

});
parcelRegister("xY9yd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0661be52fab4da99$export$2e2bcd8739ae039; });
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $0661be52fab4da99$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});



parcelRegister("eGNNU", function(module, exports) {

$parcel$export(module.exports, "createInvalidArgFactory", function () { return $ab1b9ef710a25b23$export$19ef7b929f7e2559; });
function $ab1b9ef710a25b23$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}

});


parcelRegister("c78j9", function(module, exports) {

$parcel$export(module.exports, "mapStateToPropsFactory", function () { return $8d1c9540b06a14ae$export$e00e93951827eda7; });

var $8La57 = parcelRequire("8La57");

var $eGNNU = parcelRequire("eGNNU");
function $8d1c9540b06a14ae$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $8La57.wrapMapToPropsConstant)(()=>({})) : typeof mapStateToProps === 'function' ? (0, $8La57.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : (0, $eGNNU.createInvalidArgFactory)(mapStateToProps, 'mapStateToProps');
}

});

parcelRegister("fDIbo", function(module, exports) {

$parcel$export(module.exports, "mergePropsFactory", function () { return $b62cc549347e54fe$export$17457cf6fa742f84; });

var $kOzMk = parcelRequire("kOzMk");
parcelRequire("iEbJZ");

var $eGNNU = parcelRequire("eGNNU");
function $b62cc549347e54fe$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $kOzMk.default)({}, ownProps, stateProps, dispatchProps);
}
function $b62cc549347e54fe$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $b62cc549347e54fe$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$b62cc549347e54fe$export$691c327fc30bc857 : typeof mergeProps === 'function' ? $b62cc549347e54fe$export$5b105939c84b5234(mergeProps) : (0, $eGNNU.createInvalidArgFactory)(mergeProps, 'mergeProps');
}

});

parcelRegister("5iTk3", function(module, exports) {

$parcel$export(module.exports, "createSubscription", function () { return $3dc98c16b291f56b$export$d567d2b9af322f8f; });

var $b2Qbv = parcelRequire("b2Qbv");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $3dc98c16b291f56b$var$createListenerCollection() {
    const batch = (0, $b2Qbv.getBatch)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $3dc98c16b291f56b$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $3dc98c16b291f56b$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $3dc98c16b291f56b$var$nullListeners; // Reasons to keep the subscription active
    let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $3dc98c16b291f56b$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $3dc98c16b291f56b$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}

});

parcelRegister("eUKCR", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $02cd547e18c3814f$export$700979bc83e7db82; });

var $91i6m = parcelRequire("91i6m");
const $02cd547e18c3814f$export$71594e8a50f746f4 = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
const $02cd547e18c3814f$export$700979bc83e7db82 = $02cd547e18c3814f$export$71594e8a50f746f4 ? $91i6m.useLayoutEffect : $91i6m.useEffect;

});

parcelRegister("8YwfY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $688cf2d43001115d$export$2e2bcd8739ae039; });
function $688cf2d43001115d$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $688cf2d43001115d$export$2e2bcd8739ae039(objA, objB) {
    if ($688cf2d43001115d$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$688cf2d43001115d$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});


parcelRegister("32cI2", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return (parcelRequire("49swM")).default; });
$parcel$export(module.exports, "connect", function () { return (parcelRequire("bBJZC")).default; });
$parcel$export(module.exports, "useDispatch", function () { return (parcelRequire("eOclC")).useDispatch; });
$parcel$export(module.exports, "useSelector", function () { return (parcelRequire("2rfZC")).useSelector; });

var $49swM = parcelRequire("49swM");

var $bBJZC = parcelRequire("bBJZC");

var $ilA7r = parcelRequire("ilA7r");

var $eOclC = parcelRequire("eOclC");

var $2rfZC = parcelRequire("2rfZC");

var $2qpBH = parcelRequire("2qpBH");

var $8YwfY = parcelRequire("8YwfY");
parcelRequire("adsjp");

});
parcelRegister("49swM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $305e21b8a5bd5321$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $ilA7r = parcelRequire("ilA7r");

var $5iTk3 = parcelRequire("5iTk3");

var $eUKCR = parcelRequire("eUKCR");
function $305e21b8a5bd5321$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = 'once', noopCheck: noopCheck = 'once' }) {
    const contextValue = $91i6m.useMemo(()=>{
        const subscription = (0, $5iTk3.createSubscription)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $91i6m.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $eUKCR.useIsomorphicLayoutEffect)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $ilA7r.ReactReduxContext); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $91i6m.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $305e21b8a5bd5321$export$2e2bcd8739ae039 = $305e21b8a5bd5321$var$Provider;

});

parcelRegister("eOclC", function(module, exports) {

$parcel$export(module.exports, "useDispatch", function () { return $ac7f50382cb5f39d$export$8ad76b76a4c905f8; });

var $ilA7r = parcelRequire("ilA7r");

var $2qpBH = parcelRequire("2qpBH");
function $ac7f50382cb5f39d$export$bc9b55530897c558(context = (0, $ilA7r.ReactReduxContext)) {
    const useStore = context === (0, $ilA7r.ReactReduxContext) ? (0, $2qpBH.useStore) : (0, $2qpBH.createStoreHook)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $ac7f50382cb5f39d$export$8ad76b76a4c905f8 = /*#__PURE__*/ $ac7f50382cb5f39d$export$bc9b55530897c558();

});
parcelRegister("2qpBH", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", function () { return $1c41df7c11a166ac$export$671dba69185d0304; });
$parcel$export(module.exports, "useStore", function () { return $1c41df7c11a166ac$export$6ccbb43953eebf8; });

var $ilA7r = parcelRequire("ilA7r");

var $byiaT = parcelRequire("byiaT");
function $1c41df7c11a166ac$export$671dba69185d0304(context = (0, $ilA7r.ReactReduxContext)) {
    const useReduxContext = context === (0, $ilA7r.ReactReduxContext) ? (0, $byiaT.useReduxContext) : (0, $byiaT.createReduxContextHook)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $1c41df7c11a166ac$export$6ccbb43953eebf8 = /*#__PURE__*/ $1c41df7c11a166ac$export$671dba69185d0304();

});


parcelRegister("adsjp", function(module, exports) {

});




parcelRegister("1KJSO", function(module, exports) {

$parcel$export(module.exports, "getFfsId", function () { return $a15948aa575c48ea$export$3b0e089e98b45efa; });

var $1VX1s = parcelRequire("1VX1s");
const $a15948aa575c48ea$var$FFS_ID_KEY = 'atlassian.account.ffs.id';
function $a15948aa575c48ea$export$3b0e089e98b45efa() {
    const ffsId = (0, (/*@__PURE__*/$parcel$interopDefault($1VX1s))).get($a15948aa575c48ea$var$FFS_ID_KEY);
    return ffsId && ffsId.replace(/(^")|("$)/g, '');
}

});

parcelRegister("497Dz", function(module, exports) {

$parcel$export(module.exports, "FeatureGatesInit", function () { return $ddfd10631bc638fa$export$8bae65f5bd3fcf07; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $8vTDo = parcelRequire("8vTDo");

var $c0Ow7 = parcelRequire("c0Ow7");

var $bqdjD = parcelRequire("bqdjD");

var $1HVXA = parcelRequire("1HVXA");
const $ddfd10631bc638fa$var$getLocalMode = ()=>(0, $bqdjD.currentEnv) === 'local';
const $ddfd10631bc638fa$var$getEnv = ()=>{
    switch(0, $bqdjD.currentEnv){
        case 'dev':
        case 'local':
            return (0, $c0Ow7.FeatureGateEnvironment).Development;
        case 'stg':
        case 'stg-fedm':
        case 'stg-ic':
            return (0, $c0Ow7.FeatureGateEnvironment).Staging;
        case 'prod':
        case 'prod-fedm':
        case 'prod-ic':
        default:
            return (0, $c0Ow7.FeatureGateEnvironment).Production;
    }
};
const $ddfd10631bc638fa$var$options = {
    targetApp: (0, $1HVXA.statsigTargetApp),
    environment: $ddfd10631bc638fa$var$getEnv(),
    apiKey: (0, $1HVXA.getStatsigApiKey)(),
    localMode: $ddfd10631bc638fa$var$getLocalMode()
};
const $ddfd10631bc638fa$export$8bae65f5bd3fcf07 = ({ identifiers: identifiers, onReady: onReady })=>{
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8vTDo.FeatureGatesInitialization), {
        enabled: true,
        identifiers: identifiers,
        options: $ddfd10631bc638fa$var$options,
        onReady: onReady
    });
};

});
parcelRegister("8vTDo", function(module, exports) {
"use strict";
var $632c5fc824ce28a7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $632c5fc824ce28a7$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $632c5fc824ce28a7$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$632c5fc824ce28a7$var$__exportStar((parcelRequire("liLCv")), module.exports);

$632c5fc824ce28a7$var$__exportStar((parcelRequire("9MbV3")), module.exports);

$632c5fc824ce28a7$var$__exportStar((parcelRequire("ihr6n")), module.exports);

$632c5fc824ce28a7$var$__exportStar((parcelRequire("bgUzU")), module.exports);

$632c5fc824ce28a7$var$__exportStar((parcelRequire("akeIP")), module.exports);

});
parcelRegister("liLCv", function(module, exports) {
"use strict";
var $f82037c1e3965ae6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useExperimentValue = module.exports.useFeatureGate = void 0;

var $91i6m = parcelRequire("91i6m");

const $f82037c1e3965ae6$var$feature_gate_js_client_1 = $f82037c1e3965ae6$var$__importDefault((parcelRequire("kvUiC")));
const $f82037c1e3965ae6$var$useFeatureGate = (gateName, options = {})=>{
    const [gate, setGate] = (0, $91i6m.useState)(()=>$f82037c1e3965ae6$var$feature_gate_js_client_1.default.checkGate(gateName, options));
    (0, $91i6m.useEffect)(()=>{
        const onGateChange = (newValue)=>setGate(newValue);
        return $f82037c1e3965ae6$var$feature_gate_js_client_1.default.onGateUpdated(gateName, onGateChange, options);
    }, [
        gateName,
        options
    ]);
    return gate;
};
module.exports.useFeatureGate = $f82037c1e3965ae6$var$useFeatureGate;
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
const $f82037c1e3965ae6$var$useExperimentValue = (experimentName, parameterName, defaultValue, options = {})=>{
    const [experimentValue, setExperimentValue] = (0, $91i6m.useState)(()=>$f82037c1e3965ae6$var$feature_gate_js_client_1.default.getExperimentValue(experimentName, parameterName, defaultValue, options));
    (0, $91i6m.useEffect)(()=>{
        const onExperimentValueChange = (newValue)=>setExperimentValue(newValue);
        return $f82037c1e3965ae6$var$feature_gate_js_client_1.default.onExperimentValueUpdated(experimentName, parameterName, defaultValue, onExperimentValueChange, options);
    }, [
        experimentName,
        parameterName,
        defaultValue,
        options
    ]);
    return experimentValue;
};
module.exports.useExperimentValue = $f82037c1e3965ae6$var$useExperimentValue;

});
parcelRegister("kvUiC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("kRYwT")).default; });
$parcel$export(module.exports, "FeatureGateEnvironment", function () { return (parcelRequire("c0Ow7")).FeatureGateEnvironment; });
$parcel$export(module.exports, "PerimeterType", function () { return (parcelRequire("c0Ow7")).PerimeterType; });
$parcel$export(module.exports, "CLIENT_VERSION", function () { return (parcelRequire("i7Qvh")).CLIENT_VERSION; });
$parcel$export(module.exports, "DynamicConfig", function () { return (parcelRequire("5nkgG")).DynamicConfig; });
$parcel$export(module.exports, "Layer", function () { return (parcelRequire("etNe6")).Layer; });
$parcel$export(module.exports, "EvaluationReason", function () { return (parcelRequire("4LQfc")).EvaluationReason; });
parcelRequire("kRYwT");
var $i7Qvh = parcelRequire("i7Qvh");
var $kRYwT = parcelRequire("kRYwT");
var $c0Ow7 = parcelRequire("c0Ow7");

var $5nkgG = parcelRequire("5nkgG");

var $etNe6 = parcelRequire("etNe6");

var $4LQfc = parcelRequire("4LQfc");

});


parcelRegister("9MbV3", function(module, exports) {
"use strict";
var $71e1d7a986ff4197$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitialization = void 0;

var $91i6m = parcelRequire("91i6m");

const $71e1d7a986ff4197$var$feature_gate_js_client_1 = $71e1d7a986ff4197$var$__importDefault((parcelRequire("kvUiC")));

var $bZZMK = parcelRequire("bZZMK");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $71e1d7a986ff4197$var$FeatureGatesInitialization = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializingComponent: initializingComponent, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $91i6m.useState)(!overrides && (0, $bZZMK.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $91i6m.useRef)(options);
    (0, $91i6m.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $91i6m.useEffect)(()=>{
        if (enabled) {
            if ((0, $bZZMK.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $bZZMK.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $71e1d7a986ff4197$var$feature_gate_js_client_1.default.initializeCalled() ? $71e1d7a986ff4197$var$feature_gate_js_client_1.default.updateUser(optionsRef.current, identifiers, customAttributes) : $71e1d7a986ff4197$var$feature_gate_js_client_1.default.initialize(optionsRef.current, identifiers, customAttributes);
                initPromise.catch((err)=>(0, $bZZMK.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $bZZMK.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $bZZMK.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $bZZMK.pickChildToRender)(enabled, isInitialized, children, initializingComponent);
};
module.exports.FeatureGatesInitialization = $71e1d7a986ff4197$var$FeatureGatesInitialization;
module.exports.default = module.exports.FeatureGatesInitialization;

});
parcelRegister("bZZMK", function(module, exports) {
"use strict";
var $8bc55178be922343$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isClientAlreadyInCorrectState = $8bc55178be922343$var$isClientAlreadyInCorrectState;
module.exports.pickChildToRender = $8bc55178be922343$var$pickChildToRender;
module.exports.toError = $8bc55178be922343$var$toError;
module.exports.applyOverrides = $8bc55178be922343$var$applyOverrides;
module.exports.clearOverrides = $8bc55178be922343$var$clearOverrides;

const $8bc55178be922343$var$react_1 = $8bc55178be922343$var$__importDefault((parcelRequire("91i6m")));

const $8bc55178be922343$var$feature_gate_js_client_1 = $8bc55178be922343$var$__importDefault((parcelRequire("kvUiC")));
let $8bc55178be922343$var$hasWarnedAboutMissingOverrideSupport = false;
function $8bc55178be922343$var$isClientAlreadyInCorrectState(identifiers, customAttributes) {
    var _a, _b;
    // If either of these methods don't exist (ie. if the product is using <v4.2.0), then this method will always return false
    return ((_a = $8bc55178be922343$var$feature_gate_js_client_1.default.initializeCompleted) === null || _a === void 0 ? void 0 : _a.call($8bc55178be922343$var$feature_gate_js_client_1.default)) && ((_b = $8bc55178be922343$var$feature_gate_js_client_1.default.isCurrentUser) === null || _b === void 0 ? void 0 : _b.call($8bc55178be922343$var$feature_gate_js_client_1.default, identifiers, customAttributes));
}
function $8bc55178be922343$var$pickChildToRender(enabled, isInitialized, children, initializingComponent) {
    if (!enabled || isInitialized) return $8bc55178be922343$var$react_1.default.createElement($8bc55178be922343$var$react_1.default.Fragment, null, children);
    if (initializingComponent != null) return $8bc55178be922343$var$react_1.default.createElement($8bc55178be922343$var$react_1.default.Fragment, null, initializingComponent);
    return null;
}
function $8bc55178be922343$var$toError(err) {
    if (err instanceof Error) return err;
    return new Error(err === null || err === void 0 ? void 0 : err.toString());
}
function $8bc55178be922343$var$applyOverrides(overrides) {
    // Allow newer versions of the React SDK to be used with older v3.x JS client versions,
    // provided the caller does not try to leverage the overrides which were introduced in v4.
    if (overrides && (!$8bc55178be922343$var$feature_gate_js_client_1.default.overrideGate || !$8bc55178be922343$var$feature_gate_js_client_1.default.overrideConfig)) {
        if (!$8bc55178be922343$var$hasWarnedAboutMissingOverrideSupport) {
            console.warn('Overrides are only supported in @atlaskit/feature-gate-js-client v4.0.0+');
            $8bc55178be922343$var$hasWarnedAboutMissingOverrideSupport = true;
        }
        return;
    }
    Object.entries((overrides === null || overrides === void 0 ? void 0 : overrides.gates) || {}).forEach(([gateName, value])=>{
        var _a;
        (_a = $8bc55178be922343$var$feature_gate_js_client_1.default.overrideGate) === null || _a === void 0 || _a.call($8bc55178be922343$var$feature_gate_js_client_1.default, gateName, value);
    });
    Object.entries((overrides === null || overrides === void 0 ? void 0 : overrides.configs) || {}).forEach(([configName, values])=>{
        var _a;
        (_a = $8bc55178be922343$var$feature_gate_js_client_1.default.overrideConfig) === null || _a === void 0 || _a.call($8bc55178be922343$var$feature_gate_js_client_1.default, configName, values);
    });
}
function $8bc55178be922343$var$clearOverrides(overrides) {
    Object.keys((overrides === null || overrides === void 0 ? void 0 : overrides.gates) || {}).forEach((gateName)=>{
        var _a;
        (_a = $8bc55178be922343$var$feature_gate_js_client_1.default.clearGateOverride) === null || _a === void 0 || _a.call($8bc55178be922343$var$feature_gate_js_client_1.default, gateName);
    });
    Object.keys((overrides === null || overrides === void 0 ? void 0 : overrides.configs) || {}).forEach((configName)=>{
        var _a;
        (_a = $8bc55178be922343$var$feature_gate_js_client_1.default.clearConfigOverride) === null || _a === void 0 || _a.call($8bc55178be922343$var$feature_gate_js_client_1.default, configName);
    });
}

});


parcelRegister("ihr6n", function(module, exports) {
"use strict";
var $d4eed6605ce6db46$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithProvider = void 0;

var $91i6m = parcelRequire("91i6m");

const $d4eed6605ce6db46$var$feature_gate_js_client_1 = $d4eed6605ce6db46$var$__importDefault((parcelRequire("kvUiC")));

var $bZZMK = parcelRequire("bZZMK");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $d4eed6605ce6db46$var$FeatureGatesInitializationWithProvider = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializingComponent: initializingComponent, overrides: overrides, onReady: onReady, provider: provider })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $91i6m.useState)(!overrides && (0, $bZZMK.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options and provider, so that we can use them within the following useEffect
    // without adding options and provider as dependencies.
    // This avoids the user updating every time an option or provider is attempted to be changed.
    const optionsRef = (0, $91i6m.useRef)(options);
    const providerRef = (0, $91i6m.useRef)(provider);
    (0, $91i6m.useEffect)(()=>{
        optionsRef.current = options;
        providerRef.current = provider;
    }, [
        options,
        provider
    ]);
    (0, $91i6m.useEffect)(()=>{
        if (enabled) {
            if ((0, $bZZMK.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $bZZMK.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $d4eed6605ce6db46$var$feature_gate_js_client_1.default.initializeCalled() ? $d4eed6605ce6db46$var$feature_gate_js_client_1.default.updateUserWithProvider(identifiers, customAttributes) : $d4eed6605ce6db46$var$feature_gate_js_client_1.default.initializeWithProvider(options, provider, identifiers, customAttributes);
                initPromise.catch((err)=>(0, $bZZMK.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $bZZMK.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $bZZMK.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $bZZMK.pickChildToRender)(enabled, isInitialized, children, initializingComponent);
};
module.exports.FeatureGatesInitializationWithProvider = $d4eed6605ce6db46$var$FeatureGatesInitializationWithProvider;
module.exports.default = module.exports.FeatureGatesInitializationWithProvider;

});

parcelRegister("bgUzU", function(module, exports) {
"use strict";
var $834d13990032eb86$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithDefaults = void 0;

var $91i6m = parcelRequire("91i6m");

const $834d13990032eb86$var$feature_gate_js_client_1 = $834d13990032eb86$var$__importDefault((parcelRequire("kvUiC")));

var $bZZMK = parcelRequire("bZZMK");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $834d13990032eb86$var$FeatureGatesInitializationWithDefaults = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $91i6m.useState)(!overrides && (0, $bZZMK.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $91i6m.useRef)(options);
    (0, $91i6m.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $91i6m.useEffect)(()=>{
        if (enabled) {
            if ((0, $bZZMK.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $bZZMK.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $834d13990032eb86$var$feature_gate_js_client_1.default.initializeCalled() ? $834d13990032eb86$var$feature_gate_js_client_1.default.updateUserWithValues(identifiers, customAttributes) : $834d13990032eb86$var$feature_gate_js_client_1.default.initializeFromValues(Object.assign({
                    sdkKey: 'client-default-key'
                }, optionsRef.current || {}), identifiers, customAttributes);
                initPromise.catch((err)=>(0, $bZZMK.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $bZZMK.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $bZZMK.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $bZZMK.pickChildToRender)(enabled, isInitialized, children);
};
module.exports.FeatureGatesInitializationWithDefaults = $834d13990032eb86$var$FeatureGatesInitializationWithDefaults;
module.exports.default = module.exports.FeatureGatesInitializationWithDefaults;

});

parcelRegister("akeIP", function(module, exports) {
"use strict";
var $7847311fd0bc5bb0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithValues = void 0;

var $91i6m = parcelRequire("91i6m");

const $7847311fd0bc5bb0$var$feature_gate_js_client_1 = $7847311fd0bc5bb0$var$__importDefault((parcelRequire("kvUiC")));

var $bZZMK = parcelRequire("bZZMK");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $7847311fd0bc5bb0$var$FeatureGatesInitializationWithValues = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializeValues: initializeValues, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $91i6m.useState)(!overrides && (0, $bZZMK.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $91i6m.useRef)(options);
    (0, $91i6m.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $91i6m.useEffect)(()=>{
        if (enabled) {
            if ((0, $bZZMK.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $bZZMK.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $7847311fd0bc5bb0$var$feature_gate_js_client_1.default.initializeCalled() ? $7847311fd0bc5bb0$var$feature_gate_js_client_1.default.updateUserWithValues(identifiers, customAttributes, initializeValues) : $7847311fd0bc5bb0$var$feature_gate_js_client_1.default.initializeFromValues(optionsRef.current, identifiers, customAttributes, initializeValues);
                initPromise.catch((err)=>(0, $bZZMK.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $bZZMK.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $bZZMK.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        initializeValues,
        overrides
    ]);
    return (0, $bZZMK.pickChildToRender)(enabled, isInitialized, children);
};
module.exports.FeatureGatesInitializationWithValues = $7847311fd0bc5bb0$var$FeatureGatesInitializationWithValues;
module.exports.default = module.exports.FeatureGatesInitializationWithValues;

});


parcelRegister("1HVXA", function(module, exports) {

$parcel$export(module.exports, "statsigTargetApp", function () { return $bc57bc59f3d833ce$export$c0273fbd336e77ca; });
$parcel$export(module.exports, "getStatsigApiKey", function () { return $bc57bc59f3d833ce$export$2f2c106effb3792; });
$parcel$export(module.exports, "getBooleanDynamicConfigValueOrDefault", function () { return $bc57bc59f3d833ce$export$ca7b7b70279af0; });

var $bqdjD = parcelRequire("bqdjD");
const $bc57bc59f3d833ce$export$c0273fbd336e77ca = 'aid-frontend_web';
const $bc57bc59f3d833ce$export$2f2c106effb3792 = ()=>{
    // Provided by https://developer.atlassian.com/platform/frontend-feature-flags/resources/api-keys/
    switch(0, $bqdjD.currentEnv){
        case 'dev':
        case 'local':
            return 'f0f574a2-4bcc-4049-a7d3-6a08637916e0';
        case 'stg':
        case 'stg-ic':
            return 'de816d56-15e9-402b-8d1b-09ab6175bb1c';
        case 'stg-fedm':
            return '487d67c3-d876-46d4-ac06-7a4b066e5b78';
        case 'prod-fedm':
            return 'e8a35d9c-f310-4842-9141-66e28cd0d395';
        case 'prod':
        case 'prod-ic':
        default:
            return 'af2669c5-bf1e-48d6-b37d-a8514b7073d2';
    }
};
const $bc57bc59f3d833ce$export$ca7b7b70279af0 = (dynamicConfigs, configKey)=>{
    const configResult = dynamicConfigs.getBoolean(configKey);
    if ('value' in configResult) return configResult.value;
    return false;
};

});


parcelRegister("2UbF1", function(module, exports) {

$parcel$export(module.exports, "initializeDynamicConfigs", function () { return $1d32076dab2cd6a3$export$d00723e9d793f99d; });
$parcel$export(module.exports, "DynamicConfigsContext", function () { return $1d32076dab2cd6a3$export$70e7649e6de93d3; });
$parcel$export(module.exports, "useDynamicConfigs", function () { return $1d32076dab2cd6a3$export$d18460a0831bab92; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $91i6m = parcelRequire("91i6m");

var $lJHwL = parcelRequire("lJHwL");
var $300Z0 = parcelRequire("300Z0");

var $bqdjD = parcelRequire("bqdjD");

var $1HVXA = parcelRequire("1HVXA");

var $49Pnv = parcelRequire("49Pnv");
const $1d32076dab2cd6a3$var$getDynamicConfigsClientBaseUrl = ()=>{
    // Provided by https://atlaskit.atlassian.com/packages/measurement/web-config-client
    switch((0, $bqdjD.getCurrentEnv)()){
        case 'dev':
        case 'local':
            return 'https://api.dev.atlassian.com/flags';
        case 'stg':
        case 'stg-ic':
            return 'https://api.stg.atlassian.com/flags';
        case 'stg-fedm':
        case 'prod-fedm':
            // see https://home.atlassian.com/o/2346a038-3c8c-498b-a79b-e7847859868d/s/a436116f-02ce-4520-8fbb-7301462a1674/project/ATLAS-74313/about to track FedRAMP availability
            console.warn('Dynamic configs are not currently supported in FedRAMP environments');
            return null;
        case 'prod':
        case 'prod-ic':
        default:
            return 'https://api.atlassian.com/flags';
    }
};
const $1d32076dab2cd6a3$export$f636ae968f78fa38 = 10000;
const $1d32076dab2cd6a3$export$d00723e9d793f99d = async (analyticsAnonymousId)=>{
    const baseUrl = $1d32076dab2cd6a3$var$getDynamicConfigsClientBaseUrl();
    if (baseUrl === null) return (0, $300Z0.ConfigCollection).empty();
    try {
        return await (0, $lJHwL.ConfigClient).fetch({
            ffsBaseUrl: baseUrl,
            ffsApiKey: (0, $1HVXA.getStatsigApiKey)(),
            context: {
                namespace: (0, $1HVXA.statsigTargetApp),
                // this uses a subset of the identifiers that the feature gates client uses. We can add more in future if they are needed.
                identifiers: {
                    analyticsAnonymousId: analyticsAnonymousId
                },
                metadata: {}
            },
            fetch: (input, init)=>{
                var _AbortSignal_timeout, _AbortSignal;
                return fetch(input, (0, $b2I6k._)((0, $1Fos3._)({}, init), {
                    signal: (_AbortSignal = AbortSignal) === null || _AbortSignal === void 0 ? void 0 : (_AbortSignal_timeout = _AbortSignal.timeout) === null || _AbortSignal_timeout === void 0 ? void 0 : _AbortSignal_timeout.call(_AbortSignal, $1d32076dab2cd6a3$export$f636ae968f78fa38)
                }));
            }
        });
    } catch (error) {
        (0, $49Pnv.captureException)(error);
        console.error('Error creating Statsig dynamic config collection. Falling back to empty collection.');
        return (0, $300Z0.ConfigCollection).empty();
    }
};
const $1d32076dab2cd6a3$export$70e7649e6de93d3 = (0, $91i6m.createContext)(undefined);
const $1d32076dab2cd6a3$export$d18460a0831bab92 = ()=>{
    const context = (0, $91i6m.useContext)($1d32076dab2cd6a3$export$70e7649e6de93d3);
    if (!context) throw new Error('useDynamicConfigsClient used outside of DynamicConfigsClientProvider.');
    return context;
};

});
parcelRegister("lJHwL", function(module, exports) {

$parcel$export(module.exports, "ConfigClient", function () { return $fd2f909a0df7a702$export$8489e2f039bfcc4c; });

var $2R76C = parcelRequire("2R76C");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $eWMMH = parcelRequire("eWMMH");

var $300Z0 = parcelRequire("300Z0");
var $fd2f909a0df7a702$export$8489e2f039bfcc4c = /*#__PURE__*/ function() {
    function ConfigClient() {
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, ConfigClient);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(ConfigClient, null, [
        {
            key: "fetch",
            value: function() {
                var _fetch = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee(options) {
                    var _options$fetch;
                    var fetch, response, valuesPayload;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                fetch = (_options$fetch = options.fetch) !== null && _options$fetch !== void 0 ? _options$fetch : globalThis.fetch;
                                _context.next = 3;
                                return fetch("".concat(options.ffsBaseUrl, "/api/v2/configurations"), {
                                    method: 'POST',
                                    body: JSON.stringify(options.context),
                                    headers: {
                                        'content-type': 'application/json',
                                        'x-api-key': options.ffsApiKey
                                    }
                                });
                            case 3:
                                response = _context.sent;
                                if (response.ok) {
                                    _context.next = 12;
                                    break;
                                }
                                _context.t0 = Error;
                                _context.t1 = "Unexpected response ".concat(response.status, ": ");
                                _context.next = 9;
                                return response.text();
                            case 9:
                                _context.t2 = _context.sent;
                                _context.t3 = _context.t1.concat.call(_context.t1, _context.t2);
                                throw new _context.t0(_context.t3);
                            case 12:
                                _context.next = 14;
                                return response.text();
                            case 14:
                                valuesPayload = _context.sent;
                                return _context.abrupt("return", (0, $300Z0.ConfigCollection).fromValues(valuesPayload));
                            case 16:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function fetch(_x) {
                    return _fetch.apply(this, arguments);
                }
                return fetch;
            }()
        }
    ]);
}();

});
parcelRegister("300Z0", function(module, exports) {

$parcel$export(module.exports, "ConfigCollection", function () { return $22f2226204a7991a$export$2be5653e4dada0a3; });

var $iTPYb = parcelRequire("iTPYb");

var $3lbuJ = parcelRequire("3lbuJ");

var $gGOBY = parcelRequire("gGOBY");

var $lVDuE = parcelRequire("lVDuE");

var $kSyoi = parcelRequire("kSyoi");

var $8PVNu = parcelRequire("8PVNu");

var $9Q2nf = parcelRequire("9Q2nf");
function $22f2226204a7991a$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($gGOBY)))(t, $22f2226204a7991a$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(t).constructor) : o.apply(t, e));
}
function $22f2226204a7991a$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($22f2226204a7991a$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $22f2226204a7991a$export$f9c837a54db411d = /*#__PURE__*/ function(_Error) {
    function ParseError(message, cause) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, ParseError);
        _this = $22f2226204a7991a$var$_callSuper(this, ParseError, [
            message
        ]);
        _this.cause = cause;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($kSyoi)))(ParseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(ParseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PVNu)))(Error));
function $22f2226204a7991a$var$safeParse(json) {
    try {
        return {
            data: (0, $9Q2nf.AnyConfigSchema).parse(JSON.parse(json)),
            success: true
        };
    } catch (error) {
        if (error instanceof Error) return {
            success: false,
            error: error
        };
        return {
            success: false,
            error: new $22f2226204a7991a$export$f9c837a54db411d('An unknown error occurred during parsing', error)
        };
    }
}
var $22f2226204a7991a$export$2be5653e4dada0a3 = /*#__PURE__*/ function() {
    function ConfigCollection(config) {
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, ConfigCollection);
        this.config = config;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(ConfigCollection, [
        {
            key: "toJson",
            value: function toJson(format) {
                switch(format){
                    case 'standard':
                        return JSON.stringify((0, $9Q2nf.mapToStandard)(this.config));
                    case 'minimal':
                        return JSON.stringify((0, $9Q2nf.mapToMinimal)(this.config));
                }
            }
        },
        {
            key: "getBoolean",
            value: function getBoolean(configName) {
                var config = this.config.get(configName);
                if (!config) return {
                    error: (0, $9Q2nf.ConfigError).NotFound
                };
                var value = config.value;
                if (typeof value !== 'boolean') return {
                    error: (0, $9Q2nf.ConfigError).IncorrectType,
                    received: value
                };
                return {
                    value: value
                };
            }
        },
        {
            key: "getString",
            value: function getString(configName) {
                var config = this.config.get(configName);
                if (!config) return {
                    error: (0, $9Q2nf.ConfigError).NotFound
                };
                var value = config.value;
                if (typeof value !== 'string') return {
                    error: (0, $9Q2nf.ConfigError).IncorrectType,
                    received: value
                };
                return {
                    value: value
                };
            }
        },
        {
            key: "getNumber",
            value: function getNumber(configName) {
                var config = this.config.get(configName);
                if (!config) return {
                    error: (0, $9Q2nf.ConfigError).NotFound
                };
                var value = config.value;
                if (typeof value !== 'number') return {
                    error: (0, $9Q2nf.ConfigError).IncorrectType,
                    received: value
                };
                return {
                    value: value
                };
            }
        },
        {
            key: "getStringList",
            value: function getStringList(configName) {
                var config = this.config.get(configName);
                if (!config) return {
                    error: (0, $9Q2nf.ConfigError).NotFound
                };
                var value = config.value;
                if (!Array.isArray(value) || !value.every(function(x) {
                    return typeof x === 'string';
                })) return {
                    error: (0, $9Q2nf.ConfigError).IncorrectType,
                    received: value
                };
                return {
                    value: value
                };
            }
        },
        {
            key: "getNumberList",
            value: function getNumberList(configName) {
                var config = this.config.get(configName);
                if (!config) return {
                    error: (0, $9Q2nf.ConfigError).NotFound
                };
                var value = config.value;
                if (!Array.isArray(value) || !value.every(function(x) {
                    return typeof x === 'number';
                })) return {
                    error: (0, $9Q2nf.ConfigError).IncorrectType,
                    received: value
                };
                return {
                    value: value
                };
            }
        }
    ], [
        {
            key: "fromValues",
            value: function fromValues(values, options) {
                var result = $22f2226204a7991a$var$safeParse(values);
                if (!result.success) {
                    var parseError = new $22f2226204a7991a$export$f9c837a54db411d('Failed to deserialize config', result.error);
                    if (options !== null && options !== void 0 && options.throw) throw parseError;
                    // eslint-disable-next-line no-console
                    console.error(parseError);
                    return ConfigCollection.empty();
                }
                return new ConfigCollection(Array.isArray(result.data) ? (0, $9Q2nf.minimalToMap)(result.data) : (0, $9Q2nf.standardToMap)(result.data));
            }
        },
        {
            key: "empty",
            value: function empty() {
                return new ConfigCollection(new Map());
            }
        }
    ]);
}();

});
parcelRegister("9Q2nf", function(module, exports) {

$parcel$export(module.exports, "ConfigError", function () { return $729acfcd61c46812$export$c5fb415882705cf4; });
$parcel$export(module.exports, "AnyConfigSchema", function () { return $729acfcd61c46812$export$960d45de79bd7d81; });
$parcel$export(module.exports, "minimalToMap", function () { return $729acfcd61c46812$export$c29ba52779f58587; });
$parcel$export(module.exports, "standardToMap", function () { return $729acfcd61c46812$export$be5b69ecb011d7cc; });
$parcel$export(module.exports, "mapToMinimal", function () { return $729acfcd61c46812$export$460f06addafd9f86; });
$parcel$export(module.exports, "mapToStandard", function () { return $729acfcd61c46812$export$9d0101ad8235e092; });

var $61RDg = parcelRequire("61RDg");

var $5YM7L = parcelRequire("5YM7L");

var $hTW8L = parcelRequire("hTW8L");
function $729acfcd61c46812$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $729acfcd61c46812$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $729acfcd61c46812$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $729acfcd61c46812$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $729acfcd61c46812$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $729acfcd61c46812$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $729acfcd61c46812$export$c5fb415882705cf4 = /*#__PURE__*/ function(ConfigError) {
    ConfigError["NotFound"] = "not_found";
    ConfigError["InvalidState"] = "state_invalid";
    ConfigError["IncorrectType"] = "incorrect_type";
    return ConfigError;
}({});
var $729acfcd61c46812$export$e94ee64b2671e155 = (0, $hTW8L.z).record((0, $hTW8L.z).string(), (0, $hTW8L.z).object({
    value: (0, $hTW8L.z).union([
        (0, $hTW8L.z).boolean(),
        (0, $hTW8L.z).string(),
        (0, $hTW8L.z).number(),
        (0, $hTW8L.z).string().array(),
        (0, $hTW8L.z).number().array()
    ])
}));
var $729acfcd61c46812$export$e38f7b10db0e126a = (0, $hTW8L.z).tuple([
    // list of boolean configs which are on
    (0, $hTW8L.z).string().array(),
    // list of string config tuples
    (0, $hTW8L.z).array((0, $hTW8L.z).string()).refine(function(arr) {
        return arr.length % 2 === 0;
    }),
    // list of number config tuples
    (0, $hTW8L.z).array((0, $hTW8L.z).union([
        (0, $hTW8L.z).string(),
        (0, $hTW8L.z).number()
    ])).refine(function(arr) {
        if (arr.length % 2 !== 0) return false;
        for(var i = 0; i < arr.length; i += 2){
            if (typeof arr[i] !== 'string') return false;
            if (typeof arr[i + 1] !== 'number') return false;
        }
        return true;
    }),
    // list of string list config tuples
    (0, $hTW8L.z).array((0, $hTW8L.z).union([
        (0, $hTW8L.z).string(),
        (0, $hTW8L.z).string().array()
    ])).refine(function(arr) {
        if (arr.length % 2 !== 0) return false;
        for(var i = 0; i < arr.length; i += 2){
            var key = arr[i];
            var val = arr[i + 1];
            if (typeof key !== 'string') return false;
            if (!Array.isArray(val) || !val.every(function(x) {
                return typeof x === 'string';
            })) return false;
        }
        return true;
    }),
    // list of number list config tuples
    (0, $hTW8L.z).array((0, $hTW8L.z).union([
        (0, $hTW8L.z).string(),
        (0, $hTW8L.z).number().array()
    ])).refine(function(arr) {
        if (arr.length % 2 !== 0) return false;
        for(var i = 0; i < arr.length; i += 2){
            var key = arr[i];
            var val = arr[i + 1];
            if (typeof key !== 'string') return false;
            if (!Array.isArray(val) || !val.every(function(x) {
                return typeof x === 'number';
            })) return false;
        }
        return true;
    })
]);
var $729acfcd61c46812$export$960d45de79bd7d81 = (0, $hTW8L.z).union([
    $729acfcd61c46812$export$e94ee64b2671e155,
    $729acfcd61c46812$export$e38f7b10db0e126a
]);
var $729acfcd61c46812$export$ac2e9c88ba5d7cbb = (0, $hTW8L.z).map((0, $hTW8L.z).string(), (0, $hTW8L.z).object({
    value: (0, $hTW8L.z).union([
        (0, $hTW8L.z).boolean(),
        (0, $hTW8L.z).string(),
        (0, $hTW8L.z).number(),
        (0, $hTW8L.z).string().array(),
        (0, $hTW8L.z).number().array()
    ])
}));
function $729acfcd61c46812$var$pairs(arr, fn) {
    for(var i = 0; i < arr.length; i += 2){
        var key = arr[i];
        var val = arr[i + 1];
        if (typeof key !== 'string') throw new Error("Expected a string while iterating pairs, got: ".concat(arr[i]));
        fn(key, val);
    }
}
function $729acfcd61c46812$export$c29ba52779f58587(minimal) {
    var map = new Map();
    minimal[0].forEach(function(boolean) {
        return map.set(boolean, {
            value: true
        });
    });
    $729acfcd61c46812$var$pairs(minimal[1], function(a, b) {
        return map.set(a, {
            value: b
        });
    });
    $729acfcd61c46812$var$pairs(minimal[2], function(a, b) {
        return map.set(a, {
            value: b
        });
    });
    $729acfcd61c46812$var$pairs(minimal[3], function(a, b) {
        return map.set(a, {
            value: b
        });
    });
    $729acfcd61c46812$var$pairs(minimal[4], function(a, b) {
        return map.set(a, {
            value: b
        });
    });
    return map;
}
function $729acfcd61c46812$export$be5b69ecb011d7cc(standard) {
    var map = new Map();
    Object.entries(standard).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        return map.set(key, value);
    });
    return map;
}
function $729acfcd61c46812$export$460f06addafd9f86(map) {
    var minimal = [
        [],
        [],
        [],
        [],
        []
    ];
    var _iterator = $729acfcd61c46812$var$_createForOfIteratorHelper(map.entries()), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_step.value, 2), key = _step$value[0], value = _step$value[1].value;
            switch((0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(value)){
                case 'boolean':
                    if (value) minimal[0].push(key);
                    break;
                case 'string':
                    minimal[1].push(key, value);
                    break;
                case 'number':
                    minimal[2].push(key, value);
                    break;
                default:
                    if (!Array.isArray(value)) throw new Error("Unexpected configuration value: ".concat(value));
                    var allStrings = value.every(function(x) {
                        return typeof x === 'string';
                    });
                    if (allStrings) {
                        minimal[3].push(key, value);
                        break;
                    }
                    var allNumbers = value.every(function(x) {
                        return typeof x === 'number';
                    });
                    if (allNumbers) {
                        minimal[4].push(key, value);
                        break;
                    }
                    throw new Error("Unexpected configuration value: ".concat(value));
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return minimal;
}
function $729acfcd61c46812$export$9d0101ad8235e092(map) {
    return Object.fromEntries(map.entries());
}

});
parcelRegister("hTW8L", function(module, exports) {

$parcel$export(module.exports, "z", function () { return $0056b1c7057ad614$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");
var $0056b1c7057ad614$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($0056b1c7057ad614$export$7debb50ef11d5e0b || ($0056b1c7057ad614$export$7debb50ef11d5e0b = {}));
var $0056b1c7057ad614$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return (0, $1Fos3._)({}, first, second);
    };
})($0056b1c7057ad614$export$4aa2142c225fd5c7 || ($0056b1c7057ad614$export$4aa2142c225fd5c7 = {}));
const $0056b1c7057ad614$export$5716da67bfaa244d = $0056b1c7057ad614$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $0056b1c7057ad614$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $0056b1c7057ad614$export$5716da67bfaa244d.undefined;
        case "string":
            return $0056b1c7057ad614$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $0056b1c7057ad614$export$5716da67bfaa244d.nan : $0056b1c7057ad614$export$5716da67bfaa244d.number;
        case "boolean":
            return $0056b1c7057ad614$export$5716da67bfaa244d.boolean;
        case "function":
            return $0056b1c7057ad614$export$5716da67bfaa244d.function;
        case "bigint":
            return $0056b1c7057ad614$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $0056b1c7057ad614$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $0056b1c7057ad614$export$5716da67bfaa244d.array;
            if (data === null) return $0056b1c7057ad614$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $0056b1c7057ad614$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $0056b1c7057ad614$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $0056b1c7057ad614$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $0056b1c7057ad614$export$5716da67bfaa244d.date;
            return $0056b1c7057ad614$export$5716da67bfaa244d.object;
        default:
            return $0056b1c7057ad614$export$5716da67bfaa244d.unknown;
    }
};
const $0056b1c7057ad614$export$5ba560653e4a1035 = $0056b1c7057ad614$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $0056b1c7057ad614$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $0056b1c7057ad614$export$f98dac4b251ab333 extends Error {
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof $0056b1c7057ad614$export$f98dac4b251ab333)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $0056b1c7057ad614$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
}
$0056b1c7057ad614$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $0056b1c7057ad614$export$f98dac4b251ab333(issues);
    return error;
};
const $0056b1c7057ad614$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $0056b1c7057ad614$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $0056b1c7057ad614$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $0056b1c7057ad614$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $0056b1c7057ad614$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $0056b1c7057ad614$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$0056b1c7057ad614$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $0056b1c7057ad614$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $0056b1c7057ad614$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$0056b1c7057ad614$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $0056b1c7057ad614$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$0056b1c7057ad614$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $0056b1c7057ad614$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $0056b1c7057ad614$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $0056b1c7057ad614$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $0056b1c7057ad614$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $0056b1c7057ad614$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $0056b1c7057ad614$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $0056b1c7057ad614$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $0056b1c7057ad614$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $0056b1c7057ad614$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $0056b1c7057ad614$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $0056b1c7057ad614$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $0056b1c7057ad614$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $0056b1c7057ad614$var$overrideErrorMap = $0056b1c7057ad614$export$341b0b6e0a6f5099;
function $0056b1c7057ad614$export$1097a8289cfd22d7(map) {
    $0056b1c7057ad614$var$overrideErrorMap = map;
}
function $0056b1c7057ad614$export$32f27c719778d4c4() {
    return $0056b1c7057ad614$var$overrideErrorMap;
}
const $0056b1c7057ad614$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = (0, $b2I6k._)((0, $1Fos3._)({}, issueData), {
        path: fullPath
    });
    if (issueData.message !== undefined) return (0, $b2I6k._)((0, $1Fos3._)({}, issueData), {
        path: fullPath,
        message: issueData.message
    });
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return (0, $b2I6k._)((0, $1Fos3._)({}, issueData), {
        path: fullPath,
        message: errorMessage
    });
};
const $0056b1c7057ad614$export$1526d2e05f74572 = [];
function $0056b1c7057ad614$export$db7caee60e5d514d(ctx, issueData) {
    const overrideMap = $0056b1c7057ad614$export$32f27c719778d4c4();
    const issue = $0056b1c7057ad614$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === $0056b1c7057ad614$export$341b0b6e0a6f5099 ? undefined : $0056b1c7057ad614$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $0056b1c7057ad614$export$5b20a5c3d05c1f6f {
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $0056b1c7057ad614$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key: key,
                value: value
            });
        }
        return $0056b1c7057ad614$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $0056b1c7057ad614$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $0056b1c7057ad614$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
    constructor(){
        this.value = "valid";
    }
}
const $0056b1c7057ad614$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $0056b1c7057ad614$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $0056b1c7057ad614$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $0056b1c7057ad614$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $0056b1c7057ad614$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $0056b1c7057ad614$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $0056b1c7057ad614$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $0056b1c7057ad614$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $0056b1c7057ad614$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
typeof SuppressedError === "function" && SuppressedError;
var $0056b1c7057ad614$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($0056b1c7057ad614$var$errorUtil || ($0056b1c7057ad614$var$errorUtil = {}));
var $0056b1c7057ad614$var$_ZodEnum_cache, $0056b1c7057ad614$var$_ZodNativeEnum_cache;
class $0056b1c7057ad614$var$ParseInputLazyPath {
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
}
const $0056b1c7057ad614$var$handleResult = (ctx, result)=>{
    if ($0056b1c7057ad614$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $0056b1c7057ad614$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $0056b1c7057ad614$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        var _a, _b;
        const { message: message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message !== null && message !== void 0 ? message : ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: (_a = message !== null && message !== void 0 ? message : required_error) !== null && _a !== void 0 ? _a : ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: (_b = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _b !== void 0 ? _b : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $0056b1c7057ad614$export$19342e026b58ebb7 {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $0056b1c7057ad614$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $0056b1c7057ad614$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $0056b1c7057ad614$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $0056b1c7057ad614$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($0056b1c7057ad614$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $0056b1c7057ad614$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $0056b1c7057ad614$var$handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $0056b1c7057ad614$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($0056b1c7057ad614$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $0056b1c7057ad614$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue((0, $1Fos3._)({
                    code: $0056b1c7057ad614$export$5ba560653e4a1035.custom
                }, getIssueProperties(val)));
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $0056b1c7057ad614$export$a60af00cc0ce2582({
            schema: this,
            typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $0056b1c7057ad614$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $0056b1c7057ad614$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $0056b1c7057ad614$export$7acfc3e64785411.create(this, this._def);
    }
    promise() {
        return $0056b1c7057ad614$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $0056b1c7057ad614$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $0056b1c7057ad614$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $0056b1c7057ad614$export$a60af00cc0ce2582((0, $b2I6k._)((0, $1Fos3._)({}, $0056b1c7057ad614$var$processCreateParams(this._def)), {
            schema: this,
            typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        }));
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $0056b1c7057ad614$export$bb19b37874861e7e((0, $b2I6k._)((0, $1Fos3._)({}, $0056b1c7057ad614$var$processCreateParams(this._def)), {
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodDefault
        }));
    }
    brand() {
        return new $0056b1c7057ad614$export$66b0c798a395271f((0, $1Fos3._)({
            typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodBranded,
            type: this
        }, $0056b1c7057ad614$var$processCreateParams(this._def)));
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $0056b1c7057ad614$export$75a44ec6249ac76b((0, $b2I6k._)((0, $1Fos3._)({}, $0056b1c7057ad614$var$processCreateParams(this._def)), {
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodCatch
        }));
    }
    describe(description) {
        const This = this.constructor;
        return new This((0, $b2I6k._)((0, $1Fos3._)({}, this._def), {
            description: description
        }));
    }
    pipe(target) {
        return $0056b1c7057ad614$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $0056b1c7057ad614$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
}
const $0056b1c7057ad614$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $0056b1c7057ad614$var$cuid2Regex = /^[0-9a-z]+$/;
const $0056b1c7057ad614$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $0056b1c7057ad614$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const $0056b1c7057ad614$var$nanoidRegex = /^[a-z0-9_-]{21}$/i;
const $0056b1c7057ad614$var$durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $0056b1c7057ad614$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $0056b1c7057ad614$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $0056b1c7057ad614$var$emojiRegex;
// faster, simpler, safer
const $0056b1c7057ad614$var$ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $0056b1c7057ad614$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const $0056b1c7057ad614$var$base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const $0056b1c7057ad614$var$dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $0056b1c7057ad614$var$dateRegex = new RegExp(`^${$0056b1c7057ad614$var$dateRegexSource}$`);
function $0056b1c7057ad614$var$timeRegexSource(args) {
    // let regex = `\\d{2}:\\d{2}:\\d{2}`;
    let regex = `([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d`;
    if (args.precision) regex = `${regex}\\.\\d{${args.precision}}`;
    else if (args.precision == null) regex = `${regex}(\\.\\d+)?`;
    return regex;
}
function $0056b1c7057ad614$var$timeRegex(args) {
    return new RegExp(`^${$0056b1c7057ad614$var$timeRegexSource(args)}$`);
}
// Adapted from https://stackoverflow.com/a/3143231
function $0056b1c7057ad614$export$a4b563879add27a(args) {
    let regex = `${$0056b1c7057ad614$var$dateRegexSource}T${$0056b1c7057ad614$var$timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function $0056b1c7057ad614$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $0056b1c7057ad614$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $0056b1c7057ad614$var$ipv6Regex.test(ip)) return true;
    return false;
}
class $0056b1c7057ad614$export$1230eb29b8d3b502 extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $0056b1c7057ad614$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_type,
                expected: $0056b1c7057ad614$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $0056b1c7057ad614$export$9a105a556e65c2c0;
        }
        const status = new $0056b1c7057ad614$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                        code: $0056b1c7057ad614$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                        code: $0056b1c7057ad614$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                        code: $0056b1c7057ad614$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                        code: $0056b1c7057ad614$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$0056b1c7057ad614$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$0056b1c7057ad614$var$emojiRegex) $0056b1c7057ad614$var$emojiRegex = new RegExp($0056b1c7057ad614$var$_emojiRegex, "u");
                if (!$0056b1c7057ad614$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$0056b1c7057ad614$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!$0056b1c7057ad614$var$nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                        validation: "nanoid",
                        code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$0056b1c7057ad614$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$0056b1c7057ad614$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$0056b1c7057ad614$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                        code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                        code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                        code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $0056b1c7057ad614$export$a4b563879add27a(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                        code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = $0056b1c7057ad614$var$dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                        code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = $0056b1c7057ad614$var$timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                        code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!$0056b1c7057ad614$var$durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                        validation: "duration",
                        code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$0056b1c7057ad614$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!$0056b1c7057ad614$var$base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                        validation: "base64",
                        code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $0056b1c7057ad614$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), (0, $1Fos3._)({
            validation: validation,
            code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_string
        }, $0056b1c7057ad614$var$errorUtil.errToObj(message)));
    }
    _addCheck(check) {
        return new $0056b1c7057ad614$export$1230eb29b8d3b502((0, $b2I6k._)((0, $1Fos3._)({}, this._def), {
            checks: [
                ...this._def.checks,
                check
            ]
        }));
    }
    email(message) {
        return this._addCheck((0, $1Fos3._)({
            kind: "email"
        }, $0056b1c7057ad614$var$errorUtil.errToObj(message)));
    }
    url(message) {
        return this._addCheck((0, $1Fos3._)({
            kind: "url"
        }, $0056b1c7057ad614$var$errorUtil.errToObj(message)));
    }
    emoji(message) {
        return this._addCheck((0, $1Fos3._)({
            kind: "emoji"
        }, $0056b1c7057ad614$var$errorUtil.errToObj(message)));
    }
    uuid(message) {
        return this._addCheck((0, $1Fos3._)({
            kind: "uuid"
        }, $0056b1c7057ad614$var$errorUtil.errToObj(message)));
    }
    nanoid(message) {
        return this._addCheck((0, $1Fos3._)({
            kind: "nanoid"
        }, $0056b1c7057ad614$var$errorUtil.errToObj(message)));
    }
    cuid(message) {
        return this._addCheck((0, $1Fos3._)({
            kind: "cuid"
        }, $0056b1c7057ad614$var$errorUtil.errToObj(message)));
    }
    cuid2(message) {
        return this._addCheck((0, $1Fos3._)({
            kind: "cuid2"
        }, $0056b1c7057ad614$var$errorUtil.errToObj(message)));
    }
    ulid(message) {
        return this._addCheck((0, $1Fos3._)({
            kind: "ulid"
        }, $0056b1c7057ad614$var$errorUtil.errToObj(message)));
    }
    base64(message) {
        return this._addCheck((0, $1Fos3._)({
            kind: "base64"
        }, $0056b1c7057ad614$var$errorUtil.errToObj(message)));
    }
    ip(options) {
        return this._addCheck((0, $1Fos3._)({
            kind: "ip"
        }, $0056b1c7057ad614$var$errorUtil.errToObj(options)));
    }
    datetime(options) {
        var _a, _b;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck((0, $1Fos3._)({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            local: (_b = options === null || options === void 0 ? void 0 : options.local) !== null && _b !== void 0 ? _b : false
        }, $0056b1c7057ad614$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message: message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck((0, $1Fos3._)({
            kind: "time",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision
        }, $0056b1c7057ad614$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
    }
    duration(message) {
        return this._addCheck((0, $1Fos3._)({
            kind: "duration"
        }, $0056b1c7057ad614$var$errorUtil.errToObj(message)));
    }
    regex(regex, message) {
        return this._addCheck((0, $1Fos3._)({
            kind: "regex",
            regex: regex
        }, $0056b1c7057ad614$var$errorUtil.errToObj(message)));
    }
    includes(value, options) {
        return this._addCheck((0, $1Fos3._)({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position
        }, $0056b1c7057ad614$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
    }
    startsWith(value, message) {
        return this._addCheck((0, $1Fos3._)({
            kind: "startsWith",
            value: value
        }, $0056b1c7057ad614$var$errorUtil.errToObj(message)));
    }
    endsWith(value, message) {
        return this._addCheck((0, $1Fos3._)({
            kind: "endsWith",
            value: value
        }, $0056b1c7057ad614$var$errorUtil.errToObj(message)));
    }
    min(minLength, message) {
        return this._addCheck((0, $1Fos3._)({
            kind: "min",
            value: minLength
        }, $0056b1c7057ad614$var$errorUtil.errToObj(message)));
    }
    max(maxLength, message) {
        return this._addCheck((0, $1Fos3._)({
            kind: "max",
            value: maxLength
        }, $0056b1c7057ad614$var$errorUtil.errToObj(message)));
    }
    length(len, message) {
        return this._addCheck((0, $1Fos3._)({
            kind: "length",
            value: len
        }, $0056b1c7057ad614$var$errorUtil.errToObj(message)));
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */ nonempty(message) {
        return this.min(1, $0056b1c7057ad614$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $0056b1c7057ad614$export$1230eb29b8d3b502((0, $b2I6k._)((0, $1Fos3._)({}, this._def), {
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        }));
    }
    toLowerCase() {
        return new $0056b1c7057ad614$export$1230eb29b8d3b502((0, $b2I6k._)((0, $1Fos3._)({}, this._def), {
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        }));
    }
    toUpperCase() {
        return new $0056b1c7057ad614$export$1230eb29b8d3b502((0, $b2I6k._)((0, $1Fos3._)({}, this._def), {
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        }));
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$0056b1c7057ad614$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $0056b1c7057ad614$export$1230eb29b8d3b502((0, $1Fos3._)({
        checks: [],
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $0056b1c7057ad614$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $0056b1c7057ad614$export$5b070a55c0c43e09 extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $0056b1c7057ad614$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_type,
                expected: $0056b1c7057ad614$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $0056b1c7057ad614$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $0056b1c7057ad614$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$0056b1c7057ad614$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                        code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                        code: $0056b1c7057ad614$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                        code: $0056b1c7057ad614$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($0056b1c7057ad614$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                        code: $0056b1c7057ad614$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                        code: $0056b1c7057ad614$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $0056b1c7057ad614$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $0056b1c7057ad614$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $0056b1c7057ad614$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $0056b1c7057ad614$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $0056b1c7057ad614$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $0056b1c7057ad614$export$5b070a55c0c43e09((0, $b2I6k._)((0, $1Fos3._)({}, this._def), {
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $0056b1c7057ad614$var$errorUtil.toString(message)
                }
            ]
        }));
    }
    _addCheck(check) {
        return new $0056b1c7057ad614$export$5b070a55c0c43e09((0, $b2I6k._)((0, $1Fos3._)({}, this._def), {
            checks: [
                ...this._def.checks,
                check
            ]
        }));
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $0056b1c7057ad614$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $0056b1c7057ad614$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $0056b1c7057ad614$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $0056b1c7057ad614$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $0056b1c7057ad614$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $0056b1c7057ad614$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $0056b1c7057ad614$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $0056b1c7057ad614$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $0056b1c7057ad614$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $0056b1c7057ad614$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
}
$0056b1c7057ad614$export$5b070a55c0c43e09.create = (params)=>{
    return new $0056b1c7057ad614$export$5b070a55c0c43e09((0, $1Fos3._)({
        checks: [],
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
class $0056b1c7057ad614$export$67d741fd70ff98f4 extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = BigInt(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $0056b1c7057ad614$export$5716da67bfaa244d.bigint) {
            const ctx = this._getOrReturnCtx(input);
            $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_type,
                expected: $0056b1c7057ad614$export$5716da67bfaa244d.bigint,
                received: ctx.parsedType
            });
            return $0056b1c7057ad614$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $0056b1c7057ad614$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                        code: $0056b1c7057ad614$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                        code: $0056b1c7057ad614$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                        code: $0056b1c7057ad614$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $0056b1c7057ad614$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $0056b1c7057ad614$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $0056b1c7057ad614$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $0056b1c7057ad614$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $0056b1c7057ad614$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $0056b1c7057ad614$export$67d741fd70ff98f4((0, $b2I6k._)((0, $1Fos3._)({}, this._def), {
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $0056b1c7057ad614$var$errorUtil.toString(message)
                }
            ]
        }));
    }
    _addCheck(check) {
        return new $0056b1c7057ad614$export$67d741fd70ff98f4((0, $b2I6k._)((0, $1Fos3._)({}, this._def), {
            checks: [
                ...this._def.checks,
                check
            ]
        }));
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $0056b1c7057ad614$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $0056b1c7057ad614$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $0056b1c7057ad614$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $0056b1c7057ad614$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $0056b1c7057ad614$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
}
$0056b1c7057ad614$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $0056b1c7057ad614$export$67d741fd70ff98f4((0, $1Fos3._)({
        checks: [],
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
class $0056b1c7057ad614$export$723d146f80596191 extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $0056b1c7057ad614$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_type,
                expected: $0056b1c7057ad614$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $0056b1c7057ad614$export$9a105a556e65c2c0;
        }
        return $0056b1c7057ad614$export$c6813a8d51f77eaf(input.data);
    }
}
$0056b1c7057ad614$export$723d146f80596191.create = (params)=>{
    return new $0056b1c7057ad614$export$723d146f80596191((0, $1Fos3._)({
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
class $0056b1c7057ad614$export$e974be33bdc55521 extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $0056b1c7057ad614$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_type,
                expected: $0056b1c7057ad614$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $0056b1c7057ad614$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_date
            });
            return $0056b1c7057ad614$export$9a105a556e65c2c0;
        }
        const status = new $0056b1c7057ad614$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                        code: $0056b1c7057ad614$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                        code: $0056b1c7057ad614$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $0056b1c7057ad614$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $0056b1c7057ad614$export$e974be33bdc55521((0, $b2I6k._)((0, $1Fos3._)({}, this._def), {
            checks: [
                ...this._def.checks,
                check
            ]
        }));
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $0056b1c7057ad614$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $0056b1c7057ad614$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$0056b1c7057ad614$export$e974be33bdc55521.create = (params)=>{
    return new $0056b1c7057ad614$export$e974be33bdc55521((0, $1Fos3._)({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodDate
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
class $0056b1c7057ad614$export$bcc3b40f6b638044 extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $0056b1c7057ad614$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_type,
                expected: $0056b1c7057ad614$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $0056b1c7057ad614$export$9a105a556e65c2c0;
        }
        return $0056b1c7057ad614$export$c6813a8d51f77eaf(input.data);
    }
}
$0056b1c7057ad614$export$bcc3b40f6b638044.create = (params)=>{
    return new $0056b1c7057ad614$export$bcc3b40f6b638044((0, $1Fos3._)({
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodSymbol
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
class $0056b1c7057ad614$export$4e780e961c30340d extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $0056b1c7057ad614$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_type,
                expected: $0056b1c7057ad614$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $0056b1c7057ad614$export$9a105a556e65c2c0;
        }
        return $0056b1c7057ad614$export$c6813a8d51f77eaf(input.data);
    }
}
$0056b1c7057ad614$export$4e780e961c30340d.create = (params)=>{
    return new $0056b1c7057ad614$export$4e780e961c30340d((0, $1Fos3._)({
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodUndefined
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
class $0056b1c7057ad614$export$a96281f914484f2d extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $0056b1c7057ad614$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_type,
                expected: $0056b1c7057ad614$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $0056b1c7057ad614$export$9a105a556e65c2c0;
        }
        return $0056b1c7057ad614$export$c6813a8d51f77eaf(input.data);
    }
}
$0056b1c7057ad614$export$a96281f914484f2d.create = (params)=>{
    return new $0056b1c7057ad614$export$a96281f914484f2d((0, $1Fos3._)({
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodNull
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
class $0056b1c7057ad614$export$b9d1edb536b4e4eb extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    _parse(input) {
        return $0056b1c7057ad614$export$c6813a8d51f77eaf(input.data);
    }
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
}
$0056b1c7057ad614$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $0056b1c7057ad614$export$b9d1edb536b4e4eb((0, $1Fos3._)({
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodAny
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
class $0056b1c7057ad614$export$ef3b1bb1630977ae extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    _parse(input) {
        return $0056b1c7057ad614$export$c6813a8d51f77eaf(input.data);
    }
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
}
$0056b1c7057ad614$export$ef3b1bb1630977ae.create = (params)=>{
    return new $0056b1c7057ad614$export$ef3b1bb1630977ae((0, $1Fos3._)({
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodUnknown
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
class $0056b1c7057ad614$export$1e576a20c3ce9fb5 extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
            code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_type,
            expected: $0056b1c7057ad614$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $0056b1c7057ad614$export$9a105a556e65c2c0;
    }
}
$0056b1c7057ad614$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $0056b1c7057ad614$export$1e576a20c3ce9fb5((0, $1Fos3._)({
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodNever
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
class $0056b1c7057ad614$export$7d39f5df85f21031 extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $0056b1c7057ad614$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_type,
                expected: $0056b1c7057ad614$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $0056b1c7057ad614$export$9a105a556e65c2c0;
        }
        return $0056b1c7057ad614$export$c6813a8d51f77eaf(input.data);
    }
}
$0056b1c7057ad614$export$7d39f5df85f21031.create = (params)=>{
    return new $0056b1c7057ad614$export$7d39f5df85f21031((0, $1Fos3._)({
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodVoid
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
class $0056b1c7057ad614$export$7acfc3e64785411 extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $0056b1c7057ad614$export$5716da67bfaa244d.array) {
            $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_type,
                expected: $0056b1c7057ad614$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $0056b1c7057ad614$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $0056b1c7057ad614$export$5ba560653e4a1035.too_big : $0056b1c7057ad614$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                    code: $0056b1c7057ad614$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                    code: $0056b1c7057ad614$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $0056b1c7057ad614$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $0056b1c7057ad614$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $0056b1c7057ad614$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $0056b1c7057ad614$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $0056b1c7057ad614$export$7acfc3e64785411((0, $b2I6k._)((0, $1Fos3._)({}, this._def), {
            minLength: {
                value: minLength,
                message: $0056b1c7057ad614$var$errorUtil.toString(message)
            }
        }));
    }
    max(maxLength, message) {
        return new $0056b1c7057ad614$export$7acfc3e64785411((0, $b2I6k._)((0, $1Fos3._)({}, this._def), {
            maxLength: {
                value: maxLength,
                message: $0056b1c7057ad614$var$errorUtil.toString(message)
            }
        }));
    }
    length(len, message) {
        return new $0056b1c7057ad614$export$7acfc3e64785411((0, $b2I6k._)((0, $1Fos3._)({}, this._def), {
            exactLength: {
                value: len,
                message: $0056b1c7057ad614$var$errorUtil.toString(message)
            }
        }));
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$0056b1c7057ad614$export$7acfc3e64785411.create = (schema, params)=>{
    return new $0056b1c7057ad614$export$7acfc3e64785411((0, $1Fos3._)({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodArray
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
function $0056b1c7057ad614$var$deepPartialify(schema) {
    if (schema instanceof $0056b1c7057ad614$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $0056b1c7057ad614$export$aa56fec1e9d629b8.create($0056b1c7057ad614$var$deepPartialify(fieldSchema));
        }
        return new $0056b1c7057ad614$export$736315c5b55efbad((0, $b2I6k._)((0, $1Fos3._)({}, schema._def), {
            shape: ()=>newShape
        }));
    } else if (schema instanceof $0056b1c7057ad614$export$7acfc3e64785411) return new $0056b1c7057ad614$export$7acfc3e64785411((0, $b2I6k._)((0, $1Fos3._)({}, schema._def), {
        type: $0056b1c7057ad614$var$deepPartialify(schema.element)
    }));
    else if (schema instanceof $0056b1c7057ad614$export$aa56fec1e9d629b8) return $0056b1c7057ad614$export$aa56fec1e9d629b8.create($0056b1c7057ad614$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $0056b1c7057ad614$export$aaac0b8b429cef5) return $0056b1c7057ad614$export$aaac0b8b429cef5.create($0056b1c7057ad614$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $0056b1c7057ad614$export$e2a18bb771d8e6a3) return $0056b1c7057ad614$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$0056b1c7057ad614$var$deepPartialify(item)));
    else return schema;
}
class $0056b1c7057ad614$export$736315c5b55efbad extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $0056b1c7057ad614$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $0056b1c7057ad614$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_type,
                expected: $0056b1c7057ad614$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $0056b1c7057ad614$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $0056b1c7057ad614$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $0056b1c7057ad614$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $0056b1c7057ad614$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                        code: $0056b1c7057ad614$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $0056b1c7057ad614$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key: key,
                    value: value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $0056b1c7057ad614$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $0056b1c7057ad614$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $0056b1c7057ad614$var$errorUtil.errToObj;
        return new $0056b1c7057ad614$export$736315c5b55efbad((0, $1Fos3._)((0, $b2I6k._)((0, $1Fos3._)({}, this._def), {
            unknownKeys: "strict"
        }), message !== undefined ? {
            errorMap: (issue, ctx)=>{
                var _a, _b, _c, _d;
                const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                if (issue.code === "unrecognized_keys") return {
                    message: (_d = $0056b1c7057ad614$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                };
                return {
                    message: defaultError
                };
            }
        } : {}));
    }
    strip() {
        return new $0056b1c7057ad614$export$736315c5b55efbad((0, $b2I6k._)((0, $1Fos3._)({}, this._def), {
            unknownKeys: "strip"
        }));
    }
    passthrough() {
        return new $0056b1c7057ad614$export$736315c5b55efbad((0, $b2I6k._)((0, $1Fos3._)({}, this._def), {
            unknownKeys: "passthrough"
        }));
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $0056b1c7057ad614$export$736315c5b55efbad((0, $b2I6k._)((0, $1Fos3._)({}, this._def), {
            shape: ()=>(0, $1Fos3._)({}, this._def.shape(), augmentation)
        }));
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $0056b1c7057ad614$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>(0, $1Fos3._)({}, this._def.shape(), merging._def.shape()),
            typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $0056b1c7057ad614$export$736315c5b55efbad((0, $b2I6k._)((0, $1Fos3._)({}, this._def), {
            catchall: index
        }));
    }
    pick(mask) {
        const shape = {};
        $0056b1c7057ad614$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $0056b1c7057ad614$export$736315c5b55efbad((0, $b2I6k._)((0, $1Fos3._)({}, this._def), {
            shape: ()=>shape
        }));
    }
    omit(mask) {
        const shape = {};
        $0056b1c7057ad614$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $0056b1c7057ad614$export$736315c5b55efbad((0, $b2I6k._)((0, $1Fos3._)({}, this._def), {
            shape: ()=>shape
        }));
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $0056b1c7057ad614$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $0056b1c7057ad614$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $0056b1c7057ad614$export$736315c5b55efbad((0, $b2I6k._)((0, $1Fos3._)({}, this._def), {
            shape: ()=>newShape
        }));
    }
    required(mask) {
        const newShape = {};
        $0056b1c7057ad614$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $0056b1c7057ad614$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $0056b1c7057ad614$export$736315c5b55efbad((0, $b2I6k._)((0, $1Fos3._)({}, this._def), {
            shape: ()=>newShape
        }));
    }
    keyof() {
        return $0056b1c7057ad614$var$createZodEnum($0056b1c7057ad614$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
}
$0056b1c7057ad614$export$736315c5b55efbad.create = (shape, params)=>{
    return new $0056b1c7057ad614$export$736315c5b55efbad((0, $1Fos3._)({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $0056b1c7057ad614$export$1e576a20c3ce9fb5.create(),
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodObject
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
$0056b1c7057ad614$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $0056b1c7057ad614$export$736315c5b55efbad((0, $1Fos3._)({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $0056b1c7057ad614$export$1e576a20c3ce9fb5.create(),
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodObject
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
$0056b1c7057ad614$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $0056b1c7057ad614$export$736315c5b55efbad((0, $1Fos3._)({
        shape: shape,
        unknownKeys: "strip",
        catchall: $0056b1c7057ad614$export$1e576a20c3ce9fb5.create(),
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodObject
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
class $0056b1c7057ad614$export$a8b236cb5070a311 extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $0056b1c7057ad614$export$f98dac4b251ab333(result.ctx.common.issues));
            $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $0056b1c7057ad614$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = (0, $b2I6k._)((0, $1Fos3._)({}, ctx), {
                common: (0, $b2I6k._)((0, $1Fos3._)({}, ctx.common), {
                    issues: []
                }),
                parent: null
            });
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = (0, $b2I6k._)((0, $1Fos3._)({}, ctx), {
                    common: (0, $b2I6k._)((0, $1Fos3._)({}, ctx.common), {
                        issues: []
                    }),
                    parent: null
                });
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $0056b1c7057ad614$export$f98dac4b251ab333(issues));
            $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $0056b1c7057ad614$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$0056b1c7057ad614$export$a8b236cb5070a311.create = (types, params)=>{
    return new $0056b1c7057ad614$export$a8b236cb5070a311((0, $1Fos3._)({
        options: types,
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodUnion
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $0056b1c7057ad614$var$getDiscriminator = (type)=>{
    if (type instanceof $0056b1c7057ad614$export$378d0cfce37406e6) return $0056b1c7057ad614$var$getDiscriminator(type.schema);
    else if (type instanceof $0056b1c7057ad614$export$a60af00cc0ce2582) return $0056b1c7057ad614$var$getDiscriminator(type.innerType());
    else if (type instanceof $0056b1c7057ad614$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $0056b1c7057ad614$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $0056b1c7057ad614$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return $0056b1c7057ad614$export$7debb50ef11d5e0b.objectValues(type.enum);
    else if (type instanceof $0056b1c7057ad614$export$bb19b37874861e7e) return $0056b1c7057ad614$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $0056b1c7057ad614$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $0056b1c7057ad614$export$a96281f914484f2d) return [
        null
    ];
    else if (type instanceof $0056b1c7057ad614$export$aa56fec1e9d629b8) return [
        undefined,
        ...$0056b1c7057ad614$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $0056b1c7057ad614$export$aaac0b8b429cef5) return [
        null,
        ...$0056b1c7057ad614$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $0056b1c7057ad614$export$66b0c798a395271f) return $0056b1c7057ad614$var$getDiscriminator(type.unwrap());
    else if (type instanceof $0056b1c7057ad614$export$5d1f7ef05c4e493a) return $0056b1c7057ad614$var$getDiscriminator(type.unwrap());
    else if (type instanceof $0056b1c7057ad614$export$75a44ec6249ac76b) return $0056b1c7057ad614$var$getDiscriminator(type._def.innerType);
    else return [];
};
class $0056b1c7057ad614$export$5ef2424805ac76a3 extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $0056b1c7057ad614$export$5716da67bfaa244d.object) {
            $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_type,
                expected: $0056b1c7057ad614$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $0056b1c7057ad614$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $0056b1c7057ad614$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $0056b1c7057ad614$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $0056b1c7057ad614$export$5ef2424805ac76a3((0, $1Fos3._)({
            typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap
        }, $0056b1c7057ad614$var$processCreateParams(params)));
    }
}
function $0056b1c7057ad614$var$mergeValues(a, b) {
    const aType = $0056b1c7057ad614$export$3e9057828ebd5c7a(a);
    const bType = $0056b1c7057ad614$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $0056b1c7057ad614$export$5716da67bfaa244d.object && bType === $0056b1c7057ad614$export$5716da67bfaa244d.object) {
        const bKeys = $0056b1c7057ad614$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $0056b1c7057ad614$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = (0, $1Fos3._)({}, a, b);
        for (const key of sharedKeys){
            const sharedValue = $0056b1c7057ad614$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $0056b1c7057ad614$export$5716da67bfaa244d.array && bType === $0056b1c7057ad614$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $0056b1c7057ad614$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $0056b1c7057ad614$export$5716da67bfaa244d.date && bType === $0056b1c7057ad614$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $0056b1c7057ad614$export$c02deaf0bb5203d4 extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($0056b1c7057ad614$export$afa861e3c5730743(parsedLeft) || $0056b1c7057ad614$export$afa861e3c5730743(parsedRight)) return $0056b1c7057ad614$export$9a105a556e65c2c0;
            const merged = $0056b1c7057ad614$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                    code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $0056b1c7057ad614$export$9a105a556e65c2c0;
            }
            if ($0056b1c7057ad614$export$910b6cdd390341b3(parsedLeft) || $0056b1c7057ad614$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$0056b1c7057ad614$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $0056b1c7057ad614$export$c02deaf0bb5203d4((0, $1Fos3._)({
        left: left,
        right: right,
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodIntersection
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
class $0056b1c7057ad614$export$e2a18bb771d8e6a3 extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $0056b1c7057ad614$export$5716da67bfaa244d.array) {
            $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_type,
                expected: $0056b1c7057ad614$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $0056b1c7057ad614$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                code: $0056b1c7057ad614$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $0056b1c7057ad614$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                code: $0056b1c7057ad614$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $0056b1c7057ad614$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $0056b1c7057ad614$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $0056b1c7057ad614$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $0056b1c7057ad614$export$e2a18bb771d8e6a3((0, $b2I6k._)((0, $1Fos3._)({}, this._def), {
            rest: rest
        }));
    }
}
$0056b1c7057ad614$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $0056b1c7057ad614$export$e2a18bb771d8e6a3((0, $1Fos3._)({
        items: schemas,
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodTuple,
        rest: null
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
class $0056b1c7057ad614$export$a2acc09968cb4b7f extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $0056b1c7057ad614$export$5716da67bfaa244d.object) {
            $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_type,
                expected: $0056b1c7057ad614$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $0056b1c7057ad614$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $0056b1c7057ad614$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $0056b1c7057ad614$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return $0056b1c7057ad614$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $0056b1c7057ad614$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $0056b1c7057ad614$export$19342e026b58ebb7) return new $0056b1c7057ad614$export$a2acc09968cb4b7f((0, $1Fos3._)({
            keyType: first,
            valueType: second,
            typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodRecord
        }, $0056b1c7057ad614$var$processCreateParams(third)));
        return new $0056b1c7057ad614$export$a2acc09968cb4b7f((0, $1Fos3._)({
            keyType: $0056b1c7057ad614$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodRecord
        }, $0056b1c7057ad614$var$processCreateParams(second)));
    }
}
class $0056b1c7057ad614$export$163b6a2b712d9542 extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $0056b1c7057ad614$export$5716da67bfaa244d.map) {
            $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_type,
                expected: $0056b1c7057ad614$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $0056b1c7057ad614$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $0056b1c7057ad614$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $0056b1c7057ad614$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $0056b1c7057ad614$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $0056b1c7057ad614$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$0056b1c7057ad614$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $0056b1c7057ad614$export$163b6a2b712d9542((0, $1Fos3._)({
        valueType: valueType,
        keyType: keyType,
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodMap
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
class $0056b1c7057ad614$export$977057706f816712 extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $0056b1c7057ad614$export$5716da67bfaa244d.set) {
            $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_type,
                expected: $0056b1c7057ad614$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $0056b1c7057ad614$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                    code: $0056b1c7057ad614$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                    code: $0056b1c7057ad614$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $0056b1c7057ad614$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $0056b1c7057ad614$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $0056b1c7057ad614$export$977057706f816712((0, $b2I6k._)((0, $1Fos3._)({}, this._def), {
            minSize: {
                value: minSize,
                message: $0056b1c7057ad614$var$errorUtil.toString(message)
            }
        }));
    }
    max(maxSize, message) {
        return new $0056b1c7057ad614$export$977057706f816712((0, $b2I6k._)((0, $1Fos3._)({}, this._def), {
            maxSize: {
                value: maxSize,
                message: $0056b1c7057ad614$var$errorUtil.toString(message)
            }
        }));
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$0056b1c7057ad614$export$977057706f816712.create = (valueType, params)=>{
    return new $0056b1c7057ad614$export$977057706f816712((0, $1Fos3._)({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodSet
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
class $0056b1c7057ad614$export$d4602ba55673f53c extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $0056b1c7057ad614$export$5716da67bfaa244d.function) {
            $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_type,
                expected: $0056b1c7057ad614$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $0056b1c7057ad614$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $0056b1c7057ad614$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $0056b1c7057ad614$export$32f27c719778d4c4(),
                    $0056b1c7057ad614$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $0056b1c7057ad614$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $0056b1c7057ad614$export$32f27c719778d4c4(),
                    $0056b1c7057ad614$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $0056b1c7057ad614$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $0056b1c7057ad614$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $0056b1c7057ad614$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $0056b1c7057ad614$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $0056b1c7057ad614$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $0056b1c7057ad614$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $0056b1c7057ad614$export$d4602ba55673f53c((0, $b2I6k._)((0, $1Fos3._)({}, this._def), {
            args: $0056b1c7057ad614$export$e2a18bb771d8e6a3.create(items).rest($0056b1c7057ad614$export$ef3b1bb1630977ae.create())
        }));
    }
    returns(returnType) {
        return new $0056b1c7057ad614$export$d4602ba55673f53c((0, $b2I6k._)((0, $1Fos3._)({}, this._def), {
            returns: returnType
        }));
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $0056b1c7057ad614$export$d4602ba55673f53c((0, $1Fos3._)({
            args: args ? args : $0056b1c7057ad614$export$e2a18bb771d8e6a3.create([]).rest($0056b1c7057ad614$export$ef3b1bb1630977ae.create()),
            returns: returns || $0056b1c7057ad614$export$ef3b1bb1630977ae.create(),
            typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodFunction
        }, $0056b1c7057ad614$var$processCreateParams(params)));
    }
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
}
class $0056b1c7057ad614$export$378d0cfce37406e6 extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$0056b1c7057ad614$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $0056b1c7057ad614$export$378d0cfce37406e6((0, $1Fos3._)({
        getter: getter,
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodLazy
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
class $0056b1c7057ad614$export$7e44096782a165d3 extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $0056b1c7057ad614$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$0056b1c7057ad614$export$7e44096782a165d3.create = (value, params)=>{
    return new $0056b1c7057ad614$export$7e44096782a165d3((0, $1Fos3._)({
        value: value,
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodLiteral
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
function $0056b1c7057ad614$var$createZodEnum(values, params) {
    return new $0056b1c7057ad614$export$d325d1f0e1c20179((0, $1Fos3._)({
        values: values,
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodEnum
    }, $0056b1c7057ad614$var$processCreateParams(params)));
}
class $0056b1c7057ad614$export$d325d1f0e1c20179 extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                expected: $0056b1c7057ad614$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_type
            });
            return $0056b1c7057ad614$export$9a105a556e65c2c0;
        }
        if (!$0056b1c7057ad614$var$__classPrivateFieldGet(this, $0056b1c7057ad614$var$_ZodEnum_cache, "f")) $0056b1c7057ad614$var$__classPrivateFieldSet(this, $0056b1c7057ad614$var$_ZodEnum_cache, new Set(this._def.values), "f");
        if (!$0056b1c7057ad614$var$__classPrivateFieldGet(this, $0056b1c7057ad614$var$_ZodEnum_cache, "f").has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $0056b1c7057ad614$export$9a105a556e65c2c0;
        }
        return $0056b1c7057ad614$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return $0056b1c7057ad614$export$d325d1f0e1c20179.create(values, (0, $1Fos3._)({}, this._def, newDef));
    }
    exclude(values, newDef = this._def) {
        return $0056b1c7057ad614$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)), (0, $1Fos3._)({}, this._def, newDef));
    }
    constructor(){
        super(...arguments);
        $0056b1c7057ad614$var$_ZodEnum_cache.set(this, void 0);
    }
}
$0056b1c7057ad614$var$_ZodEnum_cache = new WeakMap();
$0056b1c7057ad614$export$d325d1f0e1c20179.create = $0056b1c7057ad614$var$createZodEnum;
class $0056b1c7057ad614$export$370b2e8d6d6f5c56 extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    _parse(input) {
        const nativeEnumValues = $0056b1c7057ad614$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $0056b1c7057ad614$export$5716da67bfaa244d.string && ctx.parsedType !== $0056b1c7057ad614$export$5716da67bfaa244d.number) {
            const expectedValues = $0056b1c7057ad614$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                expected: $0056b1c7057ad614$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_type
            });
            return $0056b1c7057ad614$export$9a105a556e65c2c0;
        }
        if (!$0056b1c7057ad614$var$__classPrivateFieldGet(this, $0056b1c7057ad614$var$_ZodNativeEnum_cache, "f")) $0056b1c7057ad614$var$__classPrivateFieldSet(this, $0056b1c7057ad614$var$_ZodNativeEnum_cache, new Set($0056b1c7057ad614$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values)), "f");
        if (!$0056b1c7057ad614$var$__classPrivateFieldGet(this, $0056b1c7057ad614$var$_ZodNativeEnum_cache, "f").has(input.data)) {
            const expectedValues = $0056b1c7057ad614$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $0056b1c7057ad614$export$9a105a556e65c2c0;
        }
        return $0056b1c7057ad614$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
    constructor(){
        super(...arguments);
        $0056b1c7057ad614$var$_ZodNativeEnum_cache.set(this, void 0);
    }
}
$0056b1c7057ad614$var$_ZodNativeEnum_cache = new WeakMap();
$0056b1c7057ad614$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $0056b1c7057ad614$export$370b2e8d6d6f5c56((0, $1Fos3._)({
        values: values,
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodNativeEnum
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
class $0056b1c7057ad614$export$3f196b0127d6e50a extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $0056b1c7057ad614$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_type,
                expected: $0056b1c7057ad614$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $0056b1c7057ad614$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $0056b1c7057ad614$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $0056b1c7057ad614$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$0056b1c7057ad614$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $0056b1c7057ad614$export$3f196b0127d6e50a((0, $1Fos3._)({
        type: schema,
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodPromise
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
class $0056b1c7057ad614$export$a60af00cc0ce2582 extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $0056b1c7057ad614$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $0056b1c7057ad614$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return $0056b1c7057ad614$export$9a105a556e65c2c0;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $0056b1c7057ad614$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $0056b1c7057ad614$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $0056b1c7057ad614$export$325a211da9693fcf(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return $0056b1c7057ad614$export$9a105a556e65c2c0;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $0056b1c7057ad614$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $0056b1c7057ad614$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $0056b1c7057ad614$export$325a211da9693fcf(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $0056b1c7057ad614$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $0056b1c7057ad614$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$0056b1c7057ad614$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$0056b1c7057ad614$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $0056b1c7057ad614$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$0056b1c7057ad614$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $0056b1c7057ad614$export$a60af00cc0ce2582((0, $1Fos3._)({
        schema: schema,
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodEffects,
        effect: effect
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
$0056b1c7057ad614$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $0056b1c7057ad614$export$a60af00cc0ce2582((0, $1Fos3._)({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodEffects
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
class $0056b1c7057ad614$export$aa56fec1e9d629b8 extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $0056b1c7057ad614$export$5716da67bfaa244d.undefined) return $0056b1c7057ad614$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$0056b1c7057ad614$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $0056b1c7057ad614$export$aa56fec1e9d629b8((0, $1Fos3._)({
        innerType: type,
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodOptional
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
class $0056b1c7057ad614$export$aaac0b8b429cef5 extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $0056b1c7057ad614$export$5716da67bfaa244d.null) return $0056b1c7057ad614$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$0056b1c7057ad614$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $0056b1c7057ad614$export$aaac0b8b429cef5((0, $1Fos3._)({
        innerType: type,
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodNullable
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
class $0056b1c7057ad614$export$bb19b37874861e7e extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $0056b1c7057ad614$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$0056b1c7057ad614$export$bb19b37874861e7e.create = (type, params)=>{
    return new $0056b1c7057ad614$export$bb19b37874861e7e((0, $1Fos3._)({
        innerType: type,
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
class $0056b1c7057ad614$export$75a44ec6249ac76b extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = (0, $b2I6k._)((0, $1Fos3._)({}, ctx), {
            common: (0, $b2I6k._)((0, $1Fos3._)({}, ctx.common), {
                issues: []
            })
        });
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: (0, $1Fos3._)({}, newCtx)
        });
        if ($0056b1c7057ad614$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $0056b1c7057ad614$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $0056b1c7057ad614$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$0056b1c7057ad614$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $0056b1c7057ad614$export$75a44ec6249ac76b((0, $1Fos3._)({
        innerType: type,
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
class $0056b1c7057ad614$export$26ccfa0145e8511f extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $0056b1c7057ad614$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $0056b1c7057ad614$export$db7caee60e5d514d(ctx, {
                code: $0056b1c7057ad614$export$5ba560653e4a1035.invalid_type,
                expected: $0056b1c7057ad614$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $0056b1c7057ad614$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$0056b1c7057ad614$export$26ccfa0145e8511f.create = (params)=>{
    return new $0056b1c7057ad614$export$26ccfa0145e8511f((0, $1Fos3._)({
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodNaN
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
const $0056b1c7057ad614$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $0056b1c7057ad614$export$66b0c798a395271f extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $0056b1c7057ad614$export$a3c3ef8a0e95c6da extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $0056b1c7057ad614$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $0056b1c7057ad614$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $0056b1c7057ad614$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $0056b1c7057ad614$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $0056b1c7057ad614$export$5d1f7ef05c4e493a extends $0056b1c7057ad614$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ($0056b1c7057ad614$export$1ea939691cdc45b8(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return $0056b1c7057ad614$export$aefee5ebe1dcfd9e(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$0056b1c7057ad614$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $0056b1c7057ad614$export$5d1f7ef05c4e493a((0, $1Fos3._)({
        innerType: type,
        typeName: $0056b1c7057ad614$export$558106ce543bd011.ZodReadonly
    }, $0056b1c7057ad614$var$processCreateParams(params)));
};
function $0056b1c7057ad614$export$4c00f665f0d4b443(check, params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return $0056b1c7057ad614$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue((0, $b2I6k._)((0, $1Fos3._)({
                code: "custom"
            }, p2), {
                fatal: _fatal
            }));
        }
    });
    return $0056b1c7057ad614$export$b9d1edb536b4e4eb.create();
}
const $0056b1c7057ad614$export$1ee8ee30835eab8b = {
    object: $0056b1c7057ad614$export$736315c5b55efbad.lazycreate
};
var $0056b1c7057ad614$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($0056b1c7057ad614$export$558106ce543bd011 || ($0056b1c7057ad614$export$558106ce543bd011 = {}));
const $0056b1c7057ad614$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$0056b1c7057ad614$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $0056b1c7057ad614$export$22b082955e083ec3 = $0056b1c7057ad614$export$1230eb29b8d3b502.create;
const $0056b1c7057ad614$export$98e628dec113755e = $0056b1c7057ad614$export$5b070a55c0c43e09.create;
const $0056b1c7057ad614$export$9e06de0973666692 = $0056b1c7057ad614$export$26ccfa0145e8511f.create;
const $0056b1c7057ad614$export$a0f65b52274bcc00 = $0056b1c7057ad614$export$67d741fd70ff98f4.create;
const $0056b1c7057ad614$export$4a21f16c33752377 = $0056b1c7057ad614$export$723d146f80596191.create;
const $0056b1c7057ad614$export$324d90190a8b822a = $0056b1c7057ad614$export$e974be33bdc55521.create;
const $0056b1c7057ad614$export$8f701197936bc2a6 = $0056b1c7057ad614$export$bcc3b40f6b638044.create;
const $0056b1c7057ad614$export$1db45310990710a5 = $0056b1c7057ad614$export$4e780e961c30340d.create;
const $0056b1c7057ad614$export$7b1b591b262c240 = $0056b1c7057ad614$export$a96281f914484f2d.create;
const $0056b1c7057ad614$export$4154a199d7d90455 = $0056b1c7057ad614$export$b9d1edb536b4e4eb.create;
const $0056b1c7057ad614$export$19282c40b967aec6 = $0056b1c7057ad614$export$ef3b1bb1630977ae.create;
const $0056b1c7057ad614$export$b3e22bcfd64c1022 = $0056b1c7057ad614$export$1e576a20c3ce9fb5.create;
const $0056b1c7057ad614$export$490e536ee7389aeb = $0056b1c7057ad614$export$7d39f5df85f21031.create;
const $0056b1c7057ad614$export$2f23118c22fb2630 = $0056b1c7057ad614$export$7acfc3e64785411.create;
const $0056b1c7057ad614$export$be5493f9613cbbe = $0056b1c7057ad614$export$736315c5b55efbad.create;
const $0056b1c7057ad614$export$8fb0df5f40d0b477 = $0056b1c7057ad614$export$736315c5b55efbad.strictCreate;
const $0056b1c7057ad614$export$971dd5b0dfd021b6 = $0056b1c7057ad614$export$a8b236cb5070a311.create;
const $0056b1c7057ad614$export$4b888e40c4ee26dd = $0056b1c7057ad614$export$5ef2424805ac76a3.create;
const $0056b1c7057ad614$export$bc86dfbf7795668c = $0056b1c7057ad614$export$c02deaf0bb5203d4.create;
const $0056b1c7057ad614$export$65e3907585753458 = $0056b1c7057ad614$export$e2a18bb771d8e6a3.create;
const $0056b1c7057ad614$export$e5185e241753e543 = $0056b1c7057ad614$export$a2acc09968cb4b7f.create;
const $0056b1c7057ad614$export$871de8747c9eaa88 = $0056b1c7057ad614$export$163b6a2b712d9542.create;
const $0056b1c7057ad614$export$adaa4cf7ef1b65be = $0056b1c7057ad614$export$977057706f816712.create;
const $0056b1c7057ad614$export$44e51c8aac7c2deb = $0056b1c7057ad614$export$d4602ba55673f53c.create;
const $0056b1c7057ad614$export$488013bae63b21da = $0056b1c7057ad614$export$378d0cfce37406e6.create;
const $0056b1c7057ad614$export$c8ec6e1ec9fefcb0 = $0056b1c7057ad614$export$7e44096782a165d3.create;
const $0056b1c7057ad614$export$78a99c8d44d72635 = $0056b1c7057ad614$export$d325d1f0e1c20179.create;
const $0056b1c7057ad614$export$6fe7eca19ebe5199 = $0056b1c7057ad614$export$370b2e8d6d6f5c56.create;
const $0056b1c7057ad614$export$c957ef27a0ebfd4 = $0056b1c7057ad614$export$3f196b0127d6e50a.create;
const $0056b1c7057ad614$export$dc573d8a6576cdb3 = $0056b1c7057ad614$export$a60af00cc0ce2582.create;
const $0056b1c7057ad614$export$516e28dec6a4b6d4 = $0056b1c7057ad614$export$aa56fec1e9d629b8.create;
const $0056b1c7057ad614$export$133fc36489ac9add = $0056b1c7057ad614$export$aaac0b8b429cef5.create;
const $0056b1c7057ad614$export$fc37fe19dfda43ee = $0056b1c7057ad614$export$a60af00cc0ce2582.createWithPreprocess;
const $0056b1c7057ad614$export$43f28b24e1eb8181 = $0056b1c7057ad614$export$a3c3ef8a0e95c6da.create;
const $0056b1c7057ad614$export$3b3d07727c5b702c = ()=>$0056b1c7057ad614$export$22b082955e083ec3().optional();
const $0056b1c7057ad614$export$eb150471a61fced6 = ()=>$0056b1c7057ad614$export$98e628dec113755e().optional();
const $0056b1c7057ad614$export$269251733cdcbbf1 = ()=>$0056b1c7057ad614$export$4a21f16c33752377().optional();
const $0056b1c7057ad614$export$8c14e57e778d3873 = {
    string: (arg)=>$0056b1c7057ad614$export$1230eb29b8d3b502.create((0, $b2I6k._)((0, $1Fos3._)({}, arg), {
            coerce: true
        })),
    number: (arg)=>$0056b1c7057ad614$export$5b070a55c0c43e09.create((0, $b2I6k._)((0, $1Fos3._)({}, arg), {
            coerce: true
        })),
    boolean: (arg)=>$0056b1c7057ad614$export$723d146f80596191.create((0, $b2I6k._)((0, $1Fos3._)({}, arg), {
            coerce: true
        })),
    bigint: (arg)=>$0056b1c7057ad614$export$67d741fd70ff98f4.create((0, $b2I6k._)((0, $1Fos3._)({}, arg), {
            coerce: true
        })),
    date: (arg)=>$0056b1c7057ad614$export$e974be33bdc55521.create((0, $b2I6k._)((0, $1Fos3._)({}, arg), {
            coerce: true
        }))
};
const $0056b1c7057ad614$export$96c94437c95d7862 = $0056b1c7057ad614$export$9a105a556e65c2c0;
var $0056b1c7057ad614$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $0056b1c7057ad614$export$341b0b6e0a6f5099,
    setErrorMap: $0056b1c7057ad614$export$1097a8289cfd22d7,
    getErrorMap: $0056b1c7057ad614$export$32f27c719778d4c4,
    makeIssue: $0056b1c7057ad614$export$244a85fde9c419ed,
    EMPTY_PATH: $0056b1c7057ad614$export$1526d2e05f74572,
    addIssueToContext: $0056b1c7057ad614$export$db7caee60e5d514d,
    ParseStatus: $0056b1c7057ad614$export$5b20a5c3d05c1f6f,
    INVALID: $0056b1c7057ad614$export$9a105a556e65c2c0,
    DIRTY: $0056b1c7057ad614$export$325a211da9693fcf,
    OK: $0056b1c7057ad614$export$c6813a8d51f77eaf,
    isAborted: $0056b1c7057ad614$export$afa861e3c5730743,
    isDirty: $0056b1c7057ad614$export$910b6cdd390341b3,
    isValid: $0056b1c7057ad614$export$1ea939691cdc45b8,
    isAsync: $0056b1c7057ad614$export$aefee5ebe1dcfd9e,
    get util () {
        return $0056b1c7057ad614$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $0056b1c7057ad614$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $0056b1c7057ad614$export$5716da67bfaa244d,
    getParsedType: $0056b1c7057ad614$export$3e9057828ebd5c7a,
    ZodType: $0056b1c7057ad614$export$19342e026b58ebb7,
    datetimeRegex: $0056b1c7057ad614$export$a4b563879add27a,
    ZodString: $0056b1c7057ad614$export$1230eb29b8d3b502,
    ZodNumber: $0056b1c7057ad614$export$5b070a55c0c43e09,
    ZodBigInt: $0056b1c7057ad614$export$67d741fd70ff98f4,
    ZodBoolean: $0056b1c7057ad614$export$723d146f80596191,
    ZodDate: $0056b1c7057ad614$export$e974be33bdc55521,
    ZodSymbol: $0056b1c7057ad614$export$bcc3b40f6b638044,
    ZodUndefined: $0056b1c7057ad614$export$4e780e961c30340d,
    ZodNull: $0056b1c7057ad614$export$a96281f914484f2d,
    ZodAny: $0056b1c7057ad614$export$b9d1edb536b4e4eb,
    ZodUnknown: $0056b1c7057ad614$export$ef3b1bb1630977ae,
    ZodNever: $0056b1c7057ad614$export$1e576a20c3ce9fb5,
    ZodVoid: $0056b1c7057ad614$export$7d39f5df85f21031,
    ZodArray: $0056b1c7057ad614$export$7acfc3e64785411,
    ZodObject: $0056b1c7057ad614$export$736315c5b55efbad,
    ZodUnion: $0056b1c7057ad614$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $0056b1c7057ad614$export$5ef2424805ac76a3,
    ZodIntersection: $0056b1c7057ad614$export$c02deaf0bb5203d4,
    ZodTuple: $0056b1c7057ad614$export$e2a18bb771d8e6a3,
    ZodRecord: $0056b1c7057ad614$export$a2acc09968cb4b7f,
    ZodMap: $0056b1c7057ad614$export$163b6a2b712d9542,
    ZodSet: $0056b1c7057ad614$export$977057706f816712,
    ZodFunction: $0056b1c7057ad614$export$d4602ba55673f53c,
    ZodLazy: $0056b1c7057ad614$export$378d0cfce37406e6,
    ZodLiteral: $0056b1c7057ad614$export$7e44096782a165d3,
    ZodEnum: $0056b1c7057ad614$export$d325d1f0e1c20179,
    ZodNativeEnum: $0056b1c7057ad614$export$370b2e8d6d6f5c56,
    ZodPromise: $0056b1c7057ad614$export$3f196b0127d6e50a,
    ZodEffects: $0056b1c7057ad614$export$a60af00cc0ce2582,
    ZodTransformer: $0056b1c7057ad614$export$a60af00cc0ce2582,
    ZodOptional: $0056b1c7057ad614$export$aa56fec1e9d629b8,
    ZodNullable: $0056b1c7057ad614$export$aaac0b8b429cef5,
    ZodDefault: $0056b1c7057ad614$export$bb19b37874861e7e,
    ZodCatch: $0056b1c7057ad614$export$75a44ec6249ac76b,
    ZodNaN: $0056b1c7057ad614$export$26ccfa0145e8511f,
    BRAND: $0056b1c7057ad614$export$cf2deea74cde46b4,
    ZodBranded: $0056b1c7057ad614$export$66b0c798a395271f,
    ZodPipeline: $0056b1c7057ad614$export$a3c3ef8a0e95c6da,
    ZodReadonly: $0056b1c7057ad614$export$5d1f7ef05c4e493a,
    custom: $0056b1c7057ad614$export$4c00f665f0d4b443,
    Schema: $0056b1c7057ad614$export$19342e026b58ebb7,
    ZodSchema: $0056b1c7057ad614$export$19342e026b58ebb7,
    late: $0056b1c7057ad614$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $0056b1c7057ad614$export$558106ce543bd011;
    },
    coerce: $0056b1c7057ad614$export$8c14e57e778d3873,
    any: $0056b1c7057ad614$export$4154a199d7d90455,
    array: $0056b1c7057ad614$export$2f23118c22fb2630,
    bigint: $0056b1c7057ad614$export$a0f65b52274bcc00,
    boolean: $0056b1c7057ad614$export$4a21f16c33752377,
    date: $0056b1c7057ad614$export$324d90190a8b822a,
    discriminatedUnion: $0056b1c7057ad614$export$4b888e40c4ee26dd,
    effect: $0056b1c7057ad614$export$dc573d8a6576cdb3,
    'enum': $0056b1c7057ad614$export$78a99c8d44d72635,
    'function': $0056b1c7057ad614$export$44e51c8aac7c2deb,
    'instanceof': $0056b1c7057ad614$export$3d916e7c22dbd8b5,
    intersection: $0056b1c7057ad614$export$bc86dfbf7795668c,
    lazy: $0056b1c7057ad614$export$488013bae63b21da,
    literal: $0056b1c7057ad614$export$c8ec6e1ec9fefcb0,
    map: $0056b1c7057ad614$export$871de8747c9eaa88,
    nan: $0056b1c7057ad614$export$9e06de0973666692,
    nativeEnum: $0056b1c7057ad614$export$6fe7eca19ebe5199,
    never: $0056b1c7057ad614$export$b3e22bcfd64c1022,
    'null': $0056b1c7057ad614$export$7b1b591b262c240,
    nullable: $0056b1c7057ad614$export$133fc36489ac9add,
    number: $0056b1c7057ad614$export$98e628dec113755e,
    object: $0056b1c7057ad614$export$be5493f9613cbbe,
    oboolean: $0056b1c7057ad614$export$269251733cdcbbf1,
    onumber: $0056b1c7057ad614$export$eb150471a61fced6,
    optional: $0056b1c7057ad614$export$516e28dec6a4b6d4,
    ostring: $0056b1c7057ad614$export$3b3d07727c5b702c,
    pipeline: $0056b1c7057ad614$export$43f28b24e1eb8181,
    preprocess: $0056b1c7057ad614$export$fc37fe19dfda43ee,
    promise: $0056b1c7057ad614$export$c957ef27a0ebfd4,
    record: $0056b1c7057ad614$export$e5185e241753e543,
    set: $0056b1c7057ad614$export$adaa4cf7ef1b65be,
    strictObject: $0056b1c7057ad614$export$8fb0df5f40d0b477,
    string: $0056b1c7057ad614$export$22b082955e083ec3,
    symbol: $0056b1c7057ad614$export$8f701197936bc2a6,
    transformer: $0056b1c7057ad614$export$dc573d8a6576cdb3,
    tuple: $0056b1c7057ad614$export$65e3907585753458,
    'undefined': $0056b1c7057ad614$export$1db45310990710a5,
    union: $0056b1c7057ad614$export$971dd5b0dfd021b6,
    unknown: $0056b1c7057ad614$export$19282c40b967aec6,
    'void': $0056b1c7057ad614$export$490e536ee7389aeb,
    NEVER: $0056b1c7057ad614$export$96c94437c95d7862,
    ZodIssueCode: $0056b1c7057ad614$export$5ba560653e4a1035,
    quotelessJson: $0056b1c7057ad614$export$913eddeaf297cfea,
    ZodError: $0056b1c7057ad614$export$f98dac4b251ab333
});

});





parcelRegister("cL1dd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $949ad0873ef3639a$export$2e2bcd8739ae039; });
function $949ad0873ef3639a$export$2e2bcd8739ae039() {
    const deferred = {};
    deferred.promise = new Promise((resolve, reject)=>{
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    return deferred;
}

});





parcelRegister("7eWkL", function(module, exports) {

$parcel$export(module.exports, "getPageLoadMetric", function () { return $03e93b52da253d9e$export$74b8bc7a2c5f037b; });

var $iBu0H = parcelRequire("iBu0H");

var $6cMFi = parcelRequire("6cMFi");
const $03e93b52da253d9e$var$cachedMetrics = new Map();
const $03e93b52da253d9e$export$74b8bc7a2c5f037b = (pageId)=>{
    // Convert to kebab case to comply with naming convention:
    // https://hello.atlassian.net/wiki/spaces/APD/pages/1435310934/RUNBOOK+Get+the+Experience+Event+Key#Naming-conventions
    const page = pageId.replace(/([a-z])([A-Z])/g, '$1-$2').replace(/[\s_]+/g, '-').toLowerCase();
    let metric = $03e93b52da253d9e$var$cachedMetrics.get(page);
    if (!metric) {
        metric = (0, $iBu0H.metrics).pageLoad({
            key: page,
            custom: {
                isServedByBifrost: (0, $6cMFi.default)()
            }
        });
        $03e93b52da253d9e$var$cachedMetrics.set(page, metric);
    }
    return metric;
};

});
parcelRegister("iBu0H", function(module, exports) {

$parcel$export(module.exports, "metrics", function () { return $d8b2f61f74f1c469$export$b0c5c2fac8144e54; });

var $dmplZ = parcelRequire("dmplZ");

var $2t3U6 = parcelRequire("2t3U6");
var $d8b2f61f74f1c469$export$b0c5c2fac8144e54 = {
    pageLoad: (0, $2t3U6.pageLoad),
    pageSegmentLoad: (0, $2t3U6.pageSegmentLoad),
    interaction: (0, $2t3U6.interaction),
    custom: (0, $2t3U6.custom),
    concurrent: (0, $dmplZ.concurrent)
};

});
parcelRegister("dmplZ", function(module, exports) {

$parcel$export(module.exports, "concurrent", function () { return $9ba0ff2813fa7fb8$export$370df09ecc3de059; });

var $dsN6L = parcelRequire("dsN6L");

var $5JEHx = parcelRequire("5JEHx");

var $2t3U6 = parcelRequire("2t3U6");
function $9ba0ff2813fa7fb8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9ba0ff2813fa7fb8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9ba0ff2813fa7fb8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9ba0ff2813fa7fb8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9ba0ff2813fa7fb8$var$concurrentMetrics = {};
var $9ba0ff2813fa7fb8$var$getKey = function getKey(config, type) {
    return "".concat(type, "--").concat(config.key);
};
var $9ba0ff2813fa7fb8$var$validateConfig = function validateConfig(config) {
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
var $9ba0ff2813fa7fb8$var$ensurePath = function ensurePath(config, type) {
    var key = $9ba0ff2813fa7fb8$var$getKey(config, type);
    if (!(key in $9ba0ff2813fa7fb8$var$concurrentMetrics)) $9ba0ff2813fa7fb8$var$concurrentMetrics[key] = {};
};
var $9ba0ff2813fa7fb8$var$getMetricFromCache = function getMetricFromCache(concurrentId, config, type) {
    var concurrentKey = $9ba0ff2813fa7fb8$var$getKey(config, type);
    if (concurrentKey in $9ba0ff2813fa7fb8$var$concurrentMetrics && $9ba0ff2813fa7fb8$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $9ba0ff2813fa7fb8$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $9ba0ff2813fa7fb8$var$concurrentMetrics)) $9ba0ff2813fa7fb8$var$concurrentMetrics[concurrentKey] = {};
};
var $9ba0ff2813fa7fb8$var$makeConcurrentMetric = function makeConcurrentMetric(concurrentId, config, type) {
    $9ba0ff2813fa7fb8$var$validateConfig(config);
    $9ba0ff2813fa7fb8$var$ensurePath(config, type);
    var metricFromCache = $9ba0ff2813fa7fb8$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    var metricFactory = type === (0, $5JEHx.BMEventsType).INLINE_RESULT ? (0, $2t3U6.interaction) : (0, $2t3U6.custom);
    var metric = metricFactory(config);
    $9ba0ff2813fa7fb8$var$concurrentMetrics[$9ba0ff2813fa7fb8$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
var $9ba0ff2813fa7fb8$export$370df09ecc3de059 = {
    pageSegmentLoad: function pageSegmentLoad(config) {
        return function(concurrentId) {
            return $9ba0ff2813fa7fb8$var$makeConcurrentMetric(concurrentId, $9ba0ff2813fa7fb8$var$_objectSpread({}, config), (0, $5JEHx.BMEventsType).PAGE_SEGMENT_LOAD);
        };
    },
    interaction: function interaction(config) {
        return function(concurrentId) {
            return $9ba0ff2813fa7fb8$var$makeConcurrentMetric(concurrentId, $9ba0ff2813fa7fb8$var$_objectSpread({}, config), (0, $5JEHx.BMEventsType).INLINE_RESULT);
        };
    },
    custom: function custom(config) {
        return function(concurrentId) {
            return $9ba0ff2813fa7fb8$var$makeConcurrentMetric(concurrentId, $9ba0ff2813fa7fb8$var$_objectSpread({}, config), (0, $5JEHx.BMEventsType).CUSTOM);
        };
    }
};

});
parcelRegister("2t3U6", function(module, exports) {

$parcel$export(module.exports, "pageLoad", function () { return $1cc15173b0565835$export$791d520f7e8058a5; });
$parcel$export(module.exports, "pageSegmentLoad", function () { return $1cc15173b0565835$export$94114666844d5f66; });
$parcel$export(module.exports, "interaction", function () { return $1cc15173b0565835$export$92473e6020ad89b4; });
$parcel$export(module.exports, "custom", function () { return $1cc15173b0565835$export$4c00f665f0d4b443; });

var $dsN6L = parcelRequire("dsN6L");

var $7MgwL = parcelRequire("7MgwL");

var $5GnBi = parcelRequire("5GnBi");

var $2N7kc = parcelRequire("2N7kc");

var $5JEHx = parcelRequire("5JEHx");
function $1cc15173b0565835$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1cc15173b0565835$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1cc15173b0565835$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1cc15173b0565835$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1cc15173b0565835$export$791d520f7e8058a5 = function pageLoad(config) {
    return new (0, $5GnBi.PageLoadMetric)($1cc15173b0565835$var$_objectSpread($1cc15173b0565835$var$_objectSpread({}, config), {}, {
        type: (0, $5JEHx.BMEventsType).PAGE_LOAD
    }));
};
var $1cc15173b0565835$export$94114666844d5f66 = function pageSegmentLoad(config) {
    return new (0, $2N7kc.PageSegmentLoadMetric)($1cc15173b0565835$var$_objectSpread($1cc15173b0565835$var$_objectSpread({}, config), {}, {
        type: (0, $5JEHx.BMEventsType).PAGE_SEGMENT_LOAD
    }));
};
var $1cc15173b0565835$export$92473e6020ad89b4 = function interaction(config) {
    return new (0, $7MgwL.Metric)($1cc15173b0565835$var$_objectSpread($1cc15173b0565835$var$_objectSpread({}, config), {}, {
        type: (0, $5JEHx.BMEventsType).INLINE_RESULT
    }));
};
var $1cc15173b0565835$export$4c00f665f0d4b443 = function custom(config) {
    return new (0, $7MgwL.Metric)($1cc15173b0565835$var$_objectSpread($1cc15173b0565835$var$_objectSpread({}, config), {}, {
        type: (0, $5JEHx.BMEventsType).CUSTOM
    }));
};

});
parcelRegister("7MgwL", function(module, exports) {

$parcel$export(module.exports, "Metric", function () { return $01761819379e4539$export$efdd3e096bc27746; });

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $gGOBY = parcelRequire("gGOBY");

var $lVDuE = parcelRequire("lVDuE");

var $dX0BB = parcelRequire("dX0BB");

var $kSyoi = parcelRequire("kSyoi");

var $h8Adp = parcelRequire("h8Adp");

var $eYIeC = parcelRequire("eYIeC");

var $2Dr5Z = parcelRequire("2Dr5Z");
function $01761819379e4539$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($gGOBY)))(t, $01761819379e4539$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(t).constructor) : o.apply(t, e));
}
function $01761819379e4539$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($01761819379e4539$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $01761819379e4539$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dX0BB)))((0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $01761819379e4539$export$efdd3e096bc27746 = /*#__PURE__*/ function(_BaseMetric) {
    function Metric() {
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, Metric);
        return $01761819379e4539$var$_callSuper(this, Metric, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($kSyoi)))(Metric, _BaseMetric);
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(Metric, [
        {
            key: "start",
            value: function start() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, startTime = _ref.startTime;
                $01761819379e4539$var$_superPropGet(Metric, "start", this, 3)([
                    {
                        startTime: startTime
                    }
                ]);
                this.route = (0, $h8Adp.Route).getRoute();
            }
        },
        {
            key: "stop",
            value: function stop() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var stoppedSuccessfully = $01761819379e4539$var$_superPropGet(Metric, "stop", this, 3)([
                    params
                ]);
                if (stoppedSuccessfully && !this.config.virtual) (0, $eYIeC.submitter).queue(this.getData());
                return stoppedSuccessfully;
            }
        }
    ]);
}((0, $2Dr5Z.BaseMetric));

});

parcelRegister("5GnBi", function(module, exports) {

$parcel$export(module.exports, "PageLoadMetric", function () { return $42332e90e181182d$export$3c51073271a9eac3; });

var $2R76C = parcelRequire("2R76C");

var $dsN6L = parcelRequire("dsN6L");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $gGOBY = parcelRequire("gGOBY");

var $lVDuE = parcelRequire("lVDuE");

var $dX0BB = parcelRequire("dX0BB");

var $kSyoi = parcelRequire("kSyoi");

var $eWMMH = parcelRequire("eWMMH");

var $kvMag = parcelRequire("kvMag");

var $7SFmd = parcelRequire("7SFmd");

var $h8Adp = parcelRequire("h8Adp");

var $eYIeC = parcelRequire("eYIeC");

var $5JEHx = parcelRequire("5JEHx");

var $cpGHF = parcelRequire("cpGHF");

var $45L5U = parcelRequire("45L5U");

var $aQpN9 = parcelRequire("aQpN9");
function $42332e90e181182d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $42332e90e181182d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $42332e90e181182d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $42332e90e181182d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $42332e90e181182d$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($gGOBY)))(t, $42332e90e181182d$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(t).constructor) : o.apply(t, e));
}
function $42332e90e181182d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($42332e90e181182d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $42332e90e181182d$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dX0BB)))((0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $42332e90e181182d$export$3c51073271a9eac3 = /*#__PURE__*/ function(_BasePageLoadMetric) {
    function PageLoadMetric() {
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, PageLoadMetric);
        return $42332e90e181182d$var$_callSuper(this, PageLoadMetric, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($kSyoi)))(PageLoadMetric, _BasePageLoadMetric);
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(PageLoadMetric, [
        {
            key: "startPageLoad",
            value: function startPageLoad() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                    isInitial: false
                };
                (0, $45L5U.pageLoadMetaMetric).startPageLoad($42332e90e181182d$var$_objectSpread($42332e90e181182d$var$_objectSpread({}, params), {}, {
                    cancelStarted: 'startTime' in params
                }));
                this.watchUntil();
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$config$ssr;
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var stopTime = params.stopTime || window.performance.now();
                var pageLoadData = (0, $45L5U.pageLoadMetaMetric).getDataToMerge();
                var metaMetricStopped = (0, $45L5U.pageLoadMetaMetric).stop(params);
                if (!metaMetricStopped) return false;
                if (pageLoadData.isInitial && (_this$config$ssr = this.config.ssr) !== null && _this$config$ssr !== void 0 && _this$config$ssr.doneAsFmp) {
                    if (!this.marks[(0, $cpGHF.BasePageLoadMetric).FMP]) {
                        var mark = (0, $kvMag.SSRGetDoneMark).getDoneMark();
                        if (mark) (0, $45L5U.pageLoadMetaMetric).markFMP(mark);
                    } else (0, $45L5U.pageLoadMetaMetric).markFMP(this.marks[(0, $cpGHF.BasePageLoadMetric).FMP]);
                }
                this.route = (0, $h8Adp.Route).getRoute();
                var metricStopped = this.stopPageLoad(pageLoadData, $42332e90e181182d$var$_objectSpread($42332e90e181182d$var$_objectSpread({}, params), {}, {
                    stopTime: stopTime
                }));
                if (!metricStopped) return false;
                var data = this.getData();
                if (!this.config.virtual) (0, $eYIeC.submitter).queue(data);
                (0, $7SFmd.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
                this.enqueueWebVitals();
                return true;
            }
        },
        {
            key: "mark",
            value: function mark(_mark) {
                var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance.now();
                (0, $45L5U.pageLoadMetaMetric).mark(_mark, timestamp);
            }
        },
        {
            key: "markFMP",
            value: function markFMP(timestamp) {
                (0, $45L5U.pageLoadMetaMetric).markFMP(timestamp);
            }
        },
        {
            key: "getData",
            value: function getData() {
                var pageLoadMetaData = (0, $45L5U.pageLoadMetaMetric).getData();
                return $42332e90e181182d$var$_objectSpread($42332e90e181182d$var$_objectSpread({}, $42332e90e181182d$var$_superPropGet(PageLoadMetric, "getData", this, 3)([])), {}, {
                    // marks and explicitTimings are available only in pageLoadMeta
                    marks: pageLoadMetaData.marks,
                    explicitTimings: pageLoadMetaData.explicitTimings
                });
            }
        },
        {
            key: "enqueueWebVitals",
            value: function() {
                var _enqueueWebVitals = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee() {
                    var _configChunk$BMEvents;
                    var configChunk, webVitalMetric;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!(this.config.virtual || !this.isInitial)) {
                                    _context.next = 2;
                                    break;
                                }
                                return _context.abrupt("return", false);
                            case 2:
                                _context.next = 4;
                                return (0, $eYIeC.submitter).config.configChunk;
                            case 4:
                                configChunk = _context.sent;
                                if (configChunk !== null && configChunk !== void 0 && (_configChunk$BMEvents = configChunk[(0, $5JEHx.BMEventsType).WEB_VITALS].webVitals) !== null && _configChunk$BMEvents !== void 0 && _configChunk$BMEvents.enabled) {
                                    _context.next = 7;
                                    break;
                                }
                                return _context.abrupt("return", false);
                            case 7:
                                webVitalMetric = new (0, $aQpN9.WebVitalsMetric)({
                                    key: this.config.key,
                                    route: this.route,
                                    startTime: this.startTime,
                                    stopTime: this.stopTime,
                                    pageVisibleState: this.pageVisibleState
                                });
                                (0, $eYIeC.submitter).queue(webVitalMetric.getData());
                                (0, $7SFmd.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
                                return _context.abrupt("return", true);
                            case 11:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function enqueueWebVitals() {
                    return _enqueueWebVitals.apply(this, arguments);
                }
                return enqueueWebVitals;
            }()
        }
    ]);
}((0, $cpGHF.BasePageLoadMetric));

});
parcelRegister("aQpN9", function(module, exports) {

$parcel$export(module.exports, "WebVitalsMetric", function () { return $7e52c469d7cd8034$export$dc0d85d4d6503cd7; });

var $iTPYb = parcelRequire("iTPYb");

var $3lbuJ = parcelRequire("3lbuJ");

var $gGOBY = parcelRequire("gGOBY");

var $lVDuE = parcelRequire("lVDuE");

var $kSyoi = parcelRequire("kSyoi");

var $5JEHx = parcelRequire("5JEHx");

var $2Dr5Z = parcelRequire("2Dr5Z");
function $7e52c469d7cd8034$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($gGOBY)))(t, $7e52c469d7cd8034$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(t).constructor) : o.apply(t, e));
}
function $7e52c469d7cd8034$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7e52c469d7cd8034$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $7e52c469d7cd8034$export$dc0d85d4d6503cd7 = /*#__PURE__*/ function(_BaseMetric) {
    function WebVitalsMetric(_ref) {
        var _this;
        var key = _ref.key, route = _ref.route, startTime = _ref.startTime, stopTime = _ref.stopTime, pageVisibleState = _ref.pageVisibleState;
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, WebVitalsMetric);
        _this = $7e52c469d7cd8034$var$_callSuper(this, WebVitalsMetric, [
            {
                type: (0, $5JEHx.BMEventsType).WEB_VITALS,
                key: key
            }
        ]);
        _this.route = route;
        _this.startTime = startTime;
        _this.stopTime = stopTime;
        _this.state = (0, $2Dr5Z.MetricState).FINISHED;
        _this.pageVisibleState = pageVisibleState;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($kSyoi)))(WebVitalsMetric, _BaseMetric);
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(WebVitalsMetric);
}((0, $2Dr5Z.BaseMetric));

});


parcelRegister("2N7kc", function(module, exports) {

$parcel$export(module.exports, "PageSegmentLoadMetric", function () { return $2085d6ee71d212c5$export$24c8bfcd77494cc1; });

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $gGOBY = parcelRequire("gGOBY");

var $lVDuE = parcelRequire("lVDuE");

var $dX0BB = parcelRequire("dX0BB");

var $kSyoi = parcelRequire("kSyoi");

var $dsN6L = parcelRequire("dsN6L");

var $kvMag = parcelRequire("kvMag");

var $5JEHx = parcelRequire("5JEHx");

var $2Dr5Z = parcelRequire("2Dr5Z");

var $7MgwL = parcelRequire("7MgwL");

var $45L5U = parcelRequire("45L5U");
function $2085d6ee71d212c5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2085d6ee71d212c5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2085d6ee71d212c5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2085d6ee71d212c5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2085d6ee71d212c5$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($gGOBY)))(t, $2085d6ee71d212c5$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(t).constructor) : o.apply(t, e));
}
function $2085d6ee71d212c5$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($2085d6ee71d212c5$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $2085d6ee71d212c5$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dX0BB)))((0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $2085d6ee71d212c5$export$24c8bfcd77494cc1 = /*#__PURE__*/ function(_Metric) {
    function PageSegmentLoadMetric(config) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, PageSegmentLoadMetric);
        _this = $2085d6ee71d212c5$var$_callSuper(this, PageSegmentLoadMetric, [
            config
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "isInitial", true);
        _this.config = config;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($kSyoi)))(PageSegmentLoadMetric, _Metric);
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(PageSegmentLoadMetric, [
        {
            key: "startFromPageLoad",
            value: function startFromPageLoad() {
                var _pageLoadMetaData$sta;
                var pageLoadMetaData = (0, $45L5U.pageLoadMetaMetric).getData();
                this.start({
                    startTime: (_pageLoadMetaData$sta = pageLoadMetaData.start) !== null && _pageLoadMetaData$sta !== void 0 ? _pageLoadMetaData$sta : undefined
                });
                this.isInitial = pageLoadMetaData.isInitial;
                this.pageVisibleState = pageLoadMetaData.pageVisibleState;
            }
        },
        {
            key: "mark",
            value: function mark(_mark) {
                var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance.now();
                if (_mark === PageSegmentLoadMetric.FMP) return;
                $2085d6ee71d212c5$var$_superPropGet(PageSegmentLoadMetric, "mark", this, 3)([
                    _mark,
                    timestamp
                ]);
            }
        },
        {
            key: "markFMP",
            value: function markFMP(timestamp) {
                $2085d6ee71d212c5$var$_superPropGet(PageSegmentLoadMetric, "mark", this, 3)([
                    PageSegmentLoadMetric.FMP,
                    timestamp
                ]);
            }
        },
        {
            key: "getPageSegmentLoadData",
            value: function getPageSegmentLoadData() {
                return {
                    isInitial: this.isInitial
                };
            }
        },
        {
            key: "getData",
            value: function getData() {
                return $2085d6ee71d212c5$var$_objectSpread($2085d6ee71d212c5$var$_objectSpread({}, $2085d6ee71d212c5$var$_superPropGet(PageSegmentLoadMetric, "getData", this, 3)([])), this.getPageSegmentLoadData());
            }
        },
        {
            key: "getDataToMerge",
            value: function getDataToMerge() {
                return $2085d6ee71d212c5$var$_objectSpread($2085d6ee71d212c5$var$_objectSpread({}, $2085d6ee71d212c5$var$_superPropGet(PageSegmentLoadMetric, "getDataToMerge", this, 3)([])), this.getPageSegmentLoadData());
            }
        },
        {
            key: "merge",
            value: function merge(mergeData) {
                $2085d6ee71d212c5$var$_superPropGet(PageSegmentLoadMetric, "merge", this, 3)([
                    mergeData
                ]);
                this.isInitial = mergeData.isInitial;
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$config$ssr, _this2 = this;
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var pageLoadData = (0, $45L5U.pageLoadMetaMetric).getData();
                if (pageLoadData.isInitial && (_this$config$ssr = this.config.ssr) !== null && _this$config$ssr !== void 0 && _this$config$ssr.doneAsFmp) {
                    if (!this.marks[PageSegmentLoadMetric.FMP]) {
                        var mark = (0, $kvMag.SSRGetDoneMark).getDoneMark();
                        if (mark) this.markFMP(mark);
                    }
                }
                if (this.config.includePageLoadTimings !== (0, $5JEHx.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $2Dr5Z.MetricState).FINISHED) return $2085d6ee71d212c5$var$_superPropGet(PageSegmentLoadMetric, "stop", this, 3)([
                    params
                ]);
                var now = performance.now();
                if (pageLoadData.state === (0, $2Dr5Z.MetricState).STARTED) (0, $45L5U.pageLoadMetaMetric).onStop(function() {
                    $2085d6ee71d212c5$var$_superPropGet(PageSegmentLoadMetric, "stop", _this2, 3)([
                        $2085d6ee71d212c5$var$_objectSpread($2085d6ee71d212c5$var$_objectSpread({}, params), {}, {
                            stopTime: params.stopTime || now
                        })
                    ]);
                }, function() {
                    _this2.cancel();
                });
                return true;
            }
        }
    ]);
}((0, $7MgwL.Metric));
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($2085d6ee71d212c5$export$24c8bfcd77494cc1, "FMP", 'fmp');

});




parcelRegister("6cMFi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df74dfad98f1202e$export$2e2bcd8739ae039; });
const $df74dfad98f1202e$var$EMPTY_APP_STATE_VALUE = '{{data_app_state}}';
const $df74dfad98f1202e$var$hasNoInjectedServerState = ()=>{
    const data = document.body.getAttribute('data-app-state');
    const dataNotInjectedDueToTestContext = data === null;
    return data === $df74dfad98f1202e$var$EMPTY_APP_STATE_VALUE || dataNotInjectedDueToTestContext;
};
var $df74dfad98f1202e$export$2e2bcd8739ae039 = $df74dfad98f1202e$var$hasNoInjectedServerState;

});





parcelRegister("9r9Q6", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("3vVFy")).then(()=>parcelRequire('jLPZF'));

});

parcelRegister("2dPLK", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("4Y4Hb")).then(()=>parcelRequire('7ciIH'));

});

parcelRegister("joCrC", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("eqZfY")).then(()=>parcelRequire('hIg1y'));

});

parcelRegister("2fjoA", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("7Qdyn")).then(()=>parcelRequire('cTdvD'));

});

parcelRegister("3JUJR", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("2HI26")).then(()=>parcelRequire('13hJH'));

});

parcelRegister("aeXuF", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("dU1ZU")).then(()=>parcelRequire('bM8uo'));

});

parcelRegister("5toDY", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("4l34J")).then(()=>parcelRequire('7eBQO'));

});

parcelRegister("avvrx", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("1JlbJ")).then(()=>parcelRequire('lk6xE'));

});

parcelRegister("dl62I", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("1TY4n")).then(()=>parcelRequire('2GTGK'));

});

parcelRegister("gD3sV", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("24jzf")).then(()=>parcelRequire('3ji4Q'));

});

parcelRegister("eONep", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("1vWFJ")).then(()=>parcelRequire('kxlNJ'));

});

parcelRegister("iBmbX", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("8tYz2")).then(()=>parcelRequire('iPJbm'));

});

parcelRegister("cGqrj", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("px9BB")).then(()=>parcelRequire('2wqpp'));

});

parcelRegister("VWk06", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("2BXEZ")).then(()=>parcelRequire('2VSx5'));

});

parcelRegister("iKdYE", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("aT9no")).then(()=>parcelRequire('d2QPY'));

});

parcelRegister("3GTan", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("8EHDU")).then(()=>parcelRequire('gDR9B'));

});

parcelRegister("jRF3A", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("38Axh")).then(()=>parcelRequire('e9QtB'));

});

parcelRegister("27DUY", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("bnpcq")).then(()=>parcelRequire('l1DVf'));

});

parcelRegister("2FcqA", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("3GliG")).then(()=>parcelRequire('3E6Ib'));

});

parcelRegister("i0Gbl", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("f2Qn3")).then(()=>parcelRequire('iQgoo'));

});

parcelRegister("eQwqH", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("8tbRj")).then(()=>parcelRequire('3ifTP'));

});

parcelRegister("9alI5", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("8WnsM")).then(()=>parcelRequire('30CCJ'));

});

parcelRegister("6ZxNQ", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("eb8gQ")).then(()=>parcelRequire('dBE7n'));

});

parcelRegister("20tBf", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("5kUI8")).then(()=>parcelRequire('89uEU'));

});

parcelRegister("hMV6I", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("4fGj1")).then(()=>parcelRequire('1cezk'));

});

parcelRegister("h3wUQ", function(module, exports) {

$parcel$export(module.exports, "isValidBrandHex", function () { return $c6ac3fe6e6d430ac$export$53031ac1ecb71f44; });
$parcel$export(module.exports, "rgbToHex", function () { return $c6ac3fe6e6d430ac$export$34d09c4a771c46ef; });
$parcel$export(module.exports, "hexToRgbA", function () { return $c6ac3fe6e6d430ac$export$b36dbdb4f463f05c; });
$parcel$export(module.exports, "hexToRgb", function () { return $c6ac3fe6e6d430ac$export$5a544e13ad4e1fa5; });
$parcel$export(module.exports, "hexToHSL", function () { return $c6ac3fe6e6d430ac$export$47ea145a83f50dc0; });
$parcel$export(module.exports, "HSLToRGB", function () { return $c6ac3fe6e6d430ac$export$1ff93e992dd58bec; });
$parcel$export(module.exports, "relativeLuminanceW3C", function () { return $c6ac3fe6e6d430ac$export$e770b01b744f3745; });
$parcel$export(module.exports, "getContrastRatio", function () { return $c6ac3fe6e6d430ac$export$d061e26956a60b0a; });
$parcel$export(module.exports, "deltaE", function () { return $c6ac3fe6e6d430ac$export$e8ddad763b4bebf9; });
// valid hex color with 6 digits
var $c6ac3fe6e6d430ac$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};
// valid hex color with 4, 6 or 8 digits
var $c6ac3fe6e6d430ac$var$isValidHex = function isValidHex(hex) {
    return /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
};
function $c6ac3fe6e6d430ac$export$34d09c4a771c46ef(r, g, b) {
    return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $c6ac3fe6e6d430ac$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        var int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $c6ac3fe6e6d430ac$export$b36dbdb4f463f05c(hex) {
    if (!$c6ac3fe6e6d430ac$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $c6ac3fe6e6d430ac$export$1212645cf40ebf71(hex)
    ];
}
function $c6ac3fe6e6d430ac$export$5a544e13ad4e1fa5(hex) {
    if (!$c6ac3fe6e6d430ac$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $c6ac3fe6e6d430ac$export$47ea145a83f50dc0(hex) {
    if (!$c6ac3fe6e6d430ac$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    var cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $c6ac3fe6e6d430ac$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    var k = function k(n) {
        return (n + h / 30) % 12;
    };
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        return l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    };
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $c6ac3fe6e6d430ac$export$e770b01b744f3745(r, g, b) {
    var RsRGB = r / 255;
    var GsRGB = g / 255;
    var BsRGB = b / 255;
    var R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    var G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    var B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    var L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $c6ac3fe6e6d430ac$export$d061e26956a60b0a(foreground, background) {
    if (!$c6ac3fe6e6d430ac$var$isValidHex(foreground) || !$c6ac3fe6e6d430ac$var$isValidHex(background)) throw new Error('Invalid HEX');
    var foregroundRgb = $c6ac3fe6e6d430ac$export$5a544e13ad4e1fa5(foreground);
    var backgroundRgb = $c6ac3fe6e6d430ac$export$5a544e13ad4e1fa5(background);
    var foregroundLuminance = $c6ac3fe6e6d430ac$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    var backgroundLuminance = $c6ac3fe6e6d430ac$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $c6ac3fe6e6d430ac$export$e8ddad763b4bebf9(rgbA, rgbB) {
    var labA = $c6ac3fe6e6d430ac$var$rgbToLab(rgbA);
    var labB = $c6ac3fe6e6d430ac$var$rgbToLab(rgbB);
    var deltaL = labA[0] - labB[0];
    var deltaA = labA[1] - labB[1];
    var deltaB = labA[2] - labB[2];
    var c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    var c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    var deltaC = c1 - c2;
    var deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    var sc = 1.0 + 0.045 * c1;
    var sh = 1.0 + 0.015 * c1;
    var deltaLKlsl = deltaL / 1.0;
    var deltaCkcsc = deltaC / sc;
    var deltaHkhsh = deltaH / sh;
    var i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $c6ac3fe6e6d430ac$var$rgbToLab(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("avbPF", function(module, exports) {

$parcel$export(module.exports, "hash", function () { return $7a55fa44fdb4a4d2$export$d6af199866bfb566; });
var $7a55fa44fdb4a4d2$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("jcEtw", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("86pTb")).then(()=>parcelRequire('haHsR'));

});

parcelRegister("0X6Ox", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("2sYHg")).then(()=>parcelRequire('e6eQQ'));

});

parcelRegister("l7b0Y", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("fCDO8")).then(()=>parcelRequire('4Lqeb'));

});

parcelRegister("kZs0h", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("aqfCd")).then(()=>parcelRequire('6fKY8'));

});

parcelRegister("5lmw3", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("8bod9")).then(()=>parcelRequire('fhi35'));

});

parcelRegister("frqnA", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("iVZbQ")).then(()=>parcelRequire('45LbL'));

});

parcelRegister("iehR7", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("bqfwD")).then(()=>parcelRequire('gyV0H'));

});

parcelRegister("fpoT2", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("b25ru")).then(()=>parcelRequire('4UTDD'));

});

parcelRegister("g9XbK", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("60SPd")).then(()=>parcelRequire('8Axq6'));

});

parcelRegister("51YXZ", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("dJ9Ng")).then(()=>parcelRequire('g4daj'));

});

parcelRegister("5dIoA", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("7C4Cq")).then(()=>parcelRequire('2Psbj'));

});

parcelRegister("gCicQ", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("6NBej")).then(()=>parcelRequire('k0bnv'));

});

parcelRegister("7QiVh", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("k5lOf")).then(()=>parcelRequire('9A6Te'));

});

parcelRegister("dd6zN", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("cg2eR")).then(()=>parcelRequire('7N5ge'));

});

parcelRegister("6Y5O2", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("cPLJH")).then(()=>parcelRequire('kCX5c'));

});

parcelRegister("lvGYg", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("lWQgD")).then(()=>parcelRequire('5isYx'));

});

parcelRegister("iSUD9", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("7BIdz")).then(()=>parcelRequire('8ReIo'));

});

parcelRegister("iSykp", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("5bLPT")).then(()=>parcelRequire('5Mgi1'));

});

parcelRegister("a1G56", function(module, exports) {

$parcel$export(module.exports, "findMissingCustomStyleElements", function () { return $74caa3df31ab986a$export$bd1ac9300b0e885a; });
$parcel$export(module.exports, "limitSizeOfCustomStyleElements", function () { return $74caa3df31ab986a$export$e7ae172320e03461; });
$parcel$export(module.exports, "reduceTokenMap", function () { return $74caa3df31ab986a$export$e673f367da2ff23e; });

var $5YM7L = parcelRequire("5YM7L");

var $iqLBO = parcelRequire("iqLBO");

var $fDFhk = parcelRequire("fDFhk");

var $2S8bR = parcelRequire("2S8bR");

var $avbPF = parcelRequire("avbPF");
function $74caa3df31ab986a$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $avbPF.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $2S8bR.CUSTOM_THEME_ATTRIBUTE), "=\"").concat(uniqueId, "\"][").concat((0, $2S8bR.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $74caa3df31ab986a$export$e7ae172320e03461(sizeThreshold) {
    var styleTags = (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(Array.from(document.head.querySelectorAll("style[".concat((0, $2S8bR.CUSTOM_THEME_ATTRIBUTE), "][").concat((0, $2S8bR.THEME_DATA_ATTRIBUTE), "]"))));
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach(function(element) {
        return element.remove();
    });
}
function $74caa3df31ab986a$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce(function(acc, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        var cssVar = (0, $fDFhk.default)[key];
        return cssVar ? "".concat(acc, "\n  ").concat(cssVar, ": ").concat(typeof value === 'string' ? value : themeRamp[value], ";") : acc;
    }, '');
}

});
parcelRegister("fDFhk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b62a849393206acd$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a8feb13ecf105e7fd6247cb4d1a99b01>>
 * @codegenCommand yarn build tokens
 */ var $b62a849393206acd$var$tokens = {
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.success': '--ds-text-success',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.information': '--ds-text-information',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.warning': '--ds-border-warning',
    'color.border.success': '--ds-border-success',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.information': '--ds-border-information',
    'color.border.bold': '--ds-border-bold',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.textTransformUppercase': '--ds-UNSAFE-textTransformUppercase',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.body.UNSAFE_small': '--ds-font-body-UNSAFE_small',
    'font.metric.large': '--ds-font-metric-large',
    'font.metric.medium': '--ds-font-metric-medium',
    'font.metric.small': '--ds-font-metric-small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'radius.xsmall': '--ds-radius-xsmall',
    'radius.small': '--ds-radius-small',
    'radius.medium': '--ds-radius-medium',
    'radius.large': '--ds-radius-large',
    'radius.xlarge': '--ds-radius-xlarge',
    'radius.full': '--ds-radius-full',
    'radius.tile': '--ds-radius-tile',
    'border.radius': '--ds-border-radius',
    'border.radius.050': '--ds-border-radius-050',
    'border.radius.100': '--ds-border-radius-100',
    'border.radius.200': '--ds-border-radius-200',
    'border.radius.300': '--ds-border-radius-300',
    'border.radius.400': '--ds-border-radius-400',
    'border.radius.circle': '--ds-border-radius-circle',
    'border.width': '--ds-border-width',
    'border.width.0': '--ds-border-width-0',
    'border.width.indicator': '--ds-border-width-indicator',
    'border.width.outline': '--ds-border-width-outline',
    'border.width.selected': '--ds-border-width-selected',
    'border.width.focused': '--ds-border-width-focused'
};
var $b62a849393206acd$export$2e2bcd8739ae039 = $b62a849393206acd$var$tokens;

});


parcelRegister("3KO8O", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("cPzVc")).then(()=>parcelRequire('4J3kq'));

});

parcelRegister("8KhCJ", function(module, exports) {

$parcel$export(module.exports, "Helmet", function () { return $65e04a4ca9930aa3$export$dcef8f9bb9a41431; }, function (v) { return $65e04a4ca9930aa3$export$dcef8f9bb9a41431 = v; });
$parcel$export(module.exports, "default", function () { return $65e04a4ca9930aa3$export$2e2bcd8739ae039; }, function (v) { return $65e04a4ca9930aa3$export$2e2bcd8739ae039 = v; });
var $65e04a4ca9930aa3$export$1e511d4a378977f5;
var $65e04a4ca9930aa3$export$dcef8f9bb9a41431;
var $65e04a4ca9930aa3$export$2e2bcd8739ae039;
$65e04a4ca9930aa3$export$1e511d4a378977f5 = true;
$65e04a4ca9930aa3$export$dcef8f9bb9a41431 = undefined;
var $65e04a4ca9930aa3$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $65e04a4ca9930aa3$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $91i6m = parcelRequire("91i6m");
var $65e04a4ca9930aa3$var$_react2 = $65e04a4ca9930aa3$var$_interopRequireDefault($91i6m);

var $eYOCy = parcelRequire("eYOCy");
var $65e04a4ca9930aa3$var$_propTypes2 = $65e04a4ca9930aa3$var$_interopRequireDefault($eYOCy);

var $a6m8o = parcelRequire("a6m8o");
var $65e04a4ca9930aa3$var$_reactSideEffect2 = $65e04a4ca9930aa3$var$_interopRequireDefault($a6m8o);

var $lPtyF = parcelRequire("lPtyF");
var $65e04a4ca9930aa3$var$_reactFastCompare2 = $65e04a4ca9930aa3$var$_interopRequireDefault($lPtyF);

var $eEhsK = parcelRequire("eEhsK");

var $2oPVn = parcelRequire("2oPVn");
function $65e04a4ca9930aa3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $65e04a4ca9930aa3$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $65e04a4ca9930aa3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $65e04a4ca9930aa3$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $65e04a4ca9930aa3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $65e04a4ca9930aa3$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $65e04a4ca9930aa3$var$_inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $65e04a4ca9930aa3$var$_classCallCheck(this, HelmetWrapper);
            return $65e04a4ca9930aa3$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, $65e04a4ca9930aa3$var$_reactFastCompare2.default)(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $2oPVn.TAG_NAMES.SCRIPT:
                case $2oPVn.TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $2oPVn.TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $65e04a4ca9930aa3$var$_extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $65e04a4ca9930aa3$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _extends2));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $2oPVn.TAG_NAMES.TITLE:
                    return $65e04a4ca9930aa3$var$_extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = $65e04a4ca9930aa3$var$_extends({}, newChildProps), _extends3));
                case $2oPVn.TAG_NAMES.BODY:
                    return $65e04a4ca9930aa3$var$_extends({}, newProps, {
                        bodyAttributes: $65e04a4ca9930aa3$var$_extends({}, newChildProps)
                    });
                case $2oPVn.TAG_NAMES.HTML:
                    return $65e04a4ca9930aa3$var$_extends({}, newProps, {
                        htmlAttributes: $65e04a4ca9930aa3$var$_extends({}, newChildProps)
                    });
            }
            return $65e04a4ca9930aa3$var$_extends({}, newProps, (_extends4 = {}, _extends4[child.type] = $65e04a4ca9930aa3$var$_extends({}, newChildProps), _extends4));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $65e04a4ca9930aa3$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _extends5;
                newFlattenedProps = $65e04a4ca9930aa3$var$_extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            $65e04a4ca9930aa3$var$_react2.default.Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $65e04a4ca9930aa3$var$_objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = (0, $eEhsK.convertReactPropstoHtmlAttributes)(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $2oPVn.TAG_NAMES.LINK:
                    case $2oPVn.TAG_NAMES.META:
                    case $2oPVn.TAG_NAMES.NOSCRIPT:
                    case $2oPVn.TAG_NAMES.SCRIPT:
                    case $2oPVn.TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $65e04a4ca9930aa3$var$_objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $65e04a4ca9930aa3$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return $65e04a4ca9930aa3$var$_react2.default.createElement(Component, newProps);
        };
        $65e04a4ca9930aa3$var$_createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }($65e04a4ca9930aa3$var$_react2.default.Component), _class.propTypes = {
        base: $65e04a4ca9930aa3$var$_propTypes2.default.object,
        bodyAttributes: $65e04a4ca9930aa3$var$_propTypes2.default.object,
        children: $65e04a4ca9930aa3$var$_propTypes2.default.oneOfType([
            $65e04a4ca9930aa3$var$_propTypes2.default.arrayOf($65e04a4ca9930aa3$var$_propTypes2.default.node),
            $65e04a4ca9930aa3$var$_propTypes2.default.node
        ]),
        defaultTitle: $65e04a4ca9930aa3$var$_propTypes2.default.string,
        defer: $65e04a4ca9930aa3$var$_propTypes2.default.bool,
        encodeSpecialCharacters: $65e04a4ca9930aa3$var$_propTypes2.default.bool,
        htmlAttributes: $65e04a4ca9930aa3$var$_propTypes2.default.object,
        link: $65e04a4ca9930aa3$var$_propTypes2.default.arrayOf($65e04a4ca9930aa3$var$_propTypes2.default.object),
        meta: $65e04a4ca9930aa3$var$_propTypes2.default.arrayOf($65e04a4ca9930aa3$var$_propTypes2.default.object),
        noscript: $65e04a4ca9930aa3$var$_propTypes2.default.arrayOf($65e04a4ca9930aa3$var$_propTypes2.default.object),
        onChangeClientState: $65e04a4ca9930aa3$var$_propTypes2.default.func,
        script: $65e04a4ca9930aa3$var$_propTypes2.default.arrayOf($65e04a4ca9930aa3$var$_propTypes2.default.object),
        style: $65e04a4ca9930aa3$var$_propTypes2.default.arrayOf($65e04a4ca9930aa3$var$_propTypes2.default.object),
        title: $65e04a4ca9930aa3$var$_propTypes2.default.string,
        titleAttributes: $65e04a4ca9930aa3$var$_propTypes2.default.object,
        titleTemplate: $65e04a4ca9930aa3$var$_propTypes2.default.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = (0, $eEhsK.mapStateOnServer)({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $65e04a4ca9930aa3$var$NullComponent = function NullComponent() {
    return null;
};
var $65e04a4ca9930aa3$var$HelmetSideEffects = (0, $65e04a4ca9930aa3$var$_reactSideEffect2.default)($eEhsK.reducePropsToState, $eEhsK.handleClientStateChange, $eEhsK.mapStateOnServer)($65e04a4ca9930aa3$var$NullComponent);
var $65e04a4ca9930aa3$var$HelmetExport = $65e04a4ca9930aa3$var$Helmet($65e04a4ca9930aa3$var$HelmetSideEffects);
$65e04a4ca9930aa3$var$HelmetExport.renderStatic = $65e04a4ca9930aa3$var$HelmetExport.rewind;
$65e04a4ca9930aa3$export$dcef8f9bb9a41431 = $65e04a4ca9930aa3$var$HelmetExport;
$65e04a4ca9930aa3$export$2e2bcd8739ae039 = $65e04a4ca9930aa3$var$HelmetExport;

});
parcelRegister("eYOCy", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ae7def87b75801a1$var$ReactIs, $ae7def87b75801a1$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("9xBrx"))();

});
parcelRegister("9xBrx", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $6vLJz = parcelRequire("6vLJz");
function $6f243d89f5acb7a6$var$emptyFunction() {}
function $6f243d89f5acb7a6$var$emptyFunctionWithReset() {}
$6f243d89f5acb7a6$var$emptyFunctionWithReset.resetWarningCache = $6f243d89f5acb7a6$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $6vLJz) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $6f243d89f5acb7a6$var$emptyFunctionWithReset,
        resetWarningCache: $6f243d89f5acb7a6$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("6vLJz", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $4bdaaa50ddce2fb1$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $4bdaaa50ddce2fb1$var$ReactPropTypesSecret;

});



parcelRegister("a6m8o", function(module, exports) {
'use strict';
function $75aba2546bbebc39$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $91i6m = parcelRequire("91i6m");
var $75aba2546bbebc39$var$React__default = $75aba2546bbebc39$var$_interopDefault($91i6m);

var $75aba2546bbebc39$var$shallowEqual = $75aba2546bbebc39$var$_interopDefault((parcelRequire("565U6")));
function $75aba2546bbebc39$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $75aba2546bbebc39$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $75aba2546bbebc39$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $75aba2546bbebc39$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== 'function') throw new Error('Expected reducePropsToState to be a function.');
    if (typeof handleStateChangeOnClient !== 'function') throw new Error('Expected handleStateChangeOnClient to be a function.');
    if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') throw new Error('Expected mapStateOnServer to either be undefined or a function.');
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== 'function') throw new Error('Expected WrappedComponent to be a React component.');
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_Component) {
            $75aba2546bbebc39$var$_inheritsLoose(SideEffect, _Component);
            function SideEffect() {
                return _Component.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
                return !$75aba2546bbebc39$var$shallowEqual(nextProps, this.props);
            };
            _proto.componentWillMount = function componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $75aba2546bbebc39$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($91i6m.Component);
        $75aba2546bbebc39$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $75aba2546bbebc39$var$_defineProperty(SideEffect, "canUseDOM", $75aba2546bbebc39$var$canUseDOM);
        return SideEffect;
    };
}
module.exports = $75aba2546bbebc39$var$withSideEffect;

});
parcelRegister("565U6", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});


parcelRegister("lPtyF", function(module, exports) {
'use strict';
var $fe454a05b85ce062$var$isArray = Array.isArray;
var $fe454a05b85ce062$var$keyList = Object.keys;
var $fe454a05b85ce062$var$hasProp = Object.prototype.hasOwnProperty;
var $fe454a05b85ce062$var$hasElementType = typeof Element !== 'undefined';
function $fe454a05b85ce062$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        var arrA = $fe454a05b85ce062$var$isArray(a), arrB = $fe454a05b85ce062$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$fe454a05b85ce062$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $fe454a05b85ce062$var$keyList(a);
        length = keys.length;
        if (length !== $fe454a05b85ce062$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$fe454a05b85ce062$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($fe454a05b85ce062$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$fe454a05b85ce062$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return $fe454a05b85ce062$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("eEhsK", function(module, exports) {

$parcel$export(module.exports, "reducePropsToState", function () { return $aaa258d8bb44bb53$export$bfed3b07ff81c934; }, function (v) { return $aaa258d8bb44bb53$export$bfed3b07ff81c934 = v; });
$parcel$export(module.exports, "mapStateOnServer", function () { return $aaa258d8bb44bb53$export$971402543ca2bd1d; }, function (v) { return $aaa258d8bb44bb53$export$971402543ca2bd1d = v; });
$parcel$export(module.exports, "handleClientStateChange", function () { return $aaa258d8bb44bb53$export$8e0854f6f2040fff; }, function (v) { return $aaa258d8bb44bb53$export$8e0854f6f2040fff = v; });
$parcel$export(module.exports, "convertReactPropstoHtmlAttributes", function () { return $aaa258d8bb44bb53$export$8f437c7c6568a694; }, function (v) { return $aaa258d8bb44bb53$export$8f437c7c6568a694 = v; });
var $aaa258d8bb44bb53$export$1e511d4a378977f5;
var $aaa258d8bb44bb53$export$c106dd0671a0fc2d;
var $aaa258d8bb44bb53$export$6cb2c4c0a22909c0;
var $aaa258d8bb44bb53$export$bfed3b07ff81c934;
var $aaa258d8bb44bb53$export$971402543ca2bd1d;
var $aaa258d8bb44bb53$export$8e0854f6f2040fff;
var $aaa258d8bb44bb53$export$8f437c7c6568a694;
$aaa258d8bb44bb53$export$1e511d4a378977f5 = true;
$aaa258d8bb44bb53$export$c106dd0671a0fc2d = $aaa258d8bb44bb53$export$6cb2c4c0a22909c0 = $aaa258d8bb44bb53$export$bfed3b07ff81c934 = $aaa258d8bb44bb53$export$971402543ca2bd1d = $aaa258d8bb44bb53$export$8e0854f6f2040fff = $aaa258d8bb44bb53$export$8f437c7c6568a694 = undefined;
var $aaa258d8bb44bb53$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $aaa258d8bb44bb53$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $91i6m = parcelRequire("91i6m");
var $aaa258d8bb44bb53$var$_react2 = $aaa258d8bb44bb53$var$_interopRequireDefault($91i6m);

var $gmXIm = parcelRequire("gmXIm");
var $aaa258d8bb44bb53$var$_objectAssign2 = $aaa258d8bb44bb53$var$_interopRequireDefault($gmXIm);

var $2oPVn = parcelRequire("2oPVn");
function $aaa258d8bb44bb53$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $aaa258d8bb44bb53$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $aaa258d8bb44bb53$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $aaa258d8bb44bb53$var$getInnermostProperty(propsList, $2oPVn.TAG_NAMES.TITLE);
    var innermostTemplate = $aaa258d8bb44bb53$var$getInnermostProperty(propsList, $2oPVn.HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return innermostTitle;
    });
    var innermostDefaultTitle = $aaa258d8bb44bb53$var$getInnermostProperty(propsList, $2oPVn.HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $aaa258d8bb44bb53$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $aaa258d8bb44bb53$var$getInnermostProperty(propsList, $2oPVn.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $aaa258d8bb44bb53$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $aaa258d8bb44bb53$var$_extends({}, tagAttrs, current);
    }, {});
};
var $aaa258d8bb44bb53$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$2oPVn.TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$2oPVn.TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $aaa258d8bb44bb53$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $aaa258d8bb44bb53$var$warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + $aaa258d8bb44bb53$var$_typeof(props[tagName]) + "\"");
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $2oPVn.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $2oPVn.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $2oPVn.TAG_PROPERTIES.INNER_HTML || attributeKey === $2oPVn.TAG_PROPERTIES.CSS_TEXT || attributeKey === $2oPVn.TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, $aaa258d8bb44bb53$var$_objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $aaa258d8bb44bb53$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $aaa258d8bb44bb53$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $aaa258d8bb44bb53$var$getBaseTagFromPropsList([
            $2oPVn.TAG_PROPERTIES.HREF
        ], propsList),
        bodyAttributes: $aaa258d8bb44bb53$var$getAttributesFromPropsList($2oPVn.ATTRIBUTE_NAMES.BODY, propsList),
        defer: $aaa258d8bb44bb53$var$getInnermostProperty(propsList, $2oPVn.HELMET_PROPS.DEFER),
        encode: $aaa258d8bb44bb53$var$getInnermostProperty(propsList, $2oPVn.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $aaa258d8bb44bb53$var$getAttributesFromPropsList($2oPVn.ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $aaa258d8bb44bb53$var$getTagsFromPropsList($2oPVn.TAG_NAMES.LINK, [
            $2oPVn.TAG_PROPERTIES.REL,
            $2oPVn.TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $aaa258d8bb44bb53$var$getTagsFromPropsList($2oPVn.TAG_NAMES.META, [
            $2oPVn.TAG_PROPERTIES.NAME,
            $2oPVn.TAG_PROPERTIES.CHARSET,
            $2oPVn.TAG_PROPERTIES.HTTPEQUIV,
            $2oPVn.TAG_PROPERTIES.PROPERTY,
            $2oPVn.TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $aaa258d8bb44bb53$var$getTagsFromPropsList($2oPVn.TAG_NAMES.NOSCRIPT, [
            $2oPVn.TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $aaa258d8bb44bb53$var$getOnChangeClientState(propsList),
        scriptTags: $aaa258d8bb44bb53$var$getTagsFromPropsList($2oPVn.TAG_NAMES.SCRIPT, [
            $2oPVn.TAG_PROPERTIES.SRC,
            $2oPVn.TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $aaa258d8bb44bb53$var$getTagsFromPropsList($2oPVn.TAG_NAMES.STYLE, [
            $2oPVn.TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $aaa258d8bb44bb53$var$getTitleFromPropsList(propsList),
        titleAttributes: $aaa258d8bb44bb53$var$getAttributesFromPropsList($2oPVn.ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $aaa258d8bb44bb53$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $aaa258d8bb44bb53$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $aaa258d8bb44bb53$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $aaa258d8bb44bb53$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $aaa258d8bb44bb53$var$rafPolyfill : $parcel$global.requestAnimationFrame || $aaa258d8bb44bb53$var$rafPolyfill;
var $aaa258d8bb44bb53$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $aaa258d8bb44bb53$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $aaa258d8bb44bb53$var$cafPolyfill;
var $aaa258d8bb44bb53$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $aaa258d8bb44bb53$var$_helmetCallback = null;
var $aaa258d8bb44bb53$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($aaa258d8bb44bb53$var$_helmetCallback) $aaa258d8bb44bb53$var$cancelAnimationFrame($aaa258d8bb44bb53$var$_helmetCallback);
    if (newState.defer) $aaa258d8bb44bb53$var$_helmetCallback = $aaa258d8bb44bb53$var$requestAnimationFrame(function() {
        $aaa258d8bb44bb53$var$commitTagChanges(newState, function() {
            $aaa258d8bb44bb53$var$_helmetCallback = null;
        });
    });
    else {
        $aaa258d8bb44bb53$var$commitTagChanges(newState);
        $aaa258d8bb44bb53$var$_helmetCallback = null;
    }
};
var $aaa258d8bb44bb53$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $aaa258d8bb44bb53$var$updateAttributes($2oPVn.TAG_NAMES.BODY, bodyAttributes);
    $aaa258d8bb44bb53$var$updateAttributes($2oPVn.TAG_NAMES.HTML, htmlAttributes);
    $aaa258d8bb44bb53$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $aaa258d8bb44bb53$var$updateTags($2oPVn.TAG_NAMES.BASE, baseTag),
        linkTags: $aaa258d8bb44bb53$var$updateTags($2oPVn.TAG_NAMES.LINK, linkTags),
        metaTags: $aaa258d8bb44bb53$var$updateTags($2oPVn.TAG_NAMES.META, metaTags),
        noscriptTags: $aaa258d8bb44bb53$var$updateTags($2oPVn.TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $aaa258d8bb44bb53$var$updateTags($2oPVn.TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $aaa258d8bb44bb53$var$updateTags($2oPVn.TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $aaa258d8bb44bb53$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $aaa258d8bb44bb53$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $aaa258d8bb44bb53$var$flattenArray(title);
    $aaa258d8bb44bb53$var$updateAttributes($2oPVn.TAG_NAMES.TITLE, attributes);
};
var $aaa258d8bb44bb53$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($2oPVn.HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($2oPVn.HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($2oPVn.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($2oPVn.HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $aaa258d8bb44bb53$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($2oPVn.TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $2oPVn.HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $2oPVn.TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $2oPVn.TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($2oPVn.HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $aaa258d8bb44bb53$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $aaa258d8bb44bb53$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $aaa258d8bb44bb53$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $aaa258d8bb44bb53$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $2oPVn.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + $aaa258d8bb44bb53$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $2oPVn.HELMET_ATTRIBUTE + "=\"true\">" + $aaa258d8bb44bb53$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $aaa258d8bb44bb53$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $2oPVn.TAG_PROPERTIES.INNER_HTML || attribute === $2oPVn.TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + $aaa258d8bb44bb53$var$encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $2oPVn.SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $2oPVn.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $aaa258d8bb44bb53$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$2oPVn.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $aaa258d8bb44bb53$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$2oPVn.HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $aaa258d8bb44bb53$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$2oPVn.HELMET_ATTRIBUTE] = true, _initProps);
    var props = $aaa258d8bb44bb53$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        $aaa258d8bb44bb53$var$_react2.default.createElement($2oPVn.TAG_NAMES.TITLE, props, title)
    ];
};
var $aaa258d8bb44bb53$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$2oPVn.HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $2oPVn.REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $2oPVn.TAG_PROPERTIES.INNER_HTML || mappedAttribute === $2oPVn.TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return $aaa258d8bb44bb53$var$_react2.default.createElement(type, mappedTag);
    });
};
var $aaa258d8bb44bb53$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $2oPVn.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $aaa258d8bb44bb53$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $aaa258d8bb44bb53$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $2oPVn.ATTRIBUTE_NAMES.BODY:
        case $2oPVn.ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $aaa258d8bb44bb53$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $aaa258d8bb44bb53$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $aaa258d8bb44bb53$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $aaa258d8bb44bb53$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $aaa258d8bb44bb53$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $aaa258d8bb44bb53$var$getMethodsForTag($2oPVn.TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $aaa258d8bb44bb53$var$getMethodsForTag($2oPVn.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $aaa258d8bb44bb53$var$getMethodsForTag($2oPVn.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $aaa258d8bb44bb53$var$getMethodsForTag($2oPVn.TAG_NAMES.LINK, linkTags, encode),
        meta: $aaa258d8bb44bb53$var$getMethodsForTag($2oPVn.TAG_NAMES.META, metaTags, encode),
        noscript: $aaa258d8bb44bb53$var$getMethodsForTag($2oPVn.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $aaa258d8bb44bb53$var$getMethodsForTag($2oPVn.TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $aaa258d8bb44bb53$var$getMethodsForTag($2oPVn.TAG_NAMES.STYLE, styleTags, encode),
        title: $aaa258d8bb44bb53$var$getMethodsForTag($2oPVn.TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
$aaa258d8bb44bb53$export$8f437c7c6568a694 = $aaa258d8bb44bb53$var$convertReactPropstoHtmlAttributes;
$aaa258d8bb44bb53$export$8e0854f6f2040fff = $aaa258d8bb44bb53$var$handleClientStateChange;
$aaa258d8bb44bb53$export$971402543ca2bd1d = $aaa258d8bb44bb53$var$mapStateOnServer;
$aaa258d8bb44bb53$export$bfed3b07ff81c934 = $aaa258d8bb44bb53$var$reducePropsToState;
$aaa258d8bb44bb53$export$6cb2c4c0a22909c0 = $aaa258d8bb44bb53$var$requestAnimationFrame;
$aaa258d8bb44bb53$export$c106dd0671a0fc2d = $aaa258d8bb44bb53$var$warn;

});
parcelRegister("2oPVn", function(module, exports) {

$parcel$export(module.exports, "ATTRIBUTE_NAMES", function () { return $1bf619c737b9a9ef$export$8b4d23abccee6cc2; }, function (v) { return $1bf619c737b9a9ef$export$8b4d23abccee6cc2 = v; });
$parcel$export(module.exports, "TAG_NAMES", function () { return $1bf619c737b9a9ef$export$7e674a85a2656dce; }, function (v) { return $1bf619c737b9a9ef$export$7e674a85a2656dce = v; });
$parcel$export(module.exports, "TAG_PROPERTIES", function () { return $1bf619c737b9a9ef$export$55a55363959ee034; }, function (v) { return $1bf619c737b9a9ef$export$55a55363959ee034 = v; });
$parcel$export(module.exports, "REACT_TAG_MAP", function () { return $1bf619c737b9a9ef$export$f5ab464b3d67ea9c; }, function (v) { return $1bf619c737b9a9ef$export$f5ab464b3d67ea9c = v; });
$parcel$export(module.exports, "HELMET_PROPS", function () { return $1bf619c737b9a9ef$export$6bb0645fb3f2618c; }, function (v) { return $1bf619c737b9a9ef$export$6bb0645fb3f2618c = v; });
$parcel$export(module.exports, "HTML_TAG_MAP", function () { return $1bf619c737b9a9ef$export$3fedf55cd3a4e6fa; }, function (v) { return $1bf619c737b9a9ef$export$3fedf55cd3a4e6fa = v; });
$parcel$export(module.exports, "SELF_CLOSING_TAGS", function () { return $1bf619c737b9a9ef$export$7f7c530a82f07f20; }, function (v) { return $1bf619c737b9a9ef$export$7f7c530a82f07f20 = v; });
$parcel$export(module.exports, "HELMET_ATTRIBUTE", function () { return $1bf619c737b9a9ef$export$1f547d7d8e831b2b; }, function (v) { return $1bf619c737b9a9ef$export$1f547d7d8e831b2b = v; });
var $1bf619c737b9a9ef$export$1e511d4a378977f5;
var $1bf619c737b9a9ef$export$8b4d23abccee6cc2;
var $1bf619c737b9a9ef$export$7e674a85a2656dce;
var $1bf619c737b9a9ef$export$7a7b396eb62fa0f9;
var $1bf619c737b9a9ef$export$55a55363959ee034;
var $1bf619c737b9a9ef$export$f5ab464b3d67ea9c;
var $1bf619c737b9a9ef$export$6bb0645fb3f2618c;
var $1bf619c737b9a9ef$export$3fedf55cd3a4e6fa;
var $1bf619c737b9a9ef$export$7f7c530a82f07f20;
var $1bf619c737b9a9ef$export$1f547d7d8e831b2b;
$1bf619c737b9a9ef$export$1e511d4a378977f5 = true;
var $1bf619c737b9a9ef$var$ATTRIBUTE_NAMES = $1bf619c737b9a9ef$export$8b4d23abccee6cc2 = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $1bf619c737b9a9ef$var$TAG_NAMES = $1bf619c737b9a9ef$export$7e674a85a2656dce = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $1bf619c737b9a9ef$var$VALID_TAG_NAMES = $1bf619c737b9a9ef$export$7a7b396eb62fa0f9 = Object.keys($1bf619c737b9a9ef$var$TAG_NAMES).map(function(name) {
    return $1bf619c737b9a9ef$var$TAG_NAMES[name];
});
var $1bf619c737b9a9ef$var$TAG_PROPERTIES = $1bf619c737b9a9ef$export$55a55363959ee034 = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};
var $1bf619c737b9a9ef$var$REACT_TAG_MAP = $1bf619c737b9a9ef$export$f5ab464b3d67ea9c = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $1bf619c737b9a9ef$var$HELMET_PROPS = $1bf619c737b9a9ef$export$6bb0645fb3f2618c = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $1bf619c737b9a9ef$var$HTML_TAG_MAP = $1bf619c737b9a9ef$export$3fedf55cd3a4e6fa = Object.keys($1bf619c737b9a9ef$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$1bf619c737b9a9ef$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $1bf619c737b9a9ef$var$SELF_CLOSING_TAGS = $1bf619c737b9a9ef$export$7f7c530a82f07f20 = [
    $1bf619c737b9a9ef$var$TAG_NAMES.NOSCRIPT,
    $1bf619c737b9a9ef$var$TAG_NAMES.SCRIPT,
    $1bf619c737b9a9ef$var$TAG_NAMES.STYLE
];
var $1bf619c737b9a9ef$var$HELMET_ATTRIBUTE = $1bf619c737b9a9ef$export$1f547d7d8e831b2b = "data-react-helmet";

});



parcelRegister("6IwzG", function(module, exports) {

$parcel$export(module.exports, "SimpleCobranding", function () { return $aa1d9ab7fd224e0b$export$d04480ee89603948; });
$parcel$export(module.exports, "AdvancedCobranding", function () { return $aa1d9ab7fd224e0b$export$6e3d039ab597dde7; });
$parcel$export(module.exports, "isSimpleCobranding", function () { return $aa1d9ab7fd224e0b$export$4289c1cc8b535433; });
$parcel$export(module.exports, "isAdvancedCobranding", function () { return $aa1d9ab7fd224e0b$export$4d91d2f372f755c7; });
$parcel$export(module.exports, "getCurrentCobranding", function () { return $aa1d9ab7fd224e0b$export$7a6337ee64e317c4; });
$parcel$export(module.exports, "CobrandingProvider", function () { return $aa1d9ab7fd224e0b$export$c5b813538c5440a9; });
$parcel$export(module.exports, "useCobranding", function () { return $aa1d9ab7fd224e0b$export$808c37e33518fa32; });

var $91i6m = parcelRequire("91i6m");

var $fYxRW = parcelRequire("fYxRW");

var $3H79M = parcelRequire("3H79M");
var $aa1d9ab7fd224e0b$export$d04480ee89603948 = /*#__PURE__*/ function(SimpleCobranding) {
    SimpleCobranding["NO_COBRANDING"] = "no-cobranding";
    SimpleCobranding["BITBUCKET"] = "bitbucket";
    SimpleCobranding["COMPASS"] = "compass";
    SimpleCobranding["CONFLUENCE"] = "confluence";
    SimpleCobranding["COMMUNITY"] = "community";
    SimpleCobranding["JIRA"] = "jira";
    SimpleCobranding["OPSGENIE"] = "opsgenie";
    SimpleCobranding["STATUSPAGE"] = "statuspage";
    SimpleCobranding["TRELLO"] = "trello";
    SimpleCobranding["WAC"] = "wac";
    SimpleCobranding["ATLAS"] = "atlas";
    SimpleCobranding["LOOM"] = "loom";
    SimpleCobranding["JIRA_ALIGN"] = "jira-align";
    SimpleCobranding["ADMIN"] = "admin";
    SimpleCobranding["ROVO"] = "rovo";
    SimpleCobranding["PRT"] = "prt";
    SimpleCobranding["SUPPORT"] = "support";
    return SimpleCobranding;
}({});
var $aa1d9ab7fd224e0b$export$6e3d039ab597dde7 = /*#__PURE__*/ function(AdvancedCobranding) {
    AdvancedCobranding["DEMO"] = "demo";
    AdvancedCobranding["PRT_DEMO"] = "prt-demo";
    AdvancedCobranding["ATLAS_66195"] = "atlas-66195";
    AdvancedCobranding["CFIND_2409"] = "cfind-2409";
    AdvancedCobranding["CFIND_3856"] = "cfind-3856";
    AdvancedCobranding["JIRA_ATLAS_75650"] = "jira-atlas-75650";
    AdvancedCobranding["CONFLUENCE_ATLAS_75650"] = "confluence-atlas-75650";
    AdvancedCobranding["LOOM"] = "default";
    AdvancedCobranding["ACCOUNT_LINKING"] = "account-linking";
    AdvancedCobranding["ENTRY_AUTH"] = "entry-auth";
    AdvancedCobranding["WAC_LOOM"] = "loom-cobranding";
    AdvancedCobranding["WAC_JPD"] = "jpd";
    AdvancedCobranding["WAC_JSM"] = "jsm";
    AdvancedCobranding["SERVICE_COLLECTION"] = "service-collection";
    AdvancedCobranding["TEAMWORK_COLLECTION"] = "teamwork-collection";
    AdvancedCobranding["ISOLATED_CLOUD"] = "ic";
    return AdvancedCobranding;
}({});
const $aa1d9ab7fd224e0b$export$4289c1cc8b535433 = (value)=>Object.values($aa1d9ab7fd224e0b$export$d04480ee89603948).includes(value);
const $aa1d9ab7fd224e0b$export$4d91d2f372f755c7 = (value)=>Object.values($aa1d9ab7fd224e0b$export$6e3d039ab597dde7).includes(value);
const $aa1d9ab7fd224e0b$var$getDisabledApplicationKeys = (dynamicConfigs)=>{
    const disabledApplicationKeys = dynamicConfigs.getStringList((0, $3H79M.AidFrontendDynamicConfig).DISABLED_COBRANDING_APPLICATION_KEYS);
    if ('value' in disabledApplicationKeys) return disabledApplicationKeys.value;
    return [];
};
const $aa1d9ab7fd224e0b$var$getApplicationKey = (applicationData)=>{
    return `${applicationData.application}${applicationData.experience ? `--${applicationData.experience}` : ''}`;
};
function $aa1d9ab7fd224e0b$export$7a6337ee64e317c4(cobranding, dynamicConfigs) {
    const applicationData = (0, $fYxRW.lookupApplication)(cobranding);
    if (applicationData) {
        const disabledApplicationKeys = $aa1d9ab7fd224e0b$var$getDisabledApplicationKeys(dynamicConfigs);
        const applicationKey = $aa1d9ab7fd224e0b$var$getApplicationKey(applicationData);
        if (disabledApplicationKeys.includes(applicationKey)) {
            console.log(`Cobranding disabled for application: ${applicationKey}`);
            return "no-cobranding";
        }
        switch(applicationData.application){
            case 'admin':
                switch(applicationData.experience){
                    case 'jira-atlas-75650':
                        return "jira-atlas-75650";
                    case 'confluence-atlas-75650':
                        return "confluence-atlas-75650";
                    default:
                        return "no-cobranding";
                }
            case 'atlas':
                return "atlas";
            case 'bitbucket':
                return "bitbucket";
            case 'community':
                if (applicationData.experience === 'account-linking') return "account-linking";
                if (applicationData.experience === 'entry-auth') return "entry-auth";
                return "community";
            case 'compass':
                return "compass";
            case 'confluence':
                return "confluence";
            case 'jira':
                return "jira";
            case 'loom':
                switch(applicationData.experience){
                    case 'default':
                        return "default";
                    default:
                        return "loom";
                }
            case 'jira-align':
                return "jira-align";
            case 'opsgenie':
                return "opsgenie";
            case 'rovo':
                return "rovo";
            case 'statuspage':
                return "statuspage";
            case 'trello':
                return "trello";
            case 'wac':
                switch(applicationData.experience){
                    case 'otp-jira':
                    case 'atlas-66195':
                        return "atlas-66195";
                    case 'otp-confluence':
                    case 'cfind-2409':
                        return "cfind-2409";
                    case 'loom':
                        return "loom-cobranding";
                    case 'jpd':
                        return "jpd";
                    case 'jsm':
                        return "jsm";
                    case 'service-collection':
                        return "service-collection";
                    case 'teamwork-collection':
                        return "teamwork-collection";
                    case 'cfind-3856':
                        return "cfind-3856";
                    default:
                        return "no-cobranding";
                }
            case 'support':
                switch(applicationData.experience){
                    case 'ic':
                        return "ic";
                    default:
                        return "no-cobranding";
                }
            case 'pollinator':
                if (applicationData.experience) {
                    if (applicationData.experience.startsWith('jira')) return "jira";
                    if (applicationData.experience.startsWith('confluence')) return "confluence";
                    if (applicationData.experience === 'demo') return "demo";
                }
                return "no-cobranding";
            case 'prt':
                if (applicationData.experience === 'demo') return "prt-demo";
                return "prt";
        }
    }
    return "no-cobranding";
}
const $aa1d9ab7fd224e0b$var$CobrandingContext = /*#__PURE__*/ (0, $91i6m.createContext)({
    cobranding: "no-cobranding",
    isMobileApp: false
});
const $aa1d9ab7fd224e0b$export$c5b813538c5440a9 = $aa1d9ab7fd224e0b$var$CobrandingContext.Provider;
const $aa1d9ab7fd224e0b$export$b9c89a068720407f = $aa1d9ab7fd224e0b$var$CobrandingContext.Consumer;
const $aa1d9ab7fd224e0b$export$808c37e33518fa32 = ()=>(0, $91i6m.useContext)($aa1d9ab7fd224e0b$var$CobrandingContext);

});
parcelRegister("3H79M", function(module, exports) {

$parcel$export(module.exports, "AidFrontendDynamicConfig", function () { return $ec6b0c37b54f9347$export$72c0add96dbeed4e; });
var $ec6b0c37b54f9347$export$72c0add96dbeed4e = /*#__PURE__*/ function(AidFrontendDynamicConfig) {
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/aid-frontend_disabled_cobranding_application_keys
    AidFrontendDynamicConfig["DISABLED_COBRANDING_APPLICATION_KEYS"] = "aid-frontend_disabled_cobranding_application_keys";
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/google_login_outage_advisory
    AidFrontendDynamicConfig["GOOGLE_LOGIN_OUTAGE_ADVISORY"] = "google_login_outage_advisory";
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/aid-frontend_apple_login_outage_advisory
    AidFrontendDynamicConfig["APPLE_LOGIN_OUTAGE_ADVISORY"] = "aid-frontend_apple_login_outage_advisory";
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/aid-frontend_slack_login_outage_advisory
    AidFrontendDynamicConfig["SLACK_LOGIN_OUTAGE_ADVISORY"] = "aid-frontend_slack_login_outage_advisory";
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/aid-frontend_microsoft_login_outage_advisory
    AidFrontendDynamicConfig["MICROSOFT_LOGIN_OUTAGE_ADVISORY"] = "aid-frontend_microsoft_login_outage_advisory";
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/aid-frontend_google_one_tap_kill_switch
    AidFrontendDynamicConfig["GOOGLE_ONE_TAP_KILL_SWITCH"] = "aid-frontend_google_one_tap_kill_switch";
    return AidFrontendDynamicConfig;
}({});

});


parcelRegister("5oJNc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ee2b711bb7befb8$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $3ee2b711bb7befb8$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});

parcelRegister("koa2c", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $ed7dd52ca5a8fb03$export$a4687b0234b40e28; });

var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $8Xa2x = parcelRequire("8Xa2x");

var $2R3rH = parcelRequire("2R3rH");
function $ed7dd52ca5a8fb03$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ed7dd52ca5a8fb03$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ed7dd52ca5a8fb03$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ed7dd52ca5a8fb03$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ed7dd52ca5a8fb03$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $8Xa2x.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $2R3rH.useTrackedRef)(analyticsData);
    var fnRef = (0, $2R3rH.useTrackedRef)(fn);
    var handler = (0, $91i6m.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $ed7dd52ca5a8fb03$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("8Xa2x", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $684b9f266c80792f$export$5bf35293e545f20c; });

var $57aKu = parcelRequire("57aKu");

var $lJUi6 = parcelRequire("lJUi6");

var $jnxi2 = parcelRequire("jnxi2");
function $684b9f266c80792f$export$5bf35293e545f20c() {
    var analyticsContext = (0, $jnxi2.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $57aKu.useCallbackOne)(function(payload) {
        return new (0, $lJUi6.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("57aKu", function(module, exports) {

$parcel$export(module.exports, "useCallbackOne", function () { return $3b95f1b3b49b7408$export$33752cf3ee811995; });

var $91i6m = parcelRequire("91i6m");
function $3b95f1b3b49b7408$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $3b95f1b3b49b7408$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $91i6m.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $91i6m.useRef)(true);
    var committed = (0, $91i6m.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $3b95f1b3b49b7408$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $91i6m.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $3b95f1b3b49b7408$export$33752cf3ee811995(callback, inputs) {
    return $3b95f1b3b49b7408$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $3b95f1b3b49b7408$export$1538c33de8887b59 = $3b95f1b3b49b7408$export$b6feb8998cd9b342;
var $3b95f1b3b49b7408$export$35808ee640e87ca7 = $3b95f1b3b49b7408$export$33752cf3ee811995;

});

parcelRegister("lJUi6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd39772ea5bd61aa$export$2e2bcd8739ae039; });

var $iqLBO = parcelRequire("iqLBO");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $gGOBY = parcelRequire("gGOBY");

var $lVDuE = parcelRequire("lVDuE");

var $dX0BB = parcelRequire("dX0BB");

var $kSyoi = parcelRequire("kSyoi");

var $dsN6L = parcelRequire("dsN6L");

var $lGiCH = parcelRequire("lGiCH");
function $fd39772ea5bd61aa$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($gGOBY)))(t, $fd39772ea5bd61aa$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(t).constructor) : o.apply(t, e));
}
function $fd39772ea5bd61aa$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($fd39772ea5bd61aa$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $fd39772ea5bd61aa$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dX0BB)))((0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $fd39772ea5bd61aa$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $fd39772ea5bd61aa$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $fd39772ea5bd61aa$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, UIAnalyticsEvent);
        _this = $fd39772ea5bd61aa$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($kSyoi)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $fd39772ea5bd61aa$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $lGiCH.default));

});
parcelRegister("lGiCH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc8bf7616453991d$export$2e2bcd8739ae039; });

var $61RDg = parcelRequire("61RDg");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $dsN6L = parcelRequire("dsN6L");
function $fc8bf7616453991d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fc8bf7616453991d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fc8bf7616453991d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fc8bf7616453991d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fc8bf7616453991d$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $fc8bf7616453991d$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $fc8bf7616453991d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $fc8bf7616453991d$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(updater) === 'object') this.payload = $fc8bf7616453991d$var$_objectSpread($fc8bf7616453991d$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("jnxi2", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $e1b9fd00f2b0615c$export$d1f587f82ad51c4; });

var $91i6m = parcelRequire("91i6m");

var $6Jo8f = parcelRequire("6Jo8f");
var $e1b9fd00f2b0615c$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $91i6m.useContext)((0, $6Jo8f.default));
};

});
parcelRegister("6Jo8f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e69aa27c74235fb$export$2e2bcd8739ae039; });

var $iRSCa = parcelRequire("iRSCa");
var $4e69aa27c74235fb$export$2e2bcd8739ae039 = (0, $iRSCa.default);

});
parcelRegister("iRSCa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbc78a8e66d0df5d$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");
var $dbc78a8e66d0df5d$var$AnalyticsNextContext = (0, $91i6m.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
var $dbc78a8e66d0df5d$export$2e2bcd8739ae039 = $dbc78a8e66d0df5d$var$AnalyticsNextContext;

});




parcelRegister("2R3rH", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $21433441790c5979$export$1d27a74659855e44; });

var $91i6m = parcelRequire("91i6m");
var $21433441790c5979$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $91i6m.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("6A0cm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ca64240446d5b0e$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $4ca64240446d5b0e$export$2e2bcd8739ae039() {}

});

parcelRegister("4jXgk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3256e80d983535fa$export$2e2bcd8739ae039; });
/* heading.partial.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5YM7L = parcelRequire("5YM7L");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $7re4P = parcelRequire("7re4P");

var $hZpnm = parcelRequire("hZpnm");

var $kKFpx = parcelRequire("kKFpx");

var $e08gr = parcelRequire("e08gr");
var $3256e80d983535fa$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
var $3256e80d983535fa$var$styles = {
    reset: "_1mouidpf _1dyz4jg8 _1p1dglyw"
};
var $3256e80d983535fa$var$headingColorStylesMap = {
    'color.text': "_syaz1fxt",
    'color.text.inverse': "_syaz15cr",
    'color.text.warning.inverse': "_syazal3n"
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c47bed69b7a147a63fdb8c394e98514a>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ var $3256e80d983535fa$var$headingSizeStylesMap = {
    xxlarge: "_11c84xcc",
    xlarge: "_11c81c04",
    large: "_11c8nf1z",
    medium: "_11c8lodh",
    small: "_11c8nbxd",
    xsmall: "_11c8140y",
    xxsmall: "_11c81vhk"
};
/**
 * @codegenEnd
 */ var $3256e80d983535fa$var$useColor = function useColor(colorProp) {
    var surface = (0, $hZpnm.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $7re4P.inverseColorMap).hasOwnProperty(surface)) return (0, $7re4P.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $3256e80d983535fa$var$Heading = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(props, ref) {
    var children = props.children, size = props.size, id = props.id, testId = props.testId, as = props.as, colorProp = props.color;
    typeof $e08gr;
    var _useHeading = (0, $kKFpx.useHeading)($3256e80d983535fa$var$sizeTagMap[size]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === 'div' && hLevel;
    var color = $3256e80d983535fa$var$useColor(colorProp);
    return /*#__PURE__*/ $91i6m.createElement(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $9gzWK.default)([
            $3256e80d983535fa$var$styles.reset,
            size && $3256e80d983535fa$var$headingSizeStylesMap[size],
            $3256e80d983535fa$var$headingColorStylesMap[color]
        ])
    }, children);
});
var $3256e80d983535fa$export$2e2bcd8739ae039 = $3256e80d983535fa$var$Heading;

});
parcelRegister("7re4P", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $56a5f967a4df8085$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $56a5f967a4df8085$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $56a5f967a4df8085$export$632685d741f3dbbf; });
$parcel$export(module.exports, "inverseColorMap", function () { return $56a5f967a4df8085$export$2185ce37f9bdd963; });
$parcel$export(module.exports, "opacityMap", function () { return $56a5f967a4df8085$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $56a5f967a4df8085$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $56a5f967a4df8085$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $56a5f967a4df8085$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $56a5f967a4df8085$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $56a5f967a4df8085$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $56a5f967a4df8085$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $56a5f967a4df8085$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "fontMap", function () { return $56a5f967a4df8085$export$6ffa317d5e70375; });
$parcel$export(module.exports, "fontWeightMap", function () { return $56a5f967a4df8085$export$303e322c6b1ed114; });
$parcel$export(module.exports, "fontFamilyMap", function () { return $56a5f967a4df8085$export$3c7e9587132614b4; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $56a5f967a4df8085$export$e615f061ca585a6c; });
$parcel$export(module.exports, "spaceStylesMap", function () { return $56a5f967a4df8085$export$bf46c3f9eeafc71f; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $56a5f967a4df8085$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "textColorStylesMap", function () { return $56a5f967a4df8085$export$3a1bcba60b23d7f0; });
$parcel$export(module.exports, "textSizeStylesMap", function () { return $56a5f967a4df8085$export$219d364c0da35ae4; });
$parcel$export(module.exports, "textWeightStylesMap", function () { return $56a5f967a4df8085$export$38845ca010b93505; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $56a5f967a4df8085$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $56a5f967a4df8085$export$5e65a44e5b6ecadb; });

var $dsN6L = parcelRequire("dsN6L");

var $boAHD = parcelRequire("boAHD");

var $2S8bR = parcelRequire("2S8bR");
function $56a5f967a4df8085$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $56a5f967a4df8085$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $56a5f967a4df8085$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $56a5f967a4df8085$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $56a5f967a4df8085$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $56a5f967a4df8085$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $56a5f967a4df8085$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $56a5f967a4df8085$export$632685d741f3dbbf = $56a5f967a4df8085$var$_objectSpread($56a5f967a4df8085$var$_objectSpread({}, $56a5f967a4df8085$export$958d0ae7f2977ae4), $56a5f967a4df8085$export$d2dc61f58390201c);
var $56a5f967a4df8085$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $56a5f967a4df8085$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $56a5f967a4df8085$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $56a5f967a4df8085$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $56a5f967a4df8085$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $56a5f967a4df8085$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $56a5f967a4df8085$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $56a5f967a4df8085$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B778C)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $56a5f967a4df8085$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $56a5f967a4df8085$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    // @deprecated
    'border.width.0': "var(--ds-border-width-0, 0px)",
    // @deprecated
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    // @deprecated
    'border.width.outline': "var(--ds-border-width-outline, 2px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
var $56a5f967a4df8085$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)",
    // @deprecated
    'border.radius': "var(--ds-border-radius, 3px)",
    // @deprecated
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    // @deprecated
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    // @deprecated
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    // @deprecated
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    // @deprecated
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    // @deprecated
    'border.radius.circle': "var(--ds-border-radius-circle, 9999px)"
};
var $56a5f967a4df8085$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $56a5f967a4df8085$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $56a5f967a4df8085$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $56a5f967a4df8085$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $56a5f967a4df8085$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $56a5f967a4df8085$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $56a5f967a4df8085$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $56a5f967a4df8085$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $boAHD.css)((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $56a5f967a4df8085$export$e615f061ca585a6c = $56a5f967a4df8085$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $56a5f967a4df8085$export$ca0f9c2de39ffed7(spacingProperty, $56a5f967a4df8085$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $56a5f967a4df8085$export$bf46c3f9eeafc71f = $56a5f967a4df8085$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $56a5f967a4df8085$export$ca0f9c2de39ffed7(spacingProperty, $56a5f967a4df8085$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $56a5f967a4df8085$export$e7af83bafe7f9e63 = $56a5f967a4df8085$export$ca0f9c2de39ffed7('backgroundColor', $56a5f967a4df8085$export$d1d79bf68ac056bd);
var $56a5f967a4df8085$export$3a1bcba60b23d7f0 = $56a5f967a4df8085$export$ca0f9c2de39ffed7('color', $56a5f967a4df8085$export$8473307aa00d6ea1);
var $56a5f967a4df8085$export$45f3f4fe16f9f7d5 = $56a5f967a4df8085$export$ca0f9c2de39ffed7('fontWeight', $56a5f967a4df8085$export$303e322c6b1ed114);
var $56a5f967a4df8085$export$68cc305da27dbaa4 = $56a5f967a4df8085$export$ca0f9c2de39ffed7('fontFamily', $56a5f967a4df8085$export$3c7e9587132614b4);
var $56a5f967a4df8085$export$128f10c238242f83 = $56a5f967a4df8085$export$ca0f9c2de39ffed7('font', $56a5f967a4df8085$export$6ffa317d5e70375);
var $56a5f967a4df8085$export$219d364c0da35ae4 = $56a5f967a4df8085$export$ca0f9c2de39ffed7('font', $56a5f967a4df8085$export$236bfe3a33ef1292);
var $56a5f967a4df8085$export$38845ca010b93505 = $56a5f967a4df8085$export$ca0f9c2de39ffed7('fontWeight', $56a5f967a4df8085$export$855cfd311192d666);
var $56a5f967a4df8085$export$ff257d957d48c421 = $56a5f967a4df8085$export$ca0f9c2de39ffed7((0, $2S8bR.CURRENT_SURFACE_CSS_VAR), $56a5f967a4df8085$export$41a358c9c2356760);
var $56a5f967a4df8085$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $56a5f967a4df8085$export$41a358c9c2356760[color] !== undefined;
};
var $56a5f967a4df8085$export$7001ce64d9ff7c7f = $56a5f967a4df8085$export$ca0f9c2de39ffed7('font', $56a5f967a4df8085$export$b805719bc8cb376);

});

parcelRegister("hZpnm", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $d18bd1409a63b2ea$export$1ca2a26fecb070ae; });
$parcel$export(module.exports, "useSurface", function () { return $d18bd1409a63b2ea$export$1aeb4f6b93c4540d; });

var $91i6m = parcelRequire("91i6m");
var $d18bd1409a63b2ea$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $91i6m.createContext)('elevation.surface');
var $d18bd1409a63b2ea$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $91i6m.useContext)($d18bd1409a63b2ea$export$1ca2a26fecb070ae);
};
$d18bd1409a63b2ea$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});

parcelRegister("kKFpx", function(module, exports) {

$parcel$export(module.exports, "useHeading", function () { return $03e611732ccf8cfe$export$97a37b1befbbf9b1; });

var $91i6m = parcelRequire("91i6m");
// Allows support for heading levels 1-9 via aria-level
var $03e611732ccf8cfe$var$HeadingLevelContext = /*#__PURE__*/ (0, $91i6m.createContext)(0);
/**
 * @internal
 * @returns The current heading level context.
 */ var $03e611732ccf8cfe$var$useHeadingLevel = function useHeadingLevel() {
    return (0, $91i6m.useContext)($03e611732ccf8cfe$var$HeadingLevelContext);
};
var $03e611732ccf8cfe$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $03e611732ccf8cfe$var$useHeadingLevel();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $03e611732ccf8cfe$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $03e611732ccf8cfe$var$useHeadingLevel();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($03e611732ccf8cfe$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $03e611732ccf8cfe$export$2e2bcd8739ae039 = $03e611732ccf8cfe$var$HeadingLevelContextProvider;

});


parcelRegister("aDWwl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7bfaf0e999963df4$export$2e2bcd8739ae039; });
/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $hZpnm = parcelRequire("hZpnm");
var $7bfaf0e999963df4$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $7bfaf0e999963df4$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $7bfaf0e999963df4$var$baseStyles = null;
var $7bfaf0e999963df4$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhk1fno",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1eds",
    'color.background.accent.lime.subtler.pressed': "_bfhk1hgz",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhkhgj8",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhk1b17",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhk1pbw",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkrw5d",
    'color.background.accent.red.subtler.pressed': "_bfhk69rw",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1tf4",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhkprmn",
    'color.background.accent.orange.subtlest': "_bfhk1g3m",
    'color.background.accent.orange.subtlest.hovered': "_bfhkg4tm",
    'color.background.accent.orange.subtlest.pressed': "_bfhk1ya0",
    'color.background.accent.orange.subtler': "_bfhkf2vu",
    'color.background.accent.orange.subtler.hovered': "_bfhk1lml",
    'color.background.accent.orange.subtler.pressed': "_bfhkuxsx",
    'color.background.accent.orange.subtle': "_bfhk1g6e",
    'color.background.accent.orange.subtle.hovered': "_bfhk1oew",
    'color.background.accent.orange.subtle.pressed': "_bfhk1phk",
    'color.background.accent.orange.bolder': "_bfhkjgng",
    'color.background.accent.orange.bolder.hovered': "_bfhkhi52",
    'color.background.accent.orange.bolder.pressed': "_bfhkf767",
    'color.background.accent.yellow.subtlest': "_bfhk1ozg",
    'color.background.accent.yellow.subtlest.hovered': "_bfhk19g9",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk31d1",
    'color.background.accent.yellow.subtler': "_bfhk3fv2",
    'color.background.accent.yellow.subtler.hovered': "_bfhklg04",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1d44",
    'color.background.accent.yellow.subtle': "_bfhkry5t",
    'color.background.accent.yellow.subtle.hovered': "_bfhk17e6",
    'color.background.accent.yellow.subtle.pressed': "_bfhko0y5",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk32kj",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkv5yf",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhkung8",
    'color.background.accent.green.subtler.pressed': "_bfhk1p19",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk8h4p",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1azz",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1j2h",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkg5py",
    'color.background.accent.teal.subtler.pressed': "_bfhkq7li",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk10ai",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhkse6l",
    'color.background.accent.blue.subtlest': "_bfhkavxe",
    'color.background.accent.blue.subtlest.hovered': "_bfhkay3p",
    'color.background.accent.blue.subtlest.pressed': "_bfhk1xmr",
    'color.background.accent.blue.subtler': "_bfhk4v9p",
    'color.background.accent.blue.subtler.hovered': "_bfhk16e6",
    'color.background.accent.blue.subtler.pressed': "_bfhk1uh7",
    'color.background.accent.blue.subtle': "_bfhk1j89",
    'color.background.accent.blue.subtle.hovered': "_bfhk1f4s",
    'color.background.accent.blue.subtle.pressed': "_bfhkqctv",
    'color.background.accent.blue.bolder': "_bfhkc8cv",
    'color.background.accent.blue.bolder.hovered': "_bfhk1cwi",
    'color.background.accent.blue.bolder.pressed': "_bfhkhcrq",
    'color.background.accent.purple.subtlest': "_bfhkp7j4",
    'color.background.accent.purple.subtlest.hovered': "_bfhkm0d5",
    'color.background.accent.purple.subtlest.pressed': "_bfhkgslw",
    'color.background.accent.purple.subtler': "_bfhk1jkz",
    'color.background.accent.purple.subtler.hovered': "_bfhk1wyu",
    'color.background.accent.purple.subtler.pressed': "_bfhk5fkp",
    'color.background.accent.purple.subtle': "_bfhkdh45",
    'color.background.accent.purple.subtle.hovered': "_bfhk1wob",
    'color.background.accent.purple.subtle.pressed': "_bfhkwz05",
    'color.background.accent.purple.bolder': "_bfhkygwo",
    'color.background.accent.purple.bolder.hovered': "_bfhkadgs",
    'color.background.accent.purple.bolder.pressed': "_bfhk1uro",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1een",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1r0p",
    'color.background.accent.magenta.subtler.pressed': "_bfhkxuzc",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk1ovh",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkwaw3",
    'color.background.accent.gray.subtlest': "_bfhk11bn",
    'color.background.accent.gray.subtlest.hovered': "_bfhk12j4",
    'color.background.accent.gray.subtlest.pressed': "_bfhk1lb4",
    'color.background.accent.gray.subtler': "_bfhk1v33",
    'color.background.accent.gray.subtler.hovered': "_bfhk1f7l",
    'color.background.accent.gray.subtler.pressed': "_bfhkd8a2",
    'color.background.accent.gray.subtle': "_bfhk1t05",
    'color.background.accent.gray.subtle.hovered': "_bfhk1a2l",
    'color.background.accent.gray.subtle.pressed': "_bfhk1z0s",
    'color.background.accent.gray.bolder': "_bfhk1t1b",
    'color.background.accent.gray.bolder.hovered': "_bfhke4nv",
    'color.background.accent.gray.bolder.pressed': "_bfhk82ra",
    'color.background.disabled': "_bfhksyzs",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhk1d5g",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhkm7j4",
    'color.background.neutral.hovered': "_bfhk15ej",
    'color.background.neutral.pressed': "_bfhkip91",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk166n",
    'color.background.neutral.subtle.pressed': "_bfhk1dty",
    'color.background.neutral.bold': "_bfhkcdhy",
    'color.background.neutral.bold.hovered': "_bfhk1bsc",
    'color.background.neutral.bold.pressed': "_bfhk1b6k",
    'color.background.selected': "_bfhkfg4m",
    'color.background.selected.hovered': "_bfhki1yw",
    'color.background.selected.pressed': "_bfhk19ru",
    'color.background.selected.bold': "_bfhk1fvw",
    'color.background.selected.bold.hovered': "_bfhk18hz",
    'color.background.selected.bold.pressed': "_bfhkgr1v",
    'color.background.brand.subtlest': "_bfhk3wxy",
    'color.background.brand.subtlest.hovered': "_bfhkezq1",
    'color.background.brand.subtlest.pressed': "_bfhk2ggb",
    'color.background.brand.bold': "_bfhkb29m",
    'color.background.brand.bold.hovered': "_bfhku1se",
    'color.background.brand.bold.pressed': "_bfhkqkzo",
    'color.background.brand.boldest': "_bfhk15mt",
    'color.background.brand.boldest.hovered': "_bfhk1uwk",
    'color.background.brand.boldest.pressed': "_bfhk17jr",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1io2",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk9pqq",
    'color.background.warning': "_bfhk1tzq",
    'color.background.warning.hovered': "_bfhk1rd4",
    'color.background.warning.pressed': "_bfhk11dh",
    'color.background.warning.bold': "_bfhk190i",
    'color.background.warning.bold.hovered': "_bfhk1i4c",
    'color.background.warning.bold.pressed': "_bfhkrj9s",
    'color.background.success': "_bfhkmv6i",
    'color.background.success.hovered': "_bfhk1jgi",
    'color.background.success.pressed': "_bfhky4f1",
    'color.background.success.bold': "_bfhk8emd",
    'color.background.success.bold.hovered': "_bfhk1q4l",
    'color.background.success.bold.pressed': "_bfhkcrcn",
    'color.background.discovery': "_bfhk1nvp",
    'color.background.discovery.hovered': "_bfhk1xp7",
    'color.background.discovery.pressed': "_bfhkdlkp",
    'color.background.discovery.bold': "_bfhk1lri",
    'color.background.discovery.bold.hovered': "_bfhk1w72",
    'color.background.discovery.bold.pressed': "_bfhkrb53",
    'color.background.information': "_bfhk33gi",
    'color.background.information.hovered': "_bfhk1vps",
    'color.background.information.pressed': "_bfhk1s0z",
    'color.background.information.bold': "_bfhk14wj",
    'color.background.information.bold.hovered': "_bfhk1amz",
    'color.background.information.bold.pressed': "_bfhk5bth",
    'color.blanket': "_bfhk10xm",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkn82g",
    'color.skeleton.subtle': "_bfhkh3tw",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk108i",
    'elevation.surface.pressed': "_bfhk1ji5",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk16qz",
    'elevation.surface.overlay.pressed': "_bfhkvq0a",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk1a0f",
    'elevation.surface.raised.pressed': "_bfhkf7u5",
    'elevation.surface.sunken': "_bfhkqbzx",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $7bfaf0e999963df4$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $7bfaf0e999963df4$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l108i",
    'elevation.surface.pressed': "_1q1l1ji5",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l16qz",
    'elevation.surface.overlay.pressed': "_1q1lvq0a",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l1a0f",
    'elevation.surface.raised.pressed': "_1q1lf7u5",
    'elevation.surface.sunken': "_1q1lqbzx"
};
var $7bfaf0e999963df4$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $7bfaf0e999963df4$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $7bfaf0e999963df4$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $7bfaf0e999963df4$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $7bfaf0e999963df4$var$Box = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $7bfaf0e999963df4$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error -- className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(htmlAttributes, $7bfaf0e999963df4$var$_excluded2);
    var node = /*#__PURE__*/ $91i6m.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        style: style,
        ref: ref,
        className: (0, $9gzWK.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $7bfaf0e999963df4$var$backgroundColorMap[backgroundColor],
            backgroundColor && $7bfaf0e999963df4$var$isSurfaceToken(backgroundColor) && $7bfaf0e999963df4$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $7bfaf0e999963df4$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $7bfaf0e999963df4$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $7bfaf0e999963df4$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $7bfaf0e999963df4$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $91i6m.createElement((0, $hZpnm.SurfaceContext).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $7bfaf0e999963df4$export$2e2bcd8739ae039 = $7bfaf0e999963df4$var$Box;
function $7bfaf0e999963df4$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $7bfaf0e999963df4$var$setSurfaceTokenMap;
}

});

parcelRegister("dwV3h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d9a84d5f885345c$export$2e2bcd8739ae039; });
/* inline.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $da7Sb = parcelRequire("da7Sb");

var $9hyIK = parcelRequire("9hyIK");
var $9d9a84d5f885345c$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "shouldWrap",
    "spread",
    "grow",
    "space",
    "rowSpace",
    "separator",
    "xcss",
    "testId",
    "role",
    "children"
];
var $9d9a84d5f885345c$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $9d9a84d5f885345c$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $91i6m.createElement("span", {
        className: (0, $9gzWK.default)([
            $9d9a84d5f885345c$var$styles.separator
        ])
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $9d9a84d5f885345c$var$Inline = /*#__PURE__*/ (0, $91i6m.memo)(/*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref2, $9d9a84d5f885345c$var$_excluded);
    var separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ $91i6m.createElement($9d9a84d5f885345c$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $91i6m.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $91i6m.createElement((0, $91i6m.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $91i6m.createElement((0, $9hyIK.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, ariaAttributes, {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $da7Sb.cx)(grow === 'hug' && $9d9a84d5f885345c$var$styles.hug, grow === 'fill' && $9d9a84d5f885345c$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$9d9a84d5f885345c$var$Inline.displayName = 'Inline';
var $9d9a84d5f885345c$export$2e2bcd8739ae039 = $9d9a84d5f885345c$var$Inline;

});
parcelRegister("da7Sb", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $995250f4c69a6021$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("91i6m");


var $jdmOL = parcelRequire("jdmOL");
var $995250f4c69a6021$var$_createStrictAPI = (0, $jdmOL.createStrictAPI)(), $995250f4c69a6021$var$XCSSProp = $995250f4c69a6021$var$_createStrictAPI.XCSSProp, $995250f4c69a6021$export$dbf350e5966cf602 = $995250f4c69a6021$var$_createStrictAPI.css, $995250f4c69a6021$export$eb1ecd84a24ee424 = $995250f4c69a6021$var$_createStrictAPI.cssMap, $995250f4c69a6021$export$a274e22fb40f762e = $995250f4c69a6021$var$_createStrictAPI.cx;
 // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 
});
parcelRegister("jdmOL", function(module, exports) {

$parcel$export(module.exports, "createStrictAPI", function () { return $dfd0ee5cb1635714$export$39716b4af53f4ad; });

var $cIvFj = parcelRequire("cIvFj");

var $8kGa4 = parcelRequire("8kGa4");
function $dfd0ee5cb1635714$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $cIvFj.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $cIvFj.createStrictSetupError)();
        },
        cx: $8kGa4.cx,
        XCSSProp () {
            throw (0, $cIvFj.createStrictSetupError)();
        }
    };
}

});
parcelRegister("cIvFj", function(module, exports) {

$parcel$export(module.exports, "createStrictSetupError", function () { return $9422282edcf45c45$export$c4df1cb0c2b4d77c; });
const $9422282edcf45c45$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $9422282edcf45c45$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("8kGa4", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $6110e55f82fa189d$export$a274e22fb40f762e; });

var $9gzWK = parcelRequire("9gzWK");
const $6110e55f82fa189d$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $9gzWK.default)(actualStyles);
};

});



parcelRegister("9hyIK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c20a26aafdb55ef$export$2e2bcd8739ae039; });
/* flex.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");
var $6c20a26aafdb55ef$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $6c20a26aafdb55ef$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
var $6c20a26aafdb55ef$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
var $6c20a26aafdb55ef$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $6c20a26aafdb55ef$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $6c20a26aafdb55ef$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $6c20a26aafdb55ef$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $6c20a26aafdb55ef$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $6c20a26aafdb55ef$var$Flex = /*#__PURE__*/ (0, $91i6m.memo)(/*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $6c20a26aafdb55ef$var$_excluded);
    return /*#__PURE__*/ $91i6m.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, ariaAttributes, {
        role: role,
        className: (0, $9gzWK.default)([
            $6c20a26aafdb55ef$var$styles.root,
            gap && $6c20a26aafdb55ef$var$columnGapMap[gap],
            columnGap && $6c20a26aafdb55ef$var$columnGapMap[columnGap],
            gap && $6c20a26aafdb55ef$var$rowGapMap[gap],
            rowGap && $6c20a26aafdb55ef$var$rowGapMap[rowGap],
            alignItems && $6c20a26aafdb55ef$var$alignItemsMap[alignItems],
            direction && $6c20a26aafdb55ef$var$flexDirectionMap[direction],
            justifyContent && $6c20a26aafdb55ef$var$justifyContentMap[justifyContent],
            wrap && $6c20a26aafdb55ef$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$6c20a26aafdb55ef$var$Flex.displayName = 'Flex';
var $6c20a26aafdb55ef$export$2e2bcd8739ae039 = $6c20a26aafdb55ef$var$Flex;

});


parcelRegister("hPyLR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfb22be41b4c6d9e$export$2e2bcd8739ae039; });
/* stack.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");


var $da7Sb = parcelRequire("da7Sb");

var $9hyIK = parcelRequire("9hyIK");
var $cfb22be41b4c6d9e$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "spread",
    "grow",
    "space",
    "children",
    "testId",
    "xcss",
    "role"
];
var $cfb22be41b4c6d9e$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $cfb22be41b4c6d9e$var$Stack = /*#__PURE__*/ (0, $91i6m.memo)(/*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $cfb22be41b4c6d9e$var$_excluded);
    return /*#__PURE__*/ $91i6m.createElement((0, $9hyIK.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, ariaAttributes, {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $da7Sb.cx)(grow === 'hug' && $cfb22be41b4c6d9e$var$styles.hug, grow === 'fill' && $cfb22be41b4c6d9e$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$cfb22be41b4c6d9e$var$Stack.displayName = 'Stack';
var $cfb22be41b4c6d9e$export$2e2bcd8739ae039 = $cfb22be41b4c6d9e$var$Stack;

});

parcelRegister("kQU6o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2e42eac6e7c9d64$export$2e2bcd8739ae039; });
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");
var $f2e42eac6e7c9d64$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $f2e42eac6e7c9d64$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $91i6m.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $9gzWK.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ])
    }, children);
};
var $f2e42eac6e7c9d64$export$2e2bcd8739ae039 = $f2e42eac6e7c9d64$var$VisuallyHidden;

});

parcelRegister("8Clr7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $646280235d75004a$var$_react = $646280235d75004a$var$_interopRequireDefault((parcelRequire("91i6m")));

var $646280235d75004a$var$_baseNew = $646280235d75004a$var$_interopRequireDefault((parcelRequire("5Ooif")));
function $646280235d75004a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $646280235d75004a$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $646280235d75004a$var$_react.default.createElement($646280235d75004a$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$646280235d75004a$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $646280235d75004a$var$_default = module.exports.default = $646280235d75004a$var$StatusErrorIcon;

});
parcelRegister("5Ooif", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("lgmEG")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("lgmEG")).Icon; });

var $lgmEG = parcelRequire("lgmEG");

});
parcelRegister("lgmEG", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $f7acaa70a4f4c546$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $f7acaa70a4f4c546$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $f1k1y = parcelRequire("f1k1y");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $f7acaa70a4f4c546$var$svgStyles = null;
var $f7acaa70a4f4c546$var$iconStyles = null;
var $f7acaa70a4f4c546$var$utilityIconStyles = null;
var $f7acaa70a4f4c546$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $f7acaa70a4f4c546$var$baseHcmStyles = null;
var $f7acaa70a4f4c546$var$scaleSize = null;
var $f7acaa70a4f4c546$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $f7acaa70a4f4c546$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $f7acaa70a4f4c546$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $f7acaa70a4f4c546$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $f7acaa70a4f4c546$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $f7acaa70a4f4c546$export$f04a61298a47a40f = /*#__PURE__*/ (0, $91i6m.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $f1k1y.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $91i6m.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = $f7acaa70a4f4c546$var$baseSizeMap[type];
    var viewBoxPadding = $f7acaa70a4f4c546$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $91i6m.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $9gzWK.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $91i6m.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $9gzWK.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $f7acaa70a4f4c546$var$utilSizes[spacing] : size === 'small' ? $f7acaa70a4f4c546$var$coreSizeSmall[spacing] : $f7acaa70a4f4c546$var$coreSizeMedium[spacing]
        ])
    }));
});
var $f7acaa70a4f4c546$export$2e2bcd8739ae039 = $f7acaa70a4f4c546$export$f04a61298a47a40f;

});



parcelRegister("fraFd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b3d1a63a344f37fa$var$_react = $b3d1a63a344f37fa$var$_interopRequireDefault((parcelRequire("91i6m")));

var $3UDdx = parcelRequire("3UDdx");
function $b3d1a63a344f37fa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b3d1a63a344f37fa$var$ErrorIcon = (props)=>/*#__PURE__*/ $b3d1a63a344f37fa$var$_react.default.createElement($3UDdx.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$b3d1a63a344f37fa$var$ErrorIcon.displayName = 'ErrorIcon';
var $b3d1a63a344f37fa$var$_default = module.exports.default = $b3d1a63a344f37fa$var$ErrorIcon;

});
parcelRegister("3UDdx", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $2d9505d3d31b769a$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");
function $2d9505d3d31b769a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2d9505d3d31b769a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2d9505d3d31b769a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2d9505d3d31b769a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $2d9505d3d31b769a$var$iconStyles = null;
var $2d9505d3d31b769a$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $2d9505d3d31b769a$var$baseHcmStyles = null;
var $2d9505d3d31b769a$var$primaryEqualsSecondaryHcmStyles = null;
var $2d9505d3d31b769a$var$secondaryTransparentHcmStyles = null;
var $2d9505d3d31b769a$export$f04a61298a47a40f = /*#__PURE__*/ (0, $91i6m.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $91i6m.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $91i6m.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $2d9505d3d31b769a$var$_objectSpread($2d9505d3d31b769a$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $9gzWK.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $2d9505d3d31b769a$var$sizeStyles[size]
        ])
    }));
});
var $2d9505d3d31b769a$export$2e2bcd8739ae039 = $2d9505d3d31b769a$export$f04a61298a47a40f;

});


parcelRegister("lJzpS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::456639fbdc991aefe1af05acf697365d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fd2945ebd3c2ec6b$var$_react = $fd2945ebd3c2ec6b$var$_interopRequireDefault((parcelRequire("91i6m")));

var $fd2945ebd3c2ec6b$var$_baseNew = $fd2945ebd3c2ec6b$var$_interopRequireDefault((parcelRequire("5Ooif")));
function $fd2945ebd3c2ec6b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fd2945ebd3c2ec6b$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $fd2945ebd3c2ec6b$var$_react.default.createElement($fd2945ebd3c2ec6b$var$_baseNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$fd2945ebd3c2ec6b$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $fd2945ebd3c2ec6b$var$_default = module.exports.default = $fd2945ebd3c2ec6b$var$StatusInformationIcon;

});

parcelRegister("4lH5X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32aa8d5a0d7bd991$var$_react = $32aa8d5a0d7bd991$var$_interopRequireDefault((parcelRequire("91i6m")));

var $3UDdx = parcelRequire("3UDdx");
function $32aa8d5a0d7bd991$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $32aa8d5a0d7bd991$var$InfoIcon = (props)=>/*#__PURE__*/ $32aa8d5a0d7bd991$var$_react.default.createElement($3UDdx.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props));
$32aa8d5a0d7bd991$var$InfoIcon.displayName = 'InfoIcon';
var $32aa8d5a0d7bd991$var$_default = module.exports.default = $32aa8d5a0d7bd991$var$InfoIcon;

});

parcelRegister("cGnBH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $93bbb821c22233ad$var$_react = $93bbb821c22233ad$var$_interopRequireDefault((parcelRequire("91i6m")));

var $93bbb821c22233ad$var$_baseNew = $93bbb821c22233ad$var$_interopRequireDefault((parcelRequire("5Ooif")));
function $93bbb821c22233ad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $93bbb821c22233ad$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $93bbb821c22233ad$var$_react.default.createElement($93bbb821c22233ad$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$93bbb821c22233ad$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $93bbb821c22233ad$var$_default = module.exports.default = $93bbb821c22233ad$var$StatusSuccessIcon;

});

parcelRegister("4eF3Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $31585218019e7b49$var$_react = $31585218019e7b49$var$_interopRequireDefault((parcelRequire("91i6m")));

var $3UDdx = parcelRequire("3UDdx");
function $31585218019e7b49$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $31585218019e7b49$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $31585218019e7b49$var$_react.default.createElement($3UDdx.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props));
$31585218019e7b49$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $31585218019e7b49$var$_default = module.exports.default = $31585218019e7b49$var$CheckCircleIcon;

});

parcelRegister("5CINd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee7b3f114c675eea0f953c33a485bcf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $41833f4cdf64b4a4$var$_react = $41833f4cdf64b4a4$var$_interopRequireDefault((parcelRequire("91i6m")));

var $41833f4cdf64b4a4$var$_baseNew = $41833f4cdf64b4a4$var$_interopRequireDefault((parcelRequire("5Ooif")));
function $41833f4cdf64b4a4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $41833f4cdf64b4a4$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $41833f4cdf64b4a4$var$_react.default.createElement($41833f4cdf64b4a4$var$_baseNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$41833f4cdf64b4a4$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $41833f4cdf64b4a4$var$_default = module.exports.default = $41833f4cdf64b4a4$var$StatusWarningIcon;

});

parcelRegister("jtCfM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e2de6618a37d3e46$var$_react = $e2de6618a37d3e46$var$_interopRequireDefault((parcelRequire("91i6m")));

var $3UDdx = parcelRequire("3UDdx");
function $e2de6618a37d3e46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e2de6618a37d3e46$var$WarningIcon = (props)=>/*#__PURE__*/ $e2de6618a37d3e46$var$_react.default.createElement($3UDdx.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$e2de6618a37d3e46$var$WarningIcon.displayName = 'WarningIcon';
var $e2de6618a37d3e46$var$_default = module.exports.default = $e2de6618a37d3e46$var$WarningIcon;

});

parcelRegister("lMv0j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdb6216a319b1446$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $5YM7L = parcelRequire("5YM7L");

var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $aA6j8 = parcelRequire("aA6j8");

var $jPJEp = parcelRequire("jPJEp");

var $6A0cm = parcelRequire("6A0cm");

var $jHZOR = parcelRequire("jHZOR");

var $1cddV = parcelRequire("1cddV");

var $1tlvt = parcelRequire("1tlvt");

var $erZ2i = parcelRequire("erZ2i");
var $8iz5R = parcelRequire("8iz5R");

var $f1k1y = parcelRequire("f1k1y");

var $fFuU3 = parcelRequire("fFuU3");

var $lLIDD = parcelRequire("lLIDD");

var $2v0hR = parcelRequire("2v0hR");

var $3mKzC = parcelRequire("3mKzC");

var $kNWHq = parcelRequire("kNWHq");

var $3Ksyi = parcelRequire("3Ksyi");

var $593ND = parcelRequire("593ND");

var $jPYSb = parcelRequire("jPYSb");
function $fdb6216a319b1446$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fdb6216a319b1446$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fdb6216a319b1446$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fdb6216a319b1446$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fdb6216a319b1446$var$tooltipZIndex = (0, $2v0hR.layers).tooltip();
var $fdb6216a319b1446$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "0.0.0-development"
};
// Inverts motion direction
var $fdb6216a319b1446$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $fdb6216a319b1446$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $fdb6216a319b1446$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $593ND.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $6A0cm.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $6A0cm.default) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn;
    var tooltipPosition = position === 'mouse' ? mousePosition : position;
    var onShowHandler = (0, $jPJEp.usePlatformLeafSyntheticEventHandler)($fdb6216a319b1446$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $fdb6216a319b1446$var$analyticsAttributes));
    var onHideHandler = (0, $jPJEp.usePlatformLeafSyntheticEventHandler)($fdb6216a319b1446$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $fdb6216a319b1446$var$analyticsAttributes));
    var apiRef = (0, $91i6m.useRef)(null);
    var _useState = (0, $91i6m.useState)('hide'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $91i6m.useRef)(null);
    var containerRef = (0, $91i6m.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $91i6m.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $1cddV.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $1cddV.default)(onShowHandler);
    var onHideHandlerStable = (0, $1cddV.default)(onHideHandler);
    var delayStable = (0, $1cddV.default)(delay);
    var canAppearStable = (0, $1cddV.default)(canAppear);
    var hasCalledShowHandler = (0, $91i6m.useRef)(false);
    var start = (0, $91i6m.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $91i6m.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $91i6m.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $91i6m.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $91i6m.useRef)(false);
    (0, $91i6m.useEffect)(function() {
        return (0, $3mKzC.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $91i6m.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? 'show-immediate' : 'fade-in');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done
        };
        var api = (0, $kNWHq.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    var hideTooltipOnEsc = (0, $91i6m.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $jHZOR.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $91i6m.useEffect)(function() {
        if (state === 'hide') return 0, $6A0cm.default;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $aA6j8.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $91i6m.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $91i6m.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $91i6m.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === 'mouse' ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            mouse: (0, $jPYSb.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $91i6m.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === 'mouse' ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $jPYSb.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $91i6m.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $91i6m.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible') && (0, $f1k1y.fg)('platform-tooltip-focus-visible-new')) return;
        } catch (_) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $91i6m.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $91i6m.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    var handleOpenLayerObserverCloseSignal = (0, $91i6m.useCallback)(function() {
        var _apiRef$current4;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $1tlvt.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current5;
        if (position === 'mouse' && (_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.mousePosition) {
            var _apiRef$current6;
            return (_apiRef$current6 = apiRef.current) === null || _apiRef$current6 === void 0 ? void 0 : _apiRef$current6.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $3Ksyi.default)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps['data-testid'] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $91i6m.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Fragment, null, typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Fragment, null, children($fdb6216a319b1446$var$_objectSpread($fdb6216a319b1446$var$_objectSpread({}, tooltipTriggerProps), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $lLIDD.default), {
        zIndex: $fdb6216a319b1446$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $fFuU3.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === 'mouse' ? undefined : $fdb6216a319b1446$var$invertedDirection[$fdb6216a319b1446$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $erZ2i.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $8iz5R.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $fdb6216a319b1446$var$_objectSpread($fdb6216a319b1446$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $fdb6216a319b1446$export$2e2bcd8739ae039 = $fdb6216a319b1446$var$Tooltip;

});
parcelRegister("jPJEp", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", function () { return $e706310e4813263a$export$1a04351537078b55; });

var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $8Xa2x = parcelRequire("8Xa2x");

var $2R3rH = parcelRequire("2R3rH");
function $e706310e4813263a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e706310e4813263a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e706310e4813263a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e706310e4813263a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e706310e4813263a$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $8Xa2x.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $2R3rH.useTrackedRef)(analyticsData);
    var fnRef = (0, $2R3rH.useTrackedRef)(fn);
    var handler = (0, $91i6m.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $e706310e4813263a$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("jHZOR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e591fc7dd0cdefc3$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $aA6j8 = parcelRequire("aA6j8");

var $f1k1y = parcelRequire("f1k1y");

var $lyJnu = parcelRequire("lyJnu");
function $e591fc7dd0cdefc3$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $91i6m.useRef)(false);
    var onKeyDown = (0, $91i6m.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $lyJnu.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $91i6m.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $91i6m.useEffect)(function() {
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled && (0, $f1k1y.fg)('platform_only_attach_escape_handler_on_view')) return;
        return (0, $aA6j8.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});
parcelRegister("lyJnu", function(module, exports) {

$parcel$export(module.exports, "KEY_UP", function () { return $fb1ff9104554a579$export$390330c10ff2b9a1; });
$parcel$export(module.exports, "KEY_DOWN", function () { return $fb1ff9104554a579$export$a80636c6f41931fe; });
$parcel$export(module.exports, "KEY_HOME", function () { return $fb1ff9104554a579$export$4af703091671bc; });
$parcel$export(module.exports, "KEY_END", function () { return $fb1ff9104554a579$export$e2bc30913faa5db7; });
$parcel$export(module.exports, "KEY_TAB", function () { return $fb1ff9104554a579$export$10f6869ed0a7d75b; });
$parcel$export(module.exports, "KEY_ENTER", function () { return $fb1ff9104554a579$export$8152f929a25a0ff4; });
$parcel$export(module.exports, "KEY_SPACE", function () { return $fb1ff9104554a579$export$e51a3576c045c8d5; });
$parcel$export(module.exports, "ESCAPE", function () { return $fb1ff9104554a579$export$2bb790b9008907b4; });
/**
 * Character key codes which can be used in keyboard events.
 */ var $fb1ff9104554a579$export$390330c10ff2b9a1 = 'ArrowUp';
var $fb1ff9104554a579$export$a80636c6f41931fe = 'ArrowDown';
var $fb1ff9104554a579$export$4af703091671bc = 'Home';
var $fb1ff9104554a579$export$e2bc30913faa5db7 = 'End';
var $fb1ff9104554a579$export$10f6869ed0a7d75b = 'Tab';
var $fb1ff9104554a579$export$8152f929a25a0ff4 = 'Enter';
var $fb1ff9104554a579$export$e51a3576c045c8d5 = 'Space';
var $fb1ff9104554a579$export$2bb790b9008907b4 = 'Escape';

});


parcelRegister("1cddV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0df12b5c3d84a51a$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");
function $0df12b5c3d84a51a$export$2e2bcd8739ae039(value) {
    var ref = (0, $91i6m.useRef)(value);
    (0, $91i6m.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("1tlvt", function(module, exports) {

$parcel$export(module.exports, "useNotifyOpenLayerObserver", function () { return $11292ea16532de68$export$469bb693f11edc7f; });

var $91i6m = parcelRequire("91i6m");

var $7Vllv = parcelRequire("7Vllv");

var $kAy0P = parcelRequire("kAy0P");
function $11292ea16532de68$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose;
    var context = (0, $91i6m.useContext)((0, $7Vllv.OpenLayerObserverContext));
    var namespace = (0, $kAy0P.useOpenLayerObserverNamespace)();
    (0, $91i6m.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose
    ]);
}

});
parcelRegister("7Vllv", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverContext", function () { return $5c4e6a2130d01b46$export$5fbf4d7fae6cdc00; });

var $91i6m = parcelRequire("91i6m");
var $5c4e6a2130d01b46$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $91i6m.createContext)(null);

});

parcelRegister("kAy0P", function(module, exports) {

$parcel$export(module.exports, "useOpenLayerObserverNamespace", function () { return $efd18d934fedfaba$export$1d57e79091cc3046; });

var $91i6m = parcelRequire("91i6m");

var $7zP2Z = parcelRequire("7zP2Z");
function $efd18d934fedfaba$export$1d57e79091cc3046() {
    var namespace = (0, $91i6m.useContext)((0, $7zP2Z.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("7zP2Z", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", function () { return $584366318fc49255$export$644a49f3b8c50fcd; });

var $91i6m = parcelRequire("91i6m");
var $584366318fc49255$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $91i6m.createContext)(null);

});



parcelRegister("erZ2i", function(module, exports) {

$parcel$export(module.exports, "useExitingPersistence", function () { return $a852eecbc2b282ac$export$3b6f38abbdcbd000; });
$parcel$export(module.exports, "default", function () { return $a852eecbc2b282ac$export$2e2bcd8739ae039; });

var $5YM7L = parcelRequire("5YM7L");

var $91i6m = parcelRequire("91i6m");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $a852eecbc2b282ac$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $a852eecbc2b282ac$var$ExitingContext = /*#__PURE__*/ (0, $91i6m.createContext)($a852eecbc2b282ac$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $a852eecbc2b282ac$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $a852eecbc2b282ac$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($a852eecbc2b282ac$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $a852eecbc2b282ac$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $91i6m.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $a852eecbc2b282ac$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $a852eecbc2b282ac$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $a852eecbc2b282ac$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $a852eecbc2b282ac$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $a852eecbc2b282ac$var$ExitingPersistence = /*#__PURE__*/ (0, $91i6m.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $91i6m.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $91i6m.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $91i6m.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $91i6m.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $a852eecbc2b282ac$var$childrenToArray(previousChildren);
    var current = $a852eecbc2b282ac$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $a852eecbc2b282ac$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $a852eecbc2b282ac$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $a852eecbc2b282ac$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $a852eecbc2b282ac$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $a852eecbc2b282ac$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $91i6m.useContext)($a852eecbc2b282ac$var$ExitingContext);
};
$a852eecbc2b282ac$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $a852eecbc2b282ac$export$2e2bcd8739ae039 = $a852eecbc2b282ac$var$ExitingPersistence;

});

parcelRegister("8iz5R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60ab39fcec9d0ee4$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $kH5Bg = parcelRequire("kH5Bg");
var $60ab39fcec9d0ee4$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $60ab39fcec9d0ee4$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $60ab39fcec9d0ee4$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-out';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $kH5Bg.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $60ab39fcec9d0ee4$export$2e2bcd8739ae039 = $60ab39fcec9d0ee4$var$FadeIn;

});
parcelRegister("kH5Bg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f10c2addfda7909e$export$2e2bcd8739ae039; });
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5YM7L = parcelRequire("5YM7L");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $7CGef = parcelRequire("7CGef");

var $sw8Qy = parcelRequire("sw8Qy");

var $gyRbD = parcelRequire("gyRbD");

var $erZ2i = parcelRequire("erZ2i");

var $k7pTa = parcelRequire("k7pTa");
var $f10c2addfda7909e$var$zoomIn = null;
var $f10c2addfda7909e$var$zoomOut = null;
var $f10c2addfda7909e$var$fadeIn = null;
var $f10c2addfda7909e$var$fadeOut = null;
var $f10c2addfda7909e$var$fadeInFromTop = null;
var $f10c2addfda7909e$var$fadeOutFromTop = null;
var $f10c2addfda7909e$var$fadeInFromLeft = null;
var $f10c2addfda7909e$var$fadeOutFromLeft = null;
var $f10c2addfda7909e$var$fadeInFromBottom = null;
var $f10c2addfda7909e$var$fadeOutFromBottom = null;
var $f10c2addfda7909e$var$fadeInFromRight = null;
var $f10c2addfda7909e$var$fadeOutFromRight = null;
var $f10c2addfda7909e$var$fadeInFromTopConstant = null;
var $f10c2addfda7909e$var$fadeOutFromTopConstant = null;
var $f10c2addfda7909e$var$fadeInFromLeftConstant = null;
var $f10c2addfda7909e$var$fadeOutFromLeftConstant = null;
var $f10c2addfda7909e$var$fadeInFromBottomConstant = null;
var $f10c2addfda7909e$var$fadeOutFromBottomConstant = null;
var $f10c2addfda7909e$var$fadeInFromRightConstant = null;
var $f10c2addfda7909e$var$fadeOutFromRightConstant = null;
var $f10c2addfda7909e$var$slideInFromTop = null;
var $f10c2addfda7909e$var$slideOutFromTop = null;
var $f10c2addfda7909e$var$slideInFromRight = null;
var $f10c2addfda7909e$var$slideOutFromRight = null;
var $f10c2addfda7909e$var$slideInFromBottom = null;
var $f10c2addfda7909e$var$slideOutFromBottom = null;
var $f10c2addfda7909e$var$slideInFromLeft = null;
var $f10c2addfda7909e$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $f10c2addfda7909e$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $k7pTa.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $erZ2i.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $gyRbD.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $91i6m.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $91i6m.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $7CGef.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $sw8Qy.exitingDurations)[duration] : (0, $sw8Qy.durations)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $9gzWK.default)([
            (0, $9gzWK.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $9gzWK.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $9gzWK.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $9gzWK.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $9gzWK.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $9gzWK.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $9gzWK.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $9gzWK.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $9gzWK.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $9gzWK.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $9gzWK.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $9gzWK.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $9gzWK.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $9gzWK.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $9gzWK.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $9gzWK.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $9gzWK.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $9gzWK.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $9gzWK.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $9gzWK.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $9gzWK.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $9gzWK.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $9gzWK.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $9gzWK.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $9gzWK.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $9gzWK.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $9gzWK.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $9gzWK.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $9gzWK.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $9gzWK.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $9gzWK.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $9gzWK.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $9gzWK.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $9gzWK.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $9gzWK.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $9gzWK.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $9gzWK.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $9gzWK.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $9gzWK.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $9gzWK.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $9gzWK.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $9gzWK.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $9gzWK.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $9gzWK.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $9gzWK.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $9gzWK.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $9gzWK.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $9gzWK.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $9gzWK.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $9gzWK.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $9gzWK.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $f10c2addfda7909e$export$2e2bcd8739ae039 = $f10c2addfda7909e$var$EnteringMotion;

});
parcelRegister("7CGef", function(module, exports) {

$parcel$export(module.exports, "isReducedMotion", function () { return $58ccd6c5d9a8e1ab$export$b7baf7667a68d87c; });

var $5YM7L = parcelRequire("5YM7L");

var $91i6m = parcelRequire("91i6m");

var $aA6j8 = parcelRequire("aA6j8");
var $58ccd6c5d9a8e1ab$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var $58ccd6c5d9a8e1ab$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$58ccd6c5d9a8e1ab$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};
var $58ccd6c5d9a8e1ab$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $91i6m.useState)($58ccd6c5d9a8e1ab$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $91i6m.useEffect)(function() {
        if (!$58ccd6c5d9a8e1ab$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $aA6j8.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $58ccd6c5d9a8e1ab$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
var $58ccd6c5d9a8e1ab$export$ff7706047246b98b = function prefersReducedMotion() {
    return $58ccd6c5d9a8e1ab$export$f0f789643ba5a83c;
};

});

parcelRegister("sw8Qy", function(module, exports) {

$parcel$export(module.exports, "durations", function () { return $055b8c4f23eb9b0b$export$38b928a7167ce124; });
$parcel$export(module.exports, "exitingDurations", function () { return $055b8c4f23eb9b0b$export$30fa1a2e62ae150c; });
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $055b8c4f23eb9b0b$export$368bacef0dacbe05 = 25;
var $055b8c4f23eb9b0b$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $055b8c4f23eb9b0b$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $055b8c4f23eb9b0b$export$30fa1a2e62ae150c = {
    none: $055b8c4f23eb9b0b$export$38b928a7167ce124.none,
    small: $055b8c4f23eb9b0b$export$38b928a7167ce124.small * $055b8c4f23eb9b0b$var$EXITING_MOTION_MULTIPLIER,
    medium: $055b8c4f23eb9b0b$export$38b928a7167ce124.medium * $055b8c4f23eb9b0b$var$EXITING_MOTION_MULTIPLIER,
    large: $055b8c4f23eb9b0b$export$38b928a7167ce124.large * $055b8c4f23eb9b0b$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("gyRbD", function(module, exports) {

$parcel$export(module.exports, "useSetTimeout", function () { return $c0e914121edcbd64$export$4f34107a2b00f39c; });

var $91i6m = parcelRequire("91i6m");
var $c0e914121edcbd64$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $c0e914121edcbd64$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $91i6m.useRef)([]);
    (0, $91i6m.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $c0e914121edcbd64$var$getHookDeps(opts));
    return (0, $91i6m.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $c0e914121edcbd64$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $91i6m.useRef)([]);
    (0, $91i6m.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $c0e914121edcbd64$var$getHookDeps(opts));
    return (0, $91i6m.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("k7pTa", function(module, exports) {

$parcel$export(module.exports, "useStaggeredEntrance", function () { return $ea588b1439e13524$export$25c7213fc07ec080; });

var $5YM7L = parcelRequire("5YM7L");

var $91i6m = parcelRequire("91i6m");

var $6A0cm = parcelRequire("6A0cm");

var $ac2Ip = parcelRequire("ac2Ip");

var $3iNkJ = parcelRequire("3iNkJ");
var $ea588b1439e13524$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $91i6m.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $6A0cm.default)
    };
});
var $ea588b1439e13524$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $3iNkJ.useUniqueId)();
    var context = (0, $91i6m.useContext)($ea588b1439e13524$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $ea588b1439e13524$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $91i6m.useRef)([]);
    var indexes = [];
    var _useState = (0, $91i6m.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $ac2Ip.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($ea588b1439e13524$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $ea588b1439e13524$export$2e2bcd8739ae039 = $ea588b1439e13524$var$StaggeredEntrance;

});
parcelRegister("ac2Ip", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", function () { return $76bd218b542be167$export$e5c5a5f917a5871c; });

var $91i6m = parcelRequire("91i6m");
var $76bd218b542be167$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $91i6m.useEffect) : (0, $91i6m.useLayoutEffect);

});

parcelRegister("3iNkJ", function(module, exports) {

$parcel$export(module.exports, "useUniqueId", function () { return $26795220cf39f23b$export$c485849f2e393253; });
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $91i6m = parcelRequire("91i6m");
function $26795220cf39f23b$export$c485849f2e393253() {
    var identifier = (0, $91i6m.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("fFuU3", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $b682a811178c7b2e$export$badac9ada3a0bdf9; });

var $iqLBO = parcelRequire("iqLBO");

var $5YM7L = parcelRequire("5YM7L");

var $91i6m = parcelRequire("91i6m");

var $blZ6m = parcelRequire("blZ6m");

var $9vpSS = parcelRequire("9vpSS");

// Export types from PopperJS / React Popper
var $b682a811178c7b2e$var$viewportPadding = 5;
var $b682a811178c7b2e$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $b682a811178c7b2e$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $b682a811178c7b2e$var$defaultChildrenFn() {
    return null;
}
var $b682a811178c7b2e$var$defaultOffset = [
    0,
    8
];
function $b682a811178c7b2e$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $b682a811178c7b2e$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $b682a811178c7b2e$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $91i6m.useMemo)(function() {
        var preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $b682a811178c7b2e$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $9vpSS.getMaxSizeModifiers)({
            viewportPadding: $b682a811178c7b2e$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($b682a811178c7b2e$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $91i6m.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $blZ6m.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("blZ6m", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $84410d63031fa907$export$badac9ada3a0bdf9; });

var $91i6m = parcelRequire("91i6m");

var $8z7c3 = parcelRequire("8z7c3");

var $ippcL = parcelRequire("ippcL");

var $7GKpb = parcelRequire("7GKpb");
var $84410d63031fa907$var$NOOP = function NOOP() {
    return void 0;
};
var $84410d63031fa907$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $84410d63031fa907$var$EMPTY_MODIFIERS = [];
function $84410d63031fa907$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $84410d63031fa907$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $91i6m.useContext((0, $8z7c3.ManagerReferenceNodeContext));
    var _React$useState = $91i6m.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $91i6m.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $91i6m.useEffect(function() {
        (0, $ippcL.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $91i6m.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $7GKpb.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $91i6m.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $84410d63031fa907$var$NOOP,
            update: update || $84410d63031fa907$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $ippcL.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("8z7c3", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", function () { return $63c72c0e59d16915$export$3dbd3405086fec7b; });
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", function () { return $63c72c0e59d16915$export$cbabb21c2529b130; });
$parcel$export(module.exports, "Manager", function () { return $63c72c0e59d16915$export$d0d38e7dec7a1a61; });

var $91i6m = parcelRequire("91i6m");
var $63c72c0e59d16915$export$3dbd3405086fec7b = $91i6m.createContext();
var $63c72c0e59d16915$export$cbabb21c2529b130 = $91i6m.createContext();
function $63c72c0e59d16915$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $91i6m.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $91i6m.useRef(false);
    $91i6m.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $91i6m.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $91i6m.createElement($63c72c0e59d16915$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $91i6m.createElement($63c72c0e59d16915$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("ippcL", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", function () { return $d66e1cf0dfd38041$export$f52c55943429c8b6; });
$parcel$export(module.exports, "safeInvoke", function () { return $d66e1cf0dfd38041$export$3dfa7c28635fe028; });
$parcel$export(module.exports, "setRef", function () { return $d66e1cf0dfd38041$export$4bb192c7cacf928f; });
$parcel$export(module.exports, "fromEntries", function () { return $d66e1cf0dfd38041$export$5150077fc2e7c662; });
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $d66e1cf0dfd38041$export$700979bc83e7db82; });

var $91i6m = parcelRequire("91i6m");
var $d66e1cf0dfd38041$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $d66e1cf0dfd38041$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $d66e1cf0dfd38041$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $d66e1cf0dfd38041$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $d66e1cf0dfd38041$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $d66e1cf0dfd38041$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $91i6m.useLayoutEffect : $91i6m.useEffect;

});

parcelRegister("7GKpb", function(module, exports) {

$parcel$export(module.exports, "usePopper", function () { return $0171d0518b33def6$export$f4d5bf230a36dd6e; });

var $91i6m = parcelRequire("91i6m");

var $eAqbf = parcelRequire("eAqbf");

var $cBZUw = parcelRequire("cBZUw");

var $hco6w = parcelRequire("hco6w");

var $ippcL = parcelRequire("ippcL");
var $0171d0518b33def6$var$EMPTY_MODIFIERS = [];
var $0171d0518b33def6$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $91i6m.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $0171d0518b33def6$var$EMPTY_MODIFIERS
    };
    var _React$useState = $91i6m.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $91i6m.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $eAqbf.flushSync(function() {
                    setState({
                        styles: (0, $ippcL.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $ippcL.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $91i6m.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hco6w)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $91i6m.useRef();
    (0, $ippcL.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $ippcL.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $cBZUw.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("cBZUw", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $92e8f6e3f4bf01da$export$8f7491d57c8f97a9; });

var $5V4V2 = parcelRequire("5V4V2");

var $dDwnX = parcelRequire("dDwnX");

var $5n2As = parcelRequire("5n2As");

var $15qRt = parcelRequire("15qRt");

var $2uPqK = parcelRequire("2uPqK");

var $3ksXK = parcelRequire("3ksXK");

var $8aUYP = parcelRequire("8aUYP");

var $OI30W = parcelRequire("OI30W");

var $fQ95C = parcelRequire("fQ95C");

var $amUyP = parcelRequire("amUyP");


var $92e8f6e3f4bf01da$export$d34966752335dd47 = [
    (0, $dDwnX.default),
    (0, $5n2As.default),
    (0, $15qRt.default),
    (0, $2uPqK.default),
    (0, $3ksXK.default),
    (0, $8aUYP.default),
    (0, $OI30W.default),
    (0, $fQ95C.default),
    (0, $amUyP.default)
];
var $92e8f6e3f4bf01da$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $5V4V2.popperGenerator)({
    defaultModifiers: $92e8f6e3f4bf01da$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("5V4V2", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $44f61767b651c4e6$export$ed5e13716264f202; });

var $akwxK = parcelRequire("akwxK");

var $hLC6U = parcelRequire("hLC6U");

var $4Hb4t = parcelRequire("4Hb4t");

var $4CII3 = parcelRequire("4CII3");

var $HBGDV = parcelRequire("HBGDV");

var $bxx1T = parcelRequire("bxx1T");

var $dRERv = parcelRequire("dRERv");


var $7HECO = parcelRequire("7HECO");
var $44f61767b651c4e6$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $44f61767b651c4e6$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $44f61767b651c4e6$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $44f61767b651c4e6$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $44f61767b651c4e6$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $7HECO.isElement)(reference) ? (0, $4Hb4t.default)(reference) : reference.contextElement ? (0, $4Hb4t.default)(reference.contextElement) : [],
                    popper: (0, $4Hb4t.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $HBGDV.default)((0, $dRERv.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$44f61767b651c4e6$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $akwxK.default)(reference, (0, $4CII3.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $hLC6U.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $bxx1T.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$44f61767b651c4e6$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $44f61767b651c4e6$export$8f7491d57c8f97a9 = /*#__PURE__*/ $44f61767b651c4e6$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("akwxK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $785504161e249728$export$2e2bcd8739ae039; });

var $l33kQ = parcelRequire("l33kQ");

var $8w72e = parcelRequire("8w72e");

var $fdq7r = parcelRequire("fdq7r");

var $7HECO = parcelRequire("7HECO");

var $ioUza = parcelRequire("ioUza");

var $74CGk = parcelRequire("74CGk");

var $kg8mx = parcelRequire("kg8mx");

var $6SHZD = parcelRequire("6SHZD");
function $785504161e249728$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $6SHZD.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $6SHZD.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $785504161e249728$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $7HECO.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $7HECO.isHTMLElement)(offsetParent) && $785504161e249728$var$isElementScaled(offsetParent);
    var documentElement = (0, $74CGk.default)(offsetParent);
    var rect = (0, $l33kQ.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $fdq7r.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $kg8mx.default)(documentElement)) scroll = (0, $8w72e.default)(offsetParent);
        if ((0, $7HECO.isHTMLElement)(offsetParent)) {
            offsets = (0, $l33kQ.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $ioUza.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("l33kQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f52c77119e6a9356$export$2e2bcd8739ae039; });

var $7HECO = parcelRequire("7HECO");

var $6SHZD = parcelRequire("6SHZD");

var $8svyU = parcelRequire("8svyU");

var $anT1G = parcelRequire("anT1G");
function $f52c77119e6a9356$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $7HECO.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $6SHZD.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $6SHZD.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $7HECO.isElement)(element) ? (0, $8svyU.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $anT1G.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("7HECO", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $59bc0fd0277bf293$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $59bc0fd0277bf293$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $59bc0fd0277bf293$export$af51f0f06c0f328a; });

var $8svyU = parcelRequire("8svyU");
function $59bc0fd0277bf293$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $8svyU.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $59bc0fd0277bf293$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $8svyU.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $59bc0fd0277bf293$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $8svyU.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("8svyU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62896bd4626b8c61$export$2e2bcd8739ae039; });
function $62896bd4626b8c61$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("6SHZD", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $5029e959c9e6e756$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $5029e959c9e6e756$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $5029e959c9e6e756$export$2077e0241d6afd3c; });
var $5029e959c9e6e756$export$8960430cfd85939f = Math.max;
var $5029e959c9e6e756$export$96ec731ed4dcb222 = Math.min;
var $5029e959c9e6e756$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("anT1G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78f6bc69cbbbe065$export$2e2bcd8739ae039; });

var $6XuQN = parcelRequire("6XuQN");
function $78f6bc69cbbbe065$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6XuQN.default)());
}

});
parcelRegister("6XuQN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51102f10faa78409$export$2e2bcd8739ae039; });
function $51102f10faa78409$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("8w72e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6336c4e7b4c6d67f$export$2e2bcd8739ae039; });

var $dI4Q8 = parcelRequire("dI4Q8");

var $8svyU = parcelRequire("8svyU");

var $7HECO = parcelRequire("7HECO");

var $cAHL0 = parcelRequire("cAHL0");
function $6336c4e7b4c6d67f$export$2e2bcd8739ae039(node) {
    if (node === (0, $8svyU.default)(node) || !(0, $7HECO.isHTMLElement)(node)) return (0, $dI4Q8.default)(node);
    else return (0, $cAHL0.default)(node);
}

});
parcelRegister("dI4Q8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fb32385ab603c08$export$2e2bcd8739ae039; });

var $8svyU = parcelRequire("8svyU");
function $9fb32385ab603c08$export$2e2bcd8739ae039(node) {
    var win = (0, $8svyU.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("cAHL0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92aaca154a013233$export$2e2bcd8739ae039; });
function $92aaca154a013233$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("fdq7r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b13c5497956e9804$export$2e2bcd8739ae039; });
function $b13c5497956e9804$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("ioUza", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d65658c5aff358f9$export$2e2bcd8739ae039; });

var $l33kQ = parcelRequire("l33kQ");

var $74CGk = parcelRequire("74CGk");

var $dI4Q8 = parcelRequire("dI4Q8");
function $d65658c5aff358f9$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $l33kQ.default)((0, $74CGk.default)(element)).left + (0, $dI4Q8.default)(element).scrollLeft;
}

});
parcelRegister("74CGk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5266e98202e3819b$export$2e2bcd8739ae039; });

var $7HECO = parcelRequire("7HECO");
function $5266e98202e3819b$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $7HECO.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("kg8mx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebfbc9ea4fa75b43$export$2e2bcd8739ae039; });

var $6NmcB = parcelRequire("6NmcB");
function $ebfbc9ea4fa75b43$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $6NmcB.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("6NmcB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f288a91dde2f0d8$export$2e2bcd8739ae039; });

var $8svyU = parcelRequire("8svyU");
function $4f288a91dde2f0d8$export$2e2bcd8739ae039(element) {
    return (0, $8svyU.default)(element).getComputedStyle(element);
}

});



parcelRegister("hLC6U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cef46362711233ac$export$2e2bcd8739ae039; });

var $l33kQ = parcelRequire("l33kQ");
function $cef46362711233ac$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $l33kQ.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("4Hb4t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36b3c41180e8acea$export$2e2bcd8739ae039; });

var $5NxuV = parcelRequire("5NxuV");

var $6gvS8 = parcelRequire("6gvS8");

var $8svyU = parcelRequire("8svyU");

var $kg8mx = parcelRequire("kg8mx");
function $36b3c41180e8acea$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $5NxuV.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $8svyU.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $kg8mx.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($36b3c41180e8acea$export$2e2bcd8739ae039((0, $6gvS8.default)(target)));
}

});
parcelRegister("5NxuV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $438b834c99d4315d$export$2e2bcd8739ae039; });

var $6gvS8 = parcelRequire("6gvS8");

var $kg8mx = parcelRequire("kg8mx");

var $fdq7r = parcelRequire("fdq7r");

var $7HECO = parcelRequire("7HECO");
function $438b834c99d4315d$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $fdq7r.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $7HECO.isHTMLElement)(node) && (0, $kg8mx.default)(node)) return node;
    return $438b834c99d4315d$export$2e2bcd8739ae039((0, $6gvS8.default)(node));
}

});
parcelRegister("6gvS8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48fcf5da9ac9506c$export$2e2bcd8739ae039; });

var $fdq7r = parcelRequire("fdq7r");

var $74CGk = parcelRequire("74CGk");

var $7HECO = parcelRequire("7HECO");
function $48fcf5da9ac9506c$export$2e2bcd8739ae039(element) {
    if ((0, $fdq7r.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $7HECO.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $74CGk.default)(element) // fallback
    );
}

});



parcelRegister("4CII3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35dd6468dcfc5859$export$2e2bcd8739ae039; });

var $8svyU = parcelRequire("8svyU");

var $fdq7r = parcelRequire("fdq7r");

var $6NmcB = parcelRequire("6NmcB");

var $7HECO = parcelRequire("7HECO");

var $hvXls = parcelRequire("hvXls");

var $6gvS8 = parcelRequire("6gvS8");

var $6XuQN = parcelRequire("6XuQN");
function $35dd6468dcfc5859$var$getTrueOffsetParent(element) {
    if (!(0, $7HECO.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $6NmcB.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $35dd6468dcfc5859$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6XuQN.default)());
    var isIE = /Trident/i.test((0, $6XuQN.default)());
    if (isIE && (0, $7HECO.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $6NmcB.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $6gvS8.default)(element);
    if ((0, $7HECO.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $7HECO.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $fdq7r.default)(currentNode)) < 0){
        var css = (0, $6NmcB.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $35dd6468dcfc5859$export$2e2bcd8739ae039(element) {
    var window = (0, $8svyU.default)(element);
    var offsetParent = $35dd6468dcfc5859$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $hvXls.default)(offsetParent) && (0, $6NmcB.default)(offsetParent).position === 'static')offsetParent = $35dd6468dcfc5859$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $fdq7r.default)(offsetParent) === 'html' || (0, $fdq7r.default)(offsetParent) === 'body' && (0, $6NmcB.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $35dd6468dcfc5859$var$getContainingBlock(element) || window;
}

});
parcelRegister("hvXls", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc035d9c78014b1f$export$2e2bcd8739ae039; });

var $fdq7r = parcelRequire("fdq7r");
function $cc035d9c78014b1f$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $fdq7r.default)(element)) >= 0;
}

});


parcelRegister("HBGDV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0831401406a78d78$export$2e2bcd8739ae039; });

var $hrOxP = parcelRequire("hrOxP");
function $0831401406a78d78$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $0831401406a78d78$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $0831401406a78d78$var$order(modifiers); // order based on phase
    return (0, $hrOxP.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("hrOxP", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $cb3c2a64de595288$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $cb3c2a64de595288$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $cb3c2a64de595288$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $cb3c2a64de595288$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $cb3c2a64de595288$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $cb3c2a64de595288$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $cb3c2a64de595288$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $cb3c2a64de595288$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $cb3c2a64de595288$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $cb3c2a64de595288$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $cb3c2a64de595288$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $cb3c2a64de595288$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $cb3c2a64de595288$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $cb3c2a64de595288$export$803cd8101b6c182b; });
$parcel$export(module.exports, "modifierPhases", function () { return $cb3c2a64de595288$export$d087d3878fdf71d5; });
var $cb3c2a64de595288$export$1e95b668f3b82d = 'top';
var $cb3c2a64de595288$export$40e543e69a8b3fbb = 'bottom';
var $cb3c2a64de595288$export$79ffe56a765070d2 = 'right';
var $cb3c2a64de595288$export$eabcd2c8791e7bf4 = 'left';
var $cb3c2a64de595288$export$dfb5619354ba860 = 'auto';
var $cb3c2a64de595288$export$aec2ce47c367b8c3 = [
    $cb3c2a64de595288$export$1e95b668f3b82d,
    $cb3c2a64de595288$export$40e543e69a8b3fbb,
    $cb3c2a64de595288$export$79ffe56a765070d2,
    $cb3c2a64de595288$export$eabcd2c8791e7bf4
];
var $cb3c2a64de595288$export$b3571188c770cc5a = 'start';
var $cb3c2a64de595288$export$bd5df0f255a350f8 = 'end';
var $cb3c2a64de595288$export$390fd549c5303b4d = 'clippingParents';
var $cb3c2a64de595288$export$d7b7311ec04a3e8f = 'viewport';
var $cb3c2a64de595288$export$ae5ab1c730825774 = 'popper';
var $cb3c2a64de595288$export$ca50aac9f3ba507f = 'reference';
var $cb3c2a64de595288$export$368f9a87e87fa4e1 = /*#__PURE__*/ $cb3c2a64de595288$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $cb3c2a64de595288$export$b3571188c770cc5a,
        placement + "-" + $cb3c2a64de595288$export$bd5df0f255a350f8
    ]);
}, []);
var $cb3c2a64de595288$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($cb3c2a64de595288$export$aec2ce47c367b8c3, [
    $cb3c2a64de595288$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $cb3c2a64de595288$export$b3571188c770cc5a,
        placement + "-" + $cb3c2a64de595288$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $cb3c2a64de595288$export$421679a7c3d56e = 'beforeRead';
var $cb3c2a64de595288$export$aafa59e2e03f2942 = 'read';
var $cb3c2a64de595288$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $cb3c2a64de595288$export$c65e99957a05207c = 'beforeMain';
var $cb3c2a64de595288$export$f22da7240b7add18 = 'main';
var $cb3c2a64de595288$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $cb3c2a64de595288$export$8d4d2d70e7d46032 = 'beforeWrite';
var $cb3c2a64de595288$export$68d8715fc104d294 = 'write';
var $cb3c2a64de595288$export$70a6e5159acce2e6 = 'afterWrite';
var $cb3c2a64de595288$export$d087d3878fdf71d5 = [
    $cb3c2a64de595288$export$421679a7c3d56e,
    $cb3c2a64de595288$export$aafa59e2e03f2942,
    $cb3c2a64de595288$export$6964f6c886723980,
    $cb3c2a64de595288$export$c65e99957a05207c,
    $cb3c2a64de595288$export$f22da7240b7add18,
    $cb3c2a64de595288$export$bab79516f2d662fe,
    $cb3c2a64de595288$export$8d4d2d70e7d46032,
    $cb3c2a64de595288$export$68d8715fc104d294,
    $cb3c2a64de595288$export$70a6e5159acce2e6
];

});


parcelRegister("bxx1T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $866c65c2cba6c37c$export$2e2bcd8739ae039; });
function $866c65c2cba6c37c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("dRERv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a17febecdf8a8bb6$export$2e2bcd8739ae039; });
function $a17febecdf8a8bb6$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("dDwnX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ed809edcd44cd97$export$2e2bcd8739ae039; });

var $8svyU = parcelRequire("8svyU");
var $9ed809edcd44cd97$var$passive = {
    passive: true
};
function $9ed809edcd44cd97$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $8svyU.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $9ed809edcd44cd97$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $9ed809edcd44cd97$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $9ed809edcd44cd97$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $9ed809edcd44cd97$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $9ed809edcd44cd97$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $9ed809edcd44cd97$var$effect,
    data: {}
};

});

parcelRegister("5n2As", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e911b749cea99a5$export$2e2bcd8739ae039; });

var $aJQMB = parcelRequire("aJQMB");
function $3e911b749cea99a5$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $aJQMB.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $3e911b749cea99a5$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $3e911b749cea99a5$var$popperOffsets,
    data: {}
};

});
parcelRegister("aJQMB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d170cf714e82392$export$2e2bcd8739ae039; });

var $1lqsE = parcelRequire("1lqsE");

var $iFCgR = parcelRequire("iFCgR");

var $1rznO = parcelRequire("1rznO");

var $hrOxP = parcelRequire("hrOxP");
function $7d170cf714e82392$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $1lqsE.default)(placement) : null;
    var variation = placement ? (0, $iFCgR.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $hrOxP.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $hrOxP.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $hrOxP.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $hrOxP.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $1rznO.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $hrOxP.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $hrOxP.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("1lqsE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fac473aa49342b9$export$2e2bcd8739ae039; });

function $0fac473aa49342b9$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("iFCgR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d979be1f69b8abe9$export$2e2bcd8739ae039; });
function $d979be1f69b8abe9$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("1rznO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10d3c26102a2c0dd$export$2e2bcd8739ae039; });
function $10d3c26102a2c0dd$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("15qRt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cab1836682443b2$export$2e2bcd8739ae039; });

var $hrOxP = parcelRequire("hrOxP");

var $4CII3 = parcelRequire("4CII3");

var $8svyU = parcelRequire("8svyU");

var $74CGk = parcelRequire("74CGk");

var $6NmcB = parcelRequire("6NmcB");

var $1lqsE = parcelRequire("1lqsE");

var $iFCgR = parcelRequire("iFCgR");

var $6SHZD = parcelRequire("6SHZD");
var $0cab1836682443b2$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $0cab1836682443b2$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $6SHZD.round)(x * dpr) / dpr || 0,
        y: (0, $6SHZD.round)(y * dpr) / dpr || 0
    };
}
function $0cab1836682443b2$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $hrOxP.left);
    var sideY = (0, $hrOxP.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $4CII3.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $8svyU.default)(popper)) {
            offsetParent = (0, $74CGk.default)(popper);
            if ((0, $6NmcB.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $hrOxP.top) || (placement === (0, $hrOxP.left) || placement === (0, $hrOxP.right)) && variation === (0, $hrOxP.end)) {
            sideY = (0, $hrOxP.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $hrOxP.left) || (placement === (0, $hrOxP.top) || placement === (0, $hrOxP.bottom)) && variation === (0, $hrOxP.end)) {
            sideX = (0, $hrOxP.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $0cab1836682443b2$var$unsetSides);
    var _ref4 = roundOffsets === true ? $0cab1836682443b2$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $8svyU.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $0cab1836682443b2$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $1lqsE.default)(state.placement),
        variation: (0, $iFCgR.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $0cab1836682443b2$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $0cab1836682443b2$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $0cab1836682443b2$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $0cab1836682443b2$var$computeStyles,
    data: {}
};

});

parcelRegister("2uPqK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d164720c72a7c28$export$2e2bcd8739ae039; });

var $fdq7r = parcelRequire("fdq7r");

var $7HECO = parcelRequire("7HECO");
// and applies them to the HTMLElements such as popper and arrow
function $1d164720c72a7c28$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $7HECO.isHTMLElement)(element) || !(0, $fdq7r.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $1d164720c72a7c28$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $7HECO.isHTMLElement)(element) || !(0, $fdq7r.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $1d164720c72a7c28$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $1d164720c72a7c28$var$applyStyles,
    effect: $1d164720c72a7c28$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("3ksXK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26c9b4bc8c7e1d81$export$2e2bcd8739ae039; });

var $1lqsE = parcelRequire("1lqsE");

var $hrOxP = parcelRequire("hrOxP");
function $26c9b4bc8c7e1d81$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $1lqsE.default)(placement);
    var invertDistance = [
        (0, $hrOxP.left),
        (0, $hrOxP.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $hrOxP.left),
        (0, $hrOxP.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $26c9b4bc8c7e1d81$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $hrOxP.placements).reduce(function(acc, placement) {
        acc[placement] = $26c9b4bc8c7e1d81$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $26c9b4bc8c7e1d81$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $26c9b4bc8c7e1d81$var$offset
};

});

parcelRegister("8aUYP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f3b74f8e33912c9$export$2e2bcd8739ae039; });

var $8ukq2 = parcelRequire("8ukq2");

var $1lqsE = parcelRequire("1lqsE");

var $ajkwZ = parcelRequire("ajkwZ");

var $7rvV0 = parcelRequire("7rvV0");

var $bw3iH = parcelRequire("bw3iH");

var $hrOxP = parcelRequire("hrOxP");

var $iFCgR = parcelRequire("iFCgR");
function $5f3b74f8e33912c9$var$getExpandedFallbackPlacements(placement) {
    if ((0, $1lqsE.default)(placement) === (0, $hrOxP.auto)) return [];
    var oppositePlacement = (0, $8ukq2.default)(placement);
    return [
        (0, $ajkwZ.default)(placement),
        oppositePlacement,
        (0, $ajkwZ.default)(oppositePlacement)
    ];
}
function $5f3b74f8e33912c9$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $1lqsE.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $8ukq2.default)(preferredPlacement)
    ] : $5f3b74f8e33912c9$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $1lqsE.default)(placement) === (0, $hrOxP.auto) ? (0, $bw3iH.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $1lqsE.default)(placement);
        var isStartVariation = (0, $iFCgR.default)(placement) === (0, $hrOxP.start);
        var isVertical = [
            (0, $hrOxP.top),
            (0, $hrOxP.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $7rvV0.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $hrOxP.right) : (0, $hrOxP.left) : isStartVariation ? (0, $hrOxP.bottom) : (0, $hrOxP.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $8ukq2.default)(mainVariationSide);
        var altVariationSide = (0, $8ukq2.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $5f3b74f8e33912c9$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $5f3b74f8e33912c9$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("8ukq2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62e0f6df47359661$export$2e2bcd8739ae039; });
var $62e0f6df47359661$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $62e0f6df47359661$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $62e0f6df47359661$var$hash[matched];
    });
}

});

parcelRegister("ajkwZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $781b9acb38eb0c2f$export$2e2bcd8739ae039; });
var $781b9acb38eb0c2f$var$hash = {
    start: 'end',
    end: 'start'
};
function $781b9acb38eb0c2f$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $781b9acb38eb0c2f$var$hash[matched];
    });
}

});

parcelRegister("7rvV0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56b3d056755e4172$export$2e2bcd8739ae039; });

var $ll4J0 = parcelRequire("ll4J0");

var $74CGk = parcelRequire("74CGk");

var $l33kQ = parcelRequire("l33kQ");

var $aJQMB = parcelRequire("aJQMB");

var $jhSNt = parcelRequire("jhSNt");

var $hrOxP = parcelRequire("hrOxP");

var $7HECO = parcelRequire("7HECO");

var $arCOq = parcelRequire("arCOq");

var $iKqvW = parcelRequire("iKqvW");
function $56b3d056755e4172$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $hrOxP.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $hrOxP.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $hrOxP.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $arCOq.default)(typeof padding !== 'number' ? padding : (0, $iKqvW.default)(padding, (0, $hrOxP.basePlacements)));
    var altContext = elementContext === (0, $hrOxP.popper) ? (0, $hrOxP.reference) : (0, $hrOxP.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $ll4J0.default)((0, $7HECO.isElement)(element) ? element : element.contextElement || (0, $74CGk.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $l33kQ.default)(state.elements.reference);
    var popperOffsets = (0, $aJQMB.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $jhSNt.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $hrOxP.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $hrOxP.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $hrOxP.right),
                (0, $hrOxP.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $hrOxP.top),
                (0, $hrOxP.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("ll4J0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f88f396dad276b09$export$2e2bcd8739ae039; });

var $hrOxP = parcelRequire("hrOxP");

var $iMoRm = parcelRequire("iMoRm");

var $ggoOw = parcelRequire("ggoOw");

var $4Hb4t = parcelRequire("4Hb4t");

var $4CII3 = parcelRequire("4CII3");

var $74CGk = parcelRequire("74CGk");

var $6NmcB = parcelRequire("6NmcB");

var $7HECO = parcelRequire("7HECO");

var $l33kQ = parcelRequire("l33kQ");

var $6gvS8 = parcelRequire("6gvS8");

var $emjeY = parcelRequire("emjeY");

var $fdq7r = parcelRequire("fdq7r");

var $jhSNt = parcelRequire("jhSNt");

var $6SHZD = parcelRequire("6SHZD");
function $f88f396dad276b09$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $l33kQ.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $f88f396dad276b09$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $hrOxP.viewport) ? (0, $jhSNt.default)((0, $iMoRm.default)(element, strategy)) : (0, $7HECO.isElement)(clippingParent) ? $f88f396dad276b09$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $jhSNt.default)((0, $ggoOw.default)((0, $74CGk.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $f88f396dad276b09$var$getClippingParents(element) {
    var clippingParents = (0, $4Hb4t.default)((0, $6gvS8.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $6NmcB.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $7HECO.isHTMLElement)(element) ? (0, $4CII3.default)(element) : element;
    if (!(0, $7HECO.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $7HECO.isElement)(clippingParent) && (0, $emjeY.default)(clippingParent, clipperElement) && (0, $fdq7r.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $f88f396dad276b09$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $f88f396dad276b09$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $f88f396dad276b09$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $6SHZD.max)(rect.top, accRect.top);
        accRect.right = (0, $6SHZD.min)(rect.right, accRect.right);
        accRect.bottom = (0, $6SHZD.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $6SHZD.max)(rect.left, accRect.left);
        return accRect;
    }, $f88f396dad276b09$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("iMoRm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dabffe4d04742317$export$2e2bcd8739ae039; });

var $8svyU = parcelRequire("8svyU");

var $74CGk = parcelRequire("74CGk");

var $ioUza = parcelRequire("ioUza");

var $anT1G = parcelRequire("anT1G");
function $dabffe4d04742317$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $8svyU.default)(element);
    var html = (0, $74CGk.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $anT1G.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $ioUza.default)(element),
        y: y
    };
}

});

parcelRegister("ggoOw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd716381ee60c49f$export$2e2bcd8739ae039; });

var $74CGk = parcelRequire("74CGk");

var $6NmcB = parcelRequire("6NmcB");

var $ioUza = parcelRequire("ioUza");

var $dI4Q8 = parcelRequire("dI4Q8");

var $6SHZD = parcelRequire("6SHZD");
function $bd716381ee60c49f$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $74CGk.default)(element);
    var winScroll = (0, $dI4Q8.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $6SHZD.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $6SHZD.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $ioUza.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $6NmcB.default)(body || html).direction === 'rtl') x += (0, $6SHZD.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("emjeY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7420b8c23844178$export$2e2bcd8739ae039; });

var $7HECO = parcelRequire("7HECO");
function $a7420b8c23844178$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $7HECO.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("jhSNt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0aa1c5df4a188e9$export$2e2bcd8739ae039; });
function $e0aa1c5df4a188e9$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("arCOq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79aa884f7348a8ca$export$2e2bcd8739ae039; });

var $gaqC8 = parcelRequire("gaqC8");
function $79aa884f7348a8ca$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $gaqC8.default)(), paddingObject);
}

});
parcelRegister("gaqC8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc523987432af8fa$export$2e2bcd8739ae039; });
function $bc523987432af8fa$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("iKqvW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da611709504de0e2$export$2e2bcd8739ae039; });
function $da611709504de0e2$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("bw3iH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86253e484dd04be1$export$2e2bcd8739ae039; });

var $iFCgR = parcelRequire("iFCgR");

var $hrOxP = parcelRequire("hrOxP");

var $7rvV0 = parcelRequire("7rvV0");

var $1lqsE = parcelRequire("1lqsE");
function $86253e484dd04be1$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $hrOxP.placements) : _options$allowedAutoP;
    var variation = (0, $iFCgR.default)(placement);
    var placements = variation ? flipVariations ? (0, $hrOxP.variationPlacements) : (0, $hrOxP.variationPlacements).filter(function(placement) {
        return (0, $iFCgR.default)(placement) === variation;
    }) : (0, $hrOxP.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $7rvV0.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $1lqsE.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("OI30W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0986d690bad5923d$export$2e2bcd8739ae039; });

var $hrOxP = parcelRequire("hrOxP");

var $1lqsE = parcelRequire("1lqsE");

var $1rznO = parcelRequire("1rznO");

var $bb4wq = parcelRequire("bb4wq");

var $2I0ZK = parcelRequire("2I0ZK");

var $hLC6U = parcelRequire("hLC6U");

var $4CII3 = parcelRequire("4CII3");

var $7rvV0 = parcelRequire("7rvV0");

var $iFCgR = parcelRequire("iFCgR");

var $gaqC8 = parcelRequire("gaqC8");

var $6SHZD = parcelRequire("6SHZD");
function $0986d690bad5923d$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $7rvV0.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $1lqsE.default)(state.placement);
    var variation = (0, $iFCgR.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $1rznO.default)(basePlacement);
    var altAxis = (0, $bb4wq.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $hrOxP.top) : (0, $hrOxP.left);
        var altSide = mainAxis === 'y' ? (0, $hrOxP.bottom) : (0, $hrOxP.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $hrOxP.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $hrOxP.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $hLC6U.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $gaqC8.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $2I0ZK.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $4CII3.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $2I0ZK.within)(tether ? (0, $6SHZD.min)(min, tetherMin) : min, offset, tether ? (0, $6SHZD.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $hrOxP.top) : (0, $hrOxP.left);
        var _altSide = mainAxis === 'x' ? (0, $hrOxP.bottom) : (0, $hrOxP.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $hrOxP.top),
            (0, $hrOxP.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $2I0ZK.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $2I0ZK.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $0986d690bad5923d$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $0986d690bad5923d$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("bb4wq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82343ac14d834b52$export$2e2bcd8739ae039; });
function $82343ac14d834b52$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("2I0ZK", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $1f90766b5072cdd9$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $1f90766b5072cdd9$export$86c8af6d3ef0b4a; });

var $6SHZD = parcelRequire("6SHZD");
function $1f90766b5072cdd9$export$f28d906d67a997f3(min, value, max) {
    return (0, $6SHZD.max)(min, (0, $6SHZD.min)(value, max));
}
function $1f90766b5072cdd9$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $1f90766b5072cdd9$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("fQ95C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b882c35cdd9ffb51$export$2e2bcd8739ae039; });

var $1lqsE = parcelRequire("1lqsE");

var $hLC6U = parcelRequire("hLC6U");

var $emjeY = parcelRequire("emjeY");

var $4CII3 = parcelRequire("4CII3");

var $1rznO = parcelRequire("1rznO");

var $2I0ZK = parcelRequire("2I0ZK");

var $arCOq = parcelRequire("arCOq");

var $iKqvW = parcelRequire("iKqvW");

var $hrOxP = parcelRequire("hrOxP");
var $b882c35cdd9ffb51$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $arCOq.default)(typeof padding !== 'number' ? padding : (0, $iKqvW.default)(padding, (0, $hrOxP.basePlacements)));
};
function $b882c35cdd9ffb51$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $1lqsE.default)(state.placement);
    var axis = (0, $1rznO.default)(basePlacement);
    var isVertical = [
        (0, $hrOxP.left),
        (0, $hrOxP.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $b882c35cdd9ffb51$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $hLC6U.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $hrOxP.top) : (0, $hrOxP.left);
    var maxProp = axis === 'y' ? (0, $hrOxP.bottom) : (0, $hrOxP.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $4CII3.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $2I0ZK.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $b882c35cdd9ffb51$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $emjeY.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $b882c35cdd9ffb51$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $b882c35cdd9ffb51$var$arrow,
    effect: $b882c35cdd9ffb51$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("amUyP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78c7d53ca7a035cf$export$2e2bcd8739ae039; });

var $hrOxP = parcelRequire("hrOxP");

var $7rvV0 = parcelRequire("7rvV0");
function $78c7d53ca7a035cf$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $78c7d53ca7a035cf$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $hrOxP.top),
        (0, $hrOxP.right),
        (0, $hrOxP.bottom),
        (0, $hrOxP.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $78c7d53ca7a035cf$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $7rvV0.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $7rvV0.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $78c7d53ca7a035cf$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $78c7d53ca7a035cf$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $78c7d53ca7a035cf$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $78c7d53ca7a035cf$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $78c7d53ca7a035cf$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $78c7d53ca7a035cf$var$hide
};

});


parcelRegister("hco6w", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $c8564145a7d4bede$var$hasElementType = typeof Element !== 'undefined';
var $c8564145a7d4bede$var$hasMap = typeof Map === 'function';
var $c8564145a7d4bede$var$hasSet = typeof Set === 'function';
var $c8564145a7d4bede$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $c8564145a7d4bede$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$c8564145a7d4bede$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($c8564145a7d4bede$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$c8564145a7d4bede$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($c8564145a7d4bede$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($c8564145a7d4bede$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($c8564145a7d4bede$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$c8564145a7d4bede$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $c8564145a7d4bede$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});



parcelRegister("9vpSS", function(module, exports) {

$parcel$export(module.exports, "getMaxSizeModifiers", function () { return $6ebb165987d41554$export$6d8c2b45c99d6e3f; });

var $5YM7L = parcelRequire("5YM7L");
function $6ebb165987d41554$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split('-'), _state$placement$spli2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}

});


parcelRegister("lLIDD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0416fa4637e385c1$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $f1k1y = parcelRequire("f1k1y");

var $2aHyB = parcelRequire("2aHyB");

var $ateTp = parcelRequire("ateTp");

var $6WlC5 = parcelRequire("6WlC5");

var $eDHbU = parcelRequire("eDHbU");
function $0416fa4637e385c1$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy;
    var isSubsequentRender = (0, $6WlC5.default)(mountStrategy);
    (0, $eDHbU.default)(zIndex);
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    return !(0, $f1k1y.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2aHyB.default), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $ateTp.default), {
        zIndex: zIndex
    }, children);
}

});
parcelRegister("2aHyB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $194e4d7ada76cc7b$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $eAqbf = parcelRequire("eAqbf");

var $evg9Q = parcelRequire("evg9Q");
function $194e4d7ada76cc7b$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $91i6m.useMemo)(function() {
        return (0, $evg9Q.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $evg9Q.appendPortalContainerIfNotAppended)(container);
    (0, $91i6m.useEffect)(function() {
        return function() {
            (0, $evg9Q.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $eAqbf.createPortal)(children, container);
}

});
parcelRegister("evg9Q", function(module, exports) {

$parcel$export(module.exports, "createContainer", function () { return $a8f07e89514fa1ac$export$26ae5ca175b4ec5a; });
$parcel$export(module.exports, "removePortalContainer", function () { return $a8f07e89514fa1ac$export$da99f98bf3fe55b3; });
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", function () { return $a8f07e89514fa1ac$export$c582005add11e141; });
$parcel$export(module.exports, "createAtlaskitPortal", function () { return $a8f07e89514fa1ac$export$fef014d7cef9e543; });
$parcel$export(module.exports, "createPortalParent", function () { return $a8f07e89514fa1ac$export$95029ca7aca2989e; });

var $hTSiP = parcelRequire("hTSiP");
var $a8f07e89514fa1ac$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $hTSiP.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $a8f07e89514fa1ac$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $a8f07e89514fa1ac$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $hTSiP.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $hTSiP.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = $a8f07e89514fa1ac$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $a8f07e89514fa1ac$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $a8f07e89514fa1ac$var$getPortalParent().removeChild(container);
};
var $a8f07e89514fa1ac$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $a8f07e89514fa1ac$var$getPortalParent().appendChild(container);
};
var $a8f07e89514fa1ac$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $a8f07e89514fa1ac$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($a8f07e89514fa1ac$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $hTSiP.portalClassName);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
};
var $a8f07e89514fa1ac$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($a8f07e89514fa1ac$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $hTSiP.portalParentSelector));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement('div');
            parent.className = (0, $hTSiP.portalParentClassName);
            parent.style.display = 'flex';
            (_getBody2 = $a8f07e89514fa1ac$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
};

});
parcelRegister("hTSiP", function(module, exports) {

$parcel$export(module.exports, "portalParentClassName", function () { return $d081b214f2ce4340$export$e4c79eb95c23a0da; });
$parcel$export(module.exports, "portalParentSelector", function () { return $d081b214f2ce4340$export$72f415121273627e; });
$parcel$export(module.exports, "portalClassName", function () { return $d081b214f2ce4340$export$13f57c02915787b3; });
var $d081b214f2ce4340$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $d081b214f2ce4340$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $d081b214f2ce4340$export$13f57c02915787b3 = 'atlaskit-portal';

});



parcelRegister("ateTp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79f82a3629253ba4$export$2e2bcd8739ae039; });

var $5YM7L = parcelRequire("5YM7L");

var $91i6m = parcelRequire("91i6m");

var $eAqbf = parcelRequire("eAqbf");

var $6f6r4 = parcelRequire("6f6r4");

var $evg9Q = parcelRequire("evg9Q");
function $79f82a3629253ba4$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $91i6m.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $6f6r4.useIsomorphicLayoutEffect)(function() {
        var tempPortalContainer = (0, $evg9Q.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $evg9Q.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $91i6m.Suspense), {
        fallback: null
    }, children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $eAqbf.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("6f6r4", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $48b922c81624a029$export$700979bc83e7db82; });

var $91i6m = parcelRequire("91i6m");
var $48b922c81624a029$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $91i6m.useLayoutEffect) : (0, $91i6m.useEffect);

});


parcelRegister("6WlC5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50d8ecd55242ca6f$export$2e2bcd8739ae039; });

var $5YM7L = parcelRequire("5YM7L");

var $91i6m = parcelRequire("91i6m");

var $6f6r4 = parcelRequire("6f6r4");
var $50d8ecd55242ca6f$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $91i6m.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $91i6m.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $6f6r4.useIsomorphicLayoutEffect) : (0, $91i6m.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $50d8ecd55242ca6f$export$2e2bcd8739ae039 = $50d8ecd55242ca6f$var$useIsSubsequentRender;

});

parcelRegister("eDHbU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa863609e31b6b98$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $22Y6I = parcelRequire("22Y6I");

var $8WYfG = parcelRequire("8WYfG");
var $aa863609e31b6b98$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $91i6m.useEffect)(function() {
        (0, $8WYfG.default)((0, $22Y6I.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $8WYfG.default)((0, $22Y6I.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $aa863609e31b6b98$export$2e2bcd8739ae039 = $aa863609e31b6b98$var$useFirePortalEvent;

});
parcelRegister("22Y6I", function(module, exports) {

$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", function () { return $17da64bf16074109$export$ed5835cc67e87f72; });
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", function () { return $17da64bf16074109$export$80816bd900e5bd00; });
var $17da64bf16074109$export$ed5835cc67e87f72 = 'akPortalMount';
var $17da64bf16074109$export$80816bd900e5bd00 = 'akPortalUnmount';

});

parcelRegister("8WYfG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68427a4d76483e98$export$2e2bcd8739ae039; });
var $68427a4d76483e98$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $68427a4d76483e98$var$getLayerName = function getLayerName(zIndex) {
    return $68427a4d76483e98$var$zIndexToName.hasOwnProperty(zIndex) ? $68427a4d76483e98$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $68427a4d76483e98$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $68427a4d76483e98$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $68427a4d76483e98$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $68427a4d76483e98$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("2v0hR", function(module, exports) {

$parcel$export(module.exports, "layers", function () { return $1d1eb3012d21a643$export$7be255094ccdc533; });

var $5RmjO = parcelRequire("5RmjO");

var $5ioBG = parcelRequire("5ioBG");
var $1d1eb3012d21a643$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $1d1eb3012d21a643$export$c93026a968943f95 = 'light';
var $1d1eb3012d21a643$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $1d1eb3012d21a643$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $1d1eb3012d21a643$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $5ioBG.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $1d1eb3012d21a643$export$6d8204c2cb2e06b8() / 4;
    (0, $5RmjO.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $1d1eb3012d21a643$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $1d1eb3012d21a643$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $1d1eb3012d21a643$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $5RmjO.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $1d1eb3012d21a643$export$ba1d834b86d72a09 = $1d1eb3012d21a643$export$a1b3edb637fb4f35;
var $1d1eb3012d21a643$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $5ioBG.N20A), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $5ioBG.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $5ioBG.N30A), ")")
            }
        }
    };
};

});
parcelRegister("5ioBG", function(module, exports) {

$parcel$export(module.exports, "B200", function () { return $3db1b895656018c2$export$215b7063051591f1; });
$parcel$export(module.exports, "N0", function () { return $3db1b895656018c2$export$29a4f05edc054374; });
$parcel$export(module.exports, "N800", function () { return $3db1b895656018c2$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $3db1b895656018c2$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $3db1b895656018c2$export$920c0d5c49070351; });
// Reds
var $3db1b895656018c2$export$4b84fd0e2c617bd = '#FFEBE6';
var $3db1b895656018c2$export$b34b069eff244586 = '#FFBDAD';
var $3db1b895656018c2$export$be802dd0d8b57f35 = '#FF8F73';
var $3db1b895656018c2$export$60847d42f9da92a6 = '#FF7452';
var $3db1b895656018c2$export$4a7404f376229999 = '#FF5630';
var $3db1b895656018c2$export$2010d0fb4295b346 = '#DE350B';
var $3db1b895656018c2$export$2837b5a1a71d5c02 = '#BF2600';
var $3db1b895656018c2$export$8d9596b529bbb9cf = '#FFFAE6';
var $3db1b895656018c2$export$41060a744ab0b7ae = '#FFF0B3';
var $3db1b895656018c2$export$1cc05bbbf340e559 = '#FFE380';
var $3db1b895656018c2$export$5aae31392d72caaa = '#FFC400';
var $3db1b895656018c2$export$c6930421db9fa514 = '#FFAB00';
var $3db1b895656018c2$export$59619663aa6500fb = '#FF991F';
var $3db1b895656018c2$export$874739ea9e379ab6 = '#FF8B00';
var $3db1b895656018c2$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $3db1b895656018c2$export$69a3bf21b9686c2b = '#ABF5D1';
var $3db1b895656018c2$export$afbce1382ec95f73 = '#79F2C0';
var $3db1b895656018c2$export$747d86715d4175de = '#57D9A3';
var $3db1b895656018c2$export$940e1f69e873f202 = '#36B37E';
var $3db1b895656018c2$export$a49394138f7b8e85 = '#00875A';
var $3db1b895656018c2$export$6fa04827ac68a4fb = '#006644';
var $3db1b895656018c2$export$226de0355ed012f8 = '#DEEBFF';
var $3db1b895656018c2$export$8c13c2ee36917869 = '#B3D4FF';
var $3db1b895656018c2$export$ecfc1dff386a3e7a = '#4C9AFF';
var $3db1b895656018c2$export$215b7063051591f1 = '#2684FF';
var $3db1b895656018c2$export$e62e8919cca44969 = '#0065FF';
var $3db1b895656018c2$export$b3de0ae08da2ce64 = '#0052CC';
var $3db1b895656018c2$export$a6ee3d71bc067634 = '#0747A6';
var $3db1b895656018c2$export$67f15409e87642a1 = '#669DF1';
var $3db1b895656018c2$export$f0539dbc42dbb067 = '#8FB8F6';
var $3db1b895656018c2$export$363e4475840015bb = '#EAE6FF';
var $3db1b895656018c2$export$4b0a4417ed59760f = '#C0B6F2';
var $3db1b895656018c2$export$6011520a64d9a187 = '#998DD9';
var $3db1b895656018c2$export$a7175d4e9206bc80 = '#8777D9';
var $3db1b895656018c2$export$b48405b95304b5a1 = '#6554C0';
var $3db1b895656018c2$export$c71e4279dd54a18d = '#5243AA';
var $3db1b895656018c2$export$147899de772240ec = '#403294';
var $3db1b895656018c2$export$2cf711fe14c66f06 = '#E6FCFF';
var $3db1b895656018c2$export$7a8f4d33f6f9772c = '#B3F5FF';
var $3db1b895656018c2$export$776c9c497ef08533 = '#79E2F2';
var $3db1b895656018c2$export$69cb3ca10c1e330e = '#00C7E6';
var $3db1b895656018c2$export$9dc1ef0f3f48059b = '#00B8D9';
var $3db1b895656018c2$export$7c835c78b6fcdef8 = '#00A3BF';
var $3db1b895656018c2$export$6036577f95c3877e = '#008DA6';
var $3db1b895656018c2$export$29a4f05edc054374 = '#FFFFFF';
var $3db1b895656018c2$export$e655ef011c4aa1a2 = '#FAFBFC';
var $3db1b895656018c2$export$9fdfb749e33cdf97 = '#F4F5F7';
var $3db1b895656018c2$export$3e51e8f1440314ba = '#EBECF0';
var $3db1b895656018c2$export$1ce2d1575d444ceb = '#DFE1E6';
var $3db1b895656018c2$export$8754fc7e6d8b3000 = '#C1C7D0';
var $3db1b895656018c2$export$c2e91cbeada39b8b = '#B3BAC5';
var $3db1b895656018c2$export$5f71e19f3a7ad9de = '#A5ADBA';
var $3db1b895656018c2$export$eaa8c8a70ac22806 = '#97A0AF';
var $3db1b895656018c2$export$7c87d337fb91a97d = '#8993A4';
var $3db1b895656018c2$export$d6447c357493214f = '#7A869A';
var $3db1b895656018c2$export$f563ee71e9ee74cd = '#6B778C';
var $3db1b895656018c2$export$e2ef2124cf4024b1 = '#5E6C84';
var $3db1b895656018c2$export$eece5f492e429f08 = '#505F79';
var $3db1b895656018c2$export$c39c0fe0f26207ae = '#42526E';
var $3db1b895656018c2$export$7090862dc3038a9f = '#344563';
var $3db1b895656018c2$export$ad0bacf983b7ddaa = '#253858';
var $3db1b895656018c2$export$7d61b15e0da132af = '#172B4D';
var $3db1b895656018c2$export$fbda843f0a27fe96 = '#091E42';
var $3db1b895656018c2$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $3db1b895656018c2$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $3db1b895656018c2$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $3db1b895656018c2$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $3db1b895656018c2$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $3db1b895656018c2$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $3db1b895656018c2$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $3db1b895656018c2$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $3db1b895656018c2$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $3db1b895656018c2$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $3db1b895656018c2$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $3db1b895656018c2$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $3db1b895656018c2$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $3db1b895656018c2$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $3db1b895656018c2$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $3db1b895656018c2$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $3db1b895656018c2$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $3db1b895656018c2$export$2f6319cf7d736c2a = '#E6EDFA';
var $3db1b895656018c2$export$95126bc8884d6634 = '#DCE5F5';
var $3db1b895656018c2$export$8338d8c35d44ff1 = '#CED9EB';
var $3db1b895656018c2$export$5368d76ae4fbbda7 = '#B8C7E0';
var $3db1b895656018c2$export$9f0a771d16ec8d36 = '#ABBBD6';
var $3db1b895656018c2$export$abcf8c38338b4aa5 = '#9FB0CC';
var $3db1b895656018c2$export$97e81faa16a182c7 = '#8C9CB8';
var $3db1b895656018c2$export$bfe21c59123ecf33 = '#7988A3';
var $3db1b895656018c2$export$ee82aa2ea6a1558 = '#67758F';
var $3db1b895656018c2$export$682927c6ed76be02 = '#56637A';
var $3db1b895656018c2$export$91fd9994c5be9757 = '#455166';
var $3db1b895656018c2$export$d281fbfe3cff2df6 = '#3B475C';
var $3db1b895656018c2$export$3902c91d8b98a753 = '#313D52';
var $3db1b895656018c2$export$8e8133c1ba5845b5 = '#283447';
var $3db1b895656018c2$export$33ff357f6620b39 = '#202B3D';
var $3db1b895656018c2$export$633847cf062b69e0 = '#1B2638';
var $3db1b895656018c2$export$9776a6e503bdbf76 = '#121A29';
var $3db1b895656018c2$export$6c813d5160dff5db = '#0E1624';
var $3db1b895656018c2$export$3d4f271a500072a = '#0D1424';
var $3db1b895656018c2$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $3db1b895656018c2$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $3db1b895656018c2$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $3db1b895656018c2$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $3db1b895656018c2$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $3db1b895656018c2$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $3db1b895656018c2$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $3db1b895656018c2$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $3db1b895656018c2$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $3db1b895656018c2$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $3db1b895656018c2$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $3db1b895656018c2$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $3db1b895656018c2$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $3db1b895656018c2$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $3db1b895656018c2$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $3db1b895656018c2$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $3db1b895656018c2$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $3db1b895656018c2$export$d2adc5dedf09fced = '#292A2E';
var $3db1b895656018c2$export$f51762073d2bb381 = '#94C748';
var $3db1b895656018c2$export$95e26d54def96891 = '#B3DF72';

});


parcelRegister("3mKzC", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $27378db06f5c3f95$export$6503ec6e8aabbaf; });
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $aA6j8 = parcelRequire("aA6j8");
var $27378db06f5c3f95$var$registrations = new Set();
var $27378db06f5c3f95$var$cleanupEndEventListeners = null;
function $27378db06f5c3f95$var$onDragStart() {
    if ($27378db06f5c3f95$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $27378db06f5c3f95$var$cleanupEndEventListeners = (0, $aA6j8.bindAll)(window, [
        {
            type: 'dragend',
            listener: $27378db06f5c3f95$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $27378db06f5c3f95$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $27378db06f5c3f95$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($27378db06f5c3f95$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $27378db06f5c3f95$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $27378db06f5c3f95$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $27378db06f5c3f95$var$cleanupEndEventListeners = null;
    var clone = Array.from($27378db06f5c3f95$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $27378db06f5c3f95$var$bindStartEvents() {
    return (0, $aA6j8.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $27378db06f5c3f95$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $27378db06f5c3f95$var$onDragStart
        }
    ]);
}
var $27378db06f5c3f95$var$cleanupStartEventListeners = null;
function $27378db06f5c3f95$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$27378db06f5c3f95$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $27378db06f5c3f95$var$cleanupStartEventListeners = $27378db06f5c3f95$var$bindStartEvents();
    $27378db06f5c3f95$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $27378db06f5c3f95$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $27378db06f5c3f95$var$registrations.delete(registration);
        if ($27378db06f5c3f95$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $27378db06f5c3f95$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $27378db06f5c3f95$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("kNWHq", function(module, exports) {

$parcel$export(module.exports, "show", function () { return $f255eab6fb748286$export$57bf213be019eeb0; });

var $hYYH8 = parcelRequire("hYYH8");
// This file is a singleton for managing tooltips
var $f255eab6fb748286$var$active = null;
function $f255eab6fb748286$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($f255eab6fb748286$var$active && $f255eab6fb748286$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $hYYH8.clearScheduled)();
            $f255eab6fb748286$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $hYYH8.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $hYYH8.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $hYYH8.scheduleTimeout)(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($f255eab6fb748286$var$active && $f255eab6fb748286$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($f255eab6fb748286$var$active) {
            (0, $hYYH8.clearScheduled)();
            $f255eab6fb748286$var$active.entry.hide({
                isImmediate: true
            });
            $f255eab6fb748286$var$active.entry.done();
            $f255eab6fb748286$var$active = null;
        }
        // this tooltip is now the active tooltip
        $f255eab6fb748286$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $hYYH8.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("hYYH8", function(module, exports) {

$parcel$export(module.exports, "clearScheduled", function () { return $d1771efb1fbfe83d$export$eaf678f6f93f5250; });
$parcel$export(module.exports, "scheduleTimeout", function () { return $d1771efb1fbfe83d$export$5f4d6617421d489b; });
var $d1771efb1fbfe83d$var$delayId = null;
function $d1771efb1fbfe83d$export$eaf678f6f93f5250() {
    if ($d1771efb1fbfe83d$var$delayId != null) {
        window.clearTimeout($d1771efb1fbfe83d$var$delayId);
        $d1771efb1fbfe83d$var$delayId = null;
    }
}
function $d1771efb1fbfe83d$export$5f4d6617421d489b(fn, delay) {
    $d1771efb1fbfe83d$export$eaf678f6f93f5250();
    $d1771efb1fbfe83d$var$delayId = window.setTimeout(function() {
        $d1771efb1fbfe83d$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("3Ksyi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2babd0d632bf3e35$export$2e2bcd8739ae039; });

var $lD6mB = parcelRequire("lD6mB");
function $2babd0d632bf3e35$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $lD6mB.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});
parcelRegister("lD6mB", function(module, exports) {

$parcel$export(module.exports, "useId", function () { return $fbf22d29360a56b0$export$f680877a34711e37; });
$parcel$export(module.exports, "useIdSeed", function () { return $fbf22d29360a56b0$export$6ee17796e3d70de2; });

var $61RDg = parcelRequire("61RDg");

var $91i6m = parcelRequire("91i6m");

var $aTAfv = parcelRequire("aTAfv");

var $f1k1y = parcelRequire("f1k1y");
var $fbf22d29360a56b0$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $fbf22d29360a56b0$var$react18UseId = ($fbf22d29360a56b0$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).useId) !== null && $fbf22d29360a56b0$var$_React$useId !== void 0 ? $fbf22d29360a56b0$var$_React$useId : undefined;
function $fbf22d29360a56b0$export$f680877a34711e37() {
    if ($fbf22d29360a56b0$var$react18UseId && (0, $f1k1y.fg)('platform-dst-react-18-use-id')) return $fbf22d29360a56b0$var$react18UseId();
    return "uid".concat((0, $aTAfv.useUID)());
}
var $fbf22d29360a56b0$export$6be90bcb437e928f = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($fbf22d29360a56b0$export$f680877a34711e37()).concat(postfix);
    (0, $91i6m.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $fbf22d29360a56b0$export$6ee17796e3d70de2() {
    if ($fbf22d29360a56b0$var$react18UseId && (0, $f1k1y.fg)('platform-dst-react-18-use-id')) {
        var uid = $fbf22d29360a56b0$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $aTAfv.useUIDSeed)();
}

});
parcelRegister("aTAfv", function(module, exports) {

$parcel$export(module.exports, "useUID", function () { return $7eeb28c052954e83$export$87d05f07e65211f1; });
$parcel$export(module.exports, "useUIDSeed", function () { return $7eeb28c052954e83$export$bb5ca5fba6fb4f1f; });

var $91i6m = parcelRequire("91i6m");

var $kV8TC = parcelRequire("kV8TC");
var $7eeb28c052954e83$var$generateUID = function(context) {
    var quartz = context || (0, $kV8TC.counter);
    var prefix = (0, $kV8TC.getPrefix)(quartz);
    var id = (0, $kV8TC.getId)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $7eeb28c052954e83$var$useUIDState = function() {
    var context = (0, $91i6m.useContext)((0, $kV8TC.source));
    var uid = (0, $91i6m.useState)(function() {
        return $7eeb28c052954e83$var$generateUID(context);
    })[0];
    return uid;
};
var $7eeb28c052954e83$export$87d05f07e65211f1 = function() {
    var uid = $7eeb28c052954e83$var$useUIDState().uid;
    return uid;
};
var $7eeb28c052954e83$export$bb5ca5fba6fb4f1f = function() {
    var gen = $7eeb28c052954e83$var$useUIDState().gen;
    return gen;
};

});
parcelRegister("kV8TC", function(module, exports) {

$parcel$export(module.exports, "counter", function () { return $f3b0081445314065$export$e575061ef2a070eb; });
$parcel$export(module.exports, "source", function () { return $f3b0081445314065$export$b4d5da5f34fb77ad; });
$parcel$export(module.exports, "getId", function () { return $f3b0081445314065$export$218c8c3169c024d2; });
$parcel$export(module.exports, "getPrefix", function () { return $f3b0081445314065$export$36e24695f02d4503; });

var $91i6m = parcelRequire("91i6m");

var $3Bnk9 = parcelRequire("3Bnk9");
var $f3b0081445314065$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = '';
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $3Bnk9.generateUID)()
    };
};
var $f3b0081445314065$export$e575061ef2a070eb = $f3b0081445314065$export$1921362e86c73c88();
var $f3b0081445314065$export$b4d5da5f34fb77ad = $91i6m.createContext($f3b0081445314065$export$1921362e86c73c88());
var $f3b0081445314065$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $f3b0081445314065$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : '';
};

});
parcelRegister("3Bnk9", function(module, exports) {

$parcel$export(module.exports, "generateUID", function () { return $29f6eb70a447357d$export$bdbb4cbb3078e58d; });
$parcel$export(module.exports, "uid", function () { return $29f6eb70a447357d$export$e2a22331486dcca0; });
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ var $29f6eb70a447357d$export$bdbb4cbb3078e58d = function() {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */ var uid = function(item, index) {
        if (typeof item === 'number' || typeof item === 'string') return index ? "idx-".concat(index) : "val-".concat(item);
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return 'uid' + map.get(item);
    };
    return uid;
};
var $29f6eb70a447357d$export$e2a22331486dcca0 = $29f6eb70a447357d$export$bdbb4cbb3078e58d();

});





parcelRegister("593ND", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bf0bd8819931445$export$2e2bcd8739ae039; });
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");
var $5oJNc = parcelRequire("5oJNc");

var $5ioBG = parcelRequire("5ioBG");

var $dVb8r = parcelRequire("dVb8r");
function $3bf0bd8819931445$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3bf0bd8819931445$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3bf0bd8819931445$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3bf0bd8819931445$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3bf0bd8819931445$var$baseStyles = null;
var $3bf0bd8819931445$var$truncateStyles = null;
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $3bf0bd8819931445$var$TooltipContainer = /*#__PURE__*/ (0, $91i6m.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return /*#__PURE__*/ $91i6m.createElement((0, $dVb8r.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9gzWK.default)([
            "_2rkofajl _11c8dcr7 _vchhusvi _p12fp3fh _bfhkpioe _syaz1i9p _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna",
            truncate && "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c",
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        style: $3bf0bd8819931445$var$_objectSpread($3bf0bd8819931445$var$_objectSpread({}, style), {}, {
            "--_yr7xfv": (0, $5oJNc.default)("var(--ds-background-neutral-bold, ".concat((0, $5ioBG.N800), ")")),
            "--_ywovvi": (0, $5oJNc.default)("var(--ds-text-inverse, ".concat((0, $5ioBG.N0), ")"))
        })
    }, children);
});
$3bf0bd8819931445$var$TooltipContainer.displayName = 'TooltipContainer';
var $3bf0bd8819931445$export$2e2bcd8739ae039 = $3bf0bd8819931445$var$TooltipContainer;

});
parcelRegister("dVb8r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2293c70119ebe90$export$2e2bcd8739ae039; });
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");
var $a2293c70119ebe90$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $a2293c70119ebe90$var$TooltipPrimitive = /*#__PURE__*/ (0, $91i6m.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return /*#__PURE__*/ $91i6m.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $91i6m.createElement("div", {
        role: "tooltip",
        className: (0, $9gzWK.default)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$a2293c70119ebe90$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $a2293c70119ebe90$export$2e2bcd8739ae039 = $a2293c70119ebe90$var$TooltipPrimitive;

});


parcelRegister("jPYSb", function(module, exports) {

$parcel$export(module.exports, "getMousePosition", function () { return $e711ffd9463d5528$export$642213d516a9b928; });
function $e711ffd9463d5528$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("kKNUG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1bed24732dde29e$export$2e2bcd8739ae039; });
/* pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");


var $8kGa4 = parcelRequire("8kGa4");

var $koa2c = parcelRequire("koa2c");

var $kgCwg = parcelRequire("kgCwg");

var $6A0cm = parcelRequire("6A0cm");

var $7xei2 = parcelRequire("7xei2");

var $iFRl4 = parcelRequire("iFRl4");
var $f1bed24732dde29e$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $f1bed24732dde29e$var$_excluded2 = [
    "className"
];
var $f1bed24732dde29e$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $f1bed24732dde29e$var$Pressable = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $6A0cm.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $f1bed24732dde29e$var$_excluded);
    var interactionContext = (0, $91i6m.useContext)((0, $7xei2.default));
    var handleClick = (0, $91i6m.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $koa2c.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "0.0.0-development",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(htmlAttributes, $f1bed24732dde29e$var$_excluded2);
    return /*#__PURE__*/ $91i6m.createElement((0, $iFRl4.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $kgCwg.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $8kGa4.cx)($f1bed24732dde29e$var$styles.root, isDisabled && $f1bed24732dde29e$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $f1bed24732dde29e$export$2e2bcd8739ae039 = $f1bed24732dde29e$var$Pressable;

});
parcelRegister("kgCwg", function(module, exports) {

$parcel$export(module.exports, "isSafari", function () { return $ec132e6cc5f293d4$export$95df08bae54cb4df; });
$parcel$export(module.exports, "isAppleDevice", function () { return $ec132e6cc5f293d4$export$e1865c3bedcd822b; });
function $ec132e6cc5f293d4$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== 'undefined' && window.navigator != null ? //@ts-expect-error ignore userAgentData type issue
    re.test(((_window$navigator$use = window.navigator['userAgentData']) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $ec132e6cc5f293d4$var$isIPhone() {
    return $ec132e6cc5f293d4$var$testPlatform(/^iPhone/i);
}
function $ec132e6cc5f293d4$var$isMac() {
    return $ec132e6cc5f293d4$var$testPlatform(/^Mac/i);
}
function $ec132e6cc5f293d4$var$isIPad() {
    return $ec132e6cc5f293d4$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $ec132e6cc5f293d4$var$isMac() && navigator.maxTouchPoints > 1;
}
function $ec132e6cc5f293d4$var$isIOS() {
    return $ec132e6cc5f293d4$var$isIPhone() || $ec132e6cc5f293d4$var$isIPad();
}
function $ec132e6cc5f293d4$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        var _window$navigator$use2;
        var ua = (_window$navigator$use2 = window.navigator.userAgent) === null || _window$navigator$use2 === void 0 ? void 0 : _window$navigator$use2.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}
function $ec132e6cc5f293d4$export$e1865c3bedcd822b() {
    return $ec132e6cc5f293d4$var$isMac() || $ec132e6cc5f293d4$var$isIOS();
}

});

parcelRegister("7xei2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57c6b32cd897d069$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");
var $57c6b32cd897d069$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $91i6m.createContext)(null);

});

parcelRegister("iFRl4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9856e55411e5eec$export$2e2bcd8739ae039; });
/* focusable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $dsN6L = parcelRequire("dsN6L");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");
var $5oJNc = parcelRequire("5oJNc");
var $d9856e55411e5eec$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $d9856e55411e5eec$var$_excluded2 = [
    "className"
];
function $d9856e55411e5eec$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d9856e55411e5eec$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d9856e55411e5eec$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d9856e55411e5eec$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d9856e55411e5eec$var$focusRingStyles = null;
var $d9856e55411e5eec$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $d9856e55411e5eec$var$Focusable = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $d9856e55411e5eec$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(htmlAttributes, $d9856e55411e5eec$var$_excluded2);
    return /*#__PURE__*/ $91i6m.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $9gzWK.default)([
            "_mizu194a _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y",
            isInset && "_1ah3115h _2mwq115h",
            xcss
        ]),
        "data-testid": testId,
        style: $d9856e55411e5eec$var$_objectSpread($d9856e55411e5eec$var$_objectSpread({}, style), {}, {
            "--_1203r2w": (0, $5oJNc.default)("calc(0px - ".concat("var(--ds-border-width-outline, 2px)", ")"))
        })
    }), children);
});
var $d9856e55411e5eec$export$2e2bcd8739ae039 = $d9856e55411e5eec$var$Focusable;

});


parcelRegister("i12Lt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d1da76fd1f024307$var$_react = $d1da76fd1f024307$var$_interopRequireDefault((parcelRequire("91i6m")));

var $d1da76fd1f024307$var$_baseNew = $d1da76fd1f024307$var$_interopRequireDefault((parcelRequire("5Ooif")));
function $d1da76fd1f024307$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d1da76fd1f024307$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $d1da76fd1f024307$var$_react.default.createElement($d1da76fd1f024307$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$d1da76fd1f024307$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $d1da76fd1f024307$var$_default = module.exports.default = $d1da76fd1f024307$var$ChevronDownIcon;

});

parcelRegister("izB6f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d8584618c0f5ed85$var$_react = $d8584618c0f5ed85$var$_interopRequireDefault((parcelRequire("91i6m")));

var $3UDdx = parcelRequire("3UDdx");
function $d8584618c0f5ed85$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d8584618c0f5ed85$var$HipchatChevronDownIcon = (props)=>/*#__PURE__*/ $d8584618c0f5ed85$var$_react.default.createElement($3UDdx.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.744 8.744a1.053 1.053 0 0 0 0 1.49l4.547 4.557a1 1 0 0 0 1.416 0l4.55-4.558a1.051 1.051 0 1 0-1.488-1.488l-3.77 3.776-3.768-3.776a1.05 1.05 0 0 0-1.487 0"/></svg>`
    }, props));
$d8584618c0f5ed85$var$HipchatChevronDownIcon.displayName = 'HipchatChevronDownIcon';
var $d8584618c0f5ed85$var$_default = module.exports.default = $d8584618c0f5ed85$var$HipchatChevronDownIcon;

});

parcelRegister("6uAkD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b6f832dcdc2d7a1f91afd5e9b90e10b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4ba1ba26a7894232$var$_react = $4ba1ba26a7894232$var$_interopRequireDefault((parcelRequire("91i6m")));

var $4ba1ba26a7894232$var$_baseNew = $4ba1ba26a7894232$var$_interopRequireDefault((parcelRequire("5Ooif")));
function $4ba1ba26a7894232$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4ba1ba26a7894232$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $4ba1ba26a7894232$var$_react.default.createElement($4ba1ba26a7894232$var$_baseNew.default, Object.assign({
        name: "ChevronUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 9.97-6-6a.75.75 0 0 0-1.004-.052l-.056.052-6 6 1.06 1.06L8 5.56l5.47 5.47z"/>`
    }, props));
$4ba1ba26a7894232$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $4ba1ba26a7894232$var$_default = module.exports.default = $4ba1ba26a7894232$var$ChevronUpIcon;

});

parcelRegister("alZnA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $789b7a38144f06b1$var$_react = $789b7a38144f06b1$var$_interopRequireDefault((parcelRequire("91i6m")));

var $3UDdx = parcelRequire("3UDdx");
function $789b7a38144f06b1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $789b7a38144f06b1$var$HipchatChevronUpIcon = (props)=>/*#__PURE__*/ $789b7a38144f06b1$var$_react.default.createElement($3UDdx.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.294 8.708-4.549 4.559a1.051 1.051 0 1 0 1.486 1.488l.001-.001 3.77-3.776 3.768 3.776a1.05 1.05 0 0 0 1.486.001h.001a1.054 1.054 0 0 0 .001-1.489L12.71 8.708a1 1 0 0 0-1.415-.001"/></svg>`
    }, props));
$789b7a38144f06b1$var$HipchatChevronUpIcon.displayName = 'HipchatChevronUpIcon';
var $789b7a38144f06b1$var$_default = module.exports.default = $789b7a38144f06b1$var$HipchatChevronUpIcon;

});

parcelRegister("2sg3K", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1c9aa7612261a804$var$_react = $1c9aa7612261a804$var$_interopRequireDefault((parcelRequire("91i6m")));

var $1c9aa7612261a804$var$_baseNew = $1c9aa7612261a804$var$_interopRequireDefault((parcelRequire("5Ooif")));
function $1c9aa7612261a804$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1c9aa7612261a804$var$CrossIcon = (props)=>/*#__PURE__*/ $1c9aa7612261a804$var$_react.default.createElement($1c9aa7612261a804$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$1c9aa7612261a804$var$CrossIcon.displayName = 'CrossIcon';
var $1c9aa7612261a804$var$_default = module.exports.default = $1c9aa7612261a804$var$CrossIcon;

});

parcelRegister("l1DJt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f4e882fdbeb0584d$var$_react = $f4e882fdbeb0584d$var$_interopRequireDefault((parcelRequire("91i6m")));

var $3UDdx = parcelRequire("3UDdx");
function $f4e882fdbeb0584d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f4e882fdbeb0584d$var$CrossIcon = (props)=>/*#__PURE__*/ $f4e882fdbeb0584d$var$_react.default.createElement($3UDdx.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props));
$f4e882fdbeb0584d$var$CrossIcon.displayName = 'CrossIcon';
var $f4e882fdbeb0584d$var$_default = module.exports.default = $f4e882fdbeb0584d$var$CrossIcon;

});

parcelRegister("gJR35", function(module, exports) {

$parcel$export(module.exports, "IconFacade", function () { return $c2f9ffb36770a5db$export$3cfb73f70dfca966; });

var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $f1k1y = parcelRequire("f1k1y");

var $6crSb = parcelRequire("6crSb");
var $c2f9ffb36770a5db$var$_excluded = [
    "dangerouslySetGlyph",
    "size"
];
var $c2f9ffb36770a5db$var$sizeSpacingMap = {
    utility: {
        small: 'compact',
        medium: 'spacious'
    },
    core: {
        small: 'none',
        medium: 'spacious'
    }
};
var $c2f9ffb36770a5db$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $91i6m.memo)(function IconFacade(_ref) {
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, size = _ref.size, props = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $c2f9ffb36770a5db$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var iconSize = size !== null && size !== void 0 ? size : 'medium';
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $f1k1y.fg)('platform-visual-refresh-icons-legacy-facade');
    if (useNewIcon && NewIcon && (iconSize === 'small' || iconSize === 'medium') && !(0, $f1k1y.fg)('platform-visual-refresh-icons-facade-removal')) {
        if (props.iconType === 'utility') {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, props, {
                spacing: (0, $f1k1y.fg)('platform-visual-refresh-icons-facade-button-fix') ? $c2f9ffb36770a5db$var$sizeSpacingMap['utility'][iconSize] : 'none',
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, props, {
                size: iconSize,
                spacing: $c2f9ffb36770a5db$var$sizeSpacingMap['core'][iconSize],
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6crSb.Icon), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        dangerouslySetGlyph: dangerouslySetGlyph,
        size: size
    }, props));
});

});
parcelRegister("6crSb", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $48397c10abe52212$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");
function $48397c10abe52212$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $48397c10abe52212$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $48397c10abe52212$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $48397c10abe52212$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $48397c10abe52212$var$iconStyles = null;
var $48397c10abe52212$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $48397c10abe52212$var$baseHcmStyles = null;
var $48397c10abe52212$var$primaryEqualsSecondaryHcmStyles = null;
var $48397c10abe52212$var$secondaryTransparentHcmStyles = null;
var $48397c10abe52212$export$f04a61298a47a40f = /*#__PURE__*/ (0, $91i6m.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $91i6m.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $91i6m.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $48397c10abe52212$var$_objectSpread($48397c10abe52212$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $9gzWK.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $48397c10abe52212$var$sizeStyles[size]
        ])
    }));
});
var $48397c10abe52212$export$2e2bcd8739ae039 = $48397c10abe52212$export$f04a61298a47a40f;

});


parcelRegister("iMj1N", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8cc756abdbbefcea85e2842ee2eda39e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dabb783db4368a22$var$_react = $dabb783db4368a22$var$_interopRequireDefault((parcelRequire("91i6m")));

var $dabb783db4368a22$var$_baseNew = $dabb783db4368a22$var$_interopRequireDefault((parcelRequire("hVDwR")));
function $dabb783db4368a22$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dabb783db4368a22$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $dabb783db4368a22$var$_react.default.createElement($dabb783db4368a22$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$dabb783db4368a22$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $dabb783db4368a22$var$_default = module.exports.default = $dabb783db4368a22$var$StatusSuccessIcon;

});
parcelRegister("hVDwR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("1UcNO")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("1UcNO")).Icon; });

var $1UcNO = parcelRequire("1UcNO");

});
parcelRegister("1UcNO", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $1634f3b21bb6af6b$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $1634f3b21bb6af6b$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $f1k1y = parcelRequire("f1k1y");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $1634f3b21bb6af6b$var$svgStyles = null;
var $1634f3b21bb6af6b$var$iconStyles = null;
var $1634f3b21bb6af6b$var$utilityIconStyles = null;
var $1634f3b21bb6af6b$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $1634f3b21bb6af6b$var$baseHcmStyles = null;
var $1634f3b21bb6af6b$var$scaleSize = null;
var $1634f3b21bb6af6b$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $1634f3b21bb6af6b$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $1634f3b21bb6af6b$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $1634f3b21bb6af6b$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $1634f3b21bb6af6b$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $1634f3b21bb6af6b$export$f04a61298a47a40f = /*#__PURE__*/ (0, $91i6m.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $f1k1y.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $91i6m.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'size' in props && props.size !== undefined && // This prevents invalid sizes being passed in, which is required
    // for handling unsupported legacy icon sizes which can
    // cause errors.
    (props.size === 'small' || props.size === 'medium') ? props.size : 'medium';
    var baseSize = $1634f3b21bb6af6b$var$baseSizeMap[type];
    var viewBoxPadding = $1634f3b21bb6af6b$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $91i6m.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $9gzWK.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $91i6m.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $9gzWK.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $1634f3b21bb6af6b$var$utilSizes[spacing] : size === 'small' ? $1634f3b21bb6af6b$var$coreSizeSmall[spacing] : $1634f3b21bb6af6b$var$coreSizeMedium[spacing]
        ])
    }));
});
var $1634f3b21bb6af6b$export$2e2bcd8739ae039 = $1634f3b21bb6af6b$export$f04a61298a47a40f;

});



parcelRegister("daZRO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $997c33000cdfb9e3$var$_react = $997c33000cdfb9e3$var$_interopRequireDefault((parcelRequire("91i6m")));

var $gJR35 = parcelRequire("gJR35");

var $997c33000cdfb9e3$var$_statusError = $997c33000cdfb9e3$var$_interopRequireDefault((parcelRequire("7kLsW")));
function $997c33000cdfb9e3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $997c33000cdfb9e3$var$ErrorIcon = (props)=>/*#__PURE__*/ $997c33000cdfb9e3$var$_react.default.createElement($gJR35.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $997c33000cdfb9e3$var$_statusError.default
    }));
$997c33000cdfb9e3$var$ErrorIcon.displayName = 'ErrorIcon';
var $997c33000cdfb9e3$var$_default = module.exports.default = $997c33000cdfb9e3$var$ErrorIcon;

});
parcelRegister("7kLsW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f99ea99a006a4f29d6a537b27790dcf5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $556f38654381fee9$var$_react = $556f38654381fee9$var$_interopRequireDefault((parcelRequire("91i6m")));

var $556f38654381fee9$var$_baseNew = $556f38654381fee9$var$_interopRequireDefault((parcelRequire("hVDwR")));
function $556f38654381fee9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $556f38654381fee9$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $556f38654381fee9$var$_react.default.createElement($556f38654381fee9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$556f38654381fee9$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $556f38654381fee9$var$_default = module.exports.default = $556f38654381fee9$var$StatusErrorIcon;

});


parcelRegister("1w7tl", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("jjKyj")).then(()=>parcelRequire('gIkZ4'));

});

parcelRegister("4Dyka", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("4Od2P")).then(()=>parcelRequire('ljzG9'));

});

parcelRegister("69a4G", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("6GsoP")).then(()=>parcelRequire('p1UY9'));

});

parcelRegister("ayilx", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("hOtWz")).then(()=>parcelRequire('dWyK3'));

});

parcelRegister("aongO", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("6zPtE")).then(()=>parcelRequire('iAqDU'));

});

parcelRegister("6tdoU", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("kjrCT")).then(()=>parcelRequire('401YU'));

});

parcelRegister("3AaCt", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("2k6cw")).then(()=>parcelRequire('gP4kF'));

});

parcelRegister("lCTBC", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("fcIvx")).then(()=>parcelRequire('3HOfK'));

});

parcelRegister("lpGG9", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("aYVrY")).then(()=>parcelRequire('5Ijq4'));

});

parcelRegister("lIPHR", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("fk09M")),
    (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("iBeAy"))
]).then(()=>parcelRequire('l6Lk6'));

});

parcelRegister("5lb7m", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("bKaGI")),
    (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("fk09M")),
    (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("4l69b"))
]).then(()=>parcelRequire('4sWR4'));

});

parcelRegister("kyHV0", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("bKaGI")),
    (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("fk09M")),
    (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("700Vk"))
]).then(()=>parcelRequire('gLG9Y'));

});

parcelRegister("37tZR", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("bKaGI")),
    (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("fk09M")),
    (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("7MHFe"))
]).then(()=>parcelRequire('3ENuR'));

});

parcelRegister("kiZXb", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("b2oJM")),
    (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("bKaGI")),
    (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("fk09M")),
    (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("c061K"))
]).then(()=>parcelRequire('jRXoM'));

});

parcelRegister("9IAq0", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("c5VS0")).then(()=>parcelRequire('g3q1t'));

});

parcelRegister("DNJiT", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("b2oJM")),
    (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("cSrTL"))
]).then(()=>parcelRequire('cmzIi'));

});

parcelRegister("fT5Rq", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("fS7F0")).then(()=>parcelRequire('5WSiB'));

});

parcelRegister("I1or5", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("9xeQ7")).then(()=>parcelRequire('5l444'));

});

parcelRegister("79zf9", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("56hY4")).then(()=>parcelRequire('5tqIs'));

});

parcelRegister("jY94H", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("6UVE8")).then(()=>parcelRequire('amnsQ'));

});

parcelRegister("etMyF", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("l6SzY")).then(()=>parcelRequire('24TL8'));

});

parcelRegister("dGsLk", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("ixNGA")).then(()=>parcelRequire('cnB5G'));

});

parcelRegister("lTL6l", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("lcNgi")).then(()=>parcelRequire('5hLCD'));

});

parcelRegister("eONel", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("bcSXn")),
    (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("8sx8b")),
    (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("eFcy5"))
]).then(()=>parcelRequire('iUJE2'));

});

parcelRegister("5e2bj", function(module, exports) {

$parcel$export(module.exports, "useGlobalPageState", function () { return $f871ec21d9a1458a$export$c0c5e20150fdb34a; });
$parcel$export(module.exports, "fetchFast5GlobalPageState", function () { return $f871ec21d9a1458a$export$ad35c91c010f31a8; });
$parcel$export(module.exports, "isRedirect", function () { return $f871ec21d9a1458a$export$4cb830d4f7e56898; });
$parcel$export(module.exports, "fetchPageState", function () { return $f871ec21d9a1458a$export$8d3833b13cc689f5; });
$parcel$export(module.exports, "usePageStateLoader", function () { return $f871ec21d9a1458a$export$b176e7ce17921f38; });

var $2aGBJ = parcelRequire("2aGBJ");

var $gCn4g = parcelRequire("gCn4g");

var $l2v8Y = parcelRequire("l2v8Y");parcelRequire("6d87w");
var $l2v8Y = parcelRequire("l2v8Y");

var $lodUs = parcelRequire("lodUs");

var $91i6m = parcelRequire("91i6m");

var $6cMFi = parcelRequire("6cMFi");

var $4b8M8 = parcelRequire("4b8M8");

var $49Pnv = parcelRequire("49Pnv");

var $5mKzS = parcelRequire("5mKzS");

var $gz8Vs = parcelRequire("gz8Vs");

var $3f4xr = parcelRequire("3f4xr");

var $kpg9c = parcelRequire("kpg9c");

var $9uXJ3 = parcelRequire("9uXJ3");

var $buHgC = parcelRequire("buHgC");
const $f871ec21d9a1458a$var$SAS_FAST_FIVE_FETCH_HEADER = 'sas-fast-five-fetch';
const $f871ec21d9a1458a$var$EXCLUDED_PATHS = {
    existingSasMilestone2StateRoutes: [
        '/login',
        '/signup/welcome',
        '/signup/verify-email/otp/'
    ],
    previousReduxStore: [
        '/2step/enrollment/',
        '/signup/welcome/p/loom-create-workspace'
    ]
};
const $f871ec21d9a1458a$export$c0c5e20150fdb34a = ()=>{
    const location = (0, $l2v8Y.useLocation)();
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    (0, $91i6m.useEffect)(()=>{
        const fetchData = async ()=>{
            if (await (0, $3f4xr.checkFeatureGateOnceInitialized)((0, $kpg9c.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return;
            // For non-bifrost pages (i.e. injected state from sign-in-service), use the existing non-sas
            // behaviour. This could mean we may have old injected state which doesn't get
            // refreshed from here on page navigation, but that matches existing behaviour
            const hasInjectedServerState = !(0, $6cMFi.default)();
            if (hasInjectedServerState) return;
            const alreadyFetchesStateSpecificToRoute = (0, $gz8Vs.isSasStateEndpointEnabled)() && $f871ec21d9a1458a$var$EXCLUDED_PATHS.existingSasMilestone2StateRoutes.some((path)=>location.pathname === path);
            const requiresStateFromPreviousReduxStore = $f871ec21d9a1458a$var$EXCLUDED_PATHS.previousReduxStore.some((path)=>location.pathname.startsWith(path));
            if (requiresStateFromPreviousReduxStore || alreadyFetchesStateSpecificToRoute) return;
            dispatch({
                type: 'SET_GLOBAL_STATE_LOADING',
                isLoading: true
            });
            try {
                const url = location.pathname + location.search;
                const data = await $f871ec21d9a1458a$export$ad35c91c010f31a8(url);
                if ($f871ec21d9a1458a$export$4cb830d4f7e56898(data)) {
                    navigate(data.redirectTo);
                    return;
                }
                const fullState = await (0, $lodUs.buildInitialState)(data);
                dispatch((0, $gCn4g.resetAppState)(fullState.initialStoreState));
            } catch (error) {
                let errorType = {
                    type: 'internal_server_error'
                };
                if (error instanceof (0, $4b8M8.ServerErrorException)) {
                    errorType = error.errorType;
                    (0, $49Pnv.captureErrorMessage)(`Failed to load AppState in Bifrost: ${error.message}`);
                } else (0, $49Pnv.captureErrorMessage)(`Unexpected error while loading AppState in Bifrost: ${error}`);
                dispatch((0, $5mKzS.setServerError)(errorType));
            }
            dispatch({
                type: 'SET_GLOBAL_STATE_LOADING',
                isLoading: false
            });
        };
        fetchData();
    // re-fetch whenever we change page, i.e. the fixed route
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        location.pathname
    ]);
};
const $f871ec21d9a1458a$export$4cb830d4f7e56898 = (data)=>Boolean(data && 'redirectTo' in data);
const $f871ec21d9a1458a$export$ad35c91c010f31a8 = async (fullPageUrl)=>{
    const headers = {
        [$f871ec21d9a1458a$var$SAS_FAST_FIVE_FETCH_HEADER]: 'true'
    };
    const response = await (0, $4b8M8.fetchApi)(fullPageUrl, headers);
    const data = await response.json();
    return data;
};
const $f871ec21d9a1458a$export$8d3833b13cc689f5 = async (restStateEndpoint, request, tags)=>{
    const url = new URL(request.url);
    const queryParams = url.searchParams.size > 0 ? `?${url.searchParams.toString()}` : '';
    const response = await (0, $4b8M8.fetchApi)(restStateEndpoint + queryParams);
    if (response.status === 404 || response.status >= 500) (0, $49Pnv.captureTaggedException)('Error fetching page state', {
        capabilities: tags.capabilities,
        extraProperties: {
            restStateEndpoint: restStateEndpoint,
            responseStatus: response.status
        }
    });
    return await response.json();
};
const $f871ec21d9a1458a$export$b176e7ce17921f38 = (opts)=>{
    const location = (0, $l2v8Y.useLocation)();
    const previousLocation = (0, $buHgC.usePrevious)(location.pathname);
    const data = (0, $l2v8Y.useLoaderData)();
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    (0, $91i6m.useLayoutEffect)(()=>{
        if (previousLocation === location.pathname) // Component re-renders can cause this hook to reset the Redux app state unnecessarily.
        // This condition ensures we only ever fetch state and reset Redux when only the pathname
        // and not the search, nor other route states, changes.
        return;
        // No data should mean Feature Gate is disabled and useGlobalPageState is handling the state
        if (!data) // If Feature Gate is enabled but there is no data, we should log to Sentry?
        // TODO: throw descriptive error here for handling in fine-grained error boundaries KIRBY-9124
        return;
        if ($f871ec21d9a1458a$export$4cb830d4f7e56898(data)) {
            if (opts === null || opts === void 0 ? void 0 : opts.skipRedirect) return;
            window.location.assign(data.redirectTo);
            dispatch({
                type: 'SET_GLOBAL_STATE_LOADING',
                isLoading: true
            });
            return;
        }
        (0, $lodUs.buildInitialState)(data).then((fullState)=>{
            dispatch((0, $gCn4g.resetAppState)(fullState.initialStoreState));
        }).catch((error)=>{
            let errorType = {
                type: 'internal_server_error'
            };
            if (error instanceof (0, $4b8M8.ServerErrorException)) {
                errorType = error.errorType;
                (0, $49Pnv.captureErrorMessage)(`Failed to load AppState in Bifrost: ${error.message}`);
            } else (0, $49Pnv.captureErrorMessage)(`Unexpected error while loading AppState in Bifrost: ${error}`);
            dispatch((0, $5mKzS.setServerError)(errorType));
        });
    }, [
        data,
        dispatch,
        location.pathname,
        previousLocation,
        opts === null || opts === void 0 ? void 0 : opts.skipRedirect
    ]);
};

});
parcelRegister("4b8M8", function(module, exports) {

$parcel$export(module.exports, "fetchApi", function () { return $9fcd5aed9186d793$export$adb4bb4243526aef; });
$parcel$export(module.exports, "ServerErrorException", function () { return $9fcd5aed9186d793$export$173e0be89ecf9709; });

var $1Fos3 = parcelRequire("1Fos3");

var $49Pnv = parcelRequire("49Pnv");
const $9fcd5aed9186d793$export$adb4bb4243526aef = async (url, headers)=>{
    const response = await fetch(url, {
        headers: (0, $1Fos3._)({
            'Content-Type': 'application/json'
        }, headers)
    });
    if (response.status >= 500) {
        const data = await response.json();
        const message = `Failed to fetch ${url} [${response.status} status]`;
        const errorType = (data === null || data === void 0 ? void 0 : data.error) || {
            error: 'internal_server_error'
        };
        (0, $49Pnv.captureErrorMessage)(message, data);
        throw new $9fcd5aed9186d793$export$173e0be89ecf9709(message, response.status, errorType);
    }
    return response;
};
class $9fcd5aed9186d793$export$173e0be89ecf9709 extends Error {
    constructor(message, status, errorType){
        super(message), this.message = message, this.status = status, this.errorType = errorType;
        this.name = 'ServerErrorException';
    }
}

});

parcelRegister("5mKzS", function(module, exports) {

$parcel$export(module.exports, "setServerError", function () { return $fc9166386b07bc03$export$222f8d3ac9d63890; });
const $fc9166386b07bc03$export$222f8d3ac9d63890 = (error)=>({
        type: 'SERVER_ERROR_UPDATE',
        error: error
    });

});

parcelRegister("gz8Vs", function(module, exports) {

$parcel$export(module.exports, "isSasStateEndpointEnabled", function () { return $c93ad68fb7998f93$export$ae2c1d86ed68b3d4; });
$parcel$export(module.exports, "usePageState", function () { return $c93ad68fb7998f93$export$d2bdb7c20492cc5; });
$parcel$export(module.exports, "isPageStateResult", function () { return $c93ad68fb7998f93$export$e76aa5e66969f2de; });
$parcel$export(module.exports, "isRedirectResult", function () { return $c93ad68fb7998f93$export$72263c6e24ee9e46; });

var $jvbQq = parcelRequire("jvbQq");

var $4b8M8 = parcelRequire("4b8M8");

var $bqdjD = parcelRequire("bqdjD");

var $6d87w = parcelRequire("6d87w");

var $2aGBJ = parcelRequire("2aGBJ");

var $91i6m = parcelRequire("91i6m");

var $hB2TQ = parcelRequire("hB2TQ");
const $c93ad68fb7998f93$export$ae2c1d86ed68b3d4 = ()=>false;
const $c93ad68fb7998f93$export$d2bdb7c20492cc5 = (path, options = {
    enabled: true
})=>{
    const { enabled: enabled } = options;
    const [searchParams] = (0, $6d87w.useSearchParams)();
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const { data: data, isLoading: isLoading, isError: isError, isSuccess: isSuccess, error: error } = (0, $jvbQq.useQuery)({
        queryKey: [
            path
        ],
        refetchOnWindowFocus: false,
        queryFn: async ()=>{
            const params = searchParams.size > 0 ? `?${searchParams.toString()}` : '';
            const response = await (0, $4b8M8.fetchApi)(`${(0, $bqdjD.idacOrigin)}${path}${params}`);
            return await response.json();
        },
        enabled: enabled
    });
    (0, $91i6m.useEffect)(()=>{
        if ($c93ad68fb7998f93$export$e76aa5e66969f2de(data)) {
            const { csrfToken: csrfToken, hashedCsrfToken: hashedCsrfToken } = data;
            if (csrfToken) dispatch((0, $hB2TQ.updateCsrfToken)(csrfToken));
            if (hashedCsrfToken) dispatch((0, $hB2TQ.updateHashedCsrfToken)(hashedCsrfToken));
        }
    }, [
        isSuccess,
        data,
        dispatch
    ]);
    return {
        state: data,
        isLoading: isLoading,
        isError: isError,
        isSuccess: isSuccess,
        error: error
    };
};
const $c93ad68fb7998f93$export$72263c6e24ee9e46 = (result)=>{
    return (result === null || result === void 0 ? void 0 : result.type) === 'redirect';
};
const $c93ad68fb7998f93$export$e76aa5e66969f2de = (result)=>{
    return (result === null || result === void 0 ? void 0 : result.type) === 'page-state';
};

});
parcelRegister("jvbQq", function(module, exports) {

$parcel$export(module.exports, "useQuery", function () { return $e32a19ad30175e2a$export$dd0a697e1782aedd; });

var $2Yp8D = parcelRequire("2Yp8D");
var $4aKPy = parcelRequire("4aKPy");

var $cv9WW = parcelRequire("cv9WW");
'use client';
function $e32a19ad30175e2a$export$dd0a697e1782aedd(arg1, arg2, arg3) {
    const parsedOptions = (0, $2Yp8D.parseQueryArgs)(arg1, arg2, arg3);
    return (0, $cv9WW.useBaseQuery)(parsedOptions, (0, $4aKPy.QueryObserver));
}

});
parcelRegister("2Yp8D", function(module, exports) {

$parcel$export(module.exports, "isServer", function () { return $22a4af528b14b07a$export$6acf61af03e62db; });
$parcel$export(module.exports, "noop", function () { return $22a4af528b14b07a$export$8793edee2d425525; });
$parcel$export(module.exports, "functionalUpdate", function () { return $22a4af528b14b07a$export$7f095f455ad5af3f; });
$parcel$export(module.exports, "isValidTimeout", function () { return $22a4af528b14b07a$export$e539f754e934e270; });
$parcel$export(module.exports, "timeUntilStale", function () { return $22a4af528b14b07a$export$811b83d62bcf47f0; });
$parcel$export(module.exports, "parseQueryArgs", function () { return $22a4af528b14b07a$export$8a11fbc2c8ea08fd; });
$parcel$export(module.exports, "parseMutationArgs", function () { return $22a4af528b14b07a$export$b646c531ea475334; });
$parcel$export(module.exports, "parseFilterArgs", function () { return $22a4af528b14b07a$export$18e8f4b987e6c111; });
$parcel$export(module.exports, "matchQuery", function () { return $22a4af528b14b07a$export$c5d1efe363797780; });
$parcel$export(module.exports, "hashQueryKeyByOptions", function () { return $22a4af528b14b07a$export$cc90ca97bc0d73fd; });
$parcel$export(module.exports, "partialMatchKey", function () { return $22a4af528b14b07a$export$2f07189bb9fa26a7; });
$parcel$export(module.exports, "matchMutation", function () { return $22a4af528b14b07a$export$a1ea5fb559f63ae3; });
$parcel$export(module.exports, "hashQueryKey", function () { return $22a4af528b14b07a$export$5fcb678681417b54; });
$parcel$export(module.exports, "shallowEqualObjects", function () { return $22a4af528b14b07a$export$3e67810a3f0e9f1c; });
$parcel$export(module.exports, "sleep", function () { return $22a4af528b14b07a$export$e772c8ff12451969; });
$parcel$export(module.exports, "scheduleMicrotask", function () { return $22a4af528b14b07a$export$4304cb76768ca134; });
$parcel$export(module.exports, "getAbortController", function () { return $22a4af528b14b07a$export$382ca5d13a8f252c; });
$parcel$export(module.exports, "replaceData", function () { return $22a4af528b14b07a$export$17619bac5b909b23; });
// TYPES
// UTILS

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");
const $22a4af528b14b07a$export$6acf61af03e62db = typeof window === 'undefined' || 'Deno' in window;
function $22a4af528b14b07a$export$8793edee2d425525() {
    return undefined;
}
function $22a4af528b14b07a$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === 'function' ? updater(input) : updater;
}
function $22a4af528b14b07a$export$e539f754e934e270(value) {
    return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function $22a4af528b14b07a$export$acaf96a27438246b(array1, array2) {
    return array1.filter((x)=>!array2.includes(x));
}
function $22a4af528b14b07a$export$224e3b7078227b8a(array, index, value) {
    const copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $22a4af528b14b07a$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $22a4af528b14b07a$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$22a4af528b14b07a$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === 'function') return (0, $b2I6k._)((0, $1Fos3._)({}, arg3), {
        queryKey: arg1,
        queryFn: arg2
    });
    return (0, $b2I6k._)((0, $1Fos3._)({}, arg2), {
        queryKey: arg1
    });
}
function $22a4af528b14b07a$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($22a4af528b14b07a$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === 'function') return (0, $b2I6k._)((0, $1Fos3._)({}, arg3), {
            mutationKey: arg1,
            mutationFn: arg2
        });
        return (0, $b2I6k._)((0, $1Fos3._)({}, arg2), {
            mutationKey: arg1
        });
    }
    if (typeof arg1 === 'function') return (0, $b2I6k._)((0, $1Fos3._)({}, arg2), {
        mutationFn: arg1
    });
    return (0, $1Fos3._)({}, arg1);
}
function $22a4af528b14b07a$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $22a4af528b14b07a$export$aaae5295ec3351c9(arg1) ? [
        (0, $b2I6k._)((0, $1Fos3._)({}, arg2), {
            queryKey: arg1
        }),
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $22a4af528b14b07a$export$42387eeaac09cf54(arg1, arg2, arg3) {
    return $22a4af528b14b07a$export$aaae5295ec3351c9(arg1) ? [
        (0, $b2I6k._)((0, $1Fos3._)({}, arg2), {
            mutationKey: arg1
        }),
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $22a4af528b14b07a$export$c5d1efe363797780(filters, query) {
    const { type: type = 'all', exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if ($22a4af528b14b07a$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $22a4af528b14b07a$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$22a4af528b14b07a$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== 'all') {
        const isActive = query.isActive();
        if (type === 'active' && !isActive) return false;
        if (type === 'inactive' && isActive) return false;
    }
    if (typeof stale === 'boolean' && query.isStale() !== stale) return false;
    if (typeof fetchStatus !== 'undefined' && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $22a4af528b14b07a$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, fetching: fetching, predicate: predicate, mutationKey: mutationKey } = filters;
    if ($22a4af528b14b07a$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($22a4af528b14b07a$export$5fcb678681417b54(mutation.options.mutationKey) !== $22a4af528b14b07a$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$22a4af528b14b07a$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $22a4af528b14b07a$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $22a4af528b14b07a$export$5fcb678681417b54;
    return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 * Hashes the value into a stable hash.
 */ function $22a4af528b14b07a$export$5fcb678681417b54(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$22a4af528b14b07a$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
/**
 * Checks if key `b` partially matches with key `a`.
 */ function $22a4af528b14b07a$export$2f07189bb9fa26a7(a, b) {
    return $22a4af528b14b07a$export$3bc9138b70293839(a, b);
}
/**
 * Checks if `b` partially matches with `a`.
 */ function $22a4af528b14b07a$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === 'object' && typeof b === 'object') return !Object.keys(b).some((key)=>!$22a4af528b14b07a$export$3bc9138b70293839(a[key], b[key]));
    return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */ function $22a4af528b14b07a$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $22a4af528b14b07a$export$7a8558113332b71e(a) && $22a4af528b14b07a$export$7a8558113332b71e(b);
    if (array || $22a4af528b14b07a$export$53b83ca8eaab0383(a) && $22a4af528b14b07a$export$53b83ca8eaab0383(b)) {
        const aSize = array ? a.length : Object.keys(a).length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            copy[key] = $22a4af528b14b07a$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */ function $22a4af528b14b07a$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $22a4af528b14b07a$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $22a4af528b14b07a$export$53b83ca8eaab0383(o) {
    if (!$22a4af528b14b07a$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor === 'undefined') return true;
     // If has modified prototype
    const prot = ctor.prototype;
    if (!$22a4af528b14b07a$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty('isPrototypeOf')) return false;
     // Most likely a plain Object
    return true;
}
function $22a4af528b14b07a$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === '[object Object]';
}
function $22a4af528b14b07a$export$aaae5295ec3351c9(value) {
    return Array.isArray(value);
}
function $22a4af528b14b07a$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $22a4af528b14b07a$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */ function $22a4af528b14b07a$export$4304cb76768ca134(callback) {
    $22a4af528b14b07a$export$e772c8ff12451969(0).then(callback);
}
function $22a4af528b14b07a$export$382ca5d13a8f252c() {
    if (typeof AbortController === 'function') return new AbortController();
    return;
}
function $22a4af528b14b07a$export$17619bac5b909b23(prevData, data, options) {
    // Use prev data if an isDataEqual function is defined and returns `true`
    if (options.isDataEqual != null && options.isDataEqual(prevData, data)) return prevData;
    else if (typeof options.structuralSharing === 'function') return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) // Structurally share data between prev and new data if needed
    return $22a4af528b14b07a$export$77a71fc411098696(prevData, data);
    return data;
}

});

parcelRegister("4aKPy", function(module, exports) {

$parcel$export(module.exports, "QueryObserver", function () { return $309c6c256985a53f$export$a06cf8c0066f0d4c; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $6NU0v = parcelRequire("6NU0v");

var $2Yp8D = parcelRequire("2Yp8D");

var $3gH3P = parcelRequire("3gH3P");

var $gCDn7 = parcelRequire("gCDn7");

var $5si2t = parcelRequire("5si2t");

var $ljaX7 = parcelRequire("ljaX7");
class $309c6c256985a53f$export$a06cf8c0066f0d4c extends (0, $5si2t.Subscribable) {
    bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.currentQuery.addObserver(this);
            if ($309c6c256985a53f$var$shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $309c6c256985a53f$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $309c6c256985a53f$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = new Set();
        this.clearStaleTimeout();
        this.clearRefetchInterval();
        this.currentQuery.removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryOptions(options);
        if (!(0, $2Yp8D.shallowEqualObjects)(prevOptions, this.options)) this.client.getQueryCache().notify({
            type: 'observerOptionsUpdated',
            query: this.currentQuery,
            observer: this
        });
        if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') throw new Error('Expected enabled to be a boolean');
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        const mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && $309c6c256985a53f$var$shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        const nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = this.client.getQueryCache().build(this.client, options);
        const result = this.createResult(query, options);
        if ($309c6c256985a53f$var$shouldAssignObserverCurrentProperties(this, result, options)) {
            // this assigns the optimistic result to the current Observer
            // because if the query function changes, useQuery will be performing
            // an effect where it would fetch again.
            // When the fetch finishes, we perform a deep data cloning in order
            // to reuse objects references. This deep data clone is performed against
            // the `observer.currentResult.data` property
            // When QueryKey changes, we refresh the query and get new `optimistic`
            // result, while we leave the `observer.currentResult`, so when new data
            // arrives, it finds the old `observer.currentResult` which is related
            // to the old QueryKey. Which means that currentResult and selectData are
            // out of sync already.
            // To solve this, we move the cursor of the currentResult everytime
            // an observer reads an optimistic value.
            // When keeping the previous data, the result doesn't change until new
            // data arrives.
            this.currentResult = result;
            this.currentResultOptions = this.options;
            this.currentResultState = this.currentQuery.state;
        }
        return result;
    }
    getCurrentResult() {
        return this.currentResult;
    }
    trackResult(result) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackedProps.add(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    getCurrentQuery() {
        return this.currentQuery;
    }
    remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    }
    refetch(_param = {}) {
        var { refetchPage: refetchPage } = _param, options = (0, $6NU0v._)(_param, [
            "refetchPage"
        ]);
        return this.fetch((0, $b2I6k._)((0, $1Fos3._)({}, options), {
            meta: {
                refetchPage: refetchPage
            }
        }));
    }
    fetchOptimistic(options) {
        const defaultedOptions = this.client.defaultQueryOptions(options);
        const query = this.client.getQueryCache().build(this.client, defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        var _fetchOptions$cancelR;
        return this.executeFetch((0, $b2I6k._)((0, $1Fos3._)({}, fetchOptions), {
            cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) != null ? _fetchOptions$cancelR : true
        })).then(()=>{
            this.updateResult();
            return this.currentResult;
        });
    }
    executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        let promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions != null && fetchOptions.throwOnError)) promise = promise.catch((0, $2Yp8D.noop));
        return promise;
    }
    updateStaleTimeout() {
        this.clearStaleTimeout();
        if ((0, $2Yp8D.isServer) || this.currentResult.isStale || !(0, $2Yp8D.isValidTimeout)(this.options.staleTime)) return;
        const time = (0, $2Yp8D.timeUntilStale)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        const timeout = time + 1;
        this.staleTimeoutId = setTimeout(()=>{
            if (!this.currentResult.isStale) this.updateResult();
        }, timeout);
    }
    computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    }
    updateRefetchInterval(nextInterval) {
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, $2Yp8D.isServer) || this.options.enabled === false || !(0, $2Yp8D.isValidTimeout)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, $gCDn7.focusManager).isFocused()) this.executeFetch();
        }, this.currentRefetchInterval);
    }
    updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    }
    clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    }
    clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    }
    createResult(query, options) {
        const prevQuery = this.currentQuery;
        const prevOptions = this.options;
        const prevResult = this.currentResult;
        const prevResultState = this.currentResultState;
        const prevResultOptions = this.currentResultOptions;
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        const prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        const { state: state } = query;
        let { dataUpdatedAt: dataUpdatedAt, error: error, errorUpdatedAt: errorUpdatedAt, fetchStatus: fetchStatus, status: status } = state;
        let isPreviousData = false;
        let isPlaceholderData = false;
        let data; // Optimistically set result in fetching state if needed
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $309c6c256985a53f$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $309c6c256985a53f$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                fetchStatus = (0, $ljaX7.canFetch)(query.options.networkMode) ? 'fetching' : 'paused';
                if (!dataUpdatedAt) status = 'loading';
            }
            if (options._optimisticResults === 'isRestoring') fetchStatus = 'idle';
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdatedAt && prevQueryResult != null && prevQueryResult.isSuccess && status !== 'error') {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== 'undefined') {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                data = (0, $2Yp8D.replaceData)(prevResult == null ? void 0 : prevResult.data, data, options);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && status === 'loading') {
            let placeholderData; // Memoize placeholder data
            if (prevResult != null && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== 'undefined') try {
                    placeholderData = options.select(placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== 'undefined') {
                status = 'success';
                data = (0, $2Yp8D.replaceData)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = 'error';
        }
        const isFetching = fetchStatus === 'fetching';
        const isLoading = status === 'loading';
        const isError = status === 'error';
        const result = {
            status: status,
            fetchStatus: fetchStatus,
            isLoading: isLoading,
            isSuccess: status === 'success',
            isError: isError,
            isInitialLoading: isLoading && isFetching,
            data: data,
            dataUpdatedAt: dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            failureReason: state.fetchFailureReason,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isLoading,
            isLoadingError: isError && state.dataUpdatedAt === 0,
            isPaused: fetchStatus === 'paused',
            isPlaceholderData: isPlaceholderData,
            isPreviousData: isPreviousData,
            isRefetchError: isError && state.dataUpdatedAt !== 0,
            isStale: $309c6c256985a53f$var$isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = this.currentResult;
        const nextResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify and update result if something has changed
        if ((0, $2Yp8D.shallowEqualObjects)(nextResult, prevResult)) return;
        this.currentResult = nextResult; // Determine which callbacks to trigger
        const defaultNotifyOptions = {
            cache: true
        };
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === 'function' ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === 'all' || !notifyOnChangePropsValue && !this.trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangePropsValue != null ? notifyOnChangePropsValue : this.trackedProps);
            if (this.options.useErrorBoundary) includedProps.add('error');
            return Object.keys(this.currentResult).some((key)=>{
                const typedKey = key;
                const changed = this.currentResult[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        this.notify((0, $1Fos3._)({}, defaultNotifyOptions, notifyOptions));
    }
    updateQuery() {
        const query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        const prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    }
    onQueryUpdate(action) {
        const notifyOptions = {};
        if (action.type === 'success') notifyOptions.onSuccess = !action.manual;
        else if (action.type === 'error' && !(0, $ljaX7.isCancelledError)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    }
    notify(notifyOptions) {
        (0, $3gH3P.notifyManager).batch(()=>{
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                var _this$options$onSucce, _this$options, _this$options$onSettl, _this$options2;
                (_this$options$onSucce = (_this$options = this.options).onSuccess) == null || _this$options$onSucce.call(_this$options, this.currentResult.data);
                (_this$options$onSettl = (_this$options2 = this.options).onSettled) == null || _this$options$onSettl.call(_this$options2, this.currentResult.data, null);
            } else if (notifyOptions.onError) {
                var _this$options$onError, _this$options3, _this$options$onSettl2, _this$options4;
                (_this$options$onError = (_this$options3 = this.options).onError) == null || _this$options$onError.call(_this$options3, this.currentResult.error);
                (_this$options$onSettl2 = (_this$options4 = this.options).onSettled) == null || _this$options$onSettl2.call(_this$options4, undefined, this.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) this.listeners.forEach(({ listener: listener })=>{
                listener(this.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) this.client.getQueryCache().notify({
                query: this.currentQuery,
                type: 'observerResultsUpdated'
            });
        });
    }
    constructor(client, options){
        super();
        this.client = client;
        this.options = options;
        this.trackedProps = new Set();
        this.selectError = null;
        this.bindMethods();
        this.setOptions(options);
    }
}
function $309c6c256985a53f$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}
function $309c6c256985a53f$var$shouldFetchOnMount(query, options) {
    return $309c6c256985a53f$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $309c6c256985a53f$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $309c6c256985a53f$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === 'function' ? field(query) : field;
        return value === 'always' || value !== false && $309c6c256985a53f$var$isStale(query, options);
    }
    return false;
}
function $309c6c256985a53f$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && $309c6c256985a53f$var$isStale(query, options);
}
function $309c6c256985a53f$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
} // this function would decide if we will update the observer's 'current'
// properties after an optimistic reading via getOptimisticResult
function $309c6c256985a53f$var$shouldAssignObserverCurrentProperties(observer, optimisticResult, options) {
    // it is important to keep this condition like this for three reasons:
    // 1. It will get removed in the v5
    // 2. it reads: don't update the properties if we want to keep the previous
    // data.
    // 3. The opposite condition (!options.keepPreviousData) would fallthrough
    // and will result in a bad decision
    if (options.keepPreviousData) return false;
     // this means we want to put some placeholder data when pending and queryKey
    // changed.
    if (options.placeholderData !== undefined) // re-assign properties only if current data is placeholder data
    // which means that data did not arrive yet, so, if there is some cached data
    // we need to "prepare" to receive it
    return optimisticResult.isPlaceholderData;
     // if the newly created result isn't what the observer is holding as current,
    // then we'll need to update the properties as well
    if (!(0, $2Yp8D.shallowEqualObjects)(observer.getCurrentResult(), optimisticResult)) return true;
     // basically, just keep previous properties if nothing changed
    return false;
}

});
parcelRegister("3gH3P", function(module, exports) {

$parcel$export(module.exports, "notifyManager", function () { return $261444af48009ca0$export$520687f44db6e1ab; });

var $2Yp8D = parcelRequire("2Yp8D");
function $261444af48009ca0$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else (0, $2Yp8D.scheduleMicrotask)(()=>{
            notifyFn(callback);
        });
    };
    /**
   * All calls to the wrapped function will be batched.
   */ const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) (0, $2Yp8D.scheduleMicrotask)(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */ const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */ const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction
    };
} // SINGLETON
const $261444af48009ca0$export$520687f44db6e1ab = $261444af48009ca0$export$316a8efd03cd1458();

});

parcelRegister("gCDn7", function(module, exports) {

$parcel$export(module.exports, "focusManager", function () { return $c19ebc677f064ed9$export$6bf54661be5b02cf; });

var $5si2t = parcelRequire("5si2t");

var $2Yp8D = parcelRequire("2Yp8D");
class $c19ebc677f064ed9$export$86f1af424b2ca4de extends (0, $5si2t.Subscribable) {
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((focused)=>{
            if (typeof focused === 'boolean') this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.focused !== focused;
        if (changed) {
            this.focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isFocused() {
        if (typeof this.focused === 'boolean') return this.focused;
         // document global can be unavailable in react native
        if (typeof document === 'undefined') return true;
        return [
            undefined,
            'visible',
            'prerender'
        ].includes(document.visibilityState);
    }
    constructor(){
        super();
        this.setup = (onFocus)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $2Yp8D.isServer) && window.addEventListener) {
                const listener = ()=>onFocus(); // Listen to visibillitychange and focus
                window.addEventListener('visibilitychange', listener, false);
                window.addEventListener('focus', listener, false);
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener('visibilitychange', listener);
                    window.removeEventListener('focus', listener);
                };
            }
            return;
        };
    }
}
const $c19ebc677f064ed9$export$6bf54661be5b02cf = new $c19ebc677f064ed9$export$86f1af424b2ca4de();

});
parcelRegister("5si2t", function(module, exports) {

$parcel$export(module.exports, "Subscribable", function () { return $3f8d8f703ff742b9$export$d26086b469ecdbcc; });
class $3f8d8f703ff742b9$export$d26086b469ecdbcc {
    subscribe(listener) {
        const identity = {
            listener: listener
        };
        this.listeners.add(identity);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(identity);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
    constructor(){
        this.listeners = new Set();
        this.subscribe = this.subscribe.bind(this);
    }
}

});


parcelRegister("ljaX7", function(module, exports) {

$parcel$export(module.exports, "canFetch", function () { return $f833de4659f06699$export$61b92f63f30245cf; });
$parcel$export(module.exports, "isCancelledError", function () { return $f833de4659f06699$export$986cc6445c1d323; });
$parcel$export(module.exports, "createRetryer", function () { return $f833de4659f06699$export$2cbd00fe8a2c8d85; });

var $gCDn7 = parcelRequire("gCDn7");

var $aqfRd = parcelRequire("aqfRd");

var $2Yp8D = parcelRequire("2Yp8D");
function $f833de4659f06699$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * 2 ** failureCount, 30000);
}
function $f833de4659f06699$export$61b92f63f30245cf(networkMode) {
    return (networkMode != null ? networkMode : 'online') === 'online' ? (0, $aqfRd.onlineManager).isOnline() : true;
}
class $f833de4659f06699$export$a8430ed4188f35a9 {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
}
function $f833de4659f06699$export$986cc6445c1d323(value) {
    return value instanceof $f833de4659f06699$export$a8430ed4188f35a9;
}
function $f833de4659f06699$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        if (!isResolved) {
            reject(new $f833de4659f06699$export$a8430ed4188f35a9(cancelOptions));
            config.abort == null || config.abort();
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, $gCDn7.focusManager).isFocused() || config.networkMode !== 'always' && !(0, $aqfRd.onlineManager).isOnline();
    const resolve = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                const canContinue = isResolved || !shouldPause();
                if (canContinue) continueResolve(value);
                return canContinue;
            };
            config.onPause == null || config.onPause();
        }).then(()=>{
            continueFn = undefined;
            if (!isResolved) config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    const run = ()=>{
        // Do nothing if already resolved
        if (isResolved) return;
        let promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (isResolved) return;
             // Do we need to retry the request?
            const retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            const retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $f833de4659f06699$var$defaultRetryDelay;
            const delay = typeof retryDelay === 'function' ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === 'number' && failureCount < retry || typeof retry === 'function' && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            failureCount++; // Notify on fail
            config.onFail == null || config.onFail(failureCount, error); // Delay
            (0, $2Yp8D.sleep)(delay) // Pause if the document is not visible or when the device is offline
            .then(()=>{
                if (shouldPause()) return pause();
                return;
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    }; // Start loop
    if ($f833de4659f06699$export$61b92f63f30245cf(config.networkMode)) run();
    else pause().then(run);
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            const didContinue = continueFn == null ? void 0 : continueFn();
            return didContinue ? promise : Promise.resolve();
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry
    };
}

});
parcelRegister("aqfRd", function(module, exports) {

$parcel$export(module.exports, "onlineManager", function () { return $7968a20c876ab252$export$b113e788b2dd3fdc; });

var $5si2t = parcelRequire("5si2t");

var $2Yp8D = parcelRequire("2Yp8D");
const $7968a20c876ab252$var$onlineEvents = [
    'online',
    'offline'
];
class $7968a20c876ab252$export$58774fb55d5ff7fc extends (0, $5si2t.Subscribable) {
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((online)=>{
            if (typeof online === 'boolean') this.setOnline(online);
            else this.onOnline();
        });
    }
    setOnline(online) {
        const changed = this.online !== online;
        if (changed) {
            this.online = online;
            this.onOnline();
        }
    }
    onOnline() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isOnline() {
        if (typeof this.online === 'boolean') return this.online;
        if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') return true;
        return navigator.onLine;
    }
    constructor(){
        super();
        this.setup = (onOnline)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $2Yp8D.isServer) && window.addEventListener) {
                const listener = ()=>onOnline(); // Listen to online
                $7968a20c876ab252$var$onlineEvents.forEach((event)=>{
                    window.addEventListener(event, listener, false);
                });
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    $7968a20c876ab252$var$onlineEvents.forEach((event)=>{
                        window.removeEventListener(event, listener);
                    });
                };
            }
            return;
        };
    }
}
const $7968a20c876ab252$export$b113e788b2dd3fdc = new $7968a20c876ab252$export$58774fb55d5ff7fc();

});



parcelRegister("cv9WW", function(module, exports) {

$parcel$export(module.exports, "useBaseQuery", function () { return $91a01919b7eea1cb$export$fff0865807e996c5; });

var $91i6m = parcelRequire("91i6m");

var $3gH3P = parcelRequire("3gH3P");

var $iJ5WK = parcelRequire("iJ5WK");

var $cAJ4v = parcelRequire("cAJ4v");

var $ejkzJ = parcelRequire("ejkzJ");

var $j4cWE = parcelRequire("j4cWE");

var $2pWiG = parcelRequire("2pWiG");

var $3arzc = parcelRequire("3arzc");
'use client';
function $91a01919b7eea1cb$export$fff0865807e996c5(options, Observer) {
    const queryClient = (0, $ejkzJ.useQueryClient)({
        context: options.context
    });
    const isRestoring = (0, $j4cWE.useIsRestoring)();
    const errorResetBoundary = (0, $cAJ4v.useQueryErrorResetBoundary)();
    const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions._optimisticResults = isRestoring ? 'isRestoring' : 'optimistic'; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, $3gH3P.notifyManager).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, $3gH3P.notifyManager).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, $3gH3P.notifyManager).batchCalls(defaultedOptions.onSettled);
    (0, $3arzc.ensureStaleTime)(defaultedOptions);
    (0, $2pWiG.ensurePreventErrorBoundaryRetry)(defaultedOptions, errorResetBoundary);
    (0, $2pWiG.useClearResetErrorBoundary)(errorResetBoundary);
    const [observer] = $91i6m.useState(()=>new Observer(queryClient, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    (0, $iJ5WK.useSyncExternalStore)($91i6m.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>undefined : observer.subscribe((0, $3gH3P.notifyManager).batchCalls(onStoreChange)); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $91i6m.useEffect(()=>{
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if ((0, $3arzc.shouldSuspend)(defaultedOptions, result, isRestoring)) throw (0, $3arzc.fetchOptimistic)(defaultedOptions, observer, errorResetBoundary);
     // Handle error boundary
    if ((0, $2pWiG.getHasError)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        useErrorBoundary: defaultedOptions.useErrorBoundary,
        query: observer.getCurrentQuery()
    })) throw result.error;
     // Handle result property usage tracking
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}

});
parcelRegister("iJ5WK", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $da210ad7ec1e34a0$export$306c0aa65ff9ec16; });

var $1jUfn = parcelRequire("1jUfn");
'use client';
const $da210ad7ec1e34a0$export$306c0aa65ff9ec16 = (0, $1jUfn.useSyncExternalStore);

});

parcelRegister("cAJ4v", function(module, exports) {

$parcel$export(module.exports, "useQueryErrorResetBoundary", function () { return $92abcf1f5f58f625$export$50dfac555130cafd; });

var $91i6m = parcelRequire("91i6m");
'use client';
function $92abcf1f5f58f625$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
const $92abcf1f5f58f625$var$QueryErrorResetBoundaryContext = /*#__PURE__*/ $91i6m.createContext($92abcf1f5f58f625$var$createValue()); // HOOK
const $92abcf1f5f58f625$export$50dfac555130cafd = ()=>$91i6m.useContext($92abcf1f5f58f625$var$QueryErrorResetBoundaryContext); // COMPONENT
const $92abcf1f5f58f625$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $91i6m.useState(()=>$92abcf1f5f58f625$var$createValue());
    return /*#__PURE__*/ $91i6m.createElement($92abcf1f5f58f625$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === 'function' ? children(value) : children);
};

});

parcelRegister("ejkzJ", function(module, exports) {

$parcel$export(module.exports, "useQueryClient", function () { return $a6b2cce3b45250e4$export$22e77b9572c4fded; });
$parcel$export(module.exports, "QueryClientProvider", function () { return $a6b2cce3b45250e4$export$45604f0cc8ae667b; });

var $91i6m = parcelRequire("91i6m");
'use client';
const $a6b2cce3b45250e4$export$2fba198b5b2e37fa = /*#__PURE__*/ $91i6m.createContext(undefined);
const $a6b2cce3b45250e4$var$QueryClientSharingContext = /*#__PURE__*/ $91i6m.createContext(false); // If we are given a context, we will use it.
// Otherwise, if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $a6b2cce3b45250e4$var$getQueryClientContext(context, contextSharing) {
    if (context) return context;
    if (contextSharing && typeof window !== 'undefined') {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $a6b2cce3b45250e4$export$2fba198b5b2e37fa;
        return window.ReactQueryClientContext;
    }
    return $a6b2cce3b45250e4$export$2fba198b5b2e37fa;
}
const $a6b2cce3b45250e4$export$22e77b9572c4fded = ({ context: context } = {})=>{
    const queryClient = $91i6m.useContext($a6b2cce3b45250e4$var$getQueryClientContext(context, $91i6m.useContext($a6b2cce3b45250e4$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error('No QueryClient set, use QueryClientProvider to set one');
    return queryClient;
};
const $a6b2cce3b45250e4$export$45604f0cc8ae667b = ({ client: client, children: children, context: context, contextSharing: contextSharing = false })=>{
    $91i6m.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    const Context = $a6b2cce3b45250e4$var$getQueryClientContext(context, contextSharing);
    return /*#__PURE__*/ $91i6m.createElement($a6b2cce3b45250e4$var$QueryClientSharingContext.Provider, {
        value: !context && contextSharing
    }, /*#__PURE__*/ $91i6m.createElement(Context.Provider, {
        value: client
    }, children));
};

});

parcelRegister("j4cWE", function(module, exports) {

$parcel$export(module.exports, "useIsRestoring", function () { return $de186ea63643ce3b$export$4da0178d6b5f553; });

var $91i6m = parcelRequire("91i6m");
'use client';
const $de186ea63643ce3b$var$IsRestoringContext = /*#__PURE__*/ $91i6m.createContext(false);
const $de186ea63643ce3b$export$4da0178d6b5f553 = ()=>$91i6m.useContext($de186ea63643ce3b$var$IsRestoringContext);
const $de186ea63643ce3b$export$593807d4e94f9621 = $de186ea63643ce3b$var$IsRestoringContext.Provider;

});

parcelRegister("2pWiG", function(module, exports) {

$parcel$export(module.exports, "ensurePreventErrorBoundaryRetry", function () { return $1c2b23cb48e51925$export$ae8adb3de3d77633; });
$parcel$export(module.exports, "useClearResetErrorBoundary", function () { return $1c2b23cb48e51925$export$b2b17ca3a1fb0229; });
$parcel$export(module.exports, "getHasError", function () { return $1c2b23cb48e51925$export$1fbcf724762d607; });

var $91i6m = parcelRequire("91i6m");

var $faSZL = parcelRequire("faSZL");
'use client';
const $1c2b23cb48e51925$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
const $1c2b23cb48e51925$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $91i6m.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
const $1c2b23cb48e51925$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, useErrorBoundary: useErrorBoundary, query: query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $faSZL.shouldThrowError)(useErrorBoundary, [
        result.error,
        query
    ]);
};

});
parcelRegister("faSZL", function(module, exports) {

$parcel$export(module.exports, "shouldThrowError", function () { return $b0c273167b1efc8a$export$2072f68e6c3507cf; });
function $b0c273167b1efc8a$export$2072f68e6c3507cf(_useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === 'function') return _useErrorBoundary(...params);
    return !!_useErrorBoundary;
}

});


parcelRegister("3arzc", function(module, exports) {

$parcel$export(module.exports, "ensureStaleTime", function () { return $24e7b07969390e1b$export$2c40a591ad2dafb1; });
$parcel$export(module.exports, "shouldSuspend", function () { return $24e7b07969390e1b$export$88d3586dfed64df9; });
$parcel$export(module.exports, "fetchOptimistic", function () { return $24e7b07969390e1b$export$defdc11a9c9acfcf; });
/**
 * Ensures minimum staleTime and cacheTime values when suspense is enabled.
 * Despite the name, this function guards both staleTime and cacheTime to prevent
 * infinite re-render loops with synchronous queries.
 *
 * @deprecated in v5 - replaced by ensureSuspenseTimers
 */ const $24e7b07969390e1b$export$2c40a591ad2dafb1 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        // Always set stale time when using suspense to prevent
        // fetching again when directly mounting after suspending
        if (typeof defaultedOptions.staleTime !== 'number') defaultedOptions.staleTime = 1000;
        if (typeof defaultedOptions.cacheTime === 'number') defaultedOptions.cacheTime = Math.max(defaultedOptions.cacheTime, 1000);
    }
};
const $24e7b07969390e1b$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
const $24e7b07969390e1b$export$88d3586dfed64df9 = (defaultedOptions, result, isRestoring)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && $24e7b07969390e1b$export$e0a3f29513afe430(result, isRestoring);
const $24e7b07969390e1b$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).then(({ data: data })=>{
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch((error)=>{
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });

});



parcelRegister("hB2TQ", function(module, exports) {

$parcel$export(module.exports, "updateCsrfToken", function () { return $aae4dd533076dc9f$export$527f2c21586e0a0e; });
$parcel$export(module.exports, "updateHashedCsrfToken", function () { return $aae4dd533076dc9f$export$32d195f109b250f4; });
const $aae4dd533076dc9f$export$527f2c21586e0a0e = (csrfToken)=>({
        type: 'CSRF_TOKEN_UPDATE',
        csrfToken: csrfToken
    });
const $aae4dd533076dc9f$export$32d195f109b250f4 = (hashedCsrfToken)=>({
        type: 'HASHED_CSRF_TOKEN_UPDATE',
        hashedCsrfToken: hashedCsrfToken
    });

});


parcelRegister("kpg9c", function(module, exports) {

$parcel$export(module.exports, "AidFrontendFeatureGate", function () { return $e43764199a1feb5c$export$e2b0cf8c8e2eb757; });
var $e43764199a1feb5c$export$e2b0cf8c8e2eb757 = /*#__PURE__*/ function(AidFrontendFeatureGate) {
    // https://switcheroo.atlassian.com/ui/gates/c2e09b58-639a-4260-89de-4b390ac2b746/key/identity-aid-frontend-sms-enrollment-new-captcha
    // https://hello.atlassian.net/wiki/spaces/I/pages/4492639544/22-11-2025+Current+State+of+UniCAPTCHA+rollout
    AidFrontendFeatureGate["SMS_ENROLLMENT_UNICAPTCHA"] = "identity-aid-frontend-sms-enrollment-new-captcha";
    // !! IMPORTANT !! Make sure to update integration test mocks to use the new endpoints when this is updated/removed/added
    // https://switcheroo.atlassian.com/ui/gates/fc7e9434-0ffa-46ba-9831-43c4cba66cdc/key/id-frontend-use-state-data-loaders
    AidFrontendFeatureGate["USE_STATE_DATA_LOADERS"] = "id-frontend-use-state-data-loaders";
    // https://switcheroo.atlassian.com/ui/gates/e2f249e8-68ad-46fe-8617-c903b90bf375/key/kirby-7873_new_json_endpoint_for_verify-email
    AidFrontendFeatureGate["ENABLE_JSON_ENDPOINT_FOR_VERIFY_EMAIL"] = "kirby-7873_new_json_endpoint_for_verify-email";
    // https://switcheroo.atlassian.com/ui/gates/535b1c04-bb61-421f-9629-44f35bae8fca/key/loom-idac-enable-suggested-workspaces
    AidFrontendFeatureGate["ENABLE_LOOM_SUGGESTED_WORKSPACES"] = "loom-idac-enable-suggested-workspaces";
    // https://switcheroo.atlassian.com/ui/gates/de628605-5ad1-426a-b60e-d46d6f161a8f/key/idzero-7285-passkey-auth
    AidFrontendFeatureGate["ENABLE_PASSKEY_AUTH"] = "idzero-7285-passkey-auth";
    // https://switcheroo.atlassian.com/ui/gates/4ad43fc9-48c7-4c44-94b4-67f9607aea3d/key/id-frontend_replace_email_id_with_testid
    AidFrontendFeatureGate["REPLACE_EMAIL_ID_WITH_TEST_ID"] = "id-frontend_replace_email_id_with_testid";
    // https://switcheroo.atlassian.com/ui/gates/edfa7312-8edf-47da-b61c-eb2592ecf173/key/id-frontend-enable-new-v2-check-username-ic-flow
    AidFrontendFeatureGate["ENABLE_NEW_V2_CHECK_USERNAME_IC_FLOW"] = "id-frontend-enable-new-v2-check-username-ic-flow";
    // https://switcheroo.atlassian.com/ui/gates/5594ad08-15ae-4171-9ab7-2a93ae797488/key/id-frontend_use_new_typography
    AidFrontendFeatureGate["USE_NEW_TYPOGRAPHY"] = "id-frontend-use-new-typography";
    return AidFrontendFeatureGate;
}({});

});

parcelRegister("9uXJ3", function(module, exports) {

$parcel$export(module.exports, "useNavigateSoftOrHard", function () { return $becf1850885b6797$export$51346bfefbea0096; });

var $91i6m = parcelRequire("91i6m");
parcelRequire("6d87w");
var $l2v8Y = parcelRequire("l2v8Y");

var $exhS2 = parcelRequire("exhS2");

var $abjTs = parcelRequire("abjTs");
const $becf1850885b6797$var$isToExternalHost = (to)=>{
    try {
        const url = new URL(to);
        return url.hostname !== window.location.hostname;
    } catch (e) {
        // "to" can also validly be a path without a hostname
        return false;
    }
};
// react-router breaks if it is provided with domain information (e.g. https://id.atlassian.com:443)
// so we need to remove it
const $becf1850885b6797$var$removeDomainInformation = (to)=>{
    let pathname;
    try {
        const url = new URL(to);
        pathname = url.pathname + url.search + url.hash;
    } catch (e) {
        // "to" can also validly be a path without a hostname
        pathname = to;
    }
    return pathname;
};
// this is needed because the parameters of Partial<Path> are a subset of URL, but if we
// pass a URL to react-router's navigate function, it may break.
const $becf1850885b6797$var$stringifyIfUrl = (to)=>{
    if (to instanceof URL) return to.toString();
    return to;
};
const $becf1850885b6797$export$51346bfefbea0096 = ()=>{
    const softNavigate = (0, $l2v8Y.useNavigate)();
    return (0, $91i6m.useCallback)((to, options)=>{
        const destination = $becf1850885b6797$var$stringifyIfUrl(to);
        if (typeof destination === 'number') return softNavigate(destination);
        if (typeof destination !== 'string') // destination is a Partial<Path>
        return softNavigate(destination, options);
        if (options) return softNavigate(destination, options);
        if ($becf1850885b6797$var$isToExternalHost(destination)) return window.location.assign(destination);
        const pathname = $becf1850885b6797$var$removeDomainInformation(destination);
        // if the pathname matches the frontend App router then we can soft navigate
        const routeMatches = (0, $exhS2.matchRoutes)((0, $abjTs.router).routes, pathname);
        if (routeMatches && routeMatches.length > 0) return softNavigate(pathname);
        return window.location.assign(destination);
    }, [
        softNavigate
    ]);
};

});
parcelRegister("abjTs", function(module, exports) {

$parcel$export(module.exports, "router", function () { return $424b86cd01e796e6$export$5375cda95f0b0eb4; });

var $4ZSso = parcelRequire("4ZSso");


var $5KmZU = parcelRequire("5KmZU");

var $91i6m = parcelRequire("91i6m");

var $8KhCJ = parcelRequire("8KhCJ");

var $leG06 = parcelRequire("leG06");

var $6d87w = parcelRequire("6d87w");
var $l2v8Y = parcelRequire("l2v8Y");parcelRequire("l2v8Y");
var $exhS2 = parcelRequire("exhS2");
var $l2v8Y = parcelRequire("l2v8Y");

var $27bff = parcelRequire("27bff");

var $2aGBJ = parcelRequire("2aGBJ");

var $gCn4g = parcelRequire("gCn4g");

var $6IwzG = parcelRequire("6IwzG");

var $1Aex4 = parcelRequire("1Aex4");

var $6VgPx = parcelRequire("6VgPx");

var $gxUYA = parcelRequire("gxUYA");

var $bqdjD = parcelRequire("bqdjD");

var $lyaVk = parcelRequire("lyaVk");

var $5e2bj = parcelRequire("5e2bj");

var $9uXJ3 = parcelRequire("9uXJ3");

var $lodUs = parcelRequire("lodUs");

var $2UbF1 = parcelRequire("2UbF1");

var $b9U6C = parcelRequire("b9U6C");

var $lOb8r = parcelRequire("lOb8r");

var $jdSEF = parcelRequire("jdSEF");
parcelRequire("h8k8x");
var $cAPqq = parcelRequire("cAPqq");

var $3jGGb = parcelRequire("3jGGb");

var $1V2cH = parcelRequire("1V2cH");

var $ieLFF = parcelRequire("ieLFF");

var $b8EMT = parcelRequire("b8EMT");

var $bcp2q = parcelRequire("bcp2q");

var $9DwAy = parcelRequire("9DwAy");

var $eh3S5 = parcelRequire("eh3S5");

var $koa1e = parcelRequire("koa1e");

var $diWiU = parcelRequire("diWiU");

var $gx9dc = parcelRequire("gx9dc");

var $2fBti = parcelRequire("2fBti");

var $QvxZa = parcelRequire("QvxZa");

var $h5BP4 = parcelRequire("h5BP4");

var $3h4RJ = parcelRequire("3h4RJ");

var $kjSSV = parcelRequire("kjSSV");

var $3RQyJ = parcelRequire("3RQyJ");

var $gijFh = parcelRequire("gijFh");

var $ixF1M = parcelRequire("ixF1M");

var $79yMH = parcelRequire("79yMH");

var $4b0nc = parcelRequire("4b0nc");

var $3Zv9U = parcelRequire("3Zv9U");

var $jkJ76 = parcelRequire("jkJ76");

var $3ssyD = parcelRequire("3ssyD");

var $4xWO8 = parcelRequire("4xWO8");

var $7BePu = parcelRequire("7BePu");

var $fhmR4 = parcelRequire("fhmR4");

var $ek8yD = parcelRequire("ek8yD");

var $3f4xr = parcelRequire("3f4xr");

var $kpg9c = parcelRequire("kpg9c");

var $8vTDo = parcelRequire("8vTDo");
function $424b86cd01e796e6$export$86fbec116b87613f() {
    const useNewTypography = (0, $8vTDo.useFeatureGate)((0, $kpg9c.AidFrontendFeatureGate).USE_NEW_TYPOGRAPHY);
    (0, $91i6m.useLayoutEffect)(()=>{
        (0, $5KmZU.default)({
            colorMode: 'light',
            typography: useNewTypography ? 'typography' : 'typography-modernized'
        });
    }, [
        useNewTypography
    ]);
    (0, $5e2bj.useGlobalPageState)();
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const defaultTitle = formatMessage((0, $1Aex4.default).headTitle);
    const microbranding = (0, $2aGBJ.useAppSelector)((state)=>state.microbranding);
    const cobranding = (0, $2aGBJ.useAppSelector)((state)=>state.cobranding);
    const dynamicConfigs = (0, $2UbF1.useDynamicConfigs)();
    const isGlobalStateLoading = (0, $2aGBJ.useAppSelector)((state)=>state.globalStateLoading);
    if (isGlobalStateLoading) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $b9U6C.FullScreenSpinnerWrapper), {
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $b9U6C.LoadingSpinner), {
            testId: "global-state-loading-spinner"
        })
    });
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $3jGGb.default), {
        analyticsClient: analyticsClient,
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $lOb8r.default), {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $jdSEF.default), {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cAPqq.BrowserMetricsBoundary), {
                    children: /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $91i6m.Suspense), {
                        fallback: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $b9U6C.LoadingSpinner), {
                            testId: "suspense-loading-spinner"
                        }),
                        children: [
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8KhCJ.default), {
                                defaultTitle: defaultTitle,
                                titleTemplate: `%s - ${defaultTitle}`
                            }, "helmet"),
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $lyaVk.default), {}),
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6IwzG.CobrandingProvider), {
                                value: {
                                    cobranding: (0, $6IwzG.getCurrentCobranding)(cobranding, dynamicConfigs),
                                    isMobileApp: microbranding.isMobileApp
                                },
                                children: /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $27bff.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $4ZSso.jsx)((0, $l2v8Y.Outlet), {}),
                                        /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6VgPx.default), {})
                                    ]
                                }, "screenSizeListener")
                            })
                        ]
                    })
                })
            })
        })
    });
}
const $424b86cd01e796e6$var$TemporaryRedirectHandler = ()=>{
    const data = (0, $l2v8Y.useLoaderData)();
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const navigateSoftOrHard = (0, $9uXJ3.useNavigateSoftOrHard)();
    (0, $91i6m.useLayoutEffect)(()=>{
        if (!data) return;
        if ((0, $5e2bj.isRedirect)(data)) {
            navigateSoftOrHard(data.redirectTo);
            return;
        }
        (0, $lodUs.buildInitialState)(data).then((fullState)=>{
            dispatch((0, $gCn4g.resetAppState)(fullState.initialStoreState));
        }).catch((error)=>{
            console.error('Failed to build initial state in TemporaryRedirectHandler:', error);
        });
    }, [
        data,
        dispatch,
        navigateSoftOrHard
    ]);
    return null;
};
/**
 * Temporary loader to handle edge cases for paths that always redirect to a different path.
 * Currently SIS returns the redirects to the different path.
 * In the future these will be removed when idproxy directs traffic directly to SIS (as opposed to id-frontend first)
 * to return a redirect to those paths.
 */ const $424b86cd01e796e6$var$temporaryRedirectLoader = async ({ request: request })=>{
    if (!await (0, $3f4xr.checkFeatureGateOnceInitialized)((0, $kpg9c.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $5e2bj.fetchFast5GlobalPageState)(request.url);
};
const $424b86cd01e796e6$export$5375cda95f0b0eb4 = (0, $6d87w.createBrowserRouter)([
    {
        element: /*#__PURE__*/ (0, $4ZSso.jsx)($424b86cd01e796e6$export$86fbec116b87613f, {}),
        errorElement: /*#__PURE__*/ (0, $4ZSso.jsx)($424b86cd01e796e6$var$RouterErrorElement, {}),
        children: [
            {
                path: '/2step',
                children: [
                    {
                        index: true,
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.MfaAppsPage), {})
                    },
                    {
                        path: 'enrollment',
                        children: [
                            {
                                index: true,
                                element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.MfaEnrollmentPage), {})
                            },
                            {
                                path: '1-get-app',
                                element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.ChooseMethodPage), {})
                            },
                            {
                                path: '2-configure-app',
                                element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.ConfigureAppPage), {})
                            },
                            {
                                path: '2-configure-phone',
                                element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.ConfigurePhonePage), {})
                            },
                            {
                                path: '2-register-security-key',
                                element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.RegisterSecurityKeyPage), {})
                            },
                            {
                                path: '3-connect-phone',
                                element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.ConfigureAppPage), {
                                    isConnectPhone: true
                                })
                            },
                            {
                                path: '4-save-recovery-key',
                                element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.SaveRecoveryKeyPage), {})
                            },
                            {
                                path: 'add',
                                // These pages are for enrolling multiple methods of MFA
                                // for now these are dummy pages, and is subject to move (path, content, and/or location)
                                children: [
                                    {
                                        path: 'security-key',
                                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.MultiMfaEnrollmentAddSecurityKeyPage), {})
                                    },
                                    {
                                        path: 'authenticator',
                                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.MultiMfaEnrollmentAddAuthenticatorPage), {})
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        path: 'recover',
                        children: [
                            {
                                index: true,
                                element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.RecoveryPage), {}),
                                loader: (0, $eh3S5.recoverLoader)
                            },
                            {
                                path: 'expired',
                                element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.MultiFactorPage), {
                                    isExpired: true
                                }),
                                loader: (0, $gx9dc.recoverExpiredLoader)
                            }
                        ]
                    }
                ]
            },
            {
                path: '/error',
                element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.AuthCallbackErrorPage), {})
            },
            {
                path: '/login',
                children: [
                    {
                        index: true,
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.LoginPage), {}),
                        loader: (0, $b8EMT.loginLoader)
                    },
                    {
                        path: 'cancel-account-deletion',
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.CancelAccountDeletionPage), {}),
                        loader: (0, $9DwAy.cancelAccountDeletionLoader)
                    },
                    {
                        path: 'changepassword',
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.ChangePasswordPage), {}),
                        loader: (0, $3h4RJ.changePasswordLoader)
                    },
                    {
                        path: 'changepassword/p/*',
                        // Used for deeplinking for auth on the mobile apps
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.ChangePasswordPage), {}),
                        loader: (0, $3h4RJ.changePasswordLoader)
                    },
                    {
                        path: 'consent',
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.LoginConsentNoticePage), {}),
                        loader: (0, $3RQyJ.consentLoader)
                    },
                    {
                        path: 'continue-as',
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.ContinueAsPage), {}),
                        loader: (0, $kjSSV.continueAsLoader)
                    },
                    {
                        path: 'deletion-request-confirmation',
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.DeletionRequestConfirmationPage), {})
                    },
                    {
                        path: 'inactive',
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.InactiveAccountPage), {})
                    },
                    {
                        path: 'mfa',
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.MultiFactorPage), {
                            isExpired: false
                        }),
                        loader: (0, $gx9dc.mfaLoader)
                    },
                    {
                        path: 'pending-deletion',
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.PendingDeletionPage), {})
                    },
                    {
                        path: 'remove-account',
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.RemoveAccountPage), {}),
                        loader: (0, $3Zv9U.removeAccountLoader)
                    },
                    {
                        path: 'resetexpiredpassword',
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.ExpiredPasswordPage), {}),
                        loader: (0, $3ssyD.resetExpiredPasswordLoader)
                    },
                    {
                        path: 'resetpassword',
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.ResetPasswordPage), {})
                    },
                    {
                        path: 'select-account',
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.SelectAccountPage), {}),
                        loader: (0, $gijFh.selectAccountLoader)
                    },
                    {
                        path: 'security-screen',
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.MfaPromotePage), {}),
                        loader: (0, $4b0nc.securityScreenLoader)
                    },
                    {
                        path: 'social/confirmation',
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.CreateAccountConfirmationPage), {}),
                        loader: (0, $jkJ76.socialConfirmationLoader)
                    }
                ]
            },
            {
                path: '/logout',
                element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.LogoutPage), {}),
                loader: (0, $diWiU.logoutLoader)
            },
            {
                path: '/mf',
                element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.MultiFactorPage), {
                    isExpired: false
                })
            },
            {
                path: '/security',
                children: [
                    {
                        index: true,
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)($424b86cd01e796e6$var$NavigateToLogin, {})
                    },
                    {
                        // KIRBY-7724: This endpoint doesn't render anything,
                        // but we need to call the backend to get a redirect.
                        // This will be replaced with logic in idproxy to handle the redirect of requests to this path
                        // directly to SIS (to immediately return the redirect result) instead of id-frontend as it's being handled now.
                        path: 'auth-alert-action',
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)($424b86cd01e796e6$var$TemporaryRedirectHandler, {}),
                        loader: $424b86cd01e796e6$var$temporaryRedirectLoader
                    },
                    {
                        path: 'expiredlink',
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.SecurityExpiredLinkPage), {})
                    },
                    {
                        path: 'successfulreset',
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.SecuritySuccessPage), {
                            successType: "password-reset"
                        })
                    },
                    {
                        path: 'successfulverification',
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.SecuritySuccessPage), {
                            successType: "verification"
                        })
                    }
                ]
            },
            {
                path: '/signup',
                children: [
                    {
                        index: true,
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)($424b86cd01e796e6$var$SignupCommercial, {}),
                        loader: (0, $bcp2q.signupLoader)
                    },
                    {
                        path: 'onboard',
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)($424b86cd01e796e6$var$SignupOnboardCommercial, {})
                    },
                    {
                        // KIRBY-7259: SIS redirects /signup/invite/* to /signup/welcome/*
                        // This is a temporary fix to handle the redirect for SAS Fast5
                        // This will be replaced with logic in idproxy to handle the redirect of requests to this path
                        // directly to SIS (to immediately return the redirect result) instead of id-frontend as it's being handled now.
                        path: 'invite/*',
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)($424b86cd01e796e6$var$TemporaryRedirectHandler, {}),
                        loader: $424b86cd01e796e6$var$temporaryRedirectLoader
                    },
                    {
                        path: 'migrate-confirmation',
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.MigrateAccountConfirmationPage), {}),
                        loader: (0, $4xWO8.migrateConfirmationLoader)
                    },
                    {
                        path: 'welcome',
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.WelcomePage), {}),
                        loader: (0, $fhmR4.welcomeLoader)
                    },
                    /**
     * The standalone `/welcome/p/loom-create-workspace` page is a step in Loom's signup
     * flow where an existing Atlassian user creates a Loom workspace when creating a new Loom account.
     * In the more common Loom signup flow path where a user is new to Atlassian and Loom,
     * the workspace creation step is shown on the `/welcome` route after a user fills in their name and password.
     * If a user is new to Loom but already exists in Atlassian, this step needs to be hosted
     * on its own page since the login flow requires a redirect.
     *
     * This page will be moved to be hosted on Loom and removed from IDAC once Loom has integrated
     * with Atlassian Identity and can make authenticated requests via Edge Authenticator.
     * See epic: https://useloom.atlassian.net/browse/ID-256
     */ {
                        path: 'welcome/p/loom-create-workspace',
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.AuthenticatedLoomWorkspaceCreationPage), {}),
                        // Loom's custom page relies on some page state from the general welcome page
                        loader: (0, $fhmR4.welcomeLoader)
                    },
                    {
                        path: 'welcome/p/*',
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.WelcomePage), {}),
                        loader: (0, $fhmR4.welcomeLoader)
                    },
                    // Used for deeplinking for auth on the mobile apps
                    {
                        path: 'welcome/sent',
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.WelcomeSentPage), {}),
                        loader: (0, $ek8yD.welcomeSentLoader)
                    },
                    {
                        path: 'verify-email/otp',
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.VerifyEmailOtpPage), {}),
                        loader: (0, $7BePu.signupVerifyEmailOtpLoader)
                    }
                ]
            },
            {
                path: '/social/recovery',
                element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.SocialLoginRecoveryPage), {}),
                loader: (0, $koa1e.socialRecoveryLoader)
            },
            {
                path: '/step-up',
                children: [
                    {
                        path: 'start',
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.StepUpStartPage), {}),
                        loader: (0, $QvxZa.stepUpStartLoader)
                    },
                    {
                        path: 'sso',
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.StepUpSsoPage), {}),
                        loader: (0, $h5BP4.stepUpSsoLoader)
                    }
                ]
            },
            {
                path: '/verify-email/*',
                children: [
                    {
                        path: 'change-email',
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.EmailConfirmationPage), {}),
                        loader: (0, $2fBti.changeEmailLoader)
                    },
                    {
                        path: 'sent',
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.VerifyOrReverifyEmailSentPage), {}),
                        loader: (0, $79yMH.verifyEmailSentLoader)
                    },
                    {
                        path: '*',
                        element: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.VerifyOrReverifyEmailErrorPage), {}),
                        loader: (0, $ixF1M.verifyEmailLoader)
                    }
                ]
            }
        ]
    }
], {
    future: (0, $ieLFF.reactRouterFutureFlags)
});
function $424b86cd01e796e6$var$SignupCommercial() {
    if ((0, $bqdjD.getCurrentCloudType)() === 'commercial') return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.SignupPage), {});
    return /*#__PURE__*/ (0, $4ZSso.jsx)($424b86cd01e796e6$var$NavigateToLogin, {});
}
function $424b86cd01e796e6$var$SignupOnboardCommercial() {
    if ((0, $bqdjD.getCurrentCloudType)() === 'commercial') return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gxUYA.SignupOnboardPage), {});
    return /*#__PURE__*/ (0, $4ZSso.jsx)($424b86cd01e796e6$var$NavigateToLogin, {});
}
function $424b86cd01e796e6$var$NavigateToLogin() {
    const { search: search } = (0, $l2v8Y.useLocation)();
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $l2v8Y.Navigate), {
        to: {
            pathname: '/login',
            search: search
        },
        replace: true
    });
}
function $424b86cd01e796e6$var$RouterErrorElement() {
    const error = (0, $l2v8Y.useRouteError)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    if ((0, $exhS2.isRouteErrorResponse)(error) && error.status === 404) {
        analyticsClient.trackingEvent({
            page: 'RouterErrorElement',
            action: 'error',
            subject: 'routeNotFound'
        });
        return /*#__PURE__*/ (0, $4ZSso.jsx)($424b86cd01e796e6$var$NavigateToLogin, {});
    }
    // rethrow to let the parent error boundary handle it
    throw error;
}

});
parcelRegister("5KmZU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42f316766a3671bb$export$2e2bcd8739ae039; });

var $2R76C = parcelRequire("2R76C");

var $eWMMH = parcelRequire("eWMMH");

var $f1k1y = parcelRequire("f1k1y");

var $3cRMM = parcelRequire("3cRMM");

var $h3wUQ = parcelRequire("h3wUQ");

var $7JZQj = parcelRequire("7JZQj");

var $a1G56 = parcelRequire("a1G56");

var $2KjST = parcelRequire("2KjST");

var $7oWRv = parcelRequire("7oWRv");
function $42f316766a3671bb$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $42f316766a3671bb$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $42f316766a3671bb$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $42f316766a3671bb$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $42f316766a3671bb$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $42f316766a3671bb$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $42f316766a3671bb$var$setGlobalTheme = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee3() {
        var _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeLoader, themeState, themePreferences, loadingStrategy, loadingTasks, mode, attrOfMissingCustomStyles, themeOverridePreferences, _iterator, _step, themeId, autoUnbind, _args3 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _ref2 = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {}, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $3cRMM.themeStateDefaults)['colorMode'] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $3cRMM.themeStateDefaults)['contrastMode'] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $3cRMM.themeStateDefaults)['dark'] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $3cRMM.themeStateDefaults)['light'] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $3cRMM.themeStateDefaults)['shape'] : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $3cRMM.themeStateDefaults)['spacing'] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $3cRMM.themeStateDefaults)['typography']() : _ref2$typography, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $3cRMM.themeStateDefaults)['UNSAFE_themeOptions'] : _ref2$UNSAFE_themeOpt;
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $f1k1y.fg)('platform_increased-contrast-themes')) {
                        if (light === 'light-increased-contrast') light = 'light';
                        if (dark === 'dark-increased-contrast') dark = 'dark';
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $2KjST.getThemePreferences)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $7oWRv.loadAndAppendThemeCss); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 2;
                                        return loadingStrategy(themeId);
                                    case 2:
                                        return _context.abrupt("return", _context.sent);
                                    case 3:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }()); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $h3wUQ.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $3cRMM.themeStateDefaults)['colorMode'];
                        attrOfMissingCustomStyles = (0, $a1G56.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee2$(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 2;
                                        return (parcelRequire("3KO8O"));
                                    case 2:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 5:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 10;
                    return Promise.all(loadingTasks);
                case 10:
                    // Load override themes after standard themes
                    themeOverridePreferences = (0, $2KjST.getThemeOverridePreferences)(themeState);
                    _iterator = $42f316766a3671bb$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 12;
                    _iterator.s();
                case 14:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 20;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 18;
                    return loadingStrategy(themeId);
                case 18:
                    _context3.next = 14;
                    break;
                case 20:
                    _context3.next = 25;
                    break;
                case 22:
                    _context3.prev = 22;
                    _context3.t0 = _context3["catch"](12);
                    _iterator.e(_context3.t0);
                case 25:
                    _context3.prev = 25;
                    _iterator.f();
                    return _context3.finish(25);
                case 28:
                    autoUnbind = (0, $7JZQj.default)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 30:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                12,
                22,
                25,
                28
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();
var $42f316766a3671bb$export$2e2bcd8739ae039 = $42f316766a3671bb$var$setGlobalTheme;

});
parcelRegister("7JZQj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a2cb5141c5dd9bb$export$2e2bcd8739ae039; });

var $5YM7L = parcelRequire("5YM7L");

var $f1k1y = parcelRequire("f1k1y");

var $6R24S = parcelRequire("6R24S");

var $37vOC = parcelRequire("37vOC");

var $86Wcd = parcelRequire("86Wcd");
function $5a2cb5141c5dd9bb$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $37vOC.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $37vOC.default).bind();
    } else (0, $37vOC.default).unbind();
    if ((0, $f1k1y.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $86Wcd.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $86Wcd.default).bind();
        } else (0, $86Wcd.default).unbind();
    }
    var themeAttributes = (0, $6R24S.default)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $37vOC.default).unbind();
        if ((0, $f1k1y.fg)('platform_increased-contrast-themes')) (0, $86Wcd.default).unbind();
    };
}

});
parcelRegister("6R24S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4fd94de4f8729e44$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");

var $f1k1y = parcelRequire("f1k1y");

var $2S8bR = parcelRequire("2S8bR");

var $3cRMM = parcelRequire("3cRMM");

var $2HO6u = parcelRequire("2HO6u");

var $h3wUQ = parcelRequire("h3wUQ");

var $avbPF = parcelRequire("avbPF");
function $4fd94de4f8729e44$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4fd94de4f8729e44$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4fd94de4f8729e44$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4fd94de4f8729e44$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4fd94de4f8729e44$var$defaultColorMode = 'light';
var $4fd94de4f8729e44$var$defaultContrastMode = 'no-preference';
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ var $4fd94de4f8729e44$var$getThemeHtmlAttrs = function getThemeHtmlAttrs() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $3cRMM.themeStateDefaults)['colorMode'] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $3cRMM.themeStateDefaults)['dark'] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $3cRMM.themeStateDefaults)['light'] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $3cRMM.themeStateDefaults)['contrastMode'] : _ref$contrastMode, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $3cRMM.themeStateDefaults)['shape'] : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $3cRMM.themeStateDefaults)['spacing'] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $3cRMM.themeStateDefaults)['typography']() : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $3cRMM.themeStateDefaults)['UNSAFE_themeOptions'] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $2HO6u.themeObjectToString)({
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, (0, $2S8bR.THEME_DATA_ATTRIBUTE), themeAttribute), (0, $2S8bR.COLOR_MODE_ATTRIBUTE), colorMode === 'auto' ? $4fd94de4f8729e44$var$defaultColorMode : colorMode);
    if ((0, $f1k1y.fg)('platform_increased-contrast-themes')) result = $4fd94de4f8729e44$var$_objectSpread($4fd94de4f8729e44$var$_objectSpread({}, result), {}, (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, (0, $2S8bR.CONTRAST_MODE_ATTRIBUTE), contrastMode === 'auto' ? $4fd94de4f8729e44$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $h3wUQ.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $avbPF.hash)(optionString);
        result[0, $2S8bR.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $4fd94de4f8729e44$export$2e2bcd8739ae039 = $4fd94de4f8729e44$var$getThemeHtmlAttrs;

});

parcelRegister("37vOC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $245ab4694b6d49b7$export$2e2bcd8739ae039; });

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $dsN6L = parcelRequire("dsN6L");

var $aA6j8 = parcelRequire("aA6j8");

var $2S8bR = parcelRequire("2S8bR");

var $7oWRv = parcelRequire("7oWRv");
var $245ab4694b6d49b7$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $245ab4694b6d49b7$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $2S8bR.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
var $245ab4694b6d49b7$var$darkModeMql = $245ab4694b6d49b7$var$isMatchMediaAvailable && window.matchMedia((0, $7oWRv.darkModeMediaQuery));
var $245ab4694b6d49b7$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, ColorModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "unbindThemeChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$245ab4694b6d49b7$var$darkModeMql) return 'light';
                return $245ab4694b6d49b7$var$darkModeMql !== null && $245ab4694b6d49b7$var$darkModeMql !== void 0 && $245ab4694b6d49b7$var$darkModeMql.matches ? 'dark' : 'light';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($245ab4694b6d49b7$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $aA6j8.bind)($245ab4694b6d49b7$var$darkModeMql, {
                    type: 'change',
                    listener: $245ab4694b6d49b7$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $245ab4694b6d49b7$var$SingletonColorModeObserver = new $245ab4694b6d49b7$var$ColorModeObserver();
var $245ab4694b6d49b7$export$2e2bcd8739ae039 = $245ab4694b6d49b7$var$SingletonColorModeObserver;

});
parcelRegister("7oWRv", function(module, exports) {

$parcel$export(module.exports, "loadAndAppendThemeCss", function () { return $56386f0e65bdee3d$export$26cd7ae85c7144e5; });
$parcel$export(module.exports, "darkModeMediaQuery", function () { return $56386f0e65bdee3d$export$bb1e815119d30f8b; });
$parcel$export(module.exports, "moreContrastMediaQuery", function () { return $56386f0e65bdee3d$export$8662df6937d86fcb; });

var $2R76C = parcelRequire("2R76C");

var $eWMMH = parcelRequire("eWMMH");

var $f1k1y = parcelRequire("f1k1y");

var $iSXWj = parcelRequire("iSXWj");

var $2S8bR = parcelRequire("2S8bR");
var $56386f0e65bdee3d$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee(themeId) {
        var themeCss, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $2S8bR.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]:not([").concat((0, $2S8bR.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (themeId) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    _context.next = 6;
                    return $56386f0e65bdee3d$export$8a48286ed7df6720(themeId);
                case 6:
                    themeCss = _context.sent;
                    style = document.createElement('style');
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $56386f0e65bdee3d$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee2(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    if ((themeId === 'light' || themeId === 'dark') && (0, $f1k1y.fg)('platform-component-visual-refresh')) themeId += '-brand-refresh';
                    _context2.next = 3;
                    return (0, $iSXWj.default)[themeId]();
                case 3:
                    _yield$themeImportMap = _context2.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context2.abrupt("return", themeCss);
                case 6:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function loadThemeCss(_x2) {
        return _ref2.apply(this, arguments);
    };
}();
var $56386f0e65bdee3d$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
var $56386f0e65bdee3d$export$8662df6937d86fcb = '(prefers-contrast: more)';

});
parcelRegister("iSXWj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbfbc3e6c9b5ae46$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::3db020c00d91d31fe8e413b082708618>>
 * @codegenCommand yarn build tokens
 */ 

















var $dbfbc3e6c9b5ae46$var$themeImportsMap = {
    'light': function light() {
        return (parcelRequire("jcEtw"));
    },
    'light-future': function lightFuture() {
        return (parcelRequire("0X6Ox"));
    },
    'light-increased-contrast': function lightIncreasedContrast() {
        return (parcelRequire("l7b0Y"));
    },
    'dark': function dark() {
        return (parcelRequire("kZs0h"));
    },
    'dark-future': function darkFuture() {
        return (parcelRequire("5lmw3"));
    },
    'dark-increased-contrast': function darkIncreasedContrast() {
        return (parcelRequire("frqnA"));
    },
    'legacy-light': function legacyLight() {
        return (parcelRequire("iehR7"));
    },
    'legacy-dark': function legacyDark() {
        return (parcelRequire("fpoT2"));
    },
    'spacing': function spacing() {
        return (parcelRequire("g9XbK"));
    },
    'typography': function typography() {
        return (parcelRequire("51YXZ"));
    },
    'typography-adg3': function typographyAdg3() {
        return (parcelRequire("5dIoA"));
    },
    'shape': function shape() {
        return (parcelRequire("gCicQ"));
    },
    'shape-rounder': function shapeRounder() {
        return (parcelRequire("7QiVh"));
    },
    'shape-roundest': function shapeRoundest() {
        return (parcelRequire("dd6zN"));
    },
    'typography-modernized': function typographyModernized() {
        return (parcelRequire("6Y5O2"));
    },
    'typography-refreshed': function typographyRefreshed() {
        return (parcelRequire("lvGYg"));
    },
    'light-brand-refresh': function lightBrandRefresh() {
        return (parcelRequire("iSUD9"));
    },
    'dark-brand-refresh': function darkBrandRefresh() {
        return (parcelRequire("iSykp"));
    }
};
var $dbfbc3e6c9b5ae46$export$2e2bcd8739ae039 = $dbfbc3e6c9b5ae46$var$themeImportsMap;

});



parcelRegister("86Wcd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e7c06c651d82b35$export$2e2bcd8739ae039; });

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $dsN6L = parcelRequire("dsN6L");

var $aA6j8 = parcelRequire("aA6j8");

var $2S8bR = parcelRequire("2S8bR");

var $7oWRv = parcelRequire("7oWRv");
var $5e7c06c651d82b35$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $5e7c06c651d82b35$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $2S8bR.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
var $5e7c06c651d82b35$var$contrastModeMql = $5e7c06c651d82b35$var$isMatchMediaAvailable && window.matchMedia((0, $7oWRv.moreContrastMediaQuery));
var $5e7c06c651d82b35$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, ContrastModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "unbindContrastChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$5e7c06c651d82b35$var$contrastModeMql) return 'no-preference';
                return $5e7c06c651d82b35$var$contrastModeMql !== null && $5e7c06c651d82b35$var$contrastModeMql !== void 0 && $5e7c06c651d82b35$var$contrastModeMql.matches ? 'more' : 'no-preference';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($5e7c06c651d82b35$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $aA6j8.bind)($5e7c06c651d82b35$var$contrastModeMql, {
                    type: 'change',
                    listener: $5e7c06c651d82b35$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $5e7c06c651d82b35$var$SingletonContrastModeObserver = new $5e7c06c651d82b35$var$ContrastModeObserver();
var $5e7c06c651d82b35$export$2e2bcd8739ae039 = $5e7c06c651d82b35$var$SingletonContrastModeObserver;

});


parcelRegister("2KjST", function(module, exports) {

$parcel$export(module.exports, "getThemePreferences", function () { return $1fff4d3f5538112f$export$dd6aeb7c823fc03d; });
$parcel$export(module.exports, "getThemeOverridePreferences", function () { return $1fff4d3f5538112f$export$5d76d7014f4a5d08; });

var $iqLBO = parcelRequire("iqLBO");

var $f1k1y = parcelRequire("f1k1y");

var $kzkkt = parcelRequire("kzkkt");
var $1fff4d3f5538112f$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $f1k1y.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $kzkkt.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $f1k1y.fg)('platform_increased-contrast-themes')) {
            var increasedContrastTheme = (0, $kzkkt.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(new Set(themePreferences));
};
var $1fff4d3f5538112f$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(_themeState) {
    var themeOverridePreferences = [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(new Set(themeOverridePreferences));
};

});
parcelRegister("kzkkt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef96d88154f38653$export$2e2bcd8739ae039; });

var $5YM7L = parcelRequire("5YM7L");

var $3cRMM = parcelRequire("3cRMM");
function $ef96d88154f38653$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $3cRMM.default)).find(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}

});



parcelRegister("27bff", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7bec8fe203458234$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $9jjaN = parcelRequire("9jjaN");

var $91i6m = parcelRequire("91i6m");
parcelRequire("iCwDt");
var $bBJZC = parcelRequire("bBJZC");

var $26Riy = parcelRequire("26Riy");

var $kYTnm = parcelRequire("kYTnm");
let $7bec8fe203458234$var$_ = (t)=>t, $7bec8fe203458234$var$t;
const $7bec8fe203458234$var$FullHeightContainer = (0, $9jjaN.default).div($7bec8fe203458234$var$t || ($7bec8fe203458234$var$t = $7bec8fe203458234$var$_`
  height: 100%;
`));
const $7bec8fe203458234$var$DeviceTypeListener = ({ dispatch: dispatch, children: children })=>{
    (0, $91i6m.useEffect)(()=>{
        if (!(0, $26Riy.screenSizeMatcher)) return;
        const onScreenSizeUpdated = ({ matches: matches })=>{
            dispatch((0, $kYTnm.screenSizeUpdated)(matches ? 'mobile' : 'desktop'));
        };
        try {
            /**
       * Improved API but supported by only ~94.2% of browsers
       * https://caniuse.com/mdn-api_mediaquerylist_change_event
       */ (0, $26Riy.screenSizeMatcher).addEventListener('change', onScreenSizeUpdated);
            return ()=>(0, $26Riy.screenSizeMatcher).removeEventListener('change', onScreenSizeUpdated);
        } catch (e) {
            /**
       * These methods are deprecated but needed as fallbacks for browsers older than:
       * - Edge 79 (released 2020-01)
       * - Safari 14 (released 2020-09)
       * - Safari on iOS 14 (released 2020-09)
       *
       * All other browsers have had support since 2014-2017.
       * https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList/change_event
       */ (0, $26Riy.screenSizeMatcher).addListener(onScreenSizeUpdated);
            return ()=>(0, $26Riy.screenSizeMatcher).removeListener(onScreenSizeUpdated);
        }
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)($7bec8fe203458234$var$FullHeightContainer, {
        children: children
    });
};
var $7bec8fe203458234$export$2e2bcd8739ae039 = (0, $bBJZC.default)()($7bec8fe203458234$var$DeviceTypeListener);

});
parcelRegister("kYTnm", function(module, exports) {

$parcel$export(module.exports, "screenSizeUpdated", function () { return $46b4cadd5dd22775$export$92b52f782097f1e7; });
const $46b4cadd5dd22775$export$92b52f782097f1e7 = (screenSize)=>({
        type: 'SCREEN_SIZE_UPDATED',
        screenSize: screenSize
    });

});


parcelRegister("1Aex4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $caf776c0e71fb66f$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $caf776c0e71fb66f$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    headTitle: {
        id: 'default.head.title',
        defaultMessage: 'Log in with Atlassian account'
    }
});

});

parcelRegister("6VgPx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4e3521de11a92f6$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $9jjaN = parcelRequire("9jjaN");

var $5gYpb = parcelRequire("5gYpb");
var $l774Y = parcelRequire("l774Y");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");

var $1pjMo = parcelRequire("1pjMo");

var $daZRO = parcelRequire("daZRO");

var $leG06 = parcelRequire("leG06");

var $21Xgy = parcelRequire("21Xgy");

var $2aGBJ = parcelRequire("2aGBJ");
let $a4e3521de11a92f6$var$_ = (t)=>t, $a4e3521de11a92f6$var$t;
// We need to wrap the flag in a div to apply responsive styles so
// the flag are always visible on smaller viewports.
const $a4e3521de11a92f6$var$ResponsiveFlagWrapper = (0, $9jjaN.default).div($a4e3521de11a92f6$var$t || ($a4e3521de11a92f6$var$t = $a4e3521de11a92f6$var$_`
  [role='alert'] {
    max-width: calc(100vw - ${0}px);
  }
`), (0, $6e88g.gridSize)() * 11);
const $a4e3521de11a92f6$export$1fe549a730923236 = ()=>{
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const flags = (0, $2aGBJ.useAppSelector)((state)=>state.flags.flags);
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const toFlagComponent = (flag)=>{
        const icon = flag.type === 'success' ? /*#__PURE__*/ (0, $4ZSso.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1pjMo))), {
            label: "Success",
            primaryColor: (0, $kLNLK).G300
        }) : /*#__PURE__*/ (0, $4ZSso.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($daZRO))), {
            label: "Error",
            primaryColor: (0, $kLNLK).R300
        });
        return /*#__PURE__*/ (0, $4ZSso.jsx)($a4e3521de11a92f6$var$ResponsiveFlagWrapper, {
            id: flag.id,
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $5gYpb.default), {
                id: flag.id || '',
                title: formatMessage(flag.title),
                description: formatMessage(flag.description),
                icon: icon,
                onDismissed: ()=>dispatch((0, $21Xgy.dismissFlag)())
            })
        }, flag.id);
    };
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $l774Y.default), {
        children: flags.map(toFlagComponent)
    });
};
var $a4e3521de11a92f6$export$2e2bcd8739ae039 = $a4e3521de11a92f6$export$1fe549a730923236;

});
parcelRegister("5gYpb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d6d4d9302fe2edd$export$2e2bcd8739ae039; });
/* flag.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $dsN6L = parcelRequire("dsN6L");

var $5YM7L = parcelRequire("5YM7L");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");
var $5oJNc = parcelRequire("5oJNc");

var $koa2c = parcelRequire("koa2c");

var $6A0cm = parcelRequire("6A0cm");

var $4jXgk = parcelRequire("4jXgk");

var $aDWwl = parcelRequire("aDWwl");
var $dwV3h = parcelRequire("dwV3h");
var $hPyLR = parcelRequire("hPyLR");

var $kQU6o = parcelRequire("kQU6o");

var $jKLNt = parcelRequire("jKLNt");

var $9zuaG = parcelRequire("9zuaG");

var $l774Y = parcelRequire("l774Y");

var $fk4ke = parcelRequire("fk4ke");
var $95j1K = parcelRequire("95j1K");

var $3VuzU = parcelRequire("3VuzU");
function $3d6d4d9302fe2edd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3d6d4d9302fe2edd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3d6d4d9302fe2edd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3d6d4d9302fe2edd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3d6d4d9302fe2edd$var$styles = {
    overflowWrap: "_1i4qfg65",
    flag: "_2rkofajl _1reo15vq _18m915vq _v564z97a _16qs8sq4 _1pbyni7l _1bsb1osq"
};
var $3d6d4d9302fe2edd$var$CSS_VAR_ICON_COLOR = '--flag-icon-color';
var $3d6d4d9302fe2edd$var$descriptionStyles = null;
var $3d6d4d9302fe2edd$var$iconWrapperStyles = null;
var $3d6d4d9302fe2edd$var$flagWrapperStyles = null;
var $3d6d4d9302fe2edd$var$analyticsAttributes = {
    componentName: 'flag',
    packageName: "@atlaskit/flag",
    packageVersion: "17.4.1"
};
var $3d6d4d9302fe2edd$var$transitionStyles = null;
/**
 * __Flag__
 *
 * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
 * often displayed using a flag group.
 *
 * - [Examples](https://atlassian.design/components/flag/examples)
 * - [Code](https://atlassian.design/components/flag/code)
 * - [Usage](https://atlassian.design/components/flag/usage)
 */ var $3d6d4d9302fe2edd$var$Flag = function Flag(props) {
    var _props$actions = props.actions, actions = _props$actions === void 0 ? [] : _props$actions, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? (0, $jKLNt.DEFAULT_APPEARANCE) : _props$appearance, icon = props.icon, title = props.title, description = props.description, linkComponent = props.linkComponent, onMouseOver = props.onMouseOver, _props$onFocus = props.onFocus, onFocus = _props$onFocus === void 0 ? (0, $6A0cm.default) : _props$onFocus, onMouseOut = props.onMouseOut, _props$onBlur = props.onBlur, onBlur = _props$onBlur === void 0 ? (0, $6A0cm.default) : _props$onBlur, _props$onDismissed = props.onDismissed, onDismissedProp = _props$onDismissed === void 0 ? (0, $6A0cm.default) : _props$onDismissed, testId = props.testId, id = props.id, analyticsContext = props.analyticsContext, delayAnnouncement = props.delayAnnouncement, _props$headingLevel = props.headingLevel, headingLevel = _props$headingLevel === void 0 ? 2 : _props$headingLevel;
    var _useState = (0, $91i6m.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), isDelayToAnnounce = _useState2[0], setIsDelayToAnnounce = _useState2[1];
    var _useFlagGroup = (0, $l774Y.useFlagGroup)(), onDismissedFromFlagGroup = _useFlagGroup.onDismissed, isDismissAllowed = _useFlagGroup.isDismissAllowed;
    var onDismissed = (0, $91i6m.useCallback)(function(id, analyticsEvent) {
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    var _useState3 = (0, $91i6m.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState3, 2), isExpanded = _useState4[0], setIsExpanded = _useState4[1];
    var onDismissedAnalytics = (0, $koa2c.usePlatformLeafEventHandler)($3d6d4d9302fe2edd$var$_objectSpread({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext
    }, $3d6d4d9302fe2edd$var$analyticsAttributes));
    var isBold = appearance !== (0, $jKLNt.DEFAULT_APPEARANCE);
    var toggleExpand = (0, $91i6m.useCallback)(function() {
        setIsExpanded(function(previous) {
            return !previous;
        });
    }, []);
    var buttonActionCallback = (0, $91i6m.useCallback)(function() {
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, $91i6m.useEffect)(function() {
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    (0, $91i6m.useEffect)(function() {
        if (!delayAnnouncement) return;
        setTimeout(function() {
            setIsDelayToAnnounce(true);
        }, delayAnnouncement);
    }, [
        delayAnnouncement
    ]);
    var onFocusAnalytics = (0, $koa2c.usePlatformLeafEventHandler)($3d6d4d9302fe2edd$var$_objectSpread({
        fn: onFocus,
        action: 'focused',
        analyticsData: analyticsContext
    }, $3d6d4d9302fe2edd$var$analyticsAttributes));
    var onBlurAnalytics = (0, $koa2c.usePlatformLeafEventHandler)($3d6d4d9302fe2edd$var$_objectSpread({
        fn: onBlur,
        action: 'blurred',
        analyticsData: analyticsContext
    }, $3d6d4d9302fe2edd$var$analyticsAttributes));
    var autoDismissProps = {
        onMouseOver: onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut: onMouseOut,
        onBlur: onBlurAnalytics
    };
    var textColor = (0, $3VuzU.flagTextColor)[appearance];
    var iconColor = (0, $3VuzU.flagIconColor)[appearance];
    var iconGlyph = (0, $3VuzU.flagIconGlyph)[appearance];
    var isDismissable = isBold || isDismissAllowed;
    var shouldRenderGap = !isBold && (description || actions.length) || isExpanded;
    // when delayAnnouncement is available we will use a hidden content for announcement
    var delayedAnnouncement = delayAnnouncement ? /*#__PURE__*/ $91i6m.createElement((0, $kQU6o.default), null, title, description) : undefined;
    return /*#__PURE__*/ $91i6m.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        role: "alert",
        "data-testid": testId
    }, autoDismissProps, {
        className: (0, $9gzWK.default)([
            "_1bsb1osq"
        ])
    }), /*#__PURE__*/ $91i6m.createElement((0, $aDWwl.default), {
        padding: "space.200",
        backgroundColor: (0, $3VuzU.flagBackgroundColor)[appearance],
        xcss: $3d6d4d9302fe2edd$var$styles.flag
    }, /*#__PURE__*/ $91i6m.createElement((0, $dwV3h.default), {
        alignBlock: "start",
        space: "space.200"
    }, /*#__PURE__*/ $91i6m.createElement("div", {
        "data-testid": testId && "".concat(testId, "-icon-container"),
        className: (0, $9gzWK.default)([
            "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf _syaz16r9"
        ]),
        style: $3d6d4d9302fe2edd$var$_objectSpread($3d6d4d9302fe2edd$var$_objectSpread({}, (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, $3d6d4d9302fe2edd$var$CSS_VAR_ICON_COLOR, iconColor)), {}, {
            "--_11v68d2": (0, $5oJNc.default)("var(".concat($3d6d4d9302fe2edd$var$CSS_VAR_ICON_COLOR, ")"))
        })
    }, icon || iconGlyph), /*#__PURE__*/ $91i6m.createElement("span", {
        className: (0, $9gzWK.default)([
            "_v5641hdc _16jlkb7n"
        ])
    }, /*#__PURE__*/ $91i6m.createElement((0, $hPyLR.default), {
        space: shouldRenderGap ? 'space.100' : 'space.0' // Gap exists even when not expanded due to Expander internals always being in the DOM
    }, isDelayToAnnounce && delayedAnnouncement, /*#__PURE__*/ $91i6m.createElement((0, $dwV3h.default), {
        alignBlock: "stretch",
        space: "space.100",
        spread: "space-between"
    }, /*#__PURE__*/ $91i6m.createElement((0, $aDWwl.default), {
        paddingBlockStart: "space.050",
        paddingBlockEnd: "space.025",
        xcss: $3d6d4d9302fe2edd$var$styles.overflowWrap
    }, /*#__PURE__*/ $91i6m.createElement((0, $4jXgk.default), {
        as: "h".concat(headingLevel),
        size: "xsmall",
        color: textColor
    }, /*#__PURE__*/ $91i6m.createElement("span", {
        /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ "aria-hidden": isDelayToAnnounce
    }, title))), isDismissable ? !(isBold && !description && !actions.length) && /*#__PURE__*/ $91i6m.createElement((0, $fk4ke.default), {
        testId: testId,
        appearance: appearance,
        isBold: isBold,
        isExpanded: isExpanded,
        onClick: isBold ? toggleExpand : buttonActionCallback
    }) : null), /*#__PURE__*/ $91i6m.createElement((0, $95j1K.default), {
        isExpanded: !isBold || isExpanded,
        testId: testId
    }, description && /*#__PURE__*/ $91i6m.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            color: (0, $3VuzU.flagTextColorToken)[appearance]
        },
        "data-testid": testId && "".concat(testId, "-description"),
        "aria-hidden": isDelayToAnnounce,
        className: (0, $9gzWK.default)([
            "_11c82smr _1reo1wug _18m91wug _c71l53f4 _1i4qfg65"
        ])
    }, description), /*#__PURE__*/ $91i6m.createElement((0, $9zuaG.default), {
        actions: actions,
        appearance: appearance,
        linkComponent: linkComponent,
        testId: testId
    })))))));
};
var $3d6d4d9302fe2edd$export$2e2bcd8739ae039 = $3d6d4d9302fe2edd$var$Flag;

});
parcelRegister("jKLNt", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_APPEARANCE", function () { return $e61763ab833c47ba$export$d6830277b06edd6; });
var $e61763ab833c47ba$export$d6830277b06edd6 = 'normal';

});

parcelRegister("9zuaG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f7ec95c0ef0dd66$export$2e2bcd8739ae039; });
/* flag-actions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");
var $5oJNc = parcelRequire("5oJNc");

var $gfsDP = parcelRequire("gfsDP");

var $dwV3h = parcelRequire("dwV3h");

var $jKLNt = parcelRequire("jKLNt");

var $3VuzU = parcelRequire("3VuzU");
function $6f7ec95c0ef0dd66$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6f7ec95c0ef0dd66$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6f7ec95c0ef0dd66$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6f7ec95c0ef0dd66$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6f7ec95c0ef0dd66$var$buttonStyles = null;
var $6f7ec95c0ef0dd66$var$fontStyles = null;
var $6f7ec95c0ef0dd66$var$appearanceNormalButtonStyles = null;
var $6f7ec95c0ef0dd66$var$appearanceNormalActionsContainerStyles = null;
var $6f7ec95c0ef0dd66$var$FlagActions = function FlagActions(props) {
    var _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? (0, $jKLNt.DEFAULT_APPEARANCE) : _props$appearance, _props$actions = props.actions, actions = _props$actions === void 0 ? [] : _props$actions, linkComponent = props.linkComponent, testId = props.testId;
    if (!actions.length) return null;
    var isBold = appearance !== (0, $jKLNt.DEFAULT_APPEARANCE);
    return /*#__PURE__*/ $91i6m.createElement("span", {
        className: (0, $9gzWK.default)([
            !isBold && "_1g4l107e _y8dn107e",
            "_11c82smr"
        ])
    }, /*#__PURE__*/ $91i6m.createElement((0, $dwV3h.default), {
        space: "space.100",
        shouldWrap: true,
        alignBlock: "center",
        separator: isBold ? undefined : "\xb7",
        testId: testId && "".concat(testId, "-actions")
    }, actions.map(function(action, index) {
        return /*#__PURE__*/ $91i6m.createElement((0, $gfsDP.default), {
            onClick: action.onClick,
            href: action.href,
            target: action.target,
            appearance: isBold ? 'default' : 'link',
            component: linkComponent,
            spacing: "compact",
            testId: action.testId,
            key: index,
            className: (0, $9gzWK.default)([
                "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _1ku2grf3 _1v8mgrf3 _gbuigrf3 _1dwvgrf3 _1bk69tn6 _1wy69tn6 _b3g39tn6 _eqps9tn6 _ow071r31 _1p6b1r31 _8dbm1r31 _77mc1r31 _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                appearance === (0, $jKLNt.DEFAULT_APPEARANCE) && "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
            ]),
            style: $6f7ec95c0ef0dd66$var$_objectSpread($6f7ec95c0ef0dd66$var$_objectSpread({}, {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                '--color': (0, $3VuzU.actionTextColor)[appearance],
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color': (0, $3VuzU.actionBackgroundColor)[appearance].default,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color-hover': (0, $3VuzU.actionBackgroundColor)[appearance].pressed,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color-active': (0, $3VuzU.actionBackgroundColor)[appearance].active
            }), {}, {
                "--_zkfc5e": (0, $5oJNc.default)("var(--ds-space-100, 8px)".concat(" !important"))
            })
        }, action.content);
    })));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6f7ec95c0ef0dd66$export$2e2bcd8739ae039 = $6f7ec95c0ef0dd66$var$FlagActions;

});
parcelRegister("gfsDP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd4443a0695e193a$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $5YM7L = parcelRequire("5YM7L");

var $dsN6L = parcelRequire("dsN6L");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $az3td = parcelRequire("az3td");

var $5Xuee = parcelRequire("5Xuee");

var $7hyOW = parcelRequire("7hyOW");

var $kAAnW = parcelRequire("kAAnW");

var $c2hQI = parcelRequire("c2hQI");
var $bd4443a0695e193a$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isSelected",
    "shouldFitContainer",
    "spacing",
    "isLoading",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseDown",
    "onMouseUp",
    "onFocus",
    "onBlur",
    "theme"
];
function $bd4443a0695e193a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bd4443a0695e193a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bd4443a0695e193a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bd4443a0695e193a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $bd4443a0695e193a$var$getInteractionState(_ref) {
    var _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isActive = _ref.isActive, isActive = _ref$isActive === void 0 ? false : _ref$isActive, _ref$isFocus = _ref.isFocus, isFocus = _ref$isFocus === void 0 ? false : _ref$isFocus, _ref$isHover = _ref.isHover, isHover = _ref$isHover === void 0 ? false : _ref$isHover, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
    if (isDisabled) return 'disabled';
    if (isSelected && isFocus) return 'focusSelected';
    if (isSelected) return 'selected';
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return 'active';
    if (!isLoading && isHover) return 'hover';
    if (isFocus) return 'focus';
    return 'default';
}
var $bd4443a0695e193a$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ var $bd4443a0695e193a$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).forwardRef(function CustomThemeButton(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? 'default' : _ref2$appearance, _ref2$autoFocus = _ref2.autoFocus, autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled, _ref2$isSelected = _ref2.isSelected, isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected, _ref2$shouldFitContai = _ref2.shouldFitContainer, shouldFitContainer = _ref2$shouldFitContai === void 0 ? false : _ref2$shouldFitContai, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? 'default' : _ref2$spacing, _ref2$isLoading = _ref2.isLoading, isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading, providedOnMouseEnter = _ref2.onMouseEnter, providedOnMouseLeave = _ref2.onMouseLeave, providedOnMouseDown = _ref2.onMouseDown, providedOnMouseUp = _ref2.onMouseUp, providedOnFocus = _ref2.onFocus, providedOnBlur = _ref2.onBlur, _ref2$theme = _ref2.theme, theme = _ref2$theme === void 0 ? (0, $c2hQI.defaultThemeFn) : _ref2$theme, rest = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref2, $bd4443a0695e193a$var$_excluded);
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    var restProps = $bd4443a0695e193a$var$_objectSpread({
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    }, rest);
    var _useState = (0, $91i6m.useState)($bd4443a0695e193a$var$initial), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var onMouseEnter = (0, $91i6m.useCallback)(function(event) {
        setState(function(current) {
            return $bd4443a0695e193a$var$_objectSpread($bd4443a0695e193a$var$_objectSpread({}, current), {}, {
                isHover: true
            });
        });
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    var onMouseLeave = (0, $91i6m.useCallback)(function(event) {
        setState(function(current) {
            return $bd4443a0695e193a$var$_objectSpread($bd4443a0695e193a$var$_objectSpread({}, current), {}, {
                isHover: false,
                isActive: false
            });
        });
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    var onMouseDown = (0, $91i6m.useCallback)(function(event) {
        setState(function(current) {
            return $bd4443a0695e193a$var$_objectSpread($bd4443a0695e193a$var$_objectSpread({}, current), {}, {
                isActive: true
            });
        });
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    var onMouseUp = (0, $91i6m.useCallback)(function(event) {
        setState(function(current) {
            return $bd4443a0695e193a$var$_objectSpread($bd4443a0695e193a$var$_objectSpread({}, current), {}, {
                isActive: false
            });
        });
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    var onFocus = (0, $91i6m.useCallback)(function(event) {
        setState(function(current) {
            return $bd4443a0695e193a$var$_objectSpread($bd4443a0695e193a$var$_objectSpread({}, current), {}, {
                isFocus: true
            });
        });
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    var onBlur = (0, $91i6m.useCallback)(function(event) {
        setState(function(current) {
            return $bd4443a0695e193a$var$_objectSpread($bd4443a0695e193a$var$_objectSpread({}, current), {}, {
                isFocus: false
            });
        });
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $c2hQI.default).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $az3td.default).Consumer, null, function(_ref3) {
        var mode = _ref3.mode;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $c2hQI.default).Consumer, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
            mode: mode,
            state: $bd4443a0695e193a$var$getInteractionState($bd4443a0695e193a$var$_objectSpread($bd4443a0695e193a$var$_objectSpread({}, state), {}, {
                isLoading: isLoading,
                isSelected: restProps.isSelected,
                isDisabled: restProps.isDisabled
            })),
            iconIsOnlyChild: (0, $7hyOW.default)(restProps),
            isLoading: isLoading
        }, restProps), function(_ref4) {
            var buttonStyles = _ref4.buttonStyles;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $5Xuee.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, restProps, {
                ref: ref,
                overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $kAAnW.default), restProps) : null,
                "aria-disabled": isLoading || restProps['aria-disabled'],
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onFocus: onFocus,
                onBlur: onBlur,
                buttonCss: (0, $c2hQI.getSpecifiers)(buttonStyles)
            }));
        });
    }));
}));
// Tools including enzyme rely on components having a display name
$bd4443a0695e193a$var$CustomThemeButton.displayName = 'CustomThemeButton';
var $bd4443a0695e193a$export$2e2bcd8739ae039 = $bd4443a0695e193a$var$CustomThemeButton;

});
parcelRegister("az3td", function(module, exports) {

$parcel$export(module.exports, "useGlobalTheme", function () { return $7b0fdd61a89d08a8$export$7692396083754928; });
$parcel$export(module.exports, "default", function () { return $7b0fdd61a89d08a8$export$2e2bcd8739ae039; });

var $jNSum = parcelRequire("jNSum");
// Create default global light theme
var $7b0fdd61a89d08a8$var$_createTheme = (0, $jNSum.createTheme)(function() {
    return {
        mode: 'light'
    };
}), $7b0fdd61a89d08a8$var$Provider = $7b0fdd61a89d08a8$var$_createTheme.Provider, $7b0fdd61a89d08a8$var$Consumer = $7b0fdd61a89d08a8$var$_createTheme.Consumer, $7b0fdd61a89d08a8$export$7692396083754928 = $7b0fdd61a89d08a8$var$_createTheme.useTheme;
var $7b0fdd61a89d08a8$var$Theme = {
    Provider: $7b0fdd61a89d08a8$var$Provider,
    Consumer: $7b0fdd61a89d08a8$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7b0fdd61a89d08a8$export$2e2bcd8739ae039 = $7b0fdd61a89d08a8$var$Theme;

});
parcelRegister("jNSum", function(module, exports) {

$parcel$export(module.exports, "createTheme", function () { return $e6acdc3d9dea969a$export$25d302a5b900a763; });

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");
var $e6acdc3d9dea969a$var$_excluded = [
    "children"
];
function $e6acdc3d9dea969a$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $91i6m.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $91i6m.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(props, $e6acdc3d9dea969a$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $91i6m.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $91i6m.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("5Xuee", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4569e938d6351640$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $boAHD = parcelRequire("boAHD");

var $koa2c = parcelRequire("koa2c");

var $6A0cm = parcelRequire("6A0cm");

var $a4cH2 = parcelRequire("a4cH2");

var $2ReIv = parcelRequire("2ReIv");

var $ejN1U = parcelRequire("ejN1U");

var $4jFRu = parcelRequire("4jFRu");

var $2JC1K = parcelRequire("2JC1K");

var $dNg3u = parcelRequire("dNg3u");

var $4haQN = parcelRequire("4haQN");
var $4569e938d6351640$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $4569e938d6351640$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $4569e938d6351640$var$iconBeforeSpacingFixStyle = (0, $boAHD.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $4569e938d6351640$var$iconAfterSpacingFixStyle = (0, $boAHD.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $4569e938d6351640$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $4haQN.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
var $4569e938d6351640$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $4haQN.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? (0, $boAHD.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $4569e938d6351640$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'default' : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? 'a' : 'button' : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $6A0cm.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $6A0cm.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 'default' : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? 'button' : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(props, $4569e938d6351640$var$_excluded);
    var ourRef = (0, $91i6m.useRef)();
    var setRef = (0, $91i6m.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $a4cH2.default)(ourRef, autoFocus);
    var interactionContext = (0, $91i6m.useContext)((0, $ejN1U.default));
    var handleClick = (0, $91i6m.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $koa2c.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "@atlaskit/button",
        packageVersion: "23.4.6",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $91i6m.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $91i6m.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $boAHD.css)((0, $dNg3u.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $4jFRu.N500), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $4jFRu.N500), ")"), " !important")
        }
    };
    return (0, $boAHD.jsx)((0, $2ReIv.default), null, (0, $boAHD.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $4569e938d6351640$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $2JC1K.default)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $boAHD.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $dNg3u.getIconStyle)({
                spacing: spacing
            }),
            $4569e938d6351640$var$getSpacingFix(children, $4569e938d6351640$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $4569e938d6351640$var$getChildren(children, [
        fadeStyles,
        (0, $dNg3u.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $boAHD.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $dNg3u.getIconStyle)({
                spacing: spacing
            }),
            $4569e938d6351640$var$getSpacingFix(children, $4569e938d6351640$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $boAHD.jsx)("span", {
        css: [
            (0, $dNg3u.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4569e938d6351640$export$2e2bcd8739ae039 = $4569e938d6351640$var$ButtonBase;

});
parcelRegister("a4cH2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75441fb7c49a45ed$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");
function $75441fb7c49a45ed$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $91i6m.useRef)(true);
    (0, $91i6m.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("2ReIv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $214bf27b62ffbebe$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $91i6m = parcelRequire("91i6m");

var $boAHD = parcelRequire("boAHD");
var $214bf27b62ffbebe$var$BORDER_WIDTH = 2;
var $214bf27b62ffbebe$var$baseFocusOutsideStyles = (0, $boAHD.css)({
    outline: "".concat($214bf27b62ffbebe$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $214bf27b62ffbebe$var$BORDER_WIDTH
});
var $214bf27b62ffbebe$var$baseInsetStyles = (0, $boAHD.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$214bf27b62ffbebe$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $214bf27b62ffbebe$var$focusRingStyles = (0, $boAHD.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $214bf27b62ffbebe$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $214bf27b62ffbebe$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
var $214bf27b62ffbebe$var$insetFocusRingStyles = (0, $boAHD.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $214bf27b62ffbebe$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $214bf27b62ffbebe$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $214bf27b62ffbebe$var$FocusRing = /*#__PURE__*/ (0, $91i6m.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $214bf27b62ffbebe$var$baseInsetStyles : $214bf27b62ffbebe$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $214bf27b62ffbebe$var$insetFocusRingStyles : $214bf27b62ffbebe$var$focusRingStyles;
    var focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return (0, $boAHD.jsx)((0, $boAHD.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $91i6m.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $91i6m.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$214bf27b62ffbebe$var$FocusRing.displayName = 'FocusRing';
var $214bf27b62ffbebe$export$2e2bcd8739ae039 = $214bf27b62ffbebe$var$FocusRing;

});

parcelRegister("ejN1U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6c8df509dcc88ea$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");
var $a6c8df509dcc88ea$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $91i6m.createContext)(null);

});

parcelRegister("4jFRu", function(module, exports) {

$parcel$export(module.exports, "R300", function () { return $3249689f1beecabc$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $3249689f1beecabc$export$2010d0fb4295b346; });
$parcel$export(module.exports, "R500", function () { return $3249689f1beecabc$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y200", function () { return $3249689f1beecabc$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Y300", function () { return $3249689f1beecabc$export$c6930421db9fa514; });
$parcel$export(module.exports, "Y400", function () { return $3249689f1beecabc$export$59619663aa6500fb; });
$parcel$export(module.exports, "B50", function () { return $3249689f1beecabc$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $3249689f1beecabc$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $3249689f1beecabc$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $3249689f1beecabc$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $3249689f1beecabc$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $3249689f1beecabc$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $3249689f1beecabc$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "N0", function () { return $3249689f1beecabc$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $3249689f1beecabc$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N70", function () { return $3249689f1beecabc$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N90", function () { return $3249689f1beecabc$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N200", function () { return $3249689f1beecabc$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N400", function () { return $3249689f1beecabc$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $3249689f1beecabc$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N700", function () { return $3249689f1beecabc$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $3249689f1beecabc$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $3249689f1beecabc$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $3249689f1beecabc$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN400", function () { return $3249689f1beecabc$export$abcf8c38338b4aa5; });
$parcel$export(module.exports, "DN300", function () { return $3249689f1beecabc$export$97e81faa16a182c7; });
$parcel$export(module.exports, "DN100", function () { return $3249689f1beecabc$export$ee82aa2ea6a1558; });
$parcel$export(module.exports, "DN70", function () { return $3249689f1beecabc$export$d281fbfe3cff2df6; });
$parcel$export(module.exports, "DN60", function () { return $3249689f1beecabc$export$3902c91d8b98a753; });
$parcel$export(module.exports, "DN30", function () { return $3249689f1beecabc$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN0", function () { return $3249689f1beecabc$export$3d4f271a500072a; });
// Reds
var $3249689f1beecabc$export$4b84fd0e2c617bd = '#FFEBE6';
var $3249689f1beecabc$export$b34b069eff244586 = '#FFBDAD';
var $3249689f1beecabc$export$be802dd0d8b57f35 = '#FF8F73';
var $3249689f1beecabc$export$60847d42f9da92a6 = '#FF7452';
var $3249689f1beecabc$export$4a7404f376229999 = '#FF5630';
var $3249689f1beecabc$export$2010d0fb4295b346 = '#DE350B';
var $3249689f1beecabc$export$2837b5a1a71d5c02 = '#BF2600';
var $3249689f1beecabc$export$8d9596b529bbb9cf = '#FFFAE6';
var $3249689f1beecabc$export$41060a744ab0b7ae = '#FFF0B3';
var $3249689f1beecabc$export$1cc05bbbf340e559 = '#FFE380';
var $3249689f1beecabc$export$5aae31392d72caaa = '#FFC400';
var $3249689f1beecabc$export$c6930421db9fa514 = '#FFAB00';
var $3249689f1beecabc$export$59619663aa6500fb = '#FF991F';
var $3249689f1beecabc$export$874739ea9e379ab6 = '#FF8B00';
var $3249689f1beecabc$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $3249689f1beecabc$export$69a3bf21b9686c2b = '#ABF5D1';
var $3249689f1beecabc$export$afbce1382ec95f73 = '#79F2C0';
var $3249689f1beecabc$export$747d86715d4175de = '#57D9A3';
var $3249689f1beecabc$export$940e1f69e873f202 = '#36B37E';
var $3249689f1beecabc$export$a49394138f7b8e85 = '#00875A';
var $3249689f1beecabc$export$6fa04827ac68a4fb = '#006644';
var $3249689f1beecabc$export$226de0355ed012f8 = '#DEEBFF';
var $3249689f1beecabc$export$8c13c2ee36917869 = '#B3D4FF';
var $3249689f1beecabc$export$ecfc1dff386a3e7a = '#4C9AFF';
var $3249689f1beecabc$export$215b7063051591f1 = '#2684FF';
var $3249689f1beecabc$export$e62e8919cca44969 = '#0065FF';
var $3249689f1beecabc$export$b3de0ae08da2ce64 = '#0052CC';
var $3249689f1beecabc$export$a6ee3d71bc067634 = '#0747A6';
var $3249689f1beecabc$export$67f15409e87642a1 = '#669DF1';
var $3249689f1beecabc$export$f0539dbc42dbb067 = '#8FB8F6';
var $3249689f1beecabc$export$363e4475840015bb = '#EAE6FF';
var $3249689f1beecabc$export$4b0a4417ed59760f = '#C0B6F2';
var $3249689f1beecabc$export$6011520a64d9a187 = '#998DD9';
var $3249689f1beecabc$export$a7175d4e9206bc80 = '#8777D9';
var $3249689f1beecabc$export$b48405b95304b5a1 = '#6554C0';
var $3249689f1beecabc$export$c71e4279dd54a18d = '#5243AA';
var $3249689f1beecabc$export$147899de772240ec = '#403294';
var $3249689f1beecabc$export$2cf711fe14c66f06 = '#E6FCFF';
var $3249689f1beecabc$export$7a8f4d33f6f9772c = '#B3F5FF';
var $3249689f1beecabc$export$776c9c497ef08533 = '#79E2F2';
var $3249689f1beecabc$export$69cb3ca10c1e330e = '#00C7E6';
var $3249689f1beecabc$export$9dc1ef0f3f48059b = '#00B8D9';
var $3249689f1beecabc$export$7c835c78b6fcdef8 = '#00A3BF';
var $3249689f1beecabc$export$6036577f95c3877e = '#008DA6';
var $3249689f1beecabc$export$29a4f05edc054374 = '#FFFFFF';
var $3249689f1beecabc$export$e655ef011c4aa1a2 = '#FAFBFC';
var $3249689f1beecabc$export$9fdfb749e33cdf97 = '#F4F5F7';
var $3249689f1beecabc$export$3e51e8f1440314ba = '#EBECF0';
var $3249689f1beecabc$export$1ce2d1575d444ceb = '#DFE1E6';
var $3249689f1beecabc$export$8754fc7e6d8b3000 = '#C1C7D0';
var $3249689f1beecabc$export$c2e91cbeada39b8b = '#B3BAC5';
var $3249689f1beecabc$export$5f71e19f3a7ad9de = '#A5ADBA';
var $3249689f1beecabc$export$eaa8c8a70ac22806 = '#97A0AF';
var $3249689f1beecabc$export$7c87d337fb91a97d = '#8993A4';
var $3249689f1beecabc$export$d6447c357493214f = '#7A869A';
var $3249689f1beecabc$export$f563ee71e9ee74cd = '#6B778C';
var $3249689f1beecabc$export$e2ef2124cf4024b1 = '#5E6C84';
var $3249689f1beecabc$export$eece5f492e429f08 = '#505F79';
var $3249689f1beecabc$export$c39c0fe0f26207ae = '#42526E';
var $3249689f1beecabc$export$7090862dc3038a9f = '#344563';
var $3249689f1beecabc$export$ad0bacf983b7ddaa = '#253858';
var $3249689f1beecabc$export$7d61b15e0da132af = '#172B4D';
var $3249689f1beecabc$export$fbda843f0a27fe96 = '#091E42';
var $3249689f1beecabc$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $3249689f1beecabc$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $3249689f1beecabc$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $3249689f1beecabc$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $3249689f1beecabc$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $3249689f1beecabc$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $3249689f1beecabc$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $3249689f1beecabc$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $3249689f1beecabc$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $3249689f1beecabc$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $3249689f1beecabc$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $3249689f1beecabc$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $3249689f1beecabc$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $3249689f1beecabc$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $3249689f1beecabc$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $3249689f1beecabc$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $3249689f1beecabc$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $3249689f1beecabc$export$2f6319cf7d736c2a = '#E6EDFA';
var $3249689f1beecabc$export$95126bc8884d6634 = '#DCE5F5';
var $3249689f1beecabc$export$8338d8c35d44ff1 = '#CED9EB';
var $3249689f1beecabc$export$5368d76ae4fbbda7 = '#B8C7E0';
var $3249689f1beecabc$export$9f0a771d16ec8d36 = '#ABBBD6';
var $3249689f1beecabc$export$abcf8c38338b4aa5 = '#9FB0CC';
var $3249689f1beecabc$export$97e81faa16a182c7 = '#8C9CB8';
var $3249689f1beecabc$export$bfe21c59123ecf33 = '#7988A3';
var $3249689f1beecabc$export$ee82aa2ea6a1558 = '#67758F';
var $3249689f1beecabc$export$682927c6ed76be02 = '#56637A';
var $3249689f1beecabc$export$91fd9994c5be9757 = '#455166';
var $3249689f1beecabc$export$d281fbfe3cff2df6 = '#3B475C';
var $3249689f1beecabc$export$3902c91d8b98a753 = '#313D52';
var $3249689f1beecabc$export$8e8133c1ba5845b5 = '#283447';
var $3249689f1beecabc$export$33ff357f6620b39 = '#202B3D';
var $3249689f1beecabc$export$633847cf062b69e0 = '#1B2638';
var $3249689f1beecabc$export$9776a6e503bdbf76 = '#121A29';
var $3249689f1beecabc$export$6c813d5160dff5db = '#0E1624';
var $3249689f1beecabc$export$3d4f271a500072a = '#0D1424';
var $3249689f1beecabc$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $3249689f1beecabc$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $3249689f1beecabc$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $3249689f1beecabc$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $3249689f1beecabc$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $3249689f1beecabc$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $3249689f1beecabc$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $3249689f1beecabc$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $3249689f1beecabc$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $3249689f1beecabc$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $3249689f1beecabc$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $3249689f1beecabc$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $3249689f1beecabc$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $3249689f1beecabc$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $3249689f1beecabc$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $3249689f1beecabc$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $3249689f1beecabc$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $3249689f1beecabc$export$d2adc5dedf09fced = '#292A2E';
var $3249689f1beecabc$export$f51762073d2bb381 = '#94C748';
var $3249689f1beecabc$export$95e26d54def96891 = '#B3DF72';

});

parcelRegister("2JC1K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fdd48299ef99948$export$2e2bcd8739ae039; });
function $1fdd48299ef99948$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $1fdd48299ef99948$var$tabKeyCode = 9;
function $1fdd48299ef99948$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $1fdd48299ef99948$var$tabKeyCode) return;
    $1fdd48299ef99948$var$abort(event);
}
var $1fdd48299ef99948$var$block = {
    onMouseDownCapture: $1fdd48299ef99948$var$abort,
    onMouseUpCapture: $1fdd48299ef99948$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $1fdd48299ef99948$var$onKey,
    onKeyUpCapture: $1fdd48299ef99948$var$onKey,
    onTouchStartCapture: $1fdd48299ef99948$var$abort,
    onTouchEndCapture: $1fdd48299ef99948$var$abort,
    onPointerDownCapture: $1fdd48299ef99948$var$abort,
    onPointerUpCapture: $1fdd48299ef99948$var$abort,
    onClickCapture: $1fdd48299ef99948$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $1fdd48299ef99948$var$abort
};
var $1fdd48299ef99948$var$doNotBlock = {};
function $1fdd48299ef99948$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $1fdd48299ef99948$var$doNotBlock : $1fdd48299ef99948$var$block;
}

});

parcelRegister("dNg3u", function(module, exports) {

$parcel$export(module.exports, "getCss", function () { return $a0ac4e3b68b162d6$export$955358618f994a11; });
$parcel$export(module.exports, "getIconStyle", function () { return $a0ac4e3b68b162d6$export$864eea3f4ec3368f; });
$parcel$export(module.exports, "getContentStyle", function () { return $a0ac4e3b68b162d6$export$7ad0316cc0dd65a; });
$parcel$export(module.exports, "getFadingCss", function () { return $a0ac4e3b68b162d6$export$1b5827d324e945b1; });
$parcel$export(module.exports, "overlayCss", function () { return $a0ac4e3b68b162d6$export$1a9fe1b84c876bb5; });

var $dsN6L = parcelRequire("dsN6L");

var $boAHD = parcelRequire("boAHD");

var $f1k1y = parcelRequire("f1k1y");

var $dUSYE = parcelRequire("dUSYE");

var $hseA3 = parcelRequire("hseA3");
function $a0ac4e3b68b162d6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a0ac4e3b68b162d6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a0ac4e3b68b162d6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a0ac4e3b68b162d6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a0ac4e3b68b162d6$var$gridSize = (0, $dUSYE.gridSize)();
var $a0ac4e3b68b162d6$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $a0ac4e3b68b162d6$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: 'auto'
};
var $a0ac4e3b68b162d6$var$lineHeights = {
    default: $a0ac4e3b68b162d6$var$heights.default,
    compact: $a0ac4e3b68b162d6$var$heights.compact,
    none: 'inherit'
};
var $a0ac4e3b68b162d6$var$padding = {
    // 10px gutter
    default: "0 ".concat($a0ac4e3b68b162d6$var$gridSize + $a0ac4e3b68b162d6$var$gridSize / 4, "px"),
    compact: "0 ".concat($a0ac4e3b68b162d6$var$gridSize + $a0ac4e3b68b162d6$var$gridSize / 4, "px"),
    none: '0'
};
var $a0ac4e3b68b162d6$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($a0ac4e3b68b162d6$var$gridSize / 4, "px"),
    default: "0 ".concat($a0ac4e3b68b162d6$var$gridSize / 4, "px"),
    none: '0'
};
var $a0ac4e3b68b162d6$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
var $a0ac4e3b68b162d6$var$innerMargin = {
    content: "0 ".concat($a0ac4e3b68b162d6$var$gridSize / 4, "px"),
    icon: "0 ".concat($a0ac4e3b68b162d6$var$gridSize / 4, "px")
};
var $a0ac4e3b68b162d6$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
var $a0ac4e3b68b162d6$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #172B4D)",
    '&::after': $a0ac4e3b68b162d6$var$_objectSpread($a0ac4e3b68b162d6$var$_objectSpread({}, $a0ac4e3b68b162d6$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #091E4224)"
    }),
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #091E424F)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var $a0ac4e3b68b162d6$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #0C66E4)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #0055CC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #09326C)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #0C66E4)"
    }
};
var $a0ac4e3b68b162d6$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #0C66E4)",
    '&:hover': {
        color: "var(--ds-link, #0C66E4)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #0055CC)",
        textDecoration: 'underline'
    }
};
var $a0ac4e3b68b162d6$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #44546F)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
var $a0ac4e3b68b162d6$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #44546F)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #44546F)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #172B4D)",
        textDecoration: 'underline'
    }
};
var $a0ac4e3b68b162d6$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #F5CD47)",
    color: "var(--ds-text-warning-inverse, #172B4D)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #E2B203)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #CF9F02)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #F5CD47)"
    }
};
var $a0ac4e3b68b162d6$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #5D1F1A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var $a0ac4e3b68b162d6$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FF)",
    color: "var(--ds-text-selected, #0C66E4)",
    '&:not([disabled])::after': $a0ac4e3b68b162d6$var$_objectSpread($a0ac4e3b68b162d6$var$_objectSpread({}, $a0ac4e3b68b162d6$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #0C66E4)"
    })
};
var $a0ac4e3b68b162d6$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $a0ac4e3b68b162d6$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $a0ac4e3b68b162d6$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $a0ac4e3b68b162d6$var$getColor({
            group: (0, $hseA3.default).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($a0ac4e3b68b162d6$var$getColor({
            group: (0, $hseA3.default).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $a0ac4e3b68b162d6$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $a0ac4e3b68b162d6$var$getColors({
        appearance: appearance,
        key: isSelected ? 'selected' : 'default',
        mode: mode
    });
    return $a0ac4e3b68b162d6$var$_objectSpread($a0ac4e3b68b162d6$var$_objectSpread($a0ac4e3b68b162d6$var$_objectSpread($a0ac4e3b68b162d6$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: "var(--ds-radius-small, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap'
    }, !(0, $f1k1y.fg)('platform-component-visual-refresh') && baseColors), {}, {
        cursor: 'pointer',
        height: $a0ac4e3b68b162d6$var$heights[spacing],
        lineHeight: $a0ac4e3b68b162d6$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $a0ac4e3b68b162d6$var$singleIconPadding[spacing] : $a0ac4e3b68b162d6$var$padding[spacing],
        verticalAlign: $a0ac4e3b68b162d6$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center'
    }, !(0, $f1k1y.fg)('platform-component-visual-refresh') && $a0ac4e3b68b162d6$var$_objectSpread($a0ac4e3b68b162d6$var$_objectSpread({
        // Disabling visited styles (just using the base colors)
        '&:visited': $a0ac4e3b68b162d6$var$_objectSpread({}, baseColors),
        '&:hover': $a0ac4e3b68b162d6$var$_objectSpread($a0ac4e3b68b162d6$var$_objectSpread({}, $a0ac4e3b68b162d6$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'hover',
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === 'link' || appearance === 'subtle-link') ? 'underline' : 'inherit',
            // background, box-shadow
            transitionDuration: '0s, 0.15s'
        }),
        // giving active styles preference by listing them after focus
        '&:active': $a0ac4e3b68b162d6$var$_objectSpread($a0ac4e3b68b162d6$var$_objectSpread({}, $a0ac4e3b68b162d6$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'active',
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: '0s, 0s'
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $a0ac4e3b68b162d6$var$_objectSpread($a0ac4e3b68b162d6$var$_objectSpread({}, $a0ac4e3b68b162d6$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'active',
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: '0s, 0s'
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        '&[disabled]': $a0ac4e3b68b162d6$var$_objectSpread($a0ac4e3b68b162d6$var$_objectSpread({}, $a0ac4e3b68b162d6$var$getColors({
            appearance: appearance,
            key: 'disabled',
            mode: mode
        })), {}, {
            cursor: 'not-allowed',
            textDecoration: 'none'
        })
    }, $a0ac4e3b68b162d6$var$hasOverlayStyles), {}, {
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $a0ac4e3b68b162d6$var$_objectSpread({}, $a0ac4e3b68b162d6$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'default',
            mode: mode
        }))
    })), (0, $f1k1y.fg)('platform-component-visual-refresh') && (isSelected ? $a0ac4e3b68b162d6$var$selectedStyles : $a0ac4e3b68b162d6$var$_objectSpread($a0ac4e3b68b162d6$var$_objectSpread($a0ac4e3b68b162d6$var$_objectSpread($a0ac4e3b68b162d6$var$_objectSpread($a0ac4e3b68b162d6$var$_objectSpread($a0ac4e3b68b162d6$var$_objectSpread($a0ac4e3b68b162d6$var$_objectSpread($a0ac4e3b68b162d6$var$_objectSpread({}, appearance === 'default' && $a0ac4e3b68b162d6$var$defaultStyles), appearance === 'primary' && $a0ac4e3b68b162d6$var$primaryStyles), appearance === 'link' && $a0ac4e3b68b162d6$var$linkStyles), appearance === 'subtle' && $a0ac4e3b68b162d6$var$subtleStyles), appearance === 'subtle-link' && $a0ac4e3b68b162d6$var$subtleLinkStyles), appearance === 'warning' && $a0ac4e3b68b162d6$var$warningStyles), appearance === 'danger' && $a0ac4e3b68b162d6$var$dangerStyles), {}, {
        '&[disabled]': {
            color: "var(--ds-text-disabled, #091E424F)",
            backgroundColor: $a0ac4e3b68b162d6$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent',
            cursor: 'not-allowed',
            textDecoration: 'none',
            '&:hovered': {
                backgroundColor: $a0ac4e3b68b162d6$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent'
            },
            '&:active': {
                backgroundColor: $a0ac4e3b68b162d6$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent'
            }
        }
    }, $a0ac4e3b68b162d6$var$hasOverlayStyles))), {}, {
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $a0ac4e3b68b162d6$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $boAHD.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $a0ac4e3b68b162d6$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}
function $a0ac4e3b68b162d6$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $boAHD.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $a0ac4e3b68b162d6$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}
function $a0ac4e3b68b162d6$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $boAHD.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}
var $a0ac4e3b68b162d6$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

});
parcelRegister("dUSYE", function(module, exports) {

$parcel$export(module.exports, "gridSize", function () { return $a21b26aeb10848e1$export$6d8204c2cb2e06b8; });

var $5RmjO = parcelRequire("5RmjO");

var $4jFRu = parcelRequire("4jFRu");
var $a21b26aeb10848e1$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $a21b26aeb10848e1$export$c93026a968943f95 = 'light';
var $a21b26aeb10848e1$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $a21b26aeb10848e1$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $a21b26aeb10848e1$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $4jFRu.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $a21b26aeb10848e1$export$6d8204c2cb2e06b8() / 4;
    (0, $5RmjO.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $a21b26aeb10848e1$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $a21b26aeb10848e1$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $a21b26aeb10848e1$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $5RmjO.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $a21b26aeb10848e1$export$ba1d834b86d72a09 = $a21b26aeb10848e1$export$a1b3edb637fb4f35;
var $a21b26aeb10848e1$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $4jFRu.N20A), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $4jFRu.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $4jFRu.N30A), ")")
            }
        }
    };
};

});

parcelRegister("hseA3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb505c903d72a650$export$2e2bcd8739ae039; });

var $4jFRu = parcelRequire("4jFRu");
// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $cb505c903d72a650$var$fadedB75 = 'rgba(179, 212, 255, 0.6)';
var $cb505c903d72a650$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($4jFRu.N20A, ")"),
                dark: "var(--ds-background-neutral, ".concat($4jFRu.DN70, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($4jFRu.N30A, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($4jFRu.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($cb505c903d72a650$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($4jFRu.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($4jFRu.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($4jFRu.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($4jFRu.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($4jFRu.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($4jFRu.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($4jFRu.DN0, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($4jFRu.B400, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($4jFRu.B100, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($4jFRu.B300, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($4jFRu.B75, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($4jFRu.B500, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($4jFRu.B200, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($4jFRu.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($4jFRu.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($4jFRu.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($4jFRu.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($4jFRu.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($4jFRu.DN0, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($4jFRu.Y300, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($4jFRu.Y300, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($4jFRu.Y200, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($4jFRu.Y200, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($4jFRu.Y400, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($4jFRu.Y400, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($4jFRu.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($4jFRu.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($4jFRu.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($4jFRu.Y400, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($4jFRu.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($4jFRu.Y400, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($4jFRu.R400, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($4jFRu.R400, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($4jFRu.R300, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($4jFRu.R300, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($4jFRu.R500, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($4jFRu.R500, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($4jFRu.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($4jFRu.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($4jFRu.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($4jFRu.R500, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($4jFRu.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($4jFRu.R500, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($4jFRu.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($4jFRu.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($4jFRu.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($4jFRu.N20, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($4jFRu.N30A, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($4jFRu.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($cb505c903d72a650$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($4jFRu.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($4jFRu.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($4jFRu.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($4jFRu.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($4jFRu.DN0, ")")
            }
        },
        'subtle-link': {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($4jFRu.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($4jFRu.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($4jFRu.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($4jFRu.N20, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($4jFRu.N500, ")"),
                dark: "var(--ds-text, ".concat($4jFRu.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($4jFRu.B400, ")"),
                dark: "var(--ds-text, ".concat($4jFRu.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($4jFRu.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($4jFRu.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($4jFRu.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($4jFRu.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($4jFRu.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($4jFRu.DN400, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($4jFRu.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($4jFRu.DN30, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($4jFRu.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($4jFRu.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($4jFRu.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($4jFRu.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($4jFRu.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($4jFRu.DN400, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($4jFRu.N800, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($4jFRu.N800, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($4jFRu.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($4jFRu.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($4jFRu.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($4jFRu.N800, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($4jFRu.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($4jFRu.N800, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($4jFRu.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($4jFRu.N0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($4jFRu.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($4jFRu.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($4jFRu.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($4jFRu.N0, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($4jFRu.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($4jFRu.N0, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($4jFRu.B400, ")"),
                dark: "var(--ds-link, ".concat($4jFRu.B100, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($4jFRu.B300, ")"),
                dark: "var(--ds-link, ".concat($4jFRu.B75, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($4jFRu.B500, ")"),
                dark: "var(--ds-link-pressed, ".concat($4jFRu.B200, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($4jFRu.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($4jFRu.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($4jFRu.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($4jFRu.N700, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($4jFRu.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($4jFRu.N700, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($4jFRu.N500, ")"),
                dark: "var(--ds-text, ".concat($4jFRu.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($4jFRu.B400, ")"),
                dark: "var(--ds-text, ".concat($4jFRu.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($4jFRu.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($4jFRu.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($4jFRu.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($4jFRu.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($4jFRu.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($4jFRu.DN400, ")")
            }
        },
        'subtle-link': {
            default: {
                light: "var(--ds-text-subtle, ".concat($4jFRu.N200, ")"),
                dark: "var(--ds-text-subtle, ".concat($4jFRu.DN400, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($4jFRu.N90, ")"),
                dark: "var(--ds-text-subtle, ".concat($4jFRu.B50, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($4jFRu.N400, ")"),
                dark: "var(--ds-text, ".concat($4jFRu.DN300, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($4jFRu.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($4jFRu.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($4jFRu.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($4jFRu.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($4jFRu.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($4jFRu.DN400, ")")
            }
        }
    }
};
var $cb505c903d72a650$export$2e2bcd8739ae039 = $cb505c903d72a650$var$values;

});


parcelRegister("4haQN", function(module, exports) {

$parcel$export(module.exports, "getIfVisuallyHiddenChildren", function () { return $31d12a9fa053dfa3$export$20bbd2efb0d734c4; });

var $91i6m = parcelRequire("91i6m");

var $kQU6o = parcelRequire("kQU6o");
var $31d12a9fa053dfa3$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $91i6m.isValidElement)(children) && children.type === (0, $kQU6o.default);
};

});


parcelRegister("7hyOW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54d521902c21b50e$export$2e2bcd8739ae039; });

var $4haQN = parcelRequire("4haQN");
function $54d521902c21b50e$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $4haQN.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});

parcelRegister("kAAnW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $efd364c84ed960ee$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $9OWP7 = parcelRequire("9OWP7");
function $efd364c84ed960ee$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $efd364c84ed960ee$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? 'default' : _ref2$spacing;
    var size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $9OWP7.default), {
        size: size,
        label: ", Loading",
        appearance: $efd364c84ed960ee$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});

parcelRegister("c2hQI", function(module, exports) {

$parcel$export(module.exports, "getSpecifiers", function () { return $8c33846e9ce74f22$export$643db0b8d8778e; });
$parcel$export(module.exports, "defaultThemeFn", function () { return $8c33846e9ce74f22$export$437a7f77d13d7916; });
$parcel$export(module.exports, "default", function () { return $8c33846e9ce74f22$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");

var $jNSum = parcelRequire("jNSum");

var $dNg3u = parcelRequire("dNg3u");
function $8c33846e9ce74f22$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8c33846e9ce74f22$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8c33846e9ce74f22$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8c33846e9ce74f22$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8c33846e9ce74f22$var$stateToSelectorMap = {
    focus: '&:focus',
    focusSelected: '&:focus',
    hover: '&:hover',
    active: '&:active',
    disabled: '&[disabled]'
};
function $8c33846e9ce74f22$export$31512de7fa606fa4(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? 'light' : _ref$mode, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$iconIsOnlyChild = _ref.iconIsOnlyChild, iconIsOnlyChild = _ref$iconIsOnlyChild === void 0 ? false : _ref$iconIsOnlyChild, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, state = _ref.state;
    var result = (0, $dNg3u.getCss)({
        appearance: appearance,
        spacing: spacing,
        mode: mode,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = 'none';
    // Pulling relevant styles up to the top level
    var selector = $8c33846e9ce74f22$var$stateToSelectorMap[state];
    if (selector) result = $8c33846e9ce74f22$var$_objectSpread($8c33846e9ce74f22$var$_objectSpread({}, result), result[selector]);
    if (isLoading) result = $8c33846e9ce74f22$var$_objectSpread($8c33846e9ce74f22$var$_objectSpread({}, result), result['&[data-has-overlay="true"]']);
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach(function(key) {
        // want to keep this one
        if (key === '&::-moz-focus-inner') return;
        // Not using .startsWith for ie11
        if (key.indexOf('&') === 0) delete result[key];
    });
    return result;
}
function $8c33846e9ce74f22$export$643db0b8d8778e(styles) {
    return {
        '&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]': styles
    };
}
function $8c33846e9ce74f22$export$437a7f77d13d7916(current, values) {
    return current(values);
}
var $8c33846e9ce74f22$var$Theme = (0, $jNSum.createTheme)(function(themeProps) {
    return {
        buttonStyles: $8c33846e9ce74f22$export$31512de7fa606fa4(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    };
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8c33846e9ce74f22$export$2e2bcd8739ae039 = $8c33846e9ce74f22$var$Theme;

});


parcelRegister("3VuzU", function(module, exports) {

$parcel$export(module.exports, "flagBackgroundColor", function () { return $2dbe6a286b24a361$export$59e42969c95d314; });
$parcel$export(module.exports, "flagIconColor", function () { return $2dbe6a286b24a361$export$7f70afe2167f8235; });
$parcel$export(module.exports, "flagIconGlyph", function () { return $2dbe6a286b24a361$export$73f08aee70487cd4; });
$parcel$export(module.exports, "flagTextColor", function () { return $2dbe6a286b24a361$export$f50075b2584087f; });
$parcel$export(module.exports, "flagTextColorToken", function () { return $2dbe6a286b24a361$export$13b42cd9d596bfe0; });
$parcel$export(module.exports, "actionBackgroundColor", function () { return $2dbe6a286b24a361$export$81ba6b63eedb299f; });
$parcel$export(module.exports, "actionTextColor", function () { return $2dbe6a286b24a361$export$7bcfe3cca4dd78b6; });

var $91i6m = parcelRequire("91i6m");

var $4jQeO = parcelRequire("4jQeO");

var $a19Dx = parcelRequire("a19Dx");

var $lbiFO = parcelRequire("lbiFO");

var $5v3A0 = parcelRequire("5v3A0");

var $elvvw = parcelRequire("elvvw");
var $2dbe6a286b24a361$export$59e42969c95d314 = {
    error: 'color.background.danger.bold',
    info: 'color.background.neutral.bold',
    normal: 'elevation.surface.overlay',
    success: 'color.background.success.bold',
    warning: 'color.background.warning.bold'
};
var $2dbe6a286b24a361$export$7f70afe2167f8235 = {
    error: "var(--ds-icon-inverse, #FFFFFF)",
    info: "var(--ds-icon-inverse, #FFFFFF)",
    normal: "var(--ds-icon-subtle, #626F86)",
    success: "var(--ds-icon-inverse, #FFFFFF)",
    warning: "var(--ds-icon-warning-inverse, #172B4D)"
};
var $2dbe6a286b24a361$export$73f08aee70487cd4 = {
    error: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4jQeO))), {
        label: "",
        LEGACY_primaryColor: "var(--ds-icon-inverse, ".concat((0, $elvvw.N0), ")"),
        LEGACY_secondaryColor: "var(--ds-background-danger-bold, #C9372C)"
    }),
    info: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a19Dx))), {
        label: "",
        LEGACY_primaryColor: "var(--ds-icon-inverse, ".concat((0, $elvvw.N0), ")"),
        LEGACY_secondaryColor: "var(--ds-background-neutral-bold, #44546F)"
    }),
    normal: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a19Dx))), {
        label: "",
        LEGACY_primaryColor: "var(--ds-icon-subtle, ".concat((0, $elvvw.N500), ")"),
        LEGACY_secondaryColor: "var(--ds-surface-overlay, #FFFFFF)"
    }),
    success: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbiFO))), {
        label: "",
        LEGACY_primaryColor: "var(--ds-icon-inverse, ".concat((0, $elvvw.N0), ")"),
        LEGACY_secondaryColor: "var(--ds-background-success-bold, #1F845A)"
    }),
    warning: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5v3A0))), {
        label: "",
        LEGACY_primaryColor: "var(--ds-icon-warning-inverse, ".concat((0, $elvvw.N700), ")"),
        LEGACY_secondaryColor: "var(--ds-background-warning-bold, #F5CD47)"
    })
};
var $2dbe6a286b24a361$export$f50075b2584087f = {
    error: 'color.text.inverse',
    info: 'color.text.inverse',
    normal: 'color.text',
    success: 'color.text.inverse',
    warning: 'color.text.warning.inverse'
};
var $2dbe6a286b24a361$export$13b42cd9d596bfe0 = {
    error: "var(--ds-text-inverse, ".concat((0, $elvvw.N0), ")"),
    info: "var(--ds-text-inverse, ".concat((0, $elvvw.N0), ")"),
    normal: "var(--ds-text, ".concat((0, $elvvw.N800), ")"),
    success: "var(--ds-text-inverse, ".concat((0, $elvvw.N0), ")"),
    warning: "var(--ds-text-warning-inverse, ".concat((0, $elvvw.N700), ")")
};
var $2dbe6a286b24a361$export$81ba6b63eedb299f = {
    success: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $elvvw.N30A), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $elvvw.N30A), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $elvvw.N30A), ")")
    },
    info: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $elvvw.N30A), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $elvvw.N30A), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $elvvw.N30A), ")")
    },
    error: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $elvvw.N30A), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $elvvw.N30A), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $elvvw.N30A), ")")
    },
    warning: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $elvvw.N30A), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $elvvw.N30A), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $elvvw.N30A), ")")
    },
    normal: {
        default: 'none',
        active: 'none',
        pressed: 'none'
    }
};
var $2dbe6a286b24a361$export$7bcfe3cca4dd78b6 = {
    success: "var(--ds-text-inverse, ".concat((0, $elvvw.N0), ")"),
    info: "var(--ds-text-inverse, ".concat((0, $elvvw.N0), ")"),
    error: "var(--ds-text-inverse, ".concat((0, $elvvw.N0), ")"),
    warning: "var(--ds-text-warning-inverse, ".concat((0, $elvvw.N700), ")"),
    normal: "var(--ds-link, ".concat((0, $elvvw.B400), ")")
};

});
parcelRegister("4jQeO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f636032ea4a949f6a3ed21b2a88730cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3251751f44d9a524$var$_react = $3251751f44d9a524$var$_interopRequireDefault((parcelRequire("91i6m")));

var $3251751f44d9a524$var$_statusError = $3251751f44d9a524$var$_interopRequireDefault((parcelRequire("8Clr7")));

var $3251751f44d9a524$var$_error = $3251751f44d9a524$var$_interopRequireDefault((parcelRequire("fraFd")));
function $3251751f44d9a524$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusErrorIcon.
 * This component is StatusErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3251751f44d9a524$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $3251751f44d9a524$var$_react.default.createElement($3251751f44d9a524$var$_statusError.default, Object.assign({
        name: "StatusErrorIcon",
        LEGACY_fallbackIcon: $3251751f44d9a524$var$_error.default
    }, props));
$3251751f44d9a524$var$StatusErrorIcon.displayName = 'StatusErrorIconMigration';
var $3251751f44d9a524$var$_default = module.exports.default = $3251751f44d9a524$var$StatusErrorIcon;

});

parcelRegister("a19Dx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::750ecc162e36259ef90344888c589176>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $74b1790885c9bb75$var$_react = $74b1790885c9bb75$var$_interopRequireDefault((parcelRequire("91i6m")));

var $74b1790885c9bb75$var$_statusInformation = $74b1790885c9bb75$var$_interopRequireDefault((parcelRequire("lJzpS")));

var $74b1790885c9bb75$var$_info = $74b1790885c9bb75$var$_interopRequireDefault((parcelRequire("4lH5X")));
function $74b1790885c9bb75$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusInformationIcon.
 * This component is StatusInformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $74b1790885c9bb75$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $74b1790885c9bb75$var$_react.default.createElement($74b1790885c9bb75$var$_statusInformation.default, Object.assign({
        name: "StatusInformationIcon",
        LEGACY_fallbackIcon: $74b1790885c9bb75$var$_info.default
    }, props));
$74b1790885c9bb75$var$StatusInformationIcon.displayName = 'StatusInformationIconMigration';
var $74b1790885c9bb75$var$_default = module.exports.default = $74b1790885c9bb75$var$StatusInformationIcon;

});

parcelRegister("lbiFO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f966e8890debb57eaf4e6f167681f98b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f6b91c3558157ad2$var$_react = $f6b91c3558157ad2$var$_interopRequireDefault((parcelRequire("91i6m")));

var $f6b91c3558157ad2$var$_statusSuccess = $f6b91c3558157ad2$var$_interopRequireDefault((parcelRequire("cGnBH")));

var $f6b91c3558157ad2$var$_checkCircle = $f6b91c3558157ad2$var$_interopRequireDefault((parcelRequire("4eF3Q")));
function $f6b91c3558157ad2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusSuccessIcon.
 * This component is StatusSuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f6b91c3558157ad2$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $f6b91c3558157ad2$var$_react.default.createElement($f6b91c3558157ad2$var$_statusSuccess.default, Object.assign({
        name: "StatusSuccessIcon",
        LEGACY_fallbackIcon: $f6b91c3558157ad2$var$_checkCircle.default
    }, props));
$f6b91c3558157ad2$var$StatusSuccessIcon.displayName = 'StatusSuccessIconMigration';
var $f6b91c3558157ad2$var$_default = module.exports.default = $f6b91c3558157ad2$var$StatusSuccessIcon;

});

parcelRegister("5v3A0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::715767a087f47b16ede12b841c1dd7f2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $40129fdc2859ad39$var$_react = $40129fdc2859ad39$var$_interopRequireDefault((parcelRequire("91i6m")));

var $40129fdc2859ad39$var$_statusWarning = $40129fdc2859ad39$var$_interopRequireDefault((parcelRequire("5CINd")));

var $40129fdc2859ad39$var$_warning = $40129fdc2859ad39$var$_interopRequireDefault((parcelRequire("jtCfM")));
function $40129fdc2859ad39$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusWarningIcon.
 * This component is StatusWarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $40129fdc2859ad39$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $40129fdc2859ad39$var$_react.default.createElement($40129fdc2859ad39$var$_statusWarning.default, Object.assign({
        name: "StatusWarningIcon",
        LEGACY_fallbackIcon: $40129fdc2859ad39$var$_warning.default
    }, props));
$40129fdc2859ad39$var$StatusWarningIcon.displayName = 'StatusWarningIconMigration';
var $40129fdc2859ad39$var$_default = module.exports.default = $40129fdc2859ad39$var$StatusWarningIcon;

});

parcelRegister("elvvw", function(module, exports) {

$parcel$export(module.exports, "B200", function () { return $a71b778ef958b8f4$export$215b7063051591f1; });
$parcel$export(module.exports, "B400", function () { return $a71b778ef958b8f4$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "N0", function () { return $a71b778ef958b8f4$export$29a4f05edc054374; });
$parcel$export(module.exports, "N500", function () { return $a71b778ef958b8f4$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N700", function () { return $a71b778ef958b8f4$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $a71b778ef958b8f4$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $a71b778ef958b8f4$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $a71b778ef958b8f4$export$920c0d5c49070351; });
// Reds
var $a71b778ef958b8f4$export$4b84fd0e2c617bd = '#FFEBE6';
var $a71b778ef958b8f4$export$b34b069eff244586 = '#FFBDAD';
var $a71b778ef958b8f4$export$be802dd0d8b57f35 = '#FF8F73';
var $a71b778ef958b8f4$export$60847d42f9da92a6 = '#FF7452';
var $a71b778ef958b8f4$export$4a7404f376229999 = '#FF5630';
var $a71b778ef958b8f4$export$2010d0fb4295b346 = '#DE350B';
var $a71b778ef958b8f4$export$2837b5a1a71d5c02 = '#BF2600';
var $a71b778ef958b8f4$export$8d9596b529bbb9cf = '#FFFAE6';
var $a71b778ef958b8f4$export$41060a744ab0b7ae = '#FFF0B3';
var $a71b778ef958b8f4$export$1cc05bbbf340e559 = '#FFE380';
var $a71b778ef958b8f4$export$5aae31392d72caaa = '#FFC400';
var $a71b778ef958b8f4$export$c6930421db9fa514 = '#FFAB00';
var $a71b778ef958b8f4$export$59619663aa6500fb = '#FF991F';
var $a71b778ef958b8f4$export$874739ea9e379ab6 = '#FF8B00';
var $a71b778ef958b8f4$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $a71b778ef958b8f4$export$69a3bf21b9686c2b = '#ABF5D1';
var $a71b778ef958b8f4$export$afbce1382ec95f73 = '#79F2C0';
var $a71b778ef958b8f4$export$747d86715d4175de = '#57D9A3';
var $a71b778ef958b8f4$export$940e1f69e873f202 = '#36B37E';
var $a71b778ef958b8f4$export$a49394138f7b8e85 = '#00875A';
var $a71b778ef958b8f4$export$6fa04827ac68a4fb = '#006644';
var $a71b778ef958b8f4$export$226de0355ed012f8 = '#DEEBFF';
var $a71b778ef958b8f4$export$8c13c2ee36917869 = '#B3D4FF';
var $a71b778ef958b8f4$export$ecfc1dff386a3e7a = '#4C9AFF';
var $a71b778ef958b8f4$export$215b7063051591f1 = '#2684FF';
var $a71b778ef958b8f4$export$e62e8919cca44969 = '#0065FF';
var $a71b778ef958b8f4$export$b3de0ae08da2ce64 = '#0052CC';
var $a71b778ef958b8f4$export$a6ee3d71bc067634 = '#0747A6';
var $a71b778ef958b8f4$export$67f15409e87642a1 = '#669DF1';
var $a71b778ef958b8f4$export$f0539dbc42dbb067 = '#8FB8F6';
var $a71b778ef958b8f4$export$363e4475840015bb = '#EAE6FF';
var $a71b778ef958b8f4$export$4b0a4417ed59760f = '#C0B6F2';
var $a71b778ef958b8f4$export$6011520a64d9a187 = '#998DD9';
var $a71b778ef958b8f4$export$a7175d4e9206bc80 = '#8777D9';
var $a71b778ef958b8f4$export$b48405b95304b5a1 = '#6554C0';
var $a71b778ef958b8f4$export$c71e4279dd54a18d = '#5243AA';
var $a71b778ef958b8f4$export$147899de772240ec = '#403294';
var $a71b778ef958b8f4$export$2cf711fe14c66f06 = '#E6FCFF';
var $a71b778ef958b8f4$export$7a8f4d33f6f9772c = '#B3F5FF';
var $a71b778ef958b8f4$export$776c9c497ef08533 = '#79E2F2';
var $a71b778ef958b8f4$export$69cb3ca10c1e330e = '#00C7E6';
var $a71b778ef958b8f4$export$9dc1ef0f3f48059b = '#00B8D9';
var $a71b778ef958b8f4$export$7c835c78b6fcdef8 = '#00A3BF';
var $a71b778ef958b8f4$export$6036577f95c3877e = '#008DA6';
var $a71b778ef958b8f4$export$29a4f05edc054374 = '#FFFFFF';
var $a71b778ef958b8f4$export$e655ef011c4aa1a2 = '#FAFBFC';
var $a71b778ef958b8f4$export$9fdfb749e33cdf97 = '#F4F5F7';
var $a71b778ef958b8f4$export$3e51e8f1440314ba = '#EBECF0';
var $a71b778ef958b8f4$export$1ce2d1575d444ceb = '#DFE1E6';
var $a71b778ef958b8f4$export$8754fc7e6d8b3000 = '#C1C7D0';
var $a71b778ef958b8f4$export$c2e91cbeada39b8b = '#B3BAC5';
var $a71b778ef958b8f4$export$5f71e19f3a7ad9de = '#A5ADBA';
var $a71b778ef958b8f4$export$eaa8c8a70ac22806 = '#97A0AF';
var $a71b778ef958b8f4$export$7c87d337fb91a97d = '#8993A4';
var $a71b778ef958b8f4$export$d6447c357493214f = '#7A869A';
var $a71b778ef958b8f4$export$f563ee71e9ee74cd = '#6B778C';
var $a71b778ef958b8f4$export$e2ef2124cf4024b1 = '#5E6C84';
var $a71b778ef958b8f4$export$eece5f492e429f08 = '#505F79';
var $a71b778ef958b8f4$export$c39c0fe0f26207ae = '#42526E';
var $a71b778ef958b8f4$export$7090862dc3038a9f = '#344563';
var $a71b778ef958b8f4$export$ad0bacf983b7ddaa = '#253858';
var $a71b778ef958b8f4$export$7d61b15e0da132af = '#172B4D';
var $a71b778ef958b8f4$export$fbda843f0a27fe96 = '#091E42';
var $a71b778ef958b8f4$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $a71b778ef958b8f4$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $a71b778ef958b8f4$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $a71b778ef958b8f4$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $a71b778ef958b8f4$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $a71b778ef958b8f4$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $a71b778ef958b8f4$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $a71b778ef958b8f4$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $a71b778ef958b8f4$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $a71b778ef958b8f4$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $a71b778ef958b8f4$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $a71b778ef958b8f4$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $a71b778ef958b8f4$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $a71b778ef958b8f4$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $a71b778ef958b8f4$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $a71b778ef958b8f4$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $a71b778ef958b8f4$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $a71b778ef958b8f4$export$2f6319cf7d736c2a = '#E6EDFA';
var $a71b778ef958b8f4$export$95126bc8884d6634 = '#DCE5F5';
var $a71b778ef958b8f4$export$8338d8c35d44ff1 = '#CED9EB';
var $a71b778ef958b8f4$export$5368d76ae4fbbda7 = '#B8C7E0';
var $a71b778ef958b8f4$export$9f0a771d16ec8d36 = '#ABBBD6';
var $a71b778ef958b8f4$export$abcf8c38338b4aa5 = '#9FB0CC';
var $a71b778ef958b8f4$export$97e81faa16a182c7 = '#8C9CB8';
var $a71b778ef958b8f4$export$bfe21c59123ecf33 = '#7988A3';
var $a71b778ef958b8f4$export$ee82aa2ea6a1558 = '#67758F';
var $a71b778ef958b8f4$export$682927c6ed76be02 = '#56637A';
var $a71b778ef958b8f4$export$91fd9994c5be9757 = '#455166';
var $a71b778ef958b8f4$export$d281fbfe3cff2df6 = '#3B475C';
var $a71b778ef958b8f4$export$3902c91d8b98a753 = '#313D52';
var $a71b778ef958b8f4$export$8e8133c1ba5845b5 = '#283447';
var $a71b778ef958b8f4$export$33ff357f6620b39 = '#202B3D';
var $a71b778ef958b8f4$export$633847cf062b69e0 = '#1B2638';
var $a71b778ef958b8f4$export$9776a6e503bdbf76 = '#121A29';
var $a71b778ef958b8f4$export$6c813d5160dff5db = '#0E1624';
var $a71b778ef958b8f4$export$3d4f271a500072a = '#0D1424';
var $a71b778ef958b8f4$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $a71b778ef958b8f4$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $a71b778ef958b8f4$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $a71b778ef958b8f4$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $a71b778ef958b8f4$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $a71b778ef958b8f4$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $a71b778ef958b8f4$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $a71b778ef958b8f4$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $a71b778ef958b8f4$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $a71b778ef958b8f4$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $a71b778ef958b8f4$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $a71b778ef958b8f4$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $a71b778ef958b8f4$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $a71b778ef958b8f4$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $a71b778ef958b8f4$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $a71b778ef958b8f4$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $a71b778ef958b8f4$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $a71b778ef958b8f4$export$d2adc5dedf09fced = '#292A2E';
var $a71b778ef958b8f4$export$f51762073d2bb381 = '#94C748';
var $a71b778ef958b8f4$export$95e26d54def96891 = '#B3DF72';

});



parcelRegister("l774Y", function(module, exports) {

$parcel$export(module.exports, "useFlagGroup", function () { return $f5efbe3352e4e1f2$export$e91ea202abb66350; });
$parcel$export(module.exports, "default", function () { return $f5efbe3352e4e1f2$export$2e2bcd8739ae039; });
/* flag-group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $61RDg = parcelRequire("61RDg");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $6A0cm = parcelRequire("6A0cm");

var $erZ2i = parcelRequire("erZ2i");
var $ilvBF = parcelRequire("ilvBF");

var $lLIDD = parcelRequire("lLIDD");

var $5hco2 = parcelRequire("5hco2");

var $kQU6o = parcelRequire("kQU6o");
var $f5efbe3352e4e1f2$export$1eee5ddc4f6d41c5 = 400;
var $f5efbe3352e4e1f2$var$defaultFlagGroupContext = {
    onDismissed: (0, $6A0cm.default),
    isDismissAllowed: false
};
var $f5efbe3352e4e1f2$export$c57ba665aaa722be = /*#__PURE__*/ (0, $91i6m.createContext)($f5efbe3352e4e1f2$var$defaultFlagGroupContext);
function $f5efbe3352e4e1f2$export$e91ea202abb66350() {
    return (0, $91i6m.useContext)($f5efbe3352e4e1f2$export$c57ba665aaa722be);
}
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
var $f5efbe3352e4e1f2$var$groupStyles = {
    root: "_v5641b8g _1bsb1kdj _kqswstnw _u7coidpf _1eqkauwl",
    first: "_v564glyw _t9ec1ygq _1pbyqfx8",
    second: "_1pbyegat",
    nth: "_5sag5cps _t9ec1hw2",
    hidden: "_3um015vq"
};
// Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
var $f5efbe3352e4e1f2$var$dismissAllowedStyles = null;
var $f5efbe3352e4e1f2$var$flagGroupContainerStyles = null;
/**
 * __Flag group__
 *
 * A flag group is used to group a set of related flags, with entry and exit animations.
 *
 * - [Examples](https://atlassian.design/components/flag/flag-group/examples)
 * - [Code](https://atlassian.design/components/flag/flag-group/code)
 */ var $f5efbe3352e4e1f2$var$FlagGroup = function FlagGroup(props) {
    var id = props.id, _props$label = props.label, label = _props$label === void 0 ? 'Flag notifications' : _props$label, _props$labelTag = props.labelTag, LabelTag = _props$labelTag === void 0 ? 'h2' : _props$labelTag, _props$shouldRenderTo = props.shouldRenderToParent, shouldRenderToParent = _props$shouldRenderTo === void 0 ? false : _props$shouldRenderTo, children = props.children, _props$onDismissed = props.onDismissed, onDismissed = _props$onDismissed === void 0 ? (0, $6A0cm.default) : _props$onDismissed;
    var hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    var dismissFlagContext = (0, $91i6m.useMemo)(function() {
        return {
            onDismissed: onDismissed,
            isDismissAllowed: true
        };
    }, [
        onDismissed
    ]);
    var renderChildren = function renderChildren() {
        return children && (0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(children) === 'object' ? (0, $91i6m.Children).map(children, function(flag, index) {
            var isDismissAllowed = index === 0;
            return /*#__PURE__*/ $91i6m.createElement((0, $ilvBF.default), {
                enterFrom: "left",
                fade: "inout",
                duration: "medium",
                animationTimingFunction: "ease-in"
            }, function(_ref) {
                var className = _ref.className, ref = _ref.ref;
                return /*#__PURE__*/ $91i6m.createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $9gzWK.default)([
                        $f5efbe3352e4e1f2$var$groupStyles.root,
                        index === 0 && $f5efbe3352e4e1f2$var$groupStyles.first,
                        index === 1 && $f5efbe3352e4e1f2$var$groupStyles.second,
                        index >= 1 && $f5efbe3352e4e1f2$var$groupStyles.nth,
                        index >= 2 && $f5efbe3352e4e1f2$var$groupStyles.hidden,
                        isDismissAllowed && "_12a7luct",
                        className
                    ]),
                    ref: ref
                }, /*#__PURE__*/ $91i6m.createElement($f5efbe3352e4e1f2$export$c57ba665aaa722be.Provider, {
                    value: // Only the first flag should be able to be dismissed.
                    isDismissAllowed ? dismissFlagContext : $f5efbe3352e4e1f2$var$defaultFlagGroupContext
                }, flag));
            });
        }) : false;
    };
    var flags = /*#__PURE__*/ $91i6m.createElement("div", {
        id: id,
        className: (0, $9gzWK.default)([
            "_kqsw1n9t _1pbyxejw _u7cooahv _1e021epz _1iafidpf _il0widpf"
        ])
    }, hasFlags ? /*#__PURE__*/ $91i6m.createElement((0, $kQU6o.default), null, /*#__PURE__*/ $91i6m.createElement(LabelTag, null, label)) : null, /*#__PURE__*/ $91i6m.createElement((0, $erZ2i.default), {
        appear: false
    }, renderChildren()));
    return shouldRenderToParent ? flags : /*#__PURE__*/ $91i6m.createElement((0, $lLIDD.default), {
        zIndex: (0, $5hco2.layers).flag()
    }, flags);
};
var $f5efbe3352e4e1f2$export$2e2bcd8739ae039 = $f5efbe3352e4e1f2$var$FlagGroup;

});
parcelRegister("ilvBF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5b2b48dc0cd08b9$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $kH5Bg = parcelRequire("kH5Bg");
/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions).
 */ var $d5b2b48dc0cd08b9$var$SlideIn = function SlideIn(_ref) {
    var children = _ref.children, enterFrom = _ref.enterFrom, exitTo = _ref.exitTo, _ref$fade = _ref.fade, fade = _ref$fade === void 0 ? 'none' : _ref$fade, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'medium' : _ref$duration, isPaused = _ref.isPaused, onFinish = _ref.onFinish, _ref$animationTimingF = _ref.animationTimingFunction, animationTimingFunction = _ref$animationTimingF === void 0 ? 'ease-out' : _ref$animationTimingF, _ref$animationTimingF2 = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF2 === void 0 ? 'ease-in' : _ref$animationTimingF2;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $kH5Bg.default), {
        duration: duration,
        enteringAnimation: "slide-in-from-".concat(enterFrom),
        exitingAnimation: "slide-out-from-".concat(exitTo || enterFrom),
        animationTimingFunction: animationTimingFunction,
        animationTimingFunctionExiting: animationTimingFunctionExiting,
        isPaused: isPaused,
        onFinish: onFinish
    }, children);
};
var $d5b2b48dc0cd08b9$export$2e2bcd8739ae039 = $d5b2b48dc0cd08b9$var$SlideIn;

});

parcelRegister("5hco2", function(module, exports) {

$parcel$export(module.exports, "layers", function () { return $3d782605e395a400$export$7be255094ccdc533; });

var $5RmjO = parcelRequire("5RmjO");

var $elvvw = parcelRequire("elvvw");
var $3d782605e395a400$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $3d782605e395a400$export$c93026a968943f95 = 'light';
var $3d782605e395a400$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $3d782605e395a400$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $3d782605e395a400$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $elvvw.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $3d782605e395a400$export$6d8204c2cb2e06b8() / 4;
    (0, $5RmjO.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $3d782605e395a400$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $3d782605e395a400$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $3d782605e395a400$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $5RmjO.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $3d782605e395a400$export$ba1d834b86d72a09 = $3d782605e395a400$export$a1b3edb637fb4f35;
var $3d782605e395a400$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $elvvw.N20A), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $elvvw.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $elvvw.N30A), ")")
            }
        }
    };
};

});


parcelRegister("fk4ke", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b27c1436805a65df$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $91i6m = parcelRequire("91i6m");

var $tbh94 = parcelRequire("tbh94");

var $nCfon = parcelRequire("nCfon");

var $bfMJJ = parcelRequire("bfMJJ");

var $8bicO = parcelRequire("8bicO");

var $3VuzU = parcelRequire("3VuzU");
var $b27c1436805a65df$var$DismissButtonComponent = function DismissButtonComponent(_ref) {
    var appearance = _ref.appearance, onClick = _ref.onClick, isBold = _ref.isBold, isExpanded = _ref.isExpanded, testId = _ref.testId;
    var ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($8bicO)));
    var buttonLabel = 'Dismiss';
    var size = 'small';
    var buttonTestId = testId && "".concat(testId, "-dismiss");
    if (isBold) {
        ButtonIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($bfMJJ))) : (0, (/*@__PURE__*/$parcel$interopDefault($nCfon)));
        buttonLabel = isExpanded ? 'Collapse' : 'Expand';
        size = 'medium';
        buttonTestId = testId && "".concat(testId, "-toggle");
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $tbh94.default), {
        icon: function icon(iconProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(ButtonIcon, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, iconProps, {
                LEGACY_size: size,
                size: "small",
                label: "",
                color: (0, $3VuzU.flagTextColorToken)[appearance]
            }));
        },
        appearance: "subtle",
        spacing: "compact",
        label: buttonLabel,
        onClick: onClick,
        "aria-expanded": isBold ? isExpanded : undefined,
        testId: buttonTestId
    });
};
var $b27c1436805a65df$var$DismissButton = /*#__PURE__*/ (0, $91i6m.memo)($b27c1436805a65df$var$DismissButtonComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b27c1436805a65df$export$2e2bcd8739ae039 = $b27c1436805a65df$var$DismissButton;

});
parcelRegister("tbh94", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $057b74a26f2e932f$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $bb3nf = parcelRequire("bb3nf");

var $lMv0j = parcelRequire("lMv0j");

var $kQU6o = parcelRequire("kQU6o");

var $2jxp0 = parcelRequire("2jxp0");

var $fXpPO = parcelRequire("fXpPO");

var $aD51X = parcelRequire("aD51X");
var $057b74a26f2e932f$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $057b74a26f2e932f$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $057b74a26f2e932f$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).forwardRef(function Button(_ref, ref) {
    var _tooltip$content;
    var preventedAriaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, _onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $057b74a26f2e932f$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(unsafeRest, $057b74a26f2e932f$var$_excluded2);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2jxp0.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, saferRest, {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: _onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $fXpPO.default), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $aD51X.default), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $kQU6o.default), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $lMv0j.default), {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents
    }, function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2jxp0.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, saferRest, {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === 'circle',
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: function onClick(e, analyticsEvent) {
                var _triggerProps$onClick;
                _onClick === null || _onClick === void 0 || _onClick(e, analyticsEvent);
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            ref: (0, $bb3nf.default)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $fXpPO.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $aD51X.default), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $kQU6o.default), null, label)));
    });
}));
$057b74a26f2e932f$var$IconButton.displayName = 'IconButton';
var $057b74a26f2e932f$export$2e2bcd8739ae039 = $057b74a26f2e932f$var$IconButton;

});
parcelRegister("bb3nf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $823356c98a5580de$export$2e2bcd8739ae039; });
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $823356c98a5580de$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("2jxp0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1af7441b37ad82e4$export$2e2bcd8739ae039; });
/* button-base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $9gzWK = parcelRequire("9gzWK");

var $91i6m = parcelRequire("91i6m");

var $da7Sb = parcelRequire("da7Sb");

var $bb3nf = parcelRequire("bb3nf");

var $a4cH2 = parcelRequire("a4cH2");

var $lD6mB = parcelRequire("lD6mB");

var $f1k1y = parcelRequire("f1k1y");

var $kKNUG = parcelRequire("kKNUG");

var $kQU6o = parcelRequire("kQU6o");

var $ImPgp = parcelRequire("ImPgp");

var $7ZUmN = parcelRequire("7ZUmN");

var $56eGE = parcelRequire("56eGE");
var $1af7441b37ad82e4$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $1af7441b37ad82e4$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $1af7441b37ad82e4$var$LOADING_LABEL = ', Loading';
var $1af7441b37ad82e4$var$styles = {
    base: "_2rkofajl _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1lh4 _30l31lh4 _9h8h1lh4",
    sharedDisabled: "_bfhk1fvb _irr31fvb _1di61fvb",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $1af7441b37ad82e4$var$defaultStyles = {
    root: "_bfhk1j54 _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhksm61 _syaz1gjq _8l3mmuej _aetrb3bt _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr3yw9d _30l310s3 _1di6ih13 _9h8h10s3",
    interactiveRefreshed: "_irr3166n _30l31gjq _1di61dty _9h8h1gjq",
    disabledRefreshed: "_bfhk1j28 _8l3m13gt _irr31j28 _1di61j28"
};
var $1af7441b37ad82e4$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
var $1af7441b37ad82e4$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _9h8hal3n",
    interactive: "_30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
var $1af7441b37ad82e4$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
var $1af7441b37ad82e4$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
var $1af7441b37ad82e4$var$subtleStyles = {
    root: "_bfhkqtfy _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhkqtfy _syaz1gjq _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr34mfv _30l310s3 _1di619qy _9h8h10s3",
    interactiveRefreshed: "_irr34mfv _30l31gjq _1di619qy _9h8h1gjq",
    disabledRefreshed: "_bfhk1j28 _8l3m13gt _irr31j28 _1di61j28"
};
var $1af7441b37ad82e4$var$selectedStyles = {
    root: "_bfhk7btw _syaz1pke _10531pke _f8pj1pke _30l31pke _9h8h1pke",
    rootRefreshed: "_bfhkfg4m _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3t71w _30l31pke _1di6yssv _9h8h1pke",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $1af7441b37ad82e4$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).forwardRef(function(_ref, ref) {
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $1af7441b37ad82e4$var$_excluded);
    var localRef = (0, $91i6m.useRef)(null);
    var splitButtonContext = (0, $ImPgp.useSplitButtonContext)();
    var loadingLabelId = (0, $lD6mB.useId)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    var appearance = isDefaultAppearanceSplitButton && (0, $f1k1y.fg)('platform-component-visual-refresh') ? 'subtle' : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || 'default';
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $a4cH2.default)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(unsafeRest, $1af7441b37ad82e4$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $kKNUG.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, saferRest, {
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $bb3nf.default)([
            localRef,
            ref
        ]),
        xcss: (0, $da7Sb.cx)($1af7441b37ad82e4$var$styles.base, appearance === 'default' && ((0, $f1k1y.fg)('platform-component-visual-refresh') ? $1af7441b37ad82e4$var$defaultStyles.rootRefreshed : $1af7441b37ad82e4$var$defaultStyles.root), appearance === 'default' && isInteractive && ((0, $f1k1y.fg)('platform-component-visual-refresh') ? $1af7441b37ad82e4$var$defaultStyles.interactiveRefreshed : $1af7441b37ad82e4$var$defaultStyles.interactive), appearance === 'primary' && $1af7441b37ad82e4$var$primaryStyles.root, appearance === 'primary' && isInteractive && $1af7441b37ad82e4$var$primaryStyles.interactive, appearance === 'warning' && $1af7441b37ad82e4$var$warningStyles.root, appearance === 'warning' && isInteractive && $1af7441b37ad82e4$var$warningStyles.interactive, appearance === 'danger' && $1af7441b37ad82e4$var$dangerStyles.root, appearance === 'danger' && isInteractive && $1af7441b37ad82e4$var$dangerStyles.interactive, appearance === 'discovery' && $1af7441b37ad82e4$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $1af7441b37ad82e4$var$discoveryStyles.interactive, appearance === 'subtle' && ((0, $f1k1y.fg)('platform-component-visual-refresh') ? $1af7441b37ad82e4$var$subtleStyles.rootRefreshed : $1af7441b37ad82e4$var$subtleStyles.root), appearance === 'subtle' && isInteractive && ((0, $f1k1y.fg)('platform-component-visual-refresh') ? $1af7441b37ad82e4$var$subtleStyles.interactiveRefreshed : $1af7441b37ad82e4$var$subtleStyles.interactive), $1af7441b37ad82e4$var$styles.linkDecorationUnset, isSelected && ((0, $f1k1y.fg)('platform-component-visual-refresh') ? $1af7441b37ad82e4$var$selectedStyles.rootRefreshed : $1af7441b37ad82e4$var$selectedStyles.root), isSelected && isSplitButton && $1af7441b37ad82e4$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $1af7441b37ad82e4$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $1af7441b37ad82e4$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $1af7441b37ad82e4$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $1af7441b37ad82e4$var$selectedStyles.discovery, isDisabled && $1af7441b37ad82e4$var$styles.disabled, isDisabled && (!(0, $f1k1y.fg)('platform-component-visual-refresh') || appearance !== 'default' && appearance !== 'subtle') && $1af7441b37ad82e4$var$styles.sharedDisabled, isDisabled && appearance === 'default' && ((0, $f1k1y.fg)('platform-component-visual-refresh') ? $1af7441b37ad82e4$var$defaultStyles.disabledRefreshed : $1af7441b37ad82e4$var$defaultStyles.disabled), isCircle && !isSplitButton && $1af7441b37ad82e4$var$styles.circle, spacing === 'compact' && $1af7441b37ad82e4$var$styles.spacingCompact, hasIconBefore && $1af7441b37ad82e4$var$styles.buttonIconBefore, shouldFitContainer && $1af7441b37ad82e4$var$styles.fullWidth, hasIconAfter && $1af7441b37ad82e4$var$styles.buttonIconAfter, isIconButton && $1af7441b37ad82e4$var$styles.iconButton, isIconButton && spacing === 'compact' && $1af7441b37ad82e4$var$styles.iconButtonCompact, isLoading && $1af7441b37ad82e4$var$styles.loading, isSplitButton && $1af7441b37ad82e4$var$styles.splitButton, isNavigationSplitButton && $1af7441b37ad82e4$var$styles.navigationSplitButton),
        isDisabled: isEffectivelyDisabled,
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($1af7441b37ad82e4$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $7ZUmN.default)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $ImPgp.SplitButtonContext).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("span", {
        className: (0, $9gzWK.default)([
            $1af7441b37ad82e4$var$styles.loadingOverlay
        ])
    }, (0, $56eGE.default)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $kQU6o.default), {
        id: loadingLabelId
    }, $1af7441b37ad82e4$var$LOADING_LABEL)));
});
var $1af7441b37ad82e4$export$2e2bcd8739ae039 = $1af7441b37ad82e4$var$ButtonBase;

});
parcelRegister("ImPgp", function(module, exports) {

$parcel$export(module.exports, "SplitButtonContext", function () { return $0855d0e91824b675$export$4b86304b2c0d7e71; });
$parcel$export(module.exports, "useSplitButtonContext", function () { return $0855d0e91824b675$export$47e2c6fdb142d947; });

var $91i6m = parcelRequire("91i6m");
var $0855d0e91824b675$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $91i6m.createContext)(undefined);
var $0855d0e91824b675$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $91i6m.useContext)($0855d0e91824b675$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("7ZUmN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d29f42e5bfd9987$export$2e2bcd8739ae039; });
function $5d29f42e5bfd9987$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $5d29f42e5bfd9987$var$tabKeyCode = 9;
function $5d29f42e5bfd9987$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $5d29f42e5bfd9987$var$tabKeyCode) return;
    $5d29f42e5bfd9987$var$abort(event);
}
function $5d29f42e5bfd9987$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $5d29f42e5bfd9987$var$abort,
        onMouseUpCapture: $5d29f42e5bfd9987$var$abort,
        onKeyDownCapture: $5d29f42e5bfd9987$var$onKey,
        onKeyUpCapture: $5d29f42e5bfd9987$var$onKey,
        onTouchStartCapture: $5d29f42e5bfd9987$var$abort,
        onTouchEndCapture: $5d29f42e5bfd9987$var$abort,
        onPointerDownCapture: $5d29f42e5bfd9987$var$abort,
        onPointerUpCapture: $5d29f42e5bfd9987$var$abort,
        onClickCapture: $5d29f42e5bfd9987$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $5d29f42e5bfd9987$var$abort
    } : events;
}

});

parcelRegister("56eGE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b68e7cdfa9d044c$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $9OWP7 = parcelRequire("9OWP7");
function $3b68e7cdfa9d044c$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $3b68e7cdfa9d044c$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $3b68e7cdfa9d044c$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $9OWP7.default), {
        size: $3b68e7cdfa9d044c$var$getIconSpacing(spacing),
        appearance: $3b68e7cdfa9d044c$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}

});


parcelRegister("fXpPO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9e067efc04f5090$export$2e2bcd8739ae039; });
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $9gzWK = parcelRequire("9gzWK");

var $91i6m = parcelRequire("91i6m");
var $b9e067efc04f5090$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    beforeIcon: "_1he91b66 _w795v77o",
    afterIcon: "_1he9v77o _w7951b66",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $b9e067efc04f5090$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, isLoading = _ref.isLoading, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("span", {
        className: (0, $9gzWK.default)([
            $b9e067efc04f5090$var$styles.common,
            type === 'text' && $b9e067efc04f5090$var$styles.text,
            type === 'icon' && $b9e067efc04f5090$var$styles.icon,
            isLoading && $b9e067efc04f5090$var$styles.fade,
            position === 'before' && $b9e067efc04f5090$var$styles.beforeIcon,
            position === 'after' && $b9e067efc04f5090$var$styles.afterIcon
        ])
    }, children);
};
var $b9e067efc04f5090$export$2e2bcd8739ae039 = $b9e067efc04f5090$var$Content;

});

parcelRegister("aD51X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7bd172dc1487768c$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $f1k1y = parcelRequire("f1k1y");
function $7bd172dc1487768c$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $7bd172dc1487768c$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    var isRenderProp = $7bd172dc1487768c$var$isIconRenderProp(Icon);
    var iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $f1k1y.fg)('platform_dst_button_chevron_sizing') ? function(iconName) {
            return iconName.startsWith('Chevron') ? 'small' : 'medium';
        } : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(Icon, iconProps));
};
var $7bd172dc1487768c$export$2e2bcd8739ae039 = $7bd172dc1487768c$var$IconRenderer;

});


parcelRegister("nCfon", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::119fcb233ad7d2568bcc63888dfec4d2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $046fd134cefffd37$var$_react = $046fd134cefffd37$var$_interopRequireDefault((parcelRequire("91i6m")));

var $046fd134cefffd37$var$_chevronDown = $046fd134cefffd37$var$_interopRequireDefault((parcelRequire("i12Lt")));

var $046fd134cefffd37$var$_chevronDown2 = $046fd134cefffd37$var$_interopRequireDefault((parcelRequire("izB6f")));
function $046fd134cefffd37$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "HipchatChevronDownIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $046fd134cefffd37$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $046fd134cefffd37$var$_react.default.createElement($046fd134cefffd37$var$_chevronDown.default, Object.assign({
        name: "ChevronDownIcon",
        LEGACY_fallbackIcon: $046fd134cefffd37$var$_chevronDown2.default
    }, props));
$046fd134cefffd37$var$ChevronDownIcon.displayName = 'ChevronDownIconMigration';
var $046fd134cefffd37$var$_default = module.exports.default = $046fd134cefffd37$var$ChevronDownIcon;

});

parcelRegister("bfMJJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9122dabf5a4e80a209ec2f5b7da6e804>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8316e684b3e93c13$var$_react = $8316e684b3e93c13$var$_interopRequireDefault((parcelRequire("91i6m")));

var $8316e684b3e93c13$var$_chevronUp = $8316e684b3e93c13$var$_interopRequireDefault((parcelRequire("6uAkD")));

var $8316e684b3e93c13$var$_chevronUp2 = $8316e684b3e93c13$var$_interopRequireDefault((parcelRequire("alZnA")));
function $8316e684b3e93c13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronUpIcon.
 * This component is ChevronUpIcon, with `UNSAFE_fallbackIcon` set to "HipchatChevronUpIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8316e684b3e93c13$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $8316e684b3e93c13$var$_react.default.createElement($8316e684b3e93c13$var$_chevronUp.default, Object.assign({
        name: "ChevronUpIcon",
        LEGACY_fallbackIcon: $8316e684b3e93c13$var$_chevronUp2.default
    }, props));
$8316e684b3e93c13$var$ChevronUpIcon.displayName = 'ChevronUpIconMigration';
var $8316e684b3e93c13$var$_default = module.exports.default = $8316e684b3e93c13$var$ChevronUpIcon;

});

parcelRegister("8bicO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2c17176afeb2169f76dc501092efdf0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5f4d790de444bf55$var$_react = $5f4d790de444bf55$var$_interopRequireDefault((parcelRequire("91i6m")));

var $5f4d790de444bf55$var$_cross = $5f4d790de444bf55$var$_interopRequireDefault((parcelRequire("2sg3K")));

var $5f4d790de444bf55$var$_cross2 = $5f4d790de444bf55$var$_interopRequireDefault((parcelRequire("l1DJt")));
function $5f4d790de444bf55$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "CrossIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5f4d790de444bf55$var$CrossIcon = (props)=>/*#__PURE__*/ $5f4d790de444bf55$var$_react.default.createElement($5f4d790de444bf55$var$_cross.default, Object.assign({
        name: "CrossIcon",
        LEGACY_fallbackIcon: $5f4d790de444bf55$var$_cross2.default
    }, props));
$5f4d790de444bf55$var$CrossIcon.displayName = 'CrossIconMigration';
var $5f4d790de444bf55$var$_default = module.exports.default = $5f4d790de444bf55$var$CrossIcon;

});


parcelRegister("95j1K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69d3571ba61e17ec$export$2e2bcd8739ae039; });
/* expander.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $91i6m = parcelRequire("91i6m");


var $erZ2i = parcelRequire("erZ2i");
var $8iz5R = parcelRequire("8iz5R");

var $aDWwl = parcelRequire("aDWwl");
var $hPyLR = parcelRequire("hPyLR");
var $69d3571ba61e17ec$var$styles = {
    expander: "_1bsb1osq",
    container: "_v5641xzp"
};
var $69d3571ba61e17ec$var$Expander = function Expander(_ref) {
    var children = _ref.children, isExpanded = _ref.isExpanded, testId = _ref.testId;
    // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return /*#__PURE__*/ $91i6m.createElement((0, $aDWwl.default), {
        xcss: $69d3571ba61e17ec$var$styles.expander,
        style: {
            maxHeight: isExpanded ? 150 : 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flex: '1 1 100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        },
        "aria-hidden": !isExpanded,
        testId: testId && "".concat(testId, "-expander")
    }, /*#__PURE__*/ $91i6m.createElement((0, $erZ2i.default), {
        appear: true
    }, isExpanded && /*#__PURE__*/ $91i6m.createElement((0, $8iz5R.default), null, function(props) {
        return /*#__PURE__*/ $91i6m.createElement((0, $aDWwl.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
            xcss: $69d3571ba61e17ec$var$styles.container
        }, props), /*#__PURE__*/ $91i6m.createElement((0, $hPyLR.default), {
            space: "space.100"
        }, children));
    })));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$69d3571ba61e17ec$export$2e2bcd8739ae039 = $69d3571ba61e17ec$var$Expander;

});


parcelRegister("1pjMo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $106778104f2995f3$var$_react = $106778104f2995f3$var$_interopRequireDefault((parcelRequire("91i6m")));

var $gJR35 = parcelRequire("gJR35");

var $106778104f2995f3$var$_statusSuccess = $106778104f2995f3$var$_interopRequireDefault((parcelRequire("iMj1N")));
function $106778104f2995f3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $106778104f2995f3$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $106778104f2995f3$var$_react.default.createElement($gJR35.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $106778104f2995f3$var$_statusSuccess.default
    }));
$106778104f2995f3$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $106778104f2995f3$var$_default = module.exports.default = $106778104f2995f3$var$CheckCircleIcon;

});


parcelRegister("gxUYA", function(module, exports) {

$parcel$export(module.exports, "MfaAppsPage", function () { return $a7477bd676e16e93$export$f8df0673716775fc; });
$parcel$export(module.exports, "ExpiredPasswordPage", function () { return $a7477bd676e16e93$export$f8dc9833cdc832ea; });
$parcel$export(module.exports, "MfaEnrollmentPage", function () { return $a7477bd676e16e93$export$1feb78d7c7eef8e6; });
$parcel$export(module.exports, "MfaPromotePage", function () { return $a7477bd676e16e93$export$84ed94b8c66e0057; });
$parcel$export(module.exports, "MultiFactorPage", function () { return $a7477bd676e16e93$export$d5523937d2306712; });
$parcel$export(module.exports, "LoginConsentNoticePage", function () { return $a7477bd676e16e93$export$68f39a5ef8cea54d; });
$parcel$export(module.exports, "CancelAccountDeletionPage", function () { return $a7477bd676e16e93$export$ffebed914bd6a6c9; });
$parcel$export(module.exports, "InactiveAccountPage", function () { return $a7477bd676e16e93$export$ad79d74b0908a012; });
$parcel$export(module.exports, "PendingDeletionPage", function () { return $a7477bd676e16e93$export$40b885b03094ae2d; });
$parcel$export(module.exports, "DeletionRequestConfirmationPage", function () { return $a7477bd676e16e93$export$467fb294f057077d; });
$parcel$export(module.exports, "ChangePasswordPage", function () { return $a7477bd676e16e93$export$8ec0fb1e4323236d; });
$parcel$export(module.exports, "SocialLoginRecoveryPage", function () { return $a7477bd676e16e93$export$ee564d35600efee8; });
$parcel$export(module.exports, "VerifyOrReverifyEmailSentPage", function () { return $a7477bd676e16e93$export$980c3b624c0da509; });
$parcel$export(module.exports, "VerifyOrReverifyEmailErrorPage", function () { return $a7477bd676e16e93$export$647c199e9f3e1159; });
$parcel$export(module.exports, "WelcomeSentPage", function () { return $a7477bd676e16e93$export$9feca1f6b3b10306; });
$parcel$export(module.exports, "LogoutPage", function () { return $a7477bd676e16e93$export$ae5920452e7cb547; });
$parcel$export(module.exports, "StepUpSsoPage", function () { return $a7477bd676e16e93$export$61fae207a78c2e53; });
$parcel$export(module.exports, "StepUpStartPage", function () { return $a7477bd676e16e93$export$e561dacd818ab41; });
$parcel$export(module.exports, "EmailConfirmationPage", function () { return $a7477bd676e16e93$export$98b365c355bab28e; });
$parcel$export(module.exports, "AuthCallbackErrorPage", function () { return $a7477bd676e16e93$export$beb41ed376add573; });
$parcel$export(module.exports, "SecurityExpiredLinkPage", function () { return $a7477bd676e16e93$export$f5edf646533475ec; });
$parcel$export(module.exports, "SecuritySuccessPage", function () { return $a7477bd676e16e93$export$8d7d33e241ae6c52; });
$parcel$export(module.exports, "RemoveAccountPage", function () { return $a7477bd676e16e93$export$66bcaaca6b1eddac; });
$parcel$export(module.exports, "SelectAccountPage", function () { return $a7477bd676e16e93$export$134466789cb44107; });
$parcel$export(module.exports, "ContinueAsPage", function () { return $a7477bd676e16e93$export$a4ce1932d7e73468; });
$parcel$export(module.exports, "MigrateAccountConfirmationPage", function () { return $a7477bd676e16e93$export$3432bb22f729c42b; });
$parcel$export(module.exports, "RecoveryPage", function () { return $a7477bd676e16e93$export$280a36f5ba1cc19f; });
$parcel$export(module.exports, "ChooseMethodPage", function () { return $a7477bd676e16e93$export$d137eda0ebcc3948; });
$parcel$export(module.exports, "ConfigurePhonePage", function () { return $a7477bd676e16e93$export$717e3b31ee3d8960; });
$parcel$export(module.exports, "ConfigureAppPage", function () { return $a7477bd676e16e93$export$d316ce63fb222131; });
$parcel$export(module.exports, "SaveRecoveryKeyPage", function () { return $a7477bd676e16e93$export$70105507d801662a; });
$parcel$export(module.exports, "RegisterSecurityKeyPage", function () { return $a7477bd676e16e93$export$bfd6201eae0d5333; });
$parcel$export(module.exports, "MultiMfaEnrollmentAddAuthenticatorPage", function () { return $a7477bd676e16e93$export$db2cf97d4f19249; });
$parcel$export(module.exports, "MultiMfaEnrollmentAddSecurityKeyPage", function () { return $a7477bd676e16e93$export$6e18f48b7564d95d; });
$parcel$export(module.exports, "LoginPage", function () { return $a7477bd676e16e93$export$f14c0e3f98d164c0; });
$parcel$export(module.exports, "CreateAccountConfirmationPage", function () { return $a7477bd676e16e93$export$74ab7a9a192e1a7a; });
$parcel$export(module.exports, "WelcomePage", function () { return $a7477bd676e16e93$export$630ad10f0e1a953d; });
$parcel$export(module.exports, "VerifyEmailOtpPage", function () { return $a7477bd676e16e93$export$a16cb21d1f9bc820; });
$parcel$export(module.exports, "ResetPasswordPage", function () { return $a7477bd676e16e93$export$da4433e8d8a5678; });
$parcel$export(module.exports, "SignupPage", function () { return $a7477bd676e16e93$export$a2f4b65ede167ce5; });
$parcel$export(module.exports, "SignupOnboardPage", function () { return $a7477bd676e16e93$export$1c7442c86b06b50c; });
$parcel$export(module.exports, "AuthenticatedLoomWorkspaceCreationPage", function () { return $a7477bd676e16e93$export$f296423b4e837594; });

var $91i6m = parcelRequire("91i6m");

const $a7477bd676e16e93$export$f8df0673716775fc = /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("1w7tl")));

const $a7477bd676e16e93$export$8860bd3f7903e57e = /*#__PURE__*/ (0, $91i6m.lazy)(()=>Promise.resolve((parcelRequire("92KZy"))));

const $a7477bd676e16e93$export$357c630eb6814495 = /*#__PURE__*/ (0, $91i6m.lazy)(()=>Promise.resolve((parcelRequire("8ulLA"))));

const $a7477bd676e16e93$export$f8dc9833cdc832ea = /*#__PURE__*/ (0, $91i6m.lazy)(()=>Promise.resolve((parcelRequire("3ssyD"))));

const $a7477bd676e16e93$export$1feb78d7c7eef8e6 = /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("4Dyka")));

const $a7477bd676e16e93$export$84ed94b8c66e0057 = /*#__PURE__*/ (0, $91i6m.lazy)(()=>Promise.resolve((parcelRequire("4b0nc"))));

const $a7477bd676e16e93$export$d5523937d2306712 = /*#__PURE__*/ (0, $91i6m.lazy)(()=>Promise.resolve((parcelRequire("gx9dc"))));

const $a7477bd676e16e93$export$68f39a5ef8cea54d = /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("69a4G")));

const $a7477bd676e16e93$export$ffebed914bd6a6c9 = /*#__PURE__*/ (0, $91i6m.lazy)(()=>Promise.resolve((parcelRequire("9DwAy"))));

const $a7477bd676e16e93$export$ad79d74b0908a012 = /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("ayilx")));

const $a7477bd676e16e93$export$40b885b03094ae2d = /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("aongO")));

const $a7477bd676e16e93$export$467fb294f057077d = /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("6tdoU")));

const $a7477bd676e16e93$export$8ec0fb1e4323236d = /*#__PURE__*/ (0, $91i6m.lazy)(()=>Promise.resolve((parcelRequire("3h4RJ"))));

const $a7477bd676e16e93$export$ee564d35600efee8 = /*#__PURE__*/ (0, $91i6m.lazy)(()=>Promise.resolve((parcelRequire("koa1e"))));

const $a7477bd676e16e93$export$980c3b624c0da509 = /*#__PURE__*/ (0, $91i6m.lazy)(()=>Promise.resolve((parcelRequire("79yMH"))));

const $a7477bd676e16e93$export$647c199e9f3e1159 = /*#__PURE__*/ (0, $91i6m.lazy)(()=>Promise.resolve((parcelRequire("ixF1M"))));

const $a7477bd676e16e93$export$9feca1f6b3b10306 = /*#__PURE__*/ (0, $91i6m.lazy)(()=>Promise.resolve((parcelRequire("ek8yD"))));

const $a7477bd676e16e93$export$ae5920452e7cb547 = /*#__PURE__*/ (0, $91i6m.lazy)(()=>Promise.resolve((parcelRequire("diWiU"))));

const $a7477bd676e16e93$export$61fae207a78c2e53 = /*#__PURE__*/ (0, $91i6m.lazy)(()=>Promise.resolve((parcelRequire("h5BP4"))));

const $a7477bd676e16e93$export$e561dacd818ab41 = /*#__PURE__*/ (0, $91i6m.lazy)(()=>Promise.resolve((parcelRequire("QvxZa"))));

const $a7477bd676e16e93$export$98b365c355bab28e = /*#__PURE__*/ (0, $91i6m.lazy)(()=>Promise.resolve((parcelRequire("2fBti"))));

const $a7477bd676e16e93$export$beb41ed376add573 = /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("3AaCt")));

const $a7477bd676e16e93$export$f5edf646533475ec = /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("lCTBC")));

const $a7477bd676e16e93$export$8d7d33e241ae6c52 = /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("lpGG9")));

const $a7477bd676e16e93$export$66bcaaca6b1eddac = /*#__PURE__*/ (0, $91i6m.lazy)(()=>Promise.resolve((parcelRequire("3Zv9U"))));

const $a7477bd676e16e93$export$134466789cb44107 = /*#__PURE__*/ (0, $91i6m.lazy)(()=>Promise.resolve((parcelRequire("gijFh"))));

const $a7477bd676e16e93$export$a4ce1932d7e73468 = /*#__PURE__*/ (0, $91i6m.lazy)(()=>Promise.resolve((parcelRequire("kjSSV"))));

const $a7477bd676e16e93$export$3432bb22f729c42b = /*#__PURE__*/ (0, $91i6m.lazy)(()=>Promise.resolve((parcelRequire("4xWO8"))));

const $a7477bd676e16e93$export$280a36f5ba1cc19f = /*#__PURE__*/ (0, $91i6m.lazy)(()=>Promise.resolve((parcelRequire("eh3S5"))));

const $a7477bd676e16e93$export$d137eda0ebcc3948 = /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("lIPHR")));

const $a7477bd676e16e93$export$717e3b31ee3d8960 = /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("5lb7m")));

const $a7477bd676e16e93$export$d316ce63fb222131 = /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("kyHV0")));

const $a7477bd676e16e93$export$70105507d801662a = /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("37tZR")));

const $a7477bd676e16e93$export$bfd6201eae0d5333 = /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("kiZXb")));

const $a7477bd676e16e93$export$db2cf97d4f19249 = /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("9IAq0")));

const $a7477bd676e16e93$export$6e18f48b7564d95d = /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("DNJiT")));

const $a7477bd676e16e93$export$f14c0e3f98d164c0 = /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("fT5Rq")));

const $a7477bd676e16e93$export$74ab7a9a192e1a7a = /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("I1or5")));

const $a7477bd676e16e93$export$630ad10f0e1a953d = /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("79zf9")));

const $a7477bd676e16e93$export$a16cb21d1f9bc820 = /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("jY94H")));

const $a7477bd676e16e93$export$da4433e8d8a5678 = /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("etMyF")));

const $a7477bd676e16e93$export$a2f4b65ede167ce5 = /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("dGsLk")));

const $a7477bd676e16e93$export$1c7442c86b06b50c = /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("lTL6l")));

const $a7477bd676e16e93$export$f296423b4e837594 = /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("eONel")));

});
parcelRegister("92KZy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "VerifyEmailSentPage", function () { return $d0ce49667904cffc$export$8860bd3f7903e57e; });
$parcel$export(module.exports, "default", function () { return $d0ce49667904cffc$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $6d87w = parcelRequire("6d87w");
var $l2v8Y = parcelRequire("l2v8Y");

var $8KhCJ = parcelRequire("8KhCJ");

var $8iEgn = parcelRequire("8iEgn");

var $dBq8m = parcelRequire("dBq8m");

var $21Xgy = parcelRequire("21Xgy");

var $fYxRW = parcelRequire("fYxRW");

var $64QTD = parcelRequire("64QTD");

var $damsD = parcelRequire("damsD");

var $balRf = parcelRequire("balRf");

var $gs2u7 = parcelRequire("gs2u7");

var $1V2cH = parcelRequire("1V2cH");

var $2aGBJ = parcelRequire("2aGBJ");
const $d0ce49667904cffc$var$pageId = 'verifyEmailScreen';
const $d0ce49667904cffc$export$8860bd3f7903e57e = ()=>{
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const location = (0, $l2v8Y.useLocation)();
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const dispatchAddFlag = (flag)=>{
        dispatch((0, $21Xgy.addFlag)(flag.type, flag.title, flag.description));
    };
    const email = (0, $2aGBJ.useAppSelector)((state)=>state.user.email);
    const showBrowserWarning = (0, $2aGBJ.useAppSelector)((state)=>state.verifyEmailSent.showBrowserWarning);
    (0, $1V2cH.usePageViewedEvent)($d0ce49667904cffc$var$pageId, {
        browserWarningMessageShown: showBrowserWarning
    });
    const handleResendVerificationEmail = async ()=>{
        analyticsClient.buttonClickedEvent($d0ce49667904cffc$var$pageId, 'resendVerificationEmail');
        try {
            const response = await fetch(`/rest/resend-email${location.search}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (response.status === 204) addSuccessFlag();
            else addErrorFlag();
        } catch (e) {
            addErrorFlag();
        }
    };
    const handleReturnToLogin = ()=>{
        analyticsClient.buttonClickedEvent($d0ce49667904cffc$var$pageId, 'verifyEmailReturnLoginLink');
    };
    const addSuccessFlag = ()=>{
        dispatchAddFlag({
            type: 'success',
            title: (0, $balRf.default).verifyEmailFlagSuccessTitle,
            description: (0, $balRf.default).verifyEmailFlagSuccessDesc
        });
    };
    const addErrorFlag = ()=>{
        dispatchAddFlag({
            type: 'error',
            title: (0, $balRf.default).verifyEmailFlagErrorTitle,
            description: (0, $balRf.default).verifyEmailFlagErrorDesc
        });
    };
    const renderWhiteboxFooter = ()=>{
        const returnLoginLink = `/login?${(0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).stringify((0, $b2I6k._)((0, $1Fos3._)({}, (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(location.search)), {
            email: email
        }))}`;
        const returnToLoginLink = (0, $fYxRW.isTrelloDesktop)() ? /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6d87w.Link), {
            id: "return-login-button",
            to: returnLoginLink,
            onClick: handleReturnToLogin,
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "return.to.log.in",
                defaultMessage: "Return to log in"
            })
        }) : null;
        return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
            children: [
                /*#__PURE__*/ (0, $4ZSso.jsx)("ul", {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $64QTD.default), {
                            id: "send-validation-submit",
                            spacing: "none",
                            className: "link-color-override",
                            onClick: handleResendVerificationEmail,
                            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                                id: "verify.email.resend.signup.link",
                                defaultMessage: "Resend signup link"
                            })
                        })
                    })
                }),
                returnToLoginLink && /*#__PURE__*/ (0, $4ZSso.jsx)("ul", {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                        children: returnToLoginLink
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $gs2u7.default), {
        // @ts-ignore no id
        id: "email-sent-page",
        pageId: $d0ce49667904cffc$var$pageId,
        header: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "verify.email.title",
            tagName: "h5",
            defaultMessage: "Check your inbox to finish signup"
        }),
        whiteboxFooter: renderWhiteboxFooter(),
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8KhCJ.default), {
                title: formatMessage((0, $balRf.default).headTitle)
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $damsD.default), {
                email: email,
                message: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "verify.email.sent.signup.link",
                    tagName: "p",
                    defaultMessage: "We sent a signup link to:",
                    description: "Telling user that a verification link has been sent. This message is followed by the user's email address on the next line."
                }),
                warningMessage: showBrowserWarning && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8iEgn.default), {
                    testId: "browser-warning",
                    appearance: "information",
                    children: formatMessage((0, $balRf.default).browserWarning)
                })
            })
        ]
    });
};
var $d0ce49667904cffc$export$2e2bcd8739ae039 = $d0ce49667904cffc$export$8860bd3f7903e57e;

});
parcelRegister("8iEgn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60af3c968af4b9f4$export$2e2bcd8739ae039; });
/* section-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5YM7L = parcelRequire("5YM7L");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $tbh94 = parcelRequire("tbh94");

var $4jXgk = parcelRequire("4jXgk");

var $6oaoN = parcelRequire("6oaoN");

var $dwV3h = parcelRequire("dwV3h");
var $hPyLR = parcelRequire("hPyLR");

var $1fll9 = parcelRequire("1fll9");
var $60af3c968af4b9f4$var$sectionMessageStyles = {
    container: "_2rko12b0 _1rjcpxbi _18zrpxbi _1nmz1hna",
    iconContainer: "_1mou1i6y _1e0c1txw",
    contentContainer: "_16jlkb7n",
    content: "_11c82smr _syaz1fxt",
    actionsContainer: "_11c82smr",
    dismissButtonContainer: "_19pk1i6y"
};
var $60af3c968af4b9f4$var$appearanceStyles = {
    information: "_bfhk33gi",
    warning: "_bfhk1tzq",
    error: "_bfhk1gly",
    success: "_bfhkmv6i",
    discovery: "_bfhk1nvp"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ var $60af3c968af4b9f4$var$SectionMessage = /*#__PURE__*/ (0, $91i6m.forwardRef)(function SectionMessage(_ref, ref) {
    var children = _ref.children, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'information' : _ref$appearance, actions = _ref.actions, title = _ref.title, icon = _ref.icon, isDismissible = _ref.isDismissible, onDismiss = _ref.onDismiss, testId = _ref.testId;
    var _useState = (0, $91i6m.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), dismissed = _useState2[0], setDismissed = _useState2[1];
    var handleDismiss = (0, $91i6m.useCallback)(function() {
        onDismiss === null || onDismiss === void 0 || onDismiss();
        setDismissed(true);
    }, [
        onDismiss
    ]);
    var _getAppearanceIconSty = (0, $1fll9.getAppearanceIconStyles)(appearance, icon), primaryColor = _getAppearanceIconSty.primaryIconColor, secondaryColor = _getAppearanceIconSty.backgroundColor, Icon = _getAppearanceIconSty.Icon;
    var actionElements = actions && actions.type === (0, $91i6m.Fragment) ? actions.props.children : actions;
    var actionsArray = (0, $91i6m.Children).toArray(actionElements);
    return isDismissible && dismissed ? null : /*#__PURE__*/ $91i6m.createElement("section", {
        "data-testid": testId,
        ref: ref,
        className: (0, $9gzWK.default)([
            $60af3c968af4b9f4$var$sectionMessageStyles.container,
            $60af3c968af4b9f4$var$appearanceStyles[appearance]
        ])
    }, /*#__PURE__*/ $91i6m.createElement((0, $dwV3h.default), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ $91i6m.createElement("div", {
        className: (0, $9gzWK.default)([
            $60af3c968af4b9f4$var$sectionMessageStyles.iconContainer
        ])
    }, /*#__PURE__*/ $91i6m.createElement(Icon, {
        size: "medium",
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        LEGACY_size: "medium",
        color: primaryColor,
        spacing: "spacious"
    })), /*#__PURE__*/ $91i6m.createElement((0, $hPyLR.default), {
        space: "space.100",
        testId: testId && "".concat(testId, "--content"),
        xcss: $60af3c968af4b9f4$var$sectionMessageStyles.contentContainer
    }, !!title && /*#__PURE__*/ $91i6m.createElement((0, $4jXgk.default), {
        as: "h2",
        size: "small"
    }, title), /*#__PURE__*/ $91i6m.createElement("div", {
        className: (0, $9gzWK.default)([
            $60af3c968af4b9f4$var$sectionMessageStyles.content
        ])
    }, children), actionsArray.length > 0 && /*#__PURE__*/ $91i6m.createElement((0, $dwV3h.default), {
        shouldWrap: true,
        testId: testId && "".concat(testId, "--actions"),
        separator: "\xB7",
        space: "space.100",
        rowSpace: "space.0",
        role: actionsArray.length > 1 ? 'list' : undefined,
        xcss: $60af3c968af4b9f4$var$sectionMessageStyles.actionsContainer
    }, actionsArray.map(function(action, id) {
        return(/*#__PURE__*/ // Only use a listitem role if more than one action is present
        $91i6m.createElement((0, $dwV3h.default), {
            role: actionsArray.length > 1 ? 'listitem' : undefined,
            key: id
        }, action));
    }))), isDismissible && /*#__PURE__*/ $91i6m.createElement("div", {
        className: (0, $9gzWK.default)([
            $60af3c968af4b9f4$var$sectionMessageStyles.dismissButtonContainer
        ])
    }, /*#__PURE__*/ $91i6m.createElement((0, $tbh94.default), {
        testId: testId && "".concat(testId, "--dismiss-button"),
        label: "Dismiss",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6oaoN))),
        appearance: "subtle",
        onClick: handleDismiss,
        spacing: "compact"
    }))));
});
$60af3c968af4b9f4$var$SectionMessage.displayName = 'SectionMessage';
var $60af3c968af4b9f4$export$2e2bcd8739ae039 = $60af3c968af4b9f4$var$SectionMessage;

});
parcelRegister("6oaoN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2c17176afeb2169f76dc501092efdf0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4a6d0cf47a876801$var$_react = $4a6d0cf47a876801$var$_interopRequireDefault((parcelRequire("91i6m")));

var $4a6d0cf47a876801$var$_cross = $4a6d0cf47a876801$var$_interopRequireDefault((parcelRequire("9BgQe")));

var $4a6d0cf47a876801$var$_cross2 = $4a6d0cf47a876801$var$_interopRequireDefault((parcelRequire("8BQof")));
function $4a6d0cf47a876801$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "CrossIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4a6d0cf47a876801$var$CrossIcon = (props)=>/*#__PURE__*/ $4a6d0cf47a876801$var$_react.default.createElement($4a6d0cf47a876801$var$_cross.default, Object.assign({
        name: "CrossIcon",
        LEGACY_fallbackIcon: $4a6d0cf47a876801$var$_cross2.default
    }, props));
$4a6d0cf47a876801$var$CrossIcon.displayName = 'CrossIconMigration';
var $4a6d0cf47a876801$var$_default = module.exports.default = $4a6d0cf47a876801$var$CrossIcon;

});
parcelRegister("9BgQe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6fd4a219fc6e23ca$var$_react = $6fd4a219fc6e23ca$var$_interopRequireDefault((parcelRequire("91i6m")));

var $6fd4a219fc6e23ca$var$_baseNew = $6fd4a219fc6e23ca$var$_interopRequireDefault((parcelRequire("l88m1")));
function $6fd4a219fc6e23ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6fd4a219fc6e23ca$var$CrossIcon = (props)=>/*#__PURE__*/ $6fd4a219fc6e23ca$var$_react.default.createElement($6fd4a219fc6e23ca$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$6fd4a219fc6e23ca$var$CrossIcon.displayName = 'CrossIcon';
var $6fd4a219fc6e23ca$var$_default = module.exports.default = $6fd4a219fc6e23ca$var$CrossIcon;

});
parcelRegister("l88m1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("lCUju")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("lCUju")).Icon; });

var $lCUju = parcelRequire("lCUju");

});
parcelRegister("lCUju", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $fbe8d43e2d8c261a$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $fbe8d43e2d8c261a$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $f1k1y = parcelRequire("f1k1y");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $fbe8d43e2d8c261a$var$svgStyles = null;
var $fbe8d43e2d8c261a$var$iconStyles = null;
var $fbe8d43e2d8c261a$var$utilityIconStyles = null;
var $fbe8d43e2d8c261a$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $fbe8d43e2d8c261a$var$baseHcmStyles = null;
var $fbe8d43e2d8c261a$var$scaleSize = null;
var $fbe8d43e2d8c261a$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $fbe8d43e2d8c261a$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $fbe8d43e2d8c261a$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $fbe8d43e2d8c261a$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $fbe8d43e2d8c261a$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $fbe8d43e2d8c261a$export$f04a61298a47a40f = /*#__PURE__*/ (0, $91i6m.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $f1k1y.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $91i6m.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = $fbe8d43e2d8c261a$var$baseSizeMap[type];
    var viewBoxPadding = $fbe8d43e2d8c261a$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $91i6m.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $9gzWK.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $91i6m.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $9gzWK.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $fbe8d43e2d8c261a$var$utilSizes[spacing] : size === 'small' ? $fbe8d43e2d8c261a$var$coreSizeSmall[spacing] : $fbe8d43e2d8c261a$var$coreSizeMedium[spacing]
        ])
    }));
});
var $fbe8d43e2d8c261a$export$2e2bcd8739ae039 = $fbe8d43e2d8c261a$export$f04a61298a47a40f;

});



parcelRegister("8BQof", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $644a6b05d66df4ec$var$_react = $644a6b05d66df4ec$var$_interopRequireDefault((parcelRequire("91i6m")));

var $7NPFp = parcelRequire("7NPFp");
function $644a6b05d66df4ec$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $644a6b05d66df4ec$var$CrossIcon = (props)=>/*#__PURE__*/ $644a6b05d66df4ec$var$_react.default.createElement($7NPFp.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props));
$644a6b05d66df4ec$var$CrossIcon.displayName = 'CrossIcon';
var $644a6b05d66df4ec$var$_default = module.exports.default = $644a6b05d66df4ec$var$CrossIcon;

});
parcelRegister("7NPFp", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $5ae52ffe880a1805$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");
function $5ae52ffe880a1805$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5ae52ffe880a1805$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5ae52ffe880a1805$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5ae52ffe880a1805$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $5ae52ffe880a1805$var$iconStyles = null;
var $5ae52ffe880a1805$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $5ae52ffe880a1805$var$baseHcmStyles = null;
var $5ae52ffe880a1805$var$primaryEqualsSecondaryHcmStyles = null;
var $5ae52ffe880a1805$var$secondaryTransparentHcmStyles = null;
var $5ae52ffe880a1805$export$f04a61298a47a40f = /*#__PURE__*/ (0, $91i6m.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $91i6m.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $91i6m.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $5ae52ffe880a1805$var$_objectSpread($5ae52ffe880a1805$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $9gzWK.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $5ae52ffe880a1805$var$sizeStyles[size]
        ])
    }));
});
var $5ae52ffe880a1805$export$2e2bcd8739ae039 = $5ae52ffe880a1805$export$f04a61298a47a40f;

});



parcelRegister("1fll9", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", function () { return $0e87bee448892c08$export$e9b82d2e21ac0c1f; });

var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $1ccHl = parcelRequire("1ccHl");

var $dcWVv = parcelRequire("dcWVv");

var $dFmiz = parcelRequire("dFmiz");

var $aYBAn = parcelRequire("aYBAn");

var $lncp3 = parcelRequire("lncp3");

var $2yXtE = parcelRequire("2yXtE");

var $f1k1y = parcelRequire("f1k1y");

var $gE12B = parcelRequire("gE12B");
function $0e87bee448892c08$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0e87bee448892c08$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0e87bee448892c08$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0e87bee448892c08$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0e87bee448892c08$var$appearanceIconSchema = {
    information: {
        backgroundColor: "var(--ds-background-information, ".concat((0, $gE12B.B50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($aYBAn))),
        primaryIconColor: "var(--ds-icon-information, ".concat((0, $gE12B.B500), ")")
    },
    warning: {
        backgroundColor: "var(--ds-background-warning, ".concat((0, $gE12B.Y50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($2yXtE))),
        primaryIconColor: "var(--ds-icon-warning, ".concat((0, $gE12B.Y500), ")")
    },
    error: {
        backgroundColor: "var(--ds-background-danger, ".concat((0, $gE12B.R50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dFmiz))),
        primaryIconColor: "var(--ds-icon-danger, ".concat((0, $gE12B.R500), ")")
    },
    success: {
        backgroundColor: "var(--ds-background-success, ".concat((0, $gE12B.G50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($lncp3))),
        primaryIconColor: "var(--ds-icon-success, ".concat((0, $gE12B.G500), ")")
    },
    discovery: {
        backgroundColor: "var(--ds-background-discovery, ".concat((0, $gE12B.P50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dcWVv))),
        primaryIconColor: "var(--ds-icon-discovery, ".concat((0, $gE12B.P500), ")")
    },
    discoveryUpdated: {
        backgroundColor: "var(--ds-background-discovery, ".concat((0, $gE12B.P50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1ccHl))),
        primaryIconColor: "var(--ds-icon-discovery, ".concat((0, $gE12B.P500), ")")
    }
};
function $0e87bee448892c08$export$e9b82d2e21ac0c1f(appearance, icon) {
    var appearanceIconStyles = $0e87bee448892c08$var$appearanceIconSchema[appearance === 'discovery' && (0, $f1k1y.fg)('platform_dst_section_message_discovery_icon') ? 'discoveryUpdated' : appearance] || $0e87bee448892c08$var$appearanceIconSchema.information;
    var AppearanceIcon = function AppearanceIcon(_ref) {
        var size = _ref.size, primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(appearanceIconStyles.Icon, {
            LEGACY_size: size,
            color: primaryColor,
            spacing: "spacious",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor,
            label: appearance
        });
    };
    var Icon = icon || AppearanceIcon;
    return $0e87bee448892c08$var$_objectSpread($0e87bee448892c08$var$_objectSpread({}, appearanceIconStyles), {}, {
        Icon: Icon
    });
}

});
parcelRegister("1ccHl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5501f2ec2c7fc2907a8ddc6771935d76>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0df0c2fdcfc96958$var$_react = $0df0c2fdcfc96958$var$_interopRequireDefault((parcelRequire("91i6m")));

var $0df0c2fdcfc96958$var$_discovery = $0df0c2fdcfc96958$var$_interopRequireDefault((parcelRequire("fx19O")));

var $0df0c2fdcfc96958$var$_note = $0df0c2fdcfc96958$var$_interopRequireDefault((parcelRequire("3ztcg")));
function $0df0c2fdcfc96958$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DiscoveryIcon.
 * This component is DiscoveryIcon, with `UNSAFE_fallbackIcon` set to "EditorNoteIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0df0c2fdcfc96958$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $0df0c2fdcfc96958$var$_react.default.createElement($0df0c2fdcfc96958$var$_discovery.default, Object.assign({
        name: "DiscoveryIcon",
        LEGACY_fallbackIcon: $0df0c2fdcfc96958$var$_note.default
    }, props));
$0df0c2fdcfc96958$var$DiscoveryIcon.displayName = 'DiscoveryIconMigration';
var $0df0c2fdcfc96958$var$_default = module.exports.default = $0df0c2fdcfc96958$var$DiscoveryIcon;

});
parcelRegister("fx19O", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84ac540d37aa7b8e7ab349dbbb474c30>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4ead5dfd70e48c9$var$_react = $b4ead5dfd70e48c9$var$_interopRequireDefault((parcelRequire("91i6m")));

var $b4ead5dfd70e48c9$var$_baseNew = $b4ead5dfd70e48c9$var$_interopRequireDefault((parcelRequire("l88m1")));
function $b4ead5dfd70e48c9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Discovery".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b4ead5dfd70e48c9$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $b4ead5dfd70e48c9$var$_react.default.createElement($b4ead5dfd70e48c9$var$_baseNew.default, Object.assign({
        name: "DiscoveryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h6v-4.75C9 9.56 9.56 9 10.25 9H15V3a2 2 0 0 0-2-2M4 5.5h7V4H4zM4 9h3V7.5H4z" clip-rule="evenodd"/><path fill="currentcolor" d="M11.25 10.5a.75.75 0 0 0-.75.75v3.81l4.56-4.56z"/>`
    }, props));
$b4ead5dfd70e48c9$var$DiscoveryIcon.displayName = 'DiscoveryIcon';
var $b4ead5dfd70e48c9$var$_default = module.exports.default = $b4ead5dfd70e48c9$var$DiscoveryIcon;

});

parcelRegister("3ztcg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $299b49d7e030bec8$var$_react = $299b49d7e030bec8$var$_interopRequireDefault((parcelRequire("91i6m")));

var $7NPFp = parcelRequire("7NPFp");
function $299b49d7e030bec8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $299b49d7e030bec8$var$EditorNoteIcon = (props)=>/*#__PURE__*/ $299b49d7e030bec8$var$_react.default.createElement($7NPFp.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 4h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m1.5 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm0 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props));
$299b49d7e030bec8$var$EditorNoteIcon.displayName = 'EditorNoteIcon';
var $299b49d7e030bec8$var$_default = module.exports.default = $299b49d7e030bec8$var$EditorNoteIcon;

});


parcelRegister("dcWVv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::62c47233d9edbba3b204e8a396289dde>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $99da1ae9dc521ef4$var$_react = $99da1ae9dc521ef4$var$_interopRequireDefault((parcelRequire("91i6m")));

var $99da1ae9dc521ef4$var$_questionCircle = $99da1ae9dc521ef4$var$_interopRequireDefault((parcelRequire("45Z1R")));

var $99da1ae9dc521ef4$var$_questionCircle2 = $99da1ae9dc521ef4$var$_interopRequireDefault((parcelRequire("gvwoZ")));
function $99da1ae9dc521ef4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for QuestionCircleIcon.
 * This component is QuestionCircleIcon, with `UNSAFE_fallbackIcon` set to "QuestionCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $99da1ae9dc521ef4$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $99da1ae9dc521ef4$var$_react.default.createElement($99da1ae9dc521ef4$var$_questionCircle.default, Object.assign({
        name: "QuestionCircleIcon",
        LEGACY_fallbackIcon: $99da1ae9dc521ef4$var$_questionCircle2.default
    }, props));
$99da1ae9dc521ef4$var$QuestionCircleIcon.displayName = 'QuestionCircleIconMigration';
var $99da1ae9dc521ef4$var$_default = module.exports.default = $99da1ae9dc521ef4$var$QuestionCircleIcon;

});
parcelRegister("45Z1R", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8bb31d7b8eb39bae440b5a0002b7aa63>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2fb6f81fbfb51192$var$_react = $2fb6f81fbfb51192$var$_interopRequireDefault((parcelRequire("91i6m")));

var $2fb6f81fbfb51192$var$_baseNew = $2fb6f81fbfb51192$var$_interopRequireDefault((parcelRequire("l88m1")));
function $2fb6f81fbfb51192$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2fb6f81fbfb51192$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $2fb6f81fbfb51192$var$_react.default.createElement($2fb6f81fbfb51192$var$_baseNew.default, Object.assign({
        name: "QuestionCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$2fb6f81fbfb51192$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $2fb6f81fbfb51192$var$_default = module.exports.default = $2fb6f81fbfb51192$var$QuestionCircleIcon;

});

parcelRegister("gvwoZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c048acfd9a225c06$var$_react = $c048acfd9a225c06$var$_interopRequireDefault((parcelRequire("91i6m")));

var $7NPFp = parcelRequire("7NPFp");
function $c048acfd9a225c06$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c048acfd9a225c06$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $c048acfd9a225c06$var$_react.default.createElement($7NPFp.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="18" r="1" fill="inherit"/><path fill="inherit" d="M15.89 9.05a3.98 3.98 0 0 0-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.99.99 0 0 0 .982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 0 1 4.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 0 0-1 .987v2.014a1.001 1.001 0 0 0 2.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0 0 15.89 9.05"/></g></svg>`
    }, props));
$c048acfd9a225c06$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $c048acfd9a225c06$var$_default = module.exports.default = $c048acfd9a225c06$var$QuestionCircleIcon;

});


parcelRegister("dFmiz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f636032ea4a949f6a3ed21b2a88730cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f3066b28c339d9e$var$_react = $9f3066b28c339d9e$var$_interopRequireDefault((parcelRequire("91i6m")));

var $9f3066b28c339d9e$var$_statusError = $9f3066b28c339d9e$var$_interopRequireDefault((parcelRequire("2PKP4")));

var $9f3066b28c339d9e$var$_error = $9f3066b28c339d9e$var$_interopRequireDefault((parcelRequire("5RRXr")));
function $9f3066b28c339d9e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusErrorIcon.
 * This component is StatusErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9f3066b28c339d9e$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $9f3066b28c339d9e$var$_react.default.createElement($9f3066b28c339d9e$var$_statusError.default, Object.assign({
        name: "StatusErrorIcon",
        LEGACY_fallbackIcon: $9f3066b28c339d9e$var$_error.default
    }, props));
$9f3066b28c339d9e$var$StatusErrorIcon.displayName = 'StatusErrorIconMigration';
var $9f3066b28c339d9e$var$_default = module.exports.default = $9f3066b28c339d9e$var$StatusErrorIcon;

});
parcelRegister("2PKP4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2104aa3aac89ca04$var$_react = $2104aa3aac89ca04$var$_interopRequireDefault((parcelRequire("91i6m")));

var $2104aa3aac89ca04$var$_baseNew = $2104aa3aac89ca04$var$_interopRequireDefault((parcelRequire("l88m1")));
function $2104aa3aac89ca04$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2104aa3aac89ca04$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $2104aa3aac89ca04$var$_react.default.createElement($2104aa3aac89ca04$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$2104aa3aac89ca04$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $2104aa3aac89ca04$var$_default = module.exports.default = $2104aa3aac89ca04$var$StatusErrorIcon;

});

parcelRegister("5RRXr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $445bc1e03bd60ed9$var$_react = $445bc1e03bd60ed9$var$_interopRequireDefault((parcelRequire("91i6m")));

var $7NPFp = parcelRequire("7NPFp");
function $445bc1e03bd60ed9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $445bc1e03bd60ed9$var$ErrorIcon = (props)=>/*#__PURE__*/ $445bc1e03bd60ed9$var$_react.default.createElement($7NPFp.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$445bc1e03bd60ed9$var$ErrorIcon.displayName = 'ErrorIcon';
var $445bc1e03bd60ed9$var$_default = module.exports.default = $445bc1e03bd60ed9$var$ErrorIcon;

});


parcelRegister("aYBAn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::750ecc162e36259ef90344888c589176>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7fdca9bae5a5c3db$var$_react = $7fdca9bae5a5c3db$var$_interopRequireDefault((parcelRequire("91i6m")));

var $7fdca9bae5a5c3db$var$_statusInformation = $7fdca9bae5a5c3db$var$_interopRequireDefault((parcelRequire("dccro")));

var $7fdca9bae5a5c3db$var$_info = $7fdca9bae5a5c3db$var$_interopRequireDefault((parcelRequire("3ok70")));
function $7fdca9bae5a5c3db$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusInformationIcon.
 * This component is StatusInformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7fdca9bae5a5c3db$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $7fdca9bae5a5c3db$var$_react.default.createElement($7fdca9bae5a5c3db$var$_statusInformation.default, Object.assign({
        name: "StatusInformationIcon",
        LEGACY_fallbackIcon: $7fdca9bae5a5c3db$var$_info.default
    }, props));
$7fdca9bae5a5c3db$var$StatusInformationIcon.displayName = 'StatusInformationIconMigration';
var $7fdca9bae5a5c3db$var$_default = module.exports.default = $7fdca9bae5a5c3db$var$StatusInformationIcon;

});
parcelRegister("dccro", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::456639fbdc991aefe1af05acf697365d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $99b60bdcb23bea70$var$_react = $99b60bdcb23bea70$var$_interopRequireDefault((parcelRequire("91i6m")));

var $99b60bdcb23bea70$var$_baseNew = $99b60bdcb23bea70$var$_interopRequireDefault((parcelRequire("l88m1")));
function $99b60bdcb23bea70$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $99b60bdcb23bea70$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $99b60bdcb23bea70$var$_react.default.createElement($99b60bdcb23bea70$var$_baseNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$99b60bdcb23bea70$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $99b60bdcb23bea70$var$_default = module.exports.default = $99b60bdcb23bea70$var$StatusInformationIcon;

});

parcelRegister("3ok70", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $278336d4ca5b2fe1$var$_react = $278336d4ca5b2fe1$var$_interopRequireDefault((parcelRequire("91i6m")));

var $7NPFp = parcelRequire("7NPFp");
function $278336d4ca5b2fe1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $278336d4ca5b2fe1$var$InfoIcon = (props)=>/*#__PURE__*/ $278336d4ca5b2fe1$var$_react.default.createElement($7NPFp.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props));
$278336d4ca5b2fe1$var$InfoIcon.displayName = 'InfoIcon';
var $278336d4ca5b2fe1$var$_default = module.exports.default = $278336d4ca5b2fe1$var$InfoIcon;

});


parcelRegister("lncp3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f966e8890debb57eaf4e6f167681f98b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f8f55df887ed9748$var$_react = $f8f55df887ed9748$var$_interopRequireDefault((parcelRequire("91i6m")));

var $f8f55df887ed9748$var$_statusSuccess = $f8f55df887ed9748$var$_interopRequireDefault((parcelRequire("5Hxq1")));

var $f8f55df887ed9748$var$_checkCircle = $f8f55df887ed9748$var$_interopRequireDefault((parcelRequire("9peCk")));
function $f8f55df887ed9748$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusSuccessIcon.
 * This component is StatusSuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f8f55df887ed9748$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $f8f55df887ed9748$var$_react.default.createElement($f8f55df887ed9748$var$_statusSuccess.default, Object.assign({
        name: "StatusSuccessIcon",
        LEGACY_fallbackIcon: $f8f55df887ed9748$var$_checkCircle.default
    }, props));
$f8f55df887ed9748$var$StatusSuccessIcon.displayName = 'StatusSuccessIconMigration';
var $f8f55df887ed9748$var$_default = module.exports.default = $f8f55df887ed9748$var$StatusSuccessIcon;

});
parcelRegister("5Hxq1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $426ae42851b03b30$var$_react = $426ae42851b03b30$var$_interopRequireDefault((parcelRequire("91i6m")));

var $426ae42851b03b30$var$_baseNew = $426ae42851b03b30$var$_interopRequireDefault((parcelRequire("l88m1")));
function $426ae42851b03b30$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $426ae42851b03b30$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $426ae42851b03b30$var$_react.default.createElement($426ae42851b03b30$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$426ae42851b03b30$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $426ae42851b03b30$var$_default = module.exports.default = $426ae42851b03b30$var$StatusSuccessIcon;

});

parcelRegister("9peCk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d91c98d8e9a7833$var$_react = $6d91c98d8e9a7833$var$_interopRequireDefault((parcelRequire("91i6m")));

var $7NPFp = parcelRequire("7NPFp");
function $6d91c98d8e9a7833$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6d91c98d8e9a7833$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $6d91c98d8e9a7833$var$_react.default.createElement($7NPFp.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props));
$6d91c98d8e9a7833$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $6d91c98d8e9a7833$var$_default = module.exports.default = $6d91c98d8e9a7833$var$CheckCircleIcon;

});


parcelRegister("2yXtE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::715767a087f47b16ede12b841c1dd7f2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1ddce4b2c41b107a$var$_react = $1ddce4b2c41b107a$var$_interopRequireDefault((parcelRequire("91i6m")));

var $1ddce4b2c41b107a$var$_statusWarning = $1ddce4b2c41b107a$var$_interopRequireDefault((parcelRequire("2YhIm")));

var $1ddce4b2c41b107a$var$_warning = $1ddce4b2c41b107a$var$_interopRequireDefault((parcelRequire("iOmjJ")));
function $1ddce4b2c41b107a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusWarningIcon.
 * This component is StatusWarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1ddce4b2c41b107a$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $1ddce4b2c41b107a$var$_react.default.createElement($1ddce4b2c41b107a$var$_statusWarning.default, Object.assign({
        name: "StatusWarningIcon",
        LEGACY_fallbackIcon: $1ddce4b2c41b107a$var$_warning.default
    }, props));
$1ddce4b2c41b107a$var$StatusWarningIcon.displayName = 'StatusWarningIconMigration';
var $1ddce4b2c41b107a$var$_default = module.exports.default = $1ddce4b2c41b107a$var$StatusWarningIcon;

});
parcelRegister("2YhIm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee7b3f114c675eea0f953c33a485bcf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $229eed14a7f340a8$var$_react = $229eed14a7f340a8$var$_interopRequireDefault((parcelRequire("91i6m")));

var $229eed14a7f340a8$var$_baseNew = $229eed14a7f340a8$var$_interopRequireDefault((parcelRequire("l88m1")));
function $229eed14a7f340a8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $229eed14a7f340a8$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $229eed14a7f340a8$var$_react.default.createElement($229eed14a7f340a8$var$_baseNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$229eed14a7f340a8$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $229eed14a7f340a8$var$_default = module.exports.default = $229eed14a7f340a8$var$StatusWarningIcon;

});

parcelRegister("iOmjJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db1e353cadfdd395$var$_react = $db1e353cadfdd395$var$_interopRequireDefault((parcelRequire("91i6m")));

var $7NPFp = parcelRequire("7NPFp");
function $db1e353cadfdd395$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $db1e353cadfdd395$var$WarningIcon = (props)=>/*#__PURE__*/ $db1e353cadfdd395$var$_react.default.createElement($7NPFp.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$db1e353cadfdd395$var$WarningIcon.displayName = 'WarningIcon';
var $db1e353cadfdd395$var$_default = module.exports.default = $db1e353cadfdd395$var$WarningIcon;

});


parcelRegister("gE12B", function(module, exports) {

$parcel$export(module.exports, "R50", function () { return $0320890a3ceca095$export$4b84fd0e2c617bd; });
$parcel$export(module.exports, "R500", function () { return $0320890a3ceca095$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y50", function () { return $0320890a3ceca095$export$8d9596b529bbb9cf; });
$parcel$export(module.exports, "Y500", function () { return $0320890a3ceca095$export$874739ea9e379ab6; });
$parcel$export(module.exports, "G50", function () { return $0320890a3ceca095$export$8a6341c32b6a3ee6; });
$parcel$export(module.exports, "G500", function () { return $0320890a3ceca095$export$6fa04827ac68a4fb; });
$parcel$export(module.exports, "B50", function () { return $0320890a3ceca095$export$226de0355ed012f8; });
$parcel$export(module.exports, "B500", function () { return $0320890a3ceca095$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "P50", function () { return $0320890a3ceca095$export$363e4475840015bb; });
$parcel$export(module.exports, "P500", function () { return $0320890a3ceca095$export$147899de772240ec; });
// Reds
var $0320890a3ceca095$export$4b84fd0e2c617bd = '#FFEBE6';
var $0320890a3ceca095$export$b34b069eff244586 = '#FFBDAD';
var $0320890a3ceca095$export$be802dd0d8b57f35 = '#FF8F73';
var $0320890a3ceca095$export$60847d42f9da92a6 = '#FF7452';
var $0320890a3ceca095$export$4a7404f376229999 = '#FF5630';
var $0320890a3ceca095$export$2010d0fb4295b346 = '#DE350B';
var $0320890a3ceca095$export$2837b5a1a71d5c02 = '#BF2600';
var $0320890a3ceca095$export$8d9596b529bbb9cf = '#FFFAE6';
var $0320890a3ceca095$export$41060a744ab0b7ae = '#FFF0B3';
var $0320890a3ceca095$export$1cc05bbbf340e559 = '#FFE380';
var $0320890a3ceca095$export$5aae31392d72caaa = '#FFC400';
var $0320890a3ceca095$export$c6930421db9fa514 = '#FFAB00';
var $0320890a3ceca095$export$59619663aa6500fb = '#FF991F';
var $0320890a3ceca095$export$874739ea9e379ab6 = '#FF8B00';
var $0320890a3ceca095$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $0320890a3ceca095$export$69a3bf21b9686c2b = '#ABF5D1';
var $0320890a3ceca095$export$afbce1382ec95f73 = '#79F2C0';
var $0320890a3ceca095$export$747d86715d4175de = '#57D9A3';
var $0320890a3ceca095$export$940e1f69e873f202 = '#36B37E';
var $0320890a3ceca095$export$a49394138f7b8e85 = '#00875A';
var $0320890a3ceca095$export$6fa04827ac68a4fb = '#006644';
var $0320890a3ceca095$export$226de0355ed012f8 = '#DEEBFF';
var $0320890a3ceca095$export$8c13c2ee36917869 = '#B3D4FF';
var $0320890a3ceca095$export$ecfc1dff386a3e7a = '#4C9AFF';
var $0320890a3ceca095$export$215b7063051591f1 = '#2684FF';
var $0320890a3ceca095$export$e62e8919cca44969 = '#0065FF';
var $0320890a3ceca095$export$b3de0ae08da2ce64 = '#0052CC';
var $0320890a3ceca095$export$a6ee3d71bc067634 = '#0747A6';
var $0320890a3ceca095$export$67f15409e87642a1 = '#669DF1';
var $0320890a3ceca095$export$f0539dbc42dbb067 = '#8FB8F6';
var $0320890a3ceca095$export$363e4475840015bb = '#EAE6FF';
var $0320890a3ceca095$export$4b0a4417ed59760f = '#C0B6F2';
var $0320890a3ceca095$export$6011520a64d9a187 = '#998DD9';
var $0320890a3ceca095$export$a7175d4e9206bc80 = '#8777D9';
var $0320890a3ceca095$export$b48405b95304b5a1 = '#6554C0';
var $0320890a3ceca095$export$c71e4279dd54a18d = '#5243AA';
var $0320890a3ceca095$export$147899de772240ec = '#403294';
var $0320890a3ceca095$export$2cf711fe14c66f06 = '#E6FCFF';
var $0320890a3ceca095$export$7a8f4d33f6f9772c = '#B3F5FF';
var $0320890a3ceca095$export$776c9c497ef08533 = '#79E2F2';
var $0320890a3ceca095$export$69cb3ca10c1e330e = '#00C7E6';
var $0320890a3ceca095$export$9dc1ef0f3f48059b = '#00B8D9';
var $0320890a3ceca095$export$7c835c78b6fcdef8 = '#00A3BF';
var $0320890a3ceca095$export$6036577f95c3877e = '#008DA6';
var $0320890a3ceca095$export$29a4f05edc054374 = '#FFFFFF';
var $0320890a3ceca095$export$e655ef011c4aa1a2 = '#FAFBFC';
var $0320890a3ceca095$export$9fdfb749e33cdf97 = '#F4F5F7';
var $0320890a3ceca095$export$3e51e8f1440314ba = '#EBECF0';
var $0320890a3ceca095$export$1ce2d1575d444ceb = '#DFE1E6';
var $0320890a3ceca095$export$8754fc7e6d8b3000 = '#C1C7D0';
var $0320890a3ceca095$export$c2e91cbeada39b8b = '#B3BAC5';
var $0320890a3ceca095$export$5f71e19f3a7ad9de = '#A5ADBA';
var $0320890a3ceca095$export$eaa8c8a70ac22806 = '#97A0AF';
var $0320890a3ceca095$export$7c87d337fb91a97d = '#8993A4';
var $0320890a3ceca095$export$d6447c357493214f = '#7A869A';
var $0320890a3ceca095$export$f563ee71e9ee74cd = '#6B778C';
var $0320890a3ceca095$export$e2ef2124cf4024b1 = '#5E6C84';
var $0320890a3ceca095$export$eece5f492e429f08 = '#505F79';
var $0320890a3ceca095$export$c39c0fe0f26207ae = '#42526E';
var $0320890a3ceca095$export$7090862dc3038a9f = '#344563';
var $0320890a3ceca095$export$ad0bacf983b7ddaa = '#253858';
var $0320890a3ceca095$export$7d61b15e0da132af = '#172B4D';
var $0320890a3ceca095$export$fbda843f0a27fe96 = '#091E42';
var $0320890a3ceca095$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $0320890a3ceca095$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $0320890a3ceca095$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $0320890a3ceca095$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $0320890a3ceca095$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $0320890a3ceca095$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $0320890a3ceca095$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $0320890a3ceca095$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $0320890a3ceca095$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $0320890a3ceca095$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $0320890a3ceca095$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $0320890a3ceca095$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $0320890a3ceca095$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $0320890a3ceca095$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $0320890a3ceca095$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $0320890a3ceca095$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $0320890a3ceca095$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $0320890a3ceca095$export$2f6319cf7d736c2a = '#E6EDFA';
var $0320890a3ceca095$export$95126bc8884d6634 = '#DCE5F5';
var $0320890a3ceca095$export$8338d8c35d44ff1 = '#CED9EB';
var $0320890a3ceca095$export$5368d76ae4fbbda7 = '#B8C7E0';
var $0320890a3ceca095$export$9f0a771d16ec8d36 = '#ABBBD6';
var $0320890a3ceca095$export$abcf8c38338b4aa5 = '#9FB0CC';
var $0320890a3ceca095$export$97e81faa16a182c7 = '#8C9CB8';
var $0320890a3ceca095$export$bfe21c59123ecf33 = '#7988A3';
var $0320890a3ceca095$export$ee82aa2ea6a1558 = '#67758F';
var $0320890a3ceca095$export$682927c6ed76be02 = '#56637A';
var $0320890a3ceca095$export$91fd9994c5be9757 = '#455166';
var $0320890a3ceca095$export$d281fbfe3cff2df6 = '#3B475C';
var $0320890a3ceca095$export$3902c91d8b98a753 = '#313D52';
var $0320890a3ceca095$export$8e8133c1ba5845b5 = '#283447';
var $0320890a3ceca095$export$33ff357f6620b39 = '#202B3D';
var $0320890a3ceca095$export$633847cf062b69e0 = '#1B2638';
var $0320890a3ceca095$export$9776a6e503bdbf76 = '#121A29';
var $0320890a3ceca095$export$6c813d5160dff5db = '#0E1624';
var $0320890a3ceca095$export$3d4f271a500072a = '#0D1424';
var $0320890a3ceca095$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $0320890a3ceca095$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $0320890a3ceca095$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $0320890a3ceca095$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $0320890a3ceca095$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $0320890a3ceca095$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $0320890a3ceca095$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $0320890a3ceca095$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $0320890a3ceca095$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $0320890a3ceca095$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $0320890a3ceca095$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $0320890a3ceca095$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $0320890a3ceca095$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $0320890a3ceca095$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $0320890a3ceca095$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $0320890a3ceca095$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $0320890a3ceca095$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $0320890a3ceca095$export$d2adc5dedf09fced = '#292A2E';
var $0320890a3ceca095$export$f51762073d2bb381 = '#94C748';
var $0320890a3ceca095$export$95e26d54def96891 = '#B3DF72';

});



parcelRegister("64QTD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $095f6393660a14c2$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $6NU0v = parcelRequire("6NU0v");

var $4ZSso = parcelRequire("4ZSso");

var $jtgLn = parcelRequire("jtgLn");

var $9jjaN = parcelRequire("9jjaN");
parcelRequire("91i6m");
let $095f6393660a14c2$var$_ = (t)=>t, $095f6393660a14c2$var$t;
const $095f6393660a14c2$var$StyledButton = (0, $9jjaN.default)((0, $jtgLn.default))($095f6393660a14c2$var$t || ($095f6393660a14c2$var$t = $095f6393660a14c2$var$_`
  span {
    font-weight: 400;
  }
`));
const $095f6393660a14c2$var$ButtonLink = (props)=>{
    const { appearance: appearance } = props, rest = (0, $6NU0v._)(props, [
        "appearance"
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)($095f6393660a14c2$var$StyledButton, (0, $1Fos3._)({
        appearance: appearance || 'link'
    }, rest));
};
var $095f6393660a14c2$export$2e2bcd8739ae039 = $095f6393660a14c2$var$ButtonLink;

});
parcelRegister("jtgLn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2cdba9073f203e4$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $5YM7L = parcelRequire("5YM7L");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $6A0cm = parcelRequire("6A0cm");

var $az3td = parcelRequire("az3td");

var $5Xuee = parcelRequire("5Xuee");

var $dNg3u = parcelRequire("dNg3u");

var $7hyOW = parcelRequire("7hyOW");
var $e2cdba9073f203e4$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $e2cdba9073f203e4$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ var $e2cdba9073f203e4$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $6A0cm.default) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $6A0cm.default) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $e2cdba9073f203e4$var$_excluded);
    var _useGlobalTheme = (0, $az3td.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var isOnlySingleIcon = (0, $7hyOW.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $91i6m.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    var onMouseDown = (0, $91i6m.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($e2cdba9073f203e4$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $91i6m.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($e2cdba9073f203e4$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $91i6m.useMemo)(function() {
        return (0, $dNg3u.getCss)({
            appearance: appearance,
            spacing: spacing,
            mode: mode,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        mode,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $5Xuee.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$e2cdba9073f203e4$var$Button.displayName = 'Button';
var $e2cdba9073f203e4$export$2e2bcd8739ae039 = $e2cdba9073f203e4$var$Button;

});


parcelRegister("damsD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8fbaebb312c23f8$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $9jjaN = parcelRequire("9jjaN");

var $4Msy1 = parcelRequire("4Msy1");

var $6e88g = parcelRequire("6e88g");

var $k8ZoM = parcelRequire("k8ZoM");
let $b8fbaebb312c23f8$var$_ = (t)=>t, $b8fbaebb312c23f8$var$t, $b8fbaebb312c23f8$var$t1, $b8fbaebb312c23f8$var$t2, $b8fbaebb312c23f8$var$t3;
const $b8fbaebb312c23f8$var$imgHeight = 88;
const $b8fbaebb312c23f8$var$EmailSentImageContainer = (0, $9jjaN.default).div($b8fbaebb312c23f8$var$t || ($b8fbaebb312c23f8$var$t = $b8fbaebb312c23f8$var$_`
  background: url(${0}) no-repeat center bottom;
  height: ${0}px;
  margin: ${0}px 0 ${0}px;
`), (0, (/*@__PURE__*/$parcel$interopDefault($4Msy1))), $b8fbaebb312c23f8$var$imgHeight, (0, $6e88g.gridSize)(), (0, $6e88g.gridSize)() * 2);
const $b8fbaebb312c23f8$var$EmailSentDescriptionContainer = (0, $9jjaN.default).div($b8fbaebb312c23f8$var$t1 || ($b8fbaebb312c23f8$var$t1 = $b8fbaebb312c23f8$var$_`
  text-align: left;
`));
const $b8fbaebb312c23f8$var$EmailWarningContainer = (0, $9jjaN.default).div($b8fbaebb312c23f8$var$t2 || ($b8fbaebb312c23f8$var$t2 = $b8fbaebb312c23f8$var$_`
  text-align: left;
  margin-top: ${0}px;
`), (0, $6e88g.gridSize)() * 2);
const $b8fbaebb312c23f8$var$Email = (0, $9jjaN.default).p($b8fbaebb312c23f8$var$t3 || ($b8fbaebb312c23f8$var$t3 = $b8fbaebb312c23f8$var$_`
  font: ${0};
  text-align: left;
  overflow-wrap: break-word;
  & {
    margin-top: ${0}px;
  }
`), (0, $k8ZoM.default)('font.heading.small'), (0, $6e88g.gridSize)());
function $b8fbaebb312c23f8$export$2e2bcd8739ae039(props) {
    const { children: children, email: email, message: message, warningMessage: warningMessage, onRender: onRender, withEmailSentImage: withEmailSentImage = true } = props;
    (0, $91i6m.useEffect)(()=>{
        if (onRender) onRender();
    }, [
        onRender
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsxs)("div", {
        id: "email-sent-page",
        children: [
            withEmailSentImage && /*#__PURE__*/ (0, $4ZSso.jsx)($b8fbaebb312c23f8$var$EmailSentImageContainer, {}),
            /*#__PURE__*/ (0, $4ZSso.jsx)($b8fbaebb312c23f8$var$EmailSentDescriptionContainer, {
                children: message
            }),
            email && /*#__PURE__*/ (0, $4ZSso.jsx)($b8fbaebb312c23f8$var$Email, {
                children: email
            }),
            warningMessage && /*#__PURE__*/ (0, $4ZSso.jsx)($b8fbaebb312c23f8$var$EmailWarningContainer, {
                children: warningMessage
            }),
            children
        ]
    });
}

});
parcelRegister("4Msy1", function(module, exports) {

module.exports = (parcelRequire("cgi2g")).getBundleURL('9rAa3') + "check-your-email-open-letter.58fc87ea.svg";

});

parcelRegister("k8ZoM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eaa42e806e78d143$export$2e2bcd8739ae039; });



var $fDFhk = parcelRequire("fDFhk");

var $2S8bR = parcelRequire("2S8bR");

var $e08gr = parcelRequire("e08gr");
/**
 * Takes a dot-separated token name and an optional fallback, and returns the CSS custom property for the corresponding token.
 * This should be used to implement design decisions throughout your application.
 *
 * Note: With `@atlaskit/babel-plugin-tokens`, this function can be pre-compiled and a fallback value automatically inserted.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * <div
 *   css={{
 *     backgroundColor: token('elevation.surface.raised', N0),
 *     boxShadow: token('elevation.shadow.raised', `0 20px 32px -8px ${N50A}, 0 0 1px ${N60A}`),
 *     padding: token('spacing.scale.100', '8px'),
 *     fontWeight: token('font.weight.regular', '400'),
 *   }}
 * />
 * ```
 *
 */ function $eaa42e806e78d143$var$token(path, fallback) {
    var token = (0, $fDFhk.default)[path];
    typeof $e08gr;
    // if the token is not found - replacing it with variable name without any value, to avoid it being undefined which would result in invalid css
    if (!token) token = (0, $2S8bR.TOKEN_NOT_FOUND_CSS_VAR);
    var tokenCall = fallback ? "var(".concat(token, ", ").concat(fallback, ")") : "var(".concat(token, ")");
    return tokenCall;
}
var $eaa42e806e78d143$export$2e2bcd8739ae039 = $eaa42e806e78d143$var$token;

});


parcelRegister("balRf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aefe8c3a0e1223ce$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $aefe8c3a0e1223ce$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    // Flags
    verifyEmailFlagSuccessTitle: {
        id: 'verify.email.sent.flag.success.title',
        defaultMessage: "We've sent you an email!",
        description: ''
    },
    verifyEmailFlagSuccessDesc: {
        id: 'verify.email.sent.flag.success.description',
        defaultMessage: 'The verification email is on its way!',
        description: ''
    },
    verifyEmailFlagErrorTitle: {
        id: 'verify.email.sent.flag.error.title',
        defaultMessage: 'Something went wrong.',
        description: ''
    },
    verifyEmailFlagErrorDesc: {
        id: 'verify.email.sent.flag.error.description',
        defaultMessage: 'Please try again later.',
        description: ''
    },
    headTitle: {
        id: 'verify.email.sent.head.title',
        defaultMessage: 'Verify your email'
    },
    migrationVerifyHeader: {
        id: 'migration.welcome.sent.title',
        defaultMessage: 'Check your inbox to log in',
        description: 'Informing the user to check their inbox to login.'
    },
    migrationVerifyMessage: {
        id: 'migration.welcome.sent.signup.link',
        defaultMessage: "To complete setup and log in, click the verification link in the email we\u2019ve sent to",
        description: 'Informing user that another welcome email has been sent for migration.'
    },
    resumeMigrationVerifyMessage: {
        id: 'resume.migration.welcome.sent.signup.link',
        defaultMessage: 'Your {product} account now requires you to log in with your new Atlassian account.',
        description: 'Informing migrating user that they need to log in with their Atlassian account'
    },
    button: {
        id: 'welcome.sent.resend.signup.link',
        defaultMessage: 'Resend verification email',
        description: 'Text telling the user that they can resend the welcome email again for migration.'
    },
    browserWarning: {
        id: 'welcome.email.sent.browser.warning',
        defaultMessage: 'Make sure to verify your email on this device and browser.',
        description: 'Telling the user to open the verification email sent by this page on the same device and browser'
    }
});

});

parcelRegister("gs2u7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3004c2b043bc6b47$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $9jjaN = parcelRequire("9jjaN");

var $fo5uj = parcelRequire("fo5uj");

var $6e88g = parcelRequire("6e88g");

var $k8ZoM = parcelRequire("k8ZoM");

var $9wl70 = parcelRequire("9wl70");

var $8NcDB = parcelRequire("8NcDB");

var $6IwzG = parcelRequire("6IwzG");

var $2DHGn = parcelRequire("2DHGn");

var $2Isaq = parcelRequire("2Isaq");

var $4ksd4 = parcelRequire("4ksd4");

var $1vhID = parcelRequire("1vhID");

var $b9U6C = parcelRequire("b9U6C");
let $3004c2b043bc6b47$var$_ = (t)=>t, $3004c2b043bc6b47$var$t, $3004c2b043bc6b47$var$t1, $3004c2b043bc6b47$var$t2, $3004c2b043bc6b47$var$t3, $3004c2b043bc6b47$var$t4;
const $3004c2b043bc6b47$export$bad5896fb5d45c0b = (0, $9jjaN.default).div($3004c2b043bc6b47$var$t || ($3004c2b043bc6b47$var$t = $3004c2b043bc6b47$var$_`
  color: ${0};
  margin-top: ${0}px;
  font-size: 14px;
  text-align: center;
  line-height: 20px;

  ${0}
`), (0, $k8ZoM.default)('color.text.subtle'), (0, $6e88g.gridSize)() * 3, (0, $4ksd4.listStyles));
const $3004c2b043bc6b47$export$ba9d4abe45514a38 = (0, $9jjaN.default).footer($3004c2b043bc6b47$var$t1 || ($3004c2b043bc6b47$var$t1 = $3004c2b043bc6b47$var$_`
  color: ${0};
  padding-top: ${0}px;
  font-size: 11px;
  text-align: center;
  line-height: 14px;

  ${0}
`), (0, $k8ZoM.default)('color.text.subtle'), (0, $6e88g.gridSize)() * 2, (0, $4ksd4.listStyles));
const $3004c2b043bc6b47$var$Whitebox = (0, $9jjaN.default).div($3004c2b043bc6b47$var$t2 || ($3004c2b043bc6b47$var$t2 = $3004c2b043bc6b47$var$_`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: ${0};
  padding: ${0}px ${0}px;

  background: ${0};
  border-radius: ${0}px;
  box-shadow: ${0};
  box-sizing: border-box;
  color: ${0};

  ${0} {
    padding: ${0}px ${0}px;
    background: transparent;
    box-shadow: none;
    min-height: 100%;
    width: ${0};
  }

  ${0} {
    padding: ${0}px ${0}px;
  }
`), ({ width: width })=>width || (0, $4ksd4.whiteboxWidthDesktop), (0, $6e88g.gridSize)() * 4, (0, $6e88g.gridSize)() * 5, (0, $8NcDB.colorPalette).primaryWhite, (0, $6e88g.borderRadius)(), ({ noBorder: noBorder })=>noBorder ? 'none' : '0 0 10px rgba(0, 0, 0, 0.1)', (0, $k8ZoM.default)('color.text.subtle'), (0, $9wl70.media).below.sm, (0, $6e88g.gridSize)() * 4, (0, $6e88g.gridSize)() * 2, (0, $4ksd4.whiteboxWidthHandheld), (0, $9wl70.media).below.xs, (0, $6e88g.gridSize)() * 2, (0, $6e88g.gridSize)() * 2);
const $3004c2b043bc6b47$var$Container = (0, $9jjaN.default).div($3004c2b043bc6b47$var$t3 || ($3004c2b043bc6b47$var$t3 = $3004c2b043bc6b47$var$_`
  min-height: calc(100% - 100px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 50px 0;

  ${0} {
    height: 100%;
    margin: 0;
    justify-content: flex-start;
  }
`), (0, $9wl70.media).below.sm);
const $3004c2b043bc6b47$var$FooterSpacer = (0, $9jjaN.default).div($3004c2b043bc6b47$var$t4 || ($3004c2b043bc6b47$var$t4 = $3004c2b043bc6b47$var$_`
  ${0} {
    margin: auto;
  }
`), (0, $9wl70.media).below.sm);
const $3004c2b043bc6b47$export$c0881a38d60c6658 = ({ header: header, children: children, footer: footer, whiteboxFooter: whiteboxFooter, isLoading: isLoading, pageId: pageId, noCobranding: noCobranding })=>{
    const { cobranding: cobranding, isMobileApp: isMobileApp } = (0, $6IwzG.useCobranding)();
    const resolvedCobranding = noCobranding ? (0, $6IwzG.SimpleCobranding).NO_COBRANDING : cobranding;
    const { background: Background, logo: logo, footerProducts: footerProducts, whiteboxWidth: whiteboxWidth, hideWhiteboxBorder: hideWhiteboxBorder } = (0, $2DHGn.getCobrandedComponents)(resolvedCobranding);
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $fo5uj.default), {
        children: /*#__PURE__*/ (0, $4ZSso.jsx)(Background, {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)($3004c2b043bc6b47$var$Container, {
                id: "WhiteboxContainer",
                children: /*#__PURE__*/ (0, $4ZSso.jsxs)($3004c2b043bc6b47$var$Whitebox, {
                    width: whiteboxWidth,
                    noBorder: hideWhiteboxBorder,
                    children: [
                        /*#__PURE__*/ (0, $4ZSso.jsx)("section", {
                            role: "main",
                            children: isLoading ? /*#__PURE__*/ (0, $4ZSso.jsx)((0, $b9U6C.LoadingSpinner), {
                                testId: "whitebox-loading-spinner"
                            }) : /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $2Isaq.ProductHeading), {
                                        suffix: header,
                                        children: logo && (0, $4ksd4.renderProductLogo)(logo)
                                    }),
                                    children,
                                    whiteboxFooter && /*#__PURE__*/ (0, $4ZSso.jsx)($3004c2b043bc6b47$export$bad5896fb5d45c0b, {
                                        children: whiteboxFooter
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $4ZSso.jsx)($3004c2b043bc6b47$var$FooterSpacer, {}),
                        /*#__PURE__*/ (0, $4ZSso.jsxs)($3004c2b043bc6b47$export$ba9d4abe45514a38, {
                            children: [
                                footerProducts && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $1vhID.default), {
                                    renderText: !isMobileApp,
                                    pageId: pageId,
                                    footerProducts: footerProducts
                                }),
                                footer
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var $3004c2b043bc6b47$export$2e2bcd8739ae039 = $3004c2b043bc6b47$export$c0881a38d60c6658;

});
parcelRegister("fo5uj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b33d5ab54ff98b64$export$2e2bcd8739ae039; });

var $3MqnH = parcelRequire("3MqnH");

var $gKcIt = parcelRequire("gKcIt");

var $1MAbu = parcelRequire("1MAbu");
var // Page already has a jsdoc where it is defined
// eslint-disable-next-line @repo/internal/react/require-jsdoc
$b33d5ab54ff98b64$export$2e2bcd8739ae039 = (0, $3MqnH.default);

});
parcelRegister("3MqnH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c0a519076979439$export$2e2bcd8739ae039; });
/* page.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $kxElr = parcelRequire("kxElr");
var $2c0a519076979439$var$styles = {
    banner: "_1bsb1osq _kqsw1n9t",
    bannerContainer: "_16jlkb7n _1o9zidpf _i0dl1wug _v564evma _1bsb1osq _kqswh2mm _1pby11wp",
    pageContent: "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _kqswh2mm _1pbykb7n",
    wrapper: "_1e0c1txw _1bsb1osq _1tke1osq _2lx21bp4",
    mainContainer: "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw",
    navigation: "_kqswh2mm _1pbycs5v"
};
/**
 * __Page__
 *
 * Used to build page layouts.
 *
 * Has built in support for positioning [banners](https://atlassian.design/components/banner/examples)
 * and the deprecated `@atlaskit/navigation`.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ var $2c0a519076979439$var$Page = function Page(_ref) {
    var _ref$isBannerOpen = _ref.isBannerOpen, isBannerOpen = _ref$isBannerOpen === void 0 ? false : _ref$isBannerOpen, _ref$bannerHeight = _ref.bannerHeight, bannerHeight = _ref$bannerHeight === void 0 ? (0, $kxElr.defaultBannerHeight) : _ref$bannerHeight, banner = _ref.banner, navigation = _ref.navigation, children = _ref.children, testId = _ref.testId;
    return /*#__PURE__*/ $91i6m.createElement("div", {
        "data-testid": testId,
        className: (0, $9gzWK.default)([
            $2c0a519076979439$var$styles.wrapper
        ])
    }, banner ? /*#__PURE__*/ $91i6m.createElement("div", {
        style: {
            height: isBannerOpen ? "".concat(bannerHeight, "px") : '0'
        },
        "aria-hidden": !isBannerOpen,
        "data-testid": testId ? "".concat(testId, "--banner-container") : undefined,
        className: (0, $9gzWK.default)([
            $2c0a519076979439$var$styles.bannerContainer
        ])
    }, /*#__PURE__*/ $91i6m.createElement("div", {
        className: (0, $9gzWK.default)([
            $2c0a519076979439$var$styles.banner
        ])
    }, banner)) : null, /*#__PURE__*/ $91i6m.createElement("div", {
        className: (0, $9gzWK.default)([
            $2c0a519076979439$var$styles.mainContainer
        ])
    }, /*#__PURE__*/ $91i6m.createElement("div", {
        className: (0, $9gzWK.default)([
            $2c0a519076979439$var$styles.navigation
        ])
    }, navigation), /*#__PURE__*/ $91i6m.createElement("div", {
        className: (0, $9gzWK.default)([
            $2c0a519076979439$var$styles.pageContent
        ])
    }, children)));
};
var $2c0a519076979439$export$2e2bcd8739ae039 = $2c0a519076979439$var$Page;

});
parcelRegister("kxElr", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", function () { return $ef462f583e6caa9b$export$74797698e12f8baa; });
$parcel$export(module.exports, "spacingMapping", function () { return $ef462f583e6caa9b$export$2a89a65a43bab52d; });
$parcel$export(module.exports, "defaultSpacing", function () { return $ef462f583e6caa9b$export$8ec7372efd74b753; });
$parcel$export(module.exports, "defaultBannerHeight", function () { return $ef462f583e6caa9b$export$d77f83c3d17a7b8a; });
$parcel$export(module.exports, "defaultMedium", function () { return $ef462f583e6caa9b$export$f8725d21f81f3e01; });
$parcel$export(module.exports, "defaultLayout", function () { return $ef462f583e6caa9b$export$2303d2bd9eeff99a; });
var $ef462f583e6caa9b$var$defaultGridSize = 8;
var $ef462f583e6caa9b$export$74797698e12f8baa = 12;
var $ef462f583e6caa9b$export$b8241a1616ab1b96 = $ef462f583e6caa9b$var$defaultGridSize * 10;
var $ef462f583e6caa9b$export$2a89a65a43bab52d = {
    comfortable: $ef462f583e6caa9b$var$defaultGridSize * 5,
    cosy: $ef462f583e6caa9b$var$defaultGridSize * 2,
    compact: $ef462f583e6caa9b$var$defaultGridSize * 0.5
};
var $ef462f583e6caa9b$export$8ec7372efd74b753 = 'cosy';
var $ef462f583e6caa9b$export$d77f83c3d17a7b8a = 52;
var $ef462f583e6caa9b$export$f8725d21f81f3e01 = 0;
var $ef462f583e6caa9b$export$2303d2bd9eeff99a = 'fixed';
var $ef462f583e6caa9b$export$9ddc3632bbfb8966 = '--ds-columns-num';
var $ef462f583e6caa9b$export$8b7e31f391e6e681 = '--ds-column-span';
var $ef462f583e6caa9b$export$936829b4511db3e4 = '--ds-grid-spacing';

});


parcelRegister("gKcIt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c30ace6fdc43504e$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $kxElr = parcelRequire("kxElr");

var $gj9VU = parcelRequire("gj9VU");

var $1MAbu = parcelRequire("1MAbu");

var $d3Ch3 = parcelRequire("d3Ch3");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ var $c30ace6fdc43504e$var$GridWrapper = function GridWrapper(_ref) {
    var _ref2, _ref3, _theme$isNestedGrid;
    var spacingProp = _ref.spacing, columnsProp = _ref.columns, layout = _ref.layout, testId = _ref.testId, children = _ref.children, theme = _ref.theme;
    /**
   * isRoot is `true` only in the default context (i.e. no ancestor Grid).
   */ var _useContext = (0, $91i6m.useContext)((0, $d3Ch3.GridContext)), isRoot = _useContext.isRoot;
    var _useContext2 = (0, $91i6m.useContext)((0, $1MAbu.GridColumnContext)), medium = _useContext2.medium;
    /**
   * The colspan of the current containing GridColumn provides
   * the default amount of columns in a nested grid.
   */ var defaultColumns = medium > 0 ? medium : (0, $kxElr.defaultGridColumns);
    /**
   * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
   * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
   */ var spacing = (_ref2 = spacingProp !== null && spacingProp !== void 0 ? spacingProp : theme === null || theme === void 0 ? void 0 : theme.spacing) !== null && _ref2 !== void 0 ? _ref2 : (0, $kxElr.defaultSpacing);
    var columns = (_ref3 = columnsProp !== null && columnsProp !== void 0 ? columnsProp : theme === null || theme === void 0 ? void 0 : theme.columns) !== null && _ref3 !== void 0 ? _ref3 : defaultColumns;
    var isNested = (_theme$isNestedGrid = theme === null || theme === void 0 ? void 0 : theme.isNestedGrid) !== null && _theme$isNestedGrid !== void 0 ? _theme$isNestedGrid : !isRoot;
    var contextValue = (0, $91i6m.useMemo)(function() {
        return {
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        };
    }, [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $d3Ch3.GridContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $gj9VU.Grid), {
        layout: layout,
        testId: testId
    }, children));
};
var $c30ace6fdc43504e$export$2e2bcd8739ae039 = $c30ace6fdc43504e$var$GridWrapper;

});
parcelRegister("gj9VU", function(module, exports) {

$parcel$export(module.exports, "Grid", function () { return $bdf6202ff38102d5$export$ef2184bd89960b14; });
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $kxElr = parcelRequire("kxElr");

var $d3Ch3 = parcelRequire("d3Ch3");
var $bdf6202ff38102d5$var$defaultGridColumnWidth = 80;
/**
 * The number of available columns in each row.
 */ var $bdf6202ff38102d5$var$varColumnsNum = '--ds-columns-num';
/**
 * The spacing (in `px`) between each column.
 */ var $bdf6202ff38102d5$var$varGridSpacing = '--ds-grid-spacing';
var $bdf6202ff38102d5$var$styles = {
    grid: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _ca0qidpf _u5f3wx3y _n3tdidpf _19bvwx3y _1e0c1txw _kqswh2mm _4cvr1y6m _1n261g80",
    nestedGrid: "_19pkidpf _2hwx1un2 _otyridpf _18u01un2"
};
var $bdf6202ff38102d5$var$gridLayoutMapStyles = {
    fixed: "_p12fgkkb",
    fluid: "_p12f1osq"
};
var $bdf6202ff38102d5$export$ef2184bd89960b14 = function Grid(_ref) {
    var _ref$layout = _ref.layout, layout = _ref$layout === void 0 ? (0, $kxElr.defaultLayout) : _ref$layout, testId = _ref.testId, children = _ref.children;
    var _useContext = (0, $91i6m.useContext)((0, $d3Ch3.GridContext)), isNested = _useContext.isNested, columns = _useContext.columns, spacing = _useContext.spacing;
    return /*#__PURE__*/ $91i6m.createElement("div", {
        style: (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, $bdf6202ff38102d5$var$varColumnsNum, columns), $bdf6202ff38102d5$var$varGridSpacing, "".concat((0, $kxElr.spacingMapping)[spacing], "px")),
        "data-testid": testId,
        className: (0, $9gzWK.default)([
            $bdf6202ff38102d5$var$styles.grid,
            $bdf6202ff38102d5$var$gridLayoutMapStyles[layout],
            isNested && $bdf6202ff38102d5$var$styles.nestedGrid
        ])
    }, children);
};

});
parcelRegister("d3Ch3", function(module, exports) {

$parcel$export(module.exports, "GridContext", function () { return $98193e99dd3513fc$export$11cae3e04ab99fae; });

var $91i6m = parcelRequire("91i6m");

var $kxElr = parcelRequire("kxElr");
var $98193e99dd3513fc$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $91i6m.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $kxElr.defaultSpacing),
    columns: (0, $kxElr.defaultGridColumns)
});

});


parcelRegister("1MAbu", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", function () { return $14c65797c5cfd64a$export$1229ad7112b989f5; });
$parcel$export(module.exports, "default", function () { return $14c65797c5cfd64a$export$2e2bcd8739ae039; });
/* grid-column.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $kxElr = parcelRequire("kxElr");

var $d3Ch3 = parcelRequire("d3Ch3");
/**
 * Determines the method by which column width is calculated.
 */ var $14c65797c5cfd64a$var$ColumnVariant = /*#__PURE__*/ function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
    return ColumnVariant;
}($14c65797c5cfd64a$var$ColumnVariant || {});
/**
 * The spacing (in `px`) between each column.
 */ var $14c65797c5cfd64a$var$varGridSpacing = '--ds-grid-spacing';
/**
 * The number of columns that a `GridColumn` covers.
 */ var $14c65797c5cfd64a$var$varColumnSpan = '--ds-column-span';
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ var $14c65797c5cfd64a$var$singleColumnWidth = "(99.9999% / var(--ds-columns-num))";
var $14c65797c5cfd64a$var$styles = {
    gridColumn: "_19pkidpf _2hwxwx3y _otyridpf _18u0wx3y _1ul9hrtj _16jlkb7n _1o9zidpf _slp31hna"
};
var $14c65797c5cfd64a$var$gridColumnWidthMapStyles = {
    auto: "_p12f1ho1 _i0dl1wug",
    bounded: "_p12fpg3g _i0dl1osq",
    fullWidth: "_p12f1ho1 _i0dl1osq"
};
var $14c65797c5cfd64a$var$getVariant = function getVariant(_ref) {
    var medium = _ref.medium, columns = _ref.columns;
    if (medium === (0, $kxElr.defaultMedium)) return $14c65797c5cfd64a$var$ColumnVariant.Auto;
    else if (medium < columns) return $14c65797c5cfd64a$var$ColumnVariant.Bounded;
    return $14c65797c5cfd64a$var$ColumnVariant.FullWidth;
};
var $14c65797c5cfd64a$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $91i6m.createContext)({
    medium: (0, $kxElr.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ var $14c65797c5cfd64a$var$GridColumn = function GridColumn(_ref2) {
    var _ref2$medium = _ref2.medium, medium = _ref2$medium === void 0 ? (0, $kxElr.defaultMedium) : _ref2$medium, children = _ref2.children, testId = _ref2.testId;
    var _useContext = (0, $91i6m.useContext)((0, $d3Ch3.GridContext)), columns = _useContext.columns;
    var contextValue = (0, $91i6m.useMemo)(function() {
        return {
            medium: medium
        };
    }, [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ var colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ var variant = $14c65797c5cfd64a$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ $91i6m.createElement($14c65797c5cfd64a$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $91i6m.createElement("div", {
        style: (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, $14c65797c5cfd64a$var$varColumnSpan, variant === $14c65797c5cfd64a$var$ColumnVariant.Auto ? 'auto' : colSpan),
        "data-testid": testId,
        className: (0, $9gzWK.default)([
            $14c65797c5cfd64a$var$styles.gridColumn,
            $14c65797c5cfd64a$var$gridColumnWidthMapStyles[variant]
        ])
    }, children));
};
var $14c65797c5cfd64a$export$2e2bcd8739ae039 = $14c65797c5cfd64a$var$GridColumn;

});



parcelRegister("9wl70", function(module, exports) {

$parcel$export(module.exports, "media", function () { return $6ee77aa428324d4f$export$987d49ffe1b0900f; });
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $6ee77aa428324d4f$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

});

parcelRegister("8NcDB", function(module, exports) {

$parcel$export(module.exports, "colorPalette", function () { return $66f9a962fae8b008$export$569885e57444f84a; });

var $kLNLK = parcelRequire("kLNLK");
const $66f9a962fae8b008$export$569885e57444f84a = {
    primaryNavy: (0, $kLNLK).N800,
    primaryBlue: (0, $kLNLK).B500,
    primaryWhite: (0, $kLNLK).N0,
    secondaryRed: (0, $kLNLK).R300,
    secondaryYellow: (0, $kLNLK).Y300,
    secondaryGreen: (0, $kLNLK).G300,
    secondaryCyan: (0, $kLNLK).P300,
    secondaryPurple: (0, $kLNLK).T300
};

});

parcelRegister("2DHGn", function(module, exports) {

$parcel$export(module.exports, "getCobrandedComponents", function () { return $7f2cea94a3b6d127$export$7f88f5c61e80b9ef; });

var $6IwzG = parcelRequire("6IwzG");

var $hemgR = parcelRequire("hemgR");

var $7crQn = parcelRequire("7crQn");

var $6g8IV = parcelRequire("6g8IV");

var $5o6Xw = parcelRequire("5o6Xw");

var $4Z8fV = parcelRequire("4Z8fV");

var $18a0P = parcelRequire("18a0P");

var $745Kq = parcelRequire("745Kq");

var $9mjUv = parcelRequire("9mjUv");

var $6s95l = parcelRequire("6s95l");

var $5Ocqh = parcelRequire("5Ocqh");

var $7XL1M = parcelRequire("7XL1M");

var $h8tbz = parcelRequire("h8tbz");

var $50OJ6 = parcelRequire("50OJ6");

var $kVFs3 = parcelRequire("kVFs3");

var $kt5zq = parcelRequire("kt5zq");

var $lFUQd = parcelRequire("lFUQd");
const $7f2cea94a3b6d127$var$cobrandingMap = {
    [(0, $6IwzG.SimpleCobranding).NO_COBRANDING]: (0, $hemgR.default),
    [(0, $6IwzG.SimpleCobranding).BITBUCKET]: (0, $7crQn.default),
    [(0, $6IwzG.SimpleCobranding).COMPASS]: (0, $6g8IV.default),
    [(0, $6IwzG.SimpleCobranding).CONFLUENCE]: (0, $5o6Xw.default),
    [(0, $6IwzG.SimpleCobranding).COMMUNITY]: (0, $4Z8fV.default),
    [(0, $6IwzG.SimpleCobranding).JIRA]: (0, $18a0P.default),
    [(0, $6IwzG.SimpleCobranding).LOOM]: (0, $h8tbz.default),
    [(0, $6IwzG.SimpleCobranding).JIRA_ALIGN]: (0, $50OJ6.default),
    [(0, $6IwzG.SimpleCobranding).OPSGENIE]: (0, $745Kq.default),
    [(0, $6IwzG.SimpleCobranding).STATUSPAGE]: (0, $9mjUv.default),
    [(0, $6IwzG.SimpleCobranding).TRELLO]: (0, $6s95l.default),
    [(0, $6IwzG.SimpleCobranding).WAC]: (0, $5Ocqh.default),
    [(0, $6IwzG.SimpleCobranding).ATLAS]: (0, $7XL1M.default),
    [(0, $6IwzG.SimpleCobranding).ADMIN]: (0, $hemgR.default),
    [(0, $6IwzG.SimpleCobranding).ROVO]: (0, $lFUQd.default),
    [(0, $6IwzG.SimpleCobranding).PRT]: (0, $hemgR.default),
    [(0, $6IwzG.SimpleCobranding).SUPPORT]: (0, $hemgR.default),
    [(0, $6IwzG.AdvancedCobranding).JIRA_ATLAS_75650]: (0, $kVFs3.default),
    [(0, $6IwzG.AdvancedCobranding).CONFLUENCE_ATLAS_75650]: (0, $kt5zq.default),
    [(0, $6IwzG.AdvancedCobranding).DEMO]: (0, $hemgR.default),
    [(0, $6IwzG.AdvancedCobranding).ATLAS_66195]: (0, $hemgR.default),
    [(0, $6IwzG.AdvancedCobranding).CFIND_2409]: (0, $hemgR.default),
    [(0, $6IwzG.AdvancedCobranding).CFIND_3856]: (0, $hemgR.default),
    [(0, $6IwzG.AdvancedCobranding).WAC_LOOM]: (0, $hemgR.default),
    [(0, $6IwzG.AdvancedCobranding).WAC_JPD]: (0, $hemgR.default),
    [(0, $6IwzG.AdvancedCobranding).WAC_JSM]: (0, $hemgR.default),
    [(0, $6IwzG.AdvancedCobranding).ACCOUNT_LINKING]: (0, $hemgR.default),
    [(0, $6IwzG.AdvancedCobranding).ENTRY_AUTH]: (0, $hemgR.default),
    [(0, $6IwzG.AdvancedCobranding).SERVICE_COLLECTION]: (0, $hemgR.default),
    [(0, $6IwzG.AdvancedCobranding).TEAMWORK_COLLECTION]: (0, $hemgR.default),
    [(0, $6IwzG.AdvancedCobranding).PRT_DEMO]: (0, $hemgR.default),
    [(0, $6IwzG.AdvancedCobranding).ISOLATED_CLOUD]: (0, $hemgR.default),
    default: (0, $hemgR.default)
};
const $7f2cea94a3b6d127$export$7f88f5c61e80b9ef = (cobranding)=>{
    if ((0, $6IwzG.isSimpleCobranding)(cobranding) || (0, $6IwzG.isAdvancedCobranding)(cobranding)) return $7f2cea94a3b6d127$var$cobrandingMap[cobranding];
    else {
        console.warn(`[COBRANDING] ${cobranding} is globally configured for advanced-cobranding but corresponding configuration for ${window.location.pathname} was not provided. Loading SimpleCobranding.NO_BRANDING as fallback.`);
        return $7f2cea94a3b6d127$var$cobrandingMap[(0, $6IwzG.SimpleCobranding).NO_COBRANDING];
    }
};

});
parcelRegister("hemgR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $643fb3e2f2831b36$export$2e2bcd8739ae039; });

var $iTSCG = parcelRequire("iTSCG");

var $4ksd4 = parcelRequire("4ksd4");

var $kxTQF = parcelRequire("kxTQF");

var $4zgnR = parcelRequire("4zgnR");
const $643fb3e2f2831b36$export$f2683fd6d2de1a37 = (0, $4ksd4.backgroundWithSideImages)((0, (/*@__PURE__*/$parcel$interopDefault($kxTQF))), (0, (/*@__PURE__*/$parcel$interopDefault($4zgnR))));
const $643fb3e2f2831b36$var$DefaultCobranding = {
    background: $643fb3e2f2831b36$export$f2683fd6d2de1a37,
    logo: {
        component: (0, $iTSCG.AtlassianLogo)
    },
    footerProducts: 'Jira, Confluence, Trello'
};
var $643fb3e2f2831b36$export$2e2bcd8739ae039 = $643fb3e2f2831b36$var$DefaultCobranding;

});
parcelRegister("4ksd4", function(module, exports) {

$parcel$export(module.exports, "whiteboxWidthDesktop", function () { return $4a07205629582005$export$4dacb4c23fc28876; });
$parcel$export(module.exports, "whiteboxWidthHandheld", function () { return $4a07205629582005$export$6bfb439877eddd98; });
$parcel$export(module.exports, "linkStyles", function () { return $4a07205629582005$export$4ea5976125a01ffa; });
$parcel$export(module.exports, "listStyles", function () { return $4a07205629582005$export$f9b6c540022859c0; });
$parcel$export(module.exports, "DefaultBackground", function () { return $4a07205629582005$export$cffd0b81d0e051b1; });
$parcel$export(module.exports, "backgroundWithSideImages", function () { return $4a07205629582005$export$c9af51660ef2db22; });
$parcel$export(module.exports, "backgroundWithImage", function () { return $4a07205629582005$export$860f6dae4486c905; });
$parcel$export(module.exports, "renderProductLogo", function () { return $4a07205629582005$export$390d73d0230797c4; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $9jjaN = parcelRequire("9jjaN");

var $26Riy = parcelRequire("26Riy");

var $8NcDB = parcelRequire("8NcDB");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");
let $4a07205629582005$var$_ = (t)=>t, $4a07205629582005$var$t, $4a07205629582005$var$t1, $4a07205629582005$var$t2, $4a07205629582005$var$t3, $4a07205629582005$var$t4, $4a07205629582005$var$t5, $4a07205629582005$var$t6, $4a07205629582005$var$t7, $4a07205629582005$var$t8, $4a07205629582005$var$t9;
const $4a07205629582005$export$4dacb4c23fc28876 = `${(0, $6e88g.gridSize)() * 50}px`;
const $4a07205629582005$export$6bfb439877eddd98 = `${(0, $6e88g.gridSize)() * 40}px`;
const $4a07205629582005$export$7970b24609d80d2d = (0, $9jjaN.default).div($4a07205629582005$var$t1 || ($4a07205629582005$var$t1 = $4a07205629582005$var$_`
  ${0};
`), (0, $26Riy.media).handheld($4a07205629582005$var$t || ($4a07205629582005$var$t = $4a07205629582005$var$_`
    display: none;
  `)));
const $4a07205629582005$export$97b346657ff4770f = (0, $9jjaN.default).div($4a07205629582005$var$t3 || ($4a07205629582005$var$t3 = $4a07205629582005$var$_`
  display: none;

  ${0};
`), (0, $26Riy.media).handheld($4a07205629582005$var$t2 || ($4a07205629582005$var$t2 = $4a07205629582005$var$_`
    display: inline-block;
  `)));
const $4a07205629582005$export$4ea5976125a01ffa = (color)=>`
   a {
      color: ${color};

      &:hover {
        color: ${color};
      }
      &.hover {
        color: ${color};
      }
      &.primary-action {
        color: ${color};
      }
   }
`;
const $4a07205629582005$export$f9b6c540022859c0 = `
    ul {
      display: flex;
      justify-content: center;
      list-style: none;
      padding: 0;
    }
`;
const $4a07205629582005$export$cffd0b81d0e051b1 = (0, $9jjaN.default).div($4a07205629582005$var$t5 || ($4a07205629582005$var$t5 = $4a07205629582005$var$_`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;
  background-color: ${0};
  ${0}
`), (0, $kLNLK).N10, (0, $26Riy.media).handheld($4a07205629582005$var$t4 || ($4a07205629582005$var$t4 = $4a07205629582005$var$_`
    background: ${0};
    color: ${0};
  `), (0, $8NcDB.colorPalette).primaryWhite, (0, $8NcDB.colorPalette).primaryNavy));
function $4a07205629582005$export$c9af51660ef2db22(leftImageSrc, rightImageSrc) {
    const scalingImagesMaxWidth = `${(0, $6e88g.gridSize)() * 150}px`; //50 grid size for whitebox + 2 * 50 grid size for images
    const widescreenBackgroundImageSize = `calc((100vw - ${$4a07205629582005$export$4dacb4c23fc28876})/2 - ${(0, $6e88g.gridSize)() * 4}px) auto`;
    return (0, $9jjaN.default)($4a07205629582005$export$cffd0b81d0e051b1)($4a07205629582005$var$t7 || ($4a07205629582005$var$t7 = $4a07205629582005$var$_`
    background-image: url(${0}), url(${0});
    background-repeat: no-repeat, no-repeat;
    background-attachment: fixed, fixed;
    background-size: ${0}px auto, ${0}px auto;
    background-position: left bottom, right bottom;

    @media (max-width: ${0}) {
      background-size: ${0}, ${0}, cover;
    }

    ${0}
  `), leftImageSrc, rightImageSrc, (0, $6e88g.gridSize)() * 46, (0, $6e88g.gridSize)() * 46, scalingImagesMaxWidth, widescreenBackgroundImageSize, widescreenBackgroundImageSize, (0, $26Riy.media).handheld($4a07205629582005$var$t6 || ($4a07205629582005$var$t6 = $4a07205629582005$var$_`
      background: ${0};
      color: ${0};
    `), (0, $8NcDB.colorPalette).primaryWhite, (0, $8NcDB.colorPalette).primaryNavy));
}
function $4a07205629582005$export$860f6dae4486c905(bgImageSrc) {
    return (0, $9jjaN.default)($4a07205629582005$export$cffd0b81d0e051b1)($4a07205629582005$var$t9 || ($4a07205629582005$var$t9 = $4a07205629582005$var$_`
    background-image: url(${0});
    background-position: center;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: cover;

    ${0}
  `), bgImageSrc, (0, $26Riy.media).handheld($4a07205629582005$var$t8 || ($4a07205629582005$var$t8 = $4a07205629582005$var$_`
      background: ${0};
      color: ${0};
    `), (0, $8NcDB.colorPalette).primaryWhite, (0, $8NcDB.colorPalette).primaryNavy));
}
const $4a07205629582005$export$390d73d0230797c4 = (props)=>{
    if ('renderLogo' in props) // is a custom logo
    return props.renderLogo();
    const { component: AtlaskitLogo } = props;
    return /*#__PURE__*/ (0, $4ZSso.jsx)(AtlaskitLogo, {
        appearance: "brand",
        size: "large",
        shouldUseNewLogoDesign: true
    });
};

});

parcelRegister("kxTQF", function(module, exports) {

module.exports = (parcelRequire("cgi2g")).getBundleURL('9rAa3') + "default_left.dfc31853.svg";

});

parcelRegister("4zgnR", function(module, exports) {

module.exports = (parcelRequire("cgi2g")).getBundleURL('9rAa3') + "default_right.a801c0cc.svg";

});


parcelRegister("7crQn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae17bd9f03376c5d$export$2e2bcd8739ae039; });

var $eQ1c9 = parcelRequire("eQ1c9");

var $6uK3G = parcelRequire("6uK3G");
const $ae17bd9f03376c5d$var$BitbucketCobranding = {
    background: (0, $6uK3G.BitbucketBackground),
    logo: {
        component: (0, $eQ1c9.BitbucketLogo)
    },
    footerProducts: 'Bitbucket, Jira, Confluence'
};
var $ae17bd9f03376c5d$export$2e2bcd8739ae039 = $ae17bd9f03376c5d$var$BitbucketCobranding;

});
parcelRegister("eQ1c9", function(module, exports) {

$parcel$export(module.exports, "HomeLogo", function () { return $acd6d94dc2d30e6c$export$d5648119d5b68e90; });
$parcel$export(module.exports, "BitbucketLogo", function () { return $acd6d94dc2d30e6c$export$bd40525f5333524b; });
$parcel$export(module.exports, "CompassLogo", function () { return $acd6d94dc2d30e6c$export$eb7d748e4f9c9676; });
$parcel$export(module.exports, "ConfluenceIcon", function () { return $acd6d94dc2d30e6c$export$68f3db7f6af48bcb; });
$parcel$export(module.exports, "ConfluenceLogo", function () { return $acd6d94dc2d30e6c$export$1b2e4fe6ef471556; });
$parcel$export(module.exports, "JiraAlignLogo", function () { return $acd6d94dc2d30e6c$export$ee11e928d3d045fd; });
$parcel$export(module.exports, "JiraIcon", function () { return $acd6d94dc2d30e6c$export$c4b5b1f965d8b3eb; });
$parcel$export(module.exports, "JiraLogo", function () { return $acd6d94dc2d30e6c$export$17d3acb0b4379d02; });
$parcel$export(module.exports, "JiraProductDiscoveryIcon", function () { return $acd6d94dc2d30e6c$export$21bfbeb62fdcce8d; });
$parcel$export(module.exports, "JiraProductDiscoveryLogo", function () { return $acd6d94dc2d30e6c$export$c49a2b642fe9eef4; });
$parcel$export(module.exports, "JiraServiceManagementIcon", function () { return $acd6d94dc2d30e6c$export$3c6158790f5e01c4; });
$parcel$export(module.exports, "JiraServiceManagementLogo", function () { return $acd6d94dc2d30e6c$export$dabef2be6cd28c20; });
$parcel$export(module.exports, "LoomLogo", function () { return $acd6d94dc2d30e6c$export$94e206806e36c2ec; });
$parcel$export(module.exports, "OpsgenieLogo", function () { return $acd6d94dc2d30e6c$export$a1c6484cdecc2c4b; });
$parcel$export(module.exports, "StatuspageLogo", function () { return $acd6d94dc2d30e6c$export$bb4ae5b41b43be04; });
$parcel$export(module.exports, "TrelloLogo", function () { return $acd6d94dc2d30e6c$export$60e26212f3b61a28; });
$parcel$export(module.exports, "RovoIcon", function () { return $acd6d94dc2d30e6c$export$e23ae35269442b4f; });
$parcel$export(module.exports, "RovoLogo", function () { return $acd6d94dc2d30e6c$export$a0f6cb8061290bbb; });

var $9ibR1 = parcelRequire("9ibR1");
var $e5zth = parcelRequire("e5zth");

var $lO9wW = parcelRequire("lO9wW");
var $10SeM = parcelRequire("10SeM");

var $lJ0FX = parcelRequire("lJ0FX");
var $8Lejx = parcelRequire("8Lejx");

var $eMcuJ = parcelRequire("eMcuJ");
var $1T8Y8 = parcelRequire("1T8Y8");

var $jpPzg = parcelRequire("jpPzg");
var $hMg4N = parcelRequire("hMg4N");

var $hv0nR = parcelRequire("hv0nR");
var $hkak9 = parcelRequire("hkak9");

var $2kp1J = parcelRequire("2kp1J");
var $jE7aB = parcelRequire("jE7aB");

var $8bbo8 = parcelRequire("8bbo8");
var $bajjP = parcelRequire("bajjP");

var $2AO3x = parcelRequire("2AO3x");
var $htUaT = parcelRequire("htUaT");

var $amdEi = parcelRequire("amdEi");
var $4DkwG = parcelRequire("4DkwG");

var $ei0jF = parcelRequire("ei0jF");
var $4MxUx = parcelRequire("4MxUx");

var $27LtN = parcelRequire("27LtN");
var $i5lh8 = parcelRequire("i5lh8");

var $2i9G1 = parcelRequire("2i9G1");
var $dUVQv = parcelRequire("dUVQv");

var $tQUNw = parcelRequire("tQUNw");
var $56rbZ = parcelRequire("56rbZ");

var $4jw7D = parcelRequire("4jw7D");
var $kRIsr = parcelRequire("kRIsr");

var $ewdTe = parcelRequire("ewdTe");
var $8TU1e = parcelRequire("8TU1e");

var $3kHWf = parcelRequire("3kHWf");
var $63PMX = parcelRequire("63PMX");

var $1epFg = parcelRequire("1epFg");
var $8c991 = parcelRequire("8c991");

var $k11P2 = parcelRequire("k11P2");
var $iVV0H = parcelRequire("iVV0H");

var $4mTYt = parcelRequire("4mTYt");
var $k0DNU = parcelRequire("k0DNU");

var $3oPBA = parcelRequire("3oPBA");
var $kglpC = parcelRequire("kglpC");

var $5JE8t = parcelRequire("5JE8t");
var $8d7hN = parcelRequire("8d7hN");

var $llTTU = parcelRequire("llTTU");
var $4wSwT = parcelRequire("4wSwT");

var $4RMyC = parcelRequire("4RMyC");
var $8uRw8 = parcelRequire("8uRw8");

var $brFNI = parcelRequire("brFNI");

var $bZxlZ = parcelRequire("bZxlZ");
var $2PAY8 = parcelRequire("2PAY8");

var $2l7kX = parcelRequire("2l7kX");
var $8kcAq = parcelRequire("8kcAq");

var $kFMs3 = parcelRequire("kFMs3");
var $2EhPn = parcelRequire("2EhPn");

var $3LpE3 = parcelRequire("3LpE3");
var $knH1D = parcelRequire("knH1D");

var $cOk7p = parcelRequire("cOk7p");
var $1zM2S = parcelRequire("1zM2S");

var $dLAVA = parcelRequire("dLAVA");
var $b50SW = parcelRequire("b50SW");

var $kGYji = parcelRequire("kGYji");
var $abATu = parcelRequire("abATu");

var $8w8PR = parcelRequire("8w8PR");
var $5xGD1 = parcelRequire("5xGD1");

var $pQ3JL = parcelRequire("pQ3JL");
var $fJnmE = parcelRequire("fJnmE");

var $20Q2J = parcelRequire("20Q2J");
var $kUYj6 = parcelRequire("kUYj6");

var $aql3A = parcelRequire("aql3A");
var $2qkU7 = parcelRequire("2qkU7");

var $kEQaO = parcelRequire("kEQaO");
var $cqVtY = parcelRequire("cqVtY");

var $ZNZqm = parcelRequire("ZNZqm");
var $38UZx = parcelRequire("38UZx");

var $ebq8M = parcelRequire("ebq8M");
var $eLzxh = parcelRequire("eLzxh");

var $aEv9l = parcelRequire("aEv9l");
var $b9Dmh = parcelRequire("b9Dmh");

var $k5zT0 = parcelRequire("k5zT0");
var $2238H = parcelRequire("2238H");

var $2oUZb = parcelRequire("2oUZb");
var $3NcgT = parcelRequire("3NcgT");

var $2hPHy = parcelRequire("2hPHy");
var $2GayE = parcelRequire("2GayE");

var $1N7S0 = parcelRequire("1N7S0");
var $96Oyx = parcelRequire("96Oyx");

var $fuOdT = parcelRequire("fuOdT");
var $gvsev = parcelRequire("gvsev");

var $hHOIB = parcelRequire("hHOIB");
var $7IJuQ = parcelRequire("7IJuQ");

var $gCu52 = parcelRequire("gCu52");
var $1aINS = parcelRequire("1aINS");

var $9nGna = parcelRequire("9nGna");
var $5Y0z3 = parcelRequire("5Y0z3");

var $zbSjR = parcelRequire("zbSjR");
var $8Aorm = parcelRequire("8Aorm");

var $qKSvE = parcelRequire("qKSvE");
var $Od6As = parcelRequire("Od6As");

var $9ayXU = parcelRequire("9ayXU");
var $bVyJW = parcelRequire("bVyJW");

var $e1a9c = parcelRequire("e1a9c");
var $6jEQT = parcelRequire("6jEQT");

var $3kU2O = parcelRequire("3kU2O");
var $a1N0K = parcelRequire("a1N0K");





var $iTSCG = parcelRequire("iTSCG");


var $kmiae = parcelRequire("kmiae");
var $acd6d94dc2d30e6c$export$ef8e5f836dd989d3 = (0, $kmiae.tempSizeWrapper)((0, $9ibR1.AdminIcon));
var $acd6d94dc2d30e6c$export$ebcd30672e67406 = (0, $kmiae.tempSizeWrapper)((0, $e5zth.AdminLogoCS));
var $acd6d94dc2d30e6c$export$af3460f51ce3602a = (0, $kmiae.tempSizeWrapper)((0, $lJ0FX.AnalyticsIcon));
var $acd6d94dc2d30e6c$export$c8415b6abe4a8587 = (0, $kmiae.tempSizeWrapper)((0, $8Lejx.AnalyticsLogoCS));
var $acd6d94dc2d30e6c$export$d89497e7f33ca6f5 = (0, $kmiae.tempSizeWrapper)((0, $eMcuJ.AssetsIcon));
var $acd6d94dc2d30e6c$export$48ca930f3071e3e4 = (0, $kmiae.tempSizeWrapper)((0, $1T8Y8.AssetsLogoCS));
var $acd6d94dc2d30e6c$export$52cd484a7ef4f2b9 = (0, $kmiae.tempSizeWrapper)((0, $8bbo8.ChatIcon));
var $acd6d94dc2d30e6c$export$9ca9881809919df8 = (0, $kmiae.tempSizeWrapper)((0, $bajjP.ChatLogoCS));
var $acd6d94dc2d30e6c$export$6da5aa77c402ba0f = (0, $kmiae.tempSizeWrapper)((0, $2i9G1.CustomerServiceManagementIcon));
var $acd6d94dc2d30e6c$export$abc95e6180bb1d88 = (0, $kmiae.tempSizeWrapper)((0, $dUVQv.CustomerServiceManagementLogoCS));
var $acd6d94dc2d30e6c$export$9eb74917ea768ed4 = (0, $kmiae.tempSizeWrapper)((0, $4jw7D.GoalsIcon));
var $acd6d94dc2d30e6c$export$d2577aa28451395f = (0, $kmiae.tempSizeWrapper)((0, $kRIsr.GoalsLogoCS));
var $acd6d94dc2d30e6c$export$92c8767b874048d = (0, $kmiae.tempSizeWrapper)((0, $3kHWf.HomeIcon));
var $acd6d94dc2d30e6c$export$d5648119d5b68e90 = (0, $kmiae.tempSizeWrapper)((0, $63PMX.HomeLogoCS));
var $acd6d94dc2d30e6c$export$80b8b269d8b5014e = (0, $kmiae.tempSizeWrapper)((0, $1epFg.HubIcon));
var $acd6d94dc2d30e6c$export$fc9bd6687b80fe3b = (0, $kmiae.tempSizeWrapper)((0, $8c991.HubLogoCS));
var $acd6d94dc2d30e6c$export$5ed3e1bb3b04fc02 = (0, $kmiae.tempSizeWrapper)((0, $kFMs3.ProjectsIcon));
var $acd6d94dc2d30e6c$export$aeefab651bcf2338 = (0, $kmiae.tempSizeWrapper)((0, $2EhPn.ProjectsLogoCS));
var $acd6d94dc2d30e6c$export$82eafebb825fc23f = (0, $kmiae.tempSizeWrapper)((0, $cOk7p.SearchIcon));
var $acd6d94dc2d30e6c$export$e4c5487c9a8ae3b1 = (0, $kmiae.tempSizeWrapper)((0, $1zM2S.SearchLogoCS));
var $acd6d94dc2d30e6c$export$290a0f24614cde9f = (0, $kmiae.tempSizeWrapper)((0, $kGYji.StudioIcon));
var $acd6d94dc2d30e6c$export$8aceb78c659789b6 = (0, $kmiae.tempSizeWrapper)((0, $abATu.StudioLogoCS));
var $acd6d94dc2d30e6c$export$4b05688514531169 = (0, $kmiae.tempSizeWrapper)((0, $8w8PR.TalentIcon));
var $acd6d94dc2d30e6c$export$4f6453e012279f89 = (0, $kmiae.tempSizeWrapper)((0, $5xGD1.TalentLogoCS));
var $acd6d94dc2d30e6c$export$1bcbc9c337da86da = (0, $kmiae.tempSizeWrapper)((0, $pQ3JL.TeamsIcon));
var $acd6d94dc2d30e6c$export$9b1a0a0c574cec2a = (0, $kmiae.tempSizeWrapper)((0, $fJnmE.TeamsLogoCS));
var $acd6d94dc2d30e6c$export$e812398311cab9a3 = (0, $kmiae.tempSizeWrapper)((0, $jpPzg.BambooIcon));
var $acd6d94dc2d30e6c$export$765f5afcc1a5a7e3 = (0, $kmiae.tempSizeWrapper)((0, $hMg4N.BambooLogoCS));
var $acd6d94dc2d30e6c$export$d3ab16bbf4f954ee = (0, $kmiae.tempSizeWrapper)((0, $2kp1J.BitbucketDataCenterIcon));
var $acd6d94dc2d30e6c$export$36044946916e84a0 = (0, $kmiae.tempSizeWrapper)((0, $jE7aB.BitbucketDataCenterLogoCS));
var $acd6d94dc2d30e6c$export$53305f1f2855d3be = (0, $kmiae.tempSizeWrapper)((0, $ei0jF.ConfluenceDataCenterIcon));
var $acd6d94dc2d30e6c$export$5e06396bce773a3 = (0, $kmiae.tempSizeWrapper)((0, $4MxUx.ConfluenceDataCenterLogoCS));
var $acd6d94dc2d30e6c$export$eaf73f391f7103bd = (0, $kmiae.tempSizeWrapper)((0, $27LtN.CrowdIcon));
var $acd6d94dc2d30e6c$export$6128b385660fd3c6 = (0, $kmiae.tempSizeWrapper)((0, $i5lh8.CrowdLogoCS));
var $acd6d94dc2d30e6c$export$f8455b5667a3ee0c = (0, $kmiae.tempSizeWrapper)((0, $4mTYt.JiraDataCenterIcon));
var $acd6d94dc2d30e6c$export$eb152ab3801b2ae3 = (0, $kmiae.tempSizeWrapper)((0, $k0DNU.JiraDataCenterLogoCS));
var $acd6d94dc2d30e6c$export$65fae0eaf343f2ca = (0, $kmiae.tempSizeWrapper)((0, $llTTU.JiraServiceManagementDataCenterIcon));
var $acd6d94dc2d30e6c$export$fffc0d480fb1ebf1 = (0, $kmiae.tempSizeWrapper)((0, $4wSwT.JiraServiceManagementDataCenterLogoCS));
var $acd6d94dc2d30e6c$export$74517ed253186308 = (0, $kmiae.createFeatureFlaggedComponent)((0, $kEQaO.AtlassianAdministrationIcon), (0, $9ibR1.AdminIcon));
var $acd6d94dc2d30e6c$export$833abe6c2ce5ebfd = (0, $kmiae.createFeatureFlaggedComponent)((0, $cqVtY.AtlassianAdministrationLogo), (0, $e5zth.AdminLogoCS));
var $acd6d94dc2d30e6c$export$84109e099492cb5f = (0, $kmiae.createFeatureFlaggedComponent)((0, $aql3A.AtlassianAdminIcon), (0, $9ibR1.AdminIcon));
var $acd6d94dc2d30e6c$export$f845d9b9254f0541 = (0, $kmiae.createFeatureFlaggedComponent)((0, $2qkU7.AtlassianAdminLogo), (0, $e5zth.AdminLogoCS));
var $acd6d94dc2d30e6c$export$c42ad8a0b925c762 = (0, $kmiae.createFeatureFlaggedComponent)((0, $ZNZqm.AtlassianAnalyticsIcon), (0, $lJ0FX.AnalyticsIcon));
var $acd6d94dc2d30e6c$export$e6470bfc39010cc4 = (0, $kmiae.createFeatureFlaggedComponent)((0, $38UZx.AtlassianAnalyticsLogo), (0, $8Lejx.AnalyticsLogoCS));
var $acd6d94dc2d30e6c$export$5fc1066e677788d4 = (0, $kmiae.createFeatureFlaggedComponent)((0, $ebq8M.BitbucketIcon), (0, $hv0nR.BitbucketIcon));
var $acd6d94dc2d30e6c$export$bd40525f5333524b = (0, $kmiae.createFeatureFlaggedComponent)((0, $eLzxh.BitbucketLogo), (0, $hkak9.BitbucketLogoCS));
var $acd6d94dc2d30e6c$export$f7857fe64d7161d9 = (0, $kmiae.createFeatureFlaggedComponent)((0, $aEv9l.CompassIcon), (0, $2AO3x.CompassIcon));
var $acd6d94dc2d30e6c$export$eb7d748e4f9c9676 = (0, $kmiae.createFeatureFlaggedComponent)((0, $b9Dmh.CompassLogo), (0, $htUaT.CompassLogoCS));
var $acd6d94dc2d30e6c$export$68f3db7f6af48bcb = (0, $kmiae.createFeatureFlaggedComponent)((0, $k5zT0.ConfluenceIcon), (0, $amdEi.ConfluenceIcon));
var $acd6d94dc2d30e6c$export$1b2e4fe6ef471556 = (0, $kmiae.createFeatureFlaggedComponent)((0, $2238H.ConfluenceLogo), (0, $4DkwG.ConfluenceLogoCS));
var $acd6d94dc2d30e6c$export$70a0c2f5862937b6 = (0, $kmiae.tempSizeWrapper)((0, $lO9wW.AlignIcon));
var $acd6d94dc2d30e6c$export$1b8596b4b0ef673b = (0, $kmiae.tempSizeWrapper)((0, $10SeM.AlignLogoCS));
var $acd6d94dc2d30e6c$export$407687b2dd89cc68 = (0, $kmiae.createFeatureFlaggedComponent)((0, $fuOdT.JiraAlignIcon), (0, $lO9wW.AlignIcon));
var $acd6d94dc2d30e6c$export$ee11e928d3d045fd = (0, $kmiae.createFeatureFlaggedComponent)((0, $gvsev.JiraAlignLogo), (0, $10SeM.AlignLogoCS));
var $acd6d94dc2d30e6c$export$c4b5b1f965d8b3eb = (0, $kmiae.createFeatureFlaggedComponent)((0, $1N7S0.JiraIcon), (0, $k11P2.JiraIcon));
var $acd6d94dc2d30e6c$export$17d3acb0b4379d02 = (0, $kmiae.createFeatureFlaggedComponent)((0, $96Oyx.JiraLogo), (0, $iVV0H.JiraLogoCS));
var $acd6d94dc2d30e6c$export$21bfbeb62fdcce8d = (0, $kmiae.createFeatureFlaggedComponent)((0, $hHOIB.JiraProductDiscoveryIcon), (0, $3oPBA.JiraProductDiscoveryIcon));
var $acd6d94dc2d30e6c$export$c49a2b642fe9eef4 = (0, $kmiae.createFeatureFlaggedComponent)((0, $7IJuQ.JiraProductDiscoveryLogo), (0, $kglpC.JiraProductDiscoveryLogoCS));
var $acd6d94dc2d30e6c$export$3c6158790f5e01c4 = (0, $kmiae.createFeatureFlaggedServiceCollectionComponent)((0, $gCu52.JiraServiceManagementIcon), (0, $5JE8t.JiraServiceManagementIcon));
var $acd6d94dc2d30e6c$export$dabef2be6cd28c20 = (0, $kmiae.createFeatureFlaggedServiceCollectionComponent)((0, $1aINS.JiraServiceManagementLogo), (0, $8d7hN.JiraServiceManagementLogoCS));
var $acd6d94dc2d30e6c$export$8d789f76fde3e05 = (0, $kmiae.createFeatureFlaggedComponent)((0, $9nGna.LoomIcon), (0, $4RMyC.LoomIcon));
var $acd6d94dc2d30e6c$export$94e206806e36c2ec = (0, $kmiae.createFeatureFlaggedComponent)((0, $5Y0z3.LoomLogo), (0, $8uRw8.LoomLogoCS));
var $acd6d94dc2d30e6c$export$1bf47cdade1a9fcb = (0, $kmiae.createFeatureFlaggedComponent)((0, $zbSjR.LoomAttributionIcon), (0, $4RMyC.LoomIcon));
var $acd6d94dc2d30e6c$export$6e87ce8d41eda665 = (0, $kmiae.createFeatureFlaggedComponent)((0, $8Aorm.LoomAttributionLogo), (0, $brFNI.LoomAttributionLogoCS));
var $acd6d94dc2d30e6c$export$e84e925618e0e5bc = (0, $kmiae.tempSizeWrapper)((0, $2PAY8.LoomInternalLogoCS));
var $acd6d94dc2d30e6c$export$1940ba72c868b663 = (0, $kmiae.tempSizeWrapper)((0, $bZxlZ.LoomInternalIcon));
var $acd6d94dc2d30e6c$export$eeccc49dc7a12d9f = (0, $kmiae.createFeatureFlaggedServiceCollectionComponent)((0, $qKSvE.OpsgenieIcon), (0, $2l7kX.OpsgenieIcon));
var $acd6d94dc2d30e6c$export$a1c6484cdecc2c4b = (0, $kmiae.createFeatureFlaggedServiceCollectionComponent)((0, $Od6As.OpsgenieLogo), (0, $8kcAq.OpsgenieLogoCS));
var $acd6d94dc2d30e6c$export$f3f5aa321d88adf9 = (0, $kmiae.createFeatureFlaggedServiceCollectionComponent)((0, $e1a9c.StatuspageIcon), (0, $dLAVA.StatuspageIcon));
var $acd6d94dc2d30e6c$export$bb4ae5b41b43be04 = (0, $kmiae.createFeatureFlaggedServiceCollectionComponent)((0, $6jEQT.StatuspageLogo), (0, $b50SW.StatuspageLogoCS));
var $acd6d94dc2d30e6c$export$4384da9b8b140bf4 = (0, $kmiae.createFeatureFlaggedComponent)((0, $3kU2O.TrelloIcon), (0, $20Q2J.TrelloIcon));
var $acd6d94dc2d30e6c$export$60e26212f3b61a28 = (0, $kmiae.createFeatureFlaggedComponent)((0, $a1N0K.TrelloLogo), (0, $kUYj6.TrelloLogoCS));
var $acd6d94dc2d30e6c$export$e23ae35269442b4f = (0, $kmiae.createFeatureFlaggedServiceCollectionComponent)((0, $9ayXU.RovoIcon), (0, $3LpE3.RovoIcon));
var $acd6d94dc2d30e6c$export$a0f6cb8061290bbb = (0, $kmiae.createFeatureFlaggedServiceCollectionComponent)((0, $bVyJW.RovoLogo), (0, $knH1D.RovoLogoCS));
var $acd6d94dc2d30e6c$export$3f95fcfdc25a741d = (0, $kmiae.createFeatureFlaggedComponent)((0, $2hPHy.GuardIcon), (0, $ewdTe.GuardIcon));
var $acd6d94dc2d30e6c$export$a4a891d202775deb = (0, $kmiae.createFeatureFlaggedComponent)((0, $2GayE.GuardLogo), (0, $8TU1e.GuardLogoCS));
var $acd6d94dc2d30e6c$export$1e02e7298035a77c = (0, $kmiae.createFeatureFlaggedComponent)((0, $2oUZb.FocusIcon), (0, $tQUNw.FocusIcon));
var $acd6d94dc2d30e6c$export$33908560ea1b226d = (0, $kmiae.createFeatureFlaggedComponent)((0, $3NcgT.FocusLogo), (0, $56rbZ.FocusLogoCS));

});
parcelRegister("9ibR1", function(module, exports) {

$parcel$export(module.exports, "AdminIcon", function () { return $6c3efd791fdb7598$export$ef8e5f836dd989d3; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1b4c2b482d26b1be8309fdd18226deba>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $6c3efd791fdb7598$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.444 5h3.111l.98 2.61 2.75-.457 1.555 2.694L17.07 12l1.77 2.153-1.555 2.694-2.75-.457-.979 2.61h-3.11l-.98-2.61-2.75.457-1.555-2.694L6.931 12 5.16 9.847l1.555-2.694 2.75.457zM12 14.625a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $6c3efd791fdb7598$export$ef8e5f836dd989d3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Admin' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $6c3efd791fdb7598$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});
parcelRegister("2AmSr", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", function () { return $1e20b073844b25a8$export$be58b4326e23250f; });
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $jfDBc = parcelRequire("jfDBc");
var $1e20b073844b25a8$var$styles = {
    root: "_1e0c1o8l"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $1e20b073844b25a8$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $1e20b073844b25a8$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $1e20b073844b25a8$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $1e20b073844b25a8$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ var $1e20b073844b25a8$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl",
    '12': "_4t3i1crf",
    '16': "_4t3i7vkz",
    '20': "_4t3igktf",
    '24': "_4t3i1tcg",
    '32': "_4t3izwfg"
};
function $1e20b073844b25a8$export$be58b4326e23250f(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? '20' : _ref$size, label = _ref.label, svg = _ref.svg, customThemeSvg = _ref.customThemeSvg, userDefinedTestId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, customIconColor = _ref.iconColor, _ref$isDataCenter = _ref.isDataCenter, isDataCenter = _ref$isDataCenter === void 0 ? false : _ref$isDataCenter;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    var isCustomThemed = customThemeSvg && customIconColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ $91i6m.createElement("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $9gzWK.default)([
            $1e20b073844b25a8$var$styles.root,
            $1e20b073844b25a8$var$sizeMap[size],
            isDataCenter ? colorMode === 'dark' ? $1e20b073844b25a8$var$dataCenterDarkAppearanceMap[appearance] : $1e20b073844b25a8$var$dataCenterLightAppearanceMap[appearance] : colorMode === 'dark' ? $1e20b073844b25a8$var$cloudDarkAppearanceMap[appearance] : $1e20b073844b25a8$var$cloudLightAppearanceMap[appearance]
        ])
    });
}

});


parcelRegister("e5zth", function(module, exports) {

$parcel$export(module.exports, "AdminLogoCS", function () { return $a41d0c27fc992671$export$61afcb38c001e19; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ecce23f80806781db9edeff944632b7>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $a41d0c27fc992671$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M124.84 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-20.15-10.4c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-14.07-8.52v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.85c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-22.02-4.01c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M13.826 6.4h4.255l1.338 3.569 3.76-.626 2.128 3.684-2.422 2.945 2.421 2.943L23.18 22.6l-3.76-.626-1.338 3.57h-4.255l-1.338-3.57-3.76.625L6.6 18.915l2.421-2.943L6.6 13.028l2.127-3.685 3.76.626zm2.128 13.16a3.59 3.59 0 1 0 0-7.178 3.59 3.59 0 0 0 0 7.179\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $a41d0c27fc992671$export$61afcb38c001e19(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Admin' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $a41d0c27fc992671$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});
parcelRegister("iBDkU", function(module, exports) {

$parcel$export(module.exports, "LogoWrapper", function () { return $d8ba32128f2dfe06$export$f827d3c5a9c3f644; });
/* logo-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $jfDBc = parcelRequire("jfDBc");
var $d8ba32128f2dfe06$var$styles = {
    root: "_1e0c1o8l _vwz4idpf"
};
// These styles set the `color` property so that the child SVG can inherit the correct text color using "currentColor"
var $d8ba32128f2dfe06$var$logoTextColorMap = {
    light: "_syazqlpt",
    dark: "_syazz6c6"
};
var $d8ba32128f2dfe06$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $d8ba32128f2dfe06$var$textLightAppearanceMap = {
    brand: "_1wyc1fxt",
    neutral: "_1wyc1e01",
    inverse: "_1wycu67f",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $d8ba32128f2dfe06$var$textDarkAppearanceMap = {
    brand: "_1wyc1fxt",
    neutral: "_1wyc1gvk",
    inverse: "_1wyc5a6q",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $d8ba32128f2dfe06$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $d8ba32128f2dfe06$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $d8ba32128f2dfe06$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $d8ba32128f2dfe06$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
function $d8ba32128f2dfe06$export$f827d3c5a9c3f644(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$size = _ref.size, size = _ref$size === void 0 ? 'small' : _ref$size, svg = _ref.svg, customThemeSvg = _ref.customThemeSvg, label = _ref.label, userDefinedTestId = _ref.testId, customIconColor = _ref.iconColor, customTextColor = _ref.textColor, _ref$isDataCenter = _ref.isDataCenter, isDataCenter = _ref$isDataCenter === void 0 ? false : _ref$isDataCenter;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    var isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
    return /*#__PURE__*/ $91i6m.createElement("span", {
        style: {
            // Nav v3 passes in "inherit" incorrectly for iconColor, so we fall back to textColor when this happens.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor === 'inherit' ? customTextColor : customIconColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-text-color': customTextColor || 'inherit'
        },
        "data-testid": testId,
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $9gzWK.default)([
            $d8ba32128f2dfe06$var$styles.root,
            // Setting the color so that the SVG can inherit the correct text color using "currentColor"
            $d8ba32128f2dfe06$var$logoTextColorMap[colorMode !== null && colorMode !== void 0 ? colorMode : 'light'],
            $d8ba32128f2dfe06$var$sizeMap[size],
            colorMode === 'dark' ? $d8ba32128f2dfe06$var$textDarkAppearanceMap[appearance] : $d8ba32128f2dfe06$var$textLightAppearanceMap[appearance],
            isDataCenter ? colorMode === 'dark' ? $d8ba32128f2dfe06$var$dataCenterDarkAppearanceMap[appearance] : $d8ba32128f2dfe06$var$dataCenterLightAppearanceMap[appearance] : colorMode === 'dark' ? $d8ba32128f2dfe06$var$cloudDarkAppearanceMap[appearance] : $d8ba32128f2dfe06$var$cloudLightAppearanceMap[appearance]
        ])
    });
}

});


parcelRegister("lO9wW", function(module, exports) {

$parcel$export(module.exports, "AlignIcon", function () { return $fe05a90034df1855$export$70a0c2f5862937b6; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::267cad59c76b16aeee5f58cfa4a1f733>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $fe05a90034df1855$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M18.545 18.545a4.49 4.49 0 0 0-4.48-4.48h-4.13v-3.78h-4.48v7.434c0 .576.25.826.826.826zM5.455 5.455a4.454 4.454 0 0 0 4.455 4.48h4.155v3.78h4.48V6.28q0-.825-.826-.826z\"/>\n</svg>\n";
function $fe05a90034df1855$export$70a0c2f5862937b6(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Align' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $fe05a90034df1855$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("10SeM", function(module, exports) {

$parcel$export(module.exports, "AlignLogoCS", function () { return $0bcfdcf1273bc2c4$export$8b5103382c06639c; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::56bacfcde6f81799eb41bc2261641230>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $0bcfdcf1273bc2c4$var$svg = "<svg height=\"100%\" viewBox=\"0 0 106 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M105.76 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-19.6 7.75v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52M68.73 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-2.54-.03c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM49.6 21.32c-1.53 0-3.1-.18-4.82-.52l-1.69 4.54H40l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.68 7.43 45.6 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M23.735 23.735c0-2.928-2.396-5.295-5.295-5.295h-4.88v-4.466H8.265v8.785c0 .68.296.976.976.976zM8.265 8.265c0 2.928 2.337 5.295 5.265 5.295h4.91v4.466h5.295V9.241q0-.976-.976-.976z\"/>\n</svg>\n";
function $0bcfdcf1273bc2c4$export$8b5103382c06639c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Align' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $0bcfdcf1273bc2c4$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("lJ0FX", function(module, exports) {

$parcel$export(module.exports, "AnalyticsIcon", function () { return $fd0e531ca3d4ae8a$export$af3460f51ce3602a; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::62d7ed5486f2fde4ab85bad091e6130c>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $fd0e531ca3d4ae8a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.63 5.88v9.19h3.06v-9.2zM5.88 18.13h11.81v-1.75H5.87zm0-3.07v-4.81h3.06v4.81zm4.37-6.56v6.56h3.06V8.5z\"/>\n</svg>\n";
function $fd0e531ca3d4ae8a$export$af3460f51ce3602a(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Analytics' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $fd0e531ca3d4ae8a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8Lejx", function(module, exports) {

$parcel$export(module.exports, "AnalyticsLogoCS", function () { return $660dd0ff01f22c44$export$f0bac2b7ac3e3504; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c346421b23be4892d11f5300b3f9b8f0>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $660dd0ff01f22c44$var$svg = "<svg height=\"100%\" viewBox=\"0 0 161 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M160.66 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.6 1.41v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M129.13 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-7.46-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-14.12 3.77h-1.72L100.77 10h2.82l4.91 13.13L113.41 10h2.82l-5.8 14.84c-1.72 4.39-2.7 6.66-6.59 6.66-1.32 0-2.05-.12-2.82-.43V28.8c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.81m-7.8.94c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM79.5 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM74.1 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-24.66 4.97c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.5 7.83v12.25h4.08V7.83zM7.83 24.17h15.75v-2.33H7.83zm0-4.09v-6.42h4.08v6.42zm5.84-8.75v8.75h4.08v-8.75z\"/>\n</svg>\n";
function $660dd0ff01f22c44$export$f0bac2b7ac3e3504(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Analytics' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $660dd0ff01f22c44$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("eMcuJ", function(module, exports) {

$parcel$export(module.exports, "AssetsIcon", function () { return $ac1f3d8f1a98a774$export$d89497e7f33ca6f5; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7e353680649504e5005ac163dde6655>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $ac1f3d8f1a98a774$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z\"/>\n</svg>\n";
var $ac1f3d8f1a98a774$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM7.432 14.704a2.273 2.273 0 1 0 .001 4.547 2.273 2.273 0 0 0-.001-4.547m9.545 0a2.274 2.274 0 1 0 .001 4.548 2.274 2.274 0 0 0 0-4.548m-6.364 1.364v1.819h3.183v-1.819zM7.887 4.25a3.637 3.637 0 0 0-1.365 7.009v2.537h1.819v-2.302a3.64 3.64 0 0 0 3.153-3.153h2.302V6.522h-2.537A3.64 3.64 0 0 0 7.887 4.25m8.181 6.363v3.183h1.819v-3.183zm.91-5.454a2.273 2.273 0 1 0 0 4.547 2.273 2.273 0 0 0 0-4.547M7.887 6.522a1.364 1.364 0 1 1-.002 2.729 1.364 1.364 0 0 1 .002-2.729\"/>\n</svg>\n";
function $ac1f3d8f1a98a774$export$d89497e7f33ca6f5(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Assets' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $ac1f3d8f1a98a774$var$svg,
        customThemeSvg: $ac1f3d8f1a98a774$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("1T8Y8", function(module, exports) {

$parcel$export(module.exports, "AssetsLogoCS", function () { return $1601e28a829bf00b$export$81c47abe19675c4c; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2b2c2f81dcecc713953841df3ebcde68>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $1601e28a829bf00b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M125.8 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.77-.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.5c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.13-3.56c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63-.01c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-22.22.15c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M11.667 15.425a4.335 4.335 0 0 0 3.758-3.758h2.742V9.5h-3.023A4.335 4.335 0 1 0 9.5 15.144v3.023h2.167zm-.542-2.675a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M24.67 10.58a2.71 2.71 0 1 1-5.42 0 2.71 2.71 0 0 1 5.42 0M10.58 24.67a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m11.38 0a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m-3.79-3.79h-3.79v2.17h3.79zm2.71-6.5v3.79h2.17v-3.79z\"/>\n</svg>\n";
function $1601e28a829bf00b$export$81c47abe19675c4c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Assets' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $1601e28a829bf00b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jpPzg", function(module, exports) {

$parcel$export(module.exports, "BambooIcon", function () { return $e2285a6d4e663ac9$export$e812398311cab9a3; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e235764598011d7e6fcb75b2257be900>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $e2285a6d4e663ac9$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M9.215 12.652a2.75 2.75 0 0 0 2.749 2.742v4.205a6.964 6.964 0 0 1-6.849-5.727l-.049-.317zm9.26 0a.44.44 0 0 1 .436.468c-.222 3.311-2.783 5.989-6.043 6.414l-.904-4.14a2.75 2.75 0 0 0 2.723-2.37.44.44 0 0 1 .44-.372zM11.963 9.91a2.75 2.75 0 0 0-2.748 2.742H5v-.065c.033-3.495 2.668-6.374 6.059-6.816zm0-5.972a.436.436 0 0 1 .72-.33l4.824 4.138a.436.436 0 0 1 0 .662l-4.823 4.139a.436.436 0 0 1-.72-.331z\"/>\n</svg>\n";
function $e2285a6d4e663ac9$export$e812398311cab9a3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bamboo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $e2285a6d4e663ac9$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("hMg4N", function(module, exports) {

$parcel$export(module.exports, "BambooLogoCS", function () { return $cf1363cc8feb87c8$export$7c51958462d750e; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4be588a359814839f3a38a10b8622b63>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $cf1363cc8feb87c8$var$svg = "<svg height=\"100%\" viewBox=\"0 0 154 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M146 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-16.68 13.49c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-12.07 5.52c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-21.58-8.82v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.23-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M12.287 16.869a3.665 3.665 0 0 0 3.665 3.656v5.607c-4.71 0-8.602-3.52-9.196-8.06zm12.347 0a.584.584 0 0 1 .581.624c-.295 4.415-3.71 7.986-8.057 8.554l-1.206-5.521a3.67 3.67 0 0 0 3.63-3.161.59.59 0 0 1 .589-.496zm-8.683-3.656a3.664 3.664 0 0 0-3.665 3.656h-5.62v-.088c.044-4.66 3.557-8.498 8.078-9.088zm0-7.964a.58.58 0 0 1 .96-.44l6.432 5.518c.27.232.27.65 0 .883l-6.431 5.517a.581.581 0 0 1-.96-.44z\"/>\n</svg>\n";
function $cf1363cc8feb87c8$export$7c51958462d750e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bamboo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $cf1363cc8feb87c8$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("hv0nR", function(module, exports) {

$parcel$export(module.exports, "BitbucketIcon", function () { return $cbd5a11e73a7c7c6$export$5fc1066e677788d4; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a48cd0ac1ce9dea97cb133dca9e33de4>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $cbd5a11e73a7c7c6$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582\"/>\n</svg>\n";
var $cbd5a11e73a7c7c6$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.821 6c-.345 0-.54.238-.475.604l1.75 10.813c.065.367.324.583.691.583h8.426c.367 0 .627-.216.691-.583l.994-6.065c.065-.366-.065-.582-.497-.582h-2.917c-.302 0-.518.13-.561.453l-.41 2.59c-.022.086-.087.15-.173.15h-2.68c-.086 0-.151-.064-.173-.15l-.583-3.583c-.021-.129.044-.194.152-.194h7.431c.39 0 .627-.173.692-.583l.475-2.849c.065-.366-.13-.604-.475-.604z\"/>\n</svg>\n";
function $cbd5a11e73a7c7c6$export$5fc1066e677788d4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $cbd5a11e73a7c7c6$var$svg,
        customThemeSvg: $cbd5a11e73a7c7c6$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("hkak9", function(module, exports) {

$parcel$export(module.exports, "BitbucketLogoCS", function () { return $c9cc500e266fa45e$export$f7ef5e5488e4b430; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d54637b0b2f479c52492d2d0abf8bb82>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $c9cc500e266fa45e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 166 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.4-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.17-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.27 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.69 5.43z\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.029.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.572 0 .743.285.657.771\"/>\n</svg>\n";
function $c9cc500e266fa45e$export$f7ef5e5488e4b430(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $c9cc500e266fa45e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2kp1J", function(module, exports) {

$parcel$export(module.exports, "BitbucketDataCenterIcon", function () { return $1b20dcd614d8aa46$export$d3ab16bbf4f954ee; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b1a960d2db34ca3f44ef8828b3815ae>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $1b20dcd614d8aa46$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"m17.843 11.763-.986 6.024c-.065.365-.322.58-.686.58H7.81c-.365 0-.622-.215-.686-.58L5.387 7.047c-.064-.364.129-.6.472-.6h12.262c.343 0 .536.236.472.6l-.472 2.83c-.064.407-.3.579-.686.579h-7.374c-.107 0-.172.064-.15.193l.579 3.558c.021.086.085.15.171.15h2.658c.086 0 .15-.064.172-.15l.407-2.572c.043-.322.257-.45.558-.45h2.894c.428 0 .557.214.493.578\"/>\n</svg>\n";
function $1b20dcd614d8aa46$export$d3ab16bbf4f954ee(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $1b20dcd614d8aa46$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jE7aB", function(module, exports) {

$parcel$export(module.exports, "BitbucketDataCenterLogoCS", function () { return $e4d7508978625123$export$cc55e2a4c4b40552; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4d6df504ec1dfd9f26a50f8d7e45924c>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $e4d7508978625123$var$svg = "<svg height=\"100%\" viewBox=\"0 0 166 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.85-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.39-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.028.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.571 0 .743.285.657.771\"/>\n</svg>\n";
function $e4d7508978625123$export$cc55e2a4c4b40552(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $e4d7508978625123$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8bbo8", function(module, exports) {

$parcel$export(module.exports, "ChatIcon", function () { return $5f482f4443569a1d$export$52cd484a7ef4f2b9; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ae2d6061a51a6b69522551138415fa2a>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $5f482f4443569a1d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.125 16.5h8.125V6H5.75v13zM12 12.125a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75m4-.875a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0m-7.125.875a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $5f482f4443569a1d$export$52cd484a7ef4f2b9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $5f482f4443569a1d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bajjP", function(module, exports) {

$parcel$export(module.exports, "ChatLogoCS", function () { return $820f9d31d3d33122$export$a529e78951cd6709; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f10c9ed117b987aa620e842ad4c67da2>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $820f9d31d3d33122$var$svg = "<svg height=\"100%\" viewBox=\"0 0 102 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M97.51 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.94-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.1-8.98v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.65m-16.22 5.43v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M24.167 21.834h-10.5l-5.833 3.5v-17.5h16.333zm-12.25-5.833a1.167 1.167 0 1 0 0-2.334 1.167 1.167 0 0 0 0 2.334M16 16a1.167 1.167 0 1 0 0-2.334A1.167 1.167 0 0 0 16 16m5.25-1.167a1.167 1.167 0 1 1-2.334 0 1.167 1.167 0 0 1 2.333 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $820f9d31d3d33122$export$a529e78951cd6709(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $820f9d31d3d33122$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2AO3x", function(module, exports) {

$parcel$export(module.exports, "CompassIcon", function () { return $1e35c5acda5aea8d$export$f7857fe64d7161d9; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ec19b3c26d91498312286db03f0eb4ea>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $1e35c5acda5aea8d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z\"/>\n</svg>\n";
function $1e35c5acda5aea8d$export$f7857fe64d7161d9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Compass' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $1e35c5acda5aea8d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("htUaT", function(module, exports) {

$parcel$export(module.exports, "CompassLogoCS", function () { return $cba0b83a8f1ebd53$export$a16f50a81d183ce; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5bc93a13860fb0293d95e675d91c82c4>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $cba0b83a8f1ebd53$var$svg = "<svg height=\"100%\" viewBox=\"0 0 162 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.79 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63 0c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-25.9-3.49c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01v-2.7h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97M89.5 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.83c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.69 15.16v4.24h-4.25v-4.24zv-4.24H8.93a.74.74 0 0 0-.74.74v11.25a.74.74 0 0 0 .74.75h11.26a.74.74 0 0 0 .75-.74v-7.76zm0-8.48v4.24h4.26v4.24h4.24V7.42a.74.74 0 0 0-.73-.75h-.01z\"/>\n</svg>\n";
function $cba0b83a8f1ebd53$export$a16f50a81d183ce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Compass' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $cba0b83a8f1ebd53$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("amdEi", function(module, exports) {

$parcel$export(module.exports, "ConfluenceIcon", function () { return $78a68bd7e3cd8101$export$68f3db7f6af48bcb; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9d74d7ecef16716d9233a75661d1c4ae>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $78a68bd7e3cd8101$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673\"/>\n</svg>\n";
var $78a68bd7e3cd8101$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-7.032 12.217c-1.997 0-3.699.83-5.219 3.165l-.249.38c-.204.315-.25.427-.25.562s.068.247.317.404l2.565 1.594c.136.09.249.135.362.135.136 0 .227-.068.363-.27l.409-.628c.635-.966 1.202-1.28 1.928-1.28.636 0 1.384.18 2.315.63l2.677 1.256c.273.134.568.067.704-.247l1.27-2.783c.136-.315.045-.517-.272-.674-4.039-1.953-5.219-2.244-6.92-2.244m4.538-6.667c-.136 0-.227.067-.363.27l-.409.628c-.635.965-1.202 1.28-1.928 1.28-.636 0-1.384-.18-2.315-.63L7.813 5.843c-.272-.135-.567-.067-.703.247L5.84 8.872c-.136.314-.045.517.272.674 4.039 1.953 5.219 2.244 6.92 2.244 1.997 0 3.699-.83 5.219-3.165l.249-.382c.204-.314.25-.426.25-.56s-.068-.248-.317-.405l-2.565-1.593c-.136-.09-.249-.135-.362-.135\"/>\n</svg>\n";
function $78a68bd7e3cd8101$export$68f3db7f6af48bcb(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $78a68bd7e3cd8101$var$svg,
        customThemeSvg: $78a68bd7e3cd8101$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("4DkwG", function(module, exports) {

$parcel$export(module.exports, "ConfluenceLogoCS", function () { return $35faba055c3d77f5$export$a88b0b0da9ef63ce; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dddd2bd68cfa97eb485c03553f4e24d7>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $35faba055c3d77f5$var$svg = "<svg height=\"100%\" viewBox=\"0 0 188 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.51-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.24 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.442 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.083.302.388.494l3.135 1.948c.167.11.305.165.444.165.166 0 .277-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.692.22 2.83.768l3.273 1.537c.333.165.693.083.86-.302l1.553-3.403c.167-.384.056-.63-.333-.823M8.761 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.305-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.691 8.29c-.167-.11-.306-.165-.444-.165-.167 0-.278.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.693-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302l-1.554 3.403c-.166.384-.055.63.333.823\"/>\n</svg>\n";
function $35faba055c3d77f5$export$a88b0b0da9ef63ce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $35faba055c3d77f5$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("ei0jF", function(module, exports) {

$parcel$export(module.exports, "ConfluenceDataCenterIcon", function () { return $a672fded1d3d134a$export$53305f1f2855d3be; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a14a00c887df7cd127b285246b99735>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $a672fded1d3d134a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M17.37 14.265c-3.704-1.79-4.785-2.058-6.346-2.058-1.83 0-3.391.761-4.785 2.902l-.229.35c-.187.288-.229.39-.229.514s.063.227.292.37l2.35 1.462c.125.083.23.124.333.124.125 0 .208-.062.333-.247l.375-.577c.582-.885 1.102-1.173 1.768-1.173.583 0 1.27.165 2.122.577l2.455 1.152c.25.124.52.062.645-.226l1.165-2.552c.125-.289.042-.474-.25-.618M6.572 9.757c3.703 1.791 4.785 2.059 6.346 2.059 1.83 0 3.39-.762 4.785-2.902l.229-.35c.187-.288.228-.391.228-.515 0-.123-.062-.226-.29-.37l-2.352-1.462c-.125-.082-.229-.123-.333-.123-.125 0-.208.061-.333.247l-.374.576c-.583.885-1.103 1.173-1.769 1.173-.582 0-1.269-.164-2.122-.576L8.132 6.361c-.25-.123-.52-.061-.645.227L6.322 9.14c-.125.288-.041.473.25.617\"/>\n</svg>\n";
function $a672fded1d3d134a$export$53305f1f2855d3be(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $a672fded1d3d134a$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("4MxUx", function(module, exports) {

$parcel$export(module.exports, "ConfluenceDataCenterLogoCS", function () { return $37b5f32083f8b343$export$b3e508cb103e1f93; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::247f612d885273d5ec9340d29cd5314f>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $37b5f32083f8b343$var$svg = "<svg height=\"100%\" viewBox=\"0 0 188 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.5-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.23 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.2-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.441 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.084.302.389.494l3.134 1.948c.167.11.306.165.444.165.167 0 .278-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.693.22 2.83.768l3.273 1.537c.333.165.694.083.86-.302l1.554-3.403c.166-.384.055-.63-.333-.823M8.762 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.306-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.69 8.29c-.167-.11-.305-.165-.444-.165-.166 0-.277.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.692-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302L8.43 12.187c-.167.384-.056.63.332.823\"/>\n</svg>\n";
function $37b5f32083f8b343$export$b3e508cb103e1f93(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $37b5f32083f8b343$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("27LtN", function(module, exports) {

$parcel$export(module.exports, "CrowdIcon", function () { return $18c110a6f1185be7$export$eaf73f391f7103bd; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::737475caba8467007ea15db78e7ae272>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $18c110a6f1185be7$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M18.71 7.463 12 4.993l-6.71 2.47a.44.44 0 0 0-.29.433l.14 3.807c.103 3.148 1.684 5.489 4.163 7.018a.446.446 0 0 0 .646-.204l1.445-3.412a.22.22 0 0 0-.14-.298 2.585 2.585 0 1 1 1.492 0 .22.22 0 0 0-.14.298l1.446 3.412a.446.446 0 0 0 .645.204c2.48-1.529 4.06-3.87 4.163-7.018L19 7.896a.44.44 0 0 0-.29-.433\"/>\n</svg>\n";
function $18c110a6f1185be7$export$eaf73f391f7103bd(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Crowd' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $18c110a6f1185be7$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("i5lh8", function(module, exports) {

$parcel$export(module.exports, "CrowdLogoCS", function () { return $d2a9327a5f6f15af$export$3c371bdbcdfcdce; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c40fab6689e9bdd9624e2a214b20ab71>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $d2a9327a5f6f15af$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M113.97 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.72 0h-3.37l-2.64-7.42-1.41-4.72-1.41 4.72-2.64 7.42h-3.37L84.45 10h2.91l4.42 13 4.48-13h2.51l4.48 13 4.41-13h2.91zm-28.47.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.77 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-5.76 5.48v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M24.946 9.951 16 6.657 7.054 9.95a.59.59 0 0 0-.387.577l.187 5.076c.137 4.197 2.245 7.319 5.55 9.357.31.19.719.063.86-.272l1.928-4.55a.294.294 0 0 0-.185-.396 3.447 3.447 0 1 1 1.987 0 .294.294 0 0 0-.185.397l1.927 4.549c.142.335.55.463.86.272 3.305-2.038 5.413-5.16 5.55-9.357l.187-5.076a.59.59 0 0 0-.387-.577\"/>\n</svg>\n";
function $d2a9327a5f6f15af$export$3c371bdbcdfcdce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Crowd' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $d2a9327a5f6f15af$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2i9G1", function(module, exports) {

$parcel$export(module.exports, "CustomerServiceManagementIcon", function () { return $1ab4c4d7557b1593$export$6da5aa77c402ba0f; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf714453512d29992419d0b1472039ec>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $1ab4c4d7557b1593$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z\"/>\n</svg>\n";
var $1ab4c4d7557b1593$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.238 14.751a3.25 3.25 0 0 1-1.762.516 3.25 3.25 0 0 1-1.762-.515L6.4 18.533V19H12a6.97 6.97 0 0 0 4.43-1.58zM6.58 7.571A6.97 6.97 0 0 0 5 12a6.97 6.97 0 0 0 1.58 4.43l2.669-2.668A3.25 3.25 0 0 1 8.733 12c0-.649.19-1.253.516-1.762zm8.172 2.667c.326.508.515 1.113.515 1.762s-.189 1.254-.515 1.762l2.668 2.668A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43zM12 5a6.97 6.97 0 0 0-4.43 1.58l2.668 2.668A3.25 3.25 0 0 1 12 8.733c.649 0 1.253.19 1.762.516L16.43 6.58A6.97 6.97 0 0 0 12 5\"/>\n</svg>\n";
function $1ab4c4d7557b1593$export$6da5aa77c402ba0f(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Customer Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $1ab4c4d7557b1593$var$svg,
        customThemeSvg: $1ab4c4d7557b1593$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("dUVQv", function(module, exports) {

$parcel$export(module.exports, "CustomerServiceManagementLogoCS", function () { return $a21d604d0c5ab93e$export$f597f0f7fadce0b9; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8071dd02178137151c85fefeeccfbf6a>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $a21d604d0c5ab93e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 456 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M451.86 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.08-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.51-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M234.91 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.24 0h-3.53L217.69 10h2.76l4.97 13.09L230.36 10h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.65 2.45 6.65 6.07m-26.4-3.5v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H146.5c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.15-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M94.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45H94.1zm-6.7.58c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.89 2.79v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M21.91 23.23a9.3 9.3 0 0 1-5.91 2.1H8.53v-.62l5.12-5.04a4.34 4.34 0 0 0 2.35.69c.86 0 1.67-.25 2.35-.69zm1.32-1.32a9.3 9.3 0 0 0 2.1-5.91c0-2.24-.79-4.3-2.11-5.91l-3.56 3.56c.43.68.69 1.48.69 2.35s-.25 1.67-.69 2.35zM21.91 8.77l-3.56 3.56a4.34 4.34 0 0 0-2.35-.69c-.86 0-1.67.25-2.35.69l-3.56-3.56A9.3 9.3 0 0 1 16 6.67c2.24 0 4.3.79 5.91 2.11M8.77 10.09A9.3 9.3 0 0 0 6.67 16c0 2.24.79 4.3 2.11 5.91l3.56-3.56a4.34 4.34 0 0 1-.69-2.35c0-.86.25-1.67.69-2.35z\"/>\n</svg>\n";
function $a21d604d0c5ab93e$export$f597f0f7fadce0b9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Customer Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $a21d604d0c5ab93e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("tQUNw", function(module, exports) {

$parcel$export(module.exports, "FocusIcon", function () { return $059bc16204775f04$export$1e02e7298035a77c; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc3eeb7d4cfaf5ff93494f75e1a18082>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $059bc16204775f04$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M20.84 12.21a4.29 4.29 0 0 0-6.05 0l-1.394 1.393c-.77.769-2.02.769-2.789 0L9.45 12.445 6.424 15.47l1.158 1.158a6.25 6.25 0 0 0 8.838 0zm-17.68-.418a4.253 4.253 0 0 0 6.034.017l1.412-1.412a1.973 1.973 0 0 1 2.788 0l1.158 1.158 3.026-3.025-1.158-1.158a6.25 6.25 0 0 0-8.838 0l-4.42 4.419z\"/>\n</svg>\n";
function $059bc16204775f04$export$1e02e7298035a77c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Focus' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $059bc16204775f04$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("56rbZ", function(module, exports) {

$parcel$export(module.exports, "FocusLogoCS", function () { return $3b729b1e3aa65633$export$3a6e8b37e069a69d; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fde58bf2e05397b9d002acff853fdc38>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $3b729b1e3aa65633$var$svg = "<svg height=\"100%\" viewBox=\"0 0 117 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.03 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.71 3.58v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M64.6 25.64c-4.6 0-7.3-3.4-7.3-8S60 9.7 64.6 9.7c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.97 5.67h-9.14v7.51h-2.76V5.19h12.94v2.64H45.49v7.36h9.14z\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M27.607 16.272c-2.176-2.176-5.712-2.152-7.865 0l-1.812 1.812c-1 1-2.625 1-3.625 0L12.8 16.578l-3.933 3.934 1.505 1.505a8.126 8.126 0 0 0 11.49 0zm-22.982-.541c2.176 2.175 5.668 2.196 7.844.02l1.834-1.834c1-1 2.625-1 3.625 0l1.505 1.505 3.934-3.933-1.505-1.505a8.126 8.126 0 0 0-11.49 0l-5.745 5.745z\"/>\n</svg>\n";
function $3b729b1e3aa65633$export$3a6e8b37e069a69d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Focus' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $3b729b1e3aa65633$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("4jw7D", function(module, exports) {

$parcel$export(module.exports, "GoalsIcon", function () { return $3241da90f805a932$export$9eb74917ea768ed4; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::396f70864944722c3ba43a8857b797aa>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $3241da90f805a932$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $3241da90f805a932$export$9eb74917ea768ed4(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Goals' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $3241da90f805a932$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("kRIsr", function(module, exports) {

$parcel$export(module.exports, "GoalsLogoCS", function () { return $f30b3e49c8e6a66d$export$c527a545aa426db3; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0681058b5d17f20f830a057d776b5aa3>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $f30b3e49c8e6a66d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 116 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M115.55 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.12 4.13c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M58.71 24.2c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.36 16a3.36 3.36 0 1 1-6.72 0 3.36 3.36 0 0 1 6.72 0\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M16 25.375a9.375 9.375 0 1 0 0-18.75 9.375 9.375 0 1 0 0 18.75M21.86 16a5.86 5.86 0 1 1-11.72 0 5.86 5.86 0 0 1 11.72 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $f30b3e49c8e6a66d$export$c527a545aa426db3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Goals' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $f30b3e49c8e6a66d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("ewdTe", function(module, exports) {

$parcel$export(module.exports, "GuardIcon", function () { return $a91ed410c05b9548$export$3f95fcfdc25a741d; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9cb16fe47b2bb06a618d6f42235f4d0b>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $a91ed410c05b9548$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649\"/>\n</svg>\n";
function $a91ed410c05b9548$export$3f95fcfdc25a741d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $a91ed410c05b9548$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8TU1e", function(module, exports) {

$parcel$export(module.exports, "GuardLogoCS", function () { return $67aee9f136c838f1$export$2b896c4d595a4331; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f601744ebb3feb381ec2bc379ecb922e>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $67aee9f136c838f1$var$svg = "<svg height=\"100%\" viewBox=\"0 0 120 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M108.4 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.8-9.04v9.05H96.7V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.86 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-27.42-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-3.98 5.21c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M8.188 14.644h15.623c.449 0 .688-.24.688-.688V8.688c0-.449-.24-.688-.688-.688h-3.292c-.45 0-.689.24-.689.688v2.664h-1.496V8.688c0-.449-.24-.688-.688-.688h-3.293c-.448 0-.688.24-.688.688v2.664H12.17V8.688c0-.449-.24-.688-.689-.688H8.188c-.449 0-.688.24-.688.688v5.268c0 .449.24.688.688.688m.27 4.609a10.4 10.4 0 0 1-.599-2.993c-.03-.389.15-.598.569-.598H23.57c.42 0 .599.18.599.538q-.09 1.662-.629 3.053c-.18.479-.448.688-.957.688H9.415c-.508 0-.778-.21-.957-.688m13.856 2.484c-1.436 1.766-3.8 2.903-6.314 2.903s-4.939-1.137-6.345-2.903c-.36-.479-.18-.778.18-.778h12.33c.359 0 .538.3.15.778\"/>\n</svg>\n";
function $67aee9f136c838f1$export$2b896c4d595a4331(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $67aee9f136c838f1$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("3kHWf", function(module, exports) {

$parcel$export(module.exports, "HomeIcon", function () { return $26d55298f55f7047$export$92c8767b874048d; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f4789b6ef9b66e17e85ce46edd0e20b5>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $26d55298f55f7047$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.875 10.688v7.437h4.375V13.75h3.5v4.375h4.375v-7.437L12 5z\"/>\n</svg>\n";
function $26d55298f55f7047$export$92c8767b874048d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Home' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $26d55298f55f7047$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("63PMX", function(module, exports) {

$parcel$export(module.exports, "HomeLogoCS", function () { return $469b32056607671f$export$8b6b7f1b1b2367d3; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8f31fca5cffff624ab8dfe2f380f4c6a>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $469b32056607671f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 121 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M113.57 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM93.3 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.33 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M56.41 5.19h2.76v20.15h-2.76v-8.71H45.8v8.71h-2.76V5.19h2.76v8.8h10.61z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M7.25 14.125V24.75h6.25V18.5h5v6.25h6.25V14.125L16 6z\"/>\n</svg>\n";
function $469b32056607671f$export$8b6b7f1b1b2367d3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Home' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $469b32056607671f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("1epFg", function(module, exports) {

$parcel$export(module.exports, "HubIcon", function () { return $0e5b01aed5b30faf$export$80b8b269d8b5014e; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::826142130c83ecce3a55557ab8c9ff78>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $0e5b01aed5b30faf$var$svg = "<svg height=\"100%\" viewBox=\"0 0 32 32\">\n    <g clip-path=\"url(#clip0_95164_16219)\">\n        <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n        <g clip-path=\"url(#clip1_95164_16219)\">\n            <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z\" clip-rule=\"evenodd\"/>\n        </g>\n    </g>\n    <defs>\n        <clipPath id=\"clip0_95164_16219\">\n            <path fill=\"var(--icon-color, white)\" d=\"M0 0h32v32H0z\"/>\n        </clipPath>\n        <clipPath id=\"clip1_95164_16219\">\n            <path fill=\"var(--icon-color, white)\" d=\"M2 2h28v28H2z\"/>\n        </clipPath>\n    </defs>\n</svg>\n";
function $0e5b01aed5b30faf$export$80b8b269d8b5014e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $0e5b01aed5b30faf$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8c991", function(module, exports) {

$parcel$export(module.exports, "HubLogoCS", function () { return $5f7689a724a90638$export$7a38180641471460; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::742f94652f61dfd860aacb3fafe2261c>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $5f7689a724a90638$var$svg = "<svg height=\"100%\" viewBox=\"0 0 95 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M91.61 17.67c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-24.52-6.64V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65M56.4 5.19h2.76v20.15H56.4v-8.71H45.79v8.71h-2.76V5.19h2.76v8.8H56.4z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $5f7689a724a90638$export$7a38180641471460(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $5f7689a724a90638$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("k11P2", function(module, exports) {

$parcel$export(module.exports, "JiraIcon", function () { return $e925507b1433cda2$export$c4b5b1f965d8b3eb; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::349400291f8d779d7f120565198fb274>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $e925507b1433cda2$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z\"/>\n</svg>\n";
var $e925507b1433cda2$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM4.321 12.434c0 1.782 1.425 3 3.412 3h1.319v1.326c0 2 1.188 3.433 2.959 3.433v-7.129c0-.369-.238-.63-.605-.63zm3.5-3.52c0 1.781 1.425 2.977 3.412 2.977h1.318v1.326c0 2 1.21 3.433 2.98 3.433V9.521c0-.369-.259-.608-.626-.608zm3.52-3.544c0 1.782 1.426 3 3.413 3h1.317v1.304c0 2 1.188 3.433 2.96 3.433V5.98c0-.348-.238-.609-.605-.609z\"/>\n</svg>\n";
function $e925507b1433cda2$export$c4b5b1f965d8b3eb(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $e925507b1433cda2$var$svg,
        customThemeSvg: $e925507b1433cda2$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("iVV0H", function(module, exports) {

$parcel$export(module.exports, "JiraLogoCS", function () { return $dc89c5e64b15a018$export$bf4c5f97b468e8d6; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e76e8b0984e9a10157b3a2965f276eb>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $dc89c5e64b15a018$var$svg = "<svg height=\"100%\" viewBox=\"0 0 83 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M11.965 20.698h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.423 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.503 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.7zm4.818-4.82h-1.803c-2.72 0-4.67-1.665-4.67-4.104h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z\"/>\n</svg>\n";
function $dc89c5e64b15a018$export$bf4c5f97b468e8d6(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $dc89c5e64b15a018$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("4mTYt", function(module, exports) {

$parcel$export(module.exports, "JiraDataCenterIcon", function () { return $32e4a2d2f2343c89$export$f8455b5667a3ee0c; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be11a29c939ff0f2a727a12285a62df7>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $32e4a2d2f2343c89$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M8.974 15.523H7.62c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.647v7.317c-1.817 0-3.036-1.472-3.036-3.525zm3.591-3.636h-1.352c-2.04 0-3.503-1.227-3.503-3.056h7.272c.376 0 .642.245.642.625v7.317c-1.817 0-3.059-1.473-3.059-3.525zm3.614-3.614h-1.353c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.624v7.318c-1.817 0-3.036-1.473-3.036-3.525z\"/>\n</svg>\n";
function $32e4a2d2f2343c89$export$f8455b5667a3ee0c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $32e4a2d2f2343c89$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("k0DNU", function(module, exports) {

$parcel$export(module.exports, "JiraDataCenterLogoCS", function () { return $e912aefb41ede792$export$3224b07bc93ef23e; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2149e3bf372f0515252a5e78dec7c590>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $e912aefb41ede792$var$svg = "<svg height=\"100%\" viewBox=\"0 0 83 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M11.965 20.699h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.424 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.502 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.699zm4.818-4.819h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z\"/>\n</svg>\n";
function $e912aefb41ede792$export$3224b07bc93ef23e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $e912aefb41ede792$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("3oPBA", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryIcon", function () { return $279ba4b0ef01bf15$export$21bfbeb62fdcce8d; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4986587aa74e2199c5aaa284b753e478>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $279ba4b0ef01bf15$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#c97cf4)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z\"/>\n</svg>\n";
var $279ba4b0ef01bf15$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-5.981 5.604a6.387 6.387 0 0 0-6.394 6.394 6.373 6.373 0 0 0 6.394 6.377c3.532 0 6.41-2.854 6.41-6.377v-.563H14.19v.3c0 1.39-.97 2.412-2.171 2.413a2.154 2.154 0 0 1-2.156-2.168c0-1.197.973-2.148 2.332-2.148h.353v-4.21c-.177-.018-.353-.018-.53-.018m6.87-.722a9.47 9.47 0 0 1-5.422 0c-.141-.035-.265.07-.212.228.477 1.85.477 3.559 0 5.409-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.56 0-5.409.034-.158-.072-.263-.23-.228\"/>\n</svg>\n";
function $279ba4b0ef01bf15$export$21bfbeb62fdcce8d(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Product Discovery' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $279ba4b0ef01bf15$var$svg,
        customThemeSvg: $279ba4b0ef01bf15$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("kglpC", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryLogoCS", function () { return $ec05e94bab2c1bc3$export$602140a6a10b02bf; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::21e7556cd73294fd9a2b8ada6433a2bb>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $ec05e94bab2c1bc3$var$svg = "<svg height=\"100%\" viewBox=\"0 0 327 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M317.88 24.35h-1.72L310.62 10h2.82l4.91 13.13 4.9-13.13h2.82l-5.8 14.84c-1.72 4.39-2.7 6.65-6.59 6.65-1.32 0-2.06-.12-2.82-.43v-2.27c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.82m-13.25-8.05v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.72.6h-3.53L268.87 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.39 10.42v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-13.88-1.42c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.7-15.22c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zM207.68 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-13.41-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-14.99-1.32c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.78 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84h-4.02v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14h-3.71v8.28zm-27.87 1.56c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#c97cf4)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M17.448 6.967c2.544.746 5.113.746 7.656 0 .225-.05.375.1.325.323-.724 2.612-.724 5.025 0 7.637.05.199-.1.373-.325.298a14.3 14.3 0 0 0-7.656 0c-.2.075-.374-.1-.3-.298.674-2.612.674-5.025 0-7.637-.074-.223.1-.373.3-.323m1.023 9.253v.423c0 1.965-1.372 3.408-3.068 3.408a3.04 3.04 0 0 1-3.043-3.06c0-1.691 1.372-3.034 3.292-3.034h.5V8.012c-.25-.025-.5-.025-.749-.025a9.02 9.02 0 0 0-9.028 9.03c0 4.999 4.04 9.004 9.028 9.004s9.053-4.03 9.053-9.005v-.796z\"/>\n</svg>\n";
function $ec05e94bab2c1bc3$export$602140a6a10b02bf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Product Discovery' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $ec05e94bab2c1bc3$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5JE8t", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementIcon", function () { return $42d049d2ff3742b7$export$3c6158790f5e01c4; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a167626b0cdea243238150a218b626f1>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $42d049d2ff3742b7$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z\"/>\n</svg>\n";
var $42d049d2ff3742b7$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.256 10.156-2.481 3.12c-1.694 2.129-1.912 5.047.402 6.891l7.16-8.837c.42-.52.185-1.174-.503-1.174zm-8.619 2.348c-.419.52-.183 1.174.504 1.174h4.577l2.465-3.136c1.677-2.146 1.928-5.03-.386-6.875z\"/>\n</svg>\n";
function $42d049d2ff3742b7$export$3c6158790f5e01c4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $42d049d2ff3742b7$var$svg,
        customThemeSvg: $42d049d2ff3742b7$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8d7hN", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementLogoCS", function () { return $5fa5307f9851cd0c$export$de148263c75d2bc1; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e9309f3b1cc7fb1643e1f60f1ab07da>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $5fa5307f9851cd0c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 372 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M18.268 13.604h5.951c.894 0 1.199.85.654 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.523-8.959zm-4.6 4.577h-5.95c-.894 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z\"/>\n</svg>\n";
function $5fa5307f9851cd0c$export$de148263c75d2bc1(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $5fa5307f9851cd0c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("llTTU", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementDataCenterIcon", function () { return $f8b6ebdca595122c$export$65fae0eaf343f2ca; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::785b520448be5254a616c00701ca6073>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $f8b6ebdca595122c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 25 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M14.117 10.203h4.464c.67 0 .899.637.49 1.144l-6.98 8.616c-2.257-1.798-2.044-4.643-.393-6.72zm-3.45 3.433H6.205c-.67 0-.899-.638-.49-1.144l6.981-8.617c2.256 1.799 2.011 4.61.376 6.704z\"/>\n</svg>\n";
function $f8b6ebdca595122c$export$65fae0eaf343f2ca(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $f8b6ebdca595122c$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("4wSwT", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementDataCenterLogoCS", function () { return $34c472fe621934dd$export$f64bc7a7f04428d0; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf181e1edfa57dcb5b7463f70781d820>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $34c472fe621934dd$var$svg = "<svg height=\"100%\" viewBox=\"0 0 372 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.17-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M18.268 13.604h5.95c.895 0 1.2.85.655 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.524-8.959zm-4.6 4.577h-5.95c-.895 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z\"/>\n</svg>\n";
function $34c472fe621934dd$export$f64bc7a7f04428d0(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $34c472fe621934dd$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("4RMyC", function(module, exports) {

$parcel$export(module.exports, "LoomIcon", function () { return $38b1c71f2e60b699$export$8d789f76fde3e05; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::55187565d76d0ab70107b394d5174d9a>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $38b1c71f2e60b699$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302\"/>\n</svg>\n";
function $38b1c71f2e60b699$export$8d789f76fde3e05(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $38b1c71f2e60b699$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8uRw8", function(module, exports) {

$parcel$export(module.exports, "LoomLogoCS", function () { return $62faa38075332fbe$export$78c0b4d8be34c9b2; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ad3119cedd34de3d960e5ccfcb794468>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $62faa38075332fbe$var$svg = "<svg height=\"100%\" viewBox=\"0 0 103 32\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19\"/>\n</svg>\n";
function $62faa38075332fbe$export$78c0b4d8be34c9b2(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $62faa38075332fbe$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("brFNI", function(module, exports) {

$parcel$export(module.exports, "LoomAttributionLogoCS", function () { return $8552a420e92267b8$export$68d7391318cdef11; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e1ee46dc9ada114b6751598218ceaa3>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $8552a420e92267b8$var$svg = "<svg height=\"100%\" viewBox=\"0 0 100 32\">\n    <path fill=\"var(--icon-color, #101214)\" d=\"M66.71 5.11c0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82 0 .39-.26.62-1.08.62-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.06 0 2.85-.92 2.85-2.26m0 .03c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.5c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16m26.29-2.11v7.32h1.57V4.81l.64 1.46 2.21 4.11h1.95V3.06h-1.54v4.73l-.59-1.39-1.77-3.34zm-9.91 0h-1.7v7.32h1.7zM79.45 8.2c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.47c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16 0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82s-.26.62-1.08.62c-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.03 0 2.85-.92 2.85-2.29M53.5 3.06v7.32h3.49l.54-1.59h-2.34V3.06zm-6.91 0v1.57h1.88v5.75h1.72V4.63h2.03V3.06zm-2.49 0h-2.24l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95c-.03 0-2.57-7.32-2.57-7.32m-1.13 4.75c-.33 0-.64-.05-.93-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m20.06-4.75H60.8l-2.57 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zM61.9 7.81c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m27.32-4.75h-2.23l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zm-1.11 4.75c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19a3.7 3.7 0 0 1-.92.13\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.664-1.775-1.025-2.692 4.664V7.125h-2.048v5.385l-2.694-4.664-1.774 1.025 2.693 4.663-4.664-2.692-1.024 1.774 4.664 2.693H6.958v2.048h5.385L7.68 20.05l1.024 1.775 4.663-2.693-2.692 4.664 1.774 1.024 2.693-4.664v5.386h2.049v-5.385l2.692 4.663 1.774-1.024-2.692-4.664 4.663 2.693 1.025-1.775-4.664-2.692h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.594 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M39.32 27.74v-13.7h2.52v13.7zm24.13-9.31h2.4v1.14c.51-.91 1.7-1.4 2.72-1.4 1.27 0 2.29.55 2.76 1.55.74-1.14 1.72-1.55 2.95-1.55 1.72 0 3.37 1.04 3.37 3.54v6.04h-2.44v-5.53c0-1-.49-1.76-1.65-1.76-1.08 0-1.72.83-1.72 1.84v5.45h-2.49v-5.53c0-1-.51-1.76-1.65-1.76-1.1 0-1.74.81-1.74 1.84v5.45h-2.52zm-15.93 9.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.05 4.93-4.89 4.93m0-7.58a2.65 2.65 0 0 0-2.65 2.65 2.65 2.65 0 0 0 2.65 2.65c1.46 0 2.65-1.19 2.65-2.65a2.65 2.65 0 0 0-2.65-2.65m10.26 7.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.06 4.93-4.89 4.93m0-7.61a2.69 2.69 0 0 0-2.68 2.68 2.69 2.69 0 0 0 2.68 2.68 2.69 2.69 0 0 0 2.68-2.68 2.69 2.69 0 0 0-2.68-2.68\"/>\n</svg>\n";
function $8552a420e92267b8$export$68d7391318cdef11(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom Attribution' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $8552a420e92267b8$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bZxlZ", function(module, exports) {

$parcel$export(module.exports, "LoomInternalIcon", function () { return $8baf438e36818a36$export$38c7b37a3e5e8d70; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c3dabecb5c666d4b59916374e96299a4>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $8baf438e36818a36$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#625df5)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302\"/>\n</svg>\n";
function $8baf438e36818a36$export$38c7b37a3e5e8d70(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $8baf438e36818a36$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2PAY8", function(module, exports) {

$parcel$export(module.exports, "LoomInternalLogoCS", function () { return $20fd0578e34ecbba$export$71743a944cb62e48; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa2c5f0b3386bcf846320a0b87a8366d>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $20fd0578e34ecbba$var$svg = "<svg height=\"100%\" viewBox=\"0 0 103 32\">\n    <path fill=\"var(--tile-color,#625df5)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19\"/>\n</svg>\n";
function $20fd0578e34ecbba$export$71743a944cb62e48(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $20fd0578e34ecbba$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2l7kX", function(module, exports) {

$parcel$export(module.exports, "OpsgenieIcon", function () { return $1b433beb4edd32ad$export$eeccc49dc7a12d9f; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::579928a7702ff0666940203a9d4c2681>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $1b433beb4edd32ad$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.696 19.45c-.49.361-.749.336-1.24-.026-2.375-1.704-4.57-3.641-6.042-5.655-.155-.207-.078-.49.155-.62l2.685-1.678q.35-.233.62.077c1.033 1.188 2.04 2.35 3.202 3.176 1.162-.826 2.17-1.988 3.202-3.176q.272-.31.62-.078l2.686 1.679c.232.13.31.413.155.62-1.472 2.014-3.667 3.95-6.043 5.68m-.62-7.411c2.118 0 3.874-1.73 3.874-3.848s-1.756-3.9-3.874-3.9c-2.117 0-3.873 1.757-3.873 3.9s1.704 3.848 3.873 3.848\"/>\n</svg>\n";
function $1b433beb4edd32ad$export$eeccc49dc7a12d9f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Opsgenie' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $1b433beb4edd32ad$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8kcAq", function(module, exports) {

$parcel$export(module.exports, "OpsgenieLogoCS", function () { return $60f9f463a1a6aedf$export$a5b9122e89b32ad3; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a5a07e9eb7981952db2c58f3810afe1d>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $60f9f463a1a6aedf$var$svg = "<svg height=\"100%\" viewBox=\"0 0 164 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M156.69 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM143.39 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-3.68-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.47-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.06 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-4.72 3.52c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-16.29-3.49c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3.01v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-20.11.01c-6.22 0-9.72-4.29-9.72-10.43 0-6.07 3.5-10.33 9.72-10.33 6.2 0 9.69 4.26 9.69 10.34 0 6.13-3.5 10.43-9.69 10.43m0-18.12c-4.97 0-6.96 3.53-6.96 7.7 0 4.26 1.99 7.79 6.96 7.79 4.94 0 6.93-3.53 6.93-7.79 0-4.17-1.99-7.7-6.93-7.7\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.905 25.684c-.638.47-.974.437-1.612-.033-3.088-2.216-5.942-4.734-7.855-7.352-.202-.269-.1-.638.201-.806l3.491-2.182q.454-.302.806.1c1.343 1.545 2.652 3.056 4.163 4.13 1.51-1.074 2.82-2.585 4.163-4.13q.352-.402.805-.1l3.491 2.182c.303.168.403.537.202.806-1.914 2.618-4.767 5.136-7.855 7.385m-.806-9.635c2.753 0 5.035-2.249 5.035-5.001s-2.282-5.07-5.035-5.07-5.036 2.283-5.036 5.07c0 2.786 2.216 5.001 5.036 5.001\"/>\n</svg>\n";
function $60f9f463a1a6aedf$export$a5b9122e89b32ad3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Opsgenie' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $60f9f463a1a6aedf$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("kFMs3", function(module, exports) {

$parcel$export(module.exports, "ProjectsIcon", function () { return $f0cd386d70c84bc0$export$5ed3e1bb3b04fc02; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ae4772cca6d16bf931ca75f21c37faa7>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $f0cd386d70c84bc0$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $f0cd386d70c84bc0$export$5ed3e1bb3b04fc02(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Projects' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $f0cd386d70c84bc0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2EhPn", function(module, exports) {

$parcel$export(module.exports, "ProjectsLogoCS", function () { return $1edd2568c36c6649$export$e3d1678155aaab99; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7c130a24674470d1e95cd4899b5e3ca4>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $1edd2568c36c6649$var$svg = "<svg height=\"100%\" viewBox=\"0 0 145 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M144.54 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.75-.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M99.43 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM83.8 31.25v-2.36c.31.03.49.03.77.03 1.13 0 2.05-.49 2.05-1.87V10h2.64v17.36c0 2.82-1.59 4.02-4.11 4.02-.67 0-1.13-.06-1.35-.12m2.3-25.3c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84M76.07 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M62.3 16.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84H45.8v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14H45.8v8.28z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m6.152 19.486 2.651-2.652-2.651-2.651 2.21-2.21h5.303l3.977-3.977h6.187v6.187l-3.977 3.977v5.304l-2.21 2.21-2.652-2.652-2.651 2.651-2.429-2.428 3.978-3.978-1.326-1.325-3.978 3.977zM20.736 13.3a1.562 1.562 0 1 1-2.21-2.21 1.562 1.562 0 0 1 2.21 2.21\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $1edd2568c36c6649$export$e3d1678155aaab99(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Projects' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $1edd2568c36c6649$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("3LpE3", function(module, exports) {

$parcel$export(module.exports, "RovoIcon", function () { return $2bd9a774fd7805ea$export$e23ae35269442b4f; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::07c05c6e89f5723f7d7ed853987d71b5>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $2bd9a774fd7805ea$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M11.057 5.257a1.57 1.57 0 0 1 1.539.015l4.621 2.668c.484.279.783.797.783 1.354v5.336a1.56 1.56 0 0 1-.782 1.355l-3.474 2.005a2 2 0 0 0 .12-.691v-5.337c0-.733-.39-1.409-1.026-1.774l-2.59-1.495V6.626q.001-.246.074-.473c.117-.364.366-.68.707-.877z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.881 5.94 6.408 7.945A1.56 1.56 0 0 0 5.625 9.3v5.337c0 .557.3 1.075.783 1.354l4.621 2.668c.475.274 1.06.279 1.539.015l.027-.019a1.57 1.57 0 0 0 .781-1.35v-2.067l-2.589-1.495a2.05 2.05 0 0 1-1.026-1.775V6.631a2 2 0 0 1 .12-.691\"/>\n</svg>\n";
function $2bd9a774fd7805ea$export$e23ae35269442b4f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $2bd9a774fd7805ea$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("knH1D", function(module, exports) {

$parcel$export(module.exports, "RovoLogoCS", function () { return $ed6754975e5d817f$export$b0e15f0a1c9f4c55; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8f364ea0f6c471d2cbba8f708f2339a3>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $ed6754975e5d817f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 106 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M98.36 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.87 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896q.017-.046.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682.17-.527.529-.983 1.021-1.267h.002z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1\"/>\n</svg>\n";
function $ed6754975e5d817f$export$b0e15f0a1c9f4c55(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $ed6754975e5d817f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("cOk7p", function(module, exports) {

$parcel$export(module.exports, "SearchIcon", function () { return $9539c2ad5f9ce676$export$82eafebb825fc23f; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::71c7de2e30885b9e09669c8ade78e25c>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $9539c2ad5f9ce676$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M5 10.688a5.69 5.69 0 0 0 5.697 5.687c1.01 0 1.958-.262 2.78-.723L16.832 19 19 16.834l-3.347-3.341c.471-.828.74-1.785.74-2.806A5.69 5.69 0 0 0 10.697 5 5.69 5.69 0 0 0 5 10.688m2.191 0c0 1.932 1.57 3.5 3.506 3.5a3.503 3.503 0 0 0 3.505-3.5c0-1.933-1.57-3.5-3.505-3.5a3.503 3.503 0 0 0-3.506 3.5\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $9539c2ad5f9ce676$export$82eafebb825fc23f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $9539c2ad5f9ce676$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("1zM2S", function(module, exports) {

$parcel$export(module.exports, "SearchLogoCS", function () { return $125e542bb089087c$export$fa08cbfe393f2a68; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::517d90ad09bfbbd541d369d01d058e01>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $125e542bb089087c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 130 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M128.82 16.35v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.04 6.21v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-18.23-6.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-17.87 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10H88v15.33zM65.08 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M7.127 14.833a7.583 7.583 0 0 0 11.286 6.62l4.464 4.464 2.887-2.888-4.455-4.455a7.583 7.583 0 1 0-14.181-3.74m2.917 0a4.667 4.667 0 1 0 9.333 0 4.667 4.667 0 0 0-9.333 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $125e542bb089087c$export$fa08cbfe393f2a68(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $125e542bb089087c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("dLAVA", function(module, exports) {

$parcel$export(module.exports, "StatuspageIcon", function () { return $a05c4f3b7001d59a$export$f3f5aa321d88adf9; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d9b6abfb98a7cc46c15cd5bb68394677>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $a05c4f3b7001d59a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12 9.796c-1.924 0-3.796.832-5.324 2.118q-.238.227-.475.227c-.132 0-.263-.076-.369-.202L3.908 9.771c-.105-.126-.158-.252-.158-.353 0-.151.08-.277.237-.429C6.307 7.023 9.127 5.914 12 5.914s5.693 1.109 8.013 3.075c.158.152.237.278.237.429 0 .1-.053.227-.158.353l-1.924 2.168c-.106.126-.238.202-.37.202q-.236 0-.474-.227c-1.529-1.286-3.4-2.118-5.324-2.118m0 8.118c-2.135 0-3.875-1.664-3.875-3.68 0-2.018 1.74-3.682 3.875-3.682s3.875 1.64 3.875 3.681-1.74 3.68-3.875 3.68\"/>\n</svg>\n";
function $a05c4f3b7001d59a$export$f3f5aa321d88adf9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Statuspage' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $a05c4f3b7001d59a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("b50SW", function(module, exports) {

$parcel$export(module.exports, "StatuspageLogoCS", function () { return $8110d91ef17e32c9$export$2bc88a281410ffa7; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::336995adb994a3066957c7690d8c9207>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $8110d91ef17e32c9$var$svg = "<svg height=\"100%\" viewBox=\"0 0 192 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M184.96 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-10.55-4.47c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.61-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19H85V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.95-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.26-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M15.896 13.196c-2.464 0-4.86 1.114-6.817 2.835q-.303.304-.607.304c-.169 0-.338-.102-.473-.27l-2.463-2.902c-.135-.17-.202-.338-.202-.473 0-.202.1-.371.303-.573C8.607 9.484 12.217 8 15.896 8c3.678 0 7.29 1.484 10.259 4.117.202.202.303.37.303.573 0 .135-.067.304-.202.473l-2.463 2.902c-.135.168-.304.27-.473.27q-.303 0-.607-.304c-1.958-1.721-4.353-2.835-6.817-2.835m0 10.867c-2.733 0-4.96-2.228-4.96-4.927 0-2.7 2.227-4.927 4.96-4.927s4.96 2.193 4.96 4.927-2.227 4.927-4.96 4.927\"/>\n</svg>\n";
function $8110d91ef17e32c9$export$2bc88a281410ffa7(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Statuspage' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $8110d91ef17e32c9$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("kGYji", function(module, exports) {

$parcel$export(module.exports, "StudioIcon", function () { return $f10683403a380b50$export$290a0f24614cde9f; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::44318da2d694177bf3151a9c722c2f2d>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $f10683403a380b50$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M10.7 11.222V19h7.8v-7.778z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.6 7.609 10.05 5 5.5 7.609v5.217l3.64 2.087V9.667h5.46z\"/>\n</svg>\n";
function $f10683403a380b50$export$290a0f24614cde9f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $f10683403a380b50$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("abATu", function(module, exports) {

$parcel$export(module.exports, "StudioLogoCS", function () { return $76a78cd922bd74a5$export$273fd56580e523ae; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a3132618c94e271e59382f742ada531>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $76a78cd922bd74a5$var$svg = "<svg height=\"100%\" viewBox=\"0 0 124 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.71 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.48-6.2c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-15.3-7.66c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-27.41-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.17 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.125 14.125V24.75H24.75V14.125z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.75 9.594 13.5 6 7.25 9.594v7.187l5 2.875V12.25h7.5z\"/>\n</svg>\n";
function $76a78cd922bd74a5$export$273fd56580e523ae(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $76a78cd922bd74a5$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8w8PR", function(module, exports) {

$parcel$export(module.exports, "TalentIcon", function () { return $63382a6eecc87c02$export$4b05688514531169; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::46e5325ca16a481422af5c181121030b>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $63382a6eecc87c02$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m9.297 8.753 2.277-5.073h.858l2.277 5.073 5.529.598.265.816-4.121 3.734 1.14 5.442-.695.505-4.824-2.766-4.824 2.766-.695-.505 1.14-5.442-4.121-3.733.265-.817zm.777 6.415v-.678a1.857 1.857 0 0 1 3.715 0v.613a3.6 3.6 0 0 1-1.886.548h-.053a3.6 3.6 0 0 1-1.776-.483m1.858-3.134a1.393 1.393 0 1 0 0-2.786 1.393 1.393 0 0 0 0 2.786\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $63382a6eecc87c02$export$4b05688514531169(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Talent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $63382a6eecc87c02$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5xGD1", function(module, exports) {

$parcel$export(module.exports, "TalentLogoCS", function () { return $409119ed76e73490$export$1b3979d995ebbc6e; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8453468a68143782cf5c56d6264718dc>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $409119ed76e73490$var$svg = "<svg height=\"100%\" viewBox=\"0 0 122 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M117.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H82.4c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-14.47.57c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m16.577 4.907 3.035 6.763 7.372.797.354 1.09-5.495 4.977 1.52 7.257-.927.672-6.431-3.687-6.433 3.687-.926-.672 1.52-7.257-5.495-4.978.353-1.089 7.372-.797 3.035-6.763zm-.668 11.936a2.476 2.476 0 0 0-2.476 2.477v.904a4.8 4.8 0 0 0 2.369.644h.07a4.8 4.8 0 0 0 2.514-.73v-.818a2.477 2.477 0 0 0-2.477-2.477m0-4.511a1.857 1.857 0 1 0 0 3.714 1.857 1.857 0 0 0 0-3.714\"/>\n</svg>\n";
function $409119ed76e73490$export$1b3979d995ebbc6e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Talent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $409119ed76e73490$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("pQ3JL", function(module, exports) {

$parcel$export(module.exports, "TeamsIcon", function () { return $04dab7cd3cb481ce$export$1bcbc9c337da86da; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::46ca108d2593b6c24c5abbf971640ec4>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $04dab7cd3cb481ce$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63\"/>\n</svg>\n";
function $04dab7cd3cb481ce$export$1bcbc9c337da86da(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Teams' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $04dab7cd3cb481ce$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("fJnmE", function(module, exports) {

$parcel$export(module.exports, "TeamsLogoCS", function () { return $b73d2eabdd543c11$export$bfd8d1c4da84ce71; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9a85bb219158de09803b052bf9eb845b>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $b73d2eabdd543c11$var$svg = "<svg height=\"100%\" viewBox=\"0 0 127 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M126.58 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-24.66-4.36v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.33.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM61.99 12.08c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H57.55c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M10.75 14.83a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m10.5 0a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.23 1.75a3.86 3.86 0 0 1 3.86 3.86v3.72h-9.62l2.21-5.23a3.86 3.86 0 0 1 3.55-2.35M6.67 20.67v3.5h6.42l1.75-4.08a3.5 3.5 0 0 0-3.5-3.5h-.58a4.08 4.08 0 0 0-4.08 4.08\"/>\n</svg>\n";
function $b73d2eabdd543c11$export$bfd8d1c4da84ce71(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Teams' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $b73d2eabdd543c11$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("20Q2J", function(module, exports) {

$parcel$export(module.exports, "TrelloIcon", function () { return $1773f3845b0a278f$export$4384da9b8b140bf4; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::05385a6d8a6e0950a657f507588ba895>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $2AmSr = parcelRequire("2AmSr");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $1773f3845b0a278f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1558bc)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z\"/>\n</svg>\n";
var $1773f3845b0a278f$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.379 4.43a.95.95 0 0 0-.948.949v11.907c0 .523.424.948.948.948H9.39a.95.95 0 0 0 .947-.948V5.38a.95.95 0 0 0-.947-.948zm9.23 0a.95.95 0 0 0-.947.949v6.44c0 .523.423.948.947.949h4.012a.95.95 0 0 0 .948-.949V5.38a.95.95 0 0 0-.948-.948z\"/>\n</svg>\n";
function $1773f3845b0a278f$export$4384da9b8b140bf4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Trello' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2AmSr.IconWrapper), {
        svg: $1773f3845b0a278f$var$svg,
        customThemeSvg: $1773f3845b0a278f$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("kUYj6", function(module, exports) {

$parcel$export(module.exports, "TrelloLogoCS", function () { return $f3a7d156881ea8a1$export$1b13139dfc0336af; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e1b148b0e17835d1d6cc0b45cfa57fe0>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $91i6m = parcelRequire("91i6m");

var $iBDkU = parcelRequire("iBDkU");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $f3a7d156881ea8a1$var$svg = "<svg height=\"100%\" viewBox=\"0 0 113 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M104.97 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M96.21 25.3c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-8 0c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM72.86 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H68.42c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.48-8.44v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#1558bc)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M12.9 24c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H8.13C7.51 8 7 8.49 7 9.1v13.8c0 .61.5 1.1 1.13 1.1zm10.97-6.34c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H19.1c-.62 0-1.13.49-1.13 1.1v7.47c0 .61.5 1.1 1.13 1.1z\"/>\n</svg>\n";
function $f3a7d156881ea8a1$export$1b13139dfc0336af(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Trello' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iBDkU.LogoWrapper), {
        svg: $f3a7d156881ea8a1$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("aql3A", function(module, exports) {

$parcel$export(module.exports, "AtlassianAdminIcon", function () { return $796caa85a30fde24$export$84109e099492cb5f; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $796caa85a30fde24$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $796caa85a30fde24$export$84109e099492cb5f = function AtlassianAdminIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Admin' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        svg: $796caa85a30fde24$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("2qkU7", function(module, exports) {

$parcel$export(module.exports, "AtlassianAdminLogo", function () { return $1c3e399612d203b0$export$f845d9b9254f0541; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $1c3e399612d203b0$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 295 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M294.31 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $1c3e399612d203b0$export$f845d9b9254f0541 = function AtlassianAdminLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Admin' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $1c3e399612d203b0$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("kEQaO", function(module, exports) {

$parcel$export(module.exports, "AtlassianAdministrationIcon", function () { return $f0a0039f391ba776$export$74517ed253186308; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $f0a0039f391ba776$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $f0a0039f391ba776$export$74517ed253186308 = function AtlassianAdministrationIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Administration' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        svg: $f0a0039f391ba776$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("cqVtY", function(module, exports) {

$parcel$export(module.exports, "AtlassianAdministrationLogo", function () { return $90d48092f65735e4$export$833abe6c2ce5ebfd; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $90d48092f65735e4$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 404 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M403.77 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-23.336 9.292c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.57 0 7.237 3.343 7.237 7.943s-2.667 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.489s1.442 5.55 4.723 5.55c3.251 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49zm-13.488-6.195c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-7.461-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.078v2.453h-4.078zm-18.943-2.913c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.637v15.333zm-17.793-9.046v9.046h-2.576V10h2.576v2.699c.89-1.81 2.423-3.098 5.428-2.914v2.576c-3.373-.337-5.428.675-5.428 3.926m-10.037 4.293c0 1.35.797 2.27 2.423 2.27.613 0 1.196-.123 1.656-.215v2.545c-.46.123-.982.245-1.779.245-3.281 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.079v2.453h-4.079zm-6.696.583c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.675-2.974 1.87 0 1.074.736 1.749 3.557 2.423 3.404.828 5.121 2.086 5.121 4.754M297.497 5.952c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-3.678-8.985v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $90d48092f65735e4$export$833abe6c2ce5ebfd = function AtlassianAdministrationLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Administration' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $90d48092f65735e4$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("ZNZqm", function(module, exports) {

$parcel$export(module.exports, "AtlassianAnalyticsIcon", function () { return $0b9c7989013c4f25$export$c42ad8a0b925c762; });

var $91i6m = parcelRequire("91i6m");

var $lD6mB = parcelRequire("lD6mB");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $0b9c7989013c4f25$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return "<svg height=\"32\" viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <linearGradient id=\"".concat(id, "-a\" x1=\"12.595\" x2=\"12.595\" y1=\"40\" y2=\"30\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient id=\"").concat(id, "-b\" x1=\"28.595\" x2=\"28.595\" y1=\"40\" y2=\"27\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient xlink:href=\"#").concat(id, "-b\" id=\"").concat(id, "-c\" x1=\"20.595\" x2=\"20.595\" y2=\"22\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-b\" id=\"").concat(id, "-d\" x1=\"36.595\" x2=\"36.595\" y2=\"20\"/>\n  </defs>\n  <path d=\"M10.595 30h4v10h-4z\" fill=\"url(#").concat(id, "-a)\"/>\n  <path d=\"M26.595 27h4v13h-4z\" fill=\"url(#").concat(id, "-b)\"/>\n  <path d=\"M18.595 22h4v18h-4z\" fill=\"url(#").concat(id, "-c)\"/>\n  <path d=\"M34.595 20h4v20h-4z\" fill=\"url(#").concat(id, "-d)\"/>\n  <path fill=\"").concat(colors.iconColor, "\" d=\"m9.009 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z\" />\n</svg>");
};
var $0b9c7989013c4f25$export$c42ad8a0b925c762 = function AtlassianAnalyticsIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Analytics' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor, testId = _ref2.testId;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $lD6mB.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        label: label,
        svg: $0b9c7989013c4f25$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};

});

parcelRegister("38UZx", function(module, exports) {

$parcel$export(module.exports, "AtlassianAnalyticsLogo", function () { return $249e53cfa4ddcc83$export$e6470bfc39010cc4; });

var $91i6m = parcelRequire("91i6m");

var $lD6mB = parcelRequire("lD6mB");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $249e53cfa4ddcc83$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        textColor: textColor,
        iconColor: iconColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return "\n  <svg height=\"32\" viewBox=\"0 0 477 48\" xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <linearGradient id=\"".concat(id, "-a\" x1=\"447.285\" x2=\"447.285\" y1=\"40\" y2=\"30\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-b\" x1=\"463.285\" x2=\"463.285\" y2=\"27\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-c\" x1=\"455.285\" x2=\"455.285\" y2=\"22\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-d\" x1=\"471.285\" x2=\"471.285\" y2=\"20\"/>\n  </defs>\n  <g fill=\"").concat(colors.atlassianLogoTextColor, "\">\n    <path d=\"M106.72 18.359c0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835m0 0c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445M209.1 10.346v28.455h6.063V17.103l2.556 5.76 8.575 15.938h7.623V10.346h-6.064V28.71l-2.295-5.327-6.886-13.037H209.1zM163.909 10.346h6.626v28.455h-6.626zM156.263 30.399c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445 0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835M55.243 10.346v28.455h13.62l2.145-6.15h-9.095V10.346h-6.67zM28.334 10.346v6.15h7.363v22.305h6.67V16.496h7.882v-6.15H28.334zM18.663 10.346h-8.74L0 38.801h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM92.344 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM194.414 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524Z\"/>\n  </g>\n  <g fill=\"").concat(colors.textColor, "\">\n    <path d=\"m254.776 31.987-2.53 6.809H247.6l11.916-30.225h5.244l11.916 30.225h-4.646l-2.53-6.855c-2.714.552-5.061.828-7.499.828-2.3 0-4.646-.276-7.223-.782Zm13.479-3.496-6.119-16.562-6.119 16.608c2.254.368 4.141.552 5.98.552 1.933 0 3.911-.23 6.257-.598ZM298.984 38.796h-3.957V24.902c0-4.141-1.656-5.981-5.428-5.981-3.681 0-6.211 2.438-6.211 7.085v12.79h-3.957V15.794h3.957v3.772c1.472-2.715 4.187-4.232 7.269-4.232 5.291 0 8.327 3.634 8.327 9.983v13.479ZM320.097 34.656c-1.472 3.036-4.232 4.6-7.775 4.6-6.119 0-9.201-5.199-9.201-11.961 0-6.486 3.22-11.961 9.661-11.961 3.358 0 5.935 1.518 7.314 4.508v-4.048h3.957v23.002h-3.957v-4.14Zm-6.717.92c3.542 0 6.717-2.254 6.717-7.361v-1.84c0-5.106-2.898-7.361-6.256-7.361-4.463 0-6.763 2.944-6.763 8.281 0 5.521 2.208 8.281 6.303 8.281ZM336.196 38.935c-3.772 0-6.165-1.794-6.165-6.027V6.179h3.957v26.269c0 2.07 1.38 2.806 3.083 2.806.414 0 .69 0 1.15-.046v3.542c-.322.092-1.012.184-2.024.184ZM347.328 37.324l-8.327-21.53h4.232l7.361 19.69 7.361-19.69h4.232l-8.695 22.267c-2.576 6.579-4.048 9.983-9.891 9.983-1.979 0-3.083-.184-4.232-.644v-3.404c1.334.414 2.852.552 4.002.552 3.22 0 4.646-2.208 6.533-7.223h-2.576ZM374.698 35.07c.92 0 1.794-.185 2.484-.322v3.818c-.69.184-1.472.368-2.668.368-4.923 0-7.315-2.898-7.315-7.177V19.473h-3.727v-3.68h3.727v-4.877h3.864v4.877h6.119v3.68h-6.119v12.191c0 2.024 1.196 3.405 3.635 3.405ZM384.265 6.961c1.61 0 2.76 1.012 2.76 2.76s-1.15 2.76-2.76 2.76-2.76-1.012-2.76-2.76 1.15-2.76 2.76-2.76Zm-2.024 8.833h3.957v23.002h-3.957V15.794ZM408.416 38.198c-1.38.736-3.496 1.058-5.612 1.058-8.189 0-12.007-4.968-12.007-12.007 0-6.947 3.818-11.915 12.007-11.915 2.07 0 3.68.276 5.475 1.104v3.681c-1.472-.69-3.037-1.104-5.199-1.104-5.98 0-8.419 3.772-8.419 8.235s2.484 8.235 8.511 8.235c2.346 0 3.818-.322 5.244-.828v3.542ZM420.144 39.256c-3.451 0-6.257-.782-8.005-1.702v-4.187c1.978 1.15 5.291 2.254 8.188 2.254 3.037 0 4.601-1.242 4.601-3.036 0-1.749-1.334-2.761-5.705-3.818-5.106-1.242-7.269-3.221-7.269-6.993 0-4.002 3.082-6.44 8.327-6.44 2.99 0 5.705.736 7.407 1.656v4.094c-2.76-1.38-5.014-2.117-7.453-2.117-2.898 0-4.462 1.013-4.462 2.807 0 1.61 1.104 2.622 5.336 3.635 5.106 1.242 7.683 3.128 7.683 7.13 0 3.819-2.484 6.717-8.649 6.717Z\"/>\n  </g>\n  <path fill=\"url(#").concat(id, "-a)\" d=\"M445.285 30h4v10h-4z\"/>\n  <path fill=\"url(#").concat(id, "-b)\" d=\"M461.285 27h4v13h-4z\"/>\n  <path fill=\"url(#").concat(id, "-c)\" d=\"M453.285 22h4v18h-4z\"/>\n  <path fill=\"url(#").concat(id, "-d)\" d=\"M469.285 20h4v20h-4z\"/>\n  <path fill=\"").concat(colors.iconColor, "\" d=\"m443.699 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z\"/>\n</svg>");
};
var $249e53cfa4ddcc83$export$e6470bfc39010cc4 = function AtlassianAnalyticsLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Analytics' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $lD6mB.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        label: label,
        size: size,
        iconColor: iconColor,
        svg: $249e53cfa4ddcc83$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode, id),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("ebq8M", function(module, exports) {

$parcel$export(module.exports, "BitbucketIcon", function () { return $a5365ebfe2b5358e$export$5fc1066e677788d4; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $a5365ebfe2b5358e$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95\"/>\n    </svg>");
};
var $a5365ebfe2b5358e$export$5fc1066e677788d4 = function BitbucketIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Bitbucket' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        label: label,
        svg: $a5365ebfe2b5358e$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("eLzxh", function(module, exports) {

$parcel$export(module.exports, "BitbucketLogo", function () { return $ac01052184300e3e$export$bd40525f5333524b; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $ac01052184300e3e$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 158 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path fill=".concat(colors.iconColor, " d=\"m20.46 15.152-1.619 9.885c-.105.598-.527.95-1.125.95H3.996c-.599 0-1.02-.352-1.126-.95L.02 7.412c-.105-.598.211-.985.774-.985h20.123c.563 0 .88.387.774.985l-.774 4.644c-.106.668-.493.95-1.126.95H7.69c-.176 0-.281.105-.246.316l.95 5.84c.035.141.14.247.281.247h4.363c.14 0 .246-.106.281-.247l.668-4.221c.07-.528.423-.739.915-.739h4.75c.703 0 .914.352.809.95\"/>\n        <path fill=").concat(colors.textColor, " d=\"M153.212 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-13.537-8.494c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-23.82.613h-2.638V3.799h2.638v13.585l6.593-7.176h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.176zm-5.648-2.76v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-27.843-3.588v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.982 1.81-2.79 2.821-4.846 2.821-3.526 0-5.55-2.422-5.55-6.654m-5.388-1.319c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.699h-2.637V3.798h2.637v9.17c.982-2.025 2.822-3.067 5.183-3.067 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-14.974-5.06c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zM53.328 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S56.242 8 55.168 8s-1.84-.676-1.84-1.84m.49 19.38V10.207h2.638V25.54zm-9.828-9.046h-6.194v6.287h6.256c2.637 0 3.833-.951 3.833-2.975 0-2.147-1.134-3.312-3.894-3.312m-.889-8.464h-5.305v6.01h5.305c2.607 0 3.68-1.195 3.68-3.127 0-1.963-1.165-2.883-3.68-2.883m-8.065 17.51V5.394h8.433c4.11 0 6.103 2.024 6.103 5.274 0 2.423-1.104 3.926-3.373 4.478 2.974.49 4.446 2.116 4.446 4.968 0 3.22-2.177 5.428-6.685 5.428z\"/>\n      </svg>");
};
var $ac01052184300e3e$export$bd40525f5333524b = function BitbucketLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Bitbucket' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $ac01052184300e3e$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("aEv9l", function(module, exports) {

$parcel$export(module.exports, "CompassIcon", function () { return $7c15cd848fe41945$export$f7857fe64d7161d9; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $7c15cd848fe41945$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M15.667 15.66v5.942H9.713V15.66zV9.722H4.807c-.58.004-1.047.47-1.043 1.04v15.755a1.04 1.04 0 0 0 1.028 1.054h15.771a1.04 1.04 0 0 0 1.042-1.04V15.66zm0-11.88v5.942h5.967v5.938h5.935V4.82a1.04 1.04 0 0 0-1.028-1.053h-.014z\"/>\n      </svg>\n    ");
};
var $7c15cd848fe41945$export$f7857fe64d7161d9 = function CompassIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Compass' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        label: label,
        svg: $7c15cd848fe41945$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("b9Dmh", function(module, exports) {

$parcel$export(module.exports, "CompassLogo", function () { return $81ef10bbbd4a2d9d$export$eb7d748e4f9c9676; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $81ef10bbbd4a2d9d$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 155 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path fill=".concat(colors.iconColor, " d=\"M11.903 14.993v5.942H5.95v-5.942zV9.055H1.043c-.58.004-1.047.47-1.043 1.04v15.756a1.04 1.04 0 0 0 1.028 1.054H16.8a1.04 1.04 0 0 0 1.043-1.04V14.993zm0-11.879v5.941h5.967v5.938h5.936V4.153A1.04 1.04 0 0 0 22.778 3.1h-.015z\"/>\n    <path fill=\"").concat(colors.textColor, "\" d=\"M154.46 21.37c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.134v-2.791c1.318.767 3.526 1.503 5.458 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.889-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-13.626 0c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.134v-2.791c1.319.767 3.527 1.503 5.459 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.89-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.054-4.293 5.55-4.293 1.994 0 3.803.49 4.938 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.122 2.085 5.122 4.753m-25.873-3.496c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.226c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638v15.334zm-16.09-7.667c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v8.679h-2.637V10.207h2.637v2.76c.982-2.024 2.822-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-21.583-8.832v8.526h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526H69.13V10.207h2.637v2.515c.982-1.81 2.791-2.821 4.846-2.821 2.606 0 4.385 1.318 5.152 3.741.858-2.361 2.913-3.741 5.458-3.741 3.435 0 5.336 2.33 5.336 6.654v8.986h-2.637v-8.526c0-3.158-1.104-4.722-3.619-4.722-2.453 0-4.14 1.625-4.14 4.722m-23.335 8.832c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.942 7.299-7.942c4.57 0 7.237 3.342 7.237 7.942s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49s1.441 5.55 4.723 5.55c3.25 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49m-9.233 9.629v2.668c-1.258.828-3.251 1.196-5.336 1.196-6.624 0-10.366-3.986-10.366-10.334 0-6.134 3.742-10.427 10.304-10.427 1.963 0 3.926.368 5.367 1.41v2.669c-1.441-.92-3.036-1.411-5.367-1.411-4.722 0-7.544 3.128-7.544 7.759s2.914 7.697 7.698 7.697c2.116 0 3.772-.49 5.244-1.227\"/>\n  </svg>");
};
var $81ef10bbbd4a2d9d$export$eb7d748e4f9c9676 = function CompassLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Compass' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $81ef10bbbd4a2d9d$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("k5zT0", function(module, exports) {

$parcel$export(module.exports, "ConfluenceIcon", function () { return $ea001c80645a5a18$export$68f3db7f6af48bcb; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $ea001c80645a5a18$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098\"/>\n    </svg>");
};
var $ea001c80645a5a18$export$68f3db7f6af48bcb = function ConfluenceIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Confluence' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        label: label,
        svg: $ea001c80645a5a18$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("2238H", function(module, exports) {

$parcel$export(module.exports, "ConfluenceLogo", function () { return $17ae3411a40eb446$export$1b2e4fe6ef471556; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $17ae3411a40eb446$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 180 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M20.602 20.234c-6.584-3.183-8.507-3.66-11.281-3.66-3.255 0-6.03 1.355-8.507 5.16l-.407.622c-.333.513-.407.696-.407.915s.111.403.518.659l4.18 2.598c.221.146.406.22.591.22.222 0 .37-.11.592-.44l.666-1.024c1.035-1.574 1.96-2.086 3.144-2.086 1.035 0 2.256.293 3.772 1.025l4.365 2.049c.444.22.925.11 1.146-.403l2.072-4.537c.222-.512.074-.842-.444-1.098M1.406 12.22c6.583 3.184 8.507 3.66 11.28 3.66 3.256 0 6.03-1.354 8.508-5.16l.407-.622c.332-.512.406-.695.406-.915s-.11-.402-.518-.658L17.31 5.927c-.222-.147-.407-.22-.592-.22-.222 0-.37.11-.592.44l-.665 1.024c-1.036 1.573-1.96 2.086-3.144 2.086-1.036 0-2.257-.293-3.773-1.025L4.18 6.183c-.444-.22-.925-.11-1.147.402L.962 11.123c-.222.512-.074.841.444 1.098\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M172.49 12.293c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-15.093-2.147v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-14.503-6.226v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.791-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-22.921-4.262c-2.79 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.441-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.942 7.237-7.942 4.723 0 6.624 3.281 6.624 7.942v1.196h-11.193c.368 2.607 2.054 4.294 5.673 4.294 1.778 0 3.281-.338 4.661-.828zm-29.1-5.734v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.981 1.81-2.791 2.821-4.845 2.821-3.527 0-5.551-2.422-5.551-6.654m-2.231 6.317c-.215.061-.674.122-1.35.122-2.514 0-4.108-1.196-4.108-4.017V3.798h2.637v17.51c0 1.38.92 1.871 2.055 1.871.275 0 .459 0 .766-.03zM88.157 8.582v1.625h3.956v2.454h-3.956v12.88h-2.576V12.66h-2.484v-2.454h2.484V8.521c0-2.852 1.595-4.784 4.876-4.784a6.3 6.3 0 0 1 1.779.245v2.423a8.7 8.7 0 0 0-1.656-.154c-1.626 0-2.423.95-2.423 2.33m-7.327 7.974v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-23.336 9.292c-4.6 0-7.298-3.404-7.298-8.004s2.698-7.942 7.298-7.942c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.493c-3.28 0-4.722 2.576-4.722 5.49s1.441 5.55 4.722 5.55c3.251 0 4.662-2.637 4.662-5.55s-1.41-5.49-4.662-5.49m-9.233 9.629v2.668c-1.257.828-3.25 1.196-5.336 1.196-6.624 0-10.365-3.986-10.365-10.334 0-6.134 3.741-10.427 10.304-10.427 1.963 0 3.925.368 5.367 1.41v2.669c-1.442-.92-3.036-1.411-5.367-1.411-4.723 0-7.544 3.128-7.544 7.759s2.913 7.697 7.697 7.697c2.116 0 3.772-.49 5.244-1.227\"/>\n    </svg>\n    ");
};
var $17ae3411a40eb446$export$1b2e4fe6ef471556 = function ConfluenceLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Confluence' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $17ae3411a40eb446$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("2oUZb", function(module, exports) {

$parcel$export(module.exports, "FocusIcon", function () { return $1bfa06de8243076e$export$1e02e7298035a77c; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $1bfa06de8243076e$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 48 48\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t<path fill=\"".concat(colors.iconColor, "\" d=\"M45.4277 24.5018C41.4108 20.4849 34.8821 20.5276 30.908 24.5018L27.5636 27.8462C25.717 29.6927 22.7177 29.6927 20.8712 27.8462L18.0925 25.0675L10.8309 32.3291L13.6096 35.1078C19.4658 40.9641 28.9654 40.9641 34.8216 35.1078L45.4277 24.5018ZM3 23.5018C7.01684 27.5186 13.4637 27.5578 17.4805 23.5409L20.8676 20.1538C22.7142 18.3073 25.7135 18.3073 27.56 20.1538L30.3387 22.9325L37.6003 15.6709L34.8216 12.8922C28.9654 7.03593 19.4658 7.03593 13.6096 12.8922L3.00356 23.4982L3 23.5018Z\"/>\n\t\t</svg>\n\t\t");
};
var $1bfa06de8243076e$export$1e02e7298035a77c = function FocusIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Focus' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        label: label,
        svg: $1bfa06de8243076e$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("3NcgT", function(module, exports) {

$parcel$export(module.exports, "FocusLogo", function () { return $2c2f7792d9f599aa$export$33908560ea1b226d; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $2c2f7792d9f599aa$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 168 48\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t<path fill=\"".concat(colors.iconColor, "\" d=\"M42.4277 24.5018C38.4108 20.4849 31.8821 20.5276 27.908 24.5018L24.5636 27.8462C22.717 29.6927 19.7177 29.6927 17.8712 27.8462L15.0925 25.0675L7.83088 32.3291L10.6096 35.1078C16.4658 40.9641 25.9654 40.9641 31.8216 35.1078L42.4277 24.5018ZM0 23.5018C4.01684 27.5186 10.4637 27.5578 14.4805 23.5409L17.8676 20.1538C19.7142 18.3073 22.7135 18.3073 24.56 20.1538L27.3387 22.9325L34.6003 15.6709L31.8216 12.8922C25.9654 7.03593 16.4658 7.03593 10.6096 12.8922L0.00355592 23.4982L0 23.5018Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M167.405 31.746C167.405 35.564 164.921 38.462 158.757 38.462C155.307 38.462 152.501 37.68 150.753 36.76V32.574C152.731 33.724 156.043 34.828 158.941 34.828C161.977 34.828 163.541 33.586 163.541 31.792C163.541 30.044 162.207 29.032 157.837 27.974C152.731 26.732 150.569 24.754 150.569 20.982C150.569 16.98 153.651 14.542 158.895 14.542C161.885 14.542 164.599 15.278 166.301 16.198V20.292C163.541 18.912 161.287 18.176 158.849 18.176C155.951 18.176 154.387 19.188 154.387 20.982C154.387 22.592 155.491 23.604 159.723 24.616C164.829 25.858 167.405 27.744 167.405 31.746Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M126.009 28.48V15.002H129.965V28.894C129.965 33.034 131.621 34.874 135.393 34.874C139.073 34.874 141.603 32.436 141.603 27.79V15.002H145.559V38.002H141.603V34.23C140.131 36.944 137.417 38.462 134.335 38.462C129.045 38.462 126.009 34.828 126.009 28.48Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M121.953 33.862V37.404C120.573 38.14 118.457 38.462 116.341 38.462C108.153 38.462 104.335 33.494 104.335 26.456C104.335 19.51 108.153 14.542 116.341 14.542C118.411 14.542 120.021 14.818 121.815 15.646V19.326C120.343 18.636 118.779 18.222 116.617 18.222C110.637 18.222 108.199 21.994 108.199 26.456C108.199 30.918 110.683 34.69 116.709 34.69C119.055 34.69 120.527 34.368 121.953 33.862Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M90.2616 38.462C83.3616 38.462 79.3136 33.356 79.3136 26.456C79.3136 19.556 83.3616 14.542 90.2616 14.542C97.1156 14.542 101.118 19.556 101.118 26.456C101.118 33.356 97.1156 38.462 90.2616 38.462ZM90.2616 18.222C85.3396 18.222 83.1776 22.086 83.1776 26.456C83.1776 30.826 85.3396 34.782 90.2616 34.782C95.1376 34.782 97.2536 30.826 97.2536 26.456C97.2536 22.086 95.1376 18.222 90.2616 18.222Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M75.298 26.732H61.59V38.002H57.45V7.78003H76.862V11.736H61.59V22.776H75.298V26.732Z\"/>\n\t\t</svg>\n\t\t");
};
var $2c2f7792d9f599aa$export$33908560ea1b226d = function FocusLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Focus' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $2c2f7792d9f599aa$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("2hPHy", function(module, exports) {

$parcel$export(module.exports, "GuardIcon", function () { return $1aa54624c67eba65$export$3f95fcfdc25a741d; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $1aa54624c67eba65$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M5.584 14.4h20.83c.599 0 .918-.32.918-.918V6.459c0-.599-.319-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v7.023c0 .599.319.918.917.918zm.36 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.199-.799.758-.799h20.191c.559 0 .798.24.798.719q-.12 2.214-.838 4.07c-.24.638-.598.918-1.277.918H7.221c-.679 0-1.038-.28-1.277-.918m18.475 3.312c-1.915 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.478-.638-.239-1.038.24-1.038h16.44c.48 0 .719.4.2 1.038\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $1aa54624c67eba65$export$3f95fcfdc25a741d = function GuardIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Guard' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        svg: $1aa54624c67eba65$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("2GayE", function(module, exports) {

$parcel$export(module.exports, "GuardLogo", function () { return $1f37b197c227c423$export$a4a891d202775deb; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $1f37b197c227c423$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 114 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M.918 13.733h20.83c.598 0 .918-.32.918-.918V5.792c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.918.32-.918.918v3.551h-1.995V5.792c0-.599-.319-.918-.918-.918H9.139c-.599 0-.918.32-.918.918v3.551H6.225V5.792c0-.599-.32-.918-.918-.918H.917c-.598 0-.917.32-.917.918v7.023c0 .599.32.918.918.918m.359 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.2-.799.758-.799h20.191c.56 0 .799.24.799.719q-.12 2.214-.838 4.07c-.24.638-.599.918-1.277.918H2.554c-.679 0-1.038-.28-1.277-.918m18.476 3.312c-1.916 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.479-.638-.24-1.038.24-1.038h16.44c.479 0 .718.4.2 1.038\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n      <path\n        d=\"M102.398 17.874c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.502 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52zm8.679 7.667v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.466-6.133-7.974 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005V3.798h2.637v21.743zm-17.793-9.047v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925m-17.869 1.381c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.976 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.637v15.333zM56.68 19.193v-8.985h2.637v9.261c0 2.76 1.105 3.987 3.62 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637v15.333h-2.638v-2.514c-.981 1.809-2.79 2.821-4.845 2.821-3.527 0-5.55-2.423-5.55-6.655zm-3.973 5.213c-1.595.951-4.539 1.442-6.808 1.442-6.931 0-10.672-4.232-10.672-10.335 0-6.563 4.262-10.457 11.438-10.457 1.595 0 3.466.184 5.244.797v2.76c-1.533-.613-3.342-.89-5.213-.89-5.98 0-8.71 2.975-8.71 7.729 0 4.661 2.76 7.758 8.557 7.758.95 0 2.269-.092 3.404-.429v-5.612h-5.152v-2.637h7.912z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $1f37b197c227c423$export$a4a891d202775deb = function GuardLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Guard' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $1f37b197c227c423$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("1N7S0", function(module, exports) {

$parcel$export(module.exports, "JiraIcon", function () { return $14e078e0e6f6a689$export$c4b5b1f965d8b3eb; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $14e078e0e6f6a689$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z\"/>\n    </svg>");
};
var $14e078e0e6f6a689$export$c4b5b1f965d8b3eb = function JiraIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        label: label,
        svg: $14e078e0e6f6a689$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("96Oyx", function(module, exports) {

$parcel$export(module.exports, "JiraLogo", function () { return $6a1be3fa0bc2c7b4$export$17d3acb0b4379d02; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $6a1be3fa0bc2c7b4$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 77 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M7.967 21.323H5.748C2.401 21.323 0 19.273 0 16.271h11.933c.618 0 1.018.44 1.018 1.062V29.34c-2.983 0-4.984-2.416-4.984-5.784zm5.894-5.967h-2.22c-3.346 0-5.747-2.013-5.747-5.015h11.932c.618 0 1.055.402 1.055 1.025v12.007c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.22c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.019.439 1.019 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M65.023 17.874c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM55.91 16.493v9.047h-2.577V10.207h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M46.224 6.159c0-1.165.767-1.84 1.84-1.84s1.84.675 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.49 19.381V10.207h2.638V25.54zm-6.427-5.95V5.393h2.76v14.015c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.246-3.312-.522v-2.668c.828.338 1.84.522 2.852.522 2.33 0 3.128-1.41 3.128-3.404\"/>\n    </svg>");
};
var $6a1be3fa0bc2c7b4$export$17d3acb0b4379d02 = function JiraLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $6a1be3fa0bc2c7b4$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("fuOdT", function(module, exports) {

$parcel$export(module.exports, "JiraAlignIcon", function () { return $b4809da128ef1038$export$407687b2dd89cc68; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $b4809da128ef1038$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path\n      fill=\"".concat(colors.iconColor, "\"\n      d=\"M25.52 25.727c0-3.604-2.949-6.517-6.517-6.517h-6.007v-5.497H6.48v10.813c0 .837.364 1.201 1.201 1.201zM6.48 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z\"\n    />\n  </svg>");
};
var $b4809da128ef1038$export$407687b2dd89cc68 = function JiraAlignIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Align' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        label: label,
        svg: $b4809da128ef1038$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("gvsev", function(module, exports) {

$parcel$export(module.exports, "JiraAlignLogo", function () { return $c0457110c65bf831$export$ee11e928d3d045fd; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $c0457110c65bf831$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg viewBox=\"0 0 146 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M19.04 25.727c0-3.604-2.949-6.517-6.517-6.517H6.517v-5.497H0v10.813c0 .837.364 1.201 1.201 1.201zM0 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z\" fill=\"".concat(colors.iconColor, "\"/>\n      <path d=\"M144.993 16.555v8.985h-2.638v-9.26c0-2.76-1.104-3.988-3.618-3.988-2.454 0-4.14 1.626-4.14 4.723v8.525h-2.638V10.207h2.638v2.515c.981-1.81 2.79-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-19.589 7.759V22.78c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.465-6.072-7.973 0-4.324 2.116-7.974 6.379-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.054 5.152-4.906m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.975 0-4.508 1.962-4.508 5.52M107.96 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S110.873 8 109.8 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.638Zm-2.537-.03c-.215.061-.675.122-1.349.122-2.515 0-4.11-1.196-4.11-4.017V3.798h2.638v17.51c0 1.38.92 1.871 2.054 1.871.276 0 .46 0 .767-.03v2.36ZM88.83 21.523c-1.534 0-3.098-.184-4.815-.521l-1.687 4.539h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.57c-1.81.368-3.373.552-4.999.552Zm0-2.453c1.287 0 2.606-.153 4.17-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369Zm-27.807-1.196c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925ZM42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.637Zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404\" fill=\"").concat(colors.textColor, "\"/>\n    </svg>\n  ");
};
var $c0457110c65bf831$export$ee11e928d3d045fd = function JiraAlignLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Align' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $c0457110c65bf831$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("hHOIB", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryIcon", function () { return $ce3dcb6cca81a767$export$21bfbeb62fdcce8d; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $ce3dcb6cca81a767$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M17.655 5.884a15.3 15.3 0 0 0 8.75 0c.257-.056.428.114.37.37-.826 2.985-.826 5.742 0 8.727.058.228-.113.427-.37.342a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.342.77-2.985.77-5.742 0-8.727-.086-.256.114-.426.342-.37m1.169 10.576v.483c0 2.246-1.568 3.894-3.506 3.894a3.474 3.474 0 0 1-3.477-3.496c0-1.933 1.567-3.468 3.762-3.468h.57V7.078c-.285-.028-.57-.028-.855-.028C9.618 7.05 5 11.655 5 17.37c0 5.713 4.617 10.29 10.318 10.29s10.346-4.605 10.346-10.29v-.91z\"/>\n    </svg>");
};
var $ce3dcb6cca81a767$export$21bfbeb62fdcce8d = function JiraProductDiscoveryIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Product Discovery' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        label: label,
        svg: $ce3dcb6cca81a767$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("7IJuQ", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryLogo", function () { return $59efef24858b64be$export$c49a2b642fe9eef4; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $59efef24858b64be$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 318 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M12.655 5.218a15.3 15.3 0 0 0 8.75 0c.257-.057.428.114.37.37-.826 2.984-.826 5.742 0 8.727.058.227-.113.426-.37.341a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.341.77-2.985.77-5.743 0-8.727-.086-.256.114-.427.342-.37m1.169 10.575v.483c0 2.246-1.568 3.895-3.506 3.895a3.474 3.474 0 0 1-3.478-3.497c0-1.933 1.568-3.468 3.763-3.468h.57V6.412c-.285-.028-.57-.028-.855-.028C4.618 6.384 0 10.989 0 16.703s4.617 10.29 10.318 10.29 10.346-4.605 10.346-10.29v-.91z\" />\n      <path fill=\"").concat(colors.textColor, "\" d=\"M308.551 24.559h-1.718l-5.55-14.352h2.821l4.907 13.125 4.906-13.125h2.822l-5.796 14.843c-1.718 4.385-2.699 6.654-6.594 6.654-1.318 0-2.054-.122-2.821-.429v-2.27c.889.277 1.901.369 2.668.369 2.147 0 3.097-1.472 4.355-4.815m-13.247-8.065v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.422-3.097 5.428-2.913v2.576c-3.374-.338-5.428.674-5.428 3.925m-12.464-4.202c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-19.717.613h-3.527l-5.949-15.333h2.76l4.968 13.095 4.937-13.095h2.76zm-17.462.307c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.49 0 2.912 1.442 5.55 4.723 5.55 3.251 0 4.661-2.638 4.661-5.55 0-2.914-1.41-5.49-4.661-5.49M242.16 22.78v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-13.872-1.41c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.41-4.968-1.41-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.422 3.404.828 5.121 2.086 5.121 4.754M210.599 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.491 19.38V10.208h2.637v15.334zM198.344 8.03h-4.539v14.873h4.692c4.6 0 6.9-2.422 6.9-7.298 0-4.907-2.177-7.575-7.053-7.575m-7.299 17.51V5.394h7.422c6.532 0 9.69 4.078 9.69 10.12 0 6.102-3.189 10.028-9.69 10.028zm-13.411-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-6.66 1.993v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-27.843-3.588v-8.985h2.637v9.261c0 2.76 1.104 3.987 3.619 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637V25.54h-2.637v-2.514c-.982 1.809-2.791 2.821-4.846 2.821-3.526 0-5.55-2.423-5.55-6.655m-14.987-1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.667v-2.76c-.981 2.023-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005V3.798h2.637V25.54zm-20.698.306c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49 0 2.912 1.441 5.55 4.723 5.55 3.25 0 4.661-2.638 4.661-5.55 0-2.914-1.411-5.49-4.661-5.49m-13.776 4.14v9.047h-2.576V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-5.002-4.385c0 4.385-2.454 6.838-7.483 6.838h-4.017v6.594h-2.76V5.393h6.777c5.03 0 7.483 2.576 7.483 6.716m-7.79 4.2c3.558.124 4.938-1.563 4.938-4.14 0-2.452-1.38-4.14-4.938-4.14h-3.71v8.28zM61.69 17.874c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.931-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.24 0 3.957 1.012 4.877 3.006v-2.699h2.637V25.54zm-17.793-9.046v9.047H50V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.89 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.805 8 44.73 8s-1.84-.675-1.84-1.84m.491 19.38V10.208h2.638v15.334zm-6.428-5.949V5.393h2.76v14.014c0 3.71-1.625 6.256-5.428 6.256-1.441 0-2.545-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.331 0 3.128-1.41 3.128-3.404\" />\n    </svg>");
};
var $59efef24858b64be$export$c49a2b642fe9eef4 = function JiraProductDiscoveryLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Product Discovery' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $59efef24858b64be$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("gCu52", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementIcon", function () { return $c1978747e9ce4fb8$export$3c6158790f5e01c4; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $c1978747e9ce4fb8$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"M18.79 13.257h7.325c1.1 0 1.476 1.046.805 1.878L15.464 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H5.806c-1.1 0-1.476-1.046-.805-1.878L16.457 2.874c3.702 2.951 3.3 7.566.617 11z\"/>\n    </svg>");
};
var $c1978747e9ce4fb8$export$3c6158790f5e01c4 = function JiraServiceManagementIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Service Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        label: label,
        svg: $c1978747e9ce4fb8$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("1aINS", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementLogo", function () { return $0da97aa18758c228$export$dabef2be6cd28c20; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $0da97aa18758c228$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 362 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"M14.124 13.257h7.325c1.1 0 1.475 1.046.804 1.878L10.798 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H1.138c-1.1 0-1.476-1.046-.805-1.878L11.79 2.874c3.703 2.951 3.3 7.566.617 11z\" />\n      <path fill=").concat(colors.textColor, " d=\"M357.074 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-7.327-4.231v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-26.152-7.912v8.525h-2.637V16.28c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.625-4.14 4.723v8.525h-2.637V10.208h2.637v2.514c.981-1.81 2.79-2.821 4.845-2.821 2.607 0 4.385 1.319 5.152 3.741.859-2.361 2.913-3.741 5.459-3.741 3.434 0 5.336 2.33 5.336 6.655v8.985h-2.638v-8.525c0-3.16-1.104-4.723-3.618-4.723-2.454 0-4.14 1.625-4.14 4.723m-22.921-4.723c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.577-7.943 7.238-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638V25.54zm-14.073-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-28.327 1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-31.445-11.009-2.76-7.482V25.54h-2.76V5.393h4.784l4.569 11.56 1.871 5.552 1.87-5.551 4.6-11.561h4.447V25.54h-2.76V7.263l-2.361 7.268-4.447 11.01h-2.668zm-21.511-2.238c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.148v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.942 8.004-7.942 1.38 0 2.453.184 3.649.736v2.453c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.515-5.612 5.49s1.656 5.489 5.673 5.489c1.564 0 2.546-.215 3.496-.552M140.124 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S143.037 8 141.964 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-8.233 0h-3.527l-5.949-15.332h2.76l4.968 13.094 4.937-13.094h2.76zm-15.455-9.046v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-12.463-4.201c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zM95.024 19.99c0 3.496-2.085 5.857-7.084 5.857-3.894 0-5.704-.766-7.268-1.564v-2.821c1.87.981 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975s-1.104-2.73-4.937-3.65c-4.539-1.103-6.563-2.667-6.563-5.98 0-3.127 2.392-5.458 7.084-5.458 2.914 0 4.784.705 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.845 3.373 4.263 1.073 6.655 2.453 6.655 6.072m-34.001-2.116c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404\" />\n    </svg>");
};
var $0da97aa18758c228$export$dabef2be6cd28c20 = function JiraServiceManagementLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Service Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $0da97aa18758c228$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("9nGna", function(module, exports) {

$parcel$export(module.exports, "LoomIcon", function () { return $6d472162adb32d69$export$8d789f76fde3e05; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $6d472162adb32d69$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsForLoom)(appearance, colorMode);
    return "<svg\n    fill=\"none\"\n    height=\"32\"\n    viewBox=\"0 0 32 32\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    focusable=\"false\"\n    aria-hidden=\"true\"\n  >\n    <path\n      d=\"M27.333 15.508h-6.628l5.74-3.315-1.26-2.184-5.74 3.314 3.313-5.74-2.184-1.26-3.313 5.74V5.434h-2.522v6.628l-3.314-5.74-2.184 1.26 3.314 5.74-5.74-3.314-1.26 2.184 5.74 3.314H4.667v2.521h6.627l-5.74 3.314 1.261 2.184 5.74-3.313-3.314 5.74 2.184 1.26 3.314-5.74V28.1h2.521v-6.627l3.313 5.74 2.184-1.261-3.314-5.74 5.74 3.313 1.261-2.184-5.74-3.313h6.628zM16 20.198a3.442 3.442 0 1 1 0-6.885 3.442 3.442 0 0 1 0 6.884\"\n      fill=\"".concat(colors.iconColor, "\"\n    />\n  </svg>");
};
var $6d472162adb32d69$export$8d789f76fde3e05 = function LoomIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        label: label,
        svg: $6d472162adb32d69$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("5Y0z3", function(module, exports) {

$parcel$export(module.exports, "LoomLogo", function () { return $4582fe679d4214a7$export$94e206806e36c2ec; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $4582fe679d4214a7$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsForLoom)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 98 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M29.657 13.659h-8.672l7.51-4.337-1.649-2.857-7.51 4.336 4.335-7.51-2.857-1.65-4.336 7.51V.479H13.18v8.672l-4.337-7.51-2.856 1.65 4.336 7.51-7.51-4.336-1.65 2.857 7.51 4.336H0v3.299h8.671l-7.51 4.336 1.65 2.858 7.51-4.336-4.336 7.51 2.857 1.65 4.336-7.511v8.672h3.3v-8.671l4.335 7.51 2.857-1.65-4.336-7.51 7.51 4.336 1.65-2.858-7.51-4.335h8.672v-3.3zM14.83 19.794a4.503 4.503 0 1 1 0-9.006 4.503 4.503 0 0 1 0 9.006\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n      <path\n        d=\"M37.303 26.155V4.459h3.983v21.696zm38.204-14.743h3.803v1.798c.808-1.438 2.696-2.218 4.313-2.218 2.007 0 3.624.87 4.373 2.457 1.167-1.798 2.726-2.457 4.673-2.457 2.725 0 5.33 1.648 5.33 5.604v9.559h-3.862v-8.75c0-1.588-.78-2.786-2.607-2.786-1.707 0-2.726 1.318-2.726 2.907v8.63H84.85v-8.75c0-1.59-.808-2.787-2.606-2.787-1.738 0-2.757 1.288-2.757 2.907v8.63h-3.981zm-25.219 15.17c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.251 7.798-7.737 7.798m0-11.996a4.2 4.2 0 0 0-4.197 4.199c0 2.315 1.883 4.199 4.197 4.199s4.196-1.884 4.196-4.2a4.2 4.2 0 0 0-4.196-4.198m16.245 11.996c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.253 7.798-7.737 7.798m0-12.046c-2.34 0-4.245 1.906-4.245 4.247s1.904 4.247 4.245 4.247a4.25 4.25 0 0 0 4.245-4.247 4.25 4.25 0 0 0-4.245-4.247\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $4582fe679d4214a7$export$94e206806e36c2ec = function LoomLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $4582fe679d4214a7$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("zbSjR", function(module, exports) {

$parcel$export(module.exports, "LoomAttributionIcon", function () { return $069c7b2670baef11$export$1bf47cdade1a9fcb; });

var $91i6m = parcelRequire("91i6m");

var $anGZX = parcelRequire("anGZX");

var $9nGna = parcelRequire("9nGna");
var $069c7b2670baef11$export$1bf47cdade1a9fcb = function LoomAttributionIcon(_ref) {
    var appearance = _ref.appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom Attribution' : _ref$label, _ref$size = _ref.size, size = _ref$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref$size, testId = _ref.testId, _ref$iconColor = _ref.iconColor, iconColor = _ref$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref$iconColor, _ref$textColor = _ref.textColor, textColor = _ref$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref$textColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $9nGna.LoomIcon), {
        appearance: appearance,
        label: label,
        size: size,
        testId: testId,
        iconColor: iconColor,
        textColor: textColor
    });
};

});

parcelRegister("8Aorm", function(module, exports) {

$parcel$export(module.exports, "LoomAttributionLogo", function () { return $6404a4dd705933a6$export$6e87ce8d41eda665; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $6404a4dd705933a6$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsForLoom)(appearance, colorMode);
    return "<svg\n\t\tfill=\"none\"\n\t\theight=\"32\"\n\t\txmlns=\"http://www.w3.org/2000/svg\"\n\t\tfocusable=\"false\"\n\t\taria-hidden=\"true\"\n\t\tviewBox=\"0 0 88 32\"\n\t>\n\t\t<path\n\t\t\td=\"M29.488 12.765h-8.983l7.78-4.344-1.544-2.585-7.78 4.344 4.492-7.523-2.674-1.493-4.491 7.522V0H13.2v8.687L8.71 1.164 6.035 2.657l4.49 7.522-7.778-4.343L1.204 8.42l7.779 4.344H0v2.986h8.982l-7.778 4.343 1.543 2.585 7.78-4.342-4.492 7.522 2.674 1.493L13.2 19.83v8.687h3.087v-8.873l4.574 7.663 2.507-1.4-4.575-7.663 7.946 4.437 1.544-2.586-7.779-4.343h8.982v-2.986h.001Zm-14.744 5.552c-2.318 0-4.197-1.817-4.197-4.059s1.88-4.059 4.197-4.059 4.198 1.817 4.198 4.06c0 2.24-1.88 4.058-4.198 4.058\"\n\t\t\tfill=\"".concat(colors.iconColor, "\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M38.379 26.847V10.094h3.18v16.753zm30.503-11.79h3.036v1.438c.646-1.15 2.153-1.773 3.444-1.773 1.602 0 2.893.695 3.49 1.964.932-1.438 2.177-1.964 3.731-1.964 2.175 0 4.256 1.318 4.256 4.48v7.642h-3.084V19.85c0-1.27-.623-2.228-2.081-2.228-1.363 0-2.177 1.054-2.177 2.324v6.9h-3.155V19.85c0-1.27-.646-2.228-2.081-2.228-1.387 0-2.2 1.03-2.2 2.324v6.9h-3.18V15.057Zm-20.134 12.13c-3.582 0-6.176-2.66-6.176-6.234 0-3.517 2.585-6.242 6.176-6.242 3.609 0 6.177 2.75 6.177 6.242 0 3.547-2.596 6.234-6.177 6.234m0-9.59a3.357 3.357 0 0 0 0 6.713 3.357 3.357 0 0 0 0-6.713m12.966 9.59c-3.583 0-6.177-2.66-6.177-6.234 0-3.517 2.586-6.242 6.177-6.242 3.608 0 6.176 2.75 6.176 6.242 0 3.547-2.597 6.234-6.176 6.234m0-9.63a3.397 3.397 0 0 0-3.39 3.395 3.397 3.397 0 0 0 3.39 3.395 3.396 3.396 0 0 0 0-6.79M64.933 5.63c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473a4.46 4.46 0 0 1-2.197-.63v1.417c.483.263 1.233.473 2.197.473 1.5.052 2.197-.683 2.197-1.785Zm16.662-4.067v5.988h1.3V3.007l.542 1.23 1.841 3.368h1.626V1.563h-1.3v3.85l-.488-1.123-1.463-2.727zm-8.056 0h-1.465v6.042h1.465zm-23.981 0v6.042h2.863l.432-1.295h-1.945V1.563zm-5.671 0v1.295h1.604v4.747h1.44V2.858h1.715V1.563zm-2.177 0h-1.802l-2.066 6.042h1.59l.317-1.025a4 4 0 0 0 1.113.162q.556 0 1.113-.162l.318 1.025h1.59zm-.9 3.938a3 3 0 0 1-.743-.108l.742-2.643.742 2.643c-.265.054-.477.108-.742.108Zm16.577-3.938H55.53L53.4 7.605h1.638l.328-1.025q.573.162 1.146.162.574 0 1.147-.162l.328 1.025h1.638l-2.24-6.042Zm-.928 3.938c-.273 0-.546-.054-.765-.108l.765-2.643.764 2.643a3.3 3.3 0 0 1-.764.108m21.98-3.938h-1.857l-2.13 6.042h1.638l.328-1.025q.574.162 1.147.162c.573 0 .764-.054 1.146-.162l.328 1.025h1.638zm-.93 3.938c-.272 0-.545-.054-.763-.108l.764-2.643.765 2.643a3.3 3.3 0 0 1-.765.108Zm-6.894.129c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473-.75 0-1.608-.263-2.197-.63v1.417c.482.263 1.233.473 2.197.473 1.447.052 2.197-.683 2.197-1.785Z\"\n\t\t\tfill=\"").concat(colors.textColor, "\"\n\t\t/>\n\t</svg>");
};
var $6404a4dd705933a6$export$6e87ce8d41eda665 = function LoomAttributionLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom Attribution' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $6404a4dd705933a6$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("qKSvE", function(module, exports) {

$parcel$export(module.exports, "OpsgenieIcon", function () { return $0506cada912c6764$export$eeccc49dc7a12d9f; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $0506cada912c6764$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M17.114 28.127c-.785.578-1.199.537-1.984-.041-3.8-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.992.124c1.652 1.9 3.264 3.76 5.123 5.082 1.86-1.322 3.47-3.181 5.123-5.082q.434-.495.992-.124l4.297 2.686c.372.206.496.66.248.991-2.355 3.223-5.867 6.322-9.668 9.09m-.992-11.858c3.388 0 6.198-2.768 6.198-6.156s-2.81-6.239-6.198-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156\"/>\n    </svg>");
};
var $0506cada912c6764$export$eeccc49dc7a12d9f = function OpsgenieIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Opsgenie' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        svg: $0506cada912c6764$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("Od6As", function(module, exports) {

$parcel$export(module.exports, "OpsgenieLogo", function () { return $096ed60e0ea57ebb$export$a1c6484cdecc2c4b; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $096ed60e0ea57ebb$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 154 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M11.78 28.127c-.785.578-1.198.537-1.983-.041-3.801-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.991.124c1.653 1.9 3.264 3.76 5.124 5.082 1.859-1.322 3.47-3.181 5.123-5.082q.435-.495.992-.124l4.297 2.686c.371.206.495.66.247.991-2.355 3.223-5.867 6.322-9.668 9.09m-.99-11.857c3.388 0 6.197-2.768 6.197-6.156s-2.81-6.239-6.197-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M146.689 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zM133.385 6.16c0-1.166.767-1.84 1.841-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84c-1.074 0-1.841-.675-1.841-1.84m.491 19.38V10.208h2.638v15.334zm-3.677-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-18.639-.614v-1.533c-.981 2.024-2.821 3.067-5.182 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.378-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.834 0 5.152-2.055 5.152-4.907m-8.678-6.44c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m-4.703 3.497c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.17-.52-5.336-1.134v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.89-1.84-3.802-2.545-3.404-.829-4.846-2.147-4.846-4.662 0-2.668 2.055-4.293 5.55-4.293 1.994 0 3.804.49 4.938 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.121 2.085 5.121 4.753m-16.274-3.496c0-3.68-1.472-5.52-4.202-5.52-2.36 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.509-1.962 4.509-5.52m-3.803 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.637V10.207h2.637v2.76c.981-2.024 2.821-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.147 7.973-6.44 7.973m-20.121 0c-6.225 0-9.721-4.293-9.721-10.426 0-6.072 3.496-10.335 9.721-10.335 6.195 0 9.69 4.263 9.69 10.335 0 6.133-3.495 10.426-9.69 10.426m0-18.124c-4.968 0-6.961 3.527-6.961 7.698 0 4.262 1.993 7.789 6.961 7.789 4.937 0 6.93-3.527 6.93-7.79 0-4.17-1.993-7.697-6.93-7.697\" />\n    </svg>");
};
var $096ed60e0ea57ebb$export$a1c6484cdecc2c4b = function OpsgenieLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Opsgenie' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $096ed60e0ea57ebb$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("9ayXU", function(module, exports) {

$parcel$export(module.exports, "RovoIcon", function () { return $6ad02b9b3d4feb7e$export$e23ae35269442b4f; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $6ad02b9b3d4feb7e$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n    <g fill=\"".concat(colors.iconColor, "\" fill-rule=\"evenodd\">\n      <path d=\"M17.06 4.246a2.79 2.79 0 0 0-2.736-.026l-.049.033-.002.001c-.605.35-1.048.91-1.256 1.558-.085.268-.13.552-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566a2.77 2.77 0 0 0 1.392-2.407v-9.487c0-.991-.532-1.912-1.392-2.408z\"/>\n      <path d=\"m6.058 9 6.176-3.566a3.7 3.7 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155l4.604 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.851.47-1.89.461-2.735-.026L6.06 23.301a2.78 2.78 0 0 1-1.392-2.408v-9.486c0-.996.529-1.912 1.391-2.408z\"/>\n    </g>\n  </svg>");
};
var $6ad02b9b3d4feb7e$export$e23ae35269442b4f = function RovoIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Rovo' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        svg: $6ad02b9b3d4feb7e$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("bVyJW", function(module, exports) {

$parcel$export(module.exports, "RovoLogo", function () { return $8aeff739559dc28b$export$a0f6cb8061290bbb; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $8aeff739559dc28b$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 100 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path\n        d=\"M12.393 4.246a2.79 2.79 0 0 0-2.735-.026.4.4 0 0 1-.05.033l-.001.001c-.606.35-1.048.91-1.257 1.558q-.129.404-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566A2.77 2.77 0 0 0 22 20.884v-9.487c0-.991-.532-1.912-1.392-2.408z\"\n        fill=\"".concat(colors.iconColor, "\"\n        fillRule=\"evenodd\"\n      />\n      <path\n        d=\"m1.391 9 6.176-3.566a3.6 3.6 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155h.001l4.603 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.85.47-1.89.461-2.734-.026l-8.216-4.743A2.78 2.78 0 0 1 0 20.893v-9.486c0-.996.529-1.912 1.391-2.408z\"\n        fill=\"").concat(colors.iconColor, "\"\n        fillRule=\"evenodd\"\n      />\n      <path\n        d=\"M91.688 25.848c-4.6 0-7.298-3.404-7.298-8.004S87.088 9.9 91.688 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004zm0-13.494c-3.28 0-4.722 2.576-4.722 5.49 0 2.913 1.441 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.41-5.49-4.662-5.49M77.675 25.54H74.15L68.2 10.208h2.76l4.968 13.094 4.938-13.095h2.76zm-17.462.308c-4.6 0-7.299-3.404-7.299-8.004s2.7-7.943 7.3-7.943c4.568 0 7.236 3.342 7.236 7.942s-2.668 8.004-7.237 8.004zm0-13.494c-3.281 0-4.723 2.576-4.723 5.49 0 2.913 1.442 5.55 4.723 5.55 3.25 0 4.661-2.637 4.661-5.55 0-2.914-1.41-5.49-4.66-5.49zM43.177 8.03H39.13v7.36h4.048c3.588 0 4.692-1.38 4.692-3.68 0-2.177-1.134-3.68-4.692-3.68zm7.452 3.619c0 3.036-1.288 5.09-3.956 5.949l4.938 7.943H48.36l-4.447-7.514H39.13v7.514h-2.76V5.393h7.115c4.815 0 7.145 2.392 7.145 6.256z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $8aeff739559dc28b$export$a0f6cb8061290bbb = function RovoLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Rovo' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $8aeff739559dc28b$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("e1a9c", function(module, exports) {

$parcel$export(module.exports, "StatuspageIcon", function () { return $a34907b8bcc466fa$export$f3f5aa321d88adf9; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $a34907b8bcc466fa$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M16 12.604c-3.033 0-5.981 1.37-8.39 3.489q-.375.373-.748.373c-.208 0-.415-.124-.581-.332l-3.032-3.572c-.166-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706 3.655-3.24 8.1-5.067 12.627-5.067s8.97 1.827 12.626 5.067c.249.249.374.457.374.706 0 .166-.084.374-.25.581l-3.032 3.572c-.166.208-.373.332-.581.332q-.374 0-.748-.374c-2.409-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.365 0-6.106-2.742-6.106-6.064S12.635 13.85 16 13.85s6.106 2.7 6.106 6.064-2.741 6.063-6.105 6.063\"/>\n    </svg>");
};
var $a34907b8bcc466fa$export$f3f5aa321d88adf9 = function StatuspageIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Statuspage' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        label: label,
        svg: $a34907b8bcc466fa$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("6jEQT", function(module, exports) {

$parcel$export(module.exports, "StatuspageLogo", function () { return $499434c8308115ff$export$bb4ae5b41b43be04; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $499434c8308115ff$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 188 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M13 12.604c-3.032 0-5.98 1.37-8.39 3.489q-.373.373-.747.373c-.208 0-.416-.124-.582-.332L.25 12.562c-.167-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706C4.029 8.035 8.473 6.208 13 6.208s8.971 1.827 12.626 5.067c.25.249.374.457.374.706 0 .166-.083.374-.25.581l-3.031 3.572c-.166.208-.374.332-.582.332q-.373 0-.747-.374c-2.41-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.364 0-6.105-2.742-6.105-6.064S9.635 13.85 13 13.85c3.364 0 6.105 2.7 6.105 6.064s-2.74 6.063-6.105 6.063\" />\n      <path fill=\"").concat(colors.textColor, "\" d=\"M180.293 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.981 2.024-2.821 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.982 2.024-2.822 3.066-5.183 3.066-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-16.091-7.666c0-3.68-1.472-5.52-4.201-5.52-2.361 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.508-1.962 4.508-5.52m-3.802 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.638V10.207h2.638v2.76c.981-2.024 2.821-3.066 5.182-3.066 4.079 0 6.134 3.465 6.134 7.973 0 4.324-2.147 7.973-6.44 7.973m-10.56-4.477c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.52-5.336-1.134v-2.79c1.318.766 3.526 1.502 5.458 1.502 2.024 0 3.067-.828 3.067-2.024 0-1.165-.889-1.84-3.803-2.545-3.404-.829-4.845-2.147-4.845-4.662 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.73c-1.84-.92-3.343-1.411-4.968-1.411-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-27.598-2.177v-8.985h2.638v9.26c0 2.76 1.104 3.988 3.618 3.988 2.454 0 4.14-1.626 4.14-4.723v-8.525h2.638V25.54h-2.638v-2.515c-.981 1.81-2.79 2.821-4.845 2.821-3.527 0-5.55-2.422-5.55-6.654m-7.155 1.596c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454H85.39zm-18.943-2.914c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-17.258-4.752c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454h-4.078zm-6.894-.798c0 3.496-2.085 5.858-7.084 5.858-3.894 0-5.704-.767-7.268-1.564v-2.822c1.871.982 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975 0-1.778-1.104-2.729-4.937-3.649-4.539-1.104-6.563-2.668-6.563-5.98 0-3.128 2.392-5.459 7.084-5.459 2.914 0 4.784.706 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.846 3.373 4.262 1.074 6.654 2.454 6.654 6.072\" />\n    </svg>");
};
var $499434c8308115ff$export$bb4ae5b41b43be04 = function StatuspageLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Statuspage' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $499434c8308115ff$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("3kU2O", function(module, exports) {

$parcel$export(module.exports, "TrelloIcon", function () { return $26deb699197f822b$export$4384da9b8b140bf4; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $26deb699197f822b$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " clip-rule=\"evenodd\" d=\"M24.286 5.337H7.714a2.585 2.585 0 0 0-2.585 2.585v16.572a2.585 2.585 0 0 0 2.585 2.584h16.572a2.585 2.585 0 0 0 2.585-2.584V7.922a2.585 2.585 0 0 0-2.585-2.585m-9.791 15.66a.86.86 0 0 1-.859.858h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86zm8.362-4.953a.86.86 0 0 1-.859.859h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86z\" fill-rule=\"evenodd\"/>\n    </svg>");
};
var $26deb699197f822b$export$4384da9b8b140bf4 = function TrelloIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Trello' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        label: label,
        svg: $26deb699197f822b$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("a1N0K", function(module, exports) {

$parcel$export(module.exports, "TrelloLogo", function () { return $74d003fa1d624930$export$60e26212f3b61a28; });

var $91i6m = parcelRequire("91i6m");

var $jfDBc = parcelRequire("jfDBc");

var $anGZX = parcelRequire("anGZX");

var $1hGv8 = parcelRequire("1hGv8");

var $7NTQQ = parcelRequire("7NTQQ");
var $74d003fa1d624930$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $7NTQQ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 106 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" clip-rule=\"evenodd\" d=\"M19.157 4.67H2.585A2.585 2.585 0 0 0 0 7.255v16.572a2.585 2.585 0 0 0 2.585 2.585h16.572a2.585 2.585 0 0 0 2.584-2.585V7.255a2.585 2.585 0 0 0-2.584-2.585M9.365 20.33a.86.86 0 0 1-.858.858H4.873a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86zm8.362-4.952a.86.86 0 0 1-.858.858h-3.634a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86z\" fill-rule=\"evenodd\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M97.64 25.848c-4.6 0-7.298-3.404-7.298-8.004S93.04 9.9 97.64 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.494c-3.281 0-4.722 2.576-4.722 5.49 0 2.913 1.44 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.411-5.49-4.662-5.49M88.874 25.51c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zm-7.996 0c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zM65.532 12.293c-2.79 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.44-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196H61.085c.368 2.606 2.055 4.293 5.673 4.293 1.78 0 3.282-.337 4.662-.828zm-19.48-8.434v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M32.943 5.393H48.03V8.03h-6.164v17.511h-2.76V8.031h-6.164z\"/>\n    </svg>");
};
var $74d003fa1d624930$export$60e26212f3b61a28 = function TrelloLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Trello' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $anGZX.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $anGZX.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $anGZX.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jfDBc.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1hGv8.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $74d003fa1d624930$var$svg({
            appearance: appearance,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("kmiae", function(module, exports) {

$parcel$export(module.exports, "createFeatureFlaggedComponent", function () { return $ed23f3b5ac8df6e3$export$e30d2ddc605f6bb; });
$parcel$export(module.exports, "createFeatureFlaggedServiceCollectionComponent", function () { return $ed23f3b5ac8df6e3$export$436fcf6e31fbacea; });
$parcel$export(module.exports, "tempSizeWrapper", function () { return $ed23f3b5ac8df6e3$export$667425256e2e7296; });

var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $f1k1y = parcelRequire("f1k1y");
var $ed23f3b5ac8df6e3$var$_excluded = [
    "size",
    "shouldUseNewLogoDesign"
], $ed23f3b5ac8df6e3$var$_excluded2 = [
    "size",
    "shouldUseNewLogoDesign"
], $ed23f3b5ac8df6e3$var$_excluded3 = [
    "size"
];
var $ed23f3b5ac8df6e3$export$e30d2ddc605f6bb = function createFeatureFlaggedComponent(LegacyComponent, NewComponent) {
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return function(_ref) {
        var size = _ref.size, shouldUseNewLogoDesign = _ref.shouldUseNewLogoDesign, props = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $ed23f3b5ac8df6e3$var$_excluded);
        if ((0, $f1k1y.fg)('platform-logo-rebrand') || shouldUseNewLogoDesign) // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(NewComponent, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
            size: size || 'medium'
        }, props));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(LegacyComponent, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
            size: size
        }, props));
    };
};
var $ed23f3b5ac8df6e3$export$436fcf6e31fbacea = function createFeatureFlaggedServiceCollectionComponent(LegacyComponent, NewComponent) {
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return function(_ref2) {
        var size = _ref2.size, shouldUseNewLogoDesign = _ref2.shouldUseNewLogoDesign, props = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref2, $ed23f3b5ac8df6e3$var$_excluded2);
        if ((0, $f1k1y.fg)('platform-logo-rebrand-servco') || (0, $f1k1y.fg)('platform-logo-rebrand') || shouldUseNewLogoDesign) // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(NewComponent, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
            size: size || 'medium'
        }, props));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(LegacyComponent, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
            size: size
        }, props));
    };
};
var $ed23f3b5ac8df6e3$export$667425256e2e7296 = function tempSizeWrapper(NewComponent) {
    return function(_ref3) {
        var size = _ref3.size, props = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref3, $ed23f3b5ac8df6e3$var$_excluded3);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(NewComponent, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
            size: size || 'medium'
        }, props));
    };
};
var $ed23f3b5ac8df6e3$export$172fd793eb6ecac4 = [
    // Program logos
    {
        name: 'atlassian',
        type: 'legacy',
        category: 'program'
    },
    {
        name: 'atlassian-access',
        type: 'legacy',
        category: 'program'
    },
    {
        name: 'atlassian-marketplace',
        type: 'legacy',
        category: 'program'
    },
    // Home collection
    {
        name: 'home',
        type: 'new',
        category: 'app'
    },
    {
        name: 'hub',
        type: 'new',
        category: 'app'
    },
    // Teamwork collection
    {
        name: 'confluence',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'jira',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'loom',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'loom-blurple',
        type: 'new',
        category: 'app',
        skipExample: true
    },
    {
        name: 'loom-attribution',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'rovo',
        type: 'migration',
        category: 'app'
    },
    // Strategy collection
    {
        name: 'align',
        type: 'new',
        category: 'app'
    },
    {
        name: 'focus',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'talent',
        type: 'new',
        category: 'app'
    },
    // App collection
    {
        name: 'jira-product-discovery',
        type: 'migration',
        category: 'app'
    },
    // Dev collection
    {
        name: 'bitbucket',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'compass',
        type: 'migration',
        category: 'app'
    },
    // Customer collection
    {
        name: 'jira-service-management',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'assets',
        type: 'new',
        category: 'app'
    },
    {
        name: 'customer-service-management',
        type: 'new',
        category: 'app'
    },
    {
        name: 'opsgenie',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'statuspage',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'trello',
        type: 'migration',
        category: 'app'
    },
    // Platform Collection
    {
        name: 'admin',
        type: 'new',
        category: 'app'
    },
    {
        name: 'analytics',
        type: 'new',
        category: 'app'
    },
    {
        name: 'chat',
        type: 'new',
        category: 'app'
    },
    {
        name: 'goals',
        type: 'new',
        category: 'app'
    },
    {
        name: 'guard',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'projects',
        type: 'new',
        category: 'app'
    },
    {
        name: 'search',
        type: 'new',
        category: 'app'
    },
    {
        name: 'studio',
        type: 'new',
        category: 'app'
    },
    {
        name: 'teams',
        type: 'new',
        category: 'app'
    },
    // Data Center
    {
        name: 'jira-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'jira-service-management-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'confluence-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'bitbucket-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'bamboo',
        type: 'new',
        category: 'app'
    },
    {
        name: 'crowd',
        type: 'new',
        category: 'app'
    },
    // Deprecated
    {
        name: 'atlassian-administration',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlassian-admin',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlassian-analytics',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlas',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-align',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-software',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-work-management',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    }
];
var $ed23f3b5ac8df6e3$export$62e1212796a86b1b = $ed23f3b5ac8df6e3$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === 'program' && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
});
var $ed23f3b5ac8df6e3$export$e0dee4a765830f4d = $ed23f3b5ac8df6e3$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === 'app' && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
});
var $ed23f3b5ac8df6e3$export$516fce44c502c1d3 = $ed23f3b5ac8df6e3$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'legacy';
});
var $ed23f3b5ac8df6e3$export$b805fae8e798ed39 = $ed23f3b5ac8df6e3$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'migration';
});
var $ed23f3b5ac8df6e3$export$3f9abd26214cd85f = $ed23f3b5ac8df6e3$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'new';
});

});


parcelRegister("6uK3G", function(module, exports) {

$parcel$export(module.exports, "BitbucketBackground", function () { return $4ba945ad3902bfe1$export$7a8deb158bc23a3c; });

var $91i6m = parcelRequire("91i6m");

var $ldfoh = parcelRequire("ldfoh");

var $f1J6u = parcelRequire("f1J6u");
var $4ba945ad3902bfe1$export$7a8deb158bc23a3c = function BitbucketBackground(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $f1J6u.DesktopOnlyBackground), {
        background: (0, $ldfoh.BitbucketLightTheme)
    }, children);
};

});
parcelRegister("ldfoh", function(module, exports) {

$parcel$export(module.exports, "BitbucketLightTheme", function () { return $f716c026a03a1803$export$880f50d5c5924242; });
/* eslint-disable @atlaskit/design-system/prefer-primitives */ 
var $91i6m = parcelRequire("91i6m");

var $eUxuC = parcelRequire("eUxuC");

var $HPJv4 = parcelRequire("HPJv4");

var $j141P = parcelRequire("j141P");

var $4DTFp = parcelRequire("4DTFp");

var $5TSRQ = parcelRequire("5TSRQ");

var $bM2C8 = parcelRequire("bM2C8");

var $bZcmN = parcelRequire("bZcmN");

var $duKnJ = parcelRequire("duKnJ");
var $f716c026a03a1803$export$880f50d5c5924242 = function BitbucketLightTheme() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("div", {
        "data-testid": "testId-bitbucket-wireframe"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $eUxuC.Background), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $HPJv4.Header), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $bM2C8.Search), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $bZcmN.SecondaryNav), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $5TSRQ.PageHeader), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $j141P.PageActions), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $4DTFp.PageContent), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $duKnJ.Sidebar), null));
};

});
parcelRegister("eUxuC", function(module, exports) {

$parcel$export(module.exports, "Background", function () { return $adb046a873b25407$export$668799e4797757a8; });
/* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9jjaN = parcelRequire("9jjaN");
var $adb046a873b25407$export$668799e4797757a8 = (0, $9jjaN.default).div({
    position: 'fixed',
    background: '#fff',
    height: '100%',
    width: '100%'
});
var $adb046a873b25407$export$ede4ebd46660008d = (0, $9jjaN.default).div({
    position: 'fixed',
    background: '#2c333a',
    width: '100%',
    height: '100%'
});

});

parcelRegister("HPJv4", function(module, exports) {

$parcel$export(module.exports, "Header", function () { return $083c25566ea9a1c4$export$8b251419efc915eb; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $91i6m = parcelRequire("91i6m");

var $ikrwa = parcelRequire("ikrwa");
var $083c25566ea9a1c4$export$8b251419efc915eb = function Header() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $ikrwa.Wrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($083c25566ea9a1c4$var$Image, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $ikrwa.Line), null));
};
var $083c25566ea9a1c4$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 1440,
        height: 56,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        clipPath: "url(#a)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        clipPath: "url(#b)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M52 16h120v24H52z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#253858",
        d: "M77.445 20.2h6.523c3.18 0 4.717 1.51 4.717 3.935 0 1.825-.863 2.946-2.615 3.337 2.291.364 3.45 1.59 3.45 3.727 0 2.398-1.67 4.066-5.175 4.066h-6.9V20.2Zm2.156 6.437h4.097c2.022 0 2.857-.886 2.857-2.346s-.89-2.163-2.857-2.163h-4.097v4.51Zm0 1.851v4.692h4.852c2.048 0 2.965-.704 2.965-2.215 0-1.617-.89-2.477-3.019-2.477h-4.798Zm13.423-9.097c.836 0 1.429.495 1.429 1.382 0 .86-.593 1.381-1.429 1.381-.835 0-1.428-.495-1.428-1.381 0-.887.593-1.382 1.428-1.382Zm-1.05 4.405h2.048v11.47h-2.049v-11.47Zm9.81 9.619c.486 0 .917-.105 1.294-.157v1.903c-.35.104-.754.183-1.374.183-2.534 0-3.774-1.434-3.774-3.572v-6.151h-1.914v-1.825h1.914v-2.424h1.995v2.424h3.153v1.825h-3.153v6.073c0 1.017.62 1.72 1.859 1.72Zm5.93-.183v2.007h-2.048V19h2.048v6.855c.755-1.511 2.184-2.293 4.016-2.293 3.154 0 4.744 2.58 4.744 5.969 0 3.232-1.671 5.969-4.986 5.969-1.725 0-3.046-.756-3.774-2.268Zm3.477-7.82c-1.833 0-3.45 1.121-3.45 3.676V30c0 2.554 1.483 3.675 3.235 3.675 2.291 0 3.477-1.46 3.477-4.118-.027-2.79-1.159-4.145-3.262-4.145Zm7.413-1.616h2.048v6.934c0 2.06.863 2.971 2.804 2.971 1.886 0 3.207-1.225 3.207-3.545v-6.36h2.049v11.47h-2.049v-1.877c-.755 1.355-2.156 2.111-3.747 2.111-2.722 0-4.285-1.825-4.285-4.979v-6.725h-.027Zm21.536 11.157c-.701.364-1.806.52-2.884.52-4.232 0-6.199-2.475-6.199-5.994 0-3.467 1.967-5.944 6.199-5.944 1.078 0 1.887.13 2.83.548v1.825c-.754-.34-1.563-.548-2.668-.548-3.073 0-4.34 1.877-4.34 4.119 0 2.241 1.294 4.118 4.394 4.118 1.213 0 1.967-.156 2.695-.417v1.773h-.027Zm2.318.312V19h2.049v10.166l5.094-5.37h2.669l-5.58 5.63 5.822 5.84h-2.776l-5.229-5.37v5.37h-2.049Zm16.793.235c-4.448 0-6.388-2.476-6.388-5.995 0-3.467 1.994-5.943 5.606-5.943 3.666 0 5.121 2.45 5.121 5.943v.886h-8.652c.297 1.955 1.59 3.206 4.394 3.206 1.374 0 2.533-.26 3.612-.625v1.824c-.971.522-2.48.704-3.693.704Zm-4.34-6.803h6.631c-.108-2.138-1.105-3.337-3.154-3.337-2.156 0-3.261 1.356-3.477 3.337Zm15.795 4.718c.485 0 .917-.105 1.294-.157v1.903c-.35.104-.755.183-1.375.183-2.533 0-3.773-1.434-3.773-3.572v-6.151h-1.914v-1.825h1.914v-2.424h1.994v2.424H172v1.825h-3.154v6.073c0 1.017.62 1.72 1.86 1.72Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#2684FF",
        d: "M52.54 20.642c-.324 0-.594.287-.54.6l2.291 13.424c.054.339.35.6.728.6h10.97c.27 0 .486-.183.54-.444l2.29-13.58c.054-.313-.188-.6-.539-.6H52.54Zm9.649 9.697h-3.504l-.944-4.796h5.31l-.862 4.796Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "url(#c)",
        d: "M68.092 25.543h-5.068l-.835 4.796h-3.504l-4.151 4.744s.188.182.485.182h10.97c.27 0 .485-.182.54-.443l1.563-9.28Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        clipPath: "url(#d)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M196 0h86v56h-86z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 71,
        height: 6,
        x: 203.5,
        y: 25,
        fill: "#091E42",
        fillOpacity: 0.13,
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium large",
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M290 0h86v56h-86z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium large",
        width: 71,
        height: 6,
        x: 297.5,
        y: 25,
        fill: "#091E42",
        fillOpacity: 0.13,
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M384 0h86v56h-86z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        width: 71,
        height: 6,
        x: 391.5,
        y: 25,
        fill: "#091E42",
        fillOpacity: 0.13,
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M478 0h86v56h-86z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        width: 56,
        height: 6,
        x: 486,
        y: 25,
        fill: "#091E42",
        fillOpacity: 0.13,
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        clipPath: "url(#e)",
        opacity: 0.6
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M548 18h8v20h-8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        fill: "#344563",
        fillRule: "evenodd",
        d: "M548.292 26.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.987.987 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.986.986 0 0 0-1.084-.217.997.997 0 0 0-.322.217Z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        fill: "#0052CC",
        d: "M482 54a1 1 0 0 1 1-1h76a1 1 0 0 1 1 1v2h-78v-2Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "small",
        width: 61,
        height: 32,
        x: 289.5,
        y: 12,
        fill: "#B3D4FF",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "small",
        width: 44,
        height: 6,
        x: 297.5,
        y: 25,
        fill: "#091E42",
        fillOpacity: 0.13,
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium",
        width: 61,
        height: 32,
        x: 383.5,
        y: 12,
        fill: "#B3D4FF",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium",
        width: 44,
        height: 6,
        x: 391.5,
        y: 25,
        fill: "#091E42",
        fillOpacity: 0.13,
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        width: 61,
        height: 32,
        x: 580,
        y: 12,
        fill: "#B3D4FF",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        width: 44,
        height: 6,
        x: 588,
        y: 25,
        fill: "#091E42",
        fillOpacity: 0.13,
        rx: 3
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M18 16h24v24H18z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#A5ADBA",
        fillRule: "evenodd",
        d: "M22 21.01c0-.559.443-1.01 1.01-1.01h1.98c.559 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Zm-12 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        d: "M52 0h589v56H52z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("clipPath", {
        id: "b"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        d: "M52 16h120v24H52z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("clipPath", {
        id: "d"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        d: "M192 0h449v56H192z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("clipPath", {
        id: "e"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        d: "M548 18h8v20h-8z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("linearGradient", {
        id: "c",
        x1: 69.254,
        x2: 61.106,
        y1: 26.89,
        y2: 33.467,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("stop", {
        offset: 0.176,
        stopColor: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("stop", {
        offset: 1,
        stopColor: "#2684FF"
    }))));
};

});
parcelRegister("ikrwa", function(module, exports) {

$parcel$export(module.exports, "Wrapper", function () { return $d57f70b9c0991908$export$e6dfd72ab29f8598; });
$parcel$export(module.exports, "Line", function () { return $d57f70b9c0991908$export$17d680238e50603e; });
/* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9jjaN = parcelRequire("9jjaN");

var $lneJV = parcelRequire("lneJV");
var $d57f70b9c0991908$export$e6dfd72ab29f8598 = (0, $9jjaN.default).div({
    position: 'fixed',
    top: 0,
    left: 0,
    '@media (min-width: 1200px)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'rect.small, path.small': {
            visibility: 'hidden'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'rect.medium, path.medium': {
            visibility: 'hidden'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'rect.large, path.large': {
            visibility: 'visible'
        }
    },
    '@media (min-width: 1000px) and (max-width: 1200px)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'rect.small, path.small': {
            visibility: 'hidden'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'rect.large, path.large': {
            visibility: 'hidden'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'rect.medium, path.medium': {
            visibility: 'visible'
        }
    },
    '@media (max-width: 1000px)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'rect.medium, path.medium': {
            visibility: 'hidden'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'rect.large, path.large': {
            visibility: 'hidden'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'rect.small, path.small': {
            visibility: 'visible'
        }
    }
});
var $d57f70b9c0991908$export$17d680238e50603e = (0, $9jjaN.default).div({
    display: 'inline-block',
    position: 'fixed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $lneJV.HEADER_HEIGHT), "px"),
    left: 0,
    height: '2px',
    width: '100%',
    background: '#dfe1e6',
    zIndex: 1
});
var $d57f70b9c0991908$export$e7439992f3f52d0 = (0, $9jjaN.default).div({
    display: 'inline-block',
    position: 'fixed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $lneJV.HEADER_HEIGHT), "px"),
    left: 0,
    height: '2px',
    width: '100%',
    background: '#454f59',
    zIndex: 1
});

});
parcelRegister("lneJV", function(module, exports) {

$parcel$export(module.exports, "HEADER_HEIGHT", function () { return $f8f72df859f400dd$export$cdb7fd9d999c7168; });
$parcel$export(module.exports, "SECONDARY_NAV_WIDTH", function () { return $f8f72df859f400dd$export$6cfc56c8a5804224; });
$parcel$export(module.exports, "SIDEBAR_WIDTH", function () { return $f8f72df859f400dd$export$780035d9fe48eb32; });
var $f8f72df859f400dd$export$cdb7fd9d999c7168 = 56;
var $f8f72df859f400dd$export$6cfc56c8a5804224 = 240;
var $f8f72df859f400dd$export$780035d9fe48eb32 = 333;

});



parcelRegister("j141P", function(module, exports) {

$parcel$export(module.exports, "PageActions", function () { return $dd813c445736446d$export$a9e583a1195b23df; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $91i6m = parcelRequire("91i6m");

var $9jjaN = parcelRequire("9jjaN");

var $lneJV = parcelRequire("lneJV");
var $dd813c445736446d$export$a9e583a1195b23df = function PageActions() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($dd813c445736446d$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($dd813c445736446d$var$Image, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $dd813c445736446d$var$Wrapper = (0, $9jjaN.default).div({
    position: 'fixed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $lneJV.HEADER_HEIGHT), "px"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    right: "".concat((0, $lneJV.SIDEBAR_WIDTH), "px"),
    background: '#fff'
});
var $dd813c445736446d$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "292",
        height: "112",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        clipPath: "url(#PageActionsA)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "120",
        height: "32",
        x: "24",
        y: "56",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "104",
        height: "6",
        x: "32",
        y: "69",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "80",
        height: "32",
        x: "150",
        y: "56",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "64",
        height: "6",
        x: "158",
        y: "69",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "32",
        height: "32",
        x: "236",
        y: "56",
        fill: "#fff",
        fillOpacity: ".01",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M240 60h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#C1C7D0",
        d: "M245 74a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM252 74a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM259 74a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("clipPath", {
        id: "PageActionsA"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        d: "M24 56h244v32H24z"
    }))));
};

});

parcelRegister("4DTFp", function(module, exports) {

$parcel$export(module.exports, "PageContent", function () { return $3615fc387b735931$export$16800ac069904dff; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $91i6m = parcelRequire("91i6m");

var $9jjaN = parcelRequire("9jjaN");

var $lneJV = parcelRequire("lneJV");
var $3615fc387b735931$export$16800ac069904dff = function PageContent() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($3615fc387b735931$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($3615fc387b735931$var$ImageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($3615fc387b735931$var$Image, null)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $3615fc387b735931$var$Wrapper = (0, $9jjaN.default).div({
    position: 'fixed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $lneJV.HEADER_HEIGHT) + 150, "px"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    left: "".concat((0, $lneJV.SECONDARY_NAV_WIDTH) + 24, "px"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    right: "".concat((0, $lneJV.SIDEBAR_WIDTH) + 24, "px"),
    minHeight: '661px'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $3615fc387b735931$var$ImageWrapper = (0, $9jjaN.default).div({
    display: 'flex',
    justifyContent: 'center'
});
var $3615fc387b735931$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "820",
        height: "619",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        clipPath: "url(#PageContentA)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#B2D4FF",
        d: "M32 16c0-8.837-7.163-16-16-16S0 7.163 0 16s7.163 16 16 16 16-7.163 16-16Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#0065FF",
        d: "M24.466 25.316ZM17.472 30.51l.026-.105.023-.095-1.26.653 1.308-.87c.018-.098.029-.195.026-.29a.653.653 0 0 0-.059-.256c-.115-.038-.202-.168-.205-.33-.002-.197.118-.358.267-.363.084 0 .156.046.207.123.223.148.343.435.374.711l3.67-2.442c1.862-.822 2.445-1.505 2.607-1.935h.005-.005c.117-.31.018-.487.018-.487-.136-1.2-.799-1.85-1.587-2.191-1.01.602-2.494 1.093-3.07.632l.036.497c.015.023.054.066.105.12l.025.028c.07.075.151.167.22.251.09.113.152.215.113.256-.171.085-.343.18-.512.287-1.664 1.03-3.228 2.908-3.725 3.558-.028-.02-.069-.053-.12-.094-.576-.74-2.13-2.563-3.76-3.53a5.293 5.293 0 0 0-.62-.32c-.008-.013-.013-.026-.02-.039a.234.234 0 0 1 .074-.077c.002 0 .005-.005.01-.007l.059-.039c.15-.084.358-.15.407-.228l.118-1.54s-.008 0-.02-.006c-.006.264-.024.556-.057.873-.566.476-2.056-.015-3.072-.617-.78.343-1.439.988-1.572 2.184 0 0-.102.179.02.491-1.251.4-2.521.873-3.417 1.38a15.954 15.954 0 0 0 10.056 5.192c-.029-.482-.093-.906-.203-1.226l-.035-.1c-.085-.236-.18-.502-.17-.791 0-.029.006-.057.01-.085L6.355 25.87c.397-.151.812-.295 1.229-.433.228.43.865 1.063 2.547 1.805l3.679 2.253c.056-.17.156-.328.297-.448a.387.387 0 0 1 .358-.213c.213.005.379.167.374.364-.005.197-.18.353-.392.348h-.008a.426.426 0 0 0-.092.243v.036l1.452.888s.005.013.01.02l-1.441-.739c.025.118.066.238.112.366l.039.105c.138.4.215.911.24 1.475.41.03.825.053 1.245.053.468 0 .931-.025 1.39-.064-.031-.555-.01-1.052.082-1.426l-.003.008Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#0065FF",
        d: "M18.181 29.97c-.015.205-.064.397-.11.581l-.026.102c-.076.313-.094.738-.069 1.222a15.969 15.969 0 0 0 9.92-5.177 13.857 13.857 0 0 0-1.815-.822l-7.897 4.094h-.003Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "url(#PageContentB)",
        d: "M20.2 24.164c-.068-.085-.15-.174-.22-.251a.155.155 0 0 1-.015-.013c-.002 0-.007-.01-.01-.013a1.6 1.6 0 0 1-.105-.12l-.036-.497-.012-.007a12.55 12.55 0 0 1-.057-.817c-.005-.033-.005-.064-.008-.092-.04-.522-.076-1.1-.104-1.626-.59.569-1.411 1.13-2.57 1.582a2.062 2.062 0 0 1-.748.154h-1.08c-.262 0-.512-.061-.748-.154-.952-.37-1.677-.816-2.232-1.28-.013.382-.031.781-.052 1.16V22.39c.013 0-.094 1.543-.094 1.543-.049.077-.256.144-.407.228l-.06.039c-.002 0-.004.005-.01.007a.263.263 0 0 0-.074.077c.008.013.013.026.02.039.208.092.413.2.62.32 1.631.967 3.185 2.787 3.761 3.53l.12.095c.497-.653 2.061-2.53 3.725-3.559.17-.105.34-.2.512-.287.039-.04-.023-.14-.113-.256l-.002-.002Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#0747A6",
        d: "M14.48 30.367a2.964 2.964 0 0 1-.113-.366l1.441.74-.01-.021-1.452-.888v-.036a.42.42 0 0 1 .092-.243h.008c.213.005.387-.151.392-.349.005-.197-.164-.358-.374-.363a.387.387 0 0 0-.358.212.962.962 0 0 0-.297.448L10.13 27.25c-1.682-.743-2.32-1.372-2.547-1.805-.417.138-.832.281-1.229.433l7.414 3.814c-.003.028-.008.056-.01.084-.01.29.084.556.169.791l.035.1c.11.318.177.745.203 1.226.197.024.396.041.596.057-.026-.566-.102-1.075-.24-1.475l-.039-.105-.003-.002ZM18.045 30.653l.026-.102c.049-.187.095-.379.11-.581l7.898-4.093c-.52-.2-1.068-.387-1.61-.561h-.011c-.164.43-.745 1.113-2.606 1.935l-3.67 2.442c-.029-.279-.152-.563-.375-.711-.05-.075-.125-.126-.207-.123-.151.005-.271.166-.266.363.002.164.09.292.205.33.03.062.056.15.058.257 0 .094-.007.19-.025.289l-1.308.87 1.26-.652c-.009.03-.016.06-.024.094l-.025.105c-.093.374-.113.868-.082 1.426.197-.018.391-.038.586-.061-.023-.482-.008-.91.069-1.221l-.003-.006Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#172B4D",
        d: "M12.145 23.26c.036-.317.05-.61.056-.873V22.188c.02-.38.038-.779.051-1.16-1.779-1.485-1.797-3.149-1.797-3.149-.008-.08-.015-.154-.02-.23h-.082c-.5-2.128-.855-3.91-.031-3.828a.81.81 0 0 1 .24.062c.034-.036.267-.512.423-.812a.684.684 0 0 1 .39-.338c.836-.286 1.453-.15 1.453-.15.044-.2.103-.387.172-.564.156-.32.396-.763.722-1.18a4.685 4.685 0 0 1 1.51-1.131c.077-.021.156-.036.236-.047 1.812.067 4.669 2.517 5.273 4.053.123.31.305.261.484.125.171-.13.335-.343.433-.391.035.023.074.046.105.074.34.673.291 1.564.048 2.57-.051.18-.1.34-.146.474-.21.601-.302.937-.55 1.042a9.71 9.71 0 0 1-.026.274s-.015 1.449-1.459 2.849a69.25 69.25 0 0 0 .113 1.718 12.744 12.744 0 0 0 .056.817l.013.007c.576.463 2.06-.03 3.07-.632.647-.387 1.1-.814.987-1.065a2.796 2.796 0 0 1-.166-.52c-.03-.535-.064-1.093-.102-1.664.025-1.556.156-3.63-.745-6.438-.057-.295-.113-.592-.177-.884-.274-1.236-.793-2.516-1.602-3.591a6.662 6.662 0 0 0-5.464-2.852c-2.82 0-5.232 1.759-6.215 4.247a9.924 9.924 0 0 0-.755 2.196c-.228 1.027-.3 2.084-.308 3.141-.53 3.037.32 5.051-.268 6.367-.113.251.345.684 1 1.07 1.017.602 2.504 1.093 3.073.617l.005-.005Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#A96935",
        d: "M21.12 17.603c.248-.108.34-.443.55-1.042.047-.13.098-.295.146-.474.244-1.006.292-1.897-.048-2.57a.512.512 0 0 0-.105-.074c-.097.048-.261.26-.433.391.023.305.036.615.036.924 0 1.05-.059 1.905-.146 2.845ZM10.325 13.816c-.822-.08-.469 1.7.03 3.827.026.003.054 0 .082 0a30.21 30.21 0 0 1-.148-2.89c0-.317.013-.632.036-.942v.005Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#C4743D",
        d: "M15.237 22.461h1.08c.262 0 .512-.061.748-.153 1.157-.45 1.982-1.011 2.57-1.582 1.447-1.398 1.46-2.85 1.46-2.85.007-.092.017-.184.025-.273.087-.943.146-1.795.146-2.845 0-.312-.013-.62-.036-.924-.177.136-.36.185-.484-.125-.604-1.539-3.463-3.989-5.273-4.053-.08.01-.159.026-.236.046-.26.12-.93.469-1.51 1.132-.323.417-.566.86-.722 1.18-.07.177-.126.364-.172.563 0 0-.617-.135-1.454.151a.684.684 0 0 0-.389.338c-.156.3-.392.776-.422.812a.921.921 0 0 0-.24-.062c-.024.31-.037.625-.037.942 0 1.068.062 1.93.149 2.89l.02.231s.016 1.667 1.797 3.149c.556.463 1.28.909 2.233 1.28.235.092.489.153.747.153Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "160",
        height: "32",
        x: "40",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "120",
        height: "6",
        x: "48",
        y: "13",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M171 4h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M179.292 14.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.987.987 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.986.986 0 0 0-1.084-.217.997.997 0 0 0-.322.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "32",
        height: "32",
        x: "208",
        fill: "#fff",
        fillOpacity: ".01",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M212 4h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M223.793 9.793a.993.993 0 0 0-.217 1.09c.05.121.124.231.217.324L227.586 15H218a1 1 0 1 0 0 2h9.586l-3.793 3.793a.994.994 0 0 0-.217 1.09 1.002 1.002 0 0 0 1.632.324l5.499-5.5a.997.997 0 0 0 .293-.679v-.057a.995.995 0 0 0-.293-.678l-5.499-5.5a.997.997 0 0 0-1.09-.217.997.997 0 0 0-.325.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "100",
        height: "32",
        x: "248",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "60",
        height: "6",
        x: "256",
        y: "13",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M319 4h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M327.292 14.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.987.987 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.986.986 0 0 0-1.084-.217.997.997 0 0 0-.322.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "99",
        height: "32",
        x: "720",
        fill: "#B3D4FF",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "59",
        height: "6",
        x: "728",
        y: "13",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M790 4h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".25",
        fillRule: "evenodd",
        d: "M798.292 14.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.987.987 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.986.986 0 0 0-1.084-.217.997.997 0 0 0-.322.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "52",
        height: "14",
        x: "40",
        y: "44",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "44",
        height: "6",
        x: "44",
        y: "48",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "206",
        height: "6",
        x: "108",
        y: "48",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "53",
        height: "6",
        y: "90",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M0 106h77v2H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "53",
        height: "6",
        x: "77",
        y: "90",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M77 106h77v2H77z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "53",
        height: "6",
        x: "154",
        y: "90",
        fill: "#4C9AFF",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#4C9AFF",
        d: "M154 106h77v2h-77z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M231 106h589v2H231z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "160",
        height: "32",
        y: "132",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "120",
        height: "6",
        x: "8",
        y: "145",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M131 136h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M139.292 146.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.996.996 0 0 0-.762 0 .997.997 0 0 0-.322.218l-2.298 2.317-2.307-2.327a.994.994 0 0 0-1.084-.217c-.12.051-.23.124-.322.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        clipPath: "url(#PageContentC)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#FAFBFC",
        d: "M268 230h62v389h-62z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "15",
        height: "6",
        x: "280",
        y: "250",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "15",
        height: "6",
        x: "303",
        y: "250",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "15",
        height: "6",
        x: "303",
        y: "272",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "15",
        height: "6",
        x: "280",
        y: "294",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "15",
        height: "6",
        x: "303",
        y: "294",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "15",
        height: "6",
        x: "280",
        y: "316",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "15",
        height: "6",
        x: "303",
        y: "316",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "15",
        height: "6",
        x: "295",
        y: "344",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3",
        transform: "rotate(-180 295 344)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "15",
        height: "6",
        x: "280",
        y: "360",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "15",
        height: "6",
        x: "303",
        y: "360",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "15",
        height: "6",
        x: "280",
        y: "456",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "15",
        height: "6",
        x: "303",
        y: "456",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "15",
        height: "6",
        x: "280",
        y: "500",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "15",
        height: "6",
        x: "303",
        y: "500",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#F4F5F7",
        d: "M268 188h551v42H268z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M280 197h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M288.292 207.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.996.996 0 0 0-.762 0 .997.997 0 0 0-.322.218l-2.298 2.317-2.307-2.327a.994.994 0 0 0-1.084-.217c-.12.051-.23.124-.322.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "89.122",
        height: "6",
        x: "312",
        y: "206",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "10",
        height: "10",
        x: "676",
        y: "204",
        stroke: "#091E42",
        strokeOpacity: ".13",
        strokeWidth: "2",
        rx: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "48",
        height: "6",
        x: "695",
        y: "206",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M751 197h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M765 201.187a10.734 10.734 0 0 0-2-.187c-4.963 0-9 3.37-9 7.513s4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003c.053.02.108.031.164.033a.52.52 0 0 0 .429-.231.516.516 0 0 0 .045-.485v-.002s-1.563-2.26-.766-3.116l-.037.02c1.227-1.284 1.966-2.907 1.966-4.673 0-.171-.006-.342-.02-.513h-2.008c.02.169.03.34.03.513 0 3.039-3.141 5.51-7.002 5.51-3.861 0-7.002-2.471-7.002-5.51 0-3.038 3.141-5.51 7.002-5.51.695 0 1.366.08 2 .229v-2.045Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M770 202a1 1 0 0 0-2 0v4a1 1 0 0 0 2 0v-4Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M771 203h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M783 197h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M795 211a1.507 1.507 0 0 1-1.061-.439 1.507 1.507 0 0 1 0-2.122 1.507 1.507 0 0 1 2.122 0 1.503 1.503 0 0 1 0 2.122A1.503 1.503 0 0 1 795 211Zm-4.5 0a1.507 1.507 0 0 1-1.061-.439 1.507 1.507 0 0 1 0-2.122 1.507 1.507 0 0 1 2.122 0 1.503 1.503 0 0 1 0 2.122 1.503 1.503 0 0 1-1.061.439Zm9 0a1.507 1.507 0 0 1-1.061-.439 1.507 1.507 0 0 1 0-2.122 1.507 1.507 0 0 1 2.122 0 1.503 1.503 0 0 1 0 2.122 1.503 1.503 0 0 1-1.061.439Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        clipPath: "url(#PageContentD)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M338 228h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("circle", {
        cx: "350",
        cy: "240",
        r: "2",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "75",
        height: "6",
        x: "370",
        y: "237",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#E3FCEF",
        d: "M330 250h489v20H330z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M344 254h12v12h-12z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M350.5 259.5v-2a.504.504 0 0 0-.146-.354.504.504 0 0 0-.708 0 .504.504 0 0 0-.146.354v2h-2a.504.504 0 0 0-.354.146.504.504 0 0 0 0 .708.504.504 0 0 0 .354.146h2v2c0 .133.053.26.146.354a.504.504 0 0 0 .708 0 .504.504 0 0 0 .146-.354v-2h2c.133 0 .26-.053.354-.146a.504.504 0 0 0 0-.708.504.504 0 0 0-.354-.146h-2Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "131",
        height: "6",
        x: "370",
        y: "257",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        clipPath: "url(#PageContentE)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M338 288h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("circle", {
        cx: "350",
        cy: "300",
        r: "2",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "209",
        height: "6",
        x: "370",
        y: "297",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        clipPath: "url(#PageContentF)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M338 308h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("circle", {
        cx: "350",
        cy: "320",
        r: "2",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "135",
        height: "6",
        x: "370",
        y: "317",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#FFEBE6",
        d: "M330 330h489v20H330z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "6",
        height: "2",
        x: "347",
        y: "339",
        fill: "#D9D9D9",
        rx: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "83",
        height: "6",
        x: "370",
        y: "337",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#E3FCEF",
        d: "M330 350h489v100H330z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M344 354h12v12h-12z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M350.5 359.5v-2a.504.504 0 0 0-.146-.354.504.504 0 0 0-.708 0 .504.504 0 0 0-.146.354v2h-2a.504.504 0 0 0-.354.146.504.504 0 0 0 0 .708.504.504 0 0 0 .354.146h2v2c0 .133.053.26.146.354a.504.504 0 0 0 .708 0 .504.504 0 0 0 .146-.354v-2h2c.133 0 .26-.053.354-.146a.504.504 0 0 0 0-.708.504.504 0 0 0-.354-.146h-2Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "131",
        height: "6",
        x: "370",
        y: "357",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        d: "M344 374h465v68H344z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        clipPath: "url(#PageContentG)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#C0B6F2",
        d: "M375.904 393.998c0-6.574-5.33-11.904-11.904-11.904s-11.904 5.33-11.904 11.904 5.33 11.904 11.904 11.904 11.904-5.33 11.904-11.904Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#998DD9",
        d: "M369.098 403.32a3.41 3.41 0 0 1-2.116-3.151 3.324 3.324 0 0 1 1.171-2.565c4.694-3.942 1.782-11.574-4.276-11.453-5.935.102-8.634 7.592-4.03 11.453a3.324 3.324 0 0 1 1.171 2.565 3.408 3.408 0 0 1-2.116 3.151c-.368.153-.731.322-1.088.505-.098.051-.194.109-.292.165a11.85 11.85 0 0 0 6.476 1.918c2.391 0 4.616-.709 6.482-1.922a15.005 15.005 0 0 0-.518-.271 12.696 12.696 0 0 0-.866-.393l.002-.002Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "119",
        height: "6",
        x: "388",
        y: "391",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "303.948",
        height: "6",
        x: "352",
        y: "414",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "191.135",
        height: "6",
        x: "352",
        y: "428",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        clipPath: "url(#PageContentH)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M338 448h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("circle", {
        cx: "350",
        cy: "460",
        r: "2",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "135",
        height: "6",
        x: "370",
        y: "457",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        clipPath: "url(#PageContentI)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M338 488h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("circle", {
        cx: "350",
        cy: "500",
        r: "2",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "105",
        height: "6",
        x: "370",
        y: "497",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        stroke: "#091E42",
        strokeOpacity: ".13",
        d: "M268.5 188.5h550v430h-550z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "80",
        height: "32",
        x: "739",
        y: "132",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "64",
        height: "6",
        x: "747",
        y: "145",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M16 196h24v24H16z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M24.292 206.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "131",
        height: "6",
        x: "56",
        y: "205",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M32 236h24v24H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M40.292 246.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "131",
        height: "6",
        x: "72",
        y: "245",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "184",
        height: "20",
        x: "48",
        y: "278",
        fill: "#091E42",
        fillOpacity: ".04",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "79",
        height: "6",
        x: "80",
        y: "285",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M46 276h24v24H46z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M54.292 286.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M16 316h24v24H16z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M24.292 326.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "131",
        height: "6",
        x: "56",
        y: "325",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M32 356h24v24H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M40.292 366.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "131",
        height: "6",
        x: "72",
        y: "365",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M16 396h24v24H16z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M24.292 406.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "131",
        height: "6",
        x: "56",
        y: "405",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M32 436h24v24H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M40.292 446.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "131",
        height: "6",
        x: "72",
        y: "445",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M32 476h24v24H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M40.292 486.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "131",
        height: "6",
        x: "72",
        y: "485",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        stroke: "#091E42",
        strokeOpacity: ".13",
        d: "M.5 188.5h239v430H.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("clipPath", {
        id: "PageContentA"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        d: "M0 0h32v32H0z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("clipPath", {
        id: "PageContentC"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        d: "M268 188h551v431H268z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("clipPath", {
        id: "PageContentD"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        d: "M330 230h489v20H330z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("clipPath", {
        id: "PageContentE"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        d: "M330 290h489v20H330z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("clipPath", {
        id: "PageContentF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        d: "M330 310h489v20H330z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("clipPath", {
        id: "PageContentG"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        d: "M352 382h24v24h-24z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("clipPath", {
        id: "PageContentH"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        d: "M330 450h489v20H330z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("clipPath", {
        id: "PageContentI"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        d: "M330 490h489v20H330z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("linearGradient", {
        id: "PageContentB",
        x1: "15.944",
        x2: "15.944",
        y1: "35.84",
        y2: "20.992",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("stop", {
        stopColor: "#C4743D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("stop", {
        offset: ".43",
        stopColor: "#BB703A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("stop", {
        offset: "1",
        stopColor: "#A96935"
    }))));
};

});

parcelRegister("5TSRQ", function(module, exports) {

$parcel$export(module.exports, "PageHeader", function () { return $44bca65ab2347600$export$53f1cd6809577fc5; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $91i6m = parcelRequire("91i6m");

var $9jjaN = parcelRequire("9jjaN");

var $lneJV = parcelRequire("lneJV");
var $44bca65ab2347600$export$53f1cd6809577fc5 = function PageHeader() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($44bca65ab2347600$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($44bca65ab2347600$var$Image, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $44bca65ab2347600$var$Wrapper = (0, $9jjaN.default).div({
    position: 'fixed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $lneJV.HEADER_HEIGHT), "px"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    left: "".concat((0, $lneJV.SECONDARY_NAV_WIDTH), "px")
});
var $44bca65ab2347600$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "467",
        height: "112",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "100",
        height: "6",
        x: "24",
        y: "39",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "54",
        height: "6",
        x: "137",
        y: "39",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#6B778C",
        d: "m129.372 49.105 3.548-12.44h-1.299l-3.541 12.44h1.292Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "419.328",
        height: "20",
        x: "24",
        y: "68",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }));
};

});

parcelRegister("bM2C8", function(module, exports) {

$parcel$export(module.exports, "Search", function () { return $89263483d4c04f8c$export$4b85d3515bd863a5; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $91i6m = parcelRequire("91i6m");

var $9jjaN = parcelRequire("9jjaN");
var $89263483d4c04f8c$export$4b85d3515bd863a5 = function Search() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($89263483d4c04f8c$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($89263483d4c04f8c$var$Image, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $89263483d4c04f8c$var$Wrapper = (0, $9jjaN.default).div({
    position: 'fixed',
    top: 0,
    right: 0
});
var $89263483d4c04f8c$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "412",
        height: "56",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M356 12h32v32h-32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        clipPath: "url(#SearchA)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#B2D4FF",
        d: "M386.93 27.996c0-8.246-6.685-14.931-14.931-14.931-8.247 0-14.932 6.685-14.932 14.931 0 8.247 6.685 14.932 14.932 14.932 8.246 0 14.931-6.685 14.931-14.932Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#2684FF",
        d: "M378.394 39.69a4.277 4.277 0 0 1-2.655-3.95 4.172 4.172 0 0 1 1.471-3.218c5.888-4.944 2.235-14.518-5.364-14.364-7.444.127-10.831 9.523-5.054 14.364a4.178 4.178 0 0 1 1.471 3.218 4.27 4.27 0 0 1-2.654 3.95c-.463.192-.917.406-1.366.632-.125.064-.242.139-.365.206a14.862 14.862 0 0 0 8.124 2.407c3 0 5.792-.888 8.129-2.41a16.828 16.828 0 0 0-1.735-.835h-.002Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        clipPath: "url(#SearchB)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "238",
        height: "32",
        x: "25",
        y: "12",
        fill: "#F4F5F7",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M46 27a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-.523 4.89a6 6 0 1 1 1.414-1.414l2.816 2.817a1 1 0 0 1-1.414 1.414l-2.816-2.816Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M274 16h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M280.485 33.669a2 2 0 0 0 2.829 0l-2.829-2.83a2.004 2.004 0 0 0-.434 2.18c.101.244.248.464.434.65Zm4.897-12.191-.725.725c-.782.782-2.21 1.813-3.206 2.311l-3.017 1.509c-.495.248-.584.774-.187 1.171l8.556 8.556c.398.396.922.313 1.171-.188l1.51-3.016c.494-.988 1.526-2.42 2.311-3.206l.725-.726a5.046 5.046 0 0 0 .64-6.356 1.01 1.01 0 1 0-1.354-1.494c-.023.025-.046.049-.066.075a5.044 5.044 0 0 0-4.72-.457 5.03 5.03 0 0 0-1.638 1.095v.001Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M314 16h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M336 28c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10Zm-7.172-4.84a3.97 3.97 0 0 1 1.062 1.89 3.988 3.988 0 0 1-2.536 4.698.507.507 0 0 0-.35.472v.782a1.005 1.005 0 0 1-1.002 1.002A1.003 1.003 0 0 1 325 31.002v-2.014a.998.998 0 0 1 1-.987h-.007a2.004 2.004 0 0 0 2.003-2 2.003 2.003 0 0 0-3.405-1.386 2 2 0 0 0-.602 1.388c-.002.551-.45.998-1.002.998a.993.993 0 0 1-.982-.904L322 25.95c.017-2.504 2.321-4.436 4.933-3.842a3.973 3.973 0 0 1 1.895 1.052ZM327 34a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("clipPath", {
        id: "SearchA"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        d: "M357 13h30v30h-30z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("clipPath", {
        id: "SearchB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        d: "M24 11h314v34H24z"
    }))));
};

});

parcelRegister("bZcmN", function(module, exports) {

$parcel$export(module.exports, "SecondaryNav", function () { return $8b9efbf8ecb9e214$export$b982c89a8be501e8; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $91i6m = parcelRequire("91i6m");

var $9jjaN = parcelRequire("9jjaN");

var $8UWUV = parcelRequire("8UWUV");
var $8b9efbf8ecb9e214$export$b982c89a8be501e8 = function SecondaryNav() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($8b9efbf8ecb9e214$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($8b9efbf8ecb9e214$var$Image, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $8b9efbf8ecb9e214$var$Wrapper = (0, $9jjaN.default)((0, $8UWUV.SecondaryNavWrapper))({
    borderRight: '24px solid #fff'
});
var $8b9efbf8ecb9e214$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "240",
        height: "775",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#F4F5F7",
        d: "M0 0h240v775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        clipPath: "url(#SecondaryNavA)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M26 88h24v24H26z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "32",
        height: "32",
        x: "22",
        y: "84",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "71",
        height: "8",
        x: "66",
        y: "96",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "32",
        height: "32",
        x: "22",
        y: "124",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "71",
        height: "8",
        x: "66",
        y: "136",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M26 168h24v24H26z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "32",
        height: "32",
        x: "22",
        y: "164",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "71",
        height: "8",
        x: "66",
        y: "176",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "208",
        height: "40",
        x: "16",
        y: "200",
        fill: "#091E42",
        fillOpacity: ".04",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M26 208h24v24H26z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "32",
        height: "32",
        x: "22",
        y: "204",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "71",
        height: "8",
        x: "66",
        y: "216",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "32",
        height: "32",
        x: "22",
        y: "244",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "71",
        height: "8",
        x: "66",
        y: "256",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "32",
        height: "32",
        x: "22",
        y: "284",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "71",
        height: "8",
        x: "66",
        y: "296",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "120",
        height: "12",
        x: "74",
        y: "38",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "40",
        height: "40",
        x: "18",
        y: "24",
        fill: "#DEEBFF",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("clipPath", {
        id: "SecondaryNavA"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        d: "M16 80h208v240H16z"
    }))));
};

});
parcelRegister("8UWUV", function(module, exports) {

$parcel$export(module.exports, "SecondaryNavWrapper", function () { return $67e141643e5b8a0e$export$fd2a3539d2004332; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $91i6m = parcelRequire("91i6m");

var $9jjaN = parcelRequire("9jjaN");

var $lneJV = parcelRequire("lneJV");
var $67e141643e5b8a0e$export$fd2a3539d2004332 = function SecondaryNavWrapper(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($67e141643e5b8a0e$var$Background, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($67e141643e5b8a0e$var$Wrapper, null, children));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $67e141643e5b8a0e$var$Background = (0, $9jjaN.default).div({
    display: 'inline-block',
    position: 'fixed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $lneJV.HEADER_HEIGHT), "px"),
    left: 0,
    height: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: "".concat((0, $lneJV.SECONDARY_NAV_WIDTH), "px"),
    background: '#f4f5f7'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $67e141643e5b8a0e$var$Wrapper = (0, $9jjaN.default).div({
    position: 'fixed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $lneJV.HEADER_HEIGHT), "px"),
    left: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: "".concat((0, $lneJV.SECONDARY_NAV_WIDTH), "px")
});

});


parcelRegister("duKnJ", function(module, exports) {

$parcel$export(module.exports, "Sidebar", function () { return $9d320e244831972a$export$1ba59dacbcbf90fe; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $91i6m = parcelRequire("91i6m");

var $9jjaN = parcelRequire("9jjaN");

var $lneJV = parcelRequire("lneJV");
var $9d320e244831972a$export$1ba59dacbcbf90fe = function Sidebar() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($9d320e244831972a$var$Background, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($9d320e244831972a$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($9d320e244831972a$var$Image, null)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $9d320e244831972a$var$Background = (0, $9jjaN.default).div({
    display: 'inline-block',
    position: 'fixed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $lneJV.HEADER_HEIGHT), "px"),
    right: 0,
    height: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: "".concat((0, $lneJV.SIDEBAR_WIDTH) - 2, "px"),
    background: '#fafbfc',
    borderLeft: '2px solid #dfe1e6'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $9d320e244831972a$var$Wrapper = (0, $9jjaN.default).div({
    position: 'fixed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $lneJV.HEADER_HEIGHT), "px"),
    right: 0,
    borderLeft: '24px solid #fff'
});
var $9d320e244831972a$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "333",
        height: "776",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("mask", {
        id: "SidebarH",
        fill: "#fff"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M0 0h333v776H0V0Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#FAFBFC",
        d: "M0 0h333v776H0V0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "89.122",
        height: "6",
        x: "32",
        y: "40",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        filter: "url(#SidebarA)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        d: "M32 70h269v175H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "24",
        height: "24",
        x: "44",
        y: "81",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "78",
        height: "6",
        x: "80",
        y: "90",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M265 81h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M273.292 91.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.987.987 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.986.986 0 0 0-1.084-.217.997.997 0 0 0-.322.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M32 117h269v-1H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        clipPath: "url(#SidebarB)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#B2D4FF",
        d: "M71.944 135.997c0-6.597-5.348-11.945-11.945-11.945s-11.945 5.348-11.945 11.945 5.348 11.945 11.945 11.945 11.945-5.348 11.945-11.945Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#2684FF",
        d: "M65.115 145.352a3.421 3.421 0 0 1-2.124-3.16 3.338 3.338 0 0 1 1.177-2.575c4.71-3.955 1.788-11.614-4.29-11.491-5.957.102-8.666 7.619-4.044 11.491a3.344 3.344 0 0 1 1.177 2.575 3.416 3.416 0 0 1-2.124 3.16c-.37.154-.733.325-1.092.505-.1.052-.194.112-.292.165a11.882 11.882 0 0 0 6.499 1.926c2.4 0 4.633-.71 6.503-1.928a13.607 13.607 0 0 0-1.388-.668h-.002Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "130",
        height: "6",
        x: "80",
        y: "133",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        clipPath: "url(#SidebarC)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#B2D4FF",
        d: "M72 176c0-6.627-5.373-12-12-12s-12 5.373-12 12 5.373 12 12 12 12-5.373 12-12Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#2684FF",
        d: "M65.12 185.395a3.43 3.43 0 0 1-1.77-1.648l3.01.006c.719.004 1.212-.818.853-1.448a5.53 5.53 0 0 1-.622-2.561v-4.867a6.833 6.833 0 0 0-1.758-4.662c-3.493-3.825-9.956-2.25-11.202 2.838-.44 1.194-.196 5.357-.253 6.666a5.478 5.478 0 0 1-.628 2.561.983.983 0 0 0 .854 1.452l3.015.006a3.431 3.431 0 0 1-1.776 1.658c-.292.125-.586.252-.87.396-.175.084-.346.177-.515.269a11.943 11.943 0 0 0 6.544 1.943c2.407 0 4.646-.711 6.524-1.932a10.607 10.607 0 0 0-.538-.28 13.187 13.187 0 0 0-.87-.396l.003-.001Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "130",
        height: "6",
        x: "80",
        y: "173",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M48 204h24v24H48z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M61 215v-7.007a.996.996 0 0 0-1-.993c-.556 0-1 .445-1 .993V215h-7.007a.999.999 0 0 0-.993 1c0 .557.445 1 .993 1H59v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V217h7.007a.998.998 0 0 0 .993-1c0-.556-.445-1-.993-1H61Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "90",
        height: "6",
        x: "80",
        y: "213",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        filter: "url(#SidebarD)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        d: "M32 261h269v174H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "24",
        height: "24",
        x: "44",
        y: "272",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "114",
        height: "6",
        x: "80",
        y: "281",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#F4F5F7",
        fillRule: "evenodd",
        d: "M218 292a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M265 272h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M273.292 282.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.996.996 0 0 0-.762 0 .997.997 0 0 0-.322.218l-2.298 2.317-2.307-2.327a.994.994 0 0 0-1.084-.217c-.12.051-.23.124-.322.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M32 307.731h269v-.994H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#F4F5F7",
        fillRule: "evenodd",
        d: "M60 335a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "170",
        height: "6",
        x: "80",
        y: "324",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#F4F5F7",
        fillRule: "evenodd",
        d: "M60 375a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "139",
        height: "6",
        x: "80",
        y: "364",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M50 397h20v20H50z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#36B37E",
        fillRule: "evenodd",
        d: "M68.333 407a8.333 8.333 0 1 1-16.666 0 8.333 8.333 0 0 1 16.666 0Zm-10.514-.776a.833.833 0 0 1 .27.187l1.078 1.077 2.744-2.744a.847.847 0 0 1 .27-.187.846.846 0 0 1 .645-.005.838.838 0 0 1 .517.778.837.837 0 0 1-.254.593l-3.333 3.333a.834.834 0 0 1-1.179 0l-1.666-1.667a.84.84 0 0 1-.255-.592.834.834 0 0 1 1.163-.773Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "194",
        height: "6",
        x: "80",
        y: "404",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        filter: "url(#SidebarE)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        d: "M32 452h269v174H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "24",
        height: "24",
        x: "44",
        y: "463",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "114",
        height: "6",
        x: "80",
        y: "472",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M265 463h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M273.292 473.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.996.996 0 0 0-.762 0 .997.997 0 0 0-.322.218l-2.298 2.317-2.307-2.327a.994.994 0 0 0-1.084-.217c-.12.051-.23.124-.322.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M32 498.731h269v-.994H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "12",
        height: "12",
        x: "48",
        y: "512",
        fill: "#0052CC",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M57.207 515.793a1 1 0 0 1 0 1.414l-3.5 3.5a1 1 0 0 1-1.414 0l-1.5-1.5a1 1 0 1 1 1.414-1.414l.793.793 2.793-2.793a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "71",
        height: "6",
        x: "76",
        y: "515",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "12",
        height: "12",
        x: "48",
        y: "552",
        fill: "#fff",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "10",
        height: "10",
        x: "49",
        y: "553",
        stroke: "#091E42",
        strokeOpacity: ".13",
        strokeWidth: "2",
        rx: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "131",
        height: "6",
        x: "76",
        y: "555",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "12",
        height: "12",
        x: "48",
        y: "592",
        fill: "#fff",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "10",
        height: "10",
        x: "49",
        y: "593",
        stroke: "#091E42",
        strokeOpacity: ".13",
        strokeWidth: "2",
        rx: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "71",
        height: "6",
        x: "76",
        y: "595",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        filter: "url(#SidebarF)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        d: "M32 643h269v48H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "24",
        height: "24",
        x: "44",
        y: "654",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "114",
        height: "6",
        x: "80",
        y: "663",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M265 678v-24h24v24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M275.293 669.708a1.009 1.009 0 0 0 1.419 0l2.965-2.939c.215-.218.322-.5.322-.779s-.107-.556-.322-.769l-2.955-2.93a1.008 1.008 0 0 0-1.637.322.996.996 0 0 0 0 .762c.051.121.125.23.218.322l2.317 2.298-2.327 2.307a.99.99 0 0 0 0 1.406Z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        filter: "url(#SidebarG)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        d: "M32 707h269v48H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "24",
        height: "24",
        x: "44",
        y: "718",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: "114",
        height: "6",
        x: "80",
        y: "727",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M265 742v-24h24v24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M275.293 733.708a1.009 1.009 0 0 0 1.419 0l2.965-2.939c.215-.218.322-.5.322-.779s-.107-.556-.322-.769l-2.955-2.93a1.008 1.008 0 0 0-1.637.322.996.996 0 0 0 0 .762c.051.121.125.23.218.322l2.317 2.298-2.327 2.307a.99.99 0 0 0 0 1.406Z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M2 776V0h-4v776h4Z",
        mask: "url(#SidebarH)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("filter", {
        id: "SidebarA",
        width: "271",
        height: "179",
        x: "31",
        y: "68",
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feBlend", {
        in2: "effect1_dropShadow_943_3604",
        result: "effect2_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_943_3604",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("filter", {
        id: "SidebarD",
        width: "271",
        height: "178",
        x: "31",
        y: "259",
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feBlend", {
        in2: "effect1_dropShadow_943_3604",
        result: "effect2_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_943_3604",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("filter", {
        id: "SidebarE",
        width: "271",
        height: "178",
        x: "31",
        y: "450",
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feBlend", {
        in2: "effect1_dropShadow_943_3604",
        result: "effect2_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_943_3604",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("filter", {
        id: "SidebarF",
        width: "271",
        height: "52",
        x: "31",
        y: "641",
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feBlend", {
        in2: "effect1_dropShadow_943_3604",
        result: "effect2_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_943_3604",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("filter", {
        id: "SidebarG",
        width: "271",
        height: "52",
        x: "31",
        y: "705",
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feBlend", {
        in2: "effect1_dropShadow_943_3604",
        result: "effect2_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_943_3604",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("clipPath", {
        id: "SidebarB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        d: "M48 124h24v24H48z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("clipPath", {
        id: "SidebarC"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        d: "M48 164h24v24H48z"
    }))));
};

});


parcelRegister("f1J6u", function(module, exports) {

$parcel$export(module.exports, "DesktopOnlyBackground", function () { return $af09efa37df1d625$export$5e40b6732fa22ace; });
$parcel$export(module.exports, "useMatchMedia", function () { return $af09efa37df1d625$export$dd42f485803cd57d; });

var $5YM7L = parcelRequire("5YM7L");

var $91i6m = parcelRequire("91i6m");

var $aA6j8 = parcelRequire("aA6j8");

var $8dZTS = parcelRequire("8dZTS");

var $f1k1y = parcelRequire("f1k1y");

var $9wl70 = parcelRequire("9wl70");
var $af09efa37df1d625$export$5e40b6732fa22ace = function DesktopOnlyBackground(_ref) {
    var Background = _ref.background, children = _ref.children;
    var isAboveSmallScreen = $af09efa37df1d625$export$dd42f485803cd57d((0, $9wl70.media).above.sm);
    if ((0, $f1k1y.fg)('tblz-2487_fix_product_wireframe_child_rerender')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Fragment, null, isAboveSmallScreen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(Background, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $8dZTS.default), {
        isTinted: isAboveSmallScreen
    }, children));
    return isAboveSmallScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(Background, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $8dZTS.default), {
        isTinted: true
    }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Fragment, null, children);
};
var $af09efa37df1d625$export$dd42f485803cd57d = function useMatchMedia(mediaQuery) {
    var query = mediaQuery.replace('@media', '').trim();
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).useState(function() {
        return window.matchMedia(query).matches;
    }), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_React$useState, 2), matches = _React$useState2[0], setMatches = _React$useState2[1];
    (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).useLayoutEffect(function() {
        var screen = window.matchMedia(query);
        var unbind = (0, $aA6j8.bind)(screen, {
            type: 'change',
            listener: function listener(e) {
                setMatches(e.matches);
            }
        });
        return unbind;
    }, [
        query
    ]);
    return matches;
};

});
parcelRegister("8dZTS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fcf8db75e63239e$export$2e2bcd8739ae039; });
/* blanket.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");
var $5oJNc = parcelRequire("5oJNc");

var $koa2c = parcelRequire("koa2c");

var $zHGvR = parcelRequire("zHGvR");

var $c7aTz = parcelRequire("c7aTz");

function $5fcf8db75e63239e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5fcf8db75e63239e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5fcf8db75e63239e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5fcf8db75e63239e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5fcf8db75e63239e$var$packageName = "@atlaskit/blanket";
var $5fcf8db75e63239e$var$packageVersion = "15.0.3";
var $5fcf8db75e63239e$var$analyticsAttributes = {
    componentName: 'blanket',
    packageName: $5fcf8db75e63239e$var$packageName,
    packageVersion: $5fcf8db75e63239e$var$packageVersion
};
var $5fcf8db75e63239e$var$baseStyles = null;
var $5fcf8db75e63239e$var$shouldAllowClickThroughStyles = null;
var $5fcf8db75e63239e$var$invisibleStyles = null;
/**
 * __Blanket__
 *
 * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
 *
 * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
 */ var $5fcf8db75e63239e$var$Blanket = /*#__PURE__*/ (0, $91i6m.memo)(/*#__PURE__*/ (0, $91i6m.forwardRef)(function Blanket(_ref, ref) {
    var _ref$shouldAllowClick = _ref.shouldAllowClickThrough, shouldAllowClickThrough = _ref$shouldAllowClick === void 0 ? false : _ref$shouldAllowClick, _ref$isTinted = _ref.isTinted, isTinted = _ref$isTinted === void 0 ? false : _ref$isTinted, _ref$onBlanketClicked = _ref.onBlanketClicked, onBlanketClicked = _ref$onBlanketClicked === void 0 ? (0, $zHGvR.default) : _ref$onBlanketClicked, testId = _ref.testId, children = _ref.children, analyticsContext = _ref.analyticsContext;
    var mouseDownTarget = (0, $91i6m.useRef)(null);
    var onBlanketClickedWithAnalytics = (0, $koa2c.usePlatformLeafEventHandler)($5fcf8db75e63239e$var$_objectSpread({
        fn: onBlanketClicked,
        action: 'clicked',
        analyticsData: analyticsContext
    }, $5fcf8db75e63239e$var$analyticsAttributes));
    var blanketClickOutsideChildren = (0, $91i6m.useCallback)(function(e) {
        return e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined;
    }, [
        onBlanketClickedWithAnalytics
    ]);
    var onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    var onMouseDown = (0, $91i6m.useCallback)(function(e) {
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ $91i6m.createElement("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, $9gzWK.default)([
            "_1r04idpf _kqsw1n9t _1pbybfng _bfhk705f _18m91wug _lcxv1wug",
            shouldAllowClickThrough && "_lcxvglyw",
            !isTinted && "_bfhk1j28"
        ]),
        style: {
            "--_10avjlk": (0, $5oJNc.default)("var(--ds-blanket, ".concat((0, $c7aTz.N100A), ")"))
        }
    }, children);
}));
$5fcf8db75e63239e$var$Blanket.displayName = 'Blanket';
var $5fcf8db75e63239e$export$2e2bcd8739ae039 = $5fcf8db75e63239e$var$Blanket;

});
parcelRegister("zHGvR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06b527de5455032d$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $06b527de5455032d$export$2e2bcd8739ae039() {}

});

parcelRegister("c7aTz", function(module, exports) {

$parcel$export(module.exports, "N100A", function () { return $8d1e97114d1fdbfd$export$486ab785e4bac3c6; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $8d1e97114d1fdbfd$export$4b84fd0e2c617bd = '#FFEBE6';
var $8d1e97114d1fdbfd$export$b34b069eff244586 = '#FFBDAD';
var $8d1e97114d1fdbfd$export$be802dd0d8b57f35 = '#FF8F73';
var $8d1e97114d1fdbfd$export$60847d42f9da92a6 = '#FF7452';
var $8d1e97114d1fdbfd$export$4a7404f376229999 = '#FF5630';
var $8d1e97114d1fdbfd$export$2010d0fb4295b346 = '#DE350B';
var $8d1e97114d1fdbfd$export$2837b5a1a71d5c02 = '#BF2600';
var $8d1e97114d1fdbfd$export$8d9596b529bbb9cf = '#FFFAE6';
var $8d1e97114d1fdbfd$export$41060a744ab0b7ae = '#FFF0B3';
var $8d1e97114d1fdbfd$export$1cc05bbbf340e559 = '#FFE380';
var $8d1e97114d1fdbfd$export$5aae31392d72caaa = '#FFC400';
var $8d1e97114d1fdbfd$export$c6930421db9fa514 = '#FFAB00';
var $8d1e97114d1fdbfd$export$59619663aa6500fb = '#FF991F';
var $8d1e97114d1fdbfd$export$874739ea9e379ab6 = '#FF8B00';
var $8d1e97114d1fdbfd$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $8d1e97114d1fdbfd$export$69a3bf21b9686c2b = '#ABF5D1';
var $8d1e97114d1fdbfd$export$afbce1382ec95f73 = '#79F2C0';
var $8d1e97114d1fdbfd$export$747d86715d4175de = '#57D9A3';
var $8d1e97114d1fdbfd$export$940e1f69e873f202 = '#36B37E';
var $8d1e97114d1fdbfd$export$a49394138f7b8e85 = '#00875A';
var $8d1e97114d1fdbfd$export$6fa04827ac68a4fb = '#006644';
var $8d1e97114d1fdbfd$export$226de0355ed012f8 = '#DEEBFF';
var $8d1e97114d1fdbfd$export$8c13c2ee36917869 = '#B3D4FF';
var $8d1e97114d1fdbfd$export$ecfc1dff386a3e7a = '#4C9AFF';
var $8d1e97114d1fdbfd$export$215b7063051591f1 = '#2684FF';
var $8d1e97114d1fdbfd$export$e62e8919cca44969 = '#0065FF';
var $8d1e97114d1fdbfd$export$b3de0ae08da2ce64 = '#0052CC';
var $8d1e97114d1fdbfd$export$a6ee3d71bc067634 = '#0747A6';
var $8d1e97114d1fdbfd$export$67f15409e87642a1 = '#669DF1';
var $8d1e97114d1fdbfd$export$f0539dbc42dbb067 = '#8FB8F6';
var $8d1e97114d1fdbfd$export$363e4475840015bb = '#EAE6FF';
var $8d1e97114d1fdbfd$export$4b0a4417ed59760f = '#C0B6F2';
var $8d1e97114d1fdbfd$export$6011520a64d9a187 = '#998DD9';
var $8d1e97114d1fdbfd$export$a7175d4e9206bc80 = '#8777D9';
var $8d1e97114d1fdbfd$export$b48405b95304b5a1 = '#6554C0';
var $8d1e97114d1fdbfd$export$c71e4279dd54a18d = '#5243AA';
var $8d1e97114d1fdbfd$export$147899de772240ec = '#403294';
var $8d1e97114d1fdbfd$export$2cf711fe14c66f06 = '#E6FCFF';
var $8d1e97114d1fdbfd$export$7a8f4d33f6f9772c = '#B3F5FF';
var $8d1e97114d1fdbfd$export$776c9c497ef08533 = '#79E2F2';
var $8d1e97114d1fdbfd$export$69cb3ca10c1e330e = '#00C7E6';
var $8d1e97114d1fdbfd$export$9dc1ef0f3f48059b = '#00B8D9';
var $8d1e97114d1fdbfd$export$7c835c78b6fcdef8 = '#00A3BF';
var $8d1e97114d1fdbfd$export$6036577f95c3877e = '#008DA6';
var $8d1e97114d1fdbfd$export$29a4f05edc054374 = '#FFFFFF';
var $8d1e97114d1fdbfd$export$e655ef011c4aa1a2 = '#FAFBFC';
var $8d1e97114d1fdbfd$export$9fdfb749e33cdf97 = '#F4F5F7';
var $8d1e97114d1fdbfd$export$3e51e8f1440314ba = '#EBECF0';
var $8d1e97114d1fdbfd$export$1ce2d1575d444ceb = '#DFE1E6';
var $8d1e97114d1fdbfd$export$8754fc7e6d8b3000 = '#C1C7D0';
var $8d1e97114d1fdbfd$export$c2e91cbeada39b8b = '#B3BAC5';
var $8d1e97114d1fdbfd$export$5f71e19f3a7ad9de = '#A5ADBA';
var $8d1e97114d1fdbfd$export$eaa8c8a70ac22806 = '#97A0AF';
var $8d1e97114d1fdbfd$export$7c87d337fb91a97d = '#8993A4';
var $8d1e97114d1fdbfd$export$d6447c357493214f = '#7A869A';
var $8d1e97114d1fdbfd$export$f563ee71e9ee74cd = '#6B778C';
var $8d1e97114d1fdbfd$export$e2ef2124cf4024b1 = '#5E6C84';
var $8d1e97114d1fdbfd$export$eece5f492e429f08 = '#505F79';
var $8d1e97114d1fdbfd$export$c39c0fe0f26207ae = '#42526E';
var $8d1e97114d1fdbfd$export$7090862dc3038a9f = '#344563';
var $8d1e97114d1fdbfd$export$ad0bacf983b7ddaa = '#253858';
var $8d1e97114d1fdbfd$export$7d61b15e0da132af = '#172B4D';
var $8d1e97114d1fdbfd$export$fbda843f0a27fe96 = '#091E42';
var $8d1e97114d1fdbfd$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $8d1e97114d1fdbfd$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $8d1e97114d1fdbfd$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $8d1e97114d1fdbfd$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $8d1e97114d1fdbfd$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $8d1e97114d1fdbfd$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $8d1e97114d1fdbfd$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $8d1e97114d1fdbfd$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $8d1e97114d1fdbfd$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $8d1e97114d1fdbfd$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $8d1e97114d1fdbfd$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $8d1e97114d1fdbfd$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $8d1e97114d1fdbfd$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $8d1e97114d1fdbfd$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $8d1e97114d1fdbfd$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $8d1e97114d1fdbfd$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $8d1e97114d1fdbfd$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $8d1e97114d1fdbfd$export$2f6319cf7d736c2a = '#E6EDFA';
var $8d1e97114d1fdbfd$export$95126bc8884d6634 = '#DCE5F5';
var $8d1e97114d1fdbfd$export$8338d8c35d44ff1 = '#CED9EB';
var $8d1e97114d1fdbfd$export$5368d76ae4fbbda7 = '#B8C7E0';
var $8d1e97114d1fdbfd$export$9f0a771d16ec8d36 = '#ABBBD6';
var $8d1e97114d1fdbfd$export$abcf8c38338b4aa5 = '#9FB0CC';
var $8d1e97114d1fdbfd$export$97e81faa16a182c7 = '#8C9CB8';
var $8d1e97114d1fdbfd$export$bfe21c59123ecf33 = '#7988A3';
var $8d1e97114d1fdbfd$export$ee82aa2ea6a1558 = '#67758F';
var $8d1e97114d1fdbfd$export$682927c6ed76be02 = '#56637A';
var $8d1e97114d1fdbfd$export$91fd9994c5be9757 = '#455166';
var $8d1e97114d1fdbfd$export$d281fbfe3cff2df6 = '#3B475C';
var $8d1e97114d1fdbfd$export$3902c91d8b98a753 = '#313D52';
var $8d1e97114d1fdbfd$export$8e8133c1ba5845b5 = '#283447';
var $8d1e97114d1fdbfd$export$33ff357f6620b39 = '#202B3D';
var $8d1e97114d1fdbfd$export$633847cf062b69e0 = '#1B2638';
var $8d1e97114d1fdbfd$export$9776a6e503bdbf76 = '#121A29';
var $8d1e97114d1fdbfd$export$6c813d5160dff5db = '#0E1624';
var $8d1e97114d1fdbfd$export$3d4f271a500072a = '#0D1424';
var $8d1e97114d1fdbfd$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $8d1e97114d1fdbfd$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $8d1e97114d1fdbfd$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $8d1e97114d1fdbfd$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $8d1e97114d1fdbfd$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $8d1e97114d1fdbfd$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $8d1e97114d1fdbfd$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $8d1e97114d1fdbfd$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $8d1e97114d1fdbfd$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $8d1e97114d1fdbfd$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $8d1e97114d1fdbfd$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $8d1e97114d1fdbfd$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $8d1e97114d1fdbfd$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $8d1e97114d1fdbfd$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $8d1e97114d1fdbfd$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $8d1e97114d1fdbfd$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $8d1e97114d1fdbfd$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $8d1e97114d1fdbfd$export$d2adc5dedf09fced = '#292A2E';
var $8d1e97114d1fdbfd$export$f51762073d2bb381 = '#94C748';
var $8d1e97114d1fdbfd$export$95e26d54def96891 = '#B3DF72';

});





parcelRegister("6g8IV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc129f748c10d677$export$2e2bcd8739ae039; });

var $kxTQF = parcelRequire("kxTQF");

var $4zgnR = parcelRequire("4zgnR");

var $eQ1c9 = parcelRequire("eQ1c9");

var $4ksd4 = parcelRequire("4ksd4");
const $fc129f748c10d677$export$a882740fcd1752cc = (0, $4ksd4.backgroundWithSideImages)((0, (/*@__PURE__*/$parcel$interopDefault($kxTQF))), (0, (/*@__PURE__*/$parcel$interopDefault($4zgnR))));
const $fc129f748c10d677$var$CompassCobranding = {
    background: $fc129f748c10d677$export$a882740fcd1752cc,
    logo: {
        component: (0, $eQ1c9.CompassLogo)
    },
    footerProducts: 'Trello, Jira, Confluence'
};
var $fc129f748c10d677$export$2e2bcd8739ae039 = $fc129f748c10d677$var$CompassCobranding;

});

parcelRegister("5o6Xw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c06aed62c9f413f8$export$2e2bcd8739ae039; });

var $eQ1c9 = parcelRequire("eQ1c9");

var $cq0s9 = parcelRequire("cq0s9");
const $c06aed62c9f413f8$var$ConfluenceCobranding = {
    background: (0, $cq0s9.ConfluenceBackground),
    logo: {
        component: (0, $eQ1c9.ConfluenceLogo)
    },
    footerProducts: 'Confluence, Jira, Trello'
};
var $c06aed62c9f413f8$export$2e2bcd8739ae039 = $c06aed62c9f413f8$var$ConfluenceCobranding;

});
parcelRegister("cq0s9", function(module, exports) {

$parcel$export(module.exports, "ConfluenceBackground", function () { return $90a843b9a6a34007$export$b0d291b61d581ffd; });

var $91i6m = parcelRequire("91i6m");

var $4sggA = parcelRequire("4sggA");

var $eqNbw = parcelRequire("eqNbw");

var $dyzBB = parcelRequire("dyzBB");

var $f1J6u = parcelRequire("f1J6u");
var $90a843b9a6a34007$export$b0d291b61d581ffd = function ConfluenceBackground(_ref) {
    var children = _ref.children;
    var isDarkMode = (0, $4sggA.default)().colorMode === 'dark';
    var Background = isDarkMode ? (0, $eqNbw.ConfluenceDarkTheme) : (0, $dyzBB.ConfluenceLightTheme);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $f1J6u.DesktopOnlyBackground), {
        background: Background
    }, children);
};

});
parcelRegister("eqNbw", function(module, exports) {

$parcel$export(module.exports, "ConfluenceDarkTheme", function () { return $a819a57dd42fb4ff$export$42b780ab52e6a23f; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $91i6m = parcelRequire("91i6m");

var $dwV3h = parcelRequire("dwV3h");
var $hPyLR = parcelRequire("hPyLR");

var $eILiL = parcelRequire("eILiL");

var $fHcf2 = parcelRequire("fHcf2");

var $aq3px = parcelRequire("aq3px");

var $iiPvr = parcelRequire("iiPvr");

var $cEAXG = parcelRequire("cEAXG");

var $lrB9E = parcelRequire("lrB9E");

var $5MD4w = parcelRequire("5MD4w");

var $fMFDo = parcelRequire("fMFDo");
var $a819a57dd42fb4ff$var$styles = {
    actions: "_ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q"
};
var $a819a57dd42fb4ff$export$42b780ab52e6a23f = function ConfluenceDarkTheme() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $fHcf2.Background), {
        testId: "testId-confluence-wireframe"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $aq3px.TopNav), {
        product: (0, $eILiL.Products).CONFLUENCE
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $dwV3h.default), {
        alignBlock: "stretch",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $fMFDo.SideNav), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $hPyLR.default), {
        grow: "fill",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $dwV3h.default), {
        xcss: $a819a57dd42fb4ff$var$styles.actions,
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $cEAXG.Breadcrumbs), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iiPvr.Actions), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $dwV3h.default), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $lrB9E.Content), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $5MD4w.FloatingActions), null));
};

});
parcelRegister("eILiL", function(module, exports) {

$parcel$export(module.exports, "Products", function () { return $ab79dde33251a63c$export$92e44ea1079b9ec6; });
var $ab79dde33251a63c$export$92e44ea1079b9ec6 = {
    JIRA: 'jira',
    CONFLUENCE: 'confluence',
    JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
    JIRA_SERVICE_MANAGEMENT: 'jira-service-management'
};

});

parcelRegister("fHcf2", function(module, exports) {

$parcel$export(module.exports, "Background", function () { return $b6d45e13b2379a93$export$668799e4797757a8; });
/* background.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $91i6m = parcelRequire("91i6m");

var $hPyLR = parcelRequire("hPyLR");
var $b6d45e13b2379a93$var$styles = {
    background: "_bfhkvuon _1tke1osq"
};
var $b6d45e13b2379a93$export$668799e4797757a8 = function Background(_ref) {
    var children = _ref.children, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $hPyLR.default), {
        xcss: $b6d45e13b2379a93$var$styles.background,
        testId: testId
    }, children);
};

});

parcelRegister("aq3px", function(module, exports) {

$parcel$export(module.exports, "TopNav", function () { return $795efa68315d0a45$export$41d0d88a6b0e456f; });
/* top-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dsN6L = parcelRequire("dsN6L");


var $91i6m = parcelRequire("91i6m");

var $6HfEw = parcelRequire("6HfEw");

var $kZCbc = parcelRequire("kZCbc");

var $kjtNX = parcelRequire("kjtNX");

var $iZSIe = parcelRequire("iZSIe");

var $8brTf = parcelRequire("8brTf");

var $dJ6ak = parcelRequire("dJ6ak");

var $2bgdU = parcelRequire("2bgdU");

var $eQ1c9 = parcelRequire("eQ1c9");

var $aDWwl = parcelRequire("aDWwl");
var $dwV3h = parcelRequire("dwV3h");
var $9wl70 = parcelRequire("9wl70");

var $f1J6u = parcelRequire("f1J6u");

var $eILiL = parcelRequire("eILiL");
var $795efa68315d0a45$var$styles = {
    wrapper: "_18zrv47k _n7zl7r9e _4t3ickbl _1bsb1osq",
    search: "_195goahv _1bsb1osq",
    searchBar: "_2rkoiti9 _19it7r9e _4t3izwfg _1bsb1osq _p12fcv93 _1ul91178",
    createButton: "_2rkoiti9 _4t3izwfg _1bsbys9h _bfhk4v9p",
    createButtonText: "_2rkoiti9 _4t3ii2wt _1bsb1ady",
    chatButton: "_2rkoiti9 _19it7r9e _4t3izwfg _1bsbcae7",
    chatButtonText: "_2rkoiti9 _4t3ii2wt _1bsbzwfg"
};
var $795efa68315d0a45$var$ProductLogos = (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, (0, $eILiL.Products).JIRA, (0, $eQ1c9.JiraLogo)), (0, $eILiL.Products).CONFLUENCE, (0, $eQ1c9.ConfluenceLogo)), (0, $eILiL.Products).JIRA_PRODUCT_DISCOVERY, (0, $eQ1c9.JiraProductDiscoveryLogo)), (0, $eILiL.Products).JIRA_SERVICE_MANAGEMENT, (0, $eQ1c9.JiraServiceManagementLogo));
var $795efa68315d0a45$var$ProductIcons = (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, (0, $eILiL.Products).JIRA, (0, $eQ1c9.JiraIcon)), (0, $eILiL.Products).CONFLUENCE, (0, $eQ1c9.ConfluenceIcon)), (0, $eILiL.Products).JIRA_PRODUCT_DISCOVERY, (0, $eQ1c9.JiraProductDiscoveryIcon)), (0, $eILiL.Products).JIRA_SERVICE_MANAGEMENT, (0, $eQ1c9.JiraServiceManagementIcon));
var $795efa68315d0a45$export$41d0d88a6b0e456f = function TopNav(_ref) {
    var product = _ref.product;
    var isAboveMediumScreen = (0, $f1J6u.useMatchMedia)((0, $9wl70.media).above.md);
    var Logo = $795efa68315d0a45$var$ProductLogos[product];
    var Icon = $795efa68315d0a45$var$ProductIcons[product];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $dwV3h.default), {
        xcss: $795efa68315d0a45$var$styles.wrapper,
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $dwV3h.default), {
        alignBlock: "center",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bgdU))), {
        label: "Sidebar collapse",
        color: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6HfEw))), {
        label: "App switcher",
        color: "var(--ds-icon-subtle, #626F86)"
    }), isAboveMediumScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(Logo, {
        appearance: "brand",
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(Icon, {
        appearance: "brand",
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $dwV3h.default), {
        xcss: $795efa68315d0a45$var$styles.search,
        alignInline: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $dwV3h.default), {
        xcss: $795efa68315d0a45$var$styles.searchBar,
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8brTf))), {
        label: "Search",
        color: "var(--ds-icon-subtle, #626F86)",
        spacing: "spacious"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $dwV3h.default), {
        xcss: $795efa68315d0a45$var$styles.createButton,
        alignBlock: "center",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $aDWwl.default), {
        xcss: $795efa68315d0a45$var$styles.createButtonText,
        backgroundColor: "color.background.accent.blue.subtler.hovered"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $dwV3h.default), {
        alignBlock: "center",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $dwV3h.default), {
        xcss: $795efa68315d0a45$var$styles.chatButton,
        alignBlock: "center",
        alignInline: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $eQ1c9.RovoIcon), {
        size: "xxsmall",
        appearance: "neutral"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $aDWwl.default), {
        xcss: $795efa68315d0a45$var$styles.chatButtonText,
        backgroundColor: "color.background.accent.gray.subtlest.hovered"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kZCbc))), {
        label: "Notifications",
        color: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iZSIe))), {
        label: "Help",
        color: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dJ6ak))), {
        label: "Settings",
        color: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kjtNX))), {
        label: "User",
        color: "var(--ds-icon-subtle, #626F86)"
    })));
};

});
parcelRegister("6HfEw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0e96a69f97519443fff2bdbab242b00d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4e02e68046a39c33$var$_react = $4e02e68046a39c33$var$_interopRequireDefault((parcelRequire("91i6m")));

var $4e02e68046a39c33$var$_baseNew = $4e02e68046a39c33$var$_interopRequireDefault((parcelRequire("dj2x1")));
function $4e02e68046a39c33$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AppSwitcher".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for app switcher in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4e02e68046a39c33$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $4e02e68046a39c33$var$_react.default.createElement($4e02e68046a39c33$var$_baseNew.default, Object.assign({
        name: "AppSwitcherIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM9 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM1 11a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zm6 .5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$4e02e68046a39c33$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
var $4e02e68046a39c33$var$_default = module.exports.default = $4e02e68046a39c33$var$AppSwitcherIcon;

});
parcelRegister("dj2x1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("5vpOn")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("5vpOn")).Icon; });

var $5vpOn = parcelRequire("5vpOn");

});
parcelRegister("5vpOn", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $4023de9de2e689b9$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $4023de9de2e689b9$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $f1k1y = parcelRequire("f1k1y");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $4023de9de2e689b9$var$svgStyles = null;
var $4023de9de2e689b9$var$iconStyles = null;
var $4023de9de2e689b9$var$utilityIconStyles = null;
var $4023de9de2e689b9$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $4023de9de2e689b9$var$baseHcmStyles = null;
var $4023de9de2e689b9$var$scaleSize = null;
var $4023de9de2e689b9$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $4023de9de2e689b9$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $4023de9de2e689b9$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $4023de9de2e689b9$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $4023de9de2e689b9$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $4023de9de2e689b9$export$f04a61298a47a40f = /*#__PURE__*/ (0, $91i6m.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $f1k1y.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $91i6m.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = $4023de9de2e689b9$var$baseSizeMap[type];
    var viewBoxPadding = $4023de9de2e689b9$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $91i6m.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $9gzWK.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $91i6m.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $9gzWK.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $4023de9de2e689b9$var$utilSizes[spacing] : size === 'small' ? $4023de9de2e689b9$var$coreSizeSmall[spacing] : $4023de9de2e689b9$var$coreSizeMedium[spacing]
        ])
    }));
});
var $4023de9de2e689b9$export$2e2bcd8739ae039 = $4023de9de2e689b9$export$f04a61298a47a40f;

});



parcelRegister("kZCbc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c5050b53f23a98f3c4135467aadfbb06>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f4871ed9735eb9ff$var$_react = $f4871ed9735eb9ff$var$_interopRequireDefault((parcelRequire("91i6m")));

var $f4871ed9735eb9ff$var$_baseNew = $f4871ed9735eb9ff$var$_interopRequireDefault((parcelRequire("dj2x1")));
function $f4871ed9735eb9ff$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notification".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for notifications within global product navigation and within product screens.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f4871ed9735eb9ff$var$NotificationIcon = (props)=>/*#__PURE__*/ $f4871ed9735eb9ff$var$_react.default.createElement($f4871ed9735eb9ff$var$_baseNew.default, Object.assign({
        name: "NotificationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 5a5 5 0 0 1 10 0v3.535l1.788 2.861a1.375 1.375 0 0 1-1.166 2.104h-2.459a3.251 3.251 0 0 1-6.326 0h-2.46a1.375 1.375 0 0 1-1.165-2.104L3 8.535zm3.418 8.5a1.75 1.75 0 0 0 3.164 0zM8 1.5A3.5 3.5 0 0 0 4.5 5v3.636c0 .215-.06.426-.175.608L2.603 12h10.794l-1.723-2.756a1.15 1.15 0 0 1-.174-.608V5A3.5 3.5 0 0 0 8 1.5" clip-rule="evenodd"/>`
    }, props));
$f4871ed9735eb9ff$var$NotificationIcon.displayName = 'NotificationIcon';
var $f4871ed9735eb9ff$var$_default = module.exports.default = $f4871ed9735eb9ff$var$NotificationIcon;

});

parcelRegister("kjtNX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5a2b32fe863ac429d199dc8b174e3b3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ec9cb395b18a35c4$var$_react = $ec9cb395b18a35c4$var$_interopRequireDefault((parcelRequire("91i6m")));

var $ec9cb395b18a35c4$var$_baseNew = $ec9cb395b18a35c4$var$_interopRequireDefault((parcelRequire("dj2x1")));
function $ec9cb395b18a35c4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAvatar".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ec9cb395b18a35c4$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $ec9cb395b18a35c4$var$_react.default.createElement($ec9cb395b18a35c4$var$_baseNew.default, Object.assign({
        name: "PersonAvatarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0-4.148 11.505A2.75 2.75 0 0 1 6.5 11h3c1.26 0 2.323.848 2.648 2.005A6.5 6.5 0 0 0 8 1.5m2.75 12.392v-.142c0-.69-.56-1.25-1.25-1.25h-3c-.69 0-1.25.56-1.25 1.25v.142l.06.027c.82.373 1.73.581 2.69.581s1.87-.208 2.69-.58q.03-.016.06-.028M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3.5 2a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" clip-rule="evenodd"/>`
    }, props));
$ec9cb395b18a35c4$var$PersonAvatarIcon.displayName = 'PersonAvatarIcon';
var $ec9cb395b18a35c4$var$_default = module.exports.default = $ec9cb395b18a35c4$var$PersonAvatarIcon;

});

parcelRegister("iZSIe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8bb31d7b8eb39bae440b5a0002b7aa63>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dd485d39deeb61b4$var$_react = $dd485d39deeb61b4$var$_interopRequireDefault((parcelRequire("91i6m")));

var $dd485d39deeb61b4$var$_baseNew = $dd485d39deeb61b4$var$_interopRequireDefault((parcelRequire("dj2x1")));
function $dd485d39deeb61b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dd485d39deeb61b4$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $dd485d39deeb61b4$var$_react.default.createElement($dd485d39deeb61b4$var$_baseNew.default, Object.assign({
        name: "QuestionCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$dd485d39deeb61b4$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $dd485d39deeb61b4$var$_default = module.exports.default = $dd485d39deeb61b4$var$QuestionCircleIcon;

});

parcelRegister("8brTf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0ed30ba2fe598b1c691c4159780db191>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5f54fc3470c25edb$var$_react = $5f54fc3470c25edb$var$_interopRequireDefault((parcelRequire("91i6m")));

var $5f54fc3470c25edb$var$_baseNew = $5f54fc3470c25edb$var$_interopRequireDefault((parcelRequire("dj2x1")));
function $5f54fc3470c25edb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Search".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5f54fc3470c25edb$var$SearchIcon = (props)=>/*#__PURE__*/ $5f54fc3470c25edb$var$_react.default.createElement($5f54fc3470c25edb$var$_baseNew.default, Object.assign({
        name: "SearchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 2.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M1 7a6 6 0 1 1 10.74 3.68l3.29 3.29-1.06 1.06-3.29-3.29A6 6 0 0 1 1 7" clip-rule="evenodd"/>`
    }, props));
$5f54fc3470c25edb$var$SearchIcon.displayName = 'SearchIcon';
var $5f54fc3470c25edb$var$_default = module.exports.default = $5f54fc3470c25edb$var$SearchIcon;

});

parcelRegister("dJ6ak", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e6207a690a69d1b6395dc313a9a74c2f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9fe442aa2caf125c$var$_react = $9fe442aa2caf125c$var$_interopRequireDefault((parcelRequire("91i6m")));

var $9fe442aa2caf125c$var$_baseNew = $9fe442aa2caf125c$var$_interopRequireDefault((parcelRequire("dj2x1")));
function $9fe442aa2caf125c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Settings".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9fe442aa2caf125c$var$SettingsIcon = (props)=>/*#__PURE__*/ $9fe442aa2caf125c$var$_react.default.createElement($9fe442aa2caf125c$var$_baseNew.default, Object.assign({
        name: "SettingsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.058.462A.75.75 0 0 1 6.75 0h2.5a.75.75 0 0 1 .692.462l1.026 2.462 2.578-.374a.75.75 0 0 1 .757.367l1.25 2.166a.75.75 0 0 1-.049.824L13.937 8l1.567 2.093c.18.24.2.565.05.825l-1.25 2.165a.75.75 0 0 1-.758.367l-2.578-.374-1.026 2.463A.75.75 0 0 1 9.25 16h-2.5a.75.75 0 0 1-.692-.461l-1.026-2.463-2.578.374a.75.75 0 0 1-.757-.367l-1.25-2.165a.75.75 0 0 1 .049-.825L2.063 8 .496 5.907a.75.75 0 0 1-.05-.824l1.25-2.166a.75.75 0 0 1 .758-.367l2.578.374zM7.25 1.5l-.871 2.09c-.242.58-.845.923-1.467.833l-2.17-.315-.749 1.296L3.32 7.176c.366.488.366 1.16 0 1.648l-1.327 1.772.749 1.296 2.17-.315a1.375 1.375 0 0 1 1.467.832L7.25 14.5h1.5l.871-2.09c.242-.58.845-.923 1.467-.833l2.17.315.749-1.296-1.327-1.772a1.375 1.375 0 0 1 0-1.648l1.327-1.772-.749-1.296-2.17.315A1.375 1.375 0 0 1 9.62 3.59L8.75 1.5zm.75 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$9fe442aa2caf125c$var$SettingsIcon.displayName = 'SettingsIcon';
var $9fe442aa2caf125c$var$_default = module.exports.default = $9fe442aa2caf125c$var$SettingsIcon;

});

parcelRegister("2bgdU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7c03d2728886be26240ae9af453c127>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1969317dad93c6d5$var$_react = $1969317dad93c6d5$var$_interopRequireDefault((parcelRequire("91i6m")));

var $1969317dad93c6d5$var$_baseNew = $1969317dad93c6d5$var$_interopRequireDefault((parcelRequire("dj2x1")));
function $1969317dad93c6d5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarCollapse".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for collapsing the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1969317dad93c6d5$var$SidebarCollapseIcon = (props)=>/*#__PURE__*/ $1969317dad93c6d5$var$_react.default.createElement($1969317dad93c6d5$var$_baseNew.default, Object.assign({
        name: "SidebarCollapseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h2v-11zm3.5 0v11H14a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm7.97 4.47 2.5-2.5 1.06 1.06L9.56 8l1.97 1.97-1.06 1.06-2.5-2.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$1969317dad93c6d5$var$SidebarCollapseIcon.displayName = 'SidebarCollapseIcon';
var $1969317dad93c6d5$var$_default = module.exports.default = $1969317dad93c6d5$var$SidebarCollapseIcon;

});


parcelRegister("iiPvr", function(module, exports) {

$parcel$export(module.exports, "Actions", function () { return $d531dc7af62238eb$export$b52183d5cfb26dc9; });

var $91i6m = parcelRequire("91i6m");

var $aDWwl = parcelRequire("aDWwl");
var $d531dc7af62238eb$export$b52183d5cfb26dc9 = function Actions() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $aDWwl.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($d531dc7af62238eb$var$Image, null));
};
var $d531dc7af62238eb$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("svg", {
        width: 331,
        height: 32,
        viewBox: "0 0 331 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        clipPath: "url(#clip0_211_10675)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.5858 8.85361C12.3668 8.07256 13.6332 8.07256 14.4142 8.85361L15.1464 9.58584C15.9275 10.3669 15.9275 11.6332 15.1464 12.4143L10.0094 17.5513C9.76903 17.7917 9.47141 17.9668 9.1446 18.0602L5.95604 18.9712C5.69415 19.046 5.41227 18.973 5.21967 18.7804C5.02707 18.5878 4.95403 18.3059 5.02886 18.044L5.93987 14.8555C6.03325 14.5286 6.20837 14.231 6.44871 13.9907L11.5858 8.85361ZM13.3536 9.91427C13.1583 9.71901 12.8417 9.71901 12.6464 9.91427L12.0607 10.5001L13.5 11.9394L14.0858 11.3536C14.281 11.1583 14.281 10.8418 14.0858 10.6465L13.3536 9.91427ZM12.4393 13.0001L11 11.5607L7.50937 15.0513C7.44928 15.1114 7.4055 15.1858 7.38216 15.2675L6.84202 17.158L8.73251 16.6179C8.81422 16.5946 8.88862 16.5508 8.94871 16.4907L12.4393 13.0001ZM3 10.5012C2.72386 10.5012 2.5 10.725 2.5 11.0012V21.0012C2.5 21.2773 2.72386 21.5012 3 21.5012H13C13.2761 21.5012 13.5 21.2773 13.5 21.0012V18.0001H15V21.0012C15 22.1057 14.1046 23.0012 13 23.0012H3C1.89543 23.0012 1 22.1057 1 21.0012V11.0012C1 9.89659 1.89543 9.00115 3 9.00115H6V10.5012H3Z",
        fill: "#BFDBF8",
        fillOpacity: 0.28
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 24,
        y: 13,
        width: 40,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 131,
        y: 3,
        width: 26,
        height: 26,
        rx: 13,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 131,
        y: 3,
        width: 26,
        height: 26,
        rx: 13,
        stroke: "#454F59",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M140.566 21V19.9746L143.848 16.5225C144.281 16.0667 144.618 15.693 144.859 15.4014C145.105 15.1051 145.276 14.8408 145.372 14.6084C145.472 14.3714 145.522 14.1208 145.522 13.8564V13.8359C145.522 13.5124 145.452 13.2253 145.311 12.9746C145.169 12.7194 144.969 12.5189 144.709 12.373C144.449 12.2227 144.137 12.1475 143.772 12.1475C143.403 12.1475 143.08 12.2249 142.802 12.3799C142.524 12.5303 142.307 12.7422 142.152 13.0156C141.997 13.2845 141.92 13.6012 141.92 13.9658L141.913 13.9863L140.491 13.9795L140.478 13.9658C140.482 13.3643 140.628 12.8333 140.915 12.373C141.202 11.9128 141.599 11.5527 142.104 11.293C142.615 11.0286 143.201 10.8965 143.861 10.8965C144.467 10.8965 145.01 11.0173 145.488 11.2588C145.971 11.4958 146.35 11.8262 146.623 12.25C146.901 12.6693 147.04 13.1501 147.04 13.6924V13.7129C147.04 14.082 146.972 14.4421 146.835 14.793C146.698 15.1439 146.464 15.529 146.131 15.9482C145.798 16.3675 145.331 16.8757 144.729 17.4727L142.241 19.9678L142.631 19.2842V19.9678L142.241 19.708H147.197V21H140.566Z",
        fill: "#738496"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("circle", {
        cx: 122,
        cy: 16,
        r: 13,
        fill: "url(#pattern0_211_10675)",
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("circle", {
        cx: 100,
        cy: 16,
        r: 13,
        fill: "url(#pattern1_211_10675)",
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("mask", {
        id: "path-7-inside-1_211_10675",
        fill: "white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M176 4C176 1.79086 177.791 0 180 0H262V32H180C177.791 32 176 30.2091 176 28V4Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M175 4C175 1.23858 177.239 -1 180 -1H262V1H180C178.343 1 177 2.34315 177 4H175ZM262 33H180C177.239 33 175 30.7614 175 28H177C177 29.6569 178.343 31 180 31H262V33ZM180 33C177.239 33 175 30.7614 175 28V4C175 1.23858 177.239 -1 180 -1V1C178.343 1 177 2.34315 177 4V28C177 29.6569 178.343 31 180 31V33ZM262 0V32V0Z",
        fill: "#A1BDD9",
        fillOpacity: 0.08,
        mask: "url(#path-7-inside-1_211_10675)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M196 9.5C194.619 9.5 193.5 10.6193 193.5 12V15H200C201.105 15 202 15.8954 202 17V22C202 23.1046 201.105 24 200 24H192C190.895 24 190 23.1046 190 22V17C190 15.8954 190.895 15 192 15V12C192 9.79086 193.791 8 196 8C198.209 8 200 9.79086 200 12H198.5C198.5 10.6193 197.381 9.5 196 9.5ZM192 16.5C191.724 16.5 191.5 16.7239 191.5 17V22C191.5 22.2761 191.724 22.5 192 22.5H200C200.276 22.5 200.5 22.2761 200.5 22V17C200.5 16.7239 200.276 16.5 200 16.5H192Z",
        fill: "#BFDBF8",
        fillOpacity: 0.28
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 210,
        y: 13,
        width: 40,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M262 32V0H263V32H262Z",
        fill: "#A1BDD9",
        fillOpacity: 0.08
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("mask", {
        id: "path-12-inside-2_211_10675",
        fill: "white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M263 0H291C293.209 0 295 1.79086 295 4V28C295 30.2091 293.209 32 291 32H263V0Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M263 -1H291C293.761 -1 296 1.23858 296 4H294C294 2.34315 292.657 1 291 1H263V-1ZM296 28C296 30.7614 293.761 33 291 33H263V31H291C292.657 31 294 29.6569 294 28H296ZM263 32V0V32ZM291 -1C293.761 -1 296 1.23858 296 4V28C296 30.7614 293.761 33 291 33V31C292.657 31 294 29.6569 294 28V4C294 2.34315 292.657 1 291 1V-1Z",
        fill: "#A1BDD9",
        fillOpacity: 0.08,
        mask: "url(#path-12-inside-2_211_10675)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M278.22 10.2198C279.756 8.68423 282.245 8.68423 283.781 10.2198C285.316 11.7553 285.316 14.2449 283.781 15.7804L281.531 18.0304L280.47 16.9698L282.72 14.7198C283.67 13.77 283.67 12.2302 282.72 11.2804C281.77 10.3307 280.23 10.3307 279.281 11.2804L277.031 13.5304L275.97 12.4698L278.22 10.2198ZM281.281 13.7804L275.781 19.2804L274.72 18.2198L280.22 12.7198L281.281 13.7804ZM272.22 16.2198L274.47 13.9698L275.531 15.0304L273.281 17.2804C272.331 18.2302 272.331 19.77 273.281 20.7198C274.23 21.6695 275.77 21.6695 276.72 20.7198L278.97 18.4698L280.031 19.5304L277.781 21.7804C276.245 23.316 273.756 23.316 272.22 21.7804C270.684 20.2449 270.684 17.7553 272.22 16.2198Z",
        fill: "#BFDBF8",
        fillOpacity: 0.28
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 299,
        width: 32,
        height: 32,
        rx: 3,
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M307 16C307 15.1716 307.672 14.5 308.5 14.5C309.328 14.5 310 15.1716 310 16C310 16.8284 309.328 17.5 308.5 17.5C307.672 17.5 307 16.8284 307 16ZM313.5 16C313.5 15.1716 314.172 14.5 315 14.5C315.828 14.5 316.5 15.1716 316.5 16C316.5 16.8284 315.828 17.5 315 17.5C314.172 17.5 313.5 16.8284 313.5 16ZM320 16C320 15.1716 320.672 14.5 321.5 14.5C322.328 14.5 323 15.1716 323 16C323 16.8284 322.328 17.5 321.5 17.5C320.672 17.5 320 16.8284 320 16Z",
        fill: "#BFDBF8",
        fillOpacity: 0.28
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("pattern", {
        id: "pattern0_211_10675",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("use", {
        xlinkHref: "#image0_211_10675",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("pattern", {
        id: "pattern1_211_10675",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("use", {
        xlinkHref: "#image1_211_10675",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("clipPath", {
        id: "clip0_211_10675"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 331,
        height: 32,
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("image", {
        id: "image0_211_10675",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,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"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("image", {
        id: "image1_211_10675",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,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"
    })));
};

});

parcelRegister("cEAXG", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", function () { return $9365e4485f6d9498$export$2dc68d50d56fbbd; });

var $91i6m = parcelRequire("91i6m");

var $aDWwl = parcelRequire("aDWwl");
var $9365e4485f6d9498$export$2dc68d50d56fbbd = function Breadcrumbs() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $aDWwl.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($9365e4485f6d9498$var$Image, null));
};
var $9365e4485f6d9498$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 203,
        height: 20,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 100,
        height: 6,
        y: 7,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 54,
        height: 6,
        x: 113,
        y: 7,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#6B778C",
        d: "m108.701 4.664-3.014 12.81h-1.395l3.015-12.81h1.394Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "M195 2a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.381 2.818 1.25 4.662a.748.748 0 0 1-1.148.813L195 14.159l-3.951 2.71a.75.75 0 0 1-1.148-.813l1.25-4.662-3.381-2.818a.749.749 0 0 1 .423-1.324l4.402-.338L194.3 2.48A.75.75 0 0 1 195 2Zm0 2.84-1.345 3.496-3.506.27 2.7 2.25-.973 3.627L195 12.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27L195 4.84Z",
        clipRule: "evenodd"
    }));
};

});

parcelRegister("lrB9E", function(module, exports) {

$parcel$export(module.exports, "Content", function () { return $f9c8f0c1ec8d15ad$export$7c6e2c02157bb7d2; });

var $91i6m = parcelRequire("91i6m");

var $aDWwl = parcelRequire("aDWwl");
var $f9c8f0c1ec8d15ad$export$7c6e2c02157bb7d2 = function Content() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $aDWwl.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($f9c8f0c1ec8d15ad$var$Image, null));
};
var $f9c8f0c1ec8d15ad$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("svg", {
        width: 762,
        height: 618,
        viewBox: "0 0 762 618",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 2,
        width: 503,
        height: 20,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        clipPath: "url(#clip0_211_10701)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 46,
        y: 60,
        width: 192,
        height: 6,
        rx: 3,
        fill: "#454F59"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 46,
        y: 48,
        width: 119,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("circle", {
        cx: 18,
        cy: 60,
        r: 17,
        fill: "url(#pattern0_211_10701)",
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 2,
        y: 100,
        width: 760,
        height: 86,
        rx: 5,
        fill: "#1C2B41"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(18 116)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18 128C18 121.373 23.3726 116 30 116C36.6274 116 42 121.373 42 128C42 134.627 36.6274 140 30 140C23.3726 140 18 134.627 18 128ZM27.75 126.125H30C30.6213 126.125 31.125 126.629 31.125 127.25V134.75H28.875V128.375H27.75V126.125ZM30 124.25C30.8284 124.25 31.5 123.578 31.5 122.75C31.5 121.922 30.8284 121.25 30 121.25C29.1716 121.25 28.5 121.922 28.5 122.75C28.5 123.578 29.1716 124.25 30 124.25Z",
        fill: "#579DFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 68,
        y: 126,
        width: 659,
        height: 12,
        rx: 3,
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 68,
        y: 148,
        width: 325,
        height: 12,
        rx: 3,
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 2,
        y: 218,
        width: 32,
        height: 32,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 46,
        y: 228,
        width: 143,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 2,
        y: 262,
        width: 98.5,
        height: 20,
        rx: 10,
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M14.7402 278.6C11.2129 278.6 8.97754 276.385 8.97754 272.898V272.885C8.97754 269.508 11.2744 267.19 14.624 267.19C17.8574 267.19 20.1064 269.255 20.1064 272.215V272.229C20.1064 274.45 19.1084 275.865 17.5361 275.865C16.75 275.865 16.1484 275.421 16.0391 274.758L16.0322 274.717H15.9229C15.6289 275.414 15.0137 275.804 14.2139 275.804C12.792 275.804 11.835 274.635 11.835 272.905V272.892C11.835 271.237 12.8125 270.075 14.2139 270.075C14.9316 270.075 15.5469 270.444 15.8135 271.039H15.9229V270.205H16.9551V274.218C16.9551 274.696 17.2354 274.977 17.7275 274.977C18.5889 274.977 19.1426 273.89 19.1426 272.215V272.201C19.1426 269.74 17.2695 268.052 14.5352 268.052C11.8623 268.052 9.94141 270.089 9.94141 272.926V272.939C9.94141 275.852 11.8281 277.731 14.7539 277.731C15.6904 277.731 16.6133 277.602 17.0439 277.403V278.265C16.4287 278.477 15.6016 278.6 14.7402 278.6ZM14.3711 274.84C15.3076 274.84 15.9092 274.095 15.9092 272.933V272.919C15.9092 271.757 15.3145 271.019 14.3848 271.019C13.4688 271.019 12.9287 271.729 12.9287 272.919V272.933C12.9287 274.115 13.4756 274.84 14.3711 274.84Z",
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 23.5,
        y: 269,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 108.5,
        y: 262,
        width: 98.5,
        height: 20,
        rx: 10,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M121.24 278.6C117.713 278.6 115.478 276.385 115.478 272.898V272.885C115.478 269.508 117.774 267.19 121.124 267.19C124.357 267.19 126.606 269.255 126.606 272.215V272.229C126.606 274.45 125.608 275.865 124.036 275.865C123.25 275.865 122.648 275.421 122.539 274.758L122.532 274.717H122.423C122.129 275.414 121.514 275.804 120.714 275.804C119.292 275.804 118.335 274.635 118.335 272.905V272.892C118.335 271.237 119.312 270.075 120.714 270.075C121.432 270.075 122.047 270.444 122.313 271.039H122.423V270.205H123.455V274.218C123.455 274.696 123.735 274.977 124.228 274.977C125.089 274.977 125.643 273.89 125.643 272.215V272.201C125.643 269.74 123.77 268.052 121.035 268.052C118.362 268.052 116.441 270.089 116.441 272.926V272.939C116.441 275.852 118.328 277.731 121.254 277.731C122.19 277.731 123.113 277.602 123.544 277.403V278.265C122.929 278.477 122.102 278.6 121.24 278.6ZM120.871 274.84C121.808 274.84 122.409 274.095 122.409 272.933V272.919C122.409 271.757 121.814 271.019 120.885 271.019C119.969 271.019 119.429 271.729 119.429 272.919V272.933C119.429 274.115 119.976 274.84 120.871 274.84Z",
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 130,
        y: 269,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 215,
        y: 262,
        width: 98.5,
        height: 20,
        rx: 10,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M227.74 278.6C224.213 278.6 221.978 276.385 221.978 272.898V272.885C221.978 269.508 224.274 267.19 227.624 267.19C230.857 267.19 233.106 269.255 233.106 272.215V272.229C233.106 274.45 232.108 275.865 230.536 275.865C229.75 275.865 229.148 275.421 229.039 274.758L229.032 274.717H228.923C228.629 275.414 228.014 275.804 227.214 275.804C225.792 275.804 224.835 274.635 224.835 272.905V272.892C224.835 271.237 225.812 270.075 227.214 270.075C227.932 270.075 228.547 270.444 228.813 271.039H228.923V270.205H229.955V274.218C229.955 274.696 230.235 274.977 230.728 274.977C231.589 274.977 232.143 273.89 232.143 272.215V272.201C232.143 269.74 230.27 268.052 227.535 268.052C224.862 268.052 222.941 270.089 222.941 272.926V272.939C222.941 275.852 224.828 277.731 227.754 277.731C228.69 277.731 229.613 277.602 230.044 277.403V278.265C229.429 278.477 228.602 278.6 227.74 278.6ZM227.371 274.84C228.308 274.84 228.909 274.095 228.909 272.933V272.919C228.909 271.757 228.314 271.019 227.385 271.019C226.469 271.019 225.929 271.729 225.929 272.919V272.933C225.929 274.115 226.476 274.84 227.371 274.84Z",
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 236.5,
        y: 269,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 2,
        y: 314,
        width: 290,
        height: 20,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 2,
        y: 350,
        width: 730,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 2,
        y: 378,
        width: 730,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 2,
        y: 406,
        width: 343,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 444H28C29.1046 444 30 444.895 30 446V454C30 455.105 29.1046 456 28 456H20C18.8954 456 18 455.105 18 454V446C18 444.895 18.8954 444 20 444ZM21.3824 449.069C21.5044 449.121 21.6148 449.198 21.707 449.293L23 450.586L26.293 447.293C26.3852 447.198 26.4956 447.121 26.6176 447.069C26.7396 447.017 26.8708 446.989 27.0036 446.988C27.1364 446.987 27.2681 447.012 27.391 447.062C27.5139 447.112 27.6255 447.187 27.7194 447.281C27.8133 447.375 27.8875 447.486 27.9378 447.609C27.9881 447.732 28.0134 447.864 28.0123 447.996C28.0111 448.129 27.9835 448.26 27.9311 448.382C27.8787 448.504 27.8025 448.615 27.707 448.707L23.707 452.707C23.5195 452.894 23.2652 453 23 453C22.7348 453 22.4805 452.894 22.293 452.707L20.293 450.707C20.1975 450.615 20.1213 450.504 20.0689 450.382C20.0165 450.26 19.9889 450.129 19.9878 449.996C19.9866 449.864 20.0119 449.732 20.0622 449.609C20.1125 449.486 20.1867 449.375 20.2806 449.281C20.3745 449.187 20.4862 449.112 20.609 449.062C20.7319 449.012 20.8636 448.987 20.9964 448.988C21.1292 448.989 21.2604 449.017 21.3824 449.069Z",
        fill: "#579DFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 38,
        y: 447,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 18,
        y: 476,
        width: 12,
        height: 12,
        rx: 6,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 38,
        y: 479,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 18,
        y: 508,
        width: 12,
        height: 12,
        rx: 6,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 38,
        y: 511,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 18,
        y: 540,
        width: 12,
        height: 12,
        rx: 6,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 38,
        y: 543,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 2,
        y: 578,
        width: 730,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 2,
        y: 606,
        width: 522,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("pattern", {
        id: "pattern0_211_10701",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("use", {
        xlinkHref: "#image0_211_10701",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("clipPath", {
        id: "clip0_211_10701"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 192,
        height: 6,
        fill: "white",
        transform: "translate(46 60)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("image", {
        id: "image0_211_10701",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,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"
    })));
};

});

parcelRegister("5MD4w", function(module, exports) {

$parcel$export(module.exports, "FloatingActions", function () { return $435fbe54de1e3b4a$export$babdd492df2e202d; });
/* floating-actions.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $91i6m = parcelRequire("91i6m");

var $aDWwl = parcelRequire("aDWwl");
var $435fbe54de1e3b4a$var$styles = {
    wrapper: "_kqsw1n9t _94n512x7 _1xi212x7"
};
var $435fbe54de1e3b4a$export$babdd492df2e202d = function FloatingActions() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $aDWwl.default), {
        xcss: $435fbe54de1e3b4a$var$styles.wrapper,
        backgroundColor: "elevation.surface"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($435fbe54de1e3b4a$var$Image, null));
};
var $435fbe54de1e3b4a$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("svg", {
        width: 63,
        height: 339,
        viewBox: "0 0 63 339",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        filter: "url(#filter0_dd_211_10747)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M8 80C8 66.7452 18.7452 56 32 56C45.2548 56 56 66.7452 56 80V253C56 266.255 45.2548 277 32 277C18.7452 277 8 266.255 8 253V80Z",
        fill: "#22272B"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24 75.125C24 73.6753 25.1753 72.5 26.625 72.5H37.375C38.8247 72.5 40 73.6753 40 75.125V83.375C40 84.8247 38.8247 86 37.375 86H28.4492L25.1221 87.9012C24.89 88.0338 24.6048 88.0329 24.3736 87.8987C24.1423 87.7645 24 87.5174 24 87.25V75.125ZM26.625 74C26.0037 74 25.5 74.5037 25.5 75.125V85.9576L28.0508 84.5H37.375C37.9963 84.5 38.5 83.9963 38.5 83.375V75.125C38.5 74.5037 37.9963 74 37.375 74H26.625ZM36.0002 78.4998H28.0002V76.9998H36.0002V78.4998ZM33.0002 81.4998H28.0002V79.9998H33.0002V81.4998Z",
        fill: "#BFDBF8",
        fillOpacity: 0.28
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("circle", {
        cx: 41,
        cy: 72,
        r: 5,
        fill: "#0055CC",
        stroke: "#1D2125",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M39 115.5L25 115.5L25 114L39 114L39 115.5ZM39 120.75L25 120.75L25 119.25L39 119.25L39 120.75ZM32 126L25 126L25 124.5L32 124.5L32 126Z",
        fill: "#BFDBF8",
        fillOpacity: 0.28
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 20,
        y: 146,
        width: 24,
        height: 1,
        fill: "#0B1228",
        fillOpacity: 0.14
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M26 168.5C25.7239 168.5 25.5 168.724 25.5 169V177C25.5 177.276 25.7239 177.5 26 177.5H34C34.2761 177.5 34.5 177.276 34.5 177V169C34.5 168.724 34.2761 168.5 34 168.5H26ZM24 169C24 167.895 24.8954 167 26 167H34C35.1046 167 36 167.895 36 169V169.786L38.191 168.691C39.0221 168.275 40 168.88 40 169.809V176.191C40 177.12 39.0221 177.725 38.191 177.309L36 176.214V177C36 178.105 35.1046 179 34 179H26C24.8954 179 24 178.105 24 177V169ZM36 174.536L38.5 175.786V170.214L36 171.464V174.536Z",
        fill: "#BFDBF8",
        fillOpacity: 0.28
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M34.3774 205.102C34.6716 205.273 34.8136 205.621 34.723 205.949L32.9849 212.25H37.25C37.5534 212.25 37.8268 212.433 37.9429 212.713C38.059 212.993 37.9949 213.316 37.7804 213.53L30.5304 220.78C30.2896 221.021 29.9169 221.069 29.6226 220.898C29.3284 220.727 29.1865 220.379 29.277 220.051L31.0151 213.75H26.75C26.4467 213.75 26.1732 213.567 26.0571 213.287C25.941 213.007 26.0052 212.684 26.2197 212.47L33.4697 205.22C33.7104 204.979 34.0832 204.931 34.3774 205.102ZM31.4289 212.25L32.5216 208.289L28.5607 212.25H31.4289ZM32.5711 213.75L31.4785 217.711L35.4394 213.75H32.5711Z",
        fill: "#BFDBF8",
        fillOpacity: 0.28
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25 248C25 246.895 25.8954 246 27 246H29C30.1046 246 31 246.895 31 248V250C31 251.105 30.1046 252 29 252H27C25.8954 252 25 251.105 25 250V248ZM27 247.5C26.7239 247.5 26.5 247.724 26.5 248V250C26.5 250.276 26.7239 250.5 27 250.5H29C29.2761 250.5 29.5 250.276 29.5 250V248C29.5 247.724 29.2761 247.5 29 247.5H27ZM33 248C33 246.895 33.8954 246 35 246H37C38.1046 246 39 246.895 39 248V250C39 251.105 38.1046 252 37 252H35C33.8954 252 33 251.105 33 250V248ZM35 247.5C34.7239 247.5 34.5 247.724 34.5 248V250C34.5 250.276 34.7239 250.5 35 250.5H37C37.2761 250.5 37.5 250.276 37.5 250V248C37.5 247.724 37.2761 247.5 37 247.5H35ZM25 256C25 254.895 25.8954 254 27 254H29C30.1046 254 31 254.895 31 256V258C31 259.105 30.1046 260 29 260H27C25.8954 260 25 259.105 25 258V256ZM27 255.5C26.7239 255.5 26.5 255.724 26.5 256V258C26.5 258.276 26.7239 258.5 27 258.5H29C29.2761 258.5 29.5 258.276 29.5 258V256C29.5 255.724 29.2761 255.5 29 255.5H27ZM35.25 256.25V254H36.75V256.25H39V257.75H36.75V260H35.25V257.75H33V256.25H35.25Z",
        fill: "#BFDBF8",
        fillOpacity: 0.28
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        filter: "url(#filter1_dd_211_10747)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 8,
        y: 285,
        width: 48,
        height: 48,
        rx: 24,
        fill: "#22272B"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M31.25 305V302H32.75V305H31.25ZM29.4697 307.53L25.4697 303.53L26.5303 302.47L30.5303 306.47L29.4697 307.53ZM33.4697 306.47L37.4697 302.47L38.5303 303.53L34.5303 307.53L33.4697 306.47ZM25 308.25H28V309.75H25V308.25ZM36 308.25H39V309.75H36V308.25ZM25.4697 314.47L29.4697 310.47L30.5303 311.53L26.5303 315.53L25.4697 314.47ZM37.4697 315.53L33.4697 311.53L34.5303 310.47L38.5303 314.47L37.4697 315.53ZM31.25 316V313H32.75V316H31.25Z",
        fill: "#738496"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("filter", {
        id: "filter0_dd_211_10747",
        x: 7,
        y: 55,
        width: 50,
        height: 224,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feOffset", {
        dy: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feGaussianBlur", {
        stdDeviation: 0.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0117647 0 0 0 0.5 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_211_10747"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feGaussianBlur", {
        stdDeviation: 0.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0117647 0 0 0 0.5 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_211_10747",
        result: "effect2_dropShadow_211_10747"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_211_10747",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("filter", {
        id: "filter1_dd_211_10747",
        x: 7,
        y: 284,
        width: 50,
        height: 51,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feOffset", {
        dy: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feGaussianBlur", {
        stdDeviation: 0.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0117647 0 0 0 0.5 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_211_10747"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feGaussianBlur", {
        stdDeviation: 0.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0117647 0 0 0 0.5 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_211_10747",
        result: "effect2_dropShadow_211_10747"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_211_10747",
        result: "shape"
    }))));
};

});

parcelRegister("fMFDo", function(module, exports) {

$parcel$export(module.exports, "SideNav", function () { return $b7dba26afd7a55f3$export$1a35787d6353cf6a; });
/* side-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $91i6m = parcelRequire("91i6m");

var $aDWwl = parcelRequire("aDWwl");
var $9wl70 = parcelRequire("9wl70");

var $f1J6u = parcelRequire("f1J6u");
var $b7dba26afd7a55f3$var$styles = {
    background: "_1s7z7r9e _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
var $b7dba26afd7a55f3$export$1a35787d6353cf6a = function SideNav() {
    var isAboveMediumScreen = (0, $f1J6u.useMatchMedia)((0, $9wl70.media).above.md);
    return isAboveMediumScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $aDWwl.default), {
        xcss: $b7dba26afd7a55f3$var$styles.background
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($b7dba26afd7a55f3$var$Image, null)) : null;
};
var $b7dba26afd7a55f3$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 308,
        height: 705,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 5.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 9,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 17.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 48.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 52.96,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 60.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "m283.939 64.5-3.969-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 91.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 95.96,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 103.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "m283.939 107.5-3.969-3.97 1.06-1.06 4.5 4.5a.749.749 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 134.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 138,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 146.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 177.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 181,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 189.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "m7.94 236.5-3.97-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.97-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 24,
        y: 232.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 263.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "M9.667 279.333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM8 279a1.667 1.667 0 1 1 3.333 0A1.667 1.667 0 0 1 8 279Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM14.333 279a1.667 1.667 0 1 1 3.334 0 1.667 1.667 0 0 1-3.334 0Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM20.667 279A1.667 1.667 0 1 1 24 279a1.667 1.667 0 0 1-3.333 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        d: "M10 279a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM16.333 279a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM22.667 279a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 60,
        height: 8,
        x: 44,
        y: 275.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("mask", {
        id: "a",
        fill: "#fff"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M0 301h308v404H0V301Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#A1BDD9",
        fillOpacity: 0.08,
        d: "M0 302h308v-2H0v2Z",
        mask: "url(#a)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 306.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 310,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 318.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 361.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 365,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 373.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 404.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 408.96,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 416.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "M265.25 421.25v4.25h1.5v-4.25H271v-1.5h-4.25v-4.25h-1.5v4.25H261v1.5h4.25ZM285.25 420.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        d: "M285.5 420.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM290.25 420.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM295 420.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 270,
        height: 32,
        x: 13,
        y: 450,
        fill: "#22272B",
        stroke: "#A1BDD9",
        strokeOpacity: 0.08,
        strokeWidth: 1.5,
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "M34 465a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-.523 4.891a6 6 0 1 1 1.414-1.414l2.816 2.816a1 1 0 1 1-1.414 1.414l-2.816-2.816ZM27.94 511.5l-3.97-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.97-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 507.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "m22.03 552.47 3.97 3.969 3.97-3.969 1.06 1.06-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5 1.06-1.06Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 550.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 279,
        height: 43,
        x: 17,
        y: 576,
        fill: "#1C2B41",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("circle", {
        cx: 37,
        cy: 597.5,
        r: 2,
        fill: "#05C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 61,
        y: 593.5,
        fill: "#05C",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#1868DB",
        d: "M17 589h2.66v15.96H17z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("circle", {
        cx: 36,
        cy: 640.5,
        r: 2,
        fill: "#BFDBF8",
        fillOpacity: 0.28
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 60,
        y: 636.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("circle", {
        cx: 36,
        cy: 683.5,
        r: 2,
        fill: "#BFDBF8",
        fillOpacity: 0.28
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 60,
        y: 679.5,
        fill: "#454F59",
        rx: 3.99
    }));
};

});


parcelRegister("dyzBB", function(module, exports) {

$parcel$export(module.exports, "ConfluenceLightTheme", function () { return $9dea11df6ac51411$export$d4cbd1e5e91e64ff; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $91i6m = parcelRequire("91i6m");

var $dwV3h = parcelRequire("dwV3h");
var $hPyLR = parcelRequire("hPyLR");

var $eILiL = parcelRequire("eILiL");

var $fHcf2 = parcelRequire("fHcf2");

var $aq3px = parcelRequire("aq3px");

var $3WY7Q = parcelRequire("3WY7Q");

var $8wVij = parcelRequire("8wVij");

var $5F0pK = parcelRequire("5F0pK");

var $9cwP0 = parcelRequire("9cwP0");

var $gLyOS = parcelRequire("gLyOS");
var $9dea11df6ac51411$var$styles = {
    actions: "_ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q"
};
var $9dea11df6ac51411$export$d4cbd1e5e91e64ff = function ConfluenceLightTheme() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $fHcf2.Background), {
        testId: "testId-confluence-wireframe"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $aq3px.TopNav), {
        product: (0, $eILiL.Products).CONFLUENCE
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $dwV3h.default), {
        alignBlock: "stretch",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $gLyOS.SideNav), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $hPyLR.default), {
        grow: "fill",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $dwV3h.default), {
        xcss: $9dea11df6ac51411$var$styles.actions,
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $8wVij.Breadcrumbs), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $3WY7Q.Actions), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $dwV3h.default), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $5F0pK.Content), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $9cwP0.FloatingActions), null));
};

});
parcelRegister("3WY7Q", function(module, exports) {

$parcel$export(module.exports, "Actions", function () { return $2e056d8c5e83a055$export$b52183d5cfb26dc9; });

var $91i6m = parcelRequire("91i6m");

var $aDWwl = parcelRequire("aDWwl");
var $2e056d8c5e83a055$export$b52183d5cfb26dc9 = function Actions() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $aDWwl.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($2e056d8c5e83a055$var$Image, null));
};
var $2e056d8c5e83a055$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("svg", {
        width: 331,
        height: 32,
        viewBox: "0 0 331 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.5858 8.85361C12.3668 8.07256 13.6332 8.07256 14.4142 8.85361L15.1464 9.58584C15.9275 10.3669 15.9275 11.6332 15.1464 12.4143L10.0094 17.5513C9.76903 17.7917 9.47141 17.9668 9.1446 18.0602L5.95604 18.9712C5.69415 19.046 5.41227 18.973 5.21967 18.7804C5.02707 18.5878 4.95403 18.3059 5.02886 18.044L5.93987 14.8555C6.03325 14.5286 6.20837 14.231 6.44871 13.9907L11.5858 8.85361ZM13.3536 9.91427C13.1583 9.71901 12.8417 9.71901 12.6464 9.91427L12.0607 10.5001L13.5 11.9394L14.0858 11.3536C14.281 11.1583 14.281 10.8418 14.0858 10.6465L13.3536 9.91427ZM12.4393 13.0001L11 11.5607L7.50937 15.0513C7.44928 15.1114 7.4055 15.1858 7.38216 15.2675L6.84202 17.158L8.73251 16.6179C8.81422 16.5946 8.88862 16.5508 8.94871 16.4907L12.4393 13.0001ZM3 10.5012C2.72386 10.5012 2.5 10.725 2.5 11.0012V21.0012C2.5 21.2773 2.72386 21.5012 3 21.5012H13C13.2761 21.5012 13.5 21.2773 13.5 21.0012V18.0001H15V21.0012C15 22.1057 14.1046 23.0012 13 23.0012H3C1.89543 23.0012 1 22.1057 1 21.0012V11.0012C1 9.89659 1.89543 9.00115 3 9.00115H6V10.5012H3Z",
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 24,
        y: 13,
        width: 40,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 131,
        y: 3,
        width: 26,
        height: 26,
        rx: 13,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 131,
        y: 3,
        width: 26,
        height: 26,
        rx: 13,
        stroke: "#DCDFE4",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M140.566 21V19.9746L143.848 16.5225C144.281 16.0667 144.618 15.693 144.859 15.4014C145.105 15.1051 145.276 14.8408 145.372 14.6084C145.472 14.3714 145.522 14.1208 145.522 13.8564V13.8359C145.522 13.5124 145.452 13.2253 145.311 12.9746C145.169 12.7194 144.969 12.5189 144.709 12.373C144.449 12.2227 144.137 12.1475 143.772 12.1475C143.403 12.1475 143.08 12.2249 142.802 12.3799C142.524 12.5303 142.307 12.7422 142.152 13.0156C141.997 13.2845 141.92 13.6012 141.92 13.9658L141.913 13.9863L140.491 13.9795L140.478 13.9658C140.482 13.3643 140.628 12.8333 140.915 12.373C141.202 11.9128 141.599 11.5527 142.104 11.293C142.615 11.0286 143.201 10.8965 143.861 10.8965C144.467 10.8965 145.01 11.0173 145.488 11.2588C145.971 11.4958 146.35 11.8262 146.623 12.25C146.901 12.6693 147.04 13.1501 147.04 13.6924V13.7129C147.04 14.082 146.972 14.4421 146.835 14.793C146.698 15.1439 146.464 15.529 146.131 15.9482C145.798 16.3675 145.331 16.8757 144.729 17.4727L142.241 19.9678L142.631 19.2842V19.9678L142.241 19.708H147.197V21H140.566Z",
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("circle", {
        cx: 122,
        cy: 16,
        r: 13,
        fill: "url(#pattern0_211_9747)",
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("circle", {
        cx: 100,
        cy: 16,
        r: 13,
        fill: "url(#pattern1_211_9747)",
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("mask", {
        id: "path-7-inside-1_211_9747",
        fill: "white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M176 4C176 1.79086 177.791 0 180 0H262V32H180C177.791 32 176 30.2091 176 28V4Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M175 4C175 1.23858 177.239 -1 180 -1H262V1H180C178.343 1 177 2.34315 177 4H175ZM262 33H180C177.239 33 175 30.7614 175 28H177C177 29.6569 178.343 31 180 31H262V33ZM180 33C177.239 33 175 30.7614 175 28V4C175 1.23858 177.239 -1 180 -1V1C178.343 1 177 2.34315 177 4V28C177 29.6569 178.343 31 180 31V33ZM262 0V32V0Z",
        fill: "#091E42",
        fillOpacity: 0.06,
        mask: "url(#path-7-inside-1_211_9747)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M196 9.5C194.619 9.5 193.5 10.6193 193.5 12V15H200C201.105 15 202 15.8954 202 17V22C202 23.1046 201.105 24 200 24H192C190.895 24 190 23.1046 190 22V17C190 15.8954 190.895 15 192 15V12C192 9.79086 193.791 8 196 8C198.209 8 200 9.79086 200 12H198.5C198.5 10.6193 197.381 9.5 196 9.5ZM192 16.5C191.724 16.5 191.5 16.7239 191.5 17V22C191.5 22.2761 191.724 22.5 192 22.5H200C200.276 22.5 200.5 22.2761 200.5 22V17C200.5 16.7239 200.276 16.5 200 16.5H192Z",
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 210,
        y: 13,
        width: 40,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M262 32V0H263V32H262Z",
        fill: "#091E42",
        fillOpacity: 0.06
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("mask", {
        id: "path-12-inside-2_211_9747",
        fill: "white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M263 0H291C293.209 0 295 1.79086 295 4V28C295 30.2091 293.209 32 291 32H263V0Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M263 -1H291C293.761 -1 296 1.23858 296 4H294C294 2.34315 292.657 1 291 1H263V-1ZM296 28C296 30.7614 293.761 33 291 33H263V31H291C292.657 31 294 29.6569 294 28H296ZM263 32V0V32ZM291 -1C293.761 -1 296 1.23858 296 4V28C296 30.7614 293.761 33 291 33V31C292.657 31 294 29.6569 294 28V4C294 2.34315 292.657 1 291 1V-1Z",
        fill: "#091E42",
        fillOpacity: 0.06,
        mask: "url(#path-12-inside-2_211_9747)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M278.22 10.2196C279.756 8.68411 282.245 8.68411 283.781 10.2196C285.316 11.7552 285.316 14.2448 283.781 15.7803L281.531 18.0303L280.47 16.9696L282.72 14.7196C283.67 13.7699 283.67 12.2301 282.72 11.2803C281.77 10.3306 280.23 10.3306 279.281 11.2803L277.031 13.5303L275.97 12.4696L278.22 10.2196ZM281.281 13.7803L275.781 19.2803L274.72 18.2196L280.22 12.7196L281.281 13.7803ZM272.22 16.2196L274.47 13.9696L275.531 15.0303L273.281 17.2803C272.331 18.2301 272.331 19.7699 273.281 20.7196C274.23 21.6694 275.77 21.6694 276.72 20.7196L278.97 18.4696L280.031 19.5303L277.781 21.7803C276.245 23.3158 273.756 23.3158 272.22 21.7803C270.684 20.2448 270.684 17.7552 272.22 16.2196Z",
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 299,
        width: 32,
        height: 32,
        rx: 3,
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M307 16C307 15.1716 307.672 14.5 308.5 14.5C309.328 14.5 310 15.1716 310 16C310 16.8284 309.328 17.5 308.5 17.5C307.672 17.5 307 16.8284 307 16ZM313.5 16C313.5 15.1716 314.172 14.5 315 14.5C315.828 14.5 316.5 15.1716 316.5 16C316.5 16.8284 315.828 17.5 315 17.5C314.172 17.5 313.5 16.8284 313.5 16ZM320 16C320 15.1716 320.672 14.5 321.5 14.5C322.328 14.5 323 15.1716 323 16C323 16.8284 322.328 17.5 321.5 17.5C320.672 17.5 320 16.8284 320 16Z",
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("pattern", {
        id: "pattern0_211_9747",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("use", {
        xlinkHref: "#image0_211_9747",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("pattern", {
        id: "pattern1_211_9747",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("use", {
        xlinkHref: "#image1_211_9747",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("image", {
        id: "image0_211_9747",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAgIDAQAAAAAAAAAAAAAAAAcDBgQFCAH/xAAsEAABAwMCBQMDBQAAAAAAAAABAgMEAAURBiESEzFBUQeBkSJhcRQVMjOh/8QAFwEBAQEBAAAAAAAAAAAAAAAABwYEBf/EACkRAAEEAQIFBAIDAAAAAAAAAAECAwQRAAVREyExYYEGEnGhB0GisfD/2gAMAwEAAhEDEQA/AKVRRWXa4S7hObjt7FR3PgdzTLIkNxmlPvGkpBJOwHXDtllb7iWmxalGgO5zFSCo4SCT4FCkKQcKSUn7jFOpnRMqzx0CLDS4CASto8Sj+e9TtaQm3VBblREIaPeQMfA60YufktYlcJuEoo3ujW9VX8vOXSPRCSxxFyUhW1cvi7v68YjaK3GqLOqz3JbIyWiTw57YOCPatPSTAnM6hHRKjm0KFj/bg8j3yJlxXIbymHhSk9cKYXo9ZjOvBlvI4oqFBk468WOLf7fT/tL2rHorVc3S9wDkdQVFcUnntKGeJIO+PBxnesevQXJ8ByM11VXX9gEEjyBWatIlIiS0POdBf9EA+M6foqKLIalRmpEdYcZdQFoUOikkZBqU0QkEGjiMCCLGJj1ss/JImR0HlBaVOE9ApeRt7ppSVd/U3WMjUF1fhsOj9qju4aSkf2EbcZPffOPtVIpV9M6e5p0BLLnKyVVt7jdfeH+uzETJZcRsBe9csK9QlS1hKElSj0AGSakiR1ypTTDQytxQSKY9stsa3NBMdAC8fU4f5K9660mUlgVVk5zmWC78YxPTX9XC0Xa2ZjauMIKglWykpKiQPgitzfHJEu0TY8RPA86wtCFZ34ikgVW7Xq3ltJbuDKnCnbmN4yfyKnnawZ5ZEGMsuHop3AA9h1otf0+Y5KU57OZUT25m8v2Z0REcI93QV36VnO8iO9GcLchpbTg2KVpII+ajpqXdhF35huA5q1nJX3B8jxSzuEVUKa9HXuW1Yz5HY/FKESXxxShSsgZDHCNg2M//2Q=="
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("image", {
        id: "image1_211_9747",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAQUBAQAAAAAAAAAAAAAABQACBAYHAwj/xAAtEAABAwMDAwIEBwAAAAAAAAABAgMEAAURBhIhMUFRBxNhgaHBFDJCcZGx8P/EABcBAAMBAAAAAAAAAAAAAAAAAAQGBwX/xAAtEQABBAECAwQLAAAAAAAAAAABAAIDEQQhMQYSEyJBsfEFFBUyQlFxkcHh8P/aAAwDAQACEQMRAD8AKUqVBNX3ZdotBdYwJDqvbbJ/SepPyFOz3BjS4qIY8D8iVsUe5NIrIlx42PxL7LOenuLCf7pzD7UhG5h1t1PlCgofSsQeccfdU68tTjijkqWck/OnRJL8N9L0V1bLieikHFAev6+7om48JdjSXtfTTxW40qr+kL+LzFUh8JTMZA3gcBQ7KH3FWCj2PD28zUpZONJiymGUUQlUaLbGr9rTT1tcYVIQ28qVITtylLQSRlXwKsCpNV+53u66Q1HGv9rSlxlbQjSW1pylSQrdg+M9j5obP5jA4M3Wtw2I/aMZkNAX962W1r9NtHOOlxWnYG4nJASQP4BxQnWPpdpybpyei1WSNHuKWVKjLjjYr3AMpHXBBPHPmrrYrtDvtoi3K2uh2LIRvQodR5B8EHgjyK63SfFtVukTp7yWYkdBcccV0AH3+FJokkDtzashjjIuhS8h6RiT7Xq2PHmxZEV1aFpU282UHGD2PxFabQCHqSXrbV8y8TghDcVr2IrSRj20KUTz5Vgcmj9OGAHdEF3epDxS9js8tZ8IA/PgUqiXWKJttkxi4Gw6goKyM7Qe+KlEgAk9BzQSVJW+s5JCM8Jot5FUVhwNdzhzTVarTfQ6xOWTTcrE1UiNIkFxoEABOBhXGe5H0ot6sWM37RUuKZKmENqQ+ojHIQckc/7ismtF6uNnWpVuluMbvzJHKVfuDxXW8ahut4QEXCY462DkN8JTnzgcUvu9GPOR1ARV3/eaoUfFEYwui4OMlVem/wA/1SGaa081Z3nHo0115DqdqkqQAD4PHerBQGO+theUHjuOxo4hQWhKk9CMit6INaOVqQs2SWaTqymye/yX/9k="
    })));
};

});

parcelRegister("8wVij", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", function () { return $635dc15b05661305$export$2dc68d50d56fbbd; });

var $91i6m = parcelRequire("91i6m");

var $aDWwl = parcelRequire("aDWwl");
var $635dc15b05661305$export$2dc68d50d56fbbd = function Breadcrumbs() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $aDWwl.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($635dc15b05661305$var$Image, null));
};
var $635dc15b05661305$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 203,
        height: 20,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 100,
        height: 6,
        y: 7,
        fill: "#DCDFE4",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 54,
        height: 6,
        x: 113,
        y: 7,
        fill: "#DCDFE4",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#6B778C",
        d: "m108.701 4.664-3.014 12.81h-1.395l3.015-12.81h1.394Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M195 2a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.381 2.818 1.25 4.662a.748.748 0 0 1-1.148.813L195 14.159l-3.951 2.71a.75.75 0 0 1-1.148-.813l1.25-4.662-3.381-2.818a.749.749 0 0 1 .423-1.324l4.402-.338L194.3 2.48A.75.75 0 0 1 195 2Zm0 2.84-1.345 3.496-3.506.27 2.7 2.25-.973 3.627L195 12.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27L195 4.84Z",
        clipRule: "evenodd"
    }));
};

});

parcelRegister("5F0pK", function(module, exports) {

$parcel$export(module.exports, "Content", function () { return $41f11a5b3b8701f7$export$7c6e2c02157bb7d2; });

var $91i6m = parcelRequire("91i6m");

var $aDWwl = parcelRequire("aDWwl");
var $41f11a5b3b8701f7$export$7c6e2c02157bb7d2 = function Content() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $aDWwl.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($41f11a5b3b8701f7$var$Image, null));
};
var $41f11a5b3b8701f7$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("svg", {
        width: 612,
        height: 562,
        viewBox: "0 0 612 562",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 2,
        width: 503,
        height: 20,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 40,
        y: 60,
        width: 155,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 40,
        y: 48,
        width: 96,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("circle", {
        cx: 18,
        cy: 60,
        r: 17,
        fill: "url(#pattern0_138_18776)",
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 2,
        y: 100,
        width: 605,
        height: 86,
        rx: 5,
        fill: "#E9F2FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(18 116)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18 128C18 121.373 23.3726 116 30 116C36.6274 116 42 121.373 42 128C42 134.627 36.6274 140 30 140C23.3726 140 18 134.627 18 128ZM27.75 126.125H30C30.6213 126.125 31.125 126.629 31.125 127.25V134.75H28.875V128.375H27.75V126.125ZM30 124.25C30.8284 124.25 31.5 123.578 31.5 122.75C31.5 121.922 30.8284 121.25 30 121.25C29.1716 121.25 28.5 121.922 28.5 122.75C28.5 123.578 29.1716 124.25 30 124.25Z",
        fill: "#0C66E4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 68,
        y: 126,
        width: 529,
        height: 12,
        rx: 3,
        fill: "#CCE0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 68,
        y: 148,
        width: 261,
        height: 12,
        rx: 3,
        fill: "#CCE0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 2,
        y: 218,
        width: 32,
        height: 32,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 46,
        y: 228,
        width: 115,
        height: 12,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 2,
        y: 262,
        width: 98.5,
        height: 20,
        rx: 10,
        fill: "#CCE0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M14.7402 278.6C11.2129 278.6 8.97754 276.385 8.97754 272.898V272.885C8.97754 269.508 11.2744 267.19 14.624 267.19C17.8574 267.19 20.1064 269.255 20.1064 272.215V272.229C20.1064 274.45 19.1084 275.865 17.5361 275.865C16.75 275.865 16.1484 275.421 16.0391 274.758L16.0322 274.717H15.9229C15.6289 275.414 15.0137 275.804 14.2139 275.804C12.792 275.804 11.835 274.635 11.835 272.905V272.892C11.835 271.237 12.8125 270.075 14.2139 270.075C14.9316 270.075 15.5469 270.444 15.8135 271.039H15.9229V270.205H16.9551V274.218C16.9551 274.696 17.2354 274.977 17.7275 274.977C18.5889 274.977 19.1426 273.89 19.1426 272.215V272.201C19.1426 269.74 17.2695 268.052 14.5352 268.052C11.8623 268.052 9.94141 270.089 9.94141 272.926V272.939C9.94141 275.852 11.8281 277.731 14.7539 277.731C15.6904 277.731 16.6133 277.602 17.0439 277.403V278.265C16.4287 278.477 15.6016 278.6 14.7402 278.6ZM14.3711 274.84C15.3076 274.84 15.9092 274.095 15.9092 272.933V272.919C15.9092 271.757 15.3145 271.019 14.3848 271.019C13.4688 271.019 12.9287 271.729 12.9287 272.919V272.933C12.9287 274.115 13.4756 274.84 14.3711 274.84Z",
        fill: "#B3B9C4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 23.5,
        y: 269,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#B3B9C4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 108.5,
        y: 262,
        width: 98.5,
        height: 20,
        rx: 10,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M121.24 278.6C117.713 278.6 115.478 276.385 115.478 272.898V272.885C115.478 269.508 117.774 267.19 121.124 267.19C124.357 267.19 126.606 269.255 126.606 272.215V272.229C126.606 274.45 125.608 275.865 124.036 275.865C123.25 275.865 122.648 275.421 122.539 274.758L122.532 274.717H122.423C122.129 275.414 121.514 275.804 120.714 275.804C119.292 275.804 118.335 274.635 118.335 272.905V272.892C118.335 271.237 119.312 270.075 120.714 270.075C121.432 270.075 122.047 270.444 122.313 271.039H122.423V270.205H123.455V274.218C123.455 274.696 123.735 274.977 124.228 274.977C125.089 274.977 125.643 273.89 125.643 272.215V272.201C125.643 269.74 123.77 268.052 121.035 268.052C118.362 268.052 116.441 270.089 116.441 272.926V272.939C116.441 275.852 118.328 277.731 121.254 277.731C122.19 277.731 123.113 277.602 123.544 277.403V278.265C122.929 278.477 122.102 278.6 121.24 278.6ZM120.871 274.84C121.808 274.84 122.409 274.095 122.409 272.933V272.919C122.409 271.757 121.814 271.019 120.885 271.019C119.969 271.019 119.429 271.729 119.429 272.919V272.933C119.429 274.115 119.976 274.84 120.871 274.84Z",
        fill: "#B3B9C4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 130,
        y: 269,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#B3B9C4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 215,
        y: 262,
        width: 98.5,
        height: 20,
        rx: 10,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M227.74 278.6C224.213 278.6 221.978 276.385 221.978 272.898V272.885C221.978 269.508 224.274 267.19 227.624 267.19C230.857 267.19 233.106 269.255 233.106 272.215V272.229C233.106 274.45 232.108 275.865 230.536 275.865C229.75 275.865 229.148 275.421 229.039 274.758L229.032 274.717H228.923C228.629 275.414 228.014 275.804 227.214 275.804C225.792 275.804 224.835 274.635 224.835 272.905V272.892C224.835 271.237 225.812 270.075 227.214 270.075C227.932 270.075 228.547 270.444 228.813 271.039H228.923V270.205H229.955V274.218C229.955 274.696 230.235 274.977 230.728 274.977C231.589 274.977 232.143 273.89 232.143 272.215V272.201C232.143 269.74 230.27 268.052 227.535 268.052C224.862 268.052 222.941 270.089 222.941 272.926V272.939C222.941 275.852 224.828 277.731 227.754 277.731C228.69 277.731 229.613 277.602 230.044 277.403V278.265C229.429 278.477 228.602 278.6 227.74 278.6ZM227.371 274.84C228.308 274.84 228.909 274.095 228.909 272.933V272.919C228.909 271.757 228.314 271.019 227.385 271.019C226.469 271.019 225.929 271.729 225.929 272.919V272.933C225.929 274.115 226.476 274.84 227.371 274.84Z",
        fill: "#B3B9C4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 236.5,
        y: 269,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#B3B9C4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 2,
        y: 314,
        width: 234,
        height: 20,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 2,
        y: 350,
        width: 590,
        height: 12,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 2,
        y: 378,
        width: 590,
        height: 12,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 2,
        y: 406,
        width: 277,
        height: 12,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 444H28C29.1046 444 30 444.895 30 446V454C30 455.105 29.1046 456 28 456H20C18.8954 456 18 455.105 18 454V446C18 444.895 18.8954 444 20 444ZM21.3824 449.069C21.5044 449.121 21.6148 449.198 21.707 449.293L23 450.586L26.293 447.293C26.3852 447.198 26.4956 447.121 26.6176 447.069C26.7396 447.017 26.8708 446.989 27.0036 446.988C27.1364 446.987 27.2681 447.012 27.391 447.062C27.5139 447.112 27.6255 447.187 27.7194 447.281C27.8133 447.375 27.8875 447.486 27.9378 447.609C27.9881 447.732 28.0134 447.864 28.0123 447.996C28.0111 448.129 27.9835 448.26 27.9311 448.382C27.8787 448.504 27.8025 448.615 27.707 448.707L23.707 452.707C23.5195 452.894 23.2652 453 23 453C22.7348 453 22.4805 452.894 22.293 452.707L20.293 450.707C20.1975 450.615 20.1213 450.504 20.0689 450.382C20.0165 450.26 19.9889 450.129 19.9878 449.996C19.9866 449.864 20.0119 449.732 20.0622 449.609C20.1125 449.486 20.1867 449.375 20.2806 449.281C20.3745 449.187 20.4862 449.112 20.609 449.062C20.7319 449.012 20.8636 448.987 20.9964 448.988C21.1292 448.989 21.2604 449.017 21.3824 449.069Z",
        fill: "#0C66E4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 38,
        y: 447,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 18,
        y: 476,
        width: 12,
        height: 12,
        rx: 6,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 38,
        y: 479,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 18,
        y: 508,
        width: 12,
        height: 12,
        rx: 6,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 38,
        y: 511,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 18,
        y: 540,
        width: 12,
        height: 12,
        rx: 6,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 38,
        y: 543,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("pattern", {
        id: "pattern0_138_18776",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("use", {
        xlinkHref: "#image0_138_18776",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("image", {
        id: "image0_138_18776",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAQUBAQAAAAAAAAAAAAAABQACBAYHAwj/xAAtEAABAwMDAwIEBwAAAAAAAAABAgMEAAURBhIhMUFRBxNhgaHBFDJCcZGx8P/EABcBAAMBAAAAAAAAAAAAAAAAAAQGBwX/xAAtEQABBAECAwQLAAAAAAAAAAABAAIDEQQhMQYSEyJBsfEFFBUyQlFxkcHh8P/aAAwDAQACEQMRAD8AKUqVBNX3ZdotBdYwJDqvbbJ/SepPyFOz3BjS4qIY8D8iVsUe5NIrIlx42PxL7LOenuLCf7pzD7UhG5h1t1PlCgofSsQeccfdU68tTjijkqWck/OnRJL8N9L0V1bLieikHFAev6+7om48JdjSXtfTTxW40qr+kL+LzFUh8JTMZA3gcBQ7KH3FWCj2PD28zUpZONJiymGUUQlUaLbGr9rTT1tcYVIQ28qVITtylLQSRlXwKsCpNV+53u66Q1HGv9rSlxlbQjSW1pylSQrdg+M9j5obP5jA4M3Wtw2I/aMZkNAX962W1r9NtHOOlxWnYG4nJASQP4BxQnWPpdpybpyei1WSNHuKWVKjLjjYr3AMpHXBBPHPmrrYrtDvtoi3K2uh2LIRvQodR5B8EHgjyK63SfFtVukTp7yWYkdBcccV0AH3+FJokkDtzashjjIuhS8h6RiT7Xq2PHmxZEV1aFpU282UHGD2PxFabQCHqSXrbV8y8TghDcVr2IrSRj20KUTz5Vgcmj9OGAHdEF3epDxS9js8tZ8IA/PgUqiXWKJttkxi4Gw6goKyM7Qe+KlEgAk9BzQSVJW+s5JCM8Jot5FUVhwNdzhzTVarTfQ6xOWTTcrE1UiNIkFxoEABOBhXGe5H0ot6sWM37RUuKZKmENqQ+ojHIQckc/7ismtF6uNnWpVuluMbvzJHKVfuDxXW8ahut4QEXCY462DkN8JTnzgcUvu9GPOR1ARV3/eaoUfFEYwui4OMlVem/wA/1SGaa081Z3nHo0115DqdqkqQAD4PHerBQGO+theUHjuOxo4hQWhKk9CMit6INaOVqQs2SWaTqymye/yX/9k="
    })));
};

});

parcelRegister("9cwP0", function(module, exports) {

$parcel$export(module.exports, "FloatingActions", function () { return $6b2eb1b9ed54f304$export$babdd492df2e202d; });
/* floating-actions.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $91i6m = parcelRequire("91i6m");

var $aDWwl = parcelRequire("aDWwl");
var $6b2eb1b9ed54f304$var$styles = {
    wrapper: "_kqsw1n9t _94n512x7 _1xi212x7"
};
var $6b2eb1b9ed54f304$export$babdd492df2e202d = function FloatingActions() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $aDWwl.default), {
        xcss: $6b2eb1b9ed54f304$var$styles.wrapper,
        backgroundColor: "elevation.surface"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($6b2eb1b9ed54f304$var$Image, null));
};
var $6b2eb1b9ed54f304$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("svg", {
        width: 63,
        height: 339,
        viewBox: "0 0 63 339",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        filter: "url(#filter0_dd_211_9818)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M8 80C8 66.7452 18.7452 56 32 56C45.2548 56 56 66.7452 56 80V253C56 266.255 45.2548 277 32 277C18.7452 277 8 266.255 8 253V80Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24 75.125C24 73.6753 25.1753 72.5 26.625 72.5H37.375C38.8247 72.5 40 73.6753 40 75.125V83.375C40 84.8247 38.8247 86 37.375 86H28.4492L25.1221 87.9012C24.89 88.0338 24.6048 88.0329 24.3736 87.8987C24.1423 87.7645 24 87.5174 24 87.25V75.125ZM26.625 74C26.0037 74 25.5 74.5037 25.5 75.125V85.9576L28.0508 84.5H37.375C37.9963 84.5 38.5 83.9963 38.5 83.375V75.125C38.5 74.5037 37.9963 74 37.375 74H26.625ZM36.0002 78.4998H28.0002V76.9998H36.0002V78.4998ZM33.0002 81.4998H28.0002V79.9998H33.0002V81.4998Z",
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("circle", {
        cx: 41,
        cy: 72,
        r: 5,
        fill: "#85B8FF",
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M39 115.5L25 115.5L25 114L39 114L39 115.5ZM39 120.75L25 120.75L25 119.25L39 119.25L39 120.75ZM32 126L25 126L25 124.5L32 124.5L32 126Z",
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 20,
        y: 146,
        width: 24,
        height: 1,
        fill: "#0B1228",
        fillOpacity: 0.14
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M26 168.5C25.7239 168.5 25.5 168.724 25.5 169V177C25.5 177.276 25.7239 177.5 26 177.5H34C34.2761 177.5 34.5 177.276 34.5 177V169C34.5 168.724 34.2761 168.5 34 168.5H26ZM24 169C24 167.895 24.8954 167 26 167H34C35.1046 167 36 167.895 36 169V169.786L38.191 168.691C39.0221 168.275 40 168.88 40 169.809V176.191C40 177.12 39.0221 177.725 38.191 177.309L36 176.214V177C36 178.105 35.1046 179 34 179H26C24.8954 179 24 178.105 24 177V169ZM36 174.536L38.5 175.786V170.214L36 171.464V174.536Z",
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M34.3774 205.102C34.6716 205.273 34.8136 205.621 34.723 205.949L32.9849 212.25H37.25C37.5534 212.25 37.8268 212.433 37.9429 212.713C38.059 212.993 37.9949 213.316 37.7804 213.53L30.5304 220.78C30.2896 221.021 29.9169 221.069 29.6226 220.898C29.3284 220.727 29.1865 220.379 29.277 220.051L31.0151 213.75H26.75C26.4467 213.75 26.1732 213.567 26.0571 213.287C25.941 213.007 26.0052 212.684 26.2197 212.47L33.4697 205.22C33.7104 204.979 34.0832 204.931 34.3774 205.102ZM31.4289 212.25L32.5216 208.289L28.5607 212.25H31.4289ZM32.5711 213.75L31.4785 217.711L35.4394 213.75H32.5711Z",
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25 248C25 246.895 25.8954 246 27 246H29C30.1046 246 31 246.895 31 248V250C31 251.105 30.1046 252 29 252H27C25.8954 252 25 251.105 25 250V248ZM27 247.5C26.7239 247.5 26.5 247.724 26.5 248V250C26.5 250.276 26.7239 250.5 27 250.5H29C29.2761 250.5 29.5 250.276 29.5 250V248C29.5 247.724 29.2761 247.5 29 247.5H27ZM33 248C33 246.895 33.8954 246 35 246H37C38.1046 246 39 246.895 39 248V250C39 251.105 38.1046 252 37 252H35C33.8954 252 33 251.105 33 250V248ZM35 247.5C34.7239 247.5 34.5 247.724 34.5 248V250C34.5 250.276 34.7239 250.5 35 250.5H37C37.2761 250.5 37.5 250.276 37.5 250V248C37.5 247.724 37.2761 247.5 37 247.5H35ZM25 256C25 254.895 25.8954 254 27 254H29C30.1046 254 31 254.895 31 256V258C31 259.105 30.1046 260 29 260H27C25.8954 260 25 259.105 25 258V256ZM27 255.5C26.7239 255.5 26.5 255.724 26.5 256V258C26.5 258.276 26.7239 258.5 27 258.5H29C29.2761 258.5 29.5 258.276 29.5 258V256C29.5 255.724 29.2761 255.5 29 255.5H27ZM35.25 256.25V254H36.75V256.25H39V257.75H36.75V260H35.25V257.75H33V256.25H35.25Z",
        fill: "#091E42",
        fillOpacity: 0.31
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        filter: "url(#filter1_dd_211_9818)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 8,
        y: 285,
        width: 48,
        height: 48,
        rx: 24,
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M31.25 305V302H32.75V305H31.25ZM29.4697 307.53L25.4697 303.53L26.5303 302.47L30.5303 306.47L29.4697 307.53ZM33.4697 306.47L37.4697 302.47L38.5303 303.53L34.5303 307.53L33.4697 306.47ZM25 308.25H28V309.75H25V308.25ZM36 308.25H39V309.75H36V308.25ZM25.4697 314.47L29.4697 310.47L30.5303 311.53L26.5303 315.53L25.4697 314.47ZM37.4697 315.53L33.4697 311.53L34.5303 310.47L38.5303 314.47L37.4697 315.53ZM31.25 316V313H32.75V316H31.25Z",
        fill: "#8590A2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("filter", {
        id: "filter0_dd_211_9818",
        x: 7,
        y: 55,
        width: 50,
        height: 224,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feOffset", {
        dy: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feGaussianBlur", {
        stdDeviation: 0.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_211_9818"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feGaussianBlur", {
        stdDeviation: 0.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_211_9818",
        result: "effect2_dropShadow_211_9818"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_211_9818",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("filter", {
        id: "filter1_dd_211_9818",
        x: 7,
        y: 284,
        width: 50,
        height: 51,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feOffset", {
        dy: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feGaussianBlur", {
        stdDeviation: 0.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_211_9818"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feGaussianBlur", {
        stdDeviation: 0.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_211_9818",
        result: "effect2_dropShadow_211_9818"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_211_9818",
        result: "shape"
    }))));
};

});

parcelRegister("gLyOS", function(module, exports) {

$parcel$export(module.exports, "SideNav", function () { return $c34c0b90f45cec26$export$1a35787d6353cf6a; });
/* side-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $91i6m = parcelRequire("91i6m");

var $aDWwl = parcelRequire("aDWwl");
var $9wl70 = parcelRequire("9wl70");

var $f1J6u = parcelRequire("f1J6u");
var $c34c0b90f45cec26$var$styles = {
    background: "_1s7z7r9e _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
var $c34c0b90f45cec26$export$1a35787d6353cf6a = function SideNav() {
    var isAboveMediumScreen = (0, $f1J6u.useMatchMedia)((0, $9wl70.media).above.md);
    return isAboveMediumScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $aDWwl.default), {
        xcss: $c34c0b90f45cec26$var$styles.background
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($c34c0b90f45cec26$var$Image, null)) : null;
};
var $c34c0b90f45cec26$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 308,
        height: 705,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 5.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 9,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 17.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 48.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 52.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 60.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "m283.939 64.5-3.969-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 91.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 95.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 103.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "m283.939 107.5-3.969-3.97 1.06-1.06 4.5 4.5a.749.749 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 134.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 138,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 146.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 177.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 181,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 189.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "m7.94 236.5-3.97-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.97-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 24,
        y: 232.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 263.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M9.667 279.333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM8 279a1.667 1.667 0 1 1 3.335 0A1.667 1.667 0 0 1 8 279Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM14.333 279a1.667 1.667 0 1 1 3.335 0 1.667 1.667 0 0 1-3.335 0Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM20.667 279A1.667 1.667 0 1 1 24 279a1.667 1.667 0 0 1-3.334 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        d: "M10 279a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM16.333 279a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM22.667 279a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 60,
        height: 8,
        x: 44,
        y: 275.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("mask", {
        id: "a",
        fill: "#fff"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M0 301h308v404H0V301Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.06,
        d: "M0 302h308v-2H0v2Z",
        mask: "url(#a)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 306.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 310,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 318.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 361.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 365,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 373.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 404.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 408.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 416.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M265.25 421.25v4.25h1.5v-4.25H271v-1.5h-4.25v-4.25h-1.5v4.25H261v1.5h4.25ZM285.25 420.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        d: "M285.5 420.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM290.25 420.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM295 420.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 270,
        height: 32,
        x: 13,
        y: 450,
        fill: "#fff",
        stroke: "#091E42",
        strokeOpacity: 0.06,
        strokeWidth: 1.5,
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M34 465a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-.523 4.891a6 6 0 1 1 1.414-1.414l2.816 2.816a1 1 0 1 1-1.414 1.414l-2.816-2.816ZM27.94 511.5l-3.97-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.97-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 507.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "m22.03 552.47 3.97 3.969 3.97-3.969 1.06 1.06-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5 1.06-1.06Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 550.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 279,
        height: 43,
        x: 17,
        y: 576,
        fill: "#E9F2FF",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("circle", {
        cx: 37,
        cy: 597.5,
        r: 2,
        fill: "#85B8FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 61,
        y: 593.5,
        fill: "#85B8FF",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#1868DB",
        d: "M17 589h2.66v15.96H17z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("circle", {
        cx: 36,
        cy: 640.5,
        r: 2,
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 60,
        y: 636.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("circle", {
        cx: 36,
        cy: 683.5,
        r: 2,
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 60,
        y: 679.5,
        fill: "#DCDFE4",
        rx: 3.99
    }));
};

});




parcelRegister("4Z8fV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a68b55565e1ddfb7$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $4ksd4 = parcelRequire("4ksd4");

var $cS2tj = parcelRequire("cS2tj");

var $iTSCG = parcelRequire("iTSCG");
const $a68b55565e1ddfb7$var$logoWrapperStyles = {
    display: 'flex',
    gap: '8px'
};
const $a68b55565e1ddfb7$var$CommunityCobranding = {
    background: (0, $4ksd4.DefaultBackground),
    logo: {
        renderLogo: ()=>/*#__PURE__*/ (0, $4ZSso.jsxs)("span", {
                style: $a68b55565e1ddfb7$var$logoWrapperStyles,
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $iTSCG.AtlassianLogo), {
                        appearance: "brand",
                        size: "medium"
                    }),
                    /*#__PURE__*/ (0, $4ZSso.jsx)("span", {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cS2tj.CommunityLogo), {})
                    })
                ]
            })
    },
    footerProducts: 'Community, Jira, Confluence'
};
var $a68b55565e1ddfb7$export$2e2bcd8739ae039 = $a68b55565e1ddfb7$var$CommunityCobranding;

});
parcelRegister("cS2tj", function(module, exports) {

$parcel$export(module.exports, "CommunityLogo", function () { return $8490ae86f977a7a2$export$311e5e9ca09eea69; });
/* CommunityLogo.tsx generated by @compiled/babel-plugin v0.37.0 */ /* eslint-disable react/no-unknown-property */ 
var $9gzWK = parcelRequire("9gzWK");

var $91i6m = parcelRequire("91i6m");
const $8490ae86f977a7a2$export$311e5e9ca09eea69 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "127",
        height: "24",
        viewBox: "0 0 127 24",
        fill: "none",
        className: (0, $9gzWK.default)([
            "_1bsb1osq _4t3i1osq"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M119.728 17.303H118.315L113.75 5.33594H116.07L120.106 16.2801L124.141 5.33594H126.462L121.695 17.7121C120.282 21.3687 119.475 23.2609 116.272 23.2609C115.188 23.2609 114.582 23.1586 113.952 22.9029V21.0107C114.683 21.2408 115.516 21.3176 116.146 21.3176C117.912 21.3176 118.693 20.0902 119.728 17.303Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M109.789 14.1534C109.789 15.2785 110.444 16.0457 111.781 16.0457C112.286 16.0457 112.765 15.9434 113.143 15.8667V17.989C112.765 18.0913 112.336 18.1936 111.68 18.1936C108.981 18.1936 107.67 16.5826 107.67 14.2046V7.37722H105.627V5.33158H107.67V2.62109H109.789V5.33158H113.143V7.37722H109.789V14.1534Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M100.939 1.96002C100.939 0.988335 101.57 0.425781 102.453 0.425781C103.336 0.425781 103.966 0.988335 103.966 1.96002C103.966 2.9317 103.336 3.49425 102.453 3.49425C101.57 3.49425 100.939 2.9317 100.939 1.96002ZM101.343 18.1206V5.33533H103.512V18.1206H101.343Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M98.3189 10.6269V18.1191H96.1498V10.3968C96.1498 8.09545 95.2419 7.07263 93.1737 7.07263C91.1559 7.07263 89.7687 8.42787 89.7687 11.0105V18.1191H87.5996V5.33383H89.7687V7.43062C90.5758 5.92195 92.0639 5.07812 93.7538 5.07812C96.6543 5.07812 98.3189 7.0982 98.3189 10.6269Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M73.6016 12.8281V5.33594H75.7707V13.0583C75.7707 15.3596 76.6786 16.3824 78.7468 16.3824C80.7646 16.3824 82.1518 15.0272 82.1518 12.4446V5.33594H84.3209V18.1212H82.1518V16.0244C81.3447 17.5331 79.8566 18.3769 78.1667 18.3769C75.2662 18.3769 73.6016 16.3569 73.6016 12.8281Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M62.2838 11.0105V18.1191H60.1147V10.3968C60.1147 8.09545 59.2067 7.07263 57.1385 7.07263C55.1207 7.07263 53.7335 8.42787 53.7335 11.0105V18.1191H51.5645V5.33383H53.7335V7.43062C54.5406 5.92195 56.0287 5.07812 57.7186 5.07812C59.8625 5.07812 61.3253 6.17766 61.9559 8.19774C62.6621 6.2288 64.352 5.07812 66.4454 5.07812C69.2703 5.07812 70.834 7.02149 70.834 10.6269V18.1191H68.6649V11.0105C68.6649 8.37673 67.7569 7.07263 65.6887 7.07263C63.671 7.07263 62.2838 8.42787 62.2838 11.0105Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M39.9928 11.0105V18.1191H37.8237V10.3968C37.8237 8.09545 36.9157 7.07263 34.8475 7.07263C32.8297 7.07263 31.4425 8.42787 31.4425 11.0105V18.1191H29.2734V5.33383H31.4425V7.43062C32.2496 5.92195 33.7377 5.07812 35.4276 5.07812C37.5715 5.07812 39.0343 6.17766 39.6649 8.19774C40.3711 6.2288 42.061 5.07812 44.1544 5.07812C46.9792 5.07812 48.543 7.02149 48.543 10.6269V18.1191H46.3739V11.0105C46.3739 8.37673 45.4659 7.07263 43.3977 7.07263C41.38 7.07263 39.9928 8.42787 39.9928 11.0105Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M20.7997 18.3748C17.0164 18.3748 14.7969 15.5365 14.7969 11.7009C14.7969 7.86532 17.0164 5.07812 20.7997 5.07812C24.5578 5.07812 26.7521 7.86532 26.7521 11.7009C26.7521 15.5365 24.5578 18.3748 20.7997 18.3748ZM20.7997 7.12377C18.1009 7.12377 16.9155 9.2717 16.9155 11.7009C16.9155 14.1301 18.1009 16.3292 20.7997 16.3292C23.4732 16.3292 24.6334 14.1301 24.6334 11.7009C24.6334 9.2717 23.4732 7.12377 20.7997 7.12377Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M13.2066 15.1558V17.3804C12.1725 18.0708 10.5331 18.3777 8.81798 18.3777C3.37004 18.3777 0.292969 15.0535 0.292969 9.76041C0.292969 4.64629 3.37004 1.06641 8.76754 1.06641C10.3817 1.06641 11.9959 1.37325 13.1814 2.24265V4.46729C11.9959 3.70018 10.6844 3.29105 8.76754 3.29105C4.88336 3.29105 2.56294 5.89925 2.56294 9.76041C2.56294 13.6216 4.95903 16.1786 8.89365 16.1786C10.634 16.1786 11.9959 15.7695 13.2066 15.1558Z",
        fill: "#101214"
    }));
const $8490ae86f977a7a2$var$svgStyles = null;

});


parcelRegister("18a0P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c55a698514af0f5a$export$2e2bcd8739ae039; });

var $eQ1c9 = parcelRequire("eQ1c9");

var $8wVNq = parcelRequire("8wVNq");
const $c55a698514af0f5a$var$JiraCobranding = {
    background: (0, $8wVNq.JiraBackground),
    logo: {
        component: (0, $eQ1c9.JiraLogo)
    },
    footerProducts: 'Jira, Confluence, Trello'
};
var $c55a698514af0f5a$export$2e2bcd8739ae039 = $c55a698514af0f5a$var$JiraCobranding;

});
parcelRegister("8wVNq", function(module, exports) {

$parcel$export(module.exports, "JiraBackground", function () { return $635e2507ffeb1ffa$export$2ccb200c5de09b24; });

var $91i6m = parcelRequire("91i6m");

var $4sggA = parcelRequire("4sggA");

var $azsMU = parcelRequire("azsMU");

var $7Xtk3 = parcelRequire("7Xtk3");

var $f1J6u = parcelRequire("f1J6u");
var $635e2507ffeb1ffa$export$2ccb200c5de09b24 = function JiraBackground(_ref) {
    var children = _ref.children;
    var isDarkMode = (0, $4sggA.default)().colorMode === 'dark';
    var Background = isDarkMode ? (0, $azsMU.JiraDarkTheme) : (0, $7Xtk3.JiraLightTheme);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $f1J6u.DesktopOnlyBackground), {
        background: Background
    }, children);
};

});
parcelRegister("azsMU", function(module, exports) {

$parcel$export(module.exports, "JiraDarkTheme", function () { return $7b2380eea1c2b0e2$export$24eb0206407d5744; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $91i6m = parcelRequire("91i6m");

var $dwV3h = parcelRequire("dwV3h");
var $hPyLR = parcelRequire("hPyLR");

var $eILiL = parcelRequire("eILiL");

var $fHcf2 = parcelRequire("fHcf2");

var $aq3px = parcelRequire("aq3px");

var $1mHPt = parcelRequire("1mHPt");

var $48p54 = parcelRequire("48p54");

var $cFS5l = parcelRequire("cFS5l");

var $dyVrS = parcelRequire("dyVrS");

var $deK8N = parcelRequire("deK8N");
var $7b2380eea1c2b0e2$var$styles = {
    actions: "_ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q",
    content: "_19bvxy5q"
};
var $7b2380eea1c2b0e2$export$24eb0206407d5744 = function JiraDarkTheme() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $fHcf2.Background), {
        testId: "testId-jira-wireframe"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $aq3px.TopNav), {
        product: (0, $eILiL.Products).JIRA
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $dwV3h.default), {
        alignBlock: "stretch",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $deK8N.SideNav), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $hPyLR.default), {
        grow: "fill",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $dwV3h.default), {
        xcss: $7b2380eea1c2b0e2$var$styles.actions,
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $48p54.Breadcrumbs), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1mHPt.Actions), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $dwV3h.default), {
        xcss: $7b2380eea1c2b0e2$var$styles.content,
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $cFS5l.Content), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $dyVrS.DetailsPanel), null)))));
};

});
parcelRegister("1mHPt", function(module, exports) {

$parcel$export(module.exports, "Actions", function () { return $0fe9d819e159ec20$export$b52183d5cfb26dc9; });

var $91i6m = parcelRequire("91i6m");

var $MmFYJ = parcelRequire("MmFYJ");

var $bCtIw = parcelRequire("bCtIw");

var $4Et6N = parcelRequire("4Et6N");

var $6qkCE = parcelRequire("6qkCE");

var $1Ql4S = parcelRequire("1Ql4S");

var $dwV3h = parcelRequire("dwV3h");
var $0fe9d819e159ec20$export$b52183d5cfb26dc9 = function Actions() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $dwV3h.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bCtIw))), {
        label: "Lock Unlocked",
        color: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($MmFYJ))), {
        label: "Eye Open",
        color: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Ql4S))), {
        label: "Thumbs Up",
        color: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4Et6N))), {
        label: "Share",
        color: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6qkCE))), {
        label: "Show More Horizontal",
        color: "var(--ds-icon-subtle, #626F86)"
    }));
};

});
parcelRegister("MmFYJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7d4381d46d56f0396feef6421a091c8f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $091612ce285c3c86$var$_react = $091612ce285c3c86$var$_interopRequireDefault((parcelRequire("91i6m")));

var $091612ce285c3c86$var$_baseNew = $091612ce285c3c86$var$_interopRequireDefault((parcelRequire("dj2x1")));
function $091612ce285c3c86$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $091612ce285c3c86$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $091612ce285c3c86$var$_react.default.createElement($091612ce285c3c86$var$_baseNew.default, Object.assign({
        name: "EyeOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3.5c-2.943 0-5.49 1.845-6.424 4.396a.3.3 0 0 0 0 .208C2.509 10.655 5.057 12.5 8 12.5s5.49-1.845 6.424-4.396a.3.3 0 0 0 0-.208C13.491 5.345 10.943 3.5 8 3.5M.167 7.38C1.32 4.232 4.433 2 8 2c3.566 0 6.681 2.232 7.833 5.38.146.4.146.84 0 1.24C14.68 11.768 11.566 14 8 14 4.433 14 1.319 11.768.167 8.62a1.8 1.8 0 0 1 0-1.24M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$091612ce285c3c86$var$EyeOpenIcon.displayName = 'EyeOpenIcon';
var $091612ce285c3c86$var$_default = module.exports.default = $091612ce285c3c86$var$EyeOpenIcon;

});

parcelRegister("bCtIw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5c5d989acf678b87189f6f5a97917ee9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $875a4b7ecb22c035$var$_react = $875a4b7ecb22c035$var$_interopRequireDefault((parcelRequire("91i6m")));

var $875a4b7ecb22c035$var$_baseNew = $875a4b7ecb22c035$var$_interopRequireDefault((parcelRequire("dj2x1")));
function $875a4b7ecb22c035$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockUnlocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: unlocked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $875a4b7ecb22c035$var$LockUnlockedIcon = (props)=>/*#__PURE__*/ $875a4b7ecb22c035$var$_react.default.createElement($875a4b7ecb22c035$var$_baseNew.default, Object.assign({
        name: "LockUnlockedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3H12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2V4a4 4 0 1 1 8 0h-1.5A2.5 2.5 0 0 0 8 1.5m-4 7a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$875a4b7ecb22c035$var$LockUnlockedIcon.displayName = 'LockUnlockedIcon';
var $875a4b7ecb22c035$var$_default = module.exports.default = $875a4b7ecb22c035$var$LockUnlockedIcon;

});

parcelRegister("4Et6N", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed0eee459540e5ec28215a3b80df0172>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36317a3dbd822cb6$var$_react = $36317a3dbd822cb6$var$_interopRequireDefault((parcelRequire("91i6m")));

var $36317a3dbd822cb6$var$_baseNew = $36317a3dbd822cb6$var$_interopRequireDefault((parcelRequire("dj2x1")));
function $36317a3dbd822cb6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $36317a3dbd822cb6$var$ShareIcon = (props)=>/*#__PURE__*/ $36317a3dbd822cb6$var$_react.default.createElement($36317a3dbd822cb6$var$_baseNew.default, Object.assign({
        name: "ShareIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2.5 1a2.5 2.5 0 1 1 .73 1.765L6.212 7.567a2.5 2.5 0 0 1 0 .866l4.016 2.302a2.5 2.5 0 1 1-.692 1.332L5.521 9.766a2.5 2.5 0 1 1 0-3.53l4.016-2.302A2.5 2.5 0 0 1 9.5 3.5M3.75 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M12 11.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$36317a3dbd822cb6$var$ShareIcon.displayName = 'ShareIcon';
var $36317a3dbd822cb6$var$_default = module.exports.default = $36317a3dbd822cb6$var$ShareIcon;

});

parcelRegister("6qkCE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2a789640350a4d3b29556a43626f35de>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4ad52afd99f127fa$var$_react = $4ad52afd99f127fa$var$_interopRequireDefault((parcelRequire("91i6m")));

var $4ad52afd99f127fa$var$_baseNew = $4ad52afd99f127fa$var$_interopRequireDefault((parcelRequire("dj2x1")));
function $4ad52afd99f127fa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4ad52afd99f127fa$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $4ad52afd99f127fa$var$_react.default.createElement($4ad52afd99f127fa$var$_baseNew.default, Object.assign({
        name: "ShowMoreHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M13 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$4ad52afd99f127fa$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
var $4ad52afd99f127fa$var$_default = module.exports.default = $4ad52afd99f127fa$var$ShowMoreHorizontalIcon;

});

parcelRegister("1Ql4S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0bf82c15bca1a56d27012abd5cecbc7a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $157aff5dfcdacd11$var$_react = $157aff5dfcdacd11$var$_interopRequireDefault((parcelRequire("91i6m")));

var $157aff5dfcdacd11$var$_baseNew = $157aff5dfcdacd11$var$_interopRequireDefault((parcelRequire("dj2x1")));
function $157aff5dfcdacd11$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ThumbsUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: voting options in Jira, like.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $157aff5dfcdacd11$var$ThumbsUpIcon = (props)=>/*#__PURE__*/ $157aff5dfcdacd11$var$_react.default.createElement($157aff5dfcdacd11$var$_baseNew.default, Object.assign({
        name: "ThumbsUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.708 2.594a.5.5 0 0 0-.77.15L5.5 7.433V13.5h6.371c.493 0 .928-.32 1.074-.79l1.328-4.25A1.125 1.125 0 0 0 13.2 7H9.75A.75.75 0 0 1 9 6.25V3.075a.5.5 0 0 0-.175-.38zM4 13.5V8H2a.5.5 0 0 0-.5.5V13a.5.5 0 0 0 .5.5zm.295-7 2.313-4.45a2 2 0 0 1 3.076-.596l.118.101a2 2 0 0 1 .698 1.519V5.5h2.7a2.625 2.625 0 0 1 2.505 3.408l-1.328 4.25A2.625 2.625 0 0 1 11.871 15H2a2 2 0 0 1-2-2V8.5a2 2 0 0 1 2-2z" clip-rule="evenodd"/>`
    }, props));
$157aff5dfcdacd11$var$ThumbsUpIcon.displayName = 'ThumbsUpIcon';
var $157aff5dfcdacd11$var$_default = module.exports.default = $157aff5dfcdacd11$var$ThumbsUpIcon;

});


parcelRegister("48p54", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", function () { return $302b5d4f8ff9ca5d$export$2dc68d50d56fbbd; });

var $91i6m = parcelRequire("91i6m");

var $aDWwl = parcelRequire("aDWwl");
var $302b5d4f8ff9ca5d$export$2dc68d50d56fbbd = function Breadcrumbs() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $aDWwl.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($302b5d4f8ff9ca5d$var$Image, null));
};
var $302b5d4f8ff9ca5d$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 167,
        height: 20,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 100,
        height: 6,
        y: 7,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 54,
        height: 6,
        x: 113,
        y: 7,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#738496",
        d: "m108.701 4.664-3.014 12.81h-1.395l3.015-12.81h1.394Z"
    }));
};

});

parcelRegister("cFS5l", function(module, exports) {

$parcel$export(module.exports, "Content", function () { return $93a3449429f1fb9f$export$7c6e2c02157bb7d2; });

var $91i6m = parcelRequire("91i6m");

var $aDWwl = parcelRequire("aDWwl");
var $93a3449429f1fb9f$export$7c6e2c02157bb7d2 = function Content() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $aDWwl.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($93a3449429f1fb9f$var$Image, null));
};
var $93a3449429f1fb9f$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("svg", {
        width: 640,
        height: 427,
        viewBox: "0 0 640 427",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 640,
        height: 20,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        y: 40,
        width: 60,
        height: 32,
        rx: 3,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 8,
        y: 53,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 68,
        y: 40,
        width: 99,
        height: 32,
        rx: 3,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 76,
        y: 53,
        width: 59,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(138 44)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M146.292 54.2929C146.105 54.4818 146 54.7368 146 55.0024C146 55.2681 146.105 55.523 146.292 55.7119L149.231 58.6769C149.449 58.8919 149.731 58.9989 150.01 58.9989C150.289 58.9989 150.566 58.8919 150.779 58.6769L153.709 55.7219C153.895 55.5329 154 55.278 154 55.0124C154 54.7469 153.895 54.492 153.709 54.3029C153.617 54.2098 153.507 54.1358 153.387 54.0853C153.266 54.0347 153.136 54.0087 153.006 54.0087C152.875 54.0087 152.745 54.0347 152.625 54.0853C152.504 54.1358 152.394 54.2098 152.303 54.3029L150.005 56.6199L147.698 54.2929C147.606 54.2001 147.496 54.1264 147.375 54.0762C147.255 54.0259 147.125 54 146.995 54C146.864 54 146.734 54.0259 146.614 54.0762C146.493 54.1264 146.384 54.2001 146.292 54.2929Z",
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        y: 92,
        width: 640,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        y: 120,
        width: 640,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        y: 148,
        width: 640,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        y: 200,
        width: 180,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        y: 232,
        width: 52,
        height: 20,
        rx: 3,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 4,
        y: 239,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#091E42",
        fillOpacity: 0.13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 60,
        y: 232,
        width: 85,
        height: 20,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 64,
        y: 239,
        width: 77,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 153,
        y: 232,
        width: 52,
        height: 20,
        rx: 3,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 157,
        y: 239,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#091E42",
        fillOpacity: 0.13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 213,
        y: 232,
        width: 52,
        height: 20,
        rx: 3,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 217,
        y: 239,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#091E42",
        fillOpacity: 0.13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 14,
        y: 282,
        width: 26,
        height: 26,
        rx: 13,
        stroke: "#282E33",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("circle", {
        cx: 27,
        cy: 295,
        r: 12,
        fill: "url(#pattern0_233_7702)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 46,
        y: 279,
        width: 591,
        height: 40,
        rx: 3,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 54,
        y: 295,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 44.2764,
        y: 385,
        width: 425.66,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 44.2764,
        y: 403,
        width: 267.673,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 44.2764,
        y: 421,
        width: 267.673,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 44,
        y: 356,
        width: 119,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 10,
        y: 346,
        width: 26,
        height: 26,
        rx: 13,
        stroke: "#282E33",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("circle", {
        cx: 23,
        cy: 359,
        r: 12,
        fill: "url(#pattern1_233_7702)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("pattern", {
        id: "pattern0_233_7702",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("use", {
        xlinkHref: "#image0_233_7702",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("pattern", {
        id: "pattern1_233_7702",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("use", {
        xlinkHref: "#image1_233_7702",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("image", {
        id: "image0_233_7702",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAgMBAQEAAAAAAAAAAAAAAwYCBAUACAf/xAAuEAACAQMCBAQGAgMAAAAAAAABAgMABAUGERITITEHQVFhFCJCcYGRMuFiobH/xAAXAQEBAQEAAAAAAAAAAAAAAAAGBwUE/8QAKREAAQMDAgQGAwAAAAAAAAAAAgEDEQAEEgVBBiExURMUInGB8JGx0f/aAAwDAQACEQMRAD8ASqjI6xozuwVFG5J7AVKlzWN0UghtkO3MPE32HYfv/lWK9uUtWCeXb91PrZlX3EbTeoXmqArlbOEMo+uQ7b/ioW2qX4wLq3Xg9Yz1H4NYWNsbrJ5C3sbCB57u4cRxRIN2ZjVrUuEvdOZy7xOUi5d3bPwsPJh5Mp81I6g0IXW7xTnP4hIpMmmW+EY/NO9tcRXUCywOHjbsRRaT9IXTR3z2xPySqSB/kP6pwplp155xhHYhei+9HLy38u6obbV1A0Tp4as8UbS0vbZp8VDKi3Q3IUJwkhSR1HEw26Uesu3z2R0dqqHK4925EskUk0X0y8tgeE/72+5rN4lBwrP0bL/a7NFIBufX2r1tpvR2ndNMz4LD2dlKw2aSNN3I9OI7nb80bUGl8HqJUGcxNnfFBsjTRAso9A3cfurGn8zY6gw1rlMVMJrO5QOjDuPVT6EHoR6irl1cQ2ltLcXUqQwRKXkkc7Kigbkk+QqVqpZSvWqCgjjy6V5R8btI22kddY+4wdktriZ0iAWMnhWXdgy9Tv1A3/dUfOh651bca913PNA8gwlvMHt4yNhwoOEOfdup28t6JVN4VbcG2JT3WgmvGBPogdq6g3VrFewmCZONW8vPf296MASQB1Jp1xOKhso1dlDXBHVj9J9BW/cuAAQaTO1ZDQkpSKxFNfgBgMlp7Tt/zpX+FurkSwROOoAXZiR7nb9VreNmFympdES2ljMUCTJNNGvTmRrvuO/XqQdj6VgYrMX2LLfBTlFbqyEBlP4NFyueyOUj5d3PvF35aKFU/fbvU+c0NwrzxhjCZjn07fVpeGsNpa+EqLlETy/P1K+N2eOjxkZt442Rgfn4v5E+9WKe8jjoL+MiRQJNvlcdx/VIsiFHZG6MpIP3p/aOAQYAkRtRF4SyyJZmv//Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("image", {
        id: "image1_233_7702",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAQUBAQAAAAAAAAAAAAAABAADBQYHAQL/xAApEAABAwMDAwQCAwAAAAAAAAABAgMEAAUREiFBBlFxBzFCYROBkdHh/8QAFwEBAQEBAAAAAAAAAAAAAAAABgcEBf/EACkRAAEDAwIFAwUAAAAAAAAAAAECAxEABCEFEgYxUXGRIjLRQaHB4fD/2gAMAwEAAhEDEQA/AH6VKirXCXcJzUds4KjursOTTRa0tpK1GAKizTS3lpbbEqJgdzQoBJwASfquqSUnCgQfsVp9ut0a3tBEZoA8rIypXk07LiMTGi3JaS4k9xuPB4o2eJUb4DZ29Zz4/dO08BulqVPAL6RjzP4rKqVSV/thtc4tglTSxqbUe3Y/YqNpGy6l5AcQZBoPc2zlq6pl0QpJg0qs3QjeZ8hzAwlvT/J/yqzRMCfJt7inIa0pWRjChkHyKz6gwt+3W03zNbdFumrO+bfe9qT9O3zWp0qpULrV+54j2qzuv3FIy60t1KUIA98H3O/1XuR1m9anvxdQ2h6GtadTQacS7qHY+2Kn5tHQdsZ6SJ8VbhdNEbgcdcx5ojr1GY8RzHspSc+QP6qm0dc7vKuykrkANoGShofAHgnk/dA070q3Xb2qW3OfzmozxFeNXuoOPM8sDvAie2KVMyX0x2itW/AA5p6oqfAdWsuNrLmfio7jxW9ZIGK47SUqV6jFWprpJi8QIlwizFRZimxqWydSc/ogg42O9e4/RsS3OG4Xq5KfLe4U5skHjJJJOO1A+mocavT6XVuNthknQThKjkDcc131LbccvEb8LjjqFM50A5SggkbDjNFF2dyq5LZUdpzMfaqa1rVo3p6XEoG9MJiegif7zUew8h9GtB2zinaioEB1Cw44st4+KTufNStK0EkZqZupSFek1//Z"
    })));
};

});

parcelRegister("dyVrS", function(module, exports) {

$parcel$export(module.exports, "DetailsPanel", function () { return $9dfb036b8e67872e$export$e54a7f2505304e20; });
/* details-panel.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $91i6m = parcelRequire("91i6m");

var $aDWwl = parcelRequire("aDWwl");
var $9dfb036b8e67872e$var$styles = {
    wrapper: "_kqsw1n9t _1xi2ze3t _19bvutpp _u5f3xy5q"
};
var $9dfb036b8e67872e$export$e54a7f2505304e20 = function DetailsPanel() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $aDWwl.default), {
        xcss: $9dfb036b8e67872e$var$styles.wrapper,
        backgroundColor: "elevation.surface"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($9dfb036b8e67872e$var$Image, null));
};
var $9dfb036b8e67872e$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("svg", {
        width: 328,
        height: 597,
        viewBox: "0 0 328 597",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 80,
        height: 32,
        rx: 3,
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 17,
        y: 13,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#0055CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M0 52C0 47.5817 3.58172 44 8 44H320C324.418 44 328 47.5817 328 52V597H0V52Z",
        fill: "#1D2125"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M0.5 52C0.5 47.8579 3.85786 44.5 8 44.5H320C324.142 44.5 327.5 47.8579 327.5 52V596.5H0.5V52Z",
        stroke: "#A1BDD9",
        strokeOpacity: 0.08
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 24,
        y: 77,
        width: 253,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(280 68)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M288.292 78.2929C288.105 78.4818 288 78.7368 288 79.0024C288 79.2681 288.105 79.523 288.292 79.7119L291.231 82.6769C291.449 82.8919 291.731 82.9989 292.01 82.9989C292.289 82.9989 292.566 82.8919 292.779 82.6769L295.709 79.7219C295.895 79.5329 296 79.278 296 79.0124C296 78.7469 295.895 78.492 295.709 78.3029C295.617 78.2098 295.507 78.1358 295.387 78.0853C295.266 78.0347 295.136 78.0087 295.006 78.0087C294.875 78.0087 294.745 78.0347 294.625 78.0853C294.504 78.1358 294.394 78.2098 294.303 78.3029L292.005 80.6199L289.698 78.2929C289.606 78.2001 289.496 78.1264 289.375 78.0762C289.255 78.0259 289.125 78 288.995 78C288.864 78 288.734 78.0259 288.614 78.0762C288.493 78.1264 288.384 78.2001 288.292 78.2929Z",
        fill: "#BFDBF8",
        fillOpacity: 0.28
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 24,
        y: 121,
        width: 79,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 24,
        y: 159,
        width: 114,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 24,
        y: 197,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 24,
        y: 235,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 24,
        y: 273,
        width: 114,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 24,
        y: 311,
        width: 110,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 24,
        y: 349,
        width: 100,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 24,
        y: 387,
        width: 114,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 24,
        y: 425,
        width: 114,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 24,
        y: 463,
        width: 95,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(178 112)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M190.522 131.853L190.625 131.781L195.625 127.781C196.056 127.436 196.126 126.807 195.781 126.375C195.462 125.977 194.902 125.887 194.478 126.147L194.375 126.219L190 129.72L185.625 126.219C185.227 125.901 184.66 125.936 184.304 126.282L184.219 126.375C183.901 126.773 183.936 127.34 184.282 127.696L184.375 127.781L189.375 131.781C189.707 132.046 190.166 132.071 190.522 131.853Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M190.522 126.853L190.625 126.781L195.625 122.781C196.056 122.436 196.126 121.807 195.781 121.375C195.462 120.977 194.902 120.887 194.478 121.147L194.375 121.219L190 124.72L185.625 121.219C185.227 120.901 184.66 120.936 184.304 121.282L184.219 121.375C183.901 121.773 183.936 122.34 184.282 122.696L184.375 122.781L189.375 126.781C189.707 127.046 190.166 127.071 190.522 126.853Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M190.522 121.853L190.625 121.781L195.625 117.781C196.056 117.436 196.126 116.807 195.781 116.375C195.462 115.977 194.902 115.887 194.478 116.147L194.375 116.219L190 119.72L185.625 116.219C185.227 115.901 184.66 115.936 184.304 116.282L184.219 116.375C183.901 116.773 183.936 117.34 184.282 117.696L184.375 117.781L189.375 121.781C189.707 122.046 190.166 122.071 190.522 121.853Z",
        fill: "#4C9AFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 210,
        y: 121,
        width: 66,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 178,
        y: 159,
        width: 98,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 178,
        y: 188,
        width: 52,
        height: 20,
        rx: 3,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 182,
        y: 195,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        opacity: 0.8
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 177,
        y: 230,
        width: 18,
        height: 18,
        rx: 9,
        stroke: "#282E33",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("circle", {
        cx: 186,
        cy: 239,
        r: 8,
        fill: "url(#pattern0_233_7667)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 202,
        y: 236,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#454F59"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 178,
        y: 273,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 178,
        y: 311,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 178,
        y: 349,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 178,
        y: 387,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 178,
        y: 425,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 178,
        y: 463,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("pattern", {
        id: "pattern0_233_7667",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("use", {
        xlinkHref: "#image0_233_7667",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("image", {
        id: "image0_233_7667",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAgIDAQAAAAAAAAAAAAAAAAcDBgQFCAH/xAAsEAABAwMCBQMDBQAAAAAAAAABAgMEAAURBiESEzFBUQeBkSJhcRQVMjOh/8QAFwEBAQEBAAAAAAAAAAAAAAAABwYEBf/EACkRAAEEAQIFBAIDAAAAAAAAAAECAwQRAAVREyExYYEGEnGhB0GisfD/2gAMAwEAAhEDEQA/AKVRRWXa4S7hObjt7FR3PgdzTLIkNxmlPvGkpBJOwHXDtllb7iWmxalGgO5zFSCo4SCT4FCkKQcKSUn7jFOpnRMqzx0CLDS4CASto8Sj+e9TtaQm3VBblREIaPeQMfA60YufktYlcJuEoo3ujW9VX8vOXSPRCSxxFyUhW1cvi7v68YjaK3GqLOqz3JbIyWiTw57YOCPatPSTAnM6hHRKjm0KFj/bg8j3yJlxXIbymHhSk9cKYXo9ZjOvBlvI4oqFBk468WOLf7fT/tL2rHorVc3S9wDkdQVFcUnntKGeJIO+PBxnesevQXJ8ByM11VXX9gEEjyBWatIlIiS0POdBf9EA+M6foqKLIalRmpEdYcZdQFoUOikkZBqU0QkEGjiMCCLGJj1ss/JImR0HlBaVOE9ApeRt7ppSVd/U3WMjUF1fhsOj9qju4aSkf2EbcZPffOPtVIpV9M6e5p0BLLnKyVVt7jdfeH+uzETJZcRsBe9csK9QlS1hKElSj0AGSakiR1ypTTDQytxQSKY9stsa3NBMdAC8fU4f5K9660mUlgVVk5zmWC78YxPTX9XC0Xa2ZjauMIKglWykpKiQPgitzfHJEu0TY8RPA86wtCFZ34ikgVW7Xq3ltJbuDKnCnbmN4yfyKnnawZ5ZEGMsuHop3AA9h1otf0+Y5KU57OZUT25m8v2Z0REcI93QV36VnO8iO9GcLchpbTg2KVpII+ajpqXdhF35huA5q1nJX3B8jxSzuEVUKa9HXuW1Yz5HY/FKESXxxShSsgZDHCNg2M//2Q=="
    })));
};

});

parcelRegister("deK8N", function(module, exports) {

$parcel$export(module.exports, "SideNav", function () { return $9a305fcde1ca238b$export$1a35787d6353cf6a; });
/* side-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $91i6m = parcelRequire("91i6m");

var $aDWwl = parcelRequire("aDWwl");
var $9wl70 = parcelRequire("9wl70");

var $f1J6u = parcelRequire("f1J6u");
var $9a305fcde1ca238b$var$styles = {
    background: "_1s7z7r9e _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
var $9a305fcde1ca238b$export$1a35787d6353cf6a = function SideNav() {
    var isAboveMediumScreen = (0, $f1J6u.useMatchMedia)((0, $9wl70.media).above.md);
    return isAboveMediumScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $aDWwl.default), {
        xcss: $9a305fcde1ca238b$var$styles.background
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($9a305fcde1ca238b$var$Image, null)) : null;
};
var $9a305fcde1ca238b$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 296,
        height: 473,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        clipPath: "url(#a)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 5.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 9,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 17.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 48.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 52.96,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 60.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "m283.939 64.5-3.969-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 91.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 95.96,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 103.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "m283.939 107.5-3.969-3.97 1.06-1.06 4.5 4.5a.749.749 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 134.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 138.96,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 146.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "M265.25 151.25v4.25h1.5v-4.25H271v-1.5h-4.25v-4.25h-1.5v4.25H261v1.5h4.25ZM285.25 150.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        d: "M285.5 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM290.25 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM295 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 72,
        height: 9,
        x: 20,
        y: 189,
        fill: "#596773",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 278,
        height: 43,
        x: 18,
        y: 215,
        fill: "#1C2B41",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 220.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 224,
        fill: "#05C",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#1868DB",
        d: "M18 229h2.66v15.96H18z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 232.5,
        fill: "#05C",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "M259.25 237.25v4.25h1.5v-4.25H265v-1.5h-4.25v-4.25h-1.5v4.25H255v1.5h4.25ZM279.25 236.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        d: "M279.5 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM284.25 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM289 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 263.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 267,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 275.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 306.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 310,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 318.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M20 349.5h32v32H20z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "M39 360.5H25V359h14v1.5Zm0 5.25H25v-1.5h14v1.5ZM32 371h-7v-1.5h7v1.5Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 64,
        y: 361.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 392.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 396.96,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 404.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "m283.939 408.5-3.969-3.97 1.06-1.06 4.5 4.5a.749.749 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 435.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "M9.667 451.333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM8 451a1.667 1.667 0 1 1 3.333 0A1.667 1.667 0 0 1 8 451Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM14.333 451a1.667 1.667 0 1 1 3.334 0 1.667 1.667 0 0 1-3.334 0Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM20.667 451A1.667 1.667 0 1 1 24 451a1.667 1.667 0 0 1-3.333 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        d: "M10 451a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM16.333 451a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM22.667 451a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 60,
        height: 8,
        x: 44,
        y: 447.5,
        fill: "#454F59",
        rx: 3.99
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        d: "M0 0h296v473H0z"
    }))));
};

});


parcelRegister("7Xtk3", function(module, exports) {

$parcel$export(module.exports, "JiraLightTheme", function () { return $5cb4c9e910db6816$export$8e2414c6a082747f; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $91i6m = parcelRequire("91i6m");

var $dwV3h = parcelRequire("dwV3h");
var $hPyLR = parcelRequire("hPyLR");

var $eILiL = parcelRequire("eILiL");

var $fHcf2 = parcelRequire("fHcf2");

var $aq3px = parcelRequire("aq3px");

var $1mHPt = parcelRequire("1mHPt");

var $5Qeo2 = parcelRequire("5Qeo2");

var $kzgfK = parcelRequire("kzgfK");

var $76TkT = parcelRequire("76TkT");

var $ibiDm = parcelRequire("ibiDm");
var $5cb4c9e910db6816$var$styles = {
    actions: "_ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q",
    content: "_19bvxy5q"
};
var $5cb4c9e910db6816$export$8e2414c6a082747f = function JiraLightTheme() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $fHcf2.Background), {
        testId: "testId-jira-wireframe"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $aq3px.TopNav), {
        product: (0, $eILiL.Products).JIRA
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $dwV3h.default), {
        alignBlock: "stretch",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $ibiDm.SideNav), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $hPyLR.default), {
        grow: "fill",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $dwV3h.default), {
        xcss: $5cb4c9e910db6816$var$styles.actions,
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $5Qeo2.Breadcrumbs), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1mHPt.Actions), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $dwV3h.default), {
        xcss: $5cb4c9e910db6816$var$styles.content,
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $kzgfK.Content), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $76TkT.DetailsPanel), null)))));
};

});
parcelRegister("5Qeo2", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", function () { return $440cf7fa3711aedd$export$2dc68d50d56fbbd; });

var $91i6m = parcelRequire("91i6m");

var $aDWwl = parcelRequire("aDWwl");
var $440cf7fa3711aedd$export$2dc68d50d56fbbd = function Breadcrumbs() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $aDWwl.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($440cf7fa3711aedd$var$Image, null));
};
var $440cf7fa3711aedd$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 167,
        height: 20,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 100,
        height: 6,
        y: 7,
        fill: "#DCDFE4",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 54,
        height: 6,
        x: 113,
        y: 7,
        fill: "#DCDFE4",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#8590A2",
        d: "m108.701 4.664-3.014 12.81h-1.395l3.015-12.81h1.394Z"
    }));
};

});

parcelRegister("kzgfK", function(module, exports) {

$parcel$export(module.exports, "Content", function () { return $ef93af0960fe7a04$export$7c6e2c02157bb7d2; });

var $91i6m = parcelRequire("91i6m");

var $aDWwl = parcelRequire("aDWwl");
var $ef93af0960fe7a04$export$7c6e2c02157bb7d2 = function Content() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $aDWwl.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($ef93af0960fe7a04$var$Image, null));
};
var $ef93af0960fe7a04$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("svg", {
        width: 640,
        height: 427,
        viewBox: "0 0 640 427",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 640,
        height: 20,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        y: 40,
        width: 60,
        height: 32,
        rx: 3,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 8,
        y: 53,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 68,
        y: 40,
        width: 99,
        height: 32,
        rx: 3,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 76,
        y: 53,
        width: 59,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(138 44)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M146.292 54.2929C146.105 54.4818 146 54.7368 146 55.0024C146 55.2681 146.105 55.523 146.292 55.7119L149.231 58.6769C149.449 58.8919 149.731 58.9989 150.01 58.9989C150.289 58.9989 150.566 58.8919 150.779 58.6769L153.709 55.7219C153.895 55.5329 154 55.278 154 55.0124C154 54.7469 153.895 54.492 153.709 54.3029C153.617 54.2098 153.507 54.1358 153.387 54.0853C153.266 54.0347 153.136 54.0087 153.006 54.0087C152.875 54.0087 152.745 54.0347 152.625 54.0853C152.504 54.1358 152.394 54.2098 152.303 54.3029L150.005 56.6199L147.698 54.2929C147.606 54.2001 147.496 54.1264 147.375 54.0762C147.255 54.0259 147.125 54 146.995 54C146.864 54 146.734 54.0259 146.614 54.0762C146.493 54.1264 146.384 54.2001 146.292 54.2929Z",
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        y: 92,
        width: 640,
        height: 12,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        y: 120,
        width: 640,
        height: 12,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        y: 148,
        width: 640,
        height: 12,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        y: 200,
        width: 180,
        height: 12,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        y: 232,
        width: 52,
        height: 20,
        rx: 3,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 4,
        y: 239,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#091E42",
        fillOpacity: 0.13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 60,
        y: 232,
        width: 85,
        height: 20,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 64,
        y: 239,
        width: 77,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 153,
        y: 232,
        width: 52,
        height: 20,
        rx: 3,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 157,
        y: 239,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#091E42",
        fillOpacity: 0.13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 213,
        y: 232,
        width: 52,
        height: 20,
        rx: 3,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 217,
        y: 239,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#091E42",
        fillOpacity: 0.13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 14,
        y: 282,
        width: 26,
        height: 26,
        rx: 13,
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("circle", {
        cx: 27,
        cy: 295,
        r: 12,
        fill: "url(#pattern0_233_6340)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 46,
        y: 279,
        width: 591,
        height: 40,
        rx: 3,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 54,
        y: 295,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 44.2764,
        y: 385,
        width: 425.66,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 44.2764,
        y: 403,
        width: 267.673,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 44.2764,
        y: 421,
        width: 267.673,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 44,
        y: 356,
        width: 119,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 10,
        y: 346,
        width: 26,
        height: 26,
        rx: 13,
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("circle", {
        cx: 23,
        cy: 359,
        r: 12,
        fill: "url(#pattern1_233_6340)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("pattern", {
        id: "pattern0_233_6340",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("use", {
        xlinkHref: "#image0_233_6340",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("pattern", {
        id: "pattern1_233_6340",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("use", {
        xlinkHref: "#image1_233_6340",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("image", {
        id: "image0_233_6340",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAgMBAQEAAAAAAAAAAAAAAwYCBAUACAf/xAAuEAACAQMCBAQGAgMAAAAAAAABAgMABAUGERITITEHQVFhFCJCcYGRMuFiobH/xAAXAQEBAQEAAAAAAAAAAAAAAAAGBwUE/8QAKREAAQMDAgQGAwAAAAAAAAAAAgEDEQAEEgVBBiExURMUInGB8JGx0f/aAAwDAQACEQMRAD8ASqjI6xozuwVFG5J7AVKlzWN0UghtkO3MPE32HYfv/lWK9uUtWCeXb91PrZlX3EbTeoXmqArlbOEMo+uQ7b/ioW2qX4wLq3Xg9Yz1H4NYWNsbrJ5C3sbCB57u4cRxRIN2ZjVrUuEvdOZy7xOUi5d3bPwsPJh5Mp81I6g0IXW7xTnP4hIpMmmW+EY/NO9tcRXUCywOHjbsRRaT9IXTR3z2xPySqSB/kP6pwplp155xhHYhei+9HLy38u6obbV1A0Tp4as8UbS0vbZp8VDKi3Q3IUJwkhSR1HEw26Uesu3z2R0dqqHK4925EskUk0X0y8tgeE/72+5rN4lBwrP0bL/a7NFIBufX2r1tpvR2ndNMz4LD2dlKw2aSNN3I9OI7nb80bUGl8HqJUGcxNnfFBsjTRAso9A3cfurGn8zY6gw1rlMVMJrO5QOjDuPVT6EHoR6irl1cQ2ltLcXUqQwRKXkkc7Kigbkk+QqVqpZSvWqCgjjy6V5R8btI22kddY+4wdktriZ0iAWMnhWXdgy9Tv1A3/dUfOh651bca913PNA8gwlvMHt4yNhwoOEOfdup28t6JVN4VbcG2JT3WgmvGBPogdq6g3VrFewmCZONW8vPf296MASQB1Jp1xOKhso1dlDXBHVj9J9BW/cuAAQaTO1ZDQkpSKxFNfgBgMlp7Tt/zpX+FurkSwROOoAXZiR7nb9VreNmFympdES2ljMUCTJNNGvTmRrvuO/XqQdj6VgYrMX2LLfBTlFbqyEBlP4NFyueyOUj5d3PvF35aKFU/fbvU+c0NwrzxhjCZjn07fVpeGsNpa+EqLlETy/P1K+N2eOjxkZt442Rgfn4v5E+9WKe8jjoL+MiRQJNvlcdx/VIsiFHZG6MpIP3p/aOAQYAkRtRF4SyyJZmv//Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("image", {
        id: "image1_233_6340",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAQUBAQAAAAAAAAAAAAAABAADBQYHAQL/xAApEAABAwMDAwQCAwAAAAAAAAABAgMEAAUREiFBBlFxBzFCYROBkdHh/8QAFwEBAQEBAAAAAAAAAAAAAAAABgcEBf/EACkRAAEDAwIFAwUAAAAAAAAAAAECAxEABCEFEgYxUXGRIjLRQaHB4fD/2gAMAwEAAhEDEQA/AH6VKirXCXcJzUds4KjursOTTRa0tpK1GAKizTS3lpbbEqJgdzQoBJwASfquqSUnCgQfsVp9ut0a3tBEZoA8rIypXk07LiMTGi3JaS4k9xuPB4o2eJUb4DZ29Zz4/dO08BulqVPAL6RjzP4rKqVSV/thtc4tglTSxqbUe3Y/YqNpGy6l5AcQZBoPc2zlq6pl0QpJg0qs3QjeZ8hzAwlvT/J/yqzRMCfJt7inIa0pWRjChkHyKz6gwt+3W03zNbdFumrO+bfe9qT9O3zWp0qpULrV+54j2qzuv3FIy60t1KUIA98H3O/1XuR1m9anvxdQ2h6GtadTQacS7qHY+2Kn5tHQdsZ6SJ8VbhdNEbgcdcx5ojr1GY8RzHspSc+QP6qm0dc7vKuykrkANoGShofAHgnk/dA070q3Xb2qW3OfzmozxFeNXuoOPM8sDvAie2KVMyX0x2itW/AA5p6oqfAdWsuNrLmfio7jxW9ZIGK47SUqV6jFWprpJi8QIlwizFRZimxqWydSc/ogg42O9e4/RsS3OG4Xq5KfLe4U5skHjJJJOO1A+mocavT6XVuNthknQThKjkDcc131LbccvEb8LjjqFM50A5SggkbDjNFF2dyq5LZUdpzMfaqa1rVo3p6XEoG9MJiegif7zUew8h9GtB2zinaioEB1Cw44st4+KTufNStK0EkZqZupSFek1//Z"
    })));
};

});

parcelRegister("76TkT", function(module, exports) {

$parcel$export(module.exports, "DetailsPanel", function () { return $52d4047dae200d1f$export$e54a7f2505304e20; });
/* details-panel.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $91i6m = parcelRequire("91i6m");

var $aDWwl = parcelRequire("aDWwl");
var $52d4047dae200d1f$var$styles = {
    wrapper: "_kqsw1n9t _1xi2ze3t _19bvutpp _u5f3xy5q"
};
var $52d4047dae200d1f$export$e54a7f2505304e20 = function DetailsPanel() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $aDWwl.default), {
        xcss: $52d4047dae200d1f$var$styles.wrapper,
        backgroundColor: "elevation.surface"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($52d4047dae200d1f$var$Image, null));
};
var $52d4047dae200d1f$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("svg", {
        width: 328,
        height: 597,
        viewBox: "0 0 328 597",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 80,
        height: 32,
        rx: 3,
        fill: "#CCE0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 17,
        y: 13,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#85B8FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M0 52C0 47.5817 3.58172 44 8 44H320C324.418 44 328 47.5817 328 52V597H0V52Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M0.5 52C0.5 47.8579 3.85786 44.5 8 44.5H320C324.142 44.5 327.5 47.8579 327.5 52V596.5H0.5V52Z",
        stroke: "#091E42",
        strokeOpacity: 0.06
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 24,
        y: 77,
        width: 253,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(280 68)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M288.292 78.2929C288.105 78.4818 288 78.7368 288 79.0024C288 79.2681 288.105 79.523 288.292 79.7119L291.231 82.6769C291.449 82.8919 291.731 82.9989 292.01 82.9989C292.289 82.9989 292.566 82.8919 292.779 82.6769L295.709 79.7219C295.895 79.5329 296 79.278 296 79.0124C296 78.7469 295.895 78.492 295.709 78.3029C295.617 78.2098 295.507 78.1358 295.387 78.0853C295.266 78.0347 295.136 78.0087 295.006 78.0087C294.875 78.0087 294.745 78.0347 294.625 78.0853C294.504 78.1358 294.394 78.2098 294.303 78.3029L292.005 80.6199L289.698 78.2929C289.606 78.2001 289.496 78.1264 289.375 78.0762C289.255 78.0259 289.125 78 288.995 78C288.864 78 288.734 78.0259 288.614 78.0762C288.493 78.1264 288.384 78.2001 288.292 78.2929Z",
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 24,
        y: 121,
        width: 79,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 24,
        y: 159,
        width: 114,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 24,
        y: 197,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 24,
        y: 235,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 24,
        y: 273,
        width: 114,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 24,
        y: 311,
        width: 110,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 24,
        y: 349,
        width: 100,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 24,
        y: 387,
        width: 114,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 24,
        y: 425,
        width: 114,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 24,
        y: 463,
        width: 95,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(178 112)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M190.522 131.853L190.625 131.781L195.625 127.781C196.056 127.436 196.126 126.807 195.781 126.375C195.462 125.977 194.902 125.887 194.478 126.147L194.375 126.219L190 129.72L185.625 126.219C185.227 125.901 184.66 125.936 184.304 126.282L184.219 126.375C183.901 126.773 183.936 127.34 184.282 127.696L184.375 127.781L189.375 131.781C189.707 132.046 190.166 132.071 190.522 131.853Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M190.522 126.853L190.625 126.781L195.625 122.781C196.056 122.436 196.126 121.807 195.781 121.375C195.462 120.977 194.902 120.887 194.478 121.147L194.375 121.219L190 124.72L185.625 121.219C185.227 120.901 184.66 120.936 184.304 121.282L184.219 121.375C183.901 121.773 183.936 122.34 184.282 122.696L184.375 122.781L189.375 126.781C189.707 127.046 190.166 127.071 190.522 126.853Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        d: "M190.522 121.853L190.625 121.781L195.625 117.781C196.056 117.436 196.126 116.807 195.781 116.375C195.462 115.977 194.902 115.887 194.478 116.147L194.375 116.219L190 119.72L185.625 116.219C185.227 115.901 184.66 115.936 184.304 116.282L184.219 116.375C183.901 116.773 183.936 117.34 184.282 117.696L184.375 117.781L189.375 121.781C189.707 122.046 190.166 122.071 190.522 121.853Z",
        fill: "#4C9AFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 210,
        y: 121,
        width: 66,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 178,
        y: 159,
        width: 98,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 178,
        y: 188,
        width: 52,
        height: 20,
        rx: 3,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 182,
        y: 195,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        opacity: 0.8
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 177,
        y: 230,
        width: 18,
        height: 18,
        rx: 9,
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("circle", {
        cx: 186,
        cy: 239,
        r: 8,
        fill: "url(#pattern0_233_6342)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 202,
        y: 236,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 178,
        y: 273,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 178,
        y: 311,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 178,
        y: 349,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 178,
        y: 387,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 178,
        y: 425,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        x: 178,
        y: 463,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("pattern", {
        id: "pattern0_233_6342",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("use", {
        xlinkHref: "#image0_233_6342",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("image", {
        id: "image0_233_6342",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAgIDAQAAAAAAAAAAAAAAAAcDBgQFCAH/xAAsEAABAwMCBQMDBQAAAAAAAAABAgMEAAURBiESEzFBUQeBkSJhcRQVMjOh/8QAFwEBAQEBAAAAAAAAAAAAAAAABwYEBf/EACkRAAEEAQIFBAIDAAAAAAAAAAECAwQRAAVREyExYYEGEnGhB0GisfD/2gAMAwEAAhEDEQA/AKVRRWXa4S7hObjt7FR3PgdzTLIkNxmlPvGkpBJOwHXDtllb7iWmxalGgO5zFSCo4SCT4FCkKQcKSUn7jFOpnRMqzx0CLDS4CASto8Sj+e9TtaQm3VBblREIaPeQMfA60YufktYlcJuEoo3ujW9VX8vOXSPRCSxxFyUhW1cvi7v68YjaK3GqLOqz3JbIyWiTw57YOCPatPSTAnM6hHRKjm0KFj/bg8j3yJlxXIbymHhSk9cKYXo9ZjOvBlvI4oqFBk468WOLf7fT/tL2rHorVc3S9wDkdQVFcUnntKGeJIO+PBxnesevQXJ8ByM11VXX9gEEjyBWatIlIiS0POdBf9EA+M6foqKLIalRmpEdYcZdQFoUOikkZBqU0QkEGjiMCCLGJj1ss/JImR0HlBaVOE9ApeRt7ppSVd/U3WMjUF1fhsOj9qju4aSkf2EbcZPffOPtVIpV9M6e5p0BLLnKyVVt7jdfeH+uzETJZcRsBe9csK9QlS1hKElSj0AGSakiR1ypTTDQytxQSKY9stsa3NBMdAC8fU4f5K9660mUlgVVk5zmWC78YxPTX9XC0Xa2ZjauMIKglWykpKiQPgitzfHJEu0TY8RPA86wtCFZ34ikgVW7Xq3ltJbuDKnCnbmN4yfyKnnawZ5ZEGMsuHop3AA9h1otf0+Y5KU57OZUT25m8v2Z0REcI93QV36VnO8iO9GcLchpbTg2KVpII+ajpqXdhF35huA5q1nJX3B8jxSzuEVUKa9HXuW1Yz5HY/FKESXxxShSsgZDHCNg2M//2Q=="
    })));
};

});

parcelRegister("ibiDm", function(module, exports) {

$parcel$export(module.exports, "SideNav", function () { return $d3c7b55f08fe5770$export$1a35787d6353cf6a; });
/* side-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $91i6m = parcelRequire("91i6m");

var $aDWwl = parcelRequire("aDWwl");
var $9wl70 = parcelRequire("9wl70");

var $f1J6u = parcelRequire("f1J6u");
var $d3c7b55f08fe5770$var$styles = {
    background: "_1s7z7r9e _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
var $d3c7b55f08fe5770$export$1a35787d6353cf6a = function SideNav() {
    var isAboveMediumScreen = (0, $f1J6u.useMatchMedia)((0, $9wl70.media).above.md);
    return isAboveMediumScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $aDWwl.default), {
        xcss: $d3c7b55f08fe5770$var$styles.background
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($d3c7b55f08fe5770$var$Image, null)) : null;
};
var $d3c7b55f08fe5770$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 296,
        height: 473,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("g", {
        clipPath: "url(#a)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 5.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 9,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 17.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 48.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 52.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 60.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "m283.939 64.5-3.969-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 91.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 95.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 103.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "m283.939 107.5-3.969-3.97 1.06-1.06 4.5 4.5a.749.749 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 134.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 138.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 146.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M265.25 151.25v4.25h1.5v-4.25H271v-1.5h-4.25v-4.25h-1.5v4.25H261v1.5h4.25ZM285.25 150.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        d: "M285.5 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM290.25 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM295 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 72,
        height: 9,
        x: 20,
        y: 189,
        fill: "#B3B9C4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 278,
        height: 43,
        x: 18,
        y: 215,
        fill: "#E9F2FF",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 220.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 224,
        fill: "#85B8FF",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#1868DB",
        d: "M18 229h2.66v15.96H18z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 232.5,
        fill: "#85B8FF",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M259.25 237.25v4.25h1.5v-4.25H265v-1.5h-4.25v-4.25h-1.5v4.25H255v1.5h4.25ZM279.25 236.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        d: "M279.5 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM284.25 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM289 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 263.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 267,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 275.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 306.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 310,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 318.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M20 349.5h32v32H20z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M39 360.5H25V359h14v1.5Zm0 5.25H25v-1.5h14v1.5ZM32 371h-7v-1.5h7v1.5Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 64,
        y: 361.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 392.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 396.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 404.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "m283.939 408.5-3.969-3.97 1.06-1.06 4.5 4.5a.749.749 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 435.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M9.667 451.333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM8 451a1.667 1.667 0 1 1 3.335 0A1.667 1.667 0 0 1 8 451Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM14.333 451a1.667 1.667 0 1 1 3.335 0 1.667 1.667 0 0 1-3.335 0Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM20.667 451A1.667 1.667 0 1 1 24 451a1.667 1.667 0 0 1-3.334 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        d: "M10 451a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM16.333 451a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM22.667 451a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("rect", {
        width: 60,
        height: 8,
        x: 44,
        y: 447.5,
        fill: "#DCDFE4",
        rx: 3.99
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("path", {
        fill: "#fff",
        d: "M0 0h296v473H0z"
    }))));
};

});




parcelRegister("745Kq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b59ff40a9f03899$export$2e2bcd8739ae039; });

var $bPq5X = parcelRequire("bPq5X");

var $6zNBS = parcelRequire("6zNBS");

var $eQ1c9 = parcelRequire("eQ1c9");

var $4ksd4 = parcelRequire("4ksd4");
const $2b59ff40a9f03899$export$29decb186c8152a6 = (0, $4ksd4.backgroundWithSideImages)((0, (/*@__PURE__*/$parcel$interopDefault($bPq5X))), (0, (/*@__PURE__*/$parcel$interopDefault($6zNBS))));
const $2b59ff40a9f03899$var$OpsgenieCobranding = {
    background: $2b59ff40a9f03899$export$29decb186c8152a6,
    logo: {
        component: (0, $eQ1c9.OpsgenieLogo)
    },
    footerProducts: 'Opsgenie, Jira, Confluence'
};
var $2b59ff40a9f03899$export$2e2bcd8739ae039 = $2b59ff40a9f03899$var$OpsgenieCobranding;

});
parcelRegister("bPq5X", function(module, exports) {

module.exports = (parcelRequire("cgi2g")).getBundleURL('9rAa3') + "opsgenie-left.49c0f64b.svg";

});

parcelRegister("6zNBS", function(module, exports) {

module.exports = (parcelRequire("cgi2g")).getBundleURL('9rAa3') + "opsgenie-right.77c52ee2.svg";

});


parcelRegister("9mjUv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5cfb8f54393f8f84$export$2e2bcd8739ae039; });

var $7VLXz = parcelRequire("7VLXz");

var $4wKrC = parcelRequire("4wKrC");

var $eQ1c9 = parcelRequire("eQ1c9");

var $4ksd4 = parcelRequire("4ksd4");
const $5cfb8f54393f8f84$export$f35613b2e8bb1b7f = (0, $4ksd4.backgroundWithSideImages)((0, (/*@__PURE__*/$parcel$interopDefault($7VLXz))), (0, (/*@__PURE__*/$parcel$interopDefault($4wKrC))));
const $5cfb8f54393f8f84$var$StatuspageCobranding = {
    background: $5cfb8f54393f8f84$export$f35613b2e8bb1b7f,
    logo: {
        component: (0, $eQ1c9.StatuspageLogo)
    },
    footerProducts: 'Statuspage, Jira, Confluence'
};
var $5cfb8f54393f8f84$export$2e2bcd8739ae039 = $5cfb8f54393f8f84$var$StatuspageCobranding;

});
parcelRegister("7VLXz", function(module, exports) {

module.exports = (parcelRequire("cgi2g")).getBundleURL('9rAa3') + "statuspage-left.6c5cd6d4.svg";

});

parcelRegister("4wKrC", function(module, exports) {

module.exports = (parcelRequire("cgi2g")).getBundleURL('9rAa3') + "statuspage-right.447da08b.svg";

});


parcelRegister("6s95l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ea2b777177fa9e3$export$2e2bcd8739ae039; });

var $gcjg5 = parcelRequire("gcjg5");

var $31abt = parcelRequire("31abt");

var $eQ1c9 = parcelRequire("eQ1c9");

var $4ksd4 = parcelRequire("4ksd4");
const $8ea2b777177fa9e3$export$7995c4de8f2b3003 = (0, $4ksd4.backgroundWithSideImages)((0, (/*@__PURE__*/$parcel$interopDefault($gcjg5))), (0, (/*@__PURE__*/$parcel$interopDefault($31abt))));
const $8ea2b777177fa9e3$var$TrelloCobranding = {
    background: $8ea2b777177fa9e3$export$7995c4de8f2b3003,
    logo: {
        component: (0, $eQ1c9.TrelloLogo)
    },
    footerProducts: 'Trello, Jira, Confluence'
};
var $8ea2b777177fa9e3$export$2e2bcd8739ae039 = $8ea2b777177fa9e3$var$TrelloCobranding;

});
parcelRegister("gcjg5", function(module, exports) {

module.exports = (parcelRequire("cgi2g")).getBundleURL('9rAa3') + "trello-left.4f52d13c.svg";

});

parcelRegister("31abt", function(module, exports) {

module.exports = (parcelRequire("cgi2g")).getBundleURL('9rAa3') + "trello-right.e6e102c7.svg";

});


parcelRegister("5Ocqh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b780f4e150b26881$export$2e2bcd8739ae039; });

var $iTSCG = parcelRequire("iTSCG");

var $cKuQ0 = parcelRequire("cKuQ0");

var $4ksd4 = parcelRequire("4ksd4");
const $b780f4e150b26881$export$911a80ac761af24c = (0, $4ksd4.backgroundWithImage)((0, (/*@__PURE__*/$parcel$interopDefault($cKuQ0))));
const $b780f4e150b26881$var$WacCobranding = {
    background: $b780f4e150b26881$export$911a80ac761af24c,
    logo: {
        component: (0, $iTSCG.AtlassianLogo)
    },
    footerProducts: 'Jira, Confluence, Trello'
};
var $b780f4e150b26881$export$2e2bcd8739ae039 = $b780f4e150b26881$var$WacCobranding;

});
parcelRegister("cKuQ0", function(module, exports) {

module.exports = (parcelRequire("cgi2g")).getBundleURL('9rAa3') + "wac.92a80da2.svg";

});


parcelRegister("7XL1M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06725f86e08cd95e$export$2e2bcd8739ae039; });

var $kxTQF = parcelRequire("kxTQF");

var $4zgnR = parcelRequire("4zgnR");

var $eQ1c9 = parcelRequire("eQ1c9");

var $4ksd4 = parcelRequire("4ksd4");
const $06725f86e08cd95e$export$14ae77d7d7e2d26f = (0, $4ksd4.backgroundWithSideImages)((0, (/*@__PURE__*/$parcel$interopDefault($kxTQF))), (0, (/*@__PURE__*/$parcel$interopDefault($4zgnR))));
const $06725f86e08cd95e$var$AtlasCobranding = {
    background: $06725f86e08cd95e$export$14ae77d7d7e2d26f,
    logo: {
        component: (0, $eQ1c9.HomeLogo)
    },
    footerProducts: 'Trello, Jira, Confluence'
};
var $06725f86e08cd95e$export$2e2bcd8739ae039 = $06725f86e08cd95e$var$AtlasCobranding;

});

parcelRegister("h8tbz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e244aa69a295f074$export$2e2bcd8739ae039; });

var $eQ1c9 = parcelRequire("eQ1c9");

var $4ksd4 = parcelRequire("4ksd4");

var $9jjaN = parcelRequire("9jjaN");
let $e244aa69a295f074$var$_ = (t)=>t, $e244aa69a295f074$var$t;
const $e244aa69a295f074$export$4fcb21def34701d = (0, $9jjaN.default)((0, $4ksd4.DefaultBackground))($e244aa69a295f074$var$t || ($e244aa69a295f074$var$t = $e244aa69a295f074$var$_`
  background-color: #fff;
`));
const $e244aa69a295f074$var$LoomCobranding = {
    background: $e244aa69a295f074$export$4fcb21def34701d,
    logo: {
        component: (0, $eQ1c9.LoomLogo)
    },
    footerProducts: 'Loom, Confluence, Jira'
};
var $e244aa69a295f074$export$2e2bcd8739ae039 = $e244aa69a295f074$var$LoomCobranding;

});

parcelRegister("50OJ6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a018232c7c90810$export$2e2bcd8739ae039; });

var $eQ1c9 = parcelRequire("eQ1c9");

var $4ksd4 = parcelRequire("4ksd4");

var $9jjaN = parcelRequire("9jjaN");
let $1a018232c7c90810$var$_ = (t)=>t, $1a018232c7c90810$var$t;
const $1a018232c7c90810$export$69d75365d6a52225 = (0, $9jjaN.default)((0, $4ksd4.DefaultBackground))($1a018232c7c90810$var$t || ($1a018232c7c90810$var$t = $1a018232c7c90810$var$_`
  background-color: #fff;
`));
const $1a018232c7c90810$var$JiraAlignCobranding = {
    background: $1a018232c7c90810$export$69d75365d6a52225,
    logo: {
        component: (0, $eQ1c9.JiraAlignLogo)
    },
    footerProducts: 'Jira Align, Confluence, Jira'
};
var $1a018232c7c90810$export$2e2bcd8739ae039 = $1a018232c7c90810$var$JiraAlignCobranding;

});

parcelRegister("kVFs3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6779da1d4922b3f5$export$2e2bcd8739ae039; });

var $eQ1c9 = parcelRequire("eQ1c9");

var $8wVNq = parcelRequire("8wVNq");
const $6779da1d4922b3f5$var$AdminExperimentForJira = {
    background: (0, $8wVNq.JiraBackground),
    logo: {
        component: (0, $eQ1c9.JiraLogo)
    },
    footerProducts: 'Jira, Confluence, Trello'
};
var $6779da1d4922b3f5$export$2e2bcd8739ae039 = $6779da1d4922b3f5$var$AdminExperimentForJira;

});

parcelRegister("kt5zq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f58242e2390759b$export$2e2bcd8739ae039; });

var $eQ1c9 = parcelRequire("eQ1c9");

var $cq0s9 = parcelRequire("cq0s9");
const $4f58242e2390759b$var$AdminExperimentForConfluence = {
    background: (0, $cq0s9.ConfluenceBackground),
    logo: {
        component: (0, $eQ1c9.ConfluenceLogo)
    },
    footerProducts: 'Jira, Confluence, Trello'
};
var $4f58242e2390759b$export$2e2bcd8739ae039 = $4f58242e2390759b$var$AdminExperimentForConfluence;

});

parcelRegister("lFUQd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8119d89daaeb1099$export$2e2bcd8739ae039; });

var $eQ1c9 = parcelRequire("eQ1c9");

var $cq0s9 = parcelRequire("cq0s9");
const $8119d89daaeb1099$var$RovoCobranding = {
    background: (0, $cq0s9.ConfluenceBackground),
    logo: {
        component: (0, $eQ1c9.RovoLogo)
    },
    footerProducts: 'Confluence, Jira, Trello'
};
var $8119d89daaeb1099$export$2e2bcd8739ae039 = $8119d89daaeb1099$var$RovoCobranding;

});


parcelRegister("2Isaq", function(module, exports) {

$parcel$export(module.exports, "ProductHeading", function () { return $3914c14eb00e7b6a$export$bb672d3ab4980938; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $9jjaN = parcelRequire("9jjaN");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");
let $3914c14eb00e7b6a$var$_ = (t)=>t, $3914c14eb00e7b6a$var$t, $3914c14eb00e7b6a$var$t1;
const $3914c14eb00e7b6a$export$6fe455b424bdaa07 = (0, $9jjaN.default).div($3914c14eb00e7b6a$var$t || ($3914c14eb00e7b6a$var$t = $3914c14eb00e7b6a$var$_`
  display: flex;
  flex-direction: column;
  padding-top: ${0}px;
  align-items: center;

  h5 {
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: ${0};
  }
`), (0, $6e88g.gridSize)() * 3, (0, $kLNLK).N800);
const $3914c14eb00e7b6a$var$ProductHeadingWrapper = (0, $9jjaN.default).div($3914c14eb00e7b6a$var$t1 || ($3914c14eb00e7b6a$var$t1 = $3914c14eb00e7b6a$var$_`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: ${0}px;
`), (0, $6e88g.gridSize)() * 2);
const $3914c14eb00e7b6a$export$bb672d3ab4980938 = ({ suffix: suffix, children: children })=>{
    return /*#__PURE__*/ (0, $4ZSso.jsxs)($3914c14eb00e7b6a$var$ProductHeadingWrapper, {
        "data-testid": "header",
        id: "ProductHeading",
        children: [
            children,
            /*#__PURE__*/ (0, $4ZSso.jsx)($3914c14eb00e7b6a$export$6fe455b424bdaa07, {
                "data-testid": "header-suffix",
                id: "ProductHeadingSuffix",
                children: suffix
            })
        ]
    });
};

});

parcelRegister("1vhID", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $254591cf4e5393ef$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $9jjaN = parcelRequire("9jjaN");

var $26Riy = parcelRequire("26Riy");

var $6T9dz = parcelRequire("6T9dz");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");

var $iTSCG = parcelRequire("iTSCG");

var $4ksd4 = parcelRequire("4ksd4");

var $bE8z6 = parcelRequire("bE8z6");

var $1V2cH = parcelRequire("1V2cH");
let $254591cf4e5393ef$var$_ = (t)=>t, $254591cf4e5393ef$var$t, $254591cf4e5393ef$var$t1, $254591cf4e5393ef$var$t2;
const $254591cf4e5393ef$var$PageFooter = (0, $9jjaN.default).div($254591cf4e5393ef$var$t1 || ($254591cf4e5393ef$var$t1 = $254591cf4e5393ef$var$_`
  background: transparent;
  display: flex;
  align-items: center;
  text-align: center;
  box-sizing: border-box;
  flex-direction: column;
  margin: 0 auto;
  border-top: 1px solid ${0};
  padding-top: ${0}px;
  font-size: 11px;
  color: ${0};
  ${0}
  ${0}

  ${0}
`), (0, $kLNLK).N50, (0, $6e88g.gridSize)() * 3, (props)=>props.footerMessageTextColor, (props)=>(0, $4ksd4.linkStyles)(props.textColor), (0, $4ksd4.listStyles), (0, $26Riy.media).handheld($254591cf4e5393ef$var$t || ($254591cf4e5393ef$var$t = $254591cf4e5393ef$var$_`
     line-height: inherit;
     background-color: transparent;
  `)));
const $254591cf4e5393ef$var$SubText = (0, $9jjaN.default).div($254591cf4e5393ef$var$t2 || ($254591cf4e5393ef$var$t2 = $254591cf4e5393ef$var$_`
  padding-top: ${0}px;
`), (0, $6e88g.gridSize)());
const $254591cf4e5393ef$var$FooterComponent = ({ renderText: renderText, footerProducts: footerProducts, pageId: pageId })=>{
    const onLinkClicked = (0, $1V2cH.useButtonClickedEvent)(pageId, 'learnMoreAtlassianAccount');
    return /*#__PURE__*/ (0, $4ZSso.jsxs)($254591cf4e5393ef$var$PageFooter, {
        "data-testid": "page-footer",
        textColor: (0, $kLNLK).B400,
        footerMessageTextColor: (0, $kLNLK).N800,
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $iTSCG.AtlassianLogo), {
                appearance: "neutral",
                size: "small"
            }),
            renderText && /*#__PURE__*/ (0, $4ZSso.jsx)($254591cf4e5393ef$var$SubText, {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "footer.cobranding.text",
                    defaultMessage: "One account for {products} and {link}.",
                    description: "{products} is a comma-separated list of products. {link} is a hyperlink that will be filled with a separately translated string: more",
                    values: {
                        products: footerProducts,
                        link: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $bE8z6.LearnMoreAboutAtlassianAccountLink), {
                            onClick: onLinkClicked
                        })
                    }
                })
            })
        ]
    });
};
var $254591cf4e5393ef$export$2e2bcd8739ae039 = $254591cf4e5393ef$var$FooterComponent;

});
parcelRegister("bE8z6", function(module, exports) {

$parcel$export(module.exports, "SELF_SERVICE_LINK_URL", function () { return $f1094a4d565f5c3e$export$86be5cde852cdd25; });
$parcel$export(module.exports, "SelfServiceLink", function () { return $f1094a4d565f5c3e$export$a817dad308d44854; });
$parcel$export(module.exports, "SupportLink", function () { return $f1094a4d565f5c3e$export$a6b83d54334dba9f; });
$parcel$export(module.exports, "PRIVACY_POLICY_URL_MOBILE", function () { return $f1094a4d565f5c3e$export$e6483b6b5710900e; });
$parcel$export(module.exports, "PRIVACY_POLICY_URL", function () { return $f1094a4d565f5c3e$export$30786e8ac20c09d8; });
$parcel$export(module.exports, "PrivacyPolicyLink", function () { return $f1094a4d565f5c3e$export$fdd773f48aebb8ab; });
$parcel$export(module.exports, "CLOUD_TERMS_OF_SERVICE_URL_MOBILE", function () { return $f1094a4d565f5c3e$export$4f1e847a8e64f5b; });
$parcel$export(module.exports, "CLOUD_TERMS_OF_SERVICE_URL", function () { return $f1094a4d565f5c3e$export$b6aa5b30b55e4e21; });
$parcel$export(module.exports, "UserNoticeLink", function () { return $f1094a4d565f5c3e$export$afb6ca8138b3e5a3; });
$parcel$export(module.exports, "LearnMoreAboutAtlassianAccountLink", function () { return $f1094a4d565f5c3e$export$694937257991c79; });
$parcel$export(module.exports, "RequestAccessLink", function () { return $f1094a4d565f5c3e$export$5ce617bd6fde7ab8; });
$parcel$export(module.exports, "PASSWORD_LEAKED_LINK", function () { return $f1094a4d565f5c3e$export$4b69c758417d5b1b; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $64QTD = parcelRequire("64QTD");

var $lqtFl = parcelRequire("lqtFl");

var $bqdjD = parcelRequire("bqdjD");
const $f1094a4d565f5c3e$export$86be5cde852cdd25 = 'https://support.atlassian.com/atlassian-account/docs/troubleshoot-login-issues-with-your-atlassian-account/';
function $f1094a4d565f5c3e$export$a817dad308d44854(props) {
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $lqtFl.default), {
        href: $f1094a4d565f5c3e$export$86be5cde852cdd25,
        id: "self-service-link",
        target: "_blank",
        rel: "noopener noreferrer",
        // https://mathiasbynens.github.io/rel-noopener
        onClick: props.onClick,
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "resetpassword.self.service",
            defaultMessage: "Login help"
        })
    });
}
const $f1094a4d565f5c3e$export$56321425bd50535f = 'https://support.atlassian.com/';
function $f1094a4d565f5c3e$export$a6b83d54334dba9f(props) {
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $lqtFl.default), {
        href: $f1094a4d565f5c3e$export$56321425bd50535f,
        id: "support-link",
        target: "_blank",
        rel: "noopener noreferrer",
        // https://mathiasbynens.github.io/rel-noopener
        onClick: props.onClick,
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "resetpassword.support",
            defaultMessage: "Contact Support"
        })
    });
}
const $f1094a4d565f5c3e$export$e6483b6b5710900e = 'https://www.atlassian.com/legal/privacy-policy/mobile';
const $f1094a4d565f5c3e$export$30786e8ac20c09d8 = 'https://www.atlassian.com/legal/privacy-policy';
function $f1094a4d565f5c3e$export$fdd773f48aebb8ab(props) {
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const privacyPolicyUrl = props.isMobileLink ? $f1094a4d565f5c3e$export$e6483b6b5710900e : $f1094a4d565f5c3e$export$30786e8ac20c09d8;
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $lqtFl.default), {
        href: privacyPolicyUrl,
        target: "_blank",
        rel: "noreferrer noopener",
        "aria-label": formatMessage({
            id: 'common.atlassian.privacy.policy.link.aria.label',
            defaultMessage: 'Atlassian Privacy Policy',
            description: "Aria label for link to let users learn more about Atlassian's Privacy Policy."
        }),
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "common.privacy.policy",
            defaultMessage: "Privacy Policy"
        })
    });
}
const $f1094a4d565f5c3e$export$4f1e847a8e64f5b = 'https://www.atlassian.com/legal/customer-agreement/mobile';
const $f1094a4d565f5c3e$export$b6aa5b30b55e4e21 = 'https://www.atlassian.com/legal/cloud-terms-of-service';
const $f1094a4d565f5c3e$export$5e45d5d0eb34696e = 'https://www.atlassian.com/legal/user-notice/mobile';
const $f1094a4d565f5c3e$export$b6eec8592d48b4f1 = 'https://www.atlassian.com/legal/user-notice';
function $f1094a4d565f5c3e$export$afb6ca8138b3e5a3(props) {
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const userNoticeUrl = props.isMobileLink ? $f1094a4d565f5c3e$export$5e45d5d0eb34696e : $f1094a4d565f5c3e$export$b6eec8592d48b4f1;
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $lqtFl.default), {
        href: userNoticeUrl,
        target: "_blank",
        rel: "noreferrer noopener",
        "aria-label": formatMessage({
            id: 'common.atlassian.user.notice.link.aria.label',
            defaultMessage: 'Atlassian User Notice',
            description: "Aria label for link to let users learn more about Atlassian's User Notice."
        }),
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "common.user.notice",
            defaultMessage: "User Notice",
            description: "Link that takes users to the Atlassian User Notice"
        })
    });
}
function $f1094a4d565f5c3e$export$694937257991c79(props) {
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $lqtFl.default), {
        target: "_blank",
        rel: "noreferrer noopener",
        onClick: props.onClick,
        "aria-label": formatMessage({
            id: 'cobranding.footer.learn.more.about.atlassian.account.link.aria.label',
            defaultMessage: 'Learn more about Atlassian Account',
            description: 'Aria label for short link to let users learn more about what an Atlassian Account is.'
        }),
        href: "https://support.atlassian.com/atlassian-account/docs/what-is-an-atlassian-account/",
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "cobranding.footer.learn.more.about.atlassian.account.link",
            defaultMessage: "more",
            description: "Short link to let users learn more about using one account for multiple products. e.g. One account for {products} and more."
        })
    });
}
function $f1094a4d565f5c3e$export$5ce617bd6fde7ab8(props) {
    const { destUrl: destUrl, applicationDestination: applicationDestination } = props;
    const continueUrl = encodeURIComponent(`https://${applicationDestination.destinationHostname}/login?application=${applicationDestination.applicationName.toLowerCase()}` + '&permission-violation=true' + '&preferred-redirect=request-access' + (destUrl ? `&dest-url=${encodeURIComponent(destUrl)}` : ''));
    const redirectUrl = `${(0, $bqdjD.idacOrigin)}/login?continue=${continueUrl}`;
    const buttonText = /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
        id: "select.account.request.access.to.product",
        defaultMessage: "Request access to {productName}",
        values: {
            productName: applicationDestination.applicationName
        }
    });
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $64QTD.default), {
        id: "redirect-to-request-access",
        href: redirectUrl,
        onClick: props.onClick,
        children: buttonText
    });
}
const $f1094a4d565f5c3e$export$4b69c758417d5b1b = 'https://support.atlassian.com/atlassian-account/docs/protect-your-atlassian-account/';

});
parcelRegister("lqtFl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f99309ae3319d723$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $da7Sb = parcelRequire("da7Sb");

var $f1k1y = parcelRequire("f1k1y");

var $4mB70 = parcelRequire("4mB70");
var $aDWwl = parcelRequire("aDWwl");
var $f99309ae3319d723$var$_excluded = [
    "children",
    "testId",
    "appearance",
    "newWindowLabel",
    "target",
    "className",
    "style"
];
var $f99309ae3319d723$var$styles = {
    visitedLink: "_ect41gqc _1053w7te _1ienw7te _n0fxw7te _1vhvg3x0",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz14q2 _ect41gqc _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj14q2 _9oik1r31 _1bnxglyw _jf4cnqa1 _30l314q2 _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h16c2",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _ect41gqc _syaz1gjq _1a3b1r31 _4fprglyw _5goinqa1 _f8pj1gjq _9oik1r31 _1bnx8stv _jf4cnqa1 _30l31gjq _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8h1fxt",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _ect41gqc _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
var $f99309ae3319d723$var$iconStyles = null;
var $f99309ae3319d723$var$LinkWithoutRef = function LinkWithoutRef(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, newWindowLabel = _ref.newWindowLabel, target = _ref.target, preventedClassName = _ref.className, preventedStyle = _ref.style, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $f99309ae3319d723$var$_excluded);
    return /*#__PURE__*/ $91i6m.createElement((0, $4mB70.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, htmlAttributes, {
        target: target,
        ref: ref,
        xcss: (0, $da7Sb.cx)(appearance === 'default' && $f99309ae3319d723$var$styles.defaultAppearance, appearance === 'subtle' && $f99309ae3319d723$var$styles.subtleAppearance, appearance === 'inverse' && $f99309ae3319d723$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $f99309ae3319d723$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }), children, target === '_blank' && /*#__PURE__*/ $91i6m.createElement((0, $aDWwl.default), {
        as: "span",
        xcss: $f99309ae3319d723$var$styles.iconWrapper,
        testId: testId && "".concat(testId, "__icon")
    }, "\uFEFF", (0, $f1k1y.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ $91i6m.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $9gzWK.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $91i6m.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    })) : /*#__PURE__*/ $91i6m.createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        className: (0, $9gzWK.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $91i6m.createElement("path", {
        d: "M17.5715 3.95926L10.7587 10.772C10.5546 10.9692 10.2811 11.0784 9.99723 11.0759C9.71338 11.0734 9.44185 10.9596 9.24113 10.7589C9.04041 10.5581 8.92655 10.2866 8.92409 10.0027C8.92162 9.7189 9.03074 9.44543 9.22794 9.24125L16.0407 2.4285H14.3237C14.0366 2.4285 13.7613 2.31444 13.5582 2.11142C13.3552 1.90839 13.2411 1.63303 13.2411 1.34591C13.2411 1.05879 13.3552 0.783424 13.5582 0.580399C13.7613 0.377373 14.0366 0.263314 14.3237 0.263314H18.4981C18.5509 0.254962 18.6043 0.250507 18.658 0.250041C18.8017 0.248792 18.9443 0.276183 19.0773 0.330617C19.2104 0.385051 19.3313 0.465437 19.4329 0.567084C19.5346 0.668732 19.6149 0.789606 19.6694 0.922652C19.7238 1.0557 19.7512 1.19825 19.75 1.342C19.7495 1.3956 19.7451 1.44896 19.7367 1.50165V5.67628C19.7367 5.9634 19.6227 6.23877 19.4196 6.44179C19.2166 6.64482 18.9412 6.75888 18.6541 6.75888C18.367 6.75888 18.0916 6.64482 17.8886 6.44179C17.6856 6.23877 17.5715 5.9634 17.5715 5.67628V3.95926Z"
    }), /*#__PURE__*/ $91i6m.createElement("path", {
        d: "M2.41519 17.5848V2.4285H8.91076V0.263314H2.41194C1.22001 0.263314 0.25 1.23007 0.25 2.42201V17.5913C0.250574 18.1638 0.47834 18.7127 0.883283 19.1175C1.28823 19.5222 1.83724 19.7497 2.40978 19.75H17.5769C17.8608 19.7499 18.1418 19.6938 18.404 19.585C18.6662 19.4762 18.9044 19.3168 19.105 19.116C19.3055 18.9151 19.4646 18.6767 19.573 18.4143C19.6814 18.152 19.737 17.8708 19.7367 17.587V11.0893H17.5715V17.5848H2.41519Z"
    }))));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ var $f99309ae3319d723$var$Link = /*#__PURE__*/ (0, $91i6m.forwardRef)($f99309ae3319d723$var$LinkWithoutRef);
var $f99309ae3319d723$export$2e2bcd8739ae039 = $f99309ae3319d723$var$Link;

});
parcelRegister("4mB70", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32d6012ec5315299$export$2e2bcd8739ae039; });
/* anchor.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $61RDg = parcelRequire("61RDg");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");


var $8kGa4 = parcelRequire("8kGa4");

var $24QNd = parcelRequire("24QNd");

var $koa2c = parcelRequire("koa2c");

var $l23ST = parcelRequire("l23ST");

var $6A0cm = parcelRequire("6A0cm");

var $lD6mB = parcelRequire("lD6mB");

var $7xei2 = parcelRequire("7xei2");

var $f1k1y = parcelRequire("f1k1y");

var $kQU6o = parcelRequire("kQU6o");

var $iFRl4 = parcelRequire("iFRl4");
var $32d6012ec5315299$var$_excluded = [
    "href",
    "children",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss",
    "newWindowLabel"
], $32d6012ec5315299$var$_excluded2 = [
    "className"
];
var $32d6012ec5315299$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
var $32d6012ec5315299$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $32d6012ec5315299$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $32d6012ec5315299$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $6A0cm.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, _ref$newWindowLabel = _ref.newWindowLabel, newWindowLabel = _ref$newWindowLabel === void 0 ? '(opens new window)' : _ref$newWindowLabel, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $32d6012ec5315299$var$_excluded);
    var interactionContext = (0, $91i6m.useContext)((0, $7xei2.default));
    var handleClick = (0, $91i6m.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $lD6mB.useId)();
    var onClick = (0, $koa2c.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "@atlaskit/primitives",
        packageVersion: "0.0.0-development",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(htmlAttributes, $32d6012ec5315299$var$_excluded2);
    var RouterLink = (0, $l23ST.default)();
    var isExternal = typeof href === 'string' && $32d6012ec5315299$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $32d6012ec5315299$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(href) === 'object';
    (0, $24QNd.default)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $91i6m.createElement((0, $iFRl4.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        as: Component,
        className: xcss,
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        xcss: (0, $8kGa4.cx)($32d6012ec5315299$var$styles.root, (0, $f1k1y.fg)('platform_design-system-team_anchor-positioning') ? $32d6012ec5315299$var$styles.position : undefined, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }), children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ $91i6m.createElement((0, $kQU6o.default), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $32d6012ec5315299$var$Anchor = /*#__PURE__*/ (0, $91i6m.forwardRef)($32d6012ec5315299$var$AnchorNoRef);
var $32d6012ec5315299$export$2e2bcd8739ae039 = $32d6012ec5315299$var$Anchor;

});
parcelRegister("24QNd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1834e80975c961d7$export$2e2bcd8739ae039; });
var $1834e80975c961d7$var$isProduction = true;
var $1834e80975c961d7$var$prefix = 'Invariant failed';
function $1834e80975c961d7$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($1834e80975c961d7$var$isProduction) throw new Error($1834e80975c961d7$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($1834e80975c961d7$var$prefix, ": ").concat(provided) : $1834e80975c961d7$var$prefix;
    throw new Error(value);
}

});

parcelRegister("l23ST", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4fccc35d8c6b2e3$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $5nv0q = parcelRequire("5nv0q");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $f4fccc35d8c6b2e3$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $91i6m.useContext)((0, $5nv0q.RouterLinkProviderContext)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
};
var $f4fccc35d8c6b2e3$export$2e2bcd8739ae039 = $f4fccc35d8c6b2e3$var$useRouterLink;

});
parcelRegister("5nv0q", function(module, exports) {

$parcel$export(module.exports, "RouterLinkProviderContext", function () { return $3ea726d6cc79263c$export$2931e0ee690eee88; });
$parcel$export(module.exports, "default", function () { return $3ea726d6cc79263c$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");
var $3ea726d6cc79263c$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $91i6m.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $3ea726d6cc79263c$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($3ea726d6cc79263c$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $3ea726d6cc79263c$export$2e2bcd8739ae039 = $3ea726d6cc79263c$var$RouterLinkProvider;

});






parcelRegister("b9U6C", function(module, exports) {

$parcel$export(module.exports, "FullScreenSpinnerWrapper", function () { return $02c5ab173b7a124c$export$439279e039f7af42; });
$parcel$export(module.exports, "LoadingSpinner", function () { return $02c5ab173b7a124c$export$b08b517936747730; });

var $4ZSso = parcelRequire("4ZSso");

var $9OWP7 = parcelRequire("9OWP7");

var $6e88g = parcelRequire("6e88g");

var $9jjaN = parcelRequire("9jjaN");
parcelRequire("91i6m");
let $02c5ab173b7a124c$var$_ = (t)=>t, $02c5ab173b7a124c$var$t, $02c5ab173b7a124c$var$t1;
const $02c5ab173b7a124c$export$439279e039f7af42 = (0, $9jjaN.default).div($02c5ab173b7a124c$var$t || ($02c5ab173b7a124c$var$t = $02c5ab173b7a124c$var$_`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`));
const $02c5ab173b7a124c$var$SpinnerContainer = (0, $9jjaN.default).div($02c5ab173b7a124c$var$t1 || ($02c5ab173b7a124c$var$t1 = $02c5ab173b7a124c$var$_`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${0}px;
`), (0, $6e88g.gridSize)() * 3);
const $02c5ab173b7a124c$export$b08b517936747730 = ({ testId: testId })=>{
    return /*#__PURE__*/ (0, $4ZSso.jsx)($02c5ab173b7a124c$var$SpinnerContainer, {
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9OWP7.default), {
            testId: testId,
            size: "large"
        })
    });
};

});



parcelRegister("8ulLA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "ReverifyEmailSentPage", function () { return $4d8fff70df6f7306$export$357c630eb6814495; });
$parcel$export(module.exports, "default", function () { return $4d8fff70df6f7306$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $8KhCJ = parcelRequire("8KhCJ");
parcelRequire("6d87w");
var $l2v8Y = parcelRequire("l2v8Y");

var $damsD = parcelRequire("damsD");

var $64QTD = parcelRequire("64QTD");

var $21Xgy = parcelRequire("21Xgy");

var $65Kbf = parcelRequire("65Kbf");

var $gs2u7 = parcelRequire("gs2u7");

var $1V2cH = parcelRequire("1V2cH");

var $2aGBJ = parcelRequire("2aGBJ");

var $4jXgk = parcelRequire("4jXgk");
const $4d8fff70df6f7306$var$pageId = 'reverifyEmailSentScreen';
const $4d8fff70df6f7306$export$357c630eb6814495 = ()=>{
    const email = (0, $2aGBJ.useAppSelector)((state)=>state.user.email);
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const location = (0, $l2v8Y.useLocation)();
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    (0, $1V2cH.usePageViewedEvent)($4d8fff70df6f7306$var$pageId);
    const addSuccessFlag = ()=>{
        const flag = {
            type: 'success',
            title: (0, $65Kbf.default).reverifyEmailFlagSuccessTitle,
            description: (0, $65Kbf.default).reverifyEmailFlagSuccessDesc
        };
        dispatch((0, $21Xgy.addFlag)(flag.type, flag.title, flag.description));
    };
    const addErrorFlag = ()=>{
        const flag = {
            type: 'error',
            title: (0, $65Kbf.default).reverifyEmailFlagErrorTitle,
            description: (0, $65Kbf.default).reverifyEmailFlagErrorDesc
        };
        dispatch((0, $21Xgy.addFlag)(flag.type, flag.title, flag.description));
    };
    const handleResendVerificationEmail = ()=>{
        analyticsClient.buttonClickedEvent($4d8fff70df6f7306$var$pageId, 'resendReverificationEmail');
        return fetch(`/rest/resend-email${location.search}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response)=>{
            if (response.status === 204) addSuccessFlag();
            else addErrorFlag();
        }).catch(()=>{
            addErrorFlag();
        });
    };
    const header = ()=>/*#__PURE__*/ (0, $4ZSso.jsx)((0, $4jXgk.default), {
            as: "h1",
            size: "small",
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "reverify.email.title",
                defaultMessage: "Check your inbox to verify your email"
            })
        });
    const whiteboxFooter = ()=>{
        return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $64QTD.default), {
            id: "send-validation-submit",
            spacing: "none",
            className: "link-color-override",
            onClick: handleResendVerificationEmail,
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "verify.email.resend.reverification.link",
                defaultMessage: "Resend verification link"
            })
        });
    };
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $gs2u7.default), {
        // @ts-ignore no id
        id: "reverify-email-sent-page",
        pageId: $4d8fff70df6f7306$var$pageId,
        header: header(),
        whiteboxFooter: whiteboxFooter(),
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8KhCJ.default), {
                title: formatMessage((0, $65Kbf.default).headTitle)
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $damsD.default), {
                email: email,
                message: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "reverify.email.sent.verification.link",
                    tagName: "p",
                    defaultMessage: "We sent a verification link to:",
                    description: "Telling user that a verification link has been sent. This message is followed by the user's email address on the next line."
                })
            })
        ]
    });
};
var $4d8fff70df6f7306$export$2e2bcd8739ae039 = $4d8fff70df6f7306$export$357c630eb6814495;

});
parcelRegister("65Kbf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2e356cfab016502$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $e2e356cfab016502$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    // Flags
    reverifyEmailFlagSuccessTitle: {
        id: 'reverify.email.sent.flag.success.title',
        defaultMessage: "We've sent you an email!"
    },
    reverifyEmailFlagSuccessDesc: {
        id: 'reverify.email.sent.flag.success.description',
        defaultMessage: 'The verification email is on its way!'
    },
    reverifyEmailFlagErrorTitle: {
        id: 'reverify.email.sent.flag.error.title',
        defaultMessage: 'Something went wrong.'
    },
    reverifyEmailFlagErrorDesc: {
        id: 'reverify.email.sent.flag.error.description',
        defaultMessage: 'Please try again later.'
    },
    headTitle: {
        id: 'reverify.email.sent.head.title',
        defaultMessage: 'Verify your email'
    }
});

});


parcelRegister("3ssyD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "resetExpiredPasswordLoader", function () { return $1e975299214c8d1e$export$92394b370142461a; });
$parcel$export(module.exports, "ExpiredPasswordPage", function () { return $1e975299214c8d1e$export$f8dc9833cdc832ea; });
$parcel$export(module.exports, "default", function () { return $1e975299214c8d1e$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");
parcelRequire("6d87w");
var $l2v8Y = parcelRequire("l2v8Y");

var $leG06 = parcelRequire("leG06");

var $8KhCJ = parcelRequire("8KhCJ");

var $dBq8m = parcelRequire("dBq8m");

var $2Bbdi = parcelRequire("2Bbdi");

var $jgRXO = parcelRequire("jgRXO");

var $cLysE = parcelRequire("cLysE");

var $2ZKUQ = parcelRequire("2ZKUQ");

var $4ADEl = parcelRequire("4ADEl");

var $21Xgy = parcelRequire("21Xgy");

var $gs2u7 = parcelRequire("gs2u7");

var $1V2cH = parcelRequire("1V2cH");
parcelRequire("0wXBc");
var $buHgC = parcelRequire("buHgC");

var $5e2bj = parcelRequire("5e2bj");

var $2aGBJ = parcelRequire("2aGBJ");

var $9uXJ3 = parcelRequire("9uXJ3");

var $kpg9c = parcelRequire("kpg9c");

var $3f4xr = parcelRequire("3f4xr");
const $1e975299214c8d1e$var$pageId = 'expiredpassword';
async function $1e975299214c8d1e$export$92394b370142461a({ request: request }) {
    if (!await (0, $3f4xr.checkFeatureGateOnceInitialized)((0, $kpg9c.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $5e2bj.fetchPageState)('/rest/login/resetexpiredpassword/state', request, {
        capabilities: [
            'capability-group--manage-profile',
            'capability-name--reset-password'
        ]
    });
}
const $1e975299214c8d1e$export$f8dc9833cdc832ea = ()=>{
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    const location = (0, $l2v8Y.useLocation)();
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const email = (0, $2aGBJ.useAppSelector)((state)=>state.user.email);
    const { error: error, isLoading: isLoading, isComplete: isComplete } = (0, $2aGBJ.useAppSelector)((state)=>state.expiredPassword);
    const dispatchResetPassword = (0, $91i6m.useCallback)(()=>{
        const { token: token } = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(location.search);
        dispatch((0, $4ADEl.requestResetExpiredPassword)(token || ''));
    }, [
        dispatch,
        location.search
    ]);
    const previousIsComplete = (0, $buHgC.usePrevious)(isComplete);
    (0, $1V2cH.usePageViewedEvent)($1e975299214c8d1e$var$pageId, {
        redirectReason: 'adminForcedReset'
    });
    (0, $91i6m.useEffect)(()=>{
        if (!previousIsComplete && isComplete) switch(error){
            case null:
                dispatch((0, $21Xgy.addFlag)('success', (0, $jgRXO.default).emailSentFlagSuccessTitle, (0, $jgRXO.default).emailSentFlagSuccessDesc));
                break;
            case 'invalid_token':
                navigate(`/login?email=${encodeURIComponent(email)}`);
                dispatch((0, $21Xgy.addFlag)('error', (0, $jgRXO.default).emailSentFlagFailedTitle, (0, $jgRXO.default).emailSentFlagFailedDesc));
                break;
            case 'too_many_requests':
                dispatch((0, $21Xgy.addFlag)('error', (0, $jgRXO.default).emailSentFlagFailedTitle, (0, $jgRXO.default).emailSentFlagTooManyEmailsDesc));
                break;
            default:
                dispatch((0, $21Xgy.addFlag)('error', (0, $jgRXO.default).emailSentFlagFailedTitle, (0, $jgRXO.default).emailSentFlagFailedDesc));
                break;
        }
    }, [
        dispatch,
        email,
        error,
        isComplete,
        previousIsComplete,
        navigate
    ]);
    (0, $5e2bj.usePageStateLoader)();
    const headerMessage = formatMessage((0, $jgRXO.default).title);
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $gs2u7.default), {
        // @ts-ignore no id
        id: "expired-password-page",
        pageId: $1e975299214c8d1e$var$pageId,
        header: /*#__PURE__*/ (0, $4ZSso.jsx)("h5", {
            children: headerMessage
        }),
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8KhCJ.default), {
                title: formatMessage((0, $jgRXO.default).headTitle)
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $2Bbdi.default), {
                header: formatMessage((0, $jgRXO.default).headTitle),
                message: formatMessage((0, $jgRXO.default).contentText),
                email: email
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $2ZKUQ.default), {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                    appearance: "primary",
                    id: "send-password-reset-email",
                    type: "submit",
                    isFullWidth: true,
                    isLoading: isLoading,
                    onClick: ()=>{
                        dispatchResetPassword();
                        analyticsClient.buttonClickedEvent($1e975299214c8d1e$var$pageId, 'resetExpiredPasswordButton');
                    },
                    children: formatMessage((0, $jgRXO.default).sendResetEmailButton)
                })
            })
        ]
    });
};
var $1e975299214c8d1e$export$2e2bcd8739ae039 = $1e975299214c8d1e$export$f8dc9833cdc832ea;

});
parcelRegister("2Bbdi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b26ca67ed8499d21$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $9jjaN = parcelRequire("9jjaN");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");

var $k8ZoM = parcelRequire("k8ZoM");

var $dgHYS = parcelRequire("dgHYS");
let $b26ca67ed8499d21$var$_ = (t)=>t, $b26ca67ed8499d21$var$t, $b26ca67ed8499d21$var$t1, $b26ca67ed8499d21$var$t2, $b26ca67ed8499d21$var$t3;
const $b26ca67ed8499d21$var$imgHeight = 92;
const $b26ca67ed8499d21$var$PasswordExpiredContainer = (0, $9jjaN.default).div($b26ca67ed8499d21$var$t || ($b26ca67ed8499d21$var$t = $b26ca67ed8499d21$var$_`
  background: url(${0}) no-repeat center top;
  background-size: 50% 50%;
  padding-top: ${0}px;
`), (0, (/*@__PURE__*/$parcel$interopDefault($dgHYS))), $b26ca67ed8499d21$var$imgHeight + (0, $6e88g.gridSize)() * 8);
const $b26ca67ed8499d21$var$Header = (0, $9jjaN.default).h5($b26ca67ed8499d21$var$t1 || ($b26ca67ed8499d21$var$t1 = $b26ca67ed8499d21$var$_`
  font: ${0};
  color: ${0};
  text-align: left;
`), (0, $k8ZoM.default)('font.heading.small'), (0, $kLNLK).N300);
const $b26ca67ed8499d21$var$Message = (0, $9jjaN.default).p($b26ca67ed8499d21$var$t2 || ($b26ca67ed8499d21$var$t2 = $b26ca67ed8499d21$var$_`
  margin: ${0}px 0;
`), (0, $6e88g.gridSize)());
const $b26ca67ed8499d21$var$Email = (0, $9jjaN.default).p($b26ca67ed8499d21$var$t3 || ($b26ca67ed8499d21$var$t3 = $b26ca67ed8499d21$var$_`
  font: ${0};
  margin-top: ${0}px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
`), (0, $k8ZoM.default)('font.heading.small'), (0, $6e88g.gridSize)());
const $b26ca67ed8499d21$var$PasswordExpiredNotice = (props)=>{
    const { header: header, children: children, email: email, message: message } = props;
    return /*#__PURE__*/ (0, $4ZSso.jsxs)($b26ca67ed8499d21$var$PasswordExpiredContainer, {
        id: "password-expired-notice",
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)($b26ca67ed8499d21$var$Header, {
                id: "password-expired-header",
                children: header
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)($b26ca67ed8499d21$var$Message, {
                id: "password-expired-message",
                children: message
            }),
            email && /*#__PURE__*/ (0, $4ZSso.jsx)($b26ca67ed8499d21$var$Email, {
                children: email
            }),
            children
        ]
    });
};
var $b26ca67ed8499d21$export$2e2bcd8739ae039 = $b26ca67ed8499d21$var$PasswordExpiredNotice;

});
parcelRegister("dgHYS", function(module, exports) {

module.exports = (parcelRequire("cgi2g")).getBundleURL('9rAa3') + "trust-and-security.2e60671c.svg";

});


parcelRegister("jgRXO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $518dd23a8cea3ef3$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $518dd23a8cea3ef3$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    title: {
        id: 'expired.password.title',
        defaultMessage: 'Reset your password'
    },
    headTitle: {
        id: 'expired.password.head.title',
        defaultMessage: 'Security request from your admin'
    },
    contentText: {
        id: 'expired.password.email.content',
        defaultMessage: 'Your admin wants you to set a new password before you log back in. We will send the password reset link to your email address:'
    },
    sendResetEmailButton: {
        id: 'expired.password.button.send',
        defaultMessage: 'Send password reset email'
    },
    emailSentFlagFailedTitle: {
        id: 'expired.password.email.flag.error.title',
        defaultMessage: 'Unable to send email'
    },
    emailSentFlagFailedDesc: {
        id: 'expired.password.email.flag.general.error.desc',
        defaultMessage: 'Something went wrong when we tried to send the password reset link. Try again.'
    },
    emailSentFlagTooManyEmailsDesc: {
        id: 'expired.password.email.flag.toomanyemails.error.desc',
        defaultMessage: "We've sent too many emails, please try again later."
    },
    emailSentFlagSuccessTitle: {
        id: 'expired.password.email.flag.success.title',
        defaultMessage: 'Email successfully sent'
    },
    emailSentFlagSuccessDesc: {
        id: 'expired.password.email.flag.success.desc',
        defaultMessage: 'Check your email for the password reset link.'
    }
});

});

parcelRegister("cLysE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49b1811c9e8bf56f$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "TallLinkButton", function () { return $49b1811c9e8bf56f$export$549de15399e8aa5a; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $6NU0v = parcelRequire("6NU0v");

var $4ZSso = parcelRequire("4ZSso");

var $9jjaN = parcelRequire("9jjaN");

var $9r4Oh = parcelRequire("9r4Oh");

var $jXP7v = parcelRequire("jXP7v");
parcelRequire("91i6m");
let $49b1811c9e8bf56f$var$_ = (t)=>t, $49b1811c9e8bf56f$var$t, $49b1811c9e8bf56f$var$t1;
const $49b1811c9e8bf56f$var$StyledButton = (0, $9jjaN.default)((0, $9r4Oh.default))($49b1811c9e8bf56f$var$t || ($49b1811c9e8bf56f$var$t = $49b1811c9e8bf56f$var$_`
  height: 40px !important;
  line-height: 40px !important;

  div,
  span {
    display: flex !important;
    justify-content: center;
  }
`));
const $49b1811c9e8bf56f$var$StyledLinkButtonWrapper = (0, $9jjaN.default).div($49b1811c9e8bf56f$var$t1 || ($49b1811c9e8bf56f$var$t1 = $49b1811c9e8bf56f$var$_`
  a {
    height: 40px !important;
    line-height: 40px !important;
  }
`));
function $49b1811c9e8bf56f$export$2e2bcd8739ae039(props) {
    const { isFullWidth: isFullWidth } = props, rest = (0, $6NU0v._)(props, [
        "isFullWidth"
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)($49b1811c9e8bf56f$var$StyledButton, (0, $b2I6k._)((0, $1Fos3._)({}, rest), {
        shouldFitContainer: isFullWidth
    }));
}
const $49b1811c9e8bf56f$export$549de15399e8aa5a = (props)=>{
    const { isFullWidth: isFullWidth } = props, rest = (0, $6NU0v._)(props, [
        "isFullWidth"
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)($49b1811c9e8bf56f$var$StyledLinkButtonWrapper, {
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $jXP7v.default), (0, $b2I6k._)((0, $1Fos3._)({}, rest), {
            shouldFitContainer: isFullWidth
        }))
    });
};

});
parcelRegister("9r4Oh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6dea5dd68c9afae5$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $jtgLn = parcelRequire("jtgLn");

var $kAAnW = parcelRequire("kAAnW");
var $6dea5dd68c9afae5$var$_excluded = [
    "appearance",
    "isDisabled",
    "isSelected",
    "isLoading",
    "spacing"
];
/**
 * __Loading button__
 *
 * @deprecated Legacy loading buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new` with the `isLoading` prop.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A small wrapper around Button that allows you to show an @atlaskit/spinner as an overlay on the button when you set an isLoading prop to true.
 *
 * - [Examples](https://atlassian.design/components/button/examples#loading-button)
 */ var $6dea5dd68c9afae5$var$LoadingButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).forwardRef(function LoadingButton(_ref, ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, spacing = _ref.spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $6dea5dd68c9afae5$var$_excluded);
    // Button already has React.memo, so just leaning on that
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $jtgLn.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, rest, {
        ref: ref,
        appearance: appearance,
        "aria-disabled": isLoading || undefined,
        isDisabled: isDisabled,
        isSelected: isSelected,
        overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $kAAnW.default), {
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : null,
        spacing: spacing
    }));
});
// Tools including enzyme rely on components having a display name
$6dea5dd68c9afae5$var$LoadingButton.displayName = 'LoadingButton';
var $6dea5dd68c9afae5$export$2e2bcd8739ae039 = $6dea5dd68c9afae5$var$LoadingButton;

});

parcelRegister("jXP7v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03c02e2ad6a9fc51$export$2e2bcd8739ae039; });
/* link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");


var $da7Sb = parcelRequire("da7Sb");

var $bb3nf = parcelRequire("bb3nf");

var $a4cH2 = parcelRequire("a4cH2");

var $f1k1y = parcelRequire("f1k1y");

var $4mB70 = parcelRequire("4mB70");

var $fXpPO = parcelRequire("fXpPO");

var $aD51X = parcelRequire("aD51X");
var $03c02e2ad6a9fc51$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "href",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId"
], $03c02e2ad6a9fc51$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $03c02e2ad6a9fc51$var$styles = {
    base: "_2rkofajl _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu1snc _1hmsagmp _ajmmvv82 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhksyzs _syaz1lh4 _aetrglyw _irr3syzs _30l31lh4 _1di6syzs _9h8h1lh4",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    fullWidth: "_1bsb1osq"
};
var $03c02e2ad6a9fc51$var$defaultStyles = {
    root: "_bfhk1j54 _syaz10s3 _105310s3 _f8pj10s3 _irr3yw9d _30l310s3 _1di6ip91 _9h8h10s3",
    rootRefreshed: "_bfhksm61 _syaz1gjq _8l3mmuej _aetrb3bt _10531gjq _f8pj1gjq _irr3166n _30l31gjq _1di61dty _9h8h1gjq"
};
var $03c02e2ad6a9fc51$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
var $03c02e2ad6a9fc51$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
var $03c02e2ad6a9fc51$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
var $03c02e2ad6a9fc51$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
var $03c02e2ad6a9fc51$var$subtleStyles = {
    root: "_bfhkqtfy _syaz10s3 _105310s3 _f8pj10s3 _irr34mfv _30l310s3 _1di619qy _9h8h10s3",
    rootRefreshed: "_bfhkqtfy _syaz1gjq _10531gjq _f8pj1mjl _irr34mfv _30l31gjq _1di619qy _9h8h1gjq"
};
var $03c02e2ad6a9fc51$var$selectedStyles = {
    root: "_bfhk7btw _syaz1pke _10531pke _f8pj1pke _irr3i1yw _30l31pke _1di619ru _9h8h1pke",
    rootRefreshed: "_bfhkfg4m _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ var $03c02e2ad6a9fc51$var$LinkButtonBase = function LinkButtonBase(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, children = _ref.children, href = _ref.href, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $03c02e2ad6a9fc51$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(unsafeRest, $03c02e2ad6a9fc51$var$_excluded2);
    var hasIconAfter = Boolean(iconAfter);
    var hasIconBefore = Boolean(iconBefore);
    var localRef = (0, $91i6m.useRef)(null);
    (0, $a4cH2.default)(localRef, autoFocus);
    var combinedRef = (0, $bb3nf.default)([
        localRef,
        ref
    ]);
    return /*#__PURE__*/ $91i6m.createElement((0, $4mB70.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        analyticsContext: analyticsContext,
        ref: combinedRef,
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        testId: testId,
        componentName: "LinkButton",
        interactionName: interactionName
    }, saferRest, {
        xcss: (0, $da7Sb.cx)($03c02e2ad6a9fc51$var$styles.base, appearance === 'default' && ((0, $f1k1y.fg)('platform-component-visual-refresh') ? $03c02e2ad6a9fc51$var$defaultStyles.rootRefreshed : $03c02e2ad6a9fc51$var$defaultStyles.root), appearance === 'primary' && $03c02e2ad6a9fc51$var$primaryStyles.root, appearance === 'warning' && $03c02e2ad6a9fc51$var$warningStyles.root, appearance === 'danger' && $03c02e2ad6a9fc51$var$dangerStyles.root, appearance === 'discovery' && $03c02e2ad6a9fc51$var$discoveryStyles.root, appearance === 'subtle' && ((0, $f1k1y.fg)('platform-component-visual-refresh') ? $03c02e2ad6a9fc51$var$subtleStyles.rootRefreshed : $03c02e2ad6a9fc51$var$subtleStyles.root), $03c02e2ad6a9fc51$var$styles.linkDecorationUnset, isSelected && ((0, $f1k1y.fg)('platform-component-visual-refresh') ? $03c02e2ad6a9fc51$var$selectedStyles.rootRefreshed : $03c02e2ad6a9fc51$var$selectedStyles.root), // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $03c02e2ad6a9fc51$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $03c02e2ad6a9fc51$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $03c02e2ad6a9fc51$var$selectedStyles.discovery, isDisabled && $03c02e2ad6a9fc51$var$styles.disabled, spacing === 'compact' && $03c02e2ad6a9fc51$var$styles.spacingCompact, hasIconBefore && $03c02e2ad6a9fc51$var$styles.buttonIconBefore, hasIconAfter && $03c02e2ad6a9fc51$var$styles.buttonIconAfter, shouldFitContainer && $03c02e2ad6a9fc51$var$styles.fullWidth)
    }), iconBefore && /*#__PURE__*/ $91i6m.createElement((0, $fXpPO.default), {
        type: "icon",
        position: "before",
        isLoading: false
    }, /*#__PURE__*/ $91i6m.createElement((0, $aD51X.default), {
        icon: iconBefore
    })), children && /*#__PURE__*/ $91i6m.createElement((0, $fXpPO.default), {
        isLoading: false
    }, children), iconAfter && /*#__PURE__*/ $91i6m.createElement((0, $fXpPO.default), {
        type: "icon",
        position: "after",
        isLoading: false
    }, /*#__PURE__*/ $91i6m.createElement((0, $aD51X.default), {
        icon: iconAfter
    })));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ var $03c02e2ad6a9fc51$var$LinkButton = /*#__PURE__*/ (0, $91i6m.forwardRef)($03c02e2ad6a9fc51$var$LinkButtonBase);
$03c02e2ad6a9fc51$var$LinkButton.displayName = 'LinkButton';
var $03c02e2ad6a9fc51$export$2e2bcd8739ae039 = $03c02e2ad6a9fc51$var$LinkButton;

});


parcelRegister("2ZKUQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3bb7be123d55678$export$2e2bcd8739ae039; });

var $9jjaN = parcelRequire("9jjaN");

var $6e88g = parcelRequire("6e88g");
let $d3bb7be123d55678$var$_ = (t)=>t, $d3bb7be123d55678$var$t;
const $d3bb7be123d55678$var$ButtonContainer = (0, $9jjaN.default).div($d3bb7be123d55678$var$t || ($d3bb7be123d55678$var$t = $d3bb7be123d55678$var$_`
  width: 100%;
  padding-top: ${0}px;
`), (0, $6e88g.gridSize)() * 2);
var $d3bb7be123d55678$export$2e2bcd8739ae039 = $d3bb7be123d55678$var$ButtonContainer;

});

parcelRegister("4ADEl", function(module, exports) {

$parcel$export(module.exports, "requestResetExpiredPassword", function () { return $e034768ed903de5a$export$21fe95b80217f58c; });

var $49Pnv = parcelRequire("49Pnv");
const $e034768ed903de5a$export$2cd8252107eb640b = ()=>({
        type: 'EXPIRED_PASSWORD_RESET_REQUEST_INITIATE'
    });
const $e034768ed903de5a$export$4098f8ed622a8e6c = ()=>({
        type: 'EXPIRED_PASSWORD_RESET_REQUEST_SUCCESS'
    });
const $e034768ed903de5a$export$7ee4ab4cd9f42c10 = (error)=>({
        type: 'EXPIRED_PASSWORD_RESET_REQUEST_FAILED',
        error: error
    });
const $e034768ed903de5a$export$21fe95b80217f58c = (token)=>(dispatch)=>{
        dispatch($e034768ed903de5a$export$2cd8252107eb640b());
        return fetch('/rest/resetexpiredpassword', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                token: token
            })
        }).then((response)=>{
            if (response.status === 200) return response.json();
            return Promise.reject(new Error(response.status.toString()));
        }).then(({ isSuccessful: isSuccessful })=>{
            if (isSuccessful === true) dispatch($e034768ed903de5a$export$4098f8ed622a8e6c());
            else dispatch($e034768ed903de5a$export$7ee4ab4cd9f42c10('invalid_token'));
        }).catch((error)=>{
            switch(error.message){
                case '401':
                    dispatch($e034768ed903de5a$export$7ee4ab4cd9f42c10('invalid_token'));
                    break;
                case '429':
                    dispatch($e034768ed903de5a$export$7ee4ab4cd9f42c10('too_many_requests'));
                    break;
                default:
                    dispatch($e034768ed903de5a$export$7ee4ab4cd9f42c10('generic_error'));
                    (0, $49Pnv.captureException)(error);
                    break;
            }
        });
    };

});

parcelRegister("0wXBc", function(module, exports) {
$parcel$export(module.exports, "useForceRedirect", function () { return (parcelRequire("kBhWP")).useForceRedirect; });
$parcel$export(module.exports, "usePrevious", function () { return (parcelRequire("buHgC")).usePrevious; });
$parcel$export(module.exports, "useGoogleLoginHandler", function () { return (parcelRequire("5k5vC")).useGoogleLoginHandler; });
$parcel$export(module.exports, "useSocialLoginHandlers", function () { return (parcelRequire("5k5vC")).useSocialLoginHandlers; });
$parcel$export(module.exports, "useRecaptchaChallengeObserver", function () { return (parcelRequire("iiGfm")).useRecaptchaChallengeObserver; });
parcelRequire("kBhWP");
parcelRequire("ilSAr");
parcelRequire("buHgC");
parcelRequire("5k5vC");
parcelRequire("iiGfm");

});
parcelRegister("kBhWP", function(module, exports) {

$parcel$export(module.exports, "useForceRedirect", function () { return $b61d37644088eedf$export$20eacf679bc57a60; });

var $91i6m = parcelRequire("91i6m");

var $9uXJ3 = parcelRequire("9uXJ3");
const $b61d37644088eedf$export$20eacf679bc57a60 = ({ redirectTo: redirectTo })=>{
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    (0, $91i6m.useEffect)(()=>{
        if (redirectTo) try {
            const url = new URL(redirectTo);
            navigate(url.toString());
        } catch (e) {
            console.log('Caught error while trying to redirect...');
            console.log(e);
        }
    }, [
        redirectTo,
        navigate
    ]);
};

});

parcelRegister("ilSAr", function(module, exports) {

var $91i6m = parcelRequire("91i6m");
const $a79f15c75a3c2974$export$820558710db2d9c6 = (callback)=>{
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $91i6m.useEffect)(()=>callback(), []);
};

});

parcelRegister("buHgC", function(module, exports) {

$parcel$export(module.exports, "usePrevious", function () { return $8a47e052c4eb17f1$export$5cae361ad82dce8b; });

var $91i6m = parcelRequire("91i6m");
function $8a47e052c4eb17f1$export$5cae361ad82dce8b(newValue) {
    const previousRef = (0, $91i6m.useRef)();
    (0, $91i6m.useEffect)(()=>{
        previousRef.current = newValue;
    });
    return previousRef.current;
}

});

parcelRegister("5k5vC", function(module, exports) {

$parcel$export(module.exports, "useGoogleLoginHandler", function () { return $73f38aab5cb7ff9b$export$c5e89b4acf71d8e2; });
$parcel$export(module.exports, "useSocialLoginHandlers", function () { return $73f38aab5cb7ff9b$export$3388df9a8c5125bf; });

var $91i6m = parcelRequire("91i6m");

var $1V2cH = parcelRequire("1V2cH");

var $ccxRw = parcelRequire("ccxRw");
const $73f38aab5cb7ff9b$export$c5e89b4acf71d8e2 = ({ pageId: pageId, redirectType: redirectType, redirectParams: redirectParams })=>{
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    return (0, $91i6m.useCallback)(()=>{
        analyticsClient.buttonClickedEvent(pageId, 'googleLoginButton', {
            redirectType: redirectType
        });
        (0, $ccxRw.redirectToGoogleLogin)(redirectParams);
    }, [
        analyticsClient,
        pageId,
        redirectType,
        redirectParams
    ]);
};
const $73f38aab5cb7ff9b$export$3388df9a8c5125bf = ({ pageId: pageId, redirectType: redirectType, redirectParams: redirectParams })=>{
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const handleSocialLogin = (0, $91i6m.useCallback)((redirectFn, buttonId)=>{
        analyticsClient.buttonClickedEvent(pageId, buttonId, {
            redirectType: redirectType
        });
        redirectFn(redirectParams);
    }, [
        analyticsClient,
        pageId,
        redirectType,
        redirectParams
    ]);
    const handleMicrosoftLogin = (0, $91i6m.useCallback)(()=>handleSocialLogin((0, $ccxRw.redirectToMicrosoftLogin), 'microsoftLoginButton'), [
        handleSocialLogin
    ]);
    const handleAppleLogin = (0, $91i6m.useCallback)(()=>handleSocialLogin((0, $ccxRw.redirectToAppleLogin), 'appleLoginButton'), [
        handleSocialLogin
    ]);
    const handleSlackLogin = (0, $91i6m.useCallback)(()=>handleSocialLogin((0, $ccxRw.redirectToSlackLogin), 'slackLoginButton'), [
        handleSocialLogin
    ]);
    return {
        handleMicrosoftLogin: handleMicrosoftLogin,
        handleAppleLogin: handleAppleLogin,
        handleSlackLogin: handleSlackLogin
    };
};

});
parcelRegister("ccxRw", function(module, exports) {

$parcel$export(module.exports, "LoginType", function () { return $ea2e76527b472b38$export$7ecae1a0f094da22; });
$parcel$export(module.exports, "buildState", function () { return $ea2e76527b472b38$export$13c6022a038eeeb6; });
$parcel$export(module.exports, "redirectToGoogleLogin", function () { return $ea2e76527b472b38$export$d6e924a711e9e261; });
$parcel$export(module.exports, "redirectToMicrosoftLogin", function () { return $ea2e76527b472b38$export$a2375491e360a04f; });
$parcel$export(module.exports, "redirectToAppleLogin", function () { return $ea2e76527b472b38$export$be4d35cbb0c7d143; });
$parcel$export(module.exports, "isAppleHiddenEmail", function () { return $ea2e76527b472b38$export$3fed42f6cd70c2bc; });
$parcel$export(module.exports, "redirectToSlackLogin", function () { return $ea2e76527b472b38$export$bdab6d1697fcd9e9; });
$parcel$export(module.exports, "isGoogleLoginOutageAdvisoryEnabled", function () { return $ea2e76527b472b38$export$20fa47fc379f30f3; });
$parcel$export(module.exports, "isAppleLoginOutageAdvisoryEnabled", function () { return $ea2e76527b472b38$export$2fcd6c2fe8f717c4; });
$parcel$export(module.exports, "isMicrosoftLoginOutageAdvisoryEnabled", function () { return $ea2e76527b472b38$export$9c936482818cd3df; });
$parcel$export(module.exports, "isSlackLoginOutageAdvisoryEnabled", function () { return $ea2e76527b472b38$export$94fcb0c439ca8c06; });
/* eslint-disable max-params */ 
var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $dBq8m = parcelRequire("dBq8m");

var $3u8pF = parcelRequire("3u8pF");

var $3H79M = parcelRequire("3H79M");

var $1HVXA = parcelRequire("1HVXA");
var $ea2e76527b472b38$export$7ecae1a0f094da22 = /*#__PURE__*/ function(LoginType) {
    LoginType["Apple"] = "appleLogin";
    LoginType["Slack"] = "slackLogin";
    LoginType["Microsoft"] = "microsoftLogin";
    LoginType["GoogleButton"] = "googleButton";
    LoginType["GoogleOneTap"] = "googleYolo";
    LoginType["SSO"] = "ssoLogin";
    return LoginType;
}({});
const $ea2e76527b472b38$export$13c6022a038eeeb6 = ({ location: location, csrfToken: csrfToken, source: source, loginType: loginType, anonymousId: anonymousId, userFlow: userFlow, recoveryOptions: recoveryOptions })=>(0, $3u8pF.Base64).encode(JSON.stringify({
        csrfToken: csrfToken,
        query: location.search || undefined,
        source: source,
        loginType: loginType,
        anonymousId: anonymousId,
        userFlow: userFlow,
        expects: recoveryOptions === null || recoveryOptions === void 0 ? void 0 : recoveryOptions.expectedEmail,
        recovery: recoveryOptions === null || recoveryOptions === void 0 ? void 0 : recoveryOptions.recoveryToken
    }));
const $ea2e76527b472b38$export$d6e924a711e9e261 = ({ location: location, source: source, recoveryOptions: recoveryOptions })=>{
    const searchParams = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(location.search);
    const filteredParams = Object.fromEntries(Object.entries(searchParams).filter(([key])=>key !== 'login_hint'));
    const { userFlow: userFlow } = filteredParams;
    const params = (0, $b2I6k._)((0, $1Fos3._)({}, filteredParams), {
        prompt: 'select_account',
        source: source,
        loginType: "googleButton",
        userFlow: userFlow,
        recovery: recoveryOptions === null || recoveryOptions === void 0 ? void 0 : recoveryOptions.recoveryToken
    });
    location.assign(`${location.protocol}//${location.host}/login/initiate/google?` + (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).stringify(params));
};
const $ea2e76527b472b38$var$redirectToSocialLoginInitiate = ({ location: location, source: source, recoveryOptions: recoveryOptions, loginType: loginType, loginHint: loginHint })=>{
    const initiateParams = (0, $b2I6k._)((0, $1Fos3._)({}, (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(location.search)), {
        loginType: loginType,
        source: source,
        recovery: recoveryOptions === null || recoveryOptions === void 0 ? void 0 : recoveryOptions.recoveryToken,
        prompt: 'select_account',
        login_hint: loginHint
    });
    let initiateUriSuffix;
    switch(loginType){
        case "appleLogin":
            initiateUriSuffix = 'apple';
            break;
        case "microsoftLogin":
            initiateUriSuffix = 'microsoft';
            break;
        case "slackLogin":
            initiateUriSuffix = 'slack';
            break;
    }
    location.assign(`${location.protocol}//${location.host}/login/initiate/${initiateUriSuffix}?` + (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).stringify(initiateParams));
};
const $ea2e76527b472b38$export$a2375491e360a04f = (params)=>{
    const { location: location, source: source, recoveryOptions: recoveryOptions, email: email } = params;
    $ea2e76527b472b38$var$redirectToSocialLoginInitiate({
        location: location,
        source: source,
        recoveryOptions: recoveryOptions,
        loginType: "microsoftLogin",
        loginHint: email
    });
};
const $ea2e76527b472b38$export$be4d35cbb0c7d143 = (params)=>{
    const { location: location, source: source, recoveryOptions: recoveryOptions, email: email } = params;
    $ea2e76527b472b38$var$redirectToSocialLoginInitiate({
        location: location,
        source: source,
        recoveryOptions: recoveryOptions,
        loginType: "appleLogin",
        loginHint: email
    });
};
const $ea2e76527b472b38$export$3fed42f6cd70c2bc = (email)=>{
    if (!email) return false;
    // Hidden email as defined by <unique-alphanumeric-string>@privaterelay.appleid.com
    const hiddenEmailDomainIdentifier = 'privaterelay.appleid.com';
    const [domain] = email.split('@').slice(-1);
    return domain === hiddenEmailDomainIdentifier;
};
const $ea2e76527b472b38$export$bdab6d1697fcd9e9 = (params)=>{
    const { location: location, source: source, recoveryOptions: recoveryOptions } = params;
    $ea2e76527b472b38$var$redirectToSocialLoginInitiate({
        location: location,
        source: source,
        recoveryOptions: recoveryOptions,
        loginType: "slackLogin",
        // Slack's OIDC implementation expects login_hint to be a JWT and blows up if it's not. If
        // Slack ever supports using an email as the login_hint (like other OIDC providers) then we
        // should remove this line.
        loginHint: undefined
    });
};
const $ea2e76527b472b38$export$20fa47fc379f30f3 = (dynamicConfigs)=>(0, $1HVXA.getBooleanDynamicConfigValueOrDefault)(dynamicConfigs, (0, $3H79M.AidFrontendDynamicConfig).GOOGLE_LOGIN_OUTAGE_ADVISORY);
const $ea2e76527b472b38$export$2fcd6c2fe8f717c4 = (dynamicConfigs)=>(0, $1HVXA.getBooleanDynamicConfigValueOrDefault)(dynamicConfigs, (0, $3H79M.AidFrontendDynamicConfig).APPLE_LOGIN_OUTAGE_ADVISORY);
const $ea2e76527b472b38$export$9c936482818cd3df = (dynamicConfigs)=>(0, $1HVXA.getBooleanDynamicConfigValueOrDefault)(dynamicConfigs, (0, $3H79M.AidFrontendDynamicConfig).MICROSOFT_LOGIN_OUTAGE_ADVISORY);
const $ea2e76527b472b38$export$94fcb0c439ca8c06 = (dynamicConfigs)=>(0, $1HVXA.getBooleanDynamicConfigValueOrDefault)(dynamicConfigs, (0, $3H79M.AidFrontendDynamicConfig).SLACK_LOGIN_OUTAGE_ADVISORY);

});
parcelRegister("3u8pF", function(module, exports) {
(function(global1, factory) {
    module.exports = factory(global1);
})(typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : module.exports, function(global1) {
    'use strict';
    // existing version for noConflict()
    global1 = global1 || {};
    var _Base64 = global1.Base64;
    var version = "2.6.4";
    // constants
    var b64chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    var b64tab = function(bin) {
        var t = {};
        for(var i = 0, l = bin.length; i < l; i++)t[bin.charAt(i)] = i;
        return t;
    }(b64chars);
    var fromCharCode = String.fromCharCode;
    // encoder stuff
    var cb_utob = function(c) {
        if (c.length < 2) {
            var cc = c.charCodeAt(0);
            return cc < 0x80 ? c : cc < 0x800 ? fromCharCode(0xc0 | cc >>> 6) + fromCharCode(0x80 | cc & 0x3f) : fromCharCode(0xe0 | cc >>> 12 & 0x0f) + fromCharCode(0x80 | cc >>> 6 & 0x3f) + fromCharCode(0x80 | cc & 0x3f);
        } else {
            var cc = 0x10000 + (c.charCodeAt(0) - 0xD800) * 0x400 + (c.charCodeAt(1) - 0xDC00);
            return fromCharCode(0xf0 | cc >>> 18 & 0x07) + fromCharCode(0x80 | cc >>> 12 & 0x3f) + fromCharCode(0x80 | cc >>> 6 & 0x3f) + fromCharCode(0x80 | cc & 0x3f);
        }
    };
    var re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
    var utob = function(u) {
        return u.replace(re_utob, cb_utob);
    };
    var cb_encode = function(ccc) {
        var padlen = [
            0,
            2,
            1
        ][ccc.length % 3], ord = ccc.charCodeAt(0) << 16 | (ccc.length > 1 ? ccc.charCodeAt(1) : 0) << 8 | (ccc.length > 2 ? ccc.charCodeAt(2) : 0), chars = [
            b64chars.charAt(ord >>> 18),
            b64chars.charAt(ord >>> 12 & 63),
            padlen >= 2 ? '=' : b64chars.charAt(ord >>> 6 & 63),
            padlen >= 1 ? '=' : b64chars.charAt(ord & 63)
        ];
        return chars.join('');
    };
    var btoa = global1.btoa && typeof global1.btoa == 'function' ? function(b) {
        return global1.btoa(b);
    } : function(b) {
        if (b.match(/[^\x00-\xFF]/)) throw new RangeError('The string contains invalid characters.');
        return b.replace(/[\s\S]{1,3}/g, cb_encode);
    };
    var _encode = function(u) {
        return btoa(utob(String(u)));
    };
    var mkUriSafe = function(b64) {
        return b64.replace(/[+\/]/g, function(m0) {
            return m0 == '+' ? '-' : '_';
        }).replace(/=/g, '');
    };
    var encode = function(u, urisafe) {
        return urisafe ? mkUriSafe(_encode(u)) : _encode(u);
    };
    var encodeURI = function(u) {
        return encode(u, true);
    };
    var fromUint8Array;
    if (global1.Uint8Array) fromUint8Array = function(a, urisafe) {
        // return btoa(fromCharCode.apply(null, a));
        var b64 = '';
        for(var i = 0, l = a.length; i < l; i += 3){
            var a0 = a[i], a1 = a[i + 1], a2 = a[i + 2];
            var ord = a0 << 16 | a1 << 8 | a2;
            b64 += b64chars.charAt(ord >>> 18) + b64chars.charAt(ord >>> 12 & 63) + (typeof a1 != 'undefined' ? b64chars.charAt(ord >>> 6 & 63) : '=') + (typeof a2 != 'undefined' ? b64chars.charAt(ord & 63) : '=');
        }
        return urisafe ? mkUriSafe(b64) : b64;
    };
    // decoder stuff
    var re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
    var cb_btou = function(cccc) {
        switch(cccc.length){
            case 4:
                var cp = (0x07 & cccc.charCodeAt(0)) << 18 | (0x3f & cccc.charCodeAt(1)) << 12 | (0x3f & cccc.charCodeAt(2)) << 6 | 0x3f & cccc.charCodeAt(3), offset = cp - 0x10000;
                return fromCharCode((offset >>> 10) + 0xD800) + fromCharCode((offset & 0x3FF) + 0xDC00);
            case 3:
                return fromCharCode((0x0f & cccc.charCodeAt(0)) << 12 | (0x3f & cccc.charCodeAt(1)) << 6 | 0x3f & cccc.charCodeAt(2));
            default:
                return fromCharCode((0x1f & cccc.charCodeAt(0)) << 6 | 0x3f & cccc.charCodeAt(1));
        }
    };
    var btou = function(b) {
        return b.replace(re_btou, cb_btou);
    };
    var cb_decode = function(cccc) {
        var len = cccc.length, padlen = len % 4, n = (len > 0 ? b64tab[cccc.charAt(0)] << 18 : 0) | (len > 1 ? b64tab[cccc.charAt(1)] << 12 : 0) | (len > 2 ? b64tab[cccc.charAt(2)] << 6 : 0) | (len > 3 ? b64tab[cccc.charAt(3)] : 0), chars = [
            fromCharCode(n >>> 16),
            fromCharCode(n >>> 8 & 0xff),
            fromCharCode(n & 0xff)
        ];
        chars.length -= [
            0,
            0,
            2,
            1
        ][padlen];
        return chars.join('');
    };
    var _atob = global1.atob && typeof global1.atob == 'function' ? function(a) {
        return global1.atob(a);
    } : function(a) {
        return a.replace(/\S{1,4}/g, cb_decode);
    };
    var atob = function(a) {
        return _atob(String(a).replace(/[^A-Za-z0-9\+\/]/g, ''));
    };
    var _decode = function(a) {
        return btou(_atob(a));
    };
    var _fromURI = function(a) {
        return String(a).replace(/[-_]/g, function(m0) {
            return m0 == '-' ? '+' : '/';
        }).replace(/[^A-Za-z0-9\+\/]/g, '');
    };
    var decode = function(a) {
        return _decode(_fromURI(a));
    };
    var toUint8Array;
    if (global1.Uint8Array) toUint8Array = function(a) {
        return Uint8Array.from(atob(_fromURI(a)), function(c) {
            return c.charCodeAt(0);
        });
    };
    var noConflict = function() {
        var Base641 = global1.Base64;
        global1.Base64 = _Base64;
        return Base641;
    };
    // export Base64
    global1.Base64 = {
        VERSION: version,
        atob: atob,
        btoa: btoa,
        fromBase64: decode,
        toBase64: encode,
        utob: utob,
        encode: encode,
        encodeURI: encodeURI,
        btou: btou,
        decode: decode,
        noConflict: noConflict,
        fromUint8Array: fromUint8Array,
        toUint8Array: toUint8Array
    };
    // if ES5 is available, make Base64.extendString() available
    if (typeof Object.defineProperty === 'function') {
        var noEnum = function(v) {
            return {
                value: v,
                enumerable: false,
                writable: true,
                configurable: true
            };
        };
        global1.Base64.extendString = function() {
            Object.defineProperty(String.prototype, 'fromBase64', noEnum(function() {
                return decode(this);
            }));
            Object.defineProperty(String.prototype, 'toBase64', noEnum(function(urisafe) {
                return encode(this, urisafe);
            }));
            Object.defineProperty(String.prototype, 'toBase64URI', noEnum(function() {
                return encode(this, true);
            }));
        };
    }
    //
    // export Base64 to the namespace
    //
    if (global1['Meteor']) Base64 = global1.Base64;
    // module.exports and AMD are mutually exclusive.
    // module.exports has precedence.
    if (0, module.exports) module.exports.Base64 = global1.Base64;
    else if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define([], function() {
        return global1.Base64;
    });
    // that's it!
    return {
        Base64: global1.Base64
    };
});

});



parcelRegister("iiGfm", function(module, exports) {

$parcel$export(module.exports, "useRecaptchaChallengeObserver", function () { return $e5421413c7fac630$export$4cc6b1f2fa5dc3f4; });

var $91i6m = parcelRequire("91i6m");

var $1V2cH = parcelRequire("1V2cH");
const $e5421413c7fac630$var$recaptchaIframeTitle = 'recaptcha challenge';
const $e5421413c7fac630$export$4cc6b1f2fa5dc3f4 = (pageId)=>{
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const bodyObserver = (0, $91i6m.useRef)();
    const attributeObserver = (0, $91i6m.useRef)();
    (0, $91i6m.useEffect)(()=>{
        /*
      To determine if user has been presented with a Google reCAPTCHA challenge, we need to listen to DOM events and check if an <iframe> was injected.
      Said <iframe> will have 'src' attribute containing 'google.com/recaptcha/api2/bframe'. Unfortunately, that is not enough
      because Google will inject the <iframe> even if they're not gonna show the challenge. So we attach another observer,
      looking for a change on the 'style' attribute of the outmost containing <div>. If style.target.visibility is 'visible',
      then we send analytics event.
    */ const outerContainerAttributeObserver = ()=>{
            return new MutationObserver((records)=>{
                const visibleEvent = Array.from(records).find((mutation)=>mutation.attributeName === 'style' && mutation.target.style.visibility === 'visible');
                if (visibleEvent) {
                    var _attributeObserver_current;
                    analyticsClient.trackingEvent({
                        page: pageId,
                        action: 'challenge',
                        subject: 'googleRecaptcha'
                    });
                    (_attributeObserver_current = attributeObserver.current) === null || _attributeObserver_current === void 0 ? void 0 : _attributeObserver_current.disconnect();
                }
            });
        };
        if (window.MutationObserver) {
            var _bodyObserver_current;
            bodyObserver.current = new MutationObserver((records)=>{
                records.forEach((mutation)=>{
                    mutation.addedNodes.forEach((node)=>{
                        if (!(node instanceof Element)) return;
                        const recaptchaIframe = node.querySelector(`iframe[title*='${$e5421413c7fac630$var$recaptchaIframeTitle}']`);
                        if (recaptchaIframe) {
                            var _bodyObserver_current, _recaptchaIframe_parentNode;
                            (_bodyObserver_current = bodyObserver.current) === null || _bodyObserver_current === void 0 ? void 0 : _bodyObserver_current.disconnect();
                            const recaptchaOuterDiv = (_recaptchaIframe_parentNode = recaptchaIframe.parentNode) === null || _recaptchaIframe_parentNode === void 0 ? void 0 : _recaptchaIframe_parentNode.parentNode;
                            if (recaptchaOuterDiv) {
                                var _attributeObserver_current;
                                attributeObserver.current = outerContainerAttributeObserver();
                                (_attributeObserver_current = attributeObserver.current) === null || _attributeObserver_current === void 0 ? void 0 : _attributeObserver_current.observe(recaptchaOuterDiv, {
                                    attributes: true
                                });
                            }
                        }
                    });
                });
            });
            (_bodyObserver_current = bodyObserver.current) === null || _bodyObserver_current === void 0 ? void 0 : _bodyObserver_current.observe(window.document.body, {
                childList: true
            });
        }
        return ()=>{
            var _bodyObserver_current, _attributeObserver_current;
            (_bodyObserver_current = bodyObserver.current) === null || _bodyObserver_current === void 0 ? void 0 : _bodyObserver_current.disconnect();
            (_attributeObserver_current = attributeObserver.current) === null || _attributeObserver_current === void 0 ? void 0 : _attributeObserver_current.disconnect();
        };
    }, [
        analyticsClient,
        pageId
    ]);
};

});



parcelRegister("4b0nc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "securityScreenLoader", function () { return $8d5bd11a18963d38$export$a4b1a0446670c4d3; });
$parcel$export(module.exports, "MfaPromotePage", function () { return $8d5bd11a18963d38$export$84ed94b8c66e0057; });
$parcel$export(module.exports, "default", function () { return $8d5bd11a18963d38$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $6ZLav = parcelRequire("6ZLav");

var $6e88g = parcelRequire("6e88g");

var $9jjaN = parcelRequire("9jjaN");

var $gs2u7 = parcelRequire("gs2u7");

var $cLysE = parcelRequire("cLysE");

var $2ZKUQ = parcelRequire("2ZKUQ");

var $64QTD = parcelRequire("64QTD");

var $6T9dz = parcelRequire("6T9dz");

var $1V2cH = parcelRequire("1V2cH");

var $fqsKy = parcelRequire("fqsKy");

var $h7uck = parcelRequire("h7uck");
parcelRequire("0wXBc");
var $kBhWP = parcelRequire("kBhWP");

var $5e2bj = parcelRequire("5e2bj");

var $2aGBJ = parcelRequire("2aGBJ");
parcelRequire("6d87w");
var $l2v8Y = parcelRequire("l2v8Y");

var $kpg9c = parcelRequire("kpg9c");

var $3f4xr = parcelRequire("3f4xr");

var $4jXgk = parcelRequire("4jXgk");
let $8d5bd11a18963d38$var$_ = (t)=>t, $8d5bd11a18963d38$var$t, $8d5bd11a18963d38$var$t1, $8d5bd11a18963d38$var$t2;
const $8d5bd11a18963d38$var$MfaPromoteContainer = (0, $9jjaN.default).div($8d5bd11a18963d38$var$t || ($8d5bd11a18963d38$var$t = $8d5bd11a18963d38$var$_`
  margin-top: ${0}px;
`), (0, $6e88g.gridSize)());
const $8d5bd11a18963d38$var$MfaImg = (0, $9jjaN.default).img($8d5bd11a18963d38$var$t1 || ($8d5bd11a18963d38$var$t1 = $8d5bd11a18963d38$var$_`
  height: ${0}px;
  display: block;
  margin: 0 auto;
  padding: ${0}px 0;
`), (0, $6e88g.gridSize)() * 14, (0, $6e88g.gridSize)());
const $8d5bd11a18963d38$var$ContentBody = (0, $9jjaN.default).p($8d5bd11a18963d38$var$t2 || ($8d5bd11a18963d38$var$t2 = $8d5bd11a18963d38$var$_`
  margin: ${0}px 0;
`), (0, $6e88g.gridSize)());
const $8d5bd11a18963d38$var$pageId = 'mfaPromotePage';
async function $8d5bd11a18963d38$export$a4b1a0446670c4d3({ request: request }) {
    if (!await (0, $3f4xr.checkFeatureGateOnceInitialized)((0, $kpg9c.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $5e2bj.fetchPageState)('/rest/login/security-screen/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--mfa-promote'
        ]
    });
}
const $8d5bd11a18963d38$export$84ed94b8c66e0057 = ()=>{
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const redirectTo = (0, $2aGBJ.useAppSelector)((state)=>state.mfaPromote.redirectTo);
    (0, $kBhWP.useForceRedirect)({
        redirectTo: redirectTo
    });
    (0, $1V2cH.usePageViewedEvent)($8d5bd11a18963d38$var$pageId);
    (0, $5e2bj.usePageStateLoader)();
    (0, $1V2cH.useOperationalEvent)({
        page: $8d5bd11a18963d38$var$pageId,
        action: `loadMfaPromotePageSuccessful`,
        subject: 'sli'
    });
    const { search: search } = (0, $l2v8Y.useLocation)();
    const trackContinueButtonClicked = (0, $1V2cH.useButtonClickedEvent)($8d5bd11a18963d38$var$pageId, 'MfaPromoteContinue');
    const trackDismissButtonClicked = (0, $1V2cH.useButtonClickedEvent)($8d5bd11a18963d38$var$pageId, 'MfaPromoteDismiss');
    const trackLeanMoreLinkClicked = (0, $1V2cH.useButtonClickedEvent)($8d5bd11a18963d38$var$pageId, 'MfaPromoteLearnMore');
    const onContinueButtonClicked = ()=>{
        trackContinueButtonClicked();
        dispatch((0, $h7uck.handleMfaPromoteUserSelection)('edit_mfa', search));
    };
    const onDismissButtonClicked = ()=>{
        trackDismissButtonClicked();
        dispatch((0, $h7uck.handleMfaPromoteUserSelection)('dismiss', search));
    };
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gs2u7.default), {
        pageId: "mfaPromotePage",
        header: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4jXgk.default), {
            as: "h1",
            size: "small",
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $fqsKy.default).promoteMfaHeader))
        }),
        whiteboxFooter: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $64QTD.default), {
            id: "mfa-promote-learn-more",
            onClick: trackLeanMoreLinkClicked,
            href: "https://support.atlassian.com/atlassian-account/docs/manage-two-step-verification-for-your-atlassian-account/",
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $fqsKy.default).promoteMfaLearnMore))
        }),
        children: /*#__PURE__*/ (0, $4ZSso.jsxs)($8d5bd11a18963d38$var$MfaPromoteContainer, {
            children: [
                /*#__PURE__*/ (0, $4ZSso.jsx)($8d5bd11a18963d38$var$MfaImg, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($6ZLav)))
                }),
                /*#__PURE__*/ (0, $4ZSso.jsx)($8d5bd11a18963d38$var$ContentBody, {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $fqsKy.default).promoteMfaMessageBody))
                }),
                /*#__PURE__*/ (0, $4ZSso.jsx)((0, $2ZKUQ.default), {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                        appearance: "primary",
                        id: "mfa-promote-continue",
                        type: "submit",
                        isFullWidth: true,
                        onClick: onContinueButtonClicked,
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $fqsKy.default).promoteMfaContinue))
                    })
                }, "mfa.promote.continue.container"),
                /*#__PURE__*/ (0, $4ZSso.jsx)((0, $2ZKUQ.default), {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                        appearance: "default",
                        id: "mfa-promote-dismiss",
                        testId: "mfa-promote-dismiss-idf-testid",
                        type: "submit",
                        isFullWidth: true,
                        onClick: onDismissButtonClicked,
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $fqsKy.default).promoteMfaDismiss))
                    })
                }, "mfa.promote.dismiss.container")
            ]
        })
    });
};
var $8d5bd11a18963d38$export$2e2bcd8739ae039 = $8d5bd11a18963d38$export$84ed94b8c66e0057;

});
parcelRegister("6ZLav", function(module, exports) {

module.exports = (parcelRequire("cgi2g")).getBundleURL('9rAa3') + "mfa-enable.f2e108a8.png";

});

parcelRegister("fqsKy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7320c95e47088844$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $7320c95e47088844$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    promoteMfaHeader: {
        id: 'mfa.promote.header',
        defaultMessage: 'Enable two-step verification',
        description: 'Header to promote two-step verification'
    },
    promoteMfaMessageBody: {
        id: 'mfa.promote.message',
        defaultMessage: 'To keep your account secure, you can enable two-step verification. This adds a second login step for extra protection.',
        description: 'Main message to promote two-step verification'
    },
    promoteMfaLearnMore: {
        id: 'mfa.promote.learn',
        defaultMessage: 'Learn more about two-step verification',
        description: 'Text on link to learn more about two-step verification'
    },
    promoteMfaContinue: {
        id: 'mfa.promote.continue',
        defaultMessage: 'Enable two-step verification',
        description: 'Button text for continue to setup two-step verification'
    },
    promoteMfaDismiss: {
        id: 'mfa.promote.dismiss',
        defaultMessage: 'Continue without two-step verification',
        description: 'Button text for continuing without setting up two-step verification'
    }
});

});

parcelRegister("h7uck", function(module, exports) {

$parcel$export(module.exports, "handleMfaPromoteUserSelection", function () { return $8893ae8b6278224b$export$7eaa2fa4de4c2034; });
const $8893ae8b6278224b$export$7eaa2fa4de4c2034 = (choice, queryParams)=>(dispatch)=>{
        const loginPathWithErrorMessage = ()=>{
            const params = new URLSearchParams({
                errorCode: 'invalid.session.token',
                prompt: 'true'
            }).toString();
            return `/login?${params}`;
        };
        return fetch(`/v2/mfa/promote${queryParams || ''}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                choice: choice
            })
        }).then((response)=>{
            if (response.status === 200) return response.json();
            else throw new Error(`${response.status} ${response.statusText}: /v2/mfa/promote`);
        }).then((body)=>{
            const redirectUrl = (body === null || body === void 0 ? void 0 : body.redirectTo) || loginPathWithErrorMessage();
            dispatch($8893ae8b6278224b$export$d184870662dd3111(redirectUrl));
        }).catch(()=>{
            dispatch($8893ae8b6278224b$export$d184870662dd3111(loginPathWithErrorMessage()));
        });
    };
const $8893ae8b6278224b$export$d184870662dd3111 = (redirectTo)=>({
        type: 'MFA_PROMOTE_REDIRECT',
        redirectTo: redirectTo
    });

});


parcelRegister("gx9dc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "mfaLoader", function () { return $f3ff33d7c59be8fe$export$8902dd3d9caf7997; });
$parcel$export(module.exports, "recoverExpiredLoader", function () { return $f3ff33d7c59be8fe$export$bd26e265ac7ee3e1; });
$parcel$export(module.exports, "MultiFactorPage", function () { return $f3ff33d7c59be8fe$export$d5523937d2306712; });
$parcel$export(module.exports, "default", function () { return $f3ff33d7c59be8fe$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $8KhCJ = parcelRequire("8KhCJ");
parcelRequire("6d87w");
var $l2v8Y = parcelRequire("l2v8Y");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $4jXgk = parcelRequire("4jXgk");

var $21Xgy = parcelRequire("21Xgy");

var $2ipGE = parcelRequire("2ipGE");

var $bEnlN = parcelRequire("bEnlN");

var $cCttd = parcelRequire("cCttd");

var $6TZp4 = parcelRequire("6TZp4");

var $lt1si = parcelRequire("lt1si");

var $aeZEo = parcelRequire("aeZEo");

var $64QTD = parcelRequire("64QTD");

var $bE8z6 = parcelRequire("bE8z6");

var $gs2u7 = parcelRequire("gs2u7");

var $8Bf3D = parcelRequire("8Bf3D");

var $klwqV = parcelRequire("klwqV");

var $2aGBJ = parcelRequire("2aGBJ");

var $1V2cH = parcelRequire("1V2cH");

var $5xcuR = parcelRequire("5xcuR");
parcelRequire("0wXBc");
var $buHgC = parcelRequire("buHgC");

var $h3x7y = parcelRequire("h3x7y");

var $9uXJ3 = parcelRequire("9uXJ3");

var $5e2bj = parcelRequire("5e2bj");

var $6om6Y = parcelRequire("6om6Y");

var $3f4xr = parcelRequire("3f4xr");

var $kpg9c = parcelRequire("kpg9c");

var $fshAq = parcelRequire("fshAq");
const $f3ff33d7c59be8fe$var$pageId = 'multiFactorPage';
const $f3ff33d7c59be8fe$var$challengeId = '2svChallengeScreen';
const $f3ff33d7c59be8fe$var$expireId = '2svRecoveryLinkExpiredScreen';
const $f3ff33d7c59be8fe$var$emergencyRecoveryKey = '2svRecoveryKeyScreen';
const $f3ff33d7c59be8fe$var$saveNewRecoveryKey = '2svSaveNewRecoveryKey';
const $f3ff33d7c59be8fe$var$accountRecovery = '2svAccountRecoveryScreen';
const $f3ff33d7c59be8fe$var$recoveryEmailSent = '2svRecoveryEmailSentScreen';
async function $f3ff33d7c59be8fe$export$8902dd3d9caf7997({ request: request }) {
    if (!await (0, $3f4xr.checkFeatureGateOnceInitialized)((0, $kpg9c.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $5e2bj.fetchPageState)('/rest/login/mfa/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--mfa'
        ]
    });
}
async function $f3ff33d7c59be8fe$export$bd26e265ac7ee3e1({ request: request }) {
    if (!await (0, $3f4xr.checkFeatureGateOnceInitialized)((0, $kpg9c.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $5e2bj.fetchPageState)('/rest/2step/recover/expired/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--mfa'
        ]
    });
}
const $f3ff33d7c59be8fe$export$d5523937d2306712 = ({ isExpired: isExpired })=>{
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const { isExecuting: isExecuting, executeWithTracking: executeWithTracking } = (0, $6om6Y.useExecutionTracker)();
    const isEmbedded = (0, $2aGBJ.useAppSelector)((state)=>state.microbranding.isEmbedded);
    const { method: multifactorMethod, phoneNumber: phoneNumber, isLoading: isLoading, isManaged: isManaged, isRecoveryEmailSent: isRecoveryEmailSent, recoveryEmailError: recoveryEmailError, fieldErrors: fieldErrors, recoveryCode: recoveryCode, clearInputTrigger: clearInputTrigger } = (0, $2aGBJ.useAppSelector)((state)=>state.multiFactor);
    const email = (0, $2aGBJ.useAppSelector)((state)=>{
        const mfEmail = state.multiFactor.email;
        const userEmail = state.user.email;
        return mfEmail && mfEmail.length > 0 ? mfEmail : userEmail;
    });
    const { search: search } = (0, $l2v8Y.useLocation)();
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    (0, $1V2cH.usePageViewedEvent)($f3ff33d7c59be8fe$var$pageId);
    (0, $1V2cH.useOperationalEvent)({
        page: $f3ff33d7c59be8fe$var$pageId,
        action: `loadMultiFactorPageSuccessful`,
        subject: 'sli'
    });
    const isInitialRender = (0, $91i6m.useRef)(true);
    const mfaEventAttributes = (0, $91i6m.useMemo)(()=>({
            multifactorMethod: multifactorMethod
        }), [
        multifactorMethod
    ]);
    // User will initially be prompted for the challenged factor, but can switch to the "Recovery code" screen,
    // or futher from there, the "Account recovery" screen.
    // This mode is to keep track of which screen the user is on.
    const [mode, setMode] = (0, $91i6m.useState)('CHALLENGED_FACTOR');
    const previousMode = (0, $buHgC.usePrevious)(mode);
    (0, $91i6m.useEffect)(()=>{
        // After initial render, whenever the mode changes we want to trigger pageViewedEvents:
        if (isInitialRender.current) return;
        isInitialRender.current = false;
        if (mode !== previousMode) switch(mode){
            case 'RECOVERY_EMAIL':
                analyticsClient.pageViewedEvent($f3ff33d7c59be8fe$var$accountRecovery);
                break;
            case 'RECOVERY_CODE':
                analyticsClient.pageViewedEvent($f3ff33d7c59be8fe$var$emergencyRecoveryKey, mfaEventAttributes);
                break;
            case 'CHALLENGED_FACTOR':
                analyticsClient.pageViewedEvent($f3ff33d7c59be8fe$var$challengeId, mfaEventAttributes);
                break;
        }
    }, [
        mode,
        analyticsClient,
        multifactorMethod,
        mfaEventAttributes,
        previousMode
    ]);
    const trackConfirmedRecoveryCode = (0, $1V2cH.useButtonClickedEvent)($f3ff33d7c59be8fe$var$saveNewRecoveryKey, '2svSavedNewRecoveryKey');
    const dispatchConfirmedRecoveryCode = (0, $91i6m.useCallback)(()=>{
        trackConfirmedRecoveryCode();
        dispatch((0, $2ipGE.confirmedRecoveryCode)(search, analyticsClient, navigate));
    }, [
        trackConfirmedRecoveryCode,
        dispatch,
        search,
        analyticsClient,
        navigate
    ]);
    const trackVerifyOtpCode = (0, $1V2cH.useButtonClickedEvent)($f3ff33d7c59be8fe$var$challengeId, '2svChallengeLogin', mfaEventAttributes);
    const dispatchVerifyOtpCode = (0, $91i6m.useCallback)((otpCode)=>{
        trackVerifyOtpCode();
        dispatch((0, $2ipGE.verifyOtpCode)(search, otpCode, analyticsClient, navigate));
    }, [
        trackVerifyOtpCode,
        dispatch,
        search,
        analyticsClient,
        navigate
    ]);
    const trackVerifyRecoveryCode = (0, $1V2cH.useButtonClickedEvent)($f3ff33d7c59be8fe$var$emergencyRecoveryKey, '2svRecoveryKeyLogin', mfaEventAttributes);
    const verifyRecoveryCode = (0, $91i6m.useCallback)((recoveryCode)=>{
        trackVerifyRecoveryCode();
        dispatch((0, $2ipGE.recoverAccount)(search, recoveryCode, analyticsClient, navigate));
    }, [
        trackVerifyRecoveryCode,
        dispatch,
        search,
        analyticsClient,
        navigate
    ]);
    const trackResendSms = (0, $1V2cH.useButtonClickedEvent)($f3ff33d7c59be8fe$var$challengeId, '2svResendSms');
    const resendOtpSms = (0, $91i6m.useCallback)(()=>{
        trackResendSms();
        dispatch((0, $2ipGE.resendOtp)(search, analyticsClient, navigate, multifactorMethod));
    }, [
        trackResendSms,
        dispatch,
        search,
        analyticsClient,
        navigate,
        multifactorMethod
    ]);
    const trackResendEmailOtp = (0, $1V2cH.useButtonClickedEvent)($f3ff33d7c59be8fe$var$challengeId, '2svResendEmailOtp');
    const resendOtpEmail = (0, $91i6m.useCallback)(()=>{
        trackResendEmailOtp();
        dispatch((0, $2ipGE.resendOtp)(search, analyticsClient, navigate, multifactorMethod));
    }, [
        trackResendEmailOtp,
        dispatch,
        search,
        analyticsClient,
        navigate,
        multifactorMethod
    ]);
    const trackUseOtpCode = (0, $1V2cH.useButtonClickedEvent)($f3ff33d7c59be8fe$var$emergencyRecoveryKey, 'usePhone', mfaEventAttributes);
    const trackUseSecurityKey = (0, $1V2cH.useButtonClickedEvent)($f3ff33d7c59be8fe$var$emergencyRecoveryKey, 'useSecurityKey', mfaEventAttributes);
    const useOtpCode = (0, $91i6m.useCallback)(()=>{
        trackUseOtpCode();
        setMode('CHALLENGED_FACTOR');
    }, [
        trackUseOtpCode
    ]);
    const useSecurityKey = (0, $91i6m.useCallback)(()=>{
        trackUseSecurityKey();
        setMode('CHALLENGED_FACTOR');
    }, [
        trackUseSecurityKey
    ]);
    const trackUseRecoveryCode = (0, $1V2cH.useButtonClickedEvent)($f3ff33d7c59be8fe$var$accountRecovery, '2svAccountRecoveryScreen');
    const trackCantUsePhone = (0, $1V2cH.useButtonClickedEvent)($f3ff33d7c59be8fe$var$challengeId, 'cantUsePhone');
    const trackCantUseSecurityKey = (0, $1V2cH.useButtonClickedEvent)($f3ff33d7c59be8fe$var$challengeId, 'cantUseSecurityKey');
    const useRecoveryCode = (0, $91i6m.useCallback)(()=>{
        switch(mode){
            case 'RECOVERY_EMAIL':
                trackUseRecoveryCode();
                break;
            case 'CHALLENGED_FACTOR':
                if (multifactorMethod === 'security-key') trackCantUseSecurityKey();
                else trackCantUsePhone();
                break;
        }
        setMode('RECOVERY_CODE');
    }, [
        trackUseRecoveryCode,
        trackCantUsePhone,
        trackCantUseSecurityKey,
        mode,
        multifactorMethod
    ]);
    const trackUseRecoveryEmail = (0, $1V2cH.useButtonClickedEvent)($f3ff33d7c59be8fe$var$emergencyRecoveryKey, 'noRecoveryKey');
    const useRecoveryEmail = (0, $91i6m.useCallback)(()=>{
        trackUseRecoveryEmail();
        setMode('RECOVERY_EMAIL');
    }, [
        trackUseRecoveryEmail
    ]);
    const navigateToLogin = (0, $5xcuR.useNavigateToLoginPrompt)();
    const trackReturnToLogin = (0, $1V2cH.useLinkClickedEvent)($f3ff33d7c59be8fe$var$pageId, 'returnToLogin');
    const handleReturnToLogin = (0, $91i6m.useCallback)(()=>{
        trackReturnToLogin();
        navigateToLogin();
    }, [
        trackReturnToLogin,
        navigateToLogin
    ]);
    const renderMainContentFooter = ()=>{
        if (mode === 'RECOVERY_EMAIL' && !isRecoveryEmailSent && !isExpired) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $64QTD.default), {
            id: "two-step-verification-enter-back-recovery-key",
            onClick: useRecoveryCode,
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "mf.backtouserecoverycode",
                defaultMessage: "Enter your recovery key"
            })
        });
        else if (isRecoveryEmailSent || isExpired) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $64QTD.default), {
            id: "two-step-verification-switch-challenge-type",
            onClick: resendEmail,
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "mf.resendrecoveryemail",
                defaultMessage: "Resend recovery email"
            })
        });
        else if (mode === 'CHALLENGED_FACTOR') {
            if (multifactorMethod === 'security-key') return /*#__PURE__*/ (0, $4ZSso.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $fshAq.default), {
                        screenId: $f3ff33d7c59be8fe$var$challengeId,
                        isSwitching: isExecuting,
                        switchWithTracking: executeWithTracking
                    }),
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $64QTD.default), {
                        id: "two-step-verification-switch-challenge-type-1",
                        testId: "two-step-verification-switch-challenge-type-idf-testid",
                        onClick: useRecoveryCode,
                        isDisabled: isExecuting,
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $klwqV.default).mfSwitchToRecoveryCode))
                    })
                ]
            });
            else if (multifactorMethod === 'sms' || multifactorMethod === 'otp') return /*#__PURE__*/ (0, $4ZSso.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $fshAq.default), {
                        screenId: $f3ff33d7c59be8fe$var$challengeId,
                        isSwitching: isExecuting,
                        switchWithTracking: executeWithTracking
                    }),
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $64QTD.default), {
                        id: "two-step-verification-switch-challenge-type",
                        testId: "two-step-verification-switch-challenge-type-idf-testid",
                        onClick: useRecoveryCode,
                        isDisabled: isExecuting,
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $klwqV.default).mfSwitchToRecoveryCode))
                    })
                ]
            });
            else // email-otp should never call this function
            return null;
        } else if (mode === 'RECOVERY_CODE') return /*#__PURE__*/ (0, $4ZSso.jsxs)("div", {
            children: [
                !isManaged && /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $64QTD.default), {
                        id: "two-step-verification-switch-challenge-type",
                        onClick: useRecoveryEmail,
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                            id: "mf.userecoveryemail",
                            defaultMessage: "Can't find your recovery key?"
                        })
                    })
                }),
                multifactorMethod === 'security-key' ? /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $64QTD.default), {
                        onClick: useSecurityKey,
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                            id: "mf.useyoursecuritykey",
                            defaultMessage: "Use your security key instead"
                        })
                    })
                }) : /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $64QTD.default), {
                        onClick: useOtpCode,
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                            id: "mf.backtouseotpcode.sms",
                            defaultMessage: "Use SMS instead"
                        })
                    })
                })
            ]
        });
        else if (!isEmbedded) return /*#__PURE__*/ (0, $4ZSso.jsx)("a", {
            href: "https://confluence.atlassian.com/cloud/secure-your-account-with-two-step-verification-939505063.html#Secureyouraccountwithtwo-stepverification-Recoveryouraccount",
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "mf.gethelp",
                defaultMessage: "Help for two-step verification"
            })
        });
    };
    const renderFooter = ()=>{
        if (!isEmbedded) return /*#__PURE__*/ (0, $4ZSso.jsxs)("ul", {
            className: "fine-print",
            children: [
                /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $bE8z6.PrivacyPolicyLink), {
                        isMobileLink: false
                    })
                }),
                /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8Bf3D.default), {}),
                /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $bE8z6.UserNoticeLink), {
                        isMobileLink: false
                    })
                })
            ]
        });
    };
    const renderHeader = ()=>{
        if (isExpired) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4jXgk.default), {
            size: "small",
            as: "h1",
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "login.title.recoverylinkexpired",
                defaultMessage: "Your recovery link expired"
            })
        });
        else if (mode === 'CHALLENGED_FACTOR' || mode === 'RECOVERY_CODE') return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4jXgk.default), {
            size: "small",
            as: "h1",
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "continue.with.two.step.verification",
                defaultMessage: "Continue with two-step verification"
            })
        });
        else return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4jXgk.default), {
            size: "small",
            as: "h1",
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "mf.title.norecoverycode",
                defaultMessage: "Recover your account"
            })
        });
    };
    const trackSendRecoveryEmail = (0, $1V2cH.useButtonClickedEvent)($f3ff33d7c59be8fe$var$accountRecovery, 'sendRecoveryEmail');
    const sendEmail = (0, $91i6m.useCallback)(()=>{
        trackSendRecoveryEmail();
        dispatch((0, $2ipGE.sendRecoveryEmail)(email));
    }, [
        trackSendRecoveryEmail,
        dispatch,
        email
    ]);
    const trackResendEmail = (0, $1V2cH.useButtonClickedEvent)($f3ff33d7c59be8fe$var$recoveryEmailSent, 'resendEmail');
    const trackResendEmailExpired = (0, $1V2cH.useButtonClickedEvent)($f3ff33d7c59be8fe$var$expireId, 'resendEmail');
    const resendEmail = (0, $91i6m.useCallback)(()=>{
        sendEmail();
        if (isExpired) trackResendEmailExpired();
        else trackResendEmail();
        if (isRecoveryEmailSent) dispatch((0, $21Xgy.addFlag)('success', (0, $klwqV.default).mfRecoveryEmailResentSuccessTitle, (0, $klwqV.default).mfRecoveryEmailResentSuccessDesc));
        else dispatch((0, $21Xgy.addFlag)('error', (0, $klwqV.default).mfRecoveryEmailResentErrorTitle, (0, $klwqV.default).mfRecoveryEmailResentErrorDesc));
    }, [
        sendEmail,
        isExpired,
        isRecoveryEmailSent,
        trackResendEmailExpired,
        trackResendEmail,
        dispatch
    ]);
    const renderWhiteboxPageContent = ()=>{
        if (isRecoveryEmailSent || isExpired) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6TZp4.default), {
            email: email,
            isExpired: isExpired,
            expirePageId: $f3ff33d7c59be8fe$var$expireId,
            emailSentPageId: $f3ff33d7c59be8fe$var$recoveryEmailSent
        });
        if (mode === 'CHALLENGED_FACTOR') {
            if (multifactorMethod === 'sms' || multifactorMethod === 'otp') return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $bEnlN.default), {
                verifyOtpCode: dispatchVerifyOtpCode,
                resendOtp: resendOtpSms,
                isLoading: isLoading,
                otpError: fieldErrors.otpCode,
                multifactorMethod: multifactorMethod,
                phoneNumber: phoneNumber,
                clearInputTrigger: clearInputTrigger
            });
            if (multifactorMethod === 'security-key') return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $bEnlN.default), {
                isLoading: isLoading,
                multifactorMethod: multifactorMethod,
                clearInputTrigger: clearInputTrigger
            });
        } else if (mode === 'RECOVERY_CODE') return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $lt1si.default), {
            recoverAccount: verifyRecoveryCode,
            isLoading: isLoading,
            multifactorMethod: multifactorMethod,
            recoveryError: fieldErrors.recoveryCode
        });
        else if (mode === 'RECOVERY_EMAIL') return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cCttd.default), {
            email: email,
            sendEmail: sendEmail,
            recoveryEmailError: recoveryEmailError
        });
    };
    const renderGenericExperience = ()=>{
        return !recoveryCode ? /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $gs2u7.default), {
            pageId: $f3ff33d7c59be8fe$var$pageId,
            header: renderHeader(),
            whiteboxFooter: renderMainContentFooter(),
            footer: renderFooter(),
            noCobranding: true,
            children: [
                /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8KhCJ.default), {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)("title", {
                        children: formatMessage((0, $klwqV.default).loginHeadTitle)
                    })
                }),
                renderWhiteboxPageContent()
            ]
        }) : /*#__PURE__*/ (0, $4ZSso.jsx)((0, $aeZEo.default), {
            recoveryCode: recoveryCode,
            onComplete: dispatchConfirmedRecoveryCode,
            isEmbedded: isEmbedded
        });
    };
    const verifyEmailOtpErrorCodeMapping = {
        invalid_otp: 'invalid_otp',
        invalid_token: 'invalid_token',
        invalid_otp_format: 'invalid_otp_length'
    };
    const renderEmailOtpExperience = ()=>{
        var _fieldErrors_otpCode;
        const otpErrorCode = fieldErrors === null || fieldErrors === void 0 ? void 0 : (_fieldErrors_otpCode = fieldErrors.otpCode) === null || _fieldErrors_otpCode === void 0 ? void 0 : _fieldErrors_otpCode.errorCode;
        const verifyEmailOtpErrorCode = !otpErrorCode ? undefined : verifyEmailOtpErrorCodeMapping[otpErrorCode] || 'unexpected_error';
        return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $h3x7y.default), {
            pageId: $f3ff33d7c59be8fe$var$pageId,
            flow: "login-challenge",
            email: email,
            isLoading: isLoading,
            errorCode: verifyEmailOtpErrorCode,
            onVerifyEmailOtp: dispatchVerifyOtpCode,
            onResendEmailOtp: resendOtpEmail,
            additionalWhiteboxFooter: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $64QTD.default), {
                id: "two-step-verification-return-to-login",
                onClick: handleReturnToLogin,
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "mf.emailotp.return.to.login",
                    defaultMessage: "Log in to a different account"
                })
            })
        });
    };
    (0, $5e2bj.usePageStateLoader)();
    if (multifactorMethod === 'email-otp') return renderEmailOtpExperience();
    else return renderGenericExperience();
};
var $f3ff33d7c59be8fe$export$2e2bcd8739ae039 = $f3ff33d7c59be8fe$export$d5523937d2306712;

});
parcelRegister("bEnlN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a47027517d2f5b3d$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $9jjaN = parcelRequire("9jjaN");

var $5v178 = parcelRequire("5v178");

var $6e88g = parcelRequire("6e88g");

var $jtgLn = parcelRequire("jtgLn");

var $7081r = parcelRequire("7081r");

var $cLysE = parcelRequire("cLysE");

var $6GpTs = parcelRequire("6GpTs");

var $6FRcv = parcelRequire("6FRcv");

var $damsD = parcelRequire("damsD");

var $6VTqX = parcelRequire("6VTqX");

var $lJcQw = parcelRequire("lJcQw");
let $a47027517d2f5b3d$var$_ = (t)=>t, $a47027517d2f5b3d$var$t, $a47027517d2f5b3d$var$t1;
const $a47027517d2f5b3d$var$ButtonContainer = (0, $9jjaN.default).div($a47027517d2f5b3d$var$t || ($a47027517d2f5b3d$var$t = $a47027517d2f5b3d$var$_`
  margin-top: ${0}px;
`), (0, $6e88g.gridSize)());
const $a47027517d2f5b3d$var$ResendButton = (0, $9jjaN.default)((0, $jtgLn.default))($a47027517d2f5b3d$var$t1 || ($a47027517d2f5b3d$var$t1 = $a47027517d2f5b3d$var$_`
  span {
    text-align: left;
    white-space: normal;
  }
`));
const $a47027517d2f5b3d$var$MultiFactorForm = ({ email: email, isLoading: isLoading, multifactorMethod: multifactorMethod, otpError: otpError, phoneNumber: phoneNumber, resendOtp: resendOtp, verifyOtpCode: verifyOtpCode, clearInputTrigger: clearInputTrigger })=>{
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const helpTooltip = (method, phoneNumber, email)=>{
        if (method === 'sms') {
            const resendButton = /*#__PURE__*/ (0, $4ZSso.jsx)($a47027517d2f5b3d$var$ResendButton, {
                id: "resend-sms",
                appearance: "link",
                onClick: resendOtp,
                spacing: "none",
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "mf.mfform.sms.resend",
                    defaultMessage: "Resend the text message."
                })
            });
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "mf.mfform.getsms.tooltip",
                tagName: "p",
                defaultMessage: "We've sent a text message (SMS) with the verification code to {mobileNumber}. Didn't get it? {resendButton}",
                values: {
                    mobileNumber: /*#__PURE__*/ (0, $4ZSso.jsx)("b", {
                        children: phoneNumber
                    }),
                    resendButton: resendButton
                }
            });
        }
        if (method === 'email-otp') {
            const resendButton = /*#__PURE__*/ (0, $4ZSso.jsx)($a47027517d2f5b3d$var$ResendButton, {
                id: "resend-email-otp",
                appearance: "link",
                onClick: resendOtp,
                spacing: "none",
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "mf.mfform.emailotp.resend",
                    defaultMessage: "Resend the verification code."
                })
            });
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "mf.mfform.emailotp.tooltip",
                tagName: "p",
                defaultMessage: "We've sent the verification code to {email}. Didn't get it? {resendButton}",
                values: {
                    email: /*#__PURE__*/ (0, $4ZSso.jsx)("b", {
                        children: email
                    }),
                    resendButton: resendButton
                }
            });
        }
        if (method === 'security-key') return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "mf.mfform.securitykey.tooltip",
            tagName: "p",
            defaultMessage: "Use any security key you registered with Atlassian"
        });
        return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "mf.mfform.getcode.tooltip",
            tagName: "p",
            defaultMessage: "Open the verification app on your phone to get your verification code."
        });
    };
    const handleInputChange = (0, $91i6m.useCallback)((e)=>{
        if (e.target && !!e.target.maxLength && e.target.value.length === e.target.maxLength) verifyOtpCode === null || verifyOtpCode === void 0 ? void 0 : verifyOtpCode(e.target.value);
    }, [
        verifyOtpCode
    ]);
    const handleFormSubmit = (0, $91i6m.useCallback)((e)=>{
        e.preventDefault();
        const target = e.target;
        verifyOtpCode === null || verifyOtpCode === void 0 ? void 0 : verifyOtpCode(target.otpCode.value);
    }, [
        verifyOtpCode
    ]);
    const otpPromptMessage = (0, $91i6m.useMemo)(()=>{
        switch(multifactorMethod){
            case 'sms':
                return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $lJcQw.default).mfSmsPrompt));
            case 'otp':
                return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $lJcQw.default).mfTotpPrompt));
            case 'email-otp':
                return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $lJcQw.default).mfEmailPrompt));
            default:
                return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "mf.mfform.getcode",
                    defaultMessage: "Enter your verification code to continue."
                });
        }
    }, [
        multifactorMethod
    ]);
    const renderOtpForm = (codeLength, codeType)=>{
        return /*#__PURE__*/ (0, $4ZSso.jsxs)("form", {
            autoComplete: "off",
            onSubmit: handleFormSubmit,
            children: [
                /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $6FRcv.InputMessage), {
                    children: [
                        otpPromptMessage,
                        /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6FRcv.InlineMessageContainer), {
                            "data-testid": "mfform-tooltip-icon",
                            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $5v178.default), {
                                appearance: "info",
                                placement: "bottom-end",
                                iconLabel: formatMessage({
                                    id: 'mf.mfform.getcode.tooltip.icon.label',
                                    defaultMessage: 'More info',
                                    description: 'Icon label for the help tooltip'
                                }),
                                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6FRcv.StyledMessage), {
                                    children: helpTooltip(multifactorMethod, phoneNumber, email)
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $4ZSso.jsx)((0, $7081r.default), {
                    id: "two-step-verification-otp-code-input",
                    disabled: isLoading,
                    fieldErrorFromParent: otpError,
                    onChange: handleInputChange,
                    codeLength: codeLength,
                    codeType: codeType,
                    clearInputTrigger: clearInputTrigger
                }),
                /*#__PURE__*/ (0, $4ZSso.jsx)($a47027517d2f5b3d$var$ButtonContainer, {
                    id: "two-step-verification-submit",
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                        appearance: "primary",
                        type: "submit",
                        isFullWidth: true,
                        isLoading: isLoading,
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                            id: "common.login",
                            defaultMessage: "Log in"
                        })
                    })
                })
            ]
        });
    };
    if (multifactorMethod === 'email-otp') return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $damsD.default), {
        children: renderOtpForm(6, 'alphanumeric')
    });
    else if (multifactorMethod === 'security-key') return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6VTqX.default), {});
    else {
        const securityWallStyle = multifactorMethod === 'otp' ? 'totp' : 'default';
        return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6GpTs.SecurityWall), {
            id: "two-step-verification-form",
            securityWallStyle: securityWallStyle,
            children: renderOtpForm(6, 'numeric')
        });
    }
};
var $a47027517d2f5b3d$export$2e2bcd8739ae039 = $a47027517d2f5b3d$var$MultiFactorForm;

});
parcelRegister("5v178", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4010b6391fd55cd8$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $5YM7L = parcelRequire("5YM7L");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $lD6mB = parcelRequire("lD6mB");

var $8iC7e = parcelRequire("8iC7e");

var $aDWwl = parcelRequire("aDWwl");
var $dwV3h = parcelRequire("dwV3h");
var $kKNUG = parcelRequire("kKNUG");
var $7oEAU = parcelRequire("7oEAU");


var $7xwGT = parcelRequire("7xwGT");
var $4010b6391fd55cd8$var$_excluded = [
    "ref"
];
var $4010b6391fd55cd8$var$styles = {
    contentStyles: "_bozg1ejb _y4ti1ejb _1q51pxbi _85i5pxbi",
    rootStyles: "_1e0c1o8l _p12f1osq _1yyu1kum _nt751r31 _49pcnqa1 _1hvwt94y",
    pressableStyles: "_11c82smr _1rjcze3t _18zrze3t _1e0c116y _bfhksm61 _syaz1gjq _o5721q9c _kqswh2mm _4cvr1q9y _p12f1osq _4t3i1wug _1bsb1wug _s7n41q9y _9oik1r31 _1bnx8stv _jf4cnqa1"
};
var $4010b6391fd55cd8$var$iconColor = {
    connectivity: "_x5v91r2e",
    confirmation: "_x5v91fgg",
    info: "_x5v913wx",
    warning: "_x5v9f6ss",
    error: "_x5v9k8x7"
};
/**
 * __Inline message__
 *
 * An inline message lets users know when important information is available or when an action is required.
 *
 * - [Examples](https://atlassian.design/components/inline-message/examples)
 * - [Code](https://atlassian.design/components/inline-message/code)
 * - [Usage](https://atlassian.design/components/inline-message/usage)
 *
 * @example
 *
 * ```jsx
 * const Component = () => (
 *   <InlineMessage
 *    title="Inline Message Title Example"
 *    secondaryText="Secondary Text"
 *   >
 *    <p>Some text that would be inside the open dialog and otherwise hidden.</p>
 *   </InlineMessage>
 * );
 * ```
 */ var $4010b6391fd55cd8$var$InlineMessage = function InlineMessage(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$secondaryText = _ref.secondaryText, secondaryText = _ref$secondaryText === void 0 ? '' : _ref$secondaryText, _ref$title = _ref.title, title = _ref$title === void 0 ? '' : _ref$title, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'connectivity' : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'spacious' : _ref$spacing, children = _ref.children, testId = _ref.testId, iconLabel = _ref.iconLabel, fallbackPlacements = _ref.fallbackPlacements;
    var _useState = (0, $91i6m.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), isOpen = _useState2[0], setIsOpen = _useState2[1];
    var id = (0, $lD6mB.useId)();
    var toggleDialog = (0, $91i6m.useCallback)(function() {
        setIsOpen(function(oldState) {
            return !oldState;
        });
    }, [
        setIsOpen
    ]);
    var onCloseDialog = (0, $91i6m.useCallback)(function() {
        return setIsOpen(false);
    }, [
        setIsOpen
    ]);
    return /*#__PURE__*/ $91i6m.createElement("div", {
        "data-testid": testId,
        className: (0, $9gzWK.default)([
            $4010b6391fd55cd8$var$styles.rootStyles,
            $4010b6391fd55cd8$var$iconColor[appearance]
        ])
    }, /*#__PURE__*/ $91i6m.createElement((0, $8iC7e.default), {
        onClose: onCloseDialog,
        content: function content() {
            return /*#__PURE__*/ $91i6m.createElement((0, $aDWwl.default), {
                xcss: $4010b6391fd55cd8$var$styles.contentStyles
            }, children);
        },
        isOpen: isOpen,
        placement: placement,
        testId: testId && "".concat(testId, "--popup"),
        fallbackPlacements: fallbackPlacements,
        shouldRenderToParent: true,
        role: "dialog",
        titleId: id,
        shouldDisableFocusLock: true,
        autoFocus: false,
        trigger: function trigger(_ref2) {
            var ref = _ref2.ref, triggerProps = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref2, $4010b6391fd55cd8$var$_excluded);
            return /*#__PURE__*/ $91i6m.createElement((0, $kKNUG.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, triggerProps, {
                ref: ref,
                id: id,
                "data-ds--inline-message--button": true,
                onClick: toggleDialog,
                testId: testId && "".concat(testId, "--button"),
                xcss: $4010b6391fd55cd8$var$styles.pressableStyles,
                "aria-expanded": isOpen
            }), /*#__PURE__*/ $91i6m.createElement((0, $dwV3h.default), {
                as: "span",
                space: "space.050",
                alignBlock: "center"
            }, /*#__PURE__*/ $91i6m.createElement((0, $7xwGT.default), {
                isOpen: isOpen,
                appearance: appearance,
                label: iconLabel,
                spacing: spacing
            }), /*#__PURE__*/ $91i6m.createElement((0, $dwV3h.default), {
                as: "span",
                space: "space.100"
            }, title && /*#__PURE__*/ $91i6m.createElement((0, $7oEAU.default), {
                weight: "medium",
                testId: testId && "".concat(testId, "--title")
            }, title), secondaryText && /*#__PURE__*/ $91i6m.createElement((0, $7oEAU.default), {
                weight: "medium",
                color: "color.text.subtlest",
                maxLines: 1,
                testId: testId && "".concat(testId, "--text")
            }, secondaryText))));
        }
    }));
};
var $4010b6391fd55cd8$export$2e2bcd8739ae039 = $4010b6391fd55cd8$var$InlineMessage;

});
parcelRegister("8iC7e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60ad92235b704e17$export$2e2bcd8739ae039; });

var $lJMQ4 = parcelRequire("lJMQ4");
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$60ad92235b704e17$export$2e2bcd8739ae039 = (0, $lJMQ4.Popup);

});
parcelRegister("lJMQ4", function(module, exports) {

$parcel$export(module.exports, "Popup", function () { return $fd33af4daa0cc030$export$129a32eedafa97c5; });
/* popup.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5YM7L = parcelRequire("5YM7L");

var $91i6m = parcelRequire("91i6m");


var $4ledg = parcelRequire("4ledg");

var $aHMp1 = parcelRequire("aHMp1");

var $1tlvt = parcelRequire("1tlvt");

var $f1k1y = parcelRequire("f1k1y");

var $8z7c3 = parcelRequire("8z7c3");
var $6Xy2r = parcelRequire("6Xy2r");

var $lLIDD = parcelRequire("lLIDD");

var $aDWwl = parcelRequire("aDWwl");

var $bmnyL = parcelRequire("bmnyL");

var $3AtxU = parcelRequire("3AtxU");

var $lSMAo = parcelRequire("lSMAo");

var $ctRH8 = parcelRequire("ctRH8");
var $fd33af4daa0cc030$var$defaultLayer = 400;
var $fd33af4daa0cc030$var$wrapperStyles = {
    root: "_kqswh2mm"
};
var $fd33af4daa0cc030$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $91i6m.memo)(function(_ref) {
    var xcss = _ref.xcss, _ref$appearance = _ref.appearance, inAppearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, isOpen = _ref.isOpen, providedId = _ref.id, offset = _ref.offset, testId = _ref.testId, trigger = _ref.trigger, content = _ref.content, onClose = _ref.onClose, boundary = _ref.boundary, _ref$rootBoundary = _ref.rootBoundary, rootBoundary = _ref$rootBoundary === void 0 ? 'viewport' : _ref$rootBoundary, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, fallbackPlacements = _ref.fallbackPlacements, PopupContainer = _ref.popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? $fd33af4daa0cc030$var$defaultLayer : _ref$zIndex, _ref$shouldUseCapture = _ref.shouldUseCaptureOnOutsideClick, shouldUseCaptureOnOutsideClick = _ref$shouldUseCapture === void 0 ? false : _ref$shouldUseCapture, _ref$shouldRenderToPa = _ref.shouldRenderToParent, inShouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldDisableFoc = _ref.shouldDisableFocusLock, shouldDisableFocusLock = _ref$shouldDisableFoc === void 0 ? false : _ref$shouldDisableFoc, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport;
    var _useState = (0, $91i6m.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), triggerRef = _useState2[0], setTriggerRef = _useState2[1];
    var getMergedTriggerRef = (0, $lSMAo.useGetMemoizedMergedTriggerRef)();
    var getMergedTriggerRefNew = (0, $ctRH8.useGetMemoizedMergedTriggerRefNew)();
    var generatedId = (0, $4ledg.useId)();
    var _usePopupAppearance = (0, $3AtxU.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    }), appearance = _usePopupAppearance.appearance, shouldRenderToParent = _usePopupAppearance.shouldRenderToParent;
    var id = providedId || generatedId;
    var handleOpenLayerObserverCloseSignal = (0, $91i6m.useCallback)(function() {
        onClose === null || onClose === void 0 || onClose(null);
    }, [
        onClose
    ]);
    (0, $1tlvt.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal
    });
    var renderPopperWrapper = /*#__PURE__*/ $91i6m.createElement((0, $aHMp1.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ $91i6m.createElement((0, $bmnyL.default), {
        xcss: xcss,
        appearance: appearance,
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
        shouldFitContainer: shouldFitContainer,
        shouldDisableFocusLock: shouldDisableFocusLock,
        shouldReturnFocus: shouldReturnFocus,
        triggerRef: triggerRef,
        strategy: shouldFitContainer ? 'absolute' : strategy,
        role: role,
        label: label,
        titleId: titleId,
        modifiers: modifiers,
        shouldFitViewport: shouldFitViewport
    }));
    var popupContent = /*#__PURE__*/ $91i6m.createElement((0, $8z7c3.Manager), null, /*#__PURE__*/ $91i6m.createElement((0, $6Xy2r.Reference), null, function(_ref2) {
        var ref = _ref2.ref;
        return trigger({
            ref: !(0, $f1k1y.fg)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
            'aria-controls': isOpen ? id : undefined,
            'aria-expanded': isOpen,
            'aria-haspopup': role === 'dialog' && (0, $f1k1y.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
        });
    }), isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ $91i6m.createElement((0, $lLIDD.default), {
        zIndex: zIndex
    }, renderPopperWrapper)));
    if (shouldFitContainer) return /*#__PURE__*/ $91i6m.createElement((0, $aDWwl.default), {
        xcss: $fd33af4daa0cc030$var$wrapperStyles.root
    }, popupContent);
    return popupContent;
});

});
parcelRegister("4ledg", function(module, exports) {

$parcel$export(module.exports, "useId", function () { return $329425f8656e1344$export$f680877a34711e37; });

var $61RDg = parcelRequire("61RDg");

var $91i6m = parcelRequire("91i6m");

var $aTAfv = parcelRequire("aTAfv");

var $f1k1y = parcelRequire("f1k1y");
var $329425f8656e1344$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $329425f8656e1344$var$react18UseId = ($329425f8656e1344$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).useId) !== null && $329425f8656e1344$var$_React$useId !== void 0 ? $329425f8656e1344$var$_React$useId : undefined;
function $329425f8656e1344$export$f680877a34711e37() {
    if ($329425f8656e1344$var$react18UseId && (0, $f1k1y.fg)('platform-dst-react-18-use-id')) return $329425f8656e1344$var$react18UseId();
    return "uid".concat((0, $aTAfv.useUID)());
}
var $329425f8656e1344$export$6be90bcb437e928f = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($329425f8656e1344$export$f680877a34711e37()).concat(postfix);
    (0, $91i6m.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $329425f8656e1344$export$6ee17796e3d70de2() {
    if ($329425f8656e1344$var$react18UseId && (0, $f1k1y.fg)('platform-dst-react-18-use-id')) {
        var uid = $329425f8656e1344$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $aTAfv.useUIDSeed)();
}

});

parcelRegister("aHMp1", function(module, exports) {

$parcel$export(module.exports, "LevelContext", function () { return $7cb37746392bcf3b$export$650d12d3c2ddb8fc; });
$parcel$export(module.exports, "LevelNodeContext", function () { return $7cb37746392bcf3b$export$18f4d8b5b3a77f59; });
$parcel$export(module.exports, "RootNodeContext", function () { return $7cb37746392bcf3b$export$fa973f110e8f6ca8; });
$parcel$export(module.exports, "TopLevelContext", function () { return $7cb37746392bcf3b$export$48b383b280e20440; });
$parcel$export(module.exports, "Layering", function () { return $7cb37746392bcf3b$export$7c885f891c940977; });

var $91i6m = parcelRequire("91i6m");

var $eY7E1 = parcelRequire("eY7E1");

var $koCln = parcelRequire("koCln");

var $6YoNT = parcelRequire("6YoNT");
var $7cb37746392bcf3b$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $91i6m.createContext)(0);
var $7cb37746392bcf3b$export$18f4d8b5b3a77f59 = /*#__PURE__*/ (0, $91i6m.createContext)({
    current: null
});
var $7cb37746392bcf3b$export$fa973f110e8f6ca8 = /*#__PURE__*/ (0, $91i6m.createContext)({
    current: null
});
var $7cb37746392bcf3b$export$48b383b280e20440 = /*#__PURE__*/ (0, $91i6m.createContext)({
    topLevelRef: {
        current: null
    },
    layerList: {
        current: null
    },
    setTopLevel: (0, $eY7E1.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $7cb37746392bcf3b$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel, levelNode = _ref.node;
    (0, $91i6m.useEffect)(function() {
        var levelNodeSafe = levelNode.current;
        var parentNode = levelNodeSafe.parent;
        parentNode === null || parentNode === void 0 || parentNode.addChild(levelNodeSafe);
        return function() {
            parentNode === null || parentNode === void 0 || parentNode.removeChild(levelNodeSafe);
        };
    }, [
        levelNode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($7cb37746392bcf3b$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($7cb37746392bcf3b$export$18f4d8b5b3a77f59.Provider, {
        value: levelNode
    }, children));
};
/**
 *
 *  @internal @deprecated
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $7cb37746392bcf3b$var$LevelProviderOld = function LevelProviderOld(_ref2) {
    var children = _ref2.children, currentLevel = _ref2.currentLevel;
    var _useContext = (0, $91i6m.useContext)($7cb37746392bcf3b$export$48b383b280e20440), layerList = _useContext.layerList;
    // This is not unstable, it will run once for ref creation.
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var id = (0, $91i6m.useRef)(Math.random().toString(36));
    (0, $91i6m.useEffect)(function() {
        var safeLayerList = layerList === null || layerList === void 0 ? void 0 : layerList.current;
        var safeId = id.current;
        if (!safeLayerList) return;
        safeLayerList.push(safeId);
        return function() {
            var index = safeLayerList.indexOf(safeId);
            if (index > -1) safeLayerList.splice(index, 1);
        };
    }, [
        layerList,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($7cb37746392bcf3b$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal @deprecated
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $7cb37746392bcf3b$var$LayeringProvider = function LayeringProvider(_ref3) {
    var children = _ref3.children;
    var topLevelRef = (0, $91i6m.useRef)(0);
    var layerList = (0, $91i6m.useRef)([]);
    var value = (0, $91i6m.useMemo)(function() {
        return {
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            },
            layerList: layerList
        };
    }, [
        topLevelRef,
        layerList
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($7cb37746392bcf3b$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
/**
 *
 * @deprecated
 * @important the component is toggled by isDisabled props, the default isDisabled is true
 *
 * Layering component is a wrapper to let children to consume layer contexts and hooks.
 *
 */ var $7cb37746392bcf3b$var$LayeringOld = function LayeringOld(_ref4) {
    var children = _ref4.children, _ref4$isDisabled = _ref4.isDisabled, isDisabled = _ref4$isDisabled === void 0 ? true : _ref4$isDisabled;
    var currentLevel = (0, $91i6m.useContext)($7cb37746392bcf3b$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($7cb37746392bcf3b$var$LevelProviderOld, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($7cb37746392bcf3b$var$LayeringProvider, null, content);
};
/**
 *
 * @important the component is toggled by isDisabled props, the default isDisabled is true
 *
 * Layering component is a wrapper to let children to consume layer contexts and hooks.
 *
 */ var $7cb37746392bcf3b$var$LayeringNew = function LayeringNew(_ref5) {
    var children = _ref5.children, _ref5$isDisabled = _ref5.isDisabled, isDisabled = _ref5$isDisabled === void 0 ? true : _ref5$isDisabled;
    var currentLevel = (0, $91i6m.useContext)($7cb37746392bcf3b$export$650d12d3c2ddb8fc);
    var parentNode = (0, $91i6m.useContext)($7cb37746392bcf3b$export$18f4d8b5b3a77f59);
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var newNode = (0, $91i6m.useRef)(new (0, $6YoNT.LayerNode)(Math.random().toString(36), parentNode.current));
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($7cb37746392bcf3b$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        node: newNode
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($7cb37746392bcf3b$export$fa973f110e8f6ca8.Provider, {
        value: newNode
    }, content);
};
var $7cb37746392bcf3b$export$7c885f891c940977 = (0, $koCln.componentWithFG)('layering-tree-graph', $7cb37746392bcf3b$var$LayeringNew, $7cb37746392bcf3b$var$LayeringOld);

});
parcelRegister("eY7E1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae5c9950a3a8d6d5$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $ae5c9950a3a8d6d5$export$2e2bcd8739ae039() {}

});

parcelRegister("koCln", function(module, exports) {

$parcel$export(module.exports, "componentWithFG", function () { return $ed93cacbfc655eb3$export$cf56d0f54cfcce4; });

var $f1k1y = parcelRequire("f1k1y");

var $kPu6V = parcelRequire("kPu6V");
var $ed93cacbfc655eb3$export$cf56d0f54cfcce4 = function componentWithFG(featureFlagName, ComponentTrue, ComponentFalse) {
    return (0, $kPu6V.componentWithCondition)(function() {
        return (0, $f1k1y.fg)(featureFlagName);
    }, ComponentTrue, ComponentFalse);
};

});
parcelRegister("kPu6V", function(module, exports) {

$parcel$export(module.exports, "componentWithCondition", function () { return $f29fed6ccfa16b24$export$6e8ea24b15199873; });

var $cIDQN = parcelRequire("cIDQN");

var $91i6m = parcelRequire("91i6m");
function $f29fed6ccfa16b24$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    var ComponentWithCondition = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(props, ref) {
        return condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(ComponentTrue, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, props, {
            ref: ref
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(ComponentFalse, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, props, {
            ref: ref
        }));
    });
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = "ComponentWithCondition[".concat(condition.name, "]");
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}

});


parcelRegister("6YoNT", function(module, exports) {

$parcel$export(module.exports, "LayerNode", function () { return $513b96292d74264d$export$da4f61fd78d35243; });

var $iqLBO = parcelRequire("iqLBO");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");
var $513b96292d74264d$export$da4f61fd78d35243 = /*#__PURE__*/ function() {
    function LayerNode(id, parent) {
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, LayerNode);
        this.id = id;
        this.childNodes = [];
        this.parent = parent;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(LayerNode, [
        {
            key: "addChild",
            value: function addChild(node) {
                this.childNodes.push(node);
            }
        },
        {
            key: "removeChild",
            value: function removeChild(node) {
                this.childNodes = this.childNodes.filter(function(child) {
                    return child.id !== node.id;
                });
            }
        },
        {
            key: "getLevel",
            value: function getLevel() {
                if (!this.parent) return 1;
                return this.parent.getLevel() + 1;
            }
        },
        {
            key: "getHeight",
            value: function getHeight() {
                if (this.childNodes.length === 0) return 1;
                return Math.max.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(this.childNodes.map(function(child) {
                    return child.getHeight();
                }))) + 1;
            }
        }
    ]);
}();

});


parcelRegister("6Xy2r", function(module, exports) {

$parcel$export(module.exports, "Reference", function () { return $5112a8195f7745b7$export$e0be378c32fb70a7; });

var $91i6m = parcelRequire("91i6m");

var $2A9c9 = parcelRequire("2A9c9");

var $8z7c3 = parcelRequire("8z7c3");

var $ippcL = parcelRequire("ippcL");
function $5112a8195f7745b7$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $91i6m.useContext((0, $8z7c3.ManagerReferenceNodeSetterContext));
    var refHandler = $91i6m.useCallback(function(node) {
        (0, $ippcL.setRef)(innerRef, node);
        (0, $ippcL.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $91i6m.useEffect(function() {
        return function() {
            return (0, $ippcL.setRef)(innerRef, null);
        };
    }, []);
    $91i6m.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($2A9c9)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $ippcL.unwrapArray)(children)({
        ref: refHandler
    });
}

});
parcelRegister("2A9c9", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $1e16137e251b5c4c$var$__DEV__ = false;
var $1e16137e251b5c4c$var$warning = function() {};
if ($1e16137e251b5c4c$var$__DEV__) {
    var $1e16137e251b5c4c$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $1e16137e251b5c4c$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $1e16137e251b5c4c$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $1e16137e251b5c4c$var$warning;

});


parcelRegister("bmnyL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84540643c14daab6$export$2e2bcd8739ae039; });
/* popper-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iqLBO = parcelRequire("iqLBO");

var $5YM7L = parcelRequire("5YM7L");

var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $5MIvA = parcelRequire("5MIvA");

var $f1k1y = parcelRequire("f1k1y");

var $fFuU3 = parcelRequire("fFuU3");

var $gjyA0 = parcelRequire("gjyA0");

var $3hR9h = parcelRequire("3hR9h");

var $6IApn = parcelRequire("6IApn");
var $84540643c14daab6$var$_excluded = [
    "shouldRenderToParent",
    "shouldFitContainer",
    "children",
    "appearance",
    "className",
    "isReferenceHidden"
];
var $84540643c14daab6$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
var $84540643c14daab6$var$fullWidthStyles = null;
var $84540643c14daab6$var$wrapperStyles = {
    root: "_2rkoglpi _1e0c1ule _vchhusvi _1pby1nn1 _bfhk1bhr _16qs1cd0 _syaz1fxt _1q1l1bhr _nt751r31 _49pcglyw _1hvw1o36"
};
var $84540643c14daab6$var$scrollableStyles = null;
var $84540643c14daab6$var$blanketStyles = null;
var $84540643c14daab6$var$modalStyles = null;
var $84540643c14daab6$var$focusRingStyles = {
    root: "_mizu194a _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y"
};
var $84540643c14daab6$var$DefaultPopupComponent = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(props, ref) {
    var shouldRenderToParent = props.shouldRenderToParent, shouldFitContainer = props.shouldFitContainer, children = props.children, appearance = props.appearance, className = props.className, isReferenceHidden = props.isReferenceHidden, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(props, $84540643c14daab6$var$_excluded);
    return /*#__PURE__*/ $91i6m.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9gzWK.default)([
            $84540643c14daab6$var$wrapperStyles.root,
            appearance === 'UNSAFE_modal-below-sm' && "_dk5d1b66 _c71ldtre _kqsw1n9t _152t1b66",
            !shouldRenderToParent && "_1reo1wug _18m91wug",
            shouldFitContainer && "_1bsb1osq",
            className
        ])
    }, htmlAttributes, {
        ref: ref
    }), children);
});
function $84540643c14daab6$var$PopperWrapper(_ref) {
    var xcss = _ref.xcss, isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, content = _ref.content, fallbackPlacements = _ref.fallbackPlacements, onClose = _ref.onClose, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, shouldFlip = _ref.shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, _ref$popupComponent = _ref.popupComponent, PopupContainer = _ref$popupComponent === void 0 ? $84540643c14daab6$var$DefaultPopupComponent : _ref$popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, triggerRef = _ref.triggerRef, shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, shouldRenderToParent = _ref.shouldRenderToParent, shouldFitContainer = _ref.shouldFitContainer, shouldDisableFocusLock = _ref.shouldDisableFocusLock, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance;
    var _useState = (0, $91i6m.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), popupRef = _useState2[0], setPopupRef = _useState2[1];
    var _useState3 = (0, $91i6m.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState3, 2), initialFocusRef = _useState4[0], setInitialFocusRef = _useState4[1];
    // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    var shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    var shouldDisableFocusTrap = role !== 'dialog';
    (0, $6IApn.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $3hR9h.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    var _useLayering = (0, $5MIvA.useLayering)(), currentLevel = _useLayering.currentLevel;
    var mergedModifiers = (0, $91i6m.useMemo)(function() {
        return [
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(modifiers || []));
    }, [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return /*#__PURE__*/ $91i6m.createElement((0, $fFuU3.Popper), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style, placement = _ref2.placement, update = _ref2.update, isReferenceHidden = _ref2.isReferenceHidden;
        var popupContainer = /*#__PURE__*/ $91i6m.createElement(PopupContainer, {
            className: (0, $9gzWK.default)([
                xcss,
                // @ts-expect-error: `ax` is not typed correctly
                !initialFocusRef && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $f1k1y.fg)('platform-design-system-apply-popup-wrapper-focus') && $84540643c14daab6$var$focusRingStyles.root
            ]),
            appearance: appearance,
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            role: role,
            "aria-label": label,
            "aria-labelledby": titleId,
            ref: function ref(node) {
                if (node) {
                    if (typeof _ref3 === 'function') _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            },
            style: appearance === 'UNSAFE_modal-below-sm' ? {} : style,
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent,
            shouldFitContainer: shouldFitContainer,
            isReferenceHidden: isReferenceHidden
        }, /*#__PURE__*/ $91i6m.createElement((0, $gjyA0.RepositionOnUpdate), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
        return /*#__PURE__*/ $91i6m.createElement((0, $91i6m.Fragment), null, popupContainer, appearance === 'UNSAFE_modal-below-sm' && /*#__PURE__*/ $91i6m.createElement("div", {
            className: (0, $9gzWK.default)([
                "_1r04idpf _kqsw1n9t _bfhk10xm"
            ])
        }));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$84540643c14daab6$export$2e2bcd8739ae039 = $84540643c14daab6$var$PopperWrapper;

});
parcelRegister("5MIvA", function(module, exports) {

$parcel$export(module.exports, "useCloseOnEscapePress", function () { return $4363f5e15a9d7fc8$export$4a4bf067ea9e7886; });
$parcel$export(module.exports, "useLayering", function () { return $4363f5e15a9d7fc8$export$c8b4d54e03dee6ed; });

var $91i6m = parcelRequire("91i6m");

var $aA6j8 = parcelRequire("aA6j8");

var $f1k1y = parcelRequire("f1k1y");

var $aHMp1 = parcelRequire("aHMp1");
var $4363f5e15a9d7fc8$var$ESCAPE = 'Escape';
function $4363f5e15a9d7fc8$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $91i6m.useRef)(false);
    var _useLayering = $4363f5e15a9d7fc8$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $91i6m.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $4363f5e15a9d7fc8$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $91i6m.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $91i6m.useEffect)(function() {
        return (0, $aA6j8.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $4363f5e15a9d7fc8$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $91i6m.useContext)((0, $aHMp1.LevelContext));
    // Remove TopLevelContext on FG cleanup layering-tree-graph
    var _useContext = (0, $91i6m.useContext)((0, $aHMp1.TopLevelContext)), topLevelRef = _useContext.topLevelRef, layerList = _useContext.layerList;
    var layerNode;
    var rootNode;
    if ((0, $f1k1y.fg)('layering-tree-graph')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        layerNode = (0, $91i6m.useContext)((0, $aHMp1.LevelNodeContext));
        // eslint-disable-next-line react-hooks/rules-of-hooks
        rootNode = (0, $91i6m.useContext)((0, $aHMp1.RootNodeContext));
    }
    var isLayerDisabled = (0, $91i6m.useCallback)(function() {
        var _layerList$current$le, _layerList$current;
        if ((0, $f1k1y.fg)('layering-tree-graph')) {
            var _layerNode, _rootNode;
            // This is an impossible case, added for type safety
            if (!((_layerNode = layerNode) !== null && _layerNode !== void 0 && _layerNode.current) || !((_rootNode = rootNode) !== null && _rootNode !== void 0 && _rootNode.current)) return false;
            return layerNode.current.getLevel() < rootNode.current.getHeight();
        }
        return ((_layerList$current$le = layerList === null || layerList === void 0 || (_layerList$current = layerList.current) === null || _layerList$current === void 0 ? void 0 : _layerList$current.length) !== null && _layerList$current$le !== void 0 ? _layerList$current$le : 0) !== currentLevel;
    }, [
        currentLevel,
        layerList,
        layerNode,
        rootNode
    ]);
    var getTopLevel = (0, $91i6m.useCallback)(function() {
        var _rootNode2;
        return (_rootNode2 = rootNode) !== null && _rootNode2 !== void 0 && _rootNode2.current ? rootNode.current.getHeight() : null;
    }, [
        rootNode
    ]);
    return (0, $f1k1y.fg)('layering-tree-graph') ? {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    } : {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled,
        layerList: layerList
    };
}

});

parcelRegister("gjyA0", function(module, exports) {

$parcel$export(module.exports, "RepositionOnUpdate", function () { return $be093e7b7bfa74a9$export$51eddd7655ca235a; });

var $91i6m = parcelRequire("91i6m");
var $be093e7b7bfa74a9$export$51eddd7655ca235a = function RepositionOnUpdate(_ref) {
    var children = _ref.children, update = _ref.update;
    // Ref used here to skip update on first render (when refs haven't been set)
    var isFirstRenderRef = (0, $91i6m.useRef)(true);
    (0, $91i6m.useLayoutEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $91i6m.Fragment), null, children);
};

});

parcelRegister("3hR9h", function(module, exports) {

$parcel$export(module.exports, "useCloseManager", function () { return $264c2fd50c35d476$export$92dae2778ae88f9d; });

var $91i6m = parcelRequire("91i6m");

var $aA6j8 = parcelRequire("aA6j8");

var $1HZHn = parcelRequire("1HZHn");

var $5MIvA = parcelRequire("5MIvA");

var $f1k1y = parcelRequire("f1k1y");

var $23R5F = parcelRequire("23R5F");

var $etBPc = parcelRequire("etBPc");
var $264c2fd50c35d476$export$92dae2778ae88f9d = function useCloseManager(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, capture = _ref.shouldUseCaptureOnOutsideClick, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useLayering = (0, $5MIvA.useLayering)(), isLayerDisabled = _useLayering.isLayerDisabled, currentLevel = _useLayering.currentLevel;
    var _useAnimationFrame = (0, $etBPc.useAnimationFrame)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    (0, $91i6m.useEffect)(function() {
        if (!isOpen || !popupRef) return 0, $1HZHn.default;
        var inIframe = window && window.self !== window.top && (0, $f1k1y.fg)('fix-dropdown-close-outside-iframe');
        var closePopup = function closePopup(event) {
            if (onClose) {
                var _currentLevel = null;
                if (event.target instanceof HTMLElement) {
                    var _event$target$closest;
                    _currentLevel = (_event$target$closest = event.target.closest("[data-ds--level]")) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.getAttribute('data-ds--level');
                }
                _currentLevel ? onClose(event, Number(_currentLevel)) : onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $f1k1y.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(function() {
                triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        var onClick = function onClick(event) {
            var target = event.target;
            var doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist && !inIframe) return;
            if (isLayerDisabled()) {
                if (target instanceof HTMLElement) {
                    var _target$closest;
                    var layeredElement = (_target$closest = target.closest) === null || _target$closest === void 0 ? void 0 : _target$closest.call(target, "[data-ds--level]");
                    if (layeredElement) {
                        var closeType = layeredElement.getAttribute('[data-ds--close--type]');
                        if (closeType === 'single') // if the close type is single, we won't close other disabled layers when clicking outside
                        return;
                        var levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                        if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // won't trigger onClick event when we click in a higher layer.
                        return;
                    }
                }
            }
            var isClickOnPopup = popupRef && popupRef.contains(target);
            var isClickOnTrigger = triggerRef && triggerRef.contains(target);
            if (!isClickOnPopup && !isClickOnTrigger) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $23R5F.isInteractiveElement)(document.activeElement) && (0, $f1k1y.fg)('platform_dst_popup-disable-focuslock')) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
            }
        };
        var onKeyDown = function onKeyDown(event) {
            if ((0, $f1k1y.fg)('platform_dst_popup-disable-focuslock')) {
                var key = event.key, shiftKey = event.shiftKey;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(function() {
                        var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    var _document$activeEleme;
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && (_document$activeEleme = document.activeElement) !== null && _document$activeEleme !== void 0 && _document$activeEleme.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(function() {
                            var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(function() {
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                var _key = event.key;
                if (_key === 'Escape' || _key === 'Esc' || shouldCloseOnTab && _key === 'Tab') closePopup(event);
            }
        };
        var parentUnbind;
        // if the popup is inside iframe, we want to listen to click events outside iframe,
        // to close the popup correctly in the iframe.
        if (inIframe && isOpen) parentUnbind = (0, $aA6j8.bind)(window.parent.window, {
            type: 'click',
            listener: onClick,
            options: {
                capture: capture
            }
        });
        var unbind = (0, $1HZHn.default);
        if ((0, $f1k1y.fg)('popup-onclose-fix')) setTimeout(function() {
            unbind = (0, $aA6j8.bindAll)(window, [
                {
                    type: 'click',
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: 'keydown',
                    listener: onKeyDown
                }
            ]);
        }, 0);
        else unbind = (0, $aA6j8.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        var unbindBlur = (0, $1HZHn.default);
        unbindBlur = (0, $aA6j8.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return function() {
            var _parentUnbind;
            if ((0, $f1k1y.fg)('popup-onclose-fix')) setTimeout(function() {
                unbind();
            }, 0);
            else unbind();
            cancelAllFrames();
            (_parentUnbind = parentUnbind) === null || _parentUnbind === void 0 || _parentUnbind();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};

});
parcelRegister("1HZHn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13e9aaa9f7e59eec$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $13e9aaa9f7e59eec$export$2e2bcd8739ae039() {}

});

parcelRegister("23R5F", function(module, exports) {

$parcel$export(module.exports, "isInteractiveElement", function () { return $18050b3923bc4871$export$3dee5e4542c672d9; });
var $18050b3923bc4871$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
var $18050b3923bc4871$export$3dee5e4542c672d9 = function isInteractiveElement(element) {
    if ($18050b3923bc4871$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};

});

parcelRegister("etBPc", function(module, exports) {

$parcel$export(module.exports, "useAnimationFrame", function () { return $a8a11d54e9cf427f$export$641fa9c94086b46e; });

var $91i6m = parcelRequire("91i6m");
var $a8a11d54e9cf427f$export$641fa9c94086b46e = function useAnimationFrame() {
    var animationsRef = (0, $91i6m.useRef)([]);
    var requestFrame = (0, $91i6m.useCallback)(function(callback) {
        var id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    var cancelFrame = (0, $91i6m.useCallback)(function(id) {
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter(function(frameId) {
            return frameId !== id;
        });
    }, []);
    var cancelAllFrames = (0, $91i6m.useCallback)(function() {
        animationsRef.current.forEach(function(id) {
            return cancelAnimationFrame(id);
        });
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};

});


parcelRegister("6IApn", function(module, exports) {

$parcel$export(module.exports, "useFocusManager", function () { return $4e43180dca3fc0ac$export$10c5169755ce7bd7; });

var $91i6m = parcelRequire("91i6m");

var $duII1 = parcelRequire("duII1");

var $1HZHn = parcelRequire("1HZHn");

var $5MIvA = parcelRequire("5MIvA");

var $f1k1y = parcelRequire("f1k1y");

var $etBPc = parcelRequire("etBPc");
var $4e43180dca3fc0ac$export$10c5169755ce7bd7 = function useFocusManager(_ref) {
    var initialFocusRef = _ref.initialFocusRef, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, shouldReturnFocus = _ref.shouldReturnFocus, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useAnimationFrame = (0, $etBPc.useAnimationFrame)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var _useLayering = (0, $5MIvA.useLayering)(), currentLevel = _useLayering.currentLevel;
    (0, $91i6m.useEffect)(function() {
        if (!popupRef || shouldCloseOnTab) return 0, $1HZHn.default;
        if (shouldDisableFocusTrap && (0, $f1k1y.fg)('platform_dst_popup-disable-focuslock')) {
            var isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            var popups = document.querySelectorAll("[data-ds--level=\"".concat(currentLevel - 1, "\"]"));
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(function() {
                    triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $1HZHn.default;
            }
        }
        var trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        var focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($duII1)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(function() {
            focusTrap.activate();
        });
        return function() {
            cancelAllFrames();
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};

});
parcelRegister("duII1", function(module, exports) {

var $9D9Di = parcelRequire("9D9Di");
var $9d30c1fdded6390a$var$listeningFocusTrap = null;
function $9d30c1fdded6390a$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === 'string' ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $9d30c1fdded6390a$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($9d30c1fdded6390a$var$listeningFocusTrap) $9d30c1fdded6390a$var$listeningFocusTrap.pause();
        $9d30c1fdded6390a$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        // Ensure that the focused element doesn't capture the event that caused the focus trap activation
        setTimeout(function() {
            $9d30c1fdded6390a$var$tryFocus(firstFocusNode());
        }, 0);
        document.addEventListener('focus', checkFocus, true);
        document.addEventListener('click', checkClick, true);
        document.addEventListener('mousedown', checkPointerDown, true);
        document.addEventListener('touchstart', checkPointerDown, true);
        document.addEventListener('keydown', checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $9d30c1fdded6390a$var$listeningFocusTrap !== trap) return;
        document.removeEventListener('focus', checkFocus, true);
        document.removeEventListener('click', checkClick, true);
        document.removeEventListener('mousedown', checkPointerDown, true);
        document.removeEventListener('touchstart', checkPointerDown, true);
        document.removeEventListener('keydown', checkKey, true);
        $9d30c1fdded6390a$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === 'string') {
            node = document.querySelector(optionValue);
            if (!node) throw new Error('`' + optionName + '` refers to no known node');
        }
        if (typeof optionValue === 'function') {
            node = optionValue();
            if (!node) throw new Error('`' + optionName + '` did not return a node');
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption('initialFocus') !== null) node = getNodeForOption('initialFocus');
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption('fallbackFocus');
        if (!node) throw new Error('You can\'t have a focus-trap without at least one focusable element');
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === 'function') e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === 'Tab' || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $9d30c1fdded6390a$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute('tabindex') && Number(e.target.getAttribute('tabindex')) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $9d30c1fdded6390a$var$tryFocus(lastTabbableNode);
            return $9d30c1fdded6390a$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $9d30c1fdded6390a$var$tryFocus(firstTabbableNode);
        $9d30c1fdded6390a$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $9D9Di(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $9d30c1fdded6390a$var$tryFocus(lastTabbableNode);
        $9d30c1fdded6390a$var$tryFocus(firstTabbableNode);
    }
}
function $9d30c1fdded6390a$var$isEscapeEvent(e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}
function $9d30c1fdded6390a$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === 'input') node.select();
}
module.exports = $9d30c1fdded6390a$var$focusTrap;

});
parcelRegister("9D9Di", function(module, exports) {
module.exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $702f3a75803cd412$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        'input',
        'select',
        'a[href]',
        'textarea',
        'button',
        '[tabindex]'
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(','));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === 'INPUT' && candidate.type === 'hidden' || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $702f3a75803cd412$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === 'none') result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === 'hidden';
    };
}

});




parcelRegister("3AtxU", function(module, exports) {

$parcel$export(module.exports, "usePopupAppearance", function () { return $29cba712bf4acf02$export$4065aef1d79a5730; });

var $5YM7L = parcelRequire("5YM7L");

var $91i6m = parcelRequire("91i6m");

var $c3ipX = parcelRequire("c3ipX");
function $29cba712bf4acf02$export$4065aef1d79a5730(_ref) {
    var _appearance = _ref.appearance, _shouldRenderToParent = _ref.shouldRenderToParent;
    var mq = (0, $c3ipX.UNSAFE_useMediaQuery)('below.sm', function(e) {
        setIsSmallViewport(!!e.matches);
    });
    var _useState = (0, $91i6m.useState)(!!(mq !== null && mq !== void 0 && mq.matches)), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), isSmallViewport = _useState2[0], setIsSmallViewport = _useState2[1];
    var appearance = _appearance === 'UNSAFE_modal-below-sm' && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    var shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}

});
parcelRegister("c3ipX", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useMediaQuery", function () { return $8c640d375badba67$export$49e55ae2c03d6045; });

var $91i6m = parcelRequire("91i6m");

var $aA6j8 = parcelRequire("aA6j8");

var $9wl70 = parcelRequire("9wl70");
var $8c640d375badba67$var$_window, $8c640d375badba67$var$_window$matchMedia, $8c640d375badba67$var$_window2, $8c640d375badba67$var$_window2$matchMedia, $8c640d375badba67$var$_window3, $8c640d375badba67$var$_window3$matchMedia, $8c640d375badba67$var$_window4, $8c640d375badba67$var$_window4$matchMedia, $8c640d375badba67$var$_window5, $8c640d375badba67$var$_window5$matchMedia, $8c640d375badba67$var$_window6, $8c640d375badba67$var$_window6$matchMedia, $8c640d375badba67$var$_window7, $8c640d375badba67$var$_window7$matchMedia, $8c640d375badba67$var$_window8, $8c640d375badba67$var$_window8$matchMedia, $8c640d375badba67$var$_window9, $8c640d375badba67$var$_window9$matchMedia, $8c640d375badba67$var$_window0, $8c640d375badba67$var$_window0$matchMedia, $8c640d375badba67$var$_window1, $8c640d375badba67$var$_window1$matchMedia;
var $8c640d375badba67$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : ($8c640d375badba67$var$_window = window) === null || $8c640d375badba67$var$_window === void 0 || ($8c640d375badba67$var$_window$matchMedia = $8c640d375badba67$var$_window.matchMedia) === null || $8c640d375badba67$var$_window$matchMedia === void 0 ? void 0 : $8c640d375badba67$var$_window$matchMedia.call($8c640d375badba67$var$_window, (0, $9wl70.media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : ($8c640d375badba67$var$_window2 = window) === null || $8c640d375badba67$var$_window2 === void 0 || ($8c640d375badba67$var$_window2$matchMedia = $8c640d375badba67$var$_window2.matchMedia) === null || $8c640d375badba67$var$_window2$matchMedia === void 0 ? void 0 : $8c640d375badba67$var$_window2$matchMedia.call($8c640d375badba67$var$_window2, (0, $9wl70.media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : ($8c640d375badba67$var$_window3 = window) === null || $8c640d375badba67$var$_window3 === void 0 || ($8c640d375badba67$var$_window3$matchMedia = $8c640d375badba67$var$_window3.matchMedia) === null || $8c640d375badba67$var$_window3$matchMedia === void 0 ? void 0 : $8c640d375badba67$var$_window3$matchMedia.call($8c640d375badba67$var$_window3, (0, $9wl70.media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : ($8c640d375badba67$var$_window4 = window) === null || $8c640d375badba67$var$_window4 === void 0 || ($8c640d375badba67$var$_window4$matchMedia = $8c640d375badba67$var$_window4.matchMedia) === null || $8c640d375badba67$var$_window4$matchMedia === void 0 ? void 0 : $8c640d375badba67$var$_window4$matchMedia.call($8c640d375badba67$var$_window4, (0, $9wl70.media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : ($8c640d375badba67$var$_window5 = window) === null || $8c640d375badba67$var$_window5 === void 0 || ($8c640d375badba67$var$_window5$matchMedia = $8c640d375badba67$var$_window5.matchMedia) === null || $8c640d375badba67$var$_window5$matchMedia === void 0 ? void 0 : $8c640d375badba67$var$_window5$matchMedia.call($8c640d375badba67$var$_window5, (0, $9wl70.media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : ($8c640d375badba67$var$_window6 = window) === null || $8c640d375badba67$var$_window6 === void 0 || ($8c640d375badba67$var$_window6$matchMedia = $8c640d375badba67$var$_window6.matchMedia) === null || $8c640d375badba67$var$_window6$matchMedia === void 0 ? void 0 : $8c640d375badba67$var$_window6$matchMedia.call($8c640d375badba67$var$_window6, (0, $9wl70.media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : ($8c640d375badba67$var$_window7 = window) === null || $8c640d375badba67$var$_window7 === void 0 || ($8c640d375badba67$var$_window7$matchMedia = $8c640d375badba67$var$_window7.matchMedia) === null || $8c640d375badba67$var$_window7$matchMedia === void 0 ? void 0 : $8c640d375badba67$var$_window7$matchMedia.call($8c640d375badba67$var$_window7, (0, $9wl70.media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : ($8c640d375badba67$var$_window8 = window) === null || $8c640d375badba67$var$_window8 === void 0 || ($8c640d375badba67$var$_window8$matchMedia = $8c640d375badba67$var$_window8.matchMedia) === null || $8c640d375badba67$var$_window8$matchMedia === void 0 ? void 0 : $8c640d375badba67$var$_window8$matchMedia.call($8c640d375badba67$var$_window8, (0, $9wl70.media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : ($8c640d375badba67$var$_window9 = window) === null || $8c640d375badba67$var$_window9 === void 0 || ($8c640d375badba67$var$_window9$matchMedia = $8c640d375badba67$var$_window9.matchMedia) === null || $8c640d375badba67$var$_window9$matchMedia === void 0 ? void 0 : $8c640d375badba67$var$_window9$matchMedia.call($8c640d375badba67$var$_window9, (0, $9wl70.media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : ($8c640d375badba67$var$_window0 = window) === null || $8c640d375badba67$var$_window0 === void 0 || ($8c640d375badba67$var$_window0$matchMedia = $8c640d375badba67$var$_window0.matchMedia) === null || $8c640d375badba67$var$_window0$matchMedia === void 0 ? void 0 : $8c640d375badba67$var$_window0$matchMedia.call($8c640d375badba67$var$_window0, (0, $9wl70.media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : ($8c640d375badba67$var$_window1 = window) === null || $8c640d375badba67$var$_window1 === void 0 || ($8c640d375badba67$var$_window1$matchMedia = $8c640d375badba67$var$_window1.matchMedia) === null || $8c640d375badba67$var$_window1$matchMedia === void 0 ? void 0 : $8c640d375badba67$var$_window1$matchMedia.call($8c640d375badba67$var$_window1, (0, $9wl70.media).below.xl.replace('@media ', '').trim())
};
var $8c640d375badba67$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $91i6m.useRef)(listener);
    (0, $91i6m.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $8c640d375badba67$var$queries[queryString];
    (0, $91i6m.useLayoutEffect)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $aA6j8.bind)(mq, {
            type: 'change',
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});


parcelRegister("lSMAo", function(module, exports) {

$parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", function () { return $fee454444c0c36ff$export$7cc5c058dd769dff; });

var $5YM7L = parcelRequire("5YM7L");

var $91i6m = parcelRequire("91i6m");

var $79CCE = parcelRequire("79CCE");
var $fee454444c0c36ff$export$7cc5c058dd769dff = function useGetMemoizedMergedTriggerRef() {
    var _useState = (0, $91i6m.useState)(function() {
        return (0, $79CCE.default)(function(ref, setTriggerRef, isOpen) {
            return function(node) {
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 1), getMemoizedMergedTriggerRef = _useState2[0];
    return getMemoizedMergedTriggerRef;
};

});

parcelRegister("ctRH8", function(module, exports) {

$parcel$export(module.exports, "useGetMemoizedMergedTriggerRefNew", function () { return $9161d81f41c07238$export$5d3a2de79e07b376; });

var $5YM7L = parcelRequire("5YM7L");

var $91i6m = parcelRequire("91i6m");

var $79CCE = parcelRequire("79CCE");
var $9161d81f41c07238$export$5d3a2de79e07b376 = function useGetMemoizedMergedTriggerRefNew() {
    var _useState = (0, $91i6m.useState)(function() {
        return (0, $79CCE.default)(function(ref, setTriggerRef) {
            return function(node) {
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 1), getMemoizedMergedTriggerRefNew = _useState2[0];
    return getMemoizedMergedTriggerRefNew;
};

});



parcelRegister("7oEAU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $562a4375f5903ba2$export$2e2bcd8739ae039; });
/* text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $24QNd = parcelRequire("24QNd");

var $81u3K = parcelRequire("81u3K");

var $hZpnm = parcelRequire("hZpnm");
var $562a4375f5903ba2$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $562a4375f5903ba2$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $hZpnm.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($562a4375f5903ba2$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $562a4375f5903ba2$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
var $562a4375f5903ba2$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pmoej",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $562a4375f5903ba2$var$fontSizeMap = {
    medium: "_11c82smr",
    UNSAFE_small: "_11c8dcr7",
    large: "_11c81ixg",
    small: "_11c81o8v"
};
var $562a4375f5903ba2$var$fontWeightMap = {
    bold: "_k48pmoej",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $562a4375f5903ba2$var$textColorMap = {
    'color.text': "_syaz1fxt",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syaz1q28",
    'color.text.accent.orange.bolder': "_syaz1vps",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syazpnps",
    'color.text.accent.blue.bolder': "_syazsc1o",
    'color.text.accent.purple': "_syaz10m5",
    'color.text.accent.purple.bolder': "_syaz2ibx",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1dyx",
    'color.text.accent.gray.bolder': "_syaz1x9z",
    'color.text.disabled': "_syaz1lh4",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syazaqb7",
    'color.text.brand': "_syaz1e6v",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syazwx40",
    'color.text.warning.inverse': "_syazal3n",
    'color.text.success': "_syazy73q",
    'color.text.discovery': "_syazzjem",
    'color.text.information': "_syaze0os",
    'color.text.subtlest': "_syaz131l",
    'color.text.subtle': "_syaz1gjq",
    'color.link': "_syaz14q2",
    'color.link.pressed': "_syaz16c2",
    'color.link.visited': "_syazw7te",
    'color.link.visited.pressed': "_syazg3x0"
};
var $562a4375f5903ba2$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $562a4375f5903ba2$var$Text = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $24QNd.default)($562a4375f5903ba2$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $81u3K.useHasTextAncestor)();
    var color = $562a4375f5903ba2$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ $91i6m.createElement(Component, {
        id: id,
        className: (0, $9gzWK.default)([
            $562a4375f5903ba2$var$styles.root,
            size && $562a4375f5903ba2$var$fontSizeMap[size],
            color && $562a4375f5903ba2$var$textColorMap[color],
            maxLines && $562a4375f5903ba2$var$styles.truncation,
            maxLines === 1 && $562a4375f5903ba2$var$styles.breakAll,
            align && $562a4375f5903ba2$var$styles["textAlign.".concat(align)],
            weight && $562a4375f5903ba2$var$fontWeightMap[weight],
            Component === 'em' && $562a4375f5903ba2$var$styles['as.em'],
            Component === 'strong' && $562a4375f5903ba2$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $91i6m.createElement((0, $81u3K.HasTextAncestorProvider), {
        value: true
    }, component);
});
var $562a4375f5903ba2$export$2e2bcd8739ae039 = $562a4375f5903ba2$var$Text;

});
parcelRegister("81u3K", function(module, exports) {

$parcel$export(module.exports, "useHasTextAncestor", function () { return $0181e620a498d941$export$9322276ec105d055; });
$parcel$export(module.exports, "HasTextAncestorProvider", function () { return $0181e620a498d941$export$ae933c6cbe5643ad; });

var $91i6m = parcelRequire("91i6m");
var $0181e620a498d941$var$HasTextAncestorContext = /*#__PURE__*/ (0, $91i6m.createContext)(false);
var $0181e620a498d941$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $91i6m.useContext)($0181e620a498d941$var$HasTextAncestorContext);
};
var $0181e620a498d941$export$ae933c6cbe5643ad = $0181e620a498d941$var$HasTextAncestorContext.Provider;

});


parcelRegister("7xwGT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57d4f92eecd99af5$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");


var $dmZfh = parcelRequire("dmZfh");
var $57d4f92eecd99af5$var$iconColor = {
    connectivity: "_1b3i1c86",
    confirmation: "_1b3icdx1",
    info: "_1b3ige5s",
    warning: "_1b3i1n6p",
    error: "_1b3i1378"
};
var $57d4f92eecd99af5$var$iconWrapperStyles = null;
var $57d4f92eecd99af5$var$iconColorStyles = null;
/**
 * __Selected icon__
 *
 * The selected icon is used as the primary interactive element for the dialog.
 * Can be used with or without supporting text.
 */ var $57d4f92eecd99af5$var$SelectedIcon = function SelectedIcon(_ref) {
    var appearance = _ref.appearance, isOpen = _ref.isOpen, label = _ref.label, spacing = _ref.spacing;
    var _typesMapping$appeara = (0, $dmZfh.typesMapping)[appearance], Icon = _typesMapping$appeara.icon, defaultLabel = _typesMapping$appeara.defaultLabel;
    return /*#__PURE__*/ $91i6m.createElement("span", {
        "data-ds--inline-message--icon": true,
        className: (0, $9gzWK.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _4cvr1h6o _syazkr0v",
            isOpen && "_syaz1kum",
            $57d4f92eecd99af5$var$iconColor[appearance]
        ])
    }, /*#__PURE__*/ $91i6m.createElement(Icon, {
        testId: "inline-message-icon",
        label: label || defaultLabel,
        color: "currentColor",
        LEGACY_size: "medium",
        spacing: spacing
    }));
};
var $57d4f92eecd99af5$export$2e2bcd8739ae039 = $57d4f92eecd99af5$var$SelectedIcon;

});
parcelRegister("dmZfh", function(module, exports) {

$parcel$export(module.exports, "typesMapping", function () { return $9bbcd67eeca923c1$export$4d111645c0b39d5d; });

var $letFx = parcelRequire("letFx");

var $6K2Xp = parcelRequire("6K2Xp");

var $elGmD = parcelRequire("elGmD");

var $dEr6a = parcelRequire("dEr6a");
var $9bbcd67eeca923c1$export$4d111645c0b39d5d = {
    connectivity: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dEr6a))),
        defaultLabel: 'connectivity inline message'
    },
    confirmation: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($elGmD))),
        defaultLabel: 'confirmation inline message'
    },
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6K2Xp))),
        defaultLabel: 'info inline message'
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dEr6a))),
        defaultLabel: 'warning inline message'
    },
    error: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($letFx))),
        defaultLabel: 'error inline message'
    }
};

});
parcelRegister("letFx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f636032ea4a949f6a3ed21b2a88730cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f751eb6f6935ce3a$var$_react = $f751eb6f6935ce3a$var$_interopRequireDefault((parcelRequire("91i6m")));

var $f751eb6f6935ce3a$var$_statusError = $f751eb6f6935ce3a$var$_interopRequireDefault((parcelRequire("3QwlN")));

var $f751eb6f6935ce3a$var$_error = $f751eb6f6935ce3a$var$_interopRequireDefault((parcelRequire("i3tDa")));
function $f751eb6f6935ce3a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusErrorIcon.
 * This component is StatusErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f751eb6f6935ce3a$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $f751eb6f6935ce3a$var$_react.default.createElement($f751eb6f6935ce3a$var$_statusError.default, Object.assign({
        name: "StatusErrorIcon",
        LEGACY_fallbackIcon: $f751eb6f6935ce3a$var$_error.default
    }, props));
$f751eb6f6935ce3a$var$StatusErrorIcon.displayName = 'StatusErrorIconMigration';
var $f751eb6f6935ce3a$var$_default = module.exports.default = $f751eb6f6935ce3a$var$StatusErrorIcon;

});
parcelRegister("3QwlN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ccf528f9db08436$var$_react = $2ccf528f9db08436$var$_interopRequireDefault((parcelRequire("91i6m")));

var $2ccf528f9db08436$var$_baseNew = $2ccf528f9db08436$var$_interopRequireDefault((parcelRequire("aae9A")));
function $2ccf528f9db08436$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2ccf528f9db08436$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $2ccf528f9db08436$var$_react.default.createElement($2ccf528f9db08436$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$2ccf528f9db08436$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $2ccf528f9db08436$var$_default = module.exports.default = $2ccf528f9db08436$var$StatusErrorIcon;

});
parcelRegister("aae9A", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("c4U1D")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("c4U1D")).Icon; });

var $c4U1D = parcelRequire("c4U1D");

});
parcelRegister("c4U1D", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $8cb151340680f520$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $8cb151340680f520$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $f1k1y = parcelRequire("f1k1y");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $8cb151340680f520$var$svgStyles = null;
var $8cb151340680f520$var$iconStyles = null;
var $8cb151340680f520$var$utilityIconStyles = null;
var $8cb151340680f520$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $8cb151340680f520$var$baseHcmStyles = null;
var $8cb151340680f520$var$scaleSize = null;
var $8cb151340680f520$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $8cb151340680f520$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $8cb151340680f520$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $8cb151340680f520$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $8cb151340680f520$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $8cb151340680f520$export$f04a61298a47a40f = /*#__PURE__*/ (0, $91i6m.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $f1k1y.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $91i6m.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = $8cb151340680f520$var$baseSizeMap[type];
    var viewBoxPadding = $8cb151340680f520$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $91i6m.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $9gzWK.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $91i6m.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $9gzWK.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $8cb151340680f520$var$utilSizes[spacing] : size === 'small' ? $8cb151340680f520$var$coreSizeSmall[spacing] : $8cb151340680f520$var$coreSizeMedium[spacing]
        ])
    }));
});
var $8cb151340680f520$export$2e2bcd8739ae039 = $8cb151340680f520$export$f04a61298a47a40f;

});



parcelRegister("i3tDa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d24f7dd986d90fc6$var$_react = $d24f7dd986d90fc6$var$_interopRequireDefault((parcelRequire("91i6m")));

var $kp3ZG = parcelRequire("kp3ZG");
function $d24f7dd986d90fc6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d24f7dd986d90fc6$var$ErrorIcon = (props)=>/*#__PURE__*/ $d24f7dd986d90fc6$var$_react.default.createElement($kp3ZG.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$d24f7dd986d90fc6$var$ErrorIcon.displayName = 'ErrorIcon';
var $d24f7dd986d90fc6$var$_default = module.exports.default = $d24f7dd986d90fc6$var$ErrorIcon;

});
parcelRegister("kp3ZG", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $eda93d8dd7e1ac8d$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");
function $eda93d8dd7e1ac8d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $eda93d8dd7e1ac8d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $eda93d8dd7e1ac8d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $eda93d8dd7e1ac8d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $eda93d8dd7e1ac8d$var$iconStyles = null;
var $eda93d8dd7e1ac8d$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $eda93d8dd7e1ac8d$var$baseHcmStyles = null;
var $eda93d8dd7e1ac8d$var$primaryEqualsSecondaryHcmStyles = null;
var $eda93d8dd7e1ac8d$var$secondaryTransparentHcmStyles = null;
var $eda93d8dd7e1ac8d$export$f04a61298a47a40f = /*#__PURE__*/ (0, $91i6m.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $91i6m.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $91i6m.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $eda93d8dd7e1ac8d$var$_objectSpread($eda93d8dd7e1ac8d$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $9gzWK.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $eda93d8dd7e1ac8d$var$sizeStyles[size]
        ])
    }));
});
var $eda93d8dd7e1ac8d$export$2e2bcd8739ae039 = $eda93d8dd7e1ac8d$export$f04a61298a47a40f;

});



parcelRegister("6K2Xp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::750ecc162e36259ef90344888c589176>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4e8955337e4c916c$var$_react = $4e8955337e4c916c$var$_interopRequireDefault((parcelRequire("91i6m")));

var $4e8955337e4c916c$var$_statusInformation = $4e8955337e4c916c$var$_interopRequireDefault((parcelRequire("i7xv5")));

var $4e8955337e4c916c$var$_info = $4e8955337e4c916c$var$_interopRequireDefault((parcelRequire("gDTqd")));
function $4e8955337e4c916c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusInformationIcon.
 * This component is StatusInformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4e8955337e4c916c$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $4e8955337e4c916c$var$_react.default.createElement($4e8955337e4c916c$var$_statusInformation.default, Object.assign({
        name: "StatusInformationIcon",
        LEGACY_fallbackIcon: $4e8955337e4c916c$var$_info.default
    }, props));
$4e8955337e4c916c$var$StatusInformationIcon.displayName = 'StatusInformationIconMigration';
var $4e8955337e4c916c$var$_default = module.exports.default = $4e8955337e4c916c$var$StatusInformationIcon;

});
parcelRegister("i7xv5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::456639fbdc991aefe1af05acf697365d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d312ddec250a1437$var$_react = $d312ddec250a1437$var$_interopRequireDefault((parcelRequire("91i6m")));

var $d312ddec250a1437$var$_baseNew = $d312ddec250a1437$var$_interopRequireDefault((parcelRequire("aae9A")));
function $d312ddec250a1437$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d312ddec250a1437$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $d312ddec250a1437$var$_react.default.createElement($d312ddec250a1437$var$_baseNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$d312ddec250a1437$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $d312ddec250a1437$var$_default = module.exports.default = $d312ddec250a1437$var$StatusInformationIcon;

});

parcelRegister("gDTqd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c1db4778fe64f34b$var$_react = $c1db4778fe64f34b$var$_interopRequireDefault((parcelRequire("91i6m")));

var $kp3ZG = parcelRequire("kp3ZG");
function $c1db4778fe64f34b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c1db4778fe64f34b$var$InfoIcon = (props)=>/*#__PURE__*/ $c1db4778fe64f34b$var$_react.default.createElement($kp3ZG.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props));
$c1db4778fe64f34b$var$InfoIcon.displayName = 'InfoIcon';
var $c1db4778fe64f34b$var$_default = module.exports.default = $c1db4778fe64f34b$var$InfoIcon;

});


parcelRegister("elGmD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f966e8890debb57eaf4e6f167681f98b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a723e376eef0fe4e$var$_react = $a723e376eef0fe4e$var$_interopRequireDefault((parcelRequire("91i6m")));

var $a723e376eef0fe4e$var$_statusSuccess = $a723e376eef0fe4e$var$_interopRequireDefault((parcelRequire("iOHxx")));

var $a723e376eef0fe4e$var$_checkCircle = $a723e376eef0fe4e$var$_interopRequireDefault((parcelRequire("bekx2")));
function $a723e376eef0fe4e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusSuccessIcon.
 * This component is StatusSuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a723e376eef0fe4e$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $a723e376eef0fe4e$var$_react.default.createElement($a723e376eef0fe4e$var$_statusSuccess.default, Object.assign({
        name: "StatusSuccessIcon",
        LEGACY_fallbackIcon: $a723e376eef0fe4e$var$_checkCircle.default
    }, props));
$a723e376eef0fe4e$var$StatusSuccessIcon.displayName = 'StatusSuccessIconMigration';
var $a723e376eef0fe4e$var$_default = module.exports.default = $a723e376eef0fe4e$var$StatusSuccessIcon;

});
parcelRegister("iOHxx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db2eab9b2b321d9a$var$_react = $db2eab9b2b321d9a$var$_interopRequireDefault((parcelRequire("91i6m")));

var $db2eab9b2b321d9a$var$_baseNew = $db2eab9b2b321d9a$var$_interopRequireDefault((parcelRequire("aae9A")));
function $db2eab9b2b321d9a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $db2eab9b2b321d9a$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $db2eab9b2b321d9a$var$_react.default.createElement($db2eab9b2b321d9a$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$db2eab9b2b321d9a$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $db2eab9b2b321d9a$var$_default = module.exports.default = $db2eab9b2b321d9a$var$StatusSuccessIcon;

});

parcelRegister("bekx2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $82d0edbbec58accd$var$_react = $82d0edbbec58accd$var$_interopRequireDefault((parcelRequire("91i6m")));

var $kp3ZG = parcelRequire("kp3ZG");
function $82d0edbbec58accd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $82d0edbbec58accd$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $82d0edbbec58accd$var$_react.default.createElement($kp3ZG.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props));
$82d0edbbec58accd$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $82d0edbbec58accd$var$_default = module.exports.default = $82d0edbbec58accd$var$CheckCircleIcon;

});


parcelRegister("dEr6a", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::715767a087f47b16ede12b841c1dd7f2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f0407f5017792dd$var$_react = $9f0407f5017792dd$var$_interopRequireDefault((parcelRequire("91i6m")));

var $9f0407f5017792dd$var$_statusWarning = $9f0407f5017792dd$var$_interopRequireDefault((parcelRequire("fd5aR")));

var $9f0407f5017792dd$var$_warning = $9f0407f5017792dd$var$_interopRequireDefault((parcelRequire("j0k6e")));
function $9f0407f5017792dd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusWarningIcon.
 * This component is StatusWarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9f0407f5017792dd$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $9f0407f5017792dd$var$_react.default.createElement($9f0407f5017792dd$var$_statusWarning.default, Object.assign({
        name: "StatusWarningIcon",
        LEGACY_fallbackIcon: $9f0407f5017792dd$var$_warning.default
    }, props));
$9f0407f5017792dd$var$StatusWarningIcon.displayName = 'StatusWarningIconMigration';
var $9f0407f5017792dd$var$_default = module.exports.default = $9f0407f5017792dd$var$StatusWarningIcon;

});
parcelRegister("fd5aR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee7b3f114c675eea0f953c33a485bcf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b12c1568541a4d17$var$_react = $b12c1568541a4d17$var$_interopRequireDefault((parcelRequire("91i6m")));

var $b12c1568541a4d17$var$_baseNew = $b12c1568541a4d17$var$_interopRequireDefault((parcelRequire("aae9A")));
function $b12c1568541a4d17$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b12c1568541a4d17$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $b12c1568541a4d17$var$_react.default.createElement($b12c1568541a4d17$var$_baseNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$b12c1568541a4d17$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $b12c1568541a4d17$var$_default = module.exports.default = $b12c1568541a4d17$var$StatusWarningIcon;

});

parcelRegister("j0k6e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dd5d9bbb61a3fdd4$var$_react = $dd5d9bbb61a3fdd4$var$_interopRequireDefault((parcelRequire("91i6m")));

var $kp3ZG = parcelRequire("kp3ZG");
function $dd5d9bbb61a3fdd4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dd5d9bbb61a3fdd4$var$WarningIcon = (props)=>/*#__PURE__*/ $dd5d9bbb61a3fdd4$var$_react.default.createElement($kp3ZG.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$dd5d9bbb61a3fdd4$var$WarningIcon.displayName = 'WarningIcon';
var $dd5d9bbb61a3fdd4$var$_default = module.exports.default = $dd5d9bbb61a3fdd4$var$WarningIcon;

});





parcelRegister("7081r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3503a561e4924cf4$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $h89s9 = parcelRequire("h89s9");

var $2ZKUQ = parcelRequire("2ZKUQ");

var $cLysE = parcelRequire("cLysE");

var $4dDtg = parcelRequire("4dDtg");
parcelRequire("0wXBc");
var $buHgC = parcelRequire("buHgC");
const $3503a561e4924cf4$var$getAcceptableCharsRegex = (codeType)=>{
    switch(codeType){
        case 'numeric':
            return '\\d';
        case 'alphanumeric':
            return '[A-Za-z\\d]';
        default:
            return '.';
    }
};
const $3503a561e4924cf4$var$sanitizeInput = (input, acceptableCharsRegex)=>{
    var _input_match;
    return ((_input_match = input.match(new RegExp(acceptableCharsRegex, 'g'))) === null || _input_match === void 0 ? void 0 : _input_match.join('')) || '';
};
const $3503a561e4924cf4$var$getInputValidation = (codeType, codeLength, acceptableCharsRegex, formatMessage)=>{
    if (codeLength === undefined) return {
        label: formatMessage((0, $4dDtg.default).mfFormLabel),
        pattern: `${acceptableCharsRegex}+`,
        maxLength: undefined
    };
    else {
        const descriptor = codeType == 'numeric' ? (0, $4dDtg.default).mfFormLabelNDigits : (0, $4dDtg.default).mfFormLabelNCharacters;
        return {
            label: formatMessage(descriptor, {
                codeLength: codeLength
            }),
            pattern: `${acceptableCharsRegex}{${codeLength}}`,
            maxLength: codeLength
        };
    }
};
const $3503a561e4924cf4$var$OtpCodeField = ({ codeLength: codeLength, codeType: codeType, disabled: disabled, fieldErrorFromParent: fieldErrorFromParent, id: id, onChange: onChange, clearInputTrigger: clearInputTrigger })=>{
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const fieldTextRef = (0, $91i6m.useRef)(null);
    const [fieldValue, setFieldValue] = (0, $91i6m.useState)('');
    const [fieldError, setFieldError] = (0, $91i6m.useState)(fieldErrorFromParent);
    const previousFieldErrorFromParent = (0, $buHgC.usePrevious)(fieldErrorFromParent);
    const previousFieldValue = (0, $buHgC.usePrevious)(fieldValue);
    const previousClearInputTrigger = (0, $buHgC.usePrevious)(clearInputTrigger);
    const acceptableCharsRegex = $3503a561e4924cf4$var$getAcceptableCharsRegex(codeType);
    const { maxLength: maxLength, pattern: pattern, label: label } = $3503a561e4924cf4$var$getInputValidation(codeType, codeLength, acceptableCharsRegex, formatMessage);
    (0, $91i6m.useEffect)(()=>{
        if (!previousFieldErrorFromParent && fieldErrorFromParent) {
            setFieldError(fieldErrorFromParent);
            fieldTextRef.current && fieldTextRef.current.select();
        }
    }, [
        fieldErrorFromParent,
        previousFieldErrorFromParent
    ]);
    (0, $91i6m.useEffect)(()=>{
        if (clearInputTrigger && clearInputTrigger !== previousClearInputTrigger) {
            setFieldValue('');
            setFieldError(undefined);
        }
    }, [
        clearInputTrigger,
        previousClearInputTrigger
    ]);
    (0, $91i6m.useEffect)(()=>{
        if (fieldValue !== previousFieldValue) onChange && onChange({
            target: fieldTextRef.current
        });
    }, [
        fieldValue,
        previousFieldValue,
        onChange
    ]);
    const handlePaste = (0, $91i6m.useCallback)((e)=>{
        const target = e.target;
        const selectionStart = target.selectionStart || 0;
        const selectionEnd = target.selectionEnd || target.value.length;
        const start = target.value.substr(0, selectionStart);
        const clipboardData = (e.clipboardData || window.clipboardData).getData('text/plain');
        const sanitized = $3503a561e4924cf4$var$sanitizeInput(clipboardData, acceptableCharsRegex);
        const middle = codeLength === undefined ? sanitized : sanitized.substr(0, target.maxLength - target.value.length - selectionStart + selectionEnd);
        const end = target.value.substr(selectionEnd);
        //timeout to allow input update UI
        setTimeout(()=>setFieldValue(start + middle + end));
    }, [
        codeLength,
        acceptableCharsRegex
    ]);
    const handleChange = (0, $91i6m.useCallback)((e)=>{
        setFieldValue($3503a561e4924cf4$var$sanitizeInput(e.currentTarget.value, acceptableCharsRegex));
        setFieldError(undefined);
    }, [
        acceptableCharsRegex
    ]);
    const handleInvalid = (0, $91i6m.useCallback)((e)=>{
        e.preventDefault();
        setFieldError({
            errorCode: 'invalid_otp_pattern'
        });
    }, []);
    (0, $91i6m.useEffect)(()=>{
        const input = fieldTextRef.current;
        if (input) {
            input.addEventListener('invalid', handleInvalid);
            input.addEventListener('paste', handlePaste);
        }
        return ()=>{
            if (input) {
                input.removeEventListener('invalid', handleInvalid);
                input.removeEventListener('paste', handlePaste);
            }
        };
    }, [
        handleInvalid,
        handlePaste
    ]);
    const errorContent = (error)=>{
        switch(error && error.errorCode){
            case 'invalid_otp':
                return formatMessage((0, $4dDtg.default).errorsInvalidOtp);
            case 'invalid_otp_format':
                return formatMessage((0, $4dDtg.default).errorsInvalidOtpFormat);
            case 'invalid_otp_pattern':
                return formatMessage((0, $4dDtg.default).errorsInvalidOtpPattern, {
                    codeLength: codeLength
                });
            case 'expired_otp':
                return formatMessage((0, $4dDtg.default).errorsExpiredOtp);
            case 'too_many_requests':
                return formatMessage((0, $4dDtg.default).errorsInvalidOtp);
            case 'unknown':
                return formatMessage((0, $4dDtg.default).errorsUnknown);
            case 'invalid_token':
                return /*#__PURE__*/ (0, $4ZSso.jsxs)("form", {
                    onSubmit: ()=>window.location.reload(),
                    children: [
                        /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                            id: "mf.mfform.errors.invalid_token",
                            defaultMessage: "Your session has expired. Please refresh the page and try again."
                        }),
                        /*#__PURE__*/ (0, $4ZSso.jsx)((0, $2ZKUQ.default), {
                            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                                type: "submit",
                                isFullWidth: true,
                                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                                    id: "common.refresh",
                                    defaultMessage: "Refresh"
                                })
                            })
                        })
                    ]
                });
            default:
                return undefined;
        }
    };
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $h89s9.default), {
        id: id,
        name: "otpCode",
        type: codeType === 'numeric' ? 'tel' : 'text',
        label: label,
        autoFocus: true,
        maxLength: maxLength,
        pattern: pattern,
        onChange: handleChange,
        isInvalid: !!fieldError,
        invalidMessage: !disabled && fieldError && errorContent(fieldError),
        value: fieldValue,
        isDisabled: disabled,
        isRequired: true,
        ref: fieldTextRef
    });
};
var $3503a561e4924cf4$export$2e2bcd8739ae039 = $3503a561e4924cf4$var$OtpCodeField;

});
parcelRegister("h89s9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $666bf2328d96f7b9$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $6NU0v = parcelRequire("6NU0v");

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $7ecAu = parcelRequire("7ecAu");

var $9yEtj = parcelRequire("9yEtj");
var $iO71n = parcelRequire("iO71n");

var $TJrLs = parcelRequire("TJrLs");
const $666bf2328d96f7b9$var$FormTextField = (_param, ref)=>{
    var { name: name, label: label, isLabelHidden: isLabelHidden, invalidMessage: invalidMessage, testId: testId, isRequired: isRequired, elemAfterInput: elemAfterInput } = _param, props = (0, $6NU0v._)(_param, [
        "name",
        "label",
        "isLabelHidden",
        "invalidMessage",
        "testId",
        "isRequired",
        "elemAfterInput"
    ]);
    const ariaDescribedBy = (fieldProps)=>{
        const invalidMessageError = invalidMessage ? `${fieldProps.id}-error` : '';
        var _props_ariadescribedby;
        const ariaDescribedByMessage = (_props_ariadescribedby = props['aria-describedby']) !== null && _props_ariadescribedby !== void 0 ? _props_ariadescribedby : '';
        return invalidMessageError.concat(' ', ariaDescribedByMessage);
    };
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $iO71n.default), {
        name: name,
        label: !isLabelHidden && label,
        isRequired: isRequired,
        "aria-required": isRequired,
        children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $4ZSso.jsxs)((0, $91i6m.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $TJrLs.default), {
                        alignBlock: "center",
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $7ecAu.default), (0, $b2I6k._)((0, $1Fos3._)({}, fieldProps, props), {
                            isInvalid: !!invalidMessage,
                            "aria-describedby": ariaDescribedBy(fieldProps),
                            testId: testId,
                            ref: ref,
                            elemAfterInput: elemAfterInput
                        }))
                    }),
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9yEtj.MessageWrapper), {
                        children: invalidMessage && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9yEtj.ErrorMessage), {
                            testId: "form-text-field--input-invalid-error-message-field--idf-testid",
                            children: invalidMessage
                        })
                    })
                ]
            })
    });
};
var $666bf2328d96f7b9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).forwardRef($666bf2328d96f7b9$var$FormTextField);

});
parcelRegister("7ecAu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54339ad51eb86f63$export$2e2bcd8739ae039; });
/* text-field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $61RDg = parcelRequire("61RDg");

var $dsN6L = parcelRequire("dsN6L");

var $ai2Md = parcelRequire("ai2Md");

var $9gzWK = parcelRequire("9gzWK");
var $5oJNc = parcelRequire("5oJNc");

var $91i6m = parcelRequire("91i6m");

var $koa2c = parcelRequire("koa2c");

var $f1k1y = parcelRequire("f1k1y");
var $54339ad51eb86f63$var$_excluded = [
    "appearance",
    "className",
    "elemAfterInput",
    "elemBeforeInput",
    "isCompact",
    "isDisabled",
    "isInvalid",
    "isMonospaced",
    "isReadOnly",
    "isRequired",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "onMouseDown",
    "placeholder",
    "testId",
    "width"
];
function $54339ad51eb86f63$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $54339ad51eb86f63$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $54339ad51eb86f63$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $54339ad51eb86f63$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $54339ad51eb86f63$var$containerMedia = {
    invalid: "_msj6gir2",
    disabled: "_6up518qt"
};
var $54339ad51eb86f63$var$inputMediaDisabled = null;
var $54339ad51eb86f63$var$analyticsParams = {
    componentName: 'textField',
    packageName: "@atlaskit/textfield",
    packageVersion: "8.0.9"
};
var $54339ad51eb86f63$var$disabledStyle = {
    standard: "_1h6dsyzs _bfhksyzs _syaz1lh4 _80om13gf",
    subtle: "_1h6d1j28 _bfhk1j28 _syaz1lh4 _80om13gf",
    none: "_1h6d1j28 _bfhk1j28 _syaz1lh4 _80om13gf"
};
var $54339ad51eb86f63$var$invalidStyle = null;
var $54339ad51eb86f63$var$focusWithinStyle = {
    standard: "_1p9x1p6i _qao9r01l _q433q049",
    subtle: "_1p9x1p6i _qao9r01l _q433q049",
    none: "_1p9x1j28 _qao91j28 _q4333sij"
};
var $54339ad51eb86f63$var$hoverStyle = {
    standard: "_4cvx1elr _irr31d5g",
    subtle: "_4cvx1elr _irr31d5g",
    none: "_4cvx1j28 _irr31j28"
};
var $54339ad51eb86f63$var$getContainerTextBgAndBorderColor = {
    standard: "_1h6d1elr _1dqonqa1 _syaz1fxt _80om1kdv _bfhk1j9a _msj6gir2",
    subtle: "_1h6d1j28 _1dqonqa1 _syaz1fxt _80om1kdv _16hg1j28 _msj6gir2",
    none: "_1h6d1j28 _1dqoglyw _syaz1fxt _80om1kdv _16hg1j28 _msj6gir2"
};
var $54339ad51eb86f63$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
var $54339ad51eb86f63$var$getMaxWidth = function getMaxWidth(width) {
    return !width ? "100%" : width in $54339ad51eb86f63$var$widthMap ? "".concat($54339ad51eb86f63$var$widthMap[width], "px") : "".concat(+width, "px");
};
var $54339ad51eb86f63$var$containerStyleAppearance = {
    standard: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    subtle: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    none: "_1dqoglyw"
};
var $54339ad51eb86f63$var$containerStyles = null;
var $54339ad51eb86f63$var$inputDisabledStyle = null;
var $54339ad51eb86f63$var$inputCompactStyleWithFg = null;
var $54339ad51eb86f63$var$inputCompactStyle = null;
var $54339ad51eb86f63$var$inputMonospacedStyle = null;
var $54339ad51eb86f63$var$inputFontStyleWithFG = null;
var $54339ad51eb86f63$var$inputStyleMonospacedWithFg = null;
var $54339ad51eb86f63$var$inputStyleNotDataCompactWithFG = null;
var $54339ad51eb86f63$var$inputStyle = null;
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ var $54339ad51eb86f63$var$Textfield = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(props, ref) {
    var _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'standard' : _props$appearance, className = props.className, elemAfterInput = props.elemAfterInput, elemBeforeInput = props.elemBeforeInput, _props$isCompact = props.isCompact, isCompact = _props$isCompact === void 0 ? false : _props$isCompact, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isInvalid = props.isInvalid, isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid, _props$isMonospaced = props.isMonospaced, isMonospaced = _props$isMonospaced === void 0 ? false : _props$isMonospaced, _props$isReadOnly = props.isReadOnly, isReadOnly = _props$isReadOnly === void 0 ? false : _props$isReadOnly, _props$isRequired = props.isRequired, isRequired = _props$isRequired === void 0 ? false : _props$isRequired, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, onMouseDown = props.onMouseDown, placeholder = props.placeholder, testId = props.testId, width = props.width, spreadProps = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(props, $54339ad51eb86f63$var$_excluded);
    var inputRef = (0, $91i6m.useRef)(null);
    var handleOnFocus = (0, $koa2c.usePlatformLeafEventHandler)($54339ad51eb86f63$var$_objectSpread({
        fn: function fn(event) {
            onFocus && onFocus(event);
        },
        action: 'focused'
    }, $54339ad51eb86f63$var$analyticsParams));
    var handleOnBlur = (0, $koa2c.usePlatformLeafEventHandler)($54339ad51eb86f63$var$_objectSpread({
        fn: function fn(event) {
            onBlur && onBlur(event);
        },
        action: 'blurred'
    }, $54339ad51eb86f63$var$analyticsParams));
    var handleOnMouseDown = (0, $91i6m.useCallback)(function(event) {
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        var target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    var setInputRef = (0, $91i6m.useCallback)(function(inputElement) {
        inputRef.current = inputElement;
        if (!ref) return;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(ref) === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && "".concat(testId, "-container"),
        onMouseDown: handleOnMouseDown,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9gzWK.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1osq _11c82smr _1reo15vq _18m915vq _v564r5cv _189ee4h9 _1e0c1txw _vchhusvi _4cvr1h6o _1bah1yb4 _lcxv1wug _s7n4jp4b _slp31hna _1tnq1l7b",
            $54339ad51eb86f63$var$getContainerTextBgAndBorderColor[appearance],
            $54339ad51eb86f63$var$containerStyleAppearance[appearance],
            !isDisabled && $54339ad51eb86f63$var$focusWithinStyle[appearance],
            !isDisabled && $54339ad51eb86f63$var$hoverStyle[appearance],
            isDisabled && $54339ad51eb86f63$var$containerMedia.disabled,
            isDisabled && $54339ad51eb86f63$var$disabledStyle[appearance],
            isInvalid && $54339ad51eb86f63$var$containerMedia.invalid,
            isInvalid && "_1h6d1bqt _4cvx1bqt _16qs13x5 _1dbz13x5 _uk1sr01l",
            className
        ]),
        style: {
            maxWidth: "".concat($54339ad51eb86f63$var$getMaxWidth(width)),
            "--_x5k4n9": (0, $5oJNc.default)("inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", "var(--ds-border-danger, #E2483D)"))
        }
    }, elemBeforeInput, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, spreadProps, {
        "aria-invalid": isInvalid ? isInvalid : undefined,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired,
        className: (0, $9gzWK.default)([
            "_19itidpf _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _vchhusvi _1bsb1osq _1ul9idpf _bfhk1j28 _syaz1kw7 _80om1kw7 _14jiu2gc _olc6u2gc _1kod12x7 _7ba012x7 _1goxglyw _13xeglyw _1n7e1l2s _1idr131l",
            isMonospaced && "_ect41odn",
            isCompact && "_85i51b66 _1q511b66 _y4ti12x7 _bozg12x7",
            isDisabled && "_syaz1lh4 _1idr1lh4",
            isDisabled && "_1fnx18qt",
            !isCompact && (0, $f1k1y.fg)('platform_design_system_team_safari_input_fix') && "_14ji12x7 _olc612x7 _1kod12x7 _7ba012x7 _l9oiu2gc _549yu2gc _1h5w12x7 _124212x7",
            (0, $f1k1y.fg)('platform_design_system_team_safari_input_fix') && "_11c81ixg _1tn22smr",
            isCompact && (0, $f1k1y.fg)('platform_design_system_team_safari_input_fix') && "_11zpv77o _1l02v77o _daj712x7 _141f12x7 _1srd1b66 _oi9h1b66 _1e3012x7 _1txv12x7",
            isMonospaced && (0, $f1k1y.fg)('platform_design_system_team_safari_input_fix') && "_ect41odn _14md1odn"
        ])
    })), elemAfterInput);
});
var $54339ad51eb86f63$export$2e2bcd8739ae039 = $54339ad51eb86f63$var$Textfield;

});

parcelRegister("9yEtj", function(module, exports) {

$parcel$export(module.exports, "ErrorMessage", function () { return $6f56aedca101884d$export$915e9e7bd4f0f96d; });
$parcel$export(module.exports, "MessageWrapper", function () { return $6f56aedca101884d$export$ec445f12f63100a5; });
/* messages.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5YM7L = parcelRequire("5YM7L");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $Ww6bH = parcelRequire("Ww6bH");

var $lhpPW = parcelRequire("lhpPW");

var $f1k1y = parcelRequire("f1k1y");

var $kROoV = parcelRequire("kROoV");
/**
 * API for the internal `<Message />` component. This is not public API.
 */ /**
 * Public API of the various message components.
 */ var $6f56aedca101884d$var$messageStyles = null;
var $6f56aedca101884d$var$messageAppearanceStyles = {
    default: "_syaz1wmz",
    error: "_syaze6sf",
    valid: "_syazy73q"
};
var $6f56aedca101884d$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
var $6f56aedca101884d$var$IconWrapper = function IconWrapper(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $91i6m.createElement("span", {
        className: (0, $9gzWK.default)([
            $6f56aedca101884d$var$iconWrapperStyles.root
        ])
    }, children);
};
var $6f56aedca101884d$var$messageIcons = {
    error: /*#__PURE__*/ $91i6m.createElement((0, (/*@__PURE__*/$parcel$interopDefault($Ww6bH))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "error",
        size: "small"
    }),
    valid: /*#__PURE__*/ $91i6m.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lhpPW))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "success",
        size: "small"
    })
};
var $6f56aedca101884d$var$Message = function Message(_ref2) {
    var children = _ref2.children, _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? 'default' : _ref2$appearance, fieldId = _ref2.fieldId, testId = _ref2.testId;
    var icon = $6f56aedca101884d$var$messageIcons[appearance];
    var isFeatureFlagEnabled = (0, $f1k1y.fg)('platform_dst_form_screenreader_message_fix');
    var _useContext = (0, $91i6m.useContext)($6f56aedca101884d$var$MessageWrapperContext), isWrapper = _useContext.isWrapper;
    var _useState = (0, $91i6m.useState)(isWrapper), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), shouldRenderContent = _useState2[0], setShouldRenderContent = _useState2[1];
    // TODO: DSP-23603 - To clean up when removing "platform_dst_form_screenreader_message_fix" feature flag
    var messageRef = (0, $91i6m.useRef)(null);
    var _useState3 = (0, $91i6m.useState)(isWrapper), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState3, 2), hasMessageWrapper = _useState4[0], setHasMessageWrapper = _useState4[1];
    (0, $91i6m.useEffect)(function() {
        if (isFeatureFlagEnabled) {
            if (!isWrapper) {
                // Delay rendering to ensure aria-live announcements work on first render if there is no wrapper
                var timer = setTimeout(function() {
                    setShouldRenderContent(true);
                }, 10);
                return function() {
                    return clearTimeout(timer);
                };
            } else // When using MessageWrapper, render content immediately since the wrapper handles aria-live
            setShouldRenderContent(true);
        } else // TODO: DSP-23603 - To clean up when removing "platform_dst_form_screenreader_message_fix" feature flag
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper,
        isFeatureFlagEnabled
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ var content = typeof children === 'string' ? children : /*#__PURE__*/ $91i6m.createElement("span", null, children);
    var childrenToRender = /*#__PURE__*/ $91i6m.createElement((0, $91i6m.Fragment), null, icon && /*#__PURE__*/ $91i6m.createElement($6f56aedca101884d$var$IconWrapper, null, icon), content);
    return /*#__PURE__*/ $91i6m.createElement("div", {
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        "aria-live": !hasMessageWrapper ? 'polite' : undefined,
        className: (0, $9gzWK.default)([
            "_zulp12x7 _11c8dcr7 _1e0c1txw _1bah1q9y _1pfh1b66",
            $6f56aedca101884d$var$messageAppearanceStyles[appearance]
        ])
    }, isFeatureFlagEnabled ? shouldRenderContent && childrenToRender : childrenToRender);
};
var $6f56aedca101884d$export$8fbe3c7d0ed2c683 = function HelperMessage(_ref3) {
    var children = _ref3.children, testId = _ref3.testId;
    return /*#__PURE__*/ $91i6m.createElement((0, $kROoV.FieldId).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $91i6m.createElement($6f56aedca101884d$var$Message, {
            fieldId: fieldId ? "".concat(fieldId, "-helper") : undefined,
            testId: testId
        }, children);
    });
};
var $6f56aedca101884d$export$915e9e7bd4f0f96d = function ErrorMessage(_ref4) {
    var children = _ref4.children, testId = _ref4.testId;
    return /*#__PURE__*/ $91i6m.createElement((0, $kROoV.FieldId).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $91i6m.createElement($6f56aedca101884d$var$Message, {
            appearance: "error",
            fieldId: fieldId ? "".concat(fieldId, "-error") : undefined,
            testId: testId
        }, children);
    });
};
var $6f56aedca101884d$export$5505afb209a532c8 = function ValidMessage(_ref5) {
    var children = _ref5.children, testId = _ref5.testId;
    return /*#__PURE__*/ $91i6m.createElement((0, $kROoV.FieldId).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $91i6m.createElement($6f56aedca101884d$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? "".concat(fieldId, "-valid") : undefined,
            testId: testId
        }, children);
    });
};
/**
 * __Message wrapper context__
 *
 * A message wrapper context allows the children to check
 * if it is contained within the MessageWrapper.
 */ var $6f56aedca101884d$var$MessageWrapperContext = /*#__PURE__*/ (0, $91i6m.createContext)({
    isWrapper: false
});
var $6f56aedca101884d$export$ec445f12f63100a5 = function MessageWrapper(_ref6) {
    var children = _ref6.children;
    var contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ $91i6m.createElement($6f56aedca101884d$var$MessageWrapperContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $91i6m.createElement("div", {
        "aria-live": "polite",
        "data-testid": "message-wrapper"
    }, children));
};

});
parcelRegister("Ww6bH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f636032ea4a949f6a3ed21b2a88730cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0afe510c3281ad9f$var$_react = $0afe510c3281ad9f$var$_interopRequireDefault((parcelRequire("91i6m")));

var $0afe510c3281ad9f$var$_statusError = $0afe510c3281ad9f$var$_interopRequireDefault((parcelRequire("CQduk")));

var $0afe510c3281ad9f$var$_error = $0afe510c3281ad9f$var$_interopRequireDefault((parcelRequire("fuhSA")));
function $0afe510c3281ad9f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusErrorIcon.
 * This component is StatusErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0afe510c3281ad9f$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $0afe510c3281ad9f$var$_react.default.createElement($0afe510c3281ad9f$var$_statusError.default, Object.assign({
        name: "StatusErrorIcon",
        LEGACY_fallbackIcon: $0afe510c3281ad9f$var$_error.default
    }, props));
$0afe510c3281ad9f$var$StatusErrorIcon.displayName = 'StatusErrorIconMigration';
var $0afe510c3281ad9f$var$_default = module.exports.default = $0afe510c3281ad9f$var$StatusErrorIcon;

});
parcelRegister("CQduk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $074c0dd822037279$var$_react = $074c0dd822037279$var$_interopRequireDefault((parcelRequire("91i6m")));

var $074c0dd822037279$var$_baseNew = $074c0dd822037279$var$_interopRequireDefault((parcelRequire("8KcJQ")));
function $074c0dd822037279$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $074c0dd822037279$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $074c0dd822037279$var$_react.default.createElement($074c0dd822037279$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$074c0dd822037279$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $074c0dd822037279$var$_default = module.exports.default = $074c0dd822037279$var$StatusErrorIcon;

});
parcelRegister("8KcJQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("hjIUS")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("hjIUS")).Icon; });

var $hjIUS = parcelRequire("hjIUS");

});
parcelRegister("hjIUS", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $c9b70d77755e84c0$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $c9b70d77755e84c0$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $f1k1y = parcelRequire("f1k1y");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $c9b70d77755e84c0$var$svgStyles = null;
var $c9b70d77755e84c0$var$iconStyles = null;
var $c9b70d77755e84c0$var$utilityIconStyles = null;
var $c9b70d77755e84c0$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $c9b70d77755e84c0$var$baseHcmStyles = null;
var $c9b70d77755e84c0$var$scaleSize = null;
var $c9b70d77755e84c0$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $c9b70d77755e84c0$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $c9b70d77755e84c0$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $c9b70d77755e84c0$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $c9b70d77755e84c0$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $c9b70d77755e84c0$export$f04a61298a47a40f = /*#__PURE__*/ (0, $91i6m.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $f1k1y.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $91i6m.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = $c9b70d77755e84c0$var$baseSizeMap[type];
    var viewBoxPadding = $c9b70d77755e84c0$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $91i6m.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $9gzWK.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $91i6m.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $9gzWK.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $c9b70d77755e84c0$var$utilSizes[spacing] : size === 'small' ? $c9b70d77755e84c0$var$coreSizeSmall[spacing] : $c9b70d77755e84c0$var$coreSizeMedium[spacing]
        ])
    }));
});
var $c9b70d77755e84c0$export$2e2bcd8739ae039 = $c9b70d77755e84c0$export$f04a61298a47a40f;

});



parcelRegister("fuhSA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b46786d14d429a50$var$_react = $b46786d14d429a50$var$_interopRequireDefault((parcelRequire("91i6m")));

var $goEAo = parcelRequire("goEAo");
function $b46786d14d429a50$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b46786d14d429a50$var$ErrorIcon = (props)=>/*#__PURE__*/ $b46786d14d429a50$var$_react.default.createElement($goEAo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$b46786d14d429a50$var$ErrorIcon.displayName = 'ErrorIcon';
var $b46786d14d429a50$var$_default = module.exports.default = $b46786d14d429a50$var$ErrorIcon;

});
parcelRegister("goEAo", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $befe5ec1da9e08b0$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");
function $befe5ec1da9e08b0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $befe5ec1da9e08b0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $befe5ec1da9e08b0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $befe5ec1da9e08b0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $befe5ec1da9e08b0$var$iconStyles = null;
var $befe5ec1da9e08b0$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $befe5ec1da9e08b0$var$baseHcmStyles = null;
var $befe5ec1da9e08b0$var$primaryEqualsSecondaryHcmStyles = null;
var $befe5ec1da9e08b0$var$secondaryTransparentHcmStyles = null;
var $befe5ec1da9e08b0$export$f04a61298a47a40f = /*#__PURE__*/ (0, $91i6m.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $91i6m.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $91i6m.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $befe5ec1da9e08b0$var$_objectSpread($befe5ec1da9e08b0$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $9gzWK.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $befe5ec1da9e08b0$var$sizeStyles[size]
        ])
    }));
});
var $befe5ec1da9e08b0$export$2e2bcd8739ae039 = $befe5ec1da9e08b0$export$f04a61298a47a40f;

});



parcelRegister("lhpPW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::849e146248de3896aa5effb6cb325c8d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $03ff78ae09dbceae$var$_react = $03ff78ae09dbceae$var$_interopRequireDefault((parcelRequire("91i6m")));

var $03ff78ae09dbceae$var$_statusSuccess = $03ff78ae09dbceae$var$_interopRequireDefault((parcelRequire("k0k0T")));

var $03ff78ae09dbceae$var$_success = $03ff78ae09dbceae$var$_interopRequireDefault((parcelRequire("gzuMS")));
function $03ff78ae09dbceae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusSuccessIcon.
 * This component is StatusSuccessIcon, with `UNSAFE_fallbackIcon` set to "EditorSuccessIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $03ff78ae09dbceae$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $03ff78ae09dbceae$var$_react.default.createElement($03ff78ae09dbceae$var$_statusSuccess.default, Object.assign({
        name: "StatusSuccessIcon",
        LEGACY_fallbackIcon: $03ff78ae09dbceae$var$_success.default
    }, props));
$03ff78ae09dbceae$var$StatusSuccessIcon.displayName = 'StatusSuccessIconMigration';
var $03ff78ae09dbceae$var$_default = module.exports.default = $03ff78ae09dbceae$var$StatusSuccessIcon;

});
parcelRegister("k0k0T", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e90355004f93fb84$var$_react = $e90355004f93fb84$var$_interopRequireDefault((parcelRequire("91i6m")));

var $e90355004f93fb84$var$_baseNew = $e90355004f93fb84$var$_interopRequireDefault((parcelRequire("8KcJQ")));
function $e90355004f93fb84$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e90355004f93fb84$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $e90355004f93fb84$var$_react.default.createElement($e90355004f93fb84$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$e90355004f93fb84$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $e90355004f93fb84$var$_default = module.exports.default = $e90355004f93fb84$var$StatusSuccessIcon;

});

parcelRegister("gzuMS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c107cbf0efefb1e3$var$_react = $c107cbf0efefb1e3$var$_interopRequireDefault((parcelRequire("91i6m")));

var $goEAo = parcelRequire("goEAo");
function $c107cbf0efefb1e3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c107cbf0efefb1e3$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $c107cbf0efefb1e3$var$_react.default.createElement($goEAo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props));
$c107cbf0efefb1e3$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $c107cbf0efefb1e3$var$_default = module.exports.default = $c107cbf0efefb1e3$var$EditorSuccessIcon;

});


parcelRegister("kROoV", function(module, exports) {

$parcel$export(module.exports, "FieldId", function () { return $f30fda7574db398a$export$3c4232819458a302; });

var $91i6m = parcelRequire("91i6m");
var $f30fda7574db398a$export$3c4232819458a302 = /*#__PURE__*/ (0, $91i6m.createContext)(undefined);

});


parcelRegister("iO71n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db1257c9332b7ba7$export$2e2bcd8739ae039; });
/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dsN6L = parcelRequire("dsN6L");

var $5YM7L = parcelRequire("5YM7L");

var $61RDg = parcelRequire("61RDg");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $lD6mB = parcelRequire("lD6mB");

var $kROoV = parcelRequire("kROoV");

var $47Bqn = parcelRequire("47Bqn");

var $4xOBh = parcelRequire("4xOBh");

var $1o8Ff = parcelRequire("1o8Ff");
function $db1257c9332b7ba7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $db1257c9332b7ba7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $db1257c9332b7ba7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $db1257c9332b7ba7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $db1257c9332b7ba7$var$fieldWrapperStyles = null;
function $db1257c9332b7ba7$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $db1257c9332b7ba7$var$isFunction(x) {
    return typeof x === 'function';
}
// Must be exported to satisfy error TS4023 from Jira builds
// src/packages/servicedesk/virtual-agent/common/src/ui/base-text-field/index.tsx(10,14):
// error TS4023: Exported variable `BaseTextField` has or is using name
// `FieldComponentProps` from external module
// `/opt/atlassian/pipelines/agent/build/jira/tsDist/@atlaskit__form/app/src/field`
// but cannot be named.
function $db1257c9332b7ba7$var$usePreviousRef(current) {
    var ref = (0, $91i6m.useRef)(current);
    // will be updated on the next render
    (0, $91i6m.useEffect)(function() {
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $db1257c9332b7ba7$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(previousValue) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(currentValue) === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $db1257c9332b7ba7$export$2e2bcd8739ae039(props) {
    var _getCurrentValue;
    var _useContext = (0, $91i6m.useContext)((0, $47Bqn.FormContext)), registerField = _useContext.registerField, getCurrentValue = _useContext.getCurrentValue;
    var isDisabled = (0, $91i6m.useContext)((0, $47Bqn.IsDisabledContext)) || props.isDisabled || false;
    var defaultValue = $db1257c9332b7ba7$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    var latestPropsRef = $db1257c9332b7ba7$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ var isDefaultValueChanged = !$db1257c9332b7ba7$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    var _useState = (0, $91i6m.useState)({
        fieldProps: {
            onChange: function onChange() {},
            onBlur: function onBlur() {},
            onFocus: function onFocus() {},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
         * effectively made it an optional prop to external consumers of Field. However the
         * prop types defined defaultValue as required, so inside the component it was not
         * valid for defaultValue to be undefined. We need to suppress the error
         * after changing defaultValue to explicitly be an optional prop.
         * If default value has changed we are using new default value.
         * Otherwise we need to check if we already have value for this field
         * (because we are using changing key prop to re-run field level validation, and that
         * cause the component re-mounting) to not override the actual value with the default value.
         */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : (_getCurrentValue = getCurrentValue(props.name)) !== null && _getCurrentValue !== void 0 ? _getCurrentValue : defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var latestStateRef = $db1257c9332b7ba7$var$usePreviousRef(state);
    (0, $91i6m.useEffect)(function() {
        function fieldStateToMeta() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        var unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $db1257c9332b7ba7$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, function(fieldState) {
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ var modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ var modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ var modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            var modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ var modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($db1257c9332b7ba7$var$isEvent(eventOrValue)) {
                    var currentTarget = eventOrValue.currentTarget;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: function onChange(e) {
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: function getValidator() {
                return function validate(value, formState, fieldState) {
                    var supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                };
            }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    var uid = (0, $lD6mB.useId)();
    var fieldId = (0, $91i6m.useMemo)(function() {
        return props.id ? props.id : "".concat(props.name, "-").concat(uid);
    }, [
        props.id,
        props.name,
        uid
    ]);
    var getDescribedBy = function getDescribedBy() {
        var value = '';
        if (state.error) value += "".concat(fieldId, "-error ");
        if (state.valid) value += "".concat(fieldId, "-valid ");
        return "".concat(value).concat(fieldId, "-helper");
    };
    var extendedFieldProps = $db1257c9332b7ba7$var$_objectSpread($db1257c9332b7ba7$var$_objectSpread({}, state.fieldProps), {}, {
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': "".concat(fieldId, "-label"),
        id: fieldId
    });
    return /*#__PURE__*/ $91i6m.createElement("div", {
        "data-testid": props.testId,
        className: (0, $9gzWK.default)([
            "_1pfhu2gc"
        ])
    }, props.label && /*#__PURE__*/ $91i6m.createElement((0, $4xOBh.Label), {
        htmlFor: fieldId,
        id: "".concat(fieldId, "-label"),
        testId: props.testId && "".concat(props.testId, "--label")
    }, props.label, props.isRequired && /*#__PURE__*/ $91i6m.createElement((0, $1o8Ff.default), null), props.elementAfterLabel), /*#__PURE__*/ $91i6m.createElement((0, $kROoV.FieldId).Provider, {
        value: fieldId
    }, props.children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

});
parcelRegister("47Bqn", function(module, exports) {

$parcel$export(module.exports, "FormContext", function () { return $3004d891fd7b33cc$export$c24727297075ec6a; });
$parcel$export(module.exports, "IsDisabledContext", function () { return $3004d891fd7b33cc$export$c17cf6b332a82dbc; });
$parcel$export(module.exports, "default", function () { return $3004d891fd7b33cc$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $5YM7L = parcelRequire("5YM7L");

var $91i6m = parcelRequire("91i6m");

var $cZpyO = parcelRequire("cZpyO");

var $5bK8v = parcelRequire("5bK8v");

var $kU6Wu = parcelRequire("kU6Wu");

var $f1k1y = parcelRequire("f1k1y");

var $bpIx8 = parcelRequire("bpIx8");
var $3004d891fd7b33cc$export$c24727297075ec6a = /*#__PURE__*/ (0, $91i6m.createContext)({
    registerField: function registerField() {
        return function() {};
    },
    getCurrentValue: function getCurrentValue() {
        return undefined;
    },
    subscribe: function subscribe() {
        return function() {};
    }
});
var $3004d891fd7b33cc$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $91i6m.createContext)(false);
function $3004d891fd7b33cc$export$2e2bcd8739ae039(props) {
    var userProvidedFormProps = props.formProps, onSubmit = props.onSubmit;
    var formRef = (0, $91i6m.useRef)(null);
    var onSubmitRef = (0, $91i6m.useRef)(onSubmit);
    onSubmitRef.current = onSubmit;
    var _useState = (0, $91i6m.useState)(function() {
        // Types here would break the existing API
        var finalForm = (0, $cZpyO.createForm)({
            onSubmit: function onSubmit() {
                return onSubmitRef.current.apply(onSubmitRef, arguments);
            },
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: function setDefaultValue(_ref, state) {
                    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_ref, 2), name = _ref2[0], defaultValue = _ref2[1];
                    if (state.formState.initialValues) {
                        var initialValues = state.formState.initialValues;
                        var values = state.formState.values;
                        var _value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        (0, (/*@__PURE__*/$parcel$interopDefault($kU6Wu)))(initialValues, name, _value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($kU6Wu)))(values, name, _value);
                    }
                }
            }
        });
        (0, $5bK8v.default)(function() {
            return formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [];
        }, (0, $f1k1y.fg)('platform-form-field-error-focus') ? (0, $bpIx8.getFirstErrorField) : undefined)(finalForm);
        return finalForm;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 1), form = _useState2[0];
    var _useState3 = (0, $91i6m.useState)({
        dirty: false,
        submitting: false
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState3, 2), state = _useState4[0], setState = _useState4[1];
    (0, $91i6m.useEffect)(function() {
        var unsubscribe = form.subscribe(function(_ref3) {
            var dirty = _ref3.dirty, submitting = _ref3.submitting;
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    var registerField = (0, $91i6m.useCallback)(function(name, defaultValue, subscriber, subscription, config) {
        form.pauseValidation();
        var unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    var handleSubmit = function handleSubmit(e) {
        if (e) e.preventDefault();
        form.submit();
    };
    var handleReset = function handleReset(initialValues) {
        form.reset(initialValues);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            var submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    var _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, children = props.children;
    var dirty = state.dirty, submitting = state.submitting;
    /**
   * This method is needed in FormContext to use it on the field level
   * to check the current value of the field in case of the component re-mounting.
   */ var getCurrentValue = (0, $91i6m.useCallback)(function(name) {
        var formState = form.getState();
        return (formState === null || formState === void 0 ? void 0 : formState.values[name]) || undefined;
    }, [
        form
    ]);
    var FormContextValue = (0, $91i6m.useMemo)(function() {
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    // Abstracting so we can use the same for both rendering patterns
    var formProps = {
        onKeyDown: handleKeyDown,
        onSubmit: handleSubmit,
        ref: formRef
    };
    var childrenContent = function() {
        if (typeof children === 'function') {
            var result = children.length > 0 ? children({
                formProps: formProps,
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: function getState() {
                    return form.getState();
                },
                getValues: function getValues() {
                    return form.getState().values;
                },
                setFieldValue: form.change
            }) : children();
            return result === undefined ? null : result;
        } else return (0, $f1k1y.fg)('platform_design-system-team_form-upgrade') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("form", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, formProps, userProvidedFormProps), children) : children;
    }();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($3004d891fd7b33cc$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($3004d891fd7b33cc$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, childrenContent));
}

});
parcelRegister("cZpyO", function(module, exports) {

$parcel$export(module.exports, "getIn", function () { return $974f0251254c4b48$export$c52e5867d5879e24; });
$parcel$export(module.exports, "createForm", function () { return $974f0251254c4b48$export$f681a8129d2e9d28; });

var $kOzMk = parcelRequire("kOzMk");

var $dDDP6 = parcelRequire("dDDP6");
//      
var $974f0251254c4b48$var$charCodeOfDot = ".".charCodeAt(0);
var $974f0251254c4b48$var$reEscapeChar = /\\(\\)?/g;
var $974f0251254c4b48$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $974f0251254c4b48$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $974f0251254c4b48$var$charCodeOfDot) result.push("");
    string.replace($974f0251254c4b48$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($974f0251254c4b48$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $974f0251254c4b48$var$keysCache = {};
var $974f0251254c4b48$var$keysRegex = /[.[\]]+/;
var $974f0251254c4b48$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($974f0251254c4b48$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $974f0251254c4b48$var$keysCache[key] = key.split($974f0251254c4b48$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $974f0251254c4b48$var$keysCache[key] = $974f0251254c4b48$var$stringToPath(key);
    }
    return $974f0251254c4b48$var$keysCache[key];
};
//      
var $974f0251254c4b48$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $974f0251254c4b48$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $974f0251254c4b48$var$_toPropertyKey(arg) {
    var key = $974f0251254c4b48$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $974f0251254c4b48$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $974f0251254c4b48$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $dDDP6.default)(current, [
                key
            ].map($974f0251254c4b48$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $kOzMk.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $974f0251254c4b48$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $974f0251254c4b48$var$setInRecursor(state, 0, $974f0251254c4b48$var$toPath(key), value1, destroyArrays);
};
var $974f0251254c4b48$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $974f0251254c4b48$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $974f0251254c4b48$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $974f0251254c4b48$export$c52e5867d5879e24(values, name);
    var error = $974f0251254c4b48$export$c52e5867d5879e24(errors, name);
    if (error && error[$974f0251254c4b48$export$735bebc8ffabf28a]) error = error[$974f0251254c4b48$export$735bebc8ffabf28a];
    var submitError = submitErrors && $974f0251254c4b48$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $974f0251254c4b48$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($974f0251254c4b48$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $974f0251254c4b48$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $974f0251254c4b48$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $974f0251254c4b48$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$974f0251254c4b48$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $974f0251254c4b48$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $974f0251254c4b48$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $974f0251254c4b48$var$subscriptionFilter(result, state, previousState, subscription, $974f0251254c4b48$export$41e855cb628c1b55, $974f0251254c4b48$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $974f0251254c4b48$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $974f0251254c4b48$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $974f0251254c4b48$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $974f0251254c4b48$var$subscriptionFilter(result, state, previousState, subscription, $974f0251254c4b48$export$f1ff97b9d1c7a3c3, $974f0251254c4b48$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $974f0251254c4b48$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$974f0251254c4b48$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $974f0251254c4b48$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $974f0251254c4b48$export$83d89fbfd8236492 = "4.20.10";
var $974f0251254c4b48$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $974f0251254c4b48$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $974f0251254c4b48$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $974f0251254c4b48$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $974f0251254c4b48$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $974f0251254c4b48$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $974f0251254c4b48$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $974f0251254c4b48$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($974f0251254c4b48$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $974f0251254c4b48$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $kOzMk.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $kOzMk.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $974f0251254c4b48$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $974f0251254c4b48$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $kOzMk.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $kOzMk.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $kOzMk.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $974f0251254c4b48$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $974f0251254c4b48$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $974f0251254c4b48$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $974f0251254c4b48$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $974f0251254c4b48$export$e6bdf135a54e021b,
                    shallowEqual: $974f0251254c4b48$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $kOzMk.default)({}, state.formState.values)); // clone to avoid writing
            if ($974f0251254c4b48$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($974f0251254c4b48$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $974f0251254c4b48$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $974f0251254c4b48$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $kOzMk.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $kOzMk.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $974f0251254c4b48$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $974f0251254c4b48$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $974f0251254c4b48$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$974f0251254c4b48$export$735bebc8ffabf28a]) {
                    var existing = $974f0251254c4b48$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$974f0251254c4b48$export$735bebc8ffabf28a] = error[$974f0251254c4b48$export$735bebc8ffabf28a];
                    merged = $974f0251254c4b48$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$974f0251254c4b48$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$974f0251254c4b48$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $kOzMk.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $974f0251254c4b48$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $974f0251254c4b48$var$notify(fieldSubscriber, fieldState, lastFieldState, $974f0251254c4b48$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $974f0251254c4b48$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $kOzMk.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($974f0251254c4b48$export$c52e5867d5879e24(formState.values, key), $974f0251254c4b48$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($974f0251254c4b48$export$c52e5867d5879e24(formState.values, key), $974f0251254c4b48$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$974f0251254c4b48$var$hasAnyError(formState.errors) && !(formState.submitErrors && $974f0251254c4b48$var$hasAnyError(formState.submitErrors));
        var nextFormState = $974f0251254c4b48$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $974f0251254c4b48$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $974f0251254c4b48$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $974f0251254c4b48$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $974f0251254c4b48$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $974f0251254c4b48$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $974f0251254c4b48$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $974f0251254c4b48$var$notify(state.subscribers, nextFormState, lastFormState, $974f0251254c4b48$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $kOzMk.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($974f0251254c4b48$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $kOzMk.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $kOzMk.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($974f0251254c4b48$export$c52e5867d5879e24(formState.values, key), $974f0251254c4b48$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $974f0251254c4b48$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $974f0251254c4b48$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $974f0251254c4b48$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $974f0251254c4b48$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $974f0251254c4b48$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $974f0251254c4b48$export$c52e5867d5879e24(state.formState.values, name) === $974f0251254c4b48$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $974f0251254c4b48$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $974f0251254c4b48$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $974f0251254c4b48$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $974f0251254c4b48$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $974f0251254c4b48$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $974f0251254c4b48$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $kOzMk.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $kOzMk.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $kOzMk.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $974f0251254c4b48$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$974f0251254c4b48$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $kOzMk.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $974f0251254c4b48$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $974f0251254c4b48$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $974f0251254c4b48$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $974f0251254c4b48$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("5bK8v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c71c4801dfcba9a$export$2e2bcd8739ae039; });

var $cZpyO = parcelRequire("cZpyO");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $3c71c4801dfcba9a$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $3c71c4801dfcba9a$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($3c71c4801dfcba9a$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $3c71c4801dfcba9a$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $cZpyO.getIn)(errors, input.name);
    });
};
//      
var $3c71c4801dfcba9a$var$noop = function noop() {};
var $3c71c4801dfcba9a$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $3c71c4801dfcba9a$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $3c71c4801dfcba9a$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $3c71c4801dfcba9a$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $3c71c4801dfcba9a$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($3c71c4801dfcba9a$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$3c71c4801dfcba9a$export$2e2bcd8739ae039 = $3c71c4801dfcba9a$var$createDecorator;

});

parcelRegister("kU6Wu", function(module, exports) {

var $aD6VC = parcelRequire("aD6VC");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $f37e6c3c48df7d85$var$set(object, path, value) {
    return object == null ? object : $aD6VC(object, path, value);
}
module.exports = $f37e6c3c48df7d85$var$set;

});
parcelRegister("aD6VC", function(module, exports) {

var $mBQ45 = parcelRequire("mBQ45");

var $f1LNj = parcelRequire("f1LNj");

var $2Jb0d = parcelRequire("2Jb0d");

var $fR4kx = parcelRequire("fR4kx");

var $lky4s = parcelRequire("lky4s");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $7bd2ebb4b6a9716b$var$baseSet(object, path, value, customizer) {
    if (!$fR4kx(object)) return object;
    path = $f1LNj(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $lky4s(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $fR4kx(objValue) ? objValue : $2Jb0d(path[index + 1]) ? [] : {};
        }
        $mBQ45(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = $7bd2ebb4b6a9716b$var$baseSet;

});
parcelRegister("mBQ45", function(module, exports) {

var $3ZVmF = parcelRequire("3ZVmF");

var $7mSvq = parcelRequire("7mSvq");
/** Used for built-in method references. */ var $043f682d79b456cb$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $043f682d79b456cb$var$hasOwnProperty = $043f682d79b456cb$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $043f682d79b456cb$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($043f682d79b456cb$var$hasOwnProperty.call(object, key) && $7mSvq(objValue, value)) || value === undefined && !(key in object)) $3ZVmF(object, key, value);
}
module.exports = $043f682d79b456cb$var$assignValue;

});
parcelRegister("3ZVmF", function(module, exports) {

var $ao3ey = parcelRequire("ao3ey");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $2e93910195355493$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $ao3ey) $ao3ey(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = $2e93910195355493$var$baseAssignValue;

});
parcelRegister("ao3ey", function(module, exports) {

var $j3AXy = parcelRequire("j3AXy");
var $78fea76b8334267b$var$defineProperty = function() {
    try {
        var func = $j3AXy(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = $78fea76b8334267b$var$defineProperty;

});
parcelRegister("j3AXy", function(module, exports) {

var $8cDPt = parcelRequire("8cDPt");

var $hHmRc = parcelRequire("hHmRc");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $ddfaf787d1ed137e$var$getNative(object, key) {
    var value = $hHmRc(object, key);
    return $8cDPt(value) ? value : undefined;
}
module.exports = $ddfaf787d1ed137e$var$getNative;

});
parcelRegister("8cDPt", function(module, exports) {

var $lePUq = parcelRequire("lePUq");

var $jkwa1 = parcelRequire("jkwa1");

var $fR4kx = parcelRequire("fR4kx");

var $4xClN = parcelRequire("4xClN");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $5f8e56f7a0a7dc98$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $5f8e56f7a0a7dc98$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $5f8e56f7a0a7dc98$var$funcProto = Function.prototype, $5f8e56f7a0a7dc98$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $5f8e56f7a0a7dc98$var$funcToString = $5f8e56f7a0a7dc98$var$funcProto.toString;
/** Used to check objects for own properties. */ var $5f8e56f7a0a7dc98$var$hasOwnProperty = $5f8e56f7a0a7dc98$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $5f8e56f7a0a7dc98$var$reIsNative = RegExp('^' + $5f8e56f7a0a7dc98$var$funcToString.call($5f8e56f7a0a7dc98$var$hasOwnProperty).replace($5f8e56f7a0a7dc98$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $5f8e56f7a0a7dc98$var$baseIsNative(value) {
    if (!$fR4kx(value) || $jkwa1(value)) return false;
    var pattern = $lePUq(value) ? $5f8e56f7a0a7dc98$var$reIsNative : $5f8e56f7a0a7dc98$var$reIsHostCtor;
    return pattern.test($4xClN(value));
}
module.exports = $5f8e56f7a0a7dc98$var$baseIsNative;

});
parcelRegister("lePUq", function(module, exports) {

var $bf9T1 = parcelRequire("bf9T1");

var $fR4kx = parcelRequire("fR4kx");
/** `Object#toString` result references. */ var $f7632bd9d09e7257$var$asyncTag = '[object AsyncFunction]', $f7632bd9d09e7257$var$funcTag = '[object Function]', $f7632bd9d09e7257$var$genTag = '[object GeneratorFunction]', $f7632bd9d09e7257$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $f7632bd9d09e7257$var$isFunction(value) {
    if (!$fR4kx(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $bf9T1(value);
    return tag == $f7632bd9d09e7257$var$funcTag || tag == $f7632bd9d09e7257$var$genTag || tag == $f7632bd9d09e7257$var$asyncTag || tag == $f7632bd9d09e7257$var$proxyTag;
}
module.exports = $f7632bd9d09e7257$var$isFunction;

});
parcelRegister("bf9T1", function(module, exports) {

var $1ke0A = parcelRequire("1ke0A");

var $eBE0e = parcelRequire("eBE0e");

var $9FCOd = parcelRequire("9FCOd");
/** `Object#toString` result references. */ var $82f8c3a5061918d1$var$nullTag = '[object Null]', $82f8c3a5061918d1$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $82f8c3a5061918d1$var$symToStringTag = $1ke0A ? $1ke0A.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $82f8c3a5061918d1$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $82f8c3a5061918d1$var$undefinedTag : $82f8c3a5061918d1$var$nullTag;
    return $82f8c3a5061918d1$var$symToStringTag && $82f8c3a5061918d1$var$symToStringTag in Object(value) ? $eBE0e(value) : $9FCOd(value);
}
module.exports = $82f8c3a5061918d1$var$baseGetTag;

});
parcelRegister("1ke0A", function(module, exports) {

var $7FBld = parcelRequire("7FBld");
/** Built-in value references. */ var $0f7286803648e8c2$var$Symbol = $7FBld.Symbol;
module.exports = $0f7286803648e8c2$var$Symbol;

});
parcelRegister("7FBld", function(module, exports) {

var $avJCo = parcelRequire("avJCo");
/** Detect free variable `self`. */ var $595953eb2c1b329a$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $595953eb2c1b329a$var$root = $avJCo || $595953eb2c1b329a$var$freeSelf || Function('return this')();
module.exports = $595953eb2c1b329a$var$root;

});
parcelRegister("avJCo", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $7a702f721941f03f$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $7a702f721941f03f$var$freeGlobal;

});



parcelRegister("eBE0e", function(module, exports) {

var $1ke0A = parcelRequire("1ke0A");
/** Used for built-in method references. */ var $aa238d137d91f8cb$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $aa238d137d91f8cb$var$hasOwnProperty = $aa238d137d91f8cb$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $aa238d137d91f8cb$var$nativeObjectToString = $aa238d137d91f8cb$var$objectProto.toString;
/** Built-in value references. */ var $aa238d137d91f8cb$var$symToStringTag = $1ke0A ? $1ke0A.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $aa238d137d91f8cb$var$getRawTag(value) {
    var isOwn = $aa238d137d91f8cb$var$hasOwnProperty.call(value, $aa238d137d91f8cb$var$symToStringTag), tag = value[$aa238d137d91f8cb$var$symToStringTag];
    try {
        value[$aa238d137d91f8cb$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $aa238d137d91f8cb$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$aa238d137d91f8cb$var$symToStringTag] = tag;
        else delete value[$aa238d137d91f8cb$var$symToStringTag];
    }
    return result;
}
module.exports = $aa238d137d91f8cb$var$getRawTag;

});

parcelRegister("9FCOd", function(module, exports) {
/** Used for built-in method references. */ var $70a60c0d3d29e69f$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $70a60c0d3d29e69f$var$nativeObjectToString = $70a60c0d3d29e69f$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $70a60c0d3d29e69f$var$objectToString(value) {
    return $70a60c0d3d29e69f$var$nativeObjectToString.call(value);
}
module.exports = $70a60c0d3d29e69f$var$objectToString;

});


parcelRegister("fR4kx", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $b8af2a2b83213643$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $b8af2a2b83213643$var$isObject;

});


parcelRegister("jkwa1", function(module, exports) {

var $4whYr = parcelRequire("4whYr");
/** Used to detect methods masquerading as native. */ var $e128d5094e483083$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($4whYr && $4whYr.keys && $4whYr.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $e128d5094e483083$var$isMasked(func) {
    return !!$e128d5094e483083$var$maskSrcKey && $e128d5094e483083$var$maskSrcKey in func;
}
module.exports = $e128d5094e483083$var$isMasked;

});
parcelRegister("4whYr", function(module, exports) {

var $7FBld = parcelRequire("7FBld");
/** Used to detect overreaching core-js shims. */ var $34a817d25f6e4bf0$var$coreJsData = $7FBld["__core-js_shared__"];
module.exports = $34a817d25f6e4bf0$var$coreJsData;

});


parcelRegister("4xClN", function(module, exports) {
/** Used for built-in method references. */ var $34e7fe22ecb25185$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $34e7fe22ecb25185$var$funcToString = $34e7fe22ecb25185$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $34e7fe22ecb25185$var$toSource(func) {
    if (func != null) {
        try {
            return $34e7fe22ecb25185$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $34e7fe22ecb25185$var$toSource;

});


parcelRegister("hHmRc", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $ce282ec36a0c8521$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $ce282ec36a0c8521$var$getValue;

});




parcelRegister("7mSvq", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $55d4de34a44fe8fa$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $55d4de34a44fe8fa$var$eq;

});


parcelRegister("f1LNj", function(module, exports) {

var $eIEhU = parcelRequire("eIEhU");

var $bkp0d = parcelRequire("bkp0d");

var $epPWY = parcelRequire("epPWY");

var $hS40T = parcelRequire("hS40T");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $af0c05ff535f2288$var$castPath(value, object) {
    if ($eIEhU(value)) return value;
    return $bkp0d(value, object) ? [
        value
    ] : $epPWY($hS40T(value));
}
module.exports = $af0c05ff535f2288$var$castPath;

});
parcelRegister("eIEhU", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $ab746d137db7c6e9$var$isArray = Array.isArray;
module.exports = $ab746d137db7c6e9$var$isArray;

});

parcelRegister("bkp0d", function(module, exports) {

var $eIEhU = parcelRequire("eIEhU");

var $biZPJ = parcelRequire("biZPJ");
/** Used to match property names within property paths. */ var $83f4f4eafe26987e$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $83f4f4eafe26987e$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $83f4f4eafe26987e$var$isKey(value, object) {
    if ($eIEhU(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $biZPJ(value)) return true;
    return $83f4f4eafe26987e$var$reIsPlainProp.test(value) || !$83f4f4eafe26987e$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $83f4f4eafe26987e$var$isKey;

});
parcelRegister("biZPJ", function(module, exports) {

var $bf9T1 = parcelRequire("bf9T1");

var $9uXwq = parcelRequire("9uXwq");
/** `Object#toString` result references. */ var $83b156f982b0e943$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $83b156f982b0e943$var$isSymbol(value) {
    return typeof value == 'symbol' || $9uXwq(value) && $bf9T1(value) == $83b156f982b0e943$var$symbolTag;
}
module.exports = $83b156f982b0e943$var$isSymbol;

});
parcelRegister("9uXwq", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $6ea51635a5ad209e$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $6ea51635a5ad209e$var$isObjectLike;

});



parcelRegister("epPWY", function(module, exports) {

var $gIV4j = parcelRequire("gIV4j");
/** Used to match property names within property paths. */ var $a7ebb2b487ad1eb2$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $a7ebb2b487ad1eb2$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $a7ebb2b487ad1eb2$var$stringToPath = $gIV4j(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($a7ebb2b487ad1eb2$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($a7ebb2b487ad1eb2$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $a7ebb2b487ad1eb2$var$stringToPath;

});
parcelRegister("gIV4j", function(module, exports) {

var $7PwBX = parcelRequire("7PwBX");
/** Used as the maximum memoize cache size. */ var $c2cd0606a5d4cadd$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $c2cd0606a5d4cadd$var$memoizeCapped(func) {
    var result = $7PwBX(func, function(key) {
        if (cache.size === $c2cd0606a5d4cadd$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $c2cd0606a5d4cadd$var$memoizeCapped;

});
parcelRegister("7PwBX", function(module, exports) {

var $g9iqB = parcelRequire("g9iqB");
/** Error message constants. */ var $5b3697ba4cc69cb3$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $5b3697ba4cc69cb3$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($5b3697ba4cc69cb3$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($5b3697ba4cc69cb3$var$memoize.Cache || $g9iqB);
    return memoized;
}
// Expose `MapCache`.
$5b3697ba4cc69cb3$var$memoize.Cache = $g9iqB;
module.exports = $5b3697ba4cc69cb3$var$memoize;

});
parcelRegister("g9iqB", function(module, exports) {

var $253rh = parcelRequire("253rh");

var $hEI8A = parcelRequire("hEI8A");

var $8Y6dI = parcelRequire("8Y6dI");

var $8ZkQD = parcelRequire("8ZkQD");

var $4dj5q = parcelRequire("4dj5q");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bc1bc80ed4f398e0$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$bc1bc80ed4f398e0$var$MapCache.prototype.clear = $253rh;
$bc1bc80ed4f398e0$var$MapCache.prototype['delete'] = $hEI8A;
$bc1bc80ed4f398e0$var$MapCache.prototype.get = $8Y6dI;
$bc1bc80ed4f398e0$var$MapCache.prototype.has = $8ZkQD;
$bc1bc80ed4f398e0$var$MapCache.prototype.set = $4dj5q;
module.exports = $bc1bc80ed4f398e0$var$MapCache;

});
parcelRegister("253rh", function(module, exports) {

var $aTpbu = parcelRequire("aTpbu");

var $3HTTV = parcelRequire("3HTTV");

var $lRBu4 = parcelRequire("lRBu4");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $183eb74f8935de80$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $aTpbu,
        'map': new ($lRBu4 || $3HTTV),
        'string': new $aTpbu
    };
}
module.exports = $183eb74f8935de80$var$mapCacheClear;

});
parcelRegister("aTpbu", function(module, exports) {

var $fp3LP = parcelRequire("fp3LP");

var $9fs8a = parcelRequire("9fs8a");

var $gy9jz = parcelRequire("gy9jz");

var $3FQ49 = parcelRequire("3FQ49");

var $8maQl = parcelRequire("8maQl");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $7ee2937f0cc4a7b2$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$7ee2937f0cc4a7b2$var$Hash.prototype.clear = $fp3LP;
$7ee2937f0cc4a7b2$var$Hash.prototype['delete'] = $9fs8a;
$7ee2937f0cc4a7b2$var$Hash.prototype.get = $gy9jz;
$7ee2937f0cc4a7b2$var$Hash.prototype.has = $3FQ49;
$7ee2937f0cc4a7b2$var$Hash.prototype.set = $8maQl;
module.exports = $7ee2937f0cc4a7b2$var$Hash;

});
parcelRegister("fp3LP", function(module, exports) {

var $g6Ght = parcelRequire("g6Ght");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $b36c1d8c2959384c$var$hashClear() {
    this.__data__ = $g6Ght ? $g6Ght(null) : {};
    this.size = 0;
}
module.exports = $b36c1d8c2959384c$var$hashClear;

});
parcelRegister("g6Ght", function(module, exports) {

var $j3AXy = parcelRequire("j3AXy");
/* Built-in method references that are verified to be native. */ var $bb9e00f3f7d644cd$var$nativeCreate = $j3AXy(Object, 'create');
module.exports = $bb9e00f3f7d644cd$var$nativeCreate;

});


parcelRegister("9fs8a", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $6bbb55ec4022d39e$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $6bbb55ec4022d39e$var$hashDelete;

});

parcelRegister("gy9jz", function(module, exports) {

var $g6Ght = parcelRequire("g6Ght");
/** Used to stand-in for `undefined` hash values. */ var $c0c70bff86a18c78$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $c0c70bff86a18c78$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c0c70bff86a18c78$var$hasOwnProperty = $c0c70bff86a18c78$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $c0c70bff86a18c78$var$hashGet(key) {
    var data = this.__data__;
    if ($g6Ght) {
        var result = data[key];
        return result === $c0c70bff86a18c78$var$HASH_UNDEFINED ? undefined : result;
    }
    return $c0c70bff86a18c78$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $c0c70bff86a18c78$var$hashGet;

});

parcelRegister("3FQ49", function(module, exports) {

var $g6Ght = parcelRequire("g6Ght");
/** Used for built-in method references. */ var $2acd96a34fb698b2$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2acd96a34fb698b2$var$hasOwnProperty = $2acd96a34fb698b2$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $2acd96a34fb698b2$var$hashHas(key) {
    var data = this.__data__;
    return $g6Ght ? data[key] !== undefined : $2acd96a34fb698b2$var$hasOwnProperty.call(data, key);
}
module.exports = $2acd96a34fb698b2$var$hashHas;

});

parcelRegister("8maQl", function(module, exports) {

var $g6Ght = parcelRequire("g6Ght");
/** Used to stand-in for `undefined` hash values. */ var $6158ca08574993c7$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $6158ca08574993c7$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $g6Ght && value === undefined ? $6158ca08574993c7$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $6158ca08574993c7$var$hashSet;

});


parcelRegister("3HTTV", function(module, exports) {

var $kzf50 = parcelRequire("kzf50");

var $eA5Lx = parcelRequire("eA5Lx");

var $05jN5 = parcelRequire("05jN5");

var $9yFiD = parcelRequire("9yFiD");

var $8xfG4 = parcelRequire("8xfG4");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $2b30c00d3a72bc4e$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$2b30c00d3a72bc4e$var$ListCache.prototype.clear = $kzf50;
$2b30c00d3a72bc4e$var$ListCache.prototype['delete'] = $eA5Lx;
$2b30c00d3a72bc4e$var$ListCache.prototype.get = $05jN5;
$2b30c00d3a72bc4e$var$ListCache.prototype.has = $9yFiD;
$2b30c00d3a72bc4e$var$ListCache.prototype.set = $8xfG4;
module.exports = $2b30c00d3a72bc4e$var$ListCache;

});
parcelRegister("kzf50", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $ef92c60c9b317d4c$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $ef92c60c9b317d4c$var$listCacheClear;

});

parcelRegister("eA5Lx", function(module, exports) {

var $ggjHT = parcelRequire("ggjHT");
/** Used for built-in method references. */ var $a9d8e6747cdf8475$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $a9d8e6747cdf8475$var$splice = $a9d8e6747cdf8475$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $a9d8e6747cdf8475$var$listCacheDelete(key) {
    var data = this.__data__, index = $ggjHT(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $a9d8e6747cdf8475$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $a9d8e6747cdf8475$var$listCacheDelete;

});
parcelRegister("ggjHT", function(module, exports) {

var $7mSvq = parcelRequire("7mSvq");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bd6d6d5dfeb57c85$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($7mSvq(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $bd6d6d5dfeb57c85$var$assocIndexOf;

});


parcelRegister("05jN5", function(module, exports) {

var $ggjHT = parcelRequire("ggjHT");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $00ffd1c98808a8a3$var$listCacheGet(key) {
    var data = this.__data__, index = $ggjHT(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $00ffd1c98808a8a3$var$listCacheGet;

});

parcelRegister("9yFiD", function(module, exports) {

var $ggjHT = parcelRequire("ggjHT");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $6f5753430ee2aa1a$var$listCacheHas(key) {
    return $ggjHT(this.__data__, key) > -1;
}
module.exports = $6f5753430ee2aa1a$var$listCacheHas;

});

parcelRegister("8xfG4", function(module, exports) {

var $ggjHT = parcelRequire("ggjHT");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $636d9103c695874b$var$listCacheSet(key, value) {
    var data = this.__data__, index = $ggjHT(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $636d9103c695874b$var$listCacheSet;

});


parcelRegister("lRBu4", function(module, exports) {

var $j3AXy = parcelRequire("j3AXy");

var $7FBld = parcelRequire("7FBld");
/* Built-in method references that are verified to be native. */ var $feab9fbce561f4bb$var$Map = $j3AXy($7FBld, 'Map');
module.exports = $feab9fbce561f4bb$var$Map;

});


parcelRegister("hEI8A", function(module, exports) {

var $9oOw7 = parcelRequire("9oOw7");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $cda868e487c8ed09$var$mapCacheDelete(key) {
    var result = $9oOw7(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $cda868e487c8ed09$var$mapCacheDelete;

});
parcelRegister("9oOw7", function(module, exports) {

var $kcfmH = parcelRequire("kcfmH");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $6d7d8a8f363eb7a5$var$getMapData(map, key) {
    var data = map.__data__;
    return $kcfmH(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $6d7d8a8f363eb7a5$var$getMapData;

});
parcelRegister("kcfmH", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $eb40d8d95b69d22c$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $eb40d8d95b69d22c$var$isKeyable;

});



parcelRegister("8Y6dI", function(module, exports) {

var $9oOw7 = parcelRequire("9oOw7");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $6878c085f54f7a62$var$mapCacheGet(key) {
    return $9oOw7(this, key).get(key);
}
module.exports = $6878c085f54f7a62$var$mapCacheGet;

});

parcelRegister("8ZkQD", function(module, exports) {

var $9oOw7 = parcelRequire("9oOw7");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $68b4313611243b2f$var$mapCacheHas(key) {
    return $9oOw7(this, key).has(key);
}
module.exports = $68b4313611243b2f$var$mapCacheHas;

});

parcelRegister("4dj5q", function(module, exports) {

var $9oOw7 = parcelRequire("9oOw7");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $31172e80a1734e75$var$mapCacheSet(key, value) {
    var data = $9oOw7(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $31172e80a1734e75$var$mapCacheSet;

});





parcelRegister("hS40T", function(module, exports) {

var $fgjtm = parcelRequire("fgjtm");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $d02a97d161a0dc1b$var$toString(value) {
    return value == null ? '' : $fgjtm(value);
}
module.exports = $d02a97d161a0dc1b$var$toString;

});
parcelRegister("fgjtm", function(module, exports) {

var $1ke0A = parcelRequire("1ke0A");

var $6EKca = parcelRequire("6EKca");

var $eIEhU = parcelRequire("eIEhU");

var $biZPJ = parcelRequire("biZPJ");
/** Used as references for various `Number` constants. */ var $b1c77478d375bc51$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $b1c77478d375bc51$var$symbolProto = $1ke0A ? $1ke0A.prototype : undefined, $b1c77478d375bc51$var$symbolToString = $b1c77478d375bc51$var$symbolProto ? $b1c77478d375bc51$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $b1c77478d375bc51$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($eIEhU(value)) // Recursively convert values (susceptible to call stack limits).
    return $6EKca(value, $b1c77478d375bc51$var$baseToString) + '';
    if ($biZPJ(value)) return $b1c77478d375bc51$var$symbolToString ? $b1c77478d375bc51$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$b1c77478d375bc51$var$INFINITY ? '-0' : result;
}
module.exports = $b1c77478d375bc51$var$baseToString;

});
parcelRegister("6EKca", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $4d8a4fed52aba282$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $4d8a4fed52aba282$var$arrayMap;

});




parcelRegister("2Jb0d", function(module, exports) {
/** Used as references for various `Number` constants. */ var $1fc8519501250388$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $1fc8519501250388$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $1fc8519501250388$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $1fc8519501250388$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $1fc8519501250388$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $1fc8519501250388$var$isIndex;

});

parcelRegister("lky4s", function(module, exports) {

var $biZPJ = parcelRequire("biZPJ");
/** Used as references for various `Number` constants. */ var $f875e4fef55a89f0$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $f875e4fef55a89f0$var$toKey(value) {
    if (typeof value == 'string' || $biZPJ(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$f875e4fef55a89f0$var$INFINITY ? '-0' : result;
}
module.exports = $f875e4fef55a89f0$var$toKey;

});



parcelRegister("bpIx8", function(module, exports) {

$parcel$export(module.exports, "getFirstErrorField", function () { return $84f492ebaaac7ed9$export$fc06342dc8588d3b; });

var $cZpyO = parcelRequire("cZpyO");
var $84f492ebaaac7ed9$export$fc06342dc8588d3b = function getFirstErrorField(inputs, errors) {
    // Guaranteed to be of type HTMLInputElement[] due to getInputs function overrided in createDecorator
    var htmlInputs = inputs;
    return htmlInputs.find(function(input) {
        // If input is hidden, do not focus
        if (input.type === 'hidden') return false;
        // If input ID matches the error, focus
        if (input.id && (0, $cZpyO.getIn)(errors, input.id)) return true;
        // Default to base behavior
        return input.name && (0, $cZpyO.getIn)(errors, input.name);
    });
};

});


parcelRegister("4xOBh", function(module, exports) {

$parcel$export(module.exports, "Label", function () { return $34f17ea2aa2138f2$export$b04be29aa201d4f5; });
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");
var $34f17ea2aa2138f2$var$fieldsetLabelStyles = null;
var $34f17ea2aa2138f2$export$b04be29aa201d4f5 = function Label(_ref) {
    var children = _ref.children, htmlFor = _ref.htmlFor, id = _ref.id, testId = _ref.testId;
    return /*#__PURE__*/ $91i6m.createElement("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $9gzWK.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ])
    }, children);
};
var $34f17ea2aa2138f2$export$ed247974535929c7 = function Legend(_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/ $91i6m.createElement("legend", {
        className: (0, $9gzWK.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ])
    }, children);
};

});

parcelRegister("1o8Ff", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $102ec0dcd9159807$export$2e2bcd8739ae039; });
/* required-asterisk.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");
var $102ec0dcd9159807$var$requiredIndicatorStyles = null;
function $102ec0dcd9159807$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ $91i6m.createElement("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $9gzWK.default)([
            "_syaz1ick _ect41gqc _bozgv77o"
        ])
    }, "*");
}

});


parcelRegister("TJrLs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a7863f5b2afd1f0$export$2e2bcd8739ae039; });

var $iqLBO = parcelRequire("iqLBO");

var $91i6m = parcelRequire("91i6m");

var $boAHD = parcelRequire("boAHD");

var $lBrex = parcelRequire("lBrex");

var $c32T7 = parcelRequire("c32T7");
var $0a7863f5b2afd1f0$var$flexGrowMap = {
    hug: (0, $lBrex.xcss)({
        flexGrow: 0
    }),
    fill: (0, $lBrex.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
var $0a7863f5b2afd1f0$var$separatorStyles = (0, $boAHD.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none',
    userSelect: 'none'
});
var $0a7863f5b2afd1f0$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $boAHD.jsx)("span", {
        css: $0a7863f5b2afd1f0$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $0a7863f5b2afd1f0$var$Inline = /*#__PURE__*/ (0, $91i6m.memo)(/*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, id = _ref2.id, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === 'string' ? (0, $boAHD.jsx)($0a7863f5b2afd1f0$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $91i6m.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $boAHD.jsx)((0, $91i6m.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $0a7863f5b2afd1f0$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $boAHD.jsx)((0, $c32T7.default), {
        id: id,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$0a7863f5b2afd1f0$var$Inline.displayName = 'Inline';
var $0a7863f5b2afd1f0$export$2e2bcd8739ae039 = $0a7863f5b2afd1f0$var$Inline;

});
parcelRegister("lBrex", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $fba22db24ccc945a$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $fba22db24ccc945a$export$f6c783d06584602c; });

var $iqLBO = parcelRequire("iqLBO");

var $dsN6L = parcelRequire("dsN6L");

var $5YM7L = parcelRequire("5YM7L");

var $61RDg = parcelRequire("61RDg");

var $boAHD = parcelRequire("boAHD");

var $7re4P = parcelRequire("7re4P");

var $e08gr = parcelRequire("e08gr");
function $fba22db24ccc945a$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $fba22db24ccc945a$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $fba22db24ccc945a$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $fba22db24ccc945a$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $fba22db24ccc945a$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $fba22db24ccc945a$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $fba22db24ccc945a$export$9a199fbafee0014e = {
    backgroundColor: (0, $7re4P.backgroundColorMap),
    blockSize: (0, $7re4P.dimensionMap),
    borderBlockColor: (0, $7re4P.borderColorMap),
    borderBlockEndColor: (0, $7re4P.borderColorMap),
    borderBlockEndWidth: (0, $7re4P.borderWidthMap),
    borderBlockStartColor: (0, $7re4P.borderColorMap),
    borderBlockStartWidth: (0, $7re4P.borderWidthMap),
    borderBlockWidth: (0, $7re4P.borderWidthMap),
    borderBottomColor: (0, $7re4P.borderColorMap),
    borderBottomLeftRadius: (0, $7re4P.borderRadiusMap),
    borderBottomRightRadius: (0, $7re4P.borderRadiusMap),
    borderBottomWidth: (0, $7re4P.borderWidthMap),
    borderColor: (0, $7re4P.borderColorMap),
    borderEndEndRadius: (0, $7re4P.borderRadiusMap),
    borderEndStartRadius: (0, $7re4P.borderRadiusMap),
    borderInlineColor: (0, $7re4P.borderColorMap),
    borderInlineEndColor: (0, $7re4P.borderColorMap),
    borderInlineEndWidth: (0, $7re4P.borderWidthMap),
    borderInlineStartColor: (0, $7re4P.borderColorMap),
    borderInlineStartWidth: (0, $7re4P.borderWidthMap),
    borderInlineWidth: (0, $7re4P.borderWidthMap),
    borderLeftColor: (0, $7re4P.borderColorMap),
    borderLeftWidth: (0, $7re4P.borderWidthMap),
    borderRadius: (0, $7re4P.borderRadiusMap),
    borderRightColor: (0, $7re4P.borderColorMap),
    borderRightWidth: (0, $7re4P.borderWidthMap),
    borderStartEndRadius: (0, $7re4P.borderRadiusMap),
    borderStartStartRadius: (0, $7re4P.borderRadiusMap),
    borderTopColor: (0, $7re4P.borderColorMap),
    borderTopLeftRadius: (0, $7re4P.borderRadiusMap),
    borderTopRightRadius: (0, $7re4P.borderRadiusMap),
    borderTopWidth: (0, $7re4P.borderWidthMap),
    borderWidth: (0, $7re4P.borderWidthMap),
    bottom: (0, $7re4P.allSpaceMap),
    boxShadow: (0, $7re4P.shadowMap),
    color: (0, $7re4P.textColorMap),
    columnGap: (0, $7re4P.positiveSpaceMap),
    font: (0, $7re4P.fontMap),
    fontFamily: (0, $7re4P.fontFamilyMap),
    fontWeight: (0, $7re4P.fontWeightMap),
    gap: (0, $7re4P.positiveSpaceMap),
    height: (0, $7re4P.dimensionMap),
    inlineSize: (0, $7re4P.dimensionMap),
    inset: (0, $7re4P.allSpaceMap),
    insetBlock: (0, $7re4P.allSpaceMap),
    insetBlockEnd: (0, $7re4P.allSpaceMap),
    insetBlockStart: (0, $7re4P.allSpaceMap),
    insetInline: (0, $7re4P.allSpaceMap),
    insetInlineEnd: (0, $7re4P.allSpaceMap),
    insetInlineStart: (0, $7re4P.allSpaceMap),
    left: (0, $7re4P.allSpaceMap),
    margin: (0, $7re4P.allSpaceMap),
    marginBlock: (0, $7re4P.allSpaceMap),
    marginBlockEnd: (0, $7re4P.allSpaceMap),
    marginBlockStart: (0, $7re4P.allSpaceMap),
    marginBottom: (0, $7re4P.allSpaceMap),
    marginInline: (0, $7re4P.allSpaceMap),
    marginInlineEnd: (0, $7re4P.allSpaceMap),
    marginInlineStart: (0, $7re4P.allSpaceMap),
    marginLeft: (0, $7re4P.allSpaceMap),
    marginRight: (0, $7re4P.allSpaceMap),
    marginTop: (0, $7re4P.allSpaceMap),
    maxBlockSize: (0, $7re4P.dimensionMap),
    maxHeight: (0, $7re4P.dimensionMap),
    maxInlineSize: (0, $7re4P.dimensionMap),
    maxWidth: (0, $7re4P.dimensionMap),
    minBlockSize: (0, $7re4P.dimensionMap),
    minHeight: (0, $7re4P.dimensionMap),
    minInlineSize: (0, $7re4P.dimensionMap),
    minWidth: (0, $7re4P.dimensionMap),
    opacity: (0, $7re4P.opacityMap),
    outlineColor: (0, $7re4P.borderColorMap),
    outlineOffset: (0, $7re4P.allSpaceMap),
    outlineWidth: (0, $7re4P.borderWidthMap),
    padding: (0, $7re4P.positiveSpaceMap),
    paddingBlock: (0, $7re4P.positiveSpaceMap),
    paddingBlockEnd: (0, $7re4P.positiveSpaceMap),
    paddingBlockStart: (0, $7re4P.positiveSpaceMap),
    paddingBottom: (0, $7re4P.positiveSpaceMap),
    paddingInline: (0, $7re4P.positiveSpaceMap),
    paddingInlineEnd: (0, $7re4P.positiveSpaceMap),
    paddingInlineStart: (0, $7re4P.positiveSpaceMap),
    paddingLeft: (0, $7re4P.positiveSpaceMap),
    paddingRight: (0, $7re4P.positiveSpaceMap),
    paddingTop: (0, $7re4P.positiveSpaceMap),
    right: (0, $7re4P.allSpaceMap),
    rowGap: (0, $7re4P.positiveSpaceMap),
    top: (0, $7re4P.allSpaceMap),
    width: (0, $7re4P.dimensionMap),
    zIndex: (0, $7re4P.layerMap)
};
var $fba22db24ccc945a$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $fba22db24ccc945a$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $e08gr === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))($e08gr)) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))($e08gr.env) === 'object' && false;
};
var $fba22db24ccc945a$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $fba22db24ccc945a$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $fba22db24ccc945a$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($fba22db24ccc945a$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(value) === 'object' && $fba22db24ccc945a$var$safeSelectors.test(key)) {
            styleObj[key] = $fba22db24ccc945a$var$_transformStyles(value);
            return;
        }
        if ($fba22db24ccc945a$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($fba22db24ccc945a$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $fba22db24ccc945a$export$9a199fbafee0014e)) return;
        var tokenValue = $fba22db24ccc945a$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $fba22db24ccc945a$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $fba22db24ccc945a$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, $fba22db24ccc945a$var$uniqueSymbol, (0, $boAHD.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $fba22db24ccc945a$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $fba22db24ccc945a$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $fba22db24ccc945a$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$fba22db24ccc945a$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $fba22db24ccc945a$export$f6c783d06584602c(style) {
    return $fba22db24ccc945a$var$baseXcss(style);
}

});

parcelRegister("c32T7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c58015664b03a7f$export$2e2bcd8739ae039; });

var $iqLBO = parcelRequire("iqLBO");

var $91i6m = parcelRequire("91i6m");

var $boAHD = parcelRequire("boAHD");

var $7re4P = parcelRequire("7re4P");

var $lBrex = parcelRequire("lBrex");
var $8c58015664b03a7f$var$justifyContentMap = {
    start: (0, $boAHD.css)({
        justifyContent: 'start'
    }),
    center: (0, $boAHD.css)({
        justifyContent: 'center'
    }),
    end: (0, $boAHD.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $boAHD.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $boAHD.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $boAHD.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $boAHD.css)({
        justifyContent: 'stretch'
    })
};
var $8c58015664b03a7f$var$flexDirectionMap = {
    column: (0, $boAHD.css)({
        flexDirection: 'column'
    }),
    row: (0, $boAHD.css)({
        flexDirection: 'row'
    })
};
var $8c58015664b03a7f$var$flexWrapMap = {
    wrap: (0, $boAHD.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $boAHD.css)({
        flexWrap: 'nowrap'
    })
};
var $8c58015664b03a7f$var$alignItemsMap = {
    start: (0, $boAHD.css)({
        alignItems: 'start'
    }),
    center: (0, $boAHD.css)({
        alignItems: 'center'
    }),
    baseline: (0, $boAHD.css)({
        alignItems: 'baseline'
    }),
    end: (0, $boAHD.css)({
        alignItems: 'end'
    }),
    stretch: (0, $boAHD.css)({
        alignItems: 'stretch'
    })
};
var $8c58015664b03a7f$var$baseStyles = (0, $boAHD.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $8c58015664b03a7f$var$Flex = /*#__PURE__*/ (0, $91i6m.memo)(/*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, id = _ref.id;
    var resolvedStyles = (0, $lBrex.parseXcss)(xcss);
    return (0, $boAHD.jsx)(Component, {
        id: id,
        role: role,
        className: resolvedStyles.static,
        css: [
            $8c58015664b03a7f$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $7re4P.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $7re4P.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $7re4P.spaceStylesMap).rowGap[rowGap],
            alignItems && $8c58015664b03a7f$var$alignItemsMap[alignItems],
            direction && $8c58015664b03a7f$var$flexDirectionMap[direction],
            justifyContent && $8c58015664b03a7f$var$justifyContentMap[justifyContent],
            wrap && $8c58015664b03a7f$var$flexWrapMap[wrap]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(resolvedStyles.emotion || [])),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$8c58015664b03a7f$var$Flex.displayName = 'Flex';
var $8c58015664b03a7f$export$2e2bcd8739ae039 = $8c58015664b03a7f$var$Flex;

});



parcelRegister("4dDtg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bce9c122e4868822$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $bce9c122e4868822$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    mfFormLabel: {
        id: 'mf.mfform.placeholder.generic',
        defaultMessage: 'Verification code',
        description: 'Placeholder hint for the verification code textfield when the expected code length is unknown'
    },
    mfFormLabelNDigits: {
        id: 'mf.mfform.placeholder.ndigits',
        defaultMessage: '{codeLength}-digit verification code',
        description: ''
    },
    mfFormLabelNCharacters: {
        id: 'mf.mfform.placeholder.ncharacters',
        defaultMessage: '{codeLength, plural, one {# character} other {# characters}} verification code',
        description: ''
    },
    errorsInvalidOtp: {
        id: 'mf.mfform.errors.invalid_otp',
        defaultMessage: 'You entered an incorrect verification code.'
    },
    errorsInvalidOtpFormat: {
        id: 'mf.mfform.errors.invalid_otp_format',
        defaultMessage: 'You entered an invalid verification code.'
    },
    errorsInvalidOtpPattern: {
        id: 'mf.mfform.errors.invalid_otp_pattern',
        defaultMessage: 'Your verification code needs to be {codeLength, plural, one {# character} other {# characters}}.'
    },
    errorsExpiredOtp: {
        id: 'mf.mfform.errors.expired_otp',
        defaultMessage: 'Your verification code has expired.'
    },
    errorsUnknown: {
        id: 'mf.mfform.errors.unknown',
        defaultMessage: 'Unknown error occurred. Please try again.'
    }
});

});


parcelRegister("6GpTs", function(module, exports) {

$parcel$export(module.exports, "SecurityWall", function () { return $a7f6b75303c8dd01$export$4584cd3084bcd78; });

var $4ZSso = parcelRequire("4ZSso");

var $9jjaN = parcelRequire("9jjaN");

var $fZwbQ = parcelRequire("fZwbQ");

var $6ZLav = parcelRequire("6ZLav");

var $26Riy = parcelRequire("26Riy");

var $6e88g = parcelRequire("6e88g");

var $91i6m = parcelRequire("91i6m");
let $a7f6b75303c8dd01$var$_ = (t)=>t, $a7f6b75303c8dd01$var$t, $a7f6b75303c8dd01$var$t1, $a7f6b75303c8dd01$var$t2, $a7f6b75303c8dd01$var$t3, $a7f6b75303c8dd01$var$t4;
const $a7f6b75303c8dd01$var$DefaultSecurityWallContainer = (0, $9jjaN.default).div($a7f6b75303c8dd01$var$t1 || ($a7f6b75303c8dd01$var$t1 = $a7f6b75303c8dd01$var$_`
  background: url(${0}) no-repeat center 0 / ${0}px;
  min-width: 100%;
  margin-top: ${0}px;
  padding-top: ${0}px;
  box-sizing: border-box;

  ${0}
`), (0, (/*@__PURE__*/$parcel$interopDefault($fZwbQ))), (0, $6e88g.gridSize)() * 14.5, (0, $6e88g.gridSize)(), (0, $6e88g.gridSize)() * 18, (0, $26Riy.media).handheld($a7f6b75303c8dd01$var$t || ($a7f6b75303c8dd01$var$t = $a7f6b75303c8dd01$var$_`
    background: 0;
    padding: 0;
  `)));
const $a7f6b75303c8dd01$var$TotpChallengeContainer = (0, $9jjaN.default).div($a7f6b75303c8dd01$var$t3 || ($a7f6b75303c8dd01$var$t3 = $a7f6b75303c8dd01$var$_`
  background: url(${0}) no-repeat center 0 / ${0}px;
  min-width: 100%;
  margin-top: ${0}px;
  padding-top: ${0}px;
  box-sizing: border-box;

  ${0}
`), (0, (/*@__PURE__*/$parcel$interopDefault($6ZLav))), (0, $6e88g.gridSize)() * 30, (0, $6e88g.gridSize)(), (0, $6e88g.gridSize)() * 18, (0, $26Riy.media).handheld($a7f6b75303c8dd01$var$t2 || ($a7f6b75303c8dd01$var$t2 = $a7f6b75303c8dd01$var$_`
    background: none;
    padding: 0;
  `)));
const $a7f6b75303c8dd01$var$SuccessfulResetSecurityWallContainer = (0, $9jjaN.default).div($a7f6b75303c8dd01$var$t4 || ($a7f6b75303c8dd01$var$t4 = $a7f6b75303c8dd01$var$_`
  background: url(${0}) no-repeat center;
  height: ${0}px;
  margin-top: ${0}px;
  margin-bottom: ${0}px;
`), (0, (/*@__PURE__*/$parcel$interopDefault($fZwbQ))), (0, $6e88g.gridSize)() * 14.5, (0, $6e88g.gridSize)() * 1, (0, $6e88g.gridSize)() * 1.5);
const $a7f6b75303c8dd01$export$4584cd3084bcd78 = ({ children: children, id: id, securityWallStyle: securityWallStyle })=>{
    const WallComponent = (0, $91i6m.useMemo)(()=>{
        switch(securityWallStyle){
            case 'password-reset':
                return $a7f6b75303c8dd01$var$SuccessfulResetSecurityWallContainer;
            case 'totp':
                return $a7f6b75303c8dd01$var$TotpChallengeContainer;
            default:
                return $a7f6b75303c8dd01$var$DefaultSecurityWallContainer;
        }
    }, [
        securityWallStyle
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)(WallComponent, {
        id: id,
        children: children
    });
};

});
parcelRegister("fZwbQ", function(module, exports) {

module.exports = (parcelRequire("cgi2g")).getBundleURL('9rAa3') + "security-wall.788bd489.svg";

});


parcelRegister("6FRcv", function(module, exports) {

$parcel$export(module.exports, "InlineMessageContainer", function () { return $edc23b6aae68a5f1$export$327fb3a223d00cf3; });
$parcel$export(module.exports, "StyledMessage", function () { return $edc23b6aae68a5f1$export$ca8581ef51d2f0a9; });
$parcel$export(module.exports, "InputMessage", function () { return $edc23b6aae68a5f1$export$d2966f371054ad4a; });

var $9jjaN = parcelRequire("9jjaN");

var $6e88g = parcelRequire("6e88g");
let $edc23b6aae68a5f1$var$_ = (t)=>t, $edc23b6aae68a5f1$var$t, $edc23b6aae68a5f1$var$t1, $edc23b6aae68a5f1$var$t2;
const $edc23b6aae68a5f1$export$327fb3a223d00cf3 = (0, $9jjaN.default).div($edc23b6aae68a5f1$var$t || ($edc23b6aae68a5f1$var$t = $edc23b6aae68a5f1$var$_`
  margin-left: 4px;
  display: inline-block;
  vertical-align: middle;
`));
const $edc23b6aae68a5f1$export$ca8581ef51d2f0a9 = (0, $9jjaN.default).div($edc23b6aae68a5f1$var$t1 || ($edc23b6aae68a5f1$var$t1 = $edc23b6aae68a5f1$var$_`
  width: calc(50vw - ${0}px);
  max-width: ${0}px;
  margin-left: -${0}px;
  margin-right: -${0}px;
`), (0, $6e88g.gridSize)() * 6, (0, $6e88g.gridSize)() * 34, (0, $6e88g.gridSize)(), (0, $6e88g.gridSize)());
const $edc23b6aae68a5f1$export$d2966f371054ad4a = (0, $9jjaN.default).div($edc23b6aae68a5f1$var$t2 || ($edc23b6aae68a5f1$var$t2 = $edc23b6aae68a5f1$var$_`
  display: flex;
  justify-content: space-between;
  align-items: center;
`));

});

parcelRegister("6VTqX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a87c3e3284f991cd$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");
parcelRequire("26od7");
var $1tRwG = parcelRequire("1tRwG");

var $5xbP9 = parcelRequire("5xbP9");

var $6FRcv = parcelRequire("6FRcv");

var $5v178 = parcelRequire("5v178");

var $8iEgn = parcelRequire("8iEgn");

var $cLysE = parcelRequire("cLysE");

var $5az11 = parcelRequire("5az11");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $k8ZoM = parcelRequire("k8ZoM");

var $9jjaN = parcelRequire("9jjaN");

var $l9Zg5 = parcelRequire("l9Zg5");

var $9uXJ3 = parcelRequire("9uXJ3");
let $a87c3e3284f991cd$var$_ = (t)=>t, $a87c3e3284f991cd$var$t;
const $a87c3e3284f991cd$var$baseSpacing = (0, $k8ZoM.default)('space.100');
const $a87c3e3284f991cd$var$PAGE_ID = 'MfaChallengeSecurityKey';
const $a87c3e3284f991cd$var$ErrorMessageWrapper = (0, $9jjaN.default).div($a87c3e3284f991cd$var$t || ($a87c3e3284f991cd$var$t = $a87c3e3284f991cd$var$_`
  margin: calc(${0} * 2) 0;
`), $a87c3e3284f991cd$var$baseSpacing);
const $a87c3e3284f991cd$var$MfaChallengeSecurityKey = ()=>{
    const [errorMessage, setErrorMessage] = (0, $91i6m.useState)();
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const challengeErrorMessages = (0, $91i6m.useMemo)(()=>({
            // WebAuthn errors
            [(0, $l9Zg5.WebAuthnAuthenticationErrorCode).WebAuthnNotSupported]: formatMessage((0, $5xbP9.default).webauthnNotSupportedMessage),
            [(0, $l9Zg5.WebAuthnAuthenticationErrorCode).InvalidRequestOptions]: formatMessage((0, $5xbP9.default).webAuthnMalformedConfiguration // server returned bad options?
            ),
            [(0, $l9Zg5.WebAuthnAuthenticationErrorCode).Aborted]: formatMessage((0, $5xbP9.default).webAuthnAborted),
            [(0, $l9Zg5.WebAuthnAuthenticationErrorCode).NotAllowed]: formatMessage((0, $5xbP9.default).webAuthnAuthenticationIncomplete // eg. timeout, user cancelled
            ),
            [(0, $l9Zg5.WebAuthnAuthenticationErrorCode).InvalidDomain]: formatMessage((0, $5xbP9.default).webAuthnInvalidDomain),
            [(0, $l9Zg5.WebAuthnAuthenticationErrorCode).InvalidRpId]: formatMessage((0, $5xbP9.default).webAuthnMalformedConfiguration // server returned bad options?
            ),
            [(0, $l9Zg5.WebAuthnAuthenticationErrorCode).UnknownError]: formatMessage((0, $5xbP9.default).webauthnAuthenticationFailed),
            // API errors
            [(0, $1tRwG.ChallengeApiError).tooManyRequests]: formatMessage((0, $5xbP9.default).securityKeyTooManyAttemptsMessage),
            [(0, $1tRwG.ChallengeApiError).transactionTokenNotFound]: formatMessage((0, $5xbP9.default).failedToUseKeyMessage),
            [(0, $1tRwG.ChallengeApiError).challengeFailure]: formatMessage((0, $5xbP9.default).failedToUseKeyMessage)
        }), [
        formatMessage
    ]);
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    const { challengeSecurityKey: challengeSecurityKey, authenticating: authenticating } = (0, $1tRwG.useChallengeSecurityKey)($a87c3e3284f991cd$var$PAGE_ID, (responseData)=>{
        const redirectUri = responseData.redirectUri;
        navigate(redirectUri.toString());
    }, (error)=>{
        setErrorMessage(challengeErrorMessages[error] || formatMessage((0, $5xbP9.default).failedToUseKeyMessage));
    });
    const invokeChallengeSecurityKey = ()=>{
        setErrorMessage(undefined);
        challengeSecurityKey();
    };
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $5az11.SecurityKey), {
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $6FRcv.InputMessage), {
                style: {
                    margin: `${$a87c3e3284f991cd$var$baseSpacing} 0`
                },
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                        id: "mf.mfform.securitykey.authenticate",
                        defaultMessage: "Use your security key to continue."
                    }),
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6FRcv.InlineMessageContainer), {
                        "data-testid": "mfform-tooltip-icon",
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $5v178.default), {
                            appearance: "info",
                            placement: "bottom-end",
                            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6FRcv.StyledMessage), {
                                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                                    id: "mf.mfform.securitykey.tooltip",
                                    defaultMessage: "Use any security key you registered with Atlassian"
                                })
                            })
                        })
                    })
                ]
            }),
            errorMessage && /*#__PURE__*/ (0, $4ZSso.jsx)($a87c3e3284f991cd$var$ErrorMessageWrapper, {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8iEgn.default), {
                    appearance: "warning",
                    children: errorMessage
                })
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                id: "challenge-security-key",
                appearance: "primary",
                isFullWidth: true,
                onClick: invokeChallengeSecurityKey,
                isLoading: authenticating,
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "mf.mfform.securitykey",
                    defaultMessage: "Log in"
                })
            })
        ]
    });
};
var $a87c3e3284f991cd$export$2e2bcd8739ae039 = $a87c3e3284f991cd$var$MfaChallengeSecurityKey;

});
parcelRegister("26od7", function(module, exports) {
$parcel$export(module.exports, "useCreateAccountConfirmationPageState", function () { return (parcelRequire("divIX")).useCreateAccountConfirmationPageState; });
$parcel$export(module.exports, "ChallengeApiError", function () { return (parcelRequire("1tRwG")).ChallengeApiError; });
$parcel$export(module.exports, "useChallengeSecurityKey", function () { return (parcelRequire("1tRwG")).useChallengeSecurityKey; });
parcelRequire("divIX");
parcelRequire("bB8aZ");
parcelRequire("duNcK");

});
parcelRegister("divIX", function(module, exports) {

$parcel$export(module.exports, "useCreateAccountConfirmationPageState", function () { return $6c46b3484e826109$export$9d9b63d777a078f3; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $2aGBJ = parcelRequire("2aGBJ");
parcelRequire("5jYTP");
var $4b5th = parcelRequire("4b5th");
const $6c46b3484e826109$var$selectMarketingConsent = (state)=>state.marketingConsent;
const $6c46b3484e826109$var$selectHashedCsrfToken = (state)=>state.hashedCsrfToken;
const $6c46b3484e826109$var$selectMicrobranding = (state)=>state.microbranding;
const $6c46b3484e826109$var$selectAppConfig = (state)=>state.appConfig;
const $6c46b3484e826109$var$selectCreateAccount = (state)=>state.createAccount;
const $6c46b3484e826109$export$9d9b63d777a078f3 = ()=>{
    return (0, $2aGBJ.useAppSelector)((0, $4b5th.createSelector)([
        $6c46b3484e826109$var$selectMarketingConsent,
        $6c46b3484e826109$var$selectHashedCsrfToken,
        $6c46b3484e826109$var$selectMicrobranding,
        $6c46b3484e826109$var$selectAppConfig,
        $6c46b3484e826109$var$selectCreateAccount
    ], (marketingConsent, hashedCsrfToken, microbranding, appConfig, createAccount)=>{
        const { config: marketingConsentConfig } = marketingConsent;
        const { recaptchaEnterpriseInvisibleKeySite: recaptchaEnterpriseInvisibleKeySite } = appConfig;
        const { formError: formError, fieldErrors: fieldErrors, redirectTo: redirectTo, isLoading: isLoading } = createAccount;
        const { isEmbedded: isEmbedded, oidcContext: oidcContext } = microbranding;
        const baseState = {
            formError: formError,
            fieldErrors: fieldErrors,
            marketingConsentConfig: marketingConsentConfig,
            redirectTo: redirectTo,
            isLoading: isLoading,
            isEmbedded: isEmbedded,
            oidcContext: oidcContext,
            recaptchaEnterpriseInvisibleKeySite: recaptchaEnterpriseInvisibleKeySite
        };
        const { loginType: loginType, displayName: displayName, email: email, userFlow: userFlow, confirmationToken: confirmationToken, mfaToken: mfaToken, createNeeded: createNeeded, verifyNeeded: verifyNeeded } = createAccount;
        return (0, $b2I6k._)((0, $1Fos3._)({}, baseState), {
            loginType: loginType,
            displayName: displayName,
            email: email,
            createNeeded: createNeeded,
            verifyNeeded: verifyNeeded,
            userFlow: userFlow,
            confirmationToken: confirmationToken,
            mfaToken: mfaToken,
            hashedCsrfToken: hashedCsrfToken
        });
    }));
};

});

parcelRegister("bB8aZ", function(module, exports) {
$parcel$export(module.exports, "EnrollApiErrorType", function () { return (parcelRequire("9DiW4")).EnrollApiErrorType; });
$parcel$export(module.exports, "useEnrollSecurityKey", function () { return (parcelRequire("9DiW4")).useEnrollSecurityKey; });
parcelRequire("9DiW4");

});
parcelRegister("9DiW4", function(module, exports) {

$parcel$export(module.exports, "EnrollApiErrorType", function () { return $1d3a626608d7a9ad$export$ed8612e4d0d57df6; });
$parcel$export(module.exports, "useEnrollSecurityKey", function () { return $1d3a626608d7a9ad$export$b31ee8addd49a620; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $6NU0v = parcelRequire("6NU0v");

var $91i6m = parcelRequire("91i6m");

var $2aGBJ = parcelRequire("2aGBJ");

var $aMqeG = parcelRequire("aMqeG");

var $8YGGt = parcelRequire("8YGGt");

var $1V2cH = parcelRequire("1V2cH");

var $49Pnv = parcelRequire("49Pnv");

var $l9Zg5 = parcelRequire("l9Zg5");

var $dBq8m = parcelRequire("dBq8m");
parcelRequire("6d87w");
var $l2v8Y = parcelRequire("l2v8Y");

var $9uXJ3 = parcelRequire("9uXJ3");
const $1d3a626608d7a9ad$var$X_CSRF_TOKEN_HEADER = 'X-CSRF-TOKEN';
class $1d3a626608d7a9ad$var$EnrollError extends Error {
    constructor(message, type){
        super(message);
        this.type = type;
    }
}
var $1d3a626608d7a9ad$export$ed8612e4d0d57df6 = /*#__PURE__*/ function(EnrollApiErrorType) {
    EnrollApiErrorType["deviceNameLengthError"] = "deviceNameLengthError";
    EnrollApiErrorType["rateLimitedError"] = "rateLimited";
    EnrollApiErrorType["enrollFailure"] = "enrollFailure";
    return EnrollApiErrorType;
}({});
const $1d3a626608d7a9ad$var$initialize = async ({ deviceName: deviceName, csrfToken: csrfToken, token: token })=>{
    try {
        const response = await fetch(`/manage/rest/two-step-verification/start-security-key?token=${token}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                [$1d3a626608d7a9ad$var$X_CSRF_TOKEN_HEADER]: csrfToken
            },
            body: JSON.stringify({
                deviceName: deviceName
            })
        });
        switch(response.status){
            case 200:
                return response.json();
            case 400:
                const errorResponse = await response.json();
                const errorType = errorResponse.type === 'invalid-device-name' ? "deviceNameLengthError" : "enrollFailure";
                throw new $1d3a626608d7a9ad$var$EnrollError(`/manage/rest/two-step-verification/confirm-security key retruns unexpected status code ${response.status}`, errorType);
            case 429:
                throw new $1d3a626608d7a9ad$var$EnrollError(`/manage/rest/two-step-verification/start-security key retruns unexpected status code ${response.status}`, "rateLimited");
            default:
                throw new $1d3a626608d7a9ad$var$EnrollError(`/manage/rest/two-step-verification/start-security key retruns unexpected status code ${response.status}`, "enrollFailure");
        }
    } catch (error) {
        if (error instanceof $1d3a626608d7a9ad$var$EnrollError) throw error;
        throw new $1d3a626608d7a9ad$var$EnrollError(error.message, "enrollFailure");
    }
};
const $1d3a626608d7a9ad$var$createCredentialsOnAuthenticator = async (securityKeyEnrollmentDetails)=>{
    try {
        const options = (0, $aMqeG.parseCreationOptionsFromJSON)({
            publicKey: (0, $b2I6k._)((0, $1Fos3._)({}, securityKeyEnrollmentDetails.creationOptions), {
                timeout: 60000
            })
        });
        try {
            const securityKeyCredential = await (0, $aMqeG.create)(options);
            return securityKeyCredential.toJSON();
        } catch (error) {
            (0, $49Pnv.captureErrorMessage)('Security key credential creation failed', {
                webauthnError: {
                    name: error.name,
                    message: JSON.stringify(error.message)
                }
            });
            const errorCode = (0, $l9Zg5.translateRegistrationError)({
                error: error,
                options: options
            });
            throw new $1d3a626608d7a9ad$var$EnrollError(`Failed to create credentials on authenticator: ${error.message}`, errorCode);
        }
    } catch (error) {
        if (error instanceof $1d3a626608d7a9ad$var$EnrollError) throw error;
        (0, $49Pnv.captureErrorMessage)('Failed to parse creation options for security key', {
            webauthnError: {
                name: error.name,
                message: JSON.stringify(error.message)
            }
        });
        throw new $1d3a626608d7a9ad$var$EnrollError(`Failed to parse creation options: ${error.message}`, (0, $l9Zg5.WebAuthnRegistrationErrorCode).InvalidCreationOptions);
    }
};
const $1d3a626608d7a9ad$var$confirm = async (_param)=>{
    var { transactionToken: transactionToken, csrfToken: csrfToken, token: token, continueUrl: continueUrl } = _param, attestationJson = (0, $6NU0v._)(_param, [
        "transactionToken",
        "csrfToken",
        "token",
        "continueUrl"
    ]);
    const clientExtensionResultsJsonString = JSON.stringify(attestationJson.clientExtensionResults);
    try {
        const confirmUrl = `/manage/rest/two-step-verification/confirm-security-key?${(0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).stringify({
            transactionToken: transactionToken,
            token: token,
            continue: continueUrl
        })}`;
        const response = await fetch(confirmUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                [$1d3a626608d7a9ad$var$X_CSRF_TOKEN_HEADER]: csrfToken
            },
            body: JSON.stringify((0, $b2I6k._)((0, $1Fos3._)({}, attestationJson), {
                clientExtensionResults: clientExtensionResultsJsonString
            }))
        });
        switch(response.status){
            case 200:
                {
                    const body = await response.json();
                    const { enrollmentActionType: enrollmentActionType, redirectUrl: redirectUrl } = body;
                    if (enrollmentActionType === 'added') {
                        // `added` - user is enrolling security key as addition factor
                        // This action is called by the enrollment wizard which is designed only for enrolling the first MFA factor.
                        // If a user manually visit the url of the wizard while already have MFA enabled, the enrollment may succeed.
                        // In that case, we want to redirect them directly to the continue URL instead of showing the recovery code,
                        // which is only valid for first MFA factor enrollment.
                        // Note: `redirectUrl` is the url to `idac/login/authorize` to force session rotation before redirecting the
                        //       user to `continueUrl`, and will not be return as part of the `added` call.
                        const url = continueUrl || '/manage-profile/security/two-step-verification';
                        return {
                            redirectUrl: url,
                            immediateRedirect: true
                        };
                    } else // `created` - user is enrolling security key as their first MFA factor
                    // Show recovery page with button to redirect to `redirectUrl` at `idac/login/authorize` to force session rotation.
                    return {
                        redirectUrl: redirectUrl,
                        immediateRedirect: false
                    };
                }
            case 429:
                throw new $1d3a626608d7a9ad$var$EnrollError(`/manage/rest/two-step-verification/confirm-security key retruns unexpected status code ${response.status}`, "rateLimited");
            default:
                throw new $1d3a626608d7a9ad$var$EnrollError(`/manage/rest/two-step-verification/confirm-security key retruns unexpected status code ${response.status}`, "enrollFailure");
        }
    } catch (error) {
        if (error instanceof $1d3a626608d7a9ad$var$EnrollError) throw error;
        throw new $1d3a626608d7a9ad$var$EnrollError(error.message, "enrollFailure");
    }
};
const $1d3a626608d7a9ad$export$b31ee8addd49a620 = (analyticsPageId, onSuccess, onError)=>{
    const csrfToken = (0, $2aGBJ.useAppSelector)((state)=>state.csrfToken);
    const token = (0, $2aGBJ.useAppSelector)((state)=>state.mfaEnrollment.token) || '';
    const isSupported = (0, $l9Zg5.isWebAuthnSupported)();
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const location = (0, $l2v8Y.useLocation)();
    const search = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(location.search);
    const [confirmingEnrollment, setConfirmingEnrollment] = (0, $91i6m.useState)(false);
    const enrollSecurityKey = (0, $91i6m.useCallback)(async (deviceName)=>{
        analyticsClient.trackingEvent({
            page: analyticsPageId,
            subject: '2svEnrolRegisterSecurityKey',
            action: 'started'
        });
        if (!isSupported) {
            analyticsClient.trackingEvent({
                page: analyticsPageId,
                action: 'failed',
                subject: '2svEnrolRegisterSecurityKey',
                attributes: {
                    reason: (0, $l9Zg5.WebAuthnRegistrationErrorCode).WebAuthnNotSupported
                }
            });
            return onError((0, $l9Zg5.WebAuthnRegistrationErrorCode).WebAuthnNotSupported);
        }
        try {
            setConfirmingEnrollment(true);
            const securityKeyEnrollmentDetails = await $1d3a626608d7a9ad$var$initialize({
                deviceName: deviceName,
                csrfToken: csrfToken,
                token: token
            });
            dispatch((0, $8YGGt.confirmSecurityKeyEnrollment)(securityKeyEnrollmentDetails.recoveryCode));
            const securityKeyCredentialJson = await $1d3a626608d7a9ad$var$createCredentialsOnAuthenticator(securityKeyEnrollmentDetails);
            const { immediateRedirect: immediateRedirect, redirectUrl: redirectUrl } = await $1d3a626608d7a9ad$var$confirm((0, $1Fos3._)({
                transactionToken: securityKeyEnrollmentDetails.transactionToken,
                csrfToken: csrfToken,
                token: token,
                continueUrl: search.continue
            }, securityKeyCredentialJson));
            if (immediateRedirect) navigate(redirectUrl);
            else dispatch((0, $8YGGt.confirmEnrollResponse)(redirectUrl));
            analyticsClient.trackingEvent({
                page: analyticsPageId,
                subject: '2svEnrolRegisterSecurityKey',
                action: 'succeeded'
            });
            return onSuccess();
        } catch (e) {
            setConfirmingEnrollment(false);
            analyticsClient.trackingEvent({
                page: analyticsPageId,
                subject: '2svEnrolRegisterSecurityKey',
                action: 'failed',
                attributes: {
                    reason: e.type || "enrollFailure"
                }
            });
            return onError(e.type || "enrollFailure");
        }
    }, [
        isSupported,
        analyticsClient,
        onError,
        dispatch,
        onSuccess,
        csrfToken,
        search.continue,
        token,
        analyticsPageId,
        navigate
    ]);
    return {
        enrollSecurityKey: enrollSecurityKey,
        confirmingEnrollment: confirmingEnrollment
    };
};

});
parcelRegister("aMqeG", function(module, exports) {

$parcel$export(module.exports, "parseCreationOptionsFromJSON", function () { return $7d92bcf2c67c6687$export$edb10dc0152a1b65; });
$parcel$export(module.exports, "parseRequestOptionsFromJSON", function () { return $7d92bcf2c67c6687$export$c89152b37af49fa1; });
$parcel$export(module.exports, "create", function () { return $7d92bcf2c67c6687$export$185802fd694ee1f5; });
$parcel$export(module.exports, "get", function () { return $7d92bcf2c67c6687$export$3988ae62b71be9a3; });
// src/webauthn-json/base64url.ts
function $7d92bcf2c67c6687$var$base64urlToBuffer(baseurl64String) {
    const padding = "==".slice(0, (4 - baseurl64String.length % 4) % 4);
    const base64String = baseurl64String.replace(/-/g, "+").replace(/_/g, "/") + padding;
    const str = atob(base64String);
    const buffer = new ArrayBuffer(str.length);
    const byteView = new Uint8Array(buffer);
    for(let i = 0; i < str.length; i++)byteView[i] = str.charCodeAt(i);
    return buffer;
}
function $7d92bcf2c67c6687$var$bufferToBase64url(buffer) {
    const byteView = new Uint8Array(buffer);
    let str = "";
    for (const charCode of byteView)str += String.fromCharCode(charCode);
    const base64String = btoa(str);
    const base64urlString = base64String.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
    return base64urlString;
}
// src/webauthn-json/convert.ts
var $7d92bcf2c67c6687$var$copyValue = "copy";
var $7d92bcf2c67c6687$var$convertValue = "convert";
function $7d92bcf2c67c6687$var$convert(conversionFn, schema, input) {
    if (schema === $7d92bcf2c67c6687$var$copyValue) return input;
    if (schema === $7d92bcf2c67c6687$var$convertValue) return conversionFn(input);
    if (schema instanceof Array) return input.map((v)=>$7d92bcf2c67c6687$var$convert(conversionFn, schema[0], v));
    if (schema instanceof Object) {
        const output = {};
        for (const [key, schemaField] of Object.entries(schema)){
            if (schemaField.derive) {
                const v = schemaField.derive(input);
                if (v !== void 0) input[key] = v;
            }
            if (!(key in input)) {
                if (schemaField.required) throw new Error(`Missing key: ${key}`);
                continue;
            }
            if (input[key] == null) {
                output[key] = null;
                continue;
            }
            output[key] = $7d92bcf2c67c6687$var$convert(conversionFn, schemaField.schema, input[key]);
        }
        return output;
    }
}
function $7d92bcf2c67c6687$var$derived(schema, derive) {
    return {
        required: true,
        schema: schema,
        derive: derive
    };
}
function $7d92bcf2c67c6687$var$required(schema) {
    return {
        required: true,
        schema: schema
    };
}
function $7d92bcf2c67c6687$var$optional(schema) {
    return {
        required: false,
        schema: schema
    };
}
// src/webauthn-json/basic/schema.ts
var $7d92bcf2c67c6687$var$publicKeyCredentialDescriptorSchema = {
    type: $7d92bcf2c67c6687$var$required($7d92bcf2c67c6687$var$copyValue),
    id: $7d92bcf2c67c6687$var$required($7d92bcf2c67c6687$var$convertValue),
    transports: $7d92bcf2c67c6687$var$optional($7d92bcf2c67c6687$var$copyValue)
};
var $7d92bcf2c67c6687$var$simplifiedExtensionsSchema = {
    appid: $7d92bcf2c67c6687$var$optional($7d92bcf2c67c6687$var$copyValue),
    appidExclude: $7d92bcf2c67c6687$var$optional($7d92bcf2c67c6687$var$copyValue),
    credProps: $7d92bcf2c67c6687$var$optional($7d92bcf2c67c6687$var$copyValue)
};
var $7d92bcf2c67c6687$var$simplifiedClientExtensionResultsSchema = {
    appid: $7d92bcf2c67c6687$var$optional($7d92bcf2c67c6687$var$copyValue),
    appidExclude: $7d92bcf2c67c6687$var$optional($7d92bcf2c67c6687$var$copyValue),
    credProps: $7d92bcf2c67c6687$var$optional($7d92bcf2c67c6687$var$copyValue)
};
var $7d92bcf2c67c6687$var$credentialCreationOptions = {
    publicKey: $7d92bcf2c67c6687$var$required({
        rp: $7d92bcf2c67c6687$var$required($7d92bcf2c67c6687$var$copyValue),
        user: $7d92bcf2c67c6687$var$required({
            id: $7d92bcf2c67c6687$var$required($7d92bcf2c67c6687$var$convertValue),
            name: $7d92bcf2c67c6687$var$required($7d92bcf2c67c6687$var$copyValue),
            displayName: $7d92bcf2c67c6687$var$required($7d92bcf2c67c6687$var$copyValue)
        }),
        challenge: $7d92bcf2c67c6687$var$required($7d92bcf2c67c6687$var$convertValue),
        pubKeyCredParams: $7d92bcf2c67c6687$var$required($7d92bcf2c67c6687$var$copyValue),
        timeout: $7d92bcf2c67c6687$var$optional($7d92bcf2c67c6687$var$copyValue),
        excludeCredentials: $7d92bcf2c67c6687$var$optional([
            $7d92bcf2c67c6687$var$publicKeyCredentialDescriptorSchema
        ]),
        authenticatorSelection: $7d92bcf2c67c6687$var$optional($7d92bcf2c67c6687$var$copyValue),
        attestation: $7d92bcf2c67c6687$var$optional($7d92bcf2c67c6687$var$copyValue),
        extensions: $7d92bcf2c67c6687$var$optional($7d92bcf2c67c6687$var$simplifiedExtensionsSchema)
    }),
    signal: $7d92bcf2c67c6687$var$optional($7d92bcf2c67c6687$var$copyValue)
};
var $7d92bcf2c67c6687$var$publicKeyCredentialWithAttestation = {
    type: $7d92bcf2c67c6687$var$required($7d92bcf2c67c6687$var$copyValue),
    id: $7d92bcf2c67c6687$var$required($7d92bcf2c67c6687$var$copyValue),
    rawId: $7d92bcf2c67c6687$var$required($7d92bcf2c67c6687$var$convertValue),
    authenticatorAttachment: $7d92bcf2c67c6687$var$optional($7d92bcf2c67c6687$var$copyValue),
    response: $7d92bcf2c67c6687$var$required({
        clientDataJSON: $7d92bcf2c67c6687$var$required($7d92bcf2c67c6687$var$convertValue),
        attestationObject: $7d92bcf2c67c6687$var$required($7d92bcf2c67c6687$var$convertValue),
        transports: $7d92bcf2c67c6687$var$derived($7d92bcf2c67c6687$var$copyValue, (response)=>{
            var _a;
            return ((_a = response.getTransports) == null ? void 0 : _a.call(response)) || [];
        })
    }),
    clientExtensionResults: $7d92bcf2c67c6687$var$derived($7d92bcf2c67c6687$var$simplifiedClientExtensionResultsSchema, (pkc)=>pkc.getClientExtensionResults())
};
var $7d92bcf2c67c6687$var$credentialRequestOptions = {
    mediation: $7d92bcf2c67c6687$var$optional($7d92bcf2c67c6687$var$copyValue),
    publicKey: $7d92bcf2c67c6687$var$required({
        challenge: $7d92bcf2c67c6687$var$required($7d92bcf2c67c6687$var$convertValue),
        timeout: $7d92bcf2c67c6687$var$optional($7d92bcf2c67c6687$var$copyValue),
        rpId: $7d92bcf2c67c6687$var$optional($7d92bcf2c67c6687$var$copyValue),
        allowCredentials: $7d92bcf2c67c6687$var$optional([
            $7d92bcf2c67c6687$var$publicKeyCredentialDescriptorSchema
        ]),
        userVerification: $7d92bcf2c67c6687$var$optional($7d92bcf2c67c6687$var$copyValue),
        extensions: $7d92bcf2c67c6687$var$optional($7d92bcf2c67c6687$var$simplifiedExtensionsSchema)
    }),
    signal: $7d92bcf2c67c6687$var$optional($7d92bcf2c67c6687$var$copyValue)
};
var $7d92bcf2c67c6687$var$publicKeyCredentialWithAssertion = {
    type: $7d92bcf2c67c6687$var$required($7d92bcf2c67c6687$var$copyValue),
    id: $7d92bcf2c67c6687$var$required($7d92bcf2c67c6687$var$copyValue),
    rawId: $7d92bcf2c67c6687$var$required($7d92bcf2c67c6687$var$convertValue),
    authenticatorAttachment: $7d92bcf2c67c6687$var$optional($7d92bcf2c67c6687$var$copyValue),
    response: $7d92bcf2c67c6687$var$required({
        clientDataJSON: $7d92bcf2c67c6687$var$required($7d92bcf2c67c6687$var$convertValue),
        authenticatorData: $7d92bcf2c67c6687$var$required($7d92bcf2c67c6687$var$convertValue),
        signature: $7d92bcf2c67c6687$var$required($7d92bcf2c67c6687$var$convertValue),
        userHandle: $7d92bcf2c67c6687$var$required($7d92bcf2c67c6687$var$convertValue)
    }),
    clientExtensionResults: $7d92bcf2c67c6687$var$derived($7d92bcf2c67c6687$var$simplifiedClientExtensionResultsSchema, (pkc)=>pkc.getClientExtensionResults())
};
// src/webauthn-json/basic/api.ts
function $7d92bcf2c67c6687$export$edb10dc0152a1b65(requestJSON) {
    return $7d92bcf2c67c6687$var$convert($7d92bcf2c67c6687$var$base64urlToBuffer, $7d92bcf2c67c6687$var$credentialCreationOptions, requestJSON);
}
function $7d92bcf2c67c6687$var$createResponseToJSON(credential) {
    return $7d92bcf2c67c6687$var$convert($7d92bcf2c67c6687$var$bufferToBase64url, $7d92bcf2c67c6687$var$publicKeyCredentialWithAttestation, credential);
}
function $7d92bcf2c67c6687$export$c89152b37af49fa1(requestJSON) {
    return $7d92bcf2c67c6687$var$convert($7d92bcf2c67c6687$var$base64urlToBuffer, $7d92bcf2c67c6687$var$credentialRequestOptions, requestJSON);
}
function $7d92bcf2c67c6687$var$getResponseToJSON(credential) {
    return $7d92bcf2c67c6687$var$convert($7d92bcf2c67c6687$var$bufferToBase64url, $7d92bcf2c67c6687$var$publicKeyCredentialWithAssertion, credential);
}
// src/webauthn-json/basic/supported.ts
function $7d92bcf2c67c6687$export$5f747a46dc0eb6ee() {
    return !!(navigator.credentials && navigator.credentials.create && navigator.credentials.get && window.PublicKeyCredential);
}
// src/webauthn-json/browser-ponyfill.ts
async function $7d92bcf2c67c6687$export$185802fd694ee1f5(options) {
    const response = await navigator.credentials.create(options);
    response.toJSON = ()=>$7d92bcf2c67c6687$var$createResponseToJSON(response);
    return response;
}
async function $7d92bcf2c67c6687$export$3988ae62b71be9a3(options) {
    const response = await navigator.credentials.get(options);
    response.toJSON = ()=>$7d92bcf2c67c6687$var$getResponseToJSON(response);
    return response;
}

});

parcelRegister("8YGGt", function(module, exports) {

$parcel$export(module.exports, "startEnroll", function () { return $0d187b0064789faa$export$7c9dff46f0231dac; });
$parcel$export(module.exports, "confirmEnrollResponse", function () { return $0d187b0064789faa$export$d0b229b11a2b0436; });
$parcel$export(module.exports, "confirmEnroll", function () { return $0d187b0064789faa$export$d7fcff46f05bc313; });
$parcel$export(module.exports, "resetSmsEnrollError", function () { return $0d187b0064789faa$export$11470e604dac27df; });
$parcel$export(module.exports, "startSmsEnroll", function () { return $0d187b0064789faa$export$cc095becfa9fc392; });
$parcel$export(module.exports, "fetchUnsupportedCountries", function () { return $0d187b0064789faa$export$275825b5052968f8; });
$parcel$export(module.exports, "smsEnrollmentCaptchaFailure", function () { return $0d187b0064789faa$export$5d71d66cd3287216; });
$parcel$export(module.exports, "startSecurityKeyEnroll", function () { return $0d187b0064789faa$export$a68b4a7d4e20cc56; });
$parcel$export(module.exports, "confirmSecurityKeyEnrollment", function () { return $0d187b0064789faa$export$8adf731e4230fb01; });

var $dBq8m = parcelRequire("dBq8m");

var $49Pnv = parcelRequire("49Pnv");
const $0d187b0064789faa$export$31554e24efe6c842 = (transactionToken, emailAddress, totpSecret, recoveryCode, totpUri)=>({
        type: 'START_ENROLL_RESPONSE',
        transactionToken: transactionToken,
        emailAddress: emailAddress,
        totpSecret: totpSecret,
        recoveryCode: recoveryCode,
        totpUri: totpUri
    });
const $0d187b0064789faa$export$90c618a494cc13d3 = (token)=>({
        type: 'START_ENROLL',
        token: token
    });
const $0d187b0064789faa$export$7c9dff46f0231dac = (token)=>(dispatch, getState)=>{
        dispatch($0d187b0064789faa$export$90c618a494cc13d3(token));
        const { csrfToken: csrfToken } = getState();
        return fetch(`/manage/rest/two-step-verification/start-enroll?${(0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).stringify({
            token: token
        })}`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'X-CSRF-TOKEN': csrfToken
            }
        }).then((response)=>response.json().then((data)=>{
                if (response.ok) return data;
                else throw new Error(`${response.status} ${response.statusText}: /manage/rest/two-step-verification/start-enroll`);
            })).then(({ transactionToken: transactionToken, emailAddress: emailAddress, totpSecret: totpSecret, recoveryCode: recoveryCode, totpUri: totpUri })=>{
            dispatch($0d187b0064789faa$export$31554e24efe6c842(transactionToken, emailAddress, totpSecret, recoveryCode, totpUri));
        });
    };
const $0d187b0064789faa$export$d0b229b11a2b0436 = (redirectUrl)=>({
        type: 'CONFIRM_ENROLL_RESPONSE',
        redirectUrl: redirectUrl
    });
const $0d187b0064789faa$export$5727292bf8b89d3 = ()=>({
        type: 'CONFIRM_ENROLL_ERROR'
    });
const $0d187b0064789faa$export$3c756426338d3bb7 = (otpCode, continueUrl)=>({
        type: 'CONFIRM_ENROLL',
        otpCode: otpCode,
        continueUrl: continueUrl
    });
const $0d187b0064789faa$export$d7fcff46f05bc313 = (otpCode, continueUrl, navigate)=>(dispatch, getState)=>{
        dispatch($0d187b0064789faa$export$3c756426338d3bb7(otpCode, continueUrl));
        const { csrfToken: csrfToken, mfaEnrollment: mfaEnrollment } = getState();
        return fetch(`/manage/rest/two-step-verification/confirm-enroll?${(0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).stringify({
            token: mfaEnrollment.token,
            continue: continueUrl
        })}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            },
            body: JSON.stringify({
                transactionToken: mfaEnrollment.transactionToken,
                otpCode: otpCode
            }),
            credentials: 'same-origin'
        }).then((response)=>{
            switch(response.status){
                case 200:
                    return response.json();
                case 204:
                    return Promise.resolve({
                        redirectUrl: null
                    });
                default:
                    throw response;
            }
        }).then(({ enrollmentActionType: enrollmentActionType, redirectUrl: redirectUrl })=>{
            if (enrollmentActionType === 'added') // `added` - user is enrolling TOTP as addition factor
            // This action is called by the enrollment wizard which is designed only for enrolling the first MFA factor.
            // If a user manually visit the url of the wizard while already have MFA enabled, the enrollment may succeed.
            // In that case, we want to redirect them directly to the continue URL instead of showing the recovery code,
            // which is only valid for first MFA factor enrollment.
            // Note: `redirectUrl` is the url to `idac/login/authorize` to force session rotation before redirecting the
            //       user to `continueUrl`, and will not be return as part of the `added` call.
            navigate(continueUrl || '/manage-profile/security/two-step-verification');
            else // `created` - user is enrolling TOTP as their first MFA factor
            // Show recovery page with button to redirect to `redirectUrl` at `idac/login/authorize` to force session rotation.
            dispatch($0d187b0064789faa$export$d0b229b11a2b0436(redirectUrl));
        }, (response)=>{
            dispatch($0d187b0064789faa$export$5727292bf8b89d3());
            throw new Error(`${response.status} ${response.statusText}: /manage/rest/two-step-verification/confirm-enroll`);
        });
    };
const $0d187b0064789faa$export$854ee8e5ea8056b6 = (transactionToken, recoveryCode, phoneNumber)=>({
        type: 'START_SMS_ENROLL_RESPONSE',
        transactionToken: transactionToken,
        recoveryCode: recoveryCode,
        phoneNumber: phoneNumber
    });
const $0d187b0064789faa$export$4586154d8ae4818b = (smsEnrollError)=>({
        type: 'START_SMS_ENROLL_ERROR',
        smsEnrollError: smsEnrollError
    });
const $0d187b0064789faa$export$11470e604dac27df = ()=>({
        type: 'RESET_SMS_ENROLL_ERROR'
    });
const $0d187b0064789faa$export$3b42004cef4b7302 = (phoneNumber, token)=>({
        type: 'START_SMS_ENROLL',
        token: token,
        phoneNumber: phoneNumber
    });
const $0d187b0064789faa$export$cc095becfa9fc392 = (phoneNumber, token, captchaToken)=>(dispatch, getState)=>{
        dispatch($0d187b0064789faa$export$3b42004cef4b7302(phoneNumber, token));
        const { csrfToken: csrfToken } = getState();
        return fetch(`/manage/rest/two-step-verification/start-enroll-sms?${(0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).stringify({
            token: token
        })}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            },
            body: JSON.stringify({
                phoneNumber: phoneNumber,
                captchaToken: captchaToken
            }),
            credentials: 'same-origin'
        }).then((response)=>{
            switch(response.status){
                case 200:
                    return response.json();
                default:
                    throw response;
            }
        }).then(({ transactionToken: transactionToken, recoveryCode: recoveryCode })=>{
            dispatch($0d187b0064789faa$export$854ee8e5ea8056b6(transactionToken, recoveryCode, phoneNumber));
        }, async (response)=>{
            const errorFromBadRequest = (response)=>response.json().then((body)=>{
                    switch(body.type){
                        case 'invalidPhoneNumber':
                            return 'invalid_phone_number';
                        case 'phoneNumberNotEligible':
                            return 'phone_number_not_eligible';
                        default:
                            return 'generic_error';
                    }
                }).catch(()=>'generic_error');
            const error = (response)=>{
                switch(response.status){
                    case 400:
                        return errorFromBadRequest(response);
                    case 429:
                        return 'too_many_sms';
                    default:
                        return 'generic_error';
                }
            };
            const errorLabel = await error(response);
            dispatch($0d187b0064789faa$export$4586154d8ae4818b(errorLabel));
            if (errorLabel === 'generic_error') (0, $49Pnv.captureErrorMessage)(`${response.status} ${response.statusText}: /manage/rest/two-step-verification/start-enroll-sms`);
        });
    };
const $0d187b0064789faa$export$d6651cd2d476e6a1 = (unsupportedCountries = [])=>({
        type: 'UPDATE_SMS_ENROLLMENT_UNSUPPORTED_COUNTRIES',
        unsupportedCountries: unsupportedCountries
    });
const $0d187b0064789faa$export$275825b5052968f8 = ()=>(dispatch)=>{
        return fetch(`/v2/mfa/enroll-sms/countries`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'same-origin'
        }).then((response)=>{
            switch(response.status){
                case 200:
                    return response.json();
                default:
                    return [];
            }
        }).then((body)=>{
            dispatch($0d187b0064789faa$export$d6651cd2d476e6a1(body.unsupportedCountries || []));
        }, ()=>{
            dispatch($0d187b0064789faa$export$d6651cd2d476e6a1([]));
        });
    };
const $0d187b0064789faa$export$5d71d66cd3287216 = (isOnline)=>$0d187b0064789faa$export$4586154d8ae4818b(isOnline ? 'captcha' : 'generic_error');
const $0d187b0064789faa$export$a68b4a7d4e20cc56 = (token)=>({
        type: 'START_SECURITY_KEY_ENROLL',
        token: token
    });
const $0d187b0064789faa$export$8adf731e4230fb01 = (recoveryCode)=>({
        type: 'CONFIRM_SECURITY_KEY_ENROLLMENT',
        recoveryCode: recoveryCode
    });

});

parcelRegister("l9Zg5", function(module, exports) {

$parcel$export(module.exports, "WebAuthnRegistrationErrorCode", function () { return $9355c5c45e3fee8c$export$99a3b8eef897cf04; });
$parcel$export(module.exports, "WebAuthnAuthenticationErrorCode", function () { return $9355c5c45e3fee8c$export$d73d3e8fcbb706b6; });
$parcel$export(module.exports, "isWebAuthnSupported", function () { return $9355c5c45e3fee8c$export$b48b2572c8b3a543; });
$parcel$export(module.exports, "translateRegistrationError", function () { return $9355c5c45e3fee8c$export$b31dc4fbcb20b129; });
$parcel$export(module.exports, "translateAuthenticationError", function () { return $9355c5c45e3fee8c$export$dafd1cf90bfb0daf; });
$parcel$export(module.exports, "challengeWithAuthenticator", function () { return $9355c5c45e3fee8c$export$70714cff41fa01ec; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $49Pnv = parcelRequire("49Pnv");

var $35Y3l = parcelRequire("35Y3l");
var $9355c5c45e3fee8c$export$99a3b8eef897cf04 = /*#__PURE__*/ function(WebAuthnRegistrationErrorCode) {
    WebAuthnRegistrationErrorCode["WebAuthnNotSupported"] = "webauthn_not_supported";
    WebAuthnRegistrationErrorCode["InvalidCreationOptions"] = "invalid_creation_options";
    WebAuthnRegistrationErrorCode["Aborted"] = "aborted";
    WebAuthnRegistrationErrorCode["DiscoverableCredentialSupportRequired"] = "discoverable_credential_support_required";
    WebAuthnRegistrationErrorCode["UserVerificationSupportRequired"] = "user_verification_support_required";
    WebAuthnRegistrationErrorCode["PreviouslyRegistered"] = "previously_registered";
    WebAuthnRegistrationErrorCode["NotAllowed"] = "not_allowed";
    WebAuthnRegistrationErrorCode["MalformedPubKeyCredParams"] = "malformed_pub_key_cred_params";
    WebAuthnRegistrationErrorCode["NoSupportedPubKeyCredParamsAlgorithm"] = "no_supported_pub_key_cred_params_algorithm";
    WebAuthnRegistrationErrorCode["InvalidDomain"] = "invalid_domain";
    WebAuthnRegistrationErrorCode["InvalidRpId"] = "invalid_rp_id";
    WebAuthnRegistrationErrorCode["InvalidUserIdLength"] = "invalid_user_id_length";
    WebAuthnRegistrationErrorCode["UnknownError"] = "unknown_error";
    return WebAuthnRegistrationErrorCode;
}({});
var $9355c5c45e3fee8c$export$d73d3e8fcbb706b6 = /*#__PURE__*/ function(WebAuthnAuthenticationErrorCode) {
    WebAuthnAuthenticationErrorCode["WebAuthnNotSupported"] = "webauthn_not_supported";
    WebAuthnAuthenticationErrorCode["InvalidRequestOptions"] = "invalid_request_options";
    WebAuthnAuthenticationErrorCode["Aborted"] = "aborted";
    WebAuthnAuthenticationErrorCode["NotAllowed"] = "not_allowed";
    WebAuthnAuthenticationErrorCode["InvalidDomain"] = "invalid_domain";
    WebAuthnAuthenticationErrorCode["InvalidRpId"] = "invalid_rp_id";
    WebAuthnAuthenticationErrorCode["UnknownError"] = "unknown_error";
    return WebAuthnAuthenticationErrorCode;
}({});
const $9355c5c45e3fee8c$export$b48b2572c8b3a543 = ()=>!!window.PublicKeyCredential;
/**
 * Source: https://github.com/MasterKale/SimpleWebAuthn/blob/master/packages/browser/src/helpers/isValidDomain.ts
 *
 * A simple test to determine if a hostname is a properly-formatted domain name
 *
 * Regex sourced from here:
 * https://www.oreilly.com/library/view/regular-expressions-cookbook/9781449327453/ch08s15.html
 *
 * This regex is checking if a given string is a valid domain name.
 * It should start with a series of alphanumeric characters (can be separated by hyphens), followed by one or more dots, and end with a top-level domain of at least two alphabetic characters.
 */ const $9355c5c45e3fee8c$var$isValidDomain = (hostname)=>hostname === 'localhost' || /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/i.test(hostname);
const $9355c5c45e3fee8c$export$b31dc4fbcb20b129 = ({ error: error, options: options })=>{
    const { publicKey: publicKey } = options;
    if (!publicKey) return "invalid_creation_options";
    switch(error.name){
        case 'AbortError':
            if (options.signal instanceof AbortSignal) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 16)
            return "aborted";
            break;
        case 'ConstraintError':
            var _publicKey_authenticatorSelection, _publicKey_authenticatorSelection1;
            if (((_publicKey_authenticatorSelection = publicKey.authenticatorSelection) === null || _publicKey_authenticatorSelection === void 0 ? void 0 : _publicKey_authenticatorSelection.requireResidentKey) === true) // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 4)
            return "discoverable_credential_support_required";
            if (((_publicKey_authenticatorSelection1 = publicKey.authenticatorSelection) === null || _publicKey_authenticatorSelection1 === void 0 ? void 0 : _publicKey_authenticatorSelection1.userVerification) === 'required') // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 5)
            return "user_verification_support_required";
            break;
        case 'InvalidStateError':
            // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 20)
            // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 3)
            return "previously_registered";
        case 'NotAllowedError':
            // Platforms are overloading this error beyond what the spec defines
            // https://stackoverflow.com/questions/77448336/handling-user-cancellation-when-creating-credentials-with-webauthn-api
            return "not_allowed";
        case 'NotSupportedError':
            const hasValidPubKeyCredParams = publicKey.pubKeyCredParams.some((param)=>param.type === 'public-key') || false;
            if (!hasValidPubKeyCredParams) // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 2)
            return "malformed_pub_key_cred_params";
            // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 2)
            return "no_supported_pub_key_cred_params_algorithm";
        case 'SecurityError':
            const effectiveDomain = window.location.hostname;
            if (!$9355c5c45e3fee8c$var$isValidDomain(effectiveDomain)) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 7)
            return "invalid_domain";
            if (publicKey.rp.id !== effectiveDomain) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 8)
            return "invalid_rp_id";
            break;
        case 'TypeError':
            if (publicKey.user.id.byteLength < 1 || publicKey.user.id.byteLength > 64) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 5)
            return "invalid_user_id_length";
            break;
        case 'UnknownError':
            // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 1)
            // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 8)
            return "unknown_error";
    }
    // for anything else, return unknown error
    return "unknown_error";
};
const $9355c5c45e3fee8c$export$dafd1cf90bfb0daf = ({ error: error, options: options })=>{
    const { publicKey: publicKey } = options;
    if (!publicKey) return "invalid_request_options";
    switch(error.name){
        case 'AbortError':
            if (options.signal instanceof AbortSignal) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 16)
            return "aborted";
            break;
        case 'NotAllowedError':
            // Platforms are overloading this error beyond what the spec defines
            return "not_allowed";
        case 'SecurityError':
            const effectiveDomain = window.location.hostname;
            if (!$9355c5c45e3fee8c$var$isValidDomain(effectiveDomain)) // https://www.w3.org/TR/webauthn-2/#sctn-discover-from-external-source (Step 5)
            return "invalid_domain";
            if (publicKey.rpId !== effectiveDomain) // https://www.w3.org/TR/webauthn-2/#sctn-discover-from-external-source (Step 6)
            return "invalid_rp_id";
            break;
        case 'UnknownError':
            // https://www.w3.org/TR/webauthn-2/#sctn-op-get-assertion (Step 1)
            // https://www.w3.org/TR/webauthn-2/#sctn-op-get-assertion (Step 12)
            return "unknown_error";
    }
    // for anything else, return unknown error
    return "unknown_error";
};
function $9355c5c45e3fee8c$var$serializePublicKeyCredential(credential) {
    const response = credential.response;
    return {
        id: credential.id,
        rawId: (0, $35Y3l.bufferToBase64url)(credential.rawId),
        response: {
            authenticatorData: (0, $35Y3l.bufferToBase64url)(response.authenticatorData),
            clientDataJSON: (0, $35Y3l.bufferToBase64url)(response.clientDataJSON),
            signature: (0, $35Y3l.bufferToBase64url)(response.signature),
            userHandle: response.userHandle ? (0, $35Y3l.bufferToBase64url)(response.userHandle) : undefined,
            clientExtensionJson: credential.getClientExtensionResults()
        },
        type: credential.type
    };
}
const $9355c5c45e3fee8c$export$70714cff41fa01ec = async (requestOptions)=>{
    const publicKey = (0, $b2I6k._)((0, $1Fos3._)({}, requestOptions), {
        challenge: (0, $35Y3l.base64urlToBuffer)(requestOptions.challenge)
    });
    try {
        const credential = await navigator.credentials.get({
            publicKey: publicKey
        });
        const serializedCredential = $9355c5c45e3fee8c$var$serializePublicKeyCredential(credential);
        return {
            success: true,
            data: serializedCredential
        };
    } catch (error) {
        (0, $49Pnv.captureErrorMessage)('Authentication failed', {
            webauthnError: {
                name: error.name,
                message: JSON.stringify(error)
            }
        });
        // https://developer.mozilla.org/en-US/docs/Web/API/CredentialsContainer/get#exceptions
        switch(error.name){
            case 'AbortError':
                return {
                    success: false,
                    error: "aborted"
                };
            case 'NotAllowedError':
                return {
                    success: false,
                    error: "not_allowed"
                };
            case 'SecurityError':
                return {
                    success: false,
                    error: "invalid_domain"
                };
            case 'IdentityCredentialError':
            case 'NetworkError':
                return {
                    success: false,
                    error: "unknown_error"
                };
            default:
                return {
                    success: false,
                    error: "unknown_error"
                };
        }
    }
};

});
parcelRegister("35Y3l", function(module, exports) {

$parcel$export(module.exports, "base64urlToBuffer", function () { return $fce62bfcb570dc5e$export$d203bea30aac4ae7; });
$parcel$export(module.exports, "bufferToBase64url", function () { return $fce62bfcb570dc5e$export$35dc1b4ac9cc4512; });
// Original author: https://github.com/github/webauthn-json/blob/main/src/webauthn-json/base64url.ts
function $fce62bfcb570dc5e$export$d203bea30aac4ae7(baseurl64String) {
    // Base64url to Base64
    const padding = '=='.slice(0, (4 - baseurl64String.length % 4) % 4);
    const base64String = baseurl64String.replace(/-/g, '+').replace(/_/g, '/') + padding;
    // Base64 to binary string
    const str = atob(base64String);
    // Binary string to buffer
    const buffer = new ArrayBuffer(str.length);
    const byteView = new Uint8Array(buffer);
    for(let i = 0; i < str.length; i++)byteView[i] = str.charCodeAt(i);
    return buffer;
}
function $fce62bfcb570dc5e$export$35dc1b4ac9cc4512(buffer) {
    // Buffer to binary string
    const byteView = new Uint8Array(buffer);
    let str = '';
    for (const charCode of byteView)str += String.fromCharCode(charCode);
    // Binary string to base64
    const base64String = btoa(str);
    // Base64 to base64url
    // We assume that the base64url string is well-formed.
    const base64urlString = base64String.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
    return base64urlString;
}

});




parcelRegister("duNcK", function(module, exports) {
$parcel$export(module.exports, "ChallengeApiError", function () { return (parcelRequire("1tRwG")).ChallengeApiError; });
$parcel$export(module.exports, "useChallengeSecurityKey", function () { return (parcelRequire("1tRwG")).useChallengeSecurityKey; });
parcelRequire("1tRwG");

});
parcelRegister("1tRwG", function(module, exports) {

$parcel$export(module.exports, "ChallengeApiError", function () { return $13fbc1041fa61546$export$eba107851027d37; });
$parcel$export(module.exports, "useChallengeSecurityKey", function () { return $13fbc1041fa61546$export$9b0f7f7d25e7c579; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $91i6m = parcelRequire("91i6m");

var $aMqeG = parcelRequire("aMqeG");

var $1V2cH = parcelRequire("1V2cH");

var $dBq8m = parcelRequire("dBq8m");

var $l9Zg5 = parcelRequire("l9Zg5");

var $49Pnv = parcelRequire("49Pnv");

var $9uXJ3 = parcelRequire("9uXJ3");

var $fYxRW = parcelRequire("fYxRW");
const $13fbc1041fa61546$var$ANALYTIC_EVENT_SUBJECT_ID = 'challengeSecurityKey';
var $13fbc1041fa61546$export$eba107851027d37 = /*#__PURE__*/ function(ChallengeApiError) {
    ChallengeApiError["transactionTokenNotFound"] = "transactionTokenNotFound";
    ChallengeApiError["challengeFailure"] = "challengeFailure";
    ChallengeApiError["tooManyRequests"] = "tooManyRequests";
    return ChallengeApiError;
}({});
const $13fbc1041fa61546$var$challenge = async ({ transactionToken: transactionToken })=>{
    try {
        const response = await fetch(`/v2/mfa/security-key/challenge?transactionToken=${transactionToken}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        switch(response.status){
            case 200:
                const challengeResponse = await response.json();
                return {
                    success: true,
                    data: challengeResponse
                };
            case 429:
                return {
                    success: false,
                    error: 'too_many_requests'
                };
            default:
                throw response;
        }
    } catch (error) {
        throw new Error(`error from fetch: /v2/mfa/security-key/challenge`);
    }
};
const $13fbc1041fa61546$var$authorize = async ({ transactionToken: transactionToken })=>{
    try {
        const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(window.location.search);
        queryParams.transactionToken = transactionToken;
        const response = await fetch(`/rest/mfa/authorize?${(0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).stringify(queryParams)}`);
        switch(response.status){
            case 200:
                const authorizeResponse = await response.json();
                return {
                    success: true,
                    data: authorizeResponse
                };
            case 429:
                return {
                    success: false,
                    error: 'too_many_requests'
                };
            default:
                throw response;
        }
    } catch (error) {
        throw new Error(`error from fetch: /rest/mfa/authorize`);
    }
};
const $13fbc1041fa61546$var$challengeWithAuthenticator = async (requestOptions)=>{
    try {
        const options = (0, $aMqeG.parseRequestOptionsFromJSON)({
            publicKey: (0, $b2I6k._)((0, $1Fos3._)({}, requestOptions), {
                timeout: 60000
            })
        });
        try {
            const securityKeyCredential = await (0, $aMqeG.get)(options);
            return {
                success: true,
                data: securityKeyCredential.toJSON()
            };
        } catch (error) {
            (0, $49Pnv.captureErrorMessage)('Security key authentication failed', {
                webauthnError: {
                    name: error.name,
                    message: JSON.stringify(error.message)
                }
            });
            const errorCode = (0, $l9Zg5.translateAuthenticationError)({
                error: error,
                options: options
            });
            return {
                success: false,
                error: errorCode
            };
        }
    } catch (error) {
        (0, $49Pnv.captureErrorMessage)('Failed to parse authenticate options for security key', {
            webauthnError: {
                name: error.name,
                message: JSON.stringify(error.message)
            }
        });
        return {
            success: false,
            error: (0, $l9Zg5.WebAuthnAuthenticationErrorCode).InvalidRequestOptions
        };
    }
};
const $13fbc1041fa61546$var$verify = async ({ transactionToken: transactionToken, assertionJson: assertionJson, analyticsClient: analyticsClient, pageId: pageId })=>{
    try {
        const clientExtensionResultsJsonString = JSON.stringify(assertionJson.clientExtensionResults);
        const response = await fetch(`/v2/mfa/security-key/verify?transactionToken=${transactionToken}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify((0, $b2I6k._)((0, $1Fos3._)({}, assertionJson), {
                clientExtensionResults: clientExtensionResultsJsonString
            }))
        });
        switch(response.status){
            case 200:
                {
                    const { transactionToken: transactionToken } = await response.json();
                    const verifyResponseResult = await $13fbc1041fa61546$var$authorize({
                        transactionToken: transactionToken
                    });
                    if (!verifyResponseResult.success) switch(verifyResponseResult.error){
                        case 'too_many_requests':
                            return {
                                success: false,
                                error: 'too_many_requests'
                            };
                        default:
                            throw new Error('error during verification of security key');
                    }
                    analyticsClient.trackingEvent({
                        page: pageId,
                        action: 'succeeded',
                        subject: $13fbc1041fa61546$var$ANALYTIC_EVENT_SUBJECT_ID
                    });
                    return {
                        success: true,
                        data: verifyResponseResult.data
                    };
                }
            case 400:
                {
                    const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(window.location.search);
                    const redirectUri = $13fbc1041fa61546$var$redirectToLoginErrorOn400IncorrectTokenResponse({
                        analyticsClient: analyticsClient,
                        pageId: pageId,
                        currentQueryParams: queryParams
                    });
                    return {
                        success: true,
                        data: {
                            redirectUri: redirectUri
                        }
                    };
                }
            case 429:
                return {
                    success: false,
                    error: 'too_many_requests'
                };
            default:
                throw response;
        }
    } catch (error) {
        throw new Error(`error during verification of security key`);
    }
};
const $13fbc1041fa61546$export$9b0f7f7d25e7c579 = (pageId, onSuccess, onError)=>{
    const isSupported = (0, $l9Zg5.isWebAuthnSupported)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const [authenticating, setAuthenticating] = (0, $91i6m.useState)(false);
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    const onErrorWithTrackingAnalytics = (0, $91i6m.useCallback)((error)=>{
        analyticsClient.trackingEvent({
            page: pageId,
            action: 'failed',
            subject: $13fbc1041fa61546$var$ANALYTIC_EVENT_SUBJECT_ID,
            attributes: {
                reason: error
            }
        });
        onError(error);
    }, [
        analyticsClient,
        onError,
        pageId
    ]);
    const challengeSecurityKey = (0, $91i6m.useCallback)(async ()=>{
        analyticsClient.trackingEvent({
            page: pageId,
            action: 'started',
            subject: $13fbc1041fa61546$var$ANALYTIC_EVENT_SUBJECT_ID
        });
        if (!isSupported) return onErrorWithTrackingAnalytics((0, $l9Zg5.WebAuthnAuthenticationErrorCode).WebAuthnNotSupported);
        const transactionToken = new URLSearchParams(window.location.search).get('transactionToken');
        if (!transactionToken) return onErrorWithTrackingAnalytics("transactionTokenNotFound");
        try {
            setAuthenticating(true);
            const securityKeyChallengeResponseResult = await $13fbc1041fa61546$var$challenge({
                transactionToken: transactionToken
            });
            if (!securityKeyChallengeResponseResult.success) {
                setAuthenticating(false);
                switch(securityKeyChallengeResponseResult.error){
                    case 'too_many_requests':
                        return onErrorWithTrackingAnalytics("tooManyRequests");
                    default:
                        return onErrorWithTrackingAnalytics("challengeFailure");
                }
            }
            const { requestOptions: requestOptions, transactionToken: newTransactionToken } = securityKeyChallengeResponseResult.data;
            // This updates the search query params in the address bar, but does not trigger
            // a page reload due to the pathname remains unchanged
            // Setting this would ensure the user loads the page with the updated token should
            // they refresh (eg. F5) the page
            navigate({
                search: (0, $fYxRW.replaceQueryParam)('transactionToken', newTransactionToken)
            });
            const authenticatorChallengeResult = await $13fbc1041fa61546$var$challengeWithAuthenticator(requestOptions);
            if (!authenticatorChallengeResult.success) {
                setAuthenticating(false);
                return onErrorWithTrackingAnalytics(authenticatorChallengeResult.error);
            }
            const securityKeyCredentialJson = authenticatorChallengeResult.data;
            const verifyResponseResult = await $13fbc1041fa61546$var$verify({
                transactionToken: newTransactionToken,
                assertionJson: securityKeyCredentialJson,
                analyticsClient: analyticsClient,
                pageId: pageId
            });
            if (!verifyResponseResult.success) {
                setAuthenticating(false);
                switch(verifyResponseResult.error){
                    case 'too_many_requests':
                        return onErrorWithTrackingAnalytics("tooManyRequests");
                    default:
                        return onErrorWithTrackingAnalytics("challengeFailure");
                }
            }
            return onSuccess(verifyResponseResult.data);
        } catch (e) {
            setAuthenticating(false);
            return onErrorWithTrackingAnalytics("challengeFailure");
        }
    }, [
        isSupported,
        analyticsClient,
        onSuccess,
        pageId,
        onErrorWithTrackingAnalytics,
        navigate
    ]);
    return {
        challengeSecurityKey: challengeSecurityKey,
        authenticating: authenticating
    };
};
function $13fbc1041fa61546$var$redirectToLoginErrorOn400IncorrectTokenResponse({ analyticsClient: analyticsClient, pageId: pageId, currentQueryParams: currentQueryParams }) {
    analyticsClient.trackingEvent({
        page: pageId,
        subject: $13fbc1041fa61546$var$ANALYTIC_EVENT_SUBJECT_ID,
        action: 'failed',
        attributes: {
            reason: 'login_redirect_invalid_token'
        }
    });
    delete currentQueryParams.transactionToken;
    const currentQueryString = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).stringify(currentQueryParams);
    const extraParamsString = currentQueryString === '' ? '' : `&${currentQueryString}`;
    return new URL(`/login?prompt=true&errorCode=login.form.token.expired${extraParamsString}`, window.location.origin);
}

});



parcelRegister("5xbP9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ca78366f41adc9f$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $3ca78366f41adc9f$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    failedToUseKeyMessage: {
        id: 'mfa.challenge.securitykey.failedtousekey.label',
        defaultMessage: "We\u2019re not sure what went wrong. Try again. If this keeps happening, contact support."
    },
    securityKeyTooManyAttemptsMessage: {
        id: 'mfa.challenge.securitykey.toomanyattempts.label',
        defaultMessage: "You\u2019ve reached your rate limit. Try again in a few minutes."
    },
    webauthnNotSupportedMessage: {
        id: 'mfa.challenge.securitykey.not-supported.label',
        defaultMessage: "We\u2019re unable to verify your security key. Make sure your browser supports WebAuthn."
    },
    webAuthnMalformedConfiguration: {
        id: 'mfa.challenge.webauthn.malformed-configuration.label',
        defaultMessage: "We\u2019re unable to authenticate with your security key. Try again. If this keeps happening, contact support.",
        description: 'Error message displayed when security key challenge failed due to failure to initiate the security key challenge process due to invalid configurations passed to the WebAuthN API and authenticator.'
    },
    webAuthnAborted: {
        id: 'mfa.challenge.webauthn.aborted.label',
        defaultMessage: "We\u2019re unable to detect your authentication signal. Try again. If this keeps happening, contact support.",
        description: 'Error message displayed when security key challenge failed due to the WebAuthn authentication ceremony receiving an abort signal'
    },
    webAuthnAuthenticationIncomplete: {
        id: 'mfa.challenge.webauthn.authentication-incomplete.label',
        defaultMessage: 'You did not complete the authentication process. Try again.',
        description: 'Error message displayed when security key challenge failed due to failure to complete the process. This is commonly seen if the user cancel out of the authentication, or the process went timeout.'
    },
    webAuthnInvalidDomain: {
        id: 'mfa.challenge.webauthn.invalid-domain.label',
        defaultMessage: 'Your domain does not match the Atlassian domain.',
        description: 'Error message displayed when security key challenge failed due to the current domain the user is on is invalid'
    },
    webauthnAuthenticationFailed: {
        id: 'mfa.challenge.webauthn.authenticaton-failed.label',
        defaultMessage: "Your security key couldn\u2019t complete the authentication. Try again. If this keeps happening, contact support.",
        description: 'Error message displayed when security key challenge failed due to the authenticator failed to complete the authentication step for unidentifiable reasons'
    }
});

});

parcelRegister("5az11", function(module, exports) {

$parcel$export(module.exports, "SecurityKey", function () { return $bc3a2dfb3756e9b6$export$9dccf97bc0beb20b; });

var $4ZSso = parcelRequire("4ZSso");

var $9jjaN = parcelRequire("9jjaN");

var $jcdti = parcelRequire("jcdti");

var $26Riy = parcelRequire("26Riy");
parcelRequire("91i6m");

var $k8ZoM = parcelRequire("k8ZoM");
let $bc3a2dfb3756e9b6$var$_ = (t)=>t, $bc3a2dfb3756e9b6$var$t, $bc3a2dfb3756e9b6$var$t1;
const $bc3a2dfb3756e9b6$var$baseSpacing = (0, $k8ZoM.default)('space.100');
const $bc3a2dfb3756e9b6$var$DefaultSecurityKeyContainer = (0, $9jjaN.default).div($bc3a2dfb3756e9b6$var$t1 || ($bc3a2dfb3756e9b6$var$t1 = $bc3a2dfb3756e9b6$var$_`
  background: url(${0}) no-repeat center 0 / calc(${0} * 14.5);
  min-width: 100%;
  margin-top: ${0};
  padding-top: calc(${0} * 18);

  box-sizing: border-box;

  ${0}
`), (0, (/*@__PURE__*/$parcel$interopDefault($jcdti))), $bc3a2dfb3756e9b6$var$baseSpacing, $bc3a2dfb3756e9b6$var$baseSpacing, $bc3a2dfb3756e9b6$var$baseSpacing, (0, $26Riy.media).handheld($bc3a2dfb3756e9b6$var$t || ($bc3a2dfb3756e9b6$var$t = $bc3a2dfb3756e9b6$var$_`
    background: 0;
    padding: 0;
  `)));
const $bc3a2dfb3756e9b6$export$9dccf97bc0beb20b = ({ children: children, id: id })=>{
    return /*#__PURE__*/ (0, $4ZSso.jsx)($bc3a2dfb3756e9b6$var$DefaultSecurityKeyContainer, {
        id: id,
        children: children
    });
};

});
parcelRegister("jcdti", function(module, exports) {

module.exports = (parcelRequire("cgi2g")).getBundleURL('9rAa3') + "lock-closed.59f9256b.svg";

});



parcelRegister("lJcQw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $545872f81a90b240$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $545872f81a90b240$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    mfTotpPrompt: {
        id: 'mf.totp.prompt',
        defaultMessage: 'Enter the code from your authenticator app.',
        description: 'Message shown on the 2SV challenge screen to prompt the user to enter the code from their authenticator app'
    },
    mfSmsPrompt: {
        id: 'mf.sms.prompt',
        defaultMessage: 'Enter the code you received by SMS.',
        description: 'Message shown on the 2SV challenge screen to prompt the user to enter the code sent to their SMS'
    },
    mfEmailPrompt: {
        id: 'mf.email.prompt',
        defaultMessage: 'Enter the code from your email.',
        description: 'Message shown on the 2SV challenge screen to prompt the user to enter the code sent to their email'
    }
});

});


parcelRegister("cCttd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac911c1434e58bd1$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");

var $9jjaN = parcelRequire("9jjaN");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");

var $2ZKUQ = parcelRequire("2ZKUQ");

var $cLysE = parcelRequire("cLysE");

var $6GpTs = parcelRequire("6GpTs");
let $ac911c1434e58bd1$var$_ = (t)=>t, $ac911c1434e58bd1$var$t;
const $ac911c1434e58bd1$var$ErrorMessage = (0, $9jjaN.default).div($ac911c1434e58bd1$var$t || ($ac911c1434e58bd1$var$t = $ac911c1434e58bd1$var$_`
  color: ${0};
  margin-bottom: ${0}px;
`), (0, $kLNLK).R500, (0, $6e88g.gridSize)() * 2);
const $ac911c1434e58bd1$var$RecoveryEmailForm = ({ email: email, recoveryEmailError: recoveryEmailError, sendEmail: sendEmail })=>{
    const [loading, setLoading] = (0, $91i6m.useState)(false);
    const sendRecoveryEmail = ()=>{
        setLoading(true);
        sendEmail();
    };
    (0, $91i6m.useEffect)(()=>{
        if (recoveryEmailError) setLoading(false);
    }, [
        recoveryEmailError
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $6GpTs.SecurityWall), {
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "mf.recoveryemailform.desc",
                tagName: "p",
                defaultMessage: "We'll email you at {email} with instructions for how to recover access to your account.",
                values: {
                    email: /*#__PURE__*/ (0, $4ZSso.jsx)("strong", {
                        children: email
                    })
                }
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "mf.recoveryemailform.security.desc",
                tagName: "p",
                defaultMessage: "For security reasons, this process will take some time to complete, and you may be contacted by our Support team for verification."
            }),
            /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $2ZKUQ.default), {
                children: [
                    recoveryEmailError && /*#__PURE__*/ (0, $4ZSso.jsx)($ac911c1434e58bd1$var$RecoveryEmailErrorMessage, {
                        recoveryEmailError: recoveryEmailError
                    }),
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                        id: "send-recovery-email-button",
                        appearance: "primary",
                        isFullWidth: true,
                        onClick: sendRecoveryEmail,
                        isDisabled: loading,
                        isLoading: loading,
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                            id: "mf.recoveryemailform.sendemail",
                            defaultMessage: "Send recovery email"
                        })
                    })
                ]
            })
        ]
    });
};
const $ac911c1434e58bd1$var$RecoveryEmailErrorMessage = ({ recoveryEmailError: recoveryEmailError })=>{
    if (!recoveryEmailError) return null;
    switch(recoveryEmailError){
        case 'alreadyRequested':
            return /*#__PURE__*/ (0, $4ZSso.jsx)($ac911c1434e58bd1$var$ErrorMessage, {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "mf.recoveryemailform.error.alreadyRequested",
                    defaultMessage: "You have already requested account recovery instructions. If the account exists, these instructions will be sent to your email address. Note that this may take some time to complete."
                })
            });
        case 'userIsManaged':
        case 'userNotFound':
            return /*#__PURE__*/ (0, $4ZSso.jsx)($ac911c1434e58bd1$var$ErrorMessage, {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "mf.recoveryemailform.error.genericExpected",
                    defaultMessage: "Your recovery request can't be processed. Please <support-link>contact support</support-link>.",
                    values: {
                        'support-link': (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("a", {
                                href: 'https://www.atlassian.com/company/contact/general-inquiries',
                                children: chunks
                            })
                    }
                })
            });
        case 'unknown':
        default:
            return /*#__PURE__*/ (0, $4ZSso.jsx)($ac911c1434e58bd1$var$ErrorMessage, {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "mf.recoveryemailform.error.unknown",
                    defaultMessage: "Unexpected error happened. Please <support-link>contact support</support-link>.",
                    values: {
                        'support-link': (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("a", {
                                href: 'https://www.atlassian.com/company/contact/general-inquiries',
                                children: chunks
                            })
                    }
                })
            });
    }
};
var $ac911c1434e58bd1$export$2e2bcd8739ae039 = $ac911c1434e58bd1$var$RecoveryEmailForm;

});

parcelRegister("6TZp4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b497885600958c6$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");

var $9jjaN = parcelRequire("9jjaN");

var $3Gt1d = parcelRequire("3Gt1d");

var $6e88g = parcelRequire("6e88g");

var $k8ZoM = parcelRequire("k8ZoM");

var $1V2cH = parcelRequire("1V2cH");
let $5b497885600958c6$var$_ = (t)=>t, $5b497885600958c6$var$t, $5b497885600958c6$var$t1, $5b497885600958c6$var$t2;
const $5b497885600958c6$var$EmailSentImg = (0, $9jjaN.default).img($5b497885600958c6$var$t || ($5b497885600958c6$var$t = $5b497885600958c6$var$_`
  height: ${0}px;
  display: block;
  margin: ${0}px auto ${0}px;
`), (0, $6e88g.gridSize)() * 16, (0, $6e88g.gridSize)(), (0, $6e88g.gridSize)() * 2);
const $5b497885600958c6$var$Email = (0, $9jjaN.default).p($5b497885600958c6$var$t1 || ($5b497885600958c6$var$t1 = $5b497885600958c6$var$_`
  font: ${0};
  margin-top: ${0}px;
  overflow: hidden;
  text-overflow: ellipsis;
`), (0, $k8ZoM.default)('font.heading.small'), (0, $6e88g.gridSize)());
const $5b497885600958c6$var$TextWrapper = (0, $9jjaN.default).div($5b497885600958c6$var$t2 || ($5b497885600958c6$var$t2 = $5b497885600958c6$var$_`
  p {
    margin: 0;
  }
`));
const $5b497885600958c6$var$RecoveryEmailSent = ({ email: email, emailSentPageId: emailSentPageId, expirePageId: expirePageId, isExpired: isExpired })=>{
    (0, $1V2cH.usePageViewedEvent)(isExpired ? expirePageId : emailSentPageId);
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)($5b497885600958c6$var$EmailSentImg, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($3Gt1d)))
            }),
            /*#__PURE__*/ (0, $4ZSso.jsxs)($5b497885600958c6$var$TextWrapper, {
                children: [
                    isExpired && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                        id: "mf.recoveryemailsent.expired",
                        tagName: "p",
                        defaultMessage: "Your recovery link expired."
                    }),
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                        id: "mf.recoveryemailsent",
                        tagName: "p",
                        defaultMessage: "We've emailed instructions to:"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)($5b497885600958c6$var$Email, {
                children: email
            })
        ]
    });
};
var $5b497885600958c6$export$2e2bcd8739ae039 = $5b497885600958c6$var$RecoveryEmailSent;

});
parcelRegister("3Gt1d", function(module, exports) {

module.exports = (parcelRequire("cgi2g")).getBundleURL('9rAa3') + "check-your-email.39bc0dca.svg";

});


parcelRegister("lt1si", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18e3dd79ec1b4bc2$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $9jjaN = parcelRequire("9jjaN");

var $h89s9 = parcelRequire("h89s9");

var $5v178 = parcelRequire("5v178");

var $6e88g = parcelRequire("6e88g");

var $gFwNN = parcelRequire("gFwNN");

var $cLysE = parcelRequire("cLysE");

var $1cnQy = parcelRequire("1cnQy");

var $6GpTs = parcelRequire("6GpTs");

var $6FRcv = parcelRequire("6FRcv");
parcelRequire("0wXBc");
var $buHgC = parcelRequire("buHgC");
let $18e3dd79ec1b4bc2$var$_ = (t)=>t, $18e3dd79ec1b4bc2$var$t, $18e3dd79ec1b4bc2$var$t1;
const $18e3dd79ec1b4bc2$var$ButtonContainer = (0, $9jjaN.default).div($18e3dd79ec1b4bc2$var$t || ($18e3dd79ec1b4bc2$var$t = $18e3dd79ec1b4bc2$var$_`
  margin-top: ${0}px;
`), (0, $6e88g.gridSize)());
const $18e3dd79ec1b4bc2$var$MessageWrapper = (0, $9jjaN.default).div($18e3dd79ec1b4bc2$var$t1 || ($18e3dd79ec1b4bc2$var$t1 = $18e3dd79ec1b4bc2$var$_`
  padding-bottom: ${0}px;
`), (0, $6e88g.gridSize)() * 1.5);
const $18e3dd79ec1b4bc2$var$RecoveryCodeField = ({ disabled: disabled, fieldErrorFromParent: fieldErrorFromParent, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const fieldTextRef = (0, $91i6m.useRef)(null);
    const [fieldValue, setFieldValue] = (0, $91i6m.useState)('');
    const [fieldError, setFieldError] = (0, $91i6m.useState)(fieldErrorFromParent);
    const previousFieldValue = (0, $buHgC.usePrevious)(fieldValue);
    const previousFieldErrorFromParent = (0, $buHgC.usePrevious)(fieldErrorFromParent);
    const handlePaste = (e)=>{
        const target = e.target;
        const selectionStart = target.selectionStart || 0;
        const selectionEnd = target.selectionEnd || target.value.length;
        const start = target.value.substr(0, selectionStart);
        const middle = (e.clipboardData || window.clipboardData).getData('text/plain').replace(/\W/g, '').substr(0, target.maxLength - target.value.length - selectionStart + selectionEnd);
        const end = target.value.substr(selectionEnd);
        //timeout to allow input update UI
        setTimeout(()=>setFieldValue(start + middle + end));
    };
    const handleChange = (e)=>{
        setFieldValue(e.currentTarget.value.replace(/\W/g, '').toUpperCase());
        setFieldError(null);
    };
    const handleInvalid = (e)=>{
        e.preventDefault();
        setFieldError({
            errorCode: 'invalid_otp_pattern'
        });
    };
    (0, $91i6m.useEffect)(()=>{
        const input = fieldTextRef.current;
        if (input) {
            input.addEventListener('invalid', handleInvalid);
            input.addEventListener('paste', handlePaste);
        }
        return ()=>{
            if (input) {
                input.removeEventListener('invalid', handleInvalid);
                input.removeEventListener('paste', handlePaste);
            }
        };
    }, []);
    (0, $91i6m.useEffect)(()=>{
        if (!previousFieldErrorFromParent && fieldErrorFromParent) {
            setFieldError(fieldErrorFromParent);
            fieldTextRef.current && fieldTextRef.current.select();
        }
    }, [
        fieldErrorFromParent,
        previousFieldErrorFromParent
    ]);
    (0, $91i6m.useEffect)(()=>{
        if (fieldValue !== previousFieldValue) onChange && onChange({
            target: fieldTextRef.current
        });
    }, [
        fieldValue,
        previousFieldValue,
        onChange
    ]);
    const errorContent = (error)=>{
        const errorMessages = {
            invalid_recovery_code: formatMessage((0, $1cnQy.default).errorsInvalidRecoverCode),
            invalid_recovery_code_format: formatMessage((0, $1cnQy.default).errorsInvalidRecoveryCodeFormat),
            field_required: formatMessage((0, $1cnQy.default).errorsNoRecoveryCode),
            invalid_token: /*#__PURE__*/ (0, $4ZSso.jsxs)("form", {
                onSubmit: ()=>window.location.reload(),
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                        id: "mf.mfform.errors.invalid_token",
                        defaultMessage: "Your session has expired. Please refresh the page and try again."
                    }),
                    /*#__PURE__*/ (0, $4ZSso.jsx)($18e3dd79ec1b4bc2$var$ButtonContainer, {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                            type: "submit",
                            isFullWidth: true,
                            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                                id: "common.refresh",
                                defaultMessage: "Refresh"
                            })
                        })
                    })
                ]
            }),
            invalid_otp_pattern: formatMessage((0, $1cnQy.default).errorsInvalidOtpPattern)
        };
        return error && // @ts-ignore genuine TypeScript screw up, need to turn RecoveryCodeFieldError into a genuine discriminated union
        (errorMessages[error.errorCode] || error.message && typeof error.message === 'string');
    };
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gFwNN.default), {
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $h89s9.default), {
            name: "recoveryCode",
            type: "text",
            label: formatMessage((0, $1cnQy.default).mfRecoveryFormPlaceholder),
            autoFocus: true,
            onChange: handleChange,
            isInvalid: !!fieldError,
            invalidMessage: !disabled && fieldError && errorContent(fieldError),
            value: fieldValue,
            isDisabled: disabled,
            pattern: "\\w{24}",
            maxLength: 24,
            isRequired: true,
            ref: fieldTextRef
        })
    });
};
const $18e3dd79ec1b4bc2$var$RecoveryForm = ({ isLoading: isLoading, recoverAccount: recoverAccount, multifactorMethod: multifactorMethod, recoveryError: recoveryError })=>{
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const handleInputChange = (e)=>{
        const target = e.target;
        if (target && target.value.length === target.maxLength) recoverAccount(target.value);
    };
    const handleFormSubmit = (e)=>{
        e.preventDefault();
        // @ts-ignore check that recoveryCode is actually on the target
        recoverAccount(e.target.recoveryCode.value);
    };
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $6GpTs.SecurityWall), {
        id: "two-step-verification-recovery-form",
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $6FRcv.InputMessage), {
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)($18e3dd79ec1b4bc2$var$MessageWrapper, {
                        children: multifactorMethod === 'security-key' ? /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                            id: "mf.recoveryform.usekey.securitykey",
                            defaultMessage: "If you can't use your security key, log in with your emergency recovery key."
                        }) : /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                            id: "mf.recoveryform.usekey",
                            defaultMessage: "If you can't use your phone, log in with your emergency recovery key."
                        })
                    }),
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6FRcv.InlineMessageContainer), {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $5v178.default), {
                            appearance: "info",
                            placement: "bottom-end",
                            iconLabel: formatMessage({
                                id: 'mf.recoveryform.help.inline-message.button.label',
                                defaultMessage: 'More info',
                                description: 'Icon button label for the inline message'
                            }),
                            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6FRcv.StyledMessage), {
                                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                                    id: "mf.recoveryform.help",
                                    defaultMessage: "We asked you to save your emergency recovery key when you enabled two-step verification. You might have saved it in a local file or printed it out."
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4ZSso.jsxs)("form", {
                autoComplete: "off",
                onSubmit: handleFormSubmit,
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)($18e3dd79ec1b4bc2$var$RecoveryCodeField, {
                        disabled: isLoading,
                        fieldErrorFromParent: recoveryError,
                        onChange: handleInputChange
                    }),
                    /*#__PURE__*/ (0, $4ZSso.jsx)($18e3dd79ec1b4bc2$var$ButtonContainer, {
                        id: "two-step-verification-recovery-submit",
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                            appearance: "primary",
                            type: "submit",
                            isFullWidth: true,
                            isLoading: isLoading,
                            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                                id: "common.login",
                                defaultMessage: "Log in"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $18e3dd79ec1b4bc2$export$2e2bcd8739ae039 = $18e3dd79ec1b4bc2$var$RecoveryForm;

});
parcelRegister("gFwNN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1439af55d1343b8c$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $9jjaN = parcelRequire("9jjaN");

var $6e88g = parcelRequire("6e88g");
let $1439af55d1343b8c$var$_ = (t)=>t, $1439af55d1343b8c$var$t;
const $1439af55d1343b8c$var$FieldGroupStyled = (0, $9jjaN.default).div($1439af55d1343b8c$var$t || ($1439af55d1343b8c$var$t = $1439af55d1343b8c$var$_`
  margin-top: ${0}px;
  transform-origin: 50% 0;
  transition-property: visibility, height, margin-top, opacity, transform;
  transition-duration: 0s, 0.2s, 0.2s, 0.2s;
  transition-timing-function: ease-in-out;

  /* Offset @atlaskit/form/Field margin-top */
  &:first-of-type {
    margin-top: ${0}px;
  }

  &.hidden {
    height: 0;
    margin-top: 0;
    opacity: 0;
    pointer-events: none;
    visibility: hidden;
    overflow: hidden;
  }
`), (0, $6e88g.gridSize)(), -(0, $6e88g.gridSize)());
function $1439af55d1343b8c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $4ZSso.jsx)($1439af55d1343b8c$var$FieldGroupStyled, (0, $b2I6k._)((0, $1Fos3._)({}, props), {
        className: `${props.className ? props.className : ''} ${props.isHidden ? 'hidden' : ''}`
    }));
}

});

parcelRegister("1cnQy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3a8a6637d1d3e3a$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $e3a8a6637d1d3e3a$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    mfRecoveryFormPlaceholder: {
        id: 'mf.recoveryform.placeholder',
        defaultMessage: '24-character emergency recovery key',
        description: ''
    },
    errorsInvalidRecoverCode: {
        id: 'mf.recoveryform.errors.invalid_recovery_code',
        defaultMessage: 'You entered an incorrect emergency recovery key.'
    },
    errorsInvalidRecoveryCodeFormat: {
        id: 'mf.recoveryform.errors.invalid_recovery_code_format',
        defaultMessage: 'You entered an invalid emergency recovery key.'
    },
    errorsNoRecoveryCode: {
        id: 'mf.recoveryform.errors.no_recovery_code',
        defaultMessage: 'Please enter your emergency recovery key.'
    },
    errorsInvalidOtpPattern: {
        id: 'mf.recoveryform.errors.invalid_otp_pattern',
        defaultMessage: 'Your emergency recovery key needs to be 24 characters.'
    }
});

});


parcelRegister("aeZEo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e41c79917b2414c$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $6NU0v = parcelRequire("6NU0v");

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");

var $9jjaN = parcelRequire("9jjaN");

var $boAHD = parcelRequire("boAHD");

var $jtgLn = parcelRequire("jtgLn");

var $fo5uj = parcelRequire("fo5uj");

var $kSuKB = parcelRequire("kSuKB");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");

var $k8ZoM = parcelRequire("k8ZoM");

var $2ZKUQ = parcelRequire("2ZKUQ");

var $76nnZ = parcelRequire("76nnZ");

var $cLysE = parcelRequire("cLysE");

var $21goM = parcelRequire("21goM");

var $26Riy = parcelRequire("26Riy");

var $21Xgy = parcelRequire("21Xgy");

var $9tebk = parcelRequire("9tebk");

var $dO2o4 = parcelRequire("dO2o4");
var $2sxQu = parcelRequire("2sxQu");
var $eg9g3 = parcelRequire("eg9g3");

var $7dnU9 = parcelRequire("7dnU9");

var $2aGBJ = parcelRequire("2aGBJ");
let $4e41c79917b2414c$var$_ = (t)=>t, $4e41c79917b2414c$var$t, $4e41c79917b2414c$var$t1, $4e41c79917b2414c$var$t2, $4e41c79917b2414c$var$t3, $4e41c79917b2414c$var$t4, $4e41c79917b2414c$var$t5, $4e41c79917b2414c$var$t6, $4e41c79917b2414c$var$t7, $4e41c79917b2414c$var$t8, $4e41c79917b2414c$var$t9, $4e41c79917b2414c$var$t10, $4e41c79917b2414c$var$t11, $4e41c79917b2414c$var$t12, $4e41c79917b2414c$var$t13, $4e41c79917b2414c$var$t14, $4e41c79917b2414c$var$t15, $4e41c79917b2414c$var$t16, $4e41c79917b2414c$var$t17, $4e41c79917b2414c$var$t18, $4e41c79917b2414c$var$t19, $4e41c79917b2414c$var$t20, $4e41c79917b2414c$var$t21, $4e41c79917b2414c$var$t22, $4e41c79917b2414c$var$t23, $4e41c79917b2414c$var$t24;
const $4e41c79917b2414c$var$imageWidth = 359;
const $4e41c79917b2414c$var$Container = (0, $9jjaN.default).div($4e41c79917b2414c$var$t1 || ($4e41c79917b2414c$var$t1 = $4e41c79917b2414c$var$_`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  width: ${0}px;
  min-height: ${0}px;
  height: calc(100vh - ${0}px);
  background: url(${0}) bottom center/ ${0}px no-repeat;

  ${0}
`), (0, $6e88g.gridSize)() * 82, (0, $6e88g.gridSize)() * 80, (0, $6e88g.gridSize)(), (0, (/*@__PURE__*/$parcel$interopDefault($21goM))), $4e41c79917b2414c$var$imageWidth, (0, $26Riy.media).handheld($4e41c79917b2414c$var$t || ($4e41c79917b2414c$var$t = $4e41c79917b2414c$var$_`
    width: ${0}px;
    background: none;
    padding-bottom: 0;
  `), (0, $6e88g.gridSize)() * 44));
const $4e41c79917b2414c$var$Subcontainer = (0, $9jjaN.default).div($4e41c79917b2414c$var$t3 || ($4e41c79917b2414c$var$t3 = $4e41c79917b2414c$var$_`
  display: flex;
  flex-direction: column;
  width: ${0}px;

  ${0}
`), (0, $6e88g.gridSize)() * 52, (0, $26Riy.media).handheld($4e41c79917b2414c$var$t2 || ($4e41c79917b2414c$var$t2 = $4e41c79917b2414c$var$_`
    width: ${0}px;
  `), (0, $6e88g.gridSize)() * 44));
const $4e41c79917b2414c$var$Heading = (0, $9jjaN.default).h2($4e41c79917b2414c$var$t5 || ($4e41c79917b2414c$var$t5 = $4e41c79917b2414c$var$_`
  display: flex;
  justify-content: center;
  margin-top: ${0}px !important;

  ${0}
`), (0, $6e88g.gridSize)() * 5, (0, $26Riy.media).handheld($4e41c79917b2414c$var$t4 || ($4e41c79917b2414c$var$t4 = $4e41c79917b2414c$var$_`
    display: none;
  `)));
const $4e41c79917b2414c$var$Subheading = (0, $9jjaN.default).h3($4e41c79917b2414c$var$t6 || ($4e41c79917b2414c$var$t6 = $4e41c79917b2414c$var$_`
  display: flex;
  align-items: center;
  margin-top: ${0}px !important;

  &::before {
    counter-increment: counter;
    content: counter(counter) '. ';
    margin-right: ${0}px;
  }
`), (0, $6e88g.gridSize)() * 3.5, (0, $6e88g.gridSize)() * 0.5);
const $4e41c79917b2414c$var$DesktopSubheading = (0, $9jjaN.default)($4e41c79917b2414c$var$Subheading)($4e41c79917b2414c$var$t8 || ($4e41c79917b2414c$var$t8 = $4e41c79917b2414c$var$_`
  ${0}
`), (0, $26Riy.media).handheld($4e41c79917b2414c$var$t7 || ($4e41c79917b2414c$var$t7 = $4e41c79917b2414c$var$_`
    display: none;
  `)));
const $4e41c79917b2414c$var$MobileSubheading = (0, $9jjaN.default)($4e41c79917b2414c$var$Subheading)($4e41c79917b2414c$var$t10 || ($4e41c79917b2414c$var$t10 = $4e41c79917b2414c$var$_`
  display: none;
  justify-content: center;
  font-size: 16px;

  ${0}

  &::before {
    content: '';
    margin: 0;
  }
`), (0, $26Riy.media).handheld($4e41c79917b2414c$var$t9 || ($4e41c79917b2414c$var$t9 = $4e41c79917b2414c$var$_`
    display: flex;
  `)));
const $4e41c79917b2414c$var$RecoveryCode = (0, $9jjaN.default).div($4e41c79917b2414c$var$t12 || ($4e41c79917b2414c$var$t12 = $4e41c79917b2414c$var$_`
  display: flex;
  justify-content: space-between;
  font: ${0};
  font-size: 24px;
  font-weight: bold;
  color: ${0};
  margin-top: ${0}px;

  ${0}
`), (0, $k8ZoM.default)('font.code'), (0, $kLNLK).N300, (0, $6e88g.gridSize)() * 2, (0, $26Riy.media).handheld($4e41c79917b2414c$var$t11 || ($4e41c79917b2414c$var$t11 = $4e41c79917b2414c$var$_`
    display: none;
  `)));
const $4e41c79917b2414c$var$MobileRecoveryCode = (0, $9jjaN.default)((0, $76nnZ.default))($4e41c79917b2414c$var$t14 || ($4e41c79917b2414c$var$t14 = $4e41c79917b2414c$var$_`
  display: none;
  text-align: center;
  font: ${0};
  font-size: 20px;
  color: ${0};
  margin-top: ${0}px;

  ${0}
`), (0, $k8ZoM.default)('font.code'), (0, $kLNLK).N300, (0, $6e88g.gridSize)() * 2, (0, $26Riy.media).handheld($4e41c79917b2414c$var$t13 || ($4e41c79917b2414c$var$t13 = $4e41c79917b2414c$var$_`
    display: block;
  `)));
const $4e41c79917b2414c$var$DropdownMenuContainer = (0, $9jjaN.default).div($4e41c79917b2414c$var$t16 || ($4e41c79917b2414c$var$t16 = $4e41c79917b2414c$var$_`
  display: flex;
  justify-content: flex-end;

  ${0}
`), (0, $26Riy.media).handheld($4e41c79917b2414c$var$t15 || ($4e41c79917b2414c$var$t15 = $4e41c79917b2414c$var$_`
    display: none;
  `)));
const $4e41c79917b2414c$var$StyledButton = (0, $9jjaN.default)((0, $jtgLn.default))($4e41c79917b2414c$var$t17 || ($4e41c79917b2414c$var$t17 = $4e41c79917b2414c$var$_`
  font-size: 14px !important;
  margin-left: auto !important;
  padding: 0 16px !important;
`));
const $4e41c79917b2414c$var$MobileButtonContainer = (0, $9jjaN.default)((0, $2ZKUQ.default))($4e41c79917b2414c$var$t19 || ($4e41c79917b2414c$var$t19 = $4e41c79917b2414c$var$_`
  display: none;

  ${0}
`), (0, $26Riy.media).handheld($4e41c79917b2414c$var$t18 || ($4e41c79917b2414c$var$t18 = $4e41c79917b2414c$var$_`
    display: block;
  `)));
const $4e41c79917b2414c$var$DesktopParagraph = (0, $9jjaN.default).p($4e41c79917b2414c$var$t21 || ($4e41c79917b2414c$var$t21 = $4e41c79917b2414c$var$_`
  ${0}
`), (0, $26Riy.media).handheld($4e41c79917b2414c$var$t20 || ($4e41c79917b2414c$var$t20 = $4e41c79917b2414c$var$_`
    display: none;
  `)));
const $4e41c79917b2414c$var$MobileParagraph = (0, $9jjaN.default).p($4e41c79917b2414c$var$t23 || ($4e41c79917b2414c$var$t23 = $4e41c79917b2414c$var$_`
  display: none;

  ${0}
`), (0, $26Riy.media).handheld($4e41c79917b2414c$var$t22 || ($4e41c79917b2414c$var$t22 = $4e41c79917b2414c$var$_`
    display: block;
  `)));
const $4e41c79917b2414c$var$RecoveryPage = ({ isEmbedded: isEmbedded, recoveryCode: recoveryCode, onComplete: onComplete })=>{
    const [newCodeSaved, setNewCodeSaved] = (0, $91i6m.useState)(false);
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    (0, $91i6m.useEffect)(()=>{
        window.onbeforeunload = null;
    }, []);
    const onClickOnRecovery = (0, $91i6m.useCallback)(()=>{
        const success = (0, (/*@__PURE__*/$parcel$interopDefault($kSuKB)))(recoveryCode);
        if (success) {
            const flag = {
                type: 'success',
                title: (0, $9tebk.default).mfRecoveryCopiedTitle,
                description: (0, $9tebk.default).mfRecoveryCopiedDesc
            };
            dispatch((0, $21Xgy.addFlag)(flag.type, flag.title, flag.description));
            setNewCodeSaved(true);
        }
    }, [
        dispatch,
        recoveryCode
    ]);
    const onRecoveryPrint = (0, $91i6m.useCallback)(()=>{
        // Invocation of this method will freeze the page in React 16 in development mode.
        // It does not affect production mode. The development mode bug is fixed in React 17:
        // https://github.com/facebook/react/issues/16734
        setTimeout(window.print);
        setNewCodeSaved(true);
    }, []);
    const onRecoverySkip = (0, $91i6m.useCallback)(()=>{
        setNewCodeSaved(true);
    }, []);
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $fo5uj.default), {
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $boAHD.Global), {
                styles: (0, $boAHD.css)($4e41c79917b2414c$var$t24 || ($4e41c79917b2414c$var$t24 = $4e41c79917b2414c$var$_`
          body {
            counter-reset: counter;
          }
        `))
            }),
            /*#__PURE__*/ (0, $4ZSso.jsxs)($4e41c79917b2414c$var$Container, {
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)($4e41c79917b2414c$var$Heading, {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                            id: "mf.recovery.heading",
                            defaultMessage: "We created a new emergency recovery key for you"
                        })
                    }),
                    /*#__PURE__*/ (0, $4ZSso.jsxs)($4e41c79917b2414c$var$Subcontainer, {
                        children: [
                            /*#__PURE__*/ (0, $4ZSso.jsx)($4e41c79917b2414c$var$DesktopSubheading, {
                                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                                    id: "mf.recovery.savekey",
                                    defaultMessage: "Save this emergency recovery key"
                                })
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsx)($4e41c79917b2414c$var$MobileSubheading, {
                                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                                    id: "mf.recovery.savekey.mobile",
                                    defaultMessage: "Save recovery key"
                                })
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsx)($4e41c79917b2414c$var$DesktopParagraph, {
                                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                                    id: "mf.recovery.savekey.desc",
                                    defaultMessage: "If you lose access to your phone, you won't be able to log in to your account without this key. Print, copy or write down this key without letting anyone see it."
                                })
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsx)($4e41c79917b2414c$var$MobileParagraph, {
                                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                                    id: "mf.recovery.savekey.desc.mobile",
                                    defaultMessage: "If you lose access to your phone, you won't be able to log in to your account without the key. Save this key without letting anyone see it."
                                })
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsx)($4e41c79917b2414c$var$RecoveryCode, {
                                id: "recovery-code",
                                children: (recoveryCode.match(/.{4}/g) || []).map((item, index)=>/*#__PURE__*/ (0, $4ZSso.jsx)("span", {
                                        children: item
                                    }, index))
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsx)("input", {
                                id: "recovery-code-assistive",
                                className: "assistive",
                                value: recoveryCode,
                                readOnly: true
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsx)($4e41c79917b2414c$var$MobileRecoveryCode, {
                                value: (recoveryCode.match(/.{4}/g) || []).join(' ')
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsx)($4e41c79917b2414c$var$DropdownMenuContainer, {
                                id: "mf-save-options",
                                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $dO2o4.default), {
                                    trigger: (_param)=>{
                                        var { triggerRef: triggerRef } = _param, props = (0, $6NU0v._)(_param, [
                                            "triggerRef"
                                        ]);
                                        return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $jtgLn.default), (0, $b2I6k._)((0, $1Fos3._)({}, props), {
                                            ref: triggerRef,
                                            iconAfter: /*#__PURE__*/ (0, $4ZSso.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7dnU9))), {
                                                label: ""
                                            }),
                                            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                                                id: "mf.recovery.saveoptions",
                                                defaultMessage: "Save options"
                                            })
                                        }));
                                    },
                                    children: /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $eg9g3.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $2sxQu.default), {
                                                onClick: onClickOnRecovery,
                                                children: /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
                                                    id: "mf-copy-key",
                                                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                                                        id: "mf.recovery.copy",
                                                        defaultMessage: "Copy to clipboard"
                                                    })
                                                })
                                            }),
                                            !isEmbedded && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $2sxQu.default), {
                                                onClick: onRecoveryPrint,
                                                children: /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
                                                    id: "mf-print-key",
                                                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                                                        id: "mf.recovery.print",
                                                        defaultMessage: "Print"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $2sxQu.default), {
                                                onClick: onRecoverySkip,
                                                children: /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
                                                    id: "mf-wrote-key",
                                                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                                                        id: "mf.recovery.skip",
                                                        defaultMessage: "I wrote it down"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsxs)($4e41c79917b2414c$var$DesktopSubheading, {
                                children: [
                                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                                        id: "mf.recovery.seriously",
                                        defaultMessage: "Seriously, save this key!"
                                    }),
                                    /*#__PURE__*/ (0, $4ZSso.jsx)($4e41c79917b2414c$var$StyledButton, {
                                        id: "two-step-verification-save-recovery-code-continue",
                                        isDisabled: !newCodeSaved,
                                        onClick: onComplete,
                                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                                            id: "mf.recovery.saved",
                                            defaultMessage: "Saved, let's go"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsx)($4e41c79917b2414c$var$MobileButtonContainer, {
                                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                                    appearance: "primary",
                                    isFullWidth: true,
                                    onClick: onComplete,
                                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                                        id: "mf.recovery.saved",
                                        defaultMessage: "Saved, let's go"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $4e41c79917b2414c$export$2e2bcd8739ae039 = $4e41c79917b2414c$var$RecoveryPage;

});
parcelRegister("kSuKB", function(module, exports) {
"use strict";

var $8KTI3 = parcelRequire("8KTI3");
var $f330b43debf12764$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $f330b43debf12764$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $f330b43debf12764$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $f330b43debf12764$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $8KTI3();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = $f330b43debf12764$var$clipboardToIE11Formatting[options.format] || $f330b43debf12764$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $f330b43debf12764$var$format("message" in options ? options.message : $f330b43debf12764$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
module.exports = $f330b43debf12764$var$copy;

});
parcelRegister("8KTI3", function(module, exports) {
module.exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case 'INPUT':
        case 'TEXTAREA':
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === 'Caret' && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};

});


parcelRegister("76nnZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83c974e4d7774581$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $9jjaN = parcelRequire("9jjaN");
let $83c974e4d7774581$var$_ = (t)=>t, $83c974e4d7774581$var$t;
const $83c974e4d7774581$var$StyledInput = (0, $9jjaN.default).input($83c974e4d7774581$var$t || ($83c974e4d7774581$var$t = $83c974e4d7774581$var$_`
  border: 0;
  padding: 0;
  font-size: 16px;
  width: 100%;
`));
const $83c974e4d7774581$var$handleClick = (e)=>{
    e.target.select(); // HTMLInputElement.setSelectionRange() doesn't work in some desktop browsers
    e.target.setSelectionRange(0, e.target.value.length); // HTMLInputElement.select() doesn't work on iOS
};
var $83c974e4d7774581$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $4ZSso.jsx)($83c974e4d7774581$var$StyledInput, (0, $b2I6k._)((0, $1Fos3._)({}, props), {
        readOnly: true,
        onClick: $83c974e4d7774581$var$handleClick
    }));

});

parcelRegister("21goM", function(module, exports) {

module.exports = (parcelRequire("cgi2g")).getBundleURL('9rAa3') + "save-recovery-key.57011d69.svg";

});

parcelRegister("9tebk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $421f46e0230a31d9$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $421f46e0230a31d9$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    // Flags
    mfRecoveryCopiedTitle: {
        id: 'mf.recovery.copied',
        defaultMessage: 'Emergency recovery key is in your clipboard',
        description: ''
    },
    mfRecoveryCopiedDesc: {
        id: 'mf.recovery.copied.desc',
        defaultMessage: 'Paste it into a text file and save.',
        description: ''
    }
});

});

parcelRegister("dO2o4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0d1cbf3744265ad$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $dsN6L = parcelRequire("dsN6L");

var $ai2Md = parcelRequire("ai2Md");

var $5YM7L = parcelRequire("5YM7L");

var $91i6m = parcelRequire("91i6m");

var $aA6j8 = parcelRequire("aA6j8");

var $7F47L = parcelRequire("7F47L");

var $lyJnu = parcelRequire("lyJnu");

var $bb3nf = parcelRequire("bb3nf");

var $6A0cm = parcelRequire("6A0cm");

var $jwIU8 = parcelRequire("jwIU8");

var $6KvX5 = parcelRequire("6KvX5");

var $kmrHv = parcelRequire("kmrHv");

var $5MIvA = parcelRequire("5MIvA");

var $f1k1y = parcelRequire("f1k1y");

var $8iC7e = parcelRequire("8iC7e");

var $6mRCH = parcelRequire("6mRCH");

var $4cG1b = parcelRequire("4cG1b");

var $cTR5X = parcelRequire("cTR5X");

var $eabYz = parcelRequire("eabYz");

var $9qul5 = parcelRequire("9qul5");

var $lPy2u = parcelRequire("lPy2u");
var $a0d1cbf3744265ad$var$_excluded = [
    "ref",
    "aria-controls",
    "aria-expanded",
    "aria-haspopup"
];
function $a0d1cbf3744265ad$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a0d1cbf3744265ad$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a0d1cbf3744265ad$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a0d1cbf3744265ad$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a0d1cbf3744265ad$var$MAX_HEIGHT = "calc(100vh - 16px)";
var $a0d1cbf3744265ad$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
var $a0d1cbf3744265ad$var$getFallbackPlacements = function getFallbackPlacements(placement) {
    var placementPieces = placement.split('-');
    var mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        var crossAxis = placementPieces[1];
        return [
            "".concat(mainAxis),
            "".concat(mainAxis, "-").concat($a0d1cbf3744265ad$var$opposites[crossAxis]),
            "".concat($a0d1cbf3744265ad$var$opposites[mainAxis], "-").concat(crossAxis),
            "".concat($a0d1cbf3744265ad$var$opposites[mainAxis]),
            "".concat($a0d1cbf3744265ad$var$opposites[mainAxis], "-").concat($a0d1cbf3744265ad$var$opposites[crossAxis]),
            'auto'
        ];
    } else return [
        "".concat(mainAxis, "-start"),
        "".concat(mainAxis, "-end"),
        "".concat($a0d1cbf3744265ad$var$opposites[mainAxis]),
        "".concat($a0d1cbf3744265ad$var$opposites[mainAxis], "-start"),
        "".concat($a0d1cbf3744265ad$var$opposites[mainAxis], "-end"),
        "auto"
    ];
};
function $a0d1cbf3744265ad$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ var $a0d1cbf3744265ad$var$DropdownMenu = function DropdownMenu(_ref) {
    var _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, children = _ref.children, _ref$defaultOpen = _ref.defaultOpen, defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isOpen = _ref.isOpen, _ref$onOpenChange = _ref.onOpenChange, onOpenChange = _ref$onOpenChange === void 0 ? (0, $6A0cm.default) : _ref$onOpenChange, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$shouldRenderToPa = _ref.shouldRenderToParent, shouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, returnFocusRef = _ref.returnFocusRef, spacing = _ref.spacing, statusLabel = _ref.statusLabel, testId = _ref.testId, _trigger = _ref.trigger, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? (0, $6mRCH.layers).modal() : _ref$zIndex, label = _ref.label, interactionName = _ref.interactionName, strategy = _ref.strategy, menuLabel = _ref.menuLabel;
    var _useControlledState = (0, $jwIU8.default)(isOpen, function() {
        return defaultOpen;
    }), _useControlledState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useControlledState, 2), isLocalOpen = _useControlledState2[0], setLocalIsOpen = _useControlledState2[1];
    var triggerRef = (0, $91i6m.useRef)(null);
    var _useState = (0, $91i6m.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), isTriggeredUsingKeyboard = _useState2[0], setTriggeredUsingKeyboard = _useState2[1];
    var id = (0, $lPy2u.default)();
    var itemRef = (0, $9qul5.default)();
    var _useLayering = (0, $5MIvA.useLayering)(), currentLevel = _useLayering.currentLevel;
    var fallbackPlacements = (0, $91i6m.useMemo)(function() {
        return $a0d1cbf3744265ad$var$getFallbackPlacements(placement);
    }, [
        placement
    ]);
    var handleTriggerClicked = (0, $91i6m.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    function(event) {
        var newValue = !isLocalOpen;
        var clientX = event.clientX, clientY = event.clientY, type = event.type, detail = event.detail;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            var _itemRef$current;
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef === null || itemRef === void 0 || (_itemRef$current = itemRef.current) === null || _itemRef$current === void 0 || _itemRef$current.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    var handleOnClose = (0, $91i6m.useCallback)(function(event, currentLevel) {
        var _event$target$closest, _event$target;
        var isTabOrEscapeKey = $a0d1cbf3744265ad$var$isKeyboardEvent(event) && (event.key === 'Tab' || event.key === 'Escape');
        if (event !== null && !isTabOrEscapeKey && event.target instanceof HTMLElement && (_event$target$closest = (_event$target = event.target).closest) !== null && _event$target$closest !== void 0 && _event$target$closest.call(_event$target, "[id^=".concat((0, $lPy2u.PREFIX), "] [aria-haspopup]"))) {
            var _itemRef$current2;
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            var toCloseLevel = (_itemRef$current2 = itemRef.current) === null || _itemRef$current2 === void 0 ? void 0 : _itemRef$current2.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(function() {
            var _returnFocusRef$curre;
            (_returnFocusRef$curre = returnFocusRef.current) === null || _returnFocusRef$curre === void 0 || _returnFocusRef$curre.focus();
        });
        else if ($a0d1cbf3744265ad$var$isKeyboardEvent(event) && (event.key === 'Tab' && event.shiftKey || event.key === 'Escape')) requestAnimationFrame(function() {
            var _itemRef$current3;
            (_itemRef$current3 = itemRef.current) === null || _itemRef$current3 === void 0 || _itemRef$current3.focus();
        });
        else if (triggerRef.current) {
            var _event$target$closest2, _event$target2;
            // Don't focus the trigger if the click was outside of the menu
            var isClickOutsideMenu = (event === null || event === void 0 ? void 0 : event.target) instanceof HTMLElement && ((_event$target$closest2 = (_event$target2 = event.target).closest) === null || _event$target$closest2 === void 0 ? void 0 : _event$target$closest2.call(_event$target2, '[role="menu"]')) === null;
            var shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(function() {
                var _triggerRef$current;
                (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || _triggerRef$current.focus();
            });
        }
        var newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    var _useFocus = (0, $6KvX5.default)(), isFocused = _useFocus.isFocused, bindFocus = _useFocus.bindFocus;
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $91i6m.useEffect)(function() {
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $6A0cm.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $6A0cm.default;
        return (0, $aA6j8.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                var isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest("[id^=".concat((0, $lPy2u.PREFIX), "] [aria-haspopup]"));
                if (e.key === (0, $lyJnu.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $lyJnu.KEY_SPACE) || e.key === (0, $lyJnu.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $lyJnu.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
   * The Popup component requires either:
   * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
   * or
   * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
   *
   * But not:
   * - shouldFitContainer={true} and shouldRenderToParent={false}
   *
   * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
   * types are satisfied.
   */ var conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $eabYz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $8iC7e.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
        // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
        returnFocusRef === undefined,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        role: shouldRenderToParent && currentLevel > 0 && (0, $f1k1y.fg)('platform-dst-nested-dropdown-menu-role') ? 'group' : undefined,
        fallbackPlacements: fallbackPlacements,
        testId: testId && "".concat(testId, "--content"),
        shouldUseCaptureOnOutsideClick: true
    }, conditionalProps, {
        shouldDisableFocusLock: true,
        trigger: function trigger(_ref2) {
            var ref = _ref2.ref, ariaControls = _ref2['aria-controls'], ariaExpanded = _ref2['aria-expanded'], ariaHasPopup = _ref2['aria-haspopup'], rest = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref2, $a0d1cbf3744265ad$var$_excluded);
            if (typeof _trigger === 'function') return _trigger($a0d1cbf3744265ad$var$_objectSpread($a0d1cbf3744265ad$var$_objectSpread($a0d1cbf3744265ad$var$_objectSpread({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup
            }, rest), bindFocus), {}, {
                triggerRef: (0, $bb3nf.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger")
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $7F47L.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, bindFocus, {
                ref: (0, $bb3nf.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: function iconAfter(iconProps) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kmrHv))), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, iconProps, {
                        size: "small"
                    }));
                },
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger"),
                "aria-label": label,
                interactionName: interactionName
            }), _trigger);
        },
        content: function content(_ref3) {
            var setInitialFocusRef = _ref3.setInitialFocusRef, update = _ref3.update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $4cG1b.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $cTR5X.default), {
                spacing: spacing,
                maxHeight: $a0d1cbf3744265ad$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && "".concat(testId, "--menu-wrapper"),
                menuLabel: menuLabel
            }, children));
        }
    })));
};
var $a0d1cbf3744265ad$export$2e2bcd8739ae039 = $a0d1cbf3744265ad$var$DropdownMenu;

});
parcelRegister("7F47L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $593f8fbb8a23609a$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $2jxp0 = parcelRequire("2jxp0");

var $fXpPO = parcelRequire("fXpPO");

var $aD51X = parcelRequire("aD51X");
var $593f8fbb8a23609a$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId",
    "type"
], $593f8fbb8a23609a$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $593f8fbb8a23609a$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], autoFocus = _ref.autoFocus, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $593f8fbb8a23609a$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(unsafeRest, $593f8fbb8a23609a$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $2jxp0.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName
    }, saferRest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $91i6m.Fragment), null, iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $fXpPO.default), {
        type: "icon",
        position: "before",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $aD51X.default), {
        icon: iconBefore
    })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $fXpPO.default), {
        isLoading: isLoading
    }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $fXpPO.default), {
        type: "icon",
        position: "after",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $aD51X.default), {
        icon: iconAfter
    }))));
}));
$593f8fbb8a23609a$var$Button.displayName = 'Button';
var $593f8fbb8a23609a$export$2e2bcd8739ae039 = $593f8fbb8a23609a$var$Button;

});

parcelRegister("jwIU8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e373d68d316f5d2a$export$2e2bcd8739ae039; });

var $5YM7L = parcelRequire("5YM7L");

var $91i6m = parcelRequire("91i6m");
function $e373d68d316f5d2a$export$2e2bcd8739ae039(propValue) {
    var getDefaultPropValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {
        return propValue;
    };
    var isControlled = propValue !== undefined;
    var _useState = (0, $91i6m.useState)(getDefaultPropValue), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), valueState = _useState2[0], setValue = _useState2[1];
    var isControlledRef = (0, $91i6m.useRef)(isControlled);
    (0, $91i6m.useEffect)(function() {
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    var value = isControlled ? propValue : valueState;
    var setValueIfUncontrolled = (0, $91i6m.useCallback)(function(newValue) {
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("6KvX5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e9fd2f3fbfdeda9$export$2e2bcd8739ae039; });

var $5YM7L = parcelRequire("5YM7L");

var $91i6m = parcelRequire("91i6m");
function $4e9fd2f3fbfdeda9$export$2e2bcd8739ae039() {
    var _useState = (0, $91i6m.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), isFocused = _useState2[0], setIsFocused = _useState2[1];
    // ensure bindFocus has a stable ref
    var bindFocus = (0, $91i6m.useRef)({
        onFocus: function onFocus() {
            return setIsFocused(true);
        },
        onBlur: function onBlur() {
            return setIsFocused(false);
        }
    });
    (0, $91i6m.useEffect)(function() {
        // handle the case where a component might
        // unmount while being focused.
        return function() {
            return setIsFocused(false);
        };
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("kmrHv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d03862cd3f81bd2eb2145cf11d082237>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ed2b597ea6322e73$var$_react = $ed2b597ea6322e73$var$_interopRequireDefault((parcelRequire("91i6m")));

var $ed2b597ea6322e73$var$_chevronDown = $ed2b597ea6322e73$var$_interopRequireDefault((parcelRequire("18iy0")));

var $ed2b597ea6322e73$var$_chevronDown2 = $ed2b597ea6322e73$var$_interopRequireDefault((parcelRequire("h9k6H")));
function $ed2b597ea6322e73$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "ChevronDownIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ed2b597ea6322e73$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $ed2b597ea6322e73$var$_react.default.createElement($ed2b597ea6322e73$var$_chevronDown.default, Object.assign({
        name: "ChevronDownIcon",
        LEGACY_fallbackIcon: $ed2b597ea6322e73$var$_chevronDown2.default
    }, props));
$ed2b597ea6322e73$var$ChevronDownIcon.displayName = 'ChevronDownIconMigration';
var $ed2b597ea6322e73$var$_default = module.exports.default = $ed2b597ea6322e73$var$ChevronDownIcon;

});
parcelRegister("18iy0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0d34ecf6c939e315$var$_react = $0d34ecf6c939e315$var$_interopRequireDefault((parcelRequire("91i6m")));

var $0d34ecf6c939e315$var$_baseNew = $0d34ecf6c939e315$var$_interopRequireDefault((parcelRequire("iTqNq")));
function $0d34ecf6c939e315$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0d34ecf6c939e315$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $0d34ecf6c939e315$var$_react.default.createElement($0d34ecf6c939e315$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$0d34ecf6c939e315$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $0d34ecf6c939e315$var$_default = module.exports.default = $0d34ecf6c939e315$var$ChevronDownIcon;

});
parcelRegister("iTqNq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("3R5Yd")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("3R5Yd")).Icon; });

var $3R5Yd = parcelRequire("3R5Yd");

});
parcelRegister("3R5Yd", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $2ceaf3e11d832813$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $2ceaf3e11d832813$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $f1k1y = parcelRequire("f1k1y");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $2ceaf3e11d832813$var$svgStyles = null;
var $2ceaf3e11d832813$var$iconStyles = null;
var $2ceaf3e11d832813$var$utilityIconStyles = null;
var $2ceaf3e11d832813$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $2ceaf3e11d832813$var$baseHcmStyles = null;
var $2ceaf3e11d832813$var$scaleSize = null;
var $2ceaf3e11d832813$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $2ceaf3e11d832813$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $2ceaf3e11d832813$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $2ceaf3e11d832813$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $2ceaf3e11d832813$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $2ceaf3e11d832813$export$f04a61298a47a40f = /*#__PURE__*/ (0, $91i6m.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $f1k1y.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $91i6m.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = $2ceaf3e11d832813$var$baseSizeMap[type];
    var viewBoxPadding = $2ceaf3e11d832813$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $91i6m.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $9gzWK.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $91i6m.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $9gzWK.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $2ceaf3e11d832813$var$utilSizes[spacing] : size === 'small' ? $2ceaf3e11d832813$var$coreSizeSmall[spacing] : $2ceaf3e11d832813$var$coreSizeMedium[spacing]
        ])
    }));
});
var $2ceaf3e11d832813$export$2e2bcd8739ae039 = $2ceaf3e11d832813$export$f04a61298a47a40f;

});



parcelRegister("h9k6H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7c2dfc7b214d49f$var$_react = $c7c2dfc7b214d49f$var$_interopRequireDefault((parcelRequire("91i6m")));

var $12xEP = parcelRequire("12xEP");
function $c7c2dfc7b214d49f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c7c2dfc7b214d49f$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $c7c2dfc7b214d49f$var$_react.default.createElement($12xEP.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props));
$c7c2dfc7b214d49f$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $c7c2dfc7b214d49f$var$_default = module.exports.default = $c7c2dfc7b214d49f$var$ChevronDownIcon;

});
parcelRegister("12xEP", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $0c20160cf82863f9$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");
function $0c20160cf82863f9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0c20160cf82863f9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0c20160cf82863f9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0c20160cf82863f9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $0c20160cf82863f9$var$iconStyles = null;
var $0c20160cf82863f9$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $0c20160cf82863f9$var$baseHcmStyles = null;
var $0c20160cf82863f9$var$primaryEqualsSecondaryHcmStyles = null;
var $0c20160cf82863f9$var$secondaryTransparentHcmStyles = null;
var $0c20160cf82863f9$export$f04a61298a47a40f = /*#__PURE__*/ (0, $91i6m.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $91i6m.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $91i6m.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $0c20160cf82863f9$var$_objectSpread($0c20160cf82863f9$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $9gzWK.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $0c20160cf82863f9$var$sizeStyles[size]
        ])
    }));
});
var $0c20160cf82863f9$export$2e2bcd8739ae039 = $0c20160cf82863f9$export$f04a61298a47a40f;

});



parcelRegister("6mRCH", function(module, exports) {

$parcel$export(module.exports, "layers", function () { return $4a2e6497d771a8f3$export$7be255094ccdc533; });

var $5RmjO = parcelRequire("5RmjO");

var $aLNhZ = parcelRequire("aLNhZ");
var $4a2e6497d771a8f3$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $4a2e6497d771a8f3$export$c93026a968943f95 = 'light';
var $4a2e6497d771a8f3$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $4a2e6497d771a8f3$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $4a2e6497d771a8f3$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $aLNhZ.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $4a2e6497d771a8f3$export$6d8204c2cb2e06b8() / 4;
    (0, $5RmjO.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $4a2e6497d771a8f3$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $4a2e6497d771a8f3$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $4a2e6497d771a8f3$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $5RmjO.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $4a2e6497d771a8f3$export$ba1d834b86d72a09 = $4a2e6497d771a8f3$export$a1b3edb637fb4f35;
var $4a2e6497d771a8f3$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $aLNhZ.N20A), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $aLNhZ.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $aLNhZ.N30A), ")")
            }
        }
    };
};

});
parcelRegister("aLNhZ", function(module, exports) {

$parcel$export(module.exports, "B200", function () { return $7d7486f9cc3b1a90$export$215b7063051591f1; });
$parcel$export(module.exports, "N20A", function () { return $7d7486f9cc3b1a90$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $7d7486f9cc3b1a90$export$920c0d5c49070351; });
// Reds
var $7d7486f9cc3b1a90$export$4b84fd0e2c617bd = '#FFEBE6';
var $7d7486f9cc3b1a90$export$b34b069eff244586 = '#FFBDAD';
var $7d7486f9cc3b1a90$export$be802dd0d8b57f35 = '#FF8F73';
var $7d7486f9cc3b1a90$export$60847d42f9da92a6 = '#FF7452';
var $7d7486f9cc3b1a90$export$4a7404f376229999 = '#FF5630';
var $7d7486f9cc3b1a90$export$2010d0fb4295b346 = '#DE350B';
var $7d7486f9cc3b1a90$export$2837b5a1a71d5c02 = '#BF2600';
var $7d7486f9cc3b1a90$export$8d9596b529bbb9cf = '#FFFAE6';
var $7d7486f9cc3b1a90$export$41060a744ab0b7ae = '#FFF0B3';
var $7d7486f9cc3b1a90$export$1cc05bbbf340e559 = '#FFE380';
var $7d7486f9cc3b1a90$export$5aae31392d72caaa = '#FFC400';
var $7d7486f9cc3b1a90$export$c6930421db9fa514 = '#FFAB00';
var $7d7486f9cc3b1a90$export$59619663aa6500fb = '#FF991F';
var $7d7486f9cc3b1a90$export$874739ea9e379ab6 = '#FF8B00';
var $7d7486f9cc3b1a90$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $7d7486f9cc3b1a90$export$69a3bf21b9686c2b = '#ABF5D1';
var $7d7486f9cc3b1a90$export$afbce1382ec95f73 = '#79F2C0';
var $7d7486f9cc3b1a90$export$747d86715d4175de = '#57D9A3';
var $7d7486f9cc3b1a90$export$940e1f69e873f202 = '#36B37E';
var $7d7486f9cc3b1a90$export$a49394138f7b8e85 = '#00875A';
var $7d7486f9cc3b1a90$export$6fa04827ac68a4fb = '#006644';
var $7d7486f9cc3b1a90$export$226de0355ed012f8 = '#DEEBFF';
var $7d7486f9cc3b1a90$export$8c13c2ee36917869 = '#B3D4FF';
var $7d7486f9cc3b1a90$export$ecfc1dff386a3e7a = '#4C9AFF';
var $7d7486f9cc3b1a90$export$215b7063051591f1 = '#2684FF';
var $7d7486f9cc3b1a90$export$e62e8919cca44969 = '#0065FF';
var $7d7486f9cc3b1a90$export$b3de0ae08da2ce64 = '#0052CC';
var $7d7486f9cc3b1a90$export$a6ee3d71bc067634 = '#0747A6';
var $7d7486f9cc3b1a90$export$67f15409e87642a1 = '#669DF1';
var $7d7486f9cc3b1a90$export$f0539dbc42dbb067 = '#8FB8F6';
var $7d7486f9cc3b1a90$export$363e4475840015bb = '#EAE6FF';
var $7d7486f9cc3b1a90$export$4b0a4417ed59760f = '#C0B6F2';
var $7d7486f9cc3b1a90$export$6011520a64d9a187 = '#998DD9';
var $7d7486f9cc3b1a90$export$a7175d4e9206bc80 = '#8777D9';
var $7d7486f9cc3b1a90$export$b48405b95304b5a1 = '#6554C0';
var $7d7486f9cc3b1a90$export$c71e4279dd54a18d = '#5243AA';
var $7d7486f9cc3b1a90$export$147899de772240ec = '#403294';
var $7d7486f9cc3b1a90$export$2cf711fe14c66f06 = '#E6FCFF';
var $7d7486f9cc3b1a90$export$7a8f4d33f6f9772c = '#B3F5FF';
var $7d7486f9cc3b1a90$export$776c9c497ef08533 = '#79E2F2';
var $7d7486f9cc3b1a90$export$69cb3ca10c1e330e = '#00C7E6';
var $7d7486f9cc3b1a90$export$9dc1ef0f3f48059b = '#00B8D9';
var $7d7486f9cc3b1a90$export$7c835c78b6fcdef8 = '#00A3BF';
var $7d7486f9cc3b1a90$export$6036577f95c3877e = '#008DA6';
var $7d7486f9cc3b1a90$export$29a4f05edc054374 = '#FFFFFF';
var $7d7486f9cc3b1a90$export$e655ef011c4aa1a2 = '#FAFBFC';
var $7d7486f9cc3b1a90$export$9fdfb749e33cdf97 = '#F4F5F7';
var $7d7486f9cc3b1a90$export$3e51e8f1440314ba = '#EBECF0';
var $7d7486f9cc3b1a90$export$1ce2d1575d444ceb = '#DFE1E6';
var $7d7486f9cc3b1a90$export$8754fc7e6d8b3000 = '#C1C7D0';
var $7d7486f9cc3b1a90$export$c2e91cbeada39b8b = '#B3BAC5';
var $7d7486f9cc3b1a90$export$5f71e19f3a7ad9de = '#A5ADBA';
var $7d7486f9cc3b1a90$export$eaa8c8a70ac22806 = '#97A0AF';
var $7d7486f9cc3b1a90$export$7c87d337fb91a97d = '#8993A4';
var $7d7486f9cc3b1a90$export$d6447c357493214f = '#7A869A';
var $7d7486f9cc3b1a90$export$f563ee71e9ee74cd = '#6B778C';
var $7d7486f9cc3b1a90$export$e2ef2124cf4024b1 = '#5E6C84';
var $7d7486f9cc3b1a90$export$eece5f492e429f08 = '#505F79';
var $7d7486f9cc3b1a90$export$c39c0fe0f26207ae = '#42526E';
var $7d7486f9cc3b1a90$export$7090862dc3038a9f = '#344563';
var $7d7486f9cc3b1a90$export$ad0bacf983b7ddaa = '#253858';
var $7d7486f9cc3b1a90$export$7d61b15e0da132af = '#172B4D';
var $7d7486f9cc3b1a90$export$fbda843f0a27fe96 = '#091E42';
var $7d7486f9cc3b1a90$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $7d7486f9cc3b1a90$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $7d7486f9cc3b1a90$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $7d7486f9cc3b1a90$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $7d7486f9cc3b1a90$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $7d7486f9cc3b1a90$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $7d7486f9cc3b1a90$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $7d7486f9cc3b1a90$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $7d7486f9cc3b1a90$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $7d7486f9cc3b1a90$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $7d7486f9cc3b1a90$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $7d7486f9cc3b1a90$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $7d7486f9cc3b1a90$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $7d7486f9cc3b1a90$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $7d7486f9cc3b1a90$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $7d7486f9cc3b1a90$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $7d7486f9cc3b1a90$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $7d7486f9cc3b1a90$export$2f6319cf7d736c2a = '#E6EDFA';
var $7d7486f9cc3b1a90$export$95126bc8884d6634 = '#DCE5F5';
var $7d7486f9cc3b1a90$export$8338d8c35d44ff1 = '#CED9EB';
var $7d7486f9cc3b1a90$export$5368d76ae4fbbda7 = '#B8C7E0';
var $7d7486f9cc3b1a90$export$9f0a771d16ec8d36 = '#ABBBD6';
var $7d7486f9cc3b1a90$export$abcf8c38338b4aa5 = '#9FB0CC';
var $7d7486f9cc3b1a90$export$97e81faa16a182c7 = '#8C9CB8';
var $7d7486f9cc3b1a90$export$bfe21c59123ecf33 = '#7988A3';
var $7d7486f9cc3b1a90$export$ee82aa2ea6a1558 = '#67758F';
var $7d7486f9cc3b1a90$export$682927c6ed76be02 = '#56637A';
var $7d7486f9cc3b1a90$export$91fd9994c5be9757 = '#455166';
var $7d7486f9cc3b1a90$export$d281fbfe3cff2df6 = '#3B475C';
var $7d7486f9cc3b1a90$export$3902c91d8b98a753 = '#313D52';
var $7d7486f9cc3b1a90$export$8e8133c1ba5845b5 = '#283447';
var $7d7486f9cc3b1a90$export$33ff357f6620b39 = '#202B3D';
var $7d7486f9cc3b1a90$export$633847cf062b69e0 = '#1B2638';
var $7d7486f9cc3b1a90$export$9776a6e503bdbf76 = '#121A29';
var $7d7486f9cc3b1a90$export$6c813d5160dff5db = '#0E1624';
var $7d7486f9cc3b1a90$export$3d4f271a500072a = '#0D1424';
var $7d7486f9cc3b1a90$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $7d7486f9cc3b1a90$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $7d7486f9cc3b1a90$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $7d7486f9cc3b1a90$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $7d7486f9cc3b1a90$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $7d7486f9cc3b1a90$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $7d7486f9cc3b1a90$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $7d7486f9cc3b1a90$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $7d7486f9cc3b1a90$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $7d7486f9cc3b1a90$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $7d7486f9cc3b1a90$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $7d7486f9cc3b1a90$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $7d7486f9cc3b1a90$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $7d7486f9cc3b1a90$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $7d7486f9cc3b1a90$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $7d7486f9cc3b1a90$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $7d7486f9cc3b1a90$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $7d7486f9cc3b1a90$export$d2adc5dedf09fced = '#292A2E';
var $7d7486f9cc3b1a90$export$f51762073d2bb381 = '#94C748';
var $7d7486f9cc3b1a90$export$95e26d54def96891 = '#B3DF72';

});


parcelRegister("4cG1b", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", function () { return $30f8e059c8df28ad$export$f18c1d4fc7326096; });
$parcel$export(module.exports, "default", function () { return $30f8e059c8df28ad$export$2e2bcd8739ae039; });

var $5YM7L = parcelRequire("5YM7L");

var $91i6m = parcelRequire("91i6m");

var $aA6j8 = parcelRequire("aA6j8");

var $6A0cm = parcelRequire("6A0cm");

var $5MIvA = parcelRequire("5MIvA");

var $czAst = parcelRequire("czAst");
var $30f8e059c8df28ad$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $91i6m.createContext)({
    menuItemRefs: [],
    registerRef: (0, $6A0cm.default)
});
/**
 * Focus manager logic.
 */ var $30f8e059c8df28ad$var$FocusManager = function FocusManager(_ref) {
    var children = _ref.children, onClose = _ref.onClose;
    var menuItemRefs = (0, $91i6m.useRef)([]);
    // Used to force a re-render only
    var _useState = (0, $91i6m.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), refresh = _useState2[0], setRefresh = _useState2[1];
    var registerMode = (0, $91i6m.useRef)('ordered');
    registerMode.current = 'ordered';
    var registerRef = (0, $91i6m.useCallback)(function(ref) {
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error("Unexpected case of ".concat(registerMode.current));
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    var _useLayering = (0, $5MIvA.useLayering)(), isLayerDisabled = _useLayering.isLayerDisabled;
    // Intentionally rebinding on each render
    (0, $91i6m.useEffect)(function() {
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $91i6m.useEffect)(function() {
        return (0, $aA6j8.bind)(window, {
            type: 'keydown',
            listener: (0, $czAst.default)(menuItemRefs, isLayerDisabled, onClose)
        });
    }, [
        isLayerDisabled,
        onClose
    ]);
    var contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($30f8e059c8df28ad$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $30f8e059c8df28ad$export$2e2bcd8739ae039 = $30f8e059c8df28ad$var$FocusManager;

});
parcelRegister("czAst", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $927508bf023f03af$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");

var $lyJnu = parcelRequire("lyJnu");

var $f1k1y = parcelRequire("f1k1y");

var $lPy2u = parcelRequire("lPy2u");
var $927508bf023f03af$var$actionMap = (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, (0, $lyJnu.KEY_DOWN), 'next'), (0, $lyJnu.KEY_UP), 'prev'), (0, $lyJnu.KEY_HOME), 'first'), (0, $lyJnu.KEY_END), 'last');
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ var $927508bf023f03af$var$getNextFocusableElement = function getNextFocusableElement(refs, currentFocusedIdx) {
    for(var i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        var element = refs[currentFocusedIdx].current;
        var isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ var $927508bf023f03af$var$getPrevFocusableElement = function getPrevFocusableElement(refs, currentFocusedIdx) {
    for(var i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        var element = refs[currentFocusedIdx].current;
        var isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
};
function $927508bf023f03af$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return function(e) {
        var _refs$current;
        var currentRefs = (_refs$current = refs.current) !== null && _refs$current !== void 0 ? _refs$current : [];
        var currentFocusedIdx = currentRefs.findIndex(function(_ref) {
            var _document$activeEleme;
            var el = _ref.current;
            return el && ((_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.isSameNode(el));
        });
        if ((0, $f1k1y.fg)('platform_dst_popup-disable-focuslock')) {
            var _document$activeEleme2;
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            var isNestedDropdown = !!((_document$activeEleme2 = document.activeElement) !== null && _document$activeEleme2 !== void 0 && _document$activeEleme2.closest("[id^=".concat((0, $lPy2u.PREFIX), "]")));
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $lyJnu.KEY_TAB) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $lyJnu.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        var action = $927508bf023f03af$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                var nextFocusableElement = $927508bf023f03af$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement === null || nextFocusableElement === void 0 || nextFocusableElement.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                var prevFocusableElement = $927508bf023f03af$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement === null || prevFocusableElement === void 0 || prevFocusableElement.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                var firstFocusableElement = $927508bf023f03af$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement === null || firstFocusableElement === void 0 || firstFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                var lastFocusableElement = $927508bf023f03af$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement === null || lastFocusableElement === void 0 || lastFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

});
parcelRegister("lPy2u", function(module, exports) {

$parcel$export(module.exports, "PREFIX", function () { return $fe48c3d93fd29408$export$8a682ae47622dbb9; });
$parcel$export(module.exports, "default", function () { return $fe48c3d93fd29408$export$2e2bcd8739ae039; });

var $lD6mB = parcelRequire("lD6mB");
var $fe48c3d93fd29408$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $fe48c3d93fd29408$export$2e2bcd8739ae039() {
    var id = (0, $lD6mB.useId)();
    return "".concat($fe48c3d93fd29408$export$8a682ae47622dbb9).concat(id);
}

});



parcelRegister("cTR5X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9643cead33d57625$export$2e2bcd8739ae039; });
/* menu-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");


var $7nD7a = parcelRequire("7nD7a");

var $aDWwl = parcelRequire("aDWwl");

var $9OWP7 = parcelRequire("9OWP7");

var $iM47l = parcelRequire("iM47l");

var $6I1nw = parcelRequire("6I1nw");

var $4cG1b = parcelRequire("4cG1b");
var $9643cead33d57625$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _ca0qv47k _u5f3v47k _n3tdv47k _19bvv47k"
};
var $9643cead33d57625$var$LoadingIndicator = function LoadingIndicator(_ref) {
    var _ref$statusLabel = _ref.statusLabel, statusLabel = _ref$statusLabel === void 0 ? 'Loading' : _ref$statusLabel, testId = _ref.testId;
    return /*#__PURE__*/ $91i6m.createElement((0, $aDWwl.default), {
        xcss: $9643cead33d57625$var$styles.spinnerContainer,
        role: "menuitem"
    }, /*#__PURE__*/ $91i6m.createElement((0, $9OWP7.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
};
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ var $9643cead33d57625$var$MenuWrapper = function MenuWrapper(_ref2) {
    var children = _ref2.children, isLoading = _ref2.isLoading, maxHeight = _ref2.maxHeight, maxWidth = _ref2.maxWidth, onClose = _ref2.onClose, onUpdate = _ref2.onUpdate, statusLabel = _ref2.statusLabel, setInitialFocusRef = _ref2.setInitialFocusRef, shouldRenderToParent = _ref2.shouldRenderToParent, spacing = _ref2.spacing, testId = _ref2.testId, isTriggeredUsingKeyboard = _ref2.isTriggeredUsingKeyboard, autoFocus = _ref2.autoFocus, menuLabel = _ref2.menuLabel;
    var _useContext = (0, $91i6m.useContext)((0, $4cG1b.FocusManagerContext)), menuItemRefs = _useContext.menuItemRefs;
    var closeOnMenuItemClick = function closeOnMenuItemClick(e) {
        var isTargetMenuItemOrDescendant = menuItemRefs.some(function(menuItemRef) {
            var menuItem = menuItemRef.current;
            if (!menuItem) return false;
            var isCheckboxOrRadio = (0, $iM47l.default)(menuItem) || (0, $6I1nw.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $91i6m.useLayoutEffect)(function() {
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $91i6m.useEffect)(function() {
        var _menuItemRefs$map$fin;
        var firstFocusableRef = (_menuItemRefs$map$fin = menuItemRefs.map(function(_ref3) {
            var current = _ref3.current;
            return current;
        }).find(function(el) {
            return !!el && !el.hasAttribute('disabled');
        })) !== null && _menuItemRefs$map$fin !== void 0 ? _menuItemRefs$map$fin : null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef === null || firstFocusableRef === void 0 || firstFocusableRef.focus();
        setInitialFocusRef === null || setInitialFocusRef === void 0 || setInitialFocusRef(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ $91i6m.createElement((0, $7nD7a.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && "".concat(testId, "--menu-group"),
        menuLabel: menuLabel
    }, isLoading ? /*#__PURE__*/ $91i6m.createElement($9643cead33d57625$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && "".concat(testId, "--loading-indicator")
    }) : children);
};
var $9643cead33d57625$export$2e2bcd8739ae039 = $9643cead33d57625$var$MenuWrapper;

});
parcelRegister("7nD7a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55f905bb3a5d4330$export$2e2bcd8739ae039; });
/* menu-group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $7XmRn = parcelRequire("7XmRn");
var $55f905bb3a5d4330$var$_excluded = [
    "isLoading",
    "maxWidth",
    "minWidth",
    "minHeight",
    "maxHeight",
    "testId",
    "role",
    "spacing",
    "menuLabel",
    "className"
];
var $55f905bb3a5d4330$var$baseStyles = null;
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $55f905bb3a5d4330$var$MenuGroup = function MenuGroup(_ref) {
    var isLoading = _ref.isLoading, maxWidth = _ref.maxWidth, minWidth = _ref.minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, testId = _ref.testId, role = _ref.role, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'cozy' : _ref$spacing, menuLabel = _ref.menuLabel, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $55f905bb3a5d4330$var$_excluded);
    return /*#__PURE__*/ $91i6m.createElement((0, $7XmRn.SpacingContext).Provider, {
        value: spacing
    }, /*#__PURE__*/ $91i6m.createElement((0, $7XmRn.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "border"
    }, /*#__PURE__*/ $91i6m.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        "aria-busy": isLoading,
        style: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        },
        "data-testid": testId,
        role: role,
        className: (0, $9gzWK.default)([
            "_1reo1wug _18m91wug _1e0c1txw _kqswpfqs _2lx21bp4",
            UNSAFE_className
        ]),
        "aria-label": menuLabel
    }, rest))));
};
var $55f905bb3a5d4330$export$2e2bcd8739ae039 = $55f905bb3a5d4330$var$MenuGroup;

});
parcelRegister("7XmRn", function(module, exports) {

$parcel$export(module.exports, "SpacingContext", function () { return $5cafc69d61f62b77$export$443076ec7ebce042; });
$parcel$export(module.exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", function () { return $5cafc69d61f62b77$export$9ca534b70725964d; });

var $91i6m = parcelRequire("91i6m");
var $5cafc69d61f62b77$export$443076ec7ebce042 = /*#__PURE__*/ (0, $91i6m.createContext)('cozy');
var $5cafc69d61f62b77$export$9ca534b70725964d = /*#__PURE__*/ (0, $91i6m.createContext)('border');

});


parcelRegister("iM47l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $daafe751ad80c3f5$export$2e2bcd8739ae039; });
function $daafe751ad80c3f5$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("6I1nw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e27ebd4f6d13e04$export$2e2bcd8739ae039; });
function $4e27ebd4f6d13e04$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("eabYz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4fb4a02f33f382a$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $6A0cm = parcelRequire("6A0cm");
var $a4fb4a02f33f382a$export$756f795847463ebd = /*#__PURE__*/ (0, $91i6m.createContext)({
    setItemState: (0, $6A0cm.default),
    getItemState: function getItemState() {
        return undefined;
    },
    setGroupState: (0, $6A0cm.default),
    getGroupState: function getGroupState() {
        return {};
    }
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ var $a4fb4a02f33f382a$var$SelectionStore = function SelectionStore(props) {
    var children = props.children;
    var store = (0, $91i6m.useRef)({});
    var context = (0, $91i6m.useMemo)(function() {
        return {
            setItemState: function setItemState(group, id, value) {
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: function getItemState(group, id) {
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: function setGroupState(group, value) {
                store.current[group] = value;
            },
            getGroupState: function getGroupState(group) {
                return store.current[group] || {};
            }
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($a4fb4a02f33f382a$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $a4fb4a02f33f382a$export$2e2bcd8739ae039 = $a4fb4a02f33f382a$var$SelectionStore;

});

parcelRegister("9qul5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6dce137e17ec7d52$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $f1k1y = parcelRequire("f1k1y");

var $4cG1b = parcelRequire("4cG1b");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $6dce137e17ec7d52$var$useRegisterItemWithFocusManager() {
    var hasPopup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var _useContext = (0, $91i6m.useContext)((0, $4cG1b.FocusManagerContext)), registerRef = _useContext.registerRef;
    var itemRef = (0, $91i6m.useRef)(null);
    (0, $91i6m.useEffect)(function() {
        if (hasPopup && (0, $f1k1y.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $6dce137e17ec7d52$export$2e2bcd8739ae039 = $6dce137e17ec7d52$var$useRegisterItemWithFocusManager;

});


parcelRegister("2sxQu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ca87355d20d7cec$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $bb3nf = parcelRequire("bb3nf");

var $9WsCP = parcelRequire("9WsCP");

var $5H2f8 = parcelRequire("5H2f8");

var $hUKfR = parcelRequire("hUKfR");

var $9qul5 = parcelRequire("9qul5");
var $1ca87355d20d7cec$var$_excluded = [
    "children",
    "component",
    "description",
    "elemAfter",
    "elemBefore",
    "href",
    "isDisabled",
    "isSelected",
    "onClick",
    "rel",
    "shouldDescriptionWrap",
    "shouldTitleWrap",
    "target",
    "testId",
    "UNSAFE_shouldDisableRouterLink",
    "returnFocusRef",
    "interactionName",
    "role"
];
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ var $1ca87355d20d7cec$var$DropdownMenuItem = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref, ref) {
    var children = _ref.children, component = _ref.component, description = _ref.description, elemAfter = _ref.elemAfter, elemBefore = _ref.elemBefore, href = _ref.href, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, onClick = _ref.onClick, rel = _ref.rel, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, target = _ref.target, testId = _ref.testId, UNSAFE_shouldDisableRouterLink = _ref.UNSAFE_shouldDisableRouterLink, returnFocusRef = _ref.returnFocusRef, interactionName = _ref.interactionName, role = _ref.role, rest = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $1ca87355d20d7cec$var$_excluded);
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    var itemRef = (0, $9qul5.default)(!!rest['aria-haspopup']);
    var handleItemClick = (0, $91i6m.useCallback)(function(event) {
        if (returnFocusRef !== null && returnFocusRef !== void 0 && returnFocusRef.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $5H2f8.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $bb3nf.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        target: target,
        rel: rel,
        interactionName: interactionName
    }, rest), children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $hUKfR.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $bb3nf.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName
    }, rest), children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $9WsCP.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $bb3nf.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        target: target,
        rel: rel,
        interactionName: interactionName
    }, rest), children);
});
var $1ca87355d20d7cec$export$2e2bcd8739ae039 = $1ca87355d20d7cec$var$DropdownMenuItem;

});
parcelRegister("9WsCP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73cfbc396d9eaee3$export$2e2bcd8739ae039; });
/* button-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");


var $1C8Ck = parcelRequire("1C8Ck");

var $kt9LD = parcelRequire("kt9LD");
var $73cfbc396d9eaee3$var$_excluded = [
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "interactionName"
];
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $73cfbc396d9eaee3$var$ButtonItem = /*#__PURE__*/ (0, $91i6m.memo)(/*#__PURE__*/ (0, $91i6m.forwardRef)(function(props, ref) {
    var children = props.children, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, interactionName = props.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(props, $73cfbc396d9eaee3$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $91i6m.useContext)((0, $1C8Ck.default));
    var handleClick = (0, $91i6m.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    return /*#__PURE__*/ $91i6m.createElement((0, $kt9LD.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        className: UNSAFE_className
    }, rest, {
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isTitleHeading: false,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return /*#__PURE__*/ $91i6m.createElement("button", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
            "data-testid": testId,
            "aria-current": isSelected ? 'true' : undefined
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: handleClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }), children);
    });
}));
var $73cfbc396d9eaee3$export$2e2bcd8739ae039 = $73cfbc396d9eaee3$var$ButtonItem;

});
parcelRegister("1C8Ck", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12d0063ec45232ec$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");
var $12d0063ec45232ec$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $91i6m.createContext)(null);

});

parcelRegister("kt9LD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee6e17a67d56b59f$export$2e2bcd8739ae039; });
/* menu-item-primitive.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $f1k1y = parcelRequire("f1k1y");

var $dwV3h = parcelRequire("dwV3h");

var $7XmRn = parcelRequire("7XmRn");
var $ee6e17a67d56b59f$var$renderTitle = function renderTitle(Component, props) {
    return(/*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    $91i6m.createElement(Component, props));
};
var $ee6e17a67d56b59f$var$styles = {
    root: "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _4bfu1r31 _1hmsglyw _ajmmnqa1 _kqswh2mm _1e0c1txw _vchhusvi _1bsb1osq _1tke1ylp _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _4cvr1h6o _uiztglyw _80omtlke _ymio1r31 _ypr0glyw _zcxs1o36 _nt75194a _mizu194a _1bg411pw _1ah311pw _49pcnqa1 _ra3xnqa1 _1hvw1bk5 _128m1bk5 _9oik1r31 _1bnxglyw _jf4cnqa1 _1cvmnqa1 _4davt94y",
    beforeAfterElement: "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf",
    content: "_12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _1bah1h6o _16jlkb7n _y3gn1e5h",
    truncate: "_1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c",
    title: "_11c82smr",
    wordBreak: "_1nmz1hna",
    description: "_11c8dcr7 _syaz1wmz",
    disabledDescription: "_syaz2oi6",
    unselected: "_bfhkqtfy _syaz1r31 _10531r31 _irr31dko _30l31r31 _1di61dko _9h8h1r31",
    disabled: "_80om13gf _bfhkqtfy _syaz2oi6 _irr3qtfy _30l32oi6 _1di6qtfy _9h8h2oi6",
    selectedBorder: "_1mp4yh40 _1cs8stnw _1rus67is _1kt9b3bt _1fkrze3t _iajmze3t _z5wtze3t",
    selectedNotch: "_rfx3bx74 _1mp41y44 _1cs8stnw _1rus67is _1kt9b3bt _1fkrutpp _iajmutpp _z5wtze3t",
    selected: "_bfhk1q4k _syazhu5v _1053hu5v _irr32seo _30l316ov _1di6guph _9h8hhu5v",
    selectedOld: "_30l3hu5v"
};
var $ee6e17a67d56b59f$var$spacingMapStyles = {
    cozy: "_1rjcu2gc _18zrpxbi",
    compact: "_1rjc1b66 _18zrutpp _1tkezwfg"
};
var $ee6e17a67d56b59f$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ var $ee6e17a67d56b59f$var$MenuItemPrimitive = function MenuItemPrimitive(_ref) {
    var children = _ref.children, title = _ref.title, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, UNSAFE_externalClassName = _ref.className, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? false : _ref$shouldTitleWrap, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? false : _ref$shouldDescriptio, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isTitleHeading = _ref.isTitleHeading, isTitleHeading = _ref$isTitleHeading === void 0 ? false : _ref$isTitleHeading, testId = _ref.testId;
    var spacing = (0, $91i6m.useContext)((0, $7XmRn.SpacingContext));
    var selectionStyle = (0, $91i6m.useContext)((0, $7XmRn.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    var UNSAFE_className = UNSAFE_externalClassName;
    return function() {
        return children({
            className: (0, $9gzWK.default)([
                (0, $9gzWK.default)([
                    $ee6e17a67d56b59f$var$styles.root,
                    $ee6e17a67d56b59f$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $ee6e17a67d56b59f$var$styles.unselected,
                    !isDisabled && isSelected && $ee6e17a67d56b59f$var$styles.selected,
                    !(0, $f1k1y.fg)('platform_fix_a11y_selected_and_hovered_state_color') && !isDisabled && isSelected && $ee6e17a67d56b59f$var$styles.selectedOld,
                    !isDisabled && isSelected && selectionStyle === 'border' && $ee6e17a67d56b59f$var$styles.selectedBorder,
                    !isDisabled && isSelected && selectionStyle === 'notch' && $ee6e17a67d56b59f$var$styles.selectedNotch,
                    isDisabled && $ee6e17a67d56b59f$var$styles.disabled
                ]),
                UNSAFE_className
            ]),
            children: /*#__PURE__*/ $91i6m.createElement((0, $dwV3h.default), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $ee6e17a67d56b59f$var$gapMap[spacing],
                grow: "fill",
                testId: testId && "".concat(testId, "--container")
            }, iconBefore && /*#__PURE__*/ $91i6m.createElement("span", {
                "data-item-elem-before": true,
                "data-testid": testId && "".concat(testId, "--icon-before"),
                className: (0, $9gzWK.default)([
                    $ee6e17a67d56b59f$var$styles.beforeAfterElement
                ])
            }, iconBefore), title && /*#__PURE__*/ $91i6m.createElement("div", {
                className: (0, $9gzWK.default)([
                    $ee6e17a67d56b59f$var$styles.content
                ])
            }, $ee6e17a67d56b59f$var$renderTitle(isTitleHeading ? 'h2' : 'span', {
                children: title,
                className: (0, $9gzWK.default)([
                    $ee6e17a67d56b59f$var$styles.title,
                    shouldTitleWrap ? $ee6e17a67d56b59f$var$styles.wordBreak : $ee6e17a67d56b59f$var$styles.truncate
                ]),
                'data-item-title': true
            }), description && /*#__PURE__*/ $91i6m.createElement("span", {
                "data-item-description": true,
                className: (0, $9gzWK.default)([
                    $ee6e17a67d56b59f$var$styles.description,
                    isDisabled && $ee6e17a67d56b59f$var$styles.disabledDescription,
                    shouldDescriptionWrap && $ee6e17a67d56b59f$var$styles.wordBreak,
                    !shouldDescriptionWrap && $ee6e17a67d56b59f$var$styles.truncate
                ])
            }, description)), iconAfter && /*#__PURE__*/ $91i6m.createElement("span", {
                "data-item-elem-after": true,
                "data-testid": testId && "".concat(testId, "--icon-after"),
                className: (0, $9gzWK.default)([
                    $ee6e17a67d56b59f$var$styles.beforeAfterElement
                ])
            }, iconAfter))
        });
    }();
};
var $ee6e17a67d56b59f$export$2e2bcd8739ae039 = $ee6e17a67d56b59f$var$MenuItemPrimitive;

});


parcelRegister("5H2f8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4252b557734bd260$export$2e2bcd8739ae039; });
/* custom-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");


var $1C8Ck = parcelRequire("1C8Ck");

var $kt9LD = parcelRequire("kt9LD");
var $4252b557734bd260$var$_excluded = [
    "component",
    "isDisabled",
    "isSelected",
    "isTitleHeading",
    "onClick",
    "testId",
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $4252b557734bd260$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
// Dirty hack to get generics working with forward ref [1/2]
/**
 * __Custom item__
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $4252b557734bd260$var$CustomItem = /*#__PURE__*/ (0, $91i6m.memo)(/*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref, ref) {
    var Component = _ref.component, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isTitleHeading = _ref.isTitleHeading, isTitleHeading = _ref$isTitleHeading === void 0 ? false : _ref$isTitleHeading, onClick = _ref.onClick, testId = _ref.testId, children = _ref.children, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, onMouseDown = _ref.onMouseDown, shouldTitleWrap = _ref.shouldTitleWrap, shouldDescriptionWrap = _ref.shouldDescriptionWrap, UNSAFE_className = _ref.className, UNSAFE_isDraggable = _ref.UNSAFE_isDraggable, interactionName = _ref.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $4252b557734bd260$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $91i6m.useContext)((0, $1C8Ck.default));
    var handleClick = (0, $91i6m.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    return /*#__PURE__*/ $91i6m.createElement((0, $kt9LD.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        className: UNSAFE_className
    }, rest, {
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: isTitleHeading,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref2) {
        var children = _ref2.children, className = _ref2.className;
        return /*#__PURE__*/ $91i6m.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $4252b557734bd260$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $4252b557734bd260$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $4252b557734bd260$var$preventEvent : handleClick,
            tabIndex: isDisabled ? -1 : undefined,
            "aria-disabled": isDisabled
        }), children);
    });
}));
var $4252b557734bd260$export$2e2bcd8739ae039 = $4252b557734bd260$var$CustomItem;

});

parcelRegister("hUKfR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0ab8be1a3705315$export$2e2bcd8739ae039; });
/* link-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");


var $l23ST = parcelRequire("l23ST");

var $1C8Ck = parcelRequire("1C8Ck");

var $kt9LD = parcelRequire("kt9LD");
var $d0ab8be1a3705315$var$_excluded = [
    "children",
    "href",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_shouldDisableRouterLink",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $d0ab8be1a3705315$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $d0ab8be1a3705315$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
var $d0ab8be1a3705315$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $d0ab8be1a3705315$var$LinkItem = /*#__PURE__*/ (0, $91i6m.memo)(/*#__PURE__*/ (0, $91i6m.forwardRef)(function(props, ref) {
    var children = props.children, href = props.href, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, UNSAFE_shouldDisableRouterLink = props.UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable = props.UNSAFE_isDraggable, interactionName = props.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(props, $d0ab8be1a3705315$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var RouterLink = (0, $l23ST.default)();
    var interactionContext = (0, $91i6m.useContext)((0, $1C8Ck.default));
    var handleClick = (0, $91i6m.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    var isExternal = typeof href === 'string' && $d0ab8be1a3705315$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $d0ab8be1a3705315$var$IS_NON_HTTP_BASED.test(href);
    var isEmptyHref = href == null || href === '';
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ var isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    var Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $91i6m.createElement((0, $kt9LD.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: false,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        title: children,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return /*#__PURE__*/ $91i6m.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
            "data-testid": testId,
            "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
            "data-vc": "link-item"
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            href: isDisabled ? undefined : href
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $d0ab8be1a3705315$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $d0ab8be1a3705315$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $d0ab8be1a3705315$var$preventEvent : handleClick,
            "aria-current": isSelected ? 'page' : undefined,
            "aria-disabled": isDisabled,
            ref: ref
        }), children);
    });
}));
var $d0ab8be1a3705315$export$2e2bcd8739ae039 = $d0ab8be1a3705315$var$LinkItem;

});


parcelRegister("eg9g3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a619bdc07515f87d$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $lD6mB = parcelRequire("lD6mB");

var $BmWwz = parcelRequire("BmWwz");

var $33FXt = parcelRequire("33FXt");
var $a619bdc07515f87d$var$_excluded = [
    "children",
    "id",
    "isList",
    "isScrollable",
    "title",
    "testId",
    "hasSeparator"
];
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ var $a619bdc07515f87d$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref, ref) {
    var children = _ref.children, id = _ref.id, isList = _ref.isList, isScrollable = _ref.isScrollable, title = _ref.title, testId = _ref.testId, hasSeparator = _ref.hasSeparator, rest = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $a619bdc07515f87d$var$_excluded);
    var uid = (0, $lD6mB.useId)();
    var titleId = "dropdown-menu-item-group-title-".concat(uid);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $BmWwz.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $33FXt.default), {
        id: titleId,
        title: title
    }), children);
});
var $a619bdc07515f87d$export$2e2bcd8739ae039 = $a619bdc07515f87d$var$DropdownMenuItemGroup;

});
parcelRegister("BmWwz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $070540ce4a5ac4c1$export$2e2bcd8739ae039; });
/* section.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $5puEk = parcelRequire("5puEk");
var $070540ce4a5ac4c1$var$_excluded = [
    "children",
    "title",
    "titleId",
    "testId",
    "isScrollable",
    "hasSeparator",
    "id",
    "isList",
    "isSideNavSection",
    "className"
];
var $070540ce4a5ac4c1$var$itemHeadingTopMargin = 20;
var $070540ce4a5ac4c1$var$itemHeadingBottomMargin = 6;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
var $070540ce4a5ac4c1$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
var $070540ce4a5ac4c1$var$skeletonHeadingHeight = 8;
var $070540ce4a5ac4c1$var$skeletonHeadingMarginOffset = 3;
var $070540ce4a5ac4c1$var$skeletonHeadingTopMargin = $070540ce4a5ac4c1$var$itemHeadingTopMargin + ($070540ce4a5ac4c1$var$itemHeadingContentHeight - $070540ce4a5ac4c1$var$skeletonHeadingHeight) - $070540ce4a5ac4c1$var$skeletonHeadingMarginOffset;
var $070540ce4a5ac4c1$var$sectionPaddingTopBottom = 6;
var $070540ce4a5ac4c1$var$styles = {
    root: "_1ywu1ule _cfu11ule _1qdgi2wt _kfgti2wt _aetrb3bt _1kt9b3bt _1p3hi2wt _1l6bgktf _osbldlk8 _auo4rdoj _hp2110yn _1mfv8jkm _1bg41n1a",
    scrollable: "_1reo1wug _18m91wug _1o9zkb7n",
    unscrollable: "_1o9zidpf",
    thinSeparator: "_mqm21imm",
    noSeparator: "_n7cnyjp0",
    sideNavSectionHeading: "_18zru2gc"
};
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $070540ce4a5ac4c1$var$Section = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref, ref) {
    var children = _ref.children, title = _ref.title, titleId = _ref.titleId, testId = _ref.testId, isScrollable = _ref.isScrollable, hasSeparator = _ref.hasSeparator, id = _ref.id, _ref$isList = _ref.isList, isList = _ref$isList === void 0 ? false : _ref$isList, _ref$isSideNavSection = _ref.isSideNavSection, isSideNavSection = _ref$isSideNavSection === void 0 ? false : _ref$isSideNavSection, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $070540ce4a5ac4c1$var$_excluded);
    var content = isList ? /*#__PURE__*/ $91i6m.createElement("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        }
    }, (0, $91i6m.Children).map((0, $91i6m.Children).toArray(children), function(child, index) {
        return /*#__PURE__*/ $91i6m.createElement("li", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                listStyleType: 'none',
                margin: 0,
                padding: 0
            },
            key: index
        }, child);
    })) : children;
    var childrenMarkup = title !== undefined ? /*#__PURE__*/ $91i6m.createElement((0, $91i6m.Fragment), null, /*#__PURE__*/ $91i6m.createElement((0, $5puEk.default), {
        testId: testId && "".concat(testId, "--heading"),
        "aria-hidden": true,
        className: (0, $9gzWK.default)([
            isSideNavSection && $070540ce4a5ac4c1$var$styles.sideNavSectionHeading
        ])
    }, title), content) : /*#__PURE__*/ $91i6m.createElement((0, $91i6m.Fragment), null, content);
    return /*#__PURE__*/ $91i6m.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9gzWK.default)([
            $070540ce4a5ac4c1$var$styles.root,
            isScrollable ? $070540ce4a5ac4c1$var$styles.scrollable : $070540ce4a5ac4c1$var$styles.unscrollable,
            hasSeparator ? $070540ce4a5ac4c1$var$styles.thinSeparator : $070540ce4a5ac4c1$var$styles.noSeparator,
            UNSAFE_className
        ]),
        id: id,
        "aria-label": title,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref
    }), childrenMarkup);
});
var $070540ce4a5ac4c1$export$2e2bcd8739ae039 = $070540ce4a5ac4c1$var$Section;

});
parcelRegister("5puEk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f070fe5dcfb1425$export$2e2bcd8739ae039; });
/* heading-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");
var $5oJNc = parcelRequire("5oJNc");

var $4v8Oq = parcelRequire("4v8Oq");
var $3f070fe5dcfb1425$var$_excluded = [
    "children",
    "testId",
    "headingLevel",
    "id",
    "className"
];
var $3f070fe5dcfb1425$var$headingStyles = null;
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $3f070fe5dcfb1425$var$HeadingItem = /*#__PURE__*/ (0, $91i6m.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 2 : _ref$headingLevel, id = _ref.id, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $3f070fe5dcfb1425$var$_excluded);
    return /*#__PURE__*/ $91i6m.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        className: (0, $9gzWK.default)([
            "_11c81vhk _1rjcze3t _18zrpxbi _syaz1vvm",
            UNSAFE_className
        ])
    }, rest, {
        style: {
            "--_bbz764": (0, $5oJNc.default)("var(--ds-text-subtle, ".concat((0, $4v8Oq.N300), ")"))
        }
    }), children);
});
var $3f070fe5dcfb1425$export$2e2bcd8739ae039 = $3f070fe5dcfb1425$var$HeadingItem;

});
parcelRegister("4v8Oq", function(module, exports) {

$parcel$export(module.exports, "N300", function () { return $3470e4a18722bb08$export$e2ef2124cf4024b1; });
// Reds
var $3470e4a18722bb08$export$4b84fd0e2c617bd = '#FFEBE6';
var $3470e4a18722bb08$export$b34b069eff244586 = '#FFBDAD';
var $3470e4a18722bb08$export$be802dd0d8b57f35 = '#FF8F73';
var $3470e4a18722bb08$export$60847d42f9da92a6 = '#FF7452';
var $3470e4a18722bb08$export$4a7404f376229999 = '#FF5630';
var $3470e4a18722bb08$export$2010d0fb4295b346 = '#DE350B';
var $3470e4a18722bb08$export$2837b5a1a71d5c02 = '#BF2600';
var $3470e4a18722bb08$export$8d9596b529bbb9cf = '#FFFAE6';
var $3470e4a18722bb08$export$41060a744ab0b7ae = '#FFF0B3';
var $3470e4a18722bb08$export$1cc05bbbf340e559 = '#FFE380';
var $3470e4a18722bb08$export$5aae31392d72caaa = '#FFC400';
var $3470e4a18722bb08$export$c6930421db9fa514 = '#FFAB00';
var $3470e4a18722bb08$export$59619663aa6500fb = '#FF991F';
var $3470e4a18722bb08$export$874739ea9e379ab6 = '#FF8B00';
var $3470e4a18722bb08$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $3470e4a18722bb08$export$69a3bf21b9686c2b = '#ABF5D1';
var $3470e4a18722bb08$export$afbce1382ec95f73 = '#79F2C0';
var $3470e4a18722bb08$export$747d86715d4175de = '#57D9A3';
var $3470e4a18722bb08$export$940e1f69e873f202 = '#36B37E';
var $3470e4a18722bb08$export$a49394138f7b8e85 = '#00875A';
var $3470e4a18722bb08$export$6fa04827ac68a4fb = '#006644';
var $3470e4a18722bb08$export$226de0355ed012f8 = '#DEEBFF';
var $3470e4a18722bb08$export$8c13c2ee36917869 = '#B3D4FF';
var $3470e4a18722bb08$export$ecfc1dff386a3e7a = '#4C9AFF';
var $3470e4a18722bb08$export$215b7063051591f1 = '#2684FF';
var $3470e4a18722bb08$export$e62e8919cca44969 = '#0065FF';
var $3470e4a18722bb08$export$b3de0ae08da2ce64 = '#0052CC';
var $3470e4a18722bb08$export$a6ee3d71bc067634 = '#0747A6';
var $3470e4a18722bb08$export$67f15409e87642a1 = '#669DF1';
var $3470e4a18722bb08$export$f0539dbc42dbb067 = '#8FB8F6';
var $3470e4a18722bb08$export$363e4475840015bb = '#EAE6FF';
var $3470e4a18722bb08$export$4b0a4417ed59760f = '#C0B6F2';
var $3470e4a18722bb08$export$6011520a64d9a187 = '#998DD9';
var $3470e4a18722bb08$export$a7175d4e9206bc80 = '#8777D9';
var $3470e4a18722bb08$export$b48405b95304b5a1 = '#6554C0';
var $3470e4a18722bb08$export$c71e4279dd54a18d = '#5243AA';
var $3470e4a18722bb08$export$147899de772240ec = '#403294';
var $3470e4a18722bb08$export$2cf711fe14c66f06 = '#E6FCFF';
var $3470e4a18722bb08$export$7a8f4d33f6f9772c = '#B3F5FF';
var $3470e4a18722bb08$export$776c9c497ef08533 = '#79E2F2';
var $3470e4a18722bb08$export$69cb3ca10c1e330e = '#00C7E6';
var $3470e4a18722bb08$export$9dc1ef0f3f48059b = '#00B8D9';
var $3470e4a18722bb08$export$7c835c78b6fcdef8 = '#00A3BF';
var $3470e4a18722bb08$export$6036577f95c3877e = '#008DA6';
var $3470e4a18722bb08$export$29a4f05edc054374 = '#FFFFFF';
var $3470e4a18722bb08$export$e655ef011c4aa1a2 = '#FAFBFC';
var $3470e4a18722bb08$export$9fdfb749e33cdf97 = '#F4F5F7';
var $3470e4a18722bb08$export$3e51e8f1440314ba = '#EBECF0';
var $3470e4a18722bb08$export$1ce2d1575d444ceb = '#DFE1E6';
var $3470e4a18722bb08$export$8754fc7e6d8b3000 = '#C1C7D0';
var $3470e4a18722bb08$export$c2e91cbeada39b8b = '#B3BAC5';
var $3470e4a18722bb08$export$5f71e19f3a7ad9de = '#A5ADBA';
var $3470e4a18722bb08$export$eaa8c8a70ac22806 = '#97A0AF';
var $3470e4a18722bb08$export$7c87d337fb91a97d = '#8993A4';
var $3470e4a18722bb08$export$d6447c357493214f = '#7A869A';
var $3470e4a18722bb08$export$f563ee71e9ee74cd = '#6B778C';
var $3470e4a18722bb08$export$e2ef2124cf4024b1 = '#5E6C84';
var $3470e4a18722bb08$export$eece5f492e429f08 = '#505F79';
var $3470e4a18722bb08$export$c39c0fe0f26207ae = '#42526E';
var $3470e4a18722bb08$export$7090862dc3038a9f = '#344563';
var $3470e4a18722bb08$export$ad0bacf983b7ddaa = '#253858';
var $3470e4a18722bb08$export$7d61b15e0da132af = '#172B4D';
var $3470e4a18722bb08$export$fbda843f0a27fe96 = '#091E42';
var $3470e4a18722bb08$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $3470e4a18722bb08$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $3470e4a18722bb08$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $3470e4a18722bb08$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $3470e4a18722bb08$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $3470e4a18722bb08$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $3470e4a18722bb08$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $3470e4a18722bb08$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $3470e4a18722bb08$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $3470e4a18722bb08$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $3470e4a18722bb08$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $3470e4a18722bb08$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $3470e4a18722bb08$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $3470e4a18722bb08$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $3470e4a18722bb08$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $3470e4a18722bb08$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $3470e4a18722bb08$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $3470e4a18722bb08$export$2f6319cf7d736c2a = '#E6EDFA';
var $3470e4a18722bb08$export$95126bc8884d6634 = '#DCE5F5';
var $3470e4a18722bb08$export$8338d8c35d44ff1 = '#CED9EB';
var $3470e4a18722bb08$export$5368d76ae4fbbda7 = '#B8C7E0';
var $3470e4a18722bb08$export$9f0a771d16ec8d36 = '#ABBBD6';
var $3470e4a18722bb08$export$abcf8c38338b4aa5 = '#9FB0CC';
var $3470e4a18722bb08$export$97e81faa16a182c7 = '#8C9CB8';
var $3470e4a18722bb08$export$bfe21c59123ecf33 = '#7988A3';
var $3470e4a18722bb08$export$ee82aa2ea6a1558 = '#67758F';
var $3470e4a18722bb08$export$682927c6ed76be02 = '#56637A';
var $3470e4a18722bb08$export$91fd9994c5be9757 = '#455166';
var $3470e4a18722bb08$export$d281fbfe3cff2df6 = '#3B475C';
var $3470e4a18722bb08$export$3902c91d8b98a753 = '#313D52';
var $3470e4a18722bb08$export$8e8133c1ba5845b5 = '#283447';
var $3470e4a18722bb08$export$33ff357f6620b39 = '#202B3D';
var $3470e4a18722bb08$export$633847cf062b69e0 = '#1B2638';
var $3470e4a18722bb08$export$9776a6e503bdbf76 = '#121A29';
var $3470e4a18722bb08$export$6c813d5160dff5db = '#0E1624';
var $3470e4a18722bb08$export$3d4f271a500072a = '#0D1424';
var $3470e4a18722bb08$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $3470e4a18722bb08$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $3470e4a18722bb08$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $3470e4a18722bb08$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $3470e4a18722bb08$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $3470e4a18722bb08$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $3470e4a18722bb08$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $3470e4a18722bb08$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $3470e4a18722bb08$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $3470e4a18722bb08$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $3470e4a18722bb08$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $3470e4a18722bb08$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $3470e4a18722bb08$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $3470e4a18722bb08$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $3470e4a18722bb08$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $3470e4a18722bb08$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $3470e4a18722bb08$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $3470e4a18722bb08$export$d2adc5dedf09fced = '#292A2E';
var $3470e4a18722bb08$export$f51762073d2bb381 = '#94C748';
var $3470e4a18722bb08$export$95e26d54def96891 = '#B3DF72';

});



parcelRegister("33FXt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23a232f06939e4ec$export$2e2bcd8739ae039; });
/* group-title.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $91i6m = parcelRequire("91i6m");

var $aDWwl = parcelRequire("aDWwl");
var $23a232f06939e4ec$var$styles = {
    heading: "_11c81vhk _1rjcze3t _18zrpxbi _syaz1gjq"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ var $23a232f06939e4ec$var$GroupTitle = function GroupTitle(_ref) {
    var id = _ref.id, title = _ref.title;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $aDWwl.default), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $23a232f06939e4ec$var$styles.heading
    }, title);
};
var $23a232f06939e4ec$export$2e2bcd8739ae039 = $23a232f06939e4ec$var$GroupTitle;

});


parcelRegister("7dnU9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $540c4a404a6c7818$var$_react = $540c4a404a6c7818$var$_interopRequireDefault((parcelRequire("91i6m")));

var $gJR35 = parcelRequire("gJR35");

var $540c4a404a6c7818$var$_chevronDown = $540c4a404a6c7818$var$_interopRequireDefault((parcelRequire("7BG3J")));
function $540c4a404a6c7818$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $540c4a404a6c7818$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $540c4a404a6c7818$var$_react.default.createElement($gJR35.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $540c4a404a6c7818$var$_chevronDown.default
    }));
$540c4a404a6c7818$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $540c4a404a6c7818$var$_default = module.exports.default = $540c4a404a6c7818$var$ChevronDownIcon;

});
parcelRegister("7BG3J", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::55c6484ab5ceb86b7f950bb9205e88a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $589c9d2db3ba4c45$var$_react = $589c9d2db3ba4c45$var$_interopRequireDefault((parcelRequire("91i6m")));

var $589c9d2db3ba4c45$var$_baseNew = $589c9d2db3ba4c45$var$_interopRequireDefault((parcelRequire("hVDwR")));
function $589c9d2db3ba4c45$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $589c9d2db3ba4c45$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $589c9d2db3ba4c45$var$_react.default.createElement($589c9d2db3ba4c45$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$589c9d2db3ba4c45$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $589c9d2db3ba4c45$var$_default = module.exports.default = $589c9d2db3ba4c45$var$ChevronDownIcon;

});



parcelRegister("8Bf3D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8598e8620eefabcf$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $9jjaN = parcelRequire("9jjaN");
let $8598e8620eefabcf$var$_ = (t)=>t, $8598e8620eefabcf$var$t;
const $8598e8620eefabcf$var$SeparatorContainer = (0, $9jjaN.default).li($8598e8620eefabcf$var$t || ($8598e8620eefabcf$var$t = $8598e8620eefabcf$var$_`
  margin: 0px 8px;

  + li {
    margin-top: 0px;
  }
`));
const $8598e8620eefabcf$var$Bull = ()=>/*#__PURE__*/ (0, $4ZSso.jsx)($8598e8620eefabcf$var$SeparatorContainer, {
        role: "presentation",
        children: "\u2022"
    });
var $8598e8620eefabcf$export$2e2bcd8739ae039 = $8598e8620eefabcf$var$Bull;

});

parcelRegister("5xcuR", function(module, exports) {

$parcel$export(module.exports, "useNavigateToLoginPrompt", function () { return $fa8ac863895c6800$export$87a5fad76d200f12; });

var $jy3ZD = parcelRequire("jy3ZD");
parcelRequire("6d87w");
var $l2v8Y = parcelRequire("l2v8Y");

var $91i6m = parcelRequire("91i6m");

var $9uXJ3 = parcelRequire("9uXJ3");
const $fa8ac863895c6800$export$87a5fad76d200f12 = ()=>{
    const { search: search } = (0, $l2v8Y.useLocation)();
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    const loginHint = (0, $jy3ZD.useLoginHint)();
    const queryParams = (0, $91i6m.useMemo)(()=>new URLSearchParams(search), [
        search
    ]);
    return (0, $91i6m.useCallback)(()=>{
        // Remove MFA transaction token
        queryParams.delete('transactionToken');
        // Remove inverted login hint
        if ((loginHint === null || loginHint === void 0 ? void 0 : loginHint.type) === (0, $jy3ZD.LoginHintType).NotEmailAddress) queryParams.delete('login_hint');
        return navigate({
            pathname: '/login',
            search: `prompt=login&${queryParams}`
        });
    }, [
        loginHint === null || loginHint === void 0 ? void 0 : loginHint.type,
        navigate,
        queryParams
    ]);
};

});
parcelRegister("jy3ZD", function(module, exports) {

$parcel$export(module.exports, "LoginHintType", function () { return $591c60b533905a63$export$39d1212c3512cb3a; });
$parcel$export(module.exports, "useLoginHint", function () { return $591c60b533905a63$export$76b5c17694a141a; });
$parcel$export(module.exports, "getEmailFromLoginHint", function () { return $591c60b533905a63$export$a738b9016987c561; });

var $91i6m = parcelRequire("91i6m");

var $l2v8Y = parcelRequire("l2v8Y");
var $591c60b533905a63$export$39d1212c3512cb3a = /*#__PURE__*/ function(LoginHintType) {
    LoginHintType["EmailAddress"] = "email-address";
    LoginHintType["NotEmailAddress"] = "not-email-address";
    return LoginHintType;
}({});
const $591c60b533905a63$var$NEGATED_EMAIL_PREFIX = 'not:';
function $591c60b533905a63$var$parseLoginHint(loginHint) {
    if (!loginHint) return undefined;
    if (loginHint.startsWith($591c60b533905a63$var$NEGATED_EMAIL_PREFIX)) return {
        type: "not-email-address",
        value: loginHint.substring($591c60b533905a63$var$NEGATED_EMAIL_PREFIX.length)
    };
    return {
        type: "email-address",
        value: loginHint
    };
}
const $591c60b533905a63$export$76b5c17694a141a = ()=>{
    const { search: search } = (0, $l2v8Y.useLocation)();
    return (0, $91i6m.useMemo)(()=>{
        const loginHint = new URLSearchParams(search).get('login_hint');
        return $591c60b533905a63$var$parseLoginHint(loginHint);
    }, [
        search
    ]);
};
const $591c60b533905a63$export$a738b9016987c561 = (loginHint)=>{
    if ((loginHint === null || loginHint === void 0 ? void 0 : loginHint.type) === "email-address") return loginHint.value;
};

});


parcelRegister("h3x7y", function(module, exports) {

$parcel$export(module.exports, "VerifyEmailOtp", function () { return $78e896aaaa309166$export$fce66dd1dcb31ce2; });
$parcel$export(module.exports, "default", function () { return $78e896aaaa309166$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $4ZSso = parcelRequire("4ZSso");

var $64QTD = parcelRequire("64QTD");

var $damsD = parcelRequire("damsD");

var $daZRO = parcelRequire("daZRO");

var $gn7PJ = parcelRequire("gn7PJ");

var $91i6m = parcelRequire("91i6m");

var $cLysE = parcelRequire("cLysE");

var $gs2u7 = parcelRequire("gs2u7");

var $77TVl = parcelRequire("77TVl");

var $9jjaN = parcelRequire("9jjaN");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $8KhCJ = parcelRequire("8KhCJ");

var $68lZ6 = parcelRequire("68lZ6");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");

var $49Pnv = parcelRequire("49Pnv");
let $78e896aaaa309166$var$_ = (t)=>t, $78e896aaaa309166$var$t, $78e896aaaa309166$var$t1;
const $78e896aaaa309166$var$OtpError = (0, $9jjaN.default).div($78e896aaaa309166$var$t || ($78e896aaaa309166$var$t = $78e896aaaa309166$var$_`
  margin-top: 4px;
  margin-bottom: 0;
  display: inline-flex;
  align-items: center;
  font-size: 12px !important;
  color: ${0};
`), (0, $kLNLK).R500);
const $78e896aaaa309166$var$OtpInputWrapper = (0, $9jjaN.default).div($78e896aaaa309166$var$t1 || ($78e896aaaa309166$var$t1 = $78e896aaaa309166$var$_`
  display: flex;
  align-content: center;
  justify-content: center;
  padding: ${0}px 0 0 0;
`), (0, $6e88g.gridSize)() * 3);
const $78e896aaaa309166$var$EMPTY_OTP_STATE = ' '.repeat((0, $68lZ6.OTP_CODE_FULL_LENGTH));
const $78e896aaaa309166$var$removePlaceholders = (otp)=>otp.replace(/ /g, '');
const $78e896aaaa309166$export$fce66dd1dcb31ce2 = ({ pageId: pageId, flow: flow, email: email, isLoading: isLoading, errorCode: errorCode, additionalWhiteboxFooter: footer, onVerifyEmailOtp: onVerifyEmailOtp, onResendEmailOtp: onResendEmailOtp, onInvalidEmailOtpLength: onInvalidEmailOtpLength })=>{
    const [otp, setOtp] = (0, $91i6m.useState)($78e896aaaa309166$var$EMPTY_OTP_STATE);
    const [isInvalidOtpLength, setInvalidOtpLength] = (0, $91i6m.useState)(false);
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const handleOtpChange = (otp)=>{
        setOtp(otp);
        const sanitisedOtp = $78e896aaaa309166$var$removePlaceholders(otp);
        if (sanitisedOtp.length === (0, $68lZ6.OTP_CODE_FULL_LENGTH)) {
            setInvalidOtpLength(false);
            onVerifyEmailOtp(sanitisedOtp);
        }
    };
    const handleSubmit = ()=>{
        const sanitisedOtp = $78e896aaaa309166$var$removePlaceholders(otp);
        if (sanitisedOtp.length === (0, $68lZ6.OTP_CODE_FULL_LENGTH)) {
            setInvalidOtpLength(false);
            onVerifyEmailOtp(sanitisedOtp);
        } else {
            setInvalidOtpLength(true);
            onInvalidEmailOtpLength === null || onInvalidEmailOtpLength === void 0 ? void 0 : onInvalidEmailOtpLength(sanitisedOtp);
        }
    };
    const otpMessageDescriptor = (0, $91i6m.useMemo)(()=>{
        switch(flow){
            case 'sign-up':
                return (0, $77TVl.default).signUpOtpMessage;
            case 'login-challenge':
                return (0, $77TVl.default).loginChallengeOtpMessage;
            default:
                (0, $49Pnv.captureErrorMessage)(`No OTP message defined for VerifyEmailOtp flow "${flow}", falling back to default message`);
                return (0, $77TVl.default).defaultOtpMessage;
        }
    }, [
        flow
    ]);
    const errorMessageDescriptor = (0, $91i6m.useMemo)(()=>{
        if (isInvalidOtpLength) return (0, $77TVl.default).invalidOtpLengthErrorMessage;
        if (!errorCode) return undefined;
        switch(errorCode){
            case 'invalid_otp':
                return (0, $77TVl.default).invalidOtpErrorMessage;
            case 'invalid_otp_length':
                return (0, $77TVl.default).invalidOtpLengthErrorMessage;
            case 'invalid_token':
                return (0, $77TVl.default).invalidTokenErrorMessage;
            case 'expired_token':
                return (0, $77TVl.default).expiredTokenErrorMessage;
            case 'rate_limited':
                return (0, $77TVl.default).rateLimitedErrorMessage;
            case 'unexpected_error':
                return (0, $77TVl.default).unexpectedErrorErrorMessage;
            default:
                return (0, $77TVl.default).unexpectedErrorErrorMessage;
        }
    }, [
        errorCode,
        isInvalidOtpLength
    ]);
    (0, $91i6m.useEffect)(()=>{
        if (errorCode === 'invalid_otp') setOtp($78e896aaaa309166$var$EMPTY_OTP_STATE);
    }, [
        errorCode
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $gs2u7.default), {
        pageId: pageId,
        header: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({
            tagName: "h2"
        }, (0, $77TVl.default).headOtpTitle)),
        whiteboxFooter: /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
            children: [
                /*#__PURE__*/ (0, $4ZSso.jsx)((0, $64QTD.default), {
                    id: "otp-resend",
                    spacing: "none",
                    onClick: onResendEmailOtp,
                    children: formatMessage((0, $77TVl.default).resendOtpButton)
                }),
                footer
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8KhCJ.Helmet), {
                title: formatMessage((0, $77TVl.default).headOtpTitle)
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $damsD.default), {
                email: email,
                message: formatMessage(otpMessageDescriptor),
                withEmailSentImage: false
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)($78e896aaaa309166$var$OtpInputWrapper, {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gn7PJ.default), {
                    otpCodeFullLength: (0, $68lZ6.OTP_CODE_FULL_LENGTH),
                    onChange: handleOtpChange,
                    otp: otp,
                    isLoading: isLoading,
                    isError: !!errorCode
                })
            }),
            !!errorMessageDescriptor && /*#__PURE__*/ (0, $4ZSso.jsxs)($78e896aaaa309166$var$OtpError, {
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($daZRO))), {
                        label: 'Error message icon',
                        size: 'small'
                    }),
                    formatMessage(errorMessageDescriptor)
                ]
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                id: "otp-submit",
                appearance: 'primary',
                type: "submit",
                isFullWidth: true,
                style: {
                    marginTop: '30px'
                },
                onClick: handleSubmit,
                isLoading: isLoading,
                children: formatMessage((0, $77TVl.default).submitButton)
            })
        ]
    });
};
var $78e896aaaa309166$export$2e2bcd8739ae039 = $78e896aaaa309166$export$fce66dd1dcb31ce2;

});
parcelRegister("gn7PJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f4abf11f11273ee$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $7ecAu = parcelRequire("7ecAu");

var $9jjaN = parcelRequire("9jjaN");

var $49Pnv = parcelRequire("49Pnv");

var $6e88g = parcelRequire("6e88g");
let $0f4abf11f11273ee$var$_ = (t)=>t, $0f4abf11f11273ee$var$t;
const $0f4abf11f11273ee$export$a21f0385582d981d = [
    ' ',
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z'
];
const $0f4abf11f11273ee$var$InputWrapper = (0, $9jjaN.default).div($0f4abf11f11273ee$var$t || ($0f4abf11f11273ee$var$t = $0f4abf11f11273ee$var$_`
  display: flex;
  gap: ${0}px;

  input {
    text-align: center;
    font-size: 20px;
  }
`), (0, $6e88g.gridSize)());
const $0f4abf11f11273ee$var$OtpInput = ({ otp: otp, otpCodeFullLength: otpCodeFullLength, onChange: onChange, isLoading: isLoading, isError: isError })=>{
    const [focusedInputIndex, setFocusedInputIndex] = (0, $91i6m.useState)(0);
    const inputRefs = (0, $91i6m.useRef)([]);
    const otpCodeArray = $0f4abf11f11273ee$var$parseOtp(otp);
    (0, $91i6m.useEffect)(()=>{
        inputRefs.current = inputRefs.current.slice(0, otpCodeFullLength);
    }, [
        otpCodeFullLength
    ]);
    (0, $91i6m.useEffect)(()=>{
        var _inputRefs_current_;
        (_inputRefs_current_ = inputRefs.current[0]) === null || _inputRefs_current_ === void 0 ? void 0 : _inputRefs_current_.focus();
    }, []);
    const isInputValueValid = (value)=>value.trim().length === 1 && $0f4abf11f11273ee$var$isOtpCodeCharacter(value);
    const handleChange = (event)=>{
        const value = event.target.value.toUpperCase();
        if (isInputValueValid(value)) {
            changeOtpCodeAtFocus(value);
            focusInput(focusedInputIndex + 1);
        } else {
            const { nativeEvent: nativeEvent } = event;
            // @ts-expect-error - This was added previosly to handle and edge case
            // for dealing with keyCode "229 Unidentified" on Android. Check if this is
            // still needed.
            if (nativeEvent.data === null && nativeEvent.inputType === 'deleteContentBackward') {
                event.preventDefault();
                changeOtpCodeAtFocus(' ');
                focusInput(focusedInputIndex - 1);
            }
        }
    };
    const handleFocus = (index)=>(event)=>{
            focusInput(index);
            event.target.select();
        };
    const handleBlur = ()=>{
        setFocusedInputIndex(focusedInputIndex - 1);
    };
    const handleBackspace = (event)=>{
        event.preventDefault();
        const { selectionStart: selectionStart, selectionEnd: selectionEnd } = event.target;
        if (selectionStart === 0 && selectionEnd === 0) {
            if (focusedInputIndex > 0) {
                const newFocusedIndex = focusedInputIndex - 1;
                focusInput(newFocusedIndex);
                changeOtpCodeAtIndex(newFocusedIndex, ' ');
            }
        } else changeOtpCodeAtFocus(' ');
    };
    const handleKeyDown = (event)=>{
        switch(event.key){
            case 'Delete':
                event.preventDefault();
                changeOtpCodeAtFocus(' ');
                break;
            case 'Backspace':
                handleBackspace(event);
                break;
            case 'ArrowLeft':
                event.preventDefault();
                focusInput(focusedInputIndex - 1);
                break;
            case 'ArrowRight':
                event.preventDefault();
                focusInput(focusedInputIndex + 1);
                break;
            case 'Space':
            case 'Spacebar':
            case 'ArrowUp':
            case 'ArrowDown':
                event.preventDefault();
                break;
            default:
                // React does not trigger onChange when the same value is entered
                // again. So we need to focus the next input manually in this case.
                if (event.key === otpCodeArray[focusedInputIndex]) {
                    event.preventDefault();
                    focusInput(focusedInputIndex + 1);
                }
        }
    };
    const focusInput = (index)=>{
        var _inputRefs_current_indexToFocusInput, _inputRefs_current_indexToFocusInput1;
        const indexToFocusInput = Math.max(Math.min(otpCodeFullLength - 1, index), 0);
        (_inputRefs_current_indexToFocusInput = inputRefs.current[indexToFocusInput]) === null || _inputRefs_current_indexToFocusInput === void 0 ? void 0 : _inputRefs_current_indexToFocusInput.focus();
        (_inputRefs_current_indexToFocusInput1 = inputRefs.current[indexToFocusInput]) === null || _inputRefs_current_indexToFocusInput1 === void 0 ? void 0 : _inputRefs_current_indexToFocusInput1.select();
        setFocusedInputIndex(indexToFocusInput);
    };
    const changeOtpCodeAtIndex = (index, value)=>{
        otpCodeArray[index] = value;
        onChange($0f4abf11f11273ee$var$otpCodeArrayToString(otpCodeArray));
    };
    const changeOtpCodeAtFocus = (value)=>changeOtpCodeAtIndex(focusedInputIndex, value);
    const handlePaste = (event)=>{
        event.preventDefault();
        // Get dataToPaste in an array of max size (num of inputs - current position)
        const dataToPaste = event.clipboardData.getData('text/plain').slice(0, otpCodeFullLength - focusedInputIndex).toUpperCase().split('');
        // Prevent pasting if the clipboard data contains non-alphanumeric values for number inputs
        if (dataToPaste.some((value)=>!$0f4abf11f11273ee$var$isOtpCodeCharacter(value))) return;
        // Paste data from focused input onwards
        let indexToPaste = focusedInputIndex;
        while(indexToPaste < otpCodeFullLength && dataToPaste.length > 0){
            otpCodeArray[indexToPaste] = dataToPaste.shift();
            indexToPaste++;
        }
        focusInput(indexToPaste);
        onChange($0f4abf11f11273ee$var$otpCodeArrayToString(otpCodeArray));
    };
    return /*#__PURE__*/ (0, $4ZSso.jsx)($0f4abf11f11273ee$var$InputWrapper, {
        children: otpCodeArray.map((otpCodeDigitValue, index)=>/*#__PURE__*/ (0, $4ZSso.jsx)("div", {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $7ecAu.default), {
                    isDisabled: isLoading,
                    isInvalid: isError,
                    value: otpCodeDigitValue === ' ' ? '' : otpCodeDigitValue,
                    ref: (element)=>inputRefs.current[index] = element,
                    onChange: handleChange,
                    onFocus: handleFocus(index),
                    onBlur: handleBlur,
                    onKeyDown: handleKeyDown,
                    onPaste: handlePaste,
                    autoComplete: "off",
                    maxLength: 1,
                    "aria-label": `Please enter OTP character ${index + 1}`,
                    type: "text",
                    testId: `otp-input-index-${index}`
                })
            }, `otp-div-index-${index}`))
    });
};
const $0f4abf11f11273ee$var$isOtpCodeCharacter = (c)=>$0f4abf11f11273ee$export$a21f0385582d981d.includes(c);
const $0f4abf11f11273ee$var$parseOtp = (otp)=>{
    const otpCodeArray = otp.split('').filter($0f4abf11f11273ee$var$isOtpCodeCharacter);
    if (otp.length !== otpCodeArray.length) (0, $49Pnv.captureErrorMessage)('Error parsing OTP - received invalid OTP character', {
        otp: otp
    });
    return otpCodeArray;
};
const $0f4abf11f11273ee$var$otpCodeArrayToString = (otpCodeArray)=>otpCodeArray.join('');
var $0f4abf11f11273ee$export$2e2bcd8739ae039 = $0f4abf11f11273ee$var$OtpInput;

});

parcelRegister("77TVl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63fd38a746e8d740$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $63fd38a746e8d740$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    defaultOtpMessage: {
        id: 'verify.email.sent.body.otp.default.message',
        defaultMessage: "To proceed, enter the code we've sent to:",
        description: 'Text telling the user to enter the OTP sent to their email to verify their account to proceed to the next step'
    },
    signUpOtpMessage: {
        id: 'verify.email.sent.body.otp.sign-up.message',
        defaultMessage: "To complete your account setup, enter the code we've sent to:",
        description: 'Text telling the user to enter the OTP sent to their email to verify their account and complete account setup'
    },
    loginChallengeOtpMessage: {
        id: 'verify.email.sent.body.otp.login-challenge.message',
        defaultMessage: 'We require additional verification to protect your account. Check your email to continue:',
        description: 'Text telling the user to enter the OTP sent to their email to verify their account to proceed with the login'
    },
    invalidOtpErrorMessage: {
        id: 'verify.email.error-message.invalid-otp',
        defaultMessage: 'Provided verification code is invalid',
        description: 'Error message informing the user that the OTP code they have entered is incorrect'
    },
    invalidOtpLengthErrorMessage: {
        id: 'verify.email.error-message.invalid-otp-length',
        defaultMessage: 'Complete the verification code',
        description: 'Error message informing the user that the OTP code they have entered is of an incorrect length'
    },
    invalidTokenErrorMessage: {
        id: 'verify.email.error-message.invalid-token',
        defaultMessage: 'Invalid token',
        description: 'Error message returned when the token associated with the verification transaction is invalid'
    },
    expiredTokenErrorMessage: {
        id: 'verify.email.error-message.expired-token',
        defaultMessage: 'Token expired',
        description: 'Error message returned when the token associated with the verification transaction is expired'
    },
    rateLimitedErrorMessage: {
        id: 'verify.email.error-message.rate-limited',
        defaultMessage: 'Rate limit exceeded. Try again in a couple of minutes.',
        description: 'Error message returned when rate limited due to too many requests'
    },
    unexpectedErrorErrorMessage: {
        id: 'verify.email.error-message.unexpected',
        defaultMessage: 'Unexpected error',
        description: 'Error message returned when there is an unexpected error'
    },
    emailOtpVerifyHeader: {
        id: 'verify.email.otp.sent.title',
        defaultMessage: `We've sent you an email!`,
        description: 'Title of the component that lets them input the code to verify their email'
    },
    resendOtpButton: {
        id: 'welcome.sent.resend.signup.otp',
        defaultMessage: `Didn't receive an email? Resend email`,
        description: 'Text telling the user that they can resend the welcome OTP email again for verification.'
    },
    headOtpTitle: {
        id: 'verify.email.sent.otp.head.title',
        defaultMessage: `We've emailed you a code`,
        description: 'Text telling the user that they were sent an email with an OTP'
    },
    submitButton: {
        id: 'verify.email.signup.submit',
        defaultMessage: 'Verify',
        description: 'Text used for the button that submits the OTP for verification.'
    }
});

});

parcelRegister("68lZ6", function(module, exports) {

$parcel$export(module.exports, "OTP_CODE_FULL_LENGTH", function () { return $72863806a2fcae17$export$d9c80c0582b65520; });
const $72863806a2fcae17$export$d9c80c0582b65520 = 6;

});


parcelRegister("6om6Y", function(module, exports) {

$parcel$export(module.exports, "useExecutionTracker", function () { return $97014f1028079ee9$export$a5531e57774c1d12; });

var $91i6m = parcelRequire("91i6m");
const $97014f1028079ee9$export$a5531e57774c1d12 = ()=>{
    const [isExecuting, setIsExecuting] = (0, $91i6m.useState)(false);
    const executeWithTracking = (0, $91i6m.useCallback)(async (asyncOperation)=>{
        setIsExecuting(true);
        try {
            return await asyncOperation();
        } finally{
            setIsExecuting(false);
        }
    }, []);
    return {
        isExecuting: isExecuting,
        executeWithTracking: executeWithTracking
    };
};

});

parcelRegister("fshAq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdc40a2197250e33$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");
parcelRequire("6d87w");
var $l2v8Y = parcelRequire("l2v8Y");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $2ipGE = parcelRequire("2ipGE");

var $64QTD = parcelRequire("64QTD");

var $klwqV = parcelRequire("klwqV");

var $2aGBJ = parcelRequire("2aGBJ");

var $1V2cH = parcelRequire("1V2cH");

var $9uXJ3 = parcelRequire("9uXJ3");

var $9X0U9 = parcelRequire("9X0U9");
const $fdc40a2197250e33$export$cf34b8e1c360d82b = ({ screenId: screenId, isSwitching: isSwitching, switchWithTracking: switchWithTracking })=>{
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const { method: multifactorMethod, additionalMfaFactors: additionalMfaFactors } = (0, $2aGBJ.useAppSelector)((state)=>state.multiFactor);
    const { search: search } = (0, $l2v8Y.useLocation)();
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const trackSwitchToSms = (0, $1V2cH.useButtonClickedEvent)(screenId, 'switchToSms');
    const trackSwitchToTotp = (0, $1V2cH.useButtonClickedEvent)(screenId, 'switchToTotp');
    const trackSwitchToSecurityKey = (0, $1V2cH.useButtonClickedEvent)(screenId, 'switchToSecurityKey');
    const onSwitchToSms = (0, $91i6m.useCallback)(()=>{
        trackSwitchToSms();
        switchWithTracking(async ()=>await dispatch((0, $2ipGE.switchMfaFactor)(search, 'SMS', analyticsClient, navigate)));
    }, [
        trackSwitchToSms,
        switchWithTracking,
        dispatch,
        search,
        analyticsClient,
        navigate
    ]);
    const onSwitchToTotp = (0, $91i6m.useCallback)(()=>{
        trackSwitchToTotp();
        switchWithTracking(async ()=>await dispatch((0, $2ipGE.switchMfaFactor)(search, 'TOTP', analyticsClient, navigate)));
    }, [
        trackSwitchToTotp,
        switchWithTracking,
        dispatch,
        search,
        analyticsClient,
        navigate
    ]);
    const onSwitchToSecurityKey = (0, $91i6m.useCallback)(()=>{
        trackSwitchToSecurityKey();
        switchWithTracking(async ()=>await dispatch((0, $2ipGE.switchMfaFactor)(search, 'SecurityKey', analyticsClient, navigate)));
    }, [
        trackSwitchToSecurityKey,
        switchWithTracking,
        dispatch,
        search,
        analyticsClient,
        navigate
    ]);
    const switchableFactors = (0, $91i6m.useMemo)(()=>[
            {
                method: 'security-key',
                buttonLabel: (0, $klwqV.default).mfSwitchToSecurityKey,
                onClick: onSwitchToSecurityKey
            },
            {
                method: 'otp',
                buttonLabel: (0, $klwqV.default).mfSwitchToTotp,
                onClick: onSwitchToTotp
            },
            {
                method: 'sms',
                buttonLabel: (0, $klwqV.default).mfSwitchToSms,
                onClick: onSwitchToSms
            }
        ], [
        onSwitchToSecurityKey,
        onSwitchToTotp,
        onSwitchToSms
    ]);
    if (!additionalMfaFactors || additionalMfaFactors.length === 0) return null;
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9X0U9.default), {
                paddingBlockEnd: "space.150",
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    tagName: "p",
                    id: "mf.switch-to-other-factor-help-text",
                    defaultMessage: "Use alternate method",
                    description: "Text indicating the purposes the buttons to switch factor when being challenged on login"
                })
            }),
            switchableFactors.flatMap((factor)=>{
                if (!additionalMfaFactors.includes(factor.method) || factor.method === multifactorMethod) return [];
                else return [
                    /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $64QTD.default), {
                            id: `two-step-verification-switch-factor-${factor.method}`,
                            testId: `two-step-verification-switch-factor-${factor.method}`,
                            onClick: factor.onClick,
                            isDisabled: isSwitching,
                            children: formatMessage(factor.buttonLabel)
                        })
                    }, `switch-factor-${factor.method}-wrapper`)
                ];
            })
        ]
    });
};
var $fdc40a2197250e33$export$2e2bcd8739ae039 = $fdc40a2197250e33$export$cf34b8e1c360d82b;

});
parcelRegister("9X0U9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73ea536a25fc5dee$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $boAHD = parcelRequire("boAHD");

var $hZpnm = parcelRequire("hZpnm");

var $7re4P = parcelRequire("7re4P");

var $lBrex = parcelRequire("lBrex");
var $73ea536a25fc5dee$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $73ea536a25fc5dee$var$_excluded2 = [
    "className"
];
var $73ea536a25fc5dee$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $73ea536a25fc5dee$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(htmlAttributes, $73ea536a25fc5dee$var$_excluded2);
    var resolvedStyles = (0, $lBrex.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $boAHD.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $73ea536a25fc5dee$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $7re4P.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $7re4P.isSurfaceColorToken)(backgroundColor) && (0, $7re4P.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $7re4P.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $7re4P.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $7re4P.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $7re4P.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $7re4P.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $7re4P.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $7re4P.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $boAHD.jsx)((0, $hZpnm.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $73ea536a25fc5dee$export$2e2bcd8739ae039 = $73ea536a25fc5dee$export$e71c4d32a2263218;
var $73ea536a25fc5dee$var$baseStyles = (0, $boAHD.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

});



parcelRegister("9DwAy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "cancelAccountDeletionLoader", function () { return $3e80d9027110faef$export$bb55274e034e60c0; });
$parcel$export(module.exports, "CancelAccountDeletionPageComponent", function () { return $3e80d9027110faef$export$429c4af0f87478e0; });
$parcel$export(module.exports, "default", function () { return $3e80d9027110faef$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $2ZKUQ = parcelRequire("2ZKUQ");

var $dBq8m = parcelRequire("dBq8m");

var $cLysE = parcelRequire("cLysE");

var $8KhCJ = parcelRequire("8KhCJ");

var $kpx1A = parcelRequire("kpx1A");

var $6d87w = parcelRequire("6d87w");
var $l2v8Y = parcelRequire("l2v8Y");

var $21Xgy = parcelRequire("21Xgy");

var $d8ACO = parcelRequire("d8ACO");

var $6EpiD = parcelRequire("6EpiD");

var $gs2u7 = parcelRequire("gs2u7");

var $9jjaN = parcelRequire("9jjaN");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");

var $2aGBJ = parcelRequire("2aGBJ");

var $9uXJ3 = parcelRequire("9uXJ3");

var $5e2bj = parcelRequire("5e2bj");

var $kpg9c = parcelRequire("kpg9c");

var $3f4xr = parcelRequire("3f4xr");

var $4jXgk = parcelRequire("4jXgk");
let $3e80d9027110faef$var$_ = (t)=>t, $3e80d9027110faef$var$t;
const $3e80d9027110faef$var$SubtleLinkWrapper = (0, $9jjaN.default).div($3e80d9027110faef$var$t || ($3e80d9027110faef$var$t = $3e80d9027110faef$var$_`
  margin-top: ${0}px;
  a {
    color: ${0};

    &:hover {
      color: ${0};
    }
  }
`), (0, $6e88g.gridSize)(), (0, $kLNLK).N800, (0, $kLNLK).N800);
const $3e80d9027110faef$var$pageId = 'cancelAccountDeletionPage';
async function $3e80d9027110faef$export$bb55274e034e60c0({ request: request }) {
    if (!await (0, $3f4xr.checkFeatureGateOnceInitialized)((0, $kpg9c.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $5e2bj.fetchPageState)('/rest/login/cancel-account-deletion/state', request, {
        capabilities: [
            'capability-group--manage-profile',
            'capability-name--cancel-account-deletion'
        ]
    });
}
const $3e80d9027110faef$export$429c4af0f87478e0 = ()=>{
    const { search: search } = (0, $l2v8Y.useLocation)();
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    (0, $5e2bj.usePageStateLoader)();
    const deleteOn = (0, $2aGBJ.useAppSelector)((state)=>state.cancelDeletion.deleteOn);
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const cancelDeletion = (0, $91i6m.useCallback)(()=>{
        const { token: token } = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(search);
        return fetch(`/rest/cancel-account-deletion${search}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                token: token
            })
        }).then((response)=>{
            if (response.status === 200) return response.json();
            else throw response;
        }).then(({ redirectTo: redirectTo })=>{
            navigate(redirectTo);
        }).catch(()=>{
            const flag = {
                type: 'error',
                title: (0, $d8ACO.default).cancelAccountDeletionFlagErrorTitle,
                description: (0, $d8ACO.default).cancelAccountDeletionFlagErrorDesc
            };
            dispatch((0, $21Xgy.addFlag)(flag.type, flag.title, flag.description));
        });
    }, [
        dispatch,
        search,
        navigate
    ]);
    const signupLink = '/signup' + search;
    const loginLink = '/login' + search;
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $gs2u7.default), {
        pageId: $3e80d9027110faef$var$pageId,
        header: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4jXgk.default), {
            as: "h1",
            size: "small",
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $d8ACO.default).headTitle))
        }),
        footer: /*#__PURE__*/ (0, $4ZSso.jsx)($3e80d9027110faef$var$SubtleLinkWrapper, {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6d87w.Link), {
                id: "signup-for-new-account",
                to: signupLink,
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $d8ACO.default).cancelAccountDeletionSignupMessage))
            })
        }),
        whiteboxFooter: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6d87w.Link), {
            to: loginLink,
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $d8ACO.default).cancelAccountDeletionLogout))
        }),
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8KhCJ.default), {
                title: formatMessage((0, $d8ACO.default).headTitle)
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $kpx1A.default), {
                message: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $b2I6k._)((0, $1Fos3._)({}, (0, $d8ACO.default).cancelAccountDeletionInfo), {
                    tagName: "p",
                    values: {
                        deleteOn: (0, (/*@__PURE__*/$parcel$interopDefault($6EpiD)))(deleteOn).format('DD MMMM YYYY')
                    }
                }))
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $2ZKUQ.default), {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                    appearance: "primary",
                    id: "login-submit",
                    type: "submit",
                    isFullWidth: true,
                    onClick: cancelDeletion,
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $d8ACO.default).cancelAccountDeletionButton))
                })
            })
        ]
    });
};
var $3e80d9027110faef$export$2e2bcd8739ae039 = $3e80d9027110faef$export$429c4af0f87478e0;

});
parcelRegister("kpx1A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $511cc8f64bb1b250$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $9jjaN = parcelRequire("9jjaN");

var $4KmuI = parcelRequire("4KmuI");

var $6e88g = parcelRequire("6e88g");
let $511cc8f64bb1b250$var$_ = (t)=>t, $511cc8f64bb1b250$var$t;
const $511cc8f64bb1b250$var$imgHeight = 150;
const $511cc8f64bb1b250$var$CancelDeletionContainer = (0, $9jjaN.default).div($511cc8f64bb1b250$var$t || ($511cc8f64bb1b250$var$t = $511cc8f64bb1b250$var$_`
  background: url(${0}) no-repeat center top;
  background-size: auto ${0}px;
  padding-top: ${0}px;
  margin-top: ${0}px;
`), (0, (/*@__PURE__*/$parcel$interopDefault($4KmuI))), $511cc8f64bb1b250$var$imgHeight, $511cc8f64bb1b250$var$imgHeight + (0, $6e88g.gridSize)() * 2, (0, $6e88g.gridSize)());
const $511cc8f64bb1b250$var$CancelDeletion = ({ children: children, message: message })=>/*#__PURE__*/ (0, $4ZSso.jsxs)($511cc8f64bb1b250$var$CancelDeletionContainer, {
        id: "cancel-account-deletion-page",
        children: [
            message,
            children
        ]
    });
var $511cc8f64bb1b250$export$2e2bcd8739ae039 = $511cc8f64bb1b250$var$CancelDeletion;

});
parcelRegister("4KmuI", function(module, exports) {

module.exports = (parcelRequire("cgi2g")).getBundleURL('9rAa3') + "cancel-deletion-hourglass.714e127f.svg";

});


parcelRegister("d8ACO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d080e88717bd0a41$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $d080e88717bd0a41$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    // Flags
    cancelAccountDeletionFlagErrorTitle: {
        id: 'cancel.account.deletion.flag.error.title',
        defaultMessage: 'Something went wrong.',
        description: ''
    },
    cancelAccountDeletionFlagErrorDesc: {
        id: 'cancel.account.deletion.flag.error.description',
        defaultMessage: 'Please try again later.',
        description: ''
    },
    headTitle: {
        id: 'cancel.account.deletion.title',
        defaultMessage: 'Cancel the deletion of your account',
        description: ''
    },
    cancelAccountDeletionSignupMessage: {
        id: 'cancel.account.deletion.signup',
        defaultMessage: 'Sign up for a new account',
        description: 'Button text for signing up for a new account'
    },
    cancelAccountDeletionInfo: {
        id: 'cancel.account.deletion.info',
        defaultMessage: 'Your account will be permanently deleted. You can cancel the deletion before {deleteOn}.',
        description: 'Deletion info in the text box'
    },
    cancelAccountDeletionButton: {
        id: 'cancel.account.deletion.button',
        defaultMessage: 'Cancel deletion',
        description: 'Text for cancel deletion button'
    },
    cancelAccountDeletionLogout: {
        id: 'cancel.account.deletion.log.out',
        defaultMessage: 'Log out (and delete your account as scheduled)',
        description: 'Text for log out button'
    }
});

});

parcelRegister("6EpiD", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});


parcelRegister("3h4RJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "changePasswordLoader", function () { return $6f9feb3c2f01f01b$export$86843e04562221a8; });
$parcel$export(module.exports, "ChangePasswordPage", function () { return $6f9feb3c2f01f01b$export$8ec0fb1e4323236d; });
$parcel$export(module.exports, "default", function () { return $6f9feb3c2f01f01b$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $8KhCJ = parcelRequire("8KhCJ");

var $dBq8m = parcelRequire("dBq8m");

var $9jjaN = parcelRequire("9jjaN");
parcelRequire("6d87w");
var $l2v8Y = parcelRequire("l2v8Y");

var $6e88g = parcelRequire("6e88g");

var $cfznH = parcelRequire("cfznH");

var $cLysE = parcelRequire("cLysE");

var $49Pnv = parcelRequire("49Pnv");

var $gs2u7 = parcelRequire("gs2u7");

var $c1txK = parcelRequire("c1txK");

var $9kmG5 = parcelRequire("9kmG5");

var $gFwNN = parcelRequire("gFwNN");

var $he7tN = parcelRequire("he7tN");

var $bE8z6 = parcelRequire("bE8z6");

var $fYxRW = parcelRequire("fYxRW");

var $dgHYS = parcelRequire("dgHYS");

var $8Bf3D = parcelRequire("8Bf3D");

var $31nHY = parcelRequire("31nHY");

var $1V2cH = parcelRequire("1V2cH");

var $2aGBJ = parcelRequire("2aGBJ");

var $brCu8 = parcelRequire("brCu8");

var $9uXJ3 = parcelRequire("9uXJ3");

var $5e2bj = parcelRequire("5e2bj");

var $kpg9c = parcelRequire("kpg9c");

var $3f4xr = parcelRequire("3f4xr");

var $4jXgk = parcelRequire("4jXgk");
let $6f9feb3c2f01f01b$var$_ = (t)=>t, $6f9feb3c2f01f01b$var$t, $6f9feb3c2f01f01b$var$t1;
const $6f9feb3c2f01f01b$var$TRANSITION_DURATION = 400;
const $6f9feb3c2f01f01b$var$SecurityContainer = (0, $9jjaN.default).div($6f9feb3c2f01f01b$var$t || ($6f9feb3c2f01f01b$var$t = $6f9feb3c2f01f01b$var$_`
  background: url(${0}) no-repeat center;
  height: ${0}px;
  transition: visibility ${0}ms;
  margin-bottom: ${0}px;
`), (0, (/*@__PURE__*/$parcel$interopDefault($dgHYS))), (0, $6e88g.gridSize)() * 14.5, $6f9feb3c2f01f01b$var$TRANSITION_DURATION, (0, $6e88g.gridSize)() * 1.5);
const $6f9feb3c2f01f01b$var$Form = (0, $9jjaN.default).form($6f9feb3c2f01f01b$var$t1 || ($6f9feb3c2f01f01b$var$t1 = $6f9feb3c2f01f01b$var$_`
  margin-top: 0;
`));
const $6f9feb3c2f01f01b$var$knownMessageKeys = [
    'change_email',
    'security_wasme_reset',
    'security_wasnotme_reset'
];
function $6f9feb3c2f01f01b$var$chooseTitle(message) {
    switch(message){
        case 'security_wasme_reset':
            return (0, $cfznH.default).securityResetTitle;
        case 'security_wasnotme_reset':
            return (0, $cfznH.default).securityResetTitle;
        default:
            return (0, $cfznH.default).title;
    }
}
function $6f9feb3c2f01f01b$var$chooseButtonText(message) {
    switch(message){
        case 'security_wasme_reset':
            return (0, $cfznH.default).button;
        case 'security_wasnotme_reset':
            return (0, $cfznH.default).button;
        default:
            return (0, $cfznH.default).button;
    }
}
function $6f9feb3c2f01f01b$var$chooseAnalyticsEventName(message) {
    switch(message){
        case 'security_wasme_reset':
            return 'suspiciousWasUser';
        case 'security_wasnotme_reset':
            return 'suspiciousWasNotUser';
        case 'change_email':
            return 'changeEmail';
        default:
            return 'userRequest';
    }
}
function $6f9feb3c2f01f01b$var$chooseChangePasswordType(message) {
    switch(message){
        case 'security_wasme_reset':
            return 'security-password-reset';
        case 'security_wasnotme_reset':
            return 'security-password-reset';
        default:
            return 'password-reset';
    }
}
const $6f9feb3c2f01f01b$var$pageId = 'setNewPasswordScreen';
async function $6f9feb3c2f01f01b$export$86843e04562221a8({ request: request }) {
    if (!await (0, $3f4xr.checkFeatureGateOnceInitialized)((0, $kpg9c.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $5e2bj.fetchPageState)('/rest/login/changepassword/state', request, {
        capabilities: [
            'capability-group--manage-profile',
            'capability-name--change-password'
        ]
    });
}
const $6f9feb3c2f01f01b$export$8ec0fb1e4323236d = ()=>{
    (0, $5e2bj.usePageStateLoader)();
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const email = (0, $2aGBJ.useAppSelector)((state)=>state.changePassword.email);
    const displayName = (0, $2aGBJ.useAppSelector)((state)=>state.changePassword.displayName);
    const isLoading = (0, $2aGBJ.useAppSelector)((state)=>state.changePassword.isLoading);
    const error = (0, $2aGBJ.useAppSelector)((state)=>state.changePassword.error);
    const csrfToken = (0, $2aGBJ.useAppSelector)((state)=>state.csrfToken);
    const intl = (0, $leG06.default)();
    const passwordFieldError = (0, $2aGBJ.useAppSelector)((state)=>state.changePassword.fieldErrors.password);
    const translatedPasswordFieldError = (0, $brCu8.useTranslateFormErrorIfAvailable)(passwordFieldError);
    const location = (0, $l2v8Y.useLocation)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const [password, setPassword] = (0, $91i6m.useState)('');
    const passwordInputRef = (0, $91i6m.useRef)(null);
    const query = (0, $91i6m.useMemo)(()=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(location.search);
    }, [
        location.search
    ]);
    (0, $1V2cH.usePageViewedEvent)($6f9feb3c2f01f01b$var$pageId, {
        origin: $6f9feb3c2f01f01b$var$chooseAnalyticsEventName(query.message)
    });
    (0, $91i6m.useEffect)(()=>{
        if (query.message && !$6f9feb3c2f01f01b$var$knownMessageKeys.includes(query.message)) (0, $49Pnv.captureErrorMessage)('change_password_missing_error_message', {
            key: query.message
        });
    }, [
        query.message
    ]);
    const renderPasswordChangeError = (error)=>{
        switch(error){
            case 'unknown':
                return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "changePassword.error.unknown",
                    defaultMessage: "Something went wrong while attempting to change your password. Please try again."
                });
            case 'request_error':
                return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "changePassword.error.request_error",
                    defaultMessage: "Unable to connect. Check your internet connection or the network settings for your browser and try again."
                });
            case 'passwordLeaked':
                return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "changepassword.password.leaked.paragraph.xml",
                    defaultMessage: "<p>This password has appeared in an external data breach. To continue, enter another password. <learn-more-link>Learn more</learn-more-link></p>",
                    tagName: "p",
                    values: {
                        p: (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("p", {
                                children: chunks
                            }),
                        'learn-more-link': (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("a", {
                                href: (0, $bE8z6.PASSWORD_LEAKED_LINK),
                                children: chunks
                            })
                    }
                });
            case 'passwordCommon':
                return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "changePassword.error.passwordCommon",
                    defaultMessage: "This password is too widely used. Choose a password that's harder to guess."
                });
            case 'invalidPassword':
                return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "changePassword.error.invalidPassword",
                    defaultMessage: "Invalid password"
                });
            case 'passwordCaseError':
                return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "changePassword.error.passwordCaseError",
                    defaultMessage: "Your password must contain at least one uppercase and one lowercase letter."
                });
            case 'passwordDigitOrSpecialError':
                return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "changePassword.error.passwordDigitOrSpecialError",
                    defaultMessage: "Your password must contain at least one digit or special character."
                });
            case 'passwordLengthError':
                return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "changePassword.error.passwordLengthError",
                    defaultMessage: "Your password must be between 8 and 72 characters long."
                });
            case 'passwordUsedBefore':
                return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "changePassword.error.passwordUsedBefore",
                    defaultMessage: "You've used that password before. Please choose a different one."
                });
            case 'passwordStrengthErrorWeak':
                return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "changePassword.error.passwordStrengthErrorWeak",
                    defaultMessage: "Your password must have a minimum strength of weak."
                });
            case 'passwordStrengthErrorFair':
                return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "changePassword.error.passwordStrengthErrorFair",
                    defaultMessage: "Your password must have a minimum strength of fair."
                });
            case 'passwordStrengthErrorGood':
                return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "changePassword.error.passwordStrengthErrorGood",
                    defaultMessage: "Your password must have a minimum strength of good."
                });
            case 'passwordStrengthErrorStrong':
                return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "changePassword.error.passwordStrengthErrorStrong",
                    defaultMessage: "Your password must have a minimum strength of strong."
                });
            case 'passwordStrengthErrorVeryStrong':
                return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "changePassword.error.passwordStrengthErrorVeryStrong",
                    defaultMessage: "Your password must have a minimum strength of very strong."
                });
            default:
                return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "changePassword.form.random.error",
                    defaultMessage: "An error occurred while attempting to sign up: {error}. Please try again or reach out to Atlassian Support.",
                    values: {
                        error: error
                    }
                });
        }
    };
    const renderWhiteboxFooter = ()=>{
        return /*#__PURE__*/ (0, $4ZSso.jsx)("a", {
            id: "changepassword-selfservice-link",
            href: (0, $bE8z6.SELF_SERVICE_LINK_URL),
            onClick: ()=>analyticsClient.linkClickedEvent($6f9feb3c2f01f01b$var$pageId, 'stillHavingTroubleLogin'),
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "changepassword.self.service",
                defaultMessage: "Still having trouble logging in?"
            })
        });
    };
    const renderFooter = ()=>{
        return /*#__PURE__*/ (0, $4ZSso.jsxs)("ul", {
            children: [
                /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $bE8z6.SupportLink), {})
                }),
                /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8Bf3D.default), {}),
                /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $bE8z6.UserNoticeLink), {
                        isMobileLink: false
                    })
                }),
                /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8Bf3D.default), {}),
                /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $bE8z6.PrivacyPolicyLink), {
                        isMobileLink: false
                    })
                })
            ]
        });
    };
    const handlePasswordChange = (0, $91i6m.useCallback)((e)=>{
        setPassword(e.currentTarget.value);
    }, [
        setPassword
    ]);
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    const handleSubmit = (0, $91i6m.useCallback)((e)=>{
        e.preventDefault();
        const { signature: signature, message: message } = query;
        analyticsClient.buttonClickedEvent($6f9feb3c2f01f01b$var$pageId, 'continueToSetNewPassword', {
            origin: $6f9feb3c2f01f01b$var$chooseAnalyticsEventName(message)
        });
        dispatch((0, $he7tN.requestChangePassword)({
            signature: signature || '',
            csrfToken: csrfToken,
            password: password,
            resetType: $6f9feb3c2f01f01b$var$chooseChangePasswordType(message),
            microbranding: (0, $fYxRW.getMicrobrandingFromUrl)(location),
            intl: intl,
            analyticsClient: analyticsClient
        }, navigate));
    }, [
        query,
        analyticsClient,
        dispatch,
        csrfToken,
        password,
        location,
        intl,
        navigate
    ]);
    const { formatMessage: formatMessage } = intl;
    const { message: message } = query;
    const title = formatMessage($6f9feb3c2f01f01b$var$chooseTitle(message));
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $gs2u7.default), {
        pageId: $6f9feb3c2f01f01b$var$pageId,
        header: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4jXgk.default), {
            size: "small",
            as: "h1",
            children: title
        }),
        footer: renderFooter(),
        whiteboxFooter: renderWhiteboxFooter(),
        children: [
            (message === 'security_wasme_reset' || message === 'security_wasnotme_reset') && /*#__PURE__*/ (0, $4ZSso.jsx)($6f9feb3c2f01f01b$var$SecurityContainer, {}),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8KhCJ.default), {
                title: formatMessage($6f9feb3c2f01f01b$var$chooseTitle(message))
            }),
            error && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $31nHY.SectionError), {
                children: renderPasswordChangeError(error)
            }),
            message === 'security_wasme_reset' && /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
                id: "security-wasme-reset-message",
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "changepassword.security.wasme.reset.paragraph.xml",
                    defaultMessage: "<p>Thanks for helping us keep your account secure.</p><p>To prevent unauthorized access to your account, your password has been invalidated.</p><p>Create a new, unique password to access your account:</p><p-email>{email}</p-email>",
                    values: {
                        email: email,
                        p: (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("p", {
                                children: chunks
                            }),
                        'p-email': (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("p", {
                                style: {
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                },
                                children: /*#__PURE__*/ (0, $4ZSso.jsx)("strong", {
                                    children: chunks
                                })
                            })
                    }
                })
            }),
            message === 'security_wasnotme_reset' && /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
                id: "security-wasnotme-reset-message",
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "changepassword.security.wasnotme.reset.paragraph.xml",
                    defaultMessage: "<p>To prevent unauthorized access to your account, your password has been invalidated.</p><p>Create a new, unique password to access your account: </p><p-email>{email}</p-email>",
                    values: {
                        email: email,
                        p: (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("p", {
                                children: chunks
                            }),
                        'p-email': (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("p", {
                                style: {
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                },
                                children: /*#__PURE__*/ (0, $4ZSso.jsx)("strong", {
                                    children: chunks
                                })
                            })
                    }
                })
            }),
            /*#__PURE__*/ (0, $4ZSso.jsxs)($6f9feb3c2f01f01b$var$Form, {
                autoComplete: "on",
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $gFwNN.default), {
                        children: [
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $c1txK.default), {
                                id: "password",
                                testId: "password" // used in pollinators
                                ,
                                name: "password",
                                autoComplete: "new-password",
                                "aria-describedby": (0, $9kmG5.passwordStrengthMessageId),
                                placeholder: formatMessage((0, $cfznH.default).passwordPlaceholder),
                                label: formatMessage((0, $cfznH.default).passwordLabel),
                                isInvalid: !!translatedPasswordFieldError,
                                invalidMessage: translatedPasswordFieldError,
                                onChange: handlePasswordChange,
                                value: password,
                                ref: passwordInputRef,
                                smallPlaceholder: true
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9kmG5.PasswordStrengthMeter), {
                                password: password,
                                email: email,
                                displayName: displayName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                        appearance: "primary",
                        id: "change-password",
                        type: "submit",
                        isFullWidth: true,
                        isLoading: isLoading,
                        children: formatMessage($6f9feb3c2f01f01b$var$chooseButtonText(message))
                    })
                ]
            })
        ]
    });
};
var $6f9feb3c2f01f01b$export$2e2bcd8739ae039 = $6f9feb3c2f01f01b$export$8ec0fb1e4323236d;

});
parcelRegister("cfznH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $351ff50d4655d318$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $351ff50d4655d318$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    title: {
        id: 'changepassword.title',
        defaultMessage: 'Choose a new password'
    },
    button: {
        id: 'changepassword.button',
        defaultMessage: 'Continue'
    },
    passwordPlaceholder: {
        id: 'changepassword.password.placeholder',
        defaultMessage: 'Enter new password'
    },
    passwordLabel: {
        id: 'changepassword.password.label',
        defaultMessage: 'Password'
    },
    errorMessage: {
        id: 'changepassword.error.message',
        defaultMessage: 'Something went wrong while attempting to change your password. Please try again.'
    },
    emptyPasswordErrorMessage: {
        id: 'changepassword.error.password.empty.message',
        defaultMessage: 'Please enter a password'
    },
    securityResetTitle: {
        id: 'changepassword.security.reset.title',
        defaultMessage: 'Reset your password'
    }
});

});

parcelRegister("c1txK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d35d6bdef48785fd$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $h89s9 = parcelRequire("h89s9");

var $9jjaN = parcelRequire("9jjaN");

var $6yJnE = parcelRequire("6yJnE");

var $gB4dU = parcelRequire("gB4dU");

var $tbh94 = parcelRequire("tbh94");

var $leG06 = parcelRequire("leG06");
let $d35d6bdef48785fd$var$_ = (t)=>t, $d35d6bdef48785fd$var$t, $d35d6bdef48785fd$var$t1;
const $d35d6bdef48785fd$export$d25f95f50a0dfdf9 = (0, $9jjaN.default).div($d35d6bdef48785fd$var$t || ($d35d6bdef48785fd$var$t = $d35d6bdef48785fd$var$_`
  padding: 3px;
  margin-left: -1px;
`));
const $d35d6bdef48785fd$var$StyledDiv = (0, $9jjaN.default).div($d35d6bdef48785fd$var$t1 || ($d35d6bdef48785fd$var$t1 = $d35d6bdef48785fd$var$_`
  input {
    ${0}
  }
`), (props)=>props.smallPlaceholder && 'font-size: 14px !important;');
const $d35d6bdef48785fd$var$PasswordField = (props, ref)=>{
    const inputRef = (0, $91i6m.useRef)(null);
    const [type, setType] = (0, $91i6m.useState)('password');
    (0, $91i6m.useImperativeHandle)(ref, ()=>inputRef.current, []);
    const handleVisibilityToggle = ()=>{
        var _inputRef_current;
        setType(type === 'password' ? 'text' : 'password');
        (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
    };
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    return /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
        children: /*#__PURE__*/ (0, $4ZSso.jsx)($d35d6bdef48785fd$var$StyledDiv, {
            smallPlaceholder: props.smallPlaceholder,
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $h89s9.default), (0, $b2I6k._)((0, $1Fos3._)({}, props), {
                type: type,
                autoComplete: type === 'password' ? props.autoComplete || 'off' : 'off',
                spellCheck: false,
                ref: inputRef,
                elemAfterInput: /*#__PURE__*/ (0, $4ZSso.jsx)($d35d6bdef48785fd$export$d25f95f50a0dfdf9, {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $tbh94.default), {
                        appearance: "subtle",
                        icon: type === 'text' ? (0, (/*@__PURE__*/$parcel$interopDefault($gB4dU))) : (0, (/*@__PURE__*/$parcel$interopDefault($6yJnE))),
                        label: type === 'text' ? formatMessage({
                            id: 'password.field.password.hide',
                            defaultMessage: 'Hide password'
                        }) : formatMessage({
                            id: 'password.field.password.show',
                            defaultMessage: 'Show password'
                        }),
                        onClick: handleVisibilityToggle
                    })
                })
            }))
        })
    });
};
var $d35d6bdef48785fd$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).forwardRef($d35d6bdef48785fd$var$PasswordField);

});
parcelRegister("6yJnE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4c691eb080b990e3$var$_react = $4c691eb080b990e3$var$_interopRequireDefault((parcelRequire("91i6m")));

var $gJR35 = parcelRequire("gJR35");

var $4c691eb080b990e3$var$_eyeOpen = $4c691eb080b990e3$var$_interopRequireDefault((parcelRequire("edftA")));
function $4c691eb080b990e3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4c691eb080b990e3$var$WatchIcon = (props)=>/*#__PURE__*/ $4c691eb080b990e3$var$_react.default.createElement($gJR35.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M12 18c-4.536 0-7.999-4.26-7.999-6 0-2.001 3.459-6 8-6 4.376 0 7.998 3.973 7.998 6 0 1.74-3.462 6-7.998 6m0-14C6.48 4 2 8.841 2 12c0 3.086 4.576 8 10 8 5.423 0 10-4.914 10-8 0-3.159-4.48-8-10-8"/><path d="M11.978 13.984c-1.104 0-2-.897-2-2s.896-2 2-2c1.103 0 2 .897 2 2s-.897 2-2 2m0-6c-2.206 0-4 1.794-4 4s1.793 4 4 4 4-1.794 4-4-1.794-4-4-4"/></g></svg>`
    }, props, {
        newIcon: $4c691eb080b990e3$var$_eyeOpen.default
    }));
$4c691eb080b990e3$var$WatchIcon.displayName = 'WatchIcon';
var $4c691eb080b990e3$var$_default = module.exports.default = $4c691eb080b990e3$var$WatchIcon;

});
parcelRegister("edftA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7831691c1245bdf104acebfc690a968c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a58e48d1568d61c9$var$_react = $a58e48d1568d61c9$var$_interopRequireDefault((parcelRequire("91i6m")));

var $a58e48d1568d61c9$var$_baseNew = $a58e48d1568d61c9$var$_interopRequireDefault((parcelRequire("hVDwR")));
function $a58e48d1568d61c9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a58e48d1568d61c9$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $a58e48d1568d61c9$var$_react.default.createElement($a58e48d1568d61c9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3.5c-2.943 0-5.49 1.845-6.424 4.396a.3.3 0 0 0 0 .208C2.509 10.655 5.057 12.5 8 12.5s5.49-1.845 6.424-4.396a.3.3 0 0 0 0-.208C13.491 5.345 10.943 3.5 8 3.5M.167 7.38C1.32 4.232 4.433 2 8 2c3.566 0 6.681 2.232 7.833 5.38.146.4.146.84 0 1.24C14.68 11.768 11.566 14 8 14 4.433 14 1.319 11.768.167 8.62a1.8 1.8 0 0 1 0-1.24M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$a58e48d1568d61c9$var$EyeOpenIcon.displayName = 'EyeOpenIcon';
var $a58e48d1568d61c9$var$_default = module.exports.default = $a58e48d1568d61c9$var$EyeOpenIcon;

});


parcelRegister("gB4dU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c15360b5fe5850fb$var$_react = $c15360b5fe5850fb$var$_interopRequireDefault((parcelRequire("91i6m")));

var $gJR35 = parcelRequire("gJR35");

var $c15360b5fe5850fb$var$_eyeOpenFilled = $c15360b5fe5850fb$var$_interopRequireDefault((parcelRequire("9HWns")));
function $c15360b5fe5850fb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c15360b5fe5850fb$var$WatchFilledIcon = (props)=>/*#__PURE__*/ $c15360b5fe5850fb$var$_react.default.createElement($gJR35.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.983 15.984a4.005 4.005 0 0 1-4.002-4c0-2.206 1.795-4 4.002-4a4.005 4.005 0 0 1 4.002 4c0 2.206-1.795 4-4.002 4M12 4C6.48 4 2 8.84 2 12c0 3.086 4.577 8 10 8s10-4.914 10-8c0-3.16-4.481-8-10-8"/><circle cx="12" cy="12" r="2"/></g></svg>`
    }, props, {
        newIcon: $c15360b5fe5850fb$var$_eyeOpenFilled.default
    }));
$c15360b5fe5850fb$var$WatchFilledIcon.displayName = 'WatchFilledIcon';
var $c15360b5fe5850fb$var$_default = module.exports.default = $c15360b5fe5850fb$var$WatchFilledIcon;

});
parcelRegister("9HWns", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::895be44c60961cd5e7ff3bf0ce94ca85>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $711569baef7cc94a$var$_react = $711569baef7cc94a$var$_interopRequireDefault((parcelRequire("91i6m")));

var $711569baef7cc94a$var$_baseNew = $711569baef7cc94a$var$_interopRequireDefault((parcelRequire("hVDwR")));
function $711569baef7cc94a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpenFilled".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watched pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $711569baef7cc94a$var$EyeOpenFilledIcon = (props)=>/*#__PURE__*/ $711569baef7cc94a$var$_react.default.createElement($711569baef7cc94a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.75 8a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0"/><path fill="currentcolor" fill-rule="evenodd" d="M8 2C4.433 2 1.319 4.232.167 7.38c-.146.4-.146.84 0 1.24C1.32 11.768 4.433 14 8 14c3.566 0 6.681-2.232 7.833-5.38.146-.4.146-.84 0-1.24C14.68 4.232 11.566 2 8 2m0 2.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5" clip-rule="evenodd"/>`
    }, props));
$711569baef7cc94a$var$EyeOpenFilledIcon.displayName = 'EyeOpenFilledIcon';
var $711569baef7cc94a$var$_default = module.exports.default = $711569baef7cc94a$var$EyeOpenFilledIcon;

});



parcelRegister("9kmG5", function(module, exports) {

$parcel$export(module.exports, "passwordStrengthMessageId", function () { return $04e5d1a1675cc88d$export$2609c3dd954de874; });
$parcel$export(module.exports, "PasswordStrengthMeter", function () { return $04e5d1a1675cc88d$export$eebfb7c0549090; });
/* PasswordStrengthMeter.tsx generated by @compiled/babel-plugin v0.37.0 */ /* eslint-disable react/no-unknown-property */ 
var $4ZSso = parcelRequire("4ZSso");

var $9gzWK = parcelRequire("9gzWK");

var $91i6m = parcelRequire("91i6m");

var $9jjaN = parcelRequire("9jjaN");

var $kLNLK = parcelRequire("kLNLK");

var $eyI0A = parcelRequire("eyI0A");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $ikuma = parcelRequire("ikuma");

var $kQU6o = parcelRequire("kQU6o");

var $ijE2m = parcelRequire("ijE2m");
var $jrqUM = parcelRequire("jrqUM");
let $04e5d1a1675cc88d$var$_ = (t)=>t, $04e5d1a1675cc88d$var$t, $04e5d1a1675cc88d$var$t1, $04e5d1a1675cc88d$var$t2;
const $04e5d1a1675cc88d$var$barWidths = [
    '0%',
    '20%',
    '40%',
    '60%',
    '80%',
    '100%'
];
const $04e5d1a1675cc88d$var$Wrapper = (0, $9jjaN.default).div($04e5d1a1675cc88d$var$t || ($04e5d1a1675cc88d$var$t = $04e5d1a1675cc88d$var$_`
  margin-bottom: ${0};
`), "var(--ds-space-100, 8px)");
const $04e5d1a1675cc88d$var$textStyles = null;
const $04e5d1a1675cc88d$export$2609c3dd954de874 = 'password-strength-meter';
const $04e5d1a1675cc88d$var$Bar = (0, $9jjaN.default).div($04e5d1a1675cc88d$var$t1 || ($04e5d1a1675cc88d$var$t1 = $04e5d1a1675cc88d$var$_`
  background: ${0};
  height: 2px;
  margin-top: 5px;
  position: relative;

  &::before {
    background: ${0};
    bottom: 0;
    content: '';
    left: 0;
    position: absolute;
    top: 0;
    transition: all 0.2s ease-out;
    width: ${0};
  }
`), "var(--ds-border, #091E4224)", (props)=>props.score === null ? "var(--ds-border, #091E4224)" : $04e5d1a1675cc88d$var$barColours[props.score], (props)=>props.score === null ? 0 : $04e5d1a1675cc88d$var$barWidths[props.score]);
const $04e5d1a1675cc88d$var$barColours = [
    "var(--ds-border, #091E4224)",
    (0, $kLNLK).R500,
    (0, $kLNLK).R300,
    (0, $kLNLK).Y300,
    (0, $kLNLK).G300,
    (0, $kLNLK).G400
];
const $04e5d1a1675cc88d$var$Container = (props)=>/*#__PURE__*/ (0, $4ZSso.jsx)($04e5d1a1675cc88d$var$Wrapper, {
        children: /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $ijE2m.default), {
            children: [
                /*#__PURE__*/ (0, $4ZSso.jsx)($04e5d1a1675cc88d$var$Bar, {
                    score: props.score,
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)($04e5d1a1675cc88d$var$Dividers, {})
                }),
                /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
                    role: "status",
                    children: props.title && /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $ijE2m.default), {
                        children: [
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $kQU6o.default), {
                                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                                    id: "password.strength.accessibility.hint",
                                    defaultMessage: "Password strength: ",
                                    description: "Text that precedes the password strength hint. Hidden except for screen reader users."
                                })
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsx)("span", {
                                id: $04e5d1a1675cc88d$export$2609c3dd954de874,
                                className: (0, $9gzWK.default)([
                                    "_y3gn1h6o _p0ov18aq"
                                ]),
                                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $jrqUM.default), {
                                    size: "small",
                                    color: "color.text.subtlest",
                                    align: "center",
                                    children: props.title
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
const $04e5d1a1675cc88d$var$Dividers = (0, $9jjaN.default).span($04e5d1a1675cc88d$var$t2 || ($04e5d1a1675cc88d$var$t2 = $04e5d1a1675cc88d$var$_`
  border-left: 5px solid #fff;
  border-right: 5px solid #fff;
  bottom: 0;
  left: 19%;
  position: absolute;
  right: 19%;
  top: 0;

  &::after {
    border-left: 5px solid #fff;
    border-right: 5px solid #fff;
    bottom: 0;
    content: '';
    left: 30%;
    position: absolute;
    right: 30%;
    top: 0;
  }
`));
const $04e5d1a1675cc88d$export$eebfb7c0549090 = ({ displayName: displayName, email: email, i18nLevels: i18nLevels, i18nNoValue: i18nNoValue, i18nNoZxcvbn: i18nNoZxcvbn, password: password })=>{
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const strengthLevelMessages = (0, $91i6m.useMemo)(()=>i18nLevels || [
            (0, $eyI0A.default).passwordStrengthMinimumRequirement,
            (0, $eyI0A.default).passwordStrengthLevel1,
            (0, $eyI0A.default).passwordStrengthLevel2,
            (0, $eyI0A.default).passwordStrengthLevel3,
            (0, $eyI0A.default).passwordStrengthLevel4,
            (0, $eyI0A.default).passwordStrengthLevel5
        ].map((message)=>formatMessage(message)), [
        formatMessage,
        i18nLevels
    ]);
    const noValueMessage = i18nNoValue || formatMessage((0, $eyI0A.default).passwordStrengthMinimumRequirement);
    const noZxcvbnMessage = i18nNoZxcvbn || formatMessage((0, $eyI0A.default).passwordStrengthUnavailable);
    const { score: score } = (0, $ikuma.usePasswordScore)({
        displayName: displayName,
        email: email,
        password: password
    });
    const getStrengthText = ()=>{
        if (!password) return noValueMessage;
        else if (password.length < 8) return strengthLevelMessages[0];
        else if (password === email) return formatMessage((0, $eyI0A.default).passwordStrengthCantMatchEmail);
        else if (password === displayName) return formatMessage((0, $eyI0A.default).passwordStrengthCantMatchDisplayName);
        else if ((0, $ikuma.atlassianKeywords).includes(password)) return formatMessage((0, $eyI0A.default).passwordStrengthCantMatchAtlassianKeyword);
        else return typeof score === 'number' ? strengthLevelMessages[score] : noZxcvbnMessage;
    };
    return /*#__PURE__*/ (0, $4ZSso.jsx)($04e5d1a1675cc88d$var$Container, {
        title: getStrengthText(),
        score: score
    });
};

});
parcelRegister("eyI0A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99a498b2d21bf0a7$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $99a498b2d21bf0a7$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    passwordStrengthAccessibilityHint: {
        id: 'password.strength.accessibility.hint',
        defaultMessage: 'Password strength:'
    },
    passwordStrengthMinimumRequirement: {
        id: 'password.strength.level.minimum',
        defaultMessage: 'Password must have at least 8 characters'
    },
    passwordStrengthLevel1: {
        id: 'password.strength.level.1',
        defaultMessage: 'Weak'
    },
    passwordStrengthLevel2: {
        id: 'password.strength.level.2',
        defaultMessage: 'Fair'
    },
    passwordStrengthLevel3: {
        id: 'password.strength.level.3',
        defaultMessage: 'Good'
    },
    passwordStrengthLevel4: {
        id: 'password.strength.level.4',
        defaultMessage: 'Strong'
    },
    passwordStrengthLevel5: {
        id: 'password.strength.level.5',
        defaultMessage: 'Very strong'
    },
    passwordStrengthUnavailable: {
        id: 'password.strength.unavailable',
        defaultMessage: 'Password strength unavailable'
    },
    passwordStrengthCantMatchEmail: {
        id: 'password.strength.cant.match.email',
        defaultMessage: "Password can't match email address"
    },
    passwordStrengthCantMatchDisplayName: {
        id: 'password.strength.cant.match.display.name',
        defaultMessage: "Password can't match display name"
    },
    passwordStrengthCantMatchAtlassianKeyword: {
        id: 'password.strength.cant.match.atlassian.keyword',
        defaultMessage: "Password can't match Atlassian keyword"
    },
    weakPasswordAdvice: {
        id: 'password.strength.weak.advice',
        defaultMessage: 'Avoid common phrases or try adding more characters',
        description: 'Advice given to users when their password is weak'
    },
    weakPassword: {
        id: 'password.strength.weak',
        defaultMessage: 'Weak password',
        description: "Message shown below a user's password entry to indicate it is weak"
    },
    fairPassword: {
        id: 'password.strength.fair',
        defaultMessage: 'Fair password',
        description: "Message shown below a user's password entry to indicate it is a fair strength"
    },
    goodPassword: {
        id: 'password.strength.good',
        defaultMessage: 'Good password',
        description: "Message shown below a user's password entry to indicate it is a good strength"
    },
    strongPassword: {
        id: 'password.strength.strong',
        defaultMessage: 'Strong password',
        description: "Message shown below a user's password entry to indicate it is strong"
    },
    veryStrongPassword: {
        id: 'password.strength.veryStrong',
        defaultMessage: 'Very strong password',
        description: "Message shown below a user's password entry to indicate it is very strong"
    }
});

});

parcelRegister("ikuma", function(module, exports) {

$parcel$export(module.exports, "atlassianKeywords", function () { return $c345909471bf469c$export$d1feeaf01c705d52; });
$parcel$export(module.exports, "usePasswordScore", function () { return $c345909471bf469c$export$d135f8f04a83150a; });
/* usePasswordScore.tsx generated by @compiled/babel-plugin v0.37.0 */ /* eslint-disable react/no-unknown-property */ 
var $91i6m = parcelRequire("91i6m");

var $l8dwB = parcelRequire("l8dwB");
const $c345909471bf469c$var$SPLITTER = /\W+/;
const $c345909471bf469c$export$d1feeaf01c705d52 = [
    'atlassian',
    'bitbucket',
    'confluence',
    'jira',
    'opsgenie',
    'statuspage',
    'trello'
];
const $c345909471bf469c$export$d135f8f04a83150a = ({ displayName: displayName, email: email, password: password })=>{
    const zxcvbn = (0, $l8dwB.useZxcvbn)();
    const scoreWords = (0, $91i6m.useMemo)(()=>{
        return $c345909471bf469c$export$9e2ea7bf181a4f5([
            email,
            displayName,
            ...$c345909471bf469c$export$d1feeaf01c705d52
        ]);
    }, [
        displayName,
        email
    ]);
    const zxcvbnResult = (0, $91i6m.useMemo)(()=>{
        return zxcvbn && password ? zxcvbn(password, scoreWords) : null;
    }, [
        zxcvbn,
        password,
        scoreWords
    ]);
    const score = (0, $91i6m.useMemo)(()=>{
        if (password.length < 8 || [
            email,
            displayName,
            ...$c345909471bf469c$export$d1feeaf01c705d52
        ].includes(password)) return 0;
        else {
            const baseScore = zxcvbnResult === null || zxcvbnResult === void 0 ? void 0 : zxcvbnResult.score;
            return typeof baseScore === 'number' ? baseScore + 1 : null;
        }
    }, [
        password,
        displayName,
        email,
        zxcvbnResult
    ]);
    return {
        score: score
    };
};
const $c345909471bf469c$var$addUnique = (seen, chunk)=>seen.includes(chunk) ? seen : [
        ...seen,
        chunk
    ];
function $c345909471bf469c$export$9e2ea7bf181a4f5(strings) {
    const deduped = strings.reduce($c345909471bf469c$var$addUnique, []);
    return deduped.reduce((arr, str)=>str.split($c345909471bf469c$var$SPLITTER).reduce($c345909471bf469c$var$addUnique, arr), deduped);
}

});
parcelRegister("l8dwB", function(module, exports) {

$parcel$export(module.exports, "useZxcvbn", function () { return $c34573fa474f073c$export$edb73e506c7a3f1d; });

var $91i6m = parcelRequire("91i6m");

var $49Pnv = parcelRequire("49Pnv");

function $c34573fa474f073c$export$edb73e506c7a3f1d() {
    const [zxcvbn, setZxcvbn] = (0, $91i6m.useState)();
    (0, $91i6m.useEffect)(()=>{
        let isMounted = true;
        // asynchronously imported as package is very large
        (parcelRequire("7UTvw")).then((zxcvbn)=>{
            if (isMounted) setZxcvbn(()=>{
                /**
             * We have this divergence since we use Webpack for Jest testing and Parcel for dev/prod.
             * Webpack dynamic import returns: { default: fn }
             * Parcel dynamic import returns: fn
             * Why can't we use Parcel for Jest? See: https://parceljs.org/languages/javascript/#usage-with-other-tools
             */ return typeof zxcvbn === 'function' ? zxcvbn : zxcvbn.default;
            });
        }).catch((e)=>{
            (0, $49Pnv.captureErrorMessage)('Error while importing zxcvbn library', e);
            setZxcvbn(undefined);
        });
        return ()=>{
            isMounted = false;
        };
    }, []);
    return zxcvbn;
}

});
parcelRegister("7UTvw", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("jJiHd")).then(()=>parcelRequire('lsDkS'));

});



parcelRegister("ijE2m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5590edb3769abdf$export$2e2bcd8739ae039; });

var $iqLBO = parcelRequire("iqLBO");

var $91i6m = parcelRequire("91i6m");

var $boAHD = parcelRequire("boAHD");

var $lBrex = parcelRequire("lBrex");

var $c32T7 = parcelRequire("c32T7");
var $d5590edb3769abdf$var$flexGrowMap = {
    hug: (0, $lBrex.xcss)({
        flexGrow: 0
    }),
    fill: (0, $lBrex.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $d5590edb3769abdf$var$Stack = /*#__PURE__*/ (0, $91i6m.memo)(/*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role, id = _ref.id;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $d5590edb3769abdf$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $boAHD.jsx)((0, $c32T7.default), {
        id: id,
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$d5590edb3769abdf$var$Stack.displayName = 'Stack';
var $d5590edb3769abdf$export$2e2bcd8739ae039 = $d5590edb3769abdf$var$Stack;

});

parcelRegister("jrqUM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2756aa7541c02f4$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $91i6m = parcelRequire("91i6m");

var $boAHD = parcelRequire("boAHD");

var $24QNd = parcelRequire("24QNd");

var $81u3K = parcelRequire("81u3K");

var $hZpnm = parcelRequire("hZpnm");

var $7re4P = parcelRequire("7re4P");
var $e2756aa7541c02f4$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $e2756aa7541c02f4$var$resetStyles = (0, $boAHD.css)({
    margin: 0,
    overflowWrap: 'anywhere'
});
var $e2756aa7541c02f4$var$strongStyles = (0, $boAHD.css)({
    fontWeight: "var(--ds-font-weight-bold, 700)"
});
var $e2756aa7541c02f4$var$emStyles = (0, $boAHD.css)({
    fontStyle: 'italic'
});
var $e2756aa7541c02f4$var$textAlignMap = {
    center: (0, $boAHD.css)({
        textAlign: 'center'
    }),
    end: (0, $boAHD.css)({
        textAlign: 'end'
    }),
    start: (0, $boAHD.css)({
        textAlign: 'start'
    })
};
var $e2756aa7541c02f4$var$truncationStyles = (0, $boAHD.css)({
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
});
var $e2756aa7541c02f4$var$wordBreakMap = {
    breakAll: (0, $boAHD.css)({
        wordBreak: 'break-all'
    })
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $e2756aa7541c02f4$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $hZpnm.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, $7re4P.inverseColorMap).hasOwnProperty(surface)) return (0, $7re4P.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $e2756aa7541c02f4$var$Text = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, children = _ref.children;
    (0, $24QNd.default)($e2756aa7541c02f4$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $81u3K.useHasTextAncestor)();
    var color = $e2756aa7541c02f4$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = (0, $boAHD.jsx)(Component, {
        ref: ref,
        css: [
            $e2756aa7541c02f4$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $7re4P.textSizeStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $7re4P.textColorStylesMap)[color],
            maxLines && $e2756aa7541c02f4$var$truncationStyles,
            maxLines === 1 && $e2756aa7541c02f4$var$wordBreakMap.breakAll,
            align && $e2756aa7541c02f4$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $7re4P.textWeightStylesMap)[weight],
            Component === 'em' && $e2756aa7541c02f4$var$emStyles,
            Component === 'strong' && $e2756aa7541c02f4$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $boAHD.jsx)((0, $81u3K.HasTextAncestorProvider), {
        value: true
    }, component);
});
var $e2756aa7541c02f4$export$2e2bcd8739ae039 = $e2756aa7541c02f4$var$Text;

});


parcelRegister("he7tN", function(module, exports) {

$parcel$export(module.exports, "requestChangePassword", function () { return $75d28199a3a1a1aa$export$5f18b9a6eb1df9f8; });

var $dBq8m = parcelRequire("dBq8m");

var $hB2TQ = parcelRequire("hB2TQ");

var $cfznH = parcelRequire("cfznH");

var $49Pnv = parcelRequire("49Pnv");
const $75d28199a3a1a1aa$export$b7b281ad44bfa6c7 = ()=>({
        type: 'CHANGE_PASSWORD_REQUEST_INITIATE'
    });
const $75d28199a3a1a1aa$export$592a066e988f52df = ()=>({
        type: 'CHANGE_PASSWORD_REQUEST_SUCCESS'
    });
const $75d28199a3a1a1aa$export$a60289eb7ee45981 = (error)=>({
        type: 'CHANGE_PASSWORD_REQUEST_FAILED',
        error: error
    });
const $75d28199a3a1a1aa$export$ff1769767bfc512b = (fieldErrors)=>({
        type: 'CHANGE_PASSWORD_REQUEST_FIELD_ERRORS',
        fieldErrors: fieldErrors
    });
const $75d28199a3a1a1aa$export$5f18b9a6eb1df9f8 = (requestParams, navigate)=>(dispatch)=>{
        const changePasswordAnalyticsError = {
            passwordCaseError: 'passwordResetDoesntMeetPolicy',
            passwordDigitOrSpecialError: 'passwordResetDoesntMeetPolicy',
            passwordLengthError: 'passwordResetDoesntMeetPolicy',
            passwordUsedBefore: 'passwordResetPreviouslyUsed',
            passwordLeaked: 'passwordLeaked',
            passwordCommon: 'passwordCommon',
            invalidPassword: 'invalidPassword',
            unexpectedError: 'passwordResetUnexpectedError',
            passwordStrengthErrorWeak: 'passwordResetDoesntMeetPolicy',
            passwordStrengthErrorFair: 'passwordResetDoesntMeetPolicy',
            passwordStrengthErrorGood: 'passwordResetDoesntMeetPolicy',
            passwordStrengthErrorStrong: 'passwordResetDoesntMeetPolicy',
            passwordStrengthErrorVeryStrong: 'passwordResetDoesntMeetPolicy'
        };
        const { signature: signature, password: password, resetType: resetType, csrfToken: csrfToken, microbranding: microbranding, intl: intl, analyticsClient: analyticsClient } = requestParams;
        const qs = microbranding && Object.keys(microbranding).length ? `?${(0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).stringify(microbranding)}` : '';
        dispatch($75d28199a3a1a1aa$export$b7b281ad44bfa6c7());
        if (!password) {
            const message = intl.formatMessage((0, $cfznH.default).emptyPasswordErrorMessage);
            dispatch($75d28199a3a1a1aa$export$ff1769767bfc512b({
                password: message
            }));
            return Promise.resolve();
        }
        const request = {
            password: password,
            resetType: resetType,
            signature: signature
        };
        return fetch(`/rest/changepassword${qs}`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            },
            body: JSON.stringify(request)
        }).then((response)=>response.json()).then((response)=>{
            if (response.redirectTo !== undefined) {
                dispatch($75d28199a3a1a1aa$export$592a066e988f52df());
                navigate(response.redirectTo);
            } else {
                const { csrfToken: csrfToken, uiErrors: uiErrors, fieldErrors: fieldErrors } = response;
                // SIS doesn't set a new CSRF token on every request (like aid-signup does), and so it
                // doesn't return one. We need to handle both cases though.
                if (csrfToken) dispatch((0, $hB2TQ.updateCsrfToken)(csrfToken));
                if (uiErrors && uiErrors.length) {
                    const subjectId = changePasswordAnalyticsError[uiErrors[0].key] || 'passwordResetUnknownUiError';
                    analyticsClient.errorShownEvent('accountRecoveryScreen', subjectId);
                    dispatch($75d28199a3a1a1aa$export$a60289eb7ee45981(uiErrors[0].key));
                }
                if (Object.entries(fieldErrors).length) dispatch($75d28199a3a1a1aa$export$ff1769767bfc512b(fieldErrors));
            }
        }).catch((error)=>{
            dispatch($75d28199a3a1a1aa$export$a60289eb7ee45981('unknown'));
            (0, $49Pnv.captureErrorMessage)('Change password failed', error);
        });
    };

});

parcelRegister("31nHY", function(module, exports) {

$parcel$export(module.exports, "FormErrorWrapper", function () { return $807125d1ec365411$export$21ea266f0fa7d7c3; });
$parcel$export(module.exports, "default", function () { return $807125d1ec365411$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "SectionError", function () { return $807125d1ec365411$export$1142f7f46d50535e; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $9jjaN = parcelRequire("9jjaN");

var $6e88g = parcelRequire("6e88g");

var $8iEgn = parcelRequire("8iEgn");
let $807125d1ec365411$var$_ = (t)=>t, $807125d1ec365411$var$t, $807125d1ec365411$var$t1;
const $807125d1ec365411$export$21ea266f0fa7d7c3 = (0, $9jjaN.default).div($807125d1ec365411$var$t || ($807125d1ec365411$var$t = $807125d1ec365411$var$_`
  margin-bottom: ${0}px;
`), (0, $6e88g.gridSize)() * 2);
const $807125d1ec365411$var$SectionErrorWrapper = (0, $9jjaN.default).div($807125d1ec365411$var$t1 || ($807125d1ec365411$var$t1 = $807125d1ec365411$var$_`
  margin-top: ${0}px;
  margin-bottom: ${0}px;
`), (0, $6e88g.gridSize)(), (0, $6e88g.gridSize)());
function $807125d1ec365411$export$2e2bcd8739ae039({ testId: testId, title: title, children: children, appearance: appearance = 'warning' }) {
    return children ? /*#__PURE__*/ (0, $4ZSso.jsx)($807125d1ec365411$export$21ea266f0fa7d7c3, {
        role: "alert",
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8iEgn.default), {
            testId: testId || 'form-error',
            appearance: appearance,
            title: title,
            children: children
        })
    }) : null;
}
function $807125d1ec365411$export$1142f7f46d50535e({ id: id, testId: testId, title: title, children: children }) {
    return children ? /*#__PURE__*/ (0, $4ZSso.jsx)($807125d1ec365411$var$SectionErrorWrapper, {
        id: id,
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8iEgn.default), {
            testId: testId || 'form-error',
            appearance: "warning",
            title: title,
            children: children
        })
    }) : null;
}

});

parcelRegister("brCu8", function(module, exports) {

$parcel$export(module.exports, "useTranslateFormErrorIfAvailable", function () { return $9c7488dbc3e314ea$export$61b698e3c147347c; });

var $j5RJC = parcelRequire("j5RJC");
var $leG06 = parcelRequire("leG06");

var $91i6m = parcelRequire("91i6m");
const $9c7488dbc3e314ea$export$61b698e3c147347c = (formError)=>{
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const message = (0, $91i6m.useMemo)(()=>Object.values($9c7488dbc3e314ea$var$formValidationMessages).find(({ id: id })=>id === formError), [
        formError
    ]);
    if (message) return formatMessage(message);
    else return formError;
};
const $9c7488dbc3e314ea$var$formValidationMessages = (0, $j5RJC.defineMessages)({
    unknownError: {
        id: 'com.atlassian.profile.unknownError',
        defaultMessage: 'An unknown error occurred'
    },
    errorRequiredField: {
        id: 'error.required',
        defaultMessage: 'This field is required'
    },
    loginFormNoPassword: {
        id: 'login.form.no.password',
        defaultMessage: 'Enter your password'
    },
    loginFormPasswordTooLong: {
        id: 'login.form.password.too.long',
        defaultMessage: 'Password length capped at 100 characters'
    },
    loginFormPasswordTooShort: {
        id: 'login.form.password.too.short',
        defaultMessage: 'The password is too short.'
    },
    resetPasswordGenericError: {
        id: 'resetPassword.error',
        defaultMessage: 'An error occurred while attempting to reset your password.'
    },
    resetPasswordEmailFormatError: {
        id: 'requestPasswordReset.email.format.error',
        defaultMessage: 'Please enter a valid email address'
    },
    signupDisplayNameEmpty: {
        id: 'signup.display.name.empty',
        defaultMessage: 'Full name must not be empty'
    },
    signupDisplayNameTooLong: {
        id: 'signup.display.name.too.long',
        defaultMessage: 'Full name must not be greater than 255 characters'
    },
    signupEmailFormatError: {
        id: 'signup.email.format.error',
        defaultMessage: 'Email is required to be in correct format'
    },
    signupEmailReachedMaxAliases: {
        id: 'signup.email.reached.max.aliases',
        defaultMessage: 'Email aliases are rate limited'
    },
    signupEmailRestrictedDomain: {
        id: 'signup.email.restricted.domain.error',
        defaultMessage: 'The provided email address is not allowed, please use a different one'
    },
    signupEmailBansNotAllowed: {
        id: 'signup.email.bans.not.allowed',
        defaultMessage: 'The provided email address is not allowed, please use a different one'
    },
    signupGenericFailure: {
        id: 'signup.failure',
        defaultMessage: 'We are unable to sign you up. Please contact support.'
    },
    signupCaptchaResponseError: {
        id: 'signup.captcha.response.required.error',
        defaultMessage: "Are you sure you're not a robot?"
    }
});

});


parcelRegister("koa1e", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "pageId", function () { return $9b5ac8f5f9fea70f$export$703ba2e7ea526c1b; });
$parcel$export(module.exports, "socialRecoveryLoader", function () { return $9b5ac8f5f9fea70f$export$5e59ec17884bc552; });
$parcel$export(module.exports, "SocialLoginRecoveryPage", function () { return $9b5ac8f5f9fea70f$export$ee564d35600efee8; });
$parcel$export(module.exports, "default", function () { return $9b5ac8f5f9fea70f$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $dBq8m = parcelRequire("dBq8m");

var $9jjaN = parcelRequire("9jjaN");

var $6e88g = parcelRequire("6e88g");

var $fYxRW = parcelRequire("fYxRW");

var $gs2u7 = parcelRequire("gs2u7");

var $kyMDl = parcelRequire("kyMDl");

var $4RxN9 = parcelRequire("4RxN9");

var $cLysE = parcelRequire("cLysE");

var $2ZKUQ = parcelRequire("2ZKUQ");

var $7eeh4 = parcelRequire("7eeh4");

var $1V2cH = parcelRequire("1V2cH");

var $2aGBJ = parcelRequire("2aGBJ");

var $5e2bj = parcelRequire("5e2bj");

var $kpg9c = parcelRequire("kpg9c");

var $3f4xr = parcelRequire("3f4xr");

var $9uXJ3 = parcelRequire("9uXJ3");
let $9b5ac8f5f9fea70f$var$_ = (t)=>t, $9b5ac8f5f9fea70f$var$t, $9b5ac8f5f9fea70f$var$t1, $9b5ac8f5f9fea70f$var$t2, $9b5ac8f5f9fea70f$var$t3;
const $9b5ac8f5f9fea70f$var$Image = (0, $9jjaN.default).img($9b5ac8f5f9fea70f$var$t || ($9b5ac8f5f9fea70f$var$t = $9b5ac8f5f9fea70f$var$_`
  margin: ${0}px auto ${0}px;
  width: 100px;
`), (0, $6e88g.gridSize)(), (0, $6e88g.gridSize)());
const $9b5ac8f5f9fea70f$var$Messsage = (0, $9jjaN.default).div($9b5ac8f5f9fea70f$var$t1 || ($9b5ac8f5f9fea70f$var$t1 = $9b5ac8f5f9fea70f$var$_`
  margin-top: ${0}px;
  overflow-wrap: break-word;
`), (0, $6e88g.gridSize)());
const $9b5ac8f5f9fea70f$var$ErrorMesssage = (0, $9jjaN.default)($9b5ac8f5f9fea70f$var$Messsage)($9b5ac8f5f9fea70f$var$t2 || ($9b5ac8f5f9fea70f$var$t2 = $9b5ac8f5f9fea70f$var$_`
  text-align: center;
`));
const $9b5ac8f5f9fea70f$var$ExpectedEmailWrapper = (0, $9jjaN.default).div($9b5ac8f5f9fea70f$var$t3 || ($9b5ac8f5f9fea70f$var$t3 = $9b5ac8f5f9fea70f$var$_`
  margin-top: ${0}px;
  font-weight: bold;
`), (0, $6e88g.gridSize)() * 0.75);
const $9b5ac8f5f9fea70f$export$703ba2e7ea526c1b = 'atlassianAccountSocialLoginRecoveryScreen';
async function $9b5ac8f5f9fea70f$export$5e59ec17884bc552({ request: request }) {
    if (!await (0, $3f4xr.checkFeatureGateOnceInitialized)((0, $kpg9c.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $5e2bj.fetchPageState)('/rest/social/recovery/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-subgroup--social-login'
        ]
    });
}
const $9b5ac8f5f9fea70f$export$ee564d35600efee8 = ()=>{
    const product = (0, $91i6m.useMemo)(()=>{
        const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(window.location.search);
        return queryParams.application && (0, $fYxRW.applications)[queryParams.application];
    }, []);
    const { error: error, expectedEmail: expectedEmail, foundEmail: foundEmail, recoveryUrl: recoveryUrl } = (0, $2aGBJ.useAppSelector)((state)=>state.socialLoginRecovery);
    const isMobileApp = (0, $2aGBJ.useAppSelector)((state)=>(0, $7eeh4.isMobileOidc)(state.microbranding.oidcContext) || state.microbranding.isEmbedded);
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    (0, $1V2cH.usePageViewedEvent)($9b5ac8f5f9fea70f$export$703ba2e7ea526c1b, error && {
        errorCode: error
    });
    (0, $5e2bj.usePageStateLoader)();
    const recover = (recoveryUrl)=>{
        analyticsClient.buttonClickedEvent($9b5ac8f5f9fea70f$export$703ba2e7ea526c1b, 'tryAgainButton');
        navigate(recoveryUrl.toString());
    };
    const renderWhiteboxFooter = ()=>{
        return isMobileApp ? null : /*#__PURE__*/ (0, $4ZSso.jsx)("a", {
            id: "social-login-recovery-documentation-link",
            target: "_blank",
            rel: "noreferrer noopener",
            onClick: ()=>analyticsClient.linkClickedEvent($9b5ac8f5f9fea70f$export$703ba2e7ea526c1b, 'documentationLink'),
            href: "https://support.atlassian.com/atlassian-account/docs/login-issues-related-to-an-incorrect-email-address-error/",
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $4RxN9.default).documentationLinkMessage))
        });
    };
    const renderRecoveryPage = (recoveryUrl, expectedEmail, foundEmail)=>{
        const destinationProduct = product ? product.name : formatMessage((0, $4RxN9.default).productFallback);
        return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $gs2u7.default), {
            pageId: $9b5ac8f5f9fea70f$export$703ba2e7ea526c1b,
            header: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $b2I6k._)((0, $1Fos3._)({}, (0, $4RxN9.default).title), {
                tagName: "h5"
            })),
            whiteboxFooter: renderWhiteboxFooter(),
            children: [
                /*#__PURE__*/ (0, $4ZSso.jsx)($9b5ac8f5f9fea70f$var$Image, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($kyMDl))),
                    alt: ""
                }),
                /*#__PURE__*/ (0, $4ZSso.jsx)($9b5ac8f5f9fea70f$var$Messsage, {
                    children: foundEmail ? /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $b2I6k._)((0, $1Fos3._)({}, (0, $4RxN9.default).bodyMessageUnableToLoginWithFoundEmail), {
                        values: {
                            product: destinationProduct,
                            foundEmail: foundEmail
                        }
                    })) : /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $b2I6k._)((0, $1Fos3._)({}, (0, $4RxN9.default).bodyMessageUnableToLoginWithThisEmailAddress), {
                        values: {
                            product: destinationProduct
                        }
                    }))
                }),
                /*#__PURE__*/ (0, $4ZSso.jsxs)($9b5ac8f5f9fea70f$var$Messsage, {
                    children: [
                        /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                            id: "social.recovery.body.try.again",
                            defaultMessage: "To continue, select <b>Try again</b> and use",
                            description: `Message instructing the user that they logged in via a social
          provider (eg. Log in with Google) and selected an account that we didn't expect.
          This occurs when we know that we want the user to log in with myemail@gmail.com, but
          in the social provider they log in with otheraccount@gmail.com. They should press the Try again button and use the expected email address.`,
                            values: {
                                b: (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("strong", {
                                        children: chunks
                                    })
                            }
                        }),
                        /*#__PURE__*/ (0, $4ZSso.jsx)($9b5ac8f5f9fea70f$var$ExpectedEmailWrapper, {
                            children: expectedEmail
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $4ZSso.jsx)((0, $2ZKUQ.default), {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                        appearance: "primary",
                        id: "recovery-button",
                        isFullWidth: true,
                        onClick: ()=>recover(recoveryUrl),
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $4RxN9.default).buttonText))
                    })
                })
            ]
        });
    };
    const renderRecoveryError = (error)=>{
        const errorMessage = ()=>{
            switch(error){
                case 'expired_token':
                    return (0, $4RxN9.default).expiredTokenErrorMessage;
                case 'future_issued_token':
                case 'invalid_token':
                    return (0, $4RxN9.default).tokenErrorMessage;
                default:
                    return (0, $4RxN9.default).unknownErrorMessage;
            }
        };
        return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $gs2u7.default), {
            pageId: $9b5ac8f5f9fea70f$export$703ba2e7ea526c1b,
            header: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $b2I6k._)((0, $1Fos3._)({}, (0, $4RxN9.default).errorTitle), {
                tagName: "h5"
            })),
            children: [
                /*#__PURE__*/ (0, $4ZSso.jsx)($9b5ac8f5f9fea70f$var$Image, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($kyMDl))),
                    alt: ""
                }),
                /*#__PURE__*/ (0, $4ZSso.jsx)($9b5ac8f5f9fea70f$var$ErrorMesssage, {
                    "data-testid": "default-error-message",
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, errorMessage()))
                })
            ]
        });
    };
    if (expectedEmail && recoveryUrl) return renderRecoveryPage(recoveryUrl, expectedEmail, foundEmail);
    else if (error) return renderRecoveryError(error);
    else return renderRecoveryError('unknown_error');
};
var $9b5ac8f5f9fea70f$export$2e2bcd8739ae039 = $9b5ac8f5f9fea70f$export$ee564d35600efee8;

});
parcelRegister("4RxN9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca302acdd1860e71$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $ca302acdd1860e71$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    bodyMessageUnableToLoginWithThisEmailAddress: {
        id: 'social.recovery.body.unable.with.this.email.address',
        defaultMessage: "We\u2019re unable to log you in to {product} with this email address.",
        description: `Message describing to the user that when they logged in via a social
      provider (eg. Log in with Google) they selected an account that we didn't expect.
      This occurs when we know that we want the user to log in with myemail@gmail.com, but
      in the social provider they log in with otheraccount@gmail.com.
      If we can't detect the product, we use 'your Atlassian account' as {product}.
      `
    },
    bodyMessageUnableToLoginWithFoundEmail: {
        id: 'social.recovery.body.unable.with.found.email',
        defaultMessage: "We\u2019re unable to log you in to {product} with {foundEmail}.",
        description: `Message describing to the user that when they logged in via a social
      provider (eg. Log in with Google) they selected an account that we didn't expect.
      This occurs when we know that we want the user to log in with myemail@gmail.com, but
      in the social provider they log in with otheraccount@gmail.com.
      If we can't detect the product, we use 'your Atlassian account' as {product}.
      `
    },
    documentationLinkMessage: {
        id: 'social.recovery.documentation.link',
        defaultMessage: 'Get login help',
        description: 'Link to documentation page with help information'
    },
    productFallback: {
        id: 'social.recovery.product-fallback',
        defaultMessage: 'your Atlassian account',
        description: `If we can't determine the product the user is attempting to land on, then we
    will fall back to this value. Usage: We\u{2019}re unable to log you in to your Atlassian account with unexpectedemail@example.com`
    },
    buttonText: {
        id: 'social.recovery.button',
        defaultMessage: 'Try again',
        description: 'Button for user to try log in again.'
    },
    unknownErrorMessage: {
        id: 'social.recovery.error.unknown',
        defaultMessage: 'Try again later.'
    },
    tokenErrorMessage: {
        id: 'social.recovery.error.token-error',
        defaultMessage: "We're unable to service your request. Please try again."
    },
    expiredTokenErrorMessage: {
        id: 'social.recovery.error.token-expired',
        defaultMessage: 'Your session has expired. Please try again.'
    },
    title: {
        id: 'social.recovery.title',
        defaultMessage: 'Try again with another email address'
    },
    errorTitle: {
        id: 'social.recovery.title.error',
        defaultMessage: 'Something went wrong'
    }
});

});


parcelRegister("79yMH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "verifyEmailSentLoader", function () { return $915f4679a8bc88c9$export$fae024edc929c93e; });
$parcel$export(module.exports, "VerifyOrReverifyEmailSentPage", function () { return $915f4679a8bc88c9$export$980c3b624c0da509; });
$parcel$export(module.exports, "default", function () { return $915f4679a8bc88c9$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $5e2bj = parcelRequire("5e2bj");

var $92KZy = parcelRequire("92KZy");

var $8ulLA = parcelRequire("8ulLA");

var $gtKO2 = parcelRequire("gtKO2");

var $2aGBJ = parcelRequire("2aGBJ");

var $kpg9c = parcelRequire("kpg9c");

var $3f4xr = parcelRequire("3f4xr");
async function $915f4679a8bc88c9$export$fae024edc929c93e({ request: request }) {
    if (!await (0, $3f4xr.checkFeatureGateOnceInitialized)((0, $kpg9c.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $5e2bj.fetchPageState)('/rest/verify-email/sent/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--mfa'
        ]
    });
}
const $915f4679a8bc88c9$export$980c3b624c0da509 = ()=>{
    (0, $5e2bj.usePageStateLoader)();
    const verificationType = (0, $2aGBJ.useAppSelector)((state)=>state.verifyEmailSent.verificationType);
    return verificationType === (0, $gtKO2.VerificationType).Verify ? /*#__PURE__*/ (0, $4ZSso.jsx)((0, $92KZy.default), {}) : /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8ulLA.default), {});
};
var $915f4679a8bc88c9$export$2e2bcd8739ae039 = $915f4679a8bc88c9$export$980c3b624c0da509;

});

parcelRegister("ixF1M", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "verifyEmailLoader", function () { return $71a90f19d63f59da$export$4af04dd5c668b91a; });
$parcel$export(module.exports, "VerifyOrReverifyEmailErrorPage", function () { return $71a90f19d63f59da$export$647c199e9f3e1159; });
$parcel$export(module.exports, "default", function () { return $71a90f19d63f59da$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $gtKO2 = parcelRequire("gtKO2");

var $F1BSH = parcelRequire("F1BSH");

var $lHx7h = parcelRequire("lHx7h");

var $9w0DB = parcelRequire("9w0DB");

var $2aGBJ = parcelRequire("2aGBJ");

var $5e2bj = parcelRequire("5e2bj");

var $kpg9c = parcelRequire("kpg9c");

var $3f4xr = parcelRequire("3f4xr");
async function $71a90f19d63f59da$export$4af04dd5c668b91a({ request: request }) {
    if (!await (0, $3f4xr.checkFeatureGateOnceInitialized)((0, $kpg9c.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $5e2bj.fetchPageState)('/rest/verify-email/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--mfa'
        ]
    });
}
const $71a90f19d63f59da$export$647c199e9f3e1159 = ()=>{
    (0, $5e2bj.usePageStateLoader)();
    const { error: error, url: url, verificationType: verificationType } = (0, $2aGBJ.useAppSelector)((state)=>state.verifyEmail);
    switch(error){
        case (0, $gtKO2.VerifyOrReverifyEmailError).ExpiredToken:
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $F1BSH.default), {
                recoverUrl: url,
                verificationType: verificationType
            });
        case (0, $gtKO2.VerifyOrReverifyEmailError).InvalidToken:
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9w0DB.default), {
                recoverUrl: url,
                verificationType: verificationType
            });
        case (0, $gtKO2.VerifyOrReverifyEmailError).RateLimitExceeded:
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $lHx7h.default), {
                recoverUrl: url,
                verificationType: verificationType
            });
        default:
            return null;
    }
};
var $71a90f19d63f59da$export$2e2bcd8739ae039 = $71a90f19d63f59da$export$647c199e9f3e1159;

});
parcelRegister("F1BSH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49e5e77018f1cdbb$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $gs2u7 = parcelRequire("gs2u7");

var $6T9dz = parcelRequire("6T9dz");

var $kyMDl = parcelRequire("kyMDl");

var $cLysE = parcelRequire("cLysE");

var $2ZKUQ = parcelRequire("2ZKUQ");

var $9jjaN = parcelRequire("9jjaN");

var $1V2cH = parcelRequire("1V2cH");

var $9uXJ3 = parcelRequire("9uXJ3");
let $49e5e77018f1cdbb$var$_ = (t)=>t, $49e5e77018f1cdbb$var$t;
const $49e5e77018f1cdbb$var$MessageContainer = (0, $9jjaN.default).div($49e5e77018f1cdbb$var$t || ($49e5e77018f1cdbb$var$t = $49e5e77018f1cdbb$var$_`
  margin-bottom: 24px;
`));
const $49e5e77018f1cdbb$export$f9171eab4ea79921 = ({ recoverUrl: recoverUrl, verificationType: verificationType })=>{
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const pageId = 'verifyEmailExpiredTokenErrorPage';
    (0, $1V2cH.usePageViewedEvent)(pageId, {
        flow: verificationType
    });
    const recover = ()=>{
        analyticsClient.buttonClickedEvent(pageId, 'resendVerificationEmail', {
            flow: verificationType
        });
        navigate(recoverUrl);
    };
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $gs2u7.default), {
        pageId: pageId,
        header: /*#__PURE__*/ (0, $4ZSso.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $4ZSso.jsx)($49e5e77018f1cdbb$var$MessageContainer, {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                        id: "reverify.email.expire.title",
                        defaultMessage: "Resend verification email",
                        tagName: "h5"
                    })
                }),
                /*#__PURE__*/ (0, $4ZSso.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($kyMDl))),
                    width: "99",
                    alt: ""
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "reverify.email.expire.body",
                defaultMessage: "The link to verify your account has expired."
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $2ZKUQ.default), {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                    appearance: "primary",
                    id: "reverify.email.expire.button",
                    isFullWidth: true,
                    onClick: recover,
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                        id: "reverify.email.expire.button",
                        defaultMessage: "Resend verification email"
                    })
                })
            })
        ]
    });
};
var $49e5e77018f1cdbb$export$2e2bcd8739ae039 = $49e5e77018f1cdbb$export$f9171eab4ea79921;

});

parcelRegister("lHx7h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a877b99fef2afd2f$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $2ZKUQ = parcelRequire("2ZKUQ");

var $6T9dz = parcelRequire("6T9dz");

var $kyMDl = parcelRequire("kyMDl");

var $gs2u7 = parcelRequire("gs2u7");

var $cLysE = parcelRequire("cLysE");

var $9jjaN = parcelRequire("9jjaN");

var $1V2cH = parcelRequire("1V2cH");

var $9uXJ3 = parcelRequire("9uXJ3");
let $a877b99fef2afd2f$var$_ = (t)=>t, $a877b99fef2afd2f$var$t;
const $a877b99fef2afd2f$var$MessageContainer = (0, $9jjaN.default).div($a877b99fef2afd2f$var$t || ($a877b99fef2afd2f$var$t = $a877b99fef2afd2f$var$_`
  margin-bottom: 24px;
`));
const $a877b99fef2afd2f$var$pageId = 'reverifyEmailRateLimitExceededErrorPage';
const $a877b99fef2afd2f$export$1b84bfc67fc5d43a = ({ recoverUrl: recoverUrl, verificationType: verificationType })=>{
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const displayRecoverUrl = (0, $91i6m.useMemo)(()=>new URL(recoverUrl).hostname, [
        recoverUrl
    ]);
    (0, $1V2cH.usePageViewedEvent)($a877b99fef2afd2f$var$pageId, {
        flow: verificationType
    });
    const recover = ()=>{
        analyticsClient.buttonClickedEvent($a877b99fef2afd2f$var$pageId, 'backToStartButton', {
            flow: verificationType
        });
        navigate(recoverUrl);
    };
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $gs2u7.default), {
        pageId: $a877b99fef2afd2f$var$pageId,
        header: /*#__PURE__*/ (0, $4ZSso.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $4ZSso.jsx)($a877b99fef2afd2f$var$MessageContainer, {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                        id: "reverify.email.rate-limit-exceeded.error.title",
                        defaultMessage: "We couldn't verify your email",
                        tagName: "h5"
                    })
                }),
                /*#__PURE__*/ (0, $4ZSso.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($kyMDl))),
                    width: "99",
                    alt: ""
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "reverify.email.rate-limit-exceeded.error.main-action",
                defaultMessage: "There have been too many attempts to reverify your account in the past hour. You'll need to try again later.",
                description: "Telling the user that they have exceeded welcome email limit"
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $2ZKUQ.default), {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                    appearance: "primary",
                    id: "go-back-button",
                    isFullWidth: true,
                    onClick: recover,
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                        id: "reverify.email.rate-limit-exceeded.error.button-text",
                        defaultMessage: "Go back to {startUrl}",
                        values: {
                            startUrl: displayRecoverUrl
                        }
                    })
                })
            })
        ]
    });
};
var $a877b99fef2afd2f$export$2e2bcd8739ae039 = $a877b99fef2afd2f$export$1b84bfc67fc5d43a;

});

parcelRegister("9w0DB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e91d62c1e0ce3349$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $2ZKUQ = parcelRequire("2ZKUQ");

var $6T9dz = parcelRequire("6T9dz");

var $kyMDl = parcelRequire("kyMDl");

var $gs2u7 = parcelRequire("gs2u7");

var $cLysE = parcelRequire("cLysE");

var $9jjaN = parcelRequire("9jjaN");

var $1V2cH = parcelRequire("1V2cH");

var $9uXJ3 = parcelRequire("9uXJ3");
let $e91d62c1e0ce3349$var$_ = (t)=>t, $e91d62c1e0ce3349$var$t;
const $e91d62c1e0ce3349$var$MessageContainer = (0, $9jjaN.default).div($e91d62c1e0ce3349$var$t || ($e91d62c1e0ce3349$var$t = $e91d62c1e0ce3349$var$_`
  margin-bottom: 24px;
`));
const $e91d62c1e0ce3349$export$4ad664360e6dde74 = ({ recoverUrl: recoverUrl, verificationType: verificationType })=>{
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const pageId = 'verifyEmailInvalidTokenErrorPage';
    (0, $1V2cH.usePageViewedEvent)(pageId, {
        flow: verificationType
    });
    const recover = ()=>{
        analyticsClient.buttonClickedEvent(pageId, 'startAgain', {
            flow: verificationType
        });
        navigate(recoverUrl);
    };
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $gs2u7.default), {
        pageId: pageId,
        header: /*#__PURE__*/ (0, $4ZSso.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $4ZSso.jsx)($e91d62c1e0ce3349$var$MessageContainer, {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                        id: "reverify.email.invalid-token.error.title",
                        defaultMessage: "We couldn't verify your email",
                        tagName: "h5"
                    })
                }),
                /*#__PURE__*/ (0, $4ZSso.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($kyMDl))),
                    width: "99",
                    alt: ""
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "reverify.email.invalid-token.error.main-action",
                defaultMessage: "Something went wrong while trying to validate your email."
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $2ZKUQ.default), {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                    appearance: "primary",
                    id: "go-back-button",
                    isFullWidth: true,
                    onClick: recover,
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                        id: "reverify.email.invalid-token.error.button-text",
                        defaultMessage: "Go back to verify your email"
                    })
                })
            })
        ]
    });
};
var $e91d62c1e0ce3349$export$2e2bcd8739ae039 = $e91d62c1e0ce3349$export$4ad664360e6dde74;

});


parcelRegister("ek8yD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "welcomeSentLoader", function () { return $97e15673af758a7a$export$518566b71566715e; });
$parcel$export(module.exports, "WelcomeSentPage", function () { return $97e15673af758a7a$export$9feca1f6b3b10306; });
$parcel$export(module.exports, "default", function () { return $97e15673af758a7a$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $2aGBJ = parcelRequire("2aGBJ");

var $gtKO2 = parcelRequire("gtKO2");

var $5qfLq = parcelRequire("5qfLq");

var $cDo16 = parcelRequire("cDo16");

var $h5vs4 = parcelRequire("h5vs4");

var $5e2bj = parcelRequire("5e2bj");

var $kpg9c = parcelRequire("kpg9c");

var $3f4xr = parcelRequire("3f4xr");
async function $97e15673af758a7a$export$518566b71566715e({ request: request }) {
    if (!await (0, $3f4xr.checkFeatureGateOnceInitialized)((0, $kpg9c.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $5e2bj.fetchPageState)('/rest/signup/welcome/sent/state', request, {
        capabilities: [
            'capability-group--signup',
            'capability-name--signup'
        ]
    });
}
const $97e15673af758a7a$export$9feca1f6b3b10306 = ()=>{
    (0, $5e2bj.usePageStateLoader)();
    const error = (0, $2aGBJ.useAppSelector)((state)=>state.welcomeSent.error);
    if (error === (0, $gtKO2.WelcomeSentError).InvalidToken) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $5qfLq.default), {});
    else if (error === (0, $gtKO2.WelcomeSentError).ExpiredToken) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cDo16.default), {});
    else return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $h5vs4.default), {});
};
var $97e15673af758a7a$export$2e2bcd8739ae039 = $97e15673af758a7a$export$9feca1f6b3b10306;

});
parcelRegister("5qfLq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1d0aaed785ce360$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");

var $kyMDl = parcelRequire("kyMDl");

var $gs2u7 = parcelRequire("gs2u7");

var $9jjaN = parcelRequire("9jjaN");

var $1V2cH = parcelRequire("1V2cH");
let $e1d0aaed785ce360$var$_ = (t)=>t, $e1d0aaed785ce360$var$t;
const $e1d0aaed785ce360$var$MessageContainer = (0, $9jjaN.default).div($e1d0aaed785ce360$var$t || ($e1d0aaed785ce360$var$t = $e1d0aaed785ce360$var$_`
  margin-bottom: 24px;
`));
const $e1d0aaed785ce360$export$703ba2e7ea526c1b = 'welcomeSentInvalidTokenErrorPage';
const $e1d0aaed785ce360$export$5592c2a3db83a69d = ()=>{
    (0, $1V2cH.usePageViewedEvent)($e1d0aaed785ce360$export$703ba2e7ea526c1b);
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gs2u7.default), {
        pageId: $e1d0aaed785ce360$export$703ba2e7ea526c1b,
        header: /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
            children: [
                /*#__PURE__*/ (0, $4ZSso.jsx)($e1d0aaed785ce360$var$MessageContainer, {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                        id: "welcome.send.invalid-token.error.title",
                        defaultMessage: "We couldn't verify your email",
                        description: "Telling the user that there is an error and they're not verified. The error is caused if the user tampers with the token.",
                        tagName: "h5"
                    })
                }),
                /*#__PURE__*/ (0, $4ZSso.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($kyMDl))),
                    width: "99",
                    alt: ""
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "welcome.send.invalid-token.error.main-action",
            defaultMessage: "Something went wrong while trying to validate your email. Try again from a verification email in your inbox.",
            description: "Telling the user that there was an error while trying to send the welcome link. The error is caused if the user tampers with the token."
        })
    });
};
var $e1d0aaed785ce360$export$2e2bcd8739ae039 = $e1d0aaed785ce360$export$5592c2a3db83a69d;

});

parcelRegister("cDo16", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07f6af2ebd6d639c$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");

var $kyMDl = parcelRequire("kyMDl");

var $gs2u7 = parcelRequire("gs2u7");

var $9jjaN = parcelRequire("9jjaN");

var $1V2cH = parcelRequire("1V2cH");
let $07f6af2ebd6d639c$var$_ = (t)=>t, $07f6af2ebd6d639c$var$t;
const $07f6af2ebd6d639c$var$MessageContainer = (0, $9jjaN.default).div($07f6af2ebd6d639c$var$t || ($07f6af2ebd6d639c$var$t = $07f6af2ebd6d639c$var$_`
  margin-bottom: 24px;
`));
const $07f6af2ebd6d639c$export$703ba2e7ea526c1b = 'welcomeSentExpiredTokenErrorPage';
const $07f6af2ebd6d639c$export$807f21bb9e47b82c = ()=>{
    (0, $1V2cH.usePageViewedEvent)($07f6af2ebd6d639c$export$703ba2e7ea526c1b);
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gs2u7.default), {
        pageId: $07f6af2ebd6d639c$export$703ba2e7ea526c1b,
        header: /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
            children: [
                /*#__PURE__*/ (0, $4ZSso.jsx)($07f6af2ebd6d639c$var$MessageContainer, {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                        id: "welcome.sent.expire.title",
                        defaultMessage: "The link has expired",
                        description: "Telling the user that there is an error with the welcome link. The error is caused by submitting the resend link again after the token has expired.",
                        tagName: "h5"
                    })
                }),
                /*#__PURE__*/ (0, $4ZSso.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($kyMDl))),
                    width: "99",
                    alt: ""
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "welcome.sent.expire.body",
            defaultMessage: "Check your inbox for the verification email.",
            description: "Telling the user that the welcome resend link is expired and they're not verified. The error is caused by submitting the resend link again after the token has expired. The user should try again by clicking the link in their email."
        })
    });
};
var $07f6af2ebd6d639c$export$2e2bcd8739ae039 = $07f6af2ebd6d639c$export$807f21bb9e47b82c;

});

parcelRegister("h5vs4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6bba29e1962cbbe2$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $8KhCJ = parcelRequire("8KhCJ");
parcelRequire("6d87w");
var $l2v8Y = parcelRequire("l2v8Y");

var $dBq8m = parcelRequire("dBq8m");

var $8iEgn = parcelRequire("8iEgn");

var $21Xgy = parcelRequire("21Xgy");

var $damsD = parcelRequire("damsD");

var $64QTD = parcelRequire("64QTD");

var $gs2u7 = parcelRequire("gs2u7");

var $balRf = parcelRequire("balRf");

var $2aGBJ = parcelRequire("2aGBJ");

var $1V2cH = parcelRequire("1V2cH");

var $fYxRW = parcelRequire("fYxRW");

var $4jXgk = parcelRequire("4jXgk");
const $6bba29e1962cbbe2$export$703ba2e7ea526c1b = 'welcomeSentScreen';
const $6bba29e1962cbbe2$export$e3675ba991d10a22 = 'resendWelcomeSentEmail';
const $6bba29e1962cbbe2$export$cb17d40f6b542a55 = ()=>{
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const { email: email, redirectType: redirectType, migratingApplications: migratingApplications, showBrowserWarning: showBrowserWarning } = (0, $2aGBJ.useAppSelector)((state)=>state.welcomeSent);
    const location = (0, $l2v8Y.useLocation)();
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    (0, $1V2cH.usePageViewedEvent)($6bba29e1962cbbe2$export$703ba2e7ea526c1b, {
        browserWarningMessageShown: showBrowserWarning,
        redirectType: redirectType
    });
    function handleResendVerificationEmail() {
        const { token: token } = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(location.search);
        analyticsClient.buttonClickedEvent($6bba29e1962cbbe2$export$703ba2e7ea526c1b, $6bba29e1962cbbe2$export$e3675ba991d10a22, {
            redirectType: redirectType
        });
        return fetch(`/rest/signup/welcome/resend${location.search}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                token: token
            })
        }).then((response)=>{
            if (response.status === 204) dispatch((0, $21Xgy.addFlag)('success', (0, $balRf.default).verifyEmailFlagSuccessTitle, (0, $balRf.default).verifyEmailFlagSuccessDesc));
            else throw new Error($6bba29e1962cbbe2$export$703ba2e7ea526c1b + ' Invalid Token');
        }).catch(()=>{
            dispatch((0, $21Xgy.addFlag)('error', (0, $balRf.default).verifyEmailFlagErrorTitle, (0, $balRf.default).verifyEmailFlagErrorDesc));
        });
    }
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $gs2u7.default), {
        pageId: $6bba29e1962cbbe2$export$703ba2e7ea526c1b,
        header: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4jXgk.default), {
            as: "h1",
            size: "small",
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $balRf.default).migrationVerifyHeader))
        }),
        whiteboxFooter: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $64QTD.default), {
            id: "welcome-send-validation-submit",
            spacing: "none",
            className: "link-color-override",
            onClick: handleResendVerificationEmail,
            children: formatMessage((0, $balRf.default).button)
        }),
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8KhCJ.default), {
                title: formatMessage((0, $balRf.default).headTitle)
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $damsD.default), {
                email: email,
                message: /*#__PURE__*/ (0, $4ZSso.jsx)($6bba29e1962cbbe2$var$MigrationVerifyMessage, {
                    migratingApplications: migratingApplications
                }),
                warningMessage: showBrowserWarning && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8iEgn.default), {
                    testId: "browser-warning",
                    appearance: "information",
                    children: formatMessage((0, $balRf.default).browserWarning)
                })
            })
        ]
    });
};
var $6bba29e1962cbbe2$export$2e2bcd8739ae039 = $6bba29e1962cbbe2$export$cb17d40f6b542a55;
const $6bba29e1962cbbe2$var$MigrationVerifyMessage = ({ migratingApplications: migratingApplications })=>{
    var _applications_migratingApplications_;
    var _applications_migratingApplications__name;
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
        children: [
            migratingApplications !== undefined && /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $b2I6k._)((0, $1Fos3._)({}, (0, $balRf.default).resumeMigrationVerifyMessage), {
                        values: {
                            product: migratingApplications.includes('trello') ? (0, $fYxRW.applications)['trello'].name : (_applications_migratingApplications__name = (_applications_migratingApplications_ = (0, $fYxRW.applications)[migratingApplications[0]]) === null || _applications_migratingApplications_ === void 0 ? void 0 : _applications_migratingApplications_.name) !== null && _applications_migratingApplications__name !== void 0 ? _applications_migratingApplications__name : migratingApplications[0]
                        }
                    })),
                    ' '
                ]
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $balRf.default).migrationVerifyMessage))
        ]
    });
};

});


parcelRegister("diWiU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "logoutLoader", function () { return $882b180b1477ebb2$export$fe06aa2603bb1f9a; });
$parcel$export(module.exports, "LogoutPage", function () { return $882b180b1477ebb2$export$ae5920452e7cb547; });
$parcel$export(module.exports, "default", function () { return $882b180b1477ebb2$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $9jjaN = parcelRequire("9jjaN");

var $8KhCJ = parcelRequire("8KhCJ");

var $6e88g = parcelRequire("6e88g");

var $gs2u7 = parcelRequire("gs2u7");

var $cLysE = parcelRequire("cLysE");

var $bE8z6 = parcelRequire("bE8z6");

var $7eeh4 = parcelRequire("7eeh4");

var $fJOIy = parcelRequire("fJOIy");

var $5tkAn = parcelRequire("5tkAn");

var $8Bf3D = parcelRequire("8Bf3D");

var $1V2cH = parcelRequire("1V2cH");

var $31nHY = parcelRequire("31nHY");
parcelRequire("6d87w");
var $l2v8Y = parcelRequire("l2v8Y");

var $fajwB = parcelRequire("fajwB");

var $2aGBJ = parcelRequire("2aGBJ");

var $5e2bj = parcelRequire("5e2bj");

var $kpg9c = parcelRequire("kpg9c");

var $3f4xr = parcelRequire("3f4xr");

var $4jXgk = parcelRequire("4jXgk");
let $882b180b1477ebb2$var$_ = (t)=>t, $882b180b1477ebb2$var$t, $882b180b1477ebb2$var$t1, $882b180b1477ebb2$var$t2;
const $882b180b1477ebb2$var$AccountWrapper = (0, $9jjaN.default).div($882b180b1477ebb2$var$t || ($882b180b1477ebb2$var$t = $882b180b1477ebb2$var$_`
  > * {
    padding-bottom: ${0}px !important;
    border-bottom: none !important;
  }
`), (0, $6e88g.gridSize)());
const $882b180b1477ebb2$var$Form = (0, $9jjaN.default).form($882b180b1477ebb2$var$t1 || ($882b180b1477ebb2$var$t1 = $882b180b1477ebb2$var$_`
  margin-top: 0;
`));
const $882b180b1477ebb2$var$ButtonContainer = (0, $9jjaN.default).div($882b180b1477ebb2$var$t2 || ($882b180b1477ebb2$var$t2 = $882b180b1477ebb2$var$_`
  margin-top: ${0}px;
`), (0, $6e88g.gridSize)());
const $882b180b1477ebb2$var$pageId = 'logoutPage';
async function $882b180b1477ebb2$export$fe06aa2603bb1f9a({ request: request }) {
    if (!await (0, $3f4xr.checkFeatureGateOnceInitialized)((0, $kpg9c.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $5e2bj.fetchPageState)('/rest/logout/state', request, {
        capabilities: [
            'capability-group--logout'
        ]
    });
}
const $882b180b1477ebb2$export$ae5920452e7cb547 = ()=>{
    (0, $5e2bj.usePageStateLoader)();
    const autoSubmit = (0, $2aGBJ.useAppSelector)((state)=>state.logout.autoSubmit);
    return autoSubmit ? /*#__PURE__*/ (0, $4ZSso.jsx)($882b180b1477ebb2$var$LogoutAutoSubmit, {}) : /*#__PURE__*/ (0, $4ZSso.jsx)($882b180b1477ebb2$var$LogoutConfirmationPage, {});
};
const $882b180b1477ebb2$var$LogoutAutoSubmit = ()=>{
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    (0, $91i6m.useEffect)(()=>{
        dispatch((0, $fajwB.doLogout)());
    }, [
        dispatch
    ]);
    // When the browser loads the logout page the user will see the spinner on that page so we don't
    // want to show anything on this page, not even a spinner, to make the redirect more transparent.
    return null;
};
const $882b180b1477ebb2$var$LogoutConfirmationPage = ()=>{
    const { isEmbedded: isEmbedded, oidcContext: oidcContext } = (0, $2aGBJ.useAppSelector)((state)=>state.microbranding);
    const { userData: userData, formError: formError } = (0, $2aGBJ.useAppSelector)((state)=>state.logout);
    const location = (0, $l2v8Y.useLocation)();
    const intl = (0, $leG06.default)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    (0, $1V2cH.usePageViewedEvent)($882b180b1477ebb2$var$pageId, {
        isAuthenticatedUser: !!userData
    });
    const buildHeader = ()=>/*#__PURE__*/ (0, $4ZSso.jsx)((0, $4jXgk.default), {
            as: "h1",
            size: "small",
            children: !userData || userData.associatedSessions.length === 0 ? /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "logout.title",
                defaultMessage: "Log out of your Atlassian account"
            }) : /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "logout.title.multiple",
                defaultMessage: "Log out of your Atlassian accounts"
            })
        });
    const buildFooter = ()=>{
        return isEmbedded ? undefined : /*#__PURE__*/ (0, $4ZSso.jsxs)("ul", {
            className: "fine-print",
            children: [
                /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $bE8z6.PrivacyPolicyLink), {
                        isMobileLink: (0, $7eeh4.isMobileOidc)(oidcContext)
                    })
                }),
                /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8Bf3D.default), {}),
                /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $bE8z6.UserNoticeLink), {
                        isMobileLink: (0, $7eeh4.isMobileOidc)(oidcContext)
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8KhCJ.default), {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)("title", {
                    children: intl.formatMessage((0, $5tkAn.default).logoutTitle)
                })
            }),
            /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $gs2u7.default), {
                pageId: $882b180b1477ebb2$var$pageId,
                header: buildHeader(),
                footer: buildFooter(),
                whiteboxFooter: /*#__PURE__*/ (0, $4ZSso.jsx)("a", {
                    href: '/login/select-account' + location.search,
                    onClick: ()=>{
                        analyticsClient.linkClickedEvent($882b180b1477ebb2$var$pageId, 'selectAccount');
                    },
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                        id: "logout.switch-account",
                        defaultMessage: "Log in to another account"
                    })
                }),
                children: [
                    !!formError && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $31nHY.SectionError), {
                        children: formError
                    }),
                    !!userData && userData.associatedSessions.length === 0 && /*#__PURE__*/ (0, $4ZSso.jsx)($882b180b1477ebb2$var$AccountWrapper, {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $fJOIy.default), {
                            primary: true,
                            avatarUrl: userData.avatarUrl,
                            displayName: userData.displayName,
                            email: userData.email
                        })
                    }),
                    /*#__PURE__*/ (0, $4ZSso.jsx)($882b180b1477ebb2$var$LogoutForm, {})
                ]
            })
        ]
    });
};
const $882b180b1477ebb2$var$LogoutForm = ()=>{
    const userData = (0, $2aGBJ.useAppSelector)((state)=>state.logout.userData);
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const [submitting, setSubmitting] = (0, $91i6m.useState)(false);
    return /*#__PURE__*/ (0, $4ZSso.jsx)($882b180b1477ebb2$var$Form, {
        onSubmit: (event)=>{
            event.preventDefault();
            setSubmitting(true);
            analyticsClient.formSubmittedEvent($882b180b1477ebb2$var$pageId, 'logout');
            dispatch((0, $fajwB.doLogout)());
        },
        "data-testid": "logout-form",
        children: /*#__PURE__*/ (0, $4ZSso.jsx)($882b180b1477ebb2$var$ButtonContainer, {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                appearance: "primary",
                id: "logout-submit",
                type: "submit",
                isFullWidth: true,
                isLoading: submitting,
                testId: "logout-button",
                children: !userData || userData.associatedSessions.length === 0 ? /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "logout.confirm",
                    defaultMessage: "Log out"
                }) : /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "logout.confirm.multiple",
                    defaultMessage: "Log out of all accounts"
                })
            })
        })
    });
};
var $882b180b1477ebb2$export$2e2bcd8739ae039 = $882b180b1477ebb2$export$ae5920452e7cb547;

});
parcelRegister("fJOIy", function(module, exports) {

$parcel$export(module.exports, "AccountContainer", function () { return $bf9d181e9244a469$export$5baee99c5c7ba187; });
$parcel$export(module.exports, "AvatarContainer", function () { return $bf9d181e9244a469$export$6027454d331df3c4; });
$parcel$export(module.exports, "RowButtonContainer", function () { return $bf9d181e9244a469$export$fadcaf242d6ed62f; });
$parcel$export(module.exports, "TextContainer", function () { return $bf9d181e9244a469$export$762240c6611b6ed2; });
$parcel$export(module.exports, "Paragraph", function () { return $bf9d181e9244a469$export$358a232cca1ab2ac; });
$parcel$export(module.exports, "default", function () { return $bf9d181e9244a469$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $4SYff = parcelRequire("4SYff");

var $9jjaN = parcelRequire("9jjaN");

var $boAHD = parcelRequire("boAHD");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");

var $k8ZoM = parcelRequire("k8ZoM");
let $bf9d181e9244a469$var$_ = (t)=>t, $bf9d181e9244a469$var$t, $bf9d181e9244a469$var$t1, $bf9d181e9244a469$var$t2, $bf9d181e9244a469$var$t3, $bf9d181e9244a469$var$t4, $bf9d181e9244a469$var$t5, $bf9d181e9244a469$var$t6, $bf9d181e9244a469$var$t7, $bf9d181e9244a469$var$t8;
const $bf9d181e9244a469$export$5baee99c5c7ba187 = (0, $9jjaN.default).button($bf9d181e9244a469$var$t1 || ($bf9d181e9244a469$var$t1 = $bf9d181e9244a469$var$_`
  /* reset button styles */
  appearance: none;
  background: none;
  border: 0;
  padding: 0;
  width: 100%;
  text-align: left;

  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: ${0};
  padding-bottom: ${0};

  &:last-child {
    border-bottom: 1px solid ${0};
    ${0}
  }

  ${0}

  ${0}
`), (props)=>props.primary ? '0' : '16px', (props)=>props.primary ? '24px' : '16px', (0, $kLNLK).N30A, (props)=>props.noBorder && (0, $boAHD.css)($bf9d181e9244a469$var$t || ($bf9d181e9244a469$var$t = $bf9d181e9244a469$var$_`
        border-bottom: none;
        margin-bottom: ${0}px;
      `), -(0, $6e88g.gridSize)() * 3), (props)=>props.primary && `  &:only-child {
        margin-bottom: 0;
        border-bottom: 0;
        padding: 8px 0;
    }
      `, (props)=>props.onClick ? `&:hover, &:focus {
      border-radius: 3px;
      transition: background 0s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38);
      cursor: pointer;
      background-color: ${(0, $kLNLK).N30A};
    }` : '');
const $bf9d181e9244a469$var$primaryAvatarSize = '72px';
const $bf9d181e9244a469$var$defaultAvatarSize = '36px';
const $bf9d181e9244a469$export$6027454d331df3c4 = (0, $9jjaN.default).div($bf9d181e9244a469$var$t2 || ($bf9d181e9244a469$var$t2 = $bf9d181e9244a469$var$_`
  margin: 0 0 0 ${0};
  width: ${0};
  display: flex;
  align-items: center;
  justify-content: center;

  ${0}

  ${0}
`), (props)=>props.primary ? '0' : '8px', (props)=>props.primary ? $bf9d181e9244a469$var$primaryAvatarSize : $bf9d181e9244a469$var$defaultAvatarSize, (props)=>props.primary && `padding-left: 8px;`, (props)=>props.primary && `
    div, span {
      padding: 0;
      width: ${$bf9d181e9244a469$var$primaryAvatarSize} !important;
      height: ${$bf9d181e9244a469$var$primaryAvatarSize} !important;
    }
  `);
const $bf9d181e9244a469$var$Avatar = (props)=>/*#__PURE__*/ (0, $4ZSso.jsx)($bf9d181e9244a469$export$6027454d331df3c4, {
        primary: props.primary,
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4SYff.default), {
            appearance: "circle",
            src: props.avatarUrl,
            size: props.primary ? 'xlarge' : 'medium'
        })
    });
const $bf9d181e9244a469$export$a9754b3c8daa5172 = (0, $9jjaN.default).section($bf9d181e9244a469$var$t3 || ($bf9d181e9244a469$var$t3 = $bf9d181e9244a469$var$_`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`));
const $bf9d181e9244a469$export$fadcaf242d6ed62f = (0, $9jjaN.default)($bf9d181e9244a469$export$a9754b3c8daa5172)($bf9d181e9244a469$var$t4 || ($bf9d181e9244a469$var$t4 = $bf9d181e9244a469$var$_`
  padding: 8px 0;
`));
const $bf9d181e9244a469$export$762240c6611b6ed2 = (0, $9jjaN.default).section($bf9d181e9244a469$var$t5 || ($bf9d181e9244a469$var$t5 = $bf9d181e9244a469$var$_`
  flex-grow: 1;

  min-width: 0;
  // IE11 expands width to the parent container until the overflow kicks in
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    width: 0;
  }

  display: inline-block;
  margin: 0 16px;

  > * {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`));
const $bf9d181e9244a469$export$8b251419efc915eb = (0, $9jjaN.default).span($bf9d181e9244a469$var$t6 || ($bf9d181e9244a469$var$t6 = $bf9d181e9244a469$var$_`
  font: ${0};
  font-size: ${0};
  line-height: ${0};
  color: ${0};
  overflow-wrap: break-word;
`), (props)=>props.primary ? (0, $k8ZoM.default)('font.heading.medium') : (0, $k8ZoM.default)('font.heading.xsmall'), (props)=>props.primary ? '20px' : '14px', (props)=>props.primary ? '24px' : '20px', (0, $kLNLK).N800);
const $bf9d181e9244a469$export$358a232cca1ab2ac = (0, $9jjaN.default).p($bf9d181e9244a469$var$t7 || ($bf9d181e9244a469$var$t7 = $bf9d181e9244a469$var$_`
  font-size: 14px;
  line-height: 20px;
  color: ${0};
  margin-top: ${0};
  overflow-wrap: break-word;
`), (0, $kLNLK).N700, (props)=>props.primary ? '4px' : '0');
const $bf9d181e9244a469$export$8f314e512d92575f = (0, $9jjaN.default).section($bf9d181e9244a469$var$t8 || ($bf9d181e9244a469$var$t8 = $bf9d181e9244a469$var$_`
  margin-right: 8px;
`));
/**
 * Representation of an account in a row format, used for rendering lists of accounts, e.g. for switching an account
 * or selecting one to log in
 */ const $bf9d181e9244a469$var$Account = ({ avatarUrl: avatarUrl, children: children, displayName: displayName, email: email, header: header, icon: icon, id: id, onClick: onClick, primary: primary })=>{
    const title = displayName ? displayName : email;
    const paragraph = displayName ? email : undefined;
    return /*#__PURE__*/ (0, $4ZSso.jsxs)($bf9d181e9244a469$export$5baee99c5c7ba187, {
        id: id,
        className: "account-entry" // account-entry used by pollinators
        ,
        "data-testid": "account-entry",
        as: primary ? 'div' : 'button',
        primary: primary,
        onClick: onClick,
        children: [
            header,
            /*#__PURE__*/ (0, $4ZSso.jsxs)($bf9d181e9244a469$export$a9754b3c8daa5172, {
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)($bf9d181e9244a469$var$Avatar, {
                        avatarUrl: avatarUrl,
                        primary: primary
                    }),
                    /*#__PURE__*/ (0, $4ZSso.jsxs)($bf9d181e9244a469$export$762240c6611b6ed2, {
                        children: [
                            /*#__PURE__*/ (0, $4ZSso.jsx)($bf9d181e9244a469$export$8b251419efc915eb, {
                                primary: primary,
                                "data-testid": "email",
                                children: title
                            }),
                            paragraph && /*#__PURE__*/ (0, $4ZSso.jsx)($bf9d181e9244a469$export$358a232cca1ab2ac, {
                                primary: primary,
                                children: paragraph
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4ZSso.jsx)($bf9d181e9244a469$export$8f314e512d92575f, {
                        children: icon
                    })
                ]
            }),
            children
        ]
    });
};
var $bf9d181e9244a469$export$2e2bcd8739ae039 = $bf9d181e9244a469$var$Account;

});
parcelRegister("4SYff", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38eaeff3925b59e8$export$2e2bcd8739ae039; });
/* avatar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $8Xa2x = parcelRequire("8Xa2x");

var $lD6mB = parcelRequire("lD6mB");

var $6iPJh = parcelRequire("6iPJh");

var $9rbA6 = parcelRequire("9rbA6");

var $64lkI = parcelRequire("64lkI");

var $1vOCo = parcelRequire("1vOCo");

var $cxQl8 = parcelRequire("cxQl8");

var $cIHSL = parcelRequire("cIHSL");
function $38eaeff3925b59e8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $38eaeff3925b59e8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $38eaeff3925b59e8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $38eaeff3925b59e8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $38eaeff3925b59e8$var$packageName = "@atlaskit/avatar";
var $38eaeff3925b59e8$var$packageVersion = "25.1.17";
var $38eaeff3925b59e8$var$containerStyles = null;
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ var $38eaeff3925b59e8$var$Avatar = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'circle' : _ref$appearance, label = _ref.label, borderColor = _ref.borderColor, children = _ref.children, href = _ref.href, isDisabled = _ref.isDisabled, name = _ref.name, onClick = _ref.onClick, presence = _ref.presence, sizeProp = _ref.size, src = _ref.src, stackIndex = _ref.stackIndex, status = _ref.status, target = _ref.target, testId = _ref.testId, _ref$as = _ref.as, AvatarContainer = _ref$as === void 0 ? 'div' : _ref$as, _ref$isDecorative = _ref.isDecorative, isDecorative = _ref$isDecorative === void 0 ? false : _ref$isDecorative, imgLoading = _ref.imgLoading;
    var _useAnalyticsEvents = (0, $8Xa2x.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var context = (0, $9rbA6.useAvatarContext)();
    var size = sizeProp || (context === null || context === void 0 ? void 0 : context.size) || 'medium';
    var customPresenceNode = /*#__PURE__*/ (0, $91i6m.isValidElement)(presence) ? presence : null;
    var customStatusNode = /*#__PURE__*/ (0, $91i6m.isValidElement)(status) ? status : null;
    var isValidIconSize = size !== 'xxlarge' && size !== 'xsmall';
    var lastAnalytics = (0, $91i6m.useRef)(analyticsContext);
    var labelId = (0, $lD6mB.useId)();
    (0, $91i6m.useEffect)(function() {
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    var onClickHandler = (0, $91i6m.useCallback)(function(event) {
        if (isDisabled || typeof onClick !== 'function') return;
        var analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $38eaeff3925b59e8$var$packageName,
                packageVersion: $38eaeff3925b59e8$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ var context = $38eaeff3925b59e8$var$_objectSpread({
            componentName: 'avatar',
            packageName: $38eaeff3925b59e8$var$packageName,
            packageVersion: $38eaeff3925b59e8$var$packageVersion
        }, lastAnalytics.current);
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC.
     */ var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    var isPresence = isValidIconSize && presence && !status;
    var isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    var defaultLabel = [
        name,
        isStatus && !customStatusNode && "(".concat(status, ")"),
        isPresence && !customPresenceNode && "(".concat(presence, ")")
    ].filter(Boolean).join(' ');
    var isInteractive = onClick || href || isDisabled;
    var containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return /*#__PURE__*/ $91i6m.createElement((0, $9rbA6.EnsureIsInsideAvatarContext).Provider, {
        value: true
    }, /*#__PURE__*/ $91i6m.createElement(AvatarContainer, {
        "data-testid": testId,
        role: containerShouldBeImage ? 'img' : undefined,
        "aria-labelledby": containerShouldBeImage && !isDecorative ? labelId : undefined,
        style: {
            zIndex: stackIndex
        },
        className: (0, $9gzWK.default)([
            "_12ji1r31 _1qu2glyw _12y3idpf _1e0c1o8l _kqswh2mm"
        ])
    }, /*#__PURE__*/ $91i6m.createElement((0, $9rbA6.AvatarContentContext).Provider, {
        value: {
            as: (0, $cIHSL.getCustomElement)(isDisabled, href, onClick),
            appearance: appearance,
            borderColor: borderColor,
            href: href,
            isDisabled: isDisabled,
            label: label || defaultLabel,
            onClick: isInteractive ? onClickHandler : undefined,
            ref: ref,
            size: size,
            stackIndex: stackIndex,
            target: target,
            testId: testId ? "".concat(testId, "--inner") : undefined,
            avatarImage: /*#__PURE__*/ $91i6m.createElement((0, $64lkI.default), {
                alt: !containerShouldBeImage && src ? name : undefined,
                src: src,
                appearance: appearance,
                size: size,
                testId: testId,
                imgLoading: imgLoading
            })
        }
    }, children || /*#__PURE__*/ $91i6m.createElement((0, $6iPJh.AvatarContent), null)), isPresence && /*#__PURE__*/ $91i6m.createElement((0, $1vOCo.PresenceWrapper), {
        appearance: appearance,
        size: size,
        presence: typeof presence === 'string' ? presence : undefined,
        testId: testId
    }, customPresenceNode), isStatus && /*#__PURE__*/ $91i6m.createElement((0, $cxQl8.StatusWrapper), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        status: typeof status === 'string' ? status : undefined,
        testId: testId
    }, customStatusNode), containerShouldBeImage ? /*#__PURE__*/ $91i6m.createElement("span", {
        "data-testid": testId && "".concat(testId, "--label"),
        id: labelId,
        hidden: true
    }, defaultLabel) : undefined));
});
$38eaeff3925b59e8$var$Avatar.displayName = 'Avatar';
var $38eaeff3925b59e8$export$2e2bcd8739ae039 = $38eaeff3925b59e8$var$Avatar;

});
parcelRegister("6iPJh", function(module, exports) {

$parcel$export(module.exports, "AvatarContent", function () { return $496c8cddd099c71a$export$47fbc0b44cae5559; });
/* avatar-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $f1k1y = parcelRequire("f1k1y");

var $9rbA6 = parcelRequire("9rbA6");
var $496c8cddd099c71a$var$boxShadowCssVar = '--avatar-box-shadow';
var $496c8cddd099c71a$var$bgColorCssVar = '--avatar-bg-color';
var $496c8cddd099c71a$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk1j28 _aetrf705 _1peqidpf _11fnglyw _1ejjglyw _mizu194a _1ah3v77o _ra3xnqa1 _128m1bk5 _4dave4h9",
    circle: "_2rko1qll _14mj1qll",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peqs237"
};
var $496c8cddd099c71a$var$unboundStyles = {
    root: "_vchh1ntv _bfhkcxp3 _16qs1nhn",
    interactive: "_80omtlke _4tpu1g4v _ez1ykb7n _gcm1182g _eeh8kb7n _jlxit94y"
};
var $496c8cddd099c71a$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
var $496c8cddd099c71a$var$borderRadiusMap = {
    xsmall: "_2rkolb4i _14mjlb4i",
    small: "_2rkolb4i _14mjlb4i",
    medium: "_2rkofajl _14mjfajl",
    large: "_2rkofajl _14mjfajl",
    xlarge: "_2rko1qi0 _14mj1qi0",
    xxlarge: "_2rkopb1k _14mjpb1k"
};
var $496c8cddd099c71a$export$47fbc0b44cae5559 = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref, ref) {
    var children = _ref.children;
    (0, $9rbA6.useEnsureIsInsideAvatar)();
    var _useAvatarContent = (0, $9rbA6.useAvatarContent)(), Container = _useAvatarContent.as, appearance = _useAvatarContent.appearance, avatarImage = _useAvatarContent.avatarImage, _useAvatarContent$bor = _useAvatarContent.borderColor, borderColor = _useAvatarContent$bor === void 0 ? (0, $f1k1y.fg)('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : "var(--ds-surface-overlay, #FFFFFF)" : _useAvatarContent$bor, href = _useAvatarContent.href, isDisabled = _useAvatarContent.isDisabled, label = _useAvatarContent.label, onClick = _useAvatarContent.onClick, contextRef = _useAvatarContent.ref, tabIndex = _useAvatarContent.tabIndex, target = _useAvatarContent.target, testId = _useAvatarContent.testId, size = _useAvatarContent.size, stackIndex = _useAvatarContent.stackIndex;
    var isInteractive = Boolean(onClick || href || isDisabled);
    return /*#__PURE__*/ $91i6m.createElement(Container, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        style: (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, $496c8cddd099c71a$var$bgColorCssVar, borderColor), $496c8cddd099c71a$var$boxShadowCssVar, "0 0 0 2px ".concat(borderColor)),
        ref: ref || contextRef,
        "aria-label": isInteractive ? label : undefined,
        onClick: onClick,
        tabIndex: tabIndex,
        "data-testid": testId,
        disabled: isDisabled,
        type: Container === 'button' ? 'button' : undefined
    }, href && {
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined
    }, {
        className: (0, $9gzWK.default)([
            $496c8cddd099c71a$var$unboundStyles.root,
            $496c8cddd099c71a$var$styles.root,
            $496c8cddd099c71a$var$borderRadiusMap[size],
            appearance === 'circle' && $496c8cddd099c71a$var$styles.circle,
            $496c8cddd099c71a$var$widthHeightMap[size],
            stackIndex !== undefined && $496c8cddd099c71a$var$styles.positionRelative,
            isInteractive && !isDisabled && $496c8cddd099c71a$var$unboundStyles.interactive,
            isDisabled && $496c8cddd099c71a$var$styles.disabled
        ])
    }), children || avatarImage);
});

});
parcelRegister("9rbA6", function(module, exports) {

$parcel$export(module.exports, "useAvatarContext", function () { return $6def9e7b62419ead$export$b50b87a1c4086b23; });
$parcel$export(module.exports, "AvatarContentContext", function () { return $6def9e7b62419ead$export$b983474ddd0b6d28; });
$parcel$export(module.exports, "useAvatarContent", function () { return $6def9e7b62419ead$export$79d078b69b7e4842; });
$parcel$export(module.exports, "EnsureIsInsideAvatarContext", function () { return $6def9e7b62419ead$export$6b4cbd90d24955ad; });
$parcel$export(module.exports, "useEnsureIsInsideAvatar", function () { return $6def9e7b62419ead$export$7db5c57474082dd9; });

var $91i6m = parcelRequire("91i6m");
var $6def9e7b62419ead$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $91i6m.createContext)(undefined);
var $6def9e7b62419ead$export$b50b87a1c4086b23 = function useAvatarContext() {
    return (0, $91i6m.useContext)($6def9e7b62419ead$export$a20dad690e1279e2);
};
var $6def9e7b62419ead$var$defaultAvatarContentProps = {
    as: 'span',
    appearance: 'circle',
    avatarImage: null,
    ref: null,
    size: 'medium'
};
var $6def9e7b62419ead$export$b983474ddd0b6d28 = /*#__PURE__*/ (0, $91i6m.createContext)($6def9e7b62419ead$var$defaultAvatarContentProps);
var $6def9e7b62419ead$export$79d078b69b7e4842 = function useAvatarContent() {
    return (0, $91i6m.useContext)($6def9e7b62419ead$export$b983474ddd0b6d28);
};
var $6def9e7b62419ead$export$6b4cbd90d24955ad = /*#__PURE__*/ (0, $91i6m.createContext)(false);
var $6def9e7b62419ead$export$7db5c57474082dd9 = function useEnsureIsInsideAvatar() {
    var context = (0, $91i6m.useContext)($6def9e7b62419ead$export$6b4cbd90d24955ad);
    if (!context) throw new Error('Avatar sub-components must be used within a Avatar component.');
};

});


parcelRegister("64lkI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46b3aa176b9f9bbe$export$2e2bcd8739ae039; });
/* avatar-image.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5YM7L = parcelRequire("5YM7L");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $9qm3J = parcelRequire("9qm3J");

var $eg2iY = parcelRequire("eg2iY");

var $f1k1y = parcelRequire("f1k1y");
var $46b3aa176b9f9bbe$var$styles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq",
    icon: "_1e0c1txw _1bsb1osq _4t3i1osq",
    iconBg: "_bfhkr4aa",
    iconBGVisualRefresh: "_bfhk1v33",
    circle: "_2rko1rr0"
};
var $46b3aa176b9f9bbe$var$borderRadiusMap = {
    xsmall: "_2rkolb4i",
    small: "_2rkolb4i",
    medium: "_2rkofajl",
    large: "_2rkofajl",
    xlarge: "_2rko1qi0",
    xxlarge: "_2rkopb1k"
};
var $46b3aa176b9f9bbe$var$nestedSvgStylesMap = {
    xsmall: "_w8l57vkz _17527vkz",
    small: "_w8l51tcg _17521tcg",
    medium: "_w8l5zwfg _1752zwfg",
    large: "_w8l51ylp _17521ylp",
    xlarge: "_w8l516xz _175216xz",
    xxlarge: "_w8l51qr7 _17521qr7"
};
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ var $46b3aa176b9f9bbe$var$AvatarImage = function AvatarImage(_ref) {
    var _ref$alt = _ref.alt, alt = _ref$alt === void 0 ? '' : _ref$alt, src = _ref.src, appearance = _ref.appearance, size = _ref.size, testId = _ref.testId, imgLoading = _ref.imgLoading;
    var _useState = (0, $91i6m.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), hasImageErrored = _useState2[0], setHasImageErrored = _useState2[1];
    // If src changes, reset state
    (0, $91i6m.useEffect)(function() {
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return /*#__PURE__*/ $91i6m.createElement("span", {
        className: (0, $9gzWK.default)([
            $46b3aa176b9f9bbe$var$styles.icon,
            (0, $f1k1y.fg)('platform-component-visual-refresh') ? $46b3aa176b9f9bbe$var$styles.iconBGVisualRefresh : $46b3aa176b9f9bbe$var$styles.iconBg,
            $46b3aa176b9f9bbe$var$nestedSvgStylesMap[size]
        ])
    }, appearance === 'circle' ? /*#__PURE__*/ $91i6m.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9qm3J))), {
        label: alt,
        color: (0, $f1k1y.fg)('platform-component-visual-refresh') ? "var(--ds-icon-subtle, #626F86)" : "var(--ds-icon-inverse, #FFFFFF)",
        testId: testId && "".concat(testId, "--person"),
        spacing: "spacious",
        LEGACY_secondaryColor: "var(--ds-icon-subtle, #626F86)"
    }) : /*#__PURE__*/ $91i6m.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eg2iY))), {
        label: alt,
        color: (0, $f1k1y.fg)('platform-component-visual-refresh') ? "var(--ds-icon-subtle, #626F86)" : "var(--ds-icon-inverse, #FFFFFF)",
        testId: testId && "".concat(testId, "--ship"),
        spacing: "spacious",
        LEGACY_secondaryColor: "var(--ds-icon-subtle, #626F86)"
    }));
    return /*#__PURE__*/ $91i6m.createElement("img", {
        loading: imgLoading,
        src: src,
        alt: alt,
        "data-testid": testId && "".concat(testId, "--image"),
        onError: function onError() {
            return setHasImageErrored(true);
        },
        "aria-hidden": !alt ? true : undefined,
        "data-vc": testId ? "".concat(testId, "--image") : 'avatar-image',
        "data-ssr-placeholder-ignored": true,
        className: (0, $9gzWK.default)([
            $46b3aa176b9f9bbe$var$styles.image,
            $46b3aa176b9f9bbe$var$borderRadiusMap[size],
            appearance === 'circle' && $46b3aa176b9f9bbe$var$styles.circle
        ])
    });
};
var $46b3aa176b9f9bbe$export$2e2bcd8739ae039 = $46b3aa176b9f9bbe$var$AvatarImage;

});
parcelRegister("9qm3J", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29971dcd1e1cc09403d75aea4f4ed622>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6dc7a74566f82806$var$_react = $6dc7a74566f82806$var$_interopRequireDefault((parcelRequire("91i6m")));

var $6dc7a74566f82806$var$_person = $6dc7a74566f82806$var$_interopRequireDefault((parcelRequire("ctG5R")));

var $6dc7a74566f82806$var$_person2 = $6dc7a74566f82806$var$_interopRequireDefault((parcelRequire("hcqQp")));
function $6dc7a74566f82806$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PersonIcon.
 * This component is PersonIcon, with `UNSAFE_fallbackIcon` set to "PersonIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6dc7a74566f82806$var$PersonIcon = (props)=>/*#__PURE__*/ $6dc7a74566f82806$var$_react.default.createElement($6dc7a74566f82806$var$_person.default, Object.assign({
        name: "PersonIcon",
        LEGACY_fallbackIcon: $6dc7a74566f82806$var$_person2.default
    }, props));
$6dc7a74566f82806$var$PersonIcon.displayName = 'PersonIconMigration';
var $6dc7a74566f82806$var$_default = module.exports.default = $6dc7a74566f82806$var$PersonIcon;

});
parcelRegister("ctG5R", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc4353a18034f564a0b3573d4163ea60>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9158d8583d8616f7$var$_react = $9158d8583d8616f7$var$_interopRequireDefault((parcelRequire("91i6m")));

var $9158d8583d8616f7$var$_baseNew = $9158d8583d8616f7$var$_interopRequireDefault((parcelRequire("6fFaX")));
function $9158d8583d8616f7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9158d8583d8616f7$var$PersonIcon = (props)=>/*#__PURE__*/ $9158d8583d8616f7$var$_react.default.createElement($9158d8583d8616f7$var$_baseNew.default, Object.assign({
        name: "PersonIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$9158d8583d8616f7$var$PersonIcon.displayName = 'PersonIcon';
var $9158d8583d8616f7$var$_default = module.exports.default = $9158d8583d8616f7$var$PersonIcon;

});
parcelRegister("6fFaX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("9bVbP")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("9bVbP")).Icon; });

var $9bVbP = parcelRequire("9bVbP");

});
parcelRegister("9bVbP", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $6b1180d6517c9531$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $6b1180d6517c9531$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $f1k1y = parcelRequire("f1k1y");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $6b1180d6517c9531$var$svgStyles = null;
var $6b1180d6517c9531$var$iconStyles = null;
var $6b1180d6517c9531$var$utilityIconStyles = null;
var $6b1180d6517c9531$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $6b1180d6517c9531$var$baseHcmStyles = null;
var $6b1180d6517c9531$var$scaleSize = null;
var $6b1180d6517c9531$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $6b1180d6517c9531$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $6b1180d6517c9531$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $6b1180d6517c9531$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $6b1180d6517c9531$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $6b1180d6517c9531$export$f04a61298a47a40f = /*#__PURE__*/ (0, $91i6m.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $f1k1y.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $91i6m.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = $6b1180d6517c9531$var$baseSizeMap[type];
    var viewBoxPadding = $6b1180d6517c9531$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $91i6m.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $9gzWK.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $91i6m.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $9gzWK.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $6b1180d6517c9531$var$utilSizes[spacing] : size === 'small' ? $6b1180d6517c9531$var$coreSizeSmall[spacing] : $6b1180d6517c9531$var$coreSizeMedium[spacing]
        ])
    }));
});
var $6b1180d6517c9531$export$2e2bcd8739ae039 = $6b1180d6517c9531$export$f04a61298a47a40f;

});



parcelRegister("hcqQp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c858615c5ca15a97$var$_react = $c858615c5ca15a97$var$_interopRequireDefault((parcelRequire("91i6m")));

var $7Fz8m = parcelRequire("7Fz8m");
function $c858615c5ca15a97$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c858615c5ca15a97$var$PersonIcon = (props)=>/*#__PURE__*/ $c858615c5ca15a97$var$_react.default.createElement($7Fz8m.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="12" cy="7" r="4"/></g></svg>`
    }, props));
$c858615c5ca15a97$var$PersonIcon.displayName = 'PersonIcon';
var $c858615c5ca15a97$var$_default = module.exports.default = $c858615c5ca15a97$var$PersonIcon;

});
parcelRegister("7Fz8m", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $59579d9394b57075$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");
function $59579d9394b57075$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $59579d9394b57075$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $59579d9394b57075$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $59579d9394b57075$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $59579d9394b57075$var$iconStyles = null;
var $59579d9394b57075$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $59579d9394b57075$var$baseHcmStyles = null;
var $59579d9394b57075$var$primaryEqualsSecondaryHcmStyles = null;
var $59579d9394b57075$var$secondaryTransparentHcmStyles = null;
var $59579d9394b57075$export$f04a61298a47a40f = /*#__PURE__*/ (0, $91i6m.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $91i6m.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $91i6m.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $59579d9394b57075$var$_objectSpread($59579d9394b57075$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $9gzWK.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $59579d9394b57075$var$sizeStyles[size]
        ])
    }));
});
var $59579d9394b57075$export$2e2bcd8739ae039 = $59579d9394b57075$export$f04a61298a47a40f;

});



parcelRegister("eg2iY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d0234a675d9b1e030b7622cea0db1767>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a614590601c185a6$var$_react = $a614590601c185a6$var$_interopRequireDefault((parcelRequire("91i6m")));

var $a614590601c185a6$var$_release = $a614590601c185a6$var$_interopRequireDefault((parcelRequire("6rEza")));

var $a614590601c185a6$var$_ship = $a614590601c185a6$var$_interopRequireDefault((parcelRequire("4yCKz")));
function $a614590601c185a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ReleaseIcon.
 * This component is ReleaseIcon, with `UNSAFE_fallbackIcon` set to "ShipIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a614590601c185a6$var$ReleaseIcon = (props)=>/*#__PURE__*/ $a614590601c185a6$var$_react.default.createElement($a614590601c185a6$var$_release.default, Object.assign({
        name: "ReleaseIcon",
        LEGACY_fallbackIcon: $a614590601c185a6$var$_ship.default
    }, props));
$a614590601c185a6$var$ReleaseIcon.displayName = 'ReleaseIconMigration';
var $a614590601c185a6$var$_default = module.exports.default = $a614590601c185a6$var$ReleaseIcon;

});
parcelRegister("6rEza", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5b008ccfed50bccf7a8bb78b89f8a48>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b14bb4de8708cbb$var$_react = $4b14bb4de8708cbb$var$_interopRequireDefault((parcelRequire("91i6m")));

var $4b14bb4de8708cbb$var$_baseNew = $4b14bb4de8708cbb$var$_interopRequireDefault((parcelRequire("6fFaX")));
function $4b14bb4de8708cbb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4b14bb4de8708cbb$var$ReleaseIcon = (props)=>/*#__PURE__*/ $4b14bb4de8708cbb$var$_react.default.createElement($4b14bb4de8708cbb$var$_baseNew.default, Object.assign({
        name: "ReleaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2h3v2h2a.75.75 0 0 1 .648.372L11.18 7h4.069a.75.75 0 0 1 .646 1.132l-2.887 4.886a2 2 0 0 1-1.722.982H2a2 2 0 0 1-2-2V7.75A.75.75 0 0 1 .75 7H2V4.75A.75.75 0 0 1 2.75 4H4zm-.5 5h5.944L8.57 5.5H3.5zm-2 1.5V12a.5.5 0 0 0 .5.5h9.287a.5.5 0 0 0 .43-.246L13.936 8.5z" clip-rule="evenodd"/>`
    }, props));
$4b14bb4de8708cbb$var$ReleaseIcon.displayName = 'ReleaseIcon';
var $4b14bb4de8708cbb$var$_default = module.exports.default = $4b14bb4de8708cbb$var$ReleaseIcon;

});

parcelRegister("4yCKz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $351865630800627a$var$_react = $351865630800627a$var$_interopRequireDefault((parcelRequire("91i6m")));

var $7Fz8m = parcelRequire("7Fz8m");
function $351865630800627a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $351865630800627a$var$ShipIcon = (props)=>/*#__PURE__*/ $351865630800627a$var$_react.default.createElement($7Fz8m.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 12h8v-2H6zM4 8.99C4 8.445 4.456 8 5.002 8h9.996C15.55 8 16 8.451 16 8.99V14H4z"/><path d="M6 7.005C6 5.898 6.898 5 7.998 5h2.004C11.106 5 12 5.894 12 7.005V10H6zm4 0V7H7.999c.005 0 .002.003.002.005V8h2z"/><path fill-rule="nonzero" d="M4.5 17h13.994l1.002-3H4.14zm-2.495-4.012A.862.862 0 0 1 2.883 12h18.393c.55 0 .857.417.681.944l-1.707 5.112c-.174.521-.758.944-1.315.944H3.725a1.15 1.15 0 0 1-1.118-.988z"/></g></svg>`
    }, props));
$351865630800627a$var$ShipIcon.displayName = 'ShipIcon';
var $351865630800627a$var$_default = module.exports.default = $351865630800627a$var$ShipIcon;

});



parcelRegister("1vOCo", function(module, exports) {

$parcel$export(module.exports, "PresenceWrapper", function () { return $119ff3715b3d96a5$export$972c5e90200fa0ef; });
/* presence.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $hKPZd = parcelRequire("hKPZd");

var $5xSMk = parcelRequire("5xSMk");
var $119ff3715b3d96a5$var$BusyIndicator = /*#__PURE__*/ $91i6m.createElement((0, $91i6m.Fragment), null, /*#__PURE__*/ $91i6m.createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $hKPZd.R300), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $91i6m.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $hKPZd.N0), ")"),
    d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
}));
var $119ff3715b3d96a5$var$FocusIndicator = /*#__PURE__*/ $91i6m.createElement((0, $91i6m.Fragment), null, /*#__PURE__*/ $91i6m.createElement("path", {
    fill: "var(--ds-icon-discovery, ".concat((0, $hKPZd.P300), ")"),
    d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
}));
var $119ff3715b3d96a5$var$OfflineIndicator = /*#__PURE__*/ $91i6m.createElement((0, $91i6m.Fragment), null, /*#__PURE__*/ $91i6m.createElement("path", {
    fill: "var(--ds-text-subtlest, ".concat((0, $hKPZd.N200), ")"),
    d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}), /*#__PURE__*/ $91i6m.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $hKPZd.N40), ")"),
    d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}));
var $119ff3715b3d96a5$var$OnlineIndicator = /*#__PURE__*/ $91i6m.createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $hKPZd.G300), ")"),
    cx: "4",
    cy: "4",
    r: "4"
});
function $119ff3715b3d96a5$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $119ff3715b3d96a5$var$BusyIndicator;
        case 'focus':
            return $119ff3715b3d96a5$var$FocusIndicator;
        case 'offline':
            return $119ff3715b3d96a5$var$OfflineIndicator;
        case 'online':
            return $119ff3715b3d96a5$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ var $119ff3715b3d96a5$var$AvatarPresence = function AvatarPresence(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, presence = _ref.presence;
    return /*#__PURE__*/ $91i6m.createElement((0, $5xSMk.default), {
        bgColor: borderColor
    }, presence ? /*#__PURE__*/ $91i6m.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $119ff3715b3d96a5$var$getPresence(presence)) : children);
};
var $119ff3715b3d96a5$export$2e2bcd8739ae039 = $119ff3715b3d96a5$var$AvatarPresence;
var $119ff3715b3d96a5$var$styles = {
    root: "_kqswstnw _lcxvglyw"
};
var $119ff3715b3d96a5$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
var $119ff3715b3d96a5$var$iconOffsetMap = {
    square: "_94n5myb0 _1xi2myb0",
    small: "_94n5idpf _1xi2idpf",
    medium: "_94n5idpf _1xi2idpf",
    large: "_94n5t94y _1xi2t94y",
    xlarge: "_94n51v6z _1xi21v6z"
};
var $119ff3715b3d96a5$export$972c5e90200fa0ef = function PresenceWrapper(_ref2) {
    var size = _ref2.size, appearance = _ref2.appearance, children = _ref2.children, borderColor = _ref2.borderColor, presence = _ref2.presence, testId = _ref2.testId;
    return /*#__PURE__*/ $91i6m.createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--presence"),
        className: (0, $9gzWK.default)([
            $119ff3715b3d96a5$var$styles.root,
            $119ff3715b3d96a5$var$iconSizeMap[size],
            $119ff3715b3d96a5$var$iconOffsetMap[size],
            appearance === 'square' && $119ff3715b3d96a5$var$iconOffsetMap['square']
        ])
    }, /*#__PURE__*/ $91i6m.createElement($119ff3715b3d96a5$var$AvatarPresence, {
        borderColor: borderColor,
        presence: !children ? presence : undefined
    }, children));
};

});
parcelRegister("hKPZd", function(module, exports) {

$parcel$export(module.exports, "R300", function () { return $cecf0eed78e71026$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $cecf0eed78e71026$export$2010d0fb4295b346; });
$parcel$export(module.exports, "G300", function () { return $cecf0eed78e71026$export$940e1f69e873f202; });
$parcel$export(module.exports, "G400", function () { return $cecf0eed78e71026$export$a49394138f7b8e85; });
$parcel$export(module.exports, "P300", function () { return $cecf0eed78e71026$export$b48405b95304b5a1; });
$parcel$export(module.exports, "N0", function () { return $cecf0eed78e71026$export$29a4f05edc054374; });
$parcel$export(module.exports, "N40", function () { return $cecf0eed78e71026$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N200", function () { return $cecf0eed78e71026$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N500", function () { return $cecf0eed78e71026$export$c39c0fe0f26207ae; });
// Reds
var $cecf0eed78e71026$export$4b84fd0e2c617bd = '#FFEBE6';
var $cecf0eed78e71026$export$b34b069eff244586 = '#FFBDAD';
var $cecf0eed78e71026$export$be802dd0d8b57f35 = '#FF8F73';
var $cecf0eed78e71026$export$60847d42f9da92a6 = '#FF7452';
var $cecf0eed78e71026$export$4a7404f376229999 = '#FF5630';
var $cecf0eed78e71026$export$2010d0fb4295b346 = '#DE350B';
var $cecf0eed78e71026$export$2837b5a1a71d5c02 = '#BF2600';
var $cecf0eed78e71026$export$8d9596b529bbb9cf = '#FFFAE6';
var $cecf0eed78e71026$export$41060a744ab0b7ae = '#FFF0B3';
var $cecf0eed78e71026$export$1cc05bbbf340e559 = '#FFE380';
var $cecf0eed78e71026$export$5aae31392d72caaa = '#FFC400';
var $cecf0eed78e71026$export$c6930421db9fa514 = '#FFAB00';
var $cecf0eed78e71026$export$59619663aa6500fb = '#FF991F';
var $cecf0eed78e71026$export$874739ea9e379ab6 = '#FF8B00';
var $cecf0eed78e71026$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $cecf0eed78e71026$export$69a3bf21b9686c2b = '#ABF5D1';
var $cecf0eed78e71026$export$afbce1382ec95f73 = '#79F2C0';
var $cecf0eed78e71026$export$747d86715d4175de = '#57D9A3';
var $cecf0eed78e71026$export$940e1f69e873f202 = '#36B37E';
var $cecf0eed78e71026$export$a49394138f7b8e85 = '#00875A';
var $cecf0eed78e71026$export$6fa04827ac68a4fb = '#006644';
var $cecf0eed78e71026$export$226de0355ed012f8 = '#DEEBFF';
var $cecf0eed78e71026$export$8c13c2ee36917869 = '#B3D4FF';
var $cecf0eed78e71026$export$ecfc1dff386a3e7a = '#4C9AFF';
var $cecf0eed78e71026$export$215b7063051591f1 = '#2684FF';
var $cecf0eed78e71026$export$e62e8919cca44969 = '#0065FF';
var $cecf0eed78e71026$export$b3de0ae08da2ce64 = '#0052CC';
var $cecf0eed78e71026$export$a6ee3d71bc067634 = '#0747A6';
var $cecf0eed78e71026$export$67f15409e87642a1 = '#669DF1';
var $cecf0eed78e71026$export$f0539dbc42dbb067 = '#8FB8F6';
var $cecf0eed78e71026$export$363e4475840015bb = '#EAE6FF';
var $cecf0eed78e71026$export$4b0a4417ed59760f = '#C0B6F2';
var $cecf0eed78e71026$export$6011520a64d9a187 = '#998DD9';
var $cecf0eed78e71026$export$a7175d4e9206bc80 = '#8777D9';
var $cecf0eed78e71026$export$b48405b95304b5a1 = '#6554C0';
var $cecf0eed78e71026$export$c71e4279dd54a18d = '#5243AA';
var $cecf0eed78e71026$export$147899de772240ec = '#403294';
var $cecf0eed78e71026$export$2cf711fe14c66f06 = '#E6FCFF';
var $cecf0eed78e71026$export$7a8f4d33f6f9772c = '#B3F5FF';
var $cecf0eed78e71026$export$776c9c497ef08533 = '#79E2F2';
var $cecf0eed78e71026$export$69cb3ca10c1e330e = '#00C7E6';
var $cecf0eed78e71026$export$9dc1ef0f3f48059b = '#00B8D9';
var $cecf0eed78e71026$export$7c835c78b6fcdef8 = '#00A3BF';
var $cecf0eed78e71026$export$6036577f95c3877e = '#008DA6';
var $cecf0eed78e71026$export$29a4f05edc054374 = '#FFFFFF';
var $cecf0eed78e71026$export$e655ef011c4aa1a2 = '#FAFBFC';
var $cecf0eed78e71026$export$9fdfb749e33cdf97 = '#F4F5F7';
var $cecf0eed78e71026$export$3e51e8f1440314ba = '#EBECF0';
var $cecf0eed78e71026$export$1ce2d1575d444ceb = '#DFE1E6';
var $cecf0eed78e71026$export$8754fc7e6d8b3000 = '#C1C7D0';
var $cecf0eed78e71026$export$c2e91cbeada39b8b = '#B3BAC5';
var $cecf0eed78e71026$export$5f71e19f3a7ad9de = '#A5ADBA';
var $cecf0eed78e71026$export$eaa8c8a70ac22806 = '#97A0AF';
var $cecf0eed78e71026$export$7c87d337fb91a97d = '#8993A4';
var $cecf0eed78e71026$export$d6447c357493214f = '#7A869A';
var $cecf0eed78e71026$export$f563ee71e9ee74cd = '#6B778C';
var $cecf0eed78e71026$export$e2ef2124cf4024b1 = '#5E6C84';
var $cecf0eed78e71026$export$eece5f492e429f08 = '#505F79';
var $cecf0eed78e71026$export$c39c0fe0f26207ae = '#42526E';
var $cecf0eed78e71026$export$7090862dc3038a9f = '#344563';
var $cecf0eed78e71026$export$ad0bacf983b7ddaa = '#253858';
var $cecf0eed78e71026$export$7d61b15e0da132af = '#172B4D';
var $cecf0eed78e71026$export$fbda843f0a27fe96 = '#091E42';
var $cecf0eed78e71026$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $cecf0eed78e71026$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $cecf0eed78e71026$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $cecf0eed78e71026$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $cecf0eed78e71026$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $cecf0eed78e71026$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $cecf0eed78e71026$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $cecf0eed78e71026$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $cecf0eed78e71026$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $cecf0eed78e71026$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $cecf0eed78e71026$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $cecf0eed78e71026$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $cecf0eed78e71026$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $cecf0eed78e71026$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $cecf0eed78e71026$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $cecf0eed78e71026$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $cecf0eed78e71026$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $cecf0eed78e71026$export$2f6319cf7d736c2a = '#E6EDFA';
var $cecf0eed78e71026$export$95126bc8884d6634 = '#DCE5F5';
var $cecf0eed78e71026$export$8338d8c35d44ff1 = '#CED9EB';
var $cecf0eed78e71026$export$5368d76ae4fbbda7 = '#B8C7E0';
var $cecf0eed78e71026$export$9f0a771d16ec8d36 = '#ABBBD6';
var $cecf0eed78e71026$export$abcf8c38338b4aa5 = '#9FB0CC';
var $cecf0eed78e71026$export$97e81faa16a182c7 = '#8C9CB8';
var $cecf0eed78e71026$export$bfe21c59123ecf33 = '#7988A3';
var $cecf0eed78e71026$export$ee82aa2ea6a1558 = '#67758F';
var $cecf0eed78e71026$export$682927c6ed76be02 = '#56637A';
var $cecf0eed78e71026$export$91fd9994c5be9757 = '#455166';
var $cecf0eed78e71026$export$d281fbfe3cff2df6 = '#3B475C';
var $cecf0eed78e71026$export$3902c91d8b98a753 = '#313D52';
var $cecf0eed78e71026$export$8e8133c1ba5845b5 = '#283447';
var $cecf0eed78e71026$export$33ff357f6620b39 = '#202B3D';
var $cecf0eed78e71026$export$633847cf062b69e0 = '#1B2638';
var $cecf0eed78e71026$export$9776a6e503bdbf76 = '#121A29';
var $cecf0eed78e71026$export$6c813d5160dff5db = '#0E1624';
var $cecf0eed78e71026$export$3d4f271a500072a = '#0D1424';
var $cecf0eed78e71026$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $cecf0eed78e71026$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $cecf0eed78e71026$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $cecf0eed78e71026$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $cecf0eed78e71026$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $cecf0eed78e71026$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $cecf0eed78e71026$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $cecf0eed78e71026$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $cecf0eed78e71026$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $cecf0eed78e71026$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $cecf0eed78e71026$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $cecf0eed78e71026$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $cecf0eed78e71026$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $cecf0eed78e71026$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $cecf0eed78e71026$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $cecf0eed78e71026$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $cecf0eed78e71026$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $cecf0eed78e71026$export$d2adc5dedf09fced = '#292A2E';
var $cecf0eed78e71026$export$f51762073d2bb381 = '#94C748';
var $cecf0eed78e71026$export$95e26d54def96891 = '#B3DF72';

});

parcelRegister("5xSMk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $409a86b41196c87b$export$2e2bcd8739ae039; });
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");
var $409a86b41196c87b$var$styles = {
    root: "_2rko1qll _1reo15vq _18m915vq _189e1bk5 _1dqonqa1 _1e0c1txw _vchhusvi _1bsb1osq _4t3i1osq _4cvr1h6o _ae4v1h6o _bfhk1bhr"
};
var $409a86b41196c87b$var$unboundStyles = {
    root: "_1h6d1bhr"
};
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ var $409a86b41196c87b$var$IconWrapper = function IconWrapper(_ref) {
    var bgColor = _ref.bgColor, children = _ref.children;
    return /*#__PURE__*/ $91i6m.createElement("span", {
        role: "presentation",
        style: {
            borderColor: bgColor,
            backgroundColor: bgColor
        },
        className: (0, $9gzWK.default)([
            $409a86b41196c87b$var$styles.root,
            $409a86b41196c87b$var$unboundStyles.root
        ])
    }, children);
};
var $409a86b41196c87b$export$2e2bcd8739ae039 = $409a86b41196c87b$var$IconWrapper;

});


parcelRegister("cxQl8", function(module, exports) {

$parcel$export(module.exports, "StatusWrapper", function () { return $92212ab167d1d3d7$export$8045894f255f9726; });
/* status.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $hKPZd = parcelRequire("hKPZd");

var $5xSMk = parcelRequire("5xSMk");
var $92212ab167d1d3d7$var$styles = {
    root: "_kqswstnw"
};
var $92212ab167d1d3d7$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
var $92212ab167d1d3d7$var$iconOffsetMap = {
    square: "_1xi2idpf _154iidpf",
    small: "_1xi2idpf _154iidpf",
    medium: "_1xi2idpf _154iidpf",
    large: "_1xi2t94y _154it94y",
    xlarge: "_1xi21v6z _154i1v6z"
};
var $92212ab167d1d3d7$var$ApprovedIndicator = /*#__PURE__*/ $91i6m.createElement((0, $91i6m.Fragment), null, /*#__PURE__*/ $91i6m.createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $hKPZd.G400), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $91i6m.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $hKPZd.N0), ")"),
    d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
}));
var $92212ab167d1d3d7$var$DeclinedIndicator = /*#__PURE__*/ $91i6m.createElement((0, $91i6m.Fragment), null, /*#__PURE__*/ $91i6m.createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $hKPZd.R400), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $91i6m.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $hKPZd.N0), ")"),
    d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
}));
var $92212ab167d1d3d7$var$LockedIndicator = /*#__PURE__*/ $91i6m.createElement((0, $91i6m.Fragment), null, /*#__PURE__*/ $91i6m.createElement("circle", {
    fill: "var(--ds-text-subtlest, ".concat((0, $hKPZd.N40), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $91i6m.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $hKPZd.N500), ")"),
    d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
}));
function $92212ab167d1d3d7$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $92212ab167d1d3d7$var$ApprovedIndicator;
        case 'declined':
            return $92212ab167d1d3d7$var$DeclinedIndicator;
        case 'locked':
            return $92212ab167d1d3d7$var$LockedIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ var $92212ab167d1d3d7$var$AvatarStatus = function AvatarStatus(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, status = _ref.status;
    return /*#__PURE__*/ $91i6m.createElement((0, $5xSMk.default), {
        bgColor: borderColor
    }, status ? /*#__PURE__*/ $91i6m.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $92212ab167d1d3d7$var$getStatus(status)) : children);
};
var $92212ab167d1d3d7$export$2e2bcd8739ae039 = $92212ab167d1d3d7$var$AvatarStatus;
var $92212ab167d1d3d7$export$8045894f255f9726 = function StatusWrapper(_ref2) {
    var size = _ref2.size, status = _ref2.status, appearance = _ref2.appearance, borderColor = _ref2.borderColor, children = _ref2.children, testId = _ref2.testId;
    return /*#__PURE__*/ $91i6m.createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--status"),
        className: (0, $9gzWK.default)([
            $92212ab167d1d3d7$var$styles.root,
            $92212ab167d1d3d7$var$iconSizeMap[size],
            $92212ab167d1d3d7$var$iconOffsetMap[size],
            appearance === 'square' && $92212ab167d1d3d7$var$iconOffsetMap['square']
        ])
    }, /*#__PURE__*/ $91i6m.createElement($92212ab167d1d3d7$var$AvatarStatus, {
        borderColor: borderColor,
        status: !children ? status : undefined
    }, children));
};

});

parcelRegister("cIHSL", function(module, exports) {

$parcel$export(module.exports, "getCustomElement", function () { return $942ba232798b9221$export$83ee468102cdf04c; });
var $942ba232798b9221$export$83ee468102cdf04c = function getCustomElement(isDisabled, href, onClick) {
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled) return 'button';
    return 'span';
};

});



parcelRegister("5tkAn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb07a3e8d2505622$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $bb07a3e8d2505622$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    logoutTitle: {
        id: 'logout.title',
        defaultMessage: 'Log out of your Atlassian account'
    }
});

});

parcelRegister("fajwB", function(module, exports) {

$parcel$export(module.exports, "manageSession", function () { return $fe46854c65a2727a$export$66e31b319f474a64; });
$parcel$export(module.exports, "continueWithCurrentSession", function () { return $fe46854c65a2727a$export$5e0dba42c9dac553; });
$parcel$export(module.exports, "doLogout", function () { return $fe46854c65a2727a$export$61d11f3cbabcb5f4; });

var $1Fos3 = parcelRequire("1Fos3");

var $dBq8m = parcelRequire("dBq8m");

var $g7xf6 = parcelRequire("g7xf6");

var $49Pnv = parcelRequire("49Pnv");
const $fe46854c65a2727a$export$66e31b319f474a64 = (request, navigate, additionalParameters = {})=>(dispatch, getState)=>{
        const { csrfToken: csrfToken } = getState();
        dispatch({
            type: 'SESSION_REQUEST'
        });
        return fetch(`/rest/session`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            },
            body: JSON.stringify(request)
        }).then((response)=>response.json().then((data)=>{
                if (response.ok) {
                    const redirectUrl = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parseUrl(data.redirectUrl);
                    const currentParameters = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(window.location.search);
                    const mergedQuery = (0, $1Fos3._)({}, currentParameters, additionalParameters, redirectUrl.query);
                    return navigate(`${redirectUrl.url}?${(0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).stringify(mergedQuery)}`);
                } else (0, $49Pnv.captureErrorMessage)('manageSession failed', {
                    statusCode: response.status,
                    formErrors: data.formErrors
                });
            }));
    };
const $fe46854c65a2727a$export$5e0dba42c9dac553 = (navigate)=>async ()=>{
        navigate(`/login${$fe46854c65a2727a$var$getSanitizedQueryString()}`);
    };
const $fe46854c65a2727a$export$61d11f3cbabcb5f4 = (continueUrl)=>async (dispatch, getState)=>{
        const state = getState();
        // [KIRBY-7902] TODO: replace with `submitFormHackReplacement` once the backend endpoint is ready.
        (0, $g7xf6.default)({
            method: 'POST',
            action: `/logout${$fe46854c65a2727a$var$getSanitizedQueryString(continueUrl)}`,
            payload: {
                csrfToken: state.hashedCsrfToken
            }
        });
    };
const $fe46854c65a2727a$var$getSanitizedQueryString = (continueUrl)=>{
    const params = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(window.location.search);
    delete params.login_hint;
    delete params.prompt;
    if (continueUrl) params.continue = continueUrl;
    const paramsString = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).stringify(params);
    return paramsString && `?${paramsString}`;
};

});
parcelRegister("g7xf6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dceb0d2fa4ff3245$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "submitFormHackReplacement", function () { return $dceb0d2fa4ff3245$export$79d03e6f07528b0a; });
/**
 * This is the type definition for the submitFormHack as-is, so that I can re-use it in the replacement function.
 */ 
var $1Fos3 = parcelRequire("1Fos3");
function $dceb0d2fa4ff3245$export$2e2bcd8739ae039({ method: method, action: action = '', payload: payload, skipSanitizationKeys: skipSanitizationKeys = [] }) {
    const form = document.createElement('form');
    form.style.display = 'none';
    form.method = method;
    form.action = action;
    if (payload) Object.entries(payload).filter(([, value])=>value != null).forEach(([name, value])=>{
        const input = document.createElement('input');
        input.name = $dceb0d2fa4ff3245$var$sanitizeInput(name);
        input.value = skipSanitizationKeys.includes(name) ? String(value) : $dceb0d2fa4ff3245$var$sanitizeInput(String(value));
        form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
}
/**
 * This function takes an input string, assigns it to the textContent property of a newly created div,
 * and then returns the sanitized HTML content of the div. Since textContent does not parse HTML,
 * any harmful tags or scripts in the input will be treated as plain text, not as code.
 *
 * i.e.:
 * sanitizeInput("<script>window.alert('hi')</script>") -> "&lt;script&gt;window.alert('hi')&lt;/script&gt;"
 *
 * https://asecurityteam.atlassian.net/browse/VULN-1229071
 */ function $dceb0d2fa4ff3245$var$sanitizeInput(input) {
    const div = document.createElement('div');
    div.textContent = input;
    return div.innerHTML;
}
function $dceb0d2fa4ff3245$export$79d03e6f07528b0a({ method: method = 'POST', action: action = '', payload: payload, csrfToken: csrfToken, enablePassingCookies: enablePassingCookies = false }) {
    const requestPromise = fetch(action, {
        method: method,
        headers: (0, $1Fos3._)({
            'Content-Type': 'application/json'
        }, csrfToken ? {
            'X-CSRF-TOKEN': csrfToken
        } : {}, enablePassingCookies ? {
            credentials: 'same-origin'
        } : {}),
        body: JSON.stringify(payload)
    });
    return requestPromise;
}

});



parcelRegister("h5BP4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "pageId", function () { return $6091f1cc775a91f8$export$703ba2e7ea526c1b; });
$parcel$export(module.exports, "stepUpSsoLoader", function () { return $6091f1cc775a91f8$export$947a31480e10f4f8; });
$parcel$export(module.exports, "StepUpSsoPage", function () { return $6091f1cc775a91f8$export$61fae207a78c2e53; });
$parcel$export(module.exports, "default", function () { return $6091f1cc775a91f8$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $8KhCJ = parcelRequire("8KhCJ");

var $gs2u7 = parcelRequire("gs2u7");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $bE8z6 = parcelRequire("bE8z6");

var $8Bf3D = parcelRequire("8Bf3D");

var $7eeh4 = parcelRequire("7eeh4");

var $2aGBJ = parcelRequire("2aGBJ");

var $kYCh8 = parcelRequire("kYCh8");

var $6d87w = parcelRequire("6d87w");
var $l2v8Y = parcelRequire("l2v8Y");

var $1V2cH = parcelRequire("1V2cH");

var $9jjaN = parcelRequire("9jjaN");

var $6e88g = parcelRequire("6e88g");

var $cLysE = parcelRequire("cLysE");

var $jcdti = parcelRequire("jcdti");

var $2ZKUQ = parcelRequire("2ZKUQ");

var $49Pnv = parcelRequire("49Pnv");

var $1569T = parcelRequire("1569T");
var $4PXNb = parcelRequire("4PXNb");
var $e46Ts = parcelRequire("e46Ts");
var $aLzB7 = parcelRequire("aLzB7");
var $5hmIF = parcelRequire("5hmIF");
var $63UEK = parcelRequire("63UEK");

var $jtgLn = parcelRequire("jtgLn");

var $9uXJ3 = parcelRequire("9uXJ3");

var $5e2bj = parcelRequire("5e2bj");

var $kpg9c = parcelRequire("kpg9c");

var $3f4xr = parcelRequire("3f4xr");
let $6091f1cc775a91f8$var$_ = (t)=>t, $6091f1cc775a91f8$var$t, $6091f1cc775a91f8$var$t1;
const $6091f1cc775a91f8$export$703ba2e7ea526c1b = 'stepUpSsoScreen';
const $6091f1cc775a91f8$var$SecondaryLinkWrapper = (0, $9jjaN.default).ul($6091f1cc775a91f8$var$t || ($6091f1cc775a91f8$var$t = $6091f1cc775a91f8$var$_`
  margin-top: ${0}px;
`), (0, $6e88g.gridSize)());
const $6091f1cc775a91f8$var$PadlockImageContainer = (0, $9jjaN.default).div($6091f1cc775a91f8$var$t1 || ($6091f1cc775a91f8$var$t1 = $6091f1cc775a91f8$var$_`
  background: url(${0}) no-repeat center bottom;
  background-size: contain;
  height: 140px;
  margin: ${0}px 0 ${0}px;
`), (0, (/*@__PURE__*/$parcel$interopDefault($jcdti))), (0, $6e88g.gridSize)(), (0, $6e88g.gridSize)() * 2);
async function $6091f1cc775a91f8$export$947a31480e10f4f8({ request: request }) {
    if (!await (0, $3f4xr.checkFeatureGateOnceInitialized)((0, $kpg9c.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $5e2bj.fetchPageState)('/rest/step-up/sso/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--mfa'
        ]
    });
}
const $6091f1cc775a91f8$export$61fae207a78c2e53 = ()=>{
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const oidcContext = (0, $2aGBJ.useAppSelector)((state)=>state.microbranding.oidcContext);
    const ssoSamlRedirectUrl = (0, $2aGBJ.useAppSelector)((state)=>state.stepUpSso.ssoRedirectUrl);
    const idpDetails = (0, $2aGBJ.useAppSelector)((state)=>state.stepUpSso.idp);
    const isMobile = (0, $7eeh4.isMobileOidc)(oidcContext);
    const { search: search } = (0, $l2v8Y.useLocation)();
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    const returnLoginLink = `/login/select-account${search}`;
    const intl = (0, $leG06.default)();
    const [isWarningModalOpen, setWarningModalOpen] = (0, $91i6m.useState)(false);
    (0, $5e2bj.usePageStateLoader)();
    const eventFlowValue = idpDetails.trusted ? 'trusted-idp' : 'untrusted-idp';
    const shouldOpenWarningModalOnVerify = !idpDetails.trusted && ssoSamlRedirectUrl;
    (0, $1V2cH.usePageViewedEvent)($6091f1cc775a91f8$export$703ba2e7ea526c1b, {
        flow: eventFlowValue
    });
    (0, $1V2cH.useOperationalEvent)({
        page: $6091f1cc775a91f8$export$703ba2e7ea526c1b,
        action: `loadStepUpSsoPageSuccessful`,
        subject: 'sli'
    });
    const handleVerify = ()=>{
        analyticsClient.buttonClickedEvent($6091f1cc775a91f8$export$703ba2e7ea526c1b, 'verify', {
            flow: eventFlowValue
        });
        if (ssoSamlRedirectUrl) navigate(ssoSamlRedirectUrl);
        else {
            (0, $49Pnv.captureErrorMessage)('StepUpSsoPage verify failed: ssoSamlRedirectUrl not available');
            navigate('/login?errorCode=step_up_sso_saml_redirect_url_not_available');
        }
    };
    const openWarningModal = (0, $91i6m.useCallback)(()=>{
        analyticsClient.buttonClickedEvent($6091f1cc775a91f8$export$703ba2e7ea526c1b, 'verify', {
            flow: eventFlowValue
        });
        setWarningModalOpen(true);
    }, [
        analyticsClient,
        eventFlowValue
    ]);
    const closeWarningModal = (0, $91i6m.useCallback)(()=>{
        analyticsClient.buttonClickedEvent($6091f1cc775a91f8$export$703ba2e7ea526c1b, 'close-warning-modal');
        setWarningModalOpen(false);
    }, [
        analyticsClient
    ]);
    const handleReturnToLogin = ()=>{
        analyticsClient.linkClickedEvent($6091f1cc775a91f8$export$703ba2e7ea526c1b, 'switchAccount');
    };
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8KhCJ.default), {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)("title", {
                    children: intl.formatMessage((0, $kYCh8.default).stepUpSsoHeader)
                })
            }),
            /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $gs2u7.default), {
                pageId: $6091f1cc775a91f8$export$703ba2e7ea526c1b,
                header: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $b2I6k._)((0, $1Fos3._)({}, (0, $kYCh8.default).stepUpSsoHeader), {
                    tagName: "h5"
                })),
                footer: /*#__PURE__*/ (0, $4ZSso.jsxs)("ul", {
                    className: "fine-print",
                    children: [
                        /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $bE8z6.PrivacyPolicyLink), {
                                isMobileLink: isMobile
                            })
                        }),
                        /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8Bf3D.default), {}),
                        /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $bE8z6.UserNoticeLink), {
                                isMobileLink: isMobile
                            })
                        })
                    ]
                }),
                whiteboxFooter: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4ZSso.Fragment), {
                    children: !isMobile && /*#__PURE__*/ (0, $4ZSso.jsx)("ul", {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                            children: /*#__PURE__*/ (0, $4ZSso.jsx)($6091f1cc775a91f8$var$SecondaryLinkWrapper, {
                                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6d87w.Link), {
                                    id: "return-to-login",
                                    "data-testid": "return-to-login",
                                    to: returnLoginLink,
                                    onClick: handleReturnToLogin,
                                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $kYCh8.default).stepUpSsoReturnToLogin))
                                })
                            })
                        })
                    })
                }),
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)($6091f1cc775a91f8$var$PadlockImageContainer, {}),
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $b2I6k._)((0, $1Fos3._)({}, (0, $kYCh8.default).stepUpSsoDescription1), {
                        tagName: "p"
                    })),
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $b2I6k._)((0, $1Fos3._)({}, (0, $kYCh8.default).stepUpSsoDescription2), {
                        tagName: "p"
                    })),
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $2ZKUQ.default), {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                            id: "step-up-sso-button",
                            appearance: "primary",
                            type: 'button',
                            onClick: shouldOpenWarningModalOnVerify ? openWarningModal : handleVerify,
                            isFullWidth: true,
                            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $kYCh8.default).stepUpSsoVerifyButton))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $63UEK.default), {
                children: isWarningModalOpen && /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $1569T.default), {
                    onClose: closeWarningModal,
                    width: "small",
                    children: [
                        /*#__PURE__*/ (0, $4ZSso.jsx)((0, $aLzB7.default), {
                            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $5hmIF.default), {
                                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $kYCh8.default).stepUpSsoWarningModalHeader))
                            })
                        }),
                        /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4PXNb.default), {
                            children: [
                                /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $b2I6k._)((0, $1Fos3._)({}, (0, $kYCh8.default).stepUpSsoWarningModalDescription1), {
                                    tagName: "p",
                                    values: {
                                        idpRedirectLocation: /*#__PURE__*/ (0, $4ZSso.jsx)("strong", {
                                            children: idpDetails.humanReadableRedirectLocation
                                        })
                                    }
                                })),
                                /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $b2I6k._)((0, $1Fos3._)({}, (0, $kYCh8.default).stepUpSsoWarningModalDescription2), {
                                    tagName: "p"
                                }))
                            ]
                        }),
                        /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $e46Ts.default), {
                            children: [
                                /*#__PURE__*/ (0, $4ZSso.jsx)((0, $jtgLn.default), {
                                    appearance: "subtle",
                                    onClick: closeWarningModal,
                                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $kYCh8.default).stepUpWarningCancelButton))
                                }),
                                /*#__PURE__*/ (0, $4ZSso.jsx)((0, $jtgLn.default), {
                                    id: "continue-step-up",
                                    appearance: "primary",
                                    onClick: handleVerify,
                                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $kYCh8.default).stepUpSsoWarningLogInButton))
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $6091f1cc775a91f8$export$2e2bcd8739ae039 = $6091f1cc775a91f8$export$61fae207a78c2e53;

});
parcelRegister("kYCh8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7e46c55c65f2f98$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $f7e46c55c65f2f98$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    stepUpSsoHeader: {
        id: 'stepUp.sso.header',
        defaultMessage: 'Verify your identity'
    },
    stepUpSsoReturnToLogin: {
        id: 'stepUp.sso.return.to.login',
        defaultMessage: 'Need to log in to a different account?'
    },
    stepUpSsoDescription1: {
        id: 'stepUp.sso.description1',
        defaultMessage: 'To access this content, you need to log in with single sign-on and verify your identity.'
    },
    stepUpSsoDescription2: {
        id: 'stepUp.sso.description2',
        defaultMessage: "If you\u2019re unable to log in, contact the admin."
    },
    stepUpSsoVerifyButton: {
        id: 'stepUp.sso.button.verify',
        defaultMessage: 'Verify'
    },
    stepUpSsoWarningModalHeader: {
        id: 'stepUp.sso.warning.modal.header',
        defaultMessage: 'Log in to verify identity'
    },
    stepUpSsoWarningModalDescription1: {
        id: 'stepUp.sso.warning.modal.description',
        defaultMessage: "You\u2019re about to leave Atlassian with this external link {idpRedirectLocation}"
    },
    stepUpSsoWarningModalDescription2: {
        id: 'stepUp.sso.warning.modal.description2',
        defaultMessage: 'If you trust the link, then continue to log in with single sign-on.'
    },
    stepUpSsoWarningLogInButton: {
        id: 'stepUp.sso.warning.log.in.button',
        defaultMessage: 'Log in'
    },
    stepUpWarningCancelButton: {
        id: 'stepUp.warning.cancel.button',
        defaultMessage: 'Cancel'
    }
});

});

parcelRegister("1569T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c9b090652ecb0f3$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $91i6m = parcelRequire("91i6m");

var $kpsg0 = parcelRequire("kpsg0");
function $0c9b090652ecb0f3$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $kpsg0.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, props, {
        isFullScreen: false
    }));
}

});
parcelRegister("kpsg0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edbc0fb781854221$export$2e2bcd8739ae039; });
/* modal-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $rLDqE = parcelRequire("rLDqE");

var $llFLf = parcelRequire("llFLf");

var $koa2c = parcelRequire("koa2c");

var $8dZTS = parcelRequire("8dZTS");

var $6A0cm = parcelRequire("6A0cm");

var $aHMp1 = parcelRequire("aHMp1");

var $8iz5R = parcelRequire("8iz5R");

var $lLIDD = parcelRequire("lLIDD");

var $l9xBx = parcelRequire("l9xBx");

var $2moRh = parcelRequire("2moRh");

var $cU6yI = parcelRequire("cU6yI");

var $9UiWN = parcelRequire("9UiWN");
var $edbc0fb781854221$var$fillScreenStyles = null;
var $edbc0fb781854221$var$allowlistElements = function allowlistElements(element, callback) {
    // Allow focus to reach elements outside the modal:
    // if AUI dialog is allowListed and visible
    if (!!document.querySelector('.aui-blanket:not([hidden])')) return false;
    // allows to pass a callback function to allow elements be ignored by focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
};
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $edbc0fb781854221$var$InternalModalWrapper = function InternalModalWrapper(props) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, focusLockAllowlist = props.focusLockAllowlist, _props$shouldCloseOnE = props.shouldCloseOnEscapePress, shouldCloseOnEscapePress = _props$shouldCloseOnE === void 0 ? true : _props$shouldCloseOnE, _props$shouldCloseOnO = props.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _props$shouldCloseOnO === void 0 ? true : _props$shouldCloseOnO, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, _props$shouldReturnFo = props.shouldReturnFocus, shouldReturnFocus = _props$shouldReturnFo === void 0 ? true : _props$shouldReturnFo, stackIndexOverride = props.stackIndex, providedOnClose = props.onClose, _props$onStackChange = props.onStackChange, onStackChange = _props$onStackChange === void 0 ? (0, $6A0cm.default) : _props$onStackChange, isBlanketHidden = props.isBlanketHidden, children = props.children, height = props.height, width = props.width, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, label = props.label, testId = props.testId, isFullScreen = props.isFullScreen;
    var calculatedStackIndex = (0, $2moRh.default)({
        onStackChange: onStackChange
    });
    var stackIndex = stackIndexOverride || calculatedStackIndex;
    var isForeground = stackIndex === 0;
    // When a user supplies a ref to focus we skip auto focus via react-focus-lock
    var autoFocusLock = typeof autoFocus === 'boolean' ? autoFocus : false;
    var onCloseHandler = (0, $koa2c.usePlatformLeafEventHandler)({
        fn: providedOnClose || (0, $6A0cm.default),
        action: 'closed',
        componentName: 'modalDialog',
        packageName: "@atlaskit/modal-dialog",
        packageVersion: "0.0.0-development"
    });
    var onBlanketClicked = (0, $91i6m.useCallback)(function(e) {
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]);
    // This ensures to prevent additional re-renders while nothing is passed to focusLockAllowlist explicitly.
    var allowListCallback = (0, $91i6m.useCallback)(function(element) {
        return $edbc0fb781854221$var$allowlistElements(element, focusLockAllowlist);
    }, [
        focusLockAllowlist
    ]);
    (0, $cU6yI.default)();
    var modalDialogWithBlanket = /*#__PURE__*/ $91i6m.createElement((0, $8dZTS.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && "".concat(testId, "--blanket")
    }, /*#__PURE__*/ $91i6m.createElement((0, $9UiWN.default), {
        testId: testId,
        label: label,
        autoFocus: autoFocus,
        stackIndex: stackIndex,
        onClose: onCloseHandler,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
        shouldScrollInViewport: shouldScrollInViewport,
        height: height,
        width: width,
        onCloseComplete: onCloseComplete,
        onOpenComplete: onOpenComplete,
        hasProvidedOnClose: Boolean(providedOnClose),
        isFullScreen: isFullScreen
    }, children));
    var returnFocus = true;
    var onDeactivation;
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = function onDeactivation() {
        window.setTimeout(function() {
            var _shouldReturnFocus$cu;
            (_shouldReturnFocus$cu = shouldReturnFocus.current) === null || _shouldReturnFocus$cu === void 0 || _shouldReturnFocus$cu.focus();
        }, 0);
    };
    return /*#__PURE__*/ $91i6m.createElement((0, $aHMp1.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ $91i6m.createElement((0, $lLIDD.default), {
        zIndex: (0, $l9xBx.layers).modal()
    }, /*#__PURE__*/ $91i6m.createElement((0, $8iz5R.default), null, function(fadeInProps) {
        return /*#__PURE__*/ $91i6m.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, fadeInProps, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $9gzWK.default)([
                "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0",
                fadeInProps.className
            ]),
            "aria-hidden": !isForeground
        }), /*#__PURE__*/ $91i6m.createElement((0, $rLDqE.default), {
            autoFocus: autoFocusLock,
            returnFocus: returnFocus,
            onDeactivation: onDeactivation,
            whiteList: allowListCallback
        }, /*#__PURE__*/ $91i6m.createElement((0, (/*@__PURE__*/$parcel$interopDefault($llFLf))), null), shouldScrollInViewport ? /*#__PURE__*/ $91i6m.createElement((0, $llFLf.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket));
    })));
};
var $edbc0fb781854221$export$2e2bcd8739ae039 = $edbc0fb781854221$var$InternalModalWrapper;

});
parcelRegister("rLDqE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0537790a2bc4f29f$export$2e2bcd8739ae039; });

var $XiY14 = parcelRequire("XiY14");

var $0537790a2bc4f29f$export$2e2bcd8739ae039 = (0, $XiY14.default);

});
parcelRegister("XiY14", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b243941337fffc9$export$2e2bcd8739ae039; });

var $dDDP6 = parcelRequire("dDDP6");

var $kOzMk = parcelRequire("kOzMk");

var $91i6m = parcelRequire("91i6m");

var $aJKJb = parcelRequire("aJKJb");

var $a5M5D = parcelRequire("a5M5D");
var $0b243941337fffc9$var$FocusLockCombination = /*#__PURE__*/ $91i6m.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $91i6m.createElement((0, $aJKJb.default), (0, $kOzMk.default)({
        sideCar: (0, $a5M5D.default),
        ref: ref
    }, props));
});
var $0b243941337fffc9$var$_ref = (0, $aJKJb.default).propTypes || {}, $0b243941337fffc9$var$sideCar = $0b243941337fffc9$var$_ref.sideCar, $0b243941337fffc9$var$propTypes = (0, $dDDP6.default)($0b243941337fffc9$var$_ref, [
    "sideCar"
]);
$0b243941337fffc9$var$FocusLockCombination.propTypes = {};
var $0b243941337fffc9$export$2e2bcd8739ae039 = $0b243941337fffc9$var$FocusLockCombination;

});
parcelRegister("aJKJb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d125a8052a6b184$export$2e2bcd8739ae039; });

var $kOzMk = parcelRequire("kOzMk");

var $91i6m = parcelRequire("91i6m");


var $dwmH2 = parcelRequire("dwmH2");

var $c4nM9 = parcelRequire("c4nM9");

var $2meod = parcelRequire("2meod");

var $4sgg2 = parcelRequire("4sgg2");

var $3Xj3a = parcelRequire("3Xj3a");
var $7d125a8052a6b184$var$emptyArray = [];
var $7d125a8052a6b184$var$FocusLock = /*#__PURE__*/ $91i6m.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $91i6m.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $91i6m.useRef();
    var isActive = $91i6m.useRef(false);
    var originalFocusedElement = $91i6m.useRef(null);
    var _React$useState2 = $91i6m.useState({}), update = _React$useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $7d125a8052a6b184$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState3 = $91i6m.useState({}), id = _React$useState3[0];
    var onActivation = $91i6m.useCallback(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $91i6m.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = $91i6m.useCallback(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = $91i6m.useCallback(function(event) {
        if (isActive.current) (0, $4sgg2.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $4sgg2.mediumBlur).useMedium;
    var setObserveNode = $91i6m.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $kOzMk.default)((_extends2 = {}, _extends2[$dwmH2.FOCUS_DISABLED] = disabled && 'disabled', _extends2[$dwmH2.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $c4nM9.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = $91i6m.useMemo(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ $91i6m.createElement($91i6m.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ $91i6m.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $2meod.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ $91i6m.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $2meod.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ $91i6m.createElement(SideCar, {
        id: id,
        sideCar: (0, $4sgg2.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions
    }), /*#__PURE__*/ $91i6m.createElement(Container, (0, $kOzMk.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ $91i6m.createElement((0, $3Xj3a.focusScope).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ $91i6m.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $2meod.hiddenGuard)
    }));
});
$7d125a8052a6b184$var$FocusLock.propTypes = {};
var $7d125a8052a6b184$export$2e2bcd8739ae039 = $7d125a8052a6b184$var$FocusLock;

});
parcelRegister("dwmH2", function(module, exports) {

$parcel$export(module.exports, "FOCUS_GROUP", function () { return $9d7fdde5625450db$export$4f9a06cb7441a087; });
$parcel$export(module.exports, "FOCUS_DISABLED", function () { return $9d7fdde5625450db$export$aeda8252e54b50f7; });
$parcel$export(module.exports, "FOCUS_ALLOW", function () { return $9d7fdde5625450db$export$54ecf528c58f9ef6; });
$parcel$export(module.exports, "FOCUS_AUTO", function () { return $9d7fdde5625450db$export$70e9b4a1820af101; });
$parcel$export(module.exports, "FOCUS_NO_AUTOFOCUS", function () { return $9d7fdde5625450db$export$134ebef29fd94853; });
/**
 * defines a focus group
 */ var $9d7fdde5625450db$export$4f9a06cb7441a087 = 'data-focus-lock';
var $9d7fdde5625450db$export$aeda8252e54b50f7 = 'data-focus-lock-disabled';
var $9d7fdde5625450db$export$54ecf528c58f9ef6 = 'data-no-focus-lock';
var $9d7fdde5625450db$export$70e9b4a1820af101 = 'data-autofocus-inside';
var $9d7fdde5625450db$export$134ebef29fd94853 = 'data-no-autofocus';

});

parcelRegister("c4nM9", function(module, exports) {

$parcel$export(module.exports, "useMergeRefs", function () { return $8c984d1df58d471f$export$74665b213cb5c4cf; });

var $91i6m = parcelRequire("91i6m");

var $cxQuC = parcelRequire("cxQuC");

var $ljWMy = parcelRequire("ljWMy");
var $8c984d1df58d471f$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $91i6m.useLayoutEffect : $91i6m.useEffect;
var $8c984d1df58d471f$var$currentValues = new WeakMap();
function $8c984d1df58d471f$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $ljWMy.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $cxQuC.assignRef)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $8c984d1df58d471f$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $8c984d1df58d471f$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $cxQuC.assignRef)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $cxQuC.assignRef)(ref, current_1);
            });
        }
        $8c984d1df58d471f$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

});
parcelRegister("cxQuC", function(module, exports) {

$parcel$export(module.exports, "assignRef", function () { return $92214915f68193ef$export$d734136a7b018efe; });
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $92214915f68193ef$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("ljWMy", function(module, exports) {

$parcel$export(module.exports, "useCallbackRef", function () { return $04016f5be33112b6$export$25bec8c6f54ee79a; });

var $91i6m = parcelRequire("91i6m");
function $04016f5be33112b6$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $91i6m.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("2meod", function(module, exports) {

$parcel$export(module.exports, "hiddenGuard", function () { return $1b78cc554c9c371a$export$b8c7b07253306600; });

var $91i6m = parcelRequire("91i6m");

var $1b78cc554c9c371a$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $1b78cc554c9c371a$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ $91i6m.createElement($91i6m.Fragment, null, /*#__PURE__*/ $91i6m.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $1b78cc554c9c371a$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $91i6m.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $1b78cc554c9c371a$export$b8c7b07253306600
    }));
};
$1b78cc554c9c371a$var$InFocusGuard.propTypes = {};
var $1b78cc554c9c371a$export$2e2bcd8739ae039 = $1b78cc554c9c371a$var$InFocusGuard;

});

parcelRegister("4sgg2", function(module, exports) {

$parcel$export(module.exports, "mediumFocus", function () { return $33e6635d7b11228a$export$5733e022b1d538cb; });
$parcel$export(module.exports, "mediumBlur", function () { return $33e6635d7b11228a$export$b3e9a9312f73723c; });
$parcel$export(module.exports, "mediumEffect", function () { return $33e6635d7b11228a$export$3a1d52767cbc07b8; });
$parcel$export(module.exports, "mediumSidecar", function () { return $33e6635d7b11228a$export$892cbf28e5518020; });

var $kjp9b = parcelRequire("kjp9b");
var $33e6635d7b11228a$export$5733e022b1d538cb = (0, $kjp9b.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $33e6635d7b11228a$export$b3e9a9312f73723c = (0, $kjp9b.createMedium)();
var $33e6635d7b11228a$export$3a1d52767cbc07b8 = (0, $kjp9b.createMedium)();
var $33e6635d7b11228a$export$892cbf28e5518020 = (0, $kjp9b.createSidecarMedium)({
    async: true,
    ssr: typeof document !== 'undefined'
});

});
parcelRegister("kjp9b", function(module, exports) {

$parcel$export(module.exports, "createMedium", function () { return $ec9916b1bfba639b$export$9ffbfcaf067b02c6; });
$parcel$export(module.exports, "createSidecarMedium", function () { return $ec9916b1bfba639b$export$e13ec7dd7a14088d; });

var $2HjL4 = parcelRequire("2HjL4");
function $ec9916b1bfba639b$var$ItoI(a) {
    return a;
}
function $ec9916b1bfba639b$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $ec9916b1bfba639b$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $ec9916b1bfba639b$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $ec9916b1bfba639b$var$ItoI;
    return $ec9916b1bfba639b$var$innerCreateMedium(defaults, middleware);
}
function $ec9916b1bfba639b$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $ec9916b1bfba639b$var$innerCreateMedium(null);
    medium.options = (0, $2HjL4.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

});


parcelRegister("3Xj3a", function(module, exports) {

$parcel$export(module.exports, "focusScope", function () { return $2e15a8ba847f72a5$export$f5272e9b1168239c; });

var $91i6m = parcelRequire("91i6m");
var $2e15a8ba847f72a5$export$f5272e9b1168239c = /*#__PURE__*/ (0, $91i6m.createContext)(undefined);

});


parcelRegister("a5M5D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $758faca86306e40c$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");


var $fRS9w = parcelRequire("fRS9w");

var $arAUI = parcelRequire("arAUI");
var $5TyBn = parcelRequire("5TyBn");
var $4rAw6 = parcelRequire("4rAw6");
var $kZ7Fy = parcelRequire("kZ7Fy");
var $ddtW5 = parcelRequire("ddtW5");parcelRequire("uu7sA");
var $kCnXR = parcelRequire("kCnXR");

var $furt5 = parcelRequire("furt5");

var $4sgg2 = parcelRequire("4sgg2");
var $758faca86306e40c$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $758faca86306e40c$var$isFreeFocus = function isFreeFocus() {
    return $758faca86306e40c$var$focusOnBody() || (0, $ddtW5.focusIsHidden)();
};
var $758faca86306e40c$var$lastActiveTrap = null;
var $758faca86306e40c$var$lastActiveFocus = null;
var $758faca86306e40c$var$lastPortaledElement = null;
var $758faca86306e40c$var$focusWasOutsideWindow = false;
var $758faca86306e40c$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $758faca86306e40c$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($758faca86306e40c$var$lastActiveTrap.whiteList || $758faca86306e40c$var$defaultWhitelist)(activeElement);
};
var $758faca86306e40c$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $758faca86306e40c$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $758faca86306e40c$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $758faca86306e40c$var$lastPortaledElement && $758faca86306e40c$var$lastPortaledElement.portaledElement === element;
};
function $758faca86306e40c$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $758faca86306e40c$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($758faca86306e40c$var$focusWasOutsideWindow);
    return $758faca86306e40c$var$focusWasOutsideWindow === 'meanwhile';
};
var $758faca86306e40c$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $758faca86306e40c$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $758faca86306e40c$var$checkInHost(activeElement, area, area);
    });
};
var $758faca86306e40c$var$activateTrap = function activateTrap() {
    var result = false;
    if ($758faca86306e40c$var$lastActiveTrap) {
        var _lastActiveTrap = $758faca86306e40c$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
        var workingNode = observed || $758faca86306e40c$var$lastPortaledElement && $758faca86306e40c$var$lastPortaledElement.portaledElement;
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $furt5.extractRef)).filter(Boolean));
            if (!activeElement || $758faca86306e40c$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || $758faca86306e40c$var$focusWasOutside(crossFrame) || !$758faca86306e40c$var$isFreeFocus() || !$758faca86306e40c$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $kZ7Fy.focusInside)(workingArea) || activeElement && $758faca86306e40c$var$withinHost(activeElement, workingArea) || $758faca86306e40c$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$758faca86306e40c$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $kCnXR.moveFocusInside)(workingArea, $758faca86306e40c$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $758faca86306e40c$var$lastPortaledElement = {};
                        }
                    }
                    $758faca86306e40c$var$focusWasOutsideWindow = false;
                    $758faca86306e40c$var$lastActiveFocus = document && document.activeElement;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $5TyBn.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref) {
                    var node = _ref.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref2) {
                        var guard = _ref2.guard, node = _ref2.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref3) {
                        var node = _ref3.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $758faca86306e40c$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $758faca86306e40c$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $758faca86306e40c$var$onTrap = function onTrap(event) {
    if ($758faca86306e40c$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $758faca86306e40c$var$onBlur = function onBlur() {
    return (0, $furt5.deferAction)($758faca86306e40c$var$activateTrap);
};
var $758faca86306e40c$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $758faca86306e40c$var$recordPortal(currentNode, source);
};
var $758faca86306e40c$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $758faca86306e40c$var$FocusTrap = function FocusTrap(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ $91i6m.createElement("div", {
        onBlur: $758faca86306e40c$var$onBlur,
        onFocus: $758faca86306e40c$var$onFocus
    }, children);
};
$758faca86306e40c$var$FocusTrap.propTypes = {};
var $758faca86306e40c$var$onWindowBlur = function onWindowBlur() {
    $758faca86306e40c$var$focusWasOutsideWindow = 'just';
    (0, $furt5.deferAction)(function() {
        $758faca86306e40c$var$focusWasOutsideWindow = 'meanwhile';
    });
};
var $758faca86306e40c$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $758faca86306e40c$var$onTrap);
    document.addEventListener('focusout', $758faca86306e40c$var$onBlur);
    window.addEventListener('blur', $758faca86306e40c$var$onWindowBlur);
};
var $758faca86306e40c$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $758faca86306e40c$var$onTrap);
    document.removeEventListener('focusout', $758faca86306e40c$var$onBlur);
    window.removeEventListener('blur', $758faca86306e40c$var$onWindowBlur);
};
function $758faca86306e40c$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref5) {
        var disabled = _ref5.disabled;
        return !disabled;
    });
}
var $758faca86306e40c$var$focusLockAPI = {
    moveFocusInside: (0, $kCnXR.moveFocusInside),
    focusInside: (0, $kZ7Fy.focusInside),
    focusNextElement: (0, $4rAw6.focusNextElement),
    focusPrevElement: (0, $4rAw6.focusPrevElement),
    focusFirstElement: (0, $4rAw6.focusFirstElement),
    focusLastElement: (0, $4rAw6.focusLastElement),
    captureFocusRestore: (0, $arAUI.captureFocusRestore)
};
function $758faca86306e40c$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$758faca86306e40c$var$lastActiveTrap) $758faca86306e40c$var$attachHandler();
    var lastTrap = $758faca86306e40c$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $758faca86306e40c$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref6) {
            var id = _ref6.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $758faca86306e40c$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($758faca86306e40c$var$focusLockAPI);
        $758faca86306e40c$var$activateTrap(true);
        (0, $furt5.deferAction)($758faca86306e40c$var$activateTrap);
    } else {
        $758faca86306e40c$var$detachHandler();
        $758faca86306e40c$var$lastActiveFocus = null;
    }
}
(0, $4sgg2.mediumFocus).assignSyncMedium($758faca86306e40c$var$onFocus);
(0, $4sgg2.mediumBlur).assignMedium($758faca86306e40c$var$onBlur);
(0, $4sgg2.mediumEffect).assignMedium(function(cb) {
    return cb($758faca86306e40c$var$focusLockAPI);
});
var $758faca86306e40c$export$2e2bcd8739ae039 = (0, $fRS9w.default)($758faca86306e40c$var$reducePropsToState, $758faca86306e40c$var$handleStateChangeOnClient)($758faca86306e40c$var$FocusWatcher);

});
parcelRegister("fRS9w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8d5cfcfdde44b57$export$2e2bcd8739ae039; });

var $4N4zR = parcelRequire("4N4zR");

var $bSych = parcelRequire("bSych");

var $91i6m = parcelRequire("91i6m");
function $b8d5cfcfdde44b57$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $4N4zR.default)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $91i6m.PureComponent));
        (0, $bSych.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $b8d5cfcfdde44b57$export$2e2bcd8739ae039 = $b8d5cfcfdde44b57$var$withSideEffect;

});
parcelRegister("4N4zR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37cf4a04934cf61c$export$2e2bcd8739ae039; });

var $dgOR9 = parcelRequire("dgOR9");
function $37cf4a04934cf61c$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $dgOR9.default)(t, o);
}

});
parcelRegister("dgOR9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a9438016fccfd5d$export$2e2bcd8739ae039; });
function $9a9438016fccfd5d$export$2e2bcd8739ae039(t, e) {
    return $9a9438016fccfd5d$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $9a9438016fccfd5d$export$2e2bcd8739ae039(t, e);
}

});



parcelRegister("arAUI", function(module, exports) {

$parcel$export(module.exports, "captureFocusRestore", function () { return $79a90f49b199fe2f$export$d357db6e554ff59a; });

var $jvTdj = parcelRequire("jvTdj");
function $79a90f49b199fe2f$var$weakRef(value) {
    if (!value) return null;
    // #68 Safari 14.1 dont have it yet
    // FIXME: remove in 2025
    if (typeof WeakRef === 'undefined') return function() {
        return value || null;
    };
    var w = value ? new WeakRef(value) : null;
    return function() {
        return (w === null || w === void 0 ? void 0 : w.deref()) || null;
    };
}
var $79a90f49b199fe2f$export$5061a7725be48ff9 = function(element) {
    if (!element) return null;
    var stack = [];
    var currentElement = element;
    while(currentElement && currentElement !== document.body){
        stack.push({
            current: $79a90f49b199fe2f$var$weakRef(currentElement),
            parent: $79a90f49b199fe2f$var$weakRef(currentElement.parentElement),
            left: $79a90f49b199fe2f$var$weakRef(currentElement.previousElementSibling),
            right: $79a90f49b199fe2f$var$weakRef(currentElement.nextElementSibling)
        });
        currentElement = currentElement.parentElement;
    }
    return {
        element: $79a90f49b199fe2f$var$weakRef(element),
        stack: stack,
        ownerDocument: element.ownerDocument
    };
};
var $79a90f49b199fe2f$var$restoreFocusTo = function(location) {
    var _a, _b, _c, _d, _e;
    if (!location) return undefined;
    var stack = location.stack, ownerDocument = location.ownerDocument;
    var visibilityCache = new Map();
    for(var _i = 0, stack_1 = stack; _i < stack_1.length; _i++){
        var line = stack_1[_i];
        var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
        // is it still here?
        if (parent_1 && ownerDocument.contains(parent_1)) {
            var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
            var savedCurrent = line.current();
            var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
            var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
            var focusables = (0, $jvTdj.getTabbableNodes)([
                parent_1
            ], visibilityCache);
            var aim = // that is element itself
            (_e = (_d = current !== null && current !== void 0 ? current : // or something in it's place
            left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : // or somebody to the right, still close enough
            right) !== null && _e !== void 0 ? _e : // or somebody to the left, something?
            left;
            while(aim){
                for(var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++){
                    var focusable = focusables_1[_f];
                    if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) return focusable.node;
                }
                aim = aim.nextElementSibling;
            }
            if (focusables.length) // if parent contains a focusable - move there
            return focusables[0].node;
        }
    }
    // nothing matched
    return undefined;
};
var $79a90f49b199fe2f$export$d357db6e554ff59a = function(targetElement) {
    var location = $79a90f49b199fe2f$export$5061a7725be48ff9(targetElement);
    return function() {
        return $79a90f49b199fe2f$var$restoreFocusTo(location);
    };
};

});
parcelRegister("jvTdj", function(module, exports) {

$parcel$export(module.exports, "filterAutoFocusable", function () { return $e34bbddcdd6ba802$export$2f70373d403a5d2b; });
$parcel$export(module.exports, "getTabbableNodes", function () { return $e34bbddcdd6ba802$export$3738e313571e2ad2; });
$parcel$export(module.exports, "getFocusableNodes", function () { return $e34bbddcdd6ba802$export$493d05a3a8e6532d; });
$parcel$export(module.exports, "parentAutofocusables", function () { return $e34bbddcdd6ba802$export$dc26309a71d1ce47; });
$parcel$export(module.exports, "contains", function () { return $e34bbddcdd6ba802$export$2344b14b097df817; });

var $8PD3W = parcelRequire("8PD3W");

var $ayxgx = parcelRequire("ayxgx");

var $5KBS9 = parcelRequire("5KBS9");

var $hQUwQ = parcelRequire("hQUwQ");
var $e34bbddcdd6ba802$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $8PD3W.toArray)(nodes).filter(function(node) {
        return (0, $ayxgx.isVisibleCached)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $ayxgx.notHiddenInput)(node);
    });
};
var $e34bbddcdd6ba802$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $8PD3W.toArray)(nodes).filter(function(node) {
        return (0, $ayxgx.isAutoFocusAllowedCached)(cache, node);
    });
};
var $e34bbddcdd6ba802$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $5KBS9.orderByTabIndex)($e34bbddcdd6ba802$export$6266a5cd5915dc33((0, $hQUwQ.getFocusables)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $e34bbddcdd6ba802$export$493d05a3a8e6532d = function(topNodes, visibilityCache) {
    return (0, $5KBS9.orderByTabIndex)($e34bbddcdd6ba802$export$6266a5cd5915dc33((0, $hQUwQ.getFocusables)(topNodes), visibilityCache), false);
};
var $e34bbddcdd6ba802$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $e34bbddcdd6ba802$export$6266a5cd5915dc33((0, $hQUwQ.getParentAutofocusables)(topNode), visibilityCache);
};
var $e34bbddcdd6ba802$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $e34bbddcdd6ba802$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $8PD3W.toArray)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $e34bbddcdd6ba802$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $e34bbddcdd6ba802$export$2344b14b097df817(child, element);
        });
    }
};

});
parcelRegister("8PD3W", function(module, exports) {

$parcel$export(module.exports, "toArray", function () { return $66e163252ba3d06e$export$45b10814cc054894; });
$parcel$export(module.exports, "asArray", function () { return $66e163252ba3d06e$export$75093a47a9fa838d; });
$parcel$export(module.exports, "getFirst", function () { return $66e163252ba3d06e$export$bcd7afcd904dce14; });
/*
IE11 support
 */ var $66e163252ba3d06e$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $66e163252ba3d06e$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $66e163252ba3d06e$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};

});

parcelRegister("ayxgx", function(module, exports) {

$parcel$export(module.exports, "isVisibleCached", function () { return $7af6e23cc79f6ac6$export$3c9dc299685ad160; });
$parcel$export(module.exports, "isAutoFocusAllowedCached", function () { return $7af6e23cc79f6ac6$export$bcaa50628f6a736e; });
$parcel$export(module.exports, "getDataset", function () { return $7af6e23cc79f6ac6$export$698b339b0c8edae3; });
$parcel$export(module.exports, "isRadioElement", function () { return $7af6e23cc79f6ac6$export$9d74f6fbc6f469d0; });
$parcel$export(module.exports, "notHiddenInput", function () { return $7af6e23cc79f6ac6$export$8197b0ea56b3b055; });
$parcel$export(module.exports, "isGuard", function () { return $7af6e23cc79f6ac6$export$d94b8b58ec2f30eb; });
$parcel$export(module.exports, "isNotAGuard", function () { return $7af6e23cc79f6ac6$export$602e5a0d338d7750; });
$parcel$export(module.exports, "isDefined", function () { return $7af6e23cc79f6ac6$export$4e62c701997796c1; });

var $dwmH2 = parcelRequire("dwmH2");
var $7af6e23cc79f6ac6$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};
var $7af6e23cc79f6ac6$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $7af6e23cc79f6ac6$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $7af6e23cc79f6ac6$var$isInert = function(node) {
    return node.hasAttribute('inert');
};
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */ var $7af6e23cc79f6ac6$var$isVisibleUncached = function(node, checkParent) {
    return !node || $7af6e23cc79f6ac6$var$isTopNode(node) || !$7af6e23cc79f6ac6$var$isElementHidden(node) && !$7af6e23cc79f6ac6$var$isInert(node) && checkParent($7af6e23cc79f6ac6$var$getParentNode(node));
};
var $7af6e23cc79f6ac6$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $7af6e23cc79f6ac6$var$isVisibleUncached(node, $7af6e23cc79f6ac6$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $7af6e23cc79f6ac6$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$7af6e23cc79f6ac6$var$isTopNode(node) ? $7af6e23cc79f6ac6$export$b8550e27de209d85(node) ? checkParent($7af6e23cc79f6ac6$var$getParentNode(node)) : false : true;
};
var $7af6e23cc79f6ac6$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $7af6e23cc79f6ac6$var$isAutoFocusAllowedUncached(node, $7af6e23cc79f6ac6$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $7af6e23cc79f6ac6$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $7af6e23cc79f6ac6$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === 'BUTTON';
};
var $7af6e23cc79f6ac6$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === 'INPUT';
};
var $7af6e23cc79f6ac6$export$9d74f6fbc6f469d0 = function(node) {
    return $7af6e23cc79f6ac6$export$88a6ceeed5737ba3(node) && node.type === 'radio';
};
var $7af6e23cc79f6ac6$export$8197b0ea56b3b055 = function(node) {
    return !(($7af6e23cc79f6ac6$export$88a6ceeed5737ba3(node) || $7af6e23cc79f6ac6$export$65aad1b6bc934b11(node)) && (node.type === 'hidden' || node.disabled));
};
var $7af6e23cc79f6ac6$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $dwmH2.FOCUS_NO_AUTOFOCUS));
    return ![
        true,
        'true',
        ''
    ].includes(attribute);
};
var $7af6e23cc79f6ac6$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $7af6e23cc79f6ac6$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $7af6e23cc79f6ac6$export$602e5a0d338d7750 = function(node) {
    return !$7af6e23cc79f6ac6$export$d94b8b58ec2f30eb(node);
};
var $7af6e23cc79f6ac6$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};

});

parcelRegister("5KBS9", function(module, exports) {

$parcel$export(module.exports, "orderByTabIndex", function () { return $42fea047a9f87215$export$cb40ee071f0d5226; });

var $8PD3W = parcelRequire("8PD3W");
var $42fea047a9f87215$export$350ee6c095d98996 = function(a, b) {
    var aTab = Math.max(0, a.tabIndex);
    var bTab = Math.max(0, b.tabIndex);
    var tabDiff = aTab - bTab;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!aTab) return 1;
        if (!bTab) return -1;
    }
    return tabDiff || indexDiff;
};
var $42fea047a9f87215$var$getTabIndex = function(node) {
    if (node.tabIndex < 0) {
        // all "focusable" elements are already preselected
        // but some might have implicit negative tabIndex
        // return 0 for <audio without tabIndex attribute - it is "tabbable"
        if (!node.hasAttribute('tabindex')) return 0;
    }
    return node.tabIndex;
};
var $42fea047a9f87215$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $8PD3W.toArray)(nodes).map(function(node, index) {
        var tabIndex = $42fea047a9f87215$var$getTabIndex(node);
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($42fea047a9f87215$export$350ee6c095d98996);
};

});

parcelRegister("hQUwQ", function(module, exports) {

$parcel$export(module.exports, "getFocusables", function () { return $cff32473b83dbaad$export$f6768025e418420e; });
$parcel$export(module.exports, "getParentAutofocusables", function () { return $cff32473b83dbaad$export$853fa94d922e78b9; });

var $dwmH2 = parcelRequire("dwmH2");

var $8PD3W = parcelRequire("8PD3W");

var $1SE50 = parcelRequire("1SE50");
var $cff32473b83dbaad$var$queryTabbables = (0, $1SE50.tabbables).join(',');
var $cff32473b83dbaad$var$queryGuardTabbables = "".concat($cff32473b83dbaad$var$queryTabbables, ", [data-focus-guard]");
var $cff32473b83dbaad$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $8PD3W.toArray)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $cff32473b83dbaad$var$queryGuardTabbables : $cff32473b83dbaad$var$queryTabbables) ? [
            child
        ] : [], $cff32473b83dbaad$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $cff32473b83dbaad$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $cff32473b83dbaad$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $cff32473b83dbaad$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $cff32473b83dbaad$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $cff32473b83dbaad$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $8PD3W.toArray)(parent.parentNode.querySelectorAll($cff32473b83dbaad$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $cff32473b83dbaad$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $dwmH2.FOCUS_AUTO), "]"));
    return (0, $8PD3W.toArray)(parentFocus).map(function(node) {
        return $cff32473b83dbaad$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};

});
parcelRegister("1SE50", function(module, exports) {

$parcel$export(module.exports, "tabbables", function () { return $15e9ec968f0cc76a$export$8555f4622e95784; });
/**
 * list of the object to be considered as focusable
 */ var $15e9ec968f0cc76a$export$8555f4622e95784 = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]'
];

});




parcelRegister("5TyBn", function(module, exports) {

$parcel$export(module.exports, "expandFocusableNodes", function () { return $44acee02f44825cf$export$f89ac71e91767111; });

var $cTUR7 = parcelRequire("cTUR7");

var $ayxgx = parcelRequire("ayxgx");

var $fX3VH = parcelRequire("fX3VH");

var $5KBS9 = parcelRequire("5KBS9");

var $hQUwQ = parcelRequire("hQUwQ");
var $44acee02f44825cf$export$f89ac71e91767111 = function(topNode) {
    var entries = (0, $cTUR7.getAllAffectedNodes)(topNode).filter((0, $ayxgx.isNotAGuard));
    var commonParent = (0, $fX3VH.getTopCommonParent)(topNode, topNode, entries);
    var outerNodes = (0, $5KBS9.orderByTabIndex)((0, $hQUwQ.getFocusables)([
        commonParent
    ], true), true, true);
    var innerElements = (0, $hQUwQ.getFocusables)(entries, false);
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $ayxgx.isGuard)(node)
        };
    });
};

});
parcelRegister("cTUR7", function(module, exports) {

$parcel$export(module.exports, "getAllAffectedNodes", function () { return $9646b97733f3ade4$export$7e87c4720b9b279b; });

var $dwmH2 = parcelRequire("dwmH2");

var $8PD3W = parcelRequire("8PD3W");
/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $9646b97733f3ade4$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $9646b97733f3ade4$var$getTopParent = function(node) {
    return node.parentNode ? $9646b97733f3ade4$var$getTopParent(node.parentNode) : node;
};
var $9646b97733f3ade4$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $8PD3W.asArray)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $dwmH2.FOCUS_GROUP));
        acc.push.apply(acc, group ? $9646b97733f3ade4$var$filterNested((0, $8PD3W.toArray)($9646b97733f3ade4$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $dwmH2.FOCUS_GROUP), "=\"").concat(group, "\"]:not([").concat((0, $dwmH2.FOCUS_DISABLED), "=\"disabled\"])")))) : [
            currentNode
        ]);
        return acc;
    }, []);
};

});

parcelRegister("fX3VH", function(module, exports) {

$parcel$export(module.exports, "getTopCommonParent", function () { return $b9cf6a08d2e05428$export$a9a7252b5f2e280e; });
$parcel$export(module.exports, "allParentAutofocusables", function () { return $b9cf6a08d2e05428$export$8f99714c70a37db1; });

var $jvTdj = parcelRequire("jvTdj");

var $8PD3W = parcelRequire("8PD3W");
var $b9cf6a08d2e05428$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $b9cf6a08d2e05428$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $b9cf6a08d2e05428$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $b9cf6a08d2e05428$var$getParents(nodeA);
    var parentsB = $b9cf6a08d2e05428$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $b9cf6a08d2e05428$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $8PD3W.asArray)(baseActiveElement);
    var leftEntries = (0, $8PD3W.asArray)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $b9cf6a08d2e05428$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $b9cf6a08d2e05428$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $jvTdj.contains)(common, topCommon)) topCommon = common;
                else topCommon = $b9cf6a08d2e05428$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $b9cf6a08d2e05428$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $jvTdj.parentAutofocusables)(node, visibilityCache));
    }, []);
};

});


parcelRegister("4rAw6", function(module, exports) {

$parcel$export(module.exports, "focusNextElement", function () { return $33c602874e8c33af$export$3b0237e8566c8d65; });
$parcel$export(module.exports, "focusPrevElement", function () { return $33c602874e8c33af$export$33b47db07a82b2fb; });
$parcel$export(module.exports, "focusFirstElement", function () { return $33c602874e8c33af$export$2a791d8097a66406; });
$parcel$export(module.exports, "focusLastElement", function () { return $33c602874e8c33af$export$6a79073ddabfd6c3; });

var $4W5MP = parcelRequire("4W5MP");

var $jvTdj = parcelRequire("jvTdj");

var $8PD3W = parcelRequire("8PD3W");
var $33c602874e8c33af$export$1b42c72592537703 = function(element, scope, useTabbables) {
    if (!element || !scope) {
        console.error('no element or scope given');
        return {};
    }
    var shards = (0, $8PD3W.asArray)(scope);
    if (shards.every(function(shard) {
        return !(0, $jvTdj.contains)(shard, element);
    })) {
        console.error('Active element is not contained in the scope');
        return {};
    }
    var focusables = useTabbables ? (0, $jvTdj.getTabbableNodes)(shards, new Map()) : (0, $jvTdj.getFocusableNodes)(shards, new Map());
    var current = focusables.findIndex(function(_a) {
        var node = _a.node;
        return node === element;
    });
    if (current === -1) // an edge case, when anchor element is not found
    return undefined;
    return {
        prev: focusables[current - 1],
        next: focusables[current + 1],
        first: focusables[0],
        last: focusables[focusables.length - 1]
    };
};
var $33c602874e8c33af$var$getBoundary = function(shards, useTabbables) {
    var set = useTabbables ? (0, $jvTdj.getTabbableNodes)((0, $8PD3W.asArray)(shards), new Map()) : (0, $jvTdj.getFocusableNodes)((0, $8PD3W.asArray)(shards), new Map());
    return {
        first: set[0],
        last: set[set.length - 1]
    };
};
var $33c602874e8c33af$var$defaultOptions = function(options) {
    return Object.assign({
        scope: document.body,
        cycle: true,
        onlyTabbable: true
    }, options);
};
var $33c602874e8c33af$var$moveFocus = function(fromElement, options, cb) {
    if (options === void 0) options = {};
    var newOptions = $33c602874e8c33af$var$defaultOptions(options);
    var solution = $33c602874e8c33af$export$1b42c72592537703(fromElement, newOptions.scope, newOptions.onlyTabbable);
    if (!solution) return;
    var target = cb(solution, newOptions.cycle);
    if (target) (0, $4W5MP.focusOn)(target.node, newOptions.focusOptions);
};
var $33c602874e8c33af$export$3b0237e8566c8d65 = function(fromElement, options) {
    if (options === void 0) options = {};
    $33c602874e8c33af$var$moveFocus(fromElement, options, function(_a, cycle) {
        var next = _a.next, first = _a.first;
        return next || cycle && first;
    });
};
var $33c602874e8c33af$export$33b47db07a82b2fb = function(fromElement, options) {
    if (options === void 0) options = {};
    $33c602874e8c33af$var$moveFocus(fromElement, options, function(_a, cycle) {
        var prev = _a.prev, last = _a.last;
        return prev || cycle && last;
    });
};
var $33c602874e8c33af$var$pickBoundary = function(scope, options, what) {
    var _a;
    var boundary = $33c602874e8c33af$var$getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
    var node = boundary[what];
    if (node) (0, $4W5MP.focusOn)(node.node, options.focusOptions);
};
var $33c602874e8c33af$export$2a791d8097a66406 = function(scope, options) {
    if (options === void 0) options = {};
    $33c602874e8c33af$var$pickBoundary(scope, options, 'first');
};
var $33c602874e8c33af$export$6a79073ddabfd6c3 = function(scope, options) {
    if (options === void 0) options = {};
    $33c602874e8c33af$var$pickBoundary(scope, options, 'last');
};

});
parcelRegister("4W5MP", function(module, exports) {

$parcel$export(module.exports, "focusOn", function () { return $3981114e737f84ba$export$c12b3da842c43a8; });
var $3981114e737f84ba$export$c12b3da842c43a8 = function(target, focusOptions) {
    if (!target) // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
    return;
    if ('focus' in target) target.focus(focusOptions);
    if ('contentWindow' in target && target.contentWindow) target.contentWindow.focus();
};

});


parcelRegister("kZ7Fy", function(module, exports) {

$parcel$export(module.exports, "focusInside", function () { return $03f14810e76197c7$export$20115f8da7baa6fa; });

var $jvTdj = parcelRequire("jvTdj");

var $cTUR7 = parcelRequire("cTUR7");

var $8PD3W = parcelRequire("8PD3W");

var $i3Vzc = parcelRequire("i3Vzc");
var $03f14810e76197c7$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $03f14810e76197c7$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $8PD3W.toArray)(topNode.querySelectorAll('iframe')).some(function(node) {
        return $03f14810e76197c7$var$focusInFrame(node, activeElement);
    }));
};
var $03f14810e76197c7$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $i3Vzc.getActiveElement)((0, $8PD3W.getFirst)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $cTUR7.getAllAffectedNodes)(topNode).some(function(node) {
        return (0, $jvTdj.contains)(node, activeElement) || $03f14810e76197c7$var$focusInsideIframe(node, activeElement);
    });
};

});
parcelRegister("i3Vzc", function(module, exports) {

$parcel$export(module.exports, "getActiveElement", function () { return $d2652959b76d4500$export$cd4e5573fbe2b576; });
/**
 * returns active element from document or from nested shadowdoms
 */ 
var $gwVhT = parcelRequire("gwVhT");
var $d2652959b76d4500$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $d2652959b76d4500$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $gwVhT.safeProbe)(function() {
        return activeElement.contentWindow.document;
    }) ? $d2652959b76d4500$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};

});
parcelRegister("gwVhT", function(module, exports) {

$parcel$export(module.exports, "safeProbe", function () { return $031b088eed7c758f$export$78d20aae35adef88; });
var $031b088eed7c758f$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};

});



parcelRegister("ddtW5", function(module, exports) {

$parcel$export(module.exports, "focusIsHidden", function () { return $99f3b5e138ccf219$export$be6b21806d3fd485; });

var $dwmH2 = parcelRequire("dwmH2");

var $jvTdj = parcelRequire("jvTdj");

var $8PD3W = parcelRequire("8PD3W");

var $i3Vzc = parcelRequire("i3Vzc");
var $99f3b5e138ccf219$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $i3Vzc.getActiveElement)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $8PD3W.toArray)(inDocument.querySelectorAll("[".concat((0, $dwmH2.FOCUS_ALLOW), "]"))).some(function(node) {
        return (0, $jvTdj.contains)(node, activeElement);
    });
};

});

parcelRegister("uu7sA", function(module, exports) {

$parcel$export(module.exports, "moveFocusInside", function () { return (parcelRequire("kCnXR")).moveFocusInside; });

var $dwmH2 = parcelRequire("dwmH2");

var $kZ7Fy = parcelRequire("kZ7Fy");

var $ddtW5 = parcelRequire("ddtW5");


var $5TyBn = parcelRequire("5TyBn");

var $kCnXR = parcelRequire("kCnXR");

var $arAUI = parcelRequire("arAUI");

var $4rAw6 = parcelRequire("4rAw6");

/**
 * magic symbols to control focus behavior from DOM
 * see description of every particular one
 */ var $05ba2a86f0b4dfeb$export$1a988e7317c65621 = $dwmH2;
/**
 * @deprecated - please use {@link moveFocusInside} named export
 */ var $05ba2a86f0b4dfeb$var$deprecated_default_moveFocusInside = (0, $kCnXR.moveFocusInside);
var $05ba2a86f0b4dfeb$export$2e2bcd8739ae039 //
 = $05ba2a86f0b4dfeb$var$deprecated_default_moveFocusInside;

});
parcelRegister("kCnXR", function(module, exports) {

$parcel$export(module.exports, "moveFocusInside", function () { return $f029f21b9133ccd7$export$cd599851e879a025; });

var $4W5MP = parcelRequire("4W5MP");

var $feM71 = parcelRequire("feM71");
var $f029f21b9133ccd7$var$guardCount = 0;
var $f029f21b9133ccd7$var$lockDisabled = false;
var $f029f21b9133ccd7$export$cd599851e879a025 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $feM71.focusSolver)(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if ($f029f21b9133ccd7$var$lockDisabled) return;
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/ if ($f029f21b9133ccd7$var$guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $f029f21b9133ccd7$var$lockDisabled = true;
            setTimeout(function() {
                $f029f21b9133ccd7$var$lockDisabled = false;
            }, 1);
            return;
        }
        $f029f21b9133ccd7$var$guardCount++;
        (0, $4W5MP.focusOn)(focusable.node, options.focusOptions);
        $f029f21b9133ccd7$var$guardCount--;
    }
};

});
parcelRegister("feM71", function(module, exports) {

$parcel$export(module.exports, "focusSolver", function () { return $b17d7bebe58ecb33$export$305758c744b57f6f; });

var $fx4Kq = parcelRequire("fx4Kq");

var $jvTdj = parcelRequire("jvTdj");

var $cTUR7 = parcelRequire("cTUR7");

var $8PD3W = parcelRequire("8PD3W");

var $dK42y = parcelRequire("dK42y");

var $i3Vzc = parcelRequire("i3Vzc");

var $ayxgx = parcelRequire("ayxgx");

var $fX3VH = parcelRequire("fX3VH");
var $b17d7bebe58ecb33$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $ayxgx.isDefined));
};
var $b17d7bebe58ecb33$export$305758c744b57f6f = function(topNode, lastNode) {
    var activeElement = (0, $i3Vzc.getActiveElement)((0, $8PD3W.asArray)(topNode).length > 0 ? document : (0, $8PD3W.getFirst)(topNode).ownerDocument);
    var entries = (0, $cTUR7.getAllAffectedNodes)(topNode).filter((0, $ayxgx.isNotAGuard));
    var commonParent = (0, $fX3VH.getTopCommonParent)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $jvTdj.getFocusableNodes)(entries, visibilityCache);
    var innerElements = anyFocusable.filter(function(_a) {
        var node = _a.node;
        return (0, $ayxgx.isNotAGuard)(node);
    });
    if (!innerElements[0]) return undefined;
    var outerNodes = (0, $jvTdj.getFocusableNodes)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $b17d7bebe58ecb33$var$reorderNodes(outerNodes, innerElements);
    // collect inner focusable and separately tabbables
    var innerFocusables = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var innerTabbable = orderedInnerElements.filter(function(_a) {
        var tabIndex = _a.tabIndex;
        return tabIndex >= 0;
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $fx4Kq.newFocus)(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
    if (newId === (0, $fx4Kq.NEW_FOCUS)) {
        var focusNode = // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        (0, $dK42y.pickAutofocus)(anyFocusable, innerTabbable, (0, $fX3VH.allParentAutofocusables)(entries, visibilityCache)) || (0, $dK42y.pickAutofocus)(anyFocusable, innerFocusables, (0, $fX3VH.allParentAutofocusables)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};

});
parcelRegister("fx4Kq", function(module, exports) {

$parcel$export(module.exports, "NEW_FOCUS", function () { return $b4ed9ee011e3d554$export$85710b12cf912438; });
$parcel$export(module.exports, "newFocus", function () { return $b4ed9ee011e3d554$export$65842178e9bb4205; });

var $foESl = parcelRequire("foESl");

var $3eGFb = parcelRequire("3eGFb");

var $ayxgx = parcelRequire("ayxgx");
var $b4ed9ee011e3d554$export$85710b12cf912438 = 'NEW_FOCUS';
var $b4ed9ee011e3d554$export$65842178e9bb4205 = function(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $ayxgx.isGuard)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    // no active focus (or focus is on the body)
    if (activeIndex === -1) {
        // known fallback
        if (lastNodeInside !== -1) return lastNodeInside;
        return $b4ed9ee011e3d554$export$85710b12cf912438;
    }
    // new focus, nothing to calculate
    if (lastNodeInside === -1) return $b4ed9ee011e3d554$export$85710b12cf912438;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $foESl.correctNodes)(outerNodes);
    var currentFocusableIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var previousFocusableIndex = lastNode ? correctedNodes.indexOf(lastNode) : currentFocusableIndex;
    var tabbableNodes = correctedNodes.filter(function(node) {
        return node.tabIndex >= 0;
    });
    var currentTabbableIndex = activeElement !== undefined ? tabbableNodes.indexOf(activeElement) : -1;
    var previousTabbableIndex = lastNode ? tabbableNodes.indexOf(lastNode) : currentTabbableIndex;
    var focusIndexDiff = currentTabbableIndex >= 0 && previousTabbableIndex >= 0 ? previousTabbableIndex - currentTabbableIndex : previousFocusableIndex - currentFocusableIndex;
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // no tabbable elements, autofocus is not possible
    if (innerTabbables.length === 0) // an edge case with no tabbable elements
    // return the last focusable one
    // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
    return lastNodeInside;
    var returnFirstNode = (0, $3eGFb.pickFocusable)(innerNodes, innerTabbables[0]);
    var returnLastNode = (0, $3eGFb.pickFocusable)(innerNodes, innerTabbables[innerTabbables.length - 1]);
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(focusIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

});
parcelRegister("foESl", function(module, exports) {

$parcel$export(module.exports, "correctNode", function () { return $b358cde9764e98a7$export$5261662167ad7ced; });
$parcel$export(module.exports, "correctNodes", function () { return $b358cde9764e98a7$export$4a5a72a7124e45f9; });

var $ayxgx = parcelRequire("ayxgx");
var $b358cde9764e98a7$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $ayxgx.isRadioElement)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $b358cde9764e98a7$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $ayxgx.isRadioElement)(node) && node.name) return $b358cde9764e98a7$var$findSelectedRadio(node, nodes);
    return node;
};
var $b358cde9764e98a7$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($b358cde9764e98a7$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};

});

parcelRegister("3eGFb", function(module, exports) {

$parcel$export(module.exports, "pickFirstFocus", function () { return $25b3c5f0a284693c$export$f4e86cfa0679b9cc; });
$parcel$export(module.exports, "pickFocusable", function () { return $25b3c5f0a284693c$export$e06728ee87c96122; });

var $foESl = parcelRequire("foESl");
var $25b3c5f0a284693c$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $foESl.correctNode)(nodes[0], nodes);
    return nodes[0];
};
var $25b3c5f0a284693c$export$e06728ee87c96122 = function(nodes, node) {
    return nodes.indexOf((0, $foESl.correctNode)(node, nodes));
};

});


parcelRegister("dK42y", function(module, exports) {

$parcel$export(module.exports, "pickAutofocus", function () { return $a012b4858d547167$export$cfb742983e257555; });

var $jvTdj = parcelRequire("jvTdj");

var $3eGFb = parcelRequire("3eGFb");

var $ayxgx = parcelRequire("ayxgx");
var $a012b4858d547167$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $ayxgx.getDataset)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== 'false' || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $a012b4858d547167$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $jvTdj.filterAutoFocusable)(nodes.filter($a012b4858d547167$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $3eGFb.pickFirstFocus)(autoFocusable);
    return (0, $3eGFb.pickFirstFocus)((0, $jvTdj.filterAutoFocusable)(orderedNodes));
};

});




parcelRegister("furt5", function(module, exports) {

$parcel$export(module.exports, "deferAction", function () { return $b46ef6faf0e1addc$export$6523025722806278; });
$parcel$export(module.exports, "extractRef", function () { return $b46ef6faf0e1addc$export$c613fed06e332533; });
function $b46ef6faf0e1addc$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $b46ef6faf0e1addc$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $b46ef6faf0e1addc$export$c613fed06e332533 = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};

});




parcelRegister("llFLf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4iaP6 = parcelRequire("4iaP6");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $f8abf40a89ab1ce9$var$_interopRequireDefault($4iaP6).default;
    }
});

var $cxcbe = parcelRequire("cxcbe");
Object.defineProperty(module.exports, 'TouchScrollable', {
    enumerable: true,
    get: function get() {
        return $cxcbe.TouchScrollable;
    }
});
function $f8abf40a89ab1ce9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("4iaP6", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $32013d239d3c8293$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $91i6m = parcelRequire("91i6m");
var $32013d239d3c8293$var$_react2 = $32013d239d3c8293$var$_interopRequireDefault($91i6m);

var $9kBxa = parcelRequire("9kBxa");

var $cxcbe = parcelRequire("cxcbe");

var $3UusC = parcelRequire("3UusC");
var $32013d239d3c8293$var$_withLockSheet2 = $32013d239d3c8293$var$_interopRequireDefault($3UusC);

var $4sx7F = parcelRequire("4sx7F");
var $32013d239d3c8293$var$_withTouchListeners2 = $32013d239d3c8293$var$_interopRequireDefault($4sx7F);

var $gqtdb = parcelRequire("gqtdb");
function $32013d239d3c8293$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $32013d239d3c8293$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $32013d239d3c8293$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $32013d239d3c8293$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $32013d239d3c8293$var$ScrollLock = function(_PureComponent) {
    $32013d239d3c8293$var$_inherits(ScrollLock, _PureComponent);
    function ScrollLock() {
        $32013d239d3c8293$var$_classCallCheck(this, ScrollLock);
        return $32013d239d3c8293$var$_possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }
    $32013d239d3c8293$var$_createClass(ScrollLock, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$9kBxa.canUseDOM) return;
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var offset = window.innerHeight - this.initialHeight;
                // adjust scroll if the window has been resized since the lock was engaged
                // e.g. mobile safari dynamic chrome heights
                if (offset) window.scrollTo(0, window.pageYOffset + offset);
                // reset the initial height in case this scroll lock is used again
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'render',
            value: function render() {
                var children = this.props.children;
                return children ? $32013d239d3c8293$var$_react2.default.createElement($cxcbe.TouchScrollable, null, children) : null;
            }
        }
    ]);
    return ScrollLock;
}($91i6m.PureComponent);
// attach the stylesheet and inject styles on [un]mount
var $32013d239d3c8293$var$compose = (0, $gqtdb.pipe)($32013d239d3c8293$var$_withTouchListeners2.default, $32013d239d3c8293$var$_withLockSheet2.default);
var $32013d239d3c8293$var$SheetLock = $32013d239d3c8293$var$compose($32013d239d3c8293$var$ScrollLock);
// toggle the lock based on `isActive` prop
var $32013d239d3c8293$var$LockToggle = function LockToggle(props) {
    return props.isActive ? $32013d239d3c8293$var$_react2.default.createElement($32013d239d3c8293$var$SheetLock, props) : props.children;
};
$32013d239d3c8293$var$LockToggle.defaultProps = {
    accountForScrollbars: true,
    children: null,
    isActive: true
};
module.exports.default = $32013d239d3c8293$var$LockToggle;

});
parcelRegister("9kBxa", function(module, exports) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (0, module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

});

parcelRegister("cxcbe", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TouchScrollable = undefined;
var $920203ce19ff298a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $920203ce19ff298a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $91i6m = parcelRequire("91i6m");

var $9kBxa = parcelRequire("9kBxa");

var $gqtdb = parcelRequire("gqtdb");
function $920203ce19ff298a$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $920203ce19ff298a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $920203ce19ff298a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $920203ce19ff298a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $920203ce19ff298a$var$TouchScrollable = module.exports.TouchScrollable = function(_PureComponent) {
    $920203ce19ff298a$var$_inherits(TouchScrollable, _PureComponent);
    function TouchScrollable() {
        var _ref;
        var _temp, _this, _ret;
        $920203ce19ff298a$var$_classCallCheck(this, TouchScrollable);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $920203ce19ff298a$var$_possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.getScrollableArea = function(ref) {
            _this.scrollableArea = ref;
        }, _temp), $920203ce19ff298a$var$_possibleConstructorReturn(_this, _ret);
    }
    $920203ce19ff298a$var$_createClass(TouchScrollable, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$9kBxa.canUseEventListeners) return;
                this.scrollableArea.addEventListener('touchstart', $gqtdb.preventInertiaScroll, $gqtdb.listenerOptions);
                this.scrollableArea.addEventListener('touchmove', $gqtdb.allowTouchMove, $gqtdb.listenerOptions);
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (!$9kBxa.canUseEventListeners) return;
                this.scrollableArea.removeEventListener('touchstart', $gqtdb.preventInertiaScroll, $gqtdb.listenerOptions);
                this.scrollableArea.removeEventListener('touchmove', $gqtdb.allowTouchMove, $gqtdb.listenerOptions);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, children = _props.children, rest = $920203ce19ff298a$var$_objectWithoutProperties(_props, [
                    'children'
                ]);
                return typeof children === 'function' ? children(this.getScrollableArea) : (0, $91i6m.cloneElement)(children, $920203ce19ff298a$var$_extends({
                    ref: this.getScrollableArea
                }, rest));
            }
        }
    ]);
    return TouchScrollable;
}($91i6m.PureComponent);

});
parcelRegister("gqtdb", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pipe = module.exports.listenerOptions = undefined;
module.exports.preventTouchMove = $bf55bbe53629feed$var$preventTouchMove;
module.exports.allowTouchMove = $bf55bbe53629feed$var$allowTouchMove;
module.exports.preventInertiaScroll = $bf55bbe53629feed$var$preventInertiaScroll;
module.exports.isTouchDevice = $bf55bbe53629feed$var$isTouchDevice;
module.exports.camelToKebab = $bf55bbe53629feed$var$camelToKebab;
module.exports.parse = $bf55bbe53629feed$var$parse;
module.exports.getPadding = $bf55bbe53629feed$var$getPadding;
module.exports.getWindowHeight = $bf55bbe53629feed$var$getWindowHeight;
module.exports.getDocumentHeight = $bf55bbe53629feed$var$getDocumentHeight;
module.exports.makeStyleTag = $bf55bbe53629feed$var$makeStyleTag;
module.exports.injectStyles = $bf55bbe53629feed$var$injectStyles;
module.exports.insertStyleTag = $bf55bbe53629feed$var$insertStyleTag;

var $9kBxa = parcelRequire("9kBxa");
var $bf55bbe53629feed$var$listenerOptions = module.exports.listenerOptions = {
    capture: false,
    passive: false
};
// ==============================
// Touch Helpers
// ==============================
function $bf55bbe53629feed$var$preventTouchMove(e) {
    e.preventDefault();
    return false;
}
function $bf55bbe53629feed$var$allowTouchMove(e) {
    var target = e.currentTarget;
    if (target.scrollHeight > target.clientHeight) {
        e.stopPropagation();
        return true;
    }
    e.preventDefault();
    return false;
}
function $bf55bbe53629feed$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $bf55bbe53629feed$var$isTouchDevice() {
    if (!$9kBxa.canUseDOM) return false;
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
// ==============================
// Misc.
// ==============================
function $bf55bbe53629feed$var$camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function $bf55bbe53629feed$var$parse(val) {
    return isNaN(val) ? val : val + 'px';
}
// Take a list of functions and return a function that applies the list of
// functions from left to right
var $bf55bbe53629feed$var$pipeFns = function pipeFns(a, b) {
    return function() {
        return b(a.apply(undefined, arguments));
    };
};
var $bf55bbe53629feed$var$pipe = module.exports.pipe = function pipe() {
    for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return fns.reduce($bf55bbe53629feed$var$pipeFns);
};
// ==============================
// Document Helpers
// ==============================
function $bf55bbe53629feed$var$getPadding() {
    if (!$9kBxa.canUseDOM) return 0;
    var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return paddingRight + scrollbarWidth;
}
function $bf55bbe53629feed$var$getWindowHeight() {
    var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if ($9kBxa.canUseDOM) return window.innerHeight * multiplier;
}
function $bf55bbe53629feed$var$getDocumentHeight() {
    if ($9kBxa.canUseDOM) return document.body.clientHeight;
}
// ==============================
// Style Sheets
// ==============================
function $bf55bbe53629feed$var$makeStyleTag() {
    if (!$9kBxa.canUseDOM) return;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    tag.setAttribute('data-react-scrolllock', '');
    return tag;
}
function $bf55bbe53629feed$var$injectStyles(tag, css) {
    if (!$9kBxa.canUseDOM) return;
    if (tag.styleSheet) tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $bf55bbe53629feed$var$insertStyleTag(tag) {
    if (!$9kBxa.canUseDOM) return;
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}

});


parcelRegister("3UusC", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $2d8e3ae16c7f3379$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $2d8e3ae16c7f3379$var$withLockSheet;

var $91i6m = parcelRequire("91i6m");
var $2d8e3ae16c7f3379$var$_react2 = $2d8e3ae16c7f3379$var$_interopRequireDefault($91i6m);

var $gqtdb = parcelRequire("gqtdb");
function $2d8e3ae16c7f3379$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2d8e3ae16c7f3379$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2d8e3ae16c7f3379$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $2d8e3ae16c7f3379$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $2d8e3ae16c7f3379$var$withLockSheet(WrappedComponent) {
    return function(_PureComponent) {
        $2d8e3ae16c7f3379$var$_inherits(SheetProvider, _PureComponent);
        function SheetProvider() {
            var _ref;
            var _temp, _this, _ret;
            $2d8e3ae16c7f3379$var$_classCallCheck(this, SheetProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $2d8e3ae16c7f3379$var$_possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.addSheet = function() {
                var styles = _this.getStyles();
                var sheet = (0, $gqtdb.makeStyleTag)();
                if (!sheet) return;
                (0, $gqtdb.injectStyles)(sheet, styles);
                (0, $gqtdb.insertStyleTag)(sheet);
                _this.sheet = sheet;
            }, _this.getStyles = function() {
                var accountForScrollbars = _this.props.accountForScrollbars;
                var height = (0, $gqtdb.getDocumentHeight)();
                var paddingRight = accountForScrollbars ? (0, $gqtdb.getPadding)() : null;
                var styles = 'body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        ' + (height ? 'height: ' + height + 'px !important;' : '') + '\n        ' + (paddingRight ? 'padding-right: ' + paddingRight + 'px !important;' : '') + '\n      }';
                return styles;
            }, _temp), $2d8e3ae16c7f3379$var$_possibleConstructorReturn(_this, _ret);
        }
        $2d8e3ae16c7f3379$var$_createClass(SheetProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.addSheet();
                }
            },
            {
                key: 'removeSheet',
                value: function removeSheet() {
                    if (!this.sheet) return;
                    // $FlowFixMe
                    this.sheet.parentNode.removeChild(this.sheet);
                    this.sheet = null;
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.removeSheet();
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $2d8e3ae16c7f3379$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return SheetProvider;
    }($91i6m.PureComponent);
}

});

parcelRegister("4sx7F", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $33f3786fb1a6e972$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $33f3786fb1a6e972$var$withTouchListeners;

var $91i6m = parcelRequire("91i6m");
var $33f3786fb1a6e972$var$_react2 = $33f3786fb1a6e972$var$_interopRequireDefault($91i6m);

var $9kBxa = parcelRequire("9kBxa");

var $gqtdb = parcelRequire("gqtdb");
function $33f3786fb1a6e972$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $33f3786fb1a6e972$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $33f3786fb1a6e972$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $33f3786fb1a6e972$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Mobile Safari ignores { overflow: hidden } declaration on the body,
// so we have to prevent touchmove events via JS
function $33f3786fb1a6e972$var$withTouchListeners(WrappedComponent) {
    return function(_PureComponent) {
        $33f3786fb1a6e972$var$_inherits(TouchProvider, _PureComponent);
        function TouchProvider() {
            $33f3786fb1a6e972$var$_classCallCheck(this, TouchProvider);
            return $33f3786fb1a6e972$var$_possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
        }
        $33f3786fb1a6e972$var$_createClass(TouchProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    if (!$9kBxa.canUseDOM || !(0, $gqtdb.isTouchDevice)()) return;
                    document.addEventListener('touchmove', $gqtdb.preventTouchMove, $gqtdb.listenerOptions);
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    if (!$9kBxa.canUseDOM || !(0, $gqtdb.isTouchDevice)()) return;
                    document.removeEventListener('touchmove', $gqtdb.preventTouchMove, $gqtdb.listenerOptions);
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $33f3786fb1a6e972$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return TouchProvider;
    }($91i6m.PureComponent);
}

});



parcelRegister("l9xBx", function(module, exports) {

$parcel$export(module.exports, "layers", function () { return $f664815e663bbfe0$export$7be255094ccdc533; });

var $5RmjO = parcelRequire("5RmjO");

var $jtle9 = parcelRequire("jtle9");
var $f664815e663bbfe0$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $f664815e663bbfe0$export$c93026a968943f95 = 'light';
var $f664815e663bbfe0$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $f664815e663bbfe0$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $f664815e663bbfe0$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $jtle9.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $f664815e663bbfe0$export$6d8204c2cb2e06b8() / 4;
    (0, $5RmjO.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $f664815e663bbfe0$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $f664815e663bbfe0$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $f664815e663bbfe0$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $5RmjO.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $f664815e663bbfe0$export$ba1d834b86d72a09 = $f664815e663bbfe0$export$a1b3edb637fb4f35;
var $f664815e663bbfe0$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $jtle9.N20A), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $jtle9.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $jtle9.N30A), ")")
            }
        }
    };
};

});
parcelRegister("jtle9", function(module, exports) {

$parcel$export(module.exports, "B200", function () { return $e2d1310bb31ae028$export$215b7063051591f1; });
$parcel$export(module.exports, "N20A", function () { return $e2d1310bb31ae028$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $e2d1310bb31ae028$export$920c0d5c49070351; });
// Reds
var $e2d1310bb31ae028$export$4b84fd0e2c617bd = '#FFEBE6';
var $e2d1310bb31ae028$export$b34b069eff244586 = '#FFBDAD';
var $e2d1310bb31ae028$export$be802dd0d8b57f35 = '#FF8F73';
var $e2d1310bb31ae028$export$60847d42f9da92a6 = '#FF7452';
var $e2d1310bb31ae028$export$4a7404f376229999 = '#FF5630';
var $e2d1310bb31ae028$export$2010d0fb4295b346 = '#DE350B';
var $e2d1310bb31ae028$export$2837b5a1a71d5c02 = '#BF2600';
var $e2d1310bb31ae028$export$8d9596b529bbb9cf = '#FFFAE6';
var $e2d1310bb31ae028$export$41060a744ab0b7ae = '#FFF0B3';
var $e2d1310bb31ae028$export$1cc05bbbf340e559 = '#FFE380';
var $e2d1310bb31ae028$export$5aae31392d72caaa = '#FFC400';
var $e2d1310bb31ae028$export$c6930421db9fa514 = '#FFAB00';
var $e2d1310bb31ae028$export$59619663aa6500fb = '#FF991F';
var $e2d1310bb31ae028$export$874739ea9e379ab6 = '#FF8B00';
var $e2d1310bb31ae028$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $e2d1310bb31ae028$export$69a3bf21b9686c2b = '#ABF5D1';
var $e2d1310bb31ae028$export$afbce1382ec95f73 = '#79F2C0';
var $e2d1310bb31ae028$export$747d86715d4175de = '#57D9A3';
var $e2d1310bb31ae028$export$940e1f69e873f202 = '#36B37E';
var $e2d1310bb31ae028$export$a49394138f7b8e85 = '#00875A';
var $e2d1310bb31ae028$export$6fa04827ac68a4fb = '#006644';
var $e2d1310bb31ae028$export$226de0355ed012f8 = '#DEEBFF';
var $e2d1310bb31ae028$export$8c13c2ee36917869 = '#B3D4FF';
var $e2d1310bb31ae028$export$ecfc1dff386a3e7a = '#4C9AFF';
var $e2d1310bb31ae028$export$215b7063051591f1 = '#2684FF';
var $e2d1310bb31ae028$export$e62e8919cca44969 = '#0065FF';
var $e2d1310bb31ae028$export$b3de0ae08da2ce64 = '#0052CC';
var $e2d1310bb31ae028$export$a6ee3d71bc067634 = '#0747A6';
var $e2d1310bb31ae028$export$67f15409e87642a1 = '#669DF1';
var $e2d1310bb31ae028$export$f0539dbc42dbb067 = '#8FB8F6';
var $e2d1310bb31ae028$export$363e4475840015bb = '#EAE6FF';
var $e2d1310bb31ae028$export$4b0a4417ed59760f = '#C0B6F2';
var $e2d1310bb31ae028$export$6011520a64d9a187 = '#998DD9';
var $e2d1310bb31ae028$export$a7175d4e9206bc80 = '#8777D9';
var $e2d1310bb31ae028$export$b48405b95304b5a1 = '#6554C0';
var $e2d1310bb31ae028$export$c71e4279dd54a18d = '#5243AA';
var $e2d1310bb31ae028$export$147899de772240ec = '#403294';
var $e2d1310bb31ae028$export$2cf711fe14c66f06 = '#E6FCFF';
var $e2d1310bb31ae028$export$7a8f4d33f6f9772c = '#B3F5FF';
var $e2d1310bb31ae028$export$776c9c497ef08533 = '#79E2F2';
var $e2d1310bb31ae028$export$69cb3ca10c1e330e = '#00C7E6';
var $e2d1310bb31ae028$export$9dc1ef0f3f48059b = '#00B8D9';
var $e2d1310bb31ae028$export$7c835c78b6fcdef8 = '#00A3BF';
var $e2d1310bb31ae028$export$6036577f95c3877e = '#008DA6';
var $e2d1310bb31ae028$export$29a4f05edc054374 = '#FFFFFF';
var $e2d1310bb31ae028$export$e655ef011c4aa1a2 = '#FAFBFC';
var $e2d1310bb31ae028$export$9fdfb749e33cdf97 = '#F4F5F7';
var $e2d1310bb31ae028$export$3e51e8f1440314ba = '#EBECF0';
var $e2d1310bb31ae028$export$1ce2d1575d444ceb = '#DFE1E6';
var $e2d1310bb31ae028$export$8754fc7e6d8b3000 = '#C1C7D0';
var $e2d1310bb31ae028$export$c2e91cbeada39b8b = '#B3BAC5';
var $e2d1310bb31ae028$export$5f71e19f3a7ad9de = '#A5ADBA';
var $e2d1310bb31ae028$export$eaa8c8a70ac22806 = '#97A0AF';
var $e2d1310bb31ae028$export$7c87d337fb91a97d = '#8993A4';
var $e2d1310bb31ae028$export$d6447c357493214f = '#7A869A';
var $e2d1310bb31ae028$export$f563ee71e9ee74cd = '#6B778C';
var $e2d1310bb31ae028$export$e2ef2124cf4024b1 = '#5E6C84';
var $e2d1310bb31ae028$export$eece5f492e429f08 = '#505F79';
var $e2d1310bb31ae028$export$c39c0fe0f26207ae = '#42526E';
var $e2d1310bb31ae028$export$7090862dc3038a9f = '#344563';
var $e2d1310bb31ae028$export$ad0bacf983b7ddaa = '#253858';
var $e2d1310bb31ae028$export$7d61b15e0da132af = '#172B4D';
var $e2d1310bb31ae028$export$fbda843f0a27fe96 = '#091E42';
var $e2d1310bb31ae028$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $e2d1310bb31ae028$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $e2d1310bb31ae028$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $e2d1310bb31ae028$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $e2d1310bb31ae028$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $e2d1310bb31ae028$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $e2d1310bb31ae028$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $e2d1310bb31ae028$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $e2d1310bb31ae028$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $e2d1310bb31ae028$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $e2d1310bb31ae028$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $e2d1310bb31ae028$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $e2d1310bb31ae028$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $e2d1310bb31ae028$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $e2d1310bb31ae028$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $e2d1310bb31ae028$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $e2d1310bb31ae028$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $e2d1310bb31ae028$export$2f6319cf7d736c2a = '#E6EDFA';
var $e2d1310bb31ae028$export$95126bc8884d6634 = '#DCE5F5';
var $e2d1310bb31ae028$export$8338d8c35d44ff1 = '#CED9EB';
var $e2d1310bb31ae028$export$5368d76ae4fbbda7 = '#B8C7E0';
var $e2d1310bb31ae028$export$9f0a771d16ec8d36 = '#ABBBD6';
var $e2d1310bb31ae028$export$abcf8c38338b4aa5 = '#9FB0CC';
var $e2d1310bb31ae028$export$97e81faa16a182c7 = '#8C9CB8';
var $e2d1310bb31ae028$export$bfe21c59123ecf33 = '#7988A3';
var $e2d1310bb31ae028$export$ee82aa2ea6a1558 = '#67758F';
var $e2d1310bb31ae028$export$682927c6ed76be02 = '#56637A';
var $e2d1310bb31ae028$export$91fd9994c5be9757 = '#455166';
var $e2d1310bb31ae028$export$d281fbfe3cff2df6 = '#3B475C';
var $e2d1310bb31ae028$export$3902c91d8b98a753 = '#313D52';
var $e2d1310bb31ae028$export$8e8133c1ba5845b5 = '#283447';
var $e2d1310bb31ae028$export$33ff357f6620b39 = '#202B3D';
var $e2d1310bb31ae028$export$633847cf062b69e0 = '#1B2638';
var $e2d1310bb31ae028$export$9776a6e503bdbf76 = '#121A29';
var $e2d1310bb31ae028$export$6c813d5160dff5db = '#0E1624';
var $e2d1310bb31ae028$export$3d4f271a500072a = '#0D1424';
var $e2d1310bb31ae028$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $e2d1310bb31ae028$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $e2d1310bb31ae028$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $e2d1310bb31ae028$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $e2d1310bb31ae028$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $e2d1310bb31ae028$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $e2d1310bb31ae028$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $e2d1310bb31ae028$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $e2d1310bb31ae028$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $e2d1310bb31ae028$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $e2d1310bb31ae028$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $e2d1310bb31ae028$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $e2d1310bb31ae028$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $e2d1310bb31ae028$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $e2d1310bb31ae028$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $e2d1310bb31ae028$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $e2d1310bb31ae028$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $e2d1310bb31ae028$export$d2adc5dedf09fced = '#292A2E';
var $e2d1310bb31ae028$export$f51762073d2bb381 = '#94C748';
var $e2d1310bb31ae028$export$95e26d54def96891 = '#B3DF72';

});


parcelRegister("2moRh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b80eb389976cb27$export$2e2bcd8739ae039; });

var $5YM7L = parcelRequire("5YM7L");

var $91i6m = parcelRequire("91i6m");

var $lfhpy = parcelRequire("lfhpy");

var $kSVqA = parcelRequire("kSVqA");

var $39U0z = parcelRequire("39U0z");

var $erZ2i = parcelRequire("erZ2i");
/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ var $1b80eb389976cb27$var$modalStackRegister = [];
function $1b80eb389976cb27$export$2e2bcd8739ae039(_ref) {
    var onStackChange = _ref.onStackChange;
    var _useExitingPersistenc = (0, $erZ2i.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting;
    var _useStateRef = (0, $39U0z.default)(0), _useStateRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useStateRef, 2), stackIndexRef = _useStateRef2[0], setStackIndex = _useStateRef2[1];
    var currentStackIndex = stackIndexRef.current;
    var previousStackIndex = (0, $kSVqA.default)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    var updateStack = (0, $lfhpy.default)(function() {
        var newStackIndex = $1b80eb389976cb27$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $91i6m.useEffect)(function() {
        var currentStackIndex = $1b80eb389976cb27$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $1b80eb389976cb27$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $1b80eb389976cb27$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $1b80eb389976cb27$var$modalStackRegister.forEach(function(cb) {
            return cb();
        });
    }, [
        updateStack,
        isExiting
    ]);
    (0, $91i6m.useEffect)(function() {
        return function() {
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            var currentStackIndex = $1b80eb389976cb27$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $1b80eb389976cb27$var$modalStackRegister.splice(currentStackIndex, 1);
                $1b80eb389976cb27$var$modalStackRegister.forEach(function(cb) {
                    return cb();
                });
            }
        };
    }, [
        updateStack
    ]);
    (0, $91i6m.useEffect)(function() {
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}

});
parcelRegister("lfhpy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7788131c61c5f21$export$2e2bcd8739ae039; });

var $c3463 = parcelRequire("c3463");
function $f7788131c61c5f21$export$2e2bcd8739ae039(callback) {
    var ref = (0, $c3463.default)(function() {
        return callback;
    });
    return ref.current;
}

});
parcelRegister("c3463", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c58f1550a730eb7$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");
var $8c58f1550a730eb7$var$uniqueReferencedValue = {};
function $8c58f1550a730eb7$export$2e2bcd8739ae039(initializer) {
    var ref = (0, $91i6m.useRef)($8c58f1550a730eb7$var$uniqueReferencedValue);
    if (ref.current === $8c58f1550a730eb7$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}

});


parcelRegister("kSVqA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f34565c2b0b86fef$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");
function $f34565c2b0b86fef$export$2e2bcd8739ae039(value) {
    var ref = (0, $91i6m.useRef)();
    (0, $91i6m.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("39U0z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24cda86770810a10$export$2e2bcd8739ae039; });

var $5YM7L = parcelRequire("5YM7L");

var $91i6m = parcelRequire("91i6m");
function $24cda86770810a10$export$2e2bcd8739ae039(initialState) {
    var _useState = (0, $91i6m.useState)(initialState), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var valueRef = (0, $91i6m.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

});


parcelRegister("cU6yI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $964fcd723d314152$export$2e2bcd8739ae039; });

var $5YM7L = parcelRequire("5YM7L");

var $91i6m = parcelRequire("91i6m");

var $aA6j8 = parcelRequire("aA6j8");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $964fcd723d314152$var$getScrollDistance() {
    var _document$documentEle, _document$body;
    return window.pageYOffset || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.scrollTop) || ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.scrollTop) || 0;
}
function $964fcd723d314152$export$2e2bcd8739ae039() {
    var _useState = (0, $91i6m.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), scrollTopOffset = _useState2[0], setScrollTopOffset = _useState2[1];
    (0, $91i6m.useLayoutEffect)(function() {
        setScrollTopOffset($964fcd723d314152$var$getScrollDistance());
    }, []);
    var onWindowScroll = (0, $91i6m.useCallback)(function() {
        if ($964fcd723d314152$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $91i6m.useEffect)(function() {
        return (0, $aA6j8.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});

parcelRegister("9UiWN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73680a90f29c81e3$export$2e2bcd8739ae039; });
/* modal-dialog.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $5YM7L = parcelRequire("5YM7L");

var $61RDg = parcelRequire("61RDg");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $bb3nf = parcelRequire("bb3nf");

var $a4cH2 = parcelRequire("a4cH2");

var $lD6mB = parcelRequire("lD6mB");

var $5MIvA = parcelRequire("5MIvA");

var $8iz5R = parcelRequire("8iz5R");
parcelRequire("1s0cd");
var $hCjOC = parcelRequire("hCjOC");

var $dJMMy = parcelRequire("dJMMy");

var $gxdER = parcelRequire("gxdER");

var $37iGw = parcelRequire("37iGw");

var $iVtII = parcelRequire("iVtII");

var $fkBRZ = parcelRequire("fkBRZ");

var $5UTBq = parcelRequire("5UTBq");

var $kNXMC = parcelRequire("kNXMC");
var $73680a90f29c81e3$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
var $73680a90f29c81e3$var$dialogStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1e0c1txw _1bsb1osq _p12fauwl _4t3i1osq _1tkeidpf _c71l1kxc _2lx21bp4 _bfhk1bhr _syaz1fxt _1q1l1bhr _lcxv1wug _1mq81kw7 _m01u1kw7 _1dg11kw7 _mizu1p6i _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y _we1i1kw7 _zg7p1cd0 _yakv1kw7 _4lht1kw7 _1xlt6m9r",
    borderRadius: "_epkxfajl"
};
var $73680a90f29c81e3$var$viewportScrollStyles = null;
var $73680a90f29c81e3$var$bodyScrollStyles = null;
var $73680a90f29c81e3$var$ModalDialog = function ModalDialog(props) {
    var _props$width = props.width, width = _props$width === void 0 ? 'medium' : _props$width, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, shouldCloseOnEscapePress = props.shouldCloseOnEscapePress, autoFocus = props.autoFocus, stackIndex = props.stackIndex, onClose = props.onClose, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, height = props.height, hasProvidedOnClose = props.hasProvidedOnClose, children = props.children, label = props.label, testId = props.testId, _props$isFullScreen = props.isFullScreen, isFullScreen = _props$isFullScreen === void 0 ? false : _props$isFullScreen;
    var id = (0, $lD6mB.useId)();
    var titleId = "modal-dialog-title-".concat(id);
    var defaultTestId = testId || 'modal-dialog';
    (0, $91i6m.useEffect)(function() {
        // Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        return (0, $hCjOC.combine)((0, $37iGw.disableDraggingToCrossOriginIFramesForElement)(), (0, $fkBRZ.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $iVtII.disableDraggingToCrossOriginIFramesForExternal)());
    }, []);
    (0, $a4cH2.default)((0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(autoFocus) === 'object' ? autoFocus : undefined, // When a user supplies  a ref to focus we enable this hook
    (0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(autoFocus) === 'object');
    var _useOnMotionFinish = (0, $gxdER.default)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    }), _useOnMotionFinish2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useOnMotionFinish, 2), motionRef = _useOnMotionFinish2[0], onMotionFinish = _useOnMotionFinish2[1];
    var modalDialogContext = (0, $91i6m.useMemo)(function() {
        return {
            testId: defaultTestId,
            titleId: titleId,
            onClose: onClose,
            hasProvidedOnClose: hasProvidedOnClose,
            isFullScreen: isFullScreen
        };
    }, [
        defaultTestId,
        titleId,
        onClose,
        hasProvidedOnClose,
        isFullScreen
    ]);
    (0, $5MIvA.useCloseOnEscapePress)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    var _useLayering = (0, $5MIvA.useLayering)(), currentLevel = _useLayering.currentLevel;
    return /*#__PURE__*/ $91i6m.createElement((0, $kNXMC.default), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: defaultTestId,
        isFullScreen: isFullScreen
    }, /*#__PURE__*/ $91i6m.createElement((0, $dJMMy.ModalContext).Provider, {
        value: modalDialogContext
    }, /*#__PURE__*/ $91i6m.createElement((0, $dJMMy.ScrollContext).Provider, {
        value: shouldScrollInViewport
    }, /*#__PURE__*/ $91i6m.createElement((0, $8iz5R.default), {
        entranceDirection: isFullScreen ? undefined : 'bottom',
        onFinish: onMotionFinish
    }, function(bottomFadeInProps) {
        return /*#__PURE__*/ $91i6m.createElement("section", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, bottomFadeInProps, {
            "aria-label": label,
            ref: (0, $bb3nf.default)([
                bottomFadeInProps.ref,
                motionRef
            ]),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-width': (0, $5UTBq.dialogWidth)(width),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-height': (0, $5UTBq.dialogHeight)(height)
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $9gzWK.default)([
                $73680a90f29c81e3$var$dialogStyles.root,
                !isFullScreen && $73680a90f29c81e3$var$dialogStyles.borderRadius,
                shouldScrollInViewport ? "_1tke1kxc _c71lglyw _8kn617ks" : "_cbiz17ks _bolh1kw7",
                bottomFadeInProps.className
            ]),
            role: "dialog",
            "aria-labelledby": label ? undefined : titleId,
            "data-testid": defaultTestId,
            "data-modal-stack": stackIndex,
            tabIndex: -1,
            "aria-modal": true,
            "data-ds--level": currentLevel
        }), children);
    }))));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$73680a90f29c81e3$export$2e2bcd8739ae039 = $73680a90f29c81e3$var$ModalDialog;

});
parcelRegister("1s0cd", function(module, exports) {

$parcel$export(module.exports, "combine", function () { return (parcelRequire("hCjOC")).combine; });

var $hCjOC = parcelRequire("hCjOC");

});
parcelRegister("hCjOC", function(module, exports) {

$parcel$export(module.exports, "combine", function () { return $cd355b343b0f9c2c$export$1be1fc439b849fdf; });
/** Create a new combined function that will call all the provided functions */ function $cd355b343b0f9c2c$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function cleanup() {
        fns.forEach(function(fn) {
            return fn();
        });
    };
}

});


parcelRegister("dJMMy", function(module, exports) {

$parcel$export(module.exports, "ModalContext", function () { return $a005516dea7edc55$export$ab57792b9b6974a6; });
$parcel$export(module.exports, "ScrollContext", function () { return $a005516dea7edc55$export$dece24112a937f92; });

var $91i6m = parcelRequire("91i6m");
var $a005516dea7edc55$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $91i6m.createContext)(null);
var $a005516dea7edc55$export$dece24112a937f92 = /*#__PURE__*/ (0, $91i6m.createContext)(null);

});

parcelRegister("gxdER", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c09a52a02f418968$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");
function $c09a52a02f418968$export$2e2bcd8739ae039(_ref) {
    var onOpenComplete = _ref.onOpenComplete, onCloseComplete = _ref.onCloseComplete;
    var motionRef = (0, $91i6m.useRef)(null);
    var onMotionFinish = (0, $91i6m.useCallback)(function(state) {
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}

});

parcelRegister("37iGw", function(module, exports) {

$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForElement", function () { return $245084f0b3b74671$export$ec28e97c7d8b1b35; });

var $aA6j8 = parcelRequire("aA6j8");
parcelRequire("1s0cd");
var $hCjOC = parcelRequire("hCjOC");
parcelRequire("41itq");
var $lSJkT = parcelRequire("lSJkT");

var $9lE1T = parcelRequire("9lE1T");
function $245084f0b3b74671$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var unbindEvents = (0, $aA6j8.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: 'pointerdown',
            listener: stop
        },
        {
            // The user did not start a drag
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: 'dragstart',
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $lSJkT.monitorForElements)({
        onGenerateDragPreview: function onGenerateDragPreview() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $hCjOC.combine)(unbindEvents, unbindMonitor);
}
function $245084f0b3b74671$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $aA6j8.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener: function listener(event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
var $245084f0b3b74671$var$api = (0, $9lE1T.makeFixForAdapter)({
    watchForInteractionStart: $245084f0b3b74671$var$watchForInteractionStart,
    watchForInteractionEnd: $245084f0b3b74671$var$watchForInteractionEnd
});
function $245084f0b3b74671$export$ec28e97c7d8b1b35() {
    return $245084f0b3b74671$var$api.registerUsage();
}

});
parcelRegister("41itq", function(module, exports) {

$parcel$export(module.exports, "monitorForElements", function () { return (parcelRequire("lSJkT")).monitorForElements; });

var $lSJkT = parcelRequire("lSJkT");
 // Payload for the draggable being dragged

});
parcelRegister("lSJkT", function(module, exports) {

$parcel$export(module.exports, "monitorForElements", function () { return $fee1ceec3a8e3e07$export$59a074bac4c54f54; });

var $5YM7L = parcelRequire("5YM7L");

var $aA6j8 = parcelRequire("aA6j8");

var $khRm6 = parcelRequire("khRm6");

var $bRNeT = parcelRequire("bRNeT");

var $fd7XG = parcelRequire("fd7XG");

var $hCjOC = parcelRequire("hCjOC");

var $8B0DV = parcelRequire("8B0DV");

var $8M7n4 = parcelRequire("8M7n4");

var $bhnTv = parcelRequire("bhnTv");

var $7IH4c = parcelRequire("7IH4c");

var $hKlku = parcelRequire("hKlku");

var $aaf3t = parcelRequire("aaf3t");

var $78cjl = parcelRequire("78cjl");
var $fee1ceec3a8e3e07$var$draggableRegistry = new WeakMap();
function $fee1ceec3a8e3e07$var$addToRegistry(args) {
    $fee1ceec3a8e3e07$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $fee1ceec3a8e3e07$var$draggableRegistry.delete(args.element);
    };
}
var $fee1ceec3a8e3e07$var$honeyPotFix = (0, $bRNeT.makeHoneyPotFix)();
var $fee1ceec3a8e3e07$var$adapter = (0, $fd7XG.makeAdapter)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount: function mount(api) {
        /**  Binding event listeners the `document` rather than `window` so that
     * this adapter always gets preference over the text adapter.
     * `document` is the first `EventTarget` under `window`
     * https://twitter.com/alexandereardon/status/1604658588311465985
     */ return (0, $hCjOC.combine)($fee1ceec3a8e3e07$var$honeyPotFix.bindEvents(), (0, $aA6j8.bind)(document, {
            type: 'dragstart',
            listener: function listener(event) {
                var _entry$dragHandle, _entry$getInitialData, _entry$getInitialData2, _entry$dragHandle2, _entry$getInitialData3, _entry$getInitialData4;
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                var target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return null;
                // see if the thing being dragged is owned by us
                var entry = $fee1ceec3a8e3e07$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return null;
                /**
         * A text selection drag _can_ have the `draggable` element be
         * the `event.target` if the user is dragging the text selection
         * from the `draggable`.
         *
         * To know if the `draggable` is being dragged, we look at whether any
         * `"text/plain"` data is being dragged. If it is, then a text selection
         * drag is occurring.
         *
         * This behaviour has been validated on:
         *
         * - Chrome@128 on Android@14
         * - Chrome@128 on iOS@17.6.1
         * - Chrome@128 on Windows@11
         * - Chrome@128 on MacOS@14.6.1
         * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
         * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
         *
         * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
         * but unfortunately ProseMirror is always setting `""` as the dragged text
         *
         * Note: Unfortunately editor is (heavily) leaning on the current functionality today
         * and unwinding it will be a decent amount of effort. So for now, a text selection
         * where the `event.target` is a `draggable` element will still trigger the
         * element adapter.
         *
         * // Future state:
         * if(event.dataTransfer.getData(textMediaType)) {
         * 	return;
         * }
         *
         */ var input = (0, $7IH4c.getInput)(event);
                var feedback = {
                    element: entry.element,
                    dragHandle: (_entry$dragHandle = entry.dragHandle) !== null && _entry$dragHandle !== void 0 ? _entry$dragHandle : null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return null;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    var over = (0, $khRm6.getElementFromPointWithoutHoneypot)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return null;
                    }
                }
                /**
         *  **Goal**
         *  Pass information to other applications
         *
         * **Approach**
         *  Put data into the native data store
         *
         *  **What about the native adapter?**
         *  When the element adapter puts native data into the native data store
         *  the native adapter is not triggered in the current window,
         *  but a native adapter in an external window _can_ be triggered
         *
         *  **Why bake this into core?**
         *  This functionality could be pulled out and exposed inside of
         *  `onGenerateDragPreview`. But decided to make it a part of the
         *  base API as it felt like a common enough use case and ended
         *  up being a similar amount of code to include this function as
         *  it was to expose the hook for it
         */ var nativeData = (_entry$getInitialData = (_entry$getInitialData2 = entry.getInitialDataForExternal) === null || _entry$getInitialData2 === void 0 ? void 0 : _entry$getInitialData2.call(entry, feedback)) !== null && _entry$getInitialData !== void 0 ? _entry$getInitialData : null;
                if (nativeData) for(var _i = 0, _Object$entries = Object.entries(nativeData); _i < _Object$entries.length; _i++){
                    var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], data = _Object$entries$_i[1];
                    event.dataTransfer.setData(key, data !== null && data !== void 0 ? data : '');
                }
                /**
         *  📱 For Android devices, a drag operation will not start unless
         * "text/plain" or "text/uri-list" data exists in the native data store
         * https://twitter.com/alexandereardon/status/1732189803754713424
         *
         * Tested on:
         * Device: Google Pixel 5
         * Android version: 14 (November 5, 2023)
         * Chrome version: 120.0
         */ if ((0, $bhnTv.isAndroid)() && !event.dataTransfer.types.includes((0, $hKlku.textMediaType)) && !event.dataTransfer.types.includes((0, $aaf3t.URLMediaType))) event.dataTransfer.setData((0, $hKlku.textMediaType), (0, $bhnTv.androidFallbackText));
                /**
         * 1. Must set any media type for `iOS15` to work
         * 2. We are also doing adding data so that the native adapter
         * can know that the element adapter has handled this drag
         *
         * We used to wrap this `setData()` in a `try/catch` for Firefox,
         * but it looks like that was not needed.
         *
         * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
         *
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
         * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
         *
         * // just checking a few more combinations to be super safe
         *
         * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
         * - ✅ Chrome@78 (Oct 2019) on Windows 10
         * - ✅ Safari@14.1 on macOS Big Sur
         */ event.dataTransfer.setData((0, $78cjl.elementAdapterNativeDataKey), '');
                var payload = {
                    element: entry.element,
                    dragHandle: (_entry$dragHandle2 = entry.dragHandle) !== null && _entry$dragHandle2 !== void 0 ? _entry$dragHandle2 : null,
                    data: (_entry$getInitialData3 = (_entry$getInitialData4 = entry.getInitialData) === null || _entry$getInitialData4 === void 0 ? void 0 : _entry$getInitialData4.call(entry, feedback)) !== null && _entry$getInitialData3 !== void 0 ? _entry$getInitialData3 : {}
                };
                var dragType = {
                    type: 'element',
                    payload: payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: function dispatchEventToSource(_ref) {
        var _draggableRegistry$ge, _draggableRegistry$ge2;
        var eventName = _ref.eventName, payload = _ref.payload;
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        (_draggableRegistry$ge = $fee1ceec3a8e3e07$var$draggableRegistry.get(payload.source.element)) === null || _draggableRegistry$ge === void 0 || (_draggableRegistry$ge2 = _draggableRegistry$ge[eventName]) === null || _draggableRegistry$ge2 === void 0 || _draggableRegistry$ge2.call(_draggableRegistry$ge, // I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $fee1ceec3a8e3e07$var$honeyPotFix.getOnPostDispatch()
});
var $fee1ceec3a8e3e07$export$e7140b68045b5036 = $fee1ceec3a8e3e07$var$adapter.dropTarget;
var $fee1ceec3a8e3e07$export$59a074bac4c54f54 = $fee1ceec3a8e3e07$var$adapter.monitor;
function $fee1ceec3a8e3e07$export$c746a5152d4ba26c(args) {
    var existing;
    var cleanup = (0, $hCjOC.combine)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $fee1ceec3a8e3e07$var$adapter.registerUsage(), $fee1ceec3a8e3e07$var$addToRegistry(args), (0, $8M7n4.addAttribute)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
    // Wrapping in `once` to prevent unexpected side effects if consumers call
    // the clean up function multiple times.
    return (0, $8B0DV.once)(cleanup);
} /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Arguments given to all feedback functions (eg `canDrag()`) on for a `draggable()` */  /** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForElements()` */  /** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForElements` */ 

});
parcelRegister("khRm6", function(module, exports) {

$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", function () { return $ec4ec879da8b66cf$export$81d0353f25f5dd; });

var $5YM7L = parcelRequire("5YM7L");

var $1FqDJ = parcelRequire("1FqDJ");
function $ec4ec879da8b66cf$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    var _document$elementsFro = document.elementsFromPoint(client.x, client.y), _document$elementsFro2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_document$elementsFro, 2), top = _document$elementsFro2[0], second = _document$elementsFro2[1];
    if (!top) return null;
    if ((0, $1FqDJ.isHoneyPotElement)(top)) return second !== null && second !== void 0 ? second : null;
    return top;
}

});
parcelRegister("1FqDJ", function(module, exports) {

$parcel$export(module.exports, "isHoneyPotElement", function () { return $136e48e58c8d39ab$export$821bdcd739a2706b; });

var $6jCDB = parcelRequire("6jCDB");
function $136e48e58c8d39ab$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $6jCDB.honeyPotDataAttribute));
}

});
parcelRegister("6jCDB", function(module, exports) {

$parcel$export(module.exports, "honeyPotDataAttribute", function () { return $49927d126a7114ed$export$6eafea55f7947469; });
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
var $49927d126a7114ed$export$6eafea55f7947469 = 'data-pdnd-honey-pot';

});



parcelRegister("bRNeT", function(module, exports) {

$parcel$export(module.exports, "makeHoneyPotFix", function () { return $8a3ad6d3885fe229$export$8ecad27c959e89e0; });

var $dsN6L = parcelRequire("dsN6L");

var $aA6j8 = parcelRequire("aA6j8");

var $95BYW = parcelRequire("95BYW");

var $6jCDB = parcelRequire("6jCDB");
function $8a3ad6d3885fe229$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8a3ad6d3885fe229$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8a3ad6d3885fe229$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8a3ad6d3885fe229$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8a3ad6d3885fe229$var$honeyPotSize = 2;
var $8a3ad6d3885fe229$var$halfHoneyPotSize = $8a3ad6d3885fe229$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $8a3ad6d3885fe229$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $8a3ad6d3885fe229$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $8a3ad6d3885fe229$var$halfHoneyPotSize,
        y: point.y - $8a3ad6d3885fe229$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $8a3ad6d3885fe229$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $8a3ad6d3885fe229$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $8a3ad6d3885fe229$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $8a3ad6d3885fe229$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $8a3ad6d3885fe229$var$getHoneyPotRectFor(_ref) {
    var client = _ref.client;
    var point = $8a3ad6d3885fe229$var$preventGoingForwardsOffScreen($8a3ad6d3885fe229$var$preventGoingBackwardsOffScreen($8a3ad6d3885fe229$var$pullBackByHalfHoneyPotSize($8a3ad6d3885fe229$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $8a3ad6d3885fe229$var$honeyPotSize,
        height: $8a3ad6d3885fe229$var$honeyPotSize
    });
}
function $8a3ad6d3885fe229$var$getRectStyles(_ref2) {
    var clientRect = _ref2.clientRect;
    return {
        left: "".concat(clientRect.left, "px"),
        top: "".concat(clientRect.top, "px"),
        width: "".concat(clientRect.width, "px"),
        height: "".concat(clientRect.height, "px")
    };
}
function $8a3ad6d3885fe229$var$isWithin(_ref3) {
    var client = _ref3.client, clientRect = _ref3.clientRect;
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $8a3ad6d3885fe229$var$mountHoneyPot(_ref4) {
    var initial = _ref4.initial;
    var element = document.createElement('div');
    element.setAttribute((0, $6jCDB.honeyPotDataAttribute), 'true');
    // can shift during the drag thanks to Firefox
    var clientRect = $8a3ad6d3885fe229$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, $8a3ad6d3885fe229$var$_objectSpread($8a3ad6d3885fe229$var$_objectSpread({
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: 'transparent',
        position: 'fixed',
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: 'border-box'
    }, $8a3ad6d3885fe229$var$getRectStyles({
        clientRect: clientRect
    })), {}, {
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: 'auto',
        // Want to make sure the honey pot is top of everything else.
        // Don't need to worry about native drag previews, as they will
        // have been rendered (and removed) before the honey pot is rendered
        zIndex: (0, $95BYW.maxZIndex)
    }));
    document.body.appendChild(element);
    /**
   *  🦊 In firefox we can get `"pointermove"` events after the drag
   * has started, which is a spec violation.
   * The final `"pointermove"` will reveal where the "depressed" position
   * is for our honey pot fix.
   */ var unbindPointerMove = (0, $aA6j8.bind)(window, {
        type: 'pointermove',
        listener: function listener(event) {
            var client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $8a3ad6d3885fe229$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $8a3ad6d3885fe229$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish(_ref5) {
        var current = _ref5.current;
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($8a3ad6d3885fe229$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        var unbindPostDragEvents = (0, $aA6j8.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $8a3ad6d3885fe229$export$8ecad27c959e89e0() {
    var latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $aA6j8.bind)(window, {
            type: 'pointermove',
            listener: function listener(event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        var finish = null;
        return function onPostEvent(_ref6) {
            var eventName = _ref6.eventName, payload = _ref6.payload;
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === 'onDragStart') {
                var input = payload.location.initial.input;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                var initial = latestPointerMove !== null && latestPointerMove !== void 0 ? latestPointerMove : {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $8a3ad6d3885fe229$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === 'onDrop') {
                var _finish;
                var _input = payload.location.current.input;
                (_finish = finish) === null || _finish === void 0 || _finish({
                    current: {
                        x: _input.clientX,
                        y: _input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}

});
parcelRegister("95BYW", function(module, exports) {

$parcel$export(module.exports, "maxZIndex", function () { return $69e20b199a74634d$export$7d0a15ee70427305; });
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
var $69e20b199a74634d$export$7d0a15ee70427305 = 2147483647;

});


parcelRegister("fd7XG", function(module, exports) {

$parcel$export(module.exports, "makeAdapter", function () { return $b12e3eeee629901b$export$2aa3a33160990d96; });

var $lLtfF = parcelRequire("lLtfF");

var $kshEo = parcelRequire("kshEo");

var $keIXf = parcelRequire("keIXf");

var $8f23R = parcelRequire("8f23R");
function $b12e3eeee629901b$export$2aa3a33160990d96(_ref) {
    var typeKey = _ref.typeKey, mount = _ref.mount, dispatchEventToSource = _ref.dispatchEventToSource, onPostDispatch = _ref.onPostDispatch, defaultDropEffect = _ref.defaultDropEffect;
    var monitorAPI = (0, $8f23R.makeMonitor)();
    var dropTargetAPI = (0, $keIXf.makeDropTarget)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource === null || dispatchEventToSource === void 0 || dispatchEventToSource(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch === null || onPostDispatch === void 0 || onPostDispatch(args);
    }
    function start(_ref2) {
        var event = _ref2.event, dragType = _ref2.dragType;
        (0, $lLtfF.lifecycle).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            var api = {
                canStart: (0, $lLtfF.lifecycle).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $kshEo.register)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}

});
parcelRegister("lLtfF", function(module, exports) {

$parcel$export(module.exports, "lifecycle", function () { return $fd84ad85df1e6aad$export$3efdceeb8ca25c51; });

var $iqLBO = parcelRequire("iqLBO");

var $aA6j8 = parcelRequire("aA6j8");

var $khRm6 = parcelRequire("khRm6");

var $1FqDJ = parcelRequire("1FqDJ");

var $4P1rV = parcelRequire("4P1rV");

var $gEmSy = parcelRequire("gEmSy");

var $7IH4c = parcelRequire("7IH4c");

var $3qw5H = parcelRequire("3qw5H");
var $fd84ad85df1e6aad$var$globalState = {
    isActive: false
};
function $fd84ad85df1e6aad$var$canStart() {
    return !$fd84ad85df1e6aad$var$globalState.isActive;
}
function $fd84ad85df1e6aad$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $fd84ad85df1e6aad$var$hasHierarchyChanged(_ref) {
    var current = _ref.current, next = _ref.next;
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(var i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $fd84ad85df1e6aad$var$start(_ref2) {
    var event = _ref2.event, dragType = _ref2.dragType, getDropTargetsOver = _ref2.getDropTargetsOver, dispatchEvent = _ref2.dispatchEvent;
    if (!$fd84ad85df1e6aad$var$canStart()) return;
    var initial = $fd84ad85df1e6aad$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $fd84ad85df1e6aad$var$globalState.isActive = true;
    var state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $fd84ad85df1e6aad$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    var dispatch = (0, $3qw5H.makeDispatch)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        var hasChanged = $fd84ad85df1e6aad$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        var input = (0, $7IH4c.getInput)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        var target = (0, $1FqDJ.isHoneyPotElement)(event.target) ? (0, $khRm6.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        var nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $fd84ad85df1e6aad$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $fd84ad85df1e6aad$var$globalState.isActive = false;
        unbindEvents();
    }
    var unbindEvents = (0, $aA6j8.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener: function listener(event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener: function listener(event) {
                if (!(0, $4P1rV.isLeavingWindow)({
                    dragLeave: event
                })) return;
                /**
       * At this point we don't know if a drag is being cancelled,
       * or if a drag is leaving the `window`.
       *
       * Both have:
       *   1. "dragleave" (with `relatedTarget: null`)
       *   2. "dragend" (a "dragend" can occur when outside the `window`)
       *
       * **Clearing drop targets**
       *
       * For either case we are clearing the the drop targets
       *
       * - cancelling: we clear drop targets in `"dragend"` anyway
       * - leaving the `window`: we clear the drop targets (to clear stickiness)
       *
       * **Leaving the window and finishing the drag**
       *
       * _internal drags_
       *
       * - The drag continues when the user is outside the `window`
       *   and can resume if the user drags back over the `window`,
       *   or end when the user drops in an external `window`.
       * - We will get a `"dragend"`, or we can listen for other
       *   events to determine the drag is finished when the user re-enters the `window`).
       *
       * _external drags_
       *
       * - We conclude the drag operation.
       * - We have no idea if the user will drag back over the `window`,
       *   or if the drag ends elsewhere.
       * - We will create a new drag if the user re-enters the `window`.
       *
       * **Not updating `input`**
       *
       * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
       * Workaround: intentionally not updating `input` in "dragleave"
       * rather than the users current input values
       * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
       * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
       **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener: function listener(event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $7IH4c.getInput)(event)
                };
                /** If there are no drop targets, then we will get
       * a "drop" event if:
       * - `preventUnhandled()` is being used
       * - there is an unmanaged drop target (eg another library)
       * In these cases, it's up to the consumer
       * to handle the drop if it's not over one of our drop targets
       * - `preventUnhandled()` will cancel the "drop"
       * - unmanaged drop targets can handle the "drop" how they want to
       * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $fd84ad85df1e6aad$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener: function listener(event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $7IH4c.getInput)(event)
                };
                cancel();
            }
        }
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))((0, $gEmSy.getBindingsForBrokenDrags)({
        onDragEnd: cancel
    }))), // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $fd84ad85df1e6aad$var$getNativeSetDragImage(event)
    });
}
function $fd84ad85df1e6aad$var$setDropEffectOnEvent(_ref3) {
    var _current$;
    var event = _ref3.event, current = _ref3.current;
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    var innerMost = (_current$ = current[0]) === null || _current$ === void 0 ? void 0 : _current$.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $fd84ad85df1e6aad$var$getStartLocation(_ref4) {
    var event = _ref4.event, dragType = _ref4.dragType, getDropTargetsOver = _ref4.getDropTargetsOver;
    var input = (0, $7IH4c.getInput)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input: input,
        dropTargets: []
    };
    var dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
var $fd84ad85df1e6aad$export$3efdceeb8ca25c51 = {
    canStart: $fd84ad85df1e6aad$var$canStart,
    start: $fd84ad85df1e6aad$var$start
};

});
parcelRegister("4P1rV", function(module, exports) {

$parcel$export(module.exports, "isLeavingWindow", function () { return $382d0caf5c1d8dbc$export$57d220c74e84a273; });

var $4h9Uz = parcelRequire("4h9Uz");

var $aNroi = parcelRequire("aNroi");

var $j52ST = parcelRequire("j52ST");

var $9fYBy = parcelRequire("9fYBy");
function $382d0caf5c1d8dbc$export$57d220c74e84a273(_ref) {
    var dragLeave = _ref.dragLeave;
    var type = dragLeave.type, relatedTarget = dragLeave.relatedTarget;
    if (type !== 'dragleave') return false;
    if ((0, $aNroi.isSafari)()) return (0, $j52ST.isLeavingWindowInSafari)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   * (foreign element)
   */ if ((0, $4h9Uz.isFirefox)()) return (0, $9fYBy.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is `null` *(standard check)*
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("4h9Uz", function(module, exports) {

$parcel$export(module.exports, "isFirefox", function () { return $31d0702cfbe0e8e3$export$b7d78993b74f766d; });

var $8B0DV = parcelRequire("8B0DV");
var $31d0702cfbe0e8e3$export$b7d78993b74f766d = (0, $8B0DV.once)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});

});
parcelRegister("8B0DV", function(module, exports) {

$parcel$export(module.exports, "once", function () { return $019d74c2840093d8$export$d2de3aaeafa91619; });
/** Provide a function that you only ever want to be called a single time */ function $019d74c2840093d8$export$d2de3aaeafa91619(fn) {
    var cache = null;
    return function wrapped() {
        if (!cache) {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}

});


parcelRegister("aNroi", function(module, exports) {

$parcel$export(module.exports, "isSafari", function () { return $7dc3ba391a331c06$export$95df08bae54cb4df; });

var $8B0DV = parcelRequire("8B0DV");
var $7dc3ba391a331c06$export$95df08bae54cb4df = (0, $8B0DV.once)(function isSafari() {
    var _navigator = navigator, userAgent = _navigator.userAgent;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});

});

parcelRegister("j52ST", function(module, exports) {

$parcel$export(module.exports, "isEnteringWindowInSafari", function () { return $de40b8b578c17d1a$export$de68634bd94ed596; });
$parcel$export(module.exports, "isLeavingWindowInSafari", function () { return $de40b8b578c17d1a$export$f21837c338005454; });

var $aA6j8 = parcelRequire("aA6j8");

var $aNroi = parcelRequire("aNroi");
/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */ // Using symbols for event properties so we don't clash with
// anything on the `event` object
var $de40b8b578c17d1a$var$symbols = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
function $de40b8b578c17d1a$export$de68634bd94ed596(_ref) {
    var dragEnter = _ref.dragEnter;
    if (!(0, $aNroi.isSafari)()) return false;
    return dragEnter.hasOwnProperty($de40b8b578c17d1a$var$symbols.isEnteringWindow);
}
function $de40b8b578c17d1a$export$f21837c338005454(_ref2) {
    var dragLeave = _ref2.dragLeave;
    if (!(0, $aNroi.isSafari)()) return false;
    return dragLeave.hasOwnProperty($de40b8b578c17d1a$var$symbols.isLeavingWindow);
}
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, $aNroi.isSafari)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    var state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $aA6j8.bindAll)(window, [
        {
            type: 'dragstart',
            listener: function listener() {
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: function listener(event) {
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                // @ts-expect-error: adding property to the event object
                event[$de40b8b578c17d1a$var$symbols.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: function listener(event) {
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    // @ts-expect-error: adding property to the event object
                    event[$de40b8b578c17d1a$var$symbols.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();

});

parcelRegister("9fYBy", function(module, exports) {

$parcel$export(module.exports, "isFromAnotherWindow", function () { return $6bd4869896ea3321$export$e46810fef53b5b0e; });
/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $6bd4869896ea3321$var$isNodeLike(target) {
    return 'nodeName' in target;
}
function $6bd4869896ea3321$export$e46810fef53b5b0e(eventTarget) {
    return $6bd4869896ea3321$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}

});


parcelRegister("gEmSy", function(module, exports) {

$parcel$export(module.exports, "getBindingsForBrokenDrags", function () { return $c1f22108e6a4d0f8$export$ac5e5b0daf997b2; });
function $c1f22108e6a4d0f8$export$ac5e5b0daf997b2(_ref) {
    var onDragEnd = _ref.onDragEnd;
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            }()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}

});

parcelRegister("7IH4c", function(module, exports) {

$parcel$export(module.exports, "getInput", function () { return $59ee0c9d7c47c4ec$export$7c112ceec8941e67; });
function $59ee0c9d7c47c4ec$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}

});

parcelRegister("3qw5H", function(module, exports) {

$parcel$export(module.exports, "makeDispatch", function () { return $27ecb16a992cf81d$export$9f13ecc44e83d682; });

var $1NfQO = parcelRequire("1NfQO");
var $27ecb16a992cf81d$var$scheduleOnDrag = (0, $1NfQO.default)(function(fn) {
    return fn();
});
var $27ecb16a992cf81d$var$dragStart = function() {
    var scheduled = null;
    function schedule(fn) {
        var frameId = requestAnimationFrame(function() {
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
}();
function $27ecb16a992cf81d$export$9f13ecc44e83d682(_ref) {
    var source = _ref.source, initial = _ref.initial, dispatchEvent = _ref.dispatchEvent;
    var previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    var dispatch = {
        start: function start(_ref2) {
            var nativeSetDragImage = _ref2.nativeSetDragImage;
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            var location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $27ecb16a992cf81d$var$dragStart.schedule(function() {
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate: function dragUpdate(_ref3) {
            var current = _ref3.current;
            $27ecb16a992cf81d$var$dragStart.flush();
            $27ecb16a992cf81d$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag: function drag(_ref4) {
            var current = _ref4.current;
            $27ecb16a992cf81d$var$scheduleOnDrag(function() {
                $27ecb16a992cf81d$var$dragStart.flush();
                var location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop: function drop(_ref5) {
            var current = _ref5.current, updatedSourcePayload = _ref5.updatedSourcePayload;
            $27ecb16a992cf81d$var$dragStart.flush();
            $27ecb16a992cf81d$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload !== null && updatedSourcePayload !== void 0 ? updatedSourcePayload : source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}

});
parcelRegister("1NfQO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14e6a9b318a2b445$export$2e2bcd8739ae039; });
var $14e6a9b318a2b445$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $14e6a9b318a2b445$export$2e2bcd8739ae039 = $14e6a9b318a2b445$var$rafSchd;

});



parcelRegister("kshEo", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ee441d2b3666e110$export$6503ec6e8aabbaf; });
// Extending `Map` to allow us to link Key and Values together
var $ee441d2b3666e110$var$ledger = new Map();
function $ee441d2b3666e110$var$registerUsage(_ref) {
    var typeKey = _ref.typeKey, mount = _ref.mount;
    var entry = $ee441d2b3666e110$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    var initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $ee441d2b3666e110$var$ledger.set(typeKey, initial);
    return initial;
}
function $ee441d2b3666e110$export$6503ec6e8aabbaf(args) {
    var entry = $ee441d2b3666e110$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $ee441d2b3666e110$var$ledger.delete(args.typeKey);
    };
}

});

parcelRegister("keIXf", function(module, exports) {

$parcel$export(module.exports, "makeDropTarget", function () { return $ebb7fc806a2d21d0$export$47d10e7bd9c81890; });

var $dsN6L = parcelRequire("dsN6L");

var $iqLBO = parcelRequire("iqLBO");

var $hCjOC = parcelRequire("hCjOC");

var $8B0DV = parcelRequire("8B0DV");

var $8M7n4 = parcelRequire("8M7n4");
function $ebb7fc806a2d21d0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ebb7fc806a2d21d0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ebb7fc806a2d21d0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ebb7fc806a2d21d0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ebb7fc806a2d21d0$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $ebb7fc806a2d21d0$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $ebb7fc806a2d21d0$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $ebb7fc806a2d21d0$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $ebb7fc806a2d21d0$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $ebb7fc806a2d21d0$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $ebb7fc806a2d21d0$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $ebb7fc806a2d21d0$export$47d10e7bd9c81890(_ref) {
    var typeKey = _ref.typeKey, defaultDropEffect = _ref.defaultDropEffect;
    var registry = new WeakMap();
    var dropTargetDataAtt = "data-drop-target-for-".concat(typeKey);
    var dropTargetSelector = "[".concat(dropTargetDataAtt, "]");
    function addToRegistry(args) {
        registry.set(args.element, args);
        return function() {
            return registry.delete(args.element);
        };
    }
    function dropTargetForConsumers(args) {
        var existing;
        var cleanup = (0, $hCjOC.combine)((0, $8M7n4.addAttribute)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $8B0DV.once)(cleanup);
    }
    function getActualDropTargets(_ref2) {
        var _args$getData, _args$getData2, _args$getDropEffect, _args$getDropEffect2;
        var source = _ref2.source, target = _ref2.target, input = _ref2.input, _ref2$result = _ref2.result, result = _ref2$result === void 0 ? [] : _ref2$result;
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        var closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        var args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        var feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        var data = (_args$getData = (_args$getData2 = args.getData) === null || _args$getData2 === void 0 ? void 0 : _args$getData2.call(args, feedback)) !== null && _args$getData !== void 0 ? _args$getData : {};
        var dropEffect = (_args$getDropEffect = (_args$getDropEffect2 = args.getDropEffect) === null || _args$getDropEffect2 === void 0 ? void 0 : _args$getDropEffect2.call(args, feedback)) !== null && _args$getDropEffect !== void 0 ? _args$getDropEffect : defaultDropEffect;
        var record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [].concat((0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(result), [
                record
            ])
        });
    }
    function notifyCurrent(_ref3) {
        var eventName = _ref3.eventName, payload = _ref3.payload;
        var _iterator = $ebb7fc806a2d21d0$var$_createForOfIteratorHelper(payload.location.current.dropTargets), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _entry$eventName;
                var record = _step.value;
                var entry = registry.get(record.element);
                var args = $ebb7fc806a2d21d0$var$_objectSpread($ebb7fc806a2d21d0$var$_objectSpread({}, payload), {}, {
                    self: record
                });
                entry === null || entry === void 0 || (_entry$eventName = entry[eventName]) === null || _entry$eventName === void 0 || _entry$eventName.call(entry, // I cannot seem to get the types right here.
                // TS doesn't seem to like that one event can need `nativeSetDragImage`
                // @ts-expect-error
                args);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }
    var actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: function onDropTargetChange(_ref4) {
            var payload = _ref4.payload;
            var isCurrent = new Set(payload.location.current.dropTargets.map(function(record) {
                return record.element;
            }));
            var visited = new Set();
            var _iterator2 = $ebb7fc806a2d21d0$var$_createForOfIteratorHelper(payload.location.previous.dropTargets), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _entry$onDropTargetCh;
                    var record = _step2.value;
                    visited.add(record.element);
                    var entry = registry.get(record.element);
                    var isOver = isCurrent.has(record.element);
                    var args = $ebb7fc806a2d21d0$var$_objectSpread($ebb7fc806a2d21d0$var$_objectSpread({}, payload), {}, {
                        self: record
                    });
                    entry === null || entry === void 0 || (_entry$onDropTargetCh = entry.onDropTargetChange) === null || _entry$onDropTargetCh === void 0 || _entry$onDropTargetCh.call(entry, args);
                    // if we cannot find the drop target in the current array, then it has been left
                    if (!isOver) {
                        var _entry$onDragLeave;
                        entry === null || entry === void 0 || (_entry$onDragLeave = entry.onDragLeave) === null || _entry$onDragLeave === void 0 || _entry$onDragLeave.call(entry, args);
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var _iterator3 = $ebb7fc806a2d21d0$var$_createForOfIteratorHelper(payload.location.current.dropTargets), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var _entry$onDropTargetCh2, _entry$onDragEnter;
                    var _record = _step3.value;
                    // already published an update to this drop target
                    if (visited.has(_record.element)) continue;
                    // at this point we have a new drop target that is being entered into
                    var _args = $ebb7fc806a2d21d0$var$_objectSpread($ebb7fc806a2d21d0$var$_objectSpread({}, payload), {}, {
                        self: _record
                    });
                    var _entry = registry.get(_record.element);
                    _entry === null || _entry === void 0 || (_entry$onDropTargetCh2 = _entry.onDropTargetChange) === null || _entry$onDropTargetCh2 === void 0 || _entry$onDropTargetCh2.call(_entry, _args);
                    _entry === null || _entry === void 0 || (_entry$onDragEnter = _entry.onDragEnter) === null || _entry$onDragEnter === void 0 || _entry$onDragEnter.call(_entry, _args);
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver(_ref5) {
        var source = _ref5.source, target = _ref5.target, input = _ref5.input, current = _ref5.current;
        var actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        var lastCaptureOrdered = $ebb7fc806a2d21d0$var$copyReverse(current);
        var actualCaptureOrdered = $ebb7fc806a2d21d0$var$copyReverse(actual);
        var resultCaptureOrdered = [];
        for(var index = 0; index < lastCaptureOrdered.length; index++){
            var _argsForLast$getIsSti;
            var last = lastCaptureOrdered[index];
            var fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            var parent = resultCaptureOrdered[index - 1];
            var lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if ((parent === null || parent === void 0 ? void 0 : parent.element) !== (lastParent === null || lastParent === void 0 ? void 0 : lastParent.element)) break;
            // We need to check whether the old drop target can still be dropped on
            var argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            var feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!((_argsForLast$getIsSti = argsForLast.getIsSticky) !== null && _argsForLast$getIsSti !== void 0 && _argsForLast$getIsSti.call(argsForLast, feedback))) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push($ebb7fc806a2d21d0$var$_objectSpread($ebb7fc806a2d21d0$var$_objectSpread({}, last), {}, {
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            }));
        }
        // return bubble ordered result
        return $ebb7fc806a2d21d0$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}

});
parcelRegister("8M7n4", function(module, exports) {

$parcel$export(module.exports, "addAttribute", function () { return $66388625b2e6fd9b$export$5dcb5c23b6ba980a; });
function $66388625b2e6fd9b$export$5dcb5c23b6ba980a(element, _ref) {
    var attribute = _ref.attribute, value = _ref.value;
    element.setAttribute(attribute, value);
    return function() {
        return element.removeAttribute(attribute);
    };
}

});


parcelRegister("8f23R", function(module, exports) {

$parcel$export(module.exports, "makeMonitor", function () { return $600152c77867ca1c$export$5dd4ed888d5b12ca; });

var $dsN6L = parcelRequire("dsN6L");

var $8B0DV = parcelRequire("8B0DV");
function $600152c77867ca1c$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $600152c77867ca1c$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $600152c77867ca1c$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $600152c77867ca1c$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $600152c77867ca1c$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $600152c77867ca1c$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $600152c77867ca1c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $600152c77867ca1c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $600152c77867ca1c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $600152c77867ca1c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $600152c77867ca1c$export$5dd4ed888d5b12ca() {
    var registry = new Set();
    var dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        var entry = $600152c77867ca1c$var$_objectSpread({}, args);
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        }
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $8B0DV.once)(cleanup);
    }
    function dispatchEvent(_ref) {
        var eventName = _ref.eventName, payload = _ref.payload;
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            var _iterator = $600152c77867ca1c$var$_createForOfIteratorHelper(registry), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var monitor = _step.value;
                    tryAddToActive(monitor);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        var active = Array.from(dragging.active);
        for(var _i = 0, _active = active; _i < _active.length; _i++){
            var _monitor = _active[_i];
            // A monitor can be removed by another monitor during an event.
            // We need to check that the monitor is still registered before calling it
            if (dragging.active.has(_monitor)) {
                var _monitor$eventName;
                // @ts-expect-error: I cannot get this type working!
                (_monitor$eventName = _monitor[eventName]) === null || _monitor$eventName === void 0 || _monitor$eventName.call(_monitor, payload);
            }
        }
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}

});


parcelRegister("bhnTv", function(module, exports) {

$parcel$export(module.exports, "isAndroid", function () { return $8363d12a2807603f$export$a11b0059900ceec8; });
$parcel$export(module.exports, "androidFallbackText", function () { return $8363d12a2807603f$export$aceb3ed8b7f7bd2c; });

var $8B0DV = parcelRequire("8B0DV");
var $8363d12a2807603f$export$a11b0059900ceec8 = (0, $8B0DV.once)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
var $8363d12a2807603f$export$aceb3ed8b7f7bd2c = 'pdnd:android-fallback';

});

parcelRegister("hKlku", function(module, exports) {

$parcel$export(module.exports, "textMediaType", function () { return $ceb747239e0fb9a7$export$fd3d00026297c0ad; });
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $ceb747239e0fb9a7$export$fd3d00026297c0ad = 'text/plain';

});

parcelRegister("aaf3t", function(module, exports) {

$parcel$export(module.exports, "URLMediaType", function () { return $7666842a4a6b951f$export$4c44a460f123106; });
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $7666842a4a6b951f$export$4c44a460f123106 = 'text/uri-list';

});

parcelRegister("78cjl", function(module, exports) {

$parcel$export(module.exports, "elementAdapterNativeDataKey", function () { return $5312d478b33b193e$export$c9c4cc54e73b125d; });
/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ var $5312d478b33b193e$export$c9c4cc54e73b125d = 'application/vnd.pdnd';

});



parcelRegister("9lE1T", function(module, exports) {

$parcel$export(module.exports, "makeFixForAdapter", function () { return $6ce52042ecee47b9$export$a74bff2507e6126b; });

var $iqLBO = parcelRequire("iqLBO");
parcelRequire("1s0cd");
var $hCjOC = parcelRequire("hCjOC");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $6ce52042ecee47b9$var$setStyle(el, _ref) {
    var property = _ref.property, rule = _ref.rule, _ref$priority = _ref.priority, priority = _ref$priority === void 0 ? '' : _ref$priority;
    var originalValue = el.style.getPropertyValue(property);
    var originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $6ce52042ecee47b9$var$hasSameOrigin(href1, href2) {
    var url1;
    var url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch (error) {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $6ce52042ecee47b9$var$isIframeOnAnotherDomain(iframe) {
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
   */ if (iframe.srcdoc) return false;
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
   */ if (iframe.src.startsWith('data:')) return false;
    return !$6ce52042ecee47b9$var$hasSameOrigin(window.location.href, iframe.src);
}
var $6ce52042ecee47b9$var$registry = new Map();
function $6ce52042ecee47b9$var$applyFix(watchForEndOfInteraction) {
    var iframes = Array.from(document.querySelectorAll('iframe')).filter($6ce52042ecee47b9$var$isIframeOnAnotherDomain);
    var cleanups = iframes.map(function(iframe) {
        var entry = $6ce52042ecee47b9$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $6ce52042ecee47b9$var$setStyle(iframe, {
                    property: 'pointer-events',
                    rule: 'none',
                    priority: 'important'
                }),
                count: 1
            };
            $6ce52042ecee47b9$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $6ce52042ecee47b9$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $hCjOC.combine).apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(cleanups))();
    }
    var cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $6ce52042ecee47b9$export$a74bff2507e6126b(_ref2) {
    var watchForInteractionStart = _ref2.watchForInteractionStart, watchForInteractionEnd = _ref2.watchForInteractionEnd;
    var registrationCount = 0;
    var stopWatchingInteractionStart = null;
    function start() {
        $6ce52042ecee47b9$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            var _stopWatchingInteract;
            registrationCount--;
            if (registrationCount !== 0) return;
            (_stopWatchingInteract = stopWatchingInteractionStart) === null || _stopWatchingInteract === void 0 || _stopWatchingInteract();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}

});


parcelRegister("iVtII", function(module, exports) {

$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForExternal", function () { return $dc749ab3fe270858$export$27d79116d3a4e7d5; });
parcelRequire("cta2W");
var $5inqP = parcelRequire("5inqP");

var $9lE1T = parcelRequire("9lE1T");
function $dc749ab3fe270858$var$watchForInteractionStart(_ref) {
    var start = _ref.start;
    return (0, $5inqP.monitorForExternal)({
        onDragStart: function onDragStart() {
            start();
        }
    });
}
function $dc749ab3fe270858$var$watchForInteractionEnd(_ref2) {
    var stop = _ref2.stop;
    return (0, $5inqP.monitorForExternal)({
        onDrop: function onDrop() {
            stop();
        }
    });
}
var $dc749ab3fe270858$var$api = (0, $9lE1T.makeFixForAdapter)({
    watchForInteractionStart: $dc749ab3fe270858$var$watchForInteractionStart,
    watchForInteractionEnd: $dc749ab3fe270858$var$watchForInteractionEnd
});
function $dc749ab3fe270858$export$27d79116d3a4e7d5() {
    return $dc749ab3fe270858$var$api.registerUsage();
}

});
parcelRegister("cta2W", function(module, exports) {

$parcel$export(module.exports, "monitorForExternal", function () { return (parcelRequire("5inqP")).monitorForExternal; });

var $5inqP = parcelRequire("5inqP");
 // The data that is being dragged

});
parcelRegister("5inqP", function(module, exports) {

$parcel$export(module.exports, "monitorForExternal", function () { return $3db0cf3dd254e5c8$export$bb1740f3194979c1; });

var $iqLBO = parcelRequire("iqLBO");

var $aA6j8 = parcelRequire("aA6j8");

var $fd7XG = parcelRequire("fd7XG");

var $bhnTv = parcelRequire("bhnTv");

var $ftp0E = parcelRequire("ftp0E");

var $gEmSy = parcelRequire("gEmSy");

var $hKlku = parcelRequire("hKlku");

var $78cjl = parcelRequire("78cjl");
function $3db0cf3dd254e5c8$export$a8e56a860d7957c7(_ref) {
    var type = _ref.type, value = _ref.value;
    // We don't want to expose our private elementAdapter key / value
    if (type === (0, $78cjl.elementAdapterNativeDataKey)) return false;
    // Not exposing "text/plain" if it contains the android fallback text
    // We _could_ add an `isAndroid()` check, but it's probably safest
    // to trim this data out, regardless of what OS we see it on.
    if (type === (0, $hKlku.textMediaType) && value === (0, $bhnTv.androidFallbackText)) return false;
    return true;
}
function $3db0cf3dd254e5c8$export$8c257a3856120a77(transfer) {
    return Array.from(transfer.types).filter(function(type) {
        return $3db0cf3dd254e5c8$export$a8e56a860d7957c7({
            type: type,
            value: transfer.getData(type)
        });
    });
}
function $3db0cf3dd254e5c8$export$8d28cfecded8dcab(dataTransfer) {
    // item.kind is 'string' | 'file'
    // For 'string' item.type is the mimeType (eg 'text/plain')
    // For 'file' item.type is the file type (eg 'image/jpg')
    return Array.from(dataTransfer.items).filter(function(item) {
        return item.kind === 'file' || $3db0cf3dd254e5c8$export$a8e56a860d7957c7({
            type: item.type,
            value: dataTransfer.getData(item.type)
        });
    });
}
var $3db0cf3dd254e5c8$var$didDragStartLocally = false;
var $3db0cf3dd254e5c8$var$adapter = (0, $fd7XG.makeAdapter)({
    typeKey: 'external',
    // for external drags, we are generally making a copy of something that is being dragged
    defaultDropEffect: 'copy',
    mount: function mount(api) {
        // Binding to the `window` so that the element adapter
        // has a chance to get in first on the`document`.
        // We are giving preference to the element adapter.
        return (0, $aA6j8.bind)(window, {
            type: 'dragenter',
            listener: function listener(event) {
                // drag operation was started within the document, it won't be an "external" drag
                if ($3db0cf3dd254e5c8$var$didDragStartLocally) return;
                // Note: not checking if event was cancelled (`event.defaultPrevented`) as
                // cancelling a "dragenter" accepts the drag operation (not prevent it)
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                if (!api.canStart(event)) return;
                if (!(0, $ftp0E.isEnteringWindow)({
                    dragEnter: event
                })) return;
                // Note: not checking types for `elementAdapterNativeDataKey` as we expect to see that
                // key when pdnd started the drag in another document
                var types = $3db0cf3dd254e5c8$export$8c257a3856120a77(event.dataTransfer);
                if (!types.length) return;
                var locked = {
                    types: types,
                    items: [],
                    getStringData: function getStringData() {
                        return null;
                    }
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'external',
                        startedFrom: 'external',
                        payload: locked,
                        getDropPayload: function getDropPayload(event) {
                            // this would be a platform error
                            // trying to handle it gracefully rather than throwing (for now)
                            if (!event.dataTransfer) return locked;
                            var items = $3db0cf3dd254e5c8$export$8d28cfecded8dcab(event.dataTransfer);
                            // need to use `.bind` as `getData` is required
                            // to be run with `event.dataTransfer` as the "this" context
                            var nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                            return {
                                types: types,
                                items: items,
                                // return `null` if there is no result, otherwise string
                                getStringData: function getStringData(mediaType) {
                                    // not dragging the requested type
                                    // return `null` (no result)
                                    if (!types.includes(mediaType)) return null;
                                    // nativeGetData will return `""` when there is no value,
                                    // but at this point we know we will only get explicitly set
                                    // values back as we have checked the `types`.
                                    // `""` can be an explicitly set value.
                                    var value = nativeGetData(mediaType);
                                    // not exposing data for unavailable types
                                    if (!$3db0cf3dd254e5c8$export$a8e56a860d7957c7({
                                        type: mediaType,
                                        value: value
                                    })) return null;
                                    return value;
                                }
                            };
                        }
                    }
                });
            }
        });
    }
});
function $3db0cf3dd254e5c8$export$9edc779df9a85289(args) {
    // not removing unused events, just leaning on the type system
    return $3db0cf3dd254e5c8$var$adapter.dropTarget(args);
}
function $3db0cf3dd254e5c8$export$bb1740f3194979c1(args) {
    // not removing unused events, just leaning on the type system
    return $3db0cf3dd254e5c8$var$adapter.monitor(args);
}
(function startup() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    // A shared single usage registration as we want to capture
    // all external drag operations, even if there are no drop targets
    // on the page yet
    $3db0cf3dd254e5c8$var$adapter.registerUsage();
    // independent of pdnd, we need to keep track of
    // all drag operations so that we can know if a drag operation
    // has started locally
    var idle = {
        type: 'idle'
    };
    var state = idle;
    function clear() {
        if (state.type !== 'dragging') return;
        $3db0cf3dd254e5c8$var$didDragStartLocally = false;
        state.cleanup();
        state = idle;
    }
    function bindEndEvents() {
        return (0, $aA6j8.bindAll)(window, [
            {
                type: 'dragend',
                listener: clear
            }
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))((0, $gEmSy.getBindingsForBrokenDrags)({
            onDragEnd: clear
        }))), // we want to make sure we get all the events,
        // and this helps avoid not seeing events when folks stop
        // them later on the event path
        {
            capture: true
        });
    }
    // we always keep this event listener active
    (0, $aA6j8.bind)(window, {
        type: 'dragstart',
        listener: function listener() {
            // something bad has happened if this is true!
            if (state.type !== 'idle') return;
            // set our global flag
            $3db0cf3dd254e5c8$var$didDragStartLocally = true;
            state = {
                type: 'dragging',
                cleanup: bindEndEvents()
            };
        },
        // binding in the capture phase so these listeners are called
        // before our listeners in the adapters `mount` function
        options: {
            capture: true
        }
    });
})(); /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForExternal` */  /** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForExternal` */ 

});
parcelRegister("ftp0E", function(module, exports) {

$parcel$export(module.exports, "isEnteringWindow", function () { return $b43cf6cba73597dd$export$d1c6f249e893cdf4; });

var $4h9Uz = parcelRequire("4h9Uz");

var $aNroi = parcelRequire("aNroi");

var $j52ST = parcelRequire("j52ST");

var $9fYBy = parcelRequire("9fYBy");
function $b43cf6cba73597dd$export$d1c6f249e893cdf4(_ref) {
    var dragEnter = _ref.dragEnter;
    var type = dragEnter.type, relatedTarget = dragEnter.relatedTarget;
    if (type !== 'dragenter') return false;
    if ((0, $aNroi.isSafari)()) return (0, $j52ST.isEnteringWindowInSafari)({
        dragEnter: dragEnter
    });
    // standard check
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is the `iframe` element in the parent `window`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is an element inside the child `iframe`
   * (foreign element)
   */ if ((0, $4h9Uz.isFirefox)()) return (0, $9fYBy.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is `null` *(standard check)*
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is the `iframe` element in the parent `window`
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});




parcelRegister("fkBRZ", function(module, exports) {

$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForTextSelection", function () { return $b296196af4e1e832$export$9c0606fcefb5d1e2; });

var $aA6j8 = parcelRequire("aA6j8");
parcelRequire("1s0cd");
var $hCjOC = parcelRequire("hCjOC");
parcelRequire("5eIyo");
var $6SQSu = parcelRequire("6SQSu");

var $9lE1T = parcelRequire("9lE1T");
function $b296196af4e1e832$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var frameId = null;
    var unbindEvents = (0, $aA6j8.bindAll)(window, [
        {
            // User is starting another interaction
            type: 'pointerdown',
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            type: 'dragstart',
            listener: function listener() {
                /**
       * The pdnd `onDragStart()` fires in the frame after "dragstart"
       * So we are delaying our isDragging check to give a chance
       * for `onDragStart()` to set the value correctly.
       *
       * Note: could not use "pointercancel" as it is not
       * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
       */ frameId = requestAnimationFrame(function() {
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $6SQSu.monitorForTextSelection)({
        onDragStart: function onDragStart() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $hCjOC.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $b296196af4e1e832$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $aA6j8.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener: function listener() {
            // A text selection drag will only start when there is
            // an active text selection.
            var selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
var $b296196af4e1e832$var$api = (0, $9lE1T.makeFixForAdapter)({
    watchForInteractionStart: $b296196af4e1e832$var$watchForInteractionStart,
    watchForInteractionEnd: $b296196af4e1e832$var$watchForInteractionEnd
});
function $b296196af4e1e832$export$9c0606fcefb5d1e2() {
    return $b296196af4e1e832$var$api.registerUsage();
}

});
parcelRegister("5eIyo", function(module, exports) {

$parcel$export(module.exports, "monitorForTextSelection", function () { return (parcelRequire("6SQSu")).monitorForTextSelection; });

var $6SQSu = parcelRequire("6SQSu");
 // Payload for the text selection being dragged

});
parcelRegister("6SQSu", function(module, exports) {

$parcel$export(module.exports, "monitorForTextSelection", function () { return $5030cdaa0089fb1a$export$2e178e3647f5e6e9; });

var $aA6j8 = parcelRequire("aA6j8");

var $bRNeT = parcelRequire("bRNeT");

var $fd7XG = parcelRequire("fd7XG");

var $hCjOC = parcelRequire("hCjOC");

var $aNroi = parcelRequire("aNroi");

var $lkoqq = parcelRequire("lkoqq");

var $hKlku = parcelRequire("hKlku");

var $78cjl = parcelRequire("78cjl");
function $5030cdaa0089fb1a$var$findTextNode(event) {
    var _event$dataTransfer;
    // Standard: the `event.target` should be the closest `Text` node.
    if (event.target instanceof Text) return event.target;
    // Structuring things this way so that if Safari fixes their bug
    // then the standard check will start working
    if (!(0, $aNroi.isSafari)()) return null;
    /**
   * According to the spec, `event.target` should be the `Text` node that
   * the drag started from when dragging a text selection.
   *
   * → https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
   *
   * However, in Safari the closest `HTMLElement` is returned.
   * So we need to figure out if text is dragging ourselves.
   *
   * → https://bugs.webkit.org/show_bug.cgi?id=268959
   */ if (!(event.target instanceof HTMLElement)) return null;
    // Unlikely that this particular drag is a text selection drag
    if (event.target.draggable) return null;
    // if the drag contains no text data, then not dragging selected text
    // return `null` if there is no dataTransfer, or if `getData()` returns ""
    if (!((_event$dataTransfer = event.dataTransfer) !== null && _event$dataTransfer !== void 0 && _event$dataTransfer.getData((0, $hKlku.textMediaType)))) return null;
    /**
   * Grab the first Text node and use that.
   * Only doing a single level search as that is all we need for this bug.
   */ var text = Array.from(event.target.childNodes).find(function(node) {
        return node.nodeType === Node.TEXT_NODE;
    });
    return text !== null && text !== void 0 ? text : null;
}
var $5030cdaa0089fb1a$var$honeyPotFix = (0, $bRNeT.makeHoneyPotFix)();
var $5030cdaa0089fb1a$var$adapter = (0, $fd7XG.makeAdapter)({
    typeKey: 'text-selection',
    // for text selection, we will usually be making a copy of the text
    defaultDropEffect: 'copy',
    mount: function mount(api) {
        // Binding to the `window` so that the element adapter has a
        // chance to get in first on the `document`.
        // We are giving preference to the element adapter.
        return (0, $hCjOC.combine)($5030cdaa0089fb1a$var$honeyPotFix.bindEvents(), (0, $aA6j8.bind)(window, {
            type: 'dragstart',
            listener: function listener(event) {
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                // Drag is being handled by the element adapter
                if (event.dataTransfer.types.includes((0, $78cjl.elementAdapterNativeDataKey))) return;
                // Something else is handling this drag
                if (!api.canStart(event)) return;
                // no text being dragged
                if (!event.dataTransfer.types.includes((0, $hKlku.textMediaType))) return;
                var target = $5030cdaa0089fb1a$var$findTextNode(event);
                // could not find `Text` node that is being dragged from
                if (!target) return;
                var payload = {
                    // The `Text` node that is the `target` is the `Text` node
                    // that the user started the drag from.
                    // The full text being dragged can be looked up from the `dataTransfer`.
                    target: target,
                    plain: event.dataTransfer.getData((0, $hKlku.textMediaType)),
                    HTML: event.dataTransfer.getData((0, $lkoqq.HTMLMediaType))
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'text-selection',
                        startedFrom: 'internal',
                        payload: payload
                    }
                });
            }
        }));
    },
    onPostDispatch: $5030cdaa0089fb1a$var$honeyPotFix.getOnPostDispatch()
});
function $5030cdaa0089fb1a$export$9bfaa8eb182300d1(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $5030cdaa0089fb1a$var$adapter.dropTarget(args);
}
// A shared single usage registration as any text can be dragged at any time
(function register() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    $5030cdaa0089fb1a$var$adapter.registerUsage();
})();
function $5030cdaa0089fb1a$export$2e178e3647f5e6e9(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $5030cdaa0089fb1a$var$adapter.monitor(args);
} /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Argument given to all feedback functions (eg `canDrop()`) on a `dropTargetForExternal` */  /** Argument given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForExternal` */ 

});
parcelRegister("lkoqq", function(module, exports) {

$parcel$export(module.exports, "HTMLMediaType", function () { return $f86e698d3d3afc23$export$338a9f6c7a1f02b0; });
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $f86e698d3d3afc23$export$338a9f6c7a1f02b0 = 'text/html';

});




parcelRegister("5UTBq", function(module, exports) {

$parcel$export(module.exports, "dialogWidth", function () { return $44ed503e29a8bacc$export$a3da89b899389ed8; });
$parcel$export(module.exports, "dialogHeight", function () { return $44ed503e29a8bacc$export$ceba93bf0bdd16f2; });
var $44ed503e29a8bacc$export$7e3df82ee760448c = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};
var $44ed503e29a8bacc$export$a3da89b899389ed8 = function dialogWidth(input) {
    if (!input) return 'auto';
    var isWidthName = $44ed503e29a8bacc$export$7e3df82ee760448c.values.indexOf(input.toString()) !== -1;
    var widthName = isWidthName && input;
    if (widthName) return "".concat($44ed503e29a8bacc$export$7e3df82ee760448c.widths[widthName], "px");
    return typeof input === 'number' ? "".concat(input, "px") : input;
};
var $44ed503e29a8bacc$export$ceba93bf0bdd16f2 = function dialogHeight(input) {
    if (!input) return 'auto';
    return typeof input === 'number' ? "".concat(input, "px") : input;
};

});

parcelRegister("kNXMC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f256c1edb2fbf9ee$export$2e2bcd8739ae039; });
/* positioner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");
var $5oJNc = parcelRequire("5oJNc");

var $33mLg = parcelRequire("33mLg");

var $sw8Qy = parcelRequire("sw8Qy");

var $f1k1y = parcelRequire("f1k1y");

function $f256c1edb2fbf9ee$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f256c1edb2fbf9ee$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f256c1edb2fbf9ee$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f256c1edb2fbf9ee$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f256c1edb2fbf9ee$var$gutter = 60;
var $f256c1edb2fbf9ee$var$maxWidthDimensions = "calc(100vw - ".concat($f256c1edb2fbf9ee$var$gutter * 2, "px)");
var $f256c1edb2fbf9ee$var$maxHeightDimensions = "calc(100vh - ".concat($f256c1edb2fbf9ee$var$gutter * 2 - 1, "px)");
// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
var $f256c1edb2fbf9ee$var$positionerStyles = null;
var $f256c1edb2fbf9ee$var$scrollStyles = {
    viewport: "_4t3i1wug _kqswh2mm _1sg41wqb _maxs1wug _1jvh1wqb _1uca1wug _eoawglyw",
    body: "_we1i18uh _e8uozwhf _y1k5stnw _5ee41wqb _1urridpf _1juqidpf _yakv1wug _4lht1wug _eoawglyw",
    fullScreen: ""
};
/**
 * TODO: when tidying this feature gate, add `!important` to `scrollStyles.body`
 */ var $f256c1edb2fbf9ee$var$importantBodyFeatureGateStyles = null;
var $f256c1edb2fbf9ee$var$stackTransitionStyles = null;
var $f256c1edb2fbf9ee$var$stackTransformStyles = null;
var $f256c1edb2fbf9ee$var$stackIdleStyles = null;
function $f256c1edb2fbf9ee$var$getScrollBehavior(_ref) {
    var isFullScreen = _ref.isFullScreen, shouldScrollInViewport = _ref.shouldScrollInViewport;
    if (isFullScreen) return 'fullScreen';
    if (shouldScrollInViewport) return 'viewport';
    return 'body';
}
var $f256c1edb2fbf9ee$var$Positioner = function Positioner(props) {
    var children = props.children, stackIndex = props.stackIndex, shouldScrollInViewport = props.shouldScrollInViewport, testId = props.testId, isFullScreen = props.isFullScreen;
    var scrollBehavior = $f256c1edb2fbf9ee$var$getScrollBehavior({
        isFullScreen: isFullScreen,
        shouldScrollInViewport: shouldScrollInViewport
    });
    return /*#__PURE__*/ $91i6m.createElement("div", {
        "data-testid": testId && "".concat(testId, "--positioner"),
        className: (0, $9gzWK.default)([
            "_1e0c1txw _1bsb1osq _p12f1osq _4t3i1osq _kqsw1n9t _1pby16oo _2lx21bp4 _152tidpf _1e02idpf",
            "_k8m01e03 _1bumglyw _sedtglyw",
            stackIndex > 0 ? "_t9ec1b95" : "_t9ecglyw",
            $f256c1edb2fbf9ee$var$scrollStyles[scrollBehavior],
            scrollBehavior === 'body' && (0, $f1k1y.fg)('platform_dst_modal_dialog_AFBH_1489') && "_5ee41kr1"
        ]),
        style: $f256c1edb2fbf9ee$var$_objectSpread($f256c1edb2fbf9ee$var$_objectSpread({}, {
            '--modal-dialog-translate-y': "calc(".concat(stackIndex, "px * ", "var(--ds-space-100, 8px)", ")"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            transitionDuration: "".concat((0, $sw8Qy.durations).medium, "ms"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            transitionTimingFunction: (0, $33mLg.easeInOut)
        }), {}, {
            "--_imv74m": (0, $5oJNc.default)("".concat($f256c1edb2fbf9ee$var$gutter, "px !important"))
        })
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f256c1edb2fbf9ee$export$2e2bcd8739ae039 = $f256c1edb2fbf9ee$var$Positioner;

});
parcelRegister("33mLg", function(module, exports) {

$parcel$export(module.exports, "easeInOut", function () { return $23934ed71650edd4$export$c07234257a03d5e9; });
var $23934ed71650edd4$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
var $23934ed71650edd4$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
var $23934ed71650edd4$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
var $23934ed71650edd4$export$fc825baa2ef870d0 = 'cubic-bezier(0.4,0,0,1)';
var $23934ed71650edd4$export$816ee5d79b5bd9a5 = 'cubic-bezier(0.6,0,0,1)';
var $23934ed71650edd4$export$53ce3390a1a8f2a2 = 'cubic-bezier(0.8,0,0,1)';
var $23934ed71650edd4$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

});





parcelRegister("4PXNb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $385a4e5c7f6c4adc$export$2e2bcd8739ae039; });
/* modal-body.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $9gzWK = parcelRequire("9gzWK");

var $91i6m = parcelRequire("91i6m");

var $llFLf = parcelRequire("llFLf");

var $f1k1y = parcelRequire("f1k1y");

var $8PmdU = parcelRequire("8PmdU");

var $iAa1v = parcelRequire("iAa1v");

var $d9OCr = parcelRequire("d9OCr");
var $385a4e5c7f6c4adc$var$styles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug",
    font: "_11c82smr",
    paddingBlock: "_1rjc1bk5",
    paddingInline: "_18zr1ejb"
};
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $385a4e5c7f6c4adc$var$ModalBody = function ModalBody(props) {
    var children = props.children, userDefinedTestId = props.testId, _props$hasInlinePaddi = props.hasInlinePadding, hasInlinePadding = _props$hasInlinePaddi === void 0 ? true : _props$hasInlinePaddi;
    var _useModal = (0, $8PmdU.useModal)(), modalTestId = _useModal.testId;
    var shouldScrollInViewport = (0, $d9OCr.default)();
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--body");
    return shouldScrollInViewport ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("div", {
        "data-testid": testId,
        className: (0, $9gzWK.default)([
            $385a4e5c7f6c4adc$var$styles.root,
            hasInlinePadding && $385a4e5c7f6c4adc$var$styles.paddingInline,
            (0, $f1k1y.fg)('platform_ads_explicit_font_styles') && $385a4e5c7f6c4adc$var$styles.font
        ])
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $llFLf.TouchScrollable), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iAa1v.default), {
        testId: userDefinedTestId || modalTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("div", {
        "data-testid": testId,
        className: (0, $9gzWK.default)([
            $385a4e5c7f6c4adc$var$styles.root,
            /**
     * Adding block padding for scroll keylines, which are only shown when the scrolling
     * is on the container.
     */ $385a4e5c7f6c4adc$var$styles.paddingBlock,
            hasInlinePadding && $385a4e5c7f6c4adc$var$styles.paddingInline,
            (0, $f1k1y.fg)('platform_ads_explicit_font_styles') && $385a4e5c7f6c4adc$var$styles.font
        ])
    }, children)));
};
var $385a4e5c7f6c4adc$export$2e2bcd8739ae039 = $385a4e5c7f6c4adc$var$ModalBody;

});
parcelRegister("8PmdU", function(module, exports) {

$parcel$export(module.exports, "useModal", function () { return $66d453446ae76ab7$export$33ffd74ebf07f060; });

var $91i6m = parcelRequire("91i6m");

var $dJMMy = parcelRequire("dJMMy");
var $66d453446ae76ab7$export$33ffd74ebf07f060 = function useModal() {
    var modalContext = (0, $91i6m.useContext)((0, $dJMMy.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

});

parcelRegister("iAa1v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8735d3028762c7c$export$2e2bcd8739ae039; });
/* scroll-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5YM7L = parcelRequire("5YM7L");


var $91i6m = parcelRequire("91i6m");

var $aA6j8 = parcelRequire("aA6j8");

var $1NfQO = parcelRequire("1NfQO");

var $da7Sb = parcelRequire("da7Sb");

var $bb3nf = parcelRequire("bb3nf");

var $6A0cm = parcelRequire("6A0cm");

var $lfhpy = parcelRequire("lfhpy");

var $iFRl4 = parcelRequire("iFRl4");
var $d8735d3028762c7c$var$keylineColor = "var(--ds-border, #091E4224)";
var $d8735d3028762c7c$var$styles = {
    base: "_16jlkb7n _1o9zkb7n _i0dl1kw7 _1e0c1kw7 _2lx21kw7 _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _1reo15vq _18m91wug _1jykn7od _wzg61wug",
    topKeyline: "_mqm2v2xi",
    bottomKeyline: "_179rv2xi"
};
var $d8735d3028762c7c$var$keylineHeight = 2;
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ var $d8735d3028762c7c$var$ScrollContainer = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref, ref) {
    var testId = _ref.testId, children = _ref.children;
    var scrollableRef = (0, $91i6m.useRef)(null);
    var _useState = (0, $91i6m.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), showTopKeyline = _useState2[0], setTopKeyline = _useState2[1];
    var _useState3 = (0, $91i6m.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState3, 2), showBottomKeyline = _useState4[0], setBottomKeyline = _useState4[1];
    var _useState5 = (0, $91i6m.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState5, 2), showContentFocus = _useState6[0], setContentFocus = _useState6[1];
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $91i6m.useEffect)(function() {
        var schedule = (0, $1NfQO.default)(function() {
            var target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    var setLazyKeylines = (0, $lfhpy.default)((0, $1NfQO.default)(function() {
        var target = scrollableRef.current;
        if (target) {
            var scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > $d8735d3028762c7c$var$keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - $d8735d3028762c7c$var$keylineHeight);
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $91i6m.useEffect)(function() {
        var target = scrollableRef.current;
        setLazyKeylines();
        var unbindWindowEvent = (0, $aA6j8.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        var unbindTargetEvent = target ? (0, $aA6j8.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, $6A0cm.default);
        return function() {
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iFRl4.default), {
        as: "div",
        isInset: true,
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? 'Scrollable content' : undefined,
        testId: testId && "".concat(testId, "--scrollable"),
        ref: (0, $bb3nf.default)([
            ref,
            scrollableRef
        ]),
        xcss: (0, $da7Sb.cx)($d8735d3028762c7c$var$styles.base, showTopKeyline && $d8735d3028762c7c$var$styles.topKeyline, showBottomKeyline && $d8735d3028762c7c$var$styles.bottomKeyline)
    }, children);
});
$d8735d3028762c7c$var$ScrollContainer.displayName = 'ScrollContainer';
var $d8735d3028762c7c$export$2e2bcd8739ae039 = $d8735d3028762c7c$var$ScrollContainer;

});

parcelRegister("d9OCr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9943617d1b35c8db$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $dJMMy = parcelRequire("dJMMy");
function $9943617d1b35c8db$export$2e2bcd8739ae039() {
    var shouldScrollInViewport = (0, $91i6m.useContext)((0, $dJMMy.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}

});


parcelRegister("e46Ts", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3d6c94e92cde450$export$2e2bcd8739ae039; });
/* modal-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");
var $5oJNc = parcelRequire("5oJNc");

var $8PmdU = parcelRequire("8PmdU");
var $a3d6c94e92cde450$var$footerStyles = null;
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $a3d6c94e92cde450$var$ModalFooter = function ModalFooter(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $8PmdU.useModal)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--footer");
    return /*#__PURE__*/ $91i6m.createElement("div", {
        "data-testid": testId,
        className: (0, $9gzWK.default)([
            "_zulpu2gc _18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bahesu3 _1pfhmufe _85i51ejb _1q51pxbi"
        ]),
        style: {
            "--_t7lu6v": (0, $5oJNc.default)("calc(-1 * ".concat("var(--ds-border-width-outline, 2px)", ")"))
        }
    }, children);
};
var $a3d6c94e92cde450$export$2e2bcd8739ae039 = $a3d6c94e92cde450$var$ModalFooter;

});

parcelRegister("aLzB7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d69e826a790f8a9$export$2e2bcd8739ae039; });
/* modal-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $9gzWK = parcelRequire("9gzWK");
var $5oJNc = parcelRequire("5oJNc");

var $91i6m = parcelRequire("91i6m");

var $c32T7 = parcelRequire("c32T7");
var $lBrex = parcelRequire("lBrex");

var $aFgJD = parcelRequire("aFgJD");

var $8PmdU = parcelRequire("8PmdU");
var $7d69e826a790f8a9$var$headerStyles = null;
var $7d69e826a790f8a9$var$flexStyles = (0, $lBrex.xcss)({
    flexDirection: 'row-reverse',
    width: '100%'
});
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $7d69e826a790f8a9$var$ModalHeader = function ModalHeader(props) {
    var children = props.children, userDefinedTestId = props.testId, _props$hasCloseButton = props.hasCloseButton, hasCloseButton = _props$hasCloseButton === void 0 ? false : _props$hasCloseButton;
    var _useModal = (0, $8PmdU.useModal)(), hasProvidedOnClose = _useModal.hasProvidedOnClose, onClose = _useModal.onClose, modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--header");
    // Only show if an onClose was provided for the modal dialog
    var shouldShowCloseButton = hasCloseButton && hasProvidedOnClose && onClose;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("div", {
        "data-testid": testId,
        className: (0, $9gzWK.default)([
            "_18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bah1yb4 _6rthmufe _85i5pxbi _1q511ejb"
        ]),
        style: {
            "--_t7lu6v": (0, $5oJNc.default)("calc(-1 * ".concat("var(--ds-border-width-outline, 2px)", ")"))
        }
    }, shouldShowCloseButton ? /*#__PURE__*/ // The reason we are putting the close button first in the DOM and then
    // reordering them is to ensure that users of assistive technology get
    // all the context of a modal when initial focus is placed on the close
    // button, since it's the first interactive element.
    (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $c32T7.default), {
        gap: "space.200",
        justifyContent: "space-between",
        xcss: $7d69e826a790f8a9$var$flexStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $c32T7.default), {
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $aFgJD.CloseButton), {
        onClick: onClose,
        testId: modalTestId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $c32T7.default), {
        justifyContent: "start",
        alignItems: "center"
    }, children)) : children);
};
var $7d69e826a790f8a9$export$2e2bcd8739ae039 = $7d69e826a790f8a9$var$ModalHeader;

});
parcelRegister("aFgJD", function(module, exports) {

$parcel$export(module.exports, "CloseButton", function () { return $7c3ab6f7c1c36f79$export$de65de8213222d10; });

var $91i6m = parcelRequire("91i6m");

var $tbh94 = parcelRequire("tbh94");

var $griyM = parcelRequire("griyM");
var $7c3ab6f7c1c36f79$export$de65de8213222d10 = function CloseButton(_ref) {
    var label = _ref.label, onClick = _ref.onClick, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $tbh94.default), {
        testId: testId && "".concat(testId, "--close-button"),
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($griyM))),
        label: label || 'Close Modal',
        onClick: onClick
    });
};

});
parcelRegister("griyM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2c17176afeb2169f76dc501092efdf0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bf7d908ec649ed9e$var$_react = $bf7d908ec649ed9e$var$_interopRequireDefault((parcelRequire("91i6m")));

var $bf7d908ec649ed9e$var$_cross = $bf7d908ec649ed9e$var$_interopRequireDefault((parcelRequire("bat6b")));

var $bf7d908ec649ed9e$var$_cross2 = $bf7d908ec649ed9e$var$_interopRequireDefault((parcelRequire("4bK1k")));
function $bf7d908ec649ed9e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "CrossIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bf7d908ec649ed9e$var$CrossIcon = (props)=>/*#__PURE__*/ $bf7d908ec649ed9e$var$_react.default.createElement($bf7d908ec649ed9e$var$_cross.default, Object.assign({
        name: "CrossIcon",
        LEGACY_fallbackIcon: $bf7d908ec649ed9e$var$_cross2.default
    }, props));
$bf7d908ec649ed9e$var$CrossIcon.displayName = 'CrossIconMigration';
var $bf7d908ec649ed9e$var$_default = module.exports.default = $bf7d908ec649ed9e$var$CrossIcon;

});
parcelRegister("bat6b", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $82173347ab3fcc03$var$_react = $82173347ab3fcc03$var$_interopRequireDefault((parcelRequire("91i6m")));

var $82173347ab3fcc03$var$_baseNew = $82173347ab3fcc03$var$_interopRequireDefault((parcelRequire("6umvx")));
function $82173347ab3fcc03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $82173347ab3fcc03$var$CrossIcon = (props)=>/*#__PURE__*/ $82173347ab3fcc03$var$_react.default.createElement($82173347ab3fcc03$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$82173347ab3fcc03$var$CrossIcon.displayName = 'CrossIcon';
var $82173347ab3fcc03$var$_default = module.exports.default = $82173347ab3fcc03$var$CrossIcon;

});
parcelRegister("6umvx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("iMq8o")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("iMq8o")).Icon; });

var $iMq8o = parcelRequire("iMq8o");

});
parcelRegister("iMq8o", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $dac0fb6c620f875b$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $dac0fb6c620f875b$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $f1k1y = parcelRequire("f1k1y");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $dac0fb6c620f875b$var$svgStyles = null;
var $dac0fb6c620f875b$var$iconStyles = null;
var $dac0fb6c620f875b$var$utilityIconStyles = null;
var $dac0fb6c620f875b$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $dac0fb6c620f875b$var$baseHcmStyles = null;
var $dac0fb6c620f875b$var$scaleSize = null;
var $dac0fb6c620f875b$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $dac0fb6c620f875b$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $dac0fb6c620f875b$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $dac0fb6c620f875b$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $dac0fb6c620f875b$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $dac0fb6c620f875b$export$f04a61298a47a40f = /*#__PURE__*/ (0, $91i6m.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $f1k1y.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $91i6m.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = $dac0fb6c620f875b$var$baseSizeMap[type];
    var viewBoxPadding = $dac0fb6c620f875b$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $91i6m.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $9gzWK.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $91i6m.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $9gzWK.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $dac0fb6c620f875b$var$utilSizes[spacing] : size === 'small' ? $dac0fb6c620f875b$var$coreSizeSmall[spacing] : $dac0fb6c620f875b$var$coreSizeMedium[spacing]
        ])
    }));
});
var $dac0fb6c620f875b$export$2e2bcd8739ae039 = $dac0fb6c620f875b$export$f04a61298a47a40f;

});



parcelRegister("4bK1k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30cbe3380d2bfe9e$var$_react = $30cbe3380d2bfe9e$var$_interopRequireDefault((parcelRequire("91i6m")));

var $bvDJL = parcelRequire("bvDJL");
function $30cbe3380d2bfe9e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $30cbe3380d2bfe9e$var$CrossIcon = (props)=>/*#__PURE__*/ $30cbe3380d2bfe9e$var$_react.default.createElement($bvDJL.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props));
$30cbe3380d2bfe9e$var$CrossIcon.displayName = 'CrossIcon';
var $30cbe3380d2bfe9e$var$_default = module.exports.default = $30cbe3380d2bfe9e$var$CrossIcon;

});
parcelRegister("bvDJL", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $861169e6d0a542fb$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");
function $861169e6d0a542fb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $861169e6d0a542fb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $861169e6d0a542fb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $861169e6d0a542fb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $861169e6d0a542fb$var$iconStyles = null;
var $861169e6d0a542fb$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $861169e6d0a542fb$var$baseHcmStyles = null;
var $861169e6d0a542fb$var$primaryEqualsSecondaryHcmStyles = null;
var $861169e6d0a542fb$var$secondaryTransparentHcmStyles = null;
var $861169e6d0a542fb$export$f04a61298a47a40f = /*#__PURE__*/ (0, $91i6m.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $91i6m.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $91i6m.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $861169e6d0a542fb$var$_objectSpread($861169e6d0a542fb$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $9gzWK.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $861169e6d0a542fb$var$sizeStyles[size]
        ])
    }));
});
var $861169e6d0a542fb$export$2e2bcd8739ae039 = $861169e6d0a542fb$export$f04a61298a47a40f;

});





parcelRegister("5hmIF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d8029e73fbeb20d$export$2e2bcd8739ae039; });
/* modal-title.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $cxCOt = parcelRequire("cxCOt");

var $gEMZT = parcelRequire("gEMZT");

var $8PmdU = parcelRequire("8PmdU");
var $3d8029e73fbeb20d$var$iconColor = {
    danger: "var(--ds-icon-danger, #C9372C)",
    warning: "var(--ds-icon-warning, #E56910)"
};
var $3d8029e73fbeb20d$var$iconStyles = null;
var $3d8029e73fbeb20d$var$titleStyles = null;
var $3d8029e73fbeb20d$var$textStyles = null;
var $3d8029e73fbeb20d$var$truncatedTextStyles = null;
var $3d8029e73fbeb20d$var$TitleIcon = function TitleIcon(_ref) {
    var appearance = _ref.appearance;
    var Icon = appearance === 'danger' ? (0, (/*@__PURE__*/$parcel$interopDefault($cxCOt))) : (0, (/*@__PURE__*/$parcel$interopDefault($gEMZT)));
    return /*#__PURE__*/ $91i6m.createElement("span", {
        className: (0, $9gzWK.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _syaz1kw7 _1wyb1kw7 _zg8l1kw7 _k48p1kw7 _1dyz1kw7 _vwz41kw7"
        ])
    }, /*#__PURE__*/ $91i6m.createElement(Icon, {
        label: appearance,
        color: $3d8029e73fbeb20d$var$iconColor[appearance],
        spacing: "spacious"
    }));
};
/**
 * __Modal title__
 *
 * A modal title is used to display a title within a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $3d8029e73fbeb20d$var$ModalTitle = function ModalTitle(props) {
    var appearance = props.appearance, children = props.children, _props$isMultiline = props.isMultiline, isMultiline = _props$isMultiline === void 0 ? true : _props$isMultiline, userDefinedTestId = props.testId;
    var _useModal = (0, $8PmdU.useModal)(), titleId = _useModal.titleId, modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--title");
    return /*#__PURE__*/ $91i6m.createElement("h1", {
        "data-testid": testId,
        className: (0, $9gzWK.default)([
            "_zulpu2gc _11c8lodh _1e0c1txw _1ul9idpf _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t"
        ])
    }, appearance && /*#__PURE__*/ $91i6m.createElement($3d8029e73fbeb20d$var$TitleIcon, {
        appearance: appearance
    }), /*#__PURE__*/ $91i6m.createElement("span", {
        id: titleId,
        "data-testid": testId && "".concat(testId, "-text"),
        className: (0, $9gzWK.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _slp31hna",
            !isMultiline && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ])
    }, children));
};
var $3d8029e73fbeb20d$export$2e2bcd8739ae039 = $3d8029e73fbeb20d$var$ModalTitle;

});
parcelRegister("cxCOt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f636032ea4a949f6a3ed21b2a88730cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9216ac96d523f0f9$var$_react = $9216ac96d523f0f9$var$_interopRequireDefault((parcelRequire("91i6m")));

var $9216ac96d523f0f9$var$_statusError = $9216ac96d523f0f9$var$_interopRequireDefault((parcelRequire("a7ooX")));

var $9216ac96d523f0f9$var$_error = $9216ac96d523f0f9$var$_interopRequireDefault((parcelRequire("3aDw9")));
function $9216ac96d523f0f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusErrorIcon.
 * This component is StatusErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9216ac96d523f0f9$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $9216ac96d523f0f9$var$_react.default.createElement($9216ac96d523f0f9$var$_statusError.default, Object.assign({
        name: "StatusErrorIcon",
        LEGACY_fallbackIcon: $9216ac96d523f0f9$var$_error.default
    }, props));
$9216ac96d523f0f9$var$StatusErrorIcon.displayName = 'StatusErrorIconMigration';
var $9216ac96d523f0f9$var$_default = module.exports.default = $9216ac96d523f0f9$var$StatusErrorIcon;

});
parcelRegister("a7ooX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75dd7c76b8f4be12$var$_react = $75dd7c76b8f4be12$var$_interopRequireDefault((parcelRequire("91i6m")));

var $75dd7c76b8f4be12$var$_baseNew = $75dd7c76b8f4be12$var$_interopRequireDefault((parcelRequire("6umvx")));
function $75dd7c76b8f4be12$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75dd7c76b8f4be12$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $75dd7c76b8f4be12$var$_react.default.createElement($75dd7c76b8f4be12$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$75dd7c76b8f4be12$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $75dd7c76b8f4be12$var$_default = module.exports.default = $75dd7c76b8f4be12$var$StatusErrorIcon;

});

parcelRegister("3aDw9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $24f0f5a823015f56$var$_react = $24f0f5a823015f56$var$_interopRequireDefault((parcelRequire("91i6m")));

var $bvDJL = parcelRequire("bvDJL");
function $24f0f5a823015f56$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $24f0f5a823015f56$var$ErrorIcon = (props)=>/*#__PURE__*/ $24f0f5a823015f56$var$_react.default.createElement($bvDJL.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$24f0f5a823015f56$var$ErrorIcon.displayName = 'ErrorIcon';
var $24f0f5a823015f56$var$_default = module.exports.default = $24f0f5a823015f56$var$ErrorIcon;

});


parcelRegister("gEMZT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::715767a087f47b16ede12b841c1dd7f2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c20663981c591ced$var$_react = $c20663981c591ced$var$_interopRequireDefault((parcelRequire("91i6m")));

var $c20663981c591ced$var$_statusWarning = $c20663981c591ced$var$_interopRequireDefault((parcelRequire("iCLhW")));

var $c20663981c591ced$var$_warning = $c20663981c591ced$var$_interopRequireDefault((parcelRequire("hEvKR")));
function $c20663981c591ced$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusWarningIcon.
 * This component is StatusWarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c20663981c591ced$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $c20663981c591ced$var$_react.default.createElement($c20663981c591ced$var$_statusWarning.default, Object.assign({
        name: "StatusWarningIcon",
        LEGACY_fallbackIcon: $c20663981c591ced$var$_warning.default
    }, props));
$c20663981c591ced$var$StatusWarningIcon.displayName = 'StatusWarningIconMigration';
var $c20663981c591ced$var$_default = module.exports.default = $c20663981c591ced$var$StatusWarningIcon;

});
parcelRegister("iCLhW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee7b3f114c675eea0f953c33a485bcf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d8f0751afdb2391b$var$_react = $d8f0751afdb2391b$var$_interopRequireDefault((parcelRequire("91i6m")));

var $d8f0751afdb2391b$var$_baseNew = $d8f0751afdb2391b$var$_interopRequireDefault((parcelRequire("6umvx")));
function $d8f0751afdb2391b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d8f0751afdb2391b$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $d8f0751afdb2391b$var$_react.default.createElement($d8f0751afdb2391b$var$_baseNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$d8f0751afdb2391b$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $d8f0751afdb2391b$var$_default = module.exports.default = $d8f0751afdb2391b$var$StatusWarningIcon;

});

parcelRegister("hEvKR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cd9ecdeec7422c04$var$_react = $cd9ecdeec7422c04$var$_interopRequireDefault((parcelRequire("91i6m")));

var $bvDJL = parcelRequire("bvDJL");
function $cd9ecdeec7422c04$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cd9ecdeec7422c04$var$WarningIcon = (props)=>/*#__PURE__*/ $cd9ecdeec7422c04$var$_react.default.createElement($bvDJL.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$cd9ecdeec7422c04$var$WarningIcon.displayName = 'WarningIcon';
var $cd9ecdeec7422c04$var$_default = module.exports.default = $cd9ecdeec7422c04$var$WarningIcon;

});



parcelRegister("63UEK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $469ef8a0d65fc81f$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $erZ2i = parcelRequire("erZ2i");
/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $469ef8a0d65fc81f$var$ModalTransition = function ModalTransition(props) {
    var _props$children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $erZ2i.default), {
        appear: true
    }, (_props$children = props.children) !== null && _props$children !== void 0 ? _props$children : null);
};
var $469ef8a0d65fc81f$export$2e2bcd8739ae039 = $469ef8a0d65fc81f$var$ModalTransition;

});


parcelRegister("QvxZa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "pageId", function () { return $12fe7c0353eb611c$export$703ba2e7ea526c1b; });
$parcel$export(module.exports, "stepUpStartLoader", function () { return $12fe7c0353eb611c$export$3661a07f17c95cba; });
$parcel$export(module.exports, "StepUpStartPage", function () { return $12fe7c0353eb611c$export$e561dacd818ab41; });
$parcel$export(module.exports, "default", function () { return $12fe7c0353eb611c$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $8KhCJ = parcelRequire("8KhCJ");

var $6d87w = parcelRequire("6d87w");
var $l2v8Y = parcelRequire("l2v8Y");

var $9jjaN = parcelRequire("9jjaN");

var $6e88g = parcelRequire("6e88g");

var $gs2u7 = parcelRequire("gs2u7");

var $cLysE = parcelRequire("cLysE");

var $bE8z6 = parcelRequire("bE8z6");

var $7eeh4 = parcelRequire("7eeh4");

var $j85uw = parcelRequire("j85uw");

var $damsD = parcelRequire("damsD");

var $7081r = parcelRequire("7081r");

var $64QTD = parcelRequire("64QTD");

var $21Xgy = parcelRequire("21Xgy");

var $kFsUL = parcelRequire("kFsUL");

var $8Bf3D = parcelRequire("8Bf3D");

var $1V2cH = parcelRequire("1V2cH");

var $2aGBJ = parcelRequire("2aGBJ");

var $9uXJ3 = parcelRequire("9uXJ3");

var $5e2bj = parcelRequire("5e2bj");

var $kpg9c = parcelRequire("kpg9c");

var $3f4xr = parcelRequire("3f4xr");
let $12fe7c0353eb611c$var$_ = (t)=>t, $12fe7c0353eb611c$var$t, $12fe7c0353eb611c$var$t1, $12fe7c0353eb611c$var$t2, $12fe7c0353eb611c$var$t3;
const $12fe7c0353eb611c$export$703ba2e7ea526c1b = 'stepUpOtpChallengeScreen';
const $12fe7c0353eb611c$var$OTP_CODE_LENGTH = 8;
const $12fe7c0353eb611c$var$Form = (0, $9jjaN.default).form($12fe7c0353eb611c$var$t || ($12fe7c0353eb611c$var$t = $12fe7c0353eb611c$var$_`
  margin: ${0}px 0 0;
`), (0, $6e88g.gridSize)());
const $12fe7c0353eb611c$var$ButtonContainer = (0, $9jjaN.default).div($12fe7c0353eb611c$var$t1 || ($12fe7c0353eb611c$var$t1 = $12fe7c0353eb611c$var$_`
  margin-top: ${0}px;
`), (0, $6e88g.gridSize)());
const $12fe7c0353eb611c$var$RequestPasscodeButtonContainer = (0, $9jjaN.default).div($12fe7c0353eb611c$var$t2 || ($12fe7c0353eb611c$var$t2 = $12fe7c0353eb611c$var$_`
  margin-top: ${0}px;
`), 3 * (0, $6e88g.gridSize)());
const $12fe7c0353eb611c$var$SecondaryLinkWrapper = (0, $9jjaN.default).ul($12fe7c0353eb611c$var$t3 || ($12fe7c0353eb611c$var$t3 = $12fe7c0353eb611c$var$_`
  margin-top: ${0}px;
`), (0, $6e88g.gridSize)());
/**
 * This restores the state from session storage and saves it to session storage if it changes.
 */ function $12fe7c0353eb611c$var$useSyncWithSessionStorage(sessionStorageKey, sessionStorageValue, onStorageUpdate) {
    (0, $91i6m.useEffect)(()=>{
        const storageListener = (event)=>{
            if (event.key === sessionStorageKey) {
                if (event.newValue !== sessionStorageValue) onStorageUpdate(event.newValue);
            }
        };
        window.addEventListener('storage', storageListener);
        const sessionStorageItem = window.sessionStorage.getItem(sessionStorageKey);
        if (sessionStorageItem) onStorageUpdate(sessionStorageItem);
        return ()=>{
            window.removeEventListener('storage', storageListener);
        };
    // This code looks intended to only run on component mount. Missing deps assumed okay at the
    // time the linting rule was added, but may need further investigation.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $91i6m.useEffect)(()=>{
        if (sessionStorageValue) window.sessionStorage.setItem(sessionStorageKey, sessionStorageValue);
    }, [
        sessionStorageValue,
        sessionStorageKey
    ]);
    const clearSessionStorage = (0, $91i6m.useCallback)(()=>{
        window.sessionStorage.removeItem(sessionStorageKey);
    }, [
        sessionStorageKey
    ]);
    return [
        clearSessionStorage
    ];
}
async function $12fe7c0353eb611c$export$3661a07f17c95cba({ request: request }) {
    if (!await (0, $3f4xr.checkFeatureGateOnceInitialized)((0, $kpg9c.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $5e2bj.fetchPageState)('/rest/step-up/start/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--mfa'
        ]
    });
}
const $12fe7c0353eb611c$export$e561dacd818ab41 = ()=>{
    (0, $5e2bj.usePageStateLoader)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const intl = (0, $leG06.default)();
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const oidcContext = (0, $2aGBJ.useAppSelector)((state)=>state.microbranding.oidcContext);
    const isMobile = (0, $7eeh4.isMobileOidc)(oidcContext);
    const email = (0, $2aGBJ.useAppSelector)((state)=>state.stepUp.email);
    const mfaToken = (0, $2aGBJ.useAppSelector)((state)=>state.stepUp.mfaToken);
    const dispatchAddFlag = (0, $91i6m.useCallback)((flag)=>dispatch((0, $21Xgy.addFlag)(flag.type, flag.title, flag.description)), [
        dispatch
    ]);
    const [otpCode, setOtpCode] = (0, $91i6m.useState)('');
    const [isLoading, setLoading] = (0, $91i6m.useState)(false);
    const [verificationError, setVerificationError] = (0, $91i6m.useState)();
    const { hash: hash, search: search } = (0, $l2v8Y.useLocation)();
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    const setHash = (0, $91i6m.useCallback)((hash)=>navigate(search + '#' + hash, {
            replace: true
        }), [
        navigate,
        search
    ]);
    const [clearSessionStorageMfaToken] = $12fe7c0353eb611c$var$useSyncWithSessionStorage('mfaToken', mfaToken, (mfaToken)=>{
        dispatch((0, $kFsUL.updateFromSessionStorage)(mfaToken));
    });
    const [manualOtpCodeTriggerMode, setManualOtpCodeTriggerMode] = (0, $91i6m.useState)(()=>{
        return document.visibilityState === 'hidden';
    });
    (0, $1V2cH.usePageViewedEvent)($12fe7c0353eb611c$export$703ba2e7ea526c1b, {
        value: manualOtpCodeTriggerMode ? 'manualOtpSend' : 'autoOtpSend'
    });
    (0, $1V2cH.useOperationalEvent)({
        page: $12fe7c0353eb611c$export$703ba2e7ea526c1b,
        action: `loadStepUpStartPageSuccessful`,
        subject: 'sli'
    });
    const triggerCodeSend = (0, $91i6m.useCallback)(async ()=>{
        const codeSendResult = await dispatch((0, $kFsUL.sendCode)());
        if (codeSendResult.success) {
            analyticsClient.trackingEvent({
                page: $12fe7c0353eb611c$export$703ba2e7ea526c1b,
                subject: 'sendCode',
                action: 'succeed'
            });
            setHash('sent');
        } else if (codeSendResult.errorCode === 'too_many_requests') {
            dispatchAddFlag({
                type: 'error',
                title: (0, $j85uw.default).stepUpStartFlagErrorRateLimitTitle,
                description: (0, $j85uw.default).stepUpStartFlagErrorRateLimitDesc
            });
            analyticsClient.errorShownEvent($12fe7c0353eb611c$export$703ba2e7ea526c1b, 'sendCode', {
                errorCode: codeSendResult.errorCode
            });
        } else {
            dispatchAddFlag({
                type: 'error',
                title: (0, $j85uw.default).stepUpStartFlagErrorTitle,
                description: (0, $j85uw.default).stepUpStartFlagErrorDesc
            });
            analyticsClient.errorShownEvent($12fe7c0353eb611c$export$703ba2e7ea526c1b, 'sendCode', {
                errorCode: codeSendResult.errorCode
            });
        }
    }, [
        analyticsClient,
        dispatch,
        dispatchAddFlag,
        setHash
    ]);
    (0, $91i6m.useEffect)(()=>{
        if (hash === '#sent') analyticsClient.trackingEvent({
            page: $12fe7c0353eb611c$export$703ba2e7ea526c1b,
            subject: 'sendCode',
            action: 'skipped',
            attributes: {
                reason: 'already sent'
            }
        });
        else if (manualOtpCodeTriggerMode) analyticsClient.trackingEvent({
            page: $12fe7c0353eb611c$export$703ba2e7ea526c1b,
            subject: 'sendCode',
            action: 'skipped',
            attributes: {
                reason: 'opened in background'
            }
        });
        else triggerCodeSend().catch(()=>dispatchAddFlag({
                type: 'error',
                title: (0, $j85uw.default).stepUpStartFlagErrorTitle,
                description: (0, $j85uw.default).stepUpStartFlagErrorDesc
            }));
    // We only want to ever trigger this effect once.
    // Otherwise we risk triggering multiple email code sends due to race conditions.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleSubmit = (0, $91i6m.useCallback)(async (e)=>{
        if (e) e.preventDefault();
        analyticsClient.uiEvent({
            page: $12fe7c0353eb611c$export$703ba2e7ea526c1b,
            subject: 'form',
            subjectId: 'otpForm',
            action: 'submitted'
        });
        setLoading(true);
        try {
            const result = await dispatch((0, $kFsUL.verifyOtpCode)(otpCode));
            if ('redirectUri' in result) {
                clearSessionStorageMfaToken();
                analyticsClient.trackingEvent({
                    page: $12fe7c0353eb611c$export$703ba2e7ea526c1b,
                    action: 'succeeded',
                    subject: 'stepUpChallenge'
                });
                navigate(result.redirectUri);
            } else {
                analyticsClient.trackingEvent({
                    page: $12fe7c0353eb611c$export$703ba2e7ea526c1b,
                    action: 'failed',
                    subject: 'stepUpChallenge',
                    attributes: {
                        errorCode: result.errorCode
                    }
                });
                setVerificationError(result);
            }
        } catch (e) {
            const errorCode = 'unknown';
            analyticsClient.trackingEvent({
                page: $12fe7c0353eb611c$export$703ba2e7ea526c1b,
                action: 'failed',
                subject: 'stepUpChallenge',
                attributes: {
                    errorCode: errorCode
                }
            });
            setVerificationError({
                errorCode: errorCode
            });
        } finally{
            setLoading(false);
        }
    }, [
        analyticsClient,
        dispatch,
        otpCode,
        clearSessionStorageMfaToken,
        navigate
    ]);
    (0, $91i6m.useEffect)(()=>{
        if (otpCode.length === $12fe7c0353eb611c$var$OTP_CODE_LENGTH) handleSubmit();
    }, [
        handleSubmit,
        otpCode
    ]);
    const handleInputChange = (e)=>{
        setVerificationError(undefined);
        setOtpCode(e.target.value);
    };
    const handleResendCode = async ()=>{
        analyticsClient.linkClickedEvent($12fe7c0353eb611c$export$703ba2e7ea526c1b, 'resendOtp');
        const result = await dispatch(mfaToken ? (0, $kFsUL.resendCode)() : (0, $kFsUL.sendCode)());
        if (result.success) dispatchAddFlag({
            type: 'success',
            title: (0, $j85uw.default).stepUpStartFlagSuccessTitle,
            description: (0, $j85uw.default).stepUpStartFlagSuccessDesc
        });
        else dispatchAddFlag({
            type: 'error',
            title: (0, $j85uw.default).stepUpStartFlagErrorTitle,
            description: (0, $j85uw.default).stepUpStartFlagErrorDesc
        });
    };
    const handleVerify = ()=>{
        analyticsClient.buttonClickedEvent($12fe7c0353eb611c$export$703ba2e7ea526c1b, 'verifyOtp');
    };
    const handleReturnToLogin = ()=>{
        analyticsClient.linkClickedEvent($12fe7c0353eb611c$export$703ba2e7ea526c1b, 'switchAccount');
    };
    const handleSendOtpCode = async ()=>{
        analyticsClient.buttonClickedEvent($12fe7c0353eb611c$export$703ba2e7ea526c1b, 'sendOtpCode');
        await triggerCodeSend().catch(()=>dispatchAddFlag({
                type: 'error',
                title: (0, $j85uw.default).stepUpStartFlagErrorTitle,
                description: (0, $j85uw.default).stepUpStartFlagErrorDesc
            }));
        setManualOtpCodeTriggerMode(false);
    };
    const returnLoginLink = `/login/select-account${search}`;
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8KhCJ.default), {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)("title", {
                    children: intl.formatMessage((0, $j85uw.default).stepUpStartTitle)
                })
            }),
            /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $gs2u7.default), {
                pageId: $12fe7c0353eb611c$export$703ba2e7ea526c1b,
                header: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $b2I6k._)((0, $1Fos3._)({}, manualOtpCodeTriggerMode ? (0, $j85uw.default).stepUpOpenedInBackgroundHeader : (0, $j85uw.default).stepUpStartTitle), {
                    tagName: "h5"
                })),
                footer: /*#__PURE__*/ (0, $4ZSso.jsxs)("ul", {
                    className: "fine-print",
                    children: [
                        /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $bE8z6.PrivacyPolicyLink), {
                                isMobileLink: isMobile
                            })
                        }),
                        /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8Bf3D.default), {}),
                        /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $bE8z6.UserNoticeLink), {
                                isMobileLink: isMobile
                            })
                        })
                    ]
                }),
                whiteboxFooter: /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4ZSso.jsx)("ul", {
                            children: /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                                children: !manualOtpCodeTriggerMode && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $64QTD.default), {
                                    id: "resend-code",
                                    spacing: "none",
                                    onClick: handleResendCode,
                                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $j85uw.default).stepUpStartResendCode))
                                })
                            })
                        }),
                        !isMobile && /*#__PURE__*/ (0, $4ZSso.jsx)($12fe7c0353eb611c$var$SecondaryLinkWrapper, {
                            children: /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6d87w.Link), {
                                    id: "return-to-login",
                                    "data-testid": "return-to-login",
                                    to: returnLoginLink,
                                    onClick: handleReturnToLogin,
                                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $j85uw.default).stepUpStartReturnToLogin))
                                })
                            })
                        })
                    ]
                }),
                children: [
                    !manualOtpCodeTriggerMode && /*#__PURE__*/ (0, $4ZSso.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $damsD.default), {
                                email: email,
                                message: intl.formatMessage((0, $j85uw.default).stepUpStartEmailSentHeader)
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsxs)($12fe7c0353eb611c$var$Form, {
                                autoComplete: "off",
                                onSubmit: handleSubmit,
                                children: [
                                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $7081r.default), {
                                        id: "otp-code-input",
                                        disabled: isLoading,
                                        fieldErrorFromParent: verificationError,
                                        onChange: handleInputChange,
                                        codeLength: $12fe7c0353eb611c$var$OTP_CODE_LENGTH,
                                        codeType: "numeric"
                                    }),
                                    /*#__PURE__*/ (0, $4ZSso.jsx)($12fe7c0353eb611c$var$ButtonContainer, {
                                        id: "verify-submit",
                                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                                            appearance: "primary",
                                            type: "submit",
                                            isFullWidth: true,
                                            isLoading: isLoading,
                                            onClick: handleVerify,
                                            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $j85uw.default).stepUpStartVerify))
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    manualOtpCodeTriggerMode && /*#__PURE__*/ (0, $4ZSso.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $damsD.default), {
                                email: email,
                                message: intl.formatMessage((0, $j85uw.default).stepUpOpenedInBackgroundMessage)
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsx)($12fe7c0353eb611c$var$RequestPasscodeButtonContainer, {
                                id: "send-otp-code",
                                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                                    appearance: "primary",
                                    type: "submit",
                                    isFullWidth: true,
                                    onClick: handleSendOtpCode,
                                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $j85uw.default).stepUpStartSendCode))
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $12fe7c0353eb611c$export$2e2bcd8739ae039 = $12fe7c0353eb611c$export$e561dacd818ab41;

});
parcelRegister("j85uw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56300363c91fe572$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $56300363c91fe572$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    stepUpStartTitle: {
        id: 'stepUp.start.title',
        defaultMessage: 'Verify your identity'
    },
    stepUpStartFlagSuccessTitle: {
        id: 'stepUp.start.sent.flag.success.title',
        defaultMessage: 'Email resent'
    },
    stepUpStartFlagSuccessDesc: {
        id: 'stepUp.start.sent.flag.success.description',
        defaultMessage: 'You should have a new code waiting for you in your inbox.'
    },
    stepUpStartFlagErrorTitle: {
        id: 'stepUp.start.sent.flag.error.title',
        defaultMessage: 'Something went wrong.'
    },
    stepUpStartFlagErrorDesc: {
        id: 'stepUp.start.sent.flag.error.description',
        defaultMessage: 'Please try again later.'
    },
    stepUpStartFlagErrorRateLimitTitle: {
        id: 'stepUp.start.sent.flag.error.rate.limit.title',
        defaultMessage: 'Something went wrong.'
    },
    stepUpStartFlagErrorRateLimitDesc: {
        id: 'stepUp.start.sent.flag.error.rate.limit.description',
        defaultMessage: 'Wait for a few minutes, then try again.'
    },
    stepUpStartResendCode: {
        id: 'stepUp.start.resend.code',
        defaultMessage: "Didn't get the code? Resend it"
    },
    stepUpStartReturnToLogin: {
        id: 'stepUp.start.return.to.login',
        defaultMessage: 'Need to log in to a different account?'
    },
    stepUpStartEmailSentHeader: {
        id: 'stepUp.start.email.sent.header',
        defaultMessage: 'To access, enter the verification code that we emailed to:'
    },
    stepUpStartVerify: {
        id: 'stepUp.start.verify',
        defaultMessage: 'Verify'
    },
    stepUpStartSendCode: {
        id: 'stepUp.start.sendCode',
        defaultMessage: 'Request passcode'
    },
    stepUpOpenedInBackgroundHeader: {
        id: 'stepUp.start.opened.in.background.header',
        defaultMessage: 'Request one-time passcode'
    },
    stepUpOpenedInBackgroundMessage: {
        id: 'stepUp.start.opened.in.background.message',
        defaultMessage: 'To verify your identity, request a one-time passcode that we send to:'
    }
});

});

parcelRegister("kFsUL", function(module, exports) {

$parcel$export(module.exports, "updateFromSessionStorage", function () { return $4374c0bbee018e11$export$60734d01582497d4; });
$parcel$export(module.exports, "sendCode", function () { return $4374c0bbee018e11$export$74ede56a84543af4; });
$parcel$export(module.exports, "resendCode", function () { return $4374c0bbee018e11$export$90e3d721ed7e24a8; });
$parcel$export(module.exports, "verifyOtpCode", function () { return $4374c0bbee018e11$export$a5c568dd7addf7ae; });

var $dBq8m = parcelRequire("dBq8m");
const $4374c0bbee018e11$export$dc6765fdde20a9c1 = (mfaToken)=>({
        type: 'STEP_UP_SEND_CODE_SUCCESS',
        mfaToken: mfaToken
    });
const $4374c0bbee018e11$export$72ac8a8529ba0de5 = (mfaToken)=>({
        type: 'STEP_UP_RESEND_CODE_SUCCESS',
        mfaToken: mfaToken
    });
const $4374c0bbee018e11$export$60734d01582497d4 = (mfaToken)=>({
        type: 'STEP_UP_MFA_TOKEN_LOAD_FROM_SESSION_STORAGE',
        mfaToken: mfaToken
    });
const $4374c0bbee018e11$export$74ede56a84543af4 = ()=>async (dispatch, getState)=>{
        const { csrfToken: csrfToken, stepUp: { token: token } } = getState();
        const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(window.location.search);
        const response = await fetch('/rest/step-up/start', {
            method: 'POST',
            body: JSON.stringify({
                continue: queryParams.continue,
                application: queryParams.application,
                token: token
            }),
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            }
        });
        if (response.ok) {
            const responseBody = await response.json();
            dispatch($4374c0bbee018e11$export$dc6765fdde20a9c1(responseBody.transactionToken));
            return {
                success: true
            };
        } else if (response.status === 429) return {
            success: false,
            errorCode: 'too_many_requests'
        };
        else return {
            success: false,
            errorCode: 'unknown_error'
        };
    };
const $4374c0bbee018e11$export$90e3d721ed7e24a8 = ()=>async (dispatch, getState)=>{
        const { stepUp: { mfaToken: mfaToken }, csrfToken: csrfToken } = getState();
        try {
            const response = await fetch(`/rest/mfa/resend?transactionToken=${mfaToken}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrfToken
                }
            });
            if (response.ok) {
                const responseBody = await response.json();
                dispatch($4374c0bbee018e11$export$72ac8a8529ba0de5(responseBody.transactionToken));
                return {
                    success: true
                };
            } else return {
                success: false,
                errorCode: 'resend_failed'
            };
        } catch (error) {
            return {
                success: false,
                errorCode: 'resend_failed'
            };
        }
    };
const $4374c0bbee018e11$export$a5c568dd7addf7ae = (otpCode)=>async (dispatch, getState)=>{
        const { stepUp: stepUp, csrfToken: csrfToken } = getState();
        const continueUrl = new URLSearchParams(window.location.search).get('continue');
        try {
            const response = await fetch(`/rest/mfa/verify?transactionToken=${stepUp.mfaToken}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrfToken
                },
                body: JSON.stringify({
                    otpCode: otpCode
                })
            });
            if (response.ok) {
                const responseBody = await response.json();
                const loginAuthorizeResp = await fetch(`/rest/mfa/authorize?transactionToken=${responseBody.transactionToken}`);
                if (loginAuthorizeResp.ok) {
                    const loginAuthorizeUrl = new URL((await loginAuthorizeResp.json()).redirectUri);
                    if (continueUrl !== null) loginAuthorizeUrl.searchParams.append('continue', continueUrl);
                    return {
                        redirectUri: loginAuthorizeUrl.toString()
                    };
                } else return {
                    errorCode: 'invalid_otp'
                };
            } else switch(response.status){
                case 400:
                    const body = await response.json();
                    if (body.context.reason === 'invalid_transaction_token') return {
                        errorCode: 'expired_otp'
                    };
                    else return {
                        errorCode: 'invalid_otp'
                    };
                case 403:
                    return {
                        errorCode: 'invalid_otp'
                    };
                case 429:
                    return {
                        errorCode: 'too_many_requests'
                    };
                default:
                    return {
                        errorCode: 'unknown'
                    };
            }
        } catch (error) {
            return {
                errorCode: 'unknown'
            };
        }
    };

});


parcelRegister("2fBti", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "changeEmailLoader", function () { return $e80d33edc3552555$export$6d7f213d69a144e5; });
$parcel$export(module.exports, "EmailConfirmationPage", function () { return $e80d33edc3552555$export$98b365c355bab28e; });
$parcel$export(module.exports, "default", function () { return $e80d33edc3552555$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $8T7Aj = parcelRequire("8T7Aj");

var $9hijJ = parcelRequire("9hijJ");

var $lAipu = parcelRequire("lAipu");

var $2aGBJ = parcelRequire("2aGBJ");

var $3f4xr = parcelRequire("3f4xr");

var $kpg9c = parcelRequire("kpg9c");

var $5e2bj = parcelRequire("5e2bj");
async function $e80d33edc3552555$export$6d7f213d69a144e5({ request: request }) {
    if (!await (0, $3f4xr.checkFeatureGateOnceInitialized)((0, $kpg9c.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $5e2bj.fetchPageState)('/rest/verify-email/change-email/state', request, {
        capabilities: [
            'capability-group--manage-profile',
            'capability-name--change-email'
        ]
    });
}
const $e80d33edc3552555$export$98b365c355bab28e = ()=>{
    (0, $5e2bj.usePageStateLoader)();
    const error = (0, $2aGBJ.useAppSelector)((state)=>state.changeEmail.error);
    const isFeatureGateEnabled = (0, $3f4xr.checkFeatureGate)((0, $kpg9c.AidFrontendFeatureGate).ENABLE_JSON_ENDPOINT_FOR_VERIFY_EMAIL);
    if (error === 'invalid_token') return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8T7Aj.default), {});
    if (isFeatureGateEnabled) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9hijJ.default), {});
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $lAipu.default), {});
};
var $e80d33edc3552555$export$2e2bcd8739ae039 = $e80d33edc3552555$export$98b365c355bab28e;

});
parcelRegister("8T7Aj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87f2960f104c6e2d$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");

var $gFEh4 = parcelRequire("gFEh4");

var $7F47L = parcelRequire("7F47L");

var $1V2cH = parcelRequire("1V2cH");

var $1viQS = parcelRequire("1viQS");

var $6d87w = parcelRequire("6d87w");
const $87f2960f104c6e2d$export$703ba2e7ea526c1b = 'emailConfirmationInvalidTokenErrorPage';
const $87f2960f104c6e2d$export$de2e70c0e2bb29f5 = ()=>{
    (0, $1V2cH.usePageViewedEvent)($87f2960f104c6e2d$export$703ba2e7ea526c1b);
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $gFEh4.default), {
        title: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $1viQS.default).invalidTokenTitle)),
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)("p", {
                "data-testid": "email-confirmation-error-container-idf-testid",
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $1viQS.default).invalidTokenDescription))
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)("p", {
                className: "error-action",
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6d87w.Link), {
                    to: "/login",
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $7F47L.default), {
                        appearance: "primary",
                        testId: "email-confirmation-error-page-button-idf-testid",
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $1viQS.default).invalidTokenReturnToLoginButton))
                    })
                })
            })
        ]
    });
};
var $87f2960f104c6e2d$export$2e2bcd8739ae039 = $87f2960f104c6e2d$export$de2e70c0e2bb29f5;

});
parcelRegister("1viQS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f30a220afe25a2c$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $1f30a220afe25a2c$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    invalidTokenTitle: {
        id: 'email-confirmation.invalid-token.title',
        defaultMessage: 'Unable to verify your email address'
    },
    invalidTokenDescription: {
        id: 'email-confirmation.invalid-token.description',
        defaultMessage: 'Something went wrong while trying to validate your email. The link you followed may have expired or be broken. Please log in to try again.'
    },
    invalidTokenReturnToLoginButton: {
        id: 'email-confirmation.invalid-token.return-login-button',
        defaultMessage: 'Return to log in'
    }
});

});


parcelRegister("9hijJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e760908af4cd586e$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");

var $6d87w = parcelRequire("6d87w");

var $4jXgk = parcelRequire("4jXgk");

var $dBq8m = parcelRequire("dBq8m");

var $6q3sX = parcelRequire("6q3sX");

var $gs2u7 = parcelRequire("gs2u7");

var $jrjpa = parcelRequire("jrjpa");

var $1V2cH = parcelRequire("1V2cH");

var $2aGBJ = parcelRequire("2aGBJ");

var $lhNKj = parcelRequire("lhNKj");
parcelRequire("0wXBc");
var $kBhWP = parcelRequire("kBhWP");
const $e760908af4cd586e$var$pageId = 'EmailConfirmationPage';
const $e760908af4cd586e$export$b1860081753d8e7a = ()=>{
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const { email: email, newEmail: newEmail, error: error, isLoading: isLoading, redirectTo: redirectTo } = (0, $2aGBJ.useAppSelector)((state)=>state.changeEmail);
    const handleEmailChangeConfirmationSubmitClick = (0, $1V2cH.useButtonClickedEvent)($e760908af4cd586e$var$pageId, 'EmailConfirmationSubmit');
    (0, $1V2cH.usePageViewedEvent)($e760908af4cd586e$var$pageId);
    // These values are provided by SIS in the email that's sent to verify the user's email address.
    // We need to pass them in the URL of the API call.
    const { token: token, userId: userId, source: source = '' } = $dBq8m.parse(window.location.search);
    const handleSubmit = (0, $91i6m.useCallback)((newEmail, password)=>{
        // If the user gets here without the token - something went really wrong
        // This should have been caught by the initial page load
        if (!token) {
            dispatch((0, $jrjpa.changeEmailRequestFailedAction)('invalid_token'));
            return;
        }
        if (!userId) {
            dispatch((0, $jrjpa.changeEmailRequestFailedAction)('unknown_error'));
            return;
        }
        dispatch((0, $jrjpa.changeEmailConfirmation)(newEmail, password, token, userId, source));
    }, [
        dispatch,
        source,
        token,
        userId
    ]);
    const resetPasswordLink = '/login/resetpassword?' + new URLSearchParams([
        [
            'redirectedFrom',
            'change-email'
        ],
        [
            'email',
            email
        ],
        [
            'continue',
            window.location.href
        ]
    ]);
    // `redirectTo` is set in the success case of the email change flow.
    (0, $kBhWP.useForceRedirect)({
        redirectTo: redirectTo
    });
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gs2u7.default), {
        pageId: $e760908af4cd586e$var$pageId,
        header: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4jXgk.default), {
            as: 'h1',
            size: 'small',
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $lhNKj.default).title))
        }),
        whiteboxFooter: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6d87w.Link), {
            to: resetPasswordLink,
            id: "resetPassword",
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "having.trouble.logging.in",
                defaultMessage: "Having trouble logging in?"
            })
        }),
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6q3sX.default), {
            email: newEmail,
            isLoading: isLoading,
            error: error,
            onSubmitButtonClick: handleEmailChangeConfirmationSubmitClick,
            onSubmit: handleSubmit
        })
    });
};
var $e760908af4cd586e$export$2e2bcd8739ae039 = $e760908af4cd586e$export$b1860081753d8e7a;

});
parcelRegister("6q3sX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64b5063d2bbdc6a9$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $9jjaN = parcelRequire("9jjaN");

var $h89s9 = parcelRequire("h89s9");

var $31nHY = parcelRequire("31nHY");

var $gFwNN = parcelRequire("gFwNN");

var $c1txK = parcelRequire("c1txK");

var $jthWj = parcelRequire("jthWj");

var $cJRdM = parcelRequire("cJRdM");

var $k8ZoM = parcelRequire("k8ZoM");

var $7F47L = parcelRequire("7F47L");

var $lhNKj = parcelRequire("lhNKj");
let $64b5063d2bbdc6a9$var$_ = (t)=>t, $64b5063d2bbdc6a9$var$t;
const $64b5063d2bbdc6a9$var$StyledForm = (0, $9jjaN.default).form($64b5063d2bbdc6a9$var$t || ($64b5063d2bbdc6a9$var$t = $64b5063d2bbdc6a9$var$_`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${0}px;
`), (0, $k8ZoM.default)('space.100'));
const $64b5063d2bbdc6a9$var$ErrorContent = ({ error: error })=>{
    switch(error){
        case 'invalid_password':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "recovery.error.change-email.password.incorrect",
                defaultMessage: "The password you entered is incorrect. Please try again."
            });
        case 'invalid_token':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "recovery.error.change-email.invalid_token",
                defaultMessage: "Something went wrong. Please try again later."
            });
        case 'unknown_error':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "recovery.error.change-email.unknown_error",
                defaultMessage: "Something went wrong while attempting to change your email. Please try again."
            });
        default:
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "recovery.error.change-email.unknown",
                defaultMessage: "Something went wrong while attempting to change your email. Please try again."
            });
    }
};
const $64b5063d2bbdc6a9$var$ChangeEmailForm = ({ email: email, isLoading: isLoading, error: error, onSubmit: onSubmit, onSubmitButtonClick: onSubmitButtonClick })=>{
    const intl = (0, $leG06.default)();
    const [password, setPassword] = (0, $91i6m.useState)('');
    const [passwordFieldError, setPasswordFieldError] = (0, $91i6m.useState)(null);
    const emailInputRef = (0, $91i6m.useRef)(null);
    const passwordInputRef = (0, $91i6m.useRef)(null);
    const handleSubmit = (e)=>{
        // Reset the error state to let the validation happen again.
        setPasswordFieldError(null);
        // Prevent submission/default behaviour. We return early in the cases of validation errors, but otherwise call the submit function
        e.preventDefault();
        if (isLoading) return;
        if (password.trim() === '') {
            setPasswordFieldError(intl.formatMessage((0, $jthWj.default).passwordEmpty));
            return;
        }
        if (error === 'invalid_password') {
            setPasswordFieldError(intl.formatMessage((0, $lhNKj.default).incorrectPassword));
            return;
        }
        onSubmit(email, password);
    };
    const handlePasswordChange = (e)=>{
        setPasswordFieldError(null);
        setPassword(e.currentTarget.value);
    };
    return /*#__PURE__*/ (0, $4ZSso.jsxs)("div", {
        "data-testid": "email-verification-page-idf-testid",
        children: [
            error && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $31nHY.default), {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)($64b5063d2bbdc6a9$var$ErrorContent, {
                    error: error
                })
            }),
            /*#__PURE__*/ (0, $4ZSso.jsxs)($64b5063d2bbdc6a9$var$StyledForm, {
                onSubmit: handleSubmit,
                id: "form-change-email",
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gFwNN.default), {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $h89s9.default), {
                            id: "email",
                            name: "email",
                            type: "email",
                            autoComplete: "off",
                            placeholder: intl.formatMessage((0, $jthWj.default).emailEmpty),
                            label: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $lhNKj.default).emailLabel)),
                            value: email,
                            ref: emailInputRef,
                            isDisabled: true,
                            isRequired: true
                        })
                    }),
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gFwNN.default), {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $c1txK.default), {
                            name: "password",
                            autoComplete: "current-password",
                            id: "password",
                            testId: "password" // used in pollinators
                            ,
                            placeholder: intl.formatMessage((0, $jthWj.default).passwordEmpty),
                            label: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $cJRdM.default).passwordLabel)),
                            autoFocus: true,
                            isInvalid: !!passwordFieldError,
                            invalidMessage: passwordFieldError,
                            onChange: handlePasswordChange,
                            value: password,
                            ref: passwordInputRef,
                            isRequired: true
                        })
                    }),
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $7F47L.default), {
                        appearance: "primary",
                        type: "submit",
                        testId: "change-email-submit-button-idf-testid",
                        onClick: onSubmitButtonClick,
                        isLoading: isLoading,
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                            id: "common.confirm",
                            defaultMessage: "Confirm"
                        })
                    })
                ]
            })
        ]
    });
};
var $64b5063d2bbdc6a9$export$2e2bcd8739ae039 = $64b5063d2bbdc6a9$var$ChangeEmailForm;

});
parcelRegister("jthWj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97147eacdc47bb45$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $97147eacdc47bb45$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    unexpectedErrorHappened: {
        id: 'login.form.sso.check.unknown.error',
        defaultMessage: 'Unexpected error happened.',
        description: ''
    },
    emailPlaceholder: {
        id: 'login.form.email.placeholder',
        defaultMessage: 'Enter your email'
    },
    emailEmpty: {
        id: 'login.form.email.empty',
        defaultMessage: 'Enter an email address'
    },
    emailInvalid: {
        id: 'login.form.email.invalid',
        defaultMessage: "Email address must contain text before and after an '@' symbol"
    },
    passwordEmpty: {
        id: 'login.form.password.empty',
        defaultMessage: 'Enter your password'
    },
    migrateAccountInfo: {
        id: 'login.form.info.migrate.account',
        defaultMessage: "It looks like you already have an Atlassian account with other products such as Jira or Confluence. Log in to finish migrating your {application} account.",
        description: 'Login form info container message'
    },
    existingUserSignupAttemptInfo: {
        id: 'login.form.info.existing.user.signup.attempt',
        defaultMessage: "It looks like you've already got an account associated with this email. Log in instead or reset your password if you've forgotten it",
        description: 'Login form info container message for existing user signup attempt'
    },
    rateLimitErrorMessage: {
        id: 'login.form.email.rate-limit-exceeded.error',
        defaultMessage: 'There have been too many attempts to reverify your account in the past hour. Please try again later.',
        description: 'Telling the user that they have exceeded welcome email limit'
    },
    rememberMeCheckboxLabel: {
        id: 'login.form.remember.me.checkbox.label',
        defaultMessage: 'Remember me',
        description: "Label for the checkbox that will enable the behaviour to remember a user's account on this device"
    },
    rememberMeMoreInfoLabel: {
        id: 'login.form.remember.me.moreinfo.label',
        defaultMessage: 'More info about Remember Me.',
        description: 'Label for info icon that describes what Remember Me is'
    },
    rememberMeTooltip: {
        id: 'login.form.remember.me.tooltip',
        defaultMessage: 'We remember your account information for the next time you log in.',
        description: 'Tooltip content for the remember me checkbox'
    }
});

});

parcelRegister("cJRdM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92a8e4c7e4d2e5c9$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $92a8e4c7e4d2e5c9$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    passwordPlaceholder: {
        id: 'login.form.password.placeholder',
        defaultMessage: 'Enter password'
    },
    passwordLabel: {
        id: 'login.form.password.label',
        defaultMessage: 'Password'
    }
});

});

parcelRegister("lhNKj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab1a883cf4b44cc7$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $ab1a883cf4b44cc7$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    title: {
        id: 'email-confirmation.title',
        defaultMessage: 'Enter your password to confirm your updated email'
    },
    emailLabel: {
        id: 'account.verification.form.emailField.label',
        defaultMessage: 'Updated email',
        description: 'The label shown above a disabled email field when the user is confirming that they have updated their email.'
    },
    incorrectPassword: {
        id: 'email-confirmation.form.incorrect-password',
        defaultMessage: 'Your password was incorrect'
    },
    unknownError: {
        id: 'email-confirmation.form.unknown_error',
        defaultMessage: 'An unknown error occurred, please try again later.'
    }
});

});


parcelRegister("jrjpa", function(module, exports) {

$parcel$export(module.exports, "changeEmailRequestFailedAction", function () { return $4f560d6e98b66b62$export$85474e738669d18a; });
$parcel$export(module.exports, "changeEmailConfirmation", function () { return $4f560d6e98b66b62$export$c78d0a07bbf517cd; });

var $kpg9c = parcelRequire("kpg9c");

var $g7xf6 = parcelRequire("g7xf6");

var $3f4xr = parcelRequire("3f4xr");
const $4f560d6e98b66b62$export$593c8d2584e1aebe = ()=>({
        type: 'CHANGE_EMAIL_RESET_STATE'
    });
const $4f560d6e98b66b62$export$377eca5680d6a582 = ()=>({
        type: 'CHANGE_EMAIL_REQUEST'
    });
const $4f560d6e98b66b62$export$85474e738669d18a = (error)=>({
        type: 'CHANGE_EMAIL_REQUEST_FAILED',
        error: error
    });
const $4f560d6e98b66b62$export$17c00f40906a7c06 = (redirectTo)=>({
        type: 'CHANGE_EMAIL_REQUEST_SUCCEEDED',
        redirectTo: redirectTo
    });
const $4f560d6e98b66b62$export$98860bcb84091494 = (backendState)=>({
        type: 'CHANGE_EMAIL_STATE_UPDATE',
        backendState: backendState
    });
const $4f560d6e98b66b62$var$CHANGE_EMAIL_REST_ENDPOINT = '/rest/verify-email/change-email';
const $4f560d6e98b66b62$export$c78d0a07bbf517cd = (email, password, token, userId, source)=>async (dispatch, getState)=>{
        // Fork to use either the old submitFormHack or new submitFormHackReplacement function, well as the old or new endpoint
        // old endpoint: /verify-email/change-email (submitFormHack - form submission with input div manipulation)
        // new endpoint: /rest/verify-email/change-email (submitFormHackReplacement - REST POST request with JSON payload)
        if (!(0, $3f4xr.checkFeatureGate)((0, $kpg9c.AidFrontendFeatureGate).ENABLE_JSON_ENDPOINT_FOR_VERIFY_EMAIL)) {
            (0, $g7xf6.default)({
                method: 'POST',
                payload: {
                    email: email,
                    password: password
                },
                skipSanitizationKeys: [
                    'password'
                ]
            });
            return;
        }
        try {
            var _response_changeEmail, _response_changeEmail1;
            const csrfToken = getState().csrfToken;
            const res = await (0, $g7xf6.submitFormHackReplacement)({
                method: 'POST',
                // These three parameters are included in the link from the verification email, therefore including to match existing functionality.
                action: `${$4f560d6e98b66b62$var$CHANGE_EMAIL_REST_ENDPOINT}?token=${token}&userId=${userId}&source=${source}`,
                payload: {
                    email: email,
                    password: password
                },
                csrfToken: csrfToken
            });
            // This indicates the backend is not behaving as expected
            // since even in error cases, we expect the backend endpoint to return a 200
            if (!res.ok) {
                dispatch($4f560d6e98b66b62$export$85474e738669d18a('unknown_error'));
                return;
            }
            const response = await res.json();
            // We have state from the backend, which we want to ensure is updated in the FE state.
            if (response.changeEmail) {
                // Want to make sure the response is a valid object.
                const isChangeEmailObject = typeof response.changeEmail === 'object' && !Array.isArray(response.changeEmail);
                dispatch($4f560d6e98b66b62$export$98860bcb84091494(isChangeEmailObject ? response.changeEmail : {}));
            }
            if (response === null || response === void 0 ? void 0 : (_response_changeEmail = response.changeEmail) === null || _response_changeEmail === void 0 ? void 0 : _response_changeEmail.error) {
                const error = response.changeEmail.error;
                const validErrorTypes = [
                    'invalid_token',
                    'invalid_password',
                    'unknown_error'
                ];
                if (!validErrorTypes.includes(error)) {
                    dispatch($4f560d6e98b66b62$export$85474e738669d18a('unknown_error'));
                    return;
                }
                dispatch($4f560d6e98b66b62$export$85474e738669d18a(error));
                return;
            }
            // The types on the FE define the response to always be under `changeEmail` for this endpoint
            // but in practice the BE returns in some cases (i.e. success) in a different format
            // so we want to handle that
            const redirectTo = (response === null || response === void 0 ? void 0 : (_response_changeEmail1 = response.changeEmail) === null || _response_changeEmail1 === void 0 ? void 0 : _response_changeEmail1.redirectTo) || (response === null || response === void 0 ? void 0 : response.redirectTo);
            if (!redirectTo) {
                // If we don't get a redirect URL from the BE _and_ we haven't been able to understand the error
                // we don't know where to send the user and there aren't enough details of the error (or they aren't in the expected format) so we are assuming the request failed.
                dispatch($4f560d6e98b66b62$export$85474e738669d18a('unknown_error'));
                return;
            }
            dispatch($4f560d6e98b66b62$export$17c00f40906a7c06(redirectTo));
            return;
        } catch (error) {
            dispatch($4f560d6e98b66b62$export$85474e738669d18a('unknown_error'));
        }
    };

});


parcelRegister("lAipu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47b420edcbd64251$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $6d87w = parcelRequire("6d87w");

var $4jXgk = parcelRequire("4jXgk");

var $dBq8m = parcelRequire("dBq8m");

var $7fkJo = parcelRequire("7fkJo");

var $gs2u7 = parcelRequire("gs2u7");

var $jrjpa = parcelRequire("jrjpa");

var $1V2cH = parcelRequire("1V2cH");

var $9gY5v = parcelRequire("9gY5v");

var $2aGBJ = parcelRequire("2aGBJ");
const $47b420edcbd64251$var$pageId = 'EmailConfirmationPage';
const $47b420edcbd64251$export$b1860081753d8e7a = ()=>{
    const intl = (0, $leG06.default)();
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const { email: email, newEmail: newEmail, error: error } = (0, $2aGBJ.useAppSelector)((state)=>state.changeEmail);
    const [fieldErrors, setFieldErrors] = (0, $91i6m.useState)(error === 'invalid_password' ? {
        password: intl.formatMessage((0, $9gY5v.default).incorrectPassword)
    } : {});
    const [isLoading, setIsLoading] = (0, $91i6m.useState)(false);
    const handleLoginClick = (0, $1V2cH.useButtonClickedEvent)($47b420edcbd64251$var$pageId, 'EmailConfirmationSubmit');
    (0, $1V2cH.usePageViewedEvent)($47b420edcbd64251$var$pageId);
    // In the URL from the verification email, but used by SIS to validate that they have access to the email address.
    // These three are included in the URL
    const { token: token = '', userId: userId = '', source: source = '' } = $dBq8m.parse(window.location.search);
    const handleChangePassword = (newEmail, password)=>{
        setIsLoading(true);
        dispatch((0, $jrjpa.changeEmailConfirmation)(newEmail, password, token, userId, source));
    };
    const resetPasswordLink = '/login/resetpassword?' + new URLSearchParams([
        [
            'redirectedFrom',
            'change-email'
        ],
        [
            'email',
            email
        ],
        [
            'continue',
            window.location.href
        ]
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gs2u7.default), {
        pageId: $47b420edcbd64251$var$pageId,
        header: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4jXgk.default), {
            as: 'h1',
            size: 'small',
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $9gY5v.default).title))
        }),
        whiteboxFooter: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6d87w.Link), {
            to: resetPasswordLink,
            id: "resetPassword",
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "having.trouble.logging.in",
                defaultMessage: "Having trouble logging in?"
            })
        }),
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $7fkJo.default), {
            email: newEmail,
            emailFieldLabel: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $9gY5v.default).emailLabel)),
            isLoading: isLoading,
            fieldErrors: fieldErrors,
            onValidationError: setFieldErrors,
            submitButtonText: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "common.confirm",
                defaultMessage: "Confirm"
            }),
            onSubmitClick: handleLoginClick,
            onSubmit: handleChangePassword
        })
    });
};
var $47b420edcbd64251$export$2e2bcd8739ae039 = $47b420edcbd64251$export$b1860081753d8e7a;

});
parcelRegister("7fkJo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9568298db5cbc15c$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $9jjaN = parcelRequire("9jjaN");

var $6e88g = parcelRequire("6e88g");

var $h89s9 = parcelRequire("h89s9");

var $31nHY = parcelRequire("31nHY");

var $gFwNN = parcelRequire("gFwNN");

var $c1txK = parcelRequire("c1txK");

var $cLysE = parcelRequire("cLysE");

var $jthWj = parcelRequire("jthWj");

var $cJRdM = parcelRequire("cJRdM");

var $brCu8 = parcelRequire("brCu8");
let $9568298db5cbc15c$var$_ = (t)=>t, $9568298db5cbc15c$var$t, $9568298db5cbc15c$var$t1;
const $9568298db5cbc15c$var$Form = (0, $9jjaN.default).form($9568298db5cbc15c$var$t || ($9568298db5cbc15c$var$t = $9568298db5cbc15c$var$_`
  margin: 0;
`));
const $9568298db5cbc15c$var$ButtonContainer = (0, $9jjaN.default).div($9568298db5cbc15c$var$t1 || ($9568298db5cbc15c$var$t1 = $9568298db5cbc15c$var$_`
  margin-top: ${0}px;
`), (0, $6e88g.gridSize)());
const $9568298db5cbc15c$var$ErrorContent = ({ error: error })=>{
    switch(error){
        case 'tsvForm.password.valid':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "recovery.error.password.incorrect",
                defaultMessage: "The password you entered is incorrect. Please try again."
            });
        case 'tsvForm.password.error':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "recovery.error.unexpected",
                defaultMessage: "Something went wrong while trying to contact the server. Please refresh the page and try again."
            });
        default:
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "recovery.error.unknown",
                defaultMessage: "Something went wrong while attempting to login. Please try again."
            });
    }
};
const $9568298db5cbc15c$var$AccountVerificationForm = (props)=>{
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const passwordFieldError = (0, $brCu8.useTranslateFormErrorIfAvailable)(props.fieldErrors.password);
    const email = props.email || '';
    const previousPasswordFieldError = (0, $91i6m.useRef)(undefined);
    const [password, setPassword] = (0, $91i6m.useState)('');
    const emailInputRef = (0, $91i6m.useRef)(null);
    const passwordInputRef = (0, $91i6m.useRef)(null);
    const handleSubmit = (e)=>{
        const { isLoading: isLoading, onValidationError: onValidationError } = props;
        const validationErrors = {};
        e.preventDefault();
        if (isLoading) return;
        if (password.trim() === '') validationErrors.password = formatMessage((0, $jthWj.default).passwordEmpty);
        if (Object.keys(validationErrors).length) {
            onValidationError(validationErrors);
            return;
        }
        props.onSubmit && props.onSubmit(email, password);
    };
    const handlePasswordChange = (e)=>{
        props.onValidationError({}); // clear validation errors
        setPassword(e.currentTarget.value);
    };
    (0, $91i6m.useEffect)(()=>{
        var _passwordInputRef_current;
        const passwordError = passwordFieldError && passwordFieldError !== previousPasswordFieldError.current;
        if (passwordError) (_passwordInputRef_current = passwordInputRef.current) === null || _passwordInputRef_current === void 0 ? void 0 : _passwordInputRef_current.focus();
        previousPasswordFieldError.current = passwordFieldError;
    }, [
        props.fieldErrors.password,
        passwordFieldError
    ]);
    const { error: error, title: title, emailFieldLabel: emailFieldLabel } = props;
    return /*#__PURE__*/ (0, $4ZSso.jsxs)("div", {
        "data-testid": "email-verification-page-old-idf-testid",
        children: [
            error && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $31nHY.default), {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)($9568298db5cbc15c$var$ErrorContent, {
                    error: error
                })
            }),
            title && /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
                children: title
            }),
            /*#__PURE__*/ (0, $4ZSso.jsxs)($9568298db5cbc15c$var$Form, {
                onSubmit: handleSubmit,
                id: "form-accountverification-up",
                onClick: props.onFormClick,
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gFwNN.default), {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $h89s9.default), {
                            id: "email",
                            name: "email",
                            type: "email",
                            autoComplete: "off",
                            placeholder: formatMessage((0, $jthWj.default).emailEmpty),
                            label: emailFieldLabel,
                            value: email,
                            ref: emailInputRef,
                            isDisabled: true,
                            isRequired: true
                        })
                    }),
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gFwNN.default), {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $c1txK.default), {
                            name: "password",
                            autoComplete: "new-password",
                            id: "password",
                            testId: "password" // used in pollinators
                            ,
                            placeholder: formatMessage((0, $jthWj.default).passwordEmpty),
                            label: formatMessage((0, $cJRdM.default).passwordLabel),
                            autoFocus: true,
                            isInvalid: !!props.fieldErrors.password,
                            invalidMessage: props.fieldErrors.password,
                            onChange: handlePasswordChange,
                            value: password,
                            ref: passwordInputRef,
                            isRequired: true
                        })
                    }),
                    /*#__PURE__*/ (0, $4ZSso.jsx)($9568298db5cbc15c$var$ButtonContainer, {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                            appearance: "primary",
                            type: "submit",
                            isFullWidth: true,
                            id: "tsvrecovery-submit" // used in pollinators
                            ,
                            onClick: ()=>props.onSubmitClick && props.onSubmitClick(),
                            isLoading: props.isLoading,
                            children: props.submitButtonText
                        })
                    })
                ]
            })
        ]
    });
};
var $9568298db5cbc15c$export$2e2bcd8739ae039 = $9568298db5cbc15c$var$AccountVerificationForm;

});

parcelRegister("9gY5v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $722174816a1d9ba3$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $722174816a1d9ba3$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    title: {
        id: 'email-confirmation.title',
        defaultMessage: 'Enter your password to confirm your updated email'
    },
    emailLabel: {
        id: 'account.verification.form.emailField.label',
        defaultMessage: 'Updated email',
        description: 'The label shown above a disabled email field when the user is confirming that they have updated their email.'
    },
    incorrectPassword: {
        id: 'email-confirmation.form.incorrect-password',
        defaultMessage: 'Your password was incorrect'
    },
    invalidTokenTitle: {
        id: 'email-confirmation.invalid-token.title',
        defaultMessage: 'Unable to verify your email address'
    },
    invalidTokenDescription: {
        id: 'email-confirmation.invalid-token.description',
        defaultMessage: 'Something went wrong while trying to validate your email. The link you followed may have expired or be broken. Please log in to try again.'
    },
    invalidTokenReturnToLoginButton: {
        id: 'email-confirmation.invalid-token.return-login-button',
        defaultMessage: 'Return to log in'
    }
});

});



parcelRegister("3Zv9U", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "removeAccountLoader", function () { return $f538062f23833bb7$export$d62f2a9a504f29d1; });
$parcel$export(module.exports, "RemoveAccountPage", function () { return $f538062f23833bb7$export$66bcaaca6b1eddac; });
$parcel$export(module.exports, "default", function () { return $f538062f23833bb7$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");
parcelRequire("6d87w");
var $l2v8Y = parcelRequire("l2v8Y");

var $jtgLn = parcelRequire("jtgLn");

var $9jjaN = parcelRequire("9jjaN");

var $gtKO2 = parcelRequire("gtKO2");

var $fajwB = parcelRequire("fajwB");

var $5xcuR = parcelRequire("5xcuR");

var $1V2cH = parcelRequire("1V2cH");

var $iwKPD = parcelRequire("iwKPD");

var $1569T = parcelRequire("1569T");
var $4PXNb = parcelRequire("4PXNb");
var $e46Ts = parcelRequire("e46Ts");
var $aLzB7 = parcelRequire("aLzB7");
var $5hmIF = parcelRequire("5hmIF");

var $fJOIy = parcelRequire("fJOIy");

var $bf3PF = parcelRequire("bf3PF");

var $cYDRT = parcelRequire("cYDRT");

var $d9DYJ = parcelRequire("d9DYJ");

var $64QTD = parcelRequire("64QTD");

var $gs2u7 = parcelRequire("gs2u7");

var $7eeh4 = parcelRequire("7eeh4");

var $jy3ZD = parcelRequire("jy3ZD");

var $2aGBJ = parcelRequire("2aGBJ");

var $9uXJ3 = parcelRequire("9uXJ3");

var $5e2bj = parcelRequire("5e2bj");

var $kpg9c = parcelRequire("kpg9c");

var $3f4xr = parcelRequire("3f4xr");

var $4jXgk = parcelRequire("4jXgk");
let $f538062f23833bb7$var$_ = (t)=>t, $f538062f23833bb7$var$t;
const $f538062f23833bb7$var$pageId = 'forgetAccountFromBrowserScreen';
async function $f538062f23833bb7$export$d62f2a9a504f29d1({ request: request }) {
    if (!await (0, $3f4xr.checkFeatureGateOnceInitialized)((0, $kpg9c.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $5e2bj.fetchPageState)('/rest/login/remove-account/state', request, {
        capabilities: [
            'capability-group--manage-profile',
            'capability-name--remove-account'
        ]
    });
}
const $f538062f23833bb7$export$66bcaaca6b1eddac = ()=>{
    (0, $5e2bj.usePageStateLoader)();
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    const loginHint = (0, $jy3ZD.useLoginHint)();
    const { search: search } = (0, $l2v8Y.useLocation)();
    const navigateToLoginPrompt = (0, $5xcuR.useNavigateToLoginPrompt)();
    const [modalDialog, setModalDialog] = (0, $91i6m.useState)(null);
    const sessions = (0, $2aGBJ.useAppSelector)((state)=>(0, $bf3PF.sessionsSelector)(state, search, loginHint));
    const oidcContext = (0, $2aGBJ.useAppSelector)((state)=>state.microbranding.oidcContext);
    const isLoading = (0, $2aGBJ.useAppSelector)((state)=>state.selectAccount.isLoading);
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const eventAttributes = (0, $91i6m.useMemo)(()=>({
            accountCount: sessions.length
        }), [
        sessions.length
    ]);
    (0, $1V2cH.usePageViewedEvent)($f538062f23833bb7$var$pageId, eventAttributes);
    const renderFooter = ()=>{
        if ((0, $7eeh4.isOidcDisplayMode)(oidcContext, (0, $gtKO2.OidcDisplay).ManageSessions)) return null;
        return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $64QTD.default), {
            id: "navigate-to-select-account",
            onClick: ()=>{
                analyticsClient.buttonClickedEvent($f538062f23833bb7$var$pageId, 'dismissAccountSwitcher', eventAttributes);
                navigate({
                    pathname: '/login/select-account',
                    search: search
                });
            },
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "remove.account.footer.navigate.to.select.account",
                defaultMessage: "Done"
            })
        });
    };
    const handleSessionClick = (0, $91i6m.useCallback)((session, eventAttributes)=>{
        return ()=>{
            const handleDissociate = ()=>{
                analyticsClient.buttonClickedEvent($f538062f23833bb7$var$pageId, 'confirmForgetAccount', eventAttributes);
                dispatch((0, $fajwB.manageSession)({
                    sessionId: session.sessionId,
                    command: 'dissociate'
                }, navigate, {
                    continue: window.location.href
                }));
            };
            const handleCloseModalDialog = ()=>{
                analyticsClient.buttonClickedEvent($f538062f23833bb7$var$pageId, 'cancelForgetAccount', eventAttributes);
                setModalDialog(null);
            };
            const modalDialogElement = /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $1569T.default), {
                width: "small",
                onClose: handleCloseModalDialog,
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $aLzB7.default), {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $5hmIF.default), {
                            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                                id: "remove.account.dialog.header",
                                defaultMessage: "Remove account"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4PXNb.default), {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                            id: "remove.account.dialog.body",
                            defaultMessage: "You can always add the account for <strong>{email}</strong> back to this browser when you're ready to use it again.",
                            values: {
                                strong: (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("strong", {
                                        children: chunks
                                    }),
                                email: session.email
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $e46Ts.default), {
                        children: [
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $jtgLn.default), {
                                appearance: "subtle",
                                onClick: handleCloseModalDialog,
                                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $iwKPD.default).removeAccountDialogClose))
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $jtgLn.default), {
                                appearance: "primary",
                                onClick: handleDissociate,
                                autoFocus: true,
                                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $iwKPD.default).removeAccountDialogConfirm))
                            })
                        ]
                    })
                ]
            });
            analyticsClient.buttonClickedEvent($f538062f23833bb7$var$pageId, 'forgetAccountFromBrowser', eventAttributes);
            setModalDialog(modalDialogElement);
        };
    }, [
        analyticsClient,
        dispatch,
        navigate
    ]);
    const handleLogoutClick = (0, $91i6m.useCallback)(()=>{
        const handleCloseModalDialog = ()=>{
            analyticsClient.buttonClickedEvent($f538062f23833bb7$var$pageId, 'cancelForgetAllAccounts', eventAttributes);
            setModalDialog(null);
        };
        const modalDialogElement = /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $1569T.default), {
            width: "small",
            onClose: handleCloseModalDialog,
            children: [
                /*#__PURE__*/ (0, $4ZSso.jsx)((0, $aLzB7.default), {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $5hmIF.default), {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                            id: "remove.account.logout.dialog.header",
                            defaultMessage: "Remove all accounts"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4PXNb.default), {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                        id: "remove.account.logout.dialog.body",
                        defaultMessage: "You can always add the accounts back to this browser when you're ready to use any of them again."
                    })
                }),
                /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $e46Ts.default), {
                    children: [
                        /*#__PURE__*/ (0, $4ZSso.jsx)((0, $jtgLn.default), {
                            appearance: "subtle",
                            onClick: handleCloseModalDialog,
                            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $iwKPD.default).removeAccountDialogClose))
                        }),
                        /*#__PURE__*/ (0, $4ZSso.jsx)((0, $jtgLn.default), {
                            appearance: "primary",
                            onClick: async ()=>{
                                await analyticsClient.buttonClickedEvent($f538062f23833bb7$var$pageId, 'confirmForgetAllAccounts', eventAttributes);
                                const continueUrl = (0, $7eeh4.isOidcDisplayMode)(oidcContext, (0, $gtKO2.OidcDisplay).ManageSessions) ? window.location.href : undefined;
                                await dispatch((0, $fajwB.doLogout)(continueUrl));
                            },
                            autoFocus: true,
                            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $iwKPD.default).removeAccountDialogConfirm))
                        })
                    ]
                })
            ]
        });
        analyticsClient.buttonClickedEvent($f538062f23833bb7$var$pageId, 'forgetAllAccounts', eventAttributes);
        setModalDialog(modalDialogElement);
    }, [
        analyticsClient,
        dispatch,
        eventAttributes,
        oidcContext
    ]);
    const renderAccounts = ()=>{
        const accounts = sessions.map((session, index)=>{
            const { accountId: accountId, displayName: displayName, email: email } = session;
            const handleOnClick = handleSessionClick(session, (0, $b2I6k._)((0, $1Fos3._)({}, eventAttributes), {
                accountIndex: index
            }));
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $fJOIy.default), {
                id: `account-${accountId}`,
                onClick: handleOnClick,
                avatarUrl: session.avatarUrl,
                displayName: displayName,
                email: email,
                icon: /*#__PURE__*/ (0, $4ZSso.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d9DYJ))), {
                    label: formatMessage((0, $iwKPD.default).removeAccountIconLabel),
                    size: "small"
                })
            }, `account-${accountId}`);
        });
        accounts.push(/*#__PURE__*/ (0, $4ZSso.jsx)((0, $fJOIy.AccountContainer), {
            id: "redirect-to-logout",
            onClick: handleLogoutClick,
            children: /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $fJOIy.RowButtonContainer), {
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $fJOIy.AvatarContainer), {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d9DYJ))), {
                            label: formatMessage((0, $iwKPD.default).removeAccountIconLabel)
                        })
                    }),
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $fJOIy.TextContainer), {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $fJOIy.Paragraph), {
                            id: "remove-all",
                            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                                id: "remove.account.all",
                                defaultMessage: "Remove all accounts"
                            })
                        })
                    })
                ]
            })
        }, "redirect-to-logout"));
        return accounts;
    };
    if (sessions.length > 0) return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $gs2u7.default), {
        pageId: $f538062f23833bb7$var$pageId,
        header: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4jXgk.default), {
            as: "h1",
            size: "small",
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "remove.account.title",
                defaultMessage: "Remove accounts from this browser"
            })
        }),
        footer: true,
        whiteboxFooter: renderFooter(),
        isLoading: isLoading,
        children: [
            modalDialog,
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cYDRT.default), {
                children: renderAccounts()
            })
        ]
    });
    else if ((0, $7eeh4.isOidcDisplayMode)(oidcContext, (0, $gtKO2.OidcDisplay).ManageSessions)) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gs2u7.default), {
        pageId: $f538062f23833bb7$var$pageId,
        header: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4jXgk.default), {
            as: "h1",
            size: "small",
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "manage.sessions.no.sessions.header",
                defaultMessage: "You're logged out of all accounts on this browser"
            })
        }),
        children: /*#__PURE__*/ (0, $4ZSso.jsx)($f538062f23833bb7$var$CenterText, {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                tagName: "p",
                id: "manage.sessions.no.sessions.body",
                defaultMessage: "Close this page to return to the app."
            })
        })
    });
    else {
        navigateToLoginPrompt();
        return null;
    }
};
const $f538062f23833bb7$var$CenterText = (0, $9jjaN.default).div($f538062f23833bb7$var$t || ($f538062f23833bb7$var$t = $f538062f23833bb7$var$_`
  text-align: center;
`));
var $f538062f23833bb7$export$2e2bcd8739ae039 = $f538062f23833bb7$export$66bcaaca6b1eddac;

});
parcelRegister("iwKPD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e075576eb75173a$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $2e075576eb75173a$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    removeAccountIconLabel: {
        id: 'remove.account.icon.label',
        defaultMessage: 'Remove account',
        description: ''
    },
    removeAccountDialogConfirm: {
        id: 'remove.account.dialog.confirm',
        defaultMessage: 'Remove',
        description: ''
    },
    removeAccountDialogClose: {
        id: 'remove.account.dialog.close',
        defaultMessage: 'Cancel',
        description: ''
    }
});

});

parcelRegister("bf3PF", function(module, exports) {

$parcel$export(module.exports, "sessionsSelector", function () { return $80560c7f253456f5$export$28c41c0d40d1bdce; });
$parcel$export(module.exports, "default", function () { return $80560c7f253456f5$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");
parcelRequire("5jYTP");
var $4b5th = parcelRequire("4b5th");

var $dBq8m = parcelRequire("dBq8m");

var $jy3ZD = parcelRequire("jy3ZD");
const $80560c7f253456f5$export$28c41c0d40d1bdce = (0, $4b5th.createSelector)([
    (state)=>state.selectAccount.sessions,
    (_state, search)=>search,
    (_state, _search, loginHint)=>loginHint
], (sessions, search, loginHint)=>{
    if (!sessions) return [];
    const { suggested: suggested } = $dBq8m.parse(search);
    const combined = sessions.associated.map((session)=>{
        return (0, $b2I6k._)((0, $1Fos3._)({}, session), {
            current: false,
            suggested: false
        });
    });
    combined.unshift((0, $b2I6k._)((0, $1Fos3._)({}, sessions.current), {
        current: true,
        suggested: false
    }));
    return combined.reduce((sorted, session)=>{
        if (loginHint && loginHint.value === session.email) switch(loginHint.type){
            case (0, $jy3ZD.LoginHintType).EmailAddress:
            case (0, $jy3ZD.LoginHintType).NotEmailAddress:
                sorted.unshift((0, $b2I6k._)((0, $1Fos3._)({}, session), {
                    hint: loginHint.type
                }));
                break;
            default:
                sorted.push(session);
        }
        else sorted.push((0, $b2I6k._)((0, $1Fos3._)({}, session), {
            suggested: session.email === suggested
        }));
        return sorted;
    }, []);
});
var $80560c7f253456f5$export$2e2bcd8739ae039 = $80560c7f253456f5$export$28c41c0d40d1bdce;

});

parcelRegister("cYDRT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74dee8b99c16facc$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $9jjaN = parcelRequire("9jjaN");

var $kLNLK = parcelRequire("kLNLK");
let $74dee8b99c16facc$var$_ = (t)=>t, $74dee8b99c16facc$var$t;
const $74dee8b99c16facc$var$Accounts = (0, $9jjaN.default).div($74dee8b99c16facc$var$t || ($74dee8b99c16facc$var$t = $74dee8b99c16facc$var$_`
  > * + * {
    border-top: 1px solid ${0} !important;
  }
`), (0, $kLNLK).N30A);
var $74dee8b99c16facc$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $4ZSso.jsx)($74dee8b99c16facc$var$Accounts, {
        className: "accounts-list",
        children: props.children
    });

});

parcelRegister("d9DYJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $993b2085c317e145$var$_react = $993b2085c317e145$var$_interopRequireDefault((parcelRequire("91i6m")));

var $gJR35 = parcelRequire("gJR35");

var $993b2085c317e145$var$_logOut = $993b2085c317e145$var$_interopRequireDefault((parcelRequire("kxCSb")));
function $993b2085c317e145$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $993b2085c317e145$var$SignOutIcon = (props)=>/*#__PURE__*/ $993b2085c317e145$var$_react.default.createElement($gJR35.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M4.977 11A.99.99 0 0 0 4 12c0 .551.437 1 .977 1h11.046A.99.99 0 0 0 17 12a.99.99 0 0 0-.977-1z"/><path d="M6.23 8.31 3.3 11.27a1.05 1.05 0 0 0 0 1.48l2.93 2.96a1.03 1.03 0 0 0 1.47 0 1.05 1.05 0 0 0 0-1.48L5.5 12l2.2-2.22a1.05 1.05 0 0 0 0-1.48 1.03 1.03 0 0 0-1.47 0M15.5 3H12v2h7v14h-7v2h7.01c1.1 0 1.99-.89 1.99-1.99V5a1.99 1.99 0 0 0-1.99-2z"/></g></svg>`
    }, props, {
        newIcon: $993b2085c317e145$var$_logOut.default
    }));
$993b2085c317e145$var$SignOutIcon.displayName = 'SignOutIcon';
var $993b2085c317e145$var$_default = module.exports.default = $993b2085c317e145$var$SignOutIcon;

});
parcelRegister("kxCSb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b0ad8e82692fcbf05d6af098ca724db>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef450b10bdb8316e$var$_react = $ef450b10bdb8316e$var$_interopRequireDefault((parcelRequire("91i6m")));

var $ef450b10bdb8316e$var$_baseNew = $ef450b10bdb8316e$var$_interopRequireDefault((parcelRequire("hVDwR")));
function $ef450b10bdb8316e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LogOut".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for log out.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ef450b10bdb8316e$var$LogOutIcon = (props)=>/*#__PURE__*/ $ef450b10bdb8316e$var$_react.default.createElement($ef450b10bdb8316e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5h5V1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h5v-1.5H3a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5m11.78 4.97-3.5-3.5-1.06 1.06 2.22 2.22H6v1.5h6.44l-2.22 2.22 1.06 1.06 3.5-3.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$ef450b10bdb8316e$var$LogOutIcon.displayName = 'LogOutIcon';
var $ef450b10bdb8316e$var$_default = module.exports.default = $ef450b10bdb8316e$var$LogOutIcon;

});



parcelRegister("gijFh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "selectAccountLoader", function () { return $5c9e4cb9be8c89f0$export$f44e7fa0a0dba44f; });
$parcel$export(module.exports, "SelectAccountPage", function () { return $5c9e4cb9be8c89f0$export$134466789cb44107; });
$parcel$export(module.exports, "default", function () { return $5c9e4cb9be8c89f0$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");

var $fajwB = parcelRequire("fajwB");

var $5xcuR = parcelRequire("5xcuR");

var $1V2cH = parcelRequire("1V2cH");

var $dBq8m = parcelRequire("dBq8m");

var $jy3ZD = parcelRequire("jy3ZD");

var $isKwq = parcelRequire("isKwq");

var $h0h8A = parcelRequire("h0h8A");

var $fJOIy = parcelRequire("fJOIy");

var $bf3PF = parcelRequire("bf3PF");

var $5UVuM = parcelRequire("5UVuM");

var $64QTD = parcelRequire("64QTD");

var $cYDRT = parcelRequire("cYDRT");

var $99kO7 = parcelRequire("99kO7");

var $gs2u7 = parcelRequire("gs2u7");

var $cLysE = parcelRequire("cLysE");

var $2ZKUQ = parcelRequire("2ZKUQ");

var $7eeh4 = parcelRequire("7eeh4");

var $bE8z6 = parcelRequire("bE8z6");

var $8iEgn = parcelRequire("8iEgn");

var $9jjaN = parcelRequire("9jjaN");

var $6e88g = parcelRequire("6e88g");

var $l2v8Y = parcelRequire("l2v8Y");

var $2aGBJ = parcelRequire("2aGBJ");

var $9uXJ3 = parcelRequire("9uXJ3");

var $5e2bj = parcelRequire("5e2bj");

var $kpg9c = parcelRequire("kpg9c");

var $3f4xr = parcelRequire("3f4xr");

var $4jXgk = parcelRequire("4jXgk");
let $5c9e4cb9be8c89f0$var$_ = (t)=>t, $5c9e4cb9be8c89f0$var$t, $5c9e4cb9be8c89f0$var$t1, $5c9e4cb9be8c89f0$var$t2, $5c9e4cb9be8c89f0$var$t3, $5c9e4cb9be8c89f0$var$t4, $5c9e4cb9be8c89f0$var$t5;
const $5c9e4cb9be8c89f0$var$MAXIMUM_ASSOCIATED_SESSIONS = 9;
const $5c9e4cb9be8c89f0$var$ButtonWrapper = (0, $9jjaN.default).div($5c9e4cb9be8c89f0$var$t || ($5c9e4cb9be8c89f0$var$t = $5c9e4cb9be8c89f0$var$_`
  padding-bottom: 0;
`));
const $5c9e4cb9be8c89f0$var$SectionMessageWrapper = (0, $9jjaN.default).div($5c9e4cb9be8c89f0$var$t1 || ($5c9e4cb9be8c89f0$var$t1 = $5c9e4cb9be8c89f0$var$_`
  margin-top: ${0}px;
`), (0, $6e88g.gridSize)() * 2);
const $5c9e4cb9be8c89f0$var$UnauthorizedWrapper = (0, $9jjaN.default).div($5c9e4cb9be8c89f0$var$t2 || ($5c9e4cb9be8c89f0$var$t2 = $5c9e4cb9be8c89f0$var$_`
  padding-top: ${0}px;
`), (0, $6e88g.gridSize)() * 2);
const $5c9e4cb9be8c89f0$var$UnauthorizedHeader = (0, $9jjaN.default).div($5c9e4cb9be8c89f0$var$t3 || ($5c9e4cb9be8c89f0$var$t3 = $5c9e4cb9be8c89f0$var$_`
  padding-bottom: ${0}px;
`), (0, $6e88g.gridSize)() * 2);
const $5c9e4cb9be8c89f0$var$AccountsList = (0, $9jjaN.default).ul($5c9e4cb9be8c89f0$var$t4 || ($5c9e4cb9be8c89f0$var$t4 = $5c9e4cb9be8c89f0$var$_`
  margin-top: 0px;
  padding: 0px;
  list-style-type: none;
`));
const $5c9e4cb9be8c89f0$var$AccountsListItem = (0, $9jjaN.default).li($5c9e4cb9be8c89f0$var$t5 || ($5c9e4cb9be8c89f0$var$t5 = $5c9e4cb9be8c89f0$var$_`
  margin-top: 0px;
`));
const $5c9e4cb9be8c89f0$var$pageId = 'selectAccountScreen';
const $5c9e4cb9be8c89f0$var$generateDestUrl = (parsedUrl)=>{
    let destUrl = '';
    if (parsedUrl.pathname) destUrl += parsedUrl.pathname;
    if (parsedUrl.search) destUrl += parsedUrl.search;
    return destUrl;
};
async function $5c9e4cb9be8c89f0$export$f44e7fa0a0dba44f({ request: request }) {
    if (!await (0, $3f4xr.checkFeatureGateOnceInitialized)((0, $kpg9c.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $5e2bj.fetchPageState)('/rest/login/select-account/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--select-account'
        ]
    });
}
const $5c9e4cb9be8c89f0$export$134466789cb44107 = ()=>{
    (0, $5e2bj.usePageStateLoader)();
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    const { search: search } = (0, $l2v8Y.useLocation)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const loginHint = (0, $jy3ZD.useLoginHint)();
    const sessions = (0, $2aGBJ.useAppSelector)((state)=>(0, $bf3PF.default)(state, search, loginHint));
    const applicationDestination = (0, $2aGBJ.useAppSelector)((state)=>(0, $5UVuM.applicationDestinationSelector)(state, search));
    const hideLogout = (0, $2aGBJ.useAppSelector)((state)=>(0, $7eeh4.isMobileOidc)(state.microbranding.oidcContext) || state.microbranding.isEmbedded);
    const isLoading = (0, $2aGBJ.useAppSelector)((state)=>state.selectAccount.isLoading);
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const shouldShowRequestAccessLink = (0, $91i6m.useCallback)(()=>{
        const params = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(search);
        let parsedUrl = '';
        try {
            parsedUrl = $5c9e4cb9be8c89f0$var$generateDestUrl(new URL(decodeURIComponent(params.continue || '')));
        } catch (error) {
        // Do nothing
        }
        return params.showRequestAccessLink === 'true' && applicationDestination !== null && parsedUrl !== '';
    }, [
        applicationDestination,
        search
    ]);
    const eventAttributes = (0, $91i6m.useMemo)(()=>({
            accountCount: sessions.length,
            loginHintType: loginHint ? loginHint.type : undefined,
            hideLogout: hideLogout,
            requestAccessLinkShown: shouldShowRequestAccessLink(),
            suggestedAccountShown: sessions.some((session)=>session.suggested)
        }), [
        hideLogout,
        loginHint,
        sessions,
        shouldShowRequestAccessLink
    ]);
    (0, $1V2cH.usePageViewedEvent)($5c9e4cb9be8c89f0$var$pageId, (0, $b2I6k._)((0, $1Fos3._)({}, eventAttributes), {
        noAccess: !!loginHint && loginHint.type === (0, $jy3ZD.LoginHintType).NotEmailAddress,
        accounts: sessions.map((session)=>session.accountId)
    }));
    const renderHeader = ()=>{
        const suggestedAccount = getSuggestedAccount();
        if (sessions.length === 1 && sessions[0].hint === (0, $jy3ZD.LoginHintType).NotEmailAddress) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4jXgk.default), {
            size: "small",
            as: "h1",
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "try.another.account.title",
                defaultMessage: "Try a different account"
            })
        });
        else if (suggestedAccount) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4jXgk.default), {
            size: "small",
            as: "h1",
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "select.account.switch.title",
                defaultMessage: "Switch account"
            })
        });
        else return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4jXgk.default), {
            size: "small",
            as: "h1",
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "select.account.title",
                defaultMessage: "Choose or add another account"
            })
        });
    };
    const handleClickRequestAccessLink = (0, $1V2cH.useLinkClickedEvent)($5c9e4cb9be8c89f0$var$pageId, 'requestAccessLink');
    const renderMainContentFooter = ()=>{
        const params = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(search);
        let destUrl = '';
        try {
            destUrl = $5c9e4cb9be8c89f0$var$generateDestUrl(new URL(decodeURIComponent(params.continue || '')));
        } catch (error) {
        //
        }
        const requestAccessLink = shouldShowRequestAccessLink() && applicationDestination && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $bE8z6.RequestAccessLink), {
            onClick: handleClickRequestAccessLink,
            destUrl: destUrl,
            applicationDestination: applicationDestination
        });
        if (hideLogout) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4ZSso.Fragment), {});
        if (requestAccessLink) return requestAccessLink;
        else {
            if (sessions.length <= 1) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $64QTD.default), {
                id: "redirect-to-logout",
                onClick: async ()=>{
                    await analyticsClient.buttonClickedEvent($5c9e4cb9be8c89f0$var$pageId, 'forgetAllAccounts', eventAttributes);
                    await dispatch((0, $fajwB.doLogout)());
                },
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "select.account.footer.redirect.to.logout",
                    defaultMessage: "Log out"
                })
            });
        }
    };
    const handleSessionClick = (0, $91i6m.useCallback)((session, eventAttributes)=>{
        return ()=>{
            if (session.current) (async ()=>{
                await analyticsClient.buttonClickedEvent($5c9e4cb9be8c89f0$var$pageId, 'continueWithCurrentAccount', eventAttributes);
                await dispatch((0, $fajwB.continueWithCurrentSession)(navigate));
            })();
            else {
                analyticsClient.buttonClickedEvent($5c9e4cb9be8c89f0$var$pageId, 'switchToAccount', eventAttributes);
                const request = {
                    sessionId: session.sessionId,
                    command: 'switch'
                };
                dispatch((0, $fajwB.manageSession)(request, navigate));
            }
        };
    }, [
        analyticsClient,
        dispatch,
        navigate
    ]);
    const navigateToLogin = (0, $5xcuR.useNavigateToLoginPrompt)();
    const navigateToLoginPrompt = (0, $91i6m.useCallback)(()=>{
        analyticsClient.buttonClickedEvent($5c9e4cb9be8c89f0$var$pageId, 'addAccount', eventAttributes);
        navigateToLogin();
    }, [
        analyticsClient,
        navigateToLogin,
        eventAttributes
    ]);
    const navigateToRemoveAccountPrompt = (0, $91i6m.useCallback)(()=>{
        analyticsClient.buttonClickedEvent($5c9e4cb9be8c89f0$var$pageId, 'removeAccountFromList', eventAttributes);
        navigate({
            pathname: '/login/remove-account',
            search: search
        });
    }, [
        analyticsClient,
        eventAttributes,
        navigate,
        search
    ]);
    const LoginHintNotEmailAddress = ({ index: index, suggestedAccount: suggestedAccount, session: session })=>{
        return suggestedAccount ? /*#__PURE__*/ (0, $4ZSso.jsx)((0, $fJOIy.default), {
            id: `account-${suggestedAccount.accountId}`,
            primary: true,
            avatarUrl: suggestedAccount.avatarUrl,
            displayName: suggestedAccount.displayName,
            email: suggestedAccount.email,
            header: /*#__PURE__*/ (0, $4ZSso.jsx)($5c9e4cb9be8c89f0$var$UnauthorizedHeader, {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $99kO7.default), {
                    applicationDestination: applicationDestination,
                    emailAddress: session.email,
                    suggested: true
                })
            }),
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $2ZKUQ.default), {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                    appearance: "primary",
                    onClick: handleSessionClick(suggestedAccount, (0, $b2I6k._)((0, $1Fos3._)({}, eventAttributes), {
                        accountIndex: index
                    })) || undefined,
                    isFullWidth: true,
                    id: "continue",
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                        id: "select.account.continue",
                        defaultMessage: "Continue"
                    })
                })
            })
        }, `session-${suggestedAccount.sessionId}`) : /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
            children: [
                /*#__PURE__*/ (0, $4ZSso.jsx)((0, $fJOIy.default), {
                    id: `account-${session.accountId}`,
                    primary: true,
                    avatarUrl: session.avatarUrl,
                    displayName: session.displayName,
                    email: session.email,
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)($5c9e4cb9be8c89f0$var$UnauthorizedWrapper, {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $99kO7.default), {
                            applicationDestination: applicationDestination,
                            emailAddress: session.email,
                            suggested: false
                        })
                    })
                }, `session-${session.sessionId}`),
                sessions.length === 1 && /*#__PURE__*/ (0, $4ZSso.jsx)($5c9e4cb9be8c89f0$var$ButtonWrapper, {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                        id: "navigate-to-login-prompt",
                        appearance: "primary",
                        isFullWidth: true,
                        onClick: navigateToLoginPrompt,
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                            id: "select.account.add",
                            defaultMessage: "Log in to another account"
                        })
                    })
                })
            ]
        });
    };
    const LoginHint = ({ session: session, index: index, suggestedAccount: suggestedAccount, handleOnClick: handleOnClick })=>{
        if (!session.hint) return null;
        switch(session.hint){
            case (0, $jy3ZD.LoginHintType).EmailAddress:
                if (handleOnClick) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $fJOIy.default), {
                    id: `account-${session.accountId}`,
                    primary: true,
                    avatarUrl: session.avatarUrl,
                    displayName: session.displayName,
                    email: session.email,
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $2ZKUQ.default), {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                            appearance: "primary",
                            onClick: handleOnClick,
                            isFullWidth: true,
                            id: "continue",
                            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                                id: "select.account.continue",
                                defaultMessage: "Continue"
                            })
                        })
                    })
                }, `session-${session.sessionId}`);
                break;
            case (0, $jy3ZD.LoginHintType).NotEmailAddress:
                return /*#__PURE__*/ (0, $4ZSso.jsx)(LoginHintNotEmailAddress, {
                    index: index,
                    suggestedAccount: suggestedAccount,
                    session: session
                });
            default:
                return null;
        }
        return null;
    };
    const renderAccounts = ()=>{
        const suggestedAccount = getSuggestedAccount();
        const accountsList = sessions.map((session, index)=>{
            const { accountId: accountId, displayName: displayName, email: email } = session;
            const handleOnClick = handleSessionClick(session, (0, $b2I6k._)((0, $1Fos3._)({}, eventAttributes), {
                accountIndex: index
            }));
            return session.hint ? /*#__PURE__*/ (0, $4ZSso.jsx)(LoginHint, {
                session: session,
                index: index,
                suggestedAccount: suggestedAccount,
                handleOnClick: handleOnClick
            }, "session-hint") : !session.suggested && /*#__PURE__*/ (0, $4ZSso.jsx)($5c9e4cb9be8c89f0$var$AccountsListItem, {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $fJOIy.default), {
                    id: `account-${accountId}`,
                    onClick: handleOnClick || undefined,
                    avatarUrl: session.avatarUrl,
                    displayName: displayName,
                    email: email
                })
            }, `session-${session.sessionId}`);
        });
        const hasMultipleSessions = sessions.length > 1;
        const noLoginHint = sessions.length >= 1 && sessions[0].hint !== (0, $jy3ZD.LoginHintType).NotEmailAddress;
        const canAddSessions = (hasMultipleSessions || noLoginHint) && sessions.length <= $5c9e4cb9be8c89f0$var$MAXIMUM_ASSOCIATED_SESSIONS;
        if (canAddSessions) accountsList.push(/*#__PURE__*/ (0, $4ZSso.jsx)($5c9e4cb9be8c89f0$var$AccountsListItem, {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $fJOIy.AccountContainer), {
                id: "navigate-to-login-prompt",
                onClick: navigateToLoginPrompt,
                children: /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $fJOIy.RowButtonContainer), {
                    children: [
                        /*#__PURE__*/ (0, $4ZSso.jsx)((0, $fJOIy.AvatarContainer), {
                            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($isKwq))), {
                                label: "",
                                size: "medium"
                            })
                        }),
                        /*#__PURE__*/ (0, $4ZSso.jsx)((0, $fJOIy.TextContainer), {
                            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $fJOIy.Paragraph), {
                                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                                    id: "select.account.another",
                                    defaultMessage: "Add another account"
                                })
                            })
                        })
                    ]
                })
            })
        }, "navigate-to-login-prompt"));
        if (hasMultipleSessions) {
            const showRequestAccessLink = shouldShowRequestAccessLink();
            const showMaximumSessionsText = sessions.length > $5c9e4cb9be8c89f0$var$MAXIMUM_ASSOCIATED_SESSIONS;
            const noBorder = !showMaximumSessionsText && !showRequestAccessLink;
            accountsList.push(/*#__PURE__*/ (0, $4ZSso.jsx)($5c9e4cb9be8c89f0$var$AccountsListItem, {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $fJOIy.AccountContainer), {
                    id: "navigate-to-remove-account-prompt",
                    noBorder: noBorder,
                    onClick: navigateToRemoveAccountPrompt,
                    children: /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $fJOIy.RowButtonContainer), {
                        children: [
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $fJOIy.AvatarContainer), {
                                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($h0h8A))), {
                                    label: "",
                                    size: "medium"
                                })
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $fJOIy.TextContainer), {
                                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $fJOIy.Paragraph), {
                                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                                        id: "select.account.footer.navigate.to.remove.account",
                                        defaultMessage: "Remove accounts from this browser"
                                    })
                                })
                            })
                        ]
                    })
                })
            }, "navigate-to-remove-account-prompt"));
        }
        const loginHintAccountIndex = sessions.findIndex((session)=>session.hint);
        const loginHintAccount = loginHintAccountIndex >= 0 ? accountsList.splice(loginHintAccountIndex, 1) : [];
        const accounts = loginHintAccount.concat(/*#__PURE__*/ (0, $4ZSso.jsx)($5c9e4cb9be8c89f0$var$AccountsList, {
            children: accountsList
        }));
        return accounts;
    };
    const getSuggestedAccount = ()=>sessions.find((session)=>session.suggested);
    if (sessions.length > 0) return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $gs2u7.default), {
        pageId: $5c9e4cb9be8c89f0$var$pageId,
        header: renderHeader(),
        whiteboxFooter: renderMainContentFooter(),
        isLoading: isLoading,
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cYDRT.default), {
                children: renderAccounts()
            }),
            sessions.length > $5c9e4cb9be8c89f0$var$MAXIMUM_ASSOCIATED_SESSIONS && /*#__PURE__*/ (0, $4ZSso.jsx)($5c9e4cb9be8c89f0$var$SectionMessageWrapper, {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8iEgn.default), {
                    testId: "selectaccountmaximumassociatedsessions",
                    appearance: "warning",
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                        id: "select.account.maximum.associated.sessions",
                        defaultMessage: "You can only add up to 10 accounts. Remove at least one account from this browser to add another."
                    })
                })
            })
        ]
    });
    navigateToLoginPrompt();
    return null;
};
var $5c9e4cb9be8c89f0$export$2e2bcd8739ae039 = $5c9e4cb9be8c89f0$export$134466789cb44107;

});
parcelRegister("isKwq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d70eedceb8653096$var$_react = $d70eedceb8653096$var$_interopRequireDefault((parcelRequire("91i6m")));

var $gJR35 = parcelRequire("gJR35");

var $d70eedceb8653096$var$_personAvatar = $d70eedceb8653096$var$_interopRequireDefault((parcelRequire("3lN8O")));
function $d70eedceb8653096$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d70eedceb8653096$var$UserAvatarCircleIcon = (props)=>/*#__PURE__*/ $d70eedceb8653096$var$_react.default.createElement($gJR35.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="9" r="3" fill="inherit"/><path fill="inherit" fill-rule="nonzero" d="M7 18.245A7.97 7.97 0 0 0 12 20c1.892 0 3.63-.657 5-1.755V15c0-1.115-.895-2-2-2H9c-1.113 0-2 .895-2 2z"/></g></svg>`
    }, props, {
        newIcon: $d70eedceb8653096$var$_personAvatar.default
    }));
$d70eedceb8653096$var$UserAvatarCircleIcon.displayName = 'UserAvatarCircleIcon';
var $d70eedceb8653096$var$_default = module.exports.default = $d70eedceb8653096$var$UserAvatarCircleIcon;

});
parcelRegister("3lN8O", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aedef9bb726854d64999097926d2fc86>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $270973ad12405b0f$var$_react = $270973ad12405b0f$var$_interopRequireDefault((parcelRequire("91i6m")));

var $270973ad12405b0f$var$_baseNew = $270973ad12405b0f$var$_interopRequireDefault((parcelRequire("hVDwR")));
function $270973ad12405b0f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAvatar".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $270973ad12405b0f$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $270973ad12405b0f$var$_react.default.createElement($270973ad12405b0f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0-4.148 11.505A2.75 2.75 0 0 1 6.5 11h3c1.26 0 2.323.848 2.648 2.005A6.5 6.5 0 0 0 8 1.5m2.75 12.392v-.142c0-.69-.56-1.25-1.25-1.25h-3c-.69 0-1.25.56-1.25 1.25v.142l.06.027c.82.373 1.73.581 2.69.581s1.87-.208 2.69-.58q.03-.016.06-.028M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3.5 2a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" clip-rule="evenodd"/>`
    }, props));
$270973ad12405b0f$var$PersonAvatarIcon.displayName = 'PersonAvatarIcon';
var $270973ad12405b0f$var$_default = module.exports.default = $270973ad12405b0f$var$PersonAvatarIcon;

});


parcelRegister("h0h8A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c60fbae1f00aa6ef$var$_react = $c60fbae1f00aa6ef$var$_interopRequireDefault((parcelRequire("91i6m")));

var $gJR35 = parcelRequire("gJR35");

var $c60fbae1f00aa6ef$var$_crossCircle = $c60fbae1f00aa6ef$var$_interopRequireDefault((parcelRequire("clr9A")));
function $c60fbae1f00aa6ef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c60fbae1f00aa6ef$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $c60fbae1f00aa6ef$var$_react.default.createElement($gJR35.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="m13.477 9.113-4.36 4.386a1 1 0 1 0 1.418 1.41l4.36-4.386a1 1 0 0 0-1.418-1.41"/><path fill="inherit" d="m9.084 10.501 4.358 4.377a1 1 0 1 0 1.418-1.411L10.5 9.09a1 1 0 0 0-1.417 1.411"/></g></svg>`
    }, props, {
        newIcon: $c60fbae1f00aa6ef$var$_crossCircle.default
    }));
$c60fbae1f00aa6ef$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $c60fbae1f00aa6ef$var$_default = module.exports.default = $c60fbae1f00aa6ef$var$CrossCircleIcon;

});
parcelRegister("clr9A", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::70e4741cbfa8f6087ac64902b38a7366>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8fcc825e1e0c6862$var$_react = $8fcc825e1e0c6862$var$_interopRequireDefault((parcelRequire("91i6m")));

var $8fcc825e1e0c6862$var$_baseNew = $8fcc825e1e0c6862$var$_interopRequireDefault((parcelRequire("hVDwR")));
function $8fcc825e1e0c6862$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8fcc825e1e0c6862$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $8fcc825e1e0c6862$var$_react.default.createElement($8fcc825e1e0c6862$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$8fcc825e1e0c6862$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $8fcc825e1e0c6862$var$_default = module.exports.default = $8fcc825e1e0c6862$var$CrossCircleIcon;

});


parcelRegister("5UVuM", function(module, exports) {

$parcel$export(module.exports, "applicationDestinationSelector", function () { return $a722ba41f1ad1341$export$2305087f4689eaf8; });

var $dBq8m = parcelRequire("dBq8m");

var $fYxRW = parcelRequire("fYxRW");
parcelRequire("5jYTP");
var $4b5th = parcelRequire("4b5th");
const $a722ba41f1ad1341$var$parseContinueUrl = (search)=>{
    const params = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(search);
    if (params.continue) try {
        return new URL(params.continue);
    } catch (e) {
    //
    }
    return null;
};
const $a722ba41f1ad1341$export$2305087f4689eaf8 = (0, $4b5th.createSelector)([
    (0, $fYxRW.applicationSelector),
    (_state, search)=>search
], (applicationData, search)=>{
    const continueUrl = $a722ba41f1ad1341$var$parseContinueUrl(search);
    const destinationHostname = continueUrl && continueUrl.hostname || null;
    if (applicationData) {
        if (applicationData.application === 'jira' || applicationData.application === 'confluence') return {
            destinationHostname: destinationHostname,
            applicationName: applicationData.name
        };
        return {
            destinationHostname: null,
            applicationName: applicationData.name
        };
    }
    return null;
});
var $a722ba41f1ad1341$export$2e2bcd8739ae039 = $a722ba41f1ad1341$export$2305087f4689eaf8;

});

parcelRegister("99kO7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd54caf51ed9a4a9$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");

var $8iEgn = parcelRequire("8iEgn");
const $bd54caf51ed9a4a9$var$Message = ({ applicationDestination: applicationDestination, emailAddress: emailAddress, suggested: suggested })=>{
    if (!applicationDestination) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
        id: "login.unauthorized.email.body",
        defaultMessage: "<strong>{email}</strong> doesn't have access to this content.",
        values: {
            strong: (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("strong", {
                    children: chunks
                }),
            email: emailAddress
        }
    });
    if (applicationDestination.destinationHostname) {
        if (suggested) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "login.unauthorized.host.suggested.body",
            defaultMessage: "<strong>{email}</strong> doesn't have access to <strong>{host}</strong>. Switch to the below account to continue.",
            values: {
                strong: (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("strong", {
                        children: chunks
                    }),
                email: emailAddress,
                host: applicationDestination.destinationHostname
            }
        });
        return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "login.unauthorized.host.body",
            defaultMessage: "<strong>{email}</strong> doesn't have access to {application} on <strong>{host}</strong>.",
            values: {
                strong: (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("strong", {
                        children: chunks
                    }),
                application: applicationDestination.applicationName,
                email: emailAddress,
                host: applicationDestination.destinationHostname
            }
        });
    }
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
        id: "login.unauthorized.application.body",
        defaultMessage: "<strong>{email}</strong> doesn't have access to this content on <strong>{application}</strong>.",
        values: {
            strong: (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("strong", {
                    children: chunks
                }),
            application: applicationDestination.applicationName,
            email: emailAddress
        }
    });
};
const $bd54caf51ed9a4a9$var$UnauthorizedComponent = ({ applicationDestination: applicationDestination, emailAddress: emailAddress, suggested: suggested })=>{
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8iEgn.default), {
        testId: "unauthorized-user",
        appearance: "warning",
        children: /*#__PURE__*/ (0, $4ZSso.jsx)($bd54caf51ed9a4a9$var$Message, {
            applicationDestination: applicationDestination,
            emailAddress: emailAddress,
            suggested: !!suggested
        })
    });
};
var $bd54caf51ed9a4a9$export$2e2bcd8739ae039 = $bd54caf51ed9a4a9$var$UnauthorizedComponent;

});


parcelRegister("kjSSV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "continueAsLoader", function () { return $bf7ec3e1fa19f5e4$export$643f9a1ed27aa5c4; });
$parcel$export(module.exports, "ContinueAsPage", function () { return $bf7ec3e1fa19f5e4$export$a4ce1932d7e73468; });
$parcel$export(module.exports, "default", function () { return $bf7ec3e1fa19f5e4$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");

var $kQxhe = parcelRequire("kQxhe");

var $64QTD = parcelRequire("64QTD");

var $cLysE = parcelRequire("cLysE");

var $fJOIy = parcelRequire("fJOIy");

var $9jjaN = parcelRequire("9jjaN");

var $gtKO2 = parcelRequire("gtKO2");

var $7eeh4 = parcelRequire("7eeh4");

var $gs2u7 = parcelRequire("gs2u7");

var $6e88g = parcelRequire("6e88g");

var $1V2cH = parcelRequire("1V2cH");
parcelRequire("6d87w");
var $l2v8Y = parcelRequire("l2v8Y");

var $2aGBJ = parcelRequire("2aGBJ");

var $9uXJ3 = parcelRequire("9uXJ3");

var $5e2bj = parcelRequire("5e2bj");

var $kpg9c = parcelRequire("kpg9c");

var $3f4xr = parcelRequire("3f4xr");
let $bf7ec3e1fa19f5e4$var$_ = (t)=>t, $bf7ec3e1fa19f5e4$var$t;
const $bf7ec3e1fa19f5e4$var$AccountWrapper = (0, $9jjaN.default).div($bf7ec3e1fa19f5e4$var$t || ($bf7ec3e1fa19f5e4$var$t = $bf7ec3e1fa19f5e4$var$_`
  .account-entry {
    padding-bottom: ${0}px;
    border-bottom: none;
  }
`), (0, $6e88g.gridSize)() * 2);
const $bf7ec3e1fa19f5e4$var$pageId = 'continueAsScreen';
async function $bf7ec3e1fa19f5e4$export$643f9a1ed27aa5c4({ request: request }) {
    if (!await (0, $3f4xr.checkFeatureGateOnceInitialized)((0, $kpg9c.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $5e2bj.fetchPageState)('/rest/login/continue-as/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--continue-as'
        ]
    });
}
const $bf7ec3e1fa19f5e4$export$a4ce1932d7e73468 = ()=>{
    (0, $5e2bj.usePageStateLoader)();
    const [isLoading, setIsLoading] = (0, $91i6m.useState)(false);
    const { avatarUrl: avatarUrl, continueUrl: continueUrl, displayName: displayName, email: email } = (0, $2aGBJ.useAppSelector)((state)=>state.continueAs);
    const oidcContext = (0, $2aGBJ.useAppSelector)((state)=>state.microbranding.oidcContext);
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    const location = (0, $l2v8Y.useLocation)();
    (0, $1V2cH.usePageViewedEvent)($bf7ec3e1fa19f5e4$var$pageId);
    const trackContinueButtonClicked = (0, $1V2cH.useButtonClickedEvent)($bf7ec3e1fa19f5e4$var$pageId, 'continueAsButton');
    const handleContinueButton = (0, $91i6m.useCallback)(()=>{
        trackContinueButtonClicked();
        setIsLoading(true);
        navigate(continueUrl);
    }, [
        continueUrl,
        trackContinueButtonClicked,
        navigate
    ]);
    const trackLoginWithOtherAccountClicked = (0, $1V2cH.useButtonClickedEvent)($bf7ec3e1fa19f5e4$var$pageId, 'loginWithOtherAccount');
    const whiteboxFooter = ()=>{
        const operand = location.search && location.search.length > 0 ? '&' : '?';
        const loginLink = `/login${location.search}${operand}prompt=true`;
        if (!(0, $7eeh4.isOidcDisplayMode)(oidcContext, (0, $gtKO2.OidcDisplay).Continue)) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4ZSso.Fragment), {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $64QTD.default), {
                onClick: trackLoginWithOtherAccountClicked,
                href: loginLink,
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "continue.as.login.with.another.account",
                    defaultMessage: "Login with a different account"
                })
            })
        });
        return null;
    };
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $gs2u7.default), {
        pageId: $bf7ec3e1fa19f5e4$var$pageId,
        header: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $kQxhe.default), {
            displayName: displayName
        }),
        whiteboxFooter: whiteboxFooter(),
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)($bf7ec3e1fa19f5e4$var$AccountWrapper, {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $fJOIy.default), {
                    primary: true,
                    avatarUrl: avatarUrl,
                    displayName: displayName,
                    email: email
                })
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                appearance: "primary",
                id: "login-submit",
                type: "submit",
                isFullWidth: true,
                isLoading: isLoading,
                onClick: handleContinueButton,
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "continue.as.button",
                    defaultMessage: "Continue"
                })
            })
        ]
    });
};
var $bf7ec3e1fa19f5e4$export$2e2bcd8739ae039 = $bf7ec3e1fa19f5e4$export$a4ce1932d7e73468;

});
parcelRegister("kQxhe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0dfb08d9a4f7b14$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $4jXgk = parcelRequire("4jXgk");

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");
const $b0dfb08d9a4f7b14$var$ContinueAsHeader = ({ displayName: displayName })=>{
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Fragment, {
        children: displayName ? /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4jXgk.default), {
            as: "h1",
            size: "small",
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "continue.as.title.as",
                defaultMessage: "Continue as"
            })
        }) : /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "continue.as.title.as.application",
            tagName: "div",
            defaultMessage: "Continue to the application"
        })
    });
};
var $b0dfb08d9a4f7b14$export$2e2bcd8739ae039 = $b0dfb08d9a4f7b14$var$ContinueAsHeader;

});


parcelRegister("4xWO8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "migrateConfirmationLoader", function () { return $8b8ca23e74f2f750$export$14853815c59b96ba; });
$parcel$export(module.exports, "MigrateAccountConfirmationPage", function () { return $8b8ca23e74f2f750$export$3432bb22f729c42b; });
$parcel$export(module.exports, "default", function () { return $8b8ca23e74f2f750$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $8KhCJ = parcelRequire("8KhCJ");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");
parcelRequire("6d87w");
var $l2v8Y = parcelRequire("l2v8Y");

var $9jjaN = parcelRequire("9jjaN");

var $6e88g = parcelRequire("6e88g");

var $k8ZoM = parcelRequire("k8ZoM");

var $tSsMQ = parcelRequire("tSsMQ");

var $2ZKUQ = parcelRequire("2ZKUQ");

var $cLysE = parcelRequire("cLysE");

var $fG57D = parcelRequire("fG57D");

var $gs2u7 = parcelRequire("gs2u7");

var $fYxRW = parcelRequire("fYxRW");

var $1V2cH = parcelRequire("1V2cH");

var $2aGBJ = parcelRequire("2aGBJ");

var $9uXJ3 = parcelRequire("9uXJ3");

var $5e2bj = parcelRequire("5e2bj");

var $kpg9c = parcelRequire("kpg9c");

var $3f4xr = parcelRequire("3f4xr");

var $4jXgk = parcelRequire("4jXgk");
let $8b8ca23e74f2f750$var$_ = (t)=>t, $8b8ca23e74f2f750$var$t;
const $8b8ca23e74f2f750$var$MigrateAccountConfirmationSubHeading = (0, $9jjaN.default).p($8b8ca23e74f2f750$var$t || ($8b8ca23e74f2f750$var$t = $8b8ca23e74f2f750$var$_`
  font: ${0};
  margin-top: ${0}px;
`), (0, $k8ZoM.default)('font.body'), (0, $6e88g.gridSize)());
const $8b8ca23e74f2f750$var$pageId = 'accountMigrationSuccessfulScreen';
async function $8b8ca23e74f2f750$export$14853815c59b96ba({ request: request }) {
    if (!await (0, $3f4xr.checkFeatureGateOnceInitialized)((0, $kpg9c.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $5e2bj.fetchPageState)('/rest/signup/migrate-confirmation/state', request, {
        capabilities: []
    });
}
const $8b8ca23e74f2f750$export$3432bb22f729c42b = ()=>{
    (0, $5e2bj.usePageStateLoader)();
    const cobranding = (0, $2aGBJ.useAppSelector)((state)=>state.cobranding);
    const redirectTo = (0, $2aGBJ.useAppSelector)((state)=>state.migrateConfirmation.redirectTo);
    const location = (0, $l2v8Y.useLocation)();
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    const { infoCode: infoCode } = (0, (/*@__PURE__*/$parcel$interopDefault($tSsMQ))).parse(location.search.slice(1));
    const migratingUserInfoCode = infoCode || null;
    const pageViewedAttributes = migratingUserInfoCode ? {
        reasonViewingScreen: migratingUserInfoCode
    } : {};
    (0, $1V2cH.usePageViewedEvent)($8b8ca23e74f2f750$var$pageId, pageViewedAttributes);
    const trackContinueToProduct = (0, $1V2cH.useButtonClickedEvent)($8b8ca23e74f2f750$var$pageId, 'continueToProduct');
    const handleOnClick = ()=>{
        trackContinueToProduct();
        navigate(redirectTo);
    };
    const productDisplayName = cobranding && cobranding.application && (0, $fYxRW.applications)[cobranding.application] ? (0, $fYxRW.applications)[cobranding.application].name : 'Product';
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $gs2u7.default), {
        pageId: $8b8ca23e74f2f750$var$pageId,
        header: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4jXgk.default), {
            as: "h1",
            size: "small",
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $fG57D.default).migrateAccountConfirmationTitle))
        }),
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)($8b8ca23e74f2f750$var$MigrateAccountConfirmationSubHeading, {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $b2I6k._)((0, $1Fos3._)({}, (0, $fG57D.default).migrateAccountConfirmationSummaryText), {
                    values: {
                        productDisplayName: productDisplayName
                    }
                }))
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $2ZKUQ.default), {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                    appearance: "primary",
                    id: "continue-submit",
                    type: "submit",
                    isFullWidth: true,
                    onClick: handleOnClick,
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $b2I6k._)((0, $1Fos3._)({}, (0, $fG57D.default).migrateAccountConfirmationButtonText), {
                        values: {
                            productDisplayName: productDisplayName
                        }
                    }))
                })
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8KhCJ.default), {
                title: formatMessage((0, $fG57D.default).headTitle)
            })
        ]
    });
};
var $8b8ca23e74f2f750$export$2e2bcd8739ae039 = $8b8ca23e74f2f750$export$3432bb22f729c42b;

});
parcelRegister("tSsMQ", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $059cf4d3767746b6$export$2f872c0f2117be69; }, function (v) { return $059cf4d3767746b6$export$2f872c0f2117be69 = v; });
$parcel$export(module.exports, "parse", function () { return $059cf4d3767746b6$export$98e6a39c04603d36; }, function (v) { return $059cf4d3767746b6$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "encode", function () { return $059cf4d3767746b6$export$c564cdbbe6da493; }, function (v) { return $059cf4d3767746b6$export$c564cdbbe6da493 = v; });
$parcel$export(module.exports, "stringify", function () { return $059cf4d3767746b6$export$fac44ee5b035f737; }, function (v) { return $059cf4d3767746b6$export$fac44ee5b035f737 = v; });
var $059cf4d3767746b6$export$2f872c0f2117be69;
var $059cf4d3767746b6$export$98e6a39c04603d36;
var $059cf4d3767746b6$export$c564cdbbe6da493;
var $059cf4d3767746b6$export$fac44ee5b035f737;
'use strict';

$059cf4d3767746b6$export$2f872c0f2117be69 = $059cf4d3767746b6$export$98e6a39c04603d36 = (parcelRequire("fDq7Y"));

$059cf4d3767746b6$export$c564cdbbe6da493 = $059cf4d3767746b6$export$fac44ee5b035f737 = (parcelRequire("6XAKn"));

});
parcelRegister("fDq7Y", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $b61ec3f3e24ac80d$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || '&';
    eq = eq || '=';
    var obj = {};
    if (typeof qs !== 'string' || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === 'number') maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, '%20'), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = '';
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$b61ec3f3e24ac80d$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if ($b61ec3f3e24ac80d$var$isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var $b61ec3f3e24ac80d$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};

});

parcelRegister("6XAKn", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $5114c1f17d5686af$var$stringifyPrimitive = function(v) {
    switch(typeof v){
        case 'string':
            return v;
        case 'boolean':
            return v ? 'true' : 'false';
        case 'number':
            return isFinite(v) ? v : '';
        default:
            return '';
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || '&';
    eq = eq || '=';
    if (obj === null) obj = undefined;
    if (typeof obj === 'object') return $5114c1f17d5686af$var$map($5114c1f17d5686af$var$objectKeys(obj), function(k) {
        var ks = encodeURIComponent($5114c1f17d5686af$var$stringifyPrimitive(k)) + eq;
        if ($5114c1f17d5686af$var$isArray(obj[k])) return $5114c1f17d5686af$var$map(obj[k], function(v) {
            return ks + encodeURIComponent($5114c1f17d5686af$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($5114c1f17d5686af$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return '';
    return encodeURIComponent($5114c1f17d5686af$var$stringifyPrimitive(name)) + eq + encodeURIComponent($5114c1f17d5686af$var$stringifyPrimitive(obj));
};
var $5114c1f17d5686af$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};
function $5114c1f17d5686af$var$map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var $5114c1f17d5686af$var$objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

});


parcelRegister("fG57D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b83dff14385896ac$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $b83dff14385896ac$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    migrateAccountConfirmationTitle: {
        id: 'migrate.account.confirmation.title',
        defaultMessage: "We've migrated your account!",
        description: 'Page heading'
    },
    migrateAccountConfirmationButtonText: {
        id: 'migrate.account.confirmation.button.text',
        defaultMessage: 'Continue to {productDisplayName}',
        description: 'Button text'
    },
    migrateAccountConfirmationSummaryText: {
        id: 'migrate.account.confirmation.summary.text',
        defaultMessage: "Your {productDisplayName} password has expired. From now on, use your Atlassian account to access {productDisplayName}.",
        description: 'Summary text'
    },
    headTitle: {
        id: 'migrate.account.confirmation.head.title',
        defaultMessage: 'Confirmed'
    }
});

});


parcelRegister("eh3S5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "recoverLoader", function () { return $f875e88f16d4dbb5$export$1e2056400c8bd3bc; });
$parcel$export(module.exports, "RecoveryPage", function () { return $f875e88f16d4dbb5$export$280a36f5ba1cc19f; });
$parcel$export(module.exports, "default", function () { return $f875e88f16d4dbb5$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $8KhCJ = parcelRequire("8KhCJ");

var $9jjaN = parcelRequire("9jjaN");

var $6e88g = parcelRequire("6e88g");

var $4jXgk = parcelRequire("4jXgk");

var $7fkJo = parcelRequire("7fkJo");

var $6FKvy = parcelRequire("6FKvy");

var $gaHKK = parcelRequire("gaHKK");

var $gs2u7 = parcelRequire("gs2u7");

var $j96by = parcelRequire("j96by");

var $1V2cH = parcelRequire("1V2cH");

var $2aGBJ = parcelRequire("2aGBJ");

var $9uXJ3 = parcelRequire("9uXJ3");

var $5e2bj = parcelRequire("5e2bj");

var $3f4xr = parcelRequire("3f4xr");

var $kpg9c = parcelRequire("kpg9c");
let $f875e88f16d4dbb5$var$_ = (t)=>t, $f875e88f16d4dbb5$var$t;
const $f875e88f16d4dbb5$var$FormWrapper = (0, $9jjaN.default).div($f875e88f16d4dbb5$var$t || ($f875e88f16d4dbb5$var$t = $f875e88f16d4dbb5$var$_`
  margin-top: ${0}px;
`), (0, $6e88g.gridSize)());
const $f875e88f16d4dbb5$var$pageId = '2svRecoveryLoginScreen';
async function $f875e88f16d4dbb5$export$1e2056400c8bd3bc({ request: request }) {
    if (!await (0, $3f4xr.checkFeatureGateOnceInitialized)((0, $kpg9c.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $5e2bj.fetchPageState)('/rest/2step/recover/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--mfa-recover'
        ]
    });
}
const $f875e88f16d4dbb5$export$280a36f5ba1cc19f = ()=>{
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    (0, $1V2cH.usePageViewedEvent)($f875e88f16d4dbb5$var$pageId);
    (0, $5e2bj.usePageStateLoader)();
    const { error: error, fieldErrors: fieldErrors, redirectTo: redirectTo, isLoading: isLoading } = (0, $2aGBJ.useAppSelector)((state)=>state.recovery);
    const email = (0, $2aGBJ.useAppSelector)((state)=>state.user.email);
    (0, $91i6m.useEffect)(()=>{
        return ()=>{
            dispatch((0, $j96by.reset)());
        };
    }, [
        dispatch
    ]);
    (0, $91i6m.useEffect)(()=>{
        if (redirectTo) navigate(redirectTo);
    }, [
        redirectTo,
        navigate
    ]);
    const handleValidationError = (0, $91i6m.useCallback)((errors)=>{
        dispatch((0, $j96by.showFieldErrors)(errors));
    }, [
        dispatch
    ]);
    const handleLogIn = (0, $91i6m.useCallback)((username, password)=>{
        dispatch((0, $j96by.loginRecovery)({
            username: username,
            password: password,
            location: window.location,
            pageId: $f875e88f16d4dbb5$var$pageId,
            analyticsClient: analyticsClient
        }));
    }, [
        dispatch,
        analyticsClient
    ]);
    const buildHeader = ()=>{
        return /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4jXgk.default), {
                size: "small",
                as: "h1",
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "recovery.title",
                    defaultMessage: "Login to your Atlassian account"
                })
            })
        });
    };
    const onTsvLoginClick = (0, $1V2cH.useButtonClickedEvent)($f875e88f16d4dbb5$var$pageId, '2svRecoveryLogin');
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $gs2u7.default), {
        pageId: $f875e88f16d4dbb5$var$pageId,
        header: buildHeader(),
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8KhCJ.default), {
                title: formatMessage((0, $6FKvy.RecoveryPageMessages).headTitle)
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)($f875e88f16d4dbb5$var$FormWrapper, {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $7fkJo.default), {
                    email: email,
                    emailFieldLabel: formatMessage((0, $gaHKK.default).loginFormUsernameLabel),
                    error: error,
                    fieldErrors: fieldErrors,
                    isLoading: isLoading,
                    onValidationError: handleValidationError,
                    submitButtonText: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                        id: "common.login",
                        defaultMessage: "Log in"
                    }),
                    onSubmitClick: onTsvLoginClick,
                    onSubmit: handleLogIn
                })
            })
        ]
    });
};
var $f875e88f16d4dbb5$export$2e2bcd8739ae039 = $f875e88f16d4dbb5$export$280a36f5ba1cc19f;

});
parcelRegister("6FKvy", function(module, exports) {

$parcel$export(module.exports, "RecoveryPageMessages", function () { return $7998b4f62c21f3f6$export$d587a18b8a3f34fa; });

var $j5RJC = parcelRequire("j5RJC");
const $7998b4f62c21f3f6$export$d587a18b8a3f34fa = (0, $j5RJC.defineMessages)({
    headTitle: {
        id: 'login.head.title',
        defaultMessage: 'Log in to continue'
    }
});

});

parcelRegister("gaHKK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcb38136af8a7975$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $dcb38136af8a7975$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    loginFormUsernamePlaceholder: {
        id: 'login.form.username.placeholder',
        defaultMessage: 'Enter email'
    },
    loginFormUsernameLabel: {
        id: 'login.form.username.label',
        defaultMessage: 'Email'
    },
    loginFormReadOnlyUsernameAriaLabel: {
        id: 'login.form.readonly.username.aria.label',
        defaultMessage: 'Edit email'
    }
});

});

parcelRegister("j96by", function(module, exports) {

$parcel$export(module.exports, "reset", function () { return $c8d552e23cd8c928$export$aad8462122ac592b; });
$parcel$export(module.exports, "showFieldErrors", function () { return $c8d552e23cd8c928$export$f17d5fd8029ff8d7; });
$parcel$export(module.exports, "loginRecovery", function () { return $c8d552e23cd8c928$export$29e90b35a0be5386; });
const $c8d552e23cd8c928$export$aad8462122ac592b = ()=>({
        type: 'TSV_RECOVERY_RESET'
    });
const $c8d552e23cd8c928$export$808a667858638948 = (redirectTo)=>({
        type: 'TSV_RECOVERY_LOGIN_REQUEST_LINK_REDIRECT',
        redirectTo: redirectTo
    });
const $c8d552e23cd8c928$export$51ae2c0618607c9f = (error)=>({
        type: 'TSV_RECOVERY_REQUEST_FAILED',
        error: error
    });
const $c8d552e23cd8c928$export$f17d5fd8029ff8d7 = (error)=>({
        type: 'TSV_RECOVERY_SHOW_FIELD_ERRORS',
        error: error
    });
const $c8d552e23cd8c928$export$29e90b35a0be5386 = ({ location: location, password: password, pageId: pageId, analyticsClient: analyticsClient })=>(dispatch, getState)=>{
        const { csrfToken: csrfToken } = getState();
        dispatch($c8d552e23cd8c928$export$aad8462122ac592b());
        return fetch(`/2step/recover${location.search}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            },
            body: JSON.stringify({
                password: password
            })
        }).then((res)=>res.json()).then(({ fieldErrors: fieldErrors, uiErrors: uiErrors, redirectTo: redirectTo })=>{
            if (redirectTo) dispatch($c8d552e23cd8c928$export$808a667858638948(redirectTo));
            else {
                if (fieldErrors && Object.keys(fieldErrors).length) dispatch($c8d552e23cd8c928$export$f17d5fd8029ff8d7(fieldErrors));
                else if (uiErrors && uiErrors.length) {
                    const uiError = uiErrors[0];
                    if (uiError.key === 'password') analyticsClient.errorShownEvent(pageId, '2svRecoveryIncorrectPassword');
                    else analyticsClient.errorShownEvent(pageId, '2svRecoveryUnexpectedError');
                    dispatch($c8d552e23cd8c928$export$51ae2c0618607c9f(uiError.error));
                }
            }
        }).catch(()=>{
            analyticsClient.errorShownEvent(pageId, '2svRecoveryUnexpectedError');
            dispatch($c8d552e23cd8c928$export$51ae2c0618607c9f('unknown'));
        });
    };

});



parcelRegister("lyaVk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a132fe8f70a6da4d$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $8KhCJ = parcelRequire("8KhCJ");

var $6d87w = parcelRequire("6d87w");

var $bqdjD = parcelRequire("bqdjD");
const $a132fe8f70a6da4d$var$mobileAppToUrlPatterns = {
    jira: [
        '/secure',
        '/issues',
        '/browse',
        '#issue',
        '#myjirahome',
        '#browse'
    ],
    confluence: [
        '/wiki'
    ]
};
const $a132fe8f70a6da4d$var$iosAppId = {
    jira: '1006972087',
    confluence: '1006971684'
};
const $a132fe8f70a6da4d$var$slackAppId = {
    jira: 'A2RPP3NFR',
    confluence: 'AC23SDS77'
};
/**
 * Checks if the continueUrl contains the specified pattern.
 * Additionally searches for the url encoded form of the pattern,
 * which can be encoded up to 3 times e.g. openId continue urls.
 */ const $a132fe8f70a6da4d$var$checkForPattern = (continueUrl, pattern)=>{
    if (continueUrl.includes(pattern)) return true;
    const encode1 = encodeURIComponent(pattern);
    const encode2 = encodeURIComponent(encode1);
    const encode3 = encodeURIComponent(encode2);
    return continueUrl.includes(encode1) || continueUrl.includes(encode2) || continueUrl.includes(encode3);
};
/**
 * Adds mobile app meta tags to the document head if the continueUrl matches a pattern configured for mobile apps.
 */ const $a132fe8f70a6da4d$var$MobileAppMetaTags = ()=>{
    const [queryParams] = (0, $6d87w.useSearchParams)();
    const continueUrl = queryParams.get('continue');
    const maybeMobileApp = (0, $91i6m.useMemo)(()=>{
        if (!continueUrl) return null;
        for (const [mobileApp, urlPatterns] of Object.entries($a132fe8f70a6da4d$var$mobileAppToUrlPatterns)){
            if (urlPatterns.find((urlPattern)=>$a132fe8f70a6da4d$var$checkForPattern(continueUrl, urlPattern))) return mobileApp;
        }
        return null;
    }, [
        continueUrl
    ]);
    return maybeMobileApp && /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $8KhCJ.default), {
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)("meta", {
                name: "apple-itunes-app",
                content: `app-id=${$a132fe8f70a6da4d$var$iosAppId[maybeMobileApp]}`
            }),
            (0, $bqdjD.getCurrentCloudType)() === 'commercial' && /*#__PURE__*/ (0, $4ZSso.jsx)("meta", {
                name: "slack-app-id",
                content: $a132fe8f70a6da4d$var$slackAppId[maybeMobileApp]
            })
        ]
    });
};
var $a132fe8f70a6da4d$export$2e2bcd8739ae039 = $a132fe8f70a6da4d$var$MobileAppMetaTags;

});

parcelRegister("lOb8r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80e25aa1cd9fef08$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $gFEh4 = parcelRequire("gFEh4");

var $7Ceim = parcelRequire("7Ceim");

var $6xCxk = parcelRequire("6xCxk");

var $2aGBJ = parcelRequire("2aGBJ");
const $80e25aa1cd9fef08$export$f90bece7989dfdb6 = ({ children: children })=>{
    const intl = (0, $leG06.default)();
    const serverError = (0, $2aGBJ.useAppSelector)((state)=>state.serverError);
    if (serverError) {
        if (serverError.type === 'not_found') return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gFEh4.default), {
            title: intl.formatMessage((0, $6xCxk.default).notFoundTitle)
        });
        else if (serverError.type === 'internal_server_error') return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gFEh4.default), {
            title: intl.formatMessage((0, $6xCxk.default).internalServerErrorTitle),
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $6xCxk.default).internalServerErrorDescription))
        });
        else if (serverError.type === 'bad_request') return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gFEh4.default), {
            title: intl.formatMessage((0, $6xCxk.default).badRequestTitle),
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "error.badrequest.desc.xml",
                defaultMessage: "Often, clearing your browsers cache and restarting your browser will solve this problem.{br}If that doesn't work, please <support-link>contact support</support-link>.",
                values: {
                    br: /*#__PURE__*/ (0, $4ZSso.jsx)("br", {}),
                    'support-link': (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("a", {
                            href: "https://support.atlassian.com/",
                            target: "_blank",
                            rel: "noreferrer",
                            children: chunks
                        })
                }
            })
        });
        else if (serverError.type === 'csrf_token_mismatch') return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $7Ceim.default), {});
        else throw new Error(serverError.type || 'ServerError');
    }
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4ZSso.Fragment), {
        children: children
    });
};
var $80e25aa1cd9fef08$export$2e2bcd8739ae039 = $80e25aa1cd9fef08$export$f90bece7989dfdb6;

});
parcelRegister("7Ceim", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a0b6b1f2c57ea62$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $dBq8m = parcelRequire("dBq8m");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $kyMDl = parcelRequire("kyMDl");

var $hqxJz = parcelRequire("hqxJz");

var $gs2u7 = parcelRequire("gs2u7");

var $cLysE = parcelRequire("cLysE");

var $2ZKUQ = parcelRequire("2ZKUQ");

var $1V2cH = parcelRequire("1V2cH");

var $9jjaN = parcelRequire("9jjaN");

var $6e88g = parcelRequire("6e88g");

var $9uXJ3 = parcelRequire("9uXJ3");

var $4jXgk = parcelRequire("4jXgk");
let $2a0b6b1f2c57ea62$var$_ = (t)=>t, $2a0b6b1f2c57ea62$var$t;
const $2a0b6b1f2c57ea62$var$pageId = 'atlassianAccountCsrfTokenMismatchErrorScreen';
const $2a0b6b1f2c57ea62$var$StyledOptions = (0, $9jjaN.default).ul($2a0b6b1f2c57ea62$var$t || ($2a0b6b1f2c57ea62$var$t = $2a0b6b1f2c57ea62$var$_`
  padding-left: ${0}px;
`), 3 * (0, $6e88g.gridSize)());
const $2a0b6b1f2c57ea62$export$2529ac9c93e3a3c2 = ()=>{
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    const preservedParamsKeys = [
        'application',
        'continue',
        'display',
        'email',
        'login_hint',
        'tenant'
    ];
    const originalParams = $dBq8m.parse(window.location.search);
    const preservedParams = Object.keys(originalParams).filter((key)=>preservedParamsKeys.includes(key)).reduce((obj, key)=>{
        obj[key] = originalParams[key];
        return obj;
    }, {});
    (0, $1V2cH.usePageViewedEvent)($2a0b6b1f2c57ea62$var$pageId, {
        application: preservedParams.application
    });
    const tryLoginAgainAction = ()=>{
        analyticsClient.buttonClickedEvent($2a0b6b1f2c57ea62$var$pageId, 'csrfTokenMismatchTryAgainButton', {
            application: preservedParams.application
        });
        const queryParamsString = $dBq8m.stringify(preservedParams);
        navigate('/login' + (queryParamsString ? `?${queryParamsString}` : ''));
    };
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $gs2u7.default), {
        pageId: $2a0b6b1f2c57ea62$var$pageId,
        header: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4jXgk.default), {
            as: "h1",
            size: "small",
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $hqxJz.default).csrfMismatchTitle))
        }),
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($kyMDl))),
                height: "150",
                alt: "",
                className: "error-image"
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)("br", {}),
            /*#__PURE__*/ (0, $4ZSso.jsxs)("div", {
                className: "error-description",
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $hqxJz.default).csrfMismatchDescriptionFirstLine)),
                    /*#__PURE__*/ (0, $4ZSso.jsxs)($2a0b6b1f2c57ea62$var$StyledOptions, {
                        children: [
                            /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                                    id: "error.csrfmismatch.description.secondline",
                                    defaultMessage: "Close any <b>{siteName}</b> windows in your browser",
                                    values: {
                                        b: (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("strong", {
                                                children: chunks
                                            }),
                                        siteName: window.location.hostname
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $hqxJz.default).csrfMismatchDescriptionThirdLine))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $2ZKUQ.default), {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                    appearance: "primary",
                    id: "try-again-button",
                    isFullWidth: true,
                    onClick: tryLoginAgainAction,
                    children: formatMessage((0, $hqxJz.default).csrfMismatchButtonText)
                })
            })
        ]
    });
};
var $2a0b6b1f2c57ea62$export$2e2bcd8739ae039 = $2a0b6b1f2c57ea62$export$2529ac9c93e3a3c2;

});
parcelRegister("hqxJz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1667e98f8b35a4a$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $b1667e98f8b35a4a$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    csrfMismatchTitle: {
        id: 'error.csrfmismatch.title',
        defaultMessage: "We couldn't log you in"
    },
    csrfMismatchDescriptionFirstLine: {
        id: 'error.csrfmismatch.description.firstline',
        defaultMessage: 'Before trying again:'
    },
    csrfMismatchDescriptionThirdLine: {
        id: 'error.csrfmismatch.description.thirdline',
        defaultMessage: 'Check your browser settings and disable any extensions that may interfere with cookies.'
    },
    csrfMismatchButtonText: {
        id: 'error.csrfmismatch.button',
        defaultMessage: 'Try logging in again'
    }
});

});


parcelRegister("6xCxk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64904140bb26b1f4$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $64904140bb26b1f4$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    genericErrorTitle: {
        id: 'error.title',
        defaultMessage: 'Something went wrong.'
    },
    internalServerErrorTitle: {
        id: 'error.internalservererror.title',
        defaultMessage: 'Something went wrong while executing your request.'
    },
    internalServerErrorDescription: {
        id: 'error.internalservererror.desc',
        defaultMessage: "We're working on it, please try again shortly."
    },
    notFoundTitle: {
        id: 'error.notfound.title',
        defaultMessage: 'Page Not Found'
    },
    badRequestTitle: {
        id: 'error.badrequest.title',
        defaultMessage: "Oops, you've made a malformed request."
    }
});

});


parcelRegister("jdSEF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d4dde1c865bcaae$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");

var $7eeh4 = parcelRequire("7eeh4");

var $gFEh4 = parcelRequire("gFEh4");

var $2aGBJ = parcelRequire("2aGBJ");
const $6d4dde1c865bcaae$var$isUnSupportedMobileBrowser = ()=>{
    return /UC.*Browser|UCWEB/.test(window.navigator.userAgent);
};
const $6d4dde1c865bcaae$export$3746f9f8319adede = ({ children: children })=>{
    const oidcContext = (0, $2aGBJ.useAppSelector)((state)=>state.microbranding.oidcContext);
    if ((0, $7eeh4.isMobileOidc)(oidcContext) && $6d4dde1c865bcaae$var$isUnSupportedMobileBrowser()) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gFEh4.default), {
        title: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "unsupported.mobile.browser.error.message.heading",
            defaultMessage: "We\u2019re unable to log you in"
        }),
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "unsupported.mobile.browser.error.message.content",
            defaultMessage: "You are currently using an unsupported browser. Please use a supported browser such as Chrome, Firefox, Opera or Samsung Internet."
        })
    });
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4ZSso.Fragment), {
        children: children
    });
};
var $6d4dde1c865bcaae$export$2e2bcd8739ae039 = $6d4dde1c865bcaae$export$3746f9f8319adede;

});

parcelRegister("3jGGb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a21ec0f17c208628$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "UnexpectedApplicationErrorPage", function () { return $a21ec0f17c208628$export$4f726a446dcd19f1; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $gFEh4 = parcelRequire("gFEh4");

var $6T9dz = parcelRequire("6T9dz");

var $49Pnv = parcelRequire("49Pnv");
class $a21ec0f17c208628$export$2e2bcd8739ae039 extends (0, $91i6m.Component) {
    componentDidCatch(error, errorInfo) {
        // Handle case where the error is not specific enough for SLO but we still want to know about it
        // Example: build tools result in Event being thrown instead of Error, for failures to load
        // dynamically imported modules - should not burn SLO but is worth alerting via Sentry.
        if (!(error instanceof Error)) {
            this.setState({
                errorType: 'unexpected'
            });
            (0, $49Pnv.captureMalformedError)(new Error(`Caught object that is not of type Error: ${error}`), {
                error: error
            }, 'not-an-instance-of-error');
            return;
        }
        // Failed to fetch dynamically imported module:
        // Importing a module script failed.
        // error loading dynamically imported module:
        // Cannot find module
        if (/(import|find).*.module/i.test(error.message)) {
            this.setState({
                errorType: 'network'
            });
            return;
        }
        this.setState({
            errorType: 'unexpected'
        });
        if (this.props.skipAnalytics) return;
        const page = window.location.pathname;
        const attributes = {
            errorName: error.name,
            errorMessage: error.message,
            errorComponentStack: errorInfo.componentStack || undefined,
            errorStack: error.stack
        };
        (0, $49Pnv.captureTaggedReactException)(error, errorInfo, {
            capabilities: this.props.capabilities || [],
            extraProperties: {
                'ErrorBoundary.action': 'loadPageFailure',
                'ErrorBoundary.pageId': page
            }
        });
        this.props.analyticsClient.operationalEvent({
            page: page,
            action: 'loadPageFailure',
            subject: 'sli',
            attributes: attributes
        });
    }
    render() {
        const { errorType: errorType } = this.state;
        const anonymousId = this.props.analyticsClient.getAnonymousId();
        if (errorType === 'network') return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gFEh4.BaseErrorPage), {
            title: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "error.boundary.error.title",
                defaultMessage: "Something went wrong"
            }),
            anonymousId: anonymousId,
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "error.boundary.network.error",
                defaultMessage: "We were unable to load this page, possibly due to a network connectivity issue. Please check your network connection and try again.",
                tagName: "p"
            })
        });
        if (errorType === 'unexpected') return /*#__PURE__*/ (0, $4ZSso.jsx)($a21ec0f17c208628$export$4f726a446dcd19f1, {
            anonymousId: anonymousId
        });
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {};
    }
}
const $a21ec0f17c208628$export$4f726a446dcd19f1 = ({ anonymousId: anonymousId })=>/*#__PURE__*/ (0, $4ZSso.jsx)((0, $gFEh4.BaseErrorPage), {
        title: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "error.boundary.error.title",
            defaultMessage: "Something went wrong"
        }),
        anonymousId: anonymousId,
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "error.boundary.unexpected.error",
            defaultMessage: "An unexpected error occurred. We are looking into it. Please try again later.",
            tagName: "p"
        })
    });

});

parcelRegister("ieLFF", function(module, exports) {

$parcel$export(module.exports, "reactRouterFutureFlags", function () { return $64e761fcba2541d8$export$d4ead9fca2c685ee; });
const $64e761fcba2541d8$export$d4ead9fca2c685ee = {
    // Enabled all future flags for v7 upgrade: https://reactrouter.com/6.29.0/upgrading/future
    v7_fetcherPersist: true,
    v7_normalizeFormMethod: true,
    v7_partialHydration: true,
    v7_relativeSplatPath: true,
    v7_skipActionErrorRevalidation: true
};

});

parcelRegister("b8EMT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "loginLoader", function () { return $31fc0b63559b10c1$export$b2919fa8ecdd2f51; });
$parcel$export(module.exports, "default", function () { return $31fc0b63559b10c1$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $8KhCJ = parcelRequire("8KhCJ");

var $leG06 = parcelRequire("leG06");

var $k8MAo = parcelRequire("k8MAo");

var $7Clnv = parcelRequire("7Clnv");

var $gKURT = parcelRequire("gKURT");

var $gs2u7 = parcelRequire("gs2u7");

var $9b70D = parcelRequire("9b70D");

var $2aGBJ = parcelRequire("2aGBJ");

var $4rBM8 = parcelRequire("4rBM8");

var $gx7I6 = parcelRequire("gx7I6");

var $4tmE5 = parcelRequire("4tmE5");

var $k3QGO = parcelRequire("k3QGO");

var $68WXR = parcelRequire("68WXR");

var $1UkGo = parcelRequire("1UkGo");

var $NAfW5 = parcelRequire("NAfW5");

var $4Nxm2 = parcelRequire("4Nxm2");

var $6xwQE = parcelRequire("6xwQE");

var $h6Rwg = parcelRequire("h6Rwg");

var $6KORI = parcelRequire("6KORI");

var $7D2jm = parcelRequire("7D2jm");

var $5e2bj = parcelRequire("5e2bj");

var $kpg9c = parcelRequire("kpg9c");

var $3f4xr = parcelRequire("3f4xr");

var $ai0FP = parcelRequire("ai0FP");

var $dIBnq = parcelRequire("dIBnq");
async function $31fc0b63559b10c1$export$b2919fa8ecdd2f51({ request: request }) {
    if (!await (0, $3f4xr.checkFeatureGateOnceInitialized)((0, $kpg9c.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $5e2bj.fetchPageState)('/rest/login/state', request, {
        capabilities: [
            'capability-group--login'
        ]
    });
}
const $31fc0b63559b10c1$var$LoginPage = ()=>{
    const { state: state } = (0, $4rBM8.useLoginState)();
    const { oidcContext: oidcContext } = state || {};
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const { isPasswordlessAllowed: isPasswordlessAllowed, checkUsername: checkUsername, isUsernameChecked: isUsernameChecked, checkUsernameError: checkUsernameError, error: loginError, redirectType: redirectType, isRestrictedEmail: isRestrictedEmail, isCheckUsernameLoading: isCheckUsernameLoading, resetLogin: resetLogin, infoCode: infoCode, rememberMeEnabled: rememberMeEnabled, isRememberMeChecked: isRememberMeChecked, onToggleRememberMeCheckbox: onToggleRememberMeCheckbox } = (0, $4Nxm2.useLogin)();
    const { isLoading: isLoading, onLogin: handleLogIn, onPasswordlessLogin: handlePasswordlessLogIn } = (0, $6xwQE.useLoginSubmission)();
    const { onAppleLogin: onAppleLogin, onSlackLogin: onSlackLogin, onMicrosoftLogin: onMicrosoftLogin, onGoogleSocialLogin: onGoogleSocialLogin, onDismissGoogleOneTap: onDismissGoogleOneTap, socialLoginEligibility: socialLoginEligibility, envSupportsSocialLogin: envSupportsSocialLogin, isSocialBlocked: isSocialBlocked } = (0, $h6Rwg.useSocialLogin)();
    const { onPasskeyLogin: onPasskeyLogin, authenticating: authenticating } = (0, $dIBnq.usePasskeyLogin)();
    const cobrandingApplication = (0, $NAfW5.useCobrandingApplication)();
    const { isMobileApp: isMobileApp, isEmbedded: isEmbedded, screenSize: screenSize } = (0, $2aGBJ.useAppSelector)((state)=>state.microbranding);
    const isLoginSecondStep = isUsernameChecked;
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const emailFromSearchParams = (0, $NAfW5.useEmailFromSearchParams)();
    const [email, setEmail] = (0, $91i6m.useState)(()=>emailFromSearchParams || '');
    // Sync state with query params
    // In the case when the query params change after the component is first rendered
    (0, $91i6m.useEffect)(()=>{
        if (emailFromSearchParams) setEmail(emailFromSearchParams);
    }, [
        emailFromSearchParams
    ]);
    (0, $6KORI.useGoogleOneTap)({
        email: email
    });
    const { highlightedSocialProvider: highlightedSocialProvider = null, isEligibleForSocialLoginOnly: isEligibleForSocialLoginOnly = null } = socialLoginEligibility || {};
    const showSocialLoginOnly = isLoginSecondStep && isEligibleForSocialLoginOnly && highlightedSocialProvider && envSupportsSocialLogin;
    const handleGoogleSocialLogin = (0, $91i6m.useCallback)(()=>{
        if (envSupportsSocialLogin) onGoogleSocialLogin(email);
    }, [
        email,
        onGoogleSocialLogin,
        envSupportsSocialLogin
    ]);
    const handleMicrosoftLogin = (0, $91i6m.useCallback)(()=>{
        if (envSupportsSocialLogin) onMicrosoftLogin(email);
    }, [
        email,
        onMicrosoftLogin,
        envSupportsSocialLogin
    ]);
    const handleAppleLogin = (0, $91i6m.useCallback)(()=>{
        if (envSupportsSocialLogin) onAppleLogin(email);
    }, [
        email,
        onAppleLogin,
        envSupportsSocialLogin
    ]);
    const handleSlackLogin = (0, $91i6m.useCallback)(()=>{
        if (envSupportsSocialLogin) onSlackLogin(email);
    }, [
        email,
        onSlackLogin,
        envSupportsSocialLogin
    ]);
    const handlePasskeyLogin = (0, $91i6m.useCallback)(()=>{
        onPasskeyLogin();
    }, [
        onPasskeyLogin
    ]);
    const handleValidationError = (0, $91i6m.useCallback)((errors)=>dispatch((0, $k8MAo.showFormErrors)(errors)), [
        dispatch
    ]);
    const handleContinue = (email)=>{
        checkUsername(email);
    };
    const handleFormClick = (0, $91i6m.useCallback)(()=>{
        if (envSupportsSocialLogin && screenSize === 'mobile') onDismissGoogleOneTap();
    }, [
        onDismissGoogleOneTap,
        screenSize,
        envSupportsSocialLogin
    ]);
    const handleEmailChange = (0, $91i6m.useCallback)((email)=>{
        setEmail(email);
    }, []);
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8KhCJ.default), {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)("title", {
                    children: formatMessage((0, $9b70D.LoginPageMessages).headTitle)
                })
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gs2u7.default), {
                pageId: (0, $1UkGo.loginPageId),
                header: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4tmE5.default), {
                    highlightedSocialProvider: highlightedSocialProvider,
                    showSocialLoginOnly: showSocialLoginOnly
                }),
                footer: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gx7I6.default), {
                    oidcContext: oidcContext,
                    isEmbedded: isEmbedded
                }),
                whiteboxFooter: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $68WXR.default), {
                    showSocialLoginOnly: showSocialLoginOnly,
                    isMobileApp: isMobileApp,
                    oidcContext: oidcContext
                }),
                children: showSocialLoginOnly ? /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gKURT.default), {
                    email: email,
                    highlightedSocialProvider: highlightedSocialProvider,
                    handleGoogleLogin: handleGoogleSocialLogin,
                    handleMicrosoftLogin: handleMicrosoftLogin,
                    handleAppleLogin: handleAppleLogin,
                    handleSlackLogin: handleSlackLogin
                }) : /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4ZSso.jsx)((0, $7Clnv.default), {
                            application: cobrandingApplication || null,
                            redirectType: !isLoginSecondStep ? redirectType : null,
                            isRedirecting: redirectType !== null,
                            isSecondStep: isLoginSecondStep,
                            isPasswordlessAllowed: isPasswordlessAllowed,
                            isLoading: isLoading,
                            isCheckUsernameLoading: isCheckUsernameLoading,
                            onContinue: handleContinue,
                            onLogIn: handleLogIn,
                            onPasswordlessLogIn: handlePasswordlessLogIn,
                            error: loginError,
                            info: infoCode,
                            fieldErrors: {
                                email: checkUsernameError
                            },
                            email: email,
                            onValidationError: handleValidationError,
                            onEditEmail: resetLogin,
                            onFormClick: handleFormClick,
                            restrictedEmail: isRestrictedEmail,
                            pageId: (0, $1UkGo.loginPageId),
                            onEmailChange: handleEmailChange,
                            showRememberMeCheckbox: rememberMeEnabled,
                            rememberMeChecked: isRememberMeChecked,
                            onToggleRememberMeCheckbox: onToggleRememberMeCheckbox
                        }),
                        /*#__PURE__*/ (0, $4ZSso.jsx)((0, $ai0FP.default), {
                            onPasskeyLogin: handlePasskeyLogin,
                            authenticating: authenticating
                        }),
                        /*#__PURE__*/ (0, $4ZSso.jsx)((0, $k3QGO.default), {
                            isEmbedded: isEmbedded,
                            envSupportsSocialLogin: envSupportsSocialLogin,
                            isSocialBlocked: isSocialBlocked,
                            onSlackLogin: handleSlackLogin,
                            onAppleLogin: handleAppleLogin,
                            onMicrosoftLogin: handleMicrosoftLogin,
                            onGoogleLogin: handleGoogleSocialLogin
                        })
                    ]
                })
            })
        ]
    });
};
function $31fc0b63559b10c1$var$LoginRoute() {
    // TODO: KIRBY-8427: tidy up this double check.
    const { shouldShowRememberedAccounts: shouldShowRememberedAccounts } = (0, $4Nxm2.useLogin)();
    if (shouldShowRememberedAccounts) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $7D2jm.default), {});
    return /*#__PURE__*/ (0, $4ZSso.jsx)($31fc0b63559b10c1$var$LoginPage, {});
}
var $31fc0b63559b10c1$export$2e2bcd8739ae039 = $31fc0b63559b10c1$var$LoginRoute;

});
parcelRegister("k8MAo", function(module, exports) {

$parcel$export(module.exports, "requestCheckUsername", function () { return $1f9969ad83fb8729$export$46a04796807ec7cb; });
$parcel$export(module.exports, "requestCheckUsernameV2", function () { return $1f9969ad83fb8729$export$100ac3ffc8db9b3e; });
$parcel$export(module.exports, "checkUsernameCaptchaFailure", function () { return $1f9969ad83fb8729$export$c48d28459d63299c; });
$parcel$export(module.exports, "resetLoginForm", function () { return $1f9969ad83fb8729$export$6a45e1ba06bcfd40; });
$parcel$export(module.exports, "resetRememberMeState", function () { return $1f9969ad83fb8729$export$f89c906644f34324; });
$parcel$export(module.exports, "showFormErrors", function () { return $1f9969ad83fb8729$export$f89084e6f067bb43; });
$parcel$export(module.exports, "setRememberMeCheckbox", function () { return $1f9969ad83fb8729$export$8eb90c84b47e7339; });
$parcel$export(module.exports, "toggleRememberMeCheckbox", function () { return $1f9969ad83fb8729$export$64749aae889ad7b0; });
$parcel$export(module.exports, "loginSetState", function () { return $1f9969ad83fb8729$export$10cc404412d31053; });
$parcel$export(module.exports, "checkUsername", function () { return $1f9969ad83fb8729$export$4929d86c6e4e281e; });
$parcel$export(module.exports, "checkUsernameV2", function () { return $1f9969ad83fb8729$export$67b7193bb8e24ea6; });
$parcel$export(module.exports, "loginUsernamePassword", function () { return $1f9969ad83fb8729$export$5391cc01902916c6; });
$parcel$export(module.exports, "loginPasswordless", function () { return $1f9969ad83fb8729$export$a6eaf375001ea98a; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $dBq8m = parcelRequire("dBq8m");

var $kU6Wu = parcelRequire("kU6Wu");

var $90yWB = parcelRequire("90yWB");

var $49Pnv = parcelRequire("49Pnv");

var $gtKO2 = parcelRequire("gtKO2");

var $fqbXQ = parcelRequire("fqbXQ");

var $1UkGo = parcelRequire("1UkGo");

var $kfTGh = parcelRequire("kfTGh");

var $hB2TQ = parcelRequire("hB2TQ");

var $4JAG5 = parcelRequire("4JAG5");

var $a1suH = parcelRequire("a1suH");
const $1f9969ad83fb8729$export$9cdc46fdb2ee9975 = (response)=>response.ok ? response : response.text().then((error)=>{
        throw new Error(error || response.statusText);
    });
const $1f9969ad83fb8729$export$46a04796807ec7cb = ()=>({
        type: 'LOGIN_REQUEST_CHECK_USERNAME'
    });
const $1f9969ad83fb8729$export$100ac3ffc8db9b3e = ()=>({
        type: 'LOGIN_REQUEST_CHECK_USERNAME_V2'
    });
const $1f9969ad83fb8729$export$34d1ed284038d066 = (accounts)=>({
        type: 'LOGIN_REQUEST_CHECK_USERNAME_V2_SUCCEEDED',
        accounts: accounts
    });
const $1f9969ad83fb8729$export$2edff4284d04f803 = (userAction)=>({
        type: 'LOGIN_REQUEST_CHECK_USERNAME_REDIRECT',
        redirectUrl: userAction.redirect_uri,
        redirectType: userAction.redirect_type
    });
const $1f9969ad83fb8729$export$5cc9c4683c14face = ()=>({
        type: 'LOGIN_REQUEST_CHECK_USERNAME_SIGNUP'
    });
const $1f9969ad83fb8729$export$c7d021a470828fad = (userAction)=>({
        type: 'LOGIN_REQUEST_CHECK_USERNAME_NO_ACTION',
        passwordless: userAction.passwordless || (0, $gtKO2.CheckUserNamePasswordlessType).Disallowed,
        social: userAction.social || 'allowed'
    });
const $1f9969ad83fb8729$export$a7eb3c2b6fb70d6e = (userAction)=>({
        type: 'LOGIN_REQUEST_CHECK_USERNAME_SOCIAL_LOGIN',
        passwordless: userAction.passwordless || (0, $gtKO2.CheckUserNamePasswordlessType).Disallowed,
        identities: userAction.identities
    });
const $1f9969ad83fb8729$var$requestCheckUsernameSucceeded = (userAction, analyticsClient)=>(dispatch)=>{
        switch(userAction.action){
            case 'redirect':
                dispatch($1f9969ad83fb8729$export$2edff4284d04f803(userAction));
                break;
            case 'signup':
                dispatch($1f9969ad83fb8729$export$5cc9c4683c14face());
                break;
            case 'no_action':
                dispatch($1f9969ad83fb8729$export$c7d021a470828fad(userAction));
                break;
            case 'social_login':
                if (!userAction.identities || userAction.identities.password === undefined) // this event is needed for growth team's experiment slo
                // we want to silently fire this event and not show any error
                // this will just not enrol user in the experiment
                analyticsClient.operationalEvent({
                    page: (0, $1UkGo.loginPageId),
                    action: 'loadSocialLoginPage',
                    subject: 'sli',
                    attributes: {
                        hasError: true,
                        errorName: 'identities not as expected'
                    }
                });
                dispatch($1f9969ad83fb8729$export$a7eb3c2b6fb70d6e(userAction));
                break;
        }
        return Promise.resolve();
    };
const $1f9969ad83fb8729$export$c48d28459d63299c = (isOnline)=>$1f9969ad83fb8729$export$c445752097d9b598({
        code: isOnline ? 'captcha' : 'request_error'
    });
const $1f9969ad83fb8729$export$9cd96a2b004cc2f1 = (error)=>({
        type: 'LOGIN_REQUEST_CHECK_USERNAME_FAILED',
        error: error
    });
const $1f9969ad83fb8729$export$c445752097d9b598 = (error)=>({
        type: 'LOGIN_REQUEST_CHECK_USERNAME_ERROR',
        error: error
    });
const $1f9969ad83fb8729$export$6a45e1ba06bcfd40 = ()=>({
        type: 'LOGIN_RESET'
    });
const $1f9969ad83fb8729$export$f89c906644f34324 = ()=>({
        type: 'RESET_REMEMBER_ME_STATE'
    });
const $1f9969ad83fb8729$export$8a7c7d5c19ae03dc = ()=>({
        type: 'LOGIN_REQUEST_USERNAME_PASSWORD_LOGIN'
    });
const $1f9969ad83fb8729$export$e35197b32bd33011 = ()=>({
        type: 'LOGIN_REQUEST_PASSWORDLESS_LOGIN'
    });
const $1f9969ad83fb8729$export$2195b30ff9688f1f = ()=>({
        type: 'LOGIN_REQUEST_PASSWORDLESS_LOGIN_SUCCESS'
    });
const $1f9969ad83fb8729$export$9fbe8d742e3cfe1f = (error)=>({
        type: 'LOGIN_REQUEST_PASSWORDLESS_LOGIN_FAILED',
        error: error
    });
const $1f9969ad83fb8729$export$8d0d1628cde4bf96 = (redirectUrl = '')=>({
        type: 'LOGIN_REQUEST_USERNAME_PASSWORD_LOGIN_SUCCESS',
        redirectUrl: redirectUrl
    });
const $1f9969ad83fb8729$export$72f5cc903fa26407 = (error)=>({
        type: 'LOGIN_REQUEST_USERNAME_PASSWORD_LOGIN_FAILED',
        error: error
    });
const $1f9969ad83fb8729$export$7598c3f25ced4803 = (redirectUrl)=>({
        type: 'LOGIN_REDIRECT_USER',
        redirectUrl: redirectUrl
    });
const $1f9969ad83fb8729$export$84085369fb3df1bc = (nextAttempt)=>({
        type: 'UPDATE_LOGIN_ATTEMPT_DETAILS',
        nextAttempt: nextAttempt
    });
const $1f9969ad83fb8729$export$3e87c66a234f33b9 = (isCaptchaRequired)=>({
        type: 'LOGIN_UPDATE_CAPTCHA_REQUIREMENT',
        isCaptchaRequired: isCaptchaRequired
    });
const $1f9969ad83fb8729$export$f89084e6f067bb43 = (errors)=>({
        type: 'LOGIN_SHOW_LOGIN_FORM_ERRORS',
        errors: errors
    });
const $1f9969ad83fb8729$export$8eb90c84b47e7339 = (checked)=>({
        type: 'REMEMBER_ME_CHECKBOX_UPDATE',
        payload: {
            enabled: checked
        }
    });
const $1f9969ad83fb8729$export$64749aae889ad7b0 = ()=>({
        type: 'REMEMBER_ME_CHECKBOX_TOGGLE'
    });
const $1f9969ad83fb8729$export$10cc404412d31053 = (state)=>({
        type: 'LOGIN_SET_STATE',
        state: state
    });
const $1f9969ad83fb8729$var$usernameCheck = ({ username: username, csrfToken: csrfToken, params: params, analyticsClient: analyticsClient, recoveryToken: recoveryToken, challengeResponse: challengeResponse })=>async (dispatch)=>{
        dispatch($1f9969ad83fb8729$export$46a04796807ec7cb());
        let response;
        try {
            response = await fetch(`/rest/check-username${params}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrfToken
                },
                body: JSON.stringify({
                    username: username,
                    recoveryToken: recoveryToken,
                    'challenge-response': (0, $4JAG5.toChallengeRequest)(challengeResponse)
                })
            });
        } catch (networkError) {
            analyticsClient.operationalEvent({
                page: (0, $1UkGo.loginPageId),
                action: 'checkUsernameFailure',
                subject: 'sli'
            });
            dispatch($1f9969ad83fb8729$export$c445752097d9b598({
                code: 'request_error'
            }));
            return;
        }
        let analyticsAction;
        if (response.ok) try {
            dispatch($1f9969ad83fb8729$var$requestCheckUsernameSucceeded(await response.json(), analyticsClient));
            analyticsAction = 'checkUsernameSuccessful';
        } catch (parseError) {
            dispatch($1f9969ad83fb8729$export$c445752097d9b598({
                code: 'unknown'
            }));
            analyticsAction = 'checkUsernameFailure';
            (0, $49Pnv.captureTaggedException)(parseError, {
                capabilities: [
                    'capability-group--login',
                    'capability-subgroup--username-password-login',
                    'capability-name--login-with-username-password'
                ],
                extraProperties: {
                    description: 'Check-username response OK but failed to parse it'
                }
            });
        }
        else {
            analyticsAction = 'checkUsernameFailure';
            let responseErrorText = null;
            try {
                if (response.status === 429) dispatch($1f9969ad83fb8729$export$c445752097d9b598({
                    code: 'too_many_username_requests'
                }));
                else if (response.status === 400) {
                    const { uiErrors: uiErrors } = await response.json();
                    if (uiErrors && uiErrors.length) dispatch($1f9969ad83fb8729$export$c445752097d9b598({
                        code: uiErrors[0].key || 'unknown'
                    }));
                } else {
                    responseErrorText = await response.text() || response.statusText;
                    const extractedError = JSON.parse(responseErrorText).formErrors[0];
                    dispatch($1f9969ad83fb8729$export$9cd96a2b004cc2f1(extractedError));
                }
            } catch (parseError) {
                (0, $49Pnv.captureTaggedException)(parseError, {
                    capabilities: [
                        'capability-group--login',
                        'capability-subgroup--username-password-login',
                        'capability-name--login-with-username-password'
                    ],
                    extraProperties: {
                        description: 'Failed to handle non-OK response from check-username',
                        responseStatus: response.status,
                        responseErrorText: responseErrorText
                    }
                });
                dispatch($1f9969ad83fb8729$export$c445752097d9b598({
                    code: 'unknown'
                }));
            }
        }
        analyticsClient.operationalEvent({
            page: (0, $1UkGo.loginPageId),
            action: analyticsAction,
            subject: 'sli'
        });
    };
const $1f9969ad83fb8729$var$v2UsernameCheck = ({ username: username, csrfToken: csrfToken, params: params, analyticsClient: analyticsClient, recoveryToken: recoveryToken, challengeResponse: challengeResponse })=>async (dispatch)=>{
        dispatch($1f9969ad83fb8729$export$100ac3ffc8db9b3e());
        let response;
        try {
            response = await fetch(`/rest/v2/check-username${params}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrfToken
                },
                body: JSON.stringify({
                    username: username,
                    recoveryToken: recoveryToken,
                    'challenge-response': (0, $4JAG5.toChallengeRequest)(challengeResponse)
                })
            });
        } catch (networkError) {
            analyticsClient.operationalEvent({
                page: (0, $1UkGo.loginPageId),
                action: 'checkUsernameV2Failure',
                subject: 'sli'
            });
            dispatch($1f9969ad83fb8729$export$c445752097d9b598({
                code: 'request_error'
            }));
            return;
        }
        // TODO: add analytics https://hello.jira.atlassian.cloud/browse/IDOASIS-131
        // let analyticsAction: 'checkV2UsernameSuccessful' | 'checkV2UsernameFailure';
        if (response.ok) try {
            const accounts = await response.json();
            dispatch($1f9969ad83fb8729$export$34d1ed284038d066(accounts));
        // analyticsAction = 'checkV2UsernameSuccessful';
        } catch (parseError) {
            // TODO: add error handling https://hello.jira.atlassian.cloud/browse/IDOASIS-289
            // dispatch(requestCheckUsernameV2Error({ code: 'unknown' }));
            // analyticsAction = 'checkV2UsernameFailure';
            (0, $49Pnv.captureTaggedException)(parseError, {
                capabilities: [
                    'capability-group--login',
                    'capability-subgroup--username-password-login',
                    'capability-name--login-with-username-password'
                ],
                extraProperties: {
                    description: 'Check-username V2 response OK but failed to parse it'
                }
            });
        }
        else {
            // analyticsAction = 'checkUsernameV2Failure';
            let responseErrorText = null;
            try {
                if (response.status === 429) ;
                else if (response.status === 400) {
                    const { uiErrors: uiErrors } = await response.json();
                    uiErrors && uiErrors.length;
                } else responseErrorText = await response.text() || response.statusText;
            } catch (parseError) {
                (0, $49Pnv.captureTaggedException)(parseError, {
                    capabilities: [
                        'capability-group--login',
                        'capability-subgroup--username-password-login',
                        'capability-name--login-with-username-password'
                    ],
                    extraProperties: {
                        description: 'Failed to handle non-OK response from check-username V2',
                        responseStatus: response.status,
                        responseErrorText: responseErrorText
                    }
                });
            }
        }
    // analyticsClient.operationalEvent({
    //   page: loginPageId,
    //   action: analyticsAction,
    //   subject: 'sli',
    // });
    };
const $1f9969ad83fb8729$export$4929d86c6e4e281e = ({ username: username, params: params, analyticsClient: analyticsClient, recoveryToken: recoveryToken, challengeResponse: challengeResponse })=>(dispatch, getState)=>{
        analyticsClient.operationalEvent({
            page: (0, $1UkGo.loginPageId),
            action: 'checkUsernameStart',
            subject: 'sli'
        });
        return dispatch($1f9969ad83fb8729$var$usernameCheck({
            username: username,
            csrfToken: getState().csrfToken,
            params: params,
            analyticsClient: analyticsClient,
            recoveryToken: recoveryToken,
            challengeResponse: challengeResponse
        }));
    };
const $1f9969ad83fb8729$export$67b7193bb8e24ea6 = ({ username: username, params: params, analyticsClient: analyticsClient, recoveryToken: recoveryToken, challengeResponse: challengeResponse })=>(dispatch, getState)=>{
        analyticsClient.operationalEvent({
            page: (0, $a1suH.StatelessLoginPageId),
            action: 'checkUsernameV2Start',
            subject: 'sli'
        });
        return dispatch($1f9969ad83fb8729$var$v2UsernameCheck({
            username: username,
            csrfToken: getState().csrfToken,
            params: params,
            analyticsClient: analyticsClient,
            recoveryToken: recoveryToken,
            challengeResponse: challengeResponse
        }));
    };
function $1f9969ad83fb8729$var$reportFrontendError(error) {
    function removeField(obj, fieldName) {
        for(const prop in obj){
            if (prop === fieldName) delete obj[prop];
            else if (typeof obj[prop] === 'object') removeField(obj[prop], fieldName);
        }
    }
    function decodeJsonField(obj, path) {
        const val = (0, (/*@__PURE__*/$parcel$interopDefault($90yWB)))(obj, path);
        if (val !== 'undefined') try {
            (0, (/*@__PURE__*/$parcel$interopDefault($kU6Wu)))(obj, path, JSON.parse(val));
        } catch (_) {}
    }
    removeField(error, 'password');
    decodeJsonField(error, 'original.response.text');
    const errorCode = error['error'];
    (0, $49Pnv.captureTaggedException)(error, {
        capabilities: [
            'capability-group--login',
            'capability-subgroup--username-password-login',
            'capability-name--login-with-username-password'
        ],
        extraProperties: {
            description: (error === null || error === void 0 ? void 0 : error.error_description) || 'Failed to login for an unexpected reason',
            code: errorCode
        }
    });
}
function $1f9969ad83fb8729$var$parseAdditionalData(err) {
    try {
        return JSON.parse(atob(err.error_description));
    } catch (e) {
        return {};
    }
}
function $1f9969ad83fb8729$var$handleLoginError(err, username, application, dispatch, getState, onLoginError) {
    const additionalData = $1f9969ad83fb8729$var$parseAdditionalData(err);
    const code = (additionalData['custom_error'] || err['error'] || '').toLowerCase();
    const isBitbucket = application && application.toLowerCase() === 'bitbucket';
    if (code === 'too_many_attempts' || code === 'invalid_captcha') {
        dispatch($1f9969ad83fb8729$export$3e87c66a234f33b9(true));
        dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
            code: 'captcha'
        }));
    } else if (code === 'access_denied') {
        dispatch($1f9969ad83fb8729$export$84085369fb3df1bc(getState().login.nextAttempt + 1));
        dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
            code: 'invalid_user_password'
        }));
    } else if (code === 'ambiguous_user') dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
        code: 'ambiguous_user'
    }));
    else if (code === 'no_email_on_remote_user') dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
        code: 'no_email_on_remote_user',
        args: {
            username: username
        }
    }));
    else if (code === 'username_is_not_email') {
        const errorCode = isBitbucket ? 'bitbucket_username_is_not_email' : 'username_is_not_email';
        dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
            code: errorCode,
            args: {
                username: additionalData['email']
            }
        }));
    } else if (code === 'email_is_not_primary') {
        const errorCode = isBitbucket ? 'bitbucket_email_is_not_primary' : 'email_is_not_primary';
        dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
            code: errorCode,
            args: {
                username: additionalData['email']
            }
        }));
    } else if (code === 'too_many_logins') dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
        code: 'too_many_logins'
    }));
    else if (code === 'password_leaked') dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
        code: 'password_leaked'
    }));
    else if (code === 'blocked_user') {
        const redirectURL = application ? `/login/inactive?application=${application}` : '/login/inactive';
        dispatch($1f9969ad83fb8729$export$7598c3f25ced4803(redirectURL));
    } else if (code === 'request_error') // 'request_error' auth0-js: connection fails due to offline or cross domain issue
    dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
        code: 'request_error'
    }));
    else if (code === 'invalid.session.token') dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
        code: 'invalid.session.token'
    }));
    else {
        $1f9969ad83fb8729$var$reportFrontendError(err);
        dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
            code: 'unknown'
        }));
    }
    if (code !== 'too_many_attempts' && code !== 'invalid_captcha') dispatch($1f9969ad83fb8729$export$3e87c66a234f33b9(false));
    onLoginError(code);
}
function $1f9969ad83fb8729$var$verifyCaptchaIfRequired(captchaValue, username) {
    if (!captchaValue) return Promise.resolve();
    return fetch('/rest/captcha/verify', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            'g-recaptcha-response': captchaValue,
            email: username
        })
    }).then($1f9969ad83fb8729$export$9cdc46fdb2ee9975).catch(()=>{
        const error = new Error('invalid_captcha');
        return Promise.reject(error);
    });
}
const $1f9969ad83fb8729$export$beb986ec1c64324 = (csrfToken, config, marketingConsentState, anonymousId, userFlow)=>{
    let state = {
        csrfToken: csrfToken,
        anonymousId: anonymousId,
        userFlow: userFlow
    };
    const marketingConsent = (0, $fqbXQ.buildMarketingConsent)(config, marketingConsentState);
    if (marketingConsent) state = (0, $b2I6k._)((0, $1Fos3._)({}, state), {
        marketingConsent: marketingConsent
    });
    return state;
};
const $1f9969ad83fb8729$export$5391cc01902916c6 = (loginParams, navigate)=>(dispatch, getState)=>{
        const { location: location, username: username, password: password, captchaValue: captchaValue, onLoginError: onLoginError, anonymousId: anonymousId } = loginParams;
        const params = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(location.search);
        const { application: application, userFlow: userFlow } = params;
        const state = getState();
        const { isRememberMeChecked: isRememberMeChecked } = state.login;
        const { csrfToken: csrfToken, marketingConsent: marketingConsent } = state;
        dispatch($1f9969ad83fb8729$export$8a7c7d5c19ae03dc());
        const loginState = $1f9969ad83fb8729$export$beb986ec1c64324(csrfToken, marketingConsent.config, loginParams.marketingConsent, anonymousId, userFlow);
        // This passes the `remember` flag to the backend, "remembering" the account that we're logging into.
        if (isRememberMeChecked) params.remember = 'true';
        const query = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).stringify(params);
        const loginWithAtlassianAuth = (navigate)=>(0, $kfTGh.login)({
                username: username,
                password: password,
                state: loginState,
                query: `?${query}${location.hash}`
            }).then((result)=>{
                switch(result.kind){
                    case 'failure':
                        {
                            const err = {
                                error: result.reason
                            };
                            return $1f9969ad83fb8729$var$handleLoginError(err, username, application, dispatch, getState, onLoginError);
                        }
                    case 'success':
                        return navigate(result.redirectUri);
                }
            });
        return $1f9969ad83fb8729$var$verifyCaptchaIfRequired(captchaValue, username).then(()=>loginWithAtlassianAuth(navigate)).catch((err)=>{
            (0, $49Pnv.captureTaggedException)(err, {
                capabilities: [
                    'capability-group--login',
                    'capability-subgroup--username-password-login',
                    'capability-name--login-with-username-password'
                ],
                extraProperties: {
                    description: 'Failed to login'
                }
            });
            $1f9969ad83fb8729$var$handleLoginError(err, username, application, dispatch, getState, onLoginError);
        });
    };
const $1f9969ad83fb8729$export$a6eaf375001ea98a = ({ email: email, captchaValue: captchaValue, location: location })=>async (dispatch, getState)=>{
        const { csrfToken: csrfToken, login: { isRememberMeChecked: isRememberMeChecked } } = getState();
        dispatch($1f9969ad83fb8729$export$e35197b32bd33011());
        const urlParams = new URLSearchParams(location.search);
        if (isRememberMeChecked) urlParams.set('remember', 'true');
        const apiParams = urlParams.toString();
        try {
            const response = await fetch(`/rest/login/passwordless?${apiParams}`, {
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': csrfToken,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: email,
                    captchaValue: captchaValue
                })
            });
            const { csrfToken: newCsrfToken } = await response.json();
            if (newCsrfToken) dispatch((0, $hB2TQ.updateCsrfToken)(newCsrfToken));
            if (response.ok) {
                dispatch($1f9969ad83fb8729$export$2195b30ff9688f1f());
                return {
                    success: true
                };
            } else {
                dispatch($1f9969ad83fb8729$export$9fbe8d742e3cfe1f({
                    code: 'unknown'
                }));
                return {
                    success: false
                };
            }
        } catch (error) {
            (0, $49Pnv.captureTaggedException)(error, {
                capabilities: [
                    'capability-group--login',
                    'capability-subgroup--passwordless-login',
                    'capability-name--passwordless-login'
                ],
                extraProperties: {
                    description: 'Failed passwordless login'
                }
            });
            dispatch($1f9969ad83fb8729$export$9fbe8d742e3cfe1f({
                code: 'request_error'
            }));
            return {
                success: false
            };
        }
    };

});
parcelRegister("90yWB", function(module, exports) {

var $i8cFE = parcelRequire("i8cFE");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $68ef3859172d2fc0$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $i8cFE(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $68ef3859172d2fc0$var$get;

});
parcelRegister("i8cFE", function(module, exports) {

var $f1LNj = parcelRequire("f1LNj");

var $lky4s = parcelRequire("lky4s");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $d332cd8476f88dbf$var$baseGet(object, path) {
    path = $f1LNj(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$lky4s(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $d332cd8476f88dbf$var$baseGet;

});


parcelRegister("fqbXQ", function(module, exports) {

$parcel$export(module.exports, "IMPLICIT_CONSENT_TEXT", function () { return $51ec039540c8cce7$export$a18e359a3f598d3b; });
$parcel$export(module.exports, "buildMarketingConsent", function () { return $51ec039540c8cce7$export$689cf67bd4c05bd3; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $dBq8m = parcelRequire("dBq8m");
const $51ec039540c8cce7$export$a18e359a3f598d3b = 'general consent captured';
const $51ec039540c8cce7$export$689cf67bd4c05bd3 = (config, checkboxState, privacyPolicyText)=>{
    let marketingConsent = null;
    if (config && config.locale) {
        const hasConsent = checkboxState.state !== 'not_shown' || config.implicitConsent;
        if (hasConsent) {
            const consent = checkboxState.state === 'checked' || config.implicitConsent;
            // @ts-ignore
            const marketingConsentText = checkboxState.consentText || $51ec039540c8cce7$export$a18e359a3f598d3b;
            marketingConsent = {
                consent: consent,
                locale: config.locale,
                marketingConsentText: marketingConsentText
            };
            if (privacyPolicyText) marketingConsent = (0, $b2I6k._)((0, $1Fos3._)({}, marketingConsent), {
                privacyPolicyText: privacyPolicyText
            });
        }
    }
    return marketingConsent;
};
const $51ec039540c8cce7$var$FORCE_SHOW_MARKETING_CONSENT_PARAM = 'showMarketingConsent';
const $51ec039540c8cce7$export$44896947615de4a4 = (location)=>{
    const params = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(location.search);
    return $51ec039540c8cce7$var$FORCE_SHOW_MARKETING_CONSENT_PARAM in params;
};

});

parcelRegister("1UkGo", function(module, exports) {

$parcel$export(module.exports, "loginPageId", function () { return $6b438f71b5f4e8ce$export$bb0bd0af2c24d0c1; });
const $6b438f71b5f4e8ce$export$bb0bd0af2c24d0c1 = 'loginScreen';

});

parcelRegister("kfTGh", function(module, exports) {

$parcel$export(module.exports, "login", function () { return $8630aadc7660b7c8$export$596d806903d1f59e; });

var $dBq8m = parcelRequire("dBq8m");

var $bqdjD = parcelRequire("bqdjD");
var $8630aadc7660b7c8$export$db7ad81c1149bb91 = /*#__PURE__*/ function(LoginFailureReason) {
    LoginFailureReason["AccessDenied"] = "access_denied";
    LoginFailureReason["PasswordLeaked"] = "password_leaked";
    LoginFailureReason["BlockedUser"] = "blocked_user";
    LoginFailureReason["TooManyAttempts"] = "too_many_attempts";
    LoginFailureReason["TooManyLogins"] = "too_many_logins";
    return LoginFailureReason;
}({});
var $8630aadc7660b7c8$export$5e64a9683d127ef6 = /*#__PURE__*/ function(LoginError) {
    LoginError["PreconditionFailed"] = "precondition_failed";
    LoginError["UnexpectedError"] = "unexpected_error";
    return LoginError;
}({});
function $8630aadc7660b7c8$var$failure(reason) {
    return {
        kind: 'failure',
        reason: reason
    };
}
function $8630aadc7660b7c8$var$success(redirectUri) {
    return {
        kind: 'success',
        redirectUri: redirectUri
    };
}

async function $8630aadc7660b7c8$export$596d806903d1f59e({ state: state, username: username, password: password, query: query }) {
    const isCommercial = (0, $bqdjD.getCurrentCloudType)() === 'commercial';
    const token = isCommercial ? await (parcelRequire("jEJQB")).then(async ({ createRequestToken: createRequestToken })=>await createRequestToken()).catch(()=>'') : 'dummy-token'; // a token is expected by id-auth in IC and disabled entirely within FedRAMP
    return fetch(`/rest/authenticate${query}`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            username: username,
            password: password,
            state: state,
            token: token
        })
    }).then((response)=>{
        switch(response.status){
            case 200:
                return response.json().then((r)=>$8630aadc7660b7c8$var$success(r.redirectUri));
            case 403:
                return response.json().then((r)=>{
                    switch(r.error){
                        case 'access_denied':
                            return $8630aadc7660b7c8$var$failure("access_denied");
                        case 'blocked_user':
                            return $8630aadc7660b7c8$var$failure("blocked_user");
                        case 'password_leaked':
                            return $8630aadc7660b7c8$var$failure("password_leaked");
                        case 'too_many_attempts':
                            return $8630aadc7660b7c8$var$failure("too_many_attempts");
                        default:
                            return Promise.reject(new Error("unexpected_error"));
                    }
                });
            case 429:
                return response.json().then((r)=>r.error === 'too_many_logins' ? $8630aadc7660b7c8$var$failure("too_many_logins") : Promise.reject(new Error("unexpected_error")));
            case 412:
                return response.json().then((r)=>{
                    switch(r.error){
                        case 'mfa_required':
                            {
                                const currentQueryParams = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(window.location.search);
                                currentQueryParams.transactionToken = r.token;
                                const currentQueryString = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).stringify(currentQueryParams);
                                return $8630aadc7660b7c8$var$success(`/login/mfa?${currentQueryString}`);
                            }
                        default:
                            return Promise.reject(new Error("precondition_failed"));
                    }
                });
            default:
                return Promise.reject(new Error("unexpected_error", {
                    cause: {
                        description: 'Unexpected response status',
                        response: response
                    }
                }));
        }
    });
}

});

parcelRegister("4JAG5", function(module, exports) {

$parcel$export(module.exports, "toChallengeRequest", function () { return $72117541598b8245$export$79b8871c3ed7cc2a; });
function $72117541598b8245$export$79b8871c3ed7cc2a(response) {
    if (!response) return null;
    return {
        'challenge-kind': response.challengeKind,
        token: {
            value: response.token
        },
        type: response.type
    };
}

});

parcelRegister("a1suH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "StatelessLoginPageId", function () { return $2985d5ef60c59ef6$export$3238684376aef113; });
$parcel$export(module.exports, "default", function () { return $2985d5ef60c59ef6$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $8KhCJ = parcelRequire("8KhCJ");

var $leG06 = parcelRequire("leG06");

var $k8MAo = parcelRequire("k8MAo");

var $2aGBJ = parcelRequire("2aGBJ");

var $gwpVM = parcelRequire("gwpVM");

var $gKURT = parcelRequire("gKURT");

var $gs2u7 = parcelRequire("gs2u7");

var $9b70D = parcelRequire("9b70D");

var $4rBM8 = parcelRequire("4rBM8");

var $gx7I6 = parcelRequire("gx7I6");

var $4tmE5 = parcelRequire("4tmE5");

var $k3QGO = parcelRequire("k3QGO");

var $68WXR = parcelRequire("68WXR");

var $1UkGo = parcelRequire("1UkGo");

var $NAfW5 = parcelRequire("NAfW5");

var $4Nxm2 = parcelRequire("4Nxm2");

var $6xwQE = parcelRequire("6xwQE");

var $h6Rwg = parcelRequire("h6Rwg");

var $6KORI = parcelRequire("6KORI");

var $3f4xr = parcelRequire("3f4xr");

var $kpg9c = parcelRequire("kpg9c");
const $2985d5ef60c59ef6$export$3238684376aef113 = (0, $1UkGo.loginPageId) + '_isolated_cloud';
const $2985d5ef60c59ef6$var$LoginPage = ()=>{
    const { state: state } = (0, $4rBM8.useLoginState)();
    const { oidcContext: oidcContext } = state || {};
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const isNewV2CheckUsernameFlowEnabled = (0, $3f4xr.checkFeatureGate)((0, $kpg9c.AidFrontendFeatureGate).ENABLE_NEW_V2_CHECK_USERNAME_IC_FLOW);
    const { isPasswordlessAllowed: isPasswordlessAllowed, checkUsernameError: checkUsernameError, error: loginError, redirectType: redirectType, isRestrictedEmail: isRestrictedEmail, resetLogin: resetLogin, infoCode: infoCode, rememberMeEnabled: rememberMeEnabled, isRememberMeChecked: isRememberMeChecked, onToggleRememberMeCheckbox: onToggleRememberMeCheckbox, isUsernameChecked: isUsernameChecked, isCheckUsernameLoading: isCheckUsernameLoading, checkUsername: checkUsername, v2Accounts: v2Accounts } = (0, $4Nxm2.useLogin)({
        useV2CheckUsernameFlow: isNewV2CheckUsernameFlowEnabled
    });
    const { isLoading: isLoading, onLogin: handleLogIn, onPasswordlessLogin: handlePasswordlessLogIn } = (0, $6xwQE.useLoginSubmission)();
    const { onAppleLogin: onAppleLogin, onSlackLogin: onSlackLogin, onMicrosoftLogin: onMicrosoftLogin, onGoogleSocialLogin: onGoogleSocialLogin, onDismissGoogleOneTap: onDismissGoogleOneTap, socialLoginEligibility: socialLoginEligibility, envSupportsSocialLogin: envSupportsSocialLogin, isSocialBlocked: isSocialBlocked } = (0, $h6Rwg.useSocialLogin)();
    const { isMobileApp: isMobileApp, isEmbedded: isEmbedded, screenSize: screenSize } = (0, $2aGBJ.useAppSelector)((state)=>state.microbranding);
    const isLoginSecondStep = isUsernameChecked;
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const emailFromSearchParams = (0, $NAfW5.useEmailFromSearchParams)();
    const [email, setEmail] = (0, $91i6m.useState)(()=>emailFromSearchParams || '');
    // Sync state with query params
    // In the case when the query params change after the component is first rendered
    (0, $91i6m.useEffect)(()=>{
        if (emailFromSearchParams) setEmail(emailFromSearchParams);
    }, [
        emailFromSearchParams
    ]);
    (0, $6KORI.useGoogleOneTap)({
        email: email
    });
    const { highlightedSocialProvider: highlightedSocialProvider = null, isEligibleForSocialLoginOnly: isEligibleForSocialLoginOnly = null } = socialLoginEligibility || {};
    const showSocialLoginOnly = isLoginSecondStep && isEligibleForSocialLoginOnly && highlightedSocialProvider && envSupportsSocialLogin;
    const handleGoogleSocialLogin = (0, $91i6m.useCallback)(()=>{
        if (envSupportsSocialLogin) onGoogleSocialLogin(email);
    }, [
        email,
        onGoogleSocialLogin,
        envSupportsSocialLogin
    ]);
    const handleMicrosoftLogin = (0, $91i6m.useCallback)(()=>{
        if (envSupportsSocialLogin) onMicrosoftLogin(email);
    }, [
        email,
        onMicrosoftLogin,
        envSupportsSocialLogin
    ]);
    const handleAppleLogin = (0, $91i6m.useCallback)(()=>{
        if (envSupportsSocialLogin) onAppleLogin(email);
    }, [
        email,
        onAppleLogin,
        envSupportsSocialLogin
    ]);
    const handleSlackLogin = (0, $91i6m.useCallback)(()=>{
        if (envSupportsSocialLogin) onSlackLogin(email);
    }, [
        email,
        onSlackLogin,
        envSupportsSocialLogin
    ]);
    const handleValidationError = (0, $91i6m.useCallback)((errors)=>dispatch((0, $k8MAo.showFormErrors)(errors)), [
        dispatch
    ]);
    const handleContinue = (email)=>{
        checkUsername(email);
    };
    const handleFormClick = (0, $91i6m.useCallback)(()=>{
        if (envSupportsSocialLogin && screenSize === 'mobile') onDismissGoogleOneTap();
    }, [
        onDismissGoogleOneTap,
        screenSize,
        envSupportsSocialLogin
    ]);
    const handleEmailChange = (0, $91i6m.useCallback)((email)=>{
        setEmail(email);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $8KhCJ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("title", null, formatMessage((0, $9b70D.LoginPageMessages).headTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $gs2u7.default), {
        pageId: $2985d5ef60c59ef6$export$3238684376aef113,
        header: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $4tmE5.default), {
            highlightedSocialProvider: highlightedSocialProvider,
            showSocialLoginOnly: showSocialLoginOnly
        }),
        footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $gx7I6.default), {
            oidcContext: oidcContext,
            isEmbedded: isEmbedded
        }),
        whiteboxFooter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $68WXR.default), {
            showSocialLoginOnly: showSocialLoginOnly,
            isMobileApp: isMobileApp,
            oidcContext: oidcContext
        })
    }, showSocialLoginOnly ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $gKURT.default), {
        email: email,
        highlightedSocialProvider: highlightedSocialProvider,
        handleGoogleLogin: handleGoogleSocialLogin,
        handleMicrosoftLogin: handleMicrosoftLogin,
        handleAppleLogin: handleAppleLogin,
        handleSlackLogin: handleSlackLogin
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $gwpVM.default), {
        application: 'support',
        redirectType: !isLoginSecondStep ? redirectType : null,
        isRedirecting: redirectType !== null,
        isSecondStep: isLoginSecondStep,
        isPasswordlessAllowed: isPasswordlessAllowed,
        isLoading: isLoading,
        isCheckUsernameLoading: isCheckUsernameLoading,
        onContinue: handleContinue,
        onLogIn: handleLogIn,
        onPasswordlessLogIn: handlePasswordlessLogIn,
        error: loginError,
        info: infoCode,
        fieldErrors: {
            email: checkUsernameError
        },
        email: email,
        onValidationError: handleValidationError,
        onEditEmail: resetLogin,
        onFormClick: handleFormClick,
        restrictedEmail: isRestrictedEmail,
        pageId: $2985d5ef60c59ef6$export$3238684376aef113,
        onEmailChange: handleEmailChange,
        showRememberMeCheckbox: rememberMeEnabled,
        rememberMeChecked: isRememberMeChecked,
        onToggleRememberMeCheckbox: onToggleRememberMeCheckbox,
        v2Accounts: v2Accounts || [],
        isNewV2CheckUsernameFlow: isNewV2CheckUsernameFlowEnabled
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $k3QGO.default), {
        isEmbedded: isEmbedded,
        envSupportsSocialLogin: envSupportsSocialLogin,
        isSocialBlocked: isSocialBlocked,
        onSlackLogin: handleSlackLogin,
        onAppleLogin: handleAppleLogin,
        onMicrosoftLogin: handleMicrosoftLogin,
        onGoogleLogin: handleGoogleSocialLogin
    }))));
};
var $2985d5ef60c59ef6$export$2e2bcd8739ae039 = $2985d5ef60c59ef6$var$LoginPage;

});
parcelRegister("gwpVM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c14bebab4e90fd48$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $9OWP7 = parcelRequire("9OWP7");

var $9jjaN = parcelRequire("9jjaN");

var $bt1Sd = parcelRequire("bt1Sd");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");

var $gFwNN = parcelRequire("gFwNN");

var $dmC2D = parcelRequire("dmC2D");

var $9w0eB = parcelRequire("9w0eB");

var $cLysE = parcelRequire("cLysE");

var $31nHY = parcelRequire("31nHY");

var $lnbpL = parcelRequire("lnbpL");

var $j7UeI = parcelRequire("j7UeI");

var $jthWj = parcelRequire("jthWj");

var $gtKO2 = parcelRequire("gtKO2");

var $fYxRW = parcelRequire("fYxRW");

var $1V2cH = parcelRequire("1V2cH");

var $1UkGo = parcelRequire("1UkGo");

var $cZAbO = parcelRequire("cZAbO");

var $6eNI5 = parcelRequire("6eNI5");

var $cs6gC = parcelRequire("cs6gC");

var $brCu8 = parcelRequire("brCu8");

var $83IjZ = parcelRequire("83IjZ");

var $9X0U9 = parcelRequire("9X0U9");
var $c32T7 = parcelRequire("c32T7");

var $5v178 = parcelRequire("5v178");

var $jL47V = parcelRequire("jL47V");

var $9uXJ3 = parcelRequire("9uXJ3");
let $c14bebab4e90fd48$var$_ = (t)=>t, $c14bebab4e90fd48$var$t, $c14bebab4e90fd48$var$t1, $c14bebab4e90fd48$var$t2;
const $c14bebab4e90fd48$export$d55ce944e082b58f = (0, $9jjaN.default).div($c14bebab4e90fd48$var$t || ($c14bebab4e90fd48$var$t = $c14bebab4e90fd48$var$_`
  align-items: center;
  color: ${0};
  display: flex;
  height: 40px;
  justify-content: space-between;
  padding: 0 8px;
`), (0, $kLNLK).N90);
const $c14bebab4e90fd48$export$a7fed597f4b8afd8 = (0, $9jjaN.default).form($c14bebab4e90fd48$var$t1 || ($c14bebab4e90fd48$var$t1 = $c14bebab4e90fd48$var$_`
  margin: 0;
`));
const $c14bebab4e90fd48$var$InputsWrapper = (0, $9jjaN.default).div($c14bebab4e90fd48$var$t2 || ($c14bebab4e90fd48$var$t2 = $c14bebab4e90fd48$var$_`
  margin-bottom: ${0}px;
`), (0, $6e88g.gridSize)());
const $c14bebab4e90fd48$var$getEmailFieldViewType = (restrictedEmail, redirectType, isSecondStep, isThirdStep, isLoading)=>{
    if (restrictedEmail || redirectType === (0, $gtKO2.CheckUserNameRedirectType).Sso) return (0, $dmC2D.FieldViewType).Restricted;
    else if (isThirdStep || isLoading || isSecondStep) return (0, $dmC2D.FieldViewType).ReadOnlyWithEditButton;
    return (0, $dmC2D.FieldViewType).Editable;
};
const $c14bebab4e90fd48$export$1f58f750f20f344b = ({ application: application, email: email, error: error, fieldErrors: fieldErrors, info: info, isLoading: isLoading, isPasswordlessAllowed: isPasswordlessAllowed, isRedirecting: isRedirecting, isSecondStep: isSecondStep, isCheckUsernameLoading: isCheckUsernameLoading, onContinue: onContinue, onEditEmail: onEditEmail, onEmailChange: onEmailChange, onFormClick: onFormClick, onLogIn: onLogIn, onPasswordlessLogIn: onPasswordlessLogIn, onValidationError: onValidationError, pageId: pageId, redirectType: redirectType, restrictedEmail: restrictedEmail, showRememberMeCheckbox: showRememberMeCheckbox, rememberMeChecked: rememberMeChecked, onToggleRememberMeCheckbox: onToggleRememberMeCheckbox, v2Accounts: v2Accounts, isNewV2CheckUsernameFlow: isNewV2CheckUsernameFlow })=>{
    const intl = (0, $leG06.default)();
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    const { formatMessage: formatMessage } = intl;
    const translatedEmailFieldError = (0, $brCu8.useTranslateFormErrorIfAvailable)(fieldErrors.email);
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const [password, setPassword] = (0, $91i6m.useState)('');
    const [accountEnv, setAccountEnv] = (0, $91i6m.useState)('');
    const [buttonClicked, setButtonClicked] = (0, $91i6m.useState)('submit');
    const inputRef = (0, $91i6m.useRef)(null);
    const [passwordFieldError, setPasswordFieldError] = (0, $91i6m.useState)(null);
    const [accountEnvFieldError, setAccountEnvFieldError] = (0, $91i6m.useState)(undefined);
    const [isThirdStep, setIsThirdStep] = (0, $91i6m.useState)(false);
    const onAccountEnvChange = (0, $91i6m.useCallback)((value)=>{
        setAccountEnv(value);
        setAccountEnvFieldError(undefined);
    }, []);
    const onEmailClick = (0, $91i6m.useCallback)(()=>{
        setPassword('');
        setPasswordFieldError(null);
        setAccountEnv('');
        setAccountEnvFieldError(undefined);
        setIsThirdStep(false);
        onEditEmail();
    }, [
        onEditEmail
    ]);
    const { captchaValue: captchaValue, isRequired: isTooManyAttemptsRecaptchaRequired } = (0, $6eNI5.useLoginTooManyAttemptsRecaptchaContext)();
    const handleSubmit = async (e)=>{
        e.preventDefault();
        const trimmedEmail = email.trim();
        const emailEmpty = trimmedEmail === '';
        const emailInvalid = !trimmedEmail.match(/.+@.+/);
        const passwordEmpty = password === '';
        const accountEnvEmpty = accountEnv === '';
        // Ignore submission of form while the app is loading.
        if (isLoading) return;
        setButtonClicked('submit');
        analyticsClient.buttonClickedEvent(pageId, isThirdStep ? 'login' : 'continueToLogin');
        if (emailEmpty) {
            var _inputRef_current;
            (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
            const emailValidationError = formatMessage((0, $jthWj.default).emailEmpty);
            analyticsClient.errorShownEvent((0, $1UkGo.loginPageId), 'validationError');
            onValidationError({
                email: emailValidationError
            });
            return;
        }
        if (emailInvalid) {
            var _inputRef_current1;
            (_inputRef_current1 = inputRef.current) === null || _inputRef_current1 === void 0 ? void 0 : _inputRef_current1.focus();
            const emailValidationError = formatMessage((0, $jthWj.default).emailInvalid);
            analyticsClient.errorShownEvent((0, $1UkGo.loginPageId), 'validationError');
            onValidationError({
                email: emailValidationError
            });
            return;
        }
        if (isThirdStep && passwordEmpty) {
            setPasswordFieldError(formatMessage((0, $jthWj.default).passwordEmpty));
            return;
        }
        if (isSecondStep && accountEnvEmpty) {
            setAccountEnvFieldError(formatMessage((0, $jthWj.default).unexpectedErrorHappened));
            return;
        }
        if (!isSecondStep && !isThirdStep) onContinue(trimmedEmail);
        else if (isSecondStep && !isThirdStep && accountEnv === 'atlassian-cloud') {
            setIsThirdStep(true);
            return;
        } else if (isSecondStep && !isThirdStep && !accountEnvEmpty && accountEnv !== 'atlassian-cloud') {
            // Redirect to the selected IC environment
            const selected = v2Accounts === null || v2Accounts === void 0 ? void 0 : v2Accounts.find((acc)=>acc.action === 'ic_redirect' && acc.ic_id === accountEnv);
            if (selected && selected.action === 'ic_redirect') navigate(selected.redirect_uri);
            return;
        } else if (isThirdStep && !accountEnvEmpty && accountEnv === 'atlassian-cloud') onLogIn(trimmedEmail, password);
    };
    const handlePasswordlessButtonClick = async ()=>{
        const trimmedEmail = email.trim();
        if (isLoading || !trimmedEmail) return;
        setButtonClicked('passwordless');
        onPasswordlessLogIn(trimmedEmail);
    };
    const handlePasswordChange = (0, $91i6m.useCallback)((e)=>{
        if (passwordFieldError) setPasswordFieldError(null);
        setPassword(e.currentTarget.value);
    }, [
        passwordFieldError,
        setPasswordFieldError,
        setPassword
    ]);
    const buttonContent = ()=>{
        if (!isThirdStep) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
            id: "login.form.continue",
            defaultMessage: "Continue"
        });
        if (isPasswordlessAllowed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
            id: "common.login.with.password",
            defaultMessage: "Log in with password"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
            id: "common.login",
            defaultMessage: "Log in"
        });
    };
    const infoContent = ()=>{
        const { formatMessage: formatMessage } = intl;
        const applicationName = application ? (0, $fYxRW.applications)[application].name : 'Product';
        const testId = 'login-info-test-id';
        if (info) switch(info.code){
            case 'migratingExistingUser':
                {
                    const summary = formatMessage((0, $jthWj.default).migrateAccountInfo, {
                        application: applicationName
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $lnbpL.default), {
                        id: "login-info",
                        "data-testid": testId
                    }, summary);
                }
            case 'existingUserSignupAttempt':
                {
                    const summary = formatMessage((0, $jthWj.default).existingUserSignupAttemptInfo);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $lnbpL.default), {
                        id: "login-info",
                        "data-testid": testId
                    }, summary);
                }
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $lnbpL.default), {
                    id: "login-info",
                    "data-testid": testId,
                    isHidden: true
                }, ' ');
        }
    };
    // if not using the new V2 check username flow, allow the user to bypass the environment selection step
    (0, $91i6m.useEffect)(()=>{
        if (!isNewV2CheckUsernameFlow && isSecondStep) {
            setAccountEnv('atlassian-cloud');
            setIsThirdStep(true);
        }
    }, [
        isNewV2CheckUsernameFlow,
        isSecondStep
    ]);
    (0, $91i6m.useEffect)(()=>{
        analyticsClient.stopInitialLoadApdexEvent('viewLoginPage');
    }, [
        analyticsClient
    ]);
    const emailError = ()=>{
        switch(fieldErrors.email){
            case 'unknown':
                return intl.formatMessage((0, $jthWj.default).unexpectedErrorHappened);
            case 'rate_limit_exceeded_message':
                return intl.formatMessage((0, $jthWj.default).rateLimitErrorMessage);
            default:
                return translatedEmailFieldError;
        }
    };
    const renderExperimentButtons = ()=>{
        if (redirectType === (0, $gtKO2.CheckUserNameRedirectType).Sso) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($c14bebab4e90fd48$export$d55ce944e082b58f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
            id: "login.form.opening.sso",
            defaultMessage: "Opening your single sign-on provider"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $9OWP7.default), null));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $cLysE.default), {
            appearance: "primary",
            id: "login-submit",
            testId: "login-submit-idf-testid",
            type: "submit",
            isFullWidth: true,
            isDisabled: isThirdStep && isTooManyAttemptsRecaptchaRequired && !captchaValue,
            isLoading: buttonClicked === 'submit' && (!!isRedirecting || isLoading || isCheckUsernameLoading)
        }, buttonContent());
    };
    const options = (0, $91i6m.useMemo)(()=>{
        if (!v2Accounts || v2Accounts.length === 0) return [];
        return v2Accounts.map((account)=>{
            if (account.action === 'ic_redirect') return {
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "isolated-cloud-label",
                    defaultMessage: "{name} Isolated Cloud",
                    description: "Label for selecting the Isolated Cloud environment",
                    values: {
                        name: account.ic_display_name
                    }
                }),
                value: account.ic_id
            };
            return {
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "atlassian-cloud-label",
                    defaultMessage: "Atlassian Cloud",
                    description: "Label for selecting the Atlassian Cloud environment"
                }),
                value: 'atlassian-cloud'
            };
        });
    }, [
        v2Accounts
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("div", null, error && !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $31nHY.default), null, error === null || error === void 0 ? void 0 : error.message), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("span", null, " ", infoContent(), " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($c14bebab4e90fd48$export$a7fed597f4b8afd8, {
        id: "form-login",
        "data-testid": "form-login",
        onSubmit: handleSubmit,
        onClick: onFormClick,
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($c14bebab4e90fd48$var$InputsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $dmC2D.default), {
        fieldViewType: $c14bebab4e90fd48$var$getEmailFieldViewType(restrictedEmail, redirectType, isThirdStep, isSecondStep, isLoading),
        fieldError: emailError(),
        onChange: onEmailChange,
        value: email,
        onEmailClick: onEmailClick,
        placeholderOverride: formatMessage((0, $jthWj.default).emailPlaceholder),
        inputRef: inputRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $jL47V.default), {
        isHidden: !isSecondStep || !isNewV2CheckUsernameFlow,
        fieldError: accountEnvFieldError,
        onSelectEnvChange: onAccountEnvChange,
        isRequired: isSecondStep && isNewV2CheckUsernameFlow,
        isInvalid: !!accountEnvFieldError,
        options: options
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $9w0eB.default), {
        isHidden: !isThirdStep,
        fieldError: passwordFieldError || undefined,
        onChange: handlePasswordChange,
        value: password,
        className: `field-group password-field ${isThirdStep ? 'expanded' : 'hidden'}`,
        isRequired: isThirdStep
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $cZAbO.LoginRecaptcha), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $cs6gC.LoginMarketingConsent), null), showRememberMeCheckbox && redirectType !== (0, $gtKO2.CheckUserNameRedirectType).Sso && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $9X0U9.default), {
        paddingBlockStart: "space.100",
        paddingBlockEnd: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $c32T7.default), {
        direction: "row",
        gap: "space.050",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $83IjZ.default), {
        testId: "remember-me-checkbox",
        isChecked: rememberMeChecked,
        onClick: onToggleRememberMeCheckbox,
        name: "remember",
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), (0, $jthWj.default).rememberMeCheckboxLabel),
        // During the redirect process (and while loading), we want to disable the checkbox so that the user doesn't interact with the checkbox.
        isDisabled: buttonClicked === 'submit' && (!!isRedirecting || isLoading || isCheckUsernameLoading)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $5v178.default), {
        // TODO [KIRBY-8737]: once it is available, use prop spacing='compact'
        // https://hello.jira.atlassian.cloud/browse/KIRBY-8737
        appearance: "info",
        iconLabel: formatMessage((0, $jthWj.default).rememberMeMoreInfoLabel),
        placement: "right",
        fallbackPlacements: [
            'bottom'
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), (0, $jthWj.default).rememberMeTooltip))))), renderExperimentButtons(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $gFwNN.default), {
        isHidden: !isThirdStep || !isPasswordlessAllowed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $j7UeI.StyledSocialLoginButton), {
        id: "passwordless-button",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bt1Sd))), {
            label: "email"
        }),
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("span", {
            style: {
                width: 24
            }
        }),
        isFullWidth: true,
        advisoryEnabled: false,
        onClick: handlePasswordlessButtonClick,
        isLoading: buttonClicked === 'passwordless' && (!!isRedirecting || isLoading),
        isDisabled: isTooManyAttemptsRecaptchaRequired && !captchaValue || isLoading || isRedirecting
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
        id: "login.form.passwordless.button",
        defaultMessage: "Log in with email"
    })))));
};
var $c14bebab4e90fd48$export$2e2bcd8739ae039 = $c14bebab4e90fd48$export$1f58f750f20f344b;

});
parcelRegister("bt1Sd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8593db29877e5ae9$var$_react = $8593db29877e5ae9$var$_interopRequireDefault((parcelRequire("91i6m")));

var $gJR35 = parcelRequire("gJR35");

var $8593db29877e5ae9$var$_email = $8593db29877e5ae9$var$_interopRequireDefault((parcelRequire("an4V6")));
function $8593db29877e5ae9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8593db29877e5ae9$var$EmailIcon = (props)=>/*#__PURE__*/ $8593db29877e5ae9$var$_react.default.createElement($gJR35.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 7v10h14V7zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2z"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 0 0 4.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.12 1.12 0 0 1-1.583 0z"/></g></svg>`
    }, props, {
        newIcon: $8593db29877e5ae9$var$_email.default
    }));
$8593db29877e5ae9$var$EmailIcon.displayName = 'EmailIcon';
var $8593db29877e5ae9$var$_default = module.exports.default = $8593db29877e5ae9$var$EmailIcon;

});
parcelRegister("an4V6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::19440c8dd0e3db5766add744ad314d45>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $78cfde5c14584441$var$_react = $78cfde5c14584441$var$_interopRequireDefault((parcelRequire("91i6m")));

var $78cfde5c14584441$var$_baseNew = $78cfde5c14584441$var$_interopRequireDefault((parcelRequire("hVDwR")));
function $78cfde5c14584441$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Email".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $78cfde5c14584441$var$EmailIcon = (props)=>/*#__PURE__*/ $78cfde5c14584441$var$_react.default.createElement($78cfde5c14584441$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v.529L8 8.128l6.5-3.6V4a.5.5 0 0 0-.5-.5zm12.5 2.743L8.363 9.641a.75.75 0 0 1-.726 0L1.5 6.243V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$78cfde5c14584441$var$EmailIcon.displayName = 'EmailIcon';
var $78cfde5c14584441$var$_default = module.exports.default = $78cfde5c14584441$var$EmailIcon;

});


parcelRegister("dmC2D", function(module, exports) {

$parcel$export(module.exports, "FieldViewType", function () { return $a37bcfc7af5918f1$export$63009c89ca139043; });
$parcel$export(module.exports, "default", function () { return $a37bcfc7af5918f1$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $9jjaN = parcelRequire("9jjaN");

var $h89s9 = parcelRequire("h89s9");

var $gFwNN = parcelRequire("gFwNN");

var $gaHKK = parcelRequire("gaHKK");

var $leG06 = parcelRequire("leG06");
parcelRequire("0wXBc");
var $buHgC = parcelRequire("buHgC");

var $tbh94 = parcelRequire("tbh94");

var $e3LqV = parcelRequire("e3LqV");
let $a37bcfc7af5918f1$var$_ = (t)=>t, $a37bcfc7af5918f1$var$t;
const $a37bcfc7af5918f1$var$IconButtonWrapper = (0, $9jjaN.default).div($a37bcfc7af5918f1$var$t || ($a37bcfc7af5918f1$var$t = $a37bcfc7af5918f1$var$_`
  padding: 3px;
  margin-left: -1px;
`));
var $a37bcfc7af5918f1$export$63009c89ca139043 = /*#__PURE__*/ function(FieldViewType) {
    FieldViewType["Editable"] = "editable";
    FieldViewType["ReadOnlyWithEditButton"] = "read-only-with-edit-button";
    FieldViewType["Restricted"] = "restricted";
    return FieldViewType;
}({});
const $a37bcfc7af5918f1$var$EmailContainer = ({ fieldError: fieldError, fieldViewType: fieldViewType, onChange: onChange, onEmailClick: onEmailClick, placeholderOverride: placeholderOverride, value: value, inputRef: inputRef })=>{
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const isEditable = fieldViewType === "editable";
    const prevIsReadOnly = (0, $buHgC.usePrevious)(!isEditable);
    (0, $91i6m.useEffect)(()=>{
        var _inputRef_current;
        if (isEditable && prevIsReadOnly) (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
    }, [
        isEditable,
        prevIsReadOnly,
        inputRef
    ]);
    const handleChange = (e)=>{
        const newValue = e.currentTarget.value;
        onChange(newValue);
    };
    const placeholder = placeholderOverride || formatMessage((0, $gaHKK.default).loginFormUsernamePlaceholder);
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gFwNN.default), {
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $h89s9.default), {
            testId: "username" // used in pollinators
            ,
            name: "username",
            autoComplete: "username",
            type: "email",
            placeholder: placeholder,
            label: formatMessage((0, $gaHKK.default).loginFormUsernameLabel),
            autoFocus: isEditable,
            onChange: handleChange,
            isInvalid: !!fieldError,
            invalidMessage: fieldError,
            value: value,
            ref: inputRef,
            isRequired: true,
            isDisabled: !isEditable,
            elemAfterInput: fieldViewType === "read-only-with-edit-button" && /*#__PURE__*/ (0, $4ZSso.jsx)($a37bcfc7af5918f1$var$IconButtonWrapper, {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $tbh94.default), {
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($e3LqV))),
                    label: formatMessage((0, $gaHKK.default).loginFormReadOnlyUsernameAriaLabel),
                    onClick: onEmailClick,
                    appearance: "subtle"
                })
            })
        })
    });
};
var $a37bcfc7af5918f1$export$2e2bcd8739ae039 = $a37bcfc7af5918f1$var$EmailContainer;

});
parcelRegister("e3LqV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a3c623c5bc2fbe74$var$_react = $a3c623c5bc2fbe74$var$_interopRequireDefault((parcelRequire("91i6m")));

var $gJR35 = parcelRequire("gJR35");

var $a3c623c5bc2fbe74$var$_edit = $a3c623c5bc2fbe74$var$_interopRequireDefault((parcelRequire("j1byO")));
function $a3c623c5bc2fbe74$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a3c623c5bc2fbe74$var$EditIcon = (props)=>/*#__PURE__*/ $a3c623c5bc2fbe74$var$_react.default.createElement($gJR35.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $a3c623c5bc2fbe74$var$_edit.default
    }));
$a3c623c5bc2fbe74$var$EditIcon.displayName = 'EditIcon';
var $a3c623c5bc2fbe74$var$_default = module.exports.default = $a3c623c5bc2fbe74$var$EditIcon;

});
parcelRegister("j1byO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e8b466fb905db85ecf24180397d24c4f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dd8713f750c394f3$var$_react = $dd8713f750c394f3$var$_interopRequireDefault((parcelRequire("91i6m")));

var $dd8713f750c394f3$var$_baseNew = $dd8713f750c394f3$var$_interopRequireDefault((parcelRequire("hVDwR")));
function $dd8713f750c394f3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dd8713f750c394f3$var$EditIcon = (props)=>/*#__PURE__*/ $dd8713f750c394f3$var$_react.default.createElement($dd8713f750c394f3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.708zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.216l-.54 1.891 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V10H15v3.001a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$dd8713f750c394f3$var$EditIcon.displayName = 'EditIcon';
var $dd8713f750c394f3$var$_default = module.exports.default = $dd8713f750c394f3$var$EditIcon;

});



parcelRegister("9w0eB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b319ab9a4a7a53ac$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $gFwNN = parcelRequire("gFwNN");

var $c1txK = parcelRequire("c1txK");

var $cJRdM = parcelRequire("cJRdM");

var $leG06 = parcelRequire("leG06");
parcelRequire("0wXBc");
var $buHgC = parcelRequire("buHgC");
const $b319ab9a4a7a53ac$var$PasswordContainer = ({ className: className, fieldError: fieldError, isHidden: isHidden, onChange: onChange, value: value, isRequired: isRequired = false })=>{
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const inputRef = (0, $91i6m.useRef)(null);
    const wasHidden = (0, $buHgC.usePrevious)(isHidden);
    (0, $91i6m.useEffect)(()=>{
        var _inputRef_current;
        if (!isHidden && wasHidden) (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
    }, [
        isHidden,
        wasHidden
    ]);
    const fieldErrorNode = fieldError && /*#__PURE__*/ (0, $4ZSso.jsx)("span", {
        id: "password-error",
        "data-testid": "password-error-idf-testid" // used in pollinators
        ,
        children: fieldError
    });
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gFwNN.default), {
        isHidden: isHidden,
        className: className,
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $c1txK.default), {
            id: "password",
            testId: "password" // used in pollinators
            ,
            name: "password",
            autoComplete: "current-password",
            placeholder: formatMessage((0, $cJRdM.default).passwordPlaceholder),
            label: formatMessage((0, $cJRdM.default).passwordLabel),
            autoFocus: !isHidden,
            onChange: onChange,
            isInvalid: !!fieldError,
            invalidMessage: fieldErrorNode,
            value: value,
            ref: inputRef,
            isRequired: isRequired
        })
    });
};
var $b319ab9a4a7a53ac$export$2e2bcd8739ae039 = $b319ab9a4a7a53ac$var$PasswordContainer;

});

parcelRegister("lnbpL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c71a1682cc4a680$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $6NU0v = parcelRequire("6NU0v");

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $9jjaN = parcelRequire("9jjaN");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");
let $5c71a1682cc4a680$var$_ = (t)=>t, $5c71a1682cc4a680$var$t;
const $5c71a1682cc4a680$var$FormInfo = (0, $9jjaN.default).div($5c71a1682cc4a680$var$t || ($5c71a1682cc4a680$var$t = $5c71a1682cc4a680$var$_`
  color: ${0};
  font-size: 13px;
  line-height: 17px;
  margin-bottom: 24px;
  margin-top: -4px;
  transform: rotateX(0deg);
  transform-origin: 50% 0;
  transition-property: visibility, height, margin-bottom, opacity, transform, padding;
  transition-duration: 0s, 0.2s, 0.2s, 0.2s, 0.2s;
  transition-timing-function: ease-in-out;
  text-align: center;

  &.hidden {
    height: 0;
    margin-bottom: 0;
    opacity: 0;
    padding: 0 ${0}px;
    pointer-events: none;
    transform: rotateX(-90deg);
    visibility: hidden;
  }
`), (0, $kLNLK).N700, (0, $6e88g.gridSize)() * 2);
const $5c71a1682cc4a680$var$FormInfoComponent = (_param)=>{
    var { children: children } = _param, props = (0, $6NU0v._)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)($5c71a1682cc4a680$var$FormInfo, (0, $b2I6k._)((0, $1Fos3._)({
        role: "alert"
    }, props), {
        className: props.isHidden ? 'hidden' : '',
        children: children
    }));
};
var $5c71a1682cc4a680$export$2e2bcd8739ae039 = $5c71a1682cc4a680$var$FormInfoComponent;

});

parcelRegister("j7UeI", function(module, exports) {

$parcel$export(module.exports, "SocialLoginOptionWrapper", function () { return $6b71b168e012af76$export$84dac62724cf046; });
$parcel$export(module.exports, "SocialLoginButton", function () { return $6b71b168e012af76$export$e42ebbbcc1226808; });
$parcel$export(module.exports, "SocialLoginButtonRowGroup", function () { return $6b71b168e012af76$export$b2f108f5851fd592; });
$parcel$export(module.exports, "SocialLoginPanelWrapper", function () { return $6b71b168e012af76$export$e61ba37bbdbb1966; });
$parcel$export(module.exports, "StyledSocialLoginButton", function () { return $6b71b168e012af76$export$27110045cf7ea8db; });
$parcel$export(module.exports, "default", function () { return $6b71b168e012af76$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $6NU0v = parcelRequire("6NU0v");

var $4ZSso = parcelRequire("4ZSso");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");
parcelRequire("91i6m");

var $leG06 = parcelRequire("leG06");

var $9jjaN = parcelRequire("9jjaN");

var $eWm11 = parcelRequire("eWm11");

var $htB5i = parcelRequire("htB5i");

var $5R4qW = parcelRequire("5R4qW");

var $6h0tx = parcelRequire("6h0tx");

var $ccxRw = parcelRequire("ccxRw");

var $ySUvx = parcelRequire("ySUvx");

var $cLysE = parcelRequire("cLysE");

var $8iEgn = parcelRequire("8iEgn");

var $cOOAJ = parcelRequire("cOOAJ");

var $lMv0j = parcelRequire("lMv0j");

var $2UbF1 = parcelRequire("2UbF1");
let $6b71b168e012af76$var$_ = (t)=>t, $6b71b168e012af76$var$t, $6b71b168e012af76$var$t1, $6b71b168e012af76$var$t2, $6b71b168e012af76$var$t3;
const $6b71b168e012af76$export$969af4902a13348e = ({ handleGoogleLogin: handleGoogleLogin, handleMicrosoftLogin: handleMicrosoftLogin, handleAppleLogin: handleAppleLogin, handleSlackLogin: handleSlackLogin })=>{
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const dynamicConfigs = (0, $2UbF1.useDynamicConfigs)();
    const googleOutageEnabled = (0, $ccxRw.isGoogleLoginOutageAdvisoryEnabled)(dynamicConfigs);
    const microsoftOutageEnabled = (0, $ccxRw.isMicrosoftLoginOutageAdvisoryEnabled)(dynamicConfigs);
    const appleOutageEnabled = (0, $ccxRw.isAppleLoginOutageAdvisoryEnabled)(dynamicConfigs);
    const slackOutageEnabled = (0, $ccxRw.isSlackLoginOutageAdvisoryEnabled)(dynamicConfigs);
    const isSocialLoginOutage = googleOutageEnabled || microsoftOutageEnabled || appleOutageEnabled || slackOutageEnabled;
    const getAdvisorySectionMessage = ()=>{
        const multipleOutages = [
            googleOutageEnabled,
            microsoftOutageEnabled,
            appleOutageEnabled,
            slackOutageEnabled
        ].filter(Boolean).length > 1;
        const sectionMessageTitle = multipleOutages ? formatMessage((0, $ySUvx.default).someOutageTitle) : getAdvisorySectionMessageTitle();
        const sectionMessageDescription = multipleOutages ? formatMessage((0, $ySUvx.default).someOutageDescription) : getAdvisorySectionMessageDescription();
        return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8iEgn.default), {
            testId: "social-login-outage-section-message",
            title: sectionMessageTitle,
            appearance: "warning",
            children: /*#__PURE__*/ (0, $4ZSso.jsx)("p", {
                children: sectionMessageDescription
            })
        });
    };
    const getAdvisorySectionMessageTitle = ()=>googleOutageEnabled ? formatMessage((0, $ySUvx.default).googleOutageTitle) : microsoftOutageEnabled ? formatMessage((0, $ySUvx.default).microsoftOutageTitle) : appleOutageEnabled ? formatMessage((0, $ySUvx.default).appleOutageTitle) : slackOutageEnabled ? formatMessage((0, $ySUvx.default).slackOutageTitle) : formatMessage((0, $ySUvx.default).someOutageTitle);
    const getAdvisorySectionMessageDescription = ()=>googleOutageEnabled ? formatMessage((0, $ySUvx.default).googleOutageDescription) : microsoftOutageEnabled ? formatMessage((0, $ySUvx.default).microsoftOutageDescription) : appleOutageEnabled ? formatMessage((0, $ySUvx.default).appleOutageDescription) : slackOutageEnabled ? formatMessage((0, $ySUvx.default).slackOutageDescription) : formatMessage((0, $ySUvx.default).someOutageDescription);
    const handleGoogleLoginOnClick = ()=>{
        handleGoogleLogin();
    };
    const GoogleButton = ()=>/*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$export$84dac62724cf046, {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$export$e42ebbbcc1226808, {
                id: "google-auth-button",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($htB5i))),
                onClick: handleGoogleLoginOnClick,
                advisoryEnabled: googleOutageEnabled,
                outageTooltipMessage: formatMessage((0, $ySUvx.default).googleOutageDescription),
                children: "Google"
            })
        });
    const MicrosoftButton = ()=>/*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$export$84dac62724cf046, {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$export$e42ebbbcc1226808, {
                id: "microsoft-auth-button",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($5R4qW))),
                onClick: handleMicrosoftLogin,
                advisoryEnabled: microsoftOutageEnabled,
                outageTooltipMessage: formatMessage((0, $ySUvx.default).microsoftOutageDescription),
                children: "Microsoft"
            })
        });
    const AppleButton = ()=>/*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$export$84dac62724cf046, {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$export$e42ebbbcc1226808, {
                id: "apple-auth-button",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($eWm11))),
                onClick: handleAppleLogin,
                advisoryEnabled: appleOutageEnabled,
                outageTooltipMessage: formatMessage((0, $ySUvx.default).appleOutageDescription),
                children: "Apple"
            })
        });
    const SlackButton = ()=>/*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$export$84dac62724cf046, {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$export$e42ebbbcc1226808, {
                id: "slack-auth-button",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($6h0tx))),
                onClick: handleSlackLogin,
                advisoryEnabled: slackOutageEnabled,
                outageTooltipMessage: formatMessage((0, $ySUvx.default).slackOutageDescription),
                children: "Slack"
            })
        });
    const showButtonsGridLayout = ()=>/*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
            children: [
                /*#__PURE__*/ (0, $4ZSso.jsxs)($6b71b168e012af76$export$b2f108f5851fd592, {
                    "data-testid": "social-login-button-row",
                    children: [
                        GoogleButton(),
                        MicrosoftButton()
                    ]
                }),
                /*#__PURE__*/ (0, $4ZSso.jsxs)($6b71b168e012af76$export$b2f108f5851fd592, {
                    "data-testid": "social-login-button-row",
                    children: [
                        AppleButton(),
                        SlackButton()
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0, $4ZSso.jsxs)($6b71b168e012af76$export$e61ba37bbdbb1966, {
        role: "list",
        "data-i18n-or": formatMessage((0, $ySUvx.default).socialAuthOr),
        "data-i18n-continue": formatMessage((0, $ySUvx.default).socialAuthOrContinueWith),
        className: "google-login social-login",
        "data-testid": "social-login-wrapper",
        children: [
            showButtonsGridLayout(),
            isSocialLoginOutage && getAdvisorySectionMessage()
        ]
    });
};
const $6b71b168e012af76$export$e61ba37bbdbb1966 = (0, $9jjaN.default).ul($6b71b168e012af76$var$t || ($6b71b168e012af76$var$t = $6b71b168e012af76$var$_`
  margin-top: ${0}px;
  list-style: none;
  padding-inline: 0;
  margin-block-end: 0;
  &::before {
    color: ${0};
    content: attr(data-i18n-continue);
    display: block;
    font-size: 14px;
    line-height: 16px;
    margin-bottom: ${0}px;
    font-weight: 600;
    text-align: center;
  }
`), (0, $6e88g.gridSize)() * 3, (0, $kLNLK).N300, (0, $6e88g.gridSize)() * 2);
const $6b71b168e012af76$export$b2f108f5851fd592 = (0, $9jjaN.default).div($6b71b168e012af76$var$t1 || ($6b71b168e012af76$var$t1 = $6b71b168e012af76$var$_`
  &:not(:last-child) {
    margin-bottom: ${0}px;
  }
`), (0, $6e88g.gridSize)() * 2);
const $6b71b168e012af76$export$84dac62724cf046 = (0, $9jjaN.default).li($6b71b168e012af76$var$t2 || ($6b71b168e012af76$var$t2 = $6b71b168e012af76$var$_`
  &:not(:last-child) {
    margin-bottom: ${0}px;
  }
`), (0, $6e88g.gridSize)() * 2);
const $6b71b168e012af76$export$e42ebbbcc1226808 = (_param)=>{
    var { children: children, logo: logo, advisoryEnabled: advisoryEnabled, outageTooltipMessage: outageTooltipMessage } = _param, props = (0, $6NU0v._)(_param, [
        "children",
        "logo",
        "advisoryEnabled",
        "outageTooltipMessage"
    ]);
    const commonProps = {
        isFullWidth: true,
        iconBefore: logo ? /*#__PURE__*/ (0, $4ZSso.jsx)("img", {
            src: logo,
            alt: ""
        }) : undefined
    };
    if (advisoryEnabled) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $lMv0j.default), {
        testId: "social-auth-button-tooltip",
        content: outageTooltipMessage,
        children: /*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$export$27110045cf7ea8db, (0, $b2I6k._)((0, $1Fos3._)({
            advisoryEnabled: true,
            iconAfter: /*#__PURE__*/ (0, $4ZSso.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cOOAJ))), {
                testId: "social-auth-button-warning-icon",
                label: "",
                primaryColor: (0, $kLNLK).Y500,
                secondaryColor: (0, $kLNLK).Y50
            })
        }, commonProps, props), {
            children: children
        }))
    });
    else return /*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$export$27110045cf7ea8db, (0, $b2I6k._)((0, $1Fos3._)({
        advisoryEnabled: false
    }, commonProps, props), {
        children: children
    }));
};
const $6b71b168e012af76$export$27110045cf7ea8db = (0, $9jjaN.default)((0, $cLysE.default), {
    shouldForwardProp: (propName)=>![
            'advisoryEnabled'
        ].includes(propName)
})($6b71b168e012af76$var$t3 || ($6b71b168e012af76$var$t3 = $6b71b168e012af76$var$_`
  background: ${0} !important;
  box-shadow: none;
  font-weight: bold;
  border: 1px solid ${0};
  border-radius: 3px;
  color: ${0};
  span {
    flex-grow: unset;
  }

  &:not(:last-child) {
    margin-bottom: ${0}px;
  }

  &:hover {
    background: ${0} !important;
  }
  &:active {
    background: ${0} !important;
    color: ${0} !important;
  }
  &:focus {
    box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.2), 0 0 0 2px rgba(38, 132, 255, 0.6) !important;
  }
  img {
    height: 24px;
    width: 24px;
    margin-right: 6px;
  }
`), (props)=>props.advisoryEnabled ? (0, $kLNLK).Y50 : (0, $kLNLK).N0, (0, $kLNLK).N50, (0, $kLNLK).N800, (0, $6e88g.gridSize)() * 0.5, (0, $kLNLK).N10A, (0, $kLNLK).N20A, (0, $kLNLK).N400);
var $6b71b168e012af76$export$2e2bcd8739ae039 = $6b71b168e012af76$export$969af4902a13348e;

});
parcelRegister("eWm11", function(module, exports) {

module.exports = (parcelRequire("cgi2g")).getBundleURL('9rAa3') + "apple-logo.54e0d711.svg";

});

parcelRegister("htB5i", function(module, exports) {

module.exports = (parcelRequire("cgi2g")).getBundleURL('9rAa3') + "google-logo.5867462c.svg";

});

parcelRegister("5R4qW", function(module, exports) {

module.exports = (parcelRequire("cgi2g")).getBundleURL('9rAa3') + "microsoft-logo.c73d8dca.svg";

});

parcelRegister("6h0tx", function(module, exports) {

module.exports = (parcelRequire("cgi2g")).getBundleURL('9rAa3') + "slack-logo.5d730c10.svg";

});

parcelRegister("ySUvx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e74db0f439e21255$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $e74db0f439e21255$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    socialAuthOr: {
        id: 'social.auth.or',
        defaultMessage: 'or'
    },
    socialAuthOrContinueWith: {
        id: 'social.auth.or-continue-with',
        defaultMessage: 'Or continue with:'
    },
    socialAuthContinue: {
        id: 'social.auth.continue',
        defaultMessage: 'Or continue with',
        description: `Precedes third party login buttons. For example, "Or continue with Google"`
    },
    someOutageTitle: {
        id: 'some.outage.title',
        defaultMessage: 'Issues with some login options',
        description: 'Message to the user that there are currently issues logging in with some providers due to an outage'
    },
    googleOutageTitle: {
        id: 'google.outage.title',
        defaultMessage: 'Issues with Google login',
        description: 'Message to the user that there are currently issues logging in with Google due to an outage'
    },
    microsoftOutageTitle: {
        id: 'microsoft.outage.title',
        defaultMessage: 'Issues with Microsoft login',
        description: 'Message to the user that there are currently issues logging in with Microsoft due to an outage'
    },
    appleOutageTitle: {
        id: 'apple.outage.title',
        defaultMessage: 'Issues with Apple login',
        description: 'Message to the user that there are currently issues logging in with Apple due to an outage'
    },
    slackOutageTitle: {
        id: 'slack.outage.title',
        defaultMessage: 'Issues with Slack login',
        description: 'Message to the user that there are currently issues logging in with Slack due to an outage'
    },
    someOutageDescription: {
        id: 'some.outage.description',
        defaultMessage: 'Some login options are experiencing issues at the moment. You may be able to log in or sign up with your email and password instead.',
        description: 'Message to the user that there are currently issues logging in with due to a login provider outage'
    },
    googleOutageDescription: {
        id: 'google.outage.description',
        defaultMessage: 'There are issues with Google login and signup at the moment. If you are unable to continue with Google, you may be able to use your email and password instead.',
        description: 'Message to the user that there are currently issues logging in with Google due to an outage'
    },
    microsoftOutageDescription: {
        id: 'microsoft.outage.description',
        defaultMessage: 'There are issues with Microsoft login and signup at the moment. If you are unable to continue with Microsoft, you may be able to use your email and password instead.',
        description: 'Message to the user that there are currently issues logging in with Microsoft due to an outage'
    },
    appleOutageDescription: {
        id: 'apple.outage.description',
        defaultMessage: 'There are issues with Apple login and signup at the moment. If you are unable to continue with Apple, you may be able to use your email and password instead.',
        description: 'Message to the user that there are currently issues logging in with Apple due to an outage'
    },
    slackOutageDescription: {
        id: 'slack.outage.description',
        defaultMessage: 'There are issues with Slack login and signup at the moment. If you are unable to continue with Slack, you may be able to use your email and password instead.',
        description: 'Message to the user that there are currently issues logging in with Slack due to an outage'
    }
});

});

parcelRegister("cOOAJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $955165eea80d5a75$var$_react = $955165eea80d5a75$var$_interopRequireDefault((parcelRequire("91i6m")));

var $gJR35 = parcelRequire("gJR35");

var $955165eea80d5a75$var$_statusWarning = $955165eea80d5a75$var$_interopRequireDefault((parcelRequire("8tuT3")));
function $955165eea80d5a75$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $955165eea80d5a75$var$WarningIcon = (props)=>/*#__PURE__*/ $955165eea80d5a75$var$_react.default.createElement($gJR35.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $955165eea80d5a75$var$_statusWarning.default
    }));
$955165eea80d5a75$var$WarningIcon.displayName = 'WarningIcon';
var $955165eea80d5a75$var$_default = module.exports.default = $955165eea80d5a75$var$WarningIcon;

});
parcelRegister("8tuT3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::435e803a057e79e21a0d31c5b12f3f81>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $62b8fdb0a35f4a8e$var$_react = $62b8fdb0a35f4a8e$var$_interopRequireDefault((parcelRequire("91i6m")));

var $62b8fdb0a35f4a8e$var$_baseNew = $62b8fdb0a35f4a8e$var$_interopRequireDefault((parcelRequire("hVDwR")));
function $62b8fdb0a35f4a8e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $62b8fdb0a35f4a8e$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $62b8fdb0a35f4a8e$var$_react.default.createElement($62b8fdb0a35f4a8e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$62b8fdb0a35f4a8e$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $62b8fdb0a35f4a8e$var$_default = module.exports.default = $62b8fdb0a35f4a8e$var$StatusWarningIcon;

});



parcelRegister("cZAbO", function(module, exports) {

$parcel$export(module.exports, "LoginRecaptcha", function () { return $a4d29ea41ec40977$export$1e978f900466132e; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $2aGBJ = parcelRequire("2aGBJ");

var $lPSLn = parcelRequire("lPSLn");

var $g6OTd = parcelRequire("g6OTd");

var $a5qoX = parcelRequire("a5qoX");

var $6eNI5 = parcelRequire("6eNI5");
parcelRequire("0wXBc");
var $buHgC = parcelRequire("buHgC");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");
const $a4d29ea41ec40977$export$1e978f900466132e = ()=>{
    (0, $4PGUW.useRegisterComponent)($a4d29ea41ec40977$export$1e978f900466132e.name);
    const { enabled: recaptchaEnabled, component: recaptchaComponent } = (0, $a5qoX.useRecaptchaContext)();
    const isSecondStep = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isUsernameChecked;
    });
    const isCaptchaRequired = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isCaptchaRequired;
    });
    const shouldRenderCheckUsernameRecaptcha = !isSecondStep && recaptchaEnabled && recaptchaComponent;
    const { setCaptchaValue: setCaptchaValue } = (0, $6eNI5.useLoginTooManyAttemptsRecaptchaContext)();
    const shouldRenderTooManyAttemptsRecaptcha = isSecondStep && isCaptchaRequired;
    const prevIsCaptchaRequired = (0, $buHgC.usePrevious)(isCaptchaRequired);
    (0, $91i6m.useEffect)(()=>{
        if (prevIsCaptchaRequired && !isCaptchaRequired) setCaptchaValue(null);
    }, [
        isCaptchaRequired,
        prevIsCaptchaRequired,
        setCaptchaValue
    ]);
    const isCaptchaEnabledByConfig = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_appConfig;
        return (_state_appConfig = state.appConfig) === null || _state_appConfig === void 0 ? void 0 : _state_appConfig.recaptchaEnable;
    });
    const recaptchaEnterpriseCheckboxKeySite = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_appConfig;
        return (_state_appConfig = state.appConfig) === null || _state_appConfig === void 0 ? void 0 : _state_appConfig.recaptchaEnterpriseCheckboxKeySite;
    });
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4ZSso.Fragment), {
        children: isCaptchaEnabledByConfig && (shouldRenderCheckUsernameRecaptcha ? /*#__PURE__*/ (0, $4ZSso.jsx)((0, $g6OTd.default), {
            children: recaptchaComponent
        }) : shouldRenderTooManyAttemptsRecaptcha && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $g6OTd.default), {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $lPSLn.default), {
                sitekey: recaptchaEnterpriseCheckboxKeySite,
                onChange: setCaptchaValue
            })
        }))
    });
};

});
parcelRegister("lPSLn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc84cd0c6943b5c6$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $8hJHo = parcelRequire("8hJHo");

var $49Pnv = parcelRequire("49Pnv");
const $bc84cd0c6943b5c6$export$c8e68dd3bf26af81 = /*#__PURE__*/ (0, $91i6m.forwardRef)(function ReCAPTCHAEnterprise(props, ref) {
    const { grecaptcha: grecaptcha, onChange: onChange, onErrored: onErrored, onExpired: onExpired, size: size, sitekey: sitekey, action: action } = props;
    const enterprise = grecaptcha === null || grecaptcha === void 0 ? void 0 : grecaptcha.enterprise;
    const [widgetId, setWidgetId] = (0, $91i6m.useState)();
    const containerRef = (0, $91i6m.useRef)(null);
    const hasRendered = (0, $91i6m.useRef)(false);
    /**
     * The execution callbacks and states (hasRequest, resetRequired) etc.
     * are being tracked in a useRef since we don't want to react to its changes
     * but need to track it in-between renders.
     */ const executionRef = (0, $91i6m.useRef)({
        hasRequested: false,
        resetRequired: false
    });
    const resetExecutionHandlers = (0, $91i6m.useCallback)(()=>{
        delete executionRef.current.onResolve;
        delete executionRef.current.onReject;
    }, []);
    const reset = (0, $91i6m.useCallback)(()=>{
        if (enterprise && typeof widgetId === 'number') enterprise.reset(widgetId);
    }, [
        enterprise,
        widgetId
    ]);
    const handleError = (0, $91i6m.useCallback)((cause)=>{
        var _executionRef_current;
        if (onErrored) onErrored();
        if ((_executionRef_current = executionRef.current) === null || _executionRef_current === void 0 ? void 0 : _executionRef_current.onReject) {
            executionRef.current.onReject(new Error(`ReCAPTCHAEnterprise rejected due to: ${cause}`, {
                cause: cause
            }));
            resetExecutionHandlers();
        }
    }, [
        onErrored,
        resetExecutionHandlers
    ]);
    const handleChange = (0, $91i6m.useCallback)((token)=>{
        var _executionRef_current;
        if (onChange) onChange(token);
        if (!token) handleError('no-token');
        else if ((_executionRef_current = executionRef.current) === null || _executionRef_current === void 0 ? void 0 : _executionRef_current.onResolve) {
            executionRef.current.onResolve(token);
            resetExecutionHandlers();
        }
    }, [
        handleError,
        onChange,
        resetExecutionHandlers
    ]);
    const handleExpired = (0, $91i6m.useCallback)(()=>{
        if (onExpired) {
            var _executionRef_current;
            onExpired();
            if ((_executionRef_current = executionRef.current) === null || _executionRef_current === void 0 ? void 0 : _executionRef_current.onReject) {
                executionRef.current.onReject(new Error('ReCAPTCHAEnterprise rejected due to expired token'));
                resetExecutionHandlers();
            }
        } else handleChange(null);
    }, [
        handleChange,
        onExpired,
        resetExecutionHandlers
    ]);
    const execute = (0, $91i6m.useCallback)((targetWidgetId)=>{
        const id = typeof targetWidgetId === 'undefined' ? widgetId : targetWidgetId;
        if (enterprise && id !== undefined) {
            var _executionRef_current;
            // Tokens are cached, reset is needed after first execute
            if ((_executionRef_current = executionRef.current) === null || _executionRef_current === void 0 ? void 0 : _executionRef_current.resetRequired) reset();
            executionRef.current.resetRequired = true;
            enterprise.execute(id);
        } else executionRef.current.hasRequested = true;
    }, [
        enterprise,
        reset,
        widgetId
    ]);
    const renderExplicit = (0, $91i6m.useCallback)(()=>{
        var _executionRef_current;
        if (!sitekey) {
            (0, $49Pnv.captureErrorMessage)('ReCAPTCHAEnterprise: recaptcha enterprise site key not provided');
            return;
        }
        // Check if grecaptcha is available and if it hasn't been rendered already
        if (!(enterprise === null || enterprise === void 0 ? void 0 : enterprise.render) || widgetId !== undefined || hasRendered.current) return;
        const wrapper = document.createElement('div');
        const id = enterprise.render(wrapper, {
            sitekey: sitekey,
            action: action,
            size: size,
            callback: handleChange,
            'expired-callback': handleExpired,
            'error-callback': ()=>// NOTE: recaptcha script does not provide a value to this callback: https://cloud.google.com/recaptcha/docs/api-ref-checkbox-keys#attributes_parameters
                // This is just our own error handler
                handleError('script invoked error-callback')
        });
        setWidgetId(id);
        containerRef.current.appendChild(wrapper);
        if ((_executionRef_current = executionRef.current) === null || _executionRef_current === void 0 ? void 0 : _executionRef_current.hasRequested) {
            executionRef.current.hasRequested = false;
            execute(id);
        }
        hasRendered.current = true;
    }, [
        action,
        enterprise,
        execute,
        handleChange,
        handleError,
        handleExpired,
        sitekey,
        size,
        widgetId
    ]);
    (0, $91i6m.useEffect)(()=>{
        /**
       * This has to run on every render, hence why there is no dependency array.
       * renderExplicit was called on componentDidMount & componentDidUpdate when it was a class component.
       */ renderExplicit();
    });
    (0, $91i6m.useEffect)(()=>{
        const delayOfCaptchaIframeRemoving = ()=>{
            var _containerRef_current;
            const temporaryNode = document.createElement('div');
            document.body.appendChild(temporaryNode);
            temporaryNode.style.display = 'none';
            // move of the recaptcha to a temporary node
            while((_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.firstChild)temporaryNode.appendChild(containerRef.current.firstChild);
            // delete the temporary node after reset will be done
            setTimeout(()=>document.body.removeChild(temporaryNode), 5000);
        };
        return ()=>{
            if (widgetId !== undefined) {
                delayOfCaptchaIframeRemoving();
                reset();
                hasRendered.current = false;
            }
        };
    }, [
        reset,
        widgetId
    ]);
    (0, $91i6m.useImperativeHandle)(ref, ()=>({
            executeAsync () {
                return new Promise((resolve, reject)=>{
                    executionRef.current.onResolve = resolve;
                    executionRef.current.onReject = reject;
                    execute();
                });
            }
        }), [
        execute
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
        "data-testid": "ReCAPTCHAEnterprise",
        ref: containerRef
    });
});
var $bc84cd0c6943b5c6$export$2e2bcd8739ae039 = (0, $8hJHo.default)(()=>'https://www.recaptcha.net/recaptcha/enterprise.js?onload=onloadcallback&render=explicit', {
    callbackName: 'onloadcallback',
    globalName: 'grecaptcha'
})($bc84cd0c6943b5c6$export$c8e68dd3bf26af81);

});
parcelRegister("8hJHo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60835c15747f25e9$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $eYOCy = parcelRequire("eYOCy");

var $kTpRR = parcelRequire("kTpRR");
function $60835c15747f25e9$var$_extends() {
    $60835c15747f25e9$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $60835c15747f25e9$var$_extends.apply(this, arguments);
}
function $60835c15747f25e9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $60835c15747f25e9$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $60835c15747f25e9$var$SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function
var $60835c15747f25e9$var$idCount = 0;
function $60835c15747f25e9$export$2e2bcd8739ae039(getScriptURL, options) {
    options = options || {};
    return function wrapWithAsyncScript(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var AsyncScriptLoader = /*#__PURE__*/ function(_Component) {
            $60835c15747f25e9$var$_inheritsLoose(AsyncScriptLoader, _Component);
            function AsyncScriptLoader(props, context) {
                var _this;
                _this = _Component.call(this, props, context) || this;
                _this.state = {};
                _this.__scriptURL = "";
                return _this;
            }
            var _proto = AsyncScriptLoader.prototype;
            _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
                if (!this.__scriptLoaderID) this.__scriptLoaderID = "async-script-loader-" + $60835c15747f25e9$var$idCount++;
                return this.__scriptLoaderID;
            };
            _proto.setupScriptURL = function setupScriptURL() {
                this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
                return this.__scriptURL;
            };
            _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
                var _this2 = this;
                // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
                this.setState(state, function() {
                    return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
                });
            };
            _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
                var mapEntry = $60835c15747f25e9$var$SCRIPT_MAP[this.__scriptURL];
                if (!mapEntry || !mapEntry.loaded) throw new Error("Script is not loaded.");
                for(var obsKey in mapEntry.observers)mapEntry.observers[obsKey](mapEntry);
                delete window[options.callbackName];
            };
            _proto.componentDidMount = function componentDidMount() {
                var _this3 = this;
                var scriptURL = this.setupScriptURL();
                var key = this.asyncScriptLoaderGetScriptLoaderID();
                var _options = options, globalName = _options.globalName, callbackName = _options.callbackName, scriptId = _options.scriptId; // check if global object already attached to window
                if (globalName && typeof window[globalName] !== "undefined") $60835c15747f25e9$var$SCRIPT_MAP[scriptURL] = {
                    loaded: true,
                    observers: {}
                };
                 // check if script loading already
                if ($60835c15747f25e9$var$SCRIPT_MAP[scriptURL]) {
                    var entry = $60835c15747f25e9$var$SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"
                    if (entry && (entry.loaded || entry.errored)) {
                        this.asyncScriptLoaderHandleLoad(entry);
                        return;
                    } // if still loading then callback to observer queue
                    entry.observers[key] = function(entry) {
                        return _this3.asyncScriptLoaderHandleLoad(entry);
                    };
                    return;
                }
                /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */ var observers = {};
                observers[key] = function(entry) {
                    return _this3.asyncScriptLoaderHandleLoad(entry);
                };
                $60835c15747f25e9$var$SCRIPT_MAP[scriptURL] = {
                    loaded: false,
                    observers: observers
                };
                var script = document.createElement("script");
                script.src = scriptURL;
                script.async = true;
                for(var attribute in options.attributes)script.setAttribute(attribute, options.attributes[attribute]);
                if (scriptId) script.id = scriptId;
                var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
                    if ($60835c15747f25e9$var$SCRIPT_MAP[scriptURL]) {
                        var mapEntry = $60835c15747f25e9$var$SCRIPT_MAP[scriptURL];
                        var observersMap = mapEntry.observers;
                        for(var obsKey in observersMap)if (func(observersMap[obsKey])) delete observersMap[obsKey];
                    }
                };
                if (callbackName && typeof window !== "undefined") window[callbackName] = function() {
                    return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
                };
                script.onload = function() {
                    var mapEntry = $60835c15747f25e9$var$SCRIPT_MAP[scriptURL];
                    if (mapEntry) {
                        mapEntry.loaded = true;
                        callObserverFuncAndRemoveObserver(function(observer) {
                            if (callbackName) return false;
                            observer(mapEntry);
                            return true;
                        });
                    }
                };
                script.onerror = function() {
                    var mapEntry = $60835c15747f25e9$var$SCRIPT_MAP[scriptURL];
                    if (mapEntry) {
                        mapEntry.errored = true;
                        callObserverFuncAndRemoveObserver(function(observer) {
                            observer(mapEntry);
                            return true;
                        });
                    }
                };
                document.body.appendChild(script);
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                // Remove tag script
                var scriptURL = this.__scriptURL;
                if (options.removeOnUnmount === true) {
                    var allScripts = document.getElementsByTagName("script");
                    for(var i = 0; i < allScripts.length; i += 1){
                        if (allScripts[i].src.indexOf(scriptURL) > -1) {
                            if (allScripts[i].parentNode) allScripts[i].parentNode.removeChild(allScripts[i]);
                        }
                    }
                } // Clean the observer entry
                var mapEntry = $60835c15747f25e9$var$SCRIPT_MAP[scriptURL];
                if (mapEntry) {
                    delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];
                    if (options.removeOnUnmount === true) delete $60835c15747f25e9$var$SCRIPT_MAP[scriptURL];
                }
            };
            _proto.render = function render() {
                var globalName = options.globalName; // remove asyncScriptOnLoad from childProps
                var _this$props = this.props, asyncScriptOnLoad = _this$props.asyncScriptOnLoad, forwardedRef = _this$props.forwardedRef, childProps = $60835c15747f25e9$var$_objectWithoutPropertiesLoose(_this$props, [
                    "asyncScriptOnLoad",
                    "forwardedRef"
                ]); // eslint-disable-line no-unused-vars
                if (globalName && typeof window !== "undefined") childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
                childProps.ref = forwardedRef;
                return (0, $91i6m.createElement)(WrappedComponent, childProps);
            };
            return AsyncScriptLoader;
        }((0, $91i6m.Component)); // Note the second param "ref" provided by React.forwardRef.
        // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
        // And it can then be attached to the Component.
        var ForwardedComponent = (0, $91i6m.forwardRef)(function(props, ref) {
            return (0, $91i6m.createElement)(AsyncScriptLoader, $60835c15747f25e9$var$_extends({}, props, {
                forwardedRef: ref
            }));
        });
        ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
        ForwardedComponent.propTypes = {
            asyncScriptOnLoad: (0, (/*@__PURE__*/$parcel$interopDefault($eYOCy))).func
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($kTpRR)))(ForwardedComponent, WrappedComponent);
    };
}

});


parcelRegister("g6OTd", function(module, exports) {

$parcel$export(module.exports, "RecaptchaNotice", function () { return $6101c3d22ae535b7$export$4faf58f44fb24e61; });
$parcel$export(module.exports, "default", function () { return $6101c3d22ae535b7$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $9jjaN = parcelRequire("9jjaN");

var $6e88g = parcelRequire("6e88g");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");
parcelRequire("91i6m");

var $lqtFl = parcelRequire("lqtFl");

var $bqdjD = parcelRequire("bqdjD");
let $6101c3d22ae535b7$var$_ = (t)=>t, $6101c3d22ae535b7$var$t;
const $6101c3d22ae535b7$var$ReCaptchaContainer = (0, $9jjaN.default).div($6101c3d22ae535b7$var$t || ($6101c3d22ae535b7$var$t = $6101c3d22ae535b7$var$_`
  margin-top: ${0}px;
  display: flex;
  flex-direction: row;
  justify-content: center;
`), (0, $6e88g.gridSize)());
const $6101c3d22ae535b7$export$4faf58f44fb24e61 = ()=>{
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    if ((0, $bqdjD.isIsolatedCloud)()) return null;
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
        id: "signup.form.recaptcha.notice.xml",
        defaultMessage: "This site is protected by reCAPTCHA and the Google <google-pp-link>Privacy Policy</google-pp-link> and <google-tos-link>Terms of Service</google-tos-link> apply.",
        values: {
            'google-pp-link': (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)((0, $lqtFl.default), {
                    href: "https://policies.google.com/privacy",
                    target: "_blank",
                    rel: "noreferrer noopener",
                    "aria-label": formatMessage({
                        id: 'signup.form.recaptcha.notice.google.pp.link.aria.label',
                        defaultMessage: 'Google Privacy Policy',
                        description: "Aria label for link to let users learn more about Google's Privacy Policy."
                    }),
                    children: chunks
                }),
            'google-tos-link': (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)((0, $lqtFl.default), {
                    href: "https://policies.google.com/terms",
                    target: "_blank",
                    rel: "noreferrer noopener",
                    "aria-label": formatMessage({
                        id: 'signup.form.recaptcha.notice.google.tos.link.aria.label',
                        defaultMessage: 'Google Terms of Service',
                        description: "Aria label for link to let users learn more about Google's Terms of Service."
                    }),
                    children: chunks
                })
        }
    });
};
var $6101c3d22ae535b7$export$2e2bcd8739ae039 = $6101c3d22ae535b7$var$ReCaptchaContainer;

});

parcelRegister("a5qoX", function(module, exports) {

$parcel$export(module.exports, "useRecaptchaContext", function () { return $2e597c0bcbbea840$export$744a1a543fe96347; });
$parcel$export(module.exports, "RecaptchaContextProvider", function () { return $2e597c0bcbbea840$export$3f8996f6160b8ff2; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $k8slT = parcelRequire("k8slT");
const $2e597c0bcbbea840$export$2b9e9205883624e = /*#__PURE__*/ (0, $91i6m.createContext)(null);
const $2e597c0bcbbea840$export$744a1a543fe96347 = ()=>{
    const context = (0, $91i6m.useContext)($2e597c0bcbbea840$export$2b9e9205883624e);
    if (!context) throw new Error('useRecaptchaContext must be used within a RecaptchaContextProvider');
    return context;
};
const $2e597c0bcbbea840$export$3f8996f6160b8ff2 = ({ children: children, pageId: pageId, type: type, action: action, enabledProp: enabledProp })=>{
    const { isLoaded: isLoaded, enabled: enabled, errorMessage: errorMessage, component: component, fetchToken: baseFetchToken } = (0, $k8slT.useRecaptcha)({
        pageId: pageId,
        type: type,
        action: action,
        enabledProp: enabledProp
    });
    const fetchToken = (0, $91i6m.useCallback)(baseFetchToken, [
        baseFetchToken
    ]);
    const state = (0, $91i6m.useMemo)(()=>({
            isLoaded: isLoaded,
            enabled: enabled,
            errorMessage: errorMessage,
            component: component,
            fetchToken: fetchToken,
            recaptchaType: type
        }), [
        isLoaded,
        enabled,
        errorMessage,
        component,
        fetchToken,
        type
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)($2e597c0bcbbea840$export$2b9e9205883624e.Provider, {
        value: state,
        children: children
    });
};

});
parcelRegister("k8slT", function(module, exports) {

$parcel$export(module.exports, "useRecaptcha", function () { return $fd41387fb9659e5c$export$f7242fdfba1703e8; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $91i6m = parcelRequire("91i6m");

var $aY5EN = parcelRequire("aY5EN");

var $erh2U = parcelRequire("erh2U");

var $2aGBJ = parcelRequire("2aGBJ");

var $49Pnv = parcelRequire("49Pnv");
const $fd41387fb9659e5c$var$noOpScoreConfig = {
    sitekey: '',
    pageId: '',
    enabled: false
};
const $fd41387fb9659e5c$var$noOpCheckboxConfig = {
    sitekey: '',
    pageId: '',
    enabled: false,
    action: ''
};
const $fd41387fb9659e5c$export$f7242fdfba1703e8 = (props)=>{
    const { pageId: pageId, type: type, enabledProp: enabledProp = true, action: action } = props;
    const { config: config } = $fd41387fb9659e5c$export$9b70e8251564d9ec(pageId, type, enabledProp, action);
    const isScore = type === 'score';
    const isCheckbox = type === 'checkbox';
    const scoreRecaptcha = (0, $erh2U.useScoreRecaptcha)(isScore ? config : $fd41387fb9659e5c$var$noOpScoreConfig);
    const checkboxRecaptcha = (0, $aY5EN.useCheckboxRecaptcha)(isCheckbox ? config : $fd41387fb9659e5c$var$noOpCheckboxConfig);
    return (0, $91i6m.useMemo)(()=>isScore ? $fd41387fb9659e5c$var$handleScore(scoreRecaptcha, action) : $fd41387fb9659e5c$var$handleCheckbox(checkboxRecaptcha), [
        isScore,
        scoreRecaptcha,
        checkboxRecaptcha,
        action
    ]);
};
function $fd41387fb9659e5c$export$9b70e8251564d9ec(pageId, type, enabledProp, action) {
    const captchaEnabledByConfig = (0, $2aGBJ.useAppSelector)((state)=>state.appConfig.recaptchaEnable);
    const scoreSitekey = (0, $2aGBJ.useAppSelector)((state)=>state.appConfig.recaptchaEnterpriseScoreKeySite);
    const checkboxSitekey = (0, $2aGBJ.useAppSelector)((state)=>state.appConfig.recaptchaEnterpriseCheckboxKeySite);
    const enabled = captchaEnabledByConfig && enabledProp;
    const commonConfig = {
        pageId: pageId,
        enabled: enabled,
        action: action
    };
    const scoreConfig = (0, $b2I6k._)((0, $1Fos3._)({}, commonConfig), {
        sitekey: scoreSitekey,
        displayBadge: false
    });
    const checkboxConfig = (0, $b2I6k._)((0, $1Fos3._)({}, commonConfig), {
        sitekey: checkboxSitekey,
        action: action !== null && action !== void 0 ? action : 'unknown'
    });
    const policyConfig = (0, $b2I6k._)((0, $1Fos3._)({}, commonConfig), {
        sitekey: ''
    });
    switch(type){
        case 'score':
            return {
                type: type,
                config: scoreConfig
            };
        case 'checkbox':
            return {
                type: type,
                config: checkboxConfig
            };
        case 'policy':
            return {
                type: type,
                config: policyConfig
            };
        default:
            (0, $49Pnv.captureTaggedException)(new Error(`Unexpected captcha type: ${type}`), {
                capabilities: action === 'signup' ? [
                    'capability-group--signup'
                ] : [],
                tags: {
                    recaptcha: 'unexpected_captcha_type'
                }
            });
            return {
                type: type,
                config: (0, $b2I6k._)((0, $1Fos3._)({}, commonConfig), {
                    sitekey: '',
                    enabled: false
                })
            };
    }
}
const $fd41387fb9659e5c$var$handleCheckbox = (checkboxRecaptcha)=>{
    var _checkboxRecaptcha_error;
    const wrapToken = ()=>{
        return Promise.resolve({
            token: checkboxRecaptcha.token || '',
            type: 'checkbox',
            challengeKind: 'recaptcha'
        });
    };
    const isLoaded = checkboxRecaptcha.isLoaded;
    const enabled = checkboxRecaptcha === null || checkboxRecaptcha === void 0 ? void 0 : checkboxRecaptcha.enabled;
    var _checkboxRecaptcha_error_message;
    const errorMessage = (_checkboxRecaptcha_error_message = checkboxRecaptcha === null || checkboxRecaptcha === void 0 ? void 0 : (_checkboxRecaptcha_error = checkboxRecaptcha.error) === null || _checkboxRecaptcha_error === void 0 ? void 0 : _checkboxRecaptcha_error.message) !== null && _checkboxRecaptcha_error_message !== void 0 ? _checkboxRecaptcha_error_message : undefined;
    const component = checkboxRecaptcha.component;
    const onFetchToken = async ()=>{
        const response = await wrapToken();
        // TODO once the flag is cleaned up, the type of response will always be truthy so we can change the check to response.token === ''
        if ((!response || !response.token) && enabled) (0, $49Pnv.captureRecaptchaMessage)(errorMessage !== null && errorMessage !== void 0 ? errorMessage : 'no token returned from checkbox recaptcha', {}, 'no_token_checkbox');
        return response;
    };
    return {
        fetchToken: onFetchToken,
        isLoaded: isLoaded || false,
        enabled: enabled || false,
        errorMessage: errorMessage,
        component: component
    };
};
const $fd41387fb9659e5c$var$handleScore = (scoreRecaptcha, action)=>{
    const fetchAndWrapToken = (action)=>scoreRecaptcha.fetchRecaptchaToken(action).then((token)=>{
            return {
                token: token || '',
                type: 'score',
                challengeKind: 'recaptcha'
            };
        });
    const isLoaded = scoreRecaptcha.isLoaded;
    const enabled = scoreRecaptcha === null || scoreRecaptcha === void 0 ? void 0 : scoreRecaptcha.enabled;
    var _scoreRecaptcha_loadRecaptchaErrorReason;
    const errorMessage = (_scoreRecaptcha_loadRecaptchaErrorReason = scoreRecaptcha === null || scoreRecaptcha === void 0 ? void 0 : scoreRecaptcha.loadRecaptchaErrorReason) !== null && _scoreRecaptcha_loadRecaptchaErrorReason !== void 0 ? _scoreRecaptcha_loadRecaptchaErrorReason : undefined;
    const onFetchToken = async ()=>{
        const response = await fetchAndWrapToken(action);
        // TODO once the flag is cleaned up, the type of response will always be truthy so we can change the check to response.token === ''
        if ((!response || !response.token) && enabled) (0, $49Pnv.captureRecaptchaMessage)(errorMessage !== null && errorMessage !== void 0 ? errorMessage : 'no token returned from score recaptcha', {}, 'no_token_score');
        return response;
    };
    return {
        fetchToken: onFetchToken,
        isLoaded: isLoaded || false,
        enabled: enabled || false,
        errorMessage: errorMessage
    };
};

});
parcelRegister("aY5EN", function(module, exports) {

$parcel$export(module.exports, "useCheckboxRecaptcha", function () { return $07f810a4866efebe$export$25db2ae7b91eff3b; });

var $1Fos3 = parcelRequire("1Fos3");

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $1uBou = parcelRequire("1uBou");

var $49Pnv = parcelRequire("49Pnv");

var $1V2cH = parcelRequire("1V2cH");

var $c7m3x = parcelRequire("c7m3x");
const $07f810a4866efebe$export$25db2ae7b91eff3b = (config)=>{
    const [instanceId, setInstanceId] = (0, $91i6m.useState)();
    const [token, setToken] = (0, $91i6m.useState)('');
    const [isLoaded, setIsLoaded] = (0, $91i6m.useState)(false);
    const [isExpired, setIsExpired] = (0, $91i6m.useState)(false);
    const [error, setError] = (0, $91i6m.useState)();
    const { sitekey: sitekey, action: action, enabled: enabled, pageId: pageId } = config;
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const scriptLogic = (0, $1uBou.useCheckboxRecaptchaScripts)();
    const sendTrackingEvent = (0, $91i6m.useCallback)((action, errorType)=>{
        analyticsClient.trackingEvent((0, $1Fos3._)({
            page: pageId,
            action: action,
            subject: 'checkbox-recaptcha'
        }, errorType && {
            attributes: {
                hasError: true,
                errorName: errorType
            }
        }));
    }, [
        analyticsClient,
        pageId
    ]);
    const handleVerify = (0, $91i6m.useCallback)((newToken)=>{
        setToken(newToken);
        setIsExpired(false);
        sendTrackingEvent('checkbox-completed');
    }, [
        sendTrackingEvent
    ]);
    const handleExpire = (0, $91i6m.useCallback)(()=>{
        setToken('');
        setIsExpired(true);
        sendTrackingEvent('expired-callback', 'recaptcha-script-error');
    }, [
        sendTrackingEvent
    ]);
    const handleError = (0, $91i6m.useCallback)(()=>{
        const newError = (0, $c7m3x.RecaptchaError).fromMessage('Failed to load recaptcha script');
        setError(newError);
        (0, $49Pnv.captureRecaptchaException)(newError, {}, 'no_token_checkbox');
        sendTrackingEvent('error-callback', 'recaptcha-script-error');
    }, [
        sendTrackingEvent
    ]);
    const handleOnLoad = (0, $91i6m.useCallback)(()=>{
        sendTrackingEvent('loaded-recaptcha');
        setIsLoaded(true);
    }, [
        sendTrackingEvent
    ]);
    // This callback is used for rendering recaptcha into the ref associated HTML Element.
    // The recaptcha script is loaded, if not done already, and then rendered.
    const refCallback = (0, $91i6m.useCallback)(async (node)=>{
        if (!node) return;
        try {
            // Dynamically loads the recaptcha script when needed.
            await scriptLogic.injectRecaptchaScript();
            handleOnLoad();
            // Renders the recaptcha component into the given node.
            const newInstanceId = scriptLogic.getRecaptchaMethods().render(node, {
                sitekey: sitekey,
                action: action,
                callback: handleVerify,
                'expired-callback': handleExpire,
                'error-callback': handleError
            });
            setInstanceId(newInstanceId);
        } catch (error) {
            const newError = (0, $c7m3x.RecaptchaError).fromMessage('Failed to load recaptcha script');
            setError(newError);
            (0, $49Pnv.captureRecaptchaException)(newError, {}, 'no_token_checkbox');
            sendTrackingEvent('load-recaptcha-failed', 'recaptcha-window-error');
        }
    }, [
        scriptLogic,
        handleOnLoad,
        sitekey,
        action,
        handleVerify,
        handleExpire,
        handleError,
        sendTrackingEvent
    ]);
    const component = (0, $91i6m.useMemo)(()=>enabled ? /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
            id: "checkbox-recaptcha-hook",
            ref: refCallback
        }) : null, [
        enabled,
        refCallback
    ]);
    const reset = (0, $91i6m.useCallback)(()=>{
        if (instanceId === undefined) return;
        scriptLogic.getRecaptchaMethods().reset(instanceId);
        setToken('');
        setIsLoaded(false);
        setIsExpired(false);
    }, [
        instanceId,
        scriptLogic
    ]);
    const getResponse = (0, $91i6m.useCallback)(()=>{
        return instanceId !== undefined ? scriptLogic.getRecaptchaMethods().getResponse(instanceId) : '';
    }, [
        instanceId,
        scriptLogic
    ]);
    return {
        component: component,
        reset: reset,
        token: token,
        error: error,
        getResponse: getResponse,
        enabled: enabled,
        isLoaded: isLoaded,
        isExpired: isExpired
    };
};

});
parcelRegister("1uBou", function(module, exports) {

$parcel$export(module.exports, "useScoreRecaptchaScripts", function () { return $d1b1d46ed453d5b9$export$4b37d6e6c5707b8a; });
$parcel$export(module.exports, "useCheckboxRecaptchaScripts", function () { return $d1b1d46ed453d5b9$export$b48db21c95021cdf; });

var $49Pnv = parcelRequire("49Pnv");

var $91i6m = parcelRequire("91i6m");

var $c7m3x = parcelRequire("c7m3x");
const $d1b1d46ed453d5b9$var$RECAPTCHA_SCRIPT_DOMAIN = 'www.recaptcha.net';
const $d1b1d46ed453d5b9$var$FAIL_LOAD_CAPTCHA_ERROR_MESSAGE = 'Failed to load grecaptcha enterprise.';
const $d1b1d46ed453d5b9$export$3bfe7d4134a81119 = ()=>{
    var _window_grecaptcha;
    return (_window_grecaptcha = window.grecaptcha) === null || _window_grecaptcha === void 0 ? void 0 : _window_grecaptcha.enterprise;
};
/**
 * Loads the reCAPTCHA script if it hasn't been loaded already.
 *
 * Loading states:
 *  0. Script <src> element does not exist on the DOM.
 *  1. Script is asynchronously downloading and the reCAPTCHA methods are not available yet.
 *  2. Script has been downloaded and a 'load' event is fired for the DOM element and the reCAPTCHA methods are now available.
 *  3. Google fires a 'ready' event when the reCAPTCHA methods are available.
 *      Recaptcha can be considered to be fully ready to use at this point.
 *  4. Extra dependencies and scripts are downloaded asynchronously.
 *      This extra step should not be relevant to checkbox or score, but may be relevant for invisible.
 */ // Keep a track of all loaded scripts so the promise can be re-used by different React components/hooks:
const $d1b1d46ed453d5b9$var$scriptCache = new Map();
const $d1b1d46ed453d5b9$export$62fae4128d19343d = (scriptId)=>$d1b1d46ed453d5b9$var$scriptCache.delete(scriptId);
const $d1b1d46ed453d5b9$export$c80de0a5a6afcd7c = async (scriptId, scriptSrc)=>{
    let scriptPromise = $d1b1d46ed453d5b9$var$scriptCache.get(scriptId);
    if (!scriptPromise) {
        scriptPromise = new Promise((resolve, reject)=>{
            const scriptElement = document.createElement('script');
            scriptElement.id = scriptId;
            scriptElement.src = `https://${$d1b1d46ed453d5b9$var$RECAPTCHA_SCRIPT_DOMAIN}${scriptSrc}`;
            scriptElement.async = true;
            scriptElement.defer = true;
            scriptElement.addEventListener('load', ()=>{
                if (window && window.grecaptcha && window.grecaptcha.enterprise) // reCAPTCHA script was injected and library 'finished' loading once ready() completes
                $d1b1d46ed453d5b9$export$3bfe7d4134a81119().ready(()=>resolve());
                else {
                    (0, $49Pnv.captureErrorMessage)($d1b1d46ed453d5b9$var$FAIL_LOAD_CAPTCHA_ERROR_MESSAGE);
                    reject((0, $c7m3x.RecaptchaError).fromMessage($d1b1d46ed453d5b9$var$FAIL_LOAD_CAPTCHA_ERROR_MESSAGE));
                }
            });
            // investigate - error undefined
            scriptElement.addEventListener('error', (errorEvent)=>{
                (0, $49Pnv.captureException)(errorEvent.error);
                reject((0, $c7m3x.RecaptchaError).fromError(errorEvent.error || new Error($d1b1d46ed453d5b9$var$FAIL_LOAD_CAPTCHA_ERROR_MESSAGE)));
            });
            document.head.appendChild(scriptElement);
        });
        $d1b1d46ed453d5b9$var$scriptCache.set(scriptId, scriptPromise);
    }
    return scriptPromise;
};
const $d1b1d46ed453d5b9$export$a0a588829684d44 = (scriptId)=>{
    const script = document.getElementById(scriptId);
    return script !== null;
};
const $d1b1d46ed453d5b9$export$924e44702e93d253 = (scriptId)=>{
    const id = `${scriptId}-styles`;
    if (document.getElementById(id)) return;
    const styleElement = document.createElement('style');
    styleElement.id = id;
    styleElement.innerText = '.grecaptcha-badge { visibility: hidden; }';
    document.head.appendChild(styleElement);
};
const $d1b1d46ed453d5b9$export$684246aaf6783333 = (scriptId)=>{
    const scriptElement = document.getElementById(scriptId);
    if (scriptElement) scriptElement.remove();
};
const $d1b1d46ed453d5b9$export$42b99ab155dad274 = (scriptId)=>{
    const styleElement = document.getElementById(`${scriptId}-styles`);
    if (styleElement) styleElement.remove();
};
const $d1b1d46ed453d5b9$export$f124d412b77f93b3 = ()=>{
    document.querySelectorAll('.grecaptcha-badge').forEach((element)=>element.remove());
};
const $d1b1d46ed453d5b9$export$4b37d6e6c5707b8a = ({ sitekey: sitekey })=>{
    const scriptSrc = `/recaptcha/enterprise.js?render=${sitekey}`;
    return (0, $91i6m.useMemo)(()=>({
            injectRecaptchaScript: ()=>$d1b1d46ed453d5b9$export$c80de0a5a6afcd7c(sitekey, scriptSrc),
            getRecaptchaMethods: ()=>$d1b1d46ed453d5b9$export$3bfe7d4134a81119(),
            hideRecaptchaBadge: ()=>$d1b1d46ed453d5b9$export$924e44702e93d253(sitekey),
            unloadRecaptcha () {
                $d1b1d46ed453d5b9$export$684246aaf6783333(sitekey);
                $d1b1d46ed453d5b9$export$42b99ab155dad274(sitekey);
                $d1b1d46ed453d5b9$export$f124d412b77f93b3();
                $d1b1d46ed453d5b9$export$62fae4128d19343d(sitekey);
            }
        }), [
        sitekey,
        scriptSrc
    ]);
};
const $d1b1d46ed453d5b9$export$b48db21c95021cdf = ()=>{
    const scriptId = 'checkbox-recaptcha';
    const scriptSrc = '/recaptcha/enterprise.js?render=explicit';
    return (0, $91i6m.useMemo)(()=>({
            injectRecaptchaScript: ()=>$d1b1d46ed453d5b9$export$c80de0a5a6afcd7c(scriptId, scriptSrc),
            getRecaptchaMethods: ()=>$d1b1d46ed453d5b9$export$3bfe7d4134a81119()
        }), []);
};

});
parcelRegister("c7m3x", function(module, exports) {

$parcel$export(module.exports, "RecaptchaError", function () { return $d54c95a9295aefb7$export$e037dc82f45cc746; });
class $d54c95a9295aefb7$export$e037dc82f45cc746 extends Error {
    static fromError(error) {
        const instance = new $d54c95a9295aefb7$export$e037dc82f45cc746(error.message);
        instance.stack = error.stack;
        return instance;
    }
    static fromMessage(message) {
        const instance = new $d54c95a9295aefb7$export$e037dc82f45cc746(message);
        instance.stack = new Error().stack;
        return instance;
    }
    constructor(message){
        super(message);
        this.name = 'RecaptchaError';
    }
}

});



parcelRegister("erh2U", function(module, exports) {

$parcel$export(module.exports, "useScoreRecaptcha", function () { return $23231c7e046cbc39$export$afce2c1d72c48fc5; });

var $1Fos3 = parcelRequire("1Fos3");

var $91i6m = parcelRequire("91i6m");

var $1V2cH = parcelRequire("1V2cH");

var $49Pnv = parcelRequire("49Pnv");

var $1uBou = parcelRequire("1uBou");

var $c7m3x = parcelRequire("c7m3x");
const $23231c7e046cbc39$var$RECAPTCHA_ENTERPRISE_EXECUTE_UNAVAILABLE = 'Failed to invoke grecaptcha execute function as it is not ready.';
const $23231c7e046cbc39$export$afce2c1d72c48fc5 = (config)=>{
    const [loadRecaptchaErrorReason, setLoadRecaptchaErrorReason] = (0, $91i6m.useState)();
    const [isLoaded, setIsLoaded] = (0, $91i6m.useState)(false);
    const scriptInitializationRef = (0, $91i6m.useRef)();
    const { sitekey: sitekey, enabled: enabled, displayBadge: displayBadge = false, pageId: pageId } = config;
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const scriptLogic = (0, $1uBou.useScoreRecaptchaScripts)({
        sitekey: sitekey
    });
    const sendTrackingEvent = (0, $91i6m.useCallback)((action, errorType)=>{
        analyticsClient.trackingEvent((0, $1Fos3._)({
            page: pageId,
            action: action,
            subject: 'score-recaptcha'
        }, errorType && {
            attributes: {
                hasError: true,
                errorName: errorType
            }
        }));
    }, [
        analyticsClient,
        pageId
    ]);
    (0, $91i6m.useEffect)(()=>{
        if (!enabled) return;
        const initRecaptcha = async ()=>{
            try {
                await scriptLogic.injectRecaptchaScript();
                sendTrackingEvent('loaded-recaptcha');
                if (!displayBadge) scriptLogic.hideRecaptchaBadge();
                setIsLoaded(true);
            } catch (error) {
                const errorMessage = String(error);
                setLoadRecaptchaErrorReason(errorMessage);
                (0, $49Pnv.captureException)(error);
                sendTrackingEvent('load-recaptcha-failed', 'recaptcha-script-error');
            }
        };
        scriptInitializationRef.current = initRecaptcha();
        return ()=>{
            scriptLogic.unloadRecaptcha();
            setLoadRecaptchaErrorReason(undefined);
            scriptInitializationRef.current = undefined;
        };
    }, [
        displayBadge,
        sitekey,
        pageId,
        enabled,
        analyticsClient,
        sendTrackingEvent,
        scriptLogic
    ]);
    const fetchRecaptchaToken = (0, $91i6m.useCallback)(async (action)=>{
        var _window_grecaptcha_enterprise, _window_grecaptcha, _window;
        if (!enabled) return '';
        if (scriptInitializationRef.current) await scriptInitializationRef.current;
        if (!((_window = window) === null || _window === void 0 ? void 0 : (_window_grecaptcha = _window.grecaptcha) === null || _window_grecaptcha === void 0 ? void 0 : (_window_grecaptcha_enterprise = _window_grecaptcha.enterprise) === null || _window_grecaptcha_enterprise === void 0 ? void 0 : _window_grecaptcha_enterprise.execute)) {
            (0, $49Pnv.captureRecaptchaException)((0, $c7m3x.RecaptchaError).fromMessage($23231c7e046cbc39$var$RECAPTCHA_ENTERPRISE_EXECUTE_UNAVAILABLE), {}, 'no_token_score');
            sendTrackingEvent('get-recaptcha-token', 'recaptcha-window-error');
            return '';
        }
        try {
            return await window.grecaptcha.enterprise.execute(sitekey, {
                action: action
            });
        } catch (err) {
            (0, $49Pnv.captureRecaptchaException)((0, $c7m3x.RecaptchaError).fromError(err), {}, 'no_token_score');
            sendTrackingEvent('get-recaptcha-token', 'recaptcha-script-error');
            return '';
        }
    }, [
        enabled,
        sendTrackingEvent,
        sitekey
    ]);
    return {
        isLoaded: isLoaded,
        fetchRecaptchaToken: fetchRecaptchaToken,
        loadRecaptchaErrorReason: loadRecaptchaErrorReason,
        enabled: enabled
    };
};

});



parcelRegister("6eNI5", function(module, exports) {

$parcel$export(module.exports, "LoginTooManyAttemptsRecaptchaContextProvider", function () { return $7e5c617ff15320cb$export$b27cbe0302f9b08b; });
$parcel$export(module.exports, "useLoginTooManyAttemptsRecaptchaContext", function () { return $7e5c617ff15320cb$export$5c1b73ca6a070fab; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $2aGBJ = parcelRequire("2aGBJ");
const $7e5c617ff15320cb$export$d98a10b0f5602870 = /*#__PURE__*/ (0, $91i6m.createContext)(null);
const $7e5c617ff15320cb$export$b27cbe0302f9b08b = ({ children: children })=>{
    const [captchaValue, setCaptchaValue] = (0, $91i6m.useState)(null);
    const isRequired = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isCaptchaRequired;
    });
    const value = (0, $91i6m.useMemo)(()=>({
            isRequired: isRequired,
            captchaValue: captchaValue,
            setCaptchaValue: setCaptchaValue
        }), [
        captchaValue,
        setCaptchaValue,
        isRequired
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)($7e5c617ff15320cb$export$d98a10b0f5602870.Provider, {
        value: value,
        children: children
    });
};
const $7e5c617ff15320cb$export$5c1b73ca6a070fab = ()=>{
    const context = (0, $91i6m.useContext)($7e5c617ff15320cb$export$d98a10b0f5602870);
    if (!context) throw new Error('useLoginTooManyAttemptsRecaptchaContext must be used within a LoginTooManyAttemptsRecaptchaContextProvider');
    return context;
};

});

parcelRegister("h6aRF", function(module, exports) {
$parcel$export(module.exports, "useRegisterComponent", function () { return (parcelRequire("4PGUW")).useRegisterComponent; });
$parcel$export(module.exports, "PageOrchestrator", function () { return (parcelRequire("21dxG")).PageOrchestrator; });
$parcel$export(module.exports, "useShouldOrchestrate", function () { return (parcelRequire("ceIrb")).useShouldOrchestrate; });
parcelRequire("4PGUW");
parcelRequire("1A2bq");
parcelRequire("21dxG");
parcelRequire("d67cs");

});
parcelRegister("4PGUW", function(module, exports) {

$parcel$export(module.exports, "AdvancedCobrandingContext", function () { return $a83ddee780ae869d$export$5253ee94c7927efc; });
$parcel$export(module.exports, "useAdvancedCobrandingContext", function () { return $a83ddee780ae869d$export$12168a8568483640; });
$parcel$export(module.exports, "useRegisterComponent", function () { return $a83ddee780ae869d$export$24eaf8ff4dcf9c58; });

var $91i6m = parcelRequire("91i6m");
const $a83ddee780ae869d$export$5253ee94c7927efc = (0, $91i6m.createContext)(undefined);
const $a83ddee780ae869d$export$12168a8568483640 = ()=>{
    const context = (0, $91i6m.useContext)($a83ddee780ae869d$export$5253ee94c7927efc);
    if (!context) throw new Error('useAdvancedCobrandingContext used outside of AdvancedCobrandingContext');
    return context;
};
const $a83ddee780ae869d$export$24eaf8ff4dcf9c58 = (name)=>{
    const registered = (0, $91i6m.useRef)(false);
    const context = (0, $91i6m.useContext)($a83ddee780ae869d$export$5253ee94c7927efc);
    (0, $91i6m.useEffect)(()=>{
        if (registered.current) return;
        if (!context) return;
        registered.current = true;
        context.registerComponent(name);
    }, [
        context,
        name
    ]);
};

});

parcelRegister("1A2bq", function(module, exports) {

});

parcelRegister("21dxG", function(module, exports) {

$parcel$export(module.exports, "PageOrchestrator", function () { return $126e37a26cbc23db$export$ab5ed25a9459596a; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6IwzG = parcelRequire("6IwzG");

var $1V2cH = parcelRequire("1V2cH");

var $4PGUW = parcelRequire("4PGUW");

var $d55RL = parcelRequire("d55RL");

var $3jGGb = parcelRequire("3jGGb");
const $126e37a26cbc23db$export$ab5ed25a9459596a = ({ fallback: fallback, pages: pages, requiredComponents: requiredComponents })=>{
    const [registrationStarted, setRegistrationStarted] = (0, $91i6m.useState)(false);
    const [components, setComponents] = (0, $91i6m.useState)();
    const { cobranding: cobranding } = (0, $6IwzG.useCobranding)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const page = (0, $91i6m.useMemo)(()=>{
        return pages.find((page)=>page.cobranding === cobranding);
    }, [
        pages,
        cobranding
    ]);
    const Component = (0, $91i6m.useMemo)(()=>{
        return (page === null || page === void 0 ? void 0 : page.Component) || fallback;
    }, [
        page,
        fallback
    ]);
    // The fallback is the base page. This occurs when there is a cobranding defined, but not for the page that the user is requesting
    const isUsingFallback = !(page === null || page === void 0 ? void 0 : page.Component);
    const registerComponent = (0, $91i6m.useCallback)((component)=>{
        setComponents((components)=>{
            return components ? [
                ...components,
                component
            ] : [
                component
            ];
        });
    }, []);
    const value = (0, $91i6m.useMemo)(()=>({
            components: components,
            registerComponent: registerComponent
        }), [
        components,
        registerComponent
    ]);
    (0, $91i6m.useEffect)(()=>{
        setTimeout(()=>setRegistrationStarted(true), 0);
    }, []);
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4PGUW.AdvancedCobrandingContext).Provider, {
        value: value,
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $d55RL.PageGuard), {
            requiredComponents: requiredComponents,
            registrationStarted: registrationStarted,
            skipRequiredChecks: isUsingFallback,
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $3jGGb.default), {
                analyticsClient: analyticsClient,
                capabilities: [
                    'non-kirby-code'
                ],
                skipAnalytics: true,
                children: /*#__PURE__*/ (0, $4ZSso.jsx)(Component, {})
            })
        })
    });
};

});
parcelRegister("d55RL", function(module, exports) {

$parcel$export(module.exports, "PageGuard", function () { return $c86123a08353b2a4$export$c2e3d7bea8403012; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6IwzG = parcelRequire("6IwzG");

var $4PGUW = parcelRequire("4PGUW");

var $9OWP7 = parcelRequire("9OWP7");

var $49Pnv = parcelRequire("49Pnv");
const $c86123a08353b2a4$export$a303b4f7b8d504d8 = 2000;
/**
 * Whether or not to show the missing component error overlay. We do not want to show this in production (to real users).
 * The overlay is for developers to see the missing components and debug the issue
 */ const $c86123a08353b2a4$var$canShowOverlay = false;
const $c86123a08353b2a4$export$c2e3d7bea8403012 = ({ children: children, requiredComponents: requiredComponents, registrationStarted: registrationStarted, skipRequiredChecks: skipRequiredChecks = false })=>{
    const { cobranding: cobranding } = (0, $6IwzG.useCobranding)();
    const { components: components } = (0, $4PGUW.useAdvancedCobrandingContext)();
    const [registrationTimedOut, setRegistrationTimedOut] = (0, $91i6m.useState)(false);
    const missingComponents = (0, $91i6m.useMemo)(()=>{
        return requiredComponents.filter((requiredComponent)=>!(components === null || components === void 0 ? void 0 : components.includes(requiredComponent)));
    }, [
        requiredComponents,
        components
    ]);
    (0, $91i6m.useEffect)(()=>{
        if (!registrationStarted) return;
        const timeout = setTimeout(()=>{
            setRegistrationTimedOut(true);
        }, $c86123a08353b2a4$export$a303b4f7b8d504d8);
        return ()=>clearTimeout(timeout);
    }, [
        registrationStarted
    ]);
    const hasRegisteredAllRequiredComponents = missingComponents.length === 0;
    const isWaitingForRegistration = !registrationTimedOut;
    (0, $91i6m.useEffect)(()=>{
        if (!hasRegisteredAllRequiredComponents && !isWaitingForRegistration && !$c86123a08353b2a4$var$canShowOverlay) console.warn(`[COBRANDING] ${window.location.pathname} has not registered all required components.`);
    }, [
        cobranding,
        hasRegisteredAllRequiredComponents,
        isWaitingForRegistration
    ]);
    // skipRequiredChecks:
    // We want to skip these checks if we are using a fallback (i.e. a base page/non cobranded page) and we do not want to
    // enforce the required components. This is at least until we either audit all of the fallback pages, or we start
    // dogfooding the cobranding orchestrator in our base pages, to ensure that we are not breaking any pages.
    // hasRegisteredAllRequiredComponents:
    // If all required components have been registered, we can safely render the children without any further checks.
    if (skipRequiredChecks || hasRegisteredAllRequiredComponents) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $91i6m.Suspense), {
        fallback: /*#__PURE__*/ (0, $4ZSso.jsx)($c86123a08353b2a4$var$LoadingOverlay, {}),
        children: /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
            style: {
                height: '100%'
            },
            "data-testid": "registration-complete",
            children: children
        })
    });
    if (isWaitingForRegistration) // Displays the loading overlay while the page is lazy-loading and while the registration is in progress.
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $91i6m.Suspense), {
        fallback: /*#__PURE__*/ (0, $4ZSso.jsx)($c86123a08353b2a4$var$LoadingOverlay, {}),
        children: [
            children,
            /*#__PURE__*/ (0, $4ZSso.jsx)($c86123a08353b2a4$var$LoadingOverlay, {})
        ]
    });
    // This handles the case where the registration has timed out and the required components are still not registered
    return /*#__PURE__*/ (0, $4ZSso.jsx)($c86123a08353b2a4$var$PageGuardMissingComponent, {
        canShowOverlay: $c86123a08353b2a4$var$canShowOverlay,
        missingComponents: missingComponents,
        children: children
    });
};
/**
 * Responsible for rendering the children component (which is either the cobranded page or the fallback/non-cobranded/default/base page)
 * and checking that the page includes the components that the relevant page level cobranded config declares that it needs
 * When running locally, it also renders details of the missing components to let the developers know as well as aid with debugging the issue.
 * In production we do not show this to the user.
 * In all cases, we render the children despite it missing some details as a fallback.
 *
 * @note We send an event to Sentry in the case that this component is rendered, because we should _not_ see this in customer facing code.
 */ const $c86123a08353b2a4$var$PageGuardMissingComponent = ({ children: children, canShowOverlay: canShowOverlay, missingComponents: missingComponents })=>{
    const { cobranding: cobranding } = (0, $6IwzG.useCobranding)();
    // Generating here so that cobranding does not become a dependency of the useEffect. errorMessage will be, but it won't run again unless the string itself has changed.
    const errorMessage = `Cobranding experience missing required components after registration waiting period ${cobranding}`;
    (0, $91i6m.useEffect)(()=>{
        // If we get to this point, it means that after waiting for REGISTRATION_TIMEOUT_MS the required components are still not present
        (0, $49Pnv.captureTaggedException)(new Error(errorMessage), {
            capabilities: [
                'non-kirby-code'
            ],
            tags: {
                cobrandingOrchestrator: 'missing_required_components'
            }
        });
    }, [
        errorMessage
    ]);
    if (canShowOverlay) return /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
        "data-testid": "registration-complete",
        children: /*#__PURE__*/ (0, $4ZSso.jsx)($c86123a08353b2a4$var$MissingComponentErrorDisplay, {
            cobranding: cobranding,
            missingComponents: missingComponents,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $91i6m.Suspense), {
        fallback: /*#__PURE__*/ (0, $4ZSso.jsx)($c86123a08353b2a4$var$LoadingOverlay, {}),
        children: /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
            style: {
                height: '100%'
            },
            "data-testid": "registration-complete",
            children: children
        })
    });
};
const $c86123a08353b2a4$var$MissingComponentErrorDisplay = ({ cobranding: cobranding, missingComponents: missingComponents, children: children })=>{
    const search = new URLSearchParams(window.location.search);
    search.delete('token');
    return /*#__PURE__*/ (0, $4ZSso.jsxs)("div", {
        style: {
            position: 'relative'
        },
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsxs)("div", {
                style: {
                    position: 'fixed',
                    zIndex: 100,
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '1rem',
                    alignItems: 'center',
                    justifyContent: 'center'
                },
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
                        style: {
                            position: 'fixed',
                            zIndex: -1,
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            opacity: 0.25,
                            backgroundColor: '#FFADB0'
                        }
                    }),
                    /*#__PURE__*/ (0, $4ZSso.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '1rem',
                            padding: '4rem',
                            borderRadius: '0.5rem',
                            background: '#FFADB0',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: 'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $4ZSso.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '0.25rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $4ZSso.jsx)("h2", {
                                        style: {
                                            fontWeight: 'bold'
                                        },
                                        children: "Advanced Cobranding"
                                    }),
                                    /*#__PURE__*/ (0, $4ZSso.jsx)("p", {
                                        children: "Unable to render page due to missing required components:"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
                                style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '0.1rem',
                                    padding: '1rem',
                                    borderRadius: '0.25rem',
                                    color: 'white',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: '#c92216'
                                },
                                children: missingComponents.map((component)=>/*#__PURE__*/ (0, $4ZSso.jsx)("p", {
                                        style: {
                                            margin: 0
                                        },
                                        children: /*#__PURE__*/ (0, $4ZSso.jsx)("span", {
                                            "data-testid": "missing-component",
                                            children: component
                                        })
                                    }, component))
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '0.25rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $4ZSso.jsxs)("p", {
                                        style: {
                                            margin: 0
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $4ZSso.jsx)("strong", {
                                                children: "Cobranding"
                                            }),
                                            ": ",
                                            cobranding
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4ZSso.jsxs)("p", {
                                        style: {
                                            margin: 0,
                                            display: 'flex',
                                            flexWrap: 'wrap'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $4ZSso.jsx)("strong", {
                                                children: "URL"
                                            }),
                                            ": ",
                                            `${window.location.pathname}?${search}`
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            children
        ]
    });
};
const $c86123a08353b2a4$var$LoadingOverlay = ()=>/*#__PURE__*/ (0, $4ZSso.jsx)("div", {
        style: {
            position: 'fixed',
            top: 0,
            zIndex: 2,
            pointerEvents: 'none',
            left: 0,
            right: 0,
            bottom: 0,
            flexDirection: 'column',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'white'
        },
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9OWP7.default), {})
    });

});


parcelRegister("d67cs", function(module, exports) {
$parcel$export(module.exports, "useShouldOrchestrate", function () { return (parcelRequire("ceIrb")).useShouldOrchestrate; });
parcelRequire("ceIrb");

});
parcelRegister("ceIrb", function(module, exports) {

$parcel$export(module.exports, "useShouldOrchestrate", function () { return $aeedbd6776550638$export$eab7ff4ea760bf6a; });

var $6IwzG = parcelRequire("6IwzG");
const $aeedbd6776550638$export$eab7ff4ea760bf6a = ()=>{
    const { cobranding: cobranding } = (0, $6IwzG.useCobranding)();
    const forceOrchestration = (0, $6IwzG.isAdvancedCobranding)(cobranding);
    return forceOrchestration;
};

});




parcelRegister("cs6gC", function(module, exports) {

$parcel$export(module.exports, "LoginMarketingConsent", function () { return $de2ebe89c2fc5034$export$7f3ec3ad6a2266d2; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $9jjaN = parcelRequire("9jjaN");

var $6e88g = parcelRequire("6e88g");

var $2aGBJ = parcelRequire("2aGBJ");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");

var $7452z = parcelRequire("7452z");

var $fxz8k = parcelRequire("fxz8k");
let $de2ebe89c2fc5034$var$_ = (t)=>t, $de2ebe89c2fc5034$var$t;
const $de2ebe89c2fc5034$var$StyledMarketingConsentWrapper = (0, $9jjaN.default).div($de2ebe89c2fc5034$var$t || ($de2ebe89c2fc5034$var$t = $de2ebe89c2fc5034$var$_`
  padding-top: ${0}px;
`), (0, $6e88g.gridSize)() * 2);
const $de2ebe89c2fc5034$export$7f3ec3ad6a2266d2 = ()=>{
    (0, $4PGUW.useRegisterComponent)($de2ebe89c2fc5034$export$7f3ec3ad6a2266d2.name);
    const config = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_marketingConsent;
        return (_state_marketingConsent = state.marketingConsent) === null || _state_marketingConsent === void 0 ? void 0 : _state_marketingConsent.config;
    });
    const isUsernameChecked = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isUsernameChecked;
    });
    const isV2UsernameChecked = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isV2UsernameChecked;
    });
    const { setMarketingConsent: setMarketingConsent } = (0, $7452z.useMarketingConsentContext)();
    if (!isUsernameChecked && !isV2UsernameChecked) return null;
    return /*#__PURE__*/ (0, $4ZSso.jsx)($de2ebe89c2fc5034$var$StyledMarketingConsentWrapper, {
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $fxz8k.default), {
            config: config,
            onConsentChange: setMarketingConsent
        })
    });
};

});
parcelRegister("7452z", function(module, exports) {

$parcel$export(module.exports, "MarketingConsentContextProvider", function () { return $92b9d05d69f85169$export$a01df84c5b0bda88; });
$parcel$export(module.exports, "useMarketingConsentContext", function () { return $92b9d05d69f85169$export$3bf9eae4cd157a8c; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");
const $92b9d05d69f85169$var$MarketingConsentContext = /*#__PURE__*/ (0, $91i6m.createContext)(null);
const $92b9d05d69f85169$export$a01df84c5b0bda88 = ({ children: children })=>{
    const [marketingConsent, setMarketingConsent] = (0, $91i6m.useState)(undefined);
    const value = (0, $91i6m.useMemo)(()=>({
            marketingConsent: marketingConsent,
            setMarketingConsent: setMarketingConsent
        }), [
        marketingConsent,
        setMarketingConsent
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)($92b9d05d69f85169$var$MarketingConsentContext.Provider, {
        value: value,
        children: children
    });
};
const $92b9d05d69f85169$export$3bf9eae4cd157a8c = ()=>{
    const context = (0, $91i6m.useContext)($92b9d05d69f85169$var$MarketingConsentContext);
    if (!context) throw new Error('useMarketingConsentContext must be used within MarketingConsentContextProvider');
    return context;
};

});

parcelRegister("fxz8k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96ac1354dda50b49$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $83IjZ = parcelRequire("83IjZ");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");

var $9jjaN = parcelRequire("9jjaN");

var $leG06 = parcelRequire("leG06");

var $fZMDU = parcelRequire("fZMDU");
parcelRequire("0wXBc");
var $buHgC = parcelRequire("buHgC");
let $96ac1354dda50b49$var$_ = (t)=>t, $96ac1354dda50b49$var$t;
const $96ac1354dda50b49$var$MarketingConsentWrapper = (0, $9jjaN.default).div($96ac1354dda50b49$var$t || ($96ac1354dda50b49$var$t = $96ac1354dda50b49$var$_`
  margin-top: ${0}px;
  div {
    align-items: flex-start;
  }
  [aria-label='checkboxIcon'] {
    margin-left: -8px;
    margin-top: -4px;
  }
  label {
    font-size: 12px;
    line-height: 16px;
    color: ${0};
  }
`), (0, $6e88g.gridSize)(), (0, $kLNLK).N300);
const $96ac1354dda50b49$var$MarketingConsentCheckbox = ({ className: className, config: config, forceShow: forceShow, onConsentChange: onConsentChange })=>{
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const previousConfig = (0, $buHgC.usePrevious)(config);
    const consentText = formatMessage((0, $fZMDU.default).marketingConsentPromptText);
    const notifyConsentChange = (0, $91i6m.useCallback)(()=>{
        let consent = {
            state: 'not_shown'
        };
        if (config && config.showCheckbox) consent = {
            state: 'unchecked',
            consentText: consentText
        };
        onConsentChange(consent);
    }, [
        config,
        consentText,
        onConsentChange
    ]);
    (0, $91i6m.useEffect)(()=>{
        notifyConsentChange();
    }, [
        notifyConsentChange
    ]);
    (0, $91i6m.useEffect)(()=>{
        if (previousConfig !== config) notifyConsentChange();
    }, [
        previousConfig,
        config,
        notifyConsentChange
    ]);
    const consentCheckboxChanged = (e)=>{
        const state = e.target.checked ? 'checked' : 'unchecked';
        onConsentChange({
            state: state,
            consentText: consentText
        });
    };
    if (!config || !config.showCheckbox && !forceShow) return null;
    return /*#__PURE__*/ (0, $4ZSso.jsx)($96ac1354dda50b49$var$MarketingConsentWrapper, {
        className: className,
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $83IjZ.default), {
            testId: "marketing-consent-checkbox",
            id: "marketing-consent-checkbox",
            label: consentText,
            onChange: consentCheckboxChanged
        })
    });
};
var $96ac1354dda50b49$export$2e2bcd8739ae039 = $96ac1354dda50b49$var$MarketingConsentCheckbox;

});
parcelRegister("83IjZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5de0fbd9d160b22e$export$2e2bcd8739ae039; });
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $5YM7L = parcelRequire("5YM7L");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $koa2c = parcelRequire("koa2c");

var $bb3nf = parcelRequire("bb3nf");

var $iZbpq = parcelRequire("iZbpq");
var $6tS2B = parcelRequire("6tS2B");
var $bc1Os = parcelRequire("bc1Os");
var $dnhDS = parcelRequire("dnhDS");
var $5de0fbd9d160b22e$var$_excluded = [
    "isChecked",
    "isDisabled",
    "isInvalid",
    "defaultChecked",
    "isIndeterminate",
    "onChange",
    "analyticsContext",
    "label",
    "name",
    "value",
    "isRequired",
    "testId",
    "xcss",
    "className"
];
/**
 * Using `cssMap` to avoid a Compiled bug with the transformed styles.
 * It was using a CSS variable for the outline template string,
 * which broke because of the use of a sibling selector.
 *
 * Related to: https://github.com/atlassian-labs/compiled/pull/1795
 *
 * Using `cssMap` seems to be a workaround for this.
 */ var $5de0fbd9d160b22e$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef78r4n _1h6r8r4n _smzgj3jf _1dk7j3jf _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
};
/**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ var $5de0fbd9d160b22e$var$Checkbox = /*#__PURE__*/ (0, $91i6m.memo)(/*#__PURE__*/ (0, $91i6m.forwardRef)(function Checkbox(_ref, ref) {
    var isCheckedProp = _ref.isChecked, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isInvalid = _ref.isInvalid, isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid, _ref$defaultChecked = _ref.defaultChecked, defaultChecked = _ref$defaultChecked === void 0 ? false : _ref$defaultChecked, _ref$isIndeterminate = _ref.isIndeterminate, isIndeterminate = _ref$isIndeterminate === void 0 ? false : _ref$isIndeterminate, onChangeProps = _ref.onChange, analyticsContext = _ref.analyticsContext, label = _ref.label, name = _ref.name, value = _ref.value, isRequired = _ref.isRequired, testId = _ref.testId, xcss = _ref.xcss, className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $5de0fbd9d160b22e$var$_excluded);
    var _useState = (0, $91i6m.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), isCheckedState = _useState2[0], setIsCheckedState = _useState2[1];
    var onChange = (0, $91i6m.useCallback)(function(e, analyticsEvent) {
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    var onChangeAnalytics = (0, $koa2c.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "@atlaskit/checkbox",
        packageVersion: "17.1.13"
    });
    var internalRef = (0, $91i6m.useRef)(null);
    var mergedRefs = (0, $bb3nf.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    var isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $91i6m.useEffect)(function() {
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ $91i6m.createElement((0, $6tS2B.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? "".concat(rest.id, "-label") : undefined,
        testId: testId && "".concat(testId, "--checkbox-label"),
        xcss: xcss
    }, /*#__PURE__*/ $91i6m.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0
    }, rest, {
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9gzWK.default)([
            $5de0fbd9d160b22e$var$checkboxStyles.root,
            className
        ]),
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && "".concat(testId, "--hidden-checkbox"),
        "data-invalid": isInvalid ? 'true' : undefined
    })), /*#__PURE__*/ $91i6m.createElement((0, $iZbpq.default), {
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ $91i6m.createElement((0, $bc1Os.default), null, label, isRequired && /*#__PURE__*/ $91i6m.createElement((0, $dnhDS.default), null)));
}));
$5de0fbd9d160b22e$var$Checkbox.displayName = 'Checkbox';
var $5de0fbd9d160b22e$export$2e2bcd8739ae039 = $5de0fbd9d160b22e$var$Checkbox;

});
parcelRegister("iZbpq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd26c6167f7efb94$export$2e2bcd8739ae039; });
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");


var $aQG8A = parcelRequire("aQG8A");

var $f1k1y = parcelRequire("f1k1y");
function $dd26c6167f7efb94$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $f1k1y.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ $91i6m.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ $91i6m.createElement("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $f1k1y.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ $91i6m.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ $91i6m.createElement("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ var $dd26c6167f7efb94$var$CheckboxIcon = /*#__PURE__*/ (0, $91i6m.memo)(function(_ref) {
    var isIndeterminate = _ref.isIndeterminate, isChecked = _ref.isChecked;
    var icon = (0, $91i6m.useMemo)(function() {
        return $dd26c6167f7efb94$var$getIcon(isIndeterminate, isChecked);
    }, [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ $91i6m.createElement((0, $aQG8A.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, /*#__PURE__*/ $91i6m.createElement("g", {
        fillRule: "evenodd"
    }, // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $f1k1y.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ $91i6m.createElement("rect", {
        fill: "currentColor",
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5"
    }) : /*#__PURE__*/ $91i6m.createElement("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $dd26c6167f7efb94$export$2e2bcd8739ae039 = $dd26c6167f7efb94$var$CheckboxIcon;

});
parcelRegister("aQG8A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e5f72563c388a31$export$2e2bcd8739ae039; });
/* svg.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");
var $7e5f72563c388a31$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
var $7e5f72563c388a31$var$svgStyles = null;
/**
 * __SVG__
 *
 * @deprecated Custom SVG is deprecated and will be removed from `atlaskit/icon` in an upcoming major release. Please use either an existing icon from @atlaskit/icon or @atlaskit/icon-lab, or contributing to @atlaskit/icon-lab directly. For third party logos, use an SVG element along with a label.
 *
 * An icon is used as a visual representation of common actions and commands to provide context.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-svgs)
 */ var $7e5f72563c388a31$var$SVG = /*#__PURE__*/ (0, $91i6m.memo)(function SVG(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 'medium' : _ref$size, label = _ref.label, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, testId = _ref.testId, children = _ref.children;
    return /*#__PURE__*/ $91i6m.createElement("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            fill: secondaryColor
        },
        "data-testid": testId,
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $9gzWK.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw _vc881r31",
            $7e5f72563c388a31$var$sizeStyles[size]
        ])
    }, children);
});
var $7e5f72563c388a31$export$2e2bcd8739ae039 = $7e5f72563c388a31$var$SVG;

});


parcelRegister("6tS2B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0137bb567be00b22$export$2e2bcd8739ae039; });
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");
var $5oJNc = parcelRequire("5oJNc");

var $hLQD3 = parcelRequire("hLQD3");
var $0137bb567be00b22$var$baseStyles = null;
var $0137bb567be00b22$var$textLabelLayoutStyles = null;
var $0137bb567be00b22$var$disabledStyles = null;
var $0137bb567be00b22$var$labelStyles = null;
function $0137bb567be00b22$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, testId = _ref.testId, label = _ref.label, id = _ref.id, xcss = _ref.xcss;
    return /*#__PURE__*/ $91i6m.createElement("label", {
        className: (0, $9gzWK.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazovqm _80om73ad",
            label && "_zulp1te3 _yv0ey09t",
            isDisabled && "_syaz7wap _80om13gf",
            "_h5e31kd8 _1nzs1kc0 _1esz1j4g _yp0j1ehr _ay2w1ouc _d51u12ci _phftddza _1g1fe69j _l6wk1j4g _1dik1ehr _1sfg1380 _fpdj1ouc _1yjc3zdg _oaj1ddza _1j3h1380 _eawbxz7c _1rdaeh7q _18q0snw8 _13hr1j28",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        style: {
            "--_5xk3r4": (0, $5oJNc.default)("var(--ds-text, ".concat((0, $hLQD3.N900), ")")),
            "--_1l71759": (0, $5oJNc.default)("var(--ds-space-0, 0px)".concat(" ", "var(--ds-space-050, 4px)")),
            "--_1ynhf1h": (0, $5oJNc.default)("var(--ds-text-disabled, ".concat((0, $hLQD3.N80), ")")),
            "--_4mkb4g": (0, $5oJNc.default)("var(--ds-background-input, ".concat((0, $hLQD3.N10), ")")),
            "--_1cd0fcx": (0, $5oJNc.default)("var(--ds-background-input-pressed, ".concat((0, $hLQD3.B50), ")")),
            "--_1gcp7nr": (0, $5oJNc.default)("var(--ds-background-selected-bold, ".concat((0, $hLQD3.B400), ")")),
            "--_14y1fod": (0, $5oJNc.default)("var(--ds-background-selected-bold-hovered, ".concat((0, $hLQD3.B300), ")")),
            "--_r5pknd": (0, $5oJNc.default)("var(--ds-background-disabled, ".concat((0, $hLQD3.N20), ")")),
            "--_1z08gfx": (0, $5oJNc.default)("var(--ds-background-input-hovered, ".concat((0, $hLQD3.N30), ")")),
            "--_vnm8xo": (0, $5oJNc.default)("var(--ds-border-input, ".concat((0, $hLQD3.N100), ")")),
            "--_rczcge": (0, $5oJNc.default)("var(--ds-border, ".concat((0, $hLQD3.B50), ")")),
            "--_1i4xulb": (0, $5oJNc.default)("var(--ds-border-danger, ".concat((0, $hLQD3.R300), ")")),
            "--_xjqa3d": (0, $5oJNc.default)("var(--ds-border-focused, ".concat((0, $hLQD3.B200), ")")),
            "--_uq1ko9": (0, $5oJNc.default)("var(--ds-icon-inverse, ".concat((0, $hLQD3.B400), ")")),
            "--_jf353p": (0, $5oJNc.default)("var(--ds-icon-inverse, ".concat((0, $hLQD3.N10), ")")),
            "--_1xmcmw9": (0, $5oJNc.default)("var(--ds-icon-disabled, ".concat((0, $hLQD3.N70), ")"))
        }
    }, children);
}

});
parcelRegister("hLQD3", function(module, exports) {

$parcel$export(module.exports, "R300", function () { return $ceffa6770a29f492$export$4a7404f376229999; });
$parcel$export(module.exports, "R500", function () { return $ceffa6770a29f492$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "B50", function () { return $ceffa6770a29f492$export$226de0355ed012f8; });
$parcel$export(module.exports, "B200", function () { return $ceffa6770a29f492$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $ceffa6770a29f492$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $ceffa6770a29f492$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "N10", function () { return $ceffa6770a29f492$export$e655ef011c4aa1a2; });
$parcel$export(module.exports, "N20", function () { return $ceffa6770a29f492$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $ceffa6770a29f492$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N70", function () { return $ceffa6770a29f492$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N80", function () { return $ceffa6770a29f492$export$eaa8c8a70ac22806; });
$parcel$export(module.exports, "N100", function () { return $ceffa6770a29f492$export$d6447c357493214f; });
$parcel$export(module.exports, "N900", function () { return $ceffa6770a29f492$export$fbda843f0a27fe96; });
// Reds
var $ceffa6770a29f492$export$4b84fd0e2c617bd = '#FFEBE6';
var $ceffa6770a29f492$export$b34b069eff244586 = '#FFBDAD';
var $ceffa6770a29f492$export$be802dd0d8b57f35 = '#FF8F73';
var $ceffa6770a29f492$export$60847d42f9da92a6 = '#FF7452';
var $ceffa6770a29f492$export$4a7404f376229999 = '#FF5630';
var $ceffa6770a29f492$export$2010d0fb4295b346 = '#DE350B';
var $ceffa6770a29f492$export$2837b5a1a71d5c02 = '#BF2600';
var $ceffa6770a29f492$export$8d9596b529bbb9cf = '#FFFAE6';
var $ceffa6770a29f492$export$41060a744ab0b7ae = '#FFF0B3';
var $ceffa6770a29f492$export$1cc05bbbf340e559 = '#FFE380';
var $ceffa6770a29f492$export$5aae31392d72caaa = '#FFC400';
var $ceffa6770a29f492$export$c6930421db9fa514 = '#FFAB00';
var $ceffa6770a29f492$export$59619663aa6500fb = '#FF991F';
var $ceffa6770a29f492$export$874739ea9e379ab6 = '#FF8B00';
var $ceffa6770a29f492$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $ceffa6770a29f492$export$69a3bf21b9686c2b = '#ABF5D1';
var $ceffa6770a29f492$export$afbce1382ec95f73 = '#79F2C0';
var $ceffa6770a29f492$export$747d86715d4175de = '#57D9A3';
var $ceffa6770a29f492$export$940e1f69e873f202 = '#36B37E';
var $ceffa6770a29f492$export$a49394138f7b8e85 = '#00875A';
var $ceffa6770a29f492$export$6fa04827ac68a4fb = '#006644';
var $ceffa6770a29f492$export$226de0355ed012f8 = '#DEEBFF';
var $ceffa6770a29f492$export$8c13c2ee36917869 = '#B3D4FF';
var $ceffa6770a29f492$export$ecfc1dff386a3e7a = '#4C9AFF';
var $ceffa6770a29f492$export$215b7063051591f1 = '#2684FF';
var $ceffa6770a29f492$export$e62e8919cca44969 = '#0065FF';
var $ceffa6770a29f492$export$b3de0ae08da2ce64 = '#0052CC';
var $ceffa6770a29f492$export$a6ee3d71bc067634 = '#0747A6';
var $ceffa6770a29f492$export$67f15409e87642a1 = '#669DF1';
var $ceffa6770a29f492$export$f0539dbc42dbb067 = '#8FB8F6';
var $ceffa6770a29f492$export$363e4475840015bb = '#EAE6FF';
var $ceffa6770a29f492$export$4b0a4417ed59760f = '#C0B6F2';
var $ceffa6770a29f492$export$6011520a64d9a187 = '#998DD9';
var $ceffa6770a29f492$export$a7175d4e9206bc80 = '#8777D9';
var $ceffa6770a29f492$export$b48405b95304b5a1 = '#6554C0';
var $ceffa6770a29f492$export$c71e4279dd54a18d = '#5243AA';
var $ceffa6770a29f492$export$147899de772240ec = '#403294';
var $ceffa6770a29f492$export$2cf711fe14c66f06 = '#E6FCFF';
var $ceffa6770a29f492$export$7a8f4d33f6f9772c = '#B3F5FF';
var $ceffa6770a29f492$export$776c9c497ef08533 = '#79E2F2';
var $ceffa6770a29f492$export$69cb3ca10c1e330e = '#00C7E6';
var $ceffa6770a29f492$export$9dc1ef0f3f48059b = '#00B8D9';
var $ceffa6770a29f492$export$7c835c78b6fcdef8 = '#00A3BF';
var $ceffa6770a29f492$export$6036577f95c3877e = '#008DA6';
var $ceffa6770a29f492$export$29a4f05edc054374 = '#FFFFFF';
var $ceffa6770a29f492$export$e655ef011c4aa1a2 = '#FAFBFC';
var $ceffa6770a29f492$export$9fdfb749e33cdf97 = '#F4F5F7';
var $ceffa6770a29f492$export$3e51e8f1440314ba = '#EBECF0';
var $ceffa6770a29f492$export$1ce2d1575d444ceb = '#DFE1E6';
var $ceffa6770a29f492$export$8754fc7e6d8b3000 = '#C1C7D0';
var $ceffa6770a29f492$export$c2e91cbeada39b8b = '#B3BAC5';
var $ceffa6770a29f492$export$5f71e19f3a7ad9de = '#A5ADBA';
var $ceffa6770a29f492$export$eaa8c8a70ac22806 = '#97A0AF';
var $ceffa6770a29f492$export$7c87d337fb91a97d = '#8993A4';
var $ceffa6770a29f492$export$d6447c357493214f = '#7A869A';
var $ceffa6770a29f492$export$f563ee71e9ee74cd = '#6B778C';
var $ceffa6770a29f492$export$e2ef2124cf4024b1 = '#5E6C84';
var $ceffa6770a29f492$export$eece5f492e429f08 = '#505F79';
var $ceffa6770a29f492$export$c39c0fe0f26207ae = '#42526E';
var $ceffa6770a29f492$export$7090862dc3038a9f = '#344563';
var $ceffa6770a29f492$export$ad0bacf983b7ddaa = '#253858';
var $ceffa6770a29f492$export$7d61b15e0da132af = '#172B4D';
var $ceffa6770a29f492$export$fbda843f0a27fe96 = '#091E42';
var $ceffa6770a29f492$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $ceffa6770a29f492$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $ceffa6770a29f492$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $ceffa6770a29f492$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $ceffa6770a29f492$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $ceffa6770a29f492$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $ceffa6770a29f492$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $ceffa6770a29f492$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $ceffa6770a29f492$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $ceffa6770a29f492$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $ceffa6770a29f492$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $ceffa6770a29f492$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $ceffa6770a29f492$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $ceffa6770a29f492$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $ceffa6770a29f492$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $ceffa6770a29f492$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $ceffa6770a29f492$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $ceffa6770a29f492$export$2f6319cf7d736c2a = '#E6EDFA';
var $ceffa6770a29f492$export$95126bc8884d6634 = '#DCE5F5';
var $ceffa6770a29f492$export$8338d8c35d44ff1 = '#CED9EB';
var $ceffa6770a29f492$export$5368d76ae4fbbda7 = '#B8C7E0';
var $ceffa6770a29f492$export$9f0a771d16ec8d36 = '#ABBBD6';
var $ceffa6770a29f492$export$abcf8c38338b4aa5 = '#9FB0CC';
var $ceffa6770a29f492$export$97e81faa16a182c7 = '#8C9CB8';
var $ceffa6770a29f492$export$bfe21c59123ecf33 = '#7988A3';
var $ceffa6770a29f492$export$ee82aa2ea6a1558 = '#67758F';
var $ceffa6770a29f492$export$682927c6ed76be02 = '#56637A';
var $ceffa6770a29f492$export$91fd9994c5be9757 = '#455166';
var $ceffa6770a29f492$export$d281fbfe3cff2df6 = '#3B475C';
var $ceffa6770a29f492$export$3902c91d8b98a753 = '#313D52';
var $ceffa6770a29f492$export$8e8133c1ba5845b5 = '#283447';
var $ceffa6770a29f492$export$33ff357f6620b39 = '#202B3D';
var $ceffa6770a29f492$export$633847cf062b69e0 = '#1B2638';
var $ceffa6770a29f492$export$9776a6e503bdbf76 = '#121A29';
var $ceffa6770a29f492$export$6c813d5160dff5db = '#0E1624';
var $ceffa6770a29f492$export$3d4f271a500072a = '#0D1424';
var $ceffa6770a29f492$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $ceffa6770a29f492$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $ceffa6770a29f492$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $ceffa6770a29f492$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $ceffa6770a29f492$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $ceffa6770a29f492$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $ceffa6770a29f492$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $ceffa6770a29f492$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $ceffa6770a29f492$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $ceffa6770a29f492$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $ceffa6770a29f492$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $ceffa6770a29f492$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $ceffa6770a29f492$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $ceffa6770a29f492$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $ceffa6770a29f492$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $ceffa6770a29f492$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $ceffa6770a29f492$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $ceffa6770a29f492$export$d2adc5dedf09fced = '#292A2E';
var $ceffa6770a29f492$export$f51762073d2bb381 = '#94C748';
var $ceffa6770a29f492$export$95e26d54def96891 = '#B3DF72';

});


parcelRegister("bc1Os", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $826238b3ba55723d$export$2e2bcd8739ae039; });
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");
var $826238b3ba55723d$var$labelTextStyles = null;
function $826238b3ba55723d$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $91i6m.createElement("span", {
        className: (0, $9gzWK.default)([
            "_nd5l11ig _1wpz1h6o"
        ])
    }, children);
}

});

parcelRegister("dnhDS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9bcb1bbabfc1e798$export$2e2bcd8739ae039; });
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");
var $5oJNc = parcelRequire("5oJNc");

var $hLQD3 = parcelRequire("hLQD3");
var $9bcb1bbabfc1e798$var$requiredIndicatorStyles = null;
function $9bcb1bbabfc1e798$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ $91i6m.createElement("span", {
        "aria-hidden": true,
        className: (0, $9gzWK.default)([
            "_syaz1ml5 _bozgv77o"
        ]),
        style: {
            "--_1xw92dq": (0, $5oJNc.default)("var(--ds-text-danger, ".concat((0, $hLQD3.R500), ")"))
        }
    }, "*");
}

});


parcelRegister("fZMDU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23852cbaf3eed85c$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $23852cbaf3eed85c$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    marketingConsentPromptText: {
        id: 'marketing.consent.text',
        defaultMessage: 'Yes! Send me news and offers from Atlassian about products, events, and more.',
        description: ''
    }
});

});



parcelRegister("jL47V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37f41bee9cda75fe$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");

var $9jjaN = parcelRequire("9jjaN");

var $jjKE1 = parcelRequire("jjKE1");

var $4xOBh = parcelRequire("4xOBh");
var $1o8Ff = parcelRequire("1o8Ff");

var $6e88g = parcelRequire("6e88g");
let $37f41bee9cda75fe$var$_ = (t)=>t, $37f41bee9cda75fe$var$t;
const $37f41bee9cda75fe$var$AccountEnvSelectorWrapper = (0, $9jjaN.default).div($37f41bee9cda75fe$var$t || ($37f41bee9cda75fe$var$t = $37f41bee9cda75fe$var$_`
  margin-top: ${0}px;
`), (0, $6e88g.gridSize)());
const $37f41bee9cda75fe$export$f6c6978db589fd79 = [
    {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
            id: "atlassian-cloud-label",
            defaultMessage: "Atlassian Cloud",
            description: "Label for selecting the Atlassian Cloud environment"
        }),
        value: 'atlassian-cloud'
    },
    {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
            id: "atlassian-isolated-cloud-label",
            defaultMessage: "Atlassian Isolated Cloud",
            description: "Label for selecting the Atlassian Isolated Cloud environment"
        }),
        value: 'atlassian-isolated-cloud'
    }
];
const $37f41bee9cda75fe$var$AccountEnvSelector = ({ isHidden: isHidden = false, options: options, onSelectEnvChange: onSelectEnvChange, fieldError: fieldError, isRequired: isRequired, isInvalid: isInvalid })=>{
    if (isHidden) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($37f41bee9cda75fe$var$AccountEnvSelectorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $4xOBh.Label), {
        htmlFor: "account-env-selector",
        "aria-required": isRequired,
        "aria-label": "Environment",
        id: "account-env-selector-label"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
        id: "account-env-selector-label",
        defaultMessage: "Environment",
        description: "Label for the account environment selector"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1o8Ff.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $jjKE1.default), {
        placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
            id: "account-env-selector-placeholder",
            defaultMessage: "Select Environment",
            description: "Placeholder for the account env selector"
        }),
        isRequired: isRequired,
        options: options,
        isClearable: false,
        inputId: "account-env-selector",
        testId: "account-env-selector-idf-testid",
        onChange: (selected)=>onSelectEnvChange === null || onSelectEnvChange === void 0 ? void 0 : onSelectEnvChange(selected ? selected.value : ''),
        isInvalid: isInvalid,
        invalidMessage: fieldError
    }));
};
var $37f41bee9cda75fe$export$2e2bcd8739ae039 = $37f41bee9cda75fe$var$AccountEnvSelector;

});
parcelRegister("jjKE1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e103f9528cbdc030$export$2e2bcd8739ae039; });
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $jaRXv = parcelRequire("jaRXv");
var $8ikdx = parcelRequire("8ikdx");
var $bV0jQ = parcelRequire("bV0jQ");

var $4UqST = parcelRequire("4UqST");

var $fyqWn = parcelRequire("fyqWn");
var $e103f9528cbdc030$var$packageName = "@atlaskit/select";
var $e103f9528cbdc030$var$packageVersion = "21.2.7";
var $e103f9528cbdc030$export$d1de3b251ccaa8a3 = (0, $fyqWn.default)((0, $4UqST.default));
var $e103f9528cbdc030$var$createAndFireEventOnAtlaskit = (0, $jaRXv.default)('atlaskit');
var $e103f9528cbdc030$var$Select = (0, $8ikdx.default)({
    componentName: 'select',
    packageName: $e103f9528cbdc030$var$packageName,
    packageVersion: $e103f9528cbdc030$var$packageVersion
})((0, $bV0jQ.default)({
    onChange: $e103f9528cbdc030$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $e103f9528cbdc030$var$packageName,
            packageVersion: $e103f9528cbdc030$var$packageVersion
        }
    })
})($e103f9528cbdc030$export$d1de3b251ccaa8a3));
var $e103f9528cbdc030$export$2e2bcd8739ae039 = $e103f9528cbdc030$var$Select;

});
parcelRegister("jaRXv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df58ce9ad1a4cc6e$export$2e2bcd8739ae039; });
var $df58ce9ad1a4cc6e$export$2e2bcd8739ae039 = function(channel) {
    return function(payload) {
        return function(createAnalyticsEvent) {
            var consumerEvent = createAnalyticsEvent(payload);
            var clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };
    };
};

});

parcelRegister("8ikdx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $609fafe5d97490e0$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $dsN6L = parcelRequire("dsN6L");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $agCrL = parcelRequire("agCrL");
var $609fafe5d97490e0$var$_excluded = [
    "analyticsContext"
];
function $609fafe5d97490e0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $609fafe5d97490e0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $609fafe5d97490e0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $609fafe5d97490e0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $609fafe5d97490e0$var$withAnalyticsContext = function withAnalyticsContext(defaultData) {
    return function(WrappedComponent) {
        var WithAnalyticsContext = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref, ref) {
            var analyticsContext = _ref.analyticsContext, rest = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $609fafe5d97490e0$var$_excluded);
            var analyticsData = (0, $91i6m.useMemo)(function() {
                return $609fafe5d97490e0$var$_objectSpread($609fafe5d97490e0$var$_objectSpread({}, defaultData), analyticsContext);
            }, [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $agCrL.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, rest, {
                ref: ref
            })));
        });
        WithAnalyticsContext.displayName = "WithAnalyticsContext(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsContext;
    };
};
var $609fafe5d97490e0$export$2e2bcd8739ae039 = $609fafe5d97490e0$var$withAnalyticsContext;

});
parcelRegister("agCrL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $779938bf6fae7523$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $f1k1y = parcelRequire("f1k1y");

var $7ZOtR = parcelRequire("7ZOtR");

var $hmlXS = parcelRequire("hmlXS");

var $4VoHs = parcelRequire("4VoHs");
var $779938bf6fae7523$var$ExportedAnalyticsContext = function ExportedAnalyticsContext(props) {
    var isModernContext = (0, $7ZOtR.default) || (0, $f1k1y.fg)('analytics-next-use-modern-context_jira');
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $4VoHs.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $hmlXS.default), props);
};
var $779938bf6fae7523$export$2e2bcd8739ae039 = $779938bf6fae7523$var$ExportedAnalyticsContext;

});
parcelRegister("7ZOtR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d256350e392b90f$export$2e2bcd8739ae039; });

var $e08gr = parcelRequire("e08gr");
var $5d256350e392b90f$var$_process$env;
var /// <reference types="node" />
$5d256350e392b90f$export$2e2bcd8739ae039 = typeof $e08gr !== 'undefined' && $e08gr !== null && (($5d256350e392b90f$var$_process$env = {}, $5d256350e392b90f$var$_process$env === void 0) ? void 0 : $5d256350e392b90f$var$_process$env['ANALYTICS_NEXT_MODERN_CONTEXT']);

});

parcelRegister("hmlXS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca358776a8ae1420$export$2e2bcd8739ae039; });

var $iqLBO = parcelRequire("iqLBO");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $gGOBY = parcelRequire("gGOBY");

var $lVDuE = parcelRequire("lVDuE");

var $kSyoi = parcelRequire("kSyoi");

var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $eYOCy = parcelRequire("eYOCy");

var $6Jo8f = parcelRequire("6Jo8f");
function $ca358776a8ae1420$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($gGOBY)))(t, $ca358776a8ae1420$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(t).constructor) : o.apply(t, e));
}
function $ca358776a8ae1420$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ca358776a8ae1420$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $ca358776a8ae1420$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($eYOCy))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($eYOCy))).func
};
var $ca358776a8ae1420$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $ca358776a8ae1420$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    function AnalyticsContext(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, AnalyticsContext);
        _this = $ca358776a8ae1420$var$_callSuper(this, AnalyticsContext, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $ca358776a8ae1420$var$noop : _this$context$getAtla;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $ca358776a8ae1420$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($kSyoi)))(AnalyticsContext, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6Jo8f.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
}((0, $91i6m.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($ca358776a8ae1420$var$AnalyticsContext, "contextTypes", $ca358776a8ae1420$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($ca358776a8ae1420$var$AnalyticsContext, "childContextTypes", $ca358776a8ae1420$var$ContextTypes);
var $ca358776a8ae1420$export$2e2bcd8739ae039 = $ca358776a8ae1420$var$AnalyticsContext;

});

parcelRegister("4VoHs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $395fa5320344d3e3$export$2e2bcd8739ae039; });

var $iqLBO = parcelRequire("iqLBO");

var $91i6m = parcelRequire("91i6m");

var $6Jo8f = parcelRequire("6Jo8f");

var $jnxi2 = parcelRequire("jnxi2");

var $2R3rH = parcelRequire("2R3rH");
var $395fa5320344d3e3$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $2R3rH.useTrackedRef)(data);
    var _useAnalyticsContext = (0, $jnxi2.useAnalyticsContext)(), getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext.getAtlaskitAnalyticsEventHandlers, getOriginalAnalyticsContext = _useAnalyticsContext.getAtlaskitAnalyticsContext;
    var getAtlaskitAnalyticsContext = (0, $91i6m.useCallback)(function() {
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(getOriginalAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    var value = (0, $91i6m.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6Jo8f.default).Provider, {
        value: value
    }, children);
};
var $395fa5320344d3e3$export$2e2bcd8739ae039 = $395fa5320344d3e3$var$AnalyticsContext;

});



parcelRegister("bV0jQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ad543efbd812c18$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $91i6m = parcelRequire("91i6m");

var $8Xa2x = parcelRequire("8Xa2x");

var $8ajix = parcelRequire("8ajix");
var $8ad543efbd812c18$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(props, ref) {
            var _usePatchedProps = (0, $8ajix.usePatchedProps)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $8Xa2x.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $8ad543efbd812c18$export$2e2bcd8739ae039 = $8ad543efbd812c18$var$withAnalyticsEvents;

});
parcelRegister("8ajix", function(module, exports) {

$parcel$export(module.exports, "usePatchedProps", function () { return $5f1e3a194c820806$export$9ebb5a84d17e5d18; });

var $dsN6L = parcelRequire("dsN6L");

var $61RDg = parcelRequire("61RDg");

var $91i6m = parcelRequire("91i6m");

var $8Xa2x = parcelRequire("8Xa2x");
function $5f1e3a194c820806$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5f1e3a194c820806$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5f1e3a194c820806$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5f1e3a194c820806$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5f1e3a194c820806$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $8Xa2x.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $91i6m.useRef)({});
    var patchedProps = (0, $91i6m.useMemo)(function() {
        var cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                'object',
                'function'
            ].includes((0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $5f1e3a194c820806$var$_objectSpread($5f1e3a194c820806$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === 'function' ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === 'function') {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $5f1e3a194c820806$var$_objectSpread($5f1e3a194c820806$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});


parcelRegister("4UqST", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39313f0a9415b738$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $91i6m = parcelRequire("91i6m");

var $6bA5O = parcelRequire("6bA5O");

var $fBWoJ = parcelRequire("fBWoJ");

var $lHvFL = parcelRequire("lHvFL");
var $39313f0a9415b738$var$AsyncSelect = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(props, ref) {
    // when isAsync is true, options are not provided and async props are used, we will enable async
    var isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    var stateManagedProps = (0, $fBWoJ.default)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    var selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    var selectProps = (0, $lHvFL.default)(selectAsyncProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6bA5O.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        ref: ref
    }, selectProps));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$39313f0a9415b738$export$2e2bcd8739ae039 = $39313f0a9415b738$var$AsyncSelect;

});
parcelRegister("6bA5O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $480fc469cc17e383$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");
parcelRequire("exiN1");

var $61RDg = parcelRequire("61RDg");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $gGOBY = parcelRequire("gGOBY");

var $lVDuE = parcelRequire("lVDuE");

var $kSyoi = parcelRequire("kSyoi");

var $dsN6L = parcelRequire("dsN6L");

var $iqLBO = parcelRequire("iqLBO");

var $91i6m = parcelRequire("91i6m");

var $kgCwg = parcelRequire("kgCwg");

var $f1k1y = parcelRequire("f1k1y");

var $1PJ8A = parcelRequire("1PJ8A");

var $lNStP = parcelRequire("lNStP");

var $WaFHh = parcelRequire("WaFHh");
var $5QqBJ = parcelRequire("5QqBJ");
var $3Pzvs = parcelRequire("3Pzvs");

var $fstjg = parcelRequire("fstjg");

var $cN9P5 = parcelRequire("cN9P5");

var $gVvyR = parcelRequire("gVvyR");

var $6cVZc = parcelRequire("6cVZc");

var $hAMpx = parcelRequire("hAMpx");

var $cCoB6 = parcelRequire("cCoB6");
function $480fc469cc17e383$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $480fc469cc17e383$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $480fc469cc17e383$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $480fc469cc17e383$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $480fc469cc17e383$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($gGOBY)))(t, $480fc469cc17e383$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(t).constructor) : o.apply(t, e));
}
function $480fc469cc17e383$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($480fc469cc17e383$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $480fc469cc17e383$export$9c21a3269931e1e6 = {
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $cCoB6.isTouchCapable)(),
    captureMenuScroll: !(0, $cCoB6.isTouchCapable)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $6cVZc.createFilter)(),
    formatGroupLabel: (0, $1PJ8A.formatGroupLabel),
    getOptionLabel: (0, $1PJ8A.getOptionLabel),
    getOptionValue: (0, $1PJ8A.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $1PJ8A.isOptionDisabled),
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $cCoB6.isMobileDevice)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    shouldPreventEscapePropagation: false,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false
};
function $480fc469cc17e383$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $480fc469cc17e383$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $480fc469cc17e383$var$_isOptionSelected(props, option, selectValue);
    var label = $480fc469cc17e383$var$getOptionLabel(props, option);
    var value = $480fc469cc17e383$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $480fc469cc17e383$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        //@ts-ignore
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $480fc469cc17e383$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $480fc469cc17e383$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $480fc469cc17e383$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $480fc469cc17e383$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $cCoB6.notNullish));
}
function $480fc469cc17e383$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $480fc469cc17e383$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $480fc469cc17e383$var$buildFocusableOptions(props, selectValue) {
    return $480fc469cc17e383$var$buildFocusableOptionsFromCategorizedOptions($480fc469cc17e383$var$buildCategorizedOptions(props, selectValue));
}
function $480fc469cc17e383$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$480fc469cc17e383$var$shouldHideSelectedOptions(props) || !isSelected) && $480fc469cc17e383$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $480fc469cc17e383$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $480fc469cc17e383$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $480fc469cc17e383$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $480fc469cc17e383$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $480fc469cc17e383$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $480fc469cc17e383$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $480fc469cc17e383$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $480fc469cc17e383$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $480fc469cc17e383$var$getOptionValue(props, i) === candidate;
    });
}
function $480fc469cc17e383$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $480fc469cc17e383$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $480fc469cc17e383$var$instanceId = 1;
// eslint-disable-next-line @repo/internal/react/no-class-components
var $480fc469cc17e383$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, Select);
        _this = $480fc469cc17e383$var$_callSuper(this, Select, [
            _props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "state", {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        });
        // Misc. Instance Properties
        // ------------------------------
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "blockOptionHover", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "isComposing", false);
        // TODO
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "initialTouchX", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "initialTouchY", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "openAfterFocus", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "scrollToFocusedOptionOnUpdate", false);
        // Refs
        // ------------------------------
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "controlRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "getControlRef", function(ref) {
            _this.controlRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "focusedOptionRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "getFocusedOptionRef", function(ref) {
            _this.focusedOptionRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "menuListRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "getMenuListRef", function(ref) {
            _this.menuListRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "inputRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "getInputRef", function(ref) {
            _this.inputRef = ref;
        });
        // aliased for consumers
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "focus", _this.focusInput);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "blur", _this.blurInput);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "onChange", function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "setValue", function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            // for multiple selection options, do not clear the search input value
            if (isMulti && (0, $f1k1y.fg)('platform_do_not_clear_input_for_multiselect')) _this.onInputChange(inputValue, {
                action: 'set-value',
                prevInputValue: inputValue
            });
            else _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "selectOption", function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $cCoB6.multiValueAsValue)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $cCoB6.multiValueAsValue)([].concat((0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $cCoB6.singleValueAsValue)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $cCoB6.singleValueAsValue)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "removeValue", function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $cCoB6.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "clearValue", function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $cCoB6.valueTernary)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "popValue", function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $cCoB6.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        });
        // ==============================
        // Getters
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "getFocusedOptionId", function(focusedOption) {
            return $480fc469cc17e383$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "getFocusableOptionsWithIds", function() {
            return $480fc469cc17e383$var$buildFocusableOptionsWithIds($480fc469cc17e383$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "getValue", function() {
            return _this.state.selectValue;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "cx", function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $cCoB6.classNames).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "getOptionLabel", function(data) {
            return $480fc469cc17e383$var$getOptionLabel(_this.props, data);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "getOptionValue", function(data) {
            return $480fc469cc17e383$var$getOptionValue(_this.props, data);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "getStyles", function(key, props) {
            var base = (0, $hAMpx.defaultStyles)[key](props);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            if (!custom) return base;
            var customStyles = (0, $cCoB6.filterUnsupportedSelectors)(custom(base, props));
            return customStyles;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "getClassNames", function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "getElementId", function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "getComponents", function() {
            return (0, $lNStP.defaultComponents)(_this.props);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "buildCategorizedOptions", function() {
            return $480fc469cc17e383$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "getCategorizedOptions", function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "buildFocusableOptions", function() {
            return $480fc469cc17e383$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "getFocusableOptions", function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        });
        // ==============================
        // Helpers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "ariaOnChange", function(value, actionMeta) {
            _this.setState({
                ariaSelection: $480fc469cc17e383$var$_objectSpread({
                    value: value
                }, actionMeta)
            });
        });
        // ==============================
        // Mouse Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "onMenuMouseDown", function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "onMenuMouseMove", function(event) {
            _this.blockOptionHover = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "onControlMouseDown", function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                var _this$controlRef;
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!((_this$controlRef = _this.controlRef) !== null && _this$controlRef !== void 0 && _this$controlRef.closest('[data-rbd-draggable-context-id]'))) return;
            }
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "onDropdownIndicatorMouseDown", function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "onClearIndicatorMouseDown", function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "onScroll", function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $cCoB6.isDocumentElement)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "onCompositionStart", function() {
            _this.isComposing = true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "onCompositionEnd", function() {
            _this.isComposing = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "onTouchStart", function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "onTouchMove", function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "onTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "onControlTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "onClearIndicatorTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "onDropdownIndicatorTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        });
        // ==============================
        // Focus Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "handleInputChange", function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "onInputFocus", function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "onInputBlur", function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            if ((0, $f1k1y.fg)('platform_dst_select_menu_close_on_blur')) // when fg is enabled, we only call onMenuClose when this.props.menuIsOpen is true.
            _this.props.menuIsOpen && _this.onMenuClose();
            else _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "onOptionHover", function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "shouldHideSelectedOptions", function() {
            return $480fc469cc17e383$var$shouldHideSelectedOptions(_this.props);
        });
        // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "onValueInputFocus", function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        });
        // ==============================
        // Keyboard Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "onKeyDown", function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus, shouldPreventEscapePropagation = _this$props5.shouldPreventEscapePropagation;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) _this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                        if (shouldPreventEscapePropagation && event.target instanceof HTMLElement) event.stopPropagation();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "handleOpenLayerObserverCloseSignal", function() {
            _this.onMenuClose();
        });
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$480fc469cc17e383$var$instanceId);
        _this.state.selectValue = (0, $cCoB6.cleanValue)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $480fc469cc17e383$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($kSyoi)))(Select, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $cCoB6.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $cCoB6.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                var focusedOption = focusableOptions[openAtIndex];
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusedOption,
                    focusedOptionId: this.getFocusedOptionId(focusedOption)
                }, function() {
                    return _this2.onMenuOpen();
                });
                (0, $kgCwg.isSafari)() && focusedOption && this.updateInputLabel(this.calculateInputLabel(focusedOption, openAtIndex));
            }
        },
        {
            key: "updateInputLabel",
            value: function updateInputLabel(inputLabel) {
                var _this3 = this;
                if (inputLabel) {
                    var _this$inputRef;
                    (_this$inputRef = this.inputRef) === null || _this$inputRef === void 0 || _this$inputRef.setAttribute('aria-label', inputLabel);
                    setTimeout(function() {
                        var normalizedLabel = _this3.props['aria-label'] || _this3.props.label;
                        if (normalizedLabel) {
                            var _this3$inputRef;
                            (_this3$inputRef = _this3.inputRef) === null || _this3$inputRef === void 0 || _this3$inputRef.setAttribute('aria-label', normalizedLabel);
                        } else {
                            var _this3$inputRef2;
                            (_this3$inputRef2 = _this3.inputRef) === null || _this3$inputRef2 === void 0 || _this3$inputRef2.removeAttribute('aria-label');
                        }
                    }, 500);
                }
            }
        },
        {
            key: "calculateInputLabel",
            value: function calculateInputLabel(focusedOption, optionIndex) {
                var _this4 = this;
                var options = this.props.options;
                var isOptionsGrouped = options === null || options === void 0 ? void 0 : options.every(function(obj) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(obj) === 'object' && obj !== null && 'options' in obj;
                });
                var inputLabel = this.getOptionLabel(focusedOption);
                var isOptionFocused = function isOptionFocused(option) {
                    return _this4.getOptionLabel(option) === inputLabel;
                };
                var groupData = options === null || options === void 0 ? void 0 : options.find(function(option) {
                    var _groupCandidate$optio, _groupCandidate$optio2;
                    var groupCandidate = option;
                    return (_groupCandidate$optio = (_groupCandidate$optio2 = groupCandidate.options) === null || _groupCandidate$optio2 === void 0 ? void 0 : _groupCandidate$optio2.some(isOptionFocused)) !== null && _groupCandidate$optio !== void 0 ? _groupCandidate$optio : false;
                });
                if (isOptionsGrouped) {
                    var _groupData$options$fi;
                    var groupOptionIndex = (_groupData$options$fi = groupData === null || groupData === void 0 ? void 0 : groupData.options.findIndex(isOptionFocused)) !== null && _groupData$options$fi !== void 0 ? _groupData$options$fi : 0;
                    var totalLength = options === null || options === void 0 ? void 0 : options.reduce(function(acc, currentGroup) {
                        var _group$options;
                        var group = currentGroup;
                        acc += group === null || group === void 0 || (_group$options = group.options) === null || _group$options === void 0 ? void 0 : _group$options.length;
                        return acc;
                    }, 0);
                    inputLabel = "".concat(inputLabel, ", ").concat(groupData === null || groupData === void 0 ? void 0 : groupData.label, " (").concat(groupOptionIndex + 1, " of ").concat(totalLength, ")");
                } else inputLabel = "".concat(inputLabel, " (").concat(optionIndex + 1, " of ").concat(options === null || options === void 0 ? void 0 : options.length, ")");
                return inputLabel;
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus],
                    focusedValueId: "".concat(this.getElementId('selected-value'), "-").concat(nextFocus, "-remove"),
                    focusedOption: null,
                    focusedOptionId: null
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedValueId: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $480fc469cc17e383$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $480fc469cc17e383$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $480fc469cc17e383$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var inputValue = this.props.inputValue;
                    var selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: inputValue,
                        selectValue: selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "calculateDescription",
            value: function calculateDescription() {
                var descriptionProp = this.props['aria-describedby'] || this.props.descriptionId;
                var isMulti = this.props.isMulti;
                var hasValue = this.state.selectValue.length > 0;
                // Determine base description based on selection state
                var baseDescriptionId = hasValue ? isMulti ? '' : this.getElementId('single-value') : this.getElementId('placeholder');
                // Fast path for single select with no description prop
                if (!isMulti && !descriptionProp) return {
                    'aria-describedby': baseDescriptionId
                };
                // Build the describedby string efficiently
                var describedBy = baseDescriptionId;
                // Add description prop if it exists
                if (descriptionProp) describedBy = describedBy ? "".concat(descriptionProp, " ").concat(describedBy) : descriptionProp;
                // For multi-select, always add multi-message ID
                if (isMulti) {
                    var multiMessage = this.getElementId('multi-message');
                    describedBy = describedBy ? "".concat(describedBy, " ").concat(multiMessage) : multiMessage;
                }
                return {
                    'aria-describedby': describedBy
                };
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchstart', this.onTouchStart);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchmove', this.onTouchMove);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, form = _this$props8.form, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, isDisabled = _this$props8.isDisabled, isInvalid = _this$props8.isInvalid, isRequired = _this$props8.isRequired, isSearchable = _this$props8.isSearchable, label = _this$props8.label, labelId = _this$props8.labelId, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required, _this$props8$tabIndex = _this$props8.tabIndex, tabIndex = _this$props8$tabIndex === void 0 ? 0 : _this$props8$tabIndex, testId = _this$props8.testId;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var inputIsHidden = this.state.inputIsHidden;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = $480fc469cc17e383$var$_objectSpread($480fc469cc17e383$var$_objectSpread($480fc469cc17e383$var$_objectSpread({
                    'aria-autocomplete': 'both',
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-expanded': menuIsOpen,
                    // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
                    'aria-haspopup': this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
                    'aria-invalid': this.props['aria-invalid'] || isInvalid,
                    'aria-label': this.props['aria-label'] || label,
                    'aria-labelledby': this.props['aria-labelledby'] || labelId,
                    'aria-required': required || isRequired,
                    role: 'combobox',
                    'aria-activedescendant': this.props['UNSAFE_is_experimental_generic'] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.calculateDescription());
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $WaFHh.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $cCoB6.noop),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: "",
                    "data-testid": testId && "".concat(testId, "-select--input")
                }, ariaAttributes));
                // NOTE: Don't add the `name` prop to this Input, `name` is already a prop on the hidden input element that has the value of the select.
                // Adding `name` to this Input will cause unexpected behavior.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(Input, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    testId: testId,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this5 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder, testId = _this$props9.testId;
                var _this$state4 = this.state, selectValue = _this$state4.selectValue, focusedValue = _this$state4.focusedValue, isFocused = _this$state4.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(Placeholder, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: $480fc469cc17e383$var$_objectSpread({
                        id: this.getElementId('placeholder')
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--placeholder")
                    })
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this5.getOptionLabel(opt), "-").concat(_this5.getOptionValue(opt));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(MultiValue, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: $480fc469cc17e383$var$_objectSpread($480fc469cc17e383$var$_objectSpread({
                            onClick: function onClick() {
                                return _this5.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this5.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        }, testId && {
                            'data-testid': "".concat(testId, "-select--multivalue-").concat(index, "-remove")
                        }), {}, {
                            id: "".concat(_this5.getElementId('selected-value'), "-").concat(index, "-remove")
                        }),
                        data: opt,
                        innerProps: $480fc469cc17e383$var$_objectSpread($480fc469cc17e383$var$_objectSpread({}, testId && {
                            'data-testid': "".concat(testId, "-select--multivalue-").concat(index)
                        }), {}, {
                            id: "".concat(_this5.getElementId('selected-value'), "-").concat(index)
                        })
                    }), _this5.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(SingleValue, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled,
                    innerProps: {
                        id: this.getElementId('single-value')
                    }
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props0 = this.props, clearControlLabel = _this$props0.clearControlLabel, isDisabled = _this$props0.isDisabled, isLoading = _this$props0.isLoading, spacing = _this$props0.spacing, testId = _this$props0.testId;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = $480fc469cc17e383$var$_objectSpread({
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd
                }, testId && {
                    'data-testid': "".concat(testId, "-select--clear-indicator")
                });
                var isCompact = spacing === 'compact';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(ClearIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
                    clearControlLabel: clearControlLabel
                }, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props1 = this.props, isDisabled = _this$props1.isDisabled, isLoading = _this$props1.isLoading, spacing = _this$props1.spacing, testId = _this$props1.testId;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var isCompact = spacing === 'compact';
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(LoadingIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
                    "data-testid": testId && "".concat(testId, "-select--loading-indicator")
                }, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, spacing = _this$props10.spacing, testId = _this$props10.testId;
                var isFocused = this.state.isFocused;
                var isCompact = spacing === 'compact';
                var innerProps = $480fc469cc17e383$var$_objectSpread({
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                }, testId && {
                    'data-testid': "".concat(testId, "-select--dropdown-indicator")
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(DropdownIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this6 = this;
                var _this$getComponents6 = this.getComponents(), Group = _this$getComponents6.Group, GroupHeading = _this$getComponents6.GroupHeading, Menu = _this$getComponents6.Menu, MenuList = _this$getComponents6.MenuList, MenuPortal = _this$getComponents6.MenuPortal, LoadingMessage = _this$getComponents6.LoadingMessage, NoOptionsMessage = _this$getComponents6.NoOptionsMessage, Option = _this$getComponents6.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props11 = this.props, captureMenuScroll = _this$props11.captureMenuScroll, inputValue = _this$props11.inputValue, isLoading = _this$props11.isLoading, loadingMessage = _this$props11.loadingMessage, minMenuHeight = _this$props11.minMenuHeight, maxMenuHeight = _this$props11.maxMenuHeight, menuIsOpen = _this$props11.menuIsOpen, menuPlacement = _this$props11.menuPlacement, menuPosition = _this$props11.menuPosition, menuPortalTarget = _this$props11.menuPortalTarget, menuShouldBlockScroll = _this$props11.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props11.menuShouldScrollIntoView, noOptionsMessage = _this$props11.noOptionsMessage, onMenuScrollToTop = _this$props11.onMenuScrollToTop, onMenuScrollToBottom = _this$props11.onMenuScrollToBottom, testId = _this$props11.testId;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id, headingId) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this6.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this6.selectOption(data);
                    };
                    var optionId = "".concat(_this6.getElementId('option'), "-").concat(id);
                    var innerProps = $480fc469cc17e383$var$_objectSpread({
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        role: _this6.props['UNSAFE_is_experimental_generic'] ? 'listitem' : 'option',
                        'aria-selected': _this6.props['UNSAFE_is_experimental_generic'] ? undefined : isSelected,
                        // We don't want aria-disabled if it's false. It's just noisy.
                        'aria-disabled': !isDisabled ? undefined : isDisabled,
                        'aria-describedby': headingId
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--option-").concat(id)
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(Option, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this6.getFocusedOptionRef : undefined
                    }), _this6.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) {
                    var items = this.getCategorizedOptions();
                    menuUI = items.map(function(item) {
                        if (item.type === 'group') {
                            var data = item.data, options = item.options, groupIndex = item.index;
                            var groupId = "".concat(_this6.getElementId('group'), "-").concat(groupIndex);
                            var headingId = "".concat(groupId, "-heading");
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(Group, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, commonProps, {
                                key: groupId,
                                data: data,
                                options: options,
                                Heading: GroupHeading,
                                headingProps: $480fc469cc17e383$var$_objectSpread({
                                    id: headingId,
                                    data: item.data
                                }, testId && {
                                    'data-testid': "".concat(testId, "-select--group-").concat(groupIndex, "-heading")
                                }),
                                label: _this6.formatGroupLabel(item.data)
                            }), item.options.map(function(option) {
                                return render(option, "".concat(groupIndex, "-").concat(option.index), headingId);
                            }));
                        } else if (item.type === 'option') return render(item, "".concat(item.index));
                    });
                } else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(NoOptionsMessage, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, commonProps, {
                        innerProps: $480fc469cc17e383$var$_objectSpread({}, testId && {
                            'data-testid': "".concat(testId, "-select--no-options")
                        })
                    }), _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $gVvyR.MenuPlacer), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(Menu, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: $480fc469cc17e383$var$_objectSpread({
                            onMouseDown: _this6.onMenuMouseDown,
                            onMouseMove: _this6.onMenuMouseMove,
                            id: _this6.props.components.Menu ? _this6.getElementId('listbox') : undefined
                        }, testId && {
                            'data-testid': "".concat(testId, "-select--listbox-container")
                        }),
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $3Pzvs.default), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        var _this6$inputRef, _this6$inputRef2;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(MenuList, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this6.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: $480fc469cc17e383$var$_objectSpread($480fc469cc17e383$var$_objectSpread($480fc469cc17e383$var$_objectSpread({
                                role: _this6.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox'
                            }, _this6.props['UNSAFE_is_experimental_generic'] && {
                                'aria-labelledby': ((_this6$inputRef = _this6.inputRef) === null || _this6$inputRef === void 0 ? void 0 : _this6$inputRef.id) || _this6.getElementId('input')
                            }), {}, {
                                'aria-multiselectable': !commonProps.isMulti || _this6.props['UNSAFE_is_experimental_generic'] ? undefined : commonProps.isMulti,
                                id: _this6.getElementId('listbox')
                            }, testId && {
                                'data-testid': "".concat(testId, "-select--listbox")
                            }), (0, $kgCwg.isSafari)() && !_this6.props['UNSAFE_is_experimental_generic'] && {
                                'aria-describedby': ((_this6$inputRef2 = _this6.inputRef) === null || _this6$inputRef2 === void 0 ? void 0 : _this6$inputRef2.id) || _this6.getElementId('input')
                            }),
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), _this6.props['UNSAFE_is_experimental_generic'] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("div", {
                            role: "list"
                        }, menuUI) : menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(MenuPortal, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this7 = this;
                var _this$props12 = this.props, delimiter = _this$props12.delimiter, isDisabled = _this$props12.isDisabled, isMulti = _this$props12.isMulti, required = _this$props12.required, name = _this$props12.name;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $5QqBJ.default), {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this7.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this7.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state5 = this.state, ariaSelection = _this$state5.ariaSelection, isFocused = _this$state5.isFocused, selectValue = _this$state5.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $cN9P5.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "renderMultiselectMessage",
            value: function renderMultiselectMessage() {
                // In the future, when we actually support touch devices, we'll need to update this to not be keyboard specific.
                // Also, since this is rendered onscreen, it should be transtlated automatically.
                var msg = ", multiple selections available, ".concat(this.state.selectValue.length ? 'Use left or right arrow keys to navigate selected items' : '');
                return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
                (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("span", {
                    id: this.getElementId('multi-message'),
                    hidden: true
                }, msg));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents7 = this.getComponents(), Control = _this$getComponents7.Control, IndicatorsContainer = _this$getComponents7.IndicatorsContainer, SelectContainer = _this$getComponents7.SelectContainer, ValueContainer = _this$getComponents7.ValueContainer;
                var _this$props13 = this.props, className = _this$props13.className, id = _this$props13.id, isDisabled = _this$props13.isDisabled, menuIsOpen = _this$props13.menuIsOpen, isInvalid = _this$props13.isInvalid, testId = _this$props13.testId, _this$props13$appeara = _this$props13.appearance, appearance = _this$props13$appeara === void 0 ? 'default' : _this$props13$appeara, _this$props13$spacing = _this$props13.spacing, spacing = _this$props13$spacing === void 0 ? 'default' : _this$props13$spacing;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                var isCompact = spacing === 'compact';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(SelectContainer, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, commonProps, {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                    className: className,
                    innerProps: $480fc469cc17e383$var$_objectSpread({
                        id: id,
                        onKeyDown: this.onKeyDown
                    }, testId && {
                        'data-testid': testId && "".concat(testId, "-select--container")
                    }),
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), commonProps.isMulti && this.renderMultiselectMessage(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(Control, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: $480fc469cc17e383$var$_objectSpread({
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--control")
                    }),
                    appearance: appearance,
                    isInvalid: isInvalid,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen,
                    isCompact: isCompact
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(ValueContainer, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, commonProps, {
                    isDisabled: isDisabled,
                    isCompact: isCompact,
                    innerProps: $480fc469cc17e383$var$_objectSpread($480fc469cc17e383$var$_objectSpread({}, testId && {
                        'data-testid': "".concat(testId, "-select--value-container")
                    }), commonProps.isMulti && commonProps.hasValue && !(0, $kgCwg.isAppleDevice)() && {
                        // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                        // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                        // DST Accessibility.
                        role: 'application'
                    })
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(IndicatorsContainer, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, commonProps, {
                    isDisabled: isDisabled,
                    innerProps: $480fc469cc17e383$var$_objectSpread({}, testId && {
                        'data-testid': "".concat(testId, "-select--indicators-container")
                    })
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $fstjg.NotifyOpenLayerObserver), {
                    isOpen: this.props.menuIsOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                }));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $cCoB6.cleanValue)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $480fc469cc17e383$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $480fc469cc17e383$var$buildFocusableOptionsWithIds($480fc469cc17e383$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $480fc469cc17e383$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $480fc469cc17e383$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $480fc469cc17e383$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $cCoB6.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return $480fc469cc17e383$var$_objectSpread($480fc469cc17e383$var$_objectSpread($480fc469cc17e383$var$_objectSpread({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
}((0, $91i6m.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))($480fc469cc17e383$export$2e2bcd8739ae039, "defaultProps", $480fc469cc17e383$export$9c21a3269931e1e6);

});
parcelRegister("exiN1", function(module, exports) {
function $02bb2404271b6bce$var$_readOnlyError(r) {
    throw new TypeError('"' + r + '" is read-only');
}
module.exports = $02bb2404271b6bce$var$_readOnlyError, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1PJ8A", function(module, exports) {

$parcel$export(module.exports, "formatGroupLabel", function () { return $155d9134d358ae27$export$f4da216a6ca54656; });
$parcel$export(module.exports, "getOptionLabel", function () { return $155d9134d358ae27$export$dac6ace3020563ca; });
$parcel$export(module.exports, "getOptionValue", function () { return $155d9134d358ae27$export$40be908210c5a79c; });
$parcel$export(module.exports, "isOptionDisabled", function () { return $155d9134d358ae27$export$56bd0c8d90db075; });
/* eslint-disable @repo/internal/fs/filename-pattern-match */ var $155d9134d358ae27$export$f4da216a6ca54656 = function formatGroupLabel(group) {
    return group.label;
};
var $155d9134d358ae27$export$dac6ace3020563ca = function getOptionLabel(option) {
    return option.label;
};
var $155d9134d358ae27$export$40be908210c5a79c = function getOptionValue(option) {
    return option.value;
};
var $155d9134d358ae27$export$56bd0c8d90db075 = function isOptionDisabled(option) {
    return !!option.isDisabled;
};

});

parcelRegister("lNStP", function(module, exports) {

$parcel$export(module.exports, "defaultComponents", function () { return $fdf86f366cbc5117$export$71abc632aa29e6fe; });

var $dsN6L = parcelRequire("dsN6L");

var $kbaiE = parcelRequire("kbaiE");

var $1VLd1 = parcelRequire("1VLd1");

var $95vjP = parcelRequire("95vjP");

var $cBc2c = parcelRequire("cBc2c");

var $kpjkf = parcelRequire("kpjkf");

var $gVvyR = parcelRequire("gVvyR");

var $wLIf7 = parcelRequire("wLIf7");

var $gxbCT = parcelRequire("gxbCT");

var $7tXLu = parcelRequire("7tXLu");

var $e31Up = parcelRequire("e31Up");
function $fdf86f366cbc5117$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fdf86f366cbc5117$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fdf86f366cbc5117$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fdf86f366cbc5117$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fdf86f366cbc5117$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $cBc2c.ClearIndicator),
    Control: (0, $1VLd1.default),
    DropdownIndicator: (0, $cBc2c.DropdownIndicator),
    Group: (0, $95vjP.default),
    GroupHeading: (0, $95vjP.GroupHeading),
    IndicatorsContainer: (0, $kbaiE.IndicatorsContainer),
    Input: (0, $kpjkf.default),
    LoadingIndicator: (0, $cBc2c.LoadingIndicator),
    Menu: (0, $gVvyR.default),
    MenuList: (0, $gVvyR.MenuList),
    MenuPortal: (0, $gVvyR.MenuPortal),
    LoadingMessage: (0, $gVvyR.LoadingMessage),
    NoOptionsMessage: (0, $gVvyR.NoOptionsMessage),
    MultiValue: (0, $wLIf7.default),
    MultiValueContainer: (0, $wLIf7.MultiValueContainer),
    MultiValueLabel: (0, $wLIf7.MultiValueLabel),
    MultiValueRemove: (0, $wLIf7.MultiValueRemove),
    Option: (0, $gxbCT.default),
    Placeholder: (0, $7tXLu.default),
    SelectContainer: (0, $kbaiE.SelectContainer),
    SingleValue: (0, $e31Up.default),
    ValueContainer: (0, $kbaiE.ValueContainer)
};
var $fdf86f366cbc5117$export$71abc632aa29e6fe = function defaultComponents(props) {
    return $fdf86f366cbc5117$var$_objectSpread($fdf86f366cbc5117$var$_objectSpread({}, $fdf86f366cbc5117$export$9b5ac10f59f76296), props.components);
};

});
parcelRegister("kbaiE", function(module, exports) {

$parcel$export(module.exports, "containerCSS", function () { return $eb0cd30c2a770142$export$949392aeaf7d2e3a; });
$parcel$export(module.exports, "SelectContainer", function () { return $eb0cd30c2a770142$export$446eebadefe1123b; });
$parcel$export(module.exports, "valueContainerCSS", function () { return $eb0cd30c2a770142$export$47aec73c7aa6b9aa; });
$parcel$export(module.exports, "ValueContainer", function () { return $eb0cd30c2a770142$export$4dc9f58ad9a1a000; });
$parcel$export(module.exports, "indicatorsContainerCSS", function () { return $eb0cd30c2a770142$export$9d74e3c8b5868ad7; });
$parcel$export(module.exports, "IndicatorsContainer", function () { return $eb0cd30c2a770142$export$d0ffd7e649cab6f; });
/* containers.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $8kGa4 = parcelRequire("8kGa4");

var $f1k1y = parcelRequire("f1k1y");

var $cCoB6 = parcelRequire("cCoB6");
var $eb0cd30c2a770142$export$949392aeaf7d2e3a = function containerCSS() {
    return {};
};
var $eb0cd30c2a770142$var$containerStyles = {
    default: "_11c82smr _kqswh2mm _lcxv1rj4",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf",
    ff_safari_input_fix: "_11c81ixg _1tn22smr"
};
var $eb0cd30c2a770142$export$446eebadefe1123b = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl, xcss = props.xcss;
    var _getStyleProps = (0, $cCoB6.getStyleProps)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), className = _getStyleProps.className, css = _getStyleProps.css;
    return /*#__PURE__*/ $91i6m.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9gzWK.default)([
            $eb0cd30c2a770142$var$containerStyles.default,
            isRtl && $eb0cd30c2a770142$var$containerStyles.rtl,
            isDisabled && $eb0cd30c2a770142$var$containerStyles.disabled,
            (0, $f1k1y.fg)('platform_design_system_team_safari_input_fix') && $eb0cd30c2a770142$var$containerStyles.ff_safari_input_fix,
            (0, $8kGa4.cx)(className, xcss, '-container')
        ]),
        style: css
    }, innerProps), children);
};
var $eb0cd30c2a770142$export$47aec73c7aa6b9aa = function valueContainerCSS() {
    return {};
};
var $eb0cd30c2a770142$var$valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7",
    flex: "_1e0c1txw",
    compact: "_ca0qze3t _u5f312x7 _n3tdze3t _19bv12x7"
};
var $eb0cd30c2a770142$export$4dc9f58ad9a1a000 = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue, isCompact = props.isCompact, xcss = props.xcss, controlShouldRenderValue = props.selectProps.controlShouldRenderValue;
    var _getStyleProps2 = (0, $cCoB6.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), css = _getStyleProps2.css, className = _getStyleProps2.className;
    return /*#__PURE__*/ $91i6m.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9gzWK.default)([
            $eb0cd30c2a770142$var$valueContainerStyles.default,
            isMulti && hasValue && controlShouldRenderValue && $eb0cd30c2a770142$var$valueContainerStyles.flex,
            isCompact && $eb0cd30c2a770142$var$valueContainerStyles.compact,
            (0, $8kGa4.cx)(className, xcss, '-ValueContainer')
        ]),
        style: css
    }, innerProps), children);
};
var $eb0cd30c2a770142$export$9d74e3c8b5868ad7 = function indicatorsContainerCSS() {
    return {};
};
var $eb0cd30c2a770142$var$indicatorContainerStyles = null;
var $eb0cd30c2a770142$export$d0ffd7e649cab6f = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps3 = (0, $cCoB6.getStyleProps)(props, 'indicatorsContainer', {
        indicators: true
    }), css = _getStyleProps3.css, className = _getStyleProps3.className;
    return /*#__PURE__*/ $91i6m.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $9gzWK.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, $8kGa4.cx)(className, xcss, '-IndicatorsContainer')
        ])
    }, innerProps), children);
};

});
parcelRegister("cCoB6", function(module, exports) {

$parcel$export(module.exports, "noop", function () { return $92fc1d311188f0a9$export$8793edee2d425525; });
$parcel$export(module.exports, "classNames", function () { return $92fc1d311188f0a9$export$ce4ab0c55987d1ff; });
$parcel$export(module.exports, "cleanValue", function () { return $92fc1d311188f0a9$export$33f062f47f21a01; });
$parcel$export(module.exports, "cleanCommonProps", function () { return $92fc1d311188f0a9$export$8e9fd4287627890c; });
$parcel$export(module.exports, "getStyleProps", function () { return $92fc1d311188f0a9$export$26417cabd806a658; });
$parcel$export(module.exports, "handleInputChange", function () { return $92fc1d311188f0a9$export$2096bae78ecda911; });
$parcel$export(module.exports, "isDocumentElement", function () { return $92fc1d311188f0a9$export$d8a62a489b442872; });
$parcel$export(module.exports, "normalizedHeight", function () { return $92fc1d311188f0a9$export$2e0654fad740d2e4; });
$parcel$export(module.exports, "getScrollTop", function () { return $92fc1d311188f0a9$export$c4a223a8ba9e4ea5; });
$parcel$export(module.exports, "scrollTo", function () { return $92fc1d311188f0a9$export$3f99968195accfaf; });
$parcel$export(module.exports, "getScrollParent", function () { return $92fc1d311188f0a9$export$cfa2225e87938781; });
$parcel$export(module.exports, "animatedScrollTo", function () { return $92fc1d311188f0a9$export$858c30343199f3af; });
$parcel$export(module.exports, "scrollIntoView", function () { return $92fc1d311188f0a9$export$53a0910f038337bd; });
$parcel$export(module.exports, "getBoundingClientObj", function () { return $92fc1d311188f0a9$export$7807c2a424c2f6d1; });
$parcel$export(module.exports, "isTouchCapable", function () { return $92fc1d311188f0a9$export$56963d77dbffdde7; });
$parcel$export(module.exports, "isMobileDevice", function () { return $92fc1d311188f0a9$export$44f917bf91becd01; });
$parcel$export(module.exports, "supportsPassiveEvents", function () { return $92fc1d311188f0a9$export$b0622a6911dbeaf5; });
$parcel$export(module.exports, "notNullish", function () { return $92fc1d311188f0a9$export$aedb69ff3e31596c; });
$parcel$export(module.exports, "valueTernary", function () { return $92fc1d311188f0a9$export$40fb9515c784cc3b; });
$parcel$export(module.exports, "singleValueAsValue", function () { return $92fc1d311188f0a9$export$dea4763e29237f4c; });
$parcel$export(module.exports, "multiValueAsValue", function () { return $92fc1d311188f0a9$export$d1ca752ec761b95b; });
$parcel$export(module.exports, "removeProps", function () { return $92fc1d311188f0a9$export$4213b25a1c4e877; });
$parcel$export(module.exports, "filterUnsupportedSelectors", function () { return $92fc1d311188f0a9$export$bf2eda47afa5f369; });

var $5YM7L = parcelRequire("5YM7L");

var $dsN6L = parcelRequire("dsN6L");

var $ai2Md = parcelRequire("ai2Md");

var $61RDg = parcelRequire("61RDg");
var $92fc1d311188f0a9$var$_excluded = [
    "className",
    "clearValue",
    "cx",
    "xcss",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue"
];
function $92fc1d311188f0a9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $92fc1d311188f0a9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $92fc1d311188f0a9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $92fc1d311188f0a9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $92fc1d311188f0a9$export$8793edee2d425525 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $92fc1d311188f0a9$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $92fc1d311188f0a9$export$ce4ab0c55987d1ff(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($92fc1d311188f0a9$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
var $92fc1d311188f0a9$export$33f062f47f21a01 = function cleanValue(value) {
    if ($92fc1d311188f0a9$var$isArray(value)) return value.filter(Boolean);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
var $92fc1d311188f0a9$export$8e9fd4287627890c = function cleanCommonProps(props) {
    //className
    var className = props.className, clearValue = props.clearValue, cx = props.cx, xcss = props.xcss, getStyles = props.getStyles, getClassNames = props.getClassNames, getValue = props.getValue, hasValue = props.hasValue, isMulti = props.isMulti, isRtl = props.isRtl, options = props.options, selectOption = props.selectOption, selectProps = props.selectProps, setValue = props.setValue, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(props, $92fc1d311188f0a9$var$_excluded);
    return $92fc1d311188f0a9$var$_objectSpread({}, innerProps);
};
var $92fc1d311188f0a9$export$26417cabd806a658 = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
function $92fc1d311188f0a9$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $92fc1d311188f0a9$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $92fc1d311188f0a9$export$2e0654fad740d2e4(el) {
    if ($92fc1d311188f0a9$export$d8a62a489b442872(el)) return window.innerHeight;
    return el.clientHeight;
}
function $92fc1d311188f0a9$export$c4a223a8ba9e4ea5(el) {
    if ($92fc1d311188f0a9$export$d8a62a489b442872(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $92fc1d311188f0a9$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($92fc1d311188f0a9$export$d8a62a489b442872(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $92fc1d311188f0a9$export$cfa2225e87938781(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
 * @param t: time (elapsed)
 * @param b: initial value
 * @param c: amount of change
 * @param d: duration
 */ function $92fc1d311188f0a9$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $92fc1d311188f0a9$export$858c30343199f3af(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $92fc1d311188f0a9$export$8793edee2d425525;
    var start = $92fc1d311188f0a9$export$c4a223a8ba9e4ea5(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $92fc1d311188f0a9$var$easeOutCubic(currentTime, start, change, duration);
        $92fc1d311188f0a9$export$3f99968195accfaf(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $92fc1d311188f0a9$export$53a0910f038337bd(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $92fc1d311188f0a9$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $92fc1d311188f0a9$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $92fc1d311188f0a9$export$7807c2a424c2f6d1(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
function $92fc1d311188f0a9$export$56963d77dbffdde7() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
function $92fc1d311188f0a9$export$44f917bf91becd01() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $92fc1d311188f0a9$var$passiveOptionAccessed = false;
var $92fc1d311188f0a9$var$options = {
    get passive () {
        return $92fc1d311188f0a9$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $92fc1d311188f0a9$var$w = typeof window !== 'undefined' ? window : {};
if ($92fc1d311188f0a9$var$w.addEventListener && $92fc1d311188f0a9$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $92fc1d311188f0a9$var$w.addEventListener('p', $92fc1d311188f0a9$export$8793edee2d425525, $92fc1d311188f0a9$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $92fc1d311188f0a9$var$w.removeEventListener('p', $92fc1d311188f0a9$export$8793edee2d425525, false);
}
var $92fc1d311188f0a9$export$b0622a6911dbeaf5 = $92fc1d311188f0a9$var$passiveOptionAccessed;
function $92fc1d311188f0a9$export$aedb69ff3e31596c(item) {
    return item != null;
}
function $92fc1d311188f0a9$var$isArray(arg) {
    return Array.isArray(arg);
}
function $92fc1d311188f0a9$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $92fc1d311188f0a9$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}
function $92fc1d311188f0a9$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}
var $92fc1d311188f0a9$export$4213b25a1c4e877 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $92fc1d311188f0a9$export$bf2eda47afa5f369 = function filterUnsupportedSelectors(styles) {
    var unsupportedSelectors = [
        ':',
        // pseudo-classes/elements
        '[',
        // attribute selectors
        '>',
        // child combinator
        '+',
        // adjacent sibling combinator
        '~',
        // general sibling combinator
        ' ',
        // descendant combinator
        '*',
        // universal selector
        '#',
        // ID selector
        '.',
        // class selector
        '@',
        // at-rules
        '&',
        // parent selector
        '|',
        // namespace separator
        '^',
        // starts with
        '$',
        // ends with
        '=' // equals
    ];
    return Object.keys(styles).reduce(function(filteredStyles, key) {
        if (!unsupportedSelectors.some(function(selector) {
            return key.includes(selector);
        })) filteredStyles[key] = styles[key];
        return filteredStyles;
    }, {});
};

});


parcelRegister("1VLd1", function(module, exports) {

$parcel$export(module.exports, "css", function () { return $167fbc08b296c337$export$dbf350e5966cf602; });
$parcel$export(module.exports, "default", function () { return $167fbc08b296c337$export$2e2bcd8739ae039; });
/* control.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $8kGa4 = parcelRequire("8kGa4");

var $cCoB6 = parcelRequire("cCoB6");
var $167fbc08b296c337$var$styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkofajl _v564r5cv _1h6d1elr _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _15peftgi _1ke8ftgi _jaboglyw _1u6l1bml _4cvx1elr _123byq51 _d0altlke _irr31d5g _1ogl1caj",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsq049",
    disabled: "_1h6dsyzs _lcxvglyw _bfhksyzs _1u6llkwx",
    focused: "_1h6d1p6i _bfhkr01l _16qsq049 _1u6lq049 _4cvx1p6i _irr3r01l",
    subtle: "_1h6d1j28 _bfhk1j28 _1u6l3sij",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d1j28 _bfhk1j28 _1u6l3sij _4cvx1j28 _irr31j28"
};
var $167fbc08b296c337$export$dbf350e5966cf602 = function css() {
    return {};
};
var $167fbc08b296c337$var$Control = function Control(props) {
    var children = props.children, appearance = props.appearance, isCompact = props.isCompact, isDisabled = props.isDisabled, isFocused = props.isFocused, isInvalid = props.isInvalid, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen, xcss = props.xcss;
    var _getStyleProps = (0, $cCoB6.getStyleProps)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $91i6m.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        ref: innerRef,
        className: (0, $9gzWK.default)([
            $167fbc08b296c337$var$styles.default,
            isDisabled && $167fbc08b296c337$var$styles.disabled,
            isInvalid && $167fbc08b296c337$var$styles.invalid,
            isCompact && $167fbc08b296c337$var$styles.compact,
            appearance === 'subtle' && $167fbc08b296c337$var$styles.subtle,
            appearance === 'subtle' && isFocused && $167fbc08b296c337$var$styles.subtleFocused,
            isFocused && $167fbc08b296c337$var$styles.focused,
            appearance === 'none' && $167fbc08b296c337$var$styles.none,
            (0, $8kGa4.cx)(className, xcss, '-control')
        ]),
        style: css
    }, innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$167fbc08b296c337$export$2e2bcd8739ae039 = $167fbc08b296c337$var$Control;

});

parcelRegister("95vjP", function(module, exports) {

$parcel$export(module.exports, "groupCSS", function () { return $69dcdff55677d82d$export$b6794329c1460634; });
$parcel$export(module.exports, "groupHeadingCSS", function () { return $69dcdff55677d82d$export$e5a7fbb542efcb7d; });
$parcel$export(module.exports, "GroupHeading", function () { return $69dcdff55677d82d$export$85c8b41a3cd87edc; });
$parcel$export(module.exports, "default", function () { return $69dcdff55677d82d$export$2e2bcd8739ae039; });
/* group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $ai2Md = parcelRequire("ai2Md");

var $cIDQN = parcelRequire("cIDQN");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $8kGa4 = parcelRequire("8kGa4");

var $cCoB6 = parcelRequire("cCoB6");
var $69dcdff55677d82d$var$_excluded = [
    "data"
];
var $69dcdff55677d82d$var$styles = {
    root: "_n3tdu2gc _ca0qu2gc"
};
var $69dcdff55677d82d$export$b6794329c1460634 = function groupCSS() {
    return {};
};
var $69dcdff55677d82d$var$Group = function Group(props) {
    var children = props.children, builtinCX = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, selectProps = props.selectProps, xcss = props.xcss;
    var _getStyleProps = (0, $cCoB6.getStyleProps)(props, 'group', {
        group: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $91i6m.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css
    }, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9gzWK.default)([
            $69dcdff55677d82d$var$styles.root,
            (0, $8kGa4.cx)(className, xcss, innerProps === null || innerProps === void 0 ? void 0 : innerProps.className, '-Group')
        ])
    }), label && /*#__PURE__*/ $91i6m.createElement(Heading, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, headingProps, {
        selectProps: selectProps,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: builtinCX
    }), label), /*#__PURE__*/ $91i6m.createElement("div", null, children));
};
var $69dcdff55677d82d$var$headingStyles = null;
var $69dcdff55677d82d$export$e5a7fbb542efcb7d = function groupHeadingCSS() {
    return {};
};
var $69dcdff55677d82d$export$85c8b41a3cd87edc = function GroupHeading(props) {
    var xcss = props.xcss;
    var _cleanCommonProps = (0, $cCoB6.cleanCommonProps)(props), data = _cleanCommonProps.data, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_cleanCommonProps, $69dcdff55677d82d$var$_excluded);
    var _getStyleProps2 = (0, $cCoB6.getStyleProps)(props, 'groupHeading', {
        'group-heading': true
    }), css = _getStyleProps2.css, className = _getStyleProps2.className;
    return /*#__PURE__*/ $91i6m.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9gzWK.default)([
            "_11c81o8v _1e0c1ule _syaz1gjq _80om73ad _k48pmoej _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, $8kGa4.cx)(className, xcss, '-group')
        ]),
        style: css
    }, innerProps));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$69dcdff55677d82d$export$2e2bcd8739ae039 = $69dcdff55677d82d$var$Group;

});

parcelRegister("cBc2c", function(module, exports) {

$parcel$export(module.exports, "dropdownIndicatorCSS", function () { return $92c24682839cfd33$export$e1687335805e1230; });
$parcel$export(module.exports, "DropdownIndicator", function () { return $92c24682839cfd33$export$ec98719d3db7f2e4; });
$parcel$export(module.exports, "clearIndicatorCSS", function () { return $92c24682839cfd33$export$9c0419fd944c1def; });
$parcel$export(module.exports, "ClearIndicator", function () { return $92c24682839cfd33$export$ecf9cf59142dd54a; });
$parcel$export(module.exports, "loadingIndicatorCSS", function () { return $92c24682839cfd33$export$1d3f24cde248e6b5; });
$parcel$export(module.exports, "LoadingIndicator", function () { return $92c24682839cfd33$export$7c20be4c1d342248; });
/* indicators.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dsN6L = parcelRequire("dsN6L");

var $ai2Md = parcelRequire("ai2Md");

var $cIDQN = parcelRequire("cIDQN");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $8kGa4 = parcelRequire("8kGa4");

var $jpTaX = parcelRequire("jpTaX");

var $5Fr51 = parcelRequire("5Fr51");

var $dwV3h = parcelRequire("dwV3h");
var $kKNUG = parcelRequire("kKNUG");

var $9OWP7 = parcelRequire("9OWP7");

var $cCoB6 = parcelRequire("cCoB6");
var $92c24682839cfd33$var$_excluded = [
    "innerProps",
    "isRtl",
    "size",
    "isCompact",
    "xcss"
];
function $92c24682839cfd33$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $92c24682839cfd33$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $92c24682839cfd33$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $92c24682839cfd33$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $92c24682839cfd33$var$iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o"
};
var $92c24682839cfd33$var$dropdownWrapperStyles = {
    root: "_ca0q12x7 _u5f312x7 _n3td12x7 _19bv12x7"
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $92c24682839cfd33$var$dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1gjq _ca0q12x7 _u5f3v77o _n3td12x7 _19bvv77o _30l31gjq",
    compact: "_ca0qidpf _n3tdidpf",
    disabled: "_syaz1lh4"
};
var $92c24682839cfd33$export$e1687335805e1230 = function dropdownIndicatorCSS() {
    return {};
};
var $92c24682839cfd33$export$ec98719d3db7f2e4 = function DropdownIndicator(props) {
    var innerProps = props.innerProps, children = props.children, isDisabled = props.isDisabled, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps = (0, $cCoB6.getStyleProps)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $91i6m.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $9gzWK.default)([
            $92c24682839cfd33$var$dropdownStyles.default,
            isDisabled && $92c24682839cfd33$var$dropdownStyles.disabled,
            isCompact && $92c24682839cfd33$var$dropdownStyles.compact,
            (0, $8kGa4.cx)(className, xcss, '-indicatorContainer')
        ])
    }, innerProps), children ? children : /*#__PURE__*/ $91i6m.createElement((0, $dwV3h.default), {
        as: "span",
        xcss: $92c24682839cfd33$var$dropdownWrapperStyles.root
    }, /*#__PURE__*/ $91i6m.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jpTaX))), {
        color: "currentColor",
        label: "open",
        LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)",
        size: "small"
    })));
};
var $92c24682839cfd33$export$9c0419fd944c1def = function clearIndicatorCSS() {
    return {};
};
var $92c24682839cfd33$var$clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz131l _ca0q12x7 _u5f3v77o _n3td12x7 _19bvv77o _30l31gjq",
    compact: "_ca0qidpf _n3tdidpf"
};
var $92c24682839cfd33$export$ecf9cf59142dd54a = function ClearIndicator(props) {
    var innerProps = props.innerProps, _props$clearControlLa = props.clearControlLabel, clearControlLabel = _props$clearControlLa === void 0 ? 'clear' : _props$clearControlLa, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps2 = (0, $cCoB6.getStyleProps)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), css = _getStyleProps2.css, className = _getStyleProps2.className;
    return /*#__PURE__*/ $91i6m.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $9gzWK.default)([
            $92c24682839cfd33$var$clearIndicatorStyles.default,
            isCompact && $92c24682839cfd33$var$clearIndicatorStyles.compact,
            (0, $8kGa4.cx)(className, xcss, '-indicatorContainer')
        ])
    }, innerProps), /*#__PURE__*/ $91i6m.createElement((0, $kKNUG.default), {
        xcss: $92c24682839cfd33$var$iconContainerStyles.root,
        tabIndex: -1,
        "aria-label": clearControlLabel
    }, /*#__PURE__*/ $91i6m.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5Fr51))), {
        label: "",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)",
        size: "small"
    })));
};
var $92c24682839cfd33$export$1d3f24cde248e6b5 = function loadingIndicatorCSS() {
    return {};
};
var $92c24682839cfd33$var$loadingIndicatorStyles = {
    default: "_ca0q12x7 _u5f3u2gc _n3td12x7 _19bvu2gc",
    compact: "_ca0qidpf _n3tdidpf"
};
var $92c24682839cfd33$export$7c20be4c1d342248 = function LoadingIndicator(_ref) {
    var innerProps = _ref.innerProps, isRtl = _ref.isRtl, _ref$size = _ref.size, size = _ref$size === void 0 ? 4 : _ref$size, isCompact = _ref.isCompact, xcss = _ref.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $92c24682839cfd33$var$_excluded);
    var _getStyleProps3 = (0, $cCoB6.getStyleProps)($92c24682839cfd33$var$_objectSpread($92c24682839cfd33$var$_objectSpread({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), css = _getStyleProps3.css, className = _getStyleProps3.className;
    return /*#__PURE__*/ $91i6m.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $9gzWK.default)([
            $92c24682839cfd33$var$loadingIndicatorStyles.default,
            isCompact && $92c24682839cfd33$var$loadingIndicatorStyles.compact,
            (0, $8kGa4.cx)(className, xcss, '-loadingIndicator')
        ])
    }, innerProps), /*#__PURE__*/ $91i6m.createElement((0, $9OWP7.default), {
        size: "small"
    }));
};

});
parcelRegister("jpTaX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d03862cd3f81bd2eb2145cf11d082237>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e22b26e4c24f01f4$var$_react = $e22b26e4c24f01f4$var$_interopRequireDefault((parcelRequire("91i6m")));

var $e22b26e4c24f01f4$var$_chevronDown = $e22b26e4c24f01f4$var$_interopRequireDefault((parcelRequire("3cbc0")));

var $e22b26e4c24f01f4$var$_chevronDown2 = $e22b26e4c24f01f4$var$_interopRequireDefault((parcelRequire("kxkPV")));
function $e22b26e4c24f01f4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "ChevronDownIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e22b26e4c24f01f4$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $e22b26e4c24f01f4$var$_react.default.createElement($e22b26e4c24f01f4$var$_chevronDown.default, Object.assign({
        name: "ChevronDownIcon",
        LEGACY_fallbackIcon: $e22b26e4c24f01f4$var$_chevronDown2.default
    }, props));
$e22b26e4c24f01f4$var$ChevronDownIcon.displayName = 'ChevronDownIconMigration';
var $e22b26e4c24f01f4$var$_default = module.exports.default = $e22b26e4c24f01f4$var$ChevronDownIcon;

});
parcelRegister("3cbc0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $253b2cb0fb6fdfcd$var$_react = $253b2cb0fb6fdfcd$var$_interopRequireDefault((parcelRequire("91i6m")));

var $253b2cb0fb6fdfcd$var$_baseNew = $253b2cb0fb6fdfcd$var$_interopRequireDefault((parcelRequire("dfGW3")));
function $253b2cb0fb6fdfcd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $253b2cb0fb6fdfcd$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $253b2cb0fb6fdfcd$var$_react.default.createElement($253b2cb0fb6fdfcd$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$253b2cb0fb6fdfcd$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $253b2cb0fb6fdfcd$var$_default = module.exports.default = $253b2cb0fb6fdfcd$var$ChevronDownIcon;

});
parcelRegister("dfGW3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("6Pk1i")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("6Pk1i")).Icon; });

var $6Pk1i = parcelRequire("6Pk1i");

});
parcelRegister("6Pk1i", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $01485f1d22d787e3$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $01485f1d22d787e3$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $f1k1y = parcelRequire("f1k1y");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $01485f1d22d787e3$var$svgStyles = null;
var $01485f1d22d787e3$var$iconStyles = null;
var $01485f1d22d787e3$var$utilityIconStyles = null;
var $01485f1d22d787e3$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $01485f1d22d787e3$var$baseHcmStyles = null;
var $01485f1d22d787e3$var$scaleSize = null;
var $01485f1d22d787e3$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $01485f1d22d787e3$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $01485f1d22d787e3$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $01485f1d22d787e3$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $01485f1d22d787e3$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $01485f1d22d787e3$export$f04a61298a47a40f = /*#__PURE__*/ (0, $91i6m.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $f1k1y.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $91i6m.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = $01485f1d22d787e3$var$baseSizeMap[type];
    var viewBoxPadding = $01485f1d22d787e3$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $91i6m.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $9gzWK.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $91i6m.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $9gzWK.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $01485f1d22d787e3$var$utilSizes[spacing] : size === 'small' ? $01485f1d22d787e3$var$coreSizeSmall[spacing] : $01485f1d22d787e3$var$coreSizeMedium[spacing]
        ])
    }));
});
var $01485f1d22d787e3$export$2e2bcd8739ae039 = $01485f1d22d787e3$export$f04a61298a47a40f;

});



parcelRegister("kxkPV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef370d6d6cfa27f9$var$_react = $ef370d6d6cfa27f9$var$_interopRequireDefault((parcelRequire("91i6m")));

var $bM5dY = parcelRequire("bM5dY");
function $ef370d6d6cfa27f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ef370d6d6cfa27f9$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $ef370d6d6cfa27f9$var$_react.default.createElement($bM5dY.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props));
$ef370d6d6cfa27f9$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $ef370d6d6cfa27f9$var$_default = module.exports.default = $ef370d6d6cfa27f9$var$ChevronDownIcon;

});
parcelRegister("bM5dY", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $89283ad5f942fa93$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");
function $89283ad5f942fa93$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $89283ad5f942fa93$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $89283ad5f942fa93$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $89283ad5f942fa93$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $89283ad5f942fa93$var$iconStyles = null;
var $89283ad5f942fa93$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $89283ad5f942fa93$var$baseHcmStyles = null;
var $89283ad5f942fa93$var$primaryEqualsSecondaryHcmStyles = null;
var $89283ad5f942fa93$var$secondaryTransparentHcmStyles = null;
var $89283ad5f942fa93$export$f04a61298a47a40f = /*#__PURE__*/ (0, $91i6m.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $91i6m.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $91i6m.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $89283ad5f942fa93$var$_objectSpread($89283ad5f942fa93$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $9gzWK.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $89283ad5f942fa93$var$sizeStyles[size]
        ])
    }));
});
var $89283ad5f942fa93$export$2e2bcd8739ae039 = $89283ad5f942fa93$export$f04a61298a47a40f;

});



parcelRegister("5Fr51", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c64b1bb7f30549dd379d26abd8d4a76>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4205c99f960c4fb5$var$_react = $4205c99f960c4fb5$var$_interopRequireDefault((parcelRequire("91i6m")));

var $4205c99f960c4fb5$var$_crossCircle = $4205c99f960c4fb5$var$_interopRequireDefault((parcelRequire("de4AL")));

var $4205c99f960c4fb5$var$_selectClear = $4205c99f960c4fb5$var$_interopRequireDefault((parcelRequire("hUhx6")));
function $4205c99f960c4fb5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4205c99f960c4fb5$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $4205c99f960c4fb5$var$_react.default.createElement($4205c99f960c4fb5$var$_crossCircle.default, Object.assign({
        name: "CrossCircleIcon",
        LEGACY_fallbackIcon: $4205c99f960c4fb5$var$_selectClear.default
    }, props));
$4205c99f960c4fb5$var$CrossCircleIcon.displayName = 'CrossCircleIconMigration';
var $4205c99f960c4fb5$var$_default = module.exports.default = $4205c99f960c4fb5$var$CrossCircleIcon;

});
parcelRegister("de4AL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3eb90e0e095210547df6d71f04e27a56>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9a10250eba9e7360$var$_react = $9a10250eba9e7360$var$_interopRequireDefault((parcelRequire("91i6m")));

var $9a10250eba9e7360$var$_baseNew = $9a10250eba9e7360$var$_interopRequireDefault((parcelRequire("dfGW3")));
function $9a10250eba9e7360$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9a10250eba9e7360$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $9a10250eba9e7360$var$_react.default.createElement($9a10250eba9e7360$var$_baseNew.default, Object.assign({
        name: "CrossCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$9a10250eba9e7360$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $9a10250eba9e7360$var$_default = module.exports.default = $9a10250eba9e7360$var$CrossCircleIcon;

});

parcelRegister("hUhx6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0954453c723a0dd$var$_react = $d0954453c723a0dd$var$_interopRequireDefault((parcelRequire("91i6m")));

var $bM5dY = parcelRequire("bM5dY");
function $d0954453c723a0dd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d0954453c723a0dd$var$SelectClearIcon = (props)=>/*#__PURE__*/ $d0954453c723a0dd$var$_react.default.createElement($bM5dY.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props));
$d0954453c723a0dd$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $d0954453c723a0dd$var$_default = module.exports.default = $d0954453c723a0dd$var$SelectClearIcon;

});



parcelRegister("kpjkf", function(module, exports) {

$parcel$export(module.exports, "inputCSS", function () { return $edb5221bcdfb6b4f$export$14a7781d0ca7abea; });
$parcel$export(module.exports, "default", function () { return $edb5221bcdfb6b4f$export$2e2bcd8739ae039; });
/* input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $8kGa4 = parcelRequire("8kGa4");

var $f1k1y = parcelRequire("f1k1y");

var $cCoB6 = parcelRequire("cCoB6");
var $edb5221bcdfb6b4f$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName",
    "testId"
];
var $edb5221bcdfb6b4f$export$14a7781d0ca7abea = function inputCSS() {
    return {};
};
var $edb5221bcdfb6b4f$var$inputStylesOld = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syaz1fxt _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq"
};
var $edb5221bcdfb6b4f$var$inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _kqswh2mm _1e0c1txw _yv0e12qd _syaz1fxt _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq"
};
var $edb5221bcdfb6b4f$var$nativeInputStylesOld = null;
var $edb5221bcdfb6b4f$var$nativeInputStyles = null;
var $edb5221bcdfb6b4f$var$hidden = null;
var $edb5221bcdfb6b4f$var$Input = function Input(props) {
    var builtinCX = props.cx, value = props.value, xcss = props.xcss;
    var _cleanCommonProps = (0, $cCoB6.cleanCommonProps)(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, testId = _cleanCommonProps.testId, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_cleanCommonProps, $edb5221bcdfb6b4f$var$_excluded);
    var dataId = testId ? "".concat(testId, "-select--input") : null;
    var _getStyleProps = (0, $cCoB6.getStyleProps)(props, 'input', {
        'input-container': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    if ((0, $f1k1y.fg)('platform_do_not_clear_input_for_multiselect')) return /*#__PURE__*/ $91i6m.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $9gzWK.default)([
            $edb5221bcdfb6b4f$var$inputStyles.root,
            isDisabled && $edb5221bcdfb6b4f$var$inputStyles.disabled,
            (0, $8kGa4.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $91i6m.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9gzWK.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1r04idpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _kqswstnw _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, '-input')
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
    return /*#__PURE__*/ $91i6m.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $9gzWK.default)([
            $edb5221bcdfb6b4f$var$inputStylesOld.root,
            isDisabled && $edb5221bcdfb6b4f$var$inputStylesOld.disabled,
            (0, $8kGa4.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $91i6m.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9gzWK.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, '-input')
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$edb5221bcdfb6b4f$export$2e2bcd8739ae039 = $edb5221bcdfb6b4f$var$Input;

});

parcelRegister("gVvyR", function(module, exports) {

$parcel$export(module.exports, "menuCSS", function () { return $c52a73a3d6fae2db$export$a228922d5ca42a79; });
$parcel$export(module.exports, "MenuPlacer", function () { return $c52a73a3d6fae2db$export$f32337f3a7617699; });
$parcel$export(module.exports, "default", function () { return $c52a73a3d6fae2db$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "menuListCSS", function () { return $c52a73a3d6fae2db$export$abafed69cff95d5e; });
$parcel$export(module.exports, "MenuList", function () { return $c52a73a3d6fae2db$export$d4c4e98c5044dc8; });
$parcel$export(module.exports, "noOptionsMessageCSS", function () { return $c52a73a3d6fae2db$export$cf0e22534d8b0074; });
$parcel$export(module.exports, "loadingMessageCSS", function () { return $c52a73a3d6fae2db$export$98ec46397a8cb3cd; });
$parcel$export(module.exports, "NoOptionsMessage", function () { return $c52a73a3d6fae2db$export$d58b72b7d3c4072c; });
$parcel$export(module.exports, "LoadingMessage", function () { return $c52a73a3d6fae2db$export$e928a71d039d3102; });
$parcel$export(module.exports, "menuPortalCSS", function () { return $c52a73a3d6fae2db$export$1dbbeb9648d1fdc9; });
$parcel$export(module.exports, "MenuPortal", function () { return $c52a73a3d6fae2db$export$793392f970497feb; });
/* menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $ai2Md = parcelRequire("ai2Md");

var $cIDQN = parcelRequire("cIDQN");

var $dsN6L = parcelRequire("dsN6L");

var $5YM7L = parcelRequire("5YM7L");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $8kGa4 = parcelRequire("8kGa4");

var $1NnqZ = parcelRequire("1NnqZ");

var $eAqbf = parcelRequire("eAqbf");

var $lpKNg = parcelRequire("lpKNg");

var $7oEAU = parcelRequire("7oEAU");

var $cCoB6 = parcelRequire("cCoB6");
var $c52a73a3d6fae2db$var$_excluded = [
    "children",
    "innerProps",
    "xcss"
], $c52a73a3d6fae2db$var$_excluded2 = [
    "children",
    "innerProps",
    "xcss"
];
function $c52a73a3d6fae2db$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c52a73a3d6fae2db$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c52a73a3d6fae2db$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c52a73a3d6fae2db$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// ==============================
// Menu
// ==============================
// Get Menu Placement
// ------------------------------
function $c52a73a3d6fae2db$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = (0, $cCoB6.getScrollParent)(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : (0, $cCoB6.normalizedHeight)(scrollParent);
    var scrollTop = (0, $cCoB6.getScrollTop)(scrollParent);
    var menuTopFromParent = menuTop;
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTopFromParent;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $cCoB6.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) (0, $cCoB6.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) (0, $cCoB6.scrollTo)(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $cCoB6.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) (0, $cCoB6.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
var $c52a73a3d6fae2db$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $c52a73a3d6fae2db$var$menuStyles = {
    root: "_2rko12b0 _kqswstnw _1bsb1osq _1pbykb7n _otyru2gc _19pku2gc _bfhk1bhr _16qsd0yg",
    bottom: "_154i1osq",
    top: "_94n51osq"
};
var $c52a73a3d6fae2db$export$a228922d5ca42a79 = function menuCSS() {
    return {};
};
var $c52a73a3d6fae2db$var$PortalPlacementContext = /*#__PURE__*/ (0, $91i6m.createContext)(null);
var $c52a73a3d6fae2db$export$f32337f3a7617699 = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView;
    var _ref2 = (0, $91i6m.useContext)($c52a73a3d6fae2db$var$PortalPlacementContext) || {}, setPortalPlacement = _ref2.setPortalPlacement;
    var ref = (0, $91i6m.useRef)(null);
    var _useState = (0, $91i6m.useState)(maxMenuHeight), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $91i6m.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    // The minimum height of the control
    var controlHeight = 38;
    (0, $lpKNg.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $c52a73a3d6fae2db$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: $c52a73a3d6fae2db$var$_objectSpread($c52a73a3d6fae2db$var$_objectSpread({}, props), {}, {
            placement: placement || $c52a73a3d6fae2db$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $c52a73a3d6fae2db$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps, _props$placement = props.placement, placement = _props$placement === void 0 ? 'bottom' : _props$placement, xcss = props.xcss;
    var _getStyleProps = (0, $cCoB6.getStyleProps)(props, 'menu', {
        menu: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $91i6m.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9gzWK.default)([
            $c52a73a3d6fae2db$var$menuStyles.root,
            $c52a73a3d6fae2db$var$menuStyles[placement],
            (0, $8kGa4.cx)(xcss, className, '-menu')
        ]),
        style: css,
        ref: innerRef
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c52a73a3d6fae2db$export$2e2bcd8739ae039 = $c52a73a3d6fae2db$var$Menu;
var $c52a73a3d6fae2db$export$abafed69cff95d5e = function menuListCSS() {
    return {};
};
var $c52a73a3d6fae2db$var$menuListStyles = null;
var $c52a73a3d6fae2db$export$d4c4e98c5044dc8 = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti, maxHeight = props.maxHeight, xcss = props.xcss;
    var _getStyleProps2 = (0, $cCoB6.getStyleProps)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), css = _getStyleProps2.css, className = _getStyleProps2.className;
    return /*#__PURE__*/ $91i6m.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9gzWK.default)([
            "_kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, $8kGa4.cx)(className, xcss, '-MenuList')
        ]),
        style: $c52a73a3d6fae2db$var$_objectSpread($c52a73a3d6fae2db$var$_objectSpread({}, css), {}, {
            maxHeight: maxHeight
        }),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};
// ==============================
// Menu Notices
// ==============================
var $c52a73a3d6fae2db$var$noticeCSS = function noticeCSS() {
    return {};
};
var $c52a73a3d6fae2db$var$noticeStyles = null;
var $c52a73a3d6fae2db$export$cf0e22534d8b0074 = $c52a73a3d6fae2db$var$noticeCSS;
var $c52a73a3d6fae2db$export$98ec46397a8cb3cd = $c52a73a3d6fae2db$var$noticeCSS;
var $c52a73a3d6fae2db$export$d58b72b7d3c4072c = function NoOptionsMessage(_ref3) {
    var _ref3$children = _ref3.children, children = _ref3$children === void 0 ? 'No options' : _ref3$children, innerProps = _ref3.innerProps, xcss = _ref3.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref3, $c52a73a3d6fae2db$var$_excluded);
    var _getStyleProps3 = (0, $cCoB6.getStyleProps)($c52a73a3d6fae2db$var$_objectSpread($c52a73a3d6fae2db$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), css = _getStyleProps3.css, className = _getStyleProps3.className;
    return /*#__PURE__*/ $91i6m.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9gzWK.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $8kGa4.cx)(className, xcss, '-NoOptionsMessage')
        ]),
        style: css,
        role: "option"
    }, innerProps), /*#__PURE__*/ $91i6m.createElement((0, $7oEAU.default), {
        color: "color.text.subtle"
    }, children));
};
var $c52a73a3d6fae2db$export$e928a71d039d3102 = function LoadingMessage(_ref4) {
    var _ref4$children = _ref4.children, children = _ref4$children === void 0 ? 'Loading...' : _ref4$children, innerProps = _ref4.innerProps, xcss = _ref4.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref4, $c52a73a3d6fae2db$var$_excluded2);
    var _getStyleProps4 = (0, $cCoB6.getStyleProps)($c52a73a3d6fae2db$var$_objectSpread($c52a73a3d6fae2db$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), css = _getStyleProps4.css, className = _getStyleProps4.className;
    return /*#__PURE__*/ $91i6m.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9gzWK.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $8kGa4.cx)(className, xcss, '-LoadingMessage')
        ]),
        style: css
    }, innerProps, {
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option"
    }), /*#__PURE__*/ $91i6m.createElement((0, $7oEAU.default), {
        color: "color.text.subtle"
    }, children));
};
var $c52a73a3d6fae2db$export$1dbbeb9648d1fdc9 = function menuPortalCSS() {
    return {};
};
var $c52a73a3d6fae2db$var$menuPortalStyles = {
    root: "_1pbykb7n _1ltva1vk _kqswcp1v _154i1nmo _1bsb1qxj"
};
var $c52a73a3d6fae2db$export$793392f970497feb = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, xcss = props.xcss;
    var menuPortalRef = (0, $91i6m.useRef)(null);
    var cleanupRef = (0, $91i6m.useRef)(null);
    var _useState5 = (0, $91i6m.useState)($c52a73a3d6fae2db$var$coercePlacement(menuPlacement)), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $91i6m.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $91i6m.useState)(null), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $91i6m.useCallback)(function() {
        if (!controlElement) return;
        var rect = (0, $cCoB6.getBoundingClientObj)(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $lpKNg.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $91i6m.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $1NnqZ.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $lpKNg.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $91i6m.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    var _getStyleProps5 = (0, $cCoB6.getStyleProps)($c52a73a3d6fae2db$var$_objectSpread($c52a73a3d6fae2db$var$_objectSpread({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), css = _getStyleProps5.css, className = _getStyleProps5.className;
    // same wrapper element whether fixed or portalled
    var menuWrapper = /*#__PURE__*/ $91i6m.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9gzWK.default)([
            $c52a73a3d6fae2db$var$menuPortalStyles.root,
            (0, $8kGa4.cx)(className, xcss, '-MenuPortal')
        ]),
        ref: setMenuPortalElement,
        style: $c52a73a3d6fae2db$var$_objectSpread({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--menu-left': "".concat(computedPosition.rect.left, "px"),
            '--menu-position': menuPosition,
            '--menu-top': "".concat(computedPosition.offset, "px"),
            '--menu-width': "".concat(computedPosition.rect.width, "px")
        }, css)
    }, innerProps), children);
    return /*#__PURE__*/ $91i6m.createElement($c52a73a3d6fae2db$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $eAqbf.createPortal)(menuWrapper, appendTo) : menuWrapper);
};

});
parcelRegister("1NnqZ", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", function () { return $14ec8b9da3ed0862$export$deee3a793edee05f; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $f6v9c = parcelRequire("f6v9c");
var $7OU8P = parcelRequire("7OU8P");

var $7OU8P = parcelRequire("7OU8P");

var $gqEkU = parcelRequire("gqEkU");
function $14ec8b9da3ed0862$var$getCssDimensions(element) {
    const css = (0, $gqEkU.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $gqEkU.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $7OU8P.round)(width) !== offsetWidth || (0, $7OU8P.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $14ec8b9da3ed0862$var$unwrapElement(element) {
    return !(0, $gqEkU.isElement)(element) ? element.contextElement : element;
}
function $14ec8b9da3ed0862$var$getScale(element) {
    const domElement = $14ec8b9da3ed0862$var$unwrapElement(element);
    if (!(0, $gqEkU.isHTMLElement)(domElement)) return (0, $7OU8P.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $14ec8b9da3ed0862$var$getCssDimensions(domElement);
    let x = ($ ? (0, $7OU8P.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $7OU8P.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $14ec8b9da3ed0862$var$noOffsets = /*#__PURE__*/ (0, $7OU8P.createCoords)(0);
function $14ec8b9da3ed0862$var$getVisualOffsets(element) {
    const win = (0, $gqEkU.getWindow)(element);
    if (!(0, $gqEkU.isWebKit)() || !win.visualViewport) return $14ec8b9da3ed0862$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $14ec8b9da3ed0862$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $gqEkU.getWindow)(element)) return false;
    return isFixed;
}
function $14ec8b9da3ed0862$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $14ec8b9da3ed0862$var$unwrapElement(element);
    let scale = (0, $7OU8P.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $gqEkU.isElement)(offsetParent)) scale = $14ec8b9da3ed0862$var$getScale(offsetParent);
        } else scale = $14ec8b9da3ed0862$var$getScale(element);
    }
    const visualOffsets = $14ec8b9da3ed0862$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $14ec8b9da3ed0862$var$getVisualOffsets(domElement) : (0, $7OU8P.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $gqEkU.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $gqEkU.isElement)(offsetParent) ? (0, $gqEkU.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = currentWin.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $14ec8b9da3ed0862$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $gqEkU.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $gqEkU.getWindow)(currentIFrame);
            currentIFrame = currentWin.frameElement;
        }
    }
    return (0, $7OU8P.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $14ec8b9da3ed0862$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $gqEkU.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $gqEkU.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $7OU8P.createCoords)(1);
    const offsets = (0, $7OU8P.createCoords)(0);
    const isOffsetParentAnElement = (0, $gqEkU.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $gqEkU.getNodeName)(offsetParent) !== 'body' || (0, $gqEkU.isOverflowElement)(documentElement)) scroll = (0, $gqEkU.getNodeScroll)(offsetParent);
        if ((0, $gqEkU.isHTMLElement)(offsetParent)) {
            const offsetRect = $14ec8b9da3ed0862$var$getBoundingClientRect(offsetParent);
            scale = $14ec8b9da3ed0862$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $14ec8b9da3ed0862$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $14ec8b9da3ed0862$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $14ec8b9da3ed0862$var$getBoundingClientRect((0, $gqEkU.getDocumentElement)(element)).left + (0, $gqEkU.getNodeScroll)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $14ec8b9da3ed0862$var$getDocumentRect(element) {
    const html = (0, $gqEkU.getDocumentElement)(element);
    const scroll = (0, $gqEkU.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $7OU8P.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $7OU8P.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $14ec8b9da3ed0862$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $gqEkU.getComputedStyle)(body).direction === 'rtl') x += (0, $7OU8P.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $14ec8b9da3ed0862$var$getViewportRect(element, strategy) {
    const win = (0, $gqEkU.getWindow)(element);
    const html = (0, $gqEkU.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $gqEkU.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $14ec8b9da3ed0862$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $14ec8b9da3ed0862$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $gqEkU.isHTMLElement)(element) ? $14ec8b9da3ed0862$var$getScale(element) : (0, $7OU8P.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $14ec8b9da3ed0862$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $14ec8b9da3ed0862$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $14ec8b9da3ed0862$var$getDocumentRect((0, $gqEkU.getDocumentElement)(element));
    else if ((0, $gqEkU.isElement)(clippingAncestor)) rect = $14ec8b9da3ed0862$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $14ec8b9da3ed0862$var$getVisualOffsets(element);
        rect = (0, $b2I6k._)((0, $1Fos3._)({}, clippingAncestor), {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        });
    }
    return (0, $7OU8P.rectToClientRect)(rect);
}
function $14ec8b9da3ed0862$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $gqEkU.getParentNode)(element);
    if (parentNode === stopNode || !(0, $gqEkU.isElement)(parentNode) || (0, $gqEkU.isLastTraversableNode)(parentNode)) return false;
    return (0, $gqEkU.getComputedStyle)(parentNode).position === 'fixed' || $14ec8b9da3ed0862$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $14ec8b9da3ed0862$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $gqEkU.getOverflowAncestors)(element, [], false).filter((el)=>(0, $gqEkU.isElement)(el) && (0, $gqEkU.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $gqEkU.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $gqEkU.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $gqEkU.isElement)(currentNode) && !(0, $gqEkU.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $gqEkU.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $gqEkU.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $gqEkU.isOverflowElement)(currentNode) && !currentNodeIsContaining && $14ec8b9da3ed0862$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $gqEkU.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $14ec8b9da3ed0862$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $gqEkU.isTopLayer)(element) ? [] : $14ec8b9da3ed0862$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $14ec8b9da3ed0862$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $7OU8P.max)(rect.top, accRect.top);
        accRect.right = (0, $7OU8P.min)(rect.right, accRect.right);
        accRect.bottom = (0, $7OU8P.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $7OU8P.max)(rect.left, accRect.left);
        return accRect;
    }, $14ec8b9da3ed0862$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $14ec8b9da3ed0862$var$getDimensions(element) {
    const { width: width, height: height } = $14ec8b9da3ed0862$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $14ec8b9da3ed0862$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $gqEkU.isHTMLElement)(offsetParent);
    const documentElement = (0, $gqEkU.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $14ec8b9da3ed0862$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $7OU8P.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $gqEkU.getNodeName)(offsetParent) !== 'body' || (0, $gqEkU.isOverflowElement)(documentElement)) scroll = (0, $gqEkU.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $14ec8b9da3ed0862$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $14ec8b9da3ed0862$var$getWindowScrollBarX(documentElement);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x;
    const y = rect.top + scroll.scrollTop - offsets.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $14ec8b9da3ed0862$var$isStaticPositioned(element) {
    return (0, $gqEkU.getComputedStyle)(element).position === 'static';
}
function $14ec8b9da3ed0862$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $gqEkU.isHTMLElement)(element) || (0, $gqEkU.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $14ec8b9da3ed0862$var$getOffsetParent(element, polyfill) {
    const win = (0, $gqEkU.getWindow)(element);
    if ((0, $gqEkU.isTopLayer)(element)) return win;
    if (!(0, $gqEkU.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $gqEkU.getParentNode)(element);
        while(svgOffsetParent && !(0, $gqEkU.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $gqEkU.isElement)(svgOffsetParent) && !$14ec8b9da3ed0862$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $gqEkU.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $14ec8b9da3ed0862$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $gqEkU.isTableElement)(offsetParent) && $14ec8b9da3ed0862$var$isStaticPositioned(offsetParent))offsetParent = $14ec8b9da3ed0862$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $gqEkU.isLastTraversableNode)(offsetParent) && $14ec8b9da3ed0862$var$isStaticPositioned(offsetParent) && !(0, $gqEkU.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $gqEkU.getContainingBlock)(element) || win;
}
const $14ec8b9da3ed0862$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $14ec8b9da3ed0862$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $14ec8b9da3ed0862$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $14ec8b9da3ed0862$var$isRTL(element) {
    return (0, $gqEkU.getComputedStyle)(element).direction === 'rtl';
}
const $14ec8b9da3ed0862$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $14ec8b9da3ed0862$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $gqEkU.getDocumentElement,
    getClippingRect: $14ec8b9da3ed0862$var$getClippingRect,
    getOffsetParent: $14ec8b9da3ed0862$var$getOffsetParent,
    getElementRects: $14ec8b9da3ed0862$var$getElementRects,
    getClientRects: $14ec8b9da3ed0862$var$getClientRects,
    getDimensions: $14ec8b9da3ed0862$var$getDimensions,
    getScale: $14ec8b9da3ed0862$var$getScale,
    isElement: $gqEkU.isElement,
    isRTL: $14ec8b9da3ed0862$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $14ec8b9da3ed0862$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $gqEkU.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $7OU8P.floor)(top);
        const insetRight = (0, $7OU8P.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $7OU8P.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $7OU8P.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $7OU8P.max)(0, (0, $7OU8P.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, (0, $b2I6k._)((0, $1Fos3._)({}, options), {
                // Handle <iframe>s
                root: root.ownerDocument
            }));
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $14ec8b9da3ed0862$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $14ec8b9da3ed0862$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $gqEkU.getOverflowAncestors)(referenceEl) : [],
        ...(0, $gqEkU.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $14ec8b9da3ed0862$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $14ec8b9da3ed0862$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $14ec8b9da3ed0862$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $14ec8b9da3ed0862$export$37b6bde19b108ecc = (0, $f6v9c.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $14ec8b9da3ed0862$export$cc800923e997bb8 = (0, $f6v9c.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $14ec8b9da3ed0862$export$91fb6ecbd551914 = (0, $f6v9c.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $14ec8b9da3ed0862$export$fba63a578e423eb = (0, $f6v9c.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $14ec8b9da3ed0862$export$8a83211c878a3f1f = (0, $f6v9c.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $14ec8b9da3ed0862$export$346677f925de839c = (0, $f6v9c.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $14ec8b9da3ed0862$export$fe8985bb6374093c = (0, $f6v9c.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $14ec8b9da3ed0862$export$f2120bbfa5450bd2 = (0, $f6v9c.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $14ec8b9da3ed0862$export$18c8ad048e32c7d5 = (0, $f6v9c.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $14ec8b9da3ed0862$export$7bf07e38f3dc4b69 = (0, $f6v9c.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $14ec8b9da3ed0862$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = (0, $1Fos3._)({
        platform: $14ec8b9da3ed0862$export$722a64dea1b767dc
    }, options);
    const platformWithCache = (0, $b2I6k._)((0, $1Fos3._)({}, mergedOptions.platform), {
        _c: cache
    });
    return (0, $f6v9c.computePosition)(reference, floating, (0, $b2I6k._)((0, $1Fos3._)({}, mergedOptions), {
        platform: platformWithCache
    }));
};

});
parcelRegister("f6v9c", function(module, exports) {

$parcel$export(module.exports, "computePosition", function () { return $afef93c57f4ae395$export$48a53dcb22e581d0; });
$parcel$export(module.exports, "detectOverflow", function () { return $afef93c57f4ae395$export$37b6bde19b108ecc; });
$parcel$export(module.exports, "arrow", function () { return $afef93c57f4ae395$export$f2120bbfa5450bd2; });
$parcel$export(module.exports, "autoPlacement", function () { return $afef93c57f4ae395$export$91fb6ecbd551914; });
$parcel$export(module.exports, "flip", function () { return $afef93c57f4ae395$export$8a83211c878a3f1f; });
$parcel$export(module.exports, "hide", function () { return $afef93c57f4ae395$export$fe8985bb6374093c; });
$parcel$export(module.exports, "inline", function () { return $afef93c57f4ae395$export$18c8ad048e32c7d5; });
$parcel$export(module.exports, "offset", function () { return $afef93c57f4ae395$export$cc800923e997bb8; });
$parcel$export(module.exports, "shift", function () { return $afef93c57f4ae395$export$fba63a578e423eb; });
$parcel$export(module.exports, "limitShift", function () { return $afef93c57f4ae395$export$7bf07e38f3dc4b69; });
$parcel$export(module.exports, "size", function () { return $afef93c57f4ae395$export$346677f925de839c; });
$parcel$export(module.exports, "rectToClientRect", function () { return (parcelRequire("7OU8P")).rectToClientRect; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $6NU0v = parcelRequire("6NU0v");

var $7OU8P = parcelRequire("7OU8P");
function $afef93c57f4ae395$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $7OU8P.getSideAxis)(placement);
    const alignmentAxis = (0, $7OU8P.getAlignmentAxis)(placement);
    const alignLength = (0, $7OU8P.getAxisLength)(alignmentAxis);
    const side = (0, $7OU8P.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $7OU8P.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $afef93c57f4ae395$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $afef93c57f4ae395$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = (0, $b2I6k._)((0, $1Fos3._)({}, middlewareData), {
            [name]: (0, $1Fos3._)({}, middlewareData[name], data)
        });
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $afef93c57f4ae395$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $afef93c57f4ae395$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $7OU8P.evaluate)(options, state);
    const paddingObject = (0, $7OU8P.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $7OU8P.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $7OU8P.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $afef93c57f4ae395$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $7OU8P.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $7OU8P.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $7OU8P.getAlignmentAxis)(placement);
            const length = (0, $7OU8P.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $7OU8P.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $7OU8P.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $7OU8P.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $7OU8P.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: (0, $1Fos3._)({
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset
                }, shouldAddOffset && {
                    alignmentOffset: alignmentOffset
                }),
                reset: shouldAddOffset
            };
        }
    });
function $afef93c57f4ae395$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $7OU8P.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $7OU8P.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $7OU8P.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $7OU8P.getAlignment)(placement) === alignment || (autoAlignment ? (0, $7OU8P.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $afef93c57f4ae395$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const _evaluate = (0, $7OU8P.evaluate)(options, state), { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $7OU8P.placements), autoAlignment: autoAlignment = true } = _evaluate, detectOverflowOptions = (0, $6NU0v._)(_evaluate, [
                "crossAxis",
                "alignment",
                "allowedPlacements",
                "autoAlignment"
            ]);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $7OU8P.placements) ? $afef93c57f4ae395$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $afef93c57f4ae395$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $7OU8P.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $7OU8P.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $7OU8P.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $7OU8P.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $afef93c57f4ae395$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const _evaluate = (0, $7OU8P.evaluate)(options, state), { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true } = _evaluate, detectOverflowOptions = (0, $6NU0v._)(_evaluate, [
                "mainAxis",
                "crossAxis",
                "fallbackPlacements",
                "fallbackStrategy",
                "fallbackAxisSideDirection",
                "flipAlignment"
            ]);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $7OU8P.getSide)(placement);
            const initialSideAxis = (0, $7OU8P.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $7OU8P.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $7OU8P.getOppositePlacement)(initialPlacement)
            ] : (0, $7OU8P.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $7OU8P.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $afef93c57f4ae395$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $7OU8P.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $7OU8P.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $afef93c57f4ae395$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $afef93c57f4ae395$var$isAnySideFullyClipped(overflow) {
    return (0, $7OU8P.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $afef93c57f4ae395$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const _evaluate = (0, $7OU8P.evaluate)(options, state), { strategy: strategy = 'referenceHidden' } = _evaluate, detectOverflowOptions = (0, $6NU0v._)(_evaluate, [
                "strategy"
            ]);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $afef93c57f4ae395$export$37b6bde19b108ecc(state, (0, $b2I6k._)((0, $1Fos3._)({}, detectOverflowOptions), {
                            elementContext: 'reference'
                        }));
                        const offsets = $afef93c57f4ae395$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $afef93c57f4ae395$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $afef93c57f4ae395$export$37b6bde19b108ecc(state, (0, $b2I6k._)((0, $1Fos3._)({}, detectOverflowOptions), {
                            altBoundary: true
                        }));
                        const offsets = $afef93c57f4ae395$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $afef93c57f4ae395$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $afef93c57f4ae395$var$getBoundingRect(rects) {
    const minX = (0, $7OU8P.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $7OU8P.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $7OU8P.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $7OU8P.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $afef93c57f4ae395$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $7OU8P.rectToClientRect)($afef93c57f4ae395$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $afef93c57f4ae395$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $7OU8P.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $afef93c57f4ae395$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $7OU8P.rectToClientRect)($afef93c57f4ae395$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $7OU8P.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $7OU8P.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $7OU8P.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $7OU8P.getSide)(placement) === 'left';
                    const maxRight = (0, $7OU8P.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $7OU8P.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $afef93c57f4ae395$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $7OU8P.getSide)(placement);
    const alignment = (0, $7OU8P.getAlignment)(placement);
    const isVertical = (0, $7OU8P.getSideAxis)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $7OU8P.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : (0, $1Fos3._)({
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null
    }, rawValue);
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $afef93c57f4ae395$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $afef93c57f4ae395$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: (0, $b2I6k._)((0, $1Fos3._)({}, diffCoords), {
                    placement: placement
                })
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $afef93c57f4ae395$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const _evaluate = (0, $7OU8P.evaluate)(options, state), { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            } } = _evaluate, detectOverflowOptions = (0, $6NU0v._)(_evaluate, [
                "mainAxis",
                "crossAxis",
                "limiter"
            ]);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $afef93c57f4ae395$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $7OU8P.getSideAxis)((0, $7OU8P.getSide)(placement));
            const mainAxis = (0, $7OU8P.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $7OU8P.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $7OU8P.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn((0, $b2I6k._)((0, $1Fos3._)({}, state), {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            }));
            return (0, $b2I6k._)((0, $1Fos3._)({}, limitedCoords), {
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            });
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $afef93c57f4ae395$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $7OU8P.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $7OU8P.getSideAxis)(placement);
            const mainAxis = (0, $7OU8P.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $7OU8P.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : (0, $1Fos3._)({
                mainAxis: 0,
                crossAxis: 0
            }, rawOffset);
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $7OU8P.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $afef93c57f4ae395$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const _evaluate = (0, $7OU8P.evaluate)(options, state), { apply: apply = ()=>{} } = _evaluate, detectOverflowOptions = (0, $6NU0v._)(_evaluate, [
                "apply"
            ]);
            const overflow = await $afef93c57f4ae395$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $7OU8P.getSide)(placement);
            const alignment = (0, $7OU8P.getAlignment)(placement);
            const isYAxis = (0, $7OU8P.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $7OU8P.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $7OU8P.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) availableWidth = alignment || noShift ? (0, $7OU8P.min)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            else availableHeight = alignment || noShift ? (0, $7OU8P.min)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $7OU8P.max)(overflow.left, 0);
                const xMax = (0, $7OU8P.max)(overflow.right, 0);
                const yMin = (0, $7OU8P.max)(overflow.top, 0);
                const yMax = (0, $7OU8P.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $7OU8P.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $7OU8P.max)(overflow.top, overflow.bottom));
            }
            await apply((0, $b2I6k._)((0, $1Fos3._)({}, state), {
                availableWidth: availableWidth,
                availableHeight: availableHeight
            }));
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("7OU8P", function(module, exports) {

$parcel$export(module.exports, "sides", function () { return $5b18c06fa6e81bfc$export$832b6fa47fa053d2; });
$parcel$export(module.exports, "placements", function () { return $5b18c06fa6e81bfc$export$803cd8101b6c182b; });
$parcel$export(module.exports, "min", function () { return $5b18c06fa6e81bfc$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $5b18c06fa6e81bfc$export$8960430cfd85939f; });
$parcel$export(module.exports, "round", function () { return $5b18c06fa6e81bfc$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "floor", function () { return $5b18c06fa6e81bfc$export$a3fe094919f356fd; });
$parcel$export(module.exports, "createCoords", function () { return $5b18c06fa6e81bfc$export$a397704b5e280835; });
$parcel$export(module.exports, "clamp", function () { return $5b18c06fa6e81bfc$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "evaluate", function () { return $5b18c06fa6e81bfc$export$fef61f332f2c0afc; });
$parcel$export(module.exports, "getSide", function () { return $5b18c06fa6e81bfc$export$3c915306cb7fc97a; });
$parcel$export(module.exports, "getAlignment", function () { return $5b18c06fa6e81bfc$export$f0989780f32bfcda; });
$parcel$export(module.exports, "getOppositeAxis", function () { return $5b18c06fa6e81bfc$export$8a000a963141ac32; });
$parcel$export(module.exports, "getAxisLength", function () { return $5b18c06fa6e81bfc$export$320bd9d53520c68a; });
$parcel$export(module.exports, "getSideAxis", function () { return $5b18c06fa6e81bfc$export$f28e8f882010718a; });
$parcel$export(module.exports, "getAlignmentAxis", function () { return $5b18c06fa6e81bfc$export$2b57e0052a6d6d4c; });
$parcel$export(module.exports, "getAlignmentSides", function () { return $5b18c06fa6e81bfc$export$be42861551f17911; });
$parcel$export(module.exports, "getOppositePlacement", function () { return $5b18c06fa6e81bfc$export$9c5e28bad23365fa; });
$parcel$export(module.exports, "getExpandedPlacements", function () { return $5b18c06fa6e81bfc$export$496432a3699e50b1; });
$parcel$export(module.exports, "getOppositeAlignmentPlacement", function () { return $5b18c06fa6e81bfc$export$2b182c584985588b; });
$parcel$export(module.exports, "getOppositeAxisPlacements", function () { return $5b18c06fa6e81bfc$export$a9b6fb18fd92c3ec; });
$parcel$export(module.exports, "getPaddingObject", function () { return $5b18c06fa6e81bfc$export$598c291c29bc2e71; });
$parcel$export(module.exports, "rectToClientRect", function () { return $5b18c06fa6e81bfc$export$ee05aea0aeecbad4; });
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ 
var $1Fos3 = parcelRequire("1Fos3");
const $5b18c06fa6e81bfc$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $5b18c06fa6e81bfc$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $5b18c06fa6e81bfc$export$803cd8101b6c182b = /*#__PURE__*/ $5b18c06fa6e81bfc$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $5b18c06fa6e81bfc$export$27b07d8a310ed8b5[0], side + "-" + $5b18c06fa6e81bfc$export$27b07d8a310ed8b5[1]), []);
const $5b18c06fa6e81bfc$export$96ec731ed4dcb222 = Math.min;
const $5b18c06fa6e81bfc$export$8960430cfd85939f = Math.max;
const $5b18c06fa6e81bfc$export$2077e0241d6afd3c = Math.round;
const $5b18c06fa6e81bfc$export$a3fe094919f356fd = Math.floor;
const $5b18c06fa6e81bfc$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $5b18c06fa6e81bfc$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $5b18c06fa6e81bfc$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $5b18c06fa6e81bfc$export$7d15b64cf5a3a4c4(start, value, end) {
    return $5b18c06fa6e81bfc$export$8960430cfd85939f(start, $5b18c06fa6e81bfc$export$96ec731ed4dcb222(value, end));
}
function $5b18c06fa6e81bfc$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $5b18c06fa6e81bfc$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $5b18c06fa6e81bfc$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $5b18c06fa6e81bfc$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $5b18c06fa6e81bfc$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $5b18c06fa6e81bfc$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($5b18c06fa6e81bfc$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $5b18c06fa6e81bfc$export$2b57e0052a6d6d4c(placement) {
    return $5b18c06fa6e81bfc$export$8a000a963141ac32($5b18c06fa6e81bfc$export$f28e8f882010718a(placement));
}
function $5b18c06fa6e81bfc$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $5b18c06fa6e81bfc$export$f0989780f32bfcda(placement);
    const alignmentAxis = $5b18c06fa6e81bfc$export$2b57e0052a6d6d4c(placement);
    const length = $5b18c06fa6e81bfc$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $5b18c06fa6e81bfc$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $5b18c06fa6e81bfc$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $5b18c06fa6e81bfc$export$496432a3699e50b1(placement) {
    const oppositePlacement = $5b18c06fa6e81bfc$export$9c5e28bad23365fa(placement);
    return [
        $5b18c06fa6e81bfc$export$2b182c584985588b(placement),
        oppositePlacement,
        $5b18c06fa6e81bfc$export$2b182c584985588b(oppositePlacement)
    ];
}
function $5b18c06fa6e81bfc$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$5b18c06fa6e81bfc$var$oppositeAlignmentMap[alignment]);
}
function $5b18c06fa6e81bfc$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $5b18c06fa6e81bfc$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $5b18c06fa6e81bfc$export$f0989780f32bfcda(placement);
    let list = $5b18c06fa6e81bfc$var$getSideList($5b18c06fa6e81bfc$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($5b18c06fa6e81bfc$export$2b182c584985588b));
    }
    return list;
}
function $5b18c06fa6e81bfc$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$5b18c06fa6e81bfc$var$oppositeSideMap[side]);
}
function $5b18c06fa6e81bfc$export$1c66dbf1a9e34223(padding) {
    return (0, $1Fos3._)({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }, padding);
}
function $5b18c06fa6e81bfc$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $5b18c06fa6e81bfc$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $5b18c06fa6e81bfc$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("gqEkU", function(module, exports) {

$parcel$export(module.exports, "getNodeName", function () { return $bf5e5cfad2ed813e$export$651544f548703224; });
$parcel$export(module.exports, "getWindow", function () { return $bf5e5cfad2ed813e$export$38b2d434cce3ea22; });
$parcel$export(module.exports, "getDocumentElement", function () { return $bf5e5cfad2ed813e$export$e495491855dc5418; });
$parcel$export(module.exports, "isElement", function () { return $bf5e5cfad2ed813e$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $bf5e5cfad2ed813e$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isOverflowElement", function () { return $bf5e5cfad2ed813e$export$989e911fa9af580a; });
$parcel$export(module.exports, "getComputedStyle", function () { return $bf5e5cfad2ed813e$export$3735103072e4a80; });
$parcel$export(module.exports, "isTableElement", function () { return $bf5e5cfad2ed813e$export$71535ffaa902797f; });
$parcel$export(module.exports, "isTopLayer", function () { return $bf5e5cfad2ed813e$export$89e651af02346cd4; });
$parcel$export(module.exports, "isContainingBlock", function () { return $bf5e5cfad2ed813e$export$d6c4e8150c35fed1; });
$parcel$export(module.exports, "isWebKit", function () { return $bf5e5cfad2ed813e$export$78551043582a6a98; });
$parcel$export(module.exports, "getContainingBlock", function () { return $bf5e5cfad2ed813e$export$940d8225183e1404; });
$parcel$export(module.exports, "getParentNode", function () { return $bf5e5cfad2ed813e$export$4e12058fc4d51d56; });
$parcel$export(module.exports, "isLastTraversableNode", function () { return $bf5e5cfad2ed813e$export$d1162fb0b6d4cd51; });
$parcel$export(module.exports, "getNodeScroll", function () { return $bf5e5cfad2ed813e$export$dc8fc79fa2800137; });
$parcel$export(module.exports, "getOverflowAncestors", function () { return $bf5e5cfad2ed813e$export$3b57c1601291186b; });
function $bf5e5cfad2ed813e$export$651544f548703224(node) {
    if ($bf5e5cfad2ed813e$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $bf5e5cfad2ed813e$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $bf5e5cfad2ed813e$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($bf5e5cfad2ed813e$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $bf5e5cfad2ed813e$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $bf5e5cfad2ed813e$export$38b2d434cce3ea22(value).Node;
}
function $bf5e5cfad2ed813e$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $bf5e5cfad2ed813e$export$38b2d434cce3ea22(value).Element;
}
function $bf5e5cfad2ed813e$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $bf5e5cfad2ed813e$export$38b2d434cce3ea22(value).HTMLElement;
}
function $bf5e5cfad2ed813e$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $bf5e5cfad2ed813e$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $bf5e5cfad2ed813e$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $bf5e5cfad2ed813e$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $bf5e5cfad2ed813e$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($bf5e5cfad2ed813e$export$651544f548703224(element));
}
function $bf5e5cfad2ed813e$export$89e651af02346cd4(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $bf5e5cfad2ed813e$export$d6c4e8150c35fed1(element) {
    const webkit = $bf5e5cfad2ed813e$export$78551043582a6a98();
    const css = $bf5e5cfad2ed813e$export$3735103072e4a80(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $bf5e5cfad2ed813e$export$940d8225183e1404(element) {
    let currentNode = $bf5e5cfad2ed813e$export$4e12058fc4d51d56(element);
    while($bf5e5cfad2ed813e$export$1b3bfaa9684536aa(currentNode) && !$bf5e5cfad2ed813e$export$d1162fb0b6d4cd51(currentNode)){
        if ($bf5e5cfad2ed813e$export$89e651af02346cd4(currentNode)) return null;
        if ($bf5e5cfad2ed813e$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        currentNode = $bf5e5cfad2ed813e$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $bf5e5cfad2ed813e$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $bf5e5cfad2ed813e$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($bf5e5cfad2ed813e$export$651544f548703224(node));
}
function $bf5e5cfad2ed813e$export$3735103072e4a80(element) {
    return $bf5e5cfad2ed813e$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $bf5e5cfad2ed813e$export$dc8fc79fa2800137(element) {
    if ($bf5e5cfad2ed813e$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $bf5e5cfad2ed813e$export$4e12058fc4d51d56(node) {
    if ($bf5e5cfad2ed813e$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $bf5e5cfad2ed813e$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $bf5e5cfad2ed813e$export$e495491855dc5418(node);
    return $bf5e5cfad2ed813e$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $bf5e5cfad2ed813e$export$7cd01a57c8ca906c(node) {
    const parentNode = $bf5e5cfad2ed813e$export$4e12058fc4d51d56(node);
    if ($bf5e5cfad2ed813e$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($bf5e5cfad2ed813e$export$1b3bfaa9684536aa(parentNode) && $bf5e5cfad2ed813e$export$989e911fa9af580a(parentNode)) return parentNode;
    return $bf5e5cfad2ed813e$export$7cd01a57c8ca906c(parentNode);
}
function $bf5e5cfad2ed813e$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $bf5e5cfad2ed813e$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $bf5e5cfad2ed813e$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $bf5e5cfad2ed813e$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $bf5e5cfad2ed813e$export$3b57c1601291186b(win.frameElement) : []);
    return list.concat(scrollableAncestor, $bf5e5cfad2ed813e$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}

});


parcelRegister("lpKNg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9703b06d7b15e9c$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");
var $f9703b06d7b15e9c$var$index = (0, $91i6m.useLayoutEffect);
var $f9703b06d7b15e9c$export$2e2bcd8739ae039 = $f9703b06d7b15e9c$var$index;

});


parcelRegister("wLIf7", function(module, exports) {

$parcel$export(module.exports, "multiValueCSS", function () { return $06280000443dc15f$export$23c213f7717186af; });
$parcel$export(module.exports, "multiValueLabelCSS", function () { return $06280000443dc15f$export$f40612612e0af964; });
$parcel$export(module.exports, "multiValueRemoveCSS", function () { return $06280000443dc15f$export$283467f6c4ac142b; });
$parcel$export(module.exports, "MultiValueContainer", function () { return $06280000443dc15f$export$cf9cf2a30a59265c; });
$parcel$export(module.exports, "MultiValueLabel", function () { return $06280000443dc15f$export$544aeea2a5ce08ee; });
$parcel$export(module.exports, "MultiValueRemove", function () { return $06280000443dc15f$export$8e1fd1a40e7a2f4a; });
$parcel$export(module.exports, "default", function () { return $06280000443dc15f$export$2e2bcd8739ae039; });
/* multi-value.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dsN6L = parcelRequire("dsN6L");

var $cIDQN = parcelRequire("cIDQN");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $8kGa4 = parcelRequire("8kGa4");

var $8XZIm = parcelRequire("8XZIm");

var $hUhx6 = parcelRequire("hUhx6");

var $f1k1y = parcelRequire("f1k1y");

var $cCoB6 = parcelRequire("cCoB6");
function $06280000443dc15f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $06280000443dc15f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $06280000443dc15f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $06280000443dc15f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $06280000443dc15f$var$multiValueStyles = {
    root: "_2rkolb4i _1e0c1txw _1ul9ze3t _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _bfhkm7j4 _p12f1osq _syazjpor _3yq3glyw",
    disabled: "_syaz1lh4 _bfhkm7j4",
    focused: "_syaz1wum _bfhkfg4m _16qs7ex6 _1aewe4h9 _6up51j28 _1xdnnqa1",
    refresh: "_2rko12b0 _1h6d14je _1dqonqa1 _189ee4h9 _bfhk1j9a"
};
var $06280000443dc15f$export$23c213f7717186af = function multiValueCSS() {
    return {};
};
var $06280000443dc15f$export$f40612612e0af964 = function multiValueLabelCSS() {
    return {};
};
var $06280000443dc15f$var$multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkolb4i _11c8dcr7 _o5721q9c _ca0qv77o _u5f3v77o _n3tdv77o _19bv12x7 _syaz1kw7",
    disabled: "_syaz1lh4",
    ellipsis: "_1bto1l2s",
    refresh: "_11c82smr _ca0qidpf _n3tdidpf _19bv1b66"
};
var $06280000443dc15f$export$283467f6c4ac142b = function multiValueRemoveCSS() {
    return {};
};
var $06280000443dc15f$var$multiValueRemoveStyles = {
    focused: "_bfhkb1q9 _lswu1rrc",
    root: "_2rkovtp2 _4cvr1h6o _1e0c1txw _lswu1dx5 _19bvv77o _u5f3v77o _irr31yvi _13br1jjn _1di61io2 _i5f81jjn",
    refresh: "_19itglyw _2rko12b0 _bfhksm61 _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _syaz1fxt _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _2hwxv77o _1ah312gs _irr3166n _1di61dty"
};
var $06280000443dc15f$export$cf9cf2a30a59265c = function MultiValueContainer(_ref) {
    var children = _ref.children, innerProps = _ref.innerProps, isFocused = _ref.isFocused, isDisabled = _ref.isDisabled, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $91i6m.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9gzWK.default)([
            $06280000443dc15f$var$multiValueStyles.root,
            isDisabled && $06280000443dc15f$var$multiValueStyles.disabled,
            isFocused && $06280000443dc15f$var$multiValueStyles.focused,
            (0, $f1k1y.fg)('platform-component-visual-refresh') && $06280000443dc15f$var$multiValueStyles.refresh,
            (0, $8kGa4.cx)(className, xcss, '-multiValue')
        ])
    }), children);
};
var $06280000443dc15f$export$544aeea2a5ce08ee = function MultiValueLabel(_ref2) {
    var children = _ref2.children, innerProps = _ref2.innerProps, isDisabled = _ref2.isDisabled, hasEllipsis = _ref2.hasEllipsis, className = _ref2.className, xcss = _ref2.xcss;
    return /*#__PURE__*/ $91i6m.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9gzWK.default)([
            $06280000443dc15f$var$multiValueLabelStyles.root,
            isDisabled && $06280000443dc15f$var$multiValueLabelStyles.disabled,
            hasEllipsis && $06280000443dc15f$var$multiValueLabelStyles.ellipsis,
            (0, $f1k1y.fg)('platform-component-visual-refresh') && $06280000443dc15f$var$multiValueLabelStyles.refresh,
            (0, $8kGa4.cx)(className, xcss, '-MultiValueLabel')
        ])
    }), children);
};
var $06280000443dc15f$var$disabledStyles = null;
var $06280000443dc15f$var$enabledStyles = null;
function $06280000443dc15f$export$8e1fd1a40e7a2f4a(_ref3) {
    var isDisabled = _ref3.isDisabled, isFocused = _ref3.isFocused, innerProps = _ref3.innerProps, className = _ref3.className, xcss = _ref3.xcss;
    return /*#__PURE__*/ $91i6m.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9gzWK.default)([
            $06280000443dc15f$var$multiValueRemoveStyles.root,
            isFocused && $06280000443dc15f$var$multiValueRemoveStyles.focused,
            (0, $f1k1y.fg)('platform-component-visual-refresh') && $06280000443dc15f$var$multiValueRemoveStyles.refresh,
            (0, $8kGa4.cx)(className, xcss, '-MultiValueRemove')
        ])
    }), /*#__PURE__*/ $91i6m.createElement("div", {
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
        className: (0, $9gzWK.default)([
            isDisabled && "_1e0cglyw",
            !isDisabled && "_1e0c1kw7"
        ])
    }, /*#__PURE__*/ $91i6m.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8XZIm))), {
        label: "",
        color: "currentColor",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($hUhx6))),
        LEGACY_primaryColor: "transparent",
        LEGACY_secondaryColor: "inherit",
        LEGACY_size: "small",
        size: "small"
    })));
}
var $06280000443dc15f$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, isFocused = props.isFocused, removeProps = props.removeProps, selectProps = props.selectProps, cropWithEllipsis = props.cropWithEllipsis;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    var ariaLabel = typeof children === 'string' ? children : data.label;
    var _getStyleProps = (0, $cCoB6.getStyleProps)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    }), containerCss = _getStyleProps.css, containerClassName = _getStyleProps.className;
    var _getStyleProps2 = (0, $cCoB6.getStyleProps)(props, 'multiValueLabel', {
        'multi-value__label': true
    }), labelCss = _getStyleProps2.css, labelClassName = _getStyleProps2.className;
    var _getStyleProps3 = (0, $cCoB6.getStyleProps)(props, 'multiValueRemove', {
        'multi-value__remove': true
    }), removeCss = _getStyleProps3.css, removeClassName = _getStyleProps3.className;
    return /*#__PURE__*/ $91i6m.createElement(Container, {
        data: data,
        innerProps: $06280000443dc15f$var$_objectSpread({
            style: containerCss,
            className: containerClassName
        }, innerProps),
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps
    }, /*#__PURE__*/ $91i6m.createElement(Label, {
        data: data,
        innerProps: {
            style: labelCss,
            className: labelClassName
        },
        className: labelClassName,
        hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
        selectProps: selectProps
    }, children), /*#__PURE__*/ $91i6m.createElement(Remove, {
        data: data,
        innerProps: $06280000443dc15f$var$_objectSpread({
            style: removeCss,
            className: removeClassName,
            role: 'button',
            tabIndex: -1,
            'aria-label': "".concat(ariaLabel || 'option', ", remove")
        }, removeProps),
        className: removeClassName,
        isDisabled: isDisabled,
        selectProps: selectProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$06280000443dc15f$export$2e2bcd8739ae039 = $06280000443dc15f$var$MultiValue;

});
parcelRegister("8XZIm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6873b4a4f1e0dab6$var$_react = $6873b4a4f1e0dab6$var$_interopRequireDefault((parcelRequire("91i6m")));

var $6873b4a4f1e0dab6$var$_baseNew = $6873b4a4f1e0dab6$var$_interopRequireDefault((parcelRequire("dfGW3")));
function $6873b4a4f1e0dab6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6873b4a4f1e0dab6$var$CrossIcon = (props)=>/*#__PURE__*/ $6873b4a4f1e0dab6$var$_react.default.createElement($6873b4a4f1e0dab6$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$6873b4a4f1e0dab6$var$CrossIcon.displayName = 'CrossIcon';
var $6873b4a4f1e0dab6$var$_default = module.exports.default = $6873b4a4f1e0dab6$var$CrossIcon;

});


parcelRegister("gxbCT", function(module, exports) {

$parcel$export(module.exports, "optionCSS", function () { return $c098bf2a40afec8e$export$ef897119b7e920ba; });
$parcel$export(module.exports, "default", function () { return $c098bf2a40afec8e$export$2e2bcd8739ae039; });
/* option.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $8kGa4 = parcelRequire("8kGa4");

var $cCoB6 = parcelRequire("cCoB6");
var $c098bf2a40afec8e$export$ef897119b7e920ba = function optionCSS() {
    return {};
};
var $c098bf2a40afec8e$var$optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syaz1fxt _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di61dty",
    disabled: "_syaz1lh4 _80om13gf _bfhk1j28 _16qsglyw _1di61j28 _1pknglyw",
    focused: "_bfhk166n _16qsu4to _1pkn1vrj",
    selected: "_syazaqb7 _bfhkfg4m _16qsu4to _1di619ru _1pkn1vrj",
    focusedSelected: "_bfhki1yw"
};
var $c098bf2a40afec8e$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $cCoB6.getStyleProps)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $91i6m.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $9gzWK.default)([
            $c098bf2a40afec8e$var$optionStyles.root,
            isFocused && $c098bf2a40afec8e$var$optionStyles.focused,
            isSelected && $c098bf2a40afec8e$var$optionStyles.selected,
            isFocused && isSelected && $c098bf2a40afec8e$var$optionStyles.focusedSelected,
            isDisabled && $c098bf2a40afec8e$var$optionStyles.disabled,
            (0, $8kGa4.cx)(className, xcss, '-option')
        ]),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c098bf2a40afec8e$export$2e2bcd8739ae039 = $c098bf2a40afec8e$var$Option;

});

parcelRegister("7tXLu", function(module, exports) {

$parcel$export(module.exports, "placeholderCSS", function () { return $572999eb33588378$export$5f3ffacd6594d90f; });
$parcel$export(module.exports, "default", function () { return $572999eb33588378$export$2e2bcd8739ae039; });
/* placeholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $8kGa4 = parcelRequire("8kGa4");

var $cCoB6 = parcelRequire("cCoB6");
var $572999eb33588378$export$5f3ffacd6594d90f = function placeholderCSS() {
    return {};
};
var $572999eb33588378$var$placeholderStyles = {
    root: "_nd5l1sux _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syaz131l",
    disabled: "_syaz1lh4"
};
var $572999eb33588378$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, xcss = props.xcss;
    var _getStyleProps = (0, $cCoB6.getStyleProps)(props, 'placeholder', {
        placeholder: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $91i6m.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $9gzWK.default)([
            $572999eb33588378$var$placeholderStyles.root,
            isDisabled && $572999eb33588378$var$placeholderStyles.disabled,
            (0, $8kGa4.cx)(className, xcss, '-placeholder')
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$572999eb33588378$export$2e2bcd8739ae039 = $572999eb33588378$var$Placeholder;

});

parcelRegister("e31Up", function(module, exports) {

$parcel$export(module.exports, "css", function () { return $a3a2d388e26fdc1b$export$dbf350e5966cf602; });
$parcel$export(module.exports, "default", function () { return $a3a2d388e26fdc1b$export$2e2bcd8739ae039; });
/* single-value.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $8kGa4 = parcelRequire("8kGa4");

var $cCoB6 = parcelRequire("cCoB6");
var $a3a2d388e26fdc1b$export$dbf350e5966cf602 = function css() {
    return {};
};
var $a3a2d388e26fdc1b$var$styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syaz1fxt",
    disalbed: "_syaz1lh4"
};
var $a3a2d388e26fdc1b$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $cCoB6.getStyleProps)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $91i6m.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $9gzWK.default)([
            $a3a2d388e26fdc1b$var$styles.root,
            isDisabled && $a3a2d388e26fdc1b$var$styles.disalbed,
            (0, $8kGa4.cx)(className, xcss, '-singleValue')
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a3a2d388e26fdc1b$export$2e2bcd8739ae039 = $a3a2d388e26fdc1b$var$SingleValue;

});


parcelRegister("WaFHh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0aedb209cfc61361$export$2e2bcd8739ae039; });
/* dummy-input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $cCoB6 = parcelRequire("cCoB6");
var $0aedb209cfc61361$var$_excluded = [
    "innerRef"
];
var $0aedb209cfc61361$var$dummyInputStyles = null;
function $0aedb209cfc61361$export$2e2bcd8739ae039(_ref) {
    var innerRef = _ref.innerRef, props = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $0aedb209cfc61361$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $cCoB6.removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ $91i6m.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        ref: innerRef,
        className: (0, $9gzWK.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _nd5l1sux _12ji1r31 _1qu2glyw _12y3idpf _1bsbt94y _kqswh2mm _1n5d1j28 _syaz1j28 _1e02p1rm _tzy4idpf _t9ec1kuz",
            "-dummyInput"
        ])
    }, filteredProps));
}

});

parcelRegister("5QqBJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $441672c41db9b0ba$export$2e2bcd8739ae039; });
/* required-input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $6A0cm = parcelRequire("6A0cm");
var $441672c41db9b0ba$var$styles = null;
var $441672c41db9b0ba$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return /*#__PURE__*/ $91i6m.createElement("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        className: (0, $9gzWK.default)([
            "_1bsb1osq _kqswstnw _u7coidpf _rjxpidpf _1e02idpf _tzy4idpf _lcxvglyw",
            "-requiredInput"
        ]),
        onFocus: onFocus,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $6A0cm.default)
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$441672c41db9b0ba$export$2e2bcd8739ae039 = $441672c41db9b0ba$var$RequiredInput;

});

parcelRegister("3Pzvs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ca1ad51e8239127$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $dtO22 = parcelRequire("dtO22");

var $hktcD = parcelRequire("hktcD");
var $2ca1ad51e8239127$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $2ca1ad51e8239127$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = (0, $dtO22.default)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = (0, $hktcD.default)({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $91i6m.Fragment), null, lockEnabled && /*#__PURE__*/ // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("div", {
        onClick: $2ca1ad51e8239127$var$blurSelectInput,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            position: 'fixed',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetBlockEnd: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetBlockStart: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetInlineEnd: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetInlineStart: 0
        }
    }), children(targetRef));
}

});
parcelRegister("dtO22", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d04cb10d4bc0547$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $cCoB6 = parcelRequire("cCoB6");
var $9d04cb10d4bc0547$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $9d04cb10d4bc0547$export$2e2bcd8739ae039(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $91i6m.useRef)(false);
    var isTop = (0, $91i6m.useRef)(false);
    var touchStart = (0, $91i6m.useRef)(0);
    var scrollTarget = (0, $91i6m.useRef)(null);
    var handleEventDelta = (0, $91i6m.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $9d04cb10d4bc0547$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $91i6m.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $91i6m.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $91i6m.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $91i6m.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $cCoB6.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $91i6m.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $91i6m.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}

});

parcelRegister("hktcD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9daf4fac0780554$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");
var $c9daf4fac0780554$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $c9daf4fac0780554$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $c9daf4fac0780554$var$preventTouchMove(e) {
    e.preventDefault();
}
function $c9daf4fac0780554$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $c9daf4fac0780554$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $c9daf4fac0780554$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $c9daf4fac0780554$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $c9daf4fac0780554$var$activeScrollLocks = 0;
var $c9daf4fac0780554$var$listenerOptions = {
    capture: false,
    passive: false
};
function $c9daf4fac0780554$export$2e2bcd8739ae039(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $91i6m.useRef)({});
    var scrollTarget = (0, $91i6m.useRef)(null);
    var addScrollLock = (0, $91i6m.useCallback)(function(touchScrollTarget) {
        if (!$c9daf4fac0780554$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $c9daf4fac0780554$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $c9daf4fac0780554$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($c9daf4fac0780554$var$LOCK_STYLES).forEach(function(key) {
                var val = $c9daf4fac0780554$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $c9daf4fac0780554$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $c9daf4fac0780554$var$preventTouchMove, $c9daf4fac0780554$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $c9daf4fac0780554$var$preventInertiaScroll, $c9daf4fac0780554$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $c9daf4fac0780554$var$allowTouchMove, $c9daf4fac0780554$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $c9daf4fac0780554$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $91i6m.useCallback)(function(touchScrollTarget) {
        if (!$c9daf4fac0780554$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $c9daf4fac0780554$var$activeScrollLocks = Math.max($c9daf4fac0780554$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $c9daf4fac0780554$var$activeScrollLocks < 1) $c9daf4fac0780554$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $c9daf4fac0780554$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $c9daf4fac0780554$var$preventTouchMove, $c9daf4fac0780554$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $c9daf4fac0780554$var$preventInertiaScroll, $c9daf4fac0780554$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $c9daf4fac0780554$var$allowTouchMove, $c9daf4fac0780554$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $91i6m.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}

});


parcelRegister("fstjg", function(module, exports) {

$parcel$export(module.exports, "NotifyOpenLayerObserver", function () { return $b41034d685fdb1b3$export$17baa7c95b6ba1b8; });

var $1tlvt = parcelRequire("1tlvt");
function $b41034d685fdb1b3$export$17baa7c95b6ba1b8(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose;
    // @ts-ignore - hot-116676
    (0, $1tlvt.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

});

parcelRegister("cN9P5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9501ae4879754c04$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $13fXA = parcelRequire("13fXA");

var $fgepk = parcelRequire("fgepk");
function $9501ae4879754c04$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9501ae4879754c04$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9501ae4879754c04$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9501ae4879754c04$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// ==============================
// Root Container
// ==============================
var $9501ae4879754c04$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isOptionDisabled = selectProps.isOptionDisabled, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, isLoading = selectProps.isLoading;
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $91i6m.useMemo)(function() {
        return $9501ae4879754c04$var$_objectSpread($9501ae4879754c04$var$_objectSpread({}, (0, $13fXA.defaultAriaLiveMessages)), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $91i6m.useMemo)(function() {
        var message = '';
        if (menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (!label && !labels.length) // return empty string if no labels provided
            return '';
            var onChangeProps = $9501ae4879754c04$var$_objectSpread({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        menuIsOpen
    ]);
    var ariaResults = (0, $91i6m.useMemo)(function() {
        var resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ScreenReaderText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $91i6m.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("span", {
        id: "aria-selection"
    }, ariaSelected), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("span", {
        id: "aria-results"
    }, ariaResults));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $91i6m.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $fgepk.default), {
        id: id
    }, isInitialFocus && ScreenReaderText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $fgepk.default), {
        "aria-live": ariaLive // Should be undefined by default unless a specific use case requires it
        ,
        role: "status"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9501ae4879754c04$export$2e2bcd8739ae039 = $9501ae4879754c04$var$LiveRegion;

});
parcelRegister("13fXA", function(module, exports) {

$parcel$export(module.exports, "defaultAriaLiveMessages", function () { return $0c42739769bcfca2$export$a7265767c78f9bae; });
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ var $0c42739769bcfca2$export$a7265767c78f9bae = {
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length ? "option ".concat(label, ", deselected") : '';
            case 'clear':
                return 'All selected options have been cleared.';
            case 'select-option':
                return label.length && !isDisabled ? "option ".concat(label, ", selected.") : '';
            default:
                return '';
        }
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return inputValue ? "".concat(resultsMessage, " for search term ").concat(inputValue, ".") : '';
    }
};

});

parcelRegister("fgepk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1c386a8219afcab$export$2e2bcd8739ae039; });
/* a11y-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cIDQN = parcelRequire("cIDQN");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");
// Assistive text to describe visual elements. Hidden for sighted users.
var $b1c386a8219afcab$var$styles = null;
var $b1c386a8219afcab$var$A11yText = function A11yText(props) {
    return /*#__PURE__*/ $91i6m.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9gzWK.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _1pbydx66 _ogto7mnp _uiztglyw _o5721q9c",
            "-a11yText"
        ])
    }, props));
};
var $b1c386a8219afcab$export$2e2bcd8739ae039 = $b1c386a8219afcab$var$A11yText;

});


parcelRegister("6cVZc", function(module, exports) {

$parcel$export(module.exports, "createFilter", function () { return $4850d7eb196632bd$export$5d81789ff4aeccdf; });

var $dsN6L = parcelRequire("dsN6L");

var $79CCE = parcelRequire("79CCE");

var $9eKRf = parcelRequire("9eKRf");
function $4850d7eb196632bd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4850d7eb196632bd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4850d7eb196632bd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4850d7eb196632bd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4850d7eb196632bd$var$memoizedStripDiacriticsForInput = (0, $79CCE.default)((0, $9eKRf.stripDiacritics));
var $4850d7eb196632bd$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $4850d7eb196632bd$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $4850d7eb196632bd$export$5d81789ff4aeccdf = function createFilter(config) {
    return function(option, rawInput) {
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = $4850d7eb196632bd$var$_objectSpread({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $4850d7eb196632bd$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $4850d7eb196632bd$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $4850d7eb196632bd$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $4850d7eb196632bd$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $9eKRf.stripDiacritics)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};

});
parcelRegister("9eKRf", function(module, exports) {

$parcel$export(module.exports, "stripDiacritics", function () { return $6b99c4dbe0873780$export$b5bee4b27048330b; });
var $6b99c4dbe0873780$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $6b99c4dbe0873780$var$anyDiacritic = new RegExp('[' + $6b99c4dbe0873780$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $6b99c4dbe0873780$var$diacriticToBase = {};
for(var $6b99c4dbe0873780$var$i = 0; $6b99c4dbe0873780$var$i < $6b99c4dbe0873780$var$diacritics.length; $6b99c4dbe0873780$var$i++){
    var $6b99c4dbe0873780$var$diacritic = $6b99c4dbe0873780$var$diacritics[$6b99c4dbe0873780$var$i];
    for(var $6b99c4dbe0873780$var$j = 0; $6b99c4dbe0873780$var$j < $6b99c4dbe0873780$var$diacritic.letters.length; $6b99c4dbe0873780$var$j++)$6b99c4dbe0873780$var$diacriticToBase[$6b99c4dbe0873780$var$diacritic.letters[$6b99c4dbe0873780$var$j]] = $6b99c4dbe0873780$var$diacritic.base;
}
var $6b99c4dbe0873780$export$b5bee4b27048330b = function stripDiacritics(str) {
    return str.replace($6b99c4dbe0873780$var$anyDiacritic, function(match) {
        return $6b99c4dbe0873780$var$diacriticToBase[match];
    });
};

});


parcelRegister("hAMpx", function(module, exports) {

$parcel$export(module.exports, "defaultStyles", function () { return $cceb59dc35e74b27$export$214b055320e0bf32; });

var $dsN6L = parcelRequire("dsN6L");

var $kbaiE = parcelRequire("kbaiE");

var $1VLd1 = parcelRequire("1VLd1");

var $95vjP = parcelRequire("95vjP");

var $cBc2c = parcelRequire("cBc2c");

var $kpjkf = parcelRequire("kpjkf");

var $gVvyR = parcelRequire("gVvyR");

var $wLIf7 = parcelRequire("wLIf7");

var $gxbCT = parcelRequire("gxbCT");

var $7tXLu = parcelRequire("7tXLu");

var $e31Up = parcelRequire("e31Up");
function $cceb59dc35e74b27$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cceb59dc35e74b27$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cceb59dc35e74b27$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cceb59dc35e74b27$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cceb59dc35e74b27$export$214b055320e0bf32 = {
    clearIndicator: (0, $cBc2c.clearIndicatorCSS),
    container: (0, $kbaiE.containerCSS),
    control: (0, $1VLd1.css),
    dropdownIndicator: (0, $cBc2c.dropdownIndicatorCSS),
    group: (0, $95vjP.groupCSS),
    groupHeading: (0, $95vjP.groupHeadingCSS),
    indicatorsContainer: (0, $kbaiE.indicatorsContainerCSS),
    input: (0, $kpjkf.inputCSS),
    loadingIndicator: (0, $cBc2c.loadingIndicatorCSS),
    loadingMessage: (0, $gVvyR.loadingMessageCSS),
    menu: (0, $gVvyR.menuCSS),
    menuList: (0, $gVvyR.menuListCSS),
    menuPortal: (0, $gVvyR.menuPortalCSS),
    multiValue: (0, $wLIf7.multiValueCSS),
    multiValueLabel: (0, $wLIf7.multiValueLabelCSS),
    multiValueRemove: (0, $wLIf7.multiValueRemoveCSS),
    noOptionsMessage: (0, $gVvyR.noOptionsMessageCSS),
    option: (0, $gxbCT.optionCSS),
    placeholder: (0, $7tXLu.placeholderCSS),
    singleValue: (0, $e31Up.css),
    valueContainer: (0, $kbaiE.valueContainerCSS)
};
function $cceb59dc35e74b27$export$e618dc39ac9ad607(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = $cceb59dc35e74b27$var$_objectSpread({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}

});


parcelRegister("fBWoJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5d79c4fbf651ad8$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");

var $5YM7L = parcelRequire("5YM7L");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $cCoB6 = parcelRequire("cCoB6");
var $b5d79c4fbf651ad8$var$_excluded = [
    "defaultOptions",
    "cacheOptions",
    "loadOptions",
    "options",
    "isLoading",
    "onInputChange",
    "filterOption"
];
function $b5d79c4fbf651ad8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b5d79c4fbf651ad8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b5d79c4fbf651ad8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b5d79c4fbf651ad8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b5d79c4fbf651ad8$export$2e2bcd8739ae039(_ref) {
    var _ref$defaultOptions = _ref.defaultOptions, propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions, _ref$cacheOptions = _ref.cacheOptions, cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions, propsLoadOptions = _ref.loadOptions, propsOptions = _ref.options, _ref$isLoading = _ref.isLoading, propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, propsOnInputChange = _ref.onInputChange, _ref$filterOption = _ref.filterOption, filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption, restSelectProps = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $b5d79c4fbf651ad8$var$_excluded);
    var propsInputValue = restSelectProps.inputValue;
    var lastRequest = (0, $91i6m.useRef)(undefined);
    var mounted = (0, $91i6m.useRef)(false);
    var _useState = (0, $91i6m.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), defaultOptions = _useState2[0], setDefaultOptions = _useState2[1];
    var _useState3 = (0, $91i6m.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : ''), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState3, 2), stateInputValue = _useState4[0], setStateInputValue = _useState4[1];
    var _useState5 = (0, $91i6m.useState)(propsDefaultOptions === true), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = (0, $91i6m.useState)(undefined), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState7, 2), loadedInputValue = _useState8[0], setLoadedInputValue = _useState8[1];
    var _useState9 = (0, $91i6m.useState)([]), _useState0 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState9, 2), loadedOptions = _useState0[0], setLoadedOptions = _useState0[1];
    var _useState1 = (0, $91i6m.useState)(false), _useState10 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState1, 2), passEmptyOptions = _useState10[0], setPassEmptyOptions = _useState10[1];
    var _useState11 = (0, $91i6m.useState)({}), _useState12 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState11, 2), optionsCache = _useState12[0], setOptionsCache = _useState12[1];
    var _useState13 = (0, $91i6m.useState)(undefined), _useState14 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState13, 2), prevDefaultOptions = _useState14[0], setPrevDefaultOptions = _useState14[1];
    var _useState15 = (0, $91i6m.useState)(undefined), _useState16 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState15, 2), prevCacheOptions = _useState16[0], setPrevCacheOptions = _useState16[1];
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $91i6m.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var loadOptions = (0, $91i6m.useCallback)(function(inputValue, callback) {
        if (!propsLoadOptions) return callback();
        var loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, function() {
            return callback();
        });
    }, [
        propsLoadOptions
    ]);
    (0, $91i6m.useEffect)(function() {
        if (propsDefaultOptions === true) loadOptions(stateInputValue, function(options) {
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onInputChange = (0, $91i6m.useCallback)(function(newValue, actionMeta) {
        var inputValue = (0, $cCoB6.handleInputChange)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            var request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, function(options) {
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? $b5d79c4fbf651ad8$var$_objectSpread($b5d79c4fbf651ad8$var$_objectSpread({}, optionsCache), {}, (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, inputValue, options)) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return $b5d79c4fbf651ad8$var$_objectSpread($b5d79c4fbf651ad8$var$_objectSpread({}, restSelectProps), {}, {
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    });
}

});

parcelRegister("lHvFL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fcc62ea2e3f04a89$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");

var $5YM7L = parcelRequire("5YM7L");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");
var $fcc62ea2e3f04a89$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $fcc62ea2e3f04a89$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fcc62ea2e3f04a89$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fcc62ea2e3f04a89$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fcc62ea2e3f04a89$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fcc62ea2e3f04a89$export$2e2bcd8739ae039(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $fcc62ea2e3f04a89$var$_excluded);
    var _useState = (0, $91i6m.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $91i6m.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $91i6m.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $91i6m.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $91i6m.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $91i6m.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $91i6m.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return $fcc62ea2e3f04a89$var$_objectSpread($fcc62ea2e3f04a89$var$_objectSpread({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});


parcelRegister("fyqWn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b52eedd0f3ecf38c$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");
var $b52eedd0f3ecf38c$var$_excluded = [
    "ariaLiveMessages",
    "isInvalid",
    "onClickPreventDefault",
    "tabSelectsValue",
    "validationState"
];
function $b52eedd0f3ecf38c$export$2e2bcd8739ae039(WrappedComponent) {
    var AtlaskitSelect = /*#__PURE__*/ (0, $91i6m.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        var ariaLiveMessages = props.ariaLiveMessages, isInvalid = props.isInvalid, _props$onClickPrevent = props.onClickPreventDefault, onClickPreventDefault = _props$onClickPrevent === void 0 ? true : _props$onClickPrevent, _props$tabSelectsValu = props.tabSelectsValue, tabSelectsValue = _props$tabSelectsValu === void 0 ? false : _props$tabSelectsValu, _props$validationStat = props.validationState, validationState = _props$validationStat === void 0 ? 'default' : _props$validationStat, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(props, $b52eedd0f3ecf38c$var$_excluded);
        var internalSelectRef = (0, $91i6m.useRef)(null);
        /**
     * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
     * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
     * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
     * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
     * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
     */ (0, $91i6m.useImperativeHandle)(forwardedRef, function() {
            return {
                select: internalSelectRef.current,
                focus: function focus() {
                    var _internalSelectRef$cu;
                    return (_internalSelectRef$cu = internalSelectRef.current) === null || _internalSelectRef$cu === void 0 ? void 0 : _internalSelectRef$cu.focus();
                },
                blur: function blur() {
                    var _internalSelectRef$cu2;
                    return (_internalSelectRef$cu2 = internalSelectRef.current) === null || _internalSelectRef$cu2 === void 0 ? void 0 : _internalSelectRef$cu2.blur();
                }
            };
        }, []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
            ref: internalSelectRef,
            ariaLiveMessages: ariaLiveMessages,
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error'
        }, restProps, {
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        }));
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});




parcelRegister("gKURT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4108e007ab21b5b$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");

var $9jjaN = parcelRequire("9jjaN");

var $6e88g = parcelRequire("6e88g");

var $kLNLK = parcelRequire("kLNLK");

var $cLysE = parcelRequire("cLysE");

var $7cVVr = parcelRequire("7cVVr");

var $htB5i = parcelRequire("htB5i");

var $5R4qW = parcelRequire("5R4qW");

var $eWm11 = parcelRequire("eWm11");

var $6h0tx = parcelRequire("6h0tx");

var $gtKO2 = parcelRequire("gtKO2");
let $c4108e007ab21b5b$var$_ = (t)=>t, $c4108e007ab21b5b$var$t, $c4108e007ab21b5b$var$t1, $c4108e007ab21b5b$var$t2, $c4108e007ab21b5b$var$t3;
const $c4108e007ab21b5b$var$SocialLoginBlock = (0, $9jjaN.default).div($c4108e007ab21b5b$var$t || ($c4108e007ab21b5b$var$t = $c4108e007ab21b5b$var$_`
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${0}px;

  border: 1px solid ${0};
  border-radius: 3px;
`), (0, $6e88g.gridSize)() * 1.5, (0, $kLNLK.N50));
const $c4108e007ab21b5b$var$Header = (0, $9jjaN.default).div($c4108e007ab21b5b$var$t1 || ($c4108e007ab21b5b$var$t1 = $c4108e007ab21b5b$var$_`
  display: flex;
  align-self: center;
  justify-content: center;

  width: 100%;
  padding-bottom: ${0}px;
`), (0, $6e88g.gridSize)() * 1.5);
const $c4108e007ab21b5b$var$Email = (0, $9jjaN.default).div($c4108e007ab21b5b$var$t2 || ($c4108e007ab21b5b$var$t2 = $c4108e007ab21b5b$var$_`
  font-weight: 600;
  font-size: 14px;
  line-height: ${0}px;
  color: ${0};

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`), (0, $6e88g.gridSize)() * 3, (0, $kLNLK.N800));
const $c4108e007ab21b5b$var$Logo = (0, $9jjaN.default).img($c4108e007ab21b5b$var$t3 || ($c4108e007ab21b5b$var$t3 = $c4108e007ab21b5b$var$_`
  height: ${0}px;
  padding-right: ${0}px;
`), (0, $6e88g.gridSize)() * 3, (0, $6e88g.gridSize)());
const $c4108e007ab21b5b$var$getLogo = (highlightedSocialProvider)=>{
    switch(highlightedSocialProvider){
        case (0, $gtKO2.SocialProvider).Google:
            return 0, (/*@__PURE__*/$parcel$interopDefault($htB5i));
        case (0, $gtKO2.SocialProvider).Microsoft:
            return 0, (/*@__PURE__*/$parcel$interopDefault($5R4qW));
        case (0, $gtKO2.SocialProvider).Apple:
            return 0, (/*@__PURE__*/$parcel$interopDefault($eWm11));
        case (0, $gtKO2.SocialProvider).Slack:
            return 0, (/*@__PURE__*/$parcel$interopDefault($6h0tx));
    }
};
const $c4108e007ab21b5b$var$getSocialLoginHandler = ({ highlightedSocialProvider: highlightedSocialProvider, handleGoogleLogin: handleGoogleLogin, handleMicrosoftLogin: handleMicrosoftLogin, handleAppleLogin: handleAppleLogin, handleSlackLogin: handleSlackLogin })=>{
    switch(highlightedSocialProvider){
        case (0, $gtKO2.SocialProvider).Google:
            return handleGoogleLogin;
        case (0, $gtKO2.SocialProvider).Microsoft:
            return handleMicrosoftLogin;
        case (0, $gtKO2.SocialProvider).Apple:
            return handleAppleLogin;
        case (0, $gtKO2.SocialProvider).Slack:
            return handleSlackLogin;
    }
};
const $c4108e007ab21b5b$var$SocialLoginForm = (props)=>{
    const { highlightedSocialProvider: highlightedSocialProvider, email: email } = props;
    const handleSocialLogin = $c4108e007ab21b5b$var$getSocialLoginHandler(props);
    return /*#__PURE__*/ (0, $4ZSso.jsxs)($c4108e007ab21b5b$var$SocialLoginBlock, {
        "data-testid": "social-login-form",
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsxs)($c4108e007ab21b5b$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)($c4108e007ab21b5b$var$Logo, {
                        src: $c4108e007ab21b5b$var$getLogo(highlightedSocialProvider),
                        alt: `${highlightedSocialProvider} logo`
                    }),
                    email && /*#__PURE__*/ (0, $4ZSso.jsx)($c4108e007ab21b5b$var$Email, {
                        children: email
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                isFullWidth: true,
                id: "social-login-submit",
                appearance: "primary",
                onClick: handleSocialLogin,
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $b2I6k._)((0, $1Fos3._)({}, (0, $7cVVr.default).continueWith), {
                    values: {
                        socialProviderName: highlightedSocialProvider.replace(/^./, (str)=>str.toUpperCase())
                    }
                }))
            })
        ]
    });
};
var $c4108e007ab21b5b$export$2e2bcd8739ae039 = $c4108e007ab21b5b$var$SocialLoginForm;

});
parcelRegister("7cVVr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b70b522f9e02cef9$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $b70b522f9e02cef9$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    continueWith: {
        id: 'social.login.form.continue-button',
        defaultMessage: 'Continue with {socialProviderName}',
        description: 'Button label that is a CTA for users to continue logging in using the selected social provider.'
    }
});

});


parcelRegister("9b70D", function(module, exports) {

$parcel$export(module.exports, "LoginPageMessages", function () { return $9485df2f6920f372$export$81a860015c7169ad; });

var $j5RJC = parcelRequire("j5RJC");
const $9485df2f6920f372$export$81a860015c7169ad = (0, $j5RJC.defineMessages)({
    headTitle: {
        id: 'login.head.title',
        defaultMessage: 'Log in to continue'
    },
    contextualTitle: {
        id: 'login.contextual.title',
        defaultMessage: 'Continue to',
        description: `Precedes a page title or issue number. For example, "Continue to Sarah's Blogpost" or "Continue to TED-1024"`
    },
    socialAuthOr: {
        id: 'social.auth.or',
        defaultMessage: 'or'
    },
    socialAuthOrContinueWith: {
        id: 'social.auth.or-continue-with',
        defaultMessage: 'Or continue with:'
    },
    createAnAccount: {
        id: 'login.create.an.account',
        defaultMessage: 'Create an account'
    },
    passwordlessSuccessTitle: {
        id: 'login.passwordless.success.title',
        defaultMessage: 'Email sent'
    },
    passwordlessSuccessDescription: {
        id: 'login.passwordless.success.description',
        defaultMessage: "We've sent you an email to log in."
    },
    socialFormHeader: {
        id: 'login.social.form.header',
        defaultMessage: 'Log in',
        description: 'Subtle header shown on the social login form which allows users to login with the chosen social provider'
    },
    socialFormTitle: {
        id: 'login.social.form.title',
        defaultMessage: 'You logged in with your {socialProviderName} account before',
        description: 'Title shown on the social login form which allows users to login with the chosen social provider'
    },
    socialFormUseDifferentLoginMethod: {
        id: 'login.social.form.use-different-login-method',
        defaultMessage: 'Use a different login method',
        description: 'Button label shown on the social login form which allows users to login using another method. Takes the user back to the original login form.'
    },
    continueAs: {
        id: 'continue.as.title.as',
        defaultMessage: 'Continue as',
        description: 'This is a page title that will be followed by an avatar hero with name and email'
    }
});

});

parcelRegister("4rBM8", function(module, exports) {

$parcel$export(module.exports, "useLoginState", function () { return $c6628fb47e0e142f$export$bb159be17b1f5f11; });

var $6cMFi = parcelRequire("6cMFi");

var $gz8Vs = parcelRequire("gz8Vs");

var $2aGBJ = parcelRequire("2aGBJ");

var $k8MAo = parcelRequire("k8MAo");

var $91i6m = parcelRequire("91i6m");

var $9uXJ3 = parcelRequire("9uXJ3");
const $c6628fb47e0e142f$var$usePreloadedState = ()=>{
    const appConfig = (0, $2aGBJ.useAppSelector)((state)=>state.appConfig);
    const csrfToken = (0, $2aGBJ.useAppSelector)((state)=>state.csrfToken);
    const cobranding = (0, $2aGBJ.useAppSelector)((state)=>state.cobranding);
    const hashedCsrfToken = (0, $2aGBJ.useAppSelector)((state)=>state.hashedCsrfToken);
    const login = (0, $2aGBJ.useAppSelector)((state)=>state.login);
    const oidcContext = (0, $2aGBJ.useAppSelector)((state)=>state.microbranding.oidcContext);
    return {
        appConfig: appConfig,
        csrfToken: csrfToken,
        cobranding: cobranding,
        hashedCsrfToken: hashedCsrfToken,
        login: login,
        oidcContext: oidcContext
    };
};
const $c6628fb47e0e142f$export$bb159be17b1f5f11 = ()=>{
    const noServerState = (0, $gz8Vs.isSasStateEndpointEnabled)() && (0, $6cMFi.default)();
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    const { state: stateFromApi, isLoading: isLoading, isError: isError, error: error } = (0, $gz8Vs.usePageState)('/login/state', {
        enabled: noServerState
    });
    (0, $91i6m.useEffect)(()=>{
        if ((0, $gz8Vs.isPageStateResult)(stateFromApi)) dispatch((0, $k8MAo.loginSetState)(stateFromApi));
    }, [
        dispatch,
        stateFromApi
    ]);
    const preloadedState = $c6628fb47e0e142f$var$usePreloadedState();
    if ((0, $gz8Vs.isRedirectResult)(stateFromApi)) {
        navigate(stateFromApi.uri);
        return {
            state: undefined,
            isLoading: true,
            isError: false
        };
    }
    if (noServerState) return {
        state: stateFromApi,
        isLoading: isLoading,
        isError: isError,
        error: error
    };
    return {
        state: preloadedState,
        isLoading: false,
        isError: false,
        error: error
    };
};

});

parcelRegister("gx7I6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb3609afe7f9a073$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $8Bf3D = parcelRequire("8Bf3D");

var $bE8z6 = parcelRequire("bE8z6");

var $g6OTd = parcelRequire("g6OTd");

var $7eeh4 = parcelRequire("7eeh4");

var $1TbRW = parcelRequire("1TbRW");
const $cb3609afe7f9a073$var$Footer = ({ isEmbedded: isEmbedded, oidcContext: oidcContext })=>{
    if (isEmbedded) return null;
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsxs)("ul", {
                className: "fine-print",
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $bE8z6.PrivacyPolicyLink), {
                            isMobileLink: (0, $7eeh4.isMobileOidc)(oidcContext)
                        })
                    }),
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8Bf3D.default), {}),
                    /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $bE8z6.UserNoticeLink), {
                            isMobileLink: (0, $7eeh4.isMobileOidc)(oidcContext)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $1TbRW.RecaptchaNoticeContainer), {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $g6OTd.RecaptchaNotice), {})
            })
        ]
    });
};
var $cb3609afe7f9a073$export$2e2bcd8739ae039 = $cb3609afe7f9a073$var$Footer;

});
parcelRegister("1TbRW", function(module, exports) {

$parcel$export(module.exports, "RecaptchaNoticeContainer", function () { return $87e74b996a0bd675$export$e55f3ed22cb4599; });

var $9jjaN = parcelRequire("9jjaN");

var $6e88g = parcelRequire("6e88g");
let $87e74b996a0bd675$var$_ = (t)=>t, $87e74b996a0bd675$var$t;
const $87e74b996a0bd675$export$e55f3ed22cb4599 = (0, $9jjaN.default).div($87e74b996a0bd675$var$t || ($87e74b996a0bd675$var$t = $87e74b996a0bd675$var$_`
  margin-top: ${0}px;
`), (0, $6e88g.gridSize)());

});


parcelRegister("4tmE5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dde66b37a92d3c19$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");

var $9b70D = parcelRequire("9b70D");

var $4jXgk = parcelRequire("4jXgk");
const $dde66b37a92d3c19$var$Header = ({ highlightedSocialProvider: highlightedSocialProvider, showSocialLoginOnly: showSocialLoginOnly })=>{
    if (showSocialLoginOnly) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4jXgk.default), {
        size: "small",
        as: "h1",
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $b2I6k._)((0, $1Fos3._)({}, (0, $9b70D.LoginPageMessages).socialFormTitle), {
            values: {
                socialProviderName: highlightedSocialProvider === null || highlightedSocialProvider === void 0 ? void 0 : highlightedSocialProvider.replace(/^./, (str)=>str.toUpperCase())
            }
        }))
    });
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4jXgk.default), {
        size: "small",
        as: "h1",
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $9b70D.LoginPageMessages).headTitle))
    });
};
var $dde66b37a92d3c19$export$2e2bcd8739ae039 = $dde66b37a92d3c19$var$Header;

});

parcelRegister("k3QGO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $977fc0c59633125c$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $j7UeI = parcelRequire("j7UeI");
const $977fc0c59633125c$var$MaybeSocialLoginPanel = ({ isEmbedded: isEmbedded, isSocialBlocked: isSocialBlocked, envSupportsSocialLogin: envSupportsSocialLogin, onGoogleLogin: onGoogleLogin, onMicrosoftLogin: onMicrosoftLogin, onAppleLogin: onAppleLogin, onSlackLogin: onSlackLogin })=>{
    if (!envSupportsSocialLogin || isEmbedded || isSocialBlocked) return null;
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $j7UeI.default), {
        handleGoogleLogin: onGoogleLogin,
        handleMicrosoftLogin: onMicrosoftLogin,
        handleAppleLogin: onAppleLogin,
        handleSlackLogin: onSlackLogin
    });
};
var $977fc0c59633125c$export$2e2bcd8739ae039 = $977fc0c59633125c$var$MaybeSocialLoginPanel;

});

parcelRegister("68WXR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ef3e311772fd3c0$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");

var $dBq8m = parcelRequire("dBq8m");

var $2aGBJ = parcelRequire("2aGBJ");

var $k8MAo = parcelRequire("k8MAo");

var $8Bf3D = parcelRequire("8Bf3D");

var $64QTD = parcelRequire("64QTD");

var $gtKO2 = parcelRequire("gtKO2");

var $7eeh4 = parcelRequire("7eeh4");

var $bqdjD = parcelRequire("bqdjD");

var $9b70D = parcelRequire("9b70D");

var $1UkGo = parcelRequire("1UkGo");

var $6OnpU = parcelRequire("6OnpU");

var $oGoZh = parcelRequire("oGoZh");

var $1V2cH = parcelRequire("1V2cH");
const $1ef3e311772fd3c0$var$WhiteboxFooter = ({ isMobileApp: isMobileApp, oidcContext: oidcContext, showSocialLoginOnly: showSocialLoginOnly })=>{
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const isCommercial = (0, $bqdjD.getCurrentCloudType)() === 'commercial';
    const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(location.search);
    const signupLinkEnabled = (0, $91i6m.useMemo)(()=>{
        // Due to Apple Store rules, we don't want sign up link on login page in Mobile OAuth case, unless we provide redirection from login to signup
        const shouldRenderSignupLink = isCommercial && (!isMobileApp || (0, $7eeh4.isOidcDisplayMode)(oidcContext, (0, $gtKO2.OidcDisplay).LoginWithRedirect));
        return queryParams.shide !== 'true' && shouldRenderSignupLink;
    }, [
        isCommercial,
        isMobileApp,
        oidcContext,
        queryParams.shide
    ]);
    if (showSocialLoginOnly) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $64QTD.default), {
        id: "use-a-different-login-method",
        spacing: "none",
        onClick: ()=>{
            dispatch((0, $k8MAo.resetLoginForm)());
        },
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $9b70D.LoginPageMessages).socialFormUseDifferentLoginMethod))
    });
    return /*#__PURE__*/ (0, $4ZSso.jsxs)("ul", {
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6OnpU.ResetPasswordLink), {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                        id: "trouble.logging.in",
                        defaultMessage: "Can't log in?"
                    })
                })
            }),
            signupLinkEnabled && /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8Bf3D.default), {}),
                    /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $oGoZh.LinkToSignupPage), {
                            onClick: ()=>analyticsClient.linkClickedEvent((0, $1UkGo.loginPageId), 'signUpLink'),
                            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $9b70D.LoginPageMessages).createAnAccount))
                        })
                    })
                ]
            })
        ]
    });
};
var $1ef3e311772fd3c0$export$2e2bcd8739ae039 = $1ef3e311772fd3c0$var$WhiteboxFooter;

});
parcelRegister("6OnpU", function(module, exports) {

$parcel$export(module.exports, "ResetPasswordLink", function () { return $8c2a1933c0efed9f$export$67fc22a75e0cc5ca; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $lqtFl = parcelRequire("lqtFl");
parcelRequire("6d87w");
var $l2v8Y = parcelRequire("l2v8Y");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");
const $8c2a1933c0efed9f$export$67fc22a75e0cc5ca = ({ children: children })=>{
    (0, $4PGUW.useRegisterComponent)($8c2a1933c0efed9f$export$67fc22a75e0cc5ca.name);
    const location = (0, $l2v8Y.useLocation)();
    const resetPasswordLink = (0, $91i6m.useMemo)(()=>'/login/resetpassword' + location.search, [
        location.search
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $lqtFl.default), {
        href: resetPasswordLink,
        id: "resetPassword",
        children: children
    });
};

});

parcelRegister("oGoZh", function(module, exports) {

$parcel$export(module.exports, "LinkToSignupPage", function () { return $c52ffcfdf276cb56$export$d592e43397b27498; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $6d87w = parcelRequire("6d87w");
const $c52ffcfdf276cb56$export$d592e43397b27498 = ({ children: children, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6d87w.Link), {
        to: '/signup' + location.search,
        id: "signup",
        className: "primary-action",
        onClick: onClick,
        children: children
    });
};

});


parcelRegister("NAfW5", function(module, exports) {

$parcel$export(module.exports, "useLoginRecoveryOptions", function () { return $61d6ffcd69039b26$export$7355ce4dcfe6714; });
$parcel$export(module.exports, "useCobrandingApplication", function () { return $61d6ffcd69039b26$export$1d0a4295a0540e3; });
$parcel$export(module.exports, "useSearchParamCodes", function () { return $61d6ffcd69039b26$export$e66bdd3af3ee2b13; });
$parcel$export(module.exports, "useEmailFromSearchParams", function () { return $61d6ffcd69039b26$export$79b4d72483651c8e; });
$parcel$export(module.exports, "useAppendReasonViewingScreen", function () { return $61d6ffcd69039b26$export$833646c3f87e042d; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $91i6m = parcelRequire("91i6m");

var $l2v8Y = parcelRequire("l2v8Y");

var $6d87w = parcelRequire("6d87w");

var $fYxRW = parcelRequire("fYxRW");

var $jy3ZD = parcelRequire("jy3ZD");

var $4rBM8 = parcelRequire("4rBM8");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");
const $61d6ffcd69039b26$export$7355ce4dcfe6714 = ()=>{
    const { state: state } = (0, $4rBM8.useLoginState)();
    const { login: login } = state || {};
    const loginRecoveryOptions = (0, $91i6m.useCallback)((email)=>{
        return (login === null || login === void 0 ? void 0 : login.recoveryToken) && email ? {
            expectedEmail: email,
            recoveryToken: login.recoveryToken
        } : undefined;
    }, [
        login === null || login === void 0 ? void 0 : login.recoveryToken
    ]);
    return loginRecoveryOptions;
};
const $61d6ffcd69039b26$export$1d0a4295a0540e3 = ()=>{
    const { state: state } = (0, $4rBM8.useLoginState)();
    const { cobranding: cobranding } = state || {};
    const applicationData = (0, $91i6m.useMemo)(()=>{
        if (cobranding === undefined) return null;
        return (0, $fYxRW.lookupApplication)(cobranding);
    }, [
        cobranding
    ]);
    return applicationData === null || applicationData === void 0 ? void 0 : applicationData.application;
};
const $61d6ffcd69039b26$export$e66bdd3af3ee2b13 = ()=>{
    const location = (0, $l2v8Y.useLocation)();
    const queryParams = Object.fromEntries(new URLSearchParams(location.search).entries());
    const infoCode = (0, $91i6m.useMemo)(()=>queryParams.infoCode ? {
            code: queryParams.infoCode
        } : null, [
        queryParams.infoCode
    ]);
    const errorCode = (0, $91i6m.useMemo)(()=>queryParams.errorCode ? {
            code: queryParams.errorCode
        } : null, [
        queryParams.errorCode
    ]);
    return {
        errorCode: errorCode,
        infoCode: infoCode
    };
};
const $61d6ffcd69039b26$export$79b4d72483651c8e = ()=>{
    (0, $4PGUW.useRegisterComponent)($61d6ffcd69039b26$export$79b4d72483651c8e.name);
    const loginHint = (0, $jy3ZD.useLoginHint)();
    const [queryParams] = (0, $6d87w.useSearchParams)();
    return (0, $jy3ZD.getEmailFromLoginHint)(loginHint) || queryParams.get('email') || '';
};
const $61d6ffcd69039b26$export$833646c3f87e042d = ()=>{
    const { search: search } = (0, $l2v8Y.useLocation)();
    const infoCode = (0, $91i6m.useMemo)(()=>{
        const queryParams = new URLSearchParams(search);
        return queryParams.has('infoCode') ? {
            code: queryParams.get('infoCode')
        } : null;
    }, [
        search
    ]);
    const appendReasonViewingScreen = (0, $91i6m.useCallback)((eventAttributes)=>{
        if (infoCode) switch(infoCode.code){
            case 'migratingExistingUser':
                return (0, $b2I6k._)((0, $1Fos3._)({}, eventAttributes), {
                    reasonViewingScreen: 'migratingUser'
                });
            case 'existingUserSignupAttempt':
                return (0, $b2I6k._)((0, $1Fos3._)({}, eventAttributes), {
                    reasonViewingScreen: 'existingUserSignupAttempt'
                });
            case 'invitedUser':
                return (0, $b2I6k._)((0, $1Fos3._)({}, eventAttributes), {
                    reasonViewingScreen: 'invitedUser'
                });
            default:
                return eventAttributes;
        }
        return eventAttributes;
    }, [
        infoCode
    ]);
    return appendReasonViewingScreen;
};

});

parcelRegister("4Nxm2", function(module, exports) {

$parcel$export(module.exports, "useLogin", function () { return $ffa99c624ddf1c6c$export$d4e22f05f73ea56b; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $91i6m = parcelRequire("91i6m");

var $l2v8Y = parcelRequire("l2v8Y");

var $k8MAo = parcelRequire("k8MAo");

var $3yDip = parcelRequire("3yDip");

var $a5qoX = parcelRequire("a5qoX");

var $2aGBJ = parcelRequire("2aGBJ");

var $gtKO2 = parcelRequire("gtKO2");

var $1V2cH = parcelRequire("1V2cH");

var $4rBM8 = parcelRequire("4rBM8");

var $7eeh4 = parcelRequire("7eeh4");

var $1UkGo = parcelRequire("1UkGo");

var $NAfW5 = parcelRequire("NAfW5");

var $cRW6P = parcelRequire("cRW6P");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");

var $leG06 = parcelRequire("leG06");

var $5lN6k = parcelRequire("5lN6k");

var $7TdMa = parcelRequire("7TdMa");

var $hRXhd = parcelRequire("hRXhd");

var $9uXJ3 = parcelRequire("9uXJ3");
const $ffa99c624ddf1c6c$export$d4e22f05f73ea56b = ({ autoRedirect: autoRedirect = true, autoCheckUsername: autoCheckUsername = true, useV2CheckUsernameFlow: useV2CheckUsernameFlow = false } = {
    autoRedirect: true,
    autoCheckUsername: true,
    useV2CheckUsernameFlow: false
})=>{
    (0, $4PGUW.useRegisterComponent)($ffa99c624ddf1c6c$export$d4e22f05f73ea56b.name);
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const location = (0, $l2v8Y.useLocation)();
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const queryParams = (0, $91i6m.useMemo)(()=>Object.fromEntries(new URLSearchParams(location.search).entries()), [
        location.search
    ]);
    const { rememberMeEnabled: rememberMeEnabled, rememberedAccounts: rememberedAccounts, isRememberMeChecked: isRememberMeChecked, onToggleRememberMeCheckbox: onToggleRememberMeCheckbox } = (0, $hRXhd.useRememberMe)();
    const isV1UsernameChecked = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isUsernameChecked;
    });
    const isCheckingUsername = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isCheckingUsername;
    });
    const isV2UsernameChecked = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isV2UsernameChecked;
    });
    const isV2CheckingUsername = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isV2CheckingUsername;
    });
    const isLoggingIn = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isLoggingIn;
    });
    const passwordless = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.passwordless;
    });
    const usernameExists = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.usernameExists;
    });
    const nextAttemptCount = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.nextAttempt;
    });
    const redirectUrl = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.redirectUrl;
    });
    const redirectType = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.redirectType;
    });
    const isMobileApp = (0, $2aGBJ.useAppSelector)((state)=>state.microbranding.isMobileApp);
    const isAnyMobile = (0, $2aGBJ.useAppSelector)((state)=>state.microbranding.isAnyMobile);
    const restrictedEmail = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.restrictedEmail;
    });
    const error = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.error;
    });
    const checkUsernameError = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login_fieldErrors, _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : (_state_login_fieldErrors = _state_login.fieldErrors) === null || _state_login_fieldErrors === void 0 ? void 0 : _state_login_fieldErrors.email;
    });
    const v2Accounts = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.v2Accounts;
    });
    const isRestrictedEmail = restrictedEmail || (queryParams === null || queryParams === void 0 ? void 0 : queryParams.restrict) === 'true';
    const isLoading = isCheckingUsername || isLoggingIn;
    const { state: state } = (0, $4rBM8.useLoginState)();
    const { oidcContext: oidcContext, login: login } = state || {};
    const { error: errorFromInjectedState } = login || {};
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    const loginRecoveryOptions = (0, $NAfW5.useLoginRecoveryOptions)();
    const application = (0, $NAfW5.useCobrandingApplication)();
    const loginPrompt = queryParams === null || queryParams === void 0 ? void 0 : queryParams.prompt;
    const isUsernameChecked = useV2CheckUsernameFlow ? isV2UsernameChecked : isV1UsernameChecked;
    // redirect
    (0, $91i6m.useEffect)(()=>{
        if (!autoRedirect || useV2CheckUsernameFlow) return;
        const shouldRedirect = !isMobileApp || (0, $7eeh4.isOidcDisplayMode)(oidcContext, (0, $gtKO2.OidcDisplay).LoginWithRedirect);
        if (redirectUrl) navigate(redirectUrl);
        else if (!isLoading && isUsernameChecked && !usernameExists && shouldRedirect) {
            dispatch((0, $k8MAo.resetLoginForm)());
            analyticsClient.operationalEvent({
                page: (0, $1UkGo.loginPageId),
                subject: 'loginAttempt',
                action: 'redirectedToSignup'
            });
            if (location.search.length === 0) navigate('/signup?redirectedFrom=login');
            else navigate(`/signup${location.search}&redirectedFrom=login`);
        }
    }, [
        autoRedirect,
        useV2CheckUsernameFlow,
        analyticsClient,
        application,
        dispatch,
        navigate,
        isAnyMobile,
        isLoading,
        isMobileApp,
        isUsernameChecked,
        oidcContext,
        redirectUrl,
        usernameExists,
        location.search
    ]);
    // redirect to signup if no accounts are found when using the new V2 check username flow
    (0, $91i6m.useEffect)(()=>{
        if (useV2CheckUsernameFlow && isV2UsernameChecked && (!v2Accounts || v2Accounts.length === 0)) navigate('/signup');
    }, [
        isV2UsernameChecked,
        useV2CheckUsernameFlow,
        v2Accounts,
        navigate
    ]);
    const [isCheckUsernameCaptchaLoading, setIsCheckUsernameCaptchaLoading] = (0, $91i6m.useState)(false);
    const { errorCode: errorCode, infoCode: infoCode } = (0, $NAfW5.useSearchParamCodes)();
    // This 'combines' multiple error sources into one for easier consumption downstream.
    // 1. redux store (from server, either injected or fetched via separate api call to /frontend/state)
    // 2. fetched via api endpoint call to /login/state (which never gets written to the redux store)
    // 3. Any error code set externally via URL search param.
    //
    // Cases 1 and 2 are needed to reliably cover errors returned by server in both SAS and non-SAS contexts.
    const combinedError = (0, $91i6m.useMemo)(()=>error || errorFromInjectedState || errorCode, [
        error,
        errorFromInjectedState,
        errorCode
    ]);
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const signupLink = (0, $7TdMa.useSignupLink)();
    const combinedErrorWithMessage = (0, $91i6m.useMemo)(()=>{
        if (!combinedError) return;
        const message = (0, $5lN6k.buildLoginErrorMessage)({
            error: combinedError,
            formatMessage: formatMessage,
            signupLink: signupLink,
            nextAttempt: nextAttemptCount,
            application: application
        });
        return (0, $b2I6k._)((0, $1Fos3._)({}, combinedError), {
            message: message
        });
    }, [
        combinedError,
        formatMessage,
        signupLink,
        nextAttemptCount,
        application
    ]);
    const { isLoaded: recaptchaIsLoaded, recaptchaType: recaptchaType, fetchToken: fetchToken } = (0, $a5qoX.useRecaptchaContext)();
    const dispatchCaptchaFailure = (0, $91i6m.useCallback)(()=>{
        dispatch((0, $k8MAo.checkUsernameCaptchaFailure)(navigator.onLine));
    }, [
        dispatch
    ]);
    const fetchRecaptchaToken = (0, $91i6m.useCallback)(async ()=>{
        try {
            setIsCheckUsernameCaptchaLoading(true);
            (0, $3yDip.recaptchaCheckUsernameFetchTokenInteraction).start();
            const challengeResponse = await fetchToken();
            (0, $3yDip.recaptchaCheckUsernameFetchTokenInteraction).stop({
                customData: {
                    restrict: isRestrictedEmail
                }
            });
            return challengeResponse;
        } catch (error) {
            analyticsClient.errorShownEvent((0, $1UkGo.loginPageId), 'recaptchaError', {
                errorMessage: error.message
            });
            dispatchCaptchaFailure();
            return null;
        } finally{
            setIsCheckUsernameCaptchaLoading(false);
        }
    }, [
        analyticsClient,
        dispatchCaptchaFailure,
        isRestrictedEmail,
        fetchToken
    ]);
    const onValidationError = (0, $91i6m.useCallback)((errors)=>dispatch((0, $k8MAo.showFormErrors)(errors)), [
        dispatch
    ]);
    /**
   * @param username username to check the redirect that's required (e.g. SSO). Usually an email address.
   * @param rememberOverride used to override the current states value for the remember me checkbox. Used when selecting an SSO user from the remembered accounts page.
   */ const checkUsernameV1 = (0, $91i6m.useCallback)(async (username, rememberOverride)=>{
        var _loginRecoveryOptions;
        let challengeResponse = null;
        const remember = rememberOverride !== null && rememberOverride !== void 0 ? rememberOverride : isRememberMeChecked;
        const query = (0, $b2I6k._)((0, $1Fos3._)({}, queryParams), {
            email: username
        });
        if (remember) dispatch((0, $k8MAo.setRememberMeCheckbox)(true));
        delete query.errorCode;
        const searchParams = new URLSearchParams(query);
        navigate(`/login?${searchParams.toString()}${location.hash}`);
        // Using the state to "hack" loading state for selecting a remembered account.
        dispatch((0, $k8MAo.requestCheckUsername)());
        if (recaptchaIsLoaded) challengeResponse = await fetchRecaptchaToken();
        analyticsClient.formSubmittedEvent((0, $1UkGo.loginPageId), 'checkUsername', {
            recaptchaType: challengeResponse === null || challengeResponse === void 0 ? void 0 : challengeResponse.type,
            rememberMeChecked: !!remember
        });
        const checkUsernameParams = new URLSearchParams(location.search);
        // if remember me is enabled, then we also include `remember`
        if (remember) checkUsernameParams.append('remember', 'true');
        dispatch((0, $k8MAo.checkUsername)({
            analyticsClient: analyticsClient,
            username: username,
            params: `?${checkUsernameParams.toString()}`,
            recoveryToken: (_loginRecoveryOptions = loginRecoveryOptions(username)) === null || _loginRecoveryOptions === void 0 ? void 0 : _loginRecoveryOptions.recoveryToken,
            challengeResponse: challengeResponse
        }));
        dispatch((0, $cRW6P.fetchConsentConfig)(username));
    }, [
        isRememberMeChecked,
        queryParams,
        navigate,
        location.hash,
        location.search,
        dispatch,
        recaptchaIsLoaded,
        analyticsClient,
        loginRecoveryOptions,
        fetchRecaptchaToken
    ]);
    // V2 version that sets the correct loading state
    const checkUsernameV2 = (0, $91i6m.useCallback)(async (username, rememberOverride)=>{
        var _loginRecoveryOptions;
        let challengeResponse = null;
        const remember = rememberOverride !== null && rememberOverride !== void 0 ? rememberOverride : isRememberMeChecked;
        const query = (0, $b2I6k._)((0, $1Fos3._)({}, queryParams), {
            email: username
        });
        if (remember) dispatch((0, $k8MAo.setRememberMeCheckbox)(true));
        delete query.errorCode;
        const searchParams = new URLSearchParams(query);
        navigate(`/login?${searchParams.toString()}${location.hash}`);
        // Set V2 loading state
        dispatch((0, $k8MAo.requestCheckUsernameV2)());
        if (recaptchaIsLoaded) challengeResponse = await fetchRecaptchaToken();
        analyticsClient.formSubmittedEvent((0, $1UkGo.loginPageId), 'checkUsernameV2', {
            recaptchaType: challengeResponse === null || challengeResponse === void 0 ? void 0 : challengeResponse.type,
            rememberMeChecked: !!remember
        });
        const checkUsernameParams = new URLSearchParams(location.search);
        if (remember) checkUsernameParams.append('remember', 'true');
        dispatch((0, $k8MAo.checkUsernameV2)({
            analyticsClient: analyticsClient,
            username: username,
            params: `?${checkUsernameParams.toString()}`,
            recoveryToken: (_loginRecoveryOptions = loginRecoveryOptions(username)) === null || _loginRecoveryOptions === void 0 ? void 0 : _loginRecoveryOptions.recoveryToken,
            challengeResponse: challengeResponse
        }));
        dispatch((0, $cRW6P.fetchConsentConfig)(username));
    }, [
        isRememberMeChecked,
        queryParams,
        navigate,
        location.hash,
        location.search,
        dispatch,
        recaptchaIsLoaded,
        analyticsClient,
        loginRecoveryOptions,
        fetchRecaptchaToken
    ]);
    const emailFromSearchParams = (0, $NAfW5.useEmailFromSearchParams)();
    // This code is intended to auto-submit the check-username request if email is restricted
    (0, $91i6m.useEffect)(()=>{
        const handleMount = async ()=>{
            if (!recaptchaIsLoaded) return;
            if (!autoCheckUsername) return;
            if (!isRestrictedEmail) return;
            const emailWithDefault = emailFromSearchParams || '';
            if (!emailWithDefault) return;
            // recaptchaType 'checkbox' should not be auto-submitted
            if (recaptchaType === 'score') await checkUsernameV1(emailWithDefault);
        };
        handleMount();
    // We only want this to run when the component mounts or
    // when recaptcha.isLoaded becomes true (if it was false)
    // We need to investigate why `useRecaptcha` always returns a new object,
    // So we can remove this eslint-disable rule and add all the correct dependencies.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        recaptchaIsLoaded
    ]);
    const checkUsername = useV2CheckUsernameFlow ? checkUsernameV2 : checkUsernameV1;
    const resetLogin = (0, $91i6m.useCallback)(()=>dispatch((0, $k8MAo.resetLoginForm)()), [
        dispatch
    ]);
    const isPasswordlessAllowed = passwordless !== (0, $gtKO2.CheckUserNamePasswordlessType).Disallowed && !(0, $7eeh4.isMobileOidc)(oidcContext);
    const isV1CheckUsernameLoading = isCheckingUsername || isCheckUsernameCaptchaLoading;
    const isV2CheckUsernameLoading = isV2CheckingUsername || isCheckUsernameCaptchaLoading;
    const isCheckUsernameLoading = useV2CheckUsernameFlow ? isV2CheckUsernameLoading : isV1CheckUsernameLoading;
    // This prevents redirecting to the list of remembered accounts in certain situations.
    // TODO: KIRBY-8427: consider moving this check into a separate hook to avoid calling
    //                   `useLogin` for the check in the login OrchestratedPage.
    const shouldShowRememberedAccounts = rememberMeEnabled && emailFromSearchParams === '' && !isCheckUsernameLoading && loginPrompt !== 'true' && loginPrompt !== 'login' && rememberedAccounts && rememberedAccounts.length > 0;
    return {
        isPasswordlessAllowed: /**
     * Indicates whether the user is eligible to log in via a link emailed to them.
     * */ isPasswordlessAllowed,
        isUsernameChecked: /**
     * Reflects the state of the first essential step of the login process.
     *
     * Will be false until `checkUsername` has been called. True thereafter (until reset via
     * a call to `resetLogin`).
     *
     * */ isUsernameChecked,
        isCheckUsernameLoading: /**
     * Reflects loading state following a call to `checkUsername`.
     * */ isCheckUsernameLoading,
        checkUsernameError: /**
     * Indicates the reason `checkUsername` has failed. See type definition for details.
     * */ checkUsernameError,
        isRestrictedEmail: /**
     * Indicates whether the user's username/email has been deemed restricted. In such cases,
     * `checkUsername` will be called automatically for this username, unless opted out by setting
     * the `autoCheckUsername` option to `false` in the args to `useLogin`.
     *
     * For example, the username may be restricted by admins in the user's org.
     * */ isRestrictedEmail,
        checkUsername: /**
     * This is the essential first step of the login process.
     *
     * @warning NOTE: Until this handler has been called, username and password submission will not work.
     *
     * This function handles the commercial `checkUsername` and the isolated cloud `checkUsernameV2`
     * API call to sign-in-service, which we use to handle either the redirect for a user given their
     * configuration in commercial (e.g. password user, SSO user, social user, etc) or to show all available accounts for a user given their
     * IC (isolated cloud) configurations.
     *
     * This must be called by any cobranding that implements the login page.
     * */ checkUsername,
        loginPrompt: /**
     * Login "prompt" query parameter. If set, shows the email input to the user.
     * In case of `select_account` value, the user is redirected to the account switcher.
     * */ loginPrompt,
        /**
     * Indicates that login has failed for a particular reason. See type definition for details.
     * */ error: combinedErrorWithMessage,
        infoCode: /**
     * An externally set code indicating a message for the user may need to be rendered. See type
     * definition for details.
     * */ infoCode,
        nextAttemptCount: /**
     * The number of times the user will have attempted to login (at their next attempt). After a
     * certain number of attempts, it may be desirable to render a message directing the user to try
     * to reset their password.
     *
     * (The base login experience does this when the count is greater than 4).
     * */ nextAttemptCount,
        redirectUrl: /**
     * The URL to which the user ought to be redirected, as indicated by the server. This
     * redirection will be automatic unless opted out in the args to `useLogin`.
     * */ redirectUrl,
        redirectType: /**
     * Indicates the reason given by the server for redirecting the user. Useful for rendering
     * relevant UI while the redirect is taking place (e.g. SSO).
     * */ redirectType,
        resetLogin: /**
     * Resets the state of the login process back to the first step (where `checkUsername` must be
     * called again).
     *
     * Should be called when user has chosen to enter a different username than the one they had
     * already entered.
     * */ resetLogin,
        rememberMeEnabled: /**
     * Whether or not the `remember me` feature is enabled.
     *
     * Re-exported from `useRememberMe` hook for convenience.
     * */ rememberMeEnabled,
        rememberedAccounts: /**
     * The list of accounts that have been remembered by the user.
     *
     * Re-exported from `useRememberMe` hook for convenience.
     * */ rememberedAccounts,
        shouldShowRememberedAccounts: /**
     * Whether or not to show the remembered accounts list.
     */ shouldShowRememberedAccounts,
        isRememberMeChecked: /**
     * Whether or not the remember me checkbox is checked. Used to pre-check the checkbox when selecting a remembered account.
     *
     * Re-exported from `useRememberMe` hook for convenience.
     */ isRememberMeChecked,
        onToggleRememberMeCheckbox: /**
     * Toggles the remember me checkbox.'
     *
     * Re-exported from `useRememberMe` hook for convenience.
     */ onToggleRememberMeCheckbox,
        onValidationError: /**
     * Used to provide any additional errors (i.e. ones that aren't provided directly by this hook) that should be rendered on the login page.
     *
     * @param errors any errors that should be shown in the login form.
     */ onValidationError,
        v2Accounts: /**
     * The list of available accounts returned from the V2 check username API call. Only available when `useV2CheckUsernameFlow` is true.
     * Used to display the list of available accounts to the user across all available Atlassian Cloud and Isolated Cloud environments.
     */ v2Accounts
    };
};

});
parcelRegister("3yDip", function(module, exports) {

$parcel$export(module.exports, "recaptchaCheckUsernameFetchTokenInteraction", function () { return $04c86f329a8264d4$export$b7874a5a14992cfe; });

var $iBu0H = parcelRequire("iBu0H");
const $04c86f329a8264d4$export$b7874a5a14992cfe = (0, $iBu0H.metrics).interaction({
    key: 'aid-frontend-recaptcha-fetch-token-check-username'
});

});

parcelRegister("cRW6P", function(module, exports) {

$parcel$export(module.exports, "fetchConsentConfig", function () { return $084060f2cbf1e53b$export$58e2aa80c90a0ce1; });

var $49Pnv = parcelRequire("49Pnv");
const $084060f2cbf1e53b$export$cff006d34f7616ad = (config)=>({
        type: 'UPDATE_MARKETING_CONSENT_CONFIG',
        config: config
    });
const $084060f2cbf1e53b$export$58e2aa80c90a0ce1 = (email)=>(dispatch)=>{
        return fetch('/rest/marketing-consent/config', {
            method: 'POST',
            credentials: 'omit',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: email
            })
        }).then((response)=>{
            if (response.status === 200) return response.json().then((cfg)=>dispatch($084060f2cbf1e53b$export$cff006d34f7616ad(cfg)));
            else if (response.status === 204) {
                // No response from ConsentHub for some reason
                const level = 'warning';
                (0, $49Pnv.captureMessage)('Unable to retrieve marketing consent config', {
                    status: response.status,
                    reason: 'no_content'
                }, level);
            } else if (response.status === 400) {
                // Signup was unable to extract IP
                const level = 'warning';
                (0, $49Pnv.captureMessage)('Unable to retrieve marketing consent config', {
                    status: response.status,
                    reason: 'cannot_extract_ip'
                }, level);
            } else return response.text().then((error)=>{
                throw new Error(error || response.statusText);
            });
        }).catch((0, $49Pnv.captureException));
    };

});

parcelRegister("5lN6k", function(module, exports) {

$parcel$export(module.exports, "buildLoginErrorMessage", function () { return $190030bedfbf80d7$export$7a0831816210b6bb; });

var $1Fos3 = parcelRequire("1Fos3");

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $lqtFl = parcelRequire("lqtFl");

var $bE8z6 = parcelRequire("bE8z6");

var $bqdjD = parcelRequire("bqdjD");

var $6OnpU = parcelRequire("6OnpU");
const $190030bedfbf80d7$export$7a0831816210b6bb = ({ error: error, formatMessage: formatMessage, signupLink: signupLink, nextAttempt: nextAttempt, application: application })=>{
    if (!error) return;
    const { args: args = {} } = error;
    switch(error === null || error === void 0 ? void 0 : error.code){
        case 'captcha':
            return formatMessage({
                id: 'login.error.captcha',
                defaultMessage: 'We are having trouble verifying reCAPTCHA for this request. Please try again. If the problem persists, try another browser/device or reach out to Atlassian Support.'
            });
        case 'captchaScoreTooLow':
            return formatMessage({
                id: 'login.error.captcha.score_too_low',
                defaultMessage: "We'd like to make sure it's really you. Please confirm you're not a robot.",
                description: 'Message asking user to tick the reCAPTCHA checkbox and resubmit the form'
            });
        case 'invalid_user_password':
            return $190030bedfbf80d7$var$incorrectCredentialsErrorMessage(formatMessage, nextAttempt, signupLink, application);
        case 'ambiguous_user':
            return formatMessage({
                id: 'login.error.details.ambiguous',
                defaultMessage: 'It seems that you have multiple accounts associated with your email. Please contact your administrator to remove the duplicate.'
            });
        case 'no_email_on_remote_user':
            return formatMessage({
                id: 'login.error.remote.user.no.email',
                defaultMessage: "Your {username} user doesn't have an associated email address, so we can't create your Atlassian account. Please contact support."
            }, (0, $1Fos3._)({}, args));
        case 'bitbucket_username_is_not_email':
            return formatMessage({
                id: 'login.error.remote.user.using.username',
                defaultMessage: 'You can no longer log in with a username. Use your primary email address {username} instead.'
            }, (0, $1Fos3._)({}, args));
        case 'username_is_not_email':
            return formatMessage({
                id: 'login.error.email.not.username',
                defaultMessage: 'You must use your email address to log in. Did you mean to use {username}?'
            }, (0, $1Fos3._)({}, args));
        case 'bitbucket_email_is_not_primary':
            return formatMessage({
                id: 'login.error.remote.user.using.alias',
                defaultMessage: 'You can no longer log in with an email alias. Use your primary email address {username} instead.'
            }, (0, $1Fos3._)({}, args));
        case 'bitbucket_mfa_enforced':
            return formatMessage({
                id: 'login.error.user.mfa.enforced',
                defaultMessage: 'Your organization wants you to secure your account by setting up two-step verification.'
            }, (0, $1Fos3._)({}, args));
        case 'bitbucket_mfa_required':
            return formatMessage({
                id: 'login.error.user.mfa.required',
                defaultMessage: 'For added security, your organization wants you to log in with two-step verification.'
            }, (0, $1Fos3._)({}, args));
        case 'bitbucket_saml_user':
            return formatMessage({
                id: 'login.error.saml.user',
                defaultMessage: 'For added security, your organization wants you to log in with single sign-on.'
            }, (0, $1Fos3._)({}, args));
        case 'email_is_not_primary':
            return formatMessage({
                id: 'login.error.email.not.username',
                defaultMessage: 'You must use your email address to log in. Did you mean to use {username}?'
            }, (0, $1Fos3._)({}, args));
        case 'too_many_logins':
        case 'too_many_requests':
            return formatMessage({
                id: 'login.error.too.many.logins',
                defaultMessage: "For security purposes, we've temporarily locked your account due to multiple log in attempts within a short period of time. Please try again in a few minutes. If this issue persists, please contact Atlassian Support."
            });
        case 'multiple_google_accounts':
            return formatMessage({
                id: 'login.error.google.auth.contact.support',
                defaultMessage: "We've encountered problems signing you in with your Google Account. Please contact support to resolve this problem."
            });
        case 'unable_to_verify_google_token':
            return formatMessage({
                id: 'login.error.unable.to.verify.google.token',
                defaultMessage: 'We were unable to verify your Google Account. Please try again later.'
            });
        case 'google_email_change_not_allowed_by_auth_policy':
            return formatMessage({
                id: 'login.error.google.email.change.not.allowed.by.auth.policy',
                defaultMessage: "Sorry, we detected an email change that is not supported by your organization's authentication policy. Please log in with an email address that matches your account."
            });
        case 'google_email_change_not_allowed_by_user_managed_status':
            return formatMessage({
                id: 'login.error.google.email.change.not.allowed.by.user.managed.status',
                defaultMessage: 'We detected an email change that would remove you from your organization. Contact your organization admin to check your account is configured correctly or try to log in a different way.'
            });
        case 'social_login_missing_email':
            return formatMessage({
                id: 'login.error.social.missing.email',
                defaultMessage: 'We did not receive a valid email address from your identity provider. Please try logging in again by typing your email address. If you don\'t have a password, use the "Can\'t log in" link to set one.'
            });
        case 'social_login_missing_email_verified':
            return formatMessage({
                id: 'login.error.social.missing.email.verified',
                defaultMessage: 'We did not receive a valid email verification from your identity provider. Please try logging in again by typing your email address. If you don\'t have a password, use the "Can\'t log in" link to set one.'
            });
        case 'social_login_unexpected_login_type':
            return formatMessage({
                id: 'login.error.social.unexpected.login.type',
                defaultMessage: 'We did not receive valid information from your identity provider. Please try logging in again by typing your email address. If you don\'t have a password, use the "Can\'t log in" link to set one.'
            });
        case 'social_login_missing_slack_email_date_verified':
            return formatMessage({
                id: 'login.error.slack.missing.email.date.verified',
                defaultMessage: 'We did not receive a valid email date verified from your identity provider. Please try logging in again by typing your email address. If you don\'t have a password, use the "Can\'t log in" link to set one.'
            });
        case 'social_login_invalid_social_id':
            return formatMessage({
                id: 'login.error.social.invalid.social.id',
                defaultMessage: 'We did not receive valid id from your identity provider. Please try logging in again by typing your email address. If you don\'t have a password, use the "Can\'t log in" link to set one.'
            });
        case 'slack_login_invalid_team_id':
            return formatMessage({
                id: 'login.error.slack.invalid.team.id',
                defaultMessage: 'We did not receive valid team id from your identity provider. Please try logging in again by typing your email address. If you don\'t have a password, use the "Can\'t log in" link to set one.'
            });
        case 'social_login_managed_user':
            return formatMessage({
                id: 'login.error.social.managed.user',
                defaultMessage: "Hmm... we're having trouble logging you in. Please try again with a different authentication method."
            });
        case 'social_login_requires_password_change':
            return formatMessage({
                id: 'login.error.social.requires.password.change',
                defaultMessage: 'Your current password has expired, so you need to reset your password to continue.'
            });
        case 'social_login_hide_email_change_not_allowed_to_bypass_policy':
            return formatMessage({
                id: 'login.error.social.hide.email.change.not.allowed.to.bypass.policy',
                defaultMessage: 'Sorry, you cannot hide your email once you are part of an organization. Please ensure that you share your real email.'
            });
        case 'social_login_email_change_not_allowed_to_bypass_policy':
            return formatMessage({
                id: 'login.error.social.email.change.not.allowed.to.bypass.policy',
                defaultMessage: "Sorry, we detected an email change that is not supported by your organization's authentication policy. Please log in with a email address that matches your account."
            });
        case 'social_login_email_change_not_allowed':
            return formatMessage({
                id: 'login.error.social.email.change.not.allowed',
                defaultMessage: 'We detected an email change that would remove you from your organization. Contact your organization admin to check your account is configured correctly or try to log in a different way.'
            });
        case 'social_login_consent_required':
            return formatMessage({
                id: 'login.error.social.login.consent.required',
                defaultMessage: 'Please grant access to your account details if you wish to login to your Atlassian account.'
            });
        case 'user_is_blocked':
            return formatMessage({
                id: 'login.error.user.blocked',
                defaultMessage: 'This account has been deactivated. Please contact your organization admin.'
            });
        case 'social_login_banned':
            return formatMessage({
                id: 'login.error.social.login.banned',
                defaultMessage: 'Your admin has blocked third-party login. Log in with your email address instead.'
            });
        case 'apple_login_disabled':
            return formatMessage({
                id: 'login.error.apple.login.disabled',
                defaultMessage: 'Sorry, it is not possible to log in with Apple at this time. We are working on it.'
            });
        case 'microsoft_login_disabled':
            return formatMessage({
                id: 'login.error.microsoft.login.disabled',
                defaultMessage: 'Sorry, it is not possible to log in with Microsoft at this time. We are working on it.'
            });
        case 'slack_login_disabled':
            return formatMessage({
                id: 'login.error.slack.login.disabled',
                defaultMessage: 'Sorry, it is not possible to log in with Slack at this time. We are working on it.'
            });
        case 'password_leaked':
            return formatMessage({
                id: 'login.error.password.leaked.xml',
                defaultMessage: 'You must <reset-password-link>change your password</reset-password-link> to log in. Your current password has appeared in an external data breach and your Atlassian account is at risk. <password-leaked-link>Learn more</password-leaked-link>'
            }, {
                'reset-password-link': (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)((0, $6OnpU.ResetPasswordLink), {
                        children: chunks
                    }),
                'password-leaked-link': (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("a", {
                        href: (0, $bE8z6.PASSWORD_LEAKED_LINK),
                        children: chunks
                    })
            });
        case 'login.form.token.expired':
            return formatMessage({
                id: 'login.error.token.expired',
                defaultMessage: 'Your login request has expired.'
            });
        case 'login.form.problem.encountered':
            return formatMessage({
                id: 'login.error.problem.encountered',
                defaultMessage: "We've encountered a problem. Please try again in a few minutes."
            });
        case 'login.form.email.does.not.match.loggedin.user':
            return formatMessage({
                id: 'login.form.email.does.not.match.loggedin.user',
                defaultMessage: "You're currently logged in as {username}, logging in as another user will log you out of your current session."
            }, (0, $1Fos3._)({}, args));
        case 'hosted_domain_mismatch':
            return formatMessage({
                id: 'google.hosted.domain.mismatch',
                defaultMessage: 'Unable to log in with Google. Contact your admin to check your account is configured correctly or try to log in a different way.'
            });
        case 'switch.session.expired':
            return formatMessage({
                id: 'session.switch.error.expired',
                defaultMessage: 'Your account session expired. Log in again to continue.'
            });
        case 'request_error':
            return formatMessage({
                id: 'network.request.error',
                defaultMessage: 'Unable to connect. Check your internet connection or the network settings for your browser and try again.'
            });
        case 'invalid.session.token':
            return formatMessage({
                id: 'invalid.session.token',
                defaultMessage: 'Your session token is invalid. Log in again to continue.'
            });
        case 'verify.email.expired':
            return formatMessage({
                id: 'verify.email.expired',
                defaultMessage: 'Your email verification attempt has expired. Enter your email address and try again.'
            });
        case 'verify.email.error':
            return formatMessage({
                id: 'verify.email.error',
                defaultMessage: 'Something went wrong while verifying your email address. Enter your email address and try again.'
            });
        case 'too_many_username_requests':
            return formatMessage({
                id: 'check.username.rate.limit.exceeded',
                defaultMessage: 'Too many login attempts detected. Please wait for a few minutes before trying again.'
            });
        case 'generic-consent-error':
            return formatMessage({
                id: 'generic-consent-error',
                defaultMessage: 'To access this page, you must accept the Privacy Notice.'
            });
        case 'consent-validation-error':
            return formatMessage({
                id: 'consent-validation-error',
                defaultMessage: 'Something went wrong while attempting to validate your consent. Try logging in again later.'
            });
        case 'consent-loading-error':
            return formatMessage({
                id: 'consent-loading-error',
                defaultMessage: 'Something went wrong while loading the consent screen. Try logging in again later.'
            });
        case 'remember-me-cookie-error':
            return formatMessage({
                id: 'remember-me-cookie-error',
                defaultMessage: 'Something went wrong while loading your remembered accounts. Log in again to continue.'
            });
        case 'invalid_passkey':
            return formatMessage({
                id: 'invalid-passkey-error',
                defaultMessage: 'The provided passkey is invalid. Please try again with a different authentication method.'
            });
        case 'passkey_managed_account':
            return formatMessage({
                id: 'managed-account-passkey-error',
                defaultMessage: "Hmm... we're having trouble logging you in. Please try again with a different authentication method."
            });
        case 'webauthn_not_supported':
            return formatMessage({
                id: 'webauthn-not-supported-error',
                defaultMessage: "We\u2019re unable to verify your passkey. Make sure your browser supports WebAuthn."
            });
        case 'webauthn_challenge_failed':
            return formatMessage({
                id: 'webauthn-challenge-failed-error',
                defaultMessage: "Your passkey couldn\u2019t complete the authentication. Try again. If this keeps happening, contact support."
            });
        default:
            return formatMessage({
                id: 'login.error.unknown',
                defaultMessage: 'Something went wrong while attempting to validate your credentials.'
            });
    }
};
const $190030bedfbf80d7$var$incorrectCredentialsErrorMessage = (formatMessage, nextAttempt, signupLink, application)=>{
    if (nextAttempt > 4) return formatMessage({
        id: 'login.error.invalid.credentials.more.help.xml',
        defaultMessage: "We've recently made changes to the login page. If you are having difficulty logging in, <reset-password-link>reset your password</reset-password-link>."
    }, {
        'reset-password-link': (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)((0, $6OnpU.ResetPasswordLink), {
                children: chunks
            })
    });
    else if (application === 'trello') return formatMessage({
        id: 'login.error.invalid.credentials.trello.specific.help.xml',
        defaultMessage: 'Incorrect email address and / or password. If you recently migrated your Trello account to an Atlassian account, you will need to use your Atlassian account password. Alternatively, you can get help <reset-password-link>logging in</reset-password-link>.'
    }, {
        'reset-password-link': (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)((0, $6OnpU.ResetPasswordLink), {
                children: chunks
            })
    });
    else {
        // Fedramp doesn't have a sign up flow, so we don't want to show the sign up link.
        if ((0, $bqdjD.isFedM)()) return formatMessage({
            id: 'login.error.invalid.credentials.xml',
            defaultMessage: 'Incorrect email address and/or password. Try again or <reset-password-link>reset your password</reset-password-link>.'
        }, {
            'reset-password-link': (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)((0, $6OnpU.ResetPasswordLink), {
                    children: chunks
                })
        });
        const invalidCredentials = formatMessage({
            id: 'login.error.invalid.credentials.xml',
            defaultMessage: 'Incorrect email address and/or password. Try again or <reset-password-link>reset your password</reset-password-link>.'
        }, {
            'reset-password-link': (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)((0, $6OnpU.ResetPasswordLink), {
                    children: chunks
                })
        });
        const signupSuffix = formatMessage({
            id: 'login.error.invalid.credentials.xml.sign_up',
            defaultMessage: '<sign-up-link>Sign up</sign-up-link> for an Atlassian account.'
        }, {
            'sign-up-link': (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)((0, $lqtFl.default), {
                    href: signupLink,
                    children: chunks
                })
        });
        return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
            children: [
                invalidCredentials,
                /*#__PURE__*/ (0, $4ZSso.jsx)("br", {}),
                signupSuffix
            ]
        });
    }
};

});

parcelRegister("7TdMa", function(module, exports) {

$parcel$export(module.exports, "useSignupLink", function () { return $43ea02ff365fdc16$export$2608a74d725f1f9f; });
parcelRequire("6d87w");
var $l2v8Y = parcelRequire("l2v8Y");
const $43ea02ff365fdc16$export$2608a74d725f1f9f = ()=>{
    const location = (0, $l2v8Y.useLocation)();
    // Note: location.search includes the leading `?` character.
    return `/signup${location.search}`;
};

});

parcelRegister("hRXhd", function(module, exports) {

$parcel$export(module.exports, "useRememberMe", function () { return $f66c2dbc2074c379$export$a988c57eb90dc982; });

var $91i6m = parcelRequire("91i6m");

var $l2v8Y = parcelRequire("l2v8Y");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");

var $6d87w = parcelRequire("6d87w");

var $2aGBJ = parcelRequire("2aGBJ");

var $1V2cH = parcelRequire("1V2cH");

var $7eKPL = parcelRequire("7eKPL");

var $k8MAo = parcelRequire("k8MAo");

var $9uXJ3 = parcelRequire("9uXJ3");
const $f66c2dbc2074c379$export$a988c57eb90dc982 = ()=>{
    (0, $4PGUW.useRegisterComponent)($f66c2dbc2074c379$export$a988c57eb90dc982.name);
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    const location = (0, $l2v8Y.useLocation)();
    const [searchParams] = (0, $6d87w.useSearchParams)();
    const [isDeleteModeEnabled, setIsDeleteModeEnabled] = (0, $91i6m.useState)(false);
    const rememberMeEnabled = (0, $2aGBJ.useAppSelector)((state)=>state.login.rememberMeEnabled);
    const rememberedAccounts = (0, $2aGBJ.useAppSelector)((state)=>state.login.rememberedAccounts);
    const isRememberMeChecked = (0, $2aGBJ.useAppSelector)((state)=>state.login.isRememberMeChecked);
    const rememberedAccountsResponseCodes = (0, $2aGBJ.useAppSelector)((state)=>state.login.rememberedAccountsResponseCodes);
    const onAddAccountSelected = (0, $91i6m.useCallback)(()=>{
        searchParams.set('prompt', 'login');
        dispatch((0, $k8MAo.resetRememberMeState)());
        navigate({
            pathname: '/login',
            search: `?${searchParams.toString()}`,
            hash: location.hash
        });
    }, [
        searchParams,
        dispatch,
        navigate,
        location.hash
    ]);
    const onEnableDeleteMode = (0, $91i6m.useCallback)(()=>{
        setIsDeleteModeEnabled(true);
    }, []);
    const onDeleteAccount = (0, $91i6m.useCallback)((account)=>{
        // The backend supports deleting multiple accounts at once, so we need to provide accountIds not just the one.
        const accountIds = [
            account.accountId
        ];
        dispatch((0, $7eKPL.requestRemoveRememberedAccount)({
            accountIds: accountIds,
            analyticsClient: analyticsClient
        }));
    }, [
        analyticsClient,
        dispatch
    ]);
    const onDisableDeleteMode = (0, $91i6m.useCallback)(()=>{
        dispatch((0, $7eKPL.resetRememberMeResponseCodes)());
        setIsDeleteModeEnabled(false);
    }, [
        dispatch
    ]);
    const onToggleRememberMeCheckbox = (0, $91i6m.useCallback)(()=>{
        dispatch((0, $k8MAo.toggleRememberMeCheckbox)());
    }, [
        dispatch
    ]);
    return {
        onAddAccountSelected: onAddAccountSelected,
        onEnableDeleteMode: onEnableDeleteMode,
        rememberMeEnabled: rememberMeEnabled,
        rememberedAccounts: rememberedAccounts,
        onDeleteAccount: onDeleteAccount,
        onDisableDeleteMode: onDisableDeleteMode,
        isDeleteModeEnabled: isDeleteModeEnabled,
        isRememberMeChecked: isRememberMeChecked,
        onToggleRememberMeCheckbox: onToggleRememberMeCheckbox,
        rememberedAccountsResponseCodes: rememberedAccountsResponseCodes
    };
};

});
parcelRegister("7eKPL", function(module, exports) {

$parcel$export(module.exports, "resetRememberMeResponseCodes", function () { return $2f92938ef3a61381$export$d13bbaa5ba2d003d; });
$parcel$export(module.exports, "requestRemoveRememberedAccount", function () { return $2f92938ef3a61381$export$d1be4757a4663fa7; });

var $49Pnv = parcelRequire("49Pnv");

var $53UX4 = parcelRequire("53UX4");
const $2f92938ef3a61381$export$d13bbaa5ba2d003d = ()=>({
        type: 'RESET_REMEMBERED_ACCOUNT_RESPONSE_CODES'
    });
const $2f92938ef3a61381$export$a939d190fcd5712b = (accountIds)=>({
        type: 'REMOVE_REMEMBERED_ACCOUNT_REQUEST_INITIATE',
        payload: {
            accountIds: accountIds
        }
    });
const $2f92938ef3a61381$export$7e60d7595a30bdee = (accountIds, success)=>({
        type: 'REMOVE_REMEMBERED_ACCOUNT_REQUEST_SUCCESS',
        payload: {
            accountIds: accountIds,
            response: success
        }
    });
const $2f92938ef3a61381$export$701cdcf57b5adbcd = (error)=>({
        type: 'REMOVE_REMEMBERED_ACCOUNT_REQUEST_FAILED',
        payload: {
            response: error
        }
    });
const $2f92938ef3a61381$var$ValidResponseValues = [
    'success',
    'cookie_removed'
];
/**
 * Helper function to type guard the response from the remove remembered account API.
 */ function $2f92938ef3a61381$var$isRemoveRememberedAccountSuccessResponse(response) {
    if ('result' in response) return $2f92938ef3a61381$var$ValidResponseValues.includes(response.result);
    return false;
}
const $2f92938ef3a61381$var$REMOVE_REMEMEMBERED_ACCOUNTS_ANALYTICS_ERRORS = {
    bad_request: 'removeRememberedAccountBadRequest',
    invalid_cookie: 'removeRememberedAccountCookieInvalid',
    rate_limited: 'removeRememberedAccountRateLimited',
    unexpected_error: 'removeRememberedAccountUnexpectedError'
};
const $2f92938ef3a61381$export$d1be4757a4663fa7 = ({ accountIds: accountIds, analyticsClient: analyticsClient })=>(dispatch, getState)=>{
        const { csrfToken: csrfToken } = getState();
        dispatch($2f92938ef3a61381$export$a939d190fcd5712b(accountIds));
        if (!accountIds || accountIds.length === 0) {
            dispatch($2f92938ef3a61381$export$701cdcf57b5adbcd('bad_request'));
            return Promise.resolve();
        }
        const request = {
            accountIds: accountIds
        };
        analyticsClient.trackingEvent({
            page: (0, $53UX4.PAGE_ID),
            action: 'removeRememberedAccountInitiate',
            subject: 'account'
        });
        return fetch(`/rest/remember/remove`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            },
            body: JSON.stringify(request)
        }).then((response)=>response.json()).then((response)=>{
            // Successful case
            if ($2f92938ef3a61381$var$isRemoveRememberedAccountSuccessResponse(response)) {
                analyticsClient.trackingEvent({
                    page: (0, $53UX4.PAGE_ID),
                    action: 'removeRememberedAccountSuccess',
                    subject: 'account'
                });
                // Success, UI will update with the new values assuming state is updated.
                dispatch($2f92938ef3a61381$export$7e60d7595a30bdee(accountIds, response.result));
                return;
            }
            var _REMOVE_REMEMEMBERED_ACCOUNTS_ANALYTICS_ERRORS_response_errorCode;
            const analyticsErrorType = (_REMOVE_REMEMEMBERED_ACCOUNTS_ANALYTICS_ERRORS_response_errorCode = $2f92938ef3a61381$var$REMOVE_REMEMEMBERED_ACCOUNTS_ANALYTICS_ERRORS[response === null || response === void 0 ? void 0 : response.errorCode]) !== null && _REMOVE_REMEMEMBERED_ACCOUNTS_ANALYTICS_ERRORS_response_errorCode !== void 0 ? _REMOVE_REMEMEMBERED_ACCOUNTS_ANALYTICS_ERRORS_response_errorCode : 'removeRememberedAccountError';
            analyticsClient.trackingEvent({
                page: (0, $53UX4.PAGE_ID),
                action: analyticsErrorType,
                subject: 'account'
            });
            // Handle errors, depending on the result
            dispatch($2f92938ef3a61381$export$701cdcf57b5adbcd(response.errorCode));
        }).catch((error)=>{
            dispatch($2f92938ef3a61381$export$701cdcf57b5adbcd('unexpected_error'));
            analyticsClient.trackingEvent({
                page: (0, $53UX4.PAGE_ID),
                action: $2f92938ef3a61381$var$REMOVE_REMEMEMBERED_ACCOUNTS_ANALYTICS_ERRORS.unexpected_error,
                subject: 'account'
            });
            (0, $49Pnv.captureErrorMessage)('Remove Remembered Account failure', error);
        });
    };

});
parcelRegister("53UX4", function(module, exports) {

$parcel$export(module.exports, "PAGE_ID", function () { return $df03b443d8b5c3e2$export$e8b953ecde3e0a56; });
const $df03b443d8b5c3e2$export$e8b953ecde3e0a56 = 'rememberMeAccountSelectScreen';

});




parcelRegister("6xwQE", function(module, exports) {

$parcel$export(module.exports, "useLoginSubmission", function () { return $80aa55fa73b5fa35$export$b40fe35861b4a878; });

var $91i6m = parcelRequire("91i6m");

var $5lFna = parcelRequire("5lFna");

var $2aGBJ = parcelRequire("2aGBJ");

var $1V2cH = parcelRequire("1V2cH");

var $1UkGo = parcelRequire("1UkGo");

var $6eNI5 = parcelRequire("6eNI5");

var $k8MAo = parcelRequire("k8MAo");

var $21Xgy = parcelRequire("21Xgy");

var $9b70D = parcelRequire("9b70D");

var $NAfW5 = parcelRequire("NAfW5");

var $7452z = parcelRequire("7452z");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");

var $9uXJ3 = parcelRequire("9uXJ3");
const $80aa55fa73b5fa35$export$b40fe35861b4a878 = ({ onFailure: onFailure, onSuccess: onSuccess } = {})=>{
    (0, $4PGUW.useRegisterComponent)($80aa55fa73b5fa35$export$b40fe35861b4a878.name);
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const anonymousId = (0, $1V2cH.useAnalyticsAnonymousId)();
    const isUsernameChecked = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isUsernameChecked;
    });
    const isCheckingUsername = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isCheckingUsername;
    });
    const isV2UsernameChecked = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isV2UsernameChecked;
    });
    const isV2CheckingUsername = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isV2CheckingUsername;
    });
    const isLoggingIn = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isLoggingIn;
    });
    const isLoading = isCheckingUsername || isV2CheckingUsername || isLoggingIn;
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const appendReasonViewingScreen = (0, $NAfW5.useAppendReasonViewingScreen)();
    const { captchaValue: captchaValue } = (0, $6eNI5.useLoginTooManyAttemptsRecaptchaContext)();
    const { marketingConsent: marketingConsent } = (0, $7452z.useMarketingConsentContext)();
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    // Wrap redirect to call onSuccess before redirecting
    const redirectWithCallback = (0, $91i6m.useCallback)((url)=>{
        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        navigate(url);
    }, [
        onSuccess,
        navigate
    ]);
    const handleLogIn = (0, $91i6m.useCallback)((username, password)=>{
        if (!marketingConsent) {
            console.error('Form cannot be submitted without showing Marketing Consent');
            onFailure === null || onFailure === void 0 ? void 0 : onFailure();
            return;
        }
        if (!isUsernameChecked && !isV2UsernameChecked) {
            console.error('Cannot submit a username & password login attempt until check-username endpoint has been called (V1 or V2)');
            onFailure === null || onFailure === void 0 ? void 0 : onFailure();
            return;
        }
        analyticsClient.formSubmittedEvent((0, $1UkGo.loginPageId), 'loginForm', appendReasonViewingScreen({
            marketingConsent: (0, $5lFna.dangerouslyCreateSafeString)(marketingConsent.state)
        }));
        const onLoginError = (code)=>{
            onFailure === null || onFailure === void 0 ? void 0 : onFailure();
            analyticsClient.trackingEvent({
                page: (0, $1UkGo.loginPageId),
                action: 'submitted',
                subject: 'credentials',
                attributes: {
                    successfulAuthentication: false,
                    errorCode: code
                }
            });
        };
        dispatch((0, $k8MAo.loginUsernamePassword)({
            username: username,
            password: password,
            captchaValue: captchaValue,
            location: window.location,
            onLoginError: onLoginError,
            marketingConsent: marketingConsent,
            anonymousId: anonymousId
        }, redirectWithCallback));
    }, [
        analyticsClient,
        anonymousId,
        appendReasonViewingScreen,
        captchaValue,
        dispatch,
        isUsernameChecked,
        isV2UsernameChecked,
        marketingConsent,
        onFailure,
        redirectWithCallback
    ]);
    const handlePasswordlessLogIn = (0, $91i6m.useCallback)(async (email)=>{
        const { success: success } = await dispatch((0, $k8MAo.loginPasswordless)({
            email: email,
            captchaValue: captchaValue,
            location: window.location
        }));
        if (success) dispatch((0, $21Xgy.addFlag)('success', (0, $9b70D.LoginPageMessages).passwordlessSuccessTitle, (0, $9b70D.LoginPageMessages).passwordlessSuccessDescription));
    }, [
        dispatch,
        captchaValue
    ]);
    return {
        isLoading: /**
     * Indicates whether username & password submission is in progress.
     * */ isLoading,
        /**
     * Errors around the username (email) and password fields.
     * */ onPasswordlessLogin: handlePasswordlessLogIn,
        /**
     * Handle login with username and password.
     *
     * Note: this will be a no-op if the username (email) has not been checked by calling
     * `checkUsername` before calling `onLogin`.
     *
     * For accessing the state and handlers around working with `checkUsername`, see:
     * {@link file://./useLogin.ts}.
     * */ onLogin: handleLogIn
    };
};

});

parcelRegister("h6Rwg", function(module, exports) {

$parcel$export(module.exports, "useSocialLogin", function () { return $8c11096978e34221$export$c599a88026ac50ef; });

var $91i6m = parcelRequire("91i6m");

var $1SKGt = parcelRequire("1SKGt");

var $2aGBJ = parcelRequire("2aGBJ");

var $gtKO2 = parcelRequire("gtKO2");

var $1V2cH = parcelRequire("1V2cH");

var $bqdjD = parcelRequire("bqdjD");

var $4rBM8 = parcelRequire("4rBM8");

var $ccxRw = parcelRequire("ccxRw");

var $7JGKf = parcelRequire("7JGKf");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");

var $1UkGo = parcelRequire("1UkGo");

var $NAfW5 = parcelRequire("NAfW5");

var $2UbF1 = parcelRequire("2UbF1");
const $8c11096978e34221$export$c599a88026ac50ef = ()=>{
    (0, $4PGUW.useRegisterComponent)($8c11096978e34221$export$c599a88026ac50ef.name);
    const isCommercial = (0, $bqdjD.getCurrentCloudType)() === 'commercial';
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const appendReasonViewingScreen = (0, $NAfW5.useAppendReasonViewingScreen)();
    const isUsernameChecked = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isUsernameChecked;
    });
    const identities = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.identities;
    });
    const isLoginSecondStep = isUsernameChecked;
    const isGoogleOneTapDismissed = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_googleOneTap;
        return state === null || state === void 0 ? void 0 : (_state_googleOneTap = state.googleOneTap) === null || _state_googleOneTap === void 0 ? void 0 : _state_googleOneTap.dismissed;
    });
    const isSocialBlocked = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isSocialBlocked;
    });
    const { errorCode: errorCode } = (0, $NAfW5.useSearchParamCodes)();
    const { state: state } = (0, $4rBM8.useLoginState)();
    const { appConfig: appConfig, csrfToken: csrfToken } = state || {};
    const application = (0, $NAfW5.useCobrandingApplication)();
    const dynamicConfigs = (0, $2UbF1.useDynamicConfigs)();
    const socialLoginEligibility = (0, $91i6m.useMemo)(()=>(0, $7JGKf.getSocialLoginEligibility)(identities, application, dynamicConfigs), [
        application,
        identities,
        dynamicConfigs
    ]);
    const { highlightedSocialProvider: highlightedSocialProvider, isEligibleForSocialLoginOnly: isEligibleForSocialLoginOnly } = socialLoginEligibility;
    const showSocialLoginOnly = isLoginSecondStep && isEligibleForSocialLoginOnly && highlightedSocialProvider && isCommercial;
    const socialButtonClickedEvent = (0, $91i6m.useCallback)((socialProvider)=>{
        analyticsClient.buttonClickedEvent(showSocialLoginOnly ? 'socialLoginForm' : (0, $1UkGo.loginPageId), `${socialProvider}LoginButton`, appendReasonViewingScreen({}));
    }, [
        analyticsClient,
        appendReasonViewingScreen,
        showSocialLoginOnly
    ]);
    const loginRecoveryOptions = (0, $NAfW5.useLoginRecoveryOptions)();
    const handleGoogleSocialLogin = (0, $91i6m.useCallback)((email)=>{
        socialButtonClickedEvent((0, $gtKO2.SocialProvider).Google);
        (0, $ccxRw.redirectToGoogleLogin)({
            location: window.location,
            source: (0, $1UkGo.loginPageId),
            recoveryOptions: loginRecoveryOptions(email)
        });
    }, [
        loginRecoveryOptions,
        socialButtonClickedEvent
    ]);
    const handleAuth0SocialLogin = (0, $91i6m.useCallback)((socialProvider, email, redirectFn)=>{
        socialButtonClickedEvent(socialProvider);
        redirectFn({
            location: window.location,
            auth0Config: appConfig === null || appConfig === void 0 ? void 0 : appConfig.auth0Config,
            csrfToken: csrfToken !== null && csrfToken !== void 0 ? csrfToken : 'token-should-be-loaded',
            source: (0, $1UkGo.loginPageId),
            email: email || undefined,
            recoveryOptions: loginRecoveryOptions(email)
        });
    }, [
        appConfig === null || appConfig === void 0 ? void 0 : appConfig.auth0Config,
        csrfToken,
        loginRecoveryOptions,
        socialButtonClickedEvent
    ]);
    const handleMicrosoftLogin = (0, $91i6m.useCallback)((email)=>handleAuth0SocialLogin((0, $gtKO2.SocialProvider).Microsoft, email, (0, $ccxRw.redirectToMicrosoftLogin)), [
        handleAuth0SocialLogin
    ]);
    const handleAppleLogin = (0, $91i6m.useCallback)((email)=>handleAuth0SocialLogin((0, $gtKO2.SocialProvider).Apple, email, (0, $ccxRw.redirectToAppleLogin)), [
        handleAuth0SocialLogin
    ]);
    const handleSlackLogin = (0, $91i6m.useCallback)((email)=>handleAuth0SocialLogin((0, $gtKO2.SocialProvider).Slack, email, (0, $ccxRw.redirectToSlackLogin)), [
        handleAuth0SocialLogin
    ]);
    const onDismissGoogleOneTap = (0, $91i6m.useCallback)(()=>dispatch((0, $1SKGt.dismissGoogleOneTap)()), [
        dispatch
    ]);
    const isCheckingUsername = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isCheckingUsername;
    });
    const isLoggingIn = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isLoggingIn;
    });
    const usernameExists = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.usernameExists;
    });
    const isLoading = isCheckingUsername || isLoggingIn;
    (0, $91i6m.useEffect)(()=>{
        if (!isLoading && isLoginSecondStep && usernameExists && identities) analyticsClient.trackingEvent({
            page: (0, $1UkGo.loginPageId),
            action: 'triggered',
            subject: 'loginSecondStep',
            attributes: {
                eligibility: socialLoginEligibility
            }
        });
    }, [
        analyticsClient,
        identities,
        isLoading,
        isLoginSecondStep,
        socialLoginEligibility,
        usernameExists
    ]);
    if (isCommercial) return {
        envSupportsSocialLogin: true,
        socialLoginEligibility: socialLoginEligibility,
        onAppleLogin: handleAppleLogin,
        onSlackLogin: handleSlackLogin,
        onMicrosoftLogin: handleMicrosoftLogin,
        onGoogleSocialLogin: handleGoogleSocialLogin,
        onDismissGoogleOneTap: onDismissGoogleOneTap,
        isGoogleOneTapDismissed: isGoogleOneTapDismissed,
        isSocialBlocked: isSocialBlocked || (errorCode === null || errorCode === void 0 ? void 0 : errorCode.code) === 'social_login_banned'
    };
    return {
        envSupportsSocialLogin: false,
        socialLoginEligibility: null,
        onAppleLogin: null,
        onSlackLogin: null,
        onMicrosoftLogin: null,
        onGoogleSocialLogin: null,
        onDismissGoogleOneTap: null,
        isGoogleOneTapDismissed: null,
        isSocialBlocked: false
    };
};

});
parcelRegister("1SKGt", function(module, exports) {

$parcel$export(module.exports, "dismissGoogleOneTap", function () { return $d1fead2b0aa97e4d$export$7634a565805a5f09; });
const $d1fead2b0aa97e4d$export$7634a565805a5f09 = ()=>({
        type: 'GOOGLE_ONE_TAP_DISMISS'
    });

});

parcelRegister("7JGKf", function(module, exports) {

$parcel$export(module.exports, "getSocialLoginEligibility", function () { return $fea9e4b105970f8f$export$e8b4b1bf168dca09; });

var $gtKO2 = parcelRequire("gtKO2");

var $ccxRw = parcelRequire("ccxRw");
const $fea9e4b105970f8f$export$c612d878ad73a6c0 = [
    (0, $gtKO2.SocialProvider).Google,
    (0, $gtKO2.SocialProvider).Microsoft,
    (0, $gtKO2.SocialProvider).Apple,
    (0, $gtKO2.SocialProvider).Slack
];
const $fea9e4b105970f8f$export$94af6b531db26586 = (dynamicConfigs)=>{
    const highPriority = [];
    const lowPriority = [];
    const isProviderEnabled = {
        [(0, $gtKO2.SocialProvider).Google]: !(0, $ccxRw.isGoogleLoginOutageAdvisoryEnabled)(dynamicConfigs),
        [(0, $gtKO2.SocialProvider).Microsoft]: !(0, $ccxRw.isMicrosoftLoginOutageAdvisoryEnabled)(dynamicConfigs),
        [(0, $gtKO2.SocialProvider).Apple]: !(0, $ccxRw.isAppleLoginOutageAdvisoryEnabled)(dynamicConfigs),
        [(0, $gtKO2.SocialProvider).Slack]: !(0, $ccxRw.isSlackLoginOutageAdvisoryEnabled)(dynamicConfigs)
    };
    $fea9e4b105970f8f$export$c612d878ad73a6c0.forEach((provider)=>{
        if (!isProviderEnabled[provider]) lowPriority.push(provider);
        else // If it's enabled or undefined (not in the record), it's high priority
        highPriority.push(provider);
    });
    return [
        ...highPriority,
        ...lowPriority
    ];
};
const $fea9e4b105970f8f$export$47bb6da133b3804e = (connected, dynamicConfigs)=>{
    const rankedSocialProviders = $fea9e4b105970f8f$export$94af6b531db26586(dynamicConfigs);
    for (const socialProvider of rankedSocialProviders){
        if (connected.includes(socialProvider)) return socialProvider;
    }
    return null;
};
const $fea9e4b105970f8f$export$e5abae2d758ca82f = (identities)=>{
    if (!identities) return [];
    return Object.values((0, $gtKO2.SocialProvider)).filter((provider)=>!!(identities === null || identities === void 0 ? void 0 : identities[provider]));
};
const $fea9e4b105970f8f$export$55a908504dbef32d = (socialProvider, application, hasPassword = true)=>Boolean(socialProvider && !hasPassword && application !== 'trello');
const $fea9e4b105970f8f$export$e8b4b1bf168dca09 = (identities, application, dynamicConfigs)=>{
    const connectedSocialProviders = $fea9e4b105970f8f$export$e5abae2d758ca82f(identities);
    const highlightedSocialProvider = $fea9e4b105970f8f$export$47bb6da133b3804e(connectedSocialProviders, dynamicConfigs);
    const hasPassword = identities === null || identities === void 0 ? void 0 : identities.password;
    const isEligibleForSocialLoginOnly = $fea9e4b105970f8f$export$55a908504dbef32d(highlightedSocialProvider, application, hasPassword);
    return {
        isEligibleForSocialLoginOnly: isEligibleForSocialLoginOnly,
        highlightedSocialProvider: highlightedSocialProvider,
        connectedSocialProviders: connectedSocialProviders,
        enabledSocialButtons: $fea9e4b105970f8f$export$c612d878ad73a6c0,
        firstProductAccessed: application || 'unknown',
        hasPassword: hasPassword
    };
};

});


parcelRegister("6KORI", function(module, exports) {

$parcel$export(module.exports, "useGoogleOneTap", function () { return $0514ccbfce379500$export$84fc8ad34c97e462; });

var $91i6m = parcelRequire("91i6m");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");

var $fALlm = parcelRequire("fALlm");

var $NAfW5 = parcelRequire("NAfW5");
const $0514ccbfce379500$export$84fc8ad34c97e462 = ({ email: email })=>{
    (0, $4PGUW.useRegisterComponent)($0514ccbfce379500$export$84fc8ad34c97e462.name);
    const { setLoginRecoveryOptions: setLoginRecoveryOptions } = (0, $fALlm.useLoginRecoveryOptionsContext)();
    const buildLoginRecoveryOptions = (0, $NAfW5.useLoginRecoveryOptions)();
    (0, $91i6m.useEffect)(()=>{
        if (!email) return;
        const loginRecoveryOptions = buildLoginRecoveryOptions(email);
        setLoginRecoveryOptions(loginRecoveryOptions);
    }, [
        email,
        setLoginRecoveryOptions,
        buildLoginRecoveryOptions
    ]);
};

});
parcelRegister("fALlm", function(module, exports) {

$parcel$export(module.exports, "LoginRecoveryOptionsContextProvider", function () { return $2c694d7ec2ab16d2$export$4df382a2361d8131; });
$parcel$export(module.exports, "useLoginRecoveryOptionsContext", function () { return $2c694d7ec2ab16d2$export$402ee3e11776bab7; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");
const $2c694d7ec2ab16d2$export$84bd9b573c96976b = /*#__PURE__*/ (0, $91i6m.createContext)(null);
const $2c694d7ec2ab16d2$export$4df382a2361d8131 = ({ children: children })=>{
    const [loginRecoveryOptions, setLoginRecoveryOptions] = (0, $91i6m.useState)();
    const value = (0, $91i6m.useMemo)(()=>({
            loginRecoveryOptions: loginRecoveryOptions,
            setLoginRecoveryOptions: setLoginRecoveryOptions
        }), [
        loginRecoveryOptions
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)($2c694d7ec2ab16d2$export$84bd9b573c96976b.Provider, {
        value: value,
        children: children
    });
};
const $2c694d7ec2ab16d2$export$402ee3e11776bab7 = ()=>{
    const context = (0, $91i6m.useContext)($2c694d7ec2ab16d2$export$84bd9b573c96976b);
    if (!context) throw new Error('useLoginRecoveryOptionsContext must be used within a LoginRecoveryOptionsContextProvider');
    return context;
};

});




parcelRegister("7Clnv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2307c23eea04d7f$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $9OWP7 = parcelRequire("9OWP7");

var $9jjaN = parcelRequire("9jjaN");

var $bt1Sd = parcelRequire("bt1Sd");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");

var $gFwNN = parcelRequire("gFwNN");

var $dmC2D = parcelRequire("dmC2D");

var $9w0eB = parcelRequire("9w0eB");

var $cLysE = parcelRequire("cLysE");

var $31nHY = parcelRequire("31nHY");

var $lnbpL = parcelRequire("lnbpL");

var $j7UeI = parcelRequire("j7UeI");

var $jthWj = parcelRequire("jthWj");

var $gtKO2 = parcelRequire("gtKO2");

var $fYxRW = parcelRequire("fYxRW");

var $1V2cH = parcelRequire("1V2cH");

var $1UkGo = parcelRequire("1UkGo");

var $cZAbO = parcelRequire("cZAbO");

var $6eNI5 = parcelRequire("6eNI5");

var $cs6gC = parcelRequire("cs6gC");

var $brCu8 = parcelRequire("brCu8");

var $83IjZ = parcelRequire("83IjZ");

var $9X0U9 = parcelRequire("9X0U9");
var $c32T7 = parcelRequire("c32T7");

var $5v178 = parcelRequire("5v178");
let $a2307c23eea04d7f$var$_ = (t)=>t, $a2307c23eea04d7f$var$t, $a2307c23eea04d7f$var$t1, $a2307c23eea04d7f$var$t2;
const $a2307c23eea04d7f$export$d55ce944e082b58f = (0, $9jjaN.default).div($a2307c23eea04d7f$var$t || ($a2307c23eea04d7f$var$t = $a2307c23eea04d7f$var$_`
  align-items: center;
  color: ${0};
  display: flex;
  height: 40px;
  justify-content: space-between;
  padding: 0 8px;
`), (0, $kLNLK).N90);
const $a2307c23eea04d7f$export$a7fed597f4b8afd8 = (0, $9jjaN.default).form($a2307c23eea04d7f$var$t1 || ($a2307c23eea04d7f$var$t1 = $a2307c23eea04d7f$var$_`
  margin: 0;
`));
const $a2307c23eea04d7f$var$InputsWrapper = (0, $9jjaN.default).div($a2307c23eea04d7f$var$t2 || ($a2307c23eea04d7f$var$t2 = $a2307c23eea04d7f$var$_`
  margin-bottom: ${0}px;
`), (0, $6e88g.gridSize)());
const $a2307c23eea04d7f$var$getEmailFieldViewType = (restrictedEmail, redirectType, isSecondStep, isLoading)=>{
    if (restrictedEmail || redirectType === (0, $gtKO2.CheckUserNameRedirectType).Sso) return (0, $dmC2D.FieldViewType).Restricted;
    else if (isSecondStep || isLoading) return (0, $dmC2D.FieldViewType).ReadOnlyWithEditButton;
    return (0, $dmC2D.FieldViewType).Editable;
};
const $a2307c23eea04d7f$export$1f58f750f20f344b = ({ application: application, email: email, error: error, fieldErrors: fieldErrors, info: info, isLoading: isLoading, isPasswordlessAllowed: isPasswordlessAllowed, isRedirecting: isRedirecting, isSecondStep: isSecondStep, isCheckUsernameLoading: isCheckUsernameLoading, onContinue: onContinue, onEditEmail: onEditEmail, onEmailChange: onEmailChange, onFormClick: onFormClick, onLogIn: onLogIn, onPasswordlessLogIn: onPasswordlessLogIn, onValidationError: onValidationError, pageId: pageId, redirectType: redirectType, restrictedEmail: restrictedEmail, showRememberMeCheckbox: showRememberMeCheckbox, rememberMeChecked: rememberMeChecked, onToggleRememberMeCheckbox: onToggleRememberMeCheckbox })=>{
    const intl = (0, $leG06.default)();
    const translatedEmailFieldError = (0, $brCu8.useTranslateFormErrorIfAvailable)(fieldErrors.email);
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const [password, setPassword] = (0, $91i6m.useState)('');
    const [buttonClicked, setButtonClicked] = (0, $91i6m.useState)('submit');
    const inputRef = (0, $91i6m.useRef)(null);
    const [passwordFieldError, setPasswordFieldError] = (0, $91i6m.useState)(null);
    const onEmailClick = (0, $91i6m.useCallback)(()=>{
        setPassword('');
        setPasswordFieldError(null);
        onEditEmail();
    }, [
        onEditEmail
    ]);
    const { captchaValue: captchaValue, isRequired: isTooManyAttemptsRecaptchaRequired } = (0, $6eNI5.useLoginTooManyAttemptsRecaptchaContext)();
    const handleSubmit = async (e)=>{
        e.preventDefault();
        const trimmedEmail = email.trim();
        const emailEmpty = trimmedEmail === '';
        const emailInvalid = !trimmedEmail.match(/.+@.+/);
        const passwordEmpty = password === '';
        // Ignore submission of form while the app is loading.
        if (isLoading) return;
        setButtonClicked('submit');
        analyticsClient.buttonClickedEvent(pageId, isSecondStep ? 'login' : 'continueToLogin');
        if (emailEmpty) {
            var _inputRef_current;
            (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
            const emailValidationError = formatMessage((0, $jthWj.default).emailEmpty);
            analyticsClient.errorShownEvent((0, $1UkGo.loginPageId), 'validationError');
            onValidationError({
                email: emailValidationError
            });
            return;
        }
        if (emailInvalid) {
            var _inputRef_current1;
            (_inputRef_current1 = inputRef.current) === null || _inputRef_current1 === void 0 ? void 0 : _inputRef_current1.focus();
            const emailValidationError = formatMessage((0, $jthWj.default).emailInvalid);
            analyticsClient.errorShownEvent((0, $1UkGo.loginPageId), 'validationError');
            onValidationError({
                email: emailValidationError
            });
            return;
        }
        if (isSecondStep && passwordEmpty) {
            setPasswordFieldError(formatMessage((0, $jthWj.default).passwordEmpty));
            return;
        }
        if (!isSecondStep) onContinue(trimmedEmail);
        else onLogIn(trimmedEmail, password);
    };
    const handlePasswordlessButtonClick = async ()=>{
        const trimmedEmail = email.trim();
        if (isLoading || !trimmedEmail) return;
        setButtonClicked('passwordless');
        onPasswordlessLogIn(trimmedEmail);
    };
    const handlePasswordChange = (0, $91i6m.useCallback)((e)=>{
        if (passwordFieldError) setPasswordFieldError(null);
        setPassword(e.currentTarget.value);
    }, [
        passwordFieldError,
        setPasswordFieldError,
        setPassword
    ]);
    const buttonContent = ()=>{
        if (!isSecondStep) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "login.form.continue",
            defaultMessage: "Continue"
        });
        if (isPasswordlessAllowed) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "common.login.with.password",
            defaultMessage: "Log in with password"
        });
        return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "common.login",
            defaultMessage: "Log in"
        });
    };
    const infoContent = ()=>{
        const { formatMessage: formatMessage } = intl;
        const applicationName = application ? (0, $fYxRW.applications)[application].name : 'Product';
        const testId = 'login-info-test-id';
        if (info) switch(info.code){
            case 'migratingExistingUser':
                {
                    const summary = formatMessage((0, $jthWj.default).migrateAccountInfo, {
                        application: applicationName
                    });
                    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $lnbpL.default), {
                        id: "login-info",
                        "data-testid": testId,
                        children: summary
                    });
                }
            case 'existingUserSignupAttempt':
                {
                    const summary = formatMessage((0, $jthWj.default).existingUserSignupAttemptInfo);
                    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $lnbpL.default), {
                        id: "login-info",
                        "data-testid": testId,
                        children: summary
                    });
                }
            default:
                return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $lnbpL.default), {
                    id: "login-info",
                    "data-testid": testId,
                    isHidden: true,
                    children: ' '
                });
        }
    };
    (0, $91i6m.useEffect)(()=>{
        analyticsClient.stopInitialLoadApdexEvent('viewLoginPage');
    }, [
        analyticsClient
    ]);
    const emailError = ()=>{
        switch(fieldErrors.email){
            case 'unknown':
                return intl.formatMessage((0, $jthWj.default).unexpectedErrorHappened);
            case 'rate_limit_exceeded_message':
                return intl.formatMessage((0, $jthWj.default).rateLimitErrorMessage);
            default:
                return translatedEmailFieldError;
        }
    };
    const renderExperimentButtons = ()=>{
        if (redirectType === (0, $gtKO2.CheckUserNameRedirectType).Sso) return /*#__PURE__*/ (0, $4ZSso.jsxs)($a2307c23eea04d7f$export$d55ce944e082b58f, {
            children: [
                /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "login.form.opening.sso",
                    defaultMessage: "Opening your single sign-on provider"
                }),
                /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9OWP7.default), {})
            ]
        });
        else return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
            appearance: "primary",
            id: "login-submit",
            testId: "login-submit-idf-testid",
            type: "submit",
            isFullWidth: true,
            isDisabled: isSecondStep && isTooManyAttemptsRecaptchaRequired && !captchaValue,
            isLoading: buttonClicked === 'submit' && (!!isRedirecting || isLoading || isCheckUsernameLoading),
            children: buttonContent()
        });
    };
    const { formatMessage: formatMessage } = intl;
    return /*#__PURE__*/ (0, $4ZSso.jsxs)("div", {
        children: [
            error && !isLoading && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $31nHY.default), {
                children: error === null || error === void 0 ? void 0 : error.message
            }),
            /*#__PURE__*/ (0, $4ZSso.jsxs)("span", {
                children: [
                    " ",
                    infoContent(),
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $4ZSso.jsxs)($a2307c23eea04d7f$export$a7fed597f4b8afd8, {
                id: "form-login",
                "data-testid": "form-login",
                onSubmit: handleSubmit,
                onClick: onFormClick,
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsxs)($a2307c23eea04d7f$var$InputsWrapper, {
                        children: [
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $dmC2D.default), {
                                fieldViewType: $a2307c23eea04d7f$var$getEmailFieldViewType(restrictedEmail, redirectType, isSecondStep, isLoading),
                                fieldError: emailError(),
                                onChange: onEmailChange,
                                value: email,
                                onEmailClick: onEmailClick,
                                placeholderOverride: formatMessage((0, $jthWj.default).emailPlaceholder),
                                inputRef: inputRef
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9w0eB.default), {
                                isHidden: !isSecondStep,
                                fieldError: passwordFieldError || undefined,
                                onChange: handlePasswordChange,
                                value: password,
                                className: `field-group password-field ${isSecondStep ? 'expanded' : 'hidden'}`,
                                isRequired: isSecondStep
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cZAbO.LoginRecaptcha), {}),
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cs6gC.LoginMarketingConsent), {}),
                            showRememberMeCheckbox && redirectType !== (0, $gtKO2.CheckUserNameRedirectType).Sso && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9X0U9.default), {
                                paddingBlockStart: "space.100",
                                paddingBlockEnd: "space.100",
                                children: /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $c32T7.default), {
                                    direction: "row",
                                    gap: "space.050",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $4ZSso.jsx)((0, $83IjZ.default), {
                                            testId: "remember-me-checkbox",
                                            isChecked: rememberMeChecked,
                                            onClick: onToggleRememberMeCheckbox,
                                            name: "remember",
                                            label: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $jthWj.default).rememberMeCheckboxLabel)),
                                            // During the redirect process (and while loading), we want to disable the checkbox so that the user doesn't interact with the checkbox.
                                            isDisabled: buttonClicked === 'submit' && (!!isRedirecting || isLoading || isCheckUsernameLoading)
                                        }),
                                        /*#__PURE__*/ (0, $4ZSso.jsx)((0, $5v178.default), {
                                            // TODO [KIRBY-8737]: once it is available, use prop spacing='compact'
                                            // https://hello.jira.atlassian.cloud/browse/KIRBY-8737
                                            appearance: "info",
                                            iconLabel: formatMessage((0, $jthWj.default).rememberMeMoreInfoLabel),
                                            placement: "right",
                                            fallbackPlacements: [
                                                'bottom'
                                            ],
                                            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $jthWj.default).rememberMeTooltip))
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    renderExperimentButtons(),
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gFwNN.default), {
                        isHidden: !isSecondStep || !isPasswordlessAllowed,
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $j7UeI.StyledSocialLoginButton), {
                            id: "passwordless-button",
                            iconBefore: /*#__PURE__*/ (0, $4ZSso.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bt1Sd))), {
                                label: "email"
                            }),
                            iconAfter: /*#__PURE__*/ (0, $4ZSso.jsx)("span", {
                                style: {
                                    width: 24
                                }
                            }),
                            isFullWidth: true,
                            advisoryEnabled: false,
                            onClick: handlePasswordlessButtonClick,
                            isLoading: buttonClicked === 'passwordless' && (!!isRedirecting || isLoading),
                            isDisabled: isTooManyAttemptsRecaptchaRequired && !captchaValue || isLoading || isRedirecting,
                            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                                id: "login.form.passwordless.button",
                                defaultMessage: "Log in with email"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $a2307c23eea04d7f$export$2e2bcd8739ae039 = $a2307c23eea04d7f$export$1f58f750f20f344b;

});

parcelRegister("7D2jm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $255c740afd9c0353$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

const $255c740afd9c0353$var$BaseRememberedAccountsPage = /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("c19go")));
const $255c740afd9c0353$var$RememberedAccountsPage = ()=>{
    return /*#__PURE__*/ (0, $4ZSso.jsx)($255c740afd9c0353$var$BaseRememberedAccountsPage, {});
};
var $255c740afd9c0353$export$2e2bcd8739ae039 = $255c740afd9c0353$var$RememberedAccountsPage;

});
parcelRegister("c19go", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("6UgT0")).then(()=>parcelRequire('aAuK0'));

});


parcelRegister("ai0FP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf292c3cf6daa915$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $3f4xr = parcelRequire("3f4xr");

var $kpg9c = parcelRequire("kpg9c");

var $lEXl5 = parcelRequire("lEXl5");

var $bqdjD = parcelRequire("bqdjD");
const $cf292c3cf6daa915$var$MaybePasskeyLoginPanel = ({ onPasskeyLogin: onPasskeyLogin, authenticating: authenticating })=>{
    const isPasskeyAuthEnabled = (0, $3f4xr.checkFeatureGate)((0, $kpg9c.AidFrontendFeatureGate).ENABLE_PASSKEY_AUTH);
    const isCommercial = (0, $bqdjD.getCurrentCloudType)() === 'commercial';
    if (!isPasskeyAuthEnabled || !isCommercial) return null;
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $lEXl5.default), {
        handlePasskeyLogin: onPasskeyLogin,
        authenticating: authenticating
    });
};
var $cf292c3cf6daa915$export$2e2bcd8739ae039 = $cf292c3cf6daa915$var$MaybePasskeyLoginPanel;

});
parcelRegister("lEXl5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0926ef9bd65173ed$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $leG06 = parcelRequire("leG06");

var $h6wkw = parcelRequire("h6wkw");

var $56ooA = parcelRequire("56ooA");

var $j7UeI = parcelRequire("j7UeI");
const $0926ef9bd65173ed$export$a40fa4dfd66c03fa = ({ handlePasskeyLogin: handlePasskeyLogin, authenticating: authenticating = false })=>{
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $j7UeI.SocialLoginPanelWrapper), {
        role: "list",
        "data-i18n-or": formatMessage((0, $56ooA.default).passkeyAuthOrLoginWith),
        "data-i18n-continue": formatMessage((0, $56ooA.default).passkeyAuthOrLoginWith),
        className: "passkey-login",
        "data-testid": "passkey-login-wrapper-idf-testid",
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $j7UeI.SocialLoginButtonRowGroup), {
            "data-testid": "passkey-login-idf-testid",
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $j7UeI.SocialLoginOptionWrapper), {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $j7UeI.SocialLoginButton), {
                    id: "passkey-auth-button",
                    advisoryEnabled: false,
                    isLoading: authenticating,
                    logo: (0, (/*@__PURE__*/$parcel$interopDefault($h6wkw))),
                    onClick: handlePasskeyLogin,
                    children: "Passkey"
                })
            })
        })
    });
};
var $0926ef9bd65173ed$export$2e2bcd8739ae039 = $0926ef9bd65173ed$export$a40fa4dfd66c03fa;

});
parcelRegister("h6wkw", function(module, exports) {

module.exports = (parcelRequire("cgi2g")).getBundleURL('9rAa3') + "key-logo.39b27441.svg";

});

parcelRegister("56ooA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88565702b6aa6cd8$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $88565702b6aa6cd8$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    passkeyAuthOrLoginWith: {
        id: 'passkey.auth.or-login-with',
        defaultMessage: 'Or login with:'
    }
});

});



parcelRegister("dIBnq", function(module, exports) {

$parcel$export(module.exports, "usePasskeyLogin", function () { return $bca8ca81a9056a25$export$8649dfc50d6433ff; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $91i6m = parcelRequire("91i6m");

var $1V2cH = parcelRequire("1V2cH");

var $l9Zg5 = parcelRequire("l9Zg5");

var $9uXJ3 = parcelRequire("9uXJ3");

var $1UkGo = parcelRequire("1UkGo");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");

var $NAfW5 = parcelRequire("NAfW5");

var $6d87w = parcelRequire("6d87w");

var $bqdjD = parcelRequire("bqdjD");

const $bca8ca81a9056a25$export$8649dfc50d6433ff = ({ onSuccess: onSuccess } = {})=>{
    (0, $4PGUW.useRegisterComponent)($bca8ca81a9056a25$export$8649dfc50d6433ff.name);
    const [searchParams] = (0, $6d87w.useSearchParams)();
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const appendReasonViewingScreen = (0, $NAfW5.useAppendReasonViewingScreen)();
    const [authenticating, setAuthenticating] = (0, $91i6m.useState)(false);
    const passkeyButtonClickedEvent = (0, $91i6m.useCallback)(()=>{
        analyticsClient.buttonClickedEvent((0, $1UkGo.loginPageId), `PasskeyLoginButton`, appendReasonViewingScreen({}));
    }, [
        analyticsClient,
        appendReasonViewingScreen
    ]);
    const redirectWithCallback = (0, $91i6m.useCallback)((url)=>{
        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        navigate(url);
    }, [
        onSuccess,
        navigate
    ]);
    const onErrorWithTrackingAnalytics = (0, $91i6m.useCallback)((error)=>{
        analyticsClient.trackingEvent({
            page: (0, $1UkGo.loginPageId),
            action: 'failed',
            subject: $bca8ca81a9056a25$var$ANALYTIC_EVENT_SUBJECT_ID,
            attributes: {
                reason: error
            }
        });
    }, [
        analyticsClient
    ]);
    const startPasskeyChallenge = (0, $91i6m.useCallback)(async ()=>{
        const isSupported = (0, $l9Zg5.isWebAuthnSupported)();
        analyticsClient.trackingEvent({
            page: (0, $1UkGo.loginPageId),
            action: 'started',
            subject: $bca8ca81a9056a25$var$ANALYTIC_EVENT_SUBJECT_ID
        });
        if (!isSupported) {
            const redirectUri = $bca8ca81a9056a25$var$redirectToErrorPage({
                analyticsClient: analyticsClient,
                loginError: 'webauthn_not_supported',
                currentQueryParams: searchParams
            });
            return redirectWithCallback(redirectUri);
        }
        try {
            setAuthenticating(true);
            const isCommercial = (0, $bqdjD.getCurrentCloudType)() === 'commercial';
            const token = isCommercial ? await (parcelRequire("jEJQB")).then(async ({ createRequestToken: createRequestToken })=>await createRequestToken()).catch(()=>'') : 'dummy-token'; // a token is expected by id-auth in IC and disabled entirely within FedRAMP
            const passkeyChallengeResponseResult = await $bca8ca81a9056a25$var$challenge();
            if (!passkeyChallengeResponseResult.success) {
                const redirectUri = $bca8ca81a9056a25$var$redirectToErrorPage({
                    analyticsClient: analyticsClient,
                    loginError: passkeyChallengeResponseResult.error,
                    currentQueryParams: searchParams
                });
                return redirectWithCallback(redirectUri);
            }
            const { requestOptions: requestOptions, transactionToken: transactionToken } = passkeyChallengeResponseResult.data;
            const authenticatorChallengeResult = await (0, $l9Zg5.challengeWithAuthenticator)(requestOptions);
            if (!authenticatorChallengeResult.success) {
                const redirectUri = $bca8ca81a9056a25$var$redirectToErrorPage({
                    analyticsClient: analyticsClient,
                    loginError: 'webauthn_challenge_failed',
                    currentQueryParams: searchParams,
                    webAuthnError: authenticatorChallengeResult.error
                });
                return redirectWithCallback(redirectUri);
            }
            const passkeyCredentialJson = authenticatorChallengeResult.data;
            const verifyResponseResult = await $bca8ca81a9056a25$var$verify({
                transactionToken: transactionToken,
                assertionJson: passkeyCredentialJson,
                analyticsClient: analyticsClient,
                token: token
            });
            if (!verifyResponseResult.success) {
                const redirectUri = $bca8ca81a9056a25$var$redirectToErrorPage({
                    analyticsClient: analyticsClient,
                    loginError: verifyResponseResult.error,
                    currentQueryParams: searchParams
                });
                return redirectWithCallback(redirectUri);
            }
            return redirectWithCallback(verifyResponseResult.data.redirectUri);
        } catch (e) {
            return onErrorWithTrackingAnalytics("challengeFailure");
        } finally{
            setAuthenticating(false);
        }
    }, [
        analyticsClient,
        onErrorWithTrackingAnalytics,
        redirectWithCallback,
        searchParams
    ]);
    const handlePasskeyLogin = (0, $91i6m.useCallback)(()=>{
        passkeyButtonClickedEvent();
        startPasskeyChallenge();
    }, [
        passkeyButtonClickedEvent,
        startPasskeyChallenge
    ]);
    return {
        onPasskeyLogin: handlePasskeyLogin,
        authenticating: authenticating
    };
};
const $bca8ca81a9056a25$var$ANALYTIC_EVENT_SUBJECT_ID = 'challengePasskey';
var $bca8ca81a9056a25$var$PasskeyChallengeApiError = /*#__PURE__*/ function(PasskeyChallengeApiError) {
    PasskeyChallengeApiError["challengeFailure"] = "challengeFailure";
    PasskeyChallengeApiError["tooManyRequests"] = "tooManyRequests";
    return PasskeyChallengeApiError;
}($bca8ca81a9056a25$var$PasskeyChallengeApiError || {});
const $bca8ca81a9056a25$var$challenge = async ()=>{
    try {
        const response = await fetch(`/v2/passkey/challenge${location.search}`, {
            method: 'GET'
        });
        switch(response.status){
            case 200:
                const challengeResponse = await response.json();
                return {
                    success: true,
                    data: challengeResponse
                };
            case 429:
                return {
                    success: false,
                    error: 'too_many_requests'
                };
            case 400:
                return {
                    success: false,
                    error: await $bca8ca81a9056a25$var$errorFromBadRequest(response)
                };
            default:
                throw response;
        }
    } catch (error) {
        throw new Error(`error from fetch: /v2/passkey/challenge`);
    }
};
const $bca8ca81a9056a25$var$verify = async ({ transactionToken: transactionToken, assertionJson: assertionJson, token: token })=>{
    try {
        const query = location.search ? `${location.search}&transactionToken=${transactionToken}` : '?transactionToken=' + transactionToken;
        const response = await fetch(`/v2/passkey/verify${query}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify((0, $b2I6k._)((0, $1Fos3._)({}, assertionJson), {
                token: token
            }))
        });
        switch(response.status){
            case 200:
                const verifyResponse = await response.json();
                return {
                    success: true,
                    data: verifyResponse
                };
            case 400:
                return {
                    success: false,
                    error: await $bca8ca81a9056a25$var$errorFromBadRequest(response)
                };
            case 429:
                return {
                    success: false,
                    error: 'too_many_requests'
                };
            default:
                throw response;
        }
    } catch (error) {
        throw new Error(`error during verification of passkey`);
    }
};
const $bca8ca81a9056a25$var$errorFromBadRequest = (response)=>response.json().then((body)=>{
        switch(body.context.reason){
            case 'bad_request':
                return 'unknown';
            case 'unknown':
                return 'unknown';
            case 'login.form.token.expired':
                return 'login.form.token.expired';
            case 'login.form.invalid_token':
                return 'unknown';
            case 'invalid_passkey':
                return 'invalid_passkey';
            case 'passkey_managed_account':
                return 'passkey_managed_account';
            default:
                return 'unknown';
        }
    }).catch(()=>'unknown');
function $bca8ca81a9056a25$var$redirectToErrorPage({ analyticsClient: analyticsClient, loginError: loginError, currentQueryParams: currentQueryParams, webAuthnError: webAuthnError }) {
    if (webAuthnError) analyticsClient.trackingEvent({
        page: (0, $1UkGo.loginPageId),
        action: 'failed',
        subject: $bca8ca81a9056a25$var$ANALYTIC_EVENT_SUBJECT_ID,
        attributes: {
            reason: webAuthnError
        }
    });
    else analyticsClient.trackingEvent({
        page: (0, $1UkGo.loginPageId),
        subject: $bca8ca81a9056a25$var$ANALYTIC_EVENT_SUBJECT_ID,
        action: 'failed',
        attributes: {
            reason: loginError
        }
    });
    currentQueryParams.delete('errorCode');
    currentQueryParams.set('errorCode', loginError);
    return new URL(`/login?${currentQueryParams.toString()}`, window.location.origin);
}

});


parcelRegister("bcp2q", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "signupLoader", function () { return $b40cf9b69482170d$export$f820bc2fe9d1bd78; });
$parcel$export(module.exports, "SignupPage", function () { return $b40cf9b69482170d$export$a2f4b65ede167ce5; });
$parcel$export(module.exports, "default", function () { return $b40cf9b69482170d$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $8KhCJ = parcelRequire("8KhCJ");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $1SKGt = parcelRequire("1SKGt");

var $2AqAA = parcelRequire("2AqAA");
parcelRequire("5yg82");
var $fpusL = parcelRequire("fpusL");
var $7LixX = parcelRequire("7LixX");

var $j7UeI = parcelRequire("j7UeI");

var $gs2u7 = parcelRequire("gs2u7");

var $kGQpp = parcelRequire("kGQpp");

var $1V2cH = parcelRequire("1V2cH");

var $2aGBJ = parcelRequire("2aGBJ");

var $1EqaR = parcelRequire("1EqaR");

var $jer8F = parcelRequire("jer8F");

var $kseBF = parcelRequire("kseBF");

var $5qlnY = parcelRequire("5qlnY");

var $gQHSy = parcelRequire("gQHSy");

var $cYyV8 = parcelRequire("cYyV8");

var $evNx2 = parcelRequire("evNx2");

var $5e2bj = parcelRequire("5e2bj");

var $3f4xr = parcelRequire("3f4xr");

var $kpg9c = parcelRequire("kpg9c");

var $4jXgk = parcelRequire("4jXgk");
const $b40cf9b69482170d$var$subjectIds = {
    email: 'selfSignupNoEmail'
};
async function $b40cf9b69482170d$export$f820bc2fe9d1bd78({ request: request }) {
    if (!await (0, $3f4xr.checkFeatureGateOnceInitialized)((0, $kpg9c.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $5e2bj.fetchPageState)('/rest/signup/state', request, {
        capabilities: [
            'capability-group--signup',
            'capability-name--signup'
        ]
    });
}
const $b40cf9b69482170d$export$a2f4b65ede167ce5 = ()=>{
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const { screenSize: screenSize } = (0, $2aGBJ.useAppSelector)((state)=>state.microbranding);
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const { error: error, userJourneyContextError: userJourneyContextError } = (0, $evNx2.useSignup)();
    const { onSignup: onSignup, email: email, fieldErrors: fieldErrors, shouldDisableEmailInput: shouldDisableEmailInput } = (0, $gQHSy.useSignupSubmit)();
    const handleValidationError = (0, $91i6m.useCallback)((errors)=>{
        const errorEventNames = Object.keys(errors).map((error)=>$b40cf9b69482170d$var$subjectIds[error] || 'selfSignupUnknownUiError');
        errorEventNames.forEach((eventName)=>analyticsClient.errorShownEvent((0, $kseBF.pageId), eventName));
        dispatch((0, $2AqAA.showFieldErrors)(errors));
    }, [
        analyticsClient,
        dispatch
    ]);
    const handleFormClick = (0, $91i6m.useCallback)(()=>{
        if (screenSize === 'mobile') dispatch((0, $1SKGt.dismissGoogleOneTap)());
    }, [
        dispatch,
        screenSize
    ]);
    const onSubmitClick = (0, $91i6m.useCallback)(async ()=>{
        const isWebAuthnSupported = async ()=>{
            try {
                return await window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
            } catch (err) {
                return false;
            }
        };
        analyticsClient.buttonClickedEvent((0, $kseBF.pageId), 'signupFormSubmit', {
            isWebAuthnSupported: await isWebAuthnSupported()
        });
    }, [
        analyticsClient
    ]);
    const { envSupportsSocialSignup: envSupportsSocialSignup, handleAppleLogin: handleAppleLogin, handleGoogleLogin: handleGoogleLogin, handleMicrosoftLogin: handleMicrosoftLogin, handleSlackLogin: handleSlackLogin } = (0, $cYyV8.useSocialSignup)();
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8KhCJ.default), {
                title: formatMessage((0, $kGQpp.default).headTitle)
            }),
            /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $gs2u7.default), {
                pageId: (0, $kseBF.pageId),
                header: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4jXgk.default), {
                    as: "h1",
                    size: "small",
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $kGQpp.default).headerTitle))
                }),
                footer: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $jer8F.FooterLogoWrapper), {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $7LixX.SignupRecaptchaNotice), {})
                }),
                whiteboxFooter: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $fpusL.LoginLink), {}),
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $5qlnY.default), {
                        email: email,
                        error: error,
                        userJourneyContextError: userJourneyContextError,
                        fieldErrors: fieldErrors,
                        onSignup: onSignup,
                        onValidationError: handleValidationError,
                        onFormClick: handleFormClick,
                        onSubmitClick: onSubmitClick,
                        disableEmailInput: Boolean(email && shouldDisableEmailInput),
                        privacyPolicy: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $1EqaR.SignupPrivacyPolicy), {})
                    }),
                    envSupportsSocialSignup && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $j7UeI.default), {
                        handleGoogleLogin: handleGoogleLogin,
                        handleMicrosoftLogin: handleMicrosoftLogin,
                        handleAppleLogin: handleAppleLogin,
                        handleSlackLogin: handleSlackLogin
                    })
                ]
            })
        ]
    });
};
var $b40cf9b69482170d$export$2e2bcd8739ae039 = $b40cf9b69482170d$export$a2f4b65ede167ce5;

});
parcelRegister("2AqAA", function(module, exports) {

$parcel$export(module.exports, "reset", function () { return $e5e85b1381c260fa$export$aad8462122ac592b; });
$parcel$export(module.exports, "showFieldErrors", function () { return $e5e85b1381c260fa$export$f17d5fd8029ff8d7; });
$parcel$export(module.exports, "signupCaptchaFailure", function () { return $e5e85b1381c260fa$export$f4ba837a66b5be0a; });
$parcel$export(module.exports, "signup", function () { return $e5e85b1381c260fa$export$7200a869094fec36; });

var $dBq8m = parcelRequire("dBq8m");

var $fYxRW = parcelRequire("fYxRW");

var $4JAG5 = parcelRequire("4JAG5");

var $49Pnv = parcelRequire("49Pnv");

var $bqdjD = parcelRequire("bqdjD");
const $e5e85b1381c260fa$export$aad8462122ac592b = ()=>({
        type: 'SIGNUP_RESET'
    });
const $e5e85b1381c260fa$export$e786d9c820defe79 = ()=>({
        type: 'SIGNUP_REQUEST'
    });
const $e5e85b1381c260fa$export$99986585b9b9a16 = (redirectTo)=>({
        type: 'SIGNUP_REQUEST_SUCCESS',
        redirectTo: redirectTo
    });
const $e5e85b1381c260fa$export$addc2691c91f42be = (error)=>({
        type: 'SIGNUP_REQUEST_FAILED',
        error: error
    });
const $e5e85b1381c260fa$export$f17d5fd8029ff8d7 = (errors)=>({
        type: 'SIGNUP_SHOW_FIELD_ERRORS',
        errors: errors
    });
const $e5e85b1381c260fa$export$f4ba837a66b5be0a = (isOnline)=>$e5e85b1381c260fa$export$addc2691c91f42be(isOnline ? 'captcha' : 'request_error');

const $e5e85b1381c260fa$export$7200a869094fec36 = (signupParams, location = window.location, options)=>async (dispatch, getState)=>{
        const { email: email, challengeResponse: challengeResponse } = signupParams;
        const { display: display } = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(location.search);
        const { cobranding: { productHint: productHint } } = getState();
        const microbranding = (0, $fYxRW.getMicrobrandingFromUrl)(location);
        const qs = microbranding && Object.keys(microbranding).length ? `?${(0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).stringify(microbranding)}` : '';
        // fire castle action
        const castleToken = (0, $bqdjD.currentCloudType) === 'commercial' ? await (parcelRequire("jEJQB")).then(async ({ createRequestToken: createRequestToken })=>await createRequestToken()).catch((e)=>{
            console.error('castle error', e);
            (0, $49Pnv.captureException)(e);
            return undefined;
        }) : undefined;
        dispatch($e5e85b1381c260fa$export$e786d9c820defe79());
        // TODO: confirm whether we should be including privacy policy text in the payload
        // https://hello.jira.atlassian.cloud/browse/KIRBY-7103
        const payload = {
            'challenge-response': (0, $4JAG5.toChallengeRequest)(challengeResponse),
            email: email,
            productHint: productHint,
            display: display || null,
            castleToken: castleToken
        };
        let response;
        try {
            response = await fetch(`/rest/signup${qs}`, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });
        } catch (networkError) {
            dispatch($e5e85b1381c260fa$export$addc2691c91f42be('request_error'));
            return;
        }
        try {
            const { fieldErrors: fieldErrors, uiErrors: uiErrors, redirectTo: redirectTo } = await response.json();
            if (redirectTo) {
                const fullRedirectUrl = new URL(redirectTo);
                const redirectUrlParams = new URLSearchParams(fullRedirectUrl.search);
                const continueUrlFromParams = redirectUrlParams.get('continue');
                if ((options === null || options === void 0 ? void 0 : options.addParamsToContinueUrl) && continueUrlFromParams) {
                    const continueUrl = new URL(continueUrlFromParams);
                    const paramsToAdd = options.addParamsToContinueUrl({
                        fullRedirectUrl: fullRedirectUrl,
                        continueUrl: continueUrl
                    });
                    const updatedRedirectTo = $e5e85b1381c260fa$var$updateRedirectContinueUrlParams({
                        fullRedirectUrlValue: redirectTo,
                        continueUrlValue: continueUrlFromParams,
                        paramsToAdd: paramsToAdd
                    });
                    dispatch($e5e85b1381c260fa$export$99986585b9b9a16(updatedRedirectTo));
                    return;
                }
                dispatch($e5e85b1381c260fa$export$99986585b9b9a16(redirectTo));
            } else {
                if (uiErrors && uiErrors.length) dispatch($e5e85b1381c260fa$export$addc2691c91f42be(uiErrors[0].key || 'unknown'));
                else if (fieldErrors && Object.keys(fieldErrors).length) dispatch($e5e85b1381c260fa$export$f17d5fd8029ff8d7(fieldErrors));
                else dispatch($e5e85b1381c260fa$export$addc2691c91f42be('unknown'));
            }
        } catch (error) {
            dispatch($e5e85b1381c260fa$export$addc2691c91f42be('unknown'));
        }
    };
/**
 * This function allows additive changes only to continue URL search params.
 *
 * The full redirect URL often has a continue URL defined in its search params, usually pointing to
 * a destination product, like Loom. This continue URL, in turn, may have search params of its own.
 *
 * In some cases, consumers of the signup function may want to include certain additional params
 * inside the continue URL, based on what happened during the signup flow. This is useful to be able
 * to make decisions once the user lands on the product's domain.
 *
 * For example, a product may want to include a param to indicate that the user attempted to sign
 * up, but was redirected to /login on IDAC because they already have an account. They can include a
 * param in the continue URL to indicate that this was the case.
 */ const $e5e85b1381c260fa$var$updateRedirectContinueUrlParams = ({ fullRedirectUrlValue: fullRedirectUrlValue, paramsToAdd: paramsToAdd, continueUrlValue: continueUrlValue })=>{
    const fullRedirectUrl = new URL(fullRedirectUrlValue);
    const redirectUrlParams = new URLSearchParams(fullRedirectUrl.search);
    const continueUrl = new URL(continueUrlValue);
    // update the params of the continue URL
    const existingParams = new URLSearchParams(continueUrl.search);
    const combinedParams = new URLSearchParams([
        ...existingParams,
        ...paramsToAdd
    ]);
    continueUrl.search = combinedParams.toString();
    // update the continue param of the full redirect URL
    redirectUrlParams.set('continue', continueUrl.toString());
    fullRedirectUrl.search = redirectUrlParams.toString();
    return fullRedirectUrl.toString();
};

});

parcelRegister("5yg82", function(module, exports) {
$parcel$export(module.exports, "LoginLink", function () { return (parcelRequire("fpusL")).LoginLink; });
$parcel$export(module.exports, "SignupPrivacyPolicy", function () { return (parcelRequire("1EqaR")).SignupPrivacyPolicy; });
$parcel$export(module.exports, "SignupRecaptcha", function () { return (parcelRequire("8imOG")).SignupRecaptcha; });
$parcel$export(module.exports, "SignupRecaptchaNotice", function () { return (parcelRequire("7LixX")).SignupRecaptchaNotice; });
parcelRequire("fpusL");
parcelRequire("5qlnY");
parcelRequire("10Q7Q");
parcelRequire("1EqaR");
parcelRequire("gjyWX");

});
parcelRegister("fpusL", function(module, exports) {

$parcel$export(module.exports, "LoginLink", function () { return $53a3cb424de76120$export$ae88ed303b99c258; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $6d87w = parcelRequire("6d87w");
var $l2v8Y = parcelRequire("l2v8Y");

var $2aGBJ = parcelRequire("2aGBJ");

var $gtKO2 = parcelRequire("gtKO2");

var $7eeh4 = parcelRequire("7eeh4");

var $6T9dz = parcelRequire("6T9dz");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");
const $53a3cb424de76120$export$ae88ed303b99c258 = ({ children: children })=>{
    (0, $4PGUW.useRegisterComponent)($53a3cb424de76120$export$ae88ed303b99c258.name);
    const location = (0, $l2v8Y.useLocation)();
    const { isEmbedded: isEmbedded, oidcContext: oidcContext } = (0, $2aGBJ.useAppSelector)((state)=>state.microbranding);
    const loginLink = '/login' + location.search;
    if (isEmbedded) return null;
    if ((0, $7eeh4.isOidcDisplayMode)(oidcContext, (0, $gtKO2.OidcDisplay).Signup)) return null;
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6d87w.Link), {
        id: "already-have-an-account",
        to: loginLink,
        children: children || /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4ZSso.Fragment), {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "signup.already.have.account.log.in",
                defaultMessage: "Already have an Atlassian account? Log in"
            })
        })
    });
};

});

parcelRegister("5qlnY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db4cc745324007cc$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $8iEgn = parcelRequire("8iEgn");

var $h89s9 = parcelRequire("h89s9");

var $31nHY = parcelRequire("31nHY");

var $cLysE = parcelRequire("cLysE");

var $aVq04 = parcelRequire("aVq04");

var $49Pnv = parcelRequire("49Pnv");
parcelRequire("0wXBc");
var $buHgC = parcelRequire("buHgC");
parcelRequire("gjyWX");
var $8imOG = parcelRequire("8imOG");

var $jer8F = parcelRequire("jer8F");

var $3f4xr = parcelRequire("3f4xr");

var $kpg9c = parcelRequire("kpg9c");
const $db4cc745324007cc$export$cc15cfe224a6a69b = ({ title: title, email: emailProp, onEmailChange: onEmailChange, error: error, userJourneyContextError: userJourneyContextError, fieldErrors: fieldErrors, onSignup: onSignup, onSubmitClick: onSubmitClick, onFormClick: onFormClick, hideEmailInput: hideEmailInput, disableEmailInput: disableEmailInput, onValidationError: onValidationError, privacyPolicy: privacyPolicy })=>{
    var _fieldErrors_email;
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const [email, setEmail] = (0, $91i6m.useState)(emailProp || '');
    const [shouldShowSpinner, setShouldShowSpinner] = (0, $91i6m.useState)(false);
    const emailInputRef = (0, $91i6m.useRef)(null);
    const currentEmailError = (_fieldErrors_email = fieldErrors.email) === null || _fieldErrors_email === void 0 ? void 0 : _fieldErrors_email.message;
    const previousEmailError = (0, $buHgC.usePrevious)(currentEmailError);
    (0, $91i6m.useEffect)(()=>{
        var _emailInputRef_current;
        const emailError = currentEmailError && currentEmailError !== previousEmailError;
        if (emailError) (_emailInputRef_current = emailInputRef.current) === null || _emailInputRef_current === void 0 ? void 0 : _emailInputRef_current.focus();
    }, [
        currentEmailError,
        previousEmailError
    ]);
    const handleSubmit = (0, $91i6m.useCallback)(async ()=>{
        const validationErrors = {};
        if (shouldShowSpinner) return;
        if (!hideEmailInput && email.trim() === '') validationErrors.email = formatMessage((0, $aVq04.SignupFormMessages).emailEmpty);
        if (Object.keys(validationErrors).length) {
            var _emailInputRef_current;
            onValidationError(validationErrors);
            const hasEmailError = validationErrors.email;
            if (hasEmailError) (_emailInputRef_current = emailInputRef.current) === null || _emailInputRef_current === void 0 ? void 0 : _emailInputRef_current.focus();
            return;
        }
        setShouldShowSpinner(true);
        try {
            await onSignup({
                email: email
            });
        } catch (e) {
            (0, $49Pnv.captureException)(e);
        }
        setShouldShowSpinner(false);
    }, [
        shouldShowSpinner,
        hideEmailInput,
        email,
        formatMessage,
        onValidationError,
        onSignup
    ]);
    const handleEmailChange = (e)=>{
        const email = e.currentTarget.value;
        setEmail(email);
        if (onEmailChange) onEmailChange(email);
    };
    const renderPrivacyPolicy = ()=>{
        return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4ZSso.Fragment), {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $jer8F.PrivacyPolicyContainer), {
                children: privacyPolicy
            })
        });
    };
    const renderSubmitButton = ()=>{
        return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $jer8F.SignUpButtonWrapper), {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                appearance: "primary",
                type: "submit",
                isFullWidth: true,
                id: "signup-submit",
                isLoading: shouldShowSpinner,
                onClick: ()=>onSubmitClick && onSubmitClick(),
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "signup.form.submit.verify",
                    defaultMessage: "Sign up"
                })
            })
        });
    };
    const removeEmailId = (0, $3f4xr.checkFeatureGate)((0, $kpg9c.AidFrontendFeatureGate).REPLACE_EMAIL_ID_WITH_TEST_ID);
    return /*#__PURE__*/ (0, $4ZSso.jsxs)("div", {
        children: [
            userJourneyContextError && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $31nHY.FormErrorWrapper), {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8iEgn.default), {
                    testId: 'redirect-from-resetPassword-error',
                    appearance: "information",
                    children: userJourneyContextError.errorMessage
                })
            }),
            error ? /*#__PURE__*/ (0, $4ZSso.jsx)((0, $31nHY.default), {
                children: error.errorMessage
            }) : null,
            title && /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
                children: title
            }),
            /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $jer8F.Form), {
                onSubmit: (e)=>{
                    e.preventDefault();
                    handleSubmit();
                },
                id: "form-sign-up",
                onClick: onFormClick,
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $jer8F.EmailFieldGroup), {
                        isHidden: hideEmailInput,
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $h89s9.default), {
                            id: removeEmailId ? undefined : 'email',
                            testId: "signup-email-idf-testid",
                            name: "email",
                            autoComplete: hideEmailInput ? 'off' : 'username',
                            type: "email",
                            placeholder: formatMessage((0, $aVq04.SignupFormMessages).emailPlaceholder),
                            label: formatMessage((0, $aVq04.SignupFormMessages).emailLabel),
                            autoFocus: !email,
                            isInvalid: !!currentEmailError,
                            invalidMessage: currentEmailError,
                            onChange: handleEmailChange,
                            value: email,
                            ref: emailInputRef,
                            isDisabled: disableEmailInput
                        })
                    }),
                    renderPrivacyPolicy(),
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8imOG.SignupRecaptcha), {}),
                    renderSubmitButton()
                ]
            })
        ]
    });
};
var $db4cc745324007cc$export$2e2bcd8739ae039 = $db4cc745324007cc$export$cc15cfe224a6a69b;

});
parcelRegister("aVq04", function(module, exports) {

$parcel$export(module.exports, "SignupFormMessages", function () { return $dda89b882ac6128d$export$ef21cebdb5785715; });

var $j5RJC = parcelRequire("j5RJC");
const $dda89b882ac6128d$export$ef21cebdb5785715 = (0, $j5RJC.defineMessages)({
    emailEmpty: {
        id: 'signup.form.email.empty',
        defaultMessage: 'Please enter an email address',
        description: ''
    },
    emailPlaceholder: {
        id: 'signup.form.email.placeholder',
        defaultMessage: 'Enter your email',
        description: ''
    },
    emailLabel: {
        id: 'signup.form.email.label',
        defaultMessage: 'Email',
        description: 'Label for the email input'
    },
    signupDisplayNameEmpty: {
        id: 'signup.display.name.empty',
        defaultMessage: 'Full name must not be empty'
    },
    signupDisplayNameTooLong: {
        id: 'signup.display.name.too.long',
        defaultMessage: 'Full name must not be greater than 255 characters'
    },
    signupEmailFormatError: {
        id: 'signup.email.format.error',
        defaultMessage: 'Email is required to be in correct format'
    },
    signupEmailReachedMaxAliases: {
        id: 'signup.email.reached.max.aliases',
        defaultMessage: 'Email aliases are rate limited'
    },
    signupEmailRestrictedDomain: {
        id: 'signup.email.restricted.domain.error',
        defaultMessage: 'The provided email address is not allowed, please use a different one'
    },
    signupEmailBansNotAllowed: {
        id: 'signup.email.bans.not.allowed',
        defaultMessage: 'The provided email address is not allowed, please use a different one'
    },
    signupGenericFailure: {
        id: 'signup.failure',
        defaultMessage: 'We are unable to sign you up. Please contact support and provide this message: {0}'
    },
    signupCaptchaResponseError: {
        id: 'signup.captcha.response.required.error',
        defaultMessage: "Are you sure you're not a robot?"
    }
});

});

parcelRegister("gjyWX", function(module, exports) {
$parcel$export(module.exports, "SignupRecaptcha", function () { return (parcelRequire("8imOG")).SignupRecaptcha; });
$parcel$export(module.exports, "SignupRecaptchaNotice", function () { return (parcelRequire("7LixX")).SignupRecaptchaNotice; });
parcelRequire("8imOG");
parcelRequire("7LixX");

});
parcelRegister("8imOG", function(module, exports) {

$parcel$export(module.exports, "SignupRecaptcha", function () { return $3a1d8af26a8c61fd$export$650ffb8b3f19a565; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $a5qoX = parcelRequire("a5qoX");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");

var $jjU5l = parcelRequire("jjU5l");
const $3a1d8af26a8c61fd$export$650ffb8b3f19a565 = ()=>{
    (0, $4PGUW.useRegisterComponent)($3a1d8af26a8c61fd$export$650ffb8b3f19a565.name);
    const { enabled: recaptchaEnabled, component: recaptchaComponent } = (0, $a5qoX.useRecaptchaContext)();
    const shouldShow = recaptchaEnabled && recaptchaComponent;
    if (!shouldShow) return null;
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $jjU5l.SignupRecaptchaContainer), {
        children: recaptchaComponent
    });
};

});
parcelRegister("jjU5l", function(module, exports) {

$parcel$export(module.exports, "SignupRecaptchaContainer", function () { return $c01b036bf8c9497a$export$7f3c0d51ba2e627e; });

var $9jjaN = parcelRequire("9jjaN");

var $g6OTd = parcelRequire("g6OTd");
let $c01b036bf8c9497a$var$_ = (t)=>t, $c01b036bf8c9497a$var$t;
const $c01b036bf8c9497a$export$7f3c0d51ba2e627e = (0, $9jjaN.default)((0, $g6OTd.default))($c01b036bf8c9497a$var$t || ($c01b036bf8c9497a$var$t = $c01b036bf8c9497a$var$_`
  .grecaptcha-badge {
    display: none;
  }
`));

});


parcelRegister("7LixX", function(module, exports) {

$parcel$export(module.exports, "SignupRecaptchaNotice", function () { return $286db86e3712441f$export$3ce9549b7ed98745; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $g6OTd = parcelRequire("g6OTd");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");
const $286db86e3712441f$export$3ce9549b7ed98745 = ()=>{
    (0, $4PGUW.useRegisterComponent)($286db86e3712441f$export$3ce9549b7ed98745.name);
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $g6OTd.RecaptchaNotice), {});
};

});


parcelRegister("jer8F", function(module, exports) {

$parcel$export(module.exports, "FooterLogoWrapper", function () { return $290c2388b0b14352$export$648d5009980d0c69; });
$parcel$export(module.exports, "PrivacyPolicyContainer", function () { return $290c2388b0b14352$export$6b077d087ec15a10; });
$parcel$export(module.exports, "SignUpButtonWrapper", function () { return $290c2388b0b14352$export$5d58eaf357166f34; });
$parcel$export(module.exports, "Form", function () { return $290c2388b0b14352$export$a7fed597f4b8afd8; });
$parcel$export(module.exports, "EmailFieldGroup", function () { return $290c2388b0b14352$export$2ad90a8dcd76cc44; });

var $9jjaN = parcelRequire("9jjaN");

var $6e88g = parcelRequire("6e88g");

var $gFwNN = parcelRequire("gFwNN");
let $290c2388b0b14352$var$_ = (t)=>t, $290c2388b0b14352$var$t, $290c2388b0b14352$var$t1, $290c2388b0b14352$var$t2, $290c2388b0b14352$var$t3, $290c2388b0b14352$var$t4;
const $290c2388b0b14352$export$648d5009980d0c69 = (0, $9jjaN.default).div($290c2388b0b14352$var$t || ($290c2388b0b14352$var$t = $290c2388b0b14352$var$_`
  margin-top: ${0}px;
`), (0, $6e88g.gridSize));
const $290c2388b0b14352$export$6b077d087ec15a10 = (0, $9jjaN.default).div($290c2388b0b14352$var$t1 || ($290c2388b0b14352$var$t1 = $290c2388b0b14352$var$_`
  margin-top: ${0}px;
  text-align: left;
  padding-left: 0;
`), (0, $6e88g.gridSize)());
const $290c2388b0b14352$export$5d58eaf357166f34 = (0, $9jjaN.default).div($290c2388b0b14352$var$t2 || ($290c2388b0b14352$var$t2 = $290c2388b0b14352$var$_`
  margin-top: ${0}px;
`), (0, $6e88g.gridSize)());
const $290c2388b0b14352$export$a7fed597f4b8afd8 = (0, $9jjaN.default).form($290c2388b0b14352$var$t3 || ($290c2388b0b14352$var$t3 = $290c2388b0b14352$var$_`
  margin: 0;
`));
const $290c2388b0b14352$export$2ad90a8dcd76cc44 = (0, $9jjaN.default)((0, $gFwNN.default))($290c2388b0b14352$var$t4 || ($290c2388b0b14352$var$t4 = $290c2388b0b14352$var$_`
  margin-bottom: ${0}px;
`), (0, $6e88g.gridSize)());

});


parcelRegister("10Q7Q", function(module, exports) {

$parcel$export(module.exports, "SignupGoogleOneTap", function () { return $1ab39b7e9ebcbcd4$export$afc76af3b27474ba; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $1rFqe = parcelRequire("1rFqe");

var $2aGBJ = parcelRequire("2aGBJ");

var $kseBF = parcelRequire("kseBF");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");

var $2UbF1 = parcelRequire("2UbF1");

var $3H79M = parcelRequire("3H79M");

var $1HVXA = parcelRequire("1HVXA");
const $1ab39b7e9ebcbcd4$export$afc76af3b27474ba = ({ children: children })=>{
    (0, $4PGUW.useRegisterComponent)($1ab39b7e9ebcbcd4$export$afc76af3b27474ba.name);
    const dynamicConfigs = (0, $2UbF1.useDynamicConfigs)();
    const googleOneTapDismissed = (0, $2aGBJ.useAppSelector)((state)=>state.googleOneTap.dismissed);
    const hashedCsrfToken = (0, $2aGBJ.useAppSelector)((state)=>state.hashedCsrfToken);
    const { googleAuthClientId: googleAuthClientId } = (0, $2aGBJ.useAppSelector)((state)=>state.appConfig);
    const disableOneTap = googleOneTapDismissed || (0, $1HVXA.getBooleanDynamicConfigValueOrDefault)(dynamicConfigs, (0, $3H79M.AidFrontendDynamicConfig).GOOGLE_ONE_TAP_KILL_SWITCH);
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $1rFqe.default), {
        csrfToken: hashedCsrfToken,
        googleAuthClientId: googleAuthClientId,
        source: (0, $kseBF.pageId),
        enabled: !disableOneTap,
        children: children
    });
};

});
parcelRegister("1rFqe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a17c37a69764cd5$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $8hJHo = parcelRequire("8hJHo");

var $ccxRw = parcelRequire("ccxRw");

var $dBq8m = parcelRequire("dBq8m");

var $g7xf6 = parcelRequire("g7xf6");

var $1V2cH = parcelRequire("1V2cH");

var $bqdjD = parcelRequire("bqdjD");
const $3a17c37a69764cd5$var$oneTapClientUrl = 'https://accounts.google.com/gsi/client';
const $3a17c37a69764cd5$export$dc57f6202fda5ffc = ({ children: children, csrfToken: csrfToken, enabled: enabled, google: google, googleAuthClientId: googleAuthClientId, recoveryOptions: recoveryOptions, source: source })=>{
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    (0, $91i6m.useEffect)(()=>{
        var _google_accounts;
        const isCommercial = (0, $bqdjD.currentCloudType) === 'commercial';
        if ((google === null || google === void 0 ? void 0 : (_google_accounts = google.accounts) === null || _google_accounts === void 0 ? void 0 : _google_accounts.id) && enabled && isCommercial) {
            google.accounts.id.initialize({
                client_id: googleAuthClientId,
                cancel_on_tap_outside: false,
                use_fedcm_for_prompt: true,
                itp_support: false,
                callback: (credentialResponse)=>{
                    analyticsClient.buttonClickedEvent(source, 'googleYoloAccountSelected');
                    const { userFlow: userFlow } = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(window.location.search);
                    // [KIRBY-7902] TODO: use feature flag to determine if we should use the new endpoint (and submitFormHackReplacement) or the old one
                    // Backend URL and endpoint to be in a new place if it requires changes to accept and response with JSON, but the owner of the service is outside of Kirby.
                    const callbackBase = `${window.location.origin}/login/google`;
                    const callbackParams = {
                        state: (0, $ccxRw.buildState)({
                            location: window.location,
                            csrfToken: csrfToken,
                            source: source,
                            loginType: (0, $ccxRw.LoginType).GoogleOneTap,
                            anonymousId: analyticsClient.getAnonymousId(),
                            userFlow: userFlow,
                            recoveryOptions: recoveryOptions
                        })
                    };
                    // [KIRBY-7902] TODO: replace with `submitFormHackReplacement` once the backend endpoint is ready.
                    (0, $g7xf6.default)({
                        method: 'POST',
                        action: `${callbackBase}?${(0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).stringify(callbackParams)}`,
                        payload: {
                            id_token: credentialResponse.credential
                        }
                    });
                }
            });
            google.accounts.id.prompt((notification)=>{
                if (notification.isDismissedMoment()) {
                    const reason = notification.getDismissedReason();
                    analyticsClient.buttonClickedEvent(source, 'googleYoloDismissed', {
                        reason: reason
                    });
                }
            });
        }
        return ()=>{
            var _google_accounts_id, _google_accounts;
            return google === null || google === void 0 ? void 0 : (_google_accounts = google.accounts) === null || _google_accounts === void 0 ? void 0 : (_google_accounts_id = _google_accounts.id) === null || _google_accounts_id === void 0 ? void 0 : _google_accounts_id.cancel();
        };
    }, [
        google,
        enabled,
        googleAuthClientId,
        csrfToken,
        analyticsClient,
        source,
        recoveryOptions
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4ZSso.Fragment), {
        children: children
    });
};
var $3a17c37a69764cd5$export$2e2bcd8739ae039 = (0, $8hJHo.default)($3a17c37a69764cd5$var$oneTapClientUrl, {
    globalName: 'google',
    attributes: {
        nonce: window.cspNonce
    }
})($3a17c37a69764cd5$export$dc57f6202fda5ffc);

});

parcelRegister("kseBF", function(module, exports) {

$parcel$export(module.exports, "pageId", function () { return $552d9d2c2b7940a0$export$703ba2e7ea526c1b; });
const $552d9d2c2b7940a0$export$703ba2e7ea526c1b = 'atlassianAccountSignupScreen';

});


parcelRegister("1EqaR", function(module, exports) {

$parcel$export(module.exports, "SignupPrivacyPolicy", function () { return $f1a09e607db9aebc$export$873af88187638697; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $83pNw = parcelRequire("83pNw");

var $7eeh4 = parcelRequire("7eeh4");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");

var $kseBF = parcelRequire("kseBF");

var $l29VX = parcelRequire("l29VX");

var $2aGBJ = parcelRequire("2aGBJ");
const $f1a09e607db9aebc$export$873af88187638697 = ()=>{
    var _privacyPolicyMessageRef_current;
    (0, $4PGUW.useRegisterComponent)($f1a09e607db9aebc$export$873af88187638697.name);
    const privacyPolicyMessageRef = (0, $91i6m.useRef)(null);
    const isEmbedded = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_microbranding;
        return (_state_microbranding = state.microbranding) === null || _state_microbranding === void 0 ? void 0 : _state_microbranding.isEmbedded;
    });
    const oidcContext = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_microbranding;
        return (_state_microbranding = state.microbranding) === null || _state_microbranding === void 0 ? void 0 : _state_microbranding.oidcContext;
    });
    const { setPrivacyPolicyText: setPrivacyPolicyText } = (0, $l29VX.useSignupPageContext)();
    (0, $91i6m.useEffect)(()=>{
        var _privacyPolicyMessageRef_current;
        const privacyPolicyText = ((_privacyPolicyMessageRef_current = privacyPolicyMessageRef.current) === null || _privacyPolicyMessageRef_current === void 0 ? void 0 : _privacyPolicyMessageRef_current.innerHTML) || '';
        if (privacyPolicyText) setPrivacyPolicyText(privacyPolicyText);
    }, [
        (_privacyPolicyMessageRef_current = privacyPolicyMessageRef.current) === null || _privacyPolicyMessageRef_current === void 0 ? void 0 : _privacyPolicyMessageRef_current.innerHTML,
        setPrivacyPolicyText
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $83pNw.default), {
        isEmbedded: isEmbedded,
        isMobileOidc: (0, $7eeh4.isMobileOidc)(oidcContext),
        pageId: (0, $kseBF.pageId),
        privacyPolicyText: (0, $83pNw.PrivacyPolicyText).passwordSignup,
        ref: privacyPolicyMessageRef
    });
};

});
parcelRegister("83pNw", function(module, exports) {

$parcel$export(module.exports, "PrivacyPolicyText", function () { return $2d6bae9fb0c78a27$export$e6f99b88cb37902d; });
$parcel$export(module.exports, "default", function () { return $2d6bae9fb0c78a27$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");

var $9jjaN = parcelRequire("9jjaN");

var $bE8z6 = parcelRequire("bE8z6");

var $1V2cH = parcelRequire("1V2cH");

var $lqtFl = parcelRequire("lqtFl");
let $2d6bae9fb0c78a27$var$_ = (t)=>t, $2d6bae9fb0c78a27$var$t;
const $2d6bae9fb0c78a27$var$SignupLegal = (0, $9jjaN.default).p($2d6bae9fb0c78a27$var$t || ($2d6bae9fb0c78a27$var$t = $2d6bae9fb0c78a27$var$_`
  font-size: 12px;
`));
var $2d6bae9fb0c78a27$export$e6f99b88cb37902d = /*#__PURE__*/ function(PrivacyPolicyText) {
    PrivacyPolicyText["passwordSignup"] = "passwordSignup";
    PrivacyPolicyText["oauthSignup"] = "oauthSignup";
    return PrivacyPolicyText;
}({});
const $2d6bae9fb0c78a27$var$PrivacyPolicy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).forwardRef(({ isEmbedded: isEmbedded, isMobileOidc: isMobileOidc, pageId: pageId, privacyPolicyText: privacyPolicyText }, ref)=>{
    const cloudTOSLinkClicked = (0, $1V2cH.useLinkClickedEvent)(pageId, 'cloudTermsOfService');
    const privacyPolicyLinkClicked = (0, $1V2cH.useLinkClickedEvent)(pageId, 'privacyPolicy');
    const privacyPolicyMessage = (0, $91i6m.useMemo)(()=>{
        const shouldUseMobileLinks = isEmbedded || isMobileOidc;
        const privacyPolicyUrl = shouldUseMobileLinks ? (0, $bE8z6.PRIVACY_POLICY_URL_MOBILE) : (0, $bE8z6.PRIVACY_POLICY_URL);
        const cloudTermsOfServiceUrl = shouldUseMobileLinks ? (0, $bE8z6.CLOUD_TERMS_OF_SERVICE_URL_MOBILE) : (0, $bE8z6.CLOUD_TERMS_OF_SERVICE_URL);
        const messageValues = {
            'cloud-tos-link': (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)((0, $lqtFl.default), {
                    href: cloudTermsOfServiceUrl,
                    target: "_blank",
                    rel: "noreferrer noopener",
                    onClick: cloudTOSLinkClicked,
                    children: chunks
                }),
            'privacy-policy-link': (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)((0, $lqtFl.default), {
                    href: privacyPolicyUrl,
                    target: "_blank",
                    rel: "noreferrer noopener",
                    onClick: privacyPolicyLinkClicked,
                    children: chunks
                })
        };
        return privacyPolicyText === "passwordSignup" ? /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "signup.form.legal.updated.password.xml",
            defaultMessage: "By signing up, I accept the Atlassian <cloud-tos-link>Cloud Terms of Service</cloud-tos-link> and acknowledge the <privacy-policy-link>Privacy Policy</privacy-policy-link>.",
            description: "Cloud Terms of Service and Privacy Policy notice displayed to users when signing up for an Atlassian account",
            values: messageValues
        }) : /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "signup.form.legal.updated.Oauth.xml",
            defaultMessage: "By creating an account, I accept the Atlassian <cloud-tos-link>Cloud Terms of Service</cloud-tos-link> and acknowledge the <privacy-policy-link>Privacy Policy</privacy-policy-link>.",
            description: "Cloud Terms of Service and Privacy Policy notice displayed to users when creating an Atlassian account",
            values: messageValues
        });
    }, [
        cloudTOSLinkClicked,
        privacyPolicyLinkClicked,
        isEmbedded,
        isMobileOidc,
        privacyPolicyText
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)($2d6bae9fb0c78a27$var$SignupLegal, {
        "data-testid": "legal-message",
        ref: ref,
        children: privacyPolicyMessage
    });
});
$2d6bae9fb0c78a27$var$PrivacyPolicy.displayName = 'PrivacyPolicy';
var $2d6bae9fb0c78a27$export$2e2bcd8739ae039 = $2d6bae9fb0c78a27$var$PrivacyPolicy;

});

parcelRegister("l29VX", function(module, exports) {

$parcel$export(module.exports, "useSignupPageContext", function () { return $6350befd57b360b5$export$ca302230e223e610; });
$parcel$export(module.exports, "SignupPageContextProvider", function () { return $6350befd57b360b5$export$840533f74aa75441; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");
const $6350befd57b360b5$export$77a8faae8f9f5eab = /*#__PURE__*/ (0, $91i6m.createContext)(null);
const $6350befd57b360b5$export$ca302230e223e610 = ()=>{
    const context = (0, $91i6m.useContext)($6350befd57b360b5$export$77a8faae8f9f5eab);
    if (!context) throw new Error('useSignupPageContext must be used within a SignupPageContextProvider');
    return context;
};
const $6350befd57b360b5$export$840533f74aa75441 = ({ children: children })=>{
    const [privacyPolicyText, setPrivacyPolicyText] = (0, $91i6m.useState)();
    const state = (0, $91i6m.useMemo)(()=>({
            privacyPolicyText: privacyPolicyText,
            setPrivacyPolicyText: setPrivacyPolicyText
        }), [
        privacyPolicyText,
        setPrivacyPolicyText
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)($6350befd57b360b5$export$77a8faae8f9f5eab.Provider, {
        value: state,
        children: children
    });
};

});



parcelRegister("kGQpp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2bafee7eeed3a2b$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $b2bafee7eeed3a2b$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    headTitle: {
        id: 'signup.head.title',
        defaultMessage: 'Sign up'
    },
    contextualHeadTitle: {
        id: 'signup.contextual.head.title',
        defaultMessage: 'Sign up to continue to',
        description: `Precedes a page title or issue number. For example, "Sign up to continue to Sarah's Blogpost"`
    },
    socialAuthOr: {
        id: 'social.auth.or',
        defaultMessage: 'or'
    },
    socialAuthOrContinueWith: {
        id: 'social.auth.or-continue-with',
        defaultMessage: 'Or continue with:'
    },
    headerTitle: {
        id: 'signup.header.title',
        defaultMessage: 'Sign up to continue',
        description: 'Shown before the login form. e.g. "Sign up first then we will show you the content you requested"'
    },
    startCollaboratingHeaderTitle: {
        id: 'signup.header.start.collaborating.title',
        defaultMessage: 'Sign up to start collaborating',
        description: 'Shown before the signup form. e.g. "Sign up first then we will show you the content you requested"'
    }
});

});

parcelRegister("gQHSy", function(module, exports) {

$parcel$export(module.exports, "useSignupSubmit", function () { return $95a1b70a7ebd750e$export$5757fd9e6194326b; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $91i6m = parcelRequire("91i6m");

var $6d87w = parcelRequire("6d87w");

var $2AqAA = parcelRequire("2AqAA");

var $2aGBJ = parcelRequire("2aGBJ");

var $1V2cH = parcelRequire("1V2cH");

var $jy3ZD = parcelRequire("jy3ZD");

var $kseBF = parcelRequire("kseBF");

var $l29VX = parcelRequire("l29VX");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");

var $a5qoX = parcelRequire("a5qoX");

var $brCu8 = parcelRequire("brCu8");

var $49Pnv = parcelRequire("49Pnv");
const $95a1b70a7ebd750e$var$useEmailFromSearchParams = ()=>{
    const loginHint = (0, $jy3ZD.useLoginHint)();
    const [queryParams] = (0, $6d87w.useSearchParams)();
    const email = (0, $jy3ZD.getEmailFromLoginHint)(loginHint) || queryParams.get('email');
    const shouldDisableEmailInput = queryParams.get('disableEmailInput') === 'true';
    return {
        email: email,
        shouldDisableEmailInput: shouldDisableEmailInput
    };
};
const $95a1b70a7ebd750e$export$5757fd9e6194326b = ({ autoSubmit: autoSubmitOption = true } = {})=>{
    (0, $4PGUW.useRegisterComponent)($95a1b70a7ebd750e$export$5757fd9e6194326b.name);
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const [hasAutoSubmitted, setHasAutoSubmitted] = (0, $91i6m.useState)(false);
    const { privacyPolicyText: privacyPolicyText = '' } = (0, $l29VX.useSignupPageContext)();
    const [_, setQueryParams] = (0, $6d87w.useSearchParams)();
    const { fetchToken: fetchToken, recaptchaType: recaptchaType } = (0, $a5qoX.useRecaptchaContext)();
    const fieldErrors = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_signup;
        return (_state_signup = state.signup) === null || _state_signup === void 0 ? void 0 : _state_signup.fieldErrors;
    });
    const autoSubmitDefault = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_signup;
        return (_state_signup = state.signup) === null || _state_signup === void 0 ? void 0 : _state_signup.autoSubmit;
    });
    const autoSubmit = (0, $91i6m.useMemo)(()=>autoSubmitDefault && autoSubmitOption, [
        autoSubmitDefault,
        autoSubmitOption
    ]);
    const onSignup = (0, $91i6m.useCallback)(async (signupData, options)=>{
        try {
            const challengeResponse = await fetchToken();
            setQueryParams((urlParams)=>{
                urlParams.delete('errorCode');
                if (urlParams.has('email')) urlParams.delete('email');
                urlParams.append('email', signupData.email);
                return urlParams;
            });
            analyticsClient.formSubmittedEvent((0, $kseBF.pageId), 'signupForm', {
                autoSubmit: autoSubmit,
                recaptchaType: recaptchaType
            });
            return dispatch((0, $2AqAA.signup)((0, $b2I6k._)((0, $1Fos3._)({}, signupData), {
                challengeResponse: challengeResponse,
                privacyPolicyText: privacyPolicyText
            }), undefined, options));
        } catch (e) {
            (0, $49Pnv.captureException)(e);
            dispatch((0, $2AqAA.signupCaptchaFailure)(navigator.onLine));
        }
    }, [
        setQueryParams,
        analyticsClient,
        dispatch,
        fetchToken,
        recaptchaType,
        privacyPolicyText,
        autoSubmit
    ]);
    const { email: email, shouldDisableEmailInput: shouldDisableEmailInput } = $95a1b70a7ebd750e$var$useEmailFromSearchParams();
    (0, $91i6m.useEffect)(()=>{
        if (autoSubmit && email && !hasAutoSubmitted) {
            onSignup({
                email: email
            });
            setHasAutoSubmitted(true);
        }
    }, [
        autoSubmit,
        email,
        onSignup,
        hasAutoSubmitted,
        setHasAutoSubmitted
    ]);
    const emailTranslation = (0, $brCu8.useTranslateFormErrorIfAvailable)(fieldErrors.email);
    const fieldErrorsWithTranslations = (0, $91i6m.useCallback)((fieldErrors)=>{
        // fieldErrors.email could either be a code or a pre-translated message.
        const emailErrorIsCode = fieldErrors.email !== emailTranslation;
        return (0, $1Fos3._)({}, fieldErrors.email && {
            email: {
                code: emailErrorIsCode ? fieldErrors.email : undefined,
                // TODO [KIRBY-7532]: remove fallback to empty string after removing useTranslateFormErrorIfAvailable.
                //   emailTranslation will always be defined if fieldErrors.email is defined.
                message: emailTranslation || ''
            }
        });
    }, [
        emailTranslation
    ]);
    return {
        onSignup: onSignup,
        fieldErrors: fieldErrorsWithTranslations(fieldErrors),
        email: email,
        shouldDisableEmailInput: shouldDisableEmailInput
    };
};

});

parcelRegister("cYyV8", function(module, exports) {

$parcel$export(module.exports, "useSocialSignup", function () { return $41d62b390eff71cd$export$a4d24b27d4eb9a3e; });

var $91i6m = parcelRequire("91i6m");

var $2aGBJ = parcelRequire("2aGBJ");

var $1V2cH = parcelRequire("1V2cH");

var $5k5vC = parcelRequire("5k5vC");

var $ccxRw = parcelRequire("ccxRw");

var $kseBF = parcelRequire("kseBF");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");

var $bqdjD = parcelRequire("bqdjD");
const $41d62b390eff71cd$export$a4d24b27d4eb9a3e = ()=>{
    (0, $4PGUW.useRegisterComponent)($41d62b390eff71cd$export$a4d24b27d4eb9a3e.name);
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const handleGoogleLogin = (0, $91i6m.useCallback)((analyticsAttributes = {})=>{
        analyticsClient.buttonClickedEvent((0, $kseBF.pageId), 'googleLoginButton', analyticsAttributes);
        (0, $ccxRw.redirectToGoogleLogin)({
            location: window.location,
            source: (0, $kseBF.pageId)
        });
    }, [
        analyticsClient
    ]);
    const auth0Config = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_appConfig;
        return (_state_appConfig = state.appConfig) === null || _state_appConfig === void 0 ? void 0 : _state_appConfig.auth0Config;
    });
    const csrfToken = (0, $2aGBJ.useAppSelector)((state)=>state.csrfToken);
    const { handleAppleLogin: handleAppleLogin, handleMicrosoftLogin: handleMicrosoftLogin, handleSlackLogin: handleSlackLogin } = (0, $5k5vC.useSocialLoginHandlers)({
        pageId: $kseBF.pageId,
        redirectParams: {
            location: window.location,
            auth0Config: auth0Config,
            csrfToken: csrfToken,
            source: (0, $kseBF.pageId)
        }
    });
    const { isEmbedded: isEmbedded } = (0, $2aGBJ.useAppSelector)((state)=>state.microbranding);
    const isCommercial = (0, $bqdjD.getCurrentCloudType)() === 'commercial';
    const envSupportsSocialSignup = (0, $91i6m.useMemo)(()=>!isEmbedded && isCommercial, [
        isEmbedded,
        isCommercial
    ]);
    if (!envSupportsSocialSignup) return {
        envSupportsSocialSignup: false,
        handleGoogleLogin: null,
        handleAppleLogin: null,
        handleMicrosoftLogin: null,
        handleSlackLogin: null
    };
    return {
        envSupportsSocialSignup: true,
        handleGoogleLogin: handleGoogleLogin,
        handleAppleLogin: handleAppleLogin,
        handleMicrosoftLogin: handleMicrosoftLogin,
        handleSlackLogin: handleSlackLogin
    };
};

});

parcelRegister("evNx2", function(module, exports) {

$parcel$export(module.exports, "useSignup", function () { return $e993fe43377c37fa$export$da8941e4c91255e0; });

var $91i6m = parcelRequire("91i6m");

var $6d87w = parcelRequire("6d87w");

var $leG06 = parcelRequire("leG06");

var $2AqAA = parcelRequire("2AqAA");

var $2aGBJ = parcelRequire("2aGBJ");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");

var $9uXJ3 = parcelRequire("9uXJ3");
const $e993fe43377c37fa$export$da8941e4c91255e0 = ({ forceRedirect: forceRedirect = true } = {})=>{
    (0, $4PGUW.useRegisterComponent)($e993fe43377c37fa$export$da8941e4c91255e0.name);
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const errorCode = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_signup;
        return (_state_signup = state.signup) === null || _state_signup === void 0 ? void 0 : _state_signup.error;
    });
    const redirectTo = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_signup;
        return (_state_signup = state.signup) === null || _state_signup === void 0 ? void 0 : _state_signup.redirectTo;
    });
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    (0, $91i6m.useEffect)(()=>{
        if (redirectTo && forceRedirect) try {
            const url = new URL(redirectTo);
            navigate(url.toString());
        } catch (e) {
        // invalid URL provided
        }
    }, [
        redirectTo,
        forceRedirect,
        navigate
    ]);
    (0, $91i6m.useEffect)(()=>{
        // On unmount, dispatch reset:
        return ()=>{
            dispatch((0, $2AqAA.reset)());
        };
    }, [
        dispatch
    ]);
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const error = (0, $91i6m.useMemo)(()=>{
        return errorCode ? {
            errorCode: errorCode,
            errorMessage: $e993fe43377c37fa$var$signupErrorMessageFromCode(errorCode, formatMessage)
        } : undefined;
    }, [
        errorCode,
        formatMessage
    ]);
    const [queryParams] = (0, $6d87w.useSearchParams)();
    const isRedirectFromResetPassord = queryParams.get('errorCode') === 'account_does_not_exist';
    const userJourneyContextError = isRedirectFromResetPassord ? {
        errorCode: 'account_does_not_exist',
        errorMessage: formatMessage({
            id: 'signup.form.redirect.account.does.not.exist.error',
            defaultMessage: "We can't find an account for that email address.",
            description: 'Error message shown when user tries to reset password for account that does not exist and is redirected to sign up'
        })
    } : undefined;
    return {
        error: /**
     * An error resulting from the user's actions on the signup page (often server error from
     * submitting the form).
     * */ error,
        redirectTo: /** URL to redirect to, if opted out of forced redirect */ redirectTo,
        userJourneyContextError: /**
     * An error within the wider context of the user's journey, during which they have been
     * redirected to or otherwise landed on the signup page (i.e. not a result of something they did
     * while on the page).
     * */ userJourneyContextError
    };
};
const $e993fe43377c37fa$var$signupErrorMessageFromCode = (errorCode, formatMessage)=>{
    switch(errorCode){
        case 'unknown':
            return formatMessage({
                id: 'signup.error.unknown',
                defaultMessage: 'Something went wrong while attempting to sign up. Please try again.'
            });
        case 'captcha':
            return formatMessage({
                id: 'signup.error.captcha',
                defaultMessage: 'We are having trouble verifying reCAPTCHA for this request. Please try again. If the problem persists, try another browser/device or reach out to Atlassian Support.'
            });
        case 'captchaScoreTooLow':
            return formatMessage({
                id: 'signup.error.captcha.score_too_low',
                defaultMessage: "We'd like to make sure it's really you creating your account. Please confirm you're not a robot.",
                description: 'Message asking user to tick the reCAPTCHA checkbox and resubmit the form'
            });
        case 'request_error':
            return formatMessage({
                id: 'signup.error.request_error',
                defaultMessage: 'Unable to connect. Check your internet connection or the network settings for your browser and try again.'
            });
        case 'unexpectedError':
            return formatMessage({
                id: 'signup.error.unexpected_error',
                defaultMessage: "We couldn't create your account. Try again in a few minutes."
            });
        default:
            return formatMessage({
                id: 'signup.form.random.error',
                defaultMessage: 'An error occurred while attempting to sign up: {error}. Please try again or reach out to Atlassian Support.'
            }, {
                error: errorCode
            });
    }
};

});


parcelRegister("3RQyJ", function(module, exports) {

$parcel$export(module.exports, "consentLoader", function () { return $d74e8776b54e7639$export$51cb5cf91bb86b88; });
$parcel$export(module.exports, "default", function () { return $d74e8776b54e7639$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $fo5uj = parcelRequire("fo5uj");

var $91i6m = parcelRequire("91i6m");
parcelRequire("6d87w");
var $l2v8Y = parcelRequire("l2v8Y");

var $2DHGn = parcelRequire("2DHGn");

var $2aGBJ = parcelRequire("2aGBJ");

var $6IwzG = parcelRequire("6IwzG");

var $9uXJ3 = parcelRequire("9uXJ3");

var $5e2bj = parcelRequire("5e2bj");

var $kpg9c = parcelRequire("kpg9c");

var $3f4xr = parcelRequire("3f4xr");

var $49Pnv = parcelRequire("49Pnv");




const $d74e8776b54e7639$var$consentComponents = {
    fedramp: /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("brhHY"))),
    'a53d6b63-3k57-1408-j79d-0b60b08kb685-privacy': /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("dQ68F"))),
    '2a85b822-1ba4-44ec-968a-c2f95bf4b469-privacy': /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("hcsgg"))),
    '6e62b4f0-a2f3-4cb5-b61c-1bd397640f04-privacy': /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("iP1Hg")))
};
async function $d74e8776b54e7639$export$51cb5cf91bb86b88({ request: request }) {
    if (!await (0, $3f4xr.checkFeatureGateOnceInitialized)((0, $kpg9c.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $5e2bj.fetchPageState)('/rest/login/consent/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--consent-screen'
        ]
    });
}
const $d74e8776b54e7639$export$68f39a5ef8cea54d = ()=>{
    (0, $5e2bj.usePageStateLoader)();
    const { cobranding: cobranding } = (0, $6IwzG.useCobranding)();
    const csrfToken = (0, $2aGBJ.useAppSelector)((state)=>state.csrfToken);
    const { background: Background } = (0, $2DHGn.getCobrandedComponents)(cobranding);
    const { organisationId: organisationId, consentType: consentType } = (0, $2aGBJ.useAppSelector)((state)=>state.loginConsent);
    const { search: search } = (0, $l2v8Y.useLocation)();
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    const handleRedirectToLogin = (0, $91i6m.useCallback)((errorKey)=>{
        const existingQueryParams = new URLSearchParams(search);
        existingQueryParams.set('errorCode', errorKey);
        const queryParamsWithErrorCode = existingQueryParams.toString();
        navigate(`/login?prompt=true&${queryParamsWithErrorCode}`);
    }, [
        search,
        navigate
    ]);
    const handleOnAccept = (0, $91i6m.useCallback)(async ()=>{
        const requestPayload = {
            consent: 'provided'
        };
        const response = await fetch(`/v2/login/authorize/consent${search}`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            },
            body: JSON.stringify(requestPayload)
        });
        switch(response.status){
            case 200:
                const responseBody = await response.json();
                navigate(responseBody.uri);
                break;
            case 400:
                handleRedirectToLogin('consent-validation-error');
                break;
            default:
                handleRedirectToLogin('consent-validation-error');
                break;
        }
    }, [
        csrfToken,
        search,
        handleRedirectToLogin,
        navigate
    ]);
    const handleOnCancel = (0, $91i6m.useCallback)(()=>{
        const existingQueryParams = new URLSearchParams(search);
        existingQueryParams.delete('token');
        existingQueryParams.set('prompt', 'true');
        existingQueryParams.set('errorCode', 'generic-consent-error');
        const queryParamsWithErrorCode = existingQueryParams.toString();
        navigate(`/login?${queryParamsWithErrorCode}`);
    }, [
        search,
        navigate
    ]);
    const consentId = (0, $91i6m.useMemo)(()=>{
        if (organisationId) return `${organisationId}-${consentType}`;
        return consentType;
    }, [
        consentType,
        organisationId
    ]);
    const ConsentComponent = consentId && $d74e8776b54e7639$var$consentComponents[consentId];
    (0, $91i6m.useEffect)(()=>{
        if (!ConsentComponent) {
            (0, $49Pnv.captureTaggedException)(`[ConsentScreen] no component rendered for organisation: ${organisationId}. Redirected to /login instead.`, {
                capabilities: [
                    'capability-group--login',
                    'capability-name--consent-screen'
                ]
            });
            handleRedirectToLogin('consent-loading-error');
        }
    }, [
        ConsentComponent,
        handleRedirectToLogin,
        organisationId
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $fo5uj.default), {
        children: /*#__PURE__*/ (0, $4ZSso.jsx)(Background, {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $91i6m.Suspense), {
                fallback: null,
                children: ConsentComponent ? /*#__PURE__*/ (0, $4ZSso.jsx)(ConsentComponent, {
                    onAccept: handleOnAccept,
                    onCancel: handleOnCancel
                }) : null
            })
        })
    });
};
var $d74e8776b54e7639$export$2e2bcd8739ae039 = $d74e8776b54e7639$export$68f39a5ef8cea54d;

});
parcelRegister("brhHY", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("fegwJ")).then(()=>parcelRequire('Kcf3D'));

});

parcelRegister("dQ68F", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("bfNSm")).then(()=>parcelRequire('gL6Nj'));

});

parcelRegister("hcsgg", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("4D3hi")).then(()=>parcelRequire('lWww0'));

});

parcelRegister("iP1Hg", function(module, exports) {


module.exports = (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("hb2yi")).then(()=>parcelRequire('f0IuU'));

});


parcelRegister("jkJ76", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "socialConfirmationLoader", function () { return $2f8e9a77c46e5f90$export$1e349fd991386427; });
$parcel$export(module.exports, "CreateAccountConfirmationPage", function () { return $2f8e9a77c46e5f90$export$74ab7a9a192e1a7a; });
$parcel$export(module.exports, "default", function () { return $2f8e9a77c46e5f90$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $gs2u7 = parcelRequire("gs2u7");

var $1V2cH = parcelRequire("1V2cH");
parcelRequire("0wXBc");
var $iiGfm = parcelRequire("iiGfm");
parcelRequire("26od7");
var $divIX = parcelRequire("divIX");

var $8OxXI = parcelRequire("8OxXI");

var $5e2bj = parcelRequire("5e2bj");

var $fRj56 = parcelRequire("fRj56");

var $3Mnu4 = parcelRequire("3Mnu4");

var $87AzW = parcelRequire("87AzW");

var $d7eHS = parcelRequire("d7eHS");

var $k0R1J = parcelRequire("k0R1J");

var $9ddwm = parcelRequire("9ddwm");

var $kpg9c = parcelRequire("kpg9c");

var $3f4xr = parcelRequire("3f4xr");
async function $2f8e9a77c46e5f90$export$1e349fd991386427({ request: request }) {
    if (!await (0, $3f4xr.checkFeatureGateOnceInitialized)((0, $kpg9c.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $5e2bj.fetchPageState)('/rest/login/social/confirmation/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-subgroup--social-login'
        ]
    });
}
const $2f8e9a77c46e5f90$export$74ab7a9a192e1a7a = ()=>{
    const pageState = (0, $divIX.useCreateAccountConfirmationPageState)();
    const { createNeeded: createNeeded, isEmbedded: isEmbedded, isLoading: isLoading, loginType: loginType, oidcContext: oidcContext, verifyNeeded: verifyNeeded } = pageState;
    // TODO: move to our recaptcha component for this page?
    (0, $iiGfm.useRecaptchaChallengeObserver)((0, $3Mnu4.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID));
    const onSubmitClick = (0, $1V2cH.useButtonClickedEvent)((0, $3Mnu4.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID), 'confirmationSignup');
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gs2u7.default), {
        pageId: (0, $3Mnu4.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID),
        header: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $87AzW.Header), {
            createNeeded: createNeeded
        }),
        whiteboxFooter: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $k0R1J.WhiteboxFooter), {
            loginType: loginType,
            verifyNeeded: verifyNeeded,
            createNeeded: createNeeded,
            isEmbedded: isEmbedded,
            oidcContext: oidcContext
        }),
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $fRj56.default), {
            isEmbedded: isEmbedded,
            isLoading: isLoading,
            privacyPolicy: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8OxXI.CreateAccountConfirmationPrivacyPolicy), {}),
            onSubmitClick: onSubmitClick,
            title: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $d7eHS.TitleText), {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9ddwm.ConfirmationFormTitleText), {
                    loginType: loginType,
                    createNeeded: createNeeded
                })
            })
        })
    });
};
var $2f8e9a77c46e5f90$export$2e2bcd8739ae039 = $2f8e9a77c46e5f90$export$74ab7a9a192e1a7a;

});
parcelRegister("8OxXI", function(module, exports) {

$parcel$export(module.exports, "CreateAccountConfirmationPrivacyPolicy", function () { return $f07c2448185a4a1a$export$4f3ec0472a168e52; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $83pNw = parcelRequire("83pNw");

var $7eeh4 = parcelRequire("7eeh4");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");

var $3Mnu4 = parcelRequire("3Mnu4");

var $3SEta = parcelRequire("3SEta");

var $2aGBJ = parcelRequire("2aGBJ");
const $f07c2448185a4a1a$export$4f3ec0472a168e52 = ()=>{
    var _privacyPolicyMessageRef_current;
    (0, $4PGUW.useRegisterComponent)($f07c2448185a4a1a$export$4f3ec0472a168e52.name);
    const privacyPolicyMessageRef = (0, $91i6m.useRef)(null);
    const oidcContext = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_microbranding;
        return state === null || state === void 0 ? void 0 : (_state_microbranding = state.microbranding) === null || _state_microbranding === void 0 ? void 0 : _state_microbranding.oidcContext;
    });
    const isEmbedded = (0, $2aGBJ.useAppSelector)((state)=>Boolean(state.microbranding.isEmbedded));
    const { setPrivacyPolicyText: setPrivacyPolicyText } = (0, $3SEta.useCreateAccountConfirmationPageContext)();
    const privacyPolicyText = ((_privacyPolicyMessageRef_current = privacyPolicyMessageRef.current) === null || _privacyPolicyMessageRef_current === void 0 ? void 0 : _privacyPolicyMessageRef_current.innerHTML) || '';
    (0, $91i6m.useEffect)(()=>{
        if (privacyPolicyText) setPrivacyPolicyText(privacyPolicyText);
    }, [
        privacyPolicyText,
        setPrivacyPolicyText
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $83pNw.default), {
        isEmbedded: isEmbedded,
        isMobileOidc: (0, $7eeh4.isMobileOidc)(oidcContext),
        pageId: (0, $3Mnu4.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID),
        privacyPolicyText: (0, $83pNw.PrivacyPolicyText).oauthSignup,
        ref: privacyPolicyMessageRef
    });
};

});
parcelRegister("3Mnu4", function(module, exports) {

$parcel$export(module.exports, "CREATE_ACCOUNT_CONFIRMATION_PAGE_ID", function () { return $57ba2bfeb13b5b56$export$eda9461179ec043e; });
const $57ba2bfeb13b5b56$export$eda9461179ec043e = 'confirmCreateAccountIdpScreen';

});

parcelRegister("3SEta", function(module, exports) {

$parcel$export(module.exports, "useCreateAccountConfirmationPageContext", function () { return $de9a5cc1f63e265b$export$4b772b7a2dc6f7e0; });
$parcel$export(module.exports, "CreateAccountConfirmationPageProvider", function () { return $de9a5cc1f63e265b$export$a212ad9eda3f2daa; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");
const $de9a5cc1f63e265b$export$3906f31e8e2451c7 = /*#__PURE__*/ (0, $91i6m.createContext)(null);
const $de9a5cc1f63e265b$export$4b772b7a2dc6f7e0 = ()=>{
    const context = (0, $91i6m.useContext)($de9a5cc1f63e265b$export$3906f31e8e2451c7);
    if (!context) throw new Error('useCreateAccountConfirmationPageContext must be used within a CreateAccountConfirmationPageContext provider');
    return context;
};
const $de9a5cc1f63e265b$export$a212ad9eda3f2daa = ({ children: children })=>{
    const [privacyPolicyText, setPrivacyPolicyText] = (0, $91i6m.useState)();
    const [marketingConsent, setMarketingConsent] = (0, $91i6m.useState)({
        state: 'not_shown'
    });
    const state = (0, $91i6m.useMemo)(()=>({
            privacyPolicyText: privacyPolicyText,
            setPrivacyPolicyText: setPrivacyPolicyText,
            marketingConsent: marketingConsent,
            setMarketingConsent: setMarketingConsent
        }), [
        marketingConsent,
        privacyPolicyText
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)($de9a5cc1f63e265b$export$3906f31e8e2451c7.Provider, {
        value: state,
        children: children
    });
};

});


parcelRegister("fRj56", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $adae887cc0f2d4b2$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $7ecAu = parcelRequire("7ecAu");

var $6Yn9h = parcelRequire("6Yn9h");

var $cLysE = parcelRequire("cLysE");

var $2ZKUQ = parcelRequire("2ZKUQ");

var $31nHY = parcelRequire("31nHY");

var $9jjaN = parcelRequire("9jjaN");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");

var $gFwNN = parcelRequire("gFwNN");

var $ccxRw = parcelRequire("ccxRw");

var $9yEtj = parcelRequire("9yEtj");
var $iO71n = parcelRequire("iO71n");

var $9mRoI = parcelRequire("9mRoI");

var $e6Ygv = parcelRequire("e6Ygv");

var $fNi3o = parcelRequire("fNi3o");
let $adae887cc0f2d4b2$var$_ = (t)=>t, $adae887cc0f2d4b2$var$t, $adae887cc0f2d4b2$var$t1, $adae887cc0f2d4b2$var$t2, $adae887cc0f2d4b2$var$t3, $adae887cc0f2d4b2$var$t4, $adae887cc0f2d4b2$var$t5;
const $adae887cc0f2d4b2$export$6b077d087ec15a10 = (0, $9jjaN.default).div($adae887cc0f2d4b2$var$t || ($adae887cc0f2d4b2$var$t = $adae887cc0f2d4b2$var$_`
  margin-top: ${0}px;
  text-align: left;
`), (0, $6e88g.gridSize)());
const $adae887cc0f2d4b2$var$ConsentAndLegalContainer = (0, $9jjaN.default)((0, $gFwNN.default))($adae887cc0f2d4b2$var$t1 || ($adae887cc0f2d4b2$var$t1 = $adae887cc0f2d4b2$var$_`
  margin-top: ${0}px;
`), (0, $6e88g.gridSize)());
const $adae887cc0f2d4b2$export$9951c1d20fa87009 = (0, $9jjaN.default).div($adae887cc0f2d4b2$var$t2 || ($adae887cc0f2d4b2$var$t2 = $adae887cc0f2d4b2$var$_`
  display: flex;
  margin-top: ${0}px;
`), (0, $6e88g.gridSize)());
const $adae887cc0f2d4b2$var$StyledForm = (0, $9jjaN.default).form($adae887cc0f2d4b2$var$t3 || ($adae887cc0f2d4b2$var$t3 = $adae887cc0f2d4b2$var$_`
  margin: 0;
`));
const $adae887cc0f2d4b2$export$60374ee25b7d5e87 = (0, $9jjaN.default).div($adae887cc0f2d4b2$var$t4 || ($adae887cc0f2d4b2$var$t4 = $adae887cc0f2d4b2$var$_`
  font-weight: bold;
  color: ${0};
  word-wrap: break-word;
`), (0, $kLNLK).N800);
const $adae887cc0f2d4b2$var$VerificationWrapper = (0, $9jjaN.default).div($adae887cc0f2d4b2$var$t5 || ($adae887cc0f2d4b2$var$t5 = $adae887cc0f2d4b2$var$_`
  margin: ${0}px 0 0;
`), (0, $6e88g.gridSize)() * 2);
const $adae887cc0f2d4b2$export$ca6de4c099a9b97d = ({ isLoading: isLoading, onSubmitClick: onSubmitClick, privacyPolicy: privacyPolicy, title: title })=>{
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const { onCreateAccountConfirmation: onCreateAccountConfirmation, createAccountNeeded: createNeeded, verifyEmailNeeded: verifyNeeded, email: email, displayName: initialDisplayName, canEditDisplayName: canEditDisplayName, formError: formError, fieldErrors: fieldErrors } = (0, $e6Ygv.useCreateAccountConfirmation)({});
    const [code, setCode] = (0, $91i6m.useState)('');
    const [displayName, setDisplayName] = (0, $91i6m.useState)('');
    (0, $91i6m.useEffect)(()=>{
        if (initialDisplayName && displayName === '') setDisplayName(initialDisplayName);
    }, [
        initialDisplayName,
        displayName
    ]);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        await onCreateAccountConfirmation({
            displayName: displayName,
            code: code
        });
    };
    const handleDisplayNameChange = (e)=>{
        const displayName = e.currentTarget.value;
        setDisplayName(displayName);
    };
    const handleCodeChange = (e)=>{
        const code = e.currentTarget.value;
        setCode(code);
    };
    const submitButtonText = ()=>{
        if (createNeeded) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "confirmation.form.submit.create",
            defaultMessage: "Create your account",
            description: "Button to submit form and create account"
        });
        else return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "confirmation.form.submit.verify",
            defaultMessage: "Verify your account",
            description: "Button to submit form and verify account"
        });
    };
    const renderHiddenEmailWarning = ()=>{
        return /*#__PURE__*/ (0, $4ZSso.jsx)($adae887cc0f2d4b2$export$9951c1d20fa87009, {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $31nHY.default), {
                title: formatMessage((0, $6Yn9h.default).hiddenEmailWarningTitle),
                children: /*#__PURE__*/ (0, $4ZSso.jsx)("p", {
                    "data-testid": "hidden-email-warning",
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                        id: "confirmation.form.hiddenemailwarning.message",
                        defaultMessage: "Your team may not recognize you and you won't receive their updates. When you are ready to work with a team, just update your Apple ID settings to share your real email."
                    })
                })
            })
        });
    };
    const renderCodeError = (error)=>{
        switch(error){
            case 'invalid_code':
                return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "confirmation.form.code.invalid.server",
                    defaultMessage: "Provided verification code is invalid"
                });
            case 'invalid_length':
                return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "confirmation.form.code.invalid.length",
                    defaultMessage: "Your verification code needs to be {length, plural, one {# digit} other {# digits}} or longer",
                    values: {
                        length: 8
                    }
                });
            case 'empty_code':
                return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "confirmation.form.code.empty",
                    defaultMessage: "Please enter a verification code"
                });
        }
    };
    const displayNameError = fieldErrors && fieldErrors.displayName;
    const codeError = fieldErrors && fieldErrors.code;
    return /*#__PURE__*/ (0, $4ZSso.jsxs)("div", {
        children: [
            formError && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $31nHY.default), {
                children: formError === null || formError === void 0 ? void 0 : formError.message
            }),
            title && /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
                children: title
            }),
            email && (0, $ccxRw.isAppleHiddenEmail)(email) && renderHiddenEmailWarning(),
            /*#__PURE__*/ (0, $4ZSso.jsxs)($adae887cc0f2d4b2$var$StyledForm, {
                onSubmit: handleSubmit,
                id: "confirmation-form",
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $iO71n.default), {
                        name: "email",
                        label: formatMessage((0, $6Yn9h.default).emailLabel),
                        children: ()=>/*#__PURE__*/ (0, $4ZSso.jsx)($adae887cc0f2d4b2$export$60374ee25b7d5e87, {
                                children: email
                            })
                    }),
                    createNeeded && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $iO71n.default), {
                        name: "displayName",
                        label: formatMessage((0, $6Yn9h.default).displayNameLabel),
                        children: ({ fieldProps: fieldProps })=>!canEditDisplayName ? /*#__PURE__*/ (0, $4ZSso.jsx)($adae887cc0f2d4b2$export$60374ee25b7d5e87, {
                                role: "caption",
                                children: initialDisplayName
                            }) : /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $7ecAu.default), (0, $b2I6k._)((0, $1Fos3._)({}, fieldProps), {
                                        placeholder: formatMessage((0, $6Yn9h.default).displayNamePlaceholder),
                                        type: "text",
                                        defaultValue: initialDisplayName,
                                        onChange: handleDisplayNameChange,
                                        isInvalid: !!displayNameError,
                                        autoFocus: !!email && !initialDisplayName
                                    })),
                                    !!displayNameError && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9yEtj.ErrorMessage), {
                                        children: displayNameError
                                    })
                                ]
                            })
                    }),
                    verifyNeeded && /*#__PURE__*/ (0, $4ZSso.jsx)($adae887cc0f2d4b2$var$VerificationWrapper, {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $iO71n.default), {
                            name: "code",
                            label: formatMessage((0, $6Yn9h.default).codeLabel),
                            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $4ZSso.jsx)((0, $7ecAu.default), (0, $b2I6k._)((0, $1Fos3._)({}, fieldProps), {
                                            id: "code",
                                            placeholder: formatMessage((0, $6Yn9h.default).codePlaceHolder),
                                            type: "text",
                                            onChange: handleCodeChange,
                                            isInvalid: !!codeError,
                                            "aria-describedby": codeError ? `${fieldProps.id}-error` : undefined,
                                            spellCheck: false,
                                            autoComplete: "off",
                                            maxLength: 16
                                        })),
                                        /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9yEtj.MessageWrapper), {
                                            children: !!codeError && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9yEtj.ErrorMessage), {
                                                children: renderCodeError(codeError)
                                            })
                                        })
                                    ]
                                })
                        })
                    }),
                    createNeeded && /*#__PURE__*/ (0, $4ZSso.jsxs)($adae887cc0f2d4b2$var$ConsentAndLegalContainer, {
                        children: [
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9mRoI.CreateAccountConfirmationMarketingConsent), {}),
                            /*#__PURE__*/ (0, $4ZSso.jsx)($adae887cc0f2d4b2$export$6b077d087ec15a10, {
                                children: privacyPolicy
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $fNi3o.CreateAccountConfirmationRecaptcha), {}),
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $2ZKUQ.default), {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                            appearance: "primary",
                            id: "login-submit",
                            type: "submit",
                            isFullWidth: true,
                            isLoading: isLoading,
                            onClick: onSubmitClick,
                            children: submitButtonText()
                        })
                    })
                ]
            })
        ]
    });
};
var $adae887cc0f2d4b2$export$2e2bcd8739ae039 = $adae887cc0f2d4b2$export$ca6de4c099a9b97d;

});
parcelRegister("6Yn9h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c241bb7ca6c434b8$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $c241bb7ca6c434b8$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    displayNameEmpty: {
        id: 'confirmation.form.displayName.empty',
        defaultMessage: 'Please enter a name',
        description: ''
    },
    displayNamePlaceholder: {
        id: 'confirmation.form.displayName.placeholder',
        defaultMessage: 'Enter full name',
        description: ''
    },
    displayNameLabel: {
        id: 'confirmation.form.displayName.label',
        defaultMessage: 'Full name',
        description: ''
    },
    codePlaceHolder: {
        id: 'confirmation.form.code.placeholder',
        defaultMessage: 'Enter the code sent to your email',
        description: 'Placeholder for text input'
    },
    codeLabel: {
        id: 'confirmation.form.code.label',
        defaultMessage: 'Verification code',
        description: 'Label for text input'
    },
    emailLabel: {
        id: 'confirmation.form.emailaddress.label',
        defaultMessage: 'Email address',
        description: ''
    },
    hiddenEmailWarningTitle: {
        id: 'confirmation.form.hiddenemailwarning.title',
        defaultMessage: "You're hiding your real email",
        description: ''
    }
});

});

parcelRegister("9mRoI", function(module, exports) {

$parcel$export(module.exports, "CreateAccountConfirmationMarketingConsent", function () { return $3b38b740477403c0$export$3340e585d36bf8e8; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");

var $3SEta = parcelRequire("3SEta");

var $fxz8k = parcelRequire("fxz8k");

var $2aGBJ = parcelRequire("2aGBJ");

var $cRW6P = parcelRequire("cRW6P");
const $3b38b740477403c0$var$marketingConsentSelector = (state)=>state.marketingConsent.config;
const $3b38b740477403c0$var$createAccountEmailSelector = (state)=>state.createAccount.email;
const $3b38b740477403c0$export$3340e585d36bf8e8 = ()=>{
    (0, $4PGUW.useRegisterComponent)($3b38b740477403c0$export$3340e585d36bf8e8.name);
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const { setMarketingConsent: setMarketingConsent } = (0, $3SEta.useCreateAccountConfirmationPageContext)();
    const marketingConsentConfig = (0, $2aGBJ.useAppSelector)($3b38b740477403c0$var$marketingConsentSelector);
    const email = (0, $2aGBJ.useAppSelector)($3b38b740477403c0$var$createAccountEmailSelector);
    (0, $91i6m.useEffect)(()=>{
        if (email) dispatch((0, $cRW6P.fetchConsentConfig)(email));
    }, [
        dispatch,
        email
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $fxz8k.default), {
        config: marketingConsentConfig,
        onConsentChange: setMarketingConsent
    });
};

});

parcelRegister("e6Ygv", function(module, exports) {

$parcel$export(module.exports, "useCreateAccountConfirmation", function () { return $181bb59c36fd59eb$export$e91af0855b7bcb2e; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $91i6m = parcelRequire("91i6m");

var $3SEta = parcelRequire("3SEta");
parcelRequire("26od7");
var $divIX = parcelRequire("divIX");

var $6Yn9h = parcelRequire("6Yn9h");

var $leG06 = parcelRequire("leG06");

var $dpsxD = parcelRequire("dpsxD");

var $a5qoX = parcelRequire("a5qoX");

var $2aGBJ = parcelRequire("2aGBJ");

var $4JAG5 = parcelRequire("4JAG5");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");

var $1V2cH = parcelRequire("1V2cH");

var $3Mnu4 = parcelRequire("3Mnu4");

var $ccxRw = parcelRequire("ccxRw");

var $9uXJ3 = parcelRequire("9uXJ3");
parcelRequire("0wXBc");
var $kBhWP = parcelRequire("kBhWP");
const $181bb59c36fd59eb$export$e91af0855b7bcb2e = ({ onFailure: onFailure, onSubmit: onSubmit, autoRedirect: autoRedirect = true } = {
    autoRedirect: true
})=>{
    (0, $4PGUW.useRegisterComponent)($181bb59c36fd59eb$export$e91af0855b7bcb2e.name);
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    const pageState = (0, $divIX.useCreateAccountConfirmationPageState)();
    const { redirectTo: redirectTo, createNeeded: createNeeded, displayName: displayName, email: email, verifyNeeded: verifyNeeded, fieldErrors: fieldErrors, formError: formError, isLoading: isLoading, loginType: loginType } = pageState;
    const { fetchToken: fetchToken, recaptchaType: recaptchaType } = (0, $a5qoX.useRecaptchaContext)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    // Prevent redirect if the autoRedirect flag is true
    // Used in cases where cobranding wants to redirect the user themselves.
    // NOTE: `autoRedirect` is deprecated, please do not use
    // @see: UseCreateAccountConfirmationHookProps['autoRedirect']
    (0, $kBhWP.useForceRedirect)({
        redirectTo: autoRedirect ? redirectTo : undefined
    });
    const { marketingConsent: marketingConsent, privacyPolicyText: privacyPolicyText = '' } = (0, $3SEta.useCreateAccountConfirmationPageContext)();
    const getEventAttributes = (0, $91i6m.useCallback)((verificationCodeEntered)=>{
        return {
            loginType: loginType,
            confirmationCreateAccountNeeded: createNeeded,
            confirmationVerifyEmailNeeded: verifyNeeded,
            verificationCodeEntered: verificationCodeEntered,
            formError: formError,
            recaptchaType: recaptchaType
        };
    }, [
        createNeeded,
        formError,
        loginType,
        recaptchaType,
        verifyNeeded
    ]);
    const onValidationErrorAnalytics = (0, $91i6m.useCallback)((errors, verificationCodeEntered)=>{
        if (errors.displayName) {
            const errorBooleanMap = Object.keys(errors).reduce((acc, val)=>(0, $b2I6k._)((0, $1Fos3._)({}, acc), {
                    [val + 'Error']: true
                }), {});
            analyticsClient.uiEvent({
                page: (0, $3Mnu4.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID),
                action: 'shown',
                subject: 'error',
                subjectId: 'confirmCreateAccountIdpNoName',
                attributes: {
                    errors: errorBooleanMap
                }
            });
        }
        if (errors.code === 'empty_code') analyticsClient.errorShownEvent((0, $3Mnu4.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID), 'emptyCode', getEventAttributes(verificationCodeEntered));
        else if (errors.code === 'invalid_length') analyticsClient.errorShownEvent((0, $3Mnu4.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID), 'invalidCodeLength', getEventAttributes(verificationCodeEntered));
    }, [
        analyticsClient,
        getEventAttributes
    ]);
    const onSubmitAnalytics = (0, $91i6m.useCallback)((verificationCodeEntered)=>{
        analyticsClient.checkboxChangedEvent((0, $3Mnu4.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID), 'marketingConsent', (0, $b2I6k._)((0, $1Fos3._)({}, getEventAttributes(verificationCodeEntered)), {
            status: marketingConsent === null || marketingConsent === void 0 ? void 0 : marketingConsent.state
        }));
        analyticsClient.formSubmittedEvent((0, $3Mnu4.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID), 'confirmCreateAccountIdp', getEventAttributes(verificationCodeEntered));
    }, [
        analyticsClient,
        getEventAttributes,
        marketingConsent === null || marketingConsent === void 0 ? void 0 : marketingConsent.state
    ]);
    const handleSubmit = (0, $91i6m.useCallback)((confirmationData)=>{
        navigate(location.pathname + location.search + location.hash);
        const challengeRequest = (0, $4JAG5.toChallengeRequest)(confirmationData.challengeResponse);
        const { loginType: loginType, hashedCsrfToken: hashedCsrfToken, confirmationToken: confirmationToken, mfaToken: mfaToken } = pageState;
        dispatch((0, $dpsxD.inHouseSocialConfirmation)((0, $b2I6k._)((0, $1Fos3._)({}, confirmationData), {
            privacyPolicyText: privacyPolicyText,
            hashedCsrfToken: hashedCsrfToken,
            mfaToken: mfaToken,
            confirmationToken: confirmationToken,
            loginType: loginType,
            challengeRequest: challengeRequest
        })));
    }, [
        navigate,
        pageState,
        dispatch,
        privacyPolicyText
    ]);
    const onCreateAccountConfirmation = (0, $91i6m.useCallback)(async ({ displayName: displayName, code: code })=>{
        const validationErrors = {};
        if (isLoading) return;
        if (createNeeded && (!displayName || displayName.trim() === '')) validationErrors.displayName = formatMessage((0, $6Yn9h.default).displayNameEmpty); // TODO: do we want to create message codes here like in the OTP page?
        if (verifyNeeded) {
            if (!code || code.trim() === '') validationErrors.code = 'empty_code';
            else if (code.trim().length < 7) // Codes could be length 8 or 16, see HOT-94320 changes.
            // Condition of < 7 to allow for flexibility if further code length changes are needed.
            validationErrors.code = 'invalid_length';
        }
        const verificationCodeEntered = Boolean(code);
        if (Object.keys(validationErrors).length) {
            dispatch((0, $dpsxD.showFieldErrors)(validationErrors));
            onValidationErrorAnalytics(validationErrors, verificationCodeEntered);
            onFailure === null || onFailure === void 0 ? void 0 : onFailure(validationErrors);
            return;
        }
        const challengeResponse = await fetchToken();
        onSubmitAnalytics(verificationCodeEntered);
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
        if (createNeeded && verifyNeeded) handleSubmit({
            displayName: displayName,
            code: code,
            marketingConsentState: marketingConsent,
            challengeResponse: challengeResponse
        });
        else if (createNeeded) handleSubmit({
            displayName: displayName,
            marketingConsentState: marketingConsent,
            challengeResponse: challengeResponse
        });
        else handleSubmit({
            code: code,
            challengeResponse: challengeResponse
        });
    }, [
        isLoading,
        createNeeded,
        verifyNeeded,
        fetchToken,
        onSubmitAnalytics,
        onSubmit,
        formatMessage,
        dispatch,
        onValidationErrorAnalytics,
        onFailure,
        handleSubmit,
        marketingConsent
    ]);
    const canEditDisplayName = (0, $91i6m.useMemo)(()=>{
        return loginType === (0, $ccxRw.LoginType).Apple || loginType === (0, $ccxRw.LoginType).Slack || loginType === (0, $ccxRw.LoginType).Microsoft;
    }, [
        loginType
    ]);
    const formErrorWithMessage = (0, $91i6m.useMemo)(()=>{
        if (!formError) return;
        const message = $181bb59c36fd59eb$var$errorMessageFromCode(formError, formatMessage);
        return {
            code: formError,
            message: message
        };
    }, [
        formError,
        formatMessage
    ]);
    return {
        createAccountNeeded: createNeeded,
        canEditDisplayName: canEditDisplayName,
        displayName: displayName,
        verifyEmailNeeded: verifyNeeded,
        onCreateAccountConfirmation: onCreateAccountConfirmation,
        email: email,
        fieldErrors: fieldErrors,
        formError: formErrorWithMessage,
        isLoading: isLoading,
        redirectTo: redirectTo
    };
};
const $181bb59c36fd59eb$var$errorMessageFromCode = (errorCode, formatMessage)=>{
    switch(errorCode){
        case 'captcha_not_loaded':
        case 'captcha_failed':
            return formatMessage({
                id: 'confirmation.error.captcha.failed',
                defaultMessage: 'We are having trouble verifying ReCAPTCHA for this request. Please try again. If the problem persists, try another browser/device or reach out to Atlassian Support.'
            });
        case 'captchaScoreTooLow':
            return formatMessage({
                id: 'confirmation.error.captcha.score_too_low',
                defaultMessage: "We'd like to make sure it's really you creating your account. Please confirm you're not a robot.",
                description: 'Message asking user to tick the reCAPTCHA checkbox and resubmit the form'
            });
        case 'request_error':
            return formatMessage({
                id: 'confirmation.error.offline',
                defaultMessage: 'We seem to have lost the connection. Check your network settings, then try again. '
            });
        default:
            return formatMessage({
                id: 'confirmation.error.unknown',
                defaultMessage: 'Something went wrong while trying to create your account. Wait a few moments, then try again.'
            });
    }
};

});
parcelRegister("dpsxD", function(module, exports) {

$parcel$export(module.exports, "showFieldErrors", function () { return $ed03e544a2cec734$export$f17d5fd8029ff8d7; });
$parcel$export(module.exports, "inHouseSocialConfirmation", function () { return $ed03e544a2cec734$export$fc20e580ac82d1bc; });
$parcel$export(module.exports, "resendInHouseVerificationCode", function () { return $ed03e544a2cec734$export$1b8c49d1a252ff84; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $fqbXQ = parcelRequire("fqbXQ");

var $g7xf6 = parcelRequire("g7xf6");

var $dBq8m = parcelRequire("dBq8m");
const $ed03e544a2cec734$export$aad8462122ac592b = ()=>({
        type: 'CONFIRMATION_RESET'
    });
const $ed03e544a2cec734$export$ff19f4caed0eaf31 = ()=>({
        type: 'CONFIRMATION_REQUEST'
    });
const $ed03e544a2cec734$export$1cb045489d712953 = (redirectTo)=>({
        type: 'CONFIRMATION_REQUEST_SUCCESS',
        redirectTo: redirectTo
    });
const $ed03e544a2cec734$export$bf1ddd88318577cc = (error)=>({
        type: 'CONFIRMATION_REQUEST_FAILED',
        error: error
    });
const $ed03e544a2cec734$export$bd2309d55d5d70da = (backendState)=>({
        type: 'CONFIRMATION_STATE_UPDATE',
        backendState: backendState
    });
const $ed03e544a2cec734$export$f17d5fd8029ff8d7 = (errors)=>({
        type: 'CONFIRMATION_SHOW_FIELD_ERROR',
        errors: errors
    });
const $ed03e544a2cec734$export$4b98afed05a66101 = (mfaToken)=>({
        type: 'CONFIRMATION_RESEND_SUCCESS',
        mfaToken: mfaToken
    });
const $ed03e544a2cec734$var$buildBaseConfirmationJsonPayload = (confirmationParams, state)=>{
    const { source: source, displayName: displayName, marketingConsentState: marketingConsentState, privacyPolicyText: privacyPolicyText } = confirmationParams;
    const payload = {
        fullName: displayName,
        source: source,
        atlassianAccountCreationConfirmed: true
    };
    if (marketingConsentState) {
        const marketingConsent = (0, $fqbXQ.buildMarketingConsent)(state.marketingConsent.config, marketingConsentState, privacyPolicyText);
        if (marketingConsent) payload.marketingConsent = marketingConsent;
    }
    return payload;
};
const $ed03e544a2cec734$export$fc20e580ac82d1bc = (confirmationParams)=>async (dispatch, getState)=>{
        const { loginType: loginType, confirmationToken: confirmationToken, mfaToken: mfaToken, hashedCsrfToken: hashedCsrfToken, code: code, challengeRequest: challengeRequest } = confirmationParams;
        dispatch($ed03e544a2cec734$export$ff19f4caed0eaf31());
        try {
            var _response_createAccount, _response_createAccount1;
            const payload = (0, $b2I6k._)((0, $1Fos3._)({}, $ed03e544a2cec734$var$buildBaseConfirmationJsonPayload(confirmationParams, getState())), {
                challengeResponse: challengeRequest,
                loginType: loginType,
                csrfToken: hashedCsrfToken,
                confirmationToken: confirmationToken,
                mfaToken: mfaToken,
                code: code
            });
            const csrfToken = getState().csrfToken;
            const params = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(location.search);
            const ENDPOINT_PATH = '/rest/login/social/confirmation';
            // These are used by SIS to redirect the user to the correct place.
            // In the "old" implementation (i.e. `submitFormHack`)
            const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).stringify((0, $1Fos3._)({}, params.continue ? {
                continue: params.continue
            } : {}, params.application ? {
                application: params.application
            } : {}));
            // Only include the query parameters if any exist on the url
            const qs = queryParams.length > 0 ? `?${queryParams}` : '';
            const action = `${ENDPOINT_PATH}${qs}`;
            const res = await (0, $g7xf6.submitFormHackReplacement)({
                method: 'POST',
                action: action,
                payload: payload,
                csrfToken: csrfToken,
                enablePassingCookies: true
            });
            const response = await res.json();
            const hasCreateAccountSpecificState = !!response.createAccount;
            // We have state from the backend, which we want to ensure is updated in the FE state.
            if (hasCreateAccountSpecificState) {
                // Want to make sure that it's the shape that we expect before updating the state
                const isCreateAccountObject = typeof response.createAccount === 'object' && !Array.isArray(response.createAccount);
                dispatch($ed03e544a2cec734$export$bd2309d55d5d70da(isCreateAccountObject ? response.createAccount : {}));
            }
            const hasError = !!(response === null || response === void 0 ? void 0 : (_response_createAccount = response.createAccount) === null || _response_createAccount === void 0 ? void 0 : _response_createAccount.formError);
            if (hasError) {
                dispatch($ed03e544a2cec734$export$bf1ddd88318577cc(response.createAccount.formError));
                return;
            }
            // This indicates the backend is not behaving as expected
            // since even in error cases, we expect the backend endpoint to return a 200
            if (!res.ok) {
                dispatch($ed03e544a2cec734$export$bf1ddd88318577cc('unknown'));
                return;
            }
            // The types on the FE define the response to always be under `createAccount` for this endpoint
            // but in practice the BE returns in some cases (i.e. success) in a different format
            // so we want to handle that
            const redirectTo = (response === null || response === void 0 ? void 0 : (_response_createAccount1 = response.createAccount) === null || _response_createAccount1 === void 0 ? void 0 : _response_createAccount1.redirectTo) || (response === null || response === void 0 ? void 0 : response.redirectTo);
            const hasRedirect = !!redirectTo;
            if (!hasRedirect) {
                // If we don't get a redirect URL from the BE _and_ we haven't been able to understand the error
                // we don't know where to send the user and there aren't enough details of the error (or they aren't in the expected format) so we are assuming the request failed.
                dispatch($ed03e544a2cec734$export$bf1ddd88318577cc('unknown'));
                return;
            }
            dispatch($ed03e544a2cec734$export$1cb045489d712953(redirectTo));
        } catch (error) {
            dispatch($ed03e544a2cec734$export$bf1ddd88318577cc('unknown'));
        }
    };
const $ed03e544a2cec734$export$1b8c49d1a252ff84 = (mfaToken)=>(dispatch, getState)=>{
        const { csrfToken: csrfToken } = getState();
        return fetch(`/rest/mfa/resend?transactionToken=${mfaToken}`, {
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': csrfToken
            }
        }).then((res)=>{
            if (res.ok) return res.json().then((json)=>{
                dispatch($ed03e544a2cec734$export$4b98afed05a66101(json.transactionToken));
            });
            else return Promise.reject(new Error(`Failed to resend MFA code: ${res.status} ${res.statusText}`));
        });
    };

});


parcelRegister("fNi3o", function(module, exports) {

$parcel$export(module.exports, "CreateAccountConfirmationRecaptcha", function () { return $04fa9daf389b563d$export$4803e5c20b611abd; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $a5qoX = parcelRequire("a5qoX");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");

var $bEknK = parcelRequire("bEknK");
const $04fa9daf389b563d$export$4803e5c20b611abd = ()=>{
    (0, $4PGUW.useRegisterComponent)($04fa9daf389b563d$export$4803e5c20b611abd.name);
    const { enabled: recaptchaEnabled, component: recaptchaComponent } = (0, $a5qoX.useRecaptchaContext)();
    // TODO: confirm if server can tell this page to skip recaptcha by including a boolean flag in
    // the state, as it can for other pages (like Welcome)
    const shouldShow = recaptchaEnabled && recaptchaComponent;
    if (!shouldShow) return null;
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $bEknK.CreateAccountConfirmationRecaptchaContainer), {
        children: recaptchaComponent
    });
};

});
parcelRegister("bEknK", function(module, exports) {

$parcel$export(module.exports, "CreateAccountConfirmationRecaptchaContainer", function () { return $18d5662afd12642e$export$35fe2d48d1cfa8a6; });

var $9jjaN = parcelRequire("9jjaN");

var $g6OTd = parcelRequire("g6OTd");
let $18d5662afd12642e$var$_ = (t)=>t, $18d5662afd12642e$var$t;
const $18d5662afd12642e$export$35fe2d48d1cfa8a6 = (0, $9jjaN.default)((0, $g6OTd.default))($18d5662afd12642e$var$t || ($18d5662afd12642e$var$t = $18d5662afd12642e$var$_`
  .grecaptcha-badge {
    display: none;
  }
`));

});



parcelRegister("87AzW", function(module, exports) {

$parcel$export(module.exports, "Header", function () { return $f37ded5dbb7ed8c4$export$8b251419efc915eb; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");
const $f37ded5dbb7ed8c4$export$8b251419efc915eb = ({ createNeeded: createNeeded })=>{
    if (createNeeded) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
        id: "account.creation.confirmation.title",
        defaultMessage: "Create your account",
        description: "Title of form for creating an account",
        tagName: "h5"
    });
    else return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
        id: "account.verification.title",
        defaultMessage: "Verify your email",
        description: "Title of form for verifying an account",
        tagName: "h5"
    });
};

});

parcelRegister("d7eHS", function(module, exports) {

$parcel$export(module.exports, "TitleText", function () { return $5d48d85ca4eb510a$export$5c707c04c5c45fff; });
$parcel$export(module.exports, "LoginLinkWrapper", function () { return $5d48d85ca4eb510a$export$daf565b81da2dd58; });

var $9jjaN = parcelRequire("9jjaN");

var $6e88g = parcelRequire("6e88g");
let $5d48d85ca4eb510a$var$_ = (t)=>t, $5d48d85ca4eb510a$var$t, $5d48d85ca4eb510a$var$t1;
const $5d48d85ca4eb510a$export$5c707c04c5c45fff = (0, $9jjaN.default).div($5d48d85ca4eb510a$var$t || ($5d48d85ca4eb510a$var$t = $5d48d85ca4eb510a$var$_`
  margin-top: ${0}px;
  margin-bottom: 16px;
`), (0, $6e88g.gridSize)());
const $5d48d85ca4eb510a$export$daf565b81da2dd58 = (0, $9jjaN.default).div($5d48d85ca4eb510a$var$t1 || ($5d48d85ca4eb510a$var$t1 = $5d48d85ca4eb510a$var$_`
  margin-top: ${0};
`), ({ addTopMargin: addTopMargin })=>addTopMargin ? `${(0, $6e88g.gridSize)()}px` : 'initial');

});

parcelRegister("k0R1J", function(module, exports) {

$parcel$export(module.exports, "WhiteboxFooter", function () { return $40946f8707fea844$export$bad5896fb5d45c0b; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6d87w = parcelRequire("6d87w");

var $6T9dz = parcelRequire("6T9dz");

var $dBq8m = parcelRequire("dBq8m");

var $gtKO2 = parcelRequire("gtKO2");

var $7eeh4 = parcelRequire("7eeh4");

var $1V2cH = parcelRequire("1V2cH");

var $8cndj = parcelRequire("8cndj");

var $3Mnu4 = parcelRequire("3Mnu4");

var $d7eHS = parcelRequire("d7eHS");

var $64QTD = parcelRequire("64QTD");
const $40946f8707fea844$export$bad5896fb5d45c0b = ({ loginType: loginType, createNeeded: createNeeded, isEmbedded: isEmbedded, oidcContext: oidcContext, verifyNeeded: verifyNeeded })=>{
    const showLoginLink = createNeeded && !isEmbedded && !(0, $7eeh4.isOidcDisplayMode)(oidcContext, (0, $gtKO2.OidcDisplay).Signup);
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const handleOnLoginLinkClick = (0, $91i6m.useCallback)(async ()=>{
        const eventAttributes = {
            loginType: loginType,
            confirmationCreateAccountNeeded: createNeeded,
            confirmationVerifyEmailNeeded: verifyNeeded
        };
        await analyticsClient.linkClickedEvent((0, $3Mnu4.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID), 'alreadyHaveAccountCreateAccountIdp', eventAttributes);
    }, [
        loginType,
        createNeeded,
        verifyNeeded,
        analyticsClient
    ]);
    const { resendVerificationCode: resendVerificationCode } = (0, $8cndj.useRetryAccountCreation)();
    const stripAuth0StateToken = (0, $91i6m.useCallback)((search)=>{
        const params = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(search);
        delete params.state;
        return Object.keys(params).length ? '?' + (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).stringify(params) : '';
    }, []);
    // TODO: encapsulate in our hook, to ensure the auth0 state token is stripped?
    const loginLink = '/login' + stripAuth0StateToken(location.search);
    if (showLoginLink || verifyNeeded) return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
        children: [
            verifyNeeded && /*#__PURE__*/ (0, $4ZSso.jsx)("ul", {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $64QTD.default), {
                        id: "didnt-get-an-email-start-again",
                        spacing: "none",
                        className: "link-color-override",
                        onClick: resendVerificationCode,
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                            id: "accountcreationconfirmation.resend.verification.code",
                            defaultMessage: "Resend verification code",
                            description: "Link button to resend the verification code if the user did not receive an email"
                        })
                    })
                })
            }),
            showLoginLink && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $d7eHS.LoginLinkWrapper), {
                addTopMargin: verifyNeeded,
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6d87w.Link), {
                    id: "already-have-an-account",
                    to: loginLink,
                    onClick: handleOnLoginLinkClick,
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                        id: "accountcreationconfirmation.already.have.account.log.in",
                        defaultMessage: "Already have an Atlassian account? Log in"
                    })
                })
            })
        ]
    });
    return null;
};

});
parcelRegister("8cndj", function(module, exports) {

$parcel$export(module.exports, "useRetryAccountCreation", function () { return $33abb9f2c88a4966$export$1afab6e7aab1dd93; });

var $91i6m = parcelRequire("91i6m");

var $dpsxD = parcelRequire("dpsxD");

var $1V2cH = parcelRequire("1V2cH");

var $21Xgy = parcelRequire("21Xgy");

var $49Pnv = parcelRequire("49Pnv");

var $2aGBJ = parcelRequire("2aGBJ");
parcelRequire("26od7");
var $divIX = parcelRequire("divIX");

var $5QX6U = parcelRequire("5QX6U");

var $3Mnu4 = parcelRequire("3Mnu4");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");
const $33abb9f2c88a4966$export$1afab6e7aab1dd93 = ()=>{
    (0, $4PGUW.useRegisterComponent)($33abb9f2c88a4966$export$1afab6e7aab1dd93.name);
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const pageState = (0, $divIX.useCreateAccountConfirmationPageState)();
    const { createNeeded: createNeeded, verifyNeeded: verifyNeeded, loginType: loginType } = pageState;
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const dispatchAddFlag = (0, $91i6m.useCallback)((flag)=>dispatch((0, $21Xgy.addFlag)(flag.type, flag.title, flag.description)), [
        dispatch
    ]);
    const resendVerificationCode = async ()=>{
        analyticsClient.linkClickedEvent((0, $3Mnu4.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID), 'startAgainCreateAccountIdp', {
            loginType: loginType,
            confirmationCreateAccountNeeded: createNeeded,
            confirmationVerifyEmailNeeded: verifyNeeded
        });
        const { mfaToken: mfaToken } = pageState;
        if (!mfaToken) {
            (0, $49Pnv.captureErrorMessage)('MFA token missing');
            return;
        }
        await dispatch((0, $dpsxD.resendInHouseVerificationCode)(mfaToken));
        dispatchAddFlag({
            type: 'success',
            title: (0, $5QX6U.default).resendVerificationCodeSuccessTitle,
            description: (0, $5QX6U.default).resendVerificationCodeSuccessDesc
        });
    };
    return {
        resendVerificationCode: resendVerificationCode
    };
};

});
parcelRegister("5QX6U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be7fbfd215d8d507$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $be7fbfd215d8d507$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    resendVerificationCodeSuccessTitle: {
        id: 'account.creation.confirmation.email.sent.title',
        defaultMessage: 'Email sent'
    },
    resendVerificationCodeSuccessDesc: {
        id: 'account.creation.confirmation.email.sent.desc',
        defaultMessage: 'We sent you another verification code'
    },
    resendVerificationCodeFailureTitle: {
        id: 'account.creation.confirmation.email.error.title',
        defaultMessage: 'Error'
    },
    resendVerificationCodeFailureDesc: {
        id: 'account.creation.confirmation.email.error.body',
        defaultMessage: "We couldn\u2019t send the verification code. Please try again."
    }
});

});



parcelRegister("9ddwm", function(module, exports) {

$parcel$export(module.exports, "ConfirmationFormTitleText", function () { return $541c90b467c0ab87$export$4306c5e98031f4d1; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");

var $ccxRw = parcelRequire("ccxRw");
const $541c90b467c0ab87$export$4306c5e98031f4d1 = ({ loginType: loginType, createNeeded: createNeeded })=>{
    switch(loginType){
        case (0, $ccxRw.LoginType).GoogleButton:
        case (0, $ccxRw.LoginType).GoogleOneTap:
            if (createNeeded) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "account.creation.confirmation.explanation.google",
                defaultMessage: "We'll use your details from Google to create an account:"
            });
            else return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "account.verification.confirmation.explanation.google",
                defaultMessage: "To keep your account secure, please verify your login."
            });
        case (0, $ccxRw.LoginType).Apple:
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "account.creation.confirmation.explanation.apple",
                defaultMessage: "We'll use your details from Apple to create an account:"
            });
        case (0, $ccxRw.LoginType).Slack:
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "account.creation.confirmation.explanation.slack",
                defaultMessage: "We'll use your details from Slack to create an account for:",
                description: "Message shown to the user when they're creating an account using their Slack credentials"
            });
        case (0, $ccxRw.LoginType).Microsoft:
            if (createNeeded) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "account.creation.confirmation.explanation.microsoft",
                defaultMessage: "We'll use your details from Microsoft to create an account:"
            });
            else return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "account.verification.confirmation.explanation.microsoft",
                defaultMessage: "We were unable to verify the email associated with your Microsoft account, so let's do that now."
            });
        case (0, $ccxRw.LoginType).SSO:
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "account.creation.confirmation.explanation.sso",
                defaultMessage: "We'll use the details from your single sign-on provider to create an account. Contact your administrator if you want to change them."
            });
        default:
            return null;
    }
};

});


parcelRegister("7BePu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "signupVerifyEmailOtpLoader", function () { return $85741e4a5a151ea8$export$ee12460ca2fbd2d1; });
$parcel$export(module.exports, "VerifyEmailOtpPage", function () { return $85741e4a5a151ea8$export$a16cb21d1f9bc820; });
$parcel$export(module.exports, "default", function () { return $85741e4a5a151ea8$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");
parcelRequire("ekgdt");
var $WlmZo = parcelRequire("WlmZo");
var $aiCA5 = parcelRequire("aiCA5");
var $ik104 = parcelRequire("ik104");

var $9OWP7 = parcelRequire("9OWP7");

var $h3x7y = parcelRequire("h3x7y");

var $dJdEh = parcelRequire("dJdEh");

var $5e2bj = parcelRequire("5e2bj");

var $kpg9c = parcelRequire("kpg9c");

var $3f4xr = parcelRequire("3f4xr");
const $85741e4a5a151ea8$var$verifyEmailOtpErrorCodeMapping = {
    invalid_otp: 'invalid_otp',
    invalid_otp_length: 'invalid_otp_length',
    invalid_token: 'invalid_token',
    expired_token: 'expired_token',
    rate_limit_exceeded: 'rate_limited',
    internal_server_error: 'unexpected_error',
    unexpected_error: 'unexpected_error',
    'Too many requests. Please inspect Retry-After header.': 'rate_limited'
};
async function $85741e4a5a151ea8$export$ee12460ca2fbd2d1({ request: request }) {
    if (!await (0, $3f4xr.checkFeatureGateOnceInitialized)((0, $kpg9c.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $5e2bj.fetchPageState)('/rest/signup/verify-email/otp/state', request, {
        capabilities: [
            'capability-group--signup',
            'capability-name--verify-email'
        ]
    });
}
const $85741e4a5a151ea8$export$a16cb21d1f9bc820 = ()=>{
    const { onVerifyEmailOtp: onVerifyEmailOtp, onInvalidEmailOtpLength: onInvalidEmailOtpLength, isLoading: isLoading, error: error } = (0, $ik104.useVerifyEmailOtp)();
    const { onResendEmailOtp: onResendEmailOtp } = (0, $WlmZo.useResendEmailOtp)();
    const { state: state, isLoading: isStateLoading, error: pageStateError } = (0, $aiCA5.useSignupVerifyEmailOtpState)();
    if (isStateLoading) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9OWP7.default), {
        label: "Signup verify email OTP page loading"
    });
    else if (!state || pageStateError) throw new Error(`Page state loading unsuccessful. \nPage state error: ${pageStateError}`);
    const { email: email } = state;
    const verifyEmailOtpErrorCode = !(error === null || error === void 0 ? void 0 : error.errorCode) ? undefined : $85741e4a5a151ea8$var$verifyEmailOtpErrorCodeMapping[error === null || error === void 0 ? void 0 : error.errorCode] || 'unexpected_error';
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $h3x7y.VerifyEmailOtp), {
        pageId: (0, $dJdEh.VERIFY_EMAIL_OTP_PAGE_ID),
        flow: "sign-up",
        email: email,
        isLoading: isLoading,
        errorCode: verifyEmailOtpErrorCode,
        onVerifyEmailOtp: onVerifyEmailOtp,
        onResendEmailOtp: onResendEmailOtp,
        onInvalidEmailOtpLength: onInvalidEmailOtpLength
    });
};
var $85741e4a5a151ea8$export$2e2bcd8739ae039 = $85741e4a5a151ea8$export$a16cb21d1f9bc820;

});
parcelRegister("ekgdt", function(module, exports) {
$parcel$export(module.exports, "useVerifyEmailOtp", function () { return (parcelRequire("ik104")).useVerifyEmailOtp; });
$parcel$export(module.exports, "useResendEmailOtp", function () { return (parcelRequire("WlmZo")).useResendEmailOtp; });
$parcel$export(module.exports, "useSignupVerifyEmailOtpState", function () { return (parcelRequire("aiCA5")).useSignupVerifyEmailOtpState; });
parcelRequire("ik104");
parcelRequire("WlmZo");
parcelRequire("aiCA5");

});
parcelRegister("ik104", function(module, exports) {

$parcel$export(module.exports, "useVerifyEmailOtp", function () { return $2866f481e1fedce5$export$dbb09362ea05a8a7; });

var $91i6m = parcelRequire("91i6m");

var $2aGBJ = parcelRequire("2aGBJ");

var $1V2cH = parcelRequire("1V2cH");

var $6rMKc = parcelRequire("6rMKc");

var $leG06 = parcelRequire("leG06");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");

var $68lZ6 = parcelRequire("68lZ6");

var $dJdEh = parcelRequire("dJdEh");

var $9uXJ3 = parcelRequire("9uXJ3");
const $2866f481e1fedce5$var$verifyEmailOtpSelectorFn = (state)=>state.verifyEmailOtp;
const $2866f481e1fedce5$export$dbb09362ea05a8a7 = ({ onSubmit: onSubmit, onFailure: onFailure, onSuccess: onSuccess, autoRedirect: autoRedirect = true } = {})=>{
    (0, $4PGUW.useRegisterComponent)($2866f481e1fedce5$export$dbb09362ea05a8a7.name);
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const { redirectType: redirectType, error: errorCode, isLoading: isLoading, redirectTo: redirectTo } = (0, $2aGBJ.useAppSelector)($2866f481e1fedce5$var$verifyEmailOtpSelectorFn);
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    (0, $91i6m.useEffect)(()=>{
        if (redirectTo && autoRedirect) navigate(redirectTo);
    }, [
        autoRedirect,
        redirectTo,
        navigate
    ]);
    const trackSubmitEmailOtp = (0, $1V2cH.useFormSubmittedEvent)((0, $dJdEh.VERIFY_EMAIL_OTP_PAGE_ID), 'verifyEmailOtp', {
        signupType: redirectType,
        source: 'emailOtpScreen'
    });
    const trackSubmissionFailure = (0, $1V2cH.useFormSubmittedEvent)((0, $dJdEh.VERIFY_EMAIL_OTP_PAGE_ID), 'verifyEmailOtp', {
        signupType: redirectType,
        result: 'invalid_otp_length'
    });
    const onVerifyEmailOtp = (0, $91i6m.useCallback)((otp)=>{
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
        if (otp.length !== (0, $68lZ6.OTP_CODE_FULL_LENGTH)) {
            const error = 'invalid_otp_length';
            onFailure === null || onFailure === void 0 ? void 0 : onFailure();
            trackSubmissionFailure();
            dispatch((0, $6rMKc.verifyEmailOtpFailure)(error));
        } else {
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
            trackSubmitEmailOtp();
            dispatch((0, $6rMKc.verifyEmailOtp)(otp, (0, $dJdEh.VERIFY_EMAIL_OTP_PAGE_ID), analyticsClient));
        }
    }, [
        analyticsClient,
        dispatch,
        onFailure,
        onSubmit,
        onSuccess,
        trackSubmissionFailure,
        trackSubmitEmailOtp
    ]);
    const error = (0, $91i6m.useMemo)(()=>errorCode ? {
            errorCode: errorCode,
            errorMessage: $2866f481e1fedce5$var$otpErrorMessage(errorCode, formatMessage)
        } : undefined, [
        errorCode,
        formatMessage
    ]);
    return {
        onVerifyEmailOtp: onVerifyEmailOtp,
        onInvalidEmailOtpLength: trackSubmissionFailure,
        redirectTo: redirectTo,
        error: error,
        isLoading: isLoading
    };
};
const $2866f481e1fedce5$var$otpErrorMessage = (errorCode, formatMessage)=>{
    switch(errorCode){
        case 'invalid_otp_length':
            return formatMessage({
                id: 'validate.email.otp.error.otp_length',
                defaultMessage: 'Complete the verification code'
            });
        case 'invalid_otp':
            return formatMessage({
                id: 'validate.email.otp.error.invalid_otp',
                defaultMessage: 'Provided verification code is invalid'
            });
        case 'invalid_token':
            return formatMessage({
                id: 'validate.email.otp.error.invalid_token',
                defaultMessage: 'Invalid token'
            });
        case 'expired_token':
            return formatMessage({
                id: 'validate.email.otp.error.expired_token',
                defaultMessage: 'Token expired'
            });
        case 'internal_server_error':
            return formatMessage({
                id: 'validate.email.otp.error.internal_server_error',
                defaultMessage: 'Internal server error'
            });
        case 'rate_limit_exceeded':
        case 'Too many requests. Please inspect Retry-After header.':
            return formatMessage({
                id: 'validate.email.otp.error.rate_limit_exceeded',
                defaultMessage: 'Rate limit exceeded. Try again in a couple of minutes.'
            });
        case 'unexpected_error':
        default:
            return formatMessage({
                id: 'validate.email.otp.error.unexpected_error',
                defaultMessage: 'Unexpected error'
            });
    }
};

});
parcelRegister("6rMKc", function(module, exports) {

$parcel$export(module.exports, "verifyEmailOtpFailure", function () { return $ac86e3773431d0a0$export$3871df646f7b1bd; });
$parcel$export(module.exports, "verifyEmailOtpSetState", function () { return $ac86e3773431d0a0$export$993f69d6007872a4; });
$parcel$export(module.exports, "verifyEmailOtp", function () { return $ac86e3773431d0a0$export$f73803bb4b67b64c; });
$parcel$export(module.exports, "resendEmailOtp", function () { return $ac86e3773431d0a0$export$7738159be2c9b2bf; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $dBq8m = parcelRequire("dBq8m");

var $21Xgy = parcelRequire("21Xgy");

var $j5RJC = parcelRequire("j5RJC");

var $fYxRW = parcelRequire("fYxRW");

var $49Pnv = parcelRequire("49Pnv");
const $ac86e3773431d0a0$export$43047bab95c658dd = (redirectTo)=>({
        type: 'VERIFY_EMAIL_OTP_SUCCESS',
        redirectTo: redirectTo
    });
const $ac86e3773431d0a0$export$3871df646f7b1bd = (error)=>({
        type: 'VERIFY_EMAIL_OTP_FAILURE',
        error: error
    });
const $ac86e3773431d0a0$export$840a1b6b804c3952 = ()=>({
        type: 'VERIFY_EMAIL_OTP_REQUEST'
    });
const $ac86e3773431d0a0$export$993f69d6007872a4 = (state)=>({
        type: 'VERIFY_EMAIL_OTP_SET_STATE',
        state: state
    });
const $ac86e3773431d0a0$export$f73803bb4b67b64c = (otp, pageId, analyticsClient)=>async (dispatch, getState)=>{
        const { csrfToken: csrfToken, cobranding: { productHint: productHint }, verifyEmailOtp: { redirectType: redirectType } } = getState();
        const { token: token } = $dBq8m.parse(window.location.search);
        const params = (0, $fYxRW.cobrandingURLParams)(window.location, productHint);
        const payload = {
            otpCode: otp,
            token: token
        };
        dispatch($ac86e3773431d0a0$export$840a1b6b804c3952());
        return fetch('/rest/signup/verify-email/otp', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            },
            body: JSON.stringify(payload)
        }).then((response)=>response.json().then(({ error: error, token: token })=>{
                if (token) {
                    analyticsClient.trackingEvent({
                        page: pageId,
                        action: 'submitted',
                        subject: 'otp_submission',
                        attributes: {
                            result: 'success',
                            signupType: redirectType
                        }
                    });
                    const redirectToUrl = new URLSearchParams((0, $1Fos3._)({
                        token: token
                    }, params));
                    const redirectTo = `/signup/welcome?${redirectToUrl.toString()}`;
                    dispatch($ac86e3773431d0a0$export$43047bab95c658dd(redirectTo));
                } else {
                    const result = error || 'internal_server_error';
                    dispatch($ac86e3773431d0a0$export$3871df646f7b1bd(result));
                    (0, $49Pnv.captureTaggedException)(error, {
                        capabilities: [
                            'capability-group--signup',
                            'capability-name--verify-email'
                        ],
                        tags: {
                            otp: 'otp_submission'
                        }
                    });
                    analyticsClient.trackingEvent({
                        page: pageId,
                        action: 'submitted',
                        subject: 'otp_submission',
                        attributes: {
                            result: result,
                            signupType: redirectType
                        }
                    });
                }
            })).catch((err)=>{
            dispatch($ac86e3773431d0a0$export$3871df646f7b1bd('unexpected_error'));
            (0, $49Pnv.captureTaggedException)(err, {
                capabilities: [
                    'capability-group--signup',
                    'capability-name--verify-email'
                ],
                tags: {
                    otp: 'otp_submission'
                }
            });
            analyticsClient.trackingEvent({
                page: pageId,
                action: 'submitted',
                subject: 'otp_submission',
                attributes: {
                    result: 'unexpected_error',
                    signupType: redirectType
                }
            });
        });
    };
const $ac86e3773431d0a0$export$7738159be2c9b2bf = (pageId, analyticsClient, navigate)=>async (dispatch, getState)=>{
        const { csrfToken: csrfToken, cobranding: { productHint: productHint }, verifyEmailOtp: { redirectType: redirectType } } = getState();
        const { token: token } = $dBq8m.parse(window.location.search);
        const params = (0, $fYxRW.cobrandingURLParams)(window.location, productHint);
        const loginRedirectWithError = (error)=>{
            // @ts-expect-error URLSearchParams types aren't up to date
            const url = new URLSearchParams((0, $b2I6k._)((0, $1Fos3._)({}, params), {
                errorCode: error,
                prompt: true
            }));
            return url.toString();
        };
        const payload = {
            token: token
        };
        return fetch('/rest/signup/verify-email/otp/resend', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            },
            body: JSON.stringify(payload)
        }).then((response)=>response.json().then(({ error: error, token: token })=>{
                if (response.status === 200) {
                    const urlWithNewToken = new URLSearchParams((0, $1Fos3._)({
                        token: token
                    }, params));
                    analyticsClient.trackingEvent({
                        page: pageId,
                        action: 'link clicked',
                        subject: 'resend_otp',
                        attributes: {
                            result: 'success',
                            signupType: redirectType
                        }
                    });
                    dispatch((0, $21Xgy.addFlag)('success', $ac86e3773431d0a0$export$ca00cef23f46407b.resendEmailOtpSuccessTitle, $ac86e3773431d0a0$export$ca00cef23f46407b.resendEmailOtpSuccessBody));
                    return window.history.replaceState(window.history.state, '', `/signup/verify-email/otp?${urlWithNewToken.toString()}`);
                }
                if (response.status === 400) {
                    analyticsClient.trackingEvent({
                        page: pageId,
                        action: 'link clicked',
                        subject: 'resend_otp',
                        attributes: {
                            result: error,
                            signupType: redirectType
                        }
                    });
                    (0, $49Pnv.captureTaggedException)(error, {
                        capabilities: [
                            'capability-group--signup',
                            'capability-name--verify-email'
                        ],
                        tags: {
                            otp: 'resend_otp'
                        }
                    });
                    if (error === 'expired_token') return navigate(`/login?${loginRedirectWithError('verify.email.expired')}`);
                    else return navigate(`/login?${loginRedirectWithError('verify.email.error')}`);
                }
                if (response.status === 429) {
                    analyticsClient.trackingEvent({
                        page: pageId,
                        action: 'link clicked',
                        subject: 'resend_otp',
                        attributes: {
                            result: error,
                            signupType: redirectType
                        }
                    });
                    return dispatch((0, $21Xgy.addFlag)('error', $ac86e3773431d0a0$export$ca00cef23f46407b.emailSentFailFlagTitle, $ac86e3773431d0a0$export$ca00cef23f46407b.emailSentFailFlagBody));
                }
            }).catch((err)=>{
                analyticsClient.trackingEvent({
                    page: pageId,
                    action: 'link clicked',
                    subject: 'resend_otp',
                    attributes: {
                        result: 'unexpected_error',
                        signupType: redirectType
                    }
                });
                (0, $49Pnv.captureTaggedException)(err, {
                    capabilities: [
                        'capability-group--signup',
                        'capability-name--verify-email'
                    ],
                    tags: {
                        otp: 'resend_otp'
                    }
                });
                return navigate(`/login?${loginRedirectWithError('verify.email.error')}`);
            }));
    };
const $ac86e3773431d0a0$export$ca00cef23f46407b = (0, $j5RJC.defineMessages)({
    emailSentFailFlagTitle: {
        id: 'signup.verify-email.otp.resend.rate.limit.exceeded.title',
        description: 'Title of flag to show that the request for a new one time code failed due to a rate limit error',
        defaultMessage: 'Too many attempts.'
    },
    emailSentFailFlagBody: {
        id: 'signup.verify-email.otp.resend.rate.limit.exceeded.body',
        description: 'Body of flag to show that the request for a new one time code failed due to a rate limit error',
        defaultMessage: 'Try again later.'
    },
    resendEmailOtpSuccessTitle: {
        id: 'signup.verify-email.otp.resend.success.title',
        description: 'Title of flag to show that the request for a new one time code was successful',
        defaultMessage: 'Email sent with new code'
    },
    resendEmailOtpSuccessBody: {
        id: 'signup.verify-email.otp.resend.success.body',
        description: 'Body of flag to show that the request for a new one time code was successful',
        defaultMessage: 'Please check your inbox.'
    }
});

});

parcelRegister("dJdEh", function(module, exports) {

$parcel$export(module.exports, "VERIFY_EMAIL_OTP_PAGE_ID", function () { return $f6752e529d43dbb7$export$7a9d926185563d77; });
const $f6752e529d43dbb7$export$7a9d926185563d77 = 'emailOtpScreen';

});


parcelRegister("WlmZo", function(module, exports) {

$parcel$export(module.exports, "useResendEmailOtp", function () { return $95bece14e80e1cf7$export$43b5c30416b6c2b8; });

var $91i6m = parcelRequire("91i6m");

var $1V2cH = parcelRequire("1V2cH");

var $dJdEh = parcelRequire("dJdEh");

var $2aGBJ = parcelRequire("2aGBJ");

var $6rMKc = parcelRequire("6rMKc");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");

var $9uXJ3 = parcelRequire("9uXJ3");
const $95bece14e80e1cf7$export$43b5c30416b6c2b8 = ({ onResend: onResend } = {})=>{
    (0, $4PGUW.useRegisterComponent)($95bece14e80e1cf7$export$43b5c30416b6c2b8.name);
    const { redirectType: redirectType } = (0, $2aGBJ.useAppSelector)((state)=>state.verifyEmailOtp);
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const trackResendEmailOtp = (0, $1V2cH.useLinkClickedEvent)((0, $dJdEh.VERIFY_EMAIL_OTP_PAGE_ID), 'resentEmailOtp', {
        signupType: redirectType,
        source: 'emailOtpScreen'
    });
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    const onResendEmailOtp = (0, $91i6m.useCallback)(()=>{
        onResend === null || onResend === void 0 ? void 0 : onResend();
        trackResendEmailOtp();
        dispatch((0, $6rMKc.resendEmailOtp)((0, $dJdEh.VERIFY_EMAIL_OTP_PAGE_ID), analyticsClient, navigate));
    }, [
        onResend,
        trackResendEmailOtp,
        dispatch,
        analyticsClient,
        navigate
    ]);
    return {
        onResendEmailOtp: onResendEmailOtp
    };
};

});

parcelRegister("aiCA5", function(module, exports) {

$parcel$export(module.exports, "useSignupVerifyEmailOtpState", function () { return $49430f4746fb4890$export$2a002f6397be0f3; });

var $91i6m = parcelRequire("91i6m");

var $2aGBJ = parcelRequire("2aGBJ");

var $6cMFi = parcelRequire("6cMFi");

var $gz8Vs = parcelRequire("gz8Vs");

var $6rMKc = parcelRequire("6rMKc");

var $9uXJ3 = parcelRequire("9uXJ3");
const $49430f4746fb4890$var$usePreloadedState = ()=>{
    const { email: email } = (0, $2aGBJ.useAppSelector)((state)=>state.verifyEmailOtp);
    return {
        email: email
    };
};
const $49430f4746fb4890$export$2a002f6397be0f3 = ()=>{
    const noServerState = (0, $gz8Vs.isSasStateEndpointEnabled)() && (0, $6cMFi.default)();
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    const { state: stateFromApi, isLoading: isLoading, isError: isError, error: error } = (0, $gz8Vs.usePageState)('/signup/verify-email/otp/state', {
        enabled: noServerState
    });
    (0, $91i6m.useEffect)(()=>{
        if ((0, $gz8Vs.isPageStateResult)(stateFromApi)) dispatch((0, $6rMKc.verifyEmailOtpSetState)(stateFromApi));
    }, [
        dispatch,
        stateFromApi
    ]);
    const preloadedState = $49430f4746fb4890$var$usePreloadedState();
    if ((0, $gz8Vs.isRedirectResult)(stateFromApi)) {
        navigate(stateFromApi.uri);
        return {
            state: undefined,
            isLoading: true,
            isError: false
        };
    }
    if (noServerState) return {
        state: stateFromApi,
        isLoading: isLoading,
        isError: isError,
        error: error
    };
    return {
        state: preloadedState,
        isLoading: false,
        isError: false,
        error: error
    };
};

});



parcelRegister("fhmR4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "welcomeLoader", function () { return $58c81a26f74cd183$export$eaf9dac678ad1491; });
$parcel$export(module.exports, "WelcomePage", function () { return $58c81a26f74cd183$export$630ad10f0e1a953d; });
$parcel$export(module.exports, "default", function () { return $58c81a26f74cd183$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $leG06 = parcelRequire("leG06");

var $8KhCJ = parcelRequire("8KhCJ");

var $gtKO2 = parcelRequire("gtKO2");

var $j7UeI = parcelRequire("j7UeI");

var $gs2u7 = parcelRequire("gs2u7");

var $bEJyt = parcelRequire("bEJyt");
parcelRequire("7i3mf");
var $ejRjw = parcelRequire("ejRjw");
var $gZWGo = parcelRequire("gZWGo");
var $5kSlf = parcelRequire("5kSlf");
var $cUEmD = parcelRequire("cUEmD");

var $4272V = parcelRequire("4272V");
parcelRequire("3a10w");
var $frIrJ = parcelRequire("frIrJ");
parcelRequire("6r37m");
var $18sqi = parcelRequire("18sqi");
var $1s6X2 = parcelRequire("1s6X2");
var $joDRU = parcelRequire("joDRU");

var $4FkXL = parcelRequire("4FkXL");

var $1V2cH = parcelRequire("1V2cH");

var $9OWP7 = parcelRequire("9OWP7");

var $5e2bj = parcelRequire("5e2bj");

var $kpg9c = parcelRequire("kpg9c");

var $3f4xr = parcelRequire("3f4xr");
async function $58c81a26f74cd183$export$eaf9dac678ad1491({ request: request }) {
    if (!await (0, $3f4xr.checkFeatureGateOnceInitialized)((0, $kpg9c.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $5e2bj.fetchPageState)('/rest/signup/welcome/state', request, {
        capabilities: [
            'capability-group--signup',
            'capability-name--signup'
        ]
    });
}
const $58c81a26f74cd183$export$630ad10f0e1a953d = ()=>{
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const { state: state, isLoading: isStateLoading, error: pageStateError } = (0, $1s6X2.useWelcomeState)();
    const { isEmbedded: isEmbedded, displayName: displayName, error: error } = state || {};
    const { onWelcomeSubmit: onWelcomeSubmit } = (0, $joDRU.useWelcomeSubmission)();
    const onWelcomeClick = (0, $1V2cH.useButtonClickedEvent)((0, $4FkXL.WELCOME_PAGE_ID), 'welcomeSignup', {
        redirectType: state === null || state === void 0 ? void 0 : state.redirectType
    });
    const { handleAppleLogin: handleAppleLogin, handleGoogleLogin: handleGoogleLogin, handleMicrosoftLogin: handleMicrosoftLogin, handleSlackLogin: handleSlackLogin } = (0, $18sqi.useWelcomePageActions)();
    if (isStateLoading) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9OWP7.default), {
        label: "Signup verify email OTP page loading"
    });
    else if (!state || pageStateError) throw new Error(`Page state loading unsuccessful. \nPage state error: ${pageStateError}`);
    const { email: email, redirectType: redirectType, fieldErrors: fieldErrors, formError: formError, isLoading: isLoading } = state;
    if (error === (0, $gtKO2.WelcomeError).RateLimitExceeded) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $5kSlf.WelcomeRateLimitExceededError), {});
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $gs2u7.default), {
        pageId: (0, $4FkXL.WELCOME_PAGE_ID),
        header: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $frIrJ.WelcomeHeader), {}),
        footer: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $bEJyt.FooterLogoWrapper), {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cUEmD.WelcomeRecaptchaNotice), {})
        }),
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8KhCJ.default), {
                title: formatMessage((0, $4272V.default).subheadingResumeSignup)
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $ejRjw.WelcomeForm), {
                redirectType: redirectType,
                fieldErrors: fieldErrors,
                formError: formError,
                isLoading: isLoading,
                onSubmit: onWelcomeSubmit,
                onWelcomeClick: onWelcomeClick,
                email: email,
                displayName: displayName,
                privacyPolicy: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gZWGo.WelcomePrivacyPolicy), {})
            }),
            isEmbedded ? null : redirectType === (0, $gtKO2.RedirectType).Migration && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $j7UeI.default), {
                handleGoogleLogin: handleGoogleLogin,
                handleMicrosoftLogin: handleMicrosoftLogin,
                handleAppleLogin: handleAppleLogin,
                handleSlackLogin: handleSlackLogin
            })
        ]
    });
};
var $58c81a26f74cd183$export$2e2bcd8739ae039 = $58c81a26f74cd183$export$630ad10f0e1a953d;

});
parcelRegister("bEJyt", function(module, exports) {

$parcel$export(module.exports, "FooterLogoWrapper", function () { return $11364a2113562f22$export$648d5009980d0c69; });

var $9jjaN = parcelRequire("9jjaN");

var $6e88g = parcelRequire("6e88g");
let $11364a2113562f22$var$_ = (t)=>t, $11364a2113562f22$var$t;
const $11364a2113562f22$export$648d5009980d0c69 = (0, $9jjaN.default).div($11364a2113562f22$var$t || ($11364a2113562f22$var$t = $11364a2113562f22$var$_`
  margin-top: ${0}px;
`), (0, $6e88g.gridSize));

});

parcelRegister("7i3mf", function(module, exports) {
$parcel$export(module.exports, "emailRegex", function () { return (parcelRequire("ey3wc")).emailRegex; });
$parcel$export(module.exports, "WelcomeForm", function () { return (parcelRequire("ejRjw")).WelcomeForm; });
$parcel$export(module.exports, "WelcomeRateLimitExceededError", function () { return (parcelRequire("5kSlf")).WelcomeRateLimitExceededError; });
$parcel$export(module.exports, "WelcomePrivacyPolicy", function () { return (parcelRequire("gZWGo")).WelcomePrivacyPolicy; });
$parcel$export(module.exports, "WelcomeRecaptcha", function () { return (parcelRequire("gRTHB")).WelcomeRecaptcha; });
$parcel$export(module.exports, "WelcomeRecaptchaNotice", function () { return (parcelRequire("cUEmD")).WelcomeRecaptchaNotice; });
parcelRequire("a13nT");
parcelRequire("fTzH6");
parcelRequire("5wPFe");
parcelRequire("4Iodf");

});
parcelRegister("a13nT", function(module, exports) {
$parcel$export(module.exports, "WelcomeForm", function () { return (parcelRequire("ejRjw")).WelcomeForm; });
$parcel$export(module.exports, "emailRegex", function () { return (parcelRequire("ey3wc")).emailRegex; });
parcelRequire("ejRjw");
parcelRequire("ey3wc");

});
parcelRegister("ejRjw", function(module, exports) {

$parcel$export(module.exports, "WelcomeForm", function () { return $b0d2833e6fb32986$export$aed3bcf545666c02; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");
parcelRequire("4yqqx");
var $9kmG5 = parcelRequire("9kmG5");

var $gFwNN = parcelRequire("gFwNN");

var $31nHY = parcelRequire("31nHY");

var $h89s9 = parcelRequire("h89s9");

var $c1txK = parcelRequire("c1txK");

var $cLysE = parcelRequire("cLysE");

var $hxiEh = parcelRequire("hxiEh");

var $h0sk5 = parcelRequire("h0sk5");
parcelRequire("5aAJC");
var $7oZFd = parcelRequire("7oZFd");
var $fWdJO = parcelRequire("fWdJO");
parcelRequire("bv7jZ");
var $8MXtH = parcelRequire("8MXtH");
parcelRequire("4Iodf");
var $gRTHB = parcelRequire("gRTHB");

var $brCu8 = parcelRequire("brCu8");
const $b0d2833e6fb32986$export$aed3bcf545666c02 = ({ displayName: displayName, email: email, fieldErrors: fieldErrors, formError: formError, isLoading: isLoading, onSubmit: onSubmit, onWelcomeClick: onWelcomeClick, privacyPolicy: privacyPolicy, redirectType: redirectType })=>{
    const intl = (0, $leG06.default)();
    const [fullName, setFullName] = (0, $91i6m.useState)(()=>displayName || '');
    const [password, setPassword] = (0, $91i6m.useState)('');
    const displayNameInputRef = (0, $91i6m.useRef)(null);
    const passwordInputRef = (0, $91i6m.useRef)(null);
    const fieldErrorPassword = (0, $brCu8.useTranslateFormErrorIfAvailable)(fieldErrors.password);
    const fieldErrorDisplayName = (0, $brCu8.useTranslateFormErrorIfAvailable)(fieldErrors.displayName);
    (0, $91i6m.useEffect)(()=>{
        var _displayNameInputRef_current, _passwordInputRef_current;
        const { displayName: displayName, emailUsedAsName: emailUsedAsName, passwordUsedAsName: passwordUsedAsName } = fieldErrors;
        const displayNameError = displayName || emailUsedAsName || passwordUsedAsName;
        const passwordError = fieldErrors.password;
        if (displayNameError) (_displayNameInputRef_current = displayNameInputRef.current) === null || _displayNameInputRef_current === void 0 ? void 0 : _displayNameInputRef_current.focus();
        else if (passwordError) (_passwordInputRef_current = passwordInputRef.current) === null || _passwordInputRef_current === void 0 ? void 0 : _passwordInputRef_current.focus();
    }, [
        fieldErrors
    ]);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (isLoading) return;
        await onSubmit({
            displayName: fullName,
            password: password
        });
    };
    return /*#__PURE__*/ (0, $4ZSso.jsxs)("div", {
        children: [
            formError && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $31nHY.default), {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $fWdJO.WelcomeFormErrors), {
                    error: formError
                })
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $hxiEh.StyledForm), {
                onSubmit: handleSubmit,
                children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $4ZSso.jsxs)("form", (0, $b2I6k._)((0, $1Fos3._)({}, formProps), {
                        id: "form-sign-up",
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $7oZFd.EmailVerified), {
                                email: email,
                                redirectType: redirectType,
                                iconLabel: intl.formatMessage((0, $h0sk5.default).emailAddressVerifiedLabel)
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gFwNN.default), {
                                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $h89s9.default), {
                                    testId: "displayName" // used in pollinators
                                    ,
                                    name: "displayName",
                                    autoComplete: 'name',
                                    placeholder: intl.formatMessage((0, $h0sk5.default).displayNamePlaceholder),
                                    label: intl.formatMessage((0, $h0sk5.default).fullNameLabel),
                                    autoFocus: !!email && !displayName,
                                    isLabelHidden: false,
                                    isInvalid: !!fieldErrorDisplayName || !!fieldErrors.emailUsedAsName || !!fieldErrors.passwordUsedAsName,
                                    invalidMessage: fieldErrorDisplayName || fieldErrors.emailUsedAsName || fieldErrors.passwordUsedAsName,
                                    onChange: (e)=>setFullName(e.currentTarget.value),
                                    value: fullName,
                                    ref: displayNameInputRef
                                })
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $hxiEh.PasswordFieldGroup), {
                                children: [
                                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $c1txK.default), {
                                        testId: "password" // used in pollinators
                                        ,
                                        name: "password",
                                        autoComplete: "new-password",
                                        "aria-describedby": (0, $9kmG5.passwordStrengthMessageId),
                                        placeholder: intl.formatMessage((0, $h0sk5.default).passwordPlaceholder),
                                        label: intl.formatMessage((0, $h0sk5.default).passwordLabelNew),
                                        autoFocus: !!email && !!displayName,
                                        isLabelHidden: false,
                                        isInvalid: !!fieldErrorPassword,
                                        invalidMessage: fieldErrorPassword,
                                        onChange: (e)=>setPassword(e.currentTarget.value),
                                        value: password,
                                        ref: passwordInputRef
                                    }),
                                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9kmG5.PasswordStrengthMeter), {
                                        password: password,
                                        email: email,
                                        displayName: fullName,
                                        "data-testid": "password-strength-meter"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8MXtH.WelcomeMarketingConsent), {}),
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $hxiEh.PrivacyPolicyContainer), {
                                children: privacyPolicy
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gRTHB.WelcomeRecaptcha), {}),
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $hxiEh.WelcomeButtonWrapper), {
                                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                                    appearance: "primary",
                                    type: "submit",
                                    isFullWidth: true,
                                    id: "signup-submit",
                                    isLoading: isLoading,
                                    onClick: onWelcomeClick,
                                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                                        id: "welcome.form.submit.continue",
                                        defaultMessage: "Continue"
                                    })
                                })
                            })
                        ]
                    }))
            })
        ]
    });
};

});
parcelRegister("4yqqx", function(module, exports) {
$parcel$export(module.exports, "passwordStrengthMessageId", function () { return (parcelRequire("9kmG5")).passwordStrengthMessageId; });
$parcel$export(module.exports, "PasswordStrengthMeter", function () { return (parcelRequire("9kmG5")).PasswordStrengthMeter; });
$parcel$export(module.exports, "PasswordStrengthMeterExperimental", function () { return (parcelRequire("a0q8V")).PasswordStrengthMeterExperimental; });
parcelRequire("9kmG5");
parcelRequire("a0q8V");

});
parcelRegister("a0q8V", function(module, exports) {

$parcel$export(module.exports, "PasswordStrengthMeterExperimental", function () { return $37715c241a692e74$export$f3f4fe3da2813049; });
/* PasswordStrengthMeterExperimental.tsx generated by @compiled/babel-plugin v0.37.0 */ /* eslint-disable react/no-unknown-property */ 
var $4ZSso = parcelRequire("4ZSso");

var $9gzWK = parcelRequire("9gzWK");
var $5oJNc = parcelRequire("5oJNc");

var $91i6m = parcelRequire("91i6m");

var $9jjaN = parcelRequire("9jjaN");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");

var $eyI0A = parcelRequire("eyI0A");

var $leG06 = parcelRequire("leG06");

var $ikuma = parcelRequire("ikuma");
let $37715c241a692e74$var$_ = (t)=>t, $37715c241a692e74$var$t, $37715c241a692e74$var$t1;
const $37715c241a692e74$var$barWidths = [
    '0%',
    '20%',
    '40%',
    '60%',
    '80%',
    '100%'
];
const $37715c241a692e74$var$Wrapper = (0, $9jjaN.default).div($37715c241a692e74$var$t || ($37715c241a692e74$var$t = $37715c241a692e74$var$_`
  margin-bottom: ${0}px;
  padding-inline: 10px;
`), (0, $6e88g.gridSize)());
const $37715c241a692e74$var$Bar = (0, $9jjaN.default).div($37715c241a692e74$var$t1 || ($37715c241a692e74$var$t1 = $37715c241a692e74$var$_`
  background: ${0};
  height: 4px;
  margin-top: 8px;
  margin-bottom: 4px;
  position: relative;
  border-radius: 2px;

  &::before {
    background: ${0};
    bottom: 0;
    content: '';
    left: 0;
    border-radius: 2px;
    position: absolute;
    top: 0;
    transition: all 0.2s ease-out;
    width: ${0};
  }
`), (0, $kLNLK).N40, (props)=>props.score === null ? (0, $kLNLK).N40 : $37715c241a692e74$var$barColours[props.score], (props)=>props.score === null ? 0 : $37715c241a692e74$var$barWidths[props.score]);
const $37715c241a692e74$var$barColours = [
    (0, $kLNLK).N40,
    "var(--ds-text-accent-red, #AE2E24)",
    // Weak
    '#FFC716',
    // Fair
    '#94C748',
    // Good
    '#6A9A23',
    // Strong
    '#678933' // Very strong
];
const $37715c241a692e74$var$hintStyles = null;
const $37715c241a692e74$var$errorStyle = null;
const $37715c241a692e74$var$Hint = ({ score: score, errorText: errorText, strengthText: strengthText })=>{
    const styleAsError = !!errorText || score === 1;
    const textToDisplay = errorText || strengthText;
    return textToDisplay ? /*#__PURE__*/ (0, $4ZSso.jsx)("p", {
        className: (0, $9gzWK.default)([
            "_syaz1k2n _1wyb1crf _4t3i7vkz _19pk1y44 _kqswh2mm _ect418aq",
            styleAsError && "_syaz166f"
        ]),
        style: {
            "--_w5zcw3": (0, $5oJNc.default)((0, $kLNLK).N90)
        },
        children: textToDisplay
    }) : null;
};
const $37715c241a692e74$var$Container = (props)=>{
    return /*#__PURE__*/ (0, $4ZSso.jsxs)($37715c241a692e74$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)($37715c241a692e74$var$Bar, {
                score: props.score
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
                role: "status",
                children: /*#__PURE__*/ (0, $4ZSso.jsx)($37715c241a692e74$var$Hint, {
                    score: props.score || 0,
                    errorText: props.errorText,
                    strengthText: props.strengthText
                })
            })
        ]
    });
};
const $37715c241a692e74$export$f3f4fe3da2813049 = ({ displayName: displayName, email: email, i18nLevels: i18nLevels, i18nNoValue: i18nNoValue, i18nNoZxcvbn: i18nNoZxcvbn, password: password, errorText: errorText, passwordSelected: passwordSelected })=>{
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const strengthLevelMessages = (0, $91i6m.useMemo)(()=>i18nLevels || [
            (0, $eyI0A.default).passwordStrengthMinimumRequirement,
            (0, $eyI0A.default).weakPasswordAdvice,
            (0, $eyI0A.default).fairPassword,
            (0, $eyI0A.default).goodPassword,
            (0, $eyI0A.default).strongPassword,
            (0, $eyI0A.default).veryStrongPassword
        ].map((message)=>formatMessage(message)), [
        formatMessage,
        i18nLevels
    ]);
    const noValueMessage = i18nNoValue || '';
    const noZxcvbnMessage = i18nNoZxcvbn || formatMessage((0, $eyI0A.default).passwordStrengthUnavailable);
    const { score: score } = (0, $ikuma.usePasswordScore)({
        displayName: displayName,
        email: email,
        password: password
    });
    const getStrengthText = ()=>{
        if (!password && !passwordSelected) return noValueMessage;
        return typeof score === 'number' ? strengthLevelMessages[score] : noZxcvbnMessage;
    };
    return /*#__PURE__*/ (0, $4ZSso.jsx)($37715c241a692e74$var$Container, {
        errorText: errorText,
        strengthText: getStrengthText(),
        score: score
    });
};

});


parcelRegister("hxiEh", function(module, exports) {

$parcel$export(module.exports, "PrivacyPolicyContainer", function () { return $206761d9bc0d5aa1$export$6b077d087ec15a10; });
$parcel$export(module.exports, "PasswordFieldGroup", function () { return $206761d9bc0d5aa1$export$fc9115768a73fd6d; });
$parcel$export(module.exports, "WelcomeButtonWrapper", function () { return $206761d9bc0d5aa1$export$610e57aac9703b0f; });
$parcel$export(module.exports, "StyledForm", function () { return $206761d9bc0d5aa1$export$71655785c758526a; });

var $9jjaN = parcelRequire("9jjaN");

var $6e88g = parcelRequire("6e88g");

var $47Bqn = parcelRequire("47Bqn");

var $gFwNN = parcelRequire("gFwNN");
let $206761d9bc0d5aa1$var$_ = (t)=>t, $206761d9bc0d5aa1$var$t, $206761d9bc0d5aa1$var$t1, $206761d9bc0d5aa1$var$t2, $206761d9bc0d5aa1$var$t3, $206761d9bc0d5aa1$var$t4;
const $206761d9bc0d5aa1$export$6b077d087ec15a10 = (0, $9jjaN.default).div($206761d9bc0d5aa1$var$t || ($206761d9bc0d5aa1$var$t = $206761d9bc0d5aa1$var$_`
  margin-top: ${0}px;
  text-align: left;
  margin-left: 6px;
`), (0, $6e88g.gridSize)());
const $206761d9bc0d5aa1$export$fc9115768a73fd6d = (0, $9jjaN.default)((0, $gFwNN.default))($206761d9bc0d5aa1$var$t1 || ($206761d9bc0d5aa1$var$t1 = $206761d9bc0d5aa1$var$_`
  padding-top: ${0};
`), ({ isHidden: isHidden })=>isHidden ? `${(0, $6e88g.gridSize)() * 2}px` : 0);
const $206761d9bc0d5aa1$export$610e57aac9703b0f = (0, $9jjaN.default).div($206761d9bc0d5aa1$var$t2 || ($206761d9bc0d5aa1$var$t2 = $206761d9bc0d5aa1$var$_`
  margin-top: ${0}px;
`), (0, $6e88g.gridSize)());
const $206761d9bc0d5aa1$export$585a3b23e887288b = (0, $9jjaN.default).div($206761d9bc0d5aa1$var$t3 || ($206761d9bc0d5aa1$var$t3 = $206761d9bc0d5aa1$var$_`
  text-align: center;
  padding-top: 4px;
`));
const $206761d9bc0d5aa1$export$71655785c758526a = (0, $9jjaN.default)((0, $47Bqn.default))($206761d9bc0d5aa1$var$t4 || ($206761d9bc0d5aa1$var$t4 = $206761d9bc0d5aa1$var$_`
  margin: 0;
`));

});

parcelRegister("h0sk5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab5533c31d752205$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $ab5533c31d752205$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    displayNamePlaceholder: {
        id: 'signup.form.displayName.placeholder',
        defaultMessage: 'Enter full name'
    },
    fullNameLabel: {
        id: 'signup.form.fullName.label',
        defaultMessage: 'Full name'
    },
    emailAddressVerifiedLabel: {
        id: 'welcome.form.email.address.verified.label',
        defaultMessage: 'Verified'
    },
    passwordPlaceholder: {
        id: 'signup.form.password.placeholder',
        defaultMessage: 'Create password'
    },
    passwordLabelNew: {
        id: 'signup.form.password.label.new',
        defaultMessage: 'Password'
    }
});

});

parcelRegister("5aAJC", function(module, exports) {
$parcel$export(module.exports, "EmailVerified", function () { return (parcelRequire("7oZFd")).EmailVerified; });
$parcel$export(module.exports, "WelcomeFormErrors", function () { return (parcelRequire("fWdJO")).WelcomeFormErrors; });
$parcel$export(module.exports, "WelcomeFormErrorsExperimental", function () { return (parcelRequire("kNVeQ")).WelcomeFormErrorsExperimental; });
parcelRequire("7XLFW");
parcelRequire("k9uqq");

});
parcelRegister("7XLFW", function(module, exports) {
$parcel$export(module.exports, "EmailVerified", function () { return (parcelRequire("7oZFd")).EmailVerified; });
parcelRequire("7oZFd");

});
parcelRegister("7oZFd", function(module, exports) {

$parcel$export(module.exports, "EmailVerified", function () { return $b4d8b02a5c370c6b$export$320c6c46c464dd37; });

var $1Fos3 = parcelRequire("1Fos3");

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $4xOBh = parcelRequire("4xOBh");

var $1pjMo = parcelRequire("1pjMo");

var $gtKO2 = parcelRequire("gtKO2");

var $es9jg = parcelRequire("es9jg");

var $hJG52 = parcelRequire("hJG52");

var $6T9dz = parcelRequire("6T9dz");
const $b4d8b02a5c370c6b$export$320c6c46c464dd37 = ({ email: email, iconLabel: iconLabel, redirectType: redirectType })=>{
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $es9jg.VerifiedEmailWrapper), {
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4xOBh.Label), {
                htmlFor: "email-verified",
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $hJG52.default).emailAddressLabel)),
                    redirectType !== (0, $gtKO2.RedirectType).Signup && redirectType !== (0, $gtKO2.RedirectType).ResumeSignup && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $es9jg.VerifiedIconWrapper), {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1pjMo))), {
                            label: iconLabel,
                            size: "small"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $es9jg.BoldEmailWrapper), {
                id: "email-verified",
                children: email
            })
        ]
    });
};

});
parcelRegister("es9jg", function(module, exports) {

$parcel$export(module.exports, "VerifiedEmailWrapper", function () { return $8e8807700c15d4bc$export$6b03a82aa573dee0; });
$parcel$export(module.exports, "BoldEmailWrapper", function () { return $8e8807700c15d4bc$export$33307c8166f2d281; });
$parcel$export(module.exports, "VerifiedIconWrapper", function () { return $8e8807700c15d4bc$export$caa84cc45eb72ca8; });

var $9jjaN = parcelRequire("9jjaN");

var $kLNLK = parcelRequire("kLNLK");
let $8e8807700c15d4bc$var$_ = (t)=>t, $8e8807700c15d4bc$var$t, $8e8807700c15d4bc$var$t1, $8e8807700c15d4bc$var$t2;
const $8e8807700c15d4bc$export$6b03a82aa573dee0 = (0, $9jjaN.default).div($8e8807700c15d4bc$var$t || ($8e8807700c15d4bc$var$t = $8e8807700c15d4bc$var$_`
  margin-top: 10px;
  color: ${0};
`), (0, $kLNLK).N800);
const $8e8807700c15d4bc$export$33307c8166f2d281 = (0, $9jjaN.default).p($8e8807700c15d4bc$var$t1 || ($8e8807700c15d4bc$var$t1 = $8e8807700c15d4bc$var$_`
  font-weight: bold;
  overflow-wrap: break-word;
  margin: 0;
`));
const $8e8807700c15d4bc$export$caa84cc45eb72ca8 = (0, $9jjaN.default).span($8e8807700c15d4bc$var$t2 || ($8e8807700c15d4bc$var$t2 = $8e8807700c15d4bc$var$_`
  padding: 0 4px;
  color: ${0};
`), (0, $kLNLK).G400);

});

parcelRegister("hJG52", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e526d52e061a67e$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $7e526d52e061a67e$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    emailAddressLabel: {
        id: 'welcome.form.email.verified.label',
        defaultMessage: 'Email address'
    }
});

});



parcelRegister("k9uqq", function(module, exports) {
$parcel$export(module.exports, "WelcomeFormErrors", function () { return (parcelRequire("fWdJO")).WelcomeFormErrors; });
$parcel$export(module.exports, "WelcomeFormErrorsExperimental", function () { return (parcelRequire("kNVeQ")).WelcomeFormErrorsExperimental; });
parcelRequire("fWdJO");
parcelRequire("kNVeQ");

});
parcelRegister("fWdJO", function(module, exports) {

$parcel$export(module.exports, "WelcomeFormErrors", function () { return $6cf2dabad44937b2$export$647bfbe5c6b51f7d; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");

var $bE8z6 = parcelRequire("bE8z6");

var $iWUGx = parcelRequire("iWUGx");
const $6cf2dabad44937b2$export$647bfbe5c6b51f7d = ({ error: error })=>{
    switch(error){
        case 'unknown':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "welcome.error.unknown",
                defaultMessage: "Something went wrong while attempting to sign up. Please try again."
            });
        case 'captcha':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "welcome.error.captcha",
                defaultMessage: "We are having trouble verifying reCAPTCHA for this request. Please try again. If the problem persists, try another browser/device or reach out to Atlassian Support."
            });
        case 'captchaScoreTooLow':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "welcome.error.captcha.score_too_low",
                defaultMessage: "We'd like to make sure it's really you creating your account. Please confirm you're not a robot.",
                description: "Message asking user to tick the reCAPTCHA checkbox and resubmit the form"
            });
        case 'request_error':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "welcome.error.request_error",
                defaultMessage: "Unable to connect. Check your internet connection or the network settings for your browser and try again."
            });
        case 'passwordLeaked':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $b2I6k._)((0, $1Fos3._)({}, (0, $iWUGx.default).passwordLeakedXML), {
                tagName: "p",
                values: {
                    'password-leaked-link': (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("a", {
                            href: (0, $bE8z6.PASSWORD_LEAKED_LINK),
                            children: chunks
                        })
                }
            }));
        case 'passwordCommon':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "welcome.error.passwordCommon",
                defaultMessage: "This password is too widely used. Choose a password that's harder to guess."
            });
        case 'invalidPassword':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "welcome.error.invalidPassword",
                defaultMessage: "Invalid password"
            });
        case 'passwordCaseError':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "welcome.error.passwordCaseError",
                defaultMessage: "Your password must contain at least one uppercase and one lowercase letter."
            });
        case 'passwordDigitOrSpecialError':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "welcome.error.passwordDigitOrSpecialError",
                defaultMessage: "Your password must contain at least one digit or special character."
            });
        case 'passwordLengthError':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "welcome.error.passwordLengthError",
                defaultMessage: "Your password must be between 8 and 72 characters long."
            });
        case 'passwordUsedBefore':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "welcome.error.passwordUsedBefore",
                defaultMessage: "You've used that password before. Please choose a different one."
            });
        case 'usernameMustBeEmail':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "welcome.error.usernameMustBeEmail",
                defaultMessage: "Your account username must be a valid email address."
            });
        case 'passwordStrengthErrorWeak':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "welcome.error.passwordStrengthErrorWeak",
                defaultMessage: "Your password must have a minimum strength of weak."
            });
        case 'passwordStrengthErrorFair':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "welcome.error.passwordStrengthErrorFair",
                defaultMessage: "Your password must have a minimum strength of fair."
            });
        case 'passwordStrengthErrorGood':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "welcome.error.passwordStrengthErrorGood",
                defaultMessage: "Your password must have a minimum strength of good."
            });
        case 'passwordStrengthErrorStrong':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "welcome.error.passwordStrengthErrorStrong",
                defaultMessage: "Your password must have a minimum strength of strong."
            });
        case 'passwordStrengthErrorVeryStrong':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "welcome.error.passwordStrengthErrorVeryStrong",
                defaultMessage: "Your password must have a minimum strength of very strong."
            });
        default:
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "welcome.form.random.error",
                defaultMessage: "An error occurred while attempting to sign up: {error}. Please try again or reach out to Atlassian Support.",
                values: {
                    error: error
                }
            });
    }
};

});
parcelRegister("iWUGx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecfc947ac9be5ccb$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $ecfc947ac9be5ccb$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    passwordLeakedXML: {
        id: 'signup.form.password.leaked.xml',
        defaultMessage: 'This password has appeared in an external data breach. To continue, enter another password. <password-leaked-link>Learn more</password-leaked-link>'
    }
});

});


parcelRegister("kNVeQ", function(module, exports) {

$parcel$export(module.exports, "WelcomeFormErrorsExperimental", function () { return $e6078ad05df97be1$export$f51e84a78cbc2d9b; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $j5RJC = parcelRequire("j5RJC");
var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $bE8z6 = parcelRequire("bE8z6");

var $iWUGx = parcelRequire("iWUGx");
const $e6078ad05df97be1$var$invalidPasswordTradukiDescription = 'Reason why a password is invalid';
const $e6078ad05df97be1$var$errorWithAdvice = (0, $j5RJC.defineMessage)({
    id: 'welcome.error.adviceWrapper',
    defaultMessage: '{errorDescriptionSentence} Avoid common phrases and predictable sequences, and use a mix of characters.',
    description: 'Error describing why a password is invalid, followed by advice on how to fix it'
});
const $e6078ad05df97be1$export$f51e84a78cbc2d9b = ({ error: error, hintError: hintError })=>{
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const withAdvice = (errorDescriptionSentence)=>/*#__PURE__*/ (0, $4ZSso.jsx)((0, $4ZSso.Fragment), {
            children: formatMessage($e6078ad05df97be1$var$errorWithAdvice, {
                errorDescriptionSentence: errorDescriptionSentence
            })
        });
    const welcomeError = hintError !== null && hintError !== void 0 ? hintError : error;
    switch(welcomeError){
        case 'passwordStrengthCantMatchDisplayName':
        case 'passwordMatchesDisplayNameError':
            return withAdvice(formatMessage({
                id: 'welcome.error.passwordMatchesDisplayName',
                defaultMessage: "Your password can't match your <strong>display name</strong>.",
                description: $e6078ad05df97be1$var$invalidPasswordTradukiDescription
            }, {
                strong: (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("strong", {
                        children: chunks
                    })
            }));
        case 'passwordStrengthCantMatchAtlassianKeyword':
        case 'passwordMatchesAtlassianKeywordError':
            return withAdvice(formatMessage({
                id: 'welcome.error.passwordMatchesAtlassianKeyword',
                defaultMessage: "Your password can't match an <strong>Atlassian keyword</strong>.",
                description: $e6078ad05df97be1$var$invalidPasswordTradukiDescription
            }, {
                strong: (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("strong", {
                        children: chunks
                    })
            }));
        case 'passwordStrengthCantMatchEmail':
        case 'passwordMatchesEmailError':
            return withAdvice(formatMessage({
                id: 'welcome.error.passwordMatchesEmail',
                defaultMessage: "Your password can't match your <strong>email address</strong>.",
                description: $e6078ad05df97be1$var$invalidPasswordTradukiDescription
            }, {
                strong: (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("strong", {
                        children: chunks
                    })
            }));
        case 'unknown':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "welcome.error.unknown",
                defaultMessage: "Something went wrong while attempting to sign up. Please try again."
            });
        case 'captcha':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "welcome.error.captcha",
                defaultMessage: "We are having trouble verifying reCAPTCHA for this request. Please try again. If the problem persists, try another browser/device or reach out to Atlassian Support."
            });
        case 'captchaScoreTooLow':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "welcome.error.captcha.score_too_low",
                defaultMessage: "We'd like to make sure it's really you creating your account. Please confirm you're not a robot.",
                description: "Message asking user to tick the reCAPTCHA checkbox and resubmit the form"
            });
        case 'request_error':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "welcome.error.request_error",
                defaultMessage: "Unable to connect. Check your internet connection or the network settings for your browser and try again."
            });
        case 'passwordLeaked':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $b2I6k._)((0, $1Fos3._)({}, (0, $iWUGx.default).passwordLeakedXML), {
                tagName: "p",
                values: {
                    'password-leaked-link': (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("a", {
                            href: (0, $bE8z6.PASSWORD_LEAKED_LINK),
                            children: chunks
                        })
                }
            }));
        case 'passwordCommon':
            return withAdvice(formatMessage({
                id: 'welcome.error.passwordIsCommon',
                defaultMessage: 'This is a <strong>common password</strong>.',
                description: $e6078ad05df97be1$var$invalidPasswordTradukiDescription
            }, {
                strong: (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("strong", {
                        children: chunks
                    })
            }));
        case 'invalidPassword':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "welcome.error.invalidPassword",
                defaultMessage: "Invalid password"
            });
        case 'passwordCaseError':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "welcome.error.passwordCaseError",
                defaultMessage: "Your password must contain at least one uppercase and one lowercase letter."
            });
        case 'passwordDigitOrSpecialError':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "welcome.error.passwordDigitOrSpecialError",
                defaultMessage: "Your password must contain at least one digit or special character."
            });
        case 'passwordLengthError':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "welcome.error.passwordLengthError",
                defaultMessage: "Your password must be between 8 and 72 characters long."
            });
        case 'passwordUsedBefore':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "welcome.error.passwordUsedBefore",
                defaultMessage: "You've used that password before. Please choose a different one."
            });
        case 'usernameMustBeEmail':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "welcome.error.usernameMustBeEmail",
                defaultMessage: "Your account username must be a valid email address."
            });
        case 'passwordStrengthErrorWeak':
            return withAdvice(formatMessage({
                id: 'welcome.error.bold.passwordStrengthErrorWeak',
                defaultMessage: 'Your password must have a minimum strength of <strong>weak</strong>.'
            }, {
                strong: (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("strong", {
                        children: chunks
                    })
            }));
        case 'passwordStrengthErrorFair':
            return withAdvice(formatMessage({
                id: 'welcome.error.bold.passwordStrengthErrorFair',
                defaultMessage: 'Your password must have a minimum strength of <strong>fair</strong>.'
            }, {
                strong: (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("strong", {
                        children: chunks
                    })
            }));
        case 'passwordStrengthErrorGood':
            return withAdvice(formatMessage({
                id: 'welcome.error.bold.passwordStrengthErrorGood',
                defaultMessage: 'Your password must have a minimum strength of <strong>good</strong>.'
            }, {
                strong: (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("strong", {
                        children: chunks
                    })
            }));
        case 'passwordStrengthErrorStrong':
            return withAdvice(formatMessage({
                id: 'welcome.error.bold.passwordStrengthErrorStrong',
                defaultMessage: 'Your password must have a minimum strength of <strong>strong</strong>.'
            }, {
                strong: (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("strong", {
                        children: chunks
                    })
            }));
        case 'passwordStrengthErrorVeryStrong':
            return withAdvice(formatMessage({
                id: 'welcome.error.bold.passwordStrengthErrorVeryStrong',
                defaultMessage: 'Your password must have a minimum strength of <strong>very strong</strong>.'
            }, {
                strong: (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("strong", {
                        children: chunks
                    })
            }));
        default:
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                id: "welcome.form.random.error",
                defaultMessage: "An error occurred while attempting to sign up: {error}. Please try again or reach out to Atlassian Support.",
                values: {
                    error: error
                }
            });
    }
};

});



parcelRegister("bv7jZ", function(module, exports) {
$parcel$export(module.exports, "WelcomeMarketingConsent", function () { return (parcelRequire("8MXtH")).WelcomeMarketingConsent; });
parcelRequire("8MXtH");

});
parcelRegister("8MXtH", function(module, exports) {

$parcel$export(module.exports, "WelcomeMarketingConsent", function () { return $7c954513a5090552$export$2ba9993ec03b7ee5; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");
parcelRequire("y8xn8");
var $1aroD = parcelRequire("1aroD");

var $fxz8k = parcelRequire("fxz8k");

var $2aGBJ = parcelRequire("2aGBJ");

var $cRW6P = parcelRequire("cRW6P");
const $7c954513a5090552$var$marketingConsentSelector = (state)=>state.marketingConsent.config;
const $7c954513a5090552$var$welcomeEmailSelector = (state)=>state.welcome.email;
const $7c954513a5090552$export$2ba9993ec03b7ee5 = ()=>{
    (0, $4PGUW.useRegisterComponent)($7c954513a5090552$export$2ba9993ec03b7ee5.name);
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const { setMarketingConsent: setMarketingConsent } = (0, $1aroD.useWelcomePageContext)();
    const marketingConsentConfig = (0, $2aGBJ.useAppSelector)($7c954513a5090552$var$marketingConsentSelector);
    const email = (0, $2aGBJ.useAppSelector)($7c954513a5090552$var$welcomeEmailSelector);
    (0, $91i6m.useEffect)(()=>{
        if (email !== '') dispatch((0, $cRW6P.fetchConsentConfig)(email));
    }, [
        dispatch,
        email
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $fxz8k.default), {
        config: marketingConsentConfig,
        onConsentChange: setMarketingConsent
    });
};

});
parcelRegister("y8xn8", function(module, exports) {
$parcel$export(module.exports, "useWelcomePageContext", function () { return (parcelRequire("1aroD")).useWelcomePageContext; });
$parcel$export(module.exports, "WelcomePageProvider", function () { return (parcelRequire("1aroD")).WelcomePageProvider; });
parcelRequire("1aroD");

});
parcelRegister("1aroD", function(module, exports) {

$parcel$export(module.exports, "useWelcomePageContext", function () { return $a2145a634d28008a$export$417cf5d67969d32f; });
$parcel$export(module.exports, "WelcomePageProvider", function () { return $a2145a634d28008a$export$96494047c552bc09; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");
const $a2145a634d28008a$export$46030b7a3a8bf13f = /*#__PURE__*/ (0, $91i6m.createContext)(null);
const $a2145a634d28008a$export$417cf5d67969d32f = ()=>{
    const context = (0, $91i6m.useContext)($a2145a634d28008a$export$46030b7a3a8bf13f);
    if (!context) throw new Error('useWelcomePageContext must be used within a WelcomePageContextProvider');
    return context;
};
const $a2145a634d28008a$export$96494047c552bc09 = ({ children: children })=>{
    const [privacyPolicyText, setPrivacyPolicyText] = (0, $91i6m.useState)();
    const [marketingConsent, setMarketingConsent] = (0, $91i6m.useState)({
        state: 'not_shown'
    });
    const state = (0, $91i6m.useMemo)(()=>({
            privacyPolicyText: privacyPolicyText,
            setPrivacyPolicyText: setPrivacyPolicyText,
            marketingConsent: marketingConsent,
            setMarketingConsent: setMarketingConsent
        }), [
        marketingConsent,
        privacyPolicyText
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)($a2145a634d28008a$export$46030b7a3a8bf13f.Provider, {
        value: state,
        children: children
    });
};

});




parcelRegister("4Iodf", function(module, exports) {
$parcel$export(module.exports, "WelcomeRecaptcha", function () { return (parcelRequire("gRTHB")).WelcomeRecaptcha; });
$parcel$export(module.exports, "WelcomeRecaptchaNotice", function () { return (parcelRequire("cUEmD")).WelcomeRecaptchaNotice; });
parcelRequire("gRTHB");
parcelRequire("cUEmD");

});
parcelRegister("gRTHB", function(module, exports) {

$parcel$export(module.exports, "WelcomeRecaptcha", function () { return $b6feec8920b319b1$export$288894e7e6fbc9f; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");

var $a5qoX = parcelRequire("a5qoX");
parcelRequire("6r37m");
var $1s6X2 = parcelRequire("1s6X2");

var $C5uWN = parcelRequire("C5uWN");
const $b6feec8920b319b1$export$288894e7e6fbc9f = ()=>{
    (0, $4PGUW.useRegisterComponent)($b6feec8920b319b1$export$288894e7e6fbc9f.name);
    const { enabled: recaptchaEnabled, component: recaptchaComponent } = (0, $a5qoX.useRecaptchaContext)();
    const { state: state } = (0, $1s6X2.useWelcomeState)();
    const { recaptchaEnable: recaptchaEnable, shouldSkipCaptcha: shouldSkipCaptcha } = state || {};
    const shouldShow = recaptchaEnable && !shouldSkipCaptcha && recaptchaEnabled && recaptchaComponent;
    if (!shouldShow) return null;
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $C5uWN.WelcomeRecaptchaContainer), {
        children: recaptchaComponent
    });
};

});
parcelRegister("6r37m", function(module, exports) {
$parcel$export(module.exports, "useWelcomeState", function () { return (parcelRequire("1s6X2")).useWelcomeState; });
$parcel$export(module.exports, "useWelcomePageActions", function () { return (parcelRequire("18sqi")).useWelcomePageActions; });
$parcel$export(module.exports, "useWelcomeSubmission", function () { return (parcelRequire("joDRU")).useWelcomeSubmission; });
parcelRequire("1s6X2");
parcelRequire("18sqi");
parcelRequire("joDRU");

});
parcelRegister("1s6X2", function(module, exports) {

$parcel$export(module.exports, "useWelcomeState", function () { return $da961719d93c99e3$export$ac89f9e632e22c81; });
/* eslint-disable react-redux/useSelector-prefer-selectors */ 
var $1Fos3 = parcelRequire("1Fos3");

var $2aGBJ = parcelRequire("2aGBJ");

var $gz8Vs = parcelRequire("gz8Vs");

var $6cMFi = parcelRequire("6cMFi");

var $91i6m = parcelRequire("91i6m");

var $cADM9 = parcelRequire("cADM9");

var $juOhK = parcelRequire("juOhK");

var $9uXJ3 = parcelRequire("9uXJ3");
const $da961719d93c99e3$var$usePreloadedState = ()=>{
    const csrfToken = (0, $2aGBJ.useAppSelector)((state)=>state.csrfToken);
    const oidcContext = (0, $2aGBJ.useAppSelector)((state)=>state.microbranding.oidcContext);
    const isEmbedded = (0, $2aGBJ.useAppSelector)((state)=>Boolean(state.microbranding.isEmbedded));
    const marketingConsentConfig = (0, $2aGBJ.useAppSelector)((state)=>state.marketingConsent.config);
    const { recaptchaEnable: recaptchaEnable, auth0Config: auth0Config } = (0, $2aGBJ.useAppSelector)((state)=>state.appConfig);
    const { displayName: displayName, email: email, error: error, fieldErrors: fieldErrors, formError: formError, isLoading: isLoading, recoveryToken: recoveryToken, redirectTo: redirectTo, redirectType: redirectType, shouldSkipCaptcha: shouldSkipCaptcha } = (0, $2aGBJ.useAppSelector)((state)=>state.welcome);
    return {
        auth0Config: auth0Config,
        csrfToken: csrfToken,
        displayName: displayName,
        email: email || '',
        error: error,
        fieldErrors: fieldErrors,
        formError: formError,
        isEmbedded: isEmbedded,
        isLoading: isLoading,
        marketingConsentConfig: marketingConsentConfig,
        oidcContext: oidcContext,
        recaptchaEnable: recaptchaEnable,
        recoveryToken: recoveryToken,
        redirectTo: redirectTo,
        redirectType: redirectType,
        shouldSkipCaptcha: shouldSkipCaptcha
    };
};
const $da961719d93c99e3$export$ac89f9e632e22c81 = ()=>{
    const noServerState = (0, $gz8Vs.isSasStateEndpointEnabled)() && (0, $6cMFi.default)();
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    const { state: stateFromApi, isLoading: isLoading, isError: isError, error: error } = (0, $gz8Vs.usePageState)('/signup/welcome/state', {
        enabled: noServerState
    });
    (0, $91i6m.useEffect)(()=>{
        if ((0, $gz8Vs.isPageStateResult)(stateFromApi)) {
            dispatch((0, $cADM9.updateMicrobranding)(stateFromApi.oidcContext));
            dispatch((0, $juOhK.welcomeSetState)(stateFromApi));
        }
    }, [
        dispatch,
        stateFromApi
    ]);
    const preloadedState = $da961719d93c99e3$var$usePreloadedState();
    if ((0, $gz8Vs.isRedirectResult)(stateFromApi)) {
        navigate(stateFromApi.uri);
        return {
            state: undefined,
            isLoading: true,
            isError: false
        };
    }
    if (noServerState) return {
        state: (0, $1Fos3._)({}, preloadedState, stateFromApi),
        isLoading: isLoading,
        isError: isError,
        error: error
    };
    return {
        state: preloadedState,
        isLoading: false,
        isError: false,
        error: error
    };
};

});
parcelRegister("cADM9", function(module, exports) {

$parcel$export(module.exports, "updateMicrobranding", function () { return $b21920cd434bfe54$export$f31be3fc25ea8015; });

var $lodUs = parcelRequire("lodUs");
const $b21920cd434bfe54$export$f31be3fc25ea8015 = (oidcContext)=>({
        type: 'MICROBRANDING_UPDATE',
        microbranding: (0, $lodUs.buildMicrobranding)(oidcContext)
    });

});

parcelRegister("juOhK", function(module, exports) {

$parcel$export(module.exports, "showFieldErrors", function () { return $cea2732e62e177b1$export$f17d5fd8029ff8d7; });
$parcel$export(module.exports, "welcomeSetState", function () { return $cea2732e62e177b1$export$675233984e8f052; });
$parcel$export(module.exports, "welcome", function () { return $cea2732e62e177b1$export$424aefd0ddb3521d; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $dBq8m = parcelRequire("dBq8m");

var $fqbXQ = parcelRequire("fqbXQ");

var $4JAG5 = parcelRequire("4JAG5");

var $49Pnv = parcelRequire("49Pnv");

var $bqdjD = parcelRequire("bqdjD");
const $cea2732e62e177b1$export$aad8462122ac592b = ()=>({
        type: 'WELCOME_SIGNUP_RESET'
    });
const $cea2732e62e177b1$export$41790ce653e273fc = ()=>({
        type: 'WELCOME_SIGNUP_REQUEST'
    });
const $cea2732e62e177b1$export$4d8221b509914ddc = (redirectTo)=>({
        type: 'WELCOME_SIGNUP_REQUEST_SUCCESS',
        redirectTo: redirectTo
    });
const $cea2732e62e177b1$export$cacbe64ca8591e58 = (formError)=>({
        type: 'WELCOME_SIGNUP_REQUEST_FAILED',
        formError: formError
    });
const $cea2732e62e177b1$export$f17d5fd8029ff8d7 = (errors)=>({
        type: 'WELCOME_SIGNUP_SHOW_FIELD_ERRORS',
        errors: errors
    });
const $cea2732e62e177b1$export$675233984e8f052 = (state)=>({
        type: 'WELCOME_SIGNUP_SET_STATE',
        state: state
    });

const $cea2732e62e177b1$export$424aefd0ddb3521d = (welcomeParams)=>async (dispatch, getState)=>{
        const { displayName: displayName, password: password, token: token, microbrandingParams: microbrandingParams, challengeResponse: challengeResponse, marketingConsentState: marketingConsentState, privacyPolicyText: privacyPolicyText, csrfToken: csrfToken } = welcomeParams;
        // fire castle action
        const castleToken = (0, $bqdjD.currentCloudType) === 'commercial' ? await (parcelRequire("jEJQB")).then(async ({ createRequestToken: createRequestToken })=>await createRequestToken()).catch((e)=>{
            console.error('castle error', e);
            (0, $49Pnv.captureException)(e);
            return undefined;
        }) : undefined;
        const qs = microbrandingParams && Object.keys(microbrandingParams).length ? `?${(0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).stringify(microbrandingParams)}` : '';
        dispatch($cea2732e62e177b1$export$41790ce653e273fc());
        let payload = {
            'challenge-response': (0, $4JAG5.toChallengeRequest)(challengeResponse),
            displayName: displayName,
            password: password,
            token: token,
            display: null,
            castleToken: castleToken
        };
        const marketingConsent = (0, $fqbXQ.buildMarketingConsent)(getState().marketingConsent.config, marketingConsentState, privacyPolicyText);
        if (marketingConsent) payload = (0, $b2I6k._)((0, $1Fos3._)({}, payload), {
            marketingConsent: marketingConsent
        });
        return fetch(`/rest/signup/welcome${qs}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            },
            body: JSON.stringify(payload)
        }).then((response)=>response.json()).then(({ fieldErrors: fieldErrors, uiErrors: uiErrors, redirectTo: redirectTo })=>{
            if (redirectTo) dispatch($cea2732e62e177b1$export$4d8221b509914ddc(redirectTo));
            else {
                if (uiErrors && uiErrors.length) dispatch($cea2732e62e177b1$export$cacbe64ca8591e58(uiErrors[0].key));
                else if (fieldErrors && Object.keys(fieldErrors).length) dispatch($cea2732e62e177b1$export$f17d5fd8029ff8d7(fieldErrors));
                else dispatch($cea2732e62e177b1$export$cacbe64ca8591e58('unknown'));
            }
        }).catch(()=>{
            dispatch($cea2732e62e177b1$export$cacbe64ca8591e58('unknown'));
        });
    };

});


parcelRegister("18sqi", function(module, exports) {

$parcel$export(module.exports, "useWelcomePageActions", function () { return $d7a74d37704c186d$export$a7ba34b740a66255; });

var $91i6m = parcelRequire("91i6m");

var $1s6X2 = parcelRequire("1s6X2");
parcelRequire("0wXBc");
var $5k5vC = parcelRequire("5k5vC");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");

var $4FkXL = parcelRequire("4FkXL");
const $d7a74d37704c186d$export$a7ba34b740a66255 = ()=>{
    (0, $4PGUW.useRegisterComponent)($d7a74d37704c186d$export$a7ba34b740a66255.name);
    const { state: state } = (0, $1s6X2.useWelcomeState)();
    const { auth0Config: auth0Config, csrfToken: csrfToken, email: email, recoveryToken: recoveryToken, redirectType: redirectType } = state || {};
    const recoveryOptions = (0, $91i6m.useMemo)(()=>{
        return recoveryToken && email ? {
            expectedEmail: email,
            recoveryToken: recoveryToken
        } : undefined;
    }, [
        email,
        recoveryToken
    ]);
    const handleGoogleLogin = (0, $5k5vC.useGoogleLoginHandler)({
        pageId: (0, $4FkXL.WELCOME_PAGE_ID),
        redirectType: redirectType,
        redirectParams: {
            location: window.location,
            source: (0, $4FkXL.WELCOME_PAGE_ID),
            recoveryOptions: recoveryOptions
        }
    });
    const { handleAppleLogin: handleAppleLogin, handleMicrosoftLogin: handleMicrosoftLogin, handleSlackLogin: handleSlackLogin } = (0, $5k5vC.useSocialLoginHandlers)({
        pageId: (0, $4FkXL.WELCOME_PAGE_ID),
        redirectType: redirectType,
        redirectParams: {
            location: window.location,
            auth0Config: auth0Config,
            csrfToken: csrfToken,
            source: (0, $4FkXL.WELCOME_PAGE_ID),
            email: email,
            recoveryOptions: recoveryOptions
        }
    });
    return {
        handleAppleLogin: handleAppleLogin,
        handleMicrosoftLogin: handleMicrosoftLogin,
        handleSlackLogin: handleSlackLogin,
        handleGoogleLogin: handleGoogleLogin
    };
};

});
parcelRegister("4FkXL", function(module, exports) {

$parcel$export(module.exports, "WELCOME_PAGE_ID", function () { return $4415bf2e4784c9b8$export$ce43a0b457ba42a3; });
const $4415bf2e4784c9b8$export$ce43a0b457ba42a3 = 'welcomeScreen';

});


parcelRegister("joDRU", function(module, exports) {

$parcel$export(module.exports, "useWelcomeSubmission", function () { return $9a498aed7b7be183$export$1a7f914df8351aa8; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $91i6m = parcelRequire("91i6m");

var $dBq8m = parcelRequire("dBq8m");

var $5lFna = parcelRequire("5lFna");

var $j5RJC = parcelRequire("j5RJC");
var $leG06 = parcelRequire("leG06");

var $1s6X2 = parcelRequire("1s6X2");

var $juOhK = parcelRequire("juOhK");

var $fYxRW = parcelRequire("fYxRW");

var $1V2cH = parcelRequire("1V2cH");

var $2aGBJ = parcelRequire("2aGBJ");

var $2AqAA = parcelRequire("2AqAA");

var $49Pnv = parcelRequire("49Pnv");

var $a5qoX = parcelRequire("a5qoX");
parcelRequire("y8xn8");
var $1aroD = parcelRequire("1aroD");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");

var $4FkXL = parcelRequire("4FkXL");
parcelRequire("7i3mf");
var $ey3wc = parcelRequire("ey3wc");
parcelRequire("0wXBc");
var $kBhWP = parcelRequire("kBhWP");

var $9uXJ3 = parcelRequire("9uXJ3");
const $9a498aed7b7be183$var$subjectIds = {
    displayName: 'welcomeSignupNoName',
    password: 'welcomeSignupNoPassword',
    emailUsedAsName: 'welcomeSignupEmailUsedAsName',
    passwordUsedAsName: 'welcomeSignupPasswordUsedAsName'
};
const $9a498aed7b7be183$var$messages = (0, $j5RJC.defineMessages)({
    displayNameEmpty: {
        id: 'signup.form.displayName.empty',
        defaultMessage: 'Please enter a name'
    },
    displayNameIsEmail: {
        id: 'signup.form.displayName.is.email',
        defaultMessage: 'Please ensure your full name is not an email address'
    },
    displayNameIsPassword: {
        id: 'signup.form.displayName.is.password',
        defaultMessage: 'Please ensure your full name is not your password'
    },
    passwordEmpty: {
        id: 'signup.form.password.empty',
        defaultMessage: 'Please enter a password'
    },
    passwordMinimumRequirement: {
        id: 'signup.form.password.minimum',
        defaultMessage: 'Password must have at least 8 characters'
    }
});
const $9a498aed7b7be183$export$6f63e37550343081 = 8;
const $9a498aed7b7be183$export$1a7f914df8351aa8 = ({ autoRedirect: autoRedirect = true } = {})=>{
    (0, $4PGUW.useRegisterComponent)($9a498aed7b7be183$export$1a7f914df8351aa8.name);
    const navigate = (0, $9uXJ3.useNavigateSoftOrHard)();
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const intl = (0, $leG06.default)();
    const { fetchToken: fetchToken, recaptchaType: recaptchaType } = (0, $a5qoX.useRecaptchaContext)();
    const { marketingConsent: marketingConsent } = (0, $1aroD.useWelcomePageContext)();
    const { state: state } = (0, $1s6X2.useWelcomeState)();
    const { csrfToken: csrfToken, redirectType: redirectType, error: error, fieldErrors: fieldErrors, formError: formError, isLoading: isLoading = false, redirectTo: redirectTo = null } = state || {};
    (0, $kBhWP.useForceRedirect)({
        redirectTo: autoRedirect ? redirectTo : undefined
    });
    const { privacyPolicyText: privacyPolicyText } = (0, $1aroD.useWelcomePageContext)();
    const onWelcomeInputValidate = (0, $91i6m.useCallback)((data)=>{
        const validationErrors = {};
        const { displayName: displayName, password: password } = data;
        const hasDisplayName = typeof displayName !== 'undefined';
        const hasPassword = typeof password !== 'undefined';
        if (hasDisplayName && displayName.trim() === '') validationErrors.displayName = intl.formatMessage($9a498aed7b7be183$var$messages.displayNameEmpty);
        if (hasPassword) {
            if (password.trim() === '') validationErrors.password = intl.formatMessage($9a498aed7b7be183$var$messages.passwordEmpty);
            else if (password.length < $9a498aed7b7be183$export$6f63e37550343081) validationErrors.password = intl.formatMessage($9a498aed7b7be183$var$messages.passwordMinimumRequirement);
        }
        if (hasDisplayName && (0, $ey3wc.emailRegex).test(displayName.trim())) validationErrors.emailUsedAsName = intl.formatMessage($9a498aed7b7be183$var$messages.displayNameIsEmail);
        if (hasDisplayName && hasPassword && displayName.toLowerCase().trim() === password.toLowerCase().trim()) validationErrors.passwordUsedAsName = intl.formatMessage($9a498aed7b7be183$var$messages.displayNameIsPassword);
        return validationErrors;
    }, [
        intl
    ]);
    const onWelcomeSubmit = (0, $91i6m.useCallback)(async (data)=>{
        try {
            if (!privacyPolicyText) {
                console.error('Form cannot be submitted without showing Privacy Policy');
                return;
            }
            if (!marketingConsent) {
                console.error('Form cannot be submitted without showing Marketing Consent');
                return;
            }
            const validationErrors = onWelcomeInputValidate(data);
            if (Object.keys(validationErrors).length) {
                Object.keys(validationErrors).forEach((errorKey)=>analyticsClient.errorShownEvent((0, $4FkXL.WELCOME_PAGE_ID), $9a498aed7b7be183$var$subjectIds[errorKey] || 'welcomeSignupUnknownUiError'));
                dispatch((0, $juOhK.showFieldErrors)(validationErrors));
                return;
            }
            const challengeResponse = await fetchToken();
            const { signature: signature, token: token } = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(location.search);
            const welcomeToken = token || signature;
            const query = (0, $1Fos3._)({}, (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(location.search));
            navigate(`/signup/welcome?${(0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).stringify(query)}`);
            const microbrandingParams = (0, $fYxRW.getMicrobrandingFromUrl)(location);
            analyticsClient.formSubmittedEvent((0, $4FkXL.WELCOME_PAGE_ID), 'welcomeForm', {
                marketingConsent: (0, $5lFna.dangerouslyCreateSafeString)(marketingConsent.state),
                redirectType: redirectType,
                recaptchaType: recaptchaType
            });
            await dispatch((0, $juOhK.welcome)((0, $b2I6k._)((0, $1Fos3._)({}, data), {
                marketingConsentState: marketingConsent,
                privacyPolicyText: privacyPolicyText,
                microbrandingParams: microbrandingParams,
                challengeResponse: challengeResponse,
                password: data.password || '',
                token: welcomeToken || '',
                // TODO: Should not need this non-null assertion
                csrfToken: csrfToken
            })));
        } catch (e) {
            (0, $49Pnv.captureException)(e);
            dispatch((0, $2AqAA.signupCaptchaFailure)(navigator.onLine));
        }
    }, [
        analyticsClient,
        csrfToken,
        dispatch,
        marketingConsent,
        navigate,
        onWelcomeInputValidate,
        privacyPolicyText,
        fetchToken,
        recaptchaType,
        redirectType
    ]);
    return {
        onWelcomeSubmit: onWelcomeSubmit,
        onWelcomeInputValidate: onWelcomeInputValidate,
        isLoading: isLoading,
        redirectTo: redirectTo,
        formError: formError,
        fieldErrors: fieldErrors,
        error: error
    };
};

});


parcelRegister("C5uWN", function(module, exports) {

$parcel$export(module.exports, "WelcomeRecaptchaContainer", function () { return $652224cf73b57013$export$bb84fe97ed03d9ef; });

var $9jjaN = parcelRequire("9jjaN");

var $g6OTd = parcelRequire("g6OTd");
let $652224cf73b57013$var$_ = (t)=>t, $652224cf73b57013$var$t;
const $652224cf73b57013$export$bb84fe97ed03d9ef = (0, $9jjaN.default)((0, $g6OTd.default))($652224cf73b57013$var$t || ($652224cf73b57013$var$t = $652224cf73b57013$var$_`
  .grecaptcha-badge {
    display: none;
  }
`));

});


parcelRegister("cUEmD", function(module, exports) {

$parcel$export(module.exports, "WelcomeRecaptchaNotice", function () { return $9dff29f6dff8bef7$export$de0d13e777a02b5b; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $g6OTd = parcelRequire("g6OTd");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");
const $9dff29f6dff8bef7$export$de0d13e777a02b5b = ()=>{
    (0, $4PGUW.useRegisterComponent)($9dff29f6dff8bef7$export$de0d13e777a02b5b.name);
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $g6OTd.RecaptchaNotice), {});
};

});



parcelRegister("ey3wc", function(module, exports) {

$parcel$export(module.exports, "emailRegex", function () { return $f39c4a8edebaeece$export$976c37132e9c6a10; });
// Identity accepted email validator
const $f39c4a8edebaeece$var$regexLiteral = /([a-z0-9._%\-+!#$&/=?^|~ ]+)@([a-z0-9 -]+\.)+ *[a-z]+/;
const $f39c4a8edebaeece$export$976c37132e9c6a10 = new RegExp($f39c4a8edebaeece$var$regexLiteral);

});


parcelRegister("fTzH6", function(module, exports) {
$parcel$export(module.exports, "WelcomeRateLimitExceededError", function () { return (parcelRequire("5kSlf")).WelcomeRateLimitExceededError; });
parcelRequire("5kSlf");

});
parcelRegister("5kSlf", function(module, exports) {

$parcel$export(module.exports, "WelcomeRateLimitExceededError", function () { return $a7440fa506d0ed16$export$30b9e8215a118df0; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");

var $9jjaN = parcelRequire("9jjaN");

var $kyMDl = parcelRequire("kyMDl");

var $gs2u7 = parcelRequire("gs2u7");

var $1V2cH = parcelRequire("1V2cH");
let $a7440fa506d0ed16$var$_ = (t)=>t, $a7440fa506d0ed16$var$t;
const $a7440fa506d0ed16$var$MessageContainer = (0, $9jjaN.default).div($a7440fa506d0ed16$var$t || ($a7440fa506d0ed16$var$t = $a7440fa506d0ed16$var$_`
  margin-bottom: 24px;
`));
const $a7440fa506d0ed16$export$703ba2e7ea526c1b = 'welcomeRateLimitExceededErrorPage';
const $a7440fa506d0ed16$export$30b9e8215a118df0 = ()=>{
    (0, $1V2cH.usePageViewedEvent)($a7440fa506d0ed16$export$703ba2e7ea526c1b);
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gs2u7.default), {
        pageId: $a7440fa506d0ed16$export$703ba2e7ea526c1b,
        header: /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
            children: [
                /*#__PURE__*/ (0, $4ZSso.jsx)($a7440fa506d0ed16$var$MessageContainer, {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                        id: "welcome.rate-limit-exceeded.error.title",
                        defaultMessage: "We couldn't verify your email",
                        description: "Telling the user that there is an error and they're not verified. The error is caused by too many attempts submitting the link.",
                        tagName: "h5"
                    })
                }),
                /*#__PURE__*/ (0, $4ZSso.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($kyMDl))),
                    width: "99",
                    alt: ""
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "welcome.rate-limit-exceeded.error.main-action",
            defaultMessage: "There have been too many attempts to verify your account in the past hour. Please try again after an hour.",
            description: "Telling the user that there has been too many attempts on the welcome link and to try again later by refreshing or clicking the link again."
        })
    });
};
var $a7440fa506d0ed16$export$2e2bcd8739ae039 = $a7440fa506d0ed16$export$30b9e8215a118df0;

});


parcelRegister("5wPFe", function(module, exports) {
$parcel$export(module.exports, "WelcomePrivacyPolicy", function () { return (parcelRequire("gZWGo")).WelcomePrivacyPolicy; });
parcelRequire("gZWGo");

});
parcelRegister("gZWGo", function(module, exports) {

$parcel$export(module.exports, "WelcomePrivacyPolicy", function () { return $8ee6b245d92263a5$export$3c67e645c8f59d72; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $83pNw = parcelRequire("83pNw");

var $7eeh4 = parcelRequire("7eeh4");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");

var $4FkXL = parcelRequire("4FkXL");
parcelRequire("y8xn8");
var $1aroD = parcelRequire("1aroD");

var $2aGBJ = parcelRequire("2aGBJ");
parcelRequire("6r37m");
var $1s6X2 = parcelRequire("1s6X2");
const $8ee6b245d92263a5$var$isEmbeddedSelectorFn = (state)=>Boolean(state.microbranding.isEmbedded);
const $8ee6b245d92263a5$export$3c67e645c8f59d72 = ()=>{
    var _privacyPolicyMessageRef_current;
    (0, $4PGUW.useRegisterComponent)($8ee6b245d92263a5$export$3c67e645c8f59d72.name);
    const privacyPolicyMessageRef = (0, $91i6m.useRef)(null);
    const { state: { oidcContext: oidcContext } = {} } = (0, $1s6X2.useWelcomeState)();
    const isEmbedded = (0, $2aGBJ.useAppSelector)($8ee6b245d92263a5$var$isEmbeddedSelectorFn);
    const { setPrivacyPolicyText: setPrivacyPolicyText } = (0, $1aroD.useWelcomePageContext)();
    const privacyPolicyText = ((_privacyPolicyMessageRef_current = privacyPolicyMessageRef.current) === null || _privacyPolicyMessageRef_current === void 0 ? void 0 : _privacyPolicyMessageRef_current.innerHTML) || '';
    (0, $91i6m.useEffect)(()=>{
        if (privacyPolicyText) setPrivacyPolicyText(privacyPolicyText);
    }, [
        privacyPolicyText,
        setPrivacyPolicyText
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $83pNw.default), {
        isEmbedded: isEmbedded,
        isMobileOidc: (0, $7eeh4.isMobileOidc)(oidcContext),
        pageId: (0, $4FkXL.WELCOME_PAGE_ID),
        privacyPolicyText: (0, $83pNw.PrivacyPolicyText).passwordSignup,
        ref: privacyPolicyMessageRef
    });
};

});



parcelRegister("4272V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $904e366d75daa45f$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $904e366d75daa45f$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    headTitle: {
        id: 'welcome.head.title',
        defaultMessage: 'Sign up'
    },
    subheadingResumeSignup: {
        id: 'welcome.signup.subheading.title',
        defaultMessage: 'Finish setting up your account',
        description: 'Shown before the login form. e.g. "Sign up first then we will show you the content you requested"'
    },
    subheadingMigration: {
        id: 'welcome.migration.subheading.title',
        defaultMessage: 'Complete your migration'
    },
    emailVerifiedTitle: {
        id: 'resume.signup.head.title',
        defaultMessage: 'Email address verified'
    },
    contextualHeadTitle: {
        id: 'signup.contextual.head.title',
        defaultMessage: 'Sign up to continue to',
        description: `Precedes a page title or issue number. For example, "Sign up to continue to Sarah's Blogpost"`
    },
    socialAuthOr: {
        id: 'social.auth.or',
        defaultMessage: 'or'
    },
    socialAuthOrContinueWith: {
        id: 'social.auth.or-continue-with',
        defaultMessage: 'Or continue with:'
    },
    headerTitle: {
        id: 'signup.header.title',
        defaultMessage: 'Sign up to continue',
        description: 'Shown before the login form. e.g. "Sign up first then we will show you the content you requested"'
    },
    startCollaboratingHeaderTitle: {
        id: 'welcome.header.start.collaborating.title',
        defaultMessage: 'Sign up to start collaborating',
        description: 'Shown before the signup form. e.g. "Sign up first then we will show you the content you requested"'
    },
    headerWACExperiment: {
        id: 'welcome.signup.wac.header.title',
        defaultMessage: 'Add your account details',
        description: 'Heading for the signup form'
    },
    subheadingWACExperiment: {
        id: 'welcome.signup.wac.subheading.title',
        defaultMessage: 'This account can be used for {productName} and any other Atlassian product you add in the future.',
        description: 'Subheading for the signup form. productName is the name of the product the user is signing up for, e.g. "This account can be used for Jira and ..."'
    }
});

});

parcelRegister("3a10w", function(module, exports) {
$parcel$export(module.exports, "WelcomeHeader", function () { return (parcelRequire("frIrJ")).WelcomeHeader; });
parcelRequire("frIrJ");

});
parcelRegister("frIrJ", function(module, exports) {

$parcel$export(module.exports, "WelcomeHeader", function () { return $ae062d4502eea938$export$8e8630c5f5e8e2b0; });

var $1Fos3 = parcelRequire("1Fos3");

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");

var $1pjMo = parcelRequire("1pjMo");

var $4jXgk = parcelRequire("4jXgk");

var $cIxvP = parcelRequire("cIxvP");

var $4272V = parcelRequire("4272V");

var $kZ5BP = parcelRequire("kZ5BP");
parcelRequire("6r37m");
var $1s6X2 = parcelRequire("1s6X2");
const $ae062d4502eea938$export$8e8630c5f5e8e2b0 = ()=>{
    const { state: { redirectType: redirectType } = {} } = (0, $1s6X2.useWelcomeState)();
    switch(redirectType){
        case 'signup':
        case 'resume_signup':
            return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $kZ5BP.HeaderWrapper), {
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $kZ5BP.TitleWrapper), {
                        children: [
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4jXgk.default), {
                                as: 'h1',
                                size: 'small',
                                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $4272V.default).emailVerifiedTitle))
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1pjMo))), {
                                size: "small",
                                label: ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4jXgk.default), {
                        as: 'h2',
                        size: 'xxsmall',
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $4272V.default).subheadingResumeSignup))
                    })
                ]
            });
        case 'invite':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4jXgk.default), {
                as: 'h1',
                size: 'small',
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $cIxvP.default).inviteTitle))
            });
        case 'migration':
        case 'resume_migration':
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4jXgk.default), {
                as: 'h1',
                size: 'small',
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $4272V.default).subheadingMigration))
            });
        default:
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4jXgk.default), {
                as: 'h1',
                size: 'small',
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $4272V.default).subheadingResumeSignup))
            });
    }
};

});
parcelRegister("cIxvP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1bb98db7d003b563$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $1bb98db7d003b563$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    headTitle: {
        id: 'signup.head.title',
        defaultMessage: 'Sign up'
    },
    inviteTitle: {
        id: 'signup.invite.title',
        defaultMessage: 'Sign up to join your team'
    },
    titleNormal: {
        id: 'invitesignup.title.normal',
        defaultMessage: 'We need a few details, to create an account for {email}'
    }
});

});

parcelRegister("kZ5BP", function(module, exports) {

$parcel$export(module.exports, "HeaderWrapper", function () { return $1836a168b59c106c$export$960a49cc3d27a090; });
$parcel$export(module.exports, "TitleWrapper", function () { return $1836a168b59c106c$export$585a3b23e887288b; });

var $9jjaN = parcelRequire("9jjaN");

var $kLNLK = parcelRequire("kLNLK");
let $1836a168b59c106c$var$_ = (t)=>t, $1836a168b59c106c$var$t, $1836a168b59c106c$var$t1;
const $1836a168b59c106c$export$960a49cc3d27a090 = (0, $9jjaN.default).div($1836a168b59c106c$var$t || ($1836a168b59c106c$var$t = $1836a168b59c106c$var$_`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;
`));
const $1836a168b59c106c$export$585a3b23e887288b = (0, $9jjaN.default).div($1836a168b59c106c$var$t1 || ($1836a168b59c106c$var$t1 = $1836a168b59c106c$var$_`
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  svg {
    margin-left: 4px;
    color: ${0};
  }
`), (0, $kLNLK).G400);

});







parcelRegister("6BVyE", function(module, exports) {

$parcel$export(module.exports, "Mutation", function () { return $4d02d8972a8e9f86$export$17b8b19c814bcf56; });
$parcel$export(module.exports, "getDefaultState", function () { return $4d02d8972a8e9f86$export$a1659b54bac3252a; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $eXMu6 = parcelRequire("eXMu6");

var $3gH3P = parcelRequire("3gH3P");

var $dvGT8 = parcelRequire("dvGT8");

var $ljaX7 = parcelRequire("ljaX7");
// CLASS
class $4d02d8972a8e9f86$export$17b8b19c814bcf56 extends (0, $dvGT8.Removable) {
    setOptions(options) {
        this.options = (0, $1Fos3._)({}, this.defaultOptions, options);
        this.updateCacheTime(this.options.cacheTime);
    }
    get meta() {
        return this.options.meta;
    }
    setState(state) {
        this.dispatch({
            type: 'setState',
            state: state
        });
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the mutation from being garbage collected
            this.clearGcTimeout();
            this.mutationCache.notify({
                type: 'observerAdded',
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        this.observers = this.observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.mutationCache.notify({
            type: 'observerRemoved',
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.observers.length) {
            if (this.state.status === 'loading') this.scheduleGc();
            else this.mutationCache.remove(this);
        }
    }
    continue() {
        var _this$retryer$continu, _this$retryer;
        return (_this$retryer$continu = (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.continue()) != null ? _this$retryer$continu : this.execute();
    }
    async execute() {
        const executeMutation = ()=>{
            var _this$options$retry;
            this.retryer = (0, $ljaX7.createRetryer)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject('No mutationFn found');
                    return this.options.mutationFn(this.state.variables);
                },
                onFail: (failureCount, error)=>{
                    this.dispatch({
                        type: 'failed',
                        failureCount: failureCount,
                        error: error
                    });
                },
                onPause: ()=>{
                    this.dispatch({
                        type: 'pause'
                    });
                },
                onContinue: ()=>{
                    this.dispatch({
                        type: 'continue'
                    });
                },
                retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            });
            return this.retryer.promise;
        };
        const restored = this.state.status === 'loading';
        try {
            var _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onSettl, _this$options3;
            if (!restored) {
                var _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options;
                this.dispatch({
                    type: 'loading',
                    variables: this.options.variables
                }); // Notify cache callback
                await ((_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null ? void 0 : _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this));
                const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables));
                if (context !== this.state.context) this.dispatch({
                    type: 'loading',
                    context: context,
                    variables: this.state.variables
                });
            }
            const data = await executeMutation(); // Notify cache callback
            await ((_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null ? void 0 : _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this));
            await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context)); // Notify cache callback
            await ((_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c5.call(_this$mutationCache$c6, data, null, this.state.variables, this.state.context, this));
            await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context));
            this.dispatch({
                type: 'success',
                data: data
            });
            return data;
        } catch (error) {
            try {
                var _this$mutationCache$c7, _this$mutationCache$c8, _this$options$onError, _this$options4, _this$mutationCache$c9, _this$mutationCache$c10, _this$options$onSettl2, _this$options5;
                // Notify cache callback
                await ((_this$mutationCache$c7 = (_this$mutationCache$c8 = this.mutationCache.config).onError) == null ? void 0 : _this$mutationCache$c7.call(_this$mutationCache$c8, error, this.state.variables, this.state.context, this));
                await ((_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, error, this.state.variables, this.state.context)); // Notify cache callback
                await ((_this$mutationCache$c9 = (_this$mutationCache$c10 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c9.call(_this$mutationCache$c10, undefined, error, this.state.variables, this.state.context, this));
                await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, undefined, error, this.state.variables, this.state.context));
                throw error;
            } finally{
                this.dispatch({
                    type: 'error',
                    error: error
                });
            }
        }
    }
    dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case 'failed':
                    return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                        failureCount: action.failureCount,
                        failureReason: action.error
                    });
                case 'pause':
                    return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                        isPaused: true
                    });
                case 'continue':
                    return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                        isPaused: false
                    });
                case 'loading':
                    return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                        context: action.context,
                        data: undefined,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: !(0, $ljaX7.canFetch)(this.options.networkMode),
                        status: 'loading',
                        variables: action.variables
                    });
                case 'success':
                    return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: 'success',
                        isPaused: false
                    });
                case 'error':
                    return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                        data: undefined,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: 'error'
                    });
                case 'setState':
                    return (0, $1Fos3._)({}, state, action.state);
            }
        };
        this.state = reducer(this.state);
        (0, $3gH3P.notifyManager).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.mutationCache.notify({
                mutation: this,
                type: 'updated',
                action: action
            });
        });
    }
    constructor(config){
        super();
        this.defaultOptions = config.defaultOptions;
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.logger = config.logger || (0, $eXMu6.defaultLogger);
        this.observers = [];
        this.state = config.state || $4d02d8972a8e9f86$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
}
function $4d02d8972a8e9f86$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: 'idle',
        variables: undefined
    };
}

});
parcelRegister("eXMu6", function(module, exports) {

$parcel$export(module.exports, "defaultLogger", function () { return $ae4c2f68702969a6$export$1cf3d545f2d4635c; });
const $ae4c2f68702969a6$export$1cf3d545f2d4635c = console;

});

parcelRegister("dvGT8", function(module, exports) {

$parcel$export(module.exports, "Removable", function () { return $9d5f705327bda014$export$e09608847fcc8c59; });

var $2Yp8D = parcelRequire("2Yp8D");
class $9d5f705327bda014$export$e09608847fcc8c59 {
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $2Yp8D.isValidTimeout)(this.cacheTime)) this.gcTimeout = setTimeout(()=>{
            this.optionalRemove();
        }, this.cacheTime);
    }
    updateCacheTime(newCacheTime) {
        // Default to 5 minutes (Infinity for server-side) if no cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : (0, $2Yp8D.isServer) ? Infinity : 300000);
    }
    clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    }
}

});


var $f9b1a7071aea3193$exports = {};


(parcelRequire("lxKym")).register((parcelRequire("cgi2g")).getBundleURL('9rAa3'), JSON.parse("[\"9rAa3\",\"index.329191f6.js\",\"hQW1F\",\"Error.b0f67bec.svg\",\"lyb5Y\",\"web-vitals.c0076041.js\",\"f2uOF\",\"tti-polyfill.5b39b8c7.js\",\"hQDxa\",\"castle.fd24060c.js\",\"3vVFy\",\"pt-BR.23e6d8f6.js\",\"4Y4Hb\",\"en-ZZ.99c9e021.js\",\"eqZfY\",\"en-GB.465fc456.js\",\"7Qdyn\",\"zh-CN.bf3f0c99.js\",\"2HI26\",\"zh-TW.709ee4f6.js\",\"dU1ZU\",\"cs-CZ.45fc15d6.js\",\"4l34J\",\"da-DK.d8b9f6f7.js\",\"1JlbJ\",\"de-DE.60e25a7e.js\",\"1TY4n\",\"en.184502d3.js\",\"24jzf\",\"es.09b7abc6.js\",\"1vWFJ\",\"fi-FI.a9bc1266.js\",\"8tYz2\",\"fr-FR.a858045e.js\",\"px9BB\",\"hu-HU.fcdb97a9.js\",\"2BXEZ\",\"it-IT.f26d9c4d.js\",\"aT9no\",\"ja-JP.0c3f5e1b.js\",\"8EHDU\",\"ko-KR.0cdca777.js\",\"38Axh\",\"nb-NO.deb14e9a.js\",\"bnpcq\",\"nl-NL.cc5b6bc7.js\",\"3GliG\",\"pl-PL.b981cf6c.js\",\"f2Qn3\",\"ru-RU.489e4570.js\",\"8tbRj\",\"sv-SE.21572de2.js\",\"8WnsM\",\"th-TH.654cf922.js\",\"eb8gQ\",\"tr-TR.c80240d2.js\",\"5kUI8\",\"uk-UA.4d309170.js\",\"4fGj1\",\"vi-VN.cf07005c.js\",\"86pTb\",\"atlassian-light.0381dfa3.js\",\"2sYHg\",\"atlassian-light-future.37bafb1a.js\",\"fCDO8\",\"atlassian-light-increased-contrast.1615620d.js\",\"aqfCd\",\"atlassian-dark.91926c9c.js\",\"8bod9\",\"atlassian-dark-future.72be6e5f.js\",\"iVZbQ\",\"atlassian-dark-increased-contrast.475fd179.js\",\"bqfwD\",\"atlassian-legacy-light.b08a9ce0.js\",\"b25ru\",\"atlassian-legacy-dark.cfa111da.js\",\"60SPd\",\"atlassian-spacing.cc56f470.js\",\"dJ9Ng\",\"atlassian-typography.363146bc.js\",\"7C4Cq\",\"atlassian-typography-adg3.93dbe1da.js\",\"6NBej\",\"atlassian-shape.aae84987.js\",\"k5lOf\",\"atlassian-shape-rounder.07c55a87.js\",\"cg2eR\",\"atlassian-shape-roundest.750b6836.js\",\"cPLJH\",\"atlassian-typography-modernized.b0ea13f6.js\",\"lWQgD\",\"atlassian-typography-refreshed.533a31f1.js\",\"7BIdz\",\"atlassian-light-brand-refresh.cbf7e330.js\",\"5bLPT\",\"atlassian-dark-brand-refresh.f141dd86.js\",\"cPzVc\",\"custom-theme.4328b4e8.js\",\"jjKyj\",\"MfaAppsPage.74432d6b.js\",\"7jenY\",\"authy_icon.814b7ffa.png\",\"9vYTX\",\"duo_icon.b136e666.png\",\"Wx6J2\",\"google_authenticator_icon.e16260d2.png\",\"23roH\",\"other_app_icon.d89fb9f9.svg\",\"dJL3t\",\"check-your-email-open-letter.58fc87ea.svg\",\"fGePY\",\"default_left.dfc31853.svg\",\"6sdhV\",\"default_right.a801c0cc.svg\",\"8CICh\",\"opsgenie-left.49c0f64b.svg\",\"Voo2a\",\"opsgenie-right.77c52ee2.svg\",\"gP62D\",\"statuspage-left.6c5cd6d4.svg\",\"1ks9x\",\"statuspage-right.447da08b.svg\",\"6VcUF\",\"trello-left.4f52d13c.svg\",\"fafwt\",\"trello-right.e6e102c7.svg\",\"bIDWi\",\"wac.92a80da2.svg\",\"bx91j\",\"trust-and-security.2e60671c.svg\",\"4Od2P\",\"MfaEnrollmentPage.ea0480d8.js\",\"2CKsW\",\"mfa-enable.f2e108a8.png\",\"66aJg\",\"security-wall.788bd489.svg\",\"hHdUq\",\"lock-closed.59f9256b.svg\",\"jW7R5\",\"check-your-email.39bc0dca.svg\",\"be1JW\",\"save-recovery-key.57011d69.svg\",\"6GsoP\",\"LoginConsentNoticePage.2b563e51.js\",\"fegwJ\",\"fedramp.d1d0b13f.js\",\"bfNSm\",\"a53d6b63-3k57-1408-j79d-0b60b08kb685-privacy.552a1907.js\",\"4D3hi\",\"2a85b822-1ba4-44ec-968a-c2f95bf4b469-privacy.ba2811dd.js\",\"hb2yi\",\"6e62b4f0-a2f3-4cb5-b61c-1bd397640f04-privacy.de02b688.js\",\"ioHDi\",\"cancel-deletion-hourglass.714e127f.svg\",\"hOtWz\",\"InactiveAccountPage.5556a099.js\",\"jDxCB\",\"lock.10ed9279.svg\",\"6zPtE\",\"PendingDeletionPage.7aedb003.js\",\"kjrCT\",\"DeletionRequestConfirmationPage.89e7d6f2.js\",\"jJiHd\",\"main.10cddc61.js\",\"2k6cw\",\"AuthCallbackErrorPage.5a871bb9.js\",\"fcIvx\",\"SecurityExpiredLinkPage.5479dc3b.js\",\"aYVrY\",\"SecuritySuccessPage.a37c12d5.js\",\"iBeAy\",\"MfaEnrollmentChooseMethodPage.c55d499e.js\",\"fk09M\",\"MfaEnrollmentChooseMethodPage.71154385.js\",\"4l69b\",\"MfaEnrollmentConfigurePhonePage.861b81a5.js\",\"lrCmZ\",\"phone_black_message.b83c9523.png\",\"bKaGI\",\"MfaEnrollmentConfigurePhonePage.6057ceee.js\",\"700Vk\",\"MfaEnrollmentConfigureAppPage.f5614779.js\",\"akw5Z\",\"configure_app_desktop.e3f196e8.svg\",\"7MHFe\",\"MfaEnrollmentSaveRecoveryKeyPage.c26daaf8.js\",\"c061K\",\"MfaEnrollmentRegisterSecurityKeyPage.fad5f310.js\",\"b2oJM\",\"MfaEnrollmentRegisterSecurityKeyPage.2adc768c.js\",\"c5VS0\",\"MultiMfaEnrollmentAddAuthenticatorPage.8a911518.js\",\"cSrTL\",\"MultiMfaEnrollmentAddSecurityKeyPage.65108b90.js\",\"fS7F0\",\"page.ca8c44fe.js\",\"bWK1p\",\"LoginPage.e8bdafe7.js\",\"hvsjf\",\"LoginPage.9f709b44.js\",\"gFWp2\",\"LoginPage.794a27e2.js\",\"bfA4J\",\"defaultPage.ad0970ed.js\",\"8EdzW\",\"login-page.612ea986.js\",\"4PNwD\",\"login-page.ba57b039.js\",\"3N9O9\",\"LoginPage.01a8e61f.js\",\"84TCq\",\"apple-logo.54e0d711.svg\",\"hQgRT\",\"google-logo.5867462c.svg\",\"faAYQ\",\"microsoft-logo.c73d8dca.svg\",\"6eAR3\",\"slack-logo.5d730c10.svg\",\"2oxN3\",\"loom-atlassian-logo.72f9b02d.svg\",\"8sx8b\",\"LoginPage.22ae9e0a.js\",\"6UgT0\",\"BasePage.28ba7e41.js\",\"jLaZ5\",\"key-logo.39b27441.svg\",\"9xeQ7\",\"page.d76b9fe0.js\",\"8xxtb\",\"CreateAccountConfirmationPage.51878ade.js\",\"kC7aC\",\"CreateAccountConfirmationPage.7ce7e3eb.js\",\"2Nmkx\",\"defaultPage.3843ef36.js\",\"hg7ZR\",\"defaultPage.b36d53a5.js\",\"jZ6NW\",\"custom-theme.f8d41b09.js\",\"lO9Sx\",\"atlassian-light.0bcce433.js\",\"cgd4h\",\"atlassian-light-future.cd946fef.js\",\"6N2CL\",\"atlassian-light-increased-contrast.8b1fb951.js\",\"8quhK\",\"atlassian-dark.d9eb1909.js\",\"9Yhbo\",\"atlassian-dark-future.a3fdd3ba.js\",\"co9zD\",\"atlassian-dark-increased-contrast.da5a0ee9.js\",\"7EdKJ\",\"atlassian-legacy-light.d856de3d.js\",\"dWFph\",\"atlassian-legacy-dark.1a2db7d8.js\",\"i9fwN\",\"atlassian-spacing.dcb7dafd.js\",\"6Pz3f\",\"atlassian-typography-adg3.d93fa34b.js\",\"hmFoK\",\"atlassian-shape.37aaf615.js\",\"gpMuD\",\"atlassian-typography-modernized.ac888c47.js\",\"jSlCQ\",\"atlassian-typography-refreshed.2f57009c.js\",\"akIBj\",\"atlassian-light-brand-refresh.cfd74754.js\",\"6R6hK\",\"atlassian-dark-brand-refresh.b8f676ef.js\",\"ahXqz\",\"defaultPage.0f476f00.js\",\"1MqbO\",\"defaultPage.3c8aa798.js\",\"9X9P1\",\"defaultPage.2436a33c.js\",\"i6ffB\",\"defaultPage.02d8e24f.css\",\"jdVDk\",\"defaultPage.686cbb7a.js\",\"8G0JB\",\"defaultPage.06cd6ff2.js\",\"lS0Cm\",\"defaultPage.6b4159b3.js\",\"emrWm\",\"defaultPage.ce7010a4.css\",\"ircv7\",\"SocialWelcomePage.6cd04abb.js\",\"ar3hN\",\"SocialWelcomePage.2d42950a.js\",\"9bKfR\",\"routing-middleware.d4a82eea.js\",\"2hhQQ\",\"ajs-destination.6f237e29.js\",\"cIPUN\",\"legacy-video-plugins.5c9b6df5.js\",\"j3WzW\",\"index.umd.a8401258.js\",\"f4fHS\",\"schema-filter.dae369c0.js\",\"dW0s2\",\"remote-middleware.60b0f1f3.js\",\"lQhLG\",\"auto-track.3bf040d2.js\",\"7JIkp\",\"query-string.0413cf5c.js\",\"bcSXn\",\"SocialWelcomePage.1b988e1d.js\",\"eFQ0G\",\"SocialWelcomePage.d48aa3b2.js\",\"bCPyK\",\"SocialWelcomePage.939b7646.js\",\"4Grqq\",\"SocialWelcomePage.4a7bad29.js\",\"illv8\",\"SocialWelcomePage.0b83906a.js\",\"bSq5R\",\"SocialWelcomePage.f4e54b2f.css\",\"9Je5U\",\"SocialWelcomePage.e7dc2770.js\",\"2Ce2b\",\"SocialWelcomePage.29de7a42.css\",\"56hY4\",\"page.8cae30af.js\",\"corT2\",\"WelcomePage.6f68e7ff.js\",\"3fuCv\",\"defaultPage.6ad2d7ec.js\",\"kRfrQ\",\"defaultPage.826ddb9b.js\",\"iLg3A\",\"defaultPage.9d49b696.css\",\"h7EYk\",\"defaultPage.453c9a84.js\",\"3JVXk\",\"defaultPage.d6fa2398.css\",\"4AiAl\",\"defaultPage.1305d753.js\",\"6jLtg\",\"defaultPage.34c0162b.css\",\"c61RN\",\"WelcomePage.c5e0f3ba.js\",\"e4mYL\",\"WelcomePage.62591531.js\",\"8otIL\",\"WelcomePage.0bf84062.css\",\"6DKqL\",\"WelcomePage.04c7115b.js\",\"c5wWh\",\"WelcomePage.0cfe91ca.css\",\"3CpNu\",\"WelcomePage.3340eeed.js\",\"2kcaL\",\"WelcomePage.4434189e.css\",\"isIPl\",\"WelcomePage.b2ff5d4b.js\",\"logKB\",\"WelcomePage.bdaed42a.css\",\"d3TaM\",\"WelcomePage.40022214.js\",\"2Ng2l\",\"WelcomePage.08dd53fd.css\",\"6UVE8\",\"page.746f7fe2.js\",\"6kGRk\",\"OrchestratedPage.6a4768d3.js\",\"8mjIy\",\"VerifyEmailOtpPage.9a60dbbc.js\",\"jy1qN\",\"defaultPage.2800b3da.js\",\"eAut5\",\"defaultPage.886537c8.js\",\"cVl0F\",\"defaultPage.7b48bac3.css\",\"aGKk4\",\"defaultPage.87c94d63.js\",\"ajOnp\",\"defaultPage.d6cb27ce.css\",\"2EFAQ\",\"defaultPage.1212ff57.js\",\"gLb7z\",\"OtpPage.a3315f2b.js\",\"kNsxv\",\"OtpPage.18e8bd67.js\",\"loMLq\",\"OtpPage.e60387ac.js\",\"fOV1m\",\"OtpPage.907c3f65.js\",\"26lfy\",\"OtpPage.83a8ecdb.js\",\"ktIzx\",\"OtpPage.3fe942a8.css\",\"5llqY\",\"OtpPage.7323b7d5.js\",\"aWCiK\",\"OtpPage.f14deb97.css\",\"l6SzY\",\"page.6ac1a19a.js\",\"hwH24\",\"OrchestratedPage.e69cbaa0.js\",\"5Syz2\",\"BasePage.57a00945.js\",\"ixNGA\",\"page.89ec4675.js\",\"azJL8\",\"SignupPage.4b60f0f5.js\",\"eoGjz\",\"SignupPage.ed835152.js\",\"k1dx2\",\"colby.9b10f128.png\",\"DHE2r\",\"signup-page.32123782.js\",\"kEiMT\",\"signup-page.4b83088e.js\",\"lcNgi\",\"page.4989d9ce.js\",\"1Jzkd\",\"SignupOnboardPage.46e27be2.js\",\"c0ULl\",\"BasePage.9a2f04b6.js\",\"eFcy5\",\"LoomWorkspaceCreationPage.13abba9c.js\"]"));


var $4ZSso = parcelRequire("4ZSso");
/**
 * CoreJS https://github.com/zloirock/core-js
 * Our package.json['browserslist'] drives how Parcel/swc polyfills our application.
 * However we want to manually polyfill a handful of features that enables more of the application for more users.
 */ 'use strict';
'use strict';
var $29850882e4bbedea$exports = {};
'use strict';
var $07998499f274e259$exports = {};
'use strict';
var $07998499f274e259$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$07998499f274e259$exports = // eslint-disable-next-line es/no-global-this -- safe
$07998499f274e259$var$check(typeof globalThis == 'object' && globalThis) || $07998499f274e259$var$check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
$07998499f274e259$var$check(typeof self == 'object' && self) || $07998499f274e259$var$check(typeof $parcel$global == 'object' && $parcel$global) || $07998499f274e259$var$check(typeof $07998499f274e259$exports == 'object' && $07998499f274e259$exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function('return this')();


// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $43059c765fd950ff$export$2d1720544b23b823;
'use strict';
var $1c5c161750ba2318$exports = {};
'use strict';
var $43ca4faa4c08cac6$exports = {};
'use strict';
$43ca4faa4c08cac6$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$1c5c161750ba2318$exports = !$43ca4faa4c08cac6$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});


var $e6d4173f39686687$exports = {};
'use strict';
var $e4bfd52c2d32d906$exports = {};
'use strict';

$e4bfd52c2d32d906$exports = !$43ca4faa4c08cac6$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != 'function' || test.hasOwnProperty('prototype');
});


var $e6d4173f39686687$var$call = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
$e6d4173f39686687$exports = $e4bfd52c2d32d906$exports ? $e6d4173f39686687$var$call.bind($e6d4173f39686687$var$call) : function() {
    return $e6d4173f39686687$var$call.apply($e6d4173f39686687$var$call, arguments);
};


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $75dcc07f7d73ce0b$export$2d1720544b23b823;
'use strict';
var $75dcc07f7d73ce0b$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $75dcc07f7d73ce0b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $75dcc07f7d73ce0b$var$NASHORN_BUG = $75dcc07f7d73ce0b$var$getOwnPropertyDescriptor && !$75dcc07f7d73ce0b$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$75dcc07f7d73ce0b$export$2d1720544b23b823 = $75dcc07f7d73ce0b$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $75dcc07f7d73ce0b$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $75dcc07f7d73ce0b$var$$propertyIsEnumerable;


var $1ae5bf3096858a31$exports = {};
'use strict';
$1ae5bf3096858a31$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


var $b6a1805cad1ce744$exports = {};
'use strict';
var $54529d2c36e4943a$exports = {};
'use strict';
var $0d2d65811192edf9$exports = {};
'use strict';

var $0d2d65811192edf9$var$FunctionPrototype = Function.prototype;
var $0d2d65811192edf9$var$call = $0d2d65811192edf9$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var $0d2d65811192edf9$var$uncurryThisWithBind = $e4bfd52c2d32d906$exports && $0d2d65811192edf9$var$FunctionPrototype.bind.bind($0d2d65811192edf9$var$call, $0d2d65811192edf9$var$call);
$0d2d65811192edf9$exports = $e4bfd52c2d32d906$exports ? $0d2d65811192edf9$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $0d2d65811192edf9$var$call.apply(fn, arguments);
    };
};



var $e694db3d47ffa133$exports = {};
'use strict';

var $e694db3d47ffa133$var$toString = $0d2d65811192edf9$exports({}.toString);
var $e694db3d47ffa133$var$stringSlice = $0d2d65811192edf9$exports(''.slice);
$e694db3d47ffa133$exports = function(it) {
    return $e694db3d47ffa133$var$stringSlice($e694db3d47ffa133$var$toString(it), 8, -1);
};


var $54529d2c36e4943a$var$$Object = Object;
var $54529d2c36e4943a$var$split = $0d2d65811192edf9$exports(''.split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$54529d2c36e4943a$exports = $43ca4faa4c08cac6$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$54529d2c36e4943a$var$$Object('z').propertyIsEnumerable(0);
}) ? function(it) {
    return $e694db3d47ffa133$exports(it) === 'String' ? $54529d2c36e4943a$var$split(it, '') : $54529d2c36e4943a$var$$Object(it);
} : $54529d2c36e4943a$var$$Object;


var $0a597a3e038187ad$exports = {};
'use strict';
var $9391530d69afc856$exports = {};
'use strict';
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$9391530d69afc856$exports = function(it) {
    return it === null || it === undefined;
};


var $0a597a3e038187ad$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$0a597a3e038187ad$exports = function(it) {
    if ($9391530d69afc856$exports(it)) throw new $0a597a3e038187ad$var$$TypeError("Can't call method on " + it);
    return it;
};


$b6a1805cad1ce744$exports = function(it) {
    return $54529d2c36e4943a$exports($0a597a3e038187ad$exports(it));
};


var $d6853a08063b78e4$exports = {};
'use strict';
var $882e0ad8a67ec86f$exports = {};
'use strict';

var $924370d4951ad42d$exports = {};
'use strict';
var $4d95979672d16e01$exports = {};
'use strict';
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $4d95979672d16e01$var$documentAll = typeof document == 'object' && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
$4d95979672d16e01$exports = typeof $4d95979672d16e01$var$documentAll == 'undefined' && $4d95979672d16e01$var$documentAll !== undefined ? function(argument) {
    return typeof argument == 'function' || argument === $4d95979672d16e01$var$documentAll;
} : function(argument) {
    return typeof argument == 'function';
};


$924370d4951ad42d$exports = function(it) {
    return typeof it == 'object' ? it !== null : $4d95979672d16e01$exports(it);
};


var $2cd9fc9cfeb42ac9$exports = {};
'use strict';
var $3a6da97d1c60ac9a$exports = {};
'use strict';


var $3a6da97d1c60ac9a$var$aFunction = function(argument) {
    return $4d95979672d16e01$exports(argument) ? argument : undefined;
};
$3a6da97d1c60ac9a$exports = function(namespace, method) {
    return arguments.length < 2 ? $3a6da97d1c60ac9a$var$aFunction($07998499f274e259$exports[namespace]) : $07998499f274e259$exports[namespace] && $07998499f274e259$exports[namespace][method];
};



var $44741d43c106a994$exports = {};
'use strict';

$44741d43c106a994$exports = $0d2d65811192edf9$exports({}.isPrototypeOf);


var $bd1ea72ce010c426$exports = {};
'use strict';
var $11041b36eb77f181$exports = {};
'use strict';
var $6c492956451b2016$exports = {};
'use strict';

var $af44d573516928c0$exports = {};
'use strict';

var $af44d573516928c0$var$navigator = $07998499f274e259$exports.navigator;
var $af44d573516928c0$var$userAgent = $af44d573516928c0$var$navigator && $af44d573516928c0$var$navigator.userAgent;
$af44d573516928c0$exports = $af44d573516928c0$var$userAgent ? String($af44d573516928c0$var$userAgent) : '';


var $6c492956451b2016$var$process = $07998499f274e259$exports.process;
var $6c492956451b2016$var$Deno = $07998499f274e259$exports.Deno;
var $6c492956451b2016$var$versions = $6c492956451b2016$var$process && $6c492956451b2016$var$process.versions || $6c492956451b2016$var$Deno && $6c492956451b2016$var$Deno.version;
var $6c492956451b2016$var$v8 = $6c492956451b2016$var$versions && $6c492956451b2016$var$versions.v8;
var $6c492956451b2016$var$match, $6c492956451b2016$var$version;
if ($6c492956451b2016$var$v8) {
    $6c492956451b2016$var$match = $6c492956451b2016$var$v8.split('.');
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $6c492956451b2016$var$version = $6c492956451b2016$var$match[0] > 0 && $6c492956451b2016$var$match[0] < 4 ? 1 : +($6c492956451b2016$var$match[0] + $6c492956451b2016$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$6c492956451b2016$var$version && $af44d573516928c0$exports) {
    $6c492956451b2016$var$match = $af44d573516928c0$exports.match(/Edge\/(\d+)/);
    if (!$6c492956451b2016$var$match || $6c492956451b2016$var$match[1] >= 74) {
        $6c492956451b2016$var$match = $af44d573516928c0$exports.match(/Chrome\/(\d+)/);
        if ($6c492956451b2016$var$match) $6c492956451b2016$var$version = +$6c492956451b2016$var$match[1];
    }
}
$6c492956451b2016$exports = $6c492956451b2016$var$version;




var $11041b36eb77f181$var$$String = $07998499f274e259$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$11041b36eb77f181$exports = !!Object.getOwnPropertySymbols && !$43ca4faa4c08cac6$exports(function() {
    var symbol = Symbol('symbol detection');
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$11041b36eb77f181$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $6c492956451b2016$exports && $6c492956451b2016$exports < 41;
});


$bd1ea72ce010c426$exports = $11041b36eb77f181$exports && !Symbol.sham && typeof Symbol.iterator == 'symbol';


var $2cd9fc9cfeb42ac9$var$$Object = Object;
$2cd9fc9cfeb42ac9$exports = $bd1ea72ce010c426$exports ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    var $Symbol = $3a6da97d1c60ac9a$exports('Symbol');
    return $4d95979672d16e01$exports($Symbol) && $44741d43c106a994$exports($Symbol.prototype, $2cd9fc9cfeb42ac9$var$$Object(it));
};


var $333e279a47024ee9$exports = {};
'use strict';
var $e36db42b9d5d42af$exports = {};
'use strict';

var $f73f880bcaff5725$exports = {};
'use strict';
var $f73f880bcaff5725$var$$String = String;
$f73f880bcaff5725$exports = function(argument) {
    try {
        return $f73f880bcaff5725$var$$String(argument);
    } catch (error) {
        return 'Object';
    }
};


var $e36db42b9d5d42af$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$e36db42b9d5d42af$exports = function(argument) {
    if ($4d95979672d16e01$exports(argument)) return argument;
    throw new $e36db42b9d5d42af$var$$TypeError($f73f880bcaff5725$exports(argument) + ' is not a function');
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$333e279a47024ee9$exports = function(V, P) {
    var func = V[P];
    return $9391530d69afc856$exports(func) ? undefined : $e36db42b9d5d42af$exports(func);
};


var $611f17d30b8b24db$exports = {};
'use strict';



var $611f17d30b8b24db$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$611f17d30b8b24db$exports = function(input, pref) {
    var fn, val;
    if (pref === 'string' && $4d95979672d16e01$exports(fn = input.toString) && !$924370d4951ad42d$exports(val = $e6d4173f39686687$exports(fn, input))) return val;
    if ($4d95979672d16e01$exports(fn = input.valueOf) && !$924370d4951ad42d$exports(val = $e6d4173f39686687$exports(fn, input))) return val;
    if (pref !== 'string' && $4d95979672d16e01$exports(fn = input.toString) && !$924370d4951ad42d$exports(val = $e6d4173f39686687$exports(fn, input))) return val;
    throw new $611f17d30b8b24db$var$$TypeError("Can't convert object to primitive value");
};


var $e74a86236539799f$exports = {};
'use strict';

var $9d4c0fc2121b5662$exports = {};
'use strict';
var $209b7ab25b003f8b$exports = {};
'use strict';
var $69c699ff9075b9ca$exports = {};
'use strict';
$69c699ff9075b9ca$exports = false;



var $3bc3b5220f5e6402$exports = {};
'use strict';

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $3bc3b5220f5e6402$var$defineProperty = Object.defineProperty;
$3bc3b5220f5e6402$exports = function(key, value) {
    try {
        $3bc3b5220f5e6402$var$defineProperty($07998499f274e259$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $07998499f274e259$exports[key] = value;
    }
    return value;
};


var $209b7ab25b003f8b$var$SHARED = '__core-js_shared__';
var $209b7ab25b003f8b$var$store = $209b7ab25b003f8b$exports = $07998499f274e259$exports[$209b7ab25b003f8b$var$SHARED] || $3bc3b5220f5e6402$exports($209b7ab25b003f8b$var$SHARED, {});
($209b7ab25b003f8b$var$store.versions || ($209b7ab25b003f8b$var$store.versions = [])).push({
    version: '3.40.0',
    mode: $69c699ff9075b9ca$exports ? 'pure' : 'global',
    copyright: "\xa9 2014-2025 Denis Pushkarev (zloirock.ru)",
    license: 'https://github.com/zloirock/core-js/blob/v3.40.0/LICENSE',
    source: 'https://github.com/zloirock/core-js'
});


$9d4c0fc2121b5662$exports = function(key, value) {
    return $209b7ab25b003f8b$exports[key] || ($209b7ab25b003f8b$exports[key] = value || {});
};


var $22f28cc59c37d6a6$exports = {};
'use strict';

var $97a563d9b960a76a$exports = {};
'use strict';

var $97a563d9b960a76a$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$97a563d9b960a76a$exports = function(argument) {
    return $97a563d9b960a76a$var$$Object($0a597a3e038187ad$exports(argument));
};


var $22f28cc59c37d6a6$var$hasOwnProperty = $0d2d65811192edf9$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$22f28cc59c37d6a6$exports = Object.hasOwn || function hasOwn(it, key) {
    return $22f28cc59c37d6a6$var$hasOwnProperty($97a563d9b960a76a$exports(it), key);
};


var $dc4222fe468e4af0$exports = {};
'use strict';

var $dc4222fe468e4af0$var$id = 0;
var $dc4222fe468e4af0$var$postfix = Math.random();
var $dc4222fe468e4af0$var$toString = $0d2d65811192edf9$exports(1.0.toString);
$dc4222fe468e4af0$exports = function(key) {
    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + $dc4222fe468e4af0$var$toString(++$dc4222fe468e4af0$var$id + $dc4222fe468e4af0$var$postfix, 36);
};




var $e74a86236539799f$var$Symbol = $07998499f274e259$exports.Symbol;
var $e74a86236539799f$var$WellKnownSymbolsStore = $9d4c0fc2121b5662$exports('wks');
var $e74a86236539799f$var$createWellKnownSymbol = $bd1ea72ce010c426$exports ? $e74a86236539799f$var$Symbol['for'] || $e74a86236539799f$var$Symbol : $e74a86236539799f$var$Symbol && $e74a86236539799f$var$Symbol.withoutSetter || $dc4222fe468e4af0$exports;
$e74a86236539799f$exports = function(name) {
    if (!$22f28cc59c37d6a6$exports($e74a86236539799f$var$WellKnownSymbolsStore, name)) $e74a86236539799f$var$WellKnownSymbolsStore[name] = $11041b36eb77f181$exports && $22f28cc59c37d6a6$exports($e74a86236539799f$var$Symbol, name) ? $e74a86236539799f$var$Symbol[name] : $e74a86236539799f$var$createWellKnownSymbol('Symbol.' + name);
    return $e74a86236539799f$var$WellKnownSymbolsStore[name];
};


var $882e0ad8a67ec86f$var$$TypeError = TypeError;
var $882e0ad8a67ec86f$var$TO_PRIMITIVE = $e74a86236539799f$exports('toPrimitive');
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$882e0ad8a67ec86f$exports = function(input, pref) {
    if (!$924370d4951ad42d$exports(input) || $2cd9fc9cfeb42ac9$exports(input)) return input;
    var exoticToPrim = $333e279a47024ee9$exports(input, $882e0ad8a67ec86f$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = $e6d4173f39686687$exports(exoticToPrim, input, pref);
        if (!$924370d4951ad42d$exports(result) || $2cd9fc9cfeb42ac9$exports(result)) return result;
        throw new $882e0ad8a67ec86f$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = 'number';
    return $611f17d30b8b24db$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$d6853a08063b78e4$exports = function(argument) {
    var key = $882e0ad8a67ec86f$exports(argument, 'string');
    return $2cd9fc9cfeb42ac9$exports(key) ? key : key + '';
};



var $b71888fa6a419fec$exports = {};
'use strict';


var $3fd0d7e83748b483$exports = {};
'use strict';


var $3fd0d7e83748b483$var$document = $07998499f274e259$exports.document;
// typeof document.createElement is 'object' in old IE
var $3fd0d7e83748b483$var$EXISTS = $924370d4951ad42d$exports($3fd0d7e83748b483$var$document) && $924370d4951ad42d$exports($3fd0d7e83748b483$var$document.createElement);
$3fd0d7e83748b483$exports = function(it) {
    return $3fd0d7e83748b483$var$EXISTS ? $3fd0d7e83748b483$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$b71888fa6a419fec$exports = !$1c5c161750ba2318$exports && !$43ca4faa4c08cac6$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($3fd0d7e83748b483$exports('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a !== 7;
});


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $43059c765fd950ff$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$43059c765fd950ff$export$2d1720544b23b823 = $1c5c161750ba2318$exports ? $43059c765fd950ff$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $b6a1805cad1ce744$exports(O);
    P = $d6853a08063b78e4$exports(P);
    if ($b71888fa6a419fec$exports) try {
        return $43059c765fd950ff$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($22f28cc59c37d6a6$exports(O, P)) return $1ae5bf3096858a31$exports(!$e6d4173f39686687$exports($75dcc07f7d73ce0b$export$2d1720544b23b823, O, P), O[P]);
};


var $29850882e4bbedea$require$getOwnPropertyDescriptor = $43059c765fd950ff$export$2d1720544b23b823;
var $ee0ff772450a1c9b$exports = {};
'use strict';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $504dc1c5baf26623$export$2d1720544b23b823;
'use strict';


var $73e5de5205acd6ae$exports = {};
'use strict';


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$73e5de5205acd6ae$exports = $1c5c161750ba2318$exports && $43ca4faa4c08cac6$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, 'prototype', {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $3f75b546e5b693e9$exports = {};
'use strict';

var $3f75b546e5b693e9$var$$String = String;
var $3f75b546e5b693e9$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$3f75b546e5b693e9$exports = function(argument) {
    if ($924370d4951ad42d$exports(argument)) return argument;
    throw new $3f75b546e5b693e9$var$$TypeError($3f75b546e5b693e9$var$$String(argument) + ' is not an object');
};



var $504dc1c5baf26623$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $504dc1c5baf26623$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $504dc1c5baf26623$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $504dc1c5baf26623$var$ENUMERABLE = 'enumerable';
var $504dc1c5baf26623$var$CONFIGURABLE = 'configurable';
var $504dc1c5baf26623$var$WRITABLE = 'writable';
$504dc1c5baf26623$export$2d1720544b23b823 = $1c5c161750ba2318$exports ? $73e5de5205acd6ae$exports ? function defineProperty(O, P, Attributes) {
    $3f75b546e5b693e9$exports(O);
    P = $d6853a08063b78e4$exports(P);
    $3f75b546e5b693e9$exports(Attributes);
    if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && $504dc1c5baf26623$var$WRITABLE in Attributes && !Attributes[$504dc1c5baf26623$var$WRITABLE]) {
        var current = $504dc1c5baf26623$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$504dc1c5baf26623$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $504dc1c5baf26623$var$CONFIGURABLE in Attributes ? Attributes[$504dc1c5baf26623$var$CONFIGURABLE] : current[$504dc1c5baf26623$var$CONFIGURABLE],
                enumerable: $504dc1c5baf26623$var$ENUMERABLE in Attributes ? Attributes[$504dc1c5baf26623$var$ENUMERABLE] : current[$504dc1c5baf26623$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $504dc1c5baf26623$var$$defineProperty(O, P, Attributes);
} : $504dc1c5baf26623$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $3f75b546e5b693e9$exports(O);
    P = $d6853a08063b78e4$exports(P);
    $3f75b546e5b693e9$exports(Attributes);
    if ($b71888fa6a419fec$exports) try {
        return $504dc1c5baf26623$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw new $504dc1c5baf26623$var$$TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};



$ee0ff772450a1c9b$exports = $1c5c161750ba2318$exports ? function(object, key, value) {
    return $504dc1c5baf26623$export$2d1720544b23b823(object, key, $1ae5bf3096858a31$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};


var $0cfc8abd1cab26bf$exports = {};
'use strict';


var $fb3a82ee28846b6e$exports = {};
'use strict';





var $e4cba0162e188276$exports = {};
'use strict';


var $e4cba0162e188276$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $e4cba0162e188276$var$getDescriptor = $1c5c161750ba2318$exports && Object.getOwnPropertyDescriptor;
var $e4cba0162e188276$var$EXISTS = $22f28cc59c37d6a6$exports($e4cba0162e188276$var$FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var $e4cba0162e188276$var$PROPER = $e4cba0162e188276$var$EXISTS && (function something() {}).name === 'something';
var $e4cba0162e188276$var$CONFIGURABLE = $e4cba0162e188276$var$EXISTS && (!$1c5c161750ba2318$exports || $1c5c161750ba2318$exports && $e4cba0162e188276$var$getDescriptor($e4cba0162e188276$var$FunctionPrototype, 'name').configurable);
$e4cba0162e188276$exports = {
    EXISTS: $e4cba0162e188276$var$EXISTS,
    PROPER: $e4cba0162e188276$var$PROPER,
    CONFIGURABLE: $e4cba0162e188276$var$CONFIGURABLE
};


var $fb3a82ee28846b6e$require$CONFIGURABLE_FUNCTION_NAME = $e4cba0162e188276$exports.CONFIGURABLE;
var $da629f440e08eefe$exports = {};
'use strict';



var $da629f440e08eefe$var$functionToString = $0d2d65811192edf9$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$4d95979672d16e01$exports($209b7ab25b003f8b$exports.inspectSource)) $209b7ab25b003f8b$exports.inspectSource = function(it) {
    return $da629f440e08eefe$var$functionToString(it);
};
$da629f440e08eefe$exports = $209b7ab25b003f8b$exports.inspectSource;


var $fb48e02a2d7ead14$exports = {};
'use strict';
var $6294a7cc8b481f6f$exports = {};
'use strict';


var $6294a7cc8b481f6f$var$WeakMap = $07998499f274e259$exports.WeakMap;
$6294a7cc8b481f6f$exports = $4d95979672d16e01$exports($6294a7cc8b481f6f$var$WeakMap) && /native code/.test(String($6294a7cc8b481f6f$var$WeakMap));







var $c4c8d94438e70e7c$exports = {};
'use strict';


var $c4c8d94438e70e7c$var$keys = $9d4c0fc2121b5662$exports('keys');
$c4c8d94438e70e7c$exports = function(key) {
    return $c4c8d94438e70e7c$var$keys[key] || ($c4c8d94438e70e7c$var$keys[key] = $dc4222fe468e4af0$exports(key));
};


var $8e828713de02255a$exports = {};
'use strict';
$8e828713de02255a$exports = {};


var $fb48e02a2d7ead14$var$OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var $fb48e02a2d7ead14$var$TypeError = $07998499f274e259$exports.TypeError;
var $fb48e02a2d7ead14$var$WeakMap = $07998499f274e259$exports.WeakMap;
var $fb48e02a2d7ead14$var$set, $fb48e02a2d7ead14$var$get, $fb48e02a2d7ead14$var$has;
var $fb48e02a2d7ead14$var$enforce = function(it) {
    return $fb48e02a2d7ead14$var$has(it) ? $fb48e02a2d7ead14$var$get(it) : $fb48e02a2d7ead14$var$set(it, {});
};
var $fb48e02a2d7ead14$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$924370d4951ad42d$exports(it) || (state = $fb48e02a2d7ead14$var$get(it)).type !== TYPE) throw new $fb48e02a2d7ead14$var$TypeError('Incompatible receiver, ' + TYPE + ' required');
        return state;
    };
};
if ($6294a7cc8b481f6f$exports || $209b7ab25b003f8b$exports.state) {
    var $fb48e02a2d7ead14$var$store = $209b7ab25b003f8b$exports.state || ($209b7ab25b003f8b$exports.state = new $fb48e02a2d7ead14$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $fb48e02a2d7ead14$var$store.get = $fb48e02a2d7ead14$var$store.get;
    $fb48e02a2d7ead14$var$store.has = $fb48e02a2d7ead14$var$store.has;
    $fb48e02a2d7ead14$var$store.set = $fb48e02a2d7ead14$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $fb48e02a2d7ead14$var$set = function(it, metadata) {
        if ($fb48e02a2d7ead14$var$store.has(it)) throw new $fb48e02a2d7ead14$var$TypeError($fb48e02a2d7ead14$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $fb48e02a2d7ead14$var$store.set(it, metadata);
        return metadata;
    };
    $fb48e02a2d7ead14$var$get = function(it) {
        return $fb48e02a2d7ead14$var$store.get(it) || {};
    };
    $fb48e02a2d7ead14$var$has = function(it) {
        return $fb48e02a2d7ead14$var$store.has(it);
    };
} else {
    var $fb48e02a2d7ead14$var$STATE = $c4c8d94438e70e7c$exports('state');
    $8e828713de02255a$exports[$fb48e02a2d7ead14$var$STATE] = true;
    $fb48e02a2d7ead14$var$set = function(it, metadata) {
        if ($22f28cc59c37d6a6$exports(it, $fb48e02a2d7ead14$var$STATE)) throw new $fb48e02a2d7ead14$var$TypeError($fb48e02a2d7ead14$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $ee0ff772450a1c9b$exports(it, $fb48e02a2d7ead14$var$STATE, metadata);
        return metadata;
    };
    $fb48e02a2d7ead14$var$get = function(it) {
        return $22f28cc59c37d6a6$exports(it, $fb48e02a2d7ead14$var$STATE) ? it[$fb48e02a2d7ead14$var$STATE] : {};
    };
    $fb48e02a2d7ead14$var$has = function(it) {
        return $22f28cc59c37d6a6$exports(it, $fb48e02a2d7ead14$var$STATE);
    };
}
$fb48e02a2d7ead14$exports = {
    set: $fb48e02a2d7ead14$var$set,
    get: $fb48e02a2d7ead14$var$get,
    has: $fb48e02a2d7ead14$var$has,
    enforce: $fb48e02a2d7ead14$var$enforce,
    getterFor: $fb48e02a2d7ead14$var$getterFor
};


var $fb3a82ee28846b6e$var$enforceInternalState = $fb48e02a2d7ead14$exports.enforce;
var $fb3a82ee28846b6e$var$getInternalState = $fb48e02a2d7ead14$exports.get;
var $fb3a82ee28846b6e$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $fb3a82ee28846b6e$var$defineProperty = Object.defineProperty;
var $fb3a82ee28846b6e$var$stringSlice = $0d2d65811192edf9$exports(''.slice);
var $fb3a82ee28846b6e$var$replace = $0d2d65811192edf9$exports(''.replace);
var $fb3a82ee28846b6e$var$join = $0d2d65811192edf9$exports([].join);
var $fb3a82ee28846b6e$var$CONFIGURABLE_LENGTH = $1c5c161750ba2318$exports && !$43ca4faa4c08cac6$exports(function() {
    return $fb3a82ee28846b6e$var$defineProperty(function() {}, 'length', {
        value: 8
    }).length !== 8;
});
var $fb3a82ee28846b6e$var$TEMPLATE = String(String).split('String');
var $fb3a82ee28846b6e$var$makeBuiltIn = $fb3a82ee28846b6e$exports = function(value, name, options) {
    if ($fb3a82ee28846b6e$var$stringSlice($fb3a82ee28846b6e$var$$String(name), 0, 7) === 'Symbol(') name = '[' + $fb3a82ee28846b6e$var$replace($fb3a82ee28846b6e$var$$String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
    if (options && options.getter) name = 'get ' + name;
    if (options && options.setter) name = 'set ' + name;
    if (!$22f28cc59c37d6a6$exports(value, 'name') || $fb3a82ee28846b6e$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($1c5c161750ba2318$exports) $fb3a82ee28846b6e$var$defineProperty(value, 'name', {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($fb3a82ee28846b6e$var$CONFIGURABLE_LENGTH && options && $22f28cc59c37d6a6$exports(options, 'arity') && value.length !== options.arity) $fb3a82ee28846b6e$var$defineProperty(value, 'length', {
        value: options.arity
    });
    try {
        if (options && $22f28cc59c37d6a6$exports(options, 'constructor') && options.constructor) {
            if ($1c5c161750ba2318$exports) $fb3a82ee28846b6e$var$defineProperty(value, 'prototype', {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $fb3a82ee28846b6e$var$enforceInternalState(value);
    if (!$22f28cc59c37d6a6$exports(state, 'source')) state.source = $fb3a82ee28846b6e$var$join($fb3a82ee28846b6e$var$TEMPLATE, typeof name == 'string' ? name : '');
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $fb3a82ee28846b6e$var$makeBuiltIn(function toString() {
    return $4d95979672d16e01$exports(this) && $fb3a82ee28846b6e$var$getInternalState(this).source || $da629f440e08eefe$exports(this);
}, 'toString');



$0cfc8abd1cab26bf$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($4d95979672d16e01$exports(value)) $fb3a82ee28846b6e$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $3bc3b5220f5e6402$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $504dc1c5baf26623$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $5ad6e9c85a51de7b$exports = {};
'use strict';

var $8d4a841cdc4bca3f$exports = {};
'use strict';


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $267a63d85b48709d$export$2d1720544b23b823;
'use strict';
var $cc0d4eedd5e2249b$exports = {};
'use strict';



var $f68f4ee6353b273b$exports = {};
'use strict';

var $435f8d596523de78$exports = {};
'use strict';
var $9726cfac85e67518$exports = {};
'use strict';
var $a3e3a172112a3983$exports = {};
'use strict';
var $a3e3a172112a3983$var$ceil = Math.ceil;
var $a3e3a172112a3983$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$a3e3a172112a3983$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $a3e3a172112a3983$var$floor : $a3e3a172112a3983$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$9726cfac85e67518$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $a3e3a172112a3983$exports(number);
};


var $435f8d596523de78$var$max = Math.max;
var $435f8d596523de78$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$435f8d596523de78$exports = function(index, length) {
    var integer = $9726cfac85e67518$exports(index);
    return integer < 0 ? $435f8d596523de78$var$max(integer + length, 0) : $435f8d596523de78$var$min(integer, length);
};


var $dc0a95bf1d37d610$exports = {};
'use strict';
var $25db2042346e15a5$exports = {};
'use strict';

var $25db2042346e15a5$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$25db2042346e15a5$exports = function(argument) {
    var len = $9726cfac85e67518$exports(argument);
    return len > 0 ? $25db2042346e15a5$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$dc0a95bf1d37d610$exports = function(obj) {
    return $25db2042346e15a5$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $f68f4ee6353b273b$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $b6a1805cad1ce744$exports($this);
        var length = $dc0a95bf1d37d610$exports(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $435f8d596523de78$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$f68f4ee6353b273b$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $f68f4ee6353b273b$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $f68f4ee6353b273b$var$createMethod(false)
};


var $cc0d4eedd5e2249b$require$indexOf = $f68f4ee6353b273b$exports.indexOf;

var $cc0d4eedd5e2249b$var$push = $0d2d65811192edf9$exports([].push);
$cc0d4eedd5e2249b$exports = function(object, names) {
    var O = $b6a1805cad1ce744$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$22f28cc59c37d6a6$exports($8e828713de02255a$exports, key) && $22f28cc59c37d6a6$exports(O, key) && $cc0d4eedd5e2249b$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($22f28cc59c37d6a6$exports(O, key = names[i++])) ~$cc0d4eedd5e2249b$require$indexOf(result, key) || $cc0d4eedd5e2249b$var$push(result, key);
    return result;
};


var $74349776ee114867$exports = {};
'use strict';
// IE8- don't enum bug keys
$74349776ee114867$exports = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];


var $267a63d85b48709d$var$hiddenKeys = $74349776ee114867$exports.concat('length', 'prototype');
$267a63d85b48709d$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $cc0d4eedd5e2249b$exports(O, $267a63d85b48709d$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $1829efc5f3d98e55$export$2d1720544b23b823;
'use strict';
$1829efc5f3d98e55$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $8d4a841cdc4bca3f$var$concat = $0d2d65811192edf9$exports([].concat);
// all object keys, includes non-enumerable and symbols
$8d4a841cdc4bca3f$exports = $3a6da97d1c60ac9a$exports('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = $267a63d85b48709d$export$2d1720544b23b823($3f75b546e5b693e9$exports(it));
    var getOwnPropertySymbols = $1829efc5f3d98e55$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $8d4a841cdc4bca3f$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$5ad6e9c85a51de7b$exports = function(target, source, exceptions) {
    var keys = $8d4a841cdc4bca3f$exports(source);
    var defineProperty = $504dc1c5baf26623$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $43059c765fd950ff$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$22f28cc59c37d6a6$exports(target, key) && !(exceptions && $22f28cc59c37d6a6$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $1abdfd27f3f18e6f$exports = {};
'use strict';


var $1abdfd27f3f18e6f$var$replacement = /#|\.prototype\./;
var $1abdfd27f3f18e6f$var$isForced = function(feature, detection) {
    var value = $1abdfd27f3f18e6f$var$data[$1abdfd27f3f18e6f$var$normalize(feature)];
    return value === $1abdfd27f3f18e6f$var$POLYFILL ? true : value === $1abdfd27f3f18e6f$var$NATIVE ? false : $4d95979672d16e01$exports(detection) ? $43ca4faa4c08cac6$exports(detection) : !!detection;
};
var $1abdfd27f3f18e6f$var$normalize = $1abdfd27f3f18e6f$var$isForced.normalize = function(string) {
    return String(string).replace($1abdfd27f3f18e6f$var$replacement, '.').toLowerCase();
};
var $1abdfd27f3f18e6f$var$data = $1abdfd27f3f18e6f$var$isForced.data = {};
var $1abdfd27f3f18e6f$var$NATIVE = $1abdfd27f3f18e6f$var$isForced.NATIVE = 'N';
var $1abdfd27f3f18e6f$var$POLYFILL = $1abdfd27f3f18e6f$var$isForced.POLYFILL = 'P';
$1abdfd27f3f18e6f$exports = $1abdfd27f3f18e6f$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $29850882e4bbedea$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $07998499f274e259$exports;
    else if (STATIC) target = $07998499f274e259$exports[TARGET] || $3bc3b5220f5e6402$exports(TARGET, {});
    else target = $07998499f274e259$exports[TARGET] && $07998499f274e259$exports[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $29850882e4bbedea$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $1abdfd27f3f18e6f$exports(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $5ad6e9c85a51de7b$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $ee0ff772450a1c9b$exports(sourceProperty, 'sham', true);
        $0cfc8abd1cab26bf$exports(target, key, sourceProperty, options);
    }
};




// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
var $2f766a81f418f53e$export$2d1720544b23b823;
'use strict';

var $2f766a81f418f53e$var$$TypeError = TypeError;
var $2f766a81f418f53e$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw new $2f766a81f418f53e$var$$TypeError('Bad Promise constructor');
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $e36db42b9d5d42af$exports(resolve);
    this.reject = $e36db42b9d5d42af$exports(reject);
};
$2f766a81f418f53e$export$2d1720544b23b823 = function(C) {
    return new $2f766a81f418f53e$var$PromiseCapability(C);
};


var $6f01569580a5fd5c$exports = {};
'use strict';
$6f01569580a5fd5c$exports = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};


var $a53b9bb0ef1f9007$exports = {};
'use strict';
var $2c2f2f2732ff670e$exports = {};
'use strict';
var $b5ba91dc59d95cef$exports = {};
'use strict';


$b5ba91dc59d95cef$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($e694db3d47ffa133$exports(fn) === 'Function') return $0d2d65811192edf9$exports(fn);
};




var $2c2f2f2732ff670e$var$bind = $b5ba91dc59d95cef$exports($b5ba91dc59d95cef$exports.bind);
// optional / simple context binding
$2c2f2f2732ff670e$exports = function(fn, that) {
    $e36db42b9d5d42af$exports(fn);
    return that === undefined ? fn : $e4bfd52c2d32d906$exports ? $2c2f2f2732ff670e$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};





var $9ed71dd9c4ea2680$exports = {};
'use strict';

var $64b2ed412593cc08$exports = {};
'use strict';
$64b2ed412593cc08$exports = {};


var $9ed71dd9c4ea2680$var$ITERATOR = $e74a86236539799f$exports('iterator');
var $9ed71dd9c4ea2680$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
$9ed71dd9c4ea2680$exports = function(it) {
    return it !== undefined && ($64b2ed412593cc08$exports.Array === it || $9ed71dd9c4ea2680$var$ArrayPrototype[$9ed71dd9c4ea2680$var$ITERATOR] === it);
};




var $6be65eac4596c7ca$exports = {};
'use strict';




var $3835377711042a0d$exports = {};
'use strict';
var $2748dccea2d04fe5$exports = {};
'use strict';
var $93d3f4a67302f009$exports = {};
'use strict';

var $93d3f4a67302f009$var$TO_STRING_TAG = $e74a86236539799f$exports('toStringTag');
var $93d3f4a67302f009$var$test = {};
$93d3f4a67302f009$var$test[$93d3f4a67302f009$var$TO_STRING_TAG] = 'z';
$93d3f4a67302f009$exports = String($93d3f4a67302f009$var$test) === '[object z]';





var $2748dccea2d04fe5$var$TO_STRING_TAG = $e74a86236539799f$exports('toStringTag');
var $2748dccea2d04fe5$var$$Object = Object;
// ES3 wrong here
var $2748dccea2d04fe5$var$CORRECT_ARGUMENTS = $e694db3d47ffa133$exports(function() {
    return arguments;
}()) === 'Arguments';
// fallback for IE11 Script Access Denied error
var $2748dccea2d04fe5$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$2748dccea2d04fe5$exports = $93d3f4a67302f009$exports ? $e694db3d47ffa133$exports : function(it) {
    var O, tag, result;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = $2748dccea2d04fe5$var$tryGet(O = $2748dccea2d04fe5$var$$Object(it), $2748dccea2d04fe5$var$TO_STRING_TAG)) == 'string' ? tag : $2748dccea2d04fe5$var$CORRECT_ARGUMENTS ? $e694db3d47ffa133$exports(O) : (result = $e694db3d47ffa133$exports(O)) === 'Object' && $4d95979672d16e01$exports(O.callee) ? 'Arguments' : result;
};






var $3835377711042a0d$var$ITERATOR = $e74a86236539799f$exports('iterator');
$3835377711042a0d$exports = function(it) {
    if (!$9391530d69afc856$exports(it)) return $333e279a47024ee9$exports(it, $3835377711042a0d$var$ITERATOR) || $333e279a47024ee9$exports(it, '@@iterator') || $64b2ed412593cc08$exports[$2748dccea2d04fe5$exports(it)];
};


var $6be65eac4596c7ca$var$$TypeError = TypeError;
$6be65eac4596c7ca$exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $3835377711042a0d$exports(argument) : usingIterator;
    if ($e36db42b9d5d42af$exports(iteratorMethod)) return $3f75b546e5b693e9$exports($e6d4173f39686687$exports(iteratorMethod, argument));
    throw new $6be65eac4596c7ca$var$$TypeError($f73f880bcaff5725$exports(argument) + ' is not iterable');
};



var $56abccf0efaf06e1$exports = {};
'use strict';



$56abccf0efaf06e1$exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $3f75b546e5b693e9$exports(iterator);
    try {
        innerResult = $333e279a47024ee9$exports(iterator, 'return');
        if (!innerResult) {
            if (kind === 'throw') throw value;
            return value;
        }
        innerResult = $e6d4173f39686687$exports(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === 'throw') throw value;
    if (innerError) throw innerResult;
    $3f75b546e5b693e9$exports(innerResult);
    return value;
};


var $a53b9bb0ef1f9007$var$$TypeError = TypeError;
var $a53b9bb0ef1f9007$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $a53b9bb0ef1f9007$var$ResultPrototype = $a53b9bb0ef1f9007$var$Result.prototype;
$a53b9bb0ef1f9007$exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $2c2f2f2732ff670e$exports(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $56abccf0efaf06e1$exports(iterator, 'normal', condition);
        return new $a53b9bb0ef1f9007$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $3f75b546e5b693e9$exports(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $3835377711042a0d$exports(iterable);
        if (!iterFn) throw new $a53b9bb0ef1f9007$var$$TypeError($f73f880bcaff5725$exports(iterable) + ' is not iterable');
        // optimisation for array iterators
        if ($9ed71dd9c4ea2680$exports(iterFn)) {
            for(index = 0, length = $dc0a95bf1d37d610$exports(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $44741d43c106a994$exports($a53b9bb0ef1f9007$var$ResultPrototype, result)) return result;
            }
            return new $a53b9bb0ef1f9007$var$Result(false);
        }
        iterator = $6be65eac4596c7ca$exports(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $e6d4173f39686687$exports(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $56abccf0efaf06e1$exports(iterator, 'throw', error);
        }
        if (typeof result == 'object' && result && $44741d43c106a994$exports($a53b9bb0ef1f9007$var$ResultPrototype, result)) return result;
    }
    return new $a53b9bb0ef1f9007$var$Result(false);
};


var $282818a80ea589e9$exports = {};
'use strict';
var $622212d690c6e2b8$exports = {};
'use strict';

$622212d690c6e2b8$exports = $07998499f274e259$exports.Promise;


var $0f2a521245922699$exports = {};
'use strict';

var $0f2a521245922699$var$ITERATOR = $e74a86236539799f$exports('iterator');
var $0f2a521245922699$var$SAFE_CLOSING = false;
try {
    var $0f2a521245922699$var$called = 0;
    var $0f2a521245922699$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$0f2a521245922699$var$called++
            };
        },
        'return': function() {
            $0f2a521245922699$var$SAFE_CLOSING = true;
        }
    };
    $0f2a521245922699$var$iteratorWithReturn[$0f2a521245922699$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($0f2a521245922699$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
$0f2a521245922699$exports = function(exec, SKIP_CLOSING) {
    try {
        if (!SKIP_CLOSING && !$0f2a521245922699$var$SAFE_CLOSING) return false;
    } catch (error) {
        return false;
    } // workaround of old WebKit + `eval` bug
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$0f2a521245922699$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};


var $156f578545c62652$exports = {};
'use strict';






var $d571eb523bbd6f20$exports = {};
'use strict';



var $d571eb523bbd6f20$var$userAgentStartsWith = function(string) {
    return $af44d573516928c0$exports.slice(0, string.length) === string;
};
$d571eb523bbd6f20$exports = function() {
    if ($d571eb523bbd6f20$var$userAgentStartsWith('Bun/')) return 'BUN';
    if ($d571eb523bbd6f20$var$userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
    if ($d571eb523bbd6f20$var$userAgentStartsWith('Deno/')) return 'DENO';
    if ($d571eb523bbd6f20$var$userAgentStartsWith('Node.js/')) return 'NODE';
    if ($07998499f274e259$exports.Bun && typeof Bun.version == 'string') return 'BUN';
    if ($07998499f274e259$exports.Deno && typeof Deno.version == 'object') return 'DENO';
    if ($e694db3d47ffa133$exports($07998499f274e259$exports.process) === 'process') return 'NODE';
    if ($07998499f274e259$exports.window && $07998499f274e259$exports.document) return 'BROWSER';
    return 'REST';
}();




var $156f578545c62652$var$NativePromisePrototype = $622212d690c6e2b8$exports && $622212d690c6e2b8$exports.prototype;
var $156f578545c62652$var$SPECIES = $e74a86236539799f$exports('species');
var $156f578545c62652$var$SUBCLASSING = false;
var $156f578545c62652$var$NATIVE_PROMISE_REJECTION_EVENT = $4d95979672d16e01$exports($07998499f274e259$exports.PromiseRejectionEvent);
var $156f578545c62652$var$FORCED_PROMISE_CONSTRUCTOR = $1abdfd27f3f18e6f$exports('Promise', function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $da629f440e08eefe$exports($622212d690c6e2b8$exports);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($622212d690c6e2b8$exports);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $6c492956451b2016$exports === 66) return true;
    // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
    if ($69c699ff9075b9ca$exports && !($156f578545c62652$var$NativePromisePrototype['catch'] && $156f578545c62652$var$NativePromisePrototype['finally'])) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if (!$6c492956451b2016$exports || $6c492956451b2016$exports < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
        // Detect correctness of subclassing with @@species support
        var promise = new $622212d690c6e2b8$exports(function(resolve) {
            resolve(1);
        });
        var FakePromise = function(exec) {
            exec(function() {}, function() {});
        };
        var constructor = promise.constructor = {};
        constructor[$156f578545c62652$var$SPECIES] = FakePromise;
        $156f578545c62652$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
        if (!$156f578545c62652$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    }
    return !GLOBAL_CORE_JS_PROMISE && ($d571eb523bbd6f20$exports === 'BROWSER' || $d571eb523bbd6f20$exports === 'DENO') && !$156f578545c62652$var$NATIVE_PROMISE_REJECTION_EVENT;
});
$156f578545c62652$exports = {
    CONSTRUCTOR: $156f578545c62652$var$FORCED_PROMISE_CONSTRUCTOR,
    REJECTION_EVENT: $156f578545c62652$var$NATIVE_PROMISE_REJECTION_EVENT,
    SUBCLASSING: $156f578545c62652$var$SUBCLASSING
};


var $282818a80ea589e9$require$FORCED_PROMISE_CONSTRUCTOR = $156f578545c62652$exports.CONSTRUCTOR;
$282818a80ea589e9$exports = $282818a80ea589e9$require$FORCED_PROMISE_CONSTRUCTOR || !$0f2a521245922699$exports(function(iterable) {
    $622212d690c6e2b8$exports.all(iterable).then(undefined, function() {});
});


// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$29850882e4bbedea$exports({
    target: 'Promise',
    stat: true,
    forced: $282818a80ea589e9$exports
}, {
    allSettled: function allSettled(iterable) {
        var C = this;
        var capability = $2f766a81f418f53e$export$2d1720544b23b823(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $6f01569580a5fd5c$exports(function() {
            var promiseResolve = $e36db42b9d5d42af$exports(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $a53b9bb0ef1f9007$exports(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $e6d4173f39686687$exports(promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: 'fulfilled',
                        value: value
                    };
                    --remaining || resolve(values);
                }, function(error) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: 'rejected',
                        reason: error
                    };
                    --remaining || resolve(values);
                });
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});




'use strict';

var $ff3f069dc759d23a$exports = {};
'use strict';
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
$ff3f069dc759d23a$exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};


var $47d8e88848229ae6$exports = {};
'use strict';

var $47d8e88848229ae6$var$classList = $3fd0d7e83748b483$exports('span').classList;
var $47d8e88848229ae6$var$DOMTokenListPrototype = $47d8e88848229ae6$var$classList && $47d8e88848229ae6$var$classList.constructor && $47d8e88848229ae6$var$classList.constructor.prototype;
$47d8e88848229ae6$exports = $47d8e88848229ae6$var$DOMTokenListPrototype === Object.prototype ? undefined : $47d8e88848229ae6$var$DOMTokenListPrototype;


var $2485aef259a671d2$exports = {};
'use strict';

var $e55973d36732a6d1$exports = {};
'use strict';

var $98a136bc5a7eb71f$exports = {};
'use strict';

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $c7152e767e02c294$export$2d1720544b23b823;
'use strict';





var $81713435cc189377$exports = {};
'use strict';


// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
$81713435cc189377$exports = Object.keys || function keys(O) {
    return $cc0d4eedd5e2249b$exports(O, $74349776ee114867$exports);
};


$c7152e767e02c294$export$2d1720544b23b823 = $1c5c161750ba2318$exports && !$73e5de5205acd6ae$exports ? Object.defineProperties : function defineProperties(O, Properties) {
    $3f75b546e5b693e9$exports(O);
    var props = $b6a1805cad1ce744$exports(Properties);
    var keys = $81713435cc189377$exports(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$504dc1c5baf26623$export$2d1720544b23b823(O, key = keys[index++], props[key]);
    return O;
};




var $95c2545d03d71129$exports = {};
'use strict';

$95c2545d03d71129$exports = $3a6da97d1c60ac9a$exports('document', 'documentElement');




var $98a136bc5a7eb71f$var$GT = '>';
var $98a136bc5a7eb71f$var$LT = '<';
var $98a136bc5a7eb71f$var$PROTOTYPE = 'prototype';
var $98a136bc5a7eb71f$var$SCRIPT = 'script';
var $98a136bc5a7eb71f$var$IE_PROTO = $c4c8d94438e70e7c$exports('IE_PROTO');
var $98a136bc5a7eb71f$var$EmptyConstructor = function() {};
var $98a136bc5a7eb71f$var$scriptTag = function(content) {
    return $98a136bc5a7eb71f$var$LT + $98a136bc5a7eb71f$var$SCRIPT + $98a136bc5a7eb71f$var$GT + content + $98a136bc5a7eb71f$var$LT + '/' + $98a136bc5a7eb71f$var$SCRIPT + $98a136bc5a7eb71f$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $98a136bc5a7eb71f$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($98a136bc5a7eb71f$var$scriptTag(''));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    // eslint-disable-next-line no-useless-assignment -- avoid memory leak
    activeXDocument = null;
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $98a136bc5a7eb71f$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $3fd0d7e83748b483$exports('iframe');
    var JS = 'java' + $98a136bc5a7eb71f$var$SCRIPT + ':';
    var iframeDocument;
    iframe.style.display = 'none';
    $95c2545d03d71129$exports.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($98a136bc5a7eb71f$var$scriptTag('document.F=Object'));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $98a136bc5a7eb71f$var$activeXDocument;
var $98a136bc5a7eb71f$var$NullProtoObject = function() {
    try {
        $98a136bc5a7eb71f$var$activeXDocument = new ActiveXObject('htmlfile');
    } catch (error) {}
    $98a136bc5a7eb71f$var$NullProtoObject = typeof document != 'undefined' ? document.domain && $98a136bc5a7eb71f$var$activeXDocument ? $98a136bc5a7eb71f$var$NullProtoObjectViaActiveX($98a136bc5a7eb71f$var$activeXDocument) // old IE
     : $98a136bc5a7eb71f$var$NullProtoObjectViaIFrame() : $98a136bc5a7eb71f$var$NullProtoObjectViaActiveX($98a136bc5a7eb71f$var$activeXDocument); // WSH
    var length = $74349776ee114867$exports.length;
    while(length--)delete $98a136bc5a7eb71f$var$NullProtoObject[$98a136bc5a7eb71f$var$PROTOTYPE][$74349776ee114867$exports[length]];
    return $98a136bc5a7eb71f$var$NullProtoObject();
};
$8e828713de02255a$exports[$98a136bc5a7eb71f$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
$98a136bc5a7eb71f$exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $98a136bc5a7eb71f$var$EmptyConstructor[$98a136bc5a7eb71f$var$PROTOTYPE] = $3f75b546e5b693e9$exports(O);
        result = new $98a136bc5a7eb71f$var$EmptyConstructor();
        $98a136bc5a7eb71f$var$EmptyConstructor[$98a136bc5a7eb71f$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$98a136bc5a7eb71f$var$IE_PROTO] = O;
    } else result = $98a136bc5a7eb71f$var$NullProtoObject();
    return Properties === undefined ? result : $c7152e767e02c294$export$2d1720544b23b823(result, Properties);
};



var $e55973d36732a6d1$require$defineProperty = $504dc1c5baf26623$export$2d1720544b23b823;
var $e55973d36732a6d1$var$UNSCOPABLES = $e74a86236539799f$exports('unscopables');
var $e55973d36732a6d1$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($e55973d36732a6d1$var$ArrayPrototype[$e55973d36732a6d1$var$UNSCOPABLES] === undefined) $e55973d36732a6d1$require$defineProperty($e55973d36732a6d1$var$ArrayPrototype, $e55973d36732a6d1$var$UNSCOPABLES, {
    configurable: true,
    value: $98a136bc5a7eb71f$exports(null)
});
// add a key to Array.prototype[@@unscopables]
$e55973d36732a6d1$exports = function(key) {
    $e55973d36732a6d1$var$ArrayPrototype[$e55973d36732a6d1$var$UNSCOPABLES][key] = true;
};





var $2485aef259a671d2$require$defineProperty = $504dc1c5baf26623$export$2d1720544b23b823;
var $8ca7312b8e20281f$exports = {};
'use strict';





var $8544de73565acc4c$exports = {};
'use strict';
var $84aa040ee45c156e$exports = {};
'use strict';




var $3188520e21515625$exports = {};
'use strict';




var $5c50bc5ba9c6df2d$exports = {};
'use strict';

$5c50bc5ba9c6df2d$exports = !$43ca4faa4c08cac6$exports(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});


var $3188520e21515625$var$IE_PROTO = $c4c8d94438e70e7c$exports('IE_PROTO');
var $3188520e21515625$var$$Object = Object;
var $3188520e21515625$var$ObjectPrototype = $3188520e21515625$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
$3188520e21515625$exports = $5c50bc5ba9c6df2d$exports ? $3188520e21515625$var$$Object.getPrototypeOf : function(O) {
    var object = $97a563d9b960a76a$exports(O);
    if ($22f28cc59c37d6a6$exports(object, $3188520e21515625$var$IE_PROTO)) return object[$3188520e21515625$var$IE_PROTO];
    var constructor = object.constructor;
    if ($4d95979672d16e01$exports(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $3188520e21515625$var$$Object ? $3188520e21515625$var$ObjectPrototype : null;
};





var $84aa040ee45c156e$var$ITERATOR = $e74a86236539799f$exports('iterator');
var $84aa040ee45c156e$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $84aa040ee45c156e$var$IteratorPrototype, $84aa040ee45c156e$var$PrototypeOfArrayIteratorPrototype, $84aa040ee45c156e$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $84aa040ee45c156e$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!('next' in $84aa040ee45c156e$var$arrayIterator)) $84aa040ee45c156e$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $84aa040ee45c156e$var$PrototypeOfArrayIteratorPrototype = $3188520e21515625$exports($3188520e21515625$exports($84aa040ee45c156e$var$arrayIterator));
        if ($84aa040ee45c156e$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $84aa040ee45c156e$var$IteratorPrototype = $84aa040ee45c156e$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $84aa040ee45c156e$var$NEW_ITERATOR_PROTOTYPE = !$924370d4951ad42d$exports($84aa040ee45c156e$var$IteratorPrototype) || $43ca4faa4c08cac6$exports(function() {
    var test = {};
    // FF44- legacy iterators case
    return $84aa040ee45c156e$var$IteratorPrototype[$84aa040ee45c156e$var$ITERATOR].call(test) !== test;
});
if ($84aa040ee45c156e$var$NEW_ITERATOR_PROTOTYPE) $84aa040ee45c156e$var$IteratorPrototype = {};
else if ($69c699ff9075b9ca$exports) $84aa040ee45c156e$var$IteratorPrototype = $98a136bc5a7eb71f$exports($84aa040ee45c156e$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$4d95979672d16e01$exports($84aa040ee45c156e$var$IteratorPrototype[$84aa040ee45c156e$var$ITERATOR])) $0cfc8abd1cab26bf$exports($84aa040ee45c156e$var$IteratorPrototype, $84aa040ee45c156e$var$ITERATOR, function() {
    return this;
});
$84aa040ee45c156e$exports = {
    IteratorPrototype: $84aa040ee45c156e$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $84aa040ee45c156e$var$BUGGY_SAFARI_ITERATORS
};


var $8544de73565acc4c$require$IteratorPrototype = $84aa040ee45c156e$exports.IteratorPrototype;


var $4407df970430b678$exports = {};
'use strict';

var $4407df970430b678$require$defineProperty = $504dc1c5baf26623$export$2d1720544b23b823;


var $4407df970430b678$var$TO_STRING_TAG = $e74a86236539799f$exports('toStringTag');
$4407df970430b678$exports = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$22f28cc59c37d6a6$exports(target, $4407df970430b678$var$TO_STRING_TAG)) $4407df970430b678$require$defineProperty(target, $4407df970430b678$var$TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};



var $8544de73565acc4c$var$returnThis = function() {
    return this;
};
$8544de73565acc4c$exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + ' Iterator';
    IteratorConstructor.prototype = $98a136bc5a7eb71f$exports($8544de73565acc4c$require$IteratorPrototype, {
        next: $1ae5bf3096858a31$exports(+!ENUMERABLE_NEXT, next)
    });
    $4407df970430b678$exports(IteratorConstructor, TO_STRING_TAG, false, true);
    $64b2ed412593cc08$exports[TO_STRING_TAG] = $8544de73565acc4c$var$returnThis;
    return IteratorConstructor;
};



var $d6542d2db90cfe58$exports = {};
'use strict';
var $166b840812c838b0$exports = {};
'use strict';


$166b840812c838b0$exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $0d2d65811192edf9$exports($e36db42b9d5d42af$exports(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};




var $c1cae594eac70900$exports = {};
'use strict';
var $2626ae607b6e29fc$exports = {};
'use strict';

$2626ae607b6e29fc$exports = function(argument) {
    return $924370d4951ad42d$exports(argument) || argument === null;
};


var $c1cae594eac70900$var$$String = String;
var $c1cae594eac70900$var$$TypeError = TypeError;
$c1cae594eac70900$exports = function(argument) {
    if ($2626ae607b6e29fc$exports(argument)) return argument;
    throw new $c1cae594eac70900$var$$TypeError("Can't set " + $c1cae594eac70900$var$$String(argument) + ' as a prototype');
};


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
$d6542d2db90cfe58$exports = Object.setPrototypeOf || ('__proto__' in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $166b840812c838b0$exports(Object.prototype, '__proto__', 'set');
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $0a597a3e038187ad$exports(O);
        $c1cae594eac70900$exports(proto);
        if (!$924370d4951ad42d$exports(O)) return O;
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);








var $8ca7312b8e20281f$var$PROPER_FUNCTION_NAME = $e4cba0162e188276$exports.PROPER;
var $8ca7312b8e20281f$var$CONFIGURABLE_FUNCTION_NAME = $e4cba0162e188276$exports.CONFIGURABLE;
var $8ca7312b8e20281f$var$IteratorPrototype = $84aa040ee45c156e$exports.IteratorPrototype;
var $8ca7312b8e20281f$var$BUGGY_SAFARI_ITERATORS = $84aa040ee45c156e$exports.BUGGY_SAFARI_ITERATORS;
var $8ca7312b8e20281f$var$ITERATOR = $e74a86236539799f$exports('iterator');
var $8ca7312b8e20281f$var$KEYS = 'keys';
var $8ca7312b8e20281f$var$VALUES = 'values';
var $8ca7312b8e20281f$var$ENTRIES = 'entries';
var $8ca7312b8e20281f$var$returnThis = function() {
    return this;
};
$8ca7312b8e20281f$exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $8544de73565acc4c$exports(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$8ca7312b8e20281f$var$BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $8ca7312b8e20281f$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $8ca7312b8e20281f$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $8ca7312b8e20281f$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + ' Iterator';
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$8ca7312b8e20281f$var$ITERATOR] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$8ca7312b8e20281f$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $3188520e21515625$exports(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$69c699ff9075b9ca$exports && $3188520e21515625$exports(CurrentIteratorPrototype) !== $8ca7312b8e20281f$var$IteratorPrototype) {
                if ($d6542d2db90cfe58$exports) $d6542d2db90cfe58$exports(CurrentIteratorPrototype, $8ca7312b8e20281f$var$IteratorPrototype);
                else if (!$4d95979672d16e01$exports(CurrentIteratorPrototype[$8ca7312b8e20281f$var$ITERATOR])) $0cfc8abd1cab26bf$exports(CurrentIteratorPrototype, $8ca7312b8e20281f$var$ITERATOR, $8ca7312b8e20281f$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $4407df970430b678$exports(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($69c699ff9075b9ca$exports) $64b2ed412593cc08$exports[TO_STRING_TAG] = $8ca7312b8e20281f$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($8ca7312b8e20281f$var$PROPER_FUNCTION_NAME && DEFAULT === $8ca7312b8e20281f$var$VALUES && nativeIterator && nativeIterator.name !== $8ca7312b8e20281f$var$VALUES) {
        if (!$69c699ff9075b9ca$exports && $8ca7312b8e20281f$var$CONFIGURABLE_FUNCTION_NAME) $ee0ff772450a1c9b$exports(IterablePrototype, 'name', $8ca7312b8e20281f$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $e6d4173f39686687$exports(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($8ca7312b8e20281f$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($8ca7312b8e20281f$var$KEYS),
            entries: getIterationMethod($8ca7312b8e20281f$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($8ca7312b8e20281f$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $0cfc8abd1cab26bf$exports(IterablePrototype, KEY, methods[KEY]);
        } else $29850882e4bbedea$exports({
            target: NAME,
            proto: true,
            forced: $8ca7312b8e20281f$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$69c699ff9075b9ca$exports || FORCED) && IterablePrototype[$8ca7312b8e20281f$var$ITERATOR] !== defaultIterator) $0cfc8abd1cab26bf$exports(IterablePrototype, $8ca7312b8e20281f$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $64b2ed412593cc08$exports[NAME] = defaultIterator;
    return methods;
};


var $b9124ae661c6eb93$exports = {};
'use strict';
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
$b9124ae661c6eb93$exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};




var $2485aef259a671d2$var$ARRAY_ITERATOR = 'Array Iterator';
var $2485aef259a671d2$var$setInternalState = $fb48e02a2d7ead14$exports.set;
var $2485aef259a671d2$var$getInternalState = $fb48e02a2d7ead14$exports.getterFor($2485aef259a671d2$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
$2485aef259a671d2$exports = $8ca7312b8e20281f$exports(Array, 'Array', function(iterated, kind) {
    $2485aef259a671d2$var$setInternalState(this, {
        type: $2485aef259a671d2$var$ARRAY_ITERATOR,
        target: $b6a1805cad1ce744$exports(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $2485aef259a671d2$var$getInternalState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = null;
        return $b9124ae661c6eb93$exports(undefined, true);
    }
    switch(state.kind){
        case 'keys':
            return $b9124ae661c6eb93$exports(index, false);
        case 'values':
            return $b9124ae661c6eb93$exports(target[index], false);
    }
    return $b9124ae661c6eb93$exports([
        index,
        target[index]
    ], false);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $2485aef259a671d2$var$values = $64b2ed412593cc08$exports.Arguments = $64b2ed412593cc08$exports.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$e55973d36732a6d1$exports('keys');
$e55973d36732a6d1$exports('values');
$e55973d36732a6d1$exports('entries');
// V8 ~ Chrome 45- bug
if (!$69c699ff9075b9ca$exports && $1c5c161750ba2318$exports && $2485aef259a671d2$var$values.name !== 'values') try {
    $2485aef259a671d2$require$defineProperty($2485aef259a671d2$var$values, 'name', {
        value: 'values'
    });
} catch (error) {}





var $a95acebdf931d3d3$var$ITERATOR = $e74a86236539799f$exports('iterator');
var $a95acebdf931d3d3$var$ArrayValues = $2485aef259a671d2$exports.values;
var $a95acebdf931d3d3$var$handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$a95acebdf931d3d3$var$ITERATOR] !== $a95acebdf931d3d3$var$ArrayValues) try {
            $ee0ff772450a1c9b$exports(CollectionPrototype, $a95acebdf931d3d3$var$ITERATOR, $a95acebdf931d3d3$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$a95acebdf931d3d3$var$ITERATOR] = $a95acebdf931d3d3$var$ArrayValues;
        }
        $4407df970430b678$exports(CollectionPrototype, COLLECTION_NAME, true);
        if ($ff3f069dc759d23a$exports[COLLECTION_NAME]) for(var METHOD_NAME in $2485aef259a671d2$exports){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $2485aef259a671d2$exports[METHOD_NAME]) try {
                $ee0ff772450a1c9b$exports(CollectionPrototype, METHOD_NAME, $2485aef259a671d2$exports[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $2485aef259a671d2$exports[METHOD_NAME];
            }
        }
    }
};
for(var $a95acebdf931d3d3$var$COLLECTION_NAME in $ff3f069dc759d23a$exports)$a95acebdf931d3d3$var$handlePrototype($07998499f274e259$exports[$a95acebdf931d3d3$var$COLLECTION_NAME] && $07998499f274e259$exports[$a95acebdf931d3d3$var$COLLECTION_NAME].prototype, $a95acebdf931d3d3$var$COLLECTION_NAME);
$a95acebdf931d3d3$var$handlePrototype($47d8e88848229ae6$exports, 'DOMTokenList');




parcelRequire("91i6m");
var $5ad7482c381ec9b7$export$882461b6382ed46c;
var $5ad7482c381ec9b7$export$757ceba2d55c277e;
'use strict';

var $eAqbf = parcelRequire("eAqbf");
var $5ad7482c381ec9b7$var$i;
$5ad7482c381ec9b7$export$882461b6382ed46c = $eAqbf.createRoot;
$5ad7482c381ec9b7$export$757ceba2d55c277e = $eAqbf.hydrateRoot;


parcelRequire("iCwDt");
var $49swM = parcelRequire("49swM");

var $9OWP7 = parcelRequire("9OWP7");

var $3jGGb = parcelRequire("3jGGb");

var $49Pnv = parcelRequire("49Pnv");

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $57Ksf = parcelRequire("57Ksf");

var $49Pnv = parcelRequire("49Pnv");

var $2aGBJ = parcelRequire("2aGBJ");

























const $85b6087885ab46d9$var$languages = {
    'pt-BR': ()=>(parcelRequire("9r9Q6")),
    'en-ZZ': ()=>(parcelRequire("2dPLK")),
    'en-GB': ()=>(parcelRequire("joCrC")),
    'zh-CN': ()=>(parcelRequire("2fjoA")),
    'zh-TW': ()=>(parcelRequire("3JUJR")),
    cs: ()=>(parcelRequire("aeXuF")),
    da: ()=>(parcelRequire("5toDY")),
    de: ()=>(parcelRequire("avvrx")),
    en: ()=>(parcelRequire("dl62I")),
    es: ()=>(parcelRequire("gD3sV")),
    fi: ()=>(parcelRequire("eONep")),
    fr: ()=>(parcelRequire("iBmbX")),
    hu: ()=>(parcelRequire("cGqrj")),
    it: ()=>(parcelRequire("VWk06")),
    ja: ()=>(parcelRequire("iKdYE")),
    ko: ()=>(parcelRequire("3GTan")),
    nb: ()=>(parcelRequire("jRF3A")),
    nl: ()=>(parcelRequire("27DUY")),
    pl: ()=>(parcelRequire("2FcqA")),
    ru: ()=>(parcelRequire("i0Gbl")),
    sv: ()=>(parcelRequire("eQwqH")),
    th: ()=>(parcelRequire("9alI5")),
    tr: ()=>(parcelRequire("6ZxNQ")),
    uk: ()=>(parcelRequire("20tBf")),
    vi: ()=>(parcelRequire("hMV6I"))
};
const $85b6087885ab46d9$var$fetchLanguage = async (locale)=>{
    if (locale in $85b6087885ab46d9$var$languages) {
        const messages = await $85b6087885ab46d9$var$languages[locale]();
        return {
            locale: locale,
            messages: messages.default || messages
        };
    }
    throw new Error(`${locale} not found in languages config`);
};
const $85b6087885ab46d9$var$LocaleSwitcher = ({ children: children })=>{
    const locale = (0, $2aGBJ.useAppSelector)((state)=>state.locale);
    const [fallbackLocale] = locale.split('-', 1);
    const [{ loading: loading, messages: messages, derivedLocale: derivedLocale }, setState] = (0, $91i6m.useState)({
        loading: true,
        messages: {},
        derivedLocale: locale
    });
    (0, $91i6m.useEffect)(()=>{
        $85b6087885ab46d9$var$fetchLanguage(locale).catch(()=>$85b6087885ab46d9$var$fetchLanguage(fallbackLocale)).then((i18n)=>{
            setState({
                loading: false,
                messages: i18n.messages,
                derivedLocale: i18n.locale
            });
        }, ()=>{
            const content = `no translations were found for localeId ${locale} or fallbackLocale ${fallbackLocale}.`;
            console.debug(content);
            (0, $49Pnv.captureErrorMessage)('i18n_fetch_language_error', {
                content: content,
                locale: locale,
                fallbackLocale: fallbackLocale
            });
            setState((prevState)=>(0, $b2I6k._)((0, $1Fos3._)({}, prevState), {
                    loading: false
                }));
        });
    }, [
        locale,
        fallbackLocale
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $57Ksf.default), {
        locale: derivedLocale,
        messages: messages,
        children: loading ? /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4ZSso.Fragment), {}) : children
    });
};
var $85b6087885ab46d9$export$2e2bcd8739ae039 = $85b6087885ab46d9$var$LocaleSwitcher;



var $lodUs = parcelRequire("lodUs");

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $1V2cH = parcelRequire("1V2cH");

var $leG06 = parcelRequire("leG06");

var $2aGBJ = parcelRequire("2aGBJ");
const $decb5539395a0980$var$AnalyticsClientProvider = ({ children: children })=>{
    const { locale: locale } = (0, $leG06.default)();
    const cobranding = (0, $2aGBJ.useAppSelector)((state)=>state.cobranding);
    const microbranding = (0, $2aGBJ.useAppSelector)((state)=>state.microbranding);
    const tenantCloudId = (0, $2aGBJ.useAppSelector)((state)=>state.context.tenantCloudId);
    const userId = (0, $2aGBJ.useAppSelector)((state)=>state.context.userId);
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $1V2cH.AnalyticsClientContext).Provider, {
        value: new (0, $1V2cH.AnalyticsClientImpl)({
            cobranding: cobranding,
            locale: locale,
            microbranding: microbranding,
            tenantCloudId: tenantCloudId,
            userId: userId
        }),
        children: children
    });
};
var $decb5539395a0980$export$2e2bcd8739ae039 = $decb5539395a0980$var$AnalyticsClientProvider;



var $abjTs = parcelRequire("abjTs");
parcelRequire("h8k8x");
var $jQauR = parcelRequire("jQauR");

var $2aGBJ = parcelRequire("2aGBJ");

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $2Yp8D = parcelRequire("2Yp8D");

var $2Yp8D = parcelRequire("2Yp8D");

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $2Yp8D = parcelRequire("2Yp8D");

var $eXMu6 = parcelRequire("eXMu6");

var $3gH3P = parcelRequire("3gH3P");

var $ljaX7 = parcelRequire("ljaX7");

var $dvGT8 = parcelRequire("dvGT8");
// CLASS
class $6c2c7a69def92fc2$export$62297b13309008b2 extends (0, $dvGT8.Removable) {
    get meta() {
        return this.options.meta;
    }
    setOptions(options) {
        this.options = (0, $1Fos3._)({}, this.defaultOptions, options);
        this.updateCacheTime(this.options.cacheTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === 'idle') this.cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, $2Yp8D.replaceData)(this.state.data, newData, this.options); // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: 'success',
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.dispatch({
            type: 'setState',
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _this$retryer;
        const promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $2Yp8D.noop)).catch((0, $2Yp8D.noop)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.initialState);
    }
    isActive() {
        return this.observers.some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((observer)=>observer.getCurrentResult().isStale);
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $2Yp8D.timeUntilStale)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _this$retryer2;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    }
    onOnline() {
        var _this$retryer3;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: 'observerAdded',
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.cache.notify({
                type: 'observerRemoved',
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: 'invalidate'
        });
    }
    fetch(options, fetchOptions) {
        var _this$options$behavio, _context$fetchOptions;
        if (this.state.fetchStatus !== 'idle') {
            if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = (0, $2Yp8D.getAbortController)(); // Create query function context
        const queryFnContext = {
            queryKey: this.queryKey,
            pageParam: undefined,
            meta: this.meta
        }; // Adds an enumerable signal property to the object that
        // which sets abortSignalConsumed to true when the signal
        // is read.
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, 'signal', {
                enumerable: true,
                get: ()=>{
                    if (abortController) {
                        this.abortSignalConsumed = true;
                        return abortController.signal;
                    }
                    return undefined;
                }
            });
        };
        addSignalProperty(queryFnContext); // Create fetch function
        const fetchFn = ()=>{
            if (!this.options.queryFn) return Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'");
            this.abortSignalConsumed = false;
            return this.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_this$options$behavio = this.options.behavior) == null || _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (this.state.fetchStatus === 'idle' || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: 'fetch',
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        }
        const onError = (error)=>{
            // Optimistically update state if needed
            if (!((0, $ljaX7.isCancelledError)(error) && error.silent)) this.dispatch({
                type: 'error',
                error: error
            });
            if (!(0, $ljaX7.isCancelledError)(error)) {
                var _this$cache$config$on, _this$cache$config, _this$cache$config$on2, _this$cache$config2;
                // Notify cache callback
                (_this$cache$config$on = (_this$cache$config = this.cache.config).onError) == null || _this$cache$config$on.call(_this$cache$config, error, this);
                (_this$cache$config$on2 = (_this$cache$config2 = this.cache.config).onSettled) == null || _this$cache$config$on2.call(_this$cache$config2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) // Schedule query gc after fetching
            this.scheduleGc();
            this.isFetchingOptimistic = false;
        }; // Try to fetch the data
        this.retryer = (0, $ljaX7.createRetryer)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _this$cache$config$on3, _this$cache$config3, _this$cache$config$on4, _this$cache$config4;
                if (typeof data === 'undefined') {
                    onError(new Error(this.queryHash + " data is undefined"));
                    return;
                }
                this.setData(data); // Notify cache callback
                (_this$cache$config$on3 = (_this$cache$config3 = this.cache.config).onSuccess) == null || _this$cache$config$on3.call(_this$cache$config3, data, this);
                (_this$cache$config$on4 = (_this$cache$config4 = this.cache.config).onSettled) == null || _this$cache$config$on4.call(_this$cache$config4, data, this.state.error, this);
                if (!this.isFetchingOptimistic) // Schedule query gc after fetching
                this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                this.dispatch({
                    type: 'failed',
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.dispatch({
                    type: 'pause'
                });
            },
            onContinue: ()=>{
                this.dispatch({
                    type: 'continue'
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        });
        this.promise = this.retryer.promise;
        return this.promise;
    }
    dispatch(action) {
        const reducer = (state)=>{
            var _action$meta, _action$dataUpdatedAt;
            switch(action.type){
                case 'failed':
                    return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    });
                case 'pause':
                    return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                        fetchStatus: 'paused'
                    });
                case 'continue':
                    return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                        fetchStatus: 'fetching'
                    });
                case 'fetch':
                    return (0, $1Fos3._)((0, $b2I6k._)((0, $1Fos3._)({}, state), {
                        fetchFailureCount: 0,
                        fetchFailureReason: null,
                        fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                        fetchStatus: (0, $ljaX7.canFetch)(this.options.networkMode) ? 'fetching' : 'paused'
                    }), !state.dataUpdatedAt && {
                        error: null,
                        status: 'loading'
                    });
                case 'success':
                    return (0, $1Fos3._)((0, $b2I6k._)((0, $1Fos3._)({}, state), {
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: 'success'
                    }), !action.manual && {
                        fetchStatus: 'idle',
                        fetchFailureCount: 0,
                        fetchFailureReason: null
                    });
                case 'error':
                    const error = action.error;
                    if ((0, $ljaX7.isCancelledError)(error) && error.revert && this.revertState) return (0, $b2I6k._)((0, $1Fos3._)({}, this.revertState), {
                        fetchStatus: 'idle'
                    });
                    return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: 'idle',
                        status: 'error'
                    });
                case 'invalidate':
                    return (0, $b2I6k._)((0, $1Fos3._)({}, state), {
                        isInvalidated: true
                    });
                case 'setState':
                    return (0, $1Fos3._)({}, state, action.state);
            }
        };
        this.state = reducer(this.state);
        (0, $3gH3P.notifyManager).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate(action);
            });
            this.cache.notify({
                query: this,
                type: 'updated',
                action: action
            });
        });
    }
    constructor(config){
        super();
        this.abortSignalConsumed = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.logger = config.logger || (0, $eXMu6.defaultLogger);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || $6c2c7a69def92fc2$var$getDefaultState(this.options);
        this.state = this.initialState;
        this.scheduleGc();
    }
}
function $6c2c7a69def92fc2$var$getDefaultState(options) {
    const data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
    const hasData = typeof data !== 'undefined';
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? 'success' : 'loading',
        fetchStatus: 'idle'
    };
}



var $3gH3P = parcelRequire("3gH3P");

var $5si2t = parcelRequire("5si2t");
// CLASS
class $cdff84a84529d533$export$5dde0cd941da8468 extends (0, $5si2t.Subscribable) {
    build(client, options, state) {
        var _options$queryHash;
        const queryKey = options.queryKey;
        const queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $2Yp8D.hashQueryKeyByOptions)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $6c2c7a69def92fc2$export$62297b13309008b2)({
                cache: this,
                logger: client.getLogger(),
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: 'added',
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter((x)=>x !== query);
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: 'removed',
                query: query
            });
        }
    }
    clear() {
        (0, $3gH3P.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.queriesMap[queryHash];
    }
    getAll() {
        return this.queries;
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ find(arg1, arg2) {
        const [filters] = (0, $2Yp8D.parseFilterArgs)(arg1, arg2);
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.queries.find((query)=>(0, $2Yp8D.matchQuery)(filters, query));
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ findAll(arg1, arg2) {
        const [filters] = (0, $2Yp8D.parseFilterArgs)(arg1, arg2);
        return Object.keys(filters).length > 0 ? this.queries.filter((query)=>(0, $2Yp8D.matchQuery)(filters, query)) : this.queries;
    }
    notify(event) {
        (0, $3gH3P.notifyManager).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $3gH3P.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $3gH3P.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                query.onOnline();
            });
        });
    }
    constructor(config){
        super();
        this.config = config || {};
        this.queries = [];
        this.queriesMap = {};
    }
}



var $3gH3P = parcelRequire("3gH3P");

var $6BVyE = parcelRequire("6BVyE");

var $2Yp8D = parcelRequire("2Yp8D");

var $5si2t = parcelRequire("5si2t");
// CLASS
class $ce2f72e80bc9b16c$export$1fcfd9a244434844 extends (0, $5si2t.Subscribable) {
    build(client, options, state) {
        const mutation = new (0, $6BVyE.Mutation)({
            mutationCache: this,
            logger: client.getLogger(),
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.mutations.push(mutation);
        this.notify({
            type: 'added',
            mutation: mutation
        });
    }
    remove(mutation) {
        this.mutations = this.mutations.filter((x)=>x !== mutation);
        this.notify({
            type: 'removed',
            mutation: mutation
        });
    }
    clear() {
        (0, $3gH3P.notifyManager).batch(()=>{
            this.mutations.forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return this.mutations;
    }
    find(filters) {
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.mutations.find((mutation)=>(0, $2Yp8D.matchMutation)(filters, mutation));
    }
    findAll(filters) {
        return this.mutations.filter((mutation)=>(0, $2Yp8D.matchMutation)(filters, mutation));
    }
    notify(event) {
        (0, $3gH3P.notifyManager).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        var _this$resuming;
        this.resuming = ((_this$resuming = this.resuming) != null ? _this$resuming : Promise.resolve()).then(()=>{
            const pausedMutations = this.mutations.filter((x)=>x.state.isPaused);
            return (0, $3gH3P.notifyManager).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, $2Yp8D.noop))), Promise.resolve()));
        }).then(()=>{
            this.resuming = undefined;
        });
        return this.resuming;
    }
    constructor(config){
        super();
        this.config = config || {};
        this.mutations = [];
        this.mutationId = 0;
    }
}



var $gCDn7 = parcelRequire("gCDn7");

var $aqfRd = parcelRequire("aqfRd");

var $3gH3P = parcelRequire("3gH3P");
function $0bb85776e63a65a1$export$84470d1367601e8d() {
    return {
        onFetch: (context)=>{
            context.fetchFn = ()=>{
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                const refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                const fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                const pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                const isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
                const isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
                const oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                const oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                let newPageParams = oldPageParams;
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, 'signal', {
                        enumerable: true,
                        get: ()=>{
                            var _context$signal;
                            if ((_context$signal = context.signal) != null && _context$signal.aborted) cancelled = true;
                            else {
                                var _context$signal2;
                                (_context$signal2 = context.signal) == null || _context$signal2.addEventListener('abort', ()=>{
                                    cancelled = true;
                                });
                            }
                            return context.signal;
                        }
                    });
                }; // Get query function
                const queryFn = context.options.queryFn || (()=>Promise.reject("Missing queryFn for queryKey '" + context.options.queryHash + "'"));
                const buildNewPages = (pages, param, page, previous)=>{
                    newPageParams = previous ? [
                        param,
                        ...newPageParams
                    ] : [
                        ...newPageParams,
                        param
                    ];
                    return previous ? [
                        page,
                        ...pages
                    ] : [
                        ...pages,
                        page
                    ];
                }; // Create function to fetch a page
                const fetchPage = (pages, manual, param, previous)=>{
                    if (cancelled) return Promise.reject('Cancelled');
                    if (typeof param === 'undefined' && !manual && pages.length) return Promise.resolve(pages);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const queryFnResult = queryFn(queryFnContext);
                    const promise = Promise.resolve(queryFnResult).then((page)=>buildNewPages(pages, param, page, previous));
                    return promise;
                };
                let promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    const manual = typeof pageParam !== 'undefined';
                    const param = manual ? pageParam : $0bb85776e63a65a1$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    const manual = typeof pageParam !== 'undefined';
                    const param = manual ? pageParam : $0bb85776e63a65a1$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param, true);
                } else {
                    newPageParams = [];
                    const manual = typeof context.options.getNextPageParam === 'undefined';
                    const shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    for(let i = 1; i < oldPages.length; i++)promise = promise.then((pages)=>{
                        const shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                        if (shouldFetchNextPage) {
                            const param = manual ? oldPageParams[i] : $0bb85776e63a65a1$export$1186159d57de7255(context.options, pages);
                            return fetchPage(pages, manual, param);
                        }
                        return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                }
                const finalPromise = promise.then((pages)=>({
                        pages: pages,
                        pageParams: newPageParams
                    }));
                return finalPromise;
            };
        }
    };
}
function $0bb85776e63a65a1$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $0bb85776e63a65a1$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */ function $0bb85776e63a65a1$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        const nextPageParam = $0bb85776e63a65a1$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
    }
    return;
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */ function $0bb85776e63a65a1$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        const previousPageParam = $0bb85776e63a65a1$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
    }
    return;
}



var $eXMu6 = parcelRequire("eXMu6");
// CLASS
class $6bb42d4b41548596$export$405d0624ed55a03f {
    mount() {
        this.mountCount++;
        if (this.mountCount !== 1) return;
        this.unsubscribeFocus = (0, $gCDn7.focusManager).subscribe(()=>{
            if ((0, $gCDn7.focusManager).isFocused()) {
                this.resumePausedMutations();
                this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $aqfRd.onlineManager).subscribe(()=>{
            if ((0, $aqfRd.onlineManager).isOnline()) {
                this.resumePausedMutations();
                this.queryCache.onOnline();
            }
        });
    }
    unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        this.mountCount--;
        if (this.mountCount !== 0) return;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        this.unsubscribeFocus = undefined;
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
        this.unsubscribeOnline = undefined;
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ isFetching(arg1, arg2) {
        const [filters] = (0, $2Yp8D.parseFilterArgs)(arg1, arg2);
        filters.fetchStatus = 'fetching';
        return this.queryCache.findAll(filters).length;
    }
    isMutating(filters) {
        return this.mutationCache.findAll((0, $b2I6k._)((0, $1Fos3._)({}, filters), {
            fetching: true
        })).length;
    }
    /**
   * @deprecated This method will accept only queryKey in the next major version.
   */ getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ ensureQueryData(arg1, arg2, arg3) {
        const parsedOptions = (0, $2Yp8D.parseQueryArgs)(arg1, arg2, arg3);
        const cachedData = this.getQueryData(parsedOptions.queryKey);
        return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(parsedOptions);
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const query = this.queryCache.find(queryKey);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $2Yp8D.functionalUpdate)(updater, prevData);
        if (typeof data === 'undefined') return undefined;
        const parsedOptions = (0, $2Yp8D.parseQueryArgs)(queryKey);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(data, (0, $b2I6k._)((0, $1Fos3._)({}, options), {
            manual: true
        }));
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ setQueriesData(queryKeyOrFilters, updater, options) {
        return (0, $3gH3P.notifyManager).batch(()=>this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey, /**
   * @deprecated This filters will be removed in the next major version.
   */ filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ removeQueries(arg1, arg2) {
        const [filters] = (0, $2Yp8D.parseFilterArgs)(arg1, arg2);
        const queryCache = this.queryCache;
        (0, $3gH3P.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ resetQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $2Yp8D.parseFilterArgs)(arg1, arg2, arg3);
        const queryCache = this.queryCache;
        const refetchFilters = (0, $1Fos3._)({
            type: 'active'
        }, filters);
        return (0, $3gH3P.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ cancelQueries(arg1, arg2, arg3) {
        const [filters, cancelOptions = {}] = (0, $2Yp8D.parseFilterArgs)(arg1, arg2, arg3);
        if (typeof cancelOptions.revert === 'undefined') cancelOptions.revert = true;
        const promises = (0, $3gH3P.notifyManager).batch(()=>this.queryCache.findAll(filters).map((query)=>query.cancel(cancelOptions)));
        return Promise.all(promises).then((0, $2Yp8D.noop)).catch((0, $2Yp8D.noop));
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ invalidateQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $2Yp8D.parseFilterArgs)(arg1, arg2, arg3);
        return (0, $3gH3P.notifyManager).batch(()=>{
            var _ref, _filters$refetchType;
            this.queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === 'none') return Promise.resolve();
            const refetchFilters = (0, $b2I6k._)((0, $1Fos3._)({}, filters), {
                type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : 'active'
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ refetchQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $2Yp8D.parseFilterArgs)(arg1, arg2, arg3);
        const promises = (0, $3gH3P.notifyManager).batch(()=>this.queryCache.findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                var _options$cancelRefetc;
                return query.fetch(undefined, (0, $b2I6k._)((0, $1Fos3._)({}, options), {
                    cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
                    meta: {
                        refetchPage: filters.refetchPage
                    }
                }));
            }));
        let promise = Promise.all(promises).then((0, $2Yp8D.noop));
        if (!(options != null && options.throwOnError)) promise = promise.catch((0, $2Yp8D.noop));
        return promise;
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ fetchQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $2Yp8D.parseQueryArgs)(arg1, arg2, arg3);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === 'undefined') defaultedOptions.retry = false;
        const query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $2Yp8D.noop)).catch((0, $2Yp8D.noop));
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ fetchInfiniteQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $2Yp8D.parseQueryArgs)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $0bb85776e63a65a1$export$84470d1367601e8d)();
        return this.fetchQuery(parsedOptions);
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $2Yp8D.noop)).catch((0, $2Yp8D.noop));
    }
    resumePausedMutations() {
        return this.mutationCache.resumePausedMutations();
    }
    getQueryCache() {
        return this.queryCache;
    }
    getMutationCache() {
        return this.mutationCache;
    }
    getLogger() {
        return this.logger;
    }
    getDefaultOptions() {
        return this.defaultOptions;
    }
    setDefaultOptions(options) {
        this.defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        const result = this.queryDefaults.find((x)=>(0, $2Yp8D.hashQueryKey)(queryKey) === (0, $2Yp8D.hashQueryKey)(x.queryKey));
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        if (!queryKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.queryDefaults.find((x)=>(0, $2Yp8D.partialMatchKey)(queryKey, x.queryKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    setMutationDefaults(mutationKey, options) {
        const result = this.mutationDefaults.find((x)=>(0, $2Yp8D.hashQueryKey)(mutationKey) === (0, $2Yp8D.hashQueryKey)(x.mutationKey));
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        if (!mutationKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.mutationDefaults.find((x)=>(0, $2Yp8D.partialMatchKey)(mutationKey, x.mutationKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    defaultQueryOptions(options) {
        if (options != null && options._defaulted) return options;
        const defaultedOptions = (0, $b2I6k._)((0, $1Fos3._)({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options), {
            _defaulted: true
        });
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $2Yp8D.hashQueryKeyByOptions)(defaultedOptions.queryKey, defaultedOptions);
         // dependent default values
        if (typeof defaultedOptions.refetchOnReconnect === 'undefined') defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== 'always';
        if (typeof defaultedOptions.useErrorBoundary === 'undefined') defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options != null && options._defaulted) return options;
        return (0, $b2I6k._)((0, $1Fos3._)({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options), {
            _defaulted: true
        });
    }
    clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    }
    constructor(config = {}){
        this.queryCache = config.queryCache || new (0, $cdff84a84529d533$export$5dde0cd941da8468)();
        this.mutationCache = config.mutationCache || new (0, $ce2f72e80bc9b16c$export$1fcfd9a244434844)();
        this.logger = config.logger || (0, $eXMu6.defaultLogger);
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
        this.mountCount = 0;
    }
}


var $ejkzJ = parcelRequire("ejkzJ");
parcelRequire("02MUI");
var $eYupi = parcelRequire("eYupi");

var $1KJSO = parcelRequire("1KJSO");

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $6NU0v = parcelRequire("6NU0v");

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $91i6m = parcelRequire("91i6m");

var $5nv0q = parcelRequire("5nv0q");

var $2R76C = parcelRequire("2R76C");

var $dsN6L = parcelRequire("dsN6L");

var $5YM7L = parcelRequire("5YM7L");

var $eWMMH = parcelRequire("eWMMH");

var $91i6m = parcelRequire("91i6m");

var $aA6j8 = parcelRequire("aA6j8");

var $4sggA = parcelRequire("4sggA");
var $5KmZU = parcelRequire("5KmZU");
var $7rIXr = parcelRequire("7rIXr");
function $92d6d5b8b58207ae$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $92d6d5b8b58207ae$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $92d6d5b8b58207ae$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $92d6d5b8b58207ae$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $92d6d5b8b58207ae$var$defaultThemeSettings = function defaultThemeSettings() {
    return {
        dark: 'dark',
        light: 'light',
        spacing: 'spacing',
        typography: 'typography'
    };
};
var $92d6d5b8b58207ae$var$ColorModeContext = /*#__PURE__*/ (0, $91i6m.createContext)(undefined);
var $92d6d5b8b58207ae$var$SetColorModeContext = /*#__PURE__*/ (0, $91i6m.createContext)(undefined);
var $92d6d5b8b58207ae$var$ThemeContext = /*#__PURE__*/ (0, $91i6m.createContext)(undefined);
var $92d6d5b8b58207ae$var$SetThemeContext = /*#__PURE__*/ (0, $91i6m.createContext)(undefined);
function $92d6d5b8b58207ae$export$ce91654eb9fea460() {
    var value = (0, $91i6m.useContext)($92d6d5b8b58207ae$var$ColorModeContext);
    return value;
}
function $92d6d5b8b58207ae$export$20f3076712c8dfa() {
    var value = (0, $91i6m.useContext)($92d6d5b8b58207ae$var$ColorModeContext);
    var _getGlobalTheme = (0, $4sggA.default)(), colorMode = _getGlobalTheme.colorMode;
    var _useState = (0, $91i6m.useState)(colorMode || 'light'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), resolvedColorMode = _useState2[0], setResolvedColorMode = _useState2[1];
    (0, $91i6m.useEffect)(function() {
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        var observer = new (0, $7rIXr.default)(function(theme) {
            setResolvedColorMode(theme.colorMode || 'light');
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}
function $92d6d5b8b58207ae$export$e2afe7397c3d11c7() {
    var value = (0, $91i6m.useContext)($92d6d5b8b58207ae$var$SetColorModeContext);
    if (!value) throw new Error('useSetColorMode must be used within AppProvider.');
    return value;
}
function $92d6d5b8b58207ae$export$93d4e7f90805808f() {
    var theme = (0, $91i6m.useContext)($92d6d5b8b58207ae$var$ThemeContext);
    var _useState3 = (0, $91i6m.useState)(theme || (0, $4sggA.default)()), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState3, 2), resolvedTheme = _useState4[0], setResolvedTheme = _useState4[1];
    (0, $91i6m.useEffect)(function() {
        // We are using theme from context so no need to reference the DOM
        if (theme) return;
        var observer = new (0, $7rIXr.default)(setResolvedTheme);
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, [
        theme
    ]);
    return theme ? theme : resolvedTheme;
}
function $92d6d5b8b58207ae$export$501aa0dcd5527a48() {
    var value = (0, $91i6m.useContext)($92d6d5b8b58207ae$var$SetThemeContext);
    if (!value) throw new Error('useSetTheme must be used within AppProvider.');
    return value;
}
var $92d6d5b8b58207ae$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
var $92d6d5b8b58207ae$var$prefersDarkModeMql = $92d6d5b8b58207ae$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $92d6d5b8b58207ae$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $92d6d5b8b58207ae$var$prefersDarkModeMql !== null && $92d6d5b8b58207ae$var$prefersDarkModeMql !== void 0 && $92d6d5b8b58207ae$var$prefersDarkModeMql.matches ? 'dark' : 'light';
    return colorMode;
}
/**
 * __Theme provider__
 *
 * Provides global theming configuration.
 *
 * @internal
 */ function $92d6d5b8b58207ae$var$ThemeProvider(_ref) {
    var children = _ref.children, defaultColorMode = _ref.defaultColorMode, defaultTheme = _ref.defaultTheme;
    var _useState5 = (0, $91i6m.useState)(defaultColorMode), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState5, 2), chosenColorMode = _useState6[0], setChosenColorMode = _useState6[1];
    var _useState7 = (0, $91i6m.useState)($92d6d5b8b58207ae$var$getReconciledColorMode(defaultColorMode)), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState7, 2), reconciledColorMode = _useState8[0], setReconciledColorMode = _useState8[1];
    var _useState9 = (0, $91i6m.useState)(function() {
        return $92d6d5b8b58207ae$var$_objectSpread($92d6d5b8b58207ae$var$_objectSpread({}, $92d6d5b8b58207ae$var$defaultThemeSettings()), defaultTheme);
    }), _useState0 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState9, 2), theme = _useState0[0], setTheme = _useState0[1];
    var setColorMode = (0, $91i6m.useCallback)(function(colorMode) {
        setChosenColorMode(colorMode);
        setReconciledColorMode($92d6d5b8b58207ae$var$getReconciledColorMode(colorMode));
    }, []);
    var setPartialTheme = (0, $91i6m.useCallback)(function(nextTheme) {
        setTheme(function(theme) {
            return $92d6d5b8b58207ae$var$_objectSpread($92d6d5b8b58207ae$var$_objectSpread({}, theme), nextTheme);
        });
    }, []);
    var lastSetGlobalThemePromiseRef = (0, $91i6m.useRef)(null);
    (0, $91i6m.useEffect)(function() {
        /**
     * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
     * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
     * `data-color-mode` attribute on the root element).
     *
     * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
     * applying the new theme.
     *
     * Without this, we can end up in the following scenario:
     * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
     * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
     * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
     * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
     */ var cleanupLastFnCall = /*#__PURE__*/ function() {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee() {
                var unbindFn;
                return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (!lastSetGlobalThemePromiseRef.current) {
                                _context.next = 6;
                                break;
                            }
                            _context.next = 3;
                            return lastSetGlobalThemePromiseRef.current;
                        case 3:
                            unbindFn = _context.sent;
                            unbindFn();
                            lastSetGlobalThemePromiseRef.current = null;
                        case 6:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function cleanupLastFnCall() {
                return _ref2.apply(this, arguments);
            };
        }();
        var safelySetGlobalTheme = /*#__PURE__*/ function() {
            var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($2R76C)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).mark(function _callee2() {
                var promise;
                return (0, (/*@__PURE__*/$parcel$interopDefault($eWMMH))).wrap(function _callee2$(_context2) {
                    while(true)switch(_context2.prev = _context2.next){
                        case 0:
                            _context2.next = 2;
                            return cleanupLastFnCall();
                        case 2:
                            promise = (0, $5KmZU.default)($92d6d5b8b58207ae$var$_objectSpread($92d6d5b8b58207ae$var$_objectSpread({}, theme), {}, {
                                colorMode: reconciledColorMode
                            }));
                            lastSetGlobalThemePromiseRef.current = promise;
                        case 4:
                        case "end":
                            return _context2.stop();
                    }
                }, _callee2);
            }));
            return function safelySetGlobalTheme() {
                return _ref3.apply(this, arguments);
            };
        }();
        safelySetGlobalTheme();
        return function cleanup() {
            cleanupLastFnCall();
        };
    }, [
        theme,
        reconciledColorMode
    ]);
    (0, $91i6m.useEffect)(function() {
        if (!$92d6d5b8b58207ae$var$prefersDarkModeMql) return;
        var unbindListener = (0, $aA6j8.bind)($92d6d5b8b58207ae$var$prefersDarkModeMql, {
            type: 'change',
            listener: function listener(event) {
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($92d6d5b8b58207ae$var$ColorModeContext.Provider, {
        value: reconciledColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($92d6d5b8b58207ae$var$SetColorModeContext.Provider, {
        value: setColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($92d6d5b8b58207ae$var$ThemeContext.Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($92d6d5b8b58207ae$var$SetThemeContext.Provider, {
        value: setPartialTheme
    }, children))));
}
var $92d6d5b8b58207ae$export$2e2bcd8739ae039 = $92d6d5b8b58207ae$var$ThemeProvider;


var $2010dcab87c0cae2$var$InsideAppProviderContext = /*#__PURE__*/ (0, $91i6m.createContext)(false);
/**
 * __App provider__
 *
 * An app provider provides app level configuration such as global theming.
 *
 * Place it at the root of your application.
 */ function $2010dcab87c0cae2$var$AppProvider(_ref) {
    var children = _ref.children, _ref$defaultColorMode = _ref.defaultColorMode, defaultColorMode = _ref$defaultColorMode === void 0 ? 'light' : _ref$defaultColorMode, defaultTheme = _ref.defaultTheme, routerLinkComponent = _ref.routerLinkComponent, UNSAFE_isThemingDisabled = _ref.UNSAFE_isThemingDisabled;
    var isInsideAppProvider = (0, $91i6m.useContext)($2010dcab87c0cae2$var$InsideAppProviderContext);
    if (isInsideAppProvider) throw new Error('App provider should not be nested within another app provider.');
    var routerLinkProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $5nv0q.default), {
        routerLinkComponent: routerLinkComponent
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($2010dcab87c0cae2$var$InsideAppProviderContext.Provider, {
        value: true
    }, UNSAFE_isThemingDisabled ? routerLinkProvider : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $92d6d5b8b58207ae$export$2e2bcd8739ae039), {
        defaultColorMode: defaultColorMode,
        defaultTheme: defaultTheme
    }, routerLinkProvider));
}
var $2010dcab87c0cae2$export$2e2bcd8739ae039 = $2010dcab87c0cae2$var$AppProvider;



var $6d87w = parcelRequire("6d87w");
/**
 * This component is used to replace Atlaskit linking components with links that use react-router-dom for navigation.
 * The AppProvider determines when to use this component (it does not replace all Atlaskit linking components).
 * See https://atlassian.design/components/primitives/anchor/examples#router-links for more details.
 */ const $0c0d365cc9e12ec9$var$RouterLinkComponent = /*#__PURE__*/ (0, $91i6m.forwardRef)((_param, ref)=>{
    var { href: href, children: children } = _param, rest = (0, $6NU0v._)(_param, [
        "href",
        "children"
    ]);
    if (typeof href === 'string') return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6d87w.Link), (0, $b2I6k._)((0, $1Fos3._)({
        ref: ref,
        to: href
    }, rest), {
        children: children
    }));
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6d87w.Link), (0, $b2I6k._)((0, $1Fos3._)({
        ref: ref
    }, href, rest), {
        children: children
    }));
});
$0c0d365cc9e12ec9$var$RouterLinkComponent.displayName = 'RouterLinkComponent';
const $0c0d365cc9e12ec9$var$AppProvider = ({ children: children })=>{
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $2010dcab87c0cae2$export$2e2bcd8739ae039), {
        routerLinkComponent: $0c0d365cc9e12ec9$var$RouterLinkComponent,
        children: children
    });
};
var $0c0d365cc9e12ec9$export$2e2bcd8739ae039 = $0c0d365cc9e12ec9$var$AppProvider;



var $6d87w = parcelRequire("6d87w");
// Render a spinner to remove the "failed to load scripts" error while loading the app
const $8c05494fe3842bac$var$container = document.getElementById('root');
const $8c05494fe3842bac$var$root = (0, $5ad7482c381ec9b7$export$882461b6382ed46c)($8c05494fe3842bac$var$container);
$8c05494fe3842bac$var$root.render(/*#__PURE__*/ (0, $4ZSso.jsx)("div", {
    style: {
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center'
    },
    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9OWP7.default), {
        size: "large"
    })
}));
const $8c05494fe3842bac$var$preloadedState = (0, $lodUs.preloadAppState)();
(0, $lodUs.buildInitialState)($8c05494fe3842bac$var$preloadedState).then(async (initialState)=>{
    const { initialStoreState: initialStoreState, cspNonce: cspNonce } = initialState;
    (0, $49Pnv.initClient)(initialStoreState.microbranding);
    const analyticsClient = (0, $lodUs.createAnalyticsClient)(initialState);
    (0, $49Pnv.setUserId)(analyticsClient.getAnonymousId());
    (0, $lodUs.startupAnalyticEvent)(analyticsClient);
    (0, $jQauR.startBrowserMetrics)(analyticsClient);
    const ffsId = (0, $1KJSO.getFfsId)();
    if (ffsId) analyticsClient.setFfsId(ffsId);
    (0, $lodUs.pushGlobals)(initialStoreState.appConfig, cspNonce);
    const store = (0, $2aGBJ.createAppStore)(initialStoreState);
    if (initialStoreState.appConfig) (0, $lodUs.initCastle)(initialStoreState.appConfig);
    const queryClient = new (0, $6bb42d4b41548596$export$405d0624ed55a03f)({
        defaultOptions: {
            queries: {
                retry: false
            }
        }
    });
    $8c05494fe3842bac$var$root.render(/*#__PURE__*/ (0, $4ZSso.jsx)((0, $49swM.default), {
        store: store,
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $85b6087885ab46d9$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $3jGGb.default), {
                analyticsClient: analyticsClient,
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $0c0d365cc9e12ec9$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $ejkzJ.QueryClientProvider), {
                        client: queryClient,
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $decb5539395a0980$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $eYupi.FeatureGateProvider), {
                                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6d87w.RouterProvider), {
                                    router: (0, $abjTs.router)
                                })
                            })
                        })
                    })
                })
            })
        })
    }));
}).catch((error)=>{
    (0, $49Pnv.captureException)(error);
    const emptyStore = (0, $2aGBJ.createAppStore)({});
    $8c05494fe3842bac$var$root.render(/*#__PURE__*/ (0, $4ZSso.jsx)((0, $49swM.default), {
        store: emptyStore,
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $85b6087885ab46d9$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $3jGGb.UnexpectedApplicationErrorPage), {})
        })
    }));
});


//# sourceMappingURL=index.329191f6.js.map
